/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 98);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index__ = __webpack_require__(199);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["A"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["B"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["C"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["D"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["E"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["F"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["G"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["H"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["I"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["J"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["K"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["L"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["M"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["N"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["O"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["P"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["Q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["R"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["S"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["T"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["U"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["V"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["W"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["X"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["Y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["Z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["_0"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["_1"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["_2"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["_3"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["_4"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["_5"]; });
/**
 * index
 */



/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export disableBlazorMode */
/* harmony export (immutable) */ __webpack_exports__["c"] = createInstance;
/* harmony export (immutable) */ __webpack_exports__["q"] = setImmediate;
/* harmony export (immutable) */ __webpack_exports__["k"] = getValue;
/* harmony export (immutable) */ __webpack_exports__["r"] = setValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteObject;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return containerObject; });
/* harmony export (immutable) */ __webpack_exports__["n"] = isObject;
/* unused harmony export getEnumValue */
/* harmony export (immutable) */ __webpack_exports__["p"] = merge;
/* harmony export (immutable) */ __webpack_exports__["f"] = extend;
/* harmony export (immutable) */ __webpack_exports__["m"] = isNullOrUndefined;
/* harmony export (immutable) */ __webpack_exports__["o"] = isUndefined;
/* harmony export (immutable) */ __webpack_exports__["j"] = getUniqueID;
/* harmony export (immutable) */ __webpack_exports__["d"] = debounce;
/* unused harmony export queryParams */
/* unused harmony export isObjectArray */
/* harmony export (immutable) */ __webpack_exports__["a"] = compareElementParent;
/* harmony export (immutable) */ __webpack_exports__["s"] = throwError;
/* unused harmony export print */
/* harmony export (immutable) */ __webpack_exports__["g"] = formatUnit;
/* unused harmony export enableBlazorMode */
/* harmony export (immutable) */ __webpack_exports__["l"] = isBlazor;
/* harmony export (immutable) */ __webpack_exports__["h"] = getElement;
/* harmony export (immutable) */ __webpack_exports__["i"] = getInstance;
/* unused harmony export addInstance */
/* harmony export (immutable) */ __webpack_exports__["t"] = uniqueID;
var instances = 'ej2_instances';
var uid = 0;
var isBlazorPlatform = false;
/**
 * Function to check whether the platform is blazor or not.
 *
 * @returns {void} result
 * @private
 */
function disableBlazorMode() {
    isBlazorPlatform = false;
}
/**
 * Create Instance from constructor function with desired parameters.
 *
 * @param {Function} classFunction - Class function to which need to create instance
 * @param {any[]} params - Parameters need to passed while creating instance
 * @returns {any} ?
 * @private
 */
// eslint-disable-next-line
function createInstance(classFunction, params) {
    var arrayParam = params;
    arrayParam.unshift(undefined);
    return new (Function.prototype.bind.apply(classFunction, arrayParam));
}
/**
 * To run a callback function immediately after the browser has completed other operations.
 *
 * @param {Function} handler - callback function to be triggered.
 * @returns {Function} ?
 * @private
 */
function setImmediate(handler) {
    var unbind;
    // eslint-disable-next-line
    var num = new Uint16Array(5);
    var intCrypto = window.msCrypto || window.crypto;
    intCrypto.getRandomValues(num);
    var secret = 'ej2' + combineArray(num);
    // eslint-disable-next-line
    var messageHandler = function (event) {
        if (event.source === window && typeof event.data === 'string' && event.data.length <= 32 && event.data === secret) {
            handler();
            unbind();
        }
    };
    window.addEventListener('message', messageHandler, false);
    window.postMessage(secret, '*');
    return unbind = function () {
        window.removeEventListener('message', messageHandler);
        handler = messageHandler = secret = undefined;
    };
}
/**
 * To get nameSpace value from the desired object.
 *
 * @param {string} nameSpace - String value to the get the inner object
 * @param {any} obj - Object to get the inner object value.
 * @returns {any} ?
 * @private
 */
// eslint-disable-next-line
function getValue(nameSpace, obj) {
    // eslint-disable-next-line
    var value = obj;
    var splits = nameSpace.replace(/\[/g, '.').replace(/\]/g, '').split('.');
    for (var i = 0; i < splits.length && !isUndefined(value); i++) {
        value = value[splits[i]];
    }
    return value;
}
/**
 * To set value for the nameSpace in desired object.
 *
 * @param {string} nameSpace - String value to the get the inner object
 * @param {any} value - Value that you need to set.
 * @param {any} obj - Object to get the inner object value.
 * @returns {any} ?
 * @private
 */
// eslint-disable-next-line
function setValue(nameSpace, value, obj) {
    var keys = nameSpace.replace(/\[/g, '.').replace(/\]/g, '').split('.');
    // eslint-disable-next-line
    var start = obj || {};
    // eslint-disable-next-line
    var fromObj = start;
    var i;
    var length = keys.length;
    var key;
    for (i = 0; i < length; i++) {
        key = keys[i];
        if (i + 1 === length) {
            fromObj[key] = value === undefined ? {} : value;
        }
        else if (isNullOrUndefined(fromObj[key])) {
            fromObj[key] = {};
        }
        fromObj = fromObj[key];
    }
    return start;
}
/**
 * Delete an item from Object
 *
 * @param {any} obj - Object in which we need to delete an item.
 * @param {string} key - String value to the get the inner object
 * @returns {void} ?
 * @private
 */
// eslint-disable-next-line
function deleteObject(obj, key) {
    delete obj[key];
}
/**
 *@private
 */
var containerObject = typeof window !== "undefined" ? window : {};
/**
 * Check weather the given argument is only object.
 *
 * @param {any} obj - Object which is need to check.
 * @returns {boolean} ?
 * @private
 */
// eslint-disable-next-line
function isObject(obj) {
    var objCon = {};
    return (!isNullOrUndefined(obj) && obj.constructor === objCon.constructor);
}
/**
 * To get enum value by giving the string.
 *
 * @param {any} enumObject - Enum object.
 * @param {string} enumValue - Enum value to be searched
 * @returns {any} ?
 * @private
 */
// eslint-disable-next-line
function getEnumValue(enumObject, enumValue) {
    // eslint-disable-next-line
    return enumObject[enumValue];
}
/**
 * Merge the source object into destination object.
 *
 * @param {any} source - source object which is going to merge with destination object
 * @param {any} destination - object need to be merged
 * @returns {void} ?
 * @private
 */
function merge(source, destination) {
    if (!isNullOrUndefined(destination)) {
        var temrObj = source;
        var tempProp = destination;
        var keys = Object.keys(destination);
        var deepmerge = 'deepMerge';
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            if (!isNullOrUndefined(temrObj[deepmerge]) && (temrObj[deepmerge].indexOf(key) !== -1) &&
                (isObject(tempProp[key]) || Array.isArray(tempProp[key]))) {
                extend(temrObj[key], temrObj[key], tempProp[key], true);
            }
            else {
                temrObj[key] = tempProp[key];
            }
        }
    }
}
/**
 * Extend the two object with newer one.
 *
 * @param {any} copied - Resultant object after merged
 * @param {Object} first - First object need to merge
 * @param {Object} second - Second object need to merge
 * @param {boolean} deep ?
 * @returns {Object} ?
 * @private
 */
function extend(copied, first, second, deep) {
    var result = copied && typeof copied === 'object' ? copied : {};
    var length = arguments.length;
    if (deep) {
        length = length - 1;
    }
    var _loop_1 = function (i) {
        // eslint-disable-next-line
        if (!arguments_1[i]) {
            return "continue";
        }
        // eslint-disable-next-line
        var obj1 = arguments_1[i];
        Object.keys(obj1).forEach(function (key) {
            var src = result[key];
            var copy = obj1[key];
            var clone;
            var isArrayChanged = Array.isArray(copy) && Array.isArray(src) && (copy.length !== src.length);
            // eslint-disable-next-line
            var blazorEventExtend = isBlazor() ? (!(src instanceof Event) && !isArrayChanged) : true;
            if (deep && blazorEventExtend && (isObject(copy) || Array.isArray(copy))) {
                if (isObject(copy)) {
                    clone = src ? src : {};
                    // eslint-disable-next-line
                    if (Array.isArray(clone) && clone.hasOwnProperty('isComplexArray')) {
                        extend(clone, {}, copy, deep);
                    }
                    else {
                        result[key] = extend(clone, {}, copy, deep);
                    }
                }
                else {
                    /* istanbul ignore next */
                    clone = isBlazor() ? src && Object.keys(copy).length : src ? src : [];
                    result[key] = extend([], clone, copy, deep);
                }
            }
            else {
                result[key] = copy;
            }
        });
    };
    var arguments_1 = arguments;
    for (var i = 1; i < length; i++) {
        _loop_1(i);
    }
    return result;
}
/**
 * To check whether the object is null or undefined.
 *
 * @param {Object} value - To check the object is null or undefined
 * @returns {boolean} ?
 * @private
 */
function isNullOrUndefined(value) {
    return value === undefined || value === null;
}
/**
 * To check whether the object is undefined.
 *
 * @param {Object} value - To check the object is undefined
 * @returns {boolean} ?
 * @private
 */
function isUndefined(value) {
    return ('undefined' === typeof value);
}
/**
 * To return the generated unique name
 *
 * @param {string} definedName - To concatenate the unique id to provided name
 * @returns {string} ?
 * @private
 */
function getUniqueID(definedName) {
    return definedName + '_' + uid++;
}
/**
 * It limits the rate at which a function can fire. The function will fire only once every provided second instead of as quickly.
 *
 * @param {Function} eventFunction - Specifies the function to run when the event occurs
 * @param {number} delay - A number that specifies the milliseconds for function delay call option
 * @returns {Function} ?
 * @private
 */
function debounce(eventFunction, delay) {
    // eslint-disable-next-line
    var out;
    return function () {
        var _this = this;
        // eslint-disable-next-line
        var args = arguments;
        var later = function () {
            out = null;
            return eventFunction.apply(_this, args);
        };
        clearTimeout(out);
        out = setTimeout(later, delay);
    };
}
/**
 * To convert the object to string for query url
 *
 * @param  {Object} data ?
 * @returns {string} ?
 * @private
 */
// eslint-disable-next-line
function queryParams(data) {
    var array = [];
    var keys = Object.keys(data);
    for (var _i = 0, keys_2 = keys; _i < keys_2.length; _i++) {
        var key = keys_2[_i];
        array.push(encodeURIComponent(key) + '=' + encodeURIComponent('' + data[key]));
    }
    return array.join('&');
}
/**
 * To check whether the given array contains object.
 *
 * @param {any} value - Specifies the T type array to be checked.
 * @returns {boolean} ?
 * @private
 */
function isObjectArray(value) {
    var parser = Object.prototype.toString;
    if (parser.call(value) === '[object Array]') {
        if (parser.call(value[0]) === '[object Object]') {
            return true;
        }
    }
    return false;
}
/**
 * To check whether the  child element is descendant to parent element or parent and child are same element.
 *
 * @param {Element} child - Specifies the child element to compare with parent.
 * @param {Element} parent - Specifies the parent element.
 * @returns {boolean} ?
 * @private
 */
function compareElementParent(child, parent) {
    var node = child;
    if (node === parent) {
        return true;
    }
    else if (node === document || !node) {
        return false;
    }
    else {
        return compareElementParent(node.parentNode, parent);
    }
}
/**
 * To throw custom error message.
 *
 * @param {string} message - Specifies the error message to be thrown.
 * @returns {void} ?
 * @private
 */
function throwError(message) {
    try {
        throw new Error(message);
    }
    catch (e) {
        // eslint-disable-next-line
        throw e.message + '\n' + e.stack;
    }
}
/**
 * This function is used to print given element
 *
 * @param {Element} element - Specifies the print content element.
 * @param {Window} printWindow - Specifies the print window.
 * @returns {Window} ?
 * @private
 */
function print(element, printWindow) {
    var div = document.createElement('div');
    var links = [].slice.call(document.getElementsByTagName('head')[0].querySelectorAll('base, link, style'));
    var blinks = [].slice.call(document.getElementsByTagName('body')[0].querySelectorAll('link, style'));
    if (blinks.length) {
        for (var l = 0, len = blinks.length; l < len; l++) {
            links.push(blinks[l]);
        }
    }
    var reference = '';
    if (isNullOrUndefined(printWindow)) {
        printWindow = window.open('', 'print', 'height=452,width=1024,tabbar=no');
    }
    div.appendChild(element.cloneNode(true));
    for (var i = 0, len = links.length; i < len; i++) {
        reference += links[i].outerHTML;
    }
    printWindow.document.write('<!DOCTYPE html> <html><head>' + reference + '</head><body>' + div.innerHTML +
        '<script> (function() { window.ready = true; })(); </script>' + '</body></html>');
    printWindow.document.close();
    printWindow.focus();
    // eslint-disable-next-line
    var interval = setInterval(function () {
        if (printWindow.ready) {
            printWindow.print();
            printWindow.close();
            clearInterval(interval);
        }
    }, 500);
    return printWindow;
}
/**
 * Function to normalize the units applied to the element.
 *
 * @param {number|string} value ?
 * @returns {string} result
 * @private
 */
function formatUnit(value) {
    var result = value + '';
    if (result.match(/auto|cm|mm|in|px|pt|pc|%|em|ex|ch|rem|vw|vh|vmin|vmax/)) {
        return result;
    }
    return result + 'px';
}
/**
 * Function to check whether the platform is blazor or not.
 *
 * @returns {void} result
 * @private
 */
function enableBlazorMode() {
    isBlazorPlatform = true;
}
/**
 * Function to check whether the platform is blazor or not.
 *
 * @returns {boolean} result
 * @private
 */
function isBlazor() {
    return isBlazorPlatform;
}
/**
 * Function to convert xPath to DOM element in blazor platform
 *
 * @returns {HTMLElement} result
 * @param {HTMLElement | object} element ?
 * @private
 */
function getElement(element) {
    var xPath = 'xPath';
    if (!(element instanceof Node) && isBlazor() && !isNullOrUndefined(element[xPath])) {
        return document.evaluate(element[xPath], document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
    }
    return element;
}
/**
 * Function to fetch the Instances of a HTML element for the given component.
 *
 * @param {string | HTMLElement} element ?
 * @param {any} component ?
 * @returns {Object} ?
 * @private
 */
// eslint-disable-next-line
function getInstance(element, component) {
    // eslint-disable-next-line
    var elem = (typeof (element) === 'string') ? document.querySelector(element) : element;
    if (elem[instances]) {
        for (var _i = 0, _a = elem[instances]; _i < _a.length; _i++) {
            var inst = _a[_i];
            if (inst instanceof component) {
                return inst;
            }
        }
    }
    return null;
}
/**
 * Function to add instances for the given element.
 *
 * @param {string | HTMLElement} element ?
 * @param {Object} instance ?
 * @returns {void} ?
 * @private
 */
function addInstance(element, instance) {
    // eslint-disable-next-line
    var elem = (typeof (element) === 'string') ? document.querySelector(element) : element;
    if (elem[instances]) {
        elem[instances].push(instance);
    }
    else {
        elem[instances] = [instance];
    }
}
/**
 * Function to generate the unique id.
 *
 * @returns {any} ?
 * @private
 */
// eslint-disable-next-line
function uniqueID() {
    if ((typeof window) === 'undefined') {
        return;
    }
    // eslint-disable-next-line
    var num = new Uint16Array(5);
    var intCrypto = window.msCrypto || window.crypto;
    return intCrypto.getRandomValues(num);
}
/**
 *
 * @param {Int16Array} num ?
 * @returns {string} ?
 */
function combineArray(num) {
    var ret = '';
    for (var i = 0; i < 5; i++) {
        ret += (i ? ',' : '') + num[i];
    }
    return ret;
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(104)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index__ = __webpack_require__(289);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["e"]; });
/**
 * index
 */



/***/ }),
/* 5 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(55);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index__ = __webpack_require__(234);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["j"]; });
/**
 * index
 */



/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.14
 * (c) 2014-2021 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i], vm);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  var haveExpectedTypes = expectedTypes.some(function (t) { return t; });
  if (!valid && haveExpectedTypes) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;

function assertType (value, type, vm) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    try {
      valid = value instanceof type;
    } catch (e) {
      warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
      valid = false;
    }
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

var functionTypeCheckRE = /^\s*function (\w+)/;

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(functionTypeCheckRE);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  // check if we need to specify expected value
  if (
    expectedTypes.length === 1 &&
    isExplicable(expectedType) &&
    isExplicable(typeof value) &&
    !isBoolean(expectedType, receivedType)
  ) {
    message += " with value " + (styleValue(value, expectedType));
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + (styleValue(value, receivedType)) + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
function isExplicable (value) {
  return EXPLICABLE_TYPES.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    var vnode = res && res[0];
    return res && (
      !vnode ||
      (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode)) // #9658, #10391
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallbackRender,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) {
    // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn('slot v-bind without argument expects an Object', this);
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes =
      scopedSlotFn(props) ||
      (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
  } else {
    nodes =
      this.$slots[name] ||
      (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
  return eventKeyCode === undefined
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  // we know it's MountedComponentVNode but flow doesn't
  vnode,
  // activeInstance in lifecycle state
  parent
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
    (!newScopedSlots && vm.$scopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        var info = "callback for watcher \"" + (this.expression) + "\"";
        invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      } else if (vm.$options.methods && key in vm.$options.methods) {
        warn(("The computed property \"" + key + "\" is already defined as a method."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      var info = "callback for immediate watcher \"" + (watcher.expression) + "\"";
      pushTarget();
      invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
      popTarget();
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */





function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var entry = cache[key];
    if (entry) {
      var name = entry.name;
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var entry = cache[key];
  if (entry && (!current || entry.tag !== current.tag)) {
    entry.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  methods: {
    cacheVNode: function cacheVNode() {
      var ref = this;
      var cache = ref.cache;
      var keys = ref.keys;
      var vnodeToCache = ref.vnodeToCache;
      var keyToCache = ref.keyToCache;
      if (vnodeToCache) {
        var tag = vnodeToCache.tag;
        var componentInstance = vnodeToCache.componentInstance;
        var componentOptions = vnodeToCache.componentOptions;
        cache[keyToCache] = {
          name: getComponentName(componentOptions),
          tag: tag,
          componentInstance: componentInstance,
        };
        keys.push(keyToCache);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
        this.vnodeToCache = null;
      }
    }
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.cacheVNode();
    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  updated: function updated () {
    this.cacheVNode();
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        // delay setting the cache until update
        this.vnodeToCache = vnode;
        this.keyToCache = key;
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.14';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key &&
    a.asyncFactory === b.asyncFactory && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur, vnode.data.pre);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value, isInPre) {
  if (isInPre || el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /[ \f\t\r\n]+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!(
    el.component ||
    el.attrsMap[':is'] ||
    el.attrsMap['v-bind:is'] ||
    !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag))
  ); };
  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + ".apply(null, arguments)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ").apply(null, arguments)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  // fix #11483, Root level <script> tags should not be rendered.
  var code = ast ? (ast.tag === 'script' ? 'null' : genElement(ast, state)) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? (",function(){return " + children + "}") : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["default"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(35), __webpack_require__(99).setImmediate))

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index__ = __webpack_require__(197);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["i"]; });
/**
 * index
 */



/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = createElement;
/* harmony export (immutable) */ __webpack_exports__["a"] = addClass;
/* harmony export (immutable) */ __webpack_exports__["l"] = removeClass;
/* harmony export (immutable) */ __webpack_exports__["h"] = isVisible;
/* harmony export (immutable) */ __webpack_exports__["j"] = prepend;
/* harmony export (immutable) */ __webpack_exports__["b"] = append;
/* harmony export (immutable) */ __webpack_exports__["g"] = detach;
/* harmony export (immutable) */ __webpack_exports__["k"] = remove;
/* harmony export (immutable) */ __webpack_exports__["c"] = attributes;
/* harmony export (immutable) */ __webpack_exports__["m"] = select;
/* harmony export (immutable) */ __webpack_exports__["n"] = selectAll;
/* harmony export (immutable) */ __webpack_exports__["e"] = closest;
/* unused harmony export siblings */
/* unused harmony export getAttributeOrDefault */
/* harmony export (immutable) */ __webpack_exports__["o"] = setStyleAttribute;
/* harmony export (immutable) */ __webpack_exports__["d"] = classList;
/* harmony export (immutable) */ __webpack_exports__["i"] = matches;
/* unused harmony export includeInnerHTML */
/* unused harmony export containsClass */
/* unused harmony export cloneNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_handler__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(1);
/**
 * Functions related to dom operations.
 */


var SVG_REG = /^svg|^path|^g/;
/**
 * Function to create Html element.
 *
 * @param {string} tagName - Name of the tag, id and class names.
 * @param {ElementProperties} properties - Object to set properties in the element.
 * @param {ElementProperties} properties.id - To set the id to the created element.
 * @param {ElementProperties} properties.className - To add classes to the element.
 * @param {ElementProperties} properties.innerHTML - To set the innerHTML to element.
 * @param {ElementProperties} properties.styles - To set the some custom styles to element.
 * @param {ElementProperties} properties.attrs - To set the attributes to element.
 * @returns {any} ?
 * @private
 */
function createElement(tagName, properties) {
    var element = (SVG_REG.test(tagName) ? document.createElementNS('http://www.w3.org/2000/svg', tagName) : document.createElement(tagName));
    if (typeof (properties) === 'undefined') {
        return element;
    }
    element.innerHTML = (properties.innerHTML ? properties.innerHTML : '');
    if (properties.className !== undefined) {
        element.className = properties.className;
    }
    if (properties.id !== undefined) {
        element.id = properties.id;
    }
    if (properties.styles !== undefined) {
        element.setAttribute('style', properties.styles);
    }
    if (properties.attrs !== undefined) {
        attributes(element, properties.attrs);
    }
    return element;
}
/**
 * The function used to add the classes to array of elements
 *
 * @param  {Element[]|NodeList} elements - An array of elements that need to add a list of classes
 * @param  {string|string[]} classes - String or array of string that need to add an individual element as a class
 * @returns {any} .
 * @private
 */
function addClass(elements, classes) {
    var classList = getClassList(classes);
    for (var _i = 0, _a = elements; _i < _a.length; _i++) {
        var ele = _a[_i];
        for (var _b = 0, classList_1 = classList; _b < classList_1.length; _b++) {
            var className = classList_1[_b];
            if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["n" /* isObject */])(ele)) {
                var curClass = Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('attributes.className', ele);
                if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["m" /* isNullOrUndefined */])(curClass)) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__util__["r" /* setValue */])('attributes.className', className, ele);
                }
                else if (!new RegExp('\\b' + className + '\\b', 'i').test(curClass)) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__util__["r" /* setValue */])('attributes.className', curClass + ' ' + className, ele);
                }
            }
            else {
                if (!ele.classList.contains(className)) {
                    ele.classList.add(className);
                }
            }
        }
    }
    return elements;
}
/**
 * The function used to add the classes to array of elements
 *
 * @param  {Element[]|NodeList} elements - An array of elements that need to remove a list of classes
 * @param  {string|string[]} classes - String or array of string that need to add an individual element as a class
 * @returns {any} .
 * @private
 */
function removeClass(elements, classes) {
    var classList = getClassList(classes);
    for (var _i = 0, _a = elements; _i < _a.length; _i++) {
        var ele = _a[_i];
        var flag = Object(__WEBPACK_IMPORTED_MODULE_1__util__["n" /* isObject */])(ele);
        var canRemove = flag ? Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('attributes.className', ele) : ele.className !== '';
        if (canRemove) {
            for (var _b = 0, classList_2 = classList; _b < classList_2.length; _b++) {
                var className = classList_2[_b];
                if (flag) {
                    var classes_1 = Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('attributes.className', ele);
                    var classArr = classes_1.split(' ');
                    var index = classArr.indexOf(className);
                    if (index !== -1) {
                        classArr.splice(index, 1);
                    }
                    Object(__WEBPACK_IMPORTED_MODULE_1__util__["r" /* setValue */])('attributes.className', classArr.join(' '), ele);
                }
                else {
                    ele.classList.remove(className);
                }
            }
        }
    }
    return elements;
}
/**
 * The function used to get classlist.
 *
 * @param  {string | string[]} classes - An element the need to check visibility
 * @returns {string[]} ?
 * @private
 */
function getClassList(classes) {
    var classList = [];
    if (typeof classes === 'string') {
        classList.push(classes);
    }
    else {
        classList = classes;
    }
    return classList;
}
/**
 * The function used to check element is visible or not.
 *
 * @param  {Element|Node} element - An element the need to check visibility
 * @returns {boolean} ?
 * @private
 */
function isVisible(element) {
    var ele = element;
    return (ele.style.visibility === '' && ele.offsetWidth > 0);
}
/**
 * The function used to insert an array of elements into a first of the element.
 *
 * @param  {Element[]|NodeList} fromElements - An array of elements that need to prepend.
 * @param  {Element} toElement - An element that is going to prepend.
 * @param {boolean} isEval - ?
 * @returns {Element[] | NodeList} ?
 * @private
 */
function prepend(fromElements, toElement, isEval) {
    var docFrag = document.createDocumentFragment();
    for (var _i = 0, _a = fromElements; _i < _a.length; _i++) {
        var ele = _a[_i];
        docFrag.appendChild(ele);
    }
    toElement.insertBefore(docFrag, toElement.firstElementChild);
    if (isEval) {
        executeScript(toElement);
    }
    return fromElements;
}
/**
 * The function used to insert an array of elements into last of the element.
 *
 * @param  {Element[]|NodeList} fromElements - An array of elements that need to append.
 * @param  {Element} toElement - An element that is going to prepend.
 * @param {boolean} isEval - ?
 * @returns {Element[] | NodeList} ?
 * @private
 */
function append(fromElements, toElement, isEval) {
    var docFrag = document.createDocumentFragment();
    for (var _i = 0, _a = fromElements; _i < _a.length; _i++) {
        var ele = _a[_i];
        docFrag.appendChild(ele);
    }
    toElement.appendChild(docFrag);
    if (isEval) {
        executeScript(toElement);
    }
    return fromElements;
}
/**
 * The function is used to evaluate script from Ajax request
 *
 * @param {Element} ele - An element is going to evaluate the script
 * @returns {void} ?
 */
function executeScript(ele) {
    var eleArray = ele.querySelectorAll('script');
    eleArray.forEach(function (element) {
        var script = document.createElement('script');
        script.text = element.innerHTML;
        document.head.appendChild(script);
        detach(script);
    });
}
/**
 * The function used to remove the element from parentnode
 *
 * @param  {Element|Node|HTMLElement} element - An element that is going to detach from the Dom
 * @returns {any} ?
 * @private
 */
// eslint-disable-next-line
function detach(element) {
    var parentNode = element.parentNode;
    if (parentNode) {
        return parentNode.removeChild(element);
    }
}
/**
 * The function used to remove the element from Dom also clear the bounded events
 *
 * @param  {Element|Node|HTMLElement} element - An element remove from the Dom
 * @returns {void} ?
 * @private
 */
function remove(element) {
    var parentNode = element.parentNode;
    __WEBPACK_IMPORTED_MODULE_0__event_handler__["a" /* EventHandler */].clearEvents(element);
    parentNode.removeChild(element);
}
/**
 * The function helps to set multiple attributes to an element
 *
 * @param  {Element|Node} element - An element that need to set attributes.
 * @param  {string} attributes - JSON Object that is going to as attributes.
 * @returns {Element} ?
 * @private
 */
// eslint-disable-next-line
function attributes(element, attributes) {
    var keys = Object.keys(attributes);
    var ele = element;
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["n" /* isObject */])(ele)) {
            var iKey = key;
            if (key === 'tabindex') {
                iKey = 'tabIndex';
            }
            ele.attributes[iKey] = attributes[key];
        }
        else {
            ele.setAttribute(key, attributes[key]);
        }
    }
    return ele;
}
/**
 * The function selects the element from giving context.
 *
 * @param  {string} selector - Selector string need fetch element
 * @param  {Document|Element} context - It is an optional type, That specifies a Dom context.
 * @param {boolean} needsVDOM ?
 * @returns {any} ?
 * @private
 */
// eslint-disable-next-line
function select(selector, context, needsVDOM) {
    if (context === void 0) { context = document; }
    selector = querySelectId(selector);
    return context.querySelector(selector);
}
/**
 * The function selects an array of element from the given context.
 *
 * @param  {string} selector - Selector string need fetch element
 * @param  {Document|Element} context - It is an optional type, That specifies a Dom context.
 * @param {boolean} needsVDOM ?
 * @returns {HTMLElement[]} ?
 * @private
 */
// eslint-disable-next-line
function selectAll(selector, context, needsVDOM) {
    if (context === void 0) { context = document; }
    selector = querySelectId(selector);
    var nodeList = context.querySelectorAll(selector);
    return nodeList;
}
/**
 * The function selects an id of element from the given context.
 *
 * @param  {string} selector - Selector string need fetch element
 * @returns {string} ?
 * @private
 */
function querySelectId(selector) {
    var charRegex = /(!|"|\$|%|&|'|\(|\)|\*|\/|:|;|<|=|\?|@|\]|\^|`|{|}|\||\+|~)/g;
    if (selector.match(/#[0-9]/g) || selector.match(charRegex)) {
        var idList = selector.split(',');
        for (var i = 0; i < idList.length; i++) {
            var list = idList[i].split(' ');
            for (var j = 0; j < list.length; j++) {
                if (list[j].indexOf('#') > -1) {
                    if (!list[j].match(/\[.*\]/)) {
                        var splitId = list[j].split('#');
                        if (splitId[1].match(/^\d/) || splitId[1].match(charRegex)) {
                            var setId = list[j].split('.');
                            setId[0] = setId[0].replace(/#/, '[id=\'') + '\']';
                            list[j] = setId.join('.');
                        }
                    }
                }
            }
            idList[i] = list.join(' ');
        }
        return idList.join(',');
    }
    return selector;
}
/**
 * Returns single closest parent element based on class selector.
 *
 * @param  {Element} element - An element that need to find the closest element.
 * @param  {string} selector - A classSelector of closest element.
 * @returns {Element} ?
 * @private
 */
function closest(element, selector) {
    var el = element;
    if (typeof el.closest === 'function') {
        return el.closest(selector);
    }
    while (el && el.nodeType === 1) {
        if (matches(el, selector)) {
            return el;
        }
        el = el.parentNode;
    }
    return null;
}
/**
 * Returns all sibling elements of the given element.
 *
 * @param  {Element|Node} element - An element that need to get siblings.
 * @returns {Element[]} ?
 * @private
 */
function siblings(element) {
    var siblings = [];
    var childNodes = Array.prototype.slice.call(element.parentNode.childNodes);
    for (var _i = 0, childNodes_1 = childNodes; _i < childNodes_1.length; _i++) {
        var curNode = childNodes_1[_i];
        if (curNode.nodeType === Node.ELEMENT_NODE && element !== curNode) {
            siblings.push(curNode);
        }
    }
    return siblings;
}
/**
 * set the value if not exist. Otherwise set the existing value
 *
 * @param  {HTMLElement} element - An element to which we need to set value.
 * @param  {string} property - Property need to get or set.
 * @param  {string} value - value need to set.
 * @returns {string} ?
 * @private
 */
function getAttributeOrDefault(element, property, value) {
    var attrVal;
    var isObj = Object(__WEBPACK_IMPORTED_MODULE_1__util__["n" /* isObject */])(element);
    if (isObj) {
        attrVal = Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('attributes.' + property, element);
    }
    else {
        attrVal = element.getAttribute(property);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["m" /* isNullOrUndefined */])(attrVal) && value) {
        if (!isObj) {
            element.setAttribute(property, value.toString());
        }
        else {
            element.attributes[property] = value;
        }
        attrVal = value;
    }
    return attrVal;
}
/**
 * Set the style attributes to Html element.
 *
 * @param {HTMLElement} element - Element which we want to set attributes
 * @param {any} attrs - Set the given attributes to element
 * @returns {void} ?
 * @private
 */
function setStyleAttribute(element, attrs) {
    if (attrs !== undefined) {
        Object.keys(attrs).forEach(function (key) {
            // eslint-disable-next-line
            element.style[key] = attrs[key];
        });
    }
}
/**
 * Method for add and remove classes to a dom element.
 *
 * @param {Element} element - Element for add and remove classes
 * @param {string[]} addClasses - List of classes need to be add to the element
 * @param {string[]} removeClasses - List of classes need to be remove from the element
 * @returns {void} ?
 * @private
 */
function classList(element, addClasses, removeClasses) {
    addClass([element], addClasses);
    removeClass([element], removeClasses);
}
/**
 * Method to check whether the element matches the given selector.
 *
 * @param {Element} element - Element to compare with the selector.
 * @param {string} selector - String selector which element will satisfy.
 * @returns {void} ?
 * @private
 */
function matches(element, selector) {
    // eslint-disable-next-line
    var matches = element.matches || element.msMatchesSelector || element.webkitMatchesSelector;
    if (matches) {
        return matches.call(element, selector);
    }
    else {
        return [].indexOf.call(document.querySelectorAll(selector), element) !== -1;
    }
}
/**
 * Method to get the html text from DOM.
 *
 * @param {HTMLElement} ele - Element to compare with the selector.
 * @param {string} innerHTML - String selector which element will satisfy.
 * @returns {void} ?
 * @private
 */
function includeInnerHTML(ele, innerHTML) {
    ele.innerHTML = innerHTML;
}
/**
 * Method to get the containsclass.
 *
 * @param {HTMLElement} ele - Element to compare with the selector.
 * @param {string} className - String selector which element will satisfy.
 * @returns {any} ?
 * @private
 */
// eslint-disable-next-line
function containsClass(ele, className) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["n" /* isObject */])(ele)) {
        // eslint-disable-next-line
        return new RegExp('\\b' + className + '\\b', 'i').test(ele.attributes.className);
    }
    else {
        return ele.classList.contains(className);
    }
}
/**
 * Method to check whether the element matches the given selector.
 *
 * @param {Object} element - Element to compare with the selector.
 * @param {boolean} deep ?
 * @returns {any} ?
 * @private
 */
// eslint-disable-next-line
function cloneNode(element, deep) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["n" /* isObject */])(element)) {
        if (deep) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__util__["f" /* extend */])({}, {}, element, true);
        }
    }
    else {
        return element.cloneNode(deep);
    }
}


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index__ = __webpack_require__(217);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["c"]; });
/**
 * index
 */



/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Base; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getComponent;
/* unused harmony export removeChildInstance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observer__ = __webpack_require__(26);



var isColEName = new RegExp(']');
/* tslint:enable:no-any */
/**
 * Base library module is common module for Framework modules like touch,keyboard and etc.,
 *
 * @private
 */
var Base = /** @class */ (function () {
    /**
     * Base constructor accept options and element
     *
     * @param {Object} options ?
     * @param {string} element ?
     */
    function Base(options, element) {
        this.isRendered = false;
        this.isComplexArraySetter = false;
        this.isServerRendered = false;
        this.allowServerDataBinding = true;
        this.isProtectedOnChange = true;
        this.properties = {};
        this.changedProperties = {};
        this.oldProperties = {};
        this.bulkChanges = {};
        this.refreshing = false;
        this.ignoreCollectionWatch = false;
        // eslint-disable-next-line
        this.finalUpdate = function () { };
        this.childChangedProperties = {};
        this.modelObserver = new __WEBPACK_IMPORTED_MODULE_2__observer__["a" /* Observer */](this);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(element)) {
            if ('string' === typeof (element)) {
                this.element = document.querySelector(element);
            }
            else {
                this.element = element;
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(this.element)) {
                this.isProtectedOnChange = false;
                this.addInstance();
            }
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(options)) {
            this.setProperties(options, true);
        }
        this.isDestroyed = false;
    }
    /** Property base section */
    /**
     * Function used to set bunch of property at a time.
     *
     * @private
     * @param  {Object} prop - JSON object which holds components properties.
     * @param  {boolean} muteOnChange ? - Specifies to true when we set properties.
     * @returns {void} ?
     */
    Base.prototype.setProperties = function (prop, muteOnChange) {
        var prevDetection = this.isProtectedOnChange;
        this.isProtectedOnChange = !!muteOnChange;
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["p" /* merge */])(this, prop);
        if (muteOnChange !== true) {
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["p" /* merge */])(this.changedProperties, prop);
            this.dataBind();
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isBlazor */])() && this.isRendered) {
            this.serverDataBind(prop);
        }
        this.finalUpdate();
        this.changedProperties = {};
        this.oldProperties = {};
        this.isProtectedOnChange = prevDetection;
    };
    /**
     * Calls for child element data bind
     *
     * @param {Object} obj ?
     * @param {Object} parent ?
     * @returns {void} ?
     */
    // tslint:disable-next-line:no-any
    Base.callChildDataBind = function (obj, parent) {
        var keys = Object.keys(obj);
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            if (parent[key] instanceof Array) {
                for (var _a = 0, _b = parent[key]; _a < _b.length; _a++) {
                    var obj_1 = _b[_a];
                    if (obj_1.dataBind !== undefined) {
                        obj_1.dataBind();
                    }
                }
            }
            else {
                parent[key].dataBind();
            }
        }
    };
    Base.prototype.clearChanges = function () {
        this.finalUpdate();
        this.changedProperties = {};
        this.oldProperties = {};
        this.childChangedProperties = {};
    };
    /**
     * Bind property changes immediately to components
     *
     * @returns {void} ?
     */
    Base.prototype.dataBind = function () {
        Base.callChildDataBind(this.childChangedProperties, this);
        if (Object.getOwnPropertyNames(this.changedProperties).length) {
            var prevDetection = this.isProtectedOnChange;
            var newChanges = this.changedProperties;
            var oldChanges = this.oldProperties;
            this.clearChanges();
            this.isProtectedOnChange = true;
            this.onPropertyChanged(newChanges, oldChanges);
            this.isProtectedOnChange = prevDetection;
        }
    };
    /* tslint:disable:no-any */
    Base.prototype.serverDataBind = function (newChanges) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isBlazor */])()) {
            return;
        }
        newChanges = newChanges ? newChanges : {};
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])(this.bulkChanges, {}, newChanges, true);
        var sfBlazor = 'sfBlazor';
        if (this.allowServerDataBinding && window[sfBlazor].updateModel) {
            window[sfBlazor].updateModel(this);
            this.bulkChanges = {};
        }
    };
    /* tslint:enable:no-any */
    Base.prototype.saveChanges = function (key, newValue, oldValue) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isBlazor */])()) {
            // tslint:disable-next-line:no-any
            var newChanges = {};
            newChanges[key] = newValue;
            this.serverDataBind(newChanges);
        }
        if (this.isProtectedOnChange) {
            return;
        }
        this.oldProperties[key] = oldValue;
        this.changedProperties[key] = newValue;
        this.finalUpdate();
        this.finalUpdate = Object(__WEBPACK_IMPORTED_MODULE_0__util__["q" /* setImmediate */])(this.dataBind.bind(this));
    };
    /** Event Base Section */
    /**
     * Adds the handler to the given event listener.
     *
     * @param {string} eventName - A String that specifies the name of the event
     * @param {Function} handler - Specifies the call to run when the event occurs.
     * @returns {void} ?
     */
    Base.prototype.addEventListener = function (eventName, handler) {
        this.modelObserver.on(eventName, handler);
    };
    /**
     * Removes the handler from the given event listener.
     *
     * @param {string} eventName - A String that specifies the name of the event to remove
     * @param {Function} handler - Specifies the function to remove
     * @returns {void} ?
     */
    Base.prototype.removeEventListener = function (eventName, handler) {
        this.modelObserver.off(eventName, handler);
    };
    /**
     * Triggers the handlers in the specified event.
     *
     * @private
     * @param {string} eventName - Specifies the event to trigger for the specified component properties.
     * Can be a custom event, or any of the standard events.
     * @param {Event} eventProp - Additional parameters to pass on to the event properties
     * @param {Function} successHandler - this function will invoke after event successfully triggered
     * @param {Function} errorHandler - this function will invoke after event if it failured to call.
     * @returns {void} ?
     */
    Base.prototype.trigger = function (eventName, eventProp, successHandler, errorHandler) {
        var _this = this;
        if (this.isDestroyed !== true) {
            var prevDetection = this.isProtectedOnChange;
            this.isProtectedOnChange = false;
            var data = this.modelObserver.notify(eventName, eventProp, successHandler, errorHandler);
            if (isColEName.test(eventName)) {
                var handler = Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])(eventName, this);
                if (handler) {
                    var blazor = 'Blazor';
                    if (window[blazor]) {
                        var promise = handler.call(this, eventProp);
                        if (promise && typeof promise.then === 'function') {
                            if (!successHandler) {
                                data = promise;
                            }
                            else {
                                promise.then(function (data) {
                                    if (successHandler) {
                                        data = typeof data === 'string' && _this.modelObserver.isJson(data) ?
                                            JSON.parse(data) : data;
                                        successHandler.call(_this, data);
                                    }
                                }).catch(function (data) {
                                    if (errorHandler) {
                                        data = typeof data === 'string' && _this.modelObserver.isJson(data) ? JSON.parse(data) : data;
                                        errorHandler.call(_this, data);
                                    }
                                });
                            }
                        }
                        else if (successHandler) {
                            successHandler.call(this, eventProp);
                        }
                    }
                    else {
                        handler.call(this, eventProp);
                        if (successHandler) {
                            successHandler.call(this, eventProp);
                        }
                    }
                }
                else if (successHandler) {
                    successHandler.call(this, eventProp);
                }
            }
            this.isProtectedOnChange = prevDetection;
            return data;
        }
    };
    /**
     * To maintain instance in base class
     *
     * @returns {void} ?
     */
    Base.prototype.addInstance = function () {
        // Add module class to the root element
        var moduleClass = 'e-' + this.getModuleName().toLowerCase();
        Object(__WEBPACK_IMPORTED_MODULE_1__dom__["a" /* addClass */])([this.element], ['e-lib', moduleClass]);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(this.element.ej2_instances)) {
            this.element.ej2_instances.push(this);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["r" /* setValue */])('ej2_instances', [this], this.element);
        }
    };
    /**
     * To remove the instance from the element
     *
     * @returns {void} ?
     */
    Base.prototype.destroy = function () {
        var _this = this;
        // eslint-disable-next-line
        this.element.ej2_instances =
            this.element.ej2_instances.filter(function (i) { return i !== _this; });
        Object(__WEBPACK_IMPORTED_MODULE_1__dom__["l" /* removeClass */])([this.element], ['e-' + this.getModuleName()]);
        if (this.element.ej2_instances.length === 0) {
            // Remove module class from the root element
            Object(__WEBPACK_IMPORTED_MODULE_1__dom__["l" /* removeClass */])([this.element], ['e-lib']);
        }
        this.clearChanges();
        this.modelObserver.destroy();
        this.isDestroyed = true;
    };
    return Base;
}());

/**
 * Global function to get the component instance from the rendered element.
 *
 * @param {HTMLElement} elem Specifies the HTMLElement or element id string.
 * @param {string} comp Specifies the component module name or Component.
 * @returns {any} ?
 */
// tslint:disable-next-line:no-any
function getComponent(elem, comp) {
    var instance;
    var i;
    var ele = typeof elem === 'string' ? document.getElementById(elem) : elem;
    for (i = 0; i < ele.ej2_instances.length; i++) {
        instance = ele.ej2_instances[i];
        if (typeof comp === 'string') {
            var compName = instance.getModuleName();
            if (comp === compName) {
                return instance;
            }
        }
        else {
            // tslint:disable-next-line:no-any
            if (instance instanceof comp) {
                return instance;
            }
        }
    }
    return undefined;
}
/**
 * Function to remove the child instances.
 *
 * @param {HTMLElement} element ?
 * @return {void}
 * @private
 */
// tslint:disable-next-line:no-any
function removeChildInstance(element) {
    // tslint:disable-next-line:no-any
    var childEle = [].slice.call(element.getElementsByClassName('e-control'));
    for (var i = 0; i < childEle.length; i++) {
        var compName = childEle[i].classList[1].split('e-')[1];
        // tslint:disable-next-line:no-any
        var compInstance = getComponent(childEle[i], compName);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(compInstance)) {
            compInstance.destroy();
        }
    }
}


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = Property;
/* harmony export (immutable) */ __webpack_exports__["b"] = Complex;
/* unused harmony export ComplexFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = Collection;
/* unused harmony export CollectionFactory */
/* harmony export (immutable) */ __webpack_exports__["c"] = Event;
/* harmony export (immutable) */ __webpack_exports__["d"] = NotifyPropertyChanges;
/* unused harmony export CreateBuilder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(1);

/**
 * Returns the Class Object
 *
 * @param {ClassObject} instance - instance of ClassObject
 * @param {string} curKey - key of the current instance
 * @param {Object} defaultValue - default Value
 * @param {Object[]} type ?
 * @returns {ClassObject} ?
 */
// eslint-disable-next-line
function getObject(instance, curKey, defaultValue, type) {
    // eslint-disable-next-line
    if (!instance.properties.hasOwnProperty(curKey) || !(instance.properties[curKey] instanceof type)) {
        instance.properties[curKey] = Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* createInstance */])(type, [instance, curKey, defaultValue]);
    }
    return instance.properties[curKey];
}
/**
 * Returns object array
 *
 * @param {ClassObject} instance ?
 * @param {string} curKey ?
 * @param {Object[]} defaultValue ?
 * @param {Object} type ?
 * @param {boolean} isSetter ?
 * @param {boolean} isFactory ?
 * @returns {Object[]} ?
 */
// eslint-disable-next-line
function getObjectArray(instance, curKey, defaultValue, type, isSetter, isFactory) {
    var result = [];
    var len = defaultValue ? defaultValue.length : 0;
    for (var i = 0; i < len; i++) {
        var curType = type;
        if (isFactory) {
            curType = type(defaultValue[i], instance);
        }
        if (isSetter) {
            var inst = Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* createInstance */])(curType, [instance, curKey, {}, true]);
            inst.setProperties(defaultValue[i], true);
            result.push(inst);
        }
        else {
            result.push(Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* createInstance */])(curType, [instance, curKey, defaultValue[i], false]));
        }
    }
    return result;
}
/**
 * Returns the properties of the object
 *
 * @param {Object} defaultValue ?
 * @param {string} curKey ?
 * @returns {void} ?
 */
function propertyGetter(defaultValue, curKey) {
    return function () {
        // eslint-disable-next-line
        if (!this.properties.hasOwnProperty(curKey)) {
            this.properties[curKey] = defaultValue;
        }
        return this.properties[curKey];
    };
}
/**
 * Set the properties for the object
 *
 * @param {Object} defaultValue ?
 * @param {string} curKey ?
 * @returns {void} ?
 */
function propertySetter(defaultValue, curKey) {
    return function (newValue) {
        if (this.properties[curKey] !== newValue) {
            // eslint-disable-next-line
            var oldVal = this.properties.hasOwnProperty(curKey) ? this.properties[curKey] : defaultValue;
            this.saveChanges(curKey, newValue, oldVal);
            this.properties[curKey] = newValue;
        }
    };
}
/**
 * Returns complex objects
 *
 * @param {Object} defaultValue ?
 * @param {string} curKey ?
 * @param {Object[]} type ?
 * @returns {void} ?
 */
// eslint-disable-next-line
function complexGetter(defaultValue, curKey, type) {
    return function () {
        return getObject(this, curKey, defaultValue, type);
    };
}
/**
 * Sets complex objects
 *
 * @param {Object} defaultValue ?
 * @param {string} curKey ?
 * @param {Object[]} type ?
 * @returns {void} ?
 */
function complexSetter(defaultValue, curKey, type) {
    return function (newValue) {
        getObject(this, curKey, defaultValue, type).setProperties(newValue);
    };
}
/**
 *
 * @param {Object} defaultValue ?
 * @param {string} curKey ?
 * @param {FunctionConstructor} type ?
 * @returns {void} ?
 */
// eslint-disable-next-line
function complexFactoryGetter(defaultValue, curKey, type) {
    return function () {
        var curType = type({});
        // eslint-disable-next-line
        if (this.properties.hasOwnProperty(curKey)) {
            return this.properties[curKey];
        }
        else {
            return getObject(this, curKey, defaultValue, curType);
        }
    };
}
/**
 *
 * @param {Object} defaultValue ?
 * @param {string} curKey ?
 * @param {Object[]} type ?
 * @returns {void} ?
 */
function complexFactorySetter(defaultValue, curKey, type) {
    return function (newValue) {
        var curType = type(newValue, this);
        getObject(this, curKey, defaultValue, curType).setProperties(newValue);
    };
}
/**
 *
 * @param {Object[]} defaultValue ?
 * @param {string} curKey ?
 * @param {Object[]} type ?
 * @returns {void} ?
 */
function complexArrayGetter(defaultValue, curKey, type) {
    return function () {
        var _this = this;
        // eslint-disable-next-line
        if (!this.properties.hasOwnProperty(curKey)) {
            var defCollection = getObjectArray(this, curKey, defaultValue, type, false);
            this.properties[curKey] = defCollection;
        }
        var ignore = ((this.controlParent !== undefined && this.controlParent.ignoreCollectionWatch)
            || this.ignoreCollectionWatch);
        // eslint-disable-next-line
        if (!this.properties[curKey].hasOwnProperty('push') && !ignore) {
            ['push', 'pop'].forEach(function (extendFunc) {
                var descriptor = {
                    value: complexArrayDefinedCallback(extendFunc, curKey, type, _this.properties[curKey]).bind(_this),
                    configurable: true
                };
                Object.defineProperty(_this.properties[curKey], extendFunc, descriptor);
            });
        }
        // eslint-disable-next-line
        if (!this.properties[curKey].hasOwnProperty('isComplexArray')) {
            Object.defineProperty(this.properties[curKey], 'isComplexArray', { value: true });
        }
        return this.properties[curKey];
    };
}
/**
 *
 * @param {Object[]} defaultValue ?
 * @param {string} curKey ?
 * @param {Object[]} type ?
 * @returns {void} ?
 */
function complexArraySetter(defaultValue, curKey, type) {
    return function (newValue) {
        this.isComplexArraySetter = true;
        var oldValueCollection = getObjectArray(this, curKey, defaultValue, type, false);
        var newValCollection = getObjectArray(this, curKey, newValue, type, true);
        this.isComplexArraySetter = false;
        this.saveChanges(curKey, newValCollection, oldValueCollection);
        this.properties[curKey] = newValCollection;
    };
}
/**
 *
 * @param {Object[]} defaultValue ?
 * @param {string} curKey ?
 * @param {Object[]} type ?
 * @returns {void} ?
 */
function complexArrayFactorySetter(defaultValue, curKey, type) {
    return function (newValue) {
        // eslint-disable-next-line
        var oldValueCollection = this.properties.hasOwnProperty(curKey) ? this.properties[curKey] : defaultValue;
        var newValCollection = getObjectArray(this, curKey, newValue, type, true, true);
        this.saveChanges(curKey, newValCollection, oldValueCollection);
        this.properties[curKey] = newValCollection;
    };
}
/**
 *
 * @param {Object[]} defaultValue ?
 * @param {string} curKey ?
 * @param {FunctionConstructor} type ?
 * @returns {void} ?
 */
function complexArrayFactoryGetter(defaultValue, curKey, type) {
    return function () {
        var curType = type({});
        // eslint-disable-next-line
        if (!this.properties.hasOwnProperty(curKey)) {
            var defCollection = getObjectArray(this, curKey, defaultValue, curType, false);
            this.properties[curKey] = defCollection;
        }
        return this.properties[curKey];
    };
}
/**
 *
 * @param {string} dFunc ?
 * @param {string} curKey ?
 * @param {Object} type ?
 * @param {Object} prop ?
 * @returns {Object} ?
 */
function complexArrayDefinedCallback(dFunc, curKey, type, prop) {
    /* tslint:disable no-function-expression */
    return function () {
        var newValue = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newValue[_i] = arguments[_i];
        }
        var keyString = this.propName ? this.getParentKey() + '.' + curKey + '-' : curKey + '-';
        switch (dFunc) {
            case 'push':
                for (var i = 0; i < newValue.length; i++) {
                    Array.prototype[dFunc].apply(prop, [newValue[i]]);
                    var model_1 = getArrayModel(keyString + (prop.length - 1), newValue[i], !this.controlParent, dFunc);
                    this.serverDataBind(model_1, newValue[i], false, dFunc);
                }
                break;
            case 'pop':
                Array.prototype[dFunc].apply(prop);
                // eslint-disable-next-line
                var model = getArrayModel(keyString + prop.length, null, !this.controlParent, dFunc);
                this.serverDataBind(model, { ejsAction: 'pop' }, false, dFunc);
                break;
        }
        return prop;
    };
}
/**
 *
 * @param {string} keyString ?
 * @param {Object} value ?
 * @param {boolean} isControlParent ?
 * @param {string} arrayFunction ?
 * @returns {Object} ?
 */
function getArrayModel(keyString, value, isControlParent, arrayFunction) {
    var modelObject = keyString;
    if (isControlParent) {
        modelObject = {};
        modelObject[keyString] = value;
        if (value && typeof value === 'object') {
            var action = 'ejsAction';
            modelObject[keyString][action] = arrayFunction;
        }
    }
    return modelObject;
}
// eslint-disable-next-line
/**
 * Method used to create property. General syntax below.
 *
 * @param {Object} defaultValue - Specifies the default value of property.
 * @returns {PropertyDecorator} ?
 * ```
 * @Property('TypeScript')
 * propertyName: Type;
 * ```
 * @private
 */
function Property(defaultValue) {
    return function (target, key) {
        var propertyDescriptor = {
            set: propertySetter(defaultValue, key),
            get: propertyGetter(defaultValue, key),
            enumerable: true,
            configurable: true
        };
        //new property creation
        Object.defineProperty(target, key, propertyDescriptor);
        addPropertyCollection(target, key, 'prop', defaultValue);
    };
}
/**
 * Method used to create complex property. General syntax below.
 *
 * @param  {any} defaultValue - Specifies the default value of property.
 * @param  {Function} type - Specifies the class type of complex object.
 * @returns {PropertyDecorator} ?
 * ```
 * @Complex<Type>({},Type)
 * propertyName: Type;
 * ```
 * @private
 */
function Complex(defaultValue, type) {
    return function (target, key) {
        var propertyDescriptor = {
            set: complexSetter(defaultValue, key, type),
            get: complexGetter(defaultValue, key, type),
            enumerable: true,
            configurable: true
        };
        //new property creation
        Object.defineProperty(target, key, propertyDescriptor);
        addPropertyCollection(target, key, 'complexProp', defaultValue, type);
    };
}
/**
 * Method used to create complex Factory property. General syntax below.
 *
 * @param  {Function} type - Specifies the class factory type of complex object.
 * @returns {PropertyDecorator} ?
 * ```
 * @ComplexFactory(defaultType, factoryFunction)
 * propertyName: Type1 | Type2;
 * ```
 * @private
 */
function ComplexFactory(type) {
    return function (target, key) {
        var propertyDescriptor = {
            set: complexFactorySetter({}, key, type),
            get: complexFactoryGetter({}, key, type),
            enumerable: true,
            configurable: true
        };
        //new property creation
        Object.defineProperty(target, key, propertyDescriptor);
        addPropertyCollection(target, key, 'complexProp', {}, type);
    };
}
/**
 * Method used to create complex array property. General syntax below.
 *
 * @param  {any} defaultValue - Specifies the default value of property.
 * @param  {Function} type - Specifies the class type of complex object.
 * @returns {PropertyDecorator} ?
 * ```
 * @Collection([], Type);
 * propertyName: Type;
 * ```
 * @private
 */
function Collection(defaultValue, type) {
    return function (target, key) {
        var propertyDescriptor = {
            set: complexArraySetter(defaultValue, key, type),
            get: complexArrayGetter(defaultValue, key, type),
            enumerable: true,
            configurable: true
        };
        //new property creation
        Object.defineProperty(target, key, propertyDescriptor);
        addPropertyCollection(target, key, 'colProp', defaultValue, type);
    };
}
/**
 * Method used to create complex factory array property. General syntax below.
 *
 * @param  {Function} type - Specifies the class type of complex object.
 * @returns {PropertyCollectionInfo} ?
 * ```
 * @Collection([], Type);
 * propertyName: Type;
 * ```
 * @private
 */
function CollectionFactory(type) {
    return function (target, key) {
        var propertyDescriptor = {
            set: complexArrayFactorySetter([], key, type),
            get: complexArrayFactoryGetter([], key, type),
            enumerable: true,
            configurable: true
        };
        //new property creation
        Object.defineProperty(target, key, propertyDescriptor);
        addPropertyCollection(target, key, 'colProp', {}, type);
    };
}
/**
 * Method used to create event property. General syntax below.
 *
 * @returns {PropertyDecorator} ?
 * ```
 * @Event(()=>{return true;})
 * ```
 * @private
 */
function Event() {
    return function (target, key) {
        var eventDescriptor = {
            set: function (newValue) {
                var oldValue = this.properties[key];
                if (oldValue !== newValue) {
                    var finalContext = getParentContext(this, key);
                    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(oldValue) === false) {
                        finalContext.context.removeEventListener(finalContext.prefix, oldValue);
                    }
                    finalContext.context.addEventListener(finalContext.prefix, newValue);
                    this.properties[key] = newValue;
                }
            },
            get: propertyGetter(undefined, key),
            enumerable: true,
            configurable: true
        };
        Object.defineProperty(target, key, eventDescriptor);
        addPropertyCollection(target, key, 'event');
    };
}
/**
 * NotifyPropertyChanges is triggers the call back when the property has been changed.
 *
 * @param {Function} classConstructor ?
 * @returns {void} ?
 * ```
 *  @NotifyPropertyChanges
 * class DemoClass implements INotifyPropertyChanged {
 *
 *     @Property()
 *     property1: string;
 *
 *     dataBind: () => void;
 *
 *     constructor() { }
 *
 *     onPropertyChanged(newProp: any, oldProp: any) {
 *         // Called when property changed
 *     }
 * }
 * ```
 * @private
 */
// eslint-disable-next-line
function NotifyPropertyChanges(classConstructor) {
    /** Need to code */
}
/**
 * Method  used to create the builderObject for the target component.
 *
 * @param {BuildInfo} target ?
 * @param {string} key ?
 * @param {string} propertyType ?
 * @param {Object} defaultValue ?
 * @param {Function} type ?
 * @returns {void} ?
 * @private
 */
function addPropertyCollection(target, key, propertyType, defaultValue, type) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(target.propList)) {
        target.propList = {
            props: [],
            complexProps: [],
            colProps: [],
            events: [],
            propNames: [],
            complexPropNames: [],
            colPropNames: [],
            eventNames: []
        };
    }
    // eslint-disable-next-line
    target.propList[propertyType + 's'].push({
        propertyName: key,
        defaultValue: defaultValue,
        type: type
    });
    // eslint-disable-next-line
    target.propList[propertyType + 'Names'].push(key);
}
/**
 * Returns an object containing the builder properties
 *
 * @param {Function} component ?
 * @returns {Object} ?
 * @private
 */
function getBuilderProperties(component) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(component.prototype.builderObject)) {
        component.prototype.builderObject = {
            properties: {}, propCollections: [], add: function () {
                this.isPropertyArray = true;
                this.propCollections.push(Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])({}, this.properties, {}));
            }
        };
        var rex = /complex/;
        for (var _i = 0, _a = Object.keys(component.prototype.propList); _i < _a.length; _i++) {
            var key = _a[_i];
            var _loop_1 = function (prop) {
                if (rex.test(key)) {
                    component.prototype.builderObject[prop.propertyName] = function (value) {
                        var childType = {};
                        Object(__WEBPACK_IMPORTED_MODULE_0__util__["p" /* merge */])(childType, getBuilderProperties(prop.type));
                        value(childType);
                        var tempValue;
                        if (!childType.isPropertyArray) {
                            tempValue = Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])({}, childType.properties, {});
                        }
                        else {
                            tempValue = childType.propCollections;
                        }
                        this.properties[prop.propertyName] = tempValue;
                        childType.properties = {};
                        childType.propCollections = [];
                        childType.isPropertyArray = false;
                        return this;
                    };
                }
                else {
                    component.prototype.builderObject[prop.propertyName] = function (value) {
                        this.properties[prop.propertyName] = value;
                        return this;
                    };
                }
            };
            for (var _b = 0, _c = component.prototype.propList[key]; _b < _c.length; _b++) {
                var prop = _c[_b];
                _loop_1(prop);
            }
        }
    }
    return component.prototype.builderObject;
}
/**
 * Method used to create builder for the components
 *
 * @param {any} component -specifies the target component for which builder to be created.
 * @returns {Object} ?
 * @private
 */
function CreateBuilder(component) {
    var builderFunction = function (element) {
        this.element = element;
        return this;
    };
    var instanceFunction = function (element) {
        // eslint-disable-next-line
        if (!builderFunction.prototype.hasOwnProperty('create')) {
            builderFunction.prototype = getBuilderProperties(component);
            builderFunction.prototype.create = function () {
                var temp = Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])({}, {}, this.properties);
                this.properties = {};
                return new component(temp, this.element);
            };
        }
        return new builderFunction(element);
    };
    return instanceFunction;
}
/**
 * Returns parent options for the object
 *
 * @param {Object} context ?
 * @param {string} prefix ?
 * @returns {ParentOption} ?
 * @private
 */
function getParentContext(context, prefix) {
    // eslint-disable-next-line
    if (context.hasOwnProperty('parentObj') === false) {
        return { context: context, prefix: prefix };
    }
    else {
        var curText = Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])('propName', context);
        if (curText) {
            prefix = curText + '-' + prefix;
        }
        return getParentContext(Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])('parentObj', context), prefix);
    }
}


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export blazorCultureFormats */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IntlBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internationalization__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parser_base__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date_formatter__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number_formatter__ = __webpack_require__(79);






var blazorCultureFormats = {
    'en-US': {
        'd': 'M/d/y',
        'D': 'EEEE, MMMM d, y',
        'f': 'EEEE, MMMM d, y h:mm a',
        'F': 'EEEE, MMMM d, y h:mm:s a',
        'g': 'M/d/y h:mm a',
        'G': 'M/d/yyyy h:mm:ss tt',
        'm': 'MMMM d',
        'M': 'MMMM d',
        'r': 'ddd, dd MMM yyyy HH\':\'mm\':\'ss \'GMT\'',
        'R': 'ddd, dd MMM yyyy HH\':\'mm\':\'ss \'GMT\'',
        's': 'yyyy\'-\'MM\'-\'dd\'T\'HH\':\'mm\':\'ss',
        't': 'h:mm tt',
        'T': 'h:m:s tt',
        'u': 'yyyy\'-\'MM\'-\'dd HH\':\'mm\':\'ss\'Z\'',
        'U': 'dddd, MMMM d, yyyy h:mm:ss tt',
        'y': 'MMMM yyyy',
        'Y': 'MMMM yyyy'
    }
};
/**
 * Date base common constants and function for date parser and formatter.
 */
// eslint-disable-next-line
var IntlBase;
(function (IntlBase) {
    // tslint:disable-next-line:max-line-length
    IntlBase.negativeDataRegex = /^(('[^']+'|''|[^*#@0,.E])*)(\*.)?((([#,]*[0,]*0+)(\.0*[0-9]*#*)?)|([#,]*@+#*))(E\+?0+)?(('[^']+'|''|[^*#@0,.E])*)$/;
    IntlBase.customRegex = /^(('[^']+'|''|[^*#@0,.])*)(\*.)?((([0#,]*[0,]*[0#]*[0#\ ]*)(\.[0#]*)?)|([#,]*@+#*))(E\+?0+)?(('[^']+'|''|[^*#@0,.E])*)$/;
    IntlBase.latnParseRegex = /0|1|2|3|4|5|6|7|8|9/g;
    var fractionRegex = /[0-9]/g;
    IntlBase.defaultCurrency = '$';
    var mapper = ['infinity', 'nan', 'group', 'decimal'];
    var patternRegex = /G|M|L|H|c|'| a|yy|y|EEEE|E/g;
    var patternMatch = {
        'G': '',
        'M': 'm',
        'L': 'm',
        'H': 'h',
        'c': 'd',
        '\'': '"',
        ' a': ' AM/PM',
        'yy': 'yy',
        'y': 'yyyy',
        'EEEE': 'dddd',
        'E': 'ddd'
    };
    IntlBase.dateConverterMapper = /dddd|ddd/ig;
    var defaultFirstDay = 'sun';
    IntlBase.islamicRegex = /^islamic/;
    var firstDayMapper = {
        'sun': 0,
        'mon': 1,
        'tue': 2,
        'wed': 3,
        'thu': 4,
        'fri': 5,
        'sat': 6
    };
    IntlBase.formatRegex = /(^[ncpae]{1})([0-1]?[0-9]|20)?$/i;
    IntlBase.currencyFormatRegex = /(^[ca]{1})([0-1]?[0-9]|20)?$/i;
    IntlBase.curWithoutNumberRegex = /(c|a)$/ig;
    var typeMapper = {
        '$': 'isCurrency',
        '%': 'isPercent',
        '-': 'isNegative',
        0: 'nlead',
        1: 'nend'
    };
    IntlBase.dateParseRegex = /([a-z])\1*|'([^']|'')+'|''|./gi;
    IntlBase.basicPatterns = ['short', 'medium', 'long', 'full'];
    /* tslint:disable:quotemark */
    IntlBase.defaultObject = {
        'dates': {
            'calendars': {
                'gregorian': {
                    'months': {
                        'stand-alone': {
                            'abbreviated': {
                                '1': 'Jan',
                                '2': 'Feb',
                                '3': 'Mar',
                                '4': 'Apr',
                                '5': 'May',
                                '6': 'Jun',
                                '7': 'Jul',
                                '8': 'Aug',
                                '9': 'Sep',
                                '10': 'Oct',
                                '11': 'Nov',
                                '12': 'Dec'
                            },
                            'narrow': {
                                '1': 'J',
                                '2': 'F',
                                '3': 'M',
                                '4': 'A',
                                '5': 'M',
                                '6': 'J',
                                '7': 'J',
                                '8': 'A',
                                '9': 'S',
                                '10': 'O',
                                '11': 'N',
                                '12': 'D'
                            },
                            'wide': {
                                '1': 'January',
                                '2': 'February',
                                '3': 'March',
                                '4': 'April',
                                '5': 'May',
                                '6': 'June',
                                '7': 'July',
                                '8': 'August',
                                '9': 'September',
                                '10': 'October',
                                '11': 'November',
                                '12': 'December'
                            }
                        }
                    },
                    'days': {
                        'stand-alone': {
                            'abbreviated': {
                                'sun': 'Sun',
                                'mon': 'Mon',
                                'tue': 'Tue',
                                'wed': 'Wed',
                                'thu': 'Thu',
                                'fri': 'Fri',
                                'sat': 'Sat'
                            },
                            'narrow': {
                                'sun': 'S',
                                'mon': 'M',
                                'tue': 'T',
                                'wed': 'W',
                                'thu': 'T',
                                'fri': 'F',
                                'sat': 'S'
                            },
                            'short': {
                                'sun': 'Su',
                                'mon': 'Mo',
                                'tue': 'Tu',
                                'wed': 'We',
                                'thu': 'Th',
                                'fri': 'Fr',
                                'sat': 'Sa'
                            },
                            'wide': {
                                'sun': 'Sunday',
                                'mon': 'Monday',
                                'tue': 'Tuesday',
                                'wed': 'Wednesday',
                                'thu': 'Thursday',
                                'fri': 'Friday',
                                'sat': 'Saturday'
                            }
                        }
                    },
                    'dayPeriods': {
                        'format': {
                            'wide': {
                                'am': 'AM',
                                'pm': 'PM'
                            }
                        }
                    },
                    'eras': {
                        'eraNames': {
                            '0': 'Before Christ',
                            '0-alt-variant': 'Before Common Era',
                            '1': 'Anno Domini',
                            '1-alt-variant': 'Common Era'
                        },
                        'eraAbbr': {
                            '0': 'BC',
                            '0-alt-variant': 'BCE',
                            '1': 'AD',
                            '1-alt-variant': 'CE'
                        },
                        'eraNarrow': {
                            '0': 'B',
                            '0-alt-variant': 'BCE',
                            '1': 'A',
                            '1-alt-variant': 'CE'
                        }
                    },
                    'dateFormats': {
                        'full': 'EEEE, MMMM d, y',
                        'long': 'MMMM d, y',
                        'medium': 'MMM d, y',
                        'short': 'M/d/yy'
                    },
                    'timeFormats': {
                        'full': 'h:mm:ss a zzzz',
                        'long': 'h:mm:ss a z',
                        'medium': 'h:mm:ss a',
                        'short': 'h:mm a'
                    },
                    'dateTimeFormats': {
                        'full': '{1} \'at\' {0}',
                        'long': '{1} \'at\' {0}',
                        'medium': '{1}, {0}',
                        'short': '{1}, {0}',
                        'availableFormats': {
                            'd': 'd',
                            'E': 'ccc',
                            'Ed': 'd E',
                            'Ehm': 'E h:mm a',
                            'EHm': 'E HH:mm',
                            'Ehms': 'E h:mm:ss a',
                            'EHms': 'E HH:mm:ss',
                            'Gy': 'y G',
                            'GyMMM': 'MMM y G',
                            'GyMMMd': 'MMM d, y G',
                            'GyMMMEd': 'E, MMM d, y G',
                            'h': 'h a',
                            'H': 'HH',
                            'hm': 'h:mm a',
                            'Hm': 'HH:mm',
                            'hms': 'h:mm:ss a',
                            'Hms': 'HH:mm:ss',
                            'hmsv': 'h:mm:ss a v',
                            'Hmsv': 'HH:mm:ss v',
                            'hmv': 'h:mm a v',
                            'Hmv': 'HH:mm v',
                            'M': 'L',
                            'Md': 'M/d',
                            'MEd': 'E, M/d',
                            'MMM': 'LLL',
                            'MMMd': 'MMM d',
                            'MMMEd': 'E, MMM d',
                            'MMMMd': 'MMMM d',
                            'ms': 'mm:ss',
                            'y': 'y',
                            'yM': 'M/y',
                            'yMd': 'M/d/y',
                            'yMEd': 'E, M/d/y',
                            'yMMM': 'MMM y',
                            'yMMMd': 'MMM d, y',
                            'yMMMEd': 'E, MMM d, y',
                            'yMMMM': 'MMMM y'
                        }
                    }
                },
                'islamic': {
                    'months': {
                        'stand-alone': {
                            'abbreviated': {
                                '1': 'Muh.',
                                '2': 'Saf.',
                                '3': 'Rab. I',
                                '4': 'Rab. II',
                                '5': 'Jum. I',
                                '6': 'Jum. II',
                                '7': 'Raj.',
                                '8': 'Sha.',
                                '9': 'Ram.',
                                '10': 'Shaw.',
                                '11': 'Dhuʻl-Q.',
                                '12': 'Dhuʻl-H.'
                            },
                            'narrow': {
                                '1': '1',
                                '2': '2',
                                '3': '3',
                                '4': '4',
                                '5': '5',
                                '6': '6',
                                '7': '7',
                                '8': '8',
                                '9': '9',
                                '10': '10',
                                '11': '11',
                                '12': '12'
                            },
                            'wide': {
                                '1': 'Muharram',
                                '2': 'Safar',
                                '3': 'Rabiʻ I',
                                '4': 'Rabiʻ II',
                                '5': 'Jumada I',
                                '6': 'Jumada II',
                                '7': 'Rajab',
                                '8': 'Shaʻban',
                                '9': 'Ramadan',
                                '10': 'Shawwal',
                                '11': 'Dhuʻl-Qiʻdah',
                                '12': 'Dhuʻl-Hijjah'
                            }
                        }
                    },
                    'days': {
                        'stand-alone': {
                            'abbreviated': {
                                'sun': 'Sun',
                                'mon': 'Mon',
                                'tue': 'Tue',
                                'wed': 'Wed',
                                'thu': 'Thu',
                                'fri': 'Fri',
                                'sat': 'Sat'
                            },
                            'narrow': {
                                'sun': 'S',
                                'mon': 'M',
                                'tue': 'T',
                                'wed': 'W',
                                'thu': 'T',
                                'fri': 'F',
                                'sat': 'S'
                            },
                            'short': {
                                'sun': 'Su',
                                'mon': 'Mo',
                                'tue': 'Tu',
                                'wed': 'We',
                                'thu': 'Th',
                                'fri': 'Fr',
                                'sat': 'Sa'
                            },
                            'wide': {
                                'sun': 'Sunday',
                                'mon': 'Monday',
                                'tue': 'Tuesday',
                                'wed': 'Wednesday',
                                'thu': 'Thursday',
                                'fri': 'Friday',
                                'sat': 'Saturday'
                            }
                        }
                    },
                    'dayPeriods': {
                        'format': {
                            'wide': {
                                'am': 'AM',
                                'pm': 'PM'
                            }
                        }
                    },
                    'eras': {
                        'eraNames': {
                            '0': 'AH'
                        },
                        'eraAbbr': {
                            '0': 'AH'
                        },
                        'eraNarrow': {
                            '0': 'AH'
                        }
                    },
                    'dateFormats': {
                        'full': 'EEEE, MMMM d, y G',
                        'long': 'MMMM d, y G',
                        'medium': 'MMM d, y G',
                        'short': 'M/d/y GGGGG'
                    },
                    'timeFormats': {
                        'full': 'h:mm:ss a zzzz',
                        'long': 'h:mm:ss a z',
                        'medium': 'h:mm:ss a',
                        'short': 'h:mm a'
                    },
                    'dateTimeFormats': {
                        'full': '{1} \'at\' {0}',
                        'long': '{1} \'at\' {0}',
                        'medium': '{1}, {0}',
                        'short': '{1}, {0}',
                        'availableFormats': {
                            'd': 'd',
                            'E': 'ccc',
                            'Ed': 'd E',
                            'Ehm': 'E h:mm a',
                            'EHm': 'E HH:mm',
                            'Ehms': 'E h:mm:ss a',
                            'EHms': 'E HH:mm:ss',
                            'Gy': 'y G',
                            'GyMMM': 'MMM y G',
                            'GyMMMd': 'MMM d, y G',
                            'GyMMMEd': 'E, MMM d, y G',
                            'h': 'h a',
                            'H': 'HH',
                            'hm': 'h:mm a',
                            'Hm': 'HH:mm',
                            'hms': 'h:mm:ss a',
                            'Hms': 'HH:mm:ss',
                            'M': 'L',
                            'Md': 'M/d',
                            'MEd': 'E, M/d',
                            'MMM': 'LLL',
                            'MMMd': 'MMM d',
                            'MMMEd': 'E, MMM d',
                            'MMMMd': 'MMMM d',
                            'ms': 'mm:ss',
                            'y': 'y G',
                            'yyyy': 'y G',
                            'yyyyM': 'M/y GGGGG',
                            'yyyyMd': 'M/d/y GGGGG',
                            'yyyyMEd': 'E, M/d/y GGGGG',
                            'yyyyMMM': 'MMM y G',
                            'yyyyMMMd': 'MMM d, y G',
                            'yyyyMMMEd': 'E, MMM d, y G',
                            'yyyyMMMM': 'MMMM y G',
                            'yyyyQQQ': 'QQQ y G',
                            'yyyyQQQQ': 'QQQQ y G'
                        }
                    }
                }
            },
            'timeZoneNames': {
                'hourFormat': '+HH:mm;-HH:mm',
                'gmtFormat': 'GMT{0}',
                'gmtZeroFormat': 'GMT'
            }
        },
        'numbers': {
            'currencies': {
                'USD': {
                    'displayName': 'US Dollar',
                    'symbol': '$',
                    'symbol-alt-narrow': '$'
                },
                'EUR': {
                    'displayName': 'Euro',
                    'symbol': '€',
                    'symbol-alt-narrow': '€'
                },
                'GBP': {
                    'displayName': 'British Pound',
                    'symbol-alt-narrow': '£'
                }
            },
            'defaultNumberingSystem': 'latn',
            'minimumGroupingDigits': '1',
            'symbols-numberSystem-latn': {
                'decimal': '.',
                'group': ',',
                'list': ';',
                'percentSign': '%',
                'plusSign': '+',
                'minusSign': '-',
                'exponential': 'E',
                'superscriptingExponent': '×',
                'perMille': '‰',
                'infinity': '∞',
                'nan': 'NaN',
                'timeSeparator': ':'
            },
            'decimalFormats-numberSystem-latn': {
                'standard': '#,##0.###'
            },
            'percentFormats-numberSystem-latn': {
                'standard': '#,##0%'
            },
            'currencyFormats-numberSystem-latn': {
                'standard': '¤#,##0.00',
                'accounting': '¤#,##0.00;(¤#,##0.00)'
            },
            'scientificFormats-numberSystem-latn': {
                'standard': '#E0'
            }
        }
    };
    IntlBase.blazorDefaultObject = {
        'numbers': {
            'mapper': {
                '0': '0',
                '1': '1',
                '2': '2',
                '3': '3',
                '4': '4',
                '5': '5',
                '6': '6',
                '7': '7',
                '8': '8',
                '9': '9'
            },
            'mapperDigits': '0123456789',
            'numberSymbols': {
                'decimal': '.',
                'group': ',',
                'plusSign': '+',
                'minusSign': '-',
                'percentSign': '%',
                'nan': 'NaN',
                'timeSeparator': ':',
                'infinity': '∞'
            },
            'timeSeparator': ':',
            'currencySymbol': '$',
            'currencypData': {
                'nlead': '$',
                'nend': '',
                'groupSeparator': ',',
                'groupData': {
                    'primary': 3
                },
                'maximumFraction': 2,
                'minimumFraction': 2
            },
            'percentpData': {
                'nlead': '',
                'nend': '%',
                'groupSeparator': ',',
                'groupData': {
                    'primary': 3
                },
                'maximumFraction': 2,
                'minimumFraction': 2
            },
            'percentnData': {
                'nlead': '-',
                'nend': '%',
                'groupSeparator': ',',
                'groupData': {
                    'primary': 3
                },
                'maximumFraction': 2,
                'minimumFraction': 2
            },
            'currencynData': {
                'nlead': '($',
                'nend': ')',
                'groupSeparator': ',',
                'groupData': {
                    'primary': 3
                },
                'maximumFraction': 2,
                'minimumFraction': 2
            },
            'decimalnData': {
                'nlead': '-',
                'nend': '',
                'groupData': {
                    'primary': 3
                },
                'maximumFraction': 2,
                'minimumFraction': 2
            },
            'decimalpData': {
                'nlead': '',
                'nend': '',
                'groupData': {
                    'primary': 3
                },
                'maximumFraction': 2,
                'minimumFraction': 2
            }
        },
        'dates': {
            'dayPeriods': {
                'am': 'AM',
                'pm': 'PM'
            },
            'dateSeperator': '/',
            'days': {
                'abbreviated': {
                    'sun': 'Sun',
                    'mon': 'Mon',
                    'tue': 'Tue',
                    'wed': 'Wed',
                    'thu': 'Thu',
                    'fri': 'Fri',
                    'sat': 'Sat'
                },
                'short': {
                    'sun': 'Su',
                    'mon': 'Mo',
                    'tue': 'Tu',
                    'wed': 'We',
                    'thu': 'Th',
                    'fri': 'Fr',
                    'sat': 'Sa'
                },
                'wide': {
                    'sun': 'Sunday',
                    'mon': 'Monday',
                    'tue': 'Tuesday',
                    'wed': 'Wednesday',
                    'thu': 'Thursday',
                    'fri': 'Friday',
                    'sat': 'Saturday'
                }
            },
            'months': {
                'abbreviated': {
                    '1': 'Jan',
                    '2': 'Feb',
                    '3': 'Mar',
                    '4': 'Apr',
                    '5': 'May',
                    '6': 'Jun',
                    '7': 'Jul',
                    '8': 'Aug',
                    '9': 'Sep',
                    '10': 'Oct',
                    '11': 'Nov',
                    '12': 'Dec'
                },
                'wide': {
                    '1': 'January',
                    '2': 'February',
                    '3': 'March',
                    '4': 'April',
                    '5': 'May',
                    '6': 'June',
                    '7': 'July',
                    '8': 'August',
                    '9': 'September',
                    '10': 'October',
                    '11': 'November',
                    '12': 'December'
                }
            },
            'eras': {
                '1': 'AD'
            }
        }
    };
    /* tslint:enable:quotemark */
    IntlBase.monthIndex = {
        3: 'abbreviated',
        4: 'wide',
        5: 'narrow',
        1: 'abbreviated'
    };
    /**
     *
     */
    IntlBase.month = 'months';
    IntlBase.days = 'days';
    /**
     * Default numerber Object
     */
    IntlBase.patternMatcher = {
        C: 'currency',
        P: 'percent',
        N: 'decimal',
        A: 'currency',
        E: 'scientific'
    };
    /**
     * Returns the resultant pattern based on the skeleton, dateObject and the type provided
     *
     * @private
     * @param {string} skeleton ?
     * @param {Object} dateObject ?
     * @param {string} type ?
     * @param {boolean} isIslamic ?
     * @param {string} blazorCulture ?
     * @returns {string} ?
     */
    function getResultantPattern(skeleton, dateObject, type, isIslamic, blazorCulture) {
        var resPattern;
        var iType = type || 'date';
        if (blazorCulture) {
            resPattern = compareBlazorDateFormats({ skeleton: skeleton }, blazorCulture).format ||
                compareBlazorDateFormats({ skeleton: 'd' }, 'en-US').format;
        }
        else {
            if (IntlBase.basicPatterns.indexOf(skeleton) !== -1) {
                resPattern = Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])(iType + 'Formats.' + skeleton, dateObject);
                if (iType === 'dateTime') {
                    var dPattern = Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('dateFormats.' + skeleton, dateObject);
                    var tPattern = Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('timeFormats.' + skeleton, dateObject);
                    resPattern = resPattern.replace('{1}', dPattern).replace('{0}', tPattern);
                }
            }
            else {
                resPattern = Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('dateTimeFormats.availableFormats.' + skeleton, dateObject);
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["o" /* isUndefined */])(resPattern) && skeleton === 'yMd') {
                resPattern = 'M/d/y';
            }
        }
        return resPattern;
    }
    IntlBase.getResultantPattern = getResultantPattern;
    /**
     * Returns the dependable object for provided cldr data and culture
     *
     * @private
     * @param {Object} cldr ?
     * @param {string} culture ?
     * @param {string} mode ?
     * @param {boolean} isNumber ?
     * @returns {any} ?
     */
    function getDependables(cldr, culture, mode, isNumber) {
        var ret = {};
        var calendartype = mode || 'gregorian';
        ret.parserObject = __WEBPACK_IMPORTED_MODULE_2__parser_base__["a" /* ParserBase */].getMainObject(cldr, culture) || (Object(__WEBPACK_IMPORTED_MODULE_1__util__["l" /* isBlazor */])() ? IntlBase.blazorDefaultObject : IntlBase.defaultObject);
        if (isNumber) {
            ret.numericObject = Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('numbers', ret.parserObject);
        }
        else {
            var dateString = Object(__WEBPACK_IMPORTED_MODULE_1__util__["l" /* isBlazor */])() ? 'dates' : ('dates.calendars.' + calendartype);
            ret.dateObject = Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])(dateString, ret.parserObject);
        }
        return ret;
    }
    IntlBase.getDependables = getDependables;
    /**
     * Returns the symbol pattern for provided parameters
     *
     * @private
     * @param {string} type ?
     * @param {string} numSystem ?
     * @param {Object} obj ?
     * @param {boolean} isAccount ?
     * @returns {string} ?
     */
    function getSymbolPattern(type, numSystem, obj, isAccount) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])(type + 'Formats-numberSystem-' +
            numSystem + (isAccount ? '.accounting' : '.standard'), obj) || (isAccount ? Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])(type + 'Formats-numberSystem-' +
            numSystem + '.standard', obj) : '');
    }
    IntlBase.getSymbolPattern = getSymbolPattern;
    /**
     *
     * @param {string} format ?
     * @returns {string} ?
     */
    function ConvertDateToWeekFormat(format) {
        var convertMapper = format.match(IntlBase.dateConverterMapper);
        if (convertMapper && Object(__WEBPACK_IMPORTED_MODULE_1__util__["l" /* isBlazor */])()) {
            var tempString = convertMapper[0].length === 3 ? 'EEE' : 'EEEE';
            return format.replace(IntlBase.dateConverterMapper, tempString);
        }
        return format;
    }
    IntlBase.ConvertDateToWeekFormat = ConvertDateToWeekFormat;
    /**
     *
     * @param {DateFormatOptions} formatOptions ?
     * @param {string} culture ?
     * @returns {DateFormatOptions} ?
     */
    function compareBlazorDateFormats(formatOptions, culture) {
        var format = formatOptions.format || formatOptions.skeleton;
        var curFormatMapper = Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])((culture || 'en-US') + '.' + format, blazorCultureFormats);
        if (!curFormatMapper) {
            curFormatMapper = Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('en-US.' + format, blazorCultureFormats);
        }
        if (curFormatMapper) {
            curFormatMapper = ConvertDateToWeekFormat(curFormatMapper);
            formatOptions.format = curFormatMapper.replace(/tt/, 'a');
        }
        return formatOptions;
    }
    IntlBase.compareBlazorDateFormats = compareBlazorDateFormats;
    /**
     * Returns proper numeric skeleton
     *
     * @private
     * @param {string} skeleton ?
     * @returns {any} ?
     */
    function getProperNumericSkeleton(skeleton) {
        var matches = skeleton.match(IntlBase.formatRegex);
        var ret = {};
        var pattern = matches[1].toUpperCase();
        ret.isAccount = (pattern === 'A');
        // eslint-disable-next-line
        ret.type = IntlBase.patternMatcher[pattern];
        if (skeleton.length > 1) {
            ret.fractionDigits = parseInt(matches[2], 10);
        }
        return ret;
    }
    IntlBase.getProperNumericSkeleton = getProperNumericSkeleton;
    /**
     * Returns format data for number formatting like minimum fraction, maximum fraction, etc..,
     *
     * @private
     * @param {string} pattern ?
     * @param {boolean} needFraction ?
     * @param {string} cSymbol ?
     * @param {boolean} fractionOnly ?
     * @returns {any} ?
     */
    function getFormatData(pattern, needFraction, cSymbol, fractionOnly) {
        var nData = fractionOnly ? {} : { nlead: '', nend: '' };
        var match = pattern.match(IntlBase.customRegex);
        if (match) {
            if (!fractionOnly) {
                nData.nlead = changeCurrencySymbol(match[1], cSymbol);
                nData.nend = changeCurrencySymbol(match[10], cSymbol);
                nData.groupPattern = match[4];
            }
            var fraction = match[7];
            if (fraction && needFraction) {
                var fmatch = fraction.match(fractionRegex);
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["m" /* isNullOrUndefined */])(fmatch)) {
                    nData.minimumFraction = fmatch.length;
                }
                else {
                    nData.minimumFraction = 0;
                }
                nData.maximumFraction = fraction.length - 1;
            }
        }
        return nData;
    }
    IntlBase.getFormatData = getFormatData;
    /**
     * Changes currency symbol
     *
     * @private
     * @param {string} val ?
     * @param {string} sym ?
     * @returns {string} ?
     */
    function changeCurrencySymbol(val, sym) {
        if (val) {
            return val.replace(IntlBase.defaultCurrency, sym);
        }
        return '';
    }
    IntlBase.changeCurrencySymbol = changeCurrencySymbol;
    /**
     * Returns currency symbol based on currency code ?
     *
     * @private
     * @param {Object} numericObject ?
     * @param {string} currencyCode ?
     * @param {string} altSymbol ?
     * @returns {string} ?
     */
    function getCurrencySymbol(numericObject, currencyCode, altSymbol) {
        var symbol = altSymbol ? ('.' + altSymbol) : '.symbol';
        var getCurrency = Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('currencies.' + currencyCode + symbol, numericObject) ||
            Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('currencies.' + currencyCode + '.symbol-alt-narrow', numericObject) || '$';
        return getCurrency;
    }
    IntlBase.getCurrencySymbol = getCurrencySymbol;
    /**
     * Returns formatting options for custom number format
     *
     * @private
     * @param {string} format ?
     * @param {CommonOptions} dOptions ?
     * @param {any} obj ?
     * @returns {any} ?
     */
    function customFormat(format, dOptions, obj) {
        var options = {};
        var formatSplit = format.split(';');
        var data = ['pData', 'nData', 'zeroData'];
        for (var i = 0; i < formatSplit.length; i++) {
            // eslint-disable-next-line
            options[data[i]] = customNumberFormat(formatSplit[i], dOptions, obj);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["m" /* isNullOrUndefined */])(options.nData)) {
            options.nData = Object(__WEBPACK_IMPORTED_MODULE_1__util__["f" /* extend */])({}, options.pData);
            options.nData.nlead = Object(__WEBPACK_IMPORTED_MODULE_1__util__["m" /* isNullOrUndefined */])(dOptions) ? '-' + options.nData.nlead : dOptions.minusSymbol + options.nData.nlead;
        }
        return options;
    }
    IntlBase.customFormat = customFormat;
    /**
     * Returns custom formatting options
     *
     * @private
     * @param {string} format ?
     * @param {CommonOptions} dOptions ?
     * @param {Object} numObject ?
     * @returns {any} ?
     */
    function customNumberFormat(format, dOptions, numObject) {
        var cOptions = { type: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 };
        var pattern = format.match(IntlBase.customRegex);
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["m" /* isNullOrUndefined */])(pattern) || (pattern[5] === '' && format !== 'N/A')) {
            cOptions.type = undefined;
            return cOptions;
        }
        cOptions.nlead = pattern[1];
        cOptions.nend = pattern[10];
        var integerPart = pattern[6];
        var spaceCapture = integerPart.match(/\ $/g) ? true : false;
        var spaceGrouping = integerPart.replace(/\ $/g, '').indexOf(' ') !== -1;
        cOptions.useGrouping = integerPart.indexOf(',') !== -1 || spaceGrouping;
        integerPart = integerPart.replace(/,/g, '');
        var fractionPart = pattern[7];
        if (integerPart.indexOf('0') !== -1) {
            cOptions.minimumIntegerDigits = integerPart.length - integerPart.indexOf('0');
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["m" /* isNullOrUndefined */])(fractionPart)) {
            cOptions.minimumFractionDigits = fractionPart.lastIndexOf('0');
            cOptions.maximumFractionDigits = fractionPart.lastIndexOf('#');
            if (cOptions.minimumFractionDigits === -1) {
                cOptions.minimumFractionDigits = 0;
            }
            if (cOptions.maximumFractionDigits === -1 || cOptions.maximumFractionDigits < cOptions.minimumFractionDigits) {
                cOptions.maximumFractionDigits = cOptions.minimumFractionDigits;
            }
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["m" /* isNullOrUndefined */])(dOptions)) {
            Object(__WEBPACK_IMPORTED_MODULE_1__util__["f" /* extend */])(cOptions, isCurrencyPercent([cOptions.nlead, cOptions.nend], '$', dOptions.currencySymbol));
            if (!cOptions.isCurrency) {
                Object(__WEBPACK_IMPORTED_MODULE_1__util__["f" /* extend */])(cOptions, isCurrencyPercent([cOptions.nlead, cOptions.nend], '%', dOptions.percentSymbol));
            }
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_1__util__["f" /* extend */])(cOptions, isCurrencyPercent([cOptions.nlead, cOptions.nend], '%', '%'));
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["m" /* isNullOrUndefined */])(numObject)) {
            var symbolPattern = getSymbolPattern(cOptions.type, dOptions.numberMapper.numberSystem, numObject, false);
            if (cOptions.useGrouping) {
                // eslint-disable-next-line
                cOptions.groupSeparator = spaceGrouping ? ' ' : dOptions.numberMapper.numberSymbols[mapper[2]];
                cOptions.groupData = __WEBPACK_IMPORTED_MODULE_4__number_formatter__["a" /* NumberFormat */].getGroupingDetails(symbolPattern.split(';')[0]);
            }
            cOptions.nlead = cOptions.nlead.replace(/'/g, '');
            cOptions.nend = spaceCapture ? ' ' + cOptions.nend.replace(/'/g, '') : cOptions.nend.replace(/'/g, '');
        }
        return cOptions;
    }
    IntlBase.customNumberFormat = customNumberFormat;
    /**
     * Returns formatting options for currency or percent type
     *
     * @private
     * @param {string[]} parts ?
     * @param {string} actual ?
     * @param {string} symbol ?
     * @returns {any} ?
     */
    function isCurrencyPercent(parts, actual, symbol) {
        var options = { nlead: parts[0], nend: parts[1] };
        for (var i = 0; i < 2; i++) {
            var part = parts[i];
            var loc = part.indexOf(actual);
            if ((loc !== -1) && ((loc < part.indexOf('\'')) || (loc > part.lastIndexOf('\'')))) {
                // eslint-disable-next-line
                options[typeMapper[i]] = part.substr(0, loc) + symbol + part.substr(loc + 1);
                // eslint-disable-next-line
                options[typeMapper[actual]] = true;
                options.type = options.isCurrency ? 'currency' : 'percent';
                break;
            }
        }
        return options;
    }
    IntlBase.isCurrencyPercent = isCurrencyPercent;
    /**
     * Returns culture based date separator
     *
     * @private
     * @param {Object} dateObj ?
     * @returns {string} ?
     */
    function getDateSeparator(dateObj) {
        var value = (Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('dateFormats.short', dateObj) || '').match(/[d‏M‏]([^d‏M])[d‏M‏]/i);
        return value ? value[1] : '/';
    }
    IntlBase.getDateSeparator = getDateSeparator;
    /**
     * Returns Native Date Time pattern
     *
     * @private
     * @param {string} culture ?
     * @param {DateFormatOptions} options ?
     * @param {Object} cldr ?
     * @param {boolean} isExcelFormat ?
     * @returns {string} ?
     */
    function getActualDateTimeFormat(culture, options, cldr, isExcelFormat) {
        var dependable = getDependables(cldr, culture, options.calendar);
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["l" /* isBlazor */])()) {
            options = compareBlazorDateFormats(options, culture);
        }
        var actualPattern = options.format || getResultantPattern(options.skeleton, dependable.dateObject, options.type);
        if (isExcelFormat) {
            actualPattern = actualPattern.replace(patternRegex, function (pattern) {
                // eslint-disable-next-line
                return patternMatch[pattern];
            });
            if (actualPattern.indexOf('z') !== -1) {
                var tLength = actualPattern.match(/z/g).length;
                var timeZonePattern = void 0;
                var options_1 = { 'timeZone': {} };
                options_1.numMapper = __WEBPACK_IMPORTED_MODULE_2__parser_base__["a" /* ParserBase */].getNumberMapper(dependable.parserObject, __WEBPACK_IMPORTED_MODULE_2__parser_base__["a" /* ParserBase */].getNumberingSystem(cldr));
                options_1.timeZone = Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('dates.timeZoneNames', dependable.parserObject);
                var value = new Date();
                var timezone = value.getTimezoneOffset();
                var pattern = (tLength < 4) ? '+H;-H' : options_1.timeZone.hourFormat;
                pattern = pattern.replace(/:/g, options_1.numMapper.timeSeparator);
                if (timezone === 0) {
                    timeZonePattern = options_1.timeZone.gmtZeroFormat;
                }
                else {
                    timeZonePattern = __WEBPACK_IMPORTED_MODULE_3__date_formatter__["a" /* DateFormat */].getTimeZoneValue(timezone, pattern);
                    timeZonePattern = options_1.timeZone.gmtFormat.replace(/\{0\}/, timeZonePattern);
                }
                actualPattern = actualPattern.replace(/[z]+/, '"' + timeZonePattern + '"');
            }
            actualPattern = actualPattern.replace(/ $/, '');
        }
        return actualPattern;
    }
    IntlBase.getActualDateTimeFormat = getActualDateTimeFormat;
    /**
     *
     * @param {string} actual ?
     * @param {any} option ?
     * @returns {any} ?
     */
    // eslint-disable-next-line
    function processSymbol(actual, option) {
        if (actual.indexOf(',') !== -1) {
            // eslint-disable-next-line
            var split = actual.split(',');
            actual = (split[0] + Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('numberMapper.numberSymbols.group', option) +
                split[1].replace('.', Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('numberMapper.numberSymbols.decimal', option)));
        }
        else {
            actual = actual.replace('.', Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('numberMapper.numberSymbols.decimal', option));
        }
        return actual;
    }
    /**
     * Returns Native Number pattern
     *
     * @private
     * @param {string} culture ?
     * @param {NumberFormatOptions} options ?
     * @param {Object} cldr ?
     * @param {boolean} isExcel ?
     * @returns {string} ?
     */
    function getActualNumberFormat(culture, options, cldr, isExcel) {
        var dependable = getDependables(cldr, culture, '', true);
        var parseOptions = { custom: true };
        var numrericObject = dependable.numericObject;
        var minFrac;
        var curObj = {};
        var curMatch = (options.format || '').match(IntlBase.currencyFormatRegex);
        var type = IntlBase.formatRegex.test(options.format) ? getProperNumericSkeleton(options.format || 'N') : {};
        var dOptions = {};
        if (curMatch) {
            dOptions.numberMapper = Object(__WEBPACK_IMPORTED_MODULE_1__util__["l" /* isBlazor */])() ?
                Object(__WEBPACK_IMPORTED_MODULE_1__util__["f" /* extend */])({}, dependable.numericObject) :
                __WEBPACK_IMPORTED_MODULE_2__parser_base__["a" /* ParserBase */].getNumberMapper(dependable.parserObject, __WEBPACK_IMPORTED_MODULE_2__parser_base__["a" /* ParserBase */].getNumberingSystem(cldr), true);
            var curCode = Object(__WEBPACK_IMPORTED_MODULE_1__util__["l" /* isBlazor */])() ? Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('currencySymbol', dependable.numericObject) :
                getCurrencySymbol(dependable.numericObject, options.currency || __WEBPACK_IMPORTED_MODULE_0__internationalization__["c" /* defaultCurrencyCode */], options.altSymbol);
            var symbolPattern = getSymbolPattern('currency', dOptions.numberMapper.numberSystem, dependable.numericObject, (/a/i).test(options.format));
            symbolPattern = symbolPattern.replace(/\u00A4/g, curCode);
            var split = symbolPattern.split(';');
            curObj.hasNegativePattern = Object(__WEBPACK_IMPORTED_MODULE_1__util__["l" /* isBlazor */])() ? true : (split.length > 1);
            curObj.nData = Object(__WEBPACK_IMPORTED_MODULE_1__util__["l" /* isBlazor */])() ? Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])(type.type + 'nData', numrericObject) :
                getFormatData(split[1] || '-' + split[0], true, curCode);
            curObj.pData = Object(__WEBPACK_IMPORTED_MODULE_1__util__["l" /* isBlazor */])() ? Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])(type.type + 'pData', numrericObject) :
                getFormatData(split[0], false, curCode);
            if (!curMatch[2] && !options.minimumFractionDigits && !options.maximumFractionDigits) {
                minFrac = getFormatData(symbolPattern.split(';')[0], true, '', true).minimumFraction;
            }
        }
        var actualPattern;
        if ((IntlBase.formatRegex.test(options.format)) || !(options.format)) {
            Object(__WEBPACK_IMPORTED_MODULE_1__util__["f" /* extend */])(parseOptions, getProperNumericSkeleton(options.format || 'N'));
            parseOptions.custom = false;
            actualPattern = '###0';
            if (parseOptions.fractionDigits || options.minimumFractionDigits || options.maximumFractionDigits || minFrac) {
                var defaultMinimum = 0;
                if (parseOptions.fractionDigits) {
                    options.minimumFractionDigits = options.maximumFractionDigits = parseOptions.fractionDigits;
                }
                actualPattern = fractionDigitsPattern(actualPattern, minFrac || parseOptions.fractionDigits ||
                    options.minimumFractionDigits || defaultMinimum, options.maximumFractionDigits || defaultMinimum);
            }
            if (options.minimumIntegerDigits) {
                actualPattern = minimumIntegerPattern(actualPattern, options.minimumIntegerDigits);
            }
            if (options.useGrouping) {
                actualPattern = groupingPattern(actualPattern);
            }
            if (parseOptions.type === 'currency' || (parseOptions.type && Object(__WEBPACK_IMPORTED_MODULE_1__util__["l" /* isBlazor */])())) {
                if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["l" /* isBlazor */])() && parseOptions.type !== 'currency') {
                    curObj.pData = Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])(parseOptions.type + 'pData', numrericObject);
                    curObj.nData = Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])(parseOptions.type + 'nData', numrericObject);
                }
                var cPattern = actualPattern;
                actualPattern = curObj.pData.nlead + cPattern + curObj.pData.nend;
                if (curObj.hasNegativePattern || Object(__WEBPACK_IMPORTED_MODULE_1__util__["l" /* isBlazor */])()) {
                    actualPattern += ';' + curObj.nData.nlead + cPattern + curObj.nData.nend;
                }
            }
            if (parseOptions.type === 'percent' && !Object(__WEBPACK_IMPORTED_MODULE_1__util__["l" /* isBlazor */])()) {
                actualPattern += ' %';
            }
        }
        else {
            actualPattern = options.format.replace(/'/g, '"');
        }
        if (Object.keys(dOptions).length > 0) {
            actualPattern = !isExcel ? processSymbol(actualPattern, dOptions) : actualPattern;
        }
        return actualPattern;
    }
    IntlBase.getActualNumberFormat = getActualNumberFormat;
    /**
     *
     * @param {string} pattern ?
     * @param {number} minDigits ?
     * @param {number} maxDigits ?
     * @returns {string} ?
     */
    function fractionDigitsPattern(pattern, minDigits, maxDigits) {
        pattern += '.';
        for (var a = 0; a < minDigits; a++) {
            pattern += '0';
        }
        if (minDigits < maxDigits) {
            var diff = maxDigits - minDigits;
            for (var b = 0; b < diff; b++) {
                pattern += '#';
            }
        }
        return pattern;
    }
    IntlBase.fractionDigitsPattern = fractionDigitsPattern;
    /**
     *
     * @param {string} pattern ?
     * @param {number} digits ?
     * @returns {string} ?
     */
    function minimumIntegerPattern(pattern, digits) {
        var temp = pattern.split('.');
        var integer = '';
        for (var x = 0; x < digits; x++) {
            integer += '0';
        }
        return temp[1] ? (integer + '.' + temp[1]) : integer;
    }
    IntlBase.minimumIntegerPattern = minimumIntegerPattern;
    /**
     *
     * @param {string} pattern ?
     * @returns {string} ?
     */
    function groupingPattern(pattern) {
        var temp = pattern.split('.');
        var integer = temp[0];
        var no = 3 - integer.length % 3;
        var hash = (no && no === 1) ? '#' : (no === 2 ? '##' : '');
        integer = hash + integer;
        pattern = '';
        for (var x = integer.length - 1; x > 0; x = x - 3) {
            pattern = ',' + integer[x - 2] + integer[x - 1] + integer[x] + pattern;
        }
        pattern = pattern.slice(1);
        return temp[1] ? (pattern + '.' + temp[1]) : pattern;
    }
    IntlBase.groupingPattern = groupingPattern;
    /**
     *
     * @param {string} culture ?
     * @param {Object} cldr ?
     * @returns {number} ?
     */
    function getWeekData(culture, cldr) {
        var firstDay = defaultFirstDay;
        var mapper = Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('supplemental.weekData.firstDay', cldr);
        var iCulture = culture;
        if ((/en-/).test(iCulture)) {
            iCulture = iCulture.slice(3);
        }
        iCulture = iCulture.slice(0, 2).toUpperCase() + iCulture.substr(2);
        if (mapper) {
            firstDay = mapper[iCulture] || mapper[iCulture.slice(0, 2)] || defaultFirstDay;
        }
        return firstDayMapper[firstDay];
    }
    IntlBase.getWeekData = getWeekData;
    /**
     * @private
     * @param {any} pData ?
     * @param {string} aCurrency ?
     * @param {string} rCurrency ?
     * @returns {void} ?
     */
    function replaceBlazorCurrency(pData, aCurrency, rCurrency) {
        var iCurrency = Object(__WEBPACK_IMPORTED_MODULE_2__parser_base__["b" /* getBlazorCurrencySymbol */])(rCurrency);
        if (aCurrency !== iCurrency) {
            for (var _i = 0, pData_1 = pData; _i < pData_1.length; _i++) {
                var data = pData_1[_i];
                data.nend = data.nend.replace(aCurrency, iCurrency);
                data.nlead = data.nlead.replace(aCurrency, iCurrency);
            }
        }
    }
    IntlBase.replaceBlazorCurrency = replaceBlazorCurrency;
    /**
     * @private
     * @param {Date} date ?
     * @returns {number} ?
     */
    function getWeekOfYear(date) {
        var newYear = new Date(date.getFullYear(), 0, 1);
        var day = newYear.getDay();
        var weeknum;
        day = (day >= 0 ? day : day + 7);
        var daynum = Math.floor((date.getTime() - newYear.getTime() -
            (date.getTimezoneOffset() - newYear.getTimezoneOffset()) * 60000) / 86400000) + 1;
        if (day < 4) {
            weeknum = Math.floor((daynum + day - 1) / 7) + 1;
            if (weeknum > 52) {
                var nYear = new Date(date.getFullYear() + 1, 0, 1);
                var nday = nYear.getDay();
                nday = nday >= 0 ? nday : nday + 7;
                weeknum = nday < 4 ? 1 : 53;
            }
        }
        else {
            weeknum = Math.floor((daynum + day - 1) / 7);
        }
        return weeknum;
    }
    IntlBase.getWeekOfYear = getWeekOfYear;
})(IntlBase || (IntlBase = {}));


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser__ = __webpack_require__(16);


/**
 * EventHandler class provides option to add, remove, clear and trigger events to a HTML DOM element
 * ```html
 * <div id="Eventdiv">  </div>
 * <script>
 *   let node: HTMLElement = document.querySelector("#Eventdiv");
 *   EventHandler.addEventListener(node, "click", function(){
 *       // click handler function code
 *   });
 *   EventHandler.addEventListener(node, "onmouseover", function(){
 *       // mouseover handler function code
 *   });
 *   EventHandler.removeEventListener(node, "click", function(){
 *       // click handler function code
 *   });
 *   eventObj.clearEvents();
 * </script>
 * ```
 */
var EventHandler = /** @class */ (function () {
    function EventHandler() {
    }
    // to get the event data based on element
    EventHandler.addOrGetEventData = function (element) {
        if ('__eventList' in element) {
            return element.__eventList.events;
        }
        else {
            element.__eventList = {};
            return element.__eventList.events = [];
        }
    };
    /**
     * Add an event to the specified DOM element.
     *
     * @param {any} element - Target HTML DOM element
     * @param {string} eventName - A string that specifies the name of the event
     * @param {Function} listener - Specifies the function to run when the event occurs
     * @param {Object} bindTo - A object that binds 'this' variable in the event handler
     * @param {number} intDebounce - Specifies at what interval given event listener should be triggered.
     * @returns {Function} ?
     */
    EventHandler.add = function (element, eventName, listener, bindTo, intDebounce) {
        var eventData = EventHandler.addOrGetEventData(element);
        var debounceListener;
        if (intDebounce) {
            debounceListener = Object(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* debounce */])(listener, intDebounce);
        }
        else {
            debounceListener = listener;
        }
        if (bindTo) {
            debounceListener = debounceListener.bind(bindTo);
        }
        var event = eventName.split(' ');
        for (var i = 0; i < event.length; i++) {
            eventData.push({
                name: event[i],
                listener: listener,
                debounce: debounceListener
            });
            if (__WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].isIE) {
                element.addEventListener(event[i], debounceListener);
            }
            else {
                element.addEventListener(event[i], debounceListener, { passive: false });
            }
        }
        return debounceListener;
    };
    /**
     * Remove an event listener that has been attached before.
     *
     * @param {any} element - Specifies the target html element to remove the event
     * @param {string} eventName - A string that specifies the name of the event to remove
     * @param {Function} listener - Specifies the function to remove
     * @returns {void} ?
     */
    EventHandler.remove = function (element, eventName, listener) {
        var eventData = EventHandler.addOrGetEventData(element);
        var event = eventName.split(' ');
        var _loop_1 = function (j) {
            var index = -1;
            var debounceListener;
            if (eventData && eventData.length !== 0) {
                eventData.some(function (x, i) {
                    return x.name === event[j] && x.listener === listener ?
                        (index = i, debounceListener = x.debounce, true) : false;
                });
            }
            if (index !== -1) {
                eventData.splice(index, 1);
            }
            if (debounceListener) {
                element.removeEventListener(event[j], debounceListener);
            }
        };
        for (var j = 0; j < event.length; j++) {
            _loop_1(j);
        }
    };
    /**
     * Clear all the event listeners that has been previously attached to the element.
     *
     * @param {any} element - Specifies the target html element to clear the events
     * @returns {void} ?
     */
    EventHandler.clearEvents = function (element) {
        var eventData;
        var copyData;
        // eslint-disable-next-line
        eventData = EventHandler.addOrGetEventData(element);
        // eslint-disable-next-line
        copyData = Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])([], copyData, eventData);
        for (var i = 0; i < copyData.length; i++) {
            element.removeEventListener(copyData[i].name, copyData[i].debounce);
            eventData.shift();
        }
    };
    /**
     * Trigger particular event of the element.
     *
     * @param {any} element - Specifies the target html element to trigger the events
     * @param {string} eventName - Specifies the event to trigger for the specified element.
     * Can be a custom event, or any of the standard events.
     * @param {any} eventProp - Additional parameters to pass on to the event properties
     * @returns {void} ?
     */
    EventHandler.trigger = function (element, eventName, eventProp) {
        var eventData = EventHandler.addOrGetEventData(element);
        for (var _i = 0, eventData_1 = eventData; _i < eventData_1.length; _i++) {
            var event_1 = eventData_1[_i];
            if (event_1.name === eventName) {
                event_1.debounce.call(this, eventProp);
            }
        }
    };
    return EventHandler;
}());



/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Browser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(1);

var REGX_MOBILE = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i;
var REGX_IE = /msie|trident/i;
var REGX_IE11 = /Trident\/7\./;
var REGX_IOS = /(ipad|iphone|ipod touch)/i;
var REGX_IOS7 = /(ipad|iphone|ipod touch);.*os 7_\d|(ipad|iphone|ipod touch);.*os 8_\d/i;
var REGX_ANDROID = /android/i;
var REGX_WINDOWS = /trident|windows phone|edge/i;
var REGX_VERSION = /(version)[ /]([\w.]+)/i;
var REGX_BROWSER = {
    OPERA: /(opera|opr)(?:.*version|)[ /]([\w.]+)/i,
    EDGE: /(edge)(?:.*version|)[ /]([\w.]+)/i,
    CHROME: /(chrome|crios)[ /]([\w.]+)/i,
    PANTHOMEJS: /(phantomjs)[ /]([\w.]+)/i,
    SAFARI: /(safari)[ /]([\w.]+)/i,
    WEBKIT: /(webkit)[ /]([\w.]+)/i,
    MSIE: /(msie|trident) ([\w.]+)/i,
    MOZILLA: /(mozilla)(?:.*? rv:([\w.]+)|)/i
};
/* istanbul ignore else  */
if (typeof window !== 'undefined') {
    window.browserDetails = window.browserDetails || {};
}
/**
 * Get configuration details for Browser
 *
 * @private
 */
var Browser = /** @class */ (function () {
    function Browser() {
    }
    Browser.extractBrowserDetail = function () {
        var browserInfo = { culture: {} };
        var keys = Object.keys(REGX_BROWSER);
        var clientInfo = [];
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            clientInfo = Browser.userAgent.match(REGX_BROWSER[key]);
            if (clientInfo) {
                browserInfo.name = (clientInfo[1].toLowerCase() === 'opr' ? 'opera' : clientInfo[1].toLowerCase());
                browserInfo.name = (clientInfo[1].toLowerCase() === 'crios' ? 'chrome' : browserInfo.name);
                browserInfo.version = clientInfo[2];
                browserInfo.culture.name = browserInfo.culture.language = navigator.language;
                // eslint-disable-next-line
                if (!!Browser.userAgent.match(REGX_IE11)) {
                    browserInfo.name = 'msie';
                    break;
                }
                var version = Browser.userAgent.match(REGX_VERSION);
                if (browserInfo.name === 'safari' && version) {
                    browserInfo.version = version[2];
                }
                break;
            }
        }
        return browserInfo;
    };
    /**
     * To get events from the browser
     *
     * @param {string} event - type of event triggered.
     * @returns {boolean}
     */
    Browser.getEvent = function (event) {
        // eslint-disable-next-line
        var events = {
            start: {
                isPointer: 'pointerdown', isTouch: 'touchstart', isDevice: 'mousedown'
            },
            move: {
                isPointer: 'pointermove', isTouch: 'touchmove', isDevice: 'mousemove'
            },
            end: {
                isPointer: 'pointerup', isTouch: 'touchend', isDevice: 'mouseup'
            },
            cancel: {
                isPointer: 'pointercancel', isTouch: 'touchcancel', isDevice: 'mouseleave'
            }
        };
        return (Browser.isPointer ? events[event].isPointer :
            (Browser.isTouch ? events[event].isTouch + (!Browser.isDevice ? ' ' + events[event].isDevice : '')
                : events[event].isDevice));
    };
    /**
     * To get the Touch start event from browser
     *
     * @returns {string}
     */
    Browser.getTouchStartEvent = function () {
        return Browser.getEvent('start');
    };
    /**
     * To get the Touch end event from browser
     *
     * @returns {string}
     */
    Browser.getTouchEndEvent = function () {
        return Browser.getEvent('end');
    };
    /**
     * To get the Touch move event from browser
     *
     * @returns {string}
     */
    Browser.getTouchMoveEvent = function () {
        return Browser.getEvent('move');
    };
    /**
     * To cancel the touch event from browser
     *
     * @returns {string}
     */
    Browser.getTouchCancelEvent = function () {
        return Browser.getEvent('cancel');
    };
    /**
     * To get the value based on provided key and regX
     *
     * @param {string} key ?
     * @param {RegExp} regX ?
     * @returns {Object} ?
     */
    Browser.getValue = function (key, regX) {
        var browserDetails = window.browserDetails;
        if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 && Browser.isTouch === true) {
            browserDetails['isIos'] = true;
            browserDetails['isDevice'] = true;
            browserDetails['isTouch'] = true;
            browserDetails['isPointer'] = true;
        }
        if ('undefined' === typeof browserDetails[key]) {
            return browserDetails[key] = regX.test(Browser.userAgent);
        }
        return browserDetails[key];
    };
    Object.defineProperty(Browser, "userAgent", {
        get: function () {
            return Browser.uA;
        },
        //Properties
        /**
         * Property specifies the userAgent of the browser. Default userAgent value is based on the browser.
         * Also we can set our own userAgent.
         *
         * @param {string} uA ?
         */
        set: function (uA) {
            Browser.uA = uA;
            window.browserDetails = {};
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "info", {
        //Read Only Properties
        /**
         * Property is to get the browser information like Name, Version and Language
         *
         * @returns {BrowserInfo} ?
         */
        get: function () {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(window.browserDetails.info)) {
                return window.browserDetails.info = Browser.extractBrowserDetail();
            }
            return window.browserDetails.info;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isIE", {
        /**
         * Property is to get whether the userAgent is based IE.
         *
         * @returns {boolean} ?
         */
        get: function () {
            return Browser.getValue('isIE', REGX_IE);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isTouch", {
        /**
         * Property is to get whether the browser has touch support.
         *
         * @returns {boolean} ?
         */
        get: function () {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(window.browserDetails.isTouch)) {
                return (window.browserDetails.isTouch =
                    ('ontouchstart' in window.navigator) ||
                        (window &&
                            window.navigator &&
                            (window.navigator.maxTouchPoints > 0)) || ('ontouchstart' in window));
            }
            return window.browserDetails.isTouch;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isPointer", {
        /**
         * Property is to get whether the browser has Pointer support.
         *
         * @returns {boolean} ?
         */
        get: function () {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(window.browserDetails.isPointer)) {
                return window.browserDetails.isPointer = ('pointerEnabled' in window.navigator);
            }
            return window.browserDetails.isPointer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isMSPointer", {
        /**
         * Property is to get whether the browser has MSPointer support.
         *
         * @returns {boolean} ?
         */
        get: function () {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(window.browserDetails.isMSPointer)) {
                return window.browserDetails.isMSPointer = ('msPointerEnabled' in window.navigator);
            }
            return window.browserDetails.isMSPointer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isDevice", {
        /**
         * Property is to get whether the userAgent is device based.
         *
         * @returns {boolean} ?
         */
        get: function () {
            return Browser.getValue('isDevice', REGX_MOBILE);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isIos", {
        /**
         * Property is to get whether the userAgent is IOS.
         *
         * @returns {boolean} ?
         */
        get: function () {
            return Browser.getValue('isIos', REGX_IOS);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isIos7", {
        /**
         * Property is to get whether the userAgent is Ios7.
         *
         * @returns {boolean} ?
         */
        get: function () {
            return Browser.getValue('isIos7', REGX_IOS7);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isAndroid", {
        /**
         * Property is to get whether the userAgent is Android.
         *
         * @returns {boolean} ?
         */
        get: function () {
            return Browser.getValue('isAndroid', REGX_ANDROID);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isWebView", {
        /**
         * Property is to identify whether application ran in web view.
         *
         * @returns {boolean} ?
         */
        get: function () {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(window.browserDetails.isWebView)) {
                window.browserDetails.isWebView = !(Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(window.cordova) && Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(window.PhoneGap)
                    && Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(window.phonegap) && window.forge !== 'object');
                return window.browserDetails.isWebView;
            }
            return window.browserDetails.isWebView;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "isWindows", {
        /**
         * Property is to get whether the userAgent is Windows.
         *
         * @returns {boolean} ?
         */
        get: function () {
            return Browser.getValue('isWindows', REGX_WINDOWS);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "touchStartEvent", {
        /**
         * Property is to get the touch start event. It returns event name based on browser.
         *
         * @returns {string} ?
         */
        get: function () {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(window.browserDetails.touchStartEvent)) {
                return window.browserDetails.touchStartEvent = Browser.getTouchStartEvent();
            }
            return window.browserDetails.touchStartEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "touchMoveEvent", {
        /**
         * Property is to get the touch move event. It returns event name based on browser.
         *
         * @returns {string} ?
         */
        get: function () {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(window.browserDetails.touchMoveEvent)) {
                return window.browserDetails.touchMoveEvent = Browser.getTouchMoveEvent();
            }
            return window.browserDetails.touchMoveEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "touchEndEvent", {
        /**
         * Property is to get the touch end event. It returns event name based on browser.
         *
         * @returns {string} ?
         */
        get: function () {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(window.browserDetails.touchEndEvent)) {
                return window.browserDetails.touchEndEvent = Browser.getTouchEndEvent();
            }
            return window.browserDetails.touchEndEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser, "touchCancelEvent", {
        /**
         * Property is to cancel the touch end event.
         *
         * @returns {string} ?
         */
        get: function () {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(window.browserDetails.touchCancelEvent)) {
                return window.browserDetails.touchCancelEvent = Browser.getTouchCancelEvent();
            }
            return window.browserDetails.touchCancelEvent;
        },
        enumerable: true,
        configurable: true
    });
    /* istanbul ignore next */
    Browser.uA = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    return Browser;
}());



/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(115);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(132);
var parse = __webpack_require__(142);
var formats = __webpack_require__(38);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return onIntlChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return rightToLeft; });
/* unused harmony export cldrData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultCulture; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultCurrencyCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Internationalization; });
/* unused harmony export setCulture */
/* unused harmony export setCurrencyCode */
/* unused harmony export loadCldr */
/* unused harmony export enableRtl */
/* harmony export (immutable) */ __webpack_exports__["d"] = getNumericObject;
/* unused harmony export getNumberDependable */
/* unused harmony export getDefaultDateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intl_date_formatter__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__intl_number_formatter__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intl_date_parser__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__intl_number_parser__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__intl_intl_base__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__observer__ = __webpack_require__(26);







/**
 * Specifies the observer used for external change detection.
 */
var onIntlChange = new __WEBPACK_IMPORTED_MODULE_6__observer__["a" /* Observer */]();
/**
 * Specifies the default rtl status for EJ2 components.
 */
var rightToLeft = false;
/**
 * Specifies the CLDR data loaded for internationalization functionalities.
 *
 * @private
 */
var cldrData = {};
/**
 * Specifies the default culture value to be considered.
 *
 * @private
 */
var defaultCulture = 'en-US';
/**
 * Specifies default currency code to be considered
 *
 * @private
 */
var defaultCurrencyCode = 'USD';
var mapper = ['numericObject', 'dateObject'];
/**
 * Internationalization class provides support to parse and format the number and date object to the desired format.
 * ```typescript
 * // To set the culture globally
 * setCulture('en-GB');
 *
 * // To set currency code globally
 * setCurrencyCode('EUR');
 *
 * //Load cldr data
 * loadCldr(gregorainData);
 * loadCldr(timeZoneData);
 * loadCldr(numbersData);
 * loadCldr(numberSystemData);
 *
 * // To use formatter in component side
 * let Intl:Internationalization = new Internationalization();
 *
 * // Date formatting
 * let dateFormatter: Function = Intl.getDateFormat({skeleton:'long',type:'dateTime'});
 * dateFormatter(new Date('11/2/2016'));
 * dateFormatter(new Date('25/2/2030'));
 * Intl.formatDate(new Date(),{skeleton:'E'});
 *
 * //Number formatting
 * let numberFormatter: Function = Intl.getNumberFormat({skeleton:'C5'})
 * numberFormatter(24563334);
 * Intl.formatNumber(123123,{skeleton:'p2'});
 *
 * // Date parser
 * let dateParser: Function = Intl.getDateParser({skeleton:'short',type:'time'});
 * dateParser('10:30 PM');
 * Intl.parseDate('10',{skeleton:'H'});
 * ```
 */
var Internationalization = /** @class */ (function () {
    function Internationalization(cultureName) {
        if (cultureName) {
            this.culture = cultureName;
        }
    }
    /**
     * Returns the format function for given options.
     *
     * @param {DateFormatOptions} options - Specifies the format options in which the format function will return.
     * @returns {Function} ?
     */
    Internationalization.prototype.getDateFormat = function (options) {
        return __WEBPACK_IMPORTED_MODULE_0__intl_date_formatter__["a" /* DateFormat */].dateFormat(this.getCulture(), options || { type: 'date', skeleton: 'short' }, cldrData);
    };
    /**
     * Returns the format function for given options.
     *
     * @param {NumberFormatOptions} options - Specifies the format options in which the format function will return.
     * @returns {Function} ?
     */
    Internationalization.prototype.getNumberFormat = function (options) {
        if (options && !options.currency) {
            options.currency = defaultCurrencyCode;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_5__util__["l" /* isBlazor */])() && options && !options.format) {
            options.minimumFractionDigits = 0;
        }
        return __WEBPACK_IMPORTED_MODULE_1__intl_number_formatter__["a" /* NumberFormat */].numberFormatter(this.getCulture(), options || {}, cldrData);
    };
    /**
     * Returns the parser function for given options.
     *
     * @param {DateFormatOptions} options - Specifies the format options in which the parser function will return.
     * @returns {Function} ?
     */
    Internationalization.prototype.getDateParser = function (options) {
        return __WEBPACK_IMPORTED_MODULE_2__intl_date_parser__["a" /* DateParser */].dateParser(this.getCulture(), options || { skeleton: 'short', type: 'date' }, cldrData);
    };
    /**
     * Returns the parser function for given options.
     *
     * @param {NumberFormatOptions} options - Specifies the format options in which the parser function will return.
     * @returns {Function} ?
     */
    Internationalization.prototype.getNumberParser = function (options) {
        if (Object(__WEBPACK_IMPORTED_MODULE_5__util__["l" /* isBlazor */])() && options && !options.format) {
            options.minimumFractionDigits = 0;
        }
        return __WEBPACK_IMPORTED_MODULE_3__intl_number_parser__["a" /* NumberParser */].numberParser(this.getCulture(), options || { format: 'N' }, cldrData);
    };
    /**
     * Returns the formatted string based on format options.
     *
     * @param {number} value - Specifies the number to format.
     * @param {NumberFormatOptions} option - Specifies the format options in which the number will be formatted.
     * @returns {string} ?
     */
    Internationalization.prototype.formatNumber = function (value, option) {
        return this.getNumberFormat(option)(value);
    };
    /**
     * Returns the formatted date string based on format options.
     *
     * @param {Date} value - Specifies the number to format.
     * @param {DateFormatOptions} option - Specifies the format options in which the number will be formatted.
     * @returns {string} ?
     */
    Internationalization.prototype.formatDate = function (value, option) {
        return this.getDateFormat(option)(value);
    };
    /**
     * Returns the date object for given date string and options.
     *
     * @param {string} value - Specifies the string to parse.
     * @param {DateFormatOptions} option - Specifies the parse options in which the date string will be parsed.
     * @returns {Date} ?
     */
    Internationalization.prototype.parseDate = function (value, option) {
        return this.getDateParser(option)(value);
    };
    /**
     * Returns the number object from the given string value and options.
     *
     * @param {string} value - Specifies the string to parse.
     * @param {NumberFormatOptions} option - Specifies the parse options in which the  string number  will be parsed.
     * @returns {number} ?
     */
    Internationalization.prototype.parseNumber = function (value, option) {
        return this.getNumberParser(option)(value);
    };
    /**
     * Returns Native Date Time Pattern
     *
     * @param {DateFormatOptions} option - Specifies the parse options for resultant date time pattern.
     * @param {boolean} isExcelFormat - Specifies format value to be converted to excel pattern.
     * @returns {string} ?
     * @private
     */
    Internationalization.prototype.getDatePattern = function (option, isExcelFormat) {
        return __WEBPACK_IMPORTED_MODULE_4__intl_intl_base__["a" /* IntlBase */].getActualDateTimeFormat(this.getCulture(), option, cldrData, isExcelFormat);
    };
    /**
     * Returns Native Number Pattern
     *
     * @param {NumberFormatOptions} option - Specifies the parse options for resultant number pattern.
     * @param {boolean} isExcel ?
     * @returns {string} ?
     * @private
     */
    Internationalization.prototype.getNumberPattern = function (option, isExcel) {
        return __WEBPACK_IMPORTED_MODULE_4__intl_intl_base__["a" /* IntlBase */].getActualNumberFormat(this.getCulture(), option, cldrData, isExcel);
    };
    /**
     * Returns the First Day of the Week
     *
     * @returns {number} ?
     */
    Internationalization.prototype.getFirstDayOfWeek = function () {
        return __WEBPACK_IMPORTED_MODULE_4__intl_intl_base__["a" /* IntlBase */].getWeekData(this.getCulture(), cldrData);
    };
    /**
     * Returns the culture
     *
     * @returns {string} ?
     */
    Internationalization.prototype.getCulture = function () {
        return this.culture || defaultCulture;
    };
    return Internationalization;
}());

/**
 * Set the default culture to all EJ2 components
 *
 * @param {string} cultureName - Specifies the culture name to be set as default culture.
 * @returns {void} ?
 */
function setCulture(cultureName) {
    defaultCulture = cultureName;
    onIntlChange.notify('notifyExternalChange', { 'locale': defaultCulture });
}
/**
 * Set the default currency code to all EJ2 components
 *
 * @param {string} currencyCode Specifies the culture name to be set as default culture.
 * @returns {void} ?
 */
function setCurrencyCode(currencyCode) {
    defaultCurrencyCode = currencyCode;
    onIntlChange.notify('notifyExternalChange', { 'currencyCode': defaultCurrencyCode });
}
/**
 * Load the CLDR data into context
 *
 * @param {Object[]} data Specifies the CLDR data's to be used for formatting and parser.
 * @returns {void} ?
 */
function loadCldr() {
    var data = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        data[_i] = arguments[_i];
    }
    for (var _a = 0, data_1 = data; _a < data_1.length; _a++) {
        var obj = data_1[_a];
        Object(__WEBPACK_IMPORTED_MODULE_5__util__["f" /* extend */])(cldrData, obj, {}, true);
    }
}
/**
 * To enable or disable RTL functionality for all components globally.
 *
 * @param {boolean} status - Optional argument Specifies the status value to enable or disable rtl option.
 * @returns {void} ?
 */
function enableRtl(status) {
    if (status === void 0) { status = true; }
    rightToLeft = status;
    onIntlChange.notify('notifyExternalChange', { enableRtl: rightToLeft });
}
/**
 * To get the numeric CLDR object for given culture
 *
 * @param {string} locale - Specifies the locale for which numericObject to be returned.
 * @param {string} type ?
 * @returns {Object} ?
 * @ignore
 * @private
 */
function getNumericObject(locale, type) {
    // eslint-disable-next-line
    var numObject = __WEBPACK_IMPORTED_MODULE_4__intl_intl_base__["a" /* IntlBase */].getDependables(cldrData, locale, '', true)[mapper[0]];
    // eslint-disable-next-line
    var dateObject = __WEBPACK_IMPORTED_MODULE_4__intl_intl_base__["a" /* IntlBase */].getDependables(cldrData, locale, '')[mapper[1]];
    var numSystem = Object(__WEBPACK_IMPORTED_MODULE_5__util__["k" /* getValue */])('defaultNumberingSystem', numObject);
    var symbPattern = Object(__WEBPACK_IMPORTED_MODULE_5__util__["l" /* isBlazor */])() ? Object(__WEBPACK_IMPORTED_MODULE_5__util__["k" /* getValue */])('numberSymbols', numObject) : Object(__WEBPACK_IMPORTED_MODULE_5__util__["k" /* getValue */])('symbols-numberSystem-' + numSystem, numObject);
    var pattern = __WEBPACK_IMPORTED_MODULE_4__intl_intl_base__["a" /* IntlBase */].getSymbolPattern(type || 'decimal', numSystem, numObject, false);
    return Object(__WEBPACK_IMPORTED_MODULE_5__util__["f" /* extend */])(symbPattern, __WEBPACK_IMPORTED_MODULE_4__intl_intl_base__["a" /* IntlBase */].getFormatData(pattern, true, '', true), { 'dateSeparator': __WEBPACK_IMPORTED_MODULE_4__intl_intl_base__["a" /* IntlBase */].getDateSeparator(dateObject) });
}
/**
 * To get the numeric CLDR  number base object for given culture
 *
 * @param {string} locale - Specifies the locale for which numericObject to be returned.
 * @param {string} currency - Specifies the currency for which numericObject to be returned.
 * @returns {string} ?
 * @ignore
 * @private
 */
function getNumberDependable(locale, currency) {
    // eslint-disable-next-line
    var numObject = __WEBPACK_IMPORTED_MODULE_4__intl_intl_base__["a" /* IntlBase */].getDependables(cldrData, locale, '', true);
    // eslint-disable-next-line
    return __WEBPACK_IMPORTED_MODULE_4__intl_intl_base__["a" /* IntlBase */].getCurrencySymbol(numObject.numericObject, currency);
}
/**
 * To get the default date CLDR object.
 *
 * @param {string} mode ?
 * @returns {Object} ?
 * @ignore
 * @private
 */
function getDefaultDateObject(mode) {
    // eslint-disable-next-line
    return __WEBPACK_IMPORTED_MODULE_4__intl_intl_base__["a" /* IntlBase */].getDependables(cldrData, '', mode, false)[mapper[1]];
}


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParserBase; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getBlazorCurrencySymbol;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(1);
/**
 * Parser
 */
var defaultNumberingSystem = {
    'latn': {
        '_digits': '0123456789',
        '_type': 'numeric'
    }
};

var defaultNumberSymbols = {
    'decimal': '.',
    'group': ',',
    'percentSign': '%',
    'plusSign': '+',
    'minusSign': '-',
    'infinity': '∞',
    'nan': 'NaN',
    'exponential': 'E'
};
var latnNumberSystem = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
/**
 * Interface for parser base
 *
 * @private
 */
var ParserBase = /** @class */ (function () {
    function ParserBase() {
    }
    /**
     * Returns the cldr object for the culture specifies
     *
     * @param {Object} obj - Specifies the object from which culture object to be acquired.
     * @param {string} cName - Specifies the culture name.
     * @returns {Object} ?
     */
    ParserBase.getMainObject = function (obj, cName) {
        var value = Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isBlazor */])() ? cName : 'main.' + cName;
        return Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])(value, obj);
    };
    /**
     * Returns the numbering system object from given cldr data.
     *
     * @param {Object} obj - Specifies the object from which number system is acquired.
     * @returns {Object} ?
     */
    ParserBase.getNumberingSystem = function (obj) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])('supplemental.numberingSystems', obj) || this.numberingSystems;
    };
    /**
     * Returns the reverse of given object keys or keys specified.
     *
     * @param {Object} prop - Specifies the object to be reversed.
     * @param {number[]} keys - Optional parameter specifies the custom keyList for reversal.
     * @returns {Object} ?
     */
    ParserBase.reverseObject = function (prop, keys) {
        var propKeys = keys || Object.keys(prop);
        var res = {};
        for (var _i = 0, propKeys_1 = propKeys; _i < propKeys_1.length; _i++) {
            var key = propKeys_1[_i];
            // eslint-disable-next-line
            if (!res.hasOwnProperty(prop[key])) {
                // eslint-disable-next-line
                res[prop[key]] = key;
            }
        }
        return res;
    };
    /**
     * Returns the symbol regex by skipping the escape sequence.
     *
     * @param {string[]} props - Specifies the array values to be skipped.
     * @returns {RegExp} ?
     */
    ParserBase.getSymbolRegex = function (props) {
        var regexStr = props.map(function (str) {
            return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
        }).join('|');
        return new RegExp(regexStr, 'g');
    };
    /**
     *
     * @param {Object} prop ?
     * @returns {Object} ?
     */
    ParserBase.getSymbolMatch = function (prop) {
        var matchKeys = Object.keys(defaultNumberSymbols);
        var ret = {};
        for (var _i = 0, matchKeys_1 = matchKeys; _i < matchKeys_1.length; _i++) {
            var key = matchKeys_1[_i];
            // eslint-disable-next-line
            ret[prop[key]] = defaultNumberSymbols[key];
        }
        return ret;
    };
    /**
     * Returns regex string for provided value
     *
     * @param {string} val ?
     * @returns {string} ?
     */
    ParserBase.constructRegex = function (val) {
        var len = val.length;
        var ret = '';
        for (var i = 0; i < len; i++) {
            if (i !== len - 1) {
                ret += val[i] + '|';
            }
            else {
                ret += val[i];
            }
        }
        return ret;
    };
    /**
     * Returns the replaced value of matching regex and obj mapper.
     *
     * @param {string} value - Specifies the  values to be replaced.
     * @param {RegExp} regex - Specifies the  regex to search.
     * @param {Object} obj - Specifies the  object matcher to be replace value parts.
     * @returns {string} ?
     */
    ParserBase.convertValueParts = function (value, regex, obj) {
        return value.replace(regex, function (str) {
            // eslint-disable-next-line
            return obj[str];
        });
    };
    /**
     * Returns default numbering system object for formatting from cldr data
     *
     * @param {Object} obj ?
     * @returns {NumericObject} ?
     */
    ParserBase.getDefaultNumberingSystem = function (obj) {
        var ret = {};
        ret.obj = Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])('numbers', obj);
        ret.nSystem = Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])('defaultNumberingSystem', ret.obj);
        return ret;
    };
    /**
     * Returns the replaced value of matching regex and obj mapper.
     *
     * @param {Object} curObj ?
     * @param {Object} numberSystem ?
     * @param {boolean} needSymbols ?
     * @param {boolean} blazorMode ?
     * @returns {Object} ?
     */
    ParserBase.getCurrentNumericOptions = function (curObj, numberSystem, needSymbols, blazorMode) {
        var ret = {};
        var cur = this.getDefaultNumberingSystem(curObj);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(cur.nSystem) || blazorMode) {
            var digits = blazorMode ? Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])('obj.mapperDigits', cur) : Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])(cur.nSystem + '._digits', numberSystem);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(digits)) {
                ret.numericPair = this.reverseObject(digits, latnNumberSystem);
                ret.numberParseRegex = new RegExp(this.constructRegex(digits), 'g');
                ret.numericRegex = '[' + digits[0] + '-' + digits[9] + ']';
                if (needSymbols) {
                    ret.numericRegex = digits[0] + '-' + digits[9];
                    ret.symbolNumberSystem = Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])(blazorMode ? 'numberSymbols' : 'symbols-numberSystem-' + cur.nSystem, cur.obj);
                    ret.symbolMatch = this.getSymbolMatch(ret.symbolNumberSystem);
                    ret.numberSystem = cur.nSystem;
                }
            }
        }
        return ret;
    };
    /**
     * Returns number mapper object for the provided cldr data
     *
     * @param {Object} curObj ?
     * @param {Object} numberSystem ?
     * @param {boolean} isNumber ?
     * @returns {NumberMapper} ?
     */
    // eslint-disable-next-line
    ParserBase.getNumberMapper = function (curObj, numberSystem, isNumber) {
        var ret = { mapper: {} };
        var cur = this.getDefaultNumberingSystem(curObj);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(cur.nSystem)) {
            ret.numberSystem = cur.nSystem;
            ret.numberSymbols = Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])('symbols-numberSystem-' + cur.nSystem, cur.obj);
            ret.timeSeparator = Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])('timeSeparator', ret.numberSymbols);
            var digits = Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])(cur.nSystem + '._digits', numberSystem);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(digits)) {
                for (var _i = 0, latnNumberSystem_1 = latnNumberSystem; _i < latnNumberSystem_1.length; _i++) {
                    var i = latnNumberSystem_1[_i];
                    // eslint-disable-next-line
                    ret.mapper[i] = digits[i];
                }
            }
        }
        return ret;
    };
    ParserBase.nPair = 'numericPair';
    ParserBase.nRegex = 'numericRegex';
    ParserBase.numberingSystems = defaultNumberingSystem;
    return ParserBase;
}());

/**
 * @private
 */
var blazorCurrencyData = {
    'DJF': 'Fdj',
    'ERN': 'Nfk',
    'ETB': 'Br',
    'NAD': '$',
    'ZAR': 'R',
    'XAF': 'FCFA',
    'GHS': 'GH₵',
    'XDR': 'XDR',
    'AED': 'د.إ.‏',
    'BHD': 'د.ب.‏',
    'DZD': 'د.ج.‏',
    'EGP': 'ج.م.‏',
    'ILS': '₪',
    'IQD': 'د.ع.‏',
    'JOD': 'د.ا.‏',
    'KMF': 'CF',
    'KWD': 'د.ك.‏',
    'LBP': 'ل.ل.‏',
    'LYD': 'د.ل.‏',
    'MAD': 'د.م.‏',
    'MRU': 'أ.م.',
    'OMR': 'ر.ع.‏',
    'QAR': 'ر.ق.‏',
    'SAR': 'ر.س.‏',
    'SDG': 'ج.س.',
    'SOS': 'S',
    'SSP': '£',
    'SYP': 'ل.س.‏',
    'TND': 'د.ت.‏',
    'YER': 'ر.ي.‏',
    'CLP': '$',
    'INR': '₹',
    'TZS': 'TSh',
    'EUR': '€',
    'AZN': '₼',
    'RUB': '₽',
    'BYN': 'Br',
    'ZMW': 'K',
    'BGN': 'лв.',
    'NGN': '₦',
    'XOF': 'CFA',
    'BDT': '৳',
    'CNY': '¥',
    'BAM': 'КМ',
    'UGX': 'USh',
    'USD': '$',
    'CZK': 'Kč',
    'GBP': '£',
    'DKK': 'kr.',
    'KES': 'Ksh',
    'CHF': 'CHF',
    'MVR': 'ރ.',
    'BTN': 'Nu.',
    'XCD': 'EC$',
    'AUD': '$',
    'BBD': '$',
    'BIF': 'FBu',
    'BMD': '$',
    'BSD': '$',
    'BWP': 'P',
    'BZD': '$',
    'CAD': '$',
    'NZD': '$',
    'FJD': '$',
    'FKP': '£',
    'GIP': '£',
    'GMD': 'D',
    'GYD': '$',
    'HKD': '$',
    'IDR': 'Rp',
    'JMD': '$',
    'KYD': '$',
    'LRD': '$',
    'MGA': 'Ar',
    'MOP': 'MOP$',
    'MUR': 'Rs',
    'MWK': 'MK',
    'MYR': 'RM',
    'PGK': 'K',
    'PHP': '₱',
    'PKR': 'Rs',
    'RWF': 'RF',
    'SBD': '$',
    'SCR': 'SR',
    'SEK': 'kr',
    'SGD': '$',
    'SHP': '£',
    'SLL': 'Le',
    'ANG': 'NAf.',
    'SZL': 'E',
    'TOP': 'T$',
    'TTD': '$',
    'VUV': 'VT',
    'WST': 'WS$',
    'ARS': '$',
    'BOB': 'Bs',
    'BRL': 'R$',
    'COP': '$',
    'CRC': '₡',
    'CUP': '$',
    'DOP': '$',
    'GTQ': 'Q',
    'HNL': 'L',
    'MXN': '$',
    'NIO': 'C$',
    'PAB': 'B/.',
    'PEN': 'S/',
    'PYG': '₲',
    'UYU': '$',
    'VES': 'Bs.S',
    'IRR': 'ريال',
    'GNF': 'FG',
    'CDF': 'FC',
    'HTG': 'G',
    'XPF': 'FCFP',
    'HRK': 'kn',
    'HUF': 'Ft',
    'AMD': '֏',
    'ISK': 'kr',
    'JPY': '¥',
    'GEL': '₾',
    'CVE': '​',
    'KZT': '₸',
    'KHR': '៛',
    'KPW': '₩',
    'KRW': '₩',
    'KGS': 'сом',
    'AOA': 'Kz',
    'LAK': '₭',
    'MZN': 'MTn',
    'MKD': 'ден',
    'MNT': '₮',
    'BND': '$',
    'MMK': 'K',
    'NOK': 'kr',
    'NPR': 'रु',
    'AWG': 'Afl.',
    'SRD': '$',
    'PLN': 'zł',
    'AFN': '؋',
    'STN': 'Db',
    'MDL': 'L',
    'RON': 'lei',
    'UAH': '₴',
    'LKR': 'රු.',
    'ALL': 'Lekë',
    'RSD': 'дин.',
    'TJS': 'смн',
    'THB': '฿',
    'TMT': 'm.',
    'TRY': '₺',
    'UZS': 'сўм',
    'VND': '₫',
    'TWD': 'NT$'
};
/**
 *
 * @param {string} currencyCode ?
 * @returns {string} ?
 */
function getBlazorCurrencySymbol(currencyCode) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])(currencyCode || '', blazorCurrencyData);
}


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = wrapperInitialize;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTextNode;
/* harmony export (immutable) */ __webpack_exports__["b"] = destroy;
/* harmony export (immutable) */ __webpack_exports__["d"] = preRender;
/* harmony export (immutable) */ __webpack_exports__["a"] = createCheckBox;
/* harmony export (immutable) */ __webpack_exports__["e"] = rippleMouseHandler;
/* harmony export (immutable) */ __webpack_exports__["f"] = setHiddenInput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);


/**
 * Initialize wrapper element for angular.
 *
 * @private
 *
 * @param {CreateElementArgs} createElement - Specifies created element args
 * @param {string} tag - Specifies tag name
 * @param {string} type - Specifies type name
 * @param {HTMLInputElement} element - Specifies input element
 * @param {string} WRAPPER - Specifies wrapper element
 * @param {string} role - Specifies role
 * @returns {HTMLInputElement} - Input Element
 */
function wrapperInitialize(createElement, tag, type, element, WRAPPER, role) {
    var input = element;
    if (element.tagName === tag) {
        var ejInstance = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('ej2_instances', element);
        input = createElement('input', { attrs: { 'type': type } });
        var props = ['change', 'cssClass', 'label', 'labelPosition', 'id'];
        for (var index = 0, len = element.attributes.length; index < len; index++) {
            if (props.indexOf(element.attributes[index].nodeName) === -1) {
                input.setAttribute(element.attributes[index].nodeName, element.attributes[index].nodeValue);
            }
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(element, { 'class': WRAPPER, 'role': role, 'aria-checked': 'false' });
        element.appendChild(input);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])('ej2_instances', ejInstance, input);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["C" /* deleteObject */])(element, 'ej2_instances');
    }
    return input;
}
/**
 * Get the text node.
 *
 * @param {HTMLElement} element - Specifies html element
 * @private
 * @returns {Node} - Text node.
 */
function getTextNode(element) {
    var node;
    var childnode = element.childNodes;
    for (var i = 0; i < childnode.length; i++) {
        node = childnode[i];
        if (node.nodeType === 3) {
            return node;
        }
    }
    return null;
}
/**
 * Destroy the button components.
 *
 * @private
 * @param {Switch | CheckBox} ejInst - Specifies eJ2 Instance
 * @param {Element} wrapper - Specifies wrapper element
 * @param {string} tagName - Specifies tag name
 * @returns {void}
 */
function destroy(ejInst, wrapper, tagName) {
    if (tagName === 'INPUT') {
        wrapper.parentNode.insertBefore(ejInst.element, wrapper);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(wrapper);
        ejInst.element.checked = false;
        ['name', 'value', 'disabled'].forEach(function (key) {
            ejInst.element.removeAttribute(key);
        });
    }
    else {
        ['role', 'aria-checked', 'class'].forEach(function (key) {
            wrapper.removeAttribute(key);
        });
        wrapper.innerHTML = '';
    }
}
/**
 * Initialize control pre rendering.
 *
 * @private
 * @param {Switch | CheckBox} proxy - Specifies proxy
 * @param {string} control - Specifies control
 * @param {string} wrapper - Specifies wrapper element
 * @param {HTMLInputElement} element - Specifies input element
 * @param {string} moduleName - Specifies module name
 * @returns {void}
 */
function preRender(proxy, control, wrapper, element, moduleName) {
    element = wrapperInitialize(proxy.createElement, control, 'checkbox', element, wrapper, moduleName);
    proxy.element = element;
    if (proxy.element.getAttribute('type') !== 'checkbox') {
        proxy.element.setAttribute('type', 'checkbox');
    }
    if (!proxy.element.id) {
        proxy.element.id = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('e-' + moduleName);
    }
}
/**
 * Creates CheckBox component UI with theming and ripple support.
 *
 * @private
 * @param {CreateElementArgs} createElement - Specifies Created Element args
 * @param {boolean} enableRipple - Specifies ripple effect
 * @param {CheckBoxUtilModel} options - Specifies Checkbox util Model
 * @returns {Element} - Checkbox Element
 */
function createCheckBox(createElement, enableRipple, options) {
    if (enableRipple === void 0) { enableRipple = false; }
    if (options === void 0) { options = {}; }
    var wrapper = createElement('div', { className: 'e-checkbox-wrapper e-css' });
    if (options.cssClass) {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([wrapper], options.cssClass.split(' '));
    }
    if (options.enableRtl) {
        wrapper.classList.add('e-rtl');
    }
    if (enableRipple) {
        var rippleSpan = createElement('span', { className: 'e-ripple-container' });
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_0" /* rippleEffect */])(rippleSpan, { isCenterRipple: true, duration: 400 });
        wrapper.appendChild(rippleSpan);
    }
    var frameSpan = createElement('span', { className: 'e-frame e-icons' });
    if (options.checked) {
        frameSpan.classList.add('e-check');
    }
    wrapper.appendChild(frameSpan);
    if (options.label) {
        var labelSpan = createElement('span', { className: 'e-label' });
        if (options.disableHtmlEncode) {
            labelSpan.textContent = options.label;
        }
        else {
            labelSpan.innerHTML = options.label;
        }
        wrapper.appendChild(labelSpan);
    }
    return wrapper;
}
/**
 * Handles ripple mouse.
 *
 * @private
 * @param {MouseEvent} e - Specifies mouse event
 * @param {Element} rippleSpan - Specifies Ripple span element
 * @returns {void}
 */
function rippleMouseHandler(e, rippleSpan) {
    if (rippleSpan) {
        var event_1 = document.createEvent('MouseEvents');
        event_1.initEvent(e.type, false, true);
        rippleSpan.dispatchEvent(event_1);
    }
}
/**
 * Append hidden input to given element
 *
 * @private
 * @param {Switch | CheckBox} proxy - Specifies Proxy
 * @param {Element} wrap - Specifies Wrapper ELement
 * @returns {void}
 */
function setHiddenInput(proxy, wrap) {
    if (proxy.element.getAttribute('ejs-for')) {
        wrap.appendChild(proxy.createElement('input', {
            attrs: { 'name': proxy.name || proxy.element.name, 'value': 'false', 'type': 'hidden' }
        }));
    }
}


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Input; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* eslint-disable valid-jsdoc, jsdoc/require-jsdoc, jsdoc/require-returns, jsdoc/require-param */


var CLASSNAMES = {
    RTL: 'e-rtl',
    DISABLE: 'e-disabled',
    INPUT: 'e-input',
    TEXTAREA: 'e-multi-line-input',
    INPUTGROUP: 'e-input-group',
    FLOATINPUT: 'e-float-input',
    FLOATLINE: 'e-float-line',
    FLOATTEXT: 'e-float-text',
    CLEARICON: 'e-clear-icon',
    CLEARICONHIDE: 'e-clear-icon-hide',
    LABELTOP: 'e-label-top',
    LABELBOTTOM: 'e-label-bottom',
    NOFLOATLABEL: 'e-no-float-label',
    INPUTCUSTOMTAG: 'e-input-custom-tag',
    FLOATCUSTOMTAG: 'e-float-custom-tag'
};
/**
 * Base for Input creation through util methods.
 */
// eslint-disable-next-line @typescript-eslint/no-namespace
var Input;
(function (Input) {
    var privateInputObj = {
        container: null,
        buttons: [],
        clearButton: null
    };
    var floatType;
    var isBindClearAction = true;
    /**
     * Create a wrapper to input element with multiple span elements and set the basic properties to input based components.
     * ```
     * E.g : Input.createInput({ element: element, floatLabelType : "Auto", properties: { placeholder: 'Search' } });
     * ```
     *
     */
    function createInput(args, internalCreateElement) {
        var makeElement = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(internalCreateElement) ? internalCreateElement : __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */];
        var inputObject = { container: null, buttons: [], clearButton: null };
        floatType = args.floatLabelType;
        isBindClearAction = args.bindClearAction;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.floatLabelType) || args.floatLabelType === 'Never') {
            inputObject.container = createInputContainer(args, CLASSNAMES.INPUTGROUP, CLASSNAMES.INPUTCUSTOMTAG, 'span', makeElement);
            args.element.parentNode.insertBefore(inputObject.container, args.element);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([args.element], CLASSNAMES.INPUT);
            inputObject.container.appendChild(args.element);
        }
        else {
            createFloatingInput(args, inputObject, makeElement);
        }
        bindInitialEvent(args);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.properties) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.properties.showClearButton) &&
            args.properties.showClearButton && args.element.tagName !== 'TEXTAREA') {
            setClearButton(args.properties.showClearButton, args.element, inputObject, true, makeElement);
            inputObject.clearButton.setAttribute('role', 'button');
            if (inputObject.container.classList.contains(CLASSNAMES.FLOATINPUT)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([inputObject.container], CLASSNAMES.INPUTGROUP);
            }
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.buttons) && args.element.tagName !== 'TEXTAREA') {
            for (var i = 0; i < args.buttons.length; i++) {
                inputObject.buttons.push(appendSpan(args.buttons[i], inputObject.container, makeElement));
            }
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.element) && args.element.tagName === 'TEXTAREA') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([inputObject.container], CLASSNAMES.TEXTAREA);
        }
        validateInputType(inputObject.container, args.element);
        inputObject = setPropertyValue(args, inputObject);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        privateInputObj = inputObject;
        return inputObject;
    }
    Input.createInput = createInput;
    function bindInitialEvent(args) {
        checkInputValue(args.floatLabelType, args.element);
        args.element.addEventListener('focus', function () {
            var parent = getParentNode(this);
            if (parent.classList.contains('e-input-group') || parent.classList.contains('e-outline')
                || parent.classList.contains('e-filled')) {
                parent.classList.add('e-input-focus');
            }
        });
        args.element.addEventListener('blur', function () {
            var parent = getParentNode(this);
            if (parent.classList.contains('e-input-group') || parent.classList.contains('e-outline')
                || parent.classList.contains('e-filled')) {
                parent.classList.remove('e-input-focus');
            }
        });
        args.element.addEventListener('input', function () {
            checkInputValue(floatType, args.element);
        });
    }
    Input.bindInitialEvent = bindInitialEvent;
    function checkInputValue(floatLabelType, inputElement) {
        var inputValue = inputElement.value;
        if (inputValue !== '' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(inputValue) && inputElement.parentElement) {
            inputElement.parentElement.classList.add('e-valid-input');
        }
        else if (floatLabelType !== 'Always' && inputElement.parentElement) {
            inputElement.parentElement.classList.remove('e-valid-input');
        }
    }
    function _focusFn() {
        var label = getParentNode(this).getElementsByClassName('e-float-text')[0];
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(label)) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([label], CLASSNAMES.LABELTOP);
            if (label.classList.contains(CLASSNAMES.LABELBOTTOM)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([label], CLASSNAMES.LABELBOTTOM);
            }
        }
    }
    function _blurFn() {
        var parent = getParentNode(this);
        if ((parent.getElementsByTagName('textarea')[0]) ? parent.getElementsByTagName('textarea')[0].value === '' :
            parent.getElementsByTagName('input')[0].value === '') {
            var label = parent.getElementsByClassName('e-float-text')[0];
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(label)) {
                if (label.classList.contains(CLASSNAMES.LABELTOP)) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([label], CLASSNAMES.LABELTOP);
                }
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([label], CLASSNAMES.LABELBOTTOM);
            }
        }
    }
    function wireFloatingEvents(element) {
        element.addEventListener('focus', _focusFn);
        element.addEventListener('blur', _blurFn);
    }
    Input.wireFloatingEvents = wireFloatingEvents;
    function unwireFloatingEvents(element) {
        element.removeEventListener('focus', _focusFn);
        element.removeEventListener('blur', _blurFn);
    }
    function createFloatingInput(args, inputObject, internalCreateElement) {
        var makeElement = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(internalCreateElement) ? internalCreateElement : __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */];
        if (args.floatLabelType === 'Auto') {
            wireFloatingEvents(args.element);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(inputObject.container)) {
            inputObject.container = createInputContainer(args, CLASSNAMES.FLOATINPUT, CLASSNAMES.FLOATCUSTOMTAG, 'div', makeElement);
            if (args.element.parentNode) {
                args.element.parentNode.insertBefore(inputObject.container, args.element);
            }
        }
        else {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.customTag)) {
                inputObject.container.classList.add(CLASSNAMES.FLOATCUSTOMTAG);
            }
            inputObject.container.classList.add(CLASSNAMES.FLOATINPUT);
        }
        var floatLinelement = makeElement('span', { className: CLASSNAMES.FLOATLINE });
        var floatLabelElement = makeElement('label', { className: CLASSNAMES.FLOATTEXT });
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.element.id) && args.element.id !== '') {
            floatLabelElement.id = 'label_' + args.element.id.replace(/ /g, '_');
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(args.element, { 'aria-labelledby': floatLabelElement.id });
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.element.placeholder) && args.element.placeholder !== '') {
            floatLabelElement.innerText = encodePlaceHolder(args.element.placeholder);
            args.element.removeAttribute('placeholder');
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.properties) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.properties.placeholder) &&
            args.properties.placeholder !== '') {
            floatLabelElement.innerText = encodePlaceHolder(args.properties.placeholder);
        }
        if (!floatLabelElement.innerText) {
            inputObject.container.classList.add(CLASSNAMES.NOFLOATLABEL);
        }
        if (inputObject.container.classList.contains('e-float-icon-left')) {
            var inputWrap = inputObject.container.querySelector('.e-input-in-wrap');
            inputWrap.appendChild(args.element);
            inputWrap.appendChild(floatLinelement);
            inputWrap.appendChild(floatLabelElement);
        }
        else {
            inputObject.container.appendChild(args.element);
            inputObject.container.appendChild(floatLinelement);
            inputObject.container.appendChild(floatLabelElement);
        }
        updateLabelState(args.element.value, floatLabelElement);
        if (args.floatLabelType === 'Always') {
            if (floatLabelElement.classList.contains(CLASSNAMES.LABELBOTTOM)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([floatLabelElement], CLASSNAMES.LABELBOTTOM);
            }
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([floatLabelElement], CLASSNAMES.LABELTOP);
        }
        if (args.floatLabelType === 'Auto') {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            args.element.addEventListener('input', function (event) {
                updateLabelState(args.element.value, floatLabelElement, args.element);
            });
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            args.element.addEventListener('blur', function (event) {
                updateLabelState(args.element.value, floatLabelElement);
            });
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.element.getAttribute('id'))) {
            floatLabelElement.setAttribute('for', args.element.getAttribute('id'));
        }
    }
    function checkFloatLabelType(type, container) {
        if (type === 'Always' && container.classList.contains('e-outline')) {
            container.classList.add('e-valid-input');
        }
    }
    function setPropertyValue(args, inputObject) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.properties)) {
            for (var _i = 0, _a = Object.keys(args.properties); _i < _a.length; _i++) {
                var prop = _a[_i];
                switch (prop) {
                    case 'cssClass':
                        setCssClass(args.properties.cssClass, [inputObject.container]);
                        checkFloatLabelType(args.floatLabelType, inputObject.container);
                        break;
                    case 'enabled':
                        setEnabled(args.properties.enabled, args.element, args.floatLabelType, inputObject.container);
                        break;
                    case 'enableRtl':
                        setEnableRtl(args.properties.enableRtl, [inputObject.container]);
                        break;
                    case 'placeholder':
                        setPlaceholder(args.properties.placeholder, args.element);
                        break;
                    case 'readonly':
                        setReadonly(args.properties.readonly, args.element);
                        break;
                }
            }
        }
        return inputObject;
    }
    function updateIconState(value, button) {
        if (value) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([button], CLASSNAMES.CLEARICONHIDE);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([button], CLASSNAMES.CLEARICONHIDE);
        }
    }
    function updateLabelState(value, label, element) {
        if (element === void 0) { element = null; }
        if (value) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([label], CLASSNAMES.LABELTOP);
            if (label.classList.contains(CLASSNAMES.LABELBOTTOM)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([label], CLASSNAMES.LABELBOTTOM);
            }
        }
        else {
            var isNotFocused = element != null ? element !== document.activeElement : true;
            if (isNotFocused) {
                if (label.classList.contains(CLASSNAMES.LABELTOP)) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([label], CLASSNAMES.LABELTOP);
                }
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([label], CLASSNAMES.LABELBOTTOM);
            }
        }
    }
    function getParentNode(element) {
        var parentNode = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(element.parentNode) ? element
            : element.parentNode;
        if (parentNode && parentNode.classList.contains('e-input-in-wrap')) {
            parentNode = parentNode.parentNode;
        }
        return parentNode;
    }
    /**
     * To create clear button.
     */
    function createClearButton(element, inputObject, initial, internalCreateElement) {
        var makeElement = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(internalCreateElement) ? internalCreateElement : __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */];
        var button = makeElement('span', { className: CLASSNAMES.CLEARICON });
        var container = inputObject.container;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(initial)) {
            container.appendChild(button);
        }
        else {
            var baseElement = inputObject.container.classList.contains(CLASSNAMES.FLOATINPUT) ?
                inputObject.container.querySelector('.' + CLASSNAMES.FLOATTEXT) : element;
            baseElement.insertAdjacentElement('afterend', button);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(container) &&
            container.classList.contains(CLASSNAMES.FLOATINPUT)) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([container], CLASSNAMES.INPUTGROUP);
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([button], CLASSNAMES.CLEARICONHIDE);
        wireClearBtnEvents(element, button, container);
        button.setAttribute('aria-label', 'close');
        return button;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function wireClearBtnEvents(element, button, container) {
        if (isBindClearAction == undefined || isBindClearAction) {
            button.addEventListener('click', function (event) {
                if (!(element.classList.contains(CLASSNAMES.DISABLE) || element.readOnly)) {
                    event.preventDefault();
                    if (element !== document.activeElement) {
                        element.focus();
                    }
                    element.value = '';
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([button], CLASSNAMES.CLEARICONHIDE);
                }
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        element.addEventListener('input', function (event) {
            updateIconState(element.value, button);
        });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        element.addEventListener('focus', function (event) {
            updateIconState(element.value, button);
        });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        element.addEventListener('blur', function (event) {
            setTimeout(function () {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([button], CLASSNAMES.CLEARICONHIDE);
            }, 200);
        });
    }
    Input.wireClearBtnEvents = wireClearBtnEvents;
    function validateLabel(element, floatLabelType) {
        var parent = getParentNode(element);
        if (parent.classList.contains(CLASSNAMES.FLOATINPUT) && floatLabelType === 'Auto') {
            var label = getParentNode(element).getElementsByClassName('e-float-text')[0];
            updateLabelState(element.value, label, element);
        }
    }
    /**
     * To create input box contianer.
     */
    function createInputContainer(args, className, tagClass, tag, internalCreateElement) {
        var makeElement = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(internalCreateElement) ? internalCreateElement : __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */];
        var container;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.customTag)) {
            container = makeElement(args.customTag, { className: className });
            container.classList.add(tagClass);
        }
        else {
            container = makeElement(tag, { className: className });
        }
        container.classList.add('e-control-wrapper');
        return container;
    }
    function encodePlaceHolder(placeholder) {
        var result = '';
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(placeholder) && placeholder !== '') {
            var spanEle = document.createElement('span');
            spanEle.innerHTML = '<input  placeholder="' + placeholder + '"/>';
            var hiddenInput = (spanEle.children[0]);
            result = hiddenInput.placeholder;
        }
        return result;
    }
    /**
     * Sets the value to the input element.
     * ```
     * E.g : Input.setValue('content', element, "Auto", true );
     * ```
     *
     * @param {string} value - Specify the value of the input element.
     * @param {HTMLInputElement | HTMLTextAreaElement} element - The element on which the specified value is updated.
     * @param {string} floatLabelType - Specify the float label type of the input element.
     * @param {boolean} clearButton - Boolean value to specify whether the clear icon is enabled / disabled on the input.
     */
    function setValue(value, element, floatLabelType, clearButton) {
        element.value = value;
        if ((!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(floatLabelType)) && floatLabelType === 'Auto') {
            validateLabel(element, floatLabelType);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(clearButton) && clearButton) {
            var parentElement = getParentNode(element);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(parentElement)) {
                var button = parentElement.getElementsByClassName(CLASSNAMES.CLEARICON)[0];
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(button)) {
                    if (element.value && parentElement.classList.contains('e-input-focus')) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([button], CLASSNAMES.CLEARICONHIDE);
                    }
                    else {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([button], CLASSNAMES.CLEARICONHIDE);
                    }
                }
            }
        }
        checkInputValue(floatLabelType, element);
    }
    Input.setValue = setValue;
    /**
     * Sets the single or multiple cssClass to wrapper of input element.
     * ```
     * E.g : Input.setCssClass('e-custom-class', [element]);
     * ```
     *
     * @param {string} cssClass - Css class names which are needed to add.
     * @param {Element[] | NodeList} elements - The elements which are needed to add / remove classes.
     * @param {string} oldClass
     * - Css class names which are needed to remove. If old classes are need to remove, can give this optional parameter.
     */
    function setCssClass(cssClass, elements, oldClass) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(oldClass) && oldClass !== '') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])(elements, oldClass.split(' '));
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(cssClass) && cssClass !== '') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])(elements, cssClass.split(' '));
        }
    }
    Input.setCssClass = setCssClass;
    /**
     * Set the width to the wrapper of input element.
     * ```
     * E.g : Input.setWidth('200px', container);
     * ```
     *
     * @param {number | string} width - Width value which is need to add.
     * @param {HTMLElement} container - The element on which the width is need to add.
     */
    function setWidth(width, container) {
        if (typeof width === 'number') {
            container.style.width = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(width);
        }
        else if (typeof width === 'string') {
            container.style.width = (width.match(/px|%|em/)) ? (width) : (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(width));
        }
    }
    Input.setWidth = setWidth;
    /**
     * Set the placeholder attribute to the input element.
     * ```
     * E.g : Input.setPlaceholder('Search here', element);
     * ```
     *
     * @param {string} placeholder - Placeholder value which is need to add.
     * @param {HTMLInputElement | HTMLTextAreaElement} element - The element on which the placeholder is need to add.
     */
    function setPlaceholder(placeholder, element) {
        placeholder = encodePlaceHolder(placeholder);
        var parentElement = getParentNode(element);
        if (parentElement.classList.contains(CLASSNAMES.FLOATINPUT)) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(placeholder) && placeholder !== '') {
                parentElement.getElementsByClassName(CLASSNAMES.FLOATTEXT)[0].textContent = placeholder;
                parentElement.classList.remove(CLASSNAMES.NOFLOATLABEL);
                element.removeAttribute('placeholder');
            }
            else {
                parentElement.classList.add(CLASSNAMES.NOFLOATLABEL);
                parentElement.getElementsByClassName(CLASSNAMES.FLOATTEXT)[0].textContent = '';
            }
        }
        else {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(placeholder) && placeholder !== '') {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(element, { 'placeholder': placeholder, 'aria-placeholder': placeholder });
            }
            else {
                element.removeAttribute('placeholder');
                element.removeAttribute('aria-placeholder');
            }
        }
    }
    Input.setPlaceholder = setPlaceholder;
    /**
     * Set the read only attribute to the input element
     * ```
     * E.g : Input.setReadonly(true, element);
     * ```
     *
     * @param {boolean} isReadonly
     * - Boolean value to specify whether to set read only. Setting "True" value enables read only.
     * @param {HTMLInputElement | HTMLTextAreaElement} element
     * - The element which is need to enable read only.
     */
    function setReadonly(isReadonly, element, floatLabelType) {
        if (isReadonly) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(element, { readonly: '' });
        }
        else {
            element.removeAttribute('readonly');
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(floatLabelType)) {
            validateLabel(element, floatLabelType);
        }
    }
    Input.setReadonly = setReadonly;
    /**
     * Displays the element direction from right to left when its enabled.
     * ```
     * E.g : Input.setEnableRtl(true, [inputObj.container]);
     * ```
     *
     * @param {boolean} isRtl
     * - Boolean value to specify whether to set RTL. Setting "True" value enables the RTL mode.
     * @param {Element[] | NodeList} elements
     * - The elements that are needed to enable/disable RTL.
     */
    function setEnableRtl(isRtl, elements) {
        if (isRtl) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])(elements, CLASSNAMES.RTL);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])(elements, CLASSNAMES.RTL);
        }
    }
    Input.setEnableRtl = setEnableRtl;
    /**
     * Enables or disables the given input element.
     * ```
     * E.g : Input.setEnabled(false, element);
     * ```
     *
     * @param {boolean} isEnable
     * - Boolean value to specify whether to enable or disable.
     * @param {HTMLInputElement | HTMLTextAreaElement} element
     * - Element to be enabled or disabled.
     */
    function setEnabled(isEnable, element, floatLabelType, inputContainer) {
        var disabledAttrs = { 'disabled': 'disabled', 'aria-disabled': 'true' };
        var considerWrapper = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(inputContainer) ? false : true;
        if (isEnable) {
            element.classList.remove(CLASSNAMES.DISABLE);
            removeAttributes(disabledAttrs, element);
            if (considerWrapper) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([inputContainer], CLASSNAMES.DISABLE);
            }
        }
        else {
            element.classList.add(CLASSNAMES.DISABLE);
            addAttributes(disabledAttrs, element);
            if (considerWrapper) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([inputContainer], CLASSNAMES.DISABLE);
            }
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(floatLabelType)) {
            validateLabel(element, floatLabelType);
        }
    }
    Input.setEnabled = setEnabled;
    function setClearButton(isClear, element, inputObject, initial, internalCreateElement) {
        var makeElement = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(internalCreateElement) ? internalCreateElement : __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */];
        if (isClear) {
            inputObject.clearButton = createClearButton(element, inputObject, initial, makeElement);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(inputObject.clearButton);
            inputObject.clearButton = null;
        }
    }
    Input.setClearButton = setClearButton;
    /**
     * Removing the multiple attributes from the given element such as "disabled","id" , etc.
     * ```
     * E.g : Input.removeAttributes({ 'disabled': 'disabled', 'aria-disabled': 'true' }, element);
     * ```
     *
     * @param {string} attrs
     * - Array of attributes which are need to removed from the element.
     * @param {HTMLInputElement | HTMLElement} element
     * - Element on which the attributes are needed to be removed.
     */
    function removeAttributes(attrs, element) {
        for (var _i = 0, _a = Object.keys(attrs); _i < _a.length; _i++) {
            var key = _a[_i];
            var parentElement = getParentNode(element);
            if (key === 'disabled') {
                element.classList.remove(CLASSNAMES.DISABLE);
            }
            if (key === 'disabled' && parentElement.classList.contains(CLASSNAMES.INPUTGROUP)) {
                parentElement.classList.remove(CLASSNAMES.DISABLE);
            }
            if (key === 'placeholder' && parentElement.classList.contains(CLASSNAMES.FLOATINPUT)) {
                parentElement.getElementsByClassName(CLASSNAMES.FLOATTEXT)[0].textContent = '';
            }
            else {
                element.removeAttribute(key);
            }
        }
    }
    Input.removeAttributes = removeAttributes;
    /**
     * Adding the multiple attributes to the given element such as "disabled","id" , etc.
     * ```
     * E.g : Input.addAttributes({ 'id': 'inputpopup' }, element);
     * ```
     *
     * @param {string} attrs
     * - Array of attributes which is added to element.
     * @param {HTMLInputElement | HTMLElement} element
     * - Element on which the attributes are needed to be added.
     */
    function addAttributes(attrs, element) {
        for (var _i = 0, _a = Object.keys(attrs); _i < _a.length; _i++) {
            var key = _a[_i];
            var parentElement = getParentNode(element);
            if (key === 'disabled') {
                element.classList.add(CLASSNAMES.DISABLE);
            }
            if (key === 'disabled' && parentElement.classList.contains(CLASSNAMES.INPUTGROUP)) {
                parentElement.classList.add(CLASSNAMES.DISABLE);
            }
            if (key === 'placeholder' && parentElement.classList.contains(CLASSNAMES.FLOATINPUT)) {
                parentElement.getElementsByClassName(CLASSNAMES.FLOATTEXT)[0].textContent = attrs[key];
            }
            else {
                element.setAttribute(key, attrs[key]);
            }
        }
    }
    Input.addAttributes = addAttributes;
    function removeFloating(input) {
        var container = input.container;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(container) && container.classList.contains(CLASSNAMES.FLOATINPUT)) {
            var inputEle = container.querySelector('textarea') ? container.querySelector('textarea') :
                container.querySelector('input');
            var placeholder = container.querySelector('.' + CLASSNAMES.FLOATTEXT).textContent;
            var clearButton = container.querySelector('.e-clear-icon') !== null;
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(container.querySelector('.' + CLASSNAMES.FLOATLINE));
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(container.querySelector('.' + CLASSNAMES.FLOATTEXT));
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["x" /* classList */])(container, [CLASSNAMES.INPUTGROUP], [CLASSNAMES.FLOATINPUT]);
            unwireFloatingEvents(inputEle);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(inputEle, { 'placeholder': placeholder });
            inputEle.classList.add(CLASSNAMES.INPUT);
            if (!clearButton && inputEle.tagName === 'INPUT') {
                inputEle.removeAttribute('required');
            }
        }
    }
    Input.removeFloating = removeFloating;
    function addFloating(input, type, placeholder, internalCreateElement) {
        var makeElement = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(internalCreateElement) ? internalCreateElement : __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */];
        var container = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(input, '.' + CLASSNAMES.INPUTGROUP);
        floatType = type;
        if (type !== 'Never') {
            var customTag = container.tagName;
            customTag = customTag !== 'DIV' && customTag !== 'SPAN' ? customTag : null;
            var args = { element: input, floatLabelType: type,
                customTag: customTag, properties: { placeholder: placeholder } };
            var iconEle = container.querySelector('.e-clear-icon');
            var inputObj = { container: container };
            input.classList.remove(CLASSNAMES.INPUT);
            createFloatingInput(args, inputObj, makeElement);
            var isPrependIcon = container.classList.contains('e-float-icon-left');
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(iconEle)) {
                if (isPrependIcon) {
                    var inputWrap = container.querySelector('.e-input-in-wrap');
                    iconEle = inputWrap.querySelector('.e-input-group-icon');
                }
                else {
                    iconEle = container.querySelector('.e-input-group-icon');
                }
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(iconEle)) {
                if (isPrependIcon) {
                    iconEle = container.querySelector('.e-input-group-icon');
                }
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(iconEle)) {
                    container.classList.remove(CLASSNAMES.INPUTGROUP);
                }
            }
            else {
                var floatLine = container.querySelector('.' + CLASSNAMES.FLOATLINE);
                var floatText = container.querySelector('.' + CLASSNAMES.FLOATTEXT);
                var wrapper = isPrependIcon ? container.querySelector('.e-input-in-wrap') : container;
                wrapper.insertBefore(input, iconEle);
                wrapper.insertBefore(floatLine, iconEle);
                wrapper.insertBefore(floatText, iconEle);
            }
        }
        checkFloatLabelType(type, input.parentElement);
    }
    Input.addFloating = addFloating;
    /**
     * Enable or Disable the ripple effect on the icons inside the Input. Ripple effect is only applicable for material theme.
     * ```
     * E.g : Input.setRipple(true, [inputObjects]);
     * ```
     *
     * @param {boolean} isRipple
     * - Boolean value to specify whether to enable the ripple effect.
     * @param {InputObject[]} inputObj
     * - Specify the collection of input objects.
     */
    function setRipple(isRipple, inputObj) {
        for (var i = 0; i < inputObj.length; i++) {
            _internalRipple(isRipple, inputObj[i].container);
        }
    }
    Input.setRipple = setRipple;
    function _internalRipple(isRipple, container, button) {
        var argsButton = [];
        argsButton.push(button);
        var buttons = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(button) ?
            container.querySelectorAll('.e-input-group-icon') : argsButton;
        if (isRipple && buttons.length > 0) {
            for (var index = 0; index < buttons.length; index++) {
                buttons[index].addEventListener('mousedown', _onMouseDownRipple, false);
                buttons[index].addEventListener('mouseup', _onMouseUpRipple, false);
            }
        }
        else if (buttons.length > 0) {
            for (var index = 0; index < buttons.length; index++) {
                buttons[index].removeEventListener('mousedown', _onMouseDownRipple, this);
                buttons[index].removeEventListener('mouseup', _onMouseUpRipple, this);
            }
        }
    }
    function _onMouseRipple(container, button) {
        if (!container.classList.contains('e-disabled') && !container.querySelector('input').readOnly) {
            button.classList.add('e-input-btn-ripple');
        }
    }
    function _onMouseDownRipple() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var ele = this;
        var parentEle = this.parentElement;
        while (!parentEle.classList.contains('e-input-group')) {
            parentEle = parentEle.parentElement;
        }
        _onMouseRipple(parentEle, ele);
    }
    function _onMouseUpRipple() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var ele = this;
        setTimeout(function () {
            ele.classList.remove('e-input-btn-ripple');
        }, 500);
    }
    function createIconEle(iconClass, makeElement) {
        var button = makeElement('span', { className: iconClass });
        button.classList.add('e-input-group-icon');
        return button;
    }
    /**
     * Creates a new span element with the given icons added and append it in container element.
     * ```
     * E.g : Input.addIcon('append', 'e-icon-spin', inputObj.container, inputElement);
     * ```
     *
     * @param {string} position - Specify the icon placement on the input.Possible values are append and prepend.
     * @param {string | string[]} icons - Icon classes which are need to add to the span element which is going to created.
     * Span element acts as icon or button element for input.
     * @param {HTMLElement} container - The container on which created span element is going to append.
     * @param {HTMLElement} input - The inputElement on which created span element is going to prepend.
     */
    /* eslint-disable @typescript-eslint/indent */
    function addIcon(position, icons, container, input, internalCreate) {
        /* eslint-enable @typescript-eslint/indent */
        var result = typeof (icons) === 'string' ? icons.split(',')
            : icons;
        if (position.toLowerCase() === 'append') {
            for (var _i = 0, result_1 = result; _i < result_1.length; _i++) {
                var icon = result_1[_i];
                appendSpan(icon, container, internalCreate);
            }
        }
        else {
            for (var _a = 0, result_2 = result; _a < result_2.length; _a++) {
                var icon = result_2[_a];
                prependSpan(icon, container, input, internalCreate);
            }
        }
    }
    Input.addIcon = addIcon;
    /**
     * Creates a new span element with the given icons added and prepend it in input element.
     * ```
     * E.g : Input.prependSpan('e-icon-spin', inputObj.container, inputElement);
     * ```
     *
     * @param {string} iconClass - Icon classes which are need to add to the span element which is going to created.
     * Span element acts as icon or button element for input.
     * @param {HTMLElement} container - The container on which created span element is going to append.
     * @param {HTMLElement} inputElement - The inputElement on which created span element is going to prepend.
     */
    /* eslint-disable @typescript-eslint/indent */
    function prependSpan(iconClass, container, inputElement, internalCreateElement) {
        /* eslint-enable @typescript-eslint/indent */
        var makeElement = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(internalCreateElement) ? internalCreateElement : __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */];
        var button = createIconEle(iconClass, makeElement);
        container.classList.add('e-float-icon-left');
        var innerWrapper = container.querySelector('.e-input-in-wrap');
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(innerWrapper)) {
            innerWrapper = makeElement('span', { className: 'e-input-in-wrap' });
            inputElement.parentNode.insertBefore(innerWrapper, inputElement);
            var result = container.querySelectorAll(inputElement.tagName + ' ~ *');
            innerWrapper.appendChild(inputElement);
            for (var i = 0; i < result.length; i++) {
                innerWrapper.appendChild(result[i]);
            }
        }
        innerWrapper.parentNode.insertBefore(button, innerWrapper);
        if (!container.classList.contains(CLASSNAMES.INPUTGROUP)) {
            container.classList.add(CLASSNAMES.INPUTGROUP);
        }
        _internalRipple(true, container, button);
        return button;
    }
    Input.prependSpan = prependSpan;
    /**
     * Creates a new span element with the given icons added and append it in container element.
     * ```
     * E.g : Input.appendSpan('e-icon-spin', inputObj.container);
     * ```
     *
     * @param {string} iconClass - Icon classes which are need to add to the span element which is going to created.
     * Span element acts as icon or button element for input.
     * @param {HTMLElement} container - The container on which created span element is going to append.
     */
    function appendSpan(iconClass, container, internalCreateElement) {
        var makeElement = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(internalCreateElement) ? internalCreateElement : __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */];
        var button = createIconEle(iconClass, makeElement);
        if (!container.classList.contains(CLASSNAMES.INPUTGROUP)) {
            container.classList.add(CLASSNAMES.INPUTGROUP);
        }
        var wrap = (container.classList.contains('e-float-icon-left')) ? container.querySelector('.e-input-in-wrap') :
            container;
        wrap.appendChild(button);
        _internalRipple(true, container, button);
        return button;
    }
    Input.appendSpan = appendSpan;
    function validateInputType(containerElement, input) {
        if (input.type === 'hidden') {
            containerElement.classList.add('e-hidden');
        }
        else if (containerElement.classList.contains('e-hidden')) {
            containerElement.classList.remove('e-hidden');
        }
    }
    Input.validateInputType = validateInputType;
})(Input || (Input = {}));
/* eslint-enable valid-jsdoc, jsdoc/require-jsdoc, jsdoc/require-returns, jsdoc/require-param */


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(6);
var normalizeHeaderName = __webpack_require__(120);
var enhanceError = __webpack_require__(57);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(58);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(58);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HScroll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var CLS_ROOT = 'e-hscroll';
var CLS_RTL = 'e-rtl';
var CLS_DISABLE = 'e-overlay';
var CLS_HSCROLLBAR = 'e-hscroll-bar';
var CLS_HSCROLLCON = 'e-hscroll-content';
var CLS_NAVARROW = 'e-nav-arrow';
var CLS_NAVRIGHTARROW = 'e-nav-right-arrow';
var CLS_NAVLEFTARROW = 'e-nav-left-arrow';
var CLS_HSCROLLNAV = 'e-scroll-nav';
var CLS_HSCROLLNAVRIGHT = 'e-scroll-right-nav';
var CLS_HSCROLLNAVLEFT = 'e-scroll-left-nav';
var CLS_DEVICE = 'e-scroll-device';
var CLS_OVERLAY = 'e-scroll-overlay';
var CLS_RIGHTOVERLAY = 'e-scroll-right-overlay';
var CLS_LEFTOVERLAY = 'e-scroll-left-overlay';
var OVERLAY_MAXWID = 40;
/**
 * HScroll module is introduces horizontal scroller when content exceeds the current viewing area.
 * It can be useful for the components like Toolbar, Tab which needs horizontal scrolling alone.
 * Hidden content can be view by touch moving or icon click.
 * ```html
 * <div id="scroll"/>
 * <script>
 *   var scrollObj = new HScroll();
 *   scrollObj.appendTo("#scroll");
 * </script>
 * ```
 */
var HScroll = /** @class */ (function (_super) {
    __extends(HScroll, _super);
    /**
     * Initializes a new instance of the HScroll class.
     *
     * @param {HScrollModel} options  - Specifies HScroll model properties as options.
     * @param {string | HTMLElement} element  - Specifies the element for which horizontal scrolling applies.
     */
    function HScroll(options, element) {
        return _super.call(this, options, element) || this;
    }
    /**
     * Initialize the event handler
     *
     * @private
     * @returns {void}
     */
    HScroll.prototype.preRender = function () {
        this.browser = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name;
        this.browserCheck = this.browser === 'mozilla';
        this.isDevice = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice;
        this.customStep = true;
        var element = this.element;
        this.ieCheck = this.browser === 'edge' || this.browser === 'msie';
        this.initialize();
        if (element.id === '') {
            element.id = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('hscroll');
            this.uniqueId = true;
        }
        element.style.display = 'block';
        if (this.enableRtl) {
            element.classList.add(CLS_RTL);
        }
    };
    /**
     * To Initialize the horizontal scroll  rendering
     *
     * @private
     * @returns {void}
     */
    HScroll.prototype.render = function () {
        this.touchModule = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["t" /* Touch */](this.element, { scroll: this.touchHandler.bind(this), swipe: this.swipeHandler.bind(this) });
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.scrollEle, 'scroll', this.scrollHandler, this);
        if (!this.isDevice) {
            this.createNavIcon(this.element);
        }
        else {
            this.element.classList.add(CLS_DEVICE);
            this.createOverlay(this.element);
        }
        this.setScrollState();
    };
    HScroll.prototype.setScrollState = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.scrollStep) || this.scrollStep < 0) {
            this.scrollStep = this.scrollEle.offsetWidth;
            this.customStep = false;
        }
        else {
            this.customStep = true;
        }
    };
    HScroll.prototype.initialize = function () {
        var scrollEle = this.createElement('div', { className: CLS_HSCROLLCON });
        var scrollDiv = this.createElement('div', { className: CLS_HSCROLLBAR });
        scrollDiv.setAttribute('tabindex', '-1');
        var ele = this.element;
        var innerEle = [].slice.call(ele.children);
        for (var _i = 0, innerEle_1 = innerEle; _i < innerEle_1.length; _i++) {
            var ele_1 = innerEle_1[_i];
            scrollEle.appendChild(ele_1);
        }
        scrollDiv.appendChild(scrollEle);
        ele.appendChild(scrollDiv);
        scrollDiv.style.overflowX = 'hidden';
        this.scrollEle = scrollDiv;
        this.scrollItems = scrollEle;
    };
    HScroll.prototype.getPersistData = function () {
        var keyEntity = ['scrollStep'];
        return this.addOnPersist(keyEntity);
    };
    /**
     * Returns the current module name.
     *
     * @returns {string} - It returns the current module name.
     * @private
     */
    HScroll.prototype.getModuleName = function () {
        return 'hScroll';
    };
    /**
     * Removes the control from the DOM and also removes all its related events.
     *
     * @returns {void}
     */
    HScroll.prototype.destroy = function () {
        var ele = this.element;
        ele.style.display = '';
        ele.classList.remove(CLS_ROOT);
        ele.classList.remove(CLS_DEVICE);
        var nav = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.e-' + ele.id + '_nav.' + CLS_HSCROLLNAV, ele);
        var overlay = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_OVERLAY, ele);
        [].slice.call(overlay).forEach(function (ele) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(ele);
        });
        for (var _i = 0, _a = [].slice.call(this.scrollItems.children); _i < _a.length; _i++) {
            var elem = _a[_i];
            ele.appendChild(elem);
        }
        if (this.uniqueId) {
            this.element.removeAttribute('id');
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.scrollEle);
        if (nav.length > 0) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(nav[0]);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(nav[1])) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(nav[1]);
            }
        }
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.scrollEle, 'scroll', this.scrollHandler);
        this.touchModule.destroy();
        this.touchModule = null;
        _super.prototype.destroy.call(this);
    };
    /**
     * Specifies the value to disable/enable the HScroll component.
     * When set to `true` , the component will be disabled.
     *
     * @param  {boolean} value - Based on this Boolean value, HScroll will be enabled (false) or disabled (true).
     * @returns {void}.
     */
    HScroll.prototype.disable = function (value) {
        var navEles = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.e-scroll-nav:not(.' + CLS_DISABLE + ')', this.element);
        if (value) {
            this.element.classList.add(CLS_DISABLE);
        }
        else {
            this.element.classList.remove(CLS_DISABLE);
        }
        [].slice.call(navEles).forEach(function (el) {
            el.setAttribute('tabindex', !value ? '0' : '-1');
        });
    };
    HScroll.prototype.createOverlay = function (element) {
        var id = element.id.concat('_nav');
        var rightOverlayEle = this.createElement('div', { className: CLS_OVERLAY + ' ' + CLS_RIGHTOVERLAY });
        var clsRight = 'e-' + element.id.concat('_nav ' + CLS_HSCROLLNAV + ' ' + CLS_HSCROLLNAVRIGHT);
        var rightEle = this.createElement('div', { id: id.concat('_right'), className: clsRight });
        var navItem = this.createElement('div', { className: CLS_NAVRIGHTARROW + ' ' + CLS_NAVARROW + ' e-icons' });
        rightEle.appendChild(navItem);
        var leftEle = this.createElement('div', { className: CLS_OVERLAY + ' ' + CLS_LEFTOVERLAY });
        if (this.ieCheck) {
            rightEle.classList.add('e-ie-align');
        }
        element.appendChild(rightOverlayEle);
        element.appendChild(rightEle);
        element.insertBefore(leftEle, element.firstChild);
        this.eventBinding([rightEle]);
    };
    HScroll.prototype.createNavIcon = function (element) {
        var id = element.id.concat('_nav');
        var clsRight = 'e-' + element.id.concat('_nav ' + CLS_HSCROLLNAV + ' ' + CLS_HSCROLLNAVRIGHT);
        var rightAttributes = { 'role': 'button', 'id': id.concat('_right'), 'aria-label': 'Scroll right' };
        var nav = this.createElement('div', { className: clsRight, attrs: rightAttributes });
        nav.setAttribute('aria-disabled', 'false');
        var navItem = this.createElement('div', { className: CLS_NAVRIGHTARROW + ' ' + CLS_NAVARROW + ' e-icons' });
        var clsLeft = 'e-' + element.id.concat('_nav ' + CLS_HSCROLLNAV + ' ' + CLS_HSCROLLNAVLEFT);
        var leftAttributes = { 'role': 'button', 'id': id.concat('_left'), 'aria-label': 'Scroll left' };
        var navEle = this.createElement('div', { className: clsLeft + ' ' + CLS_DISABLE, attrs: leftAttributes });
        navEle.setAttribute('aria-disabled', 'true');
        var navLeftItem = this.createElement('div', { className: CLS_NAVLEFTARROW + ' ' + CLS_NAVARROW + ' e-icons' });
        navEle.appendChild(navLeftItem);
        nav.appendChild(navItem);
        element.appendChild(nav);
        element.insertBefore(navEle, element.firstChild);
        if (this.ieCheck) {
            nav.classList.add('e-ie-align');
            navEle.classList.add('e-ie-align');
        }
        this.eventBinding([nav, navEle]);
    };
    HScroll.prototype.onKeyPress = function (e) {
        var _this = this;
        if (e.key === 'Enter') {
            var timeoutFun_1 = function () {
                _this.keyTimeout = true;
                _this.eleScrolling(10, e.target, true);
            };
            this.keyTimer = window.setTimeout(function () {
                timeoutFun_1();
            }, 100);
        }
    };
    HScroll.prototype.onKeyUp = function (e) {
        if (e.key !== 'Enter') {
            return;
        }
        if (this.keyTimeout) {
            this.keyTimeout = false;
        }
        else {
            e.target.click();
        }
        clearTimeout(this.keyTimer);
    };
    HScroll.prototype.eventBinding = function (ele) {
        var _this = this;
        [].slice.call(ele).forEach(function (el) {
            new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["t" /* Touch */](el, { tapHold: _this.tabHoldHandler.bind(_this), tapHoldThreshold: 500 });
            el.addEventListener('keydown', _this.onKeyPress.bind(_this));
            el.addEventListener('keyup', _this.onKeyUp.bind(_this));
            el.addEventListener('mouseup', _this.repeatScroll.bind(_this));
            el.addEventListener('touchend', _this.repeatScroll.bind(_this));
            el.addEventListener('contextmenu', function (e) {
                e.preventDefault();
            });
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(el, 'click', _this.clickEventHandler, _this);
        });
    };
    HScroll.prototype.repeatScroll = function () {
        clearInterval(this.timeout);
    };
    HScroll.prototype.tabHoldHandler = function (e) {
        var _this = this;
        var trgt = e.originalEvent.target;
        trgt = this.contains(trgt, CLS_HSCROLLNAV) ? trgt.firstElementChild : trgt;
        var scrollDis = 10;
        var timeoutFun = function () {
            _this.eleScrolling(scrollDis, trgt, true);
        };
        this.timeout = window.setInterval(function () {
            timeoutFun();
        }, 50);
    };
    HScroll.prototype.contains = function (ele, className) {
        return ele.classList.contains(className);
    };
    HScroll.prototype.eleScrolling = function (scrollDis, trgt, isContinuous) {
        var rootEle = this.element;
        var classList = trgt.classList;
        if (classList.contains(CLS_HSCROLLNAV)) {
            classList = trgt.querySelector('.' + CLS_NAVARROW).classList;
        }
        if (this.contains(rootEle, CLS_RTL) && this.browserCheck) {
            scrollDis = -scrollDis;
        }
        if ((!this.contains(rootEle, CLS_RTL) || this.browserCheck) || this.ieCheck) {
            if (classList.contains(CLS_NAVRIGHTARROW)) {
                this.frameScrollRequest(scrollDis, 'add', isContinuous);
            }
            else {
                this.frameScrollRequest(scrollDis, '', isContinuous);
            }
        }
        else {
            if (classList.contains(CLS_NAVLEFTARROW)) {
                this.frameScrollRequest(scrollDis, 'add', isContinuous);
            }
            else {
                this.frameScrollRequest(scrollDis, '', isContinuous);
            }
        }
    };
    HScroll.prototype.clickEventHandler = function (e) {
        this.eleScrolling(this.scrollStep, e.target, false);
    };
    HScroll.prototype.swipeHandler = function (e) {
        var swipeEle = this.scrollEle;
        var distance;
        if (e.velocity <= 1) {
            distance = e.distanceX / (e.velocity * 10);
        }
        else {
            distance = e.distanceX / e.velocity;
        }
        var start = 0.5;
        var animate = function () {
            var step = Math.sin(start);
            if (step <= 0) {
                window.cancelAnimationFrame(step);
            }
            else {
                if (e.swipeDirection === 'Left') {
                    swipeEle.scrollLeft += distance * step;
                }
                else if (e.swipeDirection === 'Right') {
                    swipeEle.scrollLeft -= distance * step;
                }
                start -= 0.5;
                window.requestAnimationFrame(animate);
            }
        };
        animate();
    };
    HScroll.prototype.scrollUpdating = function (scrollVal, action) {
        if (action === 'add') {
            this.scrollEle.scrollLeft += scrollVal;
        }
        else {
            this.scrollEle.scrollLeft -= scrollVal;
        }
    };
    HScroll.prototype.frameScrollRequest = function (scrollVal, action, isContinuous) {
        var _this = this;
        var step = 10;
        if (isContinuous) {
            this.scrollUpdating(scrollVal, action);
            return;
        }
        if (!this.customStep) {
            [].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_OVERLAY, this.element)).forEach(function (el) {
                scrollVal -= el.offsetWidth;
            });
        }
        var animate = function () {
            var scrollValue;
            var scrollStep;
            if (_this.contains(_this.element, CLS_RTL) && _this.browserCheck) {
                scrollValue = -scrollVal;
                scrollStep = -step;
            }
            else {
                scrollValue = scrollVal;
                scrollStep = step;
            }
            if (scrollValue < step) {
                window.cancelAnimationFrame(scrollStep);
            }
            else {
                _this.scrollUpdating(scrollStep, action);
                scrollVal -= scrollStep;
                window.requestAnimationFrame(animate);
            }
        };
        animate();
    };
    HScroll.prototype.touchHandler = function (e) {
        var ele = this.scrollEle;
        var distance = e.distanceX;
        if ((this.ieCheck) && this.contains(this.element, CLS_RTL)) {
            distance = -distance;
        }
        if (e.scrollDirection === 'Left') {
            ele.scrollLeft = ele.scrollLeft + distance;
        }
        else if (e.scrollDirection === 'Right') {
            ele.scrollLeft = ele.scrollLeft - distance;
        }
    };
    HScroll.prototype.arrowDisabling = function (addDisable, removeDisable) {
        if (this.isDevice) {
            var arrowEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(addDisable) ? removeDisable : addDisable;
            var arrowIcon = arrowEle.querySelector('.' + CLS_NAVARROW);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(addDisable)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["x" /* classList */])(arrowIcon, [CLS_NAVRIGHTARROW], [CLS_NAVLEFTARROW]);
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["x" /* classList */])(arrowIcon, [CLS_NAVLEFTARROW], [CLS_NAVRIGHTARROW]);
            }
        }
        else if (addDisable && removeDisable) {
            addDisable.classList.add(CLS_DISABLE);
            addDisable.setAttribute('aria-disabled', 'true');
            addDisable.removeAttribute('tabindex');
            removeDisable.classList.remove(CLS_DISABLE);
            removeDisable.setAttribute('aria-disabled', 'false');
            removeDisable.setAttribute('tabindex', '0');
        }
        this.repeatScroll();
    };
    HScroll.prototype.scrollHandler = function (e) {
        var target = e.target;
        var width = target.offsetWidth;
        var rootEle = this.element;
        var navLeftEle = this.element.querySelector('.' + CLS_HSCROLLNAVLEFT);
        var navRightEle = this.element.querySelector('.' + CLS_HSCROLLNAVRIGHT);
        var leftOverlay = this.element.querySelector('.' + CLS_LEFTOVERLAY);
        var rightOverlay = this.element.querySelector('.' + CLS_RIGHTOVERLAY);
        var scrollLeft = target.scrollLeft;
        if (scrollLeft <= 0) {
            scrollLeft = -scrollLeft;
        }
        if (this.isDevice) {
            if (this.enableRtl && !(this.browserCheck || this.ieCheck)) {
                leftOverlay = this.element.querySelector('.' + CLS_RIGHTOVERLAY);
                rightOverlay = this.element.querySelector('.' + CLS_LEFTOVERLAY);
            }
            if (scrollLeft < OVERLAY_MAXWID) {
                leftOverlay.style.width = scrollLeft + 'px';
            }
            else {
                leftOverlay.style.width = '40px';
            }
            if ((target.scrollWidth - Math.ceil(width + scrollLeft)) < OVERLAY_MAXWID) {
                rightOverlay.style.width = (target.scrollWidth - Math.ceil(width + scrollLeft)) + 'px';
            }
            else {
                rightOverlay.style.width = '40px';
            }
        }
        if (scrollLeft === 0) {
            this.arrowDisabling(navLeftEle, navRightEle);
        }
        else if (Math.ceil(width + scrollLeft + .1) >= target.scrollWidth) {
            this.arrowDisabling(navRightEle, navLeftEle);
        }
        else {
            var disEle = this.element.querySelector('.' + CLS_HSCROLLNAV + '.' + CLS_DISABLE);
            if (disEle) {
                disEle.classList.remove(CLS_DISABLE);
                disEle.setAttribute('aria-disabled', 'false');
                disEle.setAttribute('tabindex', '0');
            }
        }
    };
    /**
     * Gets called when the model property changes.The data that describes the old and new values of property that changed.
     *
     * @param  {HScrollModel} newProp - It contains the new value of data.
     * @param  {HScrollModel} oldProp - It contains the old value of data.
     * @returns {void}
     * @private
     */
    HScroll.prototype.onPropertyChanged = function (newProp, oldProp) {
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'scrollStep':
                    this.setScrollState();
                    break;
                case 'enableRtl':
                    newProp.enableRtl ? this.element.classList.add(CLS_RTL) : this.element.classList.remove(CLS_RTL);
                    break;
            }
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], HScroll.prototype, "scrollStep", void 0);
    HScroll = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], HScroll);
    return HScroll;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Observer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(1);

var Observer = /** @class */ (function () {
    function Observer(context) {
        this.ranArray = [];
        this.boundedEvents = {};
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(context)) {
            return;
        }
        this.context = context;
    }
    /**
     * To attach handler for given property in current context.
     *
     * @param {string} property - specifies the name of the event.
     * @param {Function} handler - Specifies the handler function to be called while event notified.
     * @param {Object} context - Specifies the context binded to the handler.
     * @param {string} id - specifies the random generated id.
     * @returns {void}
     */
    Observer.prototype.on = function (property, handler, context, id) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(handler)) {
            return;
        }
        var cntxt = context || this.context;
        if (this.notExist(property)) {
            this.boundedEvents[property] = [{ handler: handler, context: cntxt }];
            return;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(id)) {
            if (this.ranArray.indexOf(id) === -1) {
                this.ranArray.push(id);
                this.boundedEvents[property].push({ handler: handler, context: cntxt, id: id });
            }
        }
        else if (!this.isHandlerPresent(this.boundedEvents[property], handler)) {
            this.boundedEvents[property].push({ handler: handler, context: cntxt });
        }
    };
    /**
     * To remove handlers from a event attached using on() function.
     *
     * @param {string} property - specifies the name of the event.
     * @param {Function} handler - Optional argument specifies the handler function to be called while event notified.
     * @param {string} id - specifies the random generated id.
     * @returns {void} ?
     */
    Observer.prototype.off = function (property, handler, id) {
        if (this.notExist(property)) {
            return;
        }
        var curObject = Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])(property, this.boundedEvents);
        if (handler) {
            for (var i = 0; i < curObject.length; i++) {
                if (id) {
                    if (curObject[i].id === id) {
                        curObject.splice(i, 1);
                        var indexLocation = this.ranArray.indexOf(id);
                        if (indexLocation !== -1) {
                            this.ranArray.splice(indexLocation, 1);
                        }
                        break;
                    }
                }
                else if (handler === curObject[i].handler) {
                    curObject.splice(i, 1);
                    break;
                }
            }
        }
        else {
            delete this.boundedEvents[property];
        }
    };
    /**
     * To notify the handlers in the specified event.
     *
     * @param {string} property - Specifies the event to be notify.
     * @param {Object} argument - Additional parameters to pass while calling the handler.
     * @param {Function} successHandler - this function will invoke after event successfully triggered
     * @param {Function} errorHandler - this function will invoke after event if it was failure to call.
     * @returns {void} ?
     */
    Observer.prototype.notify = function (property, argument, successHandler, errorHandler) {
        if (this.notExist(property)) {
            if (successHandler) {
                successHandler.call(this, argument);
            }
            return;
        }
        if (argument) {
            argument.name = property;
        }
        var blazor = 'Blazor';
        var curObject = Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])(property, this.boundedEvents).slice(0);
        if (window[blazor]) {
            return this.blazorCallback(curObject, argument, successHandler, errorHandler, 0);
        }
        else {
            for (var _i = 0, curObject_1 = curObject; _i < curObject_1.length; _i++) {
                var cur = curObject_1[_i];
                cur.handler.call(cur.context, argument);
            }
            if (successHandler) {
                successHandler.call(this, argument);
            }
        }
    };
    Observer.prototype.blazorCallback = function (objs, argument, successHandler, errorHandler, index) {
        var _this = this;
        var isTrigger = index === objs.length - 1;
        if (index < objs.length) {
            var obj_1 = objs[index];
            var promise = obj_1.handler.call(obj_1.context, argument);
            if (promise && typeof promise.then === 'function') {
                if (!successHandler) {
                    return promise;
                }
                promise.then(function (data) {
                    data = typeof data === 'string' && _this.isJson(data) ? JSON.parse(data, _this.dateReviver) : data;
                    Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])(argument, argument, data, true);
                    if (successHandler && isTrigger) {
                        successHandler.call(obj_1.context, argument);
                    }
                    else {
                        return _this.blazorCallback(objs, argument, successHandler, errorHandler, index + 1);
                    }
                }).catch(function (data) {
                    if (errorHandler) {
                        errorHandler.call(obj_1.context, typeof data === 'string' &&
                            _this.isJson(data) ? JSON.parse(data, _this.dateReviver) : data);
                    }
                });
            }
            else if (successHandler && isTrigger) {
                successHandler.call(obj_1.context, argument);
            }
            else {
                return this.blazorCallback(objs, argument, successHandler, errorHandler, index + 1);
            }
        }
    };
    // eslint-disable-next-line
    Observer.prototype.dateReviver = function (key, value) {
        var dPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
        if (__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isBlazor */] && typeof value === 'string' && value.match(dPattern) !== null) {
            return (new Date(value));
        }
        return (value);
    };
    Observer.prototype.isJson = function (value) {
        try {
            JSON.parse(value);
        }
        catch (e) {
            return false;
        }
        return true;
    };
    /**
     * To destroy handlers in the event
     *
     * @returns {void} ?
     */
    Observer.prototype.destroy = function () {
        this.boundedEvents = this.context = undefined;
    };
    /**
     * Returns if the property exists.
     *
     * @param {string} prop ?
     * @returns {boolean} ?
     */
    Observer.prototype.notExist = function (prop) {
        // eslint-disable-next-line
        return this.boundedEvents.hasOwnProperty(prop) === false || this.boundedEvents[prop].length <= 0;
    };
    /**
     * Returns if the handler is present.
     *
     * @param {BoundOptions[]} boundedEvents ?
     * @param {Function} handler ?
     * @returns {boolean} ?
     */
    Observer.prototype.isHandlerPresent = function (boundedEvents, handler) {
        for (var _i = 0, boundedEvents_1 = boundedEvents; _i < boundedEvents_1.length; _i++) {
            var cur = boundedEvents_1[_i];
            if (cur.handler === handler) {
                return true;
            }
        }
        return false;
    };
    return Observer;
}());



/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChildProperty; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(12);


/**
 * To detect the changes for inner properties.
 *
 * @private
 */
var ChildProperty = /** @class */ (function () {
    function ChildProperty(parent, propName, defaultValue, isArray) {
        this.isComplexArraySetter = false;
        this.properties = {};
        this.changedProperties = {};
        this.childChangedProperties = {};
        this.oldProperties = {};
        // eslint-disable-next-line
        this.finalUpdate = function () { };
        this.callChildDataBind = Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])('callChildDataBind', __WEBPACK_IMPORTED_MODULE_1__base__["a" /* Base */]);
        this.parentObj = parent;
        this.controlParent = this.parentObj.controlParent || this.parentObj;
        this.propName = propName;
        this.isParentArray = isArray;
        this.setProperties(defaultValue, true);
    }
    /**
     * Updates the property changes
     *
     * @param {boolean} val ?
     * @param {string} propName ?
     * @returns {void} ?
     */
    ChildProperty.prototype.updateChange = function (val, propName) {
        if (val === true) {
            this.parentObj.childChangedProperties[propName] = val;
        }
        else {
            delete this.parentObj.childChangedProperties[propName];
        }
        if (this.parentObj.updateChange) {
            this.parentObj.updateChange(val, this.parentObj.propName);
        }
    };
    /**
     * Updates time out duration
     *
     * @returns {void} ?
     */
    ChildProperty.prototype.updateTimeOut = function () {
        if (this.parentObj.updateTimeOut) {
            this.parentObj.finalUpdate();
            this.parentObj.updateTimeOut();
        }
        else {
            var changeTime_1 = setTimeout(this.parentObj.dataBind.bind(this.parentObj));
            var clearUpdate = function () {
                clearTimeout(changeTime_1);
            };
            this.finalUpdate = clearUpdate;
        }
    };
    /**
     * Clears changed properties
     *
     * @returns {void} ?
     */
    ChildProperty.prototype.clearChanges = function () {
        this.finalUpdate();
        this.updateChange(false, this.propName);
        this.oldProperties = {};
        this.changedProperties = {};
    };
    /**
     * Set property changes
     *
     * @param {Object} prop ?
     * @param {boolean} muteOnChange ?
     * @returns {void} ?
     */
    ChildProperty.prototype.setProperties = function (prop, muteOnChange) {
        if (muteOnChange === true) {
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["p" /* merge */])(this, prop);
            this.updateChange(false, this.propName);
            this.clearChanges();
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["p" /* merge */])(this, prop);
        }
    };
    /**
     * Binds data
     *
     * @returns {void} ?
     */
    ChildProperty.prototype.dataBind = function () {
        this.callChildDataBind(this.childChangedProperties, this);
        if (this.isParentArray) {
            var curIndex = this.parentObj[this.propName].indexOf(this);
            if (Object.keys(this.changedProperties).length) {
                Object(__WEBPACK_IMPORTED_MODULE_0__util__["r" /* setValue */])(this.propName + '.' + curIndex, this.changedProperties, this.parentObj.changedProperties);
                Object(__WEBPACK_IMPORTED_MODULE_0__util__["r" /* setValue */])(this.propName + '.' + curIndex, this.oldProperties, this.parentObj.oldProperties);
            }
        }
        else {
            this.parentObj.changedProperties[this.propName] = this.changedProperties;
            this.parentObj.oldProperties[this.propName] = this.oldProperties;
        }
        this.clearChanges();
    };
    /**
     * Saves changes to newer values
     *
     * @param {string} key ?
     * @param {Object} newValue ?
     * @param {Object} oldValue ?
     * @param {boolean} restrictServerDataBind ?
     * @returns {void} ?
     */
    ChildProperty.prototype.saveChanges = function (key, newValue, oldValue, restrictServerDataBind) {
        if (this.controlParent.isProtectedOnChange) {
            return;
        }
        if (!restrictServerDataBind) {
            this.serverDataBind(key, newValue, true);
        }
        this.oldProperties[key] = oldValue;
        this.changedProperties[key] = newValue;
        this.updateChange(true, this.propName);
        this.finalUpdate();
        this.updateTimeOut();
    };
    ChildProperty.prototype.serverDataBind = function (key, value, isSaveChanges, action) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isBlazor */])() && !this.parentObj.isComplexArraySetter) {
            var parent_1;
            var newChanges = {};
            var parentKey = isSaveChanges ? this.getParentKey(true) + '.' + key : key;
            /* istanbul ignore else  */
            if (parentKey.indexOf('.') !== -1) {
                var complexKeys = parentKey.split('.');
                parent_1 = newChanges;
                for (var i = 0; i < complexKeys.length; i++) {
                    var isFinal = i === complexKeys.length - 1;
                    parent_1[complexKeys[i]] = isFinal ? value : {};
                    parent_1 = isFinal ? parent_1 : parent_1[complexKeys[i]];
                }
            }
            else {
                newChanges[parentKey] = {};
                parent_1 = newChanges[parentKey];
                newChanges[parentKey][key] = value;
            }
            /* istanbul ignore next */
            if (this.isParentArray) {
                var actionProperty = 'ejsAction';
                parent_1[actionProperty] = action ? action : 'none';
            }
            this.controlParent.serverDataBind(newChanges);
        }
    };
    ChildProperty.prototype.getParentKey = function (isSaveChanges) {
        // eslint-disable-next-line
        var index = '';
        var propName = this.propName;
        /* istanbul ignore next */
        if (this.isParentArray) {
            index = this.parentObj[this.propName].indexOf(this);
            var valueLength = this.parentObj[this.propName].length;
            valueLength = isSaveChanges ? valueLength : (valueLength > 0 ? valueLength - 1 : 0);
            index = index !== -1 ? '-' + index : '-' + valueLength;
            propName = propName + index;
        }
        if (this.controlParent !== this.parentObj) {
            propName = this.parentObj.getParentKey() + '.' + this.propName + index;
        }
        return propName;
    };
    return ChildProperty;
}());



/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VScroll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var CLS_ROOT = 'e-vscroll';
var CLS_RTL = 'e-rtl';
var CLS_DISABLE = 'e-overlay';
var CLS_VSCROLLBAR = 'e-vscroll-bar';
var CLS_VSCROLLCON = 'e-vscroll-content';
var CLS_NAVARROW = 'e-nav-arrow';
var CLS_NAVUPARROW = 'e-nav-up-arrow';
var CLS_NAVDOWNARROW = 'e-nav-down-arrow';
var CLS_VSCROLLNAV = 'e-scroll-nav';
var CLS_VSCROLLNAVUP = 'e-scroll-up-nav';
var CLS_VSCROLLNAVDOWN = 'e-scroll-down-nav';
var CLS_DEVICE = 'e-scroll-device';
var CLS_OVERLAY = 'e-scroll-overlay';
var CLS_UPOVERLAY = 'e-scroll-up-overlay';
var CLS_DOWNOVERLAY = 'e-scroll-down-overlay';
var OVERLAY_MAXWID = 40;
/**
 * VScroll module is introduces vertical scroller when content exceeds the current viewing area.
 * It can be useful for the components like Toolbar, Tab which needs vertical scrolling alone.
 * Hidden content can be view by touch moving or icon click.
 * ```html
 * <div id="scroll"/>
 * <script>
 *   var scrollObj = new VScroll();
 *   scrollObj.appendTo("#scroll");
 * </script>
 * ```
 */
var VScroll = /** @class */ (function (_super) {
    __extends(VScroll, _super);
    /**
     * Initializes a new instance of the VScroll class.
     *
     * @param {VScrollModel} options  - Specifies VScroll model properties as options.
     * @param {string | HTMLElement} element  - Specifies the element for which vertical scrolling applies.
     */
    function VScroll(options, element) {
        return _super.call(this, options, element) || this;
    }
    /**
     * Initialize the event handler
     *
     * @private
     * @returns {void}
     */
    VScroll.prototype.preRender = function () {
        this.browser = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name;
        this.browserCheck = this.browser === 'mozilla';
        this.isDevice = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice;
        this.customStep = true;
        var ele = this.element;
        this.ieCheck = this.browser === 'edge' || this.browser === 'msie';
        this.initialize();
        if (ele.id === '') {
            ele.id = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('vscroll');
            this.uniqueId = true;
        }
        ele.style.display = 'block';
        if (this.enableRtl) {
            ele.classList.add(CLS_RTL);
        }
    };
    /**
     * To Initialize the vertical scroll rendering
     *
     * @private
     * @returns {void}
     */
    VScroll.prototype.render = function () {
        this.touchModule = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["t" /* Touch */](this.element, { scroll: this.touchHandler.bind(this), swipe: this.swipeHandler.bind(this) });
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.scrollEle, 'scroll', this.scrollEventHandler, this);
        if (!this.isDevice) {
            this.createNavIcon(this.element);
        }
        else {
            this.element.classList.add(CLS_DEVICE);
            this.createOverlayElement(this.element);
        }
        this.setScrollState();
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'wheel', this.wheelEventHandler, this);
    };
    VScroll.prototype.setScrollState = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.scrollStep) || this.scrollStep < 0) {
            this.scrollStep = this.scrollEle.offsetHeight;
            this.customStep = false;
        }
        else {
            this.customStep = true;
        }
    };
    VScroll.prototype.initialize = function () {
        var scrollCnt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */])('div', { className: CLS_VSCROLLCON });
        var scrollBar = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */])('div', { className: CLS_VSCROLLBAR });
        scrollBar.setAttribute('tabindex', '-1');
        var ele = this.element;
        var innerEle = [].slice.call(ele.children);
        for (var _i = 0, innerEle_1 = innerEle; _i < innerEle_1.length; _i++) {
            var ele_1 = innerEle_1[_i];
            scrollCnt.appendChild(ele_1);
        }
        scrollBar.appendChild(scrollCnt);
        ele.appendChild(scrollBar);
        scrollBar.style.overflow = 'hidden';
        this.scrollEle = scrollBar;
        this.scrollItems = scrollCnt;
    };
    VScroll.prototype.getPersistData = function () {
        var keyEntity = ['scrollStep'];
        return this.addOnPersist(keyEntity);
    };
    /**
     * Returns the current module name.
     *
     * @returns {string} - It returns the current module name.
     * @private
     */
    VScroll.prototype.getModuleName = function () {
        return 'vScroll';
    };
    /**
     * Removes the control from the DOM and also removes all its related events.
     *
     * @returns {void}
     */
    VScroll.prototype.destroy = function () {
        var el = this.element;
        el.style.display = '';
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], [CLS_ROOT, CLS_DEVICE]);
        var navs = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.e-' + el.id + '_nav.' + CLS_VSCROLLNAV, el);
        var overlays = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_OVERLAY, el);
        [].slice.call(overlays).forEach(function (ele) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(ele);
        });
        for (var _i = 0, _a = [].slice.call(this.scrollItems.children); _i < _a.length; _i++) {
            var elem = _a[_i];
            el.appendChild(elem);
        }
        if (this.uniqueId) {
            this.element.removeAttribute('id');
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.scrollEle);
        if (navs.length > 0) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(navs[0]);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(navs[1])) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(navs[1]);
            }
        }
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.scrollEle, 'scroll', this.scrollEventHandler);
        this.touchModule.destroy();
        this.touchModule = null;
        _super.prototype.destroy.call(this);
    };
    /**
     * Specifies the value to disable/enable the VScroll component.
     * When set to `true` , the component will be disabled.
     *
     * @param  {boolean} value - Based on this Boolean value, VScroll will be enabled (false) or disabled (true).
     * @returns {void}.
     */
    VScroll.prototype.disable = function (value) {
        var navEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.e-scroll-nav:not(.' + CLS_DISABLE + ')', this.element);
        if (value) {
            this.element.classList.add(CLS_DISABLE);
        }
        else {
            this.element.classList.remove(CLS_DISABLE);
        }
        [].slice.call(navEle).forEach(function (el) {
            el.setAttribute('tabindex', !value ? '0' : '-1');
        });
    };
    VScroll.prototype.createOverlayElement = function (element) {
        var id = element.id.concat('_nav');
        var downOverlayEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */])('div', { className: CLS_OVERLAY + ' ' + CLS_DOWNOVERLAY });
        var clsDown = 'e-' + element.id.concat('_nav ' + CLS_VSCROLLNAV + ' ' + CLS_VSCROLLNAVDOWN);
        var downEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */])('div', { id: id.concat('down'), className: clsDown });
        var navItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */])('div', { className: CLS_NAVDOWNARROW + ' ' + CLS_NAVARROW + ' e-icons' });
        downEle.appendChild(navItem);
        var upEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */])('div', { className: CLS_OVERLAY + ' ' + CLS_UPOVERLAY });
        if (this.ieCheck) {
            downEle.classList.add('e-ie-align');
        }
        element.appendChild(downOverlayEle);
        element.appendChild(downEle);
        element.insertBefore(upEle, element.firstChild);
        this.eventBinding([downEle]);
    };
    VScroll.prototype.createNavIcon = function (element) {
        var id = element.id.concat('_nav');
        var clsDown = 'e-' + element.id.concat('_nav ' + CLS_VSCROLLNAV + ' ' + CLS_VSCROLLNAVDOWN);
        var nav = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */])('div', { id: id.concat('_down'), className: clsDown });
        nav.setAttribute('aria-disabled', 'false');
        var navItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */])('div', { className: CLS_NAVDOWNARROW + ' ' + CLS_NAVARROW + ' e-icons' });
        var clsUp = 'e-' + element.id.concat('_nav ' + CLS_VSCROLLNAV + ' ' + CLS_VSCROLLNAVUP);
        var navElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */])('div', { id: id.concat('_up'), className: clsUp + ' ' + CLS_DISABLE });
        navElement.setAttribute('aria-disabled', 'true');
        var navUpItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */])('div', { className: CLS_NAVUPARROW + ' ' + CLS_NAVARROW + ' e-icons' });
        navElement.appendChild(navUpItem);
        nav.appendChild(navItem);
        nav.setAttribute('tabindex', '0');
        element.appendChild(nav);
        element.insertBefore(navElement, element.firstChild);
        if (this.ieCheck) {
            nav.classList.add('e-ie-align');
            navElement.classList.add('e-ie-align');
        }
        this.eventBinding([nav, navElement]);
    };
    VScroll.prototype.onKeyPress = function (ev) {
        var _this = this;
        if (ev.key === 'Enter') {
            var timeoutFun_1 = function () {
                _this.keyTimeout = true;
                _this.eleScrolling(10, ev.target, true);
            };
            this.keyTimer = window.setTimeout(function () {
                timeoutFun_1();
            }, 100);
        }
    };
    VScroll.prototype.onKeyUp = function (ev) {
        if (ev.key !== 'Enter') {
            return;
        }
        if (this.keyTimeout) {
            this.keyTimeout = false;
        }
        else {
            ev.target.click();
        }
        clearTimeout(this.keyTimer);
    };
    VScroll.prototype.eventBinding = function (element) {
        var _this = this;
        [].slice.call(element).forEach(function (ele) {
            new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["t" /* Touch */](ele, { tapHold: _this.tabHoldHandler.bind(_this), tapHoldThreshold: 500 });
            ele.addEventListener('keydown', _this.onKeyPress.bind(_this));
            ele.addEventListener('keyup', _this.onKeyUp.bind(_this));
            ele.addEventListener('mouseup', _this.repeatScroll.bind(_this));
            ele.addEventListener('touchend', _this.repeatScroll.bind(_this));
            ele.addEventListener('contextmenu', function (e) {
                e.preventDefault();
            });
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(ele, 'click', _this.clickEventHandler, _this);
        });
    };
    VScroll.prototype.repeatScroll = function () {
        clearInterval(this.timeout);
    };
    VScroll.prototype.tabHoldHandler = function (ev) {
        var _this = this;
        var trgt = ev.originalEvent.target;
        trgt = this.contains(trgt, CLS_VSCROLLNAV) ? trgt.firstElementChild : trgt;
        var scrollDistance = 10;
        var timeoutFun = function () {
            _this.eleScrolling(scrollDistance, trgt, true);
        };
        this.timeout = window.setInterval(function () {
            timeoutFun();
        }, 50);
    };
    VScroll.prototype.contains = function (element, className) {
        return element.classList.contains(className);
    };
    VScroll.prototype.eleScrolling = function (scrollDis, trgt, isContinuous) {
        var classList = trgt.classList;
        if (classList.contains(CLS_VSCROLLNAV)) {
            classList = trgt.querySelector('.' + CLS_NAVARROW).classList;
        }
        if (classList.contains(CLS_NAVDOWNARROW)) {
            this.frameScrollRequest(scrollDis, 'add', isContinuous);
        }
        else if (classList.contains(CLS_NAVUPARROW)) {
            this.frameScrollRequest(scrollDis, '', isContinuous);
        }
    };
    VScroll.prototype.clickEventHandler = function (event) {
        this.eleScrolling(this.scrollStep, event.target, false);
    };
    VScroll.prototype.wheelEventHandler = function (e) {
        e.preventDefault();
        this.frameScrollRequest(this.scrollStep, (e.deltaY > 0 ? 'add' : ''), false);
    };
    VScroll.prototype.swipeHandler = function (e) {
        var swipeElement = this.scrollEle;
        var distance;
        if (e.velocity <= 1) {
            distance = e.distanceY / (e.velocity * 10);
        }
        else {
            distance = e.distanceY / e.velocity;
        }
        var start = 0.5;
        var animate = function () {
            var step = Math.sin(start);
            if (step <= 0) {
                window.cancelAnimationFrame(step);
            }
            else {
                if (e.swipeDirection === 'Up') {
                    swipeElement.scrollTop += distance * step;
                }
                else if (e.swipeDirection === 'Down') {
                    swipeElement.scrollTop -= distance * step;
                }
                start -= 0.02;
                window.requestAnimationFrame(animate);
            }
        };
        animate();
    };
    VScroll.prototype.scrollUpdating = function (scrollVal, action) {
        if (action === 'add') {
            this.scrollEle.scrollTop += scrollVal;
        }
        else {
            this.scrollEle.scrollTop -= scrollVal;
        }
    };
    VScroll.prototype.frameScrollRequest = function (scrollValue, action, isContinuous) {
        var _this = this;
        var step = 10;
        if (isContinuous) {
            this.scrollUpdating(scrollValue, action);
            return;
        }
        if (!this.customStep) {
            [].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_OVERLAY, this.element)).forEach(function (el) {
                scrollValue -= el.offsetHeight;
            });
        }
        var animate = function () {
            if (scrollValue < step) {
                window.cancelAnimationFrame(step);
            }
            else {
                _this.scrollUpdating(step, action);
                scrollValue -= step;
                window.requestAnimationFrame(animate);
            }
        };
        animate();
    };
    VScroll.prototype.touchHandler = function (e) {
        var el = this.scrollEle;
        var distance = e.distanceY;
        if (e.scrollDirection === 'Up') {
            el.scrollTop = el.scrollTop + distance;
        }
        else if (e.scrollDirection === 'Down') {
            el.scrollTop = el.scrollTop - distance;
        }
    };
    VScroll.prototype.arrowDisabling = function (addDisableCls, removeDisableCls) {
        if (this.isDevice) {
            var arrowEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(addDisableCls) ? removeDisableCls : addDisableCls;
            var arrowIcon = arrowEle.querySelector('.' + CLS_NAVARROW);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(addDisableCls)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["x" /* classList */])(arrowIcon, [CLS_NAVDOWNARROW], [CLS_NAVUPARROW]);
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["x" /* classList */])(arrowIcon, [CLS_NAVUPARROW], [CLS_NAVDOWNARROW]);
            }
        }
        else {
            addDisableCls.classList.add(CLS_DISABLE);
            addDisableCls.setAttribute('aria-disabled', 'true');
            addDisableCls.removeAttribute('tabindex');
            removeDisableCls.classList.remove(CLS_DISABLE);
            removeDisableCls.setAttribute('aria-disabled', 'false');
            removeDisableCls.setAttribute('tabindex', '0');
        }
        this.repeatScroll();
    };
    VScroll.prototype.scrollEventHandler = function (e) {
        var target = e.target;
        var height = target.offsetHeight;
        var navUpEle = this.element.querySelector('.' + CLS_VSCROLLNAVUP);
        var navDownEle = this.element.querySelector('.' + CLS_VSCROLLNAVDOWN);
        var upOverlay = this.element.querySelector('.' + CLS_UPOVERLAY);
        var downOverlay = this.element.querySelector('.' + CLS_DOWNOVERLAY);
        var scrollTop = target.scrollTop;
        if (scrollTop <= 0) {
            scrollTop = -scrollTop;
        }
        if (this.isDevice) {
            if (scrollTop < OVERLAY_MAXWID) {
                upOverlay.style.height = scrollTop + 'px';
            }
            else {
                upOverlay.style.height = '40px';
            }
            if ((target.scrollHeight - Math.ceil(height + scrollTop)) < OVERLAY_MAXWID) {
                downOverlay.style.height = (target.scrollHeight - Math.ceil(height + scrollTop)) + 'px';
            }
            else {
                downOverlay.style.height = '40px';
            }
        }
        if (scrollTop === 0) {
            this.arrowDisabling(navUpEle, navDownEle);
        }
        else if (Math.ceil(height + scrollTop + .1) >= target.scrollHeight) {
            this.arrowDisabling(navDownEle, navUpEle);
        }
        else {
            var disEle = this.element.querySelector('.' + CLS_VSCROLLNAV + '.' + CLS_DISABLE);
            if (disEle) {
                disEle.classList.remove(CLS_DISABLE);
                disEle.setAttribute('aria-disabled', 'false');
                disEle.setAttribute('tabindex', '0');
            }
        }
    };
    /**
     * Gets called when the model property changes.The data that describes the old and new values of property that changed.
     *
     * @param  {VScrollModel} newProp - It contains the new value of data.
     * @param  {VScrollModel} oldProp - It contains the old value of data.
     * @returns {void}
     * @private
     */
    VScroll.prototype.onPropertyChanged = function (newProp, oldProp) {
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'scrollStep':
                    this.setScrollState();
                    break;
                case 'enableRtl':
                    if (newProp.enableRtl) {
                        this.element.classList.add(CLS_RTL);
                    }
                    else {
                        this.element.classList.remove(CLS_RTL);
                    }
                    break;
            }
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], VScroll.prototype, "scrollStep", void 0);
    VScroll = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], VScroll);
    return VScroll;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FieldSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MenuItem; });
/* unused harmony export MenuAnimationSettings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MenuBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_lists__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_h_scroll__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_v_scroll__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_menu_scroll__ = __webpack_require__(81);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};












var ENTER = 'enter';
var ESCAPE = 'escape';
var FOCUSED = 'e-focused';
var HEADER = 'e-menu-header';
var SELECTED = 'e-selected';
var SEPARATOR = 'e-separator';
var UPARROW = 'uparrow';
var DOWNARROW = 'downarrow';
var LEFTARROW = 'leftarrow';
var RIGHTARROW = 'rightarrow';
var HOME = 'home';
var END = 'end';
var TAB = 'tab';
var CARET = 'e-caret';
var ITEM = 'e-menu-item';
var DISABLED = 'e-disabled';
var HIDE = 'e-menu-hide';
var ICONS = 'e-icons';
var RTL = 'e-rtl';
var POPUP = 'e-menu-popup';
var TEMPLATE_PROPERTY = 'Template';
/**
 * Configures the field options of the Menu.
 */
var FieldSettings = /** @class */ (function (_super) {
    __extends(FieldSettings, _super);
    function FieldSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('id')
    ], FieldSettings.prototype, "itemId", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('parentId')
    ], FieldSettings.prototype, "parentId", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('text')
    ], FieldSettings.prototype, "text", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('iconCss')
    ], FieldSettings.prototype, "iconCss", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('url')
    ], FieldSettings.prototype, "url", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('separator')
    ], FieldSettings.prototype, "separator", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('items')
    ], FieldSettings.prototype, "children", void 0);
    return FieldSettings;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * Specifies menu items.
 */
var MenuItem = /** @class */ (function (_super) {
    __extends(MenuItem, _super);
    function MenuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], MenuItem.prototype, "iconCss", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], MenuItem.prototype, "id", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], MenuItem.prototype, "separator", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["f" /* Collection */])([], MenuItem)
    ], MenuItem.prototype, "items", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], MenuItem.prototype, "text", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], MenuItem.prototype, "url", void 0);
    return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * Animation configuration settings.
 */
var MenuAnimationSettings = /** @class */ (function (_super) {
    __extends(MenuAnimationSettings, _super);
    function MenuAnimationSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('SlideDown')
    ], MenuAnimationSettings.prototype, "effect", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(400)
    ], MenuAnimationSettings.prototype, "duration", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('ease')
    ], MenuAnimationSettings.prototype, "easing", void 0);
    return MenuAnimationSettings;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * Base class for Menu and ContextMenu components.
 *
 *  @private
 */
var MenuBase = /** @class */ (function (_super) {
    __extends(MenuBase, _super);
    /**
     * Constructor for creating the widget.
     *
     * @private
     * @param {MenuBaseModel} options - Specifies the menu base model
     * @param {string | HTMLUListElement} element - Specifies the element
     */
    function MenuBase(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.navIdx = [];
        _this.animation = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["b" /* Animation */]({});
        _this.isTapHold = false;
        _this.tempItem = [];
        _this.showSubMenuOn = 'Auto';
        return _this;
    }
    /**
     * Initialized third party configuration settings.
     *
     * @private
     * @returns {void}
     */
    MenuBase.prototype.preRender = function () {
        if (!this.isMenu) {
            var ul = void 0;
            if (this.element.tagName === 'EJS-CONTEXTMENU') {
                ul = this.createElement('ul', {
                    id: Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])(this.getModuleName()), className: 'e-control e-lib e-' + this.getModuleName()
                });
                var ejInst = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('ej2_instances', this.element);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], ['e-control', 'e-lib', 'e-' + this.getModuleName()]);
                this.clonedElement = this.element;
                this.element = ul;
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])('ej2_instances', ejInst, this.element);
            }
            else {
                ul = this.createElement('ul', { id: Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])(this.getModuleName()) });
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])([].slice.call(this.element.cloneNode(true).children), ul);
                var refEle = this.element.nextElementSibling;
                if (refEle) {
                    this.element.parentElement.insertBefore(ul, refEle);
                }
                else {
                    this.element.parentElement.appendChild(ul);
                }
                this.clonedElement = ul;
            }
            this.clonedElement.style.display = 'none';
        }
        if (this.element.tagName === 'EJS-MENU') {
            var ele = this.element;
            var ejInstance = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('ej2_instances', ele);
            var ul = this.createElement('ul');
            var wrapper = this.createElement('EJS-MENU', { className: 'e-' + this.getModuleName() + '-wrapper' });
            for (var idx = 0, len = ele.attributes.length; idx < len; idx++) {
                ul.setAttribute(ele.attributes[idx].nodeName, ele.attributes[idx].nodeValue);
            }
            ele.parentNode.insertBefore(wrapper, ele);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(ele);
            ele = ul;
            wrapper.appendChild(ele);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])('ej2_instances', ejInstance, ele);
            this.clonedElement = wrapper;
            this.element = ele;
            if (!this.element.id) {
                this.element.id = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])(this.getModuleName());
            }
        }
    };
    /**
     * Initialize the control rendering.
     *
     * @private
     * @returns {void}
     */
    MenuBase.prototype.render = function () {
        var _this = this;
        this.initialize();
        this.renderItems();
        this.wireEvents();
        this.renderComplete();
        var wrapper = this.getWrapper();
        if (this.template && this.enableScrolling && (this.isReact || this.isAngular)) {
            requestAnimationFrame(function () {
                Object(__WEBPACK_IMPORTED_MODULE_5__common_menu_scroll__["a" /* addScrolling */])(_this.createElement, wrapper, _this.element, 'hscroll', _this.enableRtl);
            });
        }
    };
    MenuBase.prototype.initialize = function () {
        var wrapper = this.getWrapper();
        if (!wrapper) {
            wrapper = this.createElement('div', { className: 'e-' + this.getModuleName() + '-wrapper' });
            if (this.isMenu) {
                this.element.parentElement.insertBefore(wrapper, this.element);
            }
            else {
                document.body.appendChild(wrapper);
            }
        }
        if (this.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([wrapper], this.cssClass.split(' '));
        }
        if (this.enableRtl) {
            wrapper.classList.add(RTL);
        }
        wrapper.appendChild(this.element);
        if (this.isMenu && this.hamburgerMode) {
            if (!this.target) {
                this.createHeaderContainer(wrapper);
            }
        }
        this.defaultOption = this.showItemOnClick;
    };
    MenuBase.prototype.renderItems = function () {
        if (!this.items.length) {
            var items = __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_lists__["a" /* ListBase */].createJsonFromElement(this.element, { fields: { child: 'items' } });
            this.setProperties({ items: items }, true);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["P" /* isBlazor */])() && !this.isMenu) {
                this.element = this.removeChildElement(this.element);
            }
            else {
                this.element.innerHTML = '';
            }
        }
        var ul = this.createItems(this.items);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(Array.prototype.slice.call(ul.children), this.element);
        this.element.classList.add('e-menu-parent');
        if (this.isMenu) {
            if (!this.hamburgerMode && this.element.classList.contains('e-vertical')) {
                this.setBlankIconStyle(this.element);
            }
            if (this.enableScrolling) {
                var wrapper = this.getWrapper();
                if (this.element.classList.contains('e-vertical')) {
                    Object(__WEBPACK_IMPORTED_MODULE_5__common_menu_scroll__["a" /* addScrolling */])(this.createElement, wrapper, this.element, 'vscroll', this.enableRtl);
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_5__common_menu_scroll__["a" /* addScrolling */])(this.createElement, wrapper, this.element, 'hscroll', this.enableRtl);
                }
            }
        }
    };
    MenuBase.prototype.wireEvents = function () {
        var wrapper = this.getWrapper();
        if (this.target) {
            var target = void 0;
            var targetElems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])(this.target);
            for (var i = 0, len = targetElems.length; i < len; i++) {
                target = targetElems[i];
                if (this.isMenu) {
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(target, 'click', this.menuHeaderClickHandler, this);
                }
                else {
                    if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isIos) {
                        new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["t" /* Touch */](target, { tapHold: this.touchHandler.bind(this) });
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(target, 'contextmenu', this.cmenuHandler, this);
                    }
                }
            }
            this.targetElement = target;
            if (!this.isMenu) {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.targetElement, 'scroll', this.scrollHandler, this);
                for (var _i = 0, _a = Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["f" /* getScrollableParent */])(this.targetElement); _i < _a.length; _i++) {
                    var parent_1 = _a[_i];
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(parent_1, 'scroll', this.scrollHandler, this);
                }
            }
        }
        if (!__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
            this.delegateMoverHandler = this.moverHandler.bind(this);
            this.delegateMouseDownHandler = this.mouseDownHandler.bind(this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.isMenu ? document : wrapper, 'mouseover', this.delegateMoverHandler, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'mousedown', this.delegateMouseDownHandler, this);
        }
        this.delegateClickHandler = this.clickHandler.bind(this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'click', this.delegateClickHandler, this);
        this.wireKeyboardEvent(wrapper);
        this.rippleFn = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_0" /* rippleEffect */])(wrapper, { selector: '.' + ITEM });
    };
    MenuBase.prototype.wireKeyboardEvent = function (element) {
        var keyConfigs = {
            downarrow: DOWNARROW,
            uparrow: UPARROW,
            enter: ENTER,
            leftarrow: LEFTARROW,
            rightarrow: RIGHTARROW,
            escape: ESCAPE
        };
        if (this.isMenu) {
            keyConfigs.home = HOME;
            keyConfigs.end = END;
            keyConfigs.tab = TAB;
        }
        new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["n" /* KeyboardEvents */](element, {
            keyAction: this.keyBoardHandler.bind(this),
            keyConfigs: keyConfigs
        });
    };
    MenuBase.prototype.mouseDownHandler = function (e) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.e-' + this.getModuleName() + '-wrapper') !== this.getWrapper()
            && (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.e-' + this.getModuleName() + '-popup'))) {
            this.closeMenu(this.isMenu ? null : this.navIdx.length, e);
        }
    };
    MenuBase.prototype.keyBoardHandler = function (e) {
        var actionName = '';
        var trgt = e.target;
        var actionNeeded = this.isMenu && !this.hamburgerMode && !this.element.classList.contains('e-vertical')
            && this.navIdx.length < 1;
        e.preventDefault();
        if (this.enableScrolling && e.keyCode === 13 && trgt.classList.contains('e-scroll-nav')) {
            this.removeLIStateByClass([FOCUSED, SELECTED], [Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '.e-' + this.getModuleName() + '-wrapper')]);
        }
        if (actionNeeded) {
            switch (e.action) {
                case RIGHTARROW:
                    actionName = RIGHTARROW;
                    e.action = DOWNARROW;
                    break;
                case LEFTARROW:
                    actionName = LEFTARROW;
                    e.action = UPARROW;
                    break;
                case DOWNARROW:
                    actionName = DOWNARROW;
                    e.action = RIGHTARROW;
                    break;
                case UPARROW:
                    actionName = UPARROW;
                    e.action = '';
                    break;
            }
        }
        else if (this.enableRtl) {
            switch (e.action) {
                case LEFTARROW:
                    actionNeeded = true;
                    actionName = LEFTARROW;
                    e.action = RIGHTARROW;
                    break;
                case RIGHTARROW:
                    actionNeeded = true;
                    actionName = RIGHTARROW;
                    e.action = LEFTARROW;
                    break;
            }
        }
        switch (e.action) {
            case DOWNARROW:
            case UPARROW:
            case END:
            case HOME:
            case TAB:
                this.upDownKeyHandler(e);
                break;
            case RIGHTARROW:
                this.rightEnterKeyHandler(e);
                break;
            case LEFTARROW:
                this.leftEscKeyHandler(e);
                break;
            case ENTER:
                if (this.hamburgerMode && trgt.tagName === 'SPAN' && trgt.classList.contains('e-menu-icon')) {
                    this.menuHeaderClickHandler(e);
                }
                else {
                    this.rightEnterKeyHandler(e);
                }
                break;
            case ESCAPE:
                this.leftEscKeyHandler(e);
                break;
        }
        if (actionNeeded) {
            e.action = actionName;
        }
    };
    MenuBase.prototype.upDownKeyHandler = function (e) {
        var cul = this.getUlByNavIdx();
        var defaultIdx = (e.action === DOWNARROW || e.action === HOME || e.action === TAB) ? 0 : cul.childElementCount - 1;
        var fliIdx = defaultIdx;
        var fli = this.getLIByClass(cul, FOCUSED);
        if (fli) {
            if (e.action !== END && e.action !== HOME) {
                fliIdx = this.getIdx(cul, fli);
            }
            fli.classList.remove(FOCUSED);
            if (e.action !== END && e.action !== HOME) {
                if (e.action === DOWNARROW) {
                    fliIdx++;
                }
                else {
                    fliIdx--;
                }
                if (fliIdx === (e.action === DOWNARROW ? cul.childElementCount : -1)) {
                    fliIdx = defaultIdx;
                }
            }
        }
        var cli = cul.children[fliIdx];
        fliIdx = this.isValidLI(cli, fliIdx, e.action);
        cul.children[fliIdx].classList.add(FOCUSED);
        cul.children[fliIdx].focus();
    };
    MenuBase.prototype.isValidLI = function (cli, index, action) {
        var cul = this.getUlByNavIdx();
        if (cli.classList.contains(SEPARATOR) || cli.classList.contains(DISABLED) || cli.classList.contains(HIDE)) {
            if ((action === DOWNARROW) || (action === RIGHTARROW)) {
                index++;
            }
            else {
                index--;
            }
        }
        cli = cul.children[index];
        if (cli.classList.contains(SEPARATOR) || cli.classList.contains(DISABLED) || cli.classList.contains(HIDE)) {
            index = this.isValidLI(cli, index, action);
        }
        return index;
    };
    MenuBase.prototype.getUlByNavIdx = function (navIdxLen) {
        if (navIdxLen === void 0) { navIdxLen = this.navIdx.length; }
        if (this.isMenu) {
            var popup = [this.getWrapper()].concat([].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + POPUP)))[navIdxLen];
            return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(popup) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-menu-parent', popup);
        }
        else {
            return this.getWrapper().children[navIdxLen];
        }
    };
    MenuBase.prototype.rightEnterKeyHandler = function (e) {
        var eventArgs;
        var cul = this.getUlByNavIdx();
        var fli = this.getLIByClass(cul, FOCUSED);
        if (fli) {
            var fliIdx = this.getIdx(cul, fli);
            var navIdx = this.navIdx.concat(fliIdx);
            var item = this.getItem(navIdx);
            if (item.items.length) {
                this.navIdx.push(fliIdx);
                this.keyType = 'right';
                this.action = e.action;
                this.openMenu(fli, item, -1, -1, e);
            }
            else {
                if (e.action === ENTER) {
                    if (this.isMenu && this.navIdx.length === 0) {
                        this.removeLIStateByClass([SELECTED], [this.getWrapper()]);
                    }
                    else {
                        fli.classList.remove(FOCUSED);
                    }
                    fli.classList.add(SELECTED);
                    eventArgs = { element: fli, item: item, event: e };
                    this.trigger('select', eventArgs);
                    this.closeMenu(null, e);
                }
            }
        }
    };
    MenuBase.prototype.leftEscKeyHandler = function (e) {
        if (this.navIdx.length) {
            this.keyType = 'left';
            this.closeMenu(this.navIdx.length, e);
        }
        else {
            if (e.action === ESCAPE) {
                this.closeMenu(null, e);
            }
        }
    };
    MenuBase.prototype.scrollHandler = function (e) {
        this.closeMenu(null, e);
    };
    MenuBase.prototype.touchHandler = function (e) {
        this.isTapHold = true;
        this.cmenuHandler(e.originalEvent);
    };
    MenuBase.prototype.cmenuHandler = function (e) {
        e.preventDefault();
        this.isCMenu = true;
        this.pageX = e.changedTouches ? e.changedTouches[0].pageX + 1 : e.pageX + 1;
        this.pageY = e.changedTouches ? e.changedTouches[0].pageY + 1 : e.pageY + 1;
        this.closeMenu(null, e);
        if (this.isCMenu) {
            if (this.canOpen(e.target)) {
                this.openMenu(null, null, this.pageY, this.pageX, e);
            }
            this.isCMenu = false;
        }
    };
    // eslint:disable-next-line:max-func-body-length
    MenuBase.prototype.closeMenu = function (ulIndex, e, isIterated) {
        var _this = this;
        if (ulIndex === void 0) { ulIndex = 0; }
        if (e === void 0) { e = null; }
        if (this.isMenuVisible()) {
            var sli = void 0;
            var item_1;
            var wrapper_1 = this.getWrapper();
            var beforeCloseArgs = void 0;
            var items_1;
            var popups = this.getPopups();
            var isClose = false;
            var cnt = this.isMenu ? popups.length + 1 : wrapper_1.childElementCount;
            var ul_1 = this.isMenu && cnt !== 1 ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-ul', popups[cnt - 2])
                : Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.e-menu-parent', wrapper_1)[cnt - 1];
            if (this.isMenu && ul_1.classList.contains('e-menu')) {
                sli = this.getLIByClass(ul_1, SELECTED);
                if (sli) {
                    sli.classList.remove(SELECTED);
                }
                isClose = true;
            }
            if (!isClose) {
                var liElem_1 = e && e.target && this.getLI(e.target);
                if (liElem_1) {
                    this.cli = liElem_1;
                }
                else {
                    this.cli = ul_1.children[0];
                }
                item_1 = this.navIdx.length ? this.getItem(this.navIdx) : null;
                items_1 = item_1 ? item_1.items : this.items;
                beforeCloseArgs = { element: ul_1, parentItem: item_1, items: items_1, event: e, cancel: false, isFocused: true };
                this.trigger('beforeClose', beforeCloseArgs, function (observedCloseArgs) {
                    var popupEle;
                    var closeArgs;
                    var popupId = '';
                    var popupObj;
                    var isOpen = !observedCloseArgs.cancel;
                    if (isOpen || _this.isCMenu) {
                        if (_this.isMenu) {
                            popupEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(ul_1, '.' + POPUP);
                            if (_this.hamburgerMode) {
                                popupEle.parentElement.style.minHeight = '';
                                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(ul_1, '.e-menu-item').setAttribute('aria-expanded', 'false');
                            }
                            _this.unWireKeyboardEvent(popupEle);
                            Object(__WEBPACK_IMPORTED_MODULE_5__common_menu_scroll__["b" /* destroyScroll */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(popupEle.children[0], __WEBPACK_IMPORTED_MODULE_4__common_v_scroll__["a" /* VScroll */]), popupEle.children[0]);
                            popupObj = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(popupEle, __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["a" /* Popup */]);
                            popupObj.hide();
                            popupId = popupEle.id;
                            popupObj.destroy();
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(popupEle);
                        }
                        else {
                            _this.toggleAnimation(ul_1, false);
                        }
                        closeArgs = { element: ul_1, parentItem: item_1, items: items_1 };
                        _this.trigger('onClose', closeArgs);
                        _this.navIdx.pop();
                    }
                    _this.updateReactTemplate();
                    var trgtliId;
                    var closedLi;
                    var trgtLi;
                    var trgtpopUp = _this.getWrapper() && _this.getUlByNavIdx();
                    if (_this.isCMenu) {
                        if (_this.canOpen(e.target)) {
                            _this.openMenu(null, null, _this.pageY, _this.pageX, e);
                        }
                        _this.isCMenu = false;
                    }
                    if (_this.isMenu && trgtpopUp && popupId.length) {
                        trgtliId = new RegExp('(.*)-ej2menu-' + _this.element.id + '-popup').exec(popupId)[1];
                        closedLi = trgtpopUp.querySelector('[id="' + trgtliId + '"]');
                        trgtLi = (liElem_1 && trgtpopUp.querySelector('[id="' + liElem_1.id + '"]'));
                    }
                    var submenus = liElem_1 && liElem_1.querySelectorAll('.e-menu-item');
                    if (isOpen && _this.hamburgerMode && ulIndex && !(submenus.length)) {
                        _this.afterCloseMenu(e);
                    }
                    else if (isOpen && !_this.hamburgerMode && _this.navIdx.length && closedLi && !trgtLi && _this.keyType !== "left") {
                        var ele = (e && e.target.classList.contains('e-vscroll'))
                            ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.e-menu-wrapper') : null;
                        if (ele) {
                            ele = ele.querySelector('.e-menu-item');
                            if (_this.showItemOnClick || (ele && _this.getIndex(ele.id, true).length <= _this.navIdx.length)) {
                                _this.closeMenu(_this.navIdx[_this.navIdx.length - 1], e, true);
                            }
                        }
                        else {
                            _this.closeMenu(_this.navIdx[_this.navIdx.length - 1], e);
                        }
                    }
                    else if (isOpen && !isIterated && !ulIndex && ((_this.hamburgerMode && _this.navIdx.length) ||
                        _this.navIdx.length === 1)) {
                        _this.closeMenu(null, e);
                    }
                    else if (isOpen && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ulIndex) && _this.navIdx.length) {
                        _this.closeMenu(null, e);
                    }
                    else if (isOpen && !_this.isMenu && !ulIndex && _this.navIdx.length === 0 && !_this.isMenusClosed) {
                        _this.isMenusClosed = true;
                        _this.closeMenu(0, e);
                    }
                    else if (isOpen && _this.isMenu && e && e.target &&
                        _this.navIdx.length !== 0 && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.e-menu-parent.e-control')) {
                        _this.closeMenu(0, e);
                    }
                    else if (isOpen && !_this.isMenu && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.e-menu-parent', wrapper_1)[ulIndex - 1] && e.which === 3) {
                        _this.closeMenu(null, e);
                    }
                    else {
                        if (isOpen && (_this.keyType === 'right' || _this.keyType === 'click')) {
                            _this.afterCloseMenu(e);
                        }
                        else {
                            var cul = _this.getUlByNavIdx();
                            var sli_1 = _this.getLIByClass(cul, SELECTED);
                            if (sli_1) {
                                sli_1.setAttribute('aria-expanded', 'false');
                                sli_1.classList.remove(SELECTED);
                                if (observedCloseArgs.isFocused && liElem_1 || _this.keyType === "left") {
                                    sli_1.classList.add(FOCUSED);
                                    sli_1.focus();
                                }
                            }
                            if (!isOpen && _this.hamburgerMode && liElem_1 && liElem_1.getAttribute('aria-expanded') === 'false' &&
                                liElem_1.getAttribute('aria-haspopup') === 'true') {
                                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(liElem_1, '.e-menu-parent.e-control')) {
                                    _this.navIdx = [];
                                }
                                else {
                                    _this.navIdx.pop();
                                }
                                _this.navIdx.push(_this.cliIdx);
                                var item_2 = _this.getItem(_this.navIdx);
                                liElem_1.setAttribute('aria-expanded', 'true');
                                _this.openMenu(liElem_1, item_2, -1, -1, e);
                            }
                        }
                        if (_this.navIdx.length < 1) {
                            if (_this.showSubMenuOn === 'Hover' || _this.showSubMenuOn === 'Click') {
                                _this.showItemOnClick = _this.defaultOption;
                                _this.showSubMenuOn = 'Auto';
                            }
                        }
                    }
                    _this.removeStateWrapper();
                });
            }
        }
    };
    MenuBase.prototype.updateReactTemplate = function () {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.isReact && this.template && this.navIdx.length === 0) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var portals = this.portals.splice(0, this.items.length);
            this.clearTemplate(['template']);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.portals = portals;
            this.renderReactTemplates();
        }
    };
    MenuBase.prototype.getMenuItemModel = function (item, level) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item)) {
            return null;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(level)) {
            level = 0;
        }
        var fields = this.getFields(level);
        return { text: item[fields.text], id: item[fields.id], items: item[fields.child], separator: item[fields.separator],
            iconCss: item[fields.iconCss], url: item[fields.url] };
    };
    MenuBase.prototype.getPopups = function () {
        var _this = this;
        var popups = [];
        [].slice.call(document.querySelectorAll('.' + POPUP)).forEach(function (elem) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(elem.querySelector('.' + ITEM)) && _this.getIndex(elem.querySelector('.' + ITEM).id, true).length) {
                popups.push(elem);
            }
        });
        return popups;
    };
    MenuBase.prototype.isMenuVisible = function () {
        return (this.navIdx.length > 0 || (this.element.classList.contains('e-contextmenu') && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(this.element).valueOf()));
    };
    MenuBase.prototype.canOpen = function (target) {
        var canOpen = true;
        if (this.filter) {
            canOpen = false;
            var filter = this.filter.split(' ');
            for (var i = 0, len = filter.length; i < len; i++) {
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(target, '.' + filter[i])) {
                    canOpen = true;
                    break;
                }
            }
        }
        return canOpen;
    };
    MenuBase.prototype.openMenu = function (li, item, top, left, e, target) {
        var _this = this;
        if (top === void 0) { top = 0; }
        if (left === void 0) { left = 0; }
        if (e === void 0) { e = null; }
        if (target === void 0) { target = this.targetElement; }
        var wrapper = this.getWrapper();
        this.lItem = li;
        var elemId = this.element.id !== '' ? this.element.id : 'menu';
        this.isMenusClosed = false;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(top)) {
            top = -1;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(left)) {
            left = -1;
        }
        if (li) {
            this.uList = this.createItems(item[this.getField('children', this.navIdx.length - 1)]);
            if (!this.isMenu && __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
                wrapper.lastChild.style.display = 'none';
                var data = {
                    text: item[this.getField('text')].toString(), iconCss: ICONS + ' e-previous'
                };
                var hdata = new MenuItem(this.items[0], 'items', data, true);
                var hli = this.createItems([hdata]).children[0];
                hli.classList.add(HEADER);
                this.uList.insertBefore(hli, this.uList.children[0]);
            }
            if (this.isMenu) {
                this.popupWrapper = this.createElement('div', {
                    className: 'e-' + this.getModuleName() + '-wrapper ' + POPUP, id: li.id + '-ej2menu-' + elemId + '-popup'
                });
                if (this.hamburgerMode) {
                    top = li.offsetHeight;
                    li.appendChild(this.popupWrapper);
                }
                else {
                    document.body.appendChild(this.popupWrapper);
                }
                this.isNestedOrVertical = this.element.classList.contains('e-vertical') || this.navIdx.length !== 1;
                this.popupObj = this.generatePopup(this.popupWrapper, this.uList, li, this.isNestedOrVertical);
                if (this.template) {
                    this.renderReactTemplates();
                }
                if (this.hamburgerMode) {
                    this.calculateIndentSize(this.uList, li);
                }
                else {
                    if (this.cssClass) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.popupWrapper], this.cssClass.split(' '));
                    }
                    this.popupObj.hide();
                }
                if (!this.hamburgerMode && !this.showItemOnClick && this.hoverDelay) {
                    window.clearInterval(this.timer);
                    this.timer = window.setTimeout(function () { _this.triggerBeforeOpen(li, _this.uList, item, e, 0, 0, 'menu'); }, this.hoverDelay);
                }
                else {
                    this.triggerBeforeOpen(li, this.uList, item, e, 0, 0, 'menu');
                }
            }
            else {
                this.uList.style.zIndex = this.element.style.zIndex;
                wrapper.appendChild(this.uList);
                if (!this.showItemOnClick && this.hoverDelay) {
                    window.clearInterval(this.timer);
                    this.timer = window.setTimeout(function () { _this.triggerBeforeOpen(li, _this.uList, item, e, top, left, 'none'); }, this.hoverDelay);
                }
                else {
                    this.triggerBeforeOpen(li, this.uList, item, e, top, left, 'none');
                }
            }
        }
        else {
            this.uList = this.element;
            this.uList.style.zIndex = Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["g" /* getZindexPartial */])(target ? target : this.element).toString();
            this.triggerBeforeOpen(li, this.uList, item, e, top, left, 'none');
        }
    };
    MenuBase.prototype.calculateIndentSize = function (ul, li) {
        var liStyle = getComputedStyle(li);
        var liIndent = parseInt(liStyle.textIndent, 10);
        if (this.navIdx.length < 2 && !li.classList.contains('e-blankicon')) {
            liIndent *= 2;
        }
        else {
            liIndent += (liIndent / 4);
        }
        ul.style.textIndent = liIndent + 'px';
        var blankIconElem = ul.querySelectorAll('.e-blankicon');
        if (blankIconElem && blankIconElem.length) {
            var menuIconElem = ul.querySelector('.e-menu-icon');
            var menuIconElemStyle = getComputedStyle(menuIconElem);
            var blankIconIndent = (parseInt(menuIconElemStyle.marginRight, 10) + menuIconElem.offsetWidth + liIndent);
            for (var i = 0; i < blankIconElem.length; i++) {
                blankIconElem[i].style.textIndent = blankIconIndent + 'px';
            }
        }
    };
    MenuBase.prototype.generatePopup = function (popupWrapper, ul, li, isNestedOrVertical) {
        var _this = this;
        var popupObj = new __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["a" /* Popup */](popupWrapper, {
            actionOnScroll: this.hamburgerMode ? 'none' : 'reposition',
            relateTo: li,
            collision: this.hamburgerMode ? { X: 'none', Y: 'none' } : { X: isNestedOrVertical ||
                    this.enableRtl ? 'none' : 'flip', Y: 'fit' },
            position: (isNestedOrVertical && !this.hamburgerMode) ? { X: 'right', Y: 'top' } : { X: 'left', Y: 'bottom' },
            targetType: 'relative',
            enableRtl: this.enableRtl,
            content: ul,
            open: function () {
                var scrollEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-menu-vscroll', popupObj.element);
                if (scrollEle) {
                    scrollEle.style.height = 'inherit';
                    scrollEle.style.maxHeight = '';
                }
                var ul = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-ul', popupObj.element);
                popupObj.element.style.maxHeight = '';
                ul.focus();
                _this.triggerOpen(ul);
            }
        });
        return popupObj;
    };
    MenuBase.prototype.createHeaderContainer = function (wrapper) {
        wrapper = wrapper || this.getWrapper();
        var spanElem = this.createElement('span', { className: 'e-' + this.getModuleName() + '-header' });
        var tempTitle = (this.enableHtmlSanitizer) ? __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(this.title) : this.title;
        var spanTitle = this.createElement('span', {
            className: 'e-' + this.getModuleName() + '-title', innerHTML: tempTitle
        });
        var spanIcon = this.createElement('span', {
            className: 'e-icons e-' + this.getModuleName() + '-icon', attrs: { 'tabindex': '0' }
        });
        spanElem.appendChild(spanTitle);
        spanElem.appendChild(spanIcon);
        wrapper.insertBefore(spanElem, this.element);
    };
    MenuBase.prototype.openHamburgerMenu = function (e) {
        if (this.hamburgerMode) {
            this.triggerBeforeOpen(null, this.element, null, e, 0, 0, 'hamburger');
        }
    };
    MenuBase.prototype.closeHamburgerMenu = function (e) {
        var _this = this;
        var beforeCloseArgs = { element: this.element, parentItem: null, event: e,
            items: this.items, cancel: false };
        this.trigger('beforeClose', beforeCloseArgs, function (observedHamburgerCloseArgs) {
            if (!observedHamburgerCloseArgs.cancel) {
                _this.closeMenu(null, e);
                _this.element.classList.add('e-hide-menu');
                _this.trigger('onClose', { element: _this.element, parentItem: null, items: _this.items });
            }
        });
    };
    MenuBase.prototype.callFit = function (element, x, y, top, left) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["e" /* fit */])(element, null, { X: x, Y: y }, { top: top, left: left });
    };
    MenuBase.prototype.triggerBeforeOpen = function (li, ul, item, e, top, left, type) {
        var _this = this;
        var items = li ? item[this.getField('children', this.navIdx.length - 1)] : this.items;
        var eventArgs = {
            element: ul, items: items, parentItem: item, event: e, cancel: false, top: top, left: left, showSubMenuOn: 'Auto'
        };
        var menuType = type;
        this.trigger('beforeOpen', eventArgs, function (observedOpenArgs) {
            switch (menuType) {
                case 'menu':
                    if (!_this.hamburgerMode) {
                        if (observedOpenArgs.showSubMenuOn !== 'Auto') {
                            _this.showItemOnClick = !_this.defaultOption;
                            _this.showSubMenuOn = observedOpenArgs.showSubMenuOn;
                        }
                        _this.top = observedOpenArgs.top;
                        _this.left = observedOpenArgs.left;
                    }
                    _this.popupWrapper.style.display = 'block';
                    if (!_this.hamburgerMode) {
                        _this.popupWrapper.style.maxHeight = _this.popupWrapper.getBoundingClientRect().height + 'px';
                        if (_this.enableScrolling) {
                            Object(__WEBPACK_IMPORTED_MODULE_5__common_menu_scroll__["a" /* addScrolling */])(_this.createElement, _this.popupWrapper, _this.uList, 'vscroll', _this.enableRtl);
                        }
                        _this.checkScrollOffset(e);
                    }
                    if (!_this.hamburgerMode && !_this.left && !_this.top) {
                        _this.popupObj.refreshPosition(_this.lItem, true);
                        _this.left = parseInt(_this.popupWrapper.style.left, 10);
                        _this.top = parseInt(_this.popupWrapper.style.top, 10);
                        if (_this.enableRtl) {
                            _this.left =
                                _this.isNestedOrVertical ? _this.left - _this.popupWrapper.offsetWidth - _this.lItem.parentElement.offsetWidth + 2
                                    : _this.left - _this.popupWrapper.offsetWidth + _this.lItem.offsetWidth;
                        }
                        if (_this.template && (_this.isReact || _this.isAngular)) {
                            requestAnimationFrame(function () {
                                _this.collision();
                                _this.popupWrapper.style.display = '';
                            });
                        }
                        else {
                            _this.collision();
                            _this.popupWrapper.style.display = '';
                        }
                    }
                    else {
                        _this.popupObj.collision = { X: 'none', Y: 'none' };
                        _this.popupWrapper.style.display = '';
                    }
                    break;
                case 'none':
                    _this.top = observedOpenArgs.top;
                    _this.left = observedOpenArgs.left;
                    break;
                case 'hamburger':
                    if (!observedOpenArgs.cancel) {
                        _this.element.classList.remove('e-hide-menu');
                        _this.triggerOpen(_this.element);
                    }
                    break;
            }
            if (menuType !== 'hamburger') {
                if (observedOpenArgs.cancel) {
                    if (_this.isMenu) {
                        _this.popupObj.destroy();
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(_this.popupWrapper);
                    }
                    else if (ul.className.indexOf('e-ul') > -1) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(ul);
                    }
                    _this.navIdx.pop();
                }
                else {
                    if (_this.isMenu) {
                        if (_this.hamburgerMode) {
                            _this.popupWrapper.style.top = _this.top + 'px';
                            _this.popupWrapper.style.left = 0 + 'px';
                            _this.toggleAnimation(_this.popupWrapper);
                        }
                        else {
                            _this.setBlankIconStyle(_this.popupWrapper);
                            _this.wireKeyboardEvent(_this.popupWrapper);
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_0" /* rippleEffect */])(_this.popupWrapper, { selector: '.' + ITEM });
                            _this.popupWrapper.style.left = _this.left + 'px';
                            _this.popupWrapper.style.top = _this.top + 'px';
                            var animationOptions = _this.animationSettings.effect !== 'None' ? {
                                name: _this.animationSettings.effect, duration: _this.animationSettings.duration,
                                timingFunction: _this.animationSettings.easing
                            } : null;
                            _this.popupObj.show(animationOptions, _this.lItem);
                        }
                    }
                    else {
                        _this.setBlankIconStyle(_this.uList);
                        _this.setPosition(_this.lItem, _this.uList, _this.top, _this.left);
                        _this.toggleAnimation(_this.uList);
                    }
                }
            }
            if (_this.keyType === 'right') {
                var cul = _this.getUlByNavIdx();
                li.classList.remove(FOCUSED);
                if (_this.isMenu && _this.navIdx.length === 1) {
                    _this.removeLIStateByClass([SELECTED], [_this.getWrapper()]);
                }
                li.classList.add(SELECTED);
                if (_this.action === ENTER) {
                    var eventArgs_1 = { element: li, item: item, event: e };
                    _this.trigger('select', eventArgs_1);
                }
                li.focus();
                cul = _this.getUlByNavIdx();
                var index = _this.isValidLI(cul.children[0], 0, _this.action);
                cul.children[index].classList.add(FOCUSED);
                cul.children[index].focus();
            }
        });
    };
    MenuBase.prototype.collision = function () {
        var collide;
        collide = Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["i" /* isCollide */])(this.popupWrapper, null, this.left, this.top);
        if ((this.isNestedOrVertical || this.enableRtl) && (collide.indexOf('right') > -1
            || collide.indexOf('left') > -1)) {
            this.popupObj.collision.X = 'none';
            var offWidth = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.lItem, '.e-' + this.getModuleName() + '-wrapper').offsetWidth;
            this.left =
                this.enableRtl ? Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["c" /* calculatePosition */])(this.lItem, this.isNestedOrVertical ? 'right' : 'left', 'top').left
                    : this.left - this.popupWrapper.offsetWidth - offWidth + 2;
        }
        collide = Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["i" /* isCollide */])(this.popupWrapper, null, this.left, this.top);
        if (collide.indexOf('left') > -1 || collide.indexOf('right') > -1) {
            this.left = this.callFit(this.popupWrapper, true, false, this.top, this.left).left;
        }
        this.popupWrapper.style.left = this.left + 'px';
    };
    MenuBase.prototype.setBlankIconStyle = function (menu) {
        var blankIconList = [].slice.call(menu.getElementsByClassName('e-blankicon'));
        if (!blankIconList.length) {
            return;
        }
        var iconLi = menu.querySelector('.e-menu-item:not(.e-blankicon):not(.e-separator)');
        var icon = iconLi.querySelector('.e-menu-icon');
        if (!icon) {
            return;
        }
        var cssProp = this.enableRtl ? { padding: 'paddingRight', margin: 'marginLeft' } :
            { padding: 'paddingLeft', margin: 'marginRight' };
        var iconCssProps = getComputedStyle(icon);
        var iconSize = parseInt(iconCssProps.fontSize, 10);
        if (!!parseInt(iconCssProps.width, 10) && parseInt(iconCssProps.width, 10) > iconSize) {
            iconSize = parseInt(iconCssProps.width, 10);
        }
        // eslint:disable
        var size = iconSize + parseInt(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        iconCssProps[cssProp.margin], 10) + parseInt(getComputedStyle(iconLi)[cssProp.padding], 10) + "px";
        blankIconList.forEach(function (li) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            li.style[cssProp.padding] = size;
        });
        // eslint:enable
    };
    MenuBase.prototype.checkScrollOffset = function (e) {
        var wrapper = this.getWrapper();
        if (wrapper.children[0].classList.contains('e-menu-hscroll') && this.navIdx.length === 1) {
            var trgt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e) ? this.element : Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.' + ITEM);
            var offsetEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-hscroll-bar', wrapper);
            if (offsetEle.scrollLeft > trgt.offsetLeft) {
                offsetEle.scrollLeft -= (offsetEle.scrollLeft - trgt.offsetLeft);
            }
            var offsetLeft = offsetEle.scrollLeft + offsetEle.offsetWidth;
            var offsetRight = trgt.offsetLeft + trgt.offsetWidth;
            if (offsetLeft < offsetRight) {
                offsetEle.scrollLeft += (offsetRight - offsetLeft);
            }
        }
    };
    MenuBase.prototype.setPosition = function (li, ul, top, left) {
        var px = 'px';
        this.toggleVisiblity(ul);
        if (ul === this.element || (left > -1 && top > -1)) {
            var collide = Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["i" /* isCollide */])(ul, null, left, top);
            if (collide.indexOf('right') > -1) {
                left = left - ul.offsetWidth;
            }
            if (collide.indexOf('bottom') > -1) {
                var offset = this.callFit(ul, false, true, top, left);
                top = offset.top - 20;
                if (top < 0) {
                    var newTop = (pageYOffset + document.documentElement.clientHeight) - ul.getBoundingClientRect().height;
                    if (newTop > -1) {
                        top = newTop;
                    }
                }
            }
            collide = Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["i" /* isCollide */])(ul, null, left, top);
            if (collide.indexOf('left') > -1) {
                var offset = this.callFit(ul, true, false, top, left);
                left = offset.left;
            }
        }
        else {
            if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
                top = Number(this.element.style.top.replace(px, ''));
                left = Number(this.element.style.left.replace(px, ''));
            }
            else {
                var x = this.enableRtl ? 'left' : 'right';
                var offset = Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["c" /* calculatePosition */])(li, x, 'top');
                top = offset.top;
                left = offset.left;
                var collide = Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["i" /* isCollide */])(ul, null, this.enableRtl ? left - ul.offsetWidth : left, top);
                var xCollision = collide.indexOf('left') > -1 || collide.indexOf('right') > -1;
                if (xCollision) {
                    offset = Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["c" /* calculatePosition */])(li, this.enableRtl ? 'right' : 'left', 'top');
                    left = offset.left;
                }
                if (this.enableRtl || xCollision) {
                    left = (this.enableRtl && xCollision) ? left : left - ul.offsetWidth;
                }
                if (collide.indexOf('bottom') > -1) {
                    offset = this.callFit(ul, false, true, top, left);
                    top = offset.top;
                }
            }
        }
        this.toggleVisiblity(ul, false);
        ul.style.top = top + px;
        ul.style.left = left + px;
    };
    MenuBase.prototype.toggleVisiblity = function (ul, isVisible) {
        if (isVisible === void 0) { isVisible = true; }
        ul.style.visibility = isVisible ? 'hidden' : '';
        ul.style.display = isVisible ? 'block' : 'none';
    };
    MenuBase.prototype.createItems = function (items) {
        var _this = this;
        var level = this.navIdx ? this.navIdx.length : 0;
        var fields = this.getFields(level);
        var showIcon = this.hasField(items, this.getField('iconCss', level));
        var listBaseOptions = {
            showIcon: showIcon,
            moduleName: 'menu',
            fields: fields,
            template: this.template,
            itemNavigable: true,
            itemCreating: function (args) {
                if (!args.curData[args.fields[fields.id]]) {
                    args.curData[args.fields[fields.id]] = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('menuitem');
                }
                args.curData.htmlAttributes = {
                    role: 'menuitem',
                    tabindex: '-1'
                };
                if (_this.isMenu && !args.curData[_this.getField('separator', level)]) {
                    args.curData.htmlAttributes['aria-label'] = args.curData[args.fields.text];
                }
                if (args.curData[args.fields[fields.iconCss]] === '') {
                    args.curData[args.fields[fields.iconCss]] = null;
                }
            },
            itemCreated: function (args) {
                if (args.curData[_this.getField('separator', level)]) {
                    args.item.classList.add(SEPARATOR);
                    args.item.removeAttribute('role');
                }
                if (showIcon && !args.curData[args.fields.iconCss]
                    && !args.curData[_this.getField('separator', level)]) {
                    args.item.classList.add('e-blankicon');
                }
                if (args.curData[args.fields.child]
                    && args.curData[args.fields.child].length) {
                    var span = _this.createElement('span', { className: ICONS + ' ' + CARET });
                    args.item.appendChild(span);
                    args.item.setAttribute('aria-haspopup', 'true');
                    args.item.setAttribute('aria-expanded', 'false');
                    if (!_this.isMenu) {
                        args.item.removeAttribute('role');
                    }
                    args.item.classList.add('e-menu-caret-icon');
                }
                if (_this.isMenu && _this.template) {
                    args.item.setAttribute('id', args.curData[args.fields.id].toString());
                    args.item.removeAttribute('data-uid');
                    if (args.item.classList.contains('e-level-1')) {
                        args.item.classList.remove('e-level-1');
                    }
                    if (args.item.classList.contains('e-has-child')) {
                        args.item.classList.remove('e-has-child');
                    }
                }
                var eventArgs = { item: args.curData, element: args.item };
                _this.trigger('beforeItemRender', eventArgs);
            }
        };
        this.setProperties({ 'items': this.items }, true);
        if (this.isMenu) {
            listBaseOptions.templateID = this.element.id + TEMPLATE_PROPERTY;
        }
        var ul = __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_lists__["a" /* ListBase */].createList(this.createElement, items, listBaseOptions, !this.template, this);
        ul.setAttribute('tabindex', '0');
        if (this.isMenu) {
            ul.setAttribute('role', 'menu');
        }
        return ul;
    };
    MenuBase.prototype.moverHandler = function (e) {
        var trgt = e.target;
        this.liTrgt = trgt;
        var cli = this.getLI(trgt);
        var wrapper = cli ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(cli, '.e-' + this.getModuleName() + '-wrapper') : this.getWrapper();
        var hdrWrapper = this.getWrapper();
        var regex = new RegExp('-ej2menu-(.*)-popup');
        var ulId;
        var isDifferentElem = false;
        if (!wrapper) {
            return;
        }
        if (wrapper.id !== '') {
            ulId = regex.exec(wrapper.id)[1];
        }
        else {
            ulId = wrapper.querySelector('ul').id;
        }
        if (ulId !== this.element.id) {
            this.removeLIStateByClass([FOCUSED, SELECTED], [this.getWrapper()]);
            if (this.navIdx.length) {
                isDifferentElem = true;
            }
            else {
                return;
            }
        }
        if (cli && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(cli, '.e-' + this.getModuleName() + '-wrapper') && !isDifferentElem) {
            this.removeLIStateByClass([FOCUSED], this.isMenu ? [wrapper].concat(this.getPopups()) : [wrapper]);
            this.removeLIStateByClass([FOCUSED], this.isMenu ? [hdrWrapper].concat(this.getPopups()) : [hdrWrapper]);
            cli.classList.add(FOCUSED);
            if (!this.showItemOnClick) {
                this.clickHandler(e);
            }
        }
        else if (this.isMenu && this.showItemOnClick && !isDifferentElem) {
            this.removeLIStateByClass([FOCUSED], [wrapper].concat(this.getPopups()));
        }
        if (this.isMenu) {
            if (!this.showItemOnClick && (trgt.parentElement !== wrapper && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '.e-' + this.getModuleName() + '-popup'))
                && (!cli || (cli && !this.getIndex(cli.id, true).length)) && this.showSubMenuOn !== 'Hover') {
                this.removeLIStateByClass([FOCUSED], [wrapper]);
                if (this.navIdx.length) {
                    this.isClosed = true;
                    this.closeMenu(null, e);
                }
            }
            else if (isDifferentElem && !this.showItemOnClick) {
                if (this.navIdx.length) {
                    this.isClosed = true;
                    this.closeMenu(null, e);
                }
            }
            if (!this.isClosed) {
                this.removeStateWrapper();
            }
            this.isClosed = false;
        }
    };
    MenuBase.prototype.removeStateWrapper = function () {
        if (this.liTrgt) {
            var wrapper = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.liTrgt, '.e-menu-vscroll');
            if (this.liTrgt.tagName === 'DIV' && wrapper) {
                this.removeLIStateByClass([FOCUSED, SELECTED], [wrapper]);
            }
        }
    };
    MenuBase.prototype.removeLIStateByClass = function (classList, element) {
        var li;
        var _loop_1 = function (i) {
            classList.forEach(function (className) {
                li = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + className, element[i]);
                if (li) {
                    li.classList.remove(className);
                }
            });
        };
        for (var i = 0; i < element.length; i++) {
            _loop_1(i);
        }
    };
    MenuBase.prototype.getField = function (propName, level) {
        if (level === void 0) { level = 0; }
        var fieldName = this.fields[propName];
        return typeof fieldName === 'string' ? fieldName :
            (!fieldName[level] ? fieldName[fieldName.length - 1].toString()
                : fieldName[level].toString());
    };
    MenuBase.prototype.getFields = function (level) {
        if (level === void 0) { level = 0; }
        return {
            id: this.getField('itemId', level),
            iconCss: this.getField('iconCss', level),
            text: this.getField('text', level),
            url: this.getField('url', level),
            child: this.getField('children', level),
            separator: this.getField('separator', level)
        };
    };
    MenuBase.prototype.hasField = function (items, field) {
        for (var i = 0, len = items.length; i < len; i++) {
            if (items[i][field]) {
                return true;
            }
        }
        return false;
    };
    MenuBase.prototype.menuHeaderClickHandler = function (e) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.e-menu-wrapper').querySelector('ul.e-menu-parent').id !== this.element.id) {
            return;
        }
        if (this.element.classList.contains('e-hide-menu')) {
            this.openHamburgerMenu(e);
        }
        else {
            this.closeHamburgerMenu(e);
        }
    };
    MenuBase.prototype.clickHandler = function (e) {
        if (this.isTapHold) {
            this.isTapHold = false;
        }
        else {
            var wrapper = this.getWrapper();
            var trgt = e.target;
            var cli = this.cli = this.getLI(trgt);
            var regex = new RegExp('-ej2menu-(.*)-popup');
            var cliWrapper = cli ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(cli, '.e-' + this.getModuleName() + '-wrapper') : null;
            var isInstLI = cli && cliWrapper && (this.isMenu ? this.getIndex(cli.id, true).length > 0
                : wrapper.firstElementChild.id === cliWrapper.firstElementChild.id);
            if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice && this.isMenu) {
                this.removeLIStateByClass([FOCUSED], [wrapper].concat(this.getPopups()));
                this.mouseDownHandler(e);
            }
            if (cli && cliWrapper && this.isMenu) {
                var cliWrapperId = cliWrapper.id ? regex.exec(cliWrapper.id)[1] : cliWrapper.querySelector('.e-menu-parent').id;
                if (this.element.id !== cliWrapperId) {
                    return;
                }
            }
            if (isInstLI && e.type === 'click' && !cli.classList.contains(HEADER)) {
                this.setLISelected(cli);
                var navIdx = this.getIndex(cli.id, true);
                var item = this.getItem(navIdx);
                var eventArgs = { element: cli, item: item, event: e };
                this.trigger('select', eventArgs);
            }
            if (isInstLI && (e.type === 'mouseover' || __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice || this.showItemOnClick)) {
                var ul = void 0;
                if (cli.classList.contains(HEADER)) {
                    ul = wrapper.children[this.navIdx.length - 1];
                    this.toggleAnimation(ul);
                    var sli = this.getLIByClass(ul, SELECTED);
                    if (sli) {
                        sli.classList.remove(SELECTED);
                    }
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(cli.parentNode);
                    this.navIdx.pop();
                }
                else {
                    if (!cli.classList.contains(SEPARATOR)) {
                        this.showSubMenu = true;
                        var cul = cli.parentNode;
                        this.cliIdx = this.getIdx(cul, cli);
                        if (this.isMenu || !__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
                            var culIdx = this.isMenu ? Array.prototype.indexOf.call([wrapper].concat(this.getPopups()), Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(cul, '.' + 'e-' + this.getModuleName() + '-wrapper'))
                                : this.getIdx(wrapper, cul);
                            if (this.navIdx[culIdx] === this.cliIdx) {
                                this.showSubMenu = false;
                            }
                            if (culIdx !== this.navIdx.length && (e.type !== 'mouseover' || this.showSubMenu)) {
                                var sli = this.getLIByClass(cul, SELECTED);
                                if (sli) {
                                    sli.classList.remove(SELECTED);
                                }
                                this.isClosed = true;
                                this.keyType = 'click';
                                if (this.showItemOnClick) {
                                    this.setLISelected(cli);
                                }
                                this.closeMenu(culIdx + 1, e);
                                if (this.showItemOnClick) {
                                    this.setLISelected(cli);
                                }
                            }
                        }
                        if (!this.isClosed) {
                            this.afterCloseMenu(e);
                        }
                        this.isClosed = false;
                    }
                }
            }
            else {
                if (this.isMenu && trgt.tagName === 'DIV' && this.navIdx.length && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '.e-menu-vscroll')) {
                    var popupEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '.' + POPUP);
                    var cIdx = Array.prototype.indexOf.call(this.getPopups(), popupEle) + 1;
                    if (cIdx < this.navIdx.length) {
                        this.closeMenu(cIdx + 1, e);
                        if (popupEle) {
                            this.removeLIStateByClass([FOCUSED, SELECTED], [popupEle]);
                        }
                    }
                }
                else if (this.isMenu && this.hamburgerMode && trgt.tagName === 'SPAN'
                    && trgt.classList.contains('e-menu-icon')) {
                    this.menuHeaderClickHandler(e);
                }
                else {
                    if (trgt.tagName !== 'UL' || (this.isMenu ? trgt.parentElement.classList.contains('e-menu-wrapper') &&
                        !this.getIndex(trgt.querySelector('.' + ITEM).id, true).length : trgt.parentElement !== wrapper)) {
                        if (!cli) {
                            this.removeLIStateByClass([SELECTED], [wrapper]);
                        }
                        if (!cli || !cli.querySelector('.' + CARET)) {
                            this.closeMenu(null, e);
                        }
                    }
                }
            }
        }
    };
    MenuBase.prototype.afterCloseMenu = function (e) {
        var isHeader;
        if (this.showSubMenu) {
            if (this.showItemOnClick && this.navIdx.length === 0) {
                isHeader = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.e-menu-parent.e-control');
            }
            else {
                isHeader = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, '.e-menu-parent.e-control');
            }
            var idx = this.navIdx.concat(this.cliIdx);
            var item = this.getItem(idx);
            if (item && item[this.getField('children', idx.length - 1)] &&
                item[this.getField('children', idx.length - 1)].length) {
                if (e.type === 'mouseover' || (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice && this.isMenu)) {
                    this.setLISelected(this.cli);
                }
                if ((!this.hamburgerMode && isHeader) || (this.hamburgerMode && this.cli.getAttribute('aria-expanded') === 'false')) {
                    this.cli.setAttribute('aria-expanded', 'true');
                    this.navIdx.push(this.cliIdx);
                    this.openMenu(this.cli, item, null, null, e);
                }
            }
            else {
                if (e.type !== 'mouseover') {
                    this.closeMenu(null, e);
                }
            }
            if (!isHeader) {
                var cul = this.getUlByNavIdx();
                var sli = this.getLIByClass(cul, SELECTED);
                if (sli) {
                    sli.setAttribute('aria-expanded', 'false');
                    sli.classList.remove(SELECTED);
                }
            }
        }
        this.keyType = '';
    };
    MenuBase.prototype.setLISelected = function (li) {
        var sli = this.getLIByClass(li.parentElement, SELECTED);
        if (sli) {
            sli.classList.remove(SELECTED);
        }
        if (!this.isMenu) {
            li.classList.remove(FOCUSED);
        }
        li.classList.add(SELECTED);
    };
    MenuBase.prototype.getLIByClass = function (ul, classname) {
        for (var i = 0, len = ul.children.length; i < len; i++) {
            if (ul.children[i].classList.contains(classname)) {
                return ul.children[i];
            }
        }
        return null;
    };
    /**
     * This method is used to get the index of the menu item in the Menu based on the argument.
     *
     * @param {MenuItem | string} item - item be passed to get the index | id to be passed to get the item index.
     * @param {boolean} isUniqueId - Set `true` if it is a unique id.
     * @returns {void}
     */
    MenuBase.prototype.getItemIndex = function (item, isUniqueId) {
        var idx;
        if (typeof item === 'string') {
            idx = item;
        }
        else {
            idx = item.id;
        }
        var isText = (isUniqueId === false) ? false : true;
        var navIdx = this.getIndex(idx, isText);
        return navIdx;
    };
    /**
     * This method is used to set the menu item in the Menu based on the argument.
     *
     * @param {MenuItem} item - item need to be updated.
     * @param {string} id - id / text to be passed to update the item.
     * @param {boolean} isUniqueId - Set `true` if it is a unique id.
     * @returns {void}
     */
    MenuBase.prototype.setItem = function (item, id, isUniqueId) {
        var idx;
        if (isUniqueId) {
            idx = id ? id : item.id;
        }
        else {
            idx = id ? id : item.text;
        }
        var navIdx = this.getIndex(idx, isUniqueId);
        var newItem = this.getItem(navIdx);
        newItem.iconCss = item.iconCss || newItem.iconCss;
        newItem.text = item.text || newItem.text;
        newItem.url = item.url || newItem.url;
        newItem.separator = item.separator || newItem.separator;
    };
    MenuBase.prototype.getItem = function (navIdx) {
        navIdx = navIdx.slice();
        var idx = navIdx.pop();
        var items = this.getItems(navIdx);
        return items[idx];
    };
    MenuBase.prototype.getItems = function (navIdx) {
        var items = this.items;
        for (var i = 0; i < navIdx.length; i++) {
            items = items[navIdx[i]][this.getField('children', i)];
        }
        return items;
    };
    MenuBase.prototype.setItems = function (newItems, navIdx) {
        var items = this.getItems(navIdx);
        items.splice(0, items.length);
        for (var i = 0; i < newItems.length; i++) {
            items.splice(i, 0, newItems[i]);
        }
    };
    MenuBase.prototype.getIdx = function (ul, li, skipHdr) {
        if (skipHdr === void 0) { skipHdr = true; }
        var idx = Array.prototype.indexOf.call(ul.children, li);
        if (skipHdr && ul.children[0].classList.contains(HEADER)) {
            idx--;
        }
        return idx;
    };
    MenuBase.prototype.getLI = function (elem) {
        if (elem.tagName === 'LI' && elem.classList.contains('e-menu-item')) {
            return elem;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(elem, 'li.e-menu-item');
    };
    MenuBase.prototype.updateItemsByNavIdx = function () {
        var items = this.items;
        var count = 0;
        for (var index = 0; index < this.navIdx.length; index++) {
            items = items[index].items;
            if (!items) {
                break;
            }
            count++;
            var ul = this.getUlByNavIdx(count);
            if (!ul) {
                break;
            }
            this.updateItem(ul, items);
        }
    };
    MenuBase.prototype.removeChildElement = function (elem) {
        while (elem.firstElementChild) {
            elem.removeChild(elem.firstElementChild);
        }
        return elem;
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @private
     * @param {MenuBaseModel} newProp - Specifies the new properties
     * @param {MenuBaseModel} oldProp - Specifies the old properties
     * @returns {void}
     */
    MenuBase.prototype.onPropertyChanged = function (newProp, oldProp) {
        var _this = this;
        var wrapper = this.getWrapper();
        var _loop_2 = function (prop) {
            switch (prop) {
                case 'cssClass':
                    if (oldProp.cssClass) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([wrapper], oldProp.cssClass.split(' '));
                    }
                    if (newProp.cssClass) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([wrapper], newProp.cssClass.split(' '));
                    }
                    break;
                case 'enableRtl':
                    wrapper.classList.toggle(RTL);
                    break;
                case 'showItemOnClick':
                    this_1.unWireEvents();
                    this_1.showItemOnClick = newProp.showItemOnClick;
                    this_1.wireEvents();
                    break;
                case 'enableScrolling':
                    if (newProp.enableScrolling) {
                        var ul_2;
                        if (this_1.element.classList.contains('e-vertical')) {
                            Object(__WEBPACK_IMPORTED_MODULE_5__common_menu_scroll__["a" /* addScrolling */])(this_1.createElement, wrapper, this_1.element, 'vscroll', this_1.enableRtl);
                        }
                        else {
                            Object(__WEBPACK_IMPORTED_MODULE_5__common_menu_scroll__["a" /* addScrolling */])(this_1.createElement, wrapper, this_1.element, 'hscroll', this_1.enableRtl);
                        }
                        this_1.getPopups().forEach(function (wrapper) {
                            ul_2 = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-ul', wrapper);
                            Object(__WEBPACK_IMPORTED_MODULE_5__common_menu_scroll__["a" /* addScrolling */])(_this.createElement, wrapper, ul_2, 'vscroll', _this.enableRtl);
                        });
                    }
                    else {
                        var ul_3 = wrapper.children[0];
                        if (this_1.element.classList.contains('e-vertical')) {
                            Object(__WEBPACK_IMPORTED_MODULE_5__common_menu_scroll__["b" /* destroyScroll */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(ul_3, __WEBPACK_IMPORTED_MODULE_4__common_v_scroll__["a" /* VScroll */]), ul_3);
                        }
                        else {
                            Object(__WEBPACK_IMPORTED_MODULE_5__common_menu_scroll__["b" /* destroyScroll */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(ul_3, __WEBPACK_IMPORTED_MODULE_3__common_h_scroll__["a" /* HScroll */]), ul_3);
                        }
                        wrapper.style.overflow = '';
                        wrapper.appendChild(this_1.element);
                        this_1.getPopups().forEach(function (wrapper) {
                            ul_3 = wrapper.children[0];
                            Object(__WEBPACK_IMPORTED_MODULE_5__common_menu_scroll__["b" /* destroyScroll */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(ul_3, __WEBPACK_IMPORTED_MODULE_4__common_v_scroll__["a" /* VScroll */]), ul_3);
                            wrapper.style.overflow = '';
                        });
                    }
                    break;
                case 'items': {
                    var idx = void 0;
                    var navIdx = void 0;
                    var item = void 0;
                    if (!Object.keys(oldProp.items).length) {
                        this_1.updateItem(this_1.element, this_1.items);
                        if (!this_1.hamburgerMode) {
                            for (var i = 1, count = wrapper.childElementCount; i < count; i++) {
                                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(wrapper.lastElementChild);
                            }
                        }
                        this_1.navIdx = [];
                    }
                    else {
                        var keys = Object.keys(newProp.items);
                        for (var i = 0; i < keys.length; i++) {
                            navIdx = this_1.getChangedItemIndex(newProp, [], Number(keys[i]));
                            if (navIdx.length <= this_1.getWrapper().children.length) {
                                idx = navIdx.pop();
                                item = this_1.getItems(navIdx);
                                this_1.insertAfter([item[idx]], item[idx].text);
                                this_1.removeItem(item, navIdx, idx);
                                this_1.setItems(item, navIdx);
                            }
                            navIdx.length = 0;
                        }
                    }
                    break;
                }
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            _loop_2(prop);
        }
    };
    MenuBase.prototype.updateItem = function (ul, items) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["P" /* isBlazor */])() && !this.isMenu) {
            ul = this.removeChildElement(ul);
        }
        else {
            ul.innerHTML = '';
        }
        var lis = [].slice.call(this.createItems(items).children);
        lis.forEach(function (li) {
            ul.appendChild(li);
        });
    };
    MenuBase.prototype.getChangedItemIndex = function (newProp, index, idx) {
        index.push(idx);
        var key = Object.keys(newProp.items[idx]).pop();
        if (key === 'items') {
            var item = newProp.items[idx];
            var popStr = Object.keys(item.items).pop();
            if (popStr) {
                this.getChangedItemIndex(item, index, Number(popStr));
            }
        }
        else {
            if (key === 'isParentArray' && index.length > 1) {
                index.pop();
            }
        }
        return index;
    };
    MenuBase.prototype.removeItem = function (item, navIdx, idx) {
        item.splice(idx, 1);
        var uls = this.getWrapper().children;
        var uls_length = this.hamburgerMode ? 1 : uls.length;
        if (navIdx.length < uls_length) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(uls[this.hamburgerMode ? 1 : navIdx.length].children[idx]);
        }
    };
    /**
     * Used to unwire the bind events.
     *
     * @private
     * @param {string} targetSelctor - Specifies the target selector
     * @returns {void}
     */
    MenuBase.prototype.unWireEvents = function (targetSelctor) {
        if (targetSelctor === void 0) { targetSelctor = this.target; }
        var wrapper = this.getWrapper();
        if (targetSelctor) {
            var target = void 0;
            var touchModule = void 0;
            var targetElems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])(targetSelctor);
            for (var i = 0, len = targetElems.length; i < len; i++) {
                target = targetElems[i];
                if (this.isMenu) {
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(target, 'click', this.menuHeaderClickHandler);
                }
                else {
                    if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isIos) {
                        touchModule = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(target, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["t" /* Touch */]);
                        if (touchModule) {
                            touchModule.destroy();
                        }
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(target, 'contextmenu', this.cmenuHandler);
                    }
                }
            }
            if (!this.isMenu) {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.targetElement, 'scroll', this.scrollHandler);
                for (var _i = 0, _a = Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["f" /* getScrollableParent */])(this.targetElement); _i < _a.length; _i++) {
                    var parent_2 = _a[_i];
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(parent_2, 'scroll', this.scrollHandler);
                }
            }
        }
        if (!__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.isMenu ? document : wrapper, 'mouseover', this.delegateMoverHandler);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'mousedown', this.delegateMouseDownHandler);
        }
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'click', this.delegateClickHandler);
        this.unWireKeyboardEvent(wrapper);
        this.rippleFn();
    };
    MenuBase.prototype.unWireKeyboardEvent = function (element) {
        var keyboardModule = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(element, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["n" /* KeyboardEvents */]);
        if (keyboardModule) {
            keyboardModule.destroy();
        }
    };
    MenuBase.prototype.toggleAnimation = function (ul, isMenuOpen) {
        var _this = this;
        if (isMenuOpen === void 0) { isMenuOpen = true; }
        var pUlHeight;
        var pElement;
        if (this.animationSettings.effect === 'None' || !isMenuOpen) {
            this.end(ul, isMenuOpen);
        }
        else {
            this.animation.animate(ul, {
                name: this.animationSettings.effect,
                duration: this.animationSettings.duration,
                timingFunction: this.animationSettings.easing,
                begin: function (options) {
                    if (_this.hamburgerMode) {
                        pElement = options.element.parentElement;
                        options.element.style.position = 'absolute';
                        pUlHeight = pElement.offsetHeight;
                        options.element.style.maxHeight = options.element.offsetHeight + 'px';
                        pElement.style.maxHeight = '';
                    }
                    else {
                        options.element.style.display = 'block';
                        options.element.style.maxHeight = options.element.getBoundingClientRect().height + 'px';
                    }
                },
                progress: function (options) {
                    if (_this.hamburgerMode) {
                        pElement.style.minHeight = (pUlHeight + options.element.offsetHeight) + 'px';
                    }
                },
                end: function (options) {
                    if (_this.hamburgerMode) {
                        options.element.style.position = '';
                        options.element.style.maxHeight = '';
                        pElement.style.minHeight = '';
                        options.element.style.top = 0 + 'px';
                        options.element.children[0].focus();
                        _this.triggerOpen(options.element.children[0]);
                    }
                    else {
                        _this.end(options.element, isMenuOpen);
                    }
                }
            });
        }
    };
    MenuBase.prototype.triggerOpen = function (ul) {
        var item = this.navIdx.length ? this.getItem(this.navIdx) : null;
        var eventArgs = {
            element: ul, parentItem: item, items: item ? item.items : this.items
        };
        this.trigger('onOpen', eventArgs);
    };
    MenuBase.prototype.end = function (ul, isMenuOpen) {
        if (isMenuOpen) {
            ul.style.display = 'block';
            ul.style.maxHeight = '';
            this.triggerOpen(ul);
            if (ul.querySelector('.' + FOCUSED)) {
                ul.querySelector('.' + FOCUSED).focus();
            }
            else {
                var ele = this.getWrapper().children[this.getIdx(this.getWrapper(), ul) - 1];
                if (ele) {
                    ele.querySelector('.' + SELECTED).focus();
                }
                else {
                    this.element.focus();
                }
            }
        }
        else {
            if (ul === this.element) {
                var fli = this.getLIByClass(this.element, FOCUSED);
                if (fli) {
                    fli.classList.remove(FOCUSED);
                }
                var sli = this.getLIByClass(this.element, SELECTED);
                if (sli) {
                    sli.classList.remove(SELECTED);
                }
                ul.style.display = 'none';
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(ul);
            }
        }
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} - Persist data
     */
    MenuBase.prototype.getPersistData = function () {
        return '';
    };
    /**
     * Get wrapper element.
     *
     * @returns {Element} - Wrapper element
     * @private
     */
    MenuBase.prototype.getWrapper = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, '.e-' + this.getModuleName() + '-wrapper');
    };
    MenuBase.prototype.getIndex = function (data, isUniqueId, items, nIndex, isCallBack, level) {
        if (items === void 0) { items = this.items; }
        if (nIndex === void 0) { nIndex = []; }
        if (isCallBack === void 0) { isCallBack = false; }
        if (level === void 0) { level = 0; }
        var item;
        level = isCallBack ? level + 1 : 0;
        for (var i = 0, len = items.length; i < len; i++) {
            item = items[i];
            if ((isUniqueId ? item[this.getField('itemId', level)] : item[this.getField('text', level)]) === data) {
                nIndex.push(i);
                break;
            }
            else if (item[this.getField('children', level)]
                && item[this.getField('children', level)].length) {
                nIndex = this.getIndex(data, isUniqueId, item[this.getField('children', level)], nIndex, true, level);
                if (nIndex[nIndex.length - 1] === -1) {
                    if (i !== len - 1) {
                        nIndex.pop();
                    }
                }
                else {
                    nIndex.unshift(i);
                    break;
                }
            }
            else {
                if (i === len - 1) {
                    nIndex.push(-1);
                }
            }
        }
        return (!isCallBack && nIndex[0] === -1) ? [] : nIndex;
    };
    /**
     * This method is used to enable or disable the menu items in the Menu based on the items and enable argument.
     *
     * @param {string[]} items - Text items that needs to be enabled/disabled.
     * @param {boolean} enable - Set `true`/`false` to enable/disable the list items.
     * @param {boolean} isUniqueId - Set `true` if it is a unique id.
     * @returns {void}
     */
    MenuBase.prototype.enableItems = function (items, enable, isUniqueId) {
        if (enable === void 0) { enable = true; }
        var ul;
        var idx;
        var navIdx;
        var disabled = DISABLED;
        var skipItem;
        for (var i = 0; i < items.length; i++) {
            navIdx = this.getIndex(items[i], isUniqueId);
            if (this.navIdx.length) {
                if (navIdx.length !== 1) {
                    skipItem = false;
                    for (var i_1 = 0, len = navIdx.length - 1; i_1 < len; i_1++) {
                        if (navIdx[i_1] !== this.navIdx[i_1]) {
                            skipItem = true;
                            break;
                        }
                    }
                    if (skipItem) {
                        continue;
                    }
                }
            }
            else {
                if (navIdx.length !== 1) {
                    continue;
                }
            }
            idx = navIdx.pop();
            ul = this.getUlByNavIdx(navIdx.length);
            if (ul) {
                if (enable) {
                    if (this.isMenu) {
                        ul.children[idx].classList.remove(disabled);
                        ul.children[idx].removeAttribute('aria-disabled');
                    }
                    else {
                        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice && !ul.classList.contains('e-contextmenu')) {
                            ul.children[idx + 1].classList.remove(disabled);
                        }
                        else {
                            ul.children[idx].classList.remove(disabled);
                        }
                    }
                }
                else {
                    if (this.isMenu) {
                        ul.children[idx].classList.add(disabled);
                        ul.children[idx].setAttribute('aria-disabled', 'true');
                    }
                    else {
                        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice && !ul.classList.contains('e-contextmenu')) {
                            ul.children[idx + 1].classList.add(disabled);
                        }
                        else {
                            ul.children[idx].classList.add(disabled);
                        }
                    }
                }
            }
        }
    };
    /**
     * This method is used to show the menu items in the Menu based on the items text.
     *
     * @param {string[]} items - Text items that needs to be shown.
     * @param {boolean} isUniqueId - Set `true` if it is a unique id.
     * @returns {void}
     */
    MenuBase.prototype.showItems = function (items, isUniqueId) {
        this.showHideItems(items, false, isUniqueId);
    };
    /**
     * This method is used to hide the menu items in the Menu based on the items text.
     *
     * @param {string[]} items - Text items that needs to be hidden.
     * @param {boolean} isUniqueId - Set `true` if it is a unique id.
     * @returns {void}
     */
    MenuBase.prototype.hideItems = function (items, isUniqueId) {
        this.showHideItems(items, true, isUniqueId);
    };
    MenuBase.prototype.showHideItems = function (items, ishide, isUniqueId) {
        var ul;
        var index;
        var navIdx;
        for (var i = 0; i < items.length; i++) {
            navIdx = this.getIndex(items[i], isUniqueId);
            index = navIdx.pop();
            ul = this.getUlByNavIdx(navIdx.length);
            if (ul) {
                if (ishide) {
                    if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice && !ul.classList.contains('e-contextmenu')) {
                        ul.children[index + 1].classList.add(HIDE);
                    }
                    else {
                        ul.children[index].classList.add(HIDE);
                    }
                }
                else {
                    if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice && !ul.classList.contains('e-contextmenu')) {
                        ul.children[index + 1].classList.remove(HIDE);
                    }
                    else {
                        ul.children[index].classList.remove(HIDE);
                    }
                }
            }
        }
    };
    /**
     * It is used to remove the menu items from the Menu based on the items text.
     *
     * @param {string[]} items Text items that needs to be removed.
     * @param {boolean} isUniqueId - Set `true` if it is a unique id.
     * @returns {void}
     */
    MenuBase.prototype.removeItems = function (items, isUniqueId) {
        var idx;
        var navIdx;
        var iitems;
        for (var i = 0; i < items.length; i++) {
            navIdx = this.getIndex(items[i], isUniqueId);
            idx = navIdx.pop();
            iitems = this.getItems(navIdx);
            this.removeItem(iitems, navIdx, idx);
        }
    };
    /**
     * It is used to insert the menu items after the specified menu item text.
     *
     * @param {MenuItemModel[]} items - Items that needs to be inserted.
     * @param {string} text - Text item after that the element to be inserted.
     * @param {boolean} isUniqueId - Set `true` if it is a unique id.
     * @returns {void}
     */
    MenuBase.prototype.insertAfter = function (items, text, isUniqueId) {
        this.insertItems(items, text, isUniqueId);
    };
    /**
     * It is used to insert the menu items before the specified menu item text.
     *
     * @param {MenuItemModel[]} items - Items that needs to be inserted.
     * @param {string} text - Text item before that the element to be inserted.
     * @param  {boolean} isUniqueId - Set `true` if it is a unique id.
     * @returns {void}
     */
    MenuBase.prototype.insertBefore = function (items, text, isUniqueId) {
        this.insertItems(items, text, isUniqueId, false);
    };
    MenuBase.prototype.insertItems = function (items, text, isUniqueId, isAfter) {
        if (isAfter === void 0) { isAfter = true; }
        var li;
        var idx;
        var navIdx;
        var iitems;
        var menuitem;
        for (var i = 0; i < items.length; i++) {
            navIdx = this.getIndex(text, isUniqueId);
            idx = navIdx.pop();
            iitems = this.getItems(navIdx);
            menuitem = new MenuItem(iitems[0], 'items', items[i], true);
            iitems.splice(isAfter ? idx + 1 : idx, 0, menuitem);
            var uls = this.isMenu ? [this.getWrapper()].concat(this.getPopups()) : [].slice.call(this.getWrapper().children);
            if (navIdx.length < uls.length) {
                idx = isAfter ? idx + 1 : idx;
                li = this.createItems(iitems).children[idx];
                var ul = this.isMenu ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-menu-parent', uls[navIdx.length]) : uls[navIdx.length];
                ul.insertBefore(li, ul.children[idx]);
            }
        }
    };
    MenuBase.prototype.removeAttributes = function () {
        var _this = this;
        ['top', 'left', 'display', 'z-index'].forEach(function (key) {
            _this.element.style.removeProperty(key);
        });
        ['role', 'tabindex', 'class', 'style'].forEach(function (key) {
            if (key === 'class' && _this.element.classList.contains('e-menu-parent')) {
                _this.element.classList.remove('e-menu-parent');
            }
            if (['class', 'style'].indexOf(key) === -1 || !_this.element.getAttribute(key)) {
                _this.element.removeAttribute(key);
            }
            if (_this.isMenu && key === 'class' && _this.element.classList.contains('e-vertical')) {
                _this.element.classList.remove('e-vertical');
            }
        });
    };
    /**
     * Destroys the widget.
     *
     * @returns {void}
     */
    MenuBase.prototype.destroy = function () {
        var wrapper = this.getWrapper();
        if (wrapper) {
            this.unWireEvents();
            if (!this.isMenu) {
                this.clonedElement.style.display = '';
                if (this.clonedElement.tagName === 'EJS-CONTEXTMENU') {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.clonedElement], ['e-control', 'e-lib', 'e-' + this.getModuleName()]);
                    this.element = this.clonedElement;
                }
                else {
                    if (this.refreshing && this.clonedElement.childElementCount && this.clonedElement.children[0].tagName === 'LI') {
                        this.setProperties({ 'items': [] }, true);
                    }
                    if (document.getElementById(this.clonedElement.id)) {
                        var refEle = this.clonedElement.nextElementSibling;
                        if (refEle && refEle !== wrapper) {
                            this.clonedElement.parentElement.insertBefore(this.element, refEle);
                        }
                        else {
                            this.clonedElement.parentElement.appendChild(this.element);
                        }
                        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["P" /* isBlazor */])() && !this.isMenu) {
                            this.element = this.removeChildElement(this.element);
                        }
                        else {
                            this.element.innerHTML = '';
                        }
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])([].slice.call(this.clonedElement.children), this.element);
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.clonedElement);
                        this.removeAttributes();
                    }
                }
                this.clonedElement = null;
            }
            else {
                this.closeMenu();
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["P" /* isBlazor */])() && !this.isMenu) {
                    this.element = this.removeChildElement(this.element);
                }
                else {
                    this.element.innerHTML = '';
                }
                this.removeAttributes();
                wrapper.parentNode.insertBefore(this.element, wrapper);
                this.clonedElement = null;
            }
            if (this.isMenu && this.clonedElement) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.element);
                wrapper.style.display = '';
                wrapper.classList.remove('e-' + this.getModuleName() + '-wrapper');
                wrapper.removeAttribute('data-ripple');
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(wrapper);
            }
            _super.prototype.destroy.call(this);
            if (this.template) {
                this.clearTemplate(['template']);
            }
        }
        this.rippleFn = null;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], MenuBase.prototype, "beforeItemRender", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], MenuBase.prototype, "beforeOpen", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], MenuBase.prototype, "onOpen", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], MenuBase.prototype, "beforeClose", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], MenuBase.prototype, "onClose", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], MenuBase.prototype, "select", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], MenuBase.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], MenuBase.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(0)
    ], MenuBase.prototype, "hoverDelay", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], MenuBase.prototype, "showItemOnClick", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], MenuBase.prototype, "target", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], MenuBase.prototype, "filter", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], MenuBase.prototype, "template", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], MenuBase.prototype, "enableScrolling", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], MenuBase.prototype, "enableHtmlSanitizer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({ itemId: 'id', text: 'text', parentId: 'parentId', iconCss: 'iconCss', url: 'url', separator: 'separator', children: 'items' }, FieldSettings)
    ], MenuBase.prototype, "fields", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["f" /* Collection */])([], MenuItem)
    ], MenuBase.prototype, "items", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({ duration: 400, easing: 'ease', effect: 'SlideDown' }, MenuAnimationSettings)
    ], MenuBase.prototype, "animationSettings", void 0);
    MenuBase = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], MenuBase);
    return MenuBase;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index__ = __webpack_require__(216);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["b"]; });
/**
 * index
 */



/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataUtil; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__manager__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__query__ = __webpack_require__(32);



var consts = { GroupGuid: '{271bbba0-1ee7}' };
/**
 * Data manager common utility methods.
 * @hidden
 */
var DataUtil = /** @class */ (function () {
    function DataUtil() {
    }
    /**
     * Returns the value by invoking the provided parameter function.
     * If the paramater is not of type function then it will be returned as it is.
     * @param  {Function|string|string[]|number} value
     * @param  {Object} inst?
     * @hidden
     */
    DataUtil.getValue = function (value, inst) {
        if (typeof value === 'function') {
            return value.call(inst || {});
        }
        return value;
    };
    /**
     * Returns true if the input string ends with given string.
     * @param  {string} input
     * @param  {string} substr
     */
    DataUtil.endsWith = function (input, substr) {
        return input.slice && input.slice(-substr.length) === substr;
    };
    /**
     * Returns true if the input string starts with given string.
     * @param  {string} str
     * @param  {string} startstr
     */
    DataUtil.startsWith = function (input, start) {
        return input.slice(0, start.length) === start;
    };
    /**
     * To return the sorting function based on the string.
     * @param  {string} order
     * @hidden
     */
    DataUtil.fnSort = function (order) {
        order = order ? DataUtil.toLowerCase(order) : 'ascending';
        if (order === 'ascending') {
            return this.fnAscending;
        }
        return this.fnDescending;
    };
    /**
     * Comparer function which is used to sort the data in ascending order.
     * @param  {string|number} x
     * @param  {string|number} y
     * @returns number
     */
    DataUtil.fnAscending = function (x, y) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(x) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(y)) {
            return -1;
        }
        if (y === null || y === undefined) {
            return -1;
        }
        if (typeof x === 'string') {
            return x.localeCompare(y);
        }
        if (x === null || x === undefined) {
            return 1;
        }
        return x - y;
    };
    /**
     * Comparer function which is used to sort the data in descending order.
     * @param  {string|number} x
     * @param  {string|number} y
     * @returns number
     */
    DataUtil.fnDescending = function (x, y) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(x) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(y)) {
            return -1;
        }
        if (y === null || y === undefined) {
            return 1;
        }
        if (typeof x === 'string') {
            return x.localeCompare(y) * -1;
        }
        if (x === null || x === undefined) {
            return -1;
        }
        return y - x;
    };
    DataUtil.extractFields = function (obj, fields) {
        var newObj = {};
        for (var i = 0; i < fields.length; i++) {
            newObj = this.setValue(fields[i], this.getObject(fields[i], obj), newObj);
        }
        return newObj;
    };
    /**
     * Select objects by given fields from jsonArray.
     * @param  {Object[]} jsonArray
     * @param  {string[]} fields
     */
    DataUtil.select = function (jsonArray, fields) {
        var newData = [];
        for (var i = 0; i < jsonArray.length; i++) {
            newData.push(this.extractFields(jsonArray[i], fields));
        }
        return newData;
    };
    /**
     * Group the input data based on the field name.
     * It also performs aggregation of the grouped records based on the aggregates paramater.
     * @param  {Object[]} jsonArray
     * @param  {string} field?
     * @param  {Object[]} agg?
     * @param  {number} level?
     * @param  {Object[]} groupDs?
     */
    DataUtil.group = function (jsonArray, field, aggregates, level, groupDs, format, isLazyLoad) {
        level = level || 1;
        var jsonData = jsonArray;
        var guid = 'GroupGuid';
        if (jsonData.GroupGuid === consts[guid]) {
            var _loop_1 = function (j) {
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(groupDs)) {
                    var indx = -1;
                    var temp = groupDs.filter(function (e) { return e.key === jsonData[j].key; });
                    indx = groupDs.indexOf(temp[0]);
                    jsonData[j].items = this_1.group(jsonData[j].items, field, aggregates, jsonData.level + 1, groupDs[indx].items, format, isLazyLoad);
                    jsonData[j].count = groupDs[indx].count;
                }
                else {
                    jsonData[j].items = this_1.group(jsonData[j].items, field, aggregates, jsonData.level + 1, null, format, isLazyLoad);
                    jsonData[j].count = jsonData[j].items.length;
                }
            };
            var this_1 = this;
            for (var j = 0; j < jsonData.length; j++) {
                _loop_1(j);
            }
            jsonData.childLevels += 1;
            return jsonData;
        }
        var grouped = {};
        var groupedArray = [];
        groupedArray.GroupGuid = consts[guid];
        groupedArray.level = level;
        groupedArray.childLevels = 0;
        groupedArray.records = jsonData;
        var _loop_2 = function (i) {
            var val = this_2.getVal(jsonData, i, field);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(format)) {
                val = format(val, field);
            }
            if (!grouped[val]) {
                grouped[val] = {
                    key: val,
                    count: 0,
                    items: [],
                    aggregates: {},
                    field: field
                };
                groupedArray.push(grouped[val]);
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(groupDs)) {
                    var tempObj = groupDs.filter(function (e) { return e.key === grouped[val].key; });
                    grouped[val].count = tempObj[0].count;
                }
            }
            grouped[val].count = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(groupDs) ? grouped[val].count : grouped[val].count += 1;
            if (!isLazyLoad || (isLazyLoad && aggregates.length)) {
                grouped[val].items.push(jsonData[i]);
            }
        };
        var this_2 = this;
        for (var i = 0; i < jsonData.length; i++) {
            _loop_2(i);
        }
        if (aggregates && aggregates.length) {
            var _loop_3 = function (i) {
                var res = {};
                var fn = void 0;
                var aggs = aggregates;
                for (var j = 0; j < aggregates.length; j++) {
                    fn = DataUtil.aggregates[aggregates[j].type];
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(groupDs)) {
                        var temp = groupDs.filter(function (e) { return e.key === groupedArray[i].key; });
                        if (fn) {
                            res[aggs[j].field + ' - ' + aggs[j].type] = fn(temp[0].items, aggs[j].field);
                        }
                    }
                    else {
                        if (fn) {
                            res[aggs[j].field + ' - ' + aggs[j].type] = fn(groupedArray[i].items, aggs[j].field);
                        }
                    }
                }
                groupedArray[i].aggregates = res;
            };
            for (var i = 0; i < groupedArray.length; i++) {
                _loop_3(i);
            }
        }
        if (isLazyLoad && groupedArray.length && aggregates.length) {
            for (var i = 0; i < groupedArray.length; i++) {
                groupedArray[i].items = [];
            }
        }
        return jsonData.length && groupedArray || jsonData;
    };
    /**
     * It is used to categorize the multiple items based on a specific field in jsonArray.
     * The hierarchical queries are commonly required when you use foreign key binding.
     * @param  {string} fKey
     * @param  {string} from
     * @param  {Object[]} source
     * @param  {Group} lookup?
     * @param  {string} pKey?
     * @hidden
     */
    DataUtil.buildHierarchy = function (fKey, from, source, lookup, pKey) {
        var i;
        var grp = {};
        var temp;
        if (lookup.result) {
            lookup = lookup.result;
        }
        if (lookup.GroupGuid) {
            this.throwError('DataManager: Do not have support Grouping in hierarchy');
        }
        for (i = 0; i < lookup.length; i++) {
            var fKeyData = this.getObject(fKey, lookup[i]);
            temp = grp[fKeyData] || (grp[fKeyData] = []);
            temp.push(lookup[i]);
        }
        for (i = 0; i < source.length; i++) {
            var fKeyData = this.getObject(pKey || fKey, source[i]);
            source[i][from] = grp[fKeyData];
        }
    };
    /**
     * The method used to get the field names which started with specified characters.
     * @param  {Object} obj
     * @param  {string[]} fields?
     * @param  {string} prefix?
     * @hidden
     */
    DataUtil.getFieldList = function (obj, fields, prefix) {
        if (prefix === undefined) {
            prefix = '';
        }
        if (fields === undefined || fields === null) {
            return this.getFieldList(obj, [], prefix);
        }
        var copyObj = obj;
        var keys = Object.keys(obj);
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var prop = keys_1[_i];
            if (typeof copyObj[prop] === 'object' && !(copyObj[prop] instanceof Array)) {
                this.getFieldList(copyObj[prop], fields, prefix + prop + '.');
            }
            else {
                fields.push(prefix + prop);
            }
        }
        return fields;
    };
    /**
     * Gets the value of the property in the given object.
     * The complex object can be accessed by providing the field names concatenated with dot(.).
     * @param  {string} nameSpace - The name of the property to be accessed.
     * @param  {Object} from - Defines the source object.
     */
    DataUtil.getObject = function (nameSpace, from) {
        if (!nameSpace) {
            return from;
        }
        if (!from) {
            return undefined;
        }
        if (nameSpace.indexOf('.') === -1) {
            return from[nameSpace];
        }
        var value = from;
        var splits = nameSpace.split('.');
        for (var i = 0; i < splits.length; i++) {
            if (value == null) {
                break;
            }
            value = value[splits[i]];
        }
        return value;
    };
    /**
     * To set value for the nameSpace in desired object.
     * @param {string} nameSpace - String value to the get the inner object.
     * @param {Object} value - Value that you need to set.
     * @param {Object} obj - Object to get the inner object value.
     * @return { [key: string]: Object; } | Object
     * @hidden
     */
    DataUtil.setValue = function (nameSpace, value, obj) {
        var keys = nameSpace.toString().split('.');
        var start = obj || {};
        var fromObj = start;
        var i;
        var length = keys.length;
        var key;
        for (i = 0; i < length; i++) {
            key = keys[i];
            if (i + 1 === length) {
                fromObj[key] = value === undefined ? undefined : value;
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fromObj[key])) {
                fromObj[key] = {};
            }
            fromObj = fromObj[key];
        }
        return start;
    };
    /**
     * Sort the given data based on the field and comparer.
     * @param  {Object[]} ds - Defines the input data.
     * @param  {string} field - Defines the field to be sorted.
     * @param  {Function} comparer - Defines the comparer function used to sort the records.
     */
    DataUtil.sort = function (ds, field, comparer) {
        if (ds.length <= 1) {
            return ds;
        }
        var middle = parseInt((ds.length / 2).toString(), 10);
        var left = ds.slice(0, middle);
        var right = ds.slice(middle);
        left = this.sort(left, field, comparer);
        right = this.sort(right, field, comparer);
        return this.merge(left, right, field, comparer);
    };
    DataUtil.ignoreDiacritics = function (value) {
        if (typeof value !== 'string') {
            return value;
        }
        var result = value.split('');
        var newValue = result.map(function (temp) { return temp in DataUtil.diacritics ? DataUtil.diacritics[temp] : temp; });
        return newValue.join('');
    };
    DataUtil.merge = function (left, right, fieldName, comparer) {
        var result = [];
        var current;
        while (left.length > 0 || right.length > 0) {
            if (left.length > 0 && right.length > 0) {
                if (comparer) {
                    current = comparer(this.getVal(left, 0, fieldName), this.getVal(right, 0, fieldName), left[0], right[0]) <= 0 ? left : right;
                }
                else {
                    current = left[0][fieldName] < left[0][fieldName] ? left : right;
                }
            }
            else {
                current = left.length > 0 ? left : right;
            }
            result.push(current.shift());
        }
        return result;
    };
    DataUtil.getVal = function (array, index, field) {
        return field ? this.getObject(field, array[index]) : array[index];
    };
    DataUtil.toLowerCase = function (val) {
        return val ? typeof val === 'string' ? val.toLowerCase() : val.toString() : (val === 0 || val === false) ? val.toString() : '';
    };
    /**
     * To perform the filter operation with specified adaptor and returns the result.
     * @param  {Object} adaptor
     * @param  {string} fnName
     * @param  {Object} param1?
     * @param  {Object} param2?
     * @hidden
     */
    DataUtil.callAdaptorFunction = function (adaptor, fnName, param1, param2) {
        if (fnName in adaptor) {
            var res = adaptor[fnName](param1, param2);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(res)) {
                param1 = res;
            }
        }
        return param1;
    };
    DataUtil.getAddParams = function (adp, dm, query) {
        var req = {};
        DataUtil.callAdaptorFunction(adp, 'addParams', {
            dm: dm,
            query: query,
            params: query.params,
            reqParams: req
        });
        return req;
    };
    /**
     * Checks wheather the given input is a plain object or not.
     * @param  {Object|Object[]} obj
     */
    DataUtil.isPlainObject = function (obj) {
        return (!!obj) && (obj.constructor === Object);
    };
    /**
     * Returns true when the browser cross origin request.
     */
    DataUtil.isCors = function () {
        var xhr = null;
        var request = 'XMLHttpRequest';
        try {
            xhr = new window[request]();
        }
        catch (e) {
            // No exception handling
        }
        return !!xhr && ('withCredentials' in xhr);
    };
    /**
     * Generate random GUID value which will be prefixed with the given value.
     * @param  {string} prefix
     */
    DataUtil.getGuid = function (prefix) {
        var hexs = '0123456789abcdef';
        var rand;
        return (prefix || '') + '00000000-0000-4000-0000-000000000000'.replace(/0/g, function (val, i) {
            if ('crypto' in window && 'getRandomValues' in crypto) {
                var arr = new Uint8Array(1);
                window.crypto.getRandomValues(arr);
                rand = arr[0] % 16 | 0;
            }
            else {
                rand = Math.random() * 16 | 0;
            }
            return hexs[i === 19 ? rand & 0x3 | 0x8 : rand];
        });
    };
    /**
     * Checks wheather the given value is null or not.
     * @param  {string|Object} val
     * @returns boolean
     */
    DataUtil.isNull = function (val) {
        return val === undefined || val === null;
    };
    /**
     * To get the required items from collection of objects.
     * @param  {Object[]} array
     * @param  {string} field
     * @param  {Function} comparer
     * @returns Object
     * @hidden
     */
    DataUtil.getItemFromComparer = function (array, field, comparer) {
        var keyVal;
        var current;
        var key;
        var i = 0;
        var castRequired = typeof DataUtil.getVal(array, 0, field) === 'string';
        if (array.length) {
            while (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(keyVal) && i < array.length) {
                keyVal = DataUtil.getVal(array, i, field);
                key = array[i++];
            }
        }
        for (; i < array.length; i++) {
            current = DataUtil.getVal(array, i, field);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(current)) {
                continue;
            }
            if (castRequired) {
                keyVal = +keyVal;
                current = +current;
            }
            if (comparer(keyVal, current) > 0) {
                keyVal = current;
                key = array[i];
            }
        }
        return key;
    };
    /**
     * To get distinct values of Array or Array of Objects.
     * @param  {Object[]} json
     * @param  {string} field
     * @param  {boolean} requiresCompleteRecord
     * @returns Object[]
     * * distinct array of objects is return when requiresCompleteRecord set as true.
     * @hidden
     */
    DataUtil.distinct = function (json, fieldName, requiresCompleteRecord) {
        requiresCompleteRecord = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(requiresCompleteRecord) ? false : requiresCompleteRecord;
        var result = [];
        var val;
        var tmp = {};
        json.forEach(function (data, index) {
            val = typeof (json[index]) === 'object' ? DataUtil.getVal(json, index, fieldName) : json[index];
            if (!(val in tmp)) {
                result.push(!requiresCompleteRecord ? val : json[index]);
                tmp[val] = 1;
            }
        });
        return result;
    };
    /**
     * Process the given records based on the datamanager string.
     * @param  {string} datamanager
     * @param  {Object[]} records
     */
    DataUtil.processData = function (dm, records) {
        var query = this.prepareQuery(dm);
        var sampledata = new __WEBPACK_IMPORTED_MODULE_1__manager__["a" /* DataManager */](records);
        if (dm.requiresCounts) {
            query.requiresCount();
        }
        var result = sampledata.executeLocal(query);
        var returnValue = {
            result: dm.requiresCounts ? result.result : result,
            count: result.count,
            aggregates: JSON.stringify(result.aggregates)
        };
        return dm.requiresCounts ? returnValue : result;
    };
    DataUtil.prepareQuery = function (dm) {
        var _this = this;
        var query = new __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */]();
        if (dm.select) {
            query.select(dm.select);
        }
        if (dm.where) {
            var where = DataUtil.parse.parseJson(dm.where);
            where.filter(function (pred) {
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(pred.condition)) {
                    query.where(pred.field, pred.operator, pred.value, pred.ignoreCase, pred.ignoreAccent);
                }
                else {
                    var predicateList = [];
                    if (pred.field) {
                        predicateList.push(new __WEBPACK_IMPORTED_MODULE_2__query__["a" /* Predicate */](pred.field, pred.operator, pred.value, pred.ignoreCase, pred.ignoreAccent));
                    }
                    else {
                        predicateList = predicateList.concat(_this.getPredicate(pred.predicates));
                    }
                    if (pred.condition == 'or') {
                        query.where(__WEBPACK_IMPORTED_MODULE_2__query__["a" /* Predicate */].or(predicateList));
                    }
                    else if (pred.condition == 'and') {
                        query.where(__WEBPACK_IMPORTED_MODULE_2__query__["a" /* Predicate */].and(predicateList));
                    }
                }
            });
        }
        if (dm.search) {
            var search = DataUtil.parse.parseJson(dm.search);
            search.filter(function (e) { return query.search(e.key, e.fields, e['operator'], e['ignoreCase'], e['ignoreAccent']); });
        }
        if (dm.aggregates) {
            dm.aggregates.filter(function (e) { return query.aggregate(e.type, e.field); });
        }
        if (dm.sorted) {
            dm.sorted.filter(function (e) { return query.sortBy(e.name, e.direction); });
        }
        if (dm.skip) {
            query.skip(dm.skip);
        }
        if (dm.take) {
            query.take(dm.take);
        }
        if (dm.group) {
            dm.group.filter(function (grp) { return query.group(grp); });
        }
        return query;
    };
    DataUtil.getPredicate = function (pred) {
        var mainPred = [];
        for (var i = 0; i < pred.length; i++) {
            var e = pred[i];
            if (e.field) {
                mainPred.push(new __WEBPACK_IMPORTED_MODULE_2__query__["a" /* Predicate */](e.field, e.operator, e.value, e.ignoreCase, e.ignoreAccent));
            }
            else {
                var childPred = [];
                var cpre = this.getPredicate(e.predicates);
                for (var _i = 0, _a = Object.keys(cpre); _i < _a.length; _i++) {
                    var prop = _a[_i];
                    childPred.push(cpre[prop]);
                }
                mainPred.push(e.condition == 'or' ? __WEBPACK_IMPORTED_MODULE_2__query__["a" /* Predicate */].or(childPred) : __WEBPACK_IMPORTED_MODULE_2__query__["a" /* Predicate */].and(childPred));
            }
        }
        return mainPred;
    };
    /**
     * Specifies the value which will be used to adjust the date value to server timezone.
     * @default null
     */
    DataUtil.serverTimezoneOffset = null;
    /**
     * Species whether are not to be parsed with serverTimezoneOffset value.
     * @hidden
     */
    DataUtil.timeZoneHandling = true;
    /**
     * Throw error with the given string as message.
     * @param  {string} er
     */
    DataUtil.throwError = function (error) {
        try {
            throw new Error(error);
        }
        catch (e) {
            throw e.message + '\n' + e.stack;
        }
    };
    DataUtil.aggregates = {
        /**
         * Calculate sum of the given field in the data.
         * @param  {Object[]} ds
         * @param  {string} field
         */
        sum: function (ds, field) {
            var result = 0;
            var val;
            var castRequired = typeof DataUtil.getVal(ds, 0, field) !== 'number';
            for (var i = 0; i < ds.length; i++) {
                val = DataUtil.getVal(ds, i, field);
                if (!isNaN(val) && val !== null) {
                    if (castRequired) {
                        val = +val;
                    }
                    result += val;
                }
            }
            return result;
        },
        /**
         * Calculate average value of the given field in the data.
         * @param  {Object[]} ds
         * @param  {string} field
         */
        average: function (ds, field) {
            return DataUtil.aggregates.sum(ds, field) / ds.length;
        },
        /**
         * Returns the min value of the data based on the field.
         * @param  {Object[]} ds
         * @param  {string|Function} field
         */
        min: function (ds, field) {
            var comparer;
            if (typeof field === 'function') {
                comparer = field;
                field = null;
            }
            return DataUtil.getObject(field, DataUtil.getItemFromComparer(ds, field, comparer || DataUtil.fnAscending));
        },
        /**
         * Returns the max value of the data based on the field.
         * @param  {Object[]} ds
         * @param  {string} field
         * @returns number
         */
        max: function (ds, field) {
            var comparer;
            if (typeof field === 'function') {
                comparer = field;
                field = null;
            }
            return DataUtil.getObject(field, DataUtil.getItemFromComparer(ds, field, comparer || DataUtil.fnDescending));
        },
        /**
         * Returns the total number of true value present in the data based on the given boolean field name.
         * @param  {Object[]} ds
         * @param  {string} field
         */
        truecount: function (ds, field) {
            return new __WEBPACK_IMPORTED_MODULE_1__manager__["a" /* DataManager */](ds).executeLocal(new __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */]().where(field, 'equal', true, true)).length;
        },
        /**
         * Returns the total number of false value present in the data based on the given boolean field name.
         * @param  {Object[]} ds
         * @param  {string} field
         */
        falsecount: function (ds, field) {
            return new __WEBPACK_IMPORTED_MODULE_1__manager__["a" /* DataManager */](ds).executeLocal(new __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */]().where(field, 'equal', false, true)).length;
        },
        /**
         * Returns the length of the given data.
         * @param  {Object[]} ds
         * @param  {string} field?
         * @returns number
         */
        count: function (ds, field) {
            return ds.length;
        }
    };
    /**
     * Specifies the Object with filter operators.
     */
    DataUtil.operatorSymbols = {
        '<': 'lessthan',
        '>': 'greaterthan',
        '<=': 'lessthanorequal',
        '>=': 'greaterthanorequal',
        '==': 'equal',
        '!=': 'notequal',
        '*=': 'contains',
        '$=': 'endswith',
        '^=': 'startswith'
    };
    /**
     * Specifies the Object with filter operators which will be used for OData filter query generation.
     * * It will be used for date/number type filter query.
     */
    DataUtil.odBiOperator = {
        '<': ' lt ',
        '>': ' gt ',
        '<=': ' le ',
        '>=': ' ge ',
        '==': ' eq ',
        '!=': ' ne ',
        'lessthan': ' lt ',
        'lessthanorequal': ' le ',
        'greaterthan': ' gt ',
        'greaterthanorequal': ' ge ',
        'equal': ' eq ',
        'notequal': ' ne '
    };
    /**
     * Specifies the Object with filter operators which will be used for OData filter query generation.
     * It will be used for string type filter query.
     */
    DataUtil.odUniOperator = {
        '$=': 'endswith',
        '^=': 'startswith',
        '*=': 'substringof',
        'endswith': 'endswith',
        'startswith': 'startswith',
        'contains': 'substringof'
    };
    /**
     * Specifies the Object with filter operators which will be used for ODataV4 filter query generation.
     * It will be used for string type filter query.
     */
    DataUtil.odv4UniOperator = {
        '$=': 'endswith',
        '^=': 'startswith',
        '*=': 'contains',
        'endswith': 'endswith',
        'startswith': 'startswith',
        'contains': 'contains'
    };
    DataUtil.diacritics = {
        '\u24B6': 'A',
        '\uFF21': 'A',
        '\u00C0': 'A',
        '\u00C1': 'A',
        '\u00C2': 'A',
        '\u1EA6': 'A',
        '\u1EA4': 'A',
        '\u1EAA': 'A',
        '\u1EA8': 'A',
        '\u00C3': 'A',
        '\u0100': 'A',
        '\u0102': 'A',
        '\u1EB0': 'A',
        '\u1EAE': 'A',
        '\u1EB4': 'A',
        '\u1EB2': 'A',
        '\u0226': 'A',
        '\u01E0': 'A',
        '\u00C4': 'A',
        '\u01DE': 'A',
        '\u1EA2': 'A',
        '\u00C5': 'A',
        '\u01FA': 'A',
        '\u01CD': 'A',
        '\u0200': 'A',
        '\u0202': 'A',
        '\u1EA0': 'A',
        '\u1EAC': 'A',
        '\u1EB6': 'A',
        '\u1E00': 'A',
        '\u0104': 'A',
        '\u023A': 'A',
        '\u2C6F': 'A',
        '\uA732': 'AA',
        '\u00C6': 'AE',
        '\u01FC': 'AE',
        '\u01E2': 'AE',
        '\uA734': 'AO',
        '\uA736': 'AU',
        '\uA738': 'AV',
        '\uA73A': 'AV',
        '\uA73C': 'AY',
        '\u24B7': 'B',
        '\uFF22': 'B',
        '\u1E02': 'B',
        '\u1E04': 'B',
        '\u1E06': 'B',
        '\u0243': 'B',
        '\u0182': 'B',
        '\u0181': 'B',
        '\u24B8': 'C',
        '\uFF23': 'C',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010A': 'C',
        '\u010C': 'C',
        '\u00C7': 'C',
        '\u1E08': 'C',
        '\u0187': 'C',
        '\u023B': 'C',
        '\uA73E': 'C',
        '\u24B9': 'D',
        '\uFF24': 'D',
        '\u1E0A': 'D',
        '\u010E': 'D',
        '\u1E0C': 'D',
        '\u1E10': 'D',
        '\u1E12': 'D',
        '\u1E0E': 'D',
        '\u0110': 'D',
        '\u018B': 'D',
        '\u018A': 'D',
        '\u0189': 'D',
        '\uA779': 'D',
        '\u01F1': 'DZ',
        '\u01C4': 'DZ',
        '\u01F2': 'Dz',
        '\u01C5': 'Dz',
        '\u24BA': 'E',
        '\uFF25': 'E',
        '\u00C8': 'E',
        '\u00C9': 'E',
        '\u00CA': 'E',
        '\u1EC0': 'E',
        '\u1EBE': 'E',
        '\u1EC4': 'E',
        '\u1EC2': 'E',
        '\u1EBC': 'E',
        '\u0112': 'E',
        '\u1E14': 'E',
        '\u1E16': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u00CB': 'E',
        '\u1EBA': 'E',
        '\u011A': 'E',
        '\u0204': 'E',
        '\u0206': 'E',
        '\u1EB8': 'E',
        '\u1EC6': 'E',
        '\u0228': 'E',
        '\u1E1C': 'E',
        '\u0118': 'E',
        '\u1E18': 'E',
        '\u1E1A': 'E',
        '\u0190': 'E',
        '\u018E': 'E',
        '\u24BB': 'F',
        '\uFF26': 'F',
        '\u1E1E': 'F',
        '\u0191': 'F',
        '\uA77B': 'F',
        '\u24BC': 'G',
        '\uFF27': 'G',
        '\u01F4': 'G',
        '\u011C': 'G',
        '\u1E20': 'G',
        '\u011E': 'G',
        '\u0120': 'G',
        '\u01E6': 'G',
        '\u0122': 'G',
        '\u01E4': 'G',
        '\u0193': 'G',
        '\uA7A0': 'G',
        '\uA77D': 'G',
        '\uA77E': 'G',
        '\u24BD': 'H',
        '\uFF28': 'H',
        '\u0124': 'H',
        '\u1E22': 'H',
        '\u1E26': 'H',
        '\u021E': 'H',
        '\u1E24': 'H',
        '\u1E28': 'H',
        '\u1E2A': 'H',
        '\u0126': 'H',
        '\u2C67': 'H',
        '\u2C75': 'H',
        '\uA78D': 'H',
        '\u24BE': 'I',
        '\uFF29': 'I',
        '\u00CC': 'I',
        '\u00CD': 'I',
        '\u00CE': 'I',
        '\u0128': 'I',
        '\u012A': 'I',
        '\u012C': 'I',
        '\u0130': 'I',
        '\u00CF': 'I',
        '\u1E2E': 'I',
        '\u1EC8': 'I',
        '\u01CF': 'I',
        '\u0208': 'I',
        '\u020A': 'I',
        '\u1ECA': 'I',
        '\u012E': 'I',
        '\u1E2C': 'I',
        '\u0197': 'I',
        '\u24BF': 'J',
        '\uFF2A': 'J',
        '\u0134': 'J',
        '\u0248': 'J',
        '\u24C0': 'K',
        '\uFF2B': 'K',
        '\u1E30': 'K',
        '\u01E8': 'K',
        '\u1E32': 'K',
        '\u0136': 'K',
        '\u1E34': 'K',
        '\u0198': 'K',
        '\u2C69': 'K',
        '\uA740': 'K',
        '\uA742': 'K',
        '\uA744': 'K',
        '\uA7A2': 'K',
        '\u24C1': 'L',
        '\uFF2C': 'L',
        '\u013F': 'L',
        '\u0139': 'L',
        '\u013D': 'L',
        '\u1E36': 'L',
        '\u1E38': 'L',
        '\u013B': 'L',
        '\u1E3C': 'L',
        '\u1E3A': 'L',
        '\u0141': 'L',
        '\u023D': 'L',
        '\u2C62': 'L',
        '\u2C60': 'L',
        '\uA748': 'L',
        '\uA746': 'L',
        '\uA780': 'L',
        '\u01C7': 'LJ',
        '\u01C8': 'Lj',
        '\u24C2': 'M',
        '\uFF2D': 'M',
        '\u1E3E': 'M',
        '\u1E40': 'M',
        '\u1E42': 'M',
        '\u2C6E': 'M',
        '\u019C': 'M',
        '\u24C3': 'N',
        '\uFF2E': 'N',
        '\u01F8': 'N',
        '\u0143': 'N',
        '\u00D1': 'N',
        '\u1E44': 'N',
        '\u0147': 'N',
        '\u1E46': 'N',
        '\u0145': 'N',
        '\u1E4A': 'N',
        '\u1E48': 'N',
        '\u0220': 'N',
        '\u019D': 'N',
        '\uA790': 'N',
        '\uA7A4': 'N',
        '\u01CA': 'NJ',
        '\u01CB': 'Nj',
        '\u24C4': 'O',
        '\uFF2F': 'O',
        '\u00D2': 'O',
        '\u00D3': 'O',
        '\u00D4': 'O',
        '\u1ED2': 'O',
        '\u1ED0': 'O',
        '\u1ED6': 'O',
        '\u1ED4': 'O',
        '\u00D5': 'O',
        '\u1E4C': 'O',
        '\u022C': 'O',
        '\u1E4E': 'O',
        '\u014C': 'O',
        '\u1E50': 'O',
        '\u1E52': 'O',
        '\u014E': 'O',
        '\u022E': 'O',
        '\u0230': 'O',
        '\u00D6': 'O',
        '\u022A': 'O',
        '\u1ECE': 'O',
        '\u0150': 'O',
        '\u01D1': 'O',
        '\u020C': 'O',
        '\u020E': 'O',
        '\u01A0': 'O',
        '\u1EDC': 'O',
        '\u1EDA': 'O',
        '\u1EE0': 'O',
        '\u1EDE': 'O',
        '\u1EE2': 'O',
        '\u1ECC': 'O',
        '\u1ED8': 'O',
        '\u01EA': 'O',
        '\u01EC': 'O',
        '\u00D8': 'O',
        '\u01FE': 'O',
        '\u0186': 'O',
        '\u019F': 'O',
        '\uA74A': 'O',
        '\uA74C': 'O',
        '\u01A2': 'OI',
        '\uA74E': 'OO',
        '\u0222': 'OU',
        '\u24C5': 'P',
        '\uFF30': 'P',
        '\u1E54': 'P',
        '\u1E56': 'P',
        '\u01A4': 'P',
        '\u2C63': 'P',
        '\uA750': 'P',
        '\uA752': 'P',
        '\uA754': 'P',
        '\u24C6': 'Q',
        '\uFF31': 'Q',
        '\uA756': 'Q',
        '\uA758': 'Q',
        '\u024A': 'Q',
        '\u24C7': 'R',
        '\uFF32': 'R',
        '\u0154': 'R',
        '\u1E58': 'R',
        '\u0158': 'R',
        '\u0210': 'R',
        '\u0212': 'R',
        '\u1E5A': 'R',
        '\u1E5C': 'R',
        '\u0156': 'R',
        '\u1E5E': 'R',
        '\u024C': 'R',
        '\u2C64': 'R',
        '\uA75A': 'R',
        '\uA7A6': 'R',
        '\uA782': 'R',
        '\u24C8': 'S',
        '\uFF33': 'S',
        '\u1E9E': 'S',
        '\u015A': 'S',
        '\u1E64': 'S',
        '\u015C': 'S',
        '\u1E60': 'S',
        '\u0160': 'S',
        '\u1E66': 'S',
        '\u1E62': 'S',
        '\u1E68': 'S',
        '\u0218': 'S',
        '\u015E': 'S',
        '\u2C7E': 'S',
        '\uA7A8': 'S',
        '\uA784': 'S',
        '\u24C9': 'T',
        '\uFF34': 'T',
        '\u1E6A': 'T',
        '\u0164': 'T',
        '\u1E6C': 'T',
        '\u021A': 'T',
        '\u0162': 'T',
        '\u1E70': 'T',
        '\u1E6E': 'T',
        '\u0166': 'T',
        '\u01AC': 'T',
        '\u01AE': 'T',
        '\u023E': 'T',
        '\uA786': 'T',
        '\uA728': 'TZ',
        '\u24CA': 'U',
        '\uFF35': 'U',
        '\u00D9': 'U',
        '\u00DA': 'U',
        '\u00DB': 'U',
        '\u0168': 'U',
        '\u1E78': 'U',
        '\u016A': 'U',
        '\u1E7A': 'U',
        '\u016C': 'U',
        '\u00DC': 'U',
        '\u01DB': 'U',
        '\u01D7': 'U',
        '\u01D5': 'U',
        '\u01D9': 'U',
        '\u1EE6': 'U',
        '\u016E': 'U',
        '\u0170': 'U',
        '\u01D3': 'U',
        '\u0214': 'U',
        '\u0216': 'U',
        '\u01AF': 'U',
        '\u1EEA': 'U',
        '\u1EE8': 'U',
        '\u1EEE': 'U',
        '\u1EEC': 'U',
        '\u1EF0': 'U',
        '\u1EE4': 'U',
        '\u1E72': 'U',
        '\u0172': 'U',
        '\u1E76': 'U',
        '\u1E74': 'U',
        '\u0244': 'U',
        '\u24CB': 'V',
        '\uFF36': 'V',
        '\u1E7C': 'V',
        '\u1E7E': 'V',
        '\u01B2': 'V',
        '\uA75E': 'V',
        '\u0245': 'V',
        '\uA760': 'VY',
        '\u24CC': 'W',
        '\uFF37': 'W',
        '\u1E80': 'W',
        '\u1E82': 'W',
        '\u0174': 'W',
        '\u1E86': 'W',
        '\u1E84': 'W',
        '\u1E88': 'W',
        '\u2C72': 'W',
        '\u24CD': 'X',
        '\uFF38': 'X',
        '\u1E8A': 'X',
        '\u1E8C': 'X',
        '\u24CE': 'Y',
        '\uFF39': 'Y',
        '\u1EF2': 'Y',
        '\u00DD': 'Y',
        '\u0176': 'Y',
        '\u1EF8': 'Y',
        '\u0232': 'Y',
        '\u1E8E': 'Y',
        '\u0178': 'Y',
        '\u1EF6': 'Y',
        '\u1EF4': 'Y',
        '\u01B3': 'Y',
        '\u024E': 'Y',
        '\u1EFE': 'Y',
        '\u24CF': 'Z',
        '\uFF3A': 'Z',
        '\u0179': 'Z',
        '\u1E90': 'Z',
        '\u017B': 'Z',
        '\u017D': 'Z',
        '\u1E92': 'Z',
        '\u1E94': 'Z',
        '\u01B5': 'Z',
        '\u0224': 'Z',
        '\u2C7F': 'Z',
        '\u2C6B': 'Z',
        '\uA762': 'Z',
        '\u24D0': 'a',
        '\uFF41': 'a',
        '\u1E9A': 'a',
        '\u00E0': 'a',
        '\u00E1': 'a',
        '\u00E2': 'a',
        '\u1EA7': 'a',
        '\u1EA5': 'a',
        '\u1EAB': 'a',
        '\u1EA9': 'a',
        '\u00E3': 'a',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u1EB1': 'a',
        '\u1EAF': 'a',
        '\u1EB5': 'a',
        '\u1EB3': 'a',
        '\u0227': 'a',
        '\u01E1': 'a',
        '\u00E4': 'a',
        '\u01DF': 'a',
        '\u1EA3': 'a',
        '\u00E5': 'a',
        '\u01FB': 'a',
        '\u01CE': 'a',
        '\u0201': 'a',
        '\u0203': 'a',
        '\u1EA1': 'a',
        '\u1EAD': 'a',
        '\u1EB7': 'a',
        '\u1E01': 'a',
        '\u0105': 'a',
        '\u2C65': 'a',
        '\u0250': 'a',
        '\uA733': 'aa',
        '\u00E6': 'ae',
        '\u01FD': 'ae',
        '\u01E3': 'ae',
        '\uA735': 'ao',
        '\uA737': 'au',
        '\uA739': 'av',
        '\uA73B': 'av',
        '\uA73D': 'ay',
        '\u24D1': 'b',
        '\uFF42': 'b',
        '\u1E03': 'b',
        '\u1E05': 'b',
        '\u1E07': 'b',
        '\u0180': 'b',
        '\u0183': 'b',
        '\u0253': 'b',
        '\u24D2': 'c',
        '\uFF43': 'c',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010B': 'c',
        '\u010D': 'c',
        '\u00E7': 'c',
        '\u1E09': 'c',
        '\u0188': 'c',
        '\u023C': 'c',
        '\uA73F': 'c',
        '\u2184': 'c',
        '\u24D3': 'd',
        '\uFF44': 'd',
        '\u1E0B': 'd',
        '\u010F': 'd',
        '\u1E0D': 'd',
        '\u1E11': 'd',
        '\u1E13': 'd',
        '\u1E0F': 'd',
        '\u0111': 'd',
        '\u018C': 'd',
        '\u0256': 'd',
        '\u0257': 'd',
        '\uA77A': 'd',
        '\u01F3': 'dz',
        '\u01C6': 'dz',
        '\u24D4': 'e',
        '\uFF45': 'e',
        '\u00E8': 'e',
        '\u00E9': 'e',
        '\u00EA': 'e',
        '\u1EC1': 'e',
        '\u1EBF': 'e',
        '\u1EC5': 'e',
        '\u1EC3': 'e',
        '\u1EBD': 'e',
        '\u0113': 'e',
        '\u1E15': 'e',
        '\u1E17': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u00EB': 'e',
        '\u1EBB': 'e',
        '\u011B': 'e',
        '\u0205': 'e',
        '\u0207': 'e',
        '\u1EB9': 'e',
        '\u1EC7': 'e',
        '\u0229': 'e',
        '\u1E1D': 'e',
        '\u0119': 'e',
        '\u1E19': 'e',
        '\u1E1B': 'e',
        '\u0247': 'e',
        '\u025B': 'e',
        '\u01DD': 'e',
        '\u24D5': 'f',
        '\uFF46': 'f',
        '\u1E1F': 'f',
        '\u0192': 'f',
        '\uA77C': 'f',
        '\u24D6': 'g',
        '\uFF47': 'g',
        '\u01F5': 'g',
        '\u011D': 'g',
        '\u1E21': 'g',
        '\u011F': 'g',
        '\u0121': 'g',
        '\u01E7': 'g',
        '\u0123': 'g',
        '\u01E5': 'g',
        '\u0260': 'g',
        '\uA7A1': 'g',
        '\u1D79': 'g',
        '\uA77F': 'g',
        '\u24D7': 'h',
        '\uFF48': 'h',
        '\u0125': 'h',
        '\u1E23': 'h',
        '\u1E27': 'h',
        '\u021F': 'h',
        '\u1E25': 'h',
        '\u1E29': 'h',
        '\u1E2B': 'h',
        '\u1E96': 'h',
        '\u0127': 'h',
        '\u2C68': 'h',
        '\u2C76': 'h',
        '\u0265': 'h',
        '\u0195': 'hv',
        '\u24D8': 'i',
        '\uFF49': 'i',
        '\u00EC': 'i',
        '\u00ED': 'i',
        '\u00EE': 'i',
        '\u0129': 'i',
        '\u012B': 'i',
        '\u012D': 'i',
        '\u00EF': 'i',
        '\u1E2F': 'i',
        '\u1EC9': 'i',
        '\u01D0': 'i',
        '\u0209': 'i',
        '\u020B': 'i',
        '\u1ECB': 'i',
        '\u012F': 'i',
        '\u1E2D': 'i',
        '\u0268': 'i',
        '\u0131': 'i',
        '\u24D9': 'j',
        '\uFF4A': 'j',
        '\u0135': 'j',
        '\u01F0': 'j',
        '\u0249': 'j',
        '\u24DA': 'k',
        '\uFF4B': 'k',
        '\u1E31': 'k',
        '\u01E9': 'k',
        '\u1E33': 'k',
        '\u0137': 'k',
        '\u1E35': 'k',
        '\u0199': 'k',
        '\u2C6A': 'k',
        '\uA741': 'k',
        '\uA743': 'k',
        '\uA745': 'k',
        '\uA7A3': 'k',
        '\u24DB': 'l',
        '\uFF4C': 'l',
        '\u0140': 'l',
        '\u013A': 'l',
        '\u013E': 'l',
        '\u1E37': 'l',
        '\u1E39': 'l',
        '\u013C': 'l',
        '\u1E3D': 'l',
        '\u1E3B': 'l',
        '\u017F': 'l',
        '\u0142': 'l',
        '\u019A': 'l',
        '\u026B': 'l',
        '\u2C61': 'l',
        '\uA749': 'l',
        '\uA781': 'l',
        '\uA747': 'l',
        '\u01C9': 'lj',
        '\u24DC': 'm',
        '\uFF4D': 'm',
        '\u1E3F': 'm',
        '\u1E41': 'm',
        '\u1E43': 'm',
        '\u0271': 'm',
        '\u026F': 'm',
        '\u24DD': 'n',
        '\uFF4E': 'n',
        '\u01F9': 'n',
        '\u0144': 'n',
        '\u00F1': 'n',
        '\u1E45': 'n',
        '\u0148': 'n',
        '\u1E47': 'n',
        '\u0146': 'n',
        '\u1E4B': 'n',
        '\u1E49': 'n',
        '\u019E': 'n',
        '\u0272': 'n',
        '\u0149': 'n',
        '\uA791': 'n',
        '\uA7A5': 'n',
        '\u01CC': 'nj',
        '\u24DE': 'o',
        '\uFF4F': 'o',
        '\u00F2': 'o',
        '\u00F3': 'o',
        '\u00F4': 'o',
        '\u1ED3': 'o',
        '\u1ED1': 'o',
        '\u1ED7': 'o',
        '\u1ED5': 'o',
        '\u00F5': 'o',
        '\u1E4D': 'o',
        '\u022D': 'o',
        '\u1E4F': 'o',
        '\u014D': 'o',
        '\u1E51': 'o',
        '\u1E53': 'o',
        '\u014F': 'o',
        '\u022F': 'o',
        '\u0231': 'o',
        '\u00F6': 'o',
        '\u022B': 'o',
        '\u1ECF': 'o',
        '\u0151': 'o',
        '\u01D2': 'o',
        '\u020D': 'o',
        '\u020F': 'o',
        '\u01A1': 'o',
        '\u1EDD': 'o',
        '\u1EDB': 'o',
        '\u1EE1': 'o',
        '\u1EDF': 'o',
        '\u1EE3': 'o',
        '\u1ECD': 'o',
        '\u1ED9': 'o',
        '\u01EB': 'o',
        '\u01ED': 'o',
        '\u00F8': 'o',
        '\u01FF': 'o',
        '\u0254': 'o',
        '\uA74B': 'o',
        '\uA74D': 'o',
        '\u0275': 'o',
        '\u01A3': 'oi',
        '\u0223': 'ou',
        '\uA74F': 'oo',
        '\u24DF': 'p',
        '\uFF50': 'p',
        '\u1E55': 'p',
        '\u1E57': 'p',
        '\u01A5': 'p',
        '\u1D7D': 'p',
        '\uA751': 'p',
        '\uA753': 'p',
        '\uA755': 'p',
        '\u24E0': 'q',
        '\uFF51': 'q',
        '\u024B': 'q',
        '\uA757': 'q',
        '\uA759': 'q',
        '\u24E1': 'r',
        '\uFF52': 'r',
        '\u0155': 'r',
        '\u1E59': 'r',
        '\u0159': 'r',
        '\u0211': 'r',
        '\u0213': 'r',
        '\u1E5B': 'r',
        '\u1E5D': 'r',
        '\u0157': 'r',
        '\u1E5F': 'r',
        '\u024D': 'r',
        '\u027D': 'r',
        '\uA75B': 'r',
        '\uA7A7': 'r',
        '\uA783': 'r',
        '\u24E2': 's',
        '\uFF53': 's',
        '\u00DF': 's',
        '\u015B': 's',
        '\u1E65': 's',
        '\u015D': 's',
        '\u1E61': 's',
        '\u0161': 's',
        '\u1E67': 's',
        '\u1E63': 's',
        '\u1E69': 's',
        '\u0219': 's',
        '\u015F': 's',
        '\u023F': 's',
        '\uA7A9': 's',
        '\uA785': 's',
        '\u1E9B': 's',
        '\u24E3': 't',
        '\uFF54': 't',
        '\u1E6B': 't',
        '\u1E97': 't',
        '\u0165': 't',
        '\u1E6D': 't',
        '\u021B': 't',
        '\u0163': 't',
        '\u1E71': 't',
        '\u1E6F': 't',
        '\u0167': 't',
        '\u01AD': 't',
        '\u0288': 't',
        '\u2C66': 't',
        '\uA787': 't',
        '\uA729': 'tz',
        '\u24E4': 'u',
        '\uFF55': 'u',
        '\u00F9': 'u',
        '\u00FA': 'u',
        '\u00FB': 'u',
        '\u0169': 'u',
        '\u1E79': 'u',
        '\u016B': 'u',
        '\u1E7B': 'u',
        '\u016D': 'u',
        '\u00FC': 'u',
        '\u01DC': 'u',
        '\u01D8': 'u',
        '\u01D6': 'u',
        '\u01DA': 'u',
        '\u1EE7': 'u',
        '\u016F': 'u',
        '\u0171': 'u',
        '\u01D4': 'u',
        '\u0215': 'u',
        '\u0217': 'u',
        '\u01B0': 'u',
        '\u1EEB': 'u',
        '\u1EE9': 'u',
        '\u1EEF': 'u',
        '\u1EED': 'u',
        '\u1EF1': 'u',
        '\u1EE5': 'u',
        '\u1E73': 'u',
        '\u0173': 'u',
        '\u1E77': 'u',
        '\u1E75': 'u',
        '\u0289': 'u',
        '\u24E5': 'v',
        '\uFF56': 'v',
        '\u1E7D': 'v',
        '\u1E7F': 'v',
        '\u028B': 'v',
        '\uA75F': 'v',
        '\u028C': 'v',
        '\uA761': 'vy',
        '\u24E6': 'w',
        '\uFF57': 'w',
        '\u1E81': 'w',
        '\u1E83': 'w',
        '\u0175': 'w',
        '\u1E87': 'w',
        '\u1E85': 'w',
        '\u1E98': 'w',
        '\u1E89': 'w',
        '\u2C73': 'w',
        '\u24E7': 'x',
        '\uFF58': 'x',
        '\u1E8B': 'x',
        '\u1E8D': 'x',
        '\u24E8': 'y',
        '\uFF59': 'y',
        '\u1EF3': 'y',
        '\u00FD': 'y',
        '\u0177': 'y',
        '\u1EF9': 'y',
        '\u0233': 'y',
        '\u1E8F': 'y',
        '\u00FF': 'y',
        '\u1EF7': 'y',
        '\u1E99': 'y',
        '\u1EF5': 'y',
        '\u01B4': 'y',
        '\u024F': 'y',
        '\u1EFF': 'y',
        '\u24E9': 'z',
        '\uFF5A': 'z',
        '\u017A': 'z',
        '\u1E91': 'z',
        '\u017C': 'z',
        '\u017E': 'z',
        '\u1E93': 'z',
        '\u1E95': 'z',
        '\u01B6': 'z',
        '\u0225': 'z',
        '\u0240': 'z',
        '\u2C6C': 'z',
        '\uA763': 'z',
        '\u0386': '\u0391',
        '\u0388': '\u0395',
        '\u0389': '\u0397',
        '\u038A': '\u0399',
        '\u03AA': '\u0399',
        '\u038C': '\u039F',
        '\u038E': '\u03A5',
        '\u03AB': '\u03A5',
        '\u038F': '\u03A9',
        '\u03AC': '\u03B1',
        '\u03AD': '\u03B5',
        '\u03AE': '\u03B7',
        '\u03AF': '\u03B9',
        '\u03CA': '\u03B9',
        '\u0390': '\u03B9',
        '\u03CC': '\u03BF',
        '\u03CD': '\u03C5',
        '\u03CB': '\u03C5',
        '\u03B0': '\u03C5',
        '\u03C9': '\u03C9',
        '\u03C2': '\u03C3'
    };
    DataUtil.fnOperators = {
        /**
         * Returns true when the actual input is equal to the given input.
         * @param  {string|number|boolean} actual
         * @param  {string|number|boolean} expected
         * @param  {boolean} ignoreCase?
         * @param  {boolean} ignoreAccent?
         */
        equal: function (actual, expected, ignoreCase, ignoreAccent) {
            if (ignoreAccent) {
                actual = DataUtil.ignoreDiacritics(actual);
                expected = DataUtil.ignoreDiacritics(expected);
            }
            if (ignoreCase) {
                return DataUtil.toLowerCase(actual) === DataUtil.toLowerCase(expected);
            }
            return actual === expected;
        },
        /**
         * Returns true when the actual input is not equal to the given input.
         * @param  {string|number|boolean} actual
         * @param  {string|number|boolean} expected
         * @param  {boolean} ignoreCase?
         */
        notequal: function (actual, expected, ignoreCase, ignoreAccent) {
            if (ignoreAccent) {
                actual = DataUtil.ignoreDiacritics(actual);
                expected = DataUtil.ignoreDiacritics(expected);
            }
            return !DataUtil.fnOperators.equal(actual, expected, ignoreCase);
        },
        /**
         * Returns true when the actual input is less than to the given input.
         * @param  {string|number|boolean} actual
         * @param  {string|number|boolean} expected
         * @param  {boolean} ignoreCase?
         */
        lessthan: function (actual, expected, ignoreCase) {
            if (ignoreCase) {
                return DataUtil.toLowerCase(actual) < DataUtil.toLowerCase(expected);
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(actual)) {
                actual = undefined;
            }
            return actual < expected;
        },
        /**
         * Returns true when the actual input is greater than to the given input.
         * @param  {string|number|boolean} actual
         * @param  {string|number|boolean} expected
         * @param  {boolean} ignoreCase?
         */
        greaterthan: function (actual, expected, ignoreCase) {
            if (ignoreCase) {
                return DataUtil.toLowerCase(actual) > DataUtil.toLowerCase(expected);
            }
            return actual > expected;
        },
        /**
         * Returns true when the actual input is less than or equal to the given input.
         * @param  {string|number|boolean} actual
         * @param  {string|number|boolean} expected
         * @param  {boolean} ignoreCase?
         */
        lessthanorequal: function (actual, expected, ignoreCase) {
            if (ignoreCase) {
                return DataUtil.toLowerCase(actual) <= DataUtil.toLowerCase(expected);
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(actual)) {
                actual = undefined;
            }
            return actual <= expected;
        },
        /**
         * Returns true when the actual input is greater than or equal to the given input.
         * @param  {string|number|boolean} actual
         * @param  {string|number|boolean} expected
         * @param  {boolean} ignoreCase?
         */
        greaterthanorequal: function (actual, expected, ignoreCase) {
            if (ignoreCase) {
                return DataUtil.toLowerCase(actual) >= DataUtil.toLowerCase(expected);
            }
            return actual >= expected;
        },
        /**
         * Returns true when the actual input contains the given string.
         * @param  {string|number} actual
         * @param  {string|number} expected
         * @param  {boolean} ignoreCase?
         */
        contains: function (actual, expected, ignoreCase, ignoreAccent) {
            if (ignoreAccent) {
                actual = DataUtil.ignoreDiacritics(actual);
                expected = DataUtil.ignoreDiacritics(expected);
            }
            if (ignoreCase) {
                return !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(actual) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(expected) &&
                    DataUtil.toLowerCase(actual).indexOf(DataUtil.toLowerCase(expected)) !== -1;
            }
            return !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(actual) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(expected) &&
                actual.toString().indexOf(expected) !== -1;
        },
        /**
         * Returns true when the given input value is not null.
         * @param  {string|number} actual
         * @returns boolean
         */
        notnull: function (actual) {
            return actual !== null;
        },
        /**
         * Returns true when the given input value is null.
         * @param  {string|number} actual
         * @returns boolean
         */
        isnull: function (actual) {
            return actual === null;
        },
        /**
         * Returns true when the actual input starts with the given string
         * @param  {string} actual
         * @param  {string} expected
         * @param  {boolean} ignoreCase?
         */
        startswith: function (actual, expected, ignoreCase, ignoreAccent) {
            if (ignoreAccent) {
                actual = DataUtil.ignoreDiacritics(actual);
                expected = DataUtil.ignoreDiacritics(expected);
            }
            if (ignoreCase) {
                return actual && expected && DataUtil.startsWith(DataUtil.toLowerCase(actual), DataUtil.toLowerCase(expected));
            }
            return actual && expected && DataUtil.startsWith(actual, expected);
        },
        /**
         * Returns true when the actual input ends with the given string.
         * @param  {string} actual
         * @param  {string} expected
         * @param  {boolean} ignoreCase?
         */
        endswith: function (actual, expected, ignoreCase, ignoreAccent) {
            if (ignoreAccent) {
                actual = DataUtil.ignoreDiacritics(actual);
                expected = DataUtil.ignoreDiacritics(expected);
            }
            if (ignoreCase) {
                return actual && expected && DataUtil.endsWith(DataUtil.toLowerCase(actual), DataUtil.toLowerCase(expected));
            }
            return actual && expected && DataUtil.endsWith(actual, expected);
        },
        /**
         * It will return the filter operator based on the filter symbol.
         * @param  {string} operator
         * @hidden
         */
        processSymbols: function (operator) {
            var fnName = DataUtil.operatorSymbols[operator];
            if (fnName) {
                var fn = DataUtil.fnOperators[fnName];
                return fn;
            }
            return DataUtil.throwError('Query - Process Operator : Invalid operator');
        },
        /**
         * It will return the valid filter operator based on the specified operators.
         * @param  {string} operator
         * @hidden
         */
        processOperator: function (operator) {
            var fn = DataUtil.fnOperators[operator];
            if (fn) {
                return fn;
            }
            return DataUtil.fnOperators.processSymbols(operator);
        }
    };
    /**
     * To perform the parse operation on JSON data, like convert to string from JSON or convert to JSON from string.
     */
    DataUtil.parse = {
        /**
         * Parse the given string to the plain JavaScript object.
         * @param  {string|Object|Object[]} jsonText
         */
        parseJson: function (jsonText) {
            if (typeof jsonText === 'string') {
                jsonText = JSON.parse(jsonText, DataUtil.parse.jsonReviver);
            }
            else if (jsonText instanceof Array) {
                DataUtil.parse.iterateAndReviveArray(jsonText);
            }
            else if (typeof jsonText === 'object' && jsonText !== null) {
                DataUtil.parse.iterateAndReviveJson(jsonText);
            }
            return jsonText;
        },
        /**
         * It will perform on array of values.
         * @param  {string[]|Object[]} array
         * @hidden
         */
        iterateAndReviveArray: function (array) {
            for (var i = 0; i < array.length; i++) {
                if (typeof array[i] === 'object' && array[i] !== null) {
                    DataUtil.parse.iterateAndReviveJson(array[i]);
                }
                else if (typeof array[i] === 'string' && !/^[\s]*\[|^[\s]*\{(.)+:|\"/g.test(array[i])) {
                    array[i] = DataUtil.parse.jsonReviver('', array[i]);
                }
                else {
                    array[i] = DataUtil.parse.parseJson(array[i]);
                }
            }
        },
        /**
         * It will perform on JSON values
         * @param  {JSON} json
         * @hidden
         */
        iterateAndReviveJson: function (json) {
            var value;
            var keys = Object.keys(json);
            for (var _i = 0, keys_2 = keys; _i < keys_2.length; _i++) {
                var prop = keys_2[_i];
                if (DataUtil.startsWith(prop, '__')) {
                    continue;
                }
                value = json[prop];
                if (typeof value === 'object') {
                    if (value instanceof Array) {
                        DataUtil.parse.iterateAndReviveArray(value);
                    }
                    else if (value) {
                        DataUtil.parse.iterateAndReviveJson(value);
                    }
                }
                else {
                    json[prop] = DataUtil.parse.jsonReviver(json[prop], value);
                }
            }
        },
        /**
         * It will perform on JSON values
         * @param  {string} field
         * @param  {string|Date} value
         * @hidden
         */
        jsonReviver: function (field, value) {
            if (typeof value === 'string') {
                var ms = /^\/Date\(([+-]?[0-9]+)([+-][0-9]{4})?\)\/$/.exec(value);
                var offSet = DataUtil.timeZoneHandling ? DataUtil.serverTimezoneOffset : null;
                if (ms) {
                    return DataUtil.dateParse.toTimeZone(new Date(parseInt(ms[1], 10)), offSet, true);
                }
                else if (/^(\d{4}\-\d\d\-\d\d([tT][\d:\.]*){1})([zZ]|([+\-])(\d\d):?(\d\d))?$/.test(value)) {
                    var isUTC = value.indexOf('Z') > -1 || value.indexOf('z') > -1;
                    var arr = value.split(/[^0-9.]/);
                    if (isUTC) {
                        value = DataUtil.dateParse
                            .toTimeZone(new Date(parseInt(arr[0], 10), parseInt(arr[1], 10) - 1, parseInt(arr[2], 10), parseInt(arr[3], 10), parseInt(arr[4], 10), parseInt(arr[5], 10)), DataUtil.serverTimezoneOffset, false);
                    }
                    else {
                        var utcFormat = new Date(parseInt(arr[0], 10), parseInt(arr[1], 10) - 1, parseInt(arr[2], 10), parseInt(arr[3], 10), parseInt(arr[4], 10), parseInt(arr[5], 10));
                        var hrs = parseInt(arr[6], 10);
                        var mins = parseInt(arr[7], 10);
                        if (isNaN(hrs) && isNaN(mins)) {
                            return utcFormat;
                        }
                        if (value.indexOf('+') > -1) {
                            utcFormat.setHours(utcFormat.getHours() - hrs, utcFormat.getMinutes() - mins);
                        }
                        else {
                            utcFormat.setHours(utcFormat.getHours() + hrs, utcFormat.getMinutes() + mins);
                        }
                        value = DataUtil.dateParse
                            .toTimeZone(utcFormat, DataUtil.serverTimezoneOffset, false);
                    }
                    if (DataUtil.serverTimezoneOffset == null) {
                        value = DataUtil.dateParse.addSelfOffset(value);
                    }
                }
            }
            return value;
        },
        /**
         * Check wheather the given value is JSON or not.
         * @param  {Object[]} jsonData
         */
        isJson: function (jsonData) {
            if (typeof jsonData[0] === 'string') {
                return jsonData;
            }
            return DataUtil.parse.parseJson(jsonData);
        },
        /**
         * Checks wheather the given value is GUID or not.
         * @param  {string} value
         */
        isGuid: function (value) {
            var regex = /[A-Fa-f0-9]{8}(?:-[A-Fa-f0-9]{4}){3}-[A-Fa-f0-9]{12}/i;
            var match = regex.exec(value);
            return match != null;
        },
        /**
         * The method used to replace the value based on the type.
         * @param  {Object} value
         * @param  {boolean} stringify
         * @hidden
         */
        replacer: function (value, stringify) {
            if (DataUtil.isPlainObject(value)) {
                return DataUtil.parse.jsonReplacer(value, stringify);
            }
            if (value instanceof Array) {
                return DataUtil.parse.arrayReplacer(value);
            }
            if (value instanceof Date) {
                return DataUtil.parse.jsonReplacer({ val: value }, stringify).val;
            }
            return value;
        },
        /**
         * It will replace the JSON value.
         * @param  {string} key
         * @param  {Object} val
         * @hidden
         */
        jsonReplacer: function (val, stringify) {
            var value;
            var keys = Object.keys(val);
            for (var _i = 0, keys_3 = keys; _i < keys_3.length; _i++) {
                var prop = keys_3[_i];
                value = val[prop];
                if (!(value instanceof Date)) {
                    continue;
                }
                var d = value;
                if (DataUtil.serverTimezoneOffset == null) {
                    val[prop] = DataUtil.dateParse.toTimeZone(d, null).toJSON();
                }
                else {
                    d = new Date(+d + DataUtil.serverTimezoneOffset * 3600000);
                    val[prop] = DataUtil.dateParse.toTimeZone(DataUtil.dateParse.addSelfOffset(d), null).toJSON();
                }
            }
            return val;
        },
        /**
         * It will replace the Array of value.
         * @param  {string} key
         * @param  {Object[]} val
         * @hidden
         */
        arrayReplacer: function (val) {
            for (var i = 0; i < val.length; i++) {
                if (DataUtil.isPlainObject(val[i])) {
                    val[i] = DataUtil.parse.jsonReplacer(val[i]);
                }
                else if (val[i] instanceof Date) {
                    val[i] = DataUtil.parse.jsonReplacer({ date: val[i] }).date;
                }
            }
            return val;
        },
        /**
         * It will replace the Date object with respective to UTC format value.
         * @param  {string} key
         * @param  {any} value
         * @hidden
         */
        /* tslint:disable-next-line:no-any */
        jsonDateReplacer: function (key, value) {
            if (key === 'value' && value) {
                if (typeof value === 'string') {
                    var ms = /^\/Date\(([+-]?[0-9]+)([+-][0-9]{4})?\)\/$/.exec(value);
                    if (ms) {
                        value = DataUtil.dateParse.toTimeZone(new Date(parseInt(ms[1], 10)), null, true);
                    }
                    else if (/^(\d{4}\-\d\d\-\d\d([tT][\d:\.]*){1})([zZ]|([+\-])(\d\d):?(\d\d))?$/.test(value)) {
                        var arr = value.split(/[^0-9]/);
                        value = DataUtil.dateParse
                            .toTimeZone(new Date(parseInt(arr[0], 10), parseInt(arr[1], 10) - 1, parseInt(arr[2], 10), parseInt(arr[3], 10), parseInt(arr[4], 10), parseInt(arr[5], 10)), null, true);
                    }
                }
                if (value instanceof Date) {
                    value = DataUtil.dateParse.addSelfOffset(value);
                    if (DataUtil.serverTimezoneOffset === null) {
                        return DataUtil.dateParse.toTimeZone(DataUtil.dateParse.addSelfOffset(value), null).toJSON();
                    }
                    else {
                        value = DataUtil.dateParse.toTimeZone(value, (((value.getTimezoneOffset() / 60) * 2)
                            - DataUtil.serverTimezoneOffset), false);
                        return value.toJSON();
                    }
                }
            }
            return value;
        }
    };
    /**
     * @hidden
     */
    DataUtil.dateParse = {
        addSelfOffset: function (input) {
            return new Date(+input - (input.getTimezoneOffset() * 60000));
        },
        toUTC: function (input) {
            return new Date(+input + (input.getTimezoneOffset() * 60000));
        },
        toTimeZone: function (input, offset, utc) {
            if (offset === null) {
                return input;
            }
            var unix = utc ? DataUtil.dateParse.toUTC(input) : input;
            return new Date(+unix - (offset * 3600000));
        },
        toLocalTime: function (input) {
            var datefn = input;
            var timeZone = -datefn.getTimezoneOffset();
            var differenceString = timeZone >= 0 ? '+' : '-';
            var localtimefn = function (num) {
                var norm = Math.floor(Math.abs(num));
                return (norm < 10 ? '0' : '') + norm;
            };
            var val = datefn.getFullYear() + '-' + localtimefn(datefn.getMonth() + 1) + '-' + localtimefn(datefn.getDate()) +
                'T' + localtimefn(datefn.getHours()) +
                ':' + localtimefn(datefn.getMinutes()) +
                ':' + localtimefn(datefn.getSeconds()) +
                differenceString + localtimefn(timeZone / 60) +
                ':' + localtimefn(timeZone % 60);
            return val;
        }
    };
    return DataUtil;
}());



/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Query; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Predicate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__ = __webpack_require__(0);


/**
 * Query class is used to build query which is used by the DataManager to communicate with datasource.
 */
var Query = /** @class */ (function () {
    /**
     * Constructor for Query class.
     * @param  {string|string[]} from?
     * @hidden
     */
    function Query(from) {
        /** @hidden */
        this.subQuery = null;
        /** @hidden */
        this.isChild = false;
        /** @hidden */
        this.distincts = [];
        this.queries = [];
        this.key = '';
        this.fKey = '';
        if (typeof from === 'string') {
            this.fromTable = from;
        }
        else if (from && from instanceof Array) {
            this.lookups = from;
        }
        this.expands = [];
        this.sortedColumns = [];
        this.groupedColumns = [];
        this.subQuery = null;
        this.isChild = false;
        this.params = [];
        this.lazyLoad = [];
        return this;
    }
    /**
     * Sets the primary key.
     * @param  {string} field - Defines the column field.
     */
    Query.prototype.setKey = function (field) {
        this.key = field;
        return this;
    };
    /**
     * Sets default DataManager to execute query.
     * @param  {DataManager} dataManager - Defines the DataManager.
     */
    Query.prototype.using = function (dataManager) {
        this.dataManager = dataManager;
        return this;
    };
    /**
     * Executes query with the given DataManager.
     * @param  {DataManager} dataManager - Defines the DataManager.
     * @param  {Function} done - Defines the success callback.
     * @param  {Function} fail - Defines the failure callback.
     * @param  {Function} always - Defines the callback which will be invoked on either success or failure.
     *
     * <pre>
     * let dataManager: DataManager = new DataManager([{ ID: '10' }, { ID: '2' }, { ID: '1' }, { ID: '20' }]);
     * let query: Query = new Query();
     * query.sortBy('ID', (x: string, y: string): number => { return parseInt(x, 10) - parseInt(y, 10) });
     * let promise: Promise< Object > = query.execute(dataManager);
     * promise.then((e: { result: Object }) => { });
     * </pre>
     */
    Query.prototype.execute = function (dataManager, done, fail, always) {
        dataManager = dataManager || this.dataManager;
        if (dataManager) {
            return dataManager.executeQuery(this, done, fail, always);
        }
        return __WEBPACK_IMPORTED_MODULE_0__util__["a" /* DataUtil */].throwError('Query - execute() : dataManager needs to be is set using "using" function or should be passed as argument');
    };
    /**
     * Executes query with the local datasource.
     * @param  {DataManager} dataManager - Defines the DataManager.
     */
    Query.prototype.executeLocal = function (dataManager) {
        dataManager = dataManager || this.dataManager;
        if (dataManager) {
            return dataManager.executeLocal(this);
        }
        return __WEBPACK_IMPORTED_MODULE_0__util__["a" /* DataUtil */].throwError('Query - executeLocal() : dataManager needs to be is set using "using" function or should be passed as argument');
    };
    /**
     * Creates deep copy of the Query object.
     */
    Query.prototype.clone = function () {
        var cloned = new Query();
        cloned.queries = this.queries.slice(0);
        cloned.key = this.key;
        cloned.isChild = this.isChild;
        cloned.dataManager = this.dataManager;
        cloned.fromTable = this.fromTable;
        cloned.params = this.params.slice(0);
        cloned.expands = this.expands.slice(0);
        cloned.sortedColumns = this.sortedColumns.slice(0);
        cloned.groupedColumns = this.groupedColumns.slice(0);
        cloned.subQuerySelector = this.subQuerySelector;
        cloned.subQuery = this.subQuery;
        cloned.fKey = this.fKey;
        cloned.isCountRequired = this.isCountRequired;
        cloned.distincts = this.distincts.slice(0);
        cloned.lazyLoad = this.lazyLoad.slice(0);
        return cloned;
    };
    /**
     * Specifies the name of table to retrieve data in query execution.
     * @param  {string} tableName - Defines the table name.
     */
    Query.prototype.from = function (tableName) {
        this.fromTable = tableName;
        return this;
    };
    /**
     * Adds additional parameter which will be sent along with the request which will be generated while DataManager execute.
     * @param  {string} key - Defines the key of additional parameter.
     * @param  {Function|string} value - Defines the value for the key.
     */
    Query.prototype.addParams = function (key, value) {
        if (typeof value === 'function') {
            this.params.push({ key: key, fn: value });
        }
        else {
            this.params.push({ key: key, value: value });
        }
        return this;
    };
    /**
     * @hidden
     */
    Query.prototype.distinct = function (fields) {
        if (typeof fields === 'string') {
            this.distincts = [].slice.call([fields], 0);
        }
        else {
            this.distincts = fields.slice(0);
        }
        return this;
    };
    /**
     * Expands the related table.
     * @param  {string|Object[]} tables
     */
    Query.prototype.expand = function (tables) {
        if (typeof tables === 'string') {
            this.expands = [].slice.call([tables], 0);
        }
        else {
            this.expands = tables.slice(0);
        }
        return this;
    };
    /**
     * Filter data with given filter criteria.
     * @param  {string|Predicate} fieldName - Defines the column field or Predicate.
     * @param  {string} operator - Defines the operator how to filter data.
     * @param  {string|number|boolean} value - Defines the values to match with data.
     * @param  {boolean} ignoreCase - If ignore case set to false, then filter data with exact match or else
     * filter data with case insensitive.
     */
    Query.prototype.where = function (fieldName, operator, value, ignoreCase, ignoreAccent) {
        operator = operator ? (operator).toLowerCase() : null;
        var predicate = null;
        if (typeof fieldName === 'string') {
            predicate = new Predicate(fieldName, operator, value, ignoreCase, ignoreAccent);
        }
        else if (fieldName instanceof Predicate) {
            predicate = fieldName;
        }
        this.queries.push({
            fn: 'onWhere',
            e: predicate
        });
        return this;
    };
    /**
     * Search data with given search criteria.
     * @param  {string|number|boolean} searchKey - Defines the search key.
     * @param  {string|string[]} fieldNames - Defines the collection of column fields.
     * @param  {string} operator - Defines the operator how to search data.
     * @param  {boolean} ignoreCase - If ignore case set to false, then filter data with exact match or else
     * filter data with case insensitive.
     */
    Query.prototype.search = function (searchKey, fieldNames, operator, ignoreCase, ignoreAccent) {
        if (typeof fieldNames === 'string') {
            fieldNames = [fieldNames];
        }
        if (!operator || operator === 'none') {
            operator = 'contains';
        }
        var comparer = __WEBPACK_IMPORTED_MODULE_0__util__["a" /* DataUtil */].fnOperators[operator];
        this.queries.push({
            fn: 'onSearch',
            e: {
                fieldNames: fieldNames,
                operator: operator,
                searchKey: searchKey,
                ignoreCase: ignoreCase,
                ignoreAccent: ignoreAccent,
                comparer: comparer
            }
        });
        return this;
    };
    /**
     * Sort the data with given sort criteria.
     * By default, sort direction is ascending.
     * @param  {string|string[]} fieldName - Defines the single or collection of column fields.
     * @param  {string|Function} comparer - Defines the sort direction or custom sort comparer function.
     */
    Query.prototype.sortBy = function (fieldName, comparer, isFromGroup) {
        return this.sortByForeignKey(fieldName, comparer, isFromGroup);
    };
    /**
     * Sort the data with given sort criteria.
     * By default, sort direction is ascending.
     * @param  {string|string[]} fieldName - Defines the single or collection of column fields.
     * @param  {string|Function} comparer - Defines the sort direction or custom sort comparer function.
     * @param  {string} direction - Defines the sort direction .
     */
    Query.prototype.sortByForeignKey = function (fieldName, comparer, isFromGroup, direction) {
        var order = !Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(direction) ? direction : 'ascending';
        var sorts;
        var temp;
        if (typeof fieldName === 'string' && __WEBPACK_IMPORTED_MODULE_0__util__["a" /* DataUtil */].endsWith(fieldName.toLowerCase(), ' desc')) {
            fieldName = fieldName.replace(/ desc$/i, '');
            comparer = 'descending';
        }
        if (!comparer || typeof comparer === 'string') {
            order = comparer ? comparer.toLowerCase() : 'ascending';
            comparer = __WEBPACK_IMPORTED_MODULE_0__util__["a" /* DataUtil */].fnSort(comparer);
        }
        if (isFromGroup) {
            sorts = Query.filterQueries(this.queries, 'onSortBy');
            for (var i = 0; i < sorts.length; i++) {
                temp = sorts[i].e.fieldName;
                if (typeof temp === 'string') {
                    if (temp === fieldName) {
                        return this;
                    }
                }
                else if (temp instanceof Array) {
                    for (var j = 0; j < temp.length; j++) {
                        if (temp[j] === fieldName || fieldName.toLowerCase() === temp[j] + ' desc') {
                            return this;
                        }
                    }
                }
            }
        }
        this.queries.push({
            fn: 'onSortBy',
            e: {
                fieldName: fieldName,
                comparer: comparer,
                direction: order
            }
        });
        return this;
    };
    /**
     * Sorts data in descending order.
     * @param  {string} fieldName - Defines the column field.
     */
    Query.prototype.sortByDesc = function (fieldName) {
        return this.sortBy(fieldName, 'descending');
    };
    /**
     * Groups data with the given field name.
     * @param  {string} fieldName - Defines the column field.
     */
    Query.prototype.group = function (fieldName, fn, format) {
        this.sortBy(fieldName, null, true);
        this.queries.push({
            fn: 'onGroup',
            e: {
                fieldName: fieldName,
                comparer: fn ? fn : null,
                format: format ? format : null
            }
        });
        return this;
    };
    /**
     * Gets data based on the given page index and size.
     * @param  {number} pageIndex - Defines the current page index.
     * @param  {number} pageSize - Defines the no of records per page.
     */
    Query.prototype.page = function (pageIndex, pageSize) {
        this.queries.push({
            fn: 'onPage',
            e: {
                pageIndex: pageIndex,
                pageSize: pageSize
            }
        });
        return this;
    };
    /**
     * Gets data based on the given start and end index.
     * @param  {number} start - Defines the start index of the datasource.
     * @param  {number} end - Defines the end index of the datasource.
     */
    Query.prototype.range = function (start, end) {
        this.queries.push({
            fn: 'onRange',
            e: {
                start: start,
                end: end
            }
        });
        return this;
    };
    /**
     * Gets data from the top of the data source based on given number of records count.
     * @param  {number} nos - Defines the no of records to retrieve from datasource.
     */
    Query.prototype.take = function (nos) {
        this.queries.push({
            fn: 'onTake',
            e: {
                nos: nos
            }
        });
        return this;
    };
    /**
     * Skips data with given number of records count from the top of the data source.
     * @param  {number} nos - Defines the no of records skip in the datasource.
     */
    Query.prototype.skip = function (nos) {
        this.queries.push({
            fn: 'onSkip',
            e: { nos: nos }
        });
        return this;
    };
    /**
     * Selects specified columns from the data source.
     * @param  {string|string[]} fieldNames - Defines the collection of column fields.
     */
    Query.prototype.select = function (fieldNames) {
        if (typeof fieldNames === 'string') {
            fieldNames = [].slice.call([fieldNames], 0);
        }
        this.queries.push({
            fn: 'onSelect',
            e: { fieldNames: fieldNames }
        });
        return this;
    };
    /**
     * Gets the records in hierarchical relationship from two tables. It requires the foreign key to relate two tables.
     * @param  {Query} query - Defines the query to relate two tables.
     * @param  {Function} selectorFn - Defines the custom function to select records.
     */
    Query.prototype.hierarchy = function (query, selectorFn) {
        this.subQuerySelector = selectorFn;
        this.subQuery = query;
        return this;
    };
    /**
     * Sets the foreign key which is used to get data from the related table.
     * @param  {string} key - Defines the foreign key.
     */
    Query.prototype.foreignKey = function (key) {
        this.fKey = key;
        return this;
    };
    /**
     * It is used to get total number of records in the DataManager execution result.
     */
    Query.prototype.requiresCount = function () {
        this.isCountRequired = true;
        return this;
    };
    //type - sum, avg, min, max
    /**
     * Aggregate the data with given type and field name.
     * @param  {string} type - Defines the aggregate type.
     * @param  {string} field - Defines the column field to aggregate.
     */
    Query.prototype.aggregate = function (type, field) {
        this.queries.push({
            fn: 'onAggregates',
            e: { field: field, type: type }
        });
        return this;
    };
    /**
     * Pass array of filterColumn query for performing filter operation.
     * @param  {QueryOptions[]} queries
     * @param  {string} name
     * @hidden
     */
    Query.filterQueries = function (queries, name) {
        return queries.filter(function (q) {
            return q.fn === name;
        });
    };
    /**
     * To get the list of queries which is already filtered in current data source.
     * @param  {Object[]} queries
     * @param  {string[]} singles
     * @hidden
     */
    Query.filterQueryLists = function (queries, singles) {
        var filtered = queries.filter(function (q) {
            return singles.indexOf(q.fn) !== -1;
        });
        var res = {};
        for (var i = 0; i < filtered.length; i++) {
            if (!res[filtered[i].fn]) {
                res[filtered[i].fn] = filtered[i].e;
            }
        }
        return res;
    };
    return Query;
}());

/**
 * Predicate class is used to generate complex filter criteria.
 * This will be used by DataManager to perform multiple filtering operation.
 */
var Predicate = /** @class */ (function () {
    /**
     * Constructor for Predicate class.
     * @param  {string|Predicate} field
     * @param  {string} operator
     * @param  {string|number|boolean|Predicate|Predicate[]} value
     * @param  {boolean=false} ignoreCase
     * @hidden
     */
    function Predicate(field, operator, value, ignoreCase, ignoreAccent) {
        if (ignoreCase === void 0) { ignoreCase = false; }
        /** @hidden */
        this.ignoreAccent = false;
        /** @hidden */
        this.isComplex = false;
        if (typeof field === 'string') {
            this.field = field;
            this.operator = operator.toLowerCase();
            this.value = value;
            this.ignoreCase = ignoreCase;
            this.ignoreAccent = ignoreAccent;
            this.isComplex = false;
            this.comparer = __WEBPACK_IMPORTED_MODULE_0__util__["a" /* DataUtil */].fnOperators.processOperator(this.operator);
        }
        else if (field instanceof Predicate && value instanceof Predicate || value instanceof Array) {
            this.isComplex = true;
            this.condition = operator.toLowerCase();
            this.predicates = [field];
            if (value instanceof Array) {
                [].push.apply(this.predicates, value);
            }
            else {
                this.predicates.push(value);
            }
        }
        return this;
    }
    /**
     * Adds n-number of new predicates on existing predicate with “and” condition.
     * @param  {Object[]} args - Defines the collection of predicates.
     */
    Predicate.and = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return Predicate.combinePredicates([].slice.call(args, 0), 'and');
    };
    /**
     * Adds new predicate on existing predicate with “and” condition.
     * @param  {string} field - Defines the column field.
     * @param  {string} operator - Defines the operator how to filter data.
     * @param  {string} value - Defines the values to match with data.
     * @param  {boolean} ignoreCase? - If ignore case set to false, then filter data with exact match or else
     * filter data with case insensitive.
     */
    Predicate.prototype.and = function (field, operator, value, ignoreCase, ignoreAccent) {
        return Predicate.combine(this, field, operator, value, 'and', ignoreCase, ignoreAccent);
    };
    /**
     * Adds n-number of new predicates on existing predicate with “or” condition.
     * @param  {Object[]} args - Defines the collection of predicates.
     */
    Predicate.or = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return Predicate.combinePredicates([].slice.call(args, 0), 'or');
    };
    /**
     * Adds new predicate on existing predicate with “or” condition.
     * @param  {string} field - Defines the column field.
     * @param  {string} operator - Defines the operator how to filter data.
     * @param  {string} value - Defines the values to match with data.
     * @param  {boolean} ignoreCase? - If ignore case set to false, then filter data with exact match or else
     * filter data with case insensitive.
     */
    Predicate.prototype.or = function (field, operator, value, ignoreCase, ignoreAccent) {
        return Predicate.combine(this, field, operator, value, 'or', ignoreCase, ignoreAccent);
    };
    /**
     * Converts plain JavaScript object to Predicate object.
     * @param  {Predicate[]|Predicate} json - Defines single or collection of Predicate.
     */
    Predicate.fromJson = function (json) {
        if (json instanceof Array) {
            var res = [];
            for (var i = 0, len = json.length; i < len; i++) {
                res.push(this.fromJSONData(json[i]));
            }
            return res;
        }
        var pred = json;
        return this.fromJSONData(pred);
    };
    /**
     * Validate the record based on the predicates.
     * @param  {Object} record - Defines the datasource record.
     */
    Predicate.prototype.validate = function (record) {
        var predicate = this.predicates ? this.predicates : [];
        var isAnd;
        var ret;
        if (!this.isComplex && this.comparer) {
            return this.comparer.call(this, __WEBPACK_IMPORTED_MODULE_0__util__["a" /* DataUtil */].getObject(this.field, record), this.value, this.ignoreCase, this.ignoreAccent);
        }
        isAnd = this.condition === 'and';
        for (var i = 0; i < predicate.length; i++) {
            ret = predicate[i].validate(record);
            if (isAnd) {
                if (!ret) {
                    return false;
                }
            }
            else {
                if (ret) {
                    return true;
                }
            }
        }
        return isAnd;
    };
    /**
     * Converts predicates to plain JavaScript.
     * This method is uses Json stringify when serializing Predicate object.
     */
    Predicate.prototype.toJson = function () {
        var predicates;
        var p;
        if (this.isComplex) {
            predicates = [];
            p = this.predicates;
            for (var i = 0; i < p.length; i++) {
                predicates.push(p[i].toJson());
            }
        }
        return {
            isComplex: this.isComplex,
            field: this.field,
            operator: this.operator,
            value: this.value,
            ignoreCase: this.ignoreCase,
            ignoreAccent: this.ignoreAccent,
            condition: this.condition,
            predicates: predicates
        };
    };
    Predicate.combinePredicates = function (predicates, operator) {
        if (predicates.length === 1) {
            if (!(predicates[0] instanceof Array)) {
                return predicates[0];
            }
            predicates = predicates[0];
        }
        return new Predicate(predicates[0], operator, predicates.slice(1));
    };
    Predicate.combine = function (pred, field, operator, value, condition, ignoreCase, ignoreAccent) {
        if (field instanceof Predicate) {
            return Predicate[condition](pred, field);
        }
        if (typeof field === 'string') {
            return Predicate[condition](pred, new Predicate(field, operator, value, ignoreCase, ignoreAccent));
        }
        return __WEBPACK_IMPORTED_MODULE_0__util__["a" /* DataUtil */].throwError('Predicate - ' + condition + ' : invalid arguments');
    };
    Predicate.fromJSONData = function (json) {
        var preds = json.predicates || [];
        var len = preds.length;
        var predicates = [];
        var result;
        for (var i = 0; i < len; i++) {
            predicates.push(this.fromJSONData(preds[i]));
        }
        if (!json.isComplex) {
            result = new Predicate(json.field, json.operator, json.value, json.ignoreCase, json.ignoreAccent);
        }
        else {
            result = new Predicate(predicates[0], json.condition, predicates.slice(1));
        }
        return result;
    };
    return Predicate;
}());



/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = calculateRelativeBasedPosition;
/* harmony export (immutable) */ __webpack_exports__["a"] = calculatePosition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/**
 * Position library
 */

var elementRect;
var popupRect;
var element;
var parentDocument;
var fixedParent = false;
/**
 *
 * @param {HTMLElement} anchor - specifies the element
 * @param {HTMLElement} element - specifies the element
 * @returns {OffsetPosition} - returns the value
 */
function calculateRelativeBasedPosition(anchor, element) {
    var fixedElement = false;
    var anchorPos = { left: 0, top: 0 };
    var tempAnchor = anchor;
    if (!anchor || !element) {
        return anchorPos;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(element.offsetParent) && element.style.position === 'fixed') {
        fixedElement = true;
    }
    while ((element.offsetParent || fixedElement) && anchor && element.offsetParent !== anchor) {
        anchorPos.left += anchor.offsetLeft;
        anchorPos.top += anchor.offsetTop;
        anchor = anchor.offsetParent;
    }
    anchor = tempAnchor;
    while ((element.offsetParent || fixedElement) && anchor && element.offsetParent !== anchor) {
        anchorPos.left -= anchor.scrollLeft;
        anchorPos.top -= anchor.scrollTop;
        anchor = anchor.parentElement;
    }
    return anchorPos;
}
/**
 *
 * @param {Element} currentElement - specifies the element
 * @param {string} positionX - specifies the position
 * @param {string} positionY - specifies the position
 * @param {boolean} parentElement - specifies the boolean
 * @param {ClientRect} targetValues - specifies the client
 * @returns {OffsetPosition} - returns the position
 */
function calculatePosition(currentElement, positionX, positionY, parentElement, targetValues) {
    //eslint-disable-next-line
    popupRect = undefined;
    popupRect = targetValues;
    fixedParent = parentElement ? true : false;
    if (!currentElement) {
        return { left: 0, top: 0 };
    }
    if (!positionX) {
        positionX = 'left';
    }
    if (!positionY) {
        positionY = 'top';
    }
    parentDocument = currentElement.ownerDocument;
    element = currentElement;
    var pos = { left: 0, top: 0 };
    return updatePosition(positionX.toLowerCase(), positionY.toLowerCase(), pos);
}
/**
 *
 * @param {number} value - specifies the number
 * @param {OffsetPosition} pos - specifies the position
 * @returns {void}
 */
function setPosx(value, pos) {
    pos.left = value;
}
/**
 *
 * @param {number} value - specifies the number
 * @param {OffsetPosition} pos - specifies the position
 * @returns {void}
 */
function setPosy(value, pos) {
    pos.top = value;
}
/**
 *
 * @param {string} posX - specifies the position
 * @param {string} posY - specifies the position
 * @param {OffsetPosition} pos - specifies the position
 * @returns {OffsetPosition} - returns the postion
 */
function updatePosition(posX, posY, pos) {
    elementRect = element.getBoundingClientRect();
    switch (posY + posX) {
        case 'topcenter':
            setPosx(getElementHCenter(), pos);
            setPosy(getElementTop(), pos);
            break;
        case 'topright':
            setPosx(getElementRight(), pos);
            setPosy(getElementTop(), pos);
            break;
        case 'centercenter':
            setPosx(getElementHCenter(), pos);
            setPosy(getElementVCenter(), pos);
            break;
        case 'centerright':
            setPosx(getElementRight(), pos);
            setPosy(getElementVCenter(), pos);
            break;
        case 'centerleft':
            setPosx(getElementLeft(), pos);
            setPosy(getElementVCenter(), pos);
            break;
        case 'bottomcenter':
            setPosx(getElementHCenter(), pos);
            setPosy(getElementBottom(), pos);
            break;
        case 'bottomright':
            setPosx(getElementRight(), pos);
            setPosy(getElementBottom(), pos);
            break;
        case 'bottomleft':
            setPosx(getElementLeft(), pos);
            setPosy(getElementBottom(), pos);
            break;
        default:
        case 'topleft':
            setPosx(getElementLeft(), pos);
            setPosy(getElementTop(), pos);
            break;
    }
    return pos;
}
/**
 * @returns {number} - specifies the number value
 */
function getBodyScrollTop() {
    return parentDocument.documentElement.scrollTop || parentDocument.body.scrollTop;
}
/**
 * @returns {number} - specifies the number value
 */
function getBodyScrollLeft() {
    return parentDocument.documentElement.scrollLeft || parentDocument.body.scrollLeft;
}
/**
 * @returns {number} - specifies the number value
 */
function getElementBottom() {
    return fixedParent ? elementRect.bottom : elementRect.bottom + getBodyScrollTop();
}
/**
 * @returns {number} - specifies the number value
 */
function getElementVCenter() {
    return getElementTop() + (elementRect.height / 2);
}
/**
 * @returns {number} - specifies the number value
 */
function getElementTop() {
    return fixedParent ? elementRect.top : elementRect.top + getBodyScrollTop();
}
/**
 * @returns {number} - specifies the number value
 */
function getElementLeft() {
    return elementRect.left + getBodyScrollLeft();
}
/**
 * @returns {number} - specifies the number value
 */
function getElementRight() {
    var popupWidth = (element && element.classList.contains('e-date-range-wrapper')) ? (popupRect ? popupRect.width : 0) :
        (popupRect && (elementRect.width >= popupRect.width) ? popupRect.width : 0);
    return elementRect.right + getBodyScrollLeft() - popupWidth;
}
/**
 * @returns {number} - specifies the number value
 */
function getElementHCenter() {
    return getElementLeft() + (elementRect.width / 2);
}


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getModel;
/* harmony export (immutable) */ __webpack_exports__["d"] = upDownKeyHandler;
/* harmony export (immutable) */ __webpack_exports__["c"] = setBlankIconStyle;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Item; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

/**
 * @param {Object} props - Specifies the properties
 * @param {string[]} model - Specifies the model
 * @returns {Object} Component Model
 */
function getModel(props, model) {
    var obj = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, props);
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var prop = _a[_i];
        if ((model).indexOf(prop) < 0) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["C" /* deleteObject */])(obj, prop);
        }
    }
    return obj;
}
/** @hidden
 * @param {HTMLElement} ul - Specifies the UL element
 * @param {number} keyCode - Specifies the keycode
 * @returns {void}
 */
function upDownKeyHandler(ul, keyCode) {
    var defaultIdx = keyCode === 40 ? 0 : ul.childElementCount - 1;
    var liIdx = defaultIdx;
    var li;
    var selectedLi = ul.querySelector('.e-selected');
    if (selectedLi) {
        selectedLi.classList.remove('e-selected');
    }
    for (var i = 0, len = ul.children.length; i < len; i++) {
        if (ul.children[i].classList.contains('e-focused')) {
            li = ul.children[i];
            liIdx = i;
            li.classList.remove('e-focused');
            if (keyCode === 40) {
                liIdx++;
            }
            else {
                liIdx--;
            }
            if (liIdx === (keyCode === 40 ? ul.childElementCount : -1)) {
                liIdx = defaultIdx;
            }
        }
    }
    li = ul.children[liIdx];
    liIdx = isValidLI(ul, li, liIdx, keyCode);
    if (liIdx !== -1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([ul.children[liIdx]], 'e-focused');
        ul.children[liIdx].focus();
    }
}
/**
 * Get Valid LI element
 *
 * @param {HTMLElement} ul - Specifies the UL element
 * @param {Element} li - Specifies the LI element
 * @param {number} index - Specifies the index
 * @param {number} keyCode - Specifies the keycode
 * @param {number} count - Specifies the count
 * @returns {number} - Index
 */
function isValidLI(ul, li, index, keyCode, count) {
    if (count === void 0) { count = 0; }
    if (li.classList.contains('e-separator') || li.classList.contains('e-disabled')) {
        if (index === (keyCode === 40 ? ul.childElementCount - 1 : 0)) {
            index = keyCode === 40 ? 0 : ul.childElementCount - 1;
        }
        else {
            if (keyCode === 40) {
                index++;
            }
            else {
                index--;
            }
        }
    }
    li = ul.children[index];
    if (li.classList.contains('e-separator') || li.classList.contains('e-disabled')) {
        count++;
        if (count === ul.childElementCount) {
            return index = -1;
        }
        index = isValidLI(ul, li, index, keyCode, count);
    }
    return index;
}
/** @hidden
 * @param {HTMLElement} popup - Specifies the popup element.
 * @returns {void}
 */
function setBlankIconStyle(popup) {
    var blankIconList = [].slice.call(popup.getElementsByClassName('e-blank-icon'));
    if (!blankIconList.length) {
        return;
    }
    var iconLi = popup.querySelector('.e-item:not(.e-blank-icon):not(.e-separator)');
    if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(iconLi)) {
        return;
    }
    if (iconLi.classList.contains('e-url')) {
        iconLi = iconLi.querySelector('.e-menu-url');
    }
    var icon = iconLi.querySelector('.e-menu-icon');
    var cssProp;
    var enableRtl = popup.classList.contains('e-rtl');
    if (enableRtl) {
        cssProp = { padding: 'paddingRight', margin: 'marginLeft' };
    }
    else {
        cssProp = { padding: 'paddingLeft', margin: 'marginRight' };
    }
    /* eslint-disable */
    var size = parseInt(getComputedStyle(icon).fontSize, 10) + parseInt((enableRtl ? getComputedStyle(icon)[cssProp.margin] : getComputedStyle(icon)[cssProp.margin]), 10)
        + parseInt(getComputedStyle(iconLi).paddingLeft, 10) + "px";
    blankIconList.forEach(function (li) {
        if (li.classList.contains('e-url')) {
            li.querySelector('.e-menu-url').style[cssProp.padding] = size;
        }
        else {
            li.style[cssProp.padding] = size;
        }
    });
    /* eslint-enable */
}
/**
 * Defines the items of Split Button/DropDownButton.
 */
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Item.prototype, "iconCss", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Item.prototype, "id", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Item.prototype, "separator", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Item.prototype, "text", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Item.prototype, "url", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Item.prototype, "disabled", void 0);
    return Item;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));



/***/ }),
/* 35 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(134)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(37);
var hasOwn = __webpack_require__(137);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(136);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export basicPatterns */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return datePartMatcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateFormat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parser_base__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__intl_base__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hijri_parser__ = __webpack_require__(40);





var abbreviateRegexGlobal = /\/MMMMM|MMMM|MMM|a|LLLL|LLL|EEEEE|EEEE|E|K|cccc|ccc|WW|W|G+|z+/gi;
var standalone = 'stand-alone';
var weekdayKey = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
var basicPatterns = ['short', 'medium', 'long', 'full'];
var timeSetter = {
    m: 'getMinutes',
    h: 'getHours',
    H: 'getHours',
    s: 'getSeconds',
    d: 'getDate',
    f: 'getMilliseconds'
};
var datePartMatcher = {
    'M': 'month',
    'd': 'day',
    'E': 'weekday',
    'c': 'weekday',
    'y': 'year',
    'm': 'minute',
    'h': 'hour',
    'H': 'hour',
    's': 'second',
    'L': 'month',
    'a': 'designator',
    'z': 'timeZone',
    'Z': 'timeZone',
    'G': 'era',
    'f': 'milliseconds'
};
var timeSeparator = 'timeSeparator';
/* tslint:disable no-any */
/**
 * Date Format is a framework provides support for date formatting.
 *
 * @private
 */
var DateFormat = /** @class */ (function () {
    function DateFormat() {
    }
    /**
     * Returns the formatter function for given skeleton.
     *
     * @param {string} culture -  Specifies the culture name to be which formatting.
     * @param {DateFormatOptions} option - Specific the format in which date  will format.
     * @param {Object} cldr - Specifies the global cldr data collection.
     * @returns {Function} ?
     */
    DateFormat.dateFormat = function (culture, option, cldr) {
        var _this = this;
        var dependable = __WEBPACK_IMPORTED_MODULE_1__intl_base__["a" /* IntlBase */].getDependables(cldr, culture, option.calendar);
        var numObject = Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* getValue */])('parserObject.numbers', dependable);
        var dateObject = dependable.dateObject;
        var formatOptions = { isIslamic: __WEBPACK_IMPORTED_MODULE_1__intl_base__["a" /* IntlBase */].islamicRegex.test(option.calendar) };
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])() && option.isServerRendered) {
            option = __WEBPACK_IMPORTED_MODULE_1__intl_base__["a" /* IntlBase */].compareBlazorDateFormats(option, culture);
        }
        var resPattern = option.format ||
            __WEBPACK_IMPORTED_MODULE_1__intl_base__["a" /* IntlBase */].getResultantPattern(option.skeleton, dependable.dateObject, option.type, false, Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])() ? culture : '');
        formatOptions.dateSeperator = Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])() ? Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* getValue */])('dateSeperator', dateObject) : __WEBPACK_IMPORTED_MODULE_1__intl_base__["a" /* IntlBase */].getDateSeparator(dependable.dateObject);
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["o" /* isUndefined */])(resPattern)) {
            Object(__WEBPACK_IMPORTED_MODULE_2__util__["s" /* throwError */])('Format options or type given must be invalid');
        }
        else {
            resPattern = __WEBPACK_IMPORTED_MODULE_1__intl_base__["a" /* IntlBase */].ConvertDateToWeekFormat(resPattern);
            if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])()) {
                resPattern = resPattern.replace(/tt/, 'a');
            }
            formatOptions.pattern = resPattern;
            formatOptions.numMapper = Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])() ?
                Object(__WEBPACK_IMPORTED_MODULE_2__util__["f" /* extend */])({}, numObject) : __WEBPACK_IMPORTED_MODULE_0__parser_base__["a" /* ParserBase */].getNumberMapper(dependable.parserObject, __WEBPACK_IMPORTED_MODULE_0__parser_base__["a" /* ParserBase */].getNumberingSystem(cldr));
            var patternMatch = resPattern.match(abbreviateRegexGlobal) || [];
            for (var _i = 0, patternMatch_1 = patternMatch; _i < patternMatch_1.length; _i++) {
                var str = patternMatch_1[_i];
                var len = str.length;
                var char = str[0];
                if (char === 'K') {
                    char = 'h';
                }
                switch (char) {
                    case 'E':
                    case 'c':
                        if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])()) {
                            // eslint-disable-next-line
                            formatOptions.weekday = Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* getValue */])('days.' + __WEBPACK_IMPORTED_MODULE_1__intl_base__["a" /* IntlBase */].monthIndex[len], dateObject);
                        }
                        else {
                            // eslint-disable-next-line
                            formatOptions.weekday = dependable.dateObject[__WEBPACK_IMPORTED_MODULE_1__intl_base__["a" /* IntlBase */].days][standalone][__WEBPACK_IMPORTED_MODULE_1__intl_base__["a" /* IntlBase */].monthIndex[len]];
                        }
                        break;
                    case 'M':
                    case 'L':
                        if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])()) {
                            // eslint-disable-next-line
                            formatOptions.month = Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* getValue */])('months.' + __WEBPACK_IMPORTED_MODULE_1__intl_base__["a" /* IntlBase */].monthIndex[len], dateObject);
                        }
                        else {
                            // eslint-disable-next-line
                            formatOptions.month = dependable.dateObject[__WEBPACK_IMPORTED_MODULE_1__intl_base__["a" /* IntlBase */].month][standalone][__WEBPACK_IMPORTED_MODULE_1__intl_base__["a" /* IntlBase */].monthIndex[len]];
                        }
                        break;
                    case 'a':
                        formatOptions.designator = Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])() ?
                            Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* getValue */])('dayPeriods', dateObject) : Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* getValue */])('dayPeriods.format.wide', dateObject);
                        break;
                    case 'G':
                        // eslint-disable-next-line
                        var eText = (len <= 3) ? 'eraAbbr' : (len === 4) ? 'eraNames' : 'eraNarrow';
                        formatOptions.era = Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])() ? Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* getValue */])('eras', dateObject) : Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* getValue */])('eras.' + eText, dependable.dateObject);
                        break;
                    case 'z':
                        formatOptions.timeZone = Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* getValue */])('dates.timeZoneNames', dependable.parserObject);
                        break;
                }
            }
        }
        return function (value) {
            if (isNaN(value.getDate())) {
                return null;
            }
            return _this.intDateFormatter(value, formatOptions);
        };
    };
    /**
     * Returns formatted date string based on options passed.
     *
     * @param {Date} value ?
     * @param {FormatOptions} options ?
     * @returns {string} ?
     */
    DateFormat.intDateFormatter = function (value, options) {
        var pattern = options.pattern;
        var ret = '';
        var matches = pattern.match(__WEBPACK_IMPORTED_MODULE_1__intl_base__["a" /* IntlBase */].dateParseRegex);
        var dObject = this.getCurrentDateValue(value, options.isIslamic);
        for (var _i = 0, matches_1 = matches; _i < matches_1.length; _i++) {
            var match = matches_1[_i];
            var length_1 = match.length;
            var char = match[0];
            if (char === 'K') {
                char = 'h';
            }
            var curval = void 0;
            var curvalstr = '';
            var isNumber = void 0;
            var processNumber = void 0;
            var curstr = '';
            switch (char) {
                case 'M':
                case 'L':
                    curval = dObject.month;
                    if (length_1 > 2) {
                        // eslint-disable-next-line
                        ret += options.month[curval];
                    }
                    else {
                        isNumber = true;
                    }
                    break;
                case 'E':
                case 'c':
                    // eslint-disable-next-line
                    ret += options.weekday[weekdayKey[value.getDay()]];
                    break;
                case 'H':
                case 'h':
                case 'm':
                case 's':
                case 'd':
                case 'f':
                    isNumber = true;
                    if (char === 'd') {
                        curval = dObject.date;
                    }
                    else if (char === 'f') {
                        isNumber = false;
                        processNumber = true;
                        // eslint-disable-next-line
                        curvalstr = value[timeSetter[char]]().toString();
                        curvalstr = curvalstr.substring(0, length_1);
                        var curlength = curvalstr.length;
                        if (length_1 !== curlength) {
                            if (length_1 > 3) {
                                continue;
                            }
                            for (var i = 0; i < length_1 - curlength; i++) {
                                curvalstr = '0' + curvalstr.toString();
                            }
                        }
                        curstr += curvalstr;
                    }
                    else {
                        // eslint-disable-next-line
                        curval = value[timeSetter[char]]();
                    }
                    if (char === 'h') {
                        curval = curval % 12 || 12;
                    }
                    break;
                case 'y':
                    processNumber = true;
                    curstr += dObject.year;
                    if (length_1 === 2) {
                        curstr = curstr.substr(curstr.length - 2);
                    }
                    break;
                case 'a':
                    // eslint-disable-next-line
                    var desig = value.getHours() < 12 ? 'am' : 'pm';
                    // eslint-disable-next-line
                    ret += options.designator[desig];
                    break;
                case 'G':
                    // eslint-disable-next-line
                    var dec = value.getFullYear() < 0 ? 0 : 1;
                    // eslint-disable-next-line
                    var retu = options.era[dec];
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["m" /* isNullOrUndefined */])(retu)) {
                        // eslint-disable-next-line
                        retu = options.era[dec ? 0 : 1];
                    }
                    ret += retu || '';
                    break;
                case '\'':
                    ret += (match === '\'\'') ? '\'' : match.replace(/'/g, '');
                    break;
                case 'z':
                    // eslint-disable-next-line
                    var timezone = value.getTimezoneOffset();
                    // eslint-disable-next-line
                    var pattern_1 = (length_1 < 4) ? '+H;-H' : options.timeZone.hourFormat;
                    pattern_1 = pattern_1.replace(/:/g, options.numMapper.timeSeparator);
                    if (timezone === 0) {
                        ret += options.timeZone.gmtZeroFormat;
                    }
                    else {
                        processNumber = true;
                        curstr = this.getTimeZoneValue(timezone, pattern_1);
                    }
                    curstr = options.timeZone.gmtFormat.replace(/\{0\}/, curstr);
                    break;
                case ':':
                    // eslint-disable-next-line
                    ret += options.numMapper.numberSymbols[timeSeparator];
                    break;
                case '/':
                    ret += options.dateSeperator;
                    break;
                case 'W':
                    isNumber = true;
                    curval = __WEBPACK_IMPORTED_MODULE_1__intl_base__["a" /* IntlBase */].getWeekOfYear(value);
                    break;
                default:
                    ret += match;
            }
            if (isNumber) {
                processNumber = true;
                curstr = this.checkTwodigitNumber(curval, length_1);
            }
            if (processNumber) {
                ret += __WEBPACK_IMPORTED_MODULE_0__parser_base__["a" /* ParserBase */].convertValueParts(curstr, __WEBPACK_IMPORTED_MODULE_1__intl_base__["a" /* IntlBase */].latnParseRegex, options.numMapper.mapper);
            }
        }
        return ret;
    };
    DateFormat.getCurrentDateValue = function (value, isIslamic) {
        if (isIslamic) {
            return __WEBPACK_IMPORTED_MODULE_3__hijri_parser__["a" /* HijriParser */].getHijriDate(value);
        }
        return { year: value.getFullYear(), month: value.getMonth() + 1, date: value.getDate() };
    };
    /**
     * Returns two digit numbers for given value and length
     *
     * @param {number} val ?
     * @param {number} len ?
     * @returns {string} ?
     */
    DateFormat.checkTwodigitNumber = function (val, len) {
        var ret = val + '';
        if (len === 2 && ret.length !== 2) {
            return '0' + ret;
        }
        return ret;
    };
    /**
     * Returns the value of the Time Zone.
     *
     * @param {number} tVal ?
     * @param {string} pattern ?
     * @returns {string} ?
     * @private
     */
    DateFormat.getTimeZoneValue = function (tVal, pattern) {
        var _this = this;
        var splt = pattern.split(';');
        var curPattern = splt[tVal > 0 ? 1 : 0];
        var no = Math.abs(tVal);
        return curPattern = curPattern.replace(/HH?|mm/g, function (str) {
            var len = str.length;
            var ishour = str.indexOf('H') !== -1;
            return _this.checkTwodigitNumber(Math.floor(ishour ? (no / 60) : (no % 60)), len);
        });
    };
    return DateFormat;
}());



/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HijriParser; });
/***
 * Hijri parser
 */
// eslint-disable-next-line
var HijriParser;
(function (HijriParser) {
    var dateCorrection = [28607, 28636, 28665, 28695, 28724, 28754, 28783, 28813, 28843, 28872, 28901, 28931, 28960, 28990,
        29019, 29049, 29078, 29108, 29137, 29167, 29196, 29226, 29255, 29285, 29315, 29345, 29375, 29404, 29434, 29463, 29492, 29522,
        29551, 29580, 29610, 29640, 29669, 29699, 29729, 29759, 29788, 29818, 29847, 29876, 29906, 29935, 29964, 29994, 30023, 30053,
        30082, 30112, 30141, 30171, 30200, 30230, 30259, 30289, 30318, 30348, 30378, 30408, 30437, 30467, 30496, 30526, 30555, 30585,
        30614, 30644, 30673, 30703, 30732, 30762, 30791, 30821, 30850, 30880, 30909, 30939, 30968, 30998, 31027, 31057, 31086, 31116,
        31145, 31175, 31204, 31234, 31263, 31293, 31322, 31352, 31381, 31411, 31441, 31471, 31500, 31530, 31559, 31589, 31618, 31648,
        31676, 31706, 31736, 31766, 31795, 31825, 31854, 31884, 31913, 31943, 31972, 32002, 32031, 32061, 32090, 32120, 32150, 32180,
        32209, 32239, 32268, 32298, 32327, 32357, 32386, 32416, 32445, 32475, 32504, 32534, 32563, 32593, 32622, 32652, 32681, 32711,
        32740, 32770, 32799, 32829, 32858, 32888, 32917, 32947, 32976, 33006, 33035, 33065, 33094, 33124, 33153, 33183, 33213, 33243,
        33272, 33302, 33331, 33361, 33390, 33420, 33450, 33479, 33509, 33539, 33568, 33598, 33627, 33657, 33686, 33716, 33745, 33775,
        33804, 33834, 33863, 33893, 33922, 33952, 33981, 34011, 34040, 34069, 34099, 34128, 34158, 34187, 34217, 34247, 34277, 34306,
        34336, 34365, 34395, 34424, 34454, 34483, 34512, 34542, 34571, 34601, 34631, 34660, 34690, 34719, 34749, 34778, 34808, 34837,
        34867, 34896, 34926, 34955, 34985, 35015, 35044, 35074, 35103, 35133, 35162, 35192, 35222, 35251, 35280, 35310, 35340, 35370,
        35399, 35429, 35458, 35488, 35517, 35547, 35576, 35605, 35635, 35665, 35694, 35723, 35753, 35782, 35811, 35841, 35871, 35901,
        35930, 35960, 35989, 36019, 36048, 36078, 36107, 36136, 36166, 36195, 36225, 36254, 36284, 36314, 36343, 36373, 36403, 36433,
        36462, 36492, 36521, 36551, 36580, 36610, 36639, 36669, 36698, 36728, 36757, 36786, 36816, 36845, 36875, 36904, 36934, 36963,
        36993, 37022, 37052, 37081, 37111, 37141, 37170, 37200, 37229, 37259, 37288, 37318, 37347, 37377, 37406, 37436, 37465, 37495,
        37524, 37554, 37584, 37613, 37643, 37672, 37701, 37731, 37760, 37790, 37819, 37849, 37878, 37908, 37938, 37967, 37997, 38027,
        38056, 38085, 38115, 38144, 38174, 38203, 38233, 38262, 38292, 38322, 38351, 38381, 38410, 38440, 38469, 38499, 38528, 38558,
        38587, 38617, 38646, 38676, 38705, 38735, 38764, 38794, 38823, 38853, 38882, 38912, 38941, 38971, 39001, 39030, 39059, 39089,
        39118, 39148, 39178, 39208, 39237, 39267, 39297, 39326, 39355, 39385, 39414, 39444, 39473, 39503, 39532, 39562, 39592, 39621,
        39650, 39680, 39709, 39739, 39768, 39798, 39827, 39857, 39886, 39916, 39946, 39975, 40005, 40035, 40064, 40094, 40123, 40153,
        40182, 40212, 40241, 40271, 40300, 40330, 40359, 40389, 40418, 40448, 40477, 40507, 40536, 40566, 40595, 40625, 40655, 40685,
        40714, 40744, 40773, 40803, 40832, 40862, 40892, 40921, 40951, 40980, 41009, 41039, 41068, 41098, 41127, 41157, 41186, 41216,
        41245, 41275, 41304, 41334, 41364, 41393, 41422, 41452, 41481, 41511, 41540, 41570, 41599, 41629, 41658, 41688, 41718, 41748,
        41777, 41807, 41836, 41865, 41894, 41924, 41953, 41983, 42012, 42042, 42072, 42102, 42131, 42161, 42190, 42220, 42249, 42279,
        42308, 42337, 42367, 42397, 42426, 42456, 42485, 42515, 42545, 42574, 42604, 42633, 42662, 42692, 42721, 42751, 42780, 42810,
        42839, 42869, 42899, 42929, 42958, 42988, 43017, 43046, 43076, 43105, 43135, 43164, 43194, 43223, 43253, 43283, 43312, 43342,
        43371, 43401, 43430, 43460, 43489, 43519, 43548, 43578, 43607, 43637, 43666, 43696, 43726, 43755, 43785, 43814, 43844, 43873,
        43903, 43932, 43962, 43991, 44021, 44050, 44080, 44109, 44139, 44169, 44198, 44228, 44258, 44287, 44317, 44346, 44375, 44405,
        44434, 44464, 44493, 44523, 44553, 44582, 44612, 44641, 44671, 44700, 44730, 44759, 44788, 44818, 44847, 44877, 44906, 44936,
        44966, 44996, 45025, 45055, 45084, 45114, 45143, 45172, 45202, 45231, 45261, 45290, 45320, 45350, 45380, 45409, 45439, 45468,
        45498, 45527, 45556, 45586, 45615, 45644, 45674, 45704, 45733, 45763, 45793, 45823, 45852, 45882, 45911, 45940, 45970, 45999,
        46028, 46058, 46088, 46117, 46147, 46177, 46206, 46236, 46265, 46295, 46324, 46354, 46383, 46413, 46442, 46472, 46501, 46531,
        46560, 46590, 46620, 46649, 46679, 46708, 46738, 46767, 46797, 46826, 46856, 46885, 46915, 46944, 46974, 47003, 47033, 47063,
        47092, 47122, 47151, 47181, 47210, 47240, 47269, 47298, 47328, 47357, 47387, 47417, 47446, 47476, 47506, 47535, 47565, 47594,
        47624, 47653, 47682, 47712, 47741, 47771, 47800, 47830, 47860, 47890, 47919, 47949, 47978, 48008, 48037, 48066, 48096, 48125,
        48155, 48184, 48214, 48244, 48273, 48303, 48333, 48362, 48392, 48421, 48450, 48480, 48509, 48538, 48568, 48598, 48627, 48657,
        48687, 48717, 48746, 48776, 48805, 48834, 48864, 48893, 48922, 48952, 48982, 49011, 49041, 49071, 49100, 49130, 49160, 49189,
        49218, 49248, 49277, 49306, 49336, 49365, 49395, 49425, 49455, 49484, 49514, 49543, 49573, 49602, 49632, 49661, 49690, 49720,
        49749, 49779, 49809, 49838, 49868, 49898, 49927, 49957, 49986, 50016, 50045, 50075, 50104, 50133, 50163, 50192, 50222, 50252,
        50281, 50311, 50340, 50370, 50400, 50429, 50459, 50488, 50518, 50547, 50576, 50606, 50635, 50665, 50694, 50724, 50754, 50784,
        50813, 50843, 50872, 50902, 50931, 50960, 50990, 51019, 51049, 51078, 51108, 51138, 51167, 51197, 51227, 51256, 51286, 51315,
        51345, 51374, 51403, 51433, 51462, 51492, 51522, 51552, 51582, 51611, 51641, 51670, 51699, 51729, 51758, 51787, 51816, 51846,
        51876, 51906, 51936, 51965, 51995, 52025, 52054, 52083, 52113, 52142, 52171, 52200, 52230, 52260, 52290, 52319, 52349, 52379,
        52408, 52438, 52467, 52497, 52526, 52555, 52585, 52614, 52644, 52673, 52703, 52733, 52762, 52792, 52822, 52851, 52881, 52910,
        52939, 52969, 52998, 53028, 53057, 53087, 53116, 53146, 53176, 53205, 53235, 53264, 53294, 53324, 53353, 53383, 53412, 53441,
        53471, 53500, 53530, 53559, 53589, 53619, 53648, 53678, 53708, 53737, 53767, 53796, 53825, 53855, 53884, 53913, 53943, 53973,
        54003, 54032, 54062, 54092, 54121, 54151, 54180, 54209, 54239, 54268, 54297, 54327, 54357, 54387, 54416, 54446, 54476, 54505,
        54535, 54564, 54593, 54623, 54652, 54681, 54711, 54741, 54770, 54800, 54830, 54859, 54889, 54919, 54948, 54977, 55007, 55036,
        55066, 55095, 55125, 55154, 55184, 55213, 55243, 55273, 55302, 55332, 55361, 55391, 55420, 55450, 55479, 55508, 55538, 55567,
        55597, 55627, 55657, 55686, 55716, 55745, 55775, 55804, 55834, 55863, 55892, 55922, 55951, 55981, 56011, 56040, 56070, 56100,
        56129, 56159, 56188, 56218, 56247, 56276, 56306, 56335, 56365, 56394, 56424, 56454, 56483, 56513, 56543, 56572, 56601, 56631,
        56660, 56690, 56719, 56749, 56778, 56808, 56837, 56867, 56897, 56926, 56956, 56985, 57015, 57044, 57074, 57103, 57133, 57162,
        57192, 57221, 57251, 57280, 57310, 57340, 57369, 57399, 57429, 57458, 57487, 57517, 57546, 57576, 57605, 57634, 57664, 57694,
        57723, 57753, 57783, 57813, 57842, 57871, 57901, 57930, 57959, 57989, 58018, 58048, 58077, 58107, 58137, 58167, 58196, 58226,
        58255, 58285, 58314, 58343, 58373, 58402, 58432, 58461, 58491, 58521, 58551, 58580, 58610, 58639, 58669, 58698, 58727, 58757,
        58786, 58816, 58845, 58875, 58905, 58934, 58964, 58994, 59023, 59053, 59082, 59111, 59141, 59170, 59200, 59229, 59259, 59288,
        59318, 59348, 59377, 59407, 59436, 59466, 59495, 59525, 59554, 59584, 59613, 59643, 59672, 59702, 59731, 59761, 59791, 59820,
        59850, 59879, 59909, 59939, 59968, 59997, 60027, 60056, 60086, 60115, 60145, 60174, 60204, 60234, 60264, 60293, 60323, 60352,
        60381, 60411, 60440, 60469, 60499, 60528, 60558, 60588, 60618, 60648, 60677, 60707, 60736, 60765, 60795, 60824, 60853, 60883,
        60912, 60942, 60972, 61002, 61031, 61061, 61090, 61120, 61149, 61179, 61208, 61237, 61267, 61296, 61326, 61356, 61385, 61415,
        61445, 61474, 61504, 61533, 61563, 61592, 61621, 61651, 61680, 61710, 61739, 61769, 61799, 61828, 61858, 61888, 61917, 61947,
        61976, 62006, 62035, 62064, 62094, 62123, 62153, 62182, 62212, 62242, 62271, 62301, 62331, 62360, 62390, 62419, 62448, 62478,
        62507, 62537, 62566, 62596, 62625, 62655, 62685, 62715, 62744, 62774, 62803, 62832, 62862, 62891, 62921, 62950, 62980, 63009,
        63039, 63069, 63099, 63128, 63157, 63187, 63216, 63246, 63275, 63305, 63334, 63363, 63393, 63423, 63453, 63482, 63512, 63541,
        63571, 63600, 63630, 63659, 63689, 63718, 63747, 63777, 63807, 63836, 63866, 63895, 63925, 63955, 63984, 64014, 64043, 64073,
        64102, 64131, 64161, 64190, 64220, 64249, 64279, 64309, 64339, 64368, 64398, 64427, 64457, 64486, 64515, 64545, 64574, 64603,
        64633, 64663, 64692, 64722, 64752, 64782, 64811, 64841, 64870, 64899, 64929, 64958, 64987, 65017, 65047, 65076, 65106, 65136,
        65166, 65195, 65225, 65254, 65283, 65313, 65342, 65371, 65401, 65431, 65460, 65490, 65520, 65549, 65579, 65608, 65638, 65667,
        65697, 65726, 65755, 65785, 65815, 65844, 65874, 65903, 65933, 65963, 65992, 66022, 66051, 66081, 66110, 66140, 66169, 66199,
        66228, 66258, 66287, 66317, 66346, 66376, 66405, 66435, 66465, 66494, 66524, 66553, 66583, 66612, 66641, 66671, 66700, 66730,
        66760, 66789, 66819, 66849, 66878, 66908, 66937, 66967, 66996, 67025, 67055, 67084, 67114, 67143, 67173, 67203, 67233, 67262,
        67292, 67321, 67351, 67380, 67409, 67439, 67468, 67497, 67527, 67557, 67587, 67617, 67646, 67676, 67705, 67735, 67764, 67793,
        67823, 67852, 67882, 67911, 67941, 67971, 68000, 68030, 68060, 68089, 68119, 68148, 68177, 68207, 68236, 68266, 68295, 68325,
        68354, 68384, 68414, 68443, 68473, 68502, 68532, 68561, 68591, 68620, 68650, 68679, 68708, 68738, 68768, 68797, 68827, 68857,
        68886, 68916, 68946, 68975, 69004, 69034, 69063, 69092, 69122, 69152, 69181, 69211, 69240, 69270, 69300, 69330, 69359, 69388,
        69418, 69447, 69476, 69506, 69535, 69565, 69595, 69624, 69654, 69684, 69713, 69743, 69772, 69802, 69831, 69861, 69890, 69919,
        69949, 69978, 70008, 70038, 70067, 70097, 70126, 70156, 70186, 70215, 70245, 70274, 70303, 70333, 70362, 70392, 70421, 70451,
        70481, 70510, 70540, 70570, 70599, 70629, 70658, 70687, 70717, 70746, 70776, 70805, 70835, 70864, 70894, 70924, 70954, 70983,
        71013, 71042, 71071, 71101, 71130, 71159, 71189, 71218, 71248, 71278, 71308, 71337, 71367, 71397, 71426, 71455, 71485, 71514,
        71543, 71573, 71602, 71632, 71662, 71691, 71721, 71751, 71781, 71810, 71839, 71869, 71898, 71927, 71957, 71986, 72016, 72046,
        72075, 72105, 72135, 72164, 72194, 72223, 72253, 72282, 72311, 72341, 72370, 72400, 72429, 72459, 72489, 72518, 72548, 72577,
        72607, 72637, 72666, 72695, 72725, 72754, 72784, 72813, 72843, 72872, 72902, 72931, 72961, 72991, 73020, 73050, 73080, 73109,
        73139, 73168, 73197, 73227, 73256, 73286, 73315, 73345, 73375, 73404, 73434, 73464, 73493, 73523, 73552, 73581, 73611, 73640,
        73669, 73699, 73729, 73758, 73788, 73818, 73848, 73877, 73907, 73936, 73965, 73995, 74024, 74053, 74083, 74113, 74142, 74172,
        74202, 74231, 74261, 74291, 74320, 74349, 74379, 74408, 74437, 74467, 74497, 74526, 74556, 74586, 74615, 74645, 74675, 74704,
        74733, 74763, 74792, 74822, 74851, 74881, 74910, 74940, 74969, 74999, 75029, 75058, 75088, 75117, 75147, 75176, 75206, 75235,
        75264, 75294, 75323, 75353, 75383, 75412, 75442, 75472, 75501, 75531, 75560, 75590, 75619, 75648, 75678, 75707, 75737, 75766,
        75796, 75826, 75856, 75885, 75915, 75944, 75974, 76003, 76032, 76062, 76091, 76121, 76150, 76180, 76210, 76239, 76269, 76299,
        76328, 76358, 76387, 76416, 76446, 76475, 76505, 76534, 76564, 76593, 76623, 76653, 76682, 76712, 76741, 76771, 76801, 76830,
        76859, 76889, 76918, 76948, 76977, 77007, 77036, 77066, 77096, 77125, 77155, 77185, 77214, 77243, 77273, 77302, 77332, 77361,
        77390, 77420, 77450, 77479, 77509, 77539, 77569, 77598, 77627, 77657, 77686, 77715, 77745, 77774, 77804, 77833, 77863, 77893,
        77923, 77952, 77982, 78011, 78041, 78070, 78099, 78129, 78158, 78188, 78217, 78247, 78277, 78307, 78336, 78366, 78395, 78425,
        78454, 78483, 78513, 78542, 78572, 78601, 78631, 78661, 78690, 78720, 78750, 78779, 78808, 78838, 78867, 78897, 78926, 78956,
        78985, 79015, 79044, 79074, 79104, 79133, 79163, 79192, 79222, 79251, 79281, 79310, 79340, 79369, 79399, 79428, 79458, 79487,
        79517, 79546, 79576, 79606, 79635, 79665, 79695, 79724, 79753, 79783, 79812, 79841, 79871, 79900, 79930, 79960, 79990
    ];
    /**
     *
     * @param {Date} gDate ?
     * @returns {Object} ?
     */
    function getHijriDate(gDate) {
        var day = gDate.getDate();
        var month = gDate.getMonth();
        var year = gDate.getFullYear();
        var tMonth = month + 1;
        var tYear = year;
        if (tMonth < 3) {
            tYear -= 1;
            tMonth += 12;
        }
        var yPrefix = Math.floor(tYear / 100.);
        var julilanOffset = yPrefix - Math.floor(yPrefix / 4.) - 2;
        var julianNumber = Math.floor(365.25 * (tYear + 4716)) + Math.floor(30.6001 * (tMonth + 1)) + day - julilanOffset - 1524;
        yPrefix = Math.floor((julianNumber - 1867216.25) / 36524.25);
        julilanOffset = yPrefix - Math.floor(yPrefix / 4.) + 1;
        var b = julianNumber + julilanOffset + 1524;
        var c = Math.floor((b - 122.1) / 365.25);
        var d = Math.floor(365.25 * c);
        var tempMonth = Math.floor((b - d) / 30.6001);
        day = (b - d) - Math.floor(30.6001 * tempMonth);
        month = Math.floor((b - d) / 20.6001);
        if (month > 13) {
            c += 1;
            month -= 12;
        }
        month -= 1;
        year = c - 4716;
        var modifiedJulianDate = julianNumber - 2400000;
        // date calculation for year after 2077
        var iyear = 10631. / 30.;
        var z = julianNumber - 1948084;
        var cyc = Math.floor(z / 10631.);
        z = z - 10631 * cyc;
        var j = Math.floor((z - 0.1335) / iyear);
        var iy = 30 * cyc + j;
        z = z - Math.floor(j * iyear + 0.1335);
        var im = Math.floor((z + 28.5001) / 29.5);
        /* istanbul ignore next */
        if (im === 13) {
            im = 12;
        }
        var tempDay = z - Math.floor(29.5001 * im - 29);
        var i = 0;
        for (; i < dateCorrection.length; i++) {
            if (dateCorrection[i] > modifiedJulianDate) {
                break;
            }
        }
        var iln = i + 16260;
        var ii = Math.floor((iln - 1) / 12);
        var hYear = ii + 1;
        var hmonth = iln - 12 * ii;
        var hDate = modifiedJulianDate - dateCorrection[i - 1] + 1;
        if ((hDate + '').length > 2) {
            hDate = tempDay;
            hmonth = im;
            hYear = iy;
        }
        return { year: hYear, month: hmonth, date: hDate };
    }
    HijriParser.getHijriDate = getHijriDate;
    /**
     *
     * @param {number} year ?
     * @param {number} month ?
     * @param {number} day ?
     * @returns {Date} ?
     */
    function toGregorian(year, month, day) {
        var iy = year;
        var im = month;
        var id = day;
        var ii = iy - 1;
        var iln = (ii * 12) + 1 + (im - 1);
        var i = iln - 16260;
        var mcjdn = id + dateCorrection[i - 1] - 1;
        var julianDate = mcjdn + 2400000;
        var z = Math.floor(julianDate + 0.5);
        var a = Math.floor((z - 1867216.25) / 36524.25);
        a = z + 1 + a - Math.floor(a / 4);
        var b = a + 1524;
        var c = Math.floor((b - 122.1) / 365.25);
        var d = Math.floor(365.25 * c);
        var e = Math.floor((b - d) / 30.6001);
        var gDay = b - d - Math.floor(e * 30.6001);
        var gMonth = e - (e > 13.5 ? 13 : 1);
        var gYear = c - (gMonth > 2.5 ? 4716 : 4715);
        /* istanbul ignore next */
        if (gYear <= 0) {
            gMonth--;
        } // No year zero
        return new Date(gYear + '/' + (gMonth) + '/' + gDay);
    }
    HijriParser.toGregorian = toGregorian;
})(HijriParser || (HijriParser = {}));


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index__ = __webpack_require__(214);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["a"]; });
/**
 * index
 */



/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cssClass */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListBase; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getFieldValues;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__ = __webpack_require__(30);
/* eslint-disable no-inner-declarations */




var cssClass = {
    li: 'e-list-item',
    ul: 'e-list-parent e-ul',
    group: 'e-list-group-item',
    icon: 'e-list-icon',
    text: 'e-list-text',
    check: 'e-list-check',
    checked: 'e-checked',
    selected: 'e-selected',
    expanded: 'e-expanded',
    textContent: 'e-text-content',
    hasChild: 'e-has-child',
    level: 'e-level',
    url: 'e-list-url',
    collapsible: 'e-icon-collapsible',
    disabled: 'e-disabled',
    image: 'e-list-img',
    iconWrapper: 'e-icon-wrapper',
    anchorWrap: 'e-anchor-wrap',
    navigable: 'e-navigable'
};
/**
 * Base List Generator
 */
// eslint-disable-next-line @typescript-eslint/no-namespace
var ListBase;
(function (ListBase) {
    /**
     *
     * Default mapped fields.
     */
    ListBase.defaultMappedFields = {
        id: 'id',
        text: 'text',
        url: 'url',
        value: 'value',
        isChecked: 'isChecked',
        enabled: 'enabled',
        expanded: 'expanded',
        selected: 'selected',
        iconCss: 'iconCss',
        child: 'child',
        isVisible: 'isVisible',
        hasChildren: 'hasChildren',
        tooltip: 'tooltip',
        htmlAttributes: 'htmlAttributes',
        urlAttributes: 'urlAttributes',
        imageAttributes: 'imageAttributes',
        imageUrl: 'imageUrl',
        groupBy: null,
        sortBy: null
    };
    var defaultAriaAttributes = {
        level: 1,
        listRole: 'presentation',
        itemRole: 'presentation',
        groupItemRole: 'group',
        itemText: 'list-item',
        wrapperRole: 'presentation'
    };
    var defaultListBaseOptions = {
        showCheckBox: false,
        showIcon: false,
        enableHtmlSanitizer: false,
        expandCollapse: false,
        fields: ListBase.defaultMappedFields,
        ariaAttributes: defaultAriaAttributes,
        listClass: '',
        itemClass: '',
        processSubChild: false,
        sortOrder: 'None',
        template: null,
        groupTemplate: null,
        headerTemplate: null,
        expandIconClass: 'e-icon-collapsible',
        moduleName: 'list',
        expandIconPosition: 'Right',
        itemNavigable: false
    };
    /**
     * Function helps to created and return the UL Li element based on your data.
     *
     * @param  {createElementParams} createElement - Specifies an array of JSON data.
     *
     * @param  {{Object}[]} dataSource - Specifies an array of JSON data.
     *
     * @param  {ListBaseOptions} options? - Specifies the list options that need to provide.
     *
     * @param  {boolean} isSingleLevel? - Specifies the list options that need to provide.
     *
     * @param  {any} componentInstance? - Specifies the list options that need to provide.
     *
     * @returns  {createElement} createListFromJson - Specifies the list options that need to provide.
     */
    function createList(createElement, dataSource, 
    // eslint-disable-next-line
    options, isSingleLevel, componentInstance) {
        var curOpt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, defaultListBaseOptions, options);
        var ariaAttributes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, defaultAriaAttributes, curOpt.ariaAttributes);
        var type = typeofData(dataSource).typeof;
        if (type === 'string' || type === 'number') {
            return createListFromArray(createElement, dataSource, isSingleLevel, options, componentInstance);
        }
        else {
            return createListFromJson(createElement, dataSource, options, ariaAttributes.level, isSingleLevel, componentInstance);
        }
    }
    ListBase.createList = createList;
    /**
     * Function helps to created an element list based on string array input .
     *
     * @param  {createElementParams} createElement - Specifies an array of JSON data.
     *
     * @param  {{Object}[]} dataSource - Specifies an array of JSON data.
     *
     * @param  {ListBaseOptions} options? - Specifies the list options that need to provide.
     *
     * @param  {boolean} isSingleLevel? - Specifies the list options that need to provide.
     *
     * @param  {any} componentInstance? - Specifies the list options that need to provide.
     *
     * @returns  {createElement} generateUL - returns the list options that need to provide.
     */
    function createListFromArray(createElement, dataSource, 
    // tslint:disable-next-line
    // eslint-disable-next-line
    isSingleLevel, options, componentInstance) {
        var subChild = createListItemFromArray(createElement, dataSource, isSingleLevel, options, componentInstance);
        return generateUL(createElement, subChild, null, options);
    }
    ListBase.createListFromArray = createListFromArray;
    /**
     * Function helps to created an element list based on string array input .
     *
     * @param  {createElementParams} createElement - Specifies an array of JSON data.
     *
     * @param  {{Object}[]} dataSource - Specifies an array of JSON data.
     *
     * @param  {ListBaseOptions} options? - Specifies the list options that need to provide.
     *
     * @param  {boolean} isSingleLevel? - Specifies the list options that need to provide.
     *
     * @param  {any} componentInstance? - Specifies the list options that need to provide.
     *
     * @returns  {HTMLElement[]} subChild - returns the list options that need to provide.
     */
    function createListItemFromArray(createElement, dataSource, 
    // eslint-disable-next-line
    isSingleLevel, options, componentInstance) {
        var subChild = [];
        var curOpt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, defaultListBaseOptions, options);
        cssClass = getModuleClass(curOpt.moduleName);
        var id = generateId(); // generate id for drop-down-list option.
        for (var i = 0; i < dataSource.length; i++) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dataSource[i])) {
                continue;
            }
            var li = void 0;
            if (curOpt.itemCreating && typeof curOpt.itemCreating === 'function') {
                var curData = {
                    dataSource: dataSource,
                    curData: dataSource[i],
                    text: dataSource[i],
                    options: curOpt
                };
                curOpt.itemCreating(curData);
            }
            if (isSingleLevel) {
                li = generateSingleLevelLI(createElement, dataSource[i], undefined, null, null, [], null, id, i, options);
            }
            else {
                li = generateLI(createElement, dataSource[i], undefined, null, null, options, componentInstance);
            }
            if (curOpt.itemCreated && typeof curOpt.itemCreated === 'function') {
                var curData = {
                    dataSource: dataSource,
                    curData: dataSource[i],
                    text: dataSource[i],
                    item: li,
                    options: curOpt
                };
                curOpt.itemCreated(curData);
            }
            subChild.push(li);
        }
        return subChild;
    }
    ListBase.createListItemFromArray = createListItemFromArray;
    /**
     * Function helps to created an element list based on array of JSON input .
     *
     * @param  {createElementParams} createElement - Specifies an array of JSON data.
     *
     * @param  {{Object}[]} dataSource - Specifies an array of JSON data.
     *
     * @param  {ListBaseOptions} options? - Specifies the list options that need to provide.
     *
     * @param  {boolean} isSingleLevel? - Specifies the list options that need to provide.
     *
     * @param  {number} level? - Specifies the list options that need to provide.
     *
     * @param  {any} componentInstance? - Specifies the list options that need to provide.
     *
     * @returns  {HTMLElement[]} child - returns the list options that need to provide.
     */
    function createListItemFromJson(createElement, dataSource, 
    // eslint-disable-next-line
    options, level, isSingleLevel, componentInstance) {
        var curOpt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, defaultListBaseOptions, options);
        cssClass = getModuleClass(curOpt.moduleName);
        var fields = (componentInstance &&
            (componentInstance.getModuleName() === 'listview' || componentInstance.getModuleName() === 'multiselect'))
            ? curOpt.fields : Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, ListBase.defaultMappedFields, curOpt.fields);
        var ariaAttributes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, defaultAriaAttributes, curOpt.ariaAttributes);
        var id;
        var checkboxElement = [];
        if (level) {
            ariaAttributes.level = level;
        }
        var child = [];
        var li;
        var anchorElement;
        if (dataSource && dataSource.length && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(typeofData(dataSource).item) &&
            // eslint-disable-next-line no-prototype-builtins
            !typeofData(dataSource).item.hasOwnProperty(fields.id)) {
            id = generateId(); // generate id for drop-down-list option.
        }
        for (var i = 0; i < dataSource.length; i++) {
            var fieldData = getFieldValues(dataSource[i], fields);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dataSource[i])) {
                continue;
            }
            if (curOpt.itemCreating && typeof curOpt.itemCreating === 'function') {
                var curData = {
                    dataSource: dataSource,
                    curData: dataSource[i],
                    text: fieldData[fields.text],
                    options: curOpt,
                    fields: fields
                };
                curOpt.itemCreating(curData);
            }
            var curItem = dataSource[i];
            if (curOpt.itemCreating && typeof curOpt.itemCreating === 'function') {
                fieldData = getFieldValues(dataSource[i], fields);
            }
            // eslint-disable-next-line no-prototype-builtins
            if (fieldData.hasOwnProperty(fields.id) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fieldData[fields.id])) {
                id = fieldData[fields.id];
            }
            var innerEle = [];
            if (curOpt.showCheckBox) {
                if (curOpt.itemNavigable && (fieldData[fields.url] || fieldData[fields.urlAttributes])) {
                    checkboxElement.push(createElement('input', { className: cssClass.check, attrs: { type: 'checkbox' } }));
                }
                else {
                    innerEle.push(createElement('input', { className: cssClass.check, attrs: { type: 'checkbox' } }));
                }
            }
            if (isSingleLevel === true) {
                // eslint-disable-next-line no-prototype-builtins
                if (curOpt.showIcon && fieldData.hasOwnProperty(fields.iconCss) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fieldData[fields.iconCss])) {
                    innerEle.push(createElement('span', { className: cssClass.icon + ' ' + fieldData[fields.iconCss] }));
                }
                li = generateSingleLevelLI(createElement, curItem, fieldData, fields, curOpt.itemClass, innerEle, 
                // eslint-disable-next-line no-prototype-builtins
                (curItem.hasOwnProperty('isHeader') &&
                    curItem.isHeader) ? true : false, id, i, options);
                anchorElement = li.querySelector('.' + cssClass.anchorWrap);
                if (curOpt.itemNavigable && checkboxElement.length) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["X" /* prepend */])(checkboxElement, li.firstElementChild);
                }
            }
            else {
                li = generateLI(createElement, curItem, fieldData, fields, curOpt.itemClass, options, componentInstance);
                li.classList.add(cssClass.level + '-' + ariaAttributes.level);
                li.setAttribute('aria-level', ariaAttributes.level.toString());
                anchorElement = li.querySelector('.' + cssClass.anchorWrap);
                // eslint-disable-next-line no-prototype-builtins
                if (fieldData.hasOwnProperty(fields.tooltip)) {
                    li.setAttribute('title', fieldData[fields.tooltip]);
                }
                // eslint-disable-next-line no-prototype-builtins
                if (fieldData.hasOwnProperty(fields.htmlAttributes) && fieldData[fields.htmlAttributes]) {
                    setAttribute(li, fieldData[fields.htmlAttributes]);
                }
                // eslint-disable-next-line no-prototype-builtins
                if (fieldData.hasOwnProperty(fields.enabled) && fieldData[fields.enabled] === false) {
                    li.classList.add(cssClass.disabled);
                }
                // eslint-disable-next-line no-prototype-builtins
                if (fieldData.hasOwnProperty(fields.isVisible) && fieldData[fields.isVisible] === false) {
                    li.style.display = 'none';
                }
                // eslint-disable-next-line no-prototype-builtins
                if (fieldData.hasOwnProperty(fields.imageUrl) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fieldData[fields.imageUrl])
                    && !curOpt.template) {
                    var attr = { src: fieldData[fields.imageUrl] };
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["V" /* merge */])(attr, fieldData[fields.imageAttributes]);
                    var imageElemnt = createElement('img', { className: cssClass.image, attrs: attr });
                    if (anchorElement) {
                        anchorElement.insertAdjacentElement('afterbegin', imageElemnt);
                    }
                    else {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["X" /* prepend */])([imageElemnt], li.firstElementChild);
                    }
                }
                // eslint-disable-next-line no-prototype-builtins
                if (curOpt.showIcon && fieldData.hasOwnProperty(fields.iconCss) &&
                    !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fieldData[fields.iconCss]) && !curOpt.template) {
                    var iconElement = createElement('div', { className: cssClass.icon + ' ' + fieldData[fields.iconCss] });
                    if (anchorElement) {
                        anchorElement.insertAdjacentElement('afterbegin', iconElement);
                    }
                    else {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["X" /* prepend */])([iconElement], li.firstElementChild);
                    }
                }
                if (innerEle.length) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["X" /* prepend */])(innerEle, li.firstElementChild);
                }
                if (curOpt.itemNavigable && checkboxElement.length) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["X" /* prepend */])(checkboxElement, li.firstElementChild);
                }
                processSubChild(createElement, fieldData, fields, dataSource, curOpt, li, ariaAttributes.level);
            }
            if (anchorElement) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([li], [cssClass.navigable]);
            }
            if (curOpt.itemCreated && typeof curOpt.itemCreated === 'function') {
                var curData = {
                    dataSource: dataSource,
                    curData: dataSource[i],
                    text: fieldData[fields.text],
                    item: li,
                    options: curOpt,
                    fields: fields
                };
                curOpt.itemCreated(curData);
            }
            checkboxElement = [];
            child.push(li);
        }
        return child;
    }
    ListBase.createListItemFromJson = createListItemFromJson;
    /**
     * Function helps to created an element list based on array of JSON input .
     *
     * @param  {createElementParams} createElement - Specifies an array of JSON data.
     *
     * @param  {{Object}[]} dataSource - Specifies an array of JSON data.
     *
     * @param  {ListBaseOptions} options? - Specifies the list options that need to provide.
     *
     * @param  {number} level? - Specifies the list options that need to provide.
     *
     * @param  {boolean} isSingleLevel? - Specifies the list options that need to provide.
     *
     * @param  {any} componentInstance? - Specifies the list options that need to provide.
     *
     * @returns  {createElement} generateUL - Specifies the list options that need to provide.
     */
    function createListFromJson(createElement, dataSource, 
    // eslint-disable-next-line
    options, level, isSingleLevel, componentInstance) {
        var curOpt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, defaultListBaseOptions, options);
        var li = createListItemFromJson(createElement, dataSource, options, level, isSingleLevel, componentInstance);
        return generateUL(createElement, li, curOpt.listClass, options);
    }
    ListBase.createListFromJson = createListFromJson;
    /**
     * Return the next or previous visible element.
     *
     * @param  {Element[]|NodeList} elementArray - An element array to find next or previous element.
     * @param  {Element} li - An element to find next or previous after this element.
     * @param  {boolean} isPrevious? - Specify when the need get previous element from array.
     */
    function getSiblingLI(elementArray, element, isPrevious) {
        cssClass = getModuleClass(defaultListBaseOptions.moduleName);
        if (!elementArray || !elementArray.length) {
            return void 0;
        }
        var siblingLI;
        var liIndex;
        var liCollections = Array.prototype.slice.call(elementArray);
        if (element) {
            liIndex = indexOf(element, liCollections);
        }
        else {
            liIndex = (isPrevious === true ? liCollections.length : -1);
        }
        siblingLI = liCollections[liIndex + (isPrevious === true ? -1 : 1)];
        while (siblingLI && (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(siblingLI) || siblingLI.classList.contains(cssClass.disabled))) {
            liIndex = liIndex + (isPrevious === true ? -1 : 1);
            siblingLI = liCollections[liIndex];
        }
        return siblingLI;
    }
    ListBase.getSiblingLI = getSiblingLI;
    /**
     * Return the index of the li element
     *
     * @param  {Element} item - An element to find next or previous after this element.
     * @param  {Element[]} elementArray - An element array to find index of given li.
     */
    function indexOf(item, elementArray) {
        if (!elementArray || !item) {
            return void 0;
        }
        else {
            var liCollections = elementArray;
            liCollections = Array.prototype.slice.call(elementArray);
            return liCollections.indexOf(item);
        }
    }
    ListBase.indexOf = indexOf;
    /**
     * Returns the grouped data from given dataSource.
     *
     * @param  {{Object}[]} dataSource - The JSON data which is necessary to process.
     * @param  {FieldsMapping} fields - Fields that are mapped from the data source.
     * @param  {SortOrder} sortOrder- Specifies final result sort order.
     */
    function groupDataSource(dataSource, fields, sortOrder) {
        if (sortOrder === void 0) { sortOrder = 'None'; }
        var curFields = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, ListBase.defaultMappedFields, fields);
        var cusQuery = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["b" /* Query */]().group(curFields.groupBy);
        // need to remove once sorting issues fixed in DataManager
        cusQuery = addSorting(sortOrder, 'key', cusQuery);
        var ds = getDataSource(dataSource, cusQuery);
        dataSource = [];
        for (var j = 0; j < ds.length; j++) {
            var itemObj = ds[j].items;
            var grpItem = {};
            var hdr = 'isHeader';
            grpItem[curFields.text] = ds[j].key;
            grpItem[hdr] = true;
            var newtext = curFields.text;
            if (newtext === 'id') {
                newtext = 'text';
                grpItem[newtext] = ds[j].key;
            }
            grpItem._id = 'group-list-item-' + (ds[j].key ?
                ds[j].key.toString().trim() : 'undefined');
            grpItem.items = itemObj;
            dataSource.push(grpItem);
            for (var k = 0; k < itemObj.length; k++) {
                dataSource.push(itemObj[k]);
            }
        }
        return dataSource;
    }
    ListBase.groupDataSource = groupDataSource;
    /**
     * Returns a sorted query object.
     *
     * @param  {SortOrder} sortOrder - Specifies that sort order.
     * @param  {string} sortBy - Specifies sortBy fields.
     * @param  {Query} query - Pass if any existing query.
     */
    function addSorting(sortOrder, sortBy, query) {
        if (query === void 0) { query = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["b" /* Query */](); }
        if (sortOrder === 'Ascending') {
            query.sortBy(sortBy, 'ascending', true);
        }
        else if (sortOrder === 'Descending') {
            query.sortBy(sortBy, 'descending', true);
        }
        else {
            for (var i = 0; i < query.queries.length; i++) {
                if (query.queries[i].fn === 'onSortBy') {
                    query.queries.splice(i, 1);
                }
            }
        }
        return query;
    }
    ListBase.addSorting = addSorting;
    /**
     * Return an array of JSON Data that processed based on queries.
     *
     * @param  {{Object}[]} dataSource - Specifies local JSON data source.
     *
     * @param  {Query} query - Specifies query that need to process.
     */
    function getDataSource(dataSource, query) {
        // eslint-disable-next-line
        return new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */](dataSource)
            .executeLocal(query);
    }
    ListBase.getDataSource = getDataSource;
    /**
     * Created JSON data based the UL and LI element
     *
     * @param  {HTMLElement|Element} element - UL element that need to convert as a JSON
     * @param  {ListBaseOptions} options? - Specifies listbase option for fields.
     */
    function createJsonFromElement(element, options) {
        var curOpt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, defaultListBaseOptions, options);
        var fields = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, ListBase.defaultMappedFields, curOpt.fields);
        var curEle = element.cloneNode(true);
        // eslint-disable-next-line
        var jsonAr = [];
        curEle.classList.add('json-parent');
        var childs = curEle.querySelectorAll('.json-parent>li');
        curEle.classList.remove('json-parent');
        for (var i = 0; i < childs.length; i++) {
            var li = childs[i];
            var anchor = li.querySelector('a');
            var ul = li.querySelector('ul');
            // eslint-disable-next-line
            var json = {};
            var childNodes = anchor ? anchor.childNodes : li.childNodes;
            var keys = Object.keys(childNodes);
            for (var i_1 = 0; i_1 < childNodes.length; i_1++) {
                if (!(childNodes[Number(keys[i_1])]).hasChildNodes()) {
                    json[fields.text] = childNodes[Number(keys[i_1])].textContent;
                }
            }
            var attributes_1 = getAllAttributes(li);
            if (attributes_1.id) {
                json[fields.id] = attributes_1.id;
                delete attributes_1.id;
            }
            else {
                json[fields.id] = generateId();
            }
            if (Object.keys(attributes_1).length) {
                json[fields.htmlAttributes] = attributes_1;
            }
            if (anchor) {
                attributes_1 = getAllAttributes(anchor);
                if (Object.keys(attributes_1).length) {
                    json[fields.urlAttributes] = attributes_1;
                }
            }
            if (ul) {
                json[fields.child] = createJsonFromElement(ul, options);
            }
            jsonAr.push(json);
        }
        return jsonAr;
    }
    ListBase.createJsonFromElement = createJsonFromElement;
    function typeofData(data) {
        var match = { typeof: null, item: null };
        for (var i = 0; i < data.length; i++) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data[i])) {
                return match = { typeof: typeof data[i], item: data[i] };
            }
        }
        return match;
    }
    function setAttribute(element, elementAttributes) {
        var attr = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["V" /* merge */])(attr, elementAttributes);
        if (attr.class) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([element], attr.class.split(' '));
            delete attr.class;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(element, attr);
    }
    function getAllAttributes(element) {
        var attributes = {};
        var attr = element.attributes;
        for (var index = 0; index < attr.length; index++) {
            attributes[attr[index].nodeName] = attr[index].nodeValue;
        }
        return attributes;
    }
    /**
     * Created UL element from content template.
     *
     * @param  {string} template - that need to convert and generate li element.
     * @param  {{Object}[]} dataSource - Specifies local JSON data source.
     * @param  {ListBaseOptions} options? - Specifies listbase option for fields.
     */
    function renderContentTemplate(createElement, template, dataSource, 
    // eslint-disable-next-line
    fields, options, componentInstance) {
        cssClass = getModuleClass(defaultListBaseOptions.moduleName);
        var ulElement = createElement('ul', { className: cssClass.ul, attrs: { role: 'presentation' } });
        var curOpt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, defaultListBaseOptions, options);
        var curFields = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, ListBase.defaultMappedFields, fields);
        // eslint-disable-next-line
        var compiledString = compileTemplate(template);
        var liCollection = [];
        var value;
        var id = generateId(); // generate id for drop-down-list option.
        for (var i = 0; i < dataSource.length; i++) {
            var fieldData = getFieldValues(dataSource[i], curFields);
            var curItem = dataSource[i];
            var isHeader = curItem.isHeader;
            if (typeof dataSource[i] === 'string' || typeof dataSource[i] === 'number') {
                value = curItem;
            }
            else {
                value = fieldData[curFields.value];
            }
            if (curOpt.itemCreating && typeof curOpt.itemCreating === 'function') {
                var curData = {
                    dataSource: dataSource,
                    curData: curItem,
                    text: value,
                    options: curOpt,
                    fields: curFields
                };
                curOpt.itemCreating(curData);
            }
            if (curOpt.itemCreating && typeof curOpt.itemCreating === 'function') {
                fieldData = getFieldValues(dataSource[i], curFields);
                if (typeof dataSource[i] === 'string' || typeof dataSource[i] === 'number') {
                    value = curItem;
                }
                else {
                    value = fieldData[curFields.value];
                }
            }
            var li = createElement('li', {
                id: id + '-' + i,
                className: isHeader ? cssClass.group : cssClass.li, attrs: { role: 'presentation' }
            });
            if (isHeader) {
                if (typeof dataSource[i] === 'string' || typeof dataSource[i] === 'number') {
                    li.innerText = curItem;
                }
                else {
                    li.innerText = fieldData[curFields.text];
                }
            }
            else {
                var currentID = isHeader ? curOpt.groupTemplateID : curOpt.templateID;
                if (isHeader) {
                    if (componentInstance && componentInstance.getModuleName() != 'listview') {
                        // eslint-disable-next-line
                        var compiledElement = compiledString(curItem, componentInstance, 'headerTemplate', currentID, !!curOpt.isStringTemplate, null, li);
                        if (compiledElement) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(compiledElement, li);
                        }
                    }
                    else {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(compiledString(curItem, componentInstance, 'headerTemplate', currentID, !!curOpt.isStringTemplate), li);
                    }
                }
                else {
                    if (componentInstance && componentInstance.getModuleName() !== 'listview') {
                        // eslint-disable-next-line
                        var compiledElement = compiledString(curItem, componentInstance, 'template', currentID, !!curOpt.isStringTemplate, null, li);
                        if (compiledElement) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(compiledElement, li);
                        }
                    }
                    else {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(compiledString(curItem, componentInstance, 'template', currentID, !!curOpt.isStringTemplate), li);
                    }
                }
                li.setAttribute('data-value', Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(value) ? 'null' : value);
                li.setAttribute('role', 'option');
            }
            if (curOpt.itemCreated && typeof curOpt.itemCreated === 'function') {
                var curData = {
                    dataSource: dataSource,
                    curData: curItem,
                    text: value,
                    item: li,
                    options: curOpt,
                    fields: curFields
                };
                curOpt.itemCreated(curData);
            }
            liCollection.push(li);
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(liCollection, ulElement);
        return ulElement;
    }
    ListBase.renderContentTemplate = renderContentTemplate;
    /**
     * Created header items from group template.
     *
     * @param  {string} template - that need to convert and generate li element.
     *
     * @param  {{Object}[]} dataSource - Specifies local JSON data source.
     *
     * @param  {FieldsMapping} fields - Specifies fields for mapping the dataSource.
     *
     * @param  {Element[]} headerItems? - Specifies listbase header items.
     */
    // tslint:disable-next-line
    function renderGroupTemplate(groupTemplate, groupDataSource, fields, 
    // eslint-disable-next-line
    headerItems, options, componentInstance) {
        // eslint-disable-next-line @typescript-eslint/ban-types
        var compiledString = compileTemplate(groupTemplate);
        var curFields = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, ListBase.defaultMappedFields, fields);
        var curOpt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, defaultListBaseOptions, options);
        var category = curFields.groupBy;
        for (var _i = 0, headerItems_1 = headerItems; _i < headerItems_1.length; _i++) {
            var header = headerItems_1[_i];
            var headerData = {};
            headerData[category] = header.textContent;
            header.innerHTML = '';
            if (componentInstance && componentInstance.getModuleName() !== "listview") {
                // eslint-disable-next-line
                var compiledElement = compiledString(headerData, componentInstance, 'groupTemplate', curOpt.groupTemplateID, !!curOpt.isStringTemplate, null, header);
                if (compiledElement) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(compiledElement, header);
                }
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(compiledString(headerData, componentInstance, 'groupTemplate', curOpt.groupTemplateID, !!curOpt.isStringTemplate), header);
            }
        }
        return headerItems;
    }
    ListBase.renderGroupTemplate = renderGroupTemplate;
    function generateId() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    ListBase.generateId = generateId;
    function processSubChild(createElement, fieldData, fields, ds, options, element, level) {
        // Get SubList
        var subDS = fieldData[fields.child] || [];
        var hasChildren = fieldData[fields.hasChildren];
        //Create Sub child
        if (subDS.length) {
            hasChildren = true;
            element.classList.add(cssClass.hasChild);
            if (options.processSubChild) {
                var subLi = createListFromJson(createElement, subDS, options, ++level);
                element.appendChild(subLi);
            }
        }
        // Create expand and collapse node
        if (!!options.expandCollapse && hasChildren && !options.template) {
            element.firstElementChild.classList.add(cssClass.iconWrapper);
            // eslint-disable-next-line @typescript-eslint/ban-types
            var expandElement = options.expandIconPosition === 'Left' ? __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["X" /* prepend */] : __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */];
            expandElement([createElement('div', { className: 'e-icons ' + options.expandIconClass })], element.querySelector('.' + cssClass.textContent));
        }
    }
    function generateSingleLevelLI(createElement, item, fieldData, fields, className, innerElements, grpLI, id, index, options) {
        var curOpt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, defaultListBaseOptions, options);
        var ariaAttributes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, defaultAriaAttributes, curOpt.ariaAttributes);
        var text = item;
        var value = item;
        var dataSource;
        if (typeof item !== 'string' && typeof item !== 'number' && typeof item !== 'boolean') {
            dataSource = item;
            text = (typeof fieldData[fields.text] === 'boolean' || typeof fieldData[fields.text] === 'number') ?
                fieldData[fields.text] : (fieldData[fields.text] || '');
            value = fieldData[fields.value];
        }
        var elementID;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dataSource) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fieldData[fields.id])
            && fieldData[fields.id] !== '') {
            elementID = id;
        }
        else {
            elementID = id + '-' + index;
        }
        var li = createElement('li', {
            className: (grpLI === true ? cssClass.group : cssClass.li) + ' ' + (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(className) ? '' : className),
            id: elementID, attrs: (ariaAttributes.groupItemRole !== '' && ariaAttributes.itemRole !== '' ?
                { role: (grpLI === true ? ariaAttributes.groupItemRole : ariaAttributes.itemRole) } : {})
        });
        // eslint-disable-next-line no-prototype-builtins
        if (dataSource && fieldData.hasOwnProperty(fields.enabled) && fieldData[fields.enabled].toString() === 'false') {
            li.classList.add(cssClass.disabled);
        }
        if (grpLI) {
            li.innerText = text;
        }
        else {
            li.setAttribute('data-value', Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(value) ? 'null' : value);
            li.setAttribute('role', 'option');
            // eslint-disable-next-line no-prototype-builtins
            if (dataSource && fieldData.hasOwnProperty(fields.htmlAttributes) && fieldData[fields.htmlAttributes]) {
                setAttribute(li, fieldData[fields.htmlAttributes]);
            }
            if (innerElements.length && !curOpt.itemNavigable) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(innerElements, li);
            }
            if (dataSource && (fieldData[fields.url] || (fieldData[fields.urlAttributes] &&
                fieldData[fields.urlAttributes].href))) {
                li.appendChild(anchorTag(createElement, dataSource, fields, text, innerElements, curOpt.itemNavigable));
            }
            else {
                if (innerElements.length && curOpt.itemNavigable) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(innerElements, li);
                }
                li.appendChild(document.createTextNode(text));
            }
        }
        return li;
    }
    function getModuleClass(moduleName) {
        var moduleClass;
        // eslint-disable-next-line
        return moduleClass = {
            li: "e-" + moduleName + "-item",
            ul: "e-" + moduleName + "-parent e-ul",
            group: "e-" + moduleName + "-group-item",
            icon: "e-" + moduleName + "-icon",
            text: "e-" + moduleName + "-text",
            check: "e-" + moduleName + "-check",
            checked: 'e-checked',
            selected: 'e-selected',
            expanded: 'e-expanded',
            textContent: 'e-text-content',
            hasChild: 'e-has-child',
            level: 'e-level',
            url: "e-" + moduleName + "-url",
            collapsible: 'e-icon-collapsible',
            disabled: 'e-disabled',
            image: "e-" + moduleName + "-img",
            iconWrapper: 'e-icon-wrapper',
            anchorWrap: 'e-anchor-wrap',
            navigable: 'e-navigable'
        };
    }
    function anchorTag(createElement, dataSource, fields, text, innerElements, isFullNavigation) {
        var fieldData = getFieldValues(dataSource, fields);
        var attr = { href: fieldData[fields.url] };
        // eslint-disable-next-line no-prototype-builtins
        if (fieldData.hasOwnProperty(fields.urlAttributes) && fieldData[fields.urlAttributes]) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["V" /* merge */])(attr, fieldData[fields.urlAttributes]);
            attr.href = fieldData[fields.url] ? fieldData[fields.url] :
                fieldData[fields.urlAttributes].href;
        }
        var anchorTag;
        if (!isFullNavigation) {
            anchorTag = createElement('a', { className: cssClass.text + ' ' + cssClass.url, innerHTML: text });
        }
        else {
            anchorTag = createElement('a', { className: cssClass.text + ' ' + cssClass.url });
            var anchorWrapper = createElement('div', { className: cssClass.anchorWrap });
            if (innerElements && innerElements.length) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(innerElements, anchorWrapper);
            }
            anchorWrapper.appendChild(document.createTextNode(text));
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])([anchorWrapper], anchorTag);
        }
        setAttribute(anchorTag, attr);
        return anchorTag;
    }
    // tslint:disable-next-line
    /* tslint:disable:align */
    function generateLI(createElement, item, fieldData, 
    // eslint-disable-next-line
    fields, className, options, componentInstance) {
        var curOpt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, defaultListBaseOptions, options);
        var ariaAttributes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, defaultAriaAttributes, curOpt.ariaAttributes);
        var text = item;
        var uID;
        var grpLI;
        var dataSource;
        if (typeof item !== 'string' && typeof item !== 'number') {
            dataSource = item;
            text = fieldData[fields.text] || '';
            // tslint:disable-next-line
            uID = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fieldData['_id'])) ? fieldData[fields.id] : fieldData['_id'];
            // eslint-disable-next-line no-prototype-builtins
            grpLI = (item.hasOwnProperty('isHeader') && item.isHeader)
                ? true : false;
        }
        if (options && options.enableHtmlSanitizer) {
            // eslint-disable-next-line no-self-assign
            text = text;
        }
        var li = createElement('li', {
            className: (grpLI === true ? cssClass.group : cssClass.li) + ' ' + (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(className) ? '' : className),
            attrs: (ariaAttributes.groupItemRole !== '' && ariaAttributes.itemRole !== '' ?
                { role: (grpLI === true ? ariaAttributes.groupItemRole : ariaAttributes.itemRole) } : {})
        });
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(uID) === true) {
            li.setAttribute('data-uid', uID);
        }
        else {
            li.setAttribute('data-uid', generateId());
        }
        if (grpLI && options && options.groupTemplate) {
            // eslint-disable-next-line @typescript-eslint/ban-types
            var compiledString = compileTemplate(options.groupTemplate);
            if (componentInstance && componentInstance.getModuleName() !== "listview") {
                // eslint-disable-next-line
                var compiledElement = compiledString(item, componentInstance, 'groupTemplate', curOpt.groupTemplateID, !!curOpt.isStringTemplate, null, li);
                if (compiledElement) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(compiledElement, li);
                }
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(compiledString(item, componentInstance, 'groupTemplate', curOpt.groupTemplateID, !!curOpt.isStringTemplate), li);
            }
        }
        else if (!grpLI && options && options.template) {
            // eslint-disable-next-line @typescript-eslint/ban-types
            var compiledString = compileTemplate(options.template);
            if (componentInstance && componentInstance.getModuleName() !== 'listview') {
                // eslint-disable-next-line
                var compiledElement = compiledString(item, componentInstance, 'template', curOpt.templateID, !!curOpt.isStringTemplate, null, li);
                if (compiledElement) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(compiledElement, li);
                }
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(compiledString(item, componentInstance, 'template', curOpt.templateID, !!curOpt.isStringTemplate), li);
            }
        }
        else {
            var innerDiv = createElement('div', {
                className: cssClass.textContent,
                attrs: (ariaAttributes.wrapperRole !== '' ? { role: ariaAttributes.wrapperRole } : {})
            });
            if (dataSource && (fieldData[fields.url] || (fieldData[fields.urlAttributes] &&
                fieldData[fields.urlAttributes].href))) {
                innerDiv.appendChild(anchorTag(createElement, dataSource, fields, text, null, curOpt.itemNavigable));
            }
            else {
                var element = createElement('span', {
                    className: cssClass.text,
                    attrs: (ariaAttributes.itemText !== '' ? { role: ariaAttributes.itemText } : {})
                });
                if (options && options.enableHtmlSanitizer) {
                    element.innerText = text;
                }
                else {
                    element.innerHTML = text;
                }
                innerDiv.appendChild(element);
            }
            li.appendChild(innerDiv);
        }
        return li;
    }
    /**
     * Returns UL element based on the given LI element.
     *
     * @param  {HTMLElement[]} liElement - Specifies array of LI element.
     *
     * @param  {string} className? - Specifies class name that need to be added in UL element.
     *
     * @param  {ListBaseOptions} options? - Specifies ListBase options.
     */
    function generateUL(createElement, liElement, className, options) {
        var curOpt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, defaultListBaseOptions, options);
        var ariaAttributes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, defaultAriaAttributes, curOpt.ariaAttributes);
        cssClass = getModuleClass(curOpt.moduleName);
        var ulElement = createElement('ul', {
            className: cssClass.ul + ' ' + (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(className) ? '' : className),
            attrs: (ariaAttributes.listRole !== '' ? { role: ariaAttributes.listRole } : {})
        });
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(liElement, ulElement);
        return ulElement;
    }
    ListBase.generateUL = generateUL;
    /**
     * Returns LI element with additional DIV tag based on the given LI element.
     *
     * @param  {liElement} liElement - Specifies LI element.
     *
     * @param  {string} className? - Specifies class name that need to be added in created DIV element.
     *
     * @param  {ListBaseOptions} options? - Specifies ListBase options.
     */
    function generateIcon(createElement, liElement, className, options) {
        var curOpt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, defaultListBaseOptions, options);
        cssClass = getModuleClass(curOpt.moduleName);
        // eslint-disable-next-line @typescript-eslint/ban-types
        var expandElement = curOpt.expandIconPosition === 'Left' ? __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["X" /* prepend */] : __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */];
        expandElement([createElement('div', {
                className: 'e-icons ' + curOpt.expandIconClass + ' ' +
                    (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(className) ? '' : className)
            })], liElement.querySelector('.' + cssClass.textContent));
        return liElement;
    }
    ListBase.generateIcon = generateIcon;
})(ListBase || (ListBase = {}));
/**
 * Used to get dataSource item from complex data using fields.
 *
 * @param {Object} dataSource - Specifies an  JSON or String data.
 *
 * @param {FieldsMapping} fields - Fields that are mapped from the dataSource.
 */
function getFieldValues(dataItem, fields) {
    var fieldData = {};
    if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dataItem) || typeof (dataItem) === 'string' || typeof (dataItem) === 'number'
        || !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dataItem.isHeader)) {
        return dataItem;
    }
    else {
        for (var _i = 0, _a = Object.keys(fields); _i < _a.length; _i++) {
            var field = _a[_i];
            var dataField = fields[field];
            var value = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dataField) &&
                typeof (dataField) === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(dataField, dataItem) : undefined;
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(value)) {
                fieldData[dataField] = value;
            }
        }
    }
    return fieldData;
}
function compileTemplate(template) {
    if (template) {
        try {
            if (document.querySelector(template)) {
                return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(document.querySelector(template).innerHTML.trim());
            }
            else {
                return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(template);
            }
        }
        catch (e) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(template);
        }
    }
    return undefined;
}


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PositionData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Popup; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getScrollableParent;
/* harmony export (immutable) */ __webpack_exports__["d"] = getZindexPartial;
/* unused harmony export getMaxZindex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_position__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_collision__ = __webpack_require__(44);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








/**
 * Specifies the offset position values.
 */
var PositionData = /** @class */ (function (_super) {
    __extends(PositionData, _super);
    function PositionData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('left')
    ], PositionData.prototype, "X", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('top')
    ], PositionData.prototype, "Y", void 0);
    return PositionData;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

// don't use space in classNames
var CLASSNAMES = {
    ROOT: 'e-popup',
    RTL: 'e-rtl',
    OPEN: 'e-popup-open',
    CLOSE: 'e-popup-close'
};
/**
 * Represents the Popup Component
 * ```html
 * <div id="popup" style="position:absolute;height:100px;width:100px;">
 * <div style="margin:35px 25px;">Popup Content</div></div>
 * ```
 * ```typescript
 * <script>
 *   var popupObj = new Popup();
 *   popupObj.appendTo("#popup");
 * </script>
 * ```
 */
var Popup = /** @class */ (function (_super) {
    __extends(Popup, _super);
    function Popup(element, options) {
        return _super.call(this, options, element) || this;
    }
    /**
     * Called internally if any of the property value changed.
     *
     * @param {PopupModel} newProp - specifies the new property
     * @param {PopupModel} oldProp - specifies the old property
     * @private
     * @returns {void}
     */
    Popup.prototype.onPropertyChanged = function (newProp, oldProp) {
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'width':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'width': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(newProp.width) });
                    break;
                case 'height':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'height': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(newProp.height) });
                    break;
                case 'zIndex':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'zIndex': newProp.zIndex });
                    break;
                case 'enableRtl':
                    this.setEnableRtl();
                    break;
                case 'position':
                case 'relateTo':
                    this.refreshPosition();
                    break;
                case 'offsetX':
                    // eslint-disable-next-line
                    var x = newProp.offsetX - oldProp.offsetX;
                    this.element.style.left = (parseInt(this.element.style.left, 10) + (x)).toString() + 'px';
                    break;
                case 'offsetY':
                    // eslint-disable-next-line
                    var y = newProp.offsetY - oldProp.offsetY;
                    this.element.style.top = (parseInt(this.element.style.top, 10) + (y)).toString() + 'px';
                    break;
                case 'content':
                    this.setContent();
                    break;
                case 'actionOnScroll':
                    if (newProp.actionOnScroll !== 'none') {
                        this.wireScrollEvents();
                    }
                    else {
                        this.unwireScrollEvents();
                    }
                    break;
            }
        }
    };
    /**
     * gets the Component module name.
     *
     * @returns {void}
     * @private
     */
    Popup.prototype.getModuleName = function () {
        return 'popup';
    };
    /**
     * To resolve if any collision occurs.
     *
     * @returns {void}
     */
    Popup.prototype.resolveCollision = function () {
        this.checkCollision();
    };
    /**
     * gets the persisted state properties of the Component.
     *
     * @returns {void}
     */
    Popup.prototype.getPersistData = function () {
        return this.addOnPersist([]);
    };
    /**
     * To destroy the control.
     *
     * @returns {void}
     */
    Popup.prototype.destroy = function () {
        this.element.classList.remove(CLASSNAMES.ROOT, CLASSNAMES.RTL, CLASSNAMES.OPEN, CLASSNAMES.CLOSE);
        this.unwireEvents();
        _super.prototype.destroy.call(this);
    };
    /**
     * To Initialize the control rendering
     *
     * @returns {void}
     * @private
     */
    Popup.prototype.render = function () {
        this.element.classList.add(CLASSNAMES.ROOT);
        var styles = {};
        if (this.zIndex !== 1000) {
            styles.zIndex = this.zIndex;
        }
        if (this.width !== 'auto') {
            styles.width = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.width);
        }
        if (this.height !== 'auto') {
            styles.height = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.height);
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, styles);
        this.fixedParent = false;
        this.setEnableRtl();
        this.setContent();
    };
    Popup.prototype.wireEvents = function () {
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(window, 'orientationchange', this.orientationOnChange, this);
        }
        if (this.actionOnScroll !== 'none') {
            this.wireScrollEvents();
        }
    };
    Popup.prototype.wireScrollEvents = function () {
        if (this.getRelateToElement()) {
            for (var _i = 0, _a = this.getScrollableParent(this.getRelateToElement()); _i < _a.length; _i++) {
                var parent_1 = _a[_i];
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(parent_1, 'scroll', this.scrollRefresh, this);
            }
        }
    };
    Popup.prototype.unwireEvents = function () {
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(window, 'orientationchange', this.orientationOnChange);
        }
        if (this.actionOnScroll !== 'none') {
            this.unwireScrollEvents();
        }
    };
    Popup.prototype.unwireScrollEvents = function () {
        if (this.getRelateToElement()) {
            for (var _i = 0, _a = this.getScrollableParent(this.getRelateToElement()); _i < _a.length; _i++) {
                var parent_2 = _a[_i];
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(parent_2, 'scroll', this.scrollRefresh);
            }
        }
    };
    Popup.prototype.getRelateToElement = function () {
        var relateToElement = this.relateTo === '' || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.relateTo) ?
            document.body : this.relateTo;
        this.setProperties({ relateTo: relateToElement }, true);
        return ((typeof this.relateTo) === 'string') ?
            document.querySelector(this.relateTo) : this.relateTo;
    };
    Popup.prototype.scrollRefresh = function (e) {
        if (this.actionOnScroll === 'reposition') {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element) && !(this.element.offsetParent === e.target ||
                (this.element.offsetParent && this.element.offsetParent.tagName === 'BODY' &&
                    e.target.parentElement == null))) {
                this.refreshPosition();
            }
        }
        else if (this.actionOnScroll === 'hide') {
            this.hide();
        }
        if (this.actionOnScroll !== 'none') {
            if (this.getRelateToElement()) {
                var targetVisible = this.isElementOnViewport(this.getRelateToElement(), e.target);
                if (!targetVisible && !this.targetInvisibleStatus) {
                    this.trigger('targetExitViewport');
                    this.targetInvisibleStatus = true;
                }
                else if (targetVisible) {
                    this.targetInvisibleStatus = false;
                }
            }
        }
    };
    /**
     * This method is to get the element visibility on viewport when scroll
     * the page. This method will returns true even though 1 px of element
     * part is in visible.
     *
     * @param {HTMLElement} relateToElement - specifies the element
     * @param {HTMLElement} scrollElement - specifies the scroll element
     * @returns {boolean} - retruns the boolean
     */
    // eslint-disable-next-line
    Popup.prototype.isElementOnViewport = function (relateToElement, scrollElement) {
        var scrollParents = this.getScrollableParent(relateToElement);
        for (var parent_3 = 0; parent_3 < scrollParents.length; parent_3++) {
            if (this.isElementVisible(relateToElement, scrollParents[parent_3])) {
                continue;
            }
            else {
                return false;
            }
        }
        return true;
    };
    Popup.prototype.isElementVisible = function (relateToElement, scrollElement) {
        var rect = this.checkGetBoundingClientRect(relateToElement);
        if (!rect.height || !rect.width) {
            return false;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.checkGetBoundingClientRect(scrollElement))) {
            var parent_4 = scrollElement.getBoundingClientRect();
            return !(rect.bottom < parent_4.top) &&
                (!(rect.bottom > parent_4.bottom) &&
                    (!(rect.right > parent_4.right) &&
                        !(rect.left < parent_4.left)));
        }
        else {
            var win = window;
            var windowView = {
                top: win.scrollY,
                left: win.scrollX,
                right: win.scrollX + win.outerWidth,
                bottom: win.scrollY + win.outerHeight
            };
            var off = Object(__WEBPACK_IMPORTED_MODULE_1__common_position__["a" /* calculatePosition */])(relateToElement);
            var ele = {
                top: off.top,
                left: off.left,
                right: off.left + rect.width,
                bottom: off.top + rect.height
            };
            var elementView = {
                top: windowView.bottom - ele.top,
                left: windowView.right - ele.left,
                bottom: ele.bottom - windowView.top,
                right: ele.right - windowView.left
            };
            return elementView.top > 0
                && elementView.left > 0
                && elementView.right > 0
                && elementView.bottom > 0;
        }
    };
    /**
     * Initialize the event handler
     *
     * @returns {void}
     * @private
     */
    Popup.prototype.preRender = function () {
        //There is no event handler
    };
    Popup.prototype.setEnableRtl = function () {
        this.reposition();
        // eslint-disable-next-line
        this.enableRtl ? this.element.classList.add(CLASSNAMES.RTL) : this.element.classList.remove(CLASSNAMES.RTL);
    };
    Popup.prototype.setContent = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.content)) {
            this.element.innerHTML = '';
            if (typeof (this.content) === 'string') {
                this.element.textContent = this.content;
            }
            else {
                var relateToElem = this.getRelateToElement();
                // eslint-disable-next-line
                var props = this.content.props;
                if (!relateToElem.classList.contains('e-dropdown-btn') || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(props)) {
                    this.element.appendChild(this.content);
                }
            }
        }
    };
    Popup.prototype.orientationOnChange = function () {
        var _this = this;
        setTimeout(function () {
            _this.refreshPosition();
        }, 200);
    };
    // eslint-disable-next-line
    /**
     * Based on the `relative` element and `offset` values, `Popup` element position will refreshed.
     *
     * @returns {void}
     */
    Popup.prototype.refreshPosition = function (target, collision) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(target)) {
            this.checkFixedParent(target);
        }
        this.reposition();
        if (!collision) {
            this.checkCollision();
        }
    };
    Popup.prototype.reposition = function () {
        var pos;
        var position;
        var relateToElement = this.getRelateToElement();
        if (typeof this.position.X === 'number' && typeof this.position.Y === 'number') {
            pos = { left: this.position.X, top: this.position.Y };
        }
        else if ((typeof this.position.X === 'string' && typeof this.position.Y === 'number') ||
            (typeof this.position.X === 'number' && typeof this.position.Y === 'string')) {
            var parentDisplay = void 0;
            var display = this.element.style.display;
            this.element.style.display = 'block';
            if (this.element.classList.contains('e-dlg-modal')) {
                parentDisplay = this.element.parentElement.style.display;
                this.element.parentElement.style.display = 'block';
            }
            position = this.getAnchorPosition(relateToElement, this.element, this.position, this.offsetX, this.offsetY);
            if (typeof this.position.X === 'string') {
                pos = { left: position.left, top: this.position.Y };
            }
            else {
                pos = { left: this.position.X, top: position.top };
            }
            this.element.style.display = display;
            if (this.element.classList.contains('e-dlg-modal')) {
                this.element.parentElement.style.display = parentDisplay;
            }
        }
        else if (relateToElement) {
            var display = this.element.style.display;
            this.element.style.display = 'block';
            pos = this.getAnchorPosition(relateToElement, this.element, this.position, this.offsetX, this.offsetY);
            this.element.style.display = display;
        }
        else {
            pos = { left: 0, top: 0 };
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(pos)) {
            this.element.style.left = pos.left + 'px';
            this.element.style.top = pos.top + 'px';
        }
    };
    Popup.prototype.checkGetBoundingClientRect = function (ele) {
        var eleRect;
        try {
            eleRect = ele.getBoundingClientRect();
            return eleRect;
        }
        catch (error) {
            return null;
        }
    };
    Popup.prototype.getAnchorPosition = function (anchorEle, ele, position, offsetX, offsetY) {
        var eleRect = this.checkGetBoundingClientRect(ele);
        var anchorRect = this.checkGetBoundingClientRect(anchorEle);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(eleRect) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(anchorRect)) {
            return null;
        }
        var anchor = anchorEle;
        var anchorPos = { left: 0, top: 0 };
        if (ele.offsetParent && ele.offsetParent.tagName === 'BODY' && anchorEle.tagName === 'BODY') {
            anchorPos = Object(__WEBPACK_IMPORTED_MODULE_1__common_position__["a" /* calculatePosition */])(anchorEle);
        }
        else {
            if ((ele.classList.contains('e-dlg-modal') && anchor.tagName !== 'BODY')) {
                ele = ele.parentElement;
            }
            anchorPos = Object(__WEBPACK_IMPORTED_MODULE_1__common_position__["b" /* calculateRelativeBasedPosition */])(anchor, ele);
        }
        switch (position.X) {
            default:
            case 'left':
                break;
            case 'center':
                if ((ele.classList.contains('e-dlg-modal') && anchor.tagName === 'BODY' && this.targetType === 'container')) {
                    anchorPos.left += (window.innerWidth / 2 - eleRect.width / 2);
                }
                else if (this.targetType === 'container') {
                    anchorPos.left += (anchorRect.width / 2 - eleRect.width / 2);
                }
                else {
                    anchorPos.left += (anchorRect.width / 2);
                }
                break;
            case 'right':
                if ((ele.classList.contains('e-dlg-modal') && anchor.tagName === 'BODY' && this.targetType === 'container')) {
                    anchorPos.left += (window.innerWidth - eleRect.width);
                }
                else if (this.targetType === 'container') {
                    anchorPos.left += (anchorRect.width - eleRect.width);
                }
                else {
                    anchorPos.left += (anchorRect.width);
                }
                break;
        }
        switch (position.Y) {
            default:
            case 'top':
                break;
            case 'center':
                if ((ele.classList.contains('e-dlg-modal') && anchor.tagName === 'BODY' && this.targetType === 'container')) {
                    anchorPos.top += (window.innerHeight / 2 - eleRect.height / 2);
                }
                else if (this.targetType === 'container') {
                    anchorPos.top += (anchorRect.height / 2 - eleRect.height / 2);
                }
                else {
                    anchorPos.top += (anchorRect.height / 2);
                }
                break;
            case 'bottom':
                if ((ele.classList.contains('e-dlg-modal') && anchor.tagName === 'BODY' && this.targetType === 'container')) {
                    anchorPos.top += (window.innerHeight - eleRect.height);
                }
                else if (this.targetType === 'container') {
                    anchorPos.top += (anchorRect.height - eleRect.height);
                }
                else {
                    anchorPos.top += (anchorRect.height);
                }
                break;
        }
        anchorPos.left += offsetX;
        anchorPos.top += offsetY;
        return anchorPos;
    };
    Popup.prototype.callFlip = function (param) {
        var relateToElement = this.getRelateToElement();
        Object(__WEBPACK_IMPORTED_MODULE_2__common_collision__["b" /* flip */])(this.element, relateToElement, this.offsetX, this.offsetY, this.position.X, this.position.Y, this.viewPortElement, param, this.fixedParent);
    };
    Popup.prototype.callFit = function (param) {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__common_collision__["c" /* isCollide */])(this.element, this.viewPortElement).length !== 0) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.viewPortElement)) {
                var data = Object(__WEBPACK_IMPORTED_MODULE_2__common_collision__["a" /* fit */])(this.element, this.viewPortElement, param);
                if (param.X) {
                    this.element.style.left = data.left + 'px';
                }
                if (param.Y) {
                    this.element.style.top = data.top + 'px';
                }
            }
            else {
                var elementRect = this.checkGetBoundingClientRect(this.element);
                var viewPortRect = this.checkGetBoundingClientRect(this.viewPortElement);
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(elementRect) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(viewPortRect)) {
                    return null;
                }
                if (param && param.Y === true) {
                    if (viewPortRect.top > elementRect.top) {
                        this.element.style.top = '0px';
                    }
                    else if (viewPortRect.bottom < elementRect.bottom) {
                        this.element.style.top = parseInt(this.element.style.top, 10) - (elementRect.bottom - viewPortRect.bottom) + 'px';
                    }
                }
                if (param && param.X === true) {
                    if (viewPortRect.right < elementRect.right) {
                        this.element.style.left = parseInt(this.element.style.left, 10) - (elementRect.right - viewPortRect.right) + 'px';
                    }
                    else if (viewPortRect.left > elementRect.left) {
                        this.element.style.left = parseInt(this.element.style.left, 10) + (viewPortRect.left - elementRect.left) + 'px';
                    }
                }
            }
        }
    };
    Popup.prototype.checkCollision = function () {
        var horz = this.collision.X;
        var vert = this.collision.Y;
        if (horz === 'none' && vert === 'none') {
            return;
        }
        if (horz === 'flip' && vert === 'flip') {
            this.callFlip({ X: true, Y: true });
        }
        else if (horz === 'fit' && vert === 'fit') {
            this.callFit({ X: true, Y: true });
        }
        else {
            if (horz === 'flip') {
                this.callFlip({ X: true, Y: false });
            }
            else if (vert === 'flip') {
                this.callFlip({ Y: true, X: false });
            }
            if (horz === 'fit') {
                this.callFit({ X: true, Y: false });
            }
            else if (vert === 'fit') {
                this.callFit({ X: false, Y: true });
            }
        }
    };
    /**
     * Shows the popup element from screen.
     *
     * @returns {void}
     * @param {AnimationModel} animationOptions - specifies the model
     * @param { HTMLElement } relativeElement - To calculate the zIndex value dynamically.
     */
    Popup.prototype.show = function (animationOptions, relativeElement) {
        var _this = this;
        this.wireEvents();
        if (this.zIndex === 1000 || !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(relativeElement)) {
            var zIndexElement = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(relativeElement)) ? this.element : relativeElement;
            this.zIndex = getZindexPartial(zIndexElement);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'zIndex': this.zIndex });
        }
        animationOptions = (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(animationOptions) && typeof animationOptions === 'object') ?
            animationOptions : this.showAnimation;
        if (this.collision.X !== 'none' || this.collision.Y !== 'none') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], CLASSNAMES.CLOSE);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], CLASSNAMES.OPEN);
            this.checkCollision();
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], CLASSNAMES.OPEN);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], CLASSNAMES.CLOSE);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(animationOptions)) {
            animationOptions.begin = function () {
                if (!_this.isDestroyed) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([_this.element], CLASSNAMES.CLOSE);
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([_this.element], CLASSNAMES.OPEN);
                }
            };
            animationOptions.end = function () {
                if (!_this.isDestroyed) {
                    _this.trigger('open');
                }
            };
            new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["b" /* Animation */](animationOptions).animate(this.element);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], CLASSNAMES.CLOSE);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], CLASSNAMES.OPEN);
            this.trigger('open');
        }
    };
    /**
     * Hides the popup element from screen.
     *
     * @param {AnimationModel} animationOptions - To give the animation options.
     * @returns {void}
     */
    Popup.prototype.hide = function (animationOptions) {
        var _this = this;
        animationOptions = (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(animationOptions) && typeof animationOptions === 'object') ?
            animationOptions : this.hideAnimation;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(animationOptions)) {
            animationOptions.end = function () {
                if (!_this.isDestroyed) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([_this.element], CLASSNAMES.OPEN);
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([_this.element], CLASSNAMES.CLOSE);
                    _this.trigger('close');
                }
            };
            new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["b" /* Animation */](animationOptions).animate(this.element);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], CLASSNAMES.OPEN);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], CLASSNAMES.CLOSE);
            this.trigger('close');
        }
        this.unwireEvents();
    };
    /**
     * Gets scrollable parent elements for the given element.
     *
     * @returns {void}
     * @param { HTMLElement } element - Specify the element to get the scrollable parents of it.
     */
    Popup.prototype.getScrollableParent = function (element) {
        this.checkFixedParent(element);
        return getScrollableParent(element, this.fixedParent);
    };
    Popup.prototype.checkFixedParent = function (element) {
        var parent = element.parentElement;
        while (parent && parent.tagName !== 'HTML') {
            var parentStyle = getComputedStyle(parent);
            if (parentStyle.position === 'fixed' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element) && this.element.offsetParent && this.element.offsetParent.tagName === 'BODY') {
                this.element.style.top = window.scrollY > parseInt(this.element.style.top) ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(window.scrollY - parseInt(this.element.style.top))
                    : Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(parseInt(this.element.style.top) - window.scrollY);
                this.element.style.position = 'fixed';
                this.fixedParent = true;
            }
            parent = parent.parentElement;
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.offsetParent) && parentStyle.position === 'fixed'
                && this.element.style.position === 'fixed') {
                this.fixedParent = true;
            }
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('auto')
    ], Popup.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('auto')
    ], Popup.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], Popup.prototype, "content", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('container')
    ], Popup.prototype, "targetType", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], Popup.prototype, "viewPortElement", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])({ X: 'none', Y: 'none' })
    ], Popup.prototype, "collision", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Popup.prototype, "relateTo", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({}, PositionData)
    ], Popup.prototype, "position", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(0)
    ], Popup.prototype, "offsetX", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(0)
    ], Popup.prototype, "offsetY", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(1000)
    ], Popup.prototype, "zIndex", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Popup.prototype, "enableRtl", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('reposition')
    ], Popup.prototype, "actionOnScroll", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], Popup.prototype, "showAnimation", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], Popup.prototype, "hideAnimation", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Popup.prototype, "open", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Popup.prototype, "close", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Popup.prototype, "targetExitViewport", void 0);
    Popup = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], Popup);
    return Popup;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));

/**
 * Gets scrollable parent elements for the given element.
 *
 * @param { HTMLElement } element - Specify the element to get the scrollable parents of it.
 * @param {boolean} fixedParent - specifies the parent element
 * @private
 * @returns {void}
 */
function getScrollableParent(element, fixedParent) {
    var eleStyle = getComputedStyle(element);
    var scrollParents = [];
    var overflowRegex = /(auto|scroll)/;
    var parent = element.parentElement;
    while (parent && parent.tagName !== 'HTML') {
        var parentStyle = getComputedStyle(parent);
        if (!(eleStyle.position === 'absolute' && parentStyle.position === 'static')
            && overflowRegex.test(parentStyle.overflow + parentStyle.overflowY + parentStyle.overflowX)) {
            scrollParents.push(parent);
        }
        parent = parent.parentElement;
    }
    if (!fixedParent) {
        scrollParents.push(document);
    }
    return scrollParents;
}
/**
 * Gets the maximum z-index of the given element.
 *
 * @returns {void}
 * @param { HTMLElement } element - Specify the element to get the maximum z-index of it.
 * @private
 */
function getZindexPartial(element) {
    // upto body traversal
    var parent = element.parentElement;
    var parentZindex = [];
    while (parent) {
        if (parent.tagName !== 'BODY') {
            var index = document.defaultView.getComputedStyle(parent, null).getPropertyValue('z-index');
            var position = document.defaultView.getComputedStyle(parent, null).getPropertyValue('position');
            if (index !== 'auto' && position !== 'static') {
                parentZindex.push(index);
            }
            parent = parent.parentElement;
        }
        else {
            break;
        }
    }
    var childrenZindex = [];
    for (var i = 0; i < document.body.children.length; i++) {
        if (!element.isEqualNode(document.body.children[i])) {
            var index = document.defaultView.getComputedStyle(document.body.children[i], null).getPropertyValue('z-index');
            var position = document.defaultView.getComputedStyle(document.body.children[i], null).getPropertyValue('position');
            if (index !== 'auto' && position !== 'static') {
                childrenZindex.push(index);
            }
        }
    }
    childrenZindex.push('999');
    var siblingsZindex = [];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(element.parentElement) && element.parentElement.tagName !== 'BODY') {
        var childNodes = [].slice.call(element.parentElement.children);
        for (var i = 0; i < childNodes.length; i++) {
            if (!element.isEqualNode(childNodes[i])) {
                var index = document.defaultView.getComputedStyle(childNodes[i], null).getPropertyValue('z-index');
                var position = document.defaultView.getComputedStyle(childNodes[i], null).getPropertyValue('position');
                if (index !== 'auto' && position !== 'static') {
                    siblingsZindex.push(index);
                }
            }
        }
    }
    var finalValue = parentZindex.concat(childrenZindex, siblingsZindex);
    // eslint-disable-next-line
    var currentZindexValue = Math.max.apply(Math, finalValue) + 1;
    return currentZindexValue > 2147483647 ? 2147483647 : currentZindexValue;
}
/**
 * Gets the maximum z-index of the page.
 *
 * @returns {void}
 * @param { HTMLElement } tagName - Specify the tagName to get the maximum z-index of it.
 * @private
 */
function getMaxZindex(tagName) {
    if (tagName === void 0) { tagName = ['*']; }
    var maxZindex = [];
    for (var i = 0; i < tagName.length; i++) {
        var elements = document.getElementsByTagName(tagName[i]);
        for (var i_1 = 0; i_1 < elements.length; i_1++) {
            var index = document.defaultView.getComputedStyle(elements[i_1], null).getPropertyValue('z-index');
            var position = document.defaultView.getComputedStyle(elements[i_1], null).getPropertyValue('position');
            if (index !== 'auto' && position !== 'static') {
                maxZindex.push(index);
            }
        }
    }
    // eslint-disable-next-line
    var currentZindexValue = Math.max.apply(Math, maxZindex) + 1;
    return currentZindexValue > 2147483647 ? 2147483647 : currentZindexValue;
}


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fit;
/* harmony export (immutable) */ __webpack_exports__["c"] = isCollide;
/* harmony export (immutable) */ __webpack_exports__["b"] = flip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__position__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__ = __webpack_require__(0);
/**
 * Collision module.
 */


var parentDocument;
var targetContainer;
/**
 *
 * @param {HTMLElement} element - specifies the element
 * @param {HTMLElement} viewPortElement - specifies the element
 * @param {CollisionCoordinates} axis - specifies the collision coordinates
 * @param {OffsetPosition} position - specifies the position
 * @returns {void}
 */
function fit(element, viewPortElement, axis, position) {
    if (viewPortElement === void 0) { viewPortElement = null; }
    if (axis === void 0) { axis = { X: false, Y: false }; }
    if (!axis.Y && !axis.X) {
        return { left: 0, top: 0 };
    }
    var elemData = element.getBoundingClientRect();
    targetContainer = viewPortElement;
    parentDocument = element.ownerDocument;
    if (!position) {
        position = Object(__WEBPACK_IMPORTED_MODULE_0__position__["a" /* calculatePosition */])(element, 'left', 'top');
    }
    if (axis.X) {
        var containerWidth = targetContainer ? getTargetContainerWidth() : getViewPortWidth();
        var containerLeft = ContainerLeft();
        var containerRight = ContainerRight();
        var overLeft = containerLeft - position.left;
        var overRight = position.left + elemData.width - containerRight;
        if (elemData.width > containerWidth) {
            if (overLeft > 0 && overRight <= 0) {
                position.left = containerRight - elemData.width;
            }
            else if (overRight > 0 && overLeft <= 0) {
                position.left = containerLeft;
            }
            else {
                position.left = overLeft > overRight ? (containerRight - elemData.width) : containerLeft;
            }
        }
        else if (overLeft > 0) {
            position.left += overLeft;
        }
        else if (overRight > 0) {
            position.left -= overRight;
        }
    }
    if (axis.Y) {
        var containerHeight = targetContainer ? getTargetContainerHeight() : getViewPortHeight();
        var containerTop = ContainerTop();
        var containerBottom = ContainerBottom();
        var overTop = containerTop - position.top;
        var overBottom = position.top + elemData.height - containerBottom;
        if (elemData.height > containerHeight) {
            if (overTop > 0 && overBottom <= 0) {
                position.top = containerBottom - elemData.height;
            }
            else if (overBottom > 0 && overTop <= 0) {
                position.top = containerTop;
            }
            else {
                position.top = overTop > overBottom ? (containerBottom - elemData.height) : containerTop;
            }
        }
        else if (overTop > 0) {
            position.top += overTop;
        }
        else if (overBottom > 0) {
            position.top -= overBottom;
        }
    }
    return position;
}
/**
 *
 * @param {HTMLElement} element - specifies the html element
 * @param {HTMLElement} viewPortElement - specifies the html element
 * @param {number} x - specifies the number
 * @param {number} y - specifies the number
 * @returns {string[]} - returns the string value
 */
function isCollide(element, viewPortElement, x, y) {
    if (viewPortElement === void 0) { viewPortElement = null; }
    var elemOffset = Object(__WEBPACK_IMPORTED_MODULE_0__position__["a" /* calculatePosition */])(element, 'left', 'top');
    if (x) {
        elemOffset.left = x;
    }
    if (y) {
        elemOffset.top = y;
    }
    var data = [];
    targetContainer = viewPortElement;
    parentDocument = element.ownerDocument;
    var elementRect = element.getBoundingClientRect();
    var top = elemOffset.top;
    var left = elemOffset.left;
    var right = elemOffset.left + elementRect.width;
    var bottom = elemOffset.top + elementRect.height;
    // eslint-disable-next-line
    var topData = '', leftData = '';
    var yAxis = topCollideCheck(top, bottom);
    var xAxis = leftCollideCheck(left, right);
    if (yAxis.topSide) {
        data.push('top');
    }
    if (xAxis.rightSide) {
        data.push('right');
    }
    if (xAxis.leftSide) {
        data.push('left');
    }
    if (yAxis.bottomSide) {
        data.push('bottom');
    }
    return data;
}
/**
 *
 * @param {HTMLElement} element - specifies the element
 * @param {HTMLElement} target - specifies the element
 * @param {number} offsetX - specifies the number
 * @param {number} offsetY - specifies the number
 * @param {string} positionX - specifies the string value
 * @param {string} positionY - specifies the string value
 * @param {HTMLElement} viewPortElement - specifies the element
 * @param {CollisionCoordinates} axis - specifies the collision axis
 * @param {boolean} fixedParent - specifies the boolean
 * @returns {void}
 */
function flip(element, target, offsetX, offsetY, positionX, positionY, viewPortElement, 
/* eslint-disable */
axis, fixedParent) {
    if (viewPortElement === void 0) { viewPortElement = null; }
    if (axis === void 0) { axis = { X: true, Y: true }; }
    if (!target || !element || !positionX || !positionY || (!axis.X && !axis.Y)) {
        return;
    }
    // eslint-disable-next-line
    var tEdge = { TL: null,
        TR: null,
        BL: null,
        BR: null
    }, eEdge = {
        TL: null,
        TR: null,
        BL: null,
        BR: null
        /* eslint-enable */
    };
    var elementRect;
    if (window.getComputedStyle(element).display === 'none') {
        var oldVisibility = element.style.visibility;
        element.style.visibility = 'hidden';
        element.style.display = 'block';
        elementRect = element.getBoundingClientRect();
        element.style.removeProperty('display');
        element.style.visibility = oldVisibility;
    }
    else {
        elementRect = element.getBoundingClientRect();
    }
    var pos = {
        posX: positionX, posY: positionY, offsetX: offsetX, offsetY: offsetY, position: { left: 0, top: 0 }
    };
    targetContainer = viewPortElement;
    parentDocument = target.ownerDocument;
    updateElementData(target, tEdge, pos, fixedParent, elementRect);
    setPosition(eEdge, pos, elementRect);
    if (axis.X) {
        leftFlip(target, eEdge, tEdge, pos, elementRect, true);
    }
    if (axis.Y && tEdge.TL.top > -1) {
        topFlip(target, eEdge, tEdge, pos, elementRect, true);
    }
    setPopup(element, pos, elementRect);
}
/**
 *
 * @param {HTMLElement} element - specifies the element
 * @param {PositionLocation} pos - specifies the location
 * @param {ClientRect} elementRect - specifies the client rect
 * @returns {void}
 */
function setPopup(element, pos, elementRect) {
    //eslint-disable-next-line
    var left = 0, top = 0;
    if (element.offsetParent != null
        && (getComputedStyle(element.offsetParent).position === 'absolute' ||
            getComputedStyle(element.offsetParent).position === 'relative')) {
        var data = Object(__WEBPACK_IMPORTED_MODULE_0__position__["a" /* calculatePosition */])(element.offsetParent, 'left', 'top', false, elementRect);
        left = data.left;
        top = data.top;
    }
    element.style.top = (pos.position.top + pos.offsetY - (top)) + 'px';
    element.style.left = (pos.position.left + pos.offsetX - (left)) + 'px';
}
/**
 *
 * @param {HTMLElement} target - specifies the element
 * @param {EdgeOffset} edge - specifies the offset
 * @param {PositionLocation} pos - specifies theloaction
 * @param {boolean} fixedParent - specifies the boolean
 * @param {ClientRect} elementRect - specifies the client rect
 * @returns {void}
 */
function updateElementData(target, edge, pos, fixedParent, elementRect) {
    pos.position = Object(__WEBPACK_IMPORTED_MODULE_0__position__["a" /* calculatePosition */])(target, pos.posX, pos.posY, fixedParent, elementRect);
    edge.TL = Object(__WEBPACK_IMPORTED_MODULE_0__position__["a" /* calculatePosition */])(target, 'left', 'top', fixedParent, elementRect);
    edge.TR = Object(__WEBPACK_IMPORTED_MODULE_0__position__["a" /* calculatePosition */])(target, 'right', 'top', fixedParent, elementRect);
    edge.BR = Object(__WEBPACK_IMPORTED_MODULE_0__position__["a" /* calculatePosition */])(target, 'left', 'bottom', fixedParent, elementRect);
    edge.BL = Object(__WEBPACK_IMPORTED_MODULE_0__position__["a" /* calculatePosition */])(target, 'right', 'bottom', fixedParent, elementRect);
}
/**
 *
 * @param {EdgeOffset} eStatus - specifies the status
 * @param {PositionLocation} pos - specifies the location
 * @param {ClientRect} elementRect - specifies the client
 * @returns {void}
 */
function setPosition(eStatus, pos, elementRect) {
    eStatus.TL = { top: pos.position.top + pos.offsetY, left: pos.position.left + pos.offsetX };
    eStatus.TR = { top: eStatus.TL.top, left: eStatus.TL.left + elementRect.width };
    eStatus.BL = { top: eStatus.TL.top + elementRect.height,
        left: eStatus.TL.left };
    eStatus.BR = { top: eStatus.TL.top + elementRect.height,
        left: eStatus.TL.left + elementRect.width };
}
/**
 *
 * @param {number} left - specifies the  number
 * @param {number} right - specifies the number
 * @returns {LeftCorners} - returns the value
 */
function leftCollideCheck(left, right) {
    //eslint-disable-next-line
    var leftSide = false, rightSide = false;
    if (((left - getBodyScrollLeft()) < ContainerLeft())) {
        leftSide = true;
    }
    if (right > ContainerRight()) {
        rightSide = true;
    }
    return { leftSide: leftSide, rightSide: rightSide };
}
/**
 *
 * @param {HTMLElement} target - specifies the element
 * @param {EdgeOffset} edge - specifes the element
 * @param {EdgeOffset} tEdge - specifies the edge offset
 * @param {PositionLocation} pos - specifes the location
 * @param {ClientRect} elementRect - specifies the client
 * @param {boolean} deepCheck - specifies the boolean value
 * @returns {void}
 */
function leftFlip(target, edge, tEdge, pos, elementRect, deepCheck) {
    var collideSide = leftCollideCheck(edge.TL.left, edge.TR.left);
    if ((tEdge.TL.left - getBodyScrollLeft()) <= ContainerLeft()) {
        collideSide.leftSide = false;
    }
    if (tEdge.TR.left > ContainerRight()) {
        collideSide.rightSide = false;
    }
    if ((collideSide.leftSide && !collideSide.rightSide) || (!collideSide.leftSide && collideSide.rightSide)) {
        if (pos.posX === 'right') {
            pos.posX = 'left';
        }
        else {
            pos.posX = 'right';
        }
        pos.offsetX = pos.offsetX + elementRect.width;
        pos.offsetX = -1 * pos.offsetX;
        pos.position = Object(__WEBPACK_IMPORTED_MODULE_0__position__["a" /* calculatePosition */])(target, pos.posX, pos.posY, false);
        setPosition(edge, pos, elementRect);
        if (deepCheck) {
            leftFlip(target, edge, tEdge, pos, elementRect, false);
        }
    }
}
/**
 *
 * @param {HTMLElement} target - specifies the element
 * @param {EdgeOffset} edge - specifies the offset
 * @param {EdgeOffset} tEdge - specifies the offset
 * @param {PositionLocation} pos - specifies the location
 * @param {ClientRect} elementRect - specifies the client rect
 * @param {boolean} deepCheck - specifies the boolean
 * @returns {void}
 */
function topFlip(target, edge, tEdge, pos, elementRect, deepCheck) {
    var collideSide = topCollideCheck(edge.TL.top, edge.BL.top);
    if ((tEdge.TL.top - getBodyScrollTop()) <= ContainerTop()) {
        collideSide.topSide = false;
    }
    if (tEdge.BL.top >= ContainerBottom() && target.getBoundingClientRect().bottom < window.innerHeight) {
        collideSide.bottomSide = false;
    }
    if ((collideSide.topSide && !collideSide.bottomSide) || (!collideSide.topSide && collideSide.bottomSide)) {
        if (pos.posY === 'top') {
            pos.posY = 'bottom';
        }
        else {
            pos.posY = 'top';
        }
        pos.offsetY = pos.offsetY + elementRect.height;
        pos.offsetY = -1 * pos.offsetY;
        pos.position = Object(__WEBPACK_IMPORTED_MODULE_0__position__["a" /* calculatePosition */])(target, pos.posX, pos.posY, false, elementRect);
        setPosition(edge, pos, elementRect);
        if (deepCheck) {
            topFlip(target, edge, tEdge, pos, elementRect, false);
        }
    }
}
/**
 *
 * @param {number} top - specifies the number
 * @param {number} bottom - specifies the number
 * @returns {TopCorners} - retyrns the value
 */
function topCollideCheck(top, bottom) {
    //eslint-disable-next-line
    var topSide = false, bottomSide = false;
    if ((top - getBodyScrollTop()) < ContainerTop()) {
        topSide = true;
    }
    if (bottom > ContainerBottom()) {
        bottomSide = true;
    }
    return { topSide: topSide, bottomSide: bottomSide };
}
/**
 * @returns {void}
 */
function getTargetContainerWidth() {
    return targetContainer.getBoundingClientRect().width;
}
/**
 * @returns {void}
 */
function getTargetContainerHeight() {
    return targetContainer.getBoundingClientRect().height;
}
/**
 * @returns {void}
 */
function getTargetContainerLeft() {
    return targetContainer.getBoundingClientRect().left;
}
/**
 * @returns {void}
 */
function getTargetContainerTop() {
    return targetContainer.getBoundingClientRect().top;
}
//eslint-disable-next-line
function ContainerTop() {
    if (targetContainer) {
        return getTargetContainerTop();
    }
    return 0;
}
//eslint-disable-next-line
function ContainerLeft() {
    if (targetContainer) {
        return getTargetContainerLeft();
    }
    return 0;
}
//eslint-disable-next-line
function ContainerRight() {
    if (targetContainer) {
        return (getBodyScrollLeft() + getTargetContainerLeft() + getTargetContainerWidth());
    }
    return (getBodyScrollLeft() + getViewPortWidth());
}
//eslint-disable-next-line
function ContainerBottom() {
    if (targetContainer) {
        return (getBodyScrollTop() + getTargetContainerTop() + getTargetContainerHeight());
    }
    return (getBodyScrollTop() + getViewPortHeight());
}
/**
 * @returns {void}
 */
function getBodyScrollTop() {
    // if(targetContainer)
    //     return targetContainer.scrollTop;
    return parentDocument.documentElement.scrollTop || parentDocument.body.scrollTop;
}
/**
 * @returns {void}
 */
function getBodyScrollLeft() {
    // if(targetContainer)
    //     return targetContainer.scrollLeft;
    return parentDocument.documentElement.scrollLeft || parentDocument.body.scrollLeft;
}
/**
 * @returns {void}
 */
function getViewPortHeight() {
    return window.innerHeight;
}
/**
 * @returns {void}
 */
function getViewPortWidth() {
    var windowWidth = window.innerWidth;
    var documentReact = document.documentElement.getBoundingClientRect();
    var offsetWidth = (Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(document.documentElement)) ? 0 : documentReact.width;
    return windowWidth - (windowWidth - offsetWidth);
}


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mask_base__ = __webpack_require__(259);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__mask_base__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__mask_base__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__mask_base__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__mask_base__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__mask_base__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__mask_base__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__mask_base__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__mask_base__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__mask_base__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__mask_base__["j"]; });
/**
 * MaskedTextbox base modules
 */



/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export aVue */
/* unused harmony export _interopRequireWildcard */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return allVue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return gh; });
/* unused harmony export isExecute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComponentBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(8);
/**
 * Vue Component Base
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var aVue = _interopRequireWildcard(__WEBPACK_IMPORTED_MODULE_1_vue__);
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    else {
        var newObj = {};
        if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key))
                    newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
var allVue = aVue;
var gh = allVue.h;
var isExecute = gh ? false : true;
var vueImport;
if (!isExecute || parseInt(allVue.version) < 3) {
    vueImport = __WEBPACK_IMPORTED_MODULE_1_vue__["default"];
}
else {
    vueImport = __WEBPACK_IMPORTED_MODULE_1_vue__["default"];
}
var ComponentBase = /** @class */ (function (_super) {
    __extends(ComponentBase, _super);
    function ComponentBase() {
        var _this = _super.call(this, arguments) || this;
        _this.hasInjectedModules = false;
        _this.hasChildDirective = false;
        _this.childDirObjects = '';
        _this.isDecorator = false;
        return _this;
    }
    ComponentBase.prototype.created = function () {
        var _this = this;
        if (!this.propKeys) {
            return;
        }
        var _loop_1 = function (prop) {
            this_1.ej2Instances.addEventListener(prop, function (args) {
                _this.$emit(prop, args);
            });
        };
        var this_1 = this;
        for (var _i = 0, _a = this.propKeys; _i < _a.length; _i++) {
            var prop = _a[_i];
            _loop_1(prop);
        }
        var injectables = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('$root.$options.provide', this);
        var vueInjectables = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('$parent.$options.provide', this);
        if (this.hasInjectedModules && !isExecute) {
            var prevModule = [];
            if (injectables && injectables.managed) {
                this.isDecorator = true;
                prevModule = this.getInjectedServices() || [];
            }
            else if (injectables) {
                prevModule = injectables[this.ej2Instances.getModuleName()] || [];
            }
            else if (vueInjectables) {
                prevModule = this.getInjectedServices() || [];
            }
            var curModule = this.ej2Instances.getInjectedModules() || [];
            for (var _b = 0, curModule_1 = curModule; _b < curModule_1.length; _b++) {
                var mod = curModule_1[_b];
                if (prevModule.indexOf(mod) === -1) {
                    prevModule.push(mod);
                }
            }
            this.ej2Instances.injectedModules = prevModule;
        }
    };
    ComponentBase.prototype.mounted = function () {
        var cusEle = this.$el ? this.$el.querySelectorAll("div.e-directive") : null;
        if (gh && cusEle) {
            for (var i = 0; i < cusEle.length; i++) {
                cusEle[i].parentElement && cusEle[i].parentElement.removeChild(cusEle[i]);
            }
        }
        this.ej2Instances.isVue = true;
        this.ej2Instances.isVue3 = this.isVue3;
        this.ej2Instances.vueInstance = this;
        if (this.isVue3) {
            this.ej2Instances.ej2Instances = this.ej2Instances;
            this.ej2Instances.referModels = this.models;
        }
        this.ej2Instances.appendTo(this.$el);
    };
    ComponentBase.prototype.getInjectedServices = function () {
        var ret = [];
        var provide;
        if (this.$root && this.isDecorator) {
            provide = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('$root.$options.provide', this);
        }
        else if (this.$vnode) {
            provide = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('$vnode.context.$options.provide', this);
        }
        else if (this.$parent) {
            provide = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('$parent.$options.provide', this);
        }
        if (provide) {
            // tslint:disable:no-any
            var injectables = provide;
            if (typeof provide === 'function') {
                if (provide.managed) {
                    var provideKey = provide.managed;
                    var provideValue = Object.keys(provideKey);
                    var key = void 0;
                    if (this.$root && this.isDecorator) {
                        key = Object.keys(this.$root);
                    }
                    else if (this.$vnode) {
                        key = Object.keys(this.$vnode.context);
                    }
                    else if (this.$parent) {
                        key = Object.keys(this.$parent);
                    }
                    for (var i = 0; i < provideValue.length; i++) {
                        for (var j = 0; j < key.length; j++) {
                            if ((key[j].indexOf(provideValue[i])) !== -1) {
                                if (this.$root && this.isDecorator) {
                                    provideKey[provideValue[j]] = this.$root[key[i]];
                                }
                                else if (this.$vnode) {
                                    provideKey[provideValue[i]] = this.$vnode.context[key[j]];
                                }
                                else if (this.$parent) {
                                    provideKey[provideValue[i]] = this.$parent[key[j]];
                                }
                                injectables = provideKey;
                            }
                        }
                    }
                }
                // tslint:disable:no-any
                else if (this.$vnode) {
                    injectables = this.$vnode.context.$options.provide();
                }
                else if (this.$parent) {
                    injectables = this.$parent.$options.provide();
                }
            }
            ret = injectables[this.ej2Instances.getModuleName()] || [];
        }
        this.isDecorator = false;
        return ret;
    };
    ComponentBase.prototype.updated = function () {
        if (this.hasChildDirective) {
            var childKey = {};
            this.fetchChildPropValues(childKey);
            var curChildDir = JSON.stringify(childKey);
            if (this.childDirObjects !== curChildDir) {
                this.childDirObjects = curChildDir;
                this.assignValueToWrapper(childKey, false);
            }
        }
    };
    ComponentBase.prototype.beforeDestroy = function () {
        var tempBeforeDestroyThis = this;
        tempBeforeDestroyThis.ej2Instances.destroy();
        tempBeforeDestroyThis.$el.style.visibility = 'hidden';
        tempBeforeDestroyThis = null;
    };
    ComponentBase.prototype.bindProperties = function () {
        var options = {};
        for (var _i = 0, _a = this.propKeys; _i < _a.length; _i++) {
            var prop = _a[_i];
            if ((!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this[prop]) && !this.isVue3) || (this[0] && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this[0][0]) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this[0][0][prop]))) {
                options[prop] = !this.isVue3 ? this[prop] : this[0][0][prop];
            }
        }
        if (this.hasChildDirective) {
            this.fetchChildPropValues(options);
        }
        if (this.hasInjectedModules) {
            var prevModule = this.getInjectedServices() || [];
            var curModule = this.ej2Instances.getInjectedModules() || [];
            for (var _b = 0, curModule_2 = curModule; _b < curModule_2.length; _b++) {
                var mod = curModule_2[_b];
                if (prevModule.indexOf(mod) === -1) {
                    prevModule.push(mod);
                }
            }
            this.ej2Instances.injectedModules = prevModule;
        }
        this.assignValueToWrapper(options);
    };
    ComponentBase.prototype.assignValueToWrapper = function (option, silent) {
        this.ej2Instances.setProperties(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, {}, option, true), Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(silent) ? true : silent);
    };
    ComponentBase.prototype.fetchChildPropValues = function (childOption) {
        var dirProps = {};
        if (!this.isVue3) {
            dirProps = this.getDirectiveValues(this.$slots.default, this.tagMapper || {}, this.tagNameMapper || {});
        }
        else {
            var propRef = void 0;
            if (this[0] && this[0][1].slots.default) {
                propRef = this[0][1].slots.default();
            }
            else if (this && this.$) {
                if (this.$.slots) {
                    propRef = this.$.slots.default();
                }
            }
            if (propRef) {
                for (var i = 0; i < propRef.length; i++) {
                    if (propRef[i].type.methods) {
                        var key = propRef[i].type.methods.getTag().replace("e-", "");
                        var ref = this.resolveArrayDirectives(propRef[i].children, key);
                        var splitKeys = key.split('-');
                        var controlName = this.ej2Instances.getModuleName().toLowerCase();
                        var keyRef = (splitKeys.length > 1 && controlName.indexOf(splitKeys[0]) > -1) ? splitKeys[1] : splitKeys[0];
                        keyRef = keyRef.replace(controlName, '');
                        if (controlName == "splitter" && keyRef == "panes") {
                            keyRef = "paneSettings";
                        }
                        else if (controlName == "bulletchart" && keyRef == "range") {
                            keyRef = "ranges";
                        }
                        else if (controlName == "schedule" && keyRef == "header") {
                            keyRef = "headerRows";
                        }
                        dirProps[keyRef] = ref[key];
                    }
                }
            }
            else {
                return;
            }
        }
        if (!this.childDirObjects) {
            this.childDirObjects = JSON.stringify(dirProps);
        }
        for (var _i = 0, _a = Object.keys(dirProps); _i < _a.length; _i++) {
            var dirProp = _a[_i];
            childOption[dirProp] = dirProps[dirProp];
        }
    };
    ComponentBase.prototype.resolveArrayDirectives = function (slots, tagName) {
        var slot = [];
        var innerDirValues;
        slot = slots.default ? slots.default() : slots;
        var items = {};
        items[tagName] = [];
        var _loop_2 = function (childSlot) {
            var tempObj = {};
            var tagRef = childSlot.type.methods ? childSlot.type.methods.getTag() : tagName;
            if (childSlot.children) {
                var key = void 0;
                innerDirValues = this_2.resolveComplexDirs(childSlot.children, this_2.tagMapper["e-" + tagName], tagRef);
                if (innerDirValues.length) {
                    tempObj = innerDirValues;
                }
                else {
                    for (var i = 0; i < Object.keys(innerDirValues).length; i++) {
                        key = Object.keys(innerDirValues)[i];
                        tempObj[key] = innerDirValues[key];
                    }
                    ;
                }
            }
            if (childSlot.props) {
                Object.keys(childSlot.props).forEach(function (key) {
                    tempObj[key] = childSlot.props[key];
                });
            }
            if ((/[s]\b/).test(tagRef) && innerDirValues) {
                if (!(/[s]\b/).test(tagName) || innerDirValues.length) {
                    items[tagName] = tempObj;
                }
                else {
                    items[tagName].push(tempObj);
                }
            }
            else {
                items[tagName].push(tempObj);
            }
        };
        var this_2 = this;
        for (var _i = 0, slot_1 = slot; _i < slot_1.length; _i++) {
            var childSlot = slot_1[_i];
            _loop_2(childSlot);
        }
        return items;
    };
    ComponentBase.prototype.resolveComplexDirs = function (slots, tagObject, tagName) {
        var slot = [];
        var innerDirValues;
        slot = slots.default ? slots.default() : slots;
        var items = {};
        var _loop_3 = function (childSlot) {
            var tagRef = void 0;
            var tag = void 0;
            if (tagObject[tagName]) {
                tagRef = Object.keys(tagObject[tagName]);
                tag = tagRef.find(function (key) {
                    return tagObject[tagName][key] ===
                        childSlot.type.methods.getTag().replace(/[s]\b/, "");
                });
                tag = tag
                    ? tag.replace("e-", "")
                    : childSlot.type.methods.getTag().replace("e-", "");
                if (this_3.ej2Instances.getModuleName().toLowerCase() == "diagram" && tag.indexOf('annotations') != -1) {
                    tag = 'annotations';
                }
            }
            if (childSlot.children) {
                innerDirValues = this_3.resolveComplexInnerDirs(childSlot.children, tagObject[tagName], childSlot.type.methods.getTag());
                if (!items[tag]) {
                    items[tag] = [];
                }
                if (innerDirValues.length > 1) {
                    items[tag] = innerDirValues;
                }
                else {
                    items[tag].push(innerDirValues);
                }
            }
            if (slot.length > 1) {
                items = Object.keys(items).length == 0 && !items.length ? [] : items;
                if (childSlot.props) {
                    items.push(childSlot.props);
                }
            }
            else {
                items = childSlot.props ? Object.assign(items, childSlot.props) : items;
            }
        };
        var this_3 = this;
        for (var _i = 0, slot_2 = slot; _i < slot_2.length; _i++) {
            var childSlot = slot_2[_i];
            _loop_3(childSlot);
        }
        return items;
    };
    ComponentBase.prototype.resolveComplexInnerDirs = function (slots, tagObject, tagName) {
        var slot = [];
        var innerDirValues;
        slot = slots.default ? slots.default() : slots;
        var items = slot.length > 1 ? [] : {};
        for (var _i = 0, slot_3 = slot; _i < slot_3.length; _i++) {
            var childSlot = slot_3[_i];
            var tag = childSlot.type.methods.getTag().replace("e-", "");
            if (childSlot.children) {
                innerDirValues = this.resolveMultilevelComplexInnerDirs(childSlot.children, tagObject[tagName], childSlot.type.methods.getTag());
                if ((/[s]\b/).test(tag) || slot.length > 1) {
                    if ((/[s]\b/).test(tag)) {
                        items[tag] = !items[tag] ? [] : items[tag];
                        if (innerDirValues.length) {
                            items[tag] = innerDirValues;
                        }
                        else {
                            items[tag].push(innerDirValues);
                        }
                    }
                    else if (innerDirValues) {
                        items.push(innerDirValues);
                    }
                }
                else {
                    items = innerDirValues ? innerDirValues : items;
                }
            }
            if (slot.length > 1 && childSlot.props) {
                if (items.length >= 0) {
                    items.push(childSlot.props);
                }
                else {
                    items = childSlot.props ? Object.assign(items, childSlot.props) : items;
                }
            }
            else {
                items = childSlot.props ? Object.assign(items, childSlot.props) : items;
            }
        }
        return items;
    };
    ComponentBase.prototype.resolveMultilevelComplexInnerDirs = function (slots, tagObject, tagName) {
        var slot = [];
        var innerDirValues;
        slot = slots.default ? slots.default() : slots;
        var items = slot.length > 1 ? [] : {};
        for (var _i = 0, slot_4 = slot; _i < slot_4.length; _i++) {
            var childSlot = slot_4[_i];
            var tag = childSlot.type.methods.getTag().replace("e-", "");
            if (childSlot.children) {
                innerDirValues = this.resolveComplexInnerDirs(childSlot.children, tagObject[tagName], childSlot.type.methods.getTag());
            }
            if ((/[s]\b/).test(tag)) {
                items[tag] = !items[tag] ? [] : items[tag];
                if (innerDirValues.length) {
                    items[tag] = innerDirValues;
                }
                else {
                    items[tag].push(innerDirValues);
                }
                if (childSlot.props) {
                    items[tag].push(childSlot.props);
                }
            }
            else {
                items = innerDirValues;
                items = childSlot.props ? Object.assign(items, childSlot.props) : items;
            }
        }
        return items;
    };
    ComponentBase.prototype.getDirectiveValues = function (tagDirectives, tagMapper, tagNameMapper) {
        var keyTags = Object.keys(tagMapper);
        var dir = {};
        if (tagDirectives) {
            for (var _i = 0, tagDirectives_1 = tagDirectives; _i < tagDirectives_1.length; _i++) {
                var tagDirective = tagDirectives_1[_i];
                if (tagDirective.componentOptions && tagDirective.componentOptions.children && tagDirective.componentOptions.tag) {
                    var dirTag = tagDirective.componentOptions.tag;
                    if (keyTags.indexOf(dirTag) !== -1) {
                        var tagName = tagNameMapper[dirTag] ? tagNameMapper[dirTag] : dirTag;
                        dir[tagName.replace('e-', '')] = [];
                        for (var _a = 0, _b = tagDirective.componentOptions.children; _a < _b.length; _a++) {
                            var tagDirChild = _b[_a];
                            var retObj = this.getVNodeValue(tagDirChild, tagMapper[dirTag], tagNameMapper);
                            if (Object.keys(retObj).length !== 0) {
                                dir[tagName.replace('e-', '')].push(retObj);
                            }
                        }
                    }
                }
            }
        }
        return dir;
    };
    ComponentBase.prototype.getMultiLevelDirValue = function (tagDirectories, tagKey, tagNameMapper) {
        var mulObj = {};
        for (var _i = 0, tagDirectories_1 = tagDirectories; _i < tagDirectories_1.length; _i++) {
            var tagDir = tagDirectories_1[_i];
            if (tagDir.componentOptions) {
                var key = tagDir.componentOptions.tag;
                var tagName = tagNameMapper[key] ? tagNameMapper[key] : key;
                mulObj[tagName.replace('e-', '')] = [];
                if (tagDir.componentOptions && tagDir.componentOptions.children) {
                    for (var _a = 0, _b = tagDir.componentOptions.children; _a < _b.length; _a++) {
                        var tagDirChild = _b[_a];
                        var mulLevObj = this.getVNodeValue(tagDirChild, tagKey[key], tagNameMapper);
                        if (Object.keys(mulLevObj).length !== 0) {
                            mulObj[tagName.replace('e-', '')].push(mulLevObj);
                        }
                    }
                }
            }
        }
        return mulObj;
    };
    ComponentBase.prototype.getVNodeValue = function (tagDirective, tagKey, tagNameMapper) {
        var ret = {};
        if (tagDirective.componentOptions) {
            var dirTag = tagDirective.componentOptions.tag;
            if (typeof tagKey === 'string' && dirTag === tagKey && tagDirective.data) {
                ret = tagDirective.data.attrs ? this.getCamelCaseProps(tagDirective.data.attrs) : this.getCamelCaseProps(tagDirective.data);
            }
            else if (typeof tagKey === 'object') {
                if (tagDirective.componentOptions.children && (Object.keys(tagKey).indexOf(dirTag) !== -1)) {
                    ret = this.getMultiLevelDirValue(tagDirective.componentOptions.children, tagKey[dirTag], tagNameMapper);
                }
                if (tagDirective.data && tagDirective.data.attrs) {
                    ret = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])(ret, this.getCamelCaseProps(tagDirective.data.attrs));
                }
            }
        }
        return ret;
    };
    /**
     * convert kebab case directive props to camel case
     */
    ComponentBase.prototype.getCamelCaseProps = function (props) {
        var retProps = {};
        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
            var prop = _a[_i];
            retProps[prop.replace(/-[a-z]/g, function (e) { return e[1].toUpperCase(); })] = props[prop];
        }
        return retProps;
    };
    ComponentBase.prototype.dataBind = function () {
        this.ej2Instances.dataBind();
    };
    ComponentBase.prototype.setProperties = function (arg, muteOnChange) {
        return this.ej2Instances.setProperties(arg, muteOnChange);
    };
    return ComponentBase;
}(vueImport));



/***/ }),
/* 47 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Comp_TreeView_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Comp_ShowProducts_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Comp_AddProduct_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Comp_DeleteProduct_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Comp_AddSubcat_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Comp_ProductDetails_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Comp_AlternativeProductDetails_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Comp_DeleteCategory_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Comp_BreadCrumb_vue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Comp_MenuBar_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Comp_NewRootNode_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Comp_AddRootNode_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_qs__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_qs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Comp_TreeView: __WEBPACK_IMPORTED_MODULE_0__Comp_TreeView_vue__["a" /* default */],
    Comp_ShowProducts: __WEBPACK_IMPORTED_MODULE_1__Comp_ShowProducts_vue__["a" /* default */],
    Comp_AddProduct: __WEBPACK_IMPORTED_MODULE_2__Comp_AddProduct_vue__["a" /* default */],
    Comp_DeleteProduct: __WEBPACK_IMPORTED_MODULE_3__Comp_DeleteProduct_vue__["a" /* default */],
    Comp_AddSubcat: __WEBPACK_IMPORTED_MODULE_4__Comp_AddSubcat_vue__["a" /* default */],
    Comp_ProductDetails: __WEBPACK_IMPORTED_MODULE_5__Comp_ProductDetails_vue__["a" /* default */],
    Comp_AlternativeProductDetails: __WEBPACK_IMPORTED_MODULE_6__Comp_AlternativeProductDetails_vue__["a" /* default */],
    Comp_DeleteCategory: __WEBPACK_IMPORTED_MODULE_7__Comp_DeleteCategory_vue__["a" /* default */],
    Comp_BreadCrumb: __WEBPACK_IMPORTED_MODULE_8__Comp_BreadCrumb_vue__["a" /* default */],
    Comp_MenuBar: __WEBPACK_IMPORTED_MODULE_9__Comp_MenuBar_vue__["a" /* default */],
    Comp_NewRootNode: __WEBPACK_IMPORTED_MODULE_10__Comp_NewRootNode_vue__["a" /* default */],
    Comp_AddRootNode: __WEBPACK_IMPORTED_MODULE_11__Comp_AddRootNode_vue__["a" /* default */]
  },
  data: function data() {
    return {
      trees: [],
      treeflat: [],
      treeloaded: false,
      products: [],
      selectedproduct: [],
      selectedprodalt: [],
      selectedalternativeproduct: [],
      loadedaltprod: true,
      loadedproductdetails: true,
      firstId: 0,
      Cat: {
        id: 0,
        level: 0,
        catname: null
      },
      Product: {
        id: 0,
        name: null
      },
      AlternativeProduct: {
        id: 0
      },
      Subcat: {
        parentid: 0,
        parentcategory: null,
        name: null,
        level: 0
      },
      CattoDelete: {
        id: 0,
        categoryname: null
      },
      breadcrumb: null,
      showcontent: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    Object.assign(this.$data, this.$options.data.call(this)); // reset all data and props at start
    // url was https://troubled-dove-leggings.cyclic.app
    __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get('https://api-japie.top/meubels/treeview').then(function (response) {
      //var jsonData = response.data[0];
      //alert(JSON.stringify(jsonData, undefined, 2));
      //this.firstId = response.data[0].id; // get Id of root node
      for (var i = 0; i < response.data.length; i++) {
        _this.trees[i] = response.data[i]; // make multiple arrays from the different root nodes
      }
      //alert(this.firstId); //--> OK, id = 1
      //this.tree = jsonData;
      _this.treeloaded = true;
      _this.Cat.level = 1; // set initial level to 1 for root node in breadcrumb
      //this.Cat.id = this.firstId; // set initial id to id of root node because we need to load productalternatives at this level
      _this.Cat.id = _this.trees[0].id;
      _this.Cat.catname = null; // reset because otherwise the data are 'hanging' in memory at browser refresh
      _this.$router.push("/ShowProducts");
    }).catch(function (err) {
      alert(err);
    });
    __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get('https://api-japie.top/meubels/treeviewflat').then(function (response) {
      var jsonData = response.data;
      //alert(JSON.stringify(jsonData, undefined, 2));
      _this.treeflat = jsonData;
    }).catch(function (err) {
      alert(err);
    });
  },

  methods: {
    showprodofcat: function showprodofcat() {
      this.$router.push('/ShowProductsofCat');
    },
    reloadTreeView: function reloadTreeView() {
      var _this2 = this;

      //this.treeloaded = false;
      __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get('https://api-japie.top/meubels/treeview').then(function (response) {
        //var jsonData = response.data[0];
        //this.firstId = response.data[0].id; // get Id of root node
        //this.tree = jsonData;
        _this2.trees = [];
        for (var i = 0; i < response.data.length; i++) {
          _this2.trees[i] = response.data[i];
        }
        //this.$router.push("/ShowProductsofCat");
        _this2.Cat.catname = null; // show no catname
        _this2.breadcrumb = null; // and no breadcrumb
        _this2.$router.push("/ShowProducts"); // load whole product tree
      }).catch(function (err) {
        alert(err);
      });
      __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get('https://api-japie.top/meubels/treeviewflat').then(function (response) {
        var jsonData = response.data;
        //alert(JSON.stringify(jsonData, undefined, 2));
        _this2.treeflat = jsonData;
      }).catch(function (err) {
        alert(err);
      });
    },
    refreshProductAndAlternatives: function refreshProductAndAlternatives() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get('https://api-japie.top/meubels/productandalternatives?productid=' + this.Product.id).then(function (response) {
        _this3.selectedproduct = response.data;
      }).catch(function (err) {
        alert(err);
      });
    },
    unloadaltprod: function unloadaltprod() {
      this.loadedaltprod = false;
    },
    getCrumb: function getCrumb() {
      var _this4 = this;

      var body = {
        "id": this.Cat.id,
        "level": this.Cat.level,
        "catname": this.Cat.catname
        //alert(JSON.stringify(body, undefined, 2));
      };var url = 'https://api-japie.top/meubels/getcrumb';
      var options = {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: __WEBPACK_IMPORTED_MODULE_13_qs___default.a.stringify(body),
        url: url
      };
      __WEBPACK_IMPORTED_MODULE_12_axios___default()(options).then(function (response) {
        var jsonData = response.data;
        _this4.breadcrumb = jsonData;
        //alert(JSON.stringify(this.breadcrumb, undefined, 2));
      }).catch(function (err) {
        alert(err);
      });
    }
  },
  computed: {
    showcontenttrue: function showcontenttrue() {
      return this.showcontent;
    },
    isShowProducts: function isShowProducts() {
      var _this5 = this;

      if (this.$route.name == 'ShowProducts') {
        __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get('https://api-japie.top/meubels/getallproducts').then(function (response) {
          var jsonData = response.data;
          _this5.products = jsonData;
          _this5.showcontent = true; // tree is loaded, products are loaded so show div content
          //alert(JSON.stringify(this.products, undefined, 2));
        }).catch(function (err) {
          alert(err);
        });
        return this.$route.name == 'ShowProducts';
      }

      if (this.$route.name == 'ShowProductsofCat') {
        if (this.$route.query.id && this.$route.query.level && this.$route.query.category) {
          this.Cat.id = this.$route.query.id;
          this.Cat.level = this.$route.query.level;
          this.Cat.catname = this.$route.query.category;
        }
        //alert("Cat Id of this node: " + this.Cat.id + " Level of this node: " + this.Cat.level);
        __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get('https://api-japie.top/meubels/getproducts?CatID=' + this.Cat.id).then(function (response) {
          var jsonData = response.data;
          _this5.products = jsonData;
          //alert(JSON.stringify(jsonData, undefined, 2));
        }).catch(function (err) {
          alert(err);
        });
        return this.$route.name == 'ShowProductsofCat';
      }
    },
    isAddProduct: function isAddProduct() {
      if (this.$route.name == 'AddProduct') {
        this.Cat.id = this.$route.query.id;
        this.Cat.level = this.$route.query.level;
        this.Cat.catname = this.$route.query.category;
        return this.$route.name == 'AddProduct';
      }
    },
    isDeleteProduct: function isDeleteProduct() {
      if (this.$route.name == 'DeleteProduct') {
        this.Product.id = this.$route.query.Id;
        this.Product.name = this.$route.query.ProdName;
        //alert(this.Product.id + " " + this.Product.name);
        return this.$route.name == 'DeleteProduct';
      }
    },
    isAddSubcat: function isAddSubcat() {
      if (this.$route.name == 'AddSubcat') {
        this.Subcat.parentid = this.$route.query.id;
        this.Subcat.parentcategory = this.$route.query.parentcategory;
        this.Subcat.level = this.$route.query.level;
        //alert(this.Product.id + " " + this.Product.name);
        return this.$route.name == 'AddSubcat';
      }
    },
    catnameOnTop: function catnameOnTop() {
      var catname = this.Cat.catname;
      if (catname == null) {
        return 'All products';
      } else {
        return catname;
      }
    },
    isProductDetails: function isProductDetails() {
      var _this6 = this;

      if (this.$route.name == 'ProductDetails') {
        this.loadedproductdetails = false;
        if (this.$route.query.Id && this.$route.query.ProdName) {
          this.Product.id = this.$route.query.Id;
          this.Product.name = this.$route.query.ProdName;
        }
        //alert(this.Product.id);
        __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get('https://api-japie.top/meubels/productandalternatives?productid=' + this.Product.id).then(function (response) {
          _this6.selectedproduct = response.data;
          _this6.loadedproductdetails = true;
        }).catch(function (err) {
          alert(err);
        });
        return this.$route.name == 'ProductDetails';
      }
    },
    isAlternativeProductDetails: function isAlternativeProductDetails() {
      var _this7 = this;

      if (this.$route.name == 'AlternativeProductDetails') {
        this.AlternativeProduct.id = this.$route.query.Id;
        __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get('https://api-japie.top/meubels/productandalternatives?productid=' + this.AlternativeProduct.id).then(function (response) {
          _this7.selectedalternativeproduct = response.data;
          _this7.loadedaltprod = true;
        }).catch(function (err) {
          alert(err);
        });
        return this.$route.name == 'AlternativeProductDetails';
      }
    },
    isDeleteCategory: function isDeleteCategory() {
      if (this.$route.name == 'DeleteCategory') {
        this.CattoDelete.id = this.$route.query.id;
        this.CattoDelete.categoryname = this.$route.query.category;
        return this.$route.name == 'DeleteCategory';
      }
    },
    isNewRootNode: function isNewRootNode() {
      if (this.$route.name == 'NewRootNode') {
        return this.$route.name == 'NewRootNode';
      }
    }
  },
  watch: {
    $route: function $route(to, from) {
      var _this8 = this;

      if (this.$route.name == 'DeleteProd') {
        var id_to_delete = this.$route.query.Id;
        __WEBPACK_IMPORTED_MODULE_12_axios___default.a.post('https://api-japie.top/meubels/deleteproduct?Id=' + id_to_delete).then(function (response) {
          _this8.$router.push('/ShowProductsofCat');
        }).catch(function (err) {
          alert(err);
        });
      }
      if (this.$route.name == 'DeleteCat') {
        var cat_to_delete = this.$route.query.CategoryId;
        //alert(cat_to_delete);
        __WEBPACK_IMPORTED_MODULE_12_axios___default.a.post('https://api-japie.top/meubels/deletecategory?CatID=' + cat_to_delete).then(function (response) {
          _this8.reloadTreeView();
        }).catch(function (err) {
          alert(err);
        });
      }
      if (this.$route.name == 'ShowProductsofCat') {
        if (this.$route.query.id && this.$route.query.level && this.$route.query.category) {
          this.Cat.id = this.$route.query.id;
          this.Cat.level = this.$route.query.level;
          this.Cat.catname = this.$route.query.category;
        }
        if (this.Cat.level == 1) {
          this.breadcrumb = null; // hide breadcrumb at root level because it has no functionality
        } else {
          this.getCrumb();
        }
      }
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_TreeView_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e407d5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_TreeView_vue__ = __webpack_require__(107);
function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65e407d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_TreeView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e407d5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_TreeView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Comp_TreeView',
  props: ['children', 'name', 'catid', 'level'],
  data: function data() {
    return {
      expanded: true
    };
  },

  computed: {
    showHand: function showHand() {
      return { 'has-children': this.children };
    },
    hasChildren: function hasChildren() {
      return this.children;
    },
    indent: function indent() {
      return { transform: 'translate(' + (this.level - 1) * 25 + 'px)' };
    },
    expanded_or_collapsed: function expanded_or_collapsed() {
      return {
        'expanded': this.expanded,
        'collapsed': !this.expanded
      };
    }
  },
  methods: {
    toggleChildren: function toggleChildren() {
      this.expanded = !this.expanded;
    },
    linkClicked: function linkClicked(e) {
      alert("Cat Id of this node: " + e.target.id);
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_ShowProducts_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea7d39de_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_ShowProducts_vue__ = __webpack_require__(110);
function injectStyle (ssrContext) {
  __webpack_require__(108)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea7d39de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_ShowProducts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea7d39de_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_ShowProducts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Comp_ShowProducts',
  props: ['products', 'catname', 'showheader'],
  data: function data() {
    return {};
  },

  methods: {},
  filters: {
    removetilde: function removetilde(string) {
      var firstChar = string.charAt(0);
      if (firstChar == '~') {
        return string.substring(1, string.length);
      } else {
        return string;
      }
    }
  },
  computed: {}
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_AddProduct_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14fc86fd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_AddProduct_vue__ = __webpack_require__(143);
function injectStyle (ssrContext) {
  __webpack_require__(111)
  __webpack_require__(113)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14fc86fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_AddProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14fc86fd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_AddProduct_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // qs was installed from command prompt with npm install qs
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Comp_AddProduct',
  props: ['catid', 'catname', 'level'],
  data: function data() {
    return {
      errors: [],
      form: {},
      name: null,
      description: null,
      price: null,
      url: null,
      imageurl: null
    };
  },
  mounted: function mounted() {
    this.imageurl = null;
  },

  computed: {
    formcomplete: function formcomplete() {
      if (this.name && this.description && this.price && this.imageurl) {
        return true;
      }
      return false;
    }
  },
  methods: {
    submitForm: function submitForm() {
      var _this = this;

      var body = {
        "name": this.name,
        "description": this.description,
        "price": this.price,
        "picture": this.imageurl,
        "catid": this.catid
      };
      var url = 'https://api-japie.top/meubels/addproduct';
      var options = {
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(body),
        url: url
      };
      __WEBPACK_IMPORTED_MODULE_0_axios___default()(options).then(function (res) {
        _this.$emit('showprodofcat');
      });
    },
    onFileChange: function onFileChange(e) {
      var _this2 = this;

      var cloudname = 'dz7ni7eqi';
      var uploadpreset = 'gwhxdpwq';

      var url = "https://api.cloudinary.com/v1_1/" + cloudname + "/image/upload";

      var file = e.target.files[0];
      this.url = URL.createObjectURL(file);

      var data = new FormData();
      data.append('upload_preset', uploadpreset);
      data.append('file', file);
      data.append('cloud_name', cloudname);

      fetch(url, {
        method: "POST",
        body: data
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        var http_string = data.url;
        var https_string = http_string.replace("http:", "https:");
        document.getElementById("url").innerHTML += https_string;
        _this2.imageurl = https_string;
      });
    }
  }
});

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var settle = __webpack_require__(121);
var cookies = __webpack_require__(122);
var buildURL = __webpack_require__(56);
var buildFullPath = __webpack_require__(123);
var parseHeaders = __webpack_require__(126);
var isURLSameOrigin = __webpack_require__(127);
var createError = __webpack_require__(59);
var defaults = __webpack_require__(23);
var Cancel = __webpack_require__(24);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || defaults.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new Cancel('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(57);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = {
  "version": "0.24.0"
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(38);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_DeleteProduct_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cbae5fb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_DeleteProduct_vue__ = __webpack_require__(148);
function injectStyle (ssrContext) {
  __webpack_require__(144)
  __webpack_require__(146)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3cbae5fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_DeleteProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cbae5fb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_DeleteProduct_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Comp_DeleteProduct',
  props: ['id', 'name'],
  data: function data() {
    return {};
  },

  methods: {
    goBack: function goBack() {
      this.$router.push('/ShowProductsofCat');
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_AddSubcat_vue__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88355c96_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_AddSubcat_vue__ = __webpack_require__(153);
function injectStyle (ssrContext) {
  __webpack_require__(149)
  __webpack_require__(151)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-88355c96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_AddSubcat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88355c96_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_AddSubcat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // qs was installed from command prompt with npm install qs
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Comp_AddSubcat',
  props: ['parentcategory', 'parentid', 'level'],
  data: function data() {
    return {
      form: {},
      subcatname: null
    };
  },

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      var body = {
        "subcatname": this.subcatname,
        "parentid": this.parentid,
        "level": this.level
      };
      var url = 'https://api-japie.top/meubels/addsubcat';
      var options = {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(body),
        url: url
      };
      __WEBPACK_IMPORTED_MODULE_0_axios___default()(options).then(function (response) {
        _this.$emit('reloadtreeview');
      }).catch(function (err) {
        alert(err);
      });
    }
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_ProductDetails_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_804d79b6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_ProductDetails_vue__ = __webpack_require__(158);
function injectStyle (ssrContext) {
  __webpack_require__(154)
  __webpack_require__(156)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-804d79b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_ProductDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_804d79b6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_ProductDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // qs was installed from command prompt with npm install qs
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Comp_ProductDetails',
  props: ['name', 'selectedproduct', 'id', 'catid'],
  data: function data() {
    return {
      altprodchooser: false,
      altproducts: [],
      checkedarray: []
    };
  },

  methods: {
    getAllProductsButOne: function getAllProductsButOne() {
      var _this = this;

      this.altprodchooser = !this.altprodchooser;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api-japie.top/meubels/getallproductsfromcategory?notproductid=' + this.id + '&catid=' + this.catid).then(function (response) {
        var jsonData = response.data;
        _this.altproducts = jsonData;
        //alert(JSON.stringify(jsonData, undefined, 2));
      }).catch(function (err) {
        alert(err);
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api-japie.top/meubels/checkedarray?productid=' + this.id).then(function (response) {
        var jsonData = response.data;
        _this.checkedarray = jsonData;
        //alert(JSON.stringify(jsonData, undefined, 2));
      }).catch(function (err) {
        alert(err);
      });
    },

    IdChecked: function IdChecked(id) {
      if (this.checkedarray.includes(id)) {
        return true;
      } else {
        return false;
      }
    },
    checkHandler: function checkHandler(e) {
      var _this2 = this;

      if (e.target.checked) {
        // checked
        //alert('you checked: ' + e.target.id);
        var IdtoInsert = e.target.id;
        var body = {
          "id": this.id,
          "alternativeproductid": IdtoInsert
        };
        var url = 'https://api-japie.top/meubels/addasalternativeproduct';
        var options = {
          method: 'POST',
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
          data: __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(body),
          url: url
        };
        __WEBPACK_IMPORTED_MODULE_0_axios___default()(options).then(function (response) {
          _this2.$emit('refreshalternativeproducts');
        }).catch(function (err) {
          alert(err);
        });
      } else {
        // not checked
        //alert('you unchecked: ' + e.target.id);
        var IdtoDelete = e.target.id;
        var _body = {
          "id": this.id,
          "alternativeproductid": IdtoDelete
        };
        var url = 'https://api-japie.top/meubels/removeasalternativeproduct';
        var _options = {
          method: 'POST',
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
          data: __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(_body),
          url: url
        };
        __WEBPACK_IMPORTED_MODULE_0_axios___default()(_options).then(function (response) {
          _this2.$emit('refreshalternativeproducts');
        }).catch(function (err) {
          alert(err);
        });
      }
    },
    showAltProduct: function showAltProduct(altprodid) {
      //alert(altprodid);
      var id = altprodid;
      this.$emit('unloadaltprod');
      this.$router.push({ name: 'AlternativeProductDetails', query: { Id: id } });
    },
    goBack: function goBack() {
      this.$router.push('/ShowProductsofCat');
    }
  },
  filters: {
    removetilde: function removetilde(string) {
      var firstChar = string.charAt(0);
      if (firstChar == '~') {
        return string.substring(1, string.length);
      } else {
        return string;
      }
    }
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_AlternativeProductDetails_vue__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15445482_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_AlternativeProductDetails_vue__ = __webpack_require__(163);
function injectStyle (ssrContext) {
  __webpack_require__(159)
  __webpack_require__(161)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15445482"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_AlternativeProductDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15445482_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_AlternativeProductDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Comp_AlternativeProductDetails',
  props: ['selectedalternativeproduct'],
  data: function data() {
    return {};
  },

  methods: {
    goBack: function goBack() {
      this.$router.push('/ProductDetails');
    }
  },
  filters: {
    removetilde: function removetilde(string) {
      var firstChar = string.charAt(0);
      if (firstChar == '~') {
        return string.substring(1, string.length);
      } else {
        return string;
      }
    }
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_DeleteCategory_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5948ee38_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_DeleteCategory_vue__ = __webpack_require__(168);
function injectStyle (ssrContext) {
  __webpack_require__(164)
  __webpack_require__(166)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5948ee38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_DeleteCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5948ee38_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_DeleteCategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Comp_DeleteCategory',
  props: ['catid', 'catname'],
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Comp_BreadCrumb',
  props: ['breadcrumb'],
  data: function data() {
    return {};
  },

  methods: {},
  computed: {}
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Comp_MenuBar',
  props: ['menuitems'],
  data: function data() {
    return {
      //Menu fields definition
      menuFields: {
        itemId: 'id',
        text: 'text',
        parentId: 'pid',
        url: 'menuurl'
      }
    };
  },

  methods: {}
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_NewRootNode_vue__ = __webpack_require__(77);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_615c4bf9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_NewRootNode_vue__ = __webpack_require__(186);
function injectStyle (ssrContext) {
  __webpack_require__(184)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-615c4bf9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_NewRootNode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_615c4bf9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_NewRootNode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Comp_NewRootNode',
  props: [],
  data: function data() {
    return {};
  },

  computed: {},
  methods: {}
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // qs was installed from command prompt with npm install qs
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Comp_AddRootNode',
  props: [],
  data: function data() {
    return {
      form: {},
      catname: null
    };
  },

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      var body = {
        "subcatname": this.catname,
        "parentid": 0,
        "level": 0
      };
      var url = 'https://api-japie.top/meubels/addsubcat';
      var options = {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(body),
        url: url
      };
      __WEBPACK_IMPORTED_MODULE_0_axios___default()(options).then(function (response) {
        _this.$emit('reloadtreeview');
      }).catch(function (err) {
        alert(err);
      });
    }
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NumberFormat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internationalization__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intl_base__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parser_base__ = __webpack_require__(20);




var errorText = {
    'ms': 'minimumSignificantDigits',
    'ls': 'maximumSignificantDigits',
    'mf': 'minimumFractionDigits',
    'lf': 'maximumFractionDigits',
};
var integerError = 'minimumIntegerDigits';
var percentSign = 'percentSign';
var minusSign = 'minusSign';
var spaceRegex = /\s/;
var mapper = ['infinity', 'nan', 'group', 'decimal', 'exponential'];
var infinity = 'infinity';
var nan = 'nan';
/**
 * Module for number formatting.
 *
 * @private
 */
var NumberFormat = /** @class */ (function () {
    function NumberFormat() {
    }
    /**
     * Returns the formatter function for given skeleton.
     *
     * @param {string} culture -  Specifies the culture name to be which formatting.
     * @param {NumberFormatOptions} option - Specific the format in which number  will format.
     * @param {Object} cldr - Specifies the global cldr data collection.
     * @returns {Function} ?
     */
    NumberFormat.numberFormatter = function (culture, option, cldr) {
        var _this = this;
        var fOptions = Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])({}, option);
        var cOptions = {};
        var dOptions = {};
        var symbolPattern;
        var dependable = __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].getDependables(cldr, culture, '', true);
        var numObject = dependable.numericObject;
        dOptions.numberMapper = Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isBlazor */])() ? Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])({}, numObject) :
            __WEBPACK_IMPORTED_MODULE_3__parser_base__["a" /* ParserBase */].getNumberMapper(dependable.parserObject, __WEBPACK_IMPORTED_MODULE_3__parser_base__["a" /* ParserBase */].getNumberingSystem(cldr), true);
        dOptions.currencySymbol = Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isBlazor */])() ? Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])('currencySymbol', numObject) : __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].getCurrencySymbol(dependable.numericObject, fOptions.currency || __WEBPACK_IMPORTED_MODULE_1__internationalization__["c" /* defaultCurrencyCode */], option.altSymbol);
        /* eslint-disable  @typescript-eslint/no-explicit-any */
        dOptions.percentSymbol = Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isBlazor */])() ? Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])('numberSymbols.percentSign', numObject) :
            dOptions.numberMapper.numberSymbols[percentSign];
        dOptions.minusSymbol = Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isBlazor */])() ? Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])('numberSymbols.minusSign', numObject) :
            dOptions.numberMapper.numberSymbols[minusSign];
        var symbols = dOptions.numberMapper.numberSymbols;
        if ((option.format) && !(__WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].formatRegex.test(option.format))) {
            cOptions = __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].customFormat(option.format, dOptions, dependable.numericObject);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])(fOptions, __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].getProperNumericSkeleton(option.format || 'N'));
            fOptions.isCurrency = fOptions.type === 'currency';
            fOptions.isPercent = fOptions.type === 'percent';
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isBlazor */])()) {
                symbolPattern = __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].getSymbolPattern(fOptions.type, dOptions.numberMapper.numberSystem, dependable.numericObject, fOptions.isAccount);
            }
            fOptions.groupOne = this.checkValueRange(fOptions.maximumSignificantDigits, fOptions.minimumSignificantDigits, true);
            this.checkValueRange(fOptions.maximumFractionDigits, fOptions.minimumFractionDigits, false, true);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(fOptions.fractionDigits)) {
                fOptions.minimumFractionDigits = fOptions.maximumFractionDigits = fOptions.fractionDigits;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(fOptions.useGrouping)) {
                fOptions.useGrouping = true;
            }
            if (fOptions.isCurrency && !Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isBlazor */])()) {
                symbolPattern = symbolPattern.replace(/\u00A4/g, __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].defaultCurrency);
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isBlazor */])()) {
                var split = symbolPattern.split(';');
                cOptions.nData = __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].getFormatData(split[1] || '-' + split[0], true, dOptions.currencySymbol);
                cOptions.pData = __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].getFormatData(split[0], false, dOptions.currencySymbol);
                if (fOptions.useGrouping) {
                    fOptions.groupSeparator = symbols[mapper[2]];
                    fOptions.groupData = this.getGroupingDetails(split[0]);
                }
            }
            else {
                cOptions.nData = Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])({}, {}, Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])(fOptions.type + 'nData', numObject));
                cOptions.pData = Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])({}, {}, Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])(fOptions.type + 'pData', numObject));
                if (fOptions.type === 'currency' && option.currency) {
                    __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].replaceBlazorCurrency([cOptions.pData, cOptions.nData], dOptions.currencySymbol, option.currency);
                }
            }
            var minFrac = Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(fOptions.minimumFractionDigits);
            if (minFrac) {
                fOptions.minimumFractionDigits = cOptions.nData.minimumFraction;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(fOptions.maximumFractionDigits)) {
                var mval = cOptions.nData.maximumFraction;
                fOptions.maximumFractionDigits = Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(mval) && fOptions.isPercent ? 0 : mval;
            }
            var mfrac = fOptions.minimumFractionDigits;
            var lfrac = fOptions.maximumFractionDigits;
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(mfrac) && !Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(lfrac)) {
                if (mfrac > lfrac) {
                    fOptions.maximumFractionDigits = mfrac;
                }
            }
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])(cOptions.nData, fOptions);
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])(cOptions.pData, fOptions);
        return function (value) {
            if (isNaN(value)) {
                return symbols[mapper[1]];
            }
            else if (!isFinite(value)) {
                return symbols[mapper[0]];
            }
            return _this.intNumberFormatter(value, cOptions, dOptions);
        };
    };
    /**
     * Returns grouping details for the pattern provided
     *
     * @param {string} pattern ?
     * @returns {GroupDetails} ?
     */
    NumberFormat.getGroupingDetails = function (pattern) {
        var ret = {};
        var match = pattern.match(__WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].negativeDataRegex);
        if (match && match[4]) {
            var pattern_1 = match[4];
            var p = pattern_1.lastIndexOf(',');
            if (p !== -1) {
                var temp = pattern_1.split('.')[0];
                ret.primary = (temp.length - p) - 1;
                var s = pattern_1.lastIndexOf(',', p - 1);
                if (s !== -1) {
                    ret.secondary = p - 1 - s;
                }
            }
        }
        return ret;
    };
    /**
     * Returns if the provided integer range is valid.
     *
     * @param {number} val1 ?
     * @param {number} val2 ?
     * @param {boolean} checkbothExist ?
     * @param {boolean} isFraction ?
     * @returns {boolean} ?
     */
    NumberFormat.checkValueRange = function (val1, val2, checkbothExist, isFraction) {
        var decide = isFraction ? 'f' : 's';
        var dint = 0;
        var str1 = errorText['l' + decide];
        // eslint-disable-next-line
        var str2 = errorText['m' + decide];
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(val1)) {
            this.checkRange(val1, str1, isFraction);
            dint++;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(val2)) {
            this.checkRange(val2, str2, isFraction);
            dint++;
        }
        if (dint === 2) {
            if (val1 < val2) {
                Object(__WEBPACK_IMPORTED_MODULE_0__util__["s" /* throwError */])(str2 + 'specified must be less than the' + str1);
            }
            else {
                return true;
            }
        }
        else if (checkbothExist && dint === 1) {
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["s" /* throwError */])('Both' + str2 + 'and' + str2 + 'must be present');
        }
        return false;
    };
    /**
     * Check if the provided fraction range is valid
     *
     * @param {number} val ?
     * @param {string} text ?
     * @param {boolean} isFraction ?
     * @returns {void} ?
     */
    NumberFormat.checkRange = function (val, text, isFraction) {
        var range = isFraction ? [0, 20] : [1, 21];
        if (val < range[0] || val > range[1]) {
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["s" /* throwError */])(text + 'value must be within the range' + range[0] + 'to' + range[1]);
        }
    };
    /**
     * Returns formatted numeric string for provided formatting options
     *
     * @param {number} value ?
     * @param {base.GenericFormatOptions} fOptions ?
     * @param {CommonOptions} dOptions ?
     * @returns {string} ?
     */
    NumberFormat.intNumberFormatter = function (value, fOptions, dOptions) {
        var curData;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(fOptions.nData.type)) {
            return undefined;
        }
        else {
            if (value < 0) {
                value = value * -1;
                curData = fOptions.nData;
            }
            else if (value === 0) {
                curData = fOptions.zeroData || fOptions.pData;
            }
            else {
                curData = fOptions.pData;
            }
            var fValue = '';
            if (curData.isPercent) {
                value = value * 100;
            }
            if (curData.groupOne) {
                fValue = this.processSignificantDigits(value, curData.minimumSignificantDigits, curData.maximumSignificantDigits);
            }
            else {
                fValue = this.processFraction(value, curData.minimumFractionDigits, curData.maximumFractionDigits);
                if (curData.minimumIntegerDigits) {
                    fValue = this.processMinimumIntegers(fValue, curData.minimumIntegerDigits);
                }
            }
            if (curData.type === 'scientific') {
                fValue = value.toExponential(curData.maximumFractionDigits);
                fValue = fValue.replace('e', dOptions.numberMapper.numberSymbols[mapper[4]]);
            }
            fValue = fValue.replace('.', dOptions.numberMapper.numberSymbols[mapper[3]]);
            if (curData.useGrouping) {
                /* eslint-disable  @typescript-eslint/no-explicit-any */
                fValue = this.groupNumbers(fValue, curData.groupData.primary, curData.groupSeparator || ',', dOptions.numberMapper.numberSymbols[mapper[3]] || '.', curData.groupData.secondary);
            }
            fValue = __WEBPACK_IMPORTED_MODULE_3__parser_base__["a" /* ParserBase */].convertValueParts(fValue, __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].latnParseRegex, dOptions.numberMapper.mapper);
            if (curData.nlead === 'N/A') {
                return curData.nlead;
            }
            else {
                return curData.nlead + fValue + curData.nend;
            }
        }
    };
    /**
     * Returns significant digits processed numeric string
     *
     * @param {number} value ?
     * @param {number} min ?
     * @param {number} max ?
     * @returns {string} ?
     */
    NumberFormat.processSignificantDigits = function (value, min, max) {
        var temp = value + '';
        var tn;
        var length = temp.length;
        if (length < min) {
            return value.toPrecision(min);
        }
        else {
            temp = value.toPrecision(max);
            tn = +temp;
            return tn + '';
        }
    };
    /**
     * Returns grouped numeric string
     *
     * @param {string} val ?
     * @param {number} level1 ?
     * @param {string} sep ?
     * @param {string} decimalSymbol ?
     * @param {number} level2 ?
     * @returns {string} ?
     */
    NumberFormat.groupNumbers = function (val, level1, sep, decimalSymbol, level2) {
        var flag = !Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(level2) && level2 !== 0;
        var split = val.split(decimalSymbol);
        var prefix = split[0];
        var length = prefix.length;
        var str = '';
        while (length > level1) {
            str = prefix.slice(length - level1, length) + (str.length ?
                (sep + str) : '');
            length -= level1;
            if (flag) {
                level1 = level2;
                flag = false;
            }
        }
        split[0] = prefix.slice(0, length) + (str.length ? sep : '') + str;
        return split.join(decimalSymbol);
    };
    /**
     * Returns fraction processed numeric string
     *
     * @param {number} value ?
     * @param {number} min ?
     * @param {number} max ?
     * @returns {string} ?
     */
    NumberFormat.processFraction = function (value, min, max) {
        var temp = (value + '').split('.')[1];
        var length = temp ? temp.length : 0;
        if (min && length < min) {
            var ret = '';
            if (length === 0) {
                ret = value.toFixed(min);
            }
            else {
                ret += value;
                for (var j = 0; j < min - length; j++) {
                    ret += '0';
                }
                return ret;
            }
            return value.toFixed(min);
        }
        else if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(max) && (length > max || max === 0)) {
            return value.toFixed(max);
        }
        return value + '';
    };
    /**
     * Returns integer processed numeric string
     *
     * @param {string} value ?
     * @param {number} min ?
     * @returns {string} ?
     */
    NumberFormat.processMinimumIntegers = function (value, min) {
        var temp = value.split('.');
        var lead = temp[0];
        var len = lead.length;
        if (len < min) {
            for (var i = 0; i < min - len; i++) {
                lead = '0' + lead;
            }
            temp[0] = lead;
        }
        return temp.join('.');
    };
    return NumberFormat;
}());



/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModuleLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(1);
/**
 * Module loading operations
 */

var MODULE_SUFFIX = 'Module';
var ModuleLoader = /** @class */ (function () {
    function ModuleLoader(parent) {
        this.loadedModules = [];
        this.parent = parent;
    }
    /**
     * Inject required modules in component library
     *
     * @returns {void} ?
     * @param {ModuleDeclaration[]} requiredModules - Array of modules to be required
     * @param {Function[]} moduleList - Array of modules to be injected from sample side
     */
    ModuleLoader.prototype.inject = function (requiredModules, moduleList) {
        var reqLength = requiredModules.length;
        if (reqLength === 0) {
            this.clean();
            return;
        }
        if (this.loadedModules.length) {
            this.clearUnusedModule(requiredModules);
        }
        for (var i = 0; i < reqLength; i++) {
            var modl = requiredModules[i];
            for (var _i = 0, moduleList_1 = moduleList; _i < moduleList_1.length; _i++) {
                var module = moduleList_1[_i];
                var modName = modl.member;
                if (module.prototype.getModuleName() === modl.member && !this.isModuleLoaded(modName)) {
                    var moduleObject = Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* createInstance */])(module, modl.args);
                    var memberName = this.getMemberName(modName);
                    if (modl.isProperty) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__util__["r" /* setValue */])(memberName, module, this.parent);
                    }
                    else {
                        Object(__WEBPACK_IMPORTED_MODULE_0__util__["r" /* setValue */])(memberName, moduleObject, this.parent);
                    }
                    var loadedModule = modl;
                    loadedModule.member = memberName;
                    this.loadedModules.push(loadedModule);
                }
            }
        }
    };
    /**
     * To remove the created object while destroying the control
     *
     * @returns {void}
     */
    ModuleLoader.prototype.clean = function () {
        for (var _i = 0, _a = this.loadedModules; _i < _a.length; _i++) {
            var modules = _a[_i];
            if (!modules.isProperty) {
                Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])(modules.member, this.parent).destroy();
            }
        }
        this.loadedModules = [];
    };
    /**
     * Removes all unused modules
     *
     * @param {ModuleDeclaration[]} moduleList ?
     * @returns {void} ?
     */
    ModuleLoader.prototype.clearUnusedModule = function (moduleList) {
        var _this = this;
        var usedModules = moduleList.map(function (arg) { return _this.getMemberName(arg.member); });
        var removableModule = this.loadedModules.filter(function (module) {
            return usedModules.indexOf(module.member) === -1;
        });
        for (var _i = 0, removableModule_1 = removableModule; _i < removableModule_1.length; _i++) {
            var mod = removableModule_1[_i];
            if (!mod.isProperty) {
                Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])(mod.member, this.parent).destroy();
            }
            this.loadedModules.splice(this.loadedModules.indexOf(mod), 1);
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* deleteObject */])(this.parent, mod.member);
        }
    };
    /**
     * To get the name of the member.
     *
     * @param {string} name ?
     * @returns {string} ?
     */
    ModuleLoader.prototype.getMemberName = function (name) {
        return name[0].toLowerCase() + name.substring(1) + MODULE_SUFFIX;
    };
    /**
     * Returns boolean based on whether the module specified is loaded or not
     *
     * @param {string} modName ?
     * @returns {boolean} ?
     */
    ModuleLoader.prototype.isModuleLoaded = function (modName) {
        for (var _i = 0, _a = this.loadedModules; _i < _a.length; _i++) {
            var mod = _a[_i];
            if (mod.member === this.getMemberName(modName)) {
                return true;
            }
        }
        return false;
    };
    return ModuleLoader;
}());



/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addScrolling;
/* harmony export (immutable) */ __webpack_exports__["b"] = destroyScroll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__v_scroll__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__h_scroll__ = __webpack_require__(25);



/**
 * Used to add scroll in menu.
 *
 * @param {createElementType} createElement - Specifies the create element model
 * @param {HTMLElement} container - Specifies the element container
 * @param {HTMLElement} content - Specifies the content element
 * @param {string} scrollType - Specifies the scroll type
 * @param {boolean} enableRtl - Specifies the enable RTL property
 * @param {boolean} offset - Specifies the offset value
 * @returns {HTMLElement} - Element
 * @hidden
 */
function addScrolling(createElement, container, content, scrollType, enableRtl, offset) {
    var containerOffset;
    var contentOffset;
    var parentElem = container.parentElement;
    if (scrollType === 'vscroll') {
        containerOffset = offset || container.getBoundingClientRect().height;
        contentOffset = content.getBoundingClientRect().height;
    }
    else {
        containerOffset = container.getBoundingClientRect().width;
        contentOffset = content.getBoundingClientRect().width;
    }
    if (containerOffset < contentOffset) {
        return createScrollbar(createElement, container, content, scrollType, enableRtl, offset);
    }
    else if (parentElem) {
        var width = parentElem.getBoundingClientRect().width;
        if (width < containerOffset && scrollType === 'hscroll') {
            contentOffset = width;
            container.style.maxWidth = width + 'px';
            return createScrollbar(createElement, container, content, scrollType, enableRtl, offset);
        }
        return content;
    }
    else {
        return content;
    }
}
/**
 * Used to create scroll bar in menu.
 *
 * @param {createElementType} createElement - Specifies the create element model
 * @param {HTMLElement} container - Specifies the element container
 * @param {HTMLElement} content - Specifies the content element
 * @param {string} scrollType - Specifies the scroll type
 * @param {boolean} enableRtl - Specifies the enable RTL property
 * @param {boolean} offset - Specifies the offset value
 * @returns {HTMLElement} - Element
 * @hidden
 */
function createScrollbar(createElement, container, content, scrollType, enableRtl, offset) {
    var scrollEle = createElement('div', { className: 'e-menu-' + scrollType });
    container.appendChild(scrollEle);
    scrollEle.appendChild(content);
    if (offset) {
        scrollEle.style.overflow = 'hidden';
        scrollEle.style.height = offset + 'px';
    }
    else {
        scrollEle.style.maxHeight = container.style.maxHeight;
        container.style.overflow = 'hidden';
    }
    var scrollObj;
    if (scrollType === 'vscroll') {
        scrollObj = new __WEBPACK_IMPORTED_MODULE_1__v_scroll__["a" /* VScroll */]({ enableRtl: enableRtl }, scrollEle);
        scrollObj.scrollStep = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-' + scrollType + '-bar', container).offsetHeight / 2;
    }
    else {
        scrollObj = new __WEBPACK_IMPORTED_MODULE_2__h_scroll__["a" /* HScroll */]({ enableRtl: enableRtl }, scrollEle);
        scrollObj.scrollStep = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-' + scrollType + '-bar', container).offsetWidth;
    }
    return scrollEle;
}
/**
 * Used to destroy the scroll option.
 *
 * @param {VScroll | HScroll} scrollObj - Specifies the scroller object
 * @param {Element} element - Specifies the element
 * @param {HTMLElement} skipEle - Specifies the skip  element
 * @returns {void}
 * @hidden
 */
function destroyScroll(scrollObj, element, skipEle) {
    if (scrollObj) {
        var menu = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-menu-parent', element);
        if (menu) {
            if (!skipEle || skipEle === menu) {
                scrollObj.destroy();
                element.parentElement.appendChild(menu);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(element);
            }
        }
        else {
            scrollObj.destroy();
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(element);
        }
    }
}


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return classNames; });
/* unused harmony export FieldSettings */
/* unused harmony export ListView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_buttons__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_list_base__ = __webpack_require__(42);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









// Effect Configuration Effect[] =  [fromViewBackward,fromViewForward,toViewBackward,toviewForward];
var effectsConfig = {
    'None': [],
    'SlideLeft': ['SlideRightOut', 'SlideLeftOut', 'SlideLeftIn', 'SlideRightIn'],
    'SlideDown': ['SlideTopOut', 'SlideBottomOut', 'SlideBottomIn', 'SlideTopIn'],
    'Zoom': ['FadeOut', 'FadeZoomOut', 'FadeZoomIn', 'FadeIn'],
    'Fade': ['FadeOut', 'FadeOut', 'FadeIn', 'FadeIn']
};
var effectsRTLConfig = {
    'None': [],
    'SlideLeft': ['SlideLeftOut', 'SlideRightOut', 'SlideRightIn', 'SlideLeftIn'],
    'SlideDown': ['SlideBottomOut', 'SlideTopOut', 'SlideTopIn', 'SlideBottomIn'],
    'Zoom': ['FadeZoomOut', 'FadeOut', 'FadeIn', 'FadeZoomIn'],
    'Fade': ['FadeOut', 'FadeOut', 'FadeIn', 'FadeIn']
};
// don't use space in classnames.
var classNames = {
    root: 'e-listview',
    hover: 'e-hover',
    selected: 'e-active',
    focused: 'e-focused',
    parentItem: 'e-list-parent',
    listItem: 'e-list-item',
    listIcon: 'e-list-icon',
    textContent: 'e-text-content',
    listItemText: 'e-list-text',
    groupListItem: 'e-list-group-item',
    hasChild: 'e-has-child',
    view: 'e-view',
    header: 'e-list-header',
    headerText: 'e-headertext',
    headerTemplateText: 'e-headertemplate-text',
    text: 'e-text',
    disable: 'e-disabled',
    content: 'e-content',
    icon: 'e-icons',
    backIcon: 'e-icon-back',
    backButton: 'e-back-button',
    checkboxWrapper: 'e-checkbox-wrapper',
    checkbox: 'e-checkbox',
    checked: 'e-check',
    checklist: 'e-checklist',
    checkboxIcon: 'e-frame',
    checkboxRight: 'e-checkbox-right',
    checkboxLeft: 'e-checkbox-left',
    listviewCheckbox: 'e-listview-checkbox',
    itemCheckList: 'e-checklist',
    virtualElementContainer: 'e-list-virtualcontainer'
};
var LISTVIEW_TEMPLATE_PROPERTY = 'Template';
var LISTVIEW_GROUPTEMPLATE_PROPERTY = 'GroupTemplate';
var LISTVIEW_HEADERTEMPLATE_PROPERTY = 'HeaderTemplate';
var swipeVelocity = 0.5;
/**
 * Represents the field settings of the ListView.
 */
var FieldSettings = /** @class */ (function (_super) {
    __extends(FieldSettings, _super);
    function FieldSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('id')
    ], FieldSettings.prototype, "id", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('text')
    ], FieldSettings.prototype, "text", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('isChecked')
    ], FieldSettings.prototype, "isChecked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('isVisible')
    ], FieldSettings.prototype, "isVisible", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('enabled')
    ], FieldSettings.prototype, "enabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('iconCss')
    ], FieldSettings.prototype, "iconCss", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('child')
    ], FieldSettings.prototype, "child", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('tooltip')
    ], FieldSettings.prototype, "tooltip", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('groupBy')
    ], FieldSettings.prototype, "groupBy", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('text')
    ], FieldSettings.prototype, "sortBy", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('htmlAttributes')
    ], FieldSettings.prototype, "htmlAttributes", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('tableName')
    ], FieldSettings.prototype, "tableName", void 0);
    return FieldSettings;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * Represents the EJ2 ListView control.
 * ```html
 * <div id="listview">
 * <ul>
 * <li>Favorite</li>
 * <li>Documents</li>
 * <li>Downloads</li>
 * </ul>
 * </div>
 * ```
 * ```typescript
 *   var listviewObject = new ListView({});
 *   listviewObject.appendTo("#listview");
 * ```
 */
var ListView = /** @class */ (function (_super) {
    __extends(ListView, _super);
    /**
     * Constructor for creating the widget
     *
     * @param options
     *
     * @param element
     */
    function ListView(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.previousSelectedItems = [];
        _this.hiddenItems = [];
        _this.enabledItems = [];
        _this.disabledItems = [];
        return _this;
    }
    /**
     * @param newProp
     *
     * @param oldProp
     *
     * @private
     */
    ListView.prototype.onPropertyChanged = function (newProp, oldProp) {
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'htmlAttributes':
                    this.setHTMLAttribute();
                    break;
                case 'cssClass':
                    this.setCSSClass(oldProp.cssClass);
                    break;
                case 'enable':
                    this.setEnable();
                    break;
                case 'width':
                case 'height':
                    this.setSize();
                    break;
                case 'enableRtl':
                    this.setEnableRTL();
                    break;
                case 'fields':
                    // eslint-disable-next-line
                    this.listBaseOption.fields = this.fields.properties;
                    if (this.enableVirtualization) {
                        this.virtualizationModule.reRenderUiVirtualization();
                    }
                    else {
                        this.reRender();
                    }
                    break;
                case 'headerTitle':
                    if (!this.curDSLevel.length) {
                        this.header(this.headerTitle, false, 'header');
                    }
                    break;
                case 'query':
                    if (this.enableVirtualization) {
                        this.virtualizationModule.reRenderUiVirtualization();
                    }
                    else {
                        this.reRender();
                    }
                    break;
                case 'showHeader':
                    this.header(this.headerTitle, false, 'header');
                    break;
                case 'enableVirtualization':
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.contentContainer)) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.contentContainer);
                    }
                    this.refresh();
                    break;
                case 'showCheckBox':
                case 'checkBoxPosition':
                    if (this.enableVirtualization) {
                        this.virtualizationModule.reRenderUiVirtualization();
                    }
                    else {
                        this.setCheckbox();
                    }
                    break;
                case 'dataSource':
                    if (this.enableVirtualization) {
                        this.virtualizationModule.reRenderUiVirtualization();
                    }
                    else {
                        this.reRender();
                    }
                    break;
                case 'sortOrder':
                case 'template':
                    if (!this.enableVirtualization) {
                        this.refresh();
                    }
                    break;
                case 'showIcon':
                    if (this.enableVirtualization) {
                        this.virtualizationModule.reRenderUiVirtualization();
                    }
                    else {
                        this.listBaseOption.showIcon = this.showIcon;
                        this.curViewDS = this.getSubDS();
                        this.resetCurrentList();
                    }
                    break;
                default:
                    break;
            }
        }
    };
    // Model Changes
    ListView.prototype.setHTMLAttribute = function () {
        if (Object.keys(this.htmlAttributes).length) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, this.htmlAttributes);
        }
    };
    ListView.prototype.setCSSClass = function (oldCSSClass) {
        if (this.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], this.cssClass.split(' ').filter(function (css) { return css; }));
        }
        if (oldCSSClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], oldCSSClass.split(' ').filter(function (css) { return css; }));
        }
    };
    ListView.prototype.setSize = function () {
        this.element.style.height = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.height);
        this.element.style.width = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.width);
        this.isWindow = this.element.clientHeight ? false : true;
    };
    ListView.prototype.setEnable = function () {
        this.enableElement(this.element, this.enable);
    };
    ListView.prototype.setEnableRTL = function () {
        if (this.enableRtl) {
            this.element.classList.add('e-rtl');
        }
        else {
            this.element.classList.remove('e-rtl');
        }
    };
    ListView.prototype.enableElement = function (element, isEnabled) {
        if (isEnabled) {
            element.classList.remove(classNames.disable);
        }
        else {
            element.classList.add(classNames.disable);
        }
    };
    // Support Component Functions
    ListView.prototype.header = function (text, showBack, prop) {
        if (this.headerEle === undefined && this.showHeader) {
            if (this.enableHtmlSanitizer) {
                this.setProperties({ headerTitle: __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(this.headerTitle) }, true);
            }
            this.headerEle = this.createElement('div', { className: classNames.header });
            var innerHeaderEle = this.createElement('span', { className: classNames.headerText, innerHTML: this.headerTitle });
            var textEle = this.createElement('div', { className: classNames.text, innerHTML: innerHeaderEle.outerHTML });
            var hedBackButton = this.createElement('div', {
                className: classNames.icon + ' ' + classNames.backIcon + ' ' + classNames.backButton,
                attrs: { style: 'display:none;' }
            });
            this.headerEle.appendChild(hedBackButton);
            this.headerEle.appendChild(textEle);
            if (this.headerTemplate) {
                // eslint-disable-next-line
                var compiledString = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(this.headerTemplate);
                var headerTemplateEle = this.createElement('div', { className: classNames.headerTemplateText });
                // eslint-disable-next-line
                var compiledElement = compiledString({}, this, prop, this.LISTVIEW_HEADERTEMPLATE_ID, null, null, this.headerEle);
                if (compiledElement) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(compiledElement, headerTemplateEle);
                }
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])([headerTemplateEle], this.headerEle);
                // eslint-disable-next-line
                if (this.isReact) {
                    this.renderReactTemplates();
                }
            }
            if (this.headerTemplate && this.headerTitle) {
                textEle.classList.add('header');
            }
            this.element.classList.add('e-has-header');
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["X" /* prepend */])([this.headerEle], this.element);
        }
        else if (this.headerEle) {
            if (this.showHeader) {
                this.headerEle.style.display = '';
                var textEle = this.headerEle.querySelector('.' + classNames.headerText);
                var hedBackButton = this.headerEle.querySelector('.' + classNames.backIcon);
                if (this.enableHtmlSanitizer) {
                    text = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(text);
                }
                textEle.innerHTML = text;
                if (this.headerTemplate && showBack) {
                    textEle.parentElement.classList.remove('header');
                    this.headerEle.querySelector('.' + classNames.headerTemplateText).classList.add('nested-header');
                }
                if (this.headerTemplate && !showBack) {
                    textEle.parentElement.classList.add('header');
                    this.headerEle.querySelector('.' + classNames.headerTemplateText).classList.remove('nested-header');
                    this.headerEle.querySelector('.' + classNames.headerTemplateText).classList.add('header');
                }
                if (showBack === true) {
                    hedBackButton.style.display = '';
                }
                else {
                    hedBackButton.style.display = 'none';
                }
            }
            else {
                this.headerEle.style.display = 'none';
            }
        }
    };
    // Animation Related Functions
    ListView.prototype.switchView = function (fromView, toView, reverse) {
        var _this = this;
        if (fromView && toView) {
            var fPos_1 = fromView.style.position;
            var overflow_1 = (this.element.style.overflow !== 'hidden') ? this.element.style.overflow : '';
            fromView.style.position = 'absolute';
            fromView.classList.add('e-view');
            var anim = void 0;
            var duration = this.animation.duration;
            if (this.animation.effect) {
                anim = (this.enableRtl ? effectsRTLConfig[this.animation.effect] : effectsConfig[this.animation.effect]);
            }
            else {
                var slideLeft = 'SlideLeft';
                anim = effectsConfig[slideLeft];
                reverse = this.enableRtl;
                duration = 0;
            }
            this.element.style.overflow = 'hidden';
            this.aniObj.animate(fromView, {
                name: (reverse === true ? anim[0] : anim[1]),
                duration: duration,
                timingFunction: this.animation.easing,
                // eslint-disable-next-line
                end: function (model) {
                    fromView.style.display = 'none';
                    _this.element.style.overflow = overflow_1;
                    fromView.style.position = fPos_1;
                    fromView.classList.remove('e-view');
                }
            });
            toView.style.display = '';
            this.aniObj.animate(toView, {
                name: (reverse === true ? anim[2] : anim[3]),
                duration: duration,
                timingFunction: this.animation.easing,
                end: function () {
                    _this.trigger('actionComplete');
                }
            });
            this.curUL = toView;
        }
    };
    ListView.prototype.preRender = function () {
        if (this.template) {
            try {
                if (document.querySelectorAll(this.template).length) {
                    this.setProperties({ template: document.querySelector(this.template).innerHTML.trim() }, true);
                }
            }
            catch (e) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(this.template);
            }
        }
        this.listBaseOption = {
            template: this.template,
            headerTemplate: this.headerTemplate,
            groupTemplate: this.groupTemplate, expandCollapse: true, listClass: '',
            ariaAttributes: {
                itemRole: 'option', listRole: 'presentation', itemText: '',
                groupItemRole: 'option', wrapperRole: 'presentation'
            },
            // eslint-disable-next-line
            fields: (this.fields.properties),
            sortOrder: this.sortOrder,
            showIcon: this.showIcon,
            itemCreated: this.renderCheckbox.bind(this),
            templateID: "" + this.element.id + LISTVIEW_TEMPLATE_PROPERTY,
            groupTemplateID: "" + this.element.id + LISTVIEW_GROUPTEMPLATE_PROPERTY,
            enableHtmlSanitizer: this.enableHtmlSanitizer,
        };
        this.initialization();
    };
    ListView.prototype.initialization = function () {
        this.curDSLevel = [];
        this.animateOptions = {};
        this.curViewDS = [];
        this.currentLiElements = [];
        this.isNestedList = false;
        this.selectedData = [];
        this.selectedId = [];
        this.LISTVIEW_TEMPLATE_ID = "" + this.element.id + LISTVIEW_TEMPLATE_PROPERTY;
        this.LISTVIEW_GROUPTEMPLATE_ID = "" + this.element.id + LISTVIEW_GROUPTEMPLATE_PROPERTY;
        this.LISTVIEW_HEADERTEMPLATE_ID = "" + this.element.id + LISTVIEW_HEADERTEMPLATE_PROPERTY;
        this.aniObj = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["b" /* Animation */](this.animateOptions);
        this.removeElement(this.curUL);
        this.removeElement(this.ulElement);
        this.removeElement(this.headerEle);
        this.removeElement(this.contentContainer);
        this.curUL = this.ulElement = this.liCollection = this.headerEle = this.contentContainer = undefined;
    };
    ListView.prototype.renderCheckbox = function (args) {
        if (args.item.classList.contains(classNames.hasChild)) {
            this.isNestedList = true;
        }
        if (this.showCheckBox && this.isValidLI(args.item)) {
            var checkboxElement = void 0;
            var fieldData = void 0;
            // eslint-disable-next-line prefer-const
            checkboxElement = Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_buttons__["b" /* createCheckBox */])(this.createElement, false, {
                checked: false, enableRtl: this.enableRtl,
                cssClass: classNames.listviewCheckbox
            });
            checkboxElement.setAttribute('role', 'checkbox');
            var frameElement_1 = checkboxElement.querySelector('.' + classNames.checkboxIcon);
            args.item.classList.add(classNames.itemCheckList);
            args.item.firstElementChild.classList.add(classNames.checkbox);
            if (typeof this.dataSource[0] !== 'string' && typeof this.dataSource[0] !== 'number') {
                fieldData = Object(__WEBPACK_IMPORTED_MODULE_3__common_list_base__["b" /* getFieldValues */])(args.curData, this.listBaseOption.fields);
                if (fieldData[this.listBaseOption.fields.isChecked]) {
                    this.checkInternally(args, checkboxElement);
                }
            }
            else if (((typeof this.dataSource[0] === 'string' ||
                typeof this.dataSource[0] === 'number') && this.selectedData.indexOf(args.text) !== -1)) {
                this.checkInternally(args, checkboxElement);
            }
            checkboxElement.setAttribute('aria-checked', frameElement_1.classList.contains(classNames.checked) ? 'true' : 'false');
            if (this.checkBoxPosition === 'Left') {
                checkboxElement.classList.add(classNames.checkboxLeft);
                args.item.firstElementChild.classList.add(classNames.checkboxLeft);
                args.item.firstElementChild.insertBefore(checkboxElement, args.item.firstElementChild.childNodes[0]);
            }
            else {
                checkboxElement.classList.add(classNames.checkboxRight);
                args.item.firstElementChild.classList.add(classNames.checkboxRight);
                args.item.firstElementChild.appendChild(checkboxElement);
            }
            this.currentLiElements.push(args.item);
            if (this.checkBoxPosition === 'Left') {
                this.virtualCheckBox = args.item.firstElementChild.children[0];
            }
            else {
                this.virtualCheckBox = args.item.firstElementChild.lastElementChild;
            }
        }
    };
    ListView.prototype.checkInternally = function (args, checkboxElement) {
        args.item.classList.add(classNames.selected);
        args.item.setAttribute('aria-selected', 'true');
        checkboxElement.querySelector('.' + classNames.checkboxIcon).classList.add(classNames.checked);
        checkboxElement.setAttribute('aria-checked', 'true');
    };
    /**
     * Checks the specific list item by passing the unchecked fields as an argument to this method.
     *
     * @param  {Fields | HTMLElement | Element} item - It accepts Fields or HTML list element as an argument.
     */
    ListView.prototype.checkItem = function (item) {
        this.toggleCheckBase(item, true);
    };
    ListView.prototype.toggleCheckBase = function (item, checked) {
        if (this.showCheckBox) {
            var liElement = item;
            if (item instanceof Object && item.constructor !== HTMLLIElement) {
                liElement = this.getLiFromObjOrElement(item);
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement)) {
                var checkboxIcon = liElement.querySelector('.' + classNames.checkboxIcon);
                if (checked === true) {
                    liElement.classList.add(classNames.selected);
                }
                else {
                    liElement.classList.remove(classNames.selected);
                }
                liElement.setAttribute('aria-selected', checked ? 'true' : 'false');
                if (checked === true) {
                    checkboxIcon.classList.add(classNames.checked);
                }
                else {
                    checkboxIcon.classList.remove(classNames.checked);
                }
                checkboxIcon.parentElement.setAttribute('aria-checked', checked ? 'true' : 'false');
            }
            this.setSelectedItemData(liElement);
        }
    };
    /**
     * Uncheck the specific list item by passing the checked fields as an argument to this method.
     *
     * @param  {Fields | HTMLElement | Element} item - It accepts Fields or HTML list element as an argument.
     */
    ListView.prototype.uncheckItem = function (item) {
        this.toggleCheckBase(item, false);
    };
    /**
     * Checks all the unchecked items in the ListView.
     */
    ListView.prototype.checkAllItems = function () {
        this.toggleAllCheckBase(true);
    };
    /**
     * Uncheck all the checked items in ListView.
     */
    ListView.prototype.uncheckAllItems = function () {
        this.toggleAllCheckBase(false);
    };
    ListView.prototype.toggleAllCheckBase = function (checked) {
        if (this.showCheckBox) {
            for (var i = 0; i < this.liCollection.length; i++) {
                var checkIcon = this.liCollection[i].querySelector('.' + classNames.checkboxIcon);
                if (checkIcon) {
                    if (checked) {
                        if (!checkIcon.classList.contains(classNames.checked)) {
                            this.checkItem(this.liCollection[i]);
                        }
                    }
                    else {
                        if (checkIcon.classList.contains(classNames.checked)) {
                            this.uncheckItem(this.liCollection[i]);
                        }
                    }
                }
            }
            if (this.enableVirtualization) {
                this.virtualizationModule.checkedItem(checked);
            }
        }
    };
    ListView.prototype.setCheckbox = function () {
        if (this.showCheckBox) {
            var liCollection = Array.prototype.slice.call(this.element.querySelectorAll('.' + classNames.listItem));
            var args = {
                item: undefined, curData: undefined, dataSource: undefined, fields: undefined,
                options: undefined, text: ''
            };
            for (var i = 0; i < liCollection.length; i++) {
                var element = liCollection[i];
                args.item = element;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                args.curData = this.getItemData(element);
                if (element.querySelector('.' + classNames.checkboxWrapper)) {
                    this.removeElement(element.querySelector('.' + classNames.checkboxWrapper));
                }
                this.renderCheckbox(args);
                if (args.item.classList.contains(classNames.selected)) {
                    this.checkInternally(args, args.item.querySelector('.' + classNames.checkboxWrapper));
                }
            }
        }
        else {
            var liCollection = Array.prototype.slice.call(this.element.querySelectorAll('.' + classNames.itemCheckList));
            for (var i = 0; i < liCollection.length; i++) {
                var element = liCollection[i];
                element.classList.remove(classNames.selected);
                element.firstElementChild.classList.remove(classNames.checkbox);
                this.removeElement(element.querySelector('.' + classNames.checkboxWrapper));
            }
            if (this.selectedItems) {
                this.selectedItems.item.classList.add(classNames.selected);
            }
        }
    };
    /**
     * Refresh the height of the list item only on enabling the virtualization property.
     */
    ListView.prototype.refreshItemHeight = function () {
        if (this.virtualizationModule) {
            this.virtualizationModule.refreshItemHeight();
        }
    };
    ListView.prototype.clickHandler = function (e) {
        var target = e.target;
        var classList = target.classList;
        var closestElement;
        if (classList.contains(classNames.backIcon) || classList.contains(classNames.headerText)) {
            if (this.showCheckBox && this.curDSLevel[this.curDSLevel.length - 1]) {
                this.uncheckAllItems();
            }
            this.back();
        }
        else {
            var li = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(target.parentNode, '.' + classNames.listItem);
            if (li === null) {
                li = target;
            }
            this.removeFocus();
            if (this.enable && this.showCheckBox && this.isValidLI(li)) {
                if (e.target.classList.contains(classNames.checkboxIcon)) {
                    li.classList.add(classNames.focused);
                    if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li.querySelector('.' + classNames.checked))) {
                        var args = {
                            curData: undefined, dataSource: undefined, fields: undefined, options: undefined,
                            text: undefined, item: li
                        };
                        this.checkInternally(args, args.item.querySelector('.' + classNames.checkboxWrapper));
                    }
                    else {
                        this.uncheckItem(li);
                        li.classList.add(classNames.focused);
                    }
                    if (this.enableVirtualization) {
                        this.virtualizationModule.setCheckboxLI(li, e);
                    }
                    if (e) {
                        var eventArgs = this.selectEventData(li, e);
                        var checkIcon = li.querySelector('.' + classNames.checkboxIcon);
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["V" /* merge */])(eventArgs, { isChecked: checkIcon.classList.contains(classNames.checked) });
                        this.trigger('select', eventArgs);
                    }
                }
                else if (li.classList.contains(classNames.hasChild)) {
                    this.removeHover();
                    this.removeSelect();
                    this.removeSelect(li);
                    this.setSelectLI(li, e);
                    li.classList.remove(classNames.selected);
                }
                else {
                    this.setCheckboxLI(li, e);
                }
            }
            else {
                this.setSelectLI(li, e);
                this.element.focus();
            }
            closestElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, 'li');
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(closestElement)) {
                if (closestElement.classList.contains('e-has-child') &&
                    !e.target.parentElement.classList.contains('e-listview-checkbox')) {
                    closestElement.classList.add(classNames.disable);
                }
            }
        }
    };
    ListView.prototype.removeElement = function (element) {
        return element && element.parentNode && element.parentNode.removeChild(element);
    };
    ListView.prototype.hoverHandler = function (e) {
        var curLi = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target.parentNode, '.' + classNames.listItem);
        this.setHoverLI(curLi);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ListView.prototype.leaveHandler = function (e) {
        this.removeHover();
    };
    ListView.prototype.homeKeyHandler = function (e, end) {
        e.preventDefault();
        if (Object.keys(this.dataSource).length && this.curUL) {
            if (this.selectedItems) {
                (this.selectedItems.item).setAttribute('aria-selected', 'false');
            }
            var li = this.curUL.querySelectorAll('.' + classNames.listItem);
            var focusedElement = this.curUL.querySelector('.' + classNames.focused) ||
                this.curUL.querySelector('.' + classNames.selected);
            if (focusedElement) {
                focusedElement.classList.remove(classNames.focused);
                if (!this.showCheckBox) {
                    focusedElement.classList.remove(classNames.selected);
                }
            }
            var index = !end ? 0 : li.length - 1;
            if (li[index].classList.contains(classNames.hasChild) || this.showCheckBox) {
                li[index].classList.add(classNames.focused);
            }
            else {
                this.setSelectLI(li[index], e);
            }
            if (li[index]) {
                this.element.setAttribute('aria-activedescendant', li[index].id.toString());
            }
            else {
                this.element.removeAttribute('aria-activedescendant');
            }
        }
    };
    ListView.prototype.onArrowKeyDown = function (e, prev) {
        var siblingLI;
        var li;
        var hasChild = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.curUL.querySelector('.' + classNames.hasChild)) ? true : false;
        if (hasChild || this.showCheckBox) {
            li = this.curUL.querySelector('.' + classNames.focused) || this.curUL.querySelector('.' + classNames.selected);
            siblingLI = __WEBPACK_IMPORTED_MODULE_3__common_list_base__["a" /* ListBase */].getSiblingLI(this.curUL.querySelectorAll('.' + classNames.listItem), li, prev);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(siblingLI)) {
                if (li) {
                    li.classList.remove(classNames.focused);
                    if (!this.showCheckBox) {
                        li.classList.remove(classNames.selected);
                    }
                }
                if (siblingLI.classList.contains(classNames.hasChild) || this.showCheckBox) {
                    siblingLI.classList.add(classNames.focused);
                }
                else {
                    this.setSelectLI(siblingLI, e);
                }
            }
        }
        else {
            li = this.curUL.querySelector('.' + classNames.selected);
            siblingLI = __WEBPACK_IMPORTED_MODULE_3__common_list_base__["a" /* ListBase */].getSiblingLI(this.curUL.querySelectorAll('.' + classNames.listItem), li, prev);
            this.setSelectLI(siblingLI, e);
        }
        if (siblingLI) {
            this.element.setAttribute('aria-activedescendant', siblingLI.id.toString());
        }
        else {
            this.element.removeAttribute('aria-activedescendant');
        }
        return siblingLI;
    };
    ListView.prototype.arrowKeyHandler = function (e, prev) {
        var _this = this;
        e.preventDefault();
        if (Object.keys(this.dataSource).length && this.curUL) {
            var siblingLI = this.onArrowKeyDown(e, prev);
            var elementTop = this.element.getBoundingClientRect().top;
            var elementHeight = this.element.getBoundingClientRect().height;
            var firstItemBounds = this.curUL.querySelector('.' + classNames.listItem).getBoundingClientRect();
            var heightDiff = void 0;
            var groupItemBounds = void 0;
            if (this.fields.groupBy) {
                groupItemBounds = this.curUL.querySelector('.' + classNames.groupListItem).getBoundingClientRect();
            }
            if (siblingLI) {
                var siblingTop = siblingLI.getBoundingClientRect().top;
                var siblingHeight = siblingLI.getBoundingClientRect().height;
                if (!prev) {
                    var height = this.isWindow ? window.innerHeight : elementHeight;
                    heightDiff = this.isWindow ? (siblingTop + siblingHeight) :
                        ((siblingTop - elementTop) + siblingHeight);
                    if (heightDiff > height) {
                        if (this.isWindow === true) {
                            window.scroll(0, pageYOffset + (heightDiff - height));
                        }
                        else {
                            this.element.scrollTop = this.element.scrollTop + (heightDiff - height);
                        }
                    }
                }
                else {
                    heightDiff = this.isWindow ? siblingTop : (siblingTop - elementTop);
                    if (heightDiff < 0) {
                        if (this.isWindow === true) {
                            window.scroll(0, pageYOffset + heightDiff);
                        }
                        else {
                            this.element.scrollTop = this.element.scrollTop + heightDiff;
                        }
                    }
                }
            }
            else if (this.enableVirtualization && prev && this.virtualizationModule.uiFirstIndex) {
                this.onUIScrolled = function () {
                    _this.onArrowKeyDown(e, prev);
                    _this.onUIScrolled = undefined;
                };
                heightDiff = this.virtualizationModule.listItemHeight;
                if (this.isWindow === true) {
                    window.scroll(0, pageYOffset - heightDiff);
                }
                else {
                    this.element.scrollTop = this.element.scrollTop - heightDiff;
                }
            }
            else if (prev) {
                if (this.showHeader && this.headerEle) {
                    var topHeight = groupItemBounds ? groupItemBounds.top : firstItemBounds.top;
                    var headerBounds = this.headerEle.getBoundingClientRect();
                    heightDiff = headerBounds.top < 0 ? (headerBounds.height - topHeight) : 0;
                    if (this.isWindow === true) {
                        window.scroll(0, pageYOffset - heightDiff);
                    }
                    else {
                        this.element.scrollTop = 0;
                    }
                }
                else if (this.fields.groupBy) {
                    heightDiff = this.isWindow ? (groupItemBounds.top < 0 ? groupItemBounds.top : 0) :
                        (elementTop - firstItemBounds.top) + groupItemBounds.height;
                    if (this.isWindow === true) {
                        window.scroll(0, pageYOffset + heightDiff);
                    }
                    else {
                        this.element.scrollTop = this.element.scrollTop - heightDiff;
                    }
                }
            }
        }
    };
    ListView.prototype.enterKeyHandler = function (e) {
        if (Object.keys(this.dataSource).length && this.curUL) {
            var hasChild = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.curUL.querySelector('.' + classNames.hasChild)) ? true : false;
            var li = this.curUL.querySelector('.' + classNames.focused);
            if (hasChild && li) {
                li.classList.remove(classNames.focused);
                if (this.showCheckBox) {
                    this.removeSelect();
                    this.removeSelect(li);
                    this.removeHover();
                }
                this.setSelectLI(li, e);
            }
        }
    };
    ListView.prototype.spaceKeyHandler = function (e) {
        e.preventDefault();
        if (this.enable && this.showCheckBox && Object.keys(this.dataSource).length && this.curUL) {
            var li = this.curUL.querySelector('.' + classNames.focused);
            var checkboxElement = void 0;
            var checkIcon = void 0;
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li.querySelector('.' + classNames.checked))) {
                var args = {
                    curData: undefined, dataSource: undefined, fields: undefined, options: undefined,
                    text: undefined, item: li
                };
                checkboxElement = args.item.querySelector('.' + classNames.checkboxWrapper);
                this.checkInternally(args, checkboxElement);
                checkIcon = checkboxElement.querySelector('.' + classNames.checkboxIcon + '.' + classNames.icon);
            }
            else {
                this.uncheckItem(li);
            }
            var eventArgs = this.selectEventData(li, e);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["V" /* merge */])(eventArgs, { isChecked: checkIcon ? checkIcon.classList.contains(classNames.checked) : false });
            this.trigger('select', eventArgs);
        }
    };
    ListView.prototype.keyActionHandler = function (e) {
        switch (e.keyCode) {
            case 36:
                this.homeKeyHandler(e);
                break;
            case 35:
                this.homeKeyHandler(e, true);
                break;
            case 40:
                this.arrowKeyHandler(e);
                break;
            case 38:
                this.arrowKeyHandler(e, true);
                break;
            case 13:
                this.enterKeyHandler(e);
                break;
            case 8:
                if (this.showCheckBox && this.curDSLevel[this.curDSLevel.length - 1]) {
                    this.uncheckAllItems();
                }
                this.back();
                break;
            case 32:
                this.spaceKeyHandler(e);
                break;
        }
    };
    ListView.prototype.swipeActionHandler = function (e) {
        if (e.swipeDirection === 'Right' && e.velocity > swipeVelocity && e.originalEvent.type === 'touchend') {
            if (this.showCheckBox && this.curDSLevel[this.curDSLevel.length - 1]) {
                this.uncheckAllItems();
            }
            this.back();
        }
    };
    ListView.prototype.focusout = function () {
        if (Object.keys(this.dataSource).length && this.curUL) {
            var focusedElement = this.curUL.querySelector('.' + classNames.focused);
            var activeElement = this.curUL.querySelector('[aria-selected = true]');
            if (focusedElement) {
                focusedElement.classList.remove(classNames.focused);
                if (activeElement && !this.showCheckBox) {
                    activeElement.classList.add(classNames.selected);
                }
            }
        }
    };
    ListView.prototype.wireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'keydown', this.keyActionHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'click', this.clickHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'mouseover', this.hoverHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'mouseout', this.leaveHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'focusout', this.focusout, this);
        this.touchModule = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["t" /* Touch */](this.element, { swipe: this.swipeActionHandler.bind(this) });
    };
    ListView.prototype.unWireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'click', this.clickHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'mouseover', this.hoverHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'mouseout', this.leaveHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'mouseover', this.hoverHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'mouseout', this.leaveHandler);
        this.touchModule.destroy();
    };
    ListView.prototype.removeFocus = function () {
        var focusedLI = this.element.querySelectorAll('.' + classNames.focused);
        for (var _i = 0, focusedLI_1 = focusedLI; _i < focusedLI_1.length; _i++) {
            var ele = focusedLI_1[_i];
            ele.classList.remove(classNames.focused);
        }
    };
    ListView.prototype.removeHover = function () {
        var hoverLI = this.element.querySelector('.' + classNames.hover);
        if (hoverLI) {
            hoverLI.classList.remove(classNames.hover);
        }
    };
    ListView.prototype.removeSelect = function (li) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li)) {
            var selectedLI = this.element.querySelectorAll('.' + classNames.selected);
            for (var _i = 0, selectedLI_1 = selectedLI; _i < selectedLI_1.length; _i++) {
                var ele = selectedLI_1[_i];
                if (this.showCheckBox && ele.querySelector('.' + classNames.checked)) {
                    continue;
                }
                else {
                    ele.setAttribute('aria-selected', 'false');
                    ele.classList.remove(classNames.selected);
                }
            }
        }
        else {
            li.classList.remove(classNames.selected);
            li.setAttribute('aria-selected', 'false');
        }
    };
    ListView.prototype.isValidLI = function (li) {
        return (li && li.classList.contains(classNames.listItem)
            && !li.classList.contains(classNames.groupListItem)
            && !li.classList.contains(classNames.disable));
    };
    ListView.prototype.setCheckboxLI = function (li, e) {
        if (this.isValidLI(li) && this.enable && this.showCheckBox) {
            if (this.curUL.querySelector('.' + classNames.focused)) {
                this.curUL.querySelector('.' + classNames.focused).classList.remove(classNames.focused);
            }
            li.classList.add(classNames.focused);
            var checkboxElement = li.querySelector('.' + classNames.checkboxWrapper);
            var checkIcon = checkboxElement.querySelector('.' + classNames.checkboxIcon + '.' + classNames.icon);
            this.removeHover();
            if (!checkIcon.classList.contains(classNames.checked)) {
                checkIcon.classList.add(classNames.checked);
                li.classList.add(classNames.selected);
                li.setAttribute('aria-selected', 'true');
            }
            else {
                checkIcon.classList.remove(classNames.checked);
                li.classList.remove(classNames.selected);
                li.setAttribute('aria-selected', 'false');
            }
            checkboxElement.setAttribute('aria-checked', checkIcon.classList.contains(classNames.checked) ?
                'true' : 'false');
            var eventArgs = this.selectEventData(li, e);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["V" /* merge */])(eventArgs, { isChecked: checkIcon.classList.contains(classNames.checked) });
            if (this.enableVirtualization) {
                this.virtualizationModule.setCheckboxLI(li, e);
            }
            this.trigger('select', eventArgs);
            this.setSelectedItemData(li);
            this.renderSubList(li);
        }
    };
    ListView.prototype.selectEventData = function (li, e) {
        var data = this.getItemData(li);
        var fieldData = Object(__WEBPACK_IMPORTED_MODULE_3__common_list_base__["b" /* getFieldValues */])(data, this.listBaseOption.fields);
        var selectedItem;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data)
            && typeof this.dataSource[0] === 'string' || typeof this.dataSource[0] === 'number') {
            selectedItem = { item: li, text: li && li.innerText.trim(), data: this.dataSource };
        }
        else {
            selectedItem =
                // eslint-disable-next-line
                {
                    item: li, text: fieldData && fieldData[this.listBaseOption.fields.text],
                    // eslint-disable-next-line
                    data: data
                };
        }
        var eventArgs = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["V" /* merge */])(eventArgs, selectedItem);
        if (e) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["V" /* merge */])(eventArgs, { isInteracted: true, event: e, index: this.curUL && Array.prototype.indexOf.call(this.curUL.children, li) });
        }
        return eventArgs;
    };
    ListView.prototype.setSelectedItemData = function (li) {
        var data = this.getItemData(li);
        // eslint-disable-next-line
        var fieldData = Object(__WEBPACK_IMPORTED_MODULE_3__common_list_base__["b" /* getFieldValues */])(data, this.listBaseOption.fields);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data) && ((typeof this.dataSource[0] === 'string') ||
            (typeof this.dataSource[0] === 'number'))) {
            this.selectedItems = {
                item: li,
                text: li && li.innerText.trim(),
                data: this.dataSource
            };
        }
        else {
            this.selectedItems = {
                item: li,
                // eslint-disable-next-line
                text: fieldData && fieldData[this.listBaseOption.fields.text],
                // eslint-disable-next-line
                data: data
            };
        }
    };
    ListView.prototype.setSelectLI = function (li, e) {
        if (this.isValidLI(li) && !li.classList.contains(classNames.selected) && this.enable) {
            if (!this.showCheckBox) {
                this.removeSelect();
            }
            li.classList.add(classNames.selected);
            li.setAttribute('aria-selected', 'true');
            this.removeHover();
            this.setSelectedItemData(li);
            if (this.enableVirtualization) {
                this.virtualizationModule.setSelectLI(li, e);
            }
            var eventArgs = this.selectEventData(li, e);
            this.trigger('select', eventArgs);
            this.selectedLI = li;
            this.renderSubList(li);
        }
    };
    ListView.prototype.setHoverLI = function (li) {
        if (this.isValidLI(li) && !li.classList.contains(classNames.hover) && this.enable) {
            var lastLi = this.element.querySelectorAll('.' + classNames.hover);
            if (lastLi && lastLi.length) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])(lastLi, classNames.hover);
            }
            if (!li.classList.contains(classNames.selected) || this.showCheckBox) {
                li.classList.add(classNames.hover);
            }
        }
    };
    //Data Source Related Functions
    ListView.prototype.getSubDS = function () {
        var levelKeys = this.curDSLevel;
        if (levelKeys.length) {
            var ds = this.localData;
            for (var _i = 0, levelKeys_1 = levelKeys; _i < levelKeys_1.length; _i++) {
                var key = levelKeys_1[_i];
                var field = {};
                // eslint-disable-next-line
                field[this.fields.id] = key;
                this.curDSJSON = this.findItemFromDS(ds, field);
                var fieldData = Object(__WEBPACK_IMPORTED_MODULE_3__common_list_base__["b" /* getFieldValues */])(this.curDSJSON, this.listBaseOption.fields);
                ds = this.curDSJSON ? fieldData[this.fields.child] : ds;
            }
            return ds;
        }
        return this.localData;
    };
    ListView.prototype.getItemData = function (li) {
        var dataSource = this.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] ?
            this.localData : this.dataSource;
        var fields = this.getElementUID(li);
        var curDS;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.querySelector('.' + classNames.hasChild)) && this.fields.groupBy) {
            curDS = this.curViewDS;
        }
        else {
            curDS = dataSource;
        }
        return this.findItemFromDS(curDS, fields);
    };
    ListView.prototype.findItemFromDS = function (dataSource, fields, parent) {
        var _this = this;
        var resultJSON;
        if (dataSource && dataSource.length && fields) {
            dataSource.some(function (data) {
                var fieldData = 
                // eslint-disable-next-line
                Object(__WEBPACK_IMPORTED_MODULE_3__common_list_base__["b" /* getFieldValues */])(data, _this.listBaseOption.fields);
                //(!(fid) || id === fid) && (!(ftext) || text === ftext) && (!!fid || !!ftext)
                if ((fields[_this.fields.id] || fields[_this.fields.text]) &&
                    (!fields[_this.fields.id] || (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fieldData[_this.fields.id]) &&
                        fieldData[_this.fields.id].toString()) === fields[_this.fields.id].toString()) &&
                    (!fields[_this.fields.text] || fieldData[_this.fields.text] === fields[_this.fields.text])) {
                    resultJSON = (parent ? dataSource : data);
                }
                else if (typeof data !== 'object' && dataSource.indexOf(data) !== -1) {
                    resultJSON = (parent ? dataSource : data);
                }
                else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fields[_this.fields.id]) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fieldData[_this.fields.id])) {
                    var li = _this.element.querySelector('[data-uid="'
                        + fields[_this.fields.id] + '"]');
                    // eslint-disable-next-line
                    if (li && li.innerText.trim() === fieldData[_this.fields.text]) {
                        resultJSON = data;
                    }
                    // eslint-disable-next-line
                }
                else if (fieldData.hasOwnProperty(_this.fields.child) && fieldData[_this.fields.child].length) {
                    resultJSON = _this.findItemFromDS(fieldData[_this.fields.child], fields, parent);
                }
                return !!resultJSON;
            });
        }
        else {
            resultJSON = dataSource;
        }
        return resultJSON;
    };
    ListView.prototype.getQuery = function () {
        var columns = [];
        var query = (this.query ? this.query : new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["b" /* Query */]());
        if (!this.query) {
            // eslint-disable-next-line
            for (var _i = 0, _a = Object.keys(this.fields.properties); _i < _a.length; _i++) {
                var column = _a[_i];
                if (column !== 'tableName' && !!(this.fields[column]) &&
                    this.fields[column] !==
                        __WEBPACK_IMPORTED_MODULE_3__common_list_base__["a" /* ListBase */].defaultMappedFields[column]
                    && columns.indexOf(this.fields[column]) === -1) {
                    columns.push(this.fields[column]);
                }
            }
            query.select(columns);
            // eslint-disable-next-line
            if (this.fields.properties.hasOwnProperty('tableName')) {
                query.from(this.fields.tableName);
            }
        }
        return query;
    };
    ListView.prototype.setViewDataSource = function (dataSource) {
        if (dataSource === void 0) { dataSource = this.localData; }
        // eslint-disable-next-line
        var fieldValue = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.fields.sortBy)) ? this.fields.text : this.fields.sortBy;
        var query = __WEBPACK_IMPORTED_MODULE_3__common_list_base__["a" /* ListBase */].addSorting(this.sortOrder, fieldValue);
        if (dataSource && this.fields.groupBy) {
            if (this.sortOrder !== 'None') {
                this.curViewDS = __WEBPACK_IMPORTED_MODULE_3__common_list_base__["a" /* ListBase */].groupDataSource(__WEBPACK_IMPORTED_MODULE_3__common_list_base__["a" /* ListBase */].getDataSource(dataSource, query), this.listBaseOption.fields, this.sortOrder);
            }
            else {
                this.curViewDS = __WEBPACK_IMPORTED_MODULE_3__common_list_base__["a" /* ListBase */].groupDataSource(dataSource, this.listBaseOption.fields, this.sortOrder);
            }
        }
        else if (dataSource && this.sortOrder !== 'None') {
            this.curViewDS = __WEBPACK_IMPORTED_MODULE_3__common_list_base__["a" /* ListBase */].getDataSource(dataSource, query);
        }
        else {
            this.curViewDS = dataSource;
        }
    };
    ListView.prototype.isInAnimation = function () {
        return this.curUL.classList.contains('.e-animate');
    };
    ListView.prototype.renderRemoteLists = function (e, listViewComponent) {
        if (this.isDestroyed) {
            return;
        }
        this.localData = e.result;
        listViewComponent.removeElement(listViewComponent.contentContainer);
        this.renderList();
        this.trigger('actionComplete', e);
    };
    ListView.prototype.triggerActionFailure = function (e) {
        if (this.isDestroyed) {
            return;
        }
        this.trigger('actionFailure', e);
    };
    ListView.prototype.setLocalData = function () {
        var _this = this;
        this.trigger('actionBegin');
        // eslint-disable-next-line
        var listViewComponent = this;
        if (this.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */]) {
            if (this.dataSource.ready) {
                this.dataSource.ready.then(function (e) {
                    /* eslint-disable */
                    _this.isOffline = _this.dataSource.dataSource.offline;
                    if (_this.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] && _this.isOffline) {
                        _this.renderRemoteLists(e, listViewComponent);
                    }
                }).catch(function (e) {
                    _this.triggerActionFailure(e);
                });
            }
            else {
                this.dataSource.executeQuery(this.getQuery()).then(function (e) {
                    _this.renderRemoteLists(e, listViewComponent);
                }).catch(function (e) {
                    _this.triggerActionFailure(e);
                });
            }
        }
        else if (!this.dataSource || !this.dataSource.length) {
            var ul = this.element.querySelector('ul');
            if (ul) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(ul);
                this.setProperties({ dataSource: __WEBPACK_IMPORTED_MODULE_3__common_list_base__["a" /* ListBase */].createJsonFromElement(ul) }, true);
                this.localData = this.dataSource;
                this.renderList();
                this.trigger('actionComplete', { data: this.localData });
            }
        }
        else {
            this.localData = this.dataSource;
            this.renderList();
            this.trigger('actionComplete', { data: this.localData });
        }
    };
    ListView.prototype.reRender = function () {
        this.removeElement(this.headerEle);
        this.removeElement(this.ulElement);
        this.removeElement(this.contentContainer);
        // eslint-disable-next-line
        if (this.isReact) {
            this.clearTemplate();
        }
        if (Object.keys(window).indexOf('ejsInterop') === -1) {
            this.element.innerHTML = '';
        }
        this.headerEle = this.ulElement = this.liCollection = undefined;
        this.header();
        this.setLocalData();
    };
    ListView.prototype.resetCurrentList = function () {
        this.setViewDataSource(this.curViewDS);
        this.contentContainer.innerHTML = '';
        this.createList();
        this.renderIntoDom(this.curUL);
    };
    ListView.prototype.setAttributes = function (liElements) {
        for (var i = 0; i < liElements.length; i++) {
            var element = liElements[i];
            if (element.classList.contains('e-list-item')) {
                element.setAttribute('id', this.element.id + '_' + element.getAttribute('data-uid'));
                element.setAttribute('aria-selected', 'false');
                element.setAttribute('tabindex', '-1');
            }
        }
    };
    ListView.prototype.createList = function () {
        this.currentLiElements = [];
        this.isNestedList = false;
        this.ulElement = this.curUL = __WEBPACK_IMPORTED_MODULE_3__common_list_base__["a" /* ListBase */].createList(this.createElement, this.curViewDS, this.listBaseOption, null, this);
        this.liCollection = this.curUL.querySelectorAll('.' + classNames.listItem);
        this.setAttributes(this.liCollection);
    };
    ListView.prototype.exceptionEvent = function (e) {
        this.trigger('actionFailure', e);
    };
    ListView.prototype.UpdateCurrentUL = function () {
        this.ulElement = this.curUL = this.element.querySelector('.' + classNames.parentItem);
        if (this.curUL) {
            // eslint-disable-next-line
            this.liCollection = this.curUL.querySelectorAll('.' + classNames.listItem);
        }
    };
    ListView.prototype.renderSubList = function (li) {
        this.liElement = li;
        var uID = li.getAttribute('data-uid');
        if (li.classList.contains(classNames.hasChild) && uID) {
            var ul = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(li.parentNode, '.' + classNames.parentItem);
            var ele = this.element.querySelector('[pid=\'' + uID + '\']');
            this.curDSLevel.push(uID);
            this.setViewDataSource(this.getSubDS());
            if (!ele) {
                var data = this.curViewDS;
                ele = __WEBPACK_IMPORTED_MODULE_3__common_list_base__["a" /* ListBase */].createListFromJson(this.createElement, data, this.listBaseOption, this.curDSLevel.length, null, this);
                // eslint-disable-next-line
                if (this.isReact) {
                    this.renderReactTemplates();
                }
                var lists = ele.querySelectorAll('.' + classNames.listItem);
                this.setAttributes(lists);
                ele.setAttribute('pID', uID);
                ele.style.display = 'none';
                this.renderIntoDom(ele);
            }
            this.switchView(ul, ele);
            this.liCollection = this.curUL.querySelectorAll('.' + classNames.listItem);
            if (this.selectedItems) {
                var fieldData = Object(__WEBPACK_IMPORTED_MODULE_3__common_list_base__["b" /* getFieldValues */])(this.selectedItems.data, this.listBaseOption.fields);
                // eslint-disable-next-line
                this.header((fieldData[this.listBaseOption.fields.text]), true, 'header');
            }
            this.selectedLI = undefined;
        }
    };
    ListView.prototype.renderIntoDom = function (ele) {
        this.contentContainer.appendChild(ele);
    };
    ListView.prototype.renderList = function (data) {
        this.setViewDataSource(data);
        if (this.enableVirtualization) {
            if (Object.keys(this.dataSource).length) {
                if ((this.template || this.groupTemplate) && !this.virtualizationModule.isNgTemplate()) {
                    if (this.isReact) {
                        if (typeof this.template == "string") {
                            this.listBaseOption.template = null;
                        }
                        if (typeof this.groupTemplate == "string") {
                            this.listBaseOption.groupTemplate = null;
                        }
                    }
                    else {
                        this.listBaseOption.template = null;
                        this.listBaseOption.groupTemplate = null;
                    }
                    this.listBaseOption.itemCreated = this.virtualizationModule.createUIItem.bind(this.virtualizationModule);
                }
            }
            this.virtualizationModule.uiVirtualization();
        }
        else {
            this.createList();
            this.contentContainer = this.createElement('div', { className: classNames.content });
            this.element.appendChild(this.contentContainer);
            this.renderIntoDom(this.ulElement);
            // eslint-disable-next-line
            if (this.isReact) {
                this.renderReactTemplates();
            }
        }
    };
    ListView.prototype.getElementUID = function (obj) {
        var fields = {};
        if (obj instanceof Element) {
            // eslint-disable-next-line
            fields[this.fields.id] = obj.getAttribute('data-uid');
        }
        else {
            fields = obj;
        }
        return fields;
    };
    /**
     * Initializes the ListView component rendering.
     */
    ListView.prototype.render = function () {
        this.element.classList.add(classNames.root);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { role: 'list', tabindex: '0' });
        this.setCSSClass();
        this.setEnableRTL();
        this.setEnable();
        this.setSize();
        this.wireEvents();
        this.header();
        this.setLocalData();
        this.setHTMLAttribute();
        this.rippleFn = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_0" /* rippleEffect */])(this.element, {
            selector: '.' + classNames.listItem
        });
        this.renderComplete();
    };
    /**
     * It is used to destroy the ListView component.
     */
    ListView.prototype.destroy = function () {
        // eslint-disable-next-line
        if (this.isReact) {
            this.clearTemplate();
        }
        this.unWireEvents();
        var classAr = [classNames.root, classNames.disable, 'e-rtl',
            'e-has-header', 'e-lib'].concat(this.cssClass.split(' ').filter(function (css) { return css; }));
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], classAr);
        this.element.removeAttribute('role');
        this.element.removeAttribute('tabindex');
        this.curUL = this.ulElement = this.liCollection = this.headerEle = undefined;
        this.element.innerHTML = '';
        _super.prototype.destroy.call(this);
    };
    /**
     * Switches back from the navigated sub list item.
     */
    ListView.prototype.back = function () {
        var pID = this.curDSLevel[this.curDSLevel.length - 1];
        if (pID === undefined || this.isInAnimation()) {
            return;
        }
        this.curDSLevel.pop();
        this.setViewDataSource(this.getSubDS());
        var toUL = this.element.querySelector('[data-uid=\'' + pID + '\']');
        var fromUL = this.curUL;
        if (!toUL) {
            this.createList();
            this.renderIntoDom(this.ulElement);
            toUL = this.curUL;
        }
        else {
            toUL = toUL.parentElement;
        }
        var fieldData = Object(__WEBPACK_IMPORTED_MODULE_3__common_list_base__["b" /* getFieldValues */])(this.curDSJSON, this.listBaseOption.fields);
        // eslint-disable-next-line
        var text = fieldData[this.fields.text];
        this.switchView(fromUL, toUL, true);
        this.removeFocus();
        var li = this.element.querySelector('[data-uid=\'' + pID + '\']');
        li.classList.remove(classNames.disable);
        li.classList.add(classNames.focused);
        if (this.showCheckBox && li.querySelector('.' + classNames.checkboxIcon).classList.contains(classNames.checked)) {
            li.setAttribute('aria-selected', 'true');
        }
        else {
            li.classList.remove(classNames.selected);
            li.setAttribute('aria-selected', 'false');
        }
        this.liCollection = this.curUL.querySelectorAll('.' + classNames.listItem);
        if (this.enableHtmlSanitizer) {
            this.setProperties({ headerTitle: __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(this.headerTitle) }, true);
        }
        this.header((this.curDSLevel.length ? text : this.headerTitle), (this.curDSLevel.length ? true : false), 'header');
    };
    /**
     * Selects the list item from the ListView by passing the elements or field object.
     *
     * @param  {Fields | HTMLElement | Element} item - We can pass element Object or Fields as Object with ID and Text fields.
     */
    ListView.prototype.selectItem = function (item) {
        if (this.enableVirtualization) {
            this.virtualizationModule.selectItem(item);
        }
        else if (this.showCheckBox) {
            this.setCheckboxLI(this.getLiFromObjOrElement(item));
        }
        else {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item) === true) {
                this.removeSelect();
            }
            else {
                this.setSelectLI(this.getLiFromObjOrElement(item));
            }
        }
    };
    ListView.prototype.getLiFromObjOrElement = function (obj) {
        var li;
        var dataSource = this.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] ?
            this.localData : this.dataSource;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(obj)) {
            if (typeof dataSource[0] === 'string' || typeof dataSource[0] === 'number') {
                if (obj instanceof Element) {
                    var uid = obj.getAttribute('data-uid').toString();
                    for (var i = 0; i < this.liCollection.length; i++) {
                        if (this.liCollection[i].getAttribute('data-uid').toString() === uid) {
                            li = this.liCollection[i];
                            break;
                        }
                    }
                }
                else {
                    Array.prototype.some.call(this.curUL.querySelectorAll('.' + classNames.listItem), function (item) {
                        if (item.innerText.trim() === obj.toString()) {
                            li = item;
                            return true;
                        }
                        else {
                            return false;
                        }
                    });
                }
            }
            else {
                var resultJSON = this.getItemData(obj);
                var fieldData = Object(__WEBPACK_IMPORTED_MODULE_3__common_list_base__["b" /* getFieldValues */])(resultJSON, this.listBaseOption.fields);
                if (resultJSON) {
                    li = this.element.querySelector('[data-uid="'
                        + fieldData[this.fields.id] + '"]');
                    if (!this.enableVirtualization && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li)) {
                        var curLi = this.element.querySelectorAll('.' + classNames.listItem);
                        for (var i = 0; i < curLi.length; i++) {
                            // eslint-disable-next-line
                            if (curLi[i].innerText.trim() === fieldData[this.fields.text]) {
                                li = curLi[i];
                            }
                        }
                    }
                }
            }
        }
        return li;
    };
    /**
     * Selects multiple list items from the ListView.
     *
     * @param  {Fields[] | HTMLElement[] | Element[]} item - We can pass array of
     *  elements or array of fields Object with ID and Text fields.
     */
    ListView.prototype.selectMultipleItems = function (item) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item)) {
            for (var i = 0; i < item.length; i++) {
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item[i])) {
                    this.selectItem(item[i]);
                }
            }
        }
    };
    ListView.prototype.getParentId = function () {
        var parentId = [];
        if (this.isNestedList) {
            for (var i = this.curDSLevel.length - 1; i >= 0; i--) {
                parentId.push(this.curDSLevel[i]);
            }
        }
        return parentId;
    };
    /**
     * Gets the details of the currently selected item from the list items.
     *
     */
    ListView.prototype.getSelectedItems = function () {
        // eslint-disable-next-line
        var finalValue;
        var isCompleted = false;
        this.selectedId = [];
        var dataSource = this.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] ?
            this.localData : this.dataSource;
        if (this.enableVirtualization && !isCompleted) {
            finalValue = this.virtualizationModule.getSelectedItems();
            isCompleted = true;
        }
        else if (this.showCheckBox && !isCompleted) {
            // eslint-disable-next-line
            var liCollection = this.curUL.getElementsByClassName(classNames.selected);
            var liTextCollection = [];
            var liDataCollection = [];
            this.selectedId = [];
            var dataParent = [];
            for (var i = 0; i < liCollection.length; i++) {
                if (typeof dataSource[0] === 'string' || typeof dataSource[0] === 'number') {
                    liTextCollection.push(liCollection[i].innerText.trim());
                }
                else {
                    var tempData = this.getItemData(liCollection[i]);
                    var fieldData = Object(__WEBPACK_IMPORTED_MODULE_3__common_list_base__["b" /* getFieldValues */])(tempData, this.listBaseOption.fields);
                    if (this.isNestedList) {
                        dataParent.push({ data: tempData, parentId: this.getParentId() });
                    }
                    else {
                        liDataCollection.push(tempData);
                    }
                    if (fieldData) {
                        // eslint-disable-next-line
                        liTextCollection.push(fieldData[this.listBaseOption.fields.text]);
                        // eslint-disable-next-line
                        this.selectedId.push(fieldData[this.listBaseOption.fields.id]);
                    }
                    else {
                        liTextCollection.push(undefined);
                        this.selectedId.push(undefined);
                    }
                }
            }
            if ((typeof dataSource[0] === 'string'
                || typeof dataSource[0] === 'number')
                && !isCompleted) {
                finalValue = { item: liCollection, data: dataSource, text: liTextCollection };
                isCompleted = true;
            }
            if (this.isNestedList && !isCompleted) {
                finalValue = { item: liCollection, data: dataParent, text: liTextCollection };
                isCompleted = true;
            }
            else if (!isCompleted) {
                finalValue = { item: liCollection, data: liDataCollection, text: liTextCollection };
                isCompleted = true;
            }
        }
        else if (!isCompleted) {
            var liElement = this.element.getElementsByClassName(classNames.selected)[0];
            var fieldData = Object(__WEBPACK_IMPORTED_MODULE_3__common_list_base__["b" /* getFieldValues */])(this.getItemData(liElement), this.listBaseOption.fields);
            if ((typeof dataSource[0] === 'string'
                || typeof dataSource[0] === 'number')
                && !isCompleted) {
                finalValue = (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement)) ? {
                    item: liElement, data: dataSource,
                    text: liElement.innerText.trim()
                } : undefined;
                isCompleted = true;
            }
            else if (!isCompleted) {
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fieldData) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement)) {
                    finalValue = undefined;
                    isCompleted = true;
                }
                else {
                    // eslint-disable-next-line
                    this.selectedId.push(fieldData[this.listBaseOption.fields.id]);
                    finalValue = {
                        text: fieldData[this.listBaseOption.fields.text], item: liElement,
                        data: this.getItemData(liElement)
                    };
                    isCompleted = true;
                }
            }
        }
        return finalValue;
    };
    /**
     * Finds out an item details from the current list.
     *
     * @param  {Fields | HTMLElement | Element} item - We can pass element Object or Fields as Object with ID and Text fields.
     */
    ListView.prototype.findItem = function (item) {
        return this.getItemData(item);
    };
    /**
     * Enables the disabled list items by passing the Id and text fields.
     *
     * @param  {Fields | HTMLElement | Element} item - We can pass element Object or Fields as Object with ID and Text fields.
     */
    ListView.prototype.enableItem = function (item) {
        this.setItemState(item, true);
        if (this.enableVirtualization) {
            this.virtualizationModule.enableItem(item);
        }
    };
    /**
     * Disables the list items by passing the Id and text fields.
     *
     * @param  {Fields | HTMLElement | Element} item - We can pass element Object or Fields as Object with ID and Text fields.
     */
    ListView.prototype.disableItem = function (item) {
        this.setItemState(item, false);
        if (this.enableVirtualization) {
            this.virtualizationModule.disableItem(item);
        }
    };
    //A function that used to set state of the list item like enable, disable.
    ListView.prototype.setItemState = function (item, isEnable) {
        var resultJSON = this.getItemData(item);
        var fieldData = Object(__WEBPACK_IMPORTED_MODULE_3__common_list_base__["b" /* getFieldValues */])(resultJSON, this.listBaseOption.fields);
        if (resultJSON) {
            var li = this.element.querySelector('[data-uid="' + fieldData[this.fields.id] + '"]');
            if (isEnable) {
                if (li) {
                    li.classList.remove(classNames.disable);
                }
                delete resultJSON[this.fields.enabled];
            }
            else if (!isEnable) {
                if (li) {
                    li.classList.add(classNames.disable);
                }
                // eslint-disable-next-line
                resultJSON[this.fields.enabled] = false;
            }
        }
    };
    /**
     * Shows the hide list item from the ListView.
     *
     * @param  {Fields | HTMLElement | Element} item - We can pass element Object or Fields as Object with ID and Text fields.
     */
    ListView.prototype.showItem = function (item) {
        this.showHideItem(item, false, '');
        if (this.enableVirtualization) {
            this.virtualizationModule.showItem(item);
        }
    };
    /**
     * Hides an list item from the ListView.
     *
     * @param  {Fields | HTMLElement | Element} item - We can pass element Object or Fields as Object with ID and Text fields.
     */
    ListView.prototype.hideItem = function (item) {
        this.showHideItem(item, true, 'none');
        if (this.enableVirtualization) {
            this.virtualizationModule.hideItem(item);
        }
    };
    ListView.prototype.showHideItem = function (obj, isHide, display) {
        var resultJSON = this.getItemData(obj);
        var fieldData = Object(__WEBPACK_IMPORTED_MODULE_3__common_list_base__["b" /* getFieldValues */])(resultJSON, this.listBaseOption.fields);
        if (resultJSON) {
            var li = this.element.querySelector('[data-uid="' + fieldData[this.fields.id] + '"]');
            if (li) {
                li.style.display = display;
            }
            if (isHide) {
                // eslint-disable-next-line
                resultJSON[this.fields.isVisible] = false;
            }
            else {
                delete resultJSON[this.fields.isVisible];
            }
        }
    };
    /**
     * Adds the new list item(s) to the current ListView.
     * To add a new list item(s) in the ListView, we need to pass the `data` as an array of items that need
     * to be added and `fields` as the target item to which we need to add the given item(s) as its children.
     * For example fields: { text: 'Name', tooltip: 'Name', id:'id'}
     *
     * @param  {{Object}[]} data - JSON Array Data that need to add.
     *
     * @param  {Fields} fields - Target item to add the given data as its children (can be null).
     *
     */
    ListView.prototype.addItem = function (data, fields) {
        if (fields === void 0) { fields = undefined; }
        var dataSource = this.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */]
            ? this.localData : this.dataSource;
        this.addItemInternally(data, fields, dataSource);
    };
    ListView.prototype.addItemInternally = function (data, fields, dataSource) {
        if (data instanceof Array) {
            if (this.enableVirtualization) {
                this.virtualizationModule.addItem(data, fields, dataSource);
            }
            else {
                var ds = this.findItemFromDS(dataSource, fields);
                var child = void 0;
                if (ds) {
                    var fieldData = Object(__WEBPACK_IMPORTED_MODULE_3__common_list_base__["b" /* getFieldValues */])(ds, this.listBaseOption.fields);
                    child = fieldData[this.fields.child];
                    if (!child) {
                        child = [];
                    }
                    child = child.concat(data);
                }
                // check for whether target is nested level or top level in list
                if (ds instanceof Array) {
                    for (var i = 0; i < data.length; i++) {
                        dataSource.push(data[i]);
                        this.setViewDataSource(dataSource);
                        // since it is top level target, get the content container's first child
                        // as it is always the top level UL
                        var targetUL = this.contentContainer
                            ? this.contentContainer.children[0]
                            : null;
                        // check for whether the list was previously empty or not, if it is
                        // proceed to call initial render
                        if (this.contentContainer && targetUL) {
                            this.addItemIntoDom(data[i], targetUL, this.curViewDS);
                        }
                        else {
                            this.reRender();
                        }
                    }
                    this.liCollection = this.curUL.querySelectorAll('.' + classNames.listItem);
                }
                else {
                    // proceed as target item is in nested level, only if it is a valid target ds
                    if (ds) {
                        ds[this.fields.child] = child;
                        this.addItemInNestedList(ds, data);
                    }
                }
            }
        }
    };
    ListView.prototype.addItemInNestedList = function (targetItemData, itemQueue) {
        // eslint-disable-next-line
        var targetItemId = targetItemData[this.fields.id];
        var targetChildDS = targetItemData[this.fields.child];
        var isAlreadyRenderedUL = this.element.querySelector('[pid=\'' + targetItemId + '\']');
        var targetLi = this.element.querySelector('[data-uid=\'' + targetItemId + '\']');
        var targetUL = isAlreadyRenderedUL
            ? isAlreadyRenderedUL
            : targetLi
                ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(targetLi, 'ul')
                : null;
        var targetDS = isAlreadyRenderedUL ? targetChildDS : [targetItemData];
        var isTargetEmptyChild = targetLi ? !targetLi.classList.contains(classNames.hasChild) : false;
        var isRefreshTemplateNeeded = false;
        // if li element is already rendered, that element needs to be refreshed so that
        // it becomes child viewable due to new child items are added now
        if (isTargetEmptyChild) {
            var targetRefreshedElement = __WEBPACK_IMPORTED_MODULE_3__common_list_base__["a" /* ListBase */].createListItemFromJson(this.createElement, targetDS, this.listBaseOption, null, null, this);
            this.setAttributes(targetRefreshedElement);
            targetUL.insertBefore(targetRefreshedElement[0], targetLi);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(targetLi);
            isRefreshTemplateNeeded = true;
        }
        // if it is already rendered element, we need to create and append new elements
        if (isAlreadyRenderedUL && itemQueue) {
            for (var i = 0; i < itemQueue.length; i++) {
                targetDS.push(itemQueue[i]);
                this.addItemIntoDom(itemQueue[i], targetUL, targetDS);
            }
            isRefreshTemplateNeeded = true;
        }
    };
    ListView.prototype.addItemIntoDom = function (currentItem, targetUL, curViewDS) {
        var index = curViewDS.indexOf(currentItem);
        this.addListItem(currentItem, index, targetUL, curViewDS);
        var curItemDS = curViewDS[index - 1];
        if (curItemDS && curItemDS.isHeader && curItemDS.items.length === 1) {
            this.addListItem(curItemDS, (index - 1), targetUL, curViewDS);
        }
    };
    ListView.prototype.addListItem = function (dataSource, index, ulElement, curViewDS) {
        var target = this.getLiFromObjOrElement(curViewDS[index + 1]) ||
            this.getLiFromObjOrElement(curViewDS[index + 2]) || null;
        var li = __WEBPACK_IMPORTED_MODULE_3__common_list_base__["a" /* ListBase */].createListItemFromJson(this.createElement, [dataSource], this.listBaseOption, null, null, this);
        this.setAttributes(li);
        // eslint-disable-next-line
        if (this.template && this.isReact) {
            this.renderReactTemplates();
        }
        if (this.fields.groupBy && curViewDS[index + 1] && curViewDS[index + 1].isHeader) {
            var targetEle = this.getLiFromObjOrElement(curViewDS[index - 1]);
            if (targetEle) {
                target = targetEle.nextElementSibling;
            }
        }
        ulElement.insertBefore(li[0], target);
    };
    /**
     * Removes the list item from the data source based on a passed
     *  element like fields: { text: 'Name', tooltip: 'Name', id:'id'}
     *
     * @param  {Fields | HTMLElement | Element} item - We can pass element Object or Fields as Object with ID and Text fields.
     */
    ListView.prototype.removeItem = function (item) {
        var listDataSource = this.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */]
            ? this.localData : this.dataSource;
        if (this.enableVirtualization) {
            this.virtualizationModule.removeItem(item);
        }
        else {
            this.removeItemFromList(item, listDataSource);
        }
    };
    ListView.prototype.removeItemFromList = function (obj, listDataSource) {
        var _this = this;
        var curViewDS = this.curViewDS;
        var fields = obj instanceof Element ? this.getElementUID(obj) : obj;
        var dataSource;
        // eslint-disable-next-line prefer-const
        dataSource = this.findItemFromDS(listDataSource, fields, true);
        if (dataSource) {
            var data_1;
            // eslint-disable-next-line prefer-const
            data_1 = this.findItemFromDS(dataSource, fields);
            var index = curViewDS.indexOf(data_1);
            var li = this.getLiFromObjOrElement(obj);
            var groupLi = void 0;
            this.validateNestedView(li);
            if (this.fields.groupBy && this.curViewDS[index - 1] &&
                curViewDS[index - 1].isHeader &&
                curViewDS[index - 1].items.length === 1) {
                if (li && li.previousElementSibling.classList.contains(classNames.groupListItem) &&
                    (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li.nextElementSibling) || (li.nextElementSibling &&
                        li.nextElementSibling.classList.contains(classNames.groupListItem)))) {
                    groupLi = li.previousElementSibling;
                }
            }
            if (li) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(li);
            }
            if (groupLi) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(groupLi);
            }
            // eslint-disable-next-line
            var foundData = (dataSource.length - 1) <= 0
                ? this.findParent(this.localData, this.fields.id, 
                // eslint-disable-next-line
                function (value) { return value === data_1[_this.fields.id]; }, null) : null;
            var dsIndex = dataSource.indexOf(data_1);
            dataSource.splice(dsIndex, 1);
            this.setViewDataSource(listDataSource);
            if (foundData
                && foundData.parent
                && Array.isArray(foundData.parent[this.fields.child])
                && foundData.parent[this.fields.child].length <= 0) {
                var parentLi = this.getLiFromObjOrElement(foundData.parent);
                if (parentLi) {
                    var li_1 = __WEBPACK_IMPORTED_MODULE_3__common_list_base__["a" /* ListBase */].createListItemFromJson(this.createElement, [foundData.parent], this.listBaseOption, null, null, this);
                    this.setAttributes(li_1);
                    parentLi.parentElement.insertBefore(li_1[0], parentLi);
                    parentLi.parentElement.removeChild(parentLi);
                }
            }
            if (dataSource.length <= 0) {
                this.back();
            }
            this.liCollection = Array.prototype.slice.call(this.element.querySelectorAll('.' + classNames.listItem));
        }
    };
    // validate before removing an element whether the current view is inside target element's child view
    ListView.prototype.validateNestedView = function (li) {
        var liID = li ? li.getAttribute('data-uid').toString().toLowerCase() : null;
        if (liID && this.curDSLevel && this.curDSLevel.length > 0) {
            while (this.curDSLevel.some(function (id) { return id.toString().toLowerCase() === liID; })) {
                this.back();
            }
        }
    };
    /**
     * Removes multiple items from the ListView by passing the array of elements or array of field objects.
     *
     * @param  {Fields[] | HTMLElement[] | Element[]} item - We can pass array of elements or array of field Object with ID and Text fields.
     */
    ListView.prototype.removeMultipleItems = function (item) {
        if (item.length) {
            for (var i = 0; i < item.length; i++) {
                this.removeItem(item[i]);
            }
        }
    };
    // eslint-disable-next-line
    ListView.prototype.findParent = function (dataSource, id, callback, parent) {
        // eslint-disable-next-line no-prototype-builtins
        if (dataSource.hasOwnProperty(id) && callback(dataSource[id]) === true) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, dataSource);
        }
        for (var i = 0; i < Object.keys(dataSource).length; i++) {
            if (dataSource[Object.keys(dataSource)[i]]
                && typeof dataSource[Object.keys(dataSource)[i]] === 'object') {
                // eslint-disable-next-line
                var result = this.findParent(dataSource[Object.keys(dataSource)[i]], id, callback, dataSource);
                if (result != null) {
                    if (!result.parent) {
                        result.parent = parent;
                    }
                    return result;
                }
            }
        }
        return null;
    };
    // Module Required function
    ListView.prototype.getModuleName = function () {
        return 'listview';
    };
    ListView.prototype.requiredModules = function () {
        var modules = [];
        if (this.enableVirtualization) {
            modules.push({ args: [this], member: 'virtualization' });
        }
        return modules;
    };
    /**
     * Get the properties to be maintained in the persisted state.
     */
    ListView.prototype.getPersistData = function () {
        return this.addOnPersist(['cssClass', 'enableRtl', 'htmlAttributes',
            'enable', 'fields', 'animation', 'headerTitle',
            'sortOrder', 'showIcon', 'height', 'width', 'showCheckBox', 'checkBoxPosition']);
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], ListView.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], ListView.prototype, "enableVirtualization", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])({})
    ], ListView.prototype, "htmlAttributes", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], ListView.prototype, "enable", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])([])
    ], ListView.prototype, "dataSource", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], ListView.prototype, "query", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])(__WEBPACK_IMPORTED_MODULE_3__common_list_base__["a" /* ListBase */].defaultMappedFields, FieldSettings)
    ], ListView.prototype, "fields", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])({ effect: 'SlideLeft', duration: 400, easing: 'ease' })
    ], ListView.prototype, "animation", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('None')
    ], ListView.prototype, "sortOrder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], ListView.prototype, "showIcon", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], ListView.prototype, "showCheckBox", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Left')
    ], ListView.prototype, "checkBoxPosition", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], ListView.prototype, "headerTitle", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], ListView.prototype, "showHeader", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], ListView.prototype, "enableHtmlSanitizer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], ListView.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], ListView.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], ListView.prototype, "template", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], ListView.prototype, "headerTemplate", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], ListView.prototype, "groupTemplate", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ListView.prototype, "select", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ListView.prototype, "actionBegin", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ListView.prototype, "actionComplete", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ListView.prototype, "actionFailure", void 0);
    ListView = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], ListView);
    return ListView;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataManager; });
/* unused harmony export Deferred */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__query__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__adaptors__ = __webpack_require__(84);





/**
 * DataManager is used to manage and manipulate relational data.
 */
var DataManager = /** @class */ (function () {
    /**
     * Constructor for DataManager class
     * @param  {DataOptions|JSON[]} dataSource?
     * @param  {Query} query?
     * @param  {AdaptorOptions|string} adaptor?
     * @hidden
     */
    function DataManager(dataSource, query, adaptor) {
        var _this = this;
        /** @hidden */
        this.dateParse = true;
        /** @hidden */
        this.timeZoneHandling = true;
        this.requests = [];
        if (!dataSource && !this.dataSource) {
            dataSource = [];
        }
        adaptor = adaptor || dataSource.adaptor;
        if (dataSource && dataSource.timeZoneHandling === false) {
            this.timeZoneHandling = dataSource.timeZoneHandling;
        }
        var data;
        if (dataSource instanceof Array) {
            data = {
                json: dataSource,
                offline: true
            };
        }
        else if (typeof dataSource === 'object') {
            if (!dataSource.json) {
                dataSource.json = [];
            }
            data = {
                url: dataSource.url,
                insertUrl: dataSource.insertUrl,
                removeUrl: dataSource.removeUrl,
                updateUrl: dataSource.updateUrl,
                crudUrl: dataSource.crudUrl,
                batchUrl: dataSource.batchUrl,
                json: dataSource.json,
                headers: dataSource.headers,
                accept: dataSource.accept,
                data: dataSource.data,
                timeTillExpiration: dataSource.timeTillExpiration,
                cachingPageSize: dataSource.cachingPageSize,
                enableCaching: dataSource.enableCaching,
                requestType: dataSource.requestType,
                key: dataSource.key,
                crossDomain: dataSource.crossDomain,
                jsonp: dataSource.jsonp,
                dataType: dataSource.dataType,
                offline: dataSource.offline !== undefined ? dataSource.offline
                    : dataSource.adaptor instanceof __WEBPACK_IMPORTED_MODULE_3__adaptors__["e" /* RemoteSaveAdaptor */] || dataSource.adaptor instanceof __WEBPACK_IMPORTED_MODULE_3__adaptors__["b" /* CustomDataAdaptor */] ?
                        false : dataSource.url ? false : true,
                requiresFormat: dataSource.requiresFormat
            };
        }
        else {
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].throwError('DataManager: Invalid arguments');
        }
        if (data.requiresFormat === undefined && !__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].isCors()) {
            data.requiresFormat = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data.crossDomain) ? true : data.crossDomain;
        }
        if (data.dataType === undefined) {
            data.dataType = 'json';
        }
        this.dataSource = data;
        this.defaultQuery = query;
        if (data.url && data.offline && !data.json.length) {
            this.isDataAvailable = false;
            this.adaptor = adaptor || new __WEBPACK_IMPORTED_MODULE_3__adaptors__["d" /* ODataAdaptor */]();
            this.dataSource.offline = false;
            this.ready = this.executeQuery(query || new __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */]());
            this.ready.then(function (e) {
                _this.dataSource.offline = true;
                _this.isDataAvailable = true;
                data.json = e.result;
                _this.adaptor = new __WEBPACK_IMPORTED_MODULE_3__adaptors__["c" /* JsonAdaptor */]();
            });
        }
        else {
            this.adaptor = data.offline ? new __WEBPACK_IMPORTED_MODULE_3__adaptors__["c" /* JsonAdaptor */]() : new __WEBPACK_IMPORTED_MODULE_3__adaptors__["d" /* ODataAdaptor */]();
        }
        if (!data.jsonp && this.adaptor instanceof __WEBPACK_IMPORTED_MODULE_3__adaptors__["d" /* ODataAdaptor */]) {
            data.jsonp = 'callback';
        }
        this.adaptor = adaptor || this.adaptor;
        if (data.enableCaching) {
            this.adaptor = new __WEBPACK_IMPORTED_MODULE_3__adaptors__["a" /* CacheAdaptor */](this.adaptor, data.timeTillExpiration, data.cachingPageSize);
        }
        return this;
    }
    /**
     * Overrides DataManager's default query with given query.
     * @param  {Query} query - Defines the new default query.
     */
    DataManager.prototype.setDefaultQuery = function (query) {
        this.defaultQuery = query;
        return this;
    };
    /**
     * Executes the given query with local data source.
     * @param  {Query} query - Defines the query to retrieve data.
     */
    DataManager.prototype.executeLocal = function (query) {
        if (!this.defaultQuery && !(query instanceof __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */])) {
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].throwError('DataManager - executeLocal() : A query is required to execute');
        }
        if (!this.dataSource.json) {
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].throwError('DataManager - executeLocal() : Json data is required to execute');
        }
        query = query || this.defaultQuery;
        var result = this.adaptor.processQuery(this, query);
        if (query.subQuery) {
            var from = query.subQuery.fromTable;
            var lookup = query.subQuery.lookups;
            var res = query.isCountRequired ? result.result :
                result;
            if (lookup && lookup instanceof Array) {
                __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].buildHierarchy(query.subQuery.fKey, from, res, lookup, query.subQuery.key);
            }
            for (var j = 0; j < res.length; j++) {
                if (res[j][from] instanceof Array) {
                    res[j] = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, {}, res[j]);
                    res[j][from] = this.adaptor.processResponse(query.subQuery.using(new DataManager(res[j][from].slice(0))).executeLocal(), this, query);
                }
            }
        }
        return this.adaptor.processResponse(result, this, query);
    };
    /**
     * Executes the given query with either local or remote data source.
     * It will be executed as asynchronously and returns Promise object which will be resolved or rejected after action completed.
     * @param  {Query|Function} query - Defines the query to retrieve data.
     * @param  {Function} done - Defines the callback function and triggers when the Promise is resolved.
     * @param  {Function} fail - Defines the callback function and triggers when the Promise is rejected.
     * @param  {Function} always - Defines the callback function and triggers when the Promise is resolved or rejected.
     */
    DataManager.prototype.executeQuery = function (query, done, fail, always) {
        var _this = this;
        var makeRequest = 'makeRequest';
        if (typeof query === 'function') {
            always = fail;
            fail = done;
            done = query;
            query = null;
        }
        if (!query) {
            query = this.defaultQuery;
        }
        if (!(query instanceof __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */])) {
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].throwError('DataManager - executeQuery() : A query is required to execute');
        }
        var deffered = new Deferred();
        var args = { query: query };
        if (!this.dataSource.offline && (this.dataSource.url !== undefined && this.dataSource.url !== '')
            || (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.adaptor[makeRequest])) || this.isCustomDataAdaptor(this.adaptor)) {
            var result = this.adaptor.processQuery(this, query);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.adaptor[makeRequest])) {
                this.adaptor[makeRequest](result, deffered, args, query);
            }
            else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(result.url) || this.isCustomDataAdaptor(this.adaptor)) {
                this.makeRequest(result, deffered, args, query);
            }
            else {
                args = DataManager.getDeferedArgs(query, result, args);
                deffered.resolve(args);
            }
        }
        else {
            DataManager.nextTick(function () {
                var res = _this.executeLocal(query);
                args = DataManager.getDeferedArgs(query, res, args);
                deffered.resolve(args);
            });
        }
        if (done || fail) {
            deffered.promise.then(done, fail);
        }
        if (always) {
            deffered.promise.then(always, always);
        }
        return deffered.promise;
    };
    DataManager.getDeferedArgs = function (query, result, args) {
        if (query.isCountRequired) {
            args.result = result.result;
            args.count = result.count;
            args.aggregates = result.aggregates;
        }
        else {
            args.result = result;
        }
        return args;
    };
    DataManager.nextTick = function (fn) {
        (window.setImmediate || window.setTimeout)(fn, 0);
    };
    DataManager.prototype.extendRequest = function (url, fnSuccess, fnFail) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, {
            type: 'GET',
            dataType: this.dataSource.dataType,
            crossDomain: this.dataSource.crossDomain,
            jsonp: this.dataSource.jsonp,
            cache: true,
            processData: false,
            onSuccess: fnSuccess,
            onFailure: fnFail
        }, url);
    };
    // tslint:disable-next-line:max-func-body-length
    DataManager.prototype.makeRequest = function (url, deffered, args, query) {
        var _this = this;
        var isSelector = !!query.subQuerySelector;
        var fnFail = function (e) {
            args.error = e;
            deffered.reject(args);
        };
        var process = function (data, count, xhr, request, actual, aggregates, virtualSelectRecords) {
            args.xhr = xhr;
            args.count = count ? parseInt(count.toString(), 10) : 0;
            args.result = data;
            args.request = request;
            args.aggregates = aggregates;
            args.actual = actual;
            args.virtualSelectRecords = virtualSelectRecords;
            deffered.resolve(args);
        };
        var fnQueryChild = function (data, selector) {
            var subDeffer = new Deferred();
            var childArgs = { parent: args };
            query.subQuery.isChild = true;
            var subUrl = _this.adaptor.processQuery(_this, query.subQuery, data ? _this.adaptor.processResponse(data) : selector);
            var childReq = _this.makeRequest(subUrl, subDeffer, childArgs, query.subQuery);
            if (!isSelector) {
                subDeffer.then(function (subData) {
                    if (data) {
                        __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].buildHierarchy(query.subQuery.fKey, query.subQuery.fromTable, data, subData, query.subQuery.key);
                        process(data, subData.count, subData.xhr);
                    }
                }, fnFail);
            }
            return childReq;
        };
        var fnSuccess = function (data, request) {
            if (_this.isGraphQLAdaptor(_this.adaptor)) {
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data['errors'])) {
                    return fnFail(data['errors'], request);
                }
            }
            if (_this.isCustomDataAdaptor(_this.adaptor)) {
                request = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, _this.ajaxReqOption, request);
            }
            if (request.httpRequest.getResponseHeader('Content-Type').indexOf('xml') === -1 && _this.dateParse) {
                data = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.parseJson(data);
            }
            var result = _this.adaptor.processResponse(data, _this, query, request.httpRequest, request);
            var count = 0;
            var aggregates = null;
            var virtualSelectRecords = 'virtualSelectRecords';
            var virtualRecords = data[virtualSelectRecords];
            if (query.isCountRequired) {
                count = result.count;
                aggregates = result.aggregates;
                result = result.result;
            }
            if (!query.subQuery) {
                process(result, count, request.httpRequest, request.type, data, aggregates, virtualRecords);
                return;
            }
            if (!isSelector) {
                fnQueryChild(result, request);
            }
        };
        var req = this.extendRequest(url, fnSuccess, fnFail);
        if (!this.isCustomDataAdaptor(this.adaptor)) {
            var ajax_1 = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["a" /* Ajax */](req);
            ajax_1.beforeSend = function () {
                _this.beforeSend(ajax_1.httpRequest, ajax_1);
            };
            req = ajax_1.send();
            req.catch(function (e) { return true; }); // to handle failure remote requests.        
            this.requests.push(ajax_1);
        }
        else {
            this.ajaxReqOption = req;
            var request = req;
            this.adaptor.options.getData({
                data: request.data,
                onSuccess: request.onSuccess, onFailure: request.onFailure
            });
        }
        if (isSelector) {
            var promise = void 0;
            var res = query.subQuerySelector.call(this, { query: query.subQuery, parent: query });
            if (res && res.length) {
                promise = Promise.all([req, fnQueryChild(null, res)]);
                promise.then(function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var result = args[0];
                    var pResult = _this.adaptor.processResponse(result[0], _this, query, _this.requests[0].httpRequest, _this.requests[0]);
                    var count = 0;
                    if (query.isCountRequired) {
                        count = pResult.count;
                        pResult = pResult.result;
                    }
                    var cResult = _this.adaptor.processResponse(result[1], _this, query.subQuery, _this.requests[1].httpRequest, _this.requests[1]);
                    count = 0;
                    if (query.subQuery.isCountRequired) {
                        count = cResult.count;
                        cResult = cResult.result;
                    }
                    __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].buildHierarchy(query.subQuery.fKey, query.subQuery.fromTable, pResult, cResult, query.subQuery.key);
                    isSelector = false;
                    process(pResult, count, _this.requests[0].httpRequest);
                });
            }
            else {
                isSelector = false;
            }
        }
        return req;
    };
    DataManager.prototype.beforeSend = function (request, settings) {
        this.adaptor.beforeSend(this, request, settings);
        var headers = this.dataSource.headers;
        var props;
        for (var i = 0; headers && i < headers.length; i++) {
            props = [];
            var keys = Object.keys(headers[i]);
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var prop = keys_1[_i];
                props.push(prop);
                request.setRequestHeader(prop, headers[i][prop]);
            }
        }
    };
    /**
     * Save bulk changes to the given table name.
     * User can add a new record, edit an existing record, and delete a record at the same time.
     * If the datasource from remote, then updated in a single post.
     * @param  {Object} changes - Defines the CrudOptions.
     * @param  {string} key - Defines the column field.
     * @param  {string|Query} tableName - Defines the table name.
     * @param  {Query} query - Sets default query for the DataManager.
     */
    DataManager.prototype.saveChanges = function (changes, key, tableName, query, original) {
        var _this = this;
        if (tableName instanceof __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */]) {
            query = tableName;
            tableName = null;
        }
        var args = {
            url: tableName,
            key: key || this.dataSource.key
        };
        var req = this.adaptor.batchRequest(this, changes, args, query || new __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */](), original);
        var doAjaxRequest = 'doAjaxRequest';
        if (this.dataSource.offline) {
            return req;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.adaptor[doAjaxRequest])) {
            return this.adaptor[doAjaxRequest](req);
        }
        else if (!this.isCustomDataAdaptor(this.adaptor)) {
            var deff_1 = new Deferred();
            var ajax_2 = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["a" /* Ajax */](req);
            ajax_2.beforeSend = function () {
                _this.beforeSend(ajax_2.httpRequest, ajax_2);
            };
            ajax_2.onSuccess = function (data, request) {
                if (_this.isGraphQLAdaptor(_this.adaptor)) {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data['errors'])) {
                        ajax_2.onFailure(JSON.stringify(data['errors']));
                    }
                }
                deff_1.resolve(_this.adaptor.processResponse(data, _this, null, request.httpRequest, request, changes, args));
            };
            ajax_2.onFailure = function (e) {
                deff_1.reject([{ error: e }]);
            };
            ajax_2.send().catch(function (e) { return true; }); // to handle the failure requests.        
            return deff_1.promise;
        }
        else {
            return this.doAjaxRequest(req, this.adaptor.options.batchUpdate);
        }
    };
    /**
     * Inserts new record in the given table.
     * @param  {Object} data - Defines the data to insert.
     * @param  {string|Query} tableName - Defines the table name.
     * @param  {Query} query - Sets default query for the DataManager.
     */
    DataManager.prototype.insert = function (data, tableName, query, position) {
        if (tableName instanceof __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */]) {
            query = tableName;
            tableName = null;
        }
        var req = this.adaptor.insert(this, data, tableName, query, position);
        var doAjaxRequest = 'doAjaxRequest';
        if (this.dataSource.offline) {
            return req;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.adaptor[doAjaxRequest])) {
            return this.adaptor[doAjaxRequest](req);
        }
        else {
            return this.doAjaxRequest(req, this.adaptor.options.addRecord);
        }
    };
    /**
     * Removes data from the table with the given key.
     * @param  {string} keyField - Defines the column field.
     * @param  {Object} value - Defines the value to find the data in the specified column.
     * @param  {string|Query} tableName - Defines the table name
     * @param  {Query} query - Sets default query for the DataManager.
     */
    DataManager.prototype.remove = function (keyField, value, tableName, query) {
        if (typeof value === 'object') {
            value = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getObject(keyField, value);
        }
        if (tableName instanceof __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */]) {
            query = tableName;
            tableName = null;
        }
        var res = this.adaptor.remove(this, keyField, value, tableName, query);
        var doAjaxRequest = 'doAjaxRequest';
        if (this.dataSource.offline) {
            return res;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.adaptor[doAjaxRequest])) {
            return this.adaptor[doAjaxRequest](res);
        }
        else {
            var remove = this.adaptor.options.deleteRecord;
            return this.doAjaxRequest(res, remove);
        }
    };
    /**
     * Updates existing record in the given table.
     * @param  {string} keyField - Defines the column field.
     * @param  {Object} value - Defines the value to find the data in the specified column.
     * @param  {string|Query} tableName - Defines the table name
     * @param  {Query} query - Sets default query for the DataManager.
     */
    DataManager.prototype.update = function (keyField, value, tableName, query, original) {
        if (tableName instanceof __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */]) {
            query = tableName;
            tableName = null;
        }
        var res = this.adaptor.update(this, keyField, value, tableName, query, original);
        var doAjaxRequest = 'doAjaxRequest';
        if (this.dataSource.offline) {
            return res;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.adaptor[doAjaxRequest])) {
            return this.adaptor[doAjaxRequest](res);
        }
        else {
            var update = this.adaptor.options.updateRecord;
            return this.doAjaxRequest(res, update);
        }
    };
    DataManager.prototype.isCustomDataAdaptor = function (dataSource) {
        return this.adaptor.getModuleName &&
            this.adaptor.getModuleName() === 'CustomDataAdaptor';
    };
    DataManager.prototype.isGraphQLAdaptor = function (dataSource) {
        return this.adaptor.getModuleName &&
            this.adaptor.getModuleName() === 'GraphQLAdaptor';
    };
    DataManager.prototype.successFunc = function (record, request) {
        if (this.isGraphQLAdaptor(this.adaptor)) {
            var data = JSON.parse(record);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data['errors'])) {
                this.failureFunc(JSON.stringify(data['errors']));
            }
        }
        if (this.isCustomDataAdaptor(this.adaptor)) {
            request = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, this.ajaxReqOption, request);
        }
        try {
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.parseJson(record);
        }
        catch (e) {
            record = [];
        }
        record = this.adaptor.processResponse(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.parseJson(record), this, null, request.httpRequest, request);
        this.ajaxDeffered.resolve(record);
    };
    ;
    DataManager.prototype.failureFunc = function (e) {
        this.ajaxDeffered.reject([{ error: e }]);
    };
    ;
    DataManager.prototype.doAjaxRequest = function (res, ajaxFunc) {
        var _this = this;
        res = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, {
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            processData: false
        }, res);
        this.ajaxDeffered = new Deferred();
        if (!this.isCustomDataAdaptor(this.adaptor)) {
            var ajax_3 = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["a" /* Ajax */](res);
            ajax_3.beforeSend = function () {
                _this.beforeSend(ajax_3.httpRequest, ajax_3);
            };
            ajax_3.onSuccess = this.successFunc.bind(this);
            ajax_3.onFailure = this.failureFunc.bind(this);
            ajax_3.send().catch(function (e) { return true; }); // to handle the failure requests.
        }
        else {
            this.ajaxReqOption = res;
            ajaxFunc.call(this, {
                data: res.data, onSuccess: this.successFunc.bind(this),
                onFailure: this.failureFunc.bind(this)
            });
        }
        return this.ajaxDeffered.promise;
    };
    return DataManager;
}());

/**
 * Deferred is used to handle asynchronous operation.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        /**
         * Promise is an object that represents a value that may not be available yet, but will be resolved at some point in the future.
         */
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        /**
         * Defines the callback function triggers when the Deferred object is resolved.
         */
        this.then = this.promise.then.bind(this.promise);
        /**
         * Defines the callback function triggers when the Deferred object is rejected.
         */
        this.catch = this.promise.catch.bind(this.promise);
    }
    return Deferred;
}());



/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Adaptor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return JsonAdaptor; });
/* unused harmony export UrlAdaptor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ODataAdaptor; });
/* unused harmony export ODataV4Adaptor */
/* unused harmony export WebApiAdaptor */
/* unused harmony export WebMethodAdaptor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RemoteSaveAdaptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CustomDataAdaptor; });
/* unused harmony export GraphQLAdaptor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CacheAdaptor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__query__ = __webpack_require__(32);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var consts = { GroupGuid: '{271bbba0-1ee7}' };
/**
 * Adaptors are specific data source type aware interfaces that are used by DataManager to communicate with DataSource.
 * This is the base adaptor class that other adaptors can extend.
 * @hidden
 */
var Adaptor = /** @class */ (function () {
    /**
     * Constructor for Adaptor class
     * @param  {DataOptions} ds?
     * @hidden
     * @returns aggregates
     */
    function Adaptor(ds) {
        // common options for all the adaptors 
        this.options = {
            from: 'table',
            requestType: 'json',
            sortBy: 'sorted',
            select: 'select',
            skip: 'skip',
            group: 'group',
            take: 'take',
            search: 'search',
            count: 'requiresCounts',
            where: 'where',
            aggregates: 'aggregates',
            expand: 'expand'
        };
        /**
         * Specifies the type of adaptor.
         * @default Adaptor
         */
        this.type = Adaptor;
        this.dataSource = ds;
        this.pvt = {};
    }
    /**
     * Returns the data from the query processing.
     * @param  {Object} data
     * @param  {DataOptions} ds?
     * @param  {Query} query?
     * @param  {XMLHttpRequest} xhr?
     * @returns Object
     */
    Adaptor.prototype.processResponse = function (data, ds, query, xhr) {
        return data;
    };
    return Adaptor;
}());

/**
 * JsonAdaptor is used to process JSON data. It contains methods to process the given JSON data based on the queries.
 * @hidden
 */
var JsonAdaptor = /** @class */ (function (_super) {
    __extends(JsonAdaptor, _super);
    function JsonAdaptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Process the JSON data based on the provided queries.
     * @param  {DataManager} dataManager
     * @param  {Query} query
     * @returns Object
     */
    JsonAdaptor.prototype.processQuery = function (dataManager, query) {
        var result = dataManager.dataSource.json.slice(0);
        var count = result.length;
        var countFlg = true;
        var ret;
        var key;
        var lazyLoad = {};
        var keyCount = 0;
        var group = [];
        var page;
        for (var i = 0; i < query.lazyLoad.length; i++) {
            keyCount++;
            lazyLoad[query.lazyLoad[i].key] = query.lazyLoad[i].value;
        }
        var agg = {};
        for (var i = 0; i < query.queries.length; i++) {
            key = query.queries[i];
            if ((key.fn === 'onPage' || key.fn === 'onGroup') && query.lazyLoad.length) {
                if (key.fn === 'onGroup') {
                    group.push(key.e);
                }
                if (key.fn === 'onPage') {
                    page = key.e;
                }
                continue;
            }
            ret = this[key.fn].call(this, result, key.e, query);
            if (key.fn === 'onAggregates') {
                agg[key.e.field + ' - ' + key.e.type] = ret;
            }
            else {
                result = ret !== undefined ? ret : result;
            }
            if (key.fn === 'onPage' || key.fn === 'onSkip' || key.fn === 'onTake' || key.fn === 'onRange') {
                countFlg = false;
            }
            if (countFlg) {
                count = result.length;
            }
        }
        if (keyCount) {
            var args = {
                query: query, lazyLoad: lazyLoad, result: result, group: group, page: page
            };
            var lazyLoadData = this.lazyLoadGroup(args);
            result = lazyLoadData.result;
            count = lazyLoadData.count;
        }
        if (query.isCountRequired) {
            result = {
                result: result,
                count: count,
                aggregates: agg
            };
        }
        return result;
    };
    /**
     * Perform lazy load grouping in JSON array based on the given query and lazy load details.
     * @param  {LazyLoadGroupArgs} args
     */
    JsonAdaptor.prototype.lazyLoadGroup = function (args) {
        var count = 0;
        var agg = this.getAggregate(args.query);
        var result = args.result;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.lazyLoad.onDemandGroupInfo)) {
            var req = args.lazyLoad.onDemandGroupInfo;
            for (var i = req.where.length - 1; i >= 0; i--) {
                result = this.onWhere(result, req.where[i]);
            }
            if (args.group.length !== req.level) {
                var field = args.group[req.level].fieldName;
                result = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].group(result, field, agg, null, null, args.group[0].comparer, true);
            }
            count = result.length;
            var data = result;
            result = result.slice(req.skip);
            result = result.slice(0, req.take);
            if (args.group.length !== req.level) {
                this.formGroupResult(result, data);
            }
        }
        else {
            var field = args.group[0].fieldName;
            result = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].group(result, field, agg, null, null, args.group[0].comparer, true);
            count = result.length;
            var data = result;
            if (args.page) {
                result = this.onPage(result, args.page, args.query);
            }
            this.formGroupResult(result, data);
        }
        return { result: result, count: count };
    };
    JsonAdaptor.prototype.formGroupResult = function (result, data) {
        if (result.length && data.length) {
            var uid = 'GroupGuid';
            var childLevel = 'childLevels';
            var level = 'level';
            var records = 'records';
            result[uid] = data[uid];
            result[childLevel] = data[childLevel];
            result[level] = data[level];
            result[records] = data[records];
        }
        return result;
    };
    /**
     * Separate the aggregate query from the given queries
     * @param  {Query} query
     */
    JsonAdaptor.prototype.getAggregate = function (query) {
        var aggQuery = __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */].filterQueries(query.queries, 'onAggregates');
        var agg = [];
        if (aggQuery.length) {
            var tmp = void 0;
            for (var i = 0; i < aggQuery.length; i++) {
                tmp = aggQuery[i].e;
                agg.push({ type: tmp.type, field: __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(tmp.field, query) });
            }
        }
        return agg;
    };
    /**
     * Performs batch update in the JSON array which add, remove and update records.
     * @param  {DataManager} dm
     * @param  {CrudOptions} changes
     * @param  {RemoteArgs} e
     */
    JsonAdaptor.prototype.batchRequest = function (dm, changes, e) {
        var i;
        var deletedRecordsLen = changes.deletedRecords.length;
        for (i = 0; i < changes.addedRecords.length; i++) {
            this.insert(dm, changes.addedRecords[i]);
        }
        for (i = 0; i < changes.changedRecords.length; i++) {
            this.update(dm, e.key, changes.changedRecords[i]);
        }
        for (i = 0; i < deletedRecordsLen; i++) {
            this.remove(dm, e.key, changes.deletedRecords[i]);
        }
        return changes;
    };
    /**
     * Performs filter operation with the given data and where query.
     * @param  {Object[]} ds
     * @param  {{validate:Function}} e
     */
    JsonAdaptor.prototype.onWhere = function (ds, e) {
        if (!ds || !ds.length) {
            return ds;
        }
        return ds.filter(function (obj) {
            if (e) {
                return e.validate(obj);
            }
        });
    };
    /**
     * Returns aggregate function based on the aggregate type.
     * @param  {Object[]} ds
     * @param  {{field:string} e
     * @param  {string}} type
     */
    JsonAdaptor.prototype.onAggregates = function (ds, e) {
        var fn = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].aggregates[e.type];
        if (!ds || !fn || ds.length === 0) {
            return null;
        }
        return fn(ds, e.field);
    };
    /**
     * Performs search operation based on the given query.
     * @param  {Object[]} ds
     * @param  {QueryOptions} e
     */
    JsonAdaptor.prototype.onSearch = function (ds, e) {
        if (!ds || !ds.length) {
            return ds;
        }
        if (e.fieldNames.length === 0) {
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getFieldList(ds[0], e.fieldNames);
        }
        return ds.filter(function (obj) {
            for (var j = 0; j < e.fieldNames.length; j++) {
                if (e.comparer.call(obj, __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getObject(e.fieldNames[j], obj), e.searchKey, e.ignoreCase, e.ignoreAccent)) {
                    return true;
                }
            }
            return false;
        });
    };
    /**
     * Sort the data with given direction and field.
     * @param  {Object[]} ds
     * @param  {{comparer:(a:Object} e
     * @param  {Object} b
     */
    JsonAdaptor.prototype.onSortBy = function (ds, e, query) {
        if (!ds || !ds.length) {
            return ds;
        }
        var fnCompare;
        var field = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(e.fieldName, query);
        if (!field) {
            return ds.sort(e.comparer);
        }
        if (field instanceof Array) {
            field = field.slice(0);
            for (var i = field.length - 1; i >= 0; i--) {
                if (!field[i]) {
                    continue;
                }
                fnCompare = e.comparer;
                if (__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].endsWith(field[i], ' desc')) {
                    fnCompare = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].fnSort('descending');
                    field[i] = field[i].replace(' desc', '');
                }
                ds = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].sort(ds, field[i], fnCompare);
            }
            return ds;
        }
        return __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].sort(ds, field, e.comparer);
    };
    /**
     * Group the data based on the given query.
     * @param  {Object[]} ds
     * @param  {QueryOptions} e
     * @param  {Query} query
     */
    JsonAdaptor.prototype.onGroup = function (ds, e, query) {
        if (!ds || !ds.length) {
            return ds;
        }
        var agg = this.getAggregate(query);
        return __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].group(ds, __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(e.fieldName, query), agg, null, null, e.comparer);
    };
    /**
     * Retrieves records based on the given page index and size.
     * @param  {Object[]} ds
     * @param  {{pageSize:number} e
     * @param  {number}} pageIndex
     * @param  {Query} query
     */
    JsonAdaptor.prototype.onPage = function (ds, e, query) {
        var size = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(e.pageSize, query);
        var start = (__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(e.pageIndex, query) - 1) * size;
        var end = start + size;
        if (!ds || !ds.length) {
            return ds;
        }
        return ds.slice(start, end);
    };
    /**
     * Retrieves records based on the given start and end index from query.
     * @param  {Object[]} ds
     * @param  {{start:number} e
     * @param  {number}} end
     */
    JsonAdaptor.prototype.onRange = function (ds, e) {
        if (!ds || !ds.length) {
            return ds;
        }
        return ds.slice(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(e.start), __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(e.end));
    };
    /**
     * Picks the given count of records from the top of the datasource.
     * @param  {Object[]} ds
     * @param  {{nos:number}} e
     */
    JsonAdaptor.prototype.onTake = function (ds, e) {
        if (!ds || !ds.length) {
            return ds;
        }
        return ds.slice(0, __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(e.nos));
    };
    /**
     * Skips the given count of records from the data source.
     * @param  {Object[]} ds
     * @param  {{nos:number}} e
     */
    JsonAdaptor.prototype.onSkip = function (ds, e) {
        if (!ds || !ds.length) {
            return ds;
        }
        return ds.slice(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(e.nos));
    };
    /**
     * Selects specified columns from the data source.
     * @param  {Object[]} ds
     * @param  {{fieldNames:string}} e
     */
    JsonAdaptor.prototype.onSelect = function (ds, e) {
        if (!ds || !ds.length) {
            return ds;
        }
        return __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].select(ds, __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(e.fieldNames));
    };
    /**
     * Inserts new record in the table.
     * @param  {DataManager} dm
     * @param  {Object} data
     * @param  {number} position
     */
    JsonAdaptor.prototype.insert = function (dm, data, tableName, query, position) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(position)) {
            return dm.dataSource.json.push(data);
        }
        else {
            return dm.dataSource.json.splice(position, 0, data);
        }
    };
    /**
     * Remove the data from the dataSource based on the key field value.
     * @param  {DataManager} dm
     * @param  {string} keyField
     * @param  {Object} value
     * @param  {string} tableName?
     * @returns null
     */
    JsonAdaptor.prototype.remove = function (dm, keyField, value, tableName) {
        var ds = dm.dataSource.json;
        var i;
        if (typeof value === 'object' && !(value instanceof Date)) {
            value = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getObject(keyField, value);
        }
        for (i = 0; i < ds.length; i++) {
            if (__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getObject(keyField, ds[i]) === value) {
                break;
            }
        }
        return i !== ds.length ? ds.splice(i, 1) : null;
    };
    /**
     * Updates existing record and saves the changes to the table.
     * @param  {DataManager} dm
     * @param  {string} keyField
     * @param  {Object} value
     * @param  {string} tableName?
     * @returns null
     */
    JsonAdaptor.prototype.update = function (dm, keyField, value, tableName) {
        var ds = dm.dataSource.json;
        var i;
        var key;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(keyField)) {
            key = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(keyField, value);
        }
        for (i = 0; i < ds.length; i++) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(keyField) && (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(keyField, ds[i])) === key) {
                break;
            }
        }
        return i < ds.length ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["V" /* merge */])(ds[i], value) : null;
    };
    return JsonAdaptor;
}(Adaptor));

/**
 * URL Adaptor of DataManager can be used when you are required to use remote service to retrieve data.
 * It interacts with server-side for all DataManager Queries and CRUD operations.
 * @hidden
 */
var UrlAdaptor = /** @class */ (function (_super) {
    __extends(UrlAdaptor, _super);
    function UrlAdaptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Process the query to generate request body.
     * @param  {DataManager} dm
     * @param  {Query} query
     * @param  {Object[]} hierarchyFilters?
     * @returns p
     */
    // tslint:disable-next-line:max-func-body-length
    UrlAdaptor.prototype.processQuery = function (dm, query, hierarchyFilters) {
        var queries = this.getQueryRequest(query);
        var singles = __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */].filterQueryLists(query.queries, ['onSelect', 'onPage', 'onSkip', 'onTake', 'onRange']);
        var params = query.params;
        var url = dm.dataSource.url;
        var temp;
        var skip;
        var take = null;
        var options = this.options;
        var request = { sorts: [], groups: [], filters: [], searches: [], aggregates: [] };
        // calc Paging & Range
        if ('onPage' in singles) {
            temp = singles.onPage;
            skip = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(temp.pageIndex, query);
            take = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(temp.pageSize, query);
            skip = (skip - 1) * take;
        }
        else if ('onRange' in singles) {
            temp = singles.onRange;
            skip = temp.start;
            take = temp.end - temp.start;
        }
        // Sorting
        for (var i = 0; i < queries.sorts.length; i++) {
            temp = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(queries.sorts[i].e.fieldName, query);
            request.sorts.push(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'onEachSort', { name: temp, direction: queries.sorts[i].e.direction }, query));
        }
        // hierarchy
        if (hierarchyFilters) {
            temp = this.getFiltersFrom(hierarchyFilters, query);
            if (temp) {
                request.filters.push(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'onEachWhere', temp.toJson(), query));
            }
        }
        // Filters
        for (var i = 0; i < queries.filters.length; i++) {
            var res = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'onEachWhere', queries.filters[i].e.toJson(), query);
            if ((this.getModuleName &&
                this.getModuleName() === 'ODataV4Adaptor') &&
                !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(queries.filters[i].e.key) && queries.filters.length > 1) {
                res = "(" + res + ")";
            }
            request.filters.push(res);
            var keys_3 = typeof request.filters[i] === 'object' ? Object.keys(request.filters[i]) : [];
            for (var _i = 0, keys_1 = keys_3; _i < keys_1.length; _i++) {
                var prop = keys_1[_i];
                if (__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].isNull((request)[prop])) {
                    delete request[prop];
                }
            }
        }
        // Searches
        for (var i = 0; i < queries.searches.length; i++) {
            temp = queries.searches[i].e;
            request.searches.push(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'onEachSearch', {
                fields: temp.fieldNames,
                operator: temp.operator,
                key: temp.searchKey,
                ignoreCase: temp.ignoreCase
            }, query));
        }
        // Grouping
        for (var i = 0; i < queries.groups.length; i++) {
            request.groups.push(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(queries.groups[i].e.fieldName, query));
        }
        // aggregates
        for (var i = 0; i < queries.aggregates.length; i++) {
            temp = queries.aggregates[i].e;
            request.aggregates.push({ type: temp.type, field: __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(temp.field, query) });
        }
        var req = {};
        this.getRequestQuery(options, query, singles, request, req);
        // Params
        __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'addParams', { dm: dm, query: query, params: params, reqParams: req });
        if (query.lazyLoad.length) {
            for (var i = 0; i < query.lazyLoad.length; i++) {
                req[query.lazyLoad[i].key] = query.lazyLoad[i].value;
            }
        }
        // cleanup
        var keys = Object.keys(req);
        for (var _a = 0, keys_2 = keys; _a < keys_2.length; _a++) {
            var prop = keys_2[_a];
            if (__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].isNull(req[prop]) || req[prop] === '' || req[prop].length === 0) {
                delete req[prop];
            }
        }
        if (!(options.skip in req && options.take in req) && take !== null) {
            req[options.skip] = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'onSkip', skip, query);
            req[options.take] = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'onTake', take, query);
        }
        var p = this.pvt;
        this.pvt = {};
        if (this.options.requestType === 'json') {
            return {
                data: JSON.stringify(req, __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.jsonDateReplacer),
                url: url,
                pvtData: p,
                type: 'POST',
                contentType: 'application/json; charset=utf-8'
            };
        }
        temp = this.convertToQueryString(req, query, dm);
        temp = (dm.dataSource.url.indexOf('?') !== -1 ? '&' : '/') + temp;
        return {
            type: 'GET', url: temp.length ? url.replace(/\/*$/, temp) : url, pvtData: p
        };
    };
    UrlAdaptor.prototype.getRequestQuery = function (options, query, singles, request, request1) {
        var param = 'param';
        var req = request1;
        req[options.from] = query.fromTable;
        if (options.apply && query.distincts.length) {
            req[options.apply] = 'onDistinct' in this ? __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'onDistinct', query.distincts) : '';
        }
        if (!query.distincts.length && options.expand) {
            req[options.expand] = 'onExpand' in this && 'onSelect' in singles ?
                __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'onExpand', { selects: __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(singles.onSelect.fieldNames, query), expands: query.expands }, query) : query.expands;
        }
        req[options.select] = 'onSelect' in singles && !query.distincts.length ?
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'onSelect', __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(singles.onSelect.fieldNames, query), query) : '';
        req[options.count] = query.isCountRequired ? __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'onCount', query.isCountRequired, query) : '';
        req[options.search] = request.searches.length ? __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'onSearch', request.searches, query) : '';
        req[options.skip] = 'onSkip' in singles ?
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'onSkip', __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(singles.onSkip.nos, query), query) : '';
        req[options.take] = 'onTake' in singles ?
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'onTake', __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getValue(singles.onTake.nos, query), query) : '';
        req[options.where] = request.filters.length || request.searches.length ?
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'onWhere', request.filters, query) : '';
        req[options.sortBy] = request.sorts.length ? __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'onSortBy', request.sorts, query) : '';
        req[options.group] = request.groups.length ? __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'onGroup', request.groups, query) : '';
        req[options.aggregates] = request.aggregates.length ?
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].callAdaptorFunction(this, 'onAggregates', request.aggregates, query) : '';
        req[param] = [];
    };
    /**
     * Convert the object from processQuery to string which can be added query string.
     * @param  {Object} req
     * @param  {Query} query
     * @param  {DataManager} dm
     */
    UrlAdaptor.prototype.convertToQueryString = function (request, query, dm) {
        return '';
        // this needs to be overridden
    };
    /**
     * Return the data from the data manager processing.
     * @param  {DataResult} data
     * @param  {DataOptions} ds?
     * @param  {Query} query?
     * @param  {XMLHttpRequest} xhr?
     * @param  {Object} request?
     * @param  {CrudOptions} changes?
     */
    UrlAdaptor.prototype.processResponse = function (data, ds, query, xhr, request, changes) {
        if (xhr && xhr.getResponseHeader('Content-Type') &&
            xhr.getResponseHeader('Content-Type').indexOf('application/json') !== -1) {
            var handleTimeZone = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].timeZoneHandling;
            if (ds && !ds.timeZoneHandling) {
                __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].timeZoneHandling = false;
            }
            data = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.parseJson(data);
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].timeZoneHandling = handleTimeZone;
        }
        var requests = request;
        var pvt = requests.pvtData || {};
        var groupDs = data ? data.groupDs : [];
        if (xhr && xhr.getResponseHeader('Content-Type') &&
            xhr.getResponseHeader('Content-Type').indexOf('xml') !== -1) {
            return (query.isCountRequired ? { result: [], count: 0 } : []);
        }
        var d = JSON.parse(requests.data);
        if (d && d.action === 'batch' && data && data.addedRecords) {
            changes.addedRecords = data.addedRecords;
            return changes;
        }
        if (data && data.d) {
            data = data.d;
        }
        var args = {};
        if (data && 'count' in data) {
            args.count = data.count;
        }
        args.result = data && data.result ? data.result : data;
        var isExpand = false;
        if (Array.isArray(data.result) && data.result.length) {
            var key = 'key';
            var val = 'value';
            var level = 'level';
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data.result[0][key])) {
                args.result = this.formRemoteGroupedData(args.result, 1, pvt.groups.length - 1);
            }
            if (query && query.lazyLoad.length && pvt.groups.length) {
                for (var i = 0; i < query.lazyLoad.length; i++) {
                    if (query.lazyLoad[i][key] === 'onDemandGroupInfo') {
                        var value = query.lazyLoad[i][val][level];
                        if (pvt.groups.length === value) {
                            isExpand = true;
                        }
                    }
                }
            }
        }
        if (!isExpand) {
            this.getAggregateResult(pvt, data, args, groupDs, query);
        }
        return __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].isNull(args.count) ? args.result : { result: args.result, count: args.count, aggregates: args.aggregates };
    };
    UrlAdaptor.prototype.formRemoteGroupedData = function (data, level, childLevel) {
        for (var i = 0; i < data.length; i++) {
            if (data[i].items.length && Object.keys(data[i].items[0]).indexOf('key') > -1) {
                this.formRemoteGroupedData(data[i].items, level + 1, childLevel - 1);
            }
        }
        var uid = 'GroupGuid';
        var childLvl = 'childLevels';
        var lvl = 'level';
        var records = 'records';
        data[uid] = consts[uid];
        data[lvl] = level;
        data[childLvl] = childLevel;
        data[records] = data[0].items.length ? this.getGroupedRecords(data, !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data[0].items[records])) : [];
        return data;
    };
    UrlAdaptor.prototype.getGroupedRecords = function (data, hasRecords) {
        var childGroupedRecords = [];
        var records = 'records';
        for (var i = 0; i < data.length; i++) {
            if (!hasRecords) {
                for (var j = 0; j < data[i].items.length; j++) {
                    childGroupedRecords.push(data[i].items[j]);
                }
            }
            else {
                childGroupedRecords = childGroupedRecords.concat(data[i].items[records]);
            }
        }
        return childGroupedRecords;
    };
    /**
     * Add the group query to the adaptor`s option.
     * @param  {Object[]} e
     * @returns void
     */
    UrlAdaptor.prototype.onGroup = function (e) {
        this.pvt.groups = e;
        return e;
    };
    /**
     * Add the aggregate query to the adaptor`s option.
     * @param  {Aggregates[]} e
     * @returns void
     */
    UrlAdaptor.prototype.onAggregates = function (e) {
        this.pvt.aggregates = e;
    };
    /**
     * Prepare the request body based on the newly added, removed and updated records.
     * The result is used by the batch request.
     * @param  {DataManager} dm
     * @param  {CrudOptions} changes
     * @param  {Object} e
     */
    UrlAdaptor.prototype.batchRequest = function (dm, changes, e, query, original) {
        var url;
        var key;
        return {
            type: 'POST',
            url: dm.dataSource.batchUrl || dm.dataSource.crudUrl || dm.dataSource.removeUrl || dm.dataSource.url,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, {
                changed: changes.changedRecords,
                added: changes.addedRecords,
                deleted: changes.deletedRecords,
                action: 'batch',
                table: e[url],
                key: e[key]
            }, __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getAddParams(this, dm, query)))
        };
    };
    /**
     * Method will trigger before send the request to server side.
     * Used to set the custom header or modify the request options.
     * @param  {DataManager} dm
     * @param  {XMLHttpRequest} request
     * @returns void
     */
    UrlAdaptor.prototype.beforeSend = function (dm, request) {
        // need to extend this method
    };
    /**
     * Prepare and returns request body which is used to insert a new record in the table.
     * @param  {DataManager} dm
     * @param  {Object} data
     * @param  {string} tableName
     */
    UrlAdaptor.prototype.insert = function (dm, data, tableName, query) {
        return {
            url: dm.dataSource.insertUrl || dm.dataSource.crudUrl || dm.dataSource.url,
            data: JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, {
                value: data,
                table: tableName,
                action: 'insert'
            }, __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getAddParams(this, dm, query)))
        };
    };
    /**
     * Prepare and return request body which is used to remove record from the table.
     * @param  {DataManager} dm
     * @param  {string} keyField
     * @param  {number|string} value
     * @param  {string} tableName
     */
    UrlAdaptor.prototype.remove = function (dm, keyField, value, tableName, query) {
        return {
            type: 'POST',
            url: dm.dataSource.removeUrl || dm.dataSource.crudUrl || dm.dataSource.url,
            data: JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, {
                key: value,
                keyColumn: keyField,
                table: tableName,
                action: 'remove'
            }, __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getAddParams(this, dm, query)))
        };
    };
    /**
     * Prepare and return request body which is used to update record.
     * @param  {DataManager} dm
     * @param  {string} keyField
     * @param  {Object} value
     * @param  {string} tableName
     */
    UrlAdaptor.prototype.update = function (dm, keyField, value, tableName, query) {
        return {
            type: 'POST',
            url: dm.dataSource.updateUrl || dm.dataSource.crudUrl || dm.dataSource.url,
            data: JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, {
                value: value,
                action: 'update',
                keyColumn: keyField,
                key: __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getObject(keyField, value),
                table: tableName
            }, __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getAddParams(this, dm, query)))
        };
    };
    /**
     * To generate the predicate based on the filtered query.
     * @param  {Object[]|string[]|number[]} data
     * @param  {Query} query
     * @hidden
     */
    UrlAdaptor.prototype.getFiltersFrom = function (data, query) {
        var key = query.fKey;
        var value;
        var prop = key;
        var pKey = query.key;
        var predicats = [];
        if (typeof data[0] !== 'object') {
            prop = null;
        }
        for (var i = 0; i < data.length; i++) {
            if (typeof data[0] === 'object') {
                value = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getObject(pKey || prop, data[i]);
            }
            else {
                value = data[i];
            }
            predicats.push(new __WEBPACK_IMPORTED_MODULE_2__query__["a" /* Predicate */](key, 'equal', value));
        }
        return __WEBPACK_IMPORTED_MODULE_2__query__["a" /* Predicate */].or(predicats);
    };
    UrlAdaptor.prototype.getAggregateResult = function (pvt, data, args, groupDs, query) {
        var pData = data;
        if (data && data.result) {
            pData = data.result;
        }
        if (pvt && pvt.aggregates && pvt.aggregates.length) {
            var agg = pvt.aggregates;
            var fn = void 0;
            var aggregateData = pData;
            var res = {};
            if (data.aggregate) {
                aggregateData = data.aggregate;
            }
            for (var i = 0; i < agg.length; i++) {
                fn = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].aggregates[agg[i].type];
                if (fn) {
                    res[agg[i].field + ' - ' + agg[i].type] = fn(aggregateData, agg[i].field);
                }
            }
            args.aggregates = res;
        }
        var key = 'key';
        var isServerGrouping = Array.isArray(data.result) && data.result.length && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data.result[0][key]);
        if (pvt && pvt.groups && pvt.groups.length && !isServerGrouping) {
            var groups = pvt.groups;
            for (var i = 0; i < groups.length; i++) {
                var level = null;
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(groupDs)) {
                    groupDs = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].group(groupDs, groups[i]);
                }
                var groupQuery = __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */].filterQueries(query.queries, 'onGroup')[i].e;
                pData = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].group(pData, groups[i], pvt.aggregates, level, groupDs, groupQuery.comparer);
            }
            args.result = pData;
        }
        return args;
    };
    UrlAdaptor.prototype.getQueryRequest = function (query) {
        var req = { sorts: [], groups: [], filters: [], searches: [], aggregates: [] };
        req.sorts = __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */].filterQueries(query.queries, 'onSortBy');
        req.groups = __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */].filterQueries(query.queries, 'onGroup');
        req.filters = __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */].filterQueries(query.queries, 'onWhere');
        req.searches = __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */].filterQueries(query.queries, 'onSearch');
        req.aggregates = __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */].filterQueries(query.queries, 'onAggregates');
        return req;
    };
    UrlAdaptor.prototype.addParams = function (options) {
        var req = options.reqParams;
        if (options.params.length) {
            req.params = {};
        }
        for (var _i = 0, _a = options.params; _i < _a.length; _i++) {
            var tmp = _a[_i];
            if (req[tmp.key]) {
                throw new Error('Query() - addParams: Custom Param is conflicting other request arguments');
            }
            req[tmp.key] = tmp.value;
            if (tmp.fn) {
                req[tmp.key] = tmp.fn.call(options.query, tmp.key, options.query, options.dm);
            }
            req.params[tmp.key] = req[tmp.key];
        }
    };
    return UrlAdaptor;
}(Adaptor));

/**
 * OData Adaptor that is extended from URL Adaptor, is used for consuming data through OData Service.
 * @hidden
 */
var ODataAdaptor = /** @class */ (function (_super) {
    __extends(ODataAdaptor, _super);
    function ODataAdaptor(props) {
        var _this = _super.call(this) || this;
        // options replaced the default adaptor options
        _this.options = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, _this.options, {
            requestType: 'get',
            accept: 'application/json;odata=light;q=1,application/json;odata=verbose;q=0.5',
            multipartAccept: 'multipart/mixed',
            sortBy: '$orderby',
            select: '$select',
            skip: '$skip',
            take: '$top',
            count: '$inlinecount',
            where: '$filter',
            expand: '$expand',
            batch: '$batch',
            changeSet: '--changeset_',
            batchPre: 'batch_',
            contentId: 'Content-Id: ',
            batchContent: 'Content-Type: multipart/mixed; boundary=',
            changeSetContent: 'Content-Type: application/http\nContent-Transfer-Encoding: binary ',
            batchChangeSetContentType: 'Content-Type: application/json; charset=utf-8 ',
            updateType: 'PUT'
        });
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])(_this.options, props || {});
        return _this;
    }
    ODataAdaptor.prototype.getModuleName = function () {
        return 'ODataAdaptor';
    };
    /**
     * Generate request string based on the filter criteria from query.
     * @param  {Predicate} pred
     * @param  {boolean} requiresCast?
     */
    ODataAdaptor.prototype.onPredicate = function (predicate, query, requiresCast) {
        var returnValue = '';
        var operator;
        var guid;
        var val = predicate.value;
        var type = typeof val;
        var field = predicate.field ? ODataAdaptor.getField(predicate.field) : null;
        if (val instanceof Date) {
            val = 'datetime\'' + __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.replacer(val) + '\'';
        }
        if (type === 'string') {
            val = val.replace(/'/g, "''");
            if (predicate.ignoreCase) {
                val = val.toLowerCase();
            }
            val = encodeURIComponent(val);
            val = '\'' + val + '\'';
            if (requiresCast) {
                field = 'cast(' + field + ', \'Edm.String\')';
            }
            if (__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.isGuid(val)) {
                guid = 'guid';
            }
            if (predicate.ignoreCase) {
                if (!guid) {
                    field = 'tolower(' + field + ')';
                }
                val = val.toLowerCase();
            }
        }
        operator = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].odBiOperator[predicate.operator];
        if (operator) {
            returnValue += field;
            returnValue += operator;
            if (guid) {
                returnValue += guid;
            }
            return returnValue + val;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.getModuleName) && this.getModuleName() === 'ODataV4Adaptor') {
            operator = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].odv4UniOperator[predicate.operator];
        }
        else {
            operator = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].odUniOperator[predicate.operator];
        }
        if (operator === 'substringof') {
            var temp = val;
            val = field;
            field = temp;
        }
        returnValue += operator + '(';
        returnValue += field + ',';
        if (guid) {
            returnValue += guid;
        }
        returnValue += val + ')';
        return returnValue;
    };
    ODataAdaptor.prototype.addParams = function (options) {
        _super.prototype.addParams.call(this, options);
        delete options.reqParams.params;
    };
    /**
     * Generate request string based on the multiple filter criteria from query.
     * @param  {Predicate} pred
     * @param  {boolean} requiresCast?
     */
    ODataAdaptor.prototype.onComplexPredicate = function (predicate, query, requiresCast) {
        var res = [];
        for (var i = 0; i < predicate.predicates.length; i++) {
            res.push('(' + this.onEachWhere(predicate.predicates[i], query, requiresCast) + ')');
        }
        return res.join(' ' + predicate.condition + ' ');
    };
    /**
     * Generate query string based on the multiple filter criteria from query.
     * @param  {Predicate} filter
     * @param  {boolean} requiresCast?
     */
    ODataAdaptor.prototype.onEachWhere = function (filter, query, requiresCast) {
        return filter.isComplex ? this.onComplexPredicate(filter, query, requiresCast) : this.onPredicate(filter, query, requiresCast);
    };
    /**
     * Generate query string based on the multiple filter criteria from query.
     * @param  {string[]} filters
     */
    ODataAdaptor.prototype.onWhere = function (filters) {
        if (this.pvt.search) {
            filters.push(this.onEachWhere(this.pvt.search, null, true));
        }
        return filters.join(' and ');
    };
    /**
     * Generate query string based on the multiple search criteria from query.
     * @param  {{fields:string[]} e
     * @param  {string} operator
     * @param  {string} key
     * @param  {boolean}} ignoreCase
     */
    ODataAdaptor.prototype.onEachSearch = function (e) {
        if (e.fields && e.fields.length === 0) {
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].throwError('Query() - Search : oData search requires list of field names to search');
        }
        var filter = this.pvt.search || [];
        for (var i = 0; i < e.fields.length; i++) {
            filter.push(new __WEBPACK_IMPORTED_MODULE_2__query__["a" /* Predicate */](e.fields[i], e.operator, e.key, e.ignoreCase));
        }
        this.pvt.search = filter;
    };
    /**
     * Generate query string based on the search criteria from query.
     * @param  {Object} e
     */
    ODataAdaptor.prototype.onSearch = function (e) {
        this.pvt.search = __WEBPACK_IMPORTED_MODULE_2__query__["a" /* Predicate */].or(this.pvt.search);
        return '';
    };
    /**
     * Generate query string based on multiple sort criteria from query.
     * @param  {QueryOptions} e
     */
    ODataAdaptor.prototype.onEachSort = function (e) {
        var res = [];
        if (e.name instanceof Array) {
            for (var i = 0; i < e.name.length; i++) {
                res.push(ODataAdaptor.getField(e.name[i]) + (e.direction === 'descending' ? ' desc' : ''));
            }
        }
        else {
            res.push(ODataAdaptor.getField(e.name) + (e.direction === 'descending' ? ' desc' : ''));
        }
        return res.join(',');
    };
    /**
     * Returns sort query string.
     * @param  {string[]} e
     */
    ODataAdaptor.prototype.onSortBy = function (e) {
        return e.reverse().join(',');
    };
    /**
     * Adds the group query to the adaptor option.
     * @param  {Object[]} e
     * @returns string
     */
    ODataAdaptor.prototype.onGroup = function (e) {
        this.pvt.groups = e;
        return [];
    };
    /**
     * Returns the select query string.
     * @param  {string[]} e
     */
    ODataAdaptor.prototype.onSelect = function (e) {
        for (var i = 0; i < e.length; i++) {
            e[i] = ODataAdaptor.getField(e[i]);
        }
        return e.join(',');
    };
    /**
     * Add the aggregate query to the adaptor option.
     * @param  {Object[]} e
     * @returns string
     */
    ODataAdaptor.prototype.onAggregates = function (e) {
        this.pvt.aggregates = e;
        return '';
    };
    /**
     * Returns the query string which requests total count from the data source.
     * @param  {boolean} e
     * @returns string
     */
    ODataAdaptor.prototype.onCount = function (e) {
        return e === true ? 'allpages' : '';
    };
    /**
     * Method will trigger before send the request to server side.
     * Used to set the custom header or modify the request options.
     * @param  {DataManager} dm
     * @param  {XMLHttpRequest} request
     * @param  {Ajax} settings?
     */
    ODataAdaptor.prototype.beforeSend = function (dm, request, settings) {
        if (__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].endsWith(settings.url, this.options.batch) && settings.type.toLowerCase() === 'post') {
            request.setRequestHeader('Accept', this.options.multipartAccept);
            request.setRequestHeader('DataServiceVersion', '2.0');
            request.overrideMimeType('text/plain; charset=x-user-defined');
        }
        else {
            request.setRequestHeader('Accept', this.options.accept);
        }
        request.setRequestHeader('DataServiceVersion', '2.0');
        request.setRequestHeader('MaxDataServiceVersion', '2.0');
    };
    /**
     * Returns the data from the query processing.
     * @param  {DataResult} data
     * @param  {DataOptions} ds?
     * @param  {Query} query?
     * @param  {XMLHttpRequest} xhr?
     * @param  {Ajax} request?
     * @param  {CrudOptions} changes?
     * @returns aggregateResult
     */
    ODataAdaptor.prototype.processResponse = function (data, ds, query, xhr, request, changes) {
        var metaCheck = 'odata.metadata';
        if ((request && request.type === 'GET') && !this.rootUrl && data[metaCheck]) {
            var dataUrls = data[metaCheck].split('/$metadata#');
            this.rootUrl = dataUrls[0];
            this.resourceTableName = dataUrls[1];
        }
        var pvtData = 'pvtData';
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data.d)) {
            var dataCopy = ((query && query.isCountRequired) ? data.d.results : data.d);
            var metaData = '__metadata';
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dataCopy)) {
                for (var i = 0; i < dataCopy.length; i++) {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dataCopy[i][metaData])) {
                        delete dataCopy[i][metaData];
                    }
                }
            }
        }
        var pvt = request && request[pvtData];
        var emptyAndBatch = this.processBatchResponse(data, query, xhr, request, changes);
        if (emptyAndBatch) {
            return emptyAndBatch;
        }
        var versionCheck = xhr && request.getResponseHeader('DataServiceVersion');
        var count = null;
        var version = (versionCheck && parseInt(versionCheck, 10)) || 2;
        if (query && query.isCountRequired) {
            var oDataCount = '__count';
            if (data[oDataCount] || data['odata.count']) {
                count = data[oDataCount] || data['odata.count'];
            }
            if (data.d) {
                data = data.d;
            }
            if (data[oDataCount] || data['odata.count']) {
                count = data[oDataCount] || data['odata.count'];
            }
        }
        if (version === 3 && data.value) {
            data = data.value;
        }
        if (data.d) {
            data = data.d;
        }
        if (version < 3 && data.results) {
            data = data.results;
        }
        var args = {};
        args.count = count;
        args.result = data;
        this.getAggregateResult(pvt, data, args, null, query);
        return __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].isNull(count) ? args.result : { result: args.result, count: args.count, aggregates: args.aggregates };
    };
    /**
     * Converts the request object to query string.
     * @param  {Object} req
     * @param  {Query} query
     * @param  {DataManager} dm
     * @returns tableName
     */
    ODataAdaptor.prototype.convertToQueryString = function (request, query, dm) {
        var res = [];
        var table = 'table';
        var tableName = request[table] || '';
        var format = '$format';
        delete request[table];
        if (dm.dataSource.requiresFormat) {
            request[format] = 'json';
        }
        var keys = Object.keys(request);
        for (var _i = 0, keys_4 = keys; _i < keys_4.length; _i++) {
            var prop = keys_4[_i];
            res.push(prop + '=' + request[prop]);
        }
        res = res.join('&');
        if (dm.dataSource.url && dm.dataSource.url.indexOf('?') !== -1 && !tableName) {
            return res;
        }
        return res.length ? tableName + '?' + res : tableName || '';
    };
    ODataAdaptor.prototype.localTimeReplacer = function (key, convertObj) {
        for (var _i = 0, _a = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(convertObj) ? Object.keys(convertObj) : []; _i < _a.length; _i++) {
            var prop = _a[_i];
            if ((convertObj[prop] instanceof Date)) {
                convertObj[prop] = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].dateParse.toLocalTime(convertObj[prop]);
            }
        }
        return convertObj;
    };
    /**
     * Prepare and returns request body which is used to insert a new record in the table.
     * @param  {DataManager} dm
     * @param  {Object} data
     * @param  {string} tableName?
     */
    ODataAdaptor.prototype.insert = function (dm, data, tableName) {
        return {
            url: (dm.dataSource.insertUrl || dm.dataSource.url).replace(/\/*$/, tableName ? '/' + tableName : ''),
            data: JSON.stringify(data, this.options.localTime ? this.localTimeReplacer : null)
        };
    };
    /**
     * Prepare and return request body which is used to remove record from the table.
     * @param  {DataManager} dm
     * @param  {string} keyField
     * @param  {number} value
     * @param  {string} tableName?
     */
    ODataAdaptor.prototype.remove = function (dm, keyField, value, tableName) {
        var url;
        if (typeof value === 'string' && !__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.isGuid(value)) {
            url = "('" + value + "')";
        }
        else {
            url = "(" + value + ")";
        }
        return {
            type: 'DELETE',
            url: (dm.dataSource.removeUrl || dm.dataSource.url).replace(/\/*$/, tableName ? '/' + tableName : '') + url
        };
    };
    /**
     * Updates existing record and saves the changes to the table.
     * @param  {DataManager} dm
     * @param  {string} keyField
     * @param  {Object} value
     * @param  {string} tableName?
     * @returns this
     */
    ODataAdaptor.prototype.update = function (dm, keyField, value, tableName, query, original) {
        if (this.options.updateType === 'PATCH' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(original)) {
            value = this.compareAndRemove(value, original, keyField);
        }
        var url;
        if (typeof value[keyField] === 'string' && !__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.isGuid(value[keyField])) {
            url = "('" + value[keyField] + "')";
        }
        else {
            url = "(" + value[keyField] + ")";
        }
        return {
            type: this.options.updateType,
            url: (dm.dataSource.updateUrl || dm.dataSource.url).replace(/\/*$/, tableName ? '/' + tableName : '') + url,
            data: JSON.stringify(value, this.options.localTime ? this.localTimeReplacer : null),
            accept: this.options.accept
        };
    };
    /**
     * Prepare the request body based on the newly added, removed and updated records.
     * The result is used by the batch request.
     * @param  {DataManager} dm
     * @param  {CrudOptions} changes
     * @param  {RemoteArgs} e
     * @returns {Object}
     */
    ODataAdaptor.prototype.batchRequest = function (dm, changes, e, query, original) {
        var initialGuid = e.guid = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getGuid(this.options.batchPre);
        var url = this.rootUrl ? this.rootUrl + '/' + this.options.batch :
            dm.dataSource.url.replace(/\/*$/, '/' + this.options.batch);
        e.url = this.resourceTableName ? this.resourceTableName : e.url;
        var args = {
            url: e.url,
            key: e.key,
            cid: 1,
            cSet: __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getGuid(this.options.changeSet)
        };
        var req = '--' + initialGuid + '\n';
        req += 'Content-Type: multipart/mixed; boundary=' + args.cSet.replace('--', '') + '\n';
        this.pvt.changeSet = 0;
        req += this.generateInsertRequest(changes.addedRecords, args, dm);
        req += this.generateUpdateRequest(changes.changedRecords, args, dm, original ? original.changedRecords : []);
        req += this.generateDeleteRequest(changes.deletedRecords, args, dm);
        req += args.cSet + '--\n';
        req += '--' + initialGuid + '--';
        return {
            type: 'POST',
            url: url,
            dataType: 'json',
            contentType: 'multipart/mixed; charset=UTF-8;boundary=' + initialGuid,
            data: req
        };
    };
    /**
     * Generate the string content from the removed records.
     * The result will be send during batch update.
     * @param  {Object[]} arr
     * @param  {RemoteArgs} e
     * @returns this
     */
    ODataAdaptor.prototype.generateDeleteRequest = function (arr, e, dm) {
        if (!arr) {
            return '';
        }
        var req = '';
        var stat = {
            'method': 'DELETE ',
            'url': function (data, i, key) {
                var url = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getObject(key, data[i]);
                if (typeof url === 'number' || __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.isGuid(url)) {
                    return '(' + url + ')';
                }
                else if (url instanceof Date) {
                    var dateTime = data[i][key];
                    return '(' + dateTime.toJSON() + ')';
                }
                else {
                    return "('" + url + "')";
                }
            },
            'data': function (data, i) { return ''; }
        };
        req = this.generateBodyContent(arr, e, stat, dm);
        return req + '\n';
    };
    /**
     * Generate the string content from the inserted records.
     * The result will be send during batch update.
     * @param  {Object[]} arr
     * @param  {RemoteArgs} e
     */
    ODataAdaptor.prototype.generateInsertRequest = function (arr, e, dm) {
        if (!arr) {
            return '';
        }
        var req = '';
        var stat = {
            'method': 'POST ',
            'url': function (data, i, key) { return ''; },
            'data': function (data, i) { return JSON.stringify(data[i]) + '\n\n'; }
        };
        req = this.generateBodyContent(arr, e, stat, dm);
        return req;
    };
    /**
     * Generate the string content from the updated records.
     * The result will be send during batch update.
     * @param  {Object[]} arr
     * @param  {RemoteArgs} e
     */
    ODataAdaptor.prototype.generateUpdateRequest = function (arr, e, dm, org) {
        var _this = this;
        if (!arr) {
            return '';
        }
        var req = '';
        arr.forEach(function (change) { return change = _this.compareAndRemove(change, org.filter(function (o) { return __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getObject(e.key, o) === __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getObject(e.key, change); })[0], e.key); });
        var stat = {
            'method': this.options.updateType + ' ',
            'url': function (data, i, key) {
                if (typeof data[i][key] === 'number' || __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.isGuid(data[i][key])) {
                    return '(' + data[i][key] + ')';
                }
                else if (data[i][key] instanceof Date) {
                    var date = data[i][key];
                    return '(' + date.toJSON() + ')';
                }
                else {
                    return "('" + data[i][key] + "')";
                }
            },
            'data': function (data, i) { return JSON.stringify(data[i]) + '\n\n'; }
        };
        req = this.generateBodyContent(arr, e, stat, dm);
        return req;
    };
    ODataAdaptor.getField = function (prop) {
        return prop.replace(/\./g, '/');
    };
    ODataAdaptor.prototype.generateBodyContent = function (arr, e, stat, dm) {
        var req = '';
        for (var i = 0; i < arr.length; i++) {
            req += '\n' + e.cSet + '\n';
            req += this.options.changeSetContent + '\n\n';
            req += stat.method;
            if (stat.method === 'POST ') {
                req += (dm.dataSource.insertUrl || dm.dataSource.crudUrl || e.url) + stat.url(arr, i, e.key) + ' HTTP/1.1\n';
            }
            else if (stat.method === 'PUT ' || stat.method === 'PATCH ') {
                req += (dm.dataSource.updateUrl || dm.dataSource.crudUrl || e.url) + stat.url(arr, i, e.key) + ' HTTP/1.1\n';
            }
            else if (stat.method === 'DELETE ') {
                req += (dm.dataSource.removeUrl || dm.dataSource.crudUrl || e.url) + stat.url(arr, i, e.key) + ' HTTP/1.1\n';
            }
            req += 'Accept: ' + this.options.accept + '\n';
            req += 'Content-Id: ' + this.pvt.changeSet++ + '\n';
            req += this.options.batchChangeSetContentType + '\n';
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(arr[i]['@odata.etag'])) {
                req += 'If-Match: ' + arr[i]['@odata.etag'] + '\n\n';
                delete arr[i]['@odata.etag'];
            }
            else {
                req += '\n';
            }
            req += stat.data(arr, i);
        }
        return req;
    };
    ODataAdaptor.prototype.processBatchResponse = function (data, query, xhr, request, changes) {
        if (xhr && xhr.getResponseHeader('Content-Type') && xhr.getResponseHeader('Content-Type').indexOf('xml') !== -1) {
            return (query.isCountRequired ? { result: [], count: 0 } : []);
        }
        if (request && this.options.batch && __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].endsWith(request.url, this.options.batch) && request.type.toLowerCase() === 'post') {
            var guid = xhr.getResponseHeader('Content-Type');
            var cIdx = void 0;
            var jsonObj = void 0;
            var d = data + '';
            guid = guid.substring(guid.indexOf('=batchresponse') + 1);
            d = d.split(guid);
            if (d.length < 2) {
                return {};
            }
            d = d[1];
            var exVal = /(?:\bContent-Type.+boundary=)(changesetresponse.+)/i.exec(d);
            if (exVal) {
                d.replace(exVal[0], '');
            }
            var changeGuid = exVal ? exVal[1] : '';
            d = d.split(changeGuid);
            for (var i = d.length; i > -1; i--) {
                if (!/\bContent-ID:/i.test(d[i]) || !/\bHTTP.+201/.test(d[i])) {
                    continue;
                }
                cIdx = parseInt(/\bContent-ID: (\d+)/i.exec(d[i])[1], 10);
                if (changes.addedRecords[cIdx]) {
                    jsonObj = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.parseJson(/^\{.+\}/m.exec(d[i])[0]);
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, changes.addedRecords[cIdx], this.processResponse(jsonObj));
                }
            }
            return changes;
        }
        return null;
    };
    ODataAdaptor.prototype.compareAndRemove = function (data, original, key) {
        var _this = this;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(original)) {
            return data;
        }
        Object.keys(data).forEach(function (prop) {
            if (prop !== key && prop !== '@odata.etag') {
                if (__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].isPlainObject(data[prop])) {
                    _this.compareAndRemove(data[prop], original[prop]);
                    var final = Object.keys(data[prop]).filter(function (data) { return data !== '@odata.etag'; });
                    if (final.length === 0) {
                        delete data[prop];
                    }
                }
                else if (data[prop] === original[prop]) {
                    delete data[prop];
                }
                else if (data[prop] && original[prop] && data[prop].valueOf() === original[prop].valueOf()) {
                    delete data[prop];
                }
            }
        });
        return data;
    };
    return ODataAdaptor;
}(UrlAdaptor));

/**
 * The OData v4 is an improved version of OData protocols.
 * The DataManager uses the ODataV4Adaptor to consume OData v4 services.
 * @hidden
 */
var ODataV4Adaptor = /** @class */ (function (_super) {
    __extends(ODataV4Adaptor, _super);
    function ODataV4Adaptor(props) {
        var _this = _super.call(this, props) || this;
        // options replaced the default adaptor options
        _this.options = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, _this.options, {
            requestType: 'get',
            accept: 'application/json, text/javascript, */*; q=0.01',
            multipartAccept: 'multipart/mixed',
            sortBy: '$orderby',
            select: '$select',
            skip: '$skip',
            take: '$top',
            count: '$count',
            search: '$search',
            where: '$filter',
            expand: '$expand',
            batch: '$batch',
            changeSet: '--changeset_',
            batchPre: 'batch_',
            contentId: 'Content-Id: ',
            batchContent: 'Content-Type: multipart/mixed; boundary=',
            changeSetContent: 'Content-Type: application/http\nContent-Transfer-Encoding: binary ',
            batchChangeSetContentType: 'Content-Type: application/json; charset=utf-8 ',
            updateType: 'PATCH',
            localTime: false,
            apply: '$apply'
        });
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])(_this.options, props || {});
        return _this;
    }
    /**
     * @hidden
     */
    ODataV4Adaptor.prototype.getModuleName = function () {
        return 'ODataV4Adaptor';
    };
    /**
     * Returns the query string which requests total count from the data source.
     * @param  {boolean} e
     * @returns string
     */
    ODataV4Adaptor.prototype.onCount = function (e) {
        return e === true ? 'true' : '';
    };
    /**
     * Generate request string based on the filter criteria from query.
     * @param  {Predicate} pred
     * @param  {boolean} requiresCast?
     */
    ODataV4Adaptor.prototype.onPredicate = function (predicate, query, requiresCast) {
        var returnValue = '';
        var val = predicate.value;
        var isDate = val instanceof Date;
        if (query instanceof __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */]) {
            var queries = this.getQueryRequest(query);
            for (var i = 0; i < queries.filters.length; i++) {
                if (queries.filters[i].e.key === predicate.value) {
                    requiresCast = true;
                }
            }
        }
        returnValue = _super.prototype.onPredicate.call(this, predicate, query, requiresCast);
        if (isDate) {
            returnValue = returnValue.replace(/datetime'(.*)'$/, '$1');
        }
        if (__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.isGuid(val)) {
            returnValue = returnValue.replace('guid', '').replace(/'/g, '');
        }
        return returnValue;
    };
    /**
     *  Generate query string based on the multiple search criteria from query.
     * @param  {{fields:string[]} e
     * @param  {string} operator
     * @param  {string} key
     * @param  {boolean}} ignoreCase
     */
    ODataV4Adaptor.prototype.onEachSearch = function (e) {
        var search = this.pvt.searches || [];
        search.push(e.key);
        this.pvt.searches = search;
    };
    /**
     *  Generate query string based on the search criteria from query.
     * @param  {Object} e
     */
    ODataV4Adaptor.prototype.onSearch = function (e) {
        return this.pvt.searches.join(' OR ');
    };
    /**
     * Returns the expand query string.
     * @param  {string} e
     */
    ODataV4Adaptor.prototype.onExpand = function (e) {
        var _this = this;
        var selected = {};
        var expanded = {};
        var expands = e.expands.slice();
        var exArr = [];
        var selects = e.selects.filter(function (item) { return item.indexOf('.') > -1; });
        selects.forEach(function (select) {
            var splits = select.split('.');
            if (!(splits[0] in selected)) {
                selected[splits[0]] = [];
            }
            if (splits.length == 2) {
                if (selected[splits[0]].length && Object.keys(selected).indexOf(splits[0]) !== -1) {
                    if (selected[splits[0]][0].indexOf('$expand') !== -1 && selected[splits[0]][0].indexOf(';$select=') === -1) {
                        selected[splits[0]][0] = selected[splits[0]][0] + ';' + '$select=' + splits[1];
                    }
                    else {
                        selected[splits[0]][0] = selected[splits[0]][0] + ',' + splits[1];
                    }
                }
                else {
                    selected[splits[0]].push('$select=' + splits[1]);
                }
            }
            else {
                var sel = '$select=' + splits[splits.length - 1];
                var exp = '';
                var close_1 = '';
                for (var i = 1; i < splits.length - 1; i++) {
                    exp = exp + '$expand=' + splits[i] + '(';
                    close_1 = close_1 + ')';
                }
                var combineVal = exp + sel + close_1;
                if (selected[splits[0]].length && Object.keys(selected).indexOf(splits[0]) !== -1 &&
                    _this.expandQueryIndex(selected[splits[0]], true)) {
                    var idx = _this.expandQueryIndex(selected[splits[0]]);
                    selected[splits[0]][idx] = selected[splits[0]][idx] + combineVal.replace('$expand=', ',');
                }
                else {
                    selected[splits[0]].push(combineVal);
                }
            }
        });
        //Auto expand from select query
        Object.keys(selected).forEach(function (expand) {
            if ((expands.indexOf(expand) === -1)) {
                expands.push(expand);
            }
        });
        expands.forEach(function (expand) {
            expanded[expand] = expand in selected ? expand + "(" + selected[expand].join(';') + ")" : expand;
        });
        Object.keys(expanded).forEach(function (ex) { return exArr.push(expanded[ex]); });
        return exArr.join(',');
    };
    ODataV4Adaptor.prototype.expandQueryIndex = function (query, isExpand) {
        for (var i = 0; i < query.length; i++) {
            if (query[i].indexOf('$expand') !== -1) {
                return isExpand ? true : i;
            }
        }
        return isExpand ? false : 0;
    };
    /**
     * Returns the groupby query string.
     * @param  {string} e
     */
    ODataV4Adaptor.prototype.onDistinct = function (distinctFields) {
        var fields = distinctFields.map(function (field) { return ODataAdaptor.getField(field); }).join(',');
        return "groupby((" + fields + "))";
    };
    /**
     * Returns the select query string.
     * @param  {string[]} e
     */
    ODataV4Adaptor.prototype.onSelect = function (e) {
        return _super.prototype.onSelect.call(this, e.filter(function (item) { return item.indexOf('.') === -1; }));
    };
    /**
     * Method will trigger before send the request to server side.
     * Used to set the custom header or modify the request options.
     * @param  {DataManager} dm
     * @param  {XMLHttpRequest} request
     * @param  {Ajax} settings
     * @returns void
     */
    ODataV4Adaptor.prototype.beforeSend = function (dm, request, settings) {
        if (settings.type === 'POST' || settings.type === 'PUT' || settings.type === 'PATCH') {
            request.setRequestHeader('Prefer', 'return=representation');
        }
        request.setRequestHeader('Accept', this.options.accept);
    };
    /**
     * Returns the data from the query processing.
     * @param  {DataResult} data
     * @param  {DataOptions} ds?
     * @param  {Query} query?
     * @param  {XMLHttpRequest} xhr?
     * @param  {Ajax} request?
     * @param  {CrudOptions} changes?
     * @returns aggregateResult
     */
    ODataV4Adaptor.prototype.processResponse = function (data, ds, query, xhr, request, changes) {
        var metaName = '@odata.context';
        if ((request && request.type === 'GET') && !this.rootUrl && data[metaName]) {
            var dataUrl = data[metaName].split('/$metadata#');
            this.rootUrl = dataUrl[0];
            this.resourceTableName = dataUrl[1];
        }
        var pvtData = 'pvtData';
        var pvt = request && request[pvtData];
        var emptyAndBatch = _super.prototype.processBatchResponse.call(this, data, query, xhr, request, changes);
        if (emptyAndBatch) {
            return emptyAndBatch;
        }
        var count = null;
        var dataCount = '@odata.count';
        if (query && query.isCountRequired) {
            if (dataCount in data) {
                count = data[dataCount];
            }
        }
        data = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data.value) ? data.value : data;
        var args = {};
        args.count = count;
        args.result = data;
        this.getAggregateResult(pvt, data, args, null, query);
        return __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].isNull(count) ? args.result : { result: args.result, count: count, aggregates: args.aggregates };
    };
    return ODataV4Adaptor;
}(ODataAdaptor));

/**
 * The Web API is a programmatic interface to define the request and response messages system that is mostly exposed in JSON or XML.
 * The DataManager uses the WebApiAdaptor to consume Web API.
 * Since this adaptor is targeted to interact with Web API created using OData endpoint, it is extended from ODataAdaptor
 * @hidden
 */
var WebApiAdaptor = /** @class */ (function (_super) {
    __extends(WebApiAdaptor, _super);
    function WebApiAdaptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebApiAdaptor.prototype.getModuleName = function () {
        return 'WebApiAdaptor';
    };
    /**
     * Prepare and returns request body which is used to insert a new record in the table.
     * @param  {DataManager} dm
     * @param  {Object} data
     * @param  {string} tableName?
     */
    WebApiAdaptor.prototype.insert = function (dm, data, tableName) {
        return {
            type: 'POST',
            url: dm.dataSource.url,
            data: JSON.stringify(data)
        };
    };
    /**
     * Prepare and return request body which is used to remove record from the table.
     * @param  {DataManager} dm
     * @param  {string} keyField
     * @param  {number} value
     * @param  {string} tableName?
     */
    WebApiAdaptor.prototype.remove = function (dm, keyField, value, tableName) {
        return {
            type: 'DELETE',
            url: dm.dataSource.url + '/' + value,
            data: JSON.stringify(value)
        };
    };
    /**
     * Prepare and return request body which is used to update record.
     * @param  {DataManager} dm
     * @param  {string} keyField
     * @param  {Object} value
     * @param  {string} tableName?
     */
    WebApiAdaptor.prototype.update = function (dm, keyField, value, tableName) {
        return {
            type: 'PUT',
            url: dm.dataSource.url,
            data: JSON.stringify(value)
        };
    };
    WebApiAdaptor.prototype.batchRequest = function (dm, changes, e) {
        var _this = this;
        var initialGuid = e.guid = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getGuid(this.options.batchPre);
        var url = dm.dataSource.url.replace(/\/*$/, '/' + this.options.batch);
        e.url = this.resourceTableName ? this.resourceTableName : e.url;
        var req = [];
        var _loop_1 = function (i, x) {
            changes.addedRecords.forEach(function (j, d) {
                var stat = {
                    'method': 'POST ',
                    'url': function (data, i, key) { return ''; },
                    'data': function (data, i) { return JSON.stringify(data[i]) + '\n\n'; }
                };
                req.push('--' + initialGuid);
                req.push('Content-Type: application/http; msgtype=request', '');
                req.push('POST ' + '/api/' + (dm.dataSource.insertUrl || dm.dataSource.crudUrl || e.url)
                    + stat.url(changes.addedRecords, i, e.key) + ' HTTP/1.1');
                req.push('Content-Type: ' + 'application/json; charset=utf-8');
                req.push('Host: ' + location.host);
                req.push('', j ? JSON.stringify(j) : '');
            });
        };
        //insertion
        for (var i = 0, x = changes.addedRecords.length; i < x; i++) {
            _loop_1(i, x);
        }
        var _loop_2 = function (i, x) {
            changes.changedRecords.forEach(function (j, d) {
                var stat = {
                    'method': _this.options.updateType + ' ',
                    'url': function (data, i, key) { return ''; },
                    'data': function (data, i) { return JSON.stringify(data[i]) + '\n\n'; }
                };
                req.push('--' + initialGuid);
                req.push('Content-Type: application/http; msgtype=request', '');
                req.push('PUT ' + '/api/' + (dm.dataSource.updateUrl || dm.dataSource.crudUrl || e.url)
                    + stat.url(changes.changedRecords, i, e.key) + ' HTTP/1.1');
                req.push('Content-Type: ' + 'application/json; charset=utf-8');
                req.push('Host: ' + location.host);
                req.push('', j ? JSON.stringify(j) : '');
            });
        };
        //updation 
        for (var i = 0, x = changes.changedRecords.length; i < x; i++) {
            _loop_2(i, x);
        }
        var _loop_3 = function (i, x) {
            changes.deletedRecords.forEach(function (j, d) {
                var state = {
                    'mtd': 'DELETE ',
                    'url': function (data, i, key) {
                        var url = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getObject(key, data[i]);
                        if (typeof url === 'number' || __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.isGuid(url)) {
                            return '/' + url;
                        }
                        else if (url instanceof Date) {
                            var datTime = data[i][key];
                            return '/' + datTime.toJSON();
                        }
                        else {
                            return "/'" + url + "'";
                        }
                    },
                    'data': function (data, i) { return ''; }
                };
                req.push('--' + initialGuid);
                req.push('Content-Type: application/http; msgtype=request', '');
                req.push('DELETE ' + '/api/' + (dm.dataSource.removeUrl || dm.dataSource.crudUrl || e.url)
                    + state.url(changes.deletedRecords, i, e.key) + ' HTTP/1.1');
                req.push('Content-Type: ' + 'application/json; charset=utf-8');
                req.push('Host: ' + location.host);
                req.push('', j ? JSON.stringify(j) : '');
            });
        };
        //deletion
        for (var i = 0, x = changes.deletedRecords.length; i < x; i++) {
            _loop_3(i, x);
        }
        req.push('--' + initialGuid + '--', '');
        return {
            type: 'POST',
            url: url,
            contentType: 'multipart/mixed; boundary=' + initialGuid,
            data: req.join('\r\n')
        };
    };
    /**
     * Method will trigger before send the request to server side.
     * Used to set the custom header or modify the request options.
     * @param  {DataManager} dm
     * @param  {XMLHttpRequest} request
     * @param  {Ajax} settings
     * @returns void
     */
    WebApiAdaptor.prototype.beforeSend = function (dm, request, settings) {
        request.setRequestHeader('Accept', 'application/json, text/javascript, */*; q=0.01');
    };
    /**
     * Returns the data from the query processing.
     * @param  {DataResult} data
     * @param  {DataOptions} ds?
     * @param  {Query} query?
     * @param  {XMLHttpRequest} xhr?
     * @param  {Ajax} request?
     * @param  {CrudOptions} changes?
     * @returns aggregateResult
     */
    WebApiAdaptor.prototype.processResponse = function (data, ds, query, xhr, request, changes) {
        var pvtData = 'pvtData';
        var pvt = request && request[pvtData];
        var count = null;
        var args = {};
        if (request && request.type.toLowerCase() !== 'post') {
            var versionCheck = xhr && request.getResponseHeader('DataServiceVersion');
            var version = (versionCheck && parseInt(versionCheck, 10)) || 2;
            if (query && query.isCountRequired) {
                if (!__WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].isNull(data.Count)) {
                    count = data.Count;
                }
            }
            if (version < 3 && data.Items) {
                data = data.Items;
            }
            args.count = count;
            args.result = data;
            this.getAggregateResult(pvt, data, args, null, query);
        }
        args.result = args.result || data;
        return __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].isNull(count) ? args.result : { result: args.result, count: args.count, aggregates: args.aggregates };
    };
    return WebApiAdaptor;
}(ODataAdaptor));

/**
 * WebMethodAdaptor can be used by DataManager to interact with web method.
 * @hidden
 */
var WebMethodAdaptor = /** @class */ (function (_super) {
    __extends(WebMethodAdaptor, _super);
    function WebMethodAdaptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Prepare the request body based on the query.
     * The query information can be accessed at the WebMethod using variable named `value`.
     * @param  {DataManager} dm
     * @param  {Query} query
     * @param  {Object[]} hierarchyFilters?
     * @returns application
     */
    WebMethodAdaptor.prototype.processQuery = function (dm, query, hierarchyFilters) {
        var obj = new UrlAdaptor().processQuery(dm, query, hierarchyFilters);
        var getData = 'data';
        var data = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.parseJson(obj[getData]);
        var result = {};
        var value = 'value';
        if (data.param) {
            for (var i = 0; i < data.param.length; i++) {
                var param = data.param[i];
                var key = Object.keys(param)[0];
                result[key] = param[key];
            }
        }
        result[value] = data;
        var pvtData = 'pvtData';
        var url = 'url';
        return {
            data: JSON.stringify(result),
            url: obj[url],
            pvtData: obj[pvtData],
            type: 'POST',
            contentType: 'application/json; charset=utf-8'
        };
    };
    return WebMethodAdaptor;
}(UrlAdaptor));

/**
 * RemoteSaveAdaptor, extended from JsonAdaptor and it is used for binding local data and performs all DataManager queries in client-side.
 * It interacts with server-side only for CRUD operations.
 * @hidden
 */
var RemoteSaveAdaptor = /** @class */ (function (_super) {
    __extends(RemoteSaveAdaptor, _super);
    /**
     * @hidden
     */
    function RemoteSaveAdaptor() {
        var _this = _super.call(this) || this;
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])('beforeSend', UrlAdaptor.prototype.beforeSend, _this);
        return _this;
    }
    RemoteSaveAdaptor.prototype.insert = function (dm, data, tableName, query, position) {
        this.pvt.position = position;
        this.updateType = 'add';
        return {
            url: dm.dataSource.insertUrl || dm.dataSource.crudUrl || dm.dataSource.url,
            data: JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, {
                value: data,
                table: tableName,
                action: 'insert'
            }, __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getAddParams(this, dm, query)))
        };
    };
    RemoteSaveAdaptor.prototype.remove = function (dm, keyField, val, tableName, query) {
        _super.prototype.remove.call(this, dm, keyField, val);
        return {
            type: 'POST',
            url: dm.dataSource.removeUrl || dm.dataSource.crudUrl || dm.dataSource.url,
            data: JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, {
                key: val,
                keyColumn: keyField,
                table: tableName,
                action: 'remove'
            }, __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getAddParams(this, dm, query)))
        };
    };
    RemoteSaveAdaptor.prototype.update = function (dm, keyField, val, tableName, query) {
        this.updateType = 'update';
        this.updateKey = keyField;
        return {
            type: 'POST',
            url: dm.dataSource.updateUrl || dm.dataSource.crudUrl || dm.dataSource.url,
            data: JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, {
                value: val,
                action: 'update',
                keyColumn: keyField,
                key: val[keyField],
                table: tableName
            }, __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getAddParams(this, dm, query)))
        };
    };
    RemoteSaveAdaptor.prototype.processResponse = function (data, ds, query, xhr, request, changes, e) {
        var i;
        var newData = request ? JSON.parse(request.data) : data;
        data = newData.action === 'batch' ? __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.parseJson(data) : data;
        if (this.updateType === 'add') {
            _super.prototype.insert.call(this, ds, data, null, null, this.pvt.position);
        }
        if (this.updateType === 'update') {
            _super.prototype.update.call(this, ds, this.updateKey, data);
        }
        this.updateType = undefined;
        if (data.added) {
            for (i = 0; i < data.added.length; i++) {
                _super.prototype.insert.call(this, ds, data.added[i]);
            }
        }
        if (data.changed) {
            for (i = 0; i < data.changed.length; i++) {
                _super.prototype.update.call(this, ds, e.key, data.changed[i]);
            }
        }
        if (data.deleted) {
            for (i = 0; i < data.deleted.length; i++) {
                _super.prototype.remove.call(this, ds, e.key, data.deleted[i]);
            }
        }
        return data;
    };
    /**
     * Prepare the request body based on the newly added, removed and updated records.
     * Also perform the changes in the locally cached data to sync with the remote data.
     * The result is used by the batch request.
     * @param  {DataManager} dm
     * @param  {CrudOptions} changes
     * @param  {RemoteArgs} e
     */
    RemoteSaveAdaptor.prototype.batchRequest = function (dm, changes, e, query, original) {
        return {
            type: 'POST',
            url: dm.dataSource.batchUrl || dm.dataSource.crudUrl || dm.dataSource.url,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, {
                changed: changes.changedRecords,
                added: changes.addedRecords,
                deleted: changes.deletedRecords,
                action: 'batch',
                table: e.url,
                key: e.key
            }, __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getAddParams(this, dm, query)))
        };
    };
    RemoteSaveAdaptor.prototype.addParams = function (options) {
        var urlParams = new UrlAdaptor();
        urlParams.addParams(options);
    };
    return RemoteSaveAdaptor;
}(JsonAdaptor));

/**
 * Ajax Adaptor that is extended from URL Adaptor, is used for handle data operations with user defined functions.
 * @hidden
 */
var CustomDataAdaptor = /** @class */ (function (_super) {
    __extends(CustomDataAdaptor, _super);
    function CustomDataAdaptor(props) {
        var _this = _super.call(this) || this;
        // options replaced the default adaptor options
        _this.options = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, _this.options, {
            getData: new Function(),
            addRecord: new Function(),
            updateRecord: new Function(),
            deleteRecord: new Function(),
            batchUpdate: new Function()
        });
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])(_this.options, props || {});
        return _this;
    }
    CustomDataAdaptor.prototype.getModuleName = function () {
        return 'CustomDataAdaptor';
    };
    return CustomDataAdaptor;
}(UrlAdaptor));

/**
 * The GraphqlAdaptor that is extended from URL Adaptor, is used for retrieving data from the Graphql server.
 * It interacts with the Graphql server with all the DataManager Queries and performs CRUD operations.
 * @hidden
 */
var GraphQLAdaptor = /** @class */ (function (_super) {
    __extends(GraphQLAdaptor, _super);
    function GraphQLAdaptor(options) {
        var _this = _super.call(this) || this;
        _this.opt = options;
        _this.schema = _this.opt.response;
        _this.query = _this.opt.query;
        _this.getVariables = _this.opt.getVariables ? _this.opt.getVariables : function () { };
        _this.getQuery = function () { return _this.query; };
        return _this;
    }
    GraphQLAdaptor.prototype.getModuleName = function () {
        return 'GraphQLAdaptor';
    };
    /**
     * Process the JSON data based on the provided queries.
     * @param  {DataManager} dm
     * @param  {Query} query?
     */
    GraphQLAdaptor.prototype.processQuery = function (datamanager, query) {
        var urlQuery = _super.prototype.processQuery.apply(this, arguments);
        var dm = JSON.parse(urlQuery.data);
        // constructing GraphQL parameters
        var keys = ['skip', 'take', 'sorted', 'table', 'select', 'where',
            'search', 'requiresCounts', 'aggregates', 'params'];
        var temp = {};
        var str = 'searchwhereparams';
        keys.filter(function (e) {
            temp[e] = str.indexOf(e) > -1 ? JSON.stringify(dm[e]) : dm[e];
        });
        var vars = this.getVariables() || {};
        vars['datamanager'] = temp;
        var data = JSON.stringify({
            query: this.getQuery(),
            variables: vars
        });
        urlQuery.data = data;
        return urlQuery;
    };
    /**
     * Returns the data from the query processing.
     * It will also cache the data for later usage.
     * @param  {DataResult} data
     * @param  {DataManager} ds?
     * @param  {Query} query?
     * @param  {XMLHttpRequest} xhr?
     * @param  {Object} request?
     * @returns DataResult
     */
    GraphQLAdaptor.prototype.processResponse = function (resData, ds, query, xhr, request) {
        var res = resData;
        var count;
        var aggregates;
        var result = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.schema.result, res.data);
        if (this.schema.count) {
            count = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.schema.count, res.data);
        }
        if (this.schema.aggregates) {
            aggregates = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.schema.aggregates, res.data);
            aggregates = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(aggregates) ? __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.parseJson(aggregates) : aggregates;
        }
        var pvt = request.pvtData || {};
        var args = { result: result, aggregates: aggregates };
        var data = args;
        if (pvt && pvt.groups && pvt.groups.length) {
            this.getAggregateResult(pvt, data, args, null, query);
        }
        return !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(count) ? { result: args.result, count: count, aggregates: aggregates } : args.result;
    };
    /**
     * Prepare and returns request body which is used to insert a new record in the table.
     */
    GraphQLAdaptor.prototype.insert = function () {
        var inserted = _super.prototype.insert.apply(this, arguments);
        return this.generateCrudData(inserted, 'insert');
    };
    /**
     * Prepare and returns request body which is used to update a new record in the table.
     */
    GraphQLAdaptor.prototype.update = function () {
        var inserted = _super.prototype.update.apply(this, arguments);
        return this.generateCrudData(inserted, 'update');
    };
    /**
     * Prepare and returns request body which is used to remove a new record in the table.
     */
    GraphQLAdaptor.prototype.remove = function () {
        var inserted = _super.prototype.remove.apply(this, arguments);
        return this.generateCrudData(inserted, 'remove');
    };
    /**
     * Prepare the request body based on the newly added, removed and updated records.
     * The result is used by the batch request.
     * @param  {DataManager} dm
     * @param  {CrudOptions} changes
     * @param  {Object} e
     * @param  {Query} query
     * @param  {Object} original
     */
    GraphQLAdaptor.prototype.batchRequest = function (dm, changes, e, query, original) {
        var batch = _super.prototype.batchRequest.apply(this, arguments);
        var bData = JSON.parse(batch.data);
        bData.key = e.key;
        batch.data = JSON.stringify(bData);
        return this.generateCrudData(batch, 'batch');
    };
    GraphQLAdaptor.prototype.generateCrudData = function (crudData, action) {
        var parsed = JSON.parse(crudData.data);
        crudData.data = JSON.stringify({
            query: this.opt.getMutation(action),
            variables: parsed
        });
        return crudData;
    };
    return GraphQLAdaptor;
}(UrlAdaptor));

/**
 * Cache Adaptor is used to cache the data of the visited pages. It prevents new requests for the previously visited pages.
 * You can configure cache page size and duration of caching by using cachingPageSize and timeTillExpiration properties of the DataManager
 * @hidden
 */
var CacheAdaptor = /** @class */ (function (_super) {
    __extends(CacheAdaptor, _super);
    /**
     * Constructor for CacheAdaptor class.
     * @param  {CacheAdaptor} adaptor?
     * @param  {number} timeStamp?
     * @param  {number} pageSize?
     * @hidden
     */
    function CacheAdaptor(adaptor, timeStamp, pageSize) {
        var _this = _super.call(this) || this;
        _this.isCrudAction = false;
        _this.isInsertAction = false;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(adaptor)) {
            _this.cacheAdaptor = adaptor;
        }
        _this.pageSize = pageSize;
        _this.guidId = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].getGuid('cacheAdaptor');
        var obj = { keys: [], results: [] };
        window.localStorage.setItem(_this.guidId, JSON.stringify(obj));
        var guid = _this.guidId;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(timeStamp)) {
            setInterval(function () {
                var data;
                data = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.parseJson(window.localStorage.getItem(guid));
                var forDel = [];
                for (var i = 0; i < data.results.length; i++) {
                    var currentTime = +new Date();
                    var requestTime = +new Date(data.results[i].timeStamp);
                    data.results[i].timeStamp = currentTime - requestTime;
                    if (currentTime - requestTime > timeStamp) {
                        forDel.push(i);
                    }
                }
                for (var i = 0; i < forDel.length; i++) {
                    data.results.splice(forDel[i], 1);
                    data.keys.splice(forDel[i], 1);
                }
                window.localStorage.removeItem(guid);
                window.localStorage.setItem(guid, JSON.stringify(data));
            }, timeStamp);
        }
        return _this;
    }
    /**
     * It will generate the key based on the URL when we send a request to server.
     * @param  {string} url
     * @param  {Query} query?
     * @hidden
     */
    CacheAdaptor.prototype.generateKey = function (url, query) {
        var queries = this.getQueryRequest(query);
        var singles = __WEBPACK_IMPORTED_MODULE_2__query__["b" /* Query */].filterQueryLists(query.queries, ['onSelect', 'onPage', 'onSkip', 'onTake', 'onRange']);
        var key = url;
        var page = 'onPage';
        if (page in singles) {
            key += singles[page].pageIndex;
        }
        queries.sorts.forEach(function (obj) {
            key += obj.e.direction + obj.e.fieldName;
        });
        queries.groups.forEach(function (obj) {
            key += obj.e.fieldName;
        });
        queries.searches.forEach(function (obj) {
            key += obj.e.searchKey;
        });
        for (var filter = 0; filter < queries.filters.length; filter++) {
            var currentFilter = queries.filters[filter];
            if (currentFilter.e.isComplex) {
                var newQuery = query.clone();
                newQuery.queries = [];
                for (var i = 0; i < currentFilter.e.predicates.length; i++) {
                    newQuery.queries.push({ fn: 'onWhere', e: currentFilter.e.predicates[i], filter: query.queries.filter });
                }
                key += currentFilter.e.condition + this.generateKey(url, newQuery);
            }
            else {
                key += currentFilter.e.field + currentFilter.e.operator + currentFilter.e.value;
            }
        }
        return key;
    };
    /**
     * Process the query to generate request body.
     * If the data is already cached, it will return the cached data.
     * @param  {DataManager} dm
     * @param  {Query} query?
     * @param  {Object[]} hierarchyFilters?
     */
    CacheAdaptor.prototype.processQuery = function (dm, query, hierarchyFilters) {
        var key = this.generateKey(dm.dataSource.url, query);
        var cachedItems;
        cachedItems = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.parseJson(window.localStorage.getItem(this.guidId));
        var data = cachedItems ? cachedItems.results[cachedItems.keys.indexOf(key)] : null;
        if (data != null && !this.isCrudAction && !this.isInsertAction) {
            return data;
        }
        this.isCrudAction = null;
        this.isInsertAction = null;
        return this.cacheAdaptor.processQuery.apply(this.cacheAdaptor, [].slice.call(arguments, 0));
    };
    /**
     * Returns the data from the query processing.
     * It will also cache the data for later usage.
     * @param  {DataResult} data
     * @param  {DataManager} ds?
     * @param  {Query} query?
     * @param  {XMLHttpRequest} xhr?
     * @param  {Ajax} request?
     * @param  {CrudOptions} changes?
     */
    CacheAdaptor.prototype.processResponse = function (data, ds, query, xhr, request, changes) {
        if (this.isInsertAction || (request && this.cacheAdaptor.options.batch &&
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].endsWith(request.url, this.cacheAdaptor.options.batch) && request.type.toLowerCase() === 'post')) {
            return this.cacheAdaptor.processResponse(data, ds, query, xhr, request, changes);
        }
        data = this.cacheAdaptor.processResponse.apply(this.cacheAdaptor, [].slice.call(arguments, 0));
        var key = query ? this.generateKey(ds.dataSource.url, query) : ds.dataSource.url;
        var obj = {};
        obj = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].parse.parseJson(window.localStorage.getItem(this.guidId));
        var index = obj.keys.indexOf(key);
        if (index !== -1) {
            obj.results.splice(index, 1);
            obj.keys.splice(index, 1);
        }
        obj.results[obj.keys.push(key) - 1] = { keys: key, result: data.result, timeStamp: new Date(), count: data.count };
        while (obj.results.length > this.pageSize) {
            obj.results.splice(0, 1);
            obj.keys.splice(0, 1);
        }
        window.localStorage.setItem(this.guidId, JSON.stringify(obj));
        return data;
    };
    /**
     * Method will trigger before send the request to server side. Used to set the custom header or modify the request options.
     * @param  {DataManager} dm
     * @param  {XMLHttpRequest} request
     * @param  {Ajax} settings?
     */
    CacheAdaptor.prototype.beforeSend = function (dm, request, settings) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.cacheAdaptor.options.batch) && __WEBPACK_IMPORTED_MODULE_1__util__["a" /* DataUtil */].endsWith(settings.url, this.cacheAdaptor.options.batch)
            && settings.type.toLowerCase() === 'post') {
            request.setRequestHeader('Accept', this.cacheAdaptor.options.multipartAccept);
        }
        if (!dm.dataSource.crossDomain) {
            request.setRequestHeader('Accept', this.cacheAdaptor.options.accept);
        }
    };
    /**
     * Updates existing record and saves the changes to the table.
     * @param  {DataManager} dm
     * @param  {string} keyField
     * @param  {Object} value
     * @param  {string} tableName
     */
    CacheAdaptor.prototype.update = function (dm, keyField, value, tableName) {
        this.isCrudAction = true;
        return this.cacheAdaptor.update(dm, keyField, value, tableName);
    };
    /**
     * Prepare and returns request body which is used to insert a new record in the table.
     * @param  {DataManager} dm
     * @param  {Object} data
     * @param  {string} tableName?
     */
    CacheAdaptor.prototype.insert = function (dm, data, tableName) {
        this.isInsertAction = true;
        return this.cacheAdaptor.insert(dm, data, tableName);
    };
    /**
     * Prepare and return request body which is used to remove record from the table.
     * @param  {DataManager} dm
     * @param  {string} keyField
     * @param  {Object} value
     * @param  {string} tableName?
     */
    CacheAdaptor.prototype.remove = function (dm, keyField, value, tableName) {
        this.isCrudAction = true;
        return this.cacheAdaptor.remove(dm, keyField, value, tableName);
    };
    /**
     * Prepare the request body based on the newly added, removed and updated records.
     * The result is used by the batch request.
     * @param  {DataManager} dm
     * @param  {CrudOptions} changes
     * @param  {RemoteArgs} e
     */
    CacheAdaptor.prototype.batchRequest = function (dm, changes, e) {
        return this.cacheAdaptor.batchRequest(dm, changes, e);
    };
    return CacheAdaptor;
}(UrlAdaptor));



/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Item */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toolbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_buttons__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_h_scroll__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_v_scroll__ = __webpack_require__(28);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */










var CLS_VERTICAL = 'e-vertical';
var CLS_ITEMS = 'e-toolbar-items';
var CLS_ITEM = 'e-toolbar-item';
var CLS_RTL = 'e-rtl';
var CLS_SEPARATOR = 'e-separator';
var CLS_POPUPICON = 'e-popup-up-icon';
var CLS_POPUPDOWN = 'e-popup-down-icon';
var CLS_POPUPOPEN = 'e-popup-open';
var CLS_TEMPLATE = 'e-template';
var CLS_DISABLE = 'e-overlay';
var CLS_POPUPTEXT = 'e-toolbar-text';
var CLS_TBARTEXT = 'e-popup-text';
var CLS_TBAROVERFLOW = 'e-overflow-show';
var CLS_POPOVERFLOW = 'e-overflow-hide';
var CLS_TBARBTN = 'e-tbar-btn';
var CLS_TBARNAV = 'e-hor-nav';
var CLS_TBARSCRLNAV = 'e-scroll-nav';
var CLS_TBARRIGHT = 'e-toolbar-right';
var CLS_TBARLEFT = 'e-toolbar-left';
var CLS_TBARCENTER = 'e-toolbar-center';
var CLS_TBARPOS = 'e-tbar-pos';
var CLS_HSCROLLCNT = 'e-hscroll-content';
var CLS_VSCROLLCNT = 'e-vscroll-content';
var CLS_HSCROLLBAR = 'e-hscroll-bar';
var CLS_POPUPNAV = 'e-hor-nav';
var CLS_POPUPCLASS = 'e-toolbar-pop';
var CLS_POPUP = 'e-toolbar-popup';
var CLS_TBARBTNTEXT = 'e-tbar-btn-text';
var CLS_TBARNAVACT = 'e-nav-active';
var CLS_TBARIGNORE = 'e-ignore';
var CLS_POPPRI = 'e-popup-alone';
var CLS_HIDDEN = 'e-hidden';
var CLS_MULTIROW = 'e-toolbar-multirow';
var CLS_MULTIROWPOS = 'e-multirow-pos';
var CLS_MULTIROW_SEPARATOR = 'e-multirow-separator';
var CLS_EXTENDABLE_SEPARATOR = 'e-extended-separator';
var CLS_EXTEANDABLE_TOOLBAR = 'e-extended-toolbar';
var CLS_EXTENDABLECLASS = 'e-toolbar-extended';
var CLS_EXTENDPOPUP = 'e-expended-nav';
var CLS_EXTENDEDPOPOPEN = 'e-tbar-extended';
/**
 * An item object that is used to configure Toolbar commands.
 */
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Item.prototype, "id", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Item.prototype, "text", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('auto')
    ], Item.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Item.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Item.prototype, "showAlwaysInPopup", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Item.prototype, "disabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Item.prototype, "prefixIcon", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Item.prototype, "suffixIcon", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Item.prototype, "visible", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('None')
    ], Item.prototype, "overflow", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Item.prototype, "template", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Button')
    ], Item.prototype, "type", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Both')
    ], Item.prototype, "showTextOn", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], Item.prototype, "htmlAttributes", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Item.prototype, "tooltipText", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Left')
    ], Item.prototype, "align", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Item.prototype, "click", void 0);
    return Item;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * The Toolbar control contains a group of commands that are aligned horizontally.
 * ```html
 * <div id="toolbar"/>
 * <script>
 *   var toolbarObj = new Toolbar();
 *   toolbarObj.appendTo("#toolbar");
 * </script>
 * ```
 */
var Toolbar = /** @class */ (function (_super) {
    __extends(Toolbar, _super);
    /**
     * Initializes a new instance of the Toolbar class.
     *
     * @param {ToolbarModel} options  - Specifies Toolbar model properties as options.
     * @param { string | HTMLElement} element  - Specifies the element that is rendered as a Toolbar.
     */
    function Toolbar(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.resizeContext = _this.resize.bind(_this);
        /**
         * Contains the keyboard configuration of the Toolbar.
         */
        _this.keyConfigs = {
            moveLeft: 'leftarrow',
            moveRight: 'rightarrow',
            moveUp: 'uparrow',
            moveDown: 'downarrow',
            popupOpen: 'enter',
            popupClose: 'escape',
            tab: 'tab',
            home: 'home',
            end: 'end'
        };
        return _this;
    }
    /**
     * Removes the control from the DOM and also removes all its related events.
     *
     * @returns {void}.
     */
    Toolbar.prototype.destroy = function () {
        var _this = this;
        if (this.isReact || this.isAngular) {
            this.clearTemplate();
        }
        var btnItems = this.element.querySelectorAll('.e-control.e-btn');
        [].slice.call(btnItems).forEach(function (el) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(el) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(el.ej2_instances) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(el.ej2_instances[0]) && !(el.ej2_instances[0].isDestroyed)) {
                el.ej2_instances[0].destroy();
            }
        });
        this.unwireEvents();
        this.tempId.forEach(function (ele) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(_this.element.querySelector(ele))) {
                document.body.appendChild(_this.element.querySelector(ele)).style.display = 'none';
            }
        });
        this.destroyItems();
        while (this.element.lastElementChild) {
            this.element.removeChild(this.element.lastElementChild);
        }
        if (this.trgtEle) {
            this.element.appendChild(this.ctrlTem);
            this.trgtEle = null;
            this.ctrlTem = null;
        }
        if (this.popObj) {
            this.popObj.destroy();
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.popObj.element);
        }
        if (this.activeEle) {
            this.activeEle = null;
        }
        this.popObj = null;
        this.tbarAlign = null;
        this.tbarItemsCol = [];
        this.remove(this.element, 'e-toolpop');
        if (this.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], this.cssClass.split(' '));
        }
        this.element.removeAttribute('style');
        ['aria-disabled', 'aria-orientation', 'aria-haspopup', 'role'].forEach(function (attrb) {
            return _this.element.removeAttribute(attrb);
        });
        _super.prototype.destroy.call(this);
    };
    /**
     * Initialize the event handler
     *
     * @private
     * @returns {void}
     */
    Toolbar.prototype.preRender = function () {
        var eventArgs = { enableCollision: this.enableCollision, scrollStep: this.scrollStep };
        this.trigger('beforeCreate', eventArgs);
        this.enableCollision = eventArgs.enableCollision;
        this.scrollStep = eventArgs.scrollStep;
        this.scrollModule = null;
        this.popObj = null;
        this.tempId = [];
        this.tbarItemsCol = this.items;
        this.isVertical = this.element.classList.contains(CLS_VERTICAL) ? true : false;
        this.isExtendedOpen = false;
        this.popupPriCount = 0;
        if (this.enableRtl) {
            this.add(this.element, CLS_RTL);
        }
    };
    Toolbar.prototype.wireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'click', this.clickHandler, this);
        window.addEventListener('resize', this.resizeContext);
        if (this.allowKeyboard) {
            this.wireKeyboardEvent();
        }
    };
    Toolbar.prototype.wireKeyboardEvent = function () {
        this.keyModule = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["n" /* KeyboardEvents */](this.element, {
            keyAction: this.keyActionHandler.bind(this),
            keyConfigs: this.keyConfigs
        });
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'keydown', this.docKeyDown, this);
        this.element.setAttribute('tabIndex', '0');
    };
    Toolbar.prototype.unwireKeyboardEvent = function () {
        if (this.keyModule) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'keydown', this.docKeyDown);
            this.keyModule.destroy();
            this.keyModule = null;
        }
    };
    Toolbar.prototype.docKeyDown = function (e) {
        if (e.target.tagName === 'INPUT') {
            return;
        }
        var popCheck = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.popObj) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(this.popObj.element) && this.overflowMode !== 'Extended';
        if (e.keyCode === 9 && e.target.classList.contains('e-hor-nav') === true && popCheck) {
            this.popObj.hide({ name: 'FadeOut', duration: 100 });
        }
        var keyCheck = (e.keyCode === 40 || e.keyCode === 38 || e.keyCode === 35 || e.keyCode === 36);
        if (keyCheck) {
            e.preventDefault();
        }
    };
    Toolbar.prototype.unwireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'click', this.clickHandler);
        this.destroyScroll();
        this.unwireKeyboardEvent();
        window.removeEventListener('resize', this.resizeContext);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'scroll', this.docEvent);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'click', this.docEvent);
    };
    Toolbar.prototype.clearProperty = function () {
        this.tbarEle = [];
        this.tbarAlgEle = { lefts: [], centers: [], rights: [] };
    };
    Toolbar.prototype.docEvent = function (e) {
        var popEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.e-popup');
        if (this.popObj && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(this.popObj.element) && !popEle && this.overflowMode === 'Popup') {
            this.popObj.hide({ name: 'FadeOut', duration: 100 });
        }
    };
    Toolbar.prototype.destroyScroll = function () {
        if (this.scrollModule) {
            if (this.tbarAlign) {
                this.add(this.scrollModule.element, CLS_TBARPOS);
            }
            this.scrollModule.destroy();
            this.scrollModule = null;
        }
    };
    Toolbar.prototype.destroyItems = function () {
        if (this.element) {
            [].slice.call(this.element.querySelectorAll('.' + CLS_ITEM)).forEach(function (el) { Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(el); });
        }
        if (this.tbarAlign) {
            var tbarItems = this.element.querySelector('.' + CLS_ITEMS);
            [].slice.call(tbarItems.children).forEach(function (el) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(el);
            });
            this.tbarAlign = false;
            this.remove(tbarItems, CLS_TBARPOS);
        }
        this.clearProperty();
    };
    Toolbar.prototype.destroyMode = function () {
        if (this.scrollModule) {
            this.remove(this.scrollModule.element, CLS_RTL);
            this.destroyScroll();
        }
        this.remove(this.element, CLS_EXTENDEDPOPOPEN);
        this.remove(this.element, CLS_EXTEANDABLE_TOOLBAR);
        var tempEle = this.element.querySelector('.e-toolbar-multirow');
        if (tempEle) {
            this.remove(tempEle, CLS_MULTIROW);
        }
        if (this.popObj) {
            this.popupRefresh(this.popObj.element, true);
        }
    };
    Toolbar.prototype.add = function (ele, val) {
        ele.classList.add(val);
    };
    Toolbar.prototype.remove = function (ele, val) {
        ele.classList.remove(val);
    };
    Toolbar.prototype.elementFocus = function (ele) {
        var fChild = ele.firstElementChild;
        if (fChild) {
            fChild.focus();
            this.activeEleSwitch(ele);
        }
        else {
            ele.focus();
        }
    };
    Toolbar.prototype.clstElement = function (tbrNavChk, trgt) {
        var clst;
        if (tbrNavChk && this.popObj && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(this.popObj.element)) {
            clst = this.popObj.element.querySelector('.' + CLS_ITEM);
        }
        else if (this.element === trgt || tbrNavChk) {
            clst = this.element.querySelector('.' + CLS_ITEM + ':not(.' + CLS_DISABLE + ' ):not(.' + CLS_SEPARATOR + ' ):not(.' + CLS_HIDDEN + ' )');
        }
        else {
            clst = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '.' + CLS_ITEM);
        }
        return clst;
    };
    Toolbar.prototype.keyHandling = function (clst, e, trgt, navChk, scrollChk) {
        var popObj = this.popObj;
        var rootEle = this.element;
        var popAnimate = { name: 'FadeOut', duration: 100 };
        var value = e.action === 'moveUp' ? 'previous' : 'next';
        var ele;
        var nodes;
        switch (e.action) {
            case 'moveRight':
                if (this.isVertical) {
                    return;
                }
                if (rootEle === trgt) {
                    this.elementFocus(clst);
                }
                else if (!navChk) {
                    this.eleFocus(clst, 'next');
                }
                break;
            case 'moveLeft':
                if (this.isVertical) {
                    return;
                }
                if (!navChk) {
                    this.eleFocus(clst, 'previous');
                }
                break;
            case 'home':
            case 'end':
                if (clst) {
                    var popupCheck = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(clst, '.e-popup');
                    var extendedPopup = this.element.querySelector('.' + CLS_EXTENDABLECLASS);
                    if (this.overflowMode === 'Extended' && extendedPopup && extendedPopup.classList.contains('e-popup-open')) {
                        popupCheck = e.action === 'end' ? extendedPopup : null;
                    }
                    if (popupCheck) {
                        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(this.popObj.element)) {
                            nodes = [].slice.call(popupCheck.children);
                            if (e.action === 'home') {
                                ele = nodes[0];
                            }
                            else {
                                ele = nodes[nodes.length - 1];
                            }
                        }
                    }
                    else {
                        nodes = this.element.querySelectorAll('.' + CLS_ITEMS + ' .' + CLS_ITEM + ':not(.' + CLS_SEPARATOR + ')');
                        if (e.action === 'home') {
                            ele = nodes[0];
                        }
                        else {
                            ele = nodes[nodes.length - 1];
                        }
                    }
                    if (ele) {
                        this.elementFocus(ele);
                    }
                }
                break;
            case 'moveUp':
            case 'moveDown':
                if (!this.isVertical) {
                    if (popObj && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '.e-popup')) {
                        var popEle = popObj.element;
                        var popFrstEle = popEle.firstElementChild;
                        if ((value === 'previous' && popFrstEle === clst) || (value === 'next' && popEle.lastElementChild === clst)) {
                            return;
                        }
                        else {
                            this.eleFocus(clst, value);
                        }
                    }
                    else if (e.action === 'moveDown' && popObj && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(popObj.element)) {
                        this.elementFocus(clst);
                    }
                }
                else {
                    if (e.action === 'moveUp') {
                        this.eleFocus(clst, 'previous');
                    }
                    else {
                        this.eleFocus(clst, 'next');
                    }
                }
                break;
            case 'tab':
                if (!scrollChk && !navChk) {
                    var ele_1 = clst.firstElementChild;
                    if (rootEle === trgt) {
                        if (this.activeEle) {
                            this.activeEle.focus();
                        }
                        else {
                            this.activeEleRemove(ele_1);
                            ele_1.focus();
                        }
                        this.element.removeAttribute('tabindex');
                    }
                }
                break;
            case 'popupClose':
                if (popObj && this.overflowMode !== 'Extended') {
                    popObj.hide(popAnimate);
                }
                break;
            case 'popupOpen':
                if (!navChk) {
                    return;
                }
                if (popObj && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(popObj.element)) {
                    popObj.element.style.top = rootEle.offsetHeight + 'px';
                    popObj.show({ name: 'FadeIn', duration: 100 });
                }
                else {
                    popObj.hide(popAnimate);
                }
                break;
        }
    };
    Toolbar.prototype.keyActionHandler = function (e) {
        var trgt = e.target;
        if (trgt.tagName === 'INPUT' || trgt.tagName === 'TEXTAREA' || this.element.classList.contains(CLS_DISABLE)) {
            return;
        }
        e.preventDefault();
        var tbrNavChk = trgt.classList.contains(CLS_TBARNAV);
        var tbarScrollChk = trgt.classList.contains(CLS_TBARSCRLNAV);
        var clst = this.clstElement(tbrNavChk, trgt);
        if (clst || tbarScrollChk) {
            this.keyHandling(clst, e, trgt, tbrNavChk, tbarScrollChk);
        }
    };
    /**
     * Specifies the value to disable/enable the Toolbar component.
     * When set to `true`, the component will be disabled.
     *
     * @param  {boolean} value - Based on this Boolean value, Toolbar will be enabled (false) or disabled (true).
     * @returns {void}.
     */
    Toolbar.prototype.disable = function (value) {
        var rootEle = this.element;
        if (value) {
            rootEle.classList.add(CLS_DISABLE);
        }
        else {
            rootEle.classList.remove(CLS_DISABLE);
        }
        rootEle.setAttribute('tabindex', !value ? '0' : '-1');
        if (this.activeEle) {
            this.activeEle.setAttribute('tabindex', !value ? '0' : '-1');
        }
        if (this.scrollModule) {
            this.scrollModule.disable(value);
        }
        if (this.popObj) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(this.popObj.element) && this.overflowMode !== 'Extended') {
                this.popObj.hide();
            }
            rootEle.querySelector('#' + rootEle.id + '_nav').setAttribute('tabindex', !value ? '0' : '-1');
        }
    };
    Toolbar.prototype.eleContains = function (el) {
        return el.classList.contains(CLS_SEPARATOR) || el.classList.contains(CLS_DISABLE) || el.getAttribute('disabled') || el.classList.contains(CLS_HIDDEN) || !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(el);
    };
    Toolbar.prototype.eleFocus = function (closest, pos) {
        var sib = Object(closest)[pos + 'ElementSibling'];
        if (sib) {
            var skipEle = this.eleContains(sib);
            if (skipEle) {
                this.eleFocus(sib, pos);
                return;
            }
            this.elementFocus(sib);
        }
        else if (this.tbarAlign) {
            var elem = Object(closest.parentElement)[pos + 'ElementSibling'];
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(elem) && elem.children.length === 0) {
                elem = Object(elem)[pos + 'ElementSibling'];
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(elem) && elem.children.length > 0) {
                if (pos === 'next') {
                    var el = elem.querySelector('.' + CLS_ITEM);
                    if (this.eleContains(el)) {
                        this.eleFocus(el, pos);
                    }
                    else {
                        el.firstElementChild.focus();
                        this.activeEleSwitch(el);
                    }
                }
                else {
                    var el = elem.lastElementChild;
                    if (this.eleContains(el)) {
                        this.eleFocus(el, pos);
                    }
                    else {
                        this.elementFocus(el);
                    }
                }
            }
        }
    };
    Toolbar.prototype.clickHandler = function (e) {
        var _this = this;
        var trgt = e.target;
        var ele = this.element;
        var isPopupElement = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '.' + CLS_POPUPCLASS));
        var clsList = trgt.classList;
        var popupNav = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, ('.' + CLS_TBARNAV));
        if (!popupNav) {
            popupNav = trgt;
        }
        if (!ele.children[0].classList.contains('e-hscroll') && !ele.children[0].classList.contains('e-vscroll')
            && (clsList.contains(CLS_TBARNAV))) {
            clsList = trgt.querySelector('.e-icons').classList;
        }
        if (clsList.contains(CLS_POPUPICON) || clsList.contains(CLS_POPUPDOWN)) {
            this.popupClickHandler(ele, popupNav, CLS_RTL);
        }
        var itemObj;
        var clst = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.' + CLS_ITEM);
        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(clst) || clst.classList.contains(CLS_DISABLE)) && !popupNav.classList.contains(CLS_TBARNAV)) {
            return;
        }
        if (clst) {
            var tempItem = this.items[this.tbarEle.indexOf(clst)];
            itemObj = tempItem;
        }
        var eventArgs = { originalEvent: e, item: itemObj };
        if (itemObj && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(itemObj.click)) {
            this.trigger('items[' + this.tbarEle.indexOf(clst) + '].click', eventArgs);
        }
        if (!eventArgs.cancel) {
            this.trigger('clicked', eventArgs, function (clickedArgs) {
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(_this.popObj) && isPopupElement && !clickedArgs.cancel && _this.overflowMode === 'Popup' &&
                    clickedArgs.item && clickedArgs.item.type !== 'Input') {
                    _this.popObj.hide({ name: 'FadeOut', duration: 100 });
                }
            });
        }
    };
    Toolbar.prototype.popupClickHandler = function (ele, popupNav, CLS_RTL) {
        var popObj = this.popObj;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(popObj.element)) {
            popupNav.classList.remove(CLS_TBARNAVACT);
            popObj.hide({ name: 'FadeOut', duration: 100 });
        }
        else {
            if (ele.classList.contains(CLS_RTL)) {
                popObj.enableRtl = true;
                popObj.position = { X: 'left', Y: 'top' };
            }
            if (popObj.offsetX === 0 && !ele.classList.contains(CLS_RTL)) {
                popObj.enableRtl = false;
                popObj.position = { X: 'right', Y: 'top' };
            }
            popObj.dataBind();
            popObj.refreshPosition();
            popObj.element.style.top = this.getElementOffsetY() + 'px';
            if (this.overflowMode === 'Extended') {
                popObj.element.style.minHeight = '0px';
            }
            popupNav.classList.add(CLS_TBARNAVACT);
            popObj.show({ name: 'FadeIn', duration: 100 });
        }
    };
    /**
     * To Initialize the control rendering
     *
     * @private
     * @returns {void}
     */
    Toolbar.prototype.render = function () {
        this.initialize();
        this.renderControl();
        this.wireEvents();
        this.renderComplete();
    };
    Toolbar.prototype.initialize = function () {
        var width = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.width);
        var height = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.height);
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name !== 'msie' || this.height !== 'auto' || this.overflowMode === 'MultiRow') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'height': height });
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'width': width });
        var ariaAttr = {
            'role': 'toolbar', 'aria-disabled': 'false', 'aria-haspopup': 'false',
            'aria-orientation': !this.isVertical ? 'horizontal' : 'vertical'
        };
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, ariaAttr);
        if (this.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], this.cssClass.split(' '));
        }
    };
    Toolbar.prototype.renderControl = function () {
        var ele = this.element;
        this.trgtEle = (ele.children.length > 0) ? ele.querySelector('div') : null;
        this.tbarAlgEle = { lefts: [], centers: [], rights: [] };
        this.renderItems();
        this.renderLayout();
    };
    Toolbar.prototype.renderLayout = function () {
        this.renderOverflowMode();
        if (this.tbarAlign) {
            this.itemPositioning();
        }
        if (this.popObj && this.popObj.element.childElementCount > 1 && this.checkPopupRefresh(this.element, this.popObj.element)) {
            this.popupRefresh(this.popObj.element, false);
        }
        this.separator();
    };
    Toolbar.prototype.itemsAlign = function (items, itemEleDom) {
        var innerItem;
        var innerPos;
        if (!this.tbarEle) {
            this.tbarEle = [];
        }
        for (var i = 0; i < items.length; i++) {
            innerItem = this.renderSubComponent(items[i], i);
            if (this.tbarEle.indexOf(innerItem) === -1) {
                this.tbarEle.push(innerItem);
            }
            if (!this.tbarAlign) {
                this.tbarItemAlign(items[i], itemEleDom, i);
            }
            innerPos = itemEleDom.querySelector('.e-toolbar-' + items[i].align.toLowerCase());
            if (innerPos) {
                if (!(items[i].showAlwaysInPopup && items[i].overflow !== 'Show')) {
                    this.tbarAlgEle[(items[i].align + 's').toLowerCase()].push(innerItem);
                }
                innerPos.appendChild(innerItem);
            }
            else {
                itemEleDom.appendChild(innerItem);
            }
        }
        if (this.isReact) {
            var portals = 'portals';
            this.notify('render-react-toolbar-template', this[portals]);
            this.renderReactTemplates();
        }
    };
    /**
     * @hidden
     * @returns {void}
     */
    Toolbar.prototype.changeOrientation = function () {
        var ele = this.element;
        if (this.isVertical) {
            ele.classList.remove(CLS_VERTICAL);
            this.isVertical = false;
            if (this.height === 'auto' || this.height === '100%') {
                ele.style.height = this.height;
            }
            ele.setAttribute('aria-orientation', 'horizontal');
        }
        else {
            ele.classList.add(CLS_VERTICAL);
            this.isVertical = true;
            ele.setAttribute('aria-orientation', 'vertical');
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'height': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.height), 'width': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.width) });
        }
        this.destroyMode();
        this.refreshOverflow();
    };
    Toolbar.prototype.initScroll = function (element, innerItems) {
        if (!this.scrollModule && this.checkOverflow(element, innerItems[0])) {
            if (this.tbarAlign) {
                this.element.querySelector('.' + CLS_ITEMS + ' .' + CLS_TBARCENTER).removeAttribute('style');
            }
            if (this.isVertical) {
                this.scrollModule = new __WEBPACK_IMPORTED_MODULE_4__common_v_scroll__["a" /* VScroll */]({ scrollStep: this.scrollStep, enableRtl: this.enableRtl }, innerItems[0]);
            }
            else {
                this.scrollModule = new __WEBPACK_IMPORTED_MODULE_3__common_h_scroll__["a" /* HScroll */]({ scrollStep: this.scrollStep, enableRtl: this.enableRtl }, innerItems[0]);
            }
            this.remove(this.scrollModule.element, CLS_TBARPOS);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { overflow: 'hidden' });
        }
    };
    Toolbar.prototype.itemWidthCal = function (items) {
        var _this = this;
        var width = 0;
        var style;
        [].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_ITEM, items)).forEach(function (el) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(el)) {
                style = window.getComputedStyle(el);
                width += _this.isVertical ? el.offsetHeight : el.offsetWidth;
                width += parseFloat(_this.isVertical ? style.marginTop : style.marginRight);
                width += parseFloat(_this.isVertical ? style.marginBottom : style.marginLeft);
            }
        });
        return width;
    };
    Toolbar.prototype.getScrollCntEle = function (innerItem) {
        var trgClass = (this.isVertical) ? '.e-vscroll-content' : '.e-hscroll-content';
        return innerItem.querySelector(trgClass);
    };
    Toolbar.prototype.checkOverflow = function (element, innerItem) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(element) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(innerItem) || !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(element)) {
            return false;
        }
        var eleWidth = this.isVertical ? element.offsetHeight : element.offsetWidth;
        var itemWidth = this.isVertical ? innerItem.offsetHeight : innerItem.offsetWidth;
        if (this.tbarAlign || this.scrollModule || (eleWidth === itemWidth)) {
            itemWidth = this.itemWidthCal(this.scrollModule ? this.getScrollCntEle(innerItem) : innerItem);
        }
        var popNav = element.querySelector('.' + CLS_TBARNAV);
        var scrollNav = element.querySelector('.' + CLS_TBARSCRLNAV);
        var navEleWidth = 0;
        if (popNav) {
            navEleWidth = this.isVertical ? popNav.offsetHeight : popNav.offsetWidth;
        }
        else if (scrollNav) {
            navEleWidth = this.isVertical ? (scrollNav.offsetHeight * (2)) : (scrollNav.offsetWidth * 2);
        }
        if (itemWidth > eleWidth - navEleWidth) {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Refresh the whole Toolbar component without re-rendering.
     * - It is used to manually refresh the Toolbar overflow modes such as scrollable, popup, multi row, and extended.
     * - It will refresh the Toolbar component after loading items dynamically.
     *
     * @returns {void}.
     */
    Toolbar.prototype.refreshOverflow = function () {
        this.resize();
    };
    Toolbar.prototype.toolbarAlign = function (innerItems) {
        if (this.tbarAlign) {
            this.add(innerItems, CLS_TBARPOS);
            this.itemPositioning();
        }
    };
    Toolbar.prototype.renderOverflowMode = function () {
        var ele = this.element;
        var innerItems = ele.querySelector('.' + CLS_ITEMS);
        var priorityCheck = this.popupPriCount > 0;
        if (ele && ele.children.length > 0) {
            this.offsetWid = ele.offsetWidth;
            this.remove(this.element, 'e-toolpop');
            if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name === 'msie' && this.height === 'auto') {
                ele.style.height = '';
            }
            switch (this.overflowMode) {
                case 'Scrollable':
                    if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.scrollModule)) {
                        this.initScroll(ele, [].slice.call(ele.getElementsByClassName(CLS_ITEMS)));
                    }
                    break;
                case 'Popup':
                    this.add(this.element, 'e-toolpop');
                    if (this.tbarAlign) {
                        this.removePositioning();
                    }
                    if (this.checkOverflow(ele, innerItems) || priorityCheck) {
                        this.setOverflowAttributes(ele);
                    }
                    this.toolbarAlign(innerItems);
                    break;
                case 'MultiRow':
                    this.add(innerItems, CLS_MULTIROW);
                    if (this.checkOverflow(ele, innerItems) && this.tbarAlign) {
                        this.removePositioning();
                        this.add(innerItems, CLS_MULTIROWPOS);
                    }
                    if (ele.style.overflow === 'hidden') {
                        ele.style.overflow = '';
                    }
                    if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name === 'msie' || ele.style.height !== 'auto') {
                        ele.style.height = 'auto';
                    }
                    break;
                case 'Extended':
                    this.add(this.element, CLS_EXTEANDABLE_TOOLBAR);
                    if (this.checkOverflow(ele, innerItems) || priorityCheck) {
                        if (this.tbarAlign) {
                            this.removePositioning();
                        }
                        this.setOverflowAttributes(ele);
                    }
                    this.toolbarAlign(innerItems);
            }
        }
    };
    Toolbar.prototype.setOverflowAttributes = function (ele) {
        this.createPopupEle(ele, [].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_ITEMS + ' .' + CLS_ITEM, ele)));
        this.element.querySelector('.' + CLS_TBARNAV).setAttribute('tabIndex', '0');
        this.element.querySelector('.' + CLS_TBARNAV).setAttribute('role', 'list');
    };
    Toolbar.prototype.separator = function () {
        var element = this.element;
        var eleItem = [].slice.call(element.querySelectorAll('.' + CLS_SEPARATOR));
        var multiVar = element.querySelector('.' + CLS_MULTIROW_SEPARATOR);
        var extendVar = element.querySelector('.' + CLS_EXTENDABLE_SEPARATOR);
        var eleInlineItem = this.overflowMode === 'MultiRow' ? multiVar : extendVar;
        if (eleInlineItem !== null) {
            if (this.overflowMode === 'MultiRow') {
                eleInlineItem.classList.remove(CLS_MULTIROW_SEPARATOR);
            }
            else if (this.overflowMode === 'Extended') {
                eleInlineItem.classList.remove(CLS_EXTENDABLE_SEPARATOR);
            }
        }
        for (var i = 0; i <= eleItem.length - 1; i++) {
            if (eleItem[i].offsetLeft < 30 && eleItem[i].offsetLeft !== 0) {
                if (this.overflowMode === 'MultiRow') {
                    eleItem[i].classList.add(CLS_MULTIROW_SEPARATOR);
                }
                else if (this.overflowMode === 'Extended') {
                    eleItem[i].classList.add(CLS_EXTENDABLE_SEPARATOR);
                }
            }
        }
    };
    Toolbar.prototype.createPopupEle = function (ele, innerEle) {
        var innerNav = ele.querySelector('.' + CLS_TBARNAV);
        var vertical = this.isVertical;
        if (!innerNav) {
            this.createPopupIcon(ele);
        }
        innerNav = ele.querySelector('.' + CLS_TBARNAV);
        var innerNavDom = (vertical ? innerNav.offsetHeight : innerNav.offsetWidth);
        var eleWidth = ((vertical ? ele.offsetHeight : ele.offsetWidth) - (innerNavDom));
        this.element.classList.remove('e-rtl');
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { direction: 'initial' });
        this.checkPriority(ele, innerEle, eleWidth, true);
        if (this.enableRtl) {
            this.element.classList.add('e-rtl');
        }
        this.element.style.removeProperty('direction');
        this.createPopup();
    };
    Toolbar.prototype.pushingPoppedEle = function (tbarObj, popupPri, ele, eleHeight, sepHeight) {
        var element = tbarObj.element;
        var poppedEle = [].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_POPUP, element.querySelector('.' + CLS_ITEMS)));
        var nodes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TBAROVERFLOW, ele);
        var nodeIndex = 0;
        var nodePri = 0;
        poppedEle.forEach(function (el, index) {
            nodes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TBAROVERFLOW, ele);
            if (el.classList.contains(CLS_TBAROVERFLOW) && nodes.length > 0) {
                if (tbarObj.tbResize && nodes.length > index) {
                    ele.insertBefore(el, nodes[index]);
                    ++nodePri;
                }
                else {
                    ele.insertBefore(el, ele.children[nodes.length]);
                    ++nodePri;
                }
            }
            else if (el.classList.contains(CLS_TBAROVERFLOW)) {
                ele.insertBefore(el, ele.firstChild);
                ++nodePri;
            }
            else if (tbarObj.tbResize && el.classList.contains(CLS_POPOVERFLOW) && ele.children.length > 0 && nodes.length === 0) {
                ele.insertBefore(el, ele.firstChild);
                ++nodePri;
            }
            else if (el.classList.contains(CLS_POPOVERFLOW)) {
                popupPri.push(el);
            }
            else if (tbarObj.tbResize) {
                ele.insertBefore(el, ele.childNodes[nodeIndex + nodePri]);
                ++nodeIndex;
            }
            else {
                ele.appendChild(el);
            }
            if (el.classList.contains(CLS_SEPARATOR)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(el, { display: '', height: sepHeight + 'px' });
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(el, { display: '', height: eleHeight + 'px' });
            }
        });
        popupPri.forEach(function (el) {
            ele.appendChild(el);
        });
        var tbarEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_ITEM, element.querySelector('.' + CLS_ITEMS));
        for (var i = tbarEle.length - 1; i >= 0; i--) {
            var tbarElement = tbarEle[i];
            if (tbarElement.classList.contains(CLS_SEPARATOR) && this.overflowMode !== 'Extended') {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(tbarElement, { display: 'none' });
            }
            else {
                break;
            }
        }
    };
    Toolbar.prototype.createPopup = function () {
        var element = this.element;
        var sepHeight;
        var sepItem;
        if (this.overflowMode === 'Extended') {
            sepItem = element.querySelector('.' + CLS_SEPARATOR + ':not(.' + CLS_POPUP + ')');
            sepHeight = (element.style.height === 'auto' || element.style.height === '') ? null : sepItem.offsetHeight;
        }
        var eleItem = element.querySelector('.' + CLS_ITEM + ':not(.' + CLS_SEPARATOR + '):not(.' + CLS_POPUP + ')');
        var eleHeight = (element.style.height === 'auto' || element.style.height === '') ? null : (eleItem && eleItem.offsetHeight);
        var ele;
        var popupPri = [];
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('#' + element.id + '_popup.' + CLS_POPUPCLASS, element)) {
            ele = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('#' + element.id + '_popup.' + CLS_POPUPCLASS, element);
        }
        else {
            var extendEle = this.createElement('div', {
                id: element.id + '_popup', className: CLS_POPUPCLASS + ' ' + CLS_EXTENDABLECLASS
            });
            var popupEle = this.createElement('div', { id: element.id + '_popup', className: CLS_POPUPCLASS });
            ele = this.overflowMode === 'Extended' ? extendEle : popupEle;
        }
        this.pushingPoppedEle(this, popupPri, ele, eleHeight, sepHeight);
        this.popupInit(element, ele);
    };
    Toolbar.prototype.getElementOffsetY = function () {
        return (this.overflowMode === 'Extended' && window.getComputedStyle(this.element).getPropertyValue('box-sizing') === 'border-box' ?
            this.element.clientHeight : this.element.offsetHeight);
    };
    Toolbar.prototype.popupInit = function (element, ele) {
        if (!this.popObj) {
            element.appendChild(ele);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { overflow: '' });
            var eleStyles = window.getComputedStyle(this.element);
            var popup = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__["a" /* Popup */](null, {
                relateTo: this.element,
                offsetY: (this.isVertical) ? 0 : this.getElementOffsetY(),
                enableRtl: this.enableRtl,
                open: this.popupOpen.bind(this),
                close: this.popupClose.bind(this),
                collision: { Y: this.enableCollision ? 'flip' : 'none' },
                position: this.enableRtl ? { X: 'left', Y: 'top' } : { X: 'right', Y: 'top' }
            });
            popup.appendTo(ele);
            if (this.overflowMode === 'Extended') {
                popup.width = parseFloat(eleStyles.width) + ((parseFloat(eleStyles.borderRightWidth)) * 2);
                popup.offsetX = 0;
            }
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'scroll', this.docEvent.bind(this));
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'click ', this.docEvent.bind(this));
            popup.element.style.maxHeight = popup.element.offsetHeight + 'px';
            if (this.isVertical) {
                popup.element.style.visibility = 'hidden';
            }
            if (this.isExtendedOpen) {
                var popupNav = this.element.querySelector('.' + CLS_TBARNAV);
                popupNav.classList.add(CLS_TBARNAVACT);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["x" /* classList */])(popupNav.firstElementChild, [CLS_POPUPICON], [CLS_POPUPDOWN]);
                this.element.querySelector('.' + CLS_EXTENDABLECLASS).classList.add(CLS_POPUPOPEN);
            }
            else {
                popup.hide();
            }
            this.popObj = popup;
            this.element.setAttribute('aria-haspopup', 'true');
        }
        else {
            var popupEle = this.popObj.element;
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(popupEle, { maxHeight: '', display: 'block' });
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(popupEle, { maxHeight: popupEle.offsetHeight + 'px', display: '' });
        }
    };
    Toolbar.prototype.tbarPopupHandler = function (isOpen) {
        if (this.overflowMode === 'Extended') {
            if (isOpen) {
                this.add(this.element, CLS_EXTENDEDPOPOPEN);
            }
            else {
                this.remove(this.element, CLS_EXTENDEDPOPOPEN);
            }
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Toolbar.prototype.popupOpen = function (e) {
        var popObj = this.popObj;
        if (!this.isVertical) {
            popObj.offsetY = this.getElementOffsetY();
            popObj.dataBind();
        }
        var popupEle = this.popObj.element;
        var toolEle = this.popObj.element.parentElement;
        var popupNav = toolEle.querySelector('.' + CLS_TBARNAV);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(popObj.element, { height: 'auto', maxHeight: '' });
        popObj.element.style.maxHeight = popObj.element.offsetHeight + 'px';
        if (this.overflowMode === 'Extended') {
            popObj.element.style.minHeight = '';
        }
        var popupElePos = popupEle.offsetTop + popupEle.offsetHeight + Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__["c" /* calculatePosition */])(toolEle).top;
        var popIcon = popupNav.firstElementChild;
        popupNav.classList.add(CLS_TBARNAVACT);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["x" /* classList */])(popIcon, [CLS_POPUPICON], [CLS_POPUPDOWN]);
        this.tbarPopupHandler(true);
        var scrollVal = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(window.scrollY) ? 0 : window.scrollY;
        if (!this.isVertical && ((window.innerHeight + scrollVal) < popupElePos) && (this.element.offsetTop < popupEle.offsetHeight)) {
            var overflowHeight = (popupEle.offsetHeight - ((popupElePos - window.innerHeight - scrollVal) + 5));
            popObj.height = overflowHeight + 'px';
            for (var i = 0; i <= popupEle.childElementCount; i++) {
                var ele = popupEle.children[i];
                if (ele.offsetTop + ele.offsetHeight > overflowHeight) {
                    overflowHeight = ele.offsetTop;
                    break;
                }
            }
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(popObj.element, { maxHeight: overflowHeight + 'px' });
        }
        else if (this.isVertical) {
            var tbEleData = this.element.getBoundingClientRect();
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(popObj.element, { maxHeight: (tbEleData.top + this.element.offsetHeight) + 'px', bottom: 0, visibility: '' });
        }
        if (popObj) {
            var popupOffset = popupEle.getBoundingClientRect();
            if (popupOffset.right > document.documentElement.clientWidth && popupOffset.width > toolEle.getBoundingClientRect().width) {
                popObj.collision = { Y: 'none' };
                popObj.dataBind();
            }
            popObj.refreshPosition();
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Toolbar.prototype.popupClose = function (e) {
        var element = this.element;
        var popupNav = element.querySelector('.' + CLS_TBARNAV);
        var popIcon = popupNav.firstElementChild;
        popupNav.classList.remove(CLS_TBARNAVACT);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["x" /* classList */])(popIcon, [CLS_POPUPDOWN], [CLS_POPUPICON]);
        this.tbarPopupHandler(false);
    };
    Toolbar.prototype.checkPriority = function (ele, inEle, eleWidth, pre) {
        var popPriority = this.popupPriCount > 0;
        var len = inEle.length;
        var eleWid = eleWidth;
        var eleOffset;
        var checkoffset;
        var sepCheck = 0;
        var itemCount = 0;
        var itemPopCount = 0;
        var checkClass = function (ele, val) {
            var rVal = false;
            val.forEach(function (cls) {
                if (ele.classList.contains(cls)) {
                    rVal = true;
                }
            });
            return rVal;
        };
        for (var i = len - 1; i >= 0; i--) {
            var mrgn = void 0;
            var compuStyle = window.getComputedStyle(inEle[i]);
            if (this.isVertical) {
                mrgn = parseFloat((compuStyle).marginTop);
                mrgn += parseFloat((compuStyle).marginBottom);
            }
            else {
                mrgn = parseFloat((compuStyle).marginRight);
                mrgn += parseFloat((compuStyle).marginLeft);
            }
            var fstEleCheck = inEle[i] === this.tbarEle[0];
            if (fstEleCheck) {
                this.tbarEleMrgn = mrgn;
            }
            eleOffset = this.isVertical ? inEle[i].offsetHeight : inEle[i].offsetWidth;
            var eleWid_1 = fstEleCheck ? (eleOffset + mrgn) : eleOffset;
            if (checkClass(inEle[i], [CLS_POPPRI]) && popPriority) {
                inEle[i].classList.add(CLS_POPUP);
                if (this.isVertical) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(inEle[i], { display: 'none', minHeight: eleWid_1 + 'px' });
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(inEle[i], { display: 'none', minWidth: eleWid_1 + 'px' });
                }
                itemPopCount++;
            }
            if (this.isVertical) {
                checkoffset = (inEle[i].offsetTop + inEle[i].offsetHeight + mrgn) > eleWidth;
            }
            else {
                checkoffset = (inEle[i].offsetLeft + inEle[i].offsetWidth + mrgn) > eleWidth;
            }
            if (checkoffset) {
                if (inEle[i].classList.contains(CLS_SEPARATOR)) {
                    if (this.overflowMode === 'Extended') {
                        if (itemCount === itemPopCount) {
                            var sepEle = inEle[i];
                            if (checkClass(sepEle, [CLS_SEPARATOR, CLS_TBARIGNORE])) {
                                inEle[i].classList.add(CLS_POPUP);
                                itemPopCount++;
                            }
                        }
                        itemCount++;
                    }
                    else if (this.overflowMode === 'Popup') {
                        if (sepCheck > 0 && itemCount === itemPopCount) {
                            var sepEle = inEle[i + itemCount + (sepCheck - 1)];
                            if (checkClass(sepEle, [CLS_SEPARATOR, CLS_TBARIGNORE])) {
                                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(sepEle, { display: 'none' });
                            }
                        }
                        sepCheck++;
                        itemCount = 0;
                        itemPopCount = 0;
                    }
                }
                else {
                    itemCount++;
                }
                if (inEle[i].classList.contains(CLS_TBAROVERFLOW) && pre) {
                    eleWidth -= ((this.isVertical ? inEle[i].offsetHeight : inEle[i].offsetWidth) + (mrgn));
                }
                else if (!checkClass(inEle[i], [CLS_SEPARATOR, CLS_TBARIGNORE])) {
                    inEle[i].classList.add(CLS_POPUP);
                    if (this.isVertical) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(inEle[i], { display: 'none', minHeight: eleWid_1 + 'px' });
                    }
                    else {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(inEle[i], { display: 'none', minWidth: eleWid_1 + 'px' });
                    }
                    itemPopCount++;
                }
                else {
                    eleWidth -= ((this.isVertical ? inEle[i].offsetHeight : inEle[i].offsetWidth) + (mrgn));
                }
            }
        }
        if (pre) {
            var popedEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_ITEM + ':not(.' + CLS_POPUP + ')', this.element);
            this.checkPriority(ele, popedEle, eleWid, false);
        }
    };
    Toolbar.prototype.createPopupIcon = function (element) {
        var id = element.id.concat('_nav');
        var className = 'e-' + element.id.concat('_nav ' + CLS_POPUPNAV);
        className = this.overflowMode === 'Extended' ? className + ' ' + CLS_EXTENDPOPUP : className;
        var nav = this.createElement('div', { id: id, className: className });
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name === 'msie' || __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name === 'edge') {
            nav.classList.add('e-ie-align');
        }
        var navItem = this.createElement('div', { className: CLS_POPUPDOWN + ' e-icons' });
        nav.appendChild(navItem);
        nav.setAttribute('tabindex', '0');
        nav.setAttribute('role', 'list');
        element.appendChild(nav);
    };
    Toolbar.prototype.tbarPriRef = function (inEle, indx, sepPri, el, des, elWid, wid, ig) {
        var ignoreCount = ig;
        var popEle = this.popObj.element;
        var query = '.' + CLS_ITEM + ':not(.' + CLS_SEPARATOR + '):not(.' + CLS_TBAROVERFLOW + ')';
        var priEleCnt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_POPUP + ':not(.' + CLS_TBAROVERFLOW + ')', popEle).length;
        var checkClass = function (ele, val) {
            return ele.classList.contains(val);
        };
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])(query, inEle).length === 0) {
            var eleSep = inEle.children[indx - (indx - sepPri) - 1];
            var ignoreCheck = (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(eleSep) && checkClass(eleSep, CLS_TBARIGNORE));
            if ((!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(eleSep) && checkClass(eleSep, CLS_SEPARATOR) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(eleSep)) || ignoreCheck) {
                var sepDisplay = 'none';
                eleSep.style.display = 'inherit';
                var eleSepWidth = eleSep.offsetWidth + (parseFloat(window.getComputedStyle(eleSep).marginRight) * 2);
                var prevSep = eleSep.previousElementSibling;
                if ((elWid + eleSepWidth) < wid || des) {
                    inEle.insertBefore(el, inEle.children[(indx + ignoreCount) - (indx - sepPri)]);
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(prevSep)) {
                        prevSep.style.display = '';
                    }
                }
                else {
                    if (prevSep.classList.contains(CLS_SEPARATOR)) {
                        prevSep.style.display = sepDisplay;
                    }
                }
                eleSep.style.display = '';
            }
            else {
                inEle.insertBefore(el, inEle.children[(indx + ignoreCount) - (indx - sepPri)]);
            }
        }
        else {
            inEle.insertBefore(el, inEle.children[(indx + ignoreCount) - priEleCnt]);
        }
    };
    Toolbar.prototype.popupRefresh = function (popupEle, destroy) {
        var _this = this;
        var ele = this.element;
        var isVer = this.isVertical;
        var innerEle = ele.querySelector('.' + CLS_ITEMS);
        var popNav = ele.querySelector('.' + CLS_TBARNAV);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(popNav)) {
            return;
        }
        innerEle.removeAttribute('style');
        popupEle.style.display = 'block';
        var dimension;
        if (isVer) {
            dimension = ele.offsetHeight - (popNav.offsetHeight + innerEle.offsetHeight);
        }
        else {
            dimension = ele.offsetWidth - (popNav.offsetWidth + innerEle.offsetWidth);
        }
        var popupEleWidth = 0;
        [].slice.call(popupEle.children).forEach(function (el) {
            popupEleWidth += _this.popupEleWidth(el);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(el, { 'position': '' });
        });
        if ((dimension + (isVer ? popNav.offsetHeight : popNav.offsetWidth)) > (popupEleWidth) && this.popupPriCount === 0) {
            destroy = true;
        }
        this.popupEleRefresh(dimension, popupEle, destroy);
        popupEle.style.display = '';
        if (popupEle.children.length === 0 && popNav && this.popObj) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(popNav);
            popNav = null;
            this.popObj.destroy();
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.popObj.element);
            this.popObj = null;
            ele.setAttribute('aria-haspopup', 'false');
        }
    };
    Toolbar.prototype.ignoreEleFetch = function (index, innerEle) {
        var ignoreEle = [].slice.call(innerEle.querySelectorAll('.' + CLS_TBARIGNORE));
        var ignoreInx = [];
        var count = 0;
        if (ignoreEle.length > 0) {
            ignoreEle.forEach(function (ele) {
                ignoreInx.push([].slice.call(innerEle.children).indexOf(ele));
            });
        }
        else {
            return 0;
        }
        ignoreInx.forEach(function (val) {
            if (val <= index) {
                count++;
            }
        });
        return count;
    };
    Toolbar.prototype.checkPopupRefresh = function (root, popEle) {
        popEle.style.display = 'block';
        var elWid = this.popupEleWidth(popEle.firstElementChild);
        popEle.firstElementChild.style.removeProperty('Position');
        var tbarWidth = root.offsetWidth - root.querySelector('.' + CLS_TBARNAV).offsetWidth;
        var tbarItemsWid = root.querySelector('.' + CLS_ITEMS).offsetWidth;
        popEle.style.removeProperty('display');
        if (tbarWidth > (elWid + tbarItemsWid)) {
            return true;
        }
        return false;
    };
    Toolbar.prototype.popupEleWidth = function (el) {
        el.style.position = 'absolute';
        var elWidth = this.isVertical ? el.offsetHeight : el.offsetWidth;
        var btnText = el.querySelector('.' + CLS_TBARBTNTEXT);
        if (el.classList.contains('e-tbtn-align') || el.classList.contains(CLS_TBARTEXT)) {
            var btn = el.children[0];
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(btnText) && el.classList.contains(CLS_TBARTEXT)) {
                btnText.style.display = 'none';
            }
            else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(btnText) && el.classList.contains(CLS_POPUPTEXT)) {
                btnText.style.display = 'block';
            }
            btn.style.minWidth = '0%';
            elWidth = parseFloat(!this.isVertical ? el.style.minWidth : el.style.minHeight);
            btn.style.minWidth = '';
            btn.style.minHeight = '';
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(btnText)) {
                btnText.style.display = '';
            }
        }
        return elWidth;
    };
    Toolbar.prototype.popupEleRefresh = function (width, popupEle, destroy) {
        var popPriority = this.popupPriCount > 0;
        var eleSplice = this.tbarEle;
        var priEleCnt;
        var index;
        var innerEle = this.element.querySelector('.' + CLS_ITEMS);
        var ignoreCount = 0;
        var _loop_1 = function (el) {
            if (el.classList.contains(CLS_POPPRI) && popPriority && !destroy) {
                return "continue";
            }
            var elWidth = this_1.popupEleWidth(el);
            if (el === this_1.tbarEle[0]) {
                elWidth += this_1.tbarEleMrgn;
            }
            el.style.position = '';
            if (elWidth < width || destroy) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(el, { minWidth: '', height: '', minHeight: '' });
                if (!el.classList.contains(CLS_POPOVERFLOW)) {
                    el.classList.remove(CLS_POPUP);
                }
                index = this_1.tbarEle.indexOf(el);
                if (this_1.tbarAlign) {
                    var pos = this_1.items[index].align;
                    index = this_1.tbarAlgEle[(pos + 's').toLowerCase()].indexOf(el);
                    eleSplice = this_1.tbarAlgEle[(pos + 's').toLowerCase()];
                    innerEle = this_1.element.querySelector('.' + CLS_ITEMS + ' .' + 'e-toolbar-' + pos.toLowerCase());
                }
                var sepBeforePri_1 = 0;
                if (this_1.overflowMode !== 'Extended') {
                    eleSplice.slice(0, index).forEach(function (el) {
                        if (el.classList.contains(CLS_TBAROVERFLOW) || el.classList.contains(CLS_SEPARATOR)) {
                            if (el.classList.contains(CLS_SEPARATOR)) {
                                el.style.display = '';
                                width -= el.offsetWidth;
                            }
                            sepBeforePri_1++;
                        }
                    });
                }
                ignoreCount = this_1.ignoreEleFetch(index, innerEle);
                if (el.classList.contains(CLS_TBAROVERFLOW)) {
                    this_1.tbarPriRef(innerEle, index, sepBeforePri_1, el, destroy, elWidth, width, ignoreCount);
                    width -= el.offsetWidth;
                }
                else if (index === 0) {
                    innerEle.insertBefore(el, innerEle.firstChild);
                    width -= el.offsetWidth;
                }
                else {
                    priEleCnt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TBAROVERFLOW, this_1.popObj.element).length;
                    innerEle.insertBefore(el, innerEle.children[(index + ignoreCount) - priEleCnt]);
                    width -= el.offsetWidth;
                }
                el.style.height = '';
            }
            else {
                return "break";
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = [].slice.call(popupEle.children); _i < _a.length; _i++) {
            var el = _a[_i];
            var state_1 = _loop_1(el);
            if (state_1 === "break")
                break;
        }
        var checkOverflow = this.checkOverflow(this.element, this.element.getElementsByClassName(CLS_ITEMS)[0]);
        if (checkOverflow && !destroy) {
            this.renderOverflowMode();
        }
    };
    Toolbar.prototype.removePositioning = function () {
        var item = this.element.querySelector('.' + CLS_ITEMS);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item) || !item.classList.contains(CLS_TBARPOS)) {
            return;
        }
        this.remove(item, CLS_TBARPOS);
        var innerItem = [].slice.call(item.childNodes);
        innerItem[1].removeAttribute('style');
        innerItem[2].removeAttribute('style');
    };
    Toolbar.prototype.refreshPositioning = function () {
        var item = this.element.querySelector('.' + CLS_ITEMS);
        this.add(item, CLS_TBARPOS);
        this.itemPositioning();
    };
    Toolbar.prototype.itemPositioning = function () {
        var item = this.element.querySelector('.' + CLS_ITEMS);
        var margin;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item) || !item.classList.contains(CLS_TBARPOS)) {
            return;
        }
        var popupNav = this.element.querySelector('.' + CLS_TBARNAV);
        var innerItem;
        if (this.scrollModule) {
            var trgClass = (this.isVertical) ? CLS_VSCROLLCNT : CLS_HSCROLLCNT;
            innerItem = [].slice.call(item.querySelector('.' + trgClass).children);
        }
        else {
            innerItem = [].slice.call(item.childNodes);
        }
        if (this.isVertical) {
            margin = innerItem[0].offsetHeight + innerItem[2].offsetHeight;
        }
        else {
            margin = innerItem[0].offsetWidth + innerItem[2].offsetWidth;
        }
        var tbarWid = this.isVertical ? this.element.offsetHeight : this.element.offsetWidth;
        if (popupNav) {
            tbarWid -= (this.isVertical ? popupNav.offsetHeight : popupNav.offsetWidth);
            var popWid = (this.isVertical ? popupNav.offsetHeight : popupNav.offsetWidth) + 'px';
            innerItem[2].removeAttribute('style');
            if (this.isVertical) {
                if (this.enableRtl) {
                    innerItem[2].style.top = popWid;
                }
                else {
                    innerItem[2].style.bottom = popWid;
                }
            }
            else {
                if (this.enableRtl) {
                    innerItem[2].style.left = popWid;
                }
                else {
                    innerItem[2].style.right = popWid;
                }
            }
        }
        if (tbarWid <= margin) {
            return;
        }
        var value = (((tbarWid - margin)) - (!this.isVertical ? innerItem[1].offsetWidth : innerItem[1].offsetHeight)) / 2;
        innerItem[1].removeAttribute('style');
        var mrgn = ((!this.isVertical ? innerItem[0].offsetWidth : innerItem[0].offsetHeight) + value) + 'px';
        if (this.isVertical) {
            if (this.enableRtl) {
                innerItem[1].style.marginBottom = mrgn;
            }
            else {
                innerItem[1].style.marginTop = mrgn;
            }
        }
        else {
            if (this.enableRtl) {
                innerItem[1].style.marginRight = mrgn;
            }
            else {
                innerItem[1].style.marginLeft = mrgn;
            }
        }
    };
    Toolbar.prototype.tbarItemAlign = function (item, itemEle, pos) {
        var _this = this;
        if (item.showAlwaysInPopup && item.overflow !== 'Show') {
            return;
        }
        var alignDiv = [];
        alignDiv.push(this.createElement('div', { className: CLS_TBARLEFT }));
        alignDiv.push(this.createElement('div', { className: CLS_TBARCENTER }));
        alignDiv.push(this.createElement('div', { className: CLS_TBARRIGHT }));
        if (pos === 0 && item.align !== 'Left') {
            alignDiv.forEach(function (ele) {
                itemEle.appendChild(ele);
            });
            this.tbarAlign = true;
            this.add(itemEle, CLS_TBARPOS);
        }
        else if (item.align !== 'Left') {
            var alignEle = itemEle.childNodes;
            var leftAlign_1 = alignDiv[0];
            [].slice.call(alignEle).forEach(function (el) {
                _this.tbarAlgEle.lefts.push(el);
                leftAlign_1.appendChild(el);
            });
            itemEle.appendChild(leftAlign_1);
            itemEle.appendChild(alignDiv[1]);
            itemEle.appendChild(alignDiv[2]);
            this.tbarAlign = true;
            this.add(itemEle, CLS_TBARPOS);
        }
    };
    Toolbar.prototype.ctrlTemplate = function () {
        var _this = this;
        this.ctrlTem = this.trgtEle.cloneNode(true);
        this.add(this.trgtEle, CLS_ITEMS);
        this.tbarEle = [];
        var innerEle = [].slice.call(this.trgtEle.children);
        innerEle.forEach(function (ele) {
            if (ele.tagName === 'DIV') {
                _this.tbarEle.push(ele);
                ele.setAttribute('aria-disabled', 'false');
                _this.add(ele, CLS_ITEM);
            }
        });
    };
    Toolbar.prototype.renderItems = function () {
        var ele = this.element;
        var items = this.items;
        if (this.trgtEle != null) {
            this.ctrlTemplate();
        }
        else if (ele && items.length > 0) {
            var itemEleDom = void 0;
            if (ele && ele.children.length > 0) {
                itemEleDom = ele.querySelector('.' + CLS_ITEMS);
            }
            if (!itemEleDom) {
                itemEleDom = this.createElement('div', { className: CLS_ITEMS });
            }
            this.itemsAlign(items, itemEleDom);
            ele.appendChild(itemEleDom);
        }
    };
    Toolbar.prototype.setAttr = function (attr, element) {
        var key = Object.keys(attr);
        var keyVal;
        for (var i = 0; i < key.length; i++) {
            keyVal = key[i];
            if (keyVal === 'class') {
                this.add(element, attr[keyVal]);
            }
            else {
                element.setAttribute(keyVal, attr[keyVal]);
            }
        }
    };
    /**
     * Enables or disables the specified Toolbar item.
     *
     * @param  {number|HTMLElement|NodeList} items - DOM element or an array of items to be enabled or disabled.
     * @param  {boolean} isEnable  - Boolean value that determines whether the command should be enabled or disabled.
     * By default, `isEnable` is set to true.
     * @returns {void}.
     */
    Toolbar.prototype.enableItems = function (items, isEnable) {
        var elements = items;
        var len = elements.length;
        var ele;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(isEnable)) {
            isEnable = true;
        }
        var enable = function (isEnable, ele) {
            if (isEnable) {
                ele.classList.remove(CLS_DISABLE);
                ele.setAttribute('aria-disabled', 'false');
            }
            else {
                ele.classList.add(CLS_DISABLE);
                ele.setAttribute('aria-disabled', 'true');
            }
        };
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(len) && len >= 1) {
            for (var a = 0, element = [].slice.call(elements); a < len; a++) {
                var itemElement = element[a];
                if (typeof (itemElement) === 'number') {
                    ele = this.getElementByIndex(itemElement);
                    if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ele)) {
                        return;
                    }
                    else {
                        elements[a] = ele;
                    }
                }
                else {
                    ele = itemElement;
                }
                enable(isEnable, ele);
            }
            if (isEnable) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])(elements, CLS_DISABLE);
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])(elements, CLS_DISABLE);
            }
        }
        else {
            if (typeof (elements) === 'number') {
                ele = this.getElementByIndex(elements);
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ele)) {
                    return;
                }
            }
            else {
                ele = items;
            }
            enable(isEnable, ele);
        }
    };
    Toolbar.prototype.getElementByIndex = function (index) {
        if (this.tbarEle[index]) {
            return this.tbarEle[index];
        }
        return null;
    };
    /**
     * Adds new items to the Toolbar that accepts an array as Toolbar items.
     *
     * @param  {ItemModel[]} items - DOM element or an array of items to be added to the Toolbar.
     * @param  {number} index - Number value that determines where the command is to be added. By default, index is 0.
     * @returns {void}.
     */
    Toolbar.prototype.addItems = function (items, index) {
        var innerItems;
        this.extendedOpen();
        var itemsDiv = this.element.querySelector('.' + CLS_ITEMS);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(itemsDiv)) {
            this.itemsRerender(items);
            return;
        }
        var innerEle;
        var itemAgn = 'Left';
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(index)) {
            index = 0;
        }
        items.forEach(function (e) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e.align) && e.align !== 'Left' && itemAgn === 'Left') {
                itemAgn = e.align;
            }
        });
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.type)) {
                item.type = 'Button';
            }
            innerItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_ITEM, this.element);
            item.align = itemAgn;
            innerEle = this.renderSubComponent(item, index);
            if (this.tbarEle.length >= index && innerItems.length >= 0) {
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.scrollModule)) {
                    this.destroyMode();
                }
                var algIndex = item.align[0] === 'L' ? 0 : item.align[0] === 'C' ? 1 : 2;
                var ele = void 0;
                if (!this.tbarAlign && itemAgn !== 'Left') {
                    this.tbarItemAlign(item, itemsDiv, 1);
                    this.tbarAlign = true;
                    ele = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(innerItems[0], '.' + CLS_ITEMS).children[algIndex];
                    ele.appendChild(innerEle);
                    this.tbarAlgEle[(item.align + 's').toLowerCase()].push(innerEle);
                    this.refreshPositioning();
                }
                else if (this.tbarAlign) {
                    ele = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(innerItems[0], '.' + CLS_ITEMS).children[algIndex];
                    ele.insertBefore(innerEle, ele.children[index]);
                    this.tbarAlgEle[(item.align + 's').toLowerCase()].splice(index, 0, innerEle);
                    this.refreshPositioning();
                }
                else if (innerItems.length === 0) {
                    innerItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_ITEMS, this.element);
                    innerItems[0].appendChild(innerEle);
                }
                else {
                    innerItems[0].parentNode.insertBefore(innerEle, innerItems[index]);
                }
                this.items.splice(index, 0, item);
                if (item.template) {
                    this.tbarEle.splice(this.tbarEle.length - 1, 1);
                }
                this.tbarEle.splice(index, 0, innerEle);
                index++;
                this.offsetWid = itemsDiv.offsetWidth;
            }
        }
        itemsDiv.style.width = '';
        this.renderOverflowMode();
        if (this.isReact) {
            this.renderReactTemplates();
        }
    };
    /**
     * Removes the items from the Toolbar. Acceptable arguments are index of item/HTMLElement/node list.
     *
     * @param  {number|HTMLElement|NodeList|HTMLElement[]} args
     * Index or DOM element or an Array of item which is to be removed from the Toolbar.
     * @returns {void}.
     */
    Toolbar.prototype.removeItems = function (args) {
        var elements = args;
        var index;
        var innerItems = [].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_ITEM, this.element));
        if (typeof (elements) === 'number') {
            index = parseInt(args.toString(), 10);
            this.removeItemByIndex(index, innerItems);
        }
        else {
            if (elements && elements.length > 1) {
                for (var _i = 0, _a = [].slice.call(elements); _i < _a.length; _i++) {
                    var ele = _a[_i];
                    index = this.tbarEle.indexOf(ele);
                    this.removeItemByIndex(index, innerItems);
                    innerItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_ITEM, this.element);
                }
            }
            else {
                var ele = (elements && elements.length && elements.length === 1) ? elements[0] : args;
                index = innerItems.indexOf(ele);
                this.removeItemByIndex(index, innerItems);
            }
        }
        this.resize();
    };
    Toolbar.prototype.removeItemByIndex = function (index, innerItems) {
        if (this.tbarEle[index] && innerItems[index]) {
            var eleIdx = this.tbarEle.indexOf(innerItems[index]);
            if (this.tbarAlign) {
                var indexAgn = this.tbarAlgEle[(this.items[eleIdx].align + 's').toLowerCase()].indexOf(this.tbarEle[eleIdx]);
                this.tbarAlgEle[(this.items[eleIdx].align + 's').toLowerCase()].splice(indexAgn, 1);
            }
            if (this.isReact) {
                this.clearTemplate();
            }
            var btnItem = innerItems[index].querySelector('.e-control.e-btn');
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(btnItem) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(btnItem.ej2_instances[0]) && !(btnItem.ej2_instances[0].isDestroyed)) {
                btnItem.ej2_instances[0].destroy();
            }
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(innerItems[index]);
            this.items.splice(eleIdx, 1);
            this.tbarEle.splice(eleIdx, 1);
        }
    };
    Toolbar.prototype.templateRender = function (templateProp, innerEle, item, index) {
        var itemType = item.type;
        var eleObj = templateProp;
        var isComponent;
        if (typeof (templateProp) === 'object') {
            isComponent = typeof (eleObj.appendTo) === 'function';
        }
        if (typeof (templateProp) === 'string' || !isComponent) {
            var templateFn = void 0;
            var val = templateProp;
            var regEx = new RegExp(/<(?=.*? .*?\/ ?>|br|hr|input|!--|wbr)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i);
            val = (typeof (templateProp) === 'string') ? templateProp.trim() : templateProp;
            try {
                if (typeof (templateProp) === 'object' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(templateProp.tagName)) {
                    innerEle.appendChild(templateProp);
                }
                else if (typeof (templateProp) === 'string' && regEx.test(val)) {
                    innerEle.innerHTML = val;
                }
                else if (document.querySelectorAll(val).length) {
                    var ele = document.querySelector(val);
                    var tempStr = ele.outerHTML.trim();
                    innerEle.appendChild(ele);
                    ele.style.display = '';
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(tempStr)) {
                        this.tempId.push(val);
                    }
                }
                else {
                    templateFn = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(val);
                }
            }
            catch (e) {
                templateFn = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(val);
            }
            var tempArray = void 0;
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(templateFn)) {
                var toolbarTemplateID = this.element.id + index + '_template';
                tempArray = templateFn({}, this, 'template', toolbarTemplateID, this.isStringTemplate);
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(tempArray) && tempArray.length > 0) {
                [].slice.call(tempArray).forEach(function (ele) {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ele.tagName)) {
                        ele.style.display = '';
                    }
                    innerEle.appendChild(ele);
                });
            }
        }
        else if (itemType === 'Input') {
            var ele = this.createElement('input');
            if (item.id) {
                ele.id = item.id;
            }
            else {
                ele.id = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('tbr-ipt');
            }
            innerEle.appendChild(ele);
            eleObj.appendTo(ele);
        }
        this.add(innerEle, CLS_TEMPLATE);
        this.tbarEle.push(innerEle);
    };
    Toolbar.prototype.buttonRendering = function (item, innerEle) {
        var dom = this.createElement('button', { className: CLS_TBARBTN });
        dom.setAttribute('type', 'button');
        var textStr = item.text;
        var iconCss;
        var iconPos;
        if (item.id) {
            dom.id = item.id;
        }
        else {
            dom.id = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('e-tbr-btn');
        }
        var btnTxt = this.createElement('span', { className: 'e-tbar-btn-text' });
        if (textStr) {
            btnTxt.innerHTML = this.enableHtmlSanitizer ? __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(textStr) : textStr;
            dom.appendChild(btnTxt);
            dom.classList.add('e-tbtn-txt');
        }
        else {
            this.add(innerEle, 'e-tbtn-align');
        }
        if (item.prefixIcon || item.suffixIcon) {
            if ((item.prefixIcon && item.suffixIcon) || item.prefixIcon) {
                iconCss = item.prefixIcon + ' e-icons';
                iconPos = 'Left';
            }
            else {
                iconCss = item.suffixIcon + ' e-icons';
                iconPos = 'Right';
            }
        }
        var btnObj = new __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_buttons__["a" /* Button */]({ iconCss: iconCss, iconPosition: iconPos });
        btnObj.createElement = this.createElement;
        btnObj.appendTo(dom);
        if (item.width) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(dom, { 'width': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(item.width) });
        }
        return dom;
    };
    Toolbar.prototype.renderSubComponent = function (item, index) {
        var dom;
        var innerEle = this.createElement('div', { className: CLS_ITEM });
        innerEle.setAttribute('aria-disabled', 'false');
        var tempDom = this.createElement('div', {
            innerHTML: this.enableHtmlSanitizer ? __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(item.tooltipText) : item.tooltipText
        });
        if (!this.tbarEle) {
            this.tbarEle = [];
        }
        if (item.htmlAttributes) {
            this.setAttr(item.htmlAttributes, innerEle);
        }
        if (item.tooltipText) {
            innerEle.setAttribute('title', tempDom.textContent);
        }
        if (item.cssClass) {
            innerEle.className = innerEle.className + ' ' + item.cssClass;
        }
        if (item.template) {
            this.templateRender(item.template, innerEle, item, index);
        }
        else {
            switch (item.type) {
                case 'Button':
                    dom = this.buttonRendering(item, innerEle);
                    dom.setAttribute('tabindex', '-1');
                    dom.setAttribute('aria-label', (item.text || item.tooltipText));
                    innerEle.appendChild(dom);
                    innerEle.addEventListener('click', this.itemClick.bind(this));
                    break;
                case 'Separator':
                    this.add(innerEle, CLS_SEPARATOR);
                    break;
            }
        }
        if (item.showTextOn) {
            var sTxt = item.showTextOn;
            if (sTxt === 'Toolbar') {
                this.add(innerEle, CLS_POPUPTEXT);
                this.add(innerEle, 'e-tbtn-align');
            }
            else if (sTxt === 'Overflow') {
                this.add(innerEle, CLS_TBARTEXT);
            }
        }
        if (item.overflow) {
            var overflow = item.overflow;
            if (overflow === 'Show') {
                this.add(innerEle, CLS_TBAROVERFLOW);
            }
            else if (overflow === 'Hide') {
                if (!innerEle.classList.contains(CLS_SEPARATOR)) {
                    this.add(innerEle, CLS_POPOVERFLOW);
                }
            }
        }
        if (item.overflow !== 'Show' && item.showAlwaysInPopup && !innerEle.classList.contains(CLS_SEPARATOR)) {
            this.add(innerEle, CLS_POPPRI);
            this.popupPriCount++;
        }
        if (item.disabled) {
            this.add(innerEle, CLS_DISABLE);
        }
        if (item.visible === false) {
            this.add(innerEle, CLS_HIDDEN);
        }
        return innerEle;
    };
    Toolbar.prototype.itemClick = function (e) {
        this.activeEleSwitch(e.currentTarget);
    };
    Toolbar.prototype.activeEleSwitch = function (ele) {
        this.activeEleRemove(ele.firstElementChild);
        this.activeEle.focus();
    };
    Toolbar.prototype.activeEleRemove = function (curEle) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.activeEle)) {
            this.activeEle.setAttribute('tabindex', '-1');
        }
        this.activeEle = curEle;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.trgtEle) && !curEle.parentElement.classList.contains(CLS_TEMPLATE)) {
            curEle.removeAttribute('tabindex');
        }
        else {
            this.activeEle.setAttribute('tabindex', '0');
        }
    };
    Toolbar.prototype.getPersistData = function () {
        return this.addOnPersist([]);
    };
    /**
     * Returns the current module name.
     *
     * @returns {string} - Returns the module name as string.
     * @private
     */
    Toolbar.prototype.getModuleName = function () {
        return 'toolbar';
    };
    Toolbar.prototype.itemsRerender = function (newProp) {
        this.items = this.tbarItemsCol;
        if (this.isReact || this.isAngular) {
            this.clearTemplate();
        }
        this.destroyMode();
        this.destroyItems();
        this.items = newProp;
        this.tbarItemsCol = this.items;
        this.renderItems();
        this.renderOverflowMode();
        if (this.isReact) {
            this.renderReactTemplates();
        }
    };
    Toolbar.prototype.resize = function () {
        var ele = this.element;
        this.tbResize = true;
        if (this.tbarAlign) {
            this.itemPositioning();
        }
        if (this.popObj && this.overflowMode === 'Popup') {
            this.popObj.hide();
        }
        var checkOverflow = this.checkOverflow(ele, ele.getElementsByClassName(CLS_ITEMS)[0]);
        if (!checkOverflow) {
            this.destroyScroll();
            var multirowele = ele.querySelector('.' + CLS_ITEMS);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(multirowele)) {
                this.remove(multirowele, CLS_MULTIROWPOS);
                if (this.tbarAlign) {
                    this.add(multirowele, CLS_TBARPOS);
                }
            }
        }
        if (checkOverflow && this.scrollModule && (this.offsetWid === ele.offsetWidth)) {
            return;
        }
        if (this.offsetWid > ele.offsetWidth || checkOverflow) {
            this.renderOverflowMode();
        }
        if (this.popObj) {
            if (this.overflowMode === 'Extended') {
                var eleStyles = window.getComputedStyle(this.element);
                this.popObj.width = parseFloat(eleStyles.width) + ((parseFloat(eleStyles.borderRightWidth)) * 2);
            }
            if (this.tbarAlign) {
                this.removePositioning();
            }
            this.popupRefresh(this.popObj.element, false);
            if (this.tbarAlign) {
                this.refreshPositioning();
            }
        }
        if (this.element.querySelector('.' + CLS_HSCROLLBAR)) {
            this.scrollStep = this.element.querySelector('.' + CLS_HSCROLLBAR).offsetWidth;
        }
        this.offsetWid = ele.offsetWidth;
        this.tbResize = false;
        this.separator();
    };
    Toolbar.prototype.extendedOpen = function () {
        var sib = this.element.querySelector('.' + CLS_EXTENDABLECLASS);
        if (this.overflowMode === 'Extended' && sib) {
            this.isExtendedOpen = sib.classList.contains(CLS_POPUPOPEN);
        }
    };
    /**
     * Gets called when the model property changes.The data that describes the old and new values of the property that changed.
     *
     * @param  {ToolbarModel} newProp - It contains new value of the data.
     * @param  {ToolbarModel} oldProp - It contains old value of the data.
     * @returns {void}
     * @private
     */
    Toolbar.prototype.onPropertyChanged = function (newProp, oldProp) {
        var tEle = this.element;
        var wid = tEle.offsetWidth;
        this.extendedOpen();
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'items':
                    if (!(newProp.items instanceof Array && oldProp.items instanceof Array)) {
                        var changedProb = Object.keys(newProp.items);
                        for (var i = 0; i < changedProb.length; i++) {
                            var index = parseInt(Object.keys(newProp.items)[i], 10);
                            var property = Object.keys(newProp.items[index])[0];
                            var newProperty = Object(newProp.items[index])[property];
                            if (typeof newProperty !== 'function') {
                                if (this.tbarAlign || property === 'align') {
                                    this.refresh();
                                    this.trigger('created');
                                    break;
                                }
                                var popupPriCheck = property === 'showAlwaysInPopup' && !newProperty;
                                var booleanCheck = property === 'overflow' && this.popupPriCount !== 0;
                                if ((popupPriCheck) || (this.items[index].showAlwaysInPopup) && booleanCheck) {
                                    --this.popupPriCount;
                                }
                                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.scrollModule)) {
                                    this.destroyMode();
                                }
                                var itemCol = [].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_ITEMS + ' .' + CLS_ITEM, tEle));
                                if (this.isReact) {
                                    this.clearTemplate();
                                }
                                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(itemCol[index]);
                                this.tbarEle.splice(index, 1);
                                this.addItems([this.items[index]], index);
                                this.items.splice(index, 1);
                                if (this.items[index].template) {
                                    this.tbarEle.splice(this.items.length, 1);
                                }
                            }
                        }
                    }
                    else {
                        this.itemsRerender(newProp.items);
                    }
                    break;
                case 'width':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(tEle, { 'width': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(newProp.width) });
                    this.renderOverflowMode();
                    if (this.popObj && wid < tEle.offsetWidth) {
                        this.popupRefresh(this.popObj.element, false);
                    }
                    break;
                case 'height':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'height': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(newProp.height) });
                    break;
                case 'overflowMode':
                    this.destroyMode();
                    this.renderOverflowMode();
                    if (this.enableRtl) {
                        this.add(tEle, CLS_RTL);
                    }
                    this.refreshOverflow();
                    break;
                case 'enableRtl':
                    if (newProp.enableRtl) {
                        this.add(tEle, CLS_RTL);
                    }
                    else {
                        this.remove(tEle, CLS_RTL);
                    }
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.scrollModule)) {
                        if (newProp.enableRtl) {
                            this.add(this.scrollModule.element, CLS_RTL);
                        }
                        else {
                            this.remove(this.scrollModule.element, CLS_RTL);
                        }
                    }
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.popObj)) {
                        if (newProp.enableRtl) {
                            this.add(this.popObj.element, CLS_RTL);
                        }
                        else {
                            this.remove(this.popObj.element, CLS_RTL);
                        }
                    }
                    if (this.tbarAlign) {
                        this.itemPositioning();
                    }
                    break;
                case 'scrollStep':
                    if (this.scrollModule) {
                        this.scrollModule.scrollStep = this.scrollStep;
                    }
                    break;
                case 'enableCollision':
                    if (this.popObj) {
                        this.popObj.collision = { Y: this.enableCollision ? 'flip' : 'none' };
                    }
                    break;
                case 'cssClass':
                    if (oldProp.cssClass) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], oldProp.cssClass.split(' '));
                    }
                    if (newProp.cssClass) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], newProp.cssClass.split(' '));
                    }
                    break;
                case 'allowKeyboard':
                    this.unwireKeyboardEvent();
                    if (newProp.allowKeyboard) {
                        this.wireKeyboardEvent();
                    }
                    break;
            }
        }
    };
    /**
     * Shows or hides the Toolbar item that is in the specified index.
     *
     * @param  {number | HTMLElement} index - Index value of target item or DOM element  of items to be hidden or shown.
     * @param  {boolean} value - Based on this Boolean value, item will be hide (true) or show (false). By default, value is false.
     * @returns {void}.
     */
    Toolbar.prototype.hideItem = function (index, value) {
        var isElement = (typeof (index) === 'object') ? true : false;
        var eleIndex = index;
        var initIndex;
        var ele;
        var innerItems = [].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_ITEM, this.element));
        if (isElement) {
            ele = index;
        }
        else if (this.tbarEle[eleIndex]) {
            var innerItems_1 = [].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_ITEM, this.element));
            ele = innerItems_1[eleIndex];
        }
        if (ele) {
            if (value) {
                ele.classList.add(CLS_HIDDEN);
            }
            else {
                ele.classList.remove(CLS_HIDDEN);
            }
            if (value && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.getAttribute('tabindex')) && !ele.classList.contains(CLS_SEPARATOR)) {
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ele.firstElementChild.getAttribute('tabindex'))) {
                    ele.firstElementChild.setAttribute('tabindex', '-1');
                    var innerItems_2 = [].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_ITEM, this.element));
                    if (isElement) {
                        eleIndex = innerItems_2.indexOf(ele);
                    }
                    var nextEle = innerItems_2[++eleIndex];
                    while (nextEle) {
                        var skipEle = this.eleContains(nextEle);
                        if (!skipEle) {
                            nextEle.firstElementChild.removeAttribute('tabindex');
                            break;
                        }
                        nextEle = innerItems_2[++eleIndex];
                    }
                }
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.getAttribute('tabindex')) && !ele.classList.contains(CLS_SEPARATOR)) {
                initIndex = 0;
                var setFlag = false;
                var removeFlag = false;
                var initELe = innerItems[initIndex];
                while (initELe) {
                    if (!initELe.classList.contains(CLS_SEPARATOR)) {
                        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(initELe.firstElementChild.getAttribute('tabindex'))) {
                            initELe.firstElementChild.setAttribute('tabindex', '-1');
                            setFlag = true;
                        }
                        else {
                            if (setFlag && removeFlag) {
                                break;
                            }
                            var skipEle = this.eleContains(initELe);
                            if (!skipEle) {
                                initELe.firstElementChild.removeAttribute('tabindex');
                                removeFlag = true;
                            }
                            initELe = innerItems[++initIndex];
                        }
                    }
                    else {
                        initELe = innerItems[++initIndex];
                    }
                }
            }
            this.refreshOverflow();
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["f" /* Collection */])([], Item)
    ], Toolbar.prototype, "items", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('auto')
    ], Toolbar.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('auto')
    ], Toolbar.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Toolbar.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Scrollable')
    ], Toolbar.prototype, "overflowMode", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Toolbar.prototype, "scrollStep", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Toolbar.prototype, "enableCollision", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Toolbar.prototype, "enableHtmlSanitizer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Toolbar.prototype, "allowKeyboard", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Toolbar.prototype, "clicked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Toolbar.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Toolbar.prototype, "destroyed", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Toolbar.prototype, "beforeCreate", void 0);
    Toolbar = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], Toolbar);
    return Toolbar;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__numerictextbox__ = __webpack_require__(257);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__numerictextbox__["a"]; });
/**
 * NumericTextBox modules
 */



/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__input__ = __webpack_require__(22);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__input__["a"]; });
/**
 * Input box Component
 */



/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TicksData */
/* unused harmony export ColorRangeData */
/* unused harmony export LimitData */
/* unused harmony export TooltipData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Slider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






/**
 * Configures the ticks data of the Slider.
 */
var TicksData = /** @class */ (function (_super) {
    __extends(TicksData, _super);
    function TicksData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('None')
    ], TicksData.prototype, "placement", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(10)
    ], TicksData.prototype, "largeStep", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(1)
    ], TicksData.prototype, "smallStep", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], TicksData.prototype, "showSmallTicks", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], TicksData.prototype, "format", void 0);
    return TicksData;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * It illustrates the color track data in slider.
 * {% codeBlock src='slider/colorrange/index.md' %}{% endcodeBlock %}
 */
var ColorRangeData = /** @class */ (function (_super) {
    __extends(ColorRangeData, _super);
    function ColorRangeData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], ColorRangeData.prototype, "color", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], ColorRangeData.prototype, "start", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], ColorRangeData.prototype, "end", void 0);
    return ColorRangeData;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * It illustrates the limit data in slider.
 * {% codeBlock src='slider/limits/index.md' %}{% endcodeBlock %}
 */
var LimitData = /** @class */ (function (_super) {
    __extends(LimitData, _super);
    function LimitData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], LimitData.prototype, "enabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], LimitData.prototype, "minStart", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], LimitData.prototype, "minEnd", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], LimitData.prototype, "maxStart", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], LimitData.prototype, "maxEnd", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], LimitData.prototype, "startHandleFixed", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], LimitData.prototype, "endHandleFixed", void 0);
    return LimitData;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * It illustrates the tooltip data in slider.
 */
var TooltipData = /** @class */ (function (_super) {
    __extends(TooltipData, _super);
    function TooltipData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], TooltipData.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Before')
    ], TooltipData.prototype, "placement", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Focus')
    ], TooltipData.prototype, "showOn", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], TooltipData.prototype, "isVisible", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], TooltipData.prototype, "format", void 0);
    return TooltipData;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

var bootstrapTooltipOffset = 6;
var bootstrap4TooltipOffset = 3;
var classNames = {
    root: 'e-slider',
    rtl: 'e-rtl',
    sliderHiddenInput: 'e-slider-input',
    controlWrapper: 'e-control-wrapper',
    sliderHandle: 'e-handle',
    rangeBar: 'e-range',
    sliderButton: 'e-slider-button',
    firstButton: 'e-first-button',
    secondButton: 'e-second-button',
    scale: 'e-scale',
    tick: 'e-tick',
    large: 'e-large',
    tickValue: 'e-tick-value',
    sliderTooltip: 'e-slider-tooltip',
    sliderHover: 'e-slider-hover',
    sliderFirstHandle: 'e-handle-first',
    sliderSecondHandle: 'e-handle-second',
    sliderDisabled: 'e-disabled',
    sliderContainer: 'e-slider-container',
    horizontalTooltipBefore: 'e-slider-horizontal-before',
    horizontalTooltipAfter: 'e-slider-horizontal-after',
    verticalTooltipBefore: 'e-slider-vertical-before',
    verticalTooltipAfter: 'e-slider-vertical-after',
    materialTooltip: 'e-material-tooltip',
    materialTooltipOpen: 'e-material-tooltip-open',
    materialTooltipActive: 'e-tooltip-active',
    materialSlider: 'e-material-slider',
    sliderTrack: 'e-slider-track',
    sliderHorizantalColor: 'e-slider-horizantal-color',
    sliderVerticalColor: 'e-slider-vertical-color',
    sliderHandleFocused: 'e-handle-focused',
    verticalSlider: 'e-vertical',
    horizontalSlider: 'e-horizontal',
    sliderHandleStart: 'e-handle-start',
    sliderTooltipStart: 'e-material-tooltip-start',
    sliderTabHandle: 'e-tab-handle',
    sliderButtonIcon: 'e-button-icon',
    sliderSmallSize: 'e-small-size',
    sliderTickPosition: 'e-tick-pos',
    sliderFirstTick: 'e-first-tick',
    sliderLastTick: 'e-last-tick',
    sliderButtonClass: 'e-slider-btn',
    sliderTooltipWrapper: 'e-tooltip-wrap',
    sliderTabTrack: 'e-tab-track',
    sliderTabRange: 'e-tab-range',
    sliderActiveHandle: 'e-handle-active',
    sliderMaterialHandle: 'e-material-handle',
    sliderMaterialRange: 'e-material-range',
    sliderMaterialDefault: 'e-material-default',
    materialTooltipShow: 'e-material-tooltip-show',
    materialTooltipHide: 'e-material-tooltip-hide',
    readonly: 'e-read-only',
    limits: 'e-limits',
    limitBarDefault: 'e-limit-bar',
    limitBarFirst: 'e-limit-first',
    limitBarSecond: 'e-limit-second',
    dragHorizontal: 'e-drag-horizontal',
    dragVertical: 'e-drag-vertical'
};
/**
 * The Slider component allows the user to select a value or range
 * of values in-between a min and max range, by dragging the handle over the slider bar.
 * ```html
 * <div id='slider'></div>
 * ```
 * ```typescript
 * <script>
 *   var sliderObj = new Slider({ value: 10 });
 *   sliderObj.appendTo('#slider');
 * </script>
 * ```
 */
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.horDir = 'left';
        _this.verDir = 'bottom';
        _this.transition = {
            handle: 'left .4s cubic-bezier(.25, .8, .25, 1), right .4s cubic-bezier(.25, .8, .25, 1), ' +
                'top .4s cubic-bezier(.25, .8, .25, 1) , bottom .4s cubic-bezier(.25, .8, .25, 1)',
            rangeBar: 'all .4s cubic-bezier(.25, .8, .25, 1)'
        };
        _this.transitionOnMaterialTooltip = {
            handle: 'left 1ms ease-out, right 1ms ease-out, bottom 1ms ease-out, top 1ms ease-out',
            rangeBar: 'left 1ms ease-out, right 1ms ease-out, bottom 1ms ease-out, width 1ms ease-out, height 1ms ease-out'
        };
        _this.scaleTransform = 'transform .4s cubic-bezier(.25, .8, .25, 1)';
        _this.customAriaText = null;
        _this.drag = true;
        _this.isDragComplete = false;
        _this.initialTooltip = true;
        return _this;
    }
    Slider.prototype.preRender = function () {
        // eslint-disable-next-line
        var localeText = { incrementTitle: 'Increase', decrementTitle: 'Decrease' };
        this.l10n = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["o" /* L10n */]('slider', localeText, this.locale);
        this.isElementFocused = false;
        this.tickElementCollection = [];
        this.tooltipFormatInfo = {};
        this.ticksFormatInfo = {};
        this.initCultureInfo();
        this.initCultureFunc();
        this.formChecker();
    };
    Slider.prototype.formChecker = function () {
        var formElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, 'form');
        if (formElement) {
            this.isForm = true;
            // this condition needs to be checked, if the slider is going to be refreshed by `refresh()`
            // then we need to revert the slider `value` back to `formResetValue` to preserve the initial value
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.formResetValue)) {
                this.setProperties({ 'value': this.formResetValue }, true);
            }
            this.formResetValue = this.value;
            if (this.type === 'Range' &&
                (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.formResetValue) || typeof (this.formResetValue) !== 'object')) {
                this.formResetValue = [parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.min)), parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.max))];
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.formResetValue)) {
                this.formResetValue = parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.min));
            }
            this.formElement = formElement;
        }
        else {
            this.isForm = false;
        }
    };
    Slider.prototype.initCultureFunc = function () {
        this.internationalization = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["m" /* Internationalization */](this.locale);
    };
    Slider.prototype.initCultureInfo = function () {
        this.tooltipFormatInfo.format = (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.tooltip.format)) ? this.tooltip.format : null;
        this.ticksFormatInfo.format = (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.ticks.format)) ? this.ticks.format : null;
    };
    Slider.prototype.formatString = function (value, formatInfo) {
        var formatValue = null;
        var formatString = null;
        if ((value || value === 0)) {
            formatValue = this.formatNumber(value);
            var numberOfDecimals = this.numberOfDecimals(value);
            formatString = this.internationalization.getNumberFormat(formatInfo)(this.makeRoundNumber(value, numberOfDecimals));
        }
        return { elementVal: formatValue, formatString: formatString };
    };
    Slider.prototype.formatNumber = function (value) {
        var numberOfDecimals = this.numberOfDecimals(value);
        return this.internationalization.getNumberFormat({
            maximumFractionDigits: numberOfDecimals,
            minimumFractionDigits: numberOfDecimals, useGrouping: false
        })(value);
    };
    Slider.prototype.numberOfDecimals = function (value) {
        var decimalPart = value.toString().split('.')[1];
        var numberOfDecimals = !decimalPart || !decimalPart.length ? 0 : decimalPart.length;
        return numberOfDecimals;
    };
    Slider.prototype.makeRoundNumber = function (value, precision) {
        var decimals = precision || 0;
        return Number(value.toFixed(decimals));
    };
    Slider.prototype.fractionalToInteger = function (value) {
        value = (this.numberOfDecimals(value) === 0) ? Number(value).toFixed(this.noOfDecimals) : value;
        var tens = 1;
        for (var i = 0; i < this.noOfDecimals; i++) {
            tens *= 10;
        }
        value = Number((value * tens).toFixed(0));
        return value;
    };
    /**
     * To Initialize the control rendering
     * @private
     */
    Slider.prototype.render = function () {
        var _this = this;
        this.initialize();
        this.initRender();
        this.wireEvents();
        this.setZindex();
        this.renderComplete();
        if (this.element.tagName === 'EJS-SLIDER') {
            if (this.getTheme(this.sliderContainer) == "none") {
                setTimeout(function () {
                    _this.refresh();
                }, 0);
            }
        }
    };
    Slider.prototype.initialize = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], classNames.root);
        this.setCSSClass();
    };
    Slider.prototype.setElementWidth = function (width) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(width)) {
            if (typeof width === 'number') {
                this.sliderContainer.style.width = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(width);
            }
            else if (typeof width === 'string') {
                this.sliderContainer.style.width = (width.match(/px|%|em/)) ? (width) : (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(width));
            }
        }
    };
    Slider.prototype.setCSSClass = function (oldCSSClass) {
        if (oldCSSClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], oldCSSClass.split(' '));
        }
        if (this.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], this.cssClass.split(' '));
        }
    };
    Slider.prototype.setEnabled = function () {
        if (!this.enabled) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.sliderContainer], [classNames.sliderDisabled]);
            if (this.tooltip.isVisible && this.tooltipElement && this.tooltip.showOn === 'Always') {
                this.tooltipElement.classList.add(classNames.sliderDisabled);
            }
            this.unwireEvents();
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.sliderContainer], [classNames.sliderDisabled]);
            if (this.tooltip.isVisible && this.tooltipElement && this.tooltip.showOn === 'Always') {
                this.tooltipElement.classList.remove(classNames.sliderDisabled);
            }
            this.wireEvents();
        }
    };
    Slider.prototype.getTheme = function (container) {
        var theme = window.getComputedStyle(container, ':after').getPropertyValue('content');
        return theme.replace(/['"]+/g, '');
    };
    /**
     * Initialize the rendering
     * @private
     */
    Slider.prototype.initRender = function () {
        this.sliderContainer = this.createElement('div', { className: classNames.sliderContainer + ' ' + classNames.controlWrapper });
        this.element.parentNode.insertBefore(this.sliderContainer, this.element);
        this.sliderContainer.appendChild(this.element);
        this.sliderTrack = this.createElement('div', { className: classNames.sliderTrack });
        this.element.appendChild(this.sliderTrack);
        this.setElementWidth(this.width);
        this.element.tabIndex = -1;
        this.getThemeInitialization();
        this.setHandler();
        this.createRangeBar();
        if (this.limits.enabled) {
            this.createLimitBar();
        }
        this.setOrientClass();
        this.hiddenInput = (this.createElement('input', {
            attrs: {
                type: 'hidden', value: (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.value) ? this.min.toString() : this.value.toString()),
                name: this.element.getAttribute('name') || this.element.getAttribute('id') ||
                    '_' + (Math.random() * 1000).toFixed(0) + 'slider', class: classNames.sliderHiddenInput
            }
        }));
        this.hiddenInput.tabIndex = -1;
        this.sliderContainer.appendChild(this.hiddenInput);
        if (this.showButtons) {
            this.setButtons();
        }
        this.setEnableRTL();
        if (this.type === 'Range') {
            this.rangeValueUpdate();
        }
        else {
            this.value = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.value) ? parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.min.toString())) : this.value;
        }
        this.previousVal = this.type !== 'Range' ? this.checkHandleValue(parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.value.toString()))) :
            [this.checkHandleValue(parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.value[0].toString()))),
                this.checkHandleValue(parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.value[1].toString())))];
        this.previousChanged = this.previousVal;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.hasAttribute('name'))) {
            this.element.removeAttribute('name');
        }
        this.setValue();
        if (this.limits.enabled) {
            this.setLimitBar();
        }
        if (this.ticks.placement !== 'None') {
            this.renderScale();
        }
        if (this.tooltip.isVisible) {
            this.renderTooltip();
        }
        if (!this.enabled) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.sliderContainer], [classNames.sliderDisabled]);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.sliderContainer], [classNames.sliderDisabled]);
        }
        if (this.readonly) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.sliderContainer], [classNames.readonly]);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.sliderContainer], [classNames.readonly]);
        }
    };
    Slider.prototype.getThemeInitialization = function () {
        this.isMaterial = this.getTheme(this.sliderContainer) === 'material'
            || this.getTheme(this.sliderContainer) === 'material-dark';
        this.isBootstrap = this.getTheme(this.sliderContainer) === 'bootstrap'
            || this.getTheme(this.sliderContainer) === 'bootstrap-dark';
        this.isBootstrap4 = this.getTheme(this.sliderContainer) === 'bootstrap4';
        this.isTailwind = this.getTheme(this.sliderContainer) === 'tailwind' || this.getTheme(this.sliderContainer) === 'tailwind-dark';
        this.isBootstrap5 = this.getTheme(this.sliderContainer) === 'bootstrap5';
        this.isFluent = this.getTheme(this.sliderContainer) === 'FluentUI';
        this.isMaterialTooltip = this.isMaterial && this.type !== 'Range' && this.tooltip.isVisible;
    };
    Slider.prototype.createRangeBar = function () {
        if (this.type !== 'Default') {
            this.rangeBar = (this.createElement('div', { attrs: { class: classNames.rangeBar } }));
            this.element.appendChild(this.rangeBar);
            if (this.drag && this.type === 'Range') {
                if (this.orientation === 'Horizontal') {
                    this.rangeBar.classList.add(classNames.dragHorizontal);
                }
                else {
                    this.rangeBar.classList.add(classNames.dragVertical);
                }
            }
        }
    };
    Slider.prototype.createLimitBar = function () {
        var firstElementClassName = this.type !== 'Range' ? classNames.limitBarDefault :
            classNames.limitBarFirst;
        firstElementClassName += ' ' + classNames.limits;
        this.limitBarFirst = (this.createElement('div', {
            attrs: { class: firstElementClassName }
        }));
        this.element.appendChild(this.limitBarFirst);
        if (this.type === 'Range') {
            this.limitBarSecond = (this.createElement('div', {
                attrs: {
                    class: classNames.limitBarSecond + ' ' + classNames.limits
                }
            }));
            this.element.appendChild(this.limitBarSecond);
        }
    };
    Slider.prototype.setOrientClass = function () {
        if (this.orientation !== 'Vertical') {
            this.sliderContainer.classList.remove(classNames.verticalSlider);
            this.sliderContainer.classList.add(classNames.horizontalSlider);
            this.firstHandle.setAttribute('aria-orientation', 'horizontal');
            if (this.type === 'Range') {
                this.secondHandle.setAttribute('aria-orientation', 'horizontal');
            }
        }
        else {
            this.sliderContainer.classList.remove(classNames.horizontalSlider);
            this.sliderContainer.classList.add(classNames.verticalSlider);
            this.firstHandle.setAttribute('aria-orientation', 'vertical');
            if (this.type === 'Range') {
                this.secondHandle.setAttribute('aria-orientation', 'vertical');
            }
        }
    };
    Slider.prototype.setAriaAttributes = function (element) {
        var _this = this;
        var min = this.min;
        var max = this.max;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customValues) && this.customValues.length > 0) {
            min = this.customValues[0];
            max = this.customValues[this.customValues.length - 1];
        }
        if (this.type !== 'Range') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(element, {
                'aria-valuemin': min.toString(), 'aria-valuemax': max.toString()
            });
        }
        else {
            var range = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customValues) && this.customValues.length > 0 ?
                [[min.toString(), (this.customValues[this.value[1]]).toString()],
                    [(this.customValues[this.value[0]]).toString(), max.toString()]] :
                [[min.toString(), this.value[1].toString()], [this.value[0].toString(), max.toString()]];
            range.forEach(function (range, index) {
                var element = index === 0 ? _this.firstHandle : _this.secondHandle;
                if (element) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(element, {
                        'aria-valuemin': range[0], 'aria-valuemax': range[1]
                    });
                }
            });
        }
    };
    Slider.prototype.createSecondHandle = function () {
        this.secondHandle = this.createElement('div', {
            attrs: {
                class: classNames.sliderHandle, 'role': 'slider', tabIndex: '0'
            }
        });
        this.secondHandle.classList.add(classNames.sliderSecondHandle);
        this.element.appendChild(this.secondHandle);
    };
    Slider.prototype.createFirstHandle = function () {
        this.firstHandle = this.createElement('div', {
            attrs: {
                class: classNames.sliderHandle, 'role': 'slider', tabIndex: '0'
            }
        });
        this.firstHandle.classList.add(classNames.sliderFirstHandle);
        this.element.appendChild(this.firstHandle);
        if (this.isMaterialTooltip) {
            this.materialHandle = this.createElement('div', {
                attrs: {
                    class: classNames.sliderHandle + ' ' +
                        classNames.sliderMaterialHandle
                }
            });
            this.element.appendChild(this.materialHandle);
        }
    };
    Slider.prototype.wireFirstHandleEvt = function (destroy) {
        if (!destroy) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.firstHandle, 'mousedown touchstart', this.handleFocus, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.firstHandle, 'transitionend', this.transitionEnd, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.firstHandle, 'mouseenter touchenter', this.handleOver, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.firstHandle, 'mouseleave touchend', this.handleLeave, this);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.firstHandle, 'mousedown touchstart', this.handleFocus);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.firstHandle, 'transitionend', this.transitionEnd);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.firstHandle, 'mouseenter touchenter', this.handleOver);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.firstHandle, 'mouseleave touchend', this.handleLeave);
        }
    };
    Slider.prototype.wireSecondHandleEvt = function (destroy) {
        if (!destroy) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.secondHandle, 'mousedown touchstart', this.handleFocus, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.secondHandle, 'transitionend', this.transitionEnd, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.secondHandle, 'mouseenter touchenter', this.handleOver, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.secondHandle, 'mouseleave touchend', this.handleLeave, this);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.secondHandle, 'mousedown touchstart', this.handleFocus);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.secondHandle, 'transitionend', this.transitionEnd);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.secondHandle, 'mouseenter touchenter', this.handleOver);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.secondHandle, 'mouseleave touchend', this.handleLeave);
        }
    };
    Slider.prototype.handleStart = function () {
        if (this.type !== 'Range') {
            this.firstHandle.classList[this.handlePos1 === 0 ? 'add' : 'remove'](classNames.sliderHandleStart);
            if (this.isMaterialTooltip) {
                this.materialHandle.classList[this.handlePos1 === 0 ? 'add' : 'remove'](classNames.sliderHandleStart);
                if (this.tooltipElement) {
                    this.tooltipElement.classList[this.handlePos1 === 0 ? 'add' : 'remove'](classNames.sliderTooltipStart);
                }
            }
        }
    };
    Slider.prototype.transitionEnd = function (e) {
        if (e.propertyName !== 'transform') {
            this.handleStart();
            if (!this.enableAnimation) {
                this.getHandle().style.transition = 'none';
            }
            if (this.type !== 'Default') {
                this.rangeBar.style.transition = 'none';
            }
            if (this.isMaterial && this.tooltip.isVisible && this.type === 'Default') {
                this.tooltipElement.style.transition = this.transition.handle;
            }
            this.tooltipToggle(this.getHandle());
            this.closeTooltip();
        }
    };
    Slider.prototype.handleFocusOut = function () {
        if (this.firstHandle.classList.contains(classNames.sliderHandleFocused)) {
            this.firstHandle.classList.remove(classNames.sliderHandleFocused);
        }
        if (this.type === 'Range') {
            if (this.secondHandle.classList.contains(classNames.sliderHandleFocused)) {
                this.secondHandle.classList.remove(classNames.sliderHandleFocused);
            }
        }
    };
    Slider.prototype.handleFocus = function (e) {
        this.focusSliderElement();
        this.sliderBarClick(e);
        if (e.currentTarget === this.firstHandle) {
            this.firstHandle.classList.add(classNames.sliderHandleFocused);
            this.firstHandle.classList.add(classNames.sliderTabHandle);
        }
        else {
            this.secondHandle.classList.add(classNames.sliderHandleFocused);
            this.secondHandle.classList.add(classNames.sliderTabHandle);
        }
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'mousemove touchmove', this.sliderBarMove, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'mouseup touchend', this.sliderBarUp, this);
    };
    Slider.prototype.handleOver = function (e) {
        if (this.tooltip.isVisible && this.tooltip.showOn === 'Hover') {
            this.tooltipToggle(e.currentTarget);
        }
        if (this.type === 'Default') {
            this.tooltipToggle(this.getHandle());
        }
    };
    Slider.prototype.handleLeave = function (e) {
        if (this.tooltip.isVisible && this.tooltip.showOn === 'Hover' &&
            !e.currentTarget.classList.contains(classNames.sliderHandleFocused) &&
            !e.currentTarget.classList.contains(classNames.sliderTabHandle)) {
            this.closeTooltip();
        }
    };
    Slider.prototype.setHandler = function () {
        if (this.min > this.max) {
            this.min = this.max;
        }
        this.createFirstHandle();
        if (this.type === 'Range') {
            this.createSecondHandle();
        }
    };
    Slider.prototype.setEnableRTL = function () {
        this.enableRtl && this.orientation !== 'Vertical' ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.sliderContainer], classNames.rtl) :
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.sliderContainer], classNames.rtl);
        var preDir = (this.orientation !== 'Vertical') ? this.horDir : this.verDir;
        if (this.enableRtl) {
            this.horDir = 'right';
            this.verDir = 'bottom';
        }
        else {
            this.horDir = 'left';
            this.verDir = 'bottom';
        }
        var currDir = (this.orientation !== 'Vertical') ? this.horDir : this.verDir;
        if (preDir !== currDir) {
            if (this.orientation === 'Horizontal') {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.firstHandle, { 'right': '', 'left': 'auto' });
                if (this.type === 'Range') {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.secondHandle, { 'top': '', 'left': 'auto' });
                }
            }
        }
        this.setBarColor();
    };
    Slider.prototype.tooltipValue = function () {
        var _this = this;
        var text;
        var args = {
            value: this.value,
            text: ''
        };
        if (this.initialTooltip) {
            this.initialTooltip = false;
            this.setTooltipContent();
            args.text = text = this.tooltipObj.content;
            this.trigger('tooltipChange', args, function (observedArgs) {
                _this.addTooltipClass(observedArgs.text);
                if (text !== observedArgs.text) {
                    _this.customAriaText = observedArgs.text;
                    _this.tooltipObj.content = observedArgs.text;
                    _this.setAriaAttrValue(_this.firstHandle);
                    if (_this.type === 'Range') {
                        _this.setAriaAttrValue(_this.secondHandle);
                    }
                }
            });
            if (this.isMaterialTooltip) {
                this.setPreviousVal('change', this.value);
            }
        }
    };
    Slider.prototype.setTooltipContent = function () {
        var content;
        content = this.formatContent(this.tooltipFormatInfo, false);
        this.tooltipObj.content = content;
    };
    Slider.prototype.formatContent = function (formatInfo, ariaContent) {
        var content = '';
        var handle1 = this.handleVal1;
        var handle2 = this.handleVal2;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customValues) && this.customValues.length > 0) {
            handle1 = this.customValues[this.handleVal1];
            handle2 = this.customValues[this.handleVal2];
        }
        if (!ariaContent) {
            if (this.type === 'Range') {
                if (this.enableRtl && this.orientation !== 'Vertical') {
                    content = (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(formatInfo.format)) ? (this.formatString(handle2, formatInfo)
                        .formatString + ' - ' + this.formatString(handle1, formatInfo).formatString) :
                        (handle2.toString() + ' - ' + handle1.toString());
                }
                else {
                    content = (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(formatInfo.format)) ? (this.formatString(handle1, formatInfo)
                        .formatString + ' - ' + this.formatString(handle2, formatInfo).formatString) :
                        (handle1.toString() + ' - ' + handle2.toString());
                }
            }
            else {
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(handle1)) {
                    content = (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(formatInfo.format)) ?
                        this.formatString(handle1, formatInfo).formatString : handle1.toString();
                }
            }
            return content;
        }
        else {
            if (this.type === 'Range') {
                if (this.enableRtl && this.orientation !== 'Vertical') {
                    content = (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.tooltip) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.tooltip.format)) ?
                        (this.formatString(handle2, formatInfo).elementVal + ' - ' +
                            this.formatString(handle1, formatInfo).elementVal) :
                        (handle2.toString() + ' - ' + handle1.toString());
                }
                else {
                    content = (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.tooltip) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.tooltip.format)) ?
                        (this.formatString(handle1, formatInfo).elementVal + ' - ' +
                            this.formatString(handle2, formatInfo).elementVal) :
                        (handle1.toString() + ' - ' + handle2.toString());
                }
            }
            else {
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(handle1)) {
                    content = (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.tooltip) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.tooltip.format)) ?
                        this.formatString(handle1, formatInfo).elementVal : handle1.toString();
                }
            }
            return content;
        }
    };
    Slider.prototype.addTooltipClass = function (content) {
        if (this.isMaterialTooltip) {
            var count = content.toString().length;
            if (!this.tooltipElement) {
                var cssClass = count > 4 ? classNames.sliderMaterialRange : classNames.sliderMaterialDefault;
                this.tooltipObj.cssClass = classNames.sliderTooltip + ' ' + cssClass;
            }
            else {
                var cssClass = count > 4 ?
                    { oldCss: classNames.sliderMaterialDefault, newCss: classNames.sliderMaterialRange } :
                    { oldCss: classNames.sliderMaterialRange, newCss: classNames.sliderMaterialDefault };
                this.tooltipElement.classList.remove(cssClass.oldCss);
                if (!this.tooltipElement.classList.contains(cssClass.newCss)) {
                    this.tooltipElement.classList.add(cssClass.newCss);
                    this.tooltipElement.style.transform = count > 4 ? 'scale(1)' :
                        this.getTooltipTransformProperties(this.previousTooltipClass).rotate;
                }
            }
        }
    };
    Slider.prototype.tooltipPlacement = function () {
        return this.orientation === 'Horizontal' ? (this.tooltip.placement === 'Before' ? 'TopCenter' : 'BottomCenter') :
            (this.tooltip.placement === 'Before' ? 'LeftCenter' : 'RightCenter');
    };
    Slider.prototype.tooltipBeforeOpen = function (args) {
        this.tooltipElement = args.element;
        if (this.tooltip.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.tooltipElement], this.tooltip.cssClass.split(' ').filter(function (css) { return css; }));
        }
        args.target.removeAttribute('aria-describedby');
        if (this.isMaterialTooltip) {
            this.tooltipElement.firstElementChild.classList.add(classNames.materialTooltipHide);
            this.handleStart();
            this.setTooltipTransform();
        }
    };
    Slider.prototype.tooltipCollision = function (position) {
        if (this.isBootstrap || this.isBootstrap4 || (this.isMaterial && !this.isMaterialTooltip)) {
            var tooltipOffsetValue = this.isBootstrap4 ? bootstrap4TooltipOffset : bootstrapTooltipOffset;
            switch (position) {
                case 'TopCenter':
                    this.tooltipObj.setProperties({ 'offsetY': -(tooltipOffsetValue) }, false);
                    break;
                case 'BottomCenter':
                    this.tooltipObj.setProperties({ 'offsetY': tooltipOffsetValue }, false);
                    break;
                case 'LeftCenter':
                    this.tooltipObj.setProperties({ 'offsetX': -(tooltipOffsetValue) }, false);
                    break;
                case 'RightCenter':
                    this.tooltipObj.setProperties({ 'offsetX': tooltipOffsetValue }, false);
                    break;
            }
        }
    };
    Slider.prototype.materialTooltipEventCallBack = function (event) {
        this.sliderBarClick(event);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'mousemove touchmove', this.sliderBarMove, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'mouseup touchend', this.sliderBarUp, this);
    };
    Slider.prototype.wireMaterialTooltipEvent = function (destroy) {
        if (this.isMaterialTooltip) {
            if (!destroy) {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.tooltipElement, 'mousedown touchstart', this.materialTooltipEventCallBack, this);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.tooltipElement, 'mousedown touchstart', this.materialTooltipEventCallBack);
            }
        }
    };
    Slider.prototype.tooltipPositionCalculation = function (position) {
        var cssClass;
        switch (position) {
            case 'TopCenter':
                cssClass = classNames.horizontalTooltipBefore;
                break;
            case 'BottomCenter':
                cssClass = classNames.horizontalTooltipAfter;
                break;
            case 'LeftCenter':
                cssClass = classNames.verticalTooltipBefore;
                break;
            case 'RightCenter':
                cssClass = classNames.verticalTooltipAfter;
                break;
        }
        return cssClass;
    };
    Slider.prototype.getTooltipTransformProperties = function (className) {
        var transformProperties;
        if (this.tooltipElement) {
            var position = this.orientation === 'Horizontal' ?
                ((this.tooltipElement.clientHeight + 14) - (this.tooltipElement.clientHeight / 2)) :
                ((this.tooltipElement.clientWidth + 14) - (this.tooltipElement.clientWidth / 2));
            transformProperties = this.orientation === 'Horizontal' ?
                (className === classNames.horizontalTooltipBefore ? { rotate: 'rotate(45deg)', translate: "translateY(" + position + "px)" } :
                    { rotate: 'rotate(225deg)', translate: "translateY(" + -(position) + "px)" }) :
                (className === classNames.verticalTooltipBefore ? { rotate: 'rotate(-45deg)', translate: "translateX(" + position + "px)" } :
                    { rotate: 'rotate(-225deg)', translate: "translateX(" + (-position) + "px)" });
        }
        return transformProperties;
    };
    Slider.prototype.openMaterialTooltip = function () {
        var _this = this;
        if (this.isMaterialTooltip) {
            this.refreshTooltip(this.firstHandle);
            var tooltipContentElement = this.tooltipElement.firstElementChild;
            tooltipContentElement.classList.remove(classNames.materialTooltipHide);
            tooltipContentElement.classList.add(classNames.materialTooltipShow);
            this.firstHandle.style.cursor = 'default';
            this.tooltipElement.style.transition = this.scaleTransform;
            this.tooltipElement.classList.add(classNames.materialTooltipOpen);
            this.materialHandle.style.transform = 'scale(0)';
            if (tooltipContentElement.innerText.length > 4) {
                this.tooltipElement.style.transform = 'scale(1)';
            }
            else {
                this.tooltipElement.style.transform = this.getTooltipTransformProperties(this.previousTooltipClass).rotate;
            }
            if (this.type === 'Default') {
                setTimeout(function () { _this.tooltipElement.style.transition = _this.transition.handle; }, 2500);
            }
            else {
                setTimeout(function () { _this.tooltipElement.style.transition = 'none'; }, 2500);
            }
        }
    };
    Slider.prototype.closeMaterialTooltip = function () {
        var _this = this;
        if (this.isMaterialTooltip) {
            var tooltipContentElement = this.tooltipElement.firstElementChild;
            this.tooltipElement.style.transition = this.scaleTransform;
            tooltipContentElement.classList.remove(classNames.materialTooltipShow);
            tooltipContentElement.classList.add(classNames.materialTooltipHide);
            this.firstHandle.style.cursor = '-webkit-grab';
            this.firstHandle.style.cursor = 'grab';
            if (this.materialHandle) {
                this.materialHandle.style.transform = 'scale(1)';
            }
            this.tooltipElement.classList.remove(classNames.materialTooltipOpen);
            this.setTooltipTransform();
            this.tooltipTarget = undefined;
            setTimeout(function () { _this.tooltipElement.style.transition = 'none'; }, 2500);
        }
    };
    Slider.prototype.checkTooltipPosition = function (args) {
        var tooltipClass = this.tooltipPositionCalculation(args.collidedPosition);
        if (this.tooltipCollidedPosition === undefined ||
            this.tooltipCollidedPosition !== args.collidedPosition || !args.element.classList.contains(tooltipClass)) {
            if (this.isMaterialTooltip) {
                if (tooltipClass !== undefined) {
                    args.element.classList.remove(this.previousTooltipClass);
                    args.element.classList.add(tooltipClass);
                    this.previousTooltipClass = tooltipClass;
                }
                if (args.element.style.transform && args.element.classList.contains(classNames.materialTooltipOpen) &&
                    args.element.firstElementChild.innerText.length <= 4) {
                    args.element.style.transform = this.getTooltipTransformProperties(this.previousTooltipClass).rotate;
                }
            }
            this.tooltipCollidedPosition = args.collidedPosition;
        }
        if (this.isMaterialTooltip && this.tooltipElement && this.tooltipElement.style.transform.indexOf('translate') !== -1) {
            this.setTooltipTransform();
        }
    };
    Slider.prototype.setTooltipTransform = function () {
        var transformProperties = this.getTooltipTransformProperties(this.previousTooltipClass);
        if (this.tooltipElement.firstElementChild.innerText.length > 4) {
            this.tooltipElement.style.transform = transformProperties.translate + " scale(0.01)";
        }
        else {
            this.tooltipElement.style.transform = transformProperties.translate + " " + transformProperties.rotate + " scale(0.01)";
        }
    };
    Slider.prototype.renderTooltip = function () {
        this.tooltipObj = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__["b" /* Tooltip */]({
            showTipPointer: this.isBootstrap || this.isMaterial || this.isBootstrap4 || this.isTailwind || this.isBootstrap5 || this.isFluent,
            cssClass: classNames.sliderTooltip,
            height: this.isMaterial ? 30 : 'auto',
            animation: { open: { effect: 'None' }, close: { effect: 'FadeOut', duration: 500 } },
            opensOn: 'Custom',
            beforeOpen: this.tooltipBeforeOpen.bind(this),
            beforeCollision: this.checkTooltipPosition.bind(this),
            beforeClose: this.tooltipBeforeClose.bind(this),
            enableHtmlSanitizer: this.enableHtmlSanitizer
        });
        this.tooltipObj.appendTo(this.firstHandle);
        this.initializeTooltipProps();
    };
    Slider.prototype.initializeTooltipProps = function () {
        var tooltipShowOn = (this.tooltip.showOn === 'Auto' ? 'Hover' : this.tooltip.showOn);
        this.setProperties({ tooltip: { showOn: tooltipShowOn } }, true);
        this.tooltipObj.position = this.tooltipPlacement();
        this.tooltipCollision(this.tooltipObj.position);
        [this.firstHandle, this.rangeBar, this.secondHandle].forEach(function (handle) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(handle)) {
                handle.style.transition = 'none';
            }
        });
        if (this.isMaterialTooltip) {
            this.sliderContainer.classList.add(classNames.materialSlider);
            this.tooltipValue();
            this.tooltipObj.animation.close.effect = 'None';
            this.tooltipObj.open(this.firstHandle);
        }
    };
    Slider.prototype.tooltipBeforeClose = function () {
        this.tooltipElement = undefined;
        this.tooltipCollidedPosition = undefined;
    };
    Slider.prototype.setButtons = function () {
        this.firstBtn = this.createElement('div', { className: classNames.sliderButton + ' ' + classNames.firstButton });
        this.firstBtn.appendChild(this.createElement('span', { className: classNames.sliderButtonIcon }));
        if (this.isTailwind) {
            this.firstBtn.querySelector('span').classList.add('e-icons');
        }
        this.firstBtn.tabIndex = -1;
        this.secondBtn = this.createElement('div', { className: classNames.sliderButton + ' ' + classNames.secondButton });
        this.secondBtn.appendChild(this.createElement('span', { className: classNames.sliderButtonIcon }));
        if (this.isTailwind) {
            this.secondBtn.querySelector('span').classList.add('e-icons');
        }
        this.secondBtn.tabIndex = -1;
        this.sliderContainer.classList.add(classNames.sliderButtonClass);
        this.sliderContainer.appendChild(this.firstBtn);
        this.sliderContainer.appendChild(this.secondBtn);
        this.sliderContainer.appendChild(this.element);
        this.buttonTitle();
    };
    Slider.prototype.buttonTitle = function () {
        var enabledRTL = this.enableRtl && this.orientation !== 'Vertical';
        this.l10n.setLocale(this.locale);
        var decrementTitle = this.l10n.getConstant('decrementTitle');
        var incrementTitle = this.l10n.getConstant('incrementTitle');
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(enabledRTL ? this.secondBtn : this.firstBtn, { 'aria-label': decrementTitle, title: decrementTitle });
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(enabledRTL ? this.firstBtn : this.secondBtn, { 'aria-label': incrementTitle, title: incrementTitle });
    };
    Slider.prototype.buttonFocusOut = function () {
        if (this.isMaterial) {
            this.getHandle().classList.remove('e-large-thumb-size');
        }
    };
    Slider.prototype.repeatButton = function (args) {
        var hVal = this.handleValueUpdate();
        var enabledRTL = this.enableRtl && this.orientation !== 'Vertical';
        var value;
        if (args.target.parentElement.classList.contains(classNames.firstButton)
            || args.target.classList.contains(classNames.firstButton)) {
            enabledRTL ? (value = this.add(hVal, parseFloat(this.step.toString()), true)) :
                (value = this.add(hVal, parseFloat(this.step.toString()), false));
        }
        else if (args.target.parentElement.classList.contains(classNames.secondButton)
            || (args.target.classList.contains(classNames.secondButton))) {
            enabledRTL ? (value = this.add(hVal, parseFloat(this.step.toString()), false)) :
                (value = this.add(hVal, parseFloat(this.step.toString()), true));
        }
        if (this.limits.enabled) {
            value = this.getLimitCorrectedValues(value);
        }
        if (value >= this.min && value <= this.max) {
            this.changeHandleValue(value);
            this.tooltipToggle(this.getHandle());
        }
    };
    Slider.prototype.repeatHandlerMouse = function (args) {
        args.preventDefault();
        if (args.type === ('mousedown') || args.type === ('touchstart')) {
            this.buttonClick(args);
            this.repeatInterval = setInterval(this.repeatButton.bind(this), 180, args);
        }
    };
    Slider.prototype.materialChange = function () {
        if (!this.getHandle().classList.contains('e-large-thumb-size')) {
            this.getHandle().classList.add('e-large-thumb-size');
        }
    };
    Slider.prototype.focusHandle = function () {
        if (!this.getHandle().classList.contains(classNames.sliderTabHandle)) {
            this.getHandle().classList.add(classNames.sliderTabHandle);
        }
    };
    Slider.prototype.repeatHandlerUp = function (e) {
        this.changeEvent('changed', e);
        this.closeTooltip();
        clearInterval(this.repeatInterval);
        this.getHandle().focus();
    };
    Slider.prototype.customTickCounter = function (bigNum) {
        var tickCount = 4;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customValues) && this.customValues.length > 0) {
            if (bigNum > 4) {
                tickCount = 3;
            }
            if (bigNum > 7) {
                tickCount = 2;
            }
            if (bigNum > 14) {
                tickCount = 1;
            }
            if (bigNum > 28) {
                tickCount = 0;
            }
        }
        return tickCount;
    };
    // tslint:disable-next-line:max-func-body-length
    Slider.prototype.renderScale = function () {
        var liElementPosition = 0;
        var orien = this.orientation === 'Vertical' ? 'v' : 'h';
        var spanText;
        this.noOfDecimals = this.numberOfDecimals(this.step);
        this.ul = this.createElement('ul', {
            className: classNames.scale + ' ' + 'e-' + orien + '-scale ' + classNames.tick + '-' + this.ticks.placement.toLowerCase(),
            attrs: { role: 'presentation', tabIndex: '-1', 'aria-hidden': 'true' }
        });
        this.ul.style.zIndex = '-1';
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isAndroid && orien === 'h') {
            this.ul.classList.add(classNames.sliderTickPosition);
        }
        var smallStep = this.ticks.smallStep;
        if (!this.ticks.showSmallTicks) {
            this.ticks.largeStep > 0 ? (smallStep = this.ticks.largeStep) :
                (smallStep = (parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.max))) - (parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.min))));
        }
        else if (smallStep <= 0) {
            smallStep = parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.step));
        }
        var min = this.fractionalToInteger(this.min);
        var max = this.fractionalToInteger(this.max);
        var steps = this.fractionalToInteger(smallStep);
        var bigNum = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customValues) && this.customValues.length > 0 && this.customValues.length - 1;
        var customStep = this.customTickCounter(bigNum);
        var count = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customValues) && this.customValues.length > 0 ?
            (bigNum * customStep) + bigNum : Math.abs((max - min) / steps);
        this.element.appendChild(this.ul);
        var li;
        var start = parseFloat(this.min.toString());
        if (orien === 'v') {
            start = parseFloat(this.max.toString());
        }
        var left = 0;
        var islargeTick;
        var tickWidth = 100 / count;
        if (tickWidth === Infinity) {
            tickWidth = 5;
        }
        for (var i = 0, y = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customValues) && this.customValues.length > 0 ?
            this.customValues.length - 1 : 0, k = 0; i <= count; i++) {
            li = (this.createElement('li', {
                attrs: {
                    class: classNames.tick, role: 'presentation', tabIndex: '-1',
                    'aria-hidden': 'true'
                }
            }));
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customValues) && this.customValues.length > 0) {
                islargeTick = i % (customStep + 1) === 0;
                if (islargeTick) {
                    if (orien === 'h') {
                        start = this.customValues[k];
                        k++;
                    }
                    else {
                        start = this.customValues[y];
                        y--;
                    }
                    li.setAttribute('title', start.toString());
                }
            }
            else {
                li.setAttribute('title', start.toString());
                if (this.numberOfDecimals(this.max) === 0 && this.numberOfDecimals(this.min) === 0 &&
                    this.numberOfDecimals(this.step) === 0) {
                    if (orien === 'h') {
                        islargeTick = ((start - parseFloat(this.min.toString())) % this.ticks.largeStep === 0) ? true : false;
                    }
                    else {
                        islargeTick = (Math.abs(start - parseFloat(this.max.toString())) % this.ticks.largeStep === 0) ? true : false;
                    }
                }
                else {
                    var largestep = this.fractionalToInteger(this.ticks.largeStep);
                    var startValue = this.fractionalToInteger(start);
                    if (orien === 'h') {
                        islargeTick = ((startValue - min) % largestep === 0) ? true : false;
                    }
                    else {
                        islargeTick = (Math.abs(startValue - parseFloat(max.toString())) % largestep === 0) ? true : false;
                    }
                }
            }
            if (islargeTick) {
                li.classList.add(classNames.large);
            }
            (orien === 'h') ? (li.style.width = tickWidth + '%') : (li.style.height = tickWidth + '%');
            var repeat = islargeTick ? (this.ticks.placement === 'Both' ? 2 : 1) : 0;
            if (islargeTick) {
                for (var j = 0; j < repeat; j++) {
                    this.createTick(li, start, tickWidth);
                }
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customValues)) {
                this.formatTicksValue(li, start);
            }
            this.ul.appendChild(li);
            this.tickElementCollection.push(li);
            var decimalPoints = void 0;
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customValues)) {
                if (this.numberOfDecimals(smallStep) > this.numberOfDecimals(start)) {
                    decimalPoints = this.numberOfDecimals(smallStep);
                }
                else {
                    decimalPoints = this.numberOfDecimals(start);
                }
                if (orien === 'h') {
                    start = this.makeRoundNumber(start + smallStep, decimalPoints);
                }
                else {
                    start = this.makeRoundNumber(start - smallStep, decimalPoints);
                }
                left = this.makeRoundNumber(left + smallStep, decimalPoints);
            }
        }
        this.ticksAlignment(orien, tickWidth);
    };
    Slider.prototype.ticksAlignment = function (orien, tickWidth, triggerEvent) {
        if (triggerEvent === void 0) { triggerEvent = true; }
        this.firstChild = this.ul.firstElementChild;
        this.lastChild = this.ul.lastElementChild;
        this.firstChild.classList.add(classNames.sliderFirstTick);
        this.lastChild.classList.add(classNames.sliderLastTick);
        this.sliderContainer.classList.add(classNames.scale + '-' + this.ticks.placement.toLowerCase());
        if (orien === 'h') {
            this.firstChild.style.width = tickWidth / 2 + '%';
            this.lastChild.style.width = tickWidth / 2 + '%';
        }
        else {
            this.firstChild.style.height = tickWidth / 2 + '%';
            this.lastChild.style.height = tickWidth / 2 + '%';
        }
        var eventArgs = { ticksWrapper: this.ul, tickElements: this.tickElementCollection };
        if (triggerEvent) {
            this.trigger('renderedTicks', eventArgs);
        }
        this.scaleAlignment();
    };
    Slider.prototype.createTick = function (li, start, tickWidth) {
        var span = this.createElement('span', {
            className: classNames.tickValue + ' ' + classNames.tick + '-' + this.ticks.placement.toLowerCase(),
            attrs: { role: 'presentation', tabIndex: '-1', 'aria-hidden': 'true' }
        });
        li.appendChild(span);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customValues)) {
            this.formatTicksValue(li, start, span, tickWidth);
        }
        else {
            if (this.enableHtmlSanitizer) {
                span.innerHTML = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(start.toString());
            }
            else {
                span.innerHTML = start.toString();
            }
        }
    };
    Slider.prototype.formatTicksValue = function (li, start, spanElement, tickWidth) {
        var _this = this;
        var tickText = this.formatNumber(start);
        var text = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.ticks) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.ticks.format) ?
            this.formatString(start, this.ticksFormatInfo).formatString : tickText;
        var eventArgs = { value: start, text: text, tickElement: li };
        this.trigger('renderingTicks', eventArgs, function (observedArgs) {
            li.setAttribute('title', observedArgs.text.toString());
            if (spanElement) {
                if (_this.enableHtmlSanitizer) {
                    spanElement.innerHTML = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(observedArgs.text.toString());
                }
                else {
                    spanElement.innerHTML = observedArgs.text.toString();
                }
            }
        });
    };
    Slider.prototype.scaleAlignment = function () {
        this.tickValuePosition();
        var smallTick = 12;
        var largeTick = 20;
        var half = largeTick / 2;
        var orien = this.orientation === 'Vertical' ? 'v' : 'h';
        if (this.orientation === 'Vertical') {
            (this.element.getBoundingClientRect().width <= 15) ?
                this.sliderContainer.classList.add(classNames.sliderSmallSize) :
                this.sliderContainer.classList.remove(classNames.sliderSmallSize);
        }
        else {
            (this.element.getBoundingClientRect().height <= 15) ?
                this.sliderContainer.classList.add(classNames.sliderSmallSize) :
                this.sliderContainer.classList.remove(classNames.sliderSmallSize);
        }
    };
    Slider.prototype.tickValuePosition = function () {
        this.firstChild = this.element.querySelector('ul').children[0];
        var first = this.firstChild.getBoundingClientRect();
        var firstChild;
        var otherChild;
        var smallStep = this.ticks.smallStep;
        var count = Math.abs((parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.max))) - (parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.min)))) / smallStep;
        if (this.firstChild.children.length > 0) {
            firstChild = this.firstChild.children[0].getBoundingClientRect();
        }
        var tickElements = [this.sliderContainer.querySelectorAll('.' + classNames.tick + '.' +
                classNames.large + ' .' + classNames.tickValue)];
        var other;
        if (this.ticks.placement === 'Both') {
            other = [].slice.call(tickElements[0], 2);
        }
        else {
            other = [].slice.call(tickElements[0], 1);
        }
        var tickWidth = this.orientation === 'Vertical' ?
            (first.height * 2) : (first.width * 2);
        for (var i = 0; i < this.firstChild.children.length; i++) {
            if (this.orientation === 'Vertical') {
                this.firstChild.children[i].style.top = -(firstChild.height / 2) + 'px';
            }
            else {
                if (!this.enableRtl) {
                    this.firstChild.children[i].style.left = -(firstChild.width / 2) + 'px';
                }
                else {
                    this.firstChild.children[i].style.left = (tickWidth -
                        this.firstChild.children[i].getBoundingClientRect().width) / 2 + 'px';
                }
            }
        }
        for (var i = 0; i < other.length; i++) {
            otherChild = other[i].getBoundingClientRect();
            if (this.orientation === 'Vertical') {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(other[i], { top: (tickWidth - otherChild.height) / 2 + 'px' });
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(other[i], { left: (tickWidth - otherChild.width) / 2 + 'px' });
            }
        }
        if (this.enableRtl && this.lastChild.children.length && count !== 0) {
            this.lastChild.children[0].style.left = -(this.lastChild.getBoundingClientRect().width / 2) + 'px';
            if (this.ticks.placement === 'Both') {
                this.lastChild.children[1].style.left = -(this.lastChild.getBoundingClientRect().width / 2) + 'px';
            }
        }
        if (count === 0) {
            if (this.orientation === 'Horizontal') {
                if (!this.enableRtl) {
                    this.firstChild.classList.remove(classNames.sliderLastTick);
                    this.firstChild.style.left = this.firstHandle.style.left;
                }
                else {
                    this.firstChild.classList.remove(classNames.sliderLastTick);
                    this.firstChild.style.right = this.firstHandle.style.right;
                    this.firstChild.children[0].style.left =
                        (this.firstChild.getBoundingClientRect().width / 2) + 2 + 'px';
                    if (this.ticks.placement === 'Both') {
                        this.firstChild.children[1].style.left =
                            (this.firstChild.getBoundingClientRect().width / 2) + 2 + 'px';
                    }
                }
            }
            if (this.orientation === 'Vertical') {
                this.firstChild.classList.remove(classNames.sliderLastTick);
            }
        }
    };
    Slider.prototype.setAriaAttrValue = function (element) {
        var ariaValueText;
        var isTickFormatted = ((!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.ticks) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.ticks.format))) ? true : false;
        var text = !isTickFormatted ?
            this.formatContent(this.ticksFormatInfo, false) : this.formatContent(this.tooltipFormatInfo, false);
        var valuenow = isTickFormatted ? this.formatContent(this.ticksFormatInfo, true) :
            this.formatContent(this.tooltipFormatInfo, true);
        text = (!this.customAriaText) ? (text) : (this.customAriaText);
        if (text.split(' - ').length === 2) {
            ariaValueText = text.split(' - ');
        }
        else {
            ariaValueText = [text, text];
        }
        this.setAriaAttributes(element);
        if (this.type !== 'Range') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(element, { 'aria-valuenow': valuenow, 'aria-valuetext': text });
        }
        else {
            // eslint-disable-next-line
            (!this.enableRtl) ? ((element === this.firstHandle) ?
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(element, { 'aria-valuenow': valuenow.split(' - ')[0], 'aria-valuetext': ariaValueText[0] }) :
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(element, { 'aria-valuenow': valuenow.split(' - ')[1], 'aria-valuetext': ariaValueText[1] })) :
                ((element === this.firstHandle) ?
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(element, { 'aria-valuenow': valuenow.split(' - ')[1], 'aria-valuetext': ariaValueText[1] }) :
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(element, { 'aria-valuenow': valuenow.split(' - ')[0], 'aria-valuetext': ariaValueText[0] }));
        }
    };
    Slider.prototype.handleValueUpdate = function () {
        var hVal;
        if (this.type === 'Range') {
            if (this.activeHandle === 1) {
                hVal = this.handleVal1;
            }
            else {
                hVal = this.handleVal2;
            }
        }
        else {
            hVal = this.handleVal1;
        }
        return hVal;
    };
    Slider.prototype.getLimitCorrectedValues = function (value) {
        if (this.type === 'MinRange' || this.type === 'Default') {
            value = (this.getLimitValueAndPosition(value, this.limits.minStart, this.limits.minEnd))[0];
        }
        else {
            if (this.activeHandle === 1) {
                value = (this.getLimitValueAndPosition(value, this.limits.minStart, this.limits.minEnd))[0];
            }
            else {
                value = (this.getLimitValueAndPosition(value, this.limits.maxStart, this.limits.maxEnd))[0];
            }
        }
        return value;
    };
    Slider.prototype.focusSliderElement = function () {
        if (!this.isElementFocused) {
            this.element.focus();
            this.isElementFocused = true;
        }
    };
    Slider.prototype.buttonClick = function (args) {
        this.focusSliderElement();
        var value;
        var enabledRTL = this.enableRtl && this.orientation !== 'Vertical';
        var hVal = this.handleValueUpdate();
        if ((args.keyCode === 40) || (args.keyCode === 37)
            || args.currentTarget.classList.contains(classNames.firstButton)) {
            // eslint-disable-next-line
            enabledRTL ? (value = this.add(hVal, parseFloat(this.step.toString()), true)) :
                (value = this.add(hVal, parseFloat(this.step.toString()), false));
        }
        else if ((args.keyCode === 38) || (args.keyCode === 39) ||
            args.currentTarget.classList.contains(classNames.secondButton)) {
            // eslint-disable-next-line
            enabledRTL ? (value = this.add(hVal, parseFloat(this.step.toString()), false)) :
                (value = this.add(hVal, parseFloat(this.step.toString()), true));
        }
        else if ((args.keyCode === 33
            || args.currentTarget.classList.contains(classNames.firstButton))) {
            // eslint-disable-next-line
            enabledRTL ? (value = this.add(hVal, parseFloat(this.ticks.largeStep.toString()), false)) :
                (value = this.add(hVal, parseFloat(this.ticks.largeStep.toString()), true));
        }
        else if ((args.keyCode === 34) ||
            args.currentTarget.classList.contains(classNames.secondButton)) {
            // eslint-disable-next-line
            enabledRTL ? (value = this.add(hVal, parseFloat(this.ticks.largeStep.toString()), true)) :
                (value = this.add(hVal, parseFloat(this.ticks.largeStep.toString()), false));
        }
        else if ((args.keyCode === 36)) {
            value = parseFloat(this.min.toString());
        }
        else if ((args.keyCode === 35)) {
            value = parseFloat(this.max.toString());
        }
        if (this.limits.enabled) {
            value = this.getLimitCorrectedValues(value);
        }
        this.changeHandleValue(value);
        if (this.isMaterial && !this.tooltip.isVisible &&
            !this.getHandle().classList.contains(classNames.sliderTabHandle)) {
            this.materialChange();
        }
        this.tooltipToggle(this.getHandle());
        this.getHandle().focus();
        this.focusHandle();
        if (args.currentTarget.classList.contains(classNames.firstButton)) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.firstBtn, 'mouseup touchend', this.buttonUp, this);
        }
        if (args.currentTarget.classList.contains(classNames.secondButton)) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.secondBtn, 'mouseup touchend', this.buttonUp, this);
        }
    };
    Slider.prototype.tooltipToggle = function (target) {
        if (this.isMaterialTooltip) {
            // eslint-disable-next-line
            !this.tooltipElement.classList.contains(classNames.materialTooltipOpen) ?
                this.openMaterialTooltip() : this.refreshTooltip(this.firstHandle);
        }
        else {
            // eslint-disable-next-line
            !this.tooltipElement ? this.openTooltip(target) : this.refreshTooltip(target);
        }
    };
    Slider.prototype.buttonUp = function (args) {
        if (args.currentTarget.classList.contains(classNames.firstButton)) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.firstBtn, 'mouseup touchend', this.buttonUp);
        }
        if (args.currentTarget.classList.contains(classNames.secondButton)) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.secondBtn, 'mouseup touchend', this.buttonUp);
        }
    };
    Slider.prototype.setRangeBar = function () {
        if (this.orientation === 'Horizontal') {
            if (this.type === 'MinRange') {
                // eslint-disable-next-line
                this.enableRtl ? (this.rangeBar.style.right = '0px') : (this.rangeBar.style.left = '0px');
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.rangeBar, { 'width': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.handlePos1) ? 0 : this.handlePos1 + 'px' });
            }
            else {
                // eslint-disable-next-line
                this.enableRtl ? (this.rangeBar.style.right =
                    this.handlePos1 + 'px') : (this.rangeBar.style.left = this.handlePos1 + 'px');
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.rangeBar, { 'width': this.handlePos2 - this.handlePos1 + 'px' });
            }
        }
        else {
            if (this.type === 'MinRange') {
                this.rangeBar.style.bottom = '0px';
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.rangeBar, { 'height': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.handlePos1) ? 0 : this.handlePos1 + 'px' });
            }
            else {
                this.rangeBar.style.bottom = this.handlePos1 + 'px';
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.rangeBar, { 'height': this.handlePos2 - this.handlePos1 + 'px' });
            }
        }
    };
    Slider.prototype.checkValidValueAndPos = function (value) {
        value = this.checkHandleValue(value);
        value = this.checkHandlePosition(value);
        return value;
    };
    Slider.prototype.setLimitBarPositions = function (fromMinPostion, fromMaxpostion, toMinPostion, toMaxpostion) {
        if (this.orientation === 'Horizontal') {
            if (!this.enableRtl) {
                this.limitBarFirst.style.left = fromMinPostion + 'px';
                this.limitBarFirst.style.width = (fromMaxpostion - fromMinPostion) + 'px';
            }
            else {
                this.limitBarFirst.style.right = fromMinPostion + 'px';
                this.limitBarFirst.style.width = (fromMaxpostion - fromMinPostion) + 'px';
            }
        }
        else {
            this.limitBarFirst.style.bottom = fromMinPostion + 'px';
            this.limitBarFirst.style.height = (fromMaxpostion - fromMinPostion) + 'px';
        }
        if (this.type === 'Range') {
            if (this.orientation === 'Horizontal') {
                if (!this.enableRtl) {
                    this.limitBarSecond.style.left = toMinPostion + 'px';
                    this.limitBarSecond.style.width = (toMaxpostion - toMinPostion) + 'px';
                }
                else {
                    this.limitBarSecond.style.right = toMinPostion + 'px';
                    this.limitBarSecond.style.width = (toMaxpostion - toMinPostion) + 'px';
                }
            }
            else {
                this.limitBarSecond.style.bottom = toMinPostion + 'px';
                this.limitBarSecond.style.height = (toMaxpostion - toMinPostion) + 'px';
            }
        }
    };
    Slider.prototype.setLimitBar = function () {
        if (this.type === 'Default' || this.type === 'MinRange') {
            var fromPosition = (this.getLimitValueAndPosition(this.limits.minStart, this.limits.minStart, this.limits.minEnd, true))[0];
            fromPosition = this.checkValidValueAndPos(fromPosition);
            var toPosition = (this.getLimitValueAndPosition(this.limits.minEnd, this.limits.minStart, this.limits.minEnd, true))[0];
            toPosition = this.checkValidValueAndPos(toPosition);
            this.setLimitBarPositions(fromPosition, toPosition);
        }
        else if (this.type === 'Range') {
            var fromMinPostion = (this.getLimitValueAndPosition(this.limits.minStart, this.limits.minStart, this.limits.minEnd, true))[0];
            fromMinPostion = this.checkValidValueAndPos(fromMinPostion);
            var fromMaxpostion = (this.getLimitValueAndPosition(this.limits.minEnd, this.limits.minStart, this.limits.minEnd, true))[0];
            fromMaxpostion = this.checkValidValueAndPos(fromMaxpostion);
            var toMinPostion = (this.getLimitValueAndPosition(this.limits.maxStart, this.limits.maxStart, this.limits.maxEnd, true))[0];
            toMinPostion = this.checkValidValueAndPos(toMinPostion);
            var toMaxpostion = (this.getLimitValueAndPosition(this.limits.maxEnd, this.limits.maxStart, this.limits.maxEnd, true))[0];
            toMaxpostion = this.checkValidValueAndPos(toMaxpostion);
            this.setLimitBarPositions(fromMinPostion, fromMaxpostion, toMinPostion, toMaxpostion);
        }
    };
    Slider.prototype.getLimitValueAndPosition = function (currentValue, minValue, maxValue, limitBar) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(minValue)) {
            minValue = this.min;
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(currentValue) && limitBar) {
                currentValue = minValue;
            }
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(maxValue)) {
            maxValue = this.max;
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(currentValue) && limitBar) {
                currentValue = maxValue;
            }
        }
        if (currentValue < minValue) {
            currentValue = minValue;
        }
        if (currentValue > maxValue) {
            currentValue = maxValue;
        }
        return [currentValue, this.checkHandlePosition(currentValue)];
    };
    Slider.prototype.setValue = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customValues) && this.customValues.length > 0) {
            this.min = 0;
            this.max = this.customValues.length - 1;
            this.setBarColor();
        }
        this.setAriaAttributes(this.firstHandle);
        this.handleVal1 = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.value) ? this.checkHandleValue(parseFloat(this.min.toString())) :
            this.checkHandleValue(parseFloat(this.value.toString()));
        this.handlePos1 = this.checkHandlePosition(this.handleVal1);
        this.preHandlePos1 = this.handlePos1;
        // eslint-disable-next-line
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.activeHandle) ? (this.type === 'Range' ? this.activeHandle = 2 : this.activeHandle = 1) :
            // eslint-disable-next-line no-self-assign
            this.activeHandle = this.activeHandle;
        if (this.type === 'Default' || this.type === 'MinRange') {
            if (this.limits.enabled) {
                var values = this.getLimitValueAndPosition(this.handleVal1, this.limits.minStart, this.limits.minEnd);
                this.handleVal1 = values[0];
                this.handlePos1 = values[1];
                this.preHandlePos1 = this.handlePos1;
            }
            this.setHandlePosition(null);
            this.handleStart();
            this.value = this.handleVal1;
            this.setAriaAttrValue(this.firstHandle);
            this.changeEvent('changed', null);
        }
        else {
            this.validateRangeValue();
        }
        if (this.type !== 'Default') {
            this.setRangeBar();
        }
        if (this.limits.enabled) {
            this.setLimitBar();
        }
    };
    Slider.prototype.rangeValueUpdate = function () {
        if (this.value === null || typeof (this.value) !== 'object') {
            this.value = [parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.min)), parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.max))];
        }
    };
    Slider.prototype.validateRangeValue = function () {
        this.rangeValueUpdate();
        this.setRangeValue();
    };
    Slider.prototype.modifyZindex = function () {
        if (this.type === 'Range') {
            if (this.activeHandle === 1) {
                this.firstHandle.style.zIndex = (this.zIndex + 4) + '';
                this.secondHandle.style.zIndex = (this.zIndex + 3) + '';
            }
            else {
                this.firstHandle.style.zIndex = (this.zIndex + 3) + '';
                this.secondHandle.style.zIndex = (this.zIndex + 4) + '';
            }
        }
        else if (this.isMaterialTooltip && this.tooltipElement) {
            this.tooltipElement.style.zIndex = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__["g" /* getZindexPartial */])(this.element) + '';
        }
    };
    Slider.prototype.setHandlePosition = function (event) {
        var _this = this;
        var handle;
        var pos = (this.activeHandle === 1) ? this.handlePos1 : this.handlePos2;
        if (this.isMaterialTooltip) {
            handle = [this.firstHandle, this.materialHandle];
        }
        else {
            handle = [this.getHandle()];
        }
        this.handleStart();
        handle.forEach(function (handle) {
            if (_this.orientation === 'Horizontal') {
                // eslint-disable-next-line
                _this.enableRtl ? (handle.style.right =
                    pos + "px") : (handle.style.left = pos + "px");
            }
            else {
                handle.style.bottom = pos + "px";
            }
        });
        this.changeEvent('change', event);
    };
    Slider.prototype.getHandle = function () {
        return (this.activeHandle === 1) ? this.firstHandle : this.secondHandle;
    };
    Slider.prototype.setRangeValue = function () {
        this.updateRangeValue();
        this.activeHandle = 1;
        this.setHandlePosition(null);
        this.activeHandle = 2;
        this.setHandlePosition(null);
        this.activeHandle = 1;
    };
    Slider.prototype.changeEvent = function (eventName, e) {
        var previous = eventName === 'change' ? this.previousVal : this.previousChanged;
        if (this.type !== 'Range') {
            this.setProperties({ 'value': this.handleVal1 }, true);
            if (previous !== this.value && (!this.isMaterialTooltip || !this.initialTooltip)) {
                this.trigger(eventName, this.changeEventArgs(eventName, e));
                this.initialTooltip = true;
                this.setPreviousVal(eventName, this.value);
            }
            this.setAriaAttrValue(this.firstHandle);
        }
        else {
            var value = this.value = [this.handleVal1, this.handleVal2];
            this.setProperties({ 'value': value }, true);
            if (previous.length === this.value.length
                && this.value[0] !== previous[0] || this.value[1] !== previous[1]) {
                this.initialTooltip = false;
                this.trigger(eventName, this.changeEventArgs(eventName, e));
                this.initialTooltip = true;
                this.setPreviousVal(eventName, this.value);
            }
            this.setAriaAttrValue(this.getHandle());
        }
        this.hiddenInput.value = this.value.toString();
    };
    Slider.prototype.changeEventArgs = function (eventName, e) {
        var eventArgs;
        if (this.tooltip.isVisible && this.tooltipObj && this.initialTooltip) {
            this.tooltipValue();
            eventArgs = {
                value: this.value,
                previousValue: eventName === 'change' ? this.previousVal : this.previousChanged,
                action: eventName, text: this.tooltipObj.content, isInteracted: Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e) ? false : true
            };
        }
        else {
            eventArgs = {
                value: this.value,
                previousValue: eventName === 'change' ? this.previousVal : this.previousChanged,
                action: eventName, text: Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.ticksFormatInfo.format) ? this.value.toString() :
                    (this.type !== 'Range' ? this.formatString(this.value, this.ticksFormatInfo).formatString :
                        (this.formatString(this.value[0], this.ticksFormatInfo).formatString + ' - ' +
                            this.formatString(this.value[1], this.ticksFormatInfo).formatString)),
                isInteracted: Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e) ? false : true
            };
        }
        return eventArgs;
    };
    Slider.prototype.setPreviousVal = function (eventName, value) {
        if (eventName === 'change') {
            this.previousVal = value;
        }
        else {
            this.previousChanged = value;
        }
    };
    Slider.prototype.updateRangeValue = function () {
        var values = this.value.toString().split(',').map(Number);
        if ((this.enableRtl && this.orientation !== 'Vertical') || this.rtl) {
            this.value = [values[1], values[0]];
        }
        else {
            this.value = [values[0], values[1]];
        }
        if (this.enableRtl && this.orientation !== 'Vertical') {
            this.handleVal1 = this.checkHandleValue(this.value[1]);
            this.handleVal2 = this.checkHandleValue(this.value[0]);
        }
        else {
            this.handleVal1 = this.checkHandleValue(this.value[0]);
            this.handleVal2 = this.checkHandleValue(this.value[1]);
        }
        this.handlePos1 = this.checkHandlePosition(this.handleVal1);
        this.handlePos2 = this.checkHandlePosition(this.handleVal2);
        if (this.handlePos1 > this.handlePos2) {
            this.handlePos1 = this.handlePos2;
            this.handleVal1 = this.handleVal2;
        }
        this.preHandlePos1 = this.handlePos1;
        this.preHandlePos2 = this.handlePos2;
        if (this.limits.enabled) {
            this.activeHandle = 1;
            var values_1 = this.getLimitValueAndPosition(this.handleVal1, this.limits.minStart, this.limits.minEnd);
            this.handleVal1 = values_1[0];
            this.handlePos1 = values_1[1];
            this.preHandlePos1 = this.handlePos1;
            this.activeHandle = 2;
            values_1 = this.getLimitValueAndPosition(this.handleVal2, this.limits.maxStart, this.limits.maxEnd);
            this.handleVal2 = values_1[0];
            this.handlePos2 = values_1[1];
            this.preHandlePos2 = this.handlePos2;
        }
    };
    Slider.prototype.checkHandlePosition = function (value) {
        var pos;
        value = (100 *
            (value - (parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.min))))) / ((parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.max))) - (parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.min))));
        if (this.orientation === 'Horizontal') {
            pos = this.element.getBoundingClientRect().width * (value / 100);
        }
        else {
            pos = this.element.getBoundingClientRect().height * (value / 100);
        }
        if (((parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.max))) === (parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.min))))) {
            if (this.orientation === 'Horizontal') {
                pos = this.element.getBoundingClientRect().width;
            }
            else {
                pos = this.element.getBoundingClientRect().height;
            }
        }
        return pos;
    };
    Slider.prototype.checkHandleValue = function (value) {
        if (this.min > this.max) {
            this.min = this.max;
        }
        if (this.min === this.max) {
            return (parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.max)));
        }
        var handle = this.tempStartEnd();
        if (value < handle.start) {
            value = handle.start;
        }
        else if (value > handle.end) {
            value = handle.end;
        }
        return value;
    };
    /**
     * It is used to reposition slider.
     * @returns void
     */
    Slider.prototype.reposition = function () {
        var _this = this;
        this.firstHandle.style.transition = 'none';
        if (this.type !== 'Default') {
            this.rangeBar.style.transition = 'none';
        }
        if (this.type === 'Range') {
            this.secondHandle.style.transition = 'none';
        }
        this.handlePos1 = this.checkHandlePosition(this.handleVal1);
        if (this.handleVal2) {
            this.handlePos2 = this.checkHandlePosition(this.handleVal2);
        }
        if (this.orientation === 'Horizontal') {
            // eslint-disable-next-line
            this.enableRtl ? this.firstHandle.style.right =
                this.handlePos1 + "px" : this.firstHandle.style.left = this.handlePos1 + "px";
            if (this.isMaterialTooltip) {
                // eslint-disable-next-line
                this.enableRtl ? this.materialHandle.style.right =
                    this.handlePos1 + "px" : this.materialHandle.style.left = this.handlePos1 + "px";
            }
            if (this.type === 'MinRange') {
                // eslint-disable-next-line
                this.enableRtl ? (this.rangeBar.style.right = '0px') : (this.rangeBar.style.left = '0px');
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.rangeBar, { 'width': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.handlePos1) ? 0 : this.handlePos1 + 'px' });
            }
            else if (this.type === 'Range') {
                // eslint-disable-next-line
                this.enableRtl ? this.secondHandle.style.right =
                    this.handlePos2 + "px" : this.secondHandle.style.left = this.handlePos2 + "px";
                // eslint-disable-next-line
                this.enableRtl ? (this.rangeBar.style.right =
                    this.handlePos1 + 'px') : (this.rangeBar.style.left = this.handlePos1 + 'px');
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.rangeBar, { 'width': this.handlePos2 - this.handlePos1 + 'px' });
            }
        }
        else {
            this.firstHandle.style.bottom = this.handlePos1 + "px";
            if (this.isMaterialTooltip) {
                this.materialHandle.style.bottom = this.handlePos1 + "px";
            }
            if (this.type === 'MinRange') {
                this.rangeBar.style.bottom = '0px';
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.rangeBar, { 'height': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.handlePos1) ? 0 : this.handlePos1 + 'px' });
            }
            else if (this.type === 'Range') {
                this.secondHandle.style.bottom = this.handlePos2 + "px";
                this.rangeBar.style.bottom = this.handlePos1 + 'px';
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.rangeBar, { 'height': this.handlePos2 - this.handlePos1 + 'px' });
            }
        }
        if (this.limits.enabled) {
            this.setLimitBar();
        }
        if (this.ticks.placement !== 'None' && this.ul) {
            this.removeElement(this.ul);
            this.ul = undefined;
            this.renderScale();
        }
        this.handleStart();
        if (!this.tooltip.isVisible) {
            setTimeout(function () {
                _this.firstHandle.style.transition = _this.scaleTransform;
                if (_this.type === 'Range') {
                    _this.secondHandle.style.transition = _this.scaleTransform;
                }
            });
        }
        this.refreshTooltip(this.tooltipTarget);
        this.setBarColor();
    };
    Slider.prototype.changeHandleValue = function (value) {
        var position = null;
        if (this.activeHandle === 1) {
            if (!(this.limits.enabled && this.limits.startHandleFixed)) {
                this.handleVal1 = this.checkHandleValue(value);
                this.handlePos1 = this.checkHandlePosition(this.handleVal1);
                if (this.type === 'Range' && this.handlePos1 > this.handlePos2) {
                    this.handlePos1 = this.handlePos2;
                    this.handleVal1 = this.handleVal2;
                }
                if (this.handlePos1 !== this.preHandlePos1) {
                    position = this.preHandlePos1 = this.handlePos1;
                }
            }
            this.modifyZindex();
        }
        else {
            if (!(this.limits.enabled && this.limits.endHandleFixed)) {
                this.handleVal2 = this.checkHandleValue(value);
                this.handlePos2 = this.checkHandlePosition(this.handleVal2);
                if (this.type === 'Range' && this.handlePos2 < this.handlePos1) {
                    this.handlePos2 = this.handlePos1;
                    this.handleVal2 = this.handleVal1;
                }
                if (this.handlePos2 !== this.preHandlePos2) {
                    position = this.preHandlePos2 = this.handlePos2;
                }
            }
            this.modifyZindex();
        }
        if (position !== null) {
            if (this.type !== 'Default') {
                this.setRangeBar();
            }
            this.setHandlePosition(null);
        }
    };
    // eslint-disable-next-line
    Slider.prototype.tempStartEnd = function () {
        if (this.min > this.max) {
            return {
                start: this.max,
                end: this.min
            };
        }
        else {
            return {
                start: this.min,
                end: this.max
            };
        }
    };
    // eslint-disable-next-line
    Slider.prototype.xyToPosition = function (position) {
        var pos;
        if (this.min === this.max) {
            return 100;
        }
        if (this.orientation === 'Horizontal') {
            var left = position.x - this.element.getBoundingClientRect().left;
            var num = this.element.offsetWidth / 100;
            this.val = (left / num);
        }
        else {
            var top_1 = position.y - this.element.getBoundingClientRect().top;
            var num = this.element.offsetHeight / 100;
            this.val = 100 - (top_1 / num);
        }
        var val = this.stepValueCalculation(this.val);
        if (val < 0) {
            val = 0;
        }
        else if (val > 100) {
            val = 100;
        }
        if (this.enableRtl && this.orientation !== 'Vertical') {
            val = 100 - val;
        }
        if (this.orientation === 'Horizontal') {
            pos = this.element.getBoundingClientRect().width * (val / 100);
        }
        else {
            pos = this.element.getBoundingClientRect().height * (val / 100);
        }
        return pos;
    };
    Slider.prototype.stepValueCalculation = function (value) {
        if (this.step === 0) {
            this.step = 1;
        }
        var percentStep = (parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.step))) / ((parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.max)) - parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.min))) / 100);
        var remain = value % Math.abs(percentStep);
        if (remain !== 0) {
            if ((percentStep / 2) > remain) {
                value -= remain;
            }
            else {
                value += Math.abs(percentStep) - remain;
            }
        }
        return value;
    };
    Slider.prototype.add = function (a, b, addition) {
        var precision;
        var x = Math.pow(10, precision || 3);
        var val;
        if (addition) {
            val = (Math.round(a * x) + Math.round(b * x)) / x;
        }
        else {
            val = (Math.round(a * x) - Math.round(b * x)) / x;
        }
        return val;
    };
    Slider.prototype.positionToValue = function (pos) {
        var val;
        var diff = parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.max)) - parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.min));
        if (this.orientation === 'Horizontal') {
            val = (pos / this.element.getBoundingClientRect().width) * diff;
        }
        else {
            val = (pos / this.element.getBoundingClientRect().height) * diff;
        }
        var total = this.add(val, parseFloat(this.min.toString()), true);
        return (total);
    };
    Slider.prototype.sliderBarClick = function (evt) {
        evt.preventDefault();
        // eslint-disable-next-line
        var pos;
        if (evt.type === 'mousedown' || evt.type === 'mouseup' || evt.type === 'click') {
            pos = { x: evt.clientX, y: evt.clientY };
        }
        else if (evt.type === 'touchend' || evt.type === 'touchstart') {
            pos = { x: evt.changedTouches[0].clientX, y: evt.changedTouches[0].clientY };
        }
        var handlepos = this.xyToPosition(pos);
        var handleVal = this.positionToValue(handlepos);
        if (this.type === 'Range' && (this.handlePos2 - handlepos) < (handlepos - this.handlePos1)) {
            this.activeHandle = 2;
            if (!(this.limits.enabled && this.limits.endHandleFixed)) {
                if (this.limits.enabled) {
                    var value = this.getLimitValueAndPosition(handleVal, this.limits.maxStart, this.limits.maxEnd);
                    handleVal = value[0];
                    handlepos = value[1];
                }
                this.secondHandle.classList.add(classNames.sliderActiveHandle);
                this.handlePos2 = this.preHandlePos2 = handlepos;
                this.handleVal2 = handleVal;
            }
            this.modifyZindex();
            this.secondHandle.focus();
        }
        else {
            this.activeHandle = 1;
            if (!(this.limits.enabled && this.limits.startHandleFixed)) {
                if (this.limits.enabled) {
                    var value = this.getLimitValueAndPosition(handleVal, this.limits.minStart, this.limits.minEnd);
                    handleVal = value[0];
                    handlepos = value[1];
                }
                this.firstHandle.classList.add(classNames.sliderActiveHandle);
                this.handlePos1 = this.preHandlePos1 = handlepos;
                this.handleVal1 = handleVal;
            }
            this.modifyZindex();
            this.firstHandle.focus();
        }
        if (this.isMaterialTooltip) {
            this.tooltipElement.classList.add(classNames.materialTooltipActive);
        }
        var focusedElement = this.element.querySelector('.' + classNames.sliderTabHandle);
        if (focusedElement && this.getHandle() !== focusedElement) {
            focusedElement.classList.remove(classNames.sliderTabHandle);
        }
        var handle = this.activeHandle === 1 ? this.firstHandle : this.secondHandle;
        if (evt.target === handle) {
            if (this.isMaterial && !this.tooltip.isVisible &&
                !this.getHandle().classList.contains(classNames.sliderTabHandle)) {
                this.materialChange();
            }
            this.sliderBarUp(evt);
            this.tooltipToggle(this.getHandle());
            return;
        }
        if (!this.checkRepeatedValue(handleVal)) {
            return;
        }
        var transition = this.isMaterial && this.tooltip.isVisible ?
            this.transitionOnMaterialTooltip : this.transition;
        this.getHandle().style.transition = transition.handle;
        if (this.type !== 'Default') {
            this.rangeBar.style.transition = transition.rangeBar;
        }
        this.setHandlePosition(evt);
        if (this.isMaterialTooltip) {
            this.initialTooltip = false;
        }
        this.changeEvent('changed', evt);
        if (this.type !== 'Default') {
            this.setRangeBar();
        }
    };
    Slider.prototype.handleValueAdjust = function (handleValue, assignValue, handleNumber) {
        if (handleNumber === 1) {
            this.handleVal1 = assignValue;
            this.handleVal2 = this.handleVal1 + this.minDiff;
        }
        else if (handleNumber === 2) {
            this.handleVal2 = assignValue;
            this.handleVal1 = this.handleVal2 - this.minDiff;
        }
        this.handlePos1 = this.checkHandlePosition(this.handleVal1);
        this.handlePos2 = this.checkHandlePosition(this.handleVal2);
    };
    Slider.prototype.dragRangeBarMove = function (event) {
        var _a, _b;
        if (event.type !== 'touchmove') {
            event.preventDefault();
        }
        this.rangeBarDragged = true;
        var pos;
        this.rangeBar.style.transition = 'none';
        this.firstHandle.style.transition = 'none';
        this.secondHandle.style.transition = 'none';
        var xPostion;
        var yPostion;
        if (event.type === 'mousemove') {
            _a = [event.clientX, event.clientY], xPostion = _a[0], yPostion = _a[1];
        }
        else {
            _b = [event.changedTouches[0].clientX, event.changedTouches[0].clientY], xPostion = _b[0], yPostion = _b[1];
        }
        if (!(this.limits.enabled && this.limits.startHandleFixed) && !(this.limits.enabled && this.limits.endHandleFixed)) {
            if (!this.enableRtl) {
                pos = { x: xPostion - this.firstPartRemain, y: yPostion + this.secondPartRemain };
            }
            else {
                pos = { x: xPostion + this.secondPartRemain, y: yPostion + this.secondPartRemain };
            }
            this.handlePos1 = this.xyToPosition(pos);
            this.handleVal1 = this.positionToValue(this.handlePos1);
            if (!this.enableRtl) {
                pos = { x: xPostion + this.secondPartRemain, y: yPostion - this.firstPartRemain };
            }
            else {
                pos = { x: xPostion - this.firstPartRemain, y: yPostion - this.firstPartRemain };
            }
            this.handlePos2 = this.xyToPosition(pos);
            this.handleVal2 = this.positionToValue(this.handlePos2);
            if (this.limits.enabled) {
                var value = this.getLimitValueAndPosition(this.handleVal1, this.limits.minStart, this.limits.minEnd);
                this.handleVal1 = value[0];
                this.handlePos1 = value[1];
                if (this.handleVal1 === this.limits.minEnd) {
                    this.handleValueAdjust(this.handleVal1, this.limits.minEnd, 1);
                }
                if (this.handleVal1 === this.limits.minStart) {
                    this.handleValueAdjust(this.handleVal1, this.limits.minStart, 1);
                }
                value = this.getLimitValueAndPosition(this.handleVal2, this.limits.maxStart, this.limits.maxEnd);
                this.handleVal2 = value[0];
                this.handlePos2 = value[1];
                if (this.handleVal2 === this.limits.maxStart) {
                    this.handleValueAdjust(this.handleVal2, this.limits.maxStart, 2);
                }
                if (this.handleVal2 === this.limits.maxEnd) {
                    this.handleValueAdjust(this.handleVal2, this.limits.maxEnd, 2);
                }
            }
            if (this.handleVal2 === this.max) {
                this.handleValueAdjust(this.handleVal2, this.max, 2);
            }
            if (this.handleVal1 === this.min) {
                this.handleValueAdjust(this.handleVal1, this.min, 1);
            }
        }
        this.activeHandle = 1;
        this.setHandlePosition(event);
        this.activeHandle = 2;
        this.setHandlePosition(event);
        this.tooltipToggle(this.rangeBar);
        this.setRangeBar();
    };
    Slider.prototype.sliderBarUp = function (event) {
        this.changeEvent('changed', event);
        this.handleFocusOut();
        this.firstHandle.classList.remove(classNames.sliderActiveHandle);
        if (this.type === 'Range') {
            this.initialTooltip = false;
            this.secondHandle.classList.remove(classNames.sliderActiveHandle);
        }
        this.closeTooltip();
        if (this.isMaterial) {
            this.getHandle().classList.remove('e-large-thumb-size');
            if (this.isMaterialTooltip) {
                this.tooltipElement.classList.remove(classNames.materialTooltipActive);
            }
        }
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'mousemove touchmove', this.sliderBarMove);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'mouseup touchend', this.sliderBarUp);
    };
    Slider.prototype.sliderBarMove = function (evt) {
        if (evt.type !== 'touchmove') {
            evt.preventDefault();
        }
        var pos;
        if (evt.type === 'mousemove') {
            pos = { x: evt.clientX, y: evt.clientY };
        }
        else {
            pos = { x: evt.changedTouches[0].clientX, y: evt.changedTouches[0].clientY };
        }
        var handlepos = this.xyToPosition(pos);
        var handleVal = this.positionToValue(handlepos);
        handlepos = Math.round(handlepos);
        if (this.type !== 'Range' && this.activeHandle === 1) {
            if (!(this.limits.enabled && this.limits.startHandleFixed)) {
                if (this.limits.enabled) {
                    var valueAndPostion = this.getLimitValueAndPosition(handleVal, this.limits.minStart, this.limits.minEnd);
                    handlepos = valueAndPostion[1];
                    handleVal = valueAndPostion[0];
                }
                this.handlePos1 = handlepos;
                this.handleVal1 = handleVal;
            }
            this.firstHandle.classList.add(classNames.sliderActiveHandle);
        }
        if (this.type === 'Range') {
            if (this.activeHandle === 1) {
                this.firstHandle.classList.add(classNames.sliderActiveHandle);
                if (!(this.limits.enabled && this.limits.startHandleFixed)) {
                    if (handlepos > this.handlePos2) {
                        handlepos = this.handlePos2;
                        handleVal = this.handleVal2;
                    }
                    if (handlepos !== this.preHandlePos1) {
                        if (this.limits.enabled) {
                            var value = this.getLimitValueAndPosition(handleVal, this.limits.minStart, this.limits.minEnd);
                            handleVal = value[0];
                            handlepos = value[1];
                        }
                        this.handlePos1 = this.preHandlePos1 = handlepos;
                        this.handleVal1 = handleVal;
                        this.activeHandle = 1;
                    }
                }
            }
            else if (this.activeHandle === 2) {
                this.secondHandle.classList.add(classNames.sliderActiveHandle);
                if (!(this.limits.enabled && this.limits.endHandleFixed)) {
                    if (handlepos < this.handlePos1) {
                        handlepos = this.handlePos1;
                        handleVal = this.handleVal1;
                    }
                    if (handlepos !== this.preHandlePos2) {
                        if (this.limits.enabled) {
                            var value = this.getLimitValueAndPosition(handleVal, this.limits.maxStart, this.limits.maxEnd);
                            handleVal = value[0];
                            handlepos = value[1];
                        }
                        this.handlePos2 = this.preHandlePos2 = handlepos;
                        this.handleVal2 = handleVal;
                        this.activeHandle = 2;
                    }
                }
            }
        }
        if (!this.checkRepeatedValue(handleVal)) {
            return;
        }
        this.getHandle().style.transition = this.scaleTransform;
        if (this.type !== 'Default') {
            this.rangeBar.style.transition = 'none';
        }
        this.setHandlePosition(evt);
        if (this.isMaterial && !this.tooltip.isVisible &&
            !this.getHandle().classList.contains(classNames.sliderTabHandle)) {
            this.materialChange();
        }
        this.tooltipToggle(this.getHandle());
        if (this.type !== 'Default') {
            this.setRangeBar();
        }
    };
    Slider.prototype.dragRangeBarUp = function (event) {
        if (!this.rangeBarDragged) {
            this.focusSliderElement();
            this.sliderBarClick(event);
        }
        else {
            this.isDragComplete = true;
        }
        this.changeEvent('changed', event);
        this.closeTooltip();
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'mousemove touchmove', this.dragRangeBarMove);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'mouseup touchend', this.dragRangeBarUp);
        this.rangeBarDragged = false;
    };
    Slider.prototype.checkRepeatedValue = function (currentValue) {
        if (this.type === 'Range') {
            var previousVal = this.enableRtl && this.orientation !== 'Vertical' ? (this.activeHandle === 1 ?
                this.previousVal[1] : this.previousVal[0]) :
                (this.activeHandle === 1 ? this.previousVal[0] : this.previousVal[1]);
            if (currentValue === previousVal) {
                return 0;
            }
        }
        else {
            if (currentValue === this.previousVal) {
                return 0;
            }
        }
        return 1;
    };
    Slider.prototype.refreshTooltip = function (target) {
        if (this.tooltip.isVisible && this.tooltipObj) {
            this.tooltipValue();
            if (target) {
                this.tooltipObj.refresh(target);
                this.tooltipTarget = target;
            }
        }
    };
    Slider.prototype.openTooltip = function (target) {
        if (this.tooltip.isVisible && this.tooltipObj && !this.isMaterialTooltip) {
            this.tooltipValue();
            this.tooltipObj.open(target);
            this.tooltipTarget = target;
        }
    };
    Slider.prototype.closeTooltip = function () {
        if (this.tooltip.isVisible && this.tooltipObj && this.tooltip.showOn !== 'Always' && !this.isMaterialTooltip) {
            this.tooltipValue();
            this.tooltipObj.close();
            this.tooltipTarget = undefined;
        }
    };
    Slider.prototype.keyDown = function (event) {
        switch (event.keyCode) {
            case 37:
            case 38:
            case 39:
            case 40:
            case 33:
            case 34:
            case 36:
            case 35:
                event.preventDefault();
                this.buttonClick(event);
                break;
        }
    };
    Slider.prototype.wireButtonEvt = function (destroy) {
        if (!destroy) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.firstBtn, 'mouseleave touchleave', this.buttonFocusOut, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.secondBtn, 'mouseleave touchleave', this.buttonFocusOut, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.firstBtn, 'mousedown touchstart', this.repeatHandlerMouse, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.firstBtn, 'mouseup mouseleave touchup touchend', this.repeatHandlerUp, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.secondBtn, 'mousedown touchstart', this.repeatHandlerMouse, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.secondBtn, 'mouseup mouseleave touchup touchend', this.repeatHandlerUp, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.firstBtn, 'focusout', this.sliderFocusOut, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.secondBtn, 'focusout', this.sliderFocusOut, this);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.firstBtn, 'mouseleave touchleave', this.buttonFocusOut);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.secondBtn, 'mouseleave touchleave', this.buttonFocusOut);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.firstBtn, 'mousedown touchstart', this.repeatHandlerMouse);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.firstBtn, 'mouseup mouseleave touchup touchend', this.repeatHandlerUp);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.secondBtn, 'mousedown touchstart', this.repeatHandlerMouse);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.secondBtn, 'mouseup mouseleave touchup touchend', this.repeatHandlerUp);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.firstBtn, 'focusout', this.sliderFocusOut);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.secondBtn, 'focusout', this.sliderFocusOut);
        }
    };
    Slider.prototype.rangeBarMousedown = function (event) {
        var _a, _b;
        event.preventDefault();
        this.focusSliderElement();
        if (this.type === 'Range' && this.drag && event.target === this.rangeBar) {
            var xPostion = void 0;
            var yPostion = void 0;
            if (event.type === 'mousedown') {
                _a = [event.clientX, event.clientY], xPostion = _a[0], yPostion = _a[1];
            }
            else if (event.type === 'touchstart') {
                _b = [event.changedTouches[0].clientX, event.changedTouches[0].clientY], xPostion = _b[0], yPostion = _b[1];
            }
            if (this.orientation === 'Horizontal') {
                this.firstPartRemain = xPostion - this.rangeBar.getBoundingClientRect().left;
                this.secondPartRemain = this.rangeBar.getBoundingClientRect().right - xPostion;
            }
            else {
                this.firstPartRemain = yPostion - this.rangeBar.getBoundingClientRect().top;
                this.secondPartRemain = this.rangeBar.getBoundingClientRect().bottom - yPostion;
            }
            this.minDiff = this.handleVal2 - this.handleVal1;
            this.tooltipToggle(this.rangeBar);
            var focusedElement = this.element.querySelector('.' + classNames.sliderTabHandle);
            if (focusedElement) {
                focusedElement.classList.remove(classNames.sliderTabHandle);
            }
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'mousemove touchmove', this.dragRangeBarMove, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'mouseup touchend', this.dragRangeBarUp, this);
        }
    };
    Slider.prototype.elementClick = function (event) {
        if (this.isDragComplete) {
            this.isDragComplete = false;
            return;
        }
        event.preventDefault();
        this.focusSliderElement();
        this.sliderBarClick(event);
        this.focusHandle();
    };
    Slider.prototype.wireEvents = function () {
        this.onresize = this.reposition.bind(this);
        window.addEventListener('resize', this.onresize);
        if (this.enabled && !this.readonly) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'click', this.elementClick, this);
            if (this.type === 'Range' && this.drag) {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.rangeBar, 'mousedown touchstart', this.rangeBarMousedown, this);
            }
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.sliderContainer, 'keydown', this.keyDown, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.sliderContainer, 'keyup', this.keyUp, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'focusout', this.sliderFocusOut, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.sliderContainer, 'mouseover mouseout touchstart touchend', this.hover, this);
            this.wireFirstHandleEvt(false);
            if (this.type === 'Range') {
                this.wireSecondHandleEvt(false);
            }
            if (this.showButtons) {
                this.wireButtonEvt(false);
            }
            this.wireMaterialTooltipEvent(false);
            if (this.isForm) {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.formElement, 'reset', this.formResetHandler, this);
            }
        }
    };
    Slider.prototype.unwireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'click', this.elementClick);
        if (this.type === 'Range' && this.drag) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.rangeBar, 'mousedown touchstart', this.rangeBarMousedown);
        }
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.sliderContainer, 'keydown', this.keyDown);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.sliderContainer, 'keyup', this.keyUp);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'focusout', this.sliderFocusOut);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.sliderContainer, 'mouseover mouseout touchstart touchend', this.hover);
        this.wireFirstHandleEvt(true);
        if (this.type === 'Range') {
            this.wireSecondHandleEvt(true);
        }
        if (this.showButtons) {
            this.wireButtonEvt(true);
        }
        this.wireMaterialTooltipEvent(true);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'reset', this.formResetHandler);
    };
    Slider.prototype.formResetHandler = function () {
        this.setProperties({ 'value': this.formResetValue }, true);
        this.setValue();
    };
    Slider.prototype.keyUp = function (event) {
        if (event.keyCode === 9 && event.target.classList.contains(classNames.sliderHandle)) {
            this.focusSliderElement();
            if (!event.target.classList.contains(classNames.sliderTabHandle)) {
                if (this.element.querySelector('.' + classNames.sliderTabHandle)) {
                    this.element.querySelector('.' + classNames.sliderTabHandle).classList.remove(classNames.sliderTabHandle);
                }
                event.target.classList.add(classNames.sliderTabHandle);
                var parentElement = event.target.parentElement;
                if (parentElement === this.element) {
                    parentElement.querySelector('.' + classNames.sliderTrack).classList.add(classNames.sliderTabTrack);
                    if (this.type === 'Range' || this.type === 'MinRange') {
                        parentElement.querySelector('.' + classNames.rangeBar).classList.add(classNames.sliderTabRange);
                    }
                }
                if (this.type === 'Range') {
                    (event.target.previousSibling).classList.contains(classNames.sliderHandle) ?
                        this.activeHandle = 2 : this.activeHandle = 1;
                }
                this.getHandle().focus();
                this.tooltipToggle(this.getHandle());
            }
        }
        this.closeTooltip();
        this.changeEvent('changed', event);
    };
    Slider.prototype.hover = function (event) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(event)) {
            if (event.type === 'mouseover' || event.type === 'touchmove' || event.type === 'mousemove' ||
                event.type === 'pointermove' || event.type === 'touchstart') {
                this.sliderContainer.classList.add(classNames.sliderHover);
            }
            else {
                this.sliderContainer.classList.remove(classNames.sliderHover);
                var curTarget = event.currentTarget;
                if (this.tooltip.isVisible && this.tooltip.showOn !== 'Always' && this.tooltipObj && this.isMaterialTooltip &&
                    !curTarget.classList.contains(classNames.sliderHandleFocused) &&
                    !curTarget.classList.contains(classNames.sliderTabHandle)) {
                    this.closeMaterialTooltip();
                }
            }
        }
    };
    Slider.prototype.sliderFocusOut = function (event) {
        if (event.relatedTarget !== this.secondHandle && event.relatedTarget !== this.firstHandle &&
            event.relatedTarget !== this.element && event.relatedTarget !== this.firstBtn && event.relatedTarget !== this.secondBtn) {
            this.closeMaterialTooltip();
            this.closeTooltip();
            if (this.element.querySelector('.' + classNames.sliderTabHandle)) {
                this.element.querySelector('.' + classNames.sliderTabHandle).classList.remove(classNames.sliderTabHandle);
            }
            if (this.element.querySelector('.' + classNames.sliderTabTrack)) {
                this.element.querySelector('.' + classNames.sliderTabTrack).classList.remove(classNames.sliderTabTrack);
                if ((this.type === 'Range' || this.type === 'MinRange') &&
                    this.element.querySelector('.' + classNames.sliderTabRange)) {
                    this.element.querySelector('.' + classNames.sliderTabRange).classList.remove(classNames.sliderTabRange);
                }
            }
            this.hiddenInput.focus();
            this.hiddenInput.blur();
            this.isElementFocused = false;
        }
    };
    Slider.prototype.removeElement = function (element) {
        if (element.parentNode) {
            element.parentNode.removeChild(element);
        }
    };
    Slider.prototype.changeSliderType = function (type, args) {
        if (this.isMaterialTooltip && this.materialHandle) {
            this.sliderContainer.classList.remove(classNames.materialSlider);
            this.removeElement(this.materialHandle);
            this.materialHandle = undefined;
        }
        this.removeElement(this.firstHandle);
        this.firstHandle = undefined;
        if (type !== 'Default') {
            if (type === 'Range') {
                this.removeElement(this.secondHandle);
                this.secondHandle = undefined;
            }
            this.removeElement(this.rangeBar);
            this.rangeBar = undefined;
        }
        if (this.tooltip.isVisible && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.tooltipObj)) {
            this.tooltipObj.destroy();
            this.tooltipElement = undefined;
            this.tooltipCollidedPosition = undefined;
        }
        if (this.limits.enabled) {
            if (type === 'MinRange' || type === 'Default') {
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.limitBarFirst)) {
                    this.removeElement(this.limitBarFirst);
                    this.limitBarFirst = undefined;
                }
            }
            else {
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.limitBarSecond)) {
                    this.removeElement(this.limitBarSecond);
                    this.limitBarSecond = undefined;
                }
            }
        }
        this.activeHandle = 1;
        this.getThemeInitialization();
        if (this.type === 'Range') {
            this.rangeValueUpdate();
        }
        this.createRangeBar();
        if (this.limits.enabled) {
            this.createLimitBar();
        }
        this.setHandler();
        this.setOrientClass();
        this.wireFirstHandleEvt(false);
        if (this.type === 'Range') {
            this.wireSecondHandleEvt(false);
        }
        this.setValue();
        if (this.tooltip.isVisible) {
            this.renderTooltip();
            this.wireMaterialTooltipEvent(false);
        }
        this.setBarColor();
        if (args !== 'tooltip') {
            this.updateConfig();
        }
    };
    Slider.prototype.changeRtl = function () {
        if (!this.enableRtl && this.type === 'Range') {
            this.value = [this.handleVal2, this.handleVal1];
        }
        this.updateConfig();
        if (this.tooltip.isVisible) {
            this.tooltipObj.refresh(this.firstHandle);
        }
        if (this.showButtons) {
            var enabledRTL = this.enableRtl && this.orientation !== 'Vertical';
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(enabledRTL ? this.secondBtn : this.firstBtn, { 'aria-label': 'Decrease', title: 'Decrease' });
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(enabledRTL ? this.firstBtn : this.secondBtn, { 'aria-label': 'Increase', title: 'Increase' });
        }
    };
    Slider.prototype.changeOrientation = function () {
        this.changeSliderType(this.type, 'null');
    };
    Slider.prototype.updateConfig = function () {
        this.setEnableRTL();
        this.setValue();
        if (this.tooltip.isVisible) {
            this.refreshTooltip(this.tooltipTarget);
        }
        if (this.ticks.placement !== 'None') {
            if (this.ul) {
                this.removeElement(this.ul);
                this.ul = undefined;
                this.renderScale();
            }
        }
        this.limitsPropertyChange();
    };
    Slider.prototype.limitsPropertyChange = function () {
        if (this.limits.enabled) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.limitBarFirst) && this.type !== 'Range') {
                this.createLimitBar();
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.limitBarFirst) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.limitBarSecond) && this.type === 'Range') {
                this.createLimitBar();
            }
            this.setLimitBar();
            this.setValue();
        }
        else {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.limitBarFirst)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.limitBarFirst);
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.limitBarSecond)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.limitBarSecond);
            }
        }
    };
    /**
     * Get the properties to be maintained in the persisted state.
     * @private
     */
    Slider.prototype.getPersistData = function () {
        var keyEntity = ['value'];
        return this.addOnPersist(keyEntity);
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers.
     * Also it removes the attributes and classes.
     * @method destroy
     * @return {void}
     */
    Slider.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.unwireEvents();
        window.removeEventListener('resize', this.onresize);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.sliderContainer], [classNames.sliderDisabled]);
        this.firstHandle.removeAttribute('aria-orientation');
        if (this.type === 'Range') {
            this.secondHandle.removeAttribute('aria-orientation');
        }
        this.sliderContainer.parentNode.insertBefore(this.element, this.sliderContainer);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.sliderContainer);
        if (this.tooltip.isVisible) {
            this.tooltipObj.destroy();
        }
        this.element.innerHTML = '';
    };
    /**
     * Calls internally if any of the property value is changed.
     * @private
     */
    // tslint:disable-next-line
    Slider.prototype.onPropertyChanged = function (newProp, oldProp) {
        var _this = this;
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'cssClass':
                    this.setCSSClass(oldProp.cssClass);
                    break;
                case 'value':
                    if (newProp && oldProp) {
                        var value = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(newProp.value) ?
                            (this.type === 'Range' ? [this.min, this.max] : this.min) : newProp.value;
                        this.setProperties({ 'value': value }, true);
                        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(oldProp.value) && oldProp.value.toString() !== value.toString()) {
                            this.setValue();
                            this.refreshTooltip(this.tooltipTarget);
                            if (this.type === 'Range') {
                                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(newProp.value) || oldProp.value[1] === value[1]) {
                                    this.activeHandle = 1;
                                }
                                else {
                                    this.activeHandle = 2;
                                }
                            }
                        }
                    }
                    break;
                case 'min':
                case 'step':
                case 'max':
                    this.setMinMaxValue();
                    break;
                case 'tooltip':
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(newProp.tooltip) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(oldProp.tooltip)) {
                        this.setTooltip(prop);
                    }
                    break;
                case 'type':
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(oldProp) && Object.keys(oldProp).length
                        && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(oldProp.type)) {
                        this.changeSliderType(oldProp.type, prop);
                        this.setZindex();
                    }
                    break;
                case 'enableRtl':
                    if (oldProp.enableRtl !== newProp.enableRtl && this.orientation !== 'Vertical') {
                        this.rtl = oldProp.enableRtl;
                        this.changeRtl();
                    }
                    break;
                case 'limits':
                    this.limitsPropertyChange();
                    break;
                case 'orientation':
                    this.changeOrientation();
                    break;
                case 'ticks':
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.sliderContainer.querySelector('.' + classNames.scale))) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.ul);
                        Array.prototype.forEach.call(this.sliderContainer.classList, function (className) {
                            if (className.match(/e-scale-/)) {
                                _this.sliderContainer.classList.remove(className);
                            }
                        });
                    }
                    if (this.ticks.placement !== 'None') {
                        this.renderScale();
                        this.setZindex();
                    }
                    break;
                case 'locale':
                    if (this.showButtons) {
                        this.buttonTitle();
                    }
                    break;
                case 'showButtons':
                    if (newProp.showButtons) {
                        this.setButtons();
                        this.reposition();
                        if (this.enabled && !this.readonly) {
                            this.wireButtonEvt(false);
                        }
                    }
                    else {
                        if (this.firstBtn && this.secondBtn) {
                            this.sliderContainer.removeChild(this.firstBtn);
                            this.sliderContainer.removeChild(this.secondBtn);
                            this.sliderContainer.classList.remove(classNames.sliderButtonClass);
                            this.firstBtn = undefined;
                            this.secondBtn = undefined;
                            this.reposition();
                        }
                    }
                    break;
                case 'enabled':
                    this.setEnabled();
                    break;
                case 'readonly':
                    this.setReadOnly();
                    break;
                case 'customValues':
                    this.setValue();
                    this.reposition();
                    break;
                case 'colorRange':
                    this.reposition();
                    break;
                case 'width':
                    this.setElementWidth(newProp.width);
                    this.setMinMaxValue();
                    if (this.limits) {
                        this.limitsPropertyChange();
                    }
                    break;
            }
        }
    };
    Slider.prototype.setReadOnly = function () {
        if (this.readonly) {
            this.unwireEvents();
            this.sliderContainer.classList.add(classNames.readonly);
        }
        else {
            this.wireEvents();
            this.sliderContainer.classList.remove(classNames.readonly);
        }
    };
    Slider.prototype.setMinMaxValue = function () {
        var _this = this;
        this.setValue();
        this.refreshTooltip(this.tooltipTarget);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.sliderContainer.querySelector('.' + classNames.scale))) {
            if (this.ul) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.ul);
                Array.prototype.forEach.call(this.sliderContainer.classList, function (className) {
                    if (className.match(/e-scale-/)) {
                        _this.sliderContainer.classList.remove(className);
                    }
                });
            }
        }
        if (this.ticks.placement !== 'None') {
            this.renderScale();
            this.setZindex();
        }
    };
    Slider.prototype.setZindex = function () {
        this.zIndex = 6;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.ticks) && this.ticks.placement !== 'None') {
            this.ul.style.zIndex = (this.zIndex + -7) + '';
            this.element.style.zIndex = (this.zIndex + 2) + '';
        }
        if (!this.isMaterial && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.ticks) && this.ticks.placement === 'Both') {
            this.element.style.zIndex = (this.zIndex + 2) + '';
        }
        this.firstHandle.style.zIndex = (this.zIndex + 3) + '';
        if (this.type === 'Range') {
            this.secondHandle.style.zIndex = (this.zIndex + 4) + '';
        }
    };
    Slider.prototype.setTooltip = function (args) {
        this.changeSliderType(this.type, args);
    };
    Slider.prototype.setBarColor = function () {
        var trackPosition;
        var trackClassName;
        var child = this.sliderTrack.lastElementChild;
        while (child) {
            this.sliderTrack.removeChild(child);
            child = this.sliderTrack.lastElementChild;
        }
        for (var i = 0; i < this.colorRange.length; i++) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.colorRange[i].start) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.colorRange[i].end)) {
                if (this.colorRange[i].end > this.colorRange[i].start) {
                    if (this.colorRange[i].start < this.min) {
                        this.colorRange[i].start = this.min;
                    }
                    if (this.colorRange[i].end > this.max) {
                        this.colorRange[i].end = this.max;
                    }
                    var startingPosition = this.checkHandlePosition(this.colorRange[i].start);
                    var endPosition = this.checkHandlePosition(this.colorRange[i].end);
                    var trackContainer = this.createElement('div');
                    trackContainer.style.backgroundColor = this.colorRange[i].color;
                    trackContainer.style.border = '1px solid ' + this.colorRange[i].color;
                    if (this.orientation === 'Horizontal') {
                        trackClassName = classNames.sliderHorizantalColor;
                        if (this.enableRtl) {
                            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customValues)) {
                                trackPosition = this.checkHandlePosition(this.max) - this.checkHandlePosition(this.colorRange[i].end);
                            }
                            else {
                                trackPosition = this.checkHandlePosition(this.customValues.length - this.colorRange[i].end - 1);
                            }
                        }
                        else {
                            trackPosition = this.checkHandlePosition(this.colorRange[i].start);
                        }
                        trackContainer.style.width = endPosition - startingPosition + 'px';
                        trackContainer.style.left = trackPosition + 'px';
                    }
                    else {
                        trackClassName = classNames.sliderVerticalColor;
                        trackPosition = this.checkHandlePosition(this.colorRange[i].start);
                        trackContainer.style.height = endPosition - startingPosition + 'px';
                        trackContainer.style.bottom = trackPosition + 'px';
                    }
                    trackContainer.classList.add(trackClassName);
                    this.sliderTrack.appendChild(trackContainer);
                }
            }
        }
    };
    /**
     * Gets the component name
     * @private
     */
    Slider.prototype.getModuleName = function () {
        return 'slider';
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], Slider.prototype, "value", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], Slider.prototype, "customValues", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(1)
    ], Slider.prototype, "step", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], Slider.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(0)
    ], Slider.prototype, "min", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(100)
    ], Slider.prototype, "max", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Slider.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Default')
    ], Slider.prototype, "type", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["f" /* Collection */])([{}], ColorRangeData)
    ], Slider.prototype, "colorRange", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({}, TicksData)
    ], Slider.prototype, "ticks", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({}, LimitData)
    ], Slider.prototype, "limits", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Slider.prototype, "enabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({}, TooltipData)
    ], Slider.prototype, "tooltip", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Slider.prototype, "showButtons", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Slider.prototype, "enableAnimation", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Horizontal')
    ], Slider.prototype, "orientation", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Slider.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Slider.prototype, "enableHtmlSanitizer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Slider.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Slider.prototype, "change", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Slider.prototype, "changed", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Slider.prototype, "renderingTicks", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Slider.prototype, "renderedTicks", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Slider.prototype, "tooltipChange", void 0);
    Slider = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], Slider);
    return Slider;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index__ = __webpack_require__(269);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["c"]; });
/**
 * index
 */



/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropDownButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_common__ = __webpack_require__(34);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var classNames = {
    DISABLED: 'e-disabled',
    FOCUS: 'e-focused',
    ICON: 'e-menu-icon',
    ITEM: 'e-item',
    POPUP: 'e-dropdown-popup',
    RTL: 'e-rtl',
    SEPARATOR: 'e-separator',
    VERTICAL: 'e-vertical'
};
/**
 * DropDownButton component is used to toggle contextual overlays for displaying list of action items.
 * It can contain both text and images.
 * ```html
 * <button id="element">DropDownButton</button>
 * ```
 * ```typescript
 * <script>
 * var dropDownButtonObj = new DropDownButton({items: [{ text: 'Action1' }, { text: 'Action2' },{ text: 'Action3' }]);
 * dropDownButtonObj.appendTo("#element");
 * </script>
 * ```
 */
var DropDownButton = /** @class */ (function (_super) {
    __extends(DropDownButton, _super);
    /**
     * Constructor for creating the widget
     *
     * @param  {DropDownButtonModel} options - Specifies dropdown button model
     * @param  {string|HTMLButtonElement} element - Specifies element
     * @hidden
     */
    function DropDownButton(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.isPopupCreated = true;
        return _this;
    }
    DropDownButton.prototype.preRender = function () {
        /** */
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} - Persist data
     */
    DropDownButton.prototype.getPersistData = function () {
        return this.addOnPersist([]);
    };
    /**
     * To open/close DropDownButton popup based on current state of the DropDownButton.
     *
     * @returns {void}
     */
    DropDownButton.prototype.toggle = function () {
        if (this.canOpen()) {
            this.openPopUp();
        }
        else {
            this.closePopup();
        }
    };
    /**
     * Initialize the Component rendering
     *
     * @returns {void}
     * @private
     */
    DropDownButton.prototype.render = function () {
        this.initialize();
        if (!this.disabled) {
            this.wireEvents();
        }
        this.renderComplete();
    };
    /**
     * Adds a new item to the menu. By default, new item appends to the list as the last item,
     * but you can insert based on the text parameter.
     *
     * @param  { ItemModel[] } items - Specifies an array of JSON data.
     * @param { string } text - Specifies the text to insert the newly added item in the menu.
     * @returns {void}.
     */
    DropDownButton.prototype.addItems = function (items, text) {
        var newItem;
        var idx = this.items.length;
        for (var j = 0, len = this.items.length; j < len; j++) {
            if (text === this.items[j].text) {
                idx = j;
                break;
            }
        }
        for (var i = items.length - 1; i >= 0; i--) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            newItem = new __WEBPACK_IMPORTED_MODULE_3__common_common__["a" /* Item */](this, 'items', items[i], true);
            this.items.splice(idx, 0, newItem);
        }
        if (!this.canOpen()) {
            this.createItems();
        }
    };
    /**
     * Removes the items from the menu.
     *
     * @param  { string[] } items - Specifies an array of string to remove the items.
     * @param { string } isUniqueId - Set `true` if specified items is a collection of unique id.
     * @returns {void}.
     */
    DropDownButton.prototype.removeItems = function (items, isUniqueId) {
        var refresh = false;
        for (var i = 0, len = items.length; i < len; i++) {
            for (var j = 0, len_1 = this.items.length; j < len_1; j++) {
                if (items[i] === (isUniqueId ? this.items[j].id : this.items[j].text)) {
                    this.items.splice(j, 1);
                    refresh = true;
                    break;
                }
            }
        }
        if (refresh && this.getULElement()) {
            this.createItems();
        }
    };
    DropDownButton.prototype.createPopup = function () {
        var _a;
        var div = this.createElement('div', {
            className: classNames.POPUP,
            id: this.element.id + '-popup'
        });
        document.body.appendChild(div);
        this.dropDown = new __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["a" /* Popup */](div, {
            relateTo: this.element,
            collision: { X: 'fit', Y: 'flip' },
            position: { X: 'left', Y: 'bottom' },
            targetType: 'relative',
            content: this.target ? this.getTargetElement() : '',
            enableRtl: this.enableRtl
        });
        if (this.dropDown.element.style.position === 'fixed') {
            this.dropDown.refreshPosition(this.element);
        }
        this.dropDown.hide();
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, (_a = {},
            _a['aria-haspopup'] = this.items.length || this.target ? 'true' : 'false',
            _a['aria-expanded'] = 'false',
            _a['aria-owns'] = this.getPopUpElement().id,
            _a['type'] = 'button',
            _a['aria-label'] = this.element.textContent + ' dropdownbutton',
            _a));
        if (this.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([div], this.cssClass.split(' '));
        }
        this.isPopupCreated = true;
    };
    DropDownButton.prototype.getTargetElement = function () {
        return typeof (this.target) === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])(this.target) : this.target;
    };
    DropDownButton.prototype.createItems = function (appendItems) {
        var items = this.items;
        var showIcon = this.hasIcon(this.items, 'iconCss');
        var span;
        var item;
        var li;
        var eventArgs;
        var ul = this.getULElement();
        if (ul) {
            ul.innerHTML = '';
        }
        else {
            ul = this.createElement('ul', {
                attrs: { 'role': 'menu', 'tabindex': '0' }
            });
        }
        for (var i = 0; i < items.length; i++) {
            item = items[i];
            var tempItem = item.text;
            li = this.createElement('li', {
                className: item.separator ? classNames.ITEM + ' ' + classNames.SEPARATOR : classNames.ITEM,
                attrs: { 'role': 'menuItem', 'tabindex': '-1' },
                id: item.id ? item.id : Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('e-' + this.getModuleName() + '-item')
            });
            if (this.enableHtmlSanitizer) {
                li.textContent = item.url ? '' : tempItem;
            }
            else {
                li.innerHTML = item.url ? '' : tempItem;
            }
            if (item.url) {
                li.appendChild(this.createAnchor(item));
                li.classList.add('e-url');
            }
            if (item.iconCss) {
                span = this.createElement('span', { className: classNames.ICON + ' ' + item.iconCss });
                if (item.url) {
                    li.childNodes[0].appendChild(span);
                }
                else {
                    li.insertBefore(span, li.childNodes[0]);
                }
            }
            else {
                if (showIcon && !item.separator) {
                    li.classList.add('e-blank-icon');
                }
            }
            if (item.disabled) {
                li.classList.add('e-disabled');
            }
            eventArgs = { item: item, element: li };
            this.trigger('beforeItemRender', eventArgs);
            ul.appendChild(li);
        }
        if (appendItems) {
            this.getPopUpElement().appendChild(ul);
        }
        if (showIcon) {
            Object(__WEBPACK_IMPORTED_MODULE_3__common_common__["c" /* setBlankIconStyle */])(this.getPopUpElement());
        }
    };
    DropDownButton.prototype.hasIcon = function (items, field) {
        for (var i = 0, len = items.length; i < len; i++) {
            if (items[i][field]) {
                return true;
            }
        }
        return false;
    };
    DropDownButton.prototype.createAnchor = function (item) {
        var tempItem = (this.enableHtmlSanitizer) ? __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(item.text) : item.text;
        return this.createElement('a', { className: 'e-menu-text e-menu-url', innerHTML: tempItem, attrs: { 'href': item.url } });
    };
    DropDownButton.prototype.initialize = function () {
        this.button = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__["a" /* Button */]({
            iconCss: this.iconCss, iconPosition: this.iconPosition, cssClass: this.cssClass, content: this.content,
            disabled: this.disabled, enableRtl: this.enableRtl, enablePersistence: this.enablePersistence
        });
        this.button.createElement = this.createElement;
        this.button.appendTo(this.element);
        if (!this.element.id) {
            this.element.id = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('e-' + this.getModuleName());
        }
        this.appendArrowSpan();
        this.setActiveElem([this.element]);
        if ((this.target && !this.isColorPicker()) || !this.createPopupOnClick) {
            this.createPopup();
        }
        else {
            this.isPopupCreated = false;
        }
    };
    DropDownButton.prototype.isColorPicker = function () {
        if (!this.element) {
            return false;
        }
        var prevElem = this.element.previousSibling;
        if (prevElem && prevElem.classList && prevElem.classList.contains('e-split-colorpicker')) {
            return true;
        }
        return false;
    };
    DropDownButton.prototype.appendArrowSpan = function () {
        this.element.appendChild(this.createElement('span', {
            className: 'e-btn-icon e-icons ' + 'e-icon-' + (this.cssClass.indexOf(classNames.VERTICAL) > -1
                ? 'bottom' : 'right') + ' e-caret'
        }));
    };
    DropDownButton.prototype.setActiveElem = function (elem) {
        this.activeElem = elem;
    };
    /**
     * Get component name.
     *
     * @returns {string} - Module Name
     * @private
     */
    DropDownButton.prototype.getModuleName = function () {
        return 'dropdown-btn';
    };
    DropDownButton.prototype.canOpen = function () {
        var val = false;
        if (this.isPopupCreated) {
            val = this.getPopUpElement().classList.contains('e-popup-close');
        }
        return val;
    };
    /**
     * Destroys the widget.
     *
     * @returns {void}
     */
    DropDownButton.prototype.destroy = function () {
        var _this = this;
        _super.prototype.destroy.call(this);
        if (this.getModuleName() === 'dropdown-btn') {
            var classList_1;
            if (this.element.querySelector('span.e-caret')) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.element.querySelector('span.e-caret'));
            }
            if (this.cssClass) {
                classList_1 = this.cssClass.split(' ');
            }
            this.button.destroy();
            if (classList_1) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], classList_1);
            }
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])(this.activeElem, ['e-active']);
            var attrList = this.element.getAttribute('class') ? ['aria-haspopup', 'aria-expanded', 'aria-owns', 'type']
                : ['aria-haspopup', 'aria-expanded', 'aria-owns', 'type', 'class'];
            attrList.forEach(function (key) {
                _this.element.removeAttribute(key);
            });
            this.popupUnWireEvents();
            this.destroyPopup();
            this.isPopupCreated = false;
            if (!this.disabled) {
                this.unWireEvents();
            }
        }
    };
    DropDownButton.prototype.destroyPopup = function () {
        if (this.isPopupCreated) {
            this.dropDown.destroy();
            if (this.getPopUpElement()) {
                var popupEle = document.getElementById(this.getPopUpElement().id);
                if (popupEle) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([popupEle], ['e-popup-open', 'e-popup-close']);
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(popupEle);
                }
            }
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.getPopUpElement(), 'click', this.clickHandler);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.getPopUpElement(), 'keydown', this.keyBoardHandler);
            if (this.isPopupCreated) {
                this.dropDown = undefined;
            }
        }
        this.isPopupCreated = false;
    };
    DropDownButton.prototype.getPopUpElement = function () {
        var val = null;
        if (this.dropDown) {
            val = this.dropDown.element;
        }
        return val;
    };
    DropDownButton.prototype.getULElement = function () {
        var val = null;
        if (this.getPopUpElement()) {
            val = this.getPopUpElement().children[0];
        }
        return val;
    };
    DropDownButton.prototype.wireEvents = function () {
        this.delegateMousedownHandler = this.mousedownHandler.bind(this);
        if (!this.createPopupOnClick) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'mousedown touchstart', this.delegateMousedownHandler, this);
        }
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'click', this.clickHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'keydown', this.keyBoardHandler, this);
    };
    DropDownButton.prototype.popupWireEvents = function () {
        var popupElement = this.getPopUpElement();
        if (this.createPopupOnClick) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'mousedown touchstart', this.delegateMousedownHandler, this);
        }
        if (popupElement) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(popupElement, 'click', this.clickHandler, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(popupElement, 'keydown', this.keyBoardHandler, this);
        }
        this.rippleFn = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_0" /* rippleEffect */])(popupElement, { selector: '.' + classNames.ITEM });
    };
    DropDownButton.prototype.popupUnWireEvents = function () {
        var popupElement = this.getPopUpElement();
        if (this.createPopupOnClick) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'mousedown touchstart', this.delegateMousedownHandler);
        }
        if (popupElement && popupElement.parentElement) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(popupElement, 'click', this.clickHandler);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(popupElement, 'keydown', this.keyBoardHandler);
        }
    };
    /**
     * Handles the keyboard interactions.
     *
     * @param {KeyboardEventArgs} e - Specifies keyboard event args.
     * @returns {void}
     * @hidden
     */
    DropDownButton.prototype.keyBoardHandler = function (e) {
        if (e.target === this.element && (e.keyCode === 9 || (!e.altKey && e.keyCode === 40) || e.keyCode === 38)) {
            return;
        }
        switch (e.keyCode) {
            case 38:
            case 40:
                if (e.altKey && (e.keyCode === 38 || e.keyCode === 40)) {
                    this.keyEventHandler(e);
                }
                else {
                    this.upDownKeyHandler(e);
                }
                break;
            case 9:
            case 13:
            case 27:
            case 32:
                this.keyEventHandler(e);
                break;
        }
    };
    DropDownButton.prototype.upDownKeyHandler = function (e) {
        if (this.target && (e.keyCode === 38 || e.keyCode === 40)) {
            return;
        }
        e.preventDefault();
        Object(__WEBPACK_IMPORTED_MODULE_3__common_common__["d" /* upDownKeyHandler */])(this.getULElement(), e.keyCode);
    };
    DropDownButton.prototype.keyEventHandler = function (e) {
        if (this.target && (e.keyCode === 13 || e.keyCode === 9)) {
            return;
        }
        if (e.target && e.target.className.indexOf('e-edit-template') > -1 && e.keyCode === 32) {
            return;
        }
        if (e.keyCode !== 9) {
            e.preventDefault();
        }
        if (e.keyCode === 27 || e.keyCode === 38 || e.keyCode === 9) {
            if (!this.canOpen()) {
                this.closePopup(e, this.element);
            }
        }
        else {
            this.clickHandler(e);
        }
    };
    DropDownButton.prototype.getLI = function (elem) {
        return elem.tagName === 'LI' ? elem : Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(elem, 'li');
    };
    DropDownButton.prototype.mousedownHandler = function (e) {
        var trgt = e.target;
        if (this.dropDown && !this.canOpen() && !(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '[id="' + this.getPopUpElement().id + '"]')
            || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '[id="' + this.element.id + '"]'))) {
            this.closePopup(e);
        }
    };
    DropDownButton.prototype.clickHandler = function (e) {
        var trgt = e.target;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '[id="' + this.element.id + '"]')) {
            if (!this.createPopupOnClick || (this.target && !this.isColorPicker())) {
                if (this.getPopUpElement().classList.contains('e-popup-close')) {
                    this.openPopUp(e);
                }
                else {
                    this.closePopup(e);
                }
            }
            else if (this.isPopupCreated) {
                this.closePopup(e, this.activeElem[0]);
            }
            else {
                this.createPopup();
                this.openPopUp(e);
            }
        }
        else {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '[id="' + this.getPopUpElement().id + '"]')) {
                var eventArgs = void 0;
                var liIdx = void 0;
                var item = void 0;
                var li = this.getLI(trgt);
                if (li) {
                    liIdx = Array.prototype.indexOf.call(this.getULElement().children, li);
                    item = this.items[liIdx];
                    if (item) {
                        eventArgs = { element: li, item: item };
                        this.trigger('select', eventArgs);
                    }
                    this.closePopup(e, this.activeElem[0]);
                }
            }
        }
    };
    DropDownButton.prototype.openPopUp = function (e) {
        var _this = this;
        if (e === void 0) { e = null; }
        var isReact = false;
        var popupElem = this.getPopUpElement();
        if (!this.target) {
            this.createItems(true);
        }
        else {
            if (this.activeElem.length > 1) {
                var splitButton = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["H" /* getComponent */])(this.activeElem[0], 'split-btn');
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (splitButton.isReact && popupElem.childNodes.length < 1) {
                    isReact = true;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    splitButton.appendReactElement(this.getTargetElement(), this.getPopUpElement());
                    this.renderReactTemplates();
                }
            }
            else {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (this.isReact && popupElem.childNodes.length < 1) {
                    isReact = true;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    this.appendReactElement(this.getTargetElement(), this.getPopUpElement());
                    this.renderReactTemplates();
                }
            }
        }
        var ul = this.getULElement();
        this.popupWireEvents();
        var beforeOpenArgs = { element: ul, items: this.items, event: e, cancel: false };
        this.trigger('beforeOpen', beforeOpenArgs, function (observedArgs) {
            if (!observedArgs.cancel) {
                var ul_1 = _this.getULElement();
                _this.dropDown.show(null, _this.element);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([_this.element], 'e-active');
                _this.element.setAttribute('aria-expanded', 'true');
                ul_1.focus();
                var openArgs = { element: ul_1, items: _this.items };
                _this.trigger('open', openArgs);
            }
        });
    };
    DropDownButton.prototype.closePopup = function (e, focusEle) {
        var _this = this;
        if (e === void 0) { e = null; }
        var ul = this.getULElement();
        var beforeCloseArgs = { element: ul, items: this.items, event: e, cancel: false };
        var popupElement = this.getPopUpElement();
        if (popupElement) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(popupElement, 'keydown', this.keyBoardHandler);
        }
        this.trigger('beforeClose', beforeCloseArgs, function (observedArgs) {
            if (!observedArgs.cancel) {
                _this.popupUnWireEvents();
                var ul_2 = _this.getULElement();
                var selectedLi = ul_2.querySelector('.e-selected');
                if (selectedLi) {
                    selectedLi.classList.remove('e-selected');
                }
                _this.dropDown.hide();
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])(_this.activeElem, 'e-active');
                _this.element.setAttribute('aria-expanded', 'false');
                if (focusEle) {
                    focusEle.focus();
                }
                var closeArgs = { element: ul_2, items: _this.items };
                _this.trigger('close', closeArgs);
                if (!_this.target && ul_2) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(ul_2);
                }
                if (!_this.target || _this.isColorPicker()) {
                    if (_this.createPopupOnClick) {
                        _this.destroyPopup();
                    }
                }
                if (_this.target) {
                    _this.isPopupCreated = _this.createPopupOnClick ? false : true;
                }
            }
        });
    };
    DropDownButton.prototype.unWireEvents = function () {
        if (!this.createPopupOnClick) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'mousedown touchstart', this.delegateMousedownHandler);
        }
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'click', this.clickHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'keydown', this.keyBoardHandler);
        if (this.isPopupCreated) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.getPopUpElement(), 'click', this.clickHandler);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.getPopUpElement(), 'keydown', this.keyBoardHandler);
        }
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param  {DropDownButtonModel} newProp - Specifies new properties
     * @param  {DropDownButtonModel} oldProp - Specifies old properties
     * @returns {void}
     * @private
     */
    DropDownButton.prototype.onPropertyChanged = function (newProp, oldProp) {
        var btnModel = ['content', 'cssClass', 'iconCss', 'iconPosition', 'disabled', 'enableRtl'];
        this.button.setProperties(Object(__WEBPACK_IMPORTED_MODULE_3__common_common__["b" /* getModel */])(newProp, btnModel));
        var popupElement;
        if (this.isPopupCreated) {
            popupElement = this.getPopUpElement();
            this.dropDown.setProperties(Object(__WEBPACK_IMPORTED_MODULE_3__common_common__["b" /* getModel */])(newProp, ['enableRtl']));
        }
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'content':
                    if (!this.element.querySelector('span.e-caret')) {
                        this.appendArrowSpan();
                    }
                    break;
                case 'disabled':
                    if (newProp.disabled) {
                        this.unWireEvents();
                        if (this.isPopupCreated && !this.canOpen()) {
                            this.closePopup();
                        }
                    }
                    else {
                        this.wireEvents();
                    }
                    break;
                case 'cssClass':
                    if (newProp.cssClass.indexOf(classNames.VERTICAL) > -1) {
                        var arrowSpan = this.element.querySelector('span.e-caret');
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["x" /* classList */])(arrowSpan, ['e-icon-bottom'], ['e-icon-right']);
                    }
                    if (this.isPopupCreated) {
                        if (oldProp.cssClass) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([popupElement], oldProp.cssClass.split(' '));
                        }
                        if (newProp.cssClass) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([popupElement], newProp.cssClass.split(' '));
                        }
                    }
                    break;
                case 'target':
                    this.dropDown.content = this.getTargetElement();
                    this.dropDown.dataBind();
                    break;
                case 'items':
                    if (this.isPopupCreated && this.getULElement()) {
                        this.createItems();
                    }
                    break;
                case 'createPopupOnClick':
                    if (newProp.createPopupOnClick) {
                        this.destroyPopup();
                    }
                    else {
                        this.createPopup();
                    }
                    break;
            }
        }
    };
    /**
     * Sets the focus to DropDownButton
     * its native method
     *
     * @public
     * @returns {void}
     */
    DropDownButton.prototype.focusIn = function () {
        this.element.focus();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], DropDownButton.prototype, "content", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], DropDownButton.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], DropDownButton.prototype, "disabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], DropDownButton.prototype, "iconCss", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Left')
    ], DropDownButton.prototype, "iconPosition", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], DropDownButton.prototype, "enableHtmlSanitizer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["f" /* Collection */])([], __WEBPACK_IMPORTED_MODULE_3__common_common__["a" /* Item */])
    ], DropDownButton.prototype, "items", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], DropDownButton.prototype, "createPopupOnClick", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], DropDownButton.prototype, "target", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], DropDownButton.prototype, "beforeItemRender", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], DropDownButton.prototype, "beforeOpen", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], DropDownButton.prototype, "beforeClose", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], DropDownButton.prototype, "close", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], DropDownButton.prototype, "open", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], DropDownButton.prototype, "select", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], DropDownButton.prototype, "created", void 0);
    DropDownButton = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], DropDownButton);
    return DropDownButton;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SignatureBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var SignatureBase = /** @class */ (function (_super) {
    __extends(SignatureBase, _super);
    function SignatureBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* minDistance(distance between the two point) was calaculated for smoothness.*/
        _this.minDistance = 5;
        _this.previous = 0;
        /* interval handles for the smoothness in the mouse move event.*/
        _this.interval = 30;
        _this.timeout = null;
        _this.isSignatureEmpty = true;
        _this.backgroundLoaded = null;
        _this.clearArray = [];
        _this.isBlazor = false;
        _this.isResponsive = false;
        return _this;
    }
    /**
     * To Initialize the component rendering
     *
     * @private
     * @param {HTMLCanvasElement} element - Specifies the canvas element.
     * @param {BlazorDotnetObject} dotnetRef - Specifies for blazor client to server communication.
     * @returns {void}
     */
    SignatureBase.prototype.initialize = function (element, dotnetRef) {
        this.element = element;
        this.canvasContext = this.element.getContext('2d');
        this.canvasContext.canvas.tabIndex = 0;
        if (dotnetRef) {
            this.dotnetRef = dotnetRef;
            this.isBlazor = true;
            if (this.signatureValue) {
                this.loadPersistedSignature();
            }
        }
        this.setHTMLProperties();
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.signatureValue)) {
            this.updateSnapCollection(true);
        }
        this.wireEvents();
        if (!this.isBlazor) {
            this.trigger('created', null);
        }
    };
    SignatureBase.prototype.wireEvents = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.pointColl) && !this.isReadOnly && !this.disabled) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.canvasContext.canvas, 'mousedown touchstart', this.mouseDownHandler, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.canvasContext.canvas, 'keydown', this.keyboardHandler, this);
            window.addEventListener('resize', this.resizeHandler.bind(this));
        }
        else if (this.pointColl) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.canvasContext.canvas, 'mousemove touchmove', this.mouseMoveHandler, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.canvasContext.canvas, 'mouseup touchend', this.mouseUpHandler, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'mouseup', this.mouseUpHandler, this);
        }
    };
    SignatureBase.prototype.unwireEvents = function (type) {
        if (type === 'mouseup' || type === 'touchend') {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.canvasContext.canvas, 'mousemove touchmove', this.mouseMoveHandler);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.canvasContext.canvas, 'mouseup touchend', this.mouseUpHandler);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'mouseup', this.mouseUpHandler);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.canvasContext.canvas, 'mousedown touchstart', this.mouseDownHandler);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.canvasContext.canvas, 'keydown', this.keyboardHandler);
            window.removeEventListener('resize', this.resizeHandler);
        }
    };
    SignatureBase.prototype.setHTMLProperties = function () {
        if (this.element.height === 150 && this.element.width === 300) {
            this.element.height = this.element.offsetHeight;
            this.element.width = this.element.offsetWidth;
            this.isResponsive = true;
        }
        this.canvasContext.scale(1, 1);
        this.canvasContext.fillStyle = this.strokeColor;
        if (this.backgroundImage) {
            this.canvasContext.canvas.style.backgroundImage = 'url(' + this.backgroundImage + ')';
            this.canvasContext.canvas.style.backgroundRepeat = "no-repeat";
        }
        else if (this.backgroundColor) {
            this.canvasContext.canvas.style.backgroundColor = this.backgroundColor;
        }
    };
    SignatureBase.prototype.mouseDownHandler = function (e) {
        if (e.buttons === 1 || e.buttons === 2 || e.type === 'touchstart') {
            if (e.type === 'touchstart') {
                e.preventDefault();
                e.stopPropagation();
            }
            this.beginStroke(e);
            this.wireEvents();
        }
    };
    SignatureBase.prototype.mouseMoveHandler = function (e) {
        if (e.buttons === 1 || e.buttons === 2 || e.type === 'touchmove') {
            if (e.type === 'touchmove') {
                e.preventDefault();
                e.stopPropagation();
            }
            if (this.interval) {
                this.updateStrokeWithThrottle(e);
            }
            else {
                this.updateStroke(e);
            }
        }
    };
    SignatureBase.prototype.mouseUpHandler = function (e) {
        var args = { actionName: 'strokeUpdate' };
        if (e.type === 'touchstart') {
            e.preventDefault();
            e.stopPropagation();
        }
        this.endDraw();
        this.updateSnapCollection();
        this.unwireEvents(e.type);
        if (!this.isBlazor) {
            this.trigger('change', args);
        }
        else {
            this.dotnetRef.invokeMethodAsync('TriggerEventAsync', 'mouseUp');
        }
        this.signatureValue = this.snapColl[this.incStep];
    };
    SignatureBase.prototype.keyboardHandler = function (e) {
        var _this = this;
        var args = { fileName: 'Signature', type: 'Png', cancel: false };
        switch (e.key) {
            case 'Delete':
                this.clear();
                break;
            case (e.ctrlKey && 's'):
                if (!this.isBlazor) {
                    this.trigger('beforeSave', args, function (observableSaveArgs) {
                        if (!args.cancel) {
                            _this.save(observableSaveArgs.type, observableSaveArgs.fileName);
                        }
                    });
                }
                else {
                    this.dotnetRef.invokeMethodAsync('TriggerEventAsync', 'beforeSave');
                }
                e.preventDefault();
                e.stopImmediatePropagation();
                break;
            case (e.ctrlKey && 'z'):
                this.undo();
                break;
            case (e.ctrlKey && 'y'):
                this.redo();
                break;
        }
    };
    SignatureBase.prototype.resizeHandler = function () {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var proxy = this;
        if (this.isResponsive) {
            this.canvasContext.canvas.width = this.element.offsetWidth;
            this.canvasContext.canvas.height = this.element.offsetHeight;
            this.canvasContext.scale(1, 1);
        }
        var restoreImg = new Image();
        restoreImg.src = this.snapColl[this.incStep];
        restoreImg.onload = function () {
            proxy.canvasContext.clearRect(0, 0, proxy.element.width, proxy.element.height);
            proxy.canvasContext.drawImage(restoreImg, 0, 0, proxy.element.width, proxy.element.height);
        };
    };
    SignatureBase.prototype.beginStroke = function (e) {
        this.refresh();
        this.updateStroke(e);
    };
    SignatureBase.prototype.updateStroke = function (e) {
        var point = this.createPoint(e);
        this.addPoint(point);
    };
    SignatureBase.prototype.updateStrokeWithThrottle = function (args) {
        var now = Date.now();
        var remaining = this.interval - (now - this.previous);
        this.storedArgs = args;
        if (remaining <= 0 || remaining > this.interval) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.previous = now;
            this.updateStroke(this.storedArgs);
            if (!this.timeout) {
                this.storedArgs = null;
            }
        }
        else if (!this.timeout) {
            this.timeout = window.setTimeout(this.delay.bind(this), remaining);
        }
    };
    SignatureBase.prototype.delay = function () {
        this.previous = Date.now();
        this.timeout = null;
        this.updateStroke(this.storedArgs);
        if (!this.timeout) {
            this.storedArgs = null;
        }
    };
    SignatureBase.prototype.createPoint = function (e) {
        var rect = this.canvasContext.canvas.getBoundingClientRect();
        if (e.type === 'mousedown' || e.type === 'mousemove') {
            return this.point(e.clientX - rect.left, e.clientY - rect.top, new Date().getTime());
        }
        else {
            return this.point(e.touches[0].clientX - rect.left, e.touches[0].clientY - rect.top, new Date().getTime());
        }
    };
    /* Returns the current point corrdinates(x, y) and time.*/
    SignatureBase.prototype.point = function (pointX, pointY, time) {
        this.pointX = pointX;
        this.pointY = pointY;
        this.time = time || new Date().getTime();
        return { x: this.pointX, y: this.pointY, time: this.time };
    };
    SignatureBase.prototype.addPoint = function (point) {
        var points = this.pointColl;
        var controlPoint1;
        var controlPoint2;
        var lastPoint = points.length > 0 && points[points.length - 1];
        var isLastPointTooClose = lastPoint ? this.distanceTo(lastPoint) <= this.minDistance : false;
        if (!lastPoint || !(lastPoint && isLastPointTooClose)) {
            points.push(point);
            if (points.length > 2) {
                if (points.length === 3) {
                    points.unshift(points[0]);
                }
                controlPoint1 = (this.calculateCurveControlPoints(points[0], points[1], points[2])).controlPoint2;
                controlPoint2 = (this.calculateCurveControlPoints(points[1], points[2], points[3])).controlPoint1;
                this.startPoint = points[1];
                this.controlPoint1 = controlPoint1;
                this.controlPoint2 = controlPoint2;
                this.endPoint = points[2];
                this.startDraw();
                points.shift();
            }
        }
    };
    SignatureBase.prototype.startDraw = function () {
        var velocity;
        velocity = this.pointVelocityCalc(this.startPoint);
        velocity = this.velocity * velocity + (1 - this.velocity) * this.lastVelocity;
        var newWidth = Math.max(this.maxStrokeWidth / (velocity + 1), this.minStrokeWidth);
        this.curveDraw(this.lastWidth, newWidth);
        this.lastVelocity = velocity;
        this.lastWidth = newWidth;
    };
    SignatureBase.prototype.endDraw = function () {
        var canDrawCurve = this.pointColl.length > 2;
        var point = this.pointColl[0];
        if (!canDrawCurve && point) {
            this.strokeDraw(point);
        }
    };
    /* Calculate the Bezier (x, y) coordinate of the curve. */
    SignatureBase.prototype.curveDraw = function (startWidth, endWidth) {
        var context = this.canvasContext;
        var width;
        var i;
        var t1;
        var t2;
        var t3;
        var u1;
        var u2;
        var u3;
        var x;
        var y;
        var widthValue = endWidth - startWidth;
        var bezierLength = this.bezierLengthCalc();
        var drawSteps = Math.ceil(bezierLength) * 2;
        context.beginPath();
        for (i = 0; i < drawSteps; i++) {
            t1 = i / drawSteps;
            t2 = t1 * t1;
            t3 = t2 * t1;
            u1 = 1 - t1;
            u2 = u1 * u1;
            u3 = u2 * u1;
            x = u3 * this.startPoint.x;
            x += 3 * u2 * t1 * this.controlPoint1.x;
            x += 3 * u1 * t2 * this.controlPoint2.x;
            x += t3 * this.endPoint.x;
            y = u3 * this.startPoint.y;
            y += 3 * u2 * t1 * this.controlPoint1.y;
            y += 3 * u1 * t2 * this.controlPoint2.y;
            y += t3 * this.endPoint.y;
            width = Math.min(startWidth + t3 * widthValue, this.maxStrokeWidth);
            this.arcDraw(x, y, width);
        }
        context.closePath();
        context.fill();
        this.isSignatureEmpty = false;
    };
    SignatureBase.prototype.strokeDraw = function (point) {
        var context = this.canvasContext;
        var pointSize = (this.minStrokeWidth + this.maxStrokeWidth) / 2;
        context.beginPath();
        this.arcDraw(point.x, point.y, pointSize);
        context.closePath();
        context.fill();
        this.isSignatureEmpty = false;
    };
    SignatureBase.prototype.arcDraw = function (x, y, size) {
        var context = this.canvasContext;
        context.moveTo(x, y);
        context.arc(x, y, size, 0, 2 * Math.PI, false);
    };
    /* Utility functions for Bezier algorithm*/
    SignatureBase.prototype.calculateCurveControlPoints = function (p1, p2, p3) {
        var dx1 = p1.x - p2.x;
        var dy1 = p1.y - p2.y;
        var dx2 = p2.x - p3.x;
        var dy2 = p2.y - p3.y;
        var m1 = { x: (p1.x + p2.x) / 2.0, y: (p1.y + p2.y) / 2.0 };
        var m2 = { x: (p2.x + p3.x) / 2.0, y: (p2.y + p3.y) / 2.0 };
        var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
        var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
        var dxm = (m1.x - m2.x);
        var dym = (m1.y - m2.y);
        var k = l2 / (l1 + l2);
        var cm = { x: m2.x + dxm * k, y: m2.y + dym * k };
        var tx = p2.x - cm.x;
        var ty = p2.y - cm.y;
        return {
            controlPoint1: this.point(m1.x + tx, m1.y + ty, 0),
            controlPoint2: this.point(m2.x + tx, m2.y + ty, 0)
        };
    };
    /* Returns approximated bezier length of the curuve.*/
    SignatureBase.prototype.bezierLengthCalc = function () {
        var steps = 10;
        var length = 0;
        var i;
        var t;
        var pointx1;
        var pointy1;
        var pointx2;
        var pointy2;
        var pointx3;
        var pointy3;
        for (i = 0; i <= steps; i++) {
            t = i / steps;
            pointx1 = this.bezierPointCalc(t, this.startPoint.x, this.controlPoint1.x, this.controlPoint2.x, this.endPoint.x);
            pointy1 = this.bezierPointCalc(t, this.startPoint.y, this.controlPoint1.y, this.controlPoint2.y, this.endPoint.y);
            if (i > 0) {
                pointx3 = pointx1 - pointx2;
                pointy3 = pointy1 - pointy2;
                length += Math.sqrt(pointx3 * pointx3 + pointy3 * pointy3);
            }
            pointx2 = pointx1;
            pointy2 = pointy1;
        }
        return length;
    };
    /* Calculate parametric value of x or y given t and the
       four point(startpoint, controlpoint1, controlpoint2, endpoint) coordinates of a cubic bezier curve.*/
    SignatureBase.prototype.bezierPointCalc = function (t, startpoint, cp1, cp2, endpoint) {
        return startpoint * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * cp1 * (1.0 - t) * (1.0 - t) * t + 3.0 *
            cp2 * (1.0 - t) * t * t + endpoint * t * t * t;
    };
    /* Velocity between the current point and last point.*/
    SignatureBase.prototype.pointVelocityCalc = function (startPoint) {
        return (this.time !== startPoint.time) ? this.distanceTo(startPoint) / (this.time - startPoint.time) : 0;
    };
    /* Distance between the current point and last point.*/
    SignatureBase.prototype.distanceTo = function (start) {
        return Math.sqrt(Math.pow(this.pointX - start.x, 2) + Math.pow(this.pointY - start.y, 2));
    };
    SignatureBase.prototype.isRead = function (isRead) {
        if (isRead) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.canvasContext.canvas, 'mousedown touchstart', this.mouseDownHandler);
        }
        else if (!this.disabled) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.canvasContext.canvas, 'mousedown touchstart', this.mouseDownHandler, this);
        }
    };
    SignatureBase.prototype.enableOrDisable = function (isDisable) {
        this.disabled = isDisable;
        if (isDisable) {
            this.reDraw('0.5');
            this.isRead(true);
        }
        else {
            this.reDraw('1');
            this.isRead(false);
        }
    };
    SignatureBase.prototype.reDraw = function (opacity) {
        var data = this.canvasContext.getImageData(0, 0, this.element.width, this.element.height);
        this.canvasContext.clearRect(0, 0, this.element.width, this.element.height);
        this.element.style.opacity = opacity;
        this.canvasContext.putImageData(data, 0, 0);
    };
    SignatureBase.prototype.updateSnapCollection = function (isClear) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.incStep)) {
            this.incStep = -1;
            this.incStep++;
            this.snapColl = [];
            this.clearArray = [];
        }
        else {
            this.incStep++;
        }
        if (this.incStep < this.snapColl.length) {
            this.snapColl.length = this.incStep;
        }
        if (this.incStep > 0) {
            var canvasNew = this.createElement('canvas', { className: 'e-' + this.getModuleName() + '-wrapper' });
            var canvasContextNew = canvasNew.getContext('2d');
            canvasNew.width = this.canvasContext.canvas.width;
            canvasNew.height = this.canvasContext.canvas.height;
            canvasContextNew.drawImage(this.canvasContext.canvas, 0, 0, canvasNew.width, canvasNew.height);
            this.snapColl.push(canvasNew.toDataURL());
        }
        else {
            this.snapColl.push(this.canvasContext.canvas.toDataURL());
        }
        if (isClear) {
            this.clearArray.push(this.incStep);
        }
    };
    SignatureBase.prototype.setBackgroundImage = function (imageSrc) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var proxy = this;
        var imageObj = new Image();
        imageObj.crossOrigin = 'anonymous';
        imageObj.src = imageSrc;
        imageObj.onload = function () {
            proxy.canvasContext.globalCompositeOperation = 'source-over';
            proxy.canvasContext.drawImage(imageObj, 0, 0, proxy.element.width, proxy.element.height);
            proxy.updateSnapCollection();
            proxy.saveBackground(true);
        };
        this.canvasContext.clearRect(0, 0, this.canvasContext.canvas.width, this.canvasContext.canvas.height);
    };
    SignatureBase.prototype.setBackgroundColor = function (color) {
        var canvasEle = this.canvasContext;
        canvasEle.strokeStyle = color;
        var i;
        var j;
        for (i = 1; i <= canvasEle.canvas.width; i++) {
            for (j = 1; j <= canvasEle.canvas.height; j++) {
                canvasEle.strokeRect(0, 0, i, j);
            }
        }
        this.updateSnapCollection();
    };
    SignatureBase.prototype.loadPersistedSignature = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.signatureValue)) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var proxy = this;
        var lastImage = new Image();
        lastImage.src = this.signatureValue;
        lastImage.onload = function () {
            proxy.canvasContext.clearRect(0, 0, proxy.element.width, proxy.element.height);
            proxy.canvasContext.drawImage(lastImage, 0, 0);
            proxy.updateSnapCollection();
        };
        this.isSignatureEmpty = false;
    };
    /**
     * To get the signature as Blob.
     *
     * @param {string} url - specify the url/base 64 string to get blob of the signature.
     * @returns {Blob}.
     */
    SignatureBase.prototype.getBlob = function (url) {
        var arr = url.split(',');
        var type = arr[0].match(/:(.*?);/)[1];
        var bstr = atob(arr[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: type });
    };
    SignatureBase.prototype.download = function (blob, fileName) {
        var blobUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = blobUrl;
        a.target = '_parent';
        a.download = fileName;
        (document.body || document.documentElement).appendChild(a);
        a.click();
        a.parentNode.removeChild(a);
    };
    /**
     * To refresh the signature.
     *
     * @private
     * @returns {void}.
     */
    SignatureBase.prototype.refresh = function () {
        this.pointColl = [];
        this.lastVelocity = 0;
        this.lastWidth = (this.minStrokeWidth + this.maxStrokeWidth) / 2;
    };
    /**
     * Erases all the signature strokes signed by user.
     *
     * @returns {void}.
     */
    SignatureBase.prototype.clear = function () {
        var args = { actionName: 'clear' };
        this.canvasContext.clearRect(0, 0, this.canvasContext.canvas.width, this.canvasContext.canvas.height);
        this.refresh();
        this.updateSnapCollection(true);
        this.isSignatureEmpty = true;
        if (!this.isBlazor) {
            this.trigger('change', args);
        }
        else {
            this.dotnetRef.invokeMethodAsync('TriggerEventAsync', 'Clear');
        }
    };
    /**
     * Undo the last user action.
     *
     * @returns {void}.
     */
    SignatureBase.prototype.undo = function () {
        var args = { actionName: 'undo' };
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var proxy = this;
        if (this.incStep > 0) {
            this.incStep--;
            var undoImg_1 = new Image();
            undoImg_1.src = this.snapColl[this.incStep];
            undoImg_1.onload = function () {
                proxy.canvasContext.clearRect(0, 0, proxy.element.width, proxy.element.height);
                proxy.canvasContext.drawImage(undoImg_1, 0, 0, proxy.element.width, proxy.element.height);
            };
        }
        this.isClear();
        if (!this.isBlazor) {
            this.trigger('change', args);
        }
        else {
            this.dotnetRef.invokeMethodAsync('TriggerEventAsync', 'Undo');
        }
    };
    /**
     * Redo the last user action.
     *
     * @returns {void}.
     */
    SignatureBase.prototype.redo = function () {
        var args = { actionName: 'redo' };
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var proxy = this;
        if (this.incStep < this.snapColl.length - 1) {
            this.incStep++;
            var redoImg_1 = new Image();
            redoImg_1.src = this.snapColl[this.incStep];
            redoImg_1.onload = function () {
                proxy.canvasContext.clearRect(0, 0, proxy.element.width, proxy.element.height);
                proxy.canvasContext.drawImage(redoImg_1, 0, 0, proxy.element.width, proxy.element.height);
            };
        }
        this.isClear();
        if (!this.isBlazor) {
            this.trigger('change', args);
        }
        else {
            this.dotnetRef.invokeMethodAsync('TriggerEventAsync', 'Redo');
        }
    };
    SignatureBase.prototype.isClear = function () {
        if (this.clearArray) {
            var empty = false;
            for (var i = 0; i < this.clearArray.length; i++) {
                if (this.clearArray[i] === this.incStep) {
                    this.isSignatureEmpty = true;
                    empty = true;
                }
            }
            if (!empty) {
                this.isSignatureEmpty = false;
            }
        }
    };
    /**
     * To check whether the signature is empty or not.
     *
     * @returns {boolean}.
     */
    SignatureBase.prototype.isEmpty = function () {
        return this.isSignatureEmpty;
    };
    /**
     * To check whether the undo collection is empty or not.
     *
     * @returns {boolean}.
     */
    SignatureBase.prototype.canUndo = function () {
        return this.incStep > 0;
    };
    /**
     * To check whether the redo collection is empty or not.
     *
     * @returns {boolean}.
     */
    SignatureBase.prototype.canRedo = function () {
        return this.incStep < this.snapColl.length - 1;
    };
    /**
     * To draw the signature based on the given text, with the font family and font size.
     *
     * @param {string} text - specify text to be drawn as signature.
     * @param {string} fontFamily - specify font family of a signature.
     * @param {number} fontSize - specify font size of a signature.
     *
     * @returns {void}.
     */
    SignatureBase.prototype.draw = function (text, fontFamily, fontSize) {
        this.canvasContext.clearRect(0, 0, this.canvasContext.canvas.width, this.canvasContext.canvas.height);
        fontFamily = fontFamily || 'Arial';
        fontSize = fontSize || 30;
        this.canvasContext.font = fontSize + 'px ' + fontFamily;
        this.canvasContext.textAlign = 'center';
        this.canvasContext.textBaseline = 'middle';
        this.canvasContext.fillText(text, this.element.width / 2, this.element.height / 2);
        this.updateSnapCollection();
        this.isSignatureEmpty = false;
    };
    /**
     * To load the signature with the given base 64 string, height and width.
     *
     * @param {string} signature - specify the url/base 64 string to be drawn as signature.
     * @param {number} width - specify the width of the loaded signature image.
     * @param {number} height - specify the height of the loaded signature image.
     * @returns {void}.
     */
    SignatureBase.prototype.load = function (signature, width, height) {
        height = height || this.element.height;
        width = width || this.element.width;
        this.canvasContext.clearRect(0, 0, this.canvasContext.canvas.width, this.canvasContext.canvas.height);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var proxy = this;
        var bitmapImage = new Image();
        bitmapImage.src = signature;
        if (signature.slice(0, 4) !== 'data') {
            bitmapImage.crossOrigin = 'anonymous';
        }
        bitmapImage.onload = function () {
            Promise.all([
                createImageBitmap(bitmapImage, 0, 0, width, height)
            ]).then(function (results) {
                var tempCanvas = document.createElement('canvas');
                tempCanvas.width = width;
                tempCanvas.height = height;
                tempCanvas.getContext('2d').drawImage(results[0], 0, 0);
                if (signature.slice(0, 4) !== 'data') {
                    proxy.canvasContext.globalCompositeOperation = 'source-over';
                }
                proxy.canvasContext.drawImage(tempCanvas, 0, 0, width, height, 0, 0, proxy.element.width, proxy.element.height);
                proxy.updateSnapCollection();
            });
        };
        this.isSignatureEmpty = false;
    };
    SignatureBase.prototype.saveBackground = function (savebg) {
        var imageSrc;
        if (savebg && this.backgroundImage) {
            imageSrc = this.snapColl[this.incStep - 1];
        }
        else {
            imageSrc = this.snapColl[this.incStep];
        }
        if (!savebg) {
            this.canvasContext.clearRect(0, 0, this.canvasContext.canvas.width, this.canvasContext.canvas.height);
            if (this.backgroundImage) {
                this.setBackgroundImage(this.backgroundImage);
            }
            else if (this.backgroundColor) {
                this.setBackgroundColor(this.backgroundColor);
                savebg = true;
            }
        }
        if (savebg) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var proxy_1 = this;
            var imageObj_1 = new Image();
            imageObj_1.crossOrigin = 'anonymous';
            imageObj_1.src = imageSrc;
            imageObj_1.onload = function () {
                proxy_1.backgroundLoaded = true;
                proxy_1.canvasContext.globalCompositeOperation = 'source-over';
                proxy_1.canvasContext.drawImage(imageObj_1, 0, 0, proxy_1.element.width, proxy_1.element.height);
                proxy_1.save(proxy_1.fileType, proxy_1.fileName);
            };
        }
    };
    /**
     * To save the signature with the given file type and file name.
     *
     * @param {SignatureFileType} type - specify type of the file to be saved a signature.
     * @param {string} fileName - specify name of the file to be saved a signature.
     *
     * @returns {void}.
     */
    SignatureBase.prototype.save = function (type, fileName) {
        if (this.saveWithBackground && this.backgroundLoaded == null && (this.backgroundImage || this.backgroundColor)) {
            this.backgroundLoaded = false;
            this.fileType = type;
            this.fileName = fileName;
            this.saveBackground(false);
        }
        else if (type === 'Svg') {
            fileName = fileName || 'Signature';
            this.toSVG(fileName);
        }
        else if (type === 'Jpeg') {
            fileName = fileName || 'Signature';
            if (!this.saveWithBackground || this.saveWithBackground && !(this.backgroundImage || this.backgroundColor)) {
                this.toJPEG(fileName);
            }
            else {
                var dataURL = this.canvasContext.canvas.toDataURL('image/jpeg');
                this.download(this.getBlob(dataURL), fileName + '.' + 'jpeg');
            }
        }
        else {
            fileName = fileName || 'Signature';
            var dataURL = this.canvasContext.canvas.toDataURL('image/png');
            this.download(this.getBlob(dataURL), fileName + '.' + 'png');
        }
        if (this.saveWithBackground && this.backgroundLoaded) {
            this.resetSnap();
        }
    };
    SignatureBase.prototype.resetSnap = function () {
        this.canvasContext.clearRect(0, 0, this.canvasContext.canvas.width, this.canvasContext.canvas.height);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var proxy = this;
        var restoreObj = new Image();
        restoreObj.src = this.snapColl[this.incStep - 1];
        restoreObj.onload = function () {
            proxy.canvasContext.drawImage(restoreObj, 0, 0, proxy.element.width, proxy.element.height);
            proxy.updateSnapCollection();
        };
        this.backgroundLoaded = null;
        this.snapColl.pop();
        this.incStep--;
        this.snapColl.pop();
        this.incStep--;
    };
    SignatureBase.prototype.toJPEG = function (fileName) {
        var _this = this;
        var imageSrc = this.snapColl[this.incStep];
        this.setBackgroundColor('#ffffff');
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var proxy = this;
        var imageObj = new Image();
        imageObj.crossOrigin = 'anonymous';
        imageObj.src = imageSrc;
        imageObj.onload = function () {
            proxy.canvasContext.globalCompositeOperation = 'source-over';
            proxy.canvasContext.drawImage(imageObj, 0, 0, proxy.element.width, proxy.element.height);
            var dataURL = proxy.canvasContext.canvas.toDataURL('image/jpeg');
            proxy.download(proxy.getBlob(dataURL), fileName + '.' + 'jpeg');
            proxy.canvasContext.clearRect(0, 0, proxy.canvasContext.canvas.width, proxy.canvasContext.canvas.height);
            _this.resizeHandler();
        };
        this.snapColl.pop();
        this.incStep--;
    };
    SignatureBase.prototype.toSVG = function (fileName) {
        var dataUrl = this.canvasContext.canvas.toDataURL();
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', this.canvasContext.canvas.width.toString());
        svg.setAttribute('height', this.canvasContext.canvas.height.toString());
        var XLinkNS = 'http://www.w3.org/1999/xlink';
        var img = document.createElementNS('http://www.w3.org/2000/svg', 'image');
        img.setAttributeNS(null, 'height', this.canvasContext.canvas.height.toString());
        img.setAttributeNS(null, 'width', this.canvasContext.canvas.width.toString());
        img.setAttributeNS(XLinkNS, 'xlink:href', dataUrl);
        svg.appendChild(img);
        var prefix = 'data:image/svg+xml;base64,';
        var header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"'
            + (" width=\"" + this.canvasContext.canvas.width + "\"") + (" height=\"" + this.canvasContext.canvas.height + "\"") + '>';
        var footer = '</svg>';
        var body = svg.innerHTML;
        var data = header + body + footer;
        var svgDataUrl = prefix + btoa(data);
        if (fileName == null) {
            return svgDataUrl;
        }
        else {
            this.download(this.getBlob(svgDataUrl), fileName + '.' + 'svg');
            return null;
        }
    };
    /**
     * To save the signature as Blob.
     *
     * @returns {Blob}.
     */
    SignatureBase.prototype.saveAsBlob = function () {
        return this.getBlob(this.canvasContext.canvas.toDataURL('image/png'));
    };
    /**
     * To get the signature as Base 64.
     *
     * @private
     * @param {SignatureFileType} type - Specifies the type of the image format.
     * @returns {string}.
     */
    SignatureBase.prototype.getSignature = function (type) {
        if (type === 'Jpeg') {
            var imgData = this.canvasContext.getImageData(0, 0, this.element.width, this.element.height);
            var data = imgData.data;
            for (var i = 0; i < data.length; i += 4) {
                if (data[i + 3] < 255) {
                    data[i] = 255 - data[i];
                    data[i + 1] = 255 - data[i + 1];
                    data[i + 2] = 255 - data[i + 2];
                    data[i + 3] = 255 - data[i + 3];
                }
            }
            this.canvasContext.putImageData(imgData, 0, 0);
            var dataURL = this.canvasContext.canvas.toDataURL('image/jpeg');
            this.resizeHandler();
            return dataURL;
        }
        else if (type === 'Svg') {
            return this.toSVG(null);
        }
        else {
            return this.canvasContext.canvas.toDataURL('image/png');
        }
    };
    /**
     * Get component name.
     *
     * @returns {string} - Module Name
     * @private
     */
    SignatureBase.prototype.getModuleName = function () {
        return 'signature';
    };
    /**
     * To get the properties to be maintained in the persisted state.
     *
     * @returns {string} - Persist data
     */
    SignatureBase.prototype.getPersistData = function () {
        this.signatureValue = this.snapColl[this.incStep];
        return this.addOnPersist(['signatureValue']);
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers.
     * Also it maintains the initial input element from the DOM.
     *
     * @method destroy
     * @returns {void}
     */
    SignatureBase.prototype.destroy = function () {
        this.unwireEvents(null);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], 'e-' + this.getModuleName());
        this.element.removeAttribute('tabindex');
        this.pointColl = null;
        _super.prototype.destroy.call(this);
    };
    /**
     * Modified onPropertyChanged method for both blazor and EJ2 signature component.
     *
     * @private
     * @param {string} key - Specifies the property, which changed.
     * @param {string} value - Specifies the property value changed.
     * @returns {void}
     */
    SignatureBase.prototype.propertyChanged = function (key, value) {
        var canvasNew = this.canvasContext;
        switch (key) {
            case 'backgroundColor':
                canvasNew.canvas.style.backgroundColor = value;
                this.backgroundColor = value;
                break;
            case 'backgroundImage':
                canvasNew.canvas.style.backgroundImage = 'url(' + value + ')';
                this.backgroundImage = value;
                break;
            case 'strokeColor':
                canvasNew.fillStyle = value;
                this.strokeColor = value;
                break;
            case 'saveWithBackground':
                this.saveWithBackground = value;
                break;
            case 'maxStrokeWidth':
                this.maxStrokeWidth = value;
                break;
            case 'minStrokeWidth':
                this.minStrokeWidth = value;
                break;
            case 'velocity':
                this.velocity = value;
                break;
            case 'isReadOnly':
                this.isRead(value);
                break;
            case 'disabled':
                this.enableOrDisable(value);
                break;
        }
    };
    return SignatureBase;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isExecute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AccordionItemsDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AccordionItemsPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionItemDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AccordionItemPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var isExecute = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? false : true;
var vueImport;
if (!isExecute || parseInt(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["c" /* allVue */].version) < 3) {
    vueImport = __WEBPACK_IMPORTED_MODULE_2_vue__["default"];
}
else {
    vueImport = __WEBPACK_IMPORTED_MODULE_2_vue__["default"];
}
var AccordionItemsDirective = /** @class */ (function (_super) {
    __extends(AccordionItemsDirective, _super);
    function AccordionItemsDirective() {
        return _super.call(this, arguments) || this;
    }
    AccordionItemsDirective.prototype.render = function (createElement) {
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */]) {
            var h = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] || createElement;
            var slots = null;
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.$slots.default)) {
                slots = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    };
    AccordionItemsDirective.prototype.updated = function () {
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] && this.custom) {
            this.custom();
        }
    };
    AccordionItemsDirective.prototype.getTag = function () {
        return 'e-accordionitems';
    };
    AccordionItemsDirective = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({}, isExecute)
        
    ], AccordionItemsDirective);
    return AccordionItemsDirective;
}(vueImport));

var AccordionItemsPlugin = {
    name: 'e-accordionitems',
    install: function (Vue) {
        Vue.component(AccordionItemsPlugin.name, AccordionItemsDirective);
    }
};
/**
 * 'e-accordionitem' directive represent a item of Vue Accordion
 * It must be contained in a Accordion component(`ejs-accordion`).
 * ```html
 * <ejs-accordion>
 *   <e-accordionitems>
 *    <e-accordionitem header='Header1'></e-accordionitem>
 *    <e-accordionitem header='Header2' content='Content2'></e-accordionitem>
 *   </e-accordionitems>
 * </ejs-accordion>
 * ```
 */
var AccordionItemDirective = /** @class */ (function (_super) {
    __extends(AccordionItemDirective, _super);
    function AccordionItemDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccordionItemDirective.prototype.render = function () {
        return;
    };
    AccordionItemDirective.prototype.getTag = function () {
        return 'e-accordionitem';
    };
    AccordionItemDirective = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({}, isExecute)
    ], AccordionItemDirective);
    return AccordionItemDirective;
}(vueImport));

var AccordionItemPlugin = {
    name: 'e-accordionitem',
    install: function (Vue) {
        Vue.component(AccordionItemPlugin.name, AccordionItemDirective);
    }
};


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isExecute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ItemsDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ItemsPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ItemPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var isExecute = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? false : true;
var vueImport;
if (!isExecute || parseInt(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["c" /* allVue */].version) < 3) {
    vueImport = __WEBPACK_IMPORTED_MODULE_2_vue__["default"];
}
else {
    vueImport = __WEBPACK_IMPORTED_MODULE_2_vue__["default"];
}
var ItemsDirective = /** @class */ (function (_super) {
    __extends(ItemsDirective, _super);
    function ItemsDirective() {
        return _super.call(this, arguments) || this;
    }
    ItemsDirective.prototype.render = function (createElement) {
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */]) {
            var h = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] || createElement;
            var slots = null;
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.$slots.default)) {
                slots = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    };
    ItemsDirective.prototype.updated = function () {
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] && this.custom) {
            this.custom();
        }
    };
    ItemsDirective.prototype.getTag = function () {
        return 'e-items';
    };
    ItemsDirective = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({}, isExecute)
        
    ], ItemsDirective);
    return ItemsDirective;
}(vueImport));

var ItemsPlugin = {
    name: 'e-items',
    install: function (Vue) {
        Vue.component(ItemsPlugin.name, ItemsDirective);
    }
};
/**
 * 'e-item' directive represent a item of Vue Toolbar
 * It must be contained in a Toolbar component(`ejs-toolbar`).
 * ```html
 * <ejs-toolbar>
 *   <e-items>
 *    <e-item text='Cut'></e-item>
 *    <e-item text='Copy'></e-item>
 *   </e-items>
 * </ejs-toolbar>
 * ```
 */
var ItemDirective = /** @class */ (function (_super) {
    __extends(ItemDirective, _super);
    function ItemDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemDirective.prototype.render = function () {
        return;
    };
    ItemDirective.prototype.getTag = function () {
        return 'e-item';
    };
    ItemDirective = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({}, isExecute)
    ], ItemDirective);
    return ItemDirective;
}(vueImport));

var ItemPlugin = {
    name: 'e-item',
    install: function (Vue) {
        Vue.component(ItemPlugin.name, ItemDirective);
    }
};


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isExecute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BreadcrumbItemsDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BreadcrumbItemsPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BreadcrumbItemDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BreadcrumbItemPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var isExecute = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? false : true;
var vueImport;
if (!isExecute || parseInt(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["c" /* allVue */].version) < 3) {
    vueImport = __WEBPACK_IMPORTED_MODULE_2_vue__["default"];
}
else {
    vueImport = __WEBPACK_IMPORTED_MODULE_2_vue__["default"];
}
var BreadcrumbItemsDirective = /** @class */ (function (_super) {
    __extends(BreadcrumbItemsDirective, _super);
    function BreadcrumbItemsDirective() {
        return _super.call(this, arguments) || this;
    }
    BreadcrumbItemsDirective.prototype.render = function (createElement) {
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */]) {
            var h = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] || createElement;
            var slots = null;
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.$slots.default)) {
                slots = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    };
    BreadcrumbItemsDirective.prototype.updated = function () {
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] && this.custom) {
            this.custom();
        }
    };
    BreadcrumbItemsDirective.prototype.getTag = function () {
        return 'e-breadcrumb-items';
    };
    BreadcrumbItemsDirective = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({}, isExecute)
        
    ], BreadcrumbItemsDirective);
    return BreadcrumbItemsDirective;
}(vueImport));

var BreadcrumbItemsPlugin = {
    name: 'e-breadcrumb-items',
    install: function (Vue) {
        Vue.component(BreadcrumbItemsPlugin.name, BreadcrumbItemsDirective);
    }
};
/**
 * `e-breadcrumb-item` directive represent a item of the Vue Breadcrumb.
 * It must be contained in a Breadcrumb component(`ejs-breadcrumb`).
 * ```html
 * <ejs-breadcrumb>
 *   <e-breadcrumb-items>
 *    <e-breadcrumb-item text='Home' url='/'></e-breadcrumb-item>
 *    <e-breadcrumb-item text='Index' url='./index'></e-breadcrumb-item>
 *   </e-breadcrumb-items>
 * </ejs-breadcrumb>
 * ```
 */
var BreadcrumbItemDirective = /** @class */ (function (_super) {
    __extends(BreadcrumbItemDirective, _super);
    function BreadcrumbItemDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BreadcrumbItemDirective.prototype.render = function () {
        return;
    };
    BreadcrumbItemDirective.prototype.getTag = function () {
        return 'e-breadcrumb-item';
    };
    BreadcrumbItemDirective = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({}, isExecute)
    ], BreadcrumbItemDirective);
    return BreadcrumbItemDirective;
}(vueImport));

var BreadcrumbItemPlugin = {
    name: 'e-breadcrumb-item',
    install: function (Vue) {
        Vue.component(BreadcrumbItemPlugin.name, BreadcrumbItemDirective);
    }
};


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isExecute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CarouselItemsDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CarouselItemsPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CarouselItemDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CarouselItemPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var isExecute = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? false : true;
var vueImport;
if (!isExecute || parseInt(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["c" /* allVue */].version) < 3) {
    vueImport = __WEBPACK_IMPORTED_MODULE_2_vue__["default"];
}
else {
    vueImport = __WEBPACK_IMPORTED_MODULE_2_vue__["default"];
}
var CarouselItemsDirective = /** @class */ (function (_super) {
    __extends(CarouselItemsDirective, _super);
    function CarouselItemsDirective() {
        return _super.call(this, arguments) || this;
    }
    CarouselItemsDirective.prototype.render = function (createElement) {
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */]) {
            var h = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] || createElement;
            var slots = null;
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.$slots.default)) {
                slots = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    };
    CarouselItemsDirective.prototype.updated = function () {
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] && this.custom) {
            this.custom();
        }
    };
    CarouselItemsDirective.prototype.getTag = function () {
        return 'e-carousel-items';
    };
    CarouselItemsDirective = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({}, isExecute)
        
    ], CarouselItemsDirective);
    return CarouselItemsDirective;
}(vueImport));

var CarouselItemsPlugin = {
    name: 'e-carousel-items',
    install: function (Vue) {
        Vue.component(CarouselItemsPlugin.name, CarouselItemsDirective);
    }
};
/**
 * `e-carousel-item` directive represent a item of the Vue Carousel.
 * It must be contained in a Carousel component(`ejs-carousel`).
 * ```html
 * <ejs-carousel>
 *   <e-carousel-items>
 *    <e-carousel-item template='itemTemplate'></e-carousel-item>
 *    <e-carousel-item template='secondItemTemplate'></e-carousel-item>
 *   </e-carousel-items>
 * </ejs-carousel>
 * ```
 */
var CarouselItemDirective = /** @class */ (function (_super) {
    __extends(CarouselItemDirective, _super);
    function CarouselItemDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CarouselItemDirective.prototype.render = function () {
        return;
    };
    CarouselItemDirective.prototype.getTag = function () {
        return 'e-carousel-item';
    };
    CarouselItemDirective = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({}, isExecute)
    ], CarouselItemDirective);
    return CarouselItemDirective;
}(vueImport));

var CarouselItemPlugin = {
    name: 'e-carousel-item',
    install: function (Vue) {
        Vue.component(CarouselItemPlugin.name, CarouselItemDirective);
    }
};


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isExecute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TabItemsDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TabItemsPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabItemDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TabItemPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var isExecute = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? false : true;
var vueImport;
if (!isExecute || parseInt(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["c" /* allVue */].version) < 3) {
    vueImport = __WEBPACK_IMPORTED_MODULE_2_vue__["default"];
}
else {
    vueImport = __WEBPACK_IMPORTED_MODULE_2_vue__["default"];
}
var TabItemsDirective = /** @class */ (function (_super) {
    __extends(TabItemsDirective, _super);
    function TabItemsDirective() {
        return _super.call(this, arguments) || this;
    }
    TabItemsDirective.prototype.render = function (createElement) {
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */]) {
            var h = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] || createElement;
            var slots = null;
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.$slots.default)) {
                slots = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    };
    TabItemsDirective.prototype.updated = function () {
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] && this.custom) {
            this.custom();
        }
    };
    TabItemsDirective.prototype.getTag = function () {
        return 'e-tabitems';
    };
    TabItemsDirective = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({}, isExecute)
        
    ], TabItemsDirective);
    return TabItemsDirective;
}(vueImport));

var TabItemsPlugin = {
    name: 'e-tabitems',
    install: function (Vue) {
        Vue.component(TabItemsPlugin.name, TabItemsDirective);
    }
};
/**
 * 'e-tabitem' directive represent a item of the Vue Tab
 * It must be contained in a Tab component(`ejs-tab`).
 * ```html
 * <ejs-tab>
 *  <e-tabitems>
 *   <e-tabitem :header='Header 1' :content='Content 1'></e-tabitem>
 *   <e-tabitem :header='Header 2' :content='Content 2'></e-tabitem>
 *  <e-tabitems>
 * </ejs-tab>
 * ```
 */
var TabItemDirective = /** @class */ (function (_super) {
    __extends(TabItemDirective, _super);
    function TabItemDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabItemDirective.prototype.render = function () {
        return;
    };
    TabItemDirective.prototype.getTag = function () {
        return 'e-tabitem';
    };
    TabItemDirective = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({}, isExecute)
    ], TabItemDirective);
    return TabItemDirective;
}(vueImport));

var TabItemPlugin = {
    name: 'e-tabitem',
    install: function (Vue) {
        Vue.component(TabItemPlugin.name, TabItemDirective);
    }
};


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isExecute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MenuItemsDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MenuItemsPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuItemDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MenuItemPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var isExecute = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? false : true;
var vueImport;
if (!isExecute || parseInt(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["c" /* allVue */].version) < 3) {
    vueImport = __WEBPACK_IMPORTED_MODULE_2_vue__["default"];
}
else {
    vueImport = __WEBPACK_IMPORTED_MODULE_2_vue__["default"];
}
var MenuItemsDirective = /** @class */ (function (_super) {
    __extends(MenuItemsDirective, _super);
    function MenuItemsDirective() {
        return _super.call(this, arguments) || this;
    }
    MenuItemsDirective.prototype.render = function (createElement) {
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */]) {
            var h = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] || createElement;
            var slots = null;
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.$slots.default)) {
                slots = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    };
    MenuItemsDirective.prototype.updated = function () {
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] && this.custom) {
            this.custom();
        }
    };
    MenuItemsDirective.prototype.getTag = function () {
        return 'e-menu-items';
    };
    MenuItemsDirective = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({}, isExecute)
        
    ], MenuItemsDirective);
    return MenuItemsDirective;
}(vueImport));

var MenuItemsPlugin = {
    name: 'e-menu-items',
    install: function (Vue) {
        Vue.component(MenuItemsPlugin.name, MenuItemsDirective);
    }
};
var MenuItemDirective = /** @class */ (function (_super) {
    __extends(MenuItemDirective, _super);
    function MenuItemDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuItemDirective.prototype.render = function () {
        return;
    };
    MenuItemDirective.prototype.getTag = function () {
        return 'e-';
    };
    MenuItemDirective = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({}, isExecute)
    ], MenuItemDirective);
    return MenuItemDirective;
}(vueImport));

var MenuItemPlugin = {
    name: 'e-',
    install: function (Vue) {
        Vue.component(MenuItemPlugin.name, MenuItemDirective);
    }
};


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_navigations__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Comp_TreeView_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Comp_ShowProducts_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Comp_AddProduct_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Comp_DeleteProduct_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Comp_AddSubcat_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Comp_ProductDetails_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Comp_AlternativeProductDetails_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Comp_DeleteCategory_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Comp_NewRootNode_vue__ = __webpack_require__(76);






Object(__WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_base__["E" /* enableRipple */])(true);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_navigations__["a" /* MenuPlugin */]);











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var routes = [{ path: "/Home", name: "Home", component: __WEBPACK_IMPORTED_MODULE_5__Comp_TreeView_vue__["a" /* default */] }, { path: "/ShowProducts", name: "ShowProducts", component: __WEBPACK_IMPORTED_MODULE_6__Comp_ShowProducts_vue__["a" /* default */] }, { path: "/ShowProductsofCat", name: "ShowProductsofCat", component: __WEBPACK_IMPORTED_MODULE_6__Comp_ShowProducts_vue__["a" /* default */] }, { path: "/AddProduct", name: "AddProduct", component: __WEBPACK_IMPORTED_MODULE_7__Comp_AddProduct_vue__["a" /* default */] }, { path: "/DeleteProduct", name: "DeleteProduct", component: __WEBPACK_IMPORTED_MODULE_8__Comp_DeleteProduct_vue__["a" /* default */] }, { path: "/DeleteProd", name: "DeleteProd" }, { path: "/AddSubcat", name: "AddSubcat", component: __WEBPACK_IMPORTED_MODULE_9__Comp_AddSubcat_vue__["a" /* default */] }, { path: "/ProductDetails", name: "ProductDetails", component: __WEBPACK_IMPORTED_MODULE_10__Comp_ProductDetails_vue__["a" /* default */] }, { path: "/AlternativeProductDetails", name: "AlternativeProductDetails", component: __WEBPACK_IMPORTED_MODULE_11__Comp_AlternativeProductDetails_vue__["a" /* default */] }, { path: "/DeleteCategory", name: "DeleteCategory", component: __WEBPACK_IMPORTED_MODULE_12__Comp_DeleteCategory_vue__["a" /* default */] }, { path: "/DeleteCat", name: "DeleteCat" }, { path: "/CrumbClicked", name: "CrumbClicked" }, { path: "/NewRootNode", name: "NewRootNode", component: __WEBPACK_IMPORTED_MODULE_13__Comp_NewRootNode_vue__["a" /* default */] }];

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: routes
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: router,
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(100);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35), __webpack_require__(47)))

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_267ddf9d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(193);
function injectStyle (ssrContext) {
  __webpack_require__(102)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_267ddf9d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(103);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("145c6632", content, true, {});

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "body{font-family:Arial;overflow:visible}#left{width:380px;float:left;height:90vh;overflow-y:scroll;position:fixed;background-color:#fff}#left,#right{border:0 solid;margin-top:50px}#right{width:calc(100% - 380px);float:right;padding-left:20px}#topleft{width:380px;height:50px}#topleft,#topright{border:0 solid;position:fixed;top:0;background-color:#fff}#topright{width:calc(100% - 380px);left:388px;height:40px;padding-top:10px}.smallspacer{height:10px}", ""]);

// exports


/***/ }),
/* 104 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(106);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2b8274d4", content, true, {});

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".link[data-v-65e407d5],.minus[data-v-65e407d5],.plus[data-v-65e407d5]{float:left}.minus[data-v-65e407d5],.plus[data-v-65e407d5]{margin-right:5px;color:#6495ed}.space[data-v-65e407d5]{float:left;margin-right:10px}.tree-menu .label-wrapper[data-v-65e407d5]{padding-bottom:25px;margin-bottom:15px}.tree-menu .has-children[data-v-65e407d5]{cursor:pointer}.hyperlink[data-v-65e407d5]{text-decoration:none}.expanded[data-v-65e407d5]{max-height:5000px;transition:max-height 1s ease-in;overflow:hidden}.collapsed[data-v-65e407d5]{max-height:0;transition:max-height 1s ease-out;overflow:hidden}.menulink[data-v-65e407d5]{margin-bottom:10px;font-size:18px;text-decoration:none;color:#6495ed}.addproduct[data-v-65e407d5],.deletelink[data-v-65e407d5]{font-size:10px;margin-left:20px;margin-top:-4px;text-decoration:none;color:#6495ed}.addproduct a[data-v-65e407d5]:hover,.deletelink a[data-v-65e407d5]:hover{text-decoration:underline}.addsubcat[data-v-65e407d5]{font-size:12px;text-decoration:none;color:#6495ed}.delcat[data-v-65e407d5]{font-size:10px;text-decoration:none;color:#6495ed}.nextline[data-v-65e407d5]{clear:both}", ""]);

// exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-menu"},[_c('div',{staticClass:"label-wrapper"},[_c('div',{class:_vm.showHand,style:(_vm.indent)},[(_vm.hasChildren && !_vm.expanded)?_c('div',{staticClass:"plus",on:{"click":_vm.toggleChildren}},[_vm._v("+")]):_vm._e(),_vm._v(" "),(_vm.hasChildren && _vm.expanded)?_c('div',{staticClass:"minus",on:{"click":_vm.toggleChildren}},[_vm._v("-")]):_vm._e(),_vm._v(" "),(!_vm.hasChildren)?_c('div',{staticClass:"space"},[_vm._v(" ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"link"},[_c('router-link',{staticClass:"menulink",attrs:{"to":{ path: '/ShowProductsofCat', query: { id: _vm.catid, level: _vm.level, category: _vm.name } }}},[_vm._v("\n          "+_vm._s(_vm.name)+"\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"delcat",attrs:{"to":{ path: '/DeleteCategory', query: { id: _vm.catid, category: _vm.name } }}},[_vm._v("\n          DEL\n        ")]),_vm._v(" "),(!_vm.hasChildren)?_c('router-link',{staticClass:"addproduct",attrs:{"to":{ path: '/AddProduct', query: { id: _vm.catid, level: _vm.level, category: _vm.name } }}},[_vm._v("\n          Add product\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nextline"},[_c('router-link',{staticClass:"addsubcat",attrs:{"to":{ path: '/AddSubcat', query: { id: _vm.catid, level: _vm.level, parentcategory: _vm.name } }}},[_vm._v("\n            Add subcategory\n          ")])],1)],1)])]),_vm._v(" "),_vm._l((_vm.children),function(child){return _c('Comp_TreeView',{key:child,class:_vm.expanded_or_collapsed,attrs:{"children":child.children,"name":child.categoryname,"catid":child.id,"level":_vm.level + 1}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(109);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("df427648", content, true, {});

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "#description[data-v-ea7d39de],#image[data-v-ea7d39de],#price[data-v-ea7d39de],#prodname[data-v-ea7d39de]{display:inline-block;vertical-align:top;margin-top:10px}#proditem[data-v-ea7d39de]{margin-left:20px;margin-bottom:20px;border-top:1px solid #d3d3d3}#prodname[data-v-ea7d39de]{width:200px}#description[data-v-ea7d39de]{width:300px}#price[data-v-ea7d39de]{width:100px}#image[data-v-ea7d39de]{width:250px}#categorydiv[data-v-ea7d39de]{margin-left:20px;font-family:Arial;font-size:20px;margin-bottom:40px}.button[data-v-ea7d39de]{border:1px solid gray;border-radius:4px;padding:10px;display:inline-block;margin-top:10px}", ""]);

// exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"categorydiv"}},[_vm._v(_vm._s(_vm.catname))]),_vm._v(" "),_vm._l((_vm.products),function(product){return _c('div',{key:product.id},[_c('div',{attrs:{"id":"proditem"}},[_c('div',{attrs:{"id":"prodname"}},[_vm._v(_vm._s(product.productname))]),_vm._v(" "),_c('div',{attrs:{"id":"description"}},[_vm._v(_vm._s(product.description))]),_vm._v(" "),_c('div',{attrs:{"id":"price"}},[_vm._v("€ "+_vm._s(product.price))]),_vm._v(" "),_c('img',{attrs:{"id":"image","src":_vm.$options.filters.removetilde(product.picture)}}),_vm._v(" "),_c('router-link',{staticClass:"button",staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"to":{ path: '/DeleteProduct', query: { Id: product.id, ProdName: product.productname  } }}},[_vm._v("\n          Delete\n      ")]),_vm._v(" "),_c('router-link',{staticClass:"button",staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"to":{ path: '/ProductDetails', query: { Id: product.id, ProdName: product.productname } }}},[_vm._v("\n          Details\n      ")])],1)])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(112);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("83ca7220", content, true, {});

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n/*!\n * Bootstrap v5.1.3 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */[data-v-14fc86fd]:root{--bs-blue:#0d6efd;--bs-indigo:#6610f2;--bs-purple:#6f42c1;--bs-pink:#d63384;--bs-red:#dc3545;--bs-orange:#fd7e14;--bs-yellow:#ffc107;--bs-green:#198754;--bs-teal:#20c997;--bs-cyan:#0dcaf0;--bs-white:#fff;--bs-gray:#6c757d;--bs-gray-dark:#343a40;--bs-gray-100:#f8f9fa;--bs-gray-200:#e9ecef;--bs-gray-300:#dee2e6;--bs-gray-400:#ced4da;--bs-gray-500:#adb5bd;--bs-gray-600:#6c757d;--bs-gray-700:#495057;--bs-gray-800:#343a40;--bs-gray-900:#212529;--bs-primary:#0d6efd;--bs-secondary:#6c757d;--bs-success:#198754;--bs-info:#0dcaf0;--bs-warning:#ffc107;--bs-danger:#dc3545;--bs-light:#f8f9fa;--bs-dark:#212529;--bs-primary-rgb:13,110,253;--bs-secondary-rgb:108,117,125;--bs-success-rgb:25,135,84;--bs-info-rgb:13,202,240;--bs-warning-rgb:255,193,7;--bs-danger-rgb:220,53,69;--bs-light-rgb:248,249,250;--bs-dark-rgb:33,37,41;--bs-white-rgb:255,255,255;--bs-black-rgb:0,0,0;--bs-body-color-rgb:33,37,41;--bs-body-bg-rgb:255,255,255;--bs-font-sans-serif:system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--bs-font-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;--bs-gradient:linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));--bs-body-font-family:var(--bs-font-sans-serif);--bs-body-font-size:1rem;--bs-body-font-weight:400;--bs-body-line-height:1.5;--bs-body-color:#212529;--bs-body-bg:#fff}[data-v-14fc86fd],[data-v-14fc86fd]:after,[data-v-14fc86fd]:before{box-sizing:border-box}@media (prefers-reduced-motion:no-preference){[data-v-14fc86fd]:root{scroll-behavior:smooth}}body[data-v-14fc86fd]{margin:0;font-family:var(--bs-body-font-family);font-size:var(--bs-body-font-size);font-weight:var(--bs-body-font-weight);line-height:var(--bs-body-line-height);color:var(--bs-body-color);text-align:var(--bs-body-text-align);background-color:var(--bs-body-bg);-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}hr[data-v-14fc86fd]{margin:1rem 0;color:inherit;background-color:currentColor;border:0;opacity:.25}hr[data-v-14fc86fd]:not([size]){height:1px}.h1[data-v-14fc86fd],.h2[data-v-14fc86fd],.h3[data-v-14fc86fd],.h4[data-v-14fc86fd],.h5[data-v-14fc86fd],.h6[data-v-14fc86fd],h1[data-v-14fc86fd],h2[data-v-14fc86fd],h3[data-v-14fc86fd],h4[data-v-14fc86fd],h5[data-v-14fc86fd],h6[data-v-14fc86fd]{margin-top:0;margin-bottom:.5rem;font-weight:500;line-height:1.2}.h1[data-v-14fc86fd],h1[data-v-14fc86fd]{font-size:calc(1.375rem + 1.5vw)}@media (min-width:1200px){.h1[data-v-14fc86fd],h1[data-v-14fc86fd]{font-size:2.5rem}}.h2[data-v-14fc86fd],h2[data-v-14fc86fd]{font-size:calc(1.325rem + .9vw)}@media (min-width:1200px){.h2[data-v-14fc86fd],h2[data-v-14fc86fd]{font-size:2rem}}.h3[data-v-14fc86fd],h3[data-v-14fc86fd]{font-size:calc(1.3rem + .6vw)}@media (min-width:1200px){.h3[data-v-14fc86fd],h3[data-v-14fc86fd]{font-size:1.75rem}}.h4[data-v-14fc86fd],h4[data-v-14fc86fd]{font-size:calc(1.275rem + .3vw)}@media (min-width:1200px){.h4[data-v-14fc86fd],h4[data-v-14fc86fd]{font-size:1.5rem}}.h5[data-v-14fc86fd],h5[data-v-14fc86fd]{font-size:1.25rem}.h6[data-v-14fc86fd],h6[data-v-14fc86fd]{font-size:1rem}p[data-v-14fc86fd]{margin-top:0;margin-bottom:1rem}abbr[data-bs-original-title][data-v-14fc86fd],abbr[title][data-v-14fc86fd]{-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address[data-v-14fc86fd]{margin-bottom:1rem;font-style:normal;line-height:inherit}ol[data-v-14fc86fd],ul[data-v-14fc86fd]{padding-left:2rem}dl[data-v-14fc86fd],ol[data-v-14fc86fd],ul[data-v-14fc86fd]{margin-top:0;margin-bottom:1rem}ol ol[data-v-14fc86fd],ol ul[data-v-14fc86fd],ul ol[data-v-14fc86fd],ul ul[data-v-14fc86fd]{margin-bottom:0}dt[data-v-14fc86fd]{font-weight:700}dd[data-v-14fc86fd]{margin-bottom:.5rem;margin-left:0}blockquote[data-v-14fc86fd]{margin:0 0 1rem}b[data-v-14fc86fd],strong[data-v-14fc86fd]{font-weight:bolder}.small[data-v-14fc86fd],small[data-v-14fc86fd]{font-size:.875em}.mark[data-v-14fc86fd],mark[data-v-14fc86fd]{padding:.2em;background-color:#fcf8e3}sub[data-v-14fc86fd],sup[data-v-14fc86fd]{position:relative;font-size:.75em;line-height:0;vertical-align:baseline}sub[data-v-14fc86fd]{bottom:-.25em}sup[data-v-14fc86fd]{top:-.5em}a[data-v-14fc86fd]{color:#0d6efd;text-decoration:underline}a[data-v-14fc86fd]:hover{color:#0a58ca}a[data-v-14fc86fd]:not([href]):not([class]),a[data-v-14fc86fd]:not([href]):not([class]):hover{color:inherit;text-decoration:none}code[data-v-14fc86fd],kbd[data-v-14fc86fd],pre[data-v-14fc86fd],samp[data-v-14fc86fd]{font-family:var(--bs-font-monospace);font-size:1em;direction:ltr;unicode-bidi:bidi-override}pre[data-v-14fc86fd]{display:block;margin-top:0;margin-bottom:1rem;overflow:auto;font-size:.875em}pre code[data-v-14fc86fd]{font-size:inherit;color:inherit;word-break:normal}code[data-v-14fc86fd]{font-size:.875em;color:#d63384;word-wrap:break-word}a>code[data-v-14fc86fd]{color:inherit}kbd[data-v-14fc86fd]{padding:.2rem .4rem;font-size:.875em;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd[data-v-14fc86fd]{padding:0;font-size:1em;font-weight:700}figure[data-v-14fc86fd]{margin:0 0 1rem}img[data-v-14fc86fd],svg[data-v-14fc86fd]{vertical-align:middle}table[data-v-14fc86fd]{caption-side:bottom;border-collapse:collapse}caption[data-v-14fc86fd]{padding-top:.5rem;padding-bottom:.5rem;color:#6c757d;text-align:left}th[data-v-14fc86fd]{text-align:inherit;text-align:-webkit-match-parent}tbody[data-v-14fc86fd],td[data-v-14fc86fd],tfoot[data-v-14fc86fd],th[data-v-14fc86fd],thead[data-v-14fc86fd],tr[data-v-14fc86fd]{border-color:inherit;border-style:solid;border-width:0}label[data-v-14fc86fd]{display:inline-block}button[data-v-14fc86fd]{border-radius:0}button[data-v-14fc86fd]:focus:not(:focus-visible){outline:0}button[data-v-14fc86fd],input[data-v-14fc86fd],optgroup[data-v-14fc86fd],select[data-v-14fc86fd],textarea[data-v-14fc86fd]{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button[data-v-14fc86fd],select[data-v-14fc86fd]{text-transform:none}[role=button][data-v-14fc86fd]{cursor:pointer}select[data-v-14fc86fd]{word-wrap:normal}select[data-v-14fc86fd]:disabled{opacity:1}[list][data-v-14fc86fd]::-webkit-calendar-picker-indicator{display:none}[type=button][data-v-14fc86fd],[type=reset][data-v-14fc86fd],[type=submit][data-v-14fc86fd],button[data-v-14fc86fd]{-webkit-appearance:button}[type=button][data-v-14fc86fd]:not(:disabled),[type=reset][data-v-14fc86fd]:not(:disabled),[type=submit][data-v-14fc86fd]:not(:disabled),button[data-v-14fc86fd]:not(:disabled){cursor:pointer}[data-v-14fc86fd]::-moz-focus-inner{padding:0;border-style:none}textarea[data-v-14fc86fd]{resize:vertical}fieldset[data-v-14fc86fd]{min-width:0;padding:0;margin:0;border:0}legend[data-v-14fc86fd]{float:left;width:100%;padding:0;margin-bottom:.5rem;font-size:calc(1.275rem + .3vw);line-height:inherit}@media (min-width:1200px){legend[data-v-14fc86fd]{font-size:1.5rem}}legend+[data-v-14fc86fd]{clear:left}[data-v-14fc86fd]::-webkit-datetime-edit-day-field,[data-v-14fc86fd]::-webkit-datetime-edit-fields-wrapper,[data-v-14fc86fd]::-webkit-datetime-edit-hour-field,[data-v-14fc86fd]::-webkit-datetime-edit-minute,[data-v-14fc86fd]::-webkit-datetime-edit-month-field,[data-v-14fc86fd]::-webkit-datetime-edit-text,[data-v-14fc86fd]::-webkit-datetime-edit-year-field{padding:0}[data-v-14fc86fd]::-webkit-inner-spin-button{height:auto}[type=search][data-v-14fc86fd]{outline-offset:-2px;-webkit-appearance:textfield}[data-v-14fc86fd]::-webkit-search-decoration{-webkit-appearance:none}[data-v-14fc86fd]::-webkit-color-swatch-wrapper{padding:0}[data-v-14fc86fd]::file-selector-button{font:inherit}[data-v-14fc86fd]::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output[data-v-14fc86fd]{display:inline-block}iframe[data-v-14fc86fd]{border:0}summary[data-v-14fc86fd]{display:list-item;cursor:pointer}progress[data-v-14fc86fd]{vertical-align:baseline}[hidden][data-v-14fc86fd]{display:none!important}.lead[data-v-14fc86fd]{font-size:1.25rem;font-weight:300}.display-1[data-v-14fc86fd]{font-size:calc(1.625rem + 4.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-1[data-v-14fc86fd]{font-size:5rem}}.display-2[data-v-14fc86fd]{font-size:calc(1.575rem + 3.9vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-2[data-v-14fc86fd]{font-size:4.5rem}}.display-3[data-v-14fc86fd]{font-size:calc(1.525rem + 3.3vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-3[data-v-14fc86fd]{font-size:4rem}}.display-4[data-v-14fc86fd]{font-size:calc(1.475rem + 2.7vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-4[data-v-14fc86fd]{font-size:3.5rem}}.display-5[data-v-14fc86fd]{font-size:calc(1.425rem + 2.1vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-5[data-v-14fc86fd]{font-size:3rem}}.display-6[data-v-14fc86fd]{font-size:calc(1.375rem + 1.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-6[data-v-14fc86fd]{font-size:2.5rem}}.list-inline[data-v-14fc86fd],.list-unstyled[data-v-14fc86fd]{padding-left:0;list-style:none}.list-inline-item[data-v-14fc86fd]{display:inline-block}.list-inline-item[data-v-14fc86fd]:not(:last-child){margin-right:.5rem}.initialism[data-v-14fc86fd]{font-size:.875em;text-transform:uppercase}.blockquote[data-v-14fc86fd]{margin-bottom:1rem;font-size:1.25rem}.blockquote[data-v-14fc86fd]>:last-child{margin-bottom:0}.blockquote-footer[data-v-14fc86fd]{margin-top:-1rem;margin-bottom:1rem;font-size:.875em;color:#6c757d}.blockquote-footer[data-v-14fc86fd]:before{content:\"\\2014\\A0\"}.img-fluid[data-v-14fc86fd]{max-width:100%;height:auto}.img-thumbnail[data-v-14fc86fd]{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.figure[data-v-14fc86fd]{display:inline-block}.figure-img[data-v-14fc86fd]{margin-bottom:.5rem;line-height:1}.figure-caption[data-v-14fc86fd]{font-size:.875em;color:#6c757d}.container-fluid[data-v-14fc86fd],.container-lg[data-v-14fc86fd],.container-md[data-v-14fc86fd],.container-sm[data-v-14fc86fd],.container-xl[data-v-14fc86fd],.container-xxl[data-v-14fc86fd],.container[data-v-14fc86fd]{width:100%;padding-right:var(--bs-gutter-x,.75rem);padding-left:var(--bs-gutter-x,.75rem);margin-right:auto;margin-left:auto}@media (min-width:576px){.container-sm[data-v-14fc86fd],.container[data-v-14fc86fd]{max-width:540px}}@media (min-width:768px){.container-md[data-v-14fc86fd],.container-sm[data-v-14fc86fd],.container[data-v-14fc86fd]{max-width:720px}}@media (min-width:992px){.container-lg[data-v-14fc86fd],.container-md[data-v-14fc86fd],.container-sm[data-v-14fc86fd],.container[data-v-14fc86fd]{max-width:960px}}@media (min-width:1200px){.container-lg[data-v-14fc86fd],.container-md[data-v-14fc86fd],.container-sm[data-v-14fc86fd],.container-xl[data-v-14fc86fd],.container[data-v-14fc86fd]{max-width:1140px}}@media (min-width:1400px){.container-lg[data-v-14fc86fd],.container-md[data-v-14fc86fd],.container-sm[data-v-14fc86fd],.container-xl[data-v-14fc86fd],.container-xxl[data-v-14fc86fd],.container[data-v-14fc86fd]{max-width:1320px}}.row[data-v-14fc86fd]{--bs-gutter-x:1.5rem;--bs-gutter-y:0;display:flex;flex-wrap:wrap;margin-top:calc(-1 * var(--bs-gutter-y));margin-right:calc(-.5 * var(--bs-gutter-x));margin-left:calc(-.5 * var(--bs-gutter-x))}.row>[data-v-14fc86fd]{flex-shrink:0;width:100%;max-width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-top:var(--bs-gutter-y)}.col[data-v-14fc86fd]{flex:1 0 0%}.row-cols-auto>[data-v-14fc86fd]{flex:0 0 auto;width:auto}.row-cols-1>[data-v-14fc86fd]{flex:0 0 auto;width:100%}.row-cols-2>[data-v-14fc86fd]{flex:0 0 auto;width:50%}.row-cols-3>[data-v-14fc86fd]{flex:0 0 auto;width:33.3333333333%}.row-cols-4>[data-v-14fc86fd]{flex:0 0 auto;width:25%}.row-cols-5>[data-v-14fc86fd]{flex:0 0 auto;width:20%}.row-cols-6>[data-v-14fc86fd]{flex:0 0 auto;width:16.6666666667%}.col-auto[data-v-14fc86fd]{flex:0 0 auto;width:auto}.col-1[data-v-14fc86fd]{flex:0 0 auto;width:8.33333333%}.col-2[data-v-14fc86fd]{flex:0 0 auto;width:16.66666667%}.col-3[data-v-14fc86fd]{flex:0 0 auto;width:25%}.col-4[data-v-14fc86fd]{flex:0 0 auto;width:33.33333333%}.col-5[data-v-14fc86fd]{flex:0 0 auto;width:41.66666667%}.col-6[data-v-14fc86fd]{flex:0 0 auto;width:50%}.col-7[data-v-14fc86fd]{flex:0 0 auto;width:58.33333333%}.col-8[data-v-14fc86fd]{flex:0 0 auto;width:66.66666667%}.col-9[data-v-14fc86fd]{flex:0 0 auto;width:75%}.col-10[data-v-14fc86fd]{flex:0 0 auto;width:83.33333333%}.col-11[data-v-14fc86fd]{flex:0 0 auto;width:91.66666667%}.col-12[data-v-14fc86fd]{flex:0 0 auto;width:100%}.offset-1[data-v-14fc86fd]{margin-left:8.33333333%}.offset-2[data-v-14fc86fd]{margin-left:16.66666667%}.offset-3[data-v-14fc86fd]{margin-left:25%}.offset-4[data-v-14fc86fd]{margin-left:33.33333333%}.offset-5[data-v-14fc86fd]{margin-left:41.66666667%}.offset-6[data-v-14fc86fd]{margin-left:50%}.offset-7[data-v-14fc86fd]{margin-left:58.33333333%}.offset-8[data-v-14fc86fd]{margin-left:66.66666667%}.offset-9[data-v-14fc86fd]{margin-left:75%}.offset-10[data-v-14fc86fd]{margin-left:83.33333333%}.offset-11[data-v-14fc86fd]{margin-left:91.66666667%}.g-0[data-v-14fc86fd],.gx-0[data-v-14fc86fd]{--bs-gutter-x:0}.g-0[data-v-14fc86fd],.gy-0[data-v-14fc86fd]{--bs-gutter-y:0}.g-1[data-v-14fc86fd],.gx-1[data-v-14fc86fd]{--bs-gutter-x:0.25rem}.g-1[data-v-14fc86fd],.gy-1[data-v-14fc86fd]{--bs-gutter-y:0.25rem}.g-2[data-v-14fc86fd],.gx-2[data-v-14fc86fd]{--bs-gutter-x:0.5rem}.g-2[data-v-14fc86fd],.gy-2[data-v-14fc86fd]{--bs-gutter-y:0.5rem}.g-3[data-v-14fc86fd],.gx-3[data-v-14fc86fd]{--bs-gutter-x:1rem}.g-3[data-v-14fc86fd],.gy-3[data-v-14fc86fd]{--bs-gutter-y:1rem}.g-4[data-v-14fc86fd],.gx-4[data-v-14fc86fd]{--bs-gutter-x:1.5rem}.g-4[data-v-14fc86fd],.gy-4[data-v-14fc86fd]{--bs-gutter-y:1.5rem}.g-5[data-v-14fc86fd],.gx-5[data-v-14fc86fd]{--bs-gutter-x:3rem}.g-5[data-v-14fc86fd],.gy-5[data-v-14fc86fd]{--bs-gutter-y:3rem}@media (min-width:576px){.col-sm[data-v-14fc86fd]{flex:1 0 0%}.row-cols-sm-auto>[data-v-14fc86fd]{flex:0 0 auto;width:auto}.row-cols-sm-1>[data-v-14fc86fd]{flex:0 0 auto;width:100%}.row-cols-sm-2>[data-v-14fc86fd]{flex:0 0 auto;width:50%}.row-cols-sm-3>[data-v-14fc86fd]{flex:0 0 auto;width:33.3333333333%}.row-cols-sm-4>[data-v-14fc86fd]{flex:0 0 auto;width:25%}.row-cols-sm-5>[data-v-14fc86fd]{flex:0 0 auto;width:20%}.row-cols-sm-6>[data-v-14fc86fd]{flex:0 0 auto;width:16.6666666667%}.col-sm-auto[data-v-14fc86fd]{flex:0 0 auto;width:auto}.col-sm-1[data-v-14fc86fd]{flex:0 0 auto;width:8.33333333%}.col-sm-2[data-v-14fc86fd]{flex:0 0 auto;width:16.66666667%}.col-sm-3[data-v-14fc86fd]{flex:0 0 auto;width:25%}.col-sm-4[data-v-14fc86fd]{flex:0 0 auto;width:33.33333333%}.col-sm-5[data-v-14fc86fd]{flex:0 0 auto;width:41.66666667%}.col-sm-6[data-v-14fc86fd]{flex:0 0 auto;width:50%}.col-sm-7[data-v-14fc86fd]{flex:0 0 auto;width:58.33333333%}.col-sm-8[data-v-14fc86fd]{flex:0 0 auto;width:66.66666667%}.col-sm-9[data-v-14fc86fd]{flex:0 0 auto;width:75%}.col-sm-10[data-v-14fc86fd]{flex:0 0 auto;width:83.33333333%}.col-sm-11[data-v-14fc86fd]{flex:0 0 auto;width:91.66666667%}.col-sm-12[data-v-14fc86fd]{flex:0 0 auto;width:100%}.offset-sm-0[data-v-14fc86fd]{margin-left:0}.offset-sm-1[data-v-14fc86fd]{margin-left:8.33333333%}.offset-sm-2[data-v-14fc86fd]{margin-left:16.66666667%}.offset-sm-3[data-v-14fc86fd]{margin-left:25%}.offset-sm-4[data-v-14fc86fd]{margin-left:33.33333333%}.offset-sm-5[data-v-14fc86fd]{margin-left:41.66666667%}.offset-sm-6[data-v-14fc86fd]{margin-left:50%}.offset-sm-7[data-v-14fc86fd]{margin-left:58.33333333%}.offset-sm-8[data-v-14fc86fd]{margin-left:66.66666667%}.offset-sm-9[data-v-14fc86fd]{margin-left:75%}.offset-sm-10[data-v-14fc86fd]{margin-left:83.33333333%}.offset-sm-11[data-v-14fc86fd]{margin-left:91.66666667%}.g-sm-0[data-v-14fc86fd],.gx-sm-0[data-v-14fc86fd]{--bs-gutter-x:0}.g-sm-0[data-v-14fc86fd],.gy-sm-0[data-v-14fc86fd]{--bs-gutter-y:0}.g-sm-1[data-v-14fc86fd],.gx-sm-1[data-v-14fc86fd]{--bs-gutter-x:0.25rem}.g-sm-1[data-v-14fc86fd],.gy-sm-1[data-v-14fc86fd]{--bs-gutter-y:0.25rem}.g-sm-2[data-v-14fc86fd],.gx-sm-2[data-v-14fc86fd]{--bs-gutter-x:0.5rem}.g-sm-2[data-v-14fc86fd],.gy-sm-2[data-v-14fc86fd]{--bs-gutter-y:0.5rem}.g-sm-3[data-v-14fc86fd],.gx-sm-3[data-v-14fc86fd]{--bs-gutter-x:1rem}.g-sm-3[data-v-14fc86fd],.gy-sm-3[data-v-14fc86fd]{--bs-gutter-y:1rem}.g-sm-4[data-v-14fc86fd],.gx-sm-4[data-v-14fc86fd]{--bs-gutter-x:1.5rem}.g-sm-4[data-v-14fc86fd],.gy-sm-4[data-v-14fc86fd]{--bs-gutter-y:1.5rem}.g-sm-5[data-v-14fc86fd],.gx-sm-5[data-v-14fc86fd]{--bs-gutter-x:3rem}.g-sm-5[data-v-14fc86fd],.gy-sm-5[data-v-14fc86fd]{--bs-gutter-y:3rem}}@media (min-width:768px){.col-md[data-v-14fc86fd]{flex:1 0 0%}.row-cols-md-auto>[data-v-14fc86fd]{flex:0 0 auto;width:auto}.row-cols-md-1>[data-v-14fc86fd]{flex:0 0 auto;width:100%}.row-cols-md-2>[data-v-14fc86fd]{flex:0 0 auto;width:50%}.row-cols-md-3>[data-v-14fc86fd]{flex:0 0 auto;width:33.3333333333%}.row-cols-md-4>[data-v-14fc86fd]{flex:0 0 auto;width:25%}.row-cols-md-5>[data-v-14fc86fd]{flex:0 0 auto;width:20%}.row-cols-md-6>[data-v-14fc86fd]{flex:0 0 auto;width:16.6666666667%}.col-md-auto[data-v-14fc86fd]{flex:0 0 auto;width:auto}.col-md-1[data-v-14fc86fd]{flex:0 0 auto;width:8.33333333%}.col-md-2[data-v-14fc86fd]{flex:0 0 auto;width:16.66666667%}.col-md-3[data-v-14fc86fd]{flex:0 0 auto;width:25%}.col-md-4[data-v-14fc86fd]{flex:0 0 auto;width:33.33333333%}.col-md-5[data-v-14fc86fd]{flex:0 0 auto;width:41.66666667%}.col-md-6[data-v-14fc86fd]{flex:0 0 auto;width:50%}.col-md-7[data-v-14fc86fd]{flex:0 0 auto;width:58.33333333%}.col-md-8[data-v-14fc86fd]{flex:0 0 auto;width:66.66666667%}.col-md-9[data-v-14fc86fd]{flex:0 0 auto;width:75%}.col-md-10[data-v-14fc86fd]{flex:0 0 auto;width:83.33333333%}.col-md-11[data-v-14fc86fd]{flex:0 0 auto;width:91.66666667%}.col-md-12[data-v-14fc86fd]{flex:0 0 auto;width:100%}.offset-md-0[data-v-14fc86fd]{margin-left:0}.offset-md-1[data-v-14fc86fd]{margin-left:8.33333333%}.offset-md-2[data-v-14fc86fd]{margin-left:16.66666667%}.offset-md-3[data-v-14fc86fd]{margin-left:25%}.offset-md-4[data-v-14fc86fd]{margin-left:33.33333333%}.offset-md-5[data-v-14fc86fd]{margin-left:41.66666667%}.offset-md-6[data-v-14fc86fd]{margin-left:50%}.offset-md-7[data-v-14fc86fd]{margin-left:58.33333333%}.offset-md-8[data-v-14fc86fd]{margin-left:66.66666667%}.offset-md-9[data-v-14fc86fd]{margin-left:75%}.offset-md-10[data-v-14fc86fd]{margin-left:83.33333333%}.offset-md-11[data-v-14fc86fd]{margin-left:91.66666667%}.g-md-0[data-v-14fc86fd],.gx-md-0[data-v-14fc86fd]{--bs-gutter-x:0}.g-md-0[data-v-14fc86fd],.gy-md-0[data-v-14fc86fd]{--bs-gutter-y:0}.g-md-1[data-v-14fc86fd],.gx-md-1[data-v-14fc86fd]{--bs-gutter-x:0.25rem}.g-md-1[data-v-14fc86fd],.gy-md-1[data-v-14fc86fd]{--bs-gutter-y:0.25rem}.g-md-2[data-v-14fc86fd],.gx-md-2[data-v-14fc86fd]{--bs-gutter-x:0.5rem}.g-md-2[data-v-14fc86fd],.gy-md-2[data-v-14fc86fd]{--bs-gutter-y:0.5rem}.g-md-3[data-v-14fc86fd],.gx-md-3[data-v-14fc86fd]{--bs-gutter-x:1rem}.g-md-3[data-v-14fc86fd],.gy-md-3[data-v-14fc86fd]{--bs-gutter-y:1rem}.g-md-4[data-v-14fc86fd],.gx-md-4[data-v-14fc86fd]{--bs-gutter-x:1.5rem}.g-md-4[data-v-14fc86fd],.gy-md-4[data-v-14fc86fd]{--bs-gutter-y:1.5rem}.g-md-5[data-v-14fc86fd],.gx-md-5[data-v-14fc86fd]{--bs-gutter-x:3rem}.g-md-5[data-v-14fc86fd],.gy-md-5[data-v-14fc86fd]{--bs-gutter-y:3rem}}@media (min-width:992px){.col-lg[data-v-14fc86fd]{flex:1 0 0%}.row-cols-lg-auto>[data-v-14fc86fd]{flex:0 0 auto;width:auto}.row-cols-lg-1>[data-v-14fc86fd]{flex:0 0 auto;width:100%}.row-cols-lg-2>[data-v-14fc86fd]{flex:0 0 auto;width:50%}.row-cols-lg-3>[data-v-14fc86fd]{flex:0 0 auto;width:33.3333333333%}.row-cols-lg-4>[data-v-14fc86fd]{flex:0 0 auto;width:25%}.row-cols-lg-5>[data-v-14fc86fd]{flex:0 0 auto;width:20%}.row-cols-lg-6>[data-v-14fc86fd]{flex:0 0 auto;width:16.6666666667%}.col-lg-auto[data-v-14fc86fd]{flex:0 0 auto;width:auto}.col-lg-1[data-v-14fc86fd]{flex:0 0 auto;width:8.33333333%}.col-lg-2[data-v-14fc86fd]{flex:0 0 auto;width:16.66666667%}.col-lg-3[data-v-14fc86fd]{flex:0 0 auto;width:25%}.col-lg-4[data-v-14fc86fd]{flex:0 0 auto;width:33.33333333%}.col-lg-5[data-v-14fc86fd]{flex:0 0 auto;width:41.66666667%}.col-lg-6[data-v-14fc86fd]{flex:0 0 auto;width:50%}.col-lg-7[data-v-14fc86fd]{flex:0 0 auto;width:58.33333333%}.col-lg-8[data-v-14fc86fd]{flex:0 0 auto;width:66.66666667%}.col-lg-9[data-v-14fc86fd]{flex:0 0 auto;width:75%}.col-lg-10[data-v-14fc86fd]{flex:0 0 auto;width:83.33333333%}.col-lg-11[data-v-14fc86fd]{flex:0 0 auto;width:91.66666667%}.col-lg-12[data-v-14fc86fd]{flex:0 0 auto;width:100%}.offset-lg-0[data-v-14fc86fd]{margin-left:0}.offset-lg-1[data-v-14fc86fd]{margin-left:8.33333333%}.offset-lg-2[data-v-14fc86fd]{margin-left:16.66666667%}.offset-lg-3[data-v-14fc86fd]{margin-left:25%}.offset-lg-4[data-v-14fc86fd]{margin-left:33.33333333%}.offset-lg-5[data-v-14fc86fd]{margin-left:41.66666667%}.offset-lg-6[data-v-14fc86fd]{margin-left:50%}.offset-lg-7[data-v-14fc86fd]{margin-left:58.33333333%}.offset-lg-8[data-v-14fc86fd]{margin-left:66.66666667%}.offset-lg-9[data-v-14fc86fd]{margin-left:75%}.offset-lg-10[data-v-14fc86fd]{margin-left:83.33333333%}.offset-lg-11[data-v-14fc86fd]{margin-left:91.66666667%}.g-lg-0[data-v-14fc86fd],.gx-lg-0[data-v-14fc86fd]{--bs-gutter-x:0}.g-lg-0[data-v-14fc86fd],.gy-lg-0[data-v-14fc86fd]{--bs-gutter-y:0}.g-lg-1[data-v-14fc86fd],.gx-lg-1[data-v-14fc86fd]{--bs-gutter-x:0.25rem}.g-lg-1[data-v-14fc86fd],.gy-lg-1[data-v-14fc86fd]{--bs-gutter-y:0.25rem}.g-lg-2[data-v-14fc86fd],.gx-lg-2[data-v-14fc86fd]{--bs-gutter-x:0.5rem}.g-lg-2[data-v-14fc86fd],.gy-lg-2[data-v-14fc86fd]{--bs-gutter-y:0.5rem}.g-lg-3[data-v-14fc86fd],.gx-lg-3[data-v-14fc86fd]{--bs-gutter-x:1rem}.g-lg-3[data-v-14fc86fd],.gy-lg-3[data-v-14fc86fd]{--bs-gutter-y:1rem}.g-lg-4[data-v-14fc86fd],.gx-lg-4[data-v-14fc86fd]{--bs-gutter-x:1.5rem}.g-lg-4[data-v-14fc86fd],.gy-lg-4[data-v-14fc86fd]{--bs-gutter-y:1.5rem}.g-lg-5[data-v-14fc86fd],.gx-lg-5[data-v-14fc86fd]{--bs-gutter-x:3rem}.g-lg-5[data-v-14fc86fd],.gy-lg-5[data-v-14fc86fd]{--bs-gutter-y:3rem}}@media (min-width:1200px){.col-xl[data-v-14fc86fd]{flex:1 0 0%}.row-cols-xl-auto>[data-v-14fc86fd]{flex:0 0 auto;width:auto}.row-cols-xl-1>[data-v-14fc86fd]{flex:0 0 auto;width:100%}.row-cols-xl-2>[data-v-14fc86fd]{flex:0 0 auto;width:50%}.row-cols-xl-3>[data-v-14fc86fd]{flex:0 0 auto;width:33.3333333333%}.row-cols-xl-4>[data-v-14fc86fd]{flex:0 0 auto;width:25%}.row-cols-xl-5>[data-v-14fc86fd]{flex:0 0 auto;width:20%}.row-cols-xl-6>[data-v-14fc86fd]{flex:0 0 auto;width:16.6666666667%}.col-xl-auto[data-v-14fc86fd]{flex:0 0 auto;width:auto}.col-xl-1[data-v-14fc86fd]{flex:0 0 auto;width:8.33333333%}.col-xl-2[data-v-14fc86fd]{flex:0 0 auto;width:16.66666667%}.col-xl-3[data-v-14fc86fd]{flex:0 0 auto;width:25%}.col-xl-4[data-v-14fc86fd]{flex:0 0 auto;width:33.33333333%}.col-xl-5[data-v-14fc86fd]{flex:0 0 auto;width:41.66666667%}.col-xl-6[data-v-14fc86fd]{flex:0 0 auto;width:50%}.col-xl-7[data-v-14fc86fd]{flex:0 0 auto;width:58.33333333%}.col-xl-8[data-v-14fc86fd]{flex:0 0 auto;width:66.66666667%}.col-xl-9[data-v-14fc86fd]{flex:0 0 auto;width:75%}.col-xl-10[data-v-14fc86fd]{flex:0 0 auto;width:83.33333333%}.col-xl-11[data-v-14fc86fd]{flex:0 0 auto;width:91.66666667%}.col-xl-12[data-v-14fc86fd]{flex:0 0 auto;width:100%}.offset-xl-0[data-v-14fc86fd]{margin-left:0}.offset-xl-1[data-v-14fc86fd]{margin-left:8.33333333%}.offset-xl-2[data-v-14fc86fd]{margin-left:16.66666667%}.offset-xl-3[data-v-14fc86fd]{margin-left:25%}.offset-xl-4[data-v-14fc86fd]{margin-left:33.33333333%}.offset-xl-5[data-v-14fc86fd]{margin-left:41.66666667%}.offset-xl-6[data-v-14fc86fd]{margin-left:50%}.offset-xl-7[data-v-14fc86fd]{margin-left:58.33333333%}.offset-xl-8[data-v-14fc86fd]{margin-left:66.66666667%}.offset-xl-9[data-v-14fc86fd]{margin-left:75%}.offset-xl-10[data-v-14fc86fd]{margin-left:83.33333333%}.offset-xl-11[data-v-14fc86fd]{margin-left:91.66666667%}.g-xl-0[data-v-14fc86fd],.gx-xl-0[data-v-14fc86fd]{--bs-gutter-x:0}.g-xl-0[data-v-14fc86fd],.gy-xl-0[data-v-14fc86fd]{--bs-gutter-y:0}.g-xl-1[data-v-14fc86fd],.gx-xl-1[data-v-14fc86fd]{--bs-gutter-x:0.25rem}.g-xl-1[data-v-14fc86fd],.gy-xl-1[data-v-14fc86fd]{--bs-gutter-y:0.25rem}.g-xl-2[data-v-14fc86fd],.gx-xl-2[data-v-14fc86fd]{--bs-gutter-x:0.5rem}.g-xl-2[data-v-14fc86fd],.gy-xl-2[data-v-14fc86fd]{--bs-gutter-y:0.5rem}.g-xl-3[data-v-14fc86fd],.gx-xl-3[data-v-14fc86fd]{--bs-gutter-x:1rem}.g-xl-3[data-v-14fc86fd],.gy-xl-3[data-v-14fc86fd]{--bs-gutter-y:1rem}.g-xl-4[data-v-14fc86fd],.gx-xl-4[data-v-14fc86fd]{--bs-gutter-x:1.5rem}.g-xl-4[data-v-14fc86fd],.gy-xl-4[data-v-14fc86fd]{--bs-gutter-y:1.5rem}.g-xl-5[data-v-14fc86fd],.gx-xl-5[data-v-14fc86fd]{--bs-gutter-x:3rem}.g-xl-5[data-v-14fc86fd],.gy-xl-5[data-v-14fc86fd]{--bs-gutter-y:3rem}}@media (min-width:1400px){.col-xxl[data-v-14fc86fd]{flex:1 0 0%}.row-cols-xxl-auto>[data-v-14fc86fd]{flex:0 0 auto;width:auto}.row-cols-xxl-1>[data-v-14fc86fd]{flex:0 0 auto;width:100%}.row-cols-xxl-2>[data-v-14fc86fd]{flex:0 0 auto;width:50%}.row-cols-xxl-3>[data-v-14fc86fd]{flex:0 0 auto;width:33.3333333333%}.row-cols-xxl-4>[data-v-14fc86fd]{flex:0 0 auto;width:25%}.row-cols-xxl-5>[data-v-14fc86fd]{flex:0 0 auto;width:20%}.row-cols-xxl-6>[data-v-14fc86fd]{flex:0 0 auto;width:16.6666666667%}.col-xxl-auto[data-v-14fc86fd]{flex:0 0 auto;width:auto}.col-xxl-1[data-v-14fc86fd]{flex:0 0 auto;width:8.33333333%}.col-xxl-2[data-v-14fc86fd]{flex:0 0 auto;width:16.66666667%}.col-xxl-3[data-v-14fc86fd]{flex:0 0 auto;width:25%}.col-xxl-4[data-v-14fc86fd]{flex:0 0 auto;width:33.33333333%}.col-xxl-5[data-v-14fc86fd]{flex:0 0 auto;width:41.66666667%}.col-xxl-6[data-v-14fc86fd]{flex:0 0 auto;width:50%}.col-xxl-7[data-v-14fc86fd]{flex:0 0 auto;width:58.33333333%}.col-xxl-8[data-v-14fc86fd]{flex:0 0 auto;width:66.66666667%}.col-xxl-9[data-v-14fc86fd]{flex:0 0 auto;width:75%}.col-xxl-10[data-v-14fc86fd]{flex:0 0 auto;width:83.33333333%}.col-xxl-11[data-v-14fc86fd]{flex:0 0 auto;width:91.66666667%}.col-xxl-12[data-v-14fc86fd]{flex:0 0 auto;width:100%}.offset-xxl-0[data-v-14fc86fd]{margin-left:0}.offset-xxl-1[data-v-14fc86fd]{margin-left:8.33333333%}.offset-xxl-2[data-v-14fc86fd]{margin-left:16.66666667%}.offset-xxl-3[data-v-14fc86fd]{margin-left:25%}.offset-xxl-4[data-v-14fc86fd]{margin-left:33.33333333%}.offset-xxl-5[data-v-14fc86fd]{margin-left:41.66666667%}.offset-xxl-6[data-v-14fc86fd]{margin-left:50%}.offset-xxl-7[data-v-14fc86fd]{margin-left:58.33333333%}.offset-xxl-8[data-v-14fc86fd]{margin-left:66.66666667%}.offset-xxl-9[data-v-14fc86fd]{margin-left:75%}.offset-xxl-10[data-v-14fc86fd]{margin-left:83.33333333%}.offset-xxl-11[data-v-14fc86fd]{margin-left:91.66666667%}.g-xxl-0[data-v-14fc86fd],.gx-xxl-0[data-v-14fc86fd]{--bs-gutter-x:0}.g-xxl-0[data-v-14fc86fd],.gy-xxl-0[data-v-14fc86fd]{--bs-gutter-y:0}.g-xxl-1[data-v-14fc86fd],.gx-xxl-1[data-v-14fc86fd]{--bs-gutter-x:0.25rem}.g-xxl-1[data-v-14fc86fd],.gy-xxl-1[data-v-14fc86fd]{--bs-gutter-y:0.25rem}.g-xxl-2[data-v-14fc86fd],.gx-xxl-2[data-v-14fc86fd]{--bs-gutter-x:0.5rem}.g-xxl-2[data-v-14fc86fd],.gy-xxl-2[data-v-14fc86fd]{--bs-gutter-y:0.5rem}.g-xxl-3[data-v-14fc86fd],.gx-xxl-3[data-v-14fc86fd]{--bs-gutter-x:1rem}.g-xxl-3[data-v-14fc86fd],.gy-xxl-3[data-v-14fc86fd]{--bs-gutter-y:1rem}.g-xxl-4[data-v-14fc86fd],.gx-xxl-4[data-v-14fc86fd]{--bs-gutter-x:1.5rem}.g-xxl-4[data-v-14fc86fd],.gy-xxl-4[data-v-14fc86fd]{--bs-gutter-y:1.5rem}.g-xxl-5[data-v-14fc86fd],.gx-xxl-5[data-v-14fc86fd]{--bs-gutter-x:3rem}.g-xxl-5[data-v-14fc86fd],.gy-xxl-5[data-v-14fc86fd]{--bs-gutter-y:3rem}}.table[data-v-14fc86fd]{--bs-table-bg:transparent;--bs-table-accent-bg:transparent;--bs-table-striped-color:#212529;--bs-table-striped-bg:rgba(0,0,0,.05);--bs-table-active-color:#212529;--bs-table-active-bg:rgba(0,0,0,.1);--bs-table-hover-color:#212529;--bs-table-hover-bg:rgba(0,0,0,.075);width:100%;margin-bottom:1rem;color:#212529;vertical-align:top;border-color:#dee2e6}.table>:not(caption)>*>[data-v-14fc86fd]{padding:.5rem;background-color:var(--bs-table-bg);border-bottom-width:1px;box-shadow:inset 0 0 0 9999px var(--bs-table-accent-bg)}.table>tbody[data-v-14fc86fd]{vertical-align:inherit}.table>thead[data-v-14fc86fd]{vertical-align:bottom}.table[data-v-14fc86fd]>:not(:first-child){border-top:2px solid currentColor}.caption-top[data-v-14fc86fd]{caption-side:top}.table-sm>:not(caption)>*>[data-v-14fc86fd]{padding:.25rem}.table-bordered>:not(caption)>[data-v-14fc86fd]{border-width:1px 0}.table-bordered>:not(caption)>*>[data-v-14fc86fd]{border-width:0 1px}.table-borderless>:not(caption)>*>[data-v-14fc86fd]{border-bottom-width:0}.table-borderless[data-v-14fc86fd]>:not(:first-child){border-top-width:0}.table-striped>tbody>tr:nth-of-type(odd)>[data-v-14fc86fd]{--bs-table-accent-bg:var(--bs-table-striped-bg);color:var(--bs-table-striped-color)}.table-active[data-v-14fc86fd]{--bs-table-accent-bg:var(--bs-table-active-bg);color:var(--bs-table-active-color)}.table-hover>tbody>tr:hover>[data-v-14fc86fd]{--bs-table-accent-bg:var(--bs-table-hover-bg);color:var(--bs-table-hover-color)}.table-primary[data-v-14fc86fd]{--bs-table-bg:#cfe2ff;--bs-table-striped-bg:#c5d7f2;--bs-table-striped-color:#000;--bs-table-active-bg:#bacbe6;--bs-table-active-color:#000;--bs-table-hover-bg:#bfd1ec;--bs-table-hover-color:#000;color:#000;border-color:#bacbe6}.table-secondary[data-v-14fc86fd]{--bs-table-bg:#e2e3e5;--bs-table-striped-bg:#d7d8da;--bs-table-striped-color:#000;--bs-table-active-bg:#cbccce;--bs-table-active-color:#000;--bs-table-hover-bg:#d1d2d4;--bs-table-hover-color:#000;color:#000;border-color:#cbccce}.table-success[data-v-14fc86fd]{--bs-table-bg:#d1e7dd;--bs-table-striped-bg:#c7dbd2;--bs-table-striped-color:#000;--bs-table-active-bg:#bcd0c7;--bs-table-active-color:#000;--bs-table-hover-bg:#c1d6cc;--bs-table-hover-color:#000;color:#000;border-color:#bcd0c7}.table-info[data-v-14fc86fd]{--bs-table-bg:#cff4fc;--bs-table-striped-bg:#c5e8ef;--bs-table-striped-color:#000;--bs-table-active-bg:#badce3;--bs-table-active-color:#000;--bs-table-hover-bg:#bfe2e9;--bs-table-hover-color:#000;color:#000;border-color:#badce3}.table-warning[data-v-14fc86fd]{--bs-table-bg:#fff3cd;--bs-table-striped-bg:#f2e7c3;--bs-table-striped-color:#000;--bs-table-active-bg:#e6dbb9;--bs-table-active-color:#000;--bs-table-hover-bg:#ece1be;--bs-table-hover-color:#000;color:#000;border-color:#e6dbb9}.table-danger[data-v-14fc86fd]{--bs-table-bg:#f8d7da;--bs-table-striped-bg:#eccccf;--bs-table-striped-color:#000;--bs-table-active-bg:#dfc2c4;--bs-table-active-color:#000;--bs-table-hover-bg:#e5c7ca;--bs-table-hover-color:#000;color:#000;border-color:#dfc2c4}.table-light[data-v-14fc86fd]{--bs-table-bg:#f8f9fa;--bs-table-striped-bg:#ecedee;--bs-table-striped-color:#000;--bs-table-active-bg:#dfe0e1;--bs-table-active-color:#000;--bs-table-hover-bg:#e5e6e7;--bs-table-hover-color:#000;color:#000;border-color:#dfe0e1}.table-dark[data-v-14fc86fd]{--bs-table-bg:#212529;--bs-table-striped-bg:#2c3034;--bs-table-striped-color:#fff;--bs-table-active-bg:#373b3e;--bs-table-active-color:#fff;--bs-table-hover-bg:#323539;--bs-table-hover-color:#fff;color:#fff;border-color:#373b3e}.table-responsive[data-v-14fc86fd]{overflow-x:auto;-webkit-overflow-scrolling:touch}@media (max-width:575.98px){.table-responsive-sm[data-v-14fc86fd]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:767.98px){.table-responsive-md[data-v-14fc86fd]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:991.98px){.table-responsive-lg[data-v-14fc86fd]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1199.98px){.table-responsive-xl[data-v-14fc86fd]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1399.98px){.table-responsive-xxl[data-v-14fc86fd]{overflow-x:auto;-webkit-overflow-scrolling:touch}}.form-label[data-v-14fc86fd]{margin-bottom:.5rem}.col-form-label[data-v-14fc86fd]{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg[data-v-14fc86fd]{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem}.col-form-label-sm[data-v-14fc86fd]{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem}.form-text[data-v-14fc86fd]{margin-top:.25rem;font-size:.875em;color:#6c757d}.form-control[data-v-14fc86fd]{display:block;width:100%;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-14fc86fd]{transition:none}}.form-control[type=file][data-v-14fc86fd]{overflow:hidden}.form-control[type=file][data-v-14fc86fd]:not(:disabled):not([readonly]){cursor:pointer}.form-control[data-v-14fc86fd]:focus{color:#212529;background-color:#fff;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-control[data-v-14fc86fd]::-webkit-date-and-time-value{height:1.5em}.form-control[data-v-14fc86fd]::-moz-placeholder{color:#6c757d;opacity:1}.form-control[data-v-14fc86fd]::placeholder{color:#6c757d;opacity:1}.form-control[data-v-14fc86fd]:disabled,.form-control[readonly][data-v-14fc86fd]{background-color:#e9ecef;opacity:1}.form-control[data-v-14fc86fd]::file-selector-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-14fc86fd]::-webkit-file-upload-button{-webkit-transition:none;transition:none}.form-control[data-v-14fc86fd]::file-selector-button{transition:none}}.form-control[data-v-14fc86fd]:hover:not(:disabled):not([readonly])::file-selector-button{background-color:#dde0e3}.form-control[data-v-14fc86fd]::-webkit-file-upload-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;-webkit-transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-14fc86fd]::-webkit-file-upload-button{-webkit-transition:none;transition:none}}.form-control[data-v-14fc86fd]:hover:not(:disabled):not([readonly])::-webkit-file-upload-button{background-color:#dde0e3}.form-control-plaintext[data-v-14fc86fd]{display:block;width:100%;padding:.375rem 0;margin-bottom:0;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg[data-v-14fc86fd],.form-control-plaintext.form-control-sm[data-v-14fc86fd]{padding-right:0;padding-left:0}.form-control-sm[data-v-14fc86fd]{min-height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.form-control-sm[data-v-14fc86fd]::file-selector-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-sm[data-v-14fc86fd]::-webkit-file-upload-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-lg[data-v-14fc86fd]{min-height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.form-control-lg[data-v-14fc86fd]::file-selector-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}.form-control-lg[data-v-14fc86fd]::-webkit-file-upload-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}textarea.form-control[data-v-14fc86fd]{min-height:calc(1.5em + .75rem + 2px)}textarea.form-control-sm[data-v-14fc86fd]{min-height:calc(1.5em + .5rem + 2px)}textarea.form-control-lg[data-v-14fc86fd]{min-height:calc(1.5em + 1rem + 2px)}.form-control-color[data-v-14fc86fd]{width:3rem;height:auto;padding:.375rem}.form-control-color[data-v-14fc86fd]:not(:disabled):not([readonly]){cursor:pointer}.form-control-color[data-v-14fc86fd]::-moz-color-swatch{height:1.5em;border-radius:.25rem}.form-control-color[data-v-14fc86fd]::-webkit-color-swatch{height:1.5em;border-radius:.25rem}.form-select[data-v-14fc86fd]{display:block;width:100%;padding:.375rem 2.25rem .375rem .75rem;-moz-padding-start:calc(.75rem - 3px);font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right .75rem center;background-size:16px 12px;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-select[data-v-14fc86fd]{transition:none}}.form-select[data-v-14fc86fd]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-select[multiple][data-v-14fc86fd],.form-select[size][data-v-14fc86fd]:not([size=\"1\"]){padding-right:.75rem;background-image:none}.form-select[data-v-14fc86fd]:disabled{background-color:#e9ecef}.form-select[data-v-14fc86fd]:-moz-focusring{color:transparent;text-shadow:0 0 0 #212529}.form-select-sm[data-v-14fc86fd]{padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem;border-radius:.2rem}.form-select-lg[data-v-14fc86fd]{padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem;border-radius:.3rem}.form-check[data-v-14fc86fd]{display:block;min-height:1.5rem;padding-left:1.5em;margin-bottom:.125rem}.form-check .form-check-input[data-v-14fc86fd]{float:left;margin-left:-1.5em}.form-check-input[data-v-14fc86fd]{width:1em;height:1em;margin-top:.25em;vertical-align:top;background-color:#fff;background-repeat:no-repeat;background-position:50%;background-size:contain;border:1px solid rgba(0,0,0,.25);-webkit-appearance:none;-moz-appearance:none;appearance:none;-webkit-print-color-adjust:exact;color-adjust:exact}.form-check-input[type=checkbox][data-v-14fc86fd]{border-radius:.25em}.form-check-input[type=radio][data-v-14fc86fd]{border-radius:50%}.form-check-input[data-v-14fc86fd]:active{filter:brightness(90%)}.form-check-input[data-v-14fc86fd]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-check-input[data-v-14fc86fd]:checked{background-color:#0d6efd;border-color:#0d6efd}.form-check-input:checked[type=checkbox][data-v-14fc86fd]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3 6-6'/%3E%3C/svg%3E\")}.form-check-input:checked[type=radio][data-v-14fc86fd]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='2' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-input[type=checkbox][data-v-14fc86fd]:indeterminate{background-color:#0d6efd;border-color:#0d6efd;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3E%3C/svg%3E\")}.form-check-input[data-v-14fc86fd]:disabled{pointer-events:none;filter:none;opacity:.5}.form-check-input:disabled~.form-check-label[data-v-14fc86fd],.form-check-input[disabled]~.form-check-label[data-v-14fc86fd]{opacity:.5}.form-switch[data-v-14fc86fd]{padding-left:2.5em}.form-switch .form-check-input[data-v-14fc86fd]{width:2em;margin-left:-2.5em;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='rgba(0, 0, 0, 0.25)'/%3E%3C/svg%3E\");background-position:0;border-radius:2em;transition:background-position .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-switch .form-check-input[data-v-14fc86fd]{transition:none}}.form-switch .form-check-input[data-v-14fc86fd]:focus{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%2386b7fe'/%3E%3C/svg%3E\")}.form-switch .form-check-input[data-v-14fc86fd]:checked{background-position:100%;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-inline[data-v-14fc86fd]{display:inline-block;margin-right:1rem}.btn-check[data-v-14fc86fd]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.btn-check:disabled+.btn[data-v-14fc86fd],.btn-check[disabled]+.btn[data-v-14fc86fd]{pointer-events:none;filter:none;opacity:.65}.form-range[data-v-14fc86fd]{width:100%;height:1.5rem;padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.form-range[data-v-14fc86fd]:focus{outline:0}.form-range[data-v-14fc86fd]:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-14fc86fd]:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-14fc86fd]::-moz-focus-outer{border:0}.form-range[data-v-14fc86fd]::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#0d6efd;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-14fc86fd]::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.form-range[data-v-14fc86fd]::-webkit-slider-thumb:active{background-color:#b6d4fe}.form-range[data-v-14fc86fd]::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-14fc86fd]::-moz-range-thumb{width:1rem;height:1rem;background-color:#0d6efd;border:0;border-radius:1rem;-moz-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-14fc86fd]::-moz-range-thumb{-moz-transition:none;transition:none}}.form-range[data-v-14fc86fd]::-moz-range-thumb:active{background-color:#b6d4fe}.form-range[data-v-14fc86fd]::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-14fc86fd]:disabled{pointer-events:none}.form-range[data-v-14fc86fd]:disabled::-webkit-slider-thumb{background-color:#adb5bd}.form-range[data-v-14fc86fd]:disabled::-moz-range-thumb{background-color:#adb5bd}.form-floating[data-v-14fc86fd]{position:relative}.form-floating>.form-control[data-v-14fc86fd],.form-floating>.form-select[data-v-14fc86fd]{height:calc(3.5rem + 2px);line-height:1.25}.form-floating>label[data-v-14fc86fd]{position:absolute;top:0;left:0;height:100%;padding:1rem .75rem;pointer-events:none;border:1px solid transparent;transform-origin:0 0;transition:opacity .1s ease-in-out,transform .1s ease-in-out}@media (prefers-reduced-motion:reduce){.form-floating>label[data-v-14fc86fd]{transition:none}}.form-floating>.form-control[data-v-14fc86fd]{padding:1rem .75rem}.form-floating>.form-control[data-v-14fc86fd]::-moz-placeholder{color:transparent}.form-floating>.form-control[data-v-14fc86fd]::placeholder{color:transparent}.form-floating>.form-control[data-v-14fc86fd]:not(:-moz-placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-14fc86fd]:focus,.form-floating>.form-control[data-v-14fc86fd]:not(:placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-14fc86fd]:-webkit-autofill{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-select[data-v-14fc86fd]{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control:not(:-moz-placeholder-shown)~label[data-v-14fc86fd]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:focus~label[data-v-14fc86fd],.form-floating>.form-control:not(:placeholder-shown)~label[data-v-14fc86fd],.form-floating>.form-select~label[data-v-14fc86fd]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:-webkit-autofill~label[data-v-14fc86fd]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.input-group[data-v-14fc86fd]{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group>.form-control[data-v-14fc86fd],.input-group>.form-select[data-v-14fc86fd]{position:relative;flex:1 1 auto;width:1%;min-width:0}.input-group>.form-control[data-v-14fc86fd]:focus,.input-group>.form-select[data-v-14fc86fd]:focus{z-index:3}.input-group .btn[data-v-14fc86fd]{position:relative;z-index:2}.input-group .btn[data-v-14fc86fd]:focus{z-index:3}.input-group-text[data-v-14fc86fd]{display:flex;align-items:center;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-lg>.btn[data-v-14fc86fd],.input-group-lg>.form-control[data-v-14fc86fd],.input-group-lg>.form-select[data-v-14fc86fd],.input-group-lg>.input-group-text[data-v-14fc86fd]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.input-group-sm>.btn[data-v-14fc86fd],.input-group-sm>.form-control[data-v-14fc86fd],.input-group-sm>.form-select[data-v-14fc86fd],.input-group-sm>.input-group-text[data-v-14fc86fd]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.input-group-lg>.form-select[data-v-14fc86fd],.input-group-sm>.form-select[data-v-14fc86fd]{padding-right:3rem}.input-group.has-validation>.dropdown-toggle[data-v-14fc86fd]:nth-last-child(n+4),.input-group.has-validation[data-v-14fc86fd]>:nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),.input-group:not(.has-validation)>.dropdown-toggle[data-v-14fc86fd]:nth-last-child(n+3),.input-group[data-v-14fc86fd]:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu){border-top-right-radius:0;border-bottom-right-radius:0}.input-group[data-v-14fc86fd]>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}.valid-feedback[data-v-14fc86fd]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#198754}.valid-tooltip[data-v-14fc86fd]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(25,135,84,.9);border-radius:.25rem}.is-valid~.valid-feedback[data-v-14fc86fd],.is-valid~.valid-tooltip[data-v-14fc86fd],.was-validated :valid~.valid-feedback[data-v-14fc86fd],.was-validated :valid~.valid-tooltip[data-v-14fc86fd]{display:block}.form-control.is-valid[data-v-14fc86fd],.was-validated .form-control[data-v-14fc86fd]:valid{border-color:#198754;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-valid[data-v-14fc86fd]:focus,.was-validated .form-control[data-v-14fc86fd]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.was-validated textarea.form-control[data-v-14fc86fd]:valid,textarea.form-control.is-valid[data-v-14fc86fd]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-valid[data-v-14fc86fd],.was-validated .form-select[data-v-14fc86fd]:valid{border-color:#198754}.form-select.is-valid:not([multiple])[size=\"1\"][data-v-14fc86fd],.form-select.is-valid[data-v-14fc86fd]:not([multiple]):not([size]),.was-validated .form-select:valid:not([multiple])[size=\"1\"][data-v-14fc86fd],.was-validated .form-select[data-v-14fc86fd]:valid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-valid[data-v-14fc86fd]:focus,.was-validated .form-select[data-v-14fc86fd]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid[data-v-14fc86fd],.was-validated .form-check-input[data-v-14fc86fd]:valid{border-color:#198754}.form-check-input.is-valid[data-v-14fc86fd]:checked,.was-validated .form-check-input[data-v-14fc86fd]:valid:checked{background-color:#198754}.form-check-input.is-valid[data-v-14fc86fd]:focus,.was-validated .form-check-input[data-v-14fc86fd]:valid:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid~.form-check-label[data-v-14fc86fd],.was-validated .form-check-input:valid~.form-check-label[data-v-14fc86fd]{color:#198754}.form-check-inline .form-check-input~.valid-feedback[data-v-14fc86fd]{margin-left:.5em}.input-group .form-control.is-valid[data-v-14fc86fd],.input-group .form-select.is-valid[data-v-14fc86fd],.was-validated .input-group .form-control[data-v-14fc86fd]:valid,.was-validated .input-group .form-select[data-v-14fc86fd]:valid{z-index:1}.input-group .form-control.is-valid[data-v-14fc86fd]:focus,.input-group .form-select.is-valid[data-v-14fc86fd]:focus,.was-validated .input-group .form-control[data-v-14fc86fd]:valid:focus,.was-validated .input-group .form-select[data-v-14fc86fd]:valid:focus{z-index:3}.invalid-feedback[data-v-14fc86fd]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#dc3545}.invalid-tooltip[data-v-14fc86fd]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(220,53,69,.9);border-radius:.25rem}.is-invalid~.invalid-feedback[data-v-14fc86fd],.is-invalid~.invalid-tooltip[data-v-14fc86fd],.was-validated :invalid~.invalid-feedback[data-v-14fc86fd],.was-validated :invalid~.invalid-tooltip[data-v-14fc86fd]{display:block}.form-control.is-invalid[data-v-14fc86fd],.was-validated .form-control[data-v-14fc86fd]:invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-invalid[data-v-14fc86fd]:focus,.was-validated .form-control[data-v-14fc86fd]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.was-validated textarea.form-control[data-v-14fc86fd]:invalid,textarea.form-control.is-invalid[data-v-14fc86fd]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-invalid[data-v-14fc86fd],.was-validated .form-select[data-v-14fc86fd]:invalid{border-color:#dc3545}.form-select.is-invalid:not([multiple])[size=\"1\"][data-v-14fc86fd],.form-select.is-invalid[data-v-14fc86fd]:not([multiple]):not([size]),.was-validated .form-select:invalid:not([multiple])[size=\"1\"][data-v-14fc86fd],.was-validated .form-select[data-v-14fc86fd]:invalid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-invalid[data-v-14fc86fd]:focus,.was-validated .form-select[data-v-14fc86fd]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid[data-v-14fc86fd],.was-validated .form-check-input[data-v-14fc86fd]:invalid{border-color:#dc3545}.form-check-input.is-invalid[data-v-14fc86fd]:checked,.was-validated .form-check-input[data-v-14fc86fd]:invalid:checked{background-color:#dc3545}.form-check-input.is-invalid[data-v-14fc86fd]:focus,.was-validated .form-check-input[data-v-14fc86fd]:invalid:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid~.form-check-label[data-v-14fc86fd],.was-validated .form-check-input:invalid~.form-check-label[data-v-14fc86fd]{color:#dc3545}.form-check-inline .form-check-input~.invalid-feedback[data-v-14fc86fd]{margin-left:.5em}.input-group .form-control.is-invalid[data-v-14fc86fd],.input-group .form-select.is-invalid[data-v-14fc86fd],.was-validated .input-group .form-control[data-v-14fc86fd]:invalid,.was-validated .input-group .form-select[data-v-14fc86fd]:invalid{z-index:2}.input-group .form-control.is-invalid[data-v-14fc86fd]:focus,.input-group .form-select.is-invalid[data-v-14fc86fd]:focus,.was-validated .input-group .form-control[data-v-14fc86fd]:invalid:focus,.was-validated .input-group .form-select[data-v-14fc86fd]:invalid:focus{z-index:3}.btn[data-v-14fc86fd]{display:inline-block;font-weight:400;line-height:1.5;color:#212529;text-align:center;text-decoration:none;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn[data-v-14fc86fd]{transition:none}}.btn[data-v-14fc86fd]:hover{color:#212529}.btn-check:focus+.btn[data-v-14fc86fd],.btn[data-v-14fc86fd]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.btn.disabled[data-v-14fc86fd],.btn[data-v-14fc86fd]:disabled,fieldset:disabled .btn[data-v-14fc86fd]{pointer-events:none;opacity:.65}.btn-primary[data-v-14fc86fd]{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-primary[data-v-14fc86fd]:hover{color:#fff;background-color:#0b5ed7;border-color:#0a58ca}.btn-check:focus+.btn-primary[data-v-14fc86fd],.btn-primary[data-v-14fc86fd]:focus{color:#fff;background-color:#0b5ed7;border-color:#0a58ca;box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-check:active+.btn-primary[data-v-14fc86fd],.btn-check:checked+.btn-primary[data-v-14fc86fd],.btn-primary.active[data-v-14fc86fd],.btn-primary[data-v-14fc86fd]:active,.show>.btn-primary.dropdown-toggle[data-v-14fc86fd]{color:#fff;background-color:#0a58ca;border-color:#0a53be}.btn-check:active+.btn-primary[data-v-14fc86fd]:focus,.btn-check:checked+.btn-primary[data-v-14fc86fd]:focus,.btn-primary.active[data-v-14fc86fd]:focus,.btn-primary[data-v-14fc86fd]:active:focus,.show>.btn-primary.dropdown-toggle[data-v-14fc86fd]:focus{box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-primary.disabled[data-v-14fc86fd],.btn-primary[data-v-14fc86fd]:disabled{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-secondary[data-v-14fc86fd]{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary[data-v-14fc86fd]:hover{color:#fff;background-color:#5c636a;border-color:#565e64}.btn-check:focus+.btn-secondary[data-v-14fc86fd],.btn-secondary[data-v-14fc86fd]:focus{color:#fff;background-color:#5c636a;border-color:#565e64;box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-check:active+.btn-secondary[data-v-14fc86fd],.btn-check:checked+.btn-secondary[data-v-14fc86fd],.btn-secondary.active[data-v-14fc86fd],.btn-secondary[data-v-14fc86fd]:active,.show>.btn-secondary.dropdown-toggle[data-v-14fc86fd]{color:#fff;background-color:#565e64;border-color:#51585e}.btn-check:active+.btn-secondary[data-v-14fc86fd]:focus,.btn-check:checked+.btn-secondary[data-v-14fc86fd]:focus,.btn-secondary.active[data-v-14fc86fd]:focus,.btn-secondary[data-v-14fc86fd]:active:focus,.show>.btn-secondary.dropdown-toggle[data-v-14fc86fd]:focus{box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-secondary.disabled[data-v-14fc86fd],.btn-secondary[data-v-14fc86fd]:disabled{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-success[data-v-14fc86fd]{color:#fff;background-color:#198754;border-color:#198754}.btn-success[data-v-14fc86fd]:hover{color:#fff;background-color:#157347;border-color:#146c43}.btn-check:focus+.btn-success[data-v-14fc86fd],.btn-success[data-v-14fc86fd]:focus{color:#fff;background-color:#157347;border-color:#146c43;box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-check:active+.btn-success[data-v-14fc86fd],.btn-check:checked+.btn-success[data-v-14fc86fd],.btn-success.active[data-v-14fc86fd],.btn-success[data-v-14fc86fd]:active,.show>.btn-success.dropdown-toggle[data-v-14fc86fd]{color:#fff;background-color:#146c43;border-color:#13653f}.btn-check:active+.btn-success[data-v-14fc86fd]:focus,.btn-check:checked+.btn-success[data-v-14fc86fd]:focus,.btn-success.active[data-v-14fc86fd]:focus,.btn-success[data-v-14fc86fd]:active:focus,.show>.btn-success.dropdown-toggle[data-v-14fc86fd]:focus{box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-success.disabled[data-v-14fc86fd],.btn-success[data-v-14fc86fd]:disabled{color:#fff;background-color:#198754;border-color:#198754}.btn-info[data-v-14fc86fd]{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-info[data-v-14fc86fd]:hover{color:#000;background-color:#31d2f2;border-color:#25cff2}.btn-check:focus+.btn-info[data-v-14fc86fd],.btn-info[data-v-14fc86fd]:focus{color:#000;background-color:#31d2f2;border-color:#25cff2;box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-check:active+.btn-info[data-v-14fc86fd],.btn-check:checked+.btn-info[data-v-14fc86fd],.btn-info.active[data-v-14fc86fd],.btn-info[data-v-14fc86fd]:active,.show>.btn-info.dropdown-toggle[data-v-14fc86fd]{color:#000;background-color:#3dd5f3;border-color:#25cff2}.btn-check:active+.btn-info[data-v-14fc86fd]:focus,.btn-check:checked+.btn-info[data-v-14fc86fd]:focus,.btn-info.active[data-v-14fc86fd]:focus,.btn-info[data-v-14fc86fd]:active:focus,.show>.btn-info.dropdown-toggle[data-v-14fc86fd]:focus{box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-info.disabled[data-v-14fc86fd],.btn-info[data-v-14fc86fd]:disabled{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-warning[data-v-14fc86fd]{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-warning[data-v-14fc86fd]:hover{color:#000;background-color:#ffca2c;border-color:#ffc720}.btn-check:focus+.btn-warning[data-v-14fc86fd],.btn-warning[data-v-14fc86fd]:focus{color:#000;background-color:#ffca2c;border-color:#ffc720;box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-check:active+.btn-warning[data-v-14fc86fd],.btn-check:checked+.btn-warning[data-v-14fc86fd],.btn-warning.active[data-v-14fc86fd],.btn-warning[data-v-14fc86fd]:active,.show>.btn-warning.dropdown-toggle[data-v-14fc86fd]{color:#000;background-color:#ffcd39;border-color:#ffc720}.btn-check:active+.btn-warning[data-v-14fc86fd]:focus,.btn-check:checked+.btn-warning[data-v-14fc86fd]:focus,.btn-warning.active[data-v-14fc86fd]:focus,.btn-warning[data-v-14fc86fd]:active:focus,.show>.btn-warning.dropdown-toggle[data-v-14fc86fd]:focus{box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-warning.disabled[data-v-14fc86fd],.btn-warning[data-v-14fc86fd]:disabled{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-danger[data-v-14fc86fd]{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger[data-v-14fc86fd]:hover{color:#fff;background-color:#bb2d3b;border-color:#b02a37}.btn-check:focus+.btn-danger[data-v-14fc86fd],.btn-danger[data-v-14fc86fd]:focus{color:#fff;background-color:#bb2d3b;border-color:#b02a37;box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-check:active+.btn-danger[data-v-14fc86fd],.btn-check:checked+.btn-danger[data-v-14fc86fd],.btn-danger.active[data-v-14fc86fd],.btn-danger[data-v-14fc86fd]:active,.show>.btn-danger.dropdown-toggle[data-v-14fc86fd]{color:#fff;background-color:#b02a37;border-color:#a52834}.btn-check:active+.btn-danger[data-v-14fc86fd]:focus,.btn-check:checked+.btn-danger[data-v-14fc86fd]:focus,.btn-danger.active[data-v-14fc86fd]:focus,.btn-danger[data-v-14fc86fd]:active:focus,.show>.btn-danger.dropdown-toggle[data-v-14fc86fd]:focus{box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-danger.disabled[data-v-14fc86fd],.btn-danger[data-v-14fc86fd]:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-light[data-v-14fc86fd]{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light[data-v-14fc86fd]:hover{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:focus+.btn-light[data-v-14fc86fd],.btn-light[data-v-14fc86fd]:focus{color:#000;background-color:#f9fafb;border-color:#f9fafb;box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-check:active+.btn-light[data-v-14fc86fd],.btn-check:checked+.btn-light[data-v-14fc86fd],.btn-light.active[data-v-14fc86fd],.btn-light[data-v-14fc86fd]:active,.show>.btn-light.dropdown-toggle[data-v-14fc86fd]{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:active+.btn-light[data-v-14fc86fd]:focus,.btn-check:checked+.btn-light[data-v-14fc86fd]:focus,.btn-light.active[data-v-14fc86fd]:focus,.btn-light[data-v-14fc86fd]:active:focus,.show>.btn-light.dropdown-toggle[data-v-14fc86fd]:focus{box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-light.disabled[data-v-14fc86fd],.btn-light[data-v-14fc86fd]:disabled{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-dark[data-v-14fc86fd]{color:#fff;background-color:#212529;border-color:#212529}.btn-dark[data-v-14fc86fd]:hover{color:#fff;background-color:#1c1f23;border-color:#1a1e21}.btn-check:focus+.btn-dark[data-v-14fc86fd],.btn-dark[data-v-14fc86fd]:focus{color:#fff;background-color:#1c1f23;border-color:#1a1e21;box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-check:active+.btn-dark[data-v-14fc86fd],.btn-check:checked+.btn-dark[data-v-14fc86fd],.btn-dark.active[data-v-14fc86fd],.btn-dark[data-v-14fc86fd]:active,.show>.btn-dark.dropdown-toggle[data-v-14fc86fd]{color:#fff;background-color:#1a1e21;border-color:#191c1f}.btn-check:active+.btn-dark[data-v-14fc86fd]:focus,.btn-check:checked+.btn-dark[data-v-14fc86fd]:focus,.btn-dark.active[data-v-14fc86fd]:focus,.btn-dark[data-v-14fc86fd]:active:focus,.show>.btn-dark.dropdown-toggle[data-v-14fc86fd]:focus{box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-dark.disabled[data-v-14fc86fd],.btn-dark[data-v-14fc86fd]:disabled{color:#fff;background-color:#212529;border-color:#212529}.btn-outline-primary[data-v-14fc86fd]{color:#0d6efd;border-color:#0d6efd}.btn-outline-primary[data-v-14fc86fd]:hover{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:focus+.btn-outline-primary[data-v-14fc86fd],.btn-outline-primary[data-v-14fc86fd]:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-check:active+.btn-outline-primary[data-v-14fc86fd],.btn-check:checked+.btn-outline-primary[data-v-14fc86fd],.btn-outline-primary.active[data-v-14fc86fd],.btn-outline-primary.dropdown-toggle.show[data-v-14fc86fd],.btn-outline-primary[data-v-14fc86fd]:active{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:active+.btn-outline-primary[data-v-14fc86fd]:focus,.btn-check:checked+.btn-outline-primary[data-v-14fc86fd]:focus,.btn-outline-primary.active[data-v-14fc86fd]:focus,.btn-outline-primary.dropdown-toggle.show[data-v-14fc86fd]:focus,.btn-outline-primary[data-v-14fc86fd]:active:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-outline-primary.disabled[data-v-14fc86fd],.btn-outline-primary[data-v-14fc86fd]:disabled{color:#0d6efd;background-color:transparent}.btn-outline-secondary[data-v-14fc86fd]{color:#6c757d;border-color:#6c757d}.btn-outline-secondary[data-v-14fc86fd]:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:focus+.btn-outline-secondary[data-v-14fc86fd],.btn-outline-secondary[data-v-14fc86fd]:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-check:active+.btn-outline-secondary[data-v-14fc86fd],.btn-check:checked+.btn-outline-secondary[data-v-14fc86fd],.btn-outline-secondary.active[data-v-14fc86fd],.btn-outline-secondary.dropdown-toggle.show[data-v-14fc86fd],.btn-outline-secondary[data-v-14fc86fd]:active{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:active+.btn-outline-secondary[data-v-14fc86fd]:focus,.btn-check:checked+.btn-outline-secondary[data-v-14fc86fd]:focus,.btn-outline-secondary.active[data-v-14fc86fd]:focus,.btn-outline-secondary.dropdown-toggle.show[data-v-14fc86fd]:focus,.btn-outline-secondary[data-v-14fc86fd]:active:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-outline-secondary.disabled[data-v-14fc86fd],.btn-outline-secondary[data-v-14fc86fd]:disabled{color:#6c757d;background-color:transparent}.btn-outline-success[data-v-14fc86fd]{color:#198754;border-color:#198754}.btn-outline-success[data-v-14fc86fd]:hover{color:#fff;background-color:#198754;border-color:#198754}.btn-check:focus+.btn-outline-success[data-v-14fc86fd],.btn-outline-success[data-v-14fc86fd]:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-check:active+.btn-outline-success[data-v-14fc86fd],.btn-check:checked+.btn-outline-success[data-v-14fc86fd],.btn-outline-success.active[data-v-14fc86fd],.btn-outline-success.dropdown-toggle.show[data-v-14fc86fd],.btn-outline-success[data-v-14fc86fd]:active{color:#fff;background-color:#198754;border-color:#198754}.btn-check:active+.btn-outline-success[data-v-14fc86fd]:focus,.btn-check:checked+.btn-outline-success[data-v-14fc86fd]:focus,.btn-outline-success.active[data-v-14fc86fd]:focus,.btn-outline-success.dropdown-toggle.show[data-v-14fc86fd]:focus,.btn-outline-success[data-v-14fc86fd]:active:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-outline-success.disabled[data-v-14fc86fd],.btn-outline-success[data-v-14fc86fd]:disabled{color:#198754;background-color:transparent}.btn-outline-info[data-v-14fc86fd]{color:#0dcaf0;border-color:#0dcaf0}.btn-outline-info[data-v-14fc86fd]:hover{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:focus+.btn-outline-info[data-v-14fc86fd],.btn-outline-info[data-v-14fc86fd]:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-check:active+.btn-outline-info[data-v-14fc86fd],.btn-check:checked+.btn-outline-info[data-v-14fc86fd],.btn-outline-info.active[data-v-14fc86fd],.btn-outline-info.dropdown-toggle.show[data-v-14fc86fd],.btn-outline-info[data-v-14fc86fd]:active{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:active+.btn-outline-info[data-v-14fc86fd]:focus,.btn-check:checked+.btn-outline-info[data-v-14fc86fd]:focus,.btn-outline-info.active[data-v-14fc86fd]:focus,.btn-outline-info.dropdown-toggle.show[data-v-14fc86fd]:focus,.btn-outline-info[data-v-14fc86fd]:active:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-outline-info.disabled[data-v-14fc86fd],.btn-outline-info[data-v-14fc86fd]:disabled{color:#0dcaf0;background-color:transparent}.btn-outline-warning[data-v-14fc86fd]{color:#ffc107;border-color:#ffc107}.btn-outline-warning[data-v-14fc86fd]:hover{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:focus+.btn-outline-warning[data-v-14fc86fd],.btn-outline-warning[data-v-14fc86fd]:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-check:active+.btn-outline-warning[data-v-14fc86fd],.btn-check:checked+.btn-outline-warning[data-v-14fc86fd],.btn-outline-warning.active[data-v-14fc86fd],.btn-outline-warning.dropdown-toggle.show[data-v-14fc86fd],.btn-outline-warning[data-v-14fc86fd]:active{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:active+.btn-outline-warning[data-v-14fc86fd]:focus,.btn-check:checked+.btn-outline-warning[data-v-14fc86fd]:focus,.btn-outline-warning.active[data-v-14fc86fd]:focus,.btn-outline-warning.dropdown-toggle.show[data-v-14fc86fd]:focus,.btn-outline-warning[data-v-14fc86fd]:active:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-outline-warning.disabled[data-v-14fc86fd],.btn-outline-warning[data-v-14fc86fd]:disabled{color:#ffc107;background-color:transparent}.btn-outline-danger[data-v-14fc86fd]{color:#dc3545;border-color:#dc3545}.btn-outline-danger[data-v-14fc86fd]:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:focus+.btn-outline-danger[data-v-14fc86fd],.btn-outline-danger[data-v-14fc86fd]:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-check:active+.btn-outline-danger[data-v-14fc86fd],.btn-check:checked+.btn-outline-danger[data-v-14fc86fd],.btn-outline-danger.active[data-v-14fc86fd],.btn-outline-danger.dropdown-toggle.show[data-v-14fc86fd],.btn-outline-danger[data-v-14fc86fd]:active{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:active+.btn-outline-danger[data-v-14fc86fd]:focus,.btn-check:checked+.btn-outline-danger[data-v-14fc86fd]:focus,.btn-outline-danger.active[data-v-14fc86fd]:focus,.btn-outline-danger.dropdown-toggle.show[data-v-14fc86fd]:focus,.btn-outline-danger[data-v-14fc86fd]:active:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-outline-danger.disabled[data-v-14fc86fd],.btn-outline-danger[data-v-14fc86fd]:disabled{color:#dc3545;background-color:transparent}.btn-outline-light[data-v-14fc86fd]{color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light[data-v-14fc86fd]:hover{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:focus+.btn-outline-light[data-v-14fc86fd],.btn-outline-light[data-v-14fc86fd]:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-check:active+.btn-outline-light[data-v-14fc86fd],.btn-check:checked+.btn-outline-light[data-v-14fc86fd],.btn-outline-light.active[data-v-14fc86fd],.btn-outline-light.dropdown-toggle.show[data-v-14fc86fd],.btn-outline-light[data-v-14fc86fd]:active{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:active+.btn-outline-light[data-v-14fc86fd]:focus,.btn-check:checked+.btn-outline-light[data-v-14fc86fd]:focus,.btn-outline-light.active[data-v-14fc86fd]:focus,.btn-outline-light.dropdown-toggle.show[data-v-14fc86fd]:focus,.btn-outline-light[data-v-14fc86fd]:active:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-outline-light.disabled[data-v-14fc86fd],.btn-outline-light[data-v-14fc86fd]:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-dark[data-v-14fc86fd]{color:#212529;border-color:#212529}.btn-outline-dark[data-v-14fc86fd]:hover{color:#fff;background-color:#212529;border-color:#212529}.btn-check:focus+.btn-outline-dark[data-v-14fc86fd],.btn-outline-dark[data-v-14fc86fd]:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-check:active+.btn-outline-dark[data-v-14fc86fd],.btn-check:checked+.btn-outline-dark[data-v-14fc86fd],.btn-outline-dark.active[data-v-14fc86fd],.btn-outline-dark.dropdown-toggle.show[data-v-14fc86fd],.btn-outline-dark[data-v-14fc86fd]:active{color:#fff;background-color:#212529;border-color:#212529}.btn-check:active+.btn-outline-dark[data-v-14fc86fd]:focus,.btn-check:checked+.btn-outline-dark[data-v-14fc86fd]:focus,.btn-outline-dark.active[data-v-14fc86fd]:focus,.btn-outline-dark.dropdown-toggle.show[data-v-14fc86fd]:focus,.btn-outline-dark[data-v-14fc86fd]:active:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-outline-dark.disabled[data-v-14fc86fd],.btn-outline-dark[data-v-14fc86fd]:disabled{color:#212529;background-color:transparent}.btn-link[data-v-14fc86fd]{font-weight:400;color:#0d6efd;text-decoration:underline}.btn-link[data-v-14fc86fd]:hover{color:#0a58ca}.btn-link.disabled[data-v-14fc86fd],.btn-link[data-v-14fc86fd]:disabled{color:#6c757d}.btn-group-lg>.btn[data-v-14fc86fd],.btn-lg[data-v-14fc86fd]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.btn-group-sm>.btn[data-v-14fc86fd],.btn-sm[data-v-14fc86fd]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.fade[data-v-14fc86fd]{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade[data-v-14fc86fd]{transition:none}}.fade[data-v-14fc86fd]:not(.show){opacity:0}.collapse[data-v-14fc86fd]:not(.show){display:none}.collapsing[data-v-14fc86fd]{height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.collapsing[data-v-14fc86fd]{transition:none}}.collapsing.collapse-horizontal[data-v-14fc86fd]{width:0;height:auto;transition:width .35s ease}@media (prefers-reduced-motion:reduce){.collapsing.collapse-horizontal[data-v-14fc86fd]{transition:none}}.dropdown[data-v-14fc86fd],.dropend[data-v-14fc86fd],.dropstart[data-v-14fc86fd],.dropup[data-v-14fc86fd]{position:relative}.dropdown-toggle[data-v-14fc86fd]{white-space:nowrap}.dropdown-toggle[data-v-14fc86fd]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle[data-v-14fc86fd]:empty:after{margin-left:0}.dropdown-menu[data-v-14fc86fd]{position:absolute;z-index:1000;display:none;min-width:10rem;padding:.5rem 0;margin:0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-menu[data-bs-popper][data-v-14fc86fd]{top:100%;left:0;margin-top:.125rem}.dropdown-menu-start[data-v-14fc86fd]{--bs-position:start}.dropdown-menu-start[data-bs-popper][data-v-14fc86fd]{right:auto;left:0}.dropdown-menu-end[data-v-14fc86fd]{--bs-position:end}.dropdown-menu-end[data-bs-popper][data-v-14fc86fd]{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-start[data-v-14fc86fd]{--bs-position:start}.dropdown-menu-sm-start[data-bs-popper][data-v-14fc86fd]{right:auto;left:0}.dropdown-menu-sm-end[data-v-14fc86fd]{--bs-position:end}.dropdown-menu-sm-end[data-bs-popper][data-v-14fc86fd]{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-start[data-v-14fc86fd]{--bs-position:start}.dropdown-menu-md-start[data-bs-popper][data-v-14fc86fd]{right:auto;left:0}.dropdown-menu-md-end[data-v-14fc86fd]{--bs-position:end}.dropdown-menu-md-end[data-bs-popper][data-v-14fc86fd]{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-start[data-v-14fc86fd]{--bs-position:start}.dropdown-menu-lg-start[data-bs-popper][data-v-14fc86fd]{right:auto;left:0}.dropdown-menu-lg-end[data-v-14fc86fd]{--bs-position:end}.dropdown-menu-lg-end[data-bs-popper][data-v-14fc86fd]{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-start[data-v-14fc86fd]{--bs-position:start}.dropdown-menu-xl-start[data-bs-popper][data-v-14fc86fd]{right:auto;left:0}.dropdown-menu-xl-end[data-v-14fc86fd]{--bs-position:end}.dropdown-menu-xl-end[data-bs-popper][data-v-14fc86fd]{right:0;left:auto}}@media (min-width:1400px){.dropdown-menu-xxl-start[data-v-14fc86fd]{--bs-position:start}.dropdown-menu-xxl-start[data-bs-popper][data-v-14fc86fd]{right:auto;left:0}.dropdown-menu-xxl-end[data-v-14fc86fd]{--bs-position:end}.dropdown-menu-xxl-end[data-bs-popper][data-v-14fc86fd]{right:0;left:auto}}.dropup .dropdown-menu[data-bs-popper][data-v-14fc86fd]{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle[data-v-14fc86fd]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle[data-v-14fc86fd]:empty:after{margin-left:0}.dropend .dropdown-menu[data-bs-popper][data-v-14fc86fd]{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.dropend .dropdown-toggle[data-v-14fc86fd]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropend .dropdown-toggle[data-v-14fc86fd]:empty:after{margin-left:0}.dropend .dropdown-toggle[data-v-14fc86fd]:after{vertical-align:0}.dropstart .dropdown-menu[data-bs-popper][data-v-14fc86fd]{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.dropstart .dropdown-toggle[data-v-14fc86fd]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";display:none}.dropstart .dropdown-toggle[data-v-14fc86fd]:before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropstart .dropdown-toggle[data-v-14fc86fd]:empty:after{margin-left:0}.dropstart .dropdown-toggle[data-v-14fc86fd]:before{vertical-align:0}.dropdown-divider[data-v-14fc86fd]{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid rgba(0,0,0,.15)}.dropdown-item[data-v-14fc86fd]{display:block;width:100%;padding:.25rem 1rem;clear:both;font-weight:400;color:#212529;text-align:inherit;text-decoration:none;white-space:nowrap;background-color:transparent;border:0}.dropdown-item[data-v-14fc86fd]:focus,.dropdown-item[data-v-14fc86fd]:hover{color:#1e2125;background-color:#e9ecef}.dropdown-item.active[data-v-14fc86fd],.dropdown-item[data-v-14fc86fd]:active{color:#fff;text-decoration:none;background-color:#0d6efd}.dropdown-item.disabled[data-v-14fc86fd],.dropdown-item[data-v-14fc86fd]:disabled{color:#adb5bd;pointer-events:none;background-color:transparent}.dropdown-menu.show[data-v-14fc86fd]{display:block}.dropdown-header[data-v-14fc86fd]{display:block;padding:.5rem 1rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.dropdown-item-text[data-v-14fc86fd]{display:block;padding:.25rem 1rem;color:#212529}.dropdown-menu-dark[data-v-14fc86fd]{color:#dee2e6;background-color:#343a40;border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item[data-v-14fc86fd]{color:#dee2e6}.dropdown-menu-dark .dropdown-item[data-v-14fc86fd]:focus,.dropdown-menu-dark .dropdown-item[data-v-14fc86fd]:hover{color:#fff;background-color:hsla(0,0%,100%,.15)}.dropdown-menu-dark .dropdown-item.active[data-v-14fc86fd],.dropdown-menu-dark .dropdown-item[data-v-14fc86fd]:active{color:#fff;background-color:#0d6efd}.dropdown-menu-dark .dropdown-item.disabled[data-v-14fc86fd],.dropdown-menu-dark .dropdown-item[data-v-14fc86fd]:disabled{color:#adb5bd}.dropdown-menu-dark .dropdown-divider[data-v-14fc86fd]{border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item-text[data-v-14fc86fd]{color:#dee2e6}.dropdown-menu-dark .dropdown-header[data-v-14fc86fd]{color:#adb5bd}.btn-group-vertical[data-v-14fc86fd],.btn-group[data-v-14fc86fd]{position:relative;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn[data-v-14fc86fd],.btn-group>.btn[data-v-14fc86fd]{position:relative;flex:1 1 auto}.btn-group-vertical>.btn-check:checked+.btn[data-v-14fc86fd],.btn-group-vertical>.btn-check:focus+.btn[data-v-14fc86fd],.btn-group-vertical>.btn.active[data-v-14fc86fd],.btn-group-vertical>.btn[data-v-14fc86fd]:active,.btn-group-vertical>.btn[data-v-14fc86fd]:focus,.btn-group-vertical>.btn[data-v-14fc86fd]:hover,.btn-group>.btn-check:checked+.btn[data-v-14fc86fd],.btn-group>.btn-check:focus+.btn[data-v-14fc86fd],.btn-group>.btn.active[data-v-14fc86fd],.btn-group>.btn[data-v-14fc86fd]:active,.btn-group>.btn[data-v-14fc86fd]:focus,.btn-group>.btn[data-v-14fc86fd]:hover{z-index:1}.btn-toolbar[data-v-14fc86fd]{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar .input-group[data-v-14fc86fd]{width:auto}.btn-group>.btn-group[data-v-14fc86fd]:not(:first-child),.btn-group>.btn[data-v-14fc86fd]:not(:first-child){margin-left:-1px}.btn-group>.btn-group:not(:last-child)>.btn[data-v-14fc86fd],.btn-group>.btn[data-v-14fc86fd]:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn[data-v-14fc86fd],.btn-group>.btn[data-v-14fc86fd]:nth-child(n+3),.btn-group>:not(.btn-check)+.btn[data-v-14fc86fd]{border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split[data-v-14fc86fd]{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split[data-v-14fc86fd]:after,.dropend .dropdown-toggle-split[data-v-14fc86fd]:after,.dropup .dropdown-toggle-split[data-v-14fc86fd]:after{margin-left:0}.dropstart .dropdown-toggle-split[data-v-14fc86fd]:before{margin-right:0}.btn-group-sm>.btn+.dropdown-toggle-split[data-v-14fc86fd],.btn-sm+.dropdown-toggle-split[data-v-14fc86fd]{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split[data-v-14fc86fd],.btn-lg+.dropdown-toggle-split[data-v-14fc86fd]{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical[data-v-14fc86fd]{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical>.btn-group[data-v-14fc86fd],.btn-group-vertical>.btn[data-v-14fc86fd]{width:100%}.btn-group-vertical>.btn-group[data-v-14fc86fd]:not(:first-child),.btn-group-vertical>.btn[data-v-14fc86fd]:not(:first-child){margin-top:-1px}.btn-group-vertical>.btn-group:not(:last-child)>.btn[data-v-14fc86fd],.btn-group-vertical>.btn[data-v-14fc86fd]:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn[data-v-14fc86fd],.btn-group-vertical>.btn~.btn[data-v-14fc86fd]{border-top-left-radius:0;border-top-right-radius:0}.nav[data-v-14fc86fd]{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link[data-v-14fc86fd]{display:block;padding:.5rem 1rem;color:#0d6efd;text-decoration:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out}@media (prefers-reduced-motion:reduce){.nav-link[data-v-14fc86fd]{transition:none}}.nav-link[data-v-14fc86fd]:focus,.nav-link[data-v-14fc86fd]:hover{color:#0a58ca}.nav-link.disabled[data-v-14fc86fd]{color:#6c757d;pointer-events:none;cursor:default}.nav-tabs[data-v-14fc86fd]{border-bottom:1px solid #dee2e6}.nav-tabs .nav-link[data-v-14fc86fd]{margin-bottom:-1px;background:0 0;border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link[data-v-14fc86fd]:focus,.nav-tabs .nav-link[data-v-14fc86fd]:hover{border-color:#e9ecef #e9ecef #dee2e6;isolation:isolate}.nav-tabs .nav-link.disabled[data-v-14fc86fd]{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link[data-v-14fc86fd],.nav-tabs .nav-link.active[data-v-14fc86fd]{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu[data-v-14fc86fd]{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link[data-v-14fc86fd]{background:0 0;border:0;border-radius:.25rem}.nav-pills .nav-link.active[data-v-14fc86fd],.nav-pills .show>.nav-link[data-v-14fc86fd]{color:#fff;background-color:#0d6efd}.nav-fill .nav-item[data-v-14fc86fd],.nav-fill>.nav-link[data-v-14fc86fd]{flex:1 1 auto;text-align:center}.nav-justified .nav-item[data-v-14fc86fd],.nav-justified>.nav-link[data-v-14fc86fd]{flex-basis:0;flex-grow:1;text-align:center}.nav-fill .nav-item .nav-link[data-v-14fc86fd],.nav-justified .nav-item .nav-link[data-v-14fc86fd]{width:100%}.tab-content>.tab-pane[data-v-14fc86fd]{display:none}.tab-content>.active[data-v-14fc86fd]{display:block}.navbar[data-v-14fc86fd]{position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding-top:.5rem;padding-bottom:.5rem}.navbar>.container-fluid[data-v-14fc86fd],.navbar>.container-lg[data-v-14fc86fd],.navbar>.container-md[data-v-14fc86fd],.navbar>.container-sm[data-v-14fc86fd],.navbar>.container-xl[data-v-14fc86fd],.navbar>.container-xxl[data-v-14fc86fd],.navbar>.container[data-v-14fc86fd]{display:flex;flex-wrap:inherit;align-items:center;justify-content:space-between}.navbar-brand[data-v-14fc86fd]{padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;text-decoration:none;white-space:nowrap}.navbar-nav[data-v-14fc86fd]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link[data-v-14fc86fd]{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu[data-v-14fc86fd]{position:static}.navbar-text[data-v-14fc86fd]{padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse[data-v-14fc86fd]{flex-basis:100%;flex-grow:1;align-items:center}.navbar-toggler[data-v-14fc86fd]{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem;transition:box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.navbar-toggler[data-v-14fc86fd]{transition:none}}.navbar-toggler[data-v-14fc86fd]:hover{text-decoration:none}.navbar-toggler[data-v-14fc86fd]:focus{text-decoration:none;outline:0;box-shadow:0 0 0 .25rem}.navbar-toggler-icon[data-v-14fc86fd]{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;background-repeat:no-repeat;background-position:50%;background-size:100%}.navbar-nav-scroll[data-v-14fc86fd]{max-height:var(--bs-scroll-height,75vh);overflow-y:auto}@media (min-width:576px){.navbar-expand-sm[data-v-14fc86fd]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-sm .navbar-nav[data-v-14fc86fd]{flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu[data-v-14fc86fd]{position:absolute}.navbar-expand-sm .navbar-nav .nav-link[data-v-14fc86fd]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm .navbar-nav-scroll[data-v-14fc86fd]{overflow:visible}.navbar-expand-sm .navbar-collapse[data-v-14fc86fd]{display:flex!important;flex-basis:auto}.navbar-expand-sm .navbar-toggler[data-v-14fc86fd],.navbar-expand-sm .offcanvas-header[data-v-14fc86fd]{display:none}.navbar-expand-sm .offcanvas[data-v-14fc86fd]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-sm .offcanvas-bottom[data-v-14fc86fd],.navbar-expand-sm .offcanvas-top[data-v-14fc86fd]{height:auto;border-top:0;border-bottom:0}.navbar-expand-sm .offcanvas-body[data-v-14fc86fd]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:768px){.navbar-expand-md[data-v-14fc86fd]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-md .navbar-nav[data-v-14fc86fd]{flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu[data-v-14fc86fd]{position:absolute}.navbar-expand-md .navbar-nav .nav-link[data-v-14fc86fd]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md .navbar-nav-scroll[data-v-14fc86fd]{overflow:visible}.navbar-expand-md .navbar-collapse[data-v-14fc86fd]{display:flex!important;flex-basis:auto}.navbar-expand-md .navbar-toggler[data-v-14fc86fd],.navbar-expand-md .offcanvas-header[data-v-14fc86fd]{display:none}.navbar-expand-md .offcanvas[data-v-14fc86fd]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-md .offcanvas-bottom[data-v-14fc86fd],.navbar-expand-md .offcanvas-top[data-v-14fc86fd]{height:auto;border-top:0;border-bottom:0}.navbar-expand-md .offcanvas-body[data-v-14fc86fd]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:992px){.navbar-expand-lg[data-v-14fc86fd]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-lg .navbar-nav[data-v-14fc86fd]{flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu[data-v-14fc86fd]{position:absolute}.navbar-expand-lg .navbar-nav .nav-link[data-v-14fc86fd]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg .navbar-nav-scroll[data-v-14fc86fd]{overflow:visible}.navbar-expand-lg .navbar-collapse[data-v-14fc86fd]{display:flex!important;flex-basis:auto}.navbar-expand-lg .navbar-toggler[data-v-14fc86fd],.navbar-expand-lg .offcanvas-header[data-v-14fc86fd]{display:none}.navbar-expand-lg .offcanvas[data-v-14fc86fd]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-lg .offcanvas-bottom[data-v-14fc86fd],.navbar-expand-lg .offcanvas-top[data-v-14fc86fd]{height:auto;border-top:0;border-bottom:0}.navbar-expand-lg .offcanvas-body[data-v-14fc86fd]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1200px){.navbar-expand-xl[data-v-14fc86fd]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xl .navbar-nav[data-v-14fc86fd]{flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu[data-v-14fc86fd]{position:absolute}.navbar-expand-xl .navbar-nav .nav-link[data-v-14fc86fd]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl .navbar-nav-scroll[data-v-14fc86fd]{overflow:visible}.navbar-expand-xl .navbar-collapse[data-v-14fc86fd]{display:flex!important;flex-basis:auto}.navbar-expand-xl .navbar-toggler[data-v-14fc86fd],.navbar-expand-xl .offcanvas-header[data-v-14fc86fd]{display:none}.navbar-expand-xl .offcanvas[data-v-14fc86fd]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xl .offcanvas-bottom[data-v-14fc86fd],.navbar-expand-xl .offcanvas-top[data-v-14fc86fd]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xl .offcanvas-body[data-v-14fc86fd]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1400px){.navbar-expand-xxl[data-v-14fc86fd]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xxl .navbar-nav[data-v-14fc86fd]{flex-direction:row}.navbar-expand-xxl .navbar-nav .dropdown-menu[data-v-14fc86fd]{position:absolute}.navbar-expand-xxl .navbar-nav .nav-link[data-v-14fc86fd]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xxl .navbar-nav-scroll[data-v-14fc86fd]{overflow:visible}.navbar-expand-xxl .navbar-collapse[data-v-14fc86fd]{display:flex!important;flex-basis:auto}.navbar-expand-xxl .navbar-toggler[data-v-14fc86fd],.navbar-expand-xxl .offcanvas-header[data-v-14fc86fd]{display:none}.navbar-expand-xxl .offcanvas[data-v-14fc86fd]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xxl .offcanvas-bottom[data-v-14fc86fd],.navbar-expand-xxl .offcanvas-top[data-v-14fc86fd]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xxl .offcanvas-body[data-v-14fc86fd]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}.navbar-expand[data-v-14fc86fd]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand .navbar-nav[data-v-14fc86fd]{flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu[data-v-14fc86fd]{position:absolute}.navbar-expand .navbar-nav .nav-link[data-v-14fc86fd]{padding-right:.5rem;padding-left:.5rem}.navbar-expand .navbar-nav-scroll[data-v-14fc86fd]{overflow:visible}.navbar-expand .navbar-collapse[data-v-14fc86fd]{display:flex!important;flex-basis:auto}.navbar-expand .navbar-toggler[data-v-14fc86fd],.navbar-expand .offcanvas-header[data-v-14fc86fd]{display:none}.navbar-expand .offcanvas[data-v-14fc86fd]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand .offcanvas-bottom[data-v-14fc86fd],.navbar-expand .offcanvas-top[data-v-14fc86fd]{height:auto;border-top:0;border-bottom:0}.navbar-expand .offcanvas-body[data-v-14fc86fd]{display:flex;flex-grow:0;padding:0;overflow-y:visible}.navbar-light .navbar-brand[data-v-14fc86fd],.navbar-light .navbar-brand[data-v-14fc86fd]:focus,.navbar-light .navbar-brand[data-v-14fc86fd]:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link[data-v-14fc86fd]{color:rgba(0,0,0,.55)}.navbar-light .navbar-nav .nav-link[data-v-14fc86fd]:focus,.navbar-light .navbar-nav .nav-link[data-v-14fc86fd]:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled[data-v-14fc86fd]{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .nav-link.active[data-v-14fc86fd],.navbar-light .navbar-nav .show>.nav-link[data-v-14fc86fd]{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler[data-v-14fc86fd]{color:rgba(0,0,0,.55);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon[data-v-14fc86fd]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(0, 0, 0, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-light .navbar-text[data-v-14fc86fd]{color:rgba(0,0,0,.55)}.navbar-light .navbar-text a[data-v-14fc86fd],.navbar-light .navbar-text a[data-v-14fc86fd]:focus,.navbar-light .navbar-text a[data-v-14fc86fd]:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand[data-v-14fc86fd],.navbar-dark .navbar-brand[data-v-14fc86fd]:focus,.navbar-dark .navbar-brand[data-v-14fc86fd]:hover{color:#fff}.navbar-dark .navbar-nav .nav-link[data-v-14fc86fd]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-nav .nav-link[data-v-14fc86fd]:focus,.navbar-dark .navbar-nav .nav-link[data-v-14fc86fd]:hover{color:hsla(0,0%,100%,.75)}.navbar-dark .navbar-nav .nav-link.disabled[data-v-14fc86fd]{color:hsla(0,0%,100%,.25)}.navbar-dark .navbar-nav .nav-link.active[data-v-14fc86fd],.navbar-dark .navbar-nav .show>.nav-link[data-v-14fc86fd]{color:#fff}.navbar-dark .navbar-toggler[data-v-14fc86fd]{color:hsla(0,0%,100%,.55);border-color:hsla(0,0%,100%,.1)}.navbar-dark .navbar-toggler-icon[data-v-14fc86fd]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(255, 255, 255, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-dark .navbar-text[data-v-14fc86fd]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-text a[data-v-14fc86fd],.navbar-dark .navbar-text a[data-v-14fc86fd]:focus,.navbar-dark .navbar-text a[data-v-14fc86fd]:hover{color:#fff}.card[data-v-14fc86fd]{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr[data-v-14fc86fd]{margin-right:0;margin-left:0}.card>.list-group[data-v-14fc86fd]{border-top:inherit;border-bottom:inherit}.card>.list-group[data-v-14fc86fd]:first-child{border-top-width:0;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card>.list-group[data-v-14fc86fd]:last-child{border-bottom-width:0;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card>.card-header+.list-group[data-v-14fc86fd],.card>.list-group+.card-footer[data-v-14fc86fd]{border-top:0}.card-body[data-v-14fc86fd]{flex:1 1 auto;padding:1rem}.card-title[data-v-14fc86fd]{margin-bottom:.5rem}.card-subtitle[data-v-14fc86fd]{margin-top:-.25rem;margin-bottom:0}.card-text[data-v-14fc86fd]:last-child{margin-bottom:0}.card-link+.card-link[data-v-14fc86fd]{margin-left:1rem}.card-header[data-v-14fc86fd]{padding:.5rem 1rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header[data-v-14fc86fd]:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-footer[data-v-14fc86fd]{padding:.5rem 1rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer[data-v-14fc86fd]:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs[data-v-14fc86fd]{margin-bottom:-.5rem;border-bottom:0}.card-header-pills[data-v-14fc86fd],.card-header-tabs[data-v-14fc86fd]{margin-right:-.5rem;margin-left:-.5rem}.card-img-overlay[data-v-14fc86fd]{position:absolute;top:0;right:0;bottom:0;left:0;padding:1rem;border-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-14fc86fd],.card-img-top[data-v-14fc86fd],.card-img[data-v-14fc86fd]{width:100%}.card-img-top[data-v-14fc86fd],.card-img[data-v-14fc86fd]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-14fc86fd],.card-img[data-v-14fc86fd]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-group>.card[data-v-14fc86fd]{margin-bottom:.75rem}@media (min-width:576px){.card-group[data-v-14fc86fd]{display:flex;flex-flow:row wrap}.card-group>.card[data-v-14fc86fd]{flex:1 0 0%;margin-bottom:0}.card-group>.card+.card[data-v-14fc86fd]{margin-left:0;border-left:0}.card-group>.card[data-v-14fc86fd]:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-header[data-v-14fc86fd],.card-group>.card:not(:last-child) .card-img-top[data-v-14fc86fd]{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-footer[data-v-14fc86fd],.card-group>.card:not(:last-child) .card-img-bottom[data-v-14fc86fd]{border-bottom-right-radius:0}.card-group>.card[data-v-14fc86fd]:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-header[data-v-14fc86fd],.card-group>.card:not(:first-child) .card-img-top[data-v-14fc86fd]{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-footer[data-v-14fc86fd],.card-group>.card:not(:first-child) .card-img-bottom[data-v-14fc86fd]{border-bottom-left-radius:0}}.accordion-button[data-v-14fc86fd]{position:relative;display:flex;align-items:center;width:100%;padding:1rem 1.25rem;font-size:1rem;color:#212529;text-align:left;background-color:#fff;border:0;border-radius:0;overflow-anchor:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,border-radius .15s ease}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-14fc86fd]{transition:none}}.accordion-button[data-v-14fc86fd]:not(.collapsed){color:#0c63e4;background-color:#e7f1ff;box-shadow:inset 0 -1px 0 rgba(0,0,0,.125)}.accordion-button[data-v-14fc86fd]:not(.collapsed):after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230c63e4'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");transform:rotate(-180deg)}.accordion-button[data-v-14fc86fd]:after{flex-shrink:0;width:1.25rem;height:1.25rem;margin-left:auto;content:\"\";background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-size:1.25rem;transition:transform .2s ease-in-out}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-14fc86fd]:after{transition:none}}.accordion-button[data-v-14fc86fd]:hover{z-index:2}.accordion-button[data-v-14fc86fd]:focus{z-index:3;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.accordion-header[data-v-14fc86fd]{margin-bottom:0}.accordion-item[data-v-14fc86fd]{background-color:#fff;border:1px solid rgba(0,0,0,.125)}.accordion-item[data-v-14fc86fd]:first-of-type{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.accordion-item:first-of-type .accordion-button[data-v-14fc86fd]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.accordion-item[data-v-14fc86fd]:not(:first-of-type){border-top:0}.accordion-item[data-v-14fc86fd]:last-of-type{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-item:last-of-type .accordion-button.collapsed[data-v-14fc86fd]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.accordion-item:last-of-type .accordion-collapse[data-v-14fc86fd]{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-body[data-v-14fc86fd]{padding:1rem 1.25rem}.accordion-flush .accordion-collapse[data-v-14fc86fd]{border-width:0}.accordion-flush .accordion-item[data-v-14fc86fd]{border-right:0;border-left:0;border-radius:0}.accordion-flush .accordion-item[data-v-14fc86fd]:first-child{border-top:0}.accordion-flush .accordion-item[data-v-14fc86fd]:last-child{border-bottom:0}.accordion-flush .accordion-item .accordion-button[data-v-14fc86fd]{border-radius:0}.breadcrumb[data-v-14fc86fd]{display:flex;flex-wrap:wrap;padding:0;margin-bottom:1rem;list-style:none}.breadcrumb-item+.breadcrumb-item[data-v-14fc86fd]{padding-left:.5rem}.breadcrumb-item+.breadcrumb-item[data-v-14fc86fd]:before{float:left;padding-right:.5rem;color:#6c757d;content:var(--bs-breadcrumb-divider,\"/\")}.breadcrumb-item.active[data-v-14fc86fd]{color:#6c757d}.pagination[data-v-14fc86fd]{display:flex;padding-left:0;list-style:none}.page-link[data-v-14fc86fd]{position:relative;display:block;color:#0d6efd;text-decoration:none;background-color:#fff;border:1px solid #dee2e6;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.page-link[data-v-14fc86fd]{transition:none}}.page-link[data-v-14fc86fd]:hover{z-index:2;color:#0a58ca;background-color:#e9ecef;border-color:#dee2e6}.page-link[data-v-14fc86fd]:focus{z-index:3;color:#0a58ca;background-color:#e9ecef;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.page-item:not(:first-child) .page-link[data-v-14fc86fd]{margin-left:-1px}.page-item.active .page-link[data-v-14fc86fd]{z-index:3;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.page-item.disabled .page-link[data-v-14fc86fd]{color:#6c757d;pointer-events:none;background-color:#fff;border-color:#dee2e6}.page-link[data-v-14fc86fd]{padding:.375rem .75rem}.page-item:first-child .page-link[data-v-14fc86fd]{border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item:last-child .page-link[data-v-14fc86fd]{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.pagination-lg .page-link[data-v-14fc86fd]{padding:.75rem 1.5rem;font-size:1.25rem}.pagination-lg .page-item:first-child .page-link[data-v-14fc86fd]{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link[data-v-14fc86fd]{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm .page-link[data-v-14fc86fd]{padding:.25rem .5rem;font-size:.875rem}.pagination-sm .page-item:first-child .page-link[data-v-14fc86fd]{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link[data-v-14fc86fd]{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge[data-v-14fc86fd]{display:inline-block;padding:.35em .65em;font-size:.75em;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}.badge[data-v-14fc86fd]:empty{display:none}.btn .badge[data-v-14fc86fd]{position:relative;top:-1px}.alert[data-v-14fc86fd]{position:relative;padding:1rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading[data-v-14fc86fd]{color:inherit}.alert-link[data-v-14fc86fd]{font-weight:700}.alert-dismissible[data-v-14fc86fd]{padding-right:3rem}.alert-dismissible .btn-close[data-v-14fc86fd]{position:absolute;top:0;right:0;z-index:2;padding:1.25rem 1rem}.alert-primary[data-v-14fc86fd]{color:#084298;background-color:#cfe2ff;border-color:#b6d4fe}.alert-primary .alert-link[data-v-14fc86fd]{color:#06357a}.alert-secondary[data-v-14fc86fd]{color:#41464b;background-color:#e2e3e5;border-color:#d3d6d8}.alert-secondary .alert-link[data-v-14fc86fd]{color:#34383c}.alert-success[data-v-14fc86fd]{color:#0f5132;background-color:#d1e7dd;border-color:#badbcc}.alert-success .alert-link[data-v-14fc86fd]{color:#0c4128}.alert-info[data-v-14fc86fd]{color:#055160;background-color:#cff4fc;border-color:#b6effb}.alert-info .alert-link[data-v-14fc86fd]{color:#04414d}.alert-warning[data-v-14fc86fd]{color:#664d03;background-color:#fff3cd;border-color:#ffecb5}.alert-warning .alert-link[data-v-14fc86fd]{color:#523e02}.alert-danger[data-v-14fc86fd]{color:#842029;background-color:#f8d7da;border-color:#f5c2c7}.alert-danger .alert-link[data-v-14fc86fd]{color:#6a1a21}.alert-light[data-v-14fc86fd]{color:#636464;background-color:#fefefe;border-color:#fdfdfe}.alert-light .alert-link[data-v-14fc86fd]{color:#4f5050}.alert-dark[data-v-14fc86fd]{color:#141619;background-color:#d3d3d4;border-color:#bcbebf}.alert-dark .alert-link[data-v-14fc86fd]{color:#101214}@-webkit-keyframes progress-bar-stripes-data-v-14fc86fd{0%{background-position-x:1rem}}@keyframes progress-bar-stripes-data-v-14fc86fd{0%{background-position-x:1rem}}.progress[data-v-14fc86fd]{display:flex;height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress-bar[data-v-14fc86fd]{display:flex;flex-direction:column;justify-content:center;overflow:hidden;color:#fff;text-align:center;white-space:nowrap;background-color:#0d6efd;transition:width .6s ease}@media (prefers-reduced-motion:reduce){.progress-bar[data-v-14fc86fd]{transition:none}}.progress-bar-striped[data-v-14fc86fd]{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-bar-animated[data-v-14fc86fd]{-webkit-animation:1s linear infinite progress-bar-stripes-data-v-14fc86fd;animation:1s linear infinite progress-bar-stripes-data-v-14fc86fd}@media (prefers-reduced-motion:reduce){.progress-bar-animated[data-v-14fc86fd]{-webkit-animation:none;animation:none}}.list-group[data-v-14fc86fd]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:.25rem}.list-group-numbered[data-v-14fc86fd]{list-style-type:none;counter-reset:section}.list-group-numbered>li[data-v-14fc86fd]:before{content:counters(section,\".\") \". \";counter-increment:section}.list-group-item-action[data-v-14fc86fd]{width:100%;color:#495057;text-align:inherit}.list-group-item-action[data-v-14fc86fd]:focus,.list-group-item-action[data-v-14fc86fd]:hover{z-index:1;color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action[data-v-14fc86fd]:active{color:#212529;background-color:#e9ecef}.list-group-item[data-v-14fc86fd]{position:relative;display:block;padding:.5rem 1rem;color:#212529;text-decoration:none;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item[data-v-14fc86fd]:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.list-group-item[data-v-14fc86fd]:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.list-group-item.disabled[data-v-14fc86fd],.list-group-item[data-v-14fc86fd]:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.list-group-item.active[data-v-14fc86fd]{z-index:2;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.list-group-item+.list-group-item[data-v-14fc86fd]{border-top-width:0}.list-group-item+.list-group-item.active[data-v-14fc86fd]{margin-top:-1px;border-top-width:1px}.list-group-horizontal[data-v-14fc86fd]{flex-direction:row}.list-group-horizontal>.list-group-item[data-v-14fc86fd]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal>.list-group-item[data-v-14fc86fd]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal>.list-group-item.active[data-v-14fc86fd]{margin-top:0}.list-group-horizontal>.list-group-item+.list-group-item[data-v-14fc86fd]{border-top-width:1px;border-left-width:0}.list-group-horizontal>.list-group-item+.list-group-item.active[data-v-14fc86fd]{margin-left:-1px;border-left-width:1px}@media (min-width:576px){.list-group-horizontal-sm[data-v-14fc86fd]{flex-direction:row}.list-group-horizontal-sm>.list-group-item[data-v-14fc86fd]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-sm>.list-group-item[data-v-14fc86fd]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-sm>.list-group-item.active[data-v-14fc86fd]{margin-top:0}.list-group-horizontal-sm>.list-group-item+.list-group-item[data-v-14fc86fd]{border-top-width:1px;border-left-width:0}.list-group-horizontal-sm>.list-group-item+.list-group-item.active[data-v-14fc86fd]{margin-left:-1px;border-left-width:1px}}@media (min-width:768px){.list-group-horizontal-md[data-v-14fc86fd]{flex-direction:row}.list-group-horizontal-md>.list-group-item[data-v-14fc86fd]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-md>.list-group-item[data-v-14fc86fd]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-md>.list-group-item.active[data-v-14fc86fd]{margin-top:0}.list-group-horizontal-md>.list-group-item+.list-group-item[data-v-14fc86fd]{border-top-width:1px;border-left-width:0}.list-group-horizontal-md>.list-group-item+.list-group-item.active[data-v-14fc86fd]{margin-left:-1px;border-left-width:1px}}@media (min-width:992px){.list-group-horizontal-lg[data-v-14fc86fd]{flex-direction:row}.list-group-horizontal-lg>.list-group-item[data-v-14fc86fd]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-lg>.list-group-item[data-v-14fc86fd]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-lg>.list-group-item.active[data-v-14fc86fd]{margin-top:0}.list-group-horizontal-lg>.list-group-item+.list-group-item[data-v-14fc86fd]{border-top-width:1px;border-left-width:0}.list-group-horizontal-lg>.list-group-item+.list-group-item.active[data-v-14fc86fd]{margin-left:-1px;border-left-width:1px}}@media (min-width:1200px){.list-group-horizontal-xl[data-v-14fc86fd]{flex-direction:row}.list-group-horizontal-xl>.list-group-item[data-v-14fc86fd]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xl>.list-group-item[data-v-14fc86fd]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xl>.list-group-item.active[data-v-14fc86fd]{margin-top:0}.list-group-horizontal-xl>.list-group-item+.list-group-item[data-v-14fc86fd]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xl>.list-group-item+.list-group-item.active[data-v-14fc86fd]{margin-left:-1px;border-left-width:1px}}@media (min-width:1400px){.list-group-horizontal-xxl[data-v-14fc86fd]{flex-direction:row}.list-group-horizontal-xxl>.list-group-item[data-v-14fc86fd]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xxl>.list-group-item[data-v-14fc86fd]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xxl>.list-group-item.active[data-v-14fc86fd]{margin-top:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item[data-v-14fc86fd]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item.active[data-v-14fc86fd]{margin-left:-1px;border-left-width:1px}}.list-group-flush[data-v-14fc86fd]{border-radius:0}.list-group-flush>.list-group-item[data-v-14fc86fd]{border-width:0 0 1px}.list-group-flush>.list-group-item[data-v-14fc86fd]:last-child{border-bottom-width:0}.list-group-item-primary[data-v-14fc86fd]{color:#084298;background-color:#cfe2ff}.list-group-item-primary.list-group-item-action[data-v-14fc86fd]:focus,.list-group-item-primary.list-group-item-action[data-v-14fc86fd]:hover{color:#084298;background-color:#bacbe6}.list-group-item-primary.list-group-item-action.active[data-v-14fc86fd]{color:#fff;background-color:#084298;border-color:#084298}.list-group-item-secondary[data-v-14fc86fd]{color:#41464b;background-color:#e2e3e5}.list-group-item-secondary.list-group-item-action[data-v-14fc86fd]:focus,.list-group-item-secondary.list-group-item-action[data-v-14fc86fd]:hover{color:#41464b;background-color:#cbccce}.list-group-item-secondary.list-group-item-action.active[data-v-14fc86fd]{color:#fff;background-color:#41464b;border-color:#41464b}.list-group-item-success[data-v-14fc86fd]{color:#0f5132;background-color:#d1e7dd}.list-group-item-success.list-group-item-action[data-v-14fc86fd]:focus,.list-group-item-success.list-group-item-action[data-v-14fc86fd]:hover{color:#0f5132;background-color:#bcd0c7}.list-group-item-success.list-group-item-action.active[data-v-14fc86fd]{color:#fff;background-color:#0f5132;border-color:#0f5132}.list-group-item-info[data-v-14fc86fd]{color:#055160;background-color:#cff4fc}.list-group-item-info.list-group-item-action[data-v-14fc86fd]:focus,.list-group-item-info.list-group-item-action[data-v-14fc86fd]:hover{color:#055160;background-color:#badce3}.list-group-item-info.list-group-item-action.active[data-v-14fc86fd]{color:#fff;background-color:#055160;border-color:#055160}.list-group-item-warning[data-v-14fc86fd]{color:#664d03;background-color:#fff3cd}.list-group-item-warning.list-group-item-action[data-v-14fc86fd]:focus,.list-group-item-warning.list-group-item-action[data-v-14fc86fd]:hover{color:#664d03;background-color:#e6dbb9}.list-group-item-warning.list-group-item-action.active[data-v-14fc86fd]{color:#fff;background-color:#664d03;border-color:#664d03}.list-group-item-danger[data-v-14fc86fd]{color:#842029;background-color:#f8d7da}.list-group-item-danger.list-group-item-action[data-v-14fc86fd]:focus,.list-group-item-danger.list-group-item-action[data-v-14fc86fd]:hover{color:#842029;background-color:#dfc2c4}.list-group-item-danger.list-group-item-action.active[data-v-14fc86fd]{color:#fff;background-color:#842029;border-color:#842029}.list-group-item-light[data-v-14fc86fd]{color:#636464;background-color:#fefefe}.list-group-item-light.list-group-item-action[data-v-14fc86fd]:focus,.list-group-item-light.list-group-item-action[data-v-14fc86fd]:hover{color:#636464;background-color:#e5e5e5}.list-group-item-light.list-group-item-action.active[data-v-14fc86fd]{color:#fff;background-color:#636464;border-color:#636464}.list-group-item-dark[data-v-14fc86fd]{color:#141619;background-color:#d3d3d4}.list-group-item-dark.list-group-item-action[data-v-14fc86fd]:focus,.list-group-item-dark.list-group-item-action[data-v-14fc86fd]:hover{color:#141619;background-color:#bebebf}.list-group-item-dark.list-group-item-action.active[data-v-14fc86fd]{color:#fff;background-color:#141619;border-color:#141619}.btn-close[data-v-14fc86fd]{box-sizing:content-box;width:1em;height:1em;padding:.25em;color:#000;background:transparent url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M.293.293a1 1 0 11.414 0 NaN NaNlNaN NaN NaN NaNa1 1 0 111.414 1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 10-1.414 NaN NaNz'/%3E%3C/svg%3E\") 50%/1em auto no-repeat;border:0;border-radius:.25rem;opacity:.5}.btn-close[data-v-14fc86fd]:hover{color:#000;text-decoration:none;opacity:.75}.btn-close[data-v-14fc86fd]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25);opacity:1}.btn-close.disabled[data-v-14fc86fd],.btn-close[data-v-14fc86fd]:disabled{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;opacity:.25}.btn-close-white[data-v-14fc86fd]{filter:invert(1) grayscale(100%) brightness(200%)}.toast[data-v-14fc86fd]{width:350px;max-width:100%;font-size:.875rem;pointer-events:auto;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .5rem 1rem rgba(0,0,0,.15);border-radius:.25rem}.toast.showing[data-v-14fc86fd]{opacity:0}.toast[data-v-14fc86fd]:not(.show){display:none}.toast-container[data-v-14fc86fd]{width:-webkit-max-content;width:-moz-max-content;width:max-content;max-width:100%;pointer-events:none}.toast-container[data-v-14fc86fd]>:not(:last-child){margin-bottom:.75rem}.toast-header[data-v-14fc86fd]{display:flex;align-items:center;padding:.5rem .75rem;color:#6c757d;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05);border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.toast-header .btn-close[data-v-14fc86fd]{margin-right:-.375rem;margin-left:.75rem}.toast-body[data-v-14fc86fd]{padding:.75rem;word-wrap:break-word}.modal[data-v-14fc86fd]{position:fixed;top:0;left:0;z-index:1055;display:none;width:100%;height:100%;overflow-x:hidden;overflow-y:auto;outline:0}.modal-dialog[data-v-14fc86fd]{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog[data-v-14fc86fd]{transition:transform .3s ease-out;transform:translateY(-50px)}@media (prefers-reduced-motion:reduce){.modal.fade .modal-dialog[data-v-14fc86fd]{transition:none}}.modal.show .modal-dialog[data-v-14fc86fd]{transform:none}.modal.modal-static .modal-dialog[data-v-14fc86fd]{transform:scale(1.02)}.modal-dialog-scrollable[data-v-14fc86fd]{height:calc(100% - 1rem)}.modal-dialog-scrollable .modal-content[data-v-14fc86fd]{max-height:100%;overflow:hidden}.modal-dialog-scrollable .modal-body[data-v-14fc86fd]{overflow-y:auto}.modal-dialog-centered[data-v-14fc86fd]{display:flex;align-items:center;min-height:calc(100% - 1rem)}.modal-content[data-v-14fc86fd]{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop[data-v-14fc86fd]{position:fixed;top:0;left:0;z-index:1050;width:100vw;height:100vh;background-color:#000}.modal-backdrop.fade[data-v-14fc86fd]{opacity:0}.modal-backdrop.show[data-v-14fc86fd]{opacity:.5}.modal-header[data-v-14fc86fd]{display:flex;flex-shrink:0;align-items:center;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.modal-header .btn-close[data-v-14fc86fd]{padding:.5rem;margin:-.5rem -.5rem -.5rem auto}.modal-title[data-v-14fc86fd]{margin-bottom:0;line-height:1.5}.modal-body[data-v-14fc86fd]{position:relative;flex:1 1 auto;padding:1rem}.modal-footer[data-v-14fc86fd]{display:flex;flex-wrap:wrap;flex-shrink:0;align-items:center;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.modal-footer>[data-v-14fc86fd]{margin:.25rem}@media (min-width:576px){.modal-dialog[data-v-14fc86fd]{max-width:500px;margin:1.75rem auto}.modal-dialog-scrollable[data-v-14fc86fd]{height:calc(100% - 3.5rem)}.modal-dialog-centered[data-v-14fc86fd]{min-height:calc(100% - 3.5rem)}.modal-sm[data-v-14fc86fd]{max-width:300px}}@media (min-width:992px){.modal-lg[data-v-14fc86fd],.modal-xl[data-v-14fc86fd]{max-width:800px}}@media (min-width:1200px){.modal-xl[data-v-14fc86fd]{max-width:1140px}}.modal-fullscreen[data-v-14fc86fd]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen .modal-content[data-v-14fc86fd]{height:100%;border:0;border-radius:0}.modal-fullscreen .modal-header[data-v-14fc86fd]{border-radius:0}.modal-fullscreen .modal-body[data-v-14fc86fd]{overflow-y:auto}.modal-fullscreen .modal-footer[data-v-14fc86fd]{border-radius:0}@media (max-width:575.98px){.modal-fullscreen-sm-down[data-v-14fc86fd]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-sm-down .modal-content[data-v-14fc86fd]{height:100%;border:0;border-radius:0}.modal-fullscreen-sm-down .modal-header[data-v-14fc86fd]{border-radius:0}.modal-fullscreen-sm-down .modal-body[data-v-14fc86fd]{overflow-y:auto}.modal-fullscreen-sm-down .modal-footer[data-v-14fc86fd]{border-radius:0}}@media (max-width:767.98px){.modal-fullscreen-md-down[data-v-14fc86fd]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-md-down .modal-content[data-v-14fc86fd]{height:100%;border:0;border-radius:0}.modal-fullscreen-md-down .modal-header[data-v-14fc86fd]{border-radius:0}.modal-fullscreen-md-down .modal-body[data-v-14fc86fd]{overflow-y:auto}.modal-fullscreen-md-down .modal-footer[data-v-14fc86fd]{border-radius:0}}@media (max-width:991.98px){.modal-fullscreen-lg-down[data-v-14fc86fd]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-lg-down .modal-content[data-v-14fc86fd]{height:100%;border:0;border-radius:0}.modal-fullscreen-lg-down .modal-header[data-v-14fc86fd]{border-radius:0}.modal-fullscreen-lg-down .modal-body[data-v-14fc86fd]{overflow-y:auto}.modal-fullscreen-lg-down .modal-footer[data-v-14fc86fd]{border-radius:0}}@media (max-width:1199.98px){.modal-fullscreen-xl-down[data-v-14fc86fd]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xl-down .modal-content[data-v-14fc86fd]{height:100%;border:0;border-radius:0}.modal-fullscreen-xl-down .modal-header[data-v-14fc86fd]{border-radius:0}.modal-fullscreen-xl-down .modal-body[data-v-14fc86fd]{overflow-y:auto}.modal-fullscreen-xl-down .modal-footer[data-v-14fc86fd]{border-radius:0}}@media (max-width:1399.98px){.modal-fullscreen-xxl-down[data-v-14fc86fd]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xxl-down .modal-content[data-v-14fc86fd]{height:100%;border:0;border-radius:0}.modal-fullscreen-xxl-down .modal-header[data-v-14fc86fd]{border-radius:0}.modal-fullscreen-xxl-down .modal-body[data-v-14fc86fd]{overflow-y:auto}.modal-fullscreen-xxl-down .modal-footer[data-v-14fc86fd]{border-radius:0}}.tooltip[data-v-14fc86fd]{position:absolute;z-index:1080;display:block;margin:0;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show[data-v-14fc86fd]{opacity:.9}.tooltip .tooltip-arrow[data-v-14fc86fd]{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .tooltip-arrow[data-v-14fc86fd]:before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[data-popper-placement^=top][data-v-14fc86fd],.bs-tooltip-top[data-v-14fc86fd]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-14fc86fd],.bs-tooltip-top .tooltip-arrow[data-v-14fc86fd]{bottom:0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-14fc86fd]:before,.bs-tooltip-top .tooltip-arrow[data-v-14fc86fd]:before{top:-1px;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[data-popper-placement^=right][data-v-14fc86fd],.bs-tooltip-end[data-v-14fc86fd]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-14fc86fd],.bs-tooltip-end .tooltip-arrow[data-v-14fc86fd]{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-14fc86fd]:before,.bs-tooltip-end .tooltip-arrow[data-v-14fc86fd]:before{right:-1px;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[data-popper-placement^=bottom][data-v-14fc86fd],.bs-tooltip-bottom[data-v-14fc86fd]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-14fc86fd],.bs-tooltip-bottom .tooltip-arrow[data-v-14fc86fd]{top:0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-14fc86fd]:before,.bs-tooltip-bottom .tooltip-arrow[data-v-14fc86fd]:before{bottom:-1px;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[data-popper-placement^=left][data-v-14fc86fd],.bs-tooltip-start[data-v-14fc86fd]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-14fc86fd],.bs-tooltip-start .tooltip-arrow[data-v-14fc86fd]{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-14fc86fd]:before,.bs-tooltip-start .tooltip-arrow[data-v-14fc86fd]:before{left:-1px;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner[data-v-14fc86fd]{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover[data-v-14fc86fd]{position:absolute;top:0;left:0;z-index:1070;display:block;max-width:276px;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover .popover-arrow[data-v-14fc86fd]{position:absolute;display:block;width:1rem;height:.5rem}.popover .popover-arrow[data-v-14fc86fd]:after,.popover .popover-arrow[data-v-14fc86fd]:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-14fc86fd],.bs-popover-top>.popover-arrow[data-v-14fc86fd]{bottom:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-14fc86fd]:before,.bs-popover-top>.popover-arrow[data-v-14fc86fd]:before{bottom:0;border-width:.5rem .5rem 0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-14fc86fd]:after,.bs-popover-top>.popover-arrow[data-v-14fc86fd]:after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:#fff}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-14fc86fd],.bs-popover-end>.popover-arrow[data-v-14fc86fd]{left:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-14fc86fd]:before,.bs-popover-end>.popover-arrow[data-v-14fc86fd]:before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-14fc86fd]:after,.bs-popover-end>.popover-arrow[data-v-14fc86fd]:after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:#fff}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-14fc86fd],.bs-popover-bottom>.popover-arrow[data-v-14fc86fd]{top:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-14fc86fd]:before,.bs-popover-bottom>.popover-arrow[data-v-14fc86fd]:before{top:0;border-width:0 .5rem .5rem;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-14fc86fd]:after,.bs-popover-bottom>.popover-arrow[data-v-14fc86fd]:after{top:1px;border-width:0 .5rem .5rem;border-bottom-color:#fff}.bs-popover-auto[data-popper-placement^=bottom] .popover-header[data-v-14fc86fd]:before,.bs-popover-bottom .popover-header[data-v-14fc86fd]:before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f0f0f0}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-14fc86fd],.bs-popover-start>.popover-arrow[data-v-14fc86fd]{right:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-14fc86fd]:before,.bs-popover-start>.popover-arrow[data-v-14fc86fd]:before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-14fc86fd]:after,.bs-popover-start>.popover-arrow[data-v-14fc86fd]:after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:#fff}.popover-header[data-v-14fc86fd]{padding:.5rem 1rem;margin-bottom:0;font-size:1rem;background-color:#f0f0f0;border-bottom:1px solid rgba(0,0,0,.2);border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header[data-v-14fc86fd]:empty{display:none}.popover-body[data-v-14fc86fd]{padding:1rem;color:#212529}.carousel[data-v-14fc86fd]{position:relative}.carousel.pointer-event[data-v-14fc86fd]{touch-action:pan-y}.carousel-inner[data-v-14fc86fd]{position:relative;width:100%;overflow:hidden}.carousel-inner[data-v-14fc86fd]:after{display:block;clear:both;content:\"\"}.carousel-item[data-v-14fc86fd]{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.carousel-item[data-v-14fc86fd]{transition:none}}.carousel-item-next[data-v-14fc86fd],.carousel-item-prev[data-v-14fc86fd],.carousel-item.active[data-v-14fc86fd]{display:block}.active.carousel-item-end[data-v-14fc86fd],.carousel-item-next[data-v-14fc86fd]:not(.carousel-item-start){transform:translateX(100%)}.active.carousel-item-start[data-v-14fc86fd],.carousel-item-prev[data-v-14fc86fd]:not(.carousel-item-end){transform:translateX(-100%)}.carousel-fade .carousel-item[data-v-14fc86fd]{opacity:0;transition-property:opacity;transform:none}.carousel-fade .carousel-item-next.carousel-item-start[data-v-14fc86fd],.carousel-fade .carousel-item-prev.carousel-item-end[data-v-14fc86fd],.carousel-fade .carousel-item.active[data-v-14fc86fd]{z-index:1;opacity:1}.carousel-fade .active.carousel-item-end[data-v-14fc86fd],.carousel-fade .active.carousel-item-start[data-v-14fc86fd]{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.carousel-fade .active.carousel-item-end[data-v-14fc86fd],.carousel-fade .active.carousel-item-start[data-v-14fc86fd]{transition:none}}.carousel-control-next[data-v-14fc86fd],.carousel-control-prev[data-v-14fc86fd]{position:absolute;top:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center;width:15%;padding:0;color:#fff;text-align:center;background:0 0;border:0;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.carousel-control-next[data-v-14fc86fd],.carousel-control-prev[data-v-14fc86fd]{transition:none}}.carousel-control-next[data-v-14fc86fd]:focus,.carousel-control-next[data-v-14fc86fd]:hover,.carousel-control-prev[data-v-14fc86fd]:focus,.carousel-control-prev[data-v-14fc86fd]:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev[data-v-14fc86fd]{left:0}.carousel-control-next[data-v-14fc86fd]{right:0}.carousel-control-next-icon[data-v-14fc86fd],.carousel-control-prev-icon[data-v-14fc86fd]{display:inline-block;width:2rem;height:2rem;background-repeat:no-repeat;background-position:50%;background-size:100% 100%}.carousel-control-prev-icon[data-v-14fc86fd]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3E%3C/svg%3E\")}.carousel-control-next-icon[data-v-14fc86fd]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\")}.carousel-indicators[data-v-14fc86fd]{position:absolute;right:0;bottom:0;left:0;z-index:2;display:flex;justify-content:center;padding:0;margin-right:15%;margin-bottom:1rem;margin-left:15%;list-style:none}.carousel-indicators [data-bs-target][data-v-14fc86fd]{box-sizing:content-box;flex:0 1 auto;width:30px;height:3px;padding:0;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border:0;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.carousel-indicators [data-bs-target][data-v-14fc86fd]{transition:none}}.carousel-indicators .active[data-v-14fc86fd]{opacity:1}.carousel-caption[data-v-14fc86fd]{position:absolute;right:15%;bottom:1.25rem;left:15%;padding-top:1.25rem;padding-bottom:1.25rem;color:#fff;text-align:center}.carousel-dark .carousel-control-next-icon[data-v-14fc86fd],.carousel-dark .carousel-control-prev-icon[data-v-14fc86fd]{filter:invert(1) grayscale(100)}.carousel-dark .carousel-indicators [data-bs-target][data-v-14fc86fd]{background-color:#000}.carousel-dark .carousel-caption[data-v-14fc86fd]{color:#000}@-webkit-keyframes spinner-border-data-v-14fc86fd{to{transform:rotate(1turn)}}@keyframes spinner-border-data-v-14fc86fd{to{transform:rotate(1turn)}}.spinner-border[data-v-14fc86fd]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:.75s linear infinite spinner-border-data-v-14fc86fd;animation:.75s linear infinite spinner-border-data-v-14fc86fd}.spinner-border-sm[data-v-14fc86fd]{width:1rem;height:1rem;border-width:.2em}@-webkit-keyframes spinner-grow-data-v-14fc86fd{0%{transform:scale(0)}50%{opacity:1;transform:none}}@keyframes spinner-grow-data-v-14fc86fd{0%{transform:scale(0)}50%{opacity:1;transform:none}}.spinner-grow[data-v-14fc86fd]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;background-color:currentColor;border-radius:50%;opacity:0;-webkit-animation:.75s linear infinite spinner-grow-data-v-14fc86fd;animation:.75s linear infinite spinner-grow-data-v-14fc86fd}.spinner-grow-sm[data-v-14fc86fd]{width:1rem;height:1rem}@media (prefers-reduced-motion:reduce){.spinner-border[data-v-14fc86fd],.spinner-grow[data-v-14fc86fd]{-webkit-animation-duration:1.5s;animation-duration:1.5s}}.offcanvas[data-v-14fc86fd]{position:fixed;bottom:0;z-index:1045;display:flex;flex-direction:column;max-width:100%;visibility:hidden;background-color:#fff;background-clip:padding-box;outline:0;transition:transform .3s ease-in-out}@media (prefers-reduced-motion:reduce){.offcanvas[data-v-14fc86fd]{transition:none}}.offcanvas-backdrop[data-v-14fc86fd]{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.offcanvas-backdrop.fade[data-v-14fc86fd]{opacity:0}.offcanvas-backdrop.show[data-v-14fc86fd]{opacity:.5}.offcanvas-header[data-v-14fc86fd]{display:flex;align-items:center;justify-content:space-between;padding:1rem}.offcanvas-header .btn-close[data-v-14fc86fd]{padding:.5rem;margin-top:-.5rem;margin-right:-.5rem;margin-bottom:-.5rem}.offcanvas-title[data-v-14fc86fd]{margin-bottom:0;line-height:1.5}.offcanvas-body[data-v-14fc86fd]{flex-grow:1;padding:1rem;overflow-y:auto}.offcanvas-start[data-v-14fc86fd]{top:0;left:0;width:400px;border-right:1px solid rgba(0,0,0,.2);transform:translateX(-100%)}.offcanvas-end[data-v-14fc86fd]{top:0;right:0;width:400px;border-left:1px solid rgba(0,0,0,.2);transform:translateX(100%)}.offcanvas-top[data-v-14fc86fd]{top:0;right:0;left:0;height:30vh;max-height:100%;border-bottom:1px solid rgba(0,0,0,.2);transform:translateY(-100%)}.offcanvas-bottom[data-v-14fc86fd]{right:0;left:0;height:30vh;max-height:100%;border-top:1px solid rgba(0,0,0,.2);transform:translateY(100%)}.offcanvas.show[data-v-14fc86fd]{transform:none}.placeholder[data-v-14fc86fd]{display:inline-block;min-height:1em;vertical-align:middle;cursor:wait;background-color:currentColor;opacity:.5}.placeholder.btn[data-v-14fc86fd]:before{display:inline-block;content:\"\"}.placeholder-xs[data-v-14fc86fd]{min-height:.6em}.placeholder-sm[data-v-14fc86fd]{min-height:.8em}.placeholder-lg[data-v-14fc86fd]{min-height:1.2em}.placeholder-glow .placeholder[data-v-14fc86fd]{-webkit-animation:placeholder-glow-data-v-14fc86fd 2s ease-in-out infinite;animation:placeholder-glow-data-v-14fc86fd 2s ease-in-out infinite}@-webkit-keyframes placeholder-glow-data-v-14fc86fd{50%{opacity:.2}}@keyframes placeholder-glow-data-v-14fc86fd{50%{opacity:.2}}.placeholder-wave[data-v-14fc86fd]{-webkit-mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);-webkit-mask-size:200% 100%;mask-size:200% 100%;-webkit-animation:placeholder-wave-data-v-14fc86fd 2s linear infinite;animation:placeholder-wave-data-v-14fc86fd 2s linear infinite}@-webkit-keyframes placeholder-wave-data-v-14fc86fd{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}@keyframes placeholder-wave-data-v-14fc86fd{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}.clearfix[data-v-14fc86fd]:after{display:block;clear:both;content:\"\"}.link-primary[data-v-14fc86fd]{color:#0d6efd}.link-primary[data-v-14fc86fd]:focus,.link-primary[data-v-14fc86fd]:hover{color:#0a58ca}.link-secondary[data-v-14fc86fd]{color:#6c757d}.link-secondary[data-v-14fc86fd]:focus,.link-secondary[data-v-14fc86fd]:hover{color:#565e64}.link-success[data-v-14fc86fd]{color:#198754}.link-success[data-v-14fc86fd]:focus,.link-success[data-v-14fc86fd]:hover{color:#146c43}.link-info[data-v-14fc86fd]{color:#0dcaf0}.link-info[data-v-14fc86fd]:focus,.link-info[data-v-14fc86fd]:hover{color:#3dd5f3}.link-warning[data-v-14fc86fd]{color:#ffc107}.link-warning[data-v-14fc86fd]:focus,.link-warning[data-v-14fc86fd]:hover{color:#ffcd39}.link-danger[data-v-14fc86fd]{color:#dc3545}.link-danger[data-v-14fc86fd]:focus,.link-danger[data-v-14fc86fd]:hover{color:#b02a37}.link-light[data-v-14fc86fd]{color:#f8f9fa}.link-light[data-v-14fc86fd]:focus,.link-light[data-v-14fc86fd]:hover{color:#f9fafb}.link-dark[data-v-14fc86fd]{color:#212529}.link-dark[data-v-14fc86fd]:focus,.link-dark[data-v-14fc86fd]:hover{color:#1a1e21}.ratio[data-v-14fc86fd]{position:relative;width:100%}.ratio[data-v-14fc86fd]:before{display:block;padding-top:var(--bs-aspect-ratio);content:\"\"}.ratio>[data-v-14fc86fd]{position:absolute;top:0;left:0;width:100%;height:100%}.ratio-1x1[data-v-14fc86fd]{--bs-aspect-ratio:100%}.ratio-4x3[data-v-14fc86fd]{--bs-aspect-ratio:75%}.ratio-16x9[data-v-14fc86fd]{--bs-aspect-ratio:56.25%}.ratio-21x9[data-v-14fc86fd]{--bs-aspect-ratio:42.8571428571%}.fixed-top[data-v-14fc86fd]{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom[data-v-14fc86fd]{position:fixed;right:0;bottom:0;left:0;z-index:1030}.sticky-top[data-v-14fc86fd]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}@media (min-width:576px){.sticky-sm-top[data-v-14fc86fd]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:768px){.sticky-md-top[data-v-14fc86fd]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:992px){.sticky-lg-top[data-v-14fc86fd]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1200px){.sticky-xl-top[data-v-14fc86fd]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1400px){.sticky-xxl-top[data-v-14fc86fd]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.hstack[data-v-14fc86fd]{display:flex;flex-direction:row;align-items:center;align-self:stretch}.vstack[data-v-14fc86fd]{display:flex;flex:1 1 auto;flex-direction:column;align-self:stretch}.visually-hidden-focusable[data-v-14fc86fd]:not(:focus):not(:focus-within),.visually-hidden[data-v-14fc86fd]{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}.stretched-link[data-v-14fc86fd]:after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;content:\"\"}.text-truncate[data-v-14fc86fd]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.vr[data-v-14fc86fd]{display:inline-block;align-self:stretch;width:1px;min-height:1em;background-color:currentColor;opacity:.25}.align-baseline[data-v-14fc86fd]{vertical-align:baseline!important}.align-top[data-v-14fc86fd]{vertical-align:top!important}.align-middle[data-v-14fc86fd]{vertical-align:middle!important}.align-bottom[data-v-14fc86fd]{vertical-align:bottom!important}.align-text-bottom[data-v-14fc86fd]{vertical-align:text-bottom!important}.align-text-top[data-v-14fc86fd]{vertical-align:text-top!important}.float-start[data-v-14fc86fd]{float:left!important}.float-end[data-v-14fc86fd]{float:right!important}.float-none[data-v-14fc86fd]{float:none!important}.opacity-0[data-v-14fc86fd]{opacity:0!important}.opacity-25[data-v-14fc86fd]{opacity:.25!important}.opacity-50[data-v-14fc86fd]{opacity:.5!important}.opacity-75[data-v-14fc86fd]{opacity:.75!important}.opacity-100[data-v-14fc86fd]{opacity:1!important}.overflow-auto[data-v-14fc86fd]{overflow:auto!important}.overflow-hidden[data-v-14fc86fd]{overflow:hidden!important}.overflow-visible[data-v-14fc86fd]{overflow:visible!important}.overflow-scroll[data-v-14fc86fd]{overflow:scroll!important}.d-inline[data-v-14fc86fd]{display:inline!important}.d-inline-block[data-v-14fc86fd]{display:inline-block!important}.d-block[data-v-14fc86fd]{display:block!important}.d-grid[data-v-14fc86fd]{display:grid!important}.d-table[data-v-14fc86fd]{display:table!important}.d-table-row[data-v-14fc86fd]{display:table-row!important}.d-table-cell[data-v-14fc86fd]{display:table-cell!important}.d-flex[data-v-14fc86fd]{display:flex!important}.d-inline-flex[data-v-14fc86fd]{display:inline-flex!important}.d-none[data-v-14fc86fd]{display:none!important}.shadow[data-v-14fc86fd]{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.shadow-sm[data-v-14fc86fd]{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.shadow-lg[data-v-14fc86fd]{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.shadow-none[data-v-14fc86fd]{box-shadow:none!important}.position-static[data-v-14fc86fd]{position:static!important}.position-relative[data-v-14fc86fd]{position:relative!important}.position-absolute[data-v-14fc86fd]{position:absolute!important}.position-fixed[data-v-14fc86fd]{position:fixed!important}.position-sticky[data-v-14fc86fd]{position:-webkit-sticky!important;position:sticky!important}.top-0[data-v-14fc86fd]{top:0!important}.top-50[data-v-14fc86fd]{top:50%!important}.top-100[data-v-14fc86fd]{top:100%!important}.bottom-0[data-v-14fc86fd]{bottom:0!important}.bottom-50[data-v-14fc86fd]{bottom:50%!important}.bottom-100[data-v-14fc86fd]{bottom:100%!important}.start-0[data-v-14fc86fd]{left:0!important}.start-50[data-v-14fc86fd]{left:50%!important}.start-100[data-v-14fc86fd]{left:100%!important}.end-0[data-v-14fc86fd]{right:0!important}.end-50[data-v-14fc86fd]{right:50%!important}.end-100[data-v-14fc86fd]{right:100%!important}.translate-middle[data-v-14fc86fd]{transform:translate(-50%,-50%)!important}.translate-middle-x[data-v-14fc86fd]{transform:translateX(-50%)!important}.translate-middle-y[data-v-14fc86fd]{transform:translateY(-50%)!important}.border[data-v-14fc86fd]{border:1px solid #dee2e6!important}.border-0[data-v-14fc86fd]{border:0!important}.border-top[data-v-14fc86fd]{border-top:1px solid #dee2e6!important}.border-top-0[data-v-14fc86fd]{border-top:0!important}.border-end[data-v-14fc86fd]{border-right:1px solid #dee2e6!important}.border-end-0[data-v-14fc86fd]{border-right:0!important}.border-bottom[data-v-14fc86fd]{border-bottom:1px solid #dee2e6!important}.border-bottom-0[data-v-14fc86fd]{border-bottom:0!important}.border-start[data-v-14fc86fd]{border-left:1px solid #dee2e6!important}.border-start-0[data-v-14fc86fd]{border-left:0!important}.border-primary[data-v-14fc86fd]{border-color:#0d6efd!important}.border-secondary[data-v-14fc86fd]{border-color:#6c757d!important}.border-success[data-v-14fc86fd]{border-color:#198754!important}.border-info[data-v-14fc86fd]{border-color:#0dcaf0!important}.border-warning[data-v-14fc86fd]{border-color:#ffc107!important}.border-danger[data-v-14fc86fd]{border-color:#dc3545!important}.border-light[data-v-14fc86fd]{border-color:#f8f9fa!important}.border-dark[data-v-14fc86fd]{border-color:#212529!important}.border-white[data-v-14fc86fd]{border-color:#fff!important}.border-1[data-v-14fc86fd]{border-width:1px!important}.border-2[data-v-14fc86fd]{border-width:2px!important}.border-3[data-v-14fc86fd]{border-width:3px!important}.border-4[data-v-14fc86fd]{border-width:4px!important}.border-5[data-v-14fc86fd]{border-width:5px!important}.w-25[data-v-14fc86fd]{width:25%!important}.w-50[data-v-14fc86fd]{width:50%!important}.w-75[data-v-14fc86fd]{width:75%!important}.w-100[data-v-14fc86fd]{width:100%!important}.w-auto[data-v-14fc86fd]{width:auto!important}.mw-100[data-v-14fc86fd]{max-width:100%!important}.vw-100[data-v-14fc86fd]{width:100vw!important}.min-vw-100[data-v-14fc86fd]{min-width:100vw!important}.h-25[data-v-14fc86fd]{height:25%!important}.h-50[data-v-14fc86fd]{height:50%!important}.h-75[data-v-14fc86fd]{height:75%!important}.h-100[data-v-14fc86fd]{height:100%!important}.h-auto[data-v-14fc86fd]{height:auto!important}.mh-100[data-v-14fc86fd]{max-height:100%!important}.vh-100[data-v-14fc86fd]{height:100vh!important}.min-vh-100[data-v-14fc86fd]{min-height:100vh!important}.flex-fill[data-v-14fc86fd]{flex:1 1 auto!important}.flex-row[data-v-14fc86fd]{flex-direction:row!important}.flex-column[data-v-14fc86fd]{flex-direction:column!important}.flex-row-reverse[data-v-14fc86fd]{flex-direction:row-reverse!important}.flex-column-reverse[data-v-14fc86fd]{flex-direction:column-reverse!important}.flex-grow-0[data-v-14fc86fd]{flex-grow:0!important}.flex-grow-1[data-v-14fc86fd]{flex-grow:1!important}.flex-shrink-0[data-v-14fc86fd]{flex-shrink:0!important}.flex-shrink-1[data-v-14fc86fd]{flex-shrink:1!important}.flex-wrap[data-v-14fc86fd]{flex-wrap:wrap!important}.flex-nowrap[data-v-14fc86fd]{flex-wrap:nowrap!important}.flex-wrap-reverse[data-v-14fc86fd]{flex-wrap:wrap-reverse!important}.gap-0[data-v-14fc86fd]{gap:0!important}.gap-1[data-v-14fc86fd]{gap:.25rem!important}.gap-2[data-v-14fc86fd]{gap:.5rem!important}.gap-3[data-v-14fc86fd]{gap:1rem!important}.gap-4[data-v-14fc86fd]{gap:1.5rem!important}.gap-5[data-v-14fc86fd]{gap:3rem!important}.justify-content-start[data-v-14fc86fd]{justify-content:flex-start!important}.justify-content-end[data-v-14fc86fd]{justify-content:flex-end!important}.justify-content-center[data-v-14fc86fd]{justify-content:center!important}.justify-content-between[data-v-14fc86fd]{justify-content:space-between!important}.justify-content-around[data-v-14fc86fd]{justify-content:space-around!important}.justify-content-evenly[data-v-14fc86fd]{justify-content:space-evenly!important}.align-items-start[data-v-14fc86fd]{align-items:flex-start!important}.align-items-end[data-v-14fc86fd]{align-items:flex-end!important}.align-items-center[data-v-14fc86fd]{align-items:center!important}.align-items-baseline[data-v-14fc86fd]{align-items:baseline!important}.align-items-stretch[data-v-14fc86fd]{align-items:stretch!important}.align-content-start[data-v-14fc86fd]{align-content:flex-start!important}.align-content-end[data-v-14fc86fd]{align-content:flex-end!important}.align-content-center[data-v-14fc86fd]{align-content:center!important}.align-content-between[data-v-14fc86fd]{align-content:space-between!important}.align-content-around[data-v-14fc86fd]{align-content:space-around!important}.align-content-stretch[data-v-14fc86fd]{align-content:stretch!important}.align-self-auto[data-v-14fc86fd]{align-self:auto!important}.align-self-start[data-v-14fc86fd]{align-self:flex-start!important}.align-self-end[data-v-14fc86fd]{align-self:flex-end!important}.align-self-center[data-v-14fc86fd]{align-self:center!important}.align-self-baseline[data-v-14fc86fd]{align-self:baseline!important}.align-self-stretch[data-v-14fc86fd]{align-self:stretch!important}.order-first[data-v-14fc86fd]{order:-1!important}.order-0[data-v-14fc86fd]{order:0!important}.order-1[data-v-14fc86fd]{order:1!important}.order-2[data-v-14fc86fd]{order:2!important}.order-3[data-v-14fc86fd]{order:3!important}.order-4[data-v-14fc86fd]{order:4!important}.order-5[data-v-14fc86fd]{order:5!important}.order-last[data-v-14fc86fd]{order:6!important}.m-0[data-v-14fc86fd]{margin:0!important}.m-1[data-v-14fc86fd]{margin:.25rem!important}.m-2[data-v-14fc86fd]{margin:.5rem!important}.m-3[data-v-14fc86fd]{margin:1rem!important}.m-4[data-v-14fc86fd]{margin:1.5rem!important}.m-5[data-v-14fc86fd]{margin:3rem!important}.m-auto[data-v-14fc86fd]{margin:auto!important}.mx-0[data-v-14fc86fd]{margin-right:0!important;margin-left:0!important}.mx-1[data-v-14fc86fd]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-2[data-v-14fc86fd]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-3[data-v-14fc86fd]{margin-right:1rem!important;margin-left:1rem!important}.mx-4[data-v-14fc86fd]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-5[data-v-14fc86fd]{margin-right:3rem!important;margin-left:3rem!important}.mx-auto[data-v-14fc86fd]{margin-right:auto!important;margin-left:auto!important}.my-0[data-v-14fc86fd]{margin-top:0!important;margin-bottom:0!important}.my-1[data-v-14fc86fd]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-2[data-v-14fc86fd]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-3[data-v-14fc86fd]{margin-top:1rem!important;margin-bottom:1rem!important}.my-4[data-v-14fc86fd]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-5[data-v-14fc86fd]{margin-top:3rem!important;margin-bottom:3rem!important}.my-auto[data-v-14fc86fd]{margin-top:auto!important;margin-bottom:auto!important}.mt-0[data-v-14fc86fd]{margin-top:0!important}.mt-1[data-v-14fc86fd]{margin-top:.25rem!important}.mt-2[data-v-14fc86fd]{margin-top:.5rem!important}.mt-3[data-v-14fc86fd]{margin-top:1rem!important}.mt-4[data-v-14fc86fd]{margin-top:1.5rem!important}.mt-5[data-v-14fc86fd]{margin-top:3rem!important}.mt-auto[data-v-14fc86fd]{margin-top:auto!important}.me-0[data-v-14fc86fd]{margin-right:0!important}.me-1[data-v-14fc86fd]{margin-right:.25rem!important}.me-2[data-v-14fc86fd]{margin-right:.5rem!important}.me-3[data-v-14fc86fd]{margin-right:1rem!important}.me-4[data-v-14fc86fd]{margin-right:1.5rem!important}.me-5[data-v-14fc86fd]{margin-right:3rem!important}.me-auto[data-v-14fc86fd]{margin-right:auto!important}.mb-0[data-v-14fc86fd]{margin-bottom:0!important}.mb-1[data-v-14fc86fd]{margin-bottom:.25rem!important}.mb-2[data-v-14fc86fd]{margin-bottom:.5rem!important}.mb-3[data-v-14fc86fd]{margin-bottom:1rem!important}.mb-4[data-v-14fc86fd]{margin-bottom:1.5rem!important}.mb-5[data-v-14fc86fd]{margin-bottom:3rem!important}.mb-auto[data-v-14fc86fd]{margin-bottom:auto!important}.ms-0[data-v-14fc86fd]{margin-left:0!important}.ms-1[data-v-14fc86fd]{margin-left:.25rem!important}.ms-2[data-v-14fc86fd]{margin-left:.5rem!important}.ms-3[data-v-14fc86fd]{margin-left:1rem!important}.ms-4[data-v-14fc86fd]{margin-left:1.5rem!important}.ms-5[data-v-14fc86fd]{margin-left:3rem!important}.ms-auto[data-v-14fc86fd]{margin-left:auto!important}.p-0[data-v-14fc86fd]{padding:0!important}.p-1[data-v-14fc86fd]{padding:.25rem!important}.p-2[data-v-14fc86fd]{padding:.5rem!important}.p-3[data-v-14fc86fd]{padding:1rem!important}.p-4[data-v-14fc86fd]{padding:1.5rem!important}.p-5[data-v-14fc86fd]{padding:3rem!important}.px-0[data-v-14fc86fd]{padding-right:0!important;padding-left:0!important}.px-1[data-v-14fc86fd]{padding-right:.25rem!important;padding-left:.25rem!important}.px-2[data-v-14fc86fd]{padding-right:.5rem!important;padding-left:.5rem!important}.px-3[data-v-14fc86fd]{padding-right:1rem!important;padding-left:1rem!important}.px-4[data-v-14fc86fd]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-5[data-v-14fc86fd]{padding-right:3rem!important;padding-left:3rem!important}.py-0[data-v-14fc86fd]{padding-top:0!important;padding-bottom:0!important}.py-1[data-v-14fc86fd]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-2[data-v-14fc86fd]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-3[data-v-14fc86fd]{padding-top:1rem!important;padding-bottom:1rem!important}.py-4[data-v-14fc86fd]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-5[data-v-14fc86fd]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-0[data-v-14fc86fd]{padding-top:0!important}.pt-1[data-v-14fc86fd]{padding-top:.25rem!important}.pt-2[data-v-14fc86fd]{padding-top:.5rem!important}.pt-3[data-v-14fc86fd]{padding-top:1rem!important}.pt-4[data-v-14fc86fd]{padding-top:1.5rem!important}.pt-5[data-v-14fc86fd]{padding-top:3rem!important}.pe-0[data-v-14fc86fd]{padding-right:0!important}.pe-1[data-v-14fc86fd]{padding-right:.25rem!important}.pe-2[data-v-14fc86fd]{padding-right:.5rem!important}.pe-3[data-v-14fc86fd]{padding-right:1rem!important}.pe-4[data-v-14fc86fd]{padding-right:1.5rem!important}.pe-5[data-v-14fc86fd]{padding-right:3rem!important}.pb-0[data-v-14fc86fd]{padding-bottom:0!important}.pb-1[data-v-14fc86fd]{padding-bottom:.25rem!important}.pb-2[data-v-14fc86fd]{padding-bottom:.5rem!important}.pb-3[data-v-14fc86fd]{padding-bottom:1rem!important}.pb-4[data-v-14fc86fd]{padding-bottom:1.5rem!important}.pb-5[data-v-14fc86fd]{padding-bottom:3rem!important}.ps-0[data-v-14fc86fd]{padding-left:0!important}.ps-1[data-v-14fc86fd]{padding-left:.25rem!important}.ps-2[data-v-14fc86fd]{padding-left:.5rem!important}.ps-3[data-v-14fc86fd]{padding-left:1rem!important}.ps-4[data-v-14fc86fd]{padding-left:1.5rem!important}.ps-5[data-v-14fc86fd]{padding-left:3rem!important}.font-monospace[data-v-14fc86fd]{font-family:var(--bs-font-monospace)!important}.fs-1[data-v-14fc86fd]{font-size:calc(1.375rem + 1.5vw)!important}.fs-2[data-v-14fc86fd]{font-size:calc(1.325rem + .9vw)!important}.fs-3[data-v-14fc86fd]{font-size:calc(1.3rem + .6vw)!important}.fs-4[data-v-14fc86fd]{font-size:calc(1.275rem + .3vw)!important}.fs-5[data-v-14fc86fd]{font-size:1.25rem!important}.fs-6[data-v-14fc86fd]{font-size:1rem!important}.fst-italic[data-v-14fc86fd]{font-style:italic!important}.fst-normal[data-v-14fc86fd]{font-style:normal!important}.fw-light[data-v-14fc86fd]{font-weight:300!important}.fw-lighter[data-v-14fc86fd]{font-weight:lighter!important}.fw-normal[data-v-14fc86fd]{font-weight:400!important}.fw-bold[data-v-14fc86fd]{font-weight:700!important}.fw-bolder[data-v-14fc86fd]{font-weight:bolder!important}.lh-1[data-v-14fc86fd]{line-height:1!important}.lh-sm[data-v-14fc86fd]{line-height:1.25!important}.lh-base[data-v-14fc86fd]{line-height:1.5!important}.lh-lg[data-v-14fc86fd]{line-height:2!important}.text-start[data-v-14fc86fd]{text-align:left!important}.text-end[data-v-14fc86fd]{text-align:right!important}.text-center[data-v-14fc86fd]{text-align:center!important}.text-decoration-none[data-v-14fc86fd]{text-decoration:none!important}.text-decoration-underline[data-v-14fc86fd]{text-decoration:underline!important}.text-decoration-line-through[data-v-14fc86fd]{text-decoration:line-through!important}.text-lowercase[data-v-14fc86fd]{text-transform:lowercase!important}.text-uppercase[data-v-14fc86fd]{text-transform:uppercase!important}.text-capitalize[data-v-14fc86fd]{text-transform:capitalize!important}.text-wrap[data-v-14fc86fd]{white-space:normal!important}.text-nowrap[data-v-14fc86fd]{white-space:nowrap!important}.text-break[data-v-14fc86fd]{word-wrap:break-word!important;word-break:break-word!important}.text-primary[data-v-14fc86fd]{--bs-text-opacity:1;color:rgba(var(--bs-primary-rgb),var(--bs-text-opacity))!important}.text-secondary[data-v-14fc86fd]{--bs-text-opacity:1;color:rgba(var(--bs-secondary-rgb),var(--bs-text-opacity))!important}.text-success[data-v-14fc86fd]{--bs-text-opacity:1;color:rgba(var(--bs-success-rgb),var(--bs-text-opacity))!important}.text-info[data-v-14fc86fd]{--bs-text-opacity:1;color:rgba(var(--bs-info-rgb),var(--bs-text-opacity))!important}.text-warning[data-v-14fc86fd]{--bs-text-opacity:1;color:rgba(var(--bs-warning-rgb),var(--bs-text-opacity))!important}.text-danger[data-v-14fc86fd]{--bs-text-opacity:1;color:rgba(var(--bs-danger-rgb),var(--bs-text-opacity))!important}.text-light[data-v-14fc86fd]{--bs-text-opacity:1;color:rgba(var(--bs-light-rgb),var(--bs-text-opacity))!important}.text-dark[data-v-14fc86fd]{--bs-text-opacity:1;color:rgba(var(--bs-dark-rgb),var(--bs-text-opacity))!important}.text-black[data-v-14fc86fd]{--bs-text-opacity:1;color:rgba(var(--bs-black-rgb),var(--bs-text-opacity))!important}.text-white[data-v-14fc86fd]{--bs-text-opacity:1;color:rgba(var(--bs-white-rgb),var(--bs-text-opacity))!important}.text-body[data-v-14fc86fd]{--bs-text-opacity:1;color:rgba(var(--bs-body-color-rgb),var(--bs-text-opacity))!important}.text-muted[data-v-14fc86fd]{--bs-text-opacity:1;color:#6c757d!important}.text-black-50[data-v-14fc86fd]{--bs-text-opacity:1;color:rgba(0,0,0,.5)!important}.text-white-50[data-v-14fc86fd]{--bs-text-opacity:1;color:hsla(0,0%,100%,.5)!important}.text-reset[data-v-14fc86fd]{--bs-text-opacity:1;color:inherit!important}.text-opacity-25[data-v-14fc86fd]{--bs-text-opacity:0.25}.text-opacity-50[data-v-14fc86fd]{--bs-text-opacity:0.5}.text-opacity-75[data-v-14fc86fd]{--bs-text-opacity:0.75}.text-opacity-100[data-v-14fc86fd]{--bs-text-opacity:1}.bg-primary[data-v-14fc86fd]{--bs-bg-opacity:1;background-color:rgba(var(--bs-primary-rgb),var(--bs-bg-opacity))!important}.bg-secondary[data-v-14fc86fd]{--bs-bg-opacity:1;background-color:rgba(var(--bs-secondary-rgb),var(--bs-bg-opacity))!important}.bg-success[data-v-14fc86fd]{--bs-bg-opacity:1;background-color:rgba(var(--bs-success-rgb),var(--bs-bg-opacity))!important}.bg-info[data-v-14fc86fd]{--bs-bg-opacity:1;background-color:rgba(var(--bs-info-rgb),var(--bs-bg-opacity))!important}.bg-warning[data-v-14fc86fd]{--bs-bg-opacity:1;background-color:rgba(var(--bs-warning-rgb),var(--bs-bg-opacity))!important}.bg-danger[data-v-14fc86fd]{--bs-bg-opacity:1;background-color:rgba(var(--bs-danger-rgb),var(--bs-bg-opacity))!important}.bg-light[data-v-14fc86fd]{--bs-bg-opacity:1;background-color:rgba(var(--bs-light-rgb),var(--bs-bg-opacity))!important}.bg-dark[data-v-14fc86fd]{--bs-bg-opacity:1;background-color:rgba(var(--bs-dark-rgb),var(--bs-bg-opacity))!important}.bg-black[data-v-14fc86fd]{--bs-bg-opacity:1;background-color:rgba(var(--bs-black-rgb),var(--bs-bg-opacity))!important}.bg-white[data-v-14fc86fd]{--bs-bg-opacity:1;background-color:rgba(var(--bs-white-rgb),var(--bs-bg-opacity))!important}.bg-body[data-v-14fc86fd]{--bs-bg-opacity:1;background-color:rgba(var(--bs-body-bg-rgb),var(--bs-bg-opacity))!important}.bg-transparent[data-v-14fc86fd]{--bs-bg-opacity:1;background-color:transparent!important}.bg-opacity-10[data-v-14fc86fd]{--bs-bg-opacity:0.1}.bg-opacity-25[data-v-14fc86fd]{--bs-bg-opacity:0.25}.bg-opacity-50[data-v-14fc86fd]{--bs-bg-opacity:0.5}.bg-opacity-75[data-v-14fc86fd]{--bs-bg-opacity:0.75}.bg-opacity-100[data-v-14fc86fd]{--bs-bg-opacity:1}.bg-gradient[data-v-14fc86fd]{background-image:var(--bs-gradient)!important}.user-select-all[data-v-14fc86fd]{-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.user-select-auto[data-v-14fc86fd]{-webkit-user-select:auto!important;-moz-user-select:auto!important;user-select:auto!important}.user-select-none[data-v-14fc86fd]{-webkit-user-select:none!important;-moz-user-select:none!important;user-select:none!important}.pe-none[data-v-14fc86fd]{pointer-events:none!important}.pe-auto[data-v-14fc86fd]{pointer-events:auto!important}.rounded[data-v-14fc86fd]{border-radius:.25rem!important}.rounded-0[data-v-14fc86fd]{border-radius:0!important}.rounded-1[data-v-14fc86fd]{border-radius:.2rem!important}.rounded-2[data-v-14fc86fd]{border-radius:.25rem!important}.rounded-3[data-v-14fc86fd]{border-radius:.3rem!important}.rounded-circle[data-v-14fc86fd]{border-radius:50%!important}.rounded-pill[data-v-14fc86fd]{border-radius:50rem!important}.rounded-top[data-v-14fc86fd]{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.rounded-end[data-v-14fc86fd]{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.rounded-bottom[data-v-14fc86fd]{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-start[data-v-14fc86fd]{border-bottom-left-radius:.25rem!important;border-top-left-radius:.25rem!important}.visible[data-v-14fc86fd]{visibility:visible!important}.invisible[data-v-14fc86fd]{visibility:hidden!important}@media (min-width:576px){.float-sm-start[data-v-14fc86fd]{float:left!important}.float-sm-end[data-v-14fc86fd]{float:right!important}.float-sm-none[data-v-14fc86fd]{float:none!important}.d-sm-inline[data-v-14fc86fd]{display:inline!important}.d-sm-inline-block[data-v-14fc86fd]{display:inline-block!important}.d-sm-block[data-v-14fc86fd]{display:block!important}.d-sm-grid[data-v-14fc86fd]{display:grid!important}.d-sm-table[data-v-14fc86fd]{display:table!important}.d-sm-table-row[data-v-14fc86fd]{display:table-row!important}.d-sm-table-cell[data-v-14fc86fd]{display:table-cell!important}.d-sm-flex[data-v-14fc86fd]{display:flex!important}.d-sm-inline-flex[data-v-14fc86fd]{display:inline-flex!important}.d-sm-none[data-v-14fc86fd]{display:none!important}.flex-sm-fill[data-v-14fc86fd]{flex:1 1 auto!important}.flex-sm-row[data-v-14fc86fd]{flex-direction:row!important}.flex-sm-column[data-v-14fc86fd]{flex-direction:column!important}.flex-sm-row-reverse[data-v-14fc86fd]{flex-direction:row-reverse!important}.flex-sm-column-reverse[data-v-14fc86fd]{flex-direction:column-reverse!important}.flex-sm-grow-0[data-v-14fc86fd]{flex-grow:0!important}.flex-sm-grow-1[data-v-14fc86fd]{flex-grow:1!important}.flex-sm-shrink-0[data-v-14fc86fd]{flex-shrink:0!important}.flex-sm-shrink-1[data-v-14fc86fd]{flex-shrink:1!important}.flex-sm-wrap[data-v-14fc86fd]{flex-wrap:wrap!important}.flex-sm-nowrap[data-v-14fc86fd]{flex-wrap:nowrap!important}.flex-sm-wrap-reverse[data-v-14fc86fd]{flex-wrap:wrap-reverse!important}.gap-sm-0[data-v-14fc86fd]{gap:0!important}.gap-sm-1[data-v-14fc86fd]{gap:.25rem!important}.gap-sm-2[data-v-14fc86fd]{gap:.5rem!important}.gap-sm-3[data-v-14fc86fd]{gap:1rem!important}.gap-sm-4[data-v-14fc86fd]{gap:1.5rem!important}.gap-sm-5[data-v-14fc86fd]{gap:3rem!important}.justify-content-sm-start[data-v-14fc86fd]{justify-content:flex-start!important}.justify-content-sm-end[data-v-14fc86fd]{justify-content:flex-end!important}.justify-content-sm-center[data-v-14fc86fd]{justify-content:center!important}.justify-content-sm-between[data-v-14fc86fd]{justify-content:space-between!important}.justify-content-sm-around[data-v-14fc86fd]{justify-content:space-around!important}.justify-content-sm-evenly[data-v-14fc86fd]{justify-content:space-evenly!important}.align-items-sm-start[data-v-14fc86fd]{align-items:flex-start!important}.align-items-sm-end[data-v-14fc86fd]{align-items:flex-end!important}.align-items-sm-center[data-v-14fc86fd]{align-items:center!important}.align-items-sm-baseline[data-v-14fc86fd]{align-items:baseline!important}.align-items-sm-stretch[data-v-14fc86fd]{align-items:stretch!important}.align-content-sm-start[data-v-14fc86fd]{align-content:flex-start!important}.align-content-sm-end[data-v-14fc86fd]{align-content:flex-end!important}.align-content-sm-center[data-v-14fc86fd]{align-content:center!important}.align-content-sm-between[data-v-14fc86fd]{align-content:space-between!important}.align-content-sm-around[data-v-14fc86fd]{align-content:space-around!important}.align-content-sm-stretch[data-v-14fc86fd]{align-content:stretch!important}.align-self-sm-auto[data-v-14fc86fd]{align-self:auto!important}.align-self-sm-start[data-v-14fc86fd]{align-self:flex-start!important}.align-self-sm-end[data-v-14fc86fd]{align-self:flex-end!important}.align-self-sm-center[data-v-14fc86fd]{align-self:center!important}.align-self-sm-baseline[data-v-14fc86fd]{align-self:baseline!important}.align-self-sm-stretch[data-v-14fc86fd]{align-self:stretch!important}.order-sm-first[data-v-14fc86fd]{order:-1!important}.order-sm-0[data-v-14fc86fd]{order:0!important}.order-sm-1[data-v-14fc86fd]{order:1!important}.order-sm-2[data-v-14fc86fd]{order:2!important}.order-sm-3[data-v-14fc86fd]{order:3!important}.order-sm-4[data-v-14fc86fd]{order:4!important}.order-sm-5[data-v-14fc86fd]{order:5!important}.order-sm-last[data-v-14fc86fd]{order:6!important}.m-sm-0[data-v-14fc86fd]{margin:0!important}.m-sm-1[data-v-14fc86fd]{margin:.25rem!important}.m-sm-2[data-v-14fc86fd]{margin:.5rem!important}.m-sm-3[data-v-14fc86fd]{margin:1rem!important}.m-sm-4[data-v-14fc86fd]{margin:1.5rem!important}.m-sm-5[data-v-14fc86fd]{margin:3rem!important}.m-sm-auto[data-v-14fc86fd]{margin:auto!important}.mx-sm-0[data-v-14fc86fd]{margin-right:0!important;margin-left:0!important}.mx-sm-1[data-v-14fc86fd]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-sm-2[data-v-14fc86fd]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-sm-3[data-v-14fc86fd]{margin-right:1rem!important;margin-left:1rem!important}.mx-sm-4[data-v-14fc86fd]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-sm-5[data-v-14fc86fd]{margin-right:3rem!important;margin-left:3rem!important}.mx-sm-auto[data-v-14fc86fd]{margin-right:auto!important;margin-left:auto!important}.my-sm-0[data-v-14fc86fd]{margin-top:0!important;margin-bottom:0!important}.my-sm-1[data-v-14fc86fd]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-sm-2[data-v-14fc86fd]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-sm-3[data-v-14fc86fd]{margin-top:1rem!important;margin-bottom:1rem!important}.my-sm-4[data-v-14fc86fd]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-sm-5[data-v-14fc86fd]{margin-top:3rem!important;margin-bottom:3rem!important}.my-sm-auto[data-v-14fc86fd]{margin-top:auto!important;margin-bottom:auto!important}.mt-sm-0[data-v-14fc86fd]{margin-top:0!important}.mt-sm-1[data-v-14fc86fd]{margin-top:.25rem!important}.mt-sm-2[data-v-14fc86fd]{margin-top:.5rem!important}.mt-sm-3[data-v-14fc86fd]{margin-top:1rem!important}.mt-sm-4[data-v-14fc86fd]{margin-top:1.5rem!important}.mt-sm-5[data-v-14fc86fd]{margin-top:3rem!important}.mt-sm-auto[data-v-14fc86fd]{margin-top:auto!important}.me-sm-0[data-v-14fc86fd]{margin-right:0!important}.me-sm-1[data-v-14fc86fd]{margin-right:.25rem!important}.me-sm-2[data-v-14fc86fd]{margin-right:.5rem!important}.me-sm-3[data-v-14fc86fd]{margin-right:1rem!important}.me-sm-4[data-v-14fc86fd]{margin-right:1.5rem!important}.me-sm-5[data-v-14fc86fd]{margin-right:3rem!important}.me-sm-auto[data-v-14fc86fd]{margin-right:auto!important}.mb-sm-0[data-v-14fc86fd]{margin-bottom:0!important}.mb-sm-1[data-v-14fc86fd]{margin-bottom:.25rem!important}.mb-sm-2[data-v-14fc86fd]{margin-bottom:.5rem!important}.mb-sm-3[data-v-14fc86fd]{margin-bottom:1rem!important}.mb-sm-4[data-v-14fc86fd]{margin-bottom:1.5rem!important}.mb-sm-5[data-v-14fc86fd]{margin-bottom:3rem!important}.mb-sm-auto[data-v-14fc86fd]{margin-bottom:auto!important}.ms-sm-0[data-v-14fc86fd]{margin-left:0!important}.ms-sm-1[data-v-14fc86fd]{margin-left:.25rem!important}.ms-sm-2[data-v-14fc86fd]{margin-left:.5rem!important}.ms-sm-3[data-v-14fc86fd]{margin-left:1rem!important}.ms-sm-4[data-v-14fc86fd]{margin-left:1.5rem!important}.ms-sm-5[data-v-14fc86fd]{margin-left:3rem!important}.ms-sm-auto[data-v-14fc86fd]{margin-left:auto!important}.p-sm-0[data-v-14fc86fd]{padding:0!important}.p-sm-1[data-v-14fc86fd]{padding:.25rem!important}.p-sm-2[data-v-14fc86fd]{padding:.5rem!important}.p-sm-3[data-v-14fc86fd]{padding:1rem!important}.p-sm-4[data-v-14fc86fd]{padding:1.5rem!important}.p-sm-5[data-v-14fc86fd]{padding:3rem!important}.px-sm-0[data-v-14fc86fd]{padding-right:0!important;padding-left:0!important}.px-sm-1[data-v-14fc86fd]{padding-right:.25rem!important;padding-left:.25rem!important}.px-sm-2[data-v-14fc86fd]{padding-right:.5rem!important;padding-left:.5rem!important}.px-sm-3[data-v-14fc86fd]{padding-right:1rem!important;padding-left:1rem!important}.px-sm-4[data-v-14fc86fd]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-sm-5[data-v-14fc86fd]{padding-right:3rem!important;padding-left:3rem!important}.py-sm-0[data-v-14fc86fd]{padding-top:0!important;padding-bottom:0!important}.py-sm-1[data-v-14fc86fd]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-sm-2[data-v-14fc86fd]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-sm-3[data-v-14fc86fd]{padding-top:1rem!important;padding-bottom:1rem!important}.py-sm-4[data-v-14fc86fd]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-sm-5[data-v-14fc86fd]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-sm-0[data-v-14fc86fd]{padding-top:0!important}.pt-sm-1[data-v-14fc86fd]{padding-top:.25rem!important}.pt-sm-2[data-v-14fc86fd]{padding-top:.5rem!important}.pt-sm-3[data-v-14fc86fd]{padding-top:1rem!important}.pt-sm-4[data-v-14fc86fd]{padding-top:1.5rem!important}.pt-sm-5[data-v-14fc86fd]{padding-top:3rem!important}.pe-sm-0[data-v-14fc86fd]{padding-right:0!important}.pe-sm-1[data-v-14fc86fd]{padding-right:.25rem!important}.pe-sm-2[data-v-14fc86fd]{padding-right:.5rem!important}.pe-sm-3[data-v-14fc86fd]{padding-right:1rem!important}.pe-sm-4[data-v-14fc86fd]{padding-right:1.5rem!important}.pe-sm-5[data-v-14fc86fd]{padding-right:3rem!important}.pb-sm-0[data-v-14fc86fd]{padding-bottom:0!important}.pb-sm-1[data-v-14fc86fd]{padding-bottom:.25rem!important}.pb-sm-2[data-v-14fc86fd]{padding-bottom:.5rem!important}.pb-sm-3[data-v-14fc86fd]{padding-bottom:1rem!important}.pb-sm-4[data-v-14fc86fd]{padding-bottom:1.5rem!important}.pb-sm-5[data-v-14fc86fd]{padding-bottom:3rem!important}.ps-sm-0[data-v-14fc86fd]{padding-left:0!important}.ps-sm-1[data-v-14fc86fd]{padding-left:.25rem!important}.ps-sm-2[data-v-14fc86fd]{padding-left:.5rem!important}.ps-sm-3[data-v-14fc86fd]{padding-left:1rem!important}.ps-sm-4[data-v-14fc86fd]{padding-left:1.5rem!important}.ps-sm-5[data-v-14fc86fd]{padding-left:3rem!important}.text-sm-start[data-v-14fc86fd]{text-align:left!important}.text-sm-end[data-v-14fc86fd]{text-align:right!important}.text-sm-center[data-v-14fc86fd]{text-align:center!important}}@media (min-width:768px){.float-md-start[data-v-14fc86fd]{float:left!important}.float-md-end[data-v-14fc86fd]{float:right!important}.float-md-none[data-v-14fc86fd]{float:none!important}.d-md-inline[data-v-14fc86fd]{display:inline!important}.d-md-inline-block[data-v-14fc86fd]{display:inline-block!important}.d-md-block[data-v-14fc86fd]{display:block!important}.d-md-grid[data-v-14fc86fd]{display:grid!important}.d-md-table[data-v-14fc86fd]{display:table!important}.d-md-table-row[data-v-14fc86fd]{display:table-row!important}.d-md-table-cell[data-v-14fc86fd]{display:table-cell!important}.d-md-flex[data-v-14fc86fd]{display:flex!important}.d-md-inline-flex[data-v-14fc86fd]{display:inline-flex!important}.d-md-none[data-v-14fc86fd]{display:none!important}.flex-md-fill[data-v-14fc86fd]{flex:1 1 auto!important}.flex-md-row[data-v-14fc86fd]{flex-direction:row!important}.flex-md-column[data-v-14fc86fd]{flex-direction:column!important}.flex-md-row-reverse[data-v-14fc86fd]{flex-direction:row-reverse!important}.flex-md-column-reverse[data-v-14fc86fd]{flex-direction:column-reverse!important}.flex-md-grow-0[data-v-14fc86fd]{flex-grow:0!important}.flex-md-grow-1[data-v-14fc86fd]{flex-grow:1!important}.flex-md-shrink-0[data-v-14fc86fd]{flex-shrink:0!important}.flex-md-shrink-1[data-v-14fc86fd]{flex-shrink:1!important}.flex-md-wrap[data-v-14fc86fd]{flex-wrap:wrap!important}.flex-md-nowrap[data-v-14fc86fd]{flex-wrap:nowrap!important}.flex-md-wrap-reverse[data-v-14fc86fd]{flex-wrap:wrap-reverse!important}.gap-md-0[data-v-14fc86fd]{gap:0!important}.gap-md-1[data-v-14fc86fd]{gap:.25rem!important}.gap-md-2[data-v-14fc86fd]{gap:.5rem!important}.gap-md-3[data-v-14fc86fd]{gap:1rem!important}.gap-md-4[data-v-14fc86fd]{gap:1.5rem!important}.gap-md-5[data-v-14fc86fd]{gap:3rem!important}.justify-content-md-start[data-v-14fc86fd]{justify-content:flex-start!important}.justify-content-md-end[data-v-14fc86fd]{justify-content:flex-end!important}.justify-content-md-center[data-v-14fc86fd]{justify-content:center!important}.justify-content-md-between[data-v-14fc86fd]{justify-content:space-between!important}.justify-content-md-around[data-v-14fc86fd]{justify-content:space-around!important}.justify-content-md-evenly[data-v-14fc86fd]{justify-content:space-evenly!important}.align-items-md-start[data-v-14fc86fd]{align-items:flex-start!important}.align-items-md-end[data-v-14fc86fd]{align-items:flex-end!important}.align-items-md-center[data-v-14fc86fd]{align-items:center!important}.align-items-md-baseline[data-v-14fc86fd]{align-items:baseline!important}.align-items-md-stretch[data-v-14fc86fd]{align-items:stretch!important}.align-content-md-start[data-v-14fc86fd]{align-content:flex-start!important}.align-content-md-end[data-v-14fc86fd]{align-content:flex-end!important}.align-content-md-center[data-v-14fc86fd]{align-content:center!important}.align-content-md-between[data-v-14fc86fd]{align-content:space-between!important}.align-content-md-around[data-v-14fc86fd]{align-content:space-around!important}.align-content-md-stretch[data-v-14fc86fd]{align-content:stretch!important}.align-self-md-auto[data-v-14fc86fd]{align-self:auto!important}.align-self-md-start[data-v-14fc86fd]{align-self:flex-start!important}.align-self-md-end[data-v-14fc86fd]{align-self:flex-end!important}.align-self-md-center[data-v-14fc86fd]{align-self:center!important}.align-self-md-baseline[data-v-14fc86fd]{align-self:baseline!important}.align-self-md-stretch[data-v-14fc86fd]{align-self:stretch!important}.order-md-first[data-v-14fc86fd]{order:-1!important}.order-md-0[data-v-14fc86fd]{order:0!important}.order-md-1[data-v-14fc86fd]{order:1!important}.order-md-2[data-v-14fc86fd]{order:2!important}.order-md-3[data-v-14fc86fd]{order:3!important}.order-md-4[data-v-14fc86fd]{order:4!important}.order-md-5[data-v-14fc86fd]{order:5!important}.order-md-last[data-v-14fc86fd]{order:6!important}.m-md-0[data-v-14fc86fd]{margin:0!important}.m-md-1[data-v-14fc86fd]{margin:.25rem!important}.m-md-2[data-v-14fc86fd]{margin:.5rem!important}.m-md-3[data-v-14fc86fd]{margin:1rem!important}.m-md-4[data-v-14fc86fd]{margin:1.5rem!important}.m-md-5[data-v-14fc86fd]{margin:3rem!important}.m-md-auto[data-v-14fc86fd]{margin:auto!important}.mx-md-0[data-v-14fc86fd]{margin-right:0!important;margin-left:0!important}.mx-md-1[data-v-14fc86fd]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-md-2[data-v-14fc86fd]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-md-3[data-v-14fc86fd]{margin-right:1rem!important;margin-left:1rem!important}.mx-md-4[data-v-14fc86fd]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-md-5[data-v-14fc86fd]{margin-right:3rem!important;margin-left:3rem!important}.mx-md-auto[data-v-14fc86fd]{margin-right:auto!important;margin-left:auto!important}.my-md-0[data-v-14fc86fd]{margin-top:0!important;margin-bottom:0!important}.my-md-1[data-v-14fc86fd]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-md-2[data-v-14fc86fd]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-md-3[data-v-14fc86fd]{margin-top:1rem!important;margin-bottom:1rem!important}.my-md-4[data-v-14fc86fd]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-md-5[data-v-14fc86fd]{margin-top:3rem!important;margin-bottom:3rem!important}.my-md-auto[data-v-14fc86fd]{margin-top:auto!important;margin-bottom:auto!important}.mt-md-0[data-v-14fc86fd]{margin-top:0!important}.mt-md-1[data-v-14fc86fd]{margin-top:.25rem!important}.mt-md-2[data-v-14fc86fd]{margin-top:.5rem!important}.mt-md-3[data-v-14fc86fd]{margin-top:1rem!important}.mt-md-4[data-v-14fc86fd]{margin-top:1.5rem!important}.mt-md-5[data-v-14fc86fd]{margin-top:3rem!important}.mt-md-auto[data-v-14fc86fd]{margin-top:auto!important}.me-md-0[data-v-14fc86fd]{margin-right:0!important}.me-md-1[data-v-14fc86fd]{margin-right:.25rem!important}.me-md-2[data-v-14fc86fd]{margin-right:.5rem!important}.me-md-3[data-v-14fc86fd]{margin-right:1rem!important}.me-md-4[data-v-14fc86fd]{margin-right:1.5rem!important}.me-md-5[data-v-14fc86fd]{margin-right:3rem!important}.me-md-auto[data-v-14fc86fd]{margin-right:auto!important}.mb-md-0[data-v-14fc86fd]{margin-bottom:0!important}.mb-md-1[data-v-14fc86fd]{margin-bottom:.25rem!important}.mb-md-2[data-v-14fc86fd]{margin-bottom:.5rem!important}.mb-md-3[data-v-14fc86fd]{margin-bottom:1rem!important}.mb-md-4[data-v-14fc86fd]{margin-bottom:1.5rem!important}.mb-md-5[data-v-14fc86fd]{margin-bottom:3rem!important}.mb-md-auto[data-v-14fc86fd]{margin-bottom:auto!important}.ms-md-0[data-v-14fc86fd]{margin-left:0!important}.ms-md-1[data-v-14fc86fd]{margin-left:.25rem!important}.ms-md-2[data-v-14fc86fd]{margin-left:.5rem!important}.ms-md-3[data-v-14fc86fd]{margin-left:1rem!important}.ms-md-4[data-v-14fc86fd]{margin-left:1.5rem!important}.ms-md-5[data-v-14fc86fd]{margin-left:3rem!important}.ms-md-auto[data-v-14fc86fd]{margin-left:auto!important}.p-md-0[data-v-14fc86fd]{padding:0!important}.p-md-1[data-v-14fc86fd]{padding:.25rem!important}.p-md-2[data-v-14fc86fd]{padding:.5rem!important}.p-md-3[data-v-14fc86fd]{padding:1rem!important}.p-md-4[data-v-14fc86fd]{padding:1.5rem!important}.p-md-5[data-v-14fc86fd]{padding:3rem!important}.px-md-0[data-v-14fc86fd]{padding-right:0!important;padding-left:0!important}.px-md-1[data-v-14fc86fd]{padding-right:.25rem!important;padding-left:.25rem!important}.px-md-2[data-v-14fc86fd]{padding-right:.5rem!important;padding-left:.5rem!important}.px-md-3[data-v-14fc86fd]{padding-right:1rem!important;padding-left:1rem!important}.px-md-4[data-v-14fc86fd]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-md-5[data-v-14fc86fd]{padding-right:3rem!important;padding-left:3rem!important}.py-md-0[data-v-14fc86fd]{padding-top:0!important;padding-bottom:0!important}.py-md-1[data-v-14fc86fd]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-md-2[data-v-14fc86fd]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-md-3[data-v-14fc86fd]{padding-top:1rem!important;padding-bottom:1rem!important}.py-md-4[data-v-14fc86fd]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-md-5[data-v-14fc86fd]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-md-0[data-v-14fc86fd]{padding-top:0!important}.pt-md-1[data-v-14fc86fd]{padding-top:.25rem!important}.pt-md-2[data-v-14fc86fd]{padding-top:.5rem!important}.pt-md-3[data-v-14fc86fd]{padding-top:1rem!important}.pt-md-4[data-v-14fc86fd]{padding-top:1.5rem!important}.pt-md-5[data-v-14fc86fd]{padding-top:3rem!important}.pe-md-0[data-v-14fc86fd]{padding-right:0!important}.pe-md-1[data-v-14fc86fd]{padding-right:.25rem!important}.pe-md-2[data-v-14fc86fd]{padding-right:.5rem!important}.pe-md-3[data-v-14fc86fd]{padding-right:1rem!important}.pe-md-4[data-v-14fc86fd]{padding-right:1.5rem!important}.pe-md-5[data-v-14fc86fd]{padding-right:3rem!important}.pb-md-0[data-v-14fc86fd]{padding-bottom:0!important}.pb-md-1[data-v-14fc86fd]{padding-bottom:.25rem!important}.pb-md-2[data-v-14fc86fd]{padding-bottom:.5rem!important}.pb-md-3[data-v-14fc86fd]{padding-bottom:1rem!important}.pb-md-4[data-v-14fc86fd]{padding-bottom:1.5rem!important}.pb-md-5[data-v-14fc86fd]{padding-bottom:3rem!important}.ps-md-0[data-v-14fc86fd]{padding-left:0!important}.ps-md-1[data-v-14fc86fd]{padding-left:.25rem!important}.ps-md-2[data-v-14fc86fd]{padding-left:.5rem!important}.ps-md-3[data-v-14fc86fd]{padding-left:1rem!important}.ps-md-4[data-v-14fc86fd]{padding-left:1.5rem!important}.ps-md-5[data-v-14fc86fd]{padding-left:3rem!important}.text-md-start[data-v-14fc86fd]{text-align:left!important}.text-md-end[data-v-14fc86fd]{text-align:right!important}.text-md-center[data-v-14fc86fd]{text-align:center!important}}@media (min-width:992px){.float-lg-start[data-v-14fc86fd]{float:left!important}.float-lg-end[data-v-14fc86fd]{float:right!important}.float-lg-none[data-v-14fc86fd]{float:none!important}.d-lg-inline[data-v-14fc86fd]{display:inline!important}.d-lg-inline-block[data-v-14fc86fd]{display:inline-block!important}.d-lg-block[data-v-14fc86fd]{display:block!important}.d-lg-grid[data-v-14fc86fd]{display:grid!important}.d-lg-table[data-v-14fc86fd]{display:table!important}.d-lg-table-row[data-v-14fc86fd]{display:table-row!important}.d-lg-table-cell[data-v-14fc86fd]{display:table-cell!important}.d-lg-flex[data-v-14fc86fd]{display:flex!important}.d-lg-inline-flex[data-v-14fc86fd]{display:inline-flex!important}.d-lg-none[data-v-14fc86fd]{display:none!important}.flex-lg-fill[data-v-14fc86fd]{flex:1 1 auto!important}.flex-lg-row[data-v-14fc86fd]{flex-direction:row!important}.flex-lg-column[data-v-14fc86fd]{flex-direction:column!important}.flex-lg-row-reverse[data-v-14fc86fd]{flex-direction:row-reverse!important}.flex-lg-column-reverse[data-v-14fc86fd]{flex-direction:column-reverse!important}.flex-lg-grow-0[data-v-14fc86fd]{flex-grow:0!important}.flex-lg-grow-1[data-v-14fc86fd]{flex-grow:1!important}.flex-lg-shrink-0[data-v-14fc86fd]{flex-shrink:0!important}.flex-lg-shrink-1[data-v-14fc86fd]{flex-shrink:1!important}.flex-lg-wrap[data-v-14fc86fd]{flex-wrap:wrap!important}.flex-lg-nowrap[data-v-14fc86fd]{flex-wrap:nowrap!important}.flex-lg-wrap-reverse[data-v-14fc86fd]{flex-wrap:wrap-reverse!important}.gap-lg-0[data-v-14fc86fd]{gap:0!important}.gap-lg-1[data-v-14fc86fd]{gap:.25rem!important}.gap-lg-2[data-v-14fc86fd]{gap:.5rem!important}.gap-lg-3[data-v-14fc86fd]{gap:1rem!important}.gap-lg-4[data-v-14fc86fd]{gap:1.5rem!important}.gap-lg-5[data-v-14fc86fd]{gap:3rem!important}.justify-content-lg-start[data-v-14fc86fd]{justify-content:flex-start!important}.justify-content-lg-end[data-v-14fc86fd]{justify-content:flex-end!important}.justify-content-lg-center[data-v-14fc86fd]{justify-content:center!important}.justify-content-lg-between[data-v-14fc86fd]{justify-content:space-between!important}.justify-content-lg-around[data-v-14fc86fd]{justify-content:space-around!important}.justify-content-lg-evenly[data-v-14fc86fd]{justify-content:space-evenly!important}.align-items-lg-start[data-v-14fc86fd]{align-items:flex-start!important}.align-items-lg-end[data-v-14fc86fd]{align-items:flex-end!important}.align-items-lg-center[data-v-14fc86fd]{align-items:center!important}.align-items-lg-baseline[data-v-14fc86fd]{align-items:baseline!important}.align-items-lg-stretch[data-v-14fc86fd]{align-items:stretch!important}.align-content-lg-start[data-v-14fc86fd]{align-content:flex-start!important}.align-content-lg-end[data-v-14fc86fd]{align-content:flex-end!important}.align-content-lg-center[data-v-14fc86fd]{align-content:center!important}.align-content-lg-between[data-v-14fc86fd]{align-content:space-between!important}.align-content-lg-around[data-v-14fc86fd]{align-content:space-around!important}.align-content-lg-stretch[data-v-14fc86fd]{align-content:stretch!important}.align-self-lg-auto[data-v-14fc86fd]{align-self:auto!important}.align-self-lg-start[data-v-14fc86fd]{align-self:flex-start!important}.align-self-lg-end[data-v-14fc86fd]{align-self:flex-end!important}.align-self-lg-center[data-v-14fc86fd]{align-self:center!important}.align-self-lg-baseline[data-v-14fc86fd]{align-self:baseline!important}.align-self-lg-stretch[data-v-14fc86fd]{align-self:stretch!important}.order-lg-first[data-v-14fc86fd]{order:-1!important}.order-lg-0[data-v-14fc86fd]{order:0!important}.order-lg-1[data-v-14fc86fd]{order:1!important}.order-lg-2[data-v-14fc86fd]{order:2!important}.order-lg-3[data-v-14fc86fd]{order:3!important}.order-lg-4[data-v-14fc86fd]{order:4!important}.order-lg-5[data-v-14fc86fd]{order:5!important}.order-lg-last[data-v-14fc86fd]{order:6!important}.m-lg-0[data-v-14fc86fd]{margin:0!important}.m-lg-1[data-v-14fc86fd]{margin:.25rem!important}.m-lg-2[data-v-14fc86fd]{margin:.5rem!important}.m-lg-3[data-v-14fc86fd]{margin:1rem!important}.m-lg-4[data-v-14fc86fd]{margin:1.5rem!important}.m-lg-5[data-v-14fc86fd]{margin:3rem!important}.m-lg-auto[data-v-14fc86fd]{margin:auto!important}.mx-lg-0[data-v-14fc86fd]{margin-right:0!important;margin-left:0!important}.mx-lg-1[data-v-14fc86fd]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-lg-2[data-v-14fc86fd]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-lg-3[data-v-14fc86fd]{margin-right:1rem!important;margin-left:1rem!important}.mx-lg-4[data-v-14fc86fd]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-lg-5[data-v-14fc86fd]{margin-right:3rem!important;margin-left:3rem!important}.mx-lg-auto[data-v-14fc86fd]{margin-right:auto!important;margin-left:auto!important}.my-lg-0[data-v-14fc86fd]{margin-top:0!important;margin-bottom:0!important}.my-lg-1[data-v-14fc86fd]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-lg-2[data-v-14fc86fd]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-lg-3[data-v-14fc86fd]{margin-top:1rem!important;margin-bottom:1rem!important}.my-lg-4[data-v-14fc86fd]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-lg-5[data-v-14fc86fd]{margin-top:3rem!important;margin-bottom:3rem!important}.my-lg-auto[data-v-14fc86fd]{margin-top:auto!important;margin-bottom:auto!important}.mt-lg-0[data-v-14fc86fd]{margin-top:0!important}.mt-lg-1[data-v-14fc86fd]{margin-top:.25rem!important}.mt-lg-2[data-v-14fc86fd]{margin-top:.5rem!important}.mt-lg-3[data-v-14fc86fd]{margin-top:1rem!important}.mt-lg-4[data-v-14fc86fd]{margin-top:1.5rem!important}.mt-lg-5[data-v-14fc86fd]{margin-top:3rem!important}.mt-lg-auto[data-v-14fc86fd]{margin-top:auto!important}.me-lg-0[data-v-14fc86fd]{margin-right:0!important}.me-lg-1[data-v-14fc86fd]{margin-right:.25rem!important}.me-lg-2[data-v-14fc86fd]{margin-right:.5rem!important}.me-lg-3[data-v-14fc86fd]{margin-right:1rem!important}.me-lg-4[data-v-14fc86fd]{margin-right:1.5rem!important}.me-lg-5[data-v-14fc86fd]{margin-right:3rem!important}.me-lg-auto[data-v-14fc86fd]{margin-right:auto!important}.mb-lg-0[data-v-14fc86fd]{margin-bottom:0!important}.mb-lg-1[data-v-14fc86fd]{margin-bottom:.25rem!important}.mb-lg-2[data-v-14fc86fd]{margin-bottom:.5rem!important}.mb-lg-3[data-v-14fc86fd]{margin-bottom:1rem!important}.mb-lg-4[data-v-14fc86fd]{margin-bottom:1.5rem!important}.mb-lg-5[data-v-14fc86fd]{margin-bottom:3rem!important}.mb-lg-auto[data-v-14fc86fd]{margin-bottom:auto!important}.ms-lg-0[data-v-14fc86fd]{margin-left:0!important}.ms-lg-1[data-v-14fc86fd]{margin-left:.25rem!important}.ms-lg-2[data-v-14fc86fd]{margin-left:.5rem!important}.ms-lg-3[data-v-14fc86fd]{margin-left:1rem!important}.ms-lg-4[data-v-14fc86fd]{margin-left:1.5rem!important}.ms-lg-5[data-v-14fc86fd]{margin-left:3rem!important}.ms-lg-auto[data-v-14fc86fd]{margin-left:auto!important}.p-lg-0[data-v-14fc86fd]{padding:0!important}.p-lg-1[data-v-14fc86fd]{padding:.25rem!important}.p-lg-2[data-v-14fc86fd]{padding:.5rem!important}.p-lg-3[data-v-14fc86fd]{padding:1rem!important}.p-lg-4[data-v-14fc86fd]{padding:1.5rem!important}.p-lg-5[data-v-14fc86fd]{padding:3rem!important}.px-lg-0[data-v-14fc86fd]{padding-right:0!important;padding-left:0!important}.px-lg-1[data-v-14fc86fd]{padding-right:.25rem!important;padding-left:.25rem!important}.px-lg-2[data-v-14fc86fd]{padding-right:.5rem!important;padding-left:.5rem!important}.px-lg-3[data-v-14fc86fd]{padding-right:1rem!important;padding-left:1rem!important}.px-lg-4[data-v-14fc86fd]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-lg-5[data-v-14fc86fd]{padding-right:3rem!important;padding-left:3rem!important}.py-lg-0[data-v-14fc86fd]{padding-top:0!important;padding-bottom:0!important}.py-lg-1[data-v-14fc86fd]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-lg-2[data-v-14fc86fd]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-lg-3[data-v-14fc86fd]{padding-top:1rem!important;padding-bottom:1rem!important}.py-lg-4[data-v-14fc86fd]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-lg-5[data-v-14fc86fd]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-lg-0[data-v-14fc86fd]{padding-top:0!important}.pt-lg-1[data-v-14fc86fd]{padding-top:.25rem!important}.pt-lg-2[data-v-14fc86fd]{padding-top:.5rem!important}.pt-lg-3[data-v-14fc86fd]{padding-top:1rem!important}.pt-lg-4[data-v-14fc86fd]{padding-top:1.5rem!important}.pt-lg-5[data-v-14fc86fd]{padding-top:3rem!important}.pe-lg-0[data-v-14fc86fd]{padding-right:0!important}.pe-lg-1[data-v-14fc86fd]{padding-right:.25rem!important}.pe-lg-2[data-v-14fc86fd]{padding-right:.5rem!important}.pe-lg-3[data-v-14fc86fd]{padding-right:1rem!important}.pe-lg-4[data-v-14fc86fd]{padding-right:1.5rem!important}.pe-lg-5[data-v-14fc86fd]{padding-right:3rem!important}.pb-lg-0[data-v-14fc86fd]{padding-bottom:0!important}.pb-lg-1[data-v-14fc86fd]{padding-bottom:.25rem!important}.pb-lg-2[data-v-14fc86fd]{padding-bottom:.5rem!important}.pb-lg-3[data-v-14fc86fd]{padding-bottom:1rem!important}.pb-lg-4[data-v-14fc86fd]{padding-bottom:1.5rem!important}.pb-lg-5[data-v-14fc86fd]{padding-bottom:3rem!important}.ps-lg-0[data-v-14fc86fd]{padding-left:0!important}.ps-lg-1[data-v-14fc86fd]{padding-left:.25rem!important}.ps-lg-2[data-v-14fc86fd]{padding-left:.5rem!important}.ps-lg-3[data-v-14fc86fd]{padding-left:1rem!important}.ps-lg-4[data-v-14fc86fd]{padding-left:1.5rem!important}.ps-lg-5[data-v-14fc86fd]{padding-left:3rem!important}.text-lg-start[data-v-14fc86fd]{text-align:left!important}.text-lg-end[data-v-14fc86fd]{text-align:right!important}.text-lg-center[data-v-14fc86fd]{text-align:center!important}}@media (min-width:1200px){.float-xl-start[data-v-14fc86fd]{float:left!important}.float-xl-end[data-v-14fc86fd]{float:right!important}.float-xl-none[data-v-14fc86fd]{float:none!important}.d-xl-inline[data-v-14fc86fd]{display:inline!important}.d-xl-inline-block[data-v-14fc86fd]{display:inline-block!important}.d-xl-block[data-v-14fc86fd]{display:block!important}.d-xl-grid[data-v-14fc86fd]{display:grid!important}.d-xl-table[data-v-14fc86fd]{display:table!important}.d-xl-table-row[data-v-14fc86fd]{display:table-row!important}.d-xl-table-cell[data-v-14fc86fd]{display:table-cell!important}.d-xl-flex[data-v-14fc86fd]{display:flex!important}.d-xl-inline-flex[data-v-14fc86fd]{display:inline-flex!important}.d-xl-none[data-v-14fc86fd]{display:none!important}.flex-xl-fill[data-v-14fc86fd]{flex:1 1 auto!important}.flex-xl-row[data-v-14fc86fd]{flex-direction:row!important}.flex-xl-column[data-v-14fc86fd]{flex-direction:column!important}.flex-xl-row-reverse[data-v-14fc86fd]{flex-direction:row-reverse!important}.flex-xl-column-reverse[data-v-14fc86fd]{flex-direction:column-reverse!important}.flex-xl-grow-0[data-v-14fc86fd]{flex-grow:0!important}.flex-xl-grow-1[data-v-14fc86fd]{flex-grow:1!important}.flex-xl-shrink-0[data-v-14fc86fd]{flex-shrink:0!important}.flex-xl-shrink-1[data-v-14fc86fd]{flex-shrink:1!important}.flex-xl-wrap[data-v-14fc86fd]{flex-wrap:wrap!important}.flex-xl-nowrap[data-v-14fc86fd]{flex-wrap:nowrap!important}.flex-xl-wrap-reverse[data-v-14fc86fd]{flex-wrap:wrap-reverse!important}.gap-xl-0[data-v-14fc86fd]{gap:0!important}.gap-xl-1[data-v-14fc86fd]{gap:.25rem!important}.gap-xl-2[data-v-14fc86fd]{gap:.5rem!important}.gap-xl-3[data-v-14fc86fd]{gap:1rem!important}.gap-xl-4[data-v-14fc86fd]{gap:1.5rem!important}.gap-xl-5[data-v-14fc86fd]{gap:3rem!important}.justify-content-xl-start[data-v-14fc86fd]{justify-content:flex-start!important}.justify-content-xl-end[data-v-14fc86fd]{justify-content:flex-end!important}.justify-content-xl-center[data-v-14fc86fd]{justify-content:center!important}.justify-content-xl-between[data-v-14fc86fd]{justify-content:space-between!important}.justify-content-xl-around[data-v-14fc86fd]{justify-content:space-around!important}.justify-content-xl-evenly[data-v-14fc86fd]{justify-content:space-evenly!important}.align-items-xl-start[data-v-14fc86fd]{align-items:flex-start!important}.align-items-xl-end[data-v-14fc86fd]{align-items:flex-end!important}.align-items-xl-center[data-v-14fc86fd]{align-items:center!important}.align-items-xl-baseline[data-v-14fc86fd]{align-items:baseline!important}.align-items-xl-stretch[data-v-14fc86fd]{align-items:stretch!important}.align-content-xl-start[data-v-14fc86fd]{align-content:flex-start!important}.align-content-xl-end[data-v-14fc86fd]{align-content:flex-end!important}.align-content-xl-center[data-v-14fc86fd]{align-content:center!important}.align-content-xl-between[data-v-14fc86fd]{align-content:space-between!important}.align-content-xl-around[data-v-14fc86fd]{align-content:space-around!important}.align-content-xl-stretch[data-v-14fc86fd]{align-content:stretch!important}.align-self-xl-auto[data-v-14fc86fd]{align-self:auto!important}.align-self-xl-start[data-v-14fc86fd]{align-self:flex-start!important}.align-self-xl-end[data-v-14fc86fd]{align-self:flex-end!important}.align-self-xl-center[data-v-14fc86fd]{align-self:center!important}.align-self-xl-baseline[data-v-14fc86fd]{align-self:baseline!important}.align-self-xl-stretch[data-v-14fc86fd]{align-self:stretch!important}.order-xl-first[data-v-14fc86fd]{order:-1!important}.order-xl-0[data-v-14fc86fd]{order:0!important}.order-xl-1[data-v-14fc86fd]{order:1!important}.order-xl-2[data-v-14fc86fd]{order:2!important}.order-xl-3[data-v-14fc86fd]{order:3!important}.order-xl-4[data-v-14fc86fd]{order:4!important}.order-xl-5[data-v-14fc86fd]{order:5!important}.order-xl-last[data-v-14fc86fd]{order:6!important}.m-xl-0[data-v-14fc86fd]{margin:0!important}.m-xl-1[data-v-14fc86fd]{margin:.25rem!important}.m-xl-2[data-v-14fc86fd]{margin:.5rem!important}.m-xl-3[data-v-14fc86fd]{margin:1rem!important}.m-xl-4[data-v-14fc86fd]{margin:1.5rem!important}.m-xl-5[data-v-14fc86fd]{margin:3rem!important}.m-xl-auto[data-v-14fc86fd]{margin:auto!important}.mx-xl-0[data-v-14fc86fd]{margin-right:0!important;margin-left:0!important}.mx-xl-1[data-v-14fc86fd]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xl-2[data-v-14fc86fd]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xl-3[data-v-14fc86fd]{margin-right:1rem!important;margin-left:1rem!important}.mx-xl-4[data-v-14fc86fd]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xl-5[data-v-14fc86fd]{margin-right:3rem!important;margin-left:3rem!important}.mx-xl-auto[data-v-14fc86fd]{margin-right:auto!important;margin-left:auto!important}.my-xl-0[data-v-14fc86fd]{margin-top:0!important;margin-bottom:0!important}.my-xl-1[data-v-14fc86fd]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xl-2[data-v-14fc86fd]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xl-3[data-v-14fc86fd]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xl-4[data-v-14fc86fd]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xl-5[data-v-14fc86fd]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xl-auto[data-v-14fc86fd]{margin-top:auto!important;margin-bottom:auto!important}.mt-xl-0[data-v-14fc86fd]{margin-top:0!important}.mt-xl-1[data-v-14fc86fd]{margin-top:.25rem!important}.mt-xl-2[data-v-14fc86fd]{margin-top:.5rem!important}.mt-xl-3[data-v-14fc86fd]{margin-top:1rem!important}.mt-xl-4[data-v-14fc86fd]{margin-top:1.5rem!important}.mt-xl-5[data-v-14fc86fd]{margin-top:3rem!important}.mt-xl-auto[data-v-14fc86fd]{margin-top:auto!important}.me-xl-0[data-v-14fc86fd]{margin-right:0!important}.me-xl-1[data-v-14fc86fd]{margin-right:.25rem!important}.me-xl-2[data-v-14fc86fd]{margin-right:.5rem!important}.me-xl-3[data-v-14fc86fd]{margin-right:1rem!important}.me-xl-4[data-v-14fc86fd]{margin-right:1.5rem!important}.me-xl-5[data-v-14fc86fd]{margin-right:3rem!important}.me-xl-auto[data-v-14fc86fd]{margin-right:auto!important}.mb-xl-0[data-v-14fc86fd]{margin-bottom:0!important}.mb-xl-1[data-v-14fc86fd]{margin-bottom:.25rem!important}.mb-xl-2[data-v-14fc86fd]{margin-bottom:.5rem!important}.mb-xl-3[data-v-14fc86fd]{margin-bottom:1rem!important}.mb-xl-4[data-v-14fc86fd]{margin-bottom:1.5rem!important}.mb-xl-5[data-v-14fc86fd]{margin-bottom:3rem!important}.mb-xl-auto[data-v-14fc86fd]{margin-bottom:auto!important}.ms-xl-0[data-v-14fc86fd]{margin-left:0!important}.ms-xl-1[data-v-14fc86fd]{margin-left:.25rem!important}.ms-xl-2[data-v-14fc86fd]{margin-left:.5rem!important}.ms-xl-3[data-v-14fc86fd]{margin-left:1rem!important}.ms-xl-4[data-v-14fc86fd]{margin-left:1.5rem!important}.ms-xl-5[data-v-14fc86fd]{margin-left:3rem!important}.ms-xl-auto[data-v-14fc86fd]{margin-left:auto!important}.p-xl-0[data-v-14fc86fd]{padding:0!important}.p-xl-1[data-v-14fc86fd]{padding:.25rem!important}.p-xl-2[data-v-14fc86fd]{padding:.5rem!important}.p-xl-3[data-v-14fc86fd]{padding:1rem!important}.p-xl-4[data-v-14fc86fd]{padding:1.5rem!important}.p-xl-5[data-v-14fc86fd]{padding:3rem!important}.px-xl-0[data-v-14fc86fd]{padding-right:0!important;padding-left:0!important}.px-xl-1[data-v-14fc86fd]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xl-2[data-v-14fc86fd]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xl-3[data-v-14fc86fd]{padding-right:1rem!important;padding-left:1rem!important}.px-xl-4[data-v-14fc86fd]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xl-5[data-v-14fc86fd]{padding-right:3rem!important;padding-left:3rem!important}.py-xl-0[data-v-14fc86fd]{padding-top:0!important;padding-bottom:0!important}.py-xl-1[data-v-14fc86fd]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xl-2[data-v-14fc86fd]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xl-3[data-v-14fc86fd]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xl-4[data-v-14fc86fd]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xl-5[data-v-14fc86fd]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xl-0[data-v-14fc86fd]{padding-top:0!important}.pt-xl-1[data-v-14fc86fd]{padding-top:.25rem!important}.pt-xl-2[data-v-14fc86fd]{padding-top:.5rem!important}.pt-xl-3[data-v-14fc86fd]{padding-top:1rem!important}.pt-xl-4[data-v-14fc86fd]{padding-top:1.5rem!important}.pt-xl-5[data-v-14fc86fd]{padding-top:3rem!important}.pe-xl-0[data-v-14fc86fd]{padding-right:0!important}.pe-xl-1[data-v-14fc86fd]{padding-right:.25rem!important}.pe-xl-2[data-v-14fc86fd]{padding-right:.5rem!important}.pe-xl-3[data-v-14fc86fd]{padding-right:1rem!important}.pe-xl-4[data-v-14fc86fd]{padding-right:1.5rem!important}.pe-xl-5[data-v-14fc86fd]{padding-right:3rem!important}.pb-xl-0[data-v-14fc86fd]{padding-bottom:0!important}.pb-xl-1[data-v-14fc86fd]{padding-bottom:.25rem!important}.pb-xl-2[data-v-14fc86fd]{padding-bottom:.5rem!important}.pb-xl-3[data-v-14fc86fd]{padding-bottom:1rem!important}.pb-xl-4[data-v-14fc86fd]{padding-bottom:1.5rem!important}.pb-xl-5[data-v-14fc86fd]{padding-bottom:3rem!important}.ps-xl-0[data-v-14fc86fd]{padding-left:0!important}.ps-xl-1[data-v-14fc86fd]{padding-left:.25rem!important}.ps-xl-2[data-v-14fc86fd]{padding-left:.5rem!important}.ps-xl-3[data-v-14fc86fd]{padding-left:1rem!important}.ps-xl-4[data-v-14fc86fd]{padding-left:1.5rem!important}.ps-xl-5[data-v-14fc86fd]{padding-left:3rem!important}.text-xl-start[data-v-14fc86fd]{text-align:left!important}.text-xl-end[data-v-14fc86fd]{text-align:right!important}.text-xl-center[data-v-14fc86fd]{text-align:center!important}}@media (min-width:1400px){.float-xxl-start[data-v-14fc86fd]{float:left!important}.float-xxl-end[data-v-14fc86fd]{float:right!important}.float-xxl-none[data-v-14fc86fd]{float:none!important}.d-xxl-inline[data-v-14fc86fd]{display:inline!important}.d-xxl-inline-block[data-v-14fc86fd]{display:inline-block!important}.d-xxl-block[data-v-14fc86fd]{display:block!important}.d-xxl-grid[data-v-14fc86fd]{display:grid!important}.d-xxl-table[data-v-14fc86fd]{display:table!important}.d-xxl-table-row[data-v-14fc86fd]{display:table-row!important}.d-xxl-table-cell[data-v-14fc86fd]{display:table-cell!important}.d-xxl-flex[data-v-14fc86fd]{display:flex!important}.d-xxl-inline-flex[data-v-14fc86fd]{display:inline-flex!important}.d-xxl-none[data-v-14fc86fd]{display:none!important}.flex-xxl-fill[data-v-14fc86fd]{flex:1 1 auto!important}.flex-xxl-row[data-v-14fc86fd]{flex-direction:row!important}.flex-xxl-column[data-v-14fc86fd]{flex-direction:column!important}.flex-xxl-row-reverse[data-v-14fc86fd]{flex-direction:row-reverse!important}.flex-xxl-column-reverse[data-v-14fc86fd]{flex-direction:column-reverse!important}.flex-xxl-grow-0[data-v-14fc86fd]{flex-grow:0!important}.flex-xxl-grow-1[data-v-14fc86fd]{flex-grow:1!important}.flex-xxl-shrink-0[data-v-14fc86fd]{flex-shrink:0!important}.flex-xxl-shrink-1[data-v-14fc86fd]{flex-shrink:1!important}.flex-xxl-wrap[data-v-14fc86fd]{flex-wrap:wrap!important}.flex-xxl-nowrap[data-v-14fc86fd]{flex-wrap:nowrap!important}.flex-xxl-wrap-reverse[data-v-14fc86fd]{flex-wrap:wrap-reverse!important}.gap-xxl-0[data-v-14fc86fd]{gap:0!important}.gap-xxl-1[data-v-14fc86fd]{gap:.25rem!important}.gap-xxl-2[data-v-14fc86fd]{gap:.5rem!important}.gap-xxl-3[data-v-14fc86fd]{gap:1rem!important}.gap-xxl-4[data-v-14fc86fd]{gap:1.5rem!important}.gap-xxl-5[data-v-14fc86fd]{gap:3rem!important}.justify-content-xxl-start[data-v-14fc86fd]{justify-content:flex-start!important}.justify-content-xxl-end[data-v-14fc86fd]{justify-content:flex-end!important}.justify-content-xxl-center[data-v-14fc86fd]{justify-content:center!important}.justify-content-xxl-between[data-v-14fc86fd]{justify-content:space-between!important}.justify-content-xxl-around[data-v-14fc86fd]{justify-content:space-around!important}.justify-content-xxl-evenly[data-v-14fc86fd]{justify-content:space-evenly!important}.align-items-xxl-start[data-v-14fc86fd]{align-items:flex-start!important}.align-items-xxl-end[data-v-14fc86fd]{align-items:flex-end!important}.align-items-xxl-center[data-v-14fc86fd]{align-items:center!important}.align-items-xxl-baseline[data-v-14fc86fd]{align-items:baseline!important}.align-items-xxl-stretch[data-v-14fc86fd]{align-items:stretch!important}.align-content-xxl-start[data-v-14fc86fd]{align-content:flex-start!important}.align-content-xxl-end[data-v-14fc86fd]{align-content:flex-end!important}.align-content-xxl-center[data-v-14fc86fd]{align-content:center!important}.align-content-xxl-between[data-v-14fc86fd]{align-content:space-between!important}.align-content-xxl-around[data-v-14fc86fd]{align-content:space-around!important}.align-content-xxl-stretch[data-v-14fc86fd]{align-content:stretch!important}.align-self-xxl-auto[data-v-14fc86fd]{align-self:auto!important}.align-self-xxl-start[data-v-14fc86fd]{align-self:flex-start!important}.align-self-xxl-end[data-v-14fc86fd]{align-self:flex-end!important}.align-self-xxl-center[data-v-14fc86fd]{align-self:center!important}.align-self-xxl-baseline[data-v-14fc86fd]{align-self:baseline!important}.align-self-xxl-stretch[data-v-14fc86fd]{align-self:stretch!important}.order-xxl-first[data-v-14fc86fd]{order:-1!important}.order-xxl-0[data-v-14fc86fd]{order:0!important}.order-xxl-1[data-v-14fc86fd]{order:1!important}.order-xxl-2[data-v-14fc86fd]{order:2!important}.order-xxl-3[data-v-14fc86fd]{order:3!important}.order-xxl-4[data-v-14fc86fd]{order:4!important}.order-xxl-5[data-v-14fc86fd]{order:5!important}.order-xxl-last[data-v-14fc86fd]{order:6!important}.m-xxl-0[data-v-14fc86fd]{margin:0!important}.m-xxl-1[data-v-14fc86fd]{margin:.25rem!important}.m-xxl-2[data-v-14fc86fd]{margin:.5rem!important}.m-xxl-3[data-v-14fc86fd]{margin:1rem!important}.m-xxl-4[data-v-14fc86fd]{margin:1.5rem!important}.m-xxl-5[data-v-14fc86fd]{margin:3rem!important}.m-xxl-auto[data-v-14fc86fd]{margin:auto!important}.mx-xxl-0[data-v-14fc86fd]{margin-right:0!important;margin-left:0!important}.mx-xxl-1[data-v-14fc86fd]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xxl-2[data-v-14fc86fd]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xxl-3[data-v-14fc86fd]{margin-right:1rem!important;margin-left:1rem!important}.mx-xxl-4[data-v-14fc86fd]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xxl-5[data-v-14fc86fd]{margin-right:3rem!important;margin-left:3rem!important}.mx-xxl-auto[data-v-14fc86fd]{margin-right:auto!important;margin-left:auto!important}.my-xxl-0[data-v-14fc86fd]{margin-top:0!important;margin-bottom:0!important}.my-xxl-1[data-v-14fc86fd]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xxl-2[data-v-14fc86fd]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xxl-3[data-v-14fc86fd]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xxl-4[data-v-14fc86fd]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xxl-5[data-v-14fc86fd]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xxl-auto[data-v-14fc86fd]{margin-top:auto!important;margin-bottom:auto!important}.mt-xxl-0[data-v-14fc86fd]{margin-top:0!important}.mt-xxl-1[data-v-14fc86fd]{margin-top:.25rem!important}.mt-xxl-2[data-v-14fc86fd]{margin-top:.5rem!important}.mt-xxl-3[data-v-14fc86fd]{margin-top:1rem!important}.mt-xxl-4[data-v-14fc86fd]{margin-top:1.5rem!important}.mt-xxl-5[data-v-14fc86fd]{margin-top:3rem!important}.mt-xxl-auto[data-v-14fc86fd]{margin-top:auto!important}.me-xxl-0[data-v-14fc86fd]{margin-right:0!important}.me-xxl-1[data-v-14fc86fd]{margin-right:.25rem!important}.me-xxl-2[data-v-14fc86fd]{margin-right:.5rem!important}.me-xxl-3[data-v-14fc86fd]{margin-right:1rem!important}.me-xxl-4[data-v-14fc86fd]{margin-right:1.5rem!important}.me-xxl-5[data-v-14fc86fd]{margin-right:3rem!important}.me-xxl-auto[data-v-14fc86fd]{margin-right:auto!important}.mb-xxl-0[data-v-14fc86fd]{margin-bottom:0!important}.mb-xxl-1[data-v-14fc86fd]{margin-bottom:.25rem!important}.mb-xxl-2[data-v-14fc86fd]{margin-bottom:.5rem!important}.mb-xxl-3[data-v-14fc86fd]{margin-bottom:1rem!important}.mb-xxl-4[data-v-14fc86fd]{margin-bottom:1.5rem!important}.mb-xxl-5[data-v-14fc86fd]{margin-bottom:3rem!important}.mb-xxl-auto[data-v-14fc86fd]{margin-bottom:auto!important}.ms-xxl-0[data-v-14fc86fd]{margin-left:0!important}.ms-xxl-1[data-v-14fc86fd]{margin-left:.25rem!important}.ms-xxl-2[data-v-14fc86fd]{margin-left:.5rem!important}.ms-xxl-3[data-v-14fc86fd]{margin-left:1rem!important}.ms-xxl-4[data-v-14fc86fd]{margin-left:1.5rem!important}.ms-xxl-5[data-v-14fc86fd]{margin-left:3rem!important}.ms-xxl-auto[data-v-14fc86fd]{margin-left:auto!important}.p-xxl-0[data-v-14fc86fd]{padding:0!important}.p-xxl-1[data-v-14fc86fd]{padding:.25rem!important}.p-xxl-2[data-v-14fc86fd]{padding:.5rem!important}.p-xxl-3[data-v-14fc86fd]{padding:1rem!important}.p-xxl-4[data-v-14fc86fd]{padding:1.5rem!important}.p-xxl-5[data-v-14fc86fd]{padding:3rem!important}.px-xxl-0[data-v-14fc86fd]{padding-right:0!important;padding-left:0!important}.px-xxl-1[data-v-14fc86fd]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xxl-2[data-v-14fc86fd]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xxl-3[data-v-14fc86fd]{padding-right:1rem!important;padding-left:1rem!important}.px-xxl-4[data-v-14fc86fd]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xxl-5[data-v-14fc86fd]{padding-right:3rem!important;padding-left:3rem!important}.py-xxl-0[data-v-14fc86fd]{padding-top:0!important;padding-bottom:0!important}.py-xxl-1[data-v-14fc86fd]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xxl-2[data-v-14fc86fd]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xxl-3[data-v-14fc86fd]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xxl-4[data-v-14fc86fd]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xxl-5[data-v-14fc86fd]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xxl-0[data-v-14fc86fd]{padding-top:0!important}.pt-xxl-1[data-v-14fc86fd]{padding-top:.25rem!important}.pt-xxl-2[data-v-14fc86fd]{padding-top:.5rem!important}.pt-xxl-3[data-v-14fc86fd]{padding-top:1rem!important}.pt-xxl-4[data-v-14fc86fd]{padding-top:1.5rem!important}.pt-xxl-5[data-v-14fc86fd]{padding-top:3rem!important}.pe-xxl-0[data-v-14fc86fd]{padding-right:0!important}.pe-xxl-1[data-v-14fc86fd]{padding-right:.25rem!important}.pe-xxl-2[data-v-14fc86fd]{padding-right:.5rem!important}.pe-xxl-3[data-v-14fc86fd]{padding-right:1rem!important}.pe-xxl-4[data-v-14fc86fd]{padding-right:1.5rem!important}.pe-xxl-5[data-v-14fc86fd]{padding-right:3rem!important}.pb-xxl-0[data-v-14fc86fd]{padding-bottom:0!important}.pb-xxl-1[data-v-14fc86fd]{padding-bottom:.25rem!important}.pb-xxl-2[data-v-14fc86fd]{padding-bottom:.5rem!important}.pb-xxl-3[data-v-14fc86fd]{padding-bottom:1rem!important}.pb-xxl-4[data-v-14fc86fd]{padding-bottom:1.5rem!important}.pb-xxl-5[data-v-14fc86fd]{padding-bottom:3rem!important}.ps-xxl-0[data-v-14fc86fd]{padding-left:0!important}.ps-xxl-1[data-v-14fc86fd]{padding-left:.25rem!important}.ps-xxl-2[data-v-14fc86fd]{padding-left:.5rem!important}.ps-xxl-3[data-v-14fc86fd]{padding-left:1rem!important}.ps-xxl-4[data-v-14fc86fd]{padding-left:1.5rem!important}.ps-xxl-5[data-v-14fc86fd]{padding-left:3rem!important}.text-xxl-start[data-v-14fc86fd]{text-align:left!important}.text-xxl-end[data-v-14fc86fd]{text-align:right!important}.text-xxl-center[data-v-14fc86fd]{text-align:center!important}}@media (min-width:1200px){.fs-1[data-v-14fc86fd]{font-size:2.5rem!important}.fs-2[data-v-14fc86fd]{font-size:2rem!important}.fs-3[data-v-14fc86fd]{font-size:1.75rem!important}.fs-4[data-v-14fc86fd]{font-size:1.5rem!important}}@media print{.d-print-inline[data-v-14fc86fd]{display:inline!important}.d-print-inline-block[data-v-14fc86fd]{display:inline-block!important}.d-print-block[data-v-14fc86fd]{display:block!important}.d-print-grid[data-v-14fc86fd]{display:grid!important}.d-print-table[data-v-14fc86fd]{display:table!important}.d-print-table-row[data-v-14fc86fd]{display:table-row!important}.d-print-table-cell[data-v-14fc86fd]{display:table-cell!important}.d-print-flex[data-v-14fc86fd]{display:flex!important}.d-print-inline-flex[data-v-14fc86fd]{display:inline-flex!important}.d-print-none[data-v-14fc86fd]{display:none!important}}", ""]);

// exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(114);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("02441b7a", content, true, {});

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".indented[data-v-14fc86fd]{margin:20px;max-width:550px}.spacer[data-v-14fc86fd]{height:65px;border:0 solid #000}.smallspacer[data-v-14fc86fd]{height:20px;border:0 solid #000}.text-danger[data-v-14fc86fd]{margin-top:10px;color:red}.spaced[data-v-14fc86fd]{margin-bottom:10px}.button[data-v-14fc86fd]{border:1px solid gray}", ""]);

// exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var bind = __webpack_require__(55);
var Axios = __webpack_require__(116);
var mergeConfig = __webpack_require__(61);
var defaults = __webpack_require__(23);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(24);
axios.CancelToken = __webpack_require__(129);
axios.isCancel = __webpack_require__(60);
axios.VERSION = __webpack_require__(62).version;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(130);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(131);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var buildURL = __webpack_require__(56);
var InterceptorManager = __webpack_require__(117);
var dispatchRequest = __webpack_require__(118);
var mergeConfig = __webpack_require__(61);
var validator = __webpack_require__(128);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var transformData = __webpack_require__(119);
var isCancel = __webpack_require__(60);
var defaults = __webpack_require__(23);
var Cancel = __webpack_require__(24);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var defaults = __webpack_require__(23);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(59);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(124);
var combineURLs = __webpack_require__(125);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var VERSION = __webpack_require__(62).version;

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(24);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(133);
var utils = __webpack_require__(63);
var formats = __webpack_require__(38);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var split = String.prototype.split;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
                var valuesArray = split.call(String(obj), ',');
                var valuesJoined = '';
                for (var i = 0; i < valuesArray.length; ++i) {
                    valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], defaults.encoder, charset, 'value', format));
                }
                return [formatter(keyValue) + '=' + valuesJoined];
            }
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key.value !== undefined ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix
            : prefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(36);
var callBound = __webpack_require__(138);
var inspect = __webpack_require__(140);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(135);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(37);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(36);

var callBind = __webpack_require__(139);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(37);
var GetIntrinsic = __webpack_require__(36);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var match = String.prototype.match;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

var inspectCustom = __webpack_require__(141).custom;
var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;
var toStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag !== 'undefined' ? Symbol.toStringTag : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
    }

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        return String(obj);
    }
    if (typeof obj === 'bigint') {
        return String(obj) + 'n';
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = seen.slice();
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function') {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + keys.join(', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? String(obj).replace(/^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + String(obj.nodeName).toLowerCase();
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + String(obj.nodeName).toLowerCase() + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + xs.join(', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + parts.join(', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? toStr(obj).slice(8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + [].concat(stringTag || [], protoTag || []).join(': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + ys.join(', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return String(s).replace(/"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString(str.slice(0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = str.replace(/(['\\])/g, '\\$1').replace(/[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + n.toString(16).toUpperCase();
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : entries.join(', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = Array(opts.indent + 1).join(' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: Array(depth + 1).join(baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + xs.join(',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ((/[^\w$]/).test(key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),
/* 141 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(63);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indented"},[_c('form',{ref:"formHTML",on:{"submit":function($event){$event.preventDefault();return _vm.submitForm.apply(null, arguments)}}},[_c('h3',[_vm._v(_vm._s(_vm.catname))]),_vm._v(" "),_c('div',{staticClass:"form-horizontal"},[_c('h4',[_vm._v("Add Product")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[_vm._v("\n        Name:\n        "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","required":""},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[_vm._v("\n        Description:\n        "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control",attrs:{"type":"text","name":"description","required":""},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[_vm._v("\n        Price:\n        "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.price),expression:"price"}],staticClass:"form-control",attrs:{"type":"text","name":"price","required":""},domProps:{"value":(_vm.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.price=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"spacer"}),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[_vm._v("\n        Picture:\n        "),_c('div',{staticClass:"col-md-10"},[_c('input',{attrs:{"type":"file","name":"imgfile","required":""},on:{"change":_vm.onFileChange}}),_vm._v(" "),(_vm.url)?_c('img',{attrs:{"src":_vm.url,"width":"200"}}):_vm._e()])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-10"},[(_vm.formcomplete)?_c('input',{staticClass:"button btn btn-default",attrs:{"type":"submit","value":"Create"}}):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group spaced"},[_vm._v("\n        After clicking Browse...and choosing image, check here if url of uploaded image has a value:\n        "),_c('div',{staticClass:"smallspacer"}),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('div',{attrs:{"id":"url"}})]),_vm._v(" "),_c('div',{staticClass:"smallspacer"}),_vm._v("\n        If you see no url here, click Browse... button again and choose image!\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(145);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2862589e", content, true, {});

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n/*!\n * Bootstrap v5.1.3 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */[data-v-3cbae5fb]:root{--bs-blue:#0d6efd;--bs-indigo:#6610f2;--bs-purple:#6f42c1;--bs-pink:#d63384;--bs-red:#dc3545;--bs-orange:#fd7e14;--bs-yellow:#ffc107;--bs-green:#198754;--bs-teal:#20c997;--bs-cyan:#0dcaf0;--bs-white:#fff;--bs-gray:#6c757d;--bs-gray-dark:#343a40;--bs-gray-100:#f8f9fa;--bs-gray-200:#e9ecef;--bs-gray-300:#dee2e6;--bs-gray-400:#ced4da;--bs-gray-500:#adb5bd;--bs-gray-600:#6c757d;--bs-gray-700:#495057;--bs-gray-800:#343a40;--bs-gray-900:#212529;--bs-primary:#0d6efd;--bs-secondary:#6c757d;--bs-success:#198754;--bs-info:#0dcaf0;--bs-warning:#ffc107;--bs-danger:#dc3545;--bs-light:#f8f9fa;--bs-dark:#212529;--bs-primary-rgb:13,110,253;--bs-secondary-rgb:108,117,125;--bs-success-rgb:25,135,84;--bs-info-rgb:13,202,240;--bs-warning-rgb:255,193,7;--bs-danger-rgb:220,53,69;--bs-light-rgb:248,249,250;--bs-dark-rgb:33,37,41;--bs-white-rgb:255,255,255;--bs-black-rgb:0,0,0;--bs-body-color-rgb:33,37,41;--bs-body-bg-rgb:255,255,255;--bs-font-sans-serif:system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--bs-font-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;--bs-gradient:linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));--bs-body-font-family:var(--bs-font-sans-serif);--bs-body-font-size:1rem;--bs-body-font-weight:400;--bs-body-line-height:1.5;--bs-body-color:#212529;--bs-body-bg:#fff}[data-v-3cbae5fb],[data-v-3cbae5fb]:after,[data-v-3cbae5fb]:before{box-sizing:border-box}@media (prefers-reduced-motion:no-preference){[data-v-3cbae5fb]:root{scroll-behavior:smooth}}body[data-v-3cbae5fb]{margin:0;font-family:var(--bs-body-font-family);font-size:var(--bs-body-font-size);font-weight:var(--bs-body-font-weight);line-height:var(--bs-body-line-height);color:var(--bs-body-color);text-align:var(--bs-body-text-align);background-color:var(--bs-body-bg);-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}hr[data-v-3cbae5fb]{margin:1rem 0;color:inherit;background-color:currentColor;border:0;opacity:.25}hr[data-v-3cbae5fb]:not([size]){height:1px}.h1[data-v-3cbae5fb],.h2[data-v-3cbae5fb],.h3[data-v-3cbae5fb],.h4[data-v-3cbae5fb],.h5[data-v-3cbae5fb],.h6[data-v-3cbae5fb],h1[data-v-3cbae5fb],h2[data-v-3cbae5fb],h3[data-v-3cbae5fb],h4[data-v-3cbae5fb],h5[data-v-3cbae5fb],h6[data-v-3cbae5fb]{margin-top:0;margin-bottom:.5rem;font-weight:500;line-height:1.2}.h1[data-v-3cbae5fb],h1[data-v-3cbae5fb]{font-size:calc(1.375rem + 1.5vw)}@media (min-width:1200px){.h1[data-v-3cbae5fb],h1[data-v-3cbae5fb]{font-size:2.5rem}}.h2[data-v-3cbae5fb],h2[data-v-3cbae5fb]{font-size:calc(1.325rem + .9vw)}@media (min-width:1200px){.h2[data-v-3cbae5fb],h2[data-v-3cbae5fb]{font-size:2rem}}.h3[data-v-3cbae5fb],h3[data-v-3cbae5fb]{font-size:calc(1.3rem + .6vw)}@media (min-width:1200px){.h3[data-v-3cbae5fb],h3[data-v-3cbae5fb]{font-size:1.75rem}}.h4[data-v-3cbae5fb],h4[data-v-3cbae5fb]{font-size:calc(1.275rem + .3vw)}@media (min-width:1200px){.h4[data-v-3cbae5fb],h4[data-v-3cbae5fb]{font-size:1.5rem}}.h5[data-v-3cbae5fb],h5[data-v-3cbae5fb]{font-size:1.25rem}.h6[data-v-3cbae5fb],h6[data-v-3cbae5fb]{font-size:1rem}p[data-v-3cbae5fb]{margin-top:0;margin-bottom:1rem}abbr[data-bs-original-title][data-v-3cbae5fb],abbr[title][data-v-3cbae5fb]{-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address[data-v-3cbae5fb]{margin-bottom:1rem;font-style:normal;line-height:inherit}ol[data-v-3cbae5fb],ul[data-v-3cbae5fb]{padding-left:2rem}dl[data-v-3cbae5fb],ol[data-v-3cbae5fb],ul[data-v-3cbae5fb]{margin-top:0;margin-bottom:1rem}ol ol[data-v-3cbae5fb],ol ul[data-v-3cbae5fb],ul ol[data-v-3cbae5fb],ul ul[data-v-3cbae5fb]{margin-bottom:0}dt[data-v-3cbae5fb]{font-weight:700}dd[data-v-3cbae5fb]{margin-bottom:.5rem;margin-left:0}blockquote[data-v-3cbae5fb]{margin:0 0 1rem}b[data-v-3cbae5fb],strong[data-v-3cbae5fb]{font-weight:bolder}.small[data-v-3cbae5fb],small[data-v-3cbae5fb]{font-size:.875em}.mark[data-v-3cbae5fb],mark[data-v-3cbae5fb]{padding:.2em;background-color:#fcf8e3}sub[data-v-3cbae5fb],sup[data-v-3cbae5fb]{position:relative;font-size:.75em;line-height:0;vertical-align:baseline}sub[data-v-3cbae5fb]{bottom:-.25em}sup[data-v-3cbae5fb]{top:-.5em}a[data-v-3cbae5fb]{color:#0d6efd;text-decoration:underline}a[data-v-3cbae5fb]:hover{color:#0a58ca}a[data-v-3cbae5fb]:not([href]):not([class]),a[data-v-3cbae5fb]:not([href]):not([class]):hover{color:inherit;text-decoration:none}code[data-v-3cbae5fb],kbd[data-v-3cbae5fb],pre[data-v-3cbae5fb],samp[data-v-3cbae5fb]{font-family:var(--bs-font-monospace);font-size:1em;direction:ltr;unicode-bidi:bidi-override}pre[data-v-3cbae5fb]{display:block;margin-top:0;margin-bottom:1rem;overflow:auto;font-size:.875em}pre code[data-v-3cbae5fb]{font-size:inherit;color:inherit;word-break:normal}code[data-v-3cbae5fb]{font-size:.875em;color:#d63384;word-wrap:break-word}a>code[data-v-3cbae5fb]{color:inherit}kbd[data-v-3cbae5fb]{padding:.2rem .4rem;font-size:.875em;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd[data-v-3cbae5fb]{padding:0;font-size:1em;font-weight:700}figure[data-v-3cbae5fb]{margin:0 0 1rem}img[data-v-3cbae5fb],svg[data-v-3cbae5fb]{vertical-align:middle}table[data-v-3cbae5fb]{caption-side:bottom;border-collapse:collapse}caption[data-v-3cbae5fb]{padding-top:.5rem;padding-bottom:.5rem;color:#6c757d;text-align:left}th[data-v-3cbae5fb]{text-align:inherit;text-align:-webkit-match-parent}tbody[data-v-3cbae5fb],td[data-v-3cbae5fb],tfoot[data-v-3cbae5fb],th[data-v-3cbae5fb],thead[data-v-3cbae5fb],tr[data-v-3cbae5fb]{border-color:inherit;border-style:solid;border-width:0}label[data-v-3cbae5fb]{display:inline-block}button[data-v-3cbae5fb]{border-radius:0}button[data-v-3cbae5fb]:focus:not(:focus-visible){outline:0}button[data-v-3cbae5fb],input[data-v-3cbae5fb],optgroup[data-v-3cbae5fb],select[data-v-3cbae5fb],textarea[data-v-3cbae5fb]{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button[data-v-3cbae5fb],select[data-v-3cbae5fb]{text-transform:none}[role=button][data-v-3cbae5fb]{cursor:pointer}select[data-v-3cbae5fb]{word-wrap:normal}select[data-v-3cbae5fb]:disabled{opacity:1}[list][data-v-3cbae5fb]::-webkit-calendar-picker-indicator{display:none}[type=button][data-v-3cbae5fb],[type=reset][data-v-3cbae5fb],[type=submit][data-v-3cbae5fb],button[data-v-3cbae5fb]{-webkit-appearance:button}[type=button][data-v-3cbae5fb]:not(:disabled),[type=reset][data-v-3cbae5fb]:not(:disabled),[type=submit][data-v-3cbae5fb]:not(:disabled),button[data-v-3cbae5fb]:not(:disabled){cursor:pointer}[data-v-3cbae5fb]::-moz-focus-inner{padding:0;border-style:none}textarea[data-v-3cbae5fb]{resize:vertical}fieldset[data-v-3cbae5fb]{min-width:0;padding:0;margin:0;border:0}legend[data-v-3cbae5fb]{float:left;width:100%;padding:0;margin-bottom:.5rem;font-size:calc(1.275rem + .3vw);line-height:inherit}@media (min-width:1200px){legend[data-v-3cbae5fb]{font-size:1.5rem}}legend+[data-v-3cbae5fb]{clear:left}[data-v-3cbae5fb]::-webkit-datetime-edit-day-field,[data-v-3cbae5fb]::-webkit-datetime-edit-fields-wrapper,[data-v-3cbae5fb]::-webkit-datetime-edit-hour-field,[data-v-3cbae5fb]::-webkit-datetime-edit-minute,[data-v-3cbae5fb]::-webkit-datetime-edit-month-field,[data-v-3cbae5fb]::-webkit-datetime-edit-text,[data-v-3cbae5fb]::-webkit-datetime-edit-year-field{padding:0}[data-v-3cbae5fb]::-webkit-inner-spin-button{height:auto}[type=search][data-v-3cbae5fb]{outline-offset:-2px;-webkit-appearance:textfield}[data-v-3cbae5fb]::-webkit-search-decoration{-webkit-appearance:none}[data-v-3cbae5fb]::-webkit-color-swatch-wrapper{padding:0}[data-v-3cbae5fb]::file-selector-button{font:inherit}[data-v-3cbae5fb]::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output[data-v-3cbae5fb]{display:inline-block}iframe[data-v-3cbae5fb]{border:0}summary[data-v-3cbae5fb]{display:list-item;cursor:pointer}progress[data-v-3cbae5fb]{vertical-align:baseline}[hidden][data-v-3cbae5fb]{display:none!important}.lead[data-v-3cbae5fb]{font-size:1.25rem;font-weight:300}.display-1[data-v-3cbae5fb]{font-size:calc(1.625rem + 4.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-1[data-v-3cbae5fb]{font-size:5rem}}.display-2[data-v-3cbae5fb]{font-size:calc(1.575rem + 3.9vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-2[data-v-3cbae5fb]{font-size:4.5rem}}.display-3[data-v-3cbae5fb]{font-size:calc(1.525rem + 3.3vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-3[data-v-3cbae5fb]{font-size:4rem}}.display-4[data-v-3cbae5fb]{font-size:calc(1.475rem + 2.7vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-4[data-v-3cbae5fb]{font-size:3.5rem}}.display-5[data-v-3cbae5fb]{font-size:calc(1.425rem + 2.1vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-5[data-v-3cbae5fb]{font-size:3rem}}.display-6[data-v-3cbae5fb]{font-size:calc(1.375rem + 1.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-6[data-v-3cbae5fb]{font-size:2.5rem}}.list-inline[data-v-3cbae5fb],.list-unstyled[data-v-3cbae5fb]{padding-left:0;list-style:none}.list-inline-item[data-v-3cbae5fb]{display:inline-block}.list-inline-item[data-v-3cbae5fb]:not(:last-child){margin-right:.5rem}.initialism[data-v-3cbae5fb]{font-size:.875em;text-transform:uppercase}.blockquote[data-v-3cbae5fb]{margin-bottom:1rem;font-size:1.25rem}.blockquote[data-v-3cbae5fb]>:last-child{margin-bottom:0}.blockquote-footer[data-v-3cbae5fb]{margin-top:-1rem;margin-bottom:1rem;font-size:.875em;color:#6c757d}.blockquote-footer[data-v-3cbae5fb]:before{content:\"\\2014\\A0\"}.img-fluid[data-v-3cbae5fb]{max-width:100%;height:auto}.img-thumbnail[data-v-3cbae5fb]{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.figure[data-v-3cbae5fb]{display:inline-block}.figure-img[data-v-3cbae5fb]{margin-bottom:.5rem;line-height:1}.figure-caption[data-v-3cbae5fb]{font-size:.875em;color:#6c757d}.container-fluid[data-v-3cbae5fb],.container-lg[data-v-3cbae5fb],.container-md[data-v-3cbae5fb],.container-sm[data-v-3cbae5fb],.container-xl[data-v-3cbae5fb],.container-xxl[data-v-3cbae5fb],.container[data-v-3cbae5fb]{width:100%;padding-right:var(--bs-gutter-x,.75rem);padding-left:var(--bs-gutter-x,.75rem);margin-right:auto;margin-left:auto}@media (min-width:576px){.container-sm[data-v-3cbae5fb],.container[data-v-3cbae5fb]{max-width:540px}}@media (min-width:768px){.container-md[data-v-3cbae5fb],.container-sm[data-v-3cbae5fb],.container[data-v-3cbae5fb]{max-width:720px}}@media (min-width:992px){.container-lg[data-v-3cbae5fb],.container-md[data-v-3cbae5fb],.container-sm[data-v-3cbae5fb],.container[data-v-3cbae5fb]{max-width:960px}}@media (min-width:1200px){.container-lg[data-v-3cbae5fb],.container-md[data-v-3cbae5fb],.container-sm[data-v-3cbae5fb],.container-xl[data-v-3cbae5fb],.container[data-v-3cbae5fb]{max-width:1140px}}@media (min-width:1400px){.container-lg[data-v-3cbae5fb],.container-md[data-v-3cbae5fb],.container-sm[data-v-3cbae5fb],.container-xl[data-v-3cbae5fb],.container-xxl[data-v-3cbae5fb],.container[data-v-3cbae5fb]{max-width:1320px}}.row[data-v-3cbae5fb]{--bs-gutter-x:1.5rem;--bs-gutter-y:0;display:flex;flex-wrap:wrap;margin-top:calc(-1 * var(--bs-gutter-y));margin-right:calc(-.5 * var(--bs-gutter-x));margin-left:calc(-.5 * var(--bs-gutter-x))}.row>[data-v-3cbae5fb]{flex-shrink:0;width:100%;max-width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-top:var(--bs-gutter-y)}.col[data-v-3cbae5fb]{flex:1 0 0%}.row-cols-auto>[data-v-3cbae5fb]{flex:0 0 auto;width:auto}.row-cols-1>[data-v-3cbae5fb]{flex:0 0 auto;width:100%}.row-cols-2>[data-v-3cbae5fb]{flex:0 0 auto;width:50%}.row-cols-3>[data-v-3cbae5fb]{flex:0 0 auto;width:33.3333333333%}.row-cols-4>[data-v-3cbae5fb]{flex:0 0 auto;width:25%}.row-cols-5>[data-v-3cbae5fb]{flex:0 0 auto;width:20%}.row-cols-6>[data-v-3cbae5fb]{flex:0 0 auto;width:16.6666666667%}.col-auto[data-v-3cbae5fb]{flex:0 0 auto;width:auto}.col-1[data-v-3cbae5fb]{flex:0 0 auto;width:8.33333333%}.col-2[data-v-3cbae5fb]{flex:0 0 auto;width:16.66666667%}.col-3[data-v-3cbae5fb]{flex:0 0 auto;width:25%}.col-4[data-v-3cbae5fb]{flex:0 0 auto;width:33.33333333%}.col-5[data-v-3cbae5fb]{flex:0 0 auto;width:41.66666667%}.col-6[data-v-3cbae5fb]{flex:0 0 auto;width:50%}.col-7[data-v-3cbae5fb]{flex:0 0 auto;width:58.33333333%}.col-8[data-v-3cbae5fb]{flex:0 0 auto;width:66.66666667%}.col-9[data-v-3cbae5fb]{flex:0 0 auto;width:75%}.col-10[data-v-3cbae5fb]{flex:0 0 auto;width:83.33333333%}.col-11[data-v-3cbae5fb]{flex:0 0 auto;width:91.66666667%}.col-12[data-v-3cbae5fb]{flex:0 0 auto;width:100%}.offset-1[data-v-3cbae5fb]{margin-left:8.33333333%}.offset-2[data-v-3cbae5fb]{margin-left:16.66666667%}.offset-3[data-v-3cbae5fb]{margin-left:25%}.offset-4[data-v-3cbae5fb]{margin-left:33.33333333%}.offset-5[data-v-3cbae5fb]{margin-left:41.66666667%}.offset-6[data-v-3cbae5fb]{margin-left:50%}.offset-7[data-v-3cbae5fb]{margin-left:58.33333333%}.offset-8[data-v-3cbae5fb]{margin-left:66.66666667%}.offset-9[data-v-3cbae5fb]{margin-left:75%}.offset-10[data-v-3cbae5fb]{margin-left:83.33333333%}.offset-11[data-v-3cbae5fb]{margin-left:91.66666667%}.g-0[data-v-3cbae5fb],.gx-0[data-v-3cbae5fb]{--bs-gutter-x:0}.g-0[data-v-3cbae5fb],.gy-0[data-v-3cbae5fb]{--bs-gutter-y:0}.g-1[data-v-3cbae5fb],.gx-1[data-v-3cbae5fb]{--bs-gutter-x:0.25rem}.g-1[data-v-3cbae5fb],.gy-1[data-v-3cbae5fb]{--bs-gutter-y:0.25rem}.g-2[data-v-3cbae5fb],.gx-2[data-v-3cbae5fb]{--bs-gutter-x:0.5rem}.g-2[data-v-3cbae5fb],.gy-2[data-v-3cbae5fb]{--bs-gutter-y:0.5rem}.g-3[data-v-3cbae5fb],.gx-3[data-v-3cbae5fb]{--bs-gutter-x:1rem}.g-3[data-v-3cbae5fb],.gy-3[data-v-3cbae5fb]{--bs-gutter-y:1rem}.g-4[data-v-3cbae5fb],.gx-4[data-v-3cbae5fb]{--bs-gutter-x:1.5rem}.g-4[data-v-3cbae5fb],.gy-4[data-v-3cbae5fb]{--bs-gutter-y:1.5rem}.g-5[data-v-3cbae5fb],.gx-5[data-v-3cbae5fb]{--bs-gutter-x:3rem}.g-5[data-v-3cbae5fb],.gy-5[data-v-3cbae5fb]{--bs-gutter-y:3rem}@media (min-width:576px){.col-sm[data-v-3cbae5fb]{flex:1 0 0%}.row-cols-sm-auto>[data-v-3cbae5fb]{flex:0 0 auto;width:auto}.row-cols-sm-1>[data-v-3cbae5fb]{flex:0 0 auto;width:100%}.row-cols-sm-2>[data-v-3cbae5fb]{flex:0 0 auto;width:50%}.row-cols-sm-3>[data-v-3cbae5fb]{flex:0 0 auto;width:33.3333333333%}.row-cols-sm-4>[data-v-3cbae5fb]{flex:0 0 auto;width:25%}.row-cols-sm-5>[data-v-3cbae5fb]{flex:0 0 auto;width:20%}.row-cols-sm-6>[data-v-3cbae5fb]{flex:0 0 auto;width:16.6666666667%}.col-sm-auto[data-v-3cbae5fb]{flex:0 0 auto;width:auto}.col-sm-1[data-v-3cbae5fb]{flex:0 0 auto;width:8.33333333%}.col-sm-2[data-v-3cbae5fb]{flex:0 0 auto;width:16.66666667%}.col-sm-3[data-v-3cbae5fb]{flex:0 0 auto;width:25%}.col-sm-4[data-v-3cbae5fb]{flex:0 0 auto;width:33.33333333%}.col-sm-5[data-v-3cbae5fb]{flex:0 0 auto;width:41.66666667%}.col-sm-6[data-v-3cbae5fb]{flex:0 0 auto;width:50%}.col-sm-7[data-v-3cbae5fb]{flex:0 0 auto;width:58.33333333%}.col-sm-8[data-v-3cbae5fb]{flex:0 0 auto;width:66.66666667%}.col-sm-9[data-v-3cbae5fb]{flex:0 0 auto;width:75%}.col-sm-10[data-v-3cbae5fb]{flex:0 0 auto;width:83.33333333%}.col-sm-11[data-v-3cbae5fb]{flex:0 0 auto;width:91.66666667%}.col-sm-12[data-v-3cbae5fb]{flex:0 0 auto;width:100%}.offset-sm-0[data-v-3cbae5fb]{margin-left:0}.offset-sm-1[data-v-3cbae5fb]{margin-left:8.33333333%}.offset-sm-2[data-v-3cbae5fb]{margin-left:16.66666667%}.offset-sm-3[data-v-3cbae5fb]{margin-left:25%}.offset-sm-4[data-v-3cbae5fb]{margin-left:33.33333333%}.offset-sm-5[data-v-3cbae5fb]{margin-left:41.66666667%}.offset-sm-6[data-v-3cbae5fb]{margin-left:50%}.offset-sm-7[data-v-3cbae5fb]{margin-left:58.33333333%}.offset-sm-8[data-v-3cbae5fb]{margin-left:66.66666667%}.offset-sm-9[data-v-3cbae5fb]{margin-left:75%}.offset-sm-10[data-v-3cbae5fb]{margin-left:83.33333333%}.offset-sm-11[data-v-3cbae5fb]{margin-left:91.66666667%}.g-sm-0[data-v-3cbae5fb],.gx-sm-0[data-v-3cbae5fb]{--bs-gutter-x:0}.g-sm-0[data-v-3cbae5fb],.gy-sm-0[data-v-3cbae5fb]{--bs-gutter-y:0}.g-sm-1[data-v-3cbae5fb],.gx-sm-1[data-v-3cbae5fb]{--bs-gutter-x:0.25rem}.g-sm-1[data-v-3cbae5fb],.gy-sm-1[data-v-3cbae5fb]{--bs-gutter-y:0.25rem}.g-sm-2[data-v-3cbae5fb],.gx-sm-2[data-v-3cbae5fb]{--bs-gutter-x:0.5rem}.g-sm-2[data-v-3cbae5fb],.gy-sm-2[data-v-3cbae5fb]{--bs-gutter-y:0.5rem}.g-sm-3[data-v-3cbae5fb],.gx-sm-3[data-v-3cbae5fb]{--bs-gutter-x:1rem}.g-sm-3[data-v-3cbae5fb],.gy-sm-3[data-v-3cbae5fb]{--bs-gutter-y:1rem}.g-sm-4[data-v-3cbae5fb],.gx-sm-4[data-v-3cbae5fb]{--bs-gutter-x:1.5rem}.g-sm-4[data-v-3cbae5fb],.gy-sm-4[data-v-3cbae5fb]{--bs-gutter-y:1.5rem}.g-sm-5[data-v-3cbae5fb],.gx-sm-5[data-v-3cbae5fb]{--bs-gutter-x:3rem}.g-sm-5[data-v-3cbae5fb],.gy-sm-5[data-v-3cbae5fb]{--bs-gutter-y:3rem}}@media (min-width:768px){.col-md[data-v-3cbae5fb]{flex:1 0 0%}.row-cols-md-auto>[data-v-3cbae5fb]{flex:0 0 auto;width:auto}.row-cols-md-1>[data-v-3cbae5fb]{flex:0 0 auto;width:100%}.row-cols-md-2>[data-v-3cbae5fb]{flex:0 0 auto;width:50%}.row-cols-md-3>[data-v-3cbae5fb]{flex:0 0 auto;width:33.3333333333%}.row-cols-md-4>[data-v-3cbae5fb]{flex:0 0 auto;width:25%}.row-cols-md-5>[data-v-3cbae5fb]{flex:0 0 auto;width:20%}.row-cols-md-6>[data-v-3cbae5fb]{flex:0 0 auto;width:16.6666666667%}.col-md-auto[data-v-3cbae5fb]{flex:0 0 auto;width:auto}.col-md-1[data-v-3cbae5fb]{flex:0 0 auto;width:8.33333333%}.col-md-2[data-v-3cbae5fb]{flex:0 0 auto;width:16.66666667%}.col-md-3[data-v-3cbae5fb]{flex:0 0 auto;width:25%}.col-md-4[data-v-3cbae5fb]{flex:0 0 auto;width:33.33333333%}.col-md-5[data-v-3cbae5fb]{flex:0 0 auto;width:41.66666667%}.col-md-6[data-v-3cbae5fb]{flex:0 0 auto;width:50%}.col-md-7[data-v-3cbae5fb]{flex:0 0 auto;width:58.33333333%}.col-md-8[data-v-3cbae5fb]{flex:0 0 auto;width:66.66666667%}.col-md-9[data-v-3cbae5fb]{flex:0 0 auto;width:75%}.col-md-10[data-v-3cbae5fb]{flex:0 0 auto;width:83.33333333%}.col-md-11[data-v-3cbae5fb]{flex:0 0 auto;width:91.66666667%}.col-md-12[data-v-3cbae5fb]{flex:0 0 auto;width:100%}.offset-md-0[data-v-3cbae5fb]{margin-left:0}.offset-md-1[data-v-3cbae5fb]{margin-left:8.33333333%}.offset-md-2[data-v-3cbae5fb]{margin-left:16.66666667%}.offset-md-3[data-v-3cbae5fb]{margin-left:25%}.offset-md-4[data-v-3cbae5fb]{margin-left:33.33333333%}.offset-md-5[data-v-3cbae5fb]{margin-left:41.66666667%}.offset-md-6[data-v-3cbae5fb]{margin-left:50%}.offset-md-7[data-v-3cbae5fb]{margin-left:58.33333333%}.offset-md-8[data-v-3cbae5fb]{margin-left:66.66666667%}.offset-md-9[data-v-3cbae5fb]{margin-left:75%}.offset-md-10[data-v-3cbae5fb]{margin-left:83.33333333%}.offset-md-11[data-v-3cbae5fb]{margin-left:91.66666667%}.g-md-0[data-v-3cbae5fb],.gx-md-0[data-v-3cbae5fb]{--bs-gutter-x:0}.g-md-0[data-v-3cbae5fb],.gy-md-0[data-v-3cbae5fb]{--bs-gutter-y:0}.g-md-1[data-v-3cbae5fb],.gx-md-1[data-v-3cbae5fb]{--bs-gutter-x:0.25rem}.g-md-1[data-v-3cbae5fb],.gy-md-1[data-v-3cbae5fb]{--bs-gutter-y:0.25rem}.g-md-2[data-v-3cbae5fb],.gx-md-2[data-v-3cbae5fb]{--bs-gutter-x:0.5rem}.g-md-2[data-v-3cbae5fb],.gy-md-2[data-v-3cbae5fb]{--bs-gutter-y:0.5rem}.g-md-3[data-v-3cbae5fb],.gx-md-3[data-v-3cbae5fb]{--bs-gutter-x:1rem}.g-md-3[data-v-3cbae5fb],.gy-md-3[data-v-3cbae5fb]{--bs-gutter-y:1rem}.g-md-4[data-v-3cbae5fb],.gx-md-4[data-v-3cbae5fb]{--bs-gutter-x:1.5rem}.g-md-4[data-v-3cbae5fb],.gy-md-4[data-v-3cbae5fb]{--bs-gutter-y:1.5rem}.g-md-5[data-v-3cbae5fb],.gx-md-5[data-v-3cbae5fb]{--bs-gutter-x:3rem}.g-md-5[data-v-3cbae5fb],.gy-md-5[data-v-3cbae5fb]{--bs-gutter-y:3rem}}@media (min-width:992px){.col-lg[data-v-3cbae5fb]{flex:1 0 0%}.row-cols-lg-auto>[data-v-3cbae5fb]{flex:0 0 auto;width:auto}.row-cols-lg-1>[data-v-3cbae5fb]{flex:0 0 auto;width:100%}.row-cols-lg-2>[data-v-3cbae5fb]{flex:0 0 auto;width:50%}.row-cols-lg-3>[data-v-3cbae5fb]{flex:0 0 auto;width:33.3333333333%}.row-cols-lg-4>[data-v-3cbae5fb]{flex:0 0 auto;width:25%}.row-cols-lg-5>[data-v-3cbae5fb]{flex:0 0 auto;width:20%}.row-cols-lg-6>[data-v-3cbae5fb]{flex:0 0 auto;width:16.6666666667%}.col-lg-auto[data-v-3cbae5fb]{flex:0 0 auto;width:auto}.col-lg-1[data-v-3cbae5fb]{flex:0 0 auto;width:8.33333333%}.col-lg-2[data-v-3cbae5fb]{flex:0 0 auto;width:16.66666667%}.col-lg-3[data-v-3cbae5fb]{flex:0 0 auto;width:25%}.col-lg-4[data-v-3cbae5fb]{flex:0 0 auto;width:33.33333333%}.col-lg-5[data-v-3cbae5fb]{flex:0 0 auto;width:41.66666667%}.col-lg-6[data-v-3cbae5fb]{flex:0 0 auto;width:50%}.col-lg-7[data-v-3cbae5fb]{flex:0 0 auto;width:58.33333333%}.col-lg-8[data-v-3cbae5fb]{flex:0 0 auto;width:66.66666667%}.col-lg-9[data-v-3cbae5fb]{flex:0 0 auto;width:75%}.col-lg-10[data-v-3cbae5fb]{flex:0 0 auto;width:83.33333333%}.col-lg-11[data-v-3cbae5fb]{flex:0 0 auto;width:91.66666667%}.col-lg-12[data-v-3cbae5fb]{flex:0 0 auto;width:100%}.offset-lg-0[data-v-3cbae5fb]{margin-left:0}.offset-lg-1[data-v-3cbae5fb]{margin-left:8.33333333%}.offset-lg-2[data-v-3cbae5fb]{margin-left:16.66666667%}.offset-lg-3[data-v-3cbae5fb]{margin-left:25%}.offset-lg-4[data-v-3cbae5fb]{margin-left:33.33333333%}.offset-lg-5[data-v-3cbae5fb]{margin-left:41.66666667%}.offset-lg-6[data-v-3cbae5fb]{margin-left:50%}.offset-lg-7[data-v-3cbae5fb]{margin-left:58.33333333%}.offset-lg-8[data-v-3cbae5fb]{margin-left:66.66666667%}.offset-lg-9[data-v-3cbae5fb]{margin-left:75%}.offset-lg-10[data-v-3cbae5fb]{margin-left:83.33333333%}.offset-lg-11[data-v-3cbae5fb]{margin-left:91.66666667%}.g-lg-0[data-v-3cbae5fb],.gx-lg-0[data-v-3cbae5fb]{--bs-gutter-x:0}.g-lg-0[data-v-3cbae5fb],.gy-lg-0[data-v-3cbae5fb]{--bs-gutter-y:0}.g-lg-1[data-v-3cbae5fb],.gx-lg-1[data-v-3cbae5fb]{--bs-gutter-x:0.25rem}.g-lg-1[data-v-3cbae5fb],.gy-lg-1[data-v-3cbae5fb]{--bs-gutter-y:0.25rem}.g-lg-2[data-v-3cbae5fb],.gx-lg-2[data-v-3cbae5fb]{--bs-gutter-x:0.5rem}.g-lg-2[data-v-3cbae5fb],.gy-lg-2[data-v-3cbae5fb]{--bs-gutter-y:0.5rem}.g-lg-3[data-v-3cbae5fb],.gx-lg-3[data-v-3cbae5fb]{--bs-gutter-x:1rem}.g-lg-3[data-v-3cbae5fb],.gy-lg-3[data-v-3cbae5fb]{--bs-gutter-y:1rem}.g-lg-4[data-v-3cbae5fb],.gx-lg-4[data-v-3cbae5fb]{--bs-gutter-x:1.5rem}.g-lg-4[data-v-3cbae5fb],.gy-lg-4[data-v-3cbae5fb]{--bs-gutter-y:1.5rem}.g-lg-5[data-v-3cbae5fb],.gx-lg-5[data-v-3cbae5fb]{--bs-gutter-x:3rem}.g-lg-5[data-v-3cbae5fb],.gy-lg-5[data-v-3cbae5fb]{--bs-gutter-y:3rem}}@media (min-width:1200px){.col-xl[data-v-3cbae5fb]{flex:1 0 0%}.row-cols-xl-auto>[data-v-3cbae5fb]{flex:0 0 auto;width:auto}.row-cols-xl-1>[data-v-3cbae5fb]{flex:0 0 auto;width:100%}.row-cols-xl-2>[data-v-3cbae5fb]{flex:0 0 auto;width:50%}.row-cols-xl-3>[data-v-3cbae5fb]{flex:0 0 auto;width:33.3333333333%}.row-cols-xl-4>[data-v-3cbae5fb]{flex:0 0 auto;width:25%}.row-cols-xl-5>[data-v-3cbae5fb]{flex:0 0 auto;width:20%}.row-cols-xl-6>[data-v-3cbae5fb]{flex:0 0 auto;width:16.6666666667%}.col-xl-auto[data-v-3cbae5fb]{flex:0 0 auto;width:auto}.col-xl-1[data-v-3cbae5fb]{flex:0 0 auto;width:8.33333333%}.col-xl-2[data-v-3cbae5fb]{flex:0 0 auto;width:16.66666667%}.col-xl-3[data-v-3cbae5fb]{flex:0 0 auto;width:25%}.col-xl-4[data-v-3cbae5fb]{flex:0 0 auto;width:33.33333333%}.col-xl-5[data-v-3cbae5fb]{flex:0 0 auto;width:41.66666667%}.col-xl-6[data-v-3cbae5fb]{flex:0 0 auto;width:50%}.col-xl-7[data-v-3cbae5fb]{flex:0 0 auto;width:58.33333333%}.col-xl-8[data-v-3cbae5fb]{flex:0 0 auto;width:66.66666667%}.col-xl-9[data-v-3cbae5fb]{flex:0 0 auto;width:75%}.col-xl-10[data-v-3cbae5fb]{flex:0 0 auto;width:83.33333333%}.col-xl-11[data-v-3cbae5fb]{flex:0 0 auto;width:91.66666667%}.col-xl-12[data-v-3cbae5fb]{flex:0 0 auto;width:100%}.offset-xl-0[data-v-3cbae5fb]{margin-left:0}.offset-xl-1[data-v-3cbae5fb]{margin-left:8.33333333%}.offset-xl-2[data-v-3cbae5fb]{margin-left:16.66666667%}.offset-xl-3[data-v-3cbae5fb]{margin-left:25%}.offset-xl-4[data-v-3cbae5fb]{margin-left:33.33333333%}.offset-xl-5[data-v-3cbae5fb]{margin-left:41.66666667%}.offset-xl-6[data-v-3cbae5fb]{margin-left:50%}.offset-xl-7[data-v-3cbae5fb]{margin-left:58.33333333%}.offset-xl-8[data-v-3cbae5fb]{margin-left:66.66666667%}.offset-xl-9[data-v-3cbae5fb]{margin-left:75%}.offset-xl-10[data-v-3cbae5fb]{margin-left:83.33333333%}.offset-xl-11[data-v-3cbae5fb]{margin-left:91.66666667%}.g-xl-0[data-v-3cbae5fb],.gx-xl-0[data-v-3cbae5fb]{--bs-gutter-x:0}.g-xl-0[data-v-3cbae5fb],.gy-xl-0[data-v-3cbae5fb]{--bs-gutter-y:0}.g-xl-1[data-v-3cbae5fb],.gx-xl-1[data-v-3cbae5fb]{--bs-gutter-x:0.25rem}.g-xl-1[data-v-3cbae5fb],.gy-xl-1[data-v-3cbae5fb]{--bs-gutter-y:0.25rem}.g-xl-2[data-v-3cbae5fb],.gx-xl-2[data-v-3cbae5fb]{--bs-gutter-x:0.5rem}.g-xl-2[data-v-3cbae5fb],.gy-xl-2[data-v-3cbae5fb]{--bs-gutter-y:0.5rem}.g-xl-3[data-v-3cbae5fb],.gx-xl-3[data-v-3cbae5fb]{--bs-gutter-x:1rem}.g-xl-3[data-v-3cbae5fb],.gy-xl-3[data-v-3cbae5fb]{--bs-gutter-y:1rem}.g-xl-4[data-v-3cbae5fb],.gx-xl-4[data-v-3cbae5fb]{--bs-gutter-x:1.5rem}.g-xl-4[data-v-3cbae5fb],.gy-xl-4[data-v-3cbae5fb]{--bs-gutter-y:1.5rem}.g-xl-5[data-v-3cbae5fb],.gx-xl-5[data-v-3cbae5fb]{--bs-gutter-x:3rem}.g-xl-5[data-v-3cbae5fb],.gy-xl-5[data-v-3cbae5fb]{--bs-gutter-y:3rem}}@media (min-width:1400px){.col-xxl[data-v-3cbae5fb]{flex:1 0 0%}.row-cols-xxl-auto>[data-v-3cbae5fb]{flex:0 0 auto;width:auto}.row-cols-xxl-1>[data-v-3cbae5fb]{flex:0 0 auto;width:100%}.row-cols-xxl-2>[data-v-3cbae5fb]{flex:0 0 auto;width:50%}.row-cols-xxl-3>[data-v-3cbae5fb]{flex:0 0 auto;width:33.3333333333%}.row-cols-xxl-4>[data-v-3cbae5fb]{flex:0 0 auto;width:25%}.row-cols-xxl-5>[data-v-3cbae5fb]{flex:0 0 auto;width:20%}.row-cols-xxl-6>[data-v-3cbae5fb]{flex:0 0 auto;width:16.6666666667%}.col-xxl-auto[data-v-3cbae5fb]{flex:0 0 auto;width:auto}.col-xxl-1[data-v-3cbae5fb]{flex:0 0 auto;width:8.33333333%}.col-xxl-2[data-v-3cbae5fb]{flex:0 0 auto;width:16.66666667%}.col-xxl-3[data-v-3cbae5fb]{flex:0 0 auto;width:25%}.col-xxl-4[data-v-3cbae5fb]{flex:0 0 auto;width:33.33333333%}.col-xxl-5[data-v-3cbae5fb]{flex:0 0 auto;width:41.66666667%}.col-xxl-6[data-v-3cbae5fb]{flex:0 0 auto;width:50%}.col-xxl-7[data-v-3cbae5fb]{flex:0 0 auto;width:58.33333333%}.col-xxl-8[data-v-3cbae5fb]{flex:0 0 auto;width:66.66666667%}.col-xxl-9[data-v-3cbae5fb]{flex:0 0 auto;width:75%}.col-xxl-10[data-v-3cbae5fb]{flex:0 0 auto;width:83.33333333%}.col-xxl-11[data-v-3cbae5fb]{flex:0 0 auto;width:91.66666667%}.col-xxl-12[data-v-3cbae5fb]{flex:0 0 auto;width:100%}.offset-xxl-0[data-v-3cbae5fb]{margin-left:0}.offset-xxl-1[data-v-3cbae5fb]{margin-left:8.33333333%}.offset-xxl-2[data-v-3cbae5fb]{margin-left:16.66666667%}.offset-xxl-3[data-v-3cbae5fb]{margin-left:25%}.offset-xxl-4[data-v-3cbae5fb]{margin-left:33.33333333%}.offset-xxl-5[data-v-3cbae5fb]{margin-left:41.66666667%}.offset-xxl-6[data-v-3cbae5fb]{margin-left:50%}.offset-xxl-7[data-v-3cbae5fb]{margin-left:58.33333333%}.offset-xxl-8[data-v-3cbae5fb]{margin-left:66.66666667%}.offset-xxl-9[data-v-3cbae5fb]{margin-left:75%}.offset-xxl-10[data-v-3cbae5fb]{margin-left:83.33333333%}.offset-xxl-11[data-v-3cbae5fb]{margin-left:91.66666667%}.g-xxl-0[data-v-3cbae5fb],.gx-xxl-0[data-v-3cbae5fb]{--bs-gutter-x:0}.g-xxl-0[data-v-3cbae5fb],.gy-xxl-0[data-v-3cbae5fb]{--bs-gutter-y:0}.g-xxl-1[data-v-3cbae5fb],.gx-xxl-1[data-v-3cbae5fb]{--bs-gutter-x:0.25rem}.g-xxl-1[data-v-3cbae5fb],.gy-xxl-1[data-v-3cbae5fb]{--bs-gutter-y:0.25rem}.g-xxl-2[data-v-3cbae5fb],.gx-xxl-2[data-v-3cbae5fb]{--bs-gutter-x:0.5rem}.g-xxl-2[data-v-3cbae5fb],.gy-xxl-2[data-v-3cbae5fb]{--bs-gutter-y:0.5rem}.g-xxl-3[data-v-3cbae5fb],.gx-xxl-3[data-v-3cbae5fb]{--bs-gutter-x:1rem}.g-xxl-3[data-v-3cbae5fb],.gy-xxl-3[data-v-3cbae5fb]{--bs-gutter-y:1rem}.g-xxl-4[data-v-3cbae5fb],.gx-xxl-4[data-v-3cbae5fb]{--bs-gutter-x:1.5rem}.g-xxl-4[data-v-3cbae5fb],.gy-xxl-4[data-v-3cbae5fb]{--bs-gutter-y:1.5rem}.g-xxl-5[data-v-3cbae5fb],.gx-xxl-5[data-v-3cbae5fb]{--bs-gutter-x:3rem}.g-xxl-5[data-v-3cbae5fb],.gy-xxl-5[data-v-3cbae5fb]{--bs-gutter-y:3rem}}.table[data-v-3cbae5fb]{--bs-table-bg:transparent;--bs-table-accent-bg:transparent;--bs-table-striped-color:#212529;--bs-table-striped-bg:rgba(0,0,0,.05);--bs-table-active-color:#212529;--bs-table-active-bg:rgba(0,0,0,.1);--bs-table-hover-color:#212529;--bs-table-hover-bg:rgba(0,0,0,.075);width:100%;margin-bottom:1rem;color:#212529;vertical-align:top;border-color:#dee2e6}.table>:not(caption)>*>[data-v-3cbae5fb]{padding:.5rem;background-color:var(--bs-table-bg);border-bottom-width:1px;box-shadow:inset 0 0 0 9999px var(--bs-table-accent-bg)}.table>tbody[data-v-3cbae5fb]{vertical-align:inherit}.table>thead[data-v-3cbae5fb]{vertical-align:bottom}.table[data-v-3cbae5fb]>:not(:first-child){border-top:2px solid currentColor}.caption-top[data-v-3cbae5fb]{caption-side:top}.table-sm>:not(caption)>*>[data-v-3cbae5fb]{padding:.25rem}.table-bordered>:not(caption)>[data-v-3cbae5fb]{border-width:1px 0}.table-bordered>:not(caption)>*>[data-v-3cbae5fb]{border-width:0 1px}.table-borderless>:not(caption)>*>[data-v-3cbae5fb]{border-bottom-width:0}.table-borderless[data-v-3cbae5fb]>:not(:first-child){border-top-width:0}.table-striped>tbody>tr:nth-of-type(odd)>[data-v-3cbae5fb]{--bs-table-accent-bg:var(--bs-table-striped-bg);color:var(--bs-table-striped-color)}.table-active[data-v-3cbae5fb]{--bs-table-accent-bg:var(--bs-table-active-bg);color:var(--bs-table-active-color)}.table-hover>tbody>tr:hover>[data-v-3cbae5fb]{--bs-table-accent-bg:var(--bs-table-hover-bg);color:var(--bs-table-hover-color)}.table-primary[data-v-3cbae5fb]{--bs-table-bg:#cfe2ff;--bs-table-striped-bg:#c5d7f2;--bs-table-striped-color:#000;--bs-table-active-bg:#bacbe6;--bs-table-active-color:#000;--bs-table-hover-bg:#bfd1ec;--bs-table-hover-color:#000;color:#000;border-color:#bacbe6}.table-secondary[data-v-3cbae5fb]{--bs-table-bg:#e2e3e5;--bs-table-striped-bg:#d7d8da;--bs-table-striped-color:#000;--bs-table-active-bg:#cbccce;--bs-table-active-color:#000;--bs-table-hover-bg:#d1d2d4;--bs-table-hover-color:#000;color:#000;border-color:#cbccce}.table-success[data-v-3cbae5fb]{--bs-table-bg:#d1e7dd;--bs-table-striped-bg:#c7dbd2;--bs-table-striped-color:#000;--bs-table-active-bg:#bcd0c7;--bs-table-active-color:#000;--bs-table-hover-bg:#c1d6cc;--bs-table-hover-color:#000;color:#000;border-color:#bcd0c7}.table-info[data-v-3cbae5fb]{--bs-table-bg:#cff4fc;--bs-table-striped-bg:#c5e8ef;--bs-table-striped-color:#000;--bs-table-active-bg:#badce3;--bs-table-active-color:#000;--bs-table-hover-bg:#bfe2e9;--bs-table-hover-color:#000;color:#000;border-color:#badce3}.table-warning[data-v-3cbae5fb]{--bs-table-bg:#fff3cd;--bs-table-striped-bg:#f2e7c3;--bs-table-striped-color:#000;--bs-table-active-bg:#e6dbb9;--bs-table-active-color:#000;--bs-table-hover-bg:#ece1be;--bs-table-hover-color:#000;color:#000;border-color:#e6dbb9}.table-danger[data-v-3cbae5fb]{--bs-table-bg:#f8d7da;--bs-table-striped-bg:#eccccf;--bs-table-striped-color:#000;--bs-table-active-bg:#dfc2c4;--bs-table-active-color:#000;--bs-table-hover-bg:#e5c7ca;--bs-table-hover-color:#000;color:#000;border-color:#dfc2c4}.table-light[data-v-3cbae5fb]{--bs-table-bg:#f8f9fa;--bs-table-striped-bg:#ecedee;--bs-table-striped-color:#000;--bs-table-active-bg:#dfe0e1;--bs-table-active-color:#000;--bs-table-hover-bg:#e5e6e7;--bs-table-hover-color:#000;color:#000;border-color:#dfe0e1}.table-dark[data-v-3cbae5fb]{--bs-table-bg:#212529;--bs-table-striped-bg:#2c3034;--bs-table-striped-color:#fff;--bs-table-active-bg:#373b3e;--bs-table-active-color:#fff;--bs-table-hover-bg:#323539;--bs-table-hover-color:#fff;color:#fff;border-color:#373b3e}.table-responsive[data-v-3cbae5fb]{overflow-x:auto;-webkit-overflow-scrolling:touch}@media (max-width:575.98px){.table-responsive-sm[data-v-3cbae5fb]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:767.98px){.table-responsive-md[data-v-3cbae5fb]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:991.98px){.table-responsive-lg[data-v-3cbae5fb]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1199.98px){.table-responsive-xl[data-v-3cbae5fb]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1399.98px){.table-responsive-xxl[data-v-3cbae5fb]{overflow-x:auto;-webkit-overflow-scrolling:touch}}.form-label[data-v-3cbae5fb]{margin-bottom:.5rem}.col-form-label[data-v-3cbae5fb]{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg[data-v-3cbae5fb]{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem}.col-form-label-sm[data-v-3cbae5fb]{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem}.form-text[data-v-3cbae5fb]{margin-top:.25rem;font-size:.875em;color:#6c757d}.form-control[data-v-3cbae5fb]{display:block;width:100%;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-3cbae5fb]{transition:none}}.form-control[type=file][data-v-3cbae5fb]{overflow:hidden}.form-control[type=file][data-v-3cbae5fb]:not(:disabled):not([readonly]){cursor:pointer}.form-control[data-v-3cbae5fb]:focus{color:#212529;background-color:#fff;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-control[data-v-3cbae5fb]::-webkit-date-and-time-value{height:1.5em}.form-control[data-v-3cbae5fb]::-moz-placeholder{color:#6c757d;opacity:1}.form-control[data-v-3cbae5fb]::placeholder{color:#6c757d;opacity:1}.form-control[data-v-3cbae5fb]:disabled,.form-control[readonly][data-v-3cbae5fb]{background-color:#e9ecef;opacity:1}.form-control[data-v-3cbae5fb]::file-selector-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-3cbae5fb]::-webkit-file-upload-button{-webkit-transition:none;transition:none}.form-control[data-v-3cbae5fb]::file-selector-button{transition:none}}.form-control[data-v-3cbae5fb]:hover:not(:disabled):not([readonly])::file-selector-button{background-color:#dde0e3}.form-control[data-v-3cbae5fb]::-webkit-file-upload-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;-webkit-transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-3cbae5fb]::-webkit-file-upload-button{-webkit-transition:none;transition:none}}.form-control[data-v-3cbae5fb]:hover:not(:disabled):not([readonly])::-webkit-file-upload-button{background-color:#dde0e3}.form-control-plaintext[data-v-3cbae5fb]{display:block;width:100%;padding:.375rem 0;margin-bottom:0;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg[data-v-3cbae5fb],.form-control-plaintext.form-control-sm[data-v-3cbae5fb]{padding-right:0;padding-left:0}.form-control-sm[data-v-3cbae5fb]{min-height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.form-control-sm[data-v-3cbae5fb]::file-selector-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-sm[data-v-3cbae5fb]::-webkit-file-upload-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-lg[data-v-3cbae5fb]{min-height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.form-control-lg[data-v-3cbae5fb]::file-selector-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}.form-control-lg[data-v-3cbae5fb]::-webkit-file-upload-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}textarea.form-control[data-v-3cbae5fb]{min-height:calc(1.5em + .75rem + 2px)}textarea.form-control-sm[data-v-3cbae5fb]{min-height:calc(1.5em + .5rem + 2px)}textarea.form-control-lg[data-v-3cbae5fb]{min-height:calc(1.5em + 1rem + 2px)}.form-control-color[data-v-3cbae5fb]{width:3rem;height:auto;padding:.375rem}.form-control-color[data-v-3cbae5fb]:not(:disabled):not([readonly]){cursor:pointer}.form-control-color[data-v-3cbae5fb]::-moz-color-swatch{height:1.5em;border-radius:.25rem}.form-control-color[data-v-3cbae5fb]::-webkit-color-swatch{height:1.5em;border-radius:.25rem}.form-select[data-v-3cbae5fb]{display:block;width:100%;padding:.375rem 2.25rem .375rem .75rem;-moz-padding-start:calc(.75rem - 3px);font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right .75rem center;background-size:16px 12px;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-select[data-v-3cbae5fb]{transition:none}}.form-select[data-v-3cbae5fb]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-select[multiple][data-v-3cbae5fb],.form-select[size][data-v-3cbae5fb]:not([size=\"1\"]){padding-right:.75rem;background-image:none}.form-select[data-v-3cbae5fb]:disabled{background-color:#e9ecef}.form-select[data-v-3cbae5fb]:-moz-focusring{color:transparent;text-shadow:0 0 0 #212529}.form-select-sm[data-v-3cbae5fb]{padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem;border-radius:.2rem}.form-select-lg[data-v-3cbae5fb]{padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem;border-radius:.3rem}.form-check[data-v-3cbae5fb]{display:block;min-height:1.5rem;padding-left:1.5em;margin-bottom:.125rem}.form-check .form-check-input[data-v-3cbae5fb]{float:left;margin-left:-1.5em}.form-check-input[data-v-3cbae5fb]{width:1em;height:1em;margin-top:.25em;vertical-align:top;background-color:#fff;background-repeat:no-repeat;background-position:50%;background-size:contain;border:1px solid rgba(0,0,0,.25);-webkit-appearance:none;-moz-appearance:none;appearance:none;-webkit-print-color-adjust:exact;color-adjust:exact}.form-check-input[type=checkbox][data-v-3cbae5fb]{border-radius:.25em}.form-check-input[type=radio][data-v-3cbae5fb]{border-radius:50%}.form-check-input[data-v-3cbae5fb]:active{filter:brightness(90%)}.form-check-input[data-v-3cbae5fb]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-check-input[data-v-3cbae5fb]:checked{background-color:#0d6efd;border-color:#0d6efd}.form-check-input:checked[type=checkbox][data-v-3cbae5fb]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3 6-6'/%3E%3C/svg%3E\")}.form-check-input:checked[type=radio][data-v-3cbae5fb]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='2' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-input[type=checkbox][data-v-3cbae5fb]:indeterminate{background-color:#0d6efd;border-color:#0d6efd;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3E%3C/svg%3E\")}.form-check-input[data-v-3cbae5fb]:disabled{pointer-events:none;filter:none;opacity:.5}.form-check-input:disabled~.form-check-label[data-v-3cbae5fb],.form-check-input[disabled]~.form-check-label[data-v-3cbae5fb]{opacity:.5}.form-switch[data-v-3cbae5fb]{padding-left:2.5em}.form-switch .form-check-input[data-v-3cbae5fb]{width:2em;margin-left:-2.5em;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='rgba(0, 0, 0, 0.25)'/%3E%3C/svg%3E\");background-position:0;border-radius:2em;transition:background-position .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-switch .form-check-input[data-v-3cbae5fb]{transition:none}}.form-switch .form-check-input[data-v-3cbae5fb]:focus{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%2386b7fe'/%3E%3C/svg%3E\")}.form-switch .form-check-input[data-v-3cbae5fb]:checked{background-position:100%;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-inline[data-v-3cbae5fb]{display:inline-block;margin-right:1rem}.btn-check[data-v-3cbae5fb]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.btn-check:disabled+.btn[data-v-3cbae5fb],.btn-check[disabled]+.btn[data-v-3cbae5fb]{pointer-events:none;filter:none;opacity:.65}.form-range[data-v-3cbae5fb]{width:100%;height:1.5rem;padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.form-range[data-v-3cbae5fb]:focus{outline:0}.form-range[data-v-3cbae5fb]:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-3cbae5fb]:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-3cbae5fb]::-moz-focus-outer{border:0}.form-range[data-v-3cbae5fb]::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#0d6efd;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-3cbae5fb]::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.form-range[data-v-3cbae5fb]::-webkit-slider-thumb:active{background-color:#b6d4fe}.form-range[data-v-3cbae5fb]::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-3cbae5fb]::-moz-range-thumb{width:1rem;height:1rem;background-color:#0d6efd;border:0;border-radius:1rem;-moz-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-3cbae5fb]::-moz-range-thumb{-moz-transition:none;transition:none}}.form-range[data-v-3cbae5fb]::-moz-range-thumb:active{background-color:#b6d4fe}.form-range[data-v-3cbae5fb]::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-3cbae5fb]:disabled{pointer-events:none}.form-range[data-v-3cbae5fb]:disabled::-webkit-slider-thumb{background-color:#adb5bd}.form-range[data-v-3cbae5fb]:disabled::-moz-range-thumb{background-color:#adb5bd}.form-floating[data-v-3cbae5fb]{position:relative}.form-floating>.form-control[data-v-3cbae5fb],.form-floating>.form-select[data-v-3cbae5fb]{height:calc(3.5rem + 2px);line-height:1.25}.form-floating>label[data-v-3cbae5fb]{position:absolute;top:0;left:0;height:100%;padding:1rem .75rem;pointer-events:none;border:1px solid transparent;transform-origin:0 0;transition:opacity .1s ease-in-out,transform .1s ease-in-out}@media (prefers-reduced-motion:reduce){.form-floating>label[data-v-3cbae5fb]{transition:none}}.form-floating>.form-control[data-v-3cbae5fb]{padding:1rem .75rem}.form-floating>.form-control[data-v-3cbae5fb]::-moz-placeholder{color:transparent}.form-floating>.form-control[data-v-3cbae5fb]::placeholder{color:transparent}.form-floating>.form-control[data-v-3cbae5fb]:not(:-moz-placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-3cbae5fb]:focus,.form-floating>.form-control[data-v-3cbae5fb]:not(:placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-3cbae5fb]:-webkit-autofill{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-select[data-v-3cbae5fb]{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control:not(:-moz-placeholder-shown)~label[data-v-3cbae5fb]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:focus~label[data-v-3cbae5fb],.form-floating>.form-control:not(:placeholder-shown)~label[data-v-3cbae5fb],.form-floating>.form-select~label[data-v-3cbae5fb]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:-webkit-autofill~label[data-v-3cbae5fb]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.input-group[data-v-3cbae5fb]{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group>.form-control[data-v-3cbae5fb],.input-group>.form-select[data-v-3cbae5fb]{position:relative;flex:1 1 auto;width:1%;min-width:0}.input-group>.form-control[data-v-3cbae5fb]:focus,.input-group>.form-select[data-v-3cbae5fb]:focus{z-index:3}.input-group .btn[data-v-3cbae5fb]{position:relative;z-index:2}.input-group .btn[data-v-3cbae5fb]:focus{z-index:3}.input-group-text[data-v-3cbae5fb]{display:flex;align-items:center;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-lg>.btn[data-v-3cbae5fb],.input-group-lg>.form-control[data-v-3cbae5fb],.input-group-lg>.form-select[data-v-3cbae5fb],.input-group-lg>.input-group-text[data-v-3cbae5fb]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.input-group-sm>.btn[data-v-3cbae5fb],.input-group-sm>.form-control[data-v-3cbae5fb],.input-group-sm>.form-select[data-v-3cbae5fb],.input-group-sm>.input-group-text[data-v-3cbae5fb]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.input-group-lg>.form-select[data-v-3cbae5fb],.input-group-sm>.form-select[data-v-3cbae5fb]{padding-right:3rem}.input-group.has-validation>.dropdown-toggle[data-v-3cbae5fb]:nth-last-child(n+4),.input-group.has-validation[data-v-3cbae5fb]>:nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),.input-group:not(.has-validation)>.dropdown-toggle[data-v-3cbae5fb]:nth-last-child(n+3),.input-group[data-v-3cbae5fb]:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu){border-top-right-radius:0;border-bottom-right-radius:0}.input-group[data-v-3cbae5fb]>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}.valid-feedback[data-v-3cbae5fb]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#198754}.valid-tooltip[data-v-3cbae5fb]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(25,135,84,.9);border-radius:.25rem}.is-valid~.valid-feedback[data-v-3cbae5fb],.is-valid~.valid-tooltip[data-v-3cbae5fb],.was-validated :valid~.valid-feedback[data-v-3cbae5fb],.was-validated :valid~.valid-tooltip[data-v-3cbae5fb]{display:block}.form-control.is-valid[data-v-3cbae5fb],.was-validated .form-control[data-v-3cbae5fb]:valid{border-color:#198754;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-valid[data-v-3cbae5fb]:focus,.was-validated .form-control[data-v-3cbae5fb]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.was-validated textarea.form-control[data-v-3cbae5fb]:valid,textarea.form-control.is-valid[data-v-3cbae5fb]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-valid[data-v-3cbae5fb],.was-validated .form-select[data-v-3cbae5fb]:valid{border-color:#198754}.form-select.is-valid:not([multiple])[size=\"1\"][data-v-3cbae5fb],.form-select.is-valid[data-v-3cbae5fb]:not([multiple]):not([size]),.was-validated .form-select:valid:not([multiple])[size=\"1\"][data-v-3cbae5fb],.was-validated .form-select[data-v-3cbae5fb]:valid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-valid[data-v-3cbae5fb]:focus,.was-validated .form-select[data-v-3cbae5fb]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid[data-v-3cbae5fb],.was-validated .form-check-input[data-v-3cbae5fb]:valid{border-color:#198754}.form-check-input.is-valid[data-v-3cbae5fb]:checked,.was-validated .form-check-input[data-v-3cbae5fb]:valid:checked{background-color:#198754}.form-check-input.is-valid[data-v-3cbae5fb]:focus,.was-validated .form-check-input[data-v-3cbae5fb]:valid:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid~.form-check-label[data-v-3cbae5fb],.was-validated .form-check-input:valid~.form-check-label[data-v-3cbae5fb]{color:#198754}.form-check-inline .form-check-input~.valid-feedback[data-v-3cbae5fb]{margin-left:.5em}.input-group .form-control.is-valid[data-v-3cbae5fb],.input-group .form-select.is-valid[data-v-3cbae5fb],.was-validated .input-group .form-control[data-v-3cbae5fb]:valid,.was-validated .input-group .form-select[data-v-3cbae5fb]:valid{z-index:1}.input-group .form-control.is-valid[data-v-3cbae5fb]:focus,.input-group .form-select.is-valid[data-v-3cbae5fb]:focus,.was-validated .input-group .form-control[data-v-3cbae5fb]:valid:focus,.was-validated .input-group .form-select[data-v-3cbae5fb]:valid:focus{z-index:3}.invalid-feedback[data-v-3cbae5fb]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#dc3545}.invalid-tooltip[data-v-3cbae5fb]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(220,53,69,.9);border-radius:.25rem}.is-invalid~.invalid-feedback[data-v-3cbae5fb],.is-invalid~.invalid-tooltip[data-v-3cbae5fb],.was-validated :invalid~.invalid-feedback[data-v-3cbae5fb],.was-validated :invalid~.invalid-tooltip[data-v-3cbae5fb]{display:block}.form-control.is-invalid[data-v-3cbae5fb],.was-validated .form-control[data-v-3cbae5fb]:invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-invalid[data-v-3cbae5fb]:focus,.was-validated .form-control[data-v-3cbae5fb]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.was-validated textarea.form-control[data-v-3cbae5fb]:invalid,textarea.form-control.is-invalid[data-v-3cbae5fb]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-invalid[data-v-3cbae5fb],.was-validated .form-select[data-v-3cbae5fb]:invalid{border-color:#dc3545}.form-select.is-invalid:not([multiple])[size=\"1\"][data-v-3cbae5fb],.form-select.is-invalid[data-v-3cbae5fb]:not([multiple]):not([size]),.was-validated .form-select:invalid:not([multiple])[size=\"1\"][data-v-3cbae5fb],.was-validated .form-select[data-v-3cbae5fb]:invalid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-invalid[data-v-3cbae5fb]:focus,.was-validated .form-select[data-v-3cbae5fb]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid[data-v-3cbae5fb],.was-validated .form-check-input[data-v-3cbae5fb]:invalid{border-color:#dc3545}.form-check-input.is-invalid[data-v-3cbae5fb]:checked,.was-validated .form-check-input[data-v-3cbae5fb]:invalid:checked{background-color:#dc3545}.form-check-input.is-invalid[data-v-3cbae5fb]:focus,.was-validated .form-check-input[data-v-3cbae5fb]:invalid:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid~.form-check-label[data-v-3cbae5fb],.was-validated .form-check-input:invalid~.form-check-label[data-v-3cbae5fb]{color:#dc3545}.form-check-inline .form-check-input~.invalid-feedback[data-v-3cbae5fb]{margin-left:.5em}.input-group .form-control.is-invalid[data-v-3cbae5fb],.input-group .form-select.is-invalid[data-v-3cbae5fb],.was-validated .input-group .form-control[data-v-3cbae5fb]:invalid,.was-validated .input-group .form-select[data-v-3cbae5fb]:invalid{z-index:2}.input-group .form-control.is-invalid[data-v-3cbae5fb]:focus,.input-group .form-select.is-invalid[data-v-3cbae5fb]:focus,.was-validated .input-group .form-control[data-v-3cbae5fb]:invalid:focus,.was-validated .input-group .form-select[data-v-3cbae5fb]:invalid:focus{z-index:3}.btn[data-v-3cbae5fb]{display:inline-block;font-weight:400;line-height:1.5;color:#212529;text-align:center;text-decoration:none;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn[data-v-3cbae5fb]{transition:none}}.btn[data-v-3cbae5fb]:hover{color:#212529}.btn-check:focus+.btn[data-v-3cbae5fb],.btn[data-v-3cbae5fb]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.btn.disabled[data-v-3cbae5fb],.btn[data-v-3cbae5fb]:disabled,fieldset:disabled .btn[data-v-3cbae5fb]{pointer-events:none;opacity:.65}.btn-primary[data-v-3cbae5fb]{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-primary[data-v-3cbae5fb]:hover{color:#fff;background-color:#0b5ed7;border-color:#0a58ca}.btn-check:focus+.btn-primary[data-v-3cbae5fb],.btn-primary[data-v-3cbae5fb]:focus{color:#fff;background-color:#0b5ed7;border-color:#0a58ca;box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-check:active+.btn-primary[data-v-3cbae5fb],.btn-check:checked+.btn-primary[data-v-3cbae5fb],.btn-primary.active[data-v-3cbae5fb],.btn-primary[data-v-3cbae5fb]:active,.show>.btn-primary.dropdown-toggle[data-v-3cbae5fb]{color:#fff;background-color:#0a58ca;border-color:#0a53be}.btn-check:active+.btn-primary[data-v-3cbae5fb]:focus,.btn-check:checked+.btn-primary[data-v-3cbae5fb]:focus,.btn-primary.active[data-v-3cbae5fb]:focus,.btn-primary[data-v-3cbae5fb]:active:focus,.show>.btn-primary.dropdown-toggle[data-v-3cbae5fb]:focus{box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-primary.disabled[data-v-3cbae5fb],.btn-primary[data-v-3cbae5fb]:disabled{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-secondary[data-v-3cbae5fb]{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary[data-v-3cbae5fb]:hover{color:#fff;background-color:#5c636a;border-color:#565e64}.btn-check:focus+.btn-secondary[data-v-3cbae5fb],.btn-secondary[data-v-3cbae5fb]:focus{color:#fff;background-color:#5c636a;border-color:#565e64;box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-check:active+.btn-secondary[data-v-3cbae5fb],.btn-check:checked+.btn-secondary[data-v-3cbae5fb],.btn-secondary.active[data-v-3cbae5fb],.btn-secondary[data-v-3cbae5fb]:active,.show>.btn-secondary.dropdown-toggle[data-v-3cbae5fb]{color:#fff;background-color:#565e64;border-color:#51585e}.btn-check:active+.btn-secondary[data-v-3cbae5fb]:focus,.btn-check:checked+.btn-secondary[data-v-3cbae5fb]:focus,.btn-secondary.active[data-v-3cbae5fb]:focus,.btn-secondary[data-v-3cbae5fb]:active:focus,.show>.btn-secondary.dropdown-toggle[data-v-3cbae5fb]:focus{box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-secondary.disabled[data-v-3cbae5fb],.btn-secondary[data-v-3cbae5fb]:disabled{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-success[data-v-3cbae5fb]{color:#fff;background-color:#198754;border-color:#198754}.btn-success[data-v-3cbae5fb]:hover{color:#fff;background-color:#157347;border-color:#146c43}.btn-check:focus+.btn-success[data-v-3cbae5fb],.btn-success[data-v-3cbae5fb]:focus{color:#fff;background-color:#157347;border-color:#146c43;box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-check:active+.btn-success[data-v-3cbae5fb],.btn-check:checked+.btn-success[data-v-3cbae5fb],.btn-success.active[data-v-3cbae5fb],.btn-success[data-v-3cbae5fb]:active,.show>.btn-success.dropdown-toggle[data-v-3cbae5fb]{color:#fff;background-color:#146c43;border-color:#13653f}.btn-check:active+.btn-success[data-v-3cbae5fb]:focus,.btn-check:checked+.btn-success[data-v-3cbae5fb]:focus,.btn-success.active[data-v-3cbae5fb]:focus,.btn-success[data-v-3cbae5fb]:active:focus,.show>.btn-success.dropdown-toggle[data-v-3cbae5fb]:focus{box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-success.disabled[data-v-3cbae5fb],.btn-success[data-v-3cbae5fb]:disabled{color:#fff;background-color:#198754;border-color:#198754}.btn-info[data-v-3cbae5fb]{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-info[data-v-3cbae5fb]:hover{color:#000;background-color:#31d2f2;border-color:#25cff2}.btn-check:focus+.btn-info[data-v-3cbae5fb],.btn-info[data-v-3cbae5fb]:focus{color:#000;background-color:#31d2f2;border-color:#25cff2;box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-check:active+.btn-info[data-v-3cbae5fb],.btn-check:checked+.btn-info[data-v-3cbae5fb],.btn-info.active[data-v-3cbae5fb],.btn-info[data-v-3cbae5fb]:active,.show>.btn-info.dropdown-toggle[data-v-3cbae5fb]{color:#000;background-color:#3dd5f3;border-color:#25cff2}.btn-check:active+.btn-info[data-v-3cbae5fb]:focus,.btn-check:checked+.btn-info[data-v-3cbae5fb]:focus,.btn-info.active[data-v-3cbae5fb]:focus,.btn-info[data-v-3cbae5fb]:active:focus,.show>.btn-info.dropdown-toggle[data-v-3cbae5fb]:focus{box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-info.disabled[data-v-3cbae5fb],.btn-info[data-v-3cbae5fb]:disabled{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-warning[data-v-3cbae5fb]{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-warning[data-v-3cbae5fb]:hover{color:#000;background-color:#ffca2c;border-color:#ffc720}.btn-check:focus+.btn-warning[data-v-3cbae5fb],.btn-warning[data-v-3cbae5fb]:focus{color:#000;background-color:#ffca2c;border-color:#ffc720;box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-check:active+.btn-warning[data-v-3cbae5fb],.btn-check:checked+.btn-warning[data-v-3cbae5fb],.btn-warning.active[data-v-3cbae5fb],.btn-warning[data-v-3cbae5fb]:active,.show>.btn-warning.dropdown-toggle[data-v-3cbae5fb]{color:#000;background-color:#ffcd39;border-color:#ffc720}.btn-check:active+.btn-warning[data-v-3cbae5fb]:focus,.btn-check:checked+.btn-warning[data-v-3cbae5fb]:focus,.btn-warning.active[data-v-3cbae5fb]:focus,.btn-warning[data-v-3cbae5fb]:active:focus,.show>.btn-warning.dropdown-toggle[data-v-3cbae5fb]:focus{box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-warning.disabled[data-v-3cbae5fb],.btn-warning[data-v-3cbae5fb]:disabled{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-danger[data-v-3cbae5fb]{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger[data-v-3cbae5fb]:hover{color:#fff;background-color:#bb2d3b;border-color:#b02a37}.btn-check:focus+.btn-danger[data-v-3cbae5fb],.btn-danger[data-v-3cbae5fb]:focus{color:#fff;background-color:#bb2d3b;border-color:#b02a37;box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-check:active+.btn-danger[data-v-3cbae5fb],.btn-check:checked+.btn-danger[data-v-3cbae5fb],.btn-danger.active[data-v-3cbae5fb],.btn-danger[data-v-3cbae5fb]:active,.show>.btn-danger.dropdown-toggle[data-v-3cbae5fb]{color:#fff;background-color:#b02a37;border-color:#a52834}.btn-check:active+.btn-danger[data-v-3cbae5fb]:focus,.btn-check:checked+.btn-danger[data-v-3cbae5fb]:focus,.btn-danger.active[data-v-3cbae5fb]:focus,.btn-danger[data-v-3cbae5fb]:active:focus,.show>.btn-danger.dropdown-toggle[data-v-3cbae5fb]:focus{box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-danger.disabled[data-v-3cbae5fb],.btn-danger[data-v-3cbae5fb]:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-light[data-v-3cbae5fb]{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light[data-v-3cbae5fb]:hover{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:focus+.btn-light[data-v-3cbae5fb],.btn-light[data-v-3cbae5fb]:focus{color:#000;background-color:#f9fafb;border-color:#f9fafb;box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-check:active+.btn-light[data-v-3cbae5fb],.btn-check:checked+.btn-light[data-v-3cbae5fb],.btn-light.active[data-v-3cbae5fb],.btn-light[data-v-3cbae5fb]:active,.show>.btn-light.dropdown-toggle[data-v-3cbae5fb]{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:active+.btn-light[data-v-3cbae5fb]:focus,.btn-check:checked+.btn-light[data-v-3cbae5fb]:focus,.btn-light.active[data-v-3cbae5fb]:focus,.btn-light[data-v-3cbae5fb]:active:focus,.show>.btn-light.dropdown-toggle[data-v-3cbae5fb]:focus{box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-light.disabled[data-v-3cbae5fb],.btn-light[data-v-3cbae5fb]:disabled{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-dark[data-v-3cbae5fb]{color:#fff;background-color:#212529;border-color:#212529}.btn-dark[data-v-3cbae5fb]:hover{color:#fff;background-color:#1c1f23;border-color:#1a1e21}.btn-check:focus+.btn-dark[data-v-3cbae5fb],.btn-dark[data-v-3cbae5fb]:focus{color:#fff;background-color:#1c1f23;border-color:#1a1e21;box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-check:active+.btn-dark[data-v-3cbae5fb],.btn-check:checked+.btn-dark[data-v-3cbae5fb],.btn-dark.active[data-v-3cbae5fb],.btn-dark[data-v-3cbae5fb]:active,.show>.btn-dark.dropdown-toggle[data-v-3cbae5fb]{color:#fff;background-color:#1a1e21;border-color:#191c1f}.btn-check:active+.btn-dark[data-v-3cbae5fb]:focus,.btn-check:checked+.btn-dark[data-v-3cbae5fb]:focus,.btn-dark.active[data-v-3cbae5fb]:focus,.btn-dark[data-v-3cbae5fb]:active:focus,.show>.btn-dark.dropdown-toggle[data-v-3cbae5fb]:focus{box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-dark.disabled[data-v-3cbae5fb],.btn-dark[data-v-3cbae5fb]:disabled{color:#fff;background-color:#212529;border-color:#212529}.btn-outline-primary[data-v-3cbae5fb]{color:#0d6efd;border-color:#0d6efd}.btn-outline-primary[data-v-3cbae5fb]:hover{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:focus+.btn-outline-primary[data-v-3cbae5fb],.btn-outline-primary[data-v-3cbae5fb]:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-check:active+.btn-outline-primary[data-v-3cbae5fb],.btn-check:checked+.btn-outline-primary[data-v-3cbae5fb],.btn-outline-primary.active[data-v-3cbae5fb],.btn-outline-primary.dropdown-toggle.show[data-v-3cbae5fb],.btn-outline-primary[data-v-3cbae5fb]:active{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:active+.btn-outline-primary[data-v-3cbae5fb]:focus,.btn-check:checked+.btn-outline-primary[data-v-3cbae5fb]:focus,.btn-outline-primary.active[data-v-3cbae5fb]:focus,.btn-outline-primary.dropdown-toggle.show[data-v-3cbae5fb]:focus,.btn-outline-primary[data-v-3cbae5fb]:active:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-outline-primary.disabled[data-v-3cbae5fb],.btn-outline-primary[data-v-3cbae5fb]:disabled{color:#0d6efd;background-color:transparent}.btn-outline-secondary[data-v-3cbae5fb]{color:#6c757d;border-color:#6c757d}.btn-outline-secondary[data-v-3cbae5fb]:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:focus+.btn-outline-secondary[data-v-3cbae5fb],.btn-outline-secondary[data-v-3cbae5fb]:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-check:active+.btn-outline-secondary[data-v-3cbae5fb],.btn-check:checked+.btn-outline-secondary[data-v-3cbae5fb],.btn-outline-secondary.active[data-v-3cbae5fb],.btn-outline-secondary.dropdown-toggle.show[data-v-3cbae5fb],.btn-outline-secondary[data-v-3cbae5fb]:active{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:active+.btn-outline-secondary[data-v-3cbae5fb]:focus,.btn-check:checked+.btn-outline-secondary[data-v-3cbae5fb]:focus,.btn-outline-secondary.active[data-v-3cbae5fb]:focus,.btn-outline-secondary.dropdown-toggle.show[data-v-3cbae5fb]:focus,.btn-outline-secondary[data-v-3cbae5fb]:active:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-outline-secondary.disabled[data-v-3cbae5fb],.btn-outline-secondary[data-v-3cbae5fb]:disabled{color:#6c757d;background-color:transparent}.btn-outline-success[data-v-3cbae5fb]{color:#198754;border-color:#198754}.btn-outline-success[data-v-3cbae5fb]:hover{color:#fff;background-color:#198754;border-color:#198754}.btn-check:focus+.btn-outline-success[data-v-3cbae5fb],.btn-outline-success[data-v-3cbae5fb]:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-check:active+.btn-outline-success[data-v-3cbae5fb],.btn-check:checked+.btn-outline-success[data-v-3cbae5fb],.btn-outline-success.active[data-v-3cbae5fb],.btn-outline-success.dropdown-toggle.show[data-v-3cbae5fb],.btn-outline-success[data-v-3cbae5fb]:active{color:#fff;background-color:#198754;border-color:#198754}.btn-check:active+.btn-outline-success[data-v-3cbae5fb]:focus,.btn-check:checked+.btn-outline-success[data-v-3cbae5fb]:focus,.btn-outline-success.active[data-v-3cbae5fb]:focus,.btn-outline-success.dropdown-toggle.show[data-v-3cbae5fb]:focus,.btn-outline-success[data-v-3cbae5fb]:active:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-outline-success.disabled[data-v-3cbae5fb],.btn-outline-success[data-v-3cbae5fb]:disabled{color:#198754;background-color:transparent}.btn-outline-info[data-v-3cbae5fb]{color:#0dcaf0;border-color:#0dcaf0}.btn-outline-info[data-v-3cbae5fb]:hover{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:focus+.btn-outline-info[data-v-3cbae5fb],.btn-outline-info[data-v-3cbae5fb]:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-check:active+.btn-outline-info[data-v-3cbae5fb],.btn-check:checked+.btn-outline-info[data-v-3cbae5fb],.btn-outline-info.active[data-v-3cbae5fb],.btn-outline-info.dropdown-toggle.show[data-v-3cbae5fb],.btn-outline-info[data-v-3cbae5fb]:active{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:active+.btn-outline-info[data-v-3cbae5fb]:focus,.btn-check:checked+.btn-outline-info[data-v-3cbae5fb]:focus,.btn-outline-info.active[data-v-3cbae5fb]:focus,.btn-outline-info.dropdown-toggle.show[data-v-3cbae5fb]:focus,.btn-outline-info[data-v-3cbae5fb]:active:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-outline-info.disabled[data-v-3cbae5fb],.btn-outline-info[data-v-3cbae5fb]:disabled{color:#0dcaf0;background-color:transparent}.btn-outline-warning[data-v-3cbae5fb]{color:#ffc107;border-color:#ffc107}.btn-outline-warning[data-v-3cbae5fb]:hover{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:focus+.btn-outline-warning[data-v-3cbae5fb],.btn-outline-warning[data-v-3cbae5fb]:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-check:active+.btn-outline-warning[data-v-3cbae5fb],.btn-check:checked+.btn-outline-warning[data-v-3cbae5fb],.btn-outline-warning.active[data-v-3cbae5fb],.btn-outline-warning.dropdown-toggle.show[data-v-3cbae5fb],.btn-outline-warning[data-v-3cbae5fb]:active{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:active+.btn-outline-warning[data-v-3cbae5fb]:focus,.btn-check:checked+.btn-outline-warning[data-v-3cbae5fb]:focus,.btn-outline-warning.active[data-v-3cbae5fb]:focus,.btn-outline-warning.dropdown-toggle.show[data-v-3cbae5fb]:focus,.btn-outline-warning[data-v-3cbae5fb]:active:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-outline-warning.disabled[data-v-3cbae5fb],.btn-outline-warning[data-v-3cbae5fb]:disabled{color:#ffc107;background-color:transparent}.btn-outline-danger[data-v-3cbae5fb]{color:#dc3545;border-color:#dc3545}.btn-outline-danger[data-v-3cbae5fb]:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:focus+.btn-outline-danger[data-v-3cbae5fb],.btn-outline-danger[data-v-3cbae5fb]:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-check:active+.btn-outline-danger[data-v-3cbae5fb],.btn-check:checked+.btn-outline-danger[data-v-3cbae5fb],.btn-outline-danger.active[data-v-3cbae5fb],.btn-outline-danger.dropdown-toggle.show[data-v-3cbae5fb],.btn-outline-danger[data-v-3cbae5fb]:active{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:active+.btn-outline-danger[data-v-3cbae5fb]:focus,.btn-check:checked+.btn-outline-danger[data-v-3cbae5fb]:focus,.btn-outline-danger.active[data-v-3cbae5fb]:focus,.btn-outline-danger.dropdown-toggle.show[data-v-3cbae5fb]:focus,.btn-outline-danger[data-v-3cbae5fb]:active:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-outline-danger.disabled[data-v-3cbae5fb],.btn-outline-danger[data-v-3cbae5fb]:disabled{color:#dc3545;background-color:transparent}.btn-outline-light[data-v-3cbae5fb]{color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light[data-v-3cbae5fb]:hover{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:focus+.btn-outline-light[data-v-3cbae5fb],.btn-outline-light[data-v-3cbae5fb]:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-check:active+.btn-outline-light[data-v-3cbae5fb],.btn-check:checked+.btn-outline-light[data-v-3cbae5fb],.btn-outline-light.active[data-v-3cbae5fb],.btn-outline-light.dropdown-toggle.show[data-v-3cbae5fb],.btn-outline-light[data-v-3cbae5fb]:active{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:active+.btn-outline-light[data-v-3cbae5fb]:focus,.btn-check:checked+.btn-outline-light[data-v-3cbae5fb]:focus,.btn-outline-light.active[data-v-3cbae5fb]:focus,.btn-outline-light.dropdown-toggle.show[data-v-3cbae5fb]:focus,.btn-outline-light[data-v-3cbae5fb]:active:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-outline-light.disabled[data-v-3cbae5fb],.btn-outline-light[data-v-3cbae5fb]:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-dark[data-v-3cbae5fb]{color:#212529;border-color:#212529}.btn-outline-dark[data-v-3cbae5fb]:hover{color:#fff;background-color:#212529;border-color:#212529}.btn-check:focus+.btn-outline-dark[data-v-3cbae5fb],.btn-outline-dark[data-v-3cbae5fb]:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-check:active+.btn-outline-dark[data-v-3cbae5fb],.btn-check:checked+.btn-outline-dark[data-v-3cbae5fb],.btn-outline-dark.active[data-v-3cbae5fb],.btn-outline-dark.dropdown-toggle.show[data-v-3cbae5fb],.btn-outline-dark[data-v-3cbae5fb]:active{color:#fff;background-color:#212529;border-color:#212529}.btn-check:active+.btn-outline-dark[data-v-3cbae5fb]:focus,.btn-check:checked+.btn-outline-dark[data-v-3cbae5fb]:focus,.btn-outline-dark.active[data-v-3cbae5fb]:focus,.btn-outline-dark.dropdown-toggle.show[data-v-3cbae5fb]:focus,.btn-outline-dark[data-v-3cbae5fb]:active:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-outline-dark.disabled[data-v-3cbae5fb],.btn-outline-dark[data-v-3cbae5fb]:disabled{color:#212529;background-color:transparent}.btn-link[data-v-3cbae5fb]{font-weight:400;color:#0d6efd;text-decoration:underline}.btn-link[data-v-3cbae5fb]:hover{color:#0a58ca}.btn-link.disabled[data-v-3cbae5fb],.btn-link[data-v-3cbae5fb]:disabled{color:#6c757d}.btn-group-lg>.btn[data-v-3cbae5fb],.btn-lg[data-v-3cbae5fb]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.btn-group-sm>.btn[data-v-3cbae5fb],.btn-sm[data-v-3cbae5fb]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.fade[data-v-3cbae5fb]{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade[data-v-3cbae5fb]{transition:none}}.fade[data-v-3cbae5fb]:not(.show){opacity:0}.collapse[data-v-3cbae5fb]:not(.show){display:none}.collapsing[data-v-3cbae5fb]{height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.collapsing[data-v-3cbae5fb]{transition:none}}.collapsing.collapse-horizontal[data-v-3cbae5fb]{width:0;height:auto;transition:width .35s ease}@media (prefers-reduced-motion:reduce){.collapsing.collapse-horizontal[data-v-3cbae5fb]{transition:none}}.dropdown[data-v-3cbae5fb],.dropend[data-v-3cbae5fb],.dropstart[data-v-3cbae5fb],.dropup[data-v-3cbae5fb]{position:relative}.dropdown-toggle[data-v-3cbae5fb]{white-space:nowrap}.dropdown-toggle[data-v-3cbae5fb]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle[data-v-3cbae5fb]:empty:after{margin-left:0}.dropdown-menu[data-v-3cbae5fb]{position:absolute;z-index:1000;display:none;min-width:10rem;padding:.5rem 0;margin:0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-menu[data-bs-popper][data-v-3cbae5fb]{top:100%;left:0;margin-top:.125rem}.dropdown-menu-start[data-v-3cbae5fb]{--bs-position:start}.dropdown-menu-start[data-bs-popper][data-v-3cbae5fb]{right:auto;left:0}.dropdown-menu-end[data-v-3cbae5fb]{--bs-position:end}.dropdown-menu-end[data-bs-popper][data-v-3cbae5fb]{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-start[data-v-3cbae5fb]{--bs-position:start}.dropdown-menu-sm-start[data-bs-popper][data-v-3cbae5fb]{right:auto;left:0}.dropdown-menu-sm-end[data-v-3cbae5fb]{--bs-position:end}.dropdown-menu-sm-end[data-bs-popper][data-v-3cbae5fb]{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-start[data-v-3cbae5fb]{--bs-position:start}.dropdown-menu-md-start[data-bs-popper][data-v-3cbae5fb]{right:auto;left:0}.dropdown-menu-md-end[data-v-3cbae5fb]{--bs-position:end}.dropdown-menu-md-end[data-bs-popper][data-v-3cbae5fb]{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-start[data-v-3cbae5fb]{--bs-position:start}.dropdown-menu-lg-start[data-bs-popper][data-v-3cbae5fb]{right:auto;left:0}.dropdown-menu-lg-end[data-v-3cbae5fb]{--bs-position:end}.dropdown-menu-lg-end[data-bs-popper][data-v-3cbae5fb]{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-start[data-v-3cbae5fb]{--bs-position:start}.dropdown-menu-xl-start[data-bs-popper][data-v-3cbae5fb]{right:auto;left:0}.dropdown-menu-xl-end[data-v-3cbae5fb]{--bs-position:end}.dropdown-menu-xl-end[data-bs-popper][data-v-3cbae5fb]{right:0;left:auto}}@media (min-width:1400px){.dropdown-menu-xxl-start[data-v-3cbae5fb]{--bs-position:start}.dropdown-menu-xxl-start[data-bs-popper][data-v-3cbae5fb]{right:auto;left:0}.dropdown-menu-xxl-end[data-v-3cbae5fb]{--bs-position:end}.dropdown-menu-xxl-end[data-bs-popper][data-v-3cbae5fb]{right:0;left:auto}}.dropup .dropdown-menu[data-bs-popper][data-v-3cbae5fb]{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle[data-v-3cbae5fb]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle[data-v-3cbae5fb]:empty:after{margin-left:0}.dropend .dropdown-menu[data-bs-popper][data-v-3cbae5fb]{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.dropend .dropdown-toggle[data-v-3cbae5fb]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropend .dropdown-toggle[data-v-3cbae5fb]:empty:after{margin-left:0}.dropend .dropdown-toggle[data-v-3cbae5fb]:after{vertical-align:0}.dropstart .dropdown-menu[data-bs-popper][data-v-3cbae5fb]{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.dropstart .dropdown-toggle[data-v-3cbae5fb]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";display:none}.dropstart .dropdown-toggle[data-v-3cbae5fb]:before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropstart .dropdown-toggle[data-v-3cbae5fb]:empty:after{margin-left:0}.dropstart .dropdown-toggle[data-v-3cbae5fb]:before{vertical-align:0}.dropdown-divider[data-v-3cbae5fb]{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid rgba(0,0,0,.15)}.dropdown-item[data-v-3cbae5fb]{display:block;width:100%;padding:.25rem 1rem;clear:both;font-weight:400;color:#212529;text-align:inherit;text-decoration:none;white-space:nowrap;background-color:transparent;border:0}.dropdown-item[data-v-3cbae5fb]:focus,.dropdown-item[data-v-3cbae5fb]:hover{color:#1e2125;background-color:#e9ecef}.dropdown-item.active[data-v-3cbae5fb],.dropdown-item[data-v-3cbae5fb]:active{color:#fff;text-decoration:none;background-color:#0d6efd}.dropdown-item.disabled[data-v-3cbae5fb],.dropdown-item[data-v-3cbae5fb]:disabled{color:#adb5bd;pointer-events:none;background-color:transparent}.dropdown-menu.show[data-v-3cbae5fb]{display:block}.dropdown-header[data-v-3cbae5fb]{display:block;padding:.5rem 1rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.dropdown-item-text[data-v-3cbae5fb]{display:block;padding:.25rem 1rem;color:#212529}.dropdown-menu-dark[data-v-3cbae5fb]{color:#dee2e6;background-color:#343a40;border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item[data-v-3cbae5fb]{color:#dee2e6}.dropdown-menu-dark .dropdown-item[data-v-3cbae5fb]:focus,.dropdown-menu-dark .dropdown-item[data-v-3cbae5fb]:hover{color:#fff;background-color:hsla(0,0%,100%,.15)}.dropdown-menu-dark .dropdown-item.active[data-v-3cbae5fb],.dropdown-menu-dark .dropdown-item[data-v-3cbae5fb]:active{color:#fff;background-color:#0d6efd}.dropdown-menu-dark .dropdown-item.disabled[data-v-3cbae5fb],.dropdown-menu-dark .dropdown-item[data-v-3cbae5fb]:disabled{color:#adb5bd}.dropdown-menu-dark .dropdown-divider[data-v-3cbae5fb]{border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item-text[data-v-3cbae5fb]{color:#dee2e6}.dropdown-menu-dark .dropdown-header[data-v-3cbae5fb]{color:#adb5bd}.btn-group-vertical[data-v-3cbae5fb],.btn-group[data-v-3cbae5fb]{position:relative;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn[data-v-3cbae5fb],.btn-group>.btn[data-v-3cbae5fb]{position:relative;flex:1 1 auto}.btn-group-vertical>.btn-check:checked+.btn[data-v-3cbae5fb],.btn-group-vertical>.btn-check:focus+.btn[data-v-3cbae5fb],.btn-group-vertical>.btn.active[data-v-3cbae5fb],.btn-group-vertical>.btn[data-v-3cbae5fb]:active,.btn-group-vertical>.btn[data-v-3cbae5fb]:focus,.btn-group-vertical>.btn[data-v-3cbae5fb]:hover,.btn-group>.btn-check:checked+.btn[data-v-3cbae5fb],.btn-group>.btn-check:focus+.btn[data-v-3cbae5fb],.btn-group>.btn.active[data-v-3cbae5fb],.btn-group>.btn[data-v-3cbae5fb]:active,.btn-group>.btn[data-v-3cbae5fb]:focus,.btn-group>.btn[data-v-3cbae5fb]:hover{z-index:1}.btn-toolbar[data-v-3cbae5fb]{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar .input-group[data-v-3cbae5fb]{width:auto}.btn-group>.btn-group[data-v-3cbae5fb]:not(:first-child),.btn-group>.btn[data-v-3cbae5fb]:not(:first-child){margin-left:-1px}.btn-group>.btn-group:not(:last-child)>.btn[data-v-3cbae5fb],.btn-group>.btn[data-v-3cbae5fb]:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn[data-v-3cbae5fb],.btn-group>.btn[data-v-3cbae5fb]:nth-child(n+3),.btn-group>:not(.btn-check)+.btn[data-v-3cbae5fb]{border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split[data-v-3cbae5fb]{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split[data-v-3cbae5fb]:after,.dropend .dropdown-toggle-split[data-v-3cbae5fb]:after,.dropup .dropdown-toggle-split[data-v-3cbae5fb]:after{margin-left:0}.dropstart .dropdown-toggle-split[data-v-3cbae5fb]:before{margin-right:0}.btn-group-sm>.btn+.dropdown-toggle-split[data-v-3cbae5fb],.btn-sm+.dropdown-toggle-split[data-v-3cbae5fb]{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split[data-v-3cbae5fb],.btn-lg+.dropdown-toggle-split[data-v-3cbae5fb]{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical[data-v-3cbae5fb]{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical>.btn-group[data-v-3cbae5fb],.btn-group-vertical>.btn[data-v-3cbae5fb]{width:100%}.btn-group-vertical>.btn-group[data-v-3cbae5fb]:not(:first-child),.btn-group-vertical>.btn[data-v-3cbae5fb]:not(:first-child){margin-top:-1px}.btn-group-vertical>.btn-group:not(:last-child)>.btn[data-v-3cbae5fb],.btn-group-vertical>.btn[data-v-3cbae5fb]:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn[data-v-3cbae5fb],.btn-group-vertical>.btn~.btn[data-v-3cbae5fb]{border-top-left-radius:0;border-top-right-radius:0}.nav[data-v-3cbae5fb]{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link[data-v-3cbae5fb]{display:block;padding:.5rem 1rem;color:#0d6efd;text-decoration:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out}@media (prefers-reduced-motion:reduce){.nav-link[data-v-3cbae5fb]{transition:none}}.nav-link[data-v-3cbae5fb]:focus,.nav-link[data-v-3cbae5fb]:hover{color:#0a58ca}.nav-link.disabled[data-v-3cbae5fb]{color:#6c757d;pointer-events:none;cursor:default}.nav-tabs[data-v-3cbae5fb]{border-bottom:1px solid #dee2e6}.nav-tabs .nav-link[data-v-3cbae5fb]{margin-bottom:-1px;background:0 0;border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link[data-v-3cbae5fb]:focus,.nav-tabs .nav-link[data-v-3cbae5fb]:hover{border-color:#e9ecef #e9ecef #dee2e6;isolation:isolate}.nav-tabs .nav-link.disabled[data-v-3cbae5fb]{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link[data-v-3cbae5fb],.nav-tabs .nav-link.active[data-v-3cbae5fb]{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu[data-v-3cbae5fb]{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link[data-v-3cbae5fb]{background:0 0;border:0;border-radius:.25rem}.nav-pills .nav-link.active[data-v-3cbae5fb],.nav-pills .show>.nav-link[data-v-3cbae5fb]{color:#fff;background-color:#0d6efd}.nav-fill .nav-item[data-v-3cbae5fb],.nav-fill>.nav-link[data-v-3cbae5fb]{flex:1 1 auto;text-align:center}.nav-justified .nav-item[data-v-3cbae5fb],.nav-justified>.nav-link[data-v-3cbae5fb]{flex-basis:0;flex-grow:1;text-align:center}.nav-fill .nav-item .nav-link[data-v-3cbae5fb],.nav-justified .nav-item .nav-link[data-v-3cbae5fb]{width:100%}.tab-content>.tab-pane[data-v-3cbae5fb]{display:none}.tab-content>.active[data-v-3cbae5fb]{display:block}.navbar[data-v-3cbae5fb]{position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding-top:.5rem;padding-bottom:.5rem}.navbar>.container-fluid[data-v-3cbae5fb],.navbar>.container-lg[data-v-3cbae5fb],.navbar>.container-md[data-v-3cbae5fb],.navbar>.container-sm[data-v-3cbae5fb],.navbar>.container-xl[data-v-3cbae5fb],.navbar>.container-xxl[data-v-3cbae5fb],.navbar>.container[data-v-3cbae5fb]{display:flex;flex-wrap:inherit;align-items:center;justify-content:space-between}.navbar-brand[data-v-3cbae5fb]{padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;text-decoration:none;white-space:nowrap}.navbar-nav[data-v-3cbae5fb]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link[data-v-3cbae5fb]{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu[data-v-3cbae5fb]{position:static}.navbar-text[data-v-3cbae5fb]{padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse[data-v-3cbae5fb]{flex-basis:100%;flex-grow:1;align-items:center}.navbar-toggler[data-v-3cbae5fb]{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem;transition:box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.navbar-toggler[data-v-3cbae5fb]{transition:none}}.navbar-toggler[data-v-3cbae5fb]:hover{text-decoration:none}.navbar-toggler[data-v-3cbae5fb]:focus{text-decoration:none;outline:0;box-shadow:0 0 0 .25rem}.navbar-toggler-icon[data-v-3cbae5fb]{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;background-repeat:no-repeat;background-position:50%;background-size:100%}.navbar-nav-scroll[data-v-3cbae5fb]{max-height:var(--bs-scroll-height,75vh);overflow-y:auto}@media (min-width:576px){.navbar-expand-sm[data-v-3cbae5fb]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-sm .navbar-nav[data-v-3cbae5fb]{flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu[data-v-3cbae5fb]{position:absolute}.navbar-expand-sm .navbar-nav .nav-link[data-v-3cbae5fb]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm .navbar-nav-scroll[data-v-3cbae5fb]{overflow:visible}.navbar-expand-sm .navbar-collapse[data-v-3cbae5fb]{display:flex!important;flex-basis:auto}.navbar-expand-sm .navbar-toggler[data-v-3cbae5fb],.navbar-expand-sm .offcanvas-header[data-v-3cbae5fb]{display:none}.navbar-expand-sm .offcanvas[data-v-3cbae5fb]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-sm .offcanvas-bottom[data-v-3cbae5fb],.navbar-expand-sm .offcanvas-top[data-v-3cbae5fb]{height:auto;border-top:0;border-bottom:0}.navbar-expand-sm .offcanvas-body[data-v-3cbae5fb]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:768px){.navbar-expand-md[data-v-3cbae5fb]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-md .navbar-nav[data-v-3cbae5fb]{flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu[data-v-3cbae5fb]{position:absolute}.navbar-expand-md .navbar-nav .nav-link[data-v-3cbae5fb]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md .navbar-nav-scroll[data-v-3cbae5fb]{overflow:visible}.navbar-expand-md .navbar-collapse[data-v-3cbae5fb]{display:flex!important;flex-basis:auto}.navbar-expand-md .navbar-toggler[data-v-3cbae5fb],.navbar-expand-md .offcanvas-header[data-v-3cbae5fb]{display:none}.navbar-expand-md .offcanvas[data-v-3cbae5fb]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-md .offcanvas-bottom[data-v-3cbae5fb],.navbar-expand-md .offcanvas-top[data-v-3cbae5fb]{height:auto;border-top:0;border-bottom:0}.navbar-expand-md .offcanvas-body[data-v-3cbae5fb]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:992px){.navbar-expand-lg[data-v-3cbae5fb]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-lg .navbar-nav[data-v-3cbae5fb]{flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu[data-v-3cbae5fb]{position:absolute}.navbar-expand-lg .navbar-nav .nav-link[data-v-3cbae5fb]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg .navbar-nav-scroll[data-v-3cbae5fb]{overflow:visible}.navbar-expand-lg .navbar-collapse[data-v-3cbae5fb]{display:flex!important;flex-basis:auto}.navbar-expand-lg .navbar-toggler[data-v-3cbae5fb],.navbar-expand-lg .offcanvas-header[data-v-3cbae5fb]{display:none}.navbar-expand-lg .offcanvas[data-v-3cbae5fb]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-lg .offcanvas-bottom[data-v-3cbae5fb],.navbar-expand-lg .offcanvas-top[data-v-3cbae5fb]{height:auto;border-top:0;border-bottom:0}.navbar-expand-lg .offcanvas-body[data-v-3cbae5fb]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1200px){.navbar-expand-xl[data-v-3cbae5fb]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xl .navbar-nav[data-v-3cbae5fb]{flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu[data-v-3cbae5fb]{position:absolute}.navbar-expand-xl .navbar-nav .nav-link[data-v-3cbae5fb]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl .navbar-nav-scroll[data-v-3cbae5fb]{overflow:visible}.navbar-expand-xl .navbar-collapse[data-v-3cbae5fb]{display:flex!important;flex-basis:auto}.navbar-expand-xl .navbar-toggler[data-v-3cbae5fb],.navbar-expand-xl .offcanvas-header[data-v-3cbae5fb]{display:none}.navbar-expand-xl .offcanvas[data-v-3cbae5fb]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xl .offcanvas-bottom[data-v-3cbae5fb],.navbar-expand-xl .offcanvas-top[data-v-3cbae5fb]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xl .offcanvas-body[data-v-3cbae5fb]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1400px){.navbar-expand-xxl[data-v-3cbae5fb]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xxl .navbar-nav[data-v-3cbae5fb]{flex-direction:row}.navbar-expand-xxl .navbar-nav .dropdown-menu[data-v-3cbae5fb]{position:absolute}.navbar-expand-xxl .navbar-nav .nav-link[data-v-3cbae5fb]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xxl .navbar-nav-scroll[data-v-3cbae5fb]{overflow:visible}.navbar-expand-xxl .navbar-collapse[data-v-3cbae5fb]{display:flex!important;flex-basis:auto}.navbar-expand-xxl .navbar-toggler[data-v-3cbae5fb],.navbar-expand-xxl .offcanvas-header[data-v-3cbae5fb]{display:none}.navbar-expand-xxl .offcanvas[data-v-3cbae5fb]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xxl .offcanvas-bottom[data-v-3cbae5fb],.navbar-expand-xxl .offcanvas-top[data-v-3cbae5fb]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xxl .offcanvas-body[data-v-3cbae5fb]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}.navbar-expand[data-v-3cbae5fb]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand .navbar-nav[data-v-3cbae5fb]{flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu[data-v-3cbae5fb]{position:absolute}.navbar-expand .navbar-nav .nav-link[data-v-3cbae5fb]{padding-right:.5rem;padding-left:.5rem}.navbar-expand .navbar-nav-scroll[data-v-3cbae5fb]{overflow:visible}.navbar-expand .navbar-collapse[data-v-3cbae5fb]{display:flex!important;flex-basis:auto}.navbar-expand .navbar-toggler[data-v-3cbae5fb],.navbar-expand .offcanvas-header[data-v-3cbae5fb]{display:none}.navbar-expand .offcanvas[data-v-3cbae5fb]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand .offcanvas-bottom[data-v-3cbae5fb],.navbar-expand .offcanvas-top[data-v-3cbae5fb]{height:auto;border-top:0;border-bottom:0}.navbar-expand .offcanvas-body[data-v-3cbae5fb]{display:flex;flex-grow:0;padding:0;overflow-y:visible}.navbar-light .navbar-brand[data-v-3cbae5fb],.navbar-light .navbar-brand[data-v-3cbae5fb]:focus,.navbar-light .navbar-brand[data-v-3cbae5fb]:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link[data-v-3cbae5fb]{color:rgba(0,0,0,.55)}.navbar-light .navbar-nav .nav-link[data-v-3cbae5fb]:focus,.navbar-light .navbar-nav .nav-link[data-v-3cbae5fb]:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled[data-v-3cbae5fb]{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .nav-link.active[data-v-3cbae5fb],.navbar-light .navbar-nav .show>.nav-link[data-v-3cbae5fb]{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler[data-v-3cbae5fb]{color:rgba(0,0,0,.55);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon[data-v-3cbae5fb]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(0, 0, 0, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-light .navbar-text[data-v-3cbae5fb]{color:rgba(0,0,0,.55)}.navbar-light .navbar-text a[data-v-3cbae5fb],.navbar-light .navbar-text a[data-v-3cbae5fb]:focus,.navbar-light .navbar-text a[data-v-3cbae5fb]:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand[data-v-3cbae5fb],.navbar-dark .navbar-brand[data-v-3cbae5fb]:focus,.navbar-dark .navbar-brand[data-v-3cbae5fb]:hover{color:#fff}.navbar-dark .navbar-nav .nav-link[data-v-3cbae5fb]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-nav .nav-link[data-v-3cbae5fb]:focus,.navbar-dark .navbar-nav .nav-link[data-v-3cbae5fb]:hover{color:hsla(0,0%,100%,.75)}.navbar-dark .navbar-nav .nav-link.disabled[data-v-3cbae5fb]{color:hsla(0,0%,100%,.25)}.navbar-dark .navbar-nav .nav-link.active[data-v-3cbae5fb],.navbar-dark .navbar-nav .show>.nav-link[data-v-3cbae5fb]{color:#fff}.navbar-dark .navbar-toggler[data-v-3cbae5fb]{color:hsla(0,0%,100%,.55);border-color:hsla(0,0%,100%,.1)}.navbar-dark .navbar-toggler-icon[data-v-3cbae5fb]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(255, 255, 255, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-dark .navbar-text[data-v-3cbae5fb]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-text a[data-v-3cbae5fb],.navbar-dark .navbar-text a[data-v-3cbae5fb]:focus,.navbar-dark .navbar-text a[data-v-3cbae5fb]:hover{color:#fff}.card[data-v-3cbae5fb]{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr[data-v-3cbae5fb]{margin-right:0;margin-left:0}.card>.list-group[data-v-3cbae5fb]{border-top:inherit;border-bottom:inherit}.card>.list-group[data-v-3cbae5fb]:first-child{border-top-width:0;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card>.list-group[data-v-3cbae5fb]:last-child{border-bottom-width:0;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card>.card-header+.list-group[data-v-3cbae5fb],.card>.list-group+.card-footer[data-v-3cbae5fb]{border-top:0}.card-body[data-v-3cbae5fb]{flex:1 1 auto;padding:1rem}.card-title[data-v-3cbae5fb]{margin-bottom:.5rem}.card-subtitle[data-v-3cbae5fb]{margin-top:-.25rem;margin-bottom:0}.card-text[data-v-3cbae5fb]:last-child{margin-bottom:0}.card-link+.card-link[data-v-3cbae5fb]{margin-left:1rem}.card-header[data-v-3cbae5fb]{padding:.5rem 1rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header[data-v-3cbae5fb]:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-footer[data-v-3cbae5fb]{padding:.5rem 1rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer[data-v-3cbae5fb]:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs[data-v-3cbae5fb]{margin-bottom:-.5rem;border-bottom:0}.card-header-pills[data-v-3cbae5fb],.card-header-tabs[data-v-3cbae5fb]{margin-right:-.5rem;margin-left:-.5rem}.card-img-overlay[data-v-3cbae5fb]{position:absolute;top:0;right:0;bottom:0;left:0;padding:1rem;border-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-3cbae5fb],.card-img-top[data-v-3cbae5fb],.card-img[data-v-3cbae5fb]{width:100%}.card-img-top[data-v-3cbae5fb],.card-img[data-v-3cbae5fb]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-3cbae5fb],.card-img[data-v-3cbae5fb]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-group>.card[data-v-3cbae5fb]{margin-bottom:.75rem}@media (min-width:576px){.card-group[data-v-3cbae5fb]{display:flex;flex-flow:row wrap}.card-group>.card[data-v-3cbae5fb]{flex:1 0 0%;margin-bottom:0}.card-group>.card+.card[data-v-3cbae5fb]{margin-left:0;border-left:0}.card-group>.card[data-v-3cbae5fb]:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-header[data-v-3cbae5fb],.card-group>.card:not(:last-child) .card-img-top[data-v-3cbae5fb]{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-footer[data-v-3cbae5fb],.card-group>.card:not(:last-child) .card-img-bottom[data-v-3cbae5fb]{border-bottom-right-radius:0}.card-group>.card[data-v-3cbae5fb]:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-header[data-v-3cbae5fb],.card-group>.card:not(:first-child) .card-img-top[data-v-3cbae5fb]{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-footer[data-v-3cbae5fb],.card-group>.card:not(:first-child) .card-img-bottom[data-v-3cbae5fb]{border-bottom-left-radius:0}}.accordion-button[data-v-3cbae5fb]{position:relative;display:flex;align-items:center;width:100%;padding:1rem 1.25rem;font-size:1rem;color:#212529;text-align:left;background-color:#fff;border:0;border-radius:0;overflow-anchor:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,border-radius .15s ease}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-3cbae5fb]{transition:none}}.accordion-button[data-v-3cbae5fb]:not(.collapsed){color:#0c63e4;background-color:#e7f1ff;box-shadow:inset 0 -1px 0 rgba(0,0,0,.125)}.accordion-button[data-v-3cbae5fb]:not(.collapsed):after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230c63e4'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");transform:rotate(-180deg)}.accordion-button[data-v-3cbae5fb]:after{flex-shrink:0;width:1.25rem;height:1.25rem;margin-left:auto;content:\"\";background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-size:1.25rem;transition:transform .2s ease-in-out}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-3cbae5fb]:after{transition:none}}.accordion-button[data-v-3cbae5fb]:hover{z-index:2}.accordion-button[data-v-3cbae5fb]:focus{z-index:3;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.accordion-header[data-v-3cbae5fb]{margin-bottom:0}.accordion-item[data-v-3cbae5fb]{background-color:#fff;border:1px solid rgba(0,0,0,.125)}.accordion-item[data-v-3cbae5fb]:first-of-type{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.accordion-item:first-of-type .accordion-button[data-v-3cbae5fb]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.accordion-item[data-v-3cbae5fb]:not(:first-of-type){border-top:0}.accordion-item[data-v-3cbae5fb]:last-of-type{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-item:last-of-type .accordion-button.collapsed[data-v-3cbae5fb]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.accordion-item:last-of-type .accordion-collapse[data-v-3cbae5fb]{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-body[data-v-3cbae5fb]{padding:1rem 1.25rem}.accordion-flush .accordion-collapse[data-v-3cbae5fb]{border-width:0}.accordion-flush .accordion-item[data-v-3cbae5fb]{border-right:0;border-left:0;border-radius:0}.accordion-flush .accordion-item[data-v-3cbae5fb]:first-child{border-top:0}.accordion-flush .accordion-item[data-v-3cbae5fb]:last-child{border-bottom:0}.accordion-flush .accordion-item .accordion-button[data-v-3cbae5fb]{border-radius:0}.breadcrumb[data-v-3cbae5fb]{display:flex;flex-wrap:wrap;padding:0;margin-bottom:1rem;list-style:none}.breadcrumb-item+.breadcrumb-item[data-v-3cbae5fb]{padding-left:.5rem}.breadcrumb-item+.breadcrumb-item[data-v-3cbae5fb]:before{float:left;padding-right:.5rem;color:#6c757d;content:var(--bs-breadcrumb-divider,\"/\")}.breadcrumb-item.active[data-v-3cbae5fb]{color:#6c757d}.pagination[data-v-3cbae5fb]{display:flex;padding-left:0;list-style:none}.page-link[data-v-3cbae5fb]{position:relative;display:block;color:#0d6efd;text-decoration:none;background-color:#fff;border:1px solid #dee2e6;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.page-link[data-v-3cbae5fb]{transition:none}}.page-link[data-v-3cbae5fb]:hover{z-index:2;color:#0a58ca;background-color:#e9ecef;border-color:#dee2e6}.page-link[data-v-3cbae5fb]:focus{z-index:3;color:#0a58ca;background-color:#e9ecef;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.page-item:not(:first-child) .page-link[data-v-3cbae5fb]{margin-left:-1px}.page-item.active .page-link[data-v-3cbae5fb]{z-index:3;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.page-item.disabled .page-link[data-v-3cbae5fb]{color:#6c757d;pointer-events:none;background-color:#fff;border-color:#dee2e6}.page-link[data-v-3cbae5fb]{padding:.375rem .75rem}.page-item:first-child .page-link[data-v-3cbae5fb]{border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item:last-child .page-link[data-v-3cbae5fb]{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.pagination-lg .page-link[data-v-3cbae5fb]{padding:.75rem 1.5rem;font-size:1.25rem}.pagination-lg .page-item:first-child .page-link[data-v-3cbae5fb]{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link[data-v-3cbae5fb]{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm .page-link[data-v-3cbae5fb]{padding:.25rem .5rem;font-size:.875rem}.pagination-sm .page-item:first-child .page-link[data-v-3cbae5fb]{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link[data-v-3cbae5fb]{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge[data-v-3cbae5fb]{display:inline-block;padding:.35em .65em;font-size:.75em;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}.badge[data-v-3cbae5fb]:empty{display:none}.btn .badge[data-v-3cbae5fb]{position:relative;top:-1px}.alert[data-v-3cbae5fb]{position:relative;padding:1rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading[data-v-3cbae5fb]{color:inherit}.alert-link[data-v-3cbae5fb]{font-weight:700}.alert-dismissible[data-v-3cbae5fb]{padding-right:3rem}.alert-dismissible .btn-close[data-v-3cbae5fb]{position:absolute;top:0;right:0;z-index:2;padding:1.25rem 1rem}.alert-primary[data-v-3cbae5fb]{color:#084298;background-color:#cfe2ff;border-color:#b6d4fe}.alert-primary .alert-link[data-v-3cbae5fb]{color:#06357a}.alert-secondary[data-v-3cbae5fb]{color:#41464b;background-color:#e2e3e5;border-color:#d3d6d8}.alert-secondary .alert-link[data-v-3cbae5fb]{color:#34383c}.alert-success[data-v-3cbae5fb]{color:#0f5132;background-color:#d1e7dd;border-color:#badbcc}.alert-success .alert-link[data-v-3cbae5fb]{color:#0c4128}.alert-info[data-v-3cbae5fb]{color:#055160;background-color:#cff4fc;border-color:#b6effb}.alert-info .alert-link[data-v-3cbae5fb]{color:#04414d}.alert-warning[data-v-3cbae5fb]{color:#664d03;background-color:#fff3cd;border-color:#ffecb5}.alert-warning .alert-link[data-v-3cbae5fb]{color:#523e02}.alert-danger[data-v-3cbae5fb]{color:#842029;background-color:#f8d7da;border-color:#f5c2c7}.alert-danger .alert-link[data-v-3cbae5fb]{color:#6a1a21}.alert-light[data-v-3cbae5fb]{color:#636464;background-color:#fefefe;border-color:#fdfdfe}.alert-light .alert-link[data-v-3cbae5fb]{color:#4f5050}.alert-dark[data-v-3cbae5fb]{color:#141619;background-color:#d3d3d4;border-color:#bcbebf}.alert-dark .alert-link[data-v-3cbae5fb]{color:#101214}@-webkit-keyframes progress-bar-stripes-data-v-3cbae5fb{0%{background-position-x:1rem}}@keyframes progress-bar-stripes-data-v-3cbae5fb{0%{background-position-x:1rem}}.progress[data-v-3cbae5fb]{display:flex;height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress-bar[data-v-3cbae5fb]{display:flex;flex-direction:column;justify-content:center;overflow:hidden;color:#fff;text-align:center;white-space:nowrap;background-color:#0d6efd;transition:width .6s ease}@media (prefers-reduced-motion:reduce){.progress-bar[data-v-3cbae5fb]{transition:none}}.progress-bar-striped[data-v-3cbae5fb]{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-bar-animated[data-v-3cbae5fb]{-webkit-animation:1s linear infinite progress-bar-stripes-data-v-3cbae5fb;animation:1s linear infinite progress-bar-stripes-data-v-3cbae5fb}@media (prefers-reduced-motion:reduce){.progress-bar-animated[data-v-3cbae5fb]{-webkit-animation:none;animation:none}}.list-group[data-v-3cbae5fb]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:.25rem}.list-group-numbered[data-v-3cbae5fb]{list-style-type:none;counter-reset:section}.list-group-numbered>li[data-v-3cbae5fb]:before{content:counters(section,\".\") \". \";counter-increment:section}.list-group-item-action[data-v-3cbae5fb]{width:100%;color:#495057;text-align:inherit}.list-group-item-action[data-v-3cbae5fb]:focus,.list-group-item-action[data-v-3cbae5fb]:hover{z-index:1;color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action[data-v-3cbae5fb]:active{color:#212529;background-color:#e9ecef}.list-group-item[data-v-3cbae5fb]{position:relative;display:block;padding:.5rem 1rem;color:#212529;text-decoration:none;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item[data-v-3cbae5fb]:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.list-group-item[data-v-3cbae5fb]:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.list-group-item.disabled[data-v-3cbae5fb],.list-group-item[data-v-3cbae5fb]:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.list-group-item.active[data-v-3cbae5fb]{z-index:2;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.list-group-item+.list-group-item[data-v-3cbae5fb]{border-top-width:0}.list-group-item+.list-group-item.active[data-v-3cbae5fb]{margin-top:-1px;border-top-width:1px}.list-group-horizontal[data-v-3cbae5fb]{flex-direction:row}.list-group-horizontal>.list-group-item[data-v-3cbae5fb]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal>.list-group-item[data-v-3cbae5fb]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal>.list-group-item.active[data-v-3cbae5fb]{margin-top:0}.list-group-horizontal>.list-group-item+.list-group-item[data-v-3cbae5fb]{border-top-width:1px;border-left-width:0}.list-group-horizontal>.list-group-item+.list-group-item.active[data-v-3cbae5fb]{margin-left:-1px;border-left-width:1px}@media (min-width:576px){.list-group-horizontal-sm[data-v-3cbae5fb]{flex-direction:row}.list-group-horizontal-sm>.list-group-item[data-v-3cbae5fb]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-sm>.list-group-item[data-v-3cbae5fb]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-sm>.list-group-item.active[data-v-3cbae5fb]{margin-top:0}.list-group-horizontal-sm>.list-group-item+.list-group-item[data-v-3cbae5fb]{border-top-width:1px;border-left-width:0}.list-group-horizontal-sm>.list-group-item+.list-group-item.active[data-v-3cbae5fb]{margin-left:-1px;border-left-width:1px}}@media (min-width:768px){.list-group-horizontal-md[data-v-3cbae5fb]{flex-direction:row}.list-group-horizontal-md>.list-group-item[data-v-3cbae5fb]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-md>.list-group-item[data-v-3cbae5fb]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-md>.list-group-item.active[data-v-3cbae5fb]{margin-top:0}.list-group-horizontal-md>.list-group-item+.list-group-item[data-v-3cbae5fb]{border-top-width:1px;border-left-width:0}.list-group-horizontal-md>.list-group-item+.list-group-item.active[data-v-3cbae5fb]{margin-left:-1px;border-left-width:1px}}@media (min-width:992px){.list-group-horizontal-lg[data-v-3cbae5fb]{flex-direction:row}.list-group-horizontal-lg>.list-group-item[data-v-3cbae5fb]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-lg>.list-group-item[data-v-3cbae5fb]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-lg>.list-group-item.active[data-v-3cbae5fb]{margin-top:0}.list-group-horizontal-lg>.list-group-item+.list-group-item[data-v-3cbae5fb]{border-top-width:1px;border-left-width:0}.list-group-horizontal-lg>.list-group-item+.list-group-item.active[data-v-3cbae5fb]{margin-left:-1px;border-left-width:1px}}@media (min-width:1200px){.list-group-horizontal-xl[data-v-3cbae5fb]{flex-direction:row}.list-group-horizontal-xl>.list-group-item[data-v-3cbae5fb]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xl>.list-group-item[data-v-3cbae5fb]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xl>.list-group-item.active[data-v-3cbae5fb]{margin-top:0}.list-group-horizontal-xl>.list-group-item+.list-group-item[data-v-3cbae5fb]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xl>.list-group-item+.list-group-item.active[data-v-3cbae5fb]{margin-left:-1px;border-left-width:1px}}@media (min-width:1400px){.list-group-horizontal-xxl[data-v-3cbae5fb]{flex-direction:row}.list-group-horizontal-xxl>.list-group-item[data-v-3cbae5fb]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xxl>.list-group-item[data-v-3cbae5fb]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xxl>.list-group-item.active[data-v-3cbae5fb]{margin-top:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item[data-v-3cbae5fb]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item.active[data-v-3cbae5fb]{margin-left:-1px;border-left-width:1px}}.list-group-flush[data-v-3cbae5fb]{border-radius:0}.list-group-flush>.list-group-item[data-v-3cbae5fb]{border-width:0 0 1px}.list-group-flush>.list-group-item[data-v-3cbae5fb]:last-child{border-bottom-width:0}.list-group-item-primary[data-v-3cbae5fb]{color:#084298;background-color:#cfe2ff}.list-group-item-primary.list-group-item-action[data-v-3cbae5fb]:focus,.list-group-item-primary.list-group-item-action[data-v-3cbae5fb]:hover{color:#084298;background-color:#bacbe6}.list-group-item-primary.list-group-item-action.active[data-v-3cbae5fb]{color:#fff;background-color:#084298;border-color:#084298}.list-group-item-secondary[data-v-3cbae5fb]{color:#41464b;background-color:#e2e3e5}.list-group-item-secondary.list-group-item-action[data-v-3cbae5fb]:focus,.list-group-item-secondary.list-group-item-action[data-v-3cbae5fb]:hover{color:#41464b;background-color:#cbccce}.list-group-item-secondary.list-group-item-action.active[data-v-3cbae5fb]{color:#fff;background-color:#41464b;border-color:#41464b}.list-group-item-success[data-v-3cbae5fb]{color:#0f5132;background-color:#d1e7dd}.list-group-item-success.list-group-item-action[data-v-3cbae5fb]:focus,.list-group-item-success.list-group-item-action[data-v-3cbae5fb]:hover{color:#0f5132;background-color:#bcd0c7}.list-group-item-success.list-group-item-action.active[data-v-3cbae5fb]{color:#fff;background-color:#0f5132;border-color:#0f5132}.list-group-item-info[data-v-3cbae5fb]{color:#055160;background-color:#cff4fc}.list-group-item-info.list-group-item-action[data-v-3cbae5fb]:focus,.list-group-item-info.list-group-item-action[data-v-3cbae5fb]:hover{color:#055160;background-color:#badce3}.list-group-item-info.list-group-item-action.active[data-v-3cbae5fb]{color:#fff;background-color:#055160;border-color:#055160}.list-group-item-warning[data-v-3cbae5fb]{color:#664d03;background-color:#fff3cd}.list-group-item-warning.list-group-item-action[data-v-3cbae5fb]:focus,.list-group-item-warning.list-group-item-action[data-v-3cbae5fb]:hover{color:#664d03;background-color:#e6dbb9}.list-group-item-warning.list-group-item-action.active[data-v-3cbae5fb]{color:#fff;background-color:#664d03;border-color:#664d03}.list-group-item-danger[data-v-3cbae5fb]{color:#842029;background-color:#f8d7da}.list-group-item-danger.list-group-item-action[data-v-3cbae5fb]:focus,.list-group-item-danger.list-group-item-action[data-v-3cbae5fb]:hover{color:#842029;background-color:#dfc2c4}.list-group-item-danger.list-group-item-action.active[data-v-3cbae5fb]{color:#fff;background-color:#842029;border-color:#842029}.list-group-item-light[data-v-3cbae5fb]{color:#636464;background-color:#fefefe}.list-group-item-light.list-group-item-action[data-v-3cbae5fb]:focus,.list-group-item-light.list-group-item-action[data-v-3cbae5fb]:hover{color:#636464;background-color:#e5e5e5}.list-group-item-light.list-group-item-action.active[data-v-3cbae5fb]{color:#fff;background-color:#636464;border-color:#636464}.list-group-item-dark[data-v-3cbae5fb]{color:#141619;background-color:#d3d3d4}.list-group-item-dark.list-group-item-action[data-v-3cbae5fb]:focus,.list-group-item-dark.list-group-item-action[data-v-3cbae5fb]:hover{color:#141619;background-color:#bebebf}.list-group-item-dark.list-group-item-action.active[data-v-3cbae5fb]{color:#fff;background-color:#141619;border-color:#141619}.btn-close[data-v-3cbae5fb]{box-sizing:content-box;width:1em;height:1em;padding:.25em;color:#000;background:transparent url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M.293.293a1 1 0 11.414 0 NaN NaNlNaN NaN NaN NaNa1 1 0 111.414 1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 10-1.414 NaN NaNz'/%3E%3C/svg%3E\") 50%/1em auto no-repeat;border:0;border-radius:.25rem;opacity:.5}.btn-close[data-v-3cbae5fb]:hover{color:#000;text-decoration:none;opacity:.75}.btn-close[data-v-3cbae5fb]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25);opacity:1}.btn-close.disabled[data-v-3cbae5fb],.btn-close[data-v-3cbae5fb]:disabled{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;opacity:.25}.btn-close-white[data-v-3cbae5fb]{filter:invert(1) grayscale(100%) brightness(200%)}.toast[data-v-3cbae5fb]{width:350px;max-width:100%;font-size:.875rem;pointer-events:auto;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .5rem 1rem rgba(0,0,0,.15);border-radius:.25rem}.toast.showing[data-v-3cbae5fb]{opacity:0}.toast[data-v-3cbae5fb]:not(.show){display:none}.toast-container[data-v-3cbae5fb]{width:-webkit-max-content;width:-moz-max-content;width:max-content;max-width:100%;pointer-events:none}.toast-container[data-v-3cbae5fb]>:not(:last-child){margin-bottom:.75rem}.toast-header[data-v-3cbae5fb]{display:flex;align-items:center;padding:.5rem .75rem;color:#6c757d;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05);border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.toast-header .btn-close[data-v-3cbae5fb]{margin-right:-.375rem;margin-left:.75rem}.toast-body[data-v-3cbae5fb]{padding:.75rem;word-wrap:break-word}.modal[data-v-3cbae5fb]{position:fixed;top:0;left:0;z-index:1055;display:none;width:100%;height:100%;overflow-x:hidden;overflow-y:auto;outline:0}.modal-dialog[data-v-3cbae5fb]{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog[data-v-3cbae5fb]{transition:transform .3s ease-out;transform:translateY(-50px)}@media (prefers-reduced-motion:reduce){.modal.fade .modal-dialog[data-v-3cbae5fb]{transition:none}}.modal.show .modal-dialog[data-v-3cbae5fb]{transform:none}.modal.modal-static .modal-dialog[data-v-3cbae5fb]{transform:scale(1.02)}.modal-dialog-scrollable[data-v-3cbae5fb]{height:calc(100% - 1rem)}.modal-dialog-scrollable .modal-content[data-v-3cbae5fb]{max-height:100%;overflow:hidden}.modal-dialog-scrollable .modal-body[data-v-3cbae5fb]{overflow-y:auto}.modal-dialog-centered[data-v-3cbae5fb]{display:flex;align-items:center;min-height:calc(100% - 1rem)}.modal-content[data-v-3cbae5fb]{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop[data-v-3cbae5fb]{position:fixed;top:0;left:0;z-index:1050;width:100vw;height:100vh;background-color:#000}.modal-backdrop.fade[data-v-3cbae5fb]{opacity:0}.modal-backdrop.show[data-v-3cbae5fb]{opacity:.5}.modal-header[data-v-3cbae5fb]{display:flex;flex-shrink:0;align-items:center;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.modal-header .btn-close[data-v-3cbae5fb]{padding:.5rem;margin:-.5rem -.5rem -.5rem auto}.modal-title[data-v-3cbae5fb]{margin-bottom:0;line-height:1.5}.modal-body[data-v-3cbae5fb]{position:relative;flex:1 1 auto;padding:1rem}.modal-footer[data-v-3cbae5fb]{display:flex;flex-wrap:wrap;flex-shrink:0;align-items:center;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.modal-footer>[data-v-3cbae5fb]{margin:.25rem}@media (min-width:576px){.modal-dialog[data-v-3cbae5fb]{max-width:500px;margin:1.75rem auto}.modal-dialog-scrollable[data-v-3cbae5fb]{height:calc(100% - 3.5rem)}.modal-dialog-centered[data-v-3cbae5fb]{min-height:calc(100% - 3.5rem)}.modal-sm[data-v-3cbae5fb]{max-width:300px}}@media (min-width:992px){.modal-lg[data-v-3cbae5fb],.modal-xl[data-v-3cbae5fb]{max-width:800px}}@media (min-width:1200px){.modal-xl[data-v-3cbae5fb]{max-width:1140px}}.modal-fullscreen[data-v-3cbae5fb]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen .modal-content[data-v-3cbae5fb]{height:100%;border:0;border-radius:0}.modal-fullscreen .modal-header[data-v-3cbae5fb]{border-radius:0}.modal-fullscreen .modal-body[data-v-3cbae5fb]{overflow-y:auto}.modal-fullscreen .modal-footer[data-v-3cbae5fb]{border-radius:0}@media (max-width:575.98px){.modal-fullscreen-sm-down[data-v-3cbae5fb]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-sm-down .modal-content[data-v-3cbae5fb]{height:100%;border:0;border-radius:0}.modal-fullscreen-sm-down .modal-header[data-v-3cbae5fb]{border-radius:0}.modal-fullscreen-sm-down .modal-body[data-v-3cbae5fb]{overflow-y:auto}.modal-fullscreen-sm-down .modal-footer[data-v-3cbae5fb]{border-radius:0}}@media (max-width:767.98px){.modal-fullscreen-md-down[data-v-3cbae5fb]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-md-down .modal-content[data-v-3cbae5fb]{height:100%;border:0;border-radius:0}.modal-fullscreen-md-down .modal-header[data-v-3cbae5fb]{border-radius:0}.modal-fullscreen-md-down .modal-body[data-v-3cbae5fb]{overflow-y:auto}.modal-fullscreen-md-down .modal-footer[data-v-3cbae5fb]{border-radius:0}}@media (max-width:991.98px){.modal-fullscreen-lg-down[data-v-3cbae5fb]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-lg-down .modal-content[data-v-3cbae5fb]{height:100%;border:0;border-radius:0}.modal-fullscreen-lg-down .modal-header[data-v-3cbae5fb]{border-radius:0}.modal-fullscreen-lg-down .modal-body[data-v-3cbae5fb]{overflow-y:auto}.modal-fullscreen-lg-down .modal-footer[data-v-3cbae5fb]{border-radius:0}}@media (max-width:1199.98px){.modal-fullscreen-xl-down[data-v-3cbae5fb]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xl-down .modal-content[data-v-3cbae5fb]{height:100%;border:0;border-radius:0}.modal-fullscreen-xl-down .modal-header[data-v-3cbae5fb]{border-radius:0}.modal-fullscreen-xl-down .modal-body[data-v-3cbae5fb]{overflow-y:auto}.modal-fullscreen-xl-down .modal-footer[data-v-3cbae5fb]{border-radius:0}}@media (max-width:1399.98px){.modal-fullscreen-xxl-down[data-v-3cbae5fb]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xxl-down .modal-content[data-v-3cbae5fb]{height:100%;border:0;border-radius:0}.modal-fullscreen-xxl-down .modal-header[data-v-3cbae5fb]{border-radius:0}.modal-fullscreen-xxl-down .modal-body[data-v-3cbae5fb]{overflow-y:auto}.modal-fullscreen-xxl-down .modal-footer[data-v-3cbae5fb]{border-radius:0}}.tooltip[data-v-3cbae5fb]{position:absolute;z-index:1080;display:block;margin:0;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show[data-v-3cbae5fb]{opacity:.9}.tooltip .tooltip-arrow[data-v-3cbae5fb]{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .tooltip-arrow[data-v-3cbae5fb]:before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[data-popper-placement^=top][data-v-3cbae5fb],.bs-tooltip-top[data-v-3cbae5fb]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-3cbae5fb],.bs-tooltip-top .tooltip-arrow[data-v-3cbae5fb]{bottom:0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-3cbae5fb]:before,.bs-tooltip-top .tooltip-arrow[data-v-3cbae5fb]:before{top:-1px;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[data-popper-placement^=right][data-v-3cbae5fb],.bs-tooltip-end[data-v-3cbae5fb]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-3cbae5fb],.bs-tooltip-end .tooltip-arrow[data-v-3cbae5fb]{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-3cbae5fb]:before,.bs-tooltip-end .tooltip-arrow[data-v-3cbae5fb]:before{right:-1px;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[data-popper-placement^=bottom][data-v-3cbae5fb],.bs-tooltip-bottom[data-v-3cbae5fb]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-3cbae5fb],.bs-tooltip-bottom .tooltip-arrow[data-v-3cbae5fb]{top:0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-3cbae5fb]:before,.bs-tooltip-bottom .tooltip-arrow[data-v-3cbae5fb]:before{bottom:-1px;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[data-popper-placement^=left][data-v-3cbae5fb],.bs-tooltip-start[data-v-3cbae5fb]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-3cbae5fb],.bs-tooltip-start .tooltip-arrow[data-v-3cbae5fb]{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-3cbae5fb]:before,.bs-tooltip-start .tooltip-arrow[data-v-3cbae5fb]:before{left:-1px;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner[data-v-3cbae5fb]{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover[data-v-3cbae5fb]{position:absolute;top:0;left:0;z-index:1070;display:block;max-width:276px;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover .popover-arrow[data-v-3cbae5fb]{position:absolute;display:block;width:1rem;height:.5rem}.popover .popover-arrow[data-v-3cbae5fb]:after,.popover .popover-arrow[data-v-3cbae5fb]:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-3cbae5fb],.bs-popover-top>.popover-arrow[data-v-3cbae5fb]{bottom:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-3cbae5fb]:before,.bs-popover-top>.popover-arrow[data-v-3cbae5fb]:before{bottom:0;border-width:.5rem .5rem 0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-3cbae5fb]:after,.bs-popover-top>.popover-arrow[data-v-3cbae5fb]:after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:#fff}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-3cbae5fb],.bs-popover-end>.popover-arrow[data-v-3cbae5fb]{left:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-3cbae5fb]:before,.bs-popover-end>.popover-arrow[data-v-3cbae5fb]:before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-3cbae5fb]:after,.bs-popover-end>.popover-arrow[data-v-3cbae5fb]:after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:#fff}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-3cbae5fb],.bs-popover-bottom>.popover-arrow[data-v-3cbae5fb]{top:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-3cbae5fb]:before,.bs-popover-bottom>.popover-arrow[data-v-3cbae5fb]:before{top:0;border-width:0 .5rem .5rem;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-3cbae5fb]:after,.bs-popover-bottom>.popover-arrow[data-v-3cbae5fb]:after{top:1px;border-width:0 .5rem .5rem;border-bottom-color:#fff}.bs-popover-auto[data-popper-placement^=bottom] .popover-header[data-v-3cbae5fb]:before,.bs-popover-bottom .popover-header[data-v-3cbae5fb]:before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f0f0f0}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-3cbae5fb],.bs-popover-start>.popover-arrow[data-v-3cbae5fb]{right:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-3cbae5fb]:before,.bs-popover-start>.popover-arrow[data-v-3cbae5fb]:before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-3cbae5fb]:after,.bs-popover-start>.popover-arrow[data-v-3cbae5fb]:after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:#fff}.popover-header[data-v-3cbae5fb]{padding:.5rem 1rem;margin-bottom:0;font-size:1rem;background-color:#f0f0f0;border-bottom:1px solid rgba(0,0,0,.2);border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header[data-v-3cbae5fb]:empty{display:none}.popover-body[data-v-3cbae5fb]{padding:1rem;color:#212529}.carousel[data-v-3cbae5fb]{position:relative}.carousel.pointer-event[data-v-3cbae5fb]{touch-action:pan-y}.carousel-inner[data-v-3cbae5fb]{position:relative;width:100%;overflow:hidden}.carousel-inner[data-v-3cbae5fb]:after{display:block;clear:both;content:\"\"}.carousel-item[data-v-3cbae5fb]{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.carousel-item[data-v-3cbae5fb]{transition:none}}.carousel-item-next[data-v-3cbae5fb],.carousel-item-prev[data-v-3cbae5fb],.carousel-item.active[data-v-3cbae5fb]{display:block}.active.carousel-item-end[data-v-3cbae5fb],.carousel-item-next[data-v-3cbae5fb]:not(.carousel-item-start){transform:translateX(100%)}.active.carousel-item-start[data-v-3cbae5fb],.carousel-item-prev[data-v-3cbae5fb]:not(.carousel-item-end){transform:translateX(-100%)}.carousel-fade .carousel-item[data-v-3cbae5fb]{opacity:0;transition-property:opacity;transform:none}.carousel-fade .carousel-item-next.carousel-item-start[data-v-3cbae5fb],.carousel-fade .carousel-item-prev.carousel-item-end[data-v-3cbae5fb],.carousel-fade .carousel-item.active[data-v-3cbae5fb]{z-index:1;opacity:1}.carousel-fade .active.carousel-item-end[data-v-3cbae5fb],.carousel-fade .active.carousel-item-start[data-v-3cbae5fb]{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.carousel-fade .active.carousel-item-end[data-v-3cbae5fb],.carousel-fade .active.carousel-item-start[data-v-3cbae5fb]{transition:none}}.carousel-control-next[data-v-3cbae5fb],.carousel-control-prev[data-v-3cbae5fb]{position:absolute;top:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center;width:15%;padding:0;color:#fff;text-align:center;background:0 0;border:0;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.carousel-control-next[data-v-3cbae5fb],.carousel-control-prev[data-v-3cbae5fb]{transition:none}}.carousel-control-next[data-v-3cbae5fb]:focus,.carousel-control-next[data-v-3cbae5fb]:hover,.carousel-control-prev[data-v-3cbae5fb]:focus,.carousel-control-prev[data-v-3cbae5fb]:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev[data-v-3cbae5fb]{left:0}.carousel-control-next[data-v-3cbae5fb]{right:0}.carousel-control-next-icon[data-v-3cbae5fb],.carousel-control-prev-icon[data-v-3cbae5fb]{display:inline-block;width:2rem;height:2rem;background-repeat:no-repeat;background-position:50%;background-size:100% 100%}.carousel-control-prev-icon[data-v-3cbae5fb]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3E%3C/svg%3E\")}.carousel-control-next-icon[data-v-3cbae5fb]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\")}.carousel-indicators[data-v-3cbae5fb]{position:absolute;right:0;bottom:0;left:0;z-index:2;display:flex;justify-content:center;padding:0;margin-right:15%;margin-bottom:1rem;margin-left:15%;list-style:none}.carousel-indicators [data-bs-target][data-v-3cbae5fb]{box-sizing:content-box;flex:0 1 auto;width:30px;height:3px;padding:0;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border:0;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.carousel-indicators [data-bs-target][data-v-3cbae5fb]{transition:none}}.carousel-indicators .active[data-v-3cbae5fb]{opacity:1}.carousel-caption[data-v-3cbae5fb]{position:absolute;right:15%;bottom:1.25rem;left:15%;padding-top:1.25rem;padding-bottom:1.25rem;color:#fff;text-align:center}.carousel-dark .carousel-control-next-icon[data-v-3cbae5fb],.carousel-dark .carousel-control-prev-icon[data-v-3cbae5fb]{filter:invert(1) grayscale(100)}.carousel-dark .carousel-indicators [data-bs-target][data-v-3cbae5fb]{background-color:#000}.carousel-dark .carousel-caption[data-v-3cbae5fb]{color:#000}@-webkit-keyframes spinner-border-data-v-3cbae5fb{to{transform:rotate(1turn)}}@keyframes spinner-border-data-v-3cbae5fb{to{transform:rotate(1turn)}}.spinner-border[data-v-3cbae5fb]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:.75s linear infinite spinner-border-data-v-3cbae5fb;animation:.75s linear infinite spinner-border-data-v-3cbae5fb}.spinner-border-sm[data-v-3cbae5fb]{width:1rem;height:1rem;border-width:.2em}@-webkit-keyframes spinner-grow-data-v-3cbae5fb{0%{transform:scale(0)}50%{opacity:1;transform:none}}@keyframes spinner-grow-data-v-3cbae5fb{0%{transform:scale(0)}50%{opacity:1;transform:none}}.spinner-grow[data-v-3cbae5fb]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;background-color:currentColor;border-radius:50%;opacity:0;-webkit-animation:.75s linear infinite spinner-grow-data-v-3cbae5fb;animation:.75s linear infinite spinner-grow-data-v-3cbae5fb}.spinner-grow-sm[data-v-3cbae5fb]{width:1rem;height:1rem}@media (prefers-reduced-motion:reduce){.spinner-border[data-v-3cbae5fb],.spinner-grow[data-v-3cbae5fb]{-webkit-animation-duration:1.5s;animation-duration:1.5s}}.offcanvas[data-v-3cbae5fb]{position:fixed;bottom:0;z-index:1045;display:flex;flex-direction:column;max-width:100%;visibility:hidden;background-color:#fff;background-clip:padding-box;outline:0;transition:transform .3s ease-in-out}@media (prefers-reduced-motion:reduce){.offcanvas[data-v-3cbae5fb]{transition:none}}.offcanvas-backdrop[data-v-3cbae5fb]{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.offcanvas-backdrop.fade[data-v-3cbae5fb]{opacity:0}.offcanvas-backdrop.show[data-v-3cbae5fb]{opacity:.5}.offcanvas-header[data-v-3cbae5fb]{display:flex;align-items:center;justify-content:space-between;padding:1rem}.offcanvas-header .btn-close[data-v-3cbae5fb]{padding:.5rem;margin-top:-.5rem;margin-right:-.5rem;margin-bottom:-.5rem}.offcanvas-title[data-v-3cbae5fb]{margin-bottom:0;line-height:1.5}.offcanvas-body[data-v-3cbae5fb]{flex-grow:1;padding:1rem;overflow-y:auto}.offcanvas-start[data-v-3cbae5fb]{top:0;left:0;width:400px;border-right:1px solid rgba(0,0,0,.2);transform:translateX(-100%)}.offcanvas-end[data-v-3cbae5fb]{top:0;right:0;width:400px;border-left:1px solid rgba(0,0,0,.2);transform:translateX(100%)}.offcanvas-top[data-v-3cbae5fb]{top:0;right:0;left:0;height:30vh;max-height:100%;border-bottom:1px solid rgba(0,0,0,.2);transform:translateY(-100%)}.offcanvas-bottom[data-v-3cbae5fb]{right:0;left:0;height:30vh;max-height:100%;border-top:1px solid rgba(0,0,0,.2);transform:translateY(100%)}.offcanvas.show[data-v-3cbae5fb]{transform:none}.placeholder[data-v-3cbae5fb]{display:inline-block;min-height:1em;vertical-align:middle;cursor:wait;background-color:currentColor;opacity:.5}.placeholder.btn[data-v-3cbae5fb]:before{display:inline-block;content:\"\"}.placeholder-xs[data-v-3cbae5fb]{min-height:.6em}.placeholder-sm[data-v-3cbae5fb]{min-height:.8em}.placeholder-lg[data-v-3cbae5fb]{min-height:1.2em}.placeholder-glow .placeholder[data-v-3cbae5fb]{-webkit-animation:placeholder-glow-data-v-3cbae5fb 2s ease-in-out infinite;animation:placeholder-glow-data-v-3cbae5fb 2s ease-in-out infinite}@-webkit-keyframes placeholder-glow-data-v-3cbae5fb{50%{opacity:.2}}@keyframes placeholder-glow-data-v-3cbae5fb{50%{opacity:.2}}.placeholder-wave[data-v-3cbae5fb]{-webkit-mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);-webkit-mask-size:200% 100%;mask-size:200% 100%;-webkit-animation:placeholder-wave-data-v-3cbae5fb 2s linear infinite;animation:placeholder-wave-data-v-3cbae5fb 2s linear infinite}@-webkit-keyframes placeholder-wave-data-v-3cbae5fb{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}@keyframes placeholder-wave-data-v-3cbae5fb{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}.clearfix[data-v-3cbae5fb]:after{display:block;clear:both;content:\"\"}.link-primary[data-v-3cbae5fb]{color:#0d6efd}.link-primary[data-v-3cbae5fb]:focus,.link-primary[data-v-3cbae5fb]:hover{color:#0a58ca}.link-secondary[data-v-3cbae5fb]{color:#6c757d}.link-secondary[data-v-3cbae5fb]:focus,.link-secondary[data-v-3cbae5fb]:hover{color:#565e64}.link-success[data-v-3cbae5fb]{color:#198754}.link-success[data-v-3cbae5fb]:focus,.link-success[data-v-3cbae5fb]:hover{color:#146c43}.link-info[data-v-3cbae5fb]{color:#0dcaf0}.link-info[data-v-3cbae5fb]:focus,.link-info[data-v-3cbae5fb]:hover{color:#3dd5f3}.link-warning[data-v-3cbae5fb]{color:#ffc107}.link-warning[data-v-3cbae5fb]:focus,.link-warning[data-v-3cbae5fb]:hover{color:#ffcd39}.link-danger[data-v-3cbae5fb]{color:#dc3545}.link-danger[data-v-3cbae5fb]:focus,.link-danger[data-v-3cbae5fb]:hover{color:#b02a37}.link-light[data-v-3cbae5fb]{color:#f8f9fa}.link-light[data-v-3cbae5fb]:focus,.link-light[data-v-3cbae5fb]:hover{color:#f9fafb}.link-dark[data-v-3cbae5fb]{color:#212529}.link-dark[data-v-3cbae5fb]:focus,.link-dark[data-v-3cbae5fb]:hover{color:#1a1e21}.ratio[data-v-3cbae5fb]{position:relative;width:100%}.ratio[data-v-3cbae5fb]:before{display:block;padding-top:var(--bs-aspect-ratio);content:\"\"}.ratio>[data-v-3cbae5fb]{position:absolute;top:0;left:0;width:100%;height:100%}.ratio-1x1[data-v-3cbae5fb]{--bs-aspect-ratio:100%}.ratio-4x3[data-v-3cbae5fb]{--bs-aspect-ratio:75%}.ratio-16x9[data-v-3cbae5fb]{--bs-aspect-ratio:56.25%}.ratio-21x9[data-v-3cbae5fb]{--bs-aspect-ratio:42.8571428571%}.fixed-top[data-v-3cbae5fb]{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom[data-v-3cbae5fb]{position:fixed;right:0;bottom:0;left:0;z-index:1030}.sticky-top[data-v-3cbae5fb]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}@media (min-width:576px){.sticky-sm-top[data-v-3cbae5fb]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:768px){.sticky-md-top[data-v-3cbae5fb]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:992px){.sticky-lg-top[data-v-3cbae5fb]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1200px){.sticky-xl-top[data-v-3cbae5fb]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1400px){.sticky-xxl-top[data-v-3cbae5fb]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.hstack[data-v-3cbae5fb]{display:flex;flex-direction:row;align-items:center;align-self:stretch}.vstack[data-v-3cbae5fb]{display:flex;flex:1 1 auto;flex-direction:column;align-self:stretch}.visually-hidden-focusable[data-v-3cbae5fb]:not(:focus):not(:focus-within),.visually-hidden[data-v-3cbae5fb]{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}.stretched-link[data-v-3cbae5fb]:after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;content:\"\"}.text-truncate[data-v-3cbae5fb]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.vr[data-v-3cbae5fb]{display:inline-block;align-self:stretch;width:1px;min-height:1em;background-color:currentColor;opacity:.25}.align-baseline[data-v-3cbae5fb]{vertical-align:baseline!important}.align-top[data-v-3cbae5fb]{vertical-align:top!important}.align-middle[data-v-3cbae5fb]{vertical-align:middle!important}.align-bottom[data-v-3cbae5fb]{vertical-align:bottom!important}.align-text-bottom[data-v-3cbae5fb]{vertical-align:text-bottom!important}.align-text-top[data-v-3cbae5fb]{vertical-align:text-top!important}.float-start[data-v-3cbae5fb]{float:left!important}.float-end[data-v-3cbae5fb]{float:right!important}.float-none[data-v-3cbae5fb]{float:none!important}.opacity-0[data-v-3cbae5fb]{opacity:0!important}.opacity-25[data-v-3cbae5fb]{opacity:.25!important}.opacity-50[data-v-3cbae5fb]{opacity:.5!important}.opacity-75[data-v-3cbae5fb]{opacity:.75!important}.opacity-100[data-v-3cbae5fb]{opacity:1!important}.overflow-auto[data-v-3cbae5fb]{overflow:auto!important}.overflow-hidden[data-v-3cbae5fb]{overflow:hidden!important}.overflow-visible[data-v-3cbae5fb]{overflow:visible!important}.overflow-scroll[data-v-3cbae5fb]{overflow:scroll!important}.d-inline[data-v-3cbae5fb]{display:inline!important}.d-inline-block[data-v-3cbae5fb]{display:inline-block!important}.d-block[data-v-3cbae5fb]{display:block!important}.d-grid[data-v-3cbae5fb]{display:grid!important}.d-table[data-v-3cbae5fb]{display:table!important}.d-table-row[data-v-3cbae5fb]{display:table-row!important}.d-table-cell[data-v-3cbae5fb]{display:table-cell!important}.d-flex[data-v-3cbae5fb]{display:flex!important}.d-inline-flex[data-v-3cbae5fb]{display:inline-flex!important}.d-none[data-v-3cbae5fb]{display:none!important}.shadow[data-v-3cbae5fb]{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.shadow-sm[data-v-3cbae5fb]{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.shadow-lg[data-v-3cbae5fb]{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.shadow-none[data-v-3cbae5fb]{box-shadow:none!important}.position-static[data-v-3cbae5fb]{position:static!important}.position-relative[data-v-3cbae5fb]{position:relative!important}.position-absolute[data-v-3cbae5fb]{position:absolute!important}.position-fixed[data-v-3cbae5fb]{position:fixed!important}.position-sticky[data-v-3cbae5fb]{position:-webkit-sticky!important;position:sticky!important}.top-0[data-v-3cbae5fb]{top:0!important}.top-50[data-v-3cbae5fb]{top:50%!important}.top-100[data-v-3cbae5fb]{top:100%!important}.bottom-0[data-v-3cbae5fb]{bottom:0!important}.bottom-50[data-v-3cbae5fb]{bottom:50%!important}.bottom-100[data-v-3cbae5fb]{bottom:100%!important}.start-0[data-v-3cbae5fb]{left:0!important}.start-50[data-v-3cbae5fb]{left:50%!important}.start-100[data-v-3cbae5fb]{left:100%!important}.end-0[data-v-3cbae5fb]{right:0!important}.end-50[data-v-3cbae5fb]{right:50%!important}.end-100[data-v-3cbae5fb]{right:100%!important}.translate-middle[data-v-3cbae5fb]{transform:translate(-50%,-50%)!important}.translate-middle-x[data-v-3cbae5fb]{transform:translateX(-50%)!important}.translate-middle-y[data-v-3cbae5fb]{transform:translateY(-50%)!important}.border[data-v-3cbae5fb]{border:1px solid #dee2e6!important}.border-0[data-v-3cbae5fb]{border:0!important}.border-top[data-v-3cbae5fb]{border-top:1px solid #dee2e6!important}.border-top-0[data-v-3cbae5fb]{border-top:0!important}.border-end[data-v-3cbae5fb]{border-right:1px solid #dee2e6!important}.border-end-0[data-v-3cbae5fb]{border-right:0!important}.border-bottom[data-v-3cbae5fb]{border-bottom:1px solid #dee2e6!important}.border-bottom-0[data-v-3cbae5fb]{border-bottom:0!important}.border-start[data-v-3cbae5fb]{border-left:1px solid #dee2e6!important}.border-start-0[data-v-3cbae5fb]{border-left:0!important}.border-primary[data-v-3cbae5fb]{border-color:#0d6efd!important}.border-secondary[data-v-3cbae5fb]{border-color:#6c757d!important}.border-success[data-v-3cbae5fb]{border-color:#198754!important}.border-info[data-v-3cbae5fb]{border-color:#0dcaf0!important}.border-warning[data-v-3cbae5fb]{border-color:#ffc107!important}.border-danger[data-v-3cbae5fb]{border-color:#dc3545!important}.border-light[data-v-3cbae5fb]{border-color:#f8f9fa!important}.border-dark[data-v-3cbae5fb]{border-color:#212529!important}.border-white[data-v-3cbae5fb]{border-color:#fff!important}.border-1[data-v-3cbae5fb]{border-width:1px!important}.border-2[data-v-3cbae5fb]{border-width:2px!important}.border-3[data-v-3cbae5fb]{border-width:3px!important}.border-4[data-v-3cbae5fb]{border-width:4px!important}.border-5[data-v-3cbae5fb]{border-width:5px!important}.w-25[data-v-3cbae5fb]{width:25%!important}.w-50[data-v-3cbae5fb]{width:50%!important}.w-75[data-v-3cbae5fb]{width:75%!important}.w-100[data-v-3cbae5fb]{width:100%!important}.w-auto[data-v-3cbae5fb]{width:auto!important}.mw-100[data-v-3cbae5fb]{max-width:100%!important}.vw-100[data-v-3cbae5fb]{width:100vw!important}.min-vw-100[data-v-3cbae5fb]{min-width:100vw!important}.h-25[data-v-3cbae5fb]{height:25%!important}.h-50[data-v-3cbae5fb]{height:50%!important}.h-75[data-v-3cbae5fb]{height:75%!important}.h-100[data-v-3cbae5fb]{height:100%!important}.h-auto[data-v-3cbae5fb]{height:auto!important}.mh-100[data-v-3cbae5fb]{max-height:100%!important}.vh-100[data-v-3cbae5fb]{height:100vh!important}.min-vh-100[data-v-3cbae5fb]{min-height:100vh!important}.flex-fill[data-v-3cbae5fb]{flex:1 1 auto!important}.flex-row[data-v-3cbae5fb]{flex-direction:row!important}.flex-column[data-v-3cbae5fb]{flex-direction:column!important}.flex-row-reverse[data-v-3cbae5fb]{flex-direction:row-reverse!important}.flex-column-reverse[data-v-3cbae5fb]{flex-direction:column-reverse!important}.flex-grow-0[data-v-3cbae5fb]{flex-grow:0!important}.flex-grow-1[data-v-3cbae5fb]{flex-grow:1!important}.flex-shrink-0[data-v-3cbae5fb]{flex-shrink:0!important}.flex-shrink-1[data-v-3cbae5fb]{flex-shrink:1!important}.flex-wrap[data-v-3cbae5fb]{flex-wrap:wrap!important}.flex-nowrap[data-v-3cbae5fb]{flex-wrap:nowrap!important}.flex-wrap-reverse[data-v-3cbae5fb]{flex-wrap:wrap-reverse!important}.gap-0[data-v-3cbae5fb]{gap:0!important}.gap-1[data-v-3cbae5fb]{gap:.25rem!important}.gap-2[data-v-3cbae5fb]{gap:.5rem!important}.gap-3[data-v-3cbae5fb]{gap:1rem!important}.gap-4[data-v-3cbae5fb]{gap:1.5rem!important}.gap-5[data-v-3cbae5fb]{gap:3rem!important}.justify-content-start[data-v-3cbae5fb]{justify-content:flex-start!important}.justify-content-end[data-v-3cbae5fb]{justify-content:flex-end!important}.justify-content-center[data-v-3cbae5fb]{justify-content:center!important}.justify-content-between[data-v-3cbae5fb]{justify-content:space-between!important}.justify-content-around[data-v-3cbae5fb]{justify-content:space-around!important}.justify-content-evenly[data-v-3cbae5fb]{justify-content:space-evenly!important}.align-items-start[data-v-3cbae5fb]{align-items:flex-start!important}.align-items-end[data-v-3cbae5fb]{align-items:flex-end!important}.align-items-center[data-v-3cbae5fb]{align-items:center!important}.align-items-baseline[data-v-3cbae5fb]{align-items:baseline!important}.align-items-stretch[data-v-3cbae5fb]{align-items:stretch!important}.align-content-start[data-v-3cbae5fb]{align-content:flex-start!important}.align-content-end[data-v-3cbae5fb]{align-content:flex-end!important}.align-content-center[data-v-3cbae5fb]{align-content:center!important}.align-content-between[data-v-3cbae5fb]{align-content:space-between!important}.align-content-around[data-v-3cbae5fb]{align-content:space-around!important}.align-content-stretch[data-v-3cbae5fb]{align-content:stretch!important}.align-self-auto[data-v-3cbae5fb]{align-self:auto!important}.align-self-start[data-v-3cbae5fb]{align-self:flex-start!important}.align-self-end[data-v-3cbae5fb]{align-self:flex-end!important}.align-self-center[data-v-3cbae5fb]{align-self:center!important}.align-self-baseline[data-v-3cbae5fb]{align-self:baseline!important}.align-self-stretch[data-v-3cbae5fb]{align-self:stretch!important}.order-first[data-v-3cbae5fb]{order:-1!important}.order-0[data-v-3cbae5fb]{order:0!important}.order-1[data-v-3cbae5fb]{order:1!important}.order-2[data-v-3cbae5fb]{order:2!important}.order-3[data-v-3cbae5fb]{order:3!important}.order-4[data-v-3cbae5fb]{order:4!important}.order-5[data-v-3cbae5fb]{order:5!important}.order-last[data-v-3cbae5fb]{order:6!important}.m-0[data-v-3cbae5fb]{margin:0!important}.m-1[data-v-3cbae5fb]{margin:.25rem!important}.m-2[data-v-3cbae5fb]{margin:.5rem!important}.m-3[data-v-3cbae5fb]{margin:1rem!important}.m-4[data-v-3cbae5fb]{margin:1.5rem!important}.m-5[data-v-3cbae5fb]{margin:3rem!important}.m-auto[data-v-3cbae5fb]{margin:auto!important}.mx-0[data-v-3cbae5fb]{margin-right:0!important;margin-left:0!important}.mx-1[data-v-3cbae5fb]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-2[data-v-3cbae5fb]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-3[data-v-3cbae5fb]{margin-right:1rem!important;margin-left:1rem!important}.mx-4[data-v-3cbae5fb]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-5[data-v-3cbae5fb]{margin-right:3rem!important;margin-left:3rem!important}.mx-auto[data-v-3cbae5fb]{margin-right:auto!important;margin-left:auto!important}.my-0[data-v-3cbae5fb]{margin-top:0!important;margin-bottom:0!important}.my-1[data-v-3cbae5fb]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-2[data-v-3cbae5fb]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-3[data-v-3cbae5fb]{margin-top:1rem!important;margin-bottom:1rem!important}.my-4[data-v-3cbae5fb]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-5[data-v-3cbae5fb]{margin-top:3rem!important;margin-bottom:3rem!important}.my-auto[data-v-3cbae5fb]{margin-top:auto!important;margin-bottom:auto!important}.mt-0[data-v-3cbae5fb]{margin-top:0!important}.mt-1[data-v-3cbae5fb]{margin-top:.25rem!important}.mt-2[data-v-3cbae5fb]{margin-top:.5rem!important}.mt-3[data-v-3cbae5fb]{margin-top:1rem!important}.mt-4[data-v-3cbae5fb]{margin-top:1.5rem!important}.mt-5[data-v-3cbae5fb]{margin-top:3rem!important}.mt-auto[data-v-3cbae5fb]{margin-top:auto!important}.me-0[data-v-3cbae5fb]{margin-right:0!important}.me-1[data-v-3cbae5fb]{margin-right:.25rem!important}.me-2[data-v-3cbae5fb]{margin-right:.5rem!important}.me-3[data-v-3cbae5fb]{margin-right:1rem!important}.me-4[data-v-3cbae5fb]{margin-right:1.5rem!important}.me-5[data-v-3cbae5fb]{margin-right:3rem!important}.me-auto[data-v-3cbae5fb]{margin-right:auto!important}.mb-0[data-v-3cbae5fb]{margin-bottom:0!important}.mb-1[data-v-3cbae5fb]{margin-bottom:.25rem!important}.mb-2[data-v-3cbae5fb]{margin-bottom:.5rem!important}.mb-3[data-v-3cbae5fb]{margin-bottom:1rem!important}.mb-4[data-v-3cbae5fb]{margin-bottom:1.5rem!important}.mb-5[data-v-3cbae5fb]{margin-bottom:3rem!important}.mb-auto[data-v-3cbae5fb]{margin-bottom:auto!important}.ms-0[data-v-3cbae5fb]{margin-left:0!important}.ms-1[data-v-3cbae5fb]{margin-left:.25rem!important}.ms-2[data-v-3cbae5fb]{margin-left:.5rem!important}.ms-3[data-v-3cbae5fb]{margin-left:1rem!important}.ms-4[data-v-3cbae5fb]{margin-left:1.5rem!important}.ms-5[data-v-3cbae5fb]{margin-left:3rem!important}.ms-auto[data-v-3cbae5fb]{margin-left:auto!important}.p-0[data-v-3cbae5fb]{padding:0!important}.p-1[data-v-3cbae5fb]{padding:.25rem!important}.p-2[data-v-3cbae5fb]{padding:.5rem!important}.p-3[data-v-3cbae5fb]{padding:1rem!important}.p-4[data-v-3cbae5fb]{padding:1.5rem!important}.p-5[data-v-3cbae5fb]{padding:3rem!important}.px-0[data-v-3cbae5fb]{padding-right:0!important;padding-left:0!important}.px-1[data-v-3cbae5fb]{padding-right:.25rem!important;padding-left:.25rem!important}.px-2[data-v-3cbae5fb]{padding-right:.5rem!important;padding-left:.5rem!important}.px-3[data-v-3cbae5fb]{padding-right:1rem!important;padding-left:1rem!important}.px-4[data-v-3cbae5fb]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-5[data-v-3cbae5fb]{padding-right:3rem!important;padding-left:3rem!important}.py-0[data-v-3cbae5fb]{padding-top:0!important;padding-bottom:0!important}.py-1[data-v-3cbae5fb]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-2[data-v-3cbae5fb]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-3[data-v-3cbae5fb]{padding-top:1rem!important;padding-bottom:1rem!important}.py-4[data-v-3cbae5fb]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-5[data-v-3cbae5fb]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-0[data-v-3cbae5fb]{padding-top:0!important}.pt-1[data-v-3cbae5fb]{padding-top:.25rem!important}.pt-2[data-v-3cbae5fb]{padding-top:.5rem!important}.pt-3[data-v-3cbae5fb]{padding-top:1rem!important}.pt-4[data-v-3cbae5fb]{padding-top:1.5rem!important}.pt-5[data-v-3cbae5fb]{padding-top:3rem!important}.pe-0[data-v-3cbae5fb]{padding-right:0!important}.pe-1[data-v-3cbae5fb]{padding-right:.25rem!important}.pe-2[data-v-3cbae5fb]{padding-right:.5rem!important}.pe-3[data-v-3cbae5fb]{padding-right:1rem!important}.pe-4[data-v-3cbae5fb]{padding-right:1.5rem!important}.pe-5[data-v-3cbae5fb]{padding-right:3rem!important}.pb-0[data-v-3cbae5fb]{padding-bottom:0!important}.pb-1[data-v-3cbae5fb]{padding-bottom:.25rem!important}.pb-2[data-v-3cbae5fb]{padding-bottom:.5rem!important}.pb-3[data-v-3cbae5fb]{padding-bottom:1rem!important}.pb-4[data-v-3cbae5fb]{padding-bottom:1.5rem!important}.pb-5[data-v-3cbae5fb]{padding-bottom:3rem!important}.ps-0[data-v-3cbae5fb]{padding-left:0!important}.ps-1[data-v-3cbae5fb]{padding-left:.25rem!important}.ps-2[data-v-3cbae5fb]{padding-left:.5rem!important}.ps-3[data-v-3cbae5fb]{padding-left:1rem!important}.ps-4[data-v-3cbae5fb]{padding-left:1.5rem!important}.ps-5[data-v-3cbae5fb]{padding-left:3rem!important}.font-monospace[data-v-3cbae5fb]{font-family:var(--bs-font-monospace)!important}.fs-1[data-v-3cbae5fb]{font-size:calc(1.375rem + 1.5vw)!important}.fs-2[data-v-3cbae5fb]{font-size:calc(1.325rem + .9vw)!important}.fs-3[data-v-3cbae5fb]{font-size:calc(1.3rem + .6vw)!important}.fs-4[data-v-3cbae5fb]{font-size:calc(1.275rem + .3vw)!important}.fs-5[data-v-3cbae5fb]{font-size:1.25rem!important}.fs-6[data-v-3cbae5fb]{font-size:1rem!important}.fst-italic[data-v-3cbae5fb]{font-style:italic!important}.fst-normal[data-v-3cbae5fb]{font-style:normal!important}.fw-light[data-v-3cbae5fb]{font-weight:300!important}.fw-lighter[data-v-3cbae5fb]{font-weight:lighter!important}.fw-normal[data-v-3cbae5fb]{font-weight:400!important}.fw-bold[data-v-3cbae5fb]{font-weight:700!important}.fw-bolder[data-v-3cbae5fb]{font-weight:bolder!important}.lh-1[data-v-3cbae5fb]{line-height:1!important}.lh-sm[data-v-3cbae5fb]{line-height:1.25!important}.lh-base[data-v-3cbae5fb]{line-height:1.5!important}.lh-lg[data-v-3cbae5fb]{line-height:2!important}.text-start[data-v-3cbae5fb]{text-align:left!important}.text-end[data-v-3cbae5fb]{text-align:right!important}.text-center[data-v-3cbae5fb]{text-align:center!important}.text-decoration-none[data-v-3cbae5fb]{text-decoration:none!important}.text-decoration-underline[data-v-3cbae5fb]{text-decoration:underline!important}.text-decoration-line-through[data-v-3cbae5fb]{text-decoration:line-through!important}.text-lowercase[data-v-3cbae5fb]{text-transform:lowercase!important}.text-uppercase[data-v-3cbae5fb]{text-transform:uppercase!important}.text-capitalize[data-v-3cbae5fb]{text-transform:capitalize!important}.text-wrap[data-v-3cbae5fb]{white-space:normal!important}.text-nowrap[data-v-3cbae5fb]{white-space:nowrap!important}.text-break[data-v-3cbae5fb]{word-wrap:break-word!important;word-break:break-word!important}.text-primary[data-v-3cbae5fb]{--bs-text-opacity:1;color:rgba(var(--bs-primary-rgb),var(--bs-text-opacity))!important}.text-secondary[data-v-3cbae5fb]{--bs-text-opacity:1;color:rgba(var(--bs-secondary-rgb),var(--bs-text-opacity))!important}.text-success[data-v-3cbae5fb]{--bs-text-opacity:1;color:rgba(var(--bs-success-rgb),var(--bs-text-opacity))!important}.text-info[data-v-3cbae5fb]{--bs-text-opacity:1;color:rgba(var(--bs-info-rgb),var(--bs-text-opacity))!important}.text-warning[data-v-3cbae5fb]{--bs-text-opacity:1;color:rgba(var(--bs-warning-rgb),var(--bs-text-opacity))!important}.text-danger[data-v-3cbae5fb]{--bs-text-opacity:1;color:rgba(var(--bs-danger-rgb),var(--bs-text-opacity))!important}.text-light[data-v-3cbae5fb]{--bs-text-opacity:1;color:rgba(var(--bs-light-rgb),var(--bs-text-opacity))!important}.text-dark[data-v-3cbae5fb]{--bs-text-opacity:1;color:rgba(var(--bs-dark-rgb),var(--bs-text-opacity))!important}.text-black[data-v-3cbae5fb]{--bs-text-opacity:1;color:rgba(var(--bs-black-rgb),var(--bs-text-opacity))!important}.text-white[data-v-3cbae5fb]{--bs-text-opacity:1;color:rgba(var(--bs-white-rgb),var(--bs-text-opacity))!important}.text-body[data-v-3cbae5fb]{--bs-text-opacity:1;color:rgba(var(--bs-body-color-rgb),var(--bs-text-opacity))!important}.text-muted[data-v-3cbae5fb]{--bs-text-opacity:1;color:#6c757d!important}.text-black-50[data-v-3cbae5fb]{--bs-text-opacity:1;color:rgba(0,0,0,.5)!important}.text-white-50[data-v-3cbae5fb]{--bs-text-opacity:1;color:hsla(0,0%,100%,.5)!important}.text-reset[data-v-3cbae5fb]{--bs-text-opacity:1;color:inherit!important}.text-opacity-25[data-v-3cbae5fb]{--bs-text-opacity:0.25}.text-opacity-50[data-v-3cbae5fb]{--bs-text-opacity:0.5}.text-opacity-75[data-v-3cbae5fb]{--bs-text-opacity:0.75}.text-opacity-100[data-v-3cbae5fb]{--bs-text-opacity:1}.bg-primary[data-v-3cbae5fb]{--bs-bg-opacity:1;background-color:rgba(var(--bs-primary-rgb),var(--bs-bg-opacity))!important}.bg-secondary[data-v-3cbae5fb]{--bs-bg-opacity:1;background-color:rgba(var(--bs-secondary-rgb),var(--bs-bg-opacity))!important}.bg-success[data-v-3cbae5fb]{--bs-bg-opacity:1;background-color:rgba(var(--bs-success-rgb),var(--bs-bg-opacity))!important}.bg-info[data-v-3cbae5fb]{--bs-bg-opacity:1;background-color:rgba(var(--bs-info-rgb),var(--bs-bg-opacity))!important}.bg-warning[data-v-3cbae5fb]{--bs-bg-opacity:1;background-color:rgba(var(--bs-warning-rgb),var(--bs-bg-opacity))!important}.bg-danger[data-v-3cbae5fb]{--bs-bg-opacity:1;background-color:rgba(var(--bs-danger-rgb),var(--bs-bg-opacity))!important}.bg-light[data-v-3cbae5fb]{--bs-bg-opacity:1;background-color:rgba(var(--bs-light-rgb),var(--bs-bg-opacity))!important}.bg-dark[data-v-3cbae5fb]{--bs-bg-opacity:1;background-color:rgba(var(--bs-dark-rgb),var(--bs-bg-opacity))!important}.bg-black[data-v-3cbae5fb]{--bs-bg-opacity:1;background-color:rgba(var(--bs-black-rgb),var(--bs-bg-opacity))!important}.bg-white[data-v-3cbae5fb]{--bs-bg-opacity:1;background-color:rgba(var(--bs-white-rgb),var(--bs-bg-opacity))!important}.bg-body[data-v-3cbae5fb]{--bs-bg-opacity:1;background-color:rgba(var(--bs-body-bg-rgb),var(--bs-bg-opacity))!important}.bg-transparent[data-v-3cbae5fb]{--bs-bg-opacity:1;background-color:transparent!important}.bg-opacity-10[data-v-3cbae5fb]{--bs-bg-opacity:0.1}.bg-opacity-25[data-v-3cbae5fb]{--bs-bg-opacity:0.25}.bg-opacity-50[data-v-3cbae5fb]{--bs-bg-opacity:0.5}.bg-opacity-75[data-v-3cbae5fb]{--bs-bg-opacity:0.75}.bg-opacity-100[data-v-3cbae5fb]{--bs-bg-opacity:1}.bg-gradient[data-v-3cbae5fb]{background-image:var(--bs-gradient)!important}.user-select-all[data-v-3cbae5fb]{-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.user-select-auto[data-v-3cbae5fb]{-webkit-user-select:auto!important;-moz-user-select:auto!important;user-select:auto!important}.user-select-none[data-v-3cbae5fb]{-webkit-user-select:none!important;-moz-user-select:none!important;user-select:none!important}.pe-none[data-v-3cbae5fb]{pointer-events:none!important}.pe-auto[data-v-3cbae5fb]{pointer-events:auto!important}.rounded[data-v-3cbae5fb]{border-radius:.25rem!important}.rounded-0[data-v-3cbae5fb]{border-radius:0!important}.rounded-1[data-v-3cbae5fb]{border-radius:.2rem!important}.rounded-2[data-v-3cbae5fb]{border-radius:.25rem!important}.rounded-3[data-v-3cbae5fb]{border-radius:.3rem!important}.rounded-circle[data-v-3cbae5fb]{border-radius:50%!important}.rounded-pill[data-v-3cbae5fb]{border-radius:50rem!important}.rounded-top[data-v-3cbae5fb]{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.rounded-end[data-v-3cbae5fb]{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.rounded-bottom[data-v-3cbae5fb]{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-start[data-v-3cbae5fb]{border-bottom-left-radius:.25rem!important;border-top-left-radius:.25rem!important}.visible[data-v-3cbae5fb]{visibility:visible!important}.invisible[data-v-3cbae5fb]{visibility:hidden!important}@media (min-width:576px){.float-sm-start[data-v-3cbae5fb]{float:left!important}.float-sm-end[data-v-3cbae5fb]{float:right!important}.float-sm-none[data-v-3cbae5fb]{float:none!important}.d-sm-inline[data-v-3cbae5fb]{display:inline!important}.d-sm-inline-block[data-v-3cbae5fb]{display:inline-block!important}.d-sm-block[data-v-3cbae5fb]{display:block!important}.d-sm-grid[data-v-3cbae5fb]{display:grid!important}.d-sm-table[data-v-3cbae5fb]{display:table!important}.d-sm-table-row[data-v-3cbae5fb]{display:table-row!important}.d-sm-table-cell[data-v-3cbae5fb]{display:table-cell!important}.d-sm-flex[data-v-3cbae5fb]{display:flex!important}.d-sm-inline-flex[data-v-3cbae5fb]{display:inline-flex!important}.d-sm-none[data-v-3cbae5fb]{display:none!important}.flex-sm-fill[data-v-3cbae5fb]{flex:1 1 auto!important}.flex-sm-row[data-v-3cbae5fb]{flex-direction:row!important}.flex-sm-column[data-v-3cbae5fb]{flex-direction:column!important}.flex-sm-row-reverse[data-v-3cbae5fb]{flex-direction:row-reverse!important}.flex-sm-column-reverse[data-v-3cbae5fb]{flex-direction:column-reverse!important}.flex-sm-grow-0[data-v-3cbae5fb]{flex-grow:0!important}.flex-sm-grow-1[data-v-3cbae5fb]{flex-grow:1!important}.flex-sm-shrink-0[data-v-3cbae5fb]{flex-shrink:0!important}.flex-sm-shrink-1[data-v-3cbae5fb]{flex-shrink:1!important}.flex-sm-wrap[data-v-3cbae5fb]{flex-wrap:wrap!important}.flex-sm-nowrap[data-v-3cbae5fb]{flex-wrap:nowrap!important}.flex-sm-wrap-reverse[data-v-3cbae5fb]{flex-wrap:wrap-reverse!important}.gap-sm-0[data-v-3cbae5fb]{gap:0!important}.gap-sm-1[data-v-3cbae5fb]{gap:.25rem!important}.gap-sm-2[data-v-3cbae5fb]{gap:.5rem!important}.gap-sm-3[data-v-3cbae5fb]{gap:1rem!important}.gap-sm-4[data-v-3cbae5fb]{gap:1.5rem!important}.gap-sm-5[data-v-3cbae5fb]{gap:3rem!important}.justify-content-sm-start[data-v-3cbae5fb]{justify-content:flex-start!important}.justify-content-sm-end[data-v-3cbae5fb]{justify-content:flex-end!important}.justify-content-sm-center[data-v-3cbae5fb]{justify-content:center!important}.justify-content-sm-between[data-v-3cbae5fb]{justify-content:space-between!important}.justify-content-sm-around[data-v-3cbae5fb]{justify-content:space-around!important}.justify-content-sm-evenly[data-v-3cbae5fb]{justify-content:space-evenly!important}.align-items-sm-start[data-v-3cbae5fb]{align-items:flex-start!important}.align-items-sm-end[data-v-3cbae5fb]{align-items:flex-end!important}.align-items-sm-center[data-v-3cbae5fb]{align-items:center!important}.align-items-sm-baseline[data-v-3cbae5fb]{align-items:baseline!important}.align-items-sm-stretch[data-v-3cbae5fb]{align-items:stretch!important}.align-content-sm-start[data-v-3cbae5fb]{align-content:flex-start!important}.align-content-sm-end[data-v-3cbae5fb]{align-content:flex-end!important}.align-content-sm-center[data-v-3cbae5fb]{align-content:center!important}.align-content-sm-between[data-v-3cbae5fb]{align-content:space-between!important}.align-content-sm-around[data-v-3cbae5fb]{align-content:space-around!important}.align-content-sm-stretch[data-v-3cbae5fb]{align-content:stretch!important}.align-self-sm-auto[data-v-3cbae5fb]{align-self:auto!important}.align-self-sm-start[data-v-3cbae5fb]{align-self:flex-start!important}.align-self-sm-end[data-v-3cbae5fb]{align-self:flex-end!important}.align-self-sm-center[data-v-3cbae5fb]{align-self:center!important}.align-self-sm-baseline[data-v-3cbae5fb]{align-self:baseline!important}.align-self-sm-stretch[data-v-3cbae5fb]{align-self:stretch!important}.order-sm-first[data-v-3cbae5fb]{order:-1!important}.order-sm-0[data-v-3cbae5fb]{order:0!important}.order-sm-1[data-v-3cbae5fb]{order:1!important}.order-sm-2[data-v-3cbae5fb]{order:2!important}.order-sm-3[data-v-3cbae5fb]{order:3!important}.order-sm-4[data-v-3cbae5fb]{order:4!important}.order-sm-5[data-v-3cbae5fb]{order:5!important}.order-sm-last[data-v-3cbae5fb]{order:6!important}.m-sm-0[data-v-3cbae5fb]{margin:0!important}.m-sm-1[data-v-3cbae5fb]{margin:.25rem!important}.m-sm-2[data-v-3cbae5fb]{margin:.5rem!important}.m-sm-3[data-v-3cbae5fb]{margin:1rem!important}.m-sm-4[data-v-3cbae5fb]{margin:1.5rem!important}.m-sm-5[data-v-3cbae5fb]{margin:3rem!important}.m-sm-auto[data-v-3cbae5fb]{margin:auto!important}.mx-sm-0[data-v-3cbae5fb]{margin-right:0!important;margin-left:0!important}.mx-sm-1[data-v-3cbae5fb]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-sm-2[data-v-3cbae5fb]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-sm-3[data-v-3cbae5fb]{margin-right:1rem!important;margin-left:1rem!important}.mx-sm-4[data-v-3cbae5fb]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-sm-5[data-v-3cbae5fb]{margin-right:3rem!important;margin-left:3rem!important}.mx-sm-auto[data-v-3cbae5fb]{margin-right:auto!important;margin-left:auto!important}.my-sm-0[data-v-3cbae5fb]{margin-top:0!important;margin-bottom:0!important}.my-sm-1[data-v-3cbae5fb]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-sm-2[data-v-3cbae5fb]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-sm-3[data-v-3cbae5fb]{margin-top:1rem!important;margin-bottom:1rem!important}.my-sm-4[data-v-3cbae5fb]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-sm-5[data-v-3cbae5fb]{margin-top:3rem!important;margin-bottom:3rem!important}.my-sm-auto[data-v-3cbae5fb]{margin-top:auto!important;margin-bottom:auto!important}.mt-sm-0[data-v-3cbae5fb]{margin-top:0!important}.mt-sm-1[data-v-3cbae5fb]{margin-top:.25rem!important}.mt-sm-2[data-v-3cbae5fb]{margin-top:.5rem!important}.mt-sm-3[data-v-3cbae5fb]{margin-top:1rem!important}.mt-sm-4[data-v-3cbae5fb]{margin-top:1.5rem!important}.mt-sm-5[data-v-3cbae5fb]{margin-top:3rem!important}.mt-sm-auto[data-v-3cbae5fb]{margin-top:auto!important}.me-sm-0[data-v-3cbae5fb]{margin-right:0!important}.me-sm-1[data-v-3cbae5fb]{margin-right:.25rem!important}.me-sm-2[data-v-3cbae5fb]{margin-right:.5rem!important}.me-sm-3[data-v-3cbae5fb]{margin-right:1rem!important}.me-sm-4[data-v-3cbae5fb]{margin-right:1.5rem!important}.me-sm-5[data-v-3cbae5fb]{margin-right:3rem!important}.me-sm-auto[data-v-3cbae5fb]{margin-right:auto!important}.mb-sm-0[data-v-3cbae5fb]{margin-bottom:0!important}.mb-sm-1[data-v-3cbae5fb]{margin-bottom:.25rem!important}.mb-sm-2[data-v-3cbae5fb]{margin-bottom:.5rem!important}.mb-sm-3[data-v-3cbae5fb]{margin-bottom:1rem!important}.mb-sm-4[data-v-3cbae5fb]{margin-bottom:1.5rem!important}.mb-sm-5[data-v-3cbae5fb]{margin-bottom:3rem!important}.mb-sm-auto[data-v-3cbae5fb]{margin-bottom:auto!important}.ms-sm-0[data-v-3cbae5fb]{margin-left:0!important}.ms-sm-1[data-v-3cbae5fb]{margin-left:.25rem!important}.ms-sm-2[data-v-3cbae5fb]{margin-left:.5rem!important}.ms-sm-3[data-v-3cbae5fb]{margin-left:1rem!important}.ms-sm-4[data-v-3cbae5fb]{margin-left:1.5rem!important}.ms-sm-5[data-v-3cbae5fb]{margin-left:3rem!important}.ms-sm-auto[data-v-3cbae5fb]{margin-left:auto!important}.p-sm-0[data-v-3cbae5fb]{padding:0!important}.p-sm-1[data-v-3cbae5fb]{padding:.25rem!important}.p-sm-2[data-v-3cbae5fb]{padding:.5rem!important}.p-sm-3[data-v-3cbae5fb]{padding:1rem!important}.p-sm-4[data-v-3cbae5fb]{padding:1.5rem!important}.p-sm-5[data-v-3cbae5fb]{padding:3rem!important}.px-sm-0[data-v-3cbae5fb]{padding-right:0!important;padding-left:0!important}.px-sm-1[data-v-3cbae5fb]{padding-right:.25rem!important;padding-left:.25rem!important}.px-sm-2[data-v-3cbae5fb]{padding-right:.5rem!important;padding-left:.5rem!important}.px-sm-3[data-v-3cbae5fb]{padding-right:1rem!important;padding-left:1rem!important}.px-sm-4[data-v-3cbae5fb]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-sm-5[data-v-3cbae5fb]{padding-right:3rem!important;padding-left:3rem!important}.py-sm-0[data-v-3cbae5fb]{padding-top:0!important;padding-bottom:0!important}.py-sm-1[data-v-3cbae5fb]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-sm-2[data-v-3cbae5fb]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-sm-3[data-v-3cbae5fb]{padding-top:1rem!important;padding-bottom:1rem!important}.py-sm-4[data-v-3cbae5fb]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-sm-5[data-v-3cbae5fb]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-sm-0[data-v-3cbae5fb]{padding-top:0!important}.pt-sm-1[data-v-3cbae5fb]{padding-top:.25rem!important}.pt-sm-2[data-v-3cbae5fb]{padding-top:.5rem!important}.pt-sm-3[data-v-3cbae5fb]{padding-top:1rem!important}.pt-sm-4[data-v-3cbae5fb]{padding-top:1.5rem!important}.pt-sm-5[data-v-3cbae5fb]{padding-top:3rem!important}.pe-sm-0[data-v-3cbae5fb]{padding-right:0!important}.pe-sm-1[data-v-3cbae5fb]{padding-right:.25rem!important}.pe-sm-2[data-v-3cbae5fb]{padding-right:.5rem!important}.pe-sm-3[data-v-3cbae5fb]{padding-right:1rem!important}.pe-sm-4[data-v-3cbae5fb]{padding-right:1.5rem!important}.pe-sm-5[data-v-3cbae5fb]{padding-right:3rem!important}.pb-sm-0[data-v-3cbae5fb]{padding-bottom:0!important}.pb-sm-1[data-v-3cbae5fb]{padding-bottom:.25rem!important}.pb-sm-2[data-v-3cbae5fb]{padding-bottom:.5rem!important}.pb-sm-3[data-v-3cbae5fb]{padding-bottom:1rem!important}.pb-sm-4[data-v-3cbae5fb]{padding-bottom:1.5rem!important}.pb-sm-5[data-v-3cbae5fb]{padding-bottom:3rem!important}.ps-sm-0[data-v-3cbae5fb]{padding-left:0!important}.ps-sm-1[data-v-3cbae5fb]{padding-left:.25rem!important}.ps-sm-2[data-v-3cbae5fb]{padding-left:.5rem!important}.ps-sm-3[data-v-3cbae5fb]{padding-left:1rem!important}.ps-sm-4[data-v-3cbae5fb]{padding-left:1.5rem!important}.ps-sm-5[data-v-3cbae5fb]{padding-left:3rem!important}.text-sm-start[data-v-3cbae5fb]{text-align:left!important}.text-sm-end[data-v-3cbae5fb]{text-align:right!important}.text-sm-center[data-v-3cbae5fb]{text-align:center!important}}@media (min-width:768px){.float-md-start[data-v-3cbae5fb]{float:left!important}.float-md-end[data-v-3cbae5fb]{float:right!important}.float-md-none[data-v-3cbae5fb]{float:none!important}.d-md-inline[data-v-3cbae5fb]{display:inline!important}.d-md-inline-block[data-v-3cbae5fb]{display:inline-block!important}.d-md-block[data-v-3cbae5fb]{display:block!important}.d-md-grid[data-v-3cbae5fb]{display:grid!important}.d-md-table[data-v-3cbae5fb]{display:table!important}.d-md-table-row[data-v-3cbae5fb]{display:table-row!important}.d-md-table-cell[data-v-3cbae5fb]{display:table-cell!important}.d-md-flex[data-v-3cbae5fb]{display:flex!important}.d-md-inline-flex[data-v-3cbae5fb]{display:inline-flex!important}.d-md-none[data-v-3cbae5fb]{display:none!important}.flex-md-fill[data-v-3cbae5fb]{flex:1 1 auto!important}.flex-md-row[data-v-3cbae5fb]{flex-direction:row!important}.flex-md-column[data-v-3cbae5fb]{flex-direction:column!important}.flex-md-row-reverse[data-v-3cbae5fb]{flex-direction:row-reverse!important}.flex-md-column-reverse[data-v-3cbae5fb]{flex-direction:column-reverse!important}.flex-md-grow-0[data-v-3cbae5fb]{flex-grow:0!important}.flex-md-grow-1[data-v-3cbae5fb]{flex-grow:1!important}.flex-md-shrink-0[data-v-3cbae5fb]{flex-shrink:0!important}.flex-md-shrink-1[data-v-3cbae5fb]{flex-shrink:1!important}.flex-md-wrap[data-v-3cbae5fb]{flex-wrap:wrap!important}.flex-md-nowrap[data-v-3cbae5fb]{flex-wrap:nowrap!important}.flex-md-wrap-reverse[data-v-3cbae5fb]{flex-wrap:wrap-reverse!important}.gap-md-0[data-v-3cbae5fb]{gap:0!important}.gap-md-1[data-v-3cbae5fb]{gap:.25rem!important}.gap-md-2[data-v-3cbae5fb]{gap:.5rem!important}.gap-md-3[data-v-3cbae5fb]{gap:1rem!important}.gap-md-4[data-v-3cbae5fb]{gap:1.5rem!important}.gap-md-5[data-v-3cbae5fb]{gap:3rem!important}.justify-content-md-start[data-v-3cbae5fb]{justify-content:flex-start!important}.justify-content-md-end[data-v-3cbae5fb]{justify-content:flex-end!important}.justify-content-md-center[data-v-3cbae5fb]{justify-content:center!important}.justify-content-md-between[data-v-3cbae5fb]{justify-content:space-between!important}.justify-content-md-around[data-v-3cbae5fb]{justify-content:space-around!important}.justify-content-md-evenly[data-v-3cbae5fb]{justify-content:space-evenly!important}.align-items-md-start[data-v-3cbae5fb]{align-items:flex-start!important}.align-items-md-end[data-v-3cbae5fb]{align-items:flex-end!important}.align-items-md-center[data-v-3cbae5fb]{align-items:center!important}.align-items-md-baseline[data-v-3cbae5fb]{align-items:baseline!important}.align-items-md-stretch[data-v-3cbae5fb]{align-items:stretch!important}.align-content-md-start[data-v-3cbae5fb]{align-content:flex-start!important}.align-content-md-end[data-v-3cbae5fb]{align-content:flex-end!important}.align-content-md-center[data-v-3cbae5fb]{align-content:center!important}.align-content-md-between[data-v-3cbae5fb]{align-content:space-between!important}.align-content-md-around[data-v-3cbae5fb]{align-content:space-around!important}.align-content-md-stretch[data-v-3cbae5fb]{align-content:stretch!important}.align-self-md-auto[data-v-3cbae5fb]{align-self:auto!important}.align-self-md-start[data-v-3cbae5fb]{align-self:flex-start!important}.align-self-md-end[data-v-3cbae5fb]{align-self:flex-end!important}.align-self-md-center[data-v-3cbae5fb]{align-self:center!important}.align-self-md-baseline[data-v-3cbae5fb]{align-self:baseline!important}.align-self-md-stretch[data-v-3cbae5fb]{align-self:stretch!important}.order-md-first[data-v-3cbae5fb]{order:-1!important}.order-md-0[data-v-3cbae5fb]{order:0!important}.order-md-1[data-v-3cbae5fb]{order:1!important}.order-md-2[data-v-3cbae5fb]{order:2!important}.order-md-3[data-v-3cbae5fb]{order:3!important}.order-md-4[data-v-3cbae5fb]{order:4!important}.order-md-5[data-v-3cbae5fb]{order:5!important}.order-md-last[data-v-3cbae5fb]{order:6!important}.m-md-0[data-v-3cbae5fb]{margin:0!important}.m-md-1[data-v-3cbae5fb]{margin:.25rem!important}.m-md-2[data-v-3cbae5fb]{margin:.5rem!important}.m-md-3[data-v-3cbae5fb]{margin:1rem!important}.m-md-4[data-v-3cbae5fb]{margin:1.5rem!important}.m-md-5[data-v-3cbae5fb]{margin:3rem!important}.m-md-auto[data-v-3cbae5fb]{margin:auto!important}.mx-md-0[data-v-3cbae5fb]{margin-right:0!important;margin-left:0!important}.mx-md-1[data-v-3cbae5fb]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-md-2[data-v-3cbae5fb]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-md-3[data-v-3cbae5fb]{margin-right:1rem!important;margin-left:1rem!important}.mx-md-4[data-v-3cbae5fb]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-md-5[data-v-3cbae5fb]{margin-right:3rem!important;margin-left:3rem!important}.mx-md-auto[data-v-3cbae5fb]{margin-right:auto!important;margin-left:auto!important}.my-md-0[data-v-3cbae5fb]{margin-top:0!important;margin-bottom:0!important}.my-md-1[data-v-3cbae5fb]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-md-2[data-v-3cbae5fb]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-md-3[data-v-3cbae5fb]{margin-top:1rem!important;margin-bottom:1rem!important}.my-md-4[data-v-3cbae5fb]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-md-5[data-v-3cbae5fb]{margin-top:3rem!important;margin-bottom:3rem!important}.my-md-auto[data-v-3cbae5fb]{margin-top:auto!important;margin-bottom:auto!important}.mt-md-0[data-v-3cbae5fb]{margin-top:0!important}.mt-md-1[data-v-3cbae5fb]{margin-top:.25rem!important}.mt-md-2[data-v-3cbae5fb]{margin-top:.5rem!important}.mt-md-3[data-v-3cbae5fb]{margin-top:1rem!important}.mt-md-4[data-v-3cbae5fb]{margin-top:1.5rem!important}.mt-md-5[data-v-3cbae5fb]{margin-top:3rem!important}.mt-md-auto[data-v-3cbae5fb]{margin-top:auto!important}.me-md-0[data-v-3cbae5fb]{margin-right:0!important}.me-md-1[data-v-3cbae5fb]{margin-right:.25rem!important}.me-md-2[data-v-3cbae5fb]{margin-right:.5rem!important}.me-md-3[data-v-3cbae5fb]{margin-right:1rem!important}.me-md-4[data-v-3cbae5fb]{margin-right:1.5rem!important}.me-md-5[data-v-3cbae5fb]{margin-right:3rem!important}.me-md-auto[data-v-3cbae5fb]{margin-right:auto!important}.mb-md-0[data-v-3cbae5fb]{margin-bottom:0!important}.mb-md-1[data-v-3cbae5fb]{margin-bottom:.25rem!important}.mb-md-2[data-v-3cbae5fb]{margin-bottom:.5rem!important}.mb-md-3[data-v-3cbae5fb]{margin-bottom:1rem!important}.mb-md-4[data-v-3cbae5fb]{margin-bottom:1.5rem!important}.mb-md-5[data-v-3cbae5fb]{margin-bottom:3rem!important}.mb-md-auto[data-v-3cbae5fb]{margin-bottom:auto!important}.ms-md-0[data-v-3cbae5fb]{margin-left:0!important}.ms-md-1[data-v-3cbae5fb]{margin-left:.25rem!important}.ms-md-2[data-v-3cbae5fb]{margin-left:.5rem!important}.ms-md-3[data-v-3cbae5fb]{margin-left:1rem!important}.ms-md-4[data-v-3cbae5fb]{margin-left:1.5rem!important}.ms-md-5[data-v-3cbae5fb]{margin-left:3rem!important}.ms-md-auto[data-v-3cbae5fb]{margin-left:auto!important}.p-md-0[data-v-3cbae5fb]{padding:0!important}.p-md-1[data-v-3cbae5fb]{padding:.25rem!important}.p-md-2[data-v-3cbae5fb]{padding:.5rem!important}.p-md-3[data-v-3cbae5fb]{padding:1rem!important}.p-md-4[data-v-3cbae5fb]{padding:1.5rem!important}.p-md-5[data-v-3cbae5fb]{padding:3rem!important}.px-md-0[data-v-3cbae5fb]{padding-right:0!important;padding-left:0!important}.px-md-1[data-v-3cbae5fb]{padding-right:.25rem!important;padding-left:.25rem!important}.px-md-2[data-v-3cbae5fb]{padding-right:.5rem!important;padding-left:.5rem!important}.px-md-3[data-v-3cbae5fb]{padding-right:1rem!important;padding-left:1rem!important}.px-md-4[data-v-3cbae5fb]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-md-5[data-v-3cbae5fb]{padding-right:3rem!important;padding-left:3rem!important}.py-md-0[data-v-3cbae5fb]{padding-top:0!important;padding-bottom:0!important}.py-md-1[data-v-3cbae5fb]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-md-2[data-v-3cbae5fb]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-md-3[data-v-3cbae5fb]{padding-top:1rem!important;padding-bottom:1rem!important}.py-md-4[data-v-3cbae5fb]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-md-5[data-v-3cbae5fb]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-md-0[data-v-3cbae5fb]{padding-top:0!important}.pt-md-1[data-v-3cbae5fb]{padding-top:.25rem!important}.pt-md-2[data-v-3cbae5fb]{padding-top:.5rem!important}.pt-md-3[data-v-3cbae5fb]{padding-top:1rem!important}.pt-md-4[data-v-3cbae5fb]{padding-top:1.5rem!important}.pt-md-5[data-v-3cbae5fb]{padding-top:3rem!important}.pe-md-0[data-v-3cbae5fb]{padding-right:0!important}.pe-md-1[data-v-3cbae5fb]{padding-right:.25rem!important}.pe-md-2[data-v-3cbae5fb]{padding-right:.5rem!important}.pe-md-3[data-v-3cbae5fb]{padding-right:1rem!important}.pe-md-4[data-v-3cbae5fb]{padding-right:1.5rem!important}.pe-md-5[data-v-3cbae5fb]{padding-right:3rem!important}.pb-md-0[data-v-3cbae5fb]{padding-bottom:0!important}.pb-md-1[data-v-3cbae5fb]{padding-bottom:.25rem!important}.pb-md-2[data-v-3cbae5fb]{padding-bottom:.5rem!important}.pb-md-3[data-v-3cbae5fb]{padding-bottom:1rem!important}.pb-md-4[data-v-3cbae5fb]{padding-bottom:1.5rem!important}.pb-md-5[data-v-3cbae5fb]{padding-bottom:3rem!important}.ps-md-0[data-v-3cbae5fb]{padding-left:0!important}.ps-md-1[data-v-3cbae5fb]{padding-left:.25rem!important}.ps-md-2[data-v-3cbae5fb]{padding-left:.5rem!important}.ps-md-3[data-v-3cbae5fb]{padding-left:1rem!important}.ps-md-4[data-v-3cbae5fb]{padding-left:1.5rem!important}.ps-md-5[data-v-3cbae5fb]{padding-left:3rem!important}.text-md-start[data-v-3cbae5fb]{text-align:left!important}.text-md-end[data-v-3cbae5fb]{text-align:right!important}.text-md-center[data-v-3cbae5fb]{text-align:center!important}}@media (min-width:992px){.float-lg-start[data-v-3cbae5fb]{float:left!important}.float-lg-end[data-v-3cbae5fb]{float:right!important}.float-lg-none[data-v-3cbae5fb]{float:none!important}.d-lg-inline[data-v-3cbae5fb]{display:inline!important}.d-lg-inline-block[data-v-3cbae5fb]{display:inline-block!important}.d-lg-block[data-v-3cbae5fb]{display:block!important}.d-lg-grid[data-v-3cbae5fb]{display:grid!important}.d-lg-table[data-v-3cbae5fb]{display:table!important}.d-lg-table-row[data-v-3cbae5fb]{display:table-row!important}.d-lg-table-cell[data-v-3cbae5fb]{display:table-cell!important}.d-lg-flex[data-v-3cbae5fb]{display:flex!important}.d-lg-inline-flex[data-v-3cbae5fb]{display:inline-flex!important}.d-lg-none[data-v-3cbae5fb]{display:none!important}.flex-lg-fill[data-v-3cbae5fb]{flex:1 1 auto!important}.flex-lg-row[data-v-3cbae5fb]{flex-direction:row!important}.flex-lg-column[data-v-3cbae5fb]{flex-direction:column!important}.flex-lg-row-reverse[data-v-3cbae5fb]{flex-direction:row-reverse!important}.flex-lg-column-reverse[data-v-3cbae5fb]{flex-direction:column-reverse!important}.flex-lg-grow-0[data-v-3cbae5fb]{flex-grow:0!important}.flex-lg-grow-1[data-v-3cbae5fb]{flex-grow:1!important}.flex-lg-shrink-0[data-v-3cbae5fb]{flex-shrink:0!important}.flex-lg-shrink-1[data-v-3cbae5fb]{flex-shrink:1!important}.flex-lg-wrap[data-v-3cbae5fb]{flex-wrap:wrap!important}.flex-lg-nowrap[data-v-3cbae5fb]{flex-wrap:nowrap!important}.flex-lg-wrap-reverse[data-v-3cbae5fb]{flex-wrap:wrap-reverse!important}.gap-lg-0[data-v-3cbae5fb]{gap:0!important}.gap-lg-1[data-v-3cbae5fb]{gap:.25rem!important}.gap-lg-2[data-v-3cbae5fb]{gap:.5rem!important}.gap-lg-3[data-v-3cbae5fb]{gap:1rem!important}.gap-lg-4[data-v-3cbae5fb]{gap:1.5rem!important}.gap-lg-5[data-v-3cbae5fb]{gap:3rem!important}.justify-content-lg-start[data-v-3cbae5fb]{justify-content:flex-start!important}.justify-content-lg-end[data-v-3cbae5fb]{justify-content:flex-end!important}.justify-content-lg-center[data-v-3cbae5fb]{justify-content:center!important}.justify-content-lg-between[data-v-3cbae5fb]{justify-content:space-between!important}.justify-content-lg-around[data-v-3cbae5fb]{justify-content:space-around!important}.justify-content-lg-evenly[data-v-3cbae5fb]{justify-content:space-evenly!important}.align-items-lg-start[data-v-3cbae5fb]{align-items:flex-start!important}.align-items-lg-end[data-v-3cbae5fb]{align-items:flex-end!important}.align-items-lg-center[data-v-3cbae5fb]{align-items:center!important}.align-items-lg-baseline[data-v-3cbae5fb]{align-items:baseline!important}.align-items-lg-stretch[data-v-3cbae5fb]{align-items:stretch!important}.align-content-lg-start[data-v-3cbae5fb]{align-content:flex-start!important}.align-content-lg-end[data-v-3cbae5fb]{align-content:flex-end!important}.align-content-lg-center[data-v-3cbae5fb]{align-content:center!important}.align-content-lg-between[data-v-3cbae5fb]{align-content:space-between!important}.align-content-lg-around[data-v-3cbae5fb]{align-content:space-around!important}.align-content-lg-stretch[data-v-3cbae5fb]{align-content:stretch!important}.align-self-lg-auto[data-v-3cbae5fb]{align-self:auto!important}.align-self-lg-start[data-v-3cbae5fb]{align-self:flex-start!important}.align-self-lg-end[data-v-3cbae5fb]{align-self:flex-end!important}.align-self-lg-center[data-v-3cbae5fb]{align-self:center!important}.align-self-lg-baseline[data-v-3cbae5fb]{align-self:baseline!important}.align-self-lg-stretch[data-v-3cbae5fb]{align-self:stretch!important}.order-lg-first[data-v-3cbae5fb]{order:-1!important}.order-lg-0[data-v-3cbae5fb]{order:0!important}.order-lg-1[data-v-3cbae5fb]{order:1!important}.order-lg-2[data-v-3cbae5fb]{order:2!important}.order-lg-3[data-v-3cbae5fb]{order:3!important}.order-lg-4[data-v-3cbae5fb]{order:4!important}.order-lg-5[data-v-3cbae5fb]{order:5!important}.order-lg-last[data-v-3cbae5fb]{order:6!important}.m-lg-0[data-v-3cbae5fb]{margin:0!important}.m-lg-1[data-v-3cbae5fb]{margin:.25rem!important}.m-lg-2[data-v-3cbae5fb]{margin:.5rem!important}.m-lg-3[data-v-3cbae5fb]{margin:1rem!important}.m-lg-4[data-v-3cbae5fb]{margin:1.5rem!important}.m-lg-5[data-v-3cbae5fb]{margin:3rem!important}.m-lg-auto[data-v-3cbae5fb]{margin:auto!important}.mx-lg-0[data-v-3cbae5fb]{margin-right:0!important;margin-left:0!important}.mx-lg-1[data-v-3cbae5fb]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-lg-2[data-v-3cbae5fb]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-lg-3[data-v-3cbae5fb]{margin-right:1rem!important;margin-left:1rem!important}.mx-lg-4[data-v-3cbae5fb]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-lg-5[data-v-3cbae5fb]{margin-right:3rem!important;margin-left:3rem!important}.mx-lg-auto[data-v-3cbae5fb]{margin-right:auto!important;margin-left:auto!important}.my-lg-0[data-v-3cbae5fb]{margin-top:0!important;margin-bottom:0!important}.my-lg-1[data-v-3cbae5fb]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-lg-2[data-v-3cbae5fb]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-lg-3[data-v-3cbae5fb]{margin-top:1rem!important;margin-bottom:1rem!important}.my-lg-4[data-v-3cbae5fb]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-lg-5[data-v-3cbae5fb]{margin-top:3rem!important;margin-bottom:3rem!important}.my-lg-auto[data-v-3cbae5fb]{margin-top:auto!important;margin-bottom:auto!important}.mt-lg-0[data-v-3cbae5fb]{margin-top:0!important}.mt-lg-1[data-v-3cbae5fb]{margin-top:.25rem!important}.mt-lg-2[data-v-3cbae5fb]{margin-top:.5rem!important}.mt-lg-3[data-v-3cbae5fb]{margin-top:1rem!important}.mt-lg-4[data-v-3cbae5fb]{margin-top:1.5rem!important}.mt-lg-5[data-v-3cbae5fb]{margin-top:3rem!important}.mt-lg-auto[data-v-3cbae5fb]{margin-top:auto!important}.me-lg-0[data-v-3cbae5fb]{margin-right:0!important}.me-lg-1[data-v-3cbae5fb]{margin-right:.25rem!important}.me-lg-2[data-v-3cbae5fb]{margin-right:.5rem!important}.me-lg-3[data-v-3cbae5fb]{margin-right:1rem!important}.me-lg-4[data-v-3cbae5fb]{margin-right:1.5rem!important}.me-lg-5[data-v-3cbae5fb]{margin-right:3rem!important}.me-lg-auto[data-v-3cbae5fb]{margin-right:auto!important}.mb-lg-0[data-v-3cbae5fb]{margin-bottom:0!important}.mb-lg-1[data-v-3cbae5fb]{margin-bottom:.25rem!important}.mb-lg-2[data-v-3cbae5fb]{margin-bottom:.5rem!important}.mb-lg-3[data-v-3cbae5fb]{margin-bottom:1rem!important}.mb-lg-4[data-v-3cbae5fb]{margin-bottom:1.5rem!important}.mb-lg-5[data-v-3cbae5fb]{margin-bottom:3rem!important}.mb-lg-auto[data-v-3cbae5fb]{margin-bottom:auto!important}.ms-lg-0[data-v-3cbae5fb]{margin-left:0!important}.ms-lg-1[data-v-3cbae5fb]{margin-left:.25rem!important}.ms-lg-2[data-v-3cbae5fb]{margin-left:.5rem!important}.ms-lg-3[data-v-3cbae5fb]{margin-left:1rem!important}.ms-lg-4[data-v-3cbae5fb]{margin-left:1.5rem!important}.ms-lg-5[data-v-3cbae5fb]{margin-left:3rem!important}.ms-lg-auto[data-v-3cbae5fb]{margin-left:auto!important}.p-lg-0[data-v-3cbae5fb]{padding:0!important}.p-lg-1[data-v-3cbae5fb]{padding:.25rem!important}.p-lg-2[data-v-3cbae5fb]{padding:.5rem!important}.p-lg-3[data-v-3cbae5fb]{padding:1rem!important}.p-lg-4[data-v-3cbae5fb]{padding:1.5rem!important}.p-lg-5[data-v-3cbae5fb]{padding:3rem!important}.px-lg-0[data-v-3cbae5fb]{padding-right:0!important;padding-left:0!important}.px-lg-1[data-v-3cbae5fb]{padding-right:.25rem!important;padding-left:.25rem!important}.px-lg-2[data-v-3cbae5fb]{padding-right:.5rem!important;padding-left:.5rem!important}.px-lg-3[data-v-3cbae5fb]{padding-right:1rem!important;padding-left:1rem!important}.px-lg-4[data-v-3cbae5fb]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-lg-5[data-v-3cbae5fb]{padding-right:3rem!important;padding-left:3rem!important}.py-lg-0[data-v-3cbae5fb]{padding-top:0!important;padding-bottom:0!important}.py-lg-1[data-v-3cbae5fb]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-lg-2[data-v-3cbae5fb]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-lg-3[data-v-3cbae5fb]{padding-top:1rem!important;padding-bottom:1rem!important}.py-lg-4[data-v-3cbae5fb]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-lg-5[data-v-3cbae5fb]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-lg-0[data-v-3cbae5fb]{padding-top:0!important}.pt-lg-1[data-v-3cbae5fb]{padding-top:.25rem!important}.pt-lg-2[data-v-3cbae5fb]{padding-top:.5rem!important}.pt-lg-3[data-v-3cbae5fb]{padding-top:1rem!important}.pt-lg-4[data-v-3cbae5fb]{padding-top:1.5rem!important}.pt-lg-5[data-v-3cbae5fb]{padding-top:3rem!important}.pe-lg-0[data-v-3cbae5fb]{padding-right:0!important}.pe-lg-1[data-v-3cbae5fb]{padding-right:.25rem!important}.pe-lg-2[data-v-3cbae5fb]{padding-right:.5rem!important}.pe-lg-3[data-v-3cbae5fb]{padding-right:1rem!important}.pe-lg-4[data-v-3cbae5fb]{padding-right:1.5rem!important}.pe-lg-5[data-v-3cbae5fb]{padding-right:3rem!important}.pb-lg-0[data-v-3cbae5fb]{padding-bottom:0!important}.pb-lg-1[data-v-3cbae5fb]{padding-bottom:.25rem!important}.pb-lg-2[data-v-3cbae5fb]{padding-bottom:.5rem!important}.pb-lg-3[data-v-3cbae5fb]{padding-bottom:1rem!important}.pb-lg-4[data-v-3cbae5fb]{padding-bottom:1.5rem!important}.pb-lg-5[data-v-3cbae5fb]{padding-bottom:3rem!important}.ps-lg-0[data-v-3cbae5fb]{padding-left:0!important}.ps-lg-1[data-v-3cbae5fb]{padding-left:.25rem!important}.ps-lg-2[data-v-3cbae5fb]{padding-left:.5rem!important}.ps-lg-3[data-v-3cbae5fb]{padding-left:1rem!important}.ps-lg-4[data-v-3cbae5fb]{padding-left:1.5rem!important}.ps-lg-5[data-v-3cbae5fb]{padding-left:3rem!important}.text-lg-start[data-v-3cbae5fb]{text-align:left!important}.text-lg-end[data-v-3cbae5fb]{text-align:right!important}.text-lg-center[data-v-3cbae5fb]{text-align:center!important}}@media (min-width:1200px){.float-xl-start[data-v-3cbae5fb]{float:left!important}.float-xl-end[data-v-3cbae5fb]{float:right!important}.float-xl-none[data-v-3cbae5fb]{float:none!important}.d-xl-inline[data-v-3cbae5fb]{display:inline!important}.d-xl-inline-block[data-v-3cbae5fb]{display:inline-block!important}.d-xl-block[data-v-3cbae5fb]{display:block!important}.d-xl-grid[data-v-3cbae5fb]{display:grid!important}.d-xl-table[data-v-3cbae5fb]{display:table!important}.d-xl-table-row[data-v-3cbae5fb]{display:table-row!important}.d-xl-table-cell[data-v-3cbae5fb]{display:table-cell!important}.d-xl-flex[data-v-3cbae5fb]{display:flex!important}.d-xl-inline-flex[data-v-3cbae5fb]{display:inline-flex!important}.d-xl-none[data-v-3cbae5fb]{display:none!important}.flex-xl-fill[data-v-3cbae5fb]{flex:1 1 auto!important}.flex-xl-row[data-v-3cbae5fb]{flex-direction:row!important}.flex-xl-column[data-v-3cbae5fb]{flex-direction:column!important}.flex-xl-row-reverse[data-v-3cbae5fb]{flex-direction:row-reverse!important}.flex-xl-column-reverse[data-v-3cbae5fb]{flex-direction:column-reverse!important}.flex-xl-grow-0[data-v-3cbae5fb]{flex-grow:0!important}.flex-xl-grow-1[data-v-3cbae5fb]{flex-grow:1!important}.flex-xl-shrink-0[data-v-3cbae5fb]{flex-shrink:0!important}.flex-xl-shrink-1[data-v-3cbae5fb]{flex-shrink:1!important}.flex-xl-wrap[data-v-3cbae5fb]{flex-wrap:wrap!important}.flex-xl-nowrap[data-v-3cbae5fb]{flex-wrap:nowrap!important}.flex-xl-wrap-reverse[data-v-3cbae5fb]{flex-wrap:wrap-reverse!important}.gap-xl-0[data-v-3cbae5fb]{gap:0!important}.gap-xl-1[data-v-3cbae5fb]{gap:.25rem!important}.gap-xl-2[data-v-3cbae5fb]{gap:.5rem!important}.gap-xl-3[data-v-3cbae5fb]{gap:1rem!important}.gap-xl-4[data-v-3cbae5fb]{gap:1.5rem!important}.gap-xl-5[data-v-3cbae5fb]{gap:3rem!important}.justify-content-xl-start[data-v-3cbae5fb]{justify-content:flex-start!important}.justify-content-xl-end[data-v-3cbae5fb]{justify-content:flex-end!important}.justify-content-xl-center[data-v-3cbae5fb]{justify-content:center!important}.justify-content-xl-between[data-v-3cbae5fb]{justify-content:space-between!important}.justify-content-xl-around[data-v-3cbae5fb]{justify-content:space-around!important}.justify-content-xl-evenly[data-v-3cbae5fb]{justify-content:space-evenly!important}.align-items-xl-start[data-v-3cbae5fb]{align-items:flex-start!important}.align-items-xl-end[data-v-3cbae5fb]{align-items:flex-end!important}.align-items-xl-center[data-v-3cbae5fb]{align-items:center!important}.align-items-xl-baseline[data-v-3cbae5fb]{align-items:baseline!important}.align-items-xl-stretch[data-v-3cbae5fb]{align-items:stretch!important}.align-content-xl-start[data-v-3cbae5fb]{align-content:flex-start!important}.align-content-xl-end[data-v-3cbae5fb]{align-content:flex-end!important}.align-content-xl-center[data-v-3cbae5fb]{align-content:center!important}.align-content-xl-between[data-v-3cbae5fb]{align-content:space-between!important}.align-content-xl-around[data-v-3cbae5fb]{align-content:space-around!important}.align-content-xl-stretch[data-v-3cbae5fb]{align-content:stretch!important}.align-self-xl-auto[data-v-3cbae5fb]{align-self:auto!important}.align-self-xl-start[data-v-3cbae5fb]{align-self:flex-start!important}.align-self-xl-end[data-v-3cbae5fb]{align-self:flex-end!important}.align-self-xl-center[data-v-3cbae5fb]{align-self:center!important}.align-self-xl-baseline[data-v-3cbae5fb]{align-self:baseline!important}.align-self-xl-stretch[data-v-3cbae5fb]{align-self:stretch!important}.order-xl-first[data-v-3cbae5fb]{order:-1!important}.order-xl-0[data-v-3cbae5fb]{order:0!important}.order-xl-1[data-v-3cbae5fb]{order:1!important}.order-xl-2[data-v-3cbae5fb]{order:2!important}.order-xl-3[data-v-3cbae5fb]{order:3!important}.order-xl-4[data-v-3cbae5fb]{order:4!important}.order-xl-5[data-v-3cbae5fb]{order:5!important}.order-xl-last[data-v-3cbae5fb]{order:6!important}.m-xl-0[data-v-3cbae5fb]{margin:0!important}.m-xl-1[data-v-3cbae5fb]{margin:.25rem!important}.m-xl-2[data-v-3cbae5fb]{margin:.5rem!important}.m-xl-3[data-v-3cbae5fb]{margin:1rem!important}.m-xl-4[data-v-3cbae5fb]{margin:1.5rem!important}.m-xl-5[data-v-3cbae5fb]{margin:3rem!important}.m-xl-auto[data-v-3cbae5fb]{margin:auto!important}.mx-xl-0[data-v-3cbae5fb]{margin-right:0!important;margin-left:0!important}.mx-xl-1[data-v-3cbae5fb]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xl-2[data-v-3cbae5fb]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xl-3[data-v-3cbae5fb]{margin-right:1rem!important;margin-left:1rem!important}.mx-xl-4[data-v-3cbae5fb]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xl-5[data-v-3cbae5fb]{margin-right:3rem!important;margin-left:3rem!important}.mx-xl-auto[data-v-3cbae5fb]{margin-right:auto!important;margin-left:auto!important}.my-xl-0[data-v-3cbae5fb]{margin-top:0!important;margin-bottom:0!important}.my-xl-1[data-v-3cbae5fb]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xl-2[data-v-3cbae5fb]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xl-3[data-v-3cbae5fb]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xl-4[data-v-3cbae5fb]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xl-5[data-v-3cbae5fb]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xl-auto[data-v-3cbae5fb]{margin-top:auto!important;margin-bottom:auto!important}.mt-xl-0[data-v-3cbae5fb]{margin-top:0!important}.mt-xl-1[data-v-3cbae5fb]{margin-top:.25rem!important}.mt-xl-2[data-v-3cbae5fb]{margin-top:.5rem!important}.mt-xl-3[data-v-3cbae5fb]{margin-top:1rem!important}.mt-xl-4[data-v-3cbae5fb]{margin-top:1.5rem!important}.mt-xl-5[data-v-3cbae5fb]{margin-top:3rem!important}.mt-xl-auto[data-v-3cbae5fb]{margin-top:auto!important}.me-xl-0[data-v-3cbae5fb]{margin-right:0!important}.me-xl-1[data-v-3cbae5fb]{margin-right:.25rem!important}.me-xl-2[data-v-3cbae5fb]{margin-right:.5rem!important}.me-xl-3[data-v-3cbae5fb]{margin-right:1rem!important}.me-xl-4[data-v-3cbae5fb]{margin-right:1.5rem!important}.me-xl-5[data-v-3cbae5fb]{margin-right:3rem!important}.me-xl-auto[data-v-3cbae5fb]{margin-right:auto!important}.mb-xl-0[data-v-3cbae5fb]{margin-bottom:0!important}.mb-xl-1[data-v-3cbae5fb]{margin-bottom:.25rem!important}.mb-xl-2[data-v-3cbae5fb]{margin-bottom:.5rem!important}.mb-xl-3[data-v-3cbae5fb]{margin-bottom:1rem!important}.mb-xl-4[data-v-3cbae5fb]{margin-bottom:1.5rem!important}.mb-xl-5[data-v-3cbae5fb]{margin-bottom:3rem!important}.mb-xl-auto[data-v-3cbae5fb]{margin-bottom:auto!important}.ms-xl-0[data-v-3cbae5fb]{margin-left:0!important}.ms-xl-1[data-v-3cbae5fb]{margin-left:.25rem!important}.ms-xl-2[data-v-3cbae5fb]{margin-left:.5rem!important}.ms-xl-3[data-v-3cbae5fb]{margin-left:1rem!important}.ms-xl-4[data-v-3cbae5fb]{margin-left:1.5rem!important}.ms-xl-5[data-v-3cbae5fb]{margin-left:3rem!important}.ms-xl-auto[data-v-3cbae5fb]{margin-left:auto!important}.p-xl-0[data-v-3cbae5fb]{padding:0!important}.p-xl-1[data-v-3cbae5fb]{padding:.25rem!important}.p-xl-2[data-v-3cbae5fb]{padding:.5rem!important}.p-xl-3[data-v-3cbae5fb]{padding:1rem!important}.p-xl-4[data-v-3cbae5fb]{padding:1.5rem!important}.p-xl-5[data-v-3cbae5fb]{padding:3rem!important}.px-xl-0[data-v-3cbae5fb]{padding-right:0!important;padding-left:0!important}.px-xl-1[data-v-3cbae5fb]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xl-2[data-v-3cbae5fb]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xl-3[data-v-3cbae5fb]{padding-right:1rem!important;padding-left:1rem!important}.px-xl-4[data-v-3cbae5fb]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xl-5[data-v-3cbae5fb]{padding-right:3rem!important;padding-left:3rem!important}.py-xl-0[data-v-3cbae5fb]{padding-top:0!important;padding-bottom:0!important}.py-xl-1[data-v-3cbae5fb]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xl-2[data-v-3cbae5fb]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xl-3[data-v-3cbae5fb]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xl-4[data-v-3cbae5fb]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xl-5[data-v-3cbae5fb]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xl-0[data-v-3cbae5fb]{padding-top:0!important}.pt-xl-1[data-v-3cbae5fb]{padding-top:.25rem!important}.pt-xl-2[data-v-3cbae5fb]{padding-top:.5rem!important}.pt-xl-3[data-v-3cbae5fb]{padding-top:1rem!important}.pt-xl-4[data-v-3cbae5fb]{padding-top:1.5rem!important}.pt-xl-5[data-v-3cbae5fb]{padding-top:3rem!important}.pe-xl-0[data-v-3cbae5fb]{padding-right:0!important}.pe-xl-1[data-v-3cbae5fb]{padding-right:.25rem!important}.pe-xl-2[data-v-3cbae5fb]{padding-right:.5rem!important}.pe-xl-3[data-v-3cbae5fb]{padding-right:1rem!important}.pe-xl-4[data-v-3cbae5fb]{padding-right:1.5rem!important}.pe-xl-5[data-v-3cbae5fb]{padding-right:3rem!important}.pb-xl-0[data-v-3cbae5fb]{padding-bottom:0!important}.pb-xl-1[data-v-3cbae5fb]{padding-bottom:.25rem!important}.pb-xl-2[data-v-3cbae5fb]{padding-bottom:.5rem!important}.pb-xl-3[data-v-3cbae5fb]{padding-bottom:1rem!important}.pb-xl-4[data-v-3cbae5fb]{padding-bottom:1.5rem!important}.pb-xl-5[data-v-3cbae5fb]{padding-bottom:3rem!important}.ps-xl-0[data-v-3cbae5fb]{padding-left:0!important}.ps-xl-1[data-v-3cbae5fb]{padding-left:.25rem!important}.ps-xl-2[data-v-3cbae5fb]{padding-left:.5rem!important}.ps-xl-3[data-v-3cbae5fb]{padding-left:1rem!important}.ps-xl-4[data-v-3cbae5fb]{padding-left:1.5rem!important}.ps-xl-5[data-v-3cbae5fb]{padding-left:3rem!important}.text-xl-start[data-v-3cbae5fb]{text-align:left!important}.text-xl-end[data-v-3cbae5fb]{text-align:right!important}.text-xl-center[data-v-3cbae5fb]{text-align:center!important}}@media (min-width:1400px){.float-xxl-start[data-v-3cbae5fb]{float:left!important}.float-xxl-end[data-v-3cbae5fb]{float:right!important}.float-xxl-none[data-v-3cbae5fb]{float:none!important}.d-xxl-inline[data-v-3cbae5fb]{display:inline!important}.d-xxl-inline-block[data-v-3cbae5fb]{display:inline-block!important}.d-xxl-block[data-v-3cbae5fb]{display:block!important}.d-xxl-grid[data-v-3cbae5fb]{display:grid!important}.d-xxl-table[data-v-3cbae5fb]{display:table!important}.d-xxl-table-row[data-v-3cbae5fb]{display:table-row!important}.d-xxl-table-cell[data-v-3cbae5fb]{display:table-cell!important}.d-xxl-flex[data-v-3cbae5fb]{display:flex!important}.d-xxl-inline-flex[data-v-3cbae5fb]{display:inline-flex!important}.d-xxl-none[data-v-3cbae5fb]{display:none!important}.flex-xxl-fill[data-v-3cbae5fb]{flex:1 1 auto!important}.flex-xxl-row[data-v-3cbae5fb]{flex-direction:row!important}.flex-xxl-column[data-v-3cbae5fb]{flex-direction:column!important}.flex-xxl-row-reverse[data-v-3cbae5fb]{flex-direction:row-reverse!important}.flex-xxl-column-reverse[data-v-3cbae5fb]{flex-direction:column-reverse!important}.flex-xxl-grow-0[data-v-3cbae5fb]{flex-grow:0!important}.flex-xxl-grow-1[data-v-3cbae5fb]{flex-grow:1!important}.flex-xxl-shrink-0[data-v-3cbae5fb]{flex-shrink:0!important}.flex-xxl-shrink-1[data-v-3cbae5fb]{flex-shrink:1!important}.flex-xxl-wrap[data-v-3cbae5fb]{flex-wrap:wrap!important}.flex-xxl-nowrap[data-v-3cbae5fb]{flex-wrap:nowrap!important}.flex-xxl-wrap-reverse[data-v-3cbae5fb]{flex-wrap:wrap-reverse!important}.gap-xxl-0[data-v-3cbae5fb]{gap:0!important}.gap-xxl-1[data-v-3cbae5fb]{gap:.25rem!important}.gap-xxl-2[data-v-3cbae5fb]{gap:.5rem!important}.gap-xxl-3[data-v-3cbae5fb]{gap:1rem!important}.gap-xxl-4[data-v-3cbae5fb]{gap:1.5rem!important}.gap-xxl-5[data-v-3cbae5fb]{gap:3rem!important}.justify-content-xxl-start[data-v-3cbae5fb]{justify-content:flex-start!important}.justify-content-xxl-end[data-v-3cbae5fb]{justify-content:flex-end!important}.justify-content-xxl-center[data-v-3cbae5fb]{justify-content:center!important}.justify-content-xxl-between[data-v-3cbae5fb]{justify-content:space-between!important}.justify-content-xxl-around[data-v-3cbae5fb]{justify-content:space-around!important}.justify-content-xxl-evenly[data-v-3cbae5fb]{justify-content:space-evenly!important}.align-items-xxl-start[data-v-3cbae5fb]{align-items:flex-start!important}.align-items-xxl-end[data-v-3cbae5fb]{align-items:flex-end!important}.align-items-xxl-center[data-v-3cbae5fb]{align-items:center!important}.align-items-xxl-baseline[data-v-3cbae5fb]{align-items:baseline!important}.align-items-xxl-stretch[data-v-3cbae5fb]{align-items:stretch!important}.align-content-xxl-start[data-v-3cbae5fb]{align-content:flex-start!important}.align-content-xxl-end[data-v-3cbae5fb]{align-content:flex-end!important}.align-content-xxl-center[data-v-3cbae5fb]{align-content:center!important}.align-content-xxl-between[data-v-3cbae5fb]{align-content:space-between!important}.align-content-xxl-around[data-v-3cbae5fb]{align-content:space-around!important}.align-content-xxl-stretch[data-v-3cbae5fb]{align-content:stretch!important}.align-self-xxl-auto[data-v-3cbae5fb]{align-self:auto!important}.align-self-xxl-start[data-v-3cbae5fb]{align-self:flex-start!important}.align-self-xxl-end[data-v-3cbae5fb]{align-self:flex-end!important}.align-self-xxl-center[data-v-3cbae5fb]{align-self:center!important}.align-self-xxl-baseline[data-v-3cbae5fb]{align-self:baseline!important}.align-self-xxl-stretch[data-v-3cbae5fb]{align-self:stretch!important}.order-xxl-first[data-v-3cbae5fb]{order:-1!important}.order-xxl-0[data-v-3cbae5fb]{order:0!important}.order-xxl-1[data-v-3cbae5fb]{order:1!important}.order-xxl-2[data-v-3cbae5fb]{order:2!important}.order-xxl-3[data-v-3cbae5fb]{order:3!important}.order-xxl-4[data-v-3cbae5fb]{order:4!important}.order-xxl-5[data-v-3cbae5fb]{order:5!important}.order-xxl-last[data-v-3cbae5fb]{order:6!important}.m-xxl-0[data-v-3cbae5fb]{margin:0!important}.m-xxl-1[data-v-3cbae5fb]{margin:.25rem!important}.m-xxl-2[data-v-3cbae5fb]{margin:.5rem!important}.m-xxl-3[data-v-3cbae5fb]{margin:1rem!important}.m-xxl-4[data-v-3cbae5fb]{margin:1.5rem!important}.m-xxl-5[data-v-3cbae5fb]{margin:3rem!important}.m-xxl-auto[data-v-3cbae5fb]{margin:auto!important}.mx-xxl-0[data-v-3cbae5fb]{margin-right:0!important;margin-left:0!important}.mx-xxl-1[data-v-3cbae5fb]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xxl-2[data-v-3cbae5fb]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xxl-3[data-v-3cbae5fb]{margin-right:1rem!important;margin-left:1rem!important}.mx-xxl-4[data-v-3cbae5fb]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xxl-5[data-v-3cbae5fb]{margin-right:3rem!important;margin-left:3rem!important}.mx-xxl-auto[data-v-3cbae5fb]{margin-right:auto!important;margin-left:auto!important}.my-xxl-0[data-v-3cbae5fb]{margin-top:0!important;margin-bottom:0!important}.my-xxl-1[data-v-3cbae5fb]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xxl-2[data-v-3cbae5fb]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xxl-3[data-v-3cbae5fb]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xxl-4[data-v-3cbae5fb]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xxl-5[data-v-3cbae5fb]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xxl-auto[data-v-3cbae5fb]{margin-top:auto!important;margin-bottom:auto!important}.mt-xxl-0[data-v-3cbae5fb]{margin-top:0!important}.mt-xxl-1[data-v-3cbae5fb]{margin-top:.25rem!important}.mt-xxl-2[data-v-3cbae5fb]{margin-top:.5rem!important}.mt-xxl-3[data-v-3cbae5fb]{margin-top:1rem!important}.mt-xxl-4[data-v-3cbae5fb]{margin-top:1.5rem!important}.mt-xxl-5[data-v-3cbae5fb]{margin-top:3rem!important}.mt-xxl-auto[data-v-3cbae5fb]{margin-top:auto!important}.me-xxl-0[data-v-3cbae5fb]{margin-right:0!important}.me-xxl-1[data-v-3cbae5fb]{margin-right:.25rem!important}.me-xxl-2[data-v-3cbae5fb]{margin-right:.5rem!important}.me-xxl-3[data-v-3cbae5fb]{margin-right:1rem!important}.me-xxl-4[data-v-3cbae5fb]{margin-right:1.5rem!important}.me-xxl-5[data-v-3cbae5fb]{margin-right:3rem!important}.me-xxl-auto[data-v-3cbae5fb]{margin-right:auto!important}.mb-xxl-0[data-v-3cbae5fb]{margin-bottom:0!important}.mb-xxl-1[data-v-3cbae5fb]{margin-bottom:.25rem!important}.mb-xxl-2[data-v-3cbae5fb]{margin-bottom:.5rem!important}.mb-xxl-3[data-v-3cbae5fb]{margin-bottom:1rem!important}.mb-xxl-4[data-v-3cbae5fb]{margin-bottom:1.5rem!important}.mb-xxl-5[data-v-3cbae5fb]{margin-bottom:3rem!important}.mb-xxl-auto[data-v-3cbae5fb]{margin-bottom:auto!important}.ms-xxl-0[data-v-3cbae5fb]{margin-left:0!important}.ms-xxl-1[data-v-3cbae5fb]{margin-left:.25rem!important}.ms-xxl-2[data-v-3cbae5fb]{margin-left:.5rem!important}.ms-xxl-3[data-v-3cbae5fb]{margin-left:1rem!important}.ms-xxl-4[data-v-3cbae5fb]{margin-left:1.5rem!important}.ms-xxl-5[data-v-3cbae5fb]{margin-left:3rem!important}.ms-xxl-auto[data-v-3cbae5fb]{margin-left:auto!important}.p-xxl-0[data-v-3cbae5fb]{padding:0!important}.p-xxl-1[data-v-3cbae5fb]{padding:.25rem!important}.p-xxl-2[data-v-3cbae5fb]{padding:.5rem!important}.p-xxl-3[data-v-3cbae5fb]{padding:1rem!important}.p-xxl-4[data-v-3cbae5fb]{padding:1.5rem!important}.p-xxl-5[data-v-3cbae5fb]{padding:3rem!important}.px-xxl-0[data-v-3cbae5fb]{padding-right:0!important;padding-left:0!important}.px-xxl-1[data-v-3cbae5fb]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xxl-2[data-v-3cbae5fb]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xxl-3[data-v-3cbae5fb]{padding-right:1rem!important;padding-left:1rem!important}.px-xxl-4[data-v-3cbae5fb]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xxl-5[data-v-3cbae5fb]{padding-right:3rem!important;padding-left:3rem!important}.py-xxl-0[data-v-3cbae5fb]{padding-top:0!important;padding-bottom:0!important}.py-xxl-1[data-v-3cbae5fb]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xxl-2[data-v-3cbae5fb]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xxl-3[data-v-3cbae5fb]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xxl-4[data-v-3cbae5fb]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xxl-5[data-v-3cbae5fb]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xxl-0[data-v-3cbae5fb]{padding-top:0!important}.pt-xxl-1[data-v-3cbae5fb]{padding-top:.25rem!important}.pt-xxl-2[data-v-3cbae5fb]{padding-top:.5rem!important}.pt-xxl-3[data-v-3cbae5fb]{padding-top:1rem!important}.pt-xxl-4[data-v-3cbae5fb]{padding-top:1.5rem!important}.pt-xxl-5[data-v-3cbae5fb]{padding-top:3rem!important}.pe-xxl-0[data-v-3cbae5fb]{padding-right:0!important}.pe-xxl-1[data-v-3cbae5fb]{padding-right:.25rem!important}.pe-xxl-2[data-v-3cbae5fb]{padding-right:.5rem!important}.pe-xxl-3[data-v-3cbae5fb]{padding-right:1rem!important}.pe-xxl-4[data-v-3cbae5fb]{padding-right:1.5rem!important}.pe-xxl-5[data-v-3cbae5fb]{padding-right:3rem!important}.pb-xxl-0[data-v-3cbae5fb]{padding-bottom:0!important}.pb-xxl-1[data-v-3cbae5fb]{padding-bottom:.25rem!important}.pb-xxl-2[data-v-3cbae5fb]{padding-bottom:.5rem!important}.pb-xxl-3[data-v-3cbae5fb]{padding-bottom:1rem!important}.pb-xxl-4[data-v-3cbae5fb]{padding-bottom:1.5rem!important}.pb-xxl-5[data-v-3cbae5fb]{padding-bottom:3rem!important}.ps-xxl-0[data-v-3cbae5fb]{padding-left:0!important}.ps-xxl-1[data-v-3cbae5fb]{padding-left:.25rem!important}.ps-xxl-2[data-v-3cbae5fb]{padding-left:.5rem!important}.ps-xxl-3[data-v-3cbae5fb]{padding-left:1rem!important}.ps-xxl-4[data-v-3cbae5fb]{padding-left:1.5rem!important}.ps-xxl-5[data-v-3cbae5fb]{padding-left:3rem!important}.text-xxl-start[data-v-3cbae5fb]{text-align:left!important}.text-xxl-end[data-v-3cbae5fb]{text-align:right!important}.text-xxl-center[data-v-3cbae5fb]{text-align:center!important}}@media (min-width:1200px){.fs-1[data-v-3cbae5fb]{font-size:2.5rem!important}.fs-2[data-v-3cbae5fb]{font-size:2rem!important}.fs-3[data-v-3cbae5fb]{font-size:1.75rem!important}.fs-4[data-v-3cbae5fb]{font-size:1.5rem!important}}@media print{.d-print-inline[data-v-3cbae5fb]{display:inline!important}.d-print-inline-block[data-v-3cbae5fb]{display:inline-block!important}.d-print-block[data-v-3cbae5fb]{display:block!important}.d-print-grid[data-v-3cbae5fb]{display:grid!important}.d-print-table[data-v-3cbae5fb]{display:table!important}.d-print-table-row[data-v-3cbae5fb]{display:table-row!important}.d-print-table-cell[data-v-3cbae5fb]{display:table-cell!important}.d-print-flex[data-v-3cbae5fb]{display:flex!important}.d-print-inline-flex[data-v-3cbae5fb]{display:inline-flex!important}.d-print-none[data-v-3cbae5fb]{display:none!important}}", ""]);

// exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(147);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("01e454ac", content, true, {});

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".indented[data-v-3cbae5fb]{margin:20px;max-width:550px}.button[data-v-3cbae5fb]{border:1px solid gray}.spaced[data-v-3cbae5fb]{margin-top:20px}", ""]);

// exports


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indented"},[_c('form',{ref:"formHTML",on:{"submit":function($event){$event.preventDefault();return _vm.submitForm.apply(null, arguments)}}},[_c('div',{staticClass:"form-horizontal"},[_c('h2',[_vm._v("Delete Product")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Are you sure you want to delete this product?")]),_vm._v(" "),_c('div',[_c('h5',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('router-link',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"to":{ path: '/DeleteProd', query: { Id: _vm.id } }}},[_c('input',{staticClass:"button btn btn-default",attrs:{"type":"submit","value":"Delete"}})])],1),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.goBack}},[_vm._v("<< Back")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(150);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("25e6b59f", content, true, {});

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n/*!\n * Bootstrap v5.1.3 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */[data-v-88355c96]:root{--bs-blue:#0d6efd;--bs-indigo:#6610f2;--bs-purple:#6f42c1;--bs-pink:#d63384;--bs-red:#dc3545;--bs-orange:#fd7e14;--bs-yellow:#ffc107;--bs-green:#198754;--bs-teal:#20c997;--bs-cyan:#0dcaf0;--bs-white:#fff;--bs-gray:#6c757d;--bs-gray-dark:#343a40;--bs-gray-100:#f8f9fa;--bs-gray-200:#e9ecef;--bs-gray-300:#dee2e6;--bs-gray-400:#ced4da;--bs-gray-500:#adb5bd;--bs-gray-600:#6c757d;--bs-gray-700:#495057;--bs-gray-800:#343a40;--bs-gray-900:#212529;--bs-primary:#0d6efd;--bs-secondary:#6c757d;--bs-success:#198754;--bs-info:#0dcaf0;--bs-warning:#ffc107;--bs-danger:#dc3545;--bs-light:#f8f9fa;--bs-dark:#212529;--bs-primary-rgb:13,110,253;--bs-secondary-rgb:108,117,125;--bs-success-rgb:25,135,84;--bs-info-rgb:13,202,240;--bs-warning-rgb:255,193,7;--bs-danger-rgb:220,53,69;--bs-light-rgb:248,249,250;--bs-dark-rgb:33,37,41;--bs-white-rgb:255,255,255;--bs-black-rgb:0,0,0;--bs-body-color-rgb:33,37,41;--bs-body-bg-rgb:255,255,255;--bs-font-sans-serif:system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--bs-font-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;--bs-gradient:linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));--bs-body-font-family:var(--bs-font-sans-serif);--bs-body-font-size:1rem;--bs-body-font-weight:400;--bs-body-line-height:1.5;--bs-body-color:#212529;--bs-body-bg:#fff}[data-v-88355c96],[data-v-88355c96]:after,[data-v-88355c96]:before{box-sizing:border-box}@media (prefers-reduced-motion:no-preference){[data-v-88355c96]:root{scroll-behavior:smooth}}body[data-v-88355c96]{margin:0;font-family:var(--bs-body-font-family);font-size:var(--bs-body-font-size);font-weight:var(--bs-body-font-weight);line-height:var(--bs-body-line-height);color:var(--bs-body-color);text-align:var(--bs-body-text-align);background-color:var(--bs-body-bg);-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}hr[data-v-88355c96]{margin:1rem 0;color:inherit;background-color:currentColor;border:0;opacity:.25}hr[data-v-88355c96]:not([size]){height:1px}.h1[data-v-88355c96],.h2[data-v-88355c96],.h3[data-v-88355c96],.h4[data-v-88355c96],.h5[data-v-88355c96],.h6[data-v-88355c96],h1[data-v-88355c96],h2[data-v-88355c96],h3[data-v-88355c96],h4[data-v-88355c96],h5[data-v-88355c96],h6[data-v-88355c96]{margin-top:0;margin-bottom:.5rem;font-weight:500;line-height:1.2}.h1[data-v-88355c96],h1[data-v-88355c96]{font-size:calc(1.375rem + 1.5vw)}@media (min-width:1200px){.h1[data-v-88355c96],h1[data-v-88355c96]{font-size:2.5rem}}.h2[data-v-88355c96],h2[data-v-88355c96]{font-size:calc(1.325rem + .9vw)}@media (min-width:1200px){.h2[data-v-88355c96],h2[data-v-88355c96]{font-size:2rem}}.h3[data-v-88355c96],h3[data-v-88355c96]{font-size:calc(1.3rem + .6vw)}@media (min-width:1200px){.h3[data-v-88355c96],h3[data-v-88355c96]{font-size:1.75rem}}.h4[data-v-88355c96],h4[data-v-88355c96]{font-size:calc(1.275rem + .3vw)}@media (min-width:1200px){.h4[data-v-88355c96],h4[data-v-88355c96]{font-size:1.5rem}}.h5[data-v-88355c96],h5[data-v-88355c96]{font-size:1.25rem}.h6[data-v-88355c96],h6[data-v-88355c96]{font-size:1rem}p[data-v-88355c96]{margin-top:0;margin-bottom:1rem}abbr[data-bs-original-title][data-v-88355c96],abbr[title][data-v-88355c96]{-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address[data-v-88355c96]{margin-bottom:1rem;font-style:normal;line-height:inherit}ol[data-v-88355c96],ul[data-v-88355c96]{padding-left:2rem}dl[data-v-88355c96],ol[data-v-88355c96],ul[data-v-88355c96]{margin-top:0;margin-bottom:1rem}ol ol[data-v-88355c96],ol ul[data-v-88355c96],ul ol[data-v-88355c96],ul ul[data-v-88355c96]{margin-bottom:0}dt[data-v-88355c96]{font-weight:700}dd[data-v-88355c96]{margin-bottom:.5rem;margin-left:0}blockquote[data-v-88355c96]{margin:0 0 1rem}b[data-v-88355c96],strong[data-v-88355c96]{font-weight:bolder}.small[data-v-88355c96],small[data-v-88355c96]{font-size:.875em}.mark[data-v-88355c96],mark[data-v-88355c96]{padding:.2em;background-color:#fcf8e3}sub[data-v-88355c96],sup[data-v-88355c96]{position:relative;font-size:.75em;line-height:0;vertical-align:baseline}sub[data-v-88355c96]{bottom:-.25em}sup[data-v-88355c96]{top:-.5em}a[data-v-88355c96]{color:#0d6efd;text-decoration:underline}a[data-v-88355c96]:hover{color:#0a58ca}a[data-v-88355c96]:not([href]):not([class]),a[data-v-88355c96]:not([href]):not([class]):hover{color:inherit;text-decoration:none}code[data-v-88355c96],kbd[data-v-88355c96],pre[data-v-88355c96],samp[data-v-88355c96]{font-family:var(--bs-font-monospace);font-size:1em;direction:ltr;unicode-bidi:bidi-override}pre[data-v-88355c96]{display:block;margin-top:0;margin-bottom:1rem;overflow:auto;font-size:.875em}pre code[data-v-88355c96]{font-size:inherit;color:inherit;word-break:normal}code[data-v-88355c96]{font-size:.875em;color:#d63384;word-wrap:break-word}a>code[data-v-88355c96]{color:inherit}kbd[data-v-88355c96]{padding:.2rem .4rem;font-size:.875em;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd[data-v-88355c96]{padding:0;font-size:1em;font-weight:700}figure[data-v-88355c96]{margin:0 0 1rem}img[data-v-88355c96],svg[data-v-88355c96]{vertical-align:middle}table[data-v-88355c96]{caption-side:bottom;border-collapse:collapse}caption[data-v-88355c96]{padding-top:.5rem;padding-bottom:.5rem;color:#6c757d;text-align:left}th[data-v-88355c96]{text-align:inherit;text-align:-webkit-match-parent}tbody[data-v-88355c96],td[data-v-88355c96],tfoot[data-v-88355c96],th[data-v-88355c96],thead[data-v-88355c96],tr[data-v-88355c96]{border-color:inherit;border-style:solid;border-width:0}label[data-v-88355c96]{display:inline-block}button[data-v-88355c96]{border-radius:0}button[data-v-88355c96]:focus:not(:focus-visible){outline:0}button[data-v-88355c96],input[data-v-88355c96],optgroup[data-v-88355c96],select[data-v-88355c96],textarea[data-v-88355c96]{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button[data-v-88355c96],select[data-v-88355c96]{text-transform:none}[role=button][data-v-88355c96]{cursor:pointer}select[data-v-88355c96]{word-wrap:normal}select[data-v-88355c96]:disabled{opacity:1}[list][data-v-88355c96]::-webkit-calendar-picker-indicator{display:none}[type=button][data-v-88355c96],[type=reset][data-v-88355c96],[type=submit][data-v-88355c96],button[data-v-88355c96]{-webkit-appearance:button}[type=button][data-v-88355c96]:not(:disabled),[type=reset][data-v-88355c96]:not(:disabled),[type=submit][data-v-88355c96]:not(:disabled),button[data-v-88355c96]:not(:disabled){cursor:pointer}[data-v-88355c96]::-moz-focus-inner{padding:0;border-style:none}textarea[data-v-88355c96]{resize:vertical}fieldset[data-v-88355c96]{min-width:0;padding:0;margin:0;border:0}legend[data-v-88355c96]{float:left;width:100%;padding:0;margin-bottom:.5rem;font-size:calc(1.275rem + .3vw);line-height:inherit}@media (min-width:1200px){legend[data-v-88355c96]{font-size:1.5rem}}legend+[data-v-88355c96]{clear:left}[data-v-88355c96]::-webkit-datetime-edit-day-field,[data-v-88355c96]::-webkit-datetime-edit-fields-wrapper,[data-v-88355c96]::-webkit-datetime-edit-hour-field,[data-v-88355c96]::-webkit-datetime-edit-minute,[data-v-88355c96]::-webkit-datetime-edit-month-field,[data-v-88355c96]::-webkit-datetime-edit-text,[data-v-88355c96]::-webkit-datetime-edit-year-field{padding:0}[data-v-88355c96]::-webkit-inner-spin-button{height:auto}[type=search][data-v-88355c96]{outline-offset:-2px;-webkit-appearance:textfield}[data-v-88355c96]::-webkit-search-decoration{-webkit-appearance:none}[data-v-88355c96]::-webkit-color-swatch-wrapper{padding:0}[data-v-88355c96]::file-selector-button{font:inherit}[data-v-88355c96]::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output[data-v-88355c96]{display:inline-block}iframe[data-v-88355c96]{border:0}summary[data-v-88355c96]{display:list-item;cursor:pointer}progress[data-v-88355c96]{vertical-align:baseline}[hidden][data-v-88355c96]{display:none!important}.lead[data-v-88355c96]{font-size:1.25rem;font-weight:300}.display-1[data-v-88355c96]{font-size:calc(1.625rem + 4.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-1[data-v-88355c96]{font-size:5rem}}.display-2[data-v-88355c96]{font-size:calc(1.575rem + 3.9vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-2[data-v-88355c96]{font-size:4.5rem}}.display-3[data-v-88355c96]{font-size:calc(1.525rem + 3.3vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-3[data-v-88355c96]{font-size:4rem}}.display-4[data-v-88355c96]{font-size:calc(1.475rem + 2.7vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-4[data-v-88355c96]{font-size:3.5rem}}.display-5[data-v-88355c96]{font-size:calc(1.425rem + 2.1vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-5[data-v-88355c96]{font-size:3rem}}.display-6[data-v-88355c96]{font-size:calc(1.375rem + 1.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-6[data-v-88355c96]{font-size:2.5rem}}.list-inline[data-v-88355c96],.list-unstyled[data-v-88355c96]{padding-left:0;list-style:none}.list-inline-item[data-v-88355c96]{display:inline-block}.list-inline-item[data-v-88355c96]:not(:last-child){margin-right:.5rem}.initialism[data-v-88355c96]{font-size:.875em;text-transform:uppercase}.blockquote[data-v-88355c96]{margin-bottom:1rem;font-size:1.25rem}.blockquote[data-v-88355c96]>:last-child{margin-bottom:0}.blockquote-footer[data-v-88355c96]{margin-top:-1rem;margin-bottom:1rem;font-size:.875em;color:#6c757d}.blockquote-footer[data-v-88355c96]:before{content:\"\\2014\\A0\"}.img-fluid[data-v-88355c96]{max-width:100%;height:auto}.img-thumbnail[data-v-88355c96]{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.figure[data-v-88355c96]{display:inline-block}.figure-img[data-v-88355c96]{margin-bottom:.5rem;line-height:1}.figure-caption[data-v-88355c96]{font-size:.875em;color:#6c757d}.container-fluid[data-v-88355c96],.container-lg[data-v-88355c96],.container-md[data-v-88355c96],.container-sm[data-v-88355c96],.container-xl[data-v-88355c96],.container-xxl[data-v-88355c96],.container[data-v-88355c96]{width:100%;padding-right:var(--bs-gutter-x,.75rem);padding-left:var(--bs-gutter-x,.75rem);margin-right:auto;margin-left:auto}@media (min-width:576px){.container-sm[data-v-88355c96],.container[data-v-88355c96]{max-width:540px}}@media (min-width:768px){.container-md[data-v-88355c96],.container-sm[data-v-88355c96],.container[data-v-88355c96]{max-width:720px}}@media (min-width:992px){.container-lg[data-v-88355c96],.container-md[data-v-88355c96],.container-sm[data-v-88355c96],.container[data-v-88355c96]{max-width:960px}}@media (min-width:1200px){.container-lg[data-v-88355c96],.container-md[data-v-88355c96],.container-sm[data-v-88355c96],.container-xl[data-v-88355c96],.container[data-v-88355c96]{max-width:1140px}}@media (min-width:1400px){.container-lg[data-v-88355c96],.container-md[data-v-88355c96],.container-sm[data-v-88355c96],.container-xl[data-v-88355c96],.container-xxl[data-v-88355c96],.container[data-v-88355c96]{max-width:1320px}}.row[data-v-88355c96]{--bs-gutter-x:1.5rem;--bs-gutter-y:0;display:flex;flex-wrap:wrap;margin-top:calc(-1 * var(--bs-gutter-y));margin-right:calc(-.5 * var(--bs-gutter-x));margin-left:calc(-.5 * var(--bs-gutter-x))}.row>[data-v-88355c96]{flex-shrink:0;width:100%;max-width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-top:var(--bs-gutter-y)}.col[data-v-88355c96]{flex:1 0 0%}.row-cols-auto>[data-v-88355c96]{flex:0 0 auto;width:auto}.row-cols-1>[data-v-88355c96]{flex:0 0 auto;width:100%}.row-cols-2>[data-v-88355c96]{flex:0 0 auto;width:50%}.row-cols-3>[data-v-88355c96]{flex:0 0 auto;width:33.3333333333%}.row-cols-4>[data-v-88355c96]{flex:0 0 auto;width:25%}.row-cols-5>[data-v-88355c96]{flex:0 0 auto;width:20%}.row-cols-6>[data-v-88355c96]{flex:0 0 auto;width:16.6666666667%}.col-auto[data-v-88355c96]{flex:0 0 auto;width:auto}.col-1[data-v-88355c96]{flex:0 0 auto;width:8.33333333%}.col-2[data-v-88355c96]{flex:0 0 auto;width:16.66666667%}.col-3[data-v-88355c96]{flex:0 0 auto;width:25%}.col-4[data-v-88355c96]{flex:0 0 auto;width:33.33333333%}.col-5[data-v-88355c96]{flex:0 0 auto;width:41.66666667%}.col-6[data-v-88355c96]{flex:0 0 auto;width:50%}.col-7[data-v-88355c96]{flex:0 0 auto;width:58.33333333%}.col-8[data-v-88355c96]{flex:0 0 auto;width:66.66666667%}.col-9[data-v-88355c96]{flex:0 0 auto;width:75%}.col-10[data-v-88355c96]{flex:0 0 auto;width:83.33333333%}.col-11[data-v-88355c96]{flex:0 0 auto;width:91.66666667%}.col-12[data-v-88355c96]{flex:0 0 auto;width:100%}.offset-1[data-v-88355c96]{margin-left:8.33333333%}.offset-2[data-v-88355c96]{margin-left:16.66666667%}.offset-3[data-v-88355c96]{margin-left:25%}.offset-4[data-v-88355c96]{margin-left:33.33333333%}.offset-5[data-v-88355c96]{margin-left:41.66666667%}.offset-6[data-v-88355c96]{margin-left:50%}.offset-7[data-v-88355c96]{margin-left:58.33333333%}.offset-8[data-v-88355c96]{margin-left:66.66666667%}.offset-9[data-v-88355c96]{margin-left:75%}.offset-10[data-v-88355c96]{margin-left:83.33333333%}.offset-11[data-v-88355c96]{margin-left:91.66666667%}.g-0[data-v-88355c96],.gx-0[data-v-88355c96]{--bs-gutter-x:0}.g-0[data-v-88355c96],.gy-0[data-v-88355c96]{--bs-gutter-y:0}.g-1[data-v-88355c96],.gx-1[data-v-88355c96]{--bs-gutter-x:0.25rem}.g-1[data-v-88355c96],.gy-1[data-v-88355c96]{--bs-gutter-y:0.25rem}.g-2[data-v-88355c96],.gx-2[data-v-88355c96]{--bs-gutter-x:0.5rem}.g-2[data-v-88355c96],.gy-2[data-v-88355c96]{--bs-gutter-y:0.5rem}.g-3[data-v-88355c96],.gx-3[data-v-88355c96]{--bs-gutter-x:1rem}.g-3[data-v-88355c96],.gy-3[data-v-88355c96]{--bs-gutter-y:1rem}.g-4[data-v-88355c96],.gx-4[data-v-88355c96]{--bs-gutter-x:1.5rem}.g-4[data-v-88355c96],.gy-4[data-v-88355c96]{--bs-gutter-y:1.5rem}.g-5[data-v-88355c96],.gx-5[data-v-88355c96]{--bs-gutter-x:3rem}.g-5[data-v-88355c96],.gy-5[data-v-88355c96]{--bs-gutter-y:3rem}@media (min-width:576px){.col-sm[data-v-88355c96]{flex:1 0 0%}.row-cols-sm-auto>[data-v-88355c96]{flex:0 0 auto;width:auto}.row-cols-sm-1>[data-v-88355c96]{flex:0 0 auto;width:100%}.row-cols-sm-2>[data-v-88355c96]{flex:0 0 auto;width:50%}.row-cols-sm-3>[data-v-88355c96]{flex:0 0 auto;width:33.3333333333%}.row-cols-sm-4>[data-v-88355c96]{flex:0 0 auto;width:25%}.row-cols-sm-5>[data-v-88355c96]{flex:0 0 auto;width:20%}.row-cols-sm-6>[data-v-88355c96]{flex:0 0 auto;width:16.6666666667%}.col-sm-auto[data-v-88355c96]{flex:0 0 auto;width:auto}.col-sm-1[data-v-88355c96]{flex:0 0 auto;width:8.33333333%}.col-sm-2[data-v-88355c96]{flex:0 0 auto;width:16.66666667%}.col-sm-3[data-v-88355c96]{flex:0 0 auto;width:25%}.col-sm-4[data-v-88355c96]{flex:0 0 auto;width:33.33333333%}.col-sm-5[data-v-88355c96]{flex:0 0 auto;width:41.66666667%}.col-sm-6[data-v-88355c96]{flex:0 0 auto;width:50%}.col-sm-7[data-v-88355c96]{flex:0 0 auto;width:58.33333333%}.col-sm-8[data-v-88355c96]{flex:0 0 auto;width:66.66666667%}.col-sm-9[data-v-88355c96]{flex:0 0 auto;width:75%}.col-sm-10[data-v-88355c96]{flex:0 0 auto;width:83.33333333%}.col-sm-11[data-v-88355c96]{flex:0 0 auto;width:91.66666667%}.col-sm-12[data-v-88355c96]{flex:0 0 auto;width:100%}.offset-sm-0[data-v-88355c96]{margin-left:0}.offset-sm-1[data-v-88355c96]{margin-left:8.33333333%}.offset-sm-2[data-v-88355c96]{margin-left:16.66666667%}.offset-sm-3[data-v-88355c96]{margin-left:25%}.offset-sm-4[data-v-88355c96]{margin-left:33.33333333%}.offset-sm-5[data-v-88355c96]{margin-left:41.66666667%}.offset-sm-6[data-v-88355c96]{margin-left:50%}.offset-sm-7[data-v-88355c96]{margin-left:58.33333333%}.offset-sm-8[data-v-88355c96]{margin-left:66.66666667%}.offset-sm-9[data-v-88355c96]{margin-left:75%}.offset-sm-10[data-v-88355c96]{margin-left:83.33333333%}.offset-sm-11[data-v-88355c96]{margin-left:91.66666667%}.g-sm-0[data-v-88355c96],.gx-sm-0[data-v-88355c96]{--bs-gutter-x:0}.g-sm-0[data-v-88355c96],.gy-sm-0[data-v-88355c96]{--bs-gutter-y:0}.g-sm-1[data-v-88355c96],.gx-sm-1[data-v-88355c96]{--bs-gutter-x:0.25rem}.g-sm-1[data-v-88355c96],.gy-sm-1[data-v-88355c96]{--bs-gutter-y:0.25rem}.g-sm-2[data-v-88355c96],.gx-sm-2[data-v-88355c96]{--bs-gutter-x:0.5rem}.g-sm-2[data-v-88355c96],.gy-sm-2[data-v-88355c96]{--bs-gutter-y:0.5rem}.g-sm-3[data-v-88355c96],.gx-sm-3[data-v-88355c96]{--bs-gutter-x:1rem}.g-sm-3[data-v-88355c96],.gy-sm-3[data-v-88355c96]{--bs-gutter-y:1rem}.g-sm-4[data-v-88355c96],.gx-sm-4[data-v-88355c96]{--bs-gutter-x:1.5rem}.g-sm-4[data-v-88355c96],.gy-sm-4[data-v-88355c96]{--bs-gutter-y:1.5rem}.g-sm-5[data-v-88355c96],.gx-sm-5[data-v-88355c96]{--bs-gutter-x:3rem}.g-sm-5[data-v-88355c96],.gy-sm-5[data-v-88355c96]{--bs-gutter-y:3rem}}@media (min-width:768px){.col-md[data-v-88355c96]{flex:1 0 0%}.row-cols-md-auto>[data-v-88355c96]{flex:0 0 auto;width:auto}.row-cols-md-1>[data-v-88355c96]{flex:0 0 auto;width:100%}.row-cols-md-2>[data-v-88355c96]{flex:0 0 auto;width:50%}.row-cols-md-3>[data-v-88355c96]{flex:0 0 auto;width:33.3333333333%}.row-cols-md-4>[data-v-88355c96]{flex:0 0 auto;width:25%}.row-cols-md-5>[data-v-88355c96]{flex:0 0 auto;width:20%}.row-cols-md-6>[data-v-88355c96]{flex:0 0 auto;width:16.6666666667%}.col-md-auto[data-v-88355c96]{flex:0 0 auto;width:auto}.col-md-1[data-v-88355c96]{flex:0 0 auto;width:8.33333333%}.col-md-2[data-v-88355c96]{flex:0 0 auto;width:16.66666667%}.col-md-3[data-v-88355c96]{flex:0 0 auto;width:25%}.col-md-4[data-v-88355c96]{flex:0 0 auto;width:33.33333333%}.col-md-5[data-v-88355c96]{flex:0 0 auto;width:41.66666667%}.col-md-6[data-v-88355c96]{flex:0 0 auto;width:50%}.col-md-7[data-v-88355c96]{flex:0 0 auto;width:58.33333333%}.col-md-8[data-v-88355c96]{flex:0 0 auto;width:66.66666667%}.col-md-9[data-v-88355c96]{flex:0 0 auto;width:75%}.col-md-10[data-v-88355c96]{flex:0 0 auto;width:83.33333333%}.col-md-11[data-v-88355c96]{flex:0 0 auto;width:91.66666667%}.col-md-12[data-v-88355c96]{flex:0 0 auto;width:100%}.offset-md-0[data-v-88355c96]{margin-left:0}.offset-md-1[data-v-88355c96]{margin-left:8.33333333%}.offset-md-2[data-v-88355c96]{margin-left:16.66666667%}.offset-md-3[data-v-88355c96]{margin-left:25%}.offset-md-4[data-v-88355c96]{margin-left:33.33333333%}.offset-md-5[data-v-88355c96]{margin-left:41.66666667%}.offset-md-6[data-v-88355c96]{margin-left:50%}.offset-md-7[data-v-88355c96]{margin-left:58.33333333%}.offset-md-8[data-v-88355c96]{margin-left:66.66666667%}.offset-md-9[data-v-88355c96]{margin-left:75%}.offset-md-10[data-v-88355c96]{margin-left:83.33333333%}.offset-md-11[data-v-88355c96]{margin-left:91.66666667%}.g-md-0[data-v-88355c96],.gx-md-0[data-v-88355c96]{--bs-gutter-x:0}.g-md-0[data-v-88355c96],.gy-md-0[data-v-88355c96]{--bs-gutter-y:0}.g-md-1[data-v-88355c96],.gx-md-1[data-v-88355c96]{--bs-gutter-x:0.25rem}.g-md-1[data-v-88355c96],.gy-md-1[data-v-88355c96]{--bs-gutter-y:0.25rem}.g-md-2[data-v-88355c96],.gx-md-2[data-v-88355c96]{--bs-gutter-x:0.5rem}.g-md-2[data-v-88355c96],.gy-md-2[data-v-88355c96]{--bs-gutter-y:0.5rem}.g-md-3[data-v-88355c96],.gx-md-3[data-v-88355c96]{--bs-gutter-x:1rem}.g-md-3[data-v-88355c96],.gy-md-3[data-v-88355c96]{--bs-gutter-y:1rem}.g-md-4[data-v-88355c96],.gx-md-4[data-v-88355c96]{--bs-gutter-x:1.5rem}.g-md-4[data-v-88355c96],.gy-md-4[data-v-88355c96]{--bs-gutter-y:1.5rem}.g-md-5[data-v-88355c96],.gx-md-5[data-v-88355c96]{--bs-gutter-x:3rem}.g-md-5[data-v-88355c96],.gy-md-5[data-v-88355c96]{--bs-gutter-y:3rem}}@media (min-width:992px){.col-lg[data-v-88355c96]{flex:1 0 0%}.row-cols-lg-auto>[data-v-88355c96]{flex:0 0 auto;width:auto}.row-cols-lg-1>[data-v-88355c96]{flex:0 0 auto;width:100%}.row-cols-lg-2>[data-v-88355c96]{flex:0 0 auto;width:50%}.row-cols-lg-3>[data-v-88355c96]{flex:0 0 auto;width:33.3333333333%}.row-cols-lg-4>[data-v-88355c96]{flex:0 0 auto;width:25%}.row-cols-lg-5>[data-v-88355c96]{flex:0 0 auto;width:20%}.row-cols-lg-6>[data-v-88355c96]{flex:0 0 auto;width:16.6666666667%}.col-lg-auto[data-v-88355c96]{flex:0 0 auto;width:auto}.col-lg-1[data-v-88355c96]{flex:0 0 auto;width:8.33333333%}.col-lg-2[data-v-88355c96]{flex:0 0 auto;width:16.66666667%}.col-lg-3[data-v-88355c96]{flex:0 0 auto;width:25%}.col-lg-4[data-v-88355c96]{flex:0 0 auto;width:33.33333333%}.col-lg-5[data-v-88355c96]{flex:0 0 auto;width:41.66666667%}.col-lg-6[data-v-88355c96]{flex:0 0 auto;width:50%}.col-lg-7[data-v-88355c96]{flex:0 0 auto;width:58.33333333%}.col-lg-8[data-v-88355c96]{flex:0 0 auto;width:66.66666667%}.col-lg-9[data-v-88355c96]{flex:0 0 auto;width:75%}.col-lg-10[data-v-88355c96]{flex:0 0 auto;width:83.33333333%}.col-lg-11[data-v-88355c96]{flex:0 0 auto;width:91.66666667%}.col-lg-12[data-v-88355c96]{flex:0 0 auto;width:100%}.offset-lg-0[data-v-88355c96]{margin-left:0}.offset-lg-1[data-v-88355c96]{margin-left:8.33333333%}.offset-lg-2[data-v-88355c96]{margin-left:16.66666667%}.offset-lg-3[data-v-88355c96]{margin-left:25%}.offset-lg-4[data-v-88355c96]{margin-left:33.33333333%}.offset-lg-5[data-v-88355c96]{margin-left:41.66666667%}.offset-lg-6[data-v-88355c96]{margin-left:50%}.offset-lg-7[data-v-88355c96]{margin-left:58.33333333%}.offset-lg-8[data-v-88355c96]{margin-left:66.66666667%}.offset-lg-9[data-v-88355c96]{margin-left:75%}.offset-lg-10[data-v-88355c96]{margin-left:83.33333333%}.offset-lg-11[data-v-88355c96]{margin-left:91.66666667%}.g-lg-0[data-v-88355c96],.gx-lg-0[data-v-88355c96]{--bs-gutter-x:0}.g-lg-0[data-v-88355c96],.gy-lg-0[data-v-88355c96]{--bs-gutter-y:0}.g-lg-1[data-v-88355c96],.gx-lg-1[data-v-88355c96]{--bs-gutter-x:0.25rem}.g-lg-1[data-v-88355c96],.gy-lg-1[data-v-88355c96]{--bs-gutter-y:0.25rem}.g-lg-2[data-v-88355c96],.gx-lg-2[data-v-88355c96]{--bs-gutter-x:0.5rem}.g-lg-2[data-v-88355c96],.gy-lg-2[data-v-88355c96]{--bs-gutter-y:0.5rem}.g-lg-3[data-v-88355c96],.gx-lg-3[data-v-88355c96]{--bs-gutter-x:1rem}.g-lg-3[data-v-88355c96],.gy-lg-3[data-v-88355c96]{--bs-gutter-y:1rem}.g-lg-4[data-v-88355c96],.gx-lg-4[data-v-88355c96]{--bs-gutter-x:1.5rem}.g-lg-4[data-v-88355c96],.gy-lg-4[data-v-88355c96]{--bs-gutter-y:1.5rem}.g-lg-5[data-v-88355c96],.gx-lg-5[data-v-88355c96]{--bs-gutter-x:3rem}.g-lg-5[data-v-88355c96],.gy-lg-5[data-v-88355c96]{--bs-gutter-y:3rem}}@media (min-width:1200px){.col-xl[data-v-88355c96]{flex:1 0 0%}.row-cols-xl-auto>[data-v-88355c96]{flex:0 0 auto;width:auto}.row-cols-xl-1>[data-v-88355c96]{flex:0 0 auto;width:100%}.row-cols-xl-2>[data-v-88355c96]{flex:0 0 auto;width:50%}.row-cols-xl-3>[data-v-88355c96]{flex:0 0 auto;width:33.3333333333%}.row-cols-xl-4>[data-v-88355c96]{flex:0 0 auto;width:25%}.row-cols-xl-5>[data-v-88355c96]{flex:0 0 auto;width:20%}.row-cols-xl-6>[data-v-88355c96]{flex:0 0 auto;width:16.6666666667%}.col-xl-auto[data-v-88355c96]{flex:0 0 auto;width:auto}.col-xl-1[data-v-88355c96]{flex:0 0 auto;width:8.33333333%}.col-xl-2[data-v-88355c96]{flex:0 0 auto;width:16.66666667%}.col-xl-3[data-v-88355c96]{flex:0 0 auto;width:25%}.col-xl-4[data-v-88355c96]{flex:0 0 auto;width:33.33333333%}.col-xl-5[data-v-88355c96]{flex:0 0 auto;width:41.66666667%}.col-xl-6[data-v-88355c96]{flex:0 0 auto;width:50%}.col-xl-7[data-v-88355c96]{flex:0 0 auto;width:58.33333333%}.col-xl-8[data-v-88355c96]{flex:0 0 auto;width:66.66666667%}.col-xl-9[data-v-88355c96]{flex:0 0 auto;width:75%}.col-xl-10[data-v-88355c96]{flex:0 0 auto;width:83.33333333%}.col-xl-11[data-v-88355c96]{flex:0 0 auto;width:91.66666667%}.col-xl-12[data-v-88355c96]{flex:0 0 auto;width:100%}.offset-xl-0[data-v-88355c96]{margin-left:0}.offset-xl-1[data-v-88355c96]{margin-left:8.33333333%}.offset-xl-2[data-v-88355c96]{margin-left:16.66666667%}.offset-xl-3[data-v-88355c96]{margin-left:25%}.offset-xl-4[data-v-88355c96]{margin-left:33.33333333%}.offset-xl-5[data-v-88355c96]{margin-left:41.66666667%}.offset-xl-6[data-v-88355c96]{margin-left:50%}.offset-xl-7[data-v-88355c96]{margin-left:58.33333333%}.offset-xl-8[data-v-88355c96]{margin-left:66.66666667%}.offset-xl-9[data-v-88355c96]{margin-left:75%}.offset-xl-10[data-v-88355c96]{margin-left:83.33333333%}.offset-xl-11[data-v-88355c96]{margin-left:91.66666667%}.g-xl-0[data-v-88355c96],.gx-xl-0[data-v-88355c96]{--bs-gutter-x:0}.g-xl-0[data-v-88355c96],.gy-xl-0[data-v-88355c96]{--bs-gutter-y:0}.g-xl-1[data-v-88355c96],.gx-xl-1[data-v-88355c96]{--bs-gutter-x:0.25rem}.g-xl-1[data-v-88355c96],.gy-xl-1[data-v-88355c96]{--bs-gutter-y:0.25rem}.g-xl-2[data-v-88355c96],.gx-xl-2[data-v-88355c96]{--bs-gutter-x:0.5rem}.g-xl-2[data-v-88355c96],.gy-xl-2[data-v-88355c96]{--bs-gutter-y:0.5rem}.g-xl-3[data-v-88355c96],.gx-xl-3[data-v-88355c96]{--bs-gutter-x:1rem}.g-xl-3[data-v-88355c96],.gy-xl-3[data-v-88355c96]{--bs-gutter-y:1rem}.g-xl-4[data-v-88355c96],.gx-xl-4[data-v-88355c96]{--bs-gutter-x:1.5rem}.g-xl-4[data-v-88355c96],.gy-xl-4[data-v-88355c96]{--bs-gutter-y:1.5rem}.g-xl-5[data-v-88355c96],.gx-xl-5[data-v-88355c96]{--bs-gutter-x:3rem}.g-xl-5[data-v-88355c96],.gy-xl-5[data-v-88355c96]{--bs-gutter-y:3rem}}@media (min-width:1400px){.col-xxl[data-v-88355c96]{flex:1 0 0%}.row-cols-xxl-auto>[data-v-88355c96]{flex:0 0 auto;width:auto}.row-cols-xxl-1>[data-v-88355c96]{flex:0 0 auto;width:100%}.row-cols-xxl-2>[data-v-88355c96]{flex:0 0 auto;width:50%}.row-cols-xxl-3>[data-v-88355c96]{flex:0 0 auto;width:33.3333333333%}.row-cols-xxl-4>[data-v-88355c96]{flex:0 0 auto;width:25%}.row-cols-xxl-5>[data-v-88355c96]{flex:0 0 auto;width:20%}.row-cols-xxl-6>[data-v-88355c96]{flex:0 0 auto;width:16.6666666667%}.col-xxl-auto[data-v-88355c96]{flex:0 0 auto;width:auto}.col-xxl-1[data-v-88355c96]{flex:0 0 auto;width:8.33333333%}.col-xxl-2[data-v-88355c96]{flex:0 0 auto;width:16.66666667%}.col-xxl-3[data-v-88355c96]{flex:0 0 auto;width:25%}.col-xxl-4[data-v-88355c96]{flex:0 0 auto;width:33.33333333%}.col-xxl-5[data-v-88355c96]{flex:0 0 auto;width:41.66666667%}.col-xxl-6[data-v-88355c96]{flex:0 0 auto;width:50%}.col-xxl-7[data-v-88355c96]{flex:0 0 auto;width:58.33333333%}.col-xxl-8[data-v-88355c96]{flex:0 0 auto;width:66.66666667%}.col-xxl-9[data-v-88355c96]{flex:0 0 auto;width:75%}.col-xxl-10[data-v-88355c96]{flex:0 0 auto;width:83.33333333%}.col-xxl-11[data-v-88355c96]{flex:0 0 auto;width:91.66666667%}.col-xxl-12[data-v-88355c96]{flex:0 0 auto;width:100%}.offset-xxl-0[data-v-88355c96]{margin-left:0}.offset-xxl-1[data-v-88355c96]{margin-left:8.33333333%}.offset-xxl-2[data-v-88355c96]{margin-left:16.66666667%}.offset-xxl-3[data-v-88355c96]{margin-left:25%}.offset-xxl-4[data-v-88355c96]{margin-left:33.33333333%}.offset-xxl-5[data-v-88355c96]{margin-left:41.66666667%}.offset-xxl-6[data-v-88355c96]{margin-left:50%}.offset-xxl-7[data-v-88355c96]{margin-left:58.33333333%}.offset-xxl-8[data-v-88355c96]{margin-left:66.66666667%}.offset-xxl-9[data-v-88355c96]{margin-left:75%}.offset-xxl-10[data-v-88355c96]{margin-left:83.33333333%}.offset-xxl-11[data-v-88355c96]{margin-left:91.66666667%}.g-xxl-0[data-v-88355c96],.gx-xxl-0[data-v-88355c96]{--bs-gutter-x:0}.g-xxl-0[data-v-88355c96],.gy-xxl-0[data-v-88355c96]{--bs-gutter-y:0}.g-xxl-1[data-v-88355c96],.gx-xxl-1[data-v-88355c96]{--bs-gutter-x:0.25rem}.g-xxl-1[data-v-88355c96],.gy-xxl-1[data-v-88355c96]{--bs-gutter-y:0.25rem}.g-xxl-2[data-v-88355c96],.gx-xxl-2[data-v-88355c96]{--bs-gutter-x:0.5rem}.g-xxl-2[data-v-88355c96],.gy-xxl-2[data-v-88355c96]{--bs-gutter-y:0.5rem}.g-xxl-3[data-v-88355c96],.gx-xxl-3[data-v-88355c96]{--bs-gutter-x:1rem}.g-xxl-3[data-v-88355c96],.gy-xxl-3[data-v-88355c96]{--bs-gutter-y:1rem}.g-xxl-4[data-v-88355c96],.gx-xxl-4[data-v-88355c96]{--bs-gutter-x:1.5rem}.g-xxl-4[data-v-88355c96],.gy-xxl-4[data-v-88355c96]{--bs-gutter-y:1.5rem}.g-xxl-5[data-v-88355c96],.gx-xxl-5[data-v-88355c96]{--bs-gutter-x:3rem}.g-xxl-5[data-v-88355c96],.gy-xxl-5[data-v-88355c96]{--bs-gutter-y:3rem}}.table[data-v-88355c96]{--bs-table-bg:transparent;--bs-table-accent-bg:transparent;--bs-table-striped-color:#212529;--bs-table-striped-bg:rgba(0,0,0,.05);--bs-table-active-color:#212529;--bs-table-active-bg:rgba(0,0,0,.1);--bs-table-hover-color:#212529;--bs-table-hover-bg:rgba(0,0,0,.075);width:100%;margin-bottom:1rem;color:#212529;vertical-align:top;border-color:#dee2e6}.table>:not(caption)>*>[data-v-88355c96]{padding:.5rem;background-color:var(--bs-table-bg);border-bottom-width:1px;box-shadow:inset 0 0 0 9999px var(--bs-table-accent-bg)}.table>tbody[data-v-88355c96]{vertical-align:inherit}.table>thead[data-v-88355c96]{vertical-align:bottom}.table[data-v-88355c96]>:not(:first-child){border-top:2px solid currentColor}.caption-top[data-v-88355c96]{caption-side:top}.table-sm>:not(caption)>*>[data-v-88355c96]{padding:.25rem}.table-bordered>:not(caption)>[data-v-88355c96]{border-width:1px 0}.table-bordered>:not(caption)>*>[data-v-88355c96]{border-width:0 1px}.table-borderless>:not(caption)>*>[data-v-88355c96]{border-bottom-width:0}.table-borderless[data-v-88355c96]>:not(:first-child){border-top-width:0}.table-striped>tbody>tr:nth-of-type(odd)>[data-v-88355c96]{--bs-table-accent-bg:var(--bs-table-striped-bg);color:var(--bs-table-striped-color)}.table-active[data-v-88355c96]{--bs-table-accent-bg:var(--bs-table-active-bg);color:var(--bs-table-active-color)}.table-hover>tbody>tr:hover>[data-v-88355c96]{--bs-table-accent-bg:var(--bs-table-hover-bg);color:var(--bs-table-hover-color)}.table-primary[data-v-88355c96]{--bs-table-bg:#cfe2ff;--bs-table-striped-bg:#c5d7f2;--bs-table-striped-color:#000;--bs-table-active-bg:#bacbe6;--bs-table-active-color:#000;--bs-table-hover-bg:#bfd1ec;--bs-table-hover-color:#000;color:#000;border-color:#bacbe6}.table-secondary[data-v-88355c96]{--bs-table-bg:#e2e3e5;--bs-table-striped-bg:#d7d8da;--bs-table-striped-color:#000;--bs-table-active-bg:#cbccce;--bs-table-active-color:#000;--bs-table-hover-bg:#d1d2d4;--bs-table-hover-color:#000;color:#000;border-color:#cbccce}.table-success[data-v-88355c96]{--bs-table-bg:#d1e7dd;--bs-table-striped-bg:#c7dbd2;--bs-table-striped-color:#000;--bs-table-active-bg:#bcd0c7;--bs-table-active-color:#000;--bs-table-hover-bg:#c1d6cc;--bs-table-hover-color:#000;color:#000;border-color:#bcd0c7}.table-info[data-v-88355c96]{--bs-table-bg:#cff4fc;--bs-table-striped-bg:#c5e8ef;--bs-table-striped-color:#000;--bs-table-active-bg:#badce3;--bs-table-active-color:#000;--bs-table-hover-bg:#bfe2e9;--bs-table-hover-color:#000;color:#000;border-color:#badce3}.table-warning[data-v-88355c96]{--bs-table-bg:#fff3cd;--bs-table-striped-bg:#f2e7c3;--bs-table-striped-color:#000;--bs-table-active-bg:#e6dbb9;--bs-table-active-color:#000;--bs-table-hover-bg:#ece1be;--bs-table-hover-color:#000;color:#000;border-color:#e6dbb9}.table-danger[data-v-88355c96]{--bs-table-bg:#f8d7da;--bs-table-striped-bg:#eccccf;--bs-table-striped-color:#000;--bs-table-active-bg:#dfc2c4;--bs-table-active-color:#000;--bs-table-hover-bg:#e5c7ca;--bs-table-hover-color:#000;color:#000;border-color:#dfc2c4}.table-light[data-v-88355c96]{--bs-table-bg:#f8f9fa;--bs-table-striped-bg:#ecedee;--bs-table-striped-color:#000;--bs-table-active-bg:#dfe0e1;--bs-table-active-color:#000;--bs-table-hover-bg:#e5e6e7;--bs-table-hover-color:#000;color:#000;border-color:#dfe0e1}.table-dark[data-v-88355c96]{--bs-table-bg:#212529;--bs-table-striped-bg:#2c3034;--bs-table-striped-color:#fff;--bs-table-active-bg:#373b3e;--bs-table-active-color:#fff;--bs-table-hover-bg:#323539;--bs-table-hover-color:#fff;color:#fff;border-color:#373b3e}.table-responsive[data-v-88355c96]{overflow-x:auto;-webkit-overflow-scrolling:touch}@media (max-width:575.98px){.table-responsive-sm[data-v-88355c96]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:767.98px){.table-responsive-md[data-v-88355c96]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:991.98px){.table-responsive-lg[data-v-88355c96]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1199.98px){.table-responsive-xl[data-v-88355c96]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1399.98px){.table-responsive-xxl[data-v-88355c96]{overflow-x:auto;-webkit-overflow-scrolling:touch}}.form-label[data-v-88355c96]{margin-bottom:.5rem}.col-form-label[data-v-88355c96]{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg[data-v-88355c96]{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem}.col-form-label-sm[data-v-88355c96]{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem}.form-text[data-v-88355c96]{margin-top:.25rem;font-size:.875em;color:#6c757d}.form-control[data-v-88355c96]{display:block;width:100%;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-88355c96]{transition:none}}.form-control[type=file][data-v-88355c96]{overflow:hidden}.form-control[type=file][data-v-88355c96]:not(:disabled):not([readonly]){cursor:pointer}.form-control[data-v-88355c96]:focus{color:#212529;background-color:#fff;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-control[data-v-88355c96]::-webkit-date-and-time-value{height:1.5em}.form-control[data-v-88355c96]::-moz-placeholder{color:#6c757d;opacity:1}.form-control[data-v-88355c96]::placeholder{color:#6c757d;opacity:1}.form-control[data-v-88355c96]:disabled,.form-control[readonly][data-v-88355c96]{background-color:#e9ecef;opacity:1}.form-control[data-v-88355c96]::file-selector-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-88355c96]::-webkit-file-upload-button{-webkit-transition:none;transition:none}.form-control[data-v-88355c96]::file-selector-button{transition:none}}.form-control[data-v-88355c96]:hover:not(:disabled):not([readonly])::file-selector-button{background-color:#dde0e3}.form-control[data-v-88355c96]::-webkit-file-upload-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;-webkit-transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-88355c96]::-webkit-file-upload-button{-webkit-transition:none;transition:none}}.form-control[data-v-88355c96]:hover:not(:disabled):not([readonly])::-webkit-file-upload-button{background-color:#dde0e3}.form-control-plaintext[data-v-88355c96]{display:block;width:100%;padding:.375rem 0;margin-bottom:0;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg[data-v-88355c96],.form-control-plaintext.form-control-sm[data-v-88355c96]{padding-right:0;padding-left:0}.form-control-sm[data-v-88355c96]{min-height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.form-control-sm[data-v-88355c96]::file-selector-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-sm[data-v-88355c96]::-webkit-file-upload-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-lg[data-v-88355c96]{min-height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.form-control-lg[data-v-88355c96]::file-selector-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}.form-control-lg[data-v-88355c96]::-webkit-file-upload-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}textarea.form-control[data-v-88355c96]{min-height:calc(1.5em + .75rem + 2px)}textarea.form-control-sm[data-v-88355c96]{min-height:calc(1.5em + .5rem + 2px)}textarea.form-control-lg[data-v-88355c96]{min-height:calc(1.5em + 1rem + 2px)}.form-control-color[data-v-88355c96]{width:3rem;height:auto;padding:.375rem}.form-control-color[data-v-88355c96]:not(:disabled):not([readonly]){cursor:pointer}.form-control-color[data-v-88355c96]::-moz-color-swatch{height:1.5em;border-radius:.25rem}.form-control-color[data-v-88355c96]::-webkit-color-swatch{height:1.5em;border-radius:.25rem}.form-select[data-v-88355c96]{display:block;width:100%;padding:.375rem 2.25rem .375rem .75rem;-moz-padding-start:calc(.75rem - 3px);font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right .75rem center;background-size:16px 12px;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-select[data-v-88355c96]{transition:none}}.form-select[data-v-88355c96]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-select[multiple][data-v-88355c96],.form-select[size][data-v-88355c96]:not([size=\"1\"]){padding-right:.75rem;background-image:none}.form-select[data-v-88355c96]:disabled{background-color:#e9ecef}.form-select[data-v-88355c96]:-moz-focusring{color:transparent;text-shadow:0 0 0 #212529}.form-select-sm[data-v-88355c96]{padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem;border-radius:.2rem}.form-select-lg[data-v-88355c96]{padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem;border-radius:.3rem}.form-check[data-v-88355c96]{display:block;min-height:1.5rem;padding-left:1.5em;margin-bottom:.125rem}.form-check .form-check-input[data-v-88355c96]{float:left;margin-left:-1.5em}.form-check-input[data-v-88355c96]{width:1em;height:1em;margin-top:.25em;vertical-align:top;background-color:#fff;background-repeat:no-repeat;background-position:50%;background-size:contain;border:1px solid rgba(0,0,0,.25);-webkit-appearance:none;-moz-appearance:none;appearance:none;-webkit-print-color-adjust:exact;color-adjust:exact}.form-check-input[type=checkbox][data-v-88355c96]{border-radius:.25em}.form-check-input[type=radio][data-v-88355c96]{border-radius:50%}.form-check-input[data-v-88355c96]:active{filter:brightness(90%)}.form-check-input[data-v-88355c96]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-check-input[data-v-88355c96]:checked{background-color:#0d6efd;border-color:#0d6efd}.form-check-input:checked[type=checkbox][data-v-88355c96]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3 6-6'/%3E%3C/svg%3E\")}.form-check-input:checked[type=radio][data-v-88355c96]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='2' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-input[type=checkbox][data-v-88355c96]:indeterminate{background-color:#0d6efd;border-color:#0d6efd;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3E%3C/svg%3E\")}.form-check-input[data-v-88355c96]:disabled{pointer-events:none;filter:none;opacity:.5}.form-check-input:disabled~.form-check-label[data-v-88355c96],.form-check-input[disabled]~.form-check-label[data-v-88355c96]{opacity:.5}.form-switch[data-v-88355c96]{padding-left:2.5em}.form-switch .form-check-input[data-v-88355c96]{width:2em;margin-left:-2.5em;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='rgba(0, 0, 0, 0.25)'/%3E%3C/svg%3E\");background-position:0;border-radius:2em;transition:background-position .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-switch .form-check-input[data-v-88355c96]{transition:none}}.form-switch .form-check-input[data-v-88355c96]:focus{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%2386b7fe'/%3E%3C/svg%3E\")}.form-switch .form-check-input[data-v-88355c96]:checked{background-position:100%;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-inline[data-v-88355c96]{display:inline-block;margin-right:1rem}.btn-check[data-v-88355c96]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.btn-check:disabled+.btn[data-v-88355c96],.btn-check[disabled]+.btn[data-v-88355c96]{pointer-events:none;filter:none;opacity:.65}.form-range[data-v-88355c96]{width:100%;height:1.5rem;padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.form-range[data-v-88355c96]:focus{outline:0}.form-range[data-v-88355c96]:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-88355c96]:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-88355c96]::-moz-focus-outer{border:0}.form-range[data-v-88355c96]::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#0d6efd;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-88355c96]::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.form-range[data-v-88355c96]::-webkit-slider-thumb:active{background-color:#b6d4fe}.form-range[data-v-88355c96]::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-88355c96]::-moz-range-thumb{width:1rem;height:1rem;background-color:#0d6efd;border:0;border-radius:1rem;-moz-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-88355c96]::-moz-range-thumb{-moz-transition:none;transition:none}}.form-range[data-v-88355c96]::-moz-range-thumb:active{background-color:#b6d4fe}.form-range[data-v-88355c96]::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-88355c96]:disabled{pointer-events:none}.form-range[data-v-88355c96]:disabled::-webkit-slider-thumb{background-color:#adb5bd}.form-range[data-v-88355c96]:disabled::-moz-range-thumb{background-color:#adb5bd}.form-floating[data-v-88355c96]{position:relative}.form-floating>.form-control[data-v-88355c96],.form-floating>.form-select[data-v-88355c96]{height:calc(3.5rem + 2px);line-height:1.25}.form-floating>label[data-v-88355c96]{position:absolute;top:0;left:0;height:100%;padding:1rem .75rem;pointer-events:none;border:1px solid transparent;transform-origin:0 0;transition:opacity .1s ease-in-out,transform .1s ease-in-out}@media (prefers-reduced-motion:reduce){.form-floating>label[data-v-88355c96]{transition:none}}.form-floating>.form-control[data-v-88355c96]{padding:1rem .75rem}.form-floating>.form-control[data-v-88355c96]::-moz-placeholder{color:transparent}.form-floating>.form-control[data-v-88355c96]::placeholder{color:transparent}.form-floating>.form-control[data-v-88355c96]:not(:-moz-placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-88355c96]:focus,.form-floating>.form-control[data-v-88355c96]:not(:placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-88355c96]:-webkit-autofill{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-select[data-v-88355c96]{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control:not(:-moz-placeholder-shown)~label[data-v-88355c96]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:focus~label[data-v-88355c96],.form-floating>.form-control:not(:placeholder-shown)~label[data-v-88355c96],.form-floating>.form-select~label[data-v-88355c96]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:-webkit-autofill~label[data-v-88355c96]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.input-group[data-v-88355c96]{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group>.form-control[data-v-88355c96],.input-group>.form-select[data-v-88355c96]{position:relative;flex:1 1 auto;width:1%;min-width:0}.input-group>.form-control[data-v-88355c96]:focus,.input-group>.form-select[data-v-88355c96]:focus{z-index:3}.input-group .btn[data-v-88355c96]{position:relative;z-index:2}.input-group .btn[data-v-88355c96]:focus{z-index:3}.input-group-text[data-v-88355c96]{display:flex;align-items:center;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-lg>.btn[data-v-88355c96],.input-group-lg>.form-control[data-v-88355c96],.input-group-lg>.form-select[data-v-88355c96],.input-group-lg>.input-group-text[data-v-88355c96]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.input-group-sm>.btn[data-v-88355c96],.input-group-sm>.form-control[data-v-88355c96],.input-group-sm>.form-select[data-v-88355c96],.input-group-sm>.input-group-text[data-v-88355c96]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.input-group-lg>.form-select[data-v-88355c96],.input-group-sm>.form-select[data-v-88355c96]{padding-right:3rem}.input-group.has-validation>.dropdown-toggle[data-v-88355c96]:nth-last-child(n+4),.input-group.has-validation[data-v-88355c96]>:nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),.input-group:not(.has-validation)>.dropdown-toggle[data-v-88355c96]:nth-last-child(n+3),.input-group[data-v-88355c96]:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu){border-top-right-radius:0;border-bottom-right-radius:0}.input-group[data-v-88355c96]>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}.valid-feedback[data-v-88355c96]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#198754}.valid-tooltip[data-v-88355c96]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(25,135,84,.9);border-radius:.25rem}.is-valid~.valid-feedback[data-v-88355c96],.is-valid~.valid-tooltip[data-v-88355c96],.was-validated :valid~.valid-feedback[data-v-88355c96],.was-validated :valid~.valid-tooltip[data-v-88355c96]{display:block}.form-control.is-valid[data-v-88355c96],.was-validated .form-control[data-v-88355c96]:valid{border-color:#198754;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-valid[data-v-88355c96]:focus,.was-validated .form-control[data-v-88355c96]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.was-validated textarea.form-control[data-v-88355c96]:valid,textarea.form-control.is-valid[data-v-88355c96]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-valid[data-v-88355c96],.was-validated .form-select[data-v-88355c96]:valid{border-color:#198754}.form-select.is-valid:not([multiple])[size=\"1\"][data-v-88355c96],.form-select.is-valid[data-v-88355c96]:not([multiple]):not([size]),.was-validated .form-select:valid:not([multiple])[size=\"1\"][data-v-88355c96],.was-validated .form-select[data-v-88355c96]:valid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-valid[data-v-88355c96]:focus,.was-validated .form-select[data-v-88355c96]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid[data-v-88355c96],.was-validated .form-check-input[data-v-88355c96]:valid{border-color:#198754}.form-check-input.is-valid[data-v-88355c96]:checked,.was-validated .form-check-input[data-v-88355c96]:valid:checked{background-color:#198754}.form-check-input.is-valid[data-v-88355c96]:focus,.was-validated .form-check-input[data-v-88355c96]:valid:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid~.form-check-label[data-v-88355c96],.was-validated .form-check-input:valid~.form-check-label[data-v-88355c96]{color:#198754}.form-check-inline .form-check-input~.valid-feedback[data-v-88355c96]{margin-left:.5em}.input-group .form-control.is-valid[data-v-88355c96],.input-group .form-select.is-valid[data-v-88355c96],.was-validated .input-group .form-control[data-v-88355c96]:valid,.was-validated .input-group .form-select[data-v-88355c96]:valid{z-index:1}.input-group .form-control.is-valid[data-v-88355c96]:focus,.input-group .form-select.is-valid[data-v-88355c96]:focus,.was-validated .input-group .form-control[data-v-88355c96]:valid:focus,.was-validated .input-group .form-select[data-v-88355c96]:valid:focus{z-index:3}.invalid-feedback[data-v-88355c96]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#dc3545}.invalid-tooltip[data-v-88355c96]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(220,53,69,.9);border-radius:.25rem}.is-invalid~.invalid-feedback[data-v-88355c96],.is-invalid~.invalid-tooltip[data-v-88355c96],.was-validated :invalid~.invalid-feedback[data-v-88355c96],.was-validated :invalid~.invalid-tooltip[data-v-88355c96]{display:block}.form-control.is-invalid[data-v-88355c96],.was-validated .form-control[data-v-88355c96]:invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-invalid[data-v-88355c96]:focus,.was-validated .form-control[data-v-88355c96]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.was-validated textarea.form-control[data-v-88355c96]:invalid,textarea.form-control.is-invalid[data-v-88355c96]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-invalid[data-v-88355c96],.was-validated .form-select[data-v-88355c96]:invalid{border-color:#dc3545}.form-select.is-invalid:not([multiple])[size=\"1\"][data-v-88355c96],.form-select.is-invalid[data-v-88355c96]:not([multiple]):not([size]),.was-validated .form-select:invalid:not([multiple])[size=\"1\"][data-v-88355c96],.was-validated .form-select[data-v-88355c96]:invalid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-invalid[data-v-88355c96]:focus,.was-validated .form-select[data-v-88355c96]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid[data-v-88355c96],.was-validated .form-check-input[data-v-88355c96]:invalid{border-color:#dc3545}.form-check-input.is-invalid[data-v-88355c96]:checked,.was-validated .form-check-input[data-v-88355c96]:invalid:checked{background-color:#dc3545}.form-check-input.is-invalid[data-v-88355c96]:focus,.was-validated .form-check-input[data-v-88355c96]:invalid:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid~.form-check-label[data-v-88355c96],.was-validated .form-check-input:invalid~.form-check-label[data-v-88355c96]{color:#dc3545}.form-check-inline .form-check-input~.invalid-feedback[data-v-88355c96]{margin-left:.5em}.input-group .form-control.is-invalid[data-v-88355c96],.input-group .form-select.is-invalid[data-v-88355c96],.was-validated .input-group .form-control[data-v-88355c96]:invalid,.was-validated .input-group .form-select[data-v-88355c96]:invalid{z-index:2}.input-group .form-control.is-invalid[data-v-88355c96]:focus,.input-group .form-select.is-invalid[data-v-88355c96]:focus,.was-validated .input-group .form-control[data-v-88355c96]:invalid:focus,.was-validated .input-group .form-select[data-v-88355c96]:invalid:focus{z-index:3}.btn[data-v-88355c96]{display:inline-block;font-weight:400;line-height:1.5;color:#212529;text-align:center;text-decoration:none;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn[data-v-88355c96]{transition:none}}.btn[data-v-88355c96]:hover{color:#212529}.btn-check:focus+.btn[data-v-88355c96],.btn[data-v-88355c96]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.btn.disabled[data-v-88355c96],.btn[data-v-88355c96]:disabled,fieldset:disabled .btn[data-v-88355c96]{pointer-events:none;opacity:.65}.btn-primary[data-v-88355c96]{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-primary[data-v-88355c96]:hover{color:#fff;background-color:#0b5ed7;border-color:#0a58ca}.btn-check:focus+.btn-primary[data-v-88355c96],.btn-primary[data-v-88355c96]:focus{color:#fff;background-color:#0b5ed7;border-color:#0a58ca;box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-check:active+.btn-primary[data-v-88355c96],.btn-check:checked+.btn-primary[data-v-88355c96],.btn-primary.active[data-v-88355c96],.btn-primary[data-v-88355c96]:active,.show>.btn-primary.dropdown-toggle[data-v-88355c96]{color:#fff;background-color:#0a58ca;border-color:#0a53be}.btn-check:active+.btn-primary[data-v-88355c96]:focus,.btn-check:checked+.btn-primary[data-v-88355c96]:focus,.btn-primary.active[data-v-88355c96]:focus,.btn-primary[data-v-88355c96]:active:focus,.show>.btn-primary.dropdown-toggle[data-v-88355c96]:focus{box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-primary.disabled[data-v-88355c96],.btn-primary[data-v-88355c96]:disabled{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-secondary[data-v-88355c96]{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary[data-v-88355c96]:hover{color:#fff;background-color:#5c636a;border-color:#565e64}.btn-check:focus+.btn-secondary[data-v-88355c96],.btn-secondary[data-v-88355c96]:focus{color:#fff;background-color:#5c636a;border-color:#565e64;box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-check:active+.btn-secondary[data-v-88355c96],.btn-check:checked+.btn-secondary[data-v-88355c96],.btn-secondary.active[data-v-88355c96],.btn-secondary[data-v-88355c96]:active,.show>.btn-secondary.dropdown-toggle[data-v-88355c96]{color:#fff;background-color:#565e64;border-color:#51585e}.btn-check:active+.btn-secondary[data-v-88355c96]:focus,.btn-check:checked+.btn-secondary[data-v-88355c96]:focus,.btn-secondary.active[data-v-88355c96]:focus,.btn-secondary[data-v-88355c96]:active:focus,.show>.btn-secondary.dropdown-toggle[data-v-88355c96]:focus{box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-secondary.disabled[data-v-88355c96],.btn-secondary[data-v-88355c96]:disabled{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-success[data-v-88355c96]{color:#fff;background-color:#198754;border-color:#198754}.btn-success[data-v-88355c96]:hover{color:#fff;background-color:#157347;border-color:#146c43}.btn-check:focus+.btn-success[data-v-88355c96],.btn-success[data-v-88355c96]:focus{color:#fff;background-color:#157347;border-color:#146c43;box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-check:active+.btn-success[data-v-88355c96],.btn-check:checked+.btn-success[data-v-88355c96],.btn-success.active[data-v-88355c96],.btn-success[data-v-88355c96]:active,.show>.btn-success.dropdown-toggle[data-v-88355c96]{color:#fff;background-color:#146c43;border-color:#13653f}.btn-check:active+.btn-success[data-v-88355c96]:focus,.btn-check:checked+.btn-success[data-v-88355c96]:focus,.btn-success.active[data-v-88355c96]:focus,.btn-success[data-v-88355c96]:active:focus,.show>.btn-success.dropdown-toggle[data-v-88355c96]:focus{box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-success.disabled[data-v-88355c96],.btn-success[data-v-88355c96]:disabled{color:#fff;background-color:#198754;border-color:#198754}.btn-info[data-v-88355c96]{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-info[data-v-88355c96]:hover{color:#000;background-color:#31d2f2;border-color:#25cff2}.btn-check:focus+.btn-info[data-v-88355c96],.btn-info[data-v-88355c96]:focus{color:#000;background-color:#31d2f2;border-color:#25cff2;box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-check:active+.btn-info[data-v-88355c96],.btn-check:checked+.btn-info[data-v-88355c96],.btn-info.active[data-v-88355c96],.btn-info[data-v-88355c96]:active,.show>.btn-info.dropdown-toggle[data-v-88355c96]{color:#000;background-color:#3dd5f3;border-color:#25cff2}.btn-check:active+.btn-info[data-v-88355c96]:focus,.btn-check:checked+.btn-info[data-v-88355c96]:focus,.btn-info.active[data-v-88355c96]:focus,.btn-info[data-v-88355c96]:active:focus,.show>.btn-info.dropdown-toggle[data-v-88355c96]:focus{box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-info.disabled[data-v-88355c96],.btn-info[data-v-88355c96]:disabled{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-warning[data-v-88355c96]{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-warning[data-v-88355c96]:hover{color:#000;background-color:#ffca2c;border-color:#ffc720}.btn-check:focus+.btn-warning[data-v-88355c96],.btn-warning[data-v-88355c96]:focus{color:#000;background-color:#ffca2c;border-color:#ffc720;box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-check:active+.btn-warning[data-v-88355c96],.btn-check:checked+.btn-warning[data-v-88355c96],.btn-warning.active[data-v-88355c96],.btn-warning[data-v-88355c96]:active,.show>.btn-warning.dropdown-toggle[data-v-88355c96]{color:#000;background-color:#ffcd39;border-color:#ffc720}.btn-check:active+.btn-warning[data-v-88355c96]:focus,.btn-check:checked+.btn-warning[data-v-88355c96]:focus,.btn-warning.active[data-v-88355c96]:focus,.btn-warning[data-v-88355c96]:active:focus,.show>.btn-warning.dropdown-toggle[data-v-88355c96]:focus{box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-warning.disabled[data-v-88355c96],.btn-warning[data-v-88355c96]:disabled{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-danger[data-v-88355c96]{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger[data-v-88355c96]:hover{color:#fff;background-color:#bb2d3b;border-color:#b02a37}.btn-check:focus+.btn-danger[data-v-88355c96],.btn-danger[data-v-88355c96]:focus{color:#fff;background-color:#bb2d3b;border-color:#b02a37;box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-check:active+.btn-danger[data-v-88355c96],.btn-check:checked+.btn-danger[data-v-88355c96],.btn-danger.active[data-v-88355c96],.btn-danger[data-v-88355c96]:active,.show>.btn-danger.dropdown-toggle[data-v-88355c96]{color:#fff;background-color:#b02a37;border-color:#a52834}.btn-check:active+.btn-danger[data-v-88355c96]:focus,.btn-check:checked+.btn-danger[data-v-88355c96]:focus,.btn-danger.active[data-v-88355c96]:focus,.btn-danger[data-v-88355c96]:active:focus,.show>.btn-danger.dropdown-toggle[data-v-88355c96]:focus{box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-danger.disabled[data-v-88355c96],.btn-danger[data-v-88355c96]:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-light[data-v-88355c96]{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light[data-v-88355c96]:hover{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:focus+.btn-light[data-v-88355c96],.btn-light[data-v-88355c96]:focus{color:#000;background-color:#f9fafb;border-color:#f9fafb;box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-check:active+.btn-light[data-v-88355c96],.btn-check:checked+.btn-light[data-v-88355c96],.btn-light.active[data-v-88355c96],.btn-light[data-v-88355c96]:active,.show>.btn-light.dropdown-toggle[data-v-88355c96]{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:active+.btn-light[data-v-88355c96]:focus,.btn-check:checked+.btn-light[data-v-88355c96]:focus,.btn-light.active[data-v-88355c96]:focus,.btn-light[data-v-88355c96]:active:focus,.show>.btn-light.dropdown-toggle[data-v-88355c96]:focus{box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-light.disabled[data-v-88355c96],.btn-light[data-v-88355c96]:disabled{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-dark[data-v-88355c96]{color:#fff;background-color:#212529;border-color:#212529}.btn-dark[data-v-88355c96]:hover{color:#fff;background-color:#1c1f23;border-color:#1a1e21}.btn-check:focus+.btn-dark[data-v-88355c96],.btn-dark[data-v-88355c96]:focus{color:#fff;background-color:#1c1f23;border-color:#1a1e21;box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-check:active+.btn-dark[data-v-88355c96],.btn-check:checked+.btn-dark[data-v-88355c96],.btn-dark.active[data-v-88355c96],.btn-dark[data-v-88355c96]:active,.show>.btn-dark.dropdown-toggle[data-v-88355c96]{color:#fff;background-color:#1a1e21;border-color:#191c1f}.btn-check:active+.btn-dark[data-v-88355c96]:focus,.btn-check:checked+.btn-dark[data-v-88355c96]:focus,.btn-dark.active[data-v-88355c96]:focus,.btn-dark[data-v-88355c96]:active:focus,.show>.btn-dark.dropdown-toggle[data-v-88355c96]:focus{box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-dark.disabled[data-v-88355c96],.btn-dark[data-v-88355c96]:disabled{color:#fff;background-color:#212529;border-color:#212529}.btn-outline-primary[data-v-88355c96]{color:#0d6efd;border-color:#0d6efd}.btn-outline-primary[data-v-88355c96]:hover{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:focus+.btn-outline-primary[data-v-88355c96],.btn-outline-primary[data-v-88355c96]:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-check:active+.btn-outline-primary[data-v-88355c96],.btn-check:checked+.btn-outline-primary[data-v-88355c96],.btn-outline-primary.active[data-v-88355c96],.btn-outline-primary.dropdown-toggle.show[data-v-88355c96],.btn-outline-primary[data-v-88355c96]:active{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:active+.btn-outline-primary[data-v-88355c96]:focus,.btn-check:checked+.btn-outline-primary[data-v-88355c96]:focus,.btn-outline-primary.active[data-v-88355c96]:focus,.btn-outline-primary.dropdown-toggle.show[data-v-88355c96]:focus,.btn-outline-primary[data-v-88355c96]:active:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-outline-primary.disabled[data-v-88355c96],.btn-outline-primary[data-v-88355c96]:disabled{color:#0d6efd;background-color:transparent}.btn-outline-secondary[data-v-88355c96]{color:#6c757d;border-color:#6c757d}.btn-outline-secondary[data-v-88355c96]:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:focus+.btn-outline-secondary[data-v-88355c96],.btn-outline-secondary[data-v-88355c96]:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-check:active+.btn-outline-secondary[data-v-88355c96],.btn-check:checked+.btn-outline-secondary[data-v-88355c96],.btn-outline-secondary.active[data-v-88355c96],.btn-outline-secondary.dropdown-toggle.show[data-v-88355c96],.btn-outline-secondary[data-v-88355c96]:active{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:active+.btn-outline-secondary[data-v-88355c96]:focus,.btn-check:checked+.btn-outline-secondary[data-v-88355c96]:focus,.btn-outline-secondary.active[data-v-88355c96]:focus,.btn-outline-secondary.dropdown-toggle.show[data-v-88355c96]:focus,.btn-outline-secondary[data-v-88355c96]:active:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-outline-secondary.disabled[data-v-88355c96],.btn-outline-secondary[data-v-88355c96]:disabled{color:#6c757d;background-color:transparent}.btn-outline-success[data-v-88355c96]{color:#198754;border-color:#198754}.btn-outline-success[data-v-88355c96]:hover{color:#fff;background-color:#198754;border-color:#198754}.btn-check:focus+.btn-outline-success[data-v-88355c96],.btn-outline-success[data-v-88355c96]:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-check:active+.btn-outline-success[data-v-88355c96],.btn-check:checked+.btn-outline-success[data-v-88355c96],.btn-outline-success.active[data-v-88355c96],.btn-outline-success.dropdown-toggle.show[data-v-88355c96],.btn-outline-success[data-v-88355c96]:active{color:#fff;background-color:#198754;border-color:#198754}.btn-check:active+.btn-outline-success[data-v-88355c96]:focus,.btn-check:checked+.btn-outline-success[data-v-88355c96]:focus,.btn-outline-success.active[data-v-88355c96]:focus,.btn-outline-success.dropdown-toggle.show[data-v-88355c96]:focus,.btn-outline-success[data-v-88355c96]:active:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-outline-success.disabled[data-v-88355c96],.btn-outline-success[data-v-88355c96]:disabled{color:#198754;background-color:transparent}.btn-outline-info[data-v-88355c96]{color:#0dcaf0;border-color:#0dcaf0}.btn-outline-info[data-v-88355c96]:hover{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:focus+.btn-outline-info[data-v-88355c96],.btn-outline-info[data-v-88355c96]:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-check:active+.btn-outline-info[data-v-88355c96],.btn-check:checked+.btn-outline-info[data-v-88355c96],.btn-outline-info.active[data-v-88355c96],.btn-outline-info.dropdown-toggle.show[data-v-88355c96],.btn-outline-info[data-v-88355c96]:active{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:active+.btn-outline-info[data-v-88355c96]:focus,.btn-check:checked+.btn-outline-info[data-v-88355c96]:focus,.btn-outline-info.active[data-v-88355c96]:focus,.btn-outline-info.dropdown-toggle.show[data-v-88355c96]:focus,.btn-outline-info[data-v-88355c96]:active:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-outline-info.disabled[data-v-88355c96],.btn-outline-info[data-v-88355c96]:disabled{color:#0dcaf0;background-color:transparent}.btn-outline-warning[data-v-88355c96]{color:#ffc107;border-color:#ffc107}.btn-outline-warning[data-v-88355c96]:hover{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:focus+.btn-outline-warning[data-v-88355c96],.btn-outline-warning[data-v-88355c96]:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-check:active+.btn-outline-warning[data-v-88355c96],.btn-check:checked+.btn-outline-warning[data-v-88355c96],.btn-outline-warning.active[data-v-88355c96],.btn-outline-warning.dropdown-toggle.show[data-v-88355c96],.btn-outline-warning[data-v-88355c96]:active{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:active+.btn-outline-warning[data-v-88355c96]:focus,.btn-check:checked+.btn-outline-warning[data-v-88355c96]:focus,.btn-outline-warning.active[data-v-88355c96]:focus,.btn-outline-warning.dropdown-toggle.show[data-v-88355c96]:focus,.btn-outline-warning[data-v-88355c96]:active:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-outline-warning.disabled[data-v-88355c96],.btn-outline-warning[data-v-88355c96]:disabled{color:#ffc107;background-color:transparent}.btn-outline-danger[data-v-88355c96]{color:#dc3545;border-color:#dc3545}.btn-outline-danger[data-v-88355c96]:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:focus+.btn-outline-danger[data-v-88355c96],.btn-outline-danger[data-v-88355c96]:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-check:active+.btn-outline-danger[data-v-88355c96],.btn-check:checked+.btn-outline-danger[data-v-88355c96],.btn-outline-danger.active[data-v-88355c96],.btn-outline-danger.dropdown-toggle.show[data-v-88355c96],.btn-outline-danger[data-v-88355c96]:active{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:active+.btn-outline-danger[data-v-88355c96]:focus,.btn-check:checked+.btn-outline-danger[data-v-88355c96]:focus,.btn-outline-danger.active[data-v-88355c96]:focus,.btn-outline-danger.dropdown-toggle.show[data-v-88355c96]:focus,.btn-outline-danger[data-v-88355c96]:active:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-outline-danger.disabled[data-v-88355c96],.btn-outline-danger[data-v-88355c96]:disabled{color:#dc3545;background-color:transparent}.btn-outline-light[data-v-88355c96]{color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light[data-v-88355c96]:hover{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:focus+.btn-outline-light[data-v-88355c96],.btn-outline-light[data-v-88355c96]:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-check:active+.btn-outline-light[data-v-88355c96],.btn-check:checked+.btn-outline-light[data-v-88355c96],.btn-outline-light.active[data-v-88355c96],.btn-outline-light.dropdown-toggle.show[data-v-88355c96],.btn-outline-light[data-v-88355c96]:active{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:active+.btn-outline-light[data-v-88355c96]:focus,.btn-check:checked+.btn-outline-light[data-v-88355c96]:focus,.btn-outline-light.active[data-v-88355c96]:focus,.btn-outline-light.dropdown-toggle.show[data-v-88355c96]:focus,.btn-outline-light[data-v-88355c96]:active:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-outline-light.disabled[data-v-88355c96],.btn-outline-light[data-v-88355c96]:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-dark[data-v-88355c96]{color:#212529;border-color:#212529}.btn-outline-dark[data-v-88355c96]:hover{color:#fff;background-color:#212529;border-color:#212529}.btn-check:focus+.btn-outline-dark[data-v-88355c96],.btn-outline-dark[data-v-88355c96]:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-check:active+.btn-outline-dark[data-v-88355c96],.btn-check:checked+.btn-outline-dark[data-v-88355c96],.btn-outline-dark.active[data-v-88355c96],.btn-outline-dark.dropdown-toggle.show[data-v-88355c96],.btn-outline-dark[data-v-88355c96]:active{color:#fff;background-color:#212529;border-color:#212529}.btn-check:active+.btn-outline-dark[data-v-88355c96]:focus,.btn-check:checked+.btn-outline-dark[data-v-88355c96]:focus,.btn-outline-dark.active[data-v-88355c96]:focus,.btn-outline-dark.dropdown-toggle.show[data-v-88355c96]:focus,.btn-outline-dark[data-v-88355c96]:active:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-outline-dark.disabled[data-v-88355c96],.btn-outline-dark[data-v-88355c96]:disabled{color:#212529;background-color:transparent}.btn-link[data-v-88355c96]{font-weight:400;color:#0d6efd;text-decoration:underline}.btn-link[data-v-88355c96]:hover{color:#0a58ca}.btn-link.disabled[data-v-88355c96],.btn-link[data-v-88355c96]:disabled{color:#6c757d}.btn-group-lg>.btn[data-v-88355c96],.btn-lg[data-v-88355c96]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.btn-group-sm>.btn[data-v-88355c96],.btn-sm[data-v-88355c96]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.fade[data-v-88355c96]{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade[data-v-88355c96]{transition:none}}.fade[data-v-88355c96]:not(.show){opacity:0}.collapse[data-v-88355c96]:not(.show){display:none}.collapsing[data-v-88355c96]{height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.collapsing[data-v-88355c96]{transition:none}}.collapsing.collapse-horizontal[data-v-88355c96]{width:0;height:auto;transition:width .35s ease}@media (prefers-reduced-motion:reduce){.collapsing.collapse-horizontal[data-v-88355c96]{transition:none}}.dropdown[data-v-88355c96],.dropend[data-v-88355c96],.dropstart[data-v-88355c96],.dropup[data-v-88355c96]{position:relative}.dropdown-toggle[data-v-88355c96]{white-space:nowrap}.dropdown-toggle[data-v-88355c96]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle[data-v-88355c96]:empty:after{margin-left:0}.dropdown-menu[data-v-88355c96]{position:absolute;z-index:1000;display:none;min-width:10rem;padding:.5rem 0;margin:0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-menu[data-bs-popper][data-v-88355c96]{top:100%;left:0;margin-top:.125rem}.dropdown-menu-start[data-v-88355c96]{--bs-position:start}.dropdown-menu-start[data-bs-popper][data-v-88355c96]{right:auto;left:0}.dropdown-menu-end[data-v-88355c96]{--bs-position:end}.dropdown-menu-end[data-bs-popper][data-v-88355c96]{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-start[data-v-88355c96]{--bs-position:start}.dropdown-menu-sm-start[data-bs-popper][data-v-88355c96]{right:auto;left:0}.dropdown-menu-sm-end[data-v-88355c96]{--bs-position:end}.dropdown-menu-sm-end[data-bs-popper][data-v-88355c96]{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-start[data-v-88355c96]{--bs-position:start}.dropdown-menu-md-start[data-bs-popper][data-v-88355c96]{right:auto;left:0}.dropdown-menu-md-end[data-v-88355c96]{--bs-position:end}.dropdown-menu-md-end[data-bs-popper][data-v-88355c96]{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-start[data-v-88355c96]{--bs-position:start}.dropdown-menu-lg-start[data-bs-popper][data-v-88355c96]{right:auto;left:0}.dropdown-menu-lg-end[data-v-88355c96]{--bs-position:end}.dropdown-menu-lg-end[data-bs-popper][data-v-88355c96]{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-start[data-v-88355c96]{--bs-position:start}.dropdown-menu-xl-start[data-bs-popper][data-v-88355c96]{right:auto;left:0}.dropdown-menu-xl-end[data-v-88355c96]{--bs-position:end}.dropdown-menu-xl-end[data-bs-popper][data-v-88355c96]{right:0;left:auto}}@media (min-width:1400px){.dropdown-menu-xxl-start[data-v-88355c96]{--bs-position:start}.dropdown-menu-xxl-start[data-bs-popper][data-v-88355c96]{right:auto;left:0}.dropdown-menu-xxl-end[data-v-88355c96]{--bs-position:end}.dropdown-menu-xxl-end[data-bs-popper][data-v-88355c96]{right:0;left:auto}}.dropup .dropdown-menu[data-bs-popper][data-v-88355c96]{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle[data-v-88355c96]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle[data-v-88355c96]:empty:after{margin-left:0}.dropend .dropdown-menu[data-bs-popper][data-v-88355c96]{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.dropend .dropdown-toggle[data-v-88355c96]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropend .dropdown-toggle[data-v-88355c96]:empty:after{margin-left:0}.dropend .dropdown-toggle[data-v-88355c96]:after{vertical-align:0}.dropstart .dropdown-menu[data-bs-popper][data-v-88355c96]{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.dropstart .dropdown-toggle[data-v-88355c96]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";display:none}.dropstart .dropdown-toggle[data-v-88355c96]:before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropstart .dropdown-toggle[data-v-88355c96]:empty:after{margin-left:0}.dropstart .dropdown-toggle[data-v-88355c96]:before{vertical-align:0}.dropdown-divider[data-v-88355c96]{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid rgba(0,0,0,.15)}.dropdown-item[data-v-88355c96]{display:block;width:100%;padding:.25rem 1rem;clear:both;font-weight:400;color:#212529;text-align:inherit;text-decoration:none;white-space:nowrap;background-color:transparent;border:0}.dropdown-item[data-v-88355c96]:focus,.dropdown-item[data-v-88355c96]:hover{color:#1e2125;background-color:#e9ecef}.dropdown-item.active[data-v-88355c96],.dropdown-item[data-v-88355c96]:active{color:#fff;text-decoration:none;background-color:#0d6efd}.dropdown-item.disabled[data-v-88355c96],.dropdown-item[data-v-88355c96]:disabled{color:#adb5bd;pointer-events:none;background-color:transparent}.dropdown-menu.show[data-v-88355c96]{display:block}.dropdown-header[data-v-88355c96]{display:block;padding:.5rem 1rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.dropdown-item-text[data-v-88355c96]{display:block;padding:.25rem 1rem;color:#212529}.dropdown-menu-dark[data-v-88355c96]{color:#dee2e6;background-color:#343a40;border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item[data-v-88355c96]{color:#dee2e6}.dropdown-menu-dark .dropdown-item[data-v-88355c96]:focus,.dropdown-menu-dark .dropdown-item[data-v-88355c96]:hover{color:#fff;background-color:hsla(0,0%,100%,.15)}.dropdown-menu-dark .dropdown-item.active[data-v-88355c96],.dropdown-menu-dark .dropdown-item[data-v-88355c96]:active{color:#fff;background-color:#0d6efd}.dropdown-menu-dark .dropdown-item.disabled[data-v-88355c96],.dropdown-menu-dark .dropdown-item[data-v-88355c96]:disabled{color:#adb5bd}.dropdown-menu-dark .dropdown-divider[data-v-88355c96]{border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item-text[data-v-88355c96]{color:#dee2e6}.dropdown-menu-dark .dropdown-header[data-v-88355c96]{color:#adb5bd}.btn-group-vertical[data-v-88355c96],.btn-group[data-v-88355c96]{position:relative;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn[data-v-88355c96],.btn-group>.btn[data-v-88355c96]{position:relative;flex:1 1 auto}.btn-group-vertical>.btn-check:checked+.btn[data-v-88355c96],.btn-group-vertical>.btn-check:focus+.btn[data-v-88355c96],.btn-group-vertical>.btn.active[data-v-88355c96],.btn-group-vertical>.btn[data-v-88355c96]:active,.btn-group-vertical>.btn[data-v-88355c96]:focus,.btn-group-vertical>.btn[data-v-88355c96]:hover,.btn-group>.btn-check:checked+.btn[data-v-88355c96],.btn-group>.btn-check:focus+.btn[data-v-88355c96],.btn-group>.btn.active[data-v-88355c96],.btn-group>.btn[data-v-88355c96]:active,.btn-group>.btn[data-v-88355c96]:focus,.btn-group>.btn[data-v-88355c96]:hover{z-index:1}.btn-toolbar[data-v-88355c96]{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar .input-group[data-v-88355c96]{width:auto}.btn-group>.btn-group[data-v-88355c96]:not(:first-child),.btn-group>.btn[data-v-88355c96]:not(:first-child){margin-left:-1px}.btn-group>.btn-group:not(:last-child)>.btn[data-v-88355c96],.btn-group>.btn[data-v-88355c96]:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn[data-v-88355c96],.btn-group>.btn[data-v-88355c96]:nth-child(n+3),.btn-group>:not(.btn-check)+.btn[data-v-88355c96]{border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split[data-v-88355c96]{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split[data-v-88355c96]:after,.dropend .dropdown-toggle-split[data-v-88355c96]:after,.dropup .dropdown-toggle-split[data-v-88355c96]:after{margin-left:0}.dropstart .dropdown-toggle-split[data-v-88355c96]:before{margin-right:0}.btn-group-sm>.btn+.dropdown-toggle-split[data-v-88355c96],.btn-sm+.dropdown-toggle-split[data-v-88355c96]{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split[data-v-88355c96],.btn-lg+.dropdown-toggle-split[data-v-88355c96]{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical[data-v-88355c96]{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical>.btn-group[data-v-88355c96],.btn-group-vertical>.btn[data-v-88355c96]{width:100%}.btn-group-vertical>.btn-group[data-v-88355c96]:not(:first-child),.btn-group-vertical>.btn[data-v-88355c96]:not(:first-child){margin-top:-1px}.btn-group-vertical>.btn-group:not(:last-child)>.btn[data-v-88355c96],.btn-group-vertical>.btn[data-v-88355c96]:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn[data-v-88355c96],.btn-group-vertical>.btn~.btn[data-v-88355c96]{border-top-left-radius:0;border-top-right-radius:0}.nav[data-v-88355c96]{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link[data-v-88355c96]{display:block;padding:.5rem 1rem;color:#0d6efd;text-decoration:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out}@media (prefers-reduced-motion:reduce){.nav-link[data-v-88355c96]{transition:none}}.nav-link[data-v-88355c96]:focus,.nav-link[data-v-88355c96]:hover{color:#0a58ca}.nav-link.disabled[data-v-88355c96]{color:#6c757d;pointer-events:none;cursor:default}.nav-tabs[data-v-88355c96]{border-bottom:1px solid #dee2e6}.nav-tabs .nav-link[data-v-88355c96]{margin-bottom:-1px;background:0 0;border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link[data-v-88355c96]:focus,.nav-tabs .nav-link[data-v-88355c96]:hover{border-color:#e9ecef #e9ecef #dee2e6;isolation:isolate}.nav-tabs .nav-link.disabled[data-v-88355c96]{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link[data-v-88355c96],.nav-tabs .nav-link.active[data-v-88355c96]{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu[data-v-88355c96]{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link[data-v-88355c96]{background:0 0;border:0;border-radius:.25rem}.nav-pills .nav-link.active[data-v-88355c96],.nav-pills .show>.nav-link[data-v-88355c96]{color:#fff;background-color:#0d6efd}.nav-fill .nav-item[data-v-88355c96],.nav-fill>.nav-link[data-v-88355c96]{flex:1 1 auto;text-align:center}.nav-justified .nav-item[data-v-88355c96],.nav-justified>.nav-link[data-v-88355c96]{flex-basis:0;flex-grow:1;text-align:center}.nav-fill .nav-item .nav-link[data-v-88355c96],.nav-justified .nav-item .nav-link[data-v-88355c96]{width:100%}.tab-content>.tab-pane[data-v-88355c96]{display:none}.tab-content>.active[data-v-88355c96]{display:block}.navbar[data-v-88355c96]{position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding-top:.5rem;padding-bottom:.5rem}.navbar>.container-fluid[data-v-88355c96],.navbar>.container-lg[data-v-88355c96],.navbar>.container-md[data-v-88355c96],.navbar>.container-sm[data-v-88355c96],.navbar>.container-xl[data-v-88355c96],.navbar>.container-xxl[data-v-88355c96],.navbar>.container[data-v-88355c96]{display:flex;flex-wrap:inherit;align-items:center;justify-content:space-between}.navbar-brand[data-v-88355c96]{padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;text-decoration:none;white-space:nowrap}.navbar-nav[data-v-88355c96]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link[data-v-88355c96]{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu[data-v-88355c96]{position:static}.navbar-text[data-v-88355c96]{padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse[data-v-88355c96]{flex-basis:100%;flex-grow:1;align-items:center}.navbar-toggler[data-v-88355c96]{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem;transition:box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.navbar-toggler[data-v-88355c96]{transition:none}}.navbar-toggler[data-v-88355c96]:hover{text-decoration:none}.navbar-toggler[data-v-88355c96]:focus{text-decoration:none;outline:0;box-shadow:0 0 0 .25rem}.navbar-toggler-icon[data-v-88355c96]{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;background-repeat:no-repeat;background-position:50%;background-size:100%}.navbar-nav-scroll[data-v-88355c96]{max-height:var(--bs-scroll-height,75vh);overflow-y:auto}@media (min-width:576px){.navbar-expand-sm[data-v-88355c96]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-sm .navbar-nav[data-v-88355c96]{flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu[data-v-88355c96]{position:absolute}.navbar-expand-sm .navbar-nav .nav-link[data-v-88355c96]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm .navbar-nav-scroll[data-v-88355c96]{overflow:visible}.navbar-expand-sm .navbar-collapse[data-v-88355c96]{display:flex!important;flex-basis:auto}.navbar-expand-sm .navbar-toggler[data-v-88355c96],.navbar-expand-sm .offcanvas-header[data-v-88355c96]{display:none}.navbar-expand-sm .offcanvas[data-v-88355c96]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-sm .offcanvas-bottom[data-v-88355c96],.navbar-expand-sm .offcanvas-top[data-v-88355c96]{height:auto;border-top:0;border-bottom:0}.navbar-expand-sm .offcanvas-body[data-v-88355c96]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:768px){.navbar-expand-md[data-v-88355c96]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-md .navbar-nav[data-v-88355c96]{flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu[data-v-88355c96]{position:absolute}.navbar-expand-md .navbar-nav .nav-link[data-v-88355c96]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md .navbar-nav-scroll[data-v-88355c96]{overflow:visible}.navbar-expand-md .navbar-collapse[data-v-88355c96]{display:flex!important;flex-basis:auto}.navbar-expand-md .navbar-toggler[data-v-88355c96],.navbar-expand-md .offcanvas-header[data-v-88355c96]{display:none}.navbar-expand-md .offcanvas[data-v-88355c96]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-md .offcanvas-bottom[data-v-88355c96],.navbar-expand-md .offcanvas-top[data-v-88355c96]{height:auto;border-top:0;border-bottom:0}.navbar-expand-md .offcanvas-body[data-v-88355c96]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:992px){.navbar-expand-lg[data-v-88355c96]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-lg .navbar-nav[data-v-88355c96]{flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu[data-v-88355c96]{position:absolute}.navbar-expand-lg .navbar-nav .nav-link[data-v-88355c96]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg .navbar-nav-scroll[data-v-88355c96]{overflow:visible}.navbar-expand-lg .navbar-collapse[data-v-88355c96]{display:flex!important;flex-basis:auto}.navbar-expand-lg .navbar-toggler[data-v-88355c96],.navbar-expand-lg .offcanvas-header[data-v-88355c96]{display:none}.navbar-expand-lg .offcanvas[data-v-88355c96]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-lg .offcanvas-bottom[data-v-88355c96],.navbar-expand-lg .offcanvas-top[data-v-88355c96]{height:auto;border-top:0;border-bottom:0}.navbar-expand-lg .offcanvas-body[data-v-88355c96]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1200px){.navbar-expand-xl[data-v-88355c96]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xl .navbar-nav[data-v-88355c96]{flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu[data-v-88355c96]{position:absolute}.navbar-expand-xl .navbar-nav .nav-link[data-v-88355c96]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl .navbar-nav-scroll[data-v-88355c96]{overflow:visible}.navbar-expand-xl .navbar-collapse[data-v-88355c96]{display:flex!important;flex-basis:auto}.navbar-expand-xl .navbar-toggler[data-v-88355c96],.navbar-expand-xl .offcanvas-header[data-v-88355c96]{display:none}.navbar-expand-xl .offcanvas[data-v-88355c96]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xl .offcanvas-bottom[data-v-88355c96],.navbar-expand-xl .offcanvas-top[data-v-88355c96]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xl .offcanvas-body[data-v-88355c96]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1400px){.navbar-expand-xxl[data-v-88355c96]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xxl .navbar-nav[data-v-88355c96]{flex-direction:row}.navbar-expand-xxl .navbar-nav .dropdown-menu[data-v-88355c96]{position:absolute}.navbar-expand-xxl .navbar-nav .nav-link[data-v-88355c96]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xxl .navbar-nav-scroll[data-v-88355c96]{overflow:visible}.navbar-expand-xxl .navbar-collapse[data-v-88355c96]{display:flex!important;flex-basis:auto}.navbar-expand-xxl .navbar-toggler[data-v-88355c96],.navbar-expand-xxl .offcanvas-header[data-v-88355c96]{display:none}.navbar-expand-xxl .offcanvas[data-v-88355c96]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xxl .offcanvas-bottom[data-v-88355c96],.navbar-expand-xxl .offcanvas-top[data-v-88355c96]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xxl .offcanvas-body[data-v-88355c96]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}.navbar-expand[data-v-88355c96]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand .navbar-nav[data-v-88355c96]{flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu[data-v-88355c96]{position:absolute}.navbar-expand .navbar-nav .nav-link[data-v-88355c96]{padding-right:.5rem;padding-left:.5rem}.navbar-expand .navbar-nav-scroll[data-v-88355c96]{overflow:visible}.navbar-expand .navbar-collapse[data-v-88355c96]{display:flex!important;flex-basis:auto}.navbar-expand .navbar-toggler[data-v-88355c96],.navbar-expand .offcanvas-header[data-v-88355c96]{display:none}.navbar-expand .offcanvas[data-v-88355c96]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand .offcanvas-bottom[data-v-88355c96],.navbar-expand .offcanvas-top[data-v-88355c96]{height:auto;border-top:0;border-bottom:0}.navbar-expand .offcanvas-body[data-v-88355c96]{display:flex;flex-grow:0;padding:0;overflow-y:visible}.navbar-light .navbar-brand[data-v-88355c96],.navbar-light .navbar-brand[data-v-88355c96]:focus,.navbar-light .navbar-brand[data-v-88355c96]:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link[data-v-88355c96]{color:rgba(0,0,0,.55)}.navbar-light .navbar-nav .nav-link[data-v-88355c96]:focus,.navbar-light .navbar-nav .nav-link[data-v-88355c96]:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled[data-v-88355c96]{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .nav-link.active[data-v-88355c96],.navbar-light .navbar-nav .show>.nav-link[data-v-88355c96]{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler[data-v-88355c96]{color:rgba(0,0,0,.55);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon[data-v-88355c96]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(0, 0, 0, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-light .navbar-text[data-v-88355c96]{color:rgba(0,0,0,.55)}.navbar-light .navbar-text a[data-v-88355c96],.navbar-light .navbar-text a[data-v-88355c96]:focus,.navbar-light .navbar-text a[data-v-88355c96]:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand[data-v-88355c96],.navbar-dark .navbar-brand[data-v-88355c96]:focus,.navbar-dark .navbar-brand[data-v-88355c96]:hover{color:#fff}.navbar-dark .navbar-nav .nav-link[data-v-88355c96]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-nav .nav-link[data-v-88355c96]:focus,.navbar-dark .navbar-nav .nav-link[data-v-88355c96]:hover{color:hsla(0,0%,100%,.75)}.navbar-dark .navbar-nav .nav-link.disabled[data-v-88355c96]{color:hsla(0,0%,100%,.25)}.navbar-dark .navbar-nav .nav-link.active[data-v-88355c96],.navbar-dark .navbar-nav .show>.nav-link[data-v-88355c96]{color:#fff}.navbar-dark .navbar-toggler[data-v-88355c96]{color:hsla(0,0%,100%,.55);border-color:hsla(0,0%,100%,.1)}.navbar-dark .navbar-toggler-icon[data-v-88355c96]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(255, 255, 255, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-dark .navbar-text[data-v-88355c96]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-text a[data-v-88355c96],.navbar-dark .navbar-text a[data-v-88355c96]:focus,.navbar-dark .navbar-text a[data-v-88355c96]:hover{color:#fff}.card[data-v-88355c96]{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr[data-v-88355c96]{margin-right:0;margin-left:0}.card>.list-group[data-v-88355c96]{border-top:inherit;border-bottom:inherit}.card>.list-group[data-v-88355c96]:first-child{border-top-width:0;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card>.list-group[data-v-88355c96]:last-child{border-bottom-width:0;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card>.card-header+.list-group[data-v-88355c96],.card>.list-group+.card-footer[data-v-88355c96]{border-top:0}.card-body[data-v-88355c96]{flex:1 1 auto;padding:1rem}.card-title[data-v-88355c96]{margin-bottom:.5rem}.card-subtitle[data-v-88355c96]{margin-top:-.25rem;margin-bottom:0}.card-text[data-v-88355c96]:last-child{margin-bottom:0}.card-link+.card-link[data-v-88355c96]{margin-left:1rem}.card-header[data-v-88355c96]{padding:.5rem 1rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header[data-v-88355c96]:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-footer[data-v-88355c96]{padding:.5rem 1rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer[data-v-88355c96]:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs[data-v-88355c96]{margin-bottom:-.5rem;border-bottom:0}.card-header-pills[data-v-88355c96],.card-header-tabs[data-v-88355c96]{margin-right:-.5rem;margin-left:-.5rem}.card-img-overlay[data-v-88355c96]{position:absolute;top:0;right:0;bottom:0;left:0;padding:1rem;border-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-88355c96],.card-img-top[data-v-88355c96],.card-img[data-v-88355c96]{width:100%}.card-img-top[data-v-88355c96],.card-img[data-v-88355c96]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-88355c96],.card-img[data-v-88355c96]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-group>.card[data-v-88355c96]{margin-bottom:.75rem}@media (min-width:576px){.card-group[data-v-88355c96]{display:flex;flex-flow:row wrap}.card-group>.card[data-v-88355c96]{flex:1 0 0%;margin-bottom:0}.card-group>.card+.card[data-v-88355c96]{margin-left:0;border-left:0}.card-group>.card[data-v-88355c96]:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-header[data-v-88355c96],.card-group>.card:not(:last-child) .card-img-top[data-v-88355c96]{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-footer[data-v-88355c96],.card-group>.card:not(:last-child) .card-img-bottom[data-v-88355c96]{border-bottom-right-radius:0}.card-group>.card[data-v-88355c96]:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-header[data-v-88355c96],.card-group>.card:not(:first-child) .card-img-top[data-v-88355c96]{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-footer[data-v-88355c96],.card-group>.card:not(:first-child) .card-img-bottom[data-v-88355c96]{border-bottom-left-radius:0}}.accordion-button[data-v-88355c96]{position:relative;display:flex;align-items:center;width:100%;padding:1rem 1.25rem;font-size:1rem;color:#212529;text-align:left;background-color:#fff;border:0;border-radius:0;overflow-anchor:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,border-radius .15s ease}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-88355c96]{transition:none}}.accordion-button[data-v-88355c96]:not(.collapsed){color:#0c63e4;background-color:#e7f1ff;box-shadow:inset 0 -1px 0 rgba(0,0,0,.125)}.accordion-button[data-v-88355c96]:not(.collapsed):after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230c63e4'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");transform:rotate(-180deg)}.accordion-button[data-v-88355c96]:after{flex-shrink:0;width:1.25rem;height:1.25rem;margin-left:auto;content:\"\";background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-size:1.25rem;transition:transform .2s ease-in-out}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-88355c96]:after{transition:none}}.accordion-button[data-v-88355c96]:hover{z-index:2}.accordion-button[data-v-88355c96]:focus{z-index:3;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.accordion-header[data-v-88355c96]{margin-bottom:0}.accordion-item[data-v-88355c96]{background-color:#fff;border:1px solid rgba(0,0,0,.125)}.accordion-item[data-v-88355c96]:first-of-type{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.accordion-item:first-of-type .accordion-button[data-v-88355c96]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.accordion-item[data-v-88355c96]:not(:first-of-type){border-top:0}.accordion-item[data-v-88355c96]:last-of-type{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-item:last-of-type .accordion-button.collapsed[data-v-88355c96]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.accordion-item:last-of-type .accordion-collapse[data-v-88355c96]{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-body[data-v-88355c96]{padding:1rem 1.25rem}.accordion-flush .accordion-collapse[data-v-88355c96]{border-width:0}.accordion-flush .accordion-item[data-v-88355c96]{border-right:0;border-left:0;border-radius:0}.accordion-flush .accordion-item[data-v-88355c96]:first-child{border-top:0}.accordion-flush .accordion-item[data-v-88355c96]:last-child{border-bottom:0}.accordion-flush .accordion-item .accordion-button[data-v-88355c96]{border-radius:0}.breadcrumb[data-v-88355c96]{display:flex;flex-wrap:wrap;padding:0;margin-bottom:1rem;list-style:none}.breadcrumb-item+.breadcrumb-item[data-v-88355c96]{padding-left:.5rem}.breadcrumb-item+.breadcrumb-item[data-v-88355c96]:before{float:left;padding-right:.5rem;color:#6c757d;content:var(--bs-breadcrumb-divider,\"/\")}.breadcrumb-item.active[data-v-88355c96]{color:#6c757d}.pagination[data-v-88355c96]{display:flex;padding-left:0;list-style:none}.page-link[data-v-88355c96]{position:relative;display:block;color:#0d6efd;text-decoration:none;background-color:#fff;border:1px solid #dee2e6;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.page-link[data-v-88355c96]{transition:none}}.page-link[data-v-88355c96]:hover{z-index:2;color:#0a58ca;background-color:#e9ecef;border-color:#dee2e6}.page-link[data-v-88355c96]:focus{z-index:3;color:#0a58ca;background-color:#e9ecef;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.page-item:not(:first-child) .page-link[data-v-88355c96]{margin-left:-1px}.page-item.active .page-link[data-v-88355c96]{z-index:3;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.page-item.disabled .page-link[data-v-88355c96]{color:#6c757d;pointer-events:none;background-color:#fff;border-color:#dee2e6}.page-link[data-v-88355c96]{padding:.375rem .75rem}.page-item:first-child .page-link[data-v-88355c96]{border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item:last-child .page-link[data-v-88355c96]{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.pagination-lg .page-link[data-v-88355c96]{padding:.75rem 1.5rem;font-size:1.25rem}.pagination-lg .page-item:first-child .page-link[data-v-88355c96]{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link[data-v-88355c96]{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm .page-link[data-v-88355c96]{padding:.25rem .5rem;font-size:.875rem}.pagination-sm .page-item:first-child .page-link[data-v-88355c96]{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link[data-v-88355c96]{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge[data-v-88355c96]{display:inline-block;padding:.35em .65em;font-size:.75em;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}.badge[data-v-88355c96]:empty{display:none}.btn .badge[data-v-88355c96]{position:relative;top:-1px}.alert[data-v-88355c96]{position:relative;padding:1rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading[data-v-88355c96]{color:inherit}.alert-link[data-v-88355c96]{font-weight:700}.alert-dismissible[data-v-88355c96]{padding-right:3rem}.alert-dismissible .btn-close[data-v-88355c96]{position:absolute;top:0;right:0;z-index:2;padding:1.25rem 1rem}.alert-primary[data-v-88355c96]{color:#084298;background-color:#cfe2ff;border-color:#b6d4fe}.alert-primary .alert-link[data-v-88355c96]{color:#06357a}.alert-secondary[data-v-88355c96]{color:#41464b;background-color:#e2e3e5;border-color:#d3d6d8}.alert-secondary .alert-link[data-v-88355c96]{color:#34383c}.alert-success[data-v-88355c96]{color:#0f5132;background-color:#d1e7dd;border-color:#badbcc}.alert-success .alert-link[data-v-88355c96]{color:#0c4128}.alert-info[data-v-88355c96]{color:#055160;background-color:#cff4fc;border-color:#b6effb}.alert-info .alert-link[data-v-88355c96]{color:#04414d}.alert-warning[data-v-88355c96]{color:#664d03;background-color:#fff3cd;border-color:#ffecb5}.alert-warning .alert-link[data-v-88355c96]{color:#523e02}.alert-danger[data-v-88355c96]{color:#842029;background-color:#f8d7da;border-color:#f5c2c7}.alert-danger .alert-link[data-v-88355c96]{color:#6a1a21}.alert-light[data-v-88355c96]{color:#636464;background-color:#fefefe;border-color:#fdfdfe}.alert-light .alert-link[data-v-88355c96]{color:#4f5050}.alert-dark[data-v-88355c96]{color:#141619;background-color:#d3d3d4;border-color:#bcbebf}.alert-dark .alert-link[data-v-88355c96]{color:#101214}@-webkit-keyframes progress-bar-stripes-data-v-88355c96{0%{background-position-x:1rem}}@keyframes progress-bar-stripes-data-v-88355c96{0%{background-position-x:1rem}}.progress[data-v-88355c96]{display:flex;height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress-bar[data-v-88355c96]{display:flex;flex-direction:column;justify-content:center;overflow:hidden;color:#fff;text-align:center;white-space:nowrap;background-color:#0d6efd;transition:width .6s ease}@media (prefers-reduced-motion:reduce){.progress-bar[data-v-88355c96]{transition:none}}.progress-bar-striped[data-v-88355c96]{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-bar-animated[data-v-88355c96]{-webkit-animation:1s linear infinite progress-bar-stripes-data-v-88355c96;animation:1s linear infinite progress-bar-stripes-data-v-88355c96}@media (prefers-reduced-motion:reduce){.progress-bar-animated[data-v-88355c96]{-webkit-animation:none;animation:none}}.list-group[data-v-88355c96]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:.25rem}.list-group-numbered[data-v-88355c96]{list-style-type:none;counter-reset:section}.list-group-numbered>li[data-v-88355c96]:before{content:counters(section,\".\") \". \";counter-increment:section}.list-group-item-action[data-v-88355c96]{width:100%;color:#495057;text-align:inherit}.list-group-item-action[data-v-88355c96]:focus,.list-group-item-action[data-v-88355c96]:hover{z-index:1;color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action[data-v-88355c96]:active{color:#212529;background-color:#e9ecef}.list-group-item[data-v-88355c96]{position:relative;display:block;padding:.5rem 1rem;color:#212529;text-decoration:none;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item[data-v-88355c96]:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.list-group-item[data-v-88355c96]:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.list-group-item.disabled[data-v-88355c96],.list-group-item[data-v-88355c96]:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.list-group-item.active[data-v-88355c96]{z-index:2;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.list-group-item+.list-group-item[data-v-88355c96]{border-top-width:0}.list-group-item+.list-group-item.active[data-v-88355c96]{margin-top:-1px;border-top-width:1px}.list-group-horizontal[data-v-88355c96]{flex-direction:row}.list-group-horizontal>.list-group-item[data-v-88355c96]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal>.list-group-item[data-v-88355c96]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal>.list-group-item.active[data-v-88355c96]{margin-top:0}.list-group-horizontal>.list-group-item+.list-group-item[data-v-88355c96]{border-top-width:1px;border-left-width:0}.list-group-horizontal>.list-group-item+.list-group-item.active[data-v-88355c96]{margin-left:-1px;border-left-width:1px}@media (min-width:576px){.list-group-horizontal-sm[data-v-88355c96]{flex-direction:row}.list-group-horizontal-sm>.list-group-item[data-v-88355c96]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-sm>.list-group-item[data-v-88355c96]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-sm>.list-group-item.active[data-v-88355c96]{margin-top:0}.list-group-horizontal-sm>.list-group-item+.list-group-item[data-v-88355c96]{border-top-width:1px;border-left-width:0}.list-group-horizontal-sm>.list-group-item+.list-group-item.active[data-v-88355c96]{margin-left:-1px;border-left-width:1px}}@media (min-width:768px){.list-group-horizontal-md[data-v-88355c96]{flex-direction:row}.list-group-horizontal-md>.list-group-item[data-v-88355c96]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-md>.list-group-item[data-v-88355c96]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-md>.list-group-item.active[data-v-88355c96]{margin-top:0}.list-group-horizontal-md>.list-group-item+.list-group-item[data-v-88355c96]{border-top-width:1px;border-left-width:0}.list-group-horizontal-md>.list-group-item+.list-group-item.active[data-v-88355c96]{margin-left:-1px;border-left-width:1px}}@media (min-width:992px){.list-group-horizontal-lg[data-v-88355c96]{flex-direction:row}.list-group-horizontal-lg>.list-group-item[data-v-88355c96]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-lg>.list-group-item[data-v-88355c96]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-lg>.list-group-item.active[data-v-88355c96]{margin-top:0}.list-group-horizontal-lg>.list-group-item+.list-group-item[data-v-88355c96]{border-top-width:1px;border-left-width:0}.list-group-horizontal-lg>.list-group-item+.list-group-item.active[data-v-88355c96]{margin-left:-1px;border-left-width:1px}}@media (min-width:1200px){.list-group-horizontal-xl[data-v-88355c96]{flex-direction:row}.list-group-horizontal-xl>.list-group-item[data-v-88355c96]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xl>.list-group-item[data-v-88355c96]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xl>.list-group-item.active[data-v-88355c96]{margin-top:0}.list-group-horizontal-xl>.list-group-item+.list-group-item[data-v-88355c96]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xl>.list-group-item+.list-group-item.active[data-v-88355c96]{margin-left:-1px;border-left-width:1px}}@media (min-width:1400px){.list-group-horizontal-xxl[data-v-88355c96]{flex-direction:row}.list-group-horizontal-xxl>.list-group-item[data-v-88355c96]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xxl>.list-group-item[data-v-88355c96]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xxl>.list-group-item.active[data-v-88355c96]{margin-top:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item[data-v-88355c96]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item.active[data-v-88355c96]{margin-left:-1px;border-left-width:1px}}.list-group-flush[data-v-88355c96]{border-radius:0}.list-group-flush>.list-group-item[data-v-88355c96]{border-width:0 0 1px}.list-group-flush>.list-group-item[data-v-88355c96]:last-child{border-bottom-width:0}.list-group-item-primary[data-v-88355c96]{color:#084298;background-color:#cfe2ff}.list-group-item-primary.list-group-item-action[data-v-88355c96]:focus,.list-group-item-primary.list-group-item-action[data-v-88355c96]:hover{color:#084298;background-color:#bacbe6}.list-group-item-primary.list-group-item-action.active[data-v-88355c96]{color:#fff;background-color:#084298;border-color:#084298}.list-group-item-secondary[data-v-88355c96]{color:#41464b;background-color:#e2e3e5}.list-group-item-secondary.list-group-item-action[data-v-88355c96]:focus,.list-group-item-secondary.list-group-item-action[data-v-88355c96]:hover{color:#41464b;background-color:#cbccce}.list-group-item-secondary.list-group-item-action.active[data-v-88355c96]{color:#fff;background-color:#41464b;border-color:#41464b}.list-group-item-success[data-v-88355c96]{color:#0f5132;background-color:#d1e7dd}.list-group-item-success.list-group-item-action[data-v-88355c96]:focus,.list-group-item-success.list-group-item-action[data-v-88355c96]:hover{color:#0f5132;background-color:#bcd0c7}.list-group-item-success.list-group-item-action.active[data-v-88355c96]{color:#fff;background-color:#0f5132;border-color:#0f5132}.list-group-item-info[data-v-88355c96]{color:#055160;background-color:#cff4fc}.list-group-item-info.list-group-item-action[data-v-88355c96]:focus,.list-group-item-info.list-group-item-action[data-v-88355c96]:hover{color:#055160;background-color:#badce3}.list-group-item-info.list-group-item-action.active[data-v-88355c96]{color:#fff;background-color:#055160;border-color:#055160}.list-group-item-warning[data-v-88355c96]{color:#664d03;background-color:#fff3cd}.list-group-item-warning.list-group-item-action[data-v-88355c96]:focus,.list-group-item-warning.list-group-item-action[data-v-88355c96]:hover{color:#664d03;background-color:#e6dbb9}.list-group-item-warning.list-group-item-action.active[data-v-88355c96]{color:#fff;background-color:#664d03;border-color:#664d03}.list-group-item-danger[data-v-88355c96]{color:#842029;background-color:#f8d7da}.list-group-item-danger.list-group-item-action[data-v-88355c96]:focus,.list-group-item-danger.list-group-item-action[data-v-88355c96]:hover{color:#842029;background-color:#dfc2c4}.list-group-item-danger.list-group-item-action.active[data-v-88355c96]{color:#fff;background-color:#842029;border-color:#842029}.list-group-item-light[data-v-88355c96]{color:#636464;background-color:#fefefe}.list-group-item-light.list-group-item-action[data-v-88355c96]:focus,.list-group-item-light.list-group-item-action[data-v-88355c96]:hover{color:#636464;background-color:#e5e5e5}.list-group-item-light.list-group-item-action.active[data-v-88355c96]{color:#fff;background-color:#636464;border-color:#636464}.list-group-item-dark[data-v-88355c96]{color:#141619;background-color:#d3d3d4}.list-group-item-dark.list-group-item-action[data-v-88355c96]:focus,.list-group-item-dark.list-group-item-action[data-v-88355c96]:hover{color:#141619;background-color:#bebebf}.list-group-item-dark.list-group-item-action.active[data-v-88355c96]{color:#fff;background-color:#141619;border-color:#141619}.btn-close[data-v-88355c96]{box-sizing:content-box;width:1em;height:1em;padding:.25em;color:#000;background:transparent url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M.293.293a1 1 0 11.414 0 NaN NaNlNaN NaN NaN NaNa1 1 0 111.414 1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 10-1.414 NaN NaNz'/%3E%3C/svg%3E\") 50%/1em auto no-repeat;border:0;border-radius:.25rem;opacity:.5}.btn-close[data-v-88355c96]:hover{color:#000;text-decoration:none;opacity:.75}.btn-close[data-v-88355c96]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25);opacity:1}.btn-close.disabled[data-v-88355c96],.btn-close[data-v-88355c96]:disabled{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;opacity:.25}.btn-close-white[data-v-88355c96]{filter:invert(1) grayscale(100%) brightness(200%)}.toast[data-v-88355c96]{width:350px;max-width:100%;font-size:.875rem;pointer-events:auto;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .5rem 1rem rgba(0,0,0,.15);border-radius:.25rem}.toast.showing[data-v-88355c96]{opacity:0}.toast[data-v-88355c96]:not(.show){display:none}.toast-container[data-v-88355c96]{width:-webkit-max-content;width:-moz-max-content;width:max-content;max-width:100%;pointer-events:none}.toast-container[data-v-88355c96]>:not(:last-child){margin-bottom:.75rem}.toast-header[data-v-88355c96]{display:flex;align-items:center;padding:.5rem .75rem;color:#6c757d;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05);border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.toast-header .btn-close[data-v-88355c96]{margin-right:-.375rem;margin-left:.75rem}.toast-body[data-v-88355c96]{padding:.75rem;word-wrap:break-word}.modal[data-v-88355c96]{position:fixed;top:0;left:0;z-index:1055;display:none;width:100%;height:100%;overflow-x:hidden;overflow-y:auto;outline:0}.modal-dialog[data-v-88355c96]{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog[data-v-88355c96]{transition:transform .3s ease-out;transform:translateY(-50px)}@media (prefers-reduced-motion:reduce){.modal.fade .modal-dialog[data-v-88355c96]{transition:none}}.modal.show .modal-dialog[data-v-88355c96]{transform:none}.modal.modal-static .modal-dialog[data-v-88355c96]{transform:scale(1.02)}.modal-dialog-scrollable[data-v-88355c96]{height:calc(100% - 1rem)}.modal-dialog-scrollable .modal-content[data-v-88355c96]{max-height:100%;overflow:hidden}.modal-dialog-scrollable .modal-body[data-v-88355c96]{overflow-y:auto}.modal-dialog-centered[data-v-88355c96]{display:flex;align-items:center;min-height:calc(100% - 1rem)}.modal-content[data-v-88355c96]{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop[data-v-88355c96]{position:fixed;top:0;left:0;z-index:1050;width:100vw;height:100vh;background-color:#000}.modal-backdrop.fade[data-v-88355c96]{opacity:0}.modal-backdrop.show[data-v-88355c96]{opacity:.5}.modal-header[data-v-88355c96]{display:flex;flex-shrink:0;align-items:center;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.modal-header .btn-close[data-v-88355c96]{padding:.5rem;margin:-.5rem -.5rem -.5rem auto}.modal-title[data-v-88355c96]{margin-bottom:0;line-height:1.5}.modal-body[data-v-88355c96]{position:relative;flex:1 1 auto;padding:1rem}.modal-footer[data-v-88355c96]{display:flex;flex-wrap:wrap;flex-shrink:0;align-items:center;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.modal-footer>[data-v-88355c96]{margin:.25rem}@media (min-width:576px){.modal-dialog[data-v-88355c96]{max-width:500px;margin:1.75rem auto}.modal-dialog-scrollable[data-v-88355c96]{height:calc(100% - 3.5rem)}.modal-dialog-centered[data-v-88355c96]{min-height:calc(100% - 3.5rem)}.modal-sm[data-v-88355c96]{max-width:300px}}@media (min-width:992px){.modal-lg[data-v-88355c96],.modal-xl[data-v-88355c96]{max-width:800px}}@media (min-width:1200px){.modal-xl[data-v-88355c96]{max-width:1140px}}.modal-fullscreen[data-v-88355c96]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen .modal-content[data-v-88355c96]{height:100%;border:0;border-radius:0}.modal-fullscreen .modal-header[data-v-88355c96]{border-radius:0}.modal-fullscreen .modal-body[data-v-88355c96]{overflow-y:auto}.modal-fullscreen .modal-footer[data-v-88355c96]{border-radius:0}@media (max-width:575.98px){.modal-fullscreen-sm-down[data-v-88355c96]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-sm-down .modal-content[data-v-88355c96]{height:100%;border:0;border-radius:0}.modal-fullscreen-sm-down .modal-header[data-v-88355c96]{border-radius:0}.modal-fullscreen-sm-down .modal-body[data-v-88355c96]{overflow-y:auto}.modal-fullscreen-sm-down .modal-footer[data-v-88355c96]{border-radius:0}}@media (max-width:767.98px){.modal-fullscreen-md-down[data-v-88355c96]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-md-down .modal-content[data-v-88355c96]{height:100%;border:0;border-radius:0}.modal-fullscreen-md-down .modal-header[data-v-88355c96]{border-radius:0}.modal-fullscreen-md-down .modal-body[data-v-88355c96]{overflow-y:auto}.modal-fullscreen-md-down .modal-footer[data-v-88355c96]{border-radius:0}}@media (max-width:991.98px){.modal-fullscreen-lg-down[data-v-88355c96]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-lg-down .modal-content[data-v-88355c96]{height:100%;border:0;border-radius:0}.modal-fullscreen-lg-down .modal-header[data-v-88355c96]{border-radius:0}.modal-fullscreen-lg-down .modal-body[data-v-88355c96]{overflow-y:auto}.modal-fullscreen-lg-down .modal-footer[data-v-88355c96]{border-radius:0}}@media (max-width:1199.98px){.modal-fullscreen-xl-down[data-v-88355c96]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xl-down .modal-content[data-v-88355c96]{height:100%;border:0;border-radius:0}.modal-fullscreen-xl-down .modal-header[data-v-88355c96]{border-radius:0}.modal-fullscreen-xl-down .modal-body[data-v-88355c96]{overflow-y:auto}.modal-fullscreen-xl-down .modal-footer[data-v-88355c96]{border-radius:0}}@media (max-width:1399.98px){.modal-fullscreen-xxl-down[data-v-88355c96]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xxl-down .modal-content[data-v-88355c96]{height:100%;border:0;border-radius:0}.modal-fullscreen-xxl-down .modal-header[data-v-88355c96]{border-radius:0}.modal-fullscreen-xxl-down .modal-body[data-v-88355c96]{overflow-y:auto}.modal-fullscreen-xxl-down .modal-footer[data-v-88355c96]{border-radius:0}}.tooltip[data-v-88355c96]{position:absolute;z-index:1080;display:block;margin:0;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show[data-v-88355c96]{opacity:.9}.tooltip .tooltip-arrow[data-v-88355c96]{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .tooltip-arrow[data-v-88355c96]:before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[data-popper-placement^=top][data-v-88355c96],.bs-tooltip-top[data-v-88355c96]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-88355c96],.bs-tooltip-top .tooltip-arrow[data-v-88355c96]{bottom:0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-88355c96]:before,.bs-tooltip-top .tooltip-arrow[data-v-88355c96]:before{top:-1px;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[data-popper-placement^=right][data-v-88355c96],.bs-tooltip-end[data-v-88355c96]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-88355c96],.bs-tooltip-end .tooltip-arrow[data-v-88355c96]{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-88355c96]:before,.bs-tooltip-end .tooltip-arrow[data-v-88355c96]:before{right:-1px;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[data-popper-placement^=bottom][data-v-88355c96],.bs-tooltip-bottom[data-v-88355c96]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-88355c96],.bs-tooltip-bottom .tooltip-arrow[data-v-88355c96]{top:0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-88355c96]:before,.bs-tooltip-bottom .tooltip-arrow[data-v-88355c96]:before{bottom:-1px;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[data-popper-placement^=left][data-v-88355c96],.bs-tooltip-start[data-v-88355c96]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-88355c96],.bs-tooltip-start .tooltip-arrow[data-v-88355c96]{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-88355c96]:before,.bs-tooltip-start .tooltip-arrow[data-v-88355c96]:before{left:-1px;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner[data-v-88355c96]{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover[data-v-88355c96]{position:absolute;top:0;left:0;z-index:1070;display:block;max-width:276px;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover .popover-arrow[data-v-88355c96]{position:absolute;display:block;width:1rem;height:.5rem}.popover .popover-arrow[data-v-88355c96]:after,.popover .popover-arrow[data-v-88355c96]:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-88355c96],.bs-popover-top>.popover-arrow[data-v-88355c96]{bottom:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-88355c96]:before,.bs-popover-top>.popover-arrow[data-v-88355c96]:before{bottom:0;border-width:.5rem .5rem 0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-88355c96]:after,.bs-popover-top>.popover-arrow[data-v-88355c96]:after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:#fff}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-88355c96],.bs-popover-end>.popover-arrow[data-v-88355c96]{left:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-88355c96]:before,.bs-popover-end>.popover-arrow[data-v-88355c96]:before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-88355c96]:after,.bs-popover-end>.popover-arrow[data-v-88355c96]:after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:#fff}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-88355c96],.bs-popover-bottom>.popover-arrow[data-v-88355c96]{top:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-88355c96]:before,.bs-popover-bottom>.popover-arrow[data-v-88355c96]:before{top:0;border-width:0 .5rem .5rem;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-88355c96]:after,.bs-popover-bottom>.popover-arrow[data-v-88355c96]:after{top:1px;border-width:0 .5rem .5rem;border-bottom-color:#fff}.bs-popover-auto[data-popper-placement^=bottom] .popover-header[data-v-88355c96]:before,.bs-popover-bottom .popover-header[data-v-88355c96]:before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f0f0f0}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-88355c96],.bs-popover-start>.popover-arrow[data-v-88355c96]{right:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-88355c96]:before,.bs-popover-start>.popover-arrow[data-v-88355c96]:before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-88355c96]:after,.bs-popover-start>.popover-arrow[data-v-88355c96]:after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:#fff}.popover-header[data-v-88355c96]{padding:.5rem 1rem;margin-bottom:0;font-size:1rem;background-color:#f0f0f0;border-bottom:1px solid rgba(0,0,0,.2);border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header[data-v-88355c96]:empty{display:none}.popover-body[data-v-88355c96]{padding:1rem;color:#212529}.carousel[data-v-88355c96]{position:relative}.carousel.pointer-event[data-v-88355c96]{touch-action:pan-y}.carousel-inner[data-v-88355c96]{position:relative;width:100%;overflow:hidden}.carousel-inner[data-v-88355c96]:after{display:block;clear:both;content:\"\"}.carousel-item[data-v-88355c96]{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.carousel-item[data-v-88355c96]{transition:none}}.carousel-item-next[data-v-88355c96],.carousel-item-prev[data-v-88355c96],.carousel-item.active[data-v-88355c96]{display:block}.active.carousel-item-end[data-v-88355c96],.carousel-item-next[data-v-88355c96]:not(.carousel-item-start){transform:translateX(100%)}.active.carousel-item-start[data-v-88355c96],.carousel-item-prev[data-v-88355c96]:not(.carousel-item-end){transform:translateX(-100%)}.carousel-fade .carousel-item[data-v-88355c96]{opacity:0;transition-property:opacity;transform:none}.carousel-fade .carousel-item-next.carousel-item-start[data-v-88355c96],.carousel-fade .carousel-item-prev.carousel-item-end[data-v-88355c96],.carousel-fade .carousel-item.active[data-v-88355c96]{z-index:1;opacity:1}.carousel-fade .active.carousel-item-end[data-v-88355c96],.carousel-fade .active.carousel-item-start[data-v-88355c96]{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.carousel-fade .active.carousel-item-end[data-v-88355c96],.carousel-fade .active.carousel-item-start[data-v-88355c96]{transition:none}}.carousel-control-next[data-v-88355c96],.carousel-control-prev[data-v-88355c96]{position:absolute;top:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center;width:15%;padding:0;color:#fff;text-align:center;background:0 0;border:0;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.carousel-control-next[data-v-88355c96],.carousel-control-prev[data-v-88355c96]{transition:none}}.carousel-control-next[data-v-88355c96]:focus,.carousel-control-next[data-v-88355c96]:hover,.carousel-control-prev[data-v-88355c96]:focus,.carousel-control-prev[data-v-88355c96]:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev[data-v-88355c96]{left:0}.carousel-control-next[data-v-88355c96]{right:0}.carousel-control-next-icon[data-v-88355c96],.carousel-control-prev-icon[data-v-88355c96]{display:inline-block;width:2rem;height:2rem;background-repeat:no-repeat;background-position:50%;background-size:100% 100%}.carousel-control-prev-icon[data-v-88355c96]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3E%3C/svg%3E\")}.carousel-control-next-icon[data-v-88355c96]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\")}.carousel-indicators[data-v-88355c96]{position:absolute;right:0;bottom:0;left:0;z-index:2;display:flex;justify-content:center;padding:0;margin-right:15%;margin-bottom:1rem;margin-left:15%;list-style:none}.carousel-indicators [data-bs-target][data-v-88355c96]{box-sizing:content-box;flex:0 1 auto;width:30px;height:3px;padding:0;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border:0;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.carousel-indicators [data-bs-target][data-v-88355c96]{transition:none}}.carousel-indicators .active[data-v-88355c96]{opacity:1}.carousel-caption[data-v-88355c96]{position:absolute;right:15%;bottom:1.25rem;left:15%;padding-top:1.25rem;padding-bottom:1.25rem;color:#fff;text-align:center}.carousel-dark .carousel-control-next-icon[data-v-88355c96],.carousel-dark .carousel-control-prev-icon[data-v-88355c96]{filter:invert(1) grayscale(100)}.carousel-dark .carousel-indicators [data-bs-target][data-v-88355c96]{background-color:#000}.carousel-dark .carousel-caption[data-v-88355c96]{color:#000}@-webkit-keyframes spinner-border-data-v-88355c96{to{transform:rotate(1turn)}}@keyframes spinner-border-data-v-88355c96{to{transform:rotate(1turn)}}.spinner-border[data-v-88355c96]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:.75s linear infinite spinner-border-data-v-88355c96;animation:.75s linear infinite spinner-border-data-v-88355c96}.spinner-border-sm[data-v-88355c96]{width:1rem;height:1rem;border-width:.2em}@-webkit-keyframes spinner-grow-data-v-88355c96{0%{transform:scale(0)}50%{opacity:1;transform:none}}@keyframes spinner-grow-data-v-88355c96{0%{transform:scale(0)}50%{opacity:1;transform:none}}.spinner-grow[data-v-88355c96]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;background-color:currentColor;border-radius:50%;opacity:0;-webkit-animation:.75s linear infinite spinner-grow-data-v-88355c96;animation:.75s linear infinite spinner-grow-data-v-88355c96}.spinner-grow-sm[data-v-88355c96]{width:1rem;height:1rem}@media (prefers-reduced-motion:reduce){.spinner-border[data-v-88355c96],.spinner-grow[data-v-88355c96]{-webkit-animation-duration:1.5s;animation-duration:1.5s}}.offcanvas[data-v-88355c96]{position:fixed;bottom:0;z-index:1045;display:flex;flex-direction:column;max-width:100%;visibility:hidden;background-color:#fff;background-clip:padding-box;outline:0;transition:transform .3s ease-in-out}@media (prefers-reduced-motion:reduce){.offcanvas[data-v-88355c96]{transition:none}}.offcanvas-backdrop[data-v-88355c96]{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.offcanvas-backdrop.fade[data-v-88355c96]{opacity:0}.offcanvas-backdrop.show[data-v-88355c96]{opacity:.5}.offcanvas-header[data-v-88355c96]{display:flex;align-items:center;justify-content:space-between;padding:1rem}.offcanvas-header .btn-close[data-v-88355c96]{padding:.5rem;margin-top:-.5rem;margin-right:-.5rem;margin-bottom:-.5rem}.offcanvas-title[data-v-88355c96]{margin-bottom:0;line-height:1.5}.offcanvas-body[data-v-88355c96]{flex-grow:1;padding:1rem;overflow-y:auto}.offcanvas-start[data-v-88355c96]{top:0;left:0;width:400px;border-right:1px solid rgba(0,0,0,.2);transform:translateX(-100%)}.offcanvas-end[data-v-88355c96]{top:0;right:0;width:400px;border-left:1px solid rgba(0,0,0,.2);transform:translateX(100%)}.offcanvas-top[data-v-88355c96]{top:0;right:0;left:0;height:30vh;max-height:100%;border-bottom:1px solid rgba(0,0,0,.2);transform:translateY(-100%)}.offcanvas-bottom[data-v-88355c96]{right:0;left:0;height:30vh;max-height:100%;border-top:1px solid rgba(0,0,0,.2);transform:translateY(100%)}.offcanvas.show[data-v-88355c96]{transform:none}.placeholder[data-v-88355c96]{display:inline-block;min-height:1em;vertical-align:middle;cursor:wait;background-color:currentColor;opacity:.5}.placeholder.btn[data-v-88355c96]:before{display:inline-block;content:\"\"}.placeholder-xs[data-v-88355c96]{min-height:.6em}.placeholder-sm[data-v-88355c96]{min-height:.8em}.placeholder-lg[data-v-88355c96]{min-height:1.2em}.placeholder-glow .placeholder[data-v-88355c96]{-webkit-animation:placeholder-glow-data-v-88355c96 2s ease-in-out infinite;animation:placeholder-glow-data-v-88355c96 2s ease-in-out infinite}@-webkit-keyframes placeholder-glow-data-v-88355c96{50%{opacity:.2}}@keyframes placeholder-glow-data-v-88355c96{50%{opacity:.2}}.placeholder-wave[data-v-88355c96]{-webkit-mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);-webkit-mask-size:200% 100%;mask-size:200% 100%;-webkit-animation:placeholder-wave-data-v-88355c96 2s linear infinite;animation:placeholder-wave-data-v-88355c96 2s linear infinite}@-webkit-keyframes placeholder-wave-data-v-88355c96{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}@keyframes placeholder-wave-data-v-88355c96{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}.clearfix[data-v-88355c96]:after{display:block;clear:both;content:\"\"}.link-primary[data-v-88355c96]{color:#0d6efd}.link-primary[data-v-88355c96]:focus,.link-primary[data-v-88355c96]:hover{color:#0a58ca}.link-secondary[data-v-88355c96]{color:#6c757d}.link-secondary[data-v-88355c96]:focus,.link-secondary[data-v-88355c96]:hover{color:#565e64}.link-success[data-v-88355c96]{color:#198754}.link-success[data-v-88355c96]:focus,.link-success[data-v-88355c96]:hover{color:#146c43}.link-info[data-v-88355c96]{color:#0dcaf0}.link-info[data-v-88355c96]:focus,.link-info[data-v-88355c96]:hover{color:#3dd5f3}.link-warning[data-v-88355c96]{color:#ffc107}.link-warning[data-v-88355c96]:focus,.link-warning[data-v-88355c96]:hover{color:#ffcd39}.link-danger[data-v-88355c96]{color:#dc3545}.link-danger[data-v-88355c96]:focus,.link-danger[data-v-88355c96]:hover{color:#b02a37}.link-light[data-v-88355c96]{color:#f8f9fa}.link-light[data-v-88355c96]:focus,.link-light[data-v-88355c96]:hover{color:#f9fafb}.link-dark[data-v-88355c96]{color:#212529}.link-dark[data-v-88355c96]:focus,.link-dark[data-v-88355c96]:hover{color:#1a1e21}.ratio[data-v-88355c96]{position:relative;width:100%}.ratio[data-v-88355c96]:before{display:block;padding-top:var(--bs-aspect-ratio);content:\"\"}.ratio>[data-v-88355c96]{position:absolute;top:0;left:0;width:100%;height:100%}.ratio-1x1[data-v-88355c96]{--bs-aspect-ratio:100%}.ratio-4x3[data-v-88355c96]{--bs-aspect-ratio:75%}.ratio-16x9[data-v-88355c96]{--bs-aspect-ratio:56.25%}.ratio-21x9[data-v-88355c96]{--bs-aspect-ratio:42.8571428571%}.fixed-top[data-v-88355c96]{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom[data-v-88355c96]{position:fixed;right:0;bottom:0;left:0;z-index:1030}.sticky-top[data-v-88355c96]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}@media (min-width:576px){.sticky-sm-top[data-v-88355c96]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:768px){.sticky-md-top[data-v-88355c96]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:992px){.sticky-lg-top[data-v-88355c96]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1200px){.sticky-xl-top[data-v-88355c96]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1400px){.sticky-xxl-top[data-v-88355c96]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.hstack[data-v-88355c96]{display:flex;flex-direction:row;align-items:center;align-self:stretch}.vstack[data-v-88355c96]{display:flex;flex:1 1 auto;flex-direction:column;align-self:stretch}.visually-hidden-focusable[data-v-88355c96]:not(:focus):not(:focus-within),.visually-hidden[data-v-88355c96]{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}.stretched-link[data-v-88355c96]:after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;content:\"\"}.text-truncate[data-v-88355c96]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.vr[data-v-88355c96]{display:inline-block;align-self:stretch;width:1px;min-height:1em;background-color:currentColor;opacity:.25}.align-baseline[data-v-88355c96]{vertical-align:baseline!important}.align-top[data-v-88355c96]{vertical-align:top!important}.align-middle[data-v-88355c96]{vertical-align:middle!important}.align-bottom[data-v-88355c96]{vertical-align:bottom!important}.align-text-bottom[data-v-88355c96]{vertical-align:text-bottom!important}.align-text-top[data-v-88355c96]{vertical-align:text-top!important}.float-start[data-v-88355c96]{float:left!important}.float-end[data-v-88355c96]{float:right!important}.float-none[data-v-88355c96]{float:none!important}.opacity-0[data-v-88355c96]{opacity:0!important}.opacity-25[data-v-88355c96]{opacity:.25!important}.opacity-50[data-v-88355c96]{opacity:.5!important}.opacity-75[data-v-88355c96]{opacity:.75!important}.opacity-100[data-v-88355c96]{opacity:1!important}.overflow-auto[data-v-88355c96]{overflow:auto!important}.overflow-hidden[data-v-88355c96]{overflow:hidden!important}.overflow-visible[data-v-88355c96]{overflow:visible!important}.overflow-scroll[data-v-88355c96]{overflow:scroll!important}.d-inline[data-v-88355c96]{display:inline!important}.d-inline-block[data-v-88355c96]{display:inline-block!important}.d-block[data-v-88355c96]{display:block!important}.d-grid[data-v-88355c96]{display:grid!important}.d-table[data-v-88355c96]{display:table!important}.d-table-row[data-v-88355c96]{display:table-row!important}.d-table-cell[data-v-88355c96]{display:table-cell!important}.d-flex[data-v-88355c96]{display:flex!important}.d-inline-flex[data-v-88355c96]{display:inline-flex!important}.d-none[data-v-88355c96]{display:none!important}.shadow[data-v-88355c96]{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.shadow-sm[data-v-88355c96]{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.shadow-lg[data-v-88355c96]{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.shadow-none[data-v-88355c96]{box-shadow:none!important}.position-static[data-v-88355c96]{position:static!important}.position-relative[data-v-88355c96]{position:relative!important}.position-absolute[data-v-88355c96]{position:absolute!important}.position-fixed[data-v-88355c96]{position:fixed!important}.position-sticky[data-v-88355c96]{position:-webkit-sticky!important;position:sticky!important}.top-0[data-v-88355c96]{top:0!important}.top-50[data-v-88355c96]{top:50%!important}.top-100[data-v-88355c96]{top:100%!important}.bottom-0[data-v-88355c96]{bottom:0!important}.bottom-50[data-v-88355c96]{bottom:50%!important}.bottom-100[data-v-88355c96]{bottom:100%!important}.start-0[data-v-88355c96]{left:0!important}.start-50[data-v-88355c96]{left:50%!important}.start-100[data-v-88355c96]{left:100%!important}.end-0[data-v-88355c96]{right:0!important}.end-50[data-v-88355c96]{right:50%!important}.end-100[data-v-88355c96]{right:100%!important}.translate-middle[data-v-88355c96]{transform:translate(-50%,-50%)!important}.translate-middle-x[data-v-88355c96]{transform:translateX(-50%)!important}.translate-middle-y[data-v-88355c96]{transform:translateY(-50%)!important}.border[data-v-88355c96]{border:1px solid #dee2e6!important}.border-0[data-v-88355c96]{border:0!important}.border-top[data-v-88355c96]{border-top:1px solid #dee2e6!important}.border-top-0[data-v-88355c96]{border-top:0!important}.border-end[data-v-88355c96]{border-right:1px solid #dee2e6!important}.border-end-0[data-v-88355c96]{border-right:0!important}.border-bottom[data-v-88355c96]{border-bottom:1px solid #dee2e6!important}.border-bottom-0[data-v-88355c96]{border-bottom:0!important}.border-start[data-v-88355c96]{border-left:1px solid #dee2e6!important}.border-start-0[data-v-88355c96]{border-left:0!important}.border-primary[data-v-88355c96]{border-color:#0d6efd!important}.border-secondary[data-v-88355c96]{border-color:#6c757d!important}.border-success[data-v-88355c96]{border-color:#198754!important}.border-info[data-v-88355c96]{border-color:#0dcaf0!important}.border-warning[data-v-88355c96]{border-color:#ffc107!important}.border-danger[data-v-88355c96]{border-color:#dc3545!important}.border-light[data-v-88355c96]{border-color:#f8f9fa!important}.border-dark[data-v-88355c96]{border-color:#212529!important}.border-white[data-v-88355c96]{border-color:#fff!important}.border-1[data-v-88355c96]{border-width:1px!important}.border-2[data-v-88355c96]{border-width:2px!important}.border-3[data-v-88355c96]{border-width:3px!important}.border-4[data-v-88355c96]{border-width:4px!important}.border-5[data-v-88355c96]{border-width:5px!important}.w-25[data-v-88355c96]{width:25%!important}.w-50[data-v-88355c96]{width:50%!important}.w-75[data-v-88355c96]{width:75%!important}.w-100[data-v-88355c96]{width:100%!important}.w-auto[data-v-88355c96]{width:auto!important}.mw-100[data-v-88355c96]{max-width:100%!important}.vw-100[data-v-88355c96]{width:100vw!important}.min-vw-100[data-v-88355c96]{min-width:100vw!important}.h-25[data-v-88355c96]{height:25%!important}.h-50[data-v-88355c96]{height:50%!important}.h-75[data-v-88355c96]{height:75%!important}.h-100[data-v-88355c96]{height:100%!important}.h-auto[data-v-88355c96]{height:auto!important}.mh-100[data-v-88355c96]{max-height:100%!important}.vh-100[data-v-88355c96]{height:100vh!important}.min-vh-100[data-v-88355c96]{min-height:100vh!important}.flex-fill[data-v-88355c96]{flex:1 1 auto!important}.flex-row[data-v-88355c96]{flex-direction:row!important}.flex-column[data-v-88355c96]{flex-direction:column!important}.flex-row-reverse[data-v-88355c96]{flex-direction:row-reverse!important}.flex-column-reverse[data-v-88355c96]{flex-direction:column-reverse!important}.flex-grow-0[data-v-88355c96]{flex-grow:0!important}.flex-grow-1[data-v-88355c96]{flex-grow:1!important}.flex-shrink-0[data-v-88355c96]{flex-shrink:0!important}.flex-shrink-1[data-v-88355c96]{flex-shrink:1!important}.flex-wrap[data-v-88355c96]{flex-wrap:wrap!important}.flex-nowrap[data-v-88355c96]{flex-wrap:nowrap!important}.flex-wrap-reverse[data-v-88355c96]{flex-wrap:wrap-reverse!important}.gap-0[data-v-88355c96]{gap:0!important}.gap-1[data-v-88355c96]{gap:.25rem!important}.gap-2[data-v-88355c96]{gap:.5rem!important}.gap-3[data-v-88355c96]{gap:1rem!important}.gap-4[data-v-88355c96]{gap:1.5rem!important}.gap-5[data-v-88355c96]{gap:3rem!important}.justify-content-start[data-v-88355c96]{justify-content:flex-start!important}.justify-content-end[data-v-88355c96]{justify-content:flex-end!important}.justify-content-center[data-v-88355c96]{justify-content:center!important}.justify-content-between[data-v-88355c96]{justify-content:space-between!important}.justify-content-around[data-v-88355c96]{justify-content:space-around!important}.justify-content-evenly[data-v-88355c96]{justify-content:space-evenly!important}.align-items-start[data-v-88355c96]{align-items:flex-start!important}.align-items-end[data-v-88355c96]{align-items:flex-end!important}.align-items-center[data-v-88355c96]{align-items:center!important}.align-items-baseline[data-v-88355c96]{align-items:baseline!important}.align-items-stretch[data-v-88355c96]{align-items:stretch!important}.align-content-start[data-v-88355c96]{align-content:flex-start!important}.align-content-end[data-v-88355c96]{align-content:flex-end!important}.align-content-center[data-v-88355c96]{align-content:center!important}.align-content-between[data-v-88355c96]{align-content:space-between!important}.align-content-around[data-v-88355c96]{align-content:space-around!important}.align-content-stretch[data-v-88355c96]{align-content:stretch!important}.align-self-auto[data-v-88355c96]{align-self:auto!important}.align-self-start[data-v-88355c96]{align-self:flex-start!important}.align-self-end[data-v-88355c96]{align-self:flex-end!important}.align-self-center[data-v-88355c96]{align-self:center!important}.align-self-baseline[data-v-88355c96]{align-self:baseline!important}.align-self-stretch[data-v-88355c96]{align-self:stretch!important}.order-first[data-v-88355c96]{order:-1!important}.order-0[data-v-88355c96]{order:0!important}.order-1[data-v-88355c96]{order:1!important}.order-2[data-v-88355c96]{order:2!important}.order-3[data-v-88355c96]{order:3!important}.order-4[data-v-88355c96]{order:4!important}.order-5[data-v-88355c96]{order:5!important}.order-last[data-v-88355c96]{order:6!important}.m-0[data-v-88355c96]{margin:0!important}.m-1[data-v-88355c96]{margin:.25rem!important}.m-2[data-v-88355c96]{margin:.5rem!important}.m-3[data-v-88355c96]{margin:1rem!important}.m-4[data-v-88355c96]{margin:1.5rem!important}.m-5[data-v-88355c96]{margin:3rem!important}.m-auto[data-v-88355c96]{margin:auto!important}.mx-0[data-v-88355c96]{margin-right:0!important;margin-left:0!important}.mx-1[data-v-88355c96]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-2[data-v-88355c96]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-3[data-v-88355c96]{margin-right:1rem!important;margin-left:1rem!important}.mx-4[data-v-88355c96]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-5[data-v-88355c96]{margin-right:3rem!important;margin-left:3rem!important}.mx-auto[data-v-88355c96]{margin-right:auto!important;margin-left:auto!important}.my-0[data-v-88355c96]{margin-top:0!important;margin-bottom:0!important}.my-1[data-v-88355c96]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-2[data-v-88355c96]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-3[data-v-88355c96]{margin-top:1rem!important;margin-bottom:1rem!important}.my-4[data-v-88355c96]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-5[data-v-88355c96]{margin-top:3rem!important;margin-bottom:3rem!important}.my-auto[data-v-88355c96]{margin-top:auto!important;margin-bottom:auto!important}.mt-0[data-v-88355c96]{margin-top:0!important}.mt-1[data-v-88355c96]{margin-top:.25rem!important}.mt-2[data-v-88355c96]{margin-top:.5rem!important}.mt-3[data-v-88355c96]{margin-top:1rem!important}.mt-4[data-v-88355c96]{margin-top:1.5rem!important}.mt-5[data-v-88355c96]{margin-top:3rem!important}.mt-auto[data-v-88355c96]{margin-top:auto!important}.me-0[data-v-88355c96]{margin-right:0!important}.me-1[data-v-88355c96]{margin-right:.25rem!important}.me-2[data-v-88355c96]{margin-right:.5rem!important}.me-3[data-v-88355c96]{margin-right:1rem!important}.me-4[data-v-88355c96]{margin-right:1.5rem!important}.me-5[data-v-88355c96]{margin-right:3rem!important}.me-auto[data-v-88355c96]{margin-right:auto!important}.mb-0[data-v-88355c96]{margin-bottom:0!important}.mb-1[data-v-88355c96]{margin-bottom:.25rem!important}.mb-2[data-v-88355c96]{margin-bottom:.5rem!important}.mb-3[data-v-88355c96]{margin-bottom:1rem!important}.mb-4[data-v-88355c96]{margin-bottom:1.5rem!important}.mb-5[data-v-88355c96]{margin-bottom:3rem!important}.mb-auto[data-v-88355c96]{margin-bottom:auto!important}.ms-0[data-v-88355c96]{margin-left:0!important}.ms-1[data-v-88355c96]{margin-left:.25rem!important}.ms-2[data-v-88355c96]{margin-left:.5rem!important}.ms-3[data-v-88355c96]{margin-left:1rem!important}.ms-4[data-v-88355c96]{margin-left:1.5rem!important}.ms-5[data-v-88355c96]{margin-left:3rem!important}.ms-auto[data-v-88355c96]{margin-left:auto!important}.p-0[data-v-88355c96]{padding:0!important}.p-1[data-v-88355c96]{padding:.25rem!important}.p-2[data-v-88355c96]{padding:.5rem!important}.p-3[data-v-88355c96]{padding:1rem!important}.p-4[data-v-88355c96]{padding:1.5rem!important}.p-5[data-v-88355c96]{padding:3rem!important}.px-0[data-v-88355c96]{padding-right:0!important;padding-left:0!important}.px-1[data-v-88355c96]{padding-right:.25rem!important;padding-left:.25rem!important}.px-2[data-v-88355c96]{padding-right:.5rem!important;padding-left:.5rem!important}.px-3[data-v-88355c96]{padding-right:1rem!important;padding-left:1rem!important}.px-4[data-v-88355c96]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-5[data-v-88355c96]{padding-right:3rem!important;padding-left:3rem!important}.py-0[data-v-88355c96]{padding-top:0!important;padding-bottom:0!important}.py-1[data-v-88355c96]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-2[data-v-88355c96]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-3[data-v-88355c96]{padding-top:1rem!important;padding-bottom:1rem!important}.py-4[data-v-88355c96]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-5[data-v-88355c96]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-0[data-v-88355c96]{padding-top:0!important}.pt-1[data-v-88355c96]{padding-top:.25rem!important}.pt-2[data-v-88355c96]{padding-top:.5rem!important}.pt-3[data-v-88355c96]{padding-top:1rem!important}.pt-4[data-v-88355c96]{padding-top:1.5rem!important}.pt-5[data-v-88355c96]{padding-top:3rem!important}.pe-0[data-v-88355c96]{padding-right:0!important}.pe-1[data-v-88355c96]{padding-right:.25rem!important}.pe-2[data-v-88355c96]{padding-right:.5rem!important}.pe-3[data-v-88355c96]{padding-right:1rem!important}.pe-4[data-v-88355c96]{padding-right:1.5rem!important}.pe-5[data-v-88355c96]{padding-right:3rem!important}.pb-0[data-v-88355c96]{padding-bottom:0!important}.pb-1[data-v-88355c96]{padding-bottom:.25rem!important}.pb-2[data-v-88355c96]{padding-bottom:.5rem!important}.pb-3[data-v-88355c96]{padding-bottom:1rem!important}.pb-4[data-v-88355c96]{padding-bottom:1.5rem!important}.pb-5[data-v-88355c96]{padding-bottom:3rem!important}.ps-0[data-v-88355c96]{padding-left:0!important}.ps-1[data-v-88355c96]{padding-left:.25rem!important}.ps-2[data-v-88355c96]{padding-left:.5rem!important}.ps-3[data-v-88355c96]{padding-left:1rem!important}.ps-4[data-v-88355c96]{padding-left:1.5rem!important}.ps-5[data-v-88355c96]{padding-left:3rem!important}.font-monospace[data-v-88355c96]{font-family:var(--bs-font-monospace)!important}.fs-1[data-v-88355c96]{font-size:calc(1.375rem + 1.5vw)!important}.fs-2[data-v-88355c96]{font-size:calc(1.325rem + .9vw)!important}.fs-3[data-v-88355c96]{font-size:calc(1.3rem + .6vw)!important}.fs-4[data-v-88355c96]{font-size:calc(1.275rem + .3vw)!important}.fs-5[data-v-88355c96]{font-size:1.25rem!important}.fs-6[data-v-88355c96]{font-size:1rem!important}.fst-italic[data-v-88355c96]{font-style:italic!important}.fst-normal[data-v-88355c96]{font-style:normal!important}.fw-light[data-v-88355c96]{font-weight:300!important}.fw-lighter[data-v-88355c96]{font-weight:lighter!important}.fw-normal[data-v-88355c96]{font-weight:400!important}.fw-bold[data-v-88355c96]{font-weight:700!important}.fw-bolder[data-v-88355c96]{font-weight:bolder!important}.lh-1[data-v-88355c96]{line-height:1!important}.lh-sm[data-v-88355c96]{line-height:1.25!important}.lh-base[data-v-88355c96]{line-height:1.5!important}.lh-lg[data-v-88355c96]{line-height:2!important}.text-start[data-v-88355c96]{text-align:left!important}.text-end[data-v-88355c96]{text-align:right!important}.text-center[data-v-88355c96]{text-align:center!important}.text-decoration-none[data-v-88355c96]{text-decoration:none!important}.text-decoration-underline[data-v-88355c96]{text-decoration:underline!important}.text-decoration-line-through[data-v-88355c96]{text-decoration:line-through!important}.text-lowercase[data-v-88355c96]{text-transform:lowercase!important}.text-uppercase[data-v-88355c96]{text-transform:uppercase!important}.text-capitalize[data-v-88355c96]{text-transform:capitalize!important}.text-wrap[data-v-88355c96]{white-space:normal!important}.text-nowrap[data-v-88355c96]{white-space:nowrap!important}.text-break[data-v-88355c96]{word-wrap:break-word!important;word-break:break-word!important}.text-primary[data-v-88355c96]{--bs-text-opacity:1;color:rgba(var(--bs-primary-rgb),var(--bs-text-opacity))!important}.text-secondary[data-v-88355c96]{--bs-text-opacity:1;color:rgba(var(--bs-secondary-rgb),var(--bs-text-opacity))!important}.text-success[data-v-88355c96]{--bs-text-opacity:1;color:rgba(var(--bs-success-rgb),var(--bs-text-opacity))!important}.text-info[data-v-88355c96]{--bs-text-opacity:1;color:rgba(var(--bs-info-rgb),var(--bs-text-opacity))!important}.text-warning[data-v-88355c96]{--bs-text-opacity:1;color:rgba(var(--bs-warning-rgb),var(--bs-text-opacity))!important}.text-danger[data-v-88355c96]{--bs-text-opacity:1;color:rgba(var(--bs-danger-rgb),var(--bs-text-opacity))!important}.text-light[data-v-88355c96]{--bs-text-opacity:1;color:rgba(var(--bs-light-rgb),var(--bs-text-opacity))!important}.text-dark[data-v-88355c96]{--bs-text-opacity:1;color:rgba(var(--bs-dark-rgb),var(--bs-text-opacity))!important}.text-black[data-v-88355c96]{--bs-text-opacity:1;color:rgba(var(--bs-black-rgb),var(--bs-text-opacity))!important}.text-white[data-v-88355c96]{--bs-text-opacity:1;color:rgba(var(--bs-white-rgb),var(--bs-text-opacity))!important}.text-body[data-v-88355c96]{--bs-text-opacity:1;color:rgba(var(--bs-body-color-rgb),var(--bs-text-opacity))!important}.text-muted[data-v-88355c96]{--bs-text-opacity:1;color:#6c757d!important}.text-black-50[data-v-88355c96]{--bs-text-opacity:1;color:rgba(0,0,0,.5)!important}.text-white-50[data-v-88355c96]{--bs-text-opacity:1;color:hsla(0,0%,100%,.5)!important}.text-reset[data-v-88355c96]{--bs-text-opacity:1;color:inherit!important}.text-opacity-25[data-v-88355c96]{--bs-text-opacity:0.25}.text-opacity-50[data-v-88355c96]{--bs-text-opacity:0.5}.text-opacity-75[data-v-88355c96]{--bs-text-opacity:0.75}.text-opacity-100[data-v-88355c96]{--bs-text-opacity:1}.bg-primary[data-v-88355c96]{--bs-bg-opacity:1;background-color:rgba(var(--bs-primary-rgb),var(--bs-bg-opacity))!important}.bg-secondary[data-v-88355c96]{--bs-bg-opacity:1;background-color:rgba(var(--bs-secondary-rgb),var(--bs-bg-opacity))!important}.bg-success[data-v-88355c96]{--bs-bg-opacity:1;background-color:rgba(var(--bs-success-rgb),var(--bs-bg-opacity))!important}.bg-info[data-v-88355c96]{--bs-bg-opacity:1;background-color:rgba(var(--bs-info-rgb),var(--bs-bg-opacity))!important}.bg-warning[data-v-88355c96]{--bs-bg-opacity:1;background-color:rgba(var(--bs-warning-rgb),var(--bs-bg-opacity))!important}.bg-danger[data-v-88355c96]{--bs-bg-opacity:1;background-color:rgba(var(--bs-danger-rgb),var(--bs-bg-opacity))!important}.bg-light[data-v-88355c96]{--bs-bg-opacity:1;background-color:rgba(var(--bs-light-rgb),var(--bs-bg-opacity))!important}.bg-dark[data-v-88355c96]{--bs-bg-opacity:1;background-color:rgba(var(--bs-dark-rgb),var(--bs-bg-opacity))!important}.bg-black[data-v-88355c96]{--bs-bg-opacity:1;background-color:rgba(var(--bs-black-rgb),var(--bs-bg-opacity))!important}.bg-white[data-v-88355c96]{--bs-bg-opacity:1;background-color:rgba(var(--bs-white-rgb),var(--bs-bg-opacity))!important}.bg-body[data-v-88355c96]{--bs-bg-opacity:1;background-color:rgba(var(--bs-body-bg-rgb),var(--bs-bg-opacity))!important}.bg-transparent[data-v-88355c96]{--bs-bg-opacity:1;background-color:transparent!important}.bg-opacity-10[data-v-88355c96]{--bs-bg-opacity:0.1}.bg-opacity-25[data-v-88355c96]{--bs-bg-opacity:0.25}.bg-opacity-50[data-v-88355c96]{--bs-bg-opacity:0.5}.bg-opacity-75[data-v-88355c96]{--bs-bg-opacity:0.75}.bg-opacity-100[data-v-88355c96]{--bs-bg-opacity:1}.bg-gradient[data-v-88355c96]{background-image:var(--bs-gradient)!important}.user-select-all[data-v-88355c96]{-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.user-select-auto[data-v-88355c96]{-webkit-user-select:auto!important;-moz-user-select:auto!important;user-select:auto!important}.user-select-none[data-v-88355c96]{-webkit-user-select:none!important;-moz-user-select:none!important;user-select:none!important}.pe-none[data-v-88355c96]{pointer-events:none!important}.pe-auto[data-v-88355c96]{pointer-events:auto!important}.rounded[data-v-88355c96]{border-radius:.25rem!important}.rounded-0[data-v-88355c96]{border-radius:0!important}.rounded-1[data-v-88355c96]{border-radius:.2rem!important}.rounded-2[data-v-88355c96]{border-radius:.25rem!important}.rounded-3[data-v-88355c96]{border-radius:.3rem!important}.rounded-circle[data-v-88355c96]{border-radius:50%!important}.rounded-pill[data-v-88355c96]{border-radius:50rem!important}.rounded-top[data-v-88355c96]{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.rounded-end[data-v-88355c96]{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.rounded-bottom[data-v-88355c96]{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-start[data-v-88355c96]{border-bottom-left-radius:.25rem!important;border-top-left-radius:.25rem!important}.visible[data-v-88355c96]{visibility:visible!important}.invisible[data-v-88355c96]{visibility:hidden!important}@media (min-width:576px){.float-sm-start[data-v-88355c96]{float:left!important}.float-sm-end[data-v-88355c96]{float:right!important}.float-sm-none[data-v-88355c96]{float:none!important}.d-sm-inline[data-v-88355c96]{display:inline!important}.d-sm-inline-block[data-v-88355c96]{display:inline-block!important}.d-sm-block[data-v-88355c96]{display:block!important}.d-sm-grid[data-v-88355c96]{display:grid!important}.d-sm-table[data-v-88355c96]{display:table!important}.d-sm-table-row[data-v-88355c96]{display:table-row!important}.d-sm-table-cell[data-v-88355c96]{display:table-cell!important}.d-sm-flex[data-v-88355c96]{display:flex!important}.d-sm-inline-flex[data-v-88355c96]{display:inline-flex!important}.d-sm-none[data-v-88355c96]{display:none!important}.flex-sm-fill[data-v-88355c96]{flex:1 1 auto!important}.flex-sm-row[data-v-88355c96]{flex-direction:row!important}.flex-sm-column[data-v-88355c96]{flex-direction:column!important}.flex-sm-row-reverse[data-v-88355c96]{flex-direction:row-reverse!important}.flex-sm-column-reverse[data-v-88355c96]{flex-direction:column-reverse!important}.flex-sm-grow-0[data-v-88355c96]{flex-grow:0!important}.flex-sm-grow-1[data-v-88355c96]{flex-grow:1!important}.flex-sm-shrink-0[data-v-88355c96]{flex-shrink:0!important}.flex-sm-shrink-1[data-v-88355c96]{flex-shrink:1!important}.flex-sm-wrap[data-v-88355c96]{flex-wrap:wrap!important}.flex-sm-nowrap[data-v-88355c96]{flex-wrap:nowrap!important}.flex-sm-wrap-reverse[data-v-88355c96]{flex-wrap:wrap-reverse!important}.gap-sm-0[data-v-88355c96]{gap:0!important}.gap-sm-1[data-v-88355c96]{gap:.25rem!important}.gap-sm-2[data-v-88355c96]{gap:.5rem!important}.gap-sm-3[data-v-88355c96]{gap:1rem!important}.gap-sm-4[data-v-88355c96]{gap:1.5rem!important}.gap-sm-5[data-v-88355c96]{gap:3rem!important}.justify-content-sm-start[data-v-88355c96]{justify-content:flex-start!important}.justify-content-sm-end[data-v-88355c96]{justify-content:flex-end!important}.justify-content-sm-center[data-v-88355c96]{justify-content:center!important}.justify-content-sm-between[data-v-88355c96]{justify-content:space-between!important}.justify-content-sm-around[data-v-88355c96]{justify-content:space-around!important}.justify-content-sm-evenly[data-v-88355c96]{justify-content:space-evenly!important}.align-items-sm-start[data-v-88355c96]{align-items:flex-start!important}.align-items-sm-end[data-v-88355c96]{align-items:flex-end!important}.align-items-sm-center[data-v-88355c96]{align-items:center!important}.align-items-sm-baseline[data-v-88355c96]{align-items:baseline!important}.align-items-sm-stretch[data-v-88355c96]{align-items:stretch!important}.align-content-sm-start[data-v-88355c96]{align-content:flex-start!important}.align-content-sm-end[data-v-88355c96]{align-content:flex-end!important}.align-content-sm-center[data-v-88355c96]{align-content:center!important}.align-content-sm-between[data-v-88355c96]{align-content:space-between!important}.align-content-sm-around[data-v-88355c96]{align-content:space-around!important}.align-content-sm-stretch[data-v-88355c96]{align-content:stretch!important}.align-self-sm-auto[data-v-88355c96]{align-self:auto!important}.align-self-sm-start[data-v-88355c96]{align-self:flex-start!important}.align-self-sm-end[data-v-88355c96]{align-self:flex-end!important}.align-self-sm-center[data-v-88355c96]{align-self:center!important}.align-self-sm-baseline[data-v-88355c96]{align-self:baseline!important}.align-self-sm-stretch[data-v-88355c96]{align-self:stretch!important}.order-sm-first[data-v-88355c96]{order:-1!important}.order-sm-0[data-v-88355c96]{order:0!important}.order-sm-1[data-v-88355c96]{order:1!important}.order-sm-2[data-v-88355c96]{order:2!important}.order-sm-3[data-v-88355c96]{order:3!important}.order-sm-4[data-v-88355c96]{order:4!important}.order-sm-5[data-v-88355c96]{order:5!important}.order-sm-last[data-v-88355c96]{order:6!important}.m-sm-0[data-v-88355c96]{margin:0!important}.m-sm-1[data-v-88355c96]{margin:.25rem!important}.m-sm-2[data-v-88355c96]{margin:.5rem!important}.m-sm-3[data-v-88355c96]{margin:1rem!important}.m-sm-4[data-v-88355c96]{margin:1.5rem!important}.m-sm-5[data-v-88355c96]{margin:3rem!important}.m-sm-auto[data-v-88355c96]{margin:auto!important}.mx-sm-0[data-v-88355c96]{margin-right:0!important;margin-left:0!important}.mx-sm-1[data-v-88355c96]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-sm-2[data-v-88355c96]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-sm-3[data-v-88355c96]{margin-right:1rem!important;margin-left:1rem!important}.mx-sm-4[data-v-88355c96]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-sm-5[data-v-88355c96]{margin-right:3rem!important;margin-left:3rem!important}.mx-sm-auto[data-v-88355c96]{margin-right:auto!important;margin-left:auto!important}.my-sm-0[data-v-88355c96]{margin-top:0!important;margin-bottom:0!important}.my-sm-1[data-v-88355c96]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-sm-2[data-v-88355c96]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-sm-3[data-v-88355c96]{margin-top:1rem!important;margin-bottom:1rem!important}.my-sm-4[data-v-88355c96]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-sm-5[data-v-88355c96]{margin-top:3rem!important;margin-bottom:3rem!important}.my-sm-auto[data-v-88355c96]{margin-top:auto!important;margin-bottom:auto!important}.mt-sm-0[data-v-88355c96]{margin-top:0!important}.mt-sm-1[data-v-88355c96]{margin-top:.25rem!important}.mt-sm-2[data-v-88355c96]{margin-top:.5rem!important}.mt-sm-3[data-v-88355c96]{margin-top:1rem!important}.mt-sm-4[data-v-88355c96]{margin-top:1.5rem!important}.mt-sm-5[data-v-88355c96]{margin-top:3rem!important}.mt-sm-auto[data-v-88355c96]{margin-top:auto!important}.me-sm-0[data-v-88355c96]{margin-right:0!important}.me-sm-1[data-v-88355c96]{margin-right:.25rem!important}.me-sm-2[data-v-88355c96]{margin-right:.5rem!important}.me-sm-3[data-v-88355c96]{margin-right:1rem!important}.me-sm-4[data-v-88355c96]{margin-right:1.5rem!important}.me-sm-5[data-v-88355c96]{margin-right:3rem!important}.me-sm-auto[data-v-88355c96]{margin-right:auto!important}.mb-sm-0[data-v-88355c96]{margin-bottom:0!important}.mb-sm-1[data-v-88355c96]{margin-bottom:.25rem!important}.mb-sm-2[data-v-88355c96]{margin-bottom:.5rem!important}.mb-sm-3[data-v-88355c96]{margin-bottom:1rem!important}.mb-sm-4[data-v-88355c96]{margin-bottom:1.5rem!important}.mb-sm-5[data-v-88355c96]{margin-bottom:3rem!important}.mb-sm-auto[data-v-88355c96]{margin-bottom:auto!important}.ms-sm-0[data-v-88355c96]{margin-left:0!important}.ms-sm-1[data-v-88355c96]{margin-left:.25rem!important}.ms-sm-2[data-v-88355c96]{margin-left:.5rem!important}.ms-sm-3[data-v-88355c96]{margin-left:1rem!important}.ms-sm-4[data-v-88355c96]{margin-left:1.5rem!important}.ms-sm-5[data-v-88355c96]{margin-left:3rem!important}.ms-sm-auto[data-v-88355c96]{margin-left:auto!important}.p-sm-0[data-v-88355c96]{padding:0!important}.p-sm-1[data-v-88355c96]{padding:.25rem!important}.p-sm-2[data-v-88355c96]{padding:.5rem!important}.p-sm-3[data-v-88355c96]{padding:1rem!important}.p-sm-4[data-v-88355c96]{padding:1.5rem!important}.p-sm-5[data-v-88355c96]{padding:3rem!important}.px-sm-0[data-v-88355c96]{padding-right:0!important;padding-left:0!important}.px-sm-1[data-v-88355c96]{padding-right:.25rem!important;padding-left:.25rem!important}.px-sm-2[data-v-88355c96]{padding-right:.5rem!important;padding-left:.5rem!important}.px-sm-3[data-v-88355c96]{padding-right:1rem!important;padding-left:1rem!important}.px-sm-4[data-v-88355c96]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-sm-5[data-v-88355c96]{padding-right:3rem!important;padding-left:3rem!important}.py-sm-0[data-v-88355c96]{padding-top:0!important;padding-bottom:0!important}.py-sm-1[data-v-88355c96]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-sm-2[data-v-88355c96]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-sm-3[data-v-88355c96]{padding-top:1rem!important;padding-bottom:1rem!important}.py-sm-4[data-v-88355c96]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-sm-5[data-v-88355c96]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-sm-0[data-v-88355c96]{padding-top:0!important}.pt-sm-1[data-v-88355c96]{padding-top:.25rem!important}.pt-sm-2[data-v-88355c96]{padding-top:.5rem!important}.pt-sm-3[data-v-88355c96]{padding-top:1rem!important}.pt-sm-4[data-v-88355c96]{padding-top:1.5rem!important}.pt-sm-5[data-v-88355c96]{padding-top:3rem!important}.pe-sm-0[data-v-88355c96]{padding-right:0!important}.pe-sm-1[data-v-88355c96]{padding-right:.25rem!important}.pe-sm-2[data-v-88355c96]{padding-right:.5rem!important}.pe-sm-3[data-v-88355c96]{padding-right:1rem!important}.pe-sm-4[data-v-88355c96]{padding-right:1.5rem!important}.pe-sm-5[data-v-88355c96]{padding-right:3rem!important}.pb-sm-0[data-v-88355c96]{padding-bottom:0!important}.pb-sm-1[data-v-88355c96]{padding-bottom:.25rem!important}.pb-sm-2[data-v-88355c96]{padding-bottom:.5rem!important}.pb-sm-3[data-v-88355c96]{padding-bottom:1rem!important}.pb-sm-4[data-v-88355c96]{padding-bottom:1.5rem!important}.pb-sm-5[data-v-88355c96]{padding-bottom:3rem!important}.ps-sm-0[data-v-88355c96]{padding-left:0!important}.ps-sm-1[data-v-88355c96]{padding-left:.25rem!important}.ps-sm-2[data-v-88355c96]{padding-left:.5rem!important}.ps-sm-3[data-v-88355c96]{padding-left:1rem!important}.ps-sm-4[data-v-88355c96]{padding-left:1.5rem!important}.ps-sm-5[data-v-88355c96]{padding-left:3rem!important}.text-sm-start[data-v-88355c96]{text-align:left!important}.text-sm-end[data-v-88355c96]{text-align:right!important}.text-sm-center[data-v-88355c96]{text-align:center!important}}@media (min-width:768px){.float-md-start[data-v-88355c96]{float:left!important}.float-md-end[data-v-88355c96]{float:right!important}.float-md-none[data-v-88355c96]{float:none!important}.d-md-inline[data-v-88355c96]{display:inline!important}.d-md-inline-block[data-v-88355c96]{display:inline-block!important}.d-md-block[data-v-88355c96]{display:block!important}.d-md-grid[data-v-88355c96]{display:grid!important}.d-md-table[data-v-88355c96]{display:table!important}.d-md-table-row[data-v-88355c96]{display:table-row!important}.d-md-table-cell[data-v-88355c96]{display:table-cell!important}.d-md-flex[data-v-88355c96]{display:flex!important}.d-md-inline-flex[data-v-88355c96]{display:inline-flex!important}.d-md-none[data-v-88355c96]{display:none!important}.flex-md-fill[data-v-88355c96]{flex:1 1 auto!important}.flex-md-row[data-v-88355c96]{flex-direction:row!important}.flex-md-column[data-v-88355c96]{flex-direction:column!important}.flex-md-row-reverse[data-v-88355c96]{flex-direction:row-reverse!important}.flex-md-column-reverse[data-v-88355c96]{flex-direction:column-reverse!important}.flex-md-grow-0[data-v-88355c96]{flex-grow:0!important}.flex-md-grow-1[data-v-88355c96]{flex-grow:1!important}.flex-md-shrink-0[data-v-88355c96]{flex-shrink:0!important}.flex-md-shrink-1[data-v-88355c96]{flex-shrink:1!important}.flex-md-wrap[data-v-88355c96]{flex-wrap:wrap!important}.flex-md-nowrap[data-v-88355c96]{flex-wrap:nowrap!important}.flex-md-wrap-reverse[data-v-88355c96]{flex-wrap:wrap-reverse!important}.gap-md-0[data-v-88355c96]{gap:0!important}.gap-md-1[data-v-88355c96]{gap:.25rem!important}.gap-md-2[data-v-88355c96]{gap:.5rem!important}.gap-md-3[data-v-88355c96]{gap:1rem!important}.gap-md-4[data-v-88355c96]{gap:1.5rem!important}.gap-md-5[data-v-88355c96]{gap:3rem!important}.justify-content-md-start[data-v-88355c96]{justify-content:flex-start!important}.justify-content-md-end[data-v-88355c96]{justify-content:flex-end!important}.justify-content-md-center[data-v-88355c96]{justify-content:center!important}.justify-content-md-between[data-v-88355c96]{justify-content:space-between!important}.justify-content-md-around[data-v-88355c96]{justify-content:space-around!important}.justify-content-md-evenly[data-v-88355c96]{justify-content:space-evenly!important}.align-items-md-start[data-v-88355c96]{align-items:flex-start!important}.align-items-md-end[data-v-88355c96]{align-items:flex-end!important}.align-items-md-center[data-v-88355c96]{align-items:center!important}.align-items-md-baseline[data-v-88355c96]{align-items:baseline!important}.align-items-md-stretch[data-v-88355c96]{align-items:stretch!important}.align-content-md-start[data-v-88355c96]{align-content:flex-start!important}.align-content-md-end[data-v-88355c96]{align-content:flex-end!important}.align-content-md-center[data-v-88355c96]{align-content:center!important}.align-content-md-between[data-v-88355c96]{align-content:space-between!important}.align-content-md-around[data-v-88355c96]{align-content:space-around!important}.align-content-md-stretch[data-v-88355c96]{align-content:stretch!important}.align-self-md-auto[data-v-88355c96]{align-self:auto!important}.align-self-md-start[data-v-88355c96]{align-self:flex-start!important}.align-self-md-end[data-v-88355c96]{align-self:flex-end!important}.align-self-md-center[data-v-88355c96]{align-self:center!important}.align-self-md-baseline[data-v-88355c96]{align-self:baseline!important}.align-self-md-stretch[data-v-88355c96]{align-self:stretch!important}.order-md-first[data-v-88355c96]{order:-1!important}.order-md-0[data-v-88355c96]{order:0!important}.order-md-1[data-v-88355c96]{order:1!important}.order-md-2[data-v-88355c96]{order:2!important}.order-md-3[data-v-88355c96]{order:3!important}.order-md-4[data-v-88355c96]{order:4!important}.order-md-5[data-v-88355c96]{order:5!important}.order-md-last[data-v-88355c96]{order:6!important}.m-md-0[data-v-88355c96]{margin:0!important}.m-md-1[data-v-88355c96]{margin:.25rem!important}.m-md-2[data-v-88355c96]{margin:.5rem!important}.m-md-3[data-v-88355c96]{margin:1rem!important}.m-md-4[data-v-88355c96]{margin:1.5rem!important}.m-md-5[data-v-88355c96]{margin:3rem!important}.m-md-auto[data-v-88355c96]{margin:auto!important}.mx-md-0[data-v-88355c96]{margin-right:0!important;margin-left:0!important}.mx-md-1[data-v-88355c96]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-md-2[data-v-88355c96]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-md-3[data-v-88355c96]{margin-right:1rem!important;margin-left:1rem!important}.mx-md-4[data-v-88355c96]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-md-5[data-v-88355c96]{margin-right:3rem!important;margin-left:3rem!important}.mx-md-auto[data-v-88355c96]{margin-right:auto!important;margin-left:auto!important}.my-md-0[data-v-88355c96]{margin-top:0!important;margin-bottom:0!important}.my-md-1[data-v-88355c96]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-md-2[data-v-88355c96]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-md-3[data-v-88355c96]{margin-top:1rem!important;margin-bottom:1rem!important}.my-md-4[data-v-88355c96]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-md-5[data-v-88355c96]{margin-top:3rem!important;margin-bottom:3rem!important}.my-md-auto[data-v-88355c96]{margin-top:auto!important;margin-bottom:auto!important}.mt-md-0[data-v-88355c96]{margin-top:0!important}.mt-md-1[data-v-88355c96]{margin-top:.25rem!important}.mt-md-2[data-v-88355c96]{margin-top:.5rem!important}.mt-md-3[data-v-88355c96]{margin-top:1rem!important}.mt-md-4[data-v-88355c96]{margin-top:1.5rem!important}.mt-md-5[data-v-88355c96]{margin-top:3rem!important}.mt-md-auto[data-v-88355c96]{margin-top:auto!important}.me-md-0[data-v-88355c96]{margin-right:0!important}.me-md-1[data-v-88355c96]{margin-right:.25rem!important}.me-md-2[data-v-88355c96]{margin-right:.5rem!important}.me-md-3[data-v-88355c96]{margin-right:1rem!important}.me-md-4[data-v-88355c96]{margin-right:1.5rem!important}.me-md-5[data-v-88355c96]{margin-right:3rem!important}.me-md-auto[data-v-88355c96]{margin-right:auto!important}.mb-md-0[data-v-88355c96]{margin-bottom:0!important}.mb-md-1[data-v-88355c96]{margin-bottom:.25rem!important}.mb-md-2[data-v-88355c96]{margin-bottom:.5rem!important}.mb-md-3[data-v-88355c96]{margin-bottom:1rem!important}.mb-md-4[data-v-88355c96]{margin-bottom:1.5rem!important}.mb-md-5[data-v-88355c96]{margin-bottom:3rem!important}.mb-md-auto[data-v-88355c96]{margin-bottom:auto!important}.ms-md-0[data-v-88355c96]{margin-left:0!important}.ms-md-1[data-v-88355c96]{margin-left:.25rem!important}.ms-md-2[data-v-88355c96]{margin-left:.5rem!important}.ms-md-3[data-v-88355c96]{margin-left:1rem!important}.ms-md-4[data-v-88355c96]{margin-left:1.5rem!important}.ms-md-5[data-v-88355c96]{margin-left:3rem!important}.ms-md-auto[data-v-88355c96]{margin-left:auto!important}.p-md-0[data-v-88355c96]{padding:0!important}.p-md-1[data-v-88355c96]{padding:.25rem!important}.p-md-2[data-v-88355c96]{padding:.5rem!important}.p-md-3[data-v-88355c96]{padding:1rem!important}.p-md-4[data-v-88355c96]{padding:1.5rem!important}.p-md-5[data-v-88355c96]{padding:3rem!important}.px-md-0[data-v-88355c96]{padding-right:0!important;padding-left:0!important}.px-md-1[data-v-88355c96]{padding-right:.25rem!important;padding-left:.25rem!important}.px-md-2[data-v-88355c96]{padding-right:.5rem!important;padding-left:.5rem!important}.px-md-3[data-v-88355c96]{padding-right:1rem!important;padding-left:1rem!important}.px-md-4[data-v-88355c96]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-md-5[data-v-88355c96]{padding-right:3rem!important;padding-left:3rem!important}.py-md-0[data-v-88355c96]{padding-top:0!important;padding-bottom:0!important}.py-md-1[data-v-88355c96]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-md-2[data-v-88355c96]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-md-3[data-v-88355c96]{padding-top:1rem!important;padding-bottom:1rem!important}.py-md-4[data-v-88355c96]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-md-5[data-v-88355c96]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-md-0[data-v-88355c96]{padding-top:0!important}.pt-md-1[data-v-88355c96]{padding-top:.25rem!important}.pt-md-2[data-v-88355c96]{padding-top:.5rem!important}.pt-md-3[data-v-88355c96]{padding-top:1rem!important}.pt-md-4[data-v-88355c96]{padding-top:1.5rem!important}.pt-md-5[data-v-88355c96]{padding-top:3rem!important}.pe-md-0[data-v-88355c96]{padding-right:0!important}.pe-md-1[data-v-88355c96]{padding-right:.25rem!important}.pe-md-2[data-v-88355c96]{padding-right:.5rem!important}.pe-md-3[data-v-88355c96]{padding-right:1rem!important}.pe-md-4[data-v-88355c96]{padding-right:1.5rem!important}.pe-md-5[data-v-88355c96]{padding-right:3rem!important}.pb-md-0[data-v-88355c96]{padding-bottom:0!important}.pb-md-1[data-v-88355c96]{padding-bottom:.25rem!important}.pb-md-2[data-v-88355c96]{padding-bottom:.5rem!important}.pb-md-3[data-v-88355c96]{padding-bottom:1rem!important}.pb-md-4[data-v-88355c96]{padding-bottom:1.5rem!important}.pb-md-5[data-v-88355c96]{padding-bottom:3rem!important}.ps-md-0[data-v-88355c96]{padding-left:0!important}.ps-md-1[data-v-88355c96]{padding-left:.25rem!important}.ps-md-2[data-v-88355c96]{padding-left:.5rem!important}.ps-md-3[data-v-88355c96]{padding-left:1rem!important}.ps-md-4[data-v-88355c96]{padding-left:1.5rem!important}.ps-md-5[data-v-88355c96]{padding-left:3rem!important}.text-md-start[data-v-88355c96]{text-align:left!important}.text-md-end[data-v-88355c96]{text-align:right!important}.text-md-center[data-v-88355c96]{text-align:center!important}}@media (min-width:992px){.float-lg-start[data-v-88355c96]{float:left!important}.float-lg-end[data-v-88355c96]{float:right!important}.float-lg-none[data-v-88355c96]{float:none!important}.d-lg-inline[data-v-88355c96]{display:inline!important}.d-lg-inline-block[data-v-88355c96]{display:inline-block!important}.d-lg-block[data-v-88355c96]{display:block!important}.d-lg-grid[data-v-88355c96]{display:grid!important}.d-lg-table[data-v-88355c96]{display:table!important}.d-lg-table-row[data-v-88355c96]{display:table-row!important}.d-lg-table-cell[data-v-88355c96]{display:table-cell!important}.d-lg-flex[data-v-88355c96]{display:flex!important}.d-lg-inline-flex[data-v-88355c96]{display:inline-flex!important}.d-lg-none[data-v-88355c96]{display:none!important}.flex-lg-fill[data-v-88355c96]{flex:1 1 auto!important}.flex-lg-row[data-v-88355c96]{flex-direction:row!important}.flex-lg-column[data-v-88355c96]{flex-direction:column!important}.flex-lg-row-reverse[data-v-88355c96]{flex-direction:row-reverse!important}.flex-lg-column-reverse[data-v-88355c96]{flex-direction:column-reverse!important}.flex-lg-grow-0[data-v-88355c96]{flex-grow:0!important}.flex-lg-grow-1[data-v-88355c96]{flex-grow:1!important}.flex-lg-shrink-0[data-v-88355c96]{flex-shrink:0!important}.flex-lg-shrink-1[data-v-88355c96]{flex-shrink:1!important}.flex-lg-wrap[data-v-88355c96]{flex-wrap:wrap!important}.flex-lg-nowrap[data-v-88355c96]{flex-wrap:nowrap!important}.flex-lg-wrap-reverse[data-v-88355c96]{flex-wrap:wrap-reverse!important}.gap-lg-0[data-v-88355c96]{gap:0!important}.gap-lg-1[data-v-88355c96]{gap:.25rem!important}.gap-lg-2[data-v-88355c96]{gap:.5rem!important}.gap-lg-3[data-v-88355c96]{gap:1rem!important}.gap-lg-4[data-v-88355c96]{gap:1.5rem!important}.gap-lg-5[data-v-88355c96]{gap:3rem!important}.justify-content-lg-start[data-v-88355c96]{justify-content:flex-start!important}.justify-content-lg-end[data-v-88355c96]{justify-content:flex-end!important}.justify-content-lg-center[data-v-88355c96]{justify-content:center!important}.justify-content-lg-between[data-v-88355c96]{justify-content:space-between!important}.justify-content-lg-around[data-v-88355c96]{justify-content:space-around!important}.justify-content-lg-evenly[data-v-88355c96]{justify-content:space-evenly!important}.align-items-lg-start[data-v-88355c96]{align-items:flex-start!important}.align-items-lg-end[data-v-88355c96]{align-items:flex-end!important}.align-items-lg-center[data-v-88355c96]{align-items:center!important}.align-items-lg-baseline[data-v-88355c96]{align-items:baseline!important}.align-items-lg-stretch[data-v-88355c96]{align-items:stretch!important}.align-content-lg-start[data-v-88355c96]{align-content:flex-start!important}.align-content-lg-end[data-v-88355c96]{align-content:flex-end!important}.align-content-lg-center[data-v-88355c96]{align-content:center!important}.align-content-lg-between[data-v-88355c96]{align-content:space-between!important}.align-content-lg-around[data-v-88355c96]{align-content:space-around!important}.align-content-lg-stretch[data-v-88355c96]{align-content:stretch!important}.align-self-lg-auto[data-v-88355c96]{align-self:auto!important}.align-self-lg-start[data-v-88355c96]{align-self:flex-start!important}.align-self-lg-end[data-v-88355c96]{align-self:flex-end!important}.align-self-lg-center[data-v-88355c96]{align-self:center!important}.align-self-lg-baseline[data-v-88355c96]{align-self:baseline!important}.align-self-lg-stretch[data-v-88355c96]{align-self:stretch!important}.order-lg-first[data-v-88355c96]{order:-1!important}.order-lg-0[data-v-88355c96]{order:0!important}.order-lg-1[data-v-88355c96]{order:1!important}.order-lg-2[data-v-88355c96]{order:2!important}.order-lg-3[data-v-88355c96]{order:3!important}.order-lg-4[data-v-88355c96]{order:4!important}.order-lg-5[data-v-88355c96]{order:5!important}.order-lg-last[data-v-88355c96]{order:6!important}.m-lg-0[data-v-88355c96]{margin:0!important}.m-lg-1[data-v-88355c96]{margin:.25rem!important}.m-lg-2[data-v-88355c96]{margin:.5rem!important}.m-lg-3[data-v-88355c96]{margin:1rem!important}.m-lg-4[data-v-88355c96]{margin:1.5rem!important}.m-lg-5[data-v-88355c96]{margin:3rem!important}.m-lg-auto[data-v-88355c96]{margin:auto!important}.mx-lg-0[data-v-88355c96]{margin-right:0!important;margin-left:0!important}.mx-lg-1[data-v-88355c96]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-lg-2[data-v-88355c96]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-lg-3[data-v-88355c96]{margin-right:1rem!important;margin-left:1rem!important}.mx-lg-4[data-v-88355c96]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-lg-5[data-v-88355c96]{margin-right:3rem!important;margin-left:3rem!important}.mx-lg-auto[data-v-88355c96]{margin-right:auto!important;margin-left:auto!important}.my-lg-0[data-v-88355c96]{margin-top:0!important;margin-bottom:0!important}.my-lg-1[data-v-88355c96]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-lg-2[data-v-88355c96]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-lg-3[data-v-88355c96]{margin-top:1rem!important;margin-bottom:1rem!important}.my-lg-4[data-v-88355c96]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-lg-5[data-v-88355c96]{margin-top:3rem!important;margin-bottom:3rem!important}.my-lg-auto[data-v-88355c96]{margin-top:auto!important;margin-bottom:auto!important}.mt-lg-0[data-v-88355c96]{margin-top:0!important}.mt-lg-1[data-v-88355c96]{margin-top:.25rem!important}.mt-lg-2[data-v-88355c96]{margin-top:.5rem!important}.mt-lg-3[data-v-88355c96]{margin-top:1rem!important}.mt-lg-4[data-v-88355c96]{margin-top:1.5rem!important}.mt-lg-5[data-v-88355c96]{margin-top:3rem!important}.mt-lg-auto[data-v-88355c96]{margin-top:auto!important}.me-lg-0[data-v-88355c96]{margin-right:0!important}.me-lg-1[data-v-88355c96]{margin-right:.25rem!important}.me-lg-2[data-v-88355c96]{margin-right:.5rem!important}.me-lg-3[data-v-88355c96]{margin-right:1rem!important}.me-lg-4[data-v-88355c96]{margin-right:1.5rem!important}.me-lg-5[data-v-88355c96]{margin-right:3rem!important}.me-lg-auto[data-v-88355c96]{margin-right:auto!important}.mb-lg-0[data-v-88355c96]{margin-bottom:0!important}.mb-lg-1[data-v-88355c96]{margin-bottom:.25rem!important}.mb-lg-2[data-v-88355c96]{margin-bottom:.5rem!important}.mb-lg-3[data-v-88355c96]{margin-bottom:1rem!important}.mb-lg-4[data-v-88355c96]{margin-bottom:1.5rem!important}.mb-lg-5[data-v-88355c96]{margin-bottom:3rem!important}.mb-lg-auto[data-v-88355c96]{margin-bottom:auto!important}.ms-lg-0[data-v-88355c96]{margin-left:0!important}.ms-lg-1[data-v-88355c96]{margin-left:.25rem!important}.ms-lg-2[data-v-88355c96]{margin-left:.5rem!important}.ms-lg-3[data-v-88355c96]{margin-left:1rem!important}.ms-lg-4[data-v-88355c96]{margin-left:1.5rem!important}.ms-lg-5[data-v-88355c96]{margin-left:3rem!important}.ms-lg-auto[data-v-88355c96]{margin-left:auto!important}.p-lg-0[data-v-88355c96]{padding:0!important}.p-lg-1[data-v-88355c96]{padding:.25rem!important}.p-lg-2[data-v-88355c96]{padding:.5rem!important}.p-lg-3[data-v-88355c96]{padding:1rem!important}.p-lg-4[data-v-88355c96]{padding:1.5rem!important}.p-lg-5[data-v-88355c96]{padding:3rem!important}.px-lg-0[data-v-88355c96]{padding-right:0!important;padding-left:0!important}.px-lg-1[data-v-88355c96]{padding-right:.25rem!important;padding-left:.25rem!important}.px-lg-2[data-v-88355c96]{padding-right:.5rem!important;padding-left:.5rem!important}.px-lg-3[data-v-88355c96]{padding-right:1rem!important;padding-left:1rem!important}.px-lg-4[data-v-88355c96]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-lg-5[data-v-88355c96]{padding-right:3rem!important;padding-left:3rem!important}.py-lg-0[data-v-88355c96]{padding-top:0!important;padding-bottom:0!important}.py-lg-1[data-v-88355c96]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-lg-2[data-v-88355c96]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-lg-3[data-v-88355c96]{padding-top:1rem!important;padding-bottom:1rem!important}.py-lg-4[data-v-88355c96]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-lg-5[data-v-88355c96]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-lg-0[data-v-88355c96]{padding-top:0!important}.pt-lg-1[data-v-88355c96]{padding-top:.25rem!important}.pt-lg-2[data-v-88355c96]{padding-top:.5rem!important}.pt-lg-3[data-v-88355c96]{padding-top:1rem!important}.pt-lg-4[data-v-88355c96]{padding-top:1.5rem!important}.pt-lg-5[data-v-88355c96]{padding-top:3rem!important}.pe-lg-0[data-v-88355c96]{padding-right:0!important}.pe-lg-1[data-v-88355c96]{padding-right:.25rem!important}.pe-lg-2[data-v-88355c96]{padding-right:.5rem!important}.pe-lg-3[data-v-88355c96]{padding-right:1rem!important}.pe-lg-4[data-v-88355c96]{padding-right:1.5rem!important}.pe-lg-5[data-v-88355c96]{padding-right:3rem!important}.pb-lg-0[data-v-88355c96]{padding-bottom:0!important}.pb-lg-1[data-v-88355c96]{padding-bottom:.25rem!important}.pb-lg-2[data-v-88355c96]{padding-bottom:.5rem!important}.pb-lg-3[data-v-88355c96]{padding-bottom:1rem!important}.pb-lg-4[data-v-88355c96]{padding-bottom:1.5rem!important}.pb-lg-5[data-v-88355c96]{padding-bottom:3rem!important}.ps-lg-0[data-v-88355c96]{padding-left:0!important}.ps-lg-1[data-v-88355c96]{padding-left:.25rem!important}.ps-lg-2[data-v-88355c96]{padding-left:.5rem!important}.ps-lg-3[data-v-88355c96]{padding-left:1rem!important}.ps-lg-4[data-v-88355c96]{padding-left:1.5rem!important}.ps-lg-5[data-v-88355c96]{padding-left:3rem!important}.text-lg-start[data-v-88355c96]{text-align:left!important}.text-lg-end[data-v-88355c96]{text-align:right!important}.text-lg-center[data-v-88355c96]{text-align:center!important}}@media (min-width:1200px){.float-xl-start[data-v-88355c96]{float:left!important}.float-xl-end[data-v-88355c96]{float:right!important}.float-xl-none[data-v-88355c96]{float:none!important}.d-xl-inline[data-v-88355c96]{display:inline!important}.d-xl-inline-block[data-v-88355c96]{display:inline-block!important}.d-xl-block[data-v-88355c96]{display:block!important}.d-xl-grid[data-v-88355c96]{display:grid!important}.d-xl-table[data-v-88355c96]{display:table!important}.d-xl-table-row[data-v-88355c96]{display:table-row!important}.d-xl-table-cell[data-v-88355c96]{display:table-cell!important}.d-xl-flex[data-v-88355c96]{display:flex!important}.d-xl-inline-flex[data-v-88355c96]{display:inline-flex!important}.d-xl-none[data-v-88355c96]{display:none!important}.flex-xl-fill[data-v-88355c96]{flex:1 1 auto!important}.flex-xl-row[data-v-88355c96]{flex-direction:row!important}.flex-xl-column[data-v-88355c96]{flex-direction:column!important}.flex-xl-row-reverse[data-v-88355c96]{flex-direction:row-reverse!important}.flex-xl-column-reverse[data-v-88355c96]{flex-direction:column-reverse!important}.flex-xl-grow-0[data-v-88355c96]{flex-grow:0!important}.flex-xl-grow-1[data-v-88355c96]{flex-grow:1!important}.flex-xl-shrink-0[data-v-88355c96]{flex-shrink:0!important}.flex-xl-shrink-1[data-v-88355c96]{flex-shrink:1!important}.flex-xl-wrap[data-v-88355c96]{flex-wrap:wrap!important}.flex-xl-nowrap[data-v-88355c96]{flex-wrap:nowrap!important}.flex-xl-wrap-reverse[data-v-88355c96]{flex-wrap:wrap-reverse!important}.gap-xl-0[data-v-88355c96]{gap:0!important}.gap-xl-1[data-v-88355c96]{gap:.25rem!important}.gap-xl-2[data-v-88355c96]{gap:.5rem!important}.gap-xl-3[data-v-88355c96]{gap:1rem!important}.gap-xl-4[data-v-88355c96]{gap:1.5rem!important}.gap-xl-5[data-v-88355c96]{gap:3rem!important}.justify-content-xl-start[data-v-88355c96]{justify-content:flex-start!important}.justify-content-xl-end[data-v-88355c96]{justify-content:flex-end!important}.justify-content-xl-center[data-v-88355c96]{justify-content:center!important}.justify-content-xl-between[data-v-88355c96]{justify-content:space-between!important}.justify-content-xl-around[data-v-88355c96]{justify-content:space-around!important}.justify-content-xl-evenly[data-v-88355c96]{justify-content:space-evenly!important}.align-items-xl-start[data-v-88355c96]{align-items:flex-start!important}.align-items-xl-end[data-v-88355c96]{align-items:flex-end!important}.align-items-xl-center[data-v-88355c96]{align-items:center!important}.align-items-xl-baseline[data-v-88355c96]{align-items:baseline!important}.align-items-xl-stretch[data-v-88355c96]{align-items:stretch!important}.align-content-xl-start[data-v-88355c96]{align-content:flex-start!important}.align-content-xl-end[data-v-88355c96]{align-content:flex-end!important}.align-content-xl-center[data-v-88355c96]{align-content:center!important}.align-content-xl-between[data-v-88355c96]{align-content:space-between!important}.align-content-xl-around[data-v-88355c96]{align-content:space-around!important}.align-content-xl-stretch[data-v-88355c96]{align-content:stretch!important}.align-self-xl-auto[data-v-88355c96]{align-self:auto!important}.align-self-xl-start[data-v-88355c96]{align-self:flex-start!important}.align-self-xl-end[data-v-88355c96]{align-self:flex-end!important}.align-self-xl-center[data-v-88355c96]{align-self:center!important}.align-self-xl-baseline[data-v-88355c96]{align-self:baseline!important}.align-self-xl-stretch[data-v-88355c96]{align-self:stretch!important}.order-xl-first[data-v-88355c96]{order:-1!important}.order-xl-0[data-v-88355c96]{order:0!important}.order-xl-1[data-v-88355c96]{order:1!important}.order-xl-2[data-v-88355c96]{order:2!important}.order-xl-3[data-v-88355c96]{order:3!important}.order-xl-4[data-v-88355c96]{order:4!important}.order-xl-5[data-v-88355c96]{order:5!important}.order-xl-last[data-v-88355c96]{order:6!important}.m-xl-0[data-v-88355c96]{margin:0!important}.m-xl-1[data-v-88355c96]{margin:.25rem!important}.m-xl-2[data-v-88355c96]{margin:.5rem!important}.m-xl-3[data-v-88355c96]{margin:1rem!important}.m-xl-4[data-v-88355c96]{margin:1.5rem!important}.m-xl-5[data-v-88355c96]{margin:3rem!important}.m-xl-auto[data-v-88355c96]{margin:auto!important}.mx-xl-0[data-v-88355c96]{margin-right:0!important;margin-left:0!important}.mx-xl-1[data-v-88355c96]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xl-2[data-v-88355c96]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xl-3[data-v-88355c96]{margin-right:1rem!important;margin-left:1rem!important}.mx-xl-4[data-v-88355c96]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xl-5[data-v-88355c96]{margin-right:3rem!important;margin-left:3rem!important}.mx-xl-auto[data-v-88355c96]{margin-right:auto!important;margin-left:auto!important}.my-xl-0[data-v-88355c96]{margin-top:0!important;margin-bottom:0!important}.my-xl-1[data-v-88355c96]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xl-2[data-v-88355c96]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xl-3[data-v-88355c96]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xl-4[data-v-88355c96]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xl-5[data-v-88355c96]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xl-auto[data-v-88355c96]{margin-top:auto!important;margin-bottom:auto!important}.mt-xl-0[data-v-88355c96]{margin-top:0!important}.mt-xl-1[data-v-88355c96]{margin-top:.25rem!important}.mt-xl-2[data-v-88355c96]{margin-top:.5rem!important}.mt-xl-3[data-v-88355c96]{margin-top:1rem!important}.mt-xl-4[data-v-88355c96]{margin-top:1.5rem!important}.mt-xl-5[data-v-88355c96]{margin-top:3rem!important}.mt-xl-auto[data-v-88355c96]{margin-top:auto!important}.me-xl-0[data-v-88355c96]{margin-right:0!important}.me-xl-1[data-v-88355c96]{margin-right:.25rem!important}.me-xl-2[data-v-88355c96]{margin-right:.5rem!important}.me-xl-3[data-v-88355c96]{margin-right:1rem!important}.me-xl-4[data-v-88355c96]{margin-right:1.5rem!important}.me-xl-5[data-v-88355c96]{margin-right:3rem!important}.me-xl-auto[data-v-88355c96]{margin-right:auto!important}.mb-xl-0[data-v-88355c96]{margin-bottom:0!important}.mb-xl-1[data-v-88355c96]{margin-bottom:.25rem!important}.mb-xl-2[data-v-88355c96]{margin-bottom:.5rem!important}.mb-xl-3[data-v-88355c96]{margin-bottom:1rem!important}.mb-xl-4[data-v-88355c96]{margin-bottom:1.5rem!important}.mb-xl-5[data-v-88355c96]{margin-bottom:3rem!important}.mb-xl-auto[data-v-88355c96]{margin-bottom:auto!important}.ms-xl-0[data-v-88355c96]{margin-left:0!important}.ms-xl-1[data-v-88355c96]{margin-left:.25rem!important}.ms-xl-2[data-v-88355c96]{margin-left:.5rem!important}.ms-xl-3[data-v-88355c96]{margin-left:1rem!important}.ms-xl-4[data-v-88355c96]{margin-left:1.5rem!important}.ms-xl-5[data-v-88355c96]{margin-left:3rem!important}.ms-xl-auto[data-v-88355c96]{margin-left:auto!important}.p-xl-0[data-v-88355c96]{padding:0!important}.p-xl-1[data-v-88355c96]{padding:.25rem!important}.p-xl-2[data-v-88355c96]{padding:.5rem!important}.p-xl-3[data-v-88355c96]{padding:1rem!important}.p-xl-4[data-v-88355c96]{padding:1.5rem!important}.p-xl-5[data-v-88355c96]{padding:3rem!important}.px-xl-0[data-v-88355c96]{padding-right:0!important;padding-left:0!important}.px-xl-1[data-v-88355c96]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xl-2[data-v-88355c96]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xl-3[data-v-88355c96]{padding-right:1rem!important;padding-left:1rem!important}.px-xl-4[data-v-88355c96]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xl-5[data-v-88355c96]{padding-right:3rem!important;padding-left:3rem!important}.py-xl-0[data-v-88355c96]{padding-top:0!important;padding-bottom:0!important}.py-xl-1[data-v-88355c96]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xl-2[data-v-88355c96]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xl-3[data-v-88355c96]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xl-4[data-v-88355c96]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xl-5[data-v-88355c96]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xl-0[data-v-88355c96]{padding-top:0!important}.pt-xl-1[data-v-88355c96]{padding-top:.25rem!important}.pt-xl-2[data-v-88355c96]{padding-top:.5rem!important}.pt-xl-3[data-v-88355c96]{padding-top:1rem!important}.pt-xl-4[data-v-88355c96]{padding-top:1.5rem!important}.pt-xl-5[data-v-88355c96]{padding-top:3rem!important}.pe-xl-0[data-v-88355c96]{padding-right:0!important}.pe-xl-1[data-v-88355c96]{padding-right:.25rem!important}.pe-xl-2[data-v-88355c96]{padding-right:.5rem!important}.pe-xl-3[data-v-88355c96]{padding-right:1rem!important}.pe-xl-4[data-v-88355c96]{padding-right:1.5rem!important}.pe-xl-5[data-v-88355c96]{padding-right:3rem!important}.pb-xl-0[data-v-88355c96]{padding-bottom:0!important}.pb-xl-1[data-v-88355c96]{padding-bottom:.25rem!important}.pb-xl-2[data-v-88355c96]{padding-bottom:.5rem!important}.pb-xl-3[data-v-88355c96]{padding-bottom:1rem!important}.pb-xl-4[data-v-88355c96]{padding-bottom:1.5rem!important}.pb-xl-5[data-v-88355c96]{padding-bottom:3rem!important}.ps-xl-0[data-v-88355c96]{padding-left:0!important}.ps-xl-1[data-v-88355c96]{padding-left:.25rem!important}.ps-xl-2[data-v-88355c96]{padding-left:.5rem!important}.ps-xl-3[data-v-88355c96]{padding-left:1rem!important}.ps-xl-4[data-v-88355c96]{padding-left:1.5rem!important}.ps-xl-5[data-v-88355c96]{padding-left:3rem!important}.text-xl-start[data-v-88355c96]{text-align:left!important}.text-xl-end[data-v-88355c96]{text-align:right!important}.text-xl-center[data-v-88355c96]{text-align:center!important}}@media (min-width:1400px){.float-xxl-start[data-v-88355c96]{float:left!important}.float-xxl-end[data-v-88355c96]{float:right!important}.float-xxl-none[data-v-88355c96]{float:none!important}.d-xxl-inline[data-v-88355c96]{display:inline!important}.d-xxl-inline-block[data-v-88355c96]{display:inline-block!important}.d-xxl-block[data-v-88355c96]{display:block!important}.d-xxl-grid[data-v-88355c96]{display:grid!important}.d-xxl-table[data-v-88355c96]{display:table!important}.d-xxl-table-row[data-v-88355c96]{display:table-row!important}.d-xxl-table-cell[data-v-88355c96]{display:table-cell!important}.d-xxl-flex[data-v-88355c96]{display:flex!important}.d-xxl-inline-flex[data-v-88355c96]{display:inline-flex!important}.d-xxl-none[data-v-88355c96]{display:none!important}.flex-xxl-fill[data-v-88355c96]{flex:1 1 auto!important}.flex-xxl-row[data-v-88355c96]{flex-direction:row!important}.flex-xxl-column[data-v-88355c96]{flex-direction:column!important}.flex-xxl-row-reverse[data-v-88355c96]{flex-direction:row-reverse!important}.flex-xxl-column-reverse[data-v-88355c96]{flex-direction:column-reverse!important}.flex-xxl-grow-0[data-v-88355c96]{flex-grow:0!important}.flex-xxl-grow-1[data-v-88355c96]{flex-grow:1!important}.flex-xxl-shrink-0[data-v-88355c96]{flex-shrink:0!important}.flex-xxl-shrink-1[data-v-88355c96]{flex-shrink:1!important}.flex-xxl-wrap[data-v-88355c96]{flex-wrap:wrap!important}.flex-xxl-nowrap[data-v-88355c96]{flex-wrap:nowrap!important}.flex-xxl-wrap-reverse[data-v-88355c96]{flex-wrap:wrap-reverse!important}.gap-xxl-0[data-v-88355c96]{gap:0!important}.gap-xxl-1[data-v-88355c96]{gap:.25rem!important}.gap-xxl-2[data-v-88355c96]{gap:.5rem!important}.gap-xxl-3[data-v-88355c96]{gap:1rem!important}.gap-xxl-4[data-v-88355c96]{gap:1.5rem!important}.gap-xxl-5[data-v-88355c96]{gap:3rem!important}.justify-content-xxl-start[data-v-88355c96]{justify-content:flex-start!important}.justify-content-xxl-end[data-v-88355c96]{justify-content:flex-end!important}.justify-content-xxl-center[data-v-88355c96]{justify-content:center!important}.justify-content-xxl-between[data-v-88355c96]{justify-content:space-between!important}.justify-content-xxl-around[data-v-88355c96]{justify-content:space-around!important}.justify-content-xxl-evenly[data-v-88355c96]{justify-content:space-evenly!important}.align-items-xxl-start[data-v-88355c96]{align-items:flex-start!important}.align-items-xxl-end[data-v-88355c96]{align-items:flex-end!important}.align-items-xxl-center[data-v-88355c96]{align-items:center!important}.align-items-xxl-baseline[data-v-88355c96]{align-items:baseline!important}.align-items-xxl-stretch[data-v-88355c96]{align-items:stretch!important}.align-content-xxl-start[data-v-88355c96]{align-content:flex-start!important}.align-content-xxl-end[data-v-88355c96]{align-content:flex-end!important}.align-content-xxl-center[data-v-88355c96]{align-content:center!important}.align-content-xxl-between[data-v-88355c96]{align-content:space-between!important}.align-content-xxl-around[data-v-88355c96]{align-content:space-around!important}.align-content-xxl-stretch[data-v-88355c96]{align-content:stretch!important}.align-self-xxl-auto[data-v-88355c96]{align-self:auto!important}.align-self-xxl-start[data-v-88355c96]{align-self:flex-start!important}.align-self-xxl-end[data-v-88355c96]{align-self:flex-end!important}.align-self-xxl-center[data-v-88355c96]{align-self:center!important}.align-self-xxl-baseline[data-v-88355c96]{align-self:baseline!important}.align-self-xxl-stretch[data-v-88355c96]{align-self:stretch!important}.order-xxl-first[data-v-88355c96]{order:-1!important}.order-xxl-0[data-v-88355c96]{order:0!important}.order-xxl-1[data-v-88355c96]{order:1!important}.order-xxl-2[data-v-88355c96]{order:2!important}.order-xxl-3[data-v-88355c96]{order:3!important}.order-xxl-4[data-v-88355c96]{order:4!important}.order-xxl-5[data-v-88355c96]{order:5!important}.order-xxl-last[data-v-88355c96]{order:6!important}.m-xxl-0[data-v-88355c96]{margin:0!important}.m-xxl-1[data-v-88355c96]{margin:.25rem!important}.m-xxl-2[data-v-88355c96]{margin:.5rem!important}.m-xxl-3[data-v-88355c96]{margin:1rem!important}.m-xxl-4[data-v-88355c96]{margin:1.5rem!important}.m-xxl-5[data-v-88355c96]{margin:3rem!important}.m-xxl-auto[data-v-88355c96]{margin:auto!important}.mx-xxl-0[data-v-88355c96]{margin-right:0!important;margin-left:0!important}.mx-xxl-1[data-v-88355c96]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xxl-2[data-v-88355c96]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xxl-3[data-v-88355c96]{margin-right:1rem!important;margin-left:1rem!important}.mx-xxl-4[data-v-88355c96]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xxl-5[data-v-88355c96]{margin-right:3rem!important;margin-left:3rem!important}.mx-xxl-auto[data-v-88355c96]{margin-right:auto!important;margin-left:auto!important}.my-xxl-0[data-v-88355c96]{margin-top:0!important;margin-bottom:0!important}.my-xxl-1[data-v-88355c96]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xxl-2[data-v-88355c96]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xxl-3[data-v-88355c96]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xxl-4[data-v-88355c96]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xxl-5[data-v-88355c96]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xxl-auto[data-v-88355c96]{margin-top:auto!important;margin-bottom:auto!important}.mt-xxl-0[data-v-88355c96]{margin-top:0!important}.mt-xxl-1[data-v-88355c96]{margin-top:.25rem!important}.mt-xxl-2[data-v-88355c96]{margin-top:.5rem!important}.mt-xxl-3[data-v-88355c96]{margin-top:1rem!important}.mt-xxl-4[data-v-88355c96]{margin-top:1.5rem!important}.mt-xxl-5[data-v-88355c96]{margin-top:3rem!important}.mt-xxl-auto[data-v-88355c96]{margin-top:auto!important}.me-xxl-0[data-v-88355c96]{margin-right:0!important}.me-xxl-1[data-v-88355c96]{margin-right:.25rem!important}.me-xxl-2[data-v-88355c96]{margin-right:.5rem!important}.me-xxl-3[data-v-88355c96]{margin-right:1rem!important}.me-xxl-4[data-v-88355c96]{margin-right:1.5rem!important}.me-xxl-5[data-v-88355c96]{margin-right:3rem!important}.me-xxl-auto[data-v-88355c96]{margin-right:auto!important}.mb-xxl-0[data-v-88355c96]{margin-bottom:0!important}.mb-xxl-1[data-v-88355c96]{margin-bottom:.25rem!important}.mb-xxl-2[data-v-88355c96]{margin-bottom:.5rem!important}.mb-xxl-3[data-v-88355c96]{margin-bottom:1rem!important}.mb-xxl-4[data-v-88355c96]{margin-bottom:1.5rem!important}.mb-xxl-5[data-v-88355c96]{margin-bottom:3rem!important}.mb-xxl-auto[data-v-88355c96]{margin-bottom:auto!important}.ms-xxl-0[data-v-88355c96]{margin-left:0!important}.ms-xxl-1[data-v-88355c96]{margin-left:.25rem!important}.ms-xxl-2[data-v-88355c96]{margin-left:.5rem!important}.ms-xxl-3[data-v-88355c96]{margin-left:1rem!important}.ms-xxl-4[data-v-88355c96]{margin-left:1.5rem!important}.ms-xxl-5[data-v-88355c96]{margin-left:3rem!important}.ms-xxl-auto[data-v-88355c96]{margin-left:auto!important}.p-xxl-0[data-v-88355c96]{padding:0!important}.p-xxl-1[data-v-88355c96]{padding:.25rem!important}.p-xxl-2[data-v-88355c96]{padding:.5rem!important}.p-xxl-3[data-v-88355c96]{padding:1rem!important}.p-xxl-4[data-v-88355c96]{padding:1.5rem!important}.p-xxl-5[data-v-88355c96]{padding:3rem!important}.px-xxl-0[data-v-88355c96]{padding-right:0!important;padding-left:0!important}.px-xxl-1[data-v-88355c96]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xxl-2[data-v-88355c96]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xxl-3[data-v-88355c96]{padding-right:1rem!important;padding-left:1rem!important}.px-xxl-4[data-v-88355c96]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xxl-5[data-v-88355c96]{padding-right:3rem!important;padding-left:3rem!important}.py-xxl-0[data-v-88355c96]{padding-top:0!important;padding-bottom:0!important}.py-xxl-1[data-v-88355c96]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xxl-2[data-v-88355c96]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xxl-3[data-v-88355c96]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xxl-4[data-v-88355c96]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xxl-5[data-v-88355c96]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xxl-0[data-v-88355c96]{padding-top:0!important}.pt-xxl-1[data-v-88355c96]{padding-top:.25rem!important}.pt-xxl-2[data-v-88355c96]{padding-top:.5rem!important}.pt-xxl-3[data-v-88355c96]{padding-top:1rem!important}.pt-xxl-4[data-v-88355c96]{padding-top:1.5rem!important}.pt-xxl-5[data-v-88355c96]{padding-top:3rem!important}.pe-xxl-0[data-v-88355c96]{padding-right:0!important}.pe-xxl-1[data-v-88355c96]{padding-right:.25rem!important}.pe-xxl-2[data-v-88355c96]{padding-right:.5rem!important}.pe-xxl-3[data-v-88355c96]{padding-right:1rem!important}.pe-xxl-4[data-v-88355c96]{padding-right:1.5rem!important}.pe-xxl-5[data-v-88355c96]{padding-right:3rem!important}.pb-xxl-0[data-v-88355c96]{padding-bottom:0!important}.pb-xxl-1[data-v-88355c96]{padding-bottom:.25rem!important}.pb-xxl-2[data-v-88355c96]{padding-bottom:.5rem!important}.pb-xxl-3[data-v-88355c96]{padding-bottom:1rem!important}.pb-xxl-4[data-v-88355c96]{padding-bottom:1.5rem!important}.pb-xxl-5[data-v-88355c96]{padding-bottom:3rem!important}.ps-xxl-0[data-v-88355c96]{padding-left:0!important}.ps-xxl-1[data-v-88355c96]{padding-left:.25rem!important}.ps-xxl-2[data-v-88355c96]{padding-left:.5rem!important}.ps-xxl-3[data-v-88355c96]{padding-left:1rem!important}.ps-xxl-4[data-v-88355c96]{padding-left:1.5rem!important}.ps-xxl-5[data-v-88355c96]{padding-left:3rem!important}.text-xxl-start[data-v-88355c96]{text-align:left!important}.text-xxl-end[data-v-88355c96]{text-align:right!important}.text-xxl-center[data-v-88355c96]{text-align:center!important}}@media (min-width:1200px){.fs-1[data-v-88355c96]{font-size:2.5rem!important}.fs-2[data-v-88355c96]{font-size:2rem!important}.fs-3[data-v-88355c96]{font-size:1.75rem!important}.fs-4[data-v-88355c96]{font-size:1.5rem!important}}@media print{.d-print-inline[data-v-88355c96]{display:inline!important}.d-print-inline-block[data-v-88355c96]{display:inline-block!important}.d-print-block[data-v-88355c96]{display:block!important}.d-print-grid[data-v-88355c96]{display:grid!important}.d-print-table[data-v-88355c96]{display:table!important}.d-print-table-row[data-v-88355c96]{display:table-row!important}.d-print-table-cell[data-v-88355c96]{display:table-cell!important}.d-print-flex[data-v-88355c96]{display:flex!important}.d-print-inline-flex[data-v-88355c96]{display:inline-flex!important}.d-print-none[data-v-88355c96]{display:none!important}}", ""]);

// exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(152);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5dc0ef48", content, true, {});

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".indented[data-v-88355c96]{margin:20px;max-width:550px}.spacer[data-v-88355c96]{height:15px;border:0 solid #000}.spaced[data-v-88355c96]{margin-bottom:10px}.button[data-v-88355c96]{border:1px solid gray}", ""]);

// exports


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indented"},[_c('form',{ref:"formHTML",on:{"submit":function($event){$event.preventDefault();return _vm.submitForm.apply(null, arguments)}}},[_c('h3',[_vm._v("Add subcategory")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-horizontal"},[_c('h5',[_vm._v("Enter subcategory you want to add to parent category '"+_vm._s(_vm.parentcategory)+"':")]),_vm._v(" "),_c('div',{staticClass:"spacer"}),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[_vm._v("\n        Subcategory name:\n        "),_c('div',{staticClass:"spacer"}),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subcatname),expression:"subcatname"}],staticClass:"form-control",attrs:{"type":"text","name":"subcatname","required":""},domProps:{"value":(_vm.subcatname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subcatname=$event.target.value}}})])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{attrs:{"id":"url"}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-10"},[_c('input',{staticClass:"button btn btn-default",attrs:{"type":"submit","value":"Add"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(155);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("09cbcd6e", content, true, {});

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n/*!\n * Bootstrap v5.1.3 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */[data-v-804d79b6]:root{--bs-blue:#0d6efd;--bs-indigo:#6610f2;--bs-purple:#6f42c1;--bs-pink:#d63384;--bs-red:#dc3545;--bs-orange:#fd7e14;--bs-yellow:#ffc107;--bs-green:#198754;--bs-teal:#20c997;--bs-cyan:#0dcaf0;--bs-white:#fff;--bs-gray:#6c757d;--bs-gray-dark:#343a40;--bs-gray-100:#f8f9fa;--bs-gray-200:#e9ecef;--bs-gray-300:#dee2e6;--bs-gray-400:#ced4da;--bs-gray-500:#adb5bd;--bs-gray-600:#6c757d;--bs-gray-700:#495057;--bs-gray-800:#343a40;--bs-gray-900:#212529;--bs-primary:#0d6efd;--bs-secondary:#6c757d;--bs-success:#198754;--bs-info:#0dcaf0;--bs-warning:#ffc107;--bs-danger:#dc3545;--bs-light:#f8f9fa;--bs-dark:#212529;--bs-primary-rgb:13,110,253;--bs-secondary-rgb:108,117,125;--bs-success-rgb:25,135,84;--bs-info-rgb:13,202,240;--bs-warning-rgb:255,193,7;--bs-danger-rgb:220,53,69;--bs-light-rgb:248,249,250;--bs-dark-rgb:33,37,41;--bs-white-rgb:255,255,255;--bs-black-rgb:0,0,0;--bs-body-color-rgb:33,37,41;--bs-body-bg-rgb:255,255,255;--bs-font-sans-serif:system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--bs-font-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;--bs-gradient:linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));--bs-body-font-family:var(--bs-font-sans-serif);--bs-body-font-size:1rem;--bs-body-font-weight:400;--bs-body-line-height:1.5;--bs-body-color:#212529;--bs-body-bg:#fff}[data-v-804d79b6],[data-v-804d79b6]:after,[data-v-804d79b6]:before{box-sizing:border-box}@media (prefers-reduced-motion:no-preference){[data-v-804d79b6]:root{scroll-behavior:smooth}}body[data-v-804d79b6]{margin:0;font-family:var(--bs-body-font-family);font-size:var(--bs-body-font-size);font-weight:var(--bs-body-font-weight);line-height:var(--bs-body-line-height);color:var(--bs-body-color);text-align:var(--bs-body-text-align);background-color:var(--bs-body-bg);-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}hr[data-v-804d79b6]{margin:1rem 0;color:inherit;background-color:currentColor;border:0;opacity:.25}hr[data-v-804d79b6]:not([size]){height:1px}.h1[data-v-804d79b6],.h2[data-v-804d79b6],.h3[data-v-804d79b6],.h4[data-v-804d79b6],.h5[data-v-804d79b6],.h6[data-v-804d79b6],h1[data-v-804d79b6],h2[data-v-804d79b6],h3[data-v-804d79b6],h4[data-v-804d79b6],h5[data-v-804d79b6],h6[data-v-804d79b6]{margin-top:0;margin-bottom:.5rem;font-weight:500;line-height:1.2}.h1[data-v-804d79b6],h1[data-v-804d79b6]{font-size:calc(1.375rem + 1.5vw)}@media (min-width:1200px){.h1[data-v-804d79b6],h1[data-v-804d79b6]{font-size:2.5rem}}.h2[data-v-804d79b6],h2[data-v-804d79b6]{font-size:calc(1.325rem + .9vw)}@media (min-width:1200px){.h2[data-v-804d79b6],h2[data-v-804d79b6]{font-size:2rem}}.h3[data-v-804d79b6],h3[data-v-804d79b6]{font-size:calc(1.3rem + .6vw)}@media (min-width:1200px){.h3[data-v-804d79b6],h3[data-v-804d79b6]{font-size:1.75rem}}.h4[data-v-804d79b6],h4[data-v-804d79b6]{font-size:calc(1.275rem + .3vw)}@media (min-width:1200px){.h4[data-v-804d79b6],h4[data-v-804d79b6]{font-size:1.5rem}}.h5[data-v-804d79b6],h5[data-v-804d79b6]{font-size:1.25rem}.h6[data-v-804d79b6],h6[data-v-804d79b6]{font-size:1rem}p[data-v-804d79b6]{margin-top:0;margin-bottom:1rem}abbr[data-bs-original-title][data-v-804d79b6],abbr[title][data-v-804d79b6]{-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address[data-v-804d79b6]{margin-bottom:1rem;font-style:normal;line-height:inherit}ol[data-v-804d79b6],ul[data-v-804d79b6]{padding-left:2rem}dl[data-v-804d79b6],ol[data-v-804d79b6],ul[data-v-804d79b6]{margin-top:0;margin-bottom:1rem}ol ol[data-v-804d79b6],ol ul[data-v-804d79b6],ul ol[data-v-804d79b6],ul ul[data-v-804d79b6]{margin-bottom:0}dt[data-v-804d79b6]{font-weight:700}dd[data-v-804d79b6]{margin-bottom:.5rem;margin-left:0}blockquote[data-v-804d79b6]{margin:0 0 1rem}b[data-v-804d79b6],strong[data-v-804d79b6]{font-weight:bolder}.small[data-v-804d79b6],small[data-v-804d79b6]{font-size:.875em}.mark[data-v-804d79b6],mark[data-v-804d79b6]{padding:.2em;background-color:#fcf8e3}sub[data-v-804d79b6],sup[data-v-804d79b6]{position:relative;font-size:.75em;line-height:0;vertical-align:baseline}sub[data-v-804d79b6]{bottom:-.25em}sup[data-v-804d79b6]{top:-.5em}a[data-v-804d79b6]{color:#0d6efd;text-decoration:underline}a[data-v-804d79b6]:hover{color:#0a58ca}a[data-v-804d79b6]:not([href]):not([class]),a[data-v-804d79b6]:not([href]):not([class]):hover{color:inherit;text-decoration:none}code[data-v-804d79b6],kbd[data-v-804d79b6],pre[data-v-804d79b6],samp[data-v-804d79b6]{font-family:var(--bs-font-monospace);font-size:1em;direction:ltr;unicode-bidi:bidi-override}pre[data-v-804d79b6]{display:block;margin-top:0;margin-bottom:1rem;overflow:auto;font-size:.875em}pre code[data-v-804d79b6]{font-size:inherit;color:inherit;word-break:normal}code[data-v-804d79b6]{font-size:.875em;color:#d63384;word-wrap:break-word}a>code[data-v-804d79b6]{color:inherit}kbd[data-v-804d79b6]{padding:.2rem .4rem;font-size:.875em;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd[data-v-804d79b6]{padding:0;font-size:1em;font-weight:700}figure[data-v-804d79b6]{margin:0 0 1rem}img[data-v-804d79b6],svg[data-v-804d79b6]{vertical-align:middle}table[data-v-804d79b6]{caption-side:bottom;border-collapse:collapse}caption[data-v-804d79b6]{padding-top:.5rem;padding-bottom:.5rem;color:#6c757d;text-align:left}th[data-v-804d79b6]{text-align:inherit;text-align:-webkit-match-parent}tbody[data-v-804d79b6],td[data-v-804d79b6],tfoot[data-v-804d79b6],th[data-v-804d79b6],thead[data-v-804d79b6],tr[data-v-804d79b6]{border-color:inherit;border-style:solid;border-width:0}label[data-v-804d79b6]{display:inline-block}button[data-v-804d79b6]{border-radius:0}button[data-v-804d79b6]:focus:not(:focus-visible){outline:0}button[data-v-804d79b6],input[data-v-804d79b6],optgroup[data-v-804d79b6],select[data-v-804d79b6],textarea[data-v-804d79b6]{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button[data-v-804d79b6],select[data-v-804d79b6]{text-transform:none}[role=button][data-v-804d79b6]{cursor:pointer}select[data-v-804d79b6]{word-wrap:normal}select[data-v-804d79b6]:disabled{opacity:1}[list][data-v-804d79b6]::-webkit-calendar-picker-indicator{display:none}[type=button][data-v-804d79b6],[type=reset][data-v-804d79b6],[type=submit][data-v-804d79b6],button[data-v-804d79b6]{-webkit-appearance:button}[type=button][data-v-804d79b6]:not(:disabled),[type=reset][data-v-804d79b6]:not(:disabled),[type=submit][data-v-804d79b6]:not(:disabled),button[data-v-804d79b6]:not(:disabled){cursor:pointer}[data-v-804d79b6]::-moz-focus-inner{padding:0;border-style:none}textarea[data-v-804d79b6]{resize:vertical}fieldset[data-v-804d79b6]{min-width:0;padding:0;margin:0;border:0}legend[data-v-804d79b6]{float:left;width:100%;padding:0;margin-bottom:.5rem;font-size:calc(1.275rem + .3vw);line-height:inherit}@media (min-width:1200px){legend[data-v-804d79b6]{font-size:1.5rem}}legend+[data-v-804d79b6]{clear:left}[data-v-804d79b6]::-webkit-datetime-edit-day-field,[data-v-804d79b6]::-webkit-datetime-edit-fields-wrapper,[data-v-804d79b6]::-webkit-datetime-edit-hour-field,[data-v-804d79b6]::-webkit-datetime-edit-minute,[data-v-804d79b6]::-webkit-datetime-edit-month-field,[data-v-804d79b6]::-webkit-datetime-edit-text,[data-v-804d79b6]::-webkit-datetime-edit-year-field{padding:0}[data-v-804d79b6]::-webkit-inner-spin-button{height:auto}[type=search][data-v-804d79b6]{outline-offset:-2px;-webkit-appearance:textfield}[data-v-804d79b6]::-webkit-search-decoration{-webkit-appearance:none}[data-v-804d79b6]::-webkit-color-swatch-wrapper{padding:0}[data-v-804d79b6]::file-selector-button{font:inherit}[data-v-804d79b6]::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output[data-v-804d79b6]{display:inline-block}iframe[data-v-804d79b6]{border:0}summary[data-v-804d79b6]{display:list-item;cursor:pointer}progress[data-v-804d79b6]{vertical-align:baseline}[hidden][data-v-804d79b6]{display:none!important}.lead[data-v-804d79b6]{font-size:1.25rem;font-weight:300}.display-1[data-v-804d79b6]{font-size:calc(1.625rem + 4.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-1[data-v-804d79b6]{font-size:5rem}}.display-2[data-v-804d79b6]{font-size:calc(1.575rem + 3.9vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-2[data-v-804d79b6]{font-size:4.5rem}}.display-3[data-v-804d79b6]{font-size:calc(1.525rem + 3.3vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-3[data-v-804d79b6]{font-size:4rem}}.display-4[data-v-804d79b6]{font-size:calc(1.475rem + 2.7vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-4[data-v-804d79b6]{font-size:3.5rem}}.display-5[data-v-804d79b6]{font-size:calc(1.425rem + 2.1vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-5[data-v-804d79b6]{font-size:3rem}}.display-6[data-v-804d79b6]{font-size:calc(1.375rem + 1.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-6[data-v-804d79b6]{font-size:2.5rem}}.list-inline[data-v-804d79b6],.list-unstyled[data-v-804d79b6]{padding-left:0;list-style:none}.list-inline-item[data-v-804d79b6]{display:inline-block}.list-inline-item[data-v-804d79b6]:not(:last-child){margin-right:.5rem}.initialism[data-v-804d79b6]{font-size:.875em;text-transform:uppercase}.blockquote[data-v-804d79b6]{margin-bottom:1rem;font-size:1.25rem}.blockquote[data-v-804d79b6]>:last-child{margin-bottom:0}.blockquote-footer[data-v-804d79b6]{margin-top:-1rem;margin-bottom:1rem;font-size:.875em;color:#6c757d}.blockquote-footer[data-v-804d79b6]:before{content:\"\\2014\\A0\"}.img-fluid[data-v-804d79b6]{max-width:100%;height:auto}.img-thumbnail[data-v-804d79b6]{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.figure[data-v-804d79b6]{display:inline-block}.figure-img[data-v-804d79b6]{margin-bottom:.5rem;line-height:1}.figure-caption[data-v-804d79b6]{font-size:.875em;color:#6c757d}.container-fluid[data-v-804d79b6],.container-lg[data-v-804d79b6],.container-md[data-v-804d79b6],.container-sm[data-v-804d79b6],.container-xl[data-v-804d79b6],.container-xxl[data-v-804d79b6],.container[data-v-804d79b6]{width:100%;padding-right:var(--bs-gutter-x,.75rem);padding-left:var(--bs-gutter-x,.75rem);margin-right:auto;margin-left:auto}@media (min-width:576px){.container-sm[data-v-804d79b6],.container[data-v-804d79b6]{max-width:540px}}@media (min-width:768px){.container-md[data-v-804d79b6],.container-sm[data-v-804d79b6],.container[data-v-804d79b6]{max-width:720px}}@media (min-width:992px){.container-lg[data-v-804d79b6],.container-md[data-v-804d79b6],.container-sm[data-v-804d79b6],.container[data-v-804d79b6]{max-width:960px}}@media (min-width:1200px){.container-lg[data-v-804d79b6],.container-md[data-v-804d79b6],.container-sm[data-v-804d79b6],.container-xl[data-v-804d79b6],.container[data-v-804d79b6]{max-width:1140px}}@media (min-width:1400px){.container-lg[data-v-804d79b6],.container-md[data-v-804d79b6],.container-sm[data-v-804d79b6],.container-xl[data-v-804d79b6],.container-xxl[data-v-804d79b6],.container[data-v-804d79b6]{max-width:1320px}}.row[data-v-804d79b6]{--bs-gutter-x:1.5rem;--bs-gutter-y:0;display:flex;flex-wrap:wrap;margin-top:calc(-1 * var(--bs-gutter-y));margin-right:calc(-.5 * var(--bs-gutter-x));margin-left:calc(-.5 * var(--bs-gutter-x))}.row>[data-v-804d79b6]{flex-shrink:0;width:100%;max-width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-top:var(--bs-gutter-y)}.col[data-v-804d79b6]{flex:1 0 0%}.row-cols-auto>[data-v-804d79b6]{flex:0 0 auto;width:auto}.row-cols-1>[data-v-804d79b6]{flex:0 0 auto;width:100%}.row-cols-2>[data-v-804d79b6]{flex:0 0 auto;width:50%}.row-cols-3>[data-v-804d79b6]{flex:0 0 auto;width:33.3333333333%}.row-cols-4>[data-v-804d79b6]{flex:0 0 auto;width:25%}.row-cols-5>[data-v-804d79b6]{flex:0 0 auto;width:20%}.row-cols-6>[data-v-804d79b6]{flex:0 0 auto;width:16.6666666667%}.col-auto[data-v-804d79b6]{flex:0 0 auto;width:auto}.col-1[data-v-804d79b6]{flex:0 0 auto;width:8.33333333%}.col-2[data-v-804d79b6]{flex:0 0 auto;width:16.66666667%}.col-3[data-v-804d79b6]{flex:0 0 auto;width:25%}.col-4[data-v-804d79b6]{flex:0 0 auto;width:33.33333333%}.col-5[data-v-804d79b6]{flex:0 0 auto;width:41.66666667%}.col-6[data-v-804d79b6]{flex:0 0 auto;width:50%}.col-7[data-v-804d79b6]{flex:0 0 auto;width:58.33333333%}.col-8[data-v-804d79b6]{flex:0 0 auto;width:66.66666667%}.col-9[data-v-804d79b6]{flex:0 0 auto;width:75%}.col-10[data-v-804d79b6]{flex:0 0 auto;width:83.33333333%}.col-11[data-v-804d79b6]{flex:0 0 auto;width:91.66666667%}.col-12[data-v-804d79b6]{flex:0 0 auto;width:100%}.offset-1[data-v-804d79b6]{margin-left:8.33333333%}.offset-2[data-v-804d79b6]{margin-left:16.66666667%}.offset-3[data-v-804d79b6]{margin-left:25%}.offset-4[data-v-804d79b6]{margin-left:33.33333333%}.offset-5[data-v-804d79b6]{margin-left:41.66666667%}.offset-6[data-v-804d79b6]{margin-left:50%}.offset-7[data-v-804d79b6]{margin-left:58.33333333%}.offset-8[data-v-804d79b6]{margin-left:66.66666667%}.offset-9[data-v-804d79b6]{margin-left:75%}.offset-10[data-v-804d79b6]{margin-left:83.33333333%}.offset-11[data-v-804d79b6]{margin-left:91.66666667%}.g-0[data-v-804d79b6],.gx-0[data-v-804d79b6]{--bs-gutter-x:0}.g-0[data-v-804d79b6],.gy-0[data-v-804d79b6]{--bs-gutter-y:0}.g-1[data-v-804d79b6],.gx-1[data-v-804d79b6]{--bs-gutter-x:0.25rem}.g-1[data-v-804d79b6],.gy-1[data-v-804d79b6]{--bs-gutter-y:0.25rem}.g-2[data-v-804d79b6],.gx-2[data-v-804d79b6]{--bs-gutter-x:0.5rem}.g-2[data-v-804d79b6],.gy-2[data-v-804d79b6]{--bs-gutter-y:0.5rem}.g-3[data-v-804d79b6],.gx-3[data-v-804d79b6]{--bs-gutter-x:1rem}.g-3[data-v-804d79b6],.gy-3[data-v-804d79b6]{--bs-gutter-y:1rem}.g-4[data-v-804d79b6],.gx-4[data-v-804d79b6]{--bs-gutter-x:1.5rem}.g-4[data-v-804d79b6],.gy-4[data-v-804d79b6]{--bs-gutter-y:1.5rem}.g-5[data-v-804d79b6],.gx-5[data-v-804d79b6]{--bs-gutter-x:3rem}.g-5[data-v-804d79b6],.gy-5[data-v-804d79b6]{--bs-gutter-y:3rem}@media (min-width:576px){.col-sm[data-v-804d79b6]{flex:1 0 0%}.row-cols-sm-auto>[data-v-804d79b6]{flex:0 0 auto;width:auto}.row-cols-sm-1>[data-v-804d79b6]{flex:0 0 auto;width:100%}.row-cols-sm-2>[data-v-804d79b6]{flex:0 0 auto;width:50%}.row-cols-sm-3>[data-v-804d79b6]{flex:0 0 auto;width:33.3333333333%}.row-cols-sm-4>[data-v-804d79b6]{flex:0 0 auto;width:25%}.row-cols-sm-5>[data-v-804d79b6]{flex:0 0 auto;width:20%}.row-cols-sm-6>[data-v-804d79b6]{flex:0 0 auto;width:16.6666666667%}.col-sm-auto[data-v-804d79b6]{flex:0 0 auto;width:auto}.col-sm-1[data-v-804d79b6]{flex:0 0 auto;width:8.33333333%}.col-sm-2[data-v-804d79b6]{flex:0 0 auto;width:16.66666667%}.col-sm-3[data-v-804d79b6]{flex:0 0 auto;width:25%}.col-sm-4[data-v-804d79b6]{flex:0 0 auto;width:33.33333333%}.col-sm-5[data-v-804d79b6]{flex:0 0 auto;width:41.66666667%}.col-sm-6[data-v-804d79b6]{flex:0 0 auto;width:50%}.col-sm-7[data-v-804d79b6]{flex:0 0 auto;width:58.33333333%}.col-sm-8[data-v-804d79b6]{flex:0 0 auto;width:66.66666667%}.col-sm-9[data-v-804d79b6]{flex:0 0 auto;width:75%}.col-sm-10[data-v-804d79b6]{flex:0 0 auto;width:83.33333333%}.col-sm-11[data-v-804d79b6]{flex:0 0 auto;width:91.66666667%}.col-sm-12[data-v-804d79b6]{flex:0 0 auto;width:100%}.offset-sm-0[data-v-804d79b6]{margin-left:0}.offset-sm-1[data-v-804d79b6]{margin-left:8.33333333%}.offset-sm-2[data-v-804d79b6]{margin-left:16.66666667%}.offset-sm-3[data-v-804d79b6]{margin-left:25%}.offset-sm-4[data-v-804d79b6]{margin-left:33.33333333%}.offset-sm-5[data-v-804d79b6]{margin-left:41.66666667%}.offset-sm-6[data-v-804d79b6]{margin-left:50%}.offset-sm-7[data-v-804d79b6]{margin-left:58.33333333%}.offset-sm-8[data-v-804d79b6]{margin-left:66.66666667%}.offset-sm-9[data-v-804d79b6]{margin-left:75%}.offset-sm-10[data-v-804d79b6]{margin-left:83.33333333%}.offset-sm-11[data-v-804d79b6]{margin-left:91.66666667%}.g-sm-0[data-v-804d79b6],.gx-sm-0[data-v-804d79b6]{--bs-gutter-x:0}.g-sm-0[data-v-804d79b6],.gy-sm-0[data-v-804d79b6]{--bs-gutter-y:0}.g-sm-1[data-v-804d79b6],.gx-sm-1[data-v-804d79b6]{--bs-gutter-x:0.25rem}.g-sm-1[data-v-804d79b6],.gy-sm-1[data-v-804d79b6]{--bs-gutter-y:0.25rem}.g-sm-2[data-v-804d79b6],.gx-sm-2[data-v-804d79b6]{--bs-gutter-x:0.5rem}.g-sm-2[data-v-804d79b6],.gy-sm-2[data-v-804d79b6]{--bs-gutter-y:0.5rem}.g-sm-3[data-v-804d79b6],.gx-sm-3[data-v-804d79b6]{--bs-gutter-x:1rem}.g-sm-3[data-v-804d79b6],.gy-sm-3[data-v-804d79b6]{--bs-gutter-y:1rem}.g-sm-4[data-v-804d79b6],.gx-sm-4[data-v-804d79b6]{--bs-gutter-x:1.5rem}.g-sm-4[data-v-804d79b6],.gy-sm-4[data-v-804d79b6]{--bs-gutter-y:1.5rem}.g-sm-5[data-v-804d79b6],.gx-sm-5[data-v-804d79b6]{--bs-gutter-x:3rem}.g-sm-5[data-v-804d79b6],.gy-sm-5[data-v-804d79b6]{--bs-gutter-y:3rem}}@media (min-width:768px){.col-md[data-v-804d79b6]{flex:1 0 0%}.row-cols-md-auto>[data-v-804d79b6]{flex:0 0 auto;width:auto}.row-cols-md-1>[data-v-804d79b6]{flex:0 0 auto;width:100%}.row-cols-md-2>[data-v-804d79b6]{flex:0 0 auto;width:50%}.row-cols-md-3>[data-v-804d79b6]{flex:0 0 auto;width:33.3333333333%}.row-cols-md-4>[data-v-804d79b6]{flex:0 0 auto;width:25%}.row-cols-md-5>[data-v-804d79b6]{flex:0 0 auto;width:20%}.row-cols-md-6>[data-v-804d79b6]{flex:0 0 auto;width:16.6666666667%}.col-md-auto[data-v-804d79b6]{flex:0 0 auto;width:auto}.col-md-1[data-v-804d79b6]{flex:0 0 auto;width:8.33333333%}.col-md-2[data-v-804d79b6]{flex:0 0 auto;width:16.66666667%}.col-md-3[data-v-804d79b6]{flex:0 0 auto;width:25%}.col-md-4[data-v-804d79b6]{flex:0 0 auto;width:33.33333333%}.col-md-5[data-v-804d79b6]{flex:0 0 auto;width:41.66666667%}.col-md-6[data-v-804d79b6]{flex:0 0 auto;width:50%}.col-md-7[data-v-804d79b6]{flex:0 0 auto;width:58.33333333%}.col-md-8[data-v-804d79b6]{flex:0 0 auto;width:66.66666667%}.col-md-9[data-v-804d79b6]{flex:0 0 auto;width:75%}.col-md-10[data-v-804d79b6]{flex:0 0 auto;width:83.33333333%}.col-md-11[data-v-804d79b6]{flex:0 0 auto;width:91.66666667%}.col-md-12[data-v-804d79b6]{flex:0 0 auto;width:100%}.offset-md-0[data-v-804d79b6]{margin-left:0}.offset-md-1[data-v-804d79b6]{margin-left:8.33333333%}.offset-md-2[data-v-804d79b6]{margin-left:16.66666667%}.offset-md-3[data-v-804d79b6]{margin-left:25%}.offset-md-4[data-v-804d79b6]{margin-left:33.33333333%}.offset-md-5[data-v-804d79b6]{margin-left:41.66666667%}.offset-md-6[data-v-804d79b6]{margin-left:50%}.offset-md-7[data-v-804d79b6]{margin-left:58.33333333%}.offset-md-8[data-v-804d79b6]{margin-left:66.66666667%}.offset-md-9[data-v-804d79b6]{margin-left:75%}.offset-md-10[data-v-804d79b6]{margin-left:83.33333333%}.offset-md-11[data-v-804d79b6]{margin-left:91.66666667%}.g-md-0[data-v-804d79b6],.gx-md-0[data-v-804d79b6]{--bs-gutter-x:0}.g-md-0[data-v-804d79b6],.gy-md-0[data-v-804d79b6]{--bs-gutter-y:0}.g-md-1[data-v-804d79b6],.gx-md-1[data-v-804d79b6]{--bs-gutter-x:0.25rem}.g-md-1[data-v-804d79b6],.gy-md-1[data-v-804d79b6]{--bs-gutter-y:0.25rem}.g-md-2[data-v-804d79b6],.gx-md-2[data-v-804d79b6]{--bs-gutter-x:0.5rem}.g-md-2[data-v-804d79b6],.gy-md-2[data-v-804d79b6]{--bs-gutter-y:0.5rem}.g-md-3[data-v-804d79b6],.gx-md-3[data-v-804d79b6]{--bs-gutter-x:1rem}.g-md-3[data-v-804d79b6],.gy-md-3[data-v-804d79b6]{--bs-gutter-y:1rem}.g-md-4[data-v-804d79b6],.gx-md-4[data-v-804d79b6]{--bs-gutter-x:1.5rem}.g-md-4[data-v-804d79b6],.gy-md-4[data-v-804d79b6]{--bs-gutter-y:1.5rem}.g-md-5[data-v-804d79b6],.gx-md-5[data-v-804d79b6]{--bs-gutter-x:3rem}.g-md-5[data-v-804d79b6],.gy-md-5[data-v-804d79b6]{--bs-gutter-y:3rem}}@media (min-width:992px){.col-lg[data-v-804d79b6]{flex:1 0 0%}.row-cols-lg-auto>[data-v-804d79b6]{flex:0 0 auto;width:auto}.row-cols-lg-1>[data-v-804d79b6]{flex:0 0 auto;width:100%}.row-cols-lg-2>[data-v-804d79b6]{flex:0 0 auto;width:50%}.row-cols-lg-3>[data-v-804d79b6]{flex:0 0 auto;width:33.3333333333%}.row-cols-lg-4>[data-v-804d79b6]{flex:0 0 auto;width:25%}.row-cols-lg-5>[data-v-804d79b6]{flex:0 0 auto;width:20%}.row-cols-lg-6>[data-v-804d79b6]{flex:0 0 auto;width:16.6666666667%}.col-lg-auto[data-v-804d79b6]{flex:0 0 auto;width:auto}.col-lg-1[data-v-804d79b6]{flex:0 0 auto;width:8.33333333%}.col-lg-2[data-v-804d79b6]{flex:0 0 auto;width:16.66666667%}.col-lg-3[data-v-804d79b6]{flex:0 0 auto;width:25%}.col-lg-4[data-v-804d79b6]{flex:0 0 auto;width:33.33333333%}.col-lg-5[data-v-804d79b6]{flex:0 0 auto;width:41.66666667%}.col-lg-6[data-v-804d79b6]{flex:0 0 auto;width:50%}.col-lg-7[data-v-804d79b6]{flex:0 0 auto;width:58.33333333%}.col-lg-8[data-v-804d79b6]{flex:0 0 auto;width:66.66666667%}.col-lg-9[data-v-804d79b6]{flex:0 0 auto;width:75%}.col-lg-10[data-v-804d79b6]{flex:0 0 auto;width:83.33333333%}.col-lg-11[data-v-804d79b6]{flex:0 0 auto;width:91.66666667%}.col-lg-12[data-v-804d79b6]{flex:0 0 auto;width:100%}.offset-lg-0[data-v-804d79b6]{margin-left:0}.offset-lg-1[data-v-804d79b6]{margin-left:8.33333333%}.offset-lg-2[data-v-804d79b6]{margin-left:16.66666667%}.offset-lg-3[data-v-804d79b6]{margin-left:25%}.offset-lg-4[data-v-804d79b6]{margin-left:33.33333333%}.offset-lg-5[data-v-804d79b6]{margin-left:41.66666667%}.offset-lg-6[data-v-804d79b6]{margin-left:50%}.offset-lg-7[data-v-804d79b6]{margin-left:58.33333333%}.offset-lg-8[data-v-804d79b6]{margin-left:66.66666667%}.offset-lg-9[data-v-804d79b6]{margin-left:75%}.offset-lg-10[data-v-804d79b6]{margin-left:83.33333333%}.offset-lg-11[data-v-804d79b6]{margin-left:91.66666667%}.g-lg-0[data-v-804d79b6],.gx-lg-0[data-v-804d79b6]{--bs-gutter-x:0}.g-lg-0[data-v-804d79b6],.gy-lg-0[data-v-804d79b6]{--bs-gutter-y:0}.g-lg-1[data-v-804d79b6],.gx-lg-1[data-v-804d79b6]{--bs-gutter-x:0.25rem}.g-lg-1[data-v-804d79b6],.gy-lg-1[data-v-804d79b6]{--bs-gutter-y:0.25rem}.g-lg-2[data-v-804d79b6],.gx-lg-2[data-v-804d79b6]{--bs-gutter-x:0.5rem}.g-lg-2[data-v-804d79b6],.gy-lg-2[data-v-804d79b6]{--bs-gutter-y:0.5rem}.g-lg-3[data-v-804d79b6],.gx-lg-3[data-v-804d79b6]{--bs-gutter-x:1rem}.g-lg-3[data-v-804d79b6],.gy-lg-3[data-v-804d79b6]{--bs-gutter-y:1rem}.g-lg-4[data-v-804d79b6],.gx-lg-4[data-v-804d79b6]{--bs-gutter-x:1.5rem}.g-lg-4[data-v-804d79b6],.gy-lg-4[data-v-804d79b6]{--bs-gutter-y:1.5rem}.g-lg-5[data-v-804d79b6],.gx-lg-5[data-v-804d79b6]{--bs-gutter-x:3rem}.g-lg-5[data-v-804d79b6],.gy-lg-5[data-v-804d79b6]{--bs-gutter-y:3rem}}@media (min-width:1200px){.col-xl[data-v-804d79b6]{flex:1 0 0%}.row-cols-xl-auto>[data-v-804d79b6]{flex:0 0 auto;width:auto}.row-cols-xl-1>[data-v-804d79b6]{flex:0 0 auto;width:100%}.row-cols-xl-2>[data-v-804d79b6]{flex:0 0 auto;width:50%}.row-cols-xl-3>[data-v-804d79b6]{flex:0 0 auto;width:33.3333333333%}.row-cols-xl-4>[data-v-804d79b6]{flex:0 0 auto;width:25%}.row-cols-xl-5>[data-v-804d79b6]{flex:0 0 auto;width:20%}.row-cols-xl-6>[data-v-804d79b6]{flex:0 0 auto;width:16.6666666667%}.col-xl-auto[data-v-804d79b6]{flex:0 0 auto;width:auto}.col-xl-1[data-v-804d79b6]{flex:0 0 auto;width:8.33333333%}.col-xl-2[data-v-804d79b6]{flex:0 0 auto;width:16.66666667%}.col-xl-3[data-v-804d79b6]{flex:0 0 auto;width:25%}.col-xl-4[data-v-804d79b6]{flex:0 0 auto;width:33.33333333%}.col-xl-5[data-v-804d79b6]{flex:0 0 auto;width:41.66666667%}.col-xl-6[data-v-804d79b6]{flex:0 0 auto;width:50%}.col-xl-7[data-v-804d79b6]{flex:0 0 auto;width:58.33333333%}.col-xl-8[data-v-804d79b6]{flex:0 0 auto;width:66.66666667%}.col-xl-9[data-v-804d79b6]{flex:0 0 auto;width:75%}.col-xl-10[data-v-804d79b6]{flex:0 0 auto;width:83.33333333%}.col-xl-11[data-v-804d79b6]{flex:0 0 auto;width:91.66666667%}.col-xl-12[data-v-804d79b6]{flex:0 0 auto;width:100%}.offset-xl-0[data-v-804d79b6]{margin-left:0}.offset-xl-1[data-v-804d79b6]{margin-left:8.33333333%}.offset-xl-2[data-v-804d79b6]{margin-left:16.66666667%}.offset-xl-3[data-v-804d79b6]{margin-left:25%}.offset-xl-4[data-v-804d79b6]{margin-left:33.33333333%}.offset-xl-5[data-v-804d79b6]{margin-left:41.66666667%}.offset-xl-6[data-v-804d79b6]{margin-left:50%}.offset-xl-7[data-v-804d79b6]{margin-left:58.33333333%}.offset-xl-8[data-v-804d79b6]{margin-left:66.66666667%}.offset-xl-9[data-v-804d79b6]{margin-left:75%}.offset-xl-10[data-v-804d79b6]{margin-left:83.33333333%}.offset-xl-11[data-v-804d79b6]{margin-left:91.66666667%}.g-xl-0[data-v-804d79b6],.gx-xl-0[data-v-804d79b6]{--bs-gutter-x:0}.g-xl-0[data-v-804d79b6],.gy-xl-0[data-v-804d79b6]{--bs-gutter-y:0}.g-xl-1[data-v-804d79b6],.gx-xl-1[data-v-804d79b6]{--bs-gutter-x:0.25rem}.g-xl-1[data-v-804d79b6],.gy-xl-1[data-v-804d79b6]{--bs-gutter-y:0.25rem}.g-xl-2[data-v-804d79b6],.gx-xl-2[data-v-804d79b6]{--bs-gutter-x:0.5rem}.g-xl-2[data-v-804d79b6],.gy-xl-2[data-v-804d79b6]{--bs-gutter-y:0.5rem}.g-xl-3[data-v-804d79b6],.gx-xl-3[data-v-804d79b6]{--bs-gutter-x:1rem}.g-xl-3[data-v-804d79b6],.gy-xl-3[data-v-804d79b6]{--bs-gutter-y:1rem}.g-xl-4[data-v-804d79b6],.gx-xl-4[data-v-804d79b6]{--bs-gutter-x:1.5rem}.g-xl-4[data-v-804d79b6],.gy-xl-4[data-v-804d79b6]{--bs-gutter-y:1.5rem}.g-xl-5[data-v-804d79b6],.gx-xl-5[data-v-804d79b6]{--bs-gutter-x:3rem}.g-xl-5[data-v-804d79b6],.gy-xl-5[data-v-804d79b6]{--bs-gutter-y:3rem}}@media (min-width:1400px){.col-xxl[data-v-804d79b6]{flex:1 0 0%}.row-cols-xxl-auto>[data-v-804d79b6]{flex:0 0 auto;width:auto}.row-cols-xxl-1>[data-v-804d79b6]{flex:0 0 auto;width:100%}.row-cols-xxl-2>[data-v-804d79b6]{flex:0 0 auto;width:50%}.row-cols-xxl-3>[data-v-804d79b6]{flex:0 0 auto;width:33.3333333333%}.row-cols-xxl-4>[data-v-804d79b6]{flex:0 0 auto;width:25%}.row-cols-xxl-5>[data-v-804d79b6]{flex:0 0 auto;width:20%}.row-cols-xxl-6>[data-v-804d79b6]{flex:0 0 auto;width:16.6666666667%}.col-xxl-auto[data-v-804d79b6]{flex:0 0 auto;width:auto}.col-xxl-1[data-v-804d79b6]{flex:0 0 auto;width:8.33333333%}.col-xxl-2[data-v-804d79b6]{flex:0 0 auto;width:16.66666667%}.col-xxl-3[data-v-804d79b6]{flex:0 0 auto;width:25%}.col-xxl-4[data-v-804d79b6]{flex:0 0 auto;width:33.33333333%}.col-xxl-5[data-v-804d79b6]{flex:0 0 auto;width:41.66666667%}.col-xxl-6[data-v-804d79b6]{flex:0 0 auto;width:50%}.col-xxl-7[data-v-804d79b6]{flex:0 0 auto;width:58.33333333%}.col-xxl-8[data-v-804d79b6]{flex:0 0 auto;width:66.66666667%}.col-xxl-9[data-v-804d79b6]{flex:0 0 auto;width:75%}.col-xxl-10[data-v-804d79b6]{flex:0 0 auto;width:83.33333333%}.col-xxl-11[data-v-804d79b6]{flex:0 0 auto;width:91.66666667%}.col-xxl-12[data-v-804d79b6]{flex:0 0 auto;width:100%}.offset-xxl-0[data-v-804d79b6]{margin-left:0}.offset-xxl-1[data-v-804d79b6]{margin-left:8.33333333%}.offset-xxl-2[data-v-804d79b6]{margin-left:16.66666667%}.offset-xxl-3[data-v-804d79b6]{margin-left:25%}.offset-xxl-4[data-v-804d79b6]{margin-left:33.33333333%}.offset-xxl-5[data-v-804d79b6]{margin-left:41.66666667%}.offset-xxl-6[data-v-804d79b6]{margin-left:50%}.offset-xxl-7[data-v-804d79b6]{margin-left:58.33333333%}.offset-xxl-8[data-v-804d79b6]{margin-left:66.66666667%}.offset-xxl-9[data-v-804d79b6]{margin-left:75%}.offset-xxl-10[data-v-804d79b6]{margin-left:83.33333333%}.offset-xxl-11[data-v-804d79b6]{margin-left:91.66666667%}.g-xxl-0[data-v-804d79b6],.gx-xxl-0[data-v-804d79b6]{--bs-gutter-x:0}.g-xxl-0[data-v-804d79b6],.gy-xxl-0[data-v-804d79b6]{--bs-gutter-y:0}.g-xxl-1[data-v-804d79b6],.gx-xxl-1[data-v-804d79b6]{--bs-gutter-x:0.25rem}.g-xxl-1[data-v-804d79b6],.gy-xxl-1[data-v-804d79b6]{--bs-gutter-y:0.25rem}.g-xxl-2[data-v-804d79b6],.gx-xxl-2[data-v-804d79b6]{--bs-gutter-x:0.5rem}.g-xxl-2[data-v-804d79b6],.gy-xxl-2[data-v-804d79b6]{--bs-gutter-y:0.5rem}.g-xxl-3[data-v-804d79b6],.gx-xxl-3[data-v-804d79b6]{--bs-gutter-x:1rem}.g-xxl-3[data-v-804d79b6],.gy-xxl-3[data-v-804d79b6]{--bs-gutter-y:1rem}.g-xxl-4[data-v-804d79b6],.gx-xxl-4[data-v-804d79b6]{--bs-gutter-x:1.5rem}.g-xxl-4[data-v-804d79b6],.gy-xxl-4[data-v-804d79b6]{--bs-gutter-y:1.5rem}.g-xxl-5[data-v-804d79b6],.gx-xxl-5[data-v-804d79b6]{--bs-gutter-x:3rem}.g-xxl-5[data-v-804d79b6],.gy-xxl-5[data-v-804d79b6]{--bs-gutter-y:3rem}}.table[data-v-804d79b6]{--bs-table-bg:transparent;--bs-table-accent-bg:transparent;--bs-table-striped-color:#212529;--bs-table-striped-bg:rgba(0,0,0,.05);--bs-table-active-color:#212529;--bs-table-active-bg:rgba(0,0,0,.1);--bs-table-hover-color:#212529;--bs-table-hover-bg:rgba(0,0,0,.075);width:100%;margin-bottom:1rem;color:#212529;vertical-align:top;border-color:#dee2e6}.table>:not(caption)>*>[data-v-804d79b6]{padding:.5rem;background-color:var(--bs-table-bg);border-bottom-width:1px;box-shadow:inset 0 0 0 9999px var(--bs-table-accent-bg)}.table>tbody[data-v-804d79b6]{vertical-align:inherit}.table>thead[data-v-804d79b6]{vertical-align:bottom}.table[data-v-804d79b6]>:not(:first-child){border-top:2px solid currentColor}.caption-top[data-v-804d79b6]{caption-side:top}.table-sm>:not(caption)>*>[data-v-804d79b6]{padding:.25rem}.table-bordered>:not(caption)>[data-v-804d79b6]{border-width:1px 0}.table-bordered>:not(caption)>*>[data-v-804d79b6]{border-width:0 1px}.table-borderless>:not(caption)>*>[data-v-804d79b6]{border-bottom-width:0}.table-borderless[data-v-804d79b6]>:not(:first-child){border-top-width:0}.table-striped>tbody>tr:nth-of-type(odd)>[data-v-804d79b6]{--bs-table-accent-bg:var(--bs-table-striped-bg);color:var(--bs-table-striped-color)}.table-active[data-v-804d79b6]{--bs-table-accent-bg:var(--bs-table-active-bg);color:var(--bs-table-active-color)}.table-hover>tbody>tr:hover>[data-v-804d79b6]{--bs-table-accent-bg:var(--bs-table-hover-bg);color:var(--bs-table-hover-color)}.table-primary[data-v-804d79b6]{--bs-table-bg:#cfe2ff;--bs-table-striped-bg:#c5d7f2;--bs-table-striped-color:#000;--bs-table-active-bg:#bacbe6;--bs-table-active-color:#000;--bs-table-hover-bg:#bfd1ec;--bs-table-hover-color:#000;color:#000;border-color:#bacbe6}.table-secondary[data-v-804d79b6]{--bs-table-bg:#e2e3e5;--bs-table-striped-bg:#d7d8da;--bs-table-striped-color:#000;--bs-table-active-bg:#cbccce;--bs-table-active-color:#000;--bs-table-hover-bg:#d1d2d4;--bs-table-hover-color:#000;color:#000;border-color:#cbccce}.table-success[data-v-804d79b6]{--bs-table-bg:#d1e7dd;--bs-table-striped-bg:#c7dbd2;--bs-table-striped-color:#000;--bs-table-active-bg:#bcd0c7;--bs-table-active-color:#000;--bs-table-hover-bg:#c1d6cc;--bs-table-hover-color:#000;color:#000;border-color:#bcd0c7}.table-info[data-v-804d79b6]{--bs-table-bg:#cff4fc;--bs-table-striped-bg:#c5e8ef;--bs-table-striped-color:#000;--bs-table-active-bg:#badce3;--bs-table-active-color:#000;--bs-table-hover-bg:#bfe2e9;--bs-table-hover-color:#000;color:#000;border-color:#badce3}.table-warning[data-v-804d79b6]{--bs-table-bg:#fff3cd;--bs-table-striped-bg:#f2e7c3;--bs-table-striped-color:#000;--bs-table-active-bg:#e6dbb9;--bs-table-active-color:#000;--bs-table-hover-bg:#ece1be;--bs-table-hover-color:#000;color:#000;border-color:#e6dbb9}.table-danger[data-v-804d79b6]{--bs-table-bg:#f8d7da;--bs-table-striped-bg:#eccccf;--bs-table-striped-color:#000;--bs-table-active-bg:#dfc2c4;--bs-table-active-color:#000;--bs-table-hover-bg:#e5c7ca;--bs-table-hover-color:#000;color:#000;border-color:#dfc2c4}.table-light[data-v-804d79b6]{--bs-table-bg:#f8f9fa;--bs-table-striped-bg:#ecedee;--bs-table-striped-color:#000;--bs-table-active-bg:#dfe0e1;--bs-table-active-color:#000;--bs-table-hover-bg:#e5e6e7;--bs-table-hover-color:#000;color:#000;border-color:#dfe0e1}.table-dark[data-v-804d79b6]{--bs-table-bg:#212529;--bs-table-striped-bg:#2c3034;--bs-table-striped-color:#fff;--bs-table-active-bg:#373b3e;--bs-table-active-color:#fff;--bs-table-hover-bg:#323539;--bs-table-hover-color:#fff;color:#fff;border-color:#373b3e}.table-responsive[data-v-804d79b6]{overflow-x:auto;-webkit-overflow-scrolling:touch}@media (max-width:575.98px){.table-responsive-sm[data-v-804d79b6]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:767.98px){.table-responsive-md[data-v-804d79b6]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:991.98px){.table-responsive-lg[data-v-804d79b6]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1199.98px){.table-responsive-xl[data-v-804d79b6]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1399.98px){.table-responsive-xxl[data-v-804d79b6]{overflow-x:auto;-webkit-overflow-scrolling:touch}}.form-label[data-v-804d79b6]{margin-bottom:.5rem}.col-form-label[data-v-804d79b6]{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg[data-v-804d79b6]{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem}.col-form-label-sm[data-v-804d79b6]{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem}.form-text[data-v-804d79b6]{margin-top:.25rem;font-size:.875em;color:#6c757d}.form-control[data-v-804d79b6]{display:block;width:100%;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-804d79b6]{transition:none}}.form-control[type=file][data-v-804d79b6]{overflow:hidden}.form-control[type=file][data-v-804d79b6]:not(:disabled):not([readonly]){cursor:pointer}.form-control[data-v-804d79b6]:focus{color:#212529;background-color:#fff;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-control[data-v-804d79b6]::-webkit-date-and-time-value{height:1.5em}.form-control[data-v-804d79b6]::-moz-placeholder{color:#6c757d;opacity:1}.form-control[data-v-804d79b6]::placeholder{color:#6c757d;opacity:1}.form-control[data-v-804d79b6]:disabled,.form-control[readonly][data-v-804d79b6]{background-color:#e9ecef;opacity:1}.form-control[data-v-804d79b6]::file-selector-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-804d79b6]::-webkit-file-upload-button{-webkit-transition:none;transition:none}.form-control[data-v-804d79b6]::file-selector-button{transition:none}}.form-control[data-v-804d79b6]:hover:not(:disabled):not([readonly])::file-selector-button{background-color:#dde0e3}.form-control[data-v-804d79b6]::-webkit-file-upload-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;-webkit-transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-804d79b6]::-webkit-file-upload-button{-webkit-transition:none;transition:none}}.form-control[data-v-804d79b6]:hover:not(:disabled):not([readonly])::-webkit-file-upload-button{background-color:#dde0e3}.form-control-plaintext[data-v-804d79b6]{display:block;width:100%;padding:.375rem 0;margin-bottom:0;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg[data-v-804d79b6],.form-control-plaintext.form-control-sm[data-v-804d79b6]{padding-right:0;padding-left:0}.form-control-sm[data-v-804d79b6]{min-height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.form-control-sm[data-v-804d79b6]::file-selector-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-sm[data-v-804d79b6]::-webkit-file-upload-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-lg[data-v-804d79b6]{min-height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.form-control-lg[data-v-804d79b6]::file-selector-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}.form-control-lg[data-v-804d79b6]::-webkit-file-upload-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}textarea.form-control[data-v-804d79b6]{min-height:calc(1.5em + .75rem + 2px)}textarea.form-control-sm[data-v-804d79b6]{min-height:calc(1.5em + .5rem + 2px)}textarea.form-control-lg[data-v-804d79b6]{min-height:calc(1.5em + 1rem + 2px)}.form-control-color[data-v-804d79b6]{width:3rem;height:auto;padding:.375rem}.form-control-color[data-v-804d79b6]:not(:disabled):not([readonly]){cursor:pointer}.form-control-color[data-v-804d79b6]::-moz-color-swatch{height:1.5em;border-radius:.25rem}.form-control-color[data-v-804d79b6]::-webkit-color-swatch{height:1.5em;border-radius:.25rem}.form-select[data-v-804d79b6]{display:block;width:100%;padding:.375rem 2.25rem .375rem .75rem;-moz-padding-start:calc(.75rem - 3px);font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right .75rem center;background-size:16px 12px;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-select[data-v-804d79b6]{transition:none}}.form-select[data-v-804d79b6]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-select[multiple][data-v-804d79b6],.form-select[size][data-v-804d79b6]:not([size=\"1\"]){padding-right:.75rem;background-image:none}.form-select[data-v-804d79b6]:disabled{background-color:#e9ecef}.form-select[data-v-804d79b6]:-moz-focusring{color:transparent;text-shadow:0 0 0 #212529}.form-select-sm[data-v-804d79b6]{padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem;border-radius:.2rem}.form-select-lg[data-v-804d79b6]{padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem;border-radius:.3rem}.form-check[data-v-804d79b6]{display:block;min-height:1.5rem;padding-left:1.5em;margin-bottom:.125rem}.form-check .form-check-input[data-v-804d79b6]{float:left;margin-left:-1.5em}.form-check-input[data-v-804d79b6]{width:1em;height:1em;margin-top:.25em;vertical-align:top;background-color:#fff;background-repeat:no-repeat;background-position:50%;background-size:contain;border:1px solid rgba(0,0,0,.25);-webkit-appearance:none;-moz-appearance:none;appearance:none;-webkit-print-color-adjust:exact;color-adjust:exact}.form-check-input[type=checkbox][data-v-804d79b6]{border-radius:.25em}.form-check-input[type=radio][data-v-804d79b6]{border-radius:50%}.form-check-input[data-v-804d79b6]:active{filter:brightness(90%)}.form-check-input[data-v-804d79b6]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-check-input[data-v-804d79b6]:checked{background-color:#0d6efd;border-color:#0d6efd}.form-check-input:checked[type=checkbox][data-v-804d79b6]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3 6-6'/%3E%3C/svg%3E\")}.form-check-input:checked[type=radio][data-v-804d79b6]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='2' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-input[type=checkbox][data-v-804d79b6]:indeterminate{background-color:#0d6efd;border-color:#0d6efd;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3E%3C/svg%3E\")}.form-check-input[data-v-804d79b6]:disabled{pointer-events:none;filter:none;opacity:.5}.form-check-input:disabled~.form-check-label[data-v-804d79b6],.form-check-input[disabled]~.form-check-label[data-v-804d79b6]{opacity:.5}.form-switch[data-v-804d79b6]{padding-left:2.5em}.form-switch .form-check-input[data-v-804d79b6]{width:2em;margin-left:-2.5em;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='rgba(0, 0, 0, 0.25)'/%3E%3C/svg%3E\");background-position:0;border-radius:2em;transition:background-position .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-switch .form-check-input[data-v-804d79b6]{transition:none}}.form-switch .form-check-input[data-v-804d79b6]:focus{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%2386b7fe'/%3E%3C/svg%3E\")}.form-switch .form-check-input[data-v-804d79b6]:checked{background-position:100%;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-inline[data-v-804d79b6]{display:inline-block;margin-right:1rem}.btn-check[data-v-804d79b6]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.btn-check:disabled+.btn[data-v-804d79b6],.btn-check[disabled]+.btn[data-v-804d79b6]{pointer-events:none;filter:none;opacity:.65}.form-range[data-v-804d79b6]{width:100%;height:1.5rem;padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.form-range[data-v-804d79b6]:focus{outline:0}.form-range[data-v-804d79b6]:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-804d79b6]:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-804d79b6]::-moz-focus-outer{border:0}.form-range[data-v-804d79b6]::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#0d6efd;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-804d79b6]::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.form-range[data-v-804d79b6]::-webkit-slider-thumb:active{background-color:#b6d4fe}.form-range[data-v-804d79b6]::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-804d79b6]::-moz-range-thumb{width:1rem;height:1rem;background-color:#0d6efd;border:0;border-radius:1rem;-moz-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-804d79b6]::-moz-range-thumb{-moz-transition:none;transition:none}}.form-range[data-v-804d79b6]::-moz-range-thumb:active{background-color:#b6d4fe}.form-range[data-v-804d79b6]::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-804d79b6]:disabled{pointer-events:none}.form-range[data-v-804d79b6]:disabled::-webkit-slider-thumb{background-color:#adb5bd}.form-range[data-v-804d79b6]:disabled::-moz-range-thumb{background-color:#adb5bd}.form-floating[data-v-804d79b6]{position:relative}.form-floating>.form-control[data-v-804d79b6],.form-floating>.form-select[data-v-804d79b6]{height:calc(3.5rem + 2px);line-height:1.25}.form-floating>label[data-v-804d79b6]{position:absolute;top:0;left:0;height:100%;padding:1rem .75rem;pointer-events:none;border:1px solid transparent;transform-origin:0 0;transition:opacity .1s ease-in-out,transform .1s ease-in-out}@media (prefers-reduced-motion:reduce){.form-floating>label[data-v-804d79b6]{transition:none}}.form-floating>.form-control[data-v-804d79b6]{padding:1rem .75rem}.form-floating>.form-control[data-v-804d79b6]::-moz-placeholder{color:transparent}.form-floating>.form-control[data-v-804d79b6]::placeholder{color:transparent}.form-floating>.form-control[data-v-804d79b6]:not(:-moz-placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-804d79b6]:focus,.form-floating>.form-control[data-v-804d79b6]:not(:placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-804d79b6]:-webkit-autofill{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-select[data-v-804d79b6]{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control:not(:-moz-placeholder-shown)~label[data-v-804d79b6]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:focus~label[data-v-804d79b6],.form-floating>.form-control:not(:placeholder-shown)~label[data-v-804d79b6],.form-floating>.form-select~label[data-v-804d79b6]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:-webkit-autofill~label[data-v-804d79b6]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.input-group[data-v-804d79b6]{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group>.form-control[data-v-804d79b6],.input-group>.form-select[data-v-804d79b6]{position:relative;flex:1 1 auto;width:1%;min-width:0}.input-group>.form-control[data-v-804d79b6]:focus,.input-group>.form-select[data-v-804d79b6]:focus{z-index:3}.input-group .btn[data-v-804d79b6]{position:relative;z-index:2}.input-group .btn[data-v-804d79b6]:focus{z-index:3}.input-group-text[data-v-804d79b6]{display:flex;align-items:center;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-lg>.btn[data-v-804d79b6],.input-group-lg>.form-control[data-v-804d79b6],.input-group-lg>.form-select[data-v-804d79b6],.input-group-lg>.input-group-text[data-v-804d79b6]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.input-group-sm>.btn[data-v-804d79b6],.input-group-sm>.form-control[data-v-804d79b6],.input-group-sm>.form-select[data-v-804d79b6],.input-group-sm>.input-group-text[data-v-804d79b6]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.input-group-lg>.form-select[data-v-804d79b6],.input-group-sm>.form-select[data-v-804d79b6]{padding-right:3rem}.input-group.has-validation>.dropdown-toggle[data-v-804d79b6]:nth-last-child(n+4),.input-group.has-validation[data-v-804d79b6]>:nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),.input-group:not(.has-validation)>.dropdown-toggle[data-v-804d79b6]:nth-last-child(n+3),.input-group[data-v-804d79b6]:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu){border-top-right-radius:0;border-bottom-right-radius:0}.input-group[data-v-804d79b6]>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}.valid-feedback[data-v-804d79b6]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#198754}.valid-tooltip[data-v-804d79b6]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(25,135,84,.9);border-radius:.25rem}.is-valid~.valid-feedback[data-v-804d79b6],.is-valid~.valid-tooltip[data-v-804d79b6],.was-validated :valid~.valid-feedback[data-v-804d79b6],.was-validated :valid~.valid-tooltip[data-v-804d79b6]{display:block}.form-control.is-valid[data-v-804d79b6],.was-validated .form-control[data-v-804d79b6]:valid{border-color:#198754;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-valid[data-v-804d79b6]:focus,.was-validated .form-control[data-v-804d79b6]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.was-validated textarea.form-control[data-v-804d79b6]:valid,textarea.form-control.is-valid[data-v-804d79b6]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-valid[data-v-804d79b6],.was-validated .form-select[data-v-804d79b6]:valid{border-color:#198754}.form-select.is-valid:not([multiple])[size=\"1\"][data-v-804d79b6],.form-select.is-valid[data-v-804d79b6]:not([multiple]):not([size]),.was-validated .form-select:valid:not([multiple])[size=\"1\"][data-v-804d79b6],.was-validated .form-select[data-v-804d79b6]:valid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-valid[data-v-804d79b6]:focus,.was-validated .form-select[data-v-804d79b6]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid[data-v-804d79b6],.was-validated .form-check-input[data-v-804d79b6]:valid{border-color:#198754}.form-check-input.is-valid[data-v-804d79b6]:checked,.was-validated .form-check-input[data-v-804d79b6]:valid:checked{background-color:#198754}.form-check-input.is-valid[data-v-804d79b6]:focus,.was-validated .form-check-input[data-v-804d79b6]:valid:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid~.form-check-label[data-v-804d79b6],.was-validated .form-check-input:valid~.form-check-label[data-v-804d79b6]{color:#198754}.form-check-inline .form-check-input~.valid-feedback[data-v-804d79b6]{margin-left:.5em}.input-group .form-control.is-valid[data-v-804d79b6],.input-group .form-select.is-valid[data-v-804d79b6],.was-validated .input-group .form-control[data-v-804d79b6]:valid,.was-validated .input-group .form-select[data-v-804d79b6]:valid{z-index:1}.input-group .form-control.is-valid[data-v-804d79b6]:focus,.input-group .form-select.is-valid[data-v-804d79b6]:focus,.was-validated .input-group .form-control[data-v-804d79b6]:valid:focus,.was-validated .input-group .form-select[data-v-804d79b6]:valid:focus{z-index:3}.invalid-feedback[data-v-804d79b6]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#dc3545}.invalid-tooltip[data-v-804d79b6]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(220,53,69,.9);border-radius:.25rem}.is-invalid~.invalid-feedback[data-v-804d79b6],.is-invalid~.invalid-tooltip[data-v-804d79b6],.was-validated :invalid~.invalid-feedback[data-v-804d79b6],.was-validated :invalid~.invalid-tooltip[data-v-804d79b6]{display:block}.form-control.is-invalid[data-v-804d79b6],.was-validated .form-control[data-v-804d79b6]:invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-invalid[data-v-804d79b6]:focus,.was-validated .form-control[data-v-804d79b6]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.was-validated textarea.form-control[data-v-804d79b6]:invalid,textarea.form-control.is-invalid[data-v-804d79b6]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-invalid[data-v-804d79b6],.was-validated .form-select[data-v-804d79b6]:invalid{border-color:#dc3545}.form-select.is-invalid:not([multiple])[size=\"1\"][data-v-804d79b6],.form-select.is-invalid[data-v-804d79b6]:not([multiple]):not([size]),.was-validated .form-select:invalid:not([multiple])[size=\"1\"][data-v-804d79b6],.was-validated .form-select[data-v-804d79b6]:invalid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-invalid[data-v-804d79b6]:focus,.was-validated .form-select[data-v-804d79b6]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid[data-v-804d79b6],.was-validated .form-check-input[data-v-804d79b6]:invalid{border-color:#dc3545}.form-check-input.is-invalid[data-v-804d79b6]:checked,.was-validated .form-check-input[data-v-804d79b6]:invalid:checked{background-color:#dc3545}.form-check-input.is-invalid[data-v-804d79b6]:focus,.was-validated .form-check-input[data-v-804d79b6]:invalid:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid~.form-check-label[data-v-804d79b6],.was-validated .form-check-input:invalid~.form-check-label[data-v-804d79b6]{color:#dc3545}.form-check-inline .form-check-input~.invalid-feedback[data-v-804d79b6]{margin-left:.5em}.input-group .form-control.is-invalid[data-v-804d79b6],.input-group .form-select.is-invalid[data-v-804d79b6],.was-validated .input-group .form-control[data-v-804d79b6]:invalid,.was-validated .input-group .form-select[data-v-804d79b6]:invalid{z-index:2}.input-group .form-control.is-invalid[data-v-804d79b6]:focus,.input-group .form-select.is-invalid[data-v-804d79b6]:focus,.was-validated .input-group .form-control[data-v-804d79b6]:invalid:focus,.was-validated .input-group .form-select[data-v-804d79b6]:invalid:focus{z-index:3}.btn[data-v-804d79b6]{display:inline-block;font-weight:400;line-height:1.5;color:#212529;text-align:center;text-decoration:none;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn[data-v-804d79b6]{transition:none}}.btn[data-v-804d79b6]:hover{color:#212529}.btn-check:focus+.btn[data-v-804d79b6],.btn[data-v-804d79b6]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.btn.disabled[data-v-804d79b6],.btn[data-v-804d79b6]:disabled,fieldset:disabled .btn[data-v-804d79b6]{pointer-events:none;opacity:.65}.btn-primary[data-v-804d79b6]{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-primary[data-v-804d79b6]:hover{color:#fff;background-color:#0b5ed7;border-color:#0a58ca}.btn-check:focus+.btn-primary[data-v-804d79b6],.btn-primary[data-v-804d79b6]:focus{color:#fff;background-color:#0b5ed7;border-color:#0a58ca;box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-check:active+.btn-primary[data-v-804d79b6],.btn-check:checked+.btn-primary[data-v-804d79b6],.btn-primary.active[data-v-804d79b6],.btn-primary[data-v-804d79b6]:active,.show>.btn-primary.dropdown-toggle[data-v-804d79b6]{color:#fff;background-color:#0a58ca;border-color:#0a53be}.btn-check:active+.btn-primary[data-v-804d79b6]:focus,.btn-check:checked+.btn-primary[data-v-804d79b6]:focus,.btn-primary.active[data-v-804d79b6]:focus,.btn-primary[data-v-804d79b6]:active:focus,.show>.btn-primary.dropdown-toggle[data-v-804d79b6]:focus{box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-primary.disabled[data-v-804d79b6],.btn-primary[data-v-804d79b6]:disabled{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-secondary[data-v-804d79b6]{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary[data-v-804d79b6]:hover{color:#fff;background-color:#5c636a;border-color:#565e64}.btn-check:focus+.btn-secondary[data-v-804d79b6],.btn-secondary[data-v-804d79b6]:focus{color:#fff;background-color:#5c636a;border-color:#565e64;box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-check:active+.btn-secondary[data-v-804d79b6],.btn-check:checked+.btn-secondary[data-v-804d79b6],.btn-secondary.active[data-v-804d79b6],.btn-secondary[data-v-804d79b6]:active,.show>.btn-secondary.dropdown-toggle[data-v-804d79b6]{color:#fff;background-color:#565e64;border-color:#51585e}.btn-check:active+.btn-secondary[data-v-804d79b6]:focus,.btn-check:checked+.btn-secondary[data-v-804d79b6]:focus,.btn-secondary.active[data-v-804d79b6]:focus,.btn-secondary[data-v-804d79b6]:active:focus,.show>.btn-secondary.dropdown-toggle[data-v-804d79b6]:focus{box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-secondary.disabled[data-v-804d79b6],.btn-secondary[data-v-804d79b6]:disabled{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-success[data-v-804d79b6]{color:#fff;background-color:#198754;border-color:#198754}.btn-success[data-v-804d79b6]:hover{color:#fff;background-color:#157347;border-color:#146c43}.btn-check:focus+.btn-success[data-v-804d79b6],.btn-success[data-v-804d79b6]:focus{color:#fff;background-color:#157347;border-color:#146c43;box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-check:active+.btn-success[data-v-804d79b6],.btn-check:checked+.btn-success[data-v-804d79b6],.btn-success.active[data-v-804d79b6],.btn-success[data-v-804d79b6]:active,.show>.btn-success.dropdown-toggle[data-v-804d79b6]{color:#fff;background-color:#146c43;border-color:#13653f}.btn-check:active+.btn-success[data-v-804d79b6]:focus,.btn-check:checked+.btn-success[data-v-804d79b6]:focus,.btn-success.active[data-v-804d79b6]:focus,.btn-success[data-v-804d79b6]:active:focus,.show>.btn-success.dropdown-toggle[data-v-804d79b6]:focus{box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-success.disabled[data-v-804d79b6],.btn-success[data-v-804d79b6]:disabled{color:#fff;background-color:#198754;border-color:#198754}.btn-info[data-v-804d79b6]{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-info[data-v-804d79b6]:hover{color:#000;background-color:#31d2f2;border-color:#25cff2}.btn-check:focus+.btn-info[data-v-804d79b6],.btn-info[data-v-804d79b6]:focus{color:#000;background-color:#31d2f2;border-color:#25cff2;box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-check:active+.btn-info[data-v-804d79b6],.btn-check:checked+.btn-info[data-v-804d79b6],.btn-info.active[data-v-804d79b6],.btn-info[data-v-804d79b6]:active,.show>.btn-info.dropdown-toggle[data-v-804d79b6]{color:#000;background-color:#3dd5f3;border-color:#25cff2}.btn-check:active+.btn-info[data-v-804d79b6]:focus,.btn-check:checked+.btn-info[data-v-804d79b6]:focus,.btn-info.active[data-v-804d79b6]:focus,.btn-info[data-v-804d79b6]:active:focus,.show>.btn-info.dropdown-toggle[data-v-804d79b6]:focus{box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-info.disabled[data-v-804d79b6],.btn-info[data-v-804d79b6]:disabled{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-warning[data-v-804d79b6]{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-warning[data-v-804d79b6]:hover{color:#000;background-color:#ffca2c;border-color:#ffc720}.btn-check:focus+.btn-warning[data-v-804d79b6],.btn-warning[data-v-804d79b6]:focus{color:#000;background-color:#ffca2c;border-color:#ffc720;box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-check:active+.btn-warning[data-v-804d79b6],.btn-check:checked+.btn-warning[data-v-804d79b6],.btn-warning.active[data-v-804d79b6],.btn-warning[data-v-804d79b6]:active,.show>.btn-warning.dropdown-toggle[data-v-804d79b6]{color:#000;background-color:#ffcd39;border-color:#ffc720}.btn-check:active+.btn-warning[data-v-804d79b6]:focus,.btn-check:checked+.btn-warning[data-v-804d79b6]:focus,.btn-warning.active[data-v-804d79b6]:focus,.btn-warning[data-v-804d79b6]:active:focus,.show>.btn-warning.dropdown-toggle[data-v-804d79b6]:focus{box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-warning.disabled[data-v-804d79b6],.btn-warning[data-v-804d79b6]:disabled{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-danger[data-v-804d79b6]{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger[data-v-804d79b6]:hover{color:#fff;background-color:#bb2d3b;border-color:#b02a37}.btn-check:focus+.btn-danger[data-v-804d79b6],.btn-danger[data-v-804d79b6]:focus{color:#fff;background-color:#bb2d3b;border-color:#b02a37;box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-check:active+.btn-danger[data-v-804d79b6],.btn-check:checked+.btn-danger[data-v-804d79b6],.btn-danger.active[data-v-804d79b6],.btn-danger[data-v-804d79b6]:active,.show>.btn-danger.dropdown-toggle[data-v-804d79b6]{color:#fff;background-color:#b02a37;border-color:#a52834}.btn-check:active+.btn-danger[data-v-804d79b6]:focus,.btn-check:checked+.btn-danger[data-v-804d79b6]:focus,.btn-danger.active[data-v-804d79b6]:focus,.btn-danger[data-v-804d79b6]:active:focus,.show>.btn-danger.dropdown-toggle[data-v-804d79b6]:focus{box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-danger.disabled[data-v-804d79b6],.btn-danger[data-v-804d79b6]:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-light[data-v-804d79b6]{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light[data-v-804d79b6]:hover{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:focus+.btn-light[data-v-804d79b6],.btn-light[data-v-804d79b6]:focus{color:#000;background-color:#f9fafb;border-color:#f9fafb;box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-check:active+.btn-light[data-v-804d79b6],.btn-check:checked+.btn-light[data-v-804d79b6],.btn-light.active[data-v-804d79b6],.btn-light[data-v-804d79b6]:active,.show>.btn-light.dropdown-toggle[data-v-804d79b6]{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:active+.btn-light[data-v-804d79b6]:focus,.btn-check:checked+.btn-light[data-v-804d79b6]:focus,.btn-light.active[data-v-804d79b6]:focus,.btn-light[data-v-804d79b6]:active:focus,.show>.btn-light.dropdown-toggle[data-v-804d79b6]:focus{box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-light.disabled[data-v-804d79b6],.btn-light[data-v-804d79b6]:disabled{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-dark[data-v-804d79b6]{color:#fff;background-color:#212529;border-color:#212529}.btn-dark[data-v-804d79b6]:hover{color:#fff;background-color:#1c1f23;border-color:#1a1e21}.btn-check:focus+.btn-dark[data-v-804d79b6],.btn-dark[data-v-804d79b6]:focus{color:#fff;background-color:#1c1f23;border-color:#1a1e21;box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-check:active+.btn-dark[data-v-804d79b6],.btn-check:checked+.btn-dark[data-v-804d79b6],.btn-dark.active[data-v-804d79b6],.btn-dark[data-v-804d79b6]:active,.show>.btn-dark.dropdown-toggle[data-v-804d79b6]{color:#fff;background-color:#1a1e21;border-color:#191c1f}.btn-check:active+.btn-dark[data-v-804d79b6]:focus,.btn-check:checked+.btn-dark[data-v-804d79b6]:focus,.btn-dark.active[data-v-804d79b6]:focus,.btn-dark[data-v-804d79b6]:active:focus,.show>.btn-dark.dropdown-toggle[data-v-804d79b6]:focus{box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-dark.disabled[data-v-804d79b6],.btn-dark[data-v-804d79b6]:disabled{color:#fff;background-color:#212529;border-color:#212529}.btn-outline-primary[data-v-804d79b6]{color:#0d6efd;border-color:#0d6efd}.btn-outline-primary[data-v-804d79b6]:hover{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:focus+.btn-outline-primary[data-v-804d79b6],.btn-outline-primary[data-v-804d79b6]:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-check:active+.btn-outline-primary[data-v-804d79b6],.btn-check:checked+.btn-outline-primary[data-v-804d79b6],.btn-outline-primary.active[data-v-804d79b6],.btn-outline-primary.dropdown-toggle.show[data-v-804d79b6],.btn-outline-primary[data-v-804d79b6]:active{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:active+.btn-outline-primary[data-v-804d79b6]:focus,.btn-check:checked+.btn-outline-primary[data-v-804d79b6]:focus,.btn-outline-primary.active[data-v-804d79b6]:focus,.btn-outline-primary.dropdown-toggle.show[data-v-804d79b6]:focus,.btn-outline-primary[data-v-804d79b6]:active:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-outline-primary.disabled[data-v-804d79b6],.btn-outline-primary[data-v-804d79b6]:disabled{color:#0d6efd;background-color:transparent}.btn-outline-secondary[data-v-804d79b6]{color:#6c757d;border-color:#6c757d}.btn-outline-secondary[data-v-804d79b6]:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:focus+.btn-outline-secondary[data-v-804d79b6],.btn-outline-secondary[data-v-804d79b6]:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-check:active+.btn-outline-secondary[data-v-804d79b6],.btn-check:checked+.btn-outline-secondary[data-v-804d79b6],.btn-outline-secondary.active[data-v-804d79b6],.btn-outline-secondary.dropdown-toggle.show[data-v-804d79b6],.btn-outline-secondary[data-v-804d79b6]:active{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:active+.btn-outline-secondary[data-v-804d79b6]:focus,.btn-check:checked+.btn-outline-secondary[data-v-804d79b6]:focus,.btn-outline-secondary.active[data-v-804d79b6]:focus,.btn-outline-secondary.dropdown-toggle.show[data-v-804d79b6]:focus,.btn-outline-secondary[data-v-804d79b6]:active:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-outline-secondary.disabled[data-v-804d79b6],.btn-outline-secondary[data-v-804d79b6]:disabled{color:#6c757d;background-color:transparent}.btn-outline-success[data-v-804d79b6]{color:#198754;border-color:#198754}.btn-outline-success[data-v-804d79b6]:hover{color:#fff;background-color:#198754;border-color:#198754}.btn-check:focus+.btn-outline-success[data-v-804d79b6],.btn-outline-success[data-v-804d79b6]:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-check:active+.btn-outline-success[data-v-804d79b6],.btn-check:checked+.btn-outline-success[data-v-804d79b6],.btn-outline-success.active[data-v-804d79b6],.btn-outline-success.dropdown-toggle.show[data-v-804d79b6],.btn-outline-success[data-v-804d79b6]:active{color:#fff;background-color:#198754;border-color:#198754}.btn-check:active+.btn-outline-success[data-v-804d79b6]:focus,.btn-check:checked+.btn-outline-success[data-v-804d79b6]:focus,.btn-outline-success.active[data-v-804d79b6]:focus,.btn-outline-success.dropdown-toggle.show[data-v-804d79b6]:focus,.btn-outline-success[data-v-804d79b6]:active:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-outline-success.disabled[data-v-804d79b6],.btn-outline-success[data-v-804d79b6]:disabled{color:#198754;background-color:transparent}.btn-outline-info[data-v-804d79b6]{color:#0dcaf0;border-color:#0dcaf0}.btn-outline-info[data-v-804d79b6]:hover{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:focus+.btn-outline-info[data-v-804d79b6],.btn-outline-info[data-v-804d79b6]:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-check:active+.btn-outline-info[data-v-804d79b6],.btn-check:checked+.btn-outline-info[data-v-804d79b6],.btn-outline-info.active[data-v-804d79b6],.btn-outline-info.dropdown-toggle.show[data-v-804d79b6],.btn-outline-info[data-v-804d79b6]:active{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:active+.btn-outline-info[data-v-804d79b6]:focus,.btn-check:checked+.btn-outline-info[data-v-804d79b6]:focus,.btn-outline-info.active[data-v-804d79b6]:focus,.btn-outline-info.dropdown-toggle.show[data-v-804d79b6]:focus,.btn-outline-info[data-v-804d79b6]:active:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-outline-info.disabled[data-v-804d79b6],.btn-outline-info[data-v-804d79b6]:disabled{color:#0dcaf0;background-color:transparent}.btn-outline-warning[data-v-804d79b6]{color:#ffc107;border-color:#ffc107}.btn-outline-warning[data-v-804d79b6]:hover{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:focus+.btn-outline-warning[data-v-804d79b6],.btn-outline-warning[data-v-804d79b6]:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-check:active+.btn-outline-warning[data-v-804d79b6],.btn-check:checked+.btn-outline-warning[data-v-804d79b6],.btn-outline-warning.active[data-v-804d79b6],.btn-outline-warning.dropdown-toggle.show[data-v-804d79b6],.btn-outline-warning[data-v-804d79b6]:active{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:active+.btn-outline-warning[data-v-804d79b6]:focus,.btn-check:checked+.btn-outline-warning[data-v-804d79b6]:focus,.btn-outline-warning.active[data-v-804d79b6]:focus,.btn-outline-warning.dropdown-toggle.show[data-v-804d79b6]:focus,.btn-outline-warning[data-v-804d79b6]:active:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-outline-warning.disabled[data-v-804d79b6],.btn-outline-warning[data-v-804d79b6]:disabled{color:#ffc107;background-color:transparent}.btn-outline-danger[data-v-804d79b6]{color:#dc3545;border-color:#dc3545}.btn-outline-danger[data-v-804d79b6]:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:focus+.btn-outline-danger[data-v-804d79b6],.btn-outline-danger[data-v-804d79b6]:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-check:active+.btn-outline-danger[data-v-804d79b6],.btn-check:checked+.btn-outline-danger[data-v-804d79b6],.btn-outline-danger.active[data-v-804d79b6],.btn-outline-danger.dropdown-toggle.show[data-v-804d79b6],.btn-outline-danger[data-v-804d79b6]:active{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:active+.btn-outline-danger[data-v-804d79b6]:focus,.btn-check:checked+.btn-outline-danger[data-v-804d79b6]:focus,.btn-outline-danger.active[data-v-804d79b6]:focus,.btn-outline-danger.dropdown-toggle.show[data-v-804d79b6]:focus,.btn-outline-danger[data-v-804d79b6]:active:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-outline-danger.disabled[data-v-804d79b6],.btn-outline-danger[data-v-804d79b6]:disabled{color:#dc3545;background-color:transparent}.btn-outline-light[data-v-804d79b6]{color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light[data-v-804d79b6]:hover{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:focus+.btn-outline-light[data-v-804d79b6],.btn-outline-light[data-v-804d79b6]:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-check:active+.btn-outline-light[data-v-804d79b6],.btn-check:checked+.btn-outline-light[data-v-804d79b6],.btn-outline-light.active[data-v-804d79b6],.btn-outline-light.dropdown-toggle.show[data-v-804d79b6],.btn-outline-light[data-v-804d79b6]:active{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:active+.btn-outline-light[data-v-804d79b6]:focus,.btn-check:checked+.btn-outline-light[data-v-804d79b6]:focus,.btn-outline-light.active[data-v-804d79b6]:focus,.btn-outline-light.dropdown-toggle.show[data-v-804d79b6]:focus,.btn-outline-light[data-v-804d79b6]:active:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-outline-light.disabled[data-v-804d79b6],.btn-outline-light[data-v-804d79b6]:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-dark[data-v-804d79b6]{color:#212529;border-color:#212529}.btn-outline-dark[data-v-804d79b6]:hover{color:#fff;background-color:#212529;border-color:#212529}.btn-check:focus+.btn-outline-dark[data-v-804d79b6],.btn-outline-dark[data-v-804d79b6]:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-check:active+.btn-outline-dark[data-v-804d79b6],.btn-check:checked+.btn-outline-dark[data-v-804d79b6],.btn-outline-dark.active[data-v-804d79b6],.btn-outline-dark.dropdown-toggle.show[data-v-804d79b6],.btn-outline-dark[data-v-804d79b6]:active{color:#fff;background-color:#212529;border-color:#212529}.btn-check:active+.btn-outline-dark[data-v-804d79b6]:focus,.btn-check:checked+.btn-outline-dark[data-v-804d79b6]:focus,.btn-outline-dark.active[data-v-804d79b6]:focus,.btn-outline-dark.dropdown-toggle.show[data-v-804d79b6]:focus,.btn-outline-dark[data-v-804d79b6]:active:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-outline-dark.disabled[data-v-804d79b6],.btn-outline-dark[data-v-804d79b6]:disabled{color:#212529;background-color:transparent}.btn-link[data-v-804d79b6]{font-weight:400;color:#0d6efd;text-decoration:underline}.btn-link[data-v-804d79b6]:hover{color:#0a58ca}.btn-link.disabled[data-v-804d79b6],.btn-link[data-v-804d79b6]:disabled{color:#6c757d}.btn-group-lg>.btn[data-v-804d79b6],.btn-lg[data-v-804d79b6]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.btn-group-sm>.btn[data-v-804d79b6],.btn-sm[data-v-804d79b6]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.fade[data-v-804d79b6]{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade[data-v-804d79b6]{transition:none}}.fade[data-v-804d79b6]:not(.show){opacity:0}.collapse[data-v-804d79b6]:not(.show){display:none}.collapsing[data-v-804d79b6]{height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.collapsing[data-v-804d79b6]{transition:none}}.collapsing.collapse-horizontal[data-v-804d79b6]{width:0;height:auto;transition:width .35s ease}@media (prefers-reduced-motion:reduce){.collapsing.collapse-horizontal[data-v-804d79b6]{transition:none}}.dropdown[data-v-804d79b6],.dropend[data-v-804d79b6],.dropstart[data-v-804d79b6],.dropup[data-v-804d79b6]{position:relative}.dropdown-toggle[data-v-804d79b6]{white-space:nowrap}.dropdown-toggle[data-v-804d79b6]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle[data-v-804d79b6]:empty:after{margin-left:0}.dropdown-menu[data-v-804d79b6]{position:absolute;z-index:1000;display:none;min-width:10rem;padding:.5rem 0;margin:0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-menu[data-bs-popper][data-v-804d79b6]{top:100%;left:0;margin-top:.125rem}.dropdown-menu-start[data-v-804d79b6]{--bs-position:start}.dropdown-menu-start[data-bs-popper][data-v-804d79b6]{right:auto;left:0}.dropdown-menu-end[data-v-804d79b6]{--bs-position:end}.dropdown-menu-end[data-bs-popper][data-v-804d79b6]{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-start[data-v-804d79b6]{--bs-position:start}.dropdown-menu-sm-start[data-bs-popper][data-v-804d79b6]{right:auto;left:0}.dropdown-menu-sm-end[data-v-804d79b6]{--bs-position:end}.dropdown-menu-sm-end[data-bs-popper][data-v-804d79b6]{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-start[data-v-804d79b6]{--bs-position:start}.dropdown-menu-md-start[data-bs-popper][data-v-804d79b6]{right:auto;left:0}.dropdown-menu-md-end[data-v-804d79b6]{--bs-position:end}.dropdown-menu-md-end[data-bs-popper][data-v-804d79b6]{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-start[data-v-804d79b6]{--bs-position:start}.dropdown-menu-lg-start[data-bs-popper][data-v-804d79b6]{right:auto;left:0}.dropdown-menu-lg-end[data-v-804d79b6]{--bs-position:end}.dropdown-menu-lg-end[data-bs-popper][data-v-804d79b6]{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-start[data-v-804d79b6]{--bs-position:start}.dropdown-menu-xl-start[data-bs-popper][data-v-804d79b6]{right:auto;left:0}.dropdown-menu-xl-end[data-v-804d79b6]{--bs-position:end}.dropdown-menu-xl-end[data-bs-popper][data-v-804d79b6]{right:0;left:auto}}@media (min-width:1400px){.dropdown-menu-xxl-start[data-v-804d79b6]{--bs-position:start}.dropdown-menu-xxl-start[data-bs-popper][data-v-804d79b6]{right:auto;left:0}.dropdown-menu-xxl-end[data-v-804d79b6]{--bs-position:end}.dropdown-menu-xxl-end[data-bs-popper][data-v-804d79b6]{right:0;left:auto}}.dropup .dropdown-menu[data-bs-popper][data-v-804d79b6]{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle[data-v-804d79b6]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle[data-v-804d79b6]:empty:after{margin-left:0}.dropend .dropdown-menu[data-bs-popper][data-v-804d79b6]{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.dropend .dropdown-toggle[data-v-804d79b6]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropend .dropdown-toggle[data-v-804d79b6]:empty:after{margin-left:0}.dropend .dropdown-toggle[data-v-804d79b6]:after{vertical-align:0}.dropstart .dropdown-menu[data-bs-popper][data-v-804d79b6]{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.dropstart .dropdown-toggle[data-v-804d79b6]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";display:none}.dropstart .dropdown-toggle[data-v-804d79b6]:before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropstart .dropdown-toggle[data-v-804d79b6]:empty:after{margin-left:0}.dropstart .dropdown-toggle[data-v-804d79b6]:before{vertical-align:0}.dropdown-divider[data-v-804d79b6]{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid rgba(0,0,0,.15)}.dropdown-item[data-v-804d79b6]{display:block;width:100%;padding:.25rem 1rem;clear:both;font-weight:400;color:#212529;text-align:inherit;text-decoration:none;white-space:nowrap;background-color:transparent;border:0}.dropdown-item[data-v-804d79b6]:focus,.dropdown-item[data-v-804d79b6]:hover{color:#1e2125;background-color:#e9ecef}.dropdown-item.active[data-v-804d79b6],.dropdown-item[data-v-804d79b6]:active{color:#fff;text-decoration:none;background-color:#0d6efd}.dropdown-item.disabled[data-v-804d79b6],.dropdown-item[data-v-804d79b6]:disabled{color:#adb5bd;pointer-events:none;background-color:transparent}.dropdown-menu.show[data-v-804d79b6]{display:block}.dropdown-header[data-v-804d79b6]{display:block;padding:.5rem 1rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.dropdown-item-text[data-v-804d79b6]{display:block;padding:.25rem 1rem;color:#212529}.dropdown-menu-dark[data-v-804d79b6]{color:#dee2e6;background-color:#343a40;border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item[data-v-804d79b6]{color:#dee2e6}.dropdown-menu-dark .dropdown-item[data-v-804d79b6]:focus,.dropdown-menu-dark .dropdown-item[data-v-804d79b6]:hover{color:#fff;background-color:hsla(0,0%,100%,.15)}.dropdown-menu-dark .dropdown-item.active[data-v-804d79b6],.dropdown-menu-dark .dropdown-item[data-v-804d79b6]:active{color:#fff;background-color:#0d6efd}.dropdown-menu-dark .dropdown-item.disabled[data-v-804d79b6],.dropdown-menu-dark .dropdown-item[data-v-804d79b6]:disabled{color:#adb5bd}.dropdown-menu-dark .dropdown-divider[data-v-804d79b6]{border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item-text[data-v-804d79b6]{color:#dee2e6}.dropdown-menu-dark .dropdown-header[data-v-804d79b6]{color:#adb5bd}.btn-group-vertical[data-v-804d79b6],.btn-group[data-v-804d79b6]{position:relative;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn[data-v-804d79b6],.btn-group>.btn[data-v-804d79b6]{position:relative;flex:1 1 auto}.btn-group-vertical>.btn-check:checked+.btn[data-v-804d79b6],.btn-group-vertical>.btn-check:focus+.btn[data-v-804d79b6],.btn-group-vertical>.btn.active[data-v-804d79b6],.btn-group-vertical>.btn[data-v-804d79b6]:active,.btn-group-vertical>.btn[data-v-804d79b6]:focus,.btn-group-vertical>.btn[data-v-804d79b6]:hover,.btn-group>.btn-check:checked+.btn[data-v-804d79b6],.btn-group>.btn-check:focus+.btn[data-v-804d79b6],.btn-group>.btn.active[data-v-804d79b6],.btn-group>.btn[data-v-804d79b6]:active,.btn-group>.btn[data-v-804d79b6]:focus,.btn-group>.btn[data-v-804d79b6]:hover{z-index:1}.btn-toolbar[data-v-804d79b6]{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar .input-group[data-v-804d79b6]{width:auto}.btn-group>.btn-group[data-v-804d79b6]:not(:first-child),.btn-group>.btn[data-v-804d79b6]:not(:first-child){margin-left:-1px}.btn-group>.btn-group:not(:last-child)>.btn[data-v-804d79b6],.btn-group>.btn[data-v-804d79b6]:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn[data-v-804d79b6],.btn-group>.btn[data-v-804d79b6]:nth-child(n+3),.btn-group>:not(.btn-check)+.btn[data-v-804d79b6]{border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split[data-v-804d79b6]{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split[data-v-804d79b6]:after,.dropend .dropdown-toggle-split[data-v-804d79b6]:after,.dropup .dropdown-toggle-split[data-v-804d79b6]:after{margin-left:0}.dropstart .dropdown-toggle-split[data-v-804d79b6]:before{margin-right:0}.btn-group-sm>.btn+.dropdown-toggle-split[data-v-804d79b6],.btn-sm+.dropdown-toggle-split[data-v-804d79b6]{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split[data-v-804d79b6],.btn-lg+.dropdown-toggle-split[data-v-804d79b6]{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical[data-v-804d79b6]{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical>.btn-group[data-v-804d79b6],.btn-group-vertical>.btn[data-v-804d79b6]{width:100%}.btn-group-vertical>.btn-group[data-v-804d79b6]:not(:first-child),.btn-group-vertical>.btn[data-v-804d79b6]:not(:first-child){margin-top:-1px}.btn-group-vertical>.btn-group:not(:last-child)>.btn[data-v-804d79b6],.btn-group-vertical>.btn[data-v-804d79b6]:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn[data-v-804d79b6],.btn-group-vertical>.btn~.btn[data-v-804d79b6]{border-top-left-radius:0;border-top-right-radius:0}.nav[data-v-804d79b6]{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link[data-v-804d79b6]{display:block;padding:.5rem 1rem;color:#0d6efd;text-decoration:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out}@media (prefers-reduced-motion:reduce){.nav-link[data-v-804d79b6]{transition:none}}.nav-link[data-v-804d79b6]:focus,.nav-link[data-v-804d79b6]:hover{color:#0a58ca}.nav-link.disabled[data-v-804d79b6]{color:#6c757d;pointer-events:none;cursor:default}.nav-tabs[data-v-804d79b6]{border-bottom:1px solid #dee2e6}.nav-tabs .nav-link[data-v-804d79b6]{margin-bottom:-1px;background:0 0;border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link[data-v-804d79b6]:focus,.nav-tabs .nav-link[data-v-804d79b6]:hover{border-color:#e9ecef #e9ecef #dee2e6;isolation:isolate}.nav-tabs .nav-link.disabled[data-v-804d79b6]{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link[data-v-804d79b6],.nav-tabs .nav-link.active[data-v-804d79b6]{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu[data-v-804d79b6]{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link[data-v-804d79b6]{background:0 0;border:0;border-radius:.25rem}.nav-pills .nav-link.active[data-v-804d79b6],.nav-pills .show>.nav-link[data-v-804d79b6]{color:#fff;background-color:#0d6efd}.nav-fill .nav-item[data-v-804d79b6],.nav-fill>.nav-link[data-v-804d79b6]{flex:1 1 auto;text-align:center}.nav-justified .nav-item[data-v-804d79b6],.nav-justified>.nav-link[data-v-804d79b6]{flex-basis:0;flex-grow:1;text-align:center}.nav-fill .nav-item .nav-link[data-v-804d79b6],.nav-justified .nav-item .nav-link[data-v-804d79b6]{width:100%}.tab-content>.tab-pane[data-v-804d79b6]{display:none}.tab-content>.active[data-v-804d79b6]{display:block}.navbar[data-v-804d79b6]{position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding-top:.5rem;padding-bottom:.5rem}.navbar>.container-fluid[data-v-804d79b6],.navbar>.container-lg[data-v-804d79b6],.navbar>.container-md[data-v-804d79b6],.navbar>.container-sm[data-v-804d79b6],.navbar>.container-xl[data-v-804d79b6],.navbar>.container-xxl[data-v-804d79b6],.navbar>.container[data-v-804d79b6]{display:flex;flex-wrap:inherit;align-items:center;justify-content:space-between}.navbar-brand[data-v-804d79b6]{padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;text-decoration:none;white-space:nowrap}.navbar-nav[data-v-804d79b6]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link[data-v-804d79b6]{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu[data-v-804d79b6]{position:static}.navbar-text[data-v-804d79b6]{padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse[data-v-804d79b6]{flex-basis:100%;flex-grow:1;align-items:center}.navbar-toggler[data-v-804d79b6]{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem;transition:box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.navbar-toggler[data-v-804d79b6]{transition:none}}.navbar-toggler[data-v-804d79b6]:hover{text-decoration:none}.navbar-toggler[data-v-804d79b6]:focus{text-decoration:none;outline:0;box-shadow:0 0 0 .25rem}.navbar-toggler-icon[data-v-804d79b6]{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;background-repeat:no-repeat;background-position:50%;background-size:100%}.navbar-nav-scroll[data-v-804d79b6]{max-height:var(--bs-scroll-height,75vh);overflow-y:auto}@media (min-width:576px){.navbar-expand-sm[data-v-804d79b6]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-sm .navbar-nav[data-v-804d79b6]{flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu[data-v-804d79b6]{position:absolute}.navbar-expand-sm .navbar-nav .nav-link[data-v-804d79b6]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm .navbar-nav-scroll[data-v-804d79b6]{overflow:visible}.navbar-expand-sm .navbar-collapse[data-v-804d79b6]{display:flex!important;flex-basis:auto}.navbar-expand-sm .navbar-toggler[data-v-804d79b6],.navbar-expand-sm .offcanvas-header[data-v-804d79b6]{display:none}.navbar-expand-sm .offcanvas[data-v-804d79b6]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-sm .offcanvas-bottom[data-v-804d79b6],.navbar-expand-sm .offcanvas-top[data-v-804d79b6]{height:auto;border-top:0;border-bottom:0}.navbar-expand-sm .offcanvas-body[data-v-804d79b6]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:768px){.navbar-expand-md[data-v-804d79b6]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-md .navbar-nav[data-v-804d79b6]{flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu[data-v-804d79b6]{position:absolute}.navbar-expand-md .navbar-nav .nav-link[data-v-804d79b6]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md .navbar-nav-scroll[data-v-804d79b6]{overflow:visible}.navbar-expand-md .navbar-collapse[data-v-804d79b6]{display:flex!important;flex-basis:auto}.navbar-expand-md .navbar-toggler[data-v-804d79b6],.navbar-expand-md .offcanvas-header[data-v-804d79b6]{display:none}.navbar-expand-md .offcanvas[data-v-804d79b6]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-md .offcanvas-bottom[data-v-804d79b6],.navbar-expand-md .offcanvas-top[data-v-804d79b6]{height:auto;border-top:0;border-bottom:0}.navbar-expand-md .offcanvas-body[data-v-804d79b6]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:992px){.navbar-expand-lg[data-v-804d79b6]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-lg .navbar-nav[data-v-804d79b6]{flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu[data-v-804d79b6]{position:absolute}.navbar-expand-lg .navbar-nav .nav-link[data-v-804d79b6]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg .navbar-nav-scroll[data-v-804d79b6]{overflow:visible}.navbar-expand-lg .navbar-collapse[data-v-804d79b6]{display:flex!important;flex-basis:auto}.navbar-expand-lg .navbar-toggler[data-v-804d79b6],.navbar-expand-lg .offcanvas-header[data-v-804d79b6]{display:none}.navbar-expand-lg .offcanvas[data-v-804d79b6]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-lg .offcanvas-bottom[data-v-804d79b6],.navbar-expand-lg .offcanvas-top[data-v-804d79b6]{height:auto;border-top:0;border-bottom:0}.navbar-expand-lg .offcanvas-body[data-v-804d79b6]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1200px){.navbar-expand-xl[data-v-804d79b6]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xl .navbar-nav[data-v-804d79b6]{flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu[data-v-804d79b6]{position:absolute}.navbar-expand-xl .navbar-nav .nav-link[data-v-804d79b6]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl .navbar-nav-scroll[data-v-804d79b6]{overflow:visible}.navbar-expand-xl .navbar-collapse[data-v-804d79b6]{display:flex!important;flex-basis:auto}.navbar-expand-xl .navbar-toggler[data-v-804d79b6],.navbar-expand-xl .offcanvas-header[data-v-804d79b6]{display:none}.navbar-expand-xl .offcanvas[data-v-804d79b6]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xl .offcanvas-bottom[data-v-804d79b6],.navbar-expand-xl .offcanvas-top[data-v-804d79b6]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xl .offcanvas-body[data-v-804d79b6]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1400px){.navbar-expand-xxl[data-v-804d79b6]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xxl .navbar-nav[data-v-804d79b6]{flex-direction:row}.navbar-expand-xxl .navbar-nav .dropdown-menu[data-v-804d79b6]{position:absolute}.navbar-expand-xxl .navbar-nav .nav-link[data-v-804d79b6]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xxl .navbar-nav-scroll[data-v-804d79b6]{overflow:visible}.navbar-expand-xxl .navbar-collapse[data-v-804d79b6]{display:flex!important;flex-basis:auto}.navbar-expand-xxl .navbar-toggler[data-v-804d79b6],.navbar-expand-xxl .offcanvas-header[data-v-804d79b6]{display:none}.navbar-expand-xxl .offcanvas[data-v-804d79b6]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xxl .offcanvas-bottom[data-v-804d79b6],.navbar-expand-xxl .offcanvas-top[data-v-804d79b6]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xxl .offcanvas-body[data-v-804d79b6]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}.navbar-expand[data-v-804d79b6]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand .navbar-nav[data-v-804d79b6]{flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu[data-v-804d79b6]{position:absolute}.navbar-expand .navbar-nav .nav-link[data-v-804d79b6]{padding-right:.5rem;padding-left:.5rem}.navbar-expand .navbar-nav-scroll[data-v-804d79b6]{overflow:visible}.navbar-expand .navbar-collapse[data-v-804d79b6]{display:flex!important;flex-basis:auto}.navbar-expand .navbar-toggler[data-v-804d79b6],.navbar-expand .offcanvas-header[data-v-804d79b6]{display:none}.navbar-expand .offcanvas[data-v-804d79b6]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand .offcanvas-bottom[data-v-804d79b6],.navbar-expand .offcanvas-top[data-v-804d79b6]{height:auto;border-top:0;border-bottom:0}.navbar-expand .offcanvas-body[data-v-804d79b6]{display:flex;flex-grow:0;padding:0;overflow-y:visible}.navbar-light .navbar-brand[data-v-804d79b6],.navbar-light .navbar-brand[data-v-804d79b6]:focus,.navbar-light .navbar-brand[data-v-804d79b6]:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link[data-v-804d79b6]{color:rgba(0,0,0,.55)}.navbar-light .navbar-nav .nav-link[data-v-804d79b6]:focus,.navbar-light .navbar-nav .nav-link[data-v-804d79b6]:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled[data-v-804d79b6]{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .nav-link.active[data-v-804d79b6],.navbar-light .navbar-nav .show>.nav-link[data-v-804d79b6]{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler[data-v-804d79b6]{color:rgba(0,0,0,.55);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon[data-v-804d79b6]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(0, 0, 0, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-light .navbar-text[data-v-804d79b6]{color:rgba(0,0,0,.55)}.navbar-light .navbar-text a[data-v-804d79b6],.navbar-light .navbar-text a[data-v-804d79b6]:focus,.navbar-light .navbar-text a[data-v-804d79b6]:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand[data-v-804d79b6],.navbar-dark .navbar-brand[data-v-804d79b6]:focus,.navbar-dark .navbar-brand[data-v-804d79b6]:hover{color:#fff}.navbar-dark .navbar-nav .nav-link[data-v-804d79b6]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-nav .nav-link[data-v-804d79b6]:focus,.navbar-dark .navbar-nav .nav-link[data-v-804d79b6]:hover{color:hsla(0,0%,100%,.75)}.navbar-dark .navbar-nav .nav-link.disabled[data-v-804d79b6]{color:hsla(0,0%,100%,.25)}.navbar-dark .navbar-nav .nav-link.active[data-v-804d79b6],.navbar-dark .navbar-nav .show>.nav-link[data-v-804d79b6]{color:#fff}.navbar-dark .navbar-toggler[data-v-804d79b6]{color:hsla(0,0%,100%,.55);border-color:hsla(0,0%,100%,.1)}.navbar-dark .navbar-toggler-icon[data-v-804d79b6]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(255, 255, 255, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-dark .navbar-text[data-v-804d79b6]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-text a[data-v-804d79b6],.navbar-dark .navbar-text a[data-v-804d79b6]:focus,.navbar-dark .navbar-text a[data-v-804d79b6]:hover{color:#fff}.card[data-v-804d79b6]{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr[data-v-804d79b6]{margin-right:0;margin-left:0}.card>.list-group[data-v-804d79b6]{border-top:inherit;border-bottom:inherit}.card>.list-group[data-v-804d79b6]:first-child{border-top-width:0;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card>.list-group[data-v-804d79b6]:last-child{border-bottom-width:0;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card>.card-header+.list-group[data-v-804d79b6],.card>.list-group+.card-footer[data-v-804d79b6]{border-top:0}.card-body[data-v-804d79b6]{flex:1 1 auto;padding:1rem}.card-title[data-v-804d79b6]{margin-bottom:.5rem}.card-subtitle[data-v-804d79b6]{margin-top:-.25rem;margin-bottom:0}.card-text[data-v-804d79b6]:last-child{margin-bottom:0}.card-link+.card-link[data-v-804d79b6]{margin-left:1rem}.card-header[data-v-804d79b6]{padding:.5rem 1rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header[data-v-804d79b6]:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-footer[data-v-804d79b6]{padding:.5rem 1rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer[data-v-804d79b6]:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs[data-v-804d79b6]{margin-bottom:-.5rem;border-bottom:0}.card-header-pills[data-v-804d79b6],.card-header-tabs[data-v-804d79b6]{margin-right:-.5rem;margin-left:-.5rem}.card-img-overlay[data-v-804d79b6]{position:absolute;top:0;right:0;bottom:0;left:0;padding:1rem;border-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-804d79b6],.card-img-top[data-v-804d79b6],.card-img[data-v-804d79b6]{width:100%}.card-img-top[data-v-804d79b6],.card-img[data-v-804d79b6]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-804d79b6],.card-img[data-v-804d79b6]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-group>.card[data-v-804d79b6]{margin-bottom:.75rem}@media (min-width:576px){.card-group[data-v-804d79b6]{display:flex;flex-flow:row wrap}.card-group>.card[data-v-804d79b6]{flex:1 0 0%;margin-bottom:0}.card-group>.card+.card[data-v-804d79b6]{margin-left:0;border-left:0}.card-group>.card[data-v-804d79b6]:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-header[data-v-804d79b6],.card-group>.card:not(:last-child) .card-img-top[data-v-804d79b6]{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-footer[data-v-804d79b6],.card-group>.card:not(:last-child) .card-img-bottom[data-v-804d79b6]{border-bottom-right-radius:0}.card-group>.card[data-v-804d79b6]:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-header[data-v-804d79b6],.card-group>.card:not(:first-child) .card-img-top[data-v-804d79b6]{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-footer[data-v-804d79b6],.card-group>.card:not(:first-child) .card-img-bottom[data-v-804d79b6]{border-bottom-left-radius:0}}.accordion-button[data-v-804d79b6]{position:relative;display:flex;align-items:center;width:100%;padding:1rem 1.25rem;font-size:1rem;color:#212529;text-align:left;background-color:#fff;border:0;border-radius:0;overflow-anchor:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,border-radius .15s ease}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-804d79b6]{transition:none}}.accordion-button[data-v-804d79b6]:not(.collapsed){color:#0c63e4;background-color:#e7f1ff;box-shadow:inset 0 -1px 0 rgba(0,0,0,.125)}.accordion-button[data-v-804d79b6]:not(.collapsed):after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230c63e4'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");transform:rotate(-180deg)}.accordion-button[data-v-804d79b6]:after{flex-shrink:0;width:1.25rem;height:1.25rem;margin-left:auto;content:\"\";background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-size:1.25rem;transition:transform .2s ease-in-out}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-804d79b6]:after{transition:none}}.accordion-button[data-v-804d79b6]:hover{z-index:2}.accordion-button[data-v-804d79b6]:focus{z-index:3;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.accordion-header[data-v-804d79b6]{margin-bottom:0}.accordion-item[data-v-804d79b6]{background-color:#fff;border:1px solid rgba(0,0,0,.125)}.accordion-item[data-v-804d79b6]:first-of-type{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.accordion-item:first-of-type .accordion-button[data-v-804d79b6]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.accordion-item[data-v-804d79b6]:not(:first-of-type){border-top:0}.accordion-item[data-v-804d79b6]:last-of-type{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-item:last-of-type .accordion-button.collapsed[data-v-804d79b6]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.accordion-item:last-of-type .accordion-collapse[data-v-804d79b6]{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-body[data-v-804d79b6]{padding:1rem 1.25rem}.accordion-flush .accordion-collapse[data-v-804d79b6]{border-width:0}.accordion-flush .accordion-item[data-v-804d79b6]{border-right:0;border-left:0;border-radius:0}.accordion-flush .accordion-item[data-v-804d79b6]:first-child{border-top:0}.accordion-flush .accordion-item[data-v-804d79b6]:last-child{border-bottom:0}.accordion-flush .accordion-item .accordion-button[data-v-804d79b6]{border-radius:0}.breadcrumb[data-v-804d79b6]{display:flex;flex-wrap:wrap;padding:0;margin-bottom:1rem;list-style:none}.breadcrumb-item+.breadcrumb-item[data-v-804d79b6]{padding-left:.5rem}.breadcrumb-item+.breadcrumb-item[data-v-804d79b6]:before{float:left;padding-right:.5rem;color:#6c757d;content:var(--bs-breadcrumb-divider,\"/\")}.breadcrumb-item.active[data-v-804d79b6]{color:#6c757d}.pagination[data-v-804d79b6]{display:flex;padding-left:0;list-style:none}.page-link[data-v-804d79b6]{position:relative;display:block;color:#0d6efd;text-decoration:none;background-color:#fff;border:1px solid #dee2e6;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.page-link[data-v-804d79b6]{transition:none}}.page-link[data-v-804d79b6]:hover{z-index:2;color:#0a58ca;background-color:#e9ecef;border-color:#dee2e6}.page-link[data-v-804d79b6]:focus{z-index:3;color:#0a58ca;background-color:#e9ecef;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.page-item:not(:first-child) .page-link[data-v-804d79b6]{margin-left:-1px}.page-item.active .page-link[data-v-804d79b6]{z-index:3;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.page-item.disabled .page-link[data-v-804d79b6]{color:#6c757d;pointer-events:none;background-color:#fff;border-color:#dee2e6}.page-link[data-v-804d79b6]{padding:.375rem .75rem}.page-item:first-child .page-link[data-v-804d79b6]{border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item:last-child .page-link[data-v-804d79b6]{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.pagination-lg .page-link[data-v-804d79b6]{padding:.75rem 1.5rem;font-size:1.25rem}.pagination-lg .page-item:first-child .page-link[data-v-804d79b6]{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link[data-v-804d79b6]{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm .page-link[data-v-804d79b6]{padding:.25rem .5rem;font-size:.875rem}.pagination-sm .page-item:first-child .page-link[data-v-804d79b6]{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link[data-v-804d79b6]{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge[data-v-804d79b6]{display:inline-block;padding:.35em .65em;font-size:.75em;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}.badge[data-v-804d79b6]:empty{display:none}.btn .badge[data-v-804d79b6]{position:relative;top:-1px}.alert[data-v-804d79b6]{position:relative;padding:1rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading[data-v-804d79b6]{color:inherit}.alert-link[data-v-804d79b6]{font-weight:700}.alert-dismissible[data-v-804d79b6]{padding-right:3rem}.alert-dismissible .btn-close[data-v-804d79b6]{position:absolute;top:0;right:0;z-index:2;padding:1.25rem 1rem}.alert-primary[data-v-804d79b6]{color:#084298;background-color:#cfe2ff;border-color:#b6d4fe}.alert-primary .alert-link[data-v-804d79b6]{color:#06357a}.alert-secondary[data-v-804d79b6]{color:#41464b;background-color:#e2e3e5;border-color:#d3d6d8}.alert-secondary .alert-link[data-v-804d79b6]{color:#34383c}.alert-success[data-v-804d79b6]{color:#0f5132;background-color:#d1e7dd;border-color:#badbcc}.alert-success .alert-link[data-v-804d79b6]{color:#0c4128}.alert-info[data-v-804d79b6]{color:#055160;background-color:#cff4fc;border-color:#b6effb}.alert-info .alert-link[data-v-804d79b6]{color:#04414d}.alert-warning[data-v-804d79b6]{color:#664d03;background-color:#fff3cd;border-color:#ffecb5}.alert-warning .alert-link[data-v-804d79b6]{color:#523e02}.alert-danger[data-v-804d79b6]{color:#842029;background-color:#f8d7da;border-color:#f5c2c7}.alert-danger .alert-link[data-v-804d79b6]{color:#6a1a21}.alert-light[data-v-804d79b6]{color:#636464;background-color:#fefefe;border-color:#fdfdfe}.alert-light .alert-link[data-v-804d79b6]{color:#4f5050}.alert-dark[data-v-804d79b6]{color:#141619;background-color:#d3d3d4;border-color:#bcbebf}.alert-dark .alert-link[data-v-804d79b6]{color:#101214}@-webkit-keyframes progress-bar-stripes-data-v-804d79b6{0%{background-position-x:1rem}}@keyframes progress-bar-stripes-data-v-804d79b6{0%{background-position-x:1rem}}.progress[data-v-804d79b6]{display:flex;height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress-bar[data-v-804d79b6]{display:flex;flex-direction:column;justify-content:center;overflow:hidden;color:#fff;text-align:center;white-space:nowrap;background-color:#0d6efd;transition:width .6s ease}@media (prefers-reduced-motion:reduce){.progress-bar[data-v-804d79b6]{transition:none}}.progress-bar-striped[data-v-804d79b6]{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-bar-animated[data-v-804d79b6]{-webkit-animation:1s linear infinite progress-bar-stripes-data-v-804d79b6;animation:1s linear infinite progress-bar-stripes-data-v-804d79b6}@media (prefers-reduced-motion:reduce){.progress-bar-animated[data-v-804d79b6]{-webkit-animation:none;animation:none}}.list-group[data-v-804d79b6]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:.25rem}.list-group-numbered[data-v-804d79b6]{list-style-type:none;counter-reset:section}.list-group-numbered>li[data-v-804d79b6]:before{content:counters(section,\".\") \". \";counter-increment:section}.list-group-item-action[data-v-804d79b6]{width:100%;color:#495057;text-align:inherit}.list-group-item-action[data-v-804d79b6]:focus,.list-group-item-action[data-v-804d79b6]:hover{z-index:1;color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action[data-v-804d79b6]:active{color:#212529;background-color:#e9ecef}.list-group-item[data-v-804d79b6]{position:relative;display:block;padding:.5rem 1rem;color:#212529;text-decoration:none;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item[data-v-804d79b6]:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.list-group-item[data-v-804d79b6]:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.list-group-item.disabled[data-v-804d79b6],.list-group-item[data-v-804d79b6]:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.list-group-item.active[data-v-804d79b6]{z-index:2;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.list-group-item+.list-group-item[data-v-804d79b6]{border-top-width:0}.list-group-item+.list-group-item.active[data-v-804d79b6]{margin-top:-1px;border-top-width:1px}.list-group-horizontal[data-v-804d79b6]{flex-direction:row}.list-group-horizontal>.list-group-item[data-v-804d79b6]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal>.list-group-item[data-v-804d79b6]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal>.list-group-item.active[data-v-804d79b6]{margin-top:0}.list-group-horizontal>.list-group-item+.list-group-item[data-v-804d79b6]{border-top-width:1px;border-left-width:0}.list-group-horizontal>.list-group-item+.list-group-item.active[data-v-804d79b6]{margin-left:-1px;border-left-width:1px}@media (min-width:576px){.list-group-horizontal-sm[data-v-804d79b6]{flex-direction:row}.list-group-horizontal-sm>.list-group-item[data-v-804d79b6]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-sm>.list-group-item[data-v-804d79b6]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-sm>.list-group-item.active[data-v-804d79b6]{margin-top:0}.list-group-horizontal-sm>.list-group-item+.list-group-item[data-v-804d79b6]{border-top-width:1px;border-left-width:0}.list-group-horizontal-sm>.list-group-item+.list-group-item.active[data-v-804d79b6]{margin-left:-1px;border-left-width:1px}}@media (min-width:768px){.list-group-horizontal-md[data-v-804d79b6]{flex-direction:row}.list-group-horizontal-md>.list-group-item[data-v-804d79b6]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-md>.list-group-item[data-v-804d79b6]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-md>.list-group-item.active[data-v-804d79b6]{margin-top:0}.list-group-horizontal-md>.list-group-item+.list-group-item[data-v-804d79b6]{border-top-width:1px;border-left-width:0}.list-group-horizontal-md>.list-group-item+.list-group-item.active[data-v-804d79b6]{margin-left:-1px;border-left-width:1px}}@media (min-width:992px){.list-group-horizontal-lg[data-v-804d79b6]{flex-direction:row}.list-group-horizontal-lg>.list-group-item[data-v-804d79b6]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-lg>.list-group-item[data-v-804d79b6]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-lg>.list-group-item.active[data-v-804d79b6]{margin-top:0}.list-group-horizontal-lg>.list-group-item+.list-group-item[data-v-804d79b6]{border-top-width:1px;border-left-width:0}.list-group-horizontal-lg>.list-group-item+.list-group-item.active[data-v-804d79b6]{margin-left:-1px;border-left-width:1px}}@media (min-width:1200px){.list-group-horizontal-xl[data-v-804d79b6]{flex-direction:row}.list-group-horizontal-xl>.list-group-item[data-v-804d79b6]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xl>.list-group-item[data-v-804d79b6]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xl>.list-group-item.active[data-v-804d79b6]{margin-top:0}.list-group-horizontal-xl>.list-group-item+.list-group-item[data-v-804d79b6]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xl>.list-group-item+.list-group-item.active[data-v-804d79b6]{margin-left:-1px;border-left-width:1px}}@media (min-width:1400px){.list-group-horizontal-xxl[data-v-804d79b6]{flex-direction:row}.list-group-horizontal-xxl>.list-group-item[data-v-804d79b6]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xxl>.list-group-item[data-v-804d79b6]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xxl>.list-group-item.active[data-v-804d79b6]{margin-top:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item[data-v-804d79b6]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item.active[data-v-804d79b6]{margin-left:-1px;border-left-width:1px}}.list-group-flush[data-v-804d79b6]{border-radius:0}.list-group-flush>.list-group-item[data-v-804d79b6]{border-width:0 0 1px}.list-group-flush>.list-group-item[data-v-804d79b6]:last-child{border-bottom-width:0}.list-group-item-primary[data-v-804d79b6]{color:#084298;background-color:#cfe2ff}.list-group-item-primary.list-group-item-action[data-v-804d79b6]:focus,.list-group-item-primary.list-group-item-action[data-v-804d79b6]:hover{color:#084298;background-color:#bacbe6}.list-group-item-primary.list-group-item-action.active[data-v-804d79b6]{color:#fff;background-color:#084298;border-color:#084298}.list-group-item-secondary[data-v-804d79b6]{color:#41464b;background-color:#e2e3e5}.list-group-item-secondary.list-group-item-action[data-v-804d79b6]:focus,.list-group-item-secondary.list-group-item-action[data-v-804d79b6]:hover{color:#41464b;background-color:#cbccce}.list-group-item-secondary.list-group-item-action.active[data-v-804d79b6]{color:#fff;background-color:#41464b;border-color:#41464b}.list-group-item-success[data-v-804d79b6]{color:#0f5132;background-color:#d1e7dd}.list-group-item-success.list-group-item-action[data-v-804d79b6]:focus,.list-group-item-success.list-group-item-action[data-v-804d79b6]:hover{color:#0f5132;background-color:#bcd0c7}.list-group-item-success.list-group-item-action.active[data-v-804d79b6]{color:#fff;background-color:#0f5132;border-color:#0f5132}.list-group-item-info[data-v-804d79b6]{color:#055160;background-color:#cff4fc}.list-group-item-info.list-group-item-action[data-v-804d79b6]:focus,.list-group-item-info.list-group-item-action[data-v-804d79b6]:hover{color:#055160;background-color:#badce3}.list-group-item-info.list-group-item-action.active[data-v-804d79b6]{color:#fff;background-color:#055160;border-color:#055160}.list-group-item-warning[data-v-804d79b6]{color:#664d03;background-color:#fff3cd}.list-group-item-warning.list-group-item-action[data-v-804d79b6]:focus,.list-group-item-warning.list-group-item-action[data-v-804d79b6]:hover{color:#664d03;background-color:#e6dbb9}.list-group-item-warning.list-group-item-action.active[data-v-804d79b6]{color:#fff;background-color:#664d03;border-color:#664d03}.list-group-item-danger[data-v-804d79b6]{color:#842029;background-color:#f8d7da}.list-group-item-danger.list-group-item-action[data-v-804d79b6]:focus,.list-group-item-danger.list-group-item-action[data-v-804d79b6]:hover{color:#842029;background-color:#dfc2c4}.list-group-item-danger.list-group-item-action.active[data-v-804d79b6]{color:#fff;background-color:#842029;border-color:#842029}.list-group-item-light[data-v-804d79b6]{color:#636464;background-color:#fefefe}.list-group-item-light.list-group-item-action[data-v-804d79b6]:focus,.list-group-item-light.list-group-item-action[data-v-804d79b6]:hover{color:#636464;background-color:#e5e5e5}.list-group-item-light.list-group-item-action.active[data-v-804d79b6]{color:#fff;background-color:#636464;border-color:#636464}.list-group-item-dark[data-v-804d79b6]{color:#141619;background-color:#d3d3d4}.list-group-item-dark.list-group-item-action[data-v-804d79b6]:focus,.list-group-item-dark.list-group-item-action[data-v-804d79b6]:hover{color:#141619;background-color:#bebebf}.list-group-item-dark.list-group-item-action.active[data-v-804d79b6]{color:#fff;background-color:#141619;border-color:#141619}.btn-close[data-v-804d79b6]{box-sizing:content-box;width:1em;height:1em;padding:.25em;color:#000;background:transparent url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M.293.293a1 1 0 11.414 0 NaN NaNlNaN NaN NaN NaNa1 1 0 111.414 1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 10-1.414 NaN NaNz'/%3E%3C/svg%3E\") 50%/1em auto no-repeat;border:0;border-radius:.25rem;opacity:.5}.btn-close[data-v-804d79b6]:hover{color:#000;text-decoration:none;opacity:.75}.btn-close[data-v-804d79b6]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25);opacity:1}.btn-close.disabled[data-v-804d79b6],.btn-close[data-v-804d79b6]:disabled{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;opacity:.25}.btn-close-white[data-v-804d79b6]{filter:invert(1) grayscale(100%) brightness(200%)}.toast[data-v-804d79b6]{width:350px;max-width:100%;font-size:.875rem;pointer-events:auto;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .5rem 1rem rgba(0,0,0,.15);border-radius:.25rem}.toast.showing[data-v-804d79b6]{opacity:0}.toast[data-v-804d79b6]:not(.show){display:none}.toast-container[data-v-804d79b6]{width:-webkit-max-content;width:-moz-max-content;width:max-content;max-width:100%;pointer-events:none}.toast-container[data-v-804d79b6]>:not(:last-child){margin-bottom:.75rem}.toast-header[data-v-804d79b6]{display:flex;align-items:center;padding:.5rem .75rem;color:#6c757d;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05);border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.toast-header .btn-close[data-v-804d79b6]{margin-right:-.375rem;margin-left:.75rem}.toast-body[data-v-804d79b6]{padding:.75rem;word-wrap:break-word}.modal[data-v-804d79b6]{position:fixed;top:0;left:0;z-index:1055;display:none;width:100%;height:100%;overflow-x:hidden;overflow-y:auto;outline:0}.modal-dialog[data-v-804d79b6]{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog[data-v-804d79b6]{transition:transform .3s ease-out;transform:translateY(-50px)}@media (prefers-reduced-motion:reduce){.modal.fade .modal-dialog[data-v-804d79b6]{transition:none}}.modal.show .modal-dialog[data-v-804d79b6]{transform:none}.modal.modal-static .modal-dialog[data-v-804d79b6]{transform:scale(1.02)}.modal-dialog-scrollable[data-v-804d79b6]{height:calc(100% - 1rem)}.modal-dialog-scrollable .modal-content[data-v-804d79b6]{max-height:100%;overflow:hidden}.modal-dialog-scrollable .modal-body[data-v-804d79b6]{overflow-y:auto}.modal-dialog-centered[data-v-804d79b6]{display:flex;align-items:center;min-height:calc(100% - 1rem)}.modal-content[data-v-804d79b6]{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop[data-v-804d79b6]{position:fixed;top:0;left:0;z-index:1050;width:100vw;height:100vh;background-color:#000}.modal-backdrop.fade[data-v-804d79b6]{opacity:0}.modal-backdrop.show[data-v-804d79b6]{opacity:.5}.modal-header[data-v-804d79b6]{display:flex;flex-shrink:0;align-items:center;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.modal-header .btn-close[data-v-804d79b6]{padding:.5rem;margin:-.5rem -.5rem -.5rem auto}.modal-title[data-v-804d79b6]{margin-bottom:0;line-height:1.5}.modal-body[data-v-804d79b6]{position:relative;flex:1 1 auto;padding:1rem}.modal-footer[data-v-804d79b6]{display:flex;flex-wrap:wrap;flex-shrink:0;align-items:center;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.modal-footer>[data-v-804d79b6]{margin:.25rem}@media (min-width:576px){.modal-dialog[data-v-804d79b6]{max-width:500px;margin:1.75rem auto}.modal-dialog-scrollable[data-v-804d79b6]{height:calc(100% - 3.5rem)}.modal-dialog-centered[data-v-804d79b6]{min-height:calc(100% - 3.5rem)}.modal-sm[data-v-804d79b6]{max-width:300px}}@media (min-width:992px){.modal-lg[data-v-804d79b6],.modal-xl[data-v-804d79b6]{max-width:800px}}@media (min-width:1200px){.modal-xl[data-v-804d79b6]{max-width:1140px}}.modal-fullscreen[data-v-804d79b6]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen .modal-content[data-v-804d79b6]{height:100%;border:0;border-radius:0}.modal-fullscreen .modal-header[data-v-804d79b6]{border-radius:0}.modal-fullscreen .modal-body[data-v-804d79b6]{overflow-y:auto}.modal-fullscreen .modal-footer[data-v-804d79b6]{border-radius:0}@media (max-width:575.98px){.modal-fullscreen-sm-down[data-v-804d79b6]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-sm-down .modal-content[data-v-804d79b6]{height:100%;border:0;border-radius:0}.modal-fullscreen-sm-down .modal-header[data-v-804d79b6]{border-radius:0}.modal-fullscreen-sm-down .modal-body[data-v-804d79b6]{overflow-y:auto}.modal-fullscreen-sm-down .modal-footer[data-v-804d79b6]{border-radius:0}}@media (max-width:767.98px){.modal-fullscreen-md-down[data-v-804d79b6]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-md-down .modal-content[data-v-804d79b6]{height:100%;border:0;border-radius:0}.modal-fullscreen-md-down .modal-header[data-v-804d79b6]{border-radius:0}.modal-fullscreen-md-down .modal-body[data-v-804d79b6]{overflow-y:auto}.modal-fullscreen-md-down .modal-footer[data-v-804d79b6]{border-radius:0}}@media (max-width:991.98px){.modal-fullscreen-lg-down[data-v-804d79b6]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-lg-down .modal-content[data-v-804d79b6]{height:100%;border:0;border-radius:0}.modal-fullscreen-lg-down .modal-header[data-v-804d79b6]{border-radius:0}.modal-fullscreen-lg-down .modal-body[data-v-804d79b6]{overflow-y:auto}.modal-fullscreen-lg-down .modal-footer[data-v-804d79b6]{border-radius:0}}@media (max-width:1199.98px){.modal-fullscreen-xl-down[data-v-804d79b6]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xl-down .modal-content[data-v-804d79b6]{height:100%;border:0;border-radius:0}.modal-fullscreen-xl-down .modal-header[data-v-804d79b6]{border-radius:0}.modal-fullscreen-xl-down .modal-body[data-v-804d79b6]{overflow-y:auto}.modal-fullscreen-xl-down .modal-footer[data-v-804d79b6]{border-radius:0}}@media (max-width:1399.98px){.modal-fullscreen-xxl-down[data-v-804d79b6]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xxl-down .modal-content[data-v-804d79b6]{height:100%;border:0;border-radius:0}.modal-fullscreen-xxl-down .modal-header[data-v-804d79b6]{border-radius:0}.modal-fullscreen-xxl-down .modal-body[data-v-804d79b6]{overflow-y:auto}.modal-fullscreen-xxl-down .modal-footer[data-v-804d79b6]{border-radius:0}}.tooltip[data-v-804d79b6]{position:absolute;z-index:1080;display:block;margin:0;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show[data-v-804d79b6]{opacity:.9}.tooltip .tooltip-arrow[data-v-804d79b6]{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .tooltip-arrow[data-v-804d79b6]:before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[data-popper-placement^=top][data-v-804d79b6],.bs-tooltip-top[data-v-804d79b6]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-804d79b6],.bs-tooltip-top .tooltip-arrow[data-v-804d79b6]{bottom:0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-804d79b6]:before,.bs-tooltip-top .tooltip-arrow[data-v-804d79b6]:before{top:-1px;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[data-popper-placement^=right][data-v-804d79b6],.bs-tooltip-end[data-v-804d79b6]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-804d79b6],.bs-tooltip-end .tooltip-arrow[data-v-804d79b6]{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-804d79b6]:before,.bs-tooltip-end .tooltip-arrow[data-v-804d79b6]:before{right:-1px;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[data-popper-placement^=bottom][data-v-804d79b6],.bs-tooltip-bottom[data-v-804d79b6]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-804d79b6],.bs-tooltip-bottom .tooltip-arrow[data-v-804d79b6]{top:0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-804d79b6]:before,.bs-tooltip-bottom .tooltip-arrow[data-v-804d79b6]:before{bottom:-1px;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[data-popper-placement^=left][data-v-804d79b6],.bs-tooltip-start[data-v-804d79b6]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-804d79b6],.bs-tooltip-start .tooltip-arrow[data-v-804d79b6]{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-804d79b6]:before,.bs-tooltip-start .tooltip-arrow[data-v-804d79b6]:before{left:-1px;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner[data-v-804d79b6]{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover[data-v-804d79b6]{position:absolute;top:0;left:0;z-index:1070;display:block;max-width:276px;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover .popover-arrow[data-v-804d79b6]{position:absolute;display:block;width:1rem;height:.5rem}.popover .popover-arrow[data-v-804d79b6]:after,.popover .popover-arrow[data-v-804d79b6]:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-804d79b6],.bs-popover-top>.popover-arrow[data-v-804d79b6]{bottom:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-804d79b6]:before,.bs-popover-top>.popover-arrow[data-v-804d79b6]:before{bottom:0;border-width:.5rem .5rem 0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-804d79b6]:after,.bs-popover-top>.popover-arrow[data-v-804d79b6]:after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:#fff}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-804d79b6],.bs-popover-end>.popover-arrow[data-v-804d79b6]{left:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-804d79b6]:before,.bs-popover-end>.popover-arrow[data-v-804d79b6]:before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-804d79b6]:after,.bs-popover-end>.popover-arrow[data-v-804d79b6]:after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:#fff}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-804d79b6],.bs-popover-bottom>.popover-arrow[data-v-804d79b6]{top:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-804d79b6]:before,.bs-popover-bottom>.popover-arrow[data-v-804d79b6]:before{top:0;border-width:0 .5rem .5rem;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-804d79b6]:after,.bs-popover-bottom>.popover-arrow[data-v-804d79b6]:after{top:1px;border-width:0 .5rem .5rem;border-bottom-color:#fff}.bs-popover-auto[data-popper-placement^=bottom] .popover-header[data-v-804d79b6]:before,.bs-popover-bottom .popover-header[data-v-804d79b6]:before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f0f0f0}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-804d79b6],.bs-popover-start>.popover-arrow[data-v-804d79b6]{right:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-804d79b6]:before,.bs-popover-start>.popover-arrow[data-v-804d79b6]:before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-804d79b6]:after,.bs-popover-start>.popover-arrow[data-v-804d79b6]:after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:#fff}.popover-header[data-v-804d79b6]{padding:.5rem 1rem;margin-bottom:0;font-size:1rem;background-color:#f0f0f0;border-bottom:1px solid rgba(0,0,0,.2);border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header[data-v-804d79b6]:empty{display:none}.popover-body[data-v-804d79b6]{padding:1rem;color:#212529}.carousel[data-v-804d79b6]{position:relative}.carousel.pointer-event[data-v-804d79b6]{touch-action:pan-y}.carousel-inner[data-v-804d79b6]{position:relative;width:100%;overflow:hidden}.carousel-inner[data-v-804d79b6]:after{display:block;clear:both;content:\"\"}.carousel-item[data-v-804d79b6]{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.carousel-item[data-v-804d79b6]{transition:none}}.carousel-item-next[data-v-804d79b6],.carousel-item-prev[data-v-804d79b6],.carousel-item.active[data-v-804d79b6]{display:block}.active.carousel-item-end[data-v-804d79b6],.carousel-item-next[data-v-804d79b6]:not(.carousel-item-start){transform:translateX(100%)}.active.carousel-item-start[data-v-804d79b6],.carousel-item-prev[data-v-804d79b6]:not(.carousel-item-end){transform:translateX(-100%)}.carousel-fade .carousel-item[data-v-804d79b6]{opacity:0;transition-property:opacity;transform:none}.carousel-fade .carousel-item-next.carousel-item-start[data-v-804d79b6],.carousel-fade .carousel-item-prev.carousel-item-end[data-v-804d79b6],.carousel-fade .carousel-item.active[data-v-804d79b6]{z-index:1;opacity:1}.carousel-fade .active.carousel-item-end[data-v-804d79b6],.carousel-fade .active.carousel-item-start[data-v-804d79b6]{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.carousel-fade .active.carousel-item-end[data-v-804d79b6],.carousel-fade .active.carousel-item-start[data-v-804d79b6]{transition:none}}.carousel-control-next[data-v-804d79b6],.carousel-control-prev[data-v-804d79b6]{position:absolute;top:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center;width:15%;padding:0;color:#fff;text-align:center;background:0 0;border:0;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.carousel-control-next[data-v-804d79b6],.carousel-control-prev[data-v-804d79b6]{transition:none}}.carousel-control-next[data-v-804d79b6]:focus,.carousel-control-next[data-v-804d79b6]:hover,.carousel-control-prev[data-v-804d79b6]:focus,.carousel-control-prev[data-v-804d79b6]:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev[data-v-804d79b6]{left:0}.carousel-control-next[data-v-804d79b6]{right:0}.carousel-control-next-icon[data-v-804d79b6],.carousel-control-prev-icon[data-v-804d79b6]{display:inline-block;width:2rem;height:2rem;background-repeat:no-repeat;background-position:50%;background-size:100% 100%}.carousel-control-prev-icon[data-v-804d79b6]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3E%3C/svg%3E\")}.carousel-control-next-icon[data-v-804d79b6]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\")}.carousel-indicators[data-v-804d79b6]{position:absolute;right:0;bottom:0;left:0;z-index:2;display:flex;justify-content:center;padding:0;margin-right:15%;margin-bottom:1rem;margin-left:15%;list-style:none}.carousel-indicators [data-bs-target][data-v-804d79b6]{box-sizing:content-box;flex:0 1 auto;width:30px;height:3px;padding:0;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border:0;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.carousel-indicators [data-bs-target][data-v-804d79b6]{transition:none}}.carousel-indicators .active[data-v-804d79b6]{opacity:1}.carousel-caption[data-v-804d79b6]{position:absolute;right:15%;bottom:1.25rem;left:15%;padding-top:1.25rem;padding-bottom:1.25rem;color:#fff;text-align:center}.carousel-dark .carousel-control-next-icon[data-v-804d79b6],.carousel-dark .carousel-control-prev-icon[data-v-804d79b6]{filter:invert(1) grayscale(100)}.carousel-dark .carousel-indicators [data-bs-target][data-v-804d79b6]{background-color:#000}.carousel-dark .carousel-caption[data-v-804d79b6]{color:#000}@-webkit-keyframes spinner-border-data-v-804d79b6{to{transform:rotate(1turn)}}@keyframes spinner-border-data-v-804d79b6{to{transform:rotate(1turn)}}.spinner-border[data-v-804d79b6]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:.75s linear infinite spinner-border-data-v-804d79b6;animation:.75s linear infinite spinner-border-data-v-804d79b6}.spinner-border-sm[data-v-804d79b6]{width:1rem;height:1rem;border-width:.2em}@-webkit-keyframes spinner-grow-data-v-804d79b6{0%{transform:scale(0)}50%{opacity:1;transform:none}}@keyframes spinner-grow-data-v-804d79b6{0%{transform:scale(0)}50%{opacity:1;transform:none}}.spinner-grow[data-v-804d79b6]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;background-color:currentColor;border-radius:50%;opacity:0;-webkit-animation:.75s linear infinite spinner-grow-data-v-804d79b6;animation:.75s linear infinite spinner-grow-data-v-804d79b6}.spinner-grow-sm[data-v-804d79b6]{width:1rem;height:1rem}@media (prefers-reduced-motion:reduce){.spinner-border[data-v-804d79b6],.spinner-grow[data-v-804d79b6]{-webkit-animation-duration:1.5s;animation-duration:1.5s}}.offcanvas[data-v-804d79b6]{position:fixed;bottom:0;z-index:1045;display:flex;flex-direction:column;max-width:100%;visibility:hidden;background-color:#fff;background-clip:padding-box;outline:0;transition:transform .3s ease-in-out}@media (prefers-reduced-motion:reduce){.offcanvas[data-v-804d79b6]{transition:none}}.offcanvas-backdrop[data-v-804d79b6]{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.offcanvas-backdrop.fade[data-v-804d79b6]{opacity:0}.offcanvas-backdrop.show[data-v-804d79b6]{opacity:.5}.offcanvas-header[data-v-804d79b6]{display:flex;align-items:center;justify-content:space-between;padding:1rem}.offcanvas-header .btn-close[data-v-804d79b6]{padding:.5rem;margin-top:-.5rem;margin-right:-.5rem;margin-bottom:-.5rem}.offcanvas-title[data-v-804d79b6]{margin-bottom:0;line-height:1.5}.offcanvas-body[data-v-804d79b6]{flex-grow:1;padding:1rem;overflow-y:auto}.offcanvas-start[data-v-804d79b6]{top:0;left:0;width:400px;border-right:1px solid rgba(0,0,0,.2);transform:translateX(-100%)}.offcanvas-end[data-v-804d79b6]{top:0;right:0;width:400px;border-left:1px solid rgba(0,0,0,.2);transform:translateX(100%)}.offcanvas-top[data-v-804d79b6]{top:0;right:0;left:0;height:30vh;max-height:100%;border-bottom:1px solid rgba(0,0,0,.2);transform:translateY(-100%)}.offcanvas-bottom[data-v-804d79b6]{right:0;left:0;height:30vh;max-height:100%;border-top:1px solid rgba(0,0,0,.2);transform:translateY(100%)}.offcanvas.show[data-v-804d79b6]{transform:none}.placeholder[data-v-804d79b6]{display:inline-block;min-height:1em;vertical-align:middle;cursor:wait;background-color:currentColor;opacity:.5}.placeholder.btn[data-v-804d79b6]:before{display:inline-block;content:\"\"}.placeholder-xs[data-v-804d79b6]{min-height:.6em}.placeholder-sm[data-v-804d79b6]{min-height:.8em}.placeholder-lg[data-v-804d79b6]{min-height:1.2em}.placeholder-glow .placeholder[data-v-804d79b6]{-webkit-animation:placeholder-glow-data-v-804d79b6 2s ease-in-out infinite;animation:placeholder-glow-data-v-804d79b6 2s ease-in-out infinite}@-webkit-keyframes placeholder-glow-data-v-804d79b6{50%{opacity:.2}}@keyframes placeholder-glow-data-v-804d79b6{50%{opacity:.2}}.placeholder-wave[data-v-804d79b6]{-webkit-mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);-webkit-mask-size:200% 100%;mask-size:200% 100%;-webkit-animation:placeholder-wave-data-v-804d79b6 2s linear infinite;animation:placeholder-wave-data-v-804d79b6 2s linear infinite}@-webkit-keyframes placeholder-wave-data-v-804d79b6{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}@keyframes placeholder-wave-data-v-804d79b6{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}.clearfix[data-v-804d79b6]:after{display:block;clear:both;content:\"\"}.link-primary[data-v-804d79b6]{color:#0d6efd}.link-primary[data-v-804d79b6]:focus,.link-primary[data-v-804d79b6]:hover{color:#0a58ca}.link-secondary[data-v-804d79b6]{color:#6c757d}.link-secondary[data-v-804d79b6]:focus,.link-secondary[data-v-804d79b6]:hover{color:#565e64}.link-success[data-v-804d79b6]{color:#198754}.link-success[data-v-804d79b6]:focus,.link-success[data-v-804d79b6]:hover{color:#146c43}.link-info[data-v-804d79b6]{color:#0dcaf0}.link-info[data-v-804d79b6]:focus,.link-info[data-v-804d79b6]:hover{color:#3dd5f3}.link-warning[data-v-804d79b6]{color:#ffc107}.link-warning[data-v-804d79b6]:focus,.link-warning[data-v-804d79b6]:hover{color:#ffcd39}.link-danger[data-v-804d79b6]{color:#dc3545}.link-danger[data-v-804d79b6]:focus,.link-danger[data-v-804d79b6]:hover{color:#b02a37}.link-light[data-v-804d79b6]{color:#f8f9fa}.link-light[data-v-804d79b6]:focus,.link-light[data-v-804d79b6]:hover{color:#f9fafb}.link-dark[data-v-804d79b6]{color:#212529}.link-dark[data-v-804d79b6]:focus,.link-dark[data-v-804d79b6]:hover{color:#1a1e21}.ratio[data-v-804d79b6]{position:relative;width:100%}.ratio[data-v-804d79b6]:before{display:block;padding-top:var(--bs-aspect-ratio);content:\"\"}.ratio>[data-v-804d79b6]{position:absolute;top:0;left:0;width:100%;height:100%}.ratio-1x1[data-v-804d79b6]{--bs-aspect-ratio:100%}.ratio-4x3[data-v-804d79b6]{--bs-aspect-ratio:75%}.ratio-16x9[data-v-804d79b6]{--bs-aspect-ratio:56.25%}.ratio-21x9[data-v-804d79b6]{--bs-aspect-ratio:42.8571428571%}.fixed-top[data-v-804d79b6]{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom[data-v-804d79b6]{position:fixed;right:0;bottom:0;left:0;z-index:1030}.sticky-top[data-v-804d79b6]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}@media (min-width:576px){.sticky-sm-top[data-v-804d79b6]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:768px){.sticky-md-top[data-v-804d79b6]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:992px){.sticky-lg-top[data-v-804d79b6]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1200px){.sticky-xl-top[data-v-804d79b6]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1400px){.sticky-xxl-top[data-v-804d79b6]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.hstack[data-v-804d79b6]{display:flex;flex-direction:row;align-items:center;align-self:stretch}.vstack[data-v-804d79b6]{display:flex;flex:1 1 auto;flex-direction:column;align-self:stretch}.visually-hidden-focusable[data-v-804d79b6]:not(:focus):not(:focus-within),.visually-hidden[data-v-804d79b6]{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}.stretched-link[data-v-804d79b6]:after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;content:\"\"}.text-truncate[data-v-804d79b6]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.vr[data-v-804d79b6]{display:inline-block;align-self:stretch;width:1px;min-height:1em;background-color:currentColor;opacity:.25}.align-baseline[data-v-804d79b6]{vertical-align:baseline!important}.align-top[data-v-804d79b6]{vertical-align:top!important}.align-middle[data-v-804d79b6]{vertical-align:middle!important}.align-bottom[data-v-804d79b6]{vertical-align:bottom!important}.align-text-bottom[data-v-804d79b6]{vertical-align:text-bottom!important}.align-text-top[data-v-804d79b6]{vertical-align:text-top!important}.float-start[data-v-804d79b6]{float:left!important}.float-end[data-v-804d79b6]{float:right!important}.float-none[data-v-804d79b6]{float:none!important}.opacity-0[data-v-804d79b6]{opacity:0!important}.opacity-25[data-v-804d79b6]{opacity:.25!important}.opacity-50[data-v-804d79b6]{opacity:.5!important}.opacity-75[data-v-804d79b6]{opacity:.75!important}.opacity-100[data-v-804d79b6]{opacity:1!important}.overflow-auto[data-v-804d79b6]{overflow:auto!important}.overflow-hidden[data-v-804d79b6]{overflow:hidden!important}.overflow-visible[data-v-804d79b6]{overflow:visible!important}.overflow-scroll[data-v-804d79b6]{overflow:scroll!important}.d-inline[data-v-804d79b6]{display:inline!important}.d-inline-block[data-v-804d79b6]{display:inline-block!important}.d-block[data-v-804d79b6]{display:block!important}.d-grid[data-v-804d79b6]{display:grid!important}.d-table[data-v-804d79b6]{display:table!important}.d-table-row[data-v-804d79b6]{display:table-row!important}.d-table-cell[data-v-804d79b6]{display:table-cell!important}.d-flex[data-v-804d79b6]{display:flex!important}.d-inline-flex[data-v-804d79b6]{display:inline-flex!important}.d-none[data-v-804d79b6]{display:none!important}.shadow[data-v-804d79b6]{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.shadow-sm[data-v-804d79b6]{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.shadow-lg[data-v-804d79b6]{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.shadow-none[data-v-804d79b6]{box-shadow:none!important}.position-static[data-v-804d79b6]{position:static!important}.position-relative[data-v-804d79b6]{position:relative!important}.position-absolute[data-v-804d79b6]{position:absolute!important}.position-fixed[data-v-804d79b6]{position:fixed!important}.position-sticky[data-v-804d79b6]{position:-webkit-sticky!important;position:sticky!important}.top-0[data-v-804d79b6]{top:0!important}.top-50[data-v-804d79b6]{top:50%!important}.top-100[data-v-804d79b6]{top:100%!important}.bottom-0[data-v-804d79b6]{bottom:0!important}.bottom-50[data-v-804d79b6]{bottom:50%!important}.bottom-100[data-v-804d79b6]{bottom:100%!important}.start-0[data-v-804d79b6]{left:0!important}.start-50[data-v-804d79b6]{left:50%!important}.start-100[data-v-804d79b6]{left:100%!important}.end-0[data-v-804d79b6]{right:0!important}.end-50[data-v-804d79b6]{right:50%!important}.end-100[data-v-804d79b6]{right:100%!important}.translate-middle[data-v-804d79b6]{transform:translate(-50%,-50%)!important}.translate-middle-x[data-v-804d79b6]{transform:translateX(-50%)!important}.translate-middle-y[data-v-804d79b6]{transform:translateY(-50%)!important}.border[data-v-804d79b6]{border:1px solid #dee2e6!important}.border-0[data-v-804d79b6]{border:0!important}.border-top[data-v-804d79b6]{border-top:1px solid #dee2e6!important}.border-top-0[data-v-804d79b6]{border-top:0!important}.border-end[data-v-804d79b6]{border-right:1px solid #dee2e6!important}.border-end-0[data-v-804d79b6]{border-right:0!important}.border-bottom[data-v-804d79b6]{border-bottom:1px solid #dee2e6!important}.border-bottom-0[data-v-804d79b6]{border-bottom:0!important}.border-start[data-v-804d79b6]{border-left:1px solid #dee2e6!important}.border-start-0[data-v-804d79b6]{border-left:0!important}.border-primary[data-v-804d79b6]{border-color:#0d6efd!important}.border-secondary[data-v-804d79b6]{border-color:#6c757d!important}.border-success[data-v-804d79b6]{border-color:#198754!important}.border-info[data-v-804d79b6]{border-color:#0dcaf0!important}.border-warning[data-v-804d79b6]{border-color:#ffc107!important}.border-danger[data-v-804d79b6]{border-color:#dc3545!important}.border-light[data-v-804d79b6]{border-color:#f8f9fa!important}.border-dark[data-v-804d79b6]{border-color:#212529!important}.border-white[data-v-804d79b6]{border-color:#fff!important}.border-1[data-v-804d79b6]{border-width:1px!important}.border-2[data-v-804d79b6]{border-width:2px!important}.border-3[data-v-804d79b6]{border-width:3px!important}.border-4[data-v-804d79b6]{border-width:4px!important}.border-5[data-v-804d79b6]{border-width:5px!important}.w-25[data-v-804d79b6]{width:25%!important}.w-50[data-v-804d79b6]{width:50%!important}.w-75[data-v-804d79b6]{width:75%!important}.w-100[data-v-804d79b6]{width:100%!important}.w-auto[data-v-804d79b6]{width:auto!important}.mw-100[data-v-804d79b6]{max-width:100%!important}.vw-100[data-v-804d79b6]{width:100vw!important}.min-vw-100[data-v-804d79b6]{min-width:100vw!important}.h-25[data-v-804d79b6]{height:25%!important}.h-50[data-v-804d79b6]{height:50%!important}.h-75[data-v-804d79b6]{height:75%!important}.h-100[data-v-804d79b6]{height:100%!important}.h-auto[data-v-804d79b6]{height:auto!important}.mh-100[data-v-804d79b6]{max-height:100%!important}.vh-100[data-v-804d79b6]{height:100vh!important}.min-vh-100[data-v-804d79b6]{min-height:100vh!important}.flex-fill[data-v-804d79b6]{flex:1 1 auto!important}.flex-row[data-v-804d79b6]{flex-direction:row!important}.flex-column[data-v-804d79b6]{flex-direction:column!important}.flex-row-reverse[data-v-804d79b6]{flex-direction:row-reverse!important}.flex-column-reverse[data-v-804d79b6]{flex-direction:column-reverse!important}.flex-grow-0[data-v-804d79b6]{flex-grow:0!important}.flex-grow-1[data-v-804d79b6]{flex-grow:1!important}.flex-shrink-0[data-v-804d79b6]{flex-shrink:0!important}.flex-shrink-1[data-v-804d79b6]{flex-shrink:1!important}.flex-wrap[data-v-804d79b6]{flex-wrap:wrap!important}.flex-nowrap[data-v-804d79b6]{flex-wrap:nowrap!important}.flex-wrap-reverse[data-v-804d79b6]{flex-wrap:wrap-reverse!important}.gap-0[data-v-804d79b6]{gap:0!important}.gap-1[data-v-804d79b6]{gap:.25rem!important}.gap-2[data-v-804d79b6]{gap:.5rem!important}.gap-3[data-v-804d79b6]{gap:1rem!important}.gap-4[data-v-804d79b6]{gap:1.5rem!important}.gap-5[data-v-804d79b6]{gap:3rem!important}.justify-content-start[data-v-804d79b6]{justify-content:flex-start!important}.justify-content-end[data-v-804d79b6]{justify-content:flex-end!important}.justify-content-center[data-v-804d79b6]{justify-content:center!important}.justify-content-between[data-v-804d79b6]{justify-content:space-between!important}.justify-content-around[data-v-804d79b6]{justify-content:space-around!important}.justify-content-evenly[data-v-804d79b6]{justify-content:space-evenly!important}.align-items-start[data-v-804d79b6]{align-items:flex-start!important}.align-items-end[data-v-804d79b6]{align-items:flex-end!important}.align-items-center[data-v-804d79b6]{align-items:center!important}.align-items-baseline[data-v-804d79b6]{align-items:baseline!important}.align-items-stretch[data-v-804d79b6]{align-items:stretch!important}.align-content-start[data-v-804d79b6]{align-content:flex-start!important}.align-content-end[data-v-804d79b6]{align-content:flex-end!important}.align-content-center[data-v-804d79b6]{align-content:center!important}.align-content-between[data-v-804d79b6]{align-content:space-between!important}.align-content-around[data-v-804d79b6]{align-content:space-around!important}.align-content-stretch[data-v-804d79b6]{align-content:stretch!important}.align-self-auto[data-v-804d79b6]{align-self:auto!important}.align-self-start[data-v-804d79b6]{align-self:flex-start!important}.align-self-end[data-v-804d79b6]{align-self:flex-end!important}.align-self-center[data-v-804d79b6]{align-self:center!important}.align-self-baseline[data-v-804d79b6]{align-self:baseline!important}.align-self-stretch[data-v-804d79b6]{align-self:stretch!important}.order-first[data-v-804d79b6]{order:-1!important}.order-0[data-v-804d79b6]{order:0!important}.order-1[data-v-804d79b6]{order:1!important}.order-2[data-v-804d79b6]{order:2!important}.order-3[data-v-804d79b6]{order:3!important}.order-4[data-v-804d79b6]{order:4!important}.order-5[data-v-804d79b6]{order:5!important}.order-last[data-v-804d79b6]{order:6!important}.m-0[data-v-804d79b6]{margin:0!important}.m-1[data-v-804d79b6]{margin:.25rem!important}.m-2[data-v-804d79b6]{margin:.5rem!important}.m-3[data-v-804d79b6]{margin:1rem!important}.m-4[data-v-804d79b6]{margin:1.5rem!important}.m-5[data-v-804d79b6]{margin:3rem!important}.m-auto[data-v-804d79b6]{margin:auto!important}.mx-0[data-v-804d79b6]{margin-right:0!important;margin-left:0!important}.mx-1[data-v-804d79b6]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-2[data-v-804d79b6]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-3[data-v-804d79b6]{margin-right:1rem!important;margin-left:1rem!important}.mx-4[data-v-804d79b6]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-5[data-v-804d79b6]{margin-right:3rem!important;margin-left:3rem!important}.mx-auto[data-v-804d79b6]{margin-right:auto!important;margin-left:auto!important}.my-0[data-v-804d79b6]{margin-top:0!important;margin-bottom:0!important}.my-1[data-v-804d79b6]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-2[data-v-804d79b6]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-3[data-v-804d79b6]{margin-top:1rem!important;margin-bottom:1rem!important}.my-4[data-v-804d79b6]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-5[data-v-804d79b6]{margin-top:3rem!important;margin-bottom:3rem!important}.my-auto[data-v-804d79b6]{margin-top:auto!important;margin-bottom:auto!important}.mt-0[data-v-804d79b6]{margin-top:0!important}.mt-1[data-v-804d79b6]{margin-top:.25rem!important}.mt-2[data-v-804d79b6]{margin-top:.5rem!important}.mt-3[data-v-804d79b6]{margin-top:1rem!important}.mt-4[data-v-804d79b6]{margin-top:1.5rem!important}.mt-5[data-v-804d79b6]{margin-top:3rem!important}.mt-auto[data-v-804d79b6]{margin-top:auto!important}.me-0[data-v-804d79b6]{margin-right:0!important}.me-1[data-v-804d79b6]{margin-right:.25rem!important}.me-2[data-v-804d79b6]{margin-right:.5rem!important}.me-3[data-v-804d79b6]{margin-right:1rem!important}.me-4[data-v-804d79b6]{margin-right:1.5rem!important}.me-5[data-v-804d79b6]{margin-right:3rem!important}.me-auto[data-v-804d79b6]{margin-right:auto!important}.mb-0[data-v-804d79b6]{margin-bottom:0!important}.mb-1[data-v-804d79b6]{margin-bottom:.25rem!important}.mb-2[data-v-804d79b6]{margin-bottom:.5rem!important}.mb-3[data-v-804d79b6]{margin-bottom:1rem!important}.mb-4[data-v-804d79b6]{margin-bottom:1.5rem!important}.mb-5[data-v-804d79b6]{margin-bottom:3rem!important}.mb-auto[data-v-804d79b6]{margin-bottom:auto!important}.ms-0[data-v-804d79b6]{margin-left:0!important}.ms-1[data-v-804d79b6]{margin-left:.25rem!important}.ms-2[data-v-804d79b6]{margin-left:.5rem!important}.ms-3[data-v-804d79b6]{margin-left:1rem!important}.ms-4[data-v-804d79b6]{margin-left:1.5rem!important}.ms-5[data-v-804d79b6]{margin-left:3rem!important}.ms-auto[data-v-804d79b6]{margin-left:auto!important}.p-0[data-v-804d79b6]{padding:0!important}.p-1[data-v-804d79b6]{padding:.25rem!important}.p-2[data-v-804d79b6]{padding:.5rem!important}.p-3[data-v-804d79b6]{padding:1rem!important}.p-4[data-v-804d79b6]{padding:1.5rem!important}.p-5[data-v-804d79b6]{padding:3rem!important}.px-0[data-v-804d79b6]{padding-right:0!important;padding-left:0!important}.px-1[data-v-804d79b6]{padding-right:.25rem!important;padding-left:.25rem!important}.px-2[data-v-804d79b6]{padding-right:.5rem!important;padding-left:.5rem!important}.px-3[data-v-804d79b6]{padding-right:1rem!important;padding-left:1rem!important}.px-4[data-v-804d79b6]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-5[data-v-804d79b6]{padding-right:3rem!important;padding-left:3rem!important}.py-0[data-v-804d79b6]{padding-top:0!important;padding-bottom:0!important}.py-1[data-v-804d79b6]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-2[data-v-804d79b6]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-3[data-v-804d79b6]{padding-top:1rem!important;padding-bottom:1rem!important}.py-4[data-v-804d79b6]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-5[data-v-804d79b6]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-0[data-v-804d79b6]{padding-top:0!important}.pt-1[data-v-804d79b6]{padding-top:.25rem!important}.pt-2[data-v-804d79b6]{padding-top:.5rem!important}.pt-3[data-v-804d79b6]{padding-top:1rem!important}.pt-4[data-v-804d79b6]{padding-top:1.5rem!important}.pt-5[data-v-804d79b6]{padding-top:3rem!important}.pe-0[data-v-804d79b6]{padding-right:0!important}.pe-1[data-v-804d79b6]{padding-right:.25rem!important}.pe-2[data-v-804d79b6]{padding-right:.5rem!important}.pe-3[data-v-804d79b6]{padding-right:1rem!important}.pe-4[data-v-804d79b6]{padding-right:1.5rem!important}.pe-5[data-v-804d79b6]{padding-right:3rem!important}.pb-0[data-v-804d79b6]{padding-bottom:0!important}.pb-1[data-v-804d79b6]{padding-bottom:.25rem!important}.pb-2[data-v-804d79b6]{padding-bottom:.5rem!important}.pb-3[data-v-804d79b6]{padding-bottom:1rem!important}.pb-4[data-v-804d79b6]{padding-bottom:1.5rem!important}.pb-5[data-v-804d79b6]{padding-bottom:3rem!important}.ps-0[data-v-804d79b6]{padding-left:0!important}.ps-1[data-v-804d79b6]{padding-left:.25rem!important}.ps-2[data-v-804d79b6]{padding-left:.5rem!important}.ps-3[data-v-804d79b6]{padding-left:1rem!important}.ps-4[data-v-804d79b6]{padding-left:1.5rem!important}.ps-5[data-v-804d79b6]{padding-left:3rem!important}.font-monospace[data-v-804d79b6]{font-family:var(--bs-font-monospace)!important}.fs-1[data-v-804d79b6]{font-size:calc(1.375rem + 1.5vw)!important}.fs-2[data-v-804d79b6]{font-size:calc(1.325rem + .9vw)!important}.fs-3[data-v-804d79b6]{font-size:calc(1.3rem + .6vw)!important}.fs-4[data-v-804d79b6]{font-size:calc(1.275rem + .3vw)!important}.fs-5[data-v-804d79b6]{font-size:1.25rem!important}.fs-6[data-v-804d79b6]{font-size:1rem!important}.fst-italic[data-v-804d79b6]{font-style:italic!important}.fst-normal[data-v-804d79b6]{font-style:normal!important}.fw-light[data-v-804d79b6]{font-weight:300!important}.fw-lighter[data-v-804d79b6]{font-weight:lighter!important}.fw-normal[data-v-804d79b6]{font-weight:400!important}.fw-bold[data-v-804d79b6]{font-weight:700!important}.fw-bolder[data-v-804d79b6]{font-weight:bolder!important}.lh-1[data-v-804d79b6]{line-height:1!important}.lh-sm[data-v-804d79b6]{line-height:1.25!important}.lh-base[data-v-804d79b6]{line-height:1.5!important}.lh-lg[data-v-804d79b6]{line-height:2!important}.text-start[data-v-804d79b6]{text-align:left!important}.text-end[data-v-804d79b6]{text-align:right!important}.text-center[data-v-804d79b6]{text-align:center!important}.text-decoration-none[data-v-804d79b6]{text-decoration:none!important}.text-decoration-underline[data-v-804d79b6]{text-decoration:underline!important}.text-decoration-line-through[data-v-804d79b6]{text-decoration:line-through!important}.text-lowercase[data-v-804d79b6]{text-transform:lowercase!important}.text-uppercase[data-v-804d79b6]{text-transform:uppercase!important}.text-capitalize[data-v-804d79b6]{text-transform:capitalize!important}.text-wrap[data-v-804d79b6]{white-space:normal!important}.text-nowrap[data-v-804d79b6]{white-space:nowrap!important}.text-break[data-v-804d79b6]{word-wrap:break-word!important;word-break:break-word!important}.text-primary[data-v-804d79b6]{--bs-text-opacity:1;color:rgba(var(--bs-primary-rgb),var(--bs-text-opacity))!important}.text-secondary[data-v-804d79b6]{--bs-text-opacity:1;color:rgba(var(--bs-secondary-rgb),var(--bs-text-opacity))!important}.text-success[data-v-804d79b6]{--bs-text-opacity:1;color:rgba(var(--bs-success-rgb),var(--bs-text-opacity))!important}.text-info[data-v-804d79b6]{--bs-text-opacity:1;color:rgba(var(--bs-info-rgb),var(--bs-text-opacity))!important}.text-warning[data-v-804d79b6]{--bs-text-opacity:1;color:rgba(var(--bs-warning-rgb),var(--bs-text-opacity))!important}.text-danger[data-v-804d79b6]{--bs-text-opacity:1;color:rgba(var(--bs-danger-rgb),var(--bs-text-opacity))!important}.text-light[data-v-804d79b6]{--bs-text-opacity:1;color:rgba(var(--bs-light-rgb),var(--bs-text-opacity))!important}.text-dark[data-v-804d79b6]{--bs-text-opacity:1;color:rgba(var(--bs-dark-rgb),var(--bs-text-opacity))!important}.text-black[data-v-804d79b6]{--bs-text-opacity:1;color:rgba(var(--bs-black-rgb),var(--bs-text-opacity))!important}.text-white[data-v-804d79b6]{--bs-text-opacity:1;color:rgba(var(--bs-white-rgb),var(--bs-text-opacity))!important}.text-body[data-v-804d79b6]{--bs-text-opacity:1;color:rgba(var(--bs-body-color-rgb),var(--bs-text-opacity))!important}.text-muted[data-v-804d79b6]{--bs-text-opacity:1;color:#6c757d!important}.text-black-50[data-v-804d79b6]{--bs-text-opacity:1;color:rgba(0,0,0,.5)!important}.text-white-50[data-v-804d79b6]{--bs-text-opacity:1;color:hsla(0,0%,100%,.5)!important}.text-reset[data-v-804d79b6]{--bs-text-opacity:1;color:inherit!important}.text-opacity-25[data-v-804d79b6]{--bs-text-opacity:0.25}.text-opacity-50[data-v-804d79b6]{--bs-text-opacity:0.5}.text-opacity-75[data-v-804d79b6]{--bs-text-opacity:0.75}.text-opacity-100[data-v-804d79b6]{--bs-text-opacity:1}.bg-primary[data-v-804d79b6]{--bs-bg-opacity:1;background-color:rgba(var(--bs-primary-rgb),var(--bs-bg-opacity))!important}.bg-secondary[data-v-804d79b6]{--bs-bg-opacity:1;background-color:rgba(var(--bs-secondary-rgb),var(--bs-bg-opacity))!important}.bg-success[data-v-804d79b6]{--bs-bg-opacity:1;background-color:rgba(var(--bs-success-rgb),var(--bs-bg-opacity))!important}.bg-info[data-v-804d79b6]{--bs-bg-opacity:1;background-color:rgba(var(--bs-info-rgb),var(--bs-bg-opacity))!important}.bg-warning[data-v-804d79b6]{--bs-bg-opacity:1;background-color:rgba(var(--bs-warning-rgb),var(--bs-bg-opacity))!important}.bg-danger[data-v-804d79b6]{--bs-bg-opacity:1;background-color:rgba(var(--bs-danger-rgb),var(--bs-bg-opacity))!important}.bg-light[data-v-804d79b6]{--bs-bg-opacity:1;background-color:rgba(var(--bs-light-rgb),var(--bs-bg-opacity))!important}.bg-dark[data-v-804d79b6]{--bs-bg-opacity:1;background-color:rgba(var(--bs-dark-rgb),var(--bs-bg-opacity))!important}.bg-black[data-v-804d79b6]{--bs-bg-opacity:1;background-color:rgba(var(--bs-black-rgb),var(--bs-bg-opacity))!important}.bg-white[data-v-804d79b6]{--bs-bg-opacity:1;background-color:rgba(var(--bs-white-rgb),var(--bs-bg-opacity))!important}.bg-body[data-v-804d79b6]{--bs-bg-opacity:1;background-color:rgba(var(--bs-body-bg-rgb),var(--bs-bg-opacity))!important}.bg-transparent[data-v-804d79b6]{--bs-bg-opacity:1;background-color:transparent!important}.bg-opacity-10[data-v-804d79b6]{--bs-bg-opacity:0.1}.bg-opacity-25[data-v-804d79b6]{--bs-bg-opacity:0.25}.bg-opacity-50[data-v-804d79b6]{--bs-bg-opacity:0.5}.bg-opacity-75[data-v-804d79b6]{--bs-bg-opacity:0.75}.bg-opacity-100[data-v-804d79b6]{--bs-bg-opacity:1}.bg-gradient[data-v-804d79b6]{background-image:var(--bs-gradient)!important}.user-select-all[data-v-804d79b6]{-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.user-select-auto[data-v-804d79b6]{-webkit-user-select:auto!important;-moz-user-select:auto!important;user-select:auto!important}.user-select-none[data-v-804d79b6]{-webkit-user-select:none!important;-moz-user-select:none!important;user-select:none!important}.pe-none[data-v-804d79b6]{pointer-events:none!important}.pe-auto[data-v-804d79b6]{pointer-events:auto!important}.rounded[data-v-804d79b6]{border-radius:.25rem!important}.rounded-0[data-v-804d79b6]{border-radius:0!important}.rounded-1[data-v-804d79b6]{border-radius:.2rem!important}.rounded-2[data-v-804d79b6]{border-radius:.25rem!important}.rounded-3[data-v-804d79b6]{border-radius:.3rem!important}.rounded-circle[data-v-804d79b6]{border-radius:50%!important}.rounded-pill[data-v-804d79b6]{border-radius:50rem!important}.rounded-top[data-v-804d79b6]{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.rounded-end[data-v-804d79b6]{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.rounded-bottom[data-v-804d79b6]{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-start[data-v-804d79b6]{border-bottom-left-radius:.25rem!important;border-top-left-radius:.25rem!important}.visible[data-v-804d79b6]{visibility:visible!important}.invisible[data-v-804d79b6]{visibility:hidden!important}@media (min-width:576px){.float-sm-start[data-v-804d79b6]{float:left!important}.float-sm-end[data-v-804d79b6]{float:right!important}.float-sm-none[data-v-804d79b6]{float:none!important}.d-sm-inline[data-v-804d79b6]{display:inline!important}.d-sm-inline-block[data-v-804d79b6]{display:inline-block!important}.d-sm-block[data-v-804d79b6]{display:block!important}.d-sm-grid[data-v-804d79b6]{display:grid!important}.d-sm-table[data-v-804d79b6]{display:table!important}.d-sm-table-row[data-v-804d79b6]{display:table-row!important}.d-sm-table-cell[data-v-804d79b6]{display:table-cell!important}.d-sm-flex[data-v-804d79b6]{display:flex!important}.d-sm-inline-flex[data-v-804d79b6]{display:inline-flex!important}.d-sm-none[data-v-804d79b6]{display:none!important}.flex-sm-fill[data-v-804d79b6]{flex:1 1 auto!important}.flex-sm-row[data-v-804d79b6]{flex-direction:row!important}.flex-sm-column[data-v-804d79b6]{flex-direction:column!important}.flex-sm-row-reverse[data-v-804d79b6]{flex-direction:row-reverse!important}.flex-sm-column-reverse[data-v-804d79b6]{flex-direction:column-reverse!important}.flex-sm-grow-0[data-v-804d79b6]{flex-grow:0!important}.flex-sm-grow-1[data-v-804d79b6]{flex-grow:1!important}.flex-sm-shrink-0[data-v-804d79b6]{flex-shrink:0!important}.flex-sm-shrink-1[data-v-804d79b6]{flex-shrink:1!important}.flex-sm-wrap[data-v-804d79b6]{flex-wrap:wrap!important}.flex-sm-nowrap[data-v-804d79b6]{flex-wrap:nowrap!important}.flex-sm-wrap-reverse[data-v-804d79b6]{flex-wrap:wrap-reverse!important}.gap-sm-0[data-v-804d79b6]{gap:0!important}.gap-sm-1[data-v-804d79b6]{gap:.25rem!important}.gap-sm-2[data-v-804d79b6]{gap:.5rem!important}.gap-sm-3[data-v-804d79b6]{gap:1rem!important}.gap-sm-4[data-v-804d79b6]{gap:1.5rem!important}.gap-sm-5[data-v-804d79b6]{gap:3rem!important}.justify-content-sm-start[data-v-804d79b6]{justify-content:flex-start!important}.justify-content-sm-end[data-v-804d79b6]{justify-content:flex-end!important}.justify-content-sm-center[data-v-804d79b6]{justify-content:center!important}.justify-content-sm-between[data-v-804d79b6]{justify-content:space-between!important}.justify-content-sm-around[data-v-804d79b6]{justify-content:space-around!important}.justify-content-sm-evenly[data-v-804d79b6]{justify-content:space-evenly!important}.align-items-sm-start[data-v-804d79b6]{align-items:flex-start!important}.align-items-sm-end[data-v-804d79b6]{align-items:flex-end!important}.align-items-sm-center[data-v-804d79b6]{align-items:center!important}.align-items-sm-baseline[data-v-804d79b6]{align-items:baseline!important}.align-items-sm-stretch[data-v-804d79b6]{align-items:stretch!important}.align-content-sm-start[data-v-804d79b6]{align-content:flex-start!important}.align-content-sm-end[data-v-804d79b6]{align-content:flex-end!important}.align-content-sm-center[data-v-804d79b6]{align-content:center!important}.align-content-sm-between[data-v-804d79b6]{align-content:space-between!important}.align-content-sm-around[data-v-804d79b6]{align-content:space-around!important}.align-content-sm-stretch[data-v-804d79b6]{align-content:stretch!important}.align-self-sm-auto[data-v-804d79b6]{align-self:auto!important}.align-self-sm-start[data-v-804d79b6]{align-self:flex-start!important}.align-self-sm-end[data-v-804d79b6]{align-self:flex-end!important}.align-self-sm-center[data-v-804d79b6]{align-self:center!important}.align-self-sm-baseline[data-v-804d79b6]{align-self:baseline!important}.align-self-sm-stretch[data-v-804d79b6]{align-self:stretch!important}.order-sm-first[data-v-804d79b6]{order:-1!important}.order-sm-0[data-v-804d79b6]{order:0!important}.order-sm-1[data-v-804d79b6]{order:1!important}.order-sm-2[data-v-804d79b6]{order:2!important}.order-sm-3[data-v-804d79b6]{order:3!important}.order-sm-4[data-v-804d79b6]{order:4!important}.order-sm-5[data-v-804d79b6]{order:5!important}.order-sm-last[data-v-804d79b6]{order:6!important}.m-sm-0[data-v-804d79b6]{margin:0!important}.m-sm-1[data-v-804d79b6]{margin:.25rem!important}.m-sm-2[data-v-804d79b6]{margin:.5rem!important}.m-sm-3[data-v-804d79b6]{margin:1rem!important}.m-sm-4[data-v-804d79b6]{margin:1.5rem!important}.m-sm-5[data-v-804d79b6]{margin:3rem!important}.m-sm-auto[data-v-804d79b6]{margin:auto!important}.mx-sm-0[data-v-804d79b6]{margin-right:0!important;margin-left:0!important}.mx-sm-1[data-v-804d79b6]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-sm-2[data-v-804d79b6]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-sm-3[data-v-804d79b6]{margin-right:1rem!important;margin-left:1rem!important}.mx-sm-4[data-v-804d79b6]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-sm-5[data-v-804d79b6]{margin-right:3rem!important;margin-left:3rem!important}.mx-sm-auto[data-v-804d79b6]{margin-right:auto!important;margin-left:auto!important}.my-sm-0[data-v-804d79b6]{margin-top:0!important;margin-bottom:0!important}.my-sm-1[data-v-804d79b6]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-sm-2[data-v-804d79b6]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-sm-3[data-v-804d79b6]{margin-top:1rem!important;margin-bottom:1rem!important}.my-sm-4[data-v-804d79b6]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-sm-5[data-v-804d79b6]{margin-top:3rem!important;margin-bottom:3rem!important}.my-sm-auto[data-v-804d79b6]{margin-top:auto!important;margin-bottom:auto!important}.mt-sm-0[data-v-804d79b6]{margin-top:0!important}.mt-sm-1[data-v-804d79b6]{margin-top:.25rem!important}.mt-sm-2[data-v-804d79b6]{margin-top:.5rem!important}.mt-sm-3[data-v-804d79b6]{margin-top:1rem!important}.mt-sm-4[data-v-804d79b6]{margin-top:1.5rem!important}.mt-sm-5[data-v-804d79b6]{margin-top:3rem!important}.mt-sm-auto[data-v-804d79b6]{margin-top:auto!important}.me-sm-0[data-v-804d79b6]{margin-right:0!important}.me-sm-1[data-v-804d79b6]{margin-right:.25rem!important}.me-sm-2[data-v-804d79b6]{margin-right:.5rem!important}.me-sm-3[data-v-804d79b6]{margin-right:1rem!important}.me-sm-4[data-v-804d79b6]{margin-right:1.5rem!important}.me-sm-5[data-v-804d79b6]{margin-right:3rem!important}.me-sm-auto[data-v-804d79b6]{margin-right:auto!important}.mb-sm-0[data-v-804d79b6]{margin-bottom:0!important}.mb-sm-1[data-v-804d79b6]{margin-bottom:.25rem!important}.mb-sm-2[data-v-804d79b6]{margin-bottom:.5rem!important}.mb-sm-3[data-v-804d79b6]{margin-bottom:1rem!important}.mb-sm-4[data-v-804d79b6]{margin-bottom:1.5rem!important}.mb-sm-5[data-v-804d79b6]{margin-bottom:3rem!important}.mb-sm-auto[data-v-804d79b6]{margin-bottom:auto!important}.ms-sm-0[data-v-804d79b6]{margin-left:0!important}.ms-sm-1[data-v-804d79b6]{margin-left:.25rem!important}.ms-sm-2[data-v-804d79b6]{margin-left:.5rem!important}.ms-sm-3[data-v-804d79b6]{margin-left:1rem!important}.ms-sm-4[data-v-804d79b6]{margin-left:1.5rem!important}.ms-sm-5[data-v-804d79b6]{margin-left:3rem!important}.ms-sm-auto[data-v-804d79b6]{margin-left:auto!important}.p-sm-0[data-v-804d79b6]{padding:0!important}.p-sm-1[data-v-804d79b6]{padding:.25rem!important}.p-sm-2[data-v-804d79b6]{padding:.5rem!important}.p-sm-3[data-v-804d79b6]{padding:1rem!important}.p-sm-4[data-v-804d79b6]{padding:1.5rem!important}.p-sm-5[data-v-804d79b6]{padding:3rem!important}.px-sm-0[data-v-804d79b6]{padding-right:0!important;padding-left:0!important}.px-sm-1[data-v-804d79b6]{padding-right:.25rem!important;padding-left:.25rem!important}.px-sm-2[data-v-804d79b6]{padding-right:.5rem!important;padding-left:.5rem!important}.px-sm-3[data-v-804d79b6]{padding-right:1rem!important;padding-left:1rem!important}.px-sm-4[data-v-804d79b6]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-sm-5[data-v-804d79b6]{padding-right:3rem!important;padding-left:3rem!important}.py-sm-0[data-v-804d79b6]{padding-top:0!important;padding-bottom:0!important}.py-sm-1[data-v-804d79b6]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-sm-2[data-v-804d79b6]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-sm-3[data-v-804d79b6]{padding-top:1rem!important;padding-bottom:1rem!important}.py-sm-4[data-v-804d79b6]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-sm-5[data-v-804d79b6]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-sm-0[data-v-804d79b6]{padding-top:0!important}.pt-sm-1[data-v-804d79b6]{padding-top:.25rem!important}.pt-sm-2[data-v-804d79b6]{padding-top:.5rem!important}.pt-sm-3[data-v-804d79b6]{padding-top:1rem!important}.pt-sm-4[data-v-804d79b6]{padding-top:1.5rem!important}.pt-sm-5[data-v-804d79b6]{padding-top:3rem!important}.pe-sm-0[data-v-804d79b6]{padding-right:0!important}.pe-sm-1[data-v-804d79b6]{padding-right:.25rem!important}.pe-sm-2[data-v-804d79b6]{padding-right:.5rem!important}.pe-sm-3[data-v-804d79b6]{padding-right:1rem!important}.pe-sm-4[data-v-804d79b6]{padding-right:1.5rem!important}.pe-sm-5[data-v-804d79b6]{padding-right:3rem!important}.pb-sm-0[data-v-804d79b6]{padding-bottom:0!important}.pb-sm-1[data-v-804d79b6]{padding-bottom:.25rem!important}.pb-sm-2[data-v-804d79b6]{padding-bottom:.5rem!important}.pb-sm-3[data-v-804d79b6]{padding-bottom:1rem!important}.pb-sm-4[data-v-804d79b6]{padding-bottom:1.5rem!important}.pb-sm-5[data-v-804d79b6]{padding-bottom:3rem!important}.ps-sm-0[data-v-804d79b6]{padding-left:0!important}.ps-sm-1[data-v-804d79b6]{padding-left:.25rem!important}.ps-sm-2[data-v-804d79b6]{padding-left:.5rem!important}.ps-sm-3[data-v-804d79b6]{padding-left:1rem!important}.ps-sm-4[data-v-804d79b6]{padding-left:1.5rem!important}.ps-sm-5[data-v-804d79b6]{padding-left:3rem!important}.text-sm-start[data-v-804d79b6]{text-align:left!important}.text-sm-end[data-v-804d79b6]{text-align:right!important}.text-sm-center[data-v-804d79b6]{text-align:center!important}}@media (min-width:768px){.float-md-start[data-v-804d79b6]{float:left!important}.float-md-end[data-v-804d79b6]{float:right!important}.float-md-none[data-v-804d79b6]{float:none!important}.d-md-inline[data-v-804d79b6]{display:inline!important}.d-md-inline-block[data-v-804d79b6]{display:inline-block!important}.d-md-block[data-v-804d79b6]{display:block!important}.d-md-grid[data-v-804d79b6]{display:grid!important}.d-md-table[data-v-804d79b6]{display:table!important}.d-md-table-row[data-v-804d79b6]{display:table-row!important}.d-md-table-cell[data-v-804d79b6]{display:table-cell!important}.d-md-flex[data-v-804d79b6]{display:flex!important}.d-md-inline-flex[data-v-804d79b6]{display:inline-flex!important}.d-md-none[data-v-804d79b6]{display:none!important}.flex-md-fill[data-v-804d79b6]{flex:1 1 auto!important}.flex-md-row[data-v-804d79b6]{flex-direction:row!important}.flex-md-column[data-v-804d79b6]{flex-direction:column!important}.flex-md-row-reverse[data-v-804d79b6]{flex-direction:row-reverse!important}.flex-md-column-reverse[data-v-804d79b6]{flex-direction:column-reverse!important}.flex-md-grow-0[data-v-804d79b6]{flex-grow:0!important}.flex-md-grow-1[data-v-804d79b6]{flex-grow:1!important}.flex-md-shrink-0[data-v-804d79b6]{flex-shrink:0!important}.flex-md-shrink-1[data-v-804d79b6]{flex-shrink:1!important}.flex-md-wrap[data-v-804d79b6]{flex-wrap:wrap!important}.flex-md-nowrap[data-v-804d79b6]{flex-wrap:nowrap!important}.flex-md-wrap-reverse[data-v-804d79b6]{flex-wrap:wrap-reverse!important}.gap-md-0[data-v-804d79b6]{gap:0!important}.gap-md-1[data-v-804d79b6]{gap:.25rem!important}.gap-md-2[data-v-804d79b6]{gap:.5rem!important}.gap-md-3[data-v-804d79b6]{gap:1rem!important}.gap-md-4[data-v-804d79b6]{gap:1.5rem!important}.gap-md-5[data-v-804d79b6]{gap:3rem!important}.justify-content-md-start[data-v-804d79b6]{justify-content:flex-start!important}.justify-content-md-end[data-v-804d79b6]{justify-content:flex-end!important}.justify-content-md-center[data-v-804d79b6]{justify-content:center!important}.justify-content-md-between[data-v-804d79b6]{justify-content:space-between!important}.justify-content-md-around[data-v-804d79b6]{justify-content:space-around!important}.justify-content-md-evenly[data-v-804d79b6]{justify-content:space-evenly!important}.align-items-md-start[data-v-804d79b6]{align-items:flex-start!important}.align-items-md-end[data-v-804d79b6]{align-items:flex-end!important}.align-items-md-center[data-v-804d79b6]{align-items:center!important}.align-items-md-baseline[data-v-804d79b6]{align-items:baseline!important}.align-items-md-stretch[data-v-804d79b6]{align-items:stretch!important}.align-content-md-start[data-v-804d79b6]{align-content:flex-start!important}.align-content-md-end[data-v-804d79b6]{align-content:flex-end!important}.align-content-md-center[data-v-804d79b6]{align-content:center!important}.align-content-md-between[data-v-804d79b6]{align-content:space-between!important}.align-content-md-around[data-v-804d79b6]{align-content:space-around!important}.align-content-md-stretch[data-v-804d79b6]{align-content:stretch!important}.align-self-md-auto[data-v-804d79b6]{align-self:auto!important}.align-self-md-start[data-v-804d79b6]{align-self:flex-start!important}.align-self-md-end[data-v-804d79b6]{align-self:flex-end!important}.align-self-md-center[data-v-804d79b6]{align-self:center!important}.align-self-md-baseline[data-v-804d79b6]{align-self:baseline!important}.align-self-md-stretch[data-v-804d79b6]{align-self:stretch!important}.order-md-first[data-v-804d79b6]{order:-1!important}.order-md-0[data-v-804d79b6]{order:0!important}.order-md-1[data-v-804d79b6]{order:1!important}.order-md-2[data-v-804d79b6]{order:2!important}.order-md-3[data-v-804d79b6]{order:3!important}.order-md-4[data-v-804d79b6]{order:4!important}.order-md-5[data-v-804d79b6]{order:5!important}.order-md-last[data-v-804d79b6]{order:6!important}.m-md-0[data-v-804d79b6]{margin:0!important}.m-md-1[data-v-804d79b6]{margin:.25rem!important}.m-md-2[data-v-804d79b6]{margin:.5rem!important}.m-md-3[data-v-804d79b6]{margin:1rem!important}.m-md-4[data-v-804d79b6]{margin:1.5rem!important}.m-md-5[data-v-804d79b6]{margin:3rem!important}.m-md-auto[data-v-804d79b6]{margin:auto!important}.mx-md-0[data-v-804d79b6]{margin-right:0!important;margin-left:0!important}.mx-md-1[data-v-804d79b6]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-md-2[data-v-804d79b6]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-md-3[data-v-804d79b6]{margin-right:1rem!important;margin-left:1rem!important}.mx-md-4[data-v-804d79b6]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-md-5[data-v-804d79b6]{margin-right:3rem!important;margin-left:3rem!important}.mx-md-auto[data-v-804d79b6]{margin-right:auto!important;margin-left:auto!important}.my-md-0[data-v-804d79b6]{margin-top:0!important;margin-bottom:0!important}.my-md-1[data-v-804d79b6]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-md-2[data-v-804d79b6]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-md-3[data-v-804d79b6]{margin-top:1rem!important;margin-bottom:1rem!important}.my-md-4[data-v-804d79b6]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-md-5[data-v-804d79b6]{margin-top:3rem!important;margin-bottom:3rem!important}.my-md-auto[data-v-804d79b6]{margin-top:auto!important;margin-bottom:auto!important}.mt-md-0[data-v-804d79b6]{margin-top:0!important}.mt-md-1[data-v-804d79b6]{margin-top:.25rem!important}.mt-md-2[data-v-804d79b6]{margin-top:.5rem!important}.mt-md-3[data-v-804d79b6]{margin-top:1rem!important}.mt-md-4[data-v-804d79b6]{margin-top:1.5rem!important}.mt-md-5[data-v-804d79b6]{margin-top:3rem!important}.mt-md-auto[data-v-804d79b6]{margin-top:auto!important}.me-md-0[data-v-804d79b6]{margin-right:0!important}.me-md-1[data-v-804d79b6]{margin-right:.25rem!important}.me-md-2[data-v-804d79b6]{margin-right:.5rem!important}.me-md-3[data-v-804d79b6]{margin-right:1rem!important}.me-md-4[data-v-804d79b6]{margin-right:1.5rem!important}.me-md-5[data-v-804d79b6]{margin-right:3rem!important}.me-md-auto[data-v-804d79b6]{margin-right:auto!important}.mb-md-0[data-v-804d79b6]{margin-bottom:0!important}.mb-md-1[data-v-804d79b6]{margin-bottom:.25rem!important}.mb-md-2[data-v-804d79b6]{margin-bottom:.5rem!important}.mb-md-3[data-v-804d79b6]{margin-bottom:1rem!important}.mb-md-4[data-v-804d79b6]{margin-bottom:1.5rem!important}.mb-md-5[data-v-804d79b6]{margin-bottom:3rem!important}.mb-md-auto[data-v-804d79b6]{margin-bottom:auto!important}.ms-md-0[data-v-804d79b6]{margin-left:0!important}.ms-md-1[data-v-804d79b6]{margin-left:.25rem!important}.ms-md-2[data-v-804d79b6]{margin-left:.5rem!important}.ms-md-3[data-v-804d79b6]{margin-left:1rem!important}.ms-md-4[data-v-804d79b6]{margin-left:1.5rem!important}.ms-md-5[data-v-804d79b6]{margin-left:3rem!important}.ms-md-auto[data-v-804d79b6]{margin-left:auto!important}.p-md-0[data-v-804d79b6]{padding:0!important}.p-md-1[data-v-804d79b6]{padding:.25rem!important}.p-md-2[data-v-804d79b6]{padding:.5rem!important}.p-md-3[data-v-804d79b6]{padding:1rem!important}.p-md-4[data-v-804d79b6]{padding:1.5rem!important}.p-md-5[data-v-804d79b6]{padding:3rem!important}.px-md-0[data-v-804d79b6]{padding-right:0!important;padding-left:0!important}.px-md-1[data-v-804d79b6]{padding-right:.25rem!important;padding-left:.25rem!important}.px-md-2[data-v-804d79b6]{padding-right:.5rem!important;padding-left:.5rem!important}.px-md-3[data-v-804d79b6]{padding-right:1rem!important;padding-left:1rem!important}.px-md-4[data-v-804d79b6]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-md-5[data-v-804d79b6]{padding-right:3rem!important;padding-left:3rem!important}.py-md-0[data-v-804d79b6]{padding-top:0!important;padding-bottom:0!important}.py-md-1[data-v-804d79b6]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-md-2[data-v-804d79b6]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-md-3[data-v-804d79b6]{padding-top:1rem!important;padding-bottom:1rem!important}.py-md-4[data-v-804d79b6]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-md-5[data-v-804d79b6]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-md-0[data-v-804d79b6]{padding-top:0!important}.pt-md-1[data-v-804d79b6]{padding-top:.25rem!important}.pt-md-2[data-v-804d79b6]{padding-top:.5rem!important}.pt-md-3[data-v-804d79b6]{padding-top:1rem!important}.pt-md-4[data-v-804d79b6]{padding-top:1.5rem!important}.pt-md-5[data-v-804d79b6]{padding-top:3rem!important}.pe-md-0[data-v-804d79b6]{padding-right:0!important}.pe-md-1[data-v-804d79b6]{padding-right:.25rem!important}.pe-md-2[data-v-804d79b6]{padding-right:.5rem!important}.pe-md-3[data-v-804d79b6]{padding-right:1rem!important}.pe-md-4[data-v-804d79b6]{padding-right:1.5rem!important}.pe-md-5[data-v-804d79b6]{padding-right:3rem!important}.pb-md-0[data-v-804d79b6]{padding-bottom:0!important}.pb-md-1[data-v-804d79b6]{padding-bottom:.25rem!important}.pb-md-2[data-v-804d79b6]{padding-bottom:.5rem!important}.pb-md-3[data-v-804d79b6]{padding-bottom:1rem!important}.pb-md-4[data-v-804d79b6]{padding-bottom:1.5rem!important}.pb-md-5[data-v-804d79b6]{padding-bottom:3rem!important}.ps-md-0[data-v-804d79b6]{padding-left:0!important}.ps-md-1[data-v-804d79b6]{padding-left:.25rem!important}.ps-md-2[data-v-804d79b6]{padding-left:.5rem!important}.ps-md-3[data-v-804d79b6]{padding-left:1rem!important}.ps-md-4[data-v-804d79b6]{padding-left:1.5rem!important}.ps-md-5[data-v-804d79b6]{padding-left:3rem!important}.text-md-start[data-v-804d79b6]{text-align:left!important}.text-md-end[data-v-804d79b6]{text-align:right!important}.text-md-center[data-v-804d79b6]{text-align:center!important}}@media (min-width:992px){.float-lg-start[data-v-804d79b6]{float:left!important}.float-lg-end[data-v-804d79b6]{float:right!important}.float-lg-none[data-v-804d79b6]{float:none!important}.d-lg-inline[data-v-804d79b6]{display:inline!important}.d-lg-inline-block[data-v-804d79b6]{display:inline-block!important}.d-lg-block[data-v-804d79b6]{display:block!important}.d-lg-grid[data-v-804d79b6]{display:grid!important}.d-lg-table[data-v-804d79b6]{display:table!important}.d-lg-table-row[data-v-804d79b6]{display:table-row!important}.d-lg-table-cell[data-v-804d79b6]{display:table-cell!important}.d-lg-flex[data-v-804d79b6]{display:flex!important}.d-lg-inline-flex[data-v-804d79b6]{display:inline-flex!important}.d-lg-none[data-v-804d79b6]{display:none!important}.flex-lg-fill[data-v-804d79b6]{flex:1 1 auto!important}.flex-lg-row[data-v-804d79b6]{flex-direction:row!important}.flex-lg-column[data-v-804d79b6]{flex-direction:column!important}.flex-lg-row-reverse[data-v-804d79b6]{flex-direction:row-reverse!important}.flex-lg-column-reverse[data-v-804d79b6]{flex-direction:column-reverse!important}.flex-lg-grow-0[data-v-804d79b6]{flex-grow:0!important}.flex-lg-grow-1[data-v-804d79b6]{flex-grow:1!important}.flex-lg-shrink-0[data-v-804d79b6]{flex-shrink:0!important}.flex-lg-shrink-1[data-v-804d79b6]{flex-shrink:1!important}.flex-lg-wrap[data-v-804d79b6]{flex-wrap:wrap!important}.flex-lg-nowrap[data-v-804d79b6]{flex-wrap:nowrap!important}.flex-lg-wrap-reverse[data-v-804d79b6]{flex-wrap:wrap-reverse!important}.gap-lg-0[data-v-804d79b6]{gap:0!important}.gap-lg-1[data-v-804d79b6]{gap:.25rem!important}.gap-lg-2[data-v-804d79b6]{gap:.5rem!important}.gap-lg-3[data-v-804d79b6]{gap:1rem!important}.gap-lg-4[data-v-804d79b6]{gap:1.5rem!important}.gap-lg-5[data-v-804d79b6]{gap:3rem!important}.justify-content-lg-start[data-v-804d79b6]{justify-content:flex-start!important}.justify-content-lg-end[data-v-804d79b6]{justify-content:flex-end!important}.justify-content-lg-center[data-v-804d79b6]{justify-content:center!important}.justify-content-lg-between[data-v-804d79b6]{justify-content:space-between!important}.justify-content-lg-around[data-v-804d79b6]{justify-content:space-around!important}.justify-content-lg-evenly[data-v-804d79b6]{justify-content:space-evenly!important}.align-items-lg-start[data-v-804d79b6]{align-items:flex-start!important}.align-items-lg-end[data-v-804d79b6]{align-items:flex-end!important}.align-items-lg-center[data-v-804d79b6]{align-items:center!important}.align-items-lg-baseline[data-v-804d79b6]{align-items:baseline!important}.align-items-lg-stretch[data-v-804d79b6]{align-items:stretch!important}.align-content-lg-start[data-v-804d79b6]{align-content:flex-start!important}.align-content-lg-end[data-v-804d79b6]{align-content:flex-end!important}.align-content-lg-center[data-v-804d79b6]{align-content:center!important}.align-content-lg-between[data-v-804d79b6]{align-content:space-between!important}.align-content-lg-around[data-v-804d79b6]{align-content:space-around!important}.align-content-lg-stretch[data-v-804d79b6]{align-content:stretch!important}.align-self-lg-auto[data-v-804d79b6]{align-self:auto!important}.align-self-lg-start[data-v-804d79b6]{align-self:flex-start!important}.align-self-lg-end[data-v-804d79b6]{align-self:flex-end!important}.align-self-lg-center[data-v-804d79b6]{align-self:center!important}.align-self-lg-baseline[data-v-804d79b6]{align-self:baseline!important}.align-self-lg-stretch[data-v-804d79b6]{align-self:stretch!important}.order-lg-first[data-v-804d79b6]{order:-1!important}.order-lg-0[data-v-804d79b6]{order:0!important}.order-lg-1[data-v-804d79b6]{order:1!important}.order-lg-2[data-v-804d79b6]{order:2!important}.order-lg-3[data-v-804d79b6]{order:3!important}.order-lg-4[data-v-804d79b6]{order:4!important}.order-lg-5[data-v-804d79b6]{order:5!important}.order-lg-last[data-v-804d79b6]{order:6!important}.m-lg-0[data-v-804d79b6]{margin:0!important}.m-lg-1[data-v-804d79b6]{margin:.25rem!important}.m-lg-2[data-v-804d79b6]{margin:.5rem!important}.m-lg-3[data-v-804d79b6]{margin:1rem!important}.m-lg-4[data-v-804d79b6]{margin:1.5rem!important}.m-lg-5[data-v-804d79b6]{margin:3rem!important}.m-lg-auto[data-v-804d79b6]{margin:auto!important}.mx-lg-0[data-v-804d79b6]{margin-right:0!important;margin-left:0!important}.mx-lg-1[data-v-804d79b6]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-lg-2[data-v-804d79b6]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-lg-3[data-v-804d79b6]{margin-right:1rem!important;margin-left:1rem!important}.mx-lg-4[data-v-804d79b6]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-lg-5[data-v-804d79b6]{margin-right:3rem!important;margin-left:3rem!important}.mx-lg-auto[data-v-804d79b6]{margin-right:auto!important;margin-left:auto!important}.my-lg-0[data-v-804d79b6]{margin-top:0!important;margin-bottom:0!important}.my-lg-1[data-v-804d79b6]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-lg-2[data-v-804d79b6]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-lg-3[data-v-804d79b6]{margin-top:1rem!important;margin-bottom:1rem!important}.my-lg-4[data-v-804d79b6]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-lg-5[data-v-804d79b6]{margin-top:3rem!important;margin-bottom:3rem!important}.my-lg-auto[data-v-804d79b6]{margin-top:auto!important;margin-bottom:auto!important}.mt-lg-0[data-v-804d79b6]{margin-top:0!important}.mt-lg-1[data-v-804d79b6]{margin-top:.25rem!important}.mt-lg-2[data-v-804d79b6]{margin-top:.5rem!important}.mt-lg-3[data-v-804d79b6]{margin-top:1rem!important}.mt-lg-4[data-v-804d79b6]{margin-top:1.5rem!important}.mt-lg-5[data-v-804d79b6]{margin-top:3rem!important}.mt-lg-auto[data-v-804d79b6]{margin-top:auto!important}.me-lg-0[data-v-804d79b6]{margin-right:0!important}.me-lg-1[data-v-804d79b6]{margin-right:.25rem!important}.me-lg-2[data-v-804d79b6]{margin-right:.5rem!important}.me-lg-3[data-v-804d79b6]{margin-right:1rem!important}.me-lg-4[data-v-804d79b6]{margin-right:1.5rem!important}.me-lg-5[data-v-804d79b6]{margin-right:3rem!important}.me-lg-auto[data-v-804d79b6]{margin-right:auto!important}.mb-lg-0[data-v-804d79b6]{margin-bottom:0!important}.mb-lg-1[data-v-804d79b6]{margin-bottom:.25rem!important}.mb-lg-2[data-v-804d79b6]{margin-bottom:.5rem!important}.mb-lg-3[data-v-804d79b6]{margin-bottom:1rem!important}.mb-lg-4[data-v-804d79b6]{margin-bottom:1.5rem!important}.mb-lg-5[data-v-804d79b6]{margin-bottom:3rem!important}.mb-lg-auto[data-v-804d79b6]{margin-bottom:auto!important}.ms-lg-0[data-v-804d79b6]{margin-left:0!important}.ms-lg-1[data-v-804d79b6]{margin-left:.25rem!important}.ms-lg-2[data-v-804d79b6]{margin-left:.5rem!important}.ms-lg-3[data-v-804d79b6]{margin-left:1rem!important}.ms-lg-4[data-v-804d79b6]{margin-left:1.5rem!important}.ms-lg-5[data-v-804d79b6]{margin-left:3rem!important}.ms-lg-auto[data-v-804d79b6]{margin-left:auto!important}.p-lg-0[data-v-804d79b6]{padding:0!important}.p-lg-1[data-v-804d79b6]{padding:.25rem!important}.p-lg-2[data-v-804d79b6]{padding:.5rem!important}.p-lg-3[data-v-804d79b6]{padding:1rem!important}.p-lg-4[data-v-804d79b6]{padding:1.5rem!important}.p-lg-5[data-v-804d79b6]{padding:3rem!important}.px-lg-0[data-v-804d79b6]{padding-right:0!important;padding-left:0!important}.px-lg-1[data-v-804d79b6]{padding-right:.25rem!important;padding-left:.25rem!important}.px-lg-2[data-v-804d79b6]{padding-right:.5rem!important;padding-left:.5rem!important}.px-lg-3[data-v-804d79b6]{padding-right:1rem!important;padding-left:1rem!important}.px-lg-4[data-v-804d79b6]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-lg-5[data-v-804d79b6]{padding-right:3rem!important;padding-left:3rem!important}.py-lg-0[data-v-804d79b6]{padding-top:0!important;padding-bottom:0!important}.py-lg-1[data-v-804d79b6]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-lg-2[data-v-804d79b6]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-lg-3[data-v-804d79b6]{padding-top:1rem!important;padding-bottom:1rem!important}.py-lg-4[data-v-804d79b6]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-lg-5[data-v-804d79b6]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-lg-0[data-v-804d79b6]{padding-top:0!important}.pt-lg-1[data-v-804d79b6]{padding-top:.25rem!important}.pt-lg-2[data-v-804d79b6]{padding-top:.5rem!important}.pt-lg-3[data-v-804d79b6]{padding-top:1rem!important}.pt-lg-4[data-v-804d79b6]{padding-top:1.5rem!important}.pt-lg-5[data-v-804d79b6]{padding-top:3rem!important}.pe-lg-0[data-v-804d79b6]{padding-right:0!important}.pe-lg-1[data-v-804d79b6]{padding-right:.25rem!important}.pe-lg-2[data-v-804d79b6]{padding-right:.5rem!important}.pe-lg-3[data-v-804d79b6]{padding-right:1rem!important}.pe-lg-4[data-v-804d79b6]{padding-right:1.5rem!important}.pe-lg-5[data-v-804d79b6]{padding-right:3rem!important}.pb-lg-0[data-v-804d79b6]{padding-bottom:0!important}.pb-lg-1[data-v-804d79b6]{padding-bottom:.25rem!important}.pb-lg-2[data-v-804d79b6]{padding-bottom:.5rem!important}.pb-lg-3[data-v-804d79b6]{padding-bottom:1rem!important}.pb-lg-4[data-v-804d79b6]{padding-bottom:1.5rem!important}.pb-lg-5[data-v-804d79b6]{padding-bottom:3rem!important}.ps-lg-0[data-v-804d79b6]{padding-left:0!important}.ps-lg-1[data-v-804d79b6]{padding-left:.25rem!important}.ps-lg-2[data-v-804d79b6]{padding-left:.5rem!important}.ps-lg-3[data-v-804d79b6]{padding-left:1rem!important}.ps-lg-4[data-v-804d79b6]{padding-left:1.5rem!important}.ps-lg-5[data-v-804d79b6]{padding-left:3rem!important}.text-lg-start[data-v-804d79b6]{text-align:left!important}.text-lg-end[data-v-804d79b6]{text-align:right!important}.text-lg-center[data-v-804d79b6]{text-align:center!important}}@media (min-width:1200px){.float-xl-start[data-v-804d79b6]{float:left!important}.float-xl-end[data-v-804d79b6]{float:right!important}.float-xl-none[data-v-804d79b6]{float:none!important}.d-xl-inline[data-v-804d79b6]{display:inline!important}.d-xl-inline-block[data-v-804d79b6]{display:inline-block!important}.d-xl-block[data-v-804d79b6]{display:block!important}.d-xl-grid[data-v-804d79b6]{display:grid!important}.d-xl-table[data-v-804d79b6]{display:table!important}.d-xl-table-row[data-v-804d79b6]{display:table-row!important}.d-xl-table-cell[data-v-804d79b6]{display:table-cell!important}.d-xl-flex[data-v-804d79b6]{display:flex!important}.d-xl-inline-flex[data-v-804d79b6]{display:inline-flex!important}.d-xl-none[data-v-804d79b6]{display:none!important}.flex-xl-fill[data-v-804d79b6]{flex:1 1 auto!important}.flex-xl-row[data-v-804d79b6]{flex-direction:row!important}.flex-xl-column[data-v-804d79b6]{flex-direction:column!important}.flex-xl-row-reverse[data-v-804d79b6]{flex-direction:row-reverse!important}.flex-xl-column-reverse[data-v-804d79b6]{flex-direction:column-reverse!important}.flex-xl-grow-0[data-v-804d79b6]{flex-grow:0!important}.flex-xl-grow-1[data-v-804d79b6]{flex-grow:1!important}.flex-xl-shrink-0[data-v-804d79b6]{flex-shrink:0!important}.flex-xl-shrink-1[data-v-804d79b6]{flex-shrink:1!important}.flex-xl-wrap[data-v-804d79b6]{flex-wrap:wrap!important}.flex-xl-nowrap[data-v-804d79b6]{flex-wrap:nowrap!important}.flex-xl-wrap-reverse[data-v-804d79b6]{flex-wrap:wrap-reverse!important}.gap-xl-0[data-v-804d79b6]{gap:0!important}.gap-xl-1[data-v-804d79b6]{gap:.25rem!important}.gap-xl-2[data-v-804d79b6]{gap:.5rem!important}.gap-xl-3[data-v-804d79b6]{gap:1rem!important}.gap-xl-4[data-v-804d79b6]{gap:1.5rem!important}.gap-xl-5[data-v-804d79b6]{gap:3rem!important}.justify-content-xl-start[data-v-804d79b6]{justify-content:flex-start!important}.justify-content-xl-end[data-v-804d79b6]{justify-content:flex-end!important}.justify-content-xl-center[data-v-804d79b6]{justify-content:center!important}.justify-content-xl-between[data-v-804d79b6]{justify-content:space-between!important}.justify-content-xl-around[data-v-804d79b6]{justify-content:space-around!important}.justify-content-xl-evenly[data-v-804d79b6]{justify-content:space-evenly!important}.align-items-xl-start[data-v-804d79b6]{align-items:flex-start!important}.align-items-xl-end[data-v-804d79b6]{align-items:flex-end!important}.align-items-xl-center[data-v-804d79b6]{align-items:center!important}.align-items-xl-baseline[data-v-804d79b6]{align-items:baseline!important}.align-items-xl-stretch[data-v-804d79b6]{align-items:stretch!important}.align-content-xl-start[data-v-804d79b6]{align-content:flex-start!important}.align-content-xl-end[data-v-804d79b6]{align-content:flex-end!important}.align-content-xl-center[data-v-804d79b6]{align-content:center!important}.align-content-xl-between[data-v-804d79b6]{align-content:space-between!important}.align-content-xl-around[data-v-804d79b6]{align-content:space-around!important}.align-content-xl-stretch[data-v-804d79b6]{align-content:stretch!important}.align-self-xl-auto[data-v-804d79b6]{align-self:auto!important}.align-self-xl-start[data-v-804d79b6]{align-self:flex-start!important}.align-self-xl-end[data-v-804d79b6]{align-self:flex-end!important}.align-self-xl-center[data-v-804d79b6]{align-self:center!important}.align-self-xl-baseline[data-v-804d79b6]{align-self:baseline!important}.align-self-xl-stretch[data-v-804d79b6]{align-self:stretch!important}.order-xl-first[data-v-804d79b6]{order:-1!important}.order-xl-0[data-v-804d79b6]{order:0!important}.order-xl-1[data-v-804d79b6]{order:1!important}.order-xl-2[data-v-804d79b6]{order:2!important}.order-xl-3[data-v-804d79b6]{order:3!important}.order-xl-4[data-v-804d79b6]{order:4!important}.order-xl-5[data-v-804d79b6]{order:5!important}.order-xl-last[data-v-804d79b6]{order:6!important}.m-xl-0[data-v-804d79b6]{margin:0!important}.m-xl-1[data-v-804d79b6]{margin:.25rem!important}.m-xl-2[data-v-804d79b6]{margin:.5rem!important}.m-xl-3[data-v-804d79b6]{margin:1rem!important}.m-xl-4[data-v-804d79b6]{margin:1.5rem!important}.m-xl-5[data-v-804d79b6]{margin:3rem!important}.m-xl-auto[data-v-804d79b6]{margin:auto!important}.mx-xl-0[data-v-804d79b6]{margin-right:0!important;margin-left:0!important}.mx-xl-1[data-v-804d79b6]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xl-2[data-v-804d79b6]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xl-3[data-v-804d79b6]{margin-right:1rem!important;margin-left:1rem!important}.mx-xl-4[data-v-804d79b6]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xl-5[data-v-804d79b6]{margin-right:3rem!important;margin-left:3rem!important}.mx-xl-auto[data-v-804d79b6]{margin-right:auto!important;margin-left:auto!important}.my-xl-0[data-v-804d79b6]{margin-top:0!important;margin-bottom:0!important}.my-xl-1[data-v-804d79b6]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xl-2[data-v-804d79b6]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xl-3[data-v-804d79b6]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xl-4[data-v-804d79b6]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xl-5[data-v-804d79b6]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xl-auto[data-v-804d79b6]{margin-top:auto!important;margin-bottom:auto!important}.mt-xl-0[data-v-804d79b6]{margin-top:0!important}.mt-xl-1[data-v-804d79b6]{margin-top:.25rem!important}.mt-xl-2[data-v-804d79b6]{margin-top:.5rem!important}.mt-xl-3[data-v-804d79b6]{margin-top:1rem!important}.mt-xl-4[data-v-804d79b6]{margin-top:1.5rem!important}.mt-xl-5[data-v-804d79b6]{margin-top:3rem!important}.mt-xl-auto[data-v-804d79b6]{margin-top:auto!important}.me-xl-0[data-v-804d79b6]{margin-right:0!important}.me-xl-1[data-v-804d79b6]{margin-right:.25rem!important}.me-xl-2[data-v-804d79b6]{margin-right:.5rem!important}.me-xl-3[data-v-804d79b6]{margin-right:1rem!important}.me-xl-4[data-v-804d79b6]{margin-right:1.5rem!important}.me-xl-5[data-v-804d79b6]{margin-right:3rem!important}.me-xl-auto[data-v-804d79b6]{margin-right:auto!important}.mb-xl-0[data-v-804d79b6]{margin-bottom:0!important}.mb-xl-1[data-v-804d79b6]{margin-bottom:.25rem!important}.mb-xl-2[data-v-804d79b6]{margin-bottom:.5rem!important}.mb-xl-3[data-v-804d79b6]{margin-bottom:1rem!important}.mb-xl-4[data-v-804d79b6]{margin-bottom:1.5rem!important}.mb-xl-5[data-v-804d79b6]{margin-bottom:3rem!important}.mb-xl-auto[data-v-804d79b6]{margin-bottom:auto!important}.ms-xl-0[data-v-804d79b6]{margin-left:0!important}.ms-xl-1[data-v-804d79b6]{margin-left:.25rem!important}.ms-xl-2[data-v-804d79b6]{margin-left:.5rem!important}.ms-xl-3[data-v-804d79b6]{margin-left:1rem!important}.ms-xl-4[data-v-804d79b6]{margin-left:1.5rem!important}.ms-xl-5[data-v-804d79b6]{margin-left:3rem!important}.ms-xl-auto[data-v-804d79b6]{margin-left:auto!important}.p-xl-0[data-v-804d79b6]{padding:0!important}.p-xl-1[data-v-804d79b6]{padding:.25rem!important}.p-xl-2[data-v-804d79b6]{padding:.5rem!important}.p-xl-3[data-v-804d79b6]{padding:1rem!important}.p-xl-4[data-v-804d79b6]{padding:1.5rem!important}.p-xl-5[data-v-804d79b6]{padding:3rem!important}.px-xl-0[data-v-804d79b6]{padding-right:0!important;padding-left:0!important}.px-xl-1[data-v-804d79b6]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xl-2[data-v-804d79b6]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xl-3[data-v-804d79b6]{padding-right:1rem!important;padding-left:1rem!important}.px-xl-4[data-v-804d79b6]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xl-5[data-v-804d79b6]{padding-right:3rem!important;padding-left:3rem!important}.py-xl-0[data-v-804d79b6]{padding-top:0!important;padding-bottom:0!important}.py-xl-1[data-v-804d79b6]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xl-2[data-v-804d79b6]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xl-3[data-v-804d79b6]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xl-4[data-v-804d79b6]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xl-5[data-v-804d79b6]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xl-0[data-v-804d79b6]{padding-top:0!important}.pt-xl-1[data-v-804d79b6]{padding-top:.25rem!important}.pt-xl-2[data-v-804d79b6]{padding-top:.5rem!important}.pt-xl-3[data-v-804d79b6]{padding-top:1rem!important}.pt-xl-4[data-v-804d79b6]{padding-top:1.5rem!important}.pt-xl-5[data-v-804d79b6]{padding-top:3rem!important}.pe-xl-0[data-v-804d79b6]{padding-right:0!important}.pe-xl-1[data-v-804d79b6]{padding-right:.25rem!important}.pe-xl-2[data-v-804d79b6]{padding-right:.5rem!important}.pe-xl-3[data-v-804d79b6]{padding-right:1rem!important}.pe-xl-4[data-v-804d79b6]{padding-right:1.5rem!important}.pe-xl-5[data-v-804d79b6]{padding-right:3rem!important}.pb-xl-0[data-v-804d79b6]{padding-bottom:0!important}.pb-xl-1[data-v-804d79b6]{padding-bottom:.25rem!important}.pb-xl-2[data-v-804d79b6]{padding-bottom:.5rem!important}.pb-xl-3[data-v-804d79b6]{padding-bottom:1rem!important}.pb-xl-4[data-v-804d79b6]{padding-bottom:1.5rem!important}.pb-xl-5[data-v-804d79b6]{padding-bottom:3rem!important}.ps-xl-0[data-v-804d79b6]{padding-left:0!important}.ps-xl-1[data-v-804d79b6]{padding-left:.25rem!important}.ps-xl-2[data-v-804d79b6]{padding-left:.5rem!important}.ps-xl-3[data-v-804d79b6]{padding-left:1rem!important}.ps-xl-4[data-v-804d79b6]{padding-left:1.5rem!important}.ps-xl-5[data-v-804d79b6]{padding-left:3rem!important}.text-xl-start[data-v-804d79b6]{text-align:left!important}.text-xl-end[data-v-804d79b6]{text-align:right!important}.text-xl-center[data-v-804d79b6]{text-align:center!important}}@media (min-width:1400px){.float-xxl-start[data-v-804d79b6]{float:left!important}.float-xxl-end[data-v-804d79b6]{float:right!important}.float-xxl-none[data-v-804d79b6]{float:none!important}.d-xxl-inline[data-v-804d79b6]{display:inline!important}.d-xxl-inline-block[data-v-804d79b6]{display:inline-block!important}.d-xxl-block[data-v-804d79b6]{display:block!important}.d-xxl-grid[data-v-804d79b6]{display:grid!important}.d-xxl-table[data-v-804d79b6]{display:table!important}.d-xxl-table-row[data-v-804d79b6]{display:table-row!important}.d-xxl-table-cell[data-v-804d79b6]{display:table-cell!important}.d-xxl-flex[data-v-804d79b6]{display:flex!important}.d-xxl-inline-flex[data-v-804d79b6]{display:inline-flex!important}.d-xxl-none[data-v-804d79b6]{display:none!important}.flex-xxl-fill[data-v-804d79b6]{flex:1 1 auto!important}.flex-xxl-row[data-v-804d79b6]{flex-direction:row!important}.flex-xxl-column[data-v-804d79b6]{flex-direction:column!important}.flex-xxl-row-reverse[data-v-804d79b6]{flex-direction:row-reverse!important}.flex-xxl-column-reverse[data-v-804d79b6]{flex-direction:column-reverse!important}.flex-xxl-grow-0[data-v-804d79b6]{flex-grow:0!important}.flex-xxl-grow-1[data-v-804d79b6]{flex-grow:1!important}.flex-xxl-shrink-0[data-v-804d79b6]{flex-shrink:0!important}.flex-xxl-shrink-1[data-v-804d79b6]{flex-shrink:1!important}.flex-xxl-wrap[data-v-804d79b6]{flex-wrap:wrap!important}.flex-xxl-nowrap[data-v-804d79b6]{flex-wrap:nowrap!important}.flex-xxl-wrap-reverse[data-v-804d79b6]{flex-wrap:wrap-reverse!important}.gap-xxl-0[data-v-804d79b6]{gap:0!important}.gap-xxl-1[data-v-804d79b6]{gap:.25rem!important}.gap-xxl-2[data-v-804d79b6]{gap:.5rem!important}.gap-xxl-3[data-v-804d79b6]{gap:1rem!important}.gap-xxl-4[data-v-804d79b6]{gap:1.5rem!important}.gap-xxl-5[data-v-804d79b6]{gap:3rem!important}.justify-content-xxl-start[data-v-804d79b6]{justify-content:flex-start!important}.justify-content-xxl-end[data-v-804d79b6]{justify-content:flex-end!important}.justify-content-xxl-center[data-v-804d79b6]{justify-content:center!important}.justify-content-xxl-between[data-v-804d79b6]{justify-content:space-between!important}.justify-content-xxl-around[data-v-804d79b6]{justify-content:space-around!important}.justify-content-xxl-evenly[data-v-804d79b6]{justify-content:space-evenly!important}.align-items-xxl-start[data-v-804d79b6]{align-items:flex-start!important}.align-items-xxl-end[data-v-804d79b6]{align-items:flex-end!important}.align-items-xxl-center[data-v-804d79b6]{align-items:center!important}.align-items-xxl-baseline[data-v-804d79b6]{align-items:baseline!important}.align-items-xxl-stretch[data-v-804d79b6]{align-items:stretch!important}.align-content-xxl-start[data-v-804d79b6]{align-content:flex-start!important}.align-content-xxl-end[data-v-804d79b6]{align-content:flex-end!important}.align-content-xxl-center[data-v-804d79b6]{align-content:center!important}.align-content-xxl-between[data-v-804d79b6]{align-content:space-between!important}.align-content-xxl-around[data-v-804d79b6]{align-content:space-around!important}.align-content-xxl-stretch[data-v-804d79b6]{align-content:stretch!important}.align-self-xxl-auto[data-v-804d79b6]{align-self:auto!important}.align-self-xxl-start[data-v-804d79b6]{align-self:flex-start!important}.align-self-xxl-end[data-v-804d79b6]{align-self:flex-end!important}.align-self-xxl-center[data-v-804d79b6]{align-self:center!important}.align-self-xxl-baseline[data-v-804d79b6]{align-self:baseline!important}.align-self-xxl-stretch[data-v-804d79b6]{align-self:stretch!important}.order-xxl-first[data-v-804d79b6]{order:-1!important}.order-xxl-0[data-v-804d79b6]{order:0!important}.order-xxl-1[data-v-804d79b6]{order:1!important}.order-xxl-2[data-v-804d79b6]{order:2!important}.order-xxl-3[data-v-804d79b6]{order:3!important}.order-xxl-4[data-v-804d79b6]{order:4!important}.order-xxl-5[data-v-804d79b6]{order:5!important}.order-xxl-last[data-v-804d79b6]{order:6!important}.m-xxl-0[data-v-804d79b6]{margin:0!important}.m-xxl-1[data-v-804d79b6]{margin:.25rem!important}.m-xxl-2[data-v-804d79b6]{margin:.5rem!important}.m-xxl-3[data-v-804d79b6]{margin:1rem!important}.m-xxl-4[data-v-804d79b6]{margin:1.5rem!important}.m-xxl-5[data-v-804d79b6]{margin:3rem!important}.m-xxl-auto[data-v-804d79b6]{margin:auto!important}.mx-xxl-0[data-v-804d79b6]{margin-right:0!important;margin-left:0!important}.mx-xxl-1[data-v-804d79b6]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xxl-2[data-v-804d79b6]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xxl-3[data-v-804d79b6]{margin-right:1rem!important;margin-left:1rem!important}.mx-xxl-4[data-v-804d79b6]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xxl-5[data-v-804d79b6]{margin-right:3rem!important;margin-left:3rem!important}.mx-xxl-auto[data-v-804d79b6]{margin-right:auto!important;margin-left:auto!important}.my-xxl-0[data-v-804d79b6]{margin-top:0!important;margin-bottom:0!important}.my-xxl-1[data-v-804d79b6]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xxl-2[data-v-804d79b6]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xxl-3[data-v-804d79b6]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xxl-4[data-v-804d79b6]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xxl-5[data-v-804d79b6]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xxl-auto[data-v-804d79b6]{margin-top:auto!important;margin-bottom:auto!important}.mt-xxl-0[data-v-804d79b6]{margin-top:0!important}.mt-xxl-1[data-v-804d79b6]{margin-top:.25rem!important}.mt-xxl-2[data-v-804d79b6]{margin-top:.5rem!important}.mt-xxl-3[data-v-804d79b6]{margin-top:1rem!important}.mt-xxl-4[data-v-804d79b6]{margin-top:1.5rem!important}.mt-xxl-5[data-v-804d79b6]{margin-top:3rem!important}.mt-xxl-auto[data-v-804d79b6]{margin-top:auto!important}.me-xxl-0[data-v-804d79b6]{margin-right:0!important}.me-xxl-1[data-v-804d79b6]{margin-right:.25rem!important}.me-xxl-2[data-v-804d79b6]{margin-right:.5rem!important}.me-xxl-3[data-v-804d79b6]{margin-right:1rem!important}.me-xxl-4[data-v-804d79b6]{margin-right:1.5rem!important}.me-xxl-5[data-v-804d79b6]{margin-right:3rem!important}.me-xxl-auto[data-v-804d79b6]{margin-right:auto!important}.mb-xxl-0[data-v-804d79b6]{margin-bottom:0!important}.mb-xxl-1[data-v-804d79b6]{margin-bottom:.25rem!important}.mb-xxl-2[data-v-804d79b6]{margin-bottom:.5rem!important}.mb-xxl-3[data-v-804d79b6]{margin-bottom:1rem!important}.mb-xxl-4[data-v-804d79b6]{margin-bottom:1.5rem!important}.mb-xxl-5[data-v-804d79b6]{margin-bottom:3rem!important}.mb-xxl-auto[data-v-804d79b6]{margin-bottom:auto!important}.ms-xxl-0[data-v-804d79b6]{margin-left:0!important}.ms-xxl-1[data-v-804d79b6]{margin-left:.25rem!important}.ms-xxl-2[data-v-804d79b6]{margin-left:.5rem!important}.ms-xxl-3[data-v-804d79b6]{margin-left:1rem!important}.ms-xxl-4[data-v-804d79b6]{margin-left:1.5rem!important}.ms-xxl-5[data-v-804d79b6]{margin-left:3rem!important}.ms-xxl-auto[data-v-804d79b6]{margin-left:auto!important}.p-xxl-0[data-v-804d79b6]{padding:0!important}.p-xxl-1[data-v-804d79b6]{padding:.25rem!important}.p-xxl-2[data-v-804d79b6]{padding:.5rem!important}.p-xxl-3[data-v-804d79b6]{padding:1rem!important}.p-xxl-4[data-v-804d79b6]{padding:1.5rem!important}.p-xxl-5[data-v-804d79b6]{padding:3rem!important}.px-xxl-0[data-v-804d79b6]{padding-right:0!important;padding-left:0!important}.px-xxl-1[data-v-804d79b6]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xxl-2[data-v-804d79b6]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xxl-3[data-v-804d79b6]{padding-right:1rem!important;padding-left:1rem!important}.px-xxl-4[data-v-804d79b6]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xxl-5[data-v-804d79b6]{padding-right:3rem!important;padding-left:3rem!important}.py-xxl-0[data-v-804d79b6]{padding-top:0!important;padding-bottom:0!important}.py-xxl-1[data-v-804d79b6]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xxl-2[data-v-804d79b6]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xxl-3[data-v-804d79b6]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xxl-4[data-v-804d79b6]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xxl-5[data-v-804d79b6]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xxl-0[data-v-804d79b6]{padding-top:0!important}.pt-xxl-1[data-v-804d79b6]{padding-top:.25rem!important}.pt-xxl-2[data-v-804d79b6]{padding-top:.5rem!important}.pt-xxl-3[data-v-804d79b6]{padding-top:1rem!important}.pt-xxl-4[data-v-804d79b6]{padding-top:1.5rem!important}.pt-xxl-5[data-v-804d79b6]{padding-top:3rem!important}.pe-xxl-0[data-v-804d79b6]{padding-right:0!important}.pe-xxl-1[data-v-804d79b6]{padding-right:.25rem!important}.pe-xxl-2[data-v-804d79b6]{padding-right:.5rem!important}.pe-xxl-3[data-v-804d79b6]{padding-right:1rem!important}.pe-xxl-4[data-v-804d79b6]{padding-right:1.5rem!important}.pe-xxl-5[data-v-804d79b6]{padding-right:3rem!important}.pb-xxl-0[data-v-804d79b6]{padding-bottom:0!important}.pb-xxl-1[data-v-804d79b6]{padding-bottom:.25rem!important}.pb-xxl-2[data-v-804d79b6]{padding-bottom:.5rem!important}.pb-xxl-3[data-v-804d79b6]{padding-bottom:1rem!important}.pb-xxl-4[data-v-804d79b6]{padding-bottom:1.5rem!important}.pb-xxl-5[data-v-804d79b6]{padding-bottom:3rem!important}.ps-xxl-0[data-v-804d79b6]{padding-left:0!important}.ps-xxl-1[data-v-804d79b6]{padding-left:.25rem!important}.ps-xxl-2[data-v-804d79b6]{padding-left:.5rem!important}.ps-xxl-3[data-v-804d79b6]{padding-left:1rem!important}.ps-xxl-4[data-v-804d79b6]{padding-left:1.5rem!important}.ps-xxl-5[data-v-804d79b6]{padding-left:3rem!important}.text-xxl-start[data-v-804d79b6]{text-align:left!important}.text-xxl-end[data-v-804d79b6]{text-align:right!important}.text-xxl-center[data-v-804d79b6]{text-align:center!important}}@media (min-width:1200px){.fs-1[data-v-804d79b6]{font-size:2.5rem!important}.fs-2[data-v-804d79b6]{font-size:2rem!important}.fs-3[data-v-804d79b6]{font-size:1.75rem!important}.fs-4[data-v-804d79b6]{font-size:1.5rem!important}}@media print{.d-print-inline[data-v-804d79b6]{display:inline!important}.d-print-inline-block[data-v-804d79b6]{display:inline-block!important}.d-print-block[data-v-804d79b6]{display:block!important}.d-print-grid[data-v-804d79b6]{display:grid!important}.d-print-table[data-v-804d79b6]{display:table!important}.d-print-table-row[data-v-804d79b6]{display:table-row!important}.d-print-table-cell[data-v-804d79b6]{display:table-cell!important}.d-print-flex[data-v-804d79b6]{display:flex!important}.d-print-inline-flex[data-v-804d79b6]{display:inline-flex!important}.d-print-none[data-v-804d79b6]{display:none!important}}", ""]);

// exports


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(157);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("b1558d62", content, true, {});

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".indented[data-v-804d79b6]{margin:20px;max-width:550px}.spacer[data-v-804d79b6]{height:25px;border:0 solid #000;clear:both}.smallspacer[data-v-804d79b6]{height:5px;border:0 solid #000;clear:both}.spaced[data-v-804d79b6]{margin-bottom:10px}.image[data-v-804d79b6]{width:90px;float:left;margin-right:20px}.button[data-v-804d79b6]{border:1px solid gray}.prodname[data-v-804d79b6]{font-size:10px}.proditem[data-v-804d79b6]{float:left;margin-right:15px}", ""]);

// exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indented"},[_c('h3',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_vm._l((_vm.selectedproduct),function(product){return _c('div',[_c('div',{staticClass:"form-horizontal"},[_c('h4',[_vm._v("Product Details")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[_vm._v("\r\n            Name:\r\n            "),_c('div',{staticClass:"col-md-10"},[_vm._v("\r\n              "+_vm._s(product.productname)+"\r\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[_vm._v("\r\n            Description:\r\n            "),_c('div',{staticClass:"col-md-10"},[_vm._v("\r\n              "+_vm._s(product.description)+"\r\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[_vm._v("\r\n            Price:\r\n            "),_c('div',{staticClass:"col-md-10"},[_vm._v("\r\n              € "+_vm._s(product.price)+"\r\n            ")])]),_vm._v(" "),_c('div',{staticClass:"spacer"}),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[_vm._v("\r\n            Picture:\r\n            "),_c('div',{staticClass:"col-md-10"},[_c('img',{attrs:{"id":"image","src":_vm.$options.filters.removetilde(product.picture)}})])]),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[_c('div',{staticClass:"spacer"}),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.goBack}},[_vm._v("<< Back")])])]),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[(product.alternateproducts)?_c('div',[_vm._v("See also these alternative products:")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"spacer"}),_vm._v(" "),_c('div',{staticClass:"col-md-10"},_vm._l((product.alternateproducts),function(altproduct){return _c('div',[_c('div',{staticClass:"proditem"},[_c('div',{staticClass:"prodname"},[_vm._v(_vm._s(altproduct.productname))]),_vm._v(" "),_c('img',{staticClass:"image",attrs:{"src":_vm.$options.filters.removetilde(altproduct.picture)},on:{"click":function($event){return _vm.showAltProduct(altproduct.id)}}})])])}),0),_vm._v(" "),_c('div',{staticClass:"spacer"}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-10"},[_c('input',{staticClass:"button btn btn-default",attrs:{"type":"button","value":"Add Alternative Products"},on:{"click":_vm.getAllProductsButOne}})])]),_vm._v(" "),_c('div',{staticClass:"spacer"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.altprodchooser),expression:"altprodchooser"}]},[_vm._v("\r\n              Click checkbox to add as a product alternative:\r\n              "),_c('div',{staticClass:"spacer"}),_vm._v(" "),_vm._l((_vm.altproducts),function(altproduct){return _c('div',[_c('div',{staticClass:"proditem"},[_c('div',{staticClass:"prodname"},[_vm._v(_vm._s(altproduct.productname))]),_vm._v(" "),_c('img',{staticClass:"image",attrs:{"src":_vm.$options.filters.removetilde(altproduct.picture)}}),_vm._v(" "),(_vm.IdChecked(altproduct.id))?_c('input',{attrs:{"checked":"","type":"checkbox","id":altproduct.id},on:{"click":_vm.checkHandler}}):(!_vm.IdChecked(altproduct.id))?_c('input',{attrs:{"type":"checkbox","id":altproduct.id},on:{"click":_vm.checkHandler}}):_vm._e()])])})],2)])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(160);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("77d616ef", content, true, {});

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n/*!\n * Bootstrap v5.1.3 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */[data-v-15445482]:root{--bs-blue:#0d6efd;--bs-indigo:#6610f2;--bs-purple:#6f42c1;--bs-pink:#d63384;--bs-red:#dc3545;--bs-orange:#fd7e14;--bs-yellow:#ffc107;--bs-green:#198754;--bs-teal:#20c997;--bs-cyan:#0dcaf0;--bs-white:#fff;--bs-gray:#6c757d;--bs-gray-dark:#343a40;--bs-gray-100:#f8f9fa;--bs-gray-200:#e9ecef;--bs-gray-300:#dee2e6;--bs-gray-400:#ced4da;--bs-gray-500:#adb5bd;--bs-gray-600:#6c757d;--bs-gray-700:#495057;--bs-gray-800:#343a40;--bs-gray-900:#212529;--bs-primary:#0d6efd;--bs-secondary:#6c757d;--bs-success:#198754;--bs-info:#0dcaf0;--bs-warning:#ffc107;--bs-danger:#dc3545;--bs-light:#f8f9fa;--bs-dark:#212529;--bs-primary-rgb:13,110,253;--bs-secondary-rgb:108,117,125;--bs-success-rgb:25,135,84;--bs-info-rgb:13,202,240;--bs-warning-rgb:255,193,7;--bs-danger-rgb:220,53,69;--bs-light-rgb:248,249,250;--bs-dark-rgb:33,37,41;--bs-white-rgb:255,255,255;--bs-black-rgb:0,0,0;--bs-body-color-rgb:33,37,41;--bs-body-bg-rgb:255,255,255;--bs-font-sans-serif:system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--bs-font-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;--bs-gradient:linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));--bs-body-font-family:var(--bs-font-sans-serif);--bs-body-font-size:1rem;--bs-body-font-weight:400;--bs-body-line-height:1.5;--bs-body-color:#212529;--bs-body-bg:#fff}[data-v-15445482],[data-v-15445482]:after,[data-v-15445482]:before{box-sizing:border-box}@media (prefers-reduced-motion:no-preference){[data-v-15445482]:root{scroll-behavior:smooth}}body[data-v-15445482]{margin:0;font-family:var(--bs-body-font-family);font-size:var(--bs-body-font-size);font-weight:var(--bs-body-font-weight);line-height:var(--bs-body-line-height);color:var(--bs-body-color);text-align:var(--bs-body-text-align);background-color:var(--bs-body-bg);-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}hr[data-v-15445482]{margin:1rem 0;color:inherit;background-color:currentColor;border:0;opacity:.25}hr[data-v-15445482]:not([size]){height:1px}.h1[data-v-15445482],.h2[data-v-15445482],.h3[data-v-15445482],.h4[data-v-15445482],.h5[data-v-15445482],.h6[data-v-15445482],h1[data-v-15445482],h2[data-v-15445482],h3[data-v-15445482],h4[data-v-15445482],h5[data-v-15445482],h6[data-v-15445482]{margin-top:0;margin-bottom:.5rem;font-weight:500;line-height:1.2}.h1[data-v-15445482],h1[data-v-15445482]{font-size:calc(1.375rem + 1.5vw)}@media (min-width:1200px){.h1[data-v-15445482],h1[data-v-15445482]{font-size:2.5rem}}.h2[data-v-15445482],h2[data-v-15445482]{font-size:calc(1.325rem + .9vw)}@media (min-width:1200px){.h2[data-v-15445482],h2[data-v-15445482]{font-size:2rem}}.h3[data-v-15445482],h3[data-v-15445482]{font-size:calc(1.3rem + .6vw)}@media (min-width:1200px){.h3[data-v-15445482],h3[data-v-15445482]{font-size:1.75rem}}.h4[data-v-15445482],h4[data-v-15445482]{font-size:calc(1.275rem + .3vw)}@media (min-width:1200px){.h4[data-v-15445482],h4[data-v-15445482]{font-size:1.5rem}}.h5[data-v-15445482],h5[data-v-15445482]{font-size:1.25rem}.h6[data-v-15445482],h6[data-v-15445482]{font-size:1rem}p[data-v-15445482]{margin-top:0;margin-bottom:1rem}abbr[data-bs-original-title][data-v-15445482],abbr[title][data-v-15445482]{-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address[data-v-15445482]{margin-bottom:1rem;font-style:normal;line-height:inherit}ol[data-v-15445482],ul[data-v-15445482]{padding-left:2rem}dl[data-v-15445482],ol[data-v-15445482],ul[data-v-15445482]{margin-top:0;margin-bottom:1rem}ol ol[data-v-15445482],ol ul[data-v-15445482],ul ol[data-v-15445482],ul ul[data-v-15445482]{margin-bottom:0}dt[data-v-15445482]{font-weight:700}dd[data-v-15445482]{margin-bottom:.5rem;margin-left:0}blockquote[data-v-15445482]{margin:0 0 1rem}b[data-v-15445482],strong[data-v-15445482]{font-weight:bolder}.small[data-v-15445482],small[data-v-15445482]{font-size:.875em}.mark[data-v-15445482],mark[data-v-15445482]{padding:.2em;background-color:#fcf8e3}sub[data-v-15445482],sup[data-v-15445482]{position:relative;font-size:.75em;line-height:0;vertical-align:baseline}sub[data-v-15445482]{bottom:-.25em}sup[data-v-15445482]{top:-.5em}a[data-v-15445482]{color:#0d6efd;text-decoration:underline}a[data-v-15445482]:hover{color:#0a58ca}a[data-v-15445482]:not([href]):not([class]),a[data-v-15445482]:not([href]):not([class]):hover{color:inherit;text-decoration:none}code[data-v-15445482],kbd[data-v-15445482],pre[data-v-15445482],samp[data-v-15445482]{font-family:var(--bs-font-monospace);font-size:1em;direction:ltr;unicode-bidi:bidi-override}pre[data-v-15445482]{display:block;margin-top:0;margin-bottom:1rem;overflow:auto;font-size:.875em}pre code[data-v-15445482]{font-size:inherit;color:inherit;word-break:normal}code[data-v-15445482]{font-size:.875em;color:#d63384;word-wrap:break-word}a>code[data-v-15445482]{color:inherit}kbd[data-v-15445482]{padding:.2rem .4rem;font-size:.875em;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd[data-v-15445482]{padding:0;font-size:1em;font-weight:700}figure[data-v-15445482]{margin:0 0 1rem}img[data-v-15445482],svg[data-v-15445482]{vertical-align:middle}table[data-v-15445482]{caption-side:bottom;border-collapse:collapse}caption[data-v-15445482]{padding-top:.5rem;padding-bottom:.5rem;color:#6c757d;text-align:left}th[data-v-15445482]{text-align:inherit;text-align:-webkit-match-parent}tbody[data-v-15445482],td[data-v-15445482],tfoot[data-v-15445482],th[data-v-15445482],thead[data-v-15445482],tr[data-v-15445482]{border-color:inherit;border-style:solid;border-width:0}label[data-v-15445482]{display:inline-block}button[data-v-15445482]{border-radius:0}button[data-v-15445482]:focus:not(:focus-visible){outline:0}button[data-v-15445482],input[data-v-15445482],optgroup[data-v-15445482],select[data-v-15445482],textarea[data-v-15445482]{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button[data-v-15445482],select[data-v-15445482]{text-transform:none}[role=button][data-v-15445482]{cursor:pointer}select[data-v-15445482]{word-wrap:normal}select[data-v-15445482]:disabled{opacity:1}[list][data-v-15445482]::-webkit-calendar-picker-indicator{display:none}[type=button][data-v-15445482],[type=reset][data-v-15445482],[type=submit][data-v-15445482],button[data-v-15445482]{-webkit-appearance:button}[type=button][data-v-15445482]:not(:disabled),[type=reset][data-v-15445482]:not(:disabled),[type=submit][data-v-15445482]:not(:disabled),button[data-v-15445482]:not(:disabled){cursor:pointer}[data-v-15445482]::-moz-focus-inner{padding:0;border-style:none}textarea[data-v-15445482]{resize:vertical}fieldset[data-v-15445482]{min-width:0;padding:0;margin:0;border:0}legend[data-v-15445482]{float:left;width:100%;padding:0;margin-bottom:.5rem;font-size:calc(1.275rem + .3vw);line-height:inherit}@media (min-width:1200px){legend[data-v-15445482]{font-size:1.5rem}}legend+[data-v-15445482]{clear:left}[data-v-15445482]::-webkit-datetime-edit-day-field,[data-v-15445482]::-webkit-datetime-edit-fields-wrapper,[data-v-15445482]::-webkit-datetime-edit-hour-field,[data-v-15445482]::-webkit-datetime-edit-minute,[data-v-15445482]::-webkit-datetime-edit-month-field,[data-v-15445482]::-webkit-datetime-edit-text,[data-v-15445482]::-webkit-datetime-edit-year-field{padding:0}[data-v-15445482]::-webkit-inner-spin-button{height:auto}[type=search][data-v-15445482]{outline-offset:-2px;-webkit-appearance:textfield}[data-v-15445482]::-webkit-search-decoration{-webkit-appearance:none}[data-v-15445482]::-webkit-color-swatch-wrapper{padding:0}[data-v-15445482]::file-selector-button{font:inherit}[data-v-15445482]::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output[data-v-15445482]{display:inline-block}iframe[data-v-15445482]{border:0}summary[data-v-15445482]{display:list-item;cursor:pointer}progress[data-v-15445482]{vertical-align:baseline}[hidden][data-v-15445482]{display:none!important}.lead[data-v-15445482]{font-size:1.25rem;font-weight:300}.display-1[data-v-15445482]{font-size:calc(1.625rem + 4.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-1[data-v-15445482]{font-size:5rem}}.display-2[data-v-15445482]{font-size:calc(1.575rem + 3.9vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-2[data-v-15445482]{font-size:4.5rem}}.display-3[data-v-15445482]{font-size:calc(1.525rem + 3.3vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-3[data-v-15445482]{font-size:4rem}}.display-4[data-v-15445482]{font-size:calc(1.475rem + 2.7vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-4[data-v-15445482]{font-size:3.5rem}}.display-5[data-v-15445482]{font-size:calc(1.425rem + 2.1vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-5[data-v-15445482]{font-size:3rem}}.display-6[data-v-15445482]{font-size:calc(1.375rem + 1.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-6[data-v-15445482]{font-size:2.5rem}}.list-inline[data-v-15445482],.list-unstyled[data-v-15445482]{padding-left:0;list-style:none}.list-inline-item[data-v-15445482]{display:inline-block}.list-inline-item[data-v-15445482]:not(:last-child){margin-right:.5rem}.initialism[data-v-15445482]{font-size:.875em;text-transform:uppercase}.blockquote[data-v-15445482]{margin-bottom:1rem;font-size:1.25rem}.blockquote[data-v-15445482]>:last-child{margin-bottom:0}.blockquote-footer[data-v-15445482]{margin-top:-1rem;margin-bottom:1rem;font-size:.875em;color:#6c757d}.blockquote-footer[data-v-15445482]:before{content:\"\\2014\\A0\"}.img-fluid[data-v-15445482]{max-width:100%;height:auto}.img-thumbnail[data-v-15445482]{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.figure[data-v-15445482]{display:inline-block}.figure-img[data-v-15445482]{margin-bottom:.5rem;line-height:1}.figure-caption[data-v-15445482]{font-size:.875em;color:#6c757d}.container-fluid[data-v-15445482],.container-lg[data-v-15445482],.container-md[data-v-15445482],.container-sm[data-v-15445482],.container-xl[data-v-15445482],.container-xxl[data-v-15445482],.container[data-v-15445482]{width:100%;padding-right:var(--bs-gutter-x,.75rem);padding-left:var(--bs-gutter-x,.75rem);margin-right:auto;margin-left:auto}@media (min-width:576px){.container-sm[data-v-15445482],.container[data-v-15445482]{max-width:540px}}@media (min-width:768px){.container-md[data-v-15445482],.container-sm[data-v-15445482],.container[data-v-15445482]{max-width:720px}}@media (min-width:992px){.container-lg[data-v-15445482],.container-md[data-v-15445482],.container-sm[data-v-15445482],.container[data-v-15445482]{max-width:960px}}@media (min-width:1200px){.container-lg[data-v-15445482],.container-md[data-v-15445482],.container-sm[data-v-15445482],.container-xl[data-v-15445482],.container[data-v-15445482]{max-width:1140px}}@media (min-width:1400px){.container-lg[data-v-15445482],.container-md[data-v-15445482],.container-sm[data-v-15445482],.container-xl[data-v-15445482],.container-xxl[data-v-15445482],.container[data-v-15445482]{max-width:1320px}}.row[data-v-15445482]{--bs-gutter-x:1.5rem;--bs-gutter-y:0;display:flex;flex-wrap:wrap;margin-top:calc(-1 * var(--bs-gutter-y));margin-right:calc(-.5 * var(--bs-gutter-x));margin-left:calc(-.5 * var(--bs-gutter-x))}.row>[data-v-15445482]{flex-shrink:0;width:100%;max-width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-top:var(--bs-gutter-y)}.col[data-v-15445482]{flex:1 0 0%}.row-cols-auto>[data-v-15445482]{flex:0 0 auto;width:auto}.row-cols-1>[data-v-15445482]{flex:0 0 auto;width:100%}.row-cols-2>[data-v-15445482]{flex:0 0 auto;width:50%}.row-cols-3>[data-v-15445482]{flex:0 0 auto;width:33.3333333333%}.row-cols-4>[data-v-15445482]{flex:0 0 auto;width:25%}.row-cols-5>[data-v-15445482]{flex:0 0 auto;width:20%}.row-cols-6>[data-v-15445482]{flex:0 0 auto;width:16.6666666667%}.col-auto[data-v-15445482]{flex:0 0 auto;width:auto}.col-1[data-v-15445482]{flex:0 0 auto;width:8.33333333%}.col-2[data-v-15445482]{flex:0 0 auto;width:16.66666667%}.col-3[data-v-15445482]{flex:0 0 auto;width:25%}.col-4[data-v-15445482]{flex:0 0 auto;width:33.33333333%}.col-5[data-v-15445482]{flex:0 0 auto;width:41.66666667%}.col-6[data-v-15445482]{flex:0 0 auto;width:50%}.col-7[data-v-15445482]{flex:0 0 auto;width:58.33333333%}.col-8[data-v-15445482]{flex:0 0 auto;width:66.66666667%}.col-9[data-v-15445482]{flex:0 0 auto;width:75%}.col-10[data-v-15445482]{flex:0 0 auto;width:83.33333333%}.col-11[data-v-15445482]{flex:0 0 auto;width:91.66666667%}.col-12[data-v-15445482]{flex:0 0 auto;width:100%}.offset-1[data-v-15445482]{margin-left:8.33333333%}.offset-2[data-v-15445482]{margin-left:16.66666667%}.offset-3[data-v-15445482]{margin-left:25%}.offset-4[data-v-15445482]{margin-left:33.33333333%}.offset-5[data-v-15445482]{margin-left:41.66666667%}.offset-6[data-v-15445482]{margin-left:50%}.offset-7[data-v-15445482]{margin-left:58.33333333%}.offset-8[data-v-15445482]{margin-left:66.66666667%}.offset-9[data-v-15445482]{margin-left:75%}.offset-10[data-v-15445482]{margin-left:83.33333333%}.offset-11[data-v-15445482]{margin-left:91.66666667%}.g-0[data-v-15445482],.gx-0[data-v-15445482]{--bs-gutter-x:0}.g-0[data-v-15445482],.gy-0[data-v-15445482]{--bs-gutter-y:0}.g-1[data-v-15445482],.gx-1[data-v-15445482]{--bs-gutter-x:0.25rem}.g-1[data-v-15445482],.gy-1[data-v-15445482]{--bs-gutter-y:0.25rem}.g-2[data-v-15445482],.gx-2[data-v-15445482]{--bs-gutter-x:0.5rem}.g-2[data-v-15445482],.gy-2[data-v-15445482]{--bs-gutter-y:0.5rem}.g-3[data-v-15445482],.gx-3[data-v-15445482]{--bs-gutter-x:1rem}.g-3[data-v-15445482],.gy-3[data-v-15445482]{--bs-gutter-y:1rem}.g-4[data-v-15445482],.gx-4[data-v-15445482]{--bs-gutter-x:1.5rem}.g-4[data-v-15445482],.gy-4[data-v-15445482]{--bs-gutter-y:1.5rem}.g-5[data-v-15445482],.gx-5[data-v-15445482]{--bs-gutter-x:3rem}.g-5[data-v-15445482],.gy-5[data-v-15445482]{--bs-gutter-y:3rem}@media (min-width:576px){.col-sm[data-v-15445482]{flex:1 0 0%}.row-cols-sm-auto>[data-v-15445482]{flex:0 0 auto;width:auto}.row-cols-sm-1>[data-v-15445482]{flex:0 0 auto;width:100%}.row-cols-sm-2>[data-v-15445482]{flex:0 0 auto;width:50%}.row-cols-sm-3>[data-v-15445482]{flex:0 0 auto;width:33.3333333333%}.row-cols-sm-4>[data-v-15445482]{flex:0 0 auto;width:25%}.row-cols-sm-5>[data-v-15445482]{flex:0 0 auto;width:20%}.row-cols-sm-6>[data-v-15445482]{flex:0 0 auto;width:16.6666666667%}.col-sm-auto[data-v-15445482]{flex:0 0 auto;width:auto}.col-sm-1[data-v-15445482]{flex:0 0 auto;width:8.33333333%}.col-sm-2[data-v-15445482]{flex:0 0 auto;width:16.66666667%}.col-sm-3[data-v-15445482]{flex:0 0 auto;width:25%}.col-sm-4[data-v-15445482]{flex:0 0 auto;width:33.33333333%}.col-sm-5[data-v-15445482]{flex:0 0 auto;width:41.66666667%}.col-sm-6[data-v-15445482]{flex:0 0 auto;width:50%}.col-sm-7[data-v-15445482]{flex:0 0 auto;width:58.33333333%}.col-sm-8[data-v-15445482]{flex:0 0 auto;width:66.66666667%}.col-sm-9[data-v-15445482]{flex:0 0 auto;width:75%}.col-sm-10[data-v-15445482]{flex:0 0 auto;width:83.33333333%}.col-sm-11[data-v-15445482]{flex:0 0 auto;width:91.66666667%}.col-sm-12[data-v-15445482]{flex:0 0 auto;width:100%}.offset-sm-0[data-v-15445482]{margin-left:0}.offset-sm-1[data-v-15445482]{margin-left:8.33333333%}.offset-sm-2[data-v-15445482]{margin-left:16.66666667%}.offset-sm-3[data-v-15445482]{margin-left:25%}.offset-sm-4[data-v-15445482]{margin-left:33.33333333%}.offset-sm-5[data-v-15445482]{margin-left:41.66666667%}.offset-sm-6[data-v-15445482]{margin-left:50%}.offset-sm-7[data-v-15445482]{margin-left:58.33333333%}.offset-sm-8[data-v-15445482]{margin-left:66.66666667%}.offset-sm-9[data-v-15445482]{margin-left:75%}.offset-sm-10[data-v-15445482]{margin-left:83.33333333%}.offset-sm-11[data-v-15445482]{margin-left:91.66666667%}.g-sm-0[data-v-15445482],.gx-sm-0[data-v-15445482]{--bs-gutter-x:0}.g-sm-0[data-v-15445482],.gy-sm-0[data-v-15445482]{--bs-gutter-y:0}.g-sm-1[data-v-15445482],.gx-sm-1[data-v-15445482]{--bs-gutter-x:0.25rem}.g-sm-1[data-v-15445482],.gy-sm-1[data-v-15445482]{--bs-gutter-y:0.25rem}.g-sm-2[data-v-15445482],.gx-sm-2[data-v-15445482]{--bs-gutter-x:0.5rem}.g-sm-2[data-v-15445482],.gy-sm-2[data-v-15445482]{--bs-gutter-y:0.5rem}.g-sm-3[data-v-15445482],.gx-sm-3[data-v-15445482]{--bs-gutter-x:1rem}.g-sm-3[data-v-15445482],.gy-sm-3[data-v-15445482]{--bs-gutter-y:1rem}.g-sm-4[data-v-15445482],.gx-sm-4[data-v-15445482]{--bs-gutter-x:1.5rem}.g-sm-4[data-v-15445482],.gy-sm-4[data-v-15445482]{--bs-gutter-y:1.5rem}.g-sm-5[data-v-15445482],.gx-sm-5[data-v-15445482]{--bs-gutter-x:3rem}.g-sm-5[data-v-15445482],.gy-sm-5[data-v-15445482]{--bs-gutter-y:3rem}}@media (min-width:768px){.col-md[data-v-15445482]{flex:1 0 0%}.row-cols-md-auto>[data-v-15445482]{flex:0 0 auto;width:auto}.row-cols-md-1>[data-v-15445482]{flex:0 0 auto;width:100%}.row-cols-md-2>[data-v-15445482]{flex:0 0 auto;width:50%}.row-cols-md-3>[data-v-15445482]{flex:0 0 auto;width:33.3333333333%}.row-cols-md-4>[data-v-15445482]{flex:0 0 auto;width:25%}.row-cols-md-5>[data-v-15445482]{flex:0 0 auto;width:20%}.row-cols-md-6>[data-v-15445482]{flex:0 0 auto;width:16.6666666667%}.col-md-auto[data-v-15445482]{flex:0 0 auto;width:auto}.col-md-1[data-v-15445482]{flex:0 0 auto;width:8.33333333%}.col-md-2[data-v-15445482]{flex:0 0 auto;width:16.66666667%}.col-md-3[data-v-15445482]{flex:0 0 auto;width:25%}.col-md-4[data-v-15445482]{flex:0 0 auto;width:33.33333333%}.col-md-5[data-v-15445482]{flex:0 0 auto;width:41.66666667%}.col-md-6[data-v-15445482]{flex:0 0 auto;width:50%}.col-md-7[data-v-15445482]{flex:0 0 auto;width:58.33333333%}.col-md-8[data-v-15445482]{flex:0 0 auto;width:66.66666667%}.col-md-9[data-v-15445482]{flex:0 0 auto;width:75%}.col-md-10[data-v-15445482]{flex:0 0 auto;width:83.33333333%}.col-md-11[data-v-15445482]{flex:0 0 auto;width:91.66666667%}.col-md-12[data-v-15445482]{flex:0 0 auto;width:100%}.offset-md-0[data-v-15445482]{margin-left:0}.offset-md-1[data-v-15445482]{margin-left:8.33333333%}.offset-md-2[data-v-15445482]{margin-left:16.66666667%}.offset-md-3[data-v-15445482]{margin-left:25%}.offset-md-4[data-v-15445482]{margin-left:33.33333333%}.offset-md-5[data-v-15445482]{margin-left:41.66666667%}.offset-md-6[data-v-15445482]{margin-left:50%}.offset-md-7[data-v-15445482]{margin-left:58.33333333%}.offset-md-8[data-v-15445482]{margin-left:66.66666667%}.offset-md-9[data-v-15445482]{margin-left:75%}.offset-md-10[data-v-15445482]{margin-left:83.33333333%}.offset-md-11[data-v-15445482]{margin-left:91.66666667%}.g-md-0[data-v-15445482],.gx-md-0[data-v-15445482]{--bs-gutter-x:0}.g-md-0[data-v-15445482],.gy-md-0[data-v-15445482]{--bs-gutter-y:0}.g-md-1[data-v-15445482],.gx-md-1[data-v-15445482]{--bs-gutter-x:0.25rem}.g-md-1[data-v-15445482],.gy-md-1[data-v-15445482]{--bs-gutter-y:0.25rem}.g-md-2[data-v-15445482],.gx-md-2[data-v-15445482]{--bs-gutter-x:0.5rem}.g-md-2[data-v-15445482],.gy-md-2[data-v-15445482]{--bs-gutter-y:0.5rem}.g-md-3[data-v-15445482],.gx-md-3[data-v-15445482]{--bs-gutter-x:1rem}.g-md-3[data-v-15445482],.gy-md-3[data-v-15445482]{--bs-gutter-y:1rem}.g-md-4[data-v-15445482],.gx-md-4[data-v-15445482]{--bs-gutter-x:1.5rem}.g-md-4[data-v-15445482],.gy-md-4[data-v-15445482]{--bs-gutter-y:1.5rem}.g-md-5[data-v-15445482],.gx-md-5[data-v-15445482]{--bs-gutter-x:3rem}.g-md-5[data-v-15445482],.gy-md-5[data-v-15445482]{--bs-gutter-y:3rem}}@media (min-width:992px){.col-lg[data-v-15445482]{flex:1 0 0%}.row-cols-lg-auto>[data-v-15445482]{flex:0 0 auto;width:auto}.row-cols-lg-1>[data-v-15445482]{flex:0 0 auto;width:100%}.row-cols-lg-2>[data-v-15445482]{flex:0 0 auto;width:50%}.row-cols-lg-3>[data-v-15445482]{flex:0 0 auto;width:33.3333333333%}.row-cols-lg-4>[data-v-15445482]{flex:0 0 auto;width:25%}.row-cols-lg-5>[data-v-15445482]{flex:0 0 auto;width:20%}.row-cols-lg-6>[data-v-15445482]{flex:0 0 auto;width:16.6666666667%}.col-lg-auto[data-v-15445482]{flex:0 0 auto;width:auto}.col-lg-1[data-v-15445482]{flex:0 0 auto;width:8.33333333%}.col-lg-2[data-v-15445482]{flex:0 0 auto;width:16.66666667%}.col-lg-3[data-v-15445482]{flex:0 0 auto;width:25%}.col-lg-4[data-v-15445482]{flex:0 0 auto;width:33.33333333%}.col-lg-5[data-v-15445482]{flex:0 0 auto;width:41.66666667%}.col-lg-6[data-v-15445482]{flex:0 0 auto;width:50%}.col-lg-7[data-v-15445482]{flex:0 0 auto;width:58.33333333%}.col-lg-8[data-v-15445482]{flex:0 0 auto;width:66.66666667%}.col-lg-9[data-v-15445482]{flex:0 0 auto;width:75%}.col-lg-10[data-v-15445482]{flex:0 0 auto;width:83.33333333%}.col-lg-11[data-v-15445482]{flex:0 0 auto;width:91.66666667%}.col-lg-12[data-v-15445482]{flex:0 0 auto;width:100%}.offset-lg-0[data-v-15445482]{margin-left:0}.offset-lg-1[data-v-15445482]{margin-left:8.33333333%}.offset-lg-2[data-v-15445482]{margin-left:16.66666667%}.offset-lg-3[data-v-15445482]{margin-left:25%}.offset-lg-4[data-v-15445482]{margin-left:33.33333333%}.offset-lg-5[data-v-15445482]{margin-left:41.66666667%}.offset-lg-6[data-v-15445482]{margin-left:50%}.offset-lg-7[data-v-15445482]{margin-left:58.33333333%}.offset-lg-8[data-v-15445482]{margin-left:66.66666667%}.offset-lg-9[data-v-15445482]{margin-left:75%}.offset-lg-10[data-v-15445482]{margin-left:83.33333333%}.offset-lg-11[data-v-15445482]{margin-left:91.66666667%}.g-lg-0[data-v-15445482],.gx-lg-0[data-v-15445482]{--bs-gutter-x:0}.g-lg-0[data-v-15445482],.gy-lg-0[data-v-15445482]{--bs-gutter-y:0}.g-lg-1[data-v-15445482],.gx-lg-1[data-v-15445482]{--bs-gutter-x:0.25rem}.g-lg-1[data-v-15445482],.gy-lg-1[data-v-15445482]{--bs-gutter-y:0.25rem}.g-lg-2[data-v-15445482],.gx-lg-2[data-v-15445482]{--bs-gutter-x:0.5rem}.g-lg-2[data-v-15445482],.gy-lg-2[data-v-15445482]{--bs-gutter-y:0.5rem}.g-lg-3[data-v-15445482],.gx-lg-3[data-v-15445482]{--bs-gutter-x:1rem}.g-lg-3[data-v-15445482],.gy-lg-3[data-v-15445482]{--bs-gutter-y:1rem}.g-lg-4[data-v-15445482],.gx-lg-4[data-v-15445482]{--bs-gutter-x:1.5rem}.g-lg-4[data-v-15445482],.gy-lg-4[data-v-15445482]{--bs-gutter-y:1.5rem}.g-lg-5[data-v-15445482],.gx-lg-5[data-v-15445482]{--bs-gutter-x:3rem}.g-lg-5[data-v-15445482],.gy-lg-5[data-v-15445482]{--bs-gutter-y:3rem}}@media (min-width:1200px){.col-xl[data-v-15445482]{flex:1 0 0%}.row-cols-xl-auto>[data-v-15445482]{flex:0 0 auto;width:auto}.row-cols-xl-1>[data-v-15445482]{flex:0 0 auto;width:100%}.row-cols-xl-2>[data-v-15445482]{flex:0 0 auto;width:50%}.row-cols-xl-3>[data-v-15445482]{flex:0 0 auto;width:33.3333333333%}.row-cols-xl-4>[data-v-15445482]{flex:0 0 auto;width:25%}.row-cols-xl-5>[data-v-15445482]{flex:0 0 auto;width:20%}.row-cols-xl-6>[data-v-15445482]{flex:0 0 auto;width:16.6666666667%}.col-xl-auto[data-v-15445482]{flex:0 0 auto;width:auto}.col-xl-1[data-v-15445482]{flex:0 0 auto;width:8.33333333%}.col-xl-2[data-v-15445482]{flex:0 0 auto;width:16.66666667%}.col-xl-3[data-v-15445482]{flex:0 0 auto;width:25%}.col-xl-4[data-v-15445482]{flex:0 0 auto;width:33.33333333%}.col-xl-5[data-v-15445482]{flex:0 0 auto;width:41.66666667%}.col-xl-6[data-v-15445482]{flex:0 0 auto;width:50%}.col-xl-7[data-v-15445482]{flex:0 0 auto;width:58.33333333%}.col-xl-8[data-v-15445482]{flex:0 0 auto;width:66.66666667%}.col-xl-9[data-v-15445482]{flex:0 0 auto;width:75%}.col-xl-10[data-v-15445482]{flex:0 0 auto;width:83.33333333%}.col-xl-11[data-v-15445482]{flex:0 0 auto;width:91.66666667%}.col-xl-12[data-v-15445482]{flex:0 0 auto;width:100%}.offset-xl-0[data-v-15445482]{margin-left:0}.offset-xl-1[data-v-15445482]{margin-left:8.33333333%}.offset-xl-2[data-v-15445482]{margin-left:16.66666667%}.offset-xl-3[data-v-15445482]{margin-left:25%}.offset-xl-4[data-v-15445482]{margin-left:33.33333333%}.offset-xl-5[data-v-15445482]{margin-left:41.66666667%}.offset-xl-6[data-v-15445482]{margin-left:50%}.offset-xl-7[data-v-15445482]{margin-left:58.33333333%}.offset-xl-8[data-v-15445482]{margin-left:66.66666667%}.offset-xl-9[data-v-15445482]{margin-left:75%}.offset-xl-10[data-v-15445482]{margin-left:83.33333333%}.offset-xl-11[data-v-15445482]{margin-left:91.66666667%}.g-xl-0[data-v-15445482],.gx-xl-0[data-v-15445482]{--bs-gutter-x:0}.g-xl-0[data-v-15445482],.gy-xl-0[data-v-15445482]{--bs-gutter-y:0}.g-xl-1[data-v-15445482],.gx-xl-1[data-v-15445482]{--bs-gutter-x:0.25rem}.g-xl-1[data-v-15445482],.gy-xl-1[data-v-15445482]{--bs-gutter-y:0.25rem}.g-xl-2[data-v-15445482],.gx-xl-2[data-v-15445482]{--bs-gutter-x:0.5rem}.g-xl-2[data-v-15445482],.gy-xl-2[data-v-15445482]{--bs-gutter-y:0.5rem}.g-xl-3[data-v-15445482],.gx-xl-3[data-v-15445482]{--bs-gutter-x:1rem}.g-xl-3[data-v-15445482],.gy-xl-3[data-v-15445482]{--bs-gutter-y:1rem}.g-xl-4[data-v-15445482],.gx-xl-4[data-v-15445482]{--bs-gutter-x:1.5rem}.g-xl-4[data-v-15445482],.gy-xl-4[data-v-15445482]{--bs-gutter-y:1.5rem}.g-xl-5[data-v-15445482],.gx-xl-5[data-v-15445482]{--bs-gutter-x:3rem}.g-xl-5[data-v-15445482],.gy-xl-5[data-v-15445482]{--bs-gutter-y:3rem}}@media (min-width:1400px){.col-xxl[data-v-15445482]{flex:1 0 0%}.row-cols-xxl-auto>[data-v-15445482]{flex:0 0 auto;width:auto}.row-cols-xxl-1>[data-v-15445482]{flex:0 0 auto;width:100%}.row-cols-xxl-2>[data-v-15445482]{flex:0 0 auto;width:50%}.row-cols-xxl-3>[data-v-15445482]{flex:0 0 auto;width:33.3333333333%}.row-cols-xxl-4>[data-v-15445482]{flex:0 0 auto;width:25%}.row-cols-xxl-5>[data-v-15445482]{flex:0 0 auto;width:20%}.row-cols-xxl-6>[data-v-15445482]{flex:0 0 auto;width:16.6666666667%}.col-xxl-auto[data-v-15445482]{flex:0 0 auto;width:auto}.col-xxl-1[data-v-15445482]{flex:0 0 auto;width:8.33333333%}.col-xxl-2[data-v-15445482]{flex:0 0 auto;width:16.66666667%}.col-xxl-3[data-v-15445482]{flex:0 0 auto;width:25%}.col-xxl-4[data-v-15445482]{flex:0 0 auto;width:33.33333333%}.col-xxl-5[data-v-15445482]{flex:0 0 auto;width:41.66666667%}.col-xxl-6[data-v-15445482]{flex:0 0 auto;width:50%}.col-xxl-7[data-v-15445482]{flex:0 0 auto;width:58.33333333%}.col-xxl-8[data-v-15445482]{flex:0 0 auto;width:66.66666667%}.col-xxl-9[data-v-15445482]{flex:0 0 auto;width:75%}.col-xxl-10[data-v-15445482]{flex:0 0 auto;width:83.33333333%}.col-xxl-11[data-v-15445482]{flex:0 0 auto;width:91.66666667%}.col-xxl-12[data-v-15445482]{flex:0 0 auto;width:100%}.offset-xxl-0[data-v-15445482]{margin-left:0}.offset-xxl-1[data-v-15445482]{margin-left:8.33333333%}.offset-xxl-2[data-v-15445482]{margin-left:16.66666667%}.offset-xxl-3[data-v-15445482]{margin-left:25%}.offset-xxl-4[data-v-15445482]{margin-left:33.33333333%}.offset-xxl-5[data-v-15445482]{margin-left:41.66666667%}.offset-xxl-6[data-v-15445482]{margin-left:50%}.offset-xxl-7[data-v-15445482]{margin-left:58.33333333%}.offset-xxl-8[data-v-15445482]{margin-left:66.66666667%}.offset-xxl-9[data-v-15445482]{margin-left:75%}.offset-xxl-10[data-v-15445482]{margin-left:83.33333333%}.offset-xxl-11[data-v-15445482]{margin-left:91.66666667%}.g-xxl-0[data-v-15445482],.gx-xxl-0[data-v-15445482]{--bs-gutter-x:0}.g-xxl-0[data-v-15445482],.gy-xxl-0[data-v-15445482]{--bs-gutter-y:0}.g-xxl-1[data-v-15445482],.gx-xxl-1[data-v-15445482]{--bs-gutter-x:0.25rem}.g-xxl-1[data-v-15445482],.gy-xxl-1[data-v-15445482]{--bs-gutter-y:0.25rem}.g-xxl-2[data-v-15445482],.gx-xxl-2[data-v-15445482]{--bs-gutter-x:0.5rem}.g-xxl-2[data-v-15445482],.gy-xxl-2[data-v-15445482]{--bs-gutter-y:0.5rem}.g-xxl-3[data-v-15445482],.gx-xxl-3[data-v-15445482]{--bs-gutter-x:1rem}.g-xxl-3[data-v-15445482],.gy-xxl-3[data-v-15445482]{--bs-gutter-y:1rem}.g-xxl-4[data-v-15445482],.gx-xxl-4[data-v-15445482]{--bs-gutter-x:1.5rem}.g-xxl-4[data-v-15445482],.gy-xxl-4[data-v-15445482]{--bs-gutter-y:1.5rem}.g-xxl-5[data-v-15445482],.gx-xxl-5[data-v-15445482]{--bs-gutter-x:3rem}.g-xxl-5[data-v-15445482],.gy-xxl-5[data-v-15445482]{--bs-gutter-y:3rem}}.table[data-v-15445482]{--bs-table-bg:transparent;--bs-table-accent-bg:transparent;--bs-table-striped-color:#212529;--bs-table-striped-bg:rgba(0,0,0,.05);--bs-table-active-color:#212529;--bs-table-active-bg:rgba(0,0,0,.1);--bs-table-hover-color:#212529;--bs-table-hover-bg:rgba(0,0,0,.075);width:100%;margin-bottom:1rem;color:#212529;vertical-align:top;border-color:#dee2e6}.table>:not(caption)>*>[data-v-15445482]{padding:.5rem;background-color:var(--bs-table-bg);border-bottom-width:1px;box-shadow:inset 0 0 0 9999px var(--bs-table-accent-bg)}.table>tbody[data-v-15445482]{vertical-align:inherit}.table>thead[data-v-15445482]{vertical-align:bottom}.table[data-v-15445482]>:not(:first-child){border-top:2px solid currentColor}.caption-top[data-v-15445482]{caption-side:top}.table-sm>:not(caption)>*>[data-v-15445482]{padding:.25rem}.table-bordered>:not(caption)>[data-v-15445482]{border-width:1px 0}.table-bordered>:not(caption)>*>[data-v-15445482]{border-width:0 1px}.table-borderless>:not(caption)>*>[data-v-15445482]{border-bottom-width:0}.table-borderless[data-v-15445482]>:not(:first-child){border-top-width:0}.table-striped>tbody>tr:nth-of-type(odd)>[data-v-15445482]{--bs-table-accent-bg:var(--bs-table-striped-bg);color:var(--bs-table-striped-color)}.table-active[data-v-15445482]{--bs-table-accent-bg:var(--bs-table-active-bg);color:var(--bs-table-active-color)}.table-hover>tbody>tr:hover>[data-v-15445482]{--bs-table-accent-bg:var(--bs-table-hover-bg);color:var(--bs-table-hover-color)}.table-primary[data-v-15445482]{--bs-table-bg:#cfe2ff;--bs-table-striped-bg:#c5d7f2;--bs-table-striped-color:#000;--bs-table-active-bg:#bacbe6;--bs-table-active-color:#000;--bs-table-hover-bg:#bfd1ec;--bs-table-hover-color:#000;color:#000;border-color:#bacbe6}.table-secondary[data-v-15445482]{--bs-table-bg:#e2e3e5;--bs-table-striped-bg:#d7d8da;--bs-table-striped-color:#000;--bs-table-active-bg:#cbccce;--bs-table-active-color:#000;--bs-table-hover-bg:#d1d2d4;--bs-table-hover-color:#000;color:#000;border-color:#cbccce}.table-success[data-v-15445482]{--bs-table-bg:#d1e7dd;--bs-table-striped-bg:#c7dbd2;--bs-table-striped-color:#000;--bs-table-active-bg:#bcd0c7;--bs-table-active-color:#000;--bs-table-hover-bg:#c1d6cc;--bs-table-hover-color:#000;color:#000;border-color:#bcd0c7}.table-info[data-v-15445482]{--bs-table-bg:#cff4fc;--bs-table-striped-bg:#c5e8ef;--bs-table-striped-color:#000;--bs-table-active-bg:#badce3;--bs-table-active-color:#000;--bs-table-hover-bg:#bfe2e9;--bs-table-hover-color:#000;color:#000;border-color:#badce3}.table-warning[data-v-15445482]{--bs-table-bg:#fff3cd;--bs-table-striped-bg:#f2e7c3;--bs-table-striped-color:#000;--bs-table-active-bg:#e6dbb9;--bs-table-active-color:#000;--bs-table-hover-bg:#ece1be;--bs-table-hover-color:#000;color:#000;border-color:#e6dbb9}.table-danger[data-v-15445482]{--bs-table-bg:#f8d7da;--bs-table-striped-bg:#eccccf;--bs-table-striped-color:#000;--bs-table-active-bg:#dfc2c4;--bs-table-active-color:#000;--bs-table-hover-bg:#e5c7ca;--bs-table-hover-color:#000;color:#000;border-color:#dfc2c4}.table-light[data-v-15445482]{--bs-table-bg:#f8f9fa;--bs-table-striped-bg:#ecedee;--bs-table-striped-color:#000;--bs-table-active-bg:#dfe0e1;--bs-table-active-color:#000;--bs-table-hover-bg:#e5e6e7;--bs-table-hover-color:#000;color:#000;border-color:#dfe0e1}.table-dark[data-v-15445482]{--bs-table-bg:#212529;--bs-table-striped-bg:#2c3034;--bs-table-striped-color:#fff;--bs-table-active-bg:#373b3e;--bs-table-active-color:#fff;--bs-table-hover-bg:#323539;--bs-table-hover-color:#fff;color:#fff;border-color:#373b3e}.table-responsive[data-v-15445482]{overflow-x:auto;-webkit-overflow-scrolling:touch}@media (max-width:575.98px){.table-responsive-sm[data-v-15445482]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:767.98px){.table-responsive-md[data-v-15445482]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:991.98px){.table-responsive-lg[data-v-15445482]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1199.98px){.table-responsive-xl[data-v-15445482]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1399.98px){.table-responsive-xxl[data-v-15445482]{overflow-x:auto;-webkit-overflow-scrolling:touch}}.form-label[data-v-15445482]{margin-bottom:.5rem}.col-form-label[data-v-15445482]{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg[data-v-15445482]{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem}.col-form-label-sm[data-v-15445482]{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem}.form-text[data-v-15445482]{margin-top:.25rem;font-size:.875em;color:#6c757d}.form-control[data-v-15445482]{display:block;width:100%;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-15445482]{transition:none}}.form-control[type=file][data-v-15445482]{overflow:hidden}.form-control[type=file][data-v-15445482]:not(:disabled):not([readonly]){cursor:pointer}.form-control[data-v-15445482]:focus{color:#212529;background-color:#fff;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-control[data-v-15445482]::-webkit-date-and-time-value{height:1.5em}.form-control[data-v-15445482]::-moz-placeholder{color:#6c757d;opacity:1}.form-control[data-v-15445482]::placeholder{color:#6c757d;opacity:1}.form-control[data-v-15445482]:disabled,.form-control[readonly][data-v-15445482]{background-color:#e9ecef;opacity:1}.form-control[data-v-15445482]::file-selector-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-15445482]::-webkit-file-upload-button{-webkit-transition:none;transition:none}.form-control[data-v-15445482]::file-selector-button{transition:none}}.form-control[data-v-15445482]:hover:not(:disabled):not([readonly])::file-selector-button{background-color:#dde0e3}.form-control[data-v-15445482]::-webkit-file-upload-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;-webkit-transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-15445482]::-webkit-file-upload-button{-webkit-transition:none;transition:none}}.form-control[data-v-15445482]:hover:not(:disabled):not([readonly])::-webkit-file-upload-button{background-color:#dde0e3}.form-control-plaintext[data-v-15445482]{display:block;width:100%;padding:.375rem 0;margin-bottom:0;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg[data-v-15445482],.form-control-plaintext.form-control-sm[data-v-15445482]{padding-right:0;padding-left:0}.form-control-sm[data-v-15445482]{min-height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.form-control-sm[data-v-15445482]::file-selector-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-sm[data-v-15445482]::-webkit-file-upload-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-lg[data-v-15445482]{min-height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.form-control-lg[data-v-15445482]::file-selector-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}.form-control-lg[data-v-15445482]::-webkit-file-upload-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}textarea.form-control[data-v-15445482]{min-height:calc(1.5em + .75rem + 2px)}textarea.form-control-sm[data-v-15445482]{min-height:calc(1.5em + .5rem + 2px)}textarea.form-control-lg[data-v-15445482]{min-height:calc(1.5em + 1rem + 2px)}.form-control-color[data-v-15445482]{width:3rem;height:auto;padding:.375rem}.form-control-color[data-v-15445482]:not(:disabled):not([readonly]){cursor:pointer}.form-control-color[data-v-15445482]::-moz-color-swatch{height:1.5em;border-radius:.25rem}.form-control-color[data-v-15445482]::-webkit-color-swatch{height:1.5em;border-radius:.25rem}.form-select[data-v-15445482]{display:block;width:100%;padding:.375rem 2.25rem .375rem .75rem;-moz-padding-start:calc(.75rem - 3px);font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right .75rem center;background-size:16px 12px;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-select[data-v-15445482]{transition:none}}.form-select[data-v-15445482]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-select[multiple][data-v-15445482],.form-select[size][data-v-15445482]:not([size=\"1\"]){padding-right:.75rem;background-image:none}.form-select[data-v-15445482]:disabled{background-color:#e9ecef}.form-select[data-v-15445482]:-moz-focusring{color:transparent;text-shadow:0 0 0 #212529}.form-select-sm[data-v-15445482]{padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem;border-radius:.2rem}.form-select-lg[data-v-15445482]{padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem;border-radius:.3rem}.form-check[data-v-15445482]{display:block;min-height:1.5rem;padding-left:1.5em;margin-bottom:.125rem}.form-check .form-check-input[data-v-15445482]{float:left;margin-left:-1.5em}.form-check-input[data-v-15445482]{width:1em;height:1em;margin-top:.25em;vertical-align:top;background-color:#fff;background-repeat:no-repeat;background-position:50%;background-size:contain;border:1px solid rgba(0,0,0,.25);-webkit-appearance:none;-moz-appearance:none;appearance:none;-webkit-print-color-adjust:exact;color-adjust:exact}.form-check-input[type=checkbox][data-v-15445482]{border-radius:.25em}.form-check-input[type=radio][data-v-15445482]{border-radius:50%}.form-check-input[data-v-15445482]:active{filter:brightness(90%)}.form-check-input[data-v-15445482]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-check-input[data-v-15445482]:checked{background-color:#0d6efd;border-color:#0d6efd}.form-check-input:checked[type=checkbox][data-v-15445482]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3 6-6'/%3E%3C/svg%3E\")}.form-check-input:checked[type=radio][data-v-15445482]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='2' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-input[type=checkbox][data-v-15445482]:indeterminate{background-color:#0d6efd;border-color:#0d6efd;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3E%3C/svg%3E\")}.form-check-input[data-v-15445482]:disabled{pointer-events:none;filter:none;opacity:.5}.form-check-input:disabled~.form-check-label[data-v-15445482],.form-check-input[disabled]~.form-check-label[data-v-15445482]{opacity:.5}.form-switch[data-v-15445482]{padding-left:2.5em}.form-switch .form-check-input[data-v-15445482]{width:2em;margin-left:-2.5em;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='rgba(0, 0, 0, 0.25)'/%3E%3C/svg%3E\");background-position:0;border-radius:2em;transition:background-position .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-switch .form-check-input[data-v-15445482]{transition:none}}.form-switch .form-check-input[data-v-15445482]:focus{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%2386b7fe'/%3E%3C/svg%3E\")}.form-switch .form-check-input[data-v-15445482]:checked{background-position:100%;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-inline[data-v-15445482]{display:inline-block;margin-right:1rem}.btn-check[data-v-15445482]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.btn-check:disabled+.btn[data-v-15445482],.btn-check[disabled]+.btn[data-v-15445482]{pointer-events:none;filter:none;opacity:.65}.form-range[data-v-15445482]{width:100%;height:1.5rem;padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.form-range[data-v-15445482]:focus{outline:0}.form-range[data-v-15445482]:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-15445482]:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-15445482]::-moz-focus-outer{border:0}.form-range[data-v-15445482]::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#0d6efd;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-15445482]::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.form-range[data-v-15445482]::-webkit-slider-thumb:active{background-color:#b6d4fe}.form-range[data-v-15445482]::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-15445482]::-moz-range-thumb{width:1rem;height:1rem;background-color:#0d6efd;border:0;border-radius:1rem;-moz-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-15445482]::-moz-range-thumb{-moz-transition:none;transition:none}}.form-range[data-v-15445482]::-moz-range-thumb:active{background-color:#b6d4fe}.form-range[data-v-15445482]::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-15445482]:disabled{pointer-events:none}.form-range[data-v-15445482]:disabled::-webkit-slider-thumb{background-color:#adb5bd}.form-range[data-v-15445482]:disabled::-moz-range-thumb{background-color:#adb5bd}.form-floating[data-v-15445482]{position:relative}.form-floating>.form-control[data-v-15445482],.form-floating>.form-select[data-v-15445482]{height:calc(3.5rem + 2px);line-height:1.25}.form-floating>label[data-v-15445482]{position:absolute;top:0;left:0;height:100%;padding:1rem .75rem;pointer-events:none;border:1px solid transparent;transform-origin:0 0;transition:opacity .1s ease-in-out,transform .1s ease-in-out}@media (prefers-reduced-motion:reduce){.form-floating>label[data-v-15445482]{transition:none}}.form-floating>.form-control[data-v-15445482]{padding:1rem .75rem}.form-floating>.form-control[data-v-15445482]::-moz-placeholder{color:transparent}.form-floating>.form-control[data-v-15445482]::placeholder{color:transparent}.form-floating>.form-control[data-v-15445482]:not(:-moz-placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-15445482]:focus,.form-floating>.form-control[data-v-15445482]:not(:placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-15445482]:-webkit-autofill{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-select[data-v-15445482]{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control:not(:-moz-placeholder-shown)~label[data-v-15445482]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:focus~label[data-v-15445482],.form-floating>.form-control:not(:placeholder-shown)~label[data-v-15445482],.form-floating>.form-select~label[data-v-15445482]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:-webkit-autofill~label[data-v-15445482]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.input-group[data-v-15445482]{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group>.form-control[data-v-15445482],.input-group>.form-select[data-v-15445482]{position:relative;flex:1 1 auto;width:1%;min-width:0}.input-group>.form-control[data-v-15445482]:focus,.input-group>.form-select[data-v-15445482]:focus{z-index:3}.input-group .btn[data-v-15445482]{position:relative;z-index:2}.input-group .btn[data-v-15445482]:focus{z-index:3}.input-group-text[data-v-15445482]{display:flex;align-items:center;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-lg>.btn[data-v-15445482],.input-group-lg>.form-control[data-v-15445482],.input-group-lg>.form-select[data-v-15445482],.input-group-lg>.input-group-text[data-v-15445482]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.input-group-sm>.btn[data-v-15445482],.input-group-sm>.form-control[data-v-15445482],.input-group-sm>.form-select[data-v-15445482],.input-group-sm>.input-group-text[data-v-15445482]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.input-group-lg>.form-select[data-v-15445482],.input-group-sm>.form-select[data-v-15445482]{padding-right:3rem}.input-group.has-validation>.dropdown-toggle[data-v-15445482]:nth-last-child(n+4),.input-group.has-validation[data-v-15445482]>:nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),.input-group:not(.has-validation)>.dropdown-toggle[data-v-15445482]:nth-last-child(n+3),.input-group[data-v-15445482]:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu){border-top-right-radius:0;border-bottom-right-radius:0}.input-group[data-v-15445482]>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}.valid-feedback[data-v-15445482]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#198754}.valid-tooltip[data-v-15445482]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(25,135,84,.9);border-radius:.25rem}.is-valid~.valid-feedback[data-v-15445482],.is-valid~.valid-tooltip[data-v-15445482],.was-validated :valid~.valid-feedback[data-v-15445482],.was-validated :valid~.valid-tooltip[data-v-15445482]{display:block}.form-control.is-valid[data-v-15445482],.was-validated .form-control[data-v-15445482]:valid{border-color:#198754;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-valid[data-v-15445482]:focus,.was-validated .form-control[data-v-15445482]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.was-validated textarea.form-control[data-v-15445482]:valid,textarea.form-control.is-valid[data-v-15445482]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-valid[data-v-15445482],.was-validated .form-select[data-v-15445482]:valid{border-color:#198754}.form-select.is-valid:not([multiple])[size=\"1\"][data-v-15445482],.form-select.is-valid[data-v-15445482]:not([multiple]):not([size]),.was-validated .form-select:valid:not([multiple])[size=\"1\"][data-v-15445482],.was-validated .form-select[data-v-15445482]:valid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-valid[data-v-15445482]:focus,.was-validated .form-select[data-v-15445482]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid[data-v-15445482],.was-validated .form-check-input[data-v-15445482]:valid{border-color:#198754}.form-check-input.is-valid[data-v-15445482]:checked,.was-validated .form-check-input[data-v-15445482]:valid:checked{background-color:#198754}.form-check-input.is-valid[data-v-15445482]:focus,.was-validated .form-check-input[data-v-15445482]:valid:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid~.form-check-label[data-v-15445482],.was-validated .form-check-input:valid~.form-check-label[data-v-15445482]{color:#198754}.form-check-inline .form-check-input~.valid-feedback[data-v-15445482]{margin-left:.5em}.input-group .form-control.is-valid[data-v-15445482],.input-group .form-select.is-valid[data-v-15445482],.was-validated .input-group .form-control[data-v-15445482]:valid,.was-validated .input-group .form-select[data-v-15445482]:valid{z-index:1}.input-group .form-control.is-valid[data-v-15445482]:focus,.input-group .form-select.is-valid[data-v-15445482]:focus,.was-validated .input-group .form-control[data-v-15445482]:valid:focus,.was-validated .input-group .form-select[data-v-15445482]:valid:focus{z-index:3}.invalid-feedback[data-v-15445482]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#dc3545}.invalid-tooltip[data-v-15445482]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(220,53,69,.9);border-radius:.25rem}.is-invalid~.invalid-feedback[data-v-15445482],.is-invalid~.invalid-tooltip[data-v-15445482],.was-validated :invalid~.invalid-feedback[data-v-15445482],.was-validated :invalid~.invalid-tooltip[data-v-15445482]{display:block}.form-control.is-invalid[data-v-15445482],.was-validated .form-control[data-v-15445482]:invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-invalid[data-v-15445482]:focus,.was-validated .form-control[data-v-15445482]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.was-validated textarea.form-control[data-v-15445482]:invalid,textarea.form-control.is-invalid[data-v-15445482]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-invalid[data-v-15445482],.was-validated .form-select[data-v-15445482]:invalid{border-color:#dc3545}.form-select.is-invalid:not([multiple])[size=\"1\"][data-v-15445482],.form-select.is-invalid[data-v-15445482]:not([multiple]):not([size]),.was-validated .form-select:invalid:not([multiple])[size=\"1\"][data-v-15445482],.was-validated .form-select[data-v-15445482]:invalid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-invalid[data-v-15445482]:focus,.was-validated .form-select[data-v-15445482]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid[data-v-15445482],.was-validated .form-check-input[data-v-15445482]:invalid{border-color:#dc3545}.form-check-input.is-invalid[data-v-15445482]:checked,.was-validated .form-check-input[data-v-15445482]:invalid:checked{background-color:#dc3545}.form-check-input.is-invalid[data-v-15445482]:focus,.was-validated .form-check-input[data-v-15445482]:invalid:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid~.form-check-label[data-v-15445482],.was-validated .form-check-input:invalid~.form-check-label[data-v-15445482]{color:#dc3545}.form-check-inline .form-check-input~.invalid-feedback[data-v-15445482]{margin-left:.5em}.input-group .form-control.is-invalid[data-v-15445482],.input-group .form-select.is-invalid[data-v-15445482],.was-validated .input-group .form-control[data-v-15445482]:invalid,.was-validated .input-group .form-select[data-v-15445482]:invalid{z-index:2}.input-group .form-control.is-invalid[data-v-15445482]:focus,.input-group .form-select.is-invalid[data-v-15445482]:focus,.was-validated .input-group .form-control[data-v-15445482]:invalid:focus,.was-validated .input-group .form-select[data-v-15445482]:invalid:focus{z-index:3}.btn[data-v-15445482]{display:inline-block;font-weight:400;line-height:1.5;color:#212529;text-align:center;text-decoration:none;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn[data-v-15445482]{transition:none}}.btn[data-v-15445482]:hover{color:#212529}.btn-check:focus+.btn[data-v-15445482],.btn[data-v-15445482]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.btn.disabled[data-v-15445482],.btn[data-v-15445482]:disabled,fieldset:disabled .btn[data-v-15445482]{pointer-events:none;opacity:.65}.btn-primary[data-v-15445482]{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-primary[data-v-15445482]:hover{color:#fff;background-color:#0b5ed7;border-color:#0a58ca}.btn-check:focus+.btn-primary[data-v-15445482],.btn-primary[data-v-15445482]:focus{color:#fff;background-color:#0b5ed7;border-color:#0a58ca;box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-check:active+.btn-primary[data-v-15445482],.btn-check:checked+.btn-primary[data-v-15445482],.btn-primary.active[data-v-15445482],.btn-primary[data-v-15445482]:active,.show>.btn-primary.dropdown-toggle[data-v-15445482]{color:#fff;background-color:#0a58ca;border-color:#0a53be}.btn-check:active+.btn-primary[data-v-15445482]:focus,.btn-check:checked+.btn-primary[data-v-15445482]:focus,.btn-primary.active[data-v-15445482]:focus,.btn-primary[data-v-15445482]:active:focus,.show>.btn-primary.dropdown-toggle[data-v-15445482]:focus{box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-primary.disabled[data-v-15445482],.btn-primary[data-v-15445482]:disabled{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-secondary[data-v-15445482]{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary[data-v-15445482]:hover{color:#fff;background-color:#5c636a;border-color:#565e64}.btn-check:focus+.btn-secondary[data-v-15445482],.btn-secondary[data-v-15445482]:focus{color:#fff;background-color:#5c636a;border-color:#565e64;box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-check:active+.btn-secondary[data-v-15445482],.btn-check:checked+.btn-secondary[data-v-15445482],.btn-secondary.active[data-v-15445482],.btn-secondary[data-v-15445482]:active,.show>.btn-secondary.dropdown-toggle[data-v-15445482]{color:#fff;background-color:#565e64;border-color:#51585e}.btn-check:active+.btn-secondary[data-v-15445482]:focus,.btn-check:checked+.btn-secondary[data-v-15445482]:focus,.btn-secondary.active[data-v-15445482]:focus,.btn-secondary[data-v-15445482]:active:focus,.show>.btn-secondary.dropdown-toggle[data-v-15445482]:focus{box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-secondary.disabled[data-v-15445482],.btn-secondary[data-v-15445482]:disabled{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-success[data-v-15445482]{color:#fff;background-color:#198754;border-color:#198754}.btn-success[data-v-15445482]:hover{color:#fff;background-color:#157347;border-color:#146c43}.btn-check:focus+.btn-success[data-v-15445482],.btn-success[data-v-15445482]:focus{color:#fff;background-color:#157347;border-color:#146c43;box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-check:active+.btn-success[data-v-15445482],.btn-check:checked+.btn-success[data-v-15445482],.btn-success.active[data-v-15445482],.btn-success[data-v-15445482]:active,.show>.btn-success.dropdown-toggle[data-v-15445482]{color:#fff;background-color:#146c43;border-color:#13653f}.btn-check:active+.btn-success[data-v-15445482]:focus,.btn-check:checked+.btn-success[data-v-15445482]:focus,.btn-success.active[data-v-15445482]:focus,.btn-success[data-v-15445482]:active:focus,.show>.btn-success.dropdown-toggle[data-v-15445482]:focus{box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-success.disabled[data-v-15445482],.btn-success[data-v-15445482]:disabled{color:#fff;background-color:#198754;border-color:#198754}.btn-info[data-v-15445482]{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-info[data-v-15445482]:hover{color:#000;background-color:#31d2f2;border-color:#25cff2}.btn-check:focus+.btn-info[data-v-15445482],.btn-info[data-v-15445482]:focus{color:#000;background-color:#31d2f2;border-color:#25cff2;box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-check:active+.btn-info[data-v-15445482],.btn-check:checked+.btn-info[data-v-15445482],.btn-info.active[data-v-15445482],.btn-info[data-v-15445482]:active,.show>.btn-info.dropdown-toggle[data-v-15445482]{color:#000;background-color:#3dd5f3;border-color:#25cff2}.btn-check:active+.btn-info[data-v-15445482]:focus,.btn-check:checked+.btn-info[data-v-15445482]:focus,.btn-info.active[data-v-15445482]:focus,.btn-info[data-v-15445482]:active:focus,.show>.btn-info.dropdown-toggle[data-v-15445482]:focus{box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-info.disabled[data-v-15445482],.btn-info[data-v-15445482]:disabled{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-warning[data-v-15445482]{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-warning[data-v-15445482]:hover{color:#000;background-color:#ffca2c;border-color:#ffc720}.btn-check:focus+.btn-warning[data-v-15445482],.btn-warning[data-v-15445482]:focus{color:#000;background-color:#ffca2c;border-color:#ffc720;box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-check:active+.btn-warning[data-v-15445482],.btn-check:checked+.btn-warning[data-v-15445482],.btn-warning.active[data-v-15445482],.btn-warning[data-v-15445482]:active,.show>.btn-warning.dropdown-toggle[data-v-15445482]{color:#000;background-color:#ffcd39;border-color:#ffc720}.btn-check:active+.btn-warning[data-v-15445482]:focus,.btn-check:checked+.btn-warning[data-v-15445482]:focus,.btn-warning.active[data-v-15445482]:focus,.btn-warning[data-v-15445482]:active:focus,.show>.btn-warning.dropdown-toggle[data-v-15445482]:focus{box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-warning.disabled[data-v-15445482],.btn-warning[data-v-15445482]:disabled{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-danger[data-v-15445482]{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger[data-v-15445482]:hover{color:#fff;background-color:#bb2d3b;border-color:#b02a37}.btn-check:focus+.btn-danger[data-v-15445482],.btn-danger[data-v-15445482]:focus{color:#fff;background-color:#bb2d3b;border-color:#b02a37;box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-check:active+.btn-danger[data-v-15445482],.btn-check:checked+.btn-danger[data-v-15445482],.btn-danger.active[data-v-15445482],.btn-danger[data-v-15445482]:active,.show>.btn-danger.dropdown-toggle[data-v-15445482]{color:#fff;background-color:#b02a37;border-color:#a52834}.btn-check:active+.btn-danger[data-v-15445482]:focus,.btn-check:checked+.btn-danger[data-v-15445482]:focus,.btn-danger.active[data-v-15445482]:focus,.btn-danger[data-v-15445482]:active:focus,.show>.btn-danger.dropdown-toggle[data-v-15445482]:focus{box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-danger.disabled[data-v-15445482],.btn-danger[data-v-15445482]:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-light[data-v-15445482]{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light[data-v-15445482]:hover{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:focus+.btn-light[data-v-15445482],.btn-light[data-v-15445482]:focus{color:#000;background-color:#f9fafb;border-color:#f9fafb;box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-check:active+.btn-light[data-v-15445482],.btn-check:checked+.btn-light[data-v-15445482],.btn-light.active[data-v-15445482],.btn-light[data-v-15445482]:active,.show>.btn-light.dropdown-toggle[data-v-15445482]{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:active+.btn-light[data-v-15445482]:focus,.btn-check:checked+.btn-light[data-v-15445482]:focus,.btn-light.active[data-v-15445482]:focus,.btn-light[data-v-15445482]:active:focus,.show>.btn-light.dropdown-toggle[data-v-15445482]:focus{box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-light.disabled[data-v-15445482],.btn-light[data-v-15445482]:disabled{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-dark[data-v-15445482]{color:#fff;background-color:#212529;border-color:#212529}.btn-dark[data-v-15445482]:hover{color:#fff;background-color:#1c1f23;border-color:#1a1e21}.btn-check:focus+.btn-dark[data-v-15445482],.btn-dark[data-v-15445482]:focus{color:#fff;background-color:#1c1f23;border-color:#1a1e21;box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-check:active+.btn-dark[data-v-15445482],.btn-check:checked+.btn-dark[data-v-15445482],.btn-dark.active[data-v-15445482],.btn-dark[data-v-15445482]:active,.show>.btn-dark.dropdown-toggle[data-v-15445482]{color:#fff;background-color:#1a1e21;border-color:#191c1f}.btn-check:active+.btn-dark[data-v-15445482]:focus,.btn-check:checked+.btn-dark[data-v-15445482]:focus,.btn-dark.active[data-v-15445482]:focus,.btn-dark[data-v-15445482]:active:focus,.show>.btn-dark.dropdown-toggle[data-v-15445482]:focus{box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-dark.disabled[data-v-15445482],.btn-dark[data-v-15445482]:disabled{color:#fff;background-color:#212529;border-color:#212529}.btn-outline-primary[data-v-15445482]{color:#0d6efd;border-color:#0d6efd}.btn-outline-primary[data-v-15445482]:hover{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:focus+.btn-outline-primary[data-v-15445482],.btn-outline-primary[data-v-15445482]:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-check:active+.btn-outline-primary[data-v-15445482],.btn-check:checked+.btn-outline-primary[data-v-15445482],.btn-outline-primary.active[data-v-15445482],.btn-outline-primary.dropdown-toggle.show[data-v-15445482],.btn-outline-primary[data-v-15445482]:active{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:active+.btn-outline-primary[data-v-15445482]:focus,.btn-check:checked+.btn-outline-primary[data-v-15445482]:focus,.btn-outline-primary.active[data-v-15445482]:focus,.btn-outline-primary.dropdown-toggle.show[data-v-15445482]:focus,.btn-outline-primary[data-v-15445482]:active:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-outline-primary.disabled[data-v-15445482],.btn-outline-primary[data-v-15445482]:disabled{color:#0d6efd;background-color:transparent}.btn-outline-secondary[data-v-15445482]{color:#6c757d;border-color:#6c757d}.btn-outline-secondary[data-v-15445482]:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:focus+.btn-outline-secondary[data-v-15445482],.btn-outline-secondary[data-v-15445482]:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-check:active+.btn-outline-secondary[data-v-15445482],.btn-check:checked+.btn-outline-secondary[data-v-15445482],.btn-outline-secondary.active[data-v-15445482],.btn-outline-secondary.dropdown-toggle.show[data-v-15445482],.btn-outline-secondary[data-v-15445482]:active{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:active+.btn-outline-secondary[data-v-15445482]:focus,.btn-check:checked+.btn-outline-secondary[data-v-15445482]:focus,.btn-outline-secondary.active[data-v-15445482]:focus,.btn-outline-secondary.dropdown-toggle.show[data-v-15445482]:focus,.btn-outline-secondary[data-v-15445482]:active:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-outline-secondary.disabled[data-v-15445482],.btn-outline-secondary[data-v-15445482]:disabled{color:#6c757d;background-color:transparent}.btn-outline-success[data-v-15445482]{color:#198754;border-color:#198754}.btn-outline-success[data-v-15445482]:hover{color:#fff;background-color:#198754;border-color:#198754}.btn-check:focus+.btn-outline-success[data-v-15445482],.btn-outline-success[data-v-15445482]:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-check:active+.btn-outline-success[data-v-15445482],.btn-check:checked+.btn-outline-success[data-v-15445482],.btn-outline-success.active[data-v-15445482],.btn-outline-success.dropdown-toggle.show[data-v-15445482],.btn-outline-success[data-v-15445482]:active{color:#fff;background-color:#198754;border-color:#198754}.btn-check:active+.btn-outline-success[data-v-15445482]:focus,.btn-check:checked+.btn-outline-success[data-v-15445482]:focus,.btn-outline-success.active[data-v-15445482]:focus,.btn-outline-success.dropdown-toggle.show[data-v-15445482]:focus,.btn-outline-success[data-v-15445482]:active:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-outline-success.disabled[data-v-15445482],.btn-outline-success[data-v-15445482]:disabled{color:#198754;background-color:transparent}.btn-outline-info[data-v-15445482]{color:#0dcaf0;border-color:#0dcaf0}.btn-outline-info[data-v-15445482]:hover{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:focus+.btn-outline-info[data-v-15445482],.btn-outline-info[data-v-15445482]:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-check:active+.btn-outline-info[data-v-15445482],.btn-check:checked+.btn-outline-info[data-v-15445482],.btn-outline-info.active[data-v-15445482],.btn-outline-info.dropdown-toggle.show[data-v-15445482],.btn-outline-info[data-v-15445482]:active{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:active+.btn-outline-info[data-v-15445482]:focus,.btn-check:checked+.btn-outline-info[data-v-15445482]:focus,.btn-outline-info.active[data-v-15445482]:focus,.btn-outline-info.dropdown-toggle.show[data-v-15445482]:focus,.btn-outline-info[data-v-15445482]:active:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-outline-info.disabled[data-v-15445482],.btn-outline-info[data-v-15445482]:disabled{color:#0dcaf0;background-color:transparent}.btn-outline-warning[data-v-15445482]{color:#ffc107;border-color:#ffc107}.btn-outline-warning[data-v-15445482]:hover{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:focus+.btn-outline-warning[data-v-15445482],.btn-outline-warning[data-v-15445482]:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-check:active+.btn-outline-warning[data-v-15445482],.btn-check:checked+.btn-outline-warning[data-v-15445482],.btn-outline-warning.active[data-v-15445482],.btn-outline-warning.dropdown-toggle.show[data-v-15445482],.btn-outline-warning[data-v-15445482]:active{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:active+.btn-outline-warning[data-v-15445482]:focus,.btn-check:checked+.btn-outline-warning[data-v-15445482]:focus,.btn-outline-warning.active[data-v-15445482]:focus,.btn-outline-warning.dropdown-toggle.show[data-v-15445482]:focus,.btn-outline-warning[data-v-15445482]:active:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-outline-warning.disabled[data-v-15445482],.btn-outline-warning[data-v-15445482]:disabled{color:#ffc107;background-color:transparent}.btn-outline-danger[data-v-15445482]{color:#dc3545;border-color:#dc3545}.btn-outline-danger[data-v-15445482]:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:focus+.btn-outline-danger[data-v-15445482],.btn-outline-danger[data-v-15445482]:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-check:active+.btn-outline-danger[data-v-15445482],.btn-check:checked+.btn-outline-danger[data-v-15445482],.btn-outline-danger.active[data-v-15445482],.btn-outline-danger.dropdown-toggle.show[data-v-15445482],.btn-outline-danger[data-v-15445482]:active{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:active+.btn-outline-danger[data-v-15445482]:focus,.btn-check:checked+.btn-outline-danger[data-v-15445482]:focus,.btn-outline-danger.active[data-v-15445482]:focus,.btn-outline-danger.dropdown-toggle.show[data-v-15445482]:focus,.btn-outline-danger[data-v-15445482]:active:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-outline-danger.disabled[data-v-15445482],.btn-outline-danger[data-v-15445482]:disabled{color:#dc3545;background-color:transparent}.btn-outline-light[data-v-15445482]{color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light[data-v-15445482]:hover{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:focus+.btn-outline-light[data-v-15445482],.btn-outline-light[data-v-15445482]:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-check:active+.btn-outline-light[data-v-15445482],.btn-check:checked+.btn-outline-light[data-v-15445482],.btn-outline-light.active[data-v-15445482],.btn-outline-light.dropdown-toggle.show[data-v-15445482],.btn-outline-light[data-v-15445482]:active{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:active+.btn-outline-light[data-v-15445482]:focus,.btn-check:checked+.btn-outline-light[data-v-15445482]:focus,.btn-outline-light.active[data-v-15445482]:focus,.btn-outline-light.dropdown-toggle.show[data-v-15445482]:focus,.btn-outline-light[data-v-15445482]:active:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-outline-light.disabled[data-v-15445482],.btn-outline-light[data-v-15445482]:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-dark[data-v-15445482]{color:#212529;border-color:#212529}.btn-outline-dark[data-v-15445482]:hover{color:#fff;background-color:#212529;border-color:#212529}.btn-check:focus+.btn-outline-dark[data-v-15445482],.btn-outline-dark[data-v-15445482]:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-check:active+.btn-outline-dark[data-v-15445482],.btn-check:checked+.btn-outline-dark[data-v-15445482],.btn-outline-dark.active[data-v-15445482],.btn-outline-dark.dropdown-toggle.show[data-v-15445482],.btn-outline-dark[data-v-15445482]:active{color:#fff;background-color:#212529;border-color:#212529}.btn-check:active+.btn-outline-dark[data-v-15445482]:focus,.btn-check:checked+.btn-outline-dark[data-v-15445482]:focus,.btn-outline-dark.active[data-v-15445482]:focus,.btn-outline-dark.dropdown-toggle.show[data-v-15445482]:focus,.btn-outline-dark[data-v-15445482]:active:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-outline-dark.disabled[data-v-15445482],.btn-outline-dark[data-v-15445482]:disabled{color:#212529;background-color:transparent}.btn-link[data-v-15445482]{font-weight:400;color:#0d6efd;text-decoration:underline}.btn-link[data-v-15445482]:hover{color:#0a58ca}.btn-link.disabled[data-v-15445482],.btn-link[data-v-15445482]:disabled{color:#6c757d}.btn-group-lg>.btn[data-v-15445482],.btn-lg[data-v-15445482]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.btn-group-sm>.btn[data-v-15445482],.btn-sm[data-v-15445482]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.fade[data-v-15445482]{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade[data-v-15445482]{transition:none}}.fade[data-v-15445482]:not(.show){opacity:0}.collapse[data-v-15445482]:not(.show){display:none}.collapsing[data-v-15445482]{height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.collapsing[data-v-15445482]{transition:none}}.collapsing.collapse-horizontal[data-v-15445482]{width:0;height:auto;transition:width .35s ease}@media (prefers-reduced-motion:reduce){.collapsing.collapse-horizontal[data-v-15445482]{transition:none}}.dropdown[data-v-15445482],.dropend[data-v-15445482],.dropstart[data-v-15445482],.dropup[data-v-15445482]{position:relative}.dropdown-toggle[data-v-15445482]{white-space:nowrap}.dropdown-toggle[data-v-15445482]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle[data-v-15445482]:empty:after{margin-left:0}.dropdown-menu[data-v-15445482]{position:absolute;z-index:1000;display:none;min-width:10rem;padding:.5rem 0;margin:0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-menu[data-bs-popper][data-v-15445482]{top:100%;left:0;margin-top:.125rem}.dropdown-menu-start[data-v-15445482]{--bs-position:start}.dropdown-menu-start[data-bs-popper][data-v-15445482]{right:auto;left:0}.dropdown-menu-end[data-v-15445482]{--bs-position:end}.dropdown-menu-end[data-bs-popper][data-v-15445482]{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-start[data-v-15445482]{--bs-position:start}.dropdown-menu-sm-start[data-bs-popper][data-v-15445482]{right:auto;left:0}.dropdown-menu-sm-end[data-v-15445482]{--bs-position:end}.dropdown-menu-sm-end[data-bs-popper][data-v-15445482]{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-start[data-v-15445482]{--bs-position:start}.dropdown-menu-md-start[data-bs-popper][data-v-15445482]{right:auto;left:0}.dropdown-menu-md-end[data-v-15445482]{--bs-position:end}.dropdown-menu-md-end[data-bs-popper][data-v-15445482]{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-start[data-v-15445482]{--bs-position:start}.dropdown-menu-lg-start[data-bs-popper][data-v-15445482]{right:auto;left:0}.dropdown-menu-lg-end[data-v-15445482]{--bs-position:end}.dropdown-menu-lg-end[data-bs-popper][data-v-15445482]{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-start[data-v-15445482]{--bs-position:start}.dropdown-menu-xl-start[data-bs-popper][data-v-15445482]{right:auto;left:0}.dropdown-menu-xl-end[data-v-15445482]{--bs-position:end}.dropdown-menu-xl-end[data-bs-popper][data-v-15445482]{right:0;left:auto}}@media (min-width:1400px){.dropdown-menu-xxl-start[data-v-15445482]{--bs-position:start}.dropdown-menu-xxl-start[data-bs-popper][data-v-15445482]{right:auto;left:0}.dropdown-menu-xxl-end[data-v-15445482]{--bs-position:end}.dropdown-menu-xxl-end[data-bs-popper][data-v-15445482]{right:0;left:auto}}.dropup .dropdown-menu[data-bs-popper][data-v-15445482]{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle[data-v-15445482]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle[data-v-15445482]:empty:after{margin-left:0}.dropend .dropdown-menu[data-bs-popper][data-v-15445482]{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.dropend .dropdown-toggle[data-v-15445482]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropend .dropdown-toggle[data-v-15445482]:empty:after{margin-left:0}.dropend .dropdown-toggle[data-v-15445482]:after{vertical-align:0}.dropstart .dropdown-menu[data-bs-popper][data-v-15445482]{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.dropstart .dropdown-toggle[data-v-15445482]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";display:none}.dropstart .dropdown-toggle[data-v-15445482]:before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropstart .dropdown-toggle[data-v-15445482]:empty:after{margin-left:0}.dropstart .dropdown-toggle[data-v-15445482]:before{vertical-align:0}.dropdown-divider[data-v-15445482]{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid rgba(0,0,0,.15)}.dropdown-item[data-v-15445482]{display:block;width:100%;padding:.25rem 1rem;clear:both;font-weight:400;color:#212529;text-align:inherit;text-decoration:none;white-space:nowrap;background-color:transparent;border:0}.dropdown-item[data-v-15445482]:focus,.dropdown-item[data-v-15445482]:hover{color:#1e2125;background-color:#e9ecef}.dropdown-item.active[data-v-15445482],.dropdown-item[data-v-15445482]:active{color:#fff;text-decoration:none;background-color:#0d6efd}.dropdown-item.disabled[data-v-15445482],.dropdown-item[data-v-15445482]:disabled{color:#adb5bd;pointer-events:none;background-color:transparent}.dropdown-menu.show[data-v-15445482]{display:block}.dropdown-header[data-v-15445482]{display:block;padding:.5rem 1rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.dropdown-item-text[data-v-15445482]{display:block;padding:.25rem 1rem;color:#212529}.dropdown-menu-dark[data-v-15445482]{color:#dee2e6;background-color:#343a40;border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item[data-v-15445482]{color:#dee2e6}.dropdown-menu-dark .dropdown-item[data-v-15445482]:focus,.dropdown-menu-dark .dropdown-item[data-v-15445482]:hover{color:#fff;background-color:hsla(0,0%,100%,.15)}.dropdown-menu-dark .dropdown-item.active[data-v-15445482],.dropdown-menu-dark .dropdown-item[data-v-15445482]:active{color:#fff;background-color:#0d6efd}.dropdown-menu-dark .dropdown-item.disabled[data-v-15445482],.dropdown-menu-dark .dropdown-item[data-v-15445482]:disabled{color:#adb5bd}.dropdown-menu-dark .dropdown-divider[data-v-15445482]{border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item-text[data-v-15445482]{color:#dee2e6}.dropdown-menu-dark .dropdown-header[data-v-15445482]{color:#adb5bd}.btn-group-vertical[data-v-15445482],.btn-group[data-v-15445482]{position:relative;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn[data-v-15445482],.btn-group>.btn[data-v-15445482]{position:relative;flex:1 1 auto}.btn-group-vertical>.btn-check:checked+.btn[data-v-15445482],.btn-group-vertical>.btn-check:focus+.btn[data-v-15445482],.btn-group-vertical>.btn.active[data-v-15445482],.btn-group-vertical>.btn[data-v-15445482]:active,.btn-group-vertical>.btn[data-v-15445482]:focus,.btn-group-vertical>.btn[data-v-15445482]:hover,.btn-group>.btn-check:checked+.btn[data-v-15445482],.btn-group>.btn-check:focus+.btn[data-v-15445482],.btn-group>.btn.active[data-v-15445482],.btn-group>.btn[data-v-15445482]:active,.btn-group>.btn[data-v-15445482]:focus,.btn-group>.btn[data-v-15445482]:hover{z-index:1}.btn-toolbar[data-v-15445482]{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar .input-group[data-v-15445482]{width:auto}.btn-group>.btn-group[data-v-15445482]:not(:first-child),.btn-group>.btn[data-v-15445482]:not(:first-child){margin-left:-1px}.btn-group>.btn-group:not(:last-child)>.btn[data-v-15445482],.btn-group>.btn[data-v-15445482]:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn[data-v-15445482],.btn-group>.btn[data-v-15445482]:nth-child(n+3),.btn-group>:not(.btn-check)+.btn[data-v-15445482]{border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split[data-v-15445482]{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split[data-v-15445482]:after,.dropend .dropdown-toggle-split[data-v-15445482]:after,.dropup .dropdown-toggle-split[data-v-15445482]:after{margin-left:0}.dropstart .dropdown-toggle-split[data-v-15445482]:before{margin-right:0}.btn-group-sm>.btn+.dropdown-toggle-split[data-v-15445482],.btn-sm+.dropdown-toggle-split[data-v-15445482]{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split[data-v-15445482],.btn-lg+.dropdown-toggle-split[data-v-15445482]{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical[data-v-15445482]{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical>.btn-group[data-v-15445482],.btn-group-vertical>.btn[data-v-15445482]{width:100%}.btn-group-vertical>.btn-group[data-v-15445482]:not(:first-child),.btn-group-vertical>.btn[data-v-15445482]:not(:first-child){margin-top:-1px}.btn-group-vertical>.btn-group:not(:last-child)>.btn[data-v-15445482],.btn-group-vertical>.btn[data-v-15445482]:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn[data-v-15445482],.btn-group-vertical>.btn~.btn[data-v-15445482]{border-top-left-radius:0;border-top-right-radius:0}.nav[data-v-15445482]{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link[data-v-15445482]{display:block;padding:.5rem 1rem;color:#0d6efd;text-decoration:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out}@media (prefers-reduced-motion:reduce){.nav-link[data-v-15445482]{transition:none}}.nav-link[data-v-15445482]:focus,.nav-link[data-v-15445482]:hover{color:#0a58ca}.nav-link.disabled[data-v-15445482]{color:#6c757d;pointer-events:none;cursor:default}.nav-tabs[data-v-15445482]{border-bottom:1px solid #dee2e6}.nav-tabs .nav-link[data-v-15445482]{margin-bottom:-1px;background:0 0;border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link[data-v-15445482]:focus,.nav-tabs .nav-link[data-v-15445482]:hover{border-color:#e9ecef #e9ecef #dee2e6;isolation:isolate}.nav-tabs .nav-link.disabled[data-v-15445482]{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link[data-v-15445482],.nav-tabs .nav-link.active[data-v-15445482]{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu[data-v-15445482]{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link[data-v-15445482]{background:0 0;border:0;border-radius:.25rem}.nav-pills .nav-link.active[data-v-15445482],.nav-pills .show>.nav-link[data-v-15445482]{color:#fff;background-color:#0d6efd}.nav-fill .nav-item[data-v-15445482],.nav-fill>.nav-link[data-v-15445482]{flex:1 1 auto;text-align:center}.nav-justified .nav-item[data-v-15445482],.nav-justified>.nav-link[data-v-15445482]{flex-basis:0;flex-grow:1;text-align:center}.nav-fill .nav-item .nav-link[data-v-15445482],.nav-justified .nav-item .nav-link[data-v-15445482]{width:100%}.tab-content>.tab-pane[data-v-15445482]{display:none}.tab-content>.active[data-v-15445482]{display:block}.navbar[data-v-15445482]{position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding-top:.5rem;padding-bottom:.5rem}.navbar>.container-fluid[data-v-15445482],.navbar>.container-lg[data-v-15445482],.navbar>.container-md[data-v-15445482],.navbar>.container-sm[data-v-15445482],.navbar>.container-xl[data-v-15445482],.navbar>.container-xxl[data-v-15445482],.navbar>.container[data-v-15445482]{display:flex;flex-wrap:inherit;align-items:center;justify-content:space-between}.navbar-brand[data-v-15445482]{padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;text-decoration:none;white-space:nowrap}.navbar-nav[data-v-15445482]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link[data-v-15445482]{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu[data-v-15445482]{position:static}.navbar-text[data-v-15445482]{padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse[data-v-15445482]{flex-basis:100%;flex-grow:1;align-items:center}.navbar-toggler[data-v-15445482]{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem;transition:box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.navbar-toggler[data-v-15445482]{transition:none}}.navbar-toggler[data-v-15445482]:hover{text-decoration:none}.navbar-toggler[data-v-15445482]:focus{text-decoration:none;outline:0;box-shadow:0 0 0 .25rem}.navbar-toggler-icon[data-v-15445482]{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;background-repeat:no-repeat;background-position:50%;background-size:100%}.navbar-nav-scroll[data-v-15445482]{max-height:var(--bs-scroll-height,75vh);overflow-y:auto}@media (min-width:576px){.navbar-expand-sm[data-v-15445482]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-sm .navbar-nav[data-v-15445482]{flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu[data-v-15445482]{position:absolute}.navbar-expand-sm .navbar-nav .nav-link[data-v-15445482]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm .navbar-nav-scroll[data-v-15445482]{overflow:visible}.navbar-expand-sm .navbar-collapse[data-v-15445482]{display:flex!important;flex-basis:auto}.navbar-expand-sm .navbar-toggler[data-v-15445482],.navbar-expand-sm .offcanvas-header[data-v-15445482]{display:none}.navbar-expand-sm .offcanvas[data-v-15445482]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-sm .offcanvas-bottom[data-v-15445482],.navbar-expand-sm .offcanvas-top[data-v-15445482]{height:auto;border-top:0;border-bottom:0}.navbar-expand-sm .offcanvas-body[data-v-15445482]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:768px){.navbar-expand-md[data-v-15445482]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-md .navbar-nav[data-v-15445482]{flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu[data-v-15445482]{position:absolute}.navbar-expand-md .navbar-nav .nav-link[data-v-15445482]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md .navbar-nav-scroll[data-v-15445482]{overflow:visible}.navbar-expand-md .navbar-collapse[data-v-15445482]{display:flex!important;flex-basis:auto}.navbar-expand-md .navbar-toggler[data-v-15445482],.navbar-expand-md .offcanvas-header[data-v-15445482]{display:none}.navbar-expand-md .offcanvas[data-v-15445482]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-md .offcanvas-bottom[data-v-15445482],.navbar-expand-md .offcanvas-top[data-v-15445482]{height:auto;border-top:0;border-bottom:0}.navbar-expand-md .offcanvas-body[data-v-15445482]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:992px){.navbar-expand-lg[data-v-15445482]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-lg .navbar-nav[data-v-15445482]{flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu[data-v-15445482]{position:absolute}.navbar-expand-lg .navbar-nav .nav-link[data-v-15445482]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg .navbar-nav-scroll[data-v-15445482]{overflow:visible}.navbar-expand-lg .navbar-collapse[data-v-15445482]{display:flex!important;flex-basis:auto}.navbar-expand-lg .navbar-toggler[data-v-15445482],.navbar-expand-lg .offcanvas-header[data-v-15445482]{display:none}.navbar-expand-lg .offcanvas[data-v-15445482]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-lg .offcanvas-bottom[data-v-15445482],.navbar-expand-lg .offcanvas-top[data-v-15445482]{height:auto;border-top:0;border-bottom:0}.navbar-expand-lg .offcanvas-body[data-v-15445482]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1200px){.navbar-expand-xl[data-v-15445482]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xl .navbar-nav[data-v-15445482]{flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu[data-v-15445482]{position:absolute}.navbar-expand-xl .navbar-nav .nav-link[data-v-15445482]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl .navbar-nav-scroll[data-v-15445482]{overflow:visible}.navbar-expand-xl .navbar-collapse[data-v-15445482]{display:flex!important;flex-basis:auto}.navbar-expand-xl .navbar-toggler[data-v-15445482],.navbar-expand-xl .offcanvas-header[data-v-15445482]{display:none}.navbar-expand-xl .offcanvas[data-v-15445482]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xl .offcanvas-bottom[data-v-15445482],.navbar-expand-xl .offcanvas-top[data-v-15445482]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xl .offcanvas-body[data-v-15445482]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1400px){.navbar-expand-xxl[data-v-15445482]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xxl .navbar-nav[data-v-15445482]{flex-direction:row}.navbar-expand-xxl .navbar-nav .dropdown-menu[data-v-15445482]{position:absolute}.navbar-expand-xxl .navbar-nav .nav-link[data-v-15445482]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xxl .navbar-nav-scroll[data-v-15445482]{overflow:visible}.navbar-expand-xxl .navbar-collapse[data-v-15445482]{display:flex!important;flex-basis:auto}.navbar-expand-xxl .navbar-toggler[data-v-15445482],.navbar-expand-xxl .offcanvas-header[data-v-15445482]{display:none}.navbar-expand-xxl .offcanvas[data-v-15445482]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xxl .offcanvas-bottom[data-v-15445482],.navbar-expand-xxl .offcanvas-top[data-v-15445482]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xxl .offcanvas-body[data-v-15445482]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}.navbar-expand[data-v-15445482]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand .navbar-nav[data-v-15445482]{flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu[data-v-15445482]{position:absolute}.navbar-expand .navbar-nav .nav-link[data-v-15445482]{padding-right:.5rem;padding-left:.5rem}.navbar-expand .navbar-nav-scroll[data-v-15445482]{overflow:visible}.navbar-expand .navbar-collapse[data-v-15445482]{display:flex!important;flex-basis:auto}.navbar-expand .navbar-toggler[data-v-15445482],.navbar-expand .offcanvas-header[data-v-15445482]{display:none}.navbar-expand .offcanvas[data-v-15445482]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand .offcanvas-bottom[data-v-15445482],.navbar-expand .offcanvas-top[data-v-15445482]{height:auto;border-top:0;border-bottom:0}.navbar-expand .offcanvas-body[data-v-15445482]{display:flex;flex-grow:0;padding:0;overflow-y:visible}.navbar-light .navbar-brand[data-v-15445482],.navbar-light .navbar-brand[data-v-15445482]:focus,.navbar-light .navbar-brand[data-v-15445482]:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link[data-v-15445482]{color:rgba(0,0,0,.55)}.navbar-light .navbar-nav .nav-link[data-v-15445482]:focus,.navbar-light .navbar-nav .nav-link[data-v-15445482]:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled[data-v-15445482]{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .nav-link.active[data-v-15445482],.navbar-light .navbar-nav .show>.nav-link[data-v-15445482]{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler[data-v-15445482]{color:rgba(0,0,0,.55);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon[data-v-15445482]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(0, 0, 0, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-light .navbar-text[data-v-15445482]{color:rgba(0,0,0,.55)}.navbar-light .navbar-text a[data-v-15445482],.navbar-light .navbar-text a[data-v-15445482]:focus,.navbar-light .navbar-text a[data-v-15445482]:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand[data-v-15445482],.navbar-dark .navbar-brand[data-v-15445482]:focus,.navbar-dark .navbar-brand[data-v-15445482]:hover{color:#fff}.navbar-dark .navbar-nav .nav-link[data-v-15445482]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-nav .nav-link[data-v-15445482]:focus,.navbar-dark .navbar-nav .nav-link[data-v-15445482]:hover{color:hsla(0,0%,100%,.75)}.navbar-dark .navbar-nav .nav-link.disabled[data-v-15445482]{color:hsla(0,0%,100%,.25)}.navbar-dark .navbar-nav .nav-link.active[data-v-15445482],.navbar-dark .navbar-nav .show>.nav-link[data-v-15445482]{color:#fff}.navbar-dark .navbar-toggler[data-v-15445482]{color:hsla(0,0%,100%,.55);border-color:hsla(0,0%,100%,.1)}.navbar-dark .navbar-toggler-icon[data-v-15445482]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(255, 255, 255, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-dark .navbar-text[data-v-15445482]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-text a[data-v-15445482],.navbar-dark .navbar-text a[data-v-15445482]:focus,.navbar-dark .navbar-text a[data-v-15445482]:hover{color:#fff}.card[data-v-15445482]{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr[data-v-15445482]{margin-right:0;margin-left:0}.card>.list-group[data-v-15445482]{border-top:inherit;border-bottom:inherit}.card>.list-group[data-v-15445482]:first-child{border-top-width:0;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card>.list-group[data-v-15445482]:last-child{border-bottom-width:0;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card>.card-header+.list-group[data-v-15445482],.card>.list-group+.card-footer[data-v-15445482]{border-top:0}.card-body[data-v-15445482]{flex:1 1 auto;padding:1rem}.card-title[data-v-15445482]{margin-bottom:.5rem}.card-subtitle[data-v-15445482]{margin-top:-.25rem;margin-bottom:0}.card-text[data-v-15445482]:last-child{margin-bottom:0}.card-link+.card-link[data-v-15445482]{margin-left:1rem}.card-header[data-v-15445482]{padding:.5rem 1rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header[data-v-15445482]:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-footer[data-v-15445482]{padding:.5rem 1rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer[data-v-15445482]:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs[data-v-15445482]{margin-bottom:-.5rem;border-bottom:0}.card-header-pills[data-v-15445482],.card-header-tabs[data-v-15445482]{margin-right:-.5rem;margin-left:-.5rem}.card-img-overlay[data-v-15445482]{position:absolute;top:0;right:0;bottom:0;left:0;padding:1rem;border-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-15445482],.card-img-top[data-v-15445482],.card-img[data-v-15445482]{width:100%}.card-img-top[data-v-15445482],.card-img[data-v-15445482]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-15445482],.card-img[data-v-15445482]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-group>.card[data-v-15445482]{margin-bottom:.75rem}@media (min-width:576px){.card-group[data-v-15445482]{display:flex;flex-flow:row wrap}.card-group>.card[data-v-15445482]{flex:1 0 0%;margin-bottom:0}.card-group>.card+.card[data-v-15445482]{margin-left:0;border-left:0}.card-group>.card[data-v-15445482]:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-header[data-v-15445482],.card-group>.card:not(:last-child) .card-img-top[data-v-15445482]{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-footer[data-v-15445482],.card-group>.card:not(:last-child) .card-img-bottom[data-v-15445482]{border-bottom-right-radius:0}.card-group>.card[data-v-15445482]:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-header[data-v-15445482],.card-group>.card:not(:first-child) .card-img-top[data-v-15445482]{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-footer[data-v-15445482],.card-group>.card:not(:first-child) .card-img-bottom[data-v-15445482]{border-bottom-left-radius:0}}.accordion-button[data-v-15445482]{position:relative;display:flex;align-items:center;width:100%;padding:1rem 1.25rem;font-size:1rem;color:#212529;text-align:left;background-color:#fff;border:0;border-radius:0;overflow-anchor:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,border-radius .15s ease}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-15445482]{transition:none}}.accordion-button[data-v-15445482]:not(.collapsed){color:#0c63e4;background-color:#e7f1ff;box-shadow:inset 0 -1px 0 rgba(0,0,0,.125)}.accordion-button[data-v-15445482]:not(.collapsed):after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230c63e4'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");transform:rotate(-180deg)}.accordion-button[data-v-15445482]:after{flex-shrink:0;width:1.25rem;height:1.25rem;margin-left:auto;content:\"\";background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-size:1.25rem;transition:transform .2s ease-in-out}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-15445482]:after{transition:none}}.accordion-button[data-v-15445482]:hover{z-index:2}.accordion-button[data-v-15445482]:focus{z-index:3;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.accordion-header[data-v-15445482]{margin-bottom:0}.accordion-item[data-v-15445482]{background-color:#fff;border:1px solid rgba(0,0,0,.125)}.accordion-item[data-v-15445482]:first-of-type{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.accordion-item:first-of-type .accordion-button[data-v-15445482]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.accordion-item[data-v-15445482]:not(:first-of-type){border-top:0}.accordion-item[data-v-15445482]:last-of-type{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-item:last-of-type .accordion-button.collapsed[data-v-15445482]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.accordion-item:last-of-type .accordion-collapse[data-v-15445482]{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-body[data-v-15445482]{padding:1rem 1.25rem}.accordion-flush .accordion-collapse[data-v-15445482]{border-width:0}.accordion-flush .accordion-item[data-v-15445482]{border-right:0;border-left:0;border-radius:0}.accordion-flush .accordion-item[data-v-15445482]:first-child{border-top:0}.accordion-flush .accordion-item[data-v-15445482]:last-child{border-bottom:0}.accordion-flush .accordion-item .accordion-button[data-v-15445482]{border-radius:0}.breadcrumb[data-v-15445482]{display:flex;flex-wrap:wrap;padding:0;margin-bottom:1rem;list-style:none}.breadcrumb-item+.breadcrumb-item[data-v-15445482]{padding-left:.5rem}.breadcrumb-item+.breadcrumb-item[data-v-15445482]:before{float:left;padding-right:.5rem;color:#6c757d;content:var(--bs-breadcrumb-divider,\"/\")}.breadcrumb-item.active[data-v-15445482]{color:#6c757d}.pagination[data-v-15445482]{display:flex;padding-left:0;list-style:none}.page-link[data-v-15445482]{position:relative;display:block;color:#0d6efd;text-decoration:none;background-color:#fff;border:1px solid #dee2e6;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.page-link[data-v-15445482]{transition:none}}.page-link[data-v-15445482]:hover{z-index:2;color:#0a58ca;background-color:#e9ecef;border-color:#dee2e6}.page-link[data-v-15445482]:focus{z-index:3;color:#0a58ca;background-color:#e9ecef;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.page-item:not(:first-child) .page-link[data-v-15445482]{margin-left:-1px}.page-item.active .page-link[data-v-15445482]{z-index:3;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.page-item.disabled .page-link[data-v-15445482]{color:#6c757d;pointer-events:none;background-color:#fff;border-color:#dee2e6}.page-link[data-v-15445482]{padding:.375rem .75rem}.page-item:first-child .page-link[data-v-15445482]{border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item:last-child .page-link[data-v-15445482]{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.pagination-lg .page-link[data-v-15445482]{padding:.75rem 1.5rem;font-size:1.25rem}.pagination-lg .page-item:first-child .page-link[data-v-15445482]{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link[data-v-15445482]{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm .page-link[data-v-15445482]{padding:.25rem .5rem;font-size:.875rem}.pagination-sm .page-item:first-child .page-link[data-v-15445482]{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link[data-v-15445482]{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge[data-v-15445482]{display:inline-block;padding:.35em .65em;font-size:.75em;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}.badge[data-v-15445482]:empty{display:none}.btn .badge[data-v-15445482]{position:relative;top:-1px}.alert[data-v-15445482]{position:relative;padding:1rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading[data-v-15445482]{color:inherit}.alert-link[data-v-15445482]{font-weight:700}.alert-dismissible[data-v-15445482]{padding-right:3rem}.alert-dismissible .btn-close[data-v-15445482]{position:absolute;top:0;right:0;z-index:2;padding:1.25rem 1rem}.alert-primary[data-v-15445482]{color:#084298;background-color:#cfe2ff;border-color:#b6d4fe}.alert-primary .alert-link[data-v-15445482]{color:#06357a}.alert-secondary[data-v-15445482]{color:#41464b;background-color:#e2e3e5;border-color:#d3d6d8}.alert-secondary .alert-link[data-v-15445482]{color:#34383c}.alert-success[data-v-15445482]{color:#0f5132;background-color:#d1e7dd;border-color:#badbcc}.alert-success .alert-link[data-v-15445482]{color:#0c4128}.alert-info[data-v-15445482]{color:#055160;background-color:#cff4fc;border-color:#b6effb}.alert-info .alert-link[data-v-15445482]{color:#04414d}.alert-warning[data-v-15445482]{color:#664d03;background-color:#fff3cd;border-color:#ffecb5}.alert-warning .alert-link[data-v-15445482]{color:#523e02}.alert-danger[data-v-15445482]{color:#842029;background-color:#f8d7da;border-color:#f5c2c7}.alert-danger .alert-link[data-v-15445482]{color:#6a1a21}.alert-light[data-v-15445482]{color:#636464;background-color:#fefefe;border-color:#fdfdfe}.alert-light .alert-link[data-v-15445482]{color:#4f5050}.alert-dark[data-v-15445482]{color:#141619;background-color:#d3d3d4;border-color:#bcbebf}.alert-dark .alert-link[data-v-15445482]{color:#101214}@-webkit-keyframes progress-bar-stripes-data-v-15445482{0%{background-position-x:1rem}}@keyframes progress-bar-stripes-data-v-15445482{0%{background-position-x:1rem}}.progress[data-v-15445482]{display:flex;height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress-bar[data-v-15445482]{display:flex;flex-direction:column;justify-content:center;overflow:hidden;color:#fff;text-align:center;white-space:nowrap;background-color:#0d6efd;transition:width .6s ease}@media (prefers-reduced-motion:reduce){.progress-bar[data-v-15445482]{transition:none}}.progress-bar-striped[data-v-15445482]{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-bar-animated[data-v-15445482]{-webkit-animation:1s linear infinite progress-bar-stripes-data-v-15445482;animation:1s linear infinite progress-bar-stripes-data-v-15445482}@media (prefers-reduced-motion:reduce){.progress-bar-animated[data-v-15445482]{-webkit-animation:none;animation:none}}.list-group[data-v-15445482]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:.25rem}.list-group-numbered[data-v-15445482]{list-style-type:none;counter-reset:section}.list-group-numbered>li[data-v-15445482]:before{content:counters(section,\".\") \". \";counter-increment:section}.list-group-item-action[data-v-15445482]{width:100%;color:#495057;text-align:inherit}.list-group-item-action[data-v-15445482]:focus,.list-group-item-action[data-v-15445482]:hover{z-index:1;color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action[data-v-15445482]:active{color:#212529;background-color:#e9ecef}.list-group-item[data-v-15445482]{position:relative;display:block;padding:.5rem 1rem;color:#212529;text-decoration:none;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item[data-v-15445482]:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.list-group-item[data-v-15445482]:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.list-group-item.disabled[data-v-15445482],.list-group-item[data-v-15445482]:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.list-group-item.active[data-v-15445482]{z-index:2;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.list-group-item+.list-group-item[data-v-15445482]{border-top-width:0}.list-group-item+.list-group-item.active[data-v-15445482]{margin-top:-1px;border-top-width:1px}.list-group-horizontal[data-v-15445482]{flex-direction:row}.list-group-horizontal>.list-group-item[data-v-15445482]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal>.list-group-item[data-v-15445482]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal>.list-group-item.active[data-v-15445482]{margin-top:0}.list-group-horizontal>.list-group-item+.list-group-item[data-v-15445482]{border-top-width:1px;border-left-width:0}.list-group-horizontal>.list-group-item+.list-group-item.active[data-v-15445482]{margin-left:-1px;border-left-width:1px}@media (min-width:576px){.list-group-horizontal-sm[data-v-15445482]{flex-direction:row}.list-group-horizontal-sm>.list-group-item[data-v-15445482]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-sm>.list-group-item[data-v-15445482]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-sm>.list-group-item.active[data-v-15445482]{margin-top:0}.list-group-horizontal-sm>.list-group-item+.list-group-item[data-v-15445482]{border-top-width:1px;border-left-width:0}.list-group-horizontal-sm>.list-group-item+.list-group-item.active[data-v-15445482]{margin-left:-1px;border-left-width:1px}}@media (min-width:768px){.list-group-horizontal-md[data-v-15445482]{flex-direction:row}.list-group-horizontal-md>.list-group-item[data-v-15445482]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-md>.list-group-item[data-v-15445482]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-md>.list-group-item.active[data-v-15445482]{margin-top:0}.list-group-horizontal-md>.list-group-item+.list-group-item[data-v-15445482]{border-top-width:1px;border-left-width:0}.list-group-horizontal-md>.list-group-item+.list-group-item.active[data-v-15445482]{margin-left:-1px;border-left-width:1px}}@media (min-width:992px){.list-group-horizontal-lg[data-v-15445482]{flex-direction:row}.list-group-horizontal-lg>.list-group-item[data-v-15445482]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-lg>.list-group-item[data-v-15445482]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-lg>.list-group-item.active[data-v-15445482]{margin-top:0}.list-group-horizontal-lg>.list-group-item+.list-group-item[data-v-15445482]{border-top-width:1px;border-left-width:0}.list-group-horizontal-lg>.list-group-item+.list-group-item.active[data-v-15445482]{margin-left:-1px;border-left-width:1px}}@media (min-width:1200px){.list-group-horizontal-xl[data-v-15445482]{flex-direction:row}.list-group-horizontal-xl>.list-group-item[data-v-15445482]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xl>.list-group-item[data-v-15445482]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xl>.list-group-item.active[data-v-15445482]{margin-top:0}.list-group-horizontal-xl>.list-group-item+.list-group-item[data-v-15445482]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xl>.list-group-item+.list-group-item.active[data-v-15445482]{margin-left:-1px;border-left-width:1px}}@media (min-width:1400px){.list-group-horizontal-xxl[data-v-15445482]{flex-direction:row}.list-group-horizontal-xxl>.list-group-item[data-v-15445482]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xxl>.list-group-item[data-v-15445482]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xxl>.list-group-item.active[data-v-15445482]{margin-top:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item[data-v-15445482]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item.active[data-v-15445482]{margin-left:-1px;border-left-width:1px}}.list-group-flush[data-v-15445482]{border-radius:0}.list-group-flush>.list-group-item[data-v-15445482]{border-width:0 0 1px}.list-group-flush>.list-group-item[data-v-15445482]:last-child{border-bottom-width:0}.list-group-item-primary[data-v-15445482]{color:#084298;background-color:#cfe2ff}.list-group-item-primary.list-group-item-action[data-v-15445482]:focus,.list-group-item-primary.list-group-item-action[data-v-15445482]:hover{color:#084298;background-color:#bacbe6}.list-group-item-primary.list-group-item-action.active[data-v-15445482]{color:#fff;background-color:#084298;border-color:#084298}.list-group-item-secondary[data-v-15445482]{color:#41464b;background-color:#e2e3e5}.list-group-item-secondary.list-group-item-action[data-v-15445482]:focus,.list-group-item-secondary.list-group-item-action[data-v-15445482]:hover{color:#41464b;background-color:#cbccce}.list-group-item-secondary.list-group-item-action.active[data-v-15445482]{color:#fff;background-color:#41464b;border-color:#41464b}.list-group-item-success[data-v-15445482]{color:#0f5132;background-color:#d1e7dd}.list-group-item-success.list-group-item-action[data-v-15445482]:focus,.list-group-item-success.list-group-item-action[data-v-15445482]:hover{color:#0f5132;background-color:#bcd0c7}.list-group-item-success.list-group-item-action.active[data-v-15445482]{color:#fff;background-color:#0f5132;border-color:#0f5132}.list-group-item-info[data-v-15445482]{color:#055160;background-color:#cff4fc}.list-group-item-info.list-group-item-action[data-v-15445482]:focus,.list-group-item-info.list-group-item-action[data-v-15445482]:hover{color:#055160;background-color:#badce3}.list-group-item-info.list-group-item-action.active[data-v-15445482]{color:#fff;background-color:#055160;border-color:#055160}.list-group-item-warning[data-v-15445482]{color:#664d03;background-color:#fff3cd}.list-group-item-warning.list-group-item-action[data-v-15445482]:focus,.list-group-item-warning.list-group-item-action[data-v-15445482]:hover{color:#664d03;background-color:#e6dbb9}.list-group-item-warning.list-group-item-action.active[data-v-15445482]{color:#fff;background-color:#664d03;border-color:#664d03}.list-group-item-danger[data-v-15445482]{color:#842029;background-color:#f8d7da}.list-group-item-danger.list-group-item-action[data-v-15445482]:focus,.list-group-item-danger.list-group-item-action[data-v-15445482]:hover{color:#842029;background-color:#dfc2c4}.list-group-item-danger.list-group-item-action.active[data-v-15445482]{color:#fff;background-color:#842029;border-color:#842029}.list-group-item-light[data-v-15445482]{color:#636464;background-color:#fefefe}.list-group-item-light.list-group-item-action[data-v-15445482]:focus,.list-group-item-light.list-group-item-action[data-v-15445482]:hover{color:#636464;background-color:#e5e5e5}.list-group-item-light.list-group-item-action.active[data-v-15445482]{color:#fff;background-color:#636464;border-color:#636464}.list-group-item-dark[data-v-15445482]{color:#141619;background-color:#d3d3d4}.list-group-item-dark.list-group-item-action[data-v-15445482]:focus,.list-group-item-dark.list-group-item-action[data-v-15445482]:hover{color:#141619;background-color:#bebebf}.list-group-item-dark.list-group-item-action.active[data-v-15445482]{color:#fff;background-color:#141619;border-color:#141619}.btn-close[data-v-15445482]{box-sizing:content-box;width:1em;height:1em;padding:.25em;color:#000;background:transparent url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M.293.293a1 1 0 11.414 0 NaN NaNlNaN NaN NaN NaNa1 1 0 111.414 1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 10-1.414 NaN NaNz'/%3E%3C/svg%3E\") 50%/1em auto no-repeat;border:0;border-radius:.25rem;opacity:.5}.btn-close[data-v-15445482]:hover{color:#000;text-decoration:none;opacity:.75}.btn-close[data-v-15445482]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25);opacity:1}.btn-close.disabled[data-v-15445482],.btn-close[data-v-15445482]:disabled{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;opacity:.25}.btn-close-white[data-v-15445482]{filter:invert(1) grayscale(100%) brightness(200%)}.toast[data-v-15445482]{width:350px;max-width:100%;font-size:.875rem;pointer-events:auto;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .5rem 1rem rgba(0,0,0,.15);border-radius:.25rem}.toast.showing[data-v-15445482]{opacity:0}.toast[data-v-15445482]:not(.show){display:none}.toast-container[data-v-15445482]{width:-webkit-max-content;width:-moz-max-content;width:max-content;max-width:100%;pointer-events:none}.toast-container[data-v-15445482]>:not(:last-child){margin-bottom:.75rem}.toast-header[data-v-15445482]{display:flex;align-items:center;padding:.5rem .75rem;color:#6c757d;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05);border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.toast-header .btn-close[data-v-15445482]{margin-right:-.375rem;margin-left:.75rem}.toast-body[data-v-15445482]{padding:.75rem;word-wrap:break-word}.modal[data-v-15445482]{position:fixed;top:0;left:0;z-index:1055;display:none;width:100%;height:100%;overflow-x:hidden;overflow-y:auto;outline:0}.modal-dialog[data-v-15445482]{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog[data-v-15445482]{transition:transform .3s ease-out;transform:translateY(-50px)}@media (prefers-reduced-motion:reduce){.modal.fade .modal-dialog[data-v-15445482]{transition:none}}.modal.show .modal-dialog[data-v-15445482]{transform:none}.modal.modal-static .modal-dialog[data-v-15445482]{transform:scale(1.02)}.modal-dialog-scrollable[data-v-15445482]{height:calc(100% - 1rem)}.modal-dialog-scrollable .modal-content[data-v-15445482]{max-height:100%;overflow:hidden}.modal-dialog-scrollable .modal-body[data-v-15445482]{overflow-y:auto}.modal-dialog-centered[data-v-15445482]{display:flex;align-items:center;min-height:calc(100% - 1rem)}.modal-content[data-v-15445482]{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop[data-v-15445482]{position:fixed;top:0;left:0;z-index:1050;width:100vw;height:100vh;background-color:#000}.modal-backdrop.fade[data-v-15445482]{opacity:0}.modal-backdrop.show[data-v-15445482]{opacity:.5}.modal-header[data-v-15445482]{display:flex;flex-shrink:0;align-items:center;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.modal-header .btn-close[data-v-15445482]{padding:.5rem;margin:-.5rem -.5rem -.5rem auto}.modal-title[data-v-15445482]{margin-bottom:0;line-height:1.5}.modal-body[data-v-15445482]{position:relative;flex:1 1 auto;padding:1rem}.modal-footer[data-v-15445482]{display:flex;flex-wrap:wrap;flex-shrink:0;align-items:center;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.modal-footer>[data-v-15445482]{margin:.25rem}@media (min-width:576px){.modal-dialog[data-v-15445482]{max-width:500px;margin:1.75rem auto}.modal-dialog-scrollable[data-v-15445482]{height:calc(100% - 3.5rem)}.modal-dialog-centered[data-v-15445482]{min-height:calc(100% - 3.5rem)}.modal-sm[data-v-15445482]{max-width:300px}}@media (min-width:992px){.modal-lg[data-v-15445482],.modal-xl[data-v-15445482]{max-width:800px}}@media (min-width:1200px){.modal-xl[data-v-15445482]{max-width:1140px}}.modal-fullscreen[data-v-15445482]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen .modal-content[data-v-15445482]{height:100%;border:0;border-radius:0}.modal-fullscreen .modal-header[data-v-15445482]{border-radius:0}.modal-fullscreen .modal-body[data-v-15445482]{overflow-y:auto}.modal-fullscreen .modal-footer[data-v-15445482]{border-radius:0}@media (max-width:575.98px){.modal-fullscreen-sm-down[data-v-15445482]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-sm-down .modal-content[data-v-15445482]{height:100%;border:0;border-radius:0}.modal-fullscreen-sm-down .modal-header[data-v-15445482]{border-radius:0}.modal-fullscreen-sm-down .modal-body[data-v-15445482]{overflow-y:auto}.modal-fullscreen-sm-down .modal-footer[data-v-15445482]{border-radius:0}}@media (max-width:767.98px){.modal-fullscreen-md-down[data-v-15445482]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-md-down .modal-content[data-v-15445482]{height:100%;border:0;border-radius:0}.modal-fullscreen-md-down .modal-header[data-v-15445482]{border-radius:0}.modal-fullscreen-md-down .modal-body[data-v-15445482]{overflow-y:auto}.modal-fullscreen-md-down .modal-footer[data-v-15445482]{border-radius:0}}@media (max-width:991.98px){.modal-fullscreen-lg-down[data-v-15445482]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-lg-down .modal-content[data-v-15445482]{height:100%;border:0;border-radius:0}.modal-fullscreen-lg-down .modal-header[data-v-15445482]{border-radius:0}.modal-fullscreen-lg-down .modal-body[data-v-15445482]{overflow-y:auto}.modal-fullscreen-lg-down .modal-footer[data-v-15445482]{border-radius:0}}@media (max-width:1199.98px){.modal-fullscreen-xl-down[data-v-15445482]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xl-down .modal-content[data-v-15445482]{height:100%;border:0;border-radius:0}.modal-fullscreen-xl-down .modal-header[data-v-15445482]{border-radius:0}.modal-fullscreen-xl-down .modal-body[data-v-15445482]{overflow-y:auto}.modal-fullscreen-xl-down .modal-footer[data-v-15445482]{border-radius:0}}@media (max-width:1399.98px){.modal-fullscreen-xxl-down[data-v-15445482]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xxl-down .modal-content[data-v-15445482]{height:100%;border:0;border-radius:0}.modal-fullscreen-xxl-down .modal-header[data-v-15445482]{border-radius:0}.modal-fullscreen-xxl-down .modal-body[data-v-15445482]{overflow-y:auto}.modal-fullscreen-xxl-down .modal-footer[data-v-15445482]{border-radius:0}}.tooltip[data-v-15445482]{position:absolute;z-index:1080;display:block;margin:0;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show[data-v-15445482]{opacity:.9}.tooltip .tooltip-arrow[data-v-15445482]{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .tooltip-arrow[data-v-15445482]:before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[data-popper-placement^=top][data-v-15445482],.bs-tooltip-top[data-v-15445482]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-15445482],.bs-tooltip-top .tooltip-arrow[data-v-15445482]{bottom:0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-15445482]:before,.bs-tooltip-top .tooltip-arrow[data-v-15445482]:before{top:-1px;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[data-popper-placement^=right][data-v-15445482],.bs-tooltip-end[data-v-15445482]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-15445482],.bs-tooltip-end .tooltip-arrow[data-v-15445482]{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-15445482]:before,.bs-tooltip-end .tooltip-arrow[data-v-15445482]:before{right:-1px;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[data-popper-placement^=bottom][data-v-15445482],.bs-tooltip-bottom[data-v-15445482]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-15445482],.bs-tooltip-bottom .tooltip-arrow[data-v-15445482]{top:0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-15445482]:before,.bs-tooltip-bottom .tooltip-arrow[data-v-15445482]:before{bottom:-1px;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[data-popper-placement^=left][data-v-15445482],.bs-tooltip-start[data-v-15445482]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-15445482],.bs-tooltip-start .tooltip-arrow[data-v-15445482]{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-15445482]:before,.bs-tooltip-start .tooltip-arrow[data-v-15445482]:before{left:-1px;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner[data-v-15445482]{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover[data-v-15445482]{position:absolute;top:0;left:0;z-index:1070;display:block;max-width:276px;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover .popover-arrow[data-v-15445482]{position:absolute;display:block;width:1rem;height:.5rem}.popover .popover-arrow[data-v-15445482]:after,.popover .popover-arrow[data-v-15445482]:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-15445482],.bs-popover-top>.popover-arrow[data-v-15445482]{bottom:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-15445482]:before,.bs-popover-top>.popover-arrow[data-v-15445482]:before{bottom:0;border-width:.5rem .5rem 0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-15445482]:after,.bs-popover-top>.popover-arrow[data-v-15445482]:after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:#fff}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-15445482],.bs-popover-end>.popover-arrow[data-v-15445482]{left:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-15445482]:before,.bs-popover-end>.popover-arrow[data-v-15445482]:before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-15445482]:after,.bs-popover-end>.popover-arrow[data-v-15445482]:after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:#fff}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-15445482],.bs-popover-bottom>.popover-arrow[data-v-15445482]{top:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-15445482]:before,.bs-popover-bottom>.popover-arrow[data-v-15445482]:before{top:0;border-width:0 .5rem .5rem;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-15445482]:after,.bs-popover-bottom>.popover-arrow[data-v-15445482]:after{top:1px;border-width:0 .5rem .5rem;border-bottom-color:#fff}.bs-popover-auto[data-popper-placement^=bottom] .popover-header[data-v-15445482]:before,.bs-popover-bottom .popover-header[data-v-15445482]:before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f0f0f0}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-15445482],.bs-popover-start>.popover-arrow[data-v-15445482]{right:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-15445482]:before,.bs-popover-start>.popover-arrow[data-v-15445482]:before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-15445482]:after,.bs-popover-start>.popover-arrow[data-v-15445482]:after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:#fff}.popover-header[data-v-15445482]{padding:.5rem 1rem;margin-bottom:0;font-size:1rem;background-color:#f0f0f0;border-bottom:1px solid rgba(0,0,0,.2);border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header[data-v-15445482]:empty{display:none}.popover-body[data-v-15445482]{padding:1rem;color:#212529}.carousel[data-v-15445482]{position:relative}.carousel.pointer-event[data-v-15445482]{touch-action:pan-y}.carousel-inner[data-v-15445482]{position:relative;width:100%;overflow:hidden}.carousel-inner[data-v-15445482]:after{display:block;clear:both;content:\"\"}.carousel-item[data-v-15445482]{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.carousel-item[data-v-15445482]{transition:none}}.carousel-item-next[data-v-15445482],.carousel-item-prev[data-v-15445482],.carousel-item.active[data-v-15445482]{display:block}.active.carousel-item-end[data-v-15445482],.carousel-item-next[data-v-15445482]:not(.carousel-item-start){transform:translateX(100%)}.active.carousel-item-start[data-v-15445482],.carousel-item-prev[data-v-15445482]:not(.carousel-item-end){transform:translateX(-100%)}.carousel-fade .carousel-item[data-v-15445482]{opacity:0;transition-property:opacity;transform:none}.carousel-fade .carousel-item-next.carousel-item-start[data-v-15445482],.carousel-fade .carousel-item-prev.carousel-item-end[data-v-15445482],.carousel-fade .carousel-item.active[data-v-15445482]{z-index:1;opacity:1}.carousel-fade .active.carousel-item-end[data-v-15445482],.carousel-fade .active.carousel-item-start[data-v-15445482]{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.carousel-fade .active.carousel-item-end[data-v-15445482],.carousel-fade .active.carousel-item-start[data-v-15445482]{transition:none}}.carousel-control-next[data-v-15445482],.carousel-control-prev[data-v-15445482]{position:absolute;top:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center;width:15%;padding:0;color:#fff;text-align:center;background:0 0;border:0;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.carousel-control-next[data-v-15445482],.carousel-control-prev[data-v-15445482]{transition:none}}.carousel-control-next[data-v-15445482]:focus,.carousel-control-next[data-v-15445482]:hover,.carousel-control-prev[data-v-15445482]:focus,.carousel-control-prev[data-v-15445482]:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev[data-v-15445482]{left:0}.carousel-control-next[data-v-15445482]{right:0}.carousel-control-next-icon[data-v-15445482],.carousel-control-prev-icon[data-v-15445482]{display:inline-block;width:2rem;height:2rem;background-repeat:no-repeat;background-position:50%;background-size:100% 100%}.carousel-control-prev-icon[data-v-15445482]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3E%3C/svg%3E\")}.carousel-control-next-icon[data-v-15445482]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\")}.carousel-indicators[data-v-15445482]{position:absolute;right:0;bottom:0;left:0;z-index:2;display:flex;justify-content:center;padding:0;margin-right:15%;margin-bottom:1rem;margin-left:15%;list-style:none}.carousel-indicators [data-bs-target][data-v-15445482]{box-sizing:content-box;flex:0 1 auto;width:30px;height:3px;padding:0;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border:0;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.carousel-indicators [data-bs-target][data-v-15445482]{transition:none}}.carousel-indicators .active[data-v-15445482]{opacity:1}.carousel-caption[data-v-15445482]{position:absolute;right:15%;bottom:1.25rem;left:15%;padding-top:1.25rem;padding-bottom:1.25rem;color:#fff;text-align:center}.carousel-dark .carousel-control-next-icon[data-v-15445482],.carousel-dark .carousel-control-prev-icon[data-v-15445482]{filter:invert(1) grayscale(100)}.carousel-dark .carousel-indicators [data-bs-target][data-v-15445482]{background-color:#000}.carousel-dark .carousel-caption[data-v-15445482]{color:#000}@-webkit-keyframes spinner-border-data-v-15445482{to{transform:rotate(1turn)}}@keyframes spinner-border-data-v-15445482{to{transform:rotate(1turn)}}.spinner-border[data-v-15445482]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:.75s linear infinite spinner-border-data-v-15445482;animation:.75s linear infinite spinner-border-data-v-15445482}.spinner-border-sm[data-v-15445482]{width:1rem;height:1rem;border-width:.2em}@-webkit-keyframes spinner-grow-data-v-15445482{0%{transform:scale(0)}50%{opacity:1;transform:none}}@keyframes spinner-grow-data-v-15445482{0%{transform:scale(0)}50%{opacity:1;transform:none}}.spinner-grow[data-v-15445482]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;background-color:currentColor;border-radius:50%;opacity:0;-webkit-animation:.75s linear infinite spinner-grow-data-v-15445482;animation:.75s linear infinite spinner-grow-data-v-15445482}.spinner-grow-sm[data-v-15445482]{width:1rem;height:1rem}@media (prefers-reduced-motion:reduce){.spinner-border[data-v-15445482],.spinner-grow[data-v-15445482]{-webkit-animation-duration:1.5s;animation-duration:1.5s}}.offcanvas[data-v-15445482]{position:fixed;bottom:0;z-index:1045;display:flex;flex-direction:column;max-width:100%;visibility:hidden;background-color:#fff;background-clip:padding-box;outline:0;transition:transform .3s ease-in-out}@media (prefers-reduced-motion:reduce){.offcanvas[data-v-15445482]{transition:none}}.offcanvas-backdrop[data-v-15445482]{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.offcanvas-backdrop.fade[data-v-15445482]{opacity:0}.offcanvas-backdrop.show[data-v-15445482]{opacity:.5}.offcanvas-header[data-v-15445482]{display:flex;align-items:center;justify-content:space-between;padding:1rem}.offcanvas-header .btn-close[data-v-15445482]{padding:.5rem;margin-top:-.5rem;margin-right:-.5rem;margin-bottom:-.5rem}.offcanvas-title[data-v-15445482]{margin-bottom:0;line-height:1.5}.offcanvas-body[data-v-15445482]{flex-grow:1;padding:1rem;overflow-y:auto}.offcanvas-start[data-v-15445482]{top:0;left:0;width:400px;border-right:1px solid rgba(0,0,0,.2);transform:translateX(-100%)}.offcanvas-end[data-v-15445482]{top:0;right:0;width:400px;border-left:1px solid rgba(0,0,0,.2);transform:translateX(100%)}.offcanvas-top[data-v-15445482]{top:0;right:0;left:0;height:30vh;max-height:100%;border-bottom:1px solid rgba(0,0,0,.2);transform:translateY(-100%)}.offcanvas-bottom[data-v-15445482]{right:0;left:0;height:30vh;max-height:100%;border-top:1px solid rgba(0,0,0,.2);transform:translateY(100%)}.offcanvas.show[data-v-15445482]{transform:none}.placeholder[data-v-15445482]{display:inline-block;min-height:1em;vertical-align:middle;cursor:wait;background-color:currentColor;opacity:.5}.placeholder.btn[data-v-15445482]:before{display:inline-block;content:\"\"}.placeholder-xs[data-v-15445482]{min-height:.6em}.placeholder-sm[data-v-15445482]{min-height:.8em}.placeholder-lg[data-v-15445482]{min-height:1.2em}.placeholder-glow .placeholder[data-v-15445482]{-webkit-animation:placeholder-glow-data-v-15445482 2s ease-in-out infinite;animation:placeholder-glow-data-v-15445482 2s ease-in-out infinite}@-webkit-keyframes placeholder-glow-data-v-15445482{50%{opacity:.2}}@keyframes placeholder-glow-data-v-15445482{50%{opacity:.2}}.placeholder-wave[data-v-15445482]{-webkit-mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);-webkit-mask-size:200% 100%;mask-size:200% 100%;-webkit-animation:placeholder-wave-data-v-15445482 2s linear infinite;animation:placeholder-wave-data-v-15445482 2s linear infinite}@-webkit-keyframes placeholder-wave-data-v-15445482{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}@keyframes placeholder-wave-data-v-15445482{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}.clearfix[data-v-15445482]:after{display:block;clear:both;content:\"\"}.link-primary[data-v-15445482]{color:#0d6efd}.link-primary[data-v-15445482]:focus,.link-primary[data-v-15445482]:hover{color:#0a58ca}.link-secondary[data-v-15445482]{color:#6c757d}.link-secondary[data-v-15445482]:focus,.link-secondary[data-v-15445482]:hover{color:#565e64}.link-success[data-v-15445482]{color:#198754}.link-success[data-v-15445482]:focus,.link-success[data-v-15445482]:hover{color:#146c43}.link-info[data-v-15445482]{color:#0dcaf0}.link-info[data-v-15445482]:focus,.link-info[data-v-15445482]:hover{color:#3dd5f3}.link-warning[data-v-15445482]{color:#ffc107}.link-warning[data-v-15445482]:focus,.link-warning[data-v-15445482]:hover{color:#ffcd39}.link-danger[data-v-15445482]{color:#dc3545}.link-danger[data-v-15445482]:focus,.link-danger[data-v-15445482]:hover{color:#b02a37}.link-light[data-v-15445482]{color:#f8f9fa}.link-light[data-v-15445482]:focus,.link-light[data-v-15445482]:hover{color:#f9fafb}.link-dark[data-v-15445482]{color:#212529}.link-dark[data-v-15445482]:focus,.link-dark[data-v-15445482]:hover{color:#1a1e21}.ratio[data-v-15445482]{position:relative;width:100%}.ratio[data-v-15445482]:before{display:block;padding-top:var(--bs-aspect-ratio);content:\"\"}.ratio>[data-v-15445482]{position:absolute;top:0;left:0;width:100%;height:100%}.ratio-1x1[data-v-15445482]{--bs-aspect-ratio:100%}.ratio-4x3[data-v-15445482]{--bs-aspect-ratio:75%}.ratio-16x9[data-v-15445482]{--bs-aspect-ratio:56.25%}.ratio-21x9[data-v-15445482]{--bs-aspect-ratio:42.8571428571%}.fixed-top[data-v-15445482]{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom[data-v-15445482]{position:fixed;right:0;bottom:0;left:0;z-index:1030}.sticky-top[data-v-15445482]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}@media (min-width:576px){.sticky-sm-top[data-v-15445482]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:768px){.sticky-md-top[data-v-15445482]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:992px){.sticky-lg-top[data-v-15445482]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1200px){.sticky-xl-top[data-v-15445482]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1400px){.sticky-xxl-top[data-v-15445482]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.hstack[data-v-15445482]{display:flex;flex-direction:row;align-items:center;align-self:stretch}.vstack[data-v-15445482]{display:flex;flex:1 1 auto;flex-direction:column;align-self:stretch}.visually-hidden-focusable[data-v-15445482]:not(:focus):not(:focus-within),.visually-hidden[data-v-15445482]{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}.stretched-link[data-v-15445482]:after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;content:\"\"}.text-truncate[data-v-15445482]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.vr[data-v-15445482]{display:inline-block;align-self:stretch;width:1px;min-height:1em;background-color:currentColor;opacity:.25}.align-baseline[data-v-15445482]{vertical-align:baseline!important}.align-top[data-v-15445482]{vertical-align:top!important}.align-middle[data-v-15445482]{vertical-align:middle!important}.align-bottom[data-v-15445482]{vertical-align:bottom!important}.align-text-bottom[data-v-15445482]{vertical-align:text-bottom!important}.align-text-top[data-v-15445482]{vertical-align:text-top!important}.float-start[data-v-15445482]{float:left!important}.float-end[data-v-15445482]{float:right!important}.float-none[data-v-15445482]{float:none!important}.opacity-0[data-v-15445482]{opacity:0!important}.opacity-25[data-v-15445482]{opacity:.25!important}.opacity-50[data-v-15445482]{opacity:.5!important}.opacity-75[data-v-15445482]{opacity:.75!important}.opacity-100[data-v-15445482]{opacity:1!important}.overflow-auto[data-v-15445482]{overflow:auto!important}.overflow-hidden[data-v-15445482]{overflow:hidden!important}.overflow-visible[data-v-15445482]{overflow:visible!important}.overflow-scroll[data-v-15445482]{overflow:scroll!important}.d-inline[data-v-15445482]{display:inline!important}.d-inline-block[data-v-15445482]{display:inline-block!important}.d-block[data-v-15445482]{display:block!important}.d-grid[data-v-15445482]{display:grid!important}.d-table[data-v-15445482]{display:table!important}.d-table-row[data-v-15445482]{display:table-row!important}.d-table-cell[data-v-15445482]{display:table-cell!important}.d-flex[data-v-15445482]{display:flex!important}.d-inline-flex[data-v-15445482]{display:inline-flex!important}.d-none[data-v-15445482]{display:none!important}.shadow[data-v-15445482]{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.shadow-sm[data-v-15445482]{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.shadow-lg[data-v-15445482]{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.shadow-none[data-v-15445482]{box-shadow:none!important}.position-static[data-v-15445482]{position:static!important}.position-relative[data-v-15445482]{position:relative!important}.position-absolute[data-v-15445482]{position:absolute!important}.position-fixed[data-v-15445482]{position:fixed!important}.position-sticky[data-v-15445482]{position:-webkit-sticky!important;position:sticky!important}.top-0[data-v-15445482]{top:0!important}.top-50[data-v-15445482]{top:50%!important}.top-100[data-v-15445482]{top:100%!important}.bottom-0[data-v-15445482]{bottom:0!important}.bottom-50[data-v-15445482]{bottom:50%!important}.bottom-100[data-v-15445482]{bottom:100%!important}.start-0[data-v-15445482]{left:0!important}.start-50[data-v-15445482]{left:50%!important}.start-100[data-v-15445482]{left:100%!important}.end-0[data-v-15445482]{right:0!important}.end-50[data-v-15445482]{right:50%!important}.end-100[data-v-15445482]{right:100%!important}.translate-middle[data-v-15445482]{transform:translate(-50%,-50%)!important}.translate-middle-x[data-v-15445482]{transform:translateX(-50%)!important}.translate-middle-y[data-v-15445482]{transform:translateY(-50%)!important}.border[data-v-15445482]{border:1px solid #dee2e6!important}.border-0[data-v-15445482]{border:0!important}.border-top[data-v-15445482]{border-top:1px solid #dee2e6!important}.border-top-0[data-v-15445482]{border-top:0!important}.border-end[data-v-15445482]{border-right:1px solid #dee2e6!important}.border-end-0[data-v-15445482]{border-right:0!important}.border-bottom[data-v-15445482]{border-bottom:1px solid #dee2e6!important}.border-bottom-0[data-v-15445482]{border-bottom:0!important}.border-start[data-v-15445482]{border-left:1px solid #dee2e6!important}.border-start-0[data-v-15445482]{border-left:0!important}.border-primary[data-v-15445482]{border-color:#0d6efd!important}.border-secondary[data-v-15445482]{border-color:#6c757d!important}.border-success[data-v-15445482]{border-color:#198754!important}.border-info[data-v-15445482]{border-color:#0dcaf0!important}.border-warning[data-v-15445482]{border-color:#ffc107!important}.border-danger[data-v-15445482]{border-color:#dc3545!important}.border-light[data-v-15445482]{border-color:#f8f9fa!important}.border-dark[data-v-15445482]{border-color:#212529!important}.border-white[data-v-15445482]{border-color:#fff!important}.border-1[data-v-15445482]{border-width:1px!important}.border-2[data-v-15445482]{border-width:2px!important}.border-3[data-v-15445482]{border-width:3px!important}.border-4[data-v-15445482]{border-width:4px!important}.border-5[data-v-15445482]{border-width:5px!important}.w-25[data-v-15445482]{width:25%!important}.w-50[data-v-15445482]{width:50%!important}.w-75[data-v-15445482]{width:75%!important}.w-100[data-v-15445482]{width:100%!important}.w-auto[data-v-15445482]{width:auto!important}.mw-100[data-v-15445482]{max-width:100%!important}.vw-100[data-v-15445482]{width:100vw!important}.min-vw-100[data-v-15445482]{min-width:100vw!important}.h-25[data-v-15445482]{height:25%!important}.h-50[data-v-15445482]{height:50%!important}.h-75[data-v-15445482]{height:75%!important}.h-100[data-v-15445482]{height:100%!important}.h-auto[data-v-15445482]{height:auto!important}.mh-100[data-v-15445482]{max-height:100%!important}.vh-100[data-v-15445482]{height:100vh!important}.min-vh-100[data-v-15445482]{min-height:100vh!important}.flex-fill[data-v-15445482]{flex:1 1 auto!important}.flex-row[data-v-15445482]{flex-direction:row!important}.flex-column[data-v-15445482]{flex-direction:column!important}.flex-row-reverse[data-v-15445482]{flex-direction:row-reverse!important}.flex-column-reverse[data-v-15445482]{flex-direction:column-reverse!important}.flex-grow-0[data-v-15445482]{flex-grow:0!important}.flex-grow-1[data-v-15445482]{flex-grow:1!important}.flex-shrink-0[data-v-15445482]{flex-shrink:0!important}.flex-shrink-1[data-v-15445482]{flex-shrink:1!important}.flex-wrap[data-v-15445482]{flex-wrap:wrap!important}.flex-nowrap[data-v-15445482]{flex-wrap:nowrap!important}.flex-wrap-reverse[data-v-15445482]{flex-wrap:wrap-reverse!important}.gap-0[data-v-15445482]{gap:0!important}.gap-1[data-v-15445482]{gap:.25rem!important}.gap-2[data-v-15445482]{gap:.5rem!important}.gap-3[data-v-15445482]{gap:1rem!important}.gap-4[data-v-15445482]{gap:1.5rem!important}.gap-5[data-v-15445482]{gap:3rem!important}.justify-content-start[data-v-15445482]{justify-content:flex-start!important}.justify-content-end[data-v-15445482]{justify-content:flex-end!important}.justify-content-center[data-v-15445482]{justify-content:center!important}.justify-content-between[data-v-15445482]{justify-content:space-between!important}.justify-content-around[data-v-15445482]{justify-content:space-around!important}.justify-content-evenly[data-v-15445482]{justify-content:space-evenly!important}.align-items-start[data-v-15445482]{align-items:flex-start!important}.align-items-end[data-v-15445482]{align-items:flex-end!important}.align-items-center[data-v-15445482]{align-items:center!important}.align-items-baseline[data-v-15445482]{align-items:baseline!important}.align-items-stretch[data-v-15445482]{align-items:stretch!important}.align-content-start[data-v-15445482]{align-content:flex-start!important}.align-content-end[data-v-15445482]{align-content:flex-end!important}.align-content-center[data-v-15445482]{align-content:center!important}.align-content-between[data-v-15445482]{align-content:space-between!important}.align-content-around[data-v-15445482]{align-content:space-around!important}.align-content-stretch[data-v-15445482]{align-content:stretch!important}.align-self-auto[data-v-15445482]{align-self:auto!important}.align-self-start[data-v-15445482]{align-self:flex-start!important}.align-self-end[data-v-15445482]{align-self:flex-end!important}.align-self-center[data-v-15445482]{align-self:center!important}.align-self-baseline[data-v-15445482]{align-self:baseline!important}.align-self-stretch[data-v-15445482]{align-self:stretch!important}.order-first[data-v-15445482]{order:-1!important}.order-0[data-v-15445482]{order:0!important}.order-1[data-v-15445482]{order:1!important}.order-2[data-v-15445482]{order:2!important}.order-3[data-v-15445482]{order:3!important}.order-4[data-v-15445482]{order:4!important}.order-5[data-v-15445482]{order:5!important}.order-last[data-v-15445482]{order:6!important}.m-0[data-v-15445482]{margin:0!important}.m-1[data-v-15445482]{margin:.25rem!important}.m-2[data-v-15445482]{margin:.5rem!important}.m-3[data-v-15445482]{margin:1rem!important}.m-4[data-v-15445482]{margin:1.5rem!important}.m-5[data-v-15445482]{margin:3rem!important}.m-auto[data-v-15445482]{margin:auto!important}.mx-0[data-v-15445482]{margin-right:0!important;margin-left:0!important}.mx-1[data-v-15445482]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-2[data-v-15445482]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-3[data-v-15445482]{margin-right:1rem!important;margin-left:1rem!important}.mx-4[data-v-15445482]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-5[data-v-15445482]{margin-right:3rem!important;margin-left:3rem!important}.mx-auto[data-v-15445482]{margin-right:auto!important;margin-left:auto!important}.my-0[data-v-15445482]{margin-top:0!important;margin-bottom:0!important}.my-1[data-v-15445482]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-2[data-v-15445482]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-3[data-v-15445482]{margin-top:1rem!important;margin-bottom:1rem!important}.my-4[data-v-15445482]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-5[data-v-15445482]{margin-top:3rem!important;margin-bottom:3rem!important}.my-auto[data-v-15445482]{margin-top:auto!important;margin-bottom:auto!important}.mt-0[data-v-15445482]{margin-top:0!important}.mt-1[data-v-15445482]{margin-top:.25rem!important}.mt-2[data-v-15445482]{margin-top:.5rem!important}.mt-3[data-v-15445482]{margin-top:1rem!important}.mt-4[data-v-15445482]{margin-top:1.5rem!important}.mt-5[data-v-15445482]{margin-top:3rem!important}.mt-auto[data-v-15445482]{margin-top:auto!important}.me-0[data-v-15445482]{margin-right:0!important}.me-1[data-v-15445482]{margin-right:.25rem!important}.me-2[data-v-15445482]{margin-right:.5rem!important}.me-3[data-v-15445482]{margin-right:1rem!important}.me-4[data-v-15445482]{margin-right:1.5rem!important}.me-5[data-v-15445482]{margin-right:3rem!important}.me-auto[data-v-15445482]{margin-right:auto!important}.mb-0[data-v-15445482]{margin-bottom:0!important}.mb-1[data-v-15445482]{margin-bottom:.25rem!important}.mb-2[data-v-15445482]{margin-bottom:.5rem!important}.mb-3[data-v-15445482]{margin-bottom:1rem!important}.mb-4[data-v-15445482]{margin-bottom:1.5rem!important}.mb-5[data-v-15445482]{margin-bottom:3rem!important}.mb-auto[data-v-15445482]{margin-bottom:auto!important}.ms-0[data-v-15445482]{margin-left:0!important}.ms-1[data-v-15445482]{margin-left:.25rem!important}.ms-2[data-v-15445482]{margin-left:.5rem!important}.ms-3[data-v-15445482]{margin-left:1rem!important}.ms-4[data-v-15445482]{margin-left:1.5rem!important}.ms-5[data-v-15445482]{margin-left:3rem!important}.ms-auto[data-v-15445482]{margin-left:auto!important}.p-0[data-v-15445482]{padding:0!important}.p-1[data-v-15445482]{padding:.25rem!important}.p-2[data-v-15445482]{padding:.5rem!important}.p-3[data-v-15445482]{padding:1rem!important}.p-4[data-v-15445482]{padding:1.5rem!important}.p-5[data-v-15445482]{padding:3rem!important}.px-0[data-v-15445482]{padding-right:0!important;padding-left:0!important}.px-1[data-v-15445482]{padding-right:.25rem!important;padding-left:.25rem!important}.px-2[data-v-15445482]{padding-right:.5rem!important;padding-left:.5rem!important}.px-3[data-v-15445482]{padding-right:1rem!important;padding-left:1rem!important}.px-4[data-v-15445482]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-5[data-v-15445482]{padding-right:3rem!important;padding-left:3rem!important}.py-0[data-v-15445482]{padding-top:0!important;padding-bottom:0!important}.py-1[data-v-15445482]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-2[data-v-15445482]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-3[data-v-15445482]{padding-top:1rem!important;padding-bottom:1rem!important}.py-4[data-v-15445482]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-5[data-v-15445482]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-0[data-v-15445482]{padding-top:0!important}.pt-1[data-v-15445482]{padding-top:.25rem!important}.pt-2[data-v-15445482]{padding-top:.5rem!important}.pt-3[data-v-15445482]{padding-top:1rem!important}.pt-4[data-v-15445482]{padding-top:1.5rem!important}.pt-5[data-v-15445482]{padding-top:3rem!important}.pe-0[data-v-15445482]{padding-right:0!important}.pe-1[data-v-15445482]{padding-right:.25rem!important}.pe-2[data-v-15445482]{padding-right:.5rem!important}.pe-3[data-v-15445482]{padding-right:1rem!important}.pe-4[data-v-15445482]{padding-right:1.5rem!important}.pe-5[data-v-15445482]{padding-right:3rem!important}.pb-0[data-v-15445482]{padding-bottom:0!important}.pb-1[data-v-15445482]{padding-bottom:.25rem!important}.pb-2[data-v-15445482]{padding-bottom:.5rem!important}.pb-3[data-v-15445482]{padding-bottom:1rem!important}.pb-4[data-v-15445482]{padding-bottom:1.5rem!important}.pb-5[data-v-15445482]{padding-bottom:3rem!important}.ps-0[data-v-15445482]{padding-left:0!important}.ps-1[data-v-15445482]{padding-left:.25rem!important}.ps-2[data-v-15445482]{padding-left:.5rem!important}.ps-3[data-v-15445482]{padding-left:1rem!important}.ps-4[data-v-15445482]{padding-left:1.5rem!important}.ps-5[data-v-15445482]{padding-left:3rem!important}.font-monospace[data-v-15445482]{font-family:var(--bs-font-monospace)!important}.fs-1[data-v-15445482]{font-size:calc(1.375rem + 1.5vw)!important}.fs-2[data-v-15445482]{font-size:calc(1.325rem + .9vw)!important}.fs-3[data-v-15445482]{font-size:calc(1.3rem + .6vw)!important}.fs-4[data-v-15445482]{font-size:calc(1.275rem + .3vw)!important}.fs-5[data-v-15445482]{font-size:1.25rem!important}.fs-6[data-v-15445482]{font-size:1rem!important}.fst-italic[data-v-15445482]{font-style:italic!important}.fst-normal[data-v-15445482]{font-style:normal!important}.fw-light[data-v-15445482]{font-weight:300!important}.fw-lighter[data-v-15445482]{font-weight:lighter!important}.fw-normal[data-v-15445482]{font-weight:400!important}.fw-bold[data-v-15445482]{font-weight:700!important}.fw-bolder[data-v-15445482]{font-weight:bolder!important}.lh-1[data-v-15445482]{line-height:1!important}.lh-sm[data-v-15445482]{line-height:1.25!important}.lh-base[data-v-15445482]{line-height:1.5!important}.lh-lg[data-v-15445482]{line-height:2!important}.text-start[data-v-15445482]{text-align:left!important}.text-end[data-v-15445482]{text-align:right!important}.text-center[data-v-15445482]{text-align:center!important}.text-decoration-none[data-v-15445482]{text-decoration:none!important}.text-decoration-underline[data-v-15445482]{text-decoration:underline!important}.text-decoration-line-through[data-v-15445482]{text-decoration:line-through!important}.text-lowercase[data-v-15445482]{text-transform:lowercase!important}.text-uppercase[data-v-15445482]{text-transform:uppercase!important}.text-capitalize[data-v-15445482]{text-transform:capitalize!important}.text-wrap[data-v-15445482]{white-space:normal!important}.text-nowrap[data-v-15445482]{white-space:nowrap!important}.text-break[data-v-15445482]{word-wrap:break-word!important;word-break:break-word!important}.text-primary[data-v-15445482]{--bs-text-opacity:1;color:rgba(var(--bs-primary-rgb),var(--bs-text-opacity))!important}.text-secondary[data-v-15445482]{--bs-text-opacity:1;color:rgba(var(--bs-secondary-rgb),var(--bs-text-opacity))!important}.text-success[data-v-15445482]{--bs-text-opacity:1;color:rgba(var(--bs-success-rgb),var(--bs-text-opacity))!important}.text-info[data-v-15445482]{--bs-text-opacity:1;color:rgba(var(--bs-info-rgb),var(--bs-text-opacity))!important}.text-warning[data-v-15445482]{--bs-text-opacity:1;color:rgba(var(--bs-warning-rgb),var(--bs-text-opacity))!important}.text-danger[data-v-15445482]{--bs-text-opacity:1;color:rgba(var(--bs-danger-rgb),var(--bs-text-opacity))!important}.text-light[data-v-15445482]{--bs-text-opacity:1;color:rgba(var(--bs-light-rgb),var(--bs-text-opacity))!important}.text-dark[data-v-15445482]{--bs-text-opacity:1;color:rgba(var(--bs-dark-rgb),var(--bs-text-opacity))!important}.text-black[data-v-15445482]{--bs-text-opacity:1;color:rgba(var(--bs-black-rgb),var(--bs-text-opacity))!important}.text-white[data-v-15445482]{--bs-text-opacity:1;color:rgba(var(--bs-white-rgb),var(--bs-text-opacity))!important}.text-body[data-v-15445482]{--bs-text-opacity:1;color:rgba(var(--bs-body-color-rgb),var(--bs-text-opacity))!important}.text-muted[data-v-15445482]{--bs-text-opacity:1;color:#6c757d!important}.text-black-50[data-v-15445482]{--bs-text-opacity:1;color:rgba(0,0,0,.5)!important}.text-white-50[data-v-15445482]{--bs-text-opacity:1;color:hsla(0,0%,100%,.5)!important}.text-reset[data-v-15445482]{--bs-text-opacity:1;color:inherit!important}.text-opacity-25[data-v-15445482]{--bs-text-opacity:0.25}.text-opacity-50[data-v-15445482]{--bs-text-opacity:0.5}.text-opacity-75[data-v-15445482]{--bs-text-opacity:0.75}.text-opacity-100[data-v-15445482]{--bs-text-opacity:1}.bg-primary[data-v-15445482]{--bs-bg-opacity:1;background-color:rgba(var(--bs-primary-rgb),var(--bs-bg-opacity))!important}.bg-secondary[data-v-15445482]{--bs-bg-opacity:1;background-color:rgba(var(--bs-secondary-rgb),var(--bs-bg-opacity))!important}.bg-success[data-v-15445482]{--bs-bg-opacity:1;background-color:rgba(var(--bs-success-rgb),var(--bs-bg-opacity))!important}.bg-info[data-v-15445482]{--bs-bg-opacity:1;background-color:rgba(var(--bs-info-rgb),var(--bs-bg-opacity))!important}.bg-warning[data-v-15445482]{--bs-bg-opacity:1;background-color:rgba(var(--bs-warning-rgb),var(--bs-bg-opacity))!important}.bg-danger[data-v-15445482]{--bs-bg-opacity:1;background-color:rgba(var(--bs-danger-rgb),var(--bs-bg-opacity))!important}.bg-light[data-v-15445482]{--bs-bg-opacity:1;background-color:rgba(var(--bs-light-rgb),var(--bs-bg-opacity))!important}.bg-dark[data-v-15445482]{--bs-bg-opacity:1;background-color:rgba(var(--bs-dark-rgb),var(--bs-bg-opacity))!important}.bg-black[data-v-15445482]{--bs-bg-opacity:1;background-color:rgba(var(--bs-black-rgb),var(--bs-bg-opacity))!important}.bg-white[data-v-15445482]{--bs-bg-opacity:1;background-color:rgba(var(--bs-white-rgb),var(--bs-bg-opacity))!important}.bg-body[data-v-15445482]{--bs-bg-opacity:1;background-color:rgba(var(--bs-body-bg-rgb),var(--bs-bg-opacity))!important}.bg-transparent[data-v-15445482]{--bs-bg-opacity:1;background-color:transparent!important}.bg-opacity-10[data-v-15445482]{--bs-bg-opacity:0.1}.bg-opacity-25[data-v-15445482]{--bs-bg-opacity:0.25}.bg-opacity-50[data-v-15445482]{--bs-bg-opacity:0.5}.bg-opacity-75[data-v-15445482]{--bs-bg-opacity:0.75}.bg-opacity-100[data-v-15445482]{--bs-bg-opacity:1}.bg-gradient[data-v-15445482]{background-image:var(--bs-gradient)!important}.user-select-all[data-v-15445482]{-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.user-select-auto[data-v-15445482]{-webkit-user-select:auto!important;-moz-user-select:auto!important;user-select:auto!important}.user-select-none[data-v-15445482]{-webkit-user-select:none!important;-moz-user-select:none!important;user-select:none!important}.pe-none[data-v-15445482]{pointer-events:none!important}.pe-auto[data-v-15445482]{pointer-events:auto!important}.rounded[data-v-15445482]{border-radius:.25rem!important}.rounded-0[data-v-15445482]{border-radius:0!important}.rounded-1[data-v-15445482]{border-radius:.2rem!important}.rounded-2[data-v-15445482]{border-radius:.25rem!important}.rounded-3[data-v-15445482]{border-radius:.3rem!important}.rounded-circle[data-v-15445482]{border-radius:50%!important}.rounded-pill[data-v-15445482]{border-radius:50rem!important}.rounded-top[data-v-15445482]{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.rounded-end[data-v-15445482]{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.rounded-bottom[data-v-15445482]{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-start[data-v-15445482]{border-bottom-left-radius:.25rem!important;border-top-left-radius:.25rem!important}.visible[data-v-15445482]{visibility:visible!important}.invisible[data-v-15445482]{visibility:hidden!important}@media (min-width:576px){.float-sm-start[data-v-15445482]{float:left!important}.float-sm-end[data-v-15445482]{float:right!important}.float-sm-none[data-v-15445482]{float:none!important}.d-sm-inline[data-v-15445482]{display:inline!important}.d-sm-inline-block[data-v-15445482]{display:inline-block!important}.d-sm-block[data-v-15445482]{display:block!important}.d-sm-grid[data-v-15445482]{display:grid!important}.d-sm-table[data-v-15445482]{display:table!important}.d-sm-table-row[data-v-15445482]{display:table-row!important}.d-sm-table-cell[data-v-15445482]{display:table-cell!important}.d-sm-flex[data-v-15445482]{display:flex!important}.d-sm-inline-flex[data-v-15445482]{display:inline-flex!important}.d-sm-none[data-v-15445482]{display:none!important}.flex-sm-fill[data-v-15445482]{flex:1 1 auto!important}.flex-sm-row[data-v-15445482]{flex-direction:row!important}.flex-sm-column[data-v-15445482]{flex-direction:column!important}.flex-sm-row-reverse[data-v-15445482]{flex-direction:row-reverse!important}.flex-sm-column-reverse[data-v-15445482]{flex-direction:column-reverse!important}.flex-sm-grow-0[data-v-15445482]{flex-grow:0!important}.flex-sm-grow-1[data-v-15445482]{flex-grow:1!important}.flex-sm-shrink-0[data-v-15445482]{flex-shrink:0!important}.flex-sm-shrink-1[data-v-15445482]{flex-shrink:1!important}.flex-sm-wrap[data-v-15445482]{flex-wrap:wrap!important}.flex-sm-nowrap[data-v-15445482]{flex-wrap:nowrap!important}.flex-sm-wrap-reverse[data-v-15445482]{flex-wrap:wrap-reverse!important}.gap-sm-0[data-v-15445482]{gap:0!important}.gap-sm-1[data-v-15445482]{gap:.25rem!important}.gap-sm-2[data-v-15445482]{gap:.5rem!important}.gap-sm-3[data-v-15445482]{gap:1rem!important}.gap-sm-4[data-v-15445482]{gap:1.5rem!important}.gap-sm-5[data-v-15445482]{gap:3rem!important}.justify-content-sm-start[data-v-15445482]{justify-content:flex-start!important}.justify-content-sm-end[data-v-15445482]{justify-content:flex-end!important}.justify-content-sm-center[data-v-15445482]{justify-content:center!important}.justify-content-sm-between[data-v-15445482]{justify-content:space-between!important}.justify-content-sm-around[data-v-15445482]{justify-content:space-around!important}.justify-content-sm-evenly[data-v-15445482]{justify-content:space-evenly!important}.align-items-sm-start[data-v-15445482]{align-items:flex-start!important}.align-items-sm-end[data-v-15445482]{align-items:flex-end!important}.align-items-sm-center[data-v-15445482]{align-items:center!important}.align-items-sm-baseline[data-v-15445482]{align-items:baseline!important}.align-items-sm-stretch[data-v-15445482]{align-items:stretch!important}.align-content-sm-start[data-v-15445482]{align-content:flex-start!important}.align-content-sm-end[data-v-15445482]{align-content:flex-end!important}.align-content-sm-center[data-v-15445482]{align-content:center!important}.align-content-sm-between[data-v-15445482]{align-content:space-between!important}.align-content-sm-around[data-v-15445482]{align-content:space-around!important}.align-content-sm-stretch[data-v-15445482]{align-content:stretch!important}.align-self-sm-auto[data-v-15445482]{align-self:auto!important}.align-self-sm-start[data-v-15445482]{align-self:flex-start!important}.align-self-sm-end[data-v-15445482]{align-self:flex-end!important}.align-self-sm-center[data-v-15445482]{align-self:center!important}.align-self-sm-baseline[data-v-15445482]{align-self:baseline!important}.align-self-sm-stretch[data-v-15445482]{align-self:stretch!important}.order-sm-first[data-v-15445482]{order:-1!important}.order-sm-0[data-v-15445482]{order:0!important}.order-sm-1[data-v-15445482]{order:1!important}.order-sm-2[data-v-15445482]{order:2!important}.order-sm-3[data-v-15445482]{order:3!important}.order-sm-4[data-v-15445482]{order:4!important}.order-sm-5[data-v-15445482]{order:5!important}.order-sm-last[data-v-15445482]{order:6!important}.m-sm-0[data-v-15445482]{margin:0!important}.m-sm-1[data-v-15445482]{margin:.25rem!important}.m-sm-2[data-v-15445482]{margin:.5rem!important}.m-sm-3[data-v-15445482]{margin:1rem!important}.m-sm-4[data-v-15445482]{margin:1.5rem!important}.m-sm-5[data-v-15445482]{margin:3rem!important}.m-sm-auto[data-v-15445482]{margin:auto!important}.mx-sm-0[data-v-15445482]{margin-right:0!important;margin-left:0!important}.mx-sm-1[data-v-15445482]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-sm-2[data-v-15445482]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-sm-3[data-v-15445482]{margin-right:1rem!important;margin-left:1rem!important}.mx-sm-4[data-v-15445482]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-sm-5[data-v-15445482]{margin-right:3rem!important;margin-left:3rem!important}.mx-sm-auto[data-v-15445482]{margin-right:auto!important;margin-left:auto!important}.my-sm-0[data-v-15445482]{margin-top:0!important;margin-bottom:0!important}.my-sm-1[data-v-15445482]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-sm-2[data-v-15445482]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-sm-3[data-v-15445482]{margin-top:1rem!important;margin-bottom:1rem!important}.my-sm-4[data-v-15445482]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-sm-5[data-v-15445482]{margin-top:3rem!important;margin-bottom:3rem!important}.my-sm-auto[data-v-15445482]{margin-top:auto!important;margin-bottom:auto!important}.mt-sm-0[data-v-15445482]{margin-top:0!important}.mt-sm-1[data-v-15445482]{margin-top:.25rem!important}.mt-sm-2[data-v-15445482]{margin-top:.5rem!important}.mt-sm-3[data-v-15445482]{margin-top:1rem!important}.mt-sm-4[data-v-15445482]{margin-top:1.5rem!important}.mt-sm-5[data-v-15445482]{margin-top:3rem!important}.mt-sm-auto[data-v-15445482]{margin-top:auto!important}.me-sm-0[data-v-15445482]{margin-right:0!important}.me-sm-1[data-v-15445482]{margin-right:.25rem!important}.me-sm-2[data-v-15445482]{margin-right:.5rem!important}.me-sm-3[data-v-15445482]{margin-right:1rem!important}.me-sm-4[data-v-15445482]{margin-right:1.5rem!important}.me-sm-5[data-v-15445482]{margin-right:3rem!important}.me-sm-auto[data-v-15445482]{margin-right:auto!important}.mb-sm-0[data-v-15445482]{margin-bottom:0!important}.mb-sm-1[data-v-15445482]{margin-bottom:.25rem!important}.mb-sm-2[data-v-15445482]{margin-bottom:.5rem!important}.mb-sm-3[data-v-15445482]{margin-bottom:1rem!important}.mb-sm-4[data-v-15445482]{margin-bottom:1.5rem!important}.mb-sm-5[data-v-15445482]{margin-bottom:3rem!important}.mb-sm-auto[data-v-15445482]{margin-bottom:auto!important}.ms-sm-0[data-v-15445482]{margin-left:0!important}.ms-sm-1[data-v-15445482]{margin-left:.25rem!important}.ms-sm-2[data-v-15445482]{margin-left:.5rem!important}.ms-sm-3[data-v-15445482]{margin-left:1rem!important}.ms-sm-4[data-v-15445482]{margin-left:1.5rem!important}.ms-sm-5[data-v-15445482]{margin-left:3rem!important}.ms-sm-auto[data-v-15445482]{margin-left:auto!important}.p-sm-0[data-v-15445482]{padding:0!important}.p-sm-1[data-v-15445482]{padding:.25rem!important}.p-sm-2[data-v-15445482]{padding:.5rem!important}.p-sm-3[data-v-15445482]{padding:1rem!important}.p-sm-4[data-v-15445482]{padding:1.5rem!important}.p-sm-5[data-v-15445482]{padding:3rem!important}.px-sm-0[data-v-15445482]{padding-right:0!important;padding-left:0!important}.px-sm-1[data-v-15445482]{padding-right:.25rem!important;padding-left:.25rem!important}.px-sm-2[data-v-15445482]{padding-right:.5rem!important;padding-left:.5rem!important}.px-sm-3[data-v-15445482]{padding-right:1rem!important;padding-left:1rem!important}.px-sm-4[data-v-15445482]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-sm-5[data-v-15445482]{padding-right:3rem!important;padding-left:3rem!important}.py-sm-0[data-v-15445482]{padding-top:0!important;padding-bottom:0!important}.py-sm-1[data-v-15445482]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-sm-2[data-v-15445482]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-sm-3[data-v-15445482]{padding-top:1rem!important;padding-bottom:1rem!important}.py-sm-4[data-v-15445482]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-sm-5[data-v-15445482]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-sm-0[data-v-15445482]{padding-top:0!important}.pt-sm-1[data-v-15445482]{padding-top:.25rem!important}.pt-sm-2[data-v-15445482]{padding-top:.5rem!important}.pt-sm-3[data-v-15445482]{padding-top:1rem!important}.pt-sm-4[data-v-15445482]{padding-top:1.5rem!important}.pt-sm-5[data-v-15445482]{padding-top:3rem!important}.pe-sm-0[data-v-15445482]{padding-right:0!important}.pe-sm-1[data-v-15445482]{padding-right:.25rem!important}.pe-sm-2[data-v-15445482]{padding-right:.5rem!important}.pe-sm-3[data-v-15445482]{padding-right:1rem!important}.pe-sm-4[data-v-15445482]{padding-right:1.5rem!important}.pe-sm-5[data-v-15445482]{padding-right:3rem!important}.pb-sm-0[data-v-15445482]{padding-bottom:0!important}.pb-sm-1[data-v-15445482]{padding-bottom:.25rem!important}.pb-sm-2[data-v-15445482]{padding-bottom:.5rem!important}.pb-sm-3[data-v-15445482]{padding-bottom:1rem!important}.pb-sm-4[data-v-15445482]{padding-bottom:1.5rem!important}.pb-sm-5[data-v-15445482]{padding-bottom:3rem!important}.ps-sm-0[data-v-15445482]{padding-left:0!important}.ps-sm-1[data-v-15445482]{padding-left:.25rem!important}.ps-sm-2[data-v-15445482]{padding-left:.5rem!important}.ps-sm-3[data-v-15445482]{padding-left:1rem!important}.ps-sm-4[data-v-15445482]{padding-left:1.5rem!important}.ps-sm-5[data-v-15445482]{padding-left:3rem!important}.text-sm-start[data-v-15445482]{text-align:left!important}.text-sm-end[data-v-15445482]{text-align:right!important}.text-sm-center[data-v-15445482]{text-align:center!important}}@media (min-width:768px){.float-md-start[data-v-15445482]{float:left!important}.float-md-end[data-v-15445482]{float:right!important}.float-md-none[data-v-15445482]{float:none!important}.d-md-inline[data-v-15445482]{display:inline!important}.d-md-inline-block[data-v-15445482]{display:inline-block!important}.d-md-block[data-v-15445482]{display:block!important}.d-md-grid[data-v-15445482]{display:grid!important}.d-md-table[data-v-15445482]{display:table!important}.d-md-table-row[data-v-15445482]{display:table-row!important}.d-md-table-cell[data-v-15445482]{display:table-cell!important}.d-md-flex[data-v-15445482]{display:flex!important}.d-md-inline-flex[data-v-15445482]{display:inline-flex!important}.d-md-none[data-v-15445482]{display:none!important}.flex-md-fill[data-v-15445482]{flex:1 1 auto!important}.flex-md-row[data-v-15445482]{flex-direction:row!important}.flex-md-column[data-v-15445482]{flex-direction:column!important}.flex-md-row-reverse[data-v-15445482]{flex-direction:row-reverse!important}.flex-md-column-reverse[data-v-15445482]{flex-direction:column-reverse!important}.flex-md-grow-0[data-v-15445482]{flex-grow:0!important}.flex-md-grow-1[data-v-15445482]{flex-grow:1!important}.flex-md-shrink-0[data-v-15445482]{flex-shrink:0!important}.flex-md-shrink-1[data-v-15445482]{flex-shrink:1!important}.flex-md-wrap[data-v-15445482]{flex-wrap:wrap!important}.flex-md-nowrap[data-v-15445482]{flex-wrap:nowrap!important}.flex-md-wrap-reverse[data-v-15445482]{flex-wrap:wrap-reverse!important}.gap-md-0[data-v-15445482]{gap:0!important}.gap-md-1[data-v-15445482]{gap:.25rem!important}.gap-md-2[data-v-15445482]{gap:.5rem!important}.gap-md-3[data-v-15445482]{gap:1rem!important}.gap-md-4[data-v-15445482]{gap:1.5rem!important}.gap-md-5[data-v-15445482]{gap:3rem!important}.justify-content-md-start[data-v-15445482]{justify-content:flex-start!important}.justify-content-md-end[data-v-15445482]{justify-content:flex-end!important}.justify-content-md-center[data-v-15445482]{justify-content:center!important}.justify-content-md-between[data-v-15445482]{justify-content:space-between!important}.justify-content-md-around[data-v-15445482]{justify-content:space-around!important}.justify-content-md-evenly[data-v-15445482]{justify-content:space-evenly!important}.align-items-md-start[data-v-15445482]{align-items:flex-start!important}.align-items-md-end[data-v-15445482]{align-items:flex-end!important}.align-items-md-center[data-v-15445482]{align-items:center!important}.align-items-md-baseline[data-v-15445482]{align-items:baseline!important}.align-items-md-stretch[data-v-15445482]{align-items:stretch!important}.align-content-md-start[data-v-15445482]{align-content:flex-start!important}.align-content-md-end[data-v-15445482]{align-content:flex-end!important}.align-content-md-center[data-v-15445482]{align-content:center!important}.align-content-md-between[data-v-15445482]{align-content:space-between!important}.align-content-md-around[data-v-15445482]{align-content:space-around!important}.align-content-md-stretch[data-v-15445482]{align-content:stretch!important}.align-self-md-auto[data-v-15445482]{align-self:auto!important}.align-self-md-start[data-v-15445482]{align-self:flex-start!important}.align-self-md-end[data-v-15445482]{align-self:flex-end!important}.align-self-md-center[data-v-15445482]{align-self:center!important}.align-self-md-baseline[data-v-15445482]{align-self:baseline!important}.align-self-md-stretch[data-v-15445482]{align-self:stretch!important}.order-md-first[data-v-15445482]{order:-1!important}.order-md-0[data-v-15445482]{order:0!important}.order-md-1[data-v-15445482]{order:1!important}.order-md-2[data-v-15445482]{order:2!important}.order-md-3[data-v-15445482]{order:3!important}.order-md-4[data-v-15445482]{order:4!important}.order-md-5[data-v-15445482]{order:5!important}.order-md-last[data-v-15445482]{order:6!important}.m-md-0[data-v-15445482]{margin:0!important}.m-md-1[data-v-15445482]{margin:.25rem!important}.m-md-2[data-v-15445482]{margin:.5rem!important}.m-md-3[data-v-15445482]{margin:1rem!important}.m-md-4[data-v-15445482]{margin:1.5rem!important}.m-md-5[data-v-15445482]{margin:3rem!important}.m-md-auto[data-v-15445482]{margin:auto!important}.mx-md-0[data-v-15445482]{margin-right:0!important;margin-left:0!important}.mx-md-1[data-v-15445482]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-md-2[data-v-15445482]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-md-3[data-v-15445482]{margin-right:1rem!important;margin-left:1rem!important}.mx-md-4[data-v-15445482]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-md-5[data-v-15445482]{margin-right:3rem!important;margin-left:3rem!important}.mx-md-auto[data-v-15445482]{margin-right:auto!important;margin-left:auto!important}.my-md-0[data-v-15445482]{margin-top:0!important;margin-bottom:0!important}.my-md-1[data-v-15445482]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-md-2[data-v-15445482]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-md-3[data-v-15445482]{margin-top:1rem!important;margin-bottom:1rem!important}.my-md-4[data-v-15445482]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-md-5[data-v-15445482]{margin-top:3rem!important;margin-bottom:3rem!important}.my-md-auto[data-v-15445482]{margin-top:auto!important;margin-bottom:auto!important}.mt-md-0[data-v-15445482]{margin-top:0!important}.mt-md-1[data-v-15445482]{margin-top:.25rem!important}.mt-md-2[data-v-15445482]{margin-top:.5rem!important}.mt-md-3[data-v-15445482]{margin-top:1rem!important}.mt-md-4[data-v-15445482]{margin-top:1.5rem!important}.mt-md-5[data-v-15445482]{margin-top:3rem!important}.mt-md-auto[data-v-15445482]{margin-top:auto!important}.me-md-0[data-v-15445482]{margin-right:0!important}.me-md-1[data-v-15445482]{margin-right:.25rem!important}.me-md-2[data-v-15445482]{margin-right:.5rem!important}.me-md-3[data-v-15445482]{margin-right:1rem!important}.me-md-4[data-v-15445482]{margin-right:1.5rem!important}.me-md-5[data-v-15445482]{margin-right:3rem!important}.me-md-auto[data-v-15445482]{margin-right:auto!important}.mb-md-0[data-v-15445482]{margin-bottom:0!important}.mb-md-1[data-v-15445482]{margin-bottom:.25rem!important}.mb-md-2[data-v-15445482]{margin-bottom:.5rem!important}.mb-md-3[data-v-15445482]{margin-bottom:1rem!important}.mb-md-4[data-v-15445482]{margin-bottom:1.5rem!important}.mb-md-5[data-v-15445482]{margin-bottom:3rem!important}.mb-md-auto[data-v-15445482]{margin-bottom:auto!important}.ms-md-0[data-v-15445482]{margin-left:0!important}.ms-md-1[data-v-15445482]{margin-left:.25rem!important}.ms-md-2[data-v-15445482]{margin-left:.5rem!important}.ms-md-3[data-v-15445482]{margin-left:1rem!important}.ms-md-4[data-v-15445482]{margin-left:1.5rem!important}.ms-md-5[data-v-15445482]{margin-left:3rem!important}.ms-md-auto[data-v-15445482]{margin-left:auto!important}.p-md-0[data-v-15445482]{padding:0!important}.p-md-1[data-v-15445482]{padding:.25rem!important}.p-md-2[data-v-15445482]{padding:.5rem!important}.p-md-3[data-v-15445482]{padding:1rem!important}.p-md-4[data-v-15445482]{padding:1.5rem!important}.p-md-5[data-v-15445482]{padding:3rem!important}.px-md-0[data-v-15445482]{padding-right:0!important;padding-left:0!important}.px-md-1[data-v-15445482]{padding-right:.25rem!important;padding-left:.25rem!important}.px-md-2[data-v-15445482]{padding-right:.5rem!important;padding-left:.5rem!important}.px-md-3[data-v-15445482]{padding-right:1rem!important;padding-left:1rem!important}.px-md-4[data-v-15445482]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-md-5[data-v-15445482]{padding-right:3rem!important;padding-left:3rem!important}.py-md-0[data-v-15445482]{padding-top:0!important;padding-bottom:0!important}.py-md-1[data-v-15445482]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-md-2[data-v-15445482]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-md-3[data-v-15445482]{padding-top:1rem!important;padding-bottom:1rem!important}.py-md-4[data-v-15445482]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-md-5[data-v-15445482]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-md-0[data-v-15445482]{padding-top:0!important}.pt-md-1[data-v-15445482]{padding-top:.25rem!important}.pt-md-2[data-v-15445482]{padding-top:.5rem!important}.pt-md-3[data-v-15445482]{padding-top:1rem!important}.pt-md-4[data-v-15445482]{padding-top:1.5rem!important}.pt-md-5[data-v-15445482]{padding-top:3rem!important}.pe-md-0[data-v-15445482]{padding-right:0!important}.pe-md-1[data-v-15445482]{padding-right:.25rem!important}.pe-md-2[data-v-15445482]{padding-right:.5rem!important}.pe-md-3[data-v-15445482]{padding-right:1rem!important}.pe-md-4[data-v-15445482]{padding-right:1.5rem!important}.pe-md-5[data-v-15445482]{padding-right:3rem!important}.pb-md-0[data-v-15445482]{padding-bottom:0!important}.pb-md-1[data-v-15445482]{padding-bottom:.25rem!important}.pb-md-2[data-v-15445482]{padding-bottom:.5rem!important}.pb-md-3[data-v-15445482]{padding-bottom:1rem!important}.pb-md-4[data-v-15445482]{padding-bottom:1.5rem!important}.pb-md-5[data-v-15445482]{padding-bottom:3rem!important}.ps-md-0[data-v-15445482]{padding-left:0!important}.ps-md-1[data-v-15445482]{padding-left:.25rem!important}.ps-md-2[data-v-15445482]{padding-left:.5rem!important}.ps-md-3[data-v-15445482]{padding-left:1rem!important}.ps-md-4[data-v-15445482]{padding-left:1.5rem!important}.ps-md-5[data-v-15445482]{padding-left:3rem!important}.text-md-start[data-v-15445482]{text-align:left!important}.text-md-end[data-v-15445482]{text-align:right!important}.text-md-center[data-v-15445482]{text-align:center!important}}@media (min-width:992px){.float-lg-start[data-v-15445482]{float:left!important}.float-lg-end[data-v-15445482]{float:right!important}.float-lg-none[data-v-15445482]{float:none!important}.d-lg-inline[data-v-15445482]{display:inline!important}.d-lg-inline-block[data-v-15445482]{display:inline-block!important}.d-lg-block[data-v-15445482]{display:block!important}.d-lg-grid[data-v-15445482]{display:grid!important}.d-lg-table[data-v-15445482]{display:table!important}.d-lg-table-row[data-v-15445482]{display:table-row!important}.d-lg-table-cell[data-v-15445482]{display:table-cell!important}.d-lg-flex[data-v-15445482]{display:flex!important}.d-lg-inline-flex[data-v-15445482]{display:inline-flex!important}.d-lg-none[data-v-15445482]{display:none!important}.flex-lg-fill[data-v-15445482]{flex:1 1 auto!important}.flex-lg-row[data-v-15445482]{flex-direction:row!important}.flex-lg-column[data-v-15445482]{flex-direction:column!important}.flex-lg-row-reverse[data-v-15445482]{flex-direction:row-reverse!important}.flex-lg-column-reverse[data-v-15445482]{flex-direction:column-reverse!important}.flex-lg-grow-0[data-v-15445482]{flex-grow:0!important}.flex-lg-grow-1[data-v-15445482]{flex-grow:1!important}.flex-lg-shrink-0[data-v-15445482]{flex-shrink:0!important}.flex-lg-shrink-1[data-v-15445482]{flex-shrink:1!important}.flex-lg-wrap[data-v-15445482]{flex-wrap:wrap!important}.flex-lg-nowrap[data-v-15445482]{flex-wrap:nowrap!important}.flex-lg-wrap-reverse[data-v-15445482]{flex-wrap:wrap-reverse!important}.gap-lg-0[data-v-15445482]{gap:0!important}.gap-lg-1[data-v-15445482]{gap:.25rem!important}.gap-lg-2[data-v-15445482]{gap:.5rem!important}.gap-lg-3[data-v-15445482]{gap:1rem!important}.gap-lg-4[data-v-15445482]{gap:1.5rem!important}.gap-lg-5[data-v-15445482]{gap:3rem!important}.justify-content-lg-start[data-v-15445482]{justify-content:flex-start!important}.justify-content-lg-end[data-v-15445482]{justify-content:flex-end!important}.justify-content-lg-center[data-v-15445482]{justify-content:center!important}.justify-content-lg-between[data-v-15445482]{justify-content:space-between!important}.justify-content-lg-around[data-v-15445482]{justify-content:space-around!important}.justify-content-lg-evenly[data-v-15445482]{justify-content:space-evenly!important}.align-items-lg-start[data-v-15445482]{align-items:flex-start!important}.align-items-lg-end[data-v-15445482]{align-items:flex-end!important}.align-items-lg-center[data-v-15445482]{align-items:center!important}.align-items-lg-baseline[data-v-15445482]{align-items:baseline!important}.align-items-lg-stretch[data-v-15445482]{align-items:stretch!important}.align-content-lg-start[data-v-15445482]{align-content:flex-start!important}.align-content-lg-end[data-v-15445482]{align-content:flex-end!important}.align-content-lg-center[data-v-15445482]{align-content:center!important}.align-content-lg-between[data-v-15445482]{align-content:space-between!important}.align-content-lg-around[data-v-15445482]{align-content:space-around!important}.align-content-lg-stretch[data-v-15445482]{align-content:stretch!important}.align-self-lg-auto[data-v-15445482]{align-self:auto!important}.align-self-lg-start[data-v-15445482]{align-self:flex-start!important}.align-self-lg-end[data-v-15445482]{align-self:flex-end!important}.align-self-lg-center[data-v-15445482]{align-self:center!important}.align-self-lg-baseline[data-v-15445482]{align-self:baseline!important}.align-self-lg-stretch[data-v-15445482]{align-self:stretch!important}.order-lg-first[data-v-15445482]{order:-1!important}.order-lg-0[data-v-15445482]{order:0!important}.order-lg-1[data-v-15445482]{order:1!important}.order-lg-2[data-v-15445482]{order:2!important}.order-lg-3[data-v-15445482]{order:3!important}.order-lg-4[data-v-15445482]{order:4!important}.order-lg-5[data-v-15445482]{order:5!important}.order-lg-last[data-v-15445482]{order:6!important}.m-lg-0[data-v-15445482]{margin:0!important}.m-lg-1[data-v-15445482]{margin:.25rem!important}.m-lg-2[data-v-15445482]{margin:.5rem!important}.m-lg-3[data-v-15445482]{margin:1rem!important}.m-lg-4[data-v-15445482]{margin:1.5rem!important}.m-lg-5[data-v-15445482]{margin:3rem!important}.m-lg-auto[data-v-15445482]{margin:auto!important}.mx-lg-0[data-v-15445482]{margin-right:0!important;margin-left:0!important}.mx-lg-1[data-v-15445482]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-lg-2[data-v-15445482]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-lg-3[data-v-15445482]{margin-right:1rem!important;margin-left:1rem!important}.mx-lg-4[data-v-15445482]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-lg-5[data-v-15445482]{margin-right:3rem!important;margin-left:3rem!important}.mx-lg-auto[data-v-15445482]{margin-right:auto!important;margin-left:auto!important}.my-lg-0[data-v-15445482]{margin-top:0!important;margin-bottom:0!important}.my-lg-1[data-v-15445482]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-lg-2[data-v-15445482]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-lg-3[data-v-15445482]{margin-top:1rem!important;margin-bottom:1rem!important}.my-lg-4[data-v-15445482]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-lg-5[data-v-15445482]{margin-top:3rem!important;margin-bottom:3rem!important}.my-lg-auto[data-v-15445482]{margin-top:auto!important;margin-bottom:auto!important}.mt-lg-0[data-v-15445482]{margin-top:0!important}.mt-lg-1[data-v-15445482]{margin-top:.25rem!important}.mt-lg-2[data-v-15445482]{margin-top:.5rem!important}.mt-lg-3[data-v-15445482]{margin-top:1rem!important}.mt-lg-4[data-v-15445482]{margin-top:1.5rem!important}.mt-lg-5[data-v-15445482]{margin-top:3rem!important}.mt-lg-auto[data-v-15445482]{margin-top:auto!important}.me-lg-0[data-v-15445482]{margin-right:0!important}.me-lg-1[data-v-15445482]{margin-right:.25rem!important}.me-lg-2[data-v-15445482]{margin-right:.5rem!important}.me-lg-3[data-v-15445482]{margin-right:1rem!important}.me-lg-4[data-v-15445482]{margin-right:1.5rem!important}.me-lg-5[data-v-15445482]{margin-right:3rem!important}.me-lg-auto[data-v-15445482]{margin-right:auto!important}.mb-lg-0[data-v-15445482]{margin-bottom:0!important}.mb-lg-1[data-v-15445482]{margin-bottom:.25rem!important}.mb-lg-2[data-v-15445482]{margin-bottom:.5rem!important}.mb-lg-3[data-v-15445482]{margin-bottom:1rem!important}.mb-lg-4[data-v-15445482]{margin-bottom:1.5rem!important}.mb-lg-5[data-v-15445482]{margin-bottom:3rem!important}.mb-lg-auto[data-v-15445482]{margin-bottom:auto!important}.ms-lg-0[data-v-15445482]{margin-left:0!important}.ms-lg-1[data-v-15445482]{margin-left:.25rem!important}.ms-lg-2[data-v-15445482]{margin-left:.5rem!important}.ms-lg-3[data-v-15445482]{margin-left:1rem!important}.ms-lg-4[data-v-15445482]{margin-left:1.5rem!important}.ms-lg-5[data-v-15445482]{margin-left:3rem!important}.ms-lg-auto[data-v-15445482]{margin-left:auto!important}.p-lg-0[data-v-15445482]{padding:0!important}.p-lg-1[data-v-15445482]{padding:.25rem!important}.p-lg-2[data-v-15445482]{padding:.5rem!important}.p-lg-3[data-v-15445482]{padding:1rem!important}.p-lg-4[data-v-15445482]{padding:1.5rem!important}.p-lg-5[data-v-15445482]{padding:3rem!important}.px-lg-0[data-v-15445482]{padding-right:0!important;padding-left:0!important}.px-lg-1[data-v-15445482]{padding-right:.25rem!important;padding-left:.25rem!important}.px-lg-2[data-v-15445482]{padding-right:.5rem!important;padding-left:.5rem!important}.px-lg-3[data-v-15445482]{padding-right:1rem!important;padding-left:1rem!important}.px-lg-4[data-v-15445482]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-lg-5[data-v-15445482]{padding-right:3rem!important;padding-left:3rem!important}.py-lg-0[data-v-15445482]{padding-top:0!important;padding-bottom:0!important}.py-lg-1[data-v-15445482]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-lg-2[data-v-15445482]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-lg-3[data-v-15445482]{padding-top:1rem!important;padding-bottom:1rem!important}.py-lg-4[data-v-15445482]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-lg-5[data-v-15445482]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-lg-0[data-v-15445482]{padding-top:0!important}.pt-lg-1[data-v-15445482]{padding-top:.25rem!important}.pt-lg-2[data-v-15445482]{padding-top:.5rem!important}.pt-lg-3[data-v-15445482]{padding-top:1rem!important}.pt-lg-4[data-v-15445482]{padding-top:1.5rem!important}.pt-lg-5[data-v-15445482]{padding-top:3rem!important}.pe-lg-0[data-v-15445482]{padding-right:0!important}.pe-lg-1[data-v-15445482]{padding-right:.25rem!important}.pe-lg-2[data-v-15445482]{padding-right:.5rem!important}.pe-lg-3[data-v-15445482]{padding-right:1rem!important}.pe-lg-4[data-v-15445482]{padding-right:1.5rem!important}.pe-lg-5[data-v-15445482]{padding-right:3rem!important}.pb-lg-0[data-v-15445482]{padding-bottom:0!important}.pb-lg-1[data-v-15445482]{padding-bottom:.25rem!important}.pb-lg-2[data-v-15445482]{padding-bottom:.5rem!important}.pb-lg-3[data-v-15445482]{padding-bottom:1rem!important}.pb-lg-4[data-v-15445482]{padding-bottom:1.5rem!important}.pb-lg-5[data-v-15445482]{padding-bottom:3rem!important}.ps-lg-0[data-v-15445482]{padding-left:0!important}.ps-lg-1[data-v-15445482]{padding-left:.25rem!important}.ps-lg-2[data-v-15445482]{padding-left:.5rem!important}.ps-lg-3[data-v-15445482]{padding-left:1rem!important}.ps-lg-4[data-v-15445482]{padding-left:1.5rem!important}.ps-lg-5[data-v-15445482]{padding-left:3rem!important}.text-lg-start[data-v-15445482]{text-align:left!important}.text-lg-end[data-v-15445482]{text-align:right!important}.text-lg-center[data-v-15445482]{text-align:center!important}}@media (min-width:1200px){.float-xl-start[data-v-15445482]{float:left!important}.float-xl-end[data-v-15445482]{float:right!important}.float-xl-none[data-v-15445482]{float:none!important}.d-xl-inline[data-v-15445482]{display:inline!important}.d-xl-inline-block[data-v-15445482]{display:inline-block!important}.d-xl-block[data-v-15445482]{display:block!important}.d-xl-grid[data-v-15445482]{display:grid!important}.d-xl-table[data-v-15445482]{display:table!important}.d-xl-table-row[data-v-15445482]{display:table-row!important}.d-xl-table-cell[data-v-15445482]{display:table-cell!important}.d-xl-flex[data-v-15445482]{display:flex!important}.d-xl-inline-flex[data-v-15445482]{display:inline-flex!important}.d-xl-none[data-v-15445482]{display:none!important}.flex-xl-fill[data-v-15445482]{flex:1 1 auto!important}.flex-xl-row[data-v-15445482]{flex-direction:row!important}.flex-xl-column[data-v-15445482]{flex-direction:column!important}.flex-xl-row-reverse[data-v-15445482]{flex-direction:row-reverse!important}.flex-xl-column-reverse[data-v-15445482]{flex-direction:column-reverse!important}.flex-xl-grow-0[data-v-15445482]{flex-grow:0!important}.flex-xl-grow-1[data-v-15445482]{flex-grow:1!important}.flex-xl-shrink-0[data-v-15445482]{flex-shrink:0!important}.flex-xl-shrink-1[data-v-15445482]{flex-shrink:1!important}.flex-xl-wrap[data-v-15445482]{flex-wrap:wrap!important}.flex-xl-nowrap[data-v-15445482]{flex-wrap:nowrap!important}.flex-xl-wrap-reverse[data-v-15445482]{flex-wrap:wrap-reverse!important}.gap-xl-0[data-v-15445482]{gap:0!important}.gap-xl-1[data-v-15445482]{gap:.25rem!important}.gap-xl-2[data-v-15445482]{gap:.5rem!important}.gap-xl-3[data-v-15445482]{gap:1rem!important}.gap-xl-4[data-v-15445482]{gap:1.5rem!important}.gap-xl-5[data-v-15445482]{gap:3rem!important}.justify-content-xl-start[data-v-15445482]{justify-content:flex-start!important}.justify-content-xl-end[data-v-15445482]{justify-content:flex-end!important}.justify-content-xl-center[data-v-15445482]{justify-content:center!important}.justify-content-xl-between[data-v-15445482]{justify-content:space-between!important}.justify-content-xl-around[data-v-15445482]{justify-content:space-around!important}.justify-content-xl-evenly[data-v-15445482]{justify-content:space-evenly!important}.align-items-xl-start[data-v-15445482]{align-items:flex-start!important}.align-items-xl-end[data-v-15445482]{align-items:flex-end!important}.align-items-xl-center[data-v-15445482]{align-items:center!important}.align-items-xl-baseline[data-v-15445482]{align-items:baseline!important}.align-items-xl-stretch[data-v-15445482]{align-items:stretch!important}.align-content-xl-start[data-v-15445482]{align-content:flex-start!important}.align-content-xl-end[data-v-15445482]{align-content:flex-end!important}.align-content-xl-center[data-v-15445482]{align-content:center!important}.align-content-xl-between[data-v-15445482]{align-content:space-between!important}.align-content-xl-around[data-v-15445482]{align-content:space-around!important}.align-content-xl-stretch[data-v-15445482]{align-content:stretch!important}.align-self-xl-auto[data-v-15445482]{align-self:auto!important}.align-self-xl-start[data-v-15445482]{align-self:flex-start!important}.align-self-xl-end[data-v-15445482]{align-self:flex-end!important}.align-self-xl-center[data-v-15445482]{align-self:center!important}.align-self-xl-baseline[data-v-15445482]{align-self:baseline!important}.align-self-xl-stretch[data-v-15445482]{align-self:stretch!important}.order-xl-first[data-v-15445482]{order:-1!important}.order-xl-0[data-v-15445482]{order:0!important}.order-xl-1[data-v-15445482]{order:1!important}.order-xl-2[data-v-15445482]{order:2!important}.order-xl-3[data-v-15445482]{order:3!important}.order-xl-4[data-v-15445482]{order:4!important}.order-xl-5[data-v-15445482]{order:5!important}.order-xl-last[data-v-15445482]{order:6!important}.m-xl-0[data-v-15445482]{margin:0!important}.m-xl-1[data-v-15445482]{margin:.25rem!important}.m-xl-2[data-v-15445482]{margin:.5rem!important}.m-xl-3[data-v-15445482]{margin:1rem!important}.m-xl-4[data-v-15445482]{margin:1.5rem!important}.m-xl-5[data-v-15445482]{margin:3rem!important}.m-xl-auto[data-v-15445482]{margin:auto!important}.mx-xl-0[data-v-15445482]{margin-right:0!important;margin-left:0!important}.mx-xl-1[data-v-15445482]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xl-2[data-v-15445482]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xl-3[data-v-15445482]{margin-right:1rem!important;margin-left:1rem!important}.mx-xl-4[data-v-15445482]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xl-5[data-v-15445482]{margin-right:3rem!important;margin-left:3rem!important}.mx-xl-auto[data-v-15445482]{margin-right:auto!important;margin-left:auto!important}.my-xl-0[data-v-15445482]{margin-top:0!important;margin-bottom:0!important}.my-xl-1[data-v-15445482]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xl-2[data-v-15445482]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xl-3[data-v-15445482]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xl-4[data-v-15445482]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xl-5[data-v-15445482]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xl-auto[data-v-15445482]{margin-top:auto!important;margin-bottom:auto!important}.mt-xl-0[data-v-15445482]{margin-top:0!important}.mt-xl-1[data-v-15445482]{margin-top:.25rem!important}.mt-xl-2[data-v-15445482]{margin-top:.5rem!important}.mt-xl-3[data-v-15445482]{margin-top:1rem!important}.mt-xl-4[data-v-15445482]{margin-top:1.5rem!important}.mt-xl-5[data-v-15445482]{margin-top:3rem!important}.mt-xl-auto[data-v-15445482]{margin-top:auto!important}.me-xl-0[data-v-15445482]{margin-right:0!important}.me-xl-1[data-v-15445482]{margin-right:.25rem!important}.me-xl-2[data-v-15445482]{margin-right:.5rem!important}.me-xl-3[data-v-15445482]{margin-right:1rem!important}.me-xl-4[data-v-15445482]{margin-right:1.5rem!important}.me-xl-5[data-v-15445482]{margin-right:3rem!important}.me-xl-auto[data-v-15445482]{margin-right:auto!important}.mb-xl-0[data-v-15445482]{margin-bottom:0!important}.mb-xl-1[data-v-15445482]{margin-bottom:.25rem!important}.mb-xl-2[data-v-15445482]{margin-bottom:.5rem!important}.mb-xl-3[data-v-15445482]{margin-bottom:1rem!important}.mb-xl-4[data-v-15445482]{margin-bottom:1.5rem!important}.mb-xl-5[data-v-15445482]{margin-bottom:3rem!important}.mb-xl-auto[data-v-15445482]{margin-bottom:auto!important}.ms-xl-0[data-v-15445482]{margin-left:0!important}.ms-xl-1[data-v-15445482]{margin-left:.25rem!important}.ms-xl-2[data-v-15445482]{margin-left:.5rem!important}.ms-xl-3[data-v-15445482]{margin-left:1rem!important}.ms-xl-4[data-v-15445482]{margin-left:1.5rem!important}.ms-xl-5[data-v-15445482]{margin-left:3rem!important}.ms-xl-auto[data-v-15445482]{margin-left:auto!important}.p-xl-0[data-v-15445482]{padding:0!important}.p-xl-1[data-v-15445482]{padding:.25rem!important}.p-xl-2[data-v-15445482]{padding:.5rem!important}.p-xl-3[data-v-15445482]{padding:1rem!important}.p-xl-4[data-v-15445482]{padding:1.5rem!important}.p-xl-5[data-v-15445482]{padding:3rem!important}.px-xl-0[data-v-15445482]{padding-right:0!important;padding-left:0!important}.px-xl-1[data-v-15445482]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xl-2[data-v-15445482]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xl-3[data-v-15445482]{padding-right:1rem!important;padding-left:1rem!important}.px-xl-4[data-v-15445482]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xl-5[data-v-15445482]{padding-right:3rem!important;padding-left:3rem!important}.py-xl-0[data-v-15445482]{padding-top:0!important;padding-bottom:0!important}.py-xl-1[data-v-15445482]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xl-2[data-v-15445482]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xl-3[data-v-15445482]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xl-4[data-v-15445482]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xl-5[data-v-15445482]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xl-0[data-v-15445482]{padding-top:0!important}.pt-xl-1[data-v-15445482]{padding-top:.25rem!important}.pt-xl-2[data-v-15445482]{padding-top:.5rem!important}.pt-xl-3[data-v-15445482]{padding-top:1rem!important}.pt-xl-4[data-v-15445482]{padding-top:1.5rem!important}.pt-xl-5[data-v-15445482]{padding-top:3rem!important}.pe-xl-0[data-v-15445482]{padding-right:0!important}.pe-xl-1[data-v-15445482]{padding-right:.25rem!important}.pe-xl-2[data-v-15445482]{padding-right:.5rem!important}.pe-xl-3[data-v-15445482]{padding-right:1rem!important}.pe-xl-4[data-v-15445482]{padding-right:1.5rem!important}.pe-xl-5[data-v-15445482]{padding-right:3rem!important}.pb-xl-0[data-v-15445482]{padding-bottom:0!important}.pb-xl-1[data-v-15445482]{padding-bottom:.25rem!important}.pb-xl-2[data-v-15445482]{padding-bottom:.5rem!important}.pb-xl-3[data-v-15445482]{padding-bottom:1rem!important}.pb-xl-4[data-v-15445482]{padding-bottom:1.5rem!important}.pb-xl-5[data-v-15445482]{padding-bottom:3rem!important}.ps-xl-0[data-v-15445482]{padding-left:0!important}.ps-xl-1[data-v-15445482]{padding-left:.25rem!important}.ps-xl-2[data-v-15445482]{padding-left:.5rem!important}.ps-xl-3[data-v-15445482]{padding-left:1rem!important}.ps-xl-4[data-v-15445482]{padding-left:1.5rem!important}.ps-xl-5[data-v-15445482]{padding-left:3rem!important}.text-xl-start[data-v-15445482]{text-align:left!important}.text-xl-end[data-v-15445482]{text-align:right!important}.text-xl-center[data-v-15445482]{text-align:center!important}}@media (min-width:1400px){.float-xxl-start[data-v-15445482]{float:left!important}.float-xxl-end[data-v-15445482]{float:right!important}.float-xxl-none[data-v-15445482]{float:none!important}.d-xxl-inline[data-v-15445482]{display:inline!important}.d-xxl-inline-block[data-v-15445482]{display:inline-block!important}.d-xxl-block[data-v-15445482]{display:block!important}.d-xxl-grid[data-v-15445482]{display:grid!important}.d-xxl-table[data-v-15445482]{display:table!important}.d-xxl-table-row[data-v-15445482]{display:table-row!important}.d-xxl-table-cell[data-v-15445482]{display:table-cell!important}.d-xxl-flex[data-v-15445482]{display:flex!important}.d-xxl-inline-flex[data-v-15445482]{display:inline-flex!important}.d-xxl-none[data-v-15445482]{display:none!important}.flex-xxl-fill[data-v-15445482]{flex:1 1 auto!important}.flex-xxl-row[data-v-15445482]{flex-direction:row!important}.flex-xxl-column[data-v-15445482]{flex-direction:column!important}.flex-xxl-row-reverse[data-v-15445482]{flex-direction:row-reverse!important}.flex-xxl-column-reverse[data-v-15445482]{flex-direction:column-reverse!important}.flex-xxl-grow-0[data-v-15445482]{flex-grow:0!important}.flex-xxl-grow-1[data-v-15445482]{flex-grow:1!important}.flex-xxl-shrink-0[data-v-15445482]{flex-shrink:0!important}.flex-xxl-shrink-1[data-v-15445482]{flex-shrink:1!important}.flex-xxl-wrap[data-v-15445482]{flex-wrap:wrap!important}.flex-xxl-nowrap[data-v-15445482]{flex-wrap:nowrap!important}.flex-xxl-wrap-reverse[data-v-15445482]{flex-wrap:wrap-reverse!important}.gap-xxl-0[data-v-15445482]{gap:0!important}.gap-xxl-1[data-v-15445482]{gap:.25rem!important}.gap-xxl-2[data-v-15445482]{gap:.5rem!important}.gap-xxl-3[data-v-15445482]{gap:1rem!important}.gap-xxl-4[data-v-15445482]{gap:1.5rem!important}.gap-xxl-5[data-v-15445482]{gap:3rem!important}.justify-content-xxl-start[data-v-15445482]{justify-content:flex-start!important}.justify-content-xxl-end[data-v-15445482]{justify-content:flex-end!important}.justify-content-xxl-center[data-v-15445482]{justify-content:center!important}.justify-content-xxl-between[data-v-15445482]{justify-content:space-between!important}.justify-content-xxl-around[data-v-15445482]{justify-content:space-around!important}.justify-content-xxl-evenly[data-v-15445482]{justify-content:space-evenly!important}.align-items-xxl-start[data-v-15445482]{align-items:flex-start!important}.align-items-xxl-end[data-v-15445482]{align-items:flex-end!important}.align-items-xxl-center[data-v-15445482]{align-items:center!important}.align-items-xxl-baseline[data-v-15445482]{align-items:baseline!important}.align-items-xxl-stretch[data-v-15445482]{align-items:stretch!important}.align-content-xxl-start[data-v-15445482]{align-content:flex-start!important}.align-content-xxl-end[data-v-15445482]{align-content:flex-end!important}.align-content-xxl-center[data-v-15445482]{align-content:center!important}.align-content-xxl-between[data-v-15445482]{align-content:space-between!important}.align-content-xxl-around[data-v-15445482]{align-content:space-around!important}.align-content-xxl-stretch[data-v-15445482]{align-content:stretch!important}.align-self-xxl-auto[data-v-15445482]{align-self:auto!important}.align-self-xxl-start[data-v-15445482]{align-self:flex-start!important}.align-self-xxl-end[data-v-15445482]{align-self:flex-end!important}.align-self-xxl-center[data-v-15445482]{align-self:center!important}.align-self-xxl-baseline[data-v-15445482]{align-self:baseline!important}.align-self-xxl-stretch[data-v-15445482]{align-self:stretch!important}.order-xxl-first[data-v-15445482]{order:-1!important}.order-xxl-0[data-v-15445482]{order:0!important}.order-xxl-1[data-v-15445482]{order:1!important}.order-xxl-2[data-v-15445482]{order:2!important}.order-xxl-3[data-v-15445482]{order:3!important}.order-xxl-4[data-v-15445482]{order:4!important}.order-xxl-5[data-v-15445482]{order:5!important}.order-xxl-last[data-v-15445482]{order:6!important}.m-xxl-0[data-v-15445482]{margin:0!important}.m-xxl-1[data-v-15445482]{margin:.25rem!important}.m-xxl-2[data-v-15445482]{margin:.5rem!important}.m-xxl-3[data-v-15445482]{margin:1rem!important}.m-xxl-4[data-v-15445482]{margin:1.5rem!important}.m-xxl-5[data-v-15445482]{margin:3rem!important}.m-xxl-auto[data-v-15445482]{margin:auto!important}.mx-xxl-0[data-v-15445482]{margin-right:0!important;margin-left:0!important}.mx-xxl-1[data-v-15445482]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xxl-2[data-v-15445482]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xxl-3[data-v-15445482]{margin-right:1rem!important;margin-left:1rem!important}.mx-xxl-4[data-v-15445482]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xxl-5[data-v-15445482]{margin-right:3rem!important;margin-left:3rem!important}.mx-xxl-auto[data-v-15445482]{margin-right:auto!important;margin-left:auto!important}.my-xxl-0[data-v-15445482]{margin-top:0!important;margin-bottom:0!important}.my-xxl-1[data-v-15445482]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xxl-2[data-v-15445482]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xxl-3[data-v-15445482]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xxl-4[data-v-15445482]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xxl-5[data-v-15445482]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xxl-auto[data-v-15445482]{margin-top:auto!important;margin-bottom:auto!important}.mt-xxl-0[data-v-15445482]{margin-top:0!important}.mt-xxl-1[data-v-15445482]{margin-top:.25rem!important}.mt-xxl-2[data-v-15445482]{margin-top:.5rem!important}.mt-xxl-3[data-v-15445482]{margin-top:1rem!important}.mt-xxl-4[data-v-15445482]{margin-top:1.5rem!important}.mt-xxl-5[data-v-15445482]{margin-top:3rem!important}.mt-xxl-auto[data-v-15445482]{margin-top:auto!important}.me-xxl-0[data-v-15445482]{margin-right:0!important}.me-xxl-1[data-v-15445482]{margin-right:.25rem!important}.me-xxl-2[data-v-15445482]{margin-right:.5rem!important}.me-xxl-3[data-v-15445482]{margin-right:1rem!important}.me-xxl-4[data-v-15445482]{margin-right:1.5rem!important}.me-xxl-5[data-v-15445482]{margin-right:3rem!important}.me-xxl-auto[data-v-15445482]{margin-right:auto!important}.mb-xxl-0[data-v-15445482]{margin-bottom:0!important}.mb-xxl-1[data-v-15445482]{margin-bottom:.25rem!important}.mb-xxl-2[data-v-15445482]{margin-bottom:.5rem!important}.mb-xxl-3[data-v-15445482]{margin-bottom:1rem!important}.mb-xxl-4[data-v-15445482]{margin-bottom:1.5rem!important}.mb-xxl-5[data-v-15445482]{margin-bottom:3rem!important}.mb-xxl-auto[data-v-15445482]{margin-bottom:auto!important}.ms-xxl-0[data-v-15445482]{margin-left:0!important}.ms-xxl-1[data-v-15445482]{margin-left:.25rem!important}.ms-xxl-2[data-v-15445482]{margin-left:.5rem!important}.ms-xxl-3[data-v-15445482]{margin-left:1rem!important}.ms-xxl-4[data-v-15445482]{margin-left:1.5rem!important}.ms-xxl-5[data-v-15445482]{margin-left:3rem!important}.ms-xxl-auto[data-v-15445482]{margin-left:auto!important}.p-xxl-0[data-v-15445482]{padding:0!important}.p-xxl-1[data-v-15445482]{padding:.25rem!important}.p-xxl-2[data-v-15445482]{padding:.5rem!important}.p-xxl-3[data-v-15445482]{padding:1rem!important}.p-xxl-4[data-v-15445482]{padding:1.5rem!important}.p-xxl-5[data-v-15445482]{padding:3rem!important}.px-xxl-0[data-v-15445482]{padding-right:0!important;padding-left:0!important}.px-xxl-1[data-v-15445482]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xxl-2[data-v-15445482]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xxl-3[data-v-15445482]{padding-right:1rem!important;padding-left:1rem!important}.px-xxl-4[data-v-15445482]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xxl-5[data-v-15445482]{padding-right:3rem!important;padding-left:3rem!important}.py-xxl-0[data-v-15445482]{padding-top:0!important;padding-bottom:0!important}.py-xxl-1[data-v-15445482]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xxl-2[data-v-15445482]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xxl-3[data-v-15445482]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xxl-4[data-v-15445482]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xxl-5[data-v-15445482]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xxl-0[data-v-15445482]{padding-top:0!important}.pt-xxl-1[data-v-15445482]{padding-top:.25rem!important}.pt-xxl-2[data-v-15445482]{padding-top:.5rem!important}.pt-xxl-3[data-v-15445482]{padding-top:1rem!important}.pt-xxl-4[data-v-15445482]{padding-top:1.5rem!important}.pt-xxl-5[data-v-15445482]{padding-top:3rem!important}.pe-xxl-0[data-v-15445482]{padding-right:0!important}.pe-xxl-1[data-v-15445482]{padding-right:.25rem!important}.pe-xxl-2[data-v-15445482]{padding-right:.5rem!important}.pe-xxl-3[data-v-15445482]{padding-right:1rem!important}.pe-xxl-4[data-v-15445482]{padding-right:1.5rem!important}.pe-xxl-5[data-v-15445482]{padding-right:3rem!important}.pb-xxl-0[data-v-15445482]{padding-bottom:0!important}.pb-xxl-1[data-v-15445482]{padding-bottom:.25rem!important}.pb-xxl-2[data-v-15445482]{padding-bottom:.5rem!important}.pb-xxl-3[data-v-15445482]{padding-bottom:1rem!important}.pb-xxl-4[data-v-15445482]{padding-bottom:1.5rem!important}.pb-xxl-5[data-v-15445482]{padding-bottom:3rem!important}.ps-xxl-0[data-v-15445482]{padding-left:0!important}.ps-xxl-1[data-v-15445482]{padding-left:.25rem!important}.ps-xxl-2[data-v-15445482]{padding-left:.5rem!important}.ps-xxl-3[data-v-15445482]{padding-left:1rem!important}.ps-xxl-4[data-v-15445482]{padding-left:1.5rem!important}.ps-xxl-5[data-v-15445482]{padding-left:3rem!important}.text-xxl-start[data-v-15445482]{text-align:left!important}.text-xxl-end[data-v-15445482]{text-align:right!important}.text-xxl-center[data-v-15445482]{text-align:center!important}}@media (min-width:1200px){.fs-1[data-v-15445482]{font-size:2.5rem!important}.fs-2[data-v-15445482]{font-size:2rem!important}.fs-3[data-v-15445482]{font-size:1.75rem!important}.fs-4[data-v-15445482]{font-size:1.5rem!important}}@media print{.d-print-inline[data-v-15445482]{display:inline!important}.d-print-inline-block[data-v-15445482]{display:inline-block!important}.d-print-block[data-v-15445482]{display:block!important}.d-print-grid[data-v-15445482]{display:grid!important}.d-print-table[data-v-15445482]{display:table!important}.d-print-table-row[data-v-15445482]{display:table-row!important}.d-print-table-cell[data-v-15445482]{display:table-cell!important}.d-print-flex[data-v-15445482]{display:flex!important}.d-print-inline-flex[data-v-15445482]{display:inline-flex!important}.d-print-none[data-v-15445482]{display:none!important}}", ""]);

// exports


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(162);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("c09a84a8", content, true, {});

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".indented[data-v-15445482]{margin:20px;max-width:550px}.spacer[data-v-15445482]{height:25px;border:0 solid #000;clear:both}.smallspacer[data-v-15445482]{height:5px;border:0 solid #000;clear:both}.spaced[data-v-15445482]{margin-bottom:10px}.image[data-v-15445482]{width:90px;float:left;margin-right:20px}.button[data-v-15445482]{border:1px solid gray}.prodname[data-v-15445482]{font-size:10px}.proditem[data-v-15445482]{float:left;margin-right:15px}", ""]);

// exports


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indented"},[_c('h3',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_vm._l((_vm.selectedalternativeproduct),function(product){return _c('div',[_c('div',{staticClass:"form-horizontal"},[_c('h4',[_vm._v("Alternative Product Details")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[_vm._v("\r\n          Name:\r\n          "),_c('div',{staticClass:"col-md-10"},[_vm._v("\r\n            "+_vm._s(product.productname)+"\r\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[_vm._v("\r\n          Description:\r\n          "),_c('div',{staticClass:"col-md-10"},[_vm._v("\r\n            "+_vm._s(product.description)+"\r\n          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[_vm._v("\r\n          Price:\r\n          "),_c('div',{staticClass:"col-md-10"},[_vm._v("\r\n            € "+_vm._s(product.price)+"\r\n          ")])]),_vm._v(" "),_c('div',{staticClass:"spacer"}),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[_vm._v("\r\n          Picture:\r\n          "),_c('div',{staticClass:"col-md-10"},[_c('img',{attrs:{"id":"image","src":_vm.$options.filters.removetilde(product.picture)}})])]),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[_c('div',{staticClass:"spacer"}),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.goBack}},[_vm._v("<< Back")])])])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(165);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7f311582", content, true, {});

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n/*!\n * Bootstrap v5.1.3 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */[data-v-5948ee38]:root{--bs-blue:#0d6efd;--bs-indigo:#6610f2;--bs-purple:#6f42c1;--bs-pink:#d63384;--bs-red:#dc3545;--bs-orange:#fd7e14;--bs-yellow:#ffc107;--bs-green:#198754;--bs-teal:#20c997;--bs-cyan:#0dcaf0;--bs-white:#fff;--bs-gray:#6c757d;--bs-gray-dark:#343a40;--bs-gray-100:#f8f9fa;--bs-gray-200:#e9ecef;--bs-gray-300:#dee2e6;--bs-gray-400:#ced4da;--bs-gray-500:#adb5bd;--bs-gray-600:#6c757d;--bs-gray-700:#495057;--bs-gray-800:#343a40;--bs-gray-900:#212529;--bs-primary:#0d6efd;--bs-secondary:#6c757d;--bs-success:#198754;--bs-info:#0dcaf0;--bs-warning:#ffc107;--bs-danger:#dc3545;--bs-light:#f8f9fa;--bs-dark:#212529;--bs-primary-rgb:13,110,253;--bs-secondary-rgb:108,117,125;--bs-success-rgb:25,135,84;--bs-info-rgb:13,202,240;--bs-warning-rgb:255,193,7;--bs-danger-rgb:220,53,69;--bs-light-rgb:248,249,250;--bs-dark-rgb:33,37,41;--bs-white-rgb:255,255,255;--bs-black-rgb:0,0,0;--bs-body-color-rgb:33,37,41;--bs-body-bg-rgb:255,255,255;--bs-font-sans-serif:system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--bs-font-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;--bs-gradient:linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));--bs-body-font-family:var(--bs-font-sans-serif);--bs-body-font-size:1rem;--bs-body-font-weight:400;--bs-body-line-height:1.5;--bs-body-color:#212529;--bs-body-bg:#fff}[data-v-5948ee38],[data-v-5948ee38]:after,[data-v-5948ee38]:before{box-sizing:border-box}@media (prefers-reduced-motion:no-preference){[data-v-5948ee38]:root{scroll-behavior:smooth}}body[data-v-5948ee38]{margin:0;font-family:var(--bs-body-font-family);font-size:var(--bs-body-font-size);font-weight:var(--bs-body-font-weight);line-height:var(--bs-body-line-height);color:var(--bs-body-color);text-align:var(--bs-body-text-align);background-color:var(--bs-body-bg);-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}hr[data-v-5948ee38]{margin:1rem 0;color:inherit;background-color:currentColor;border:0;opacity:.25}hr[data-v-5948ee38]:not([size]){height:1px}.h1[data-v-5948ee38],.h2[data-v-5948ee38],.h3[data-v-5948ee38],.h4[data-v-5948ee38],.h5[data-v-5948ee38],.h6[data-v-5948ee38],h1[data-v-5948ee38],h2[data-v-5948ee38],h3[data-v-5948ee38],h4[data-v-5948ee38],h5[data-v-5948ee38],h6[data-v-5948ee38]{margin-top:0;margin-bottom:.5rem;font-weight:500;line-height:1.2}.h1[data-v-5948ee38],h1[data-v-5948ee38]{font-size:calc(1.375rem + 1.5vw)}@media (min-width:1200px){.h1[data-v-5948ee38],h1[data-v-5948ee38]{font-size:2.5rem}}.h2[data-v-5948ee38],h2[data-v-5948ee38]{font-size:calc(1.325rem + .9vw)}@media (min-width:1200px){.h2[data-v-5948ee38],h2[data-v-5948ee38]{font-size:2rem}}.h3[data-v-5948ee38],h3[data-v-5948ee38]{font-size:calc(1.3rem + .6vw)}@media (min-width:1200px){.h3[data-v-5948ee38],h3[data-v-5948ee38]{font-size:1.75rem}}.h4[data-v-5948ee38],h4[data-v-5948ee38]{font-size:calc(1.275rem + .3vw)}@media (min-width:1200px){.h4[data-v-5948ee38],h4[data-v-5948ee38]{font-size:1.5rem}}.h5[data-v-5948ee38],h5[data-v-5948ee38]{font-size:1.25rem}.h6[data-v-5948ee38],h6[data-v-5948ee38]{font-size:1rem}p[data-v-5948ee38]{margin-top:0;margin-bottom:1rem}abbr[data-bs-original-title][data-v-5948ee38],abbr[title][data-v-5948ee38]{-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address[data-v-5948ee38]{margin-bottom:1rem;font-style:normal;line-height:inherit}ol[data-v-5948ee38],ul[data-v-5948ee38]{padding-left:2rem}dl[data-v-5948ee38],ol[data-v-5948ee38],ul[data-v-5948ee38]{margin-top:0;margin-bottom:1rem}ol ol[data-v-5948ee38],ol ul[data-v-5948ee38],ul ol[data-v-5948ee38],ul ul[data-v-5948ee38]{margin-bottom:0}dt[data-v-5948ee38]{font-weight:700}dd[data-v-5948ee38]{margin-bottom:.5rem;margin-left:0}blockquote[data-v-5948ee38]{margin:0 0 1rem}b[data-v-5948ee38],strong[data-v-5948ee38]{font-weight:bolder}.small[data-v-5948ee38],small[data-v-5948ee38]{font-size:.875em}.mark[data-v-5948ee38],mark[data-v-5948ee38]{padding:.2em;background-color:#fcf8e3}sub[data-v-5948ee38],sup[data-v-5948ee38]{position:relative;font-size:.75em;line-height:0;vertical-align:baseline}sub[data-v-5948ee38]{bottom:-.25em}sup[data-v-5948ee38]{top:-.5em}a[data-v-5948ee38]{color:#0d6efd;text-decoration:underline}a[data-v-5948ee38]:hover{color:#0a58ca}a[data-v-5948ee38]:not([href]):not([class]),a[data-v-5948ee38]:not([href]):not([class]):hover{color:inherit;text-decoration:none}code[data-v-5948ee38],kbd[data-v-5948ee38],pre[data-v-5948ee38],samp[data-v-5948ee38]{font-family:var(--bs-font-monospace);font-size:1em;direction:ltr;unicode-bidi:bidi-override}pre[data-v-5948ee38]{display:block;margin-top:0;margin-bottom:1rem;overflow:auto;font-size:.875em}pre code[data-v-5948ee38]{font-size:inherit;color:inherit;word-break:normal}code[data-v-5948ee38]{font-size:.875em;color:#d63384;word-wrap:break-word}a>code[data-v-5948ee38]{color:inherit}kbd[data-v-5948ee38]{padding:.2rem .4rem;font-size:.875em;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd[data-v-5948ee38]{padding:0;font-size:1em;font-weight:700}figure[data-v-5948ee38]{margin:0 0 1rem}img[data-v-5948ee38],svg[data-v-5948ee38]{vertical-align:middle}table[data-v-5948ee38]{caption-side:bottom;border-collapse:collapse}caption[data-v-5948ee38]{padding-top:.5rem;padding-bottom:.5rem;color:#6c757d;text-align:left}th[data-v-5948ee38]{text-align:inherit;text-align:-webkit-match-parent}tbody[data-v-5948ee38],td[data-v-5948ee38],tfoot[data-v-5948ee38],th[data-v-5948ee38],thead[data-v-5948ee38],tr[data-v-5948ee38]{border-color:inherit;border-style:solid;border-width:0}label[data-v-5948ee38]{display:inline-block}button[data-v-5948ee38]{border-radius:0}button[data-v-5948ee38]:focus:not(:focus-visible){outline:0}button[data-v-5948ee38],input[data-v-5948ee38],optgroup[data-v-5948ee38],select[data-v-5948ee38],textarea[data-v-5948ee38]{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button[data-v-5948ee38],select[data-v-5948ee38]{text-transform:none}[role=button][data-v-5948ee38]{cursor:pointer}select[data-v-5948ee38]{word-wrap:normal}select[data-v-5948ee38]:disabled{opacity:1}[list][data-v-5948ee38]::-webkit-calendar-picker-indicator{display:none}[type=button][data-v-5948ee38],[type=reset][data-v-5948ee38],[type=submit][data-v-5948ee38],button[data-v-5948ee38]{-webkit-appearance:button}[type=button][data-v-5948ee38]:not(:disabled),[type=reset][data-v-5948ee38]:not(:disabled),[type=submit][data-v-5948ee38]:not(:disabled),button[data-v-5948ee38]:not(:disabled){cursor:pointer}[data-v-5948ee38]::-moz-focus-inner{padding:0;border-style:none}textarea[data-v-5948ee38]{resize:vertical}fieldset[data-v-5948ee38]{min-width:0;padding:0;margin:0;border:0}legend[data-v-5948ee38]{float:left;width:100%;padding:0;margin-bottom:.5rem;font-size:calc(1.275rem + .3vw);line-height:inherit}@media (min-width:1200px){legend[data-v-5948ee38]{font-size:1.5rem}}legend+[data-v-5948ee38]{clear:left}[data-v-5948ee38]::-webkit-datetime-edit-day-field,[data-v-5948ee38]::-webkit-datetime-edit-fields-wrapper,[data-v-5948ee38]::-webkit-datetime-edit-hour-field,[data-v-5948ee38]::-webkit-datetime-edit-minute,[data-v-5948ee38]::-webkit-datetime-edit-month-field,[data-v-5948ee38]::-webkit-datetime-edit-text,[data-v-5948ee38]::-webkit-datetime-edit-year-field{padding:0}[data-v-5948ee38]::-webkit-inner-spin-button{height:auto}[type=search][data-v-5948ee38]{outline-offset:-2px;-webkit-appearance:textfield}[data-v-5948ee38]::-webkit-search-decoration{-webkit-appearance:none}[data-v-5948ee38]::-webkit-color-swatch-wrapper{padding:0}[data-v-5948ee38]::file-selector-button{font:inherit}[data-v-5948ee38]::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output[data-v-5948ee38]{display:inline-block}iframe[data-v-5948ee38]{border:0}summary[data-v-5948ee38]{display:list-item;cursor:pointer}progress[data-v-5948ee38]{vertical-align:baseline}[hidden][data-v-5948ee38]{display:none!important}.lead[data-v-5948ee38]{font-size:1.25rem;font-weight:300}.display-1[data-v-5948ee38]{font-size:calc(1.625rem + 4.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-1[data-v-5948ee38]{font-size:5rem}}.display-2[data-v-5948ee38]{font-size:calc(1.575rem + 3.9vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-2[data-v-5948ee38]{font-size:4.5rem}}.display-3[data-v-5948ee38]{font-size:calc(1.525rem + 3.3vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-3[data-v-5948ee38]{font-size:4rem}}.display-4[data-v-5948ee38]{font-size:calc(1.475rem + 2.7vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-4[data-v-5948ee38]{font-size:3.5rem}}.display-5[data-v-5948ee38]{font-size:calc(1.425rem + 2.1vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-5[data-v-5948ee38]{font-size:3rem}}.display-6[data-v-5948ee38]{font-size:calc(1.375rem + 1.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-6[data-v-5948ee38]{font-size:2.5rem}}.list-inline[data-v-5948ee38],.list-unstyled[data-v-5948ee38]{padding-left:0;list-style:none}.list-inline-item[data-v-5948ee38]{display:inline-block}.list-inline-item[data-v-5948ee38]:not(:last-child){margin-right:.5rem}.initialism[data-v-5948ee38]{font-size:.875em;text-transform:uppercase}.blockquote[data-v-5948ee38]{margin-bottom:1rem;font-size:1.25rem}.blockquote[data-v-5948ee38]>:last-child{margin-bottom:0}.blockquote-footer[data-v-5948ee38]{margin-top:-1rem;margin-bottom:1rem;font-size:.875em;color:#6c757d}.blockquote-footer[data-v-5948ee38]:before{content:\"\\2014\\A0\"}.img-fluid[data-v-5948ee38]{max-width:100%;height:auto}.img-thumbnail[data-v-5948ee38]{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.figure[data-v-5948ee38]{display:inline-block}.figure-img[data-v-5948ee38]{margin-bottom:.5rem;line-height:1}.figure-caption[data-v-5948ee38]{font-size:.875em;color:#6c757d}.container-fluid[data-v-5948ee38],.container-lg[data-v-5948ee38],.container-md[data-v-5948ee38],.container-sm[data-v-5948ee38],.container-xl[data-v-5948ee38],.container-xxl[data-v-5948ee38],.container[data-v-5948ee38]{width:100%;padding-right:var(--bs-gutter-x,.75rem);padding-left:var(--bs-gutter-x,.75rem);margin-right:auto;margin-left:auto}@media (min-width:576px){.container-sm[data-v-5948ee38],.container[data-v-5948ee38]{max-width:540px}}@media (min-width:768px){.container-md[data-v-5948ee38],.container-sm[data-v-5948ee38],.container[data-v-5948ee38]{max-width:720px}}@media (min-width:992px){.container-lg[data-v-5948ee38],.container-md[data-v-5948ee38],.container-sm[data-v-5948ee38],.container[data-v-5948ee38]{max-width:960px}}@media (min-width:1200px){.container-lg[data-v-5948ee38],.container-md[data-v-5948ee38],.container-sm[data-v-5948ee38],.container-xl[data-v-5948ee38],.container[data-v-5948ee38]{max-width:1140px}}@media (min-width:1400px){.container-lg[data-v-5948ee38],.container-md[data-v-5948ee38],.container-sm[data-v-5948ee38],.container-xl[data-v-5948ee38],.container-xxl[data-v-5948ee38],.container[data-v-5948ee38]{max-width:1320px}}.row[data-v-5948ee38]{--bs-gutter-x:1.5rem;--bs-gutter-y:0;display:flex;flex-wrap:wrap;margin-top:calc(-1 * var(--bs-gutter-y));margin-right:calc(-.5 * var(--bs-gutter-x));margin-left:calc(-.5 * var(--bs-gutter-x))}.row>[data-v-5948ee38]{flex-shrink:0;width:100%;max-width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-top:var(--bs-gutter-y)}.col[data-v-5948ee38]{flex:1 0 0%}.row-cols-auto>[data-v-5948ee38]{flex:0 0 auto;width:auto}.row-cols-1>[data-v-5948ee38]{flex:0 0 auto;width:100%}.row-cols-2>[data-v-5948ee38]{flex:0 0 auto;width:50%}.row-cols-3>[data-v-5948ee38]{flex:0 0 auto;width:33.3333333333%}.row-cols-4>[data-v-5948ee38]{flex:0 0 auto;width:25%}.row-cols-5>[data-v-5948ee38]{flex:0 0 auto;width:20%}.row-cols-6>[data-v-5948ee38]{flex:0 0 auto;width:16.6666666667%}.col-auto[data-v-5948ee38]{flex:0 0 auto;width:auto}.col-1[data-v-5948ee38]{flex:0 0 auto;width:8.33333333%}.col-2[data-v-5948ee38]{flex:0 0 auto;width:16.66666667%}.col-3[data-v-5948ee38]{flex:0 0 auto;width:25%}.col-4[data-v-5948ee38]{flex:0 0 auto;width:33.33333333%}.col-5[data-v-5948ee38]{flex:0 0 auto;width:41.66666667%}.col-6[data-v-5948ee38]{flex:0 0 auto;width:50%}.col-7[data-v-5948ee38]{flex:0 0 auto;width:58.33333333%}.col-8[data-v-5948ee38]{flex:0 0 auto;width:66.66666667%}.col-9[data-v-5948ee38]{flex:0 0 auto;width:75%}.col-10[data-v-5948ee38]{flex:0 0 auto;width:83.33333333%}.col-11[data-v-5948ee38]{flex:0 0 auto;width:91.66666667%}.col-12[data-v-5948ee38]{flex:0 0 auto;width:100%}.offset-1[data-v-5948ee38]{margin-left:8.33333333%}.offset-2[data-v-5948ee38]{margin-left:16.66666667%}.offset-3[data-v-5948ee38]{margin-left:25%}.offset-4[data-v-5948ee38]{margin-left:33.33333333%}.offset-5[data-v-5948ee38]{margin-left:41.66666667%}.offset-6[data-v-5948ee38]{margin-left:50%}.offset-7[data-v-5948ee38]{margin-left:58.33333333%}.offset-8[data-v-5948ee38]{margin-left:66.66666667%}.offset-9[data-v-5948ee38]{margin-left:75%}.offset-10[data-v-5948ee38]{margin-left:83.33333333%}.offset-11[data-v-5948ee38]{margin-left:91.66666667%}.g-0[data-v-5948ee38],.gx-0[data-v-5948ee38]{--bs-gutter-x:0}.g-0[data-v-5948ee38],.gy-0[data-v-5948ee38]{--bs-gutter-y:0}.g-1[data-v-5948ee38],.gx-1[data-v-5948ee38]{--bs-gutter-x:0.25rem}.g-1[data-v-5948ee38],.gy-1[data-v-5948ee38]{--bs-gutter-y:0.25rem}.g-2[data-v-5948ee38],.gx-2[data-v-5948ee38]{--bs-gutter-x:0.5rem}.g-2[data-v-5948ee38],.gy-2[data-v-5948ee38]{--bs-gutter-y:0.5rem}.g-3[data-v-5948ee38],.gx-3[data-v-5948ee38]{--bs-gutter-x:1rem}.g-3[data-v-5948ee38],.gy-3[data-v-5948ee38]{--bs-gutter-y:1rem}.g-4[data-v-5948ee38],.gx-4[data-v-5948ee38]{--bs-gutter-x:1.5rem}.g-4[data-v-5948ee38],.gy-4[data-v-5948ee38]{--bs-gutter-y:1.5rem}.g-5[data-v-5948ee38],.gx-5[data-v-5948ee38]{--bs-gutter-x:3rem}.g-5[data-v-5948ee38],.gy-5[data-v-5948ee38]{--bs-gutter-y:3rem}@media (min-width:576px){.col-sm[data-v-5948ee38]{flex:1 0 0%}.row-cols-sm-auto>[data-v-5948ee38]{flex:0 0 auto;width:auto}.row-cols-sm-1>[data-v-5948ee38]{flex:0 0 auto;width:100%}.row-cols-sm-2>[data-v-5948ee38]{flex:0 0 auto;width:50%}.row-cols-sm-3>[data-v-5948ee38]{flex:0 0 auto;width:33.3333333333%}.row-cols-sm-4>[data-v-5948ee38]{flex:0 0 auto;width:25%}.row-cols-sm-5>[data-v-5948ee38]{flex:0 0 auto;width:20%}.row-cols-sm-6>[data-v-5948ee38]{flex:0 0 auto;width:16.6666666667%}.col-sm-auto[data-v-5948ee38]{flex:0 0 auto;width:auto}.col-sm-1[data-v-5948ee38]{flex:0 0 auto;width:8.33333333%}.col-sm-2[data-v-5948ee38]{flex:0 0 auto;width:16.66666667%}.col-sm-3[data-v-5948ee38]{flex:0 0 auto;width:25%}.col-sm-4[data-v-5948ee38]{flex:0 0 auto;width:33.33333333%}.col-sm-5[data-v-5948ee38]{flex:0 0 auto;width:41.66666667%}.col-sm-6[data-v-5948ee38]{flex:0 0 auto;width:50%}.col-sm-7[data-v-5948ee38]{flex:0 0 auto;width:58.33333333%}.col-sm-8[data-v-5948ee38]{flex:0 0 auto;width:66.66666667%}.col-sm-9[data-v-5948ee38]{flex:0 0 auto;width:75%}.col-sm-10[data-v-5948ee38]{flex:0 0 auto;width:83.33333333%}.col-sm-11[data-v-5948ee38]{flex:0 0 auto;width:91.66666667%}.col-sm-12[data-v-5948ee38]{flex:0 0 auto;width:100%}.offset-sm-0[data-v-5948ee38]{margin-left:0}.offset-sm-1[data-v-5948ee38]{margin-left:8.33333333%}.offset-sm-2[data-v-5948ee38]{margin-left:16.66666667%}.offset-sm-3[data-v-5948ee38]{margin-left:25%}.offset-sm-4[data-v-5948ee38]{margin-left:33.33333333%}.offset-sm-5[data-v-5948ee38]{margin-left:41.66666667%}.offset-sm-6[data-v-5948ee38]{margin-left:50%}.offset-sm-7[data-v-5948ee38]{margin-left:58.33333333%}.offset-sm-8[data-v-5948ee38]{margin-left:66.66666667%}.offset-sm-9[data-v-5948ee38]{margin-left:75%}.offset-sm-10[data-v-5948ee38]{margin-left:83.33333333%}.offset-sm-11[data-v-5948ee38]{margin-left:91.66666667%}.g-sm-0[data-v-5948ee38],.gx-sm-0[data-v-5948ee38]{--bs-gutter-x:0}.g-sm-0[data-v-5948ee38],.gy-sm-0[data-v-5948ee38]{--bs-gutter-y:0}.g-sm-1[data-v-5948ee38],.gx-sm-1[data-v-5948ee38]{--bs-gutter-x:0.25rem}.g-sm-1[data-v-5948ee38],.gy-sm-1[data-v-5948ee38]{--bs-gutter-y:0.25rem}.g-sm-2[data-v-5948ee38],.gx-sm-2[data-v-5948ee38]{--bs-gutter-x:0.5rem}.g-sm-2[data-v-5948ee38],.gy-sm-2[data-v-5948ee38]{--bs-gutter-y:0.5rem}.g-sm-3[data-v-5948ee38],.gx-sm-3[data-v-5948ee38]{--bs-gutter-x:1rem}.g-sm-3[data-v-5948ee38],.gy-sm-3[data-v-5948ee38]{--bs-gutter-y:1rem}.g-sm-4[data-v-5948ee38],.gx-sm-4[data-v-5948ee38]{--bs-gutter-x:1.5rem}.g-sm-4[data-v-5948ee38],.gy-sm-4[data-v-5948ee38]{--bs-gutter-y:1.5rem}.g-sm-5[data-v-5948ee38],.gx-sm-5[data-v-5948ee38]{--bs-gutter-x:3rem}.g-sm-5[data-v-5948ee38],.gy-sm-5[data-v-5948ee38]{--bs-gutter-y:3rem}}@media (min-width:768px){.col-md[data-v-5948ee38]{flex:1 0 0%}.row-cols-md-auto>[data-v-5948ee38]{flex:0 0 auto;width:auto}.row-cols-md-1>[data-v-5948ee38]{flex:0 0 auto;width:100%}.row-cols-md-2>[data-v-5948ee38]{flex:0 0 auto;width:50%}.row-cols-md-3>[data-v-5948ee38]{flex:0 0 auto;width:33.3333333333%}.row-cols-md-4>[data-v-5948ee38]{flex:0 0 auto;width:25%}.row-cols-md-5>[data-v-5948ee38]{flex:0 0 auto;width:20%}.row-cols-md-6>[data-v-5948ee38]{flex:0 0 auto;width:16.6666666667%}.col-md-auto[data-v-5948ee38]{flex:0 0 auto;width:auto}.col-md-1[data-v-5948ee38]{flex:0 0 auto;width:8.33333333%}.col-md-2[data-v-5948ee38]{flex:0 0 auto;width:16.66666667%}.col-md-3[data-v-5948ee38]{flex:0 0 auto;width:25%}.col-md-4[data-v-5948ee38]{flex:0 0 auto;width:33.33333333%}.col-md-5[data-v-5948ee38]{flex:0 0 auto;width:41.66666667%}.col-md-6[data-v-5948ee38]{flex:0 0 auto;width:50%}.col-md-7[data-v-5948ee38]{flex:0 0 auto;width:58.33333333%}.col-md-8[data-v-5948ee38]{flex:0 0 auto;width:66.66666667%}.col-md-9[data-v-5948ee38]{flex:0 0 auto;width:75%}.col-md-10[data-v-5948ee38]{flex:0 0 auto;width:83.33333333%}.col-md-11[data-v-5948ee38]{flex:0 0 auto;width:91.66666667%}.col-md-12[data-v-5948ee38]{flex:0 0 auto;width:100%}.offset-md-0[data-v-5948ee38]{margin-left:0}.offset-md-1[data-v-5948ee38]{margin-left:8.33333333%}.offset-md-2[data-v-5948ee38]{margin-left:16.66666667%}.offset-md-3[data-v-5948ee38]{margin-left:25%}.offset-md-4[data-v-5948ee38]{margin-left:33.33333333%}.offset-md-5[data-v-5948ee38]{margin-left:41.66666667%}.offset-md-6[data-v-5948ee38]{margin-left:50%}.offset-md-7[data-v-5948ee38]{margin-left:58.33333333%}.offset-md-8[data-v-5948ee38]{margin-left:66.66666667%}.offset-md-9[data-v-5948ee38]{margin-left:75%}.offset-md-10[data-v-5948ee38]{margin-left:83.33333333%}.offset-md-11[data-v-5948ee38]{margin-left:91.66666667%}.g-md-0[data-v-5948ee38],.gx-md-0[data-v-5948ee38]{--bs-gutter-x:0}.g-md-0[data-v-5948ee38],.gy-md-0[data-v-5948ee38]{--bs-gutter-y:0}.g-md-1[data-v-5948ee38],.gx-md-1[data-v-5948ee38]{--bs-gutter-x:0.25rem}.g-md-1[data-v-5948ee38],.gy-md-1[data-v-5948ee38]{--bs-gutter-y:0.25rem}.g-md-2[data-v-5948ee38],.gx-md-2[data-v-5948ee38]{--bs-gutter-x:0.5rem}.g-md-2[data-v-5948ee38],.gy-md-2[data-v-5948ee38]{--bs-gutter-y:0.5rem}.g-md-3[data-v-5948ee38],.gx-md-3[data-v-5948ee38]{--bs-gutter-x:1rem}.g-md-3[data-v-5948ee38],.gy-md-3[data-v-5948ee38]{--bs-gutter-y:1rem}.g-md-4[data-v-5948ee38],.gx-md-4[data-v-5948ee38]{--bs-gutter-x:1.5rem}.g-md-4[data-v-5948ee38],.gy-md-4[data-v-5948ee38]{--bs-gutter-y:1.5rem}.g-md-5[data-v-5948ee38],.gx-md-5[data-v-5948ee38]{--bs-gutter-x:3rem}.g-md-5[data-v-5948ee38],.gy-md-5[data-v-5948ee38]{--bs-gutter-y:3rem}}@media (min-width:992px){.col-lg[data-v-5948ee38]{flex:1 0 0%}.row-cols-lg-auto>[data-v-5948ee38]{flex:0 0 auto;width:auto}.row-cols-lg-1>[data-v-5948ee38]{flex:0 0 auto;width:100%}.row-cols-lg-2>[data-v-5948ee38]{flex:0 0 auto;width:50%}.row-cols-lg-3>[data-v-5948ee38]{flex:0 0 auto;width:33.3333333333%}.row-cols-lg-4>[data-v-5948ee38]{flex:0 0 auto;width:25%}.row-cols-lg-5>[data-v-5948ee38]{flex:0 0 auto;width:20%}.row-cols-lg-6>[data-v-5948ee38]{flex:0 0 auto;width:16.6666666667%}.col-lg-auto[data-v-5948ee38]{flex:0 0 auto;width:auto}.col-lg-1[data-v-5948ee38]{flex:0 0 auto;width:8.33333333%}.col-lg-2[data-v-5948ee38]{flex:0 0 auto;width:16.66666667%}.col-lg-3[data-v-5948ee38]{flex:0 0 auto;width:25%}.col-lg-4[data-v-5948ee38]{flex:0 0 auto;width:33.33333333%}.col-lg-5[data-v-5948ee38]{flex:0 0 auto;width:41.66666667%}.col-lg-6[data-v-5948ee38]{flex:0 0 auto;width:50%}.col-lg-7[data-v-5948ee38]{flex:0 0 auto;width:58.33333333%}.col-lg-8[data-v-5948ee38]{flex:0 0 auto;width:66.66666667%}.col-lg-9[data-v-5948ee38]{flex:0 0 auto;width:75%}.col-lg-10[data-v-5948ee38]{flex:0 0 auto;width:83.33333333%}.col-lg-11[data-v-5948ee38]{flex:0 0 auto;width:91.66666667%}.col-lg-12[data-v-5948ee38]{flex:0 0 auto;width:100%}.offset-lg-0[data-v-5948ee38]{margin-left:0}.offset-lg-1[data-v-5948ee38]{margin-left:8.33333333%}.offset-lg-2[data-v-5948ee38]{margin-left:16.66666667%}.offset-lg-3[data-v-5948ee38]{margin-left:25%}.offset-lg-4[data-v-5948ee38]{margin-left:33.33333333%}.offset-lg-5[data-v-5948ee38]{margin-left:41.66666667%}.offset-lg-6[data-v-5948ee38]{margin-left:50%}.offset-lg-7[data-v-5948ee38]{margin-left:58.33333333%}.offset-lg-8[data-v-5948ee38]{margin-left:66.66666667%}.offset-lg-9[data-v-5948ee38]{margin-left:75%}.offset-lg-10[data-v-5948ee38]{margin-left:83.33333333%}.offset-lg-11[data-v-5948ee38]{margin-left:91.66666667%}.g-lg-0[data-v-5948ee38],.gx-lg-0[data-v-5948ee38]{--bs-gutter-x:0}.g-lg-0[data-v-5948ee38],.gy-lg-0[data-v-5948ee38]{--bs-gutter-y:0}.g-lg-1[data-v-5948ee38],.gx-lg-1[data-v-5948ee38]{--bs-gutter-x:0.25rem}.g-lg-1[data-v-5948ee38],.gy-lg-1[data-v-5948ee38]{--bs-gutter-y:0.25rem}.g-lg-2[data-v-5948ee38],.gx-lg-2[data-v-5948ee38]{--bs-gutter-x:0.5rem}.g-lg-2[data-v-5948ee38],.gy-lg-2[data-v-5948ee38]{--bs-gutter-y:0.5rem}.g-lg-3[data-v-5948ee38],.gx-lg-3[data-v-5948ee38]{--bs-gutter-x:1rem}.g-lg-3[data-v-5948ee38],.gy-lg-3[data-v-5948ee38]{--bs-gutter-y:1rem}.g-lg-4[data-v-5948ee38],.gx-lg-4[data-v-5948ee38]{--bs-gutter-x:1.5rem}.g-lg-4[data-v-5948ee38],.gy-lg-4[data-v-5948ee38]{--bs-gutter-y:1.5rem}.g-lg-5[data-v-5948ee38],.gx-lg-5[data-v-5948ee38]{--bs-gutter-x:3rem}.g-lg-5[data-v-5948ee38],.gy-lg-5[data-v-5948ee38]{--bs-gutter-y:3rem}}@media (min-width:1200px){.col-xl[data-v-5948ee38]{flex:1 0 0%}.row-cols-xl-auto>[data-v-5948ee38]{flex:0 0 auto;width:auto}.row-cols-xl-1>[data-v-5948ee38]{flex:0 0 auto;width:100%}.row-cols-xl-2>[data-v-5948ee38]{flex:0 0 auto;width:50%}.row-cols-xl-3>[data-v-5948ee38]{flex:0 0 auto;width:33.3333333333%}.row-cols-xl-4>[data-v-5948ee38]{flex:0 0 auto;width:25%}.row-cols-xl-5>[data-v-5948ee38]{flex:0 0 auto;width:20%}.row-cols-xl-6>[data-v-5948ee38]{flex:0 0 auto;width:16.6666666667%}.col-xl-auto[data-v-5948ee38]{flex:0 0 auto;width:auto}.col-xl-1[data-v-5948ee38]{flex:0 0 auto;width:8.33333333%}.col-xl-2[data-v-5948ee38]{flex:0 0 auto;width:16.66666667%}.col-xl-3[data-v-5948ee38]{flex:0 0 auto;width:25%}.col-xl-4[data-v-5948ee38]{flex:0 0 auto;width:33.33333333%}.col-xl-5[data-v-5948ee38]{flex:0 0 auto;width:41.66666667%}.col-xl-6[data-v-5948ee38]{flex:0 0 auto;width:50%}.col-xl-7[data-v-5948ee38]{flex:0 0 auto;width:58.33333333%}.col-xl-8[data-v-5948ee38]{flex:0 0 auto;width:66.66666667%}.col-xl-9[data-v-5948ee38]{flex:0 0 auto;width:75%}.col-xl-10[data-v-5948ee38]{flex:0 0 auto;width:83.33333333%}.col-xl-11[data-v-5948ee38]{flex:0 0 auto;width:91.66666667%}.col-xl-12[data-v-5948ee38]{flex:0 0 auto;width:100%}.offset-xl-0[data-v-5948ee38]{margin-left:0}.offset-xl-1[data-v-5948ee38]{margin-left:8.33333333%}.offset-xl-2[data-v-5948ee38]{margin-left:16.66666667%}.offset-xl-3[data-v-5948ee38]{margin-left:25%}.offset-xl-4[data-v-5948ee38]{margin-left:33.33333333%}.offset-xl-5[data-v-5948ee38]{margin-left:41.66666667%}.offset-xl-6[data-v-5948ee38]{margin-left:50%}.offset-xl-7[data-v-5948ee38]{margin-left:58.33333333%}.offset-xl-8[data-v-5948ee38]{margin-left:66.66666667%}.offset-xl-9[data-v-5948ee38]{margin-left:75%}.offset-xl-10[data-v-5948ee38]{margin-left:83.33333333%}.offset-xl-11[data-v-5948ee38]{margin-left:91.66666667%}.g-xl-0[data-v-5948ee38],.gx-xl-0[data-v-5948ee38]{--bs-gutter-x:0}.g-xl-0[data-v-5948ee38],.gy-xl-0[data-v-5948ee38]{--bs-gutter-y:0}.g-xl-1[data-v-5948ee38],.gx-xl-1[data-v-5948ee38]{--bs-gutter-x:0.25rem}.g-xl-1[data-v-5948ee38],.gy-xl-1[data-v-5948ee38]{--bs-gutter-y:0.25rem}.g-xl-2[data-v-5948ee38],.gx-xl-2[data-v-5948ee38]{--bs-gutter-x:0.5rem}.g-xl-2[data-v-5948ee38],.gy-xl-2[data-v-5948ee38]{--bs-gutter-y:0.5rem}.g-xl-3[data-v-5948ee38],.gx-xl-3[data-v-5948ee38]{--bs-gutter-x:1rem}.g-xl-3[data-v-5948ee38],.gy-xl-3[data-v-5948ee38]{--bs-gutter-y:1rem}.g-xl-4[data-v-5948ee38],.gx-xl-4[data-v-5948ee38]{--bs-gutter-x:1.5rem}.g-xl-4[data-v-5948ee38],.gy-xl-4[data-v-5948ee38]{--bs-gutter-y:1.5rem}.g-xl-5[data-v-5948ee38],.gx-xl-5[data-v-5948ee38]{--bs-gutter-x:3rem}.g-xl-5[data-v-5948ee38],.gy-xl-5[data-v-5948ee38]{--bs-gutter-y:3rem}}@media (min-width:1400px){.col-xxl[data-v-5948ee38]{flex:1 0 0%}.row-cols-xxl-auto>[data-v-5948ee38]{flex:0 0 auto;width:auto}.row-cols-xxl-1>[data-v-5948ee38]{flex:0 0 auto;width:100%}.row-cols-xxl-2>[data-v-5948ee38]{flex:0 0 auto;width:50%}.row-cols-xxl-3>[data-v-5948ee38]{flex:0 0 auto;width:33.3333333333%}.row-cols-xxl-4>[data-v-5948ee38]{flex:0 0 auto;width:25%}.row-cols-xxl-5>[data-v-5948ee38]{flex:0 0 auto;width:20%}.row-cols-xxl-6>[data-v-5948ee38]{flex:0 0 auto;width:16.6666666667%}.col-xxl-auto[data-v-5948ee38]{flex:0 0 auto;width:auto}.col-xxl-1[data-v-5948ee38]{flex:0 0 auto;width:8.33333333%}.col-xxl-2[data-v-5948ee38]{flex:0 0 auto;width:16.66666667%}.col-xxl-3[data-v-5948ee38]{flex:0 0 auto;width:25%}.col-xxl-4[data-v-5948ee38]{flex:0 0 auto;width:33.33333333%}.col-xxl-5[data-v-5948ee38]{flex:0 0 auto;width:41.66666667%}.col-xxl-6[data-v-5948ee38]{flex:0 0 auto;width:50%}.col-xxl-7[data-v-5948ee38]{flex:0 0 auto;width:58.33333333%}.col-xxl-8[data-v-5948ee38]{flex:0 0 auto;width:66.66666667%}.col-xxl-9[data-v-5948ee38]{flex:0 0 auto;width:75%}.col-xxl-10[data-v-5948ee38]{flex:0 0 auto;width:83.33333333%}.col-xxl-11[data-v-5948ee38]{flex:0 0 auto;width:91.66666667%}.col-xxl-12[data-v-5948ee38]{flex:0 0 auto;width:100%}.offset-xxl-0[data-v-5948ee38]{margin-left:0}.offset-xxl-1[data-v-5948ee38]{margin-left:8.33333333%}.offset-xxl-2[data-v-5948ee38]{margin-left:16.66666667%}.offset-xxl-3[data-v-5948ee38]{margin-left:25%}.offset-xxl-4[data-v-5948ee38]{margin-left:33.33333333%}.offset-xxl-5[data-v-5948ee38]{margin-left:41.66666667%}.offset-xxl-6[data-v-5948ee38]{margin-left:50%}.offset-xxl-7[data-v-5948ee38]{margin-left:58.33333333%}.offset-xxl-8[data-v-5948ee38]{margin-left:66.66666667%}.offset-xxl-9[data-v-5948ee38]{margin-left:75%}.offset-xxl-10[data-v-5948ee38]{margin-left:83.33333333%}.offset-xxl-11[data-v-5948ee38]{margin-left:91.66666667%}.g-xxl-0[data-v-5948ee38],.gx-xxl-0[data-v-5948ee38]{--bs-gutter-x:0}.g-xxl-0[data-v-5948ee38],.gy-xxl-0[data-v-5948ee38]{--bs-gutter-y:0}.g-xxl-1[data-v-5948ee38],.gx-xxl-1[data-v-5948ee38]{--bs-gutter-x:0.25rem}.g-xxl-1[data-v-5948ee38],.gy-xxl-1[data-v-5948ee38]{--bs-gutter-y:0.25rem}.g-xxl-2[data-v-5948ee38],.gx-xxl-2[data-v-5948ee38]{--bs-gutter-x:0.5rem}.g-xxl-2[data-v-5948ee38],.gy-xxl-2[data-v-5948ee38]{--bs-gutter-y:0.5rem}.g-xxl-3[data-v-5948ee38],.gx-xxl-3[data-v-5948ee38]{--bs-gutter-x:1rem}.g-xxl-3[data-v-5948ee38],.gy-xxl-3[data-v-5948ee38]{--bs-gutter-y:1rem}.g-xxl-4[data-v-5948ee38],.gx-xxl-4[data-v-5948ee38]{--bs-gutter-x:1.5rem}.g-xxl-4[data-v-5948ee38],.gy-xxl-4[data-v-5948ee38]{--bs-gutter-y:1.5rem}.g-xxl-5[data-v-5948ee38],.gx-xxl-5[data-v-5948ee38]{--bs-gutter-x:3rem}.g-xxl-5[data-v-5948ee38],.gy-xxl-5[data-v-5948ee38]{--bs-gutter-y:3rem}}.table[data-v-5948ee38]{--bs-table-bg:transparent;--bs-table-accent-bg:transparent;--bs-table-striped-color:#212529;--bs-table-striped-bg:rgba(0,0,0,.05);--bs-table-active-color:#212529;--bs-table-active-bg:rgba(0,0,0,.1);--bs-table-hover-color:#212529;--bs-table-hover-bg:rgba(0,0,0,.075);width:100%;margin-bottom:1rem;color:#212529;vertical-align:top;border-color:#dee2e6}.table>:not(caption)>*>[data-v-5948ee38]{padding:.5rem;background-color:var(--bs-table-bg);border-bottom-width:1px;box-shadow:inset 0 0 0 9999px var(--bs-table-accent-bg)}.table>tbody[data-v-5948ee38]{vertical-align:inherit}.table>thead[data-v-5948ee38]{vertical-align:bottom}.table[data-v-5948ee38]>:not(:first-child){border-top:2px solid currentColor}.caption-top[data-v-5948ee38]{caption-side:top}.table-sm>:not(caption)>*>[data-v-5948ee38]{padding:.25rem}.table-bordered>:not(caption)>[data-v-5948ee38]{border-width:1px 0}.table-bordered>:not(caption)>*>[data-v-5948ee38]{border-width:0 1px}.table-borderless>:not(caption)>*>[data-v-5948ee38]{border-bottom-width:0}.table-borderless[data-v-5948ee38]>:not(:first-child){border-top-width:0}.table-striped>tbody>tr:nth-of-type(odd)>[data-v-5948ee38]{--bs-table-accent-bg:var(--bs-table-striped-bg);color:var(--bs-table-striped-color)}.table-active[data-v-5948ee38]{--bs-table-accent-bg:var(--bs-table-active-bg);color:var(--bs-table-active-color)}.table-hover>tbody>tr:hover>[data-v-5948ee38]{--bs-table-accent-bg:var(--bs-table-hover-bg);color:var(--bs-table-hover-color)}.table-primary[data-v-5948ee38]{--bs-table-bg:#cfe2ff;--bs-table-striped-bg:#c5d7f2;--bs-table-striped-color:#000;--bs-table-active-bg:#bacbe6;--bs-table-active-color:#000;--bs-table-hover-bg:#bfd1ec;--bs-table-hover-color:#000;color:#000;border-color:#bacbe6}.table-secondary[data-v-5948ee38]{--bs-table-bg:#e2e3e5;--bs-table-striped-bg:#d7d8da;--bs-table-striped-color:#000;--bs-table-active-bg:#cbccce;--bs-table-active-color:#000;--bs-table-hover-bg:#d1d2d4;--bs-table-hover-color:#000;color:#000;border-color:#cbccce}.table-success[data-v-5948ee38]{--bs-table-bg:#d1e7dd;--bs-table-striped-bg:#c7dbd2;--bs-table-striped-color:#000;--bs-table-active-bg:#bcd0c7;--bs-table-active-color:#000;--bs-table-hover-bg:#c1d6cc;--bs-table-hover-color:#000;color:#000;border-color:#bcd0c7}.table-info[data-v-5948ee38]{--bs-table-bg:#cff4fc;--bs-table-striped-bg:#c5e8ef;--bs-table-striped-color:#000;--bs-table-active-bg:#badce3;--bs-table-active-color:#000;--bs-table-hover-bg:#bfe2e9;--bs-table-hover-color:#000;color:#000;border-color:#badce3}.table-warning[data-v-5948ee38]{--bs-table-bg:#fff3cd;--bs-table-striped-bg:#f2e7c3;--bs-table-striped-color:#000;--bs-table-active-bg:#e6dbb9;--bs-table-active-color:#000;--bs-table-hover-bg:#ece1be;--bs-table-hover-color:#000;color:#000;border-color:#e6dbb9}.table-danger[data-v-5948ee38]{--bs-table-bg:#f8d7da;--bs-table-striped-bg:#eccccf;--bs-table-striped-color:#000;--bs-table-active-bg:#dfc2c4;--bs-table-active-color:#000;--bs-table-hover-bg:#e5c7ca;--bs-table-hover-color:#000;color:#000;border-color:#dfc2c4}.table-light[data-v-5948ee38]{--bs-table-bg:#f8f9fa;--bs-table-striped-bg:#ecedee;--bs-table-striped-color:#000;--bs-table-active-bg:#dfe0e1;--bs-table-active-color:#000;--bs-table-hover-bg:#e5e6e7;--bs-table-hover-color:#000;color:#000;border-color:#dfe0e1}.table-dark[data-v-5948ee38]{--bs-table-bg:#212529;--bs-table-striped-bg:#2c3034;--bs-table-striped-color:#fff;--bs-table-active-bg:#373b3e;--bs-table-active-color:#fff;--bs-table-hover-bg:#323539;--bs-table-hover-color:#fff;color:#fff;border-color:#373b3e}.table-responsive[data-v-5948ee38]{overflow-x:auto;-webkit-overflow-scrolling:touch}@media (max-width:575.98px){.table-responsive-sm[data-v-5948ee38]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:767.98px){.table-responsive-md[data-v-5948ee38]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:991.98px){.table-responsive-lg[data-v-5948ee38]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1199.98px){.table-responsive-xl[data-v-5948ee38]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1399.98px){.table-responsive-xxl[data-v-5948ee38]{overflow-x:auto;-webkit-overflow-scrolling:touch}}.form-label[data-v-5948ee38]{margin-bottom:.5rem}.col-form-label[data-v-5948ee38]{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg[data-v-5948ee38]{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem}.col-form-label-sm[data-v-5948ee38]{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem}.form-text[data-v-5948ee38]{margin-top:.25rem;font-size:.875em;color:#6c757d}.form-control[data-v-5948ee38]{display:block;width:100%;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-5948ee38]{transition:none}}.form-control[type=file][data-v-5948ee38]{overflow:hidden}.form-control[type=file][data-v-5948ee38]:not(:disabled):not([readonly]){cursor:pointer}.form-control[data-v-5948ee38]:focus{color:#212529;background-color:#fff;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-control[data-v-5948ee38]::-webkit-date-and-time-value{height:1.5em}.form-control[data-v-5948ee38]::-moz-placeholder{color:#6c757d;opacity:1}.form-control[data-v-5948ee38]::placeholder{color:#6c757d;opacity:1}.form-control[data-v-5948ee38]:disabled,.form-control[readonly][data-v-5948ee38]{background-color:#e9ecef;opacity:1}.form-control[data-v-5948ee38]::file-selector-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-5948ee38]::-webkit-file-upload-button{-webkit-transition:none;transition:none}.form-control[data-v-5948ee38]::file-selector-button{transition:none}}.form-control[data-v-5948ee38]:hover:not(:disabled):not([readonly])::file-selector-button{background-color:#dde0e3}.form-control[data-v-5948ee38]::-webkit-file-upload-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;-webkit-transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-5948ee38]::-webkit-file-upload-button{-webkit-transition:none;transition:none}}.form-control[data-v-5948ee38]:hover:not(:disabled):not([readonly])::-webkit-file-upload-button{background-color:#dde0e3}.form-control-plaintext[data-v-5948ee38]{display:block;width:100%;padding:.375rem 0;margin-bottom:0;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg[data-v-5948ee38],.form-control-plaintext.form-control-sm[data-v-5948ee38]{padding-right:0;padding-left:0}.form-control-sm[data-v-5948ee38]{min-height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.form-control-sm[data-v-5948ee38]::file-selector-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-sm[data-v-5948ee38]::-webkit-file-upload-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-lg[data-v-5948ee38]{min-height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.form-control-lg[data-v-5948ee38]::file-selector-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}.form-control-lg[data-v-5948ee38]::-webkit-file-upload-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}textarea.form-control[data-v-5948ee38]{min-height:calc(1.5em + .75rem + 2px)}textarea.form-control-sm[data-v-5948ee38]{min-height:calc(1.5em + .5rem + 2px)}textarea.form-control-lg[data-v-5948ee38]{min-height:calc(1.5em + 1rem + 2px)}.form-control-color[data-v-5948ee38]{width:3rem;height:auto;padding:.375rem}.form-control-color[data-v-5948ee38]:not(:disabled):not([readonly]){cursor:pointer}.form-control-color[data-v-5948ee38]::-moz-color-swatch{height:1.5em;border-radius:.25rem}.form-control-color[data-v-5948ee38]::-webkit-color-swatch{height:1.5em;border-radius:.25rem}.form-select[data-v-5948ee38]{display:block;width:100%;padding:.375rem 2.25rem .375rem .75rem;-moz-padding-start:calc(.75rem - 3px);font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right .75rem center;background-size:16px 12px;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-select[data-v-5948ee38]{transition:none}}.form-select[data-v-5948ee38]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-select[multiple][data-v-5948ee38],.form-select[size][data-v-5948ee38]:not([size=\"1\"]){padding-right:.75rem;background-image:none}.form-select[data-v-5948ee38]:disabled{background-color:#e9ecef}.form-select[data-v-5948ee38]:-moz-focusring{color:transparent;text-shadow:0 0 0 #212529}.form-select-sm[data-v-5948ee38]{padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem;border-radius:.2rem}.form-select-lg[data-v-5948ee38]{padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem;border-radius:.3rem}.form-check[data-v-5948ee38]{display:block;min-height:1.5rem;padding-left:1.5em;margin-bottom:.125rem}.form-check .form-check-input[data-v-5948ee38]{float:left;margin-left:-1.5em}.form-check-input[data-v-5948ee38]{width:1em;height:1em;margin-top:.25em;vertical-align:top;background-color:#fff;background-repeat:no-repeat;background-position:50%;background-size:contain;border:1px solid rgba(0,0,0,.25);-webkit-appearance:none;-moz-appearance:none;appearance:none;-webkit-print-color-adjust:exact;color-adjust:exact}.form-check-input[type=checkbox][data-v-5948ee38]{border-radius:.25em}.form-check-input[type=radio][data-v-5948ee38]{border-radius:50%}.form-check-input[data-v-5948ee38]:active{filter:brightness(90%)}.form-check-input[data-v-5948ee38]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-check-input[data-v-5948ee38]:checked{background-color:#0d6efd;border-color:#0d6efd}.form-check-input:checked[type=checkbox][data-v-5948ee38]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3 6-6'/%3E%3C/svg%3E\")}.form-check-input:checked[type=radio][data-v-5948ee38]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='2' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-input[type=checkbox][data-v-5948ee38]:indeterminate{background-color:#0d6efd;border-color:#0d6efd;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3E%3C/svg%3E\")}.form-check-input[data-v-5948ee38]:disabled{pointer-events:none;filter:none;opacity:.5}.form-check-input:disabled~.form-check-label[data-v-5948ee38],.form-check-input[disabled]~.form-check-label[data-v-5948ee38]{opacity:.5}.form-switch[data-v-5948ee38]{padding-left:2.5em}.form-switch .form-check-input[data-v-5948ee38]{width:2em;margin-left:-2.5em;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='rgba(0, 0, 0, 0.25)'/%3E%3C/svg%3E\");background-position:0;border-radius:2em;transition:background-position .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-switch .form-check-input[data-v-5948ee38]{transition:none}}.form-switch .form-check-input[data-v-5948ee38]:focus{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%2386b7fe'/%3E%3C/svg%3E\")}.form-switch .form-check-input[data-v-5948ee38]:checked{background-position:100%;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-inline[data-v-5948ee38]{display:inline-block;margin-right:1rem}.btn-check[data-v-5948ee38]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.btn-check:disabled+.btn[data-v-5948ee38],.btn-check[disabled]+.btn[data-v-5948ee38]{pointer-events:none;filter:none;opacity:.65}.form-range[data-v-5948ee38]{width:100%;height:1.5rem;padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.form-range[data-v-5948ee38]:focus{outline:0}.form-range[data-v-5948ee38]:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-5948ee38]:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-5948ee38]::-moz-focus-outer{border:0}.form-range[data-v-5948ee38]::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#0d6efd;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-5948ee38]::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.form-range[data-v-5948ee38]::-webkit-slider-thumb:active{background-color:#b6d4fe}.form-range[data-v-5948ee38]::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-5948ee38]::-moz-range-thumb{width:1rem;height:1rem;background-color:#0d6efd;border:0;border-radius:1rem;-moz-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-5948ee38]::-moz-range-thumb{-moz-transition:none;transition:none}}.form-range[data-v-5948ee38]::-moz-range-thumb:active{background-color:#b6d4fe}.form-range[data-v-5948ee38]::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-5948ee38]:disabled{pointer-events:none}.form-range[data-v-5948ee38]:disabled::-webkit-slider-thumb{background-color:#adb5bd}.form-range[data-v-5948ee38]:disabled::-moz-range-thumb{background-color:#adb5bd}.form-floating[data-v-5948ee38]{position:relative}.form-floating>.form-control[data-v-5948ee38],.form-floating>.form-select[data-v-5948ee38]{height:calc(3.5rem + 2px);line-height:1.25}.form-floating>label[data-v-5948ee38]{position:absolute;top:0;left:0;height:100%;padding:1rem .75rem;pointer-events:none;border:1px solid transparent;transform-origin:0 0;transition:opacity .1s ease-in-out,transform .1s ease-in-out}@media (prefers-reduced-motion:reduce){.form-floating>label[data-v-5948ee38]{transition:none}}.form-floating>.form-control[data-v-5948ee38]{padding:1rem .75rem}.form-floating>.form-control[data-v-5948ee38]::-moz-placeholder{color:transparent}.form-floating>.form-control[data-v-5948ee38]::placeholder{color:transparent}.form-floating>.form-control[data-v-5948ee38]:not(:-moz-placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-5948ee38]:focus,.form-floating>.form-control[data-v-5948ee38]:not(:placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-5948ee38]:-webkit-autofill{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-select[data-v-5948ee38]{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control:not(:-moz-placeholder-shown)~label[data-v-5948ee38]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:focus~label[data-v-5948ee38],.form-floating>.form-control:not(:placeholder-shown)~label[data-v-5948ee38],.form-floating>.form-select~label[data-v-5948ee38]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:-webkit-autofill~label[data-v-5948ee38]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.input-group[data-v-5948ee38]{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group>.form-control[data-v-5948ee38],.input-group>.form-select[data-v-5948ee38]{position:relative;flex:1 1 auto;width:1%;min-width:0}.input-group>.form-control[data-v-5948ee38]:focus,.input-group>.form-select[data-v-5948ee38]:focus{z-index:3}.input-group .btn[data-v-5948ee38]{position:relative;z-index:2}.input-group .btn[data-v-5948ee38]:focus{z-index:3}.input-group-text[data-v-5948ee38]{display:flex;align-items:center;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-lg>.btn[data-v-5948ee38],.input-group-lg>.form-control[data-v-5948ee38],.input-group-lg>.form-select[data-v-5948ee38],.input-group-lg>.input-group-text[data-v-5948ee38]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.input-group-sm>.btn[data-v-5948ee38],.input-group-sm>.form-control[data-v-5948ee38],.input-group-sm>.form-select[data-v-5948ee38],.input-group-sm>.input-group-text[data-v-5948ee38]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.input-group-lg>.form-select[data-v-5948ee38],.input-group-sm>.form-select[data-v-5948ee38]{padding-right:3rem}.input-group.has-validation>.dropdown-toggle[data-v-5948ee38]:nth-last-child(n+4),.input-group.has-validation[data-v-5948ee38]>:nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),.input-group:not(.has-validation)>.dropdown-toggle[data-v-5948ee38]:nth-last-child(n+3),.input-group[data-v-5948ee38]:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu){border-top-right-radius:0;border-bottom-right-radius:0}.input-group[data-v-5948ee38]>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}.valid-feedback[data-v-5948ee38]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#198754}.valid-tooltip[data-v-5948ee38]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(25,135,84,.9);border-radius:.25rem}.is-valid~.valid-feedback[data-v-5948ee38],.is-valid~.valid-tooltip[data-v-5948ee38],.was-validated :valid~.valid-feedback[data-v-5948ee38],.was-validated :valid~.valid-tooltip[data-v-5948ee38]{display:block}.form-control.is-valid[data-v-5948ee38],.was-validated .form-control[data-v-5948ee38]:valid{border-color:#198754;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-valid[data-v-5948ee38]:focus,.was-validated .form-control[data-v-5948ee38]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.was-validated textarea.form-control[data-v-5948ee38]:valid,textarea.form-control.is-valid[data-v-5948ee38]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-valid[data-v-5948ee38],.was-validated .form-select[data-v-5948ee38]:valid{border-color:#198754}.form-select.is-valid:not([multiple])[size=\"1\"][data-v-5948ee38],.form-select.is-valid[data-v-5948ee38]:not([multiple]):not([size]),.was-validated .form-select:valid:not([multiple])[size=\"1\"][data-v-5948ee38],.was-validated .form-select[data-v-5948ee38]:valid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-valid[data-v-5948ee38]:focus,.was-validated .form-select[data-v-5948ee38]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid[data-v-5948ee38],.was-validated .form-check-input[data-v-5948ee38]:valid{border-color:#198754}.form-check-input.is-valid[data-v-5948ee38]:checked,.was-validated .form-check-input[data-v-5948ee38]:valid:checked{background-color:#198754}.form-check-input.is-valid[data-v-5948ee38]:focus,.was-validated .form-check-input[data-v-5948ee38]:valid:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid~.form-check-label[data-v-5948ee38],.was-validated .form-check-input:valid~.form-check-label[data-v-5948ee38]{color:#198754}.form-check-inline .form-check-input~.valid-feedback[data-v-5948ee38]{margin-left:.5em}.input-group .form-control.is-valid[data-v-5948ee38],.input-group .form-select.is-valid[data-v-5948ee38],.was-validated .input-group .form-control[data-v-5948ee38]:valid,.was-validated .input-group .form-select[data-v-5948ee38]:valid{z-index:1}.input-group .form-control.is-valid[data-v-5948ee38]:focus,.input-group .form-select.is-valid[data-v-5948ee38]:focus,.was-validated .input-group .form-control[data-v-5948ee38]:valid:focus,.was-validated .input-group .form-select[data-v-5948ee38]:valid:focus{z-index:3}.invalid-feedback[data-v-5948ee38]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#dc3545}.invalid-tooltip[data-v-5948ee38]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(220,53,69,.9);border-radius:.25rem}.is-invalid~.invalid-feedback[data-v-5948ee38],.is-invalid~.invalid-tooltip[data-v-5948ee38],.was-validated :invalid~.invalid-feedback[data-v-5948ee38],.was-validated :invalid~.invalid-tooltip[data-v-5948ee38]{display:block}.form-control.is-invalid[data-v-5948ee38],.was-validated .form-control[data-v-5948ee38]:invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-invalid[data-v-5948ee38]:focus,.was-validated .form-control[data-v-5948ee38]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.was-validated textarea.form-control[data-v-5948ee38]:invalid,textarea.form-control.is-invalid[data-v-5948ee38]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-invalid[data-v-5948ee38],.was-validated .form-select[data-v-5948ee38]:invalid{border-color:#dc3545}.form-select.is-invalid:not([multiple])[size=\"1\"][data-v-5948ee38],.form-select.is-invalid[data-v-5948ee38]:not([multiple]):not([size]),.was-validated .form-select:invalid:not([multiple])[size=\"1\"][data-v-5948ee38],.was-validated .form-select[data-v-5948ee38]:invalid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-invalid[data-v-5948ee38]:focus,.was-validated .form-select[data-v-5948ee38]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid[data-v-5948ee38],.was-validated .form-check-input[data-v-5948ee38]:invalid{border-color:#dc3545}.form-check-input.is-invalid[data-v-5948ee38]:checked,.was-validated .form-check-input[data-v-5948ee38]:invalid:checked{background-color:#dc3545}.form-check-input.is-invalid[data-v-5948ee38]:focus,.was-validated .form-check-input[data-v-5948ee38]:invalid:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid~.form-check-label[data-v-5948ee38],.was-validated .form-check-input:invalid~.form-check-label[data-v-5948ee38]{color:#dc3545}.form-check-inline .form-check-input~.invalid-feedback[data-v-5948ee38]{margin-left:.5em}.input-group .form-control.is-invalid[data-v-5948ee38],.input-group .form-select.is-invalid[data-v-5948ee38],.was-validated .input-group .form-control[data-v-5948ee38]:invalid,.was-validated .input-group .form-select[data-v-5948ee38]:invalid{z-index:2}.input-group .form-control.is-invalid[data-v-5948ee38]:focus,.input-group .form-select.is-invalid[data-v-5948ee38]:focus,.was-validated .input-group .form-control[data-v-5948ee38]:invalid:focus,.was-validated .input-group .form-select[data-v-5948ee38]:invalid:focus{z-index:3}.btn[data-v-5948ee38]{display:inline-block;font-weight:400;line-height:1.5;color:#212529;text-align:center;text-decoration:none;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn[data-v-5948ee38]{transition:none}}.btn[data-v-5948ee38]:hover{color:#212529}.btn-check:focus+.btn[data-v-5948ee38],.btn[data-v-5948ee38]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.btn.disabled[data-v-5948ee38],.btn[data-v-5948ee38]:disabled,fieldset:disabled .btn[data-v-5948ee38]{pointer-events:none;opacity:.65}.btn-primary[data-v-5948ee38]{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-primary[data-v-5948ee38]:hover{color:#fff;background-color:#0b5ed7;border-color:#0a58ca}.btn-check:focus+.btn-primary[data-v-5948ee38],.btn-primary[data-v-5948ee38]:focus{color:#fff;background-color:#0b5ed7;border-color:#0a58ca;box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-check:active+.btn-primary[data-v-5948ee38],.btn-check:checked+.btn-primary[data-v-5948ee38],.btn-primary.active[data-v-5948ee38],.btn-primary[data-v-5948ee38]:active,.show>.btn-primary.dropdown-toggle[data-v-5948ee38]{color:#fff;background-color:#0a58ca;border-color:#0a53be}.btn-check:active+.btn-primary[data-v-5948ee38]:focus,.btn-check:checked+.btn-primary[data-v-5948ee38]:focus,.btn-primary.active[data-v-5948ee38]:focus,.btn-primary[data-v-5948ee38]:active:focus,.show>.btn-primary.dropdown-toggle[data-v-5948ee38]:focus{box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-primary.disabled[data-v-5948ee38],.btn-primary[data-v-5948ee38]:disabled{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-secondary[data-v-5948ee38]{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary[data-v-5948ee38]:hover{color:#fff;background-color:#5c636a;border-color:#565e64}.btn-check:focus+.btn-secondary[data-v-5948ee38],.btn-secondary[data-v-5948ee38]:focus{color:#fff;background-color:#5c636a;border-color:#565e64;box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-check:active+.btn-secondary[data-v-5948ee38],.btn-check:checked+.btn-secondary[data-v-5948ee38],.btn-secondary.active[data-v-5948ee38],.btn-secondary[data-v-5948ee38]:active,.show>.btn-secondary.dropdown-toggle[data-v-5948ee38]{color:#fff;background-color:#565e64;border-color:#51585e}.btn-check:active+.btn-secondary[data-v-5948ee38]:focus,.btn-check:checked+.btn-secondary[data-v-5948ee38]:focus,.btn-secondary.active[data-v-5948ee38]:focus,.btn-secondary[data-v-5948ee38]:active:focus,.show>.btn-secondary.dropdown-toggle[data-v-5948ee38]:focus{box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-secondary.disabled[data-v-5948ee38],.btn-secondary[data-v-5948ee38]:disabled{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-success[data-v-5948ee38]{color:#fff;background-color:#198754;border-color:#198754}.btn-success[data-v-5948ee38]:hover{color:#fff;background-color:#157347;border-color:#146c43}.btn-check:focus+.btn-success[data-v-5948ee38],.btn-success[data-v-5948ee38]:focus{color:#fff;background-color:#157347;border-color:#146c43;box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-check:active+.btn-success[data-v-5948ee38],.btn-check:checked+.btn-success[data-v-5948ee38],.btn-success.active[data-v-5948ee38],.btn-success[data-v-5948ee38]:active,.show>.btn-success.dropdown-toggle[data-v-5948ee38]{color:#fff;background-color:#146c43;border-color:#13653f}.btn-check:active+.btn-success[data-v-5948ee38]:focus,.btn-check:checked+.btn-success[data-v-5948ee38]:focus,.btn-success.active[data-v-5948ee38]:focus,.btn-success[data-v-5948ee38]:active:focus,.show>.btn-success.dropdown-toggle[data-v-5948ee38]:focus{box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-success.disabled[data-v-5948ee38],.btn-success[data-v-5948ee38]:disabled{color:#fff;background-color:#198754;border-color:#198754}.btn-info[data-v-5948ee38]{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-info[data-v-5948ee38]:hover{color:#000;background-color:#31d2f2;border-color:#25cff2}.btn-check:focus+.btn-info[data-v-5948ee38],.btn-info[data-v-5948ee38]:focus{color:#000;background-color:#31d2f2;border-color:#25cff2;box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-check:active+.btn-info[data-v-5948ee38],.btn-check:checked+.btn-info[data-v-5948ee38],.btn-info.active[data-v-5948ee38],.btn-info[data-v-5948ee38]:active,.show>.btn-info.dropdown-toggle[data-v-5948ee38]{color:#000;background-color:#3dd5f3;border-color:#25cff2}.btn-check:active+.btn-info[data-v-5948ee38]:focus,.btn-check:checked+.btn-info[data-v-5948ee38]:focus,.btn-info.active[data-v-5948ee38]:focus,.btn-info[data-v-5948ee38]:active:focus,.show>.btn-info.dropdown-toggle[data-v-5948ee38]:focus{box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-info.disabled[data-v-5948ee38],.btn-info[data-v-5948ee38]:disabled{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-warning[data-v-5948ee38]{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-warning[data-v-5948ee38]:hover{color:#000;background-color:#ffca2c;border-color:#ffc720}.btn-check:focus+.btn-warning[data-v-5948ee38],.btn-warning[data-v-5948ee38]:focus{color:#000;background-color:#ffca2c;border-color:#ffc720;box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-check:active+.btn-warning[data-v-5948ee38],.btn-check:checked+.btn-warning[data-v-5948ee38],.btn-warning.active[data-v-5948ee38],.btn-warning[data-v-5948ee38]:active,.show>.btn-warning.dropdown-toggle[data-v-5948ee38]{color:#000;background-color:#ffcd39;border-color:#ffc720}.btn-check:active+.btn-warning[data-v-5948ee38]:focus,.btn-check:checked+.btn-warning[data-v-5948ee38]:focus,.btn-warning.active[data-v-5948ee38]:focus,.btn-warning[data-v-5948ee38]:active:focus,.show>.btn-warning.dropdown-toggle[data-v-5948ee38]:focus{box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-warning.disabled[data-v-5948ee38],.btn-warning[data-v-5948ee38]:disabled{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-danger[data-v-5948ee38]{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger[data-v-5948ee38]:hover{color:#fff;background-color:#bb2d3b;border-color:#b02a37}.btn-check:focus+.btn-danger[data-v-5948ee38],.btn-danger[data-v-5948ee38]:focus{color:#fff;background-color:#bb2d3b;border-color:#b02a37;box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-check:active+.btn-danger[data-v-5948ee38],.btn-check:checked+.btn-danger[data-v-5948ee38],.btn-danger.active[data-v-5948ee38],.btn-danger[data-v-5948ee38]:active,.show>.btn-danger.dropdown-toggle[data-v-5948ee38]{color:#fff;background-color:#b02a37;border-color:#a52834}.btn-check:active+.btn-danger[data-v-5948ee38]:focus,.btn-check:checked+.btn-danger[data-v-5948ee38]:focus,.btn-danger.active[data-v-5948ee38]:focus,.btn-danger[data-v-5948ee38]:active:focus,.show>.btn-danger.dropdown-toggle[data-v-5948ee38]:focus{box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-danger.disabled[data-v-5948ee38],.btn-danger[data-v-5948ee38]:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-light[data-v-5948ee38]{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light[data-v-5948ee38]:hover{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:focus+.btn-light[data-v-5948ee38],.btn-light[data-v-5948ee38]:focus{color:#000;background-color:#f9fafb;border-color:#f9fafb;box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-check:active+.btn-light[data-v-5948ee38],.btn-check:checked+.btn-light[data-v-5948ee38],.btn-light.active[data-v-5948ee38],.btn-light[data-v-5948ee38]:active,.show>.btn-light.dropdown-toggle[data-v-5948ee38]{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:active+.btn-light[data-v-5948ee38]:focus,.btn-check:checked+.btn-light[data-v-5948ee38]:focus,.btn-light.active[data-v-5948ee38]:focus,.btn-light[data-v-5948ee38]:active:focus,.show>.btn-light.dropdown-toggle[data-v-5948ee38]:focus{box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-light.disabled[data-v-5948ee38],.btn-light[data-v-5948ee38]:disabled{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-dark[data-v-5948ee38]{color:#fff;background-color:#212529;border-color:#212529}.btn-dark[data-v-5948ee38]:hover{color:#fff;background-color:#1c1f23;border-color:#1a1e21}.btn-check:focus+.btn-dark[data-v-5948ee38],.btn-dark[data-v-5948ee38]:focus{color:#fff;background-color:#1c1f23;border-color:#1a1e21;box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-check:active+.btn-dark[data-v-5948ee38],.btn-check:checked+.btn-dark[data-v-5948ee38],.btn-dark.active[data-v-5948ee38],.btn-dark[data-v-5948ee38]:active,.show>.btn-dark.dropdown-toggle[data-v-5948ee38]{color:#fff;background-color:#1a1e21;border-color:#191c1f}.btn-check:active+.btn-dark[data-v-5948ee38]:focus,.btn-check:checked+.btn-dark[data-v-5948ee38]:focus,.btn-dark.active[data-v-5948ee38]:focus,.btn-dark[data-v-5948ee38]:active:focus,.show>.btn-dark.dropdown-toggle[data-v-5948ee38]:focus{box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-dark.disabled[data-v-5948ee38],.btn-dark[data-v-5948ee38]:disabled{color:#fff;background-color:#212529;border-color:#212529}.btn-outline-primary[data-v-5948ee38]{color:#0d6efd;border-color:#0d6efd}.btn-outline-primary[data-v-5948ee38]:hover{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:focus+.btn-outline-primary[data-v-5948ee38],.btn-outline-primary[data-v-5948ee38]:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-check:active+.btn-outline-primary[data-v-5948ee38],.btn-check:checked+.btn-outline-primary[data-v-5948ee38],.btn-outline-primary.active[data-v-5948ee38],.btn-outline-primary.dropdown-toggle.show[data-v-5948ee38],.btn-outline-primary[data-v-5948ee38]:active{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:active+.btn-outline-primary[data-v-5948ee38]:focus,.btn-check:checked+.btn-outline-primary[data-v-5948ee38]:focus,.btn-outline-primary.active[data-v-5948ee38]:focus,.btn-outline-primary.dropdown-toggle.show[data-v-5948ee38]:focus,.btn-outline-primary[data-v-5948ee38]:active:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-outline-primary.disabled[data-v-5948ee38],.btn-outline-primary[data-v-5948ee38]:disabled{color:#0d6efd;background-color:transparent}.btn-outline-secondary[data-v-5948ee38]{color:#6c757d;border-color:#6c757d}.btn-outline-secondary[data-v-5948ee38]:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:focus+.btn-outline-secondary[data-v-5948ee38],.btn-outline-secondary[data-v-5948ee38]:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-check:active+.btn-outline-secondary[data-v-5948ee38],.btn-check:checked+.btn-outline-secondary[data-v-5948ee38],.btn-outline-secondary.active[data-v-5948ee38],.btn-outline-secondary.dropdown-toggle.show[data-v-5948ee38],.btn-outline-secondary[data-v-5948ee38]:active{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:active+.btn-outline-secondary[data-v-5948ee38]:focus,.btn-check:checked+.btn-outline-secondary[data-v-5948ee38]:focus,.btn-outline-secondary.active[data-v-5948ee38]:focus,.btn-outline-secondary.dropdown-toggle.show[data-v-5948ee38]:focus,.btn-outline-secondary[data-v-5948ee38]:active:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-outline-secondary.disabled[data-v-5948ee38],.btn-outline-secondary[data-v-5948ee38]:disabled{color:#6c757d;background-color:transparent}.btn-outline-success[data-v-5948ee38]{color:#198754;border-color:#198754}.btn-outline-success[data-v-5948ee38]:hover{color:#fff;background-color:#198754;border-color:#198754}.btn-check:focus+.btn-outline-success[data-v-5948ee38],.btn-outline-success[data-v-5948ee38]:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-check:active+.btn-outline-success[data-v-5948ee38],.btn-check:checked+.btn-outline-success[data-v-5948ee38],.btn-outline-success.active[data-v-5948ee38],.btn-outline-success.dropdown-toggle.show[data-v-5948ee38],.btn-outline-success[data-v-5948ee38]:active{color:#fff;background-color:#198754;border-color:#198754}.btn-check:active+.btn-outline-success[data-v-5948ee38]:focus,.btn-check:checked+.btn-outline-success[data-v-5948ee38]:focus,.btn-outline-success.active[data-v-5948ee38]:focus,.btn-outline-success.dropdown-toggle.show[data-v-5948ee38]:focus,.btn-outline-success[data-v-5948ee38]:active:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-outline-success.disabled[data-v-5948ee38],.btn-outline-success[data-v-5948ee38]:disabled{color:#198754;background-color:transparent}.btn-outline-info[data-v-5948ee38]{color:#0dcaf0;border-color:#0dcaf0}.btn-outline-info[data-v-5948ee38]:hover{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:focus+.btn-outline-info[data-v-5948ee38],.btn-outline-info[data-v-5948ee38]:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-check:active+.btn-outline-info[data-v-5948ee38],.btn-check:checked+.btn-outline-info[data-v-5948ee38],.btn-outline-info.active[data-v-5948ee38],.btn-outline-info.dropdown-toggle.show[data-v-5948ee38],.btn-outline-info[data-v-5948ee38]:active{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:active+.btn-outline-info[data-v-5948ee38]:focus,.btn-check:checked+.btn-outline-info[data-v-5948ee38]:focus,.btn-outline-info.active[data-v-5948ee38]:focus,.btn-outline-info.dropdown-toggle.show[data-v-5948ee38]:focus,.btn-outline-info[data-v-5948ee38]:active:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-outline-info.disabled[data-v-5948ee38],.btn-outline-info[data-v-5948ee38]:disabled{color:#0dcaf0;background-color:transparent}.btn-outline-warning[data-v-5948ee38]{color:#ffc107;border-color:#ffc107}.btn-outline-warning[data-v-5948ee38]:hover{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:focus+.btn-outline-warning[data-v-5948ee38],.btn-outline-warning[data-v-5948ee38]:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-check:active+.btn-outline-warning[data-v-5948ee38],.btn-check:checked+.btn-outline-warning[data-v-5948ee38],.btn-outline-warning.active[data-v-5948ee38],.btn-outline-warning.dropdown-toggle.show[data-v-5948ee38],.btn-outline-warning[data-v-5948ee38]:active{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:active+.btn-outline-warning[data-v-5948ee38]:focus,.btn-check:checked+.btn-outline-warning[data-v-5948ee38]:focus,.btn-outline-warning.active[data-v-5948ee38]:focus,.btn-outline-warning.dropdown-toggle.show[data-v-5948ee38]:focus,.btn-outline-warning[data-v-5948ee38]:active:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-outline-warning.disabled[data-v-5948ee38],.btn-outline-warning[data-v-5948ee38]:disabled{color:#ffc107;background-color:transparent}.btn-outline-danger[data-v-5948ee38]{color:#dc3545;border-color:#dc3545}.btn-outline-danger[data-v-5948ee38]:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:focus+.btn-outline-danger[data-v-5948ee38],.btn-outline-danger[data-v-5948ee38]:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-check:active+.btn-outline-danger[data-v-5948ee38],.btn-check:checked+.btn-outline-danger[data-v-5948ee38],.btn-outline-danger.active[data-v-5948ee38],.btn-outline-danger.dropdown-toggle.show[data-v-5948ee38],.btn-outline-danger[data-v-5948ee38]:active{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:active+.btn-outline-danger[data-v-5948ee38]:focus,.btn-check:checked+.btn-outline-danger[data-v-5948ee38]:focus,.btn-outline-danger.active[data-v-5948ee38]:focus,.btn-outline-danger.dropdown-toggle.show[data-v-5948ee38]:focus,.btn-outline-danger[data-v-5948ee38]:active:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-outline-danger.disabled[data-v-5948ee38],.btn-outline-danger[data-v-5948ee38]:disabled{color:#dc3545;background-color:transparent}.btn-outline-light[data-v-5948ee38]{color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light[data-v-5948ee38]:hover{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:focus+.btn-outline-light[data-v-5948ee38],.btn-outline-light[data-v-5948ee38]:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-check:active+.btn-outline-light[data-v-5948ee38],.btn-check:checked+.btn-outline-light[data-v-5948ee38],.btn-outline-light.active[data-v-5948ee38],.btn-outline-light.dropdown-toggle.show[data-v-5948ee38],.btn-outline-light[data-v-5948ee38]:active{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:active+.btn-outline-light[data-v-5948ee38]:focus,.btn-check:checked+.btn-outline-light[data-v-5948ee38]:focus,.btn-outline-light.active[data-v-5948ee38]:focus,.btn-outline-light.dropdown-toggle.show[data-v-5948ee38]:focus,.btn-outline-light[data-v-5948ee38]:active:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-outline-light.disabled[data-v-5948ee38],.btn-outline-light[data-v-5948ee38]:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-dark[data-v-5948ee38]{color:#212529;border-color:#212529}.btn-outline-dark[data-v-5948ee38]:hover{color:#fff;background-color:#212529;border-color:#212529}.btn-check:focus+.btn-outline-dark[data-v-5948ee38],.btn-outline-dark[data-v-5948ee38]:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-check:active+.btn-outline-dark[data-v-5948ee38],.btn-check:checked+.btn-outline-dark[data-v-5948ee38],.btn-outline-dark.active[data-v-5948ee38],.btn-outline-dark.dropdown-toggle.show[data-v-5948ee38],.btn-outline-dark[data-v-5948ee38]:active{color:#fff;background-color:#212529;border-color:#212529}.btn-check:active+.btn-outline-dark[data-v-5948ee38]:focus,.btn-check:checked+.btn-outline-dark[data-v-5948ee38]:focus,.btn-outline-dark.active[data-v-5948ee38]:focus,.btn-outline-dark.dropdown-toggle.show[data-v-5948ee38]:focus,.btn-outline-dark[data-v-5948ee38]:active:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-outline-dark.disabled[data-v-5948ee38],.btn-outline-dark[data-v-5948ee38]:disabled{color:#212529;background-color:transparent}.btn-link[data-v-5948ee38]{font-weight:400;color:#0d6efd;text-decoration:underline}.btn-link[data-v-5948ee38]:hover{color:#0a58ca}.btn-link.disabled[data-v-5948ee38],.btn-link[data-v-5948ee38]:disabled{color:#6c757d}.btn-group-lg>.btn[data-v-5948ee38],.btn-lg[data-v-5948ee38]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.btn-group-sm>.btn[data-v-5948ee38],.btn-sm[data-v-5948ee38]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.fade[data-v-5948ee38]{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade[data-v-5948ee38]{transition:none}}.fade[data-v-5948ee38]:not(.show){opacity:0}.collapse[data-v-5948ee38]:not(.show){display:none}.collapsing[data-v-5948ee38]{height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.collapsing[data-v-5948ee38]{transition:none}}.collapsing.collapse-horizontal[data-v-5948ee38]{width:0;height:auto;transition:width .35s ease}@media (prefers-reduced-motion:reduce){.collapsing.collapse-horizontal[data-v-5948ee38]{transition:none}}.dropdown[data-v-5948ee38],.dropend[data-v-5948ee38],.dropstart[data-v-5948ee38],.dropup[data-v-5948ee38]{position:relative}.dropdown-toggle[data-v-5948ee38]{white-space:nowrap}.dropdown-toggle[data-v-5948ee38]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle[data-v-5948ee38]:empty:after{margin-left:0}.dropdown-menu[data-v-5948ee38]{position:absolute;z-index:1000;display:none;min-width:10rem;padding:.5rem 0;margin:0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-menu[data-bs-popper][data-v-5948ee38]{top:100%;left:0;margin-top:.125rem}.dropdown-menu-start[data-v-5948ee38]{--bs-position:start}.dropdown-menu-start[data-bs-popper][data-v-5948ee38]{right:auto;left:0}.dropdown-menu-end[data-v-5948ee38]{--bs-position:end}.dropdown-menu-end[data-bs-popper][data-v-5948ee38]{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-start[data-v-5948ee38]{--bs-position:start}.dropdown-menu-sm-start[data-bs-popper][data-v-5948ee38]{right:auto;left:0}.dropdown-menu-sm-end[data-v-5948ee38]{--bs-position:end}.dropdown-menu-sm-end[data-bs-popper][data-v-5948ee38]{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-start[data-v-5948ee38]{--bs-position:start}.dropdown-menu-md-start[data-bs-popper][data-v-5948ee38]{right:auto;left:0}.dropdown-menu-md-end[data-v-5948ee38]{--bs-position:end}.dropdown-menu-md-end[data-bs-popper][data-v-5948ee38]{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-start[data-v-5948ee38]{--bs-position:start}.dropdown-menu-lg-start[data-bs-popper][data-v-5948ee38]{right:auto;left:0}.dropdown-menu-lg-end[data-v-5948ee38]{--bs-position:end}.dropdown-menu-lg-end[data-bs-popper][data-v-5948ee38]{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-start[data-v-5948ee38]{--bs-position:start}.dropdown-menu-xl-start[data-bs-popper][data-v-5948ee38]{right:auto;left:0}.dropdown-menu-xl-end[data-v-5948ee38]{--bs-position:end}.dropdown-menu-xl-end[data-bs-popper][data-v-5948ee38]{right:0;left:auto}}@media (min-width:1400px){.dropdown-menu-xxl-start[data-v-5948ee38]{--bs-position:start}.dropdown-menu-xxl-start[data-bs-popper][data-v-5948ee38]{right:auto;left:0}.dropdown-menu-xxl-end[data-v-5948ee38]{--bs-position:end}.dropdown-menu-xxl-end[data-bs-popper][data-v-5948ee38]{right:0;left:auto}}.dropup .dropdown-menu[data-bs-popper][data-v-5948ee38]{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle[data-v-5948ee38]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle[data-v-5948ee38]:empty:after{margin-left:0}.dropend .dropdown-menu[data-bs-popper][data-v-5948ee38]{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.dropend .dropdown-toggle[data-v-5948ee38]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropend .dropdown-toggle[data-v-5948ee38]:empty:after{margin-left:0}.dropend .dropdown-toggle[data-v-5948ee38]:after{vertical-align:0}.dropstart .dropdown-menu[data-bs-popper][data-v-5948ee38]{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.dropstart .dropdown-toggle[data-v-5948ee38]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";display:none}.dropstart .dropdown-toggle[data-v-5948ee38]:before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropstart .dropdown-toggle[data-v-5948ee38]:empty:after{margin-left:0}.dropstart .dropdown-toggle[data-v-5948ee38]:before{vertical-align:0}.dropdown-divider[data-v-5948ee38]{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid rgba(0,0,0,.15)}.dropdown-item[data-v-5948ee38]{display:block;width:100%;padding:.25rem 1rem;clear:both;font-weight:400;color:#212529;text-align:inherit;text-decoration:none;white-space:nowrap;background-color:transparent;border:0}.dropdown-item[data-v-5948ee38]:focus,.dropdown-item[data-v-5948ee38]:hover{color:#1e2125;background-color:#e9ecef}.dropdown-item.active[data-v-5948ee38],.dropdown-item[data-v-5948ee38]:active{color:#fff;text-decoration:none;background-color:#0d6efd}.dropdown-item.disabled[data-v-5948ee38],.dropdown-item[data-v-5948ee38]:disabled{color:#adb5bd;pointer-events:none;background-color:transparent}.dropdown-menu.show[data-v-5948ee38]{display:block}.dropdown-header[data-v-5948ee38]{display:block;padding:.5rem 1rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.dropdown-item-text[data-v-5948ee38]{display:block;padding:.25rem 1rem;color:#212529}.dropdown-menu-dark[data-v-5948ee38]{color:#dee2e6;background-color:#343a40;border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item[data-v-5948ee38]{color:#dee2e6}.dropdown-menu-dark .dropdown-item[data-v-5948ee38]:focus,.dropdown-menu-dark .dropdown-item[data-v-5948ee38]:hover{color:#fff;background-color:hsla(0,0%,100%,.15)}.dropdown-menu-dark .dropdown-item.active[data-v-5948ee38],.dropdown-menu-dark .dropdown-item[data-v-5948ee38]:active{color:#fff;background-color:#0d6efd}.dropdown-menu-dark .dropdown-item.disabled[data-v-5948ee38],.dropdown-menu-dark .dropdown-item[data-v-5948ee38]:disabled{color:#adb5bd}.dropdown-menu-dark .dropdown-divider[data-v-5948ee38]{border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item-text[data-v-5948ee38]{color:#dee2e6}.dropdown-menu-dark .dropdown-header[data-v-5948ee38]{color:#adb5bd}.btn-group-vertical[data-v-5948ee38],.btn-group[data-v-5948ee38]{position:relative;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn[data-v-5948ee38],.btn-group>.btn[data-v-5948ee38]{position:relative;flex:1 1 auto}.btn-group-vertical>.btn-check:checked+.btn[data-v-5948ee38],.btn-group-vertical>.btn-check:focus+.btn[data-v-5948ee38],.btn-group-vertical>.btn.active[data-v-5948ee38],.btn-group-vertical>.btn[data-v-5948ee38]:active,.btn-group-vertical>.btn[data-v-5948ee38]:focus,.btn-group-vertical>.btn[data-v-5948ee38]:hover,.btn-group>.btn-check:checked+.btn[data-v-5948ee38],.btn-group>.btn-check:focus+.btn[data-v-5948ee38],.btn-group>.btn.active[data-v-5948ee38],.btn-group>.btn[data-v-5948ee38]:active,.btn-group>.btn[data-v-5948ee38]:focus,.btn-group>.btn[data-v-5948ee38]:hover{z-index:1}.btn-toolbar[data-v-5948ee38]{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar .input-group[data-v-5948ee38]{width:auto}.btn-group>.btn-group[data-v-5948ee38]:not(:first-child),.btn-group>.btn[data-v-5948ee38]:not(:first-child){margin-left:-1px}.btn-group>.btn-group:not(:last-child)>.btn[data-v-5948ee38],.btn-group>.btn[data-v-5948ee38]:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn[data-v-5948ee38],.btn-group>.btn[data-v-5948ee38]:nth-child(n+3),.btn-group>:not(.btn-check)+.btn[data-v-5948ee38]{border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split[data-v-5948ee38]{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split[data-v-5948ee38]:after,.dropend .dropdown-toggle-split[data-v-5948ee38]:after,.dropup .dropdown-toggle-split[data-v-5948ee38]:after{margin-left:0}.dropstart .dropdown-toggle-split[data-v-5948ee38]:before{margin-right:0}.btn-group-sm>.btn+.dropdown-toggle-split[data-v-5948ee38],.btn-sm+.dropdown-toggle-split[data-v-5948ee38]{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split[data-v-5948ee38],.btn-lg+.dropdown-toggle-split[data-v-5948ee38]{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical[data-v-5948ee38]{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical>.btn-group[data-v-5948ee38],.btn-group-vertical>.btn[data-v-5948ee38]{width:100%}.btn-group-vertical>.btn-group[data-v-5948ee38]:not(:first-child),.btn-group-vertical>.btn[data-v-5948ee38]:not(:first-child){margin-top:-1px}.btn-group-vertical>.btn-group:not(:last-child)>.btn[data-v-5948ee38],.btn-group-vertical>.btn[data-v-5948ee38]:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn[data-v-5948ee38],.btn-group-vertical>.btn~.btn[data-v-5948ee38]{border-top-left-radius:0;border-top-right-radius:0}.nav[data-v-5948ee38]{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link[data-v-5948ee38]{display:block;padding:.5rem 1rem;color:#0d6efd;text-decoration:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out}@media (prefers-reduced-motion:reduce){.nav-link[data-v-5948ee38]{transition:none}}.nav-link[data-v-5948ee38]:focus,.nav-link[data-v-5948ee38]:hover{color:#0a58ca}.nav-link.disabled[data-v-5948ee38]{color:#6c757d;pointer-events:none;cursor:default}.nav-tabs[data-v-5948ee38]{border-bottom:1px solid #dee2e6}.nav-tabs .nav-link[data-v-5948ee38]{margin-bottom:-1px;background:0 0;border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link[data-v-5948ee38]:focus,.nav-tabs .nav-link[data-v-5948ee38]:hover{border-color:#e9ecef #e9ecef #dee2e6;isolation:isolate}.nav-tabs .nav-link.disabled[data-v-5948ee38]{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link[data-v-5948ee38],.nav-tabs .nav-link.active[data-v-5948ee38]{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu[data-v-5948ee38]{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link[data-v-5948ee38]{background:0 0;border:0;border-radius:.25rem}.nav-pills .nav-link.active[data-v-5948ee38],.nav-pills .show>.nav-link[data-v-5948ee38]{color:#fff;background-color:#0d6efd}.nav-fill .nav-item[data-v-5948ee38],.nav-fill>.nav-link[data-v-5948ee38]{flex:1 1 auto;text-align:center}.nav-justified .nav-item[data-v-5948ee38],.nav-justified>.nav-link[data-v-5948ee38]{flex-basis:0;flex-grow:1;text-align:center}.nav-fill .nav-item .nav-link[data-v-5948ee38],.nav-justified .nav-item .nav-link[data-v-5948ee38]{width:100%}.tab-content>.tab-pane[data-v-5948ee38]{display:none}.tab-content>.active[data-v-5948ee38]{display:block}.navbar[data-v-5948ee38]{position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding-top:.5rem;padding-bottom:.5rem}.navbar>.container-fluid[data-v-5948ee38],.navbar>.container-lg[data-v-5948ee38],.navbar>.container-md[data-v-5948ee38],.navbar>.container-sm[data-v-5948ee38],.navbar>.container-xl[data-v-5948ee38],.navbar>.container-xxl[data-v-5948ee38],.navbar>.container[data-v-5948ee38]{display:flex;flex-wrap:inherit;align-items:center;justify-content:space-between}.navbar-brand[data-v-5948ee38]{padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;text-decoration:none;white-space:nowrap}.navbar-nav[data-v-5948ee38]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link[data-v-5948ee38]{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu[data-v-5948ee38]{position:static}.navbar-text[data-v-5948ee38]{padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse[data-v-5948ee38]{flex-basis:100%;flex-grow:1;align-items:center}.navbar-toggler[data-v-5948ee38]{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem;transition:box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.navbar-toggler[data-v-5948ee38]{transition:none}}.navbar-toggler[data-v-5948ee38]:hover{text-decoration:none}.navbar-toggler[data-v-5948ee38]:focus{text-decoration:none;outline:0;box-shadow:0 0 0 .25rem}.navbar-toggler-icon[data-v-5948ee38]{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;background-repeat:no-repeat;background-position:50%;background-size:100%}.navbar-nav-scroll[data-v-5948ee38]{max-height:var(--bs-scroll-height,75vh);overflow-y:auto}@media (min-width:576px){.navbar-expand-sm[data-v-5948ee38]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-sm .navbar-nav[data-v-5948ee38]{flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu[data-v-5948ee38]{position:absolute}.navbar-expand-sm .navbar-nav .nav-link[data-v-5948ee38]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm .navbar-nav-scroll[data-v-5948ee38]{overflow:visible}.navbar-expand-sm .navbar-collapse[data-v-5948ee38]{display:flex!important;flex-basis:auto}.navbar-expand-sm .navbar-toggler[data-v-5948ee38],.navbar-expand-sm .offcanvas-header[data-v-5948ee38]{display:none}.navbar-expand-sm .offcanvas[data-v-5948ee38]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-sm .offcanvas-bottom[data-v-5948ee38],.navbar-expand-sm .offcanvas-top[data-v-5948ee38]{height:auto;border-top:0;border-bottom:0}.navbar-expand-sm .offcanvas-body[data-v-5948ee38]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:768px){.navbar-expand-md[data-v-5948ee38]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-md .navbar-nav[data-v-5948ee38]{flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu[data-v-5948ee38]{position:absolute}.navbar-expand-md .navbar-nav .nav-link[data-v-5948ee38]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md .navbar-nav-scroll[data-v-5948ee38]{overflow:visible}.navbar-expand-md .navbar-collapse[data-v-5948ee38]{display:flex!important;flex-basis:auto}.navbar-expand-md .navbar-toggler[data-v-5948ee38],.navbar-expand-md .offcanvas-header[data-v-5948ee38]{display:none}.navbar-expand-md .offcanvas[data-v-5948ee38]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-md .offcanvas-bottom[data-v-5948ee38],.navbar-expand-md .offcanvas-top[data-v-5948ee38]{height:auto;border-top:0;border-bottom:0}.navbar-expand-md .offcanvas-body[data-v-5948ee38]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:992px){.navbar-expand-lg[data-v-5948ee38]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-lg .navbar-nav[data-v-5948ee38]{flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu[data-v-5948ee38]{position:absolute}.navbar-expand-lg .navbar-nav .nav-link[data-v-5948ee38]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg .navbar-nav-scroll[data-v-5948ee38]{overflow:visible}.navbar-expand-lg .navbar-collapse[data-v-5948ee38]{display:flex!important;flex-basis:auto}.navbar-expand-lg .navbar-toggler[data-v-5948ee38],.navbar-expand-lg .offcanvas-header[data-v-5948ee38]{display:none}.navbar-expand-lg .offcanvas[data-v-5948ee38]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-lg .offcanvas-bottom[data-v-5948ee38],.navbar-expand-lg .offcanvas-top[data-v-5948ee38]{height:auto;border-top:0;border-bottom:0}.navbar-expand-lg .offcanvas-body[data-v-5948ee38]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1200px){.navbar-expand-xl[data-v-5948ee38]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xl .navbar-nav[data-v-5948ee38]{flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu[data-v-5948ee38]{position:absolute}.navbar-expand-xl .navbar-nav .nav-link[data-v-5948ee38]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl .navbar-nav-scroll[data-v-5948ee38]{overflow:visible}.navbar-expand-xl .navbar-collapse[data-v-5948ee38]{display:flex!important;flex-basis:auto}.navbar-expand-xl .navbar-toggler[data-v-5948ee38],.navbar-expand-xl .offcanvas-header[data-v-5948ee38]{display:none}.navbar-expand-xl .offcanvas[data-v-5948ee38]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xl .offcanvas-bottom[data-v-5948ee38],.navbar-expand-xl .offcanvas-top[data-v-5948ee38]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xl .offcanvas-body[data-v-5948ee38]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1400px){.navbar-expand-xxl[data-v-5948ee38]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xxl .navbar-nav[data-v-5948ee38]{flex-direction:row}.navbar-expand-xxl .navbar-nav .dropdown-menu[data-v-5948ee38]{position:absolute}.navbar-expand-xxl .navbar-nav .nav-link[data-v-5948ee38]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xxl .navbar-nav-scroll[data-v-5948ee38]{overflow:visible}.navbar-expand-xxl .navbar-collapse[data-v-5948ee38]{display:flex!important;flex-basis:auto}.navbar-expand-xxl .navbar-toggler[data-v-5948ee38],.navbar-expand-xxl .offcanvas-header[data-v-5948ee38]{display:none}.navbar-expand-xxl .offcanvas[data-v-5948ee38]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xxl .offcanvas-bottom[data-v-5948ee38],.navbar-expand-xxl .offcanvas-top[data-v-5948ee38]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xxl .offcanvas-body[data-v-5948ee38]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}.navbar-expand[data-v-5948ee38]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand .navbar-nav[data-v-5948ee38]{flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu[data-v-5948ee38]{position:absolute}.navbar-expand .navbar-nav .nav-link[data-v-5948ee38]{padding-right:.5rem;padding-left:.5rem}.navbar-expand .navbar-nav-scroll[data-v-5948ee38]{overflow:visible}.navbar-expand .navbar-collapse[data-v-5948ee38]{display:flex!important;flex-basis:auto}.navbar-expand .navbar-toggler[data-v-5948ee38],.navbar-expand .offcanvas-header[data-v-5948ee38]{display:none}.navbar-expand .offcanvas[data-v-5948ee38]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand .offcanvas-bottom[data-v-5948ee38],.navbar-expand .offcanvas-top[data-v-5948ee38]{height:auto;border-top:0;border-bottom:0}.navbar-expand .offcanvas-body[data-v-5948ee38]{display:flex;flex-grow:0;padding:0;overflow-y:visible}.navbar-light .navbar-brand[data-v-5948ee38],.navbar-light .navbar-brand[data-v-5948ee38]:focus,.navbar-light .navbar-brand[data-v-5948ee38]:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link[data-v-5948ee38]{color:rgba(0,0,0,.55)}.navbar-light .navbar-nav .nav-link[data-v-5948ee38]:focus,.navbar-light .navbar-nav .nav-link[data-v-5948ee38]:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled[data-v-5948ee38]{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .nav-link.active[data-v-5948ee38],.navbar-light .navbar-nav .show>.nav-link[data-v-5948ee38]{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler[data-v-5948ee38]{color:rgba(0,0,0,.55);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon[data-v-5948ee38]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(0, 0, 0, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-light .navbar-text[data-v-5948ee38]{color:rgba(0,0,0,.55)}.navbar-light .navbar-text a[data-v-5948ee38],.navbar-light .navbar-text a[data-v-5948ee38]:focus,.navbar-light .navbar-text a[data-v-5948ee38]:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand[data-v-5948ee38],.navbar-dark .navbar-brand[data-v-5948ee38]:focus,.navbar-dark .navbar-brand[data-v-5948ee38]:hover{color:#fff}.navbar-dark .navbar-nav .nav-link[data-v-5948ee38]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-nav .nav-link[data-v-5948ee38]:focus,.navbar-dark .navbar-nav .nav-link[data-v-5948ee38]:hover{color:hsla(0,0%,100%,.75)}.navbar-dark .navbar-nav .nav-link.disabled[data-v-5948ee38]{color:hsla(0,0%,100%,.25)}.navbar-dark .navbar-nav .nav-link.active[data-v-5948ee38],.navbar-dark .navbar-nav .show>.nav-link[data-v-5948ee38]{color:#fff}.navbar-dark .navbar-toggler[data-v-5948ee38]{color:hsla(0,0%,100%,.55);border-color:hsla(0,0%,100%,.1)}.navbar-dark .navbar-toggler-icon[data-v-5948ee38]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(255, 255, 255, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-dark .navbar-text[data-v-5948ee38]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-text a[data-v-5948ee38],.navbar-dark .navbar-text a[data-v-5948ee38]:focus,.navbar-dark .navbar-text a[data-v-5948ee38]:hover{color:#fff}.card[data-v-5948ee38]{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr[data-v-5948ee38]{margin-right:0;margin-left:0}.card>.list-group[data-v-5948ee38]{border-top:inherit;border-bottom:inherit}.card>.list-group[data-v-5948ee38]:first-child{border-top-width:0;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card>.list-group[data-v-5948ee38]:last-child{border-bottom-width:0;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card>.card-header+.list-group[data-v-5948ee38],.card>.list-group+.card-footer[data-v-5948ee38]{border-top:0}.card-body[data-v-5948ee38]{flex:1 1 auto;padding:1rem}.card-title[data-v-5948ee38]{margin-bottom:.5rem}.card-subtitle[data-v-5948ee38]{margin-top:-.25rem;margin-bottom:0}.card-text[data-v-5948ee38]:last-child{margin-bottom:0}.card-link+.card-link[data-v-5948ee38]{margin-left:1rem}.card-header[data-v-5948ee38]{padding:.5rem 1rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header[data-v-5948ee38]:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-footer[data-v-5948ee38]{padding:.5rem 1rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer[data-v-5948ee38]:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs[data-v-5948ee38]{margin-bottom:-.5rem;border-bottom:0}.card-header-pills[data-v-5948ee38],.card-header-tabs[data-v-5948ee38]{margin-right:-.5rem;margin-left:-.5rem}.card-img-overlay[data-v-5948ee38]{position:absolute;top:0;right:0;bottom:0;left:0;padding:1rem;border-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-5948ee38],.card-img-top[data-v-5948ee38],.card-img[data-v-5948ee38]{width:100%}.card-img-top[data-v-5948ee38],.card-img[data-v-5948ee38]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-5948ee38],.card-img[data-v-5948ee38]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-group>.card[data-v-5948ee38]{margin-bottom:.75rem}@media (min-width:576px){.card-group[data-v-5948ee38]{display:flex;flex-flow:row wrap}.card-group>.card[data-v-5948ee38]{flex:1 0 0%;margin-bottom:0}.card-group>.card+.card[data-v-5948ee38]{margin-left:0;border-left:0}.card-group>.card[data-v-5948ee38]:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-header[data-v-5948ee38],.card-group>.card:not(:last-child) .card-img-top[data-v-5948ee38]{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-footer[data-v-5948ee38],.card-group>.card:not(:last-child) .card-img-bottom[data-v-5948ee38]{border-bottom-right-radius:0}.card-group>.card[data-v-5948ee38]:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-header[data-v-5948ee38],.card-group>.card:not(:first-child) .card-img-top[data-v-5948ee38]{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-footer[data-v-5948ee38],.card-group>.card:not(:first-child) .card-img-bottom[data-v-5948ee38]{border-bottom-left-radius:0}}.accordion-button[data-v-5948ee38]{position:relative;display:flex;align-items:center;width:100%;padding:1rem 1.25rem;font-size:1rem;color:#212529;text-align:left;background-color:#fff;border:0;border-radius:0;overflow-anchor:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,border-radius .15s ease}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-5948ee38]{transition:none}}.accordion-button[data-v-5948ee38]:not(.collapsed){color:#0c63e4;background-color:#e7f1ff;box-shadow:inset 0 -1px 0 rgba(0,0,0,.125)}.accordion-button[data-v-5948ee38]:not(.collapsed):after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230c63e4'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");transform:rotate(-180deg)}.accordion-button[data-v-5948ee38]:after{flex-shrink:0;width:1.25rem;height:1.25rem;margin-left:auto;content:\"\";background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-size:1.25rem;transition:transform .2s ease-in-out}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-5948ee38]:after{transition:none}}.accordion-button[data-v-5948ee38]:hover{z-index:2}.accordion-button[data-v-5948ee38]:focus{z-index:3;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.accordion-header[data-v-5948ee38]{margin-bottom:0}.accordion-item[data-v-5948ee38]{background-color:#fff;border:1px solid rgba(0,0,0,.125)}.accordion-item[data-v-5948ee38]:first-of-type{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.accordion-item:first-of-type .accordion-button[data-v-5948ee38]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.accordion-item[data-v-5948ee38]:not(:first-of-type){border-top:0}.accordion-item[data-v-5948ee38]:last-of-type{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-item:last-of-type .accordion-button.collapsed[data-v-5948ee38]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.accordion-item:last-of-type .accordion-collapse[data-v-5948ee38]{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-body[data-v-5948ee38]{padding:1rem 1.25rem}.accordion-flush .accordion-collapse[data-v-5948ee38]{border-width:0}.accordion-flush .accordion-item[data-v-5948ee38]{border-right:0;border-left:0;border-radius:0}.accordion-flush .accordion-item[data-v-5948ee38]:first-child{border-top:0}.accordion-flush .accordion-item[data-v-5948ee38]:last-child{border-bottom:0}.accordion-flush .accordion-item .accordion-button[data-v-5948ee38]{border-radius:0}.breadcrumb[data-v-5948ee38]{display:flex;flex-wrap:wrap;padding:0;margin-bottom:1rem;list-style:none}.breadcrumb-item+.breadcrumb-item[data-v-5948ee38]{padding-left:.5rem}.breadcrumb-item+.breadcrumb-item[data-v-5948ee38]:before{float:left;padding-right:.5rem;color:#6c757d;content:var(--bs-breadcrumb-divider,\"/\")}.breadcrumb-item.active[data-v-5948ee38]{color:#6c757d}.pagination[data-v-5948ee38]{display:flex;padding-left:0;list-style:none}.page-link[data-v-5948ee38]{position:relative;display:block;color:#0d6efd;text-decoration:none;background-color:#fff;border:1px solid #dee2e6;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.page-link[data-v-5948ee38]{transition:none}}.page-link[data-v-5948ee38]:hover{z-index:2;color:#0a58ca;background-color:#e9ecef;border-color:#dee2e6}.page-link[data-v-5948ee38]:focus{z-index:3;color:#0a58ca;background-color:#e9ecef;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.page-item:not(:first-child) .page-link[data-v-5948ee38]{margin-left:-1px}.page-item.active .page-link[data-v-5948ee38]{z-index:3;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.page-item.disabled .page-link[data-v-5948ee38]{color:#6c757d;pointer-events:none;background-color:#fff;border-color:#dee2e6}.page-link[data-v-5948ee38]{padding:.375rem .75rem}.page-item:first-child .page-link[data-v-5948ee38]{border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item:last-child .page-link[data-v-5948ee38]{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.pagination-lg .page-link[data-v-5948ee38]{padding:.75rem 1.5rem;font-size:1.25rem}.pagination-lg .page-item:first-child .page-link[data-v-5948ee38]{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link[data-v-5948ee38]{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm .page-link[data-v-5948ee38]{padding:.25rem .5rem;font-size:.875rem}.pagination-sm .page-item:first-child .page-link[data-v-5948ee38]{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link[data-v-5948ee38]{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge[data-v-5948ee38]{display:inline-block;padding:.35em .65em;font-size:.75em;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}.badge[data-v-5948ee38]:empty{display:none}.btn .badge[data-v-5948ee38]{position:relative;top:-1px}.alert[data-v-5948ee38]{position:relative;padding:1rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading[data-v-5948ee38]{color:inherit}.alert-link[data-v-5948ee38]{font-weight:700}.alert-dismissible[data-v-5948ee38]{padding-right:3rem}.alert-dismissible .btn-close[data-v-5948ee38]{position:absolute;top:0;right:0;z-index:2;padding:1.25rem 1rem}.alert-primary[data-v-5948ee38]{color:#084298;background-color:#cfe2ff;border-color:#b6d4fe}.alert-primary .alert-link[data-v-5948ee38]{color:#06357a}.alert-secondary[data-v-5948ee38]{color:#41464b;background-color:#e2e3e5;border-color:#d3d6d8}.alert-secondary .alert-link[data-v-5948ee38]{color:#34383c}.alert-success[data-v-5948ee38]{color:#0f5132;background-color:#d1e7dd;border-color:#badbcc}.alert-success .alert-link[data-v-5948ee38]{color:#0c4128}.alert-info[data-v-5948ee38]{color:#055160;background-color:#cff4fc;border-color:#b6effb}.alert-info .alert-link[data-v-5948ee38]{color:#04414d}.alert-warning[data-v-5948ee38]{color:#664d03;background-color:#fff3cd;border-color:#ffecb5}.alert-warning .alert-link[data-v-5948ee38]{color:#523e02}.alert-danger[data-v-5948ee38]{color:#842029;background-color:#f8d7da;border-color:#f5c2c7}.alert-danger .alert-link[data-v-5948ee38]{color:#6a1a21}.alert-light[data-v-5948ee38]{color:#636464;background-color:#fefefe;border-color:#fdfdfe}.alert-light .alert-link[data-v-5948ee38]{color:#4f5050}.alert-dark[data-v-5948ee38]{color:#141619;background-color:#d3d3d4;border-color:#bcbebf}.alert-dark .alert-link[data-v-5948ee38]{color:#101214}@-webkit-keyframes progress-bar-stripes-data-v-5948ee38{0%{background-position-x:1rem}}@keyframes progress-bar-stripes-data-v-5948ee38{0%{background-position-x:1rem}}.progress[data-v-5948ee38]{display:flex;height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress-bar[data-v-5948ee38]{display:flex;flex-direction:column;justify-content:center;overflow:hidden;color:#fff;text-align:center;white-space:nowrap;background-color:#0d6efd;transition:width .6s ease}@media (prefers-reduced-motion:reduce){.progress-bar[data-v-5948ee38]{transition:none}}.progress-bar-striped[data-v-5948ee38]{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-bar-animated[data-v-5948ee38]{-webkit-animation:1s linear infinite progress-bar-stripes-data-v-5948ee38;animation:1s linear infinite progress-bar-stripes-data-v-5948ee38}@media (prefers-reduced-motion:reduce){.progress-bar-animated[data-v-5948ee38]{-webkit-animation:none;animation:none}}.list-group[data-v-5948ee38]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:.25rem}.list-group-numbered[data-v-5948ee38]{list-style-type:none;counter-reset:section}.list-group-numbered>li[data-v-5948ee38]:before{content:counters(section,\".\") \". \";counter-increment:section}.list-group-item-action[data-v-5948ee38]{width:100%;color:#495057;text-align:inherit}.list-group-item-action[data-v-5948ee38]:focus,.list-group-item-action[data-v-5948ee38]:hover{z-index:1;color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action[data-v-5948ee38]:active{color:#212529;background-color:#e9ecef}.list-group-item[data-v-5948ee38]{position:relative;display:block;padding:.5rem 1rem;color:#212529;text-decoration:none;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item[data-v-5948ee38]:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.list-group-item[data-v-5948ee38]:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.list-group-item.disabled[data-v-5948ee38],.list-group-item[data-v-5948ee38]:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.list-group-item.active[data-v-5948ee38]{z-index:2;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.list-group-item+.list-group-item[data-v-5948ee38]{border-top-width:0}.list-group-item+.list-group-item.active[data-v-5948ee38]{margin-top:-1px;border-top-width:1px}.list-group-horizontal[data-v-5948ee38]{flex-direction:row}.list-group-horizontal>.list-group-item[data-v-5948ee38]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal>.list-group-item[data-v-5948ee38]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal>.list-group-item.active[data-v-5948ee38]{margin-top:0}.list-group-horizontal>.list-group-item+.list-group-item[data-v-5948ee38]{border-top-width:1px;border-left-width:0}.list-group-horizontal>.list-group-item+.list-group-item.active[data-v-5948ee38]{margin-left:-1px;border-left-width:1px}@media (min-width:576px){.list-group-horizontal-sm[data-v-5948ee38]{flex-direction:row}.list-group-horizontal-sm>.list-group-item[data-v-5948ee38]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-sm>.list-group-item[data-v-5948ee38]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-sm>.list-group-item.active[data-v-5948ee38]{margin-top:0}.list-group-horizontal-sm>.list-group-item+.list-group-item[data-v-5948ee38]{border-top-width:1px;border-left-width:0}.list-group-horizontal-sm>.list-group-item+.list-group-item.active[data-v-5948ee38]{margin-left:-1px;border-left-width:1px}}@media (min-width:768px){.list-group-horizontal-md[data-v-5948ee38]{flex-direction:row}.list-group-horizontal-md>.list-group-item[data-v-5948ee38]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-md>.list-group-item[data-v-5948ee38]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-md>.list-group-item.active[data-v-5948ee38]{margin-top:0}.list-group-horizontal-md>.list-group-item+.list-group-item[data-v-5948ee38]{border-top-width:1px;border-left-width:0}.list-group-horizontal-md>.list-group-item+.list-group-item.active[data-v-5948ee38]{margin-left:-1px;border-left-width:1px}}@media (min-width:992px){.list-group-horizontal-lg[data-v-5948ee38]{flex-direction:row}.list-group-horizontal-lg>.list-group-item[data-v-5948ee38]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-lg>.list-group-item[data-v-5948ee38]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-lg>.list-group-item.active[data-v-5948ee38]{margin-top:0}.list-group-horizontal-lg>.list-group-item+.list-group-item[data-v-5948ee38]{border-top-width:1px;border-left-width:0}.list-group-horizontal-lg>.list-group-item+.list-group-item.active[data-v-5948ee38]{margin-left:-1px;border-left-width:1px}}@media (min-width:1200px){.list-group-horizontal-xl[data-v-5948ee38]{flex-direction:row}.list-group-horizontal-xl>.list-group-item[data-v-5948ee38]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xl>.list-group-item[data-v-5948ee38]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xl>.list-group-item.active[data-v-5948ee38]{margin-top:0}.list-group-horizontal-xl>.list-group-item+.list-group-item[data-v-5948ee38]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xl>.list-group-item+.list-group-item.active[data-v-5948ee38]{margin-left:-1px;border-left-width:1px}}@media (min-width:1400px){.list-group-horizontal-xxl[data-v-5948ee38]{flex-direction:row}.list-group-horizontal-xxl>.list-group-item[data-v-5948ee38]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xxl>.list-group-item[data-v-5948ee38]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xxl>.list-group-item.active[data-v-5948ee38]{margin-top:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item[data-v-5948ee38]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item.active[data-v-5948ee38]{margin-left:-1px;border-left-width:1px}}.list-group-flush[data-v-5948ee38]{border-radius:0}.list-group-flush>.list-group-item[data-v-5948ee38]{border-width:0 0 1px}.list-group-flush>.list-group-item[data-v-5948ee38]:last-child{border-bottom-width:0}.list-group-item-primary[data-v-5948ee38]{color:#084298;background-color:#cfe2ff}.list-group-item-primary.list-group-item-action[data-v-5948ee38]:focus,.list-group-item-primary.list-group-item-action[data-v-5948ee38]:hover{color:#084298;background-color:#bacbe6}.list-group-item-primary.list-group-item-action.active[data-v-5948ee38]{color:#fff;background-color:#084298;border-color:#084298}.list-group-item-secondary[data-v-5948ee38]{color:#41464b;background-color:#e2e3e5}.list-group-item-secondary.list-group-item-action[data-v-5948ee38]:focus,.list-group-item-secondary.list-group-item-action[data-v-5948ee38]:hover{color:#41464b;background-color:#cbccce}.list-group-item-secondary.list-group-item-action.active[data-v-5948ee38]{color:#fff;background-color:#41464b;border-color:#41464b}.list-group-item-success[data-v-5948ee38]{color:#0f5132;background-color:#d1e7dd}.list-group-item-success.list-group-item-action[data-v-5948ee38]:focus,.list-group-item-success.list-group-item-action[data-v-5948ee38]:hover{color:#0f5132;background-color:#bcd0c7}.list-group-item-success.list-group-item-action.active[data-v-5948ee38]{color:#fff;background-color:#0f5132;border-color:#0f5132}.list-group-item-info[data-v-5948ee38]{color:#055160;background-color:#cff4fc}.list-group-item-info.list-group-item-action[data-v-5948ee38]:focus,.list-group-item-info.list-group-item-action[data-v-5948ee38]:hover{color:#055160;background-color:#badce3}.list-group-item-info.list-group-item-action.active[data-v-5948ee38]{color:#fff;background-color:#055160;border-color:#055160}.list-group-item-warning[data-v-5948ee38]{color:#664d03;background-color:#fff3cd}.list-group-item-warning.list-group-item-action[data-v-5948ee38]:focus,.list-group-item-warning.list-group-item-action[data-v-5948ee38]:hover{color:#664d03;background-color:#e6dbb9}.list-group-item-warning.list-group-item-action.active[data-v-5948ee38]{color:#fff;background-color:#664d03;border-color:#664d03}.list-group-item-danger[data-v-5948ee38]{color:#842029;background-color:#f8d7da}.list-group-item-danger.list-group-item-action[data-v-5948ee38]:focus,.list-group-item-danger.list-group-item-action[data-v-5948ee38]:hover{color:#842029;background-color:#dfc2c4}.list-group-item-danger.list-group-item-action.active[data-v-5948ee38]{color:#fff;background-color:#842029;border-color:#842029}.list-group-item-light[data-v-5948ee38]{color:#636464;background-color:#fefefe}.list-group-item-light.list-group-item-action[data-v-5948ee38]:focus,.list-group-item-light.list-group-item-action[data-v-5948ee38]:hover{color:#636464;background-color:#e5e5e5}.list-group-item-light.list-group-item-action.active[data-v-5948ee38]{color:#fff;background-color:#636464;border-color:#636464}.list-group-item-dark[data-v-5948ee38]{color:#141619;background-color:#d3d3d4}.list-group-item-dark.list-group-item-action[data-v-5948ee38]:focus,.list-group-item-dark.list-group-item-action[data-v-5948ee38]:hover{color:#141619;background-color:#bebebf}.list-group-item-dark.list-group-item-action.active[data-v-5948ee38]{color:#fff;background-color:#141619;border-color:#141619}.btn-close[data-v-5948ee38]{box-sizing:content-box;width:1em;height:1em;padding:.25em;color:#000;background:transparent url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M.293.293a1 1 0 11.414 0 NaN NaNlNaN NaN NaN NaNa1 1 0 111.414 1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 10-1.414 NaN NaNz'/%3E%3C/svg%3E\") 50%/1em auto no-repeat;border:0;border-radius:.25rem;opacity:.5}.btn-close[data-v-5948ee38]:hover{color:#000;text-decoration:none;opacity:.75}.btn-close[data-v-5948ee38]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25);opacity:1}.btn-close.disabled[data-v-5948ee38],.btn-close[data-v-5948ee38]:disabled{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;opacity:.25}.btn-close-white[data-v-5948ee38]{filter:invert(1) grayscale(100%) brightness(200%)}.toast[data-v-5948ee38]{width:350px;max-width:100%;font-size:.875rem;pointer-events:auto;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .5rem 1rem rgba(0,0,0,.15);border-radius:.25rem}.toast.showing[data-v-5948ee38]{opacity:0}.toast[data-v-5948ee38]:not(.show){display:none}.toast-container[data-v-5948ee38]{width:-webkit-max-content;width:-moz-max-content;width:max-content;max-width:100%;pointer-events:none}.toast-container[data-v-5948ee38]>:not(:last-child){margin-bottom:.75rem}.toast-header[data-v-5948ee38]{display:flex;align-items:center;padding:.5rem .75rem;color:#6c757d;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05);border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.toast-header .btn-close[data-v-5948ee38]{margin-right:-.375rem;margin-left:.75rem}.toast-body[data-v-5948ee38]{padding:.75rem;word-wrap:break-word}.modal[data-v-5948ee38]{position:fixed;top:0;left:0;z-index:1055;display:none;width:100%;height:100%;overflow-x:hidden;overflow-y:auto;outline:0}.modal-dialog[data-v-5948ee38]{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog[data-v-5948ee38]{transition:transform .3s ease-out;transform:translateY(-50px)}@media (prefers-reduced-motion:reduce){.modal.fade .modal-dialog[data-v-5948ee38]{transition:none}}.modal.show .modal-dialog[data-v-5948ee38]{transform:none}.modal.modal-static .modal-dialog[data-v-5948ee38]{transform:scale(1.02)}.modal-dialog-scrollable[data-v-5948ee38]{height:calc(100% - 1rem)}.modal-dialog-scrollable .modal-content[data-v-5948ee38]{max-height:100%;overflow:hidden}.modal-dialog-scrollable .modal-body[data-v-5948ee38]{overflow-y:auto}.modal-dialog-centered[data-v-5948ee38]{display:flex;align-items:center;min-height:calc(100% - 1rem)}.modal-content[data-v-5948ee38]{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop[data-v-5948ee38]{position:fixed;top:0;left:0;z-index:1050;width:100vw;height:100vh;background-color:#000}.modal-backdrop.fade[data-v-5948ee38]{opacity:0}.modal-backdrop.show[data-v-5948ee38]{opacity:.5}.modal-header[data-v-5948ee38]{display:flex;flex-shrink:0;align-items:center;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.modal-header .btn-close[data-v-5948ee38]{padding:.5rem;margin:-.5rem -.5rem -.5rem auto}.modal-title[data-v-5948ee38]{margin-bottom:0;line-height:1.5}.modal-body[data-v-5948ee38]{position:relative;flex:1 1 auto;padding:1rem}.modal-footer[data-v-5948ee38]{display:flex;flex-wrap:wrap;flex-shrink:0;align-items:center;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.modal-footer>[data-v-5948ee38]{margin:.25rem}@media (min-width:576px){.modal-dialog[data-v-5948ee38]{max-width:500px;margin:1.75rem auto}.modal-dialog-scrollable[data-v-5948ee38]{height:calc(100% - 3.5rem)}.modal-dialog-centered[data-v-5948ee38]{min-height:calc(100% - 3.5rem)}.modal-sm[data-v-5948ee38]{max-width:300px}}@media (min-width:992px){.modal-lg[data-v-5948ee38],.modal-xl[data-v-5948ee38]{max-width:800px}}@media (min-width:1200px){.modal-xl[data-v-5948ee38]{max-width:1140px}}.modal-fullscreen[data-v-5948ee38]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen .modal-content[data-v-5948ee38]{height:100%;border:0;border-radius:0}.modal-fullscreen .modal-header[data-v-5948ee38]{border-radius:0}.modal-fullscreen .modal-body[data-v-5948ee38]{overflow-y:auto}.modal-fullscreen .modal-footer[data-v-5948ee38]{border-radius:0}@media (max-width:575.98px){.modal-fullscreen-sm-down[data-v-5948ee38]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-sm-down .modal-content[data-v-5948ee38]{height:100%;border:0;border-radius:0}.modal-fullscreen-sm-down .modal-header[data-v-5948ee38]{border-radius:0}.modal-fullscreen-sm-down .modal-body[data-v-5948ee38]{overflow-y:auto}.modal-fullscreen-sm-down .modal-footer[data-v-5948ee38]{border-radius:0}}@media (max-width:767.98px){.modal-fullscreen-md-down[data-v-5948ee38]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-md-down .modal-content[data-v-5948ee38]{height:100%;border:0;border-radius:0}.modal-fullscreen-md-down .modal-header[data-v-5948ee38]{border-radius:0}.modal-fullscreen-md-down .modal-body[data-v-5948ee38]{overflow-y:auto}.modal-fullscreen-md-down .modal-footer[data-v-5948ee38]{border-radius:0}}@media (max-width:991.98px){.modal-fullscreen-lg-down[data-v-5948ee38]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-lg-down .modal-content[data-v-5948ee38]{height:100%;border:0;border-radius:0}.modal-fullscreen-lg-down .modal-header[data-v-5948ee38]{border-radius:0}.modal-fullscreen-lg-down .modal-body[data-v-5948ee38]{overflow-y:auto}.modal-fullscreen-lg-down .modal-footer[data-v-5948ee38]{border-radius:0}}@media (max-width:1199.98px){.modal-fullscreen-xl-down[data-v-5948ee38]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xl-down .modal-content[data-v-5948ee38]{height:100%;border:0;border-radius:0}.modal-fullscreen-xl-down .modal-header[data-v-5948ee38]{border-radius:0}.modal-fullscreen-xl-down .modal-body[data-v-5948ee38]{overflow-y:auto}.modal-fullscreen-xl-down .modal-footer[data-v-5948ee38]{border-radius:0}}@media (max-width:1399.98px){.modal-fullscreen-xxl-down[data-v-5948ee38]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xxl-down .modal-content[data-v-5948ee38]{height:100%;border:0;border-radius:0}.modal-fullscreen-xxl-down .modal-header[data-v-5948ee38]{border-radius:0}.modal-fullscreen-xxl-down .modal-body[data-v-5948ee38]{overflow-y:auto}.modal-fullscreen-xxl-down .modal-footer[data-v-5948ee38]{border-radius:0}}.tooltip[data-v-5948ee38]{position:absolute;z-index:1080;display:block;margin:0;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show[data-v-5948ee38]{opacity:.9}.tooltip .tooltip-arrow[data-v-5948ee38]{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .tooltip-arrow[data-v-5948ee38]:before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[data-popper-placement^=top][data-v-5948ee38],.bs-tooltip-top[data-v-5948ee38]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-5948ee38],.bs-tooltip-top .tooltip-arrow[data-v-5948ee38]{bottom:0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-5948ee38]:before,.bs-tooltip-top .tooltip-arrow[data-v-5948ee38]:before{top:-1px;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[data-popper-placement^=right][data-v-5948ee38],.bs-tooltip-end[data-v-5948ee38]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-5948ee38],.bs-tooltip-end .tooltip-arrow[data-v-5948ee38]{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-5948ee38]:before,.bs-tooltip-end .tooltip-arrow[data-v-5948ee38]:before{right:-1px;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[data-popper-placement^=bottom][data-v-5948ee38],.bs-tooltip-bottom[data-v-5948ee38]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-5948ee38],.bs-tooltip-bottom .tooltip-arrow[data-v-5948ee38]{top:0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-5948ee38]:before,.bs-tooltip-bottom .tooltip-arrow[data-v-5948ee38]:before{bottom:-1px;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[data-popper-placement^=left][data-v-5948ee38],.bs-tooltip-start[data-v-5948ee38]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-5948ee38],.bs-tooltip-start .tooltip-arrow[data-v-5948ee38]{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-5948ee38]:before,.bs-tooltip-start .tooltip-arrow[data-v-5948ee38]:before{left:-1px;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner[data-v-5948ee38]{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover[data-v-5948ee38]{position:absolute;top:0;left:0;z-index:1070;display:block;max-width:276px;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover .popover-arrow[data-v-5948ee38]{position:absolute;display:block;width:1rem;height:.5rem}.popover .popover-arrow[data-v-5948ee38]:after,.popover .popover-arrow[data-v-5948ee38]:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-5948ee38],.bs-popover-top>.popover-arrow[data-v-5948ee38]{bottom:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-5948ee38]:before,.bs-popover-top>.popover-arrow[data-v-5948ee38]:before{bottom:0;border-width:.5rem .5rem 0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-5948ee38]:after,.bs-popover-top>.popover-arrow[data-v-5948ee38]:after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:#fff}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-5948ee38],.bs-popover-end>.popover-arrow[data-v-5948ee38]{left:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-5948ee38]:before,.bs-popover-end>.popover-arrow[data-v-5948ee38]:before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-5948ee38]:after,.bs-popover-end>.popover-arrow[data-v-5948ee38]:after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:#fff}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-5948ee38],.bs-popover-bottom>.popover-arrow[data-v-5948ee38]{top:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-5948ee38]:before,.bs-popover-bottom>.popover-arrow[data-v-5948ee38]:before{top:0;border-width:0 .5rem .5rem;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-5948ee38]:after,.bs-popover-bottom>.popover-arrow[data-v-5948ee38]:after{top:1px;border-width:0 .5rem .5rem;border-bottom-color:#fff}.bs-popover-auto[data-popper-placement^=bottom] .popover-header[data-v-5948ee38]:before,.bs-popover-bottom .popover-header[data-v-5948ee38]:before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f0f0f0}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-5948ee38],.bs-popover-start>.popover-arrow[data-v-5948ee38]{right:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-5948ee38]:before,.bs-popover-start>.popover-arrow[data-v-5948ee38]:before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-5948ee38]:after,.bs-popover-start>.popover-arrow[data-v-5948ee38]:after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:#fff}.popover-header[data-v-5948ee38]{padding:.5rem 1rem;margin-bottom:0;font-size:1rem;background-color:#f0f0f0;border-bottom:1px solid rgba(0,0,0,.2);border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header[data-v-5948ee38]:empty{display:none}.popover-body[data-v-5948ee38]{padding:1rem;color:#212529}.carousel[data-v-5948ee38]{position:relative}.carousel.pointer-event[data-v-5948ee38]{touch-action:pan-y}.carousel-inner[data-v-5948ee38]{position:relative;width:100%;overflow:hidden}.carousel-inner[data-v-5948ee38]:after{display:block;clear:both;content:\"\"}.carousel-item[data-v-5948ee38]{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.carousel-item[data-v-5948ee38]{transition:none}}.carousel-item-next[data-v-5948ee38],.carousel-item-prev[data-v-5948ee38],.carousel-item.active[data-v-5948ee38]{display:block}.active.carousel-item-end[data-v-5948ee38],.carousel-item-next[data-v-5948ee38]:not(.carousel-item-start){transform:translateX(100%)}.active.carousel-item-start[data-v-5948ee38],.carousel-item-prev[data-v-5948ee38]:not(.carousel-item-end){transform:translateX(-100%)}.carousel-fade .carousel-item[data-v-5948ee38]{opacity:0;transition-property:opacity;transform:none}.carousel-fade .carousel-item-next.carousel-item-start[data-v-5948ee38],.carousel-fade .carousel-item-prev.carousel-item-end[data-v-5948ee38],.carousel-fade .carousel-item.active[data-v-5948ee38]{z-index:1;opacity:1}.carousel-fade .active.carousel-item-end[data-v-5948ee38],.carousel-fade .active.carousel-item-start[data-v-5948ee38]{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.carousel-fade .active.carousel-item-end[data-v-5948ee38],.carousel-fade .active.carousel-item-start[data-v-5948ee38]{transition:none}}.carousel-control-next[data-v-5948ee38],.carousel-control-prev[data-v-5948ee38]{position:absolute;top:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center;width:15%;padding:0;color:#fff;text-align:center;background:0 0;border:0;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.carousel-control-next[data-v-5948ee38],.carousel-control-prev[data-v-5948ee38]{transition:none}}.carousel-control-next[data-v-5948ee38]:focus,.carousel-control-next[data-v-5948ee38]:hover,.carousel-control-prev[data-v-5948ee38]:focus,.carousel-control-prev[data-v-5948ee38]:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev[data-v-5948ee38]{left:0}.carousel-control-next[data-v-5948ee38]{right:0}.carousel-control-next-icon[data-v-5948ee38],.carousel-control-prev-icon[data-v-5948ee38]{display:inline-block;width:2rem;height:2rem;background-repeat:no-repeat;background-position:50%;background-size:100% 100%}.carousel-control-prev-icon[data-v-5948ee38]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3E%3C/svg%3E\")}.carousel-control-next-icon[data-v-5948ee38]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\")}.carousel-indicators[data-v-5948ee38]{position:absolute;right:0;bottom:0;left:0;z-index:2;display:flex;justify-content:center;padding:0;margin-right:15%;margin-bottom:1rem;margin-left:15%;list-style:none}.carousel-indicators [data-bs-target][data-v-5948ee38]{box-sizing:content-box;flex:0 1 auto;width:30px;height:3px;padding:0;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border:0;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.carousel-indicators [data-bs-target][data-v-5948ee38]{transition:none}}.carousel-indicators .active[data-v-5948ee38]{opacity:1}.carousel-caption[data-v-5948ee38]{position:absolute;right:15%;bottom:1.25rem;left:15%;padding-top:1.25rem;padding-bottom:1.25rem;color:#fff;text-align:center}.carousel-dark .carousel-control-next-icon[data-v-5948ee38],.carousel-dark .carousel-control-prev-icon[data-v-5948ee38]{filter:invert(1) grayscale(100)}.carousel-dark .carousel-indicators [data-bs-target][data-v-5948ee38]{background-color:#000}.carousel-dark .carousel-caption[data-v-5948ee38]{color:#000}@-webkit-keyframes spinner-border-data-v-5948ee38{to{transform:rotate(1turn)}}@keyframes spinner-border-data-v-5948ee38{to{transform:rotate(1turn)}}.spinner-border[data-v-5948ee38]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:.75s linear infinite spinner-border-data-v-5948ee38;animation:.75s linear infinite spinner-border-data-v-5948ee38}.spinner-border-sm[data-v-5948ee38]{width:1rem;height:1rem;border-width:.2em}@-webkit-keyframes spinner-grow-data-v-5948ee38{0%{transform:scale(0)}50%{opacity:1;transform:none}}@keyframes spinner-grow-data-v-5948ee38{0%{transform:scale(0)}50%{opacity:1;transform:none}}.spinner-grow[data-v-5948ee38]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;background-color:currentColor;border-radius:50%;opacity:0;-webkit-animation:.75s linear infinite spinner-grow-data-v-5948ee38;animation:.75s linear infinite spinner-grow-data-v-5948ee38}.spinner-grow-sm[data-v-5948ee38]{width:1rem;height:1rem}@media (prefers-reduced-motion:reduce){.spinner-border[data-v-5948ee38],.spinner-grow[data-v-5948ee38]{-webkit-animation-duration:1.5s;animation-duration:1.5s}}.offcanvas[data-v-5948ee38]{position:fixed;bottom:0;z-index:1045;display:flex;flex-direction:column;max-width:100%;visibility:hidden;background-color:#fff;background-clip:padding-box;outline:0;transition:transform .3s ease-in-out}@media (prefers-reduced-motion:reduce){.offcanvas[data-v-5948ee38]{transition:none}}.offcanvas-backdrop[data-v-5948ee38]{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.offcanvas-backdrop.fade[data-v-5948ee38]{opacity:0}.offcanvas-backdrop.show[data-v-5948ee38]{opacity:.5}.offcanvas-header[data-v-5948ee38]{display:flex;align-items:center;justify-content:space-between;padding:1rem}.offcanvas-header .btn-close[data-v-5948ee38]{padding:.5rem;margin-top:-.5rem;margin-right:-.5rem;margin-bottom:-.5rem}.offcanvas-title[data-v-5948ee38]{margin-bottom:0;line-height:1.5}.offcanvas-body[data-v-5948ee38]{flex-grow:1;padding:1rem;overflow-y:auto}.offcanvas-start[data-v-5948ee38]{top:0;left:0;width:400px;border-right:1px solid rgba(0,0,0,.2);transform:translateX(-100%)}.offcanvas-end[data-v-5948ee38]{top:0;right:0;width:400px;border-left:1px solid rgba(0,0,0,.2);transform:translateX(100%)}.offcanvas-top[data-v-5948ee38]{top:0;right:0;left:0;height:30vh;max-height:100%;border-bottom:1px solid rgba(0,0,0,.2);transform:translateY(-100%)}.offcanvas-bottom[data-v-5948ee38]{right:0;left:0;height:30vh;max-height:100%;border-top:1px solid rgba(0,0,0,.2);transform:translateY(100%)}.offcanvas.show[data-v-5948ee38]{transform:none}.placeholder[data-v-5948ee38]{display:inline-block;min-height:1em;vertical-align:middle;cursor:wait;background-color:currentColor;opacity:.5}.placeholder.btn[data-v-5948ee38]:before{display:inline-block;content:\"\"}.placeholder-xs[data-v-5948ee38]{min-height:.6em}.placeholder-sm[data-v-5948ee38]{min-height:.8em}.placeholder-lg[data-v-5948ee38]{min-height:1.2em}.placeholder-glow .placeholder[data-v-5948ee38]{-webkit-animation:placeholder-glow-data-v-5948ee38 2s ease-in-out infinite;animation:placeholder-glow-data-v-5948ee38 2s ease-in-out infinite}@-webkit-keyframes placeholder-glow-data-v-5948ee38{50%{opacity:.2}}@keyframes placeholder-glow-data-v-5948ee38{50%{opacity:.2}}.placeholder-wave[data-v-5948ee38]{-webkit-mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);-webkit-mask-size:200% 100%;mask-size:200% 100%;-webkit-animation:placeholder-wave-data-v-5948ee38 2s linear infinite;animation:placeholder-wave-data-v-5948ee38 2s linear infinite}@-webkit-keyframes placeholder-wave-data-v-5948ee38{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}@keyframes placeholder-wave-data-v-5948ee38{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}.clearfix[data-v-5948ee38]:after{display:block;clear:both;content:\"\"}.link-primary[data-v-5948ee38]{color:#0d6efd}.link-primary[data-v-5948ee38]:focus,.link-primary[data-v-5948ee38]:hover{color:#0a58ca}.link-secondary[data-v-5948ee38]{color:#6c757d}.link-secondary[data-v-5948ee38]:focus,.link-secondary[data-v-5948ee38]:hover{color:#565e64}.link-success[data-v-5948ee38]{color:#198754}.link-success[data-v-5948ee38]:focus,.link-success[data-v-5948ee38]:hover{color:#146c43}.link-info[data-v-5948ee38]{color:#0dcaf0}.link-info[data-v-5948ee38]:focus,.link-info[data-v-5948ee38]:hover{color:#3dd5f3}.link-warning[data-v-5948ee38]{color:#ffc107}.link-warning[data-v-5948ee38]:focus,.link-warning[data-v-5948ee38]:hover{color:#ffcd39}.link-danger[data-v-5948ee38]{color:#dc3545}.link-danger[data-v-5948ee38]:focus,.link-danger[data-v-5948ee38]:hover{color:#b02a37}.link-light[data-v-5948ee38]{color:#f8f9fa}.link-light[data-v-5948ee38]:focus,.link-light[data-v-5948ee38]:hover{color:#f9fafb}.link-dark[data-v-5948ee38]{color:#212529}.link-dark[data-v-5948ee38]:focus,.link-dark[data-v-5948ee38]:hover{color:#1a1e21}.ratio[data-v-5948ee38]{position:relative;width:100%}.ratio[data-v-5948ee38]:before{display:block;padding-top:var(--bs-aspect-ratio);content:\"\"}.ratio>[data-v-5948ee38]{position:absolute;top:0;left:0;width:100%;height:100%}.ratio-1x1[data-v-5948ee38]{--bs-aspect-ratio:100%}.ratio-4x3[data-v-5948ee38]{--bs-aspect-ratio:75%}.ratio-16x9[data-v-5948ee38]{--bs-aspect-ratio:56.25%}.ratio-21x9[data-v-5948ee38]{--bs-aspect-ratio:42.8571428571%}.fixed-top[data-v-5948ee38]{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom[data-v-5948ee38]{position:fixed;right:0;bottom:0;left:0;z-index:1030}.sticky-top[data-v-5948ee38]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}@media (min-width:576px){.sticky-sm-top[data-v-5948ee38]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:768px){.sticky-md-top[data-v-5948ee38]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:992px){.sticky-lg-top[data-v-5948ee38]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1200px){.sticky-xl-top[data-v-5948ee38]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1400px){.sticky-xxl-top[data-v-5948ee38]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.hstack[data-v-5948ee38]{display:flex;flex-direction:row;align-items:center;align-self:stretch}.vstack[data-v-5948ee38]{display:flex;flex:1 1 auto;flex-direction:column;align-self:stretch}.visually-hidden-focusable[data-v-5948ee38]:not(:focus):not(:focus-within),.visually-hidden[data-v-5948ee38]{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}.stretched-link[data-v-5948ee38]:after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;content:\"\"}.text-truncate[data-v-5948ee38]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.vr[data-v-5948ee38]{display:inline-block;align-self:stretch;width:1px;min-height:1em;background-color:currentColor;opacity:.25}.align-baseline[data-v-5948ee38]{vertical-align:baseline!important}.align-top[data-v-5948ee38]{vertical-align:top!important}.align-middle[data-v-5948ee38]{vertical-align:middle!important}.align-bottom[data-v-5948ee38]{vertical-align:bottom!important}.align-text-bottom[data-v-5948ee38]{vertical-align:text-bottom!important}.align-text-top[data-v-5948ee38]{vertical-align:text-top!important}.float-start[data-v-5948ee38]{float:left!important}.float-end[data-v-5948ee38]{float:right!important}.float-none[data-v-5948ee38]{float:none!important}.opacity-0[data-v-5948ee38]{opacity:0!important}.opacity-25[data-v-5948ee38]{opacity:.25!important}.opacity-50[data-v-5948ee38]{opacity:.5!important}.opacity-75[data-v-5948ee38]{opacity:.75!important}.opacity-100[data-v-5948ee38]{opacity:1!important}.overflow-auto[data-v-5948ee38]{overflow:auto!important}.overflow-hidden[data-v-5948ee38]{overflow:hidden!important}.overflow-visible[data-v-5948ee38]{overflow:visible!important}.overflow-scroll[data-v-5948ee38]{overflow:scroll!important}.d-inline[data-v-5948ee38]{display:inline!important}.d-inline-block[data-v-5948ee38]{display:inline-block!important}.d-block[data-v-5948ee38]{display:block!important}.d-grid[data-v-5948ee38]{display:grid!important}.d-table[data-v-5948ee38]{display:table!important}.d-table-row[data-v-5948ee38]{display:table-row!important}.d-table-cell[data-v-5948ee38]{display:table-cell!important}.d-flex[data-v-5948ee38]{display:flex!important}.d-inline-flex[data-v-5948ee38]{display:inline-flex!important}.d-none[data-v-5948ee38]{display:none!important}.shadow[data-v-5948ee38]{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.shadow-sm[data-v-5948ee38]{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.shadow-lg[data-v-5948ee38]{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.shadow-none[data-v-5948ee38]{box-shadow:none!important}.position-static[data-v-5948ee38]{position:static!important}.position-relative[data-v-5948ee38]{position:relative!important}.position-absolute[data-v-5948ee38]{position:absolute!important}.position-fixed[data-v-5948ee38]{position:fixed!important}.position-sticky[data-v-5948ee38]{position:-webkit-sticky!important;position:sticky!important}.top-0[data-v-5948ee38]{top:0!important}.top-50[data-v-5948ee38]{top:50%!important}.top-100[data-v-5948ee38]{top:100%!important}.bottom-0[data-v-5948ee38]{bottom:0!important}.bottom-50[data-v-5948ee38]{bottom:50%!important}.bottom-100[data-v-5948ee38]{bottom:100%!important}.start-0[data-v-5948ee38]{left:0!important}.start-50[data-v-5948ee38]{left:50%!important}.start-100[data-v-5948ee38]{left:100%!important}.end-0[data-v-5948ee38]{right:0!important}.end-50[data-v-5948ee38]{right:50%!important}.end-100[data-v-5948ee38]{right:100%!important}.translate-middle[data-v-5948ee38]{transform:translate(-50%,-50%)!important}.translate-middle-x[data-v-5948ee38]{transform:translateX(-50%)!important}.translate-middle-y[data-v-5948ee38]{transform:translateY(-50%)!important}.border[data-v-5948ee38]{border:1px solid #dee2e6!important}.border-0[data-v-5948ee38]{border:0!important}.border-top[data-v-5948ee38]{border-top:1px solid #dee2e6!important}.border-top-0[data-v-5948ee38]{border-top:0!important}.border-end[data-v-5948ee38]{border-right:1px solid #dee2e6!important}.border-end-0[data-v-5948ee38]{border-right:0!important}.border-bottom[data-v-5948ee38]{border-bottom:1px solid #dee2e6!important}.border-bottom-0[data-v-5948ee38]{border-bottom:0!important}.border-start[data-v-5948ee38]{border-left:1px solid #dee2e6!important}.border-start-0[data-v-5948ee38]{border-left:0!important}.border-primary[data-v-5948ee38]{border-color:#0d6efd!important}.border-secondary[data-v-5948ee38]{border-color:#6c757d!important}.border-success[data-v-5948ee38]{border-color:#198754!important}.border-info[data-v-5948ee38]{border-color:#0dcaf0!important}.border-warning[data-v-5948ee38]{border-color:#ffc107!important}.border-danger[data-v-5948ee38]{border-color:#dc3545!important}.border-light[data-v-5948ee38]{border-color:#f8f9fa!important}.border-dark[data-v-5948ee38]{border-color:#212529!important}.border-white[data-v-5948ee38]{border-color:#fff!important}.border-1[data-v-5948ee38]{border-width:1px!important}.border-2[data-v-5948ee38]{border-width:2px!important}.border-3[data-v-5948ee38]{border-width:3px!important}.border-4[data-v-5948ee38]{border-width:4px!important}.border-5[data-v-5948ee38]{border-width:5px!important}.w-25[data-v-5948ee38]{width:25%!important}.w-50[data-v-5948ee38]{width:50%!important}.w-75[data-v-5948ee38]{width:75%!important}.w-100[data-v-5948ee38]{width:100%!important}.w-auto[data-v-5948ee38]{width:auto!important}.mw-100[data-v-5948ee38]{max-width:100%!important}.vw-100[data-v-5948ee38]{width:100vw!important}.min-vw-100[data-v-5948ee38]{min-width:100vw!important}.h-25[data-v-5948ee38]{height:25%!important}.h-50[data-v-5948ee38]{height:50%!important}.h-75[data-v-5948ee38]{height:75%!important}.h-100[data-v-5948ee38]{height:100%!important}.h-auto[data-v-5948ee38]{height:auto!important}.mh-100[data-v-5948ee38]{max-height:100%!important}.vh-100[data-v-5948ee38]{height:100vh!important}.min-vh-100[data-v-5948ee38]{min-height:100vh!important}.flex-fill[data-v-5948ee38]{flex:1 1 auto!important}.flex-row[data-v-5948ee38]{flex-direction:row!important}.flex-column[data-v-5948ee38]{flex-direction:column!important}.flex-row-reverse[data-v-5948ee38]{flex-direction:row-reverse!important}.flex-column-reverse[data-v-5948ee38]{flex-direction:column-reverse!important}.flex-grow-0[data-v-5948ee38]{flex-grow:0!important}.flex-grow-1[data-v-5948ee38]{flex-grow:1!important}.flex-shrink-0[data-v-5948ee38]{flex-shrink:0!important}.flex-shrink-1[data-v-5948ee38]{flex-shrink:1!important}.flex-wrap[data-v-5948ee38]{flex-wrap:wrap!important}.flex-nowrap[data-v-5948ee38]{flex-wrap:nowrap!important}.flex-wrap-reverse[data-v-5948ee38]{flex-wrap:wrap-reverse!important}.gap-0[data-v-5948ee38]{gap:0!important}.gap-1[data-v-5948ee38]{gap:.25rem!important}.gap-2[data-v-5948ee38]{gap:.5rem!important}.gap-3[data-v-5948ee38]{gap:1rem!important}.gap-4[data-v-5948ee38]{gap:1.5rem!important}.gap-5[data-v-5948ee38]{gap:3rem!important}.justify-content-start[data-v-5948ee38]{justify-content:flex-start!important}.justify-content-end[data-v-5948ee38]{justify-content:flex-end!important}.justify-content-center[data-v-5948ee38]{justify-content:center!important}.justify-content-between[data-v-5948ee38]{justify-content:space-between!important}.justify-content-around[data-v-5948ee38]{justify-content:space-around!important}.justify-content-evenly[data-v-5948ee38]{justify-content:space-evenly!important}.align-items-start[data-v-5948ee38]{align-items:flex-start!important}.align-items-end[data-v-5948ee38]{align-items:flex-end!important}.align-items-center[data-v-5948ee38]{align-items:center!important}.align-items-baseline[data-v-5948ee38]{align-items:baseline!important}.align-items-stretch[data-v-5948ee38]{align-items:stretch!important}.align-content-start[data-v-5948ee38]{align-content:flex-start!important}.align-content-end[data-v-5948ee38]{align-content:flex-end!important}.align-content-center[data-v-5948ee38]{align-content:center!important}.align-content-between[data-v-5948ee38]{align-content:space-between!important}.align-content-around[data-v-5948ee38]{align-content:space-around!important}.align-content-stretch[data-v-5948ee38]{align-content:stretch!important}.align-self-auto[data-v-5948ee38]{align-self:auto!important}.align-self-start[data-v-5948ee38]{align-self:flex-start!important}.align-self-end[data-v-5948ee38]{align-self:flex-end!important}.align-self-center[data-v-5948ee38]{align-self:center!important}.align-self-baseline[data-v-5948ee38]{align-self:baseline!important}.align-self-stretch[data-v-5948ee38]{align-self:stretch!important}.order-first[data-v-5948ee38]{order:-1!important}.order-0[data-v-5948ee38]{order:0!important}.order-1[data-v-5948ee38]{order:1!important}.order-2[data-v-5948ee38]{order:2!important}.order-3[data-v-5948ee38]{order:3!important}.order-4[data-v-5948ee38]{order:4!important}.order-5[data-v-5948ee38]{order:5!important}.order-last[data-v-5948ee38]{order:6!important}.m-0[data-v-5948ee38]{margin:0!important}.m-1[data-v-5948ee38]{margin:.25rem!important}.m-2[data-v-5948ee38]{margin:.5rem!important}.m-3[data-v-5948ee38]{margin:1rem!important}.m-4[data-v-5948ee38]{margin:1.5rem!important}.m-5[data-v-5948ee38]{margin:3rem!important}.m-auto[data-v-5948ee38]{margin:auto!important}.mx-0[data-v-5948ee38]{margin-right:0!important;margin-left:0!important}.mx-1[data-v-5948ee38]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-2[data-v-5948ee38]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-3[data-v-5948ee38]{margin-right:1rem!important;margin-left:1rem!important}.mx-4[data-v-5948ee38]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-5[data-v-5948ee38]{margin-right:3rem!important;margin-left:3rem!important}.mx-auto[data-v-5948ee38]{margin-right:auto!important;margin-left:auto!important}.my-0[data-v-5948ee38]{margin-top:0!important;margin-bottom:0!important}.my-1[data-v-5948ee38]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-2[data-v-5948ee38]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-3[data-v-5948ee38]{margin-top:1rem!important;margin-bottom:1rem!important}.my-4[data-v-5948ee38]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-5[data-v-5948ee38]{margin-top:3rem!important;margin-bottom:3rem!important}.my-auto[data-v-5948ee38]{margin-top:auto!important;margin-bottom:auto!important}.mt-0[data-v-5948ee38]{margin-top:0!important}.mt-1[data-v-5948ee38]{margin-top:.25rem!important}.mt-2[data-v-5948ee38]{margin-top:.5rem!important}.mt-3[data-v-5948ee38]{margin-top:1rem!important}.mt-4[data-v-5948ee38]{margin-top:1.5rem!important}.mt-5[data-v-5948ee38]{margin-top:3rem!important}.mt-auto[data-v-5948ee38]{margin-top:auto!important}.me-0[data-v-5948ee38]{margin-right:0!important}.me-1[data-v-5948ee38]{margin-right:.25rem!important}.me-2[data-v-5948ee38]{margin-right:.5rem!important}.me-3[data-v-5948ee38]{margin-right:1rem!important}.me-4[data-v-5948ee38]{margin-right:1.5rem!important}.me-5[data-v-5948ee38]{margin-right:3rem!important}.me-auto[data-v-5948ee38]{margin-right:auto!important}.mb-0[data-v-5948ee38]{margin-bottom:0!important}.mb-1[data-v-5948ee38]{margin-bottom:.25rem!important}.mb-2[data-v-5948ee38]{margin-bottom:.5rem!important}.mb-3[data-v-5948ee38]{margin-bottom:1rem!important}.mb-4[data-v-5948ee38]{margin-bottom:1.5rem!important}.mb-5[data-v-5948ee38]{margin-bottom:3rem!important}.mb-auto[data-v-5948ee38]{margin-bottom:auto!important}.ms-0[data-v-5948ee38]{margin-left:0!important}.ms-1[data-v-5948ee38]{margin-left:.25rem!important}.ms-2[data-v-5948ee38]{margin-left:.5rem!important}.ms-3[data-v-5948ee38]{margin-left:1rem!important}.ms-4[data-v-5948ee38]{margin-left:1.5rem!important}.ms-5[data-v-5948ee38]{margin-left:3rem!important}.ms-auto[data-v-5948ee38]{margin-left:auto!important}.p-0[data-v-5948ee38]{padding:0!important}.p-1[data-v-5948ee38]{padding:.25rem!important}.p-2[data-v-5948ee38]{padding:.5rem!important}.p-3[data-v-5948ee38]{padding:1rem!important}.p-4[data-v-5948ee38]{padding:1.5rem!important}.p-5[data-v-5948ee38]{padding:3rem!important}.px-0[data-v-5948ee38]{padding-right:0!important;padding-left:0!important}.px-1[data-v-5948ee38]{padding-right:.25rem!important;padding-left:.25rem!important}.px-2[data-v-5948ee38]{padding-right:.5rem!important;padding-left:.5rem!important}.px-3[data-v-5948ee38]{padding-right:1rem!important;padding-left:1rem!important}.px-4[data-v-5948ee38]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-5[data-v-5948ee38]{padding-right:3rem!important;padding-left:3rem!important}.py-0[data-v-5948ee38]{padding-top:0!important;padding-bottom:0!important}.py-1[data-v-5948ee38]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-2[data-v-5948ee38]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-3[data-v-5948ee38]{padding-top:1rem!important;padding-bottom:1rem!important}.py-4[data-v-5948ee38]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-5[data-v-5948ee38]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-0[data-v-5948ee38]{padding-top:0!important}.pt-1[data-v-5948ee38]{padding-top:.25rem!important}.pt-2[data-v-5948ee38]{padding-top:.5rem!important}.pt-3[data-v-5948ee38]{padding-top:1rem!important}.pt-4[data-v-5948ee38]{padding-top:1.5rem!important}.pt-5[data-v-5948ee38]{padding-top:3rem!important}.pe-0[data-v-5948ee38]{padding-right:0!important}.pe-1[data-v-5948ee38]{padding-right:.25rem!important}.pe-2[data-v-5948ee38]{padding-right:.5rem!important}.pe-3[data-v-5948ee38]{padding-right:1rem!important}.pe-4[data-v-5948ee38]{padding-right:1.5rem!important}.pe-5[data-v-5948ee38]{padding-right:3rem!important}.pb-0[data-v-5948ee38]{padding-bottom:0!important}.pb-1[data-v-5948ee38]{padding-bottom:.25rem!important}.pb-2[data-v-5948ee38]{padding-bottom:.5rem!important}.pb-3[data-v-5948ee38]{padding-bottom:1rem!important}.pb-4[data-v-5948ee38]{padding-bottom:1.5rem!important}.pb-5[data-v-5948ee38]{padding-bottom:3rem!important}.ps-0[data-v-5948ee38]{padding-left:0!important}.ps-1[data-v-5948ee38]{padding-left:.25rem!important}.ps-2[data-v-5948ee38]{padding-left:.5rem!important}.ps-3[data-v-5948ee38]{padding-left:1rem!important}.ps-4[data-v-5948ee38]{padding-left:1.5rem!important}.ps-5[data-v-5948ee38]{padding-left:3rem!important}.font-monospace[data-v-5948ee38]{font-family:var(--bs-font-monospace)!important}.fs-1[data-v-5948ee38]{font-size:calc(1.375rem + 1.5vw)!important}.fs-2[data-v-5948ee38]{font-size:calc(1.325rem + .9vw)!important}.fs-3[data-v-5948ee38]{font-size:calc(1.3rem + .6vw)!important}.fs-4[data-v-5948ee38]{font-size:calc(1.275rem + .3vw)!important}.fs-5[data-v-5948ee38]{font-size:1.25rem!important}.fs-6[data-v-5948ee38]{font-size:1rem!important}.fst-italic[data-v-5948ee38]{font-style:italic!important}.fst-normal[data-v-5948ee38]{font-style:normal!important}.fw-light[data-v-5948ee38]{font-weight:300!important}.fw-lighter[data-v-5948ee38]{font-weight:lighter!important}.fw-normal[data-v-5948ee38]{font-weight:400!important}.fw-bold[data-v-5948ee38]{font-weight:700!important}.fw-bolder[data-v-5948ee38]{font-weight:bolder!important}.lh-1[data-v-5948ee38]{line-height:1!important}.lh-sm[data-v-5948ee38]{line-height:1.25!important}.lh-base[data-v-5948ee38]{line-height:1.5!important}.lh-lg[data-v-5948ee38]{line-height:2!important}.text-start[data-v-5948ee38]{text-align:left!important}.text-end[data-v-5948ee38]{text-align:right!important}.text-center[data-v-5948ee38]{text-align:center!important}.text-decoration-none[data-v-5948ee38]{text-decoration:none!important}.text-decoration-underline[data-v-5948ee38]{text-decoration:underline!important}.text-decoration-line-through[data-v-5948ee38]{text-decoration:line-through!important}.text-lowercase[data-v-5948ee38]{text-transform:lowercase!important}.text-uppercase[data-v-5948ee38]{text-transform:uppercase!important}.text-capitalize[data-v-5948ee38]{text-transform:capitalize!important}.text-wrap[data-v-5948ee38]{white-space:normal!important}.text-nowrap[data-v-5948ee38]{white-space:nowrap!important}.text-break[data-v-5948ee38]{word-wrap:break-word!important;word-break:break-word!important}.text-primary[data-v-5948ee38]{--bs-text-opacity:1;color:rgba(var(--bs-primary-rgb),var(--bs-text-opacity))!important}.text-secondary[data-v-5948ee38]{--bs-text-opacity:1;color:rgba(var(--bs-secondary-rgb),var(--bs-text-opacity))!important}.text-success[data-v-5948ee38]{--bs-text-opacity:1;color:rgba(var(--bs-success-rgb),var(--bs-text-opacity))!important}.text-info[data-v-5948ee38]{--bs-text-opacity:1;color:rgba(var(--bs-info-rgb),var(--bs-text-opacity))!important}.text-warning[data-v-5948ee38]{--bs-text-opacity:1;color:rgba(var(--bs-warning-rgb),var(--bs-text-opacity))!important}.text-danger[data-v-5948ee38]{--bs-text-opacity:1;color:rgba(var(--bs-danger-rgb),var(--bs-text-opacity))!important}.text-light[data-v-5948ee38]{--bs-text-opacity:1;color:rgba(var(--bs-light-rgb),var(--bs-text-opacity))!important}.text-dark[data-v-5948ee38]{--bs-text-opacity:1;color:rgba(var(--bs-dark-rgb),var(--bs-text-opacity))!important}.text-black[data-v-5948ee38]{--bs-text-opacity:1;color:rgba(var(--bs-black-rgb),var(--bs-text-opacity))!important}.text-white[data-v-5948ee38]{--bs-text-opacity:1;color:rgba(var(--bs-white-rgb),var(--bs-text-opacity))!important}.text-body[data-v-5948ee38]{--bs-text-opacity:1;color:rgba(var(--bs-body-color-rgb),var(--bs-text-opacity))!important}.text-muted[data-v-5948ee38]{--bs-text-opacity:1;color:#6c757d!important}.text-black-50[data-v-5948ee38]{--bs-text-opacity:1;color:rgba(0,0,0,.5)!important}.text-white-50[data-v-5948ee38]{--bs-text-opacity:1;color:hsla(0,0%,100%,.5)!important}.text-reset[data-v-5948ee38]{--bs-text-opacity:1;color:inherit!important}.text-opacity-25[data-v-5948ee38]{--bs-text-opacity:0.25}.text-opacity-50[data-v-5948ee38]{--bs-text-opacity:0.5}.text-opacity-75[data-v-5948ee38]{--bs-text-opacity:0.75}.text-opacity-100[data-v-5948ee38]{--bs-text-opacity:1}.bg-primary[data-v-5948ee38]{--bs-bg-opacity:1;background-color:rgba(var(--bs-primary-rgb),var(--bs-bg-opacity))!important}.bg-secondary[data-v-5948ee38]{--bs-bg-opacity:1;background-color:rgba(var(--bs-secondary-rgb),var(--bs-bg-opacity))!important}.bg-success[data-v-5948ee38]{--bs-bg-opacity:1;background-color:rgba(var(--bs-success-rgb),var(--bs-bg-opacity))!important}.bg-info[data-v-5948ee38]{--bs-bg-opacity:1;background-color:rgba(var(--bs-info-rgb),var(--bs-bg-opacity))!important}.bg-warning[data-v-5948ee38]{--bs-bg-opacity:1;background-color:rgba(var(--bs-warning-rgb),var(--bs-bg-opacity))!important}.bg-danger[data-v-5948ee38]{--bs-bg-opacity:1;background-color:rgba(var(--bs-danger-rgb),var(--bs-bg-opacity))!important}.bg-light[data-v-5948ee38]{--bs-bg-opacity:1;background-color:rgba(var(--bs-light-rgb),var(--bs-bg-opacity))!important}.bg-dark[data-v-5948ee38]{--bs-bg-opacity:1;background-color:rgba(var(--bs-dark-rgb),var(--bs-bg-opacity))!important}.bg-black[data-v-5948ee38]{--bs-bg-opacity:1;background-color:rgba(var(--bs-black-rgb),var(--bs-bg-opacity))!important}.bg-white[data-v-5948ee38]{--bs-bg-opacity:1;background-color:rgba(var(--bs-white-rgb),var(--bs-bg-opacity))!important}.bg-body[data-v-5948ee38]{--bs-bg-opacity:1;background-color:rgba(var(--bs-body-bg-rgb),var(--bs-bg-opacity))!important}.bg-transparent[data-v-5948ee38]{--bs-bg-opacity:1;background-color:transparent!important}.bg-opacity-10[data-v-5948ee38]{--bs-bg-opacity:0.1}.bg-opacity-25[data-v-5948ee38]{--bs-bg-opacity:0.25}.bg-opacity-50[data-v-5948ee38]{--bs-bg-opacity:0.5}.bg-opacity-75[data-v-5948ee38]{--bs-bg-opacity:0.75}.bg-opacity-100[data-v-5948ee38]{--bs-bg-opacity:1}.bg-gradient[data-v-5948ee38]{background-image:var(--bs-gradient)!important}.user-select-all[data-v-5948ee38]{-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.user-select-auto[data-v-5948ee38]{-webkit-user-select:auto!important;-moz-user-select:auto!important;user-select:auto!important}.user-select-none[data-v-5948ee38]{-webkit-user-select:none!important;-moz-user-select:none!important;user-select:none!important}.pe-none[data-v-5948ee38]{pointer-events:none!important}.pe-auto[data-v-5948ee38]{pointer-events:auto!important}.rounded[data-v-5948ee38]{border-radius:.25rem!important}.rounded-0[data-v-5948ee38]{border-radius:0!important}.rounded-1[data-v-5948ee38]{border-radius:.2rem!important}.rounded-2[data-v-5948ee38]{border-radius:.25rem!important}.rounded-3[data-v-5948ee38]{border-radius:.3rem!important}.rounded-circle[data-v-5948ee38]{border-radius:50%!important}.rounded-pill[data-v-5948ee38]{border-radius:50rem!important}.rounded-top[data-v-5948ee38]{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.rounded-end[data-v-5948ee38]{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.rounded-bottom[data-v-5948ee38]{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-start[data-v-5948ee38]{border-bottom-left-radius:.25rem!important;border-top-left-radius:.25rem!important}.visible[data-v-5948ee38]{visibility:visible!important}.invisible[data-v-5948ee38]{visibility:hidden!important}@media (min-width:576px){.float-sm-start[data-v-5948ee38]{float:left!important}.float-sm-end[data-v-5948ee38]{float:right!important}.float-sm-none[data-v-5948ee38]{float:none!important}.d-sm-inline[data-v-5948ee38]{display:inline!important}.d-sm-inline-block[data-v-5948ee38]{display:inline-block!important}.d-sm-block[data-v-5948ee38]{display:block!important}.d-sm-grid[data-v-5948ee38]{display:grid!important}.d-sm-table[data-v-5948ee38]{display:table!important}.d-sm-table-row[data-v-5948ee38]{display:table-row!important}.d-sm-table-cell[data-v-5948ee38]{display:table-cell!important}.d-sm-flex[data-v-5948ee38]{display:flex!important}.d-sm-inline-flex[data-v-5948ee38]{display:inline-flex!important}.d-sm-none[data-v-5948ee38]{display:none!important}.flex-sm-fill[data-v-5948ee38]{flex:1 1 auto!important}.flex-sm-row[data-v-5948ee38]{flex-direction:row!important}.flex-sm-column[data-v-5948ee38]{flex-direction:column!important}.flex-sm-row-reverse[data-v-5948ee38]{flex-direction:row-reverse!important}.flex-sm-column-reverse[data-v-5948ee38]{flex-direction:column-reverse!important}.flex-sm-grow-0[data-v-5948ee38]{flex-grow:0!important}.flex-sm-grow-1[data-v-5948ee38]{flex-grow:1!important}.flex-sm-shrink-0[data-v-5948ee38]{flex-shrink:0!important}.flex-sm-shrink-1[data-v-5948ee38]{flex-shrink:1!important}.flex-sm-wrap[data-v-5948ee38]{flex-wrap:wrap!important}.flex-sm-nowrap[data-v-5948ee38]{flex-wrap:nowrap!important}.flex-sm-wrap-reverse[data-v-5948ee38]{flex-wrap:wrap-reverse!important}.gap-sm-0[data-v-5948ee38]{gap:0!important}.gap-sm-1[data-v-5948ee38]{gap:.25rem!important}.gap-sm-2[data-v-5948ee38]{gap:.5rem!important}.gap-sm-3[data-v-5948ee38]{gap:1rem!important}.gap-sm-4[data-v-5948ee38]{gap:1.5rem!important}.gap-sm-5[data-v-5948ee38]{gap:3rem!important}.justify-content-sm-start[data-v-5948ee38]{justify-content:flex-start!important}.justify-content-sm-end[data-v-5948ee38]{justify-content:flex-end!important}.justify-content-sm-center[data-v-5948ee38]{justify-content:center!important}.justify-content-sm-between[data-v-5948ee38]{justify-content:space-between!important}.justify-content-sm-around[data-v-5948ee38]{justify-content:space-around!important}.justify-content-sm-evenly[data-v-5948ee38]{justify-content:space-evenly!important}.align-items-sm-start[data-v-5948ee38]{align-items:flex-start!important}.align-items-sm-end[data-v-5948ee38]{align-items:flex-end!important}.align-items-sm-center[data-v-5948ee38]{align-items:center!important}.align-items-sm-baseline[data-v-5948ee38]{align-items:baseline!important}.align-items-sm-stretch[data-v-5948ee38]{align-items:stretch!important}.align-content-sm-start[data-v-5948ee38]{align-content:flex-start!important}.align-content-sm-end[data-v-5948ee38]{align-content:flex-end!important}.align-content-sm-center[data-v-5948ee38]{align-content:center!important}.align-content-sm-between[data-v-5948ee38]{align-content:space-between!important}.align-content-sm-around[data-v-5948ee38]{align-content:space-around!important}.align-content-sm-stretch[data-v-5948ee38]{align-content:stretch!important}.align-self-sm-auto[data-v-5948ee38]{align-self:auto!important}.align-self-sm-start[data-v-5948ee38]{align-self:flex-start!important}.align-self-sm-end[data-v-5948ee38]{align-self:flex-end!important}.align-self-sm-center[data-v-5948ee38]{align-self:center!important}.align-self-sm-baseline[data-v-5948ee38]{align-self:baseline!important}.align-self-sm-stretch[data-v-5948ee38]{align-self:stretch!important}.order-sm-first[data-v-5948ee38]{order:-1!important}.order-sm-0[data-v-5948ee38]{order:0!important}.order-sm-1[data-v-5948ee38]{order:1!important}.order-sm-2[data-v-5948ee38]{order:2!important}.order-sm-3[data-v-5948ee38]{order:3!important}.order-sm-4[data-v-5948ee38]{order:4!important}.order-sm-5[data-v-5948ee38]{order:5!important}.order-sm-last[data-v-5948ee38]{order:6!important}.m-sm-0[data-v-5948ee38]{margin:0!important}.m-sm-1[data-v-5948ee38]{margin:.25rem!important}.m-sm-2[data-v-5948ee38]{margin:.5rem!important}.m-sm-3[data-v-5948ee38]{margin:1rem!important}.m-sm-4[data-v-5948ee38]{margin:1.5rem!important}.m-sm-5[data-v-5948ee38]{margin:3rem!important}.m-sm-auto[data-v-5948ee38]{margin:auto!important}.mx-sm-0[data-v-5948ee38]{margin-right:0!important;margin-left:0!important}.mx-sm-1[data-v-5948ee38]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-sm-2[data-v-5948ee38]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-sm-3[data-v-5948ee38]{margin-right:1rem!important;margin-left:1rem!important}.mx-sm-4[data-v-5948ee38]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-sm-5[data-v-5948ee38]{margin-right:3rem!important;margin-left:3rem!important}.mx-sm-auto[data-v-5948ee38]{margin-right:auto!important;margin-left:auto!important}.my-sm-0[data-v-5948ee38]{margin-top:0!important;margin-bottom:0!important}.my-sm-1[data-v-5948ee38]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-sm-2[data-v-5948ee38]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-sm-3[data-v-5948ee38]{margin-top:1rem!important;margin-bottom:1rem!important}.my-sm-4[data-v-5948ee38]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-sm-5[data-v-5948ee38]{margin-top:3rem!important;margin-bottom:3rem!important}.my-sm-auto[data-v-5948ee38]{margin-top:auto!important;margin-bottom:auto!important}.mt-sm-0[data-v-5948ee38]{margin-top:0!important}.mt-sm-1[data-v-5948ee38]{margin-top:.25rem!important}.mt-sm-2[data-v-5948ee38]{margin-top:.5rem!important}.mt-sm-3[data-v-5948ee38]{margin-top:1rem!important}.mt-sm-4[data-v-5948ee38]{margin-top:1.5rem!important}.mt-sm-5[data-v-5948ee38]{margin-top:3rem!important}.mt-sm-auto[data-v-5948ee38]{margin-top:auto!important}.me-sm-0[data-v-5948ee38]{margin-right:0!important}.me-sm-1[data-v-5948ee38]{margin-right:.25rem!important}.me-sm-2[data-v-5948ee38]{margin-right:.5rem!important}.me-sm-3[data-v-5948ee38]{margin-right:1rem!important}.me-sm-4[data-v-5948ee38]{margin-right:1.5rem!important}.me-sm-5[data-v-5948ee38]{margin-right:3rem!important}.me-sm-auto[data-v-5948ee38]{margin-right:auto!important}.mb-sm-0[data-v-5948ee38]{margin-bottom:0!important}.mb-sm-1[data-v-5948ee38]{margin-bottom:.25rem!important}.mb-sm-2[data-v-5948ee38]{margin-bottom:.5rem!important}.mb-sm-3[data-v-5948ee38]{margin-bottom:1rem!important}.mb-sm-4[data-v-5948ee38]{margin-bottom:1.5rem!important}.mb-sm-5[data-v-5948ee38]{margin-bottom:3rem!important}.mb-sm-auto[data-v-5948ee38]{margin-bottom:auto!important}.ms-sm-0[data-v-5948ee38]{margin-left:0!important}.ms-sm-1[data-v-5948ee38]{margin-left:.25rem!important}.ms-sm-2[data-v-5948ee38]{margin-left:.5rem!important}.ms-sm-3[data-v-5948ee38]{margin-left:1rem!important}.ms-sm-4[data-v-5948ee38]{margin-left:1.5rem!important}.ms-sm-5[data-v-5948ee38]{margin-left:3rem!important}.ms-sm-auto[data-v-5948ee38]{margin-left:auto!important}.p-sm-0[data-v-5948ee38]{padding:0!important}.p-sm-1[data-v-5948ee38]{padding:.25rem!important}.p-sm-2[data-v-5948ee38]{padding:.5rem!important}.p-sm-3[data-v-5948ee38]{padding:1rem!important}.p-sm-4[data-v-5948ee38]{padding:1.5rem!important}.p-sm-5[data-v-5948ee38]{padding:3rem!important}.px-sm-0[data-v-5948ee38]{padding-right:0!important;padding-left:0!important}.px-sm-1[data-v-5948ee38]{padding-right:.25rem!important;padding-left:.25rem!important}.px-sm-2[data-v-5948ee38]{padding-right:.5rem!important;padding-left:.5rem!important}.px-sm-3[data-v-5948ee38]{padding-right:1rem!important;padding-left:1rem!important}.px-sm-4[data-v-5948ee38]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-sm-5[data-v-5948ee38]{padding-right:3rem!important;padding-left:3rem!important}.py-sm-0[data-v-5948ee38]{padding-top:0!important;padding-bottom:0!important}.py-sm-1[data-v-5948ee38]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-sm-2[data-v-5948ee38]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-sm-3[data-v-5948ee38]{padding-top:1rem!important;padding-bottom:1rem!important}.py-sm-4[data-v-5948ee38]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-sm-5[data-v-5948ee38]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-sm-0[data-v-5948ee38]{padding-top:0!important}.pt-sm-1[data-v-5948ee38]{padding-top:.25rem!important}.pt-sm-2[data-v-5948ee38]{padding-top:.5rem!important}.pt-sm-3[data-v-5948ee38]{padding-top:1rem!important}.pt-sm-4[data-v-5948ee38]{padding-top:1.5rem!important}.pt-sm-5[data-v-5948ee38]{padding-top:3rem!important}.pe-sm-0[data-v-5948ee38]{padding-right:0!important}.pe-sm-1[data-v-5948ee38]{padding-right:.25rem!important}.pe-sm-2[data-v-5948ee38]{padding-right:.5rem!important}.pe-sm-3[data-v-5948ee38]{padding-right:1rem!important}.pe-sm-4[data-v-5948ee38]{padding-right:1.5rem!important}.pe-sm-5[data-v-5948ee38]{padding-right:3rem!important}.pb-sm-0[data-v-5948ee38]{padding-bottom:0!important}.pb-sm-1[data-v-5948ee38]{padding-bottom:.25rem!important}.pb-sm-2[data-v-5948ee38]{padding-bottom:.5rem!important}.pb-sm-3[data-v-5948ee38]{padding-bottom:1rem!important}.pb-sm-4[data-v-5948ee38]{padding-bottom:1.5rem!important}.pb-sm-5[data-v-5948ee38]{padding-bottom:3rem!important}.ps-sm-0[data-v-5948ee38]{padding-left:0!important}.ps-sm-1[data-v-5948ee38]{padding-left:.25rem!important}.ps-sm-2[data-v-5948ee38]{padding-left:.5rem!important}.ps-sm-3[data-v-5948ee38]{padding-left:1rem!important}.ps-sm-4[data-v-5948ee38]{padding-left:1.5rem!important}.ps-sm-5[data-v-5948ee38]{padding-left:3rem!important}.text-sm-start[data-v-5948ee38]{text-align:left!important}.text-sm-end[data-v-5948ee38]{text-align:right!important}.text-sm-center[data-v-5948ee38]{text-align:center!important}}@media (min-width:768px){.float-md-start[data-v-5948ee38]{float:left!important}.float-md-end[data-v-5948ee38]{float:right!important}.float-md-none[data-v-5948ee38]{float:none!important}.d-md-inline[data-v-5948ee38]{display:inline!important}.d-md-inline-block[data-v-5948ee38]{display:inline-block!important}.d-md-block[data-v-5948ee38]{display:block!important}.d-md-grid[data-v-5948ee38]{display:grid!important}.d-md-table[data-v-5948ee38]{display:table!important}.d-md-table-row[data-v-5948ee38]{display:table-row!important}.d-md-table-cell[data-v-5948ee38]{display:table-cell!important}.d-md-flex[data-v-5948ee38]{display:flex!important}.d-md-inline-flex[data-v-5948ee38]{display:inline-flex!important}.d-md-none[data-v-5948ee38]{display:none!important}.flex-md-fill[data-v-5948ee38]{flex:1 1 auto!important}.flex-md-row[data-v-5948ee38]{flex-direction:row!important}.flex-md-column[data-v-5948ee38]{flex-direction:column!important}.flex-md-row-reverse[data-v-5948ee38]{flex-direction:row-reverse!important}.flex-md-column-reverse[data-v-5948ee38]{flex-direction:column-reverse!important}.flex-md-grow-0[data-v-5948ee38]{flex-grow:0!important}.flex-md-grow-1[data-v-5948ee38]{flex-grow:1!important}.flex-md-shrink-0[data-v-5948ee38]{flex-shrink:0!important}.flex-md-shrink-1[data-v-5948ee38]{flex-shrink:1!important}.flex-md-wrap[data-v-5948ee38]{flex-wrap:wrap!important}.flex-md-nowrap[data-v-5948ee38]{flex-wrap:nowrap!important}.flex-md-wrap-reverse[data-v-5948ee38]{flex-wrap:wrap-reverse!important}.gap-md-0[data-v-5948ee38]{gap:0!important}.gap-md-1[data-v-5948ee38]{gap:.25rem!important}.gap-md-2[data-v-5948ee38]{gap:.5rem!important}.gap-md-3[data-v-5948ee38]{gap:1rem!important}.gap-md-4[data-v-5948ee38]{gap:1.5rem!important}.gap-md-5[data-v-5948ee38]{gap:3rem!important}.justify-content-md-start[data-v-5948ee38]{justify-content:flex-start!important}.justify-content-md-end[data-v-5948ee38]{justify-content:flex-end!important}.justify-content-md-center[data-v-5948ee38]{justify-content:center!important}.justify-content-md-between[data-v-5948ee38]{justify-content:space-between!important}.justify-content-md-around[data-v-5948ee38]{justify-content:space-around!important}.justify-content-md-evenly[data-v-5948ee38]{justify-content:space-evenly!important}.align-items-md-start[data-v-5948ee38]{align-items:flex-start!important}.align-items-md-end[data-v-5948ee38]{align-items:flex-end!important}.align-items-md-center[data-v-5948ee38]{align-items:center!important}.align-items-md-baseline[data-v-5948ee38]{align-items:baseline!important}.align-items-md-stretch[data-v-5948ee38]{align-items:stretch!important}.align-content-md-start[data-v-5948ee38]{align-content:flex-start!important}.align-content-md-end[data-v-5948ee38]{align-content:flex-end!important}.align-content-md-center[data-v-5948ee38]{align-content:center!important}.align-content-md-between[data-v-5948ee38]{align-content:space-between!important}.align-content-md-around[data-v-5948ee38]{align-content:space-around!important}.align-content-md-stretch[data-v-5948ee38]{align-content:stretch!important}.align-self-md-auto[data-v-5948ee38]{align-self:auto!important}.align-self-md-start[data-v-5948ee38]{align-self:flex-start!important}.align-self-md-end[data-v-5948ee38]{align-self:flex-end!important}.align-self-md-center[data-v-5948ee38]{align-self:center!important}.align-self-md-baseline[data-v-5948ee38]{align-self:baseline!important}.align-self-md-stretch[data-v-5948ee38]{align-self:stretch!important}.order-md-first[data-v-5948ee38]{order:-1!important}.order-md-0[data-v-5948ee38]{order:0!important}.order-md-1[data-v-5948ee38]{order:1!important}.order-md-2[data-v-5948ee38]{order:2!important}.order-md-3[data-v-5948ee38]{order:3!important}.order-md-4[data-v-5948ee38]{order:4!important}.order-md-5[data-v-5948ee38]{order:5!important}.order-md-last[data-v-5948ee38]{order:6!important}.m-md-0[data-v-5948ee38]{margin:0!important}.m-md-1[data-v-5948ee38]{margin:.25rem!important}.m-md-2[data-v-5948ee38]{margin:.5rem!important}.m-md-3[data-v-5948ee38]{margin:1rem!important}.m-md-4[data-v-5948ee38]{margin:1.5rem!important}.m-md-5[data-v-5948ee38]{margin:3rem!important}.m-md-auto[data-v-5948ee38]{margin:auto!important}.mx-md-0[data-v-5948ee38]{margin-right:0!important;margin-left:0!important}.mx-md-1[data-v-5948ee38]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-md-2[data-v-5948ee38]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-md-3[data-v-5948ee38]{margin-right:1rem!important;margin-left:1rem!important}.mx-md-4[data-v-5948ee38]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-md-5[data-v-5948ee38]{margin-right:3rem!important;margin-left:3rem!important}.mx-md-auto[data-v-5948ee38]{margin-right:auto!important;margin-left:auto!important}.my-md-0[data-v-5948ee38]{margin-top:0!important;margin-bottom:0!important}.my-md-1[data-v-5948ee38]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-md-2[data-v-5948ee38]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-md-3[data-v-5948ee38]{margin-top:1rem!important;margin-bottom:1rem!important}.my-md-4[data-v-5948ee38]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-md-5[data-v-5948ee38]{margin-top:3rem!important;margin-bottom:3rem!important}.my-md-auto[data-v-5948ee38]{margin-top:auto!important;margin-bottom:auto!important}.mt-md-0[data-v-5948ee38]{margin-top:0!important}.mt-md-1[data-v-5948ee38]{margin-top:.25rem!important}.mt-md-2[data-v-5948ee38]{margin-top:.5rem!important}.mt-md-3[data-v-5948ee38]{margin-top:1rem!important}.mt-md-4[data-v-5948ee38]{margin-top:1.5rem!important}.mt-md-5[data-v-5948ee38]{margin-top:3rem!important}.mt-md-auto[data-v-5948ee38]{margin-top:auto!important}.me-md-0[data-v-5948ee38]{margin-right:0!important}.me-md-1[data-v-5948ee38]{margin-right:.25rem!important}.me-md-2[data-v-5948ee38]{margin-right:.5rem!important}.me-md-3[data-v-5948ee38]{margin-right:1rem!important}.me-md-4[data-v-5948ee38]{margin-right:1.5rem!important}.me-md-5[data-v-5948ee38]{margin-right:3rem!important}.me-md-auto[data-v-5948ee38]{margin-right:auto!important}.mb-md-0[data-v-5948ee38]{margin-bottom:0!important}.mb-md-1[data-v-5948ee38]{margin-bottom:.25rem!important}.mb-md-2[data-v-5948ee38]{margin-bottom:.5rem!important}.mb-md-3[data-v-5948ee38]{margin-bottom:1rem!important}.mb-md-4[data-v-5948ee38]{margin-bottom:1.5rem!important}.mb-md-5[data-v-5948ee38]{margin-bottom:3rem!important}.mb-md-auto[data-v-5948ee38]{margin-bottom:auto!important}.ms-md-0[data-v-5948ee38]{margin-left:0!important}.ms-md-1[data-v-5948ee38]{margin-left:.25rem!important}.ms-md-2[data-v-5948ee38]{margin-left:.5rem!important}.ms-md-3[data-v-5948ee38]{margin-left:1rem!important}.ms-md-4[data-v-5948ee38]{margin-left:1.5rem!important}.ms-md-5[data-v-5948ee38]{margin-left:3rem!important}.ms-md-auto[data-v-5948ee38]{margin-left:auto!important}.p-md-0[data-v-5948ee38]{padding:0!important}.p-md-1[data-v-5948ee38]{padding:.25rem!important}.p-md-2[data-v-5948ee38]{padding:.5rem!important}.p-md-3[data-v-5948ee38]{padding:1rem!important}.p-md-4[data-v-5948ee38]{padding:1.5rem!important}.p-md-5[data-v-5948ee38]{padding:3rem!important}.px-md-0[data-v-5948ee38]{padding-right:0!important;padding-left:0!important}.px-md-1[data-v-5948ee38]{padding-right:.25rem!important;padding-left:.25rem!important}.px-md-2[data-v-5948ee38]{padding-right:.5rem!important;padding-left:.5rem!important}.px-md-3[data-v-5948ee38]{padding-right:1rem!important;padding-left:1rem!important}.px-md-4[data-v-5948ee38]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-md-5[data-v-5948ee38]{padding-right:3rem!important;padding-left:3rem!important}.py-md-0[data-v-5948ee38]{padding-top:0!important;padding-bottom:0!important}.py-md-1[data-v-5948ee38]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-md-2[data-v-5948ee38]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-md-3[data-v-5948ee38]{padding-top:1rem!important;padding-bottom:1rem!important}.py-md-4[data-v-5948ee38]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-md-5[data-v-5948ee38]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-md-0[data-v-5948ee38]{padding-top:0!important}.pt-md-1[data-v-5948ee38]{padding-top:.25rem!important}.pt-md-2[data-v-5948ee38]{padding-top:.5rem!important}.pt-md-3[data-v-5948ee38]{padding-top:1rem!important}.pt-md-4[data-v-5948ee38]{padding-top:1.5rem!important}.pt-md-5[data-v-5948ee38]{padding-top:3rem!important}.pe-md-0[data-v-5948ee38]{padding-right:0!important}.pe-md-1[data-v-5948ee38]{padding-right:.25rem!important}.pe-md-2[data-v-5948ee38]{padding-right:.5rem!important}.pe-md-3[data-v-5948ee38]{padding-right:1rem!important}.pe-md-4[data-v-5948ee38]{padding-right:1.5rem!important}.pe-md-5[data-v-5948ee38]{padding-right:3rem!important}.pb-md-0[data-v-5948ee38]{padding-bottom:0!important}.pb-md-1[data-v-5948ee38]{padding-bottom:.25rem!important}.pb-md-2[data-v-5948ee38]{padding-bottom:.5rem!important}.pb-md-3[data-v-5948ee38]{padding-bottom:1rem!important}.pb-md-4[data-v-5948ee38]{padding-bottom:1.5rem!important}.pb-md-5[data-v-5948ee38]{padding-bottom:3rem!important}.ps-md-0[data-v-5948ee38]{padding-left:0!important}.ps-md-1[data-v-5948ee38]{padding-left:.25rem!important}.ps-md-2[data-v-5948ee38]{padding-left:.5rem!important}.ps-md-3[data-v-5948ee38]{padding-left:1rem!important}.ps-md-4[data-v-5948ee38]{padding-left:1.5rem!important}.ps-md-5[data-v-5948ee38]{padding-left:3rem!important}.text-md-start[data-v-5948ee38]{text-align:left!important}.text-md-end[data-v-5948ee38]{text-align:right!important}.text-md-center[data-v-5948ee38]{text-align:center!important}}@media (min-width:992px){.float-lg-start[data-v-5948ee38]{float:left!important}.float-lg-end[data-v-5948ee38]{float:right!important}.float-lg-none[data-v-5948ee38]{float:none!important}.d-lg-inline[data-v-5948ee38]{display:inline!important}.d-lg-inline-block[data-v-5948ee38]{display:inline-block!important}.d-lg-block[data-v-5948ee38]{display:block!important}.d-lg-grid[data-v-5948ee38]{display:grid!important}.d-lg-table[data-v-5948ee38]{display:table!important}.d-lg-table-row[data-v-5948ee38]{display:table-row!important}.d-lg-table-cell[data-v-5948ee38]{display:table-cell!important}.d-lg-flex[data-v-5948ee38]{display:flex!important}.d-lg-inline-flex[data-v-5948ee38]{display:inline-flex!important}.d-lg-none[data-v-5948ee38]{display:none!important}.flex-lg-fill[data-v-5948ee38]{flex:1 1 auto!important}.flex-lg-row[data-v-5948ee38]{flex-direction:row!important}.flex-lg-column[data-v-5948ee38]{flex-direction:column!important}.flex-lg-row-reverse[data-v-5948ee38]{flex-direction:row-reverse!important}.flex-lg-column-reverse[data-v-5948ee38]{flex-direction:column-reverse!important}.flex-lg-grow-0[data-v-5948ee38]{flex-grow:0!important}.flex-lg-grow-1[data-v-5948ee38]{flex-grow:1!important}.flex-lg-shrink-0[data-v-5948ee38]{flex-shrink:0!important}.flex-lg-shrink-1[data-v-5948ee38]{flex-shrink:1!important}.flex-lg-wrap[data-v-5948ee38]{flex-wrap:wrap!important}.flex-lg-nowrap[data-v-5948ee38]{flex-wrap:nowrap!important}.flex-lg-wrap-reverse[data-v-5948ee38]{flex-wrap:wrap-reverse!important}.gap-lg-0[data-v-5948ee38]{gap:0!important}.gap-lg-1[data-v-5948ee38]{gap:.25rem!important}.gap-lg-2[data-v-5948ee38]{gap:.5rem!important}.gap-lg-3[data-v-5948ee38]{gap:1rem!important}.gap-lg-4[data-v-5948ee38]{gap:1.5rem!important}.gap-lg-5[data-v-5948ee38]{gap:3rem!important}.justify-content-lg-start[data-v-5948ee38]{justify-content:flex-start!important}.justify-content-lg-end[data-v-5948ee38]{justify-content:flex-end!important}.justify-content-lg-center[data-v-5948ee38]{justify-content:center!important}.justify-content-lg-between[data-v-5948ee38]{justify-content:space-between!important}.justify-content-lg-around[data-v-5948ee38]{justify-content:space-around!important}.justify-content-lg-evenly[data-v-5948ee38]{justify-content:space-evenly!important}.align-items-lg-start[data-v-5948ee38]{align-items:flex-start!important}.align-items-lg-end[data-v-5948ee38]{align-items:flex-end!important}.align-items-lg-center[data-v-5948ee38]{align-items:center!important}.align-items-lg-baseline[data-v-5948ee38]{align-items:baseline!important}.align-items-lg-stretch[data-v-5948ee38]{align-items:stretch!important}.align-content-lg-start[data-v-5948ee38]{align-content:flex-start!important}.align-content-lg-end[data-v-5948ee38]{align-content:flex-end!important}.align-content-lg-center[data-v-5948ee38]{align-content:center!important}.align-content-lg-between[data-v-5948ee38]{align-content:space-between!important}.align-content-lg-around[data-v-5948ee38]{align-content:space-around!important}.align-content-lg-stretch[data-v-5948ee38]{align-content:stretch!important}.align-self-lg-auto[data-v-5948ee38]{align-self:auto!important}.align-self-lg-start[data-v-5948ee38]{align-self:flex-start!important}.align-self-lg-end[data-v-5948ee38]{align-self:flex-end!important}.align-self-lg-center[data-v-5948ee38]{align-self:center!important}.align-self-lg-baseline[data-v-5948ee38]{align-self:baseline!important}.align-self-lg-stretch[data-v-5948ee38]{align-self:stretch!important}.order-lg-first[data-v-5948ee38]{order:-1!important}.order-lg-0[data-v-5948ee38]{order:0!important}.order-lg-1[data-v-5948ee38]{order:1!important}.order-lg-2[data-v-5948ee38]{order:2!important}.order-lg-3[data-v-5948ee38]{order:3!important}.order-lg-4[data-v-5948ee38]{order:4!important}.order-lg-5[data-v-5948ee38]{order:5!important}.order-lg-last[data-v-5948ee38]{order:6!important}.m-lg-0[data-v-5948ee38]{margin:0!important}.m-lg-1[data-v-5948ee38]{margin:.25rem!important}.m-lg-2[data-v-5948ee38]{margin:.5rem!important}.m-lg-3[data-v-5948ee38]{margin:1rem!important}.m-lg-4[data-v-5948ee38]{margin:1.5rem!important}.m-lg-5[data-v-5948ee38]{margin:3rem!important}.m-lg-auto[data-v-5948ee38]{margin:auto!important}.mx-lg-0[data-v-5948ee38]{margin-right:0!important;margin-left:0!important}.mx-lg-1[data-v-5948ee38]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-lg-2[data-v-5948ee38]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-lg-3[data-v-5948ee38]{margin-right:1rem!important;margin-left:1rem!important}.mx-lg-4[data-v-5948ee38]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-lg-5[data-v-5948ee38]{margin-right:3rem!important;margin-left:3rem!important}.mx-lg-auto[data-v-5948ee38]{margin-right:auto!important;margin-left:auto!important}.my-lg-0[data-v-5948ee38]{margin-top:0!important;margin-bottom:0!important}.my-lg-1[data-v-5948ee38]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-lg-2[data-v-5948ee38]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-lg-3[data-v-5948ee38]{margin-top:1rem!important;margin-bottom:1rem!important}.my-lg-4[data-v-5948ee38]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-lg-5[data-v-5948ee38]{margin-top:3rem!important;margin-bottom:3rem!important}.my-lg-auto[data-v-5948ee38]{margin-top:auto!important;margin-bottom:auto!important}.mt-lg-0[data-v-5948ee38]{margin-top:0!important}.mt-lg-1[data-v-5948ee38]{margin-top:.25rem!important}.mt-lg-2[data-v-5948ee38]{margin-top:.5rem!important}.mt-lg-3[data-v-5948ee38]{margin-top:1rem!important}.mt-lg-4[data-v-5948ee38]{margin-top:1.5rem!important}.mt-lg-5[data-v-5948ee38]{margin-top:3rem!important}.mt-lg-auto[data-v-5948ee38]{margin-top:auto!important}.me-lg-0[data-v-5948ee38]{margin-right:0!important}.me-lg-1[data-v-5948ee38]{margin-right:.25rem!important}.me-lg-2[data-v-5948ee38]{margin-right:.5rem!important}.me-lg-3[data-v-5948ee38]{margin-right:1rem!important}.me-lg-4[data-v-5948ee38]{margin-right:1.5rem!important}.me-lg-5[data-v-5948ee38]{margin-right:3rem!important}.me-lg-auto[data-v-5948ee38]{margin-right:auto!important}.mb-lg-0[data-v-5948ee38]{margin-bottom:0!important}.mb-lg-1[data-v-5948ee38]{margin-bottom:.25rem!important}.mb-lg-2[data-v-5948ee38]{margin-bottom:.5rem!important}.mb-lg-3[data-v-5948ee38]{margin-bottom:1rem!important}.mb-lg-4[data-v-5948ee38]{margin-bottom:1.5rem!important}.mb-lg-5[data-v-5948ee38]{margin-bottom:3rem!important}.mb-lg-auto[data-v-5948ee38]{margin-bottom:auto!important}.ms-lg-0[data-v-5948ee38]{margin-left:0!important}.ms-lg-1[data-v-5948ee38]{margin-left:.25rem!important}.ms-lg-2[data-v-5948ee38]{margin-left:.5rem!important}.ms-lg-3[data-v-5948ee38]{margin-left:1rem!important}.ms-lg-4[data-v-5948ee38]{margin-left:1.5rem!important}.ms-lg-5[data-v-5948ee38]{margin-left:3rem!important}.ms-lg-auto[data-v-5948ee38]{margin-left:auto!important}.p-lg-0[data-v-5948ee38]{padding:0!important}.p-lg-1[data-v-5948ee38]{padding:.25rem!important}.p-lg-2[data-v-5948ee38]{padding:.5rem!important}.p-lg-3[data-v-5948ee38]{padding:1rem!important}.p-lg-4[data-v-5948ee38]{padding:1.5rem!important}.p-lg-5[data-v-5948ee38]{padding:3rem!important}.px-lg-0[data-v-5948ee38]{padding-right:0!important;padding-left:0!important}.px-lg-1[data-v-5948ee38]{padding-right:.25rem!important;padding-left:.25rem!important}.px-lg-2[data-v-5948ee38]{padding-right:.5rem!important;padding-left:.5rem!important}.px-lg-3[data-v-5948ee38]{padding-right:1rem!important;padding-left:1rem!important}.px-lg-4[data-v-5948ee38]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-lg-5[data-v-5948ee38]{padding-right:3rem!important;padding-left:3rem!important}.py-lg-0[data-v-5948ee38]{padding-top:0!important;padding-bottom:0!important}.py-lg-1[data-v-5948ee38]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-lg-2[data-v-5948ee38]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-lg-3[data-v-5948ee38]{padding-top:1rem!important;padding-bottom:1rem!important}.py-lg-4[data-v-5948ee38]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-lg-5[data-v-5948ee38]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-lg-0[data-v-5948ee38]{padding-top:0!important}.pt-lg-1[data-v-5948ee38]{padding-top:.25rem!important}.pt-lg-2[data-v-5948ee38]{padding-top:.5rem!important}.pt-lg-3[data-v-5948ee38]{padding-top:1rem!important}.pt-lg-4[data-v-5948ee38]{padding-top:1.5rem!important}.pt-lg-5[data-v-5948ee38]{padding-top:3rem!important}.pe-lg-0[data-v-5948ee38]{padding-right:0!important}.pe-lg-1[data-v-5948ee38]{padding-right:.25rem!important}.pe-lg-2[data-v-5948ee38]{padding-right:.5rem!important}.pe-lg-3[data-v-5948ee38]{padding-right:1rem!important}.pe-lg-4[data-v-5948ee38]{padding-right:1.5rem!important}.pe-lg-5[data-v-5948ee38]{padding-right:3rem!important}.pb-lg-0[data-v-5948ee38]{padding-bottom:0!important}.pb-lg-1[data-v-5948ee38]{padding-bottom:.25rem!important}.pb-lg-2[data-v-5948ee38]{padding-bottom:.5rem!important}.pb-lg-3[data-v-5948ee38]{padding-bottom:1rem!important}.pb-lg-4[data-v-5948ee38]{padding-bottom:1.5rem!important}.pb-lg-5[data-v-5948ee38]{padding-bottom:3rem!important}.ps-lg-0[data-v-5948ee38]{padding-left:0!important}.ps-lg-1[data-v-5948ee38]{padding-left:.25rem!important}.ps-lg-2[data-v-5948ee38]{padding-left:.5rem!important}.ps-lg-3[data-v-5948ee38]{padding-left:1rem!important}.ps-lg-4[data-v-5948ee38]{padding-left:1.5rem!important}.ps-lg-5[data-v-5948ee38]{padding-left:3rem!important}.text-lg-start[data-v-5948ee38]{text-align:left!important}.text-lg-end[data-v-5948ee38]{text-align:right!important}.text-lg-center[data-v-5948ee38]{text-align:center!important}}@media (min-width:1200px){.float-xl-start[data-v-5948ee38]{float:left!important}.float-xl-end[data-v-5948ee38]{float:right!important}.float-xl-none[data-v-5948ee38]{float:none!important}.d-xl-inline[data-v-5948ee38]{display:inline!important}.d-xl-inline-block[data-v-5948ee38]{display:inline-block!important}.d-xl-block[data-v-5948ee38]{display:block!important}.d-xl-grid[data-v-5948ee38]{display:grid!important}.d-xl-table[data-v-5948ee38]{display:table!important}.d-xl-table-row[data-v-5948ee38]{display:table-row!important}.d-xl-table-cell[data-v-5948ee38]{display:table-cell!important}.d-xl-flex[data-v-5948ee38]{display:flex!important}.d-xl-inline-flex[data-v-5948ee38]{display:inline-flex!important}.d-xl-none[data-v-5948ee38]{display:none!important}.flex-xl-fill[data-v-5948ee38]{flex:1 1 auto!important}.flex-xl-row[data-v-5948ee38]{flex-direction:row!important}.flex-xl-column[data-v-5948ee38]{flex-direction:column!important}.flex-xl-row-reverse[data-v-5948ee38]{flex-direction:row-reverse!important}.flex-xl-column-reverse[data-v-5948ee38]{flex-direction:column-reverse!important}.flex-xl-grow-0[data-v-5948ee38]{flex-grow:0!important}.flex-xl-grow-1[data-v-5948ee38]{flex-grow:1!important}.flex-xl-shrink-0[data-v-5948ee38]{flex-shrink:0!important}.flex-xl-shrink-1[data-v-5948ee38]{flex-shrink:1!important}.flex-xl-wrap[data-v-5948ee38]{flex-wrap:wrap!important}.flex-xl-nowrap[data-v-5948ee38]{flex-wrap:nowrap!important}.flex-xl-wrap-reverse[data-v-5948ee38]{flex-wrap:wrap-reverse!important}.gap-xl-0[data-v-5948ee38]{gap:0!important}.gap-xl-1[data-v-5948ee38]{gap:.25rem!important}.gap-xl-2[data-v-5948ee38]{gap:.5rem!important}.gap-xl-3[data-v-5948ee38]{gap:1rem!important}.gap-xl-4[data-v-5948ee38]{gap:1.5rem!important}.gap-xl-5[data-v-5948ee38]{gap:3rem!important}.justify-content-xl-start[data-v-5948ee38]{justify-content:flex-start!important}.justify-content-xl-end[data-v-5948ee38]{justify-content:flex-end!important}.justify-content-xl-center[data-v-5948ee38]{justify-content:center!important}.justify-content-xl-between[data-v-5948ee38]{justify-content:space-between!important}.justify-content-xl-around[data-v-5948ee38]{justify-content:space-around!important}.justify-content-xl-evenly[data-v-5948ee38]{justify-content:space-evenly!important}.align-items-xl-start[data-v-5948ee38]{align-items:flex-start!important}.align-items-xl-end[data-v-5948ee38]{align-items:flex-end!important}.align-items-xl-center[data-v-5948ee38]{align-items:center!important}.align-items-xl-baseline[data-v-5948ee38]{align-items:baseline!important}.align-items-xl-stretch[data-v-5948ee38]{align-items:stretch!important}.align-content-xl-start[data-v-5948ee38]{align-content:flex-start!important}.align-content-xl-end[data-v-5948ee38]{align-content:flex-end!important}.align-content-xl-center[data-v-5948ee38]{align-content:center!important}.align-content-xl-between[data-v-5948ee38]{align-content:space-between!important}.align-content-xl-around[data-v-5948ee38]{align-content:space-around!important}.align-content-xl-stretch[data-v-5948ee38]{align-content:stretch!important}.align-self-xl-auto[data-v-5948ee38]{align-self:auto!important}.align-self-xl-start[data-v-5948ee38]{align-self:flex-start!important}.align-self-xl-end[data-v-5948ee38]{align-self:flex-end!important}.align-self-xl-center[data-v-5948ee38]{align-self:center!important}.align-self-xl-baseline[data-v-5948ee38]{align-self:baseline!important}.align-self-xl-stretch[data-v-5948ee38]{align-self:stretch!important}.order-xl-first[data-v-5948ee38]{order:-1!important}.order-xl-0[data-v-5948ee38]{order:0!important}.order-xl-1[data-v-5948ee38]{order:1!important}.order-xl-2[data-v-5948ee38]{order:2!important}.order-xl-3[data-v-5948ee38]{order:3!important}.order-xl-4[data-v-5948ee38]{order:4!important}.order-xl-5[data-v-5948ee38]{order:5!important}.order-xl-last[data-v-5948ee38]{order:6!important}.m-xl-0[data-v-5948ee38]{margin:0!important}.m-xl-1[data-v-5948ee38]{margin:.25rem!important}.m-xl-2[data-v-5948ee38]{margin:.5rem!important}.m-xl-3[data-v-5948ee38]{margin:1rem!important}.m-xl-4[data-v-5948ee38]{margin:1.5rem!important}.m-xl-5[data-v-5948ee38]{margin:3rem!important}.m-xl-auto[data-v-5948ee38]{margin:auto!important}.mx-xl-0[data-v-5948ee38]{margin-right:0!important;margin-left:0!important}.mx-xl-1[data-v-5948ee38]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xl-2[data-v-5948ee38]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xl-3[data-v-5948ee38]{margin-right:1rem!important;margin-left:1rem!important}.mx-xl-4[data-v-5948ee38]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xl-5[data-v-5948ee38]{margin-right:3rem!important;margin-left:3rem!important}.mx-xl-auto[data-v-5948ee38]{margin-right:auto!important;margin-left:auto!important}.my-xl-0[data-v-5948ee38]{margin-top:0!important;margin-bottom:0!important}.my-xl-1[data-v-5948ee38]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xl-2[data-v-5948ee38]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xl-3[data-v-5948ee38]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xl-4[data-v-5948ee38]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xl-5[data-v-5948ee38]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xl-auto[data-v-5948ee38]{margin-top:auto!important;margin-bottom:auto!important}.mt-xl-0[data-v-5948ee38]{margin-top:0!important}.mt-xl-1[data-v-5948ee38]{margin-top:.25rem!important}.mt-xl-2[data-v-5948ee38]{margin-top:.5rem!important}.mt-xl-3[data-v-5948ee38]{margin-top:1rem!important}.mt-xl-4[data-v-5948ee38]{margin-top:1.5rem!important}.mt-xl-5[data-v-5948ee38]{margin-top:3rem!important}.mt-xl-auto[data-v-5948ee38]{margin-top:auto!important}.me-xl-0[data-v-5948ee38]{margin-right:0!important}.me-xl-1[data-v-5948ee38]{margin-right:.25rem!important}.me-xl-2[data-v-5948ee38]{margin-right:.5rem!important}.me-xl-3[data-v-5948ee38]{margin-right:1rem!important}.me-xl-4[data-v-5948ee38]{margin-right:1.5rem!important}.me-xl-5[data-v-5948ee38]{margin-right:3rem!important}.me-xl-auto[data-v-5948ee38]{margin-right:auto!important}.mb-xl-0[data-v-5948ee38]{margin-bottom:0!important}.mb-xl-1[data-v-5948ee38]{margin-bottom:.25rem!important}.mb-xl-2[data-v-5948ee38]{margin-bottom:.5rem!important}.mb-xl-3[data-v-5948ee38]{margin-bottom:1rem!important}.mb-xl-4[data-v-5948ee38]{margin-bottom:1.5rem!important}.mb-xl-5[data-v-5948ee38]{margin-bottom:3rem!important}.mb-xl-auto[data-v-5948ee38]{margin-bottom:auto!important}.ms-xl-0[data-v-5948ee38]{margin-left:0!important}.ms-xl-1[data-v-5948ee38]{margin-left:.25rem!important}.ms-xl-2[data-v-5948ee38]{margin-left:.5rem!important}.ms-xl-3[data-v-5948ee38]{margin-left:1rem!important}.ms-xl-4[data-v-5948ee38]{margin-left:1.5rem!important}.ms-xl-5[data-v-5948ee38]{margin-left:3rem!important}.ms-xl-auto[data-v-5948ee38]{margin-left:auto!important}.p-xl-0[data-v-5948ee38]{padding:0!important}.p-xl-1[data-v-5948ee38]{padding:.25rem!important}.p-xl-2[data-v-5948ee38]{padding:.5rem!important}.p-xl-3[data-v-5948ee38]{padding:1rem!important}.p-xl-4[data-v-5948ee38]{padding:1.5rem!important}.p-xl-5[data-v-5948ee38]{padding:3rem!important}.px-xl-0[data-v-5948ee38]{padding-right:0!important;padding-left:0!important}.px-xl-1[data-v-5948ee38]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xl-2[data-v-5948ee38]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xl-3[data-v-5948ee38]{padding-right:1rem!important;padding-left:1rem!important}.px-xl-4[data-v-5948ee38]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xl-5[data-v-5948ee38]{padding-right:3rem!important;padding-left:3rem!important}.py-xl-0[data-v-5948ee38]{padding-top:0!important;padding-bottom:0!important}.py-xl-1[data-v-5948ee38]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xl-2[data-v-5948ee38]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xl-3[data-v-5948ee38]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xl-4[data-v-5948ee38]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xl-5[data-v-5948ee38]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xl-0[data-v-5948ee38]{padding-top:0!important}.pt-xl-1[data-v-5948ee38]{padding-top:.25rem!important}.pt-xl-2[data-v-5948ee38]{padding-top:.5rem!important}.pt-xl-3[data-v-5948ee38]{padding-top:1rem!important}.pt-xl-4[data-v-5948ee38]{padding-top:1.5rem!important}.pt-xl-5[data-v-5948ee38]{padding-top:3rem!important}.pe-xl-0[data-v-5948ee38]{padding-right:0!important}.pe-xl-1[data-v-5948ee38]{padding-right:.25rem!important}.pe-xl-2[data-v-5948ee38]{padding-right:.5rem!important}.pe-xl-3[data-v-5948ee38]{padding-right:1rem!important}.pe-xl-4[data-v-5948ee38]{padding-right:1.5rem!important}.pe-xl-5[data-v-5948ee38]{padding-right:3rem!important}.pb-xl-0[data-v-5948ee38]{padding-bottom:0!important}.pb-xl-1[data-v-5948ee38]{padding-bottom:.25rem!important}.pb-xl-2[data-v-5948ee38]{padding-bottom:.5rem!important}.pb-xl-3[data-v-5948ee38]{padding-bottom:1rem!important}.pb-xl-4[data-v-5948ee38]{padding-bottom:1.5rem!important}.pb-xl-5[data-v-5948ee38]{padding-bottom:3rem!important}.ps-xl-0[data-v-5948ee38]{padding-left:0!important}.ps-xl-1[data-v-5948ee38]{padding-left:.25rem!important}.ps-xl-2[data-v-5948ee38]{padding-left:.5rem!important}.ps-xl-3[data-v-5948ee38]{padding-left:1rem!important}.ps-xl-4[data-v-5948ee38]{padding-left:1.5rem!important}.ps-xl-5[data-v-5948ee38]{padding-left:3rem!important}.text-xl-start[data-v-5948ee38]{text-align:left!important}.text-xl-end[data-v-5948ee38]{text-align:right!important}.text-xl-center[data-v-5948ee38]{text-align:center!important}}@media (min-width:1400px){.float-xxl-start[data-v-5948ee38]{float:left!important}.float-xxl-end[data-v-5948ee38]{float:right!important}.float-xxl-none[data-v-5948ee38]{float:none!important}.d-xxl-inline[data-v-5948ee38]{display:inline!important}.d-xxl-inline-block[data-v-5948ee38]{display:inline-block!important}.d-xxl-block[data-v-5948ee38]{display:block!important}.d-xxl-grid[data-v-5948ee38]{display:grid!important}.d-xxl-table[data-v-5948ee38]{display:table!important}.d-xxl-table-row[data-v-5948ee38]{display:table-row!important}.d-xxl-table-cell[data-v-5948ee38]{display:table-cell!important}.d-xxl-flex[data-v-5948ee38]{display:flex!important}.d-xxl-inline-flex[data-v-5948ee38]{display:inline-flex!important}.d-xxl-none[data-v-5948ee38]{display:none!important}.flex-xxl-fill[data-v-5948ee38]{flex:1 1 auto!important}.flex-xxl-row[data-v-5948ee38]{flex-direction:row!important}.flex-xxl-column[data-v-5948ee38]{flex-direction:column!important}.flex-xxl-row-reverse[data-v-5948ee38]{flex-direction:row-reverse!important}.flex-xxl-column-reverse[data-v-5948ee38]{flex-direction:column-reverse!important}.flex-xxl-grow-0[data-v-5948ee38]{flex-grow:0!important}.flex-xxl-grow-1[data-v-5948ee38]{flex-grow:1!important}.flex-xxl-shrink-0[data-v-5948ee38]{flex-shrink:0!important}.flex-xxl-shrink-1[data-v-5948ee38]{flex-shrink:1!important}.flex-xxl-wrap[data-v-5948ee38]{flex-wrap:wrap!important}.flex-xxl-nowrap[data-v-5948ee38]{flex-wrap:nowrap!important}.flex-xxl-wrap-reverse[data-v-5948ee38]{flex-wrap:wrap-reverse!important}.gap-xxl-0[data-v-5948ee38]{gap:0!important}.gap-xxl-1[data-v-5948ee38]{gap:.25rem!important}.gap-xxl-2[data-v-5948ee38]{gap:.5rem!important}.gap-xxl-3[data-v-5948ee38]{gap:1rem!important}.gap-xxl-4[data-v-5948ee38]{gap:1.5rem!important}.gap-xxl-5[data-v-5948ee38]{gap:3rem!important}.justify-content-xxl-start[data-v-5948ee38]{justify-content:flex-start!important}.justify-content-xxl-end[data-v-5948ee38]{justify-content:flex-end!important}.justify-content-xxl-center[data-v-5948ee38]{justify-content:center!important}.justify-content-xxl-between[data-v-5948ee38]{justify-content:space-between!important}.justify-content-xxl-around[data-v-5948ee38]{justify-content:space-around!important}.justify-content-xxl-evenly[data-v-5948ee38]{justify-content:space-evenly!important}.align-items-xxl-start[data-v-5948ee38]{align-items:flex-start!important}.align-items-xxl-end[data-v-5948ee38]{align-items:flex-end!important}.align-items-xxl-center[data-v-5948ee38]{align-items:center!important}.align-items-xxl-baseline[data-v-5948ee38]{align-items:baseline!important}.align-items-xxl-stretch[data-v-5948ee38]{align-items:stretch!important}.align-content-xxl-start[data-v-5948ee38]{align-content:flex-start!important}.align-content-xxl-end[data-v-5948ee38]{align-content:flex-end!important}.align-content-xxl-center[data-v-5948ee38]{align-content:center!important}.align-content-xxl-between[data-v-5948ee38]{align-content:space-between!important}.align-content-xxl-around[data-v-5948ee38]{align-content:space-around!important}.align-content-xxl-stretch[data-v-5948ee38]{align-content:stretch!important}.align-self-xxl-auto[data-v-5948ee38]{align-self:auto!important}.align-self-xxl-start[data-v-5948ee38]{align-self:flex-start!important}.align-self-xxl-end[data-v-5948ee38]{align-self:flex-end!important}.align-self-xxl-center[data-v-5948ee38]{align-self:center!important}.align-self-xxl-baseline[data-v-5948ee38]{align-self:baseline!important}.align-self-xxl-stretch[data-v-5948ee38]{align-self:stretch!important}.order-xxl-first[data-v-5948ee38]{order:-1!important}.order-xxl-0[data-v-5948ee38]{order:0!important}.order-xxl-1[data-v-5948ee38]{order:1!important}.order-xxl-2[data-v-5948ee38]{order:2!important}.order-xxl-3[data-v-5948ee38]{order:3!important}.order-xxl-4[data-v-5948ee38]{order:4!important}.order-xxl-5[data-v-5948ee38]{order:5!important}.order-xxl-last[data-v-5948ee38]{order:6!important}.m-xxl-0[data-v-5948ee38]{margin:0!important}.m-xxl-1[data-v-5948ee38]{margin:.25rem!important}.m-xxl-2[data-v-5948ee38]{margin:.5rem!important}.m-xxl-3[data-v-5948ee38]{margin:1rem!important}.m-xxl-4[data-v-5948ee38]{margin:1.5rem!important}.m-xxl-5[data-v-5948ee38]{margin:3rem!important}.m-xxl-auto[data-v-5948ee38]{margin:auto!important}.mx-xxl-0[data-v-5948ee38]{margin-right:0!important;margin-left:0!important}.mx-xxl-1[data-v-5948ee38]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xxl-2[data-v-5948ee38]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xxl-3[data-v-5948ee38]{margin-right:1rem!important;margin-left:1rem!important}.mx-xxl-4[data-v-5948ee38]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xxl-5[data-v-5948ee38]{margin-right:3rem!important;margin-left:3rem!important}.mx-xxl-auto[data-v-5948ee38]{margin-right:auto!important;margin-left:auto!important}.my-xxl-0[data-v-5948ee38]{margin-top:0!important;margin-bottom:0!important}.my-xxl-1[data-v-5948ee38]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xxl-2[data-v-5948ee38]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xxl-3[data-v-5948ee38]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xxl-4[data-v-5948ee38]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xxl-5[data-v-5948ee38]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xxl-auto[data-v-5948ee38]{margin-top:auto!important;margin-bottom:auto!important}.mt-xxl-0[data-v-5948ee38]{margin-top:0!important}.mt-xxl-1[data-v-5948ee38]{margin-top:.25rem!important}.mt-xxl-2[data-v-5948ee38]{margin-top:.5rem!important}.mt-xxl-3[data-v-5948ee38]{margin-top:1rem!important}.mt-xxl-4[data-v-5948ee38]{margin-top:1.5rem!important}.mt-xxl-5[data-v-5948ee38]{margin-top:3rem!important}.mt-xxl-auto[data-v-5948ee38]{margin-top:auto!important}.me-xxl-0[data-v-5948ee38]{margin-right:0!important}.me-xxl-1[data-v-5948ee38]{margin-right:.25rem!important}.me-xxl-2[data-v-5948ee38]{margin-right:.5rem!important}.me-xxl-3[data-v-5948ee38]{margin-right:1rem!important}.me-xxl-4[data-v-5948ee38]{margin-right:1.5rem!important}.me-xxl-5[data-v-5948ee38]{margin-right:3rem!important}.me-xxl-auto[data-v-5948ee38]{margin-right:auto!important}.mb-xxl-0[data-v-5948ee38]{margin-bottom:0!important}.mb-xxl-1[data-v-5948ee38]{margin-bottom:.25rem!important}.mb-xxl-2[data-v-5948ee38]{margin-bottom:.5rem!important}.mb-xxl-3[data-v-5948ee38]{margin-bottom:1rem!important}.mb-xxl-4[data-v-5948ee38]{margin-bottom:1.5rem!important}.mb-xxl-5[data-v-5948ee38]{margin-bottom:3rem!important}.mb-xxl-auto[data-v-5948ee38]{margin-bottom:auto!important}.ms-xxl-0[data-v-5948ee38]{margin-left:0!important}.ms-xxl-1[data-v-5948ee38]{margin-left:.25rem!important}.ms-xxl-2[data-v-5948ee38]{margin-left:.5rem!important}.ms-xxl-3[data-v-5948ee38]{margin-left:1rem!important}.ms-xxl-4[data-v-5948ee38]{margin-left:1.5rem!important}.ms-xxl-5[data-v-5948ee38]{margin-left:3rem!important}.ms-xxl-auto[data-v-5948ee38]{margin-left:auto!important}.p-xxl-0[data-v-5948ee38]{padding:0!important}.p-xxl-1[data-v-5948ee38]{padding:.25rem!important}.p-xxl-2[data-v-5948ee38]{padding:.5rem!important}.p-xxl-3[data-v-5948ee38]{padding:1rem!important}.p-xxl-4[data-v-5948ee38]{padding:1.5rem!important}.p-xxl-5[data-v-5948ee38]{padding:3rem!important}.px-xxl-0[data-v-5948ee38]{padding-right:0!important;padding-left:0!important}.px-xxl-1[data-v-5948ee38]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xxl-2[data-v-5948ee38]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xxl-3[data-v-5948ee38]{padding-right:1rem!important;padding-left:1rem!important}.px-xxl-4[data-v-5948ee38]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xxl-5[data-v-5948ee38]{padding-right:3rem!important;padding-left:3rem!important}.py-xxl-0[data-v-5948ee38]{padding-top:0!important;padding-bottom:0!important}.py-xxl-1[data-v-5948ee38]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xxl-2[data-v-5948ee38]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xxl-3[data-v-5948ee38]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xxl-4[data-v-5948ee38]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xxl-5[data-v-5948ee38]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xxl-0[data-v-5948ee38]{padding-top:0!important}.pt-xxl-1[data-v-5948ee38]{padding-top:.25rem!important}.pt-xxl-2[data-v-5948ee38]{padding-top:.5rem!important}.pt-xxl-3[data-v-5948ee38]{padding-top:1rem!important}.pt-xxl-4[data-v-5948ee38]{padding-top:1.5rem!important}.pt-xxl-5[data-v-5948ee38]{padding-top:3rem!important}.pe-xxl-0[data-v-5948ee38]{padding-right:0!important}.pe-xxl-1[data-v-5948ee38]{padding-right:.25rem!important}.pe-xxl-2[data-v-5948ee38]{padding-right:.5rem!important}.pe-xxl-3[data-v-5948ee38]{padding-right:1rem!important}.pe-xxl-4[data-v-5948ee38]{padding-right:1.5rem!important}.pe-xxl-5[data-v-5948ee38]{padding-right:3rem!important}.pb-xxl-0[data-v-5948ee38]{padding-bottom:0!important}.pb-xxl-1[data-v-5948ee38]{padding-bottom:.25rem!important}.pb-xxl-2[data-v-5948ee38]{padding-bottom:.5rem!important}.pb-xxl-3[data-v-5948ee38]{padding-bottom:1rem!important}.pb-xxl-4[data-v-5948ee38]{padding-bottom:1.5rem!important}.pb-xxl-5[data-v-5948ee38]{padding-bottom:3rem!important}.ps-xxl-0[data-v-5948ee38]{padding-left:0!important}.ps-xxl-1[data-v-5948ee38]{padding-left:.25rem!important}.ps-xxl-2[data-v-5948ee38]{padding-left:.5rem!important}.ps-xxl-3[data-v-5948ee38]{padding-left:1rem!important}.ps-xxl-4[data-v-5948ee38]{padding-left:1.5rem!important}.ps-xxl-5[data-v-5948ee38]{padding-left:3rem!important}.text-xxl-start[data-v-5948ee38]{text-align:left!important}.text-xxl-end[data-v-5948ee38]{text-align:right!important}.text-xxl-center[data-v-5948ee38]{text-align:center!important}}@media (min-width:1200px){.fs-1[data-v-5948ee38]{font-size:2.5rem!important}.fs-2[data-v-5948ee38]{font-size:2rem!important}.fs-3[data-v-5948ee38]{font-size:1.75rem!important}.fs-4[data-v-5948ee38]{font-size:1.5rem!important}}@media print{.d-print-inline[data-v-5948ee38]{display:inline!important}.d-print-inline-block[data-v-5948ee38]{display:inline-block!important}.d-print-block[data-v-5948ee38]{display:block!important}.d-print-grid[data-v-5948ee38]{display:grid!important}.d-print-table[data-v-5948ee38]{display:table!important}.d-print-table-row[data-v-5948ee38]{display:table-row!important}.d-print-table-cell[data-v-5948ee38]{display:table-cell!important}.d-print-flex[data-v-5948ee38]{display:flex!important}.d-print-inline-flex[data-v-5948ee38]{display:inline-flex!important}.d-print-none[data-v-5948ee38]{display:none!important}}", ""]);

// exports


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(167);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("c1e48a6c", content, true, {});

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".indented[data-v-5948ee38]{margin:20px;max-width:550px}.spacer[data-v-5948ee38]{height:15px;border:0 solid #000}.spaced[data-v-5948ee38]{margin-top:10px}.button[data-v-5948ee38]{border:1px solid gray}", ""]);

// exports


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indented"},[_c('form',{ref:"formHTML",on:{"submit":function($event){$event.preventDefault();return _vm.submitForm.apply(null, arguments)}}},[_c('div',{staticClass:"form-horizontal"},[_c('h2',[_vm._v("Delete Category")]),_vm._v(" "),_c('hr'),_vm._v("\n      "+_vm._s(_vm.catname)+"\n      "),_c('div',{staticClass:"spacer"}),_vm._v(" "),_c('h5',[_vm._v("Are you sure you want to delete this category? All subcategories, associated products and alternative products will be deleted!")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"form-group spaced"},[_c('router-link',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"to":{ path: '/DeleteCat', query: { CategoryId: _vm.catid } }}},[_c('input',{staticClass:"button btn btn-default",attrs:{"type":"submit","value":"Delete"}})])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_BreadCrumb_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dbaddd8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_BreadCrumb_vue__ = __webpack_require__(174);
function injectStyle (ssrContext) {
  __webpack_require__(170)
  __webpack_require__(172)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7dbaddd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_BreadCrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dbaddd8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_BreadCrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(171);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("b29cf228", content, true, {});

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n/*!\n * Bootstrap v5.1.3 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */[data-v-7dbaddd8]:root{--bs-blue:#0d6efd;--bs-indigo:#6610f2;--bs-purple:#6f42c1;--bs-pink:#d63384;--bs-red:#dc3545;--bs-orange:#fd7e14;--bs-yellow:#ffc107;--bs-green:#198754;--bs-teal:#20c997;--bs-cyan:#0dcaf0;--bs-white:#fff;--bs-gray:#6c757d;--bs-gray-dark:#343a40;--bs-gray-100:#f8f9fa;--bs-gray-200:#e9ecef;--bs-gray-300:#dee2e6;--bs-gray-400:#ced4da;--bs-gray-500:#adb5bd;--bs-gray-600:#6c757d;--bs-gray-700:#495057;--bs-gray-800:#343a40;--bs-gray-900:#212529;--bs-primary:#0d6efd;--bs-secondary:#6c757d;--bs-success:#198754;--bs-info:#0dcaf0;--bs-warning:#ffc107;--bs-danger:#dc3545;--bs-light:#f8f9fa;--bs-dark:#212529;--bs-primary-rgb:13,110,253;--bs-secondary-rgb:108,117,125;--bs-success-rgb:25,135,84;--bs-info-rgb:13,202,240;--bs-warning-rgb:255,193,7;--bs-danger-rgb:220,53,69;--bs-light-rgb:248,249,250;--bs-dark-rgb:33,37,41;--bs-white-rgb:255,255,255;--bs-black-rgb:0,0,0;--bs-body-color-rgb:33,37,41;--bs-body-bg-rgb:255,255,255;--bs-font-sans-serif:system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--bs-font-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;--bs-gradient:linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));--bs-body-font-family:var(--bs-font-sans-serif);--bs-body-font-size:1rem;--bs-body-font-weight:400;--bs-body-line-height:1.5;--bs-body-color:#212529;--bs-body-bg:#fff}[data-v-7dbaddd8],[data-v-7dbaddd8]:after,[data-v-7dbaddd8]:before{box-sizing:border-box}@media (prefers-reduced-motion:no-preference){[data-v-7dbaddd8]:root{scroll-behavior:smooth}}body[data-v-7dbaddd8]{margin:0;font-family:var(--bs-body-font-family);font-size:var(--bs-body-font-size);font-weight:var(--bs-body-font-weight);line-height:var(--bs-body-line-height);color:var(--bs-body-color);text-align:var(--bs-body-text-align);background-color:var(--bs-body-bg);-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}hr[data-v-7dbaddd8]{margin:1rem 0;color:inherit;background-color:currentColor;border:0;opacity:.25}hr[data-v-7dbaddd8]:not([size]){height:1px}.h1[data-v-7dbaddd8],.h2[data-v-7dbaddd8],.h3[data-v-7dbaddd8],.h4[data-v-7dbaddd8],.h5[data-v-7dbaddd8],.h6[data-v-7dbaddd8],h1[data-v-7dbaddd8],h2[data-v-7dbaddd8],h3[data-v-7dbaddd8],h4[data-v-7dbaddd8],h5[data-v-7dbaddd8],h6[data-v-7dbaddd8]{margin-top:0;margin-bottom:.5rem;font-weight:500;line-height:1.2}.h1[data-v-7dbaddd8],h1[data-v-7dbaddd8]{font-size:calc(1.375rem + 1.5vw)}@media (min-width:1200px){.h1[data-v-7dbaddd8],h1[data-v-7dbaddd8]{font-size:2.5rem}}.h2[data-v-7dbaddd8],h2[data-v-7dbaddd8]{font-size:calc(1.325rem + .9vw)}@media (min-width:1200px){.h2[data-v-7dbaddd8],h2[data-v-7dbaddd8]{font-size:2rem}}.h3[data-v-7dbaddd8],h3[data-v-7dbaddd8]{font-size:calc(1.3rem + .6vw)}@media (min-width:1200px){.h3[data-v-7dbaddd8],h3[data-v-7dbaddd8]{font-size:1.75rem}}.h4[data-v-7dbaddd8],h4[data-v-7dbaddd8]{font-size:calc(1.275rem + .3vw)}@media (min-width:1200px){.h4[data-v-7dbaddd8],h4[data-v-7dbaddd8]{font-size:1.5rem}}.h5[data-v-7dbaddd8],h5[data-v-7dbaddd8]{font-size:1.25rem}.h6[data-v-7dbaddd8],h6[data-v-7dbaddd8]{font-size:1rem}p[data-v-7dbaddd8]{margin-top:0;margin-bottom:1rem}abbr[data-bs-original-title][data-v-7dbaddd8],abbr[title][data-v-7dbaddd8]{-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address[data-v-7dbaddd8]{margin-bottom:1rem;font-style:normal;line-height:inherit}ol[data-v-7dbaddd8],ul[data-v-7dbaddd8]{padding-left:2rem}dl[data-v-7dbaddd8],ol[data-v-7dbaddd8],ul[data-v-7dbaddd8]{margin-top:0;margin-bottom:1rem}ol ol[data-v-7dbaddd8],ol ul[data-v-7dbaddd8],ul ol[data-v-7dbaddd8],ul ul[data-v-7dbaddd8]{margin-bottom:0}dt[data-v-7dbaddd8]{font-weight:700}dd[data-v-7dbaddd8]{margin-bottom:.5rem;margin-left:0}blockquote[data-v-7dbaddd8]{margin:0 0 1rem}b[data-v-7dbaddd8],strong[data-v-7dbaddd8]{font-weight:bolder}.small[data-v-7dbaddd8],small[data-v-7dbaddd8]{font-size:.875em}.mark[data-v-7dbaddd8],mark[data-v-7dbaddd8]{padding:.2em;background-color:#fcf8e3}sub[data-v-7dbaddd8],sup[data-v-7dbaddd8]{position:relative;font-size:.75em;line-height:0;vertical-align:baseline}sub[data-v-7dbaddd8]{bottom:-.25em}sup[data-v-7dbaddd8]{top:-.5em}a[data-v-7dbaddd8]{color:#0d6efd;text-decoration:underline}a[data-v-7dbaddd8]:hover{color:#0a58ca}a[data-v-7dbaddd8]:not([href]):not([class]),a[data-v-7dbaddd8]:not([href]):not([class]):hover{color:inherit;text-decoration:none}code[data-v-7dbaddd8],kbd[data-v-7dbaddd8],pre[data-v-7dbaddd8],samp[data-v-7dbaddd8]{font-family:var(--bs-font-monospace);font-size:1em;direction:ltr;unicode-bidi:bidi-override}pre[data-v-7dbaddd8]{display:block;margin-top:0;margin-bottom:1rem;overflow:auto;font-size:.875em}pre code[data-v-7dbaddd8]{font-size:inherit;color:inherit;word-break:normal}code[data-v-7dbaddd8]{font-size:.875em;color:#d63384;word-wrap:break-word}a>code[data-v-7dbaddd8]{color:inherit}kbd[data-v-7dbaddd8]{padding:.2rem .4rem;font-size:.875em;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd[data-v-7dbaddd8]{padding:0;font-size:1em;font-weight:700}figure[data-v-7dbaddd8]{margin:0 0 1rem}img[data-v-7dbaddd8],svg[data-v-7dbaddd8]{vertical-align:middle}table[data-v-7dbaddd8]{caption-side:bottom;border-collapse:collapse}caption[data-v-7dbaddd8]{padding-top:.5rem;padding-bottom:.5rem;color:#6c757d;text-align:left}th[data-v-7dbaddd8]{text-align:inherit;text-align:-webkit-match-parent}tbody[data-v-7dbaddd8],td[data-v-7dbaddd8],tfoot[data-v-7dbaddd8],th[data-v-7dbaddd8],thead[data-v-7dbaddd8],tr[data-v-7dbaddd8]{border-color:inherit;border-style:solid;border-width:0}label[data-v-7dbaddd8]{display:inline-block}button[data-v-7dbaddd8]{border-radius:0}button[data-v-7dbaddd8]:focus:not(:focus-visible){outline:0}button[data-v-7dbaddd8],input[data-v-7dbaddd8],optgroup[data-v-7dbaddd8],select[data-v-7dbaddd8],textarea[data-v-7dbaddd8]{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button[data-v-7dbaddd8],select[data-v-7dbaddd8]{text-transform:none}[role=button][data-v-7dbaddd8]{cursor:pointer}select[data-v-7dbaddd8]{word-wrap:normal}select[data-v-7dbaddd8]:disabled{opacity:1}[list][data-v-7dbaddd8]::-webkit-calendar-picker-indicator{display:none}[type=button][data-v-7dbaddd8],[type=reset][data-v-7dbaddd8],[type=submit][data-v-7dbaddd8],button[data-v-7dbaddd8]{-webkit-appearance:button}[type=button][data-v-7dbaddd8]:not(:disabled),[type=reset][data-v-7dbaddd8]:not(:disabled),[type=submit][data-v-7dbaddd8]:not(:disabled),button[data-v-7dbaddd8]:not(:disabled){cursor:pointer}[data-v-7dbaddd8]::-moz-focus-inner{padding:0;border-style:none}textarea[data-v-7dbaddd8]{resize:vertical}fieldset[data-v-7dbaddd8]{min-width:0;padding:0;margin:0;border:0}legend[data-v-7dbaddd8]{float:left;width:100%;padding:0;margin-bottom:.5rem;font-size:calc(1.275rem + .3vw);line-height:inherit}@media (min-width:1200px){legend[data-v-7dbaddd8]{font-size:1.5rem}}legend+[data-v-7dbaddd8]{clear:left}[data-v-7dbaddd8]::-webkit-datetime-edit-day-field,[data-v-7dbaddd8]::-webkit-datetime-edit-fields-wrapper,[data-v-7dbaddd8]::-webkit-datetime-edit-hour-field,[data-v-7dbaddd8]::-webkit-datetime-edit-minute,[data-v-7dbaddd8]::-webkit-datetime-edit-month-field,[data-v-7dbaddd8]::-webkit-datetime-edit-text,[data-v-7dbaddd8]::-webkit-datetime-edit-year-field{padding:0}[data-v-7dbaddd8]::-webkit-inner-spin-button{height:auto}[type=search][data-v-7dbaddd8]{outline-offset:-2px;-webkit-appearance:textfield}[data-v-7dbaddd8]::-webkit-search-decoration{-webkit-appearance:none}[data-v-7dbaddd8]::-webkit-color-swatch-wrapper{padding:0}[data-v-7dbaddd8]::file-selector-button{font:inherit}[data-v-7dbaddd8]::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output[data-v-7dbaddd8]{display:inline-block}iframe[data-v-7dbaddd8]{border:0}summary[data-v-7dbaddd8]{display:list-item;cursor:pointer}progress[data-v-7dbaddd8]{vertical-align:baseline}[hidden][data-v-7dbaddd8]{display:none!important}.lead[data-v-7dbaddd8]{font-size:1.25rem;font-weight:300}.display-1[data-v-7dbaddd8]{font-size:calc(1.625rem + 4.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-1[data-v-7dbaddd8]{font-size:5rem}}.display-2[data-v-7dbaddd8]{font-size:calc(1.575rem + 3.9vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-2[data-v-7dbaddd8]{font-size:4.5rem}}.display-3[data-v-7dbaddd8]{font-size:calc(1.525rem + 3.3vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-3[data-v-7dbaddd8]{font-size:4rem}}.display-4[data-v-7dbaddd8]{font-size:calc(1.475rem + 2.7vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-4[data-v-7dbaddd8]{font-size:3.5rem}}.display-5[data-v-7dbaddd8]{font-size:calc(1.425rem + 2.1vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-5[data-v-7dbaddd8]{font-size:3rem}}.display-6[data-v-7dbaddd8]{font-size:calc(1.375rem + 1.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-6[data-v-7dbaddd8]{font-size:2.5rem}}.list-inline[data-v-7dbaddd8],.list-unstyled[data-v-7dbaddd8]{padding-left:0;list-style:none}.list-inline-item[data-v-7dbaddd8]{display:inline-block}.list-inline-item[data-v-7dbaddd8]:not(:last-child){margin-right:.5rem}.initialism[data-v-7dbaddd8]{font-size:.875em;text-transform:uppercase}.blockquote[data-v-7dbaddd8]{margin-bottom:1rem;font-size:1.25rem}.blockquote[data-v-7dbaddd8]>:last-child{margin-bottom:0}.blockquote-footer[data-v-7dbaddd8]{margin-top:-1rem;margin-bottom:1rem;font-size:.875em;color:#6c757d}.blockquote-footer[data-v-7dbaddd8]:before{content:\"\\2014\\A0\"}.img-fluid[data-v-7dbaddd8]{max-width:100%;height:auto}.img-thumbnail[data-v-7dbaddd8]{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.figure[data-v-7dbaddd8]{display:inline-block}.figure-img[data-v-7dbaddd8]{margin-bottom:.5rem;line-height:1}.figure-caption[data-v-7dbaddd8]{font-size:.875em;color:#6c757d}.container-fluid[data-v-7dbaddd8],.container-lg[data-v-7dbaddd8],.container-md[data-v-7dbaddd8],.container-sm[data-v-7dbaddd8],.container-xl[data-v-7dbaddd8],.container-xxl[data-v-7dbaddd8],.container[data-v-7dbaddd8]{width:100%;padding-right:var(--bs-gutter-x,.75rem);padding-left:var(--bs-gutter-x,.75rem);margin-right:auto;margin-left:auto}@media (min-width:576px){.container-sm[data-v-7dbaddd8],.container[data-v-7dbaddd8]{max-width:540px}}@media (min-width:768px){.container-md[data-v-7dbaddd8],.container-sm[data-v-7dbaddd8],.container[data-v-7dbaddd8]{max-width:720px}}@media (min-width:992px){.container-lg[data-v-7dbaddd8],.container-md[data-v-7dbaddd8],.container-sm[data-v-7dbaddd8],.container[data-v-7dbaddd8]{max-width:960px}}@media (min-width:1200px){.container-lg[data-v-7dbaddd8],.container-md[data-v-7dbaddd8],.container-sm[data-v-7dbaddd8],.container-xl[data-v-7dbaddd8],.container[data-v-7dbaddd8]{max-width:1140px}}@media (min-width:1400px){.container-lg[data-v-7dbaddd8],.container-md[data-v-7dbaddd8],.container-sm[data-v-7dbaddd8],.container-xl[data-v-7dbaddd8],.container-xxl[data-v-7dbaddd8],.container[data-v-7dbaddd8]{max-width:1320px}}.row[data-v-7dbaddd8]{--bs-gutter-x:1.5rem;--bs-gutter-y:0;display:flex;flex-wrap:wrap;margin-top:calc(-1 * var(--bs-gutter-y));margin-right:calc(-.5 * var(--bs-gutter-x));margin-left:calc(-.5 * var(--bs-gutter-x))}.row>[data-v-7dbaddd8]{flex-shrink:0;width:100%;max-width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-top:var(--bs-gutter-y)}.col[data-v-7dbaddd8]{flex:1 0 0%}.row-cols-auto>[data-v-7dbaddd8]{flex:0 0 auto;width:auto}.row-cols-1>[data-v-7dbaddd8]{flex:0 0 auto;width:100%}.row-cols-2>[data-v-7dbaddd8]{flex:0 0 auto;width:50%}.row-cols-3>[data-v-7dbaddd8]{flex:0 0 auto;width:33.3333333333%}.row-cols-4>[data-v-7dbaddd8]{flex:0 0 auto;width:25%}.row-cols-5>[data-v-7dbaddd8]{flex:0 0 auto;width:20%}.row-cols-6>[data-v-7dbaddd8]{flex:0 0 auto;width:16.6666666667%}.col-auto[data-v-7dbaddd8]{flex:0 0 auto;width:auto}.col-1[data-v-7dbaddd8]{flex:0 0 auto;width:8.33333333%}.col-2[data-v-7dbaddd8]{flex:0 0 auto;width:16.66666667%}.col-3[data-v-7dbaddd8]{flex:0 0 auto;width:25%}.col-4[data-v-7dbaddd8]{flex:0 0 auto;width:33.33333333%}.col-5[data-v-7dbaddd8]{flex:0 0 auto;width:41.66666667%}.col-6[data-v-7dbaddd8]{flex:0 0 auto;width:50%}.col-7[data-v-7dbaddd8]{flex:0 0 auto;width:58.33333333%}.col-8[data-v-7dbaddd8]{flex:0 0 auto;width:66.66666667%}.col-9[data-v-7dbaddd8]{flex:0 0 auto;width:75%}.col-10[data-v-7dbaddd8]{flex:0 0 auto;width:83.33333333%}.col-11[data-v-7dbaddd8]{flex:0 0 auto;width:91.66666667%}.col-12[data-v-7dbaddd8]{flex:0 0 auto;width:100%}.offset-1[data-v-7dbaddd8]{margin-left:8.33333333%}.offset-2[data-v-7dbaddd8]{margin-left:16.66666667%}.offset-3[data-v-7dbaddd8]{margin-left:25%}.offset-4[data-v-7dbaddd8]{margin-left:33.33333333%}.offset-5[data-v-7dbaddd8]{margin-left:41.66666667%}.offset-6[data-v-7dbaddd8]{margin-left:50%}.offset-7[data-v-7dbaddd8]{margin-left:58.33333333%}.offset-8[data-v-7dbaddd8]{margin-left:66.66666667%}.offset-9[data-v-7dbaddd8]{margin-left:75%}.offset-10[data-v-7dbaddd8]{margin-left:83.33333333%}.offset-11[data-v-7dbaddd8]{margin-left:91.66666667%}.g-0[data-v-7dbaddd8],.gx-0[data-v-7dbaddd8]{--bs-gutter-x:0}.g-0[data-v-7dbaddd8],.gy-0[data-v-7dbaddd8]{--bs-gutter-y:0}.g-1[data-v-7dbaddd8],.gx-1[data-v-7dbaddd8]{--bs-gutter-x:0.25rem}.g-1[data-v-7dbaddd8],.gy-1[data-v-7dbaddd8]{--bs-gutter-y:0.25rem}.g-2[data-v-7dbaddd8],.gx-2[data-v-7dbaddd8]{--bs-gutter-x:0.5rem}.g-2[data-v-7dbaddd8],.gy-2[data-v-7dbaddd8]{--bs-gutter-y:0.5rem}.g-3[data-v-7dbaddd8],.gx-3[data-v-7dbaddd8]{--bs-gutter-x:1rem}.g-3[data-v-7dbaddd8],.gy-3[data-v-7dbaddd8]{--bs-gutter-y:1rem}.g-4[data-v-7dbaddd8],.gx-4[data-v-7dbaddd8]{--bs-gutter-x:1.5rem}.g-4[data-v-7dbaddd8],.gy-4[data-v-7dbaddd8]{--bs-gutter-y:1.5rem}.g-5[data-v-7dbaddd8],.gx-5[data-v-7dbaddd8]{--bs-gutter-x:3rem}.g-5[data-v-7dbaddd8],.gy-5[data-v-7dbaddd8]{--bs-gutter-y:3rem}@media (min-width:576px){.col-sm[data-v-7dbaddd8]{flex:1 0 0%}.row-cols-sm-auto>[data-v-7dbaddd8]{flex:0 0 auto;width:auto}.row-cols-sm-1>[data-v-7dbaddd8]{flex:0 0 auto;width:100%}.row-cols-sm-2>[data-v-7dbaddd8]{flex:0 0 auto;width:50%}.row-cols-sm-3>[data-v-7dbaddd8]{flex:0 0 auto;width:33.3333333333%}.row-cols-sm-4>[data-v-7dbaddd8]{flex:0 0 auto;width:25%}.row-cols-sm-5>[data-v-7dbaddd8]{flex:0 0 auto;width:20%}.row-cols-sm-6>[data-v-7dbaddd8]{flex:0 0 auto;width:16.6666666667%}.col-sm-auto[data-v-7dbaddd8]{flex:0 0 auto;width:auto}.col-sm-1[data-v-7dbaddd8]{flex:0 0 auto;width:8.33333333%}.col-sm-2[data-v-7dbaddd8]{flex:0 0 auto;width:16.66666667%}.col-sm-3[data-v-7dbaddd8]{flex:0 0 auto;width:25%}.col-sm-4[data-v-7dbaddd8]{flex:0 0 auto;width:33.33333333%}.col-sm-5[data-v-7dbaddd8]{flex:0 0 auto;width:41.66666667%}.col-sm-6[data-v-7dbaddd8]{flex:0 0 auto;width:50%}.col-sm-7[data-v-7dbaddd8]{flex:0 0 auto;width:58.33333333%}.col-sm-8[data-v-7dbaddd8]{flex:0 0 auto;width:66.66666667%}.col-sm-9[data-v-7dbaddd8]{flex:0 0 auto;width:75%}.col-sm-10[data-v-7dbaddd8]{flex:0 0 auto;width:83.33333333%}.col-sm-11[data-v-7dbaddd8]{flex:0 0 auto;width:91.66666667%}.col-sm-12[data-v-7dbaddd8]{flex:0 0 auto;width:100%}.offset-sm-0[data-v-7dbaddd8]{margin-left:0}.offset-sm-1[data-v-7dbaddd8]{margin-left:8.33333333%}.offset-sm-2[data-v-7dbaddd8]{margin-left:16.66666667%}.offset-sm-3[data-v-7dbaddd8]{margin-left:25%}.offset-sm-4[data-v-7dbaddd8]{margin-left:33.33333333%}.offset-sm-5[data-v-7dbaddd8]{margin-left:41.66666667%}.offset-sm-6[data-v-7dbaddd8]{margin-left:50%}.offset-sm-7[data-v-7dbaddd8]{margin-left:58.33333333%}.offset-sm-8[data-v-7dbaddd8]{margin-left:66.66666667%}.offset-sm-9[data-v-7dbaddd8]{margin-left:75%}.offset-sm-10[data-v-7dbaddd8]{margin-left:83.33333333%}.offset-sm-11[data-v-7dbaddd8]{margin-left:91.66666667%}.g-sm-0[data-v-7dbaddd8],.gx-sm-0[data-v-7dbaddd8]{--bs-gutter-x:0}.g-sm-0[data-v-7dbaddd8],.gy-sm-0[data-v-7dbaddd8]{--bs-gutter-y:0}.g-sm-1[data-v-7dbaddd8],.gx-sm-1[data-v-7dbaddd8]{--bs-gutter-x:0.25rem}.g-sm-1[data-v-7dbaddd8],.gy-sm-1[data-v-7dbaddd8]{--bs-gutter-y:0.25rem}.g-sm-2[data-v-7dbaddd8],.gx-sm-2[data-v-7dbaddd8]{--bs-gutter-x:0.5rem}.g-sm-2[data-v-7dbaddd8],.gy-sm-2[data-v-7dbaddd8]{--bs-gutter-y:0.5rem}.g-sm-3[data-v-7dbaddd8],.gx-sm-3[data-v-7dbaddd8]{--bs-gutter-x:1rem}.g-sm-3[data-v-7dbaddd8],.gy-sm-3[data-v-7dbaddd8]{--bs-gutter-y:1rem}.g-sm-4[data-v-7dbaddd8],.gx-sm-4[data-v-7dbaddd8]{--bs-gutter-x:1.5rem}.g-sm-4[data-v-7dbaddd8],.gy-sm-4[data-v-7dbaddd8]{--bs-gutter-y:1.5rem}.g-sm-5[data-v-7dbaddd8],.gx-sm-5[data-v-7dbaddd8]{--bs-gutter-x:3rem}.g-sm-5[data-v-7dbaddd8],.gy-sm-5[data-v-7dbaddd8]{--bs-gutter-y:3rem}}@media (min-width:768px){.col-md[data-v-7dbaddd8]{flex:1 0 0%}.row-cols-md-auto>[data-v-7dbaddd8]{flex:0 0 auto;width:auto}.row-cols-md-1>[data-v-7dbaddd8]{flex:0 0 auto;width:100%}.row-cols-md-2>[data-v-7dbaddd8]{flex:0 0 auto;width:50%}.row-cols-md-3>[data-v-7dbaddd8]{flex:0 0 auto;width:33.3333333333%}.row-cols-md-4>[data-v-7dbaddd8]{flex:0 0 auto;width:25%}.row-cols-md-5>[data-v-7dbaddd8]{flex:0 0 auto;width:20%}.row-cols-md-6>[data-v-7dbaddd8]{flex:0 0 auto;width:16.6666666667%}.col-md-auto[data-v-7dbaddd8]{flex:0 0 auto;width:auto}.col-md-1[data-v-7dbaddd8]{flex:0 0 auto;width:8.33333333%}.col-md-2[data-v-7dbaddd8]{flex:0 0 auto;width:16.66666667%}.col-md-3[data-v-7dbaddd8]{flex:0 0 auto;width:25%}.col-md-4[data-v-7dbaddd8]{flex:0 0 auto;width:33.33333333%}.col-md-5[data-v-7dbaddd8]{flex:0 0 auto;width:41.66666667%}.col-md-6[data-v-7dbaddd8]{flex:0 0 auto;width:50%}.col-md-7[data-v-7dbaddd8]{flex:0 0 auto;width:58.33333333%}.col-md-8[data-v-7dbaddd8]{flex:0 0 auto;width:66.66666667%}.col-md-9[data-v-7dbaddd8]{flex:0 0 auto;width:75%}.col-md-10[data-v-7dbaddd8]{flex:0 0 auto;width:83.33333333%}.col-md-11[data-v-7dbaddd8]{flex:0 0 auto;width:91.66666667%}.col-md-12[data-v-7dbaddd8]{flex:0 0 auto;width:100%}.offset-md-0[data-v-7dbaddd8]{margin-left:0}.offset-md-1[data-v-7dbaddd8]{margin-left:8.33333333%}.offset-md-2[data-v-7dbaddd8]{margin-left:16.66666667%}.offset-md-3[data-v-7dbaddd8]{margin-left:25%}.offset-md-4[data-v-7dbaddd8]{margin-left:33.33333333%}.offset-md-5[data-v-7dbaddd8]{margin-left:41.66666667%}.offset-md-6[data-v-7dbaddd8]{margin-left:50%}.offset-md-7[data-v-7dbaddd8]{margin-left:58.33333333%}.offset-md-8[data-v-7dbaddd8]{margin-left:66.66666667%}.offset-md-9[data-v-7dbaddd8]{margin-left:75%}.offset-md-10[data-v-7dbaddd8]{margin-left:83.33333333%}.offset-md-11[data-v-7dbaddd8]{margin-left:91.66666667%}.g-md-0[data-v-7dbaddd8],.gx-md-0[data-v-7dbaddd8]{--bs-gutter-x:0}.g-md-0[data-v-7dbaddd8],.gy-md-0[data-v-7dbaddd8]{--bs-gutter-y:0}.g-md-1[data-v-7dbaddd8],.gx-md-1[data-v-7dbaddd8]{--bs-gutter-x:0.25rem}.g-md-1[data-v-7dbaddd8],.gy-md-1[data-v-7dbaddd8]{--bs-gutter-y:0.25rem}.g-md-2[data-v-7dbaddd8],.gx-md-2[data-v-7dbaddd8]{--bs-gutter-x:0.5rem}.g-md-2[data-v-7dbaddd8],.gy-md-2[data-v-7dbaddd8]{--bs-gutter-y:0.5rem}.g-md-3[data-v-7dbaddd8],.gx-md-3[data-v-7dbaddd8]{--bs-gutter-x:1rem}.g-md-3[data-v-7dbaddd8],.gy-md-3[data-v-7dbaddd8]{--bs-gutter-y:1rem}.g-md-4[data-v-7dbaddd8],.gx-md-4[data-v-7dbaddd8]{--bs-gutter-x:1.5rem}.g-md-4[data-v-7dbaddd8],.gy-md-4[data-v-7dbaddd8]{--bs-gutter-y:1.5rem}.g-md-5[data-v-7dbaddd8],.gx-md-5[data-v-7dbaddd8]{--bs-gutter-x:3rem}.g-md-5[data-v-7dbaddd8],.gy-md-5[data-v-7dbaddd8]{--bs-gutter-y:3rem}}@media (min-width:992px){.col-lg[data-v-7dbaddd8]{flex:1 0 0%}.row-cols-lg-auto>[data-v-7dbaddd8]{flex:0 0 auto;width:auto}.row-cols-lg-1>[data-v-7dbaddd8]{flex:0 0 auto;width:100%}.row-cols-lg-2>[data-v-7dbaddd8]{flex:0 0 auto;width:50%}.row-cols-lg-3>[data-v-7dbaddd8]{flex:0 0 auto;width:33.3333333333%}.row-cols-lg-4>[data-v-7dbaddd8]{flex:0 0 auto;width:25%}.row-cols-lg-5>[data-v-7dbaddd8]{flex:0 0 auto;width:20%}.row-cols-lg-6>[data-v-7dbaddd8]{flex:0 0 auto;width:16.6666666667%}.col-lg-auto[data-v-7dbaddd8]{flex:0 0 auto;width:auto}.col-lg-1[data-v-7dbaddd8]{flex:0 0 auto;width:8.33333333%}.col-lg-2[data-v-7dbaddd8]{flex:0 0 auto;width:16.66666667%}.col-lg-3[data-v-7dbaddd8]{flex:0 0 auto;width:25%}.col-lg-4[data-v-7dbaddd8]{flex:0 0 auto;width:33.33333333%}.col-lg-5[data-v-7dbaddd8]{flex:0 0 auto;width:41.66666667%}.col-lg-6[data-v-7dbaddd8]{flex:0 0 auto;width:50%}.col-lg-7[data-v-7dbaddd8]{flex:0 0 auto;width:58.33333333%}.col-lg-8[data-v-7dbaddd8]{flex:0 0 auto;width:66.66666667%}.col-lg-9[data-v-7dbaddd8]{flex:0 0 auto;width:75%}.col-lg-10[data-v-7dbaddd8]{flex:0 0 auto;width:83.33333333%}.col-lg-11[data-v-7dbaddd8]{flex:0 0 auto;width:91.66666667%}.col-lg-12[data-v-7dbaddd8]{flex:0 0 auto;width:100%}.offset-lg-0[data-v-7dbaddd8]{margin-left:0}.offset-lg-1[data-v-7dbaddd8]{margin-left:8.33333333%}.offset-lg-2[data-v-7dbaddd8]{margin-left:16.66666667%}.offset-lg-3[data-v-7dbaddd8]{margin-left:25%}.offset-lg-4[data-v-7dbaddd8]{margin-left:33.33333333%}.offset-lg-5[data-v-7dbaddd8]{margin-left:41.66666667%}.offset-lg-6[data-v-7dbaddd8]{margin-left:50%}.offset-lg-7[data-v-7dbaddd8]{margin-left:58.33333333%}.offset-lg-8[data-v-7dbaddd8]{margin-left:66.66666667%}.offset-lg-9[data-v-7dbaddd8]{margin-left:75%}.offset-lg-10[data-v-7dbaddd8]{margin-left:83.33333333%}.offset-lg-11[data-v-7dbaddd8]{margin-left:91.66666667%}.g-lg-0[data-v-7dbaddd8],.gx-lg-0[data-v-7dbaddd8]{--bs-gutter-x:0}.g-lg-0[data-v-7dbaddd8],.gy-lg-0[data-v-7dbaddd8]{--bs-gutter-y:0}.g-lg-1[data-v-7dbaddd8],.gx-lg-1[data-v-7dbaddd8]{--bs-gutter-x:0.25rem}.g-lg-1[data-v-7dbaddd8],.gy-lg-1[data-v-7dbaddd8]{--bs-gutter-y:0.25rem}.g-lg-2[data-v-7dbaddd8],.gx-lg-2[data-v-7dbaddd8]{--bs-gutter-x:0.5rem}.g-lg-2[data-v-7dbaddd8],.gy-lg-2[data-v-7dbaddd8]{--bs-gutter-y:0.5rem}.g-lg-3[data-v-7dbaddd8],.gx-lg-3[data-v-7dbaddd8]{--bs-gutter-x:1rem}.g-lg-3[data-v-7dbaddd8],.gy-lg-3[data-v-7dbaddd8]{--bs-gutter-y:1rem}.g-lg-4[data-v-7dbaddd8],.gx-lg-4[data-v-7dbaddd8]{--bs-gutter-x:1.5rem}.g-lg-4[data-v-7dbaddd8],.gy-lg-4[data-v-7dbaddd8]{--bs-gutter-y:1.5rem}.g-lg-5[data-v-7dbaddd8],.gx-lg-5[data-v-7dbaddd8]{--bs-gutter-x:3rem}.g-lg-5[data-v-7dbaddd8],.gy-lg-5[data-v-7dbaddd8]{--bs-gutter-y:3rem}}@media (min-width:1200px){.col-xl[data-v-7dbaddd8]{flex:1 0 0%}.row-cols-xl-auto>[data-v-7dbaddd8]{flex:0 0 auto;width:auto}.row-cols-xl-1>[data-v-7dbaddd8]{flex:0 0 auto;width:100%}.row-cols-xl-2>[data-v-7dbaddd8]{flex:0 0 auto;width:50%}.row-cols-xl-3>[data-v-7dbaddd8]{flex:0 0 auto;width:33.3333333333%}.row-cols-xl-4>[data-v-7dbaddd8]{flex:0 0 auto;width:25%}.row-cols-xl-5>[data-v-7dbaddd8]{flex:0 0 auto;width:20%}.row-cols-xl-6>[data-v-7dbaddd8]{flex:0 0 auto;width:16.6666666667%}.col-xl-auto[data-v-7dbaddd8]{flex:0 0 auto;width:auto}.col-xl-1[data-v-7dbaddd8]{flex:0 0 auto;width:8.33333333%}.col-xl-2[data-v-7dbaddd8]{flex:0 0 auto;width:16.66666667%}.col-xl-3[data-v-7dbaddd8]{flex:0 0 auto;width:25%}.col-xl-4[data-v-7dbaddd8]{flex:0 0 auto;width:33.33333333%}.col-xl-5[data-v-7dbaddd8]{flex:0 0 auto;width:41.66666667%}.col-xl-6[data-v-7dbaddd8]{flex:0 0 auto;width:50%}.col-xl-7[data-v-7dbaddd8]{flex:0 0 auto;width:58.33333333%}.col-xl-8[data-v-7dbaddd8]{flex:0 0 auto;width:66.66666667%}.col-xl-9[data-v-7dbaddd8]{flex:0 0 auto;width:75%}.col-xl-10[data-v-7dbaddd8]{flex:0 0 auto;width:83.33333333%}.col-xl-11[data-v-7dbaddd8]{flex:0 0 auto;width:91.66666667%}.col-xl-12[data-v-7dbaddd8]{flex:0 0 auto;width:100%}.offset-xl-0[data-v-7dbaddd8]{margin-left:0}.offset-xl-1[data-v-7dbaddd8]{margin-left:8.33333333%}.offset-xl-2[data-v-7dbaddd8]{margin-left:16.66666667%}.offset-xl-3[data-v-7dbaddd8]{margin-left:25%}.offset-xl-4[data-v-7dbaddd8]{margin-left:33.33333333%}.offset-xl-5[data-v-7dbaddd8]{margin-left:41.66666667%}.offset-xl-6[data-v-7dbaddd8]{margin-left:50%}.offset-xl-7[data-v-7dbaddd8]{margin-left:58.33333333%}.offset-xl-8[data-v-7dbaddd8]{margin-left:66.66666667%}.offset-xl-9[data-v-7dbaddd8]{margin-left:75%}.offset-xl-10[data-v-7dbaddd8]{margin-left:83.33333333%}.offset-xl-11[data-v-7dbaddd8]{margin-left:91.66666667%}.g-xl-0[data-v-7dbaddd8],.gx-xl-0[data-v-7dbaddd8]{--bs-gutter-x:0}.g-xl-0[data-v-7dbaddd8],.gy-xl-0[data-v-7dbaddd8]{--bs-gutter-y:0}.g-xl-1[data-v-7dbaddd8],.gx-xl-1[data-v-7dbaddd8]{--bs-gutter-x:0.25rem}.g-xl-1[data-v-7dbaddd8],.gy-xl-1[data-v-7dbaddd8]{--bs-gutter-y:0.25rem}.g-xl-2[data-v-7dbaddd8],.gx-xl-2[data-v-7dbaddd8]{--bs-gutter-x:0.5rem}.g-xl-2[data-v-7dbaddd8],.gy-xl-2[data-v-7dbaddd8]{--bs-gutter-y:0.5rem}.g-xl-3[data-v-7dbaddd8],.gx-xl-3[data-v-7dbaddd8]{--bs-gutter-x:1rem}.g-xl-3[data-v-7dbaddd8],.gy-xl-3[data-v-7dbaddd8]{--bs-gutter-y:1rem}.g-xl-4[data-v-7dbaddd8],.gx-xl-4[data-v-7dbaddd8]{--bs-gutter-x:1.5rem}.g-xl-4[data-v-7dbaddd8],.gy-xl-4[data-v-7dbaddd8]{--bs-gutter-y:1.5rem}.g-xl-5[data-v-7dbaddd8],.gx-xl-5[data-v-7dbaddd8]{--bs-gutter-x:3rem}.g-xl-5[data-v-7dbaddd8],.gy-xl-5[data-v-7dbaddd8]{--bs-gutter-y:3rem}}@media (min-width:1400px){.col-xxl[data-v-7dbaddd8]{flex:1 0 0%}.row-cols-xxl-auto>[data-v-7dbaddd8]{flex:0 0 auto;width:auto}.row-cols-xxl-1>[data-v-7dbaddd8]{flex:0 0 auto;width:100%}.row-cols-xxl-2>[data-v-7dbaddd8]{flex:0 0 auto;width:50%}.row-cols-xxl-3>[data-v-7dbaddd8]{flex:0 0 auto;width:33.3333333333%}.row-cols-xxl-4>[data-v-7dbaddd8]{flex:0 0 auto;width:25%}.row-cols-xxl-5>[data-v-7dbaddd8]{flex:0 0 auto;width:20%}.row-cols-xxl-6>[data-v-7dbaddd8]{flex:0 0 auto;width:16.6666666667%}.col-xxl-auto[data-v-7dbaddd8]{flex:0 0 auto;width:auto}.col-xxl-1[data-v-7dbaddd8]{flex:0 0 auto;width:8.33333333%}.col-xxl-2[data-v-7dbaddd8]{flex:0 0 auto;width:16.66666667%}.col-xxl-3[data-v-7dbaddd8]{flex:0 0 auto;width:25%}.col-xxl-4[data-v-7dbaddd8]{flex:0 0 auto;width:33.33333333%}.col-xxl-5[data-v-7dbaddd8]{flex:0 0 auto;width:41.66666667%}.col-xxl-6[data-v-7dbaddd8]{flex:0 0 auto;width:50%}.col-xxl-7[data-v-7dbaddd8]{flex:0 0 auto;width:58.33333333%}.col-xxl-8[data-v-7dbaddd8]{flex:0 0 auto;width:66.66666667%}.col-xxl-9[data-v-7dbaddd8]{flex:0 0 auto;width:75%}.col-xxl-10[data-v-7dbaddd8]{flex:0 0 auto;width:83.33333333%}.col-xxl-11[data-v-7dbaddd8]{flex:0 0 auto;width:91.66666667%}.col-xxl-12[data-v-7dbaddd8]{flex:0 0 auto;width:100%}.offset-xxl-0[data-v-7dbaddd8]{margin-left:0}.offset-xxl-1[data-v-7dbaddd8]{margin-left:8.33333333%}.offset-xxl-2[data-v-7dbaddd8]{margin-left:16.66666667%}.offset-xxl-3[data-v-7dbaddd8]{margin-left:25%}.offset-xxl-4[data-v-7dbaddd8]{margin-left:33.33333333%}.offset-xxl-5[data-v-7dbaddd8]{margin-left:41.66666667%}.offset-xxl-6[data-v-7dbaddd8]{margin-left:50%}.offset-xxl-7[data-v-7dbaddd8]{margin-left:58.33333333%}.offset-xxl-8[data-v-7dbaddd8]{margin-left:66.66666667%}.offset-xxl-9[data-v-7dbaddd8]{margin-left:75%}.offset-xxl-10[data-v-7dbaddd8]{margin-left:83.33333333%}.offset-xxl-11[data-v-7dbaddd8]{margin-left:91.66666667%}.g-xxl-0[data-v-7dbaddd8],.gx-xxl-0[data-v-7dbaddd8]{--bs-gutter-x:0}.g-xxl-0[data-v-7dbaddd8],.gy-xxl-0[data-v-7dbaddd8]{--bs-gutter-y:0}.g-xxl-1[data-v-7dbaddd8],.gx-xxl-1[data-v-7dbaddd8]{--bs-gutter-x:0.25rem}.g-xxl-1[data-v-7dbaddd8],.gy-xxl-1[data-v-7dbaddd8]{--bs-gutter-y:0.25rem}.g-xxl-2[data-v-7dbaddd8],.gx-xxl-2[data-v-7dbaddd8]{--bs-gutter-x:0.5rem}.g-xxl-2[data-v-7dbaddd8],.gy-xxl-2[data-v-7dbaddd8]{--bs-gutter-y:0.5rem}.g-xxl-3[data-v-7dbaddd8],.gx-xxl-3[data-v-7dbaddd8]{--bs-gutter-x:1rem}.g-xxl-3[data-v-7dbaddd8],.gy-xxl-3[data-v-7dbaddd8]{--bs-gutter-y:1rem}.g-xxl-4[data-v-7dbaddd8],.gx-xxl-4[data-v-7dbaddd8]{--bs-gutter-x:1.5rem}.g-xxl-4[data-v-7dbaddd8],.gy-xxl-4[data-v-7dbaddd8]{--bs-gutter-y:1.5rem}.g-xxl-5[data-v-7dbaddd8],.gx-xxl-5[data-v-7dbaddd8]{--bs-gutter-x:3rem}.g-xxl-5[data-v-7dbaddd8],.gy-xxl-5[data-v-7dbaddd8]{--bs-gutter-y:3rem}}.table[data-v-7dbaddd8]{--bs-table-bg:transparent;--bs-table-accent-bg:transparent;--bs-table-striped-color:#212529;--bs-table-striped-bg:rgba(0,0,0,.05);--bs-table-active-color:#212529;--bs-table-active-bg:rgba(0,0,0,.1);--bs-table-hover-color:#212529;--bs-table-hover-bg:rgba(0,0,0,.075);width:100%;margin-bottom:1rem;color:#212529;vertical-align:top;border-color:#dee2e6}.table>:not(caption)>*>[data-v-7dbaddd8]{padding:.5rem;background-color:var(--bs-table-bg);border-bottom-width:1px;box-shadow:inset 0 0 0 9999px var(--bs-table-accent-bg)}.table>tbody[data-v-7dbaddd8]{vertical-align:inherit}.table>thead[data-v-7dbaddd8]{vertical-align:bottom}.table[data-v-7dbaddd8]>:not(:first-child){border-top:2px solid currentColor}.caption-top[data-v-7dbaddd8]{caption-side:top}.table-sm>:not(caption)>*>[data-v-7dbaddd8]{padding:.25rem}.table-bordered>:not(caption)>[data-v-7dbaddd8]{border-width:1px 0}.table-bordered>:not(caption)>*>[data-v-7dbaddd8]{border-width:0 1px}.table-borderless>:not(caption)>*>[data-v-7dbaddd8]{border-bottom-width:0}.table-borderless[data-v-7dbaddd8]>:not(:first-child){border-top-width:0}.table-striped>tbody>tr:nth-of-type(odd)>[data-v-7dbaddd8]{--bs-table-accent-bg:var(--bs-table-striped-bg);color:var(--bs-table-striped-color)}.table-active[data-v-7dbaddd8]{--bs-table-accent-bg:var(--bs-table-active-bg);color:var(--bs-table-active-color)}.table-hover>tbody>tr:hover>[data-v-7dbaddd8]{--bs-table-accent-bg:var(--bs-table-hover-bg);color:var(--bs-table-hover-color)}.table-primary[data-v-7dbaddd8]{--bs-table-bg:#cfe2ff;--bs-table-striped-bg:#c5d7f2;--bs-table-striped-color:#000;--bs-table-active-bg:#bacbe6;--bs-table-active-color:#000;--bs-table-hover-bg:#bfd1ec;--bs-table-hover-color:#000;color:#000;border-color:#bacbe6}.table-secondary[data-v-7dbaddd8]{--bs-table-bg:#e2e3e5;--bs-table-striped-bg:#d7d8da;--bs-table-striped-color:#000;--bs-table-active-bg:#cbccce;--bs-table-active-color:#000;--bs-table-hover-bg:#d1d2d4;--bs-table-hover-color:#000;color:#000;border-color:#cbccce}.table-success[data-v-7dbaddd8]{--bs-table-bg:#d1e7dd;--bs-table-striped-bg:#c7dbd2;--bs-table-striped-color:#000;--bs-table-active-bg:#bcd0c7;--bs-table-active-color:#000;--bs-table-hover-bg:#c1d6cc;--bs-table-hover-color:#000;color:#000;border-color:#bcd0c7}.table-info[data-v-7dbaddd8]{--bs-table-bg:#cff4fc;--bs-table-striped-bg:#c5e8ef;--bs-table-striped-color:#000;--bs-table-active-bg:#badce3;--bs-table-active-color:#000;--bs-table-hover-bg:#bfe2e9;--bs-table-hover-color:#000;color:#000;border-color:#badce3}.table-warning[data-v-7dbaddd8]{--bs-table-bg:#fff3cd;--bs-table-striped-bg:#f2e7c3;--bs-table-striped-color:#000;--bs-table-active-bg:#e6dbb9;--bs-table-active-color:#000;--bs-table-hover-bg:#ece1be;--bs-table-hover-color:#000;color:#000;border-color:#e6dbb9}.table-danger[data-v-7dbaddd8]{--bs-table-bg:#f8d7da;--bs-table-striped-bg:#eccccf;--bs-table-striped-color:#000;--bs-table-active-bg:#dfc2c4;--bs-table-active-color:#000;--bs-table-hover-bg:#e5c7ca;--bs-table-hover-color:#000;color:#000;border-color:#dfc2c4}.table-light[data-v-7dbaddd8]{--bs-table-bg:#f8f9fa;--bs-table-striped-bg:#ecedee;--bs-table-striped-color:#000;--bs-table-active-bg:#dfe0e1;--bs-table-active-color:#000;--bs-table-hover-bg:#e5e6e7;--bs-table-hover-color:#000;color:#000;border-color:#dfe0e1}.table-dark[data-v-7dbaddd8]{--bs-table-bg:#212529;--bs-table-striped-bg:#2c3034;--bs-table-striped-color:#fff;--bs-table-active-bg:#373b3e;--bs-table-active-color:#fff;--bs-table-hover-bg:#323539;--bs-table-hover-color:#fff;color:#fff;border-color:#373b3e}.table-responsive[data-v-7dbaddd8]{overflow-x:auto;-webkit-overflow-scrolling:touch}@media (max-width:575.98px){.table-responsive-sm[data-v-7dbaddd8]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:767.98px){.table-responsive-md[data-v-7dbaddd8]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:991.98px){.table-responsive-lg[data-v-7dbaddd8]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1199.98px){.table-responsive-xl[data-v-7dbaddd8]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1399.98px){.table-responsive-xxl[data-v-7dbaddd8]{overflow-x:auto;-webkit-overflow-scrolling:touch}}.form-label[data-v-7dbaddd8]{margin-bottom:.5rem}.col-form-label[data-v-7dbaddd8]{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg[data-v-7dbaddd8]{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem}.col-form-label-sm[data-v-7dbaddd8]{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem}.form-text[data-v-7dbaddd8]{margin-top:.25rem;font-size:.875em;color:#6c757d}.form-control[data-v-7dbaddd8]{display:block;width:100%;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-7dbaddd8]{transition:none}}.form-control[type=file][data-v-7dbaddd8]{overflow:hidden}.form-control[type=file][data-v-7dbaddd8]:not(:disabled):not([readonly]){cursor:pointer}.form-control[data-v-7dbaddd8]:focus{color:#212529;background-color:#fff;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-control[data-v-7dbaddd8]::-webkit-date-and-time-value{height:1.5em}.form-control[data-v-7dbaddd8]::-moz-placeholder{color:#6c757d;opacity:1}.form-control[data-v-7dbaddd8]::placeholder{color:#6c757d;opacity:1}.form-control[data-v-7dbaddd8]:disabled,.form-control[readonly][data-v-7dbaddd8]{background-color:#e9ecef;opacity:1}.form-control[data-v-7dbaddd8]::file-selector-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-7dbaddd8]::-webkit-file-upload-button{-webkit-transition:none;transition:none}.form-control[data-v-7dbaddd8]::file-selector-button{transition:none}}.form-control[data-v-7dbaddd8]:hover:not(:disabled):not([readonly])::file-selector-button{background-color:#dde0e3}.form-control[data-v-7dbaddd8]::-webkit-file-upload-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;-webkit-transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-7dbaddd8]::-webkit-file-upload-button{-webkit-transition:none;transition:none}}.form-control[data-v-7dbaddd8]:hover:not(:disabled):not([readonly])::-webkit-file-upload-button{background-color:#dde0e3}.form-control-plaintext[data-v-7dbaddd8]{display:block;width:100%;padding:.375rem 0;margin-bottom:0;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg[data-v-7dbaddd8],.form-control-plaintext.form-control-sm[data-v-7dbaddd8]{padding-right:0;padding-left:0}.form-control-sm[data-v-7dbaddd8]{min-height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.form-control-sm[data-v-7dbaddd8]::file-selector-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-sm[data-v-7dbaddd8]::-webkit-file-upload-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-lg[data-v-7dbaddd8]{min-height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.form-control-lg[data-v-7dbaddd8]::file-selector-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}.form-control-lg[data-v-7dbaddd8]::-webkit-file-upload-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}textarea.form-control[data-v-7dbaddd8]{min-height:calc(1.5em + .75rem + 2px)}textarea.form-control-sm[data-v-7dbaddd8]{min-height:calc(1.5em + .5rem + 2px)}textarea.form-control-lg[data-v-7dbaddd8]{min-height:calc(1.5em + 1rem + 2px)}.form-control-color[data-v-7dbaddd8]{width:3rem;height:auto;padding:.375rem}.form-control-color[data-v-7dbaddd8]:not(:disabled):not([readonly]){cursor:pointer}.form-control-color[data-v-7dbaddd8]::-moz-color-swatch{height:1.5em;border-radius:.25rem}.form-control-color[data-v-7dbaddd8]::-webkit-color-swatch{height:1.5em;border-radius:.25rem}.form-select[data-v-7dbaddd8]{display:block;width:100%;padding:.375rem 2.25rem .375rem .75rem;-moz-padding-start:calc(.75rem - 3px);font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right .75rem center;background-size:16px 12px;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-select[data-v-7dbaddd8]{transition:none}}.form-select[data-v-7dbaddd8]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-select[multiple][data-v-7dbaddd8],.form-select[size][data-v-7dbaddd8]:not([size=\"1\"]){padding-right:.75rem;background-image:none}.form-select[data-v-7dbaddd8]:disabled{background-color:#e9ecef}.form-select[data-v-7dbaddd8]:-moz-focusring{color:transparent;text-shadow:0 0 0 #212529}.form-select-sm[data-v-7dbaddd8]{padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem;border-radius:.2rem}.form-select-lg[data-v-7dbaddd8]{padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem;border-radius:.3rem}.form-check[data-v-7dbaddd8]{display:block;min-height:1.5rem;padding-left:1.5em;margin-bottom:.125rem}.form-check .form-check-input[data-v-7dbaddd8]{float:left;margin-left:-1.5em}.form-check-input[data-v-7dbaddd8]{width:1em;height:1em;margin-top:.25em;vertical-align:top;background-color:#fff;background-repeat:no-repeat;background-position:50%;background-size:contain;border:1px solid rgba(0,0,0,.25);-webkit-appearance:none;-moz-appearance:none;appearance:none;-webkit-print-color-adjust:exact;color-adjust:exact}.form-check-input[type=checkbox][data-v-7dbaddd8]{border-radius:.25em}.form-check-input[type=radio][data-v-7dbaddd8]{border-radius:50%}.form-check-input[data-v-7dbaddd8]:active{filter:brightness(90%)}.form-check-input[data-v-7dbaddd8]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-check-input[data-v-7dbaddd8]:checked{background-color:#0d6efd;border-color:#0d6efd}.form-check-input:checked[type=checkbox][data-v-7dbaddd8]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3 6-6'/%3E%3C/svg%3E\")}.form-check-input:checked[type=radio][data-v-7dbaddd8]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='2' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-input[type=checkbox][data-v-7dbaddd8]:indeterminate{background-color:#0d6efd;border-color:#0d6efd;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3E%3C/svg%3E\")}.form-check-input[data-v-7dbaddd8]:disabled{pointer-events:none;filter:none;opacity:.5}.form-check-input:disabled~.form-check-label[data-v-7dbaddd8],.form-check-input[disabled]~.form-check-label[data-v-7dbaddd8]{opacity:.5}.form-switch[data-v-7dbaddd8]{padding-left:2.5em}.form-switch .form-check-input[data-v-7dbaddd8]{width:2em;margin-left:-2.5em;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='rgba(0, 0, 0, 0.25)'/%3E%3C/svg%3E\");background-position:0;border-radius:2em;transition:background-position .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-switch .form-check-input[data-v-7dbaddd8]{transition:none}}.form-switch .form-check-input[data-v-7dbaddd8]:focus{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%2386b7fe'/%3E%3C/svg%3E\")}.form-switch .form-check-input[data-v-7dbaddd8]:checked{background-position:100%;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-inline[data-v-7dbaddd8]{display:inline-block;margin-right:1rem}.btn-check[data-v-7dbaddd8]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.btn-check:disabled+.btn[data-v-7dbaddd8],.btn-check[disabled]+.btn[data-v-7dbaddd8]{pointer-events:none;filter:none;opacity:.65}.form-range[data-v-7dbaddd8]{width:100%;height:1.5rem;padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.form-range[data-v-7dbaddd8]:focus{outline:0}.form-range[data-v-7dbaddd8]:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-7dbaddd8]:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-7dbaddd8]::-moz-focus-outer{border:0}.form-range[data-v-7dbaddd8]::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#0d6efd;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-7dbaddd8]::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.form-range[data-v-7dbaddd8]::-webkit-slider-thumb:active{background-color:#b6d4fe}.form-range[data-v-7dbaddd8]::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-7dbaddd8]::-moz-range-thumb{width:1rem;height:1rem;background-color:#0d6efd;border:0;border-radius:1rem;-moz-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-7dbaddd8]::-moz-range-thumb{-moz-transition:none;transition:none}}.form-range[data-v-7dbaddd8]::-moz-range-thumb:active{background-color:#b6d4fe}.form-range[data-v-7dbaddd8]::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-7dbaddd8]:disabled{pointer-events:none}.form-range[data-v-7dbaddd8]:disabled::-webkit-slider-thumb{background-color:#adb5bd}.form-range[data-v-7dbaddd8]:disabled::-moz-range-thumb{background-color:#adb5bd}.form-floating[data-v-7dbaddd8]{position:relative}.form-floating>.form-control[data-v-7dbaddd8],.form-floating>.form-select[data-v-7dbaddd8]{height:calc(3.5rem + 2px);line-height:1.25}.form-floating>label[data-v-7dbaddd8]{position:absolute;top:0;left:0;height:100%;padding:1rem .75rem;pointer-events:none;border:1px solid transparent;transform-origin:0 0;transition:opacity .1s ease-in-out,transform .1s ease-in-out}@media (prefers-reduced-motion:reduce){.form-floating>label[data-v-7dbaddd8]{transition:none}}.form-floating>.form-control[data-v-7dbaddd8]{padding:1rem .75rem}.form-floating>.form-control[data-v-7dbaddd8]::-moz-placeholder{color:transparent}.form-floating>.form-control[data-v-7dbaddd8]::placeholder{color:transparent}.form-floating>.form-control[data-v-7dbaddd8]:not(:-moz-placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-7dbaddd8]:focus,.form-floating>.form-control[data-v-7dbaddd8]:not(:placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-7dbaddd8]:-webkit-autofill{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-select[data-v-7dbaddd8]{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control:not(:-moz-placeholder-shown)~label[data-v-7dbaddd8]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:focus~label[data-v-7dbaddd8],.form-floating>.form-control:not(:placeholder-shown)~label[data-v-7dbaddd8],.form-floating>.form-select~label[data-v-7dbaddd8]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:-webkit-autofill~label[data-v-7dbaddd8]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.input-group[data-v-7dbaddd8]{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group>.form-control[data-v-7dbaddd8],.input-group>.form-select[data-v-7dbaddd8]{position:relative;flex:1 1 auto;width:1%;min-width:0}.input-group>.form-control[data-v-7dbaddd8]:focus,.input-group>.form-select[data-v-7dbaddd8]:focus{z-index:3}.input-group .btn[data-v-7dbaddd8]{position:relative;z-index:2}.input-group .btn[data-v-7dbaddd8]:focus{z-index:3}.input-group-text[data-v-7dbaddd8]{display:flex;align-items:center;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-lg>.btn[data-v-7dbaddd8],.input-group-lg>.form-control[data-v-7dbaddd8],.input-group-lg>.form-select[data-v-7dbaddd8],.input-group-lg>.input-group-text[data-v-7dbaddd8]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.input-group-sm>.btn[data-v-7dbaddd8],.input-group-sm>.form-control[data-v-7dbaddd8],.input-group-sm>.form-select[data-v-7dbaddd8],.input-group-sm>.input-group-text[data-v-7dbaddd8]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.input-group-lg>.form-select[data-v-7dbaddd8],.input-group-sm>.form-select[data-v-7dbaddd8]{padding-right:3rem}.input-group.has-validation>.dropdown-toggle[data-v-7dbaddd8]:nth-last-child(n+4),.input-group.has-validation[data-v-7dbaddd8]>:nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),.input-group:not(.has-validation)>.dropdown-toggle[data-v-7dbaddd8]:nth-last-child(n+3),.input-group[data-v-7dbaddd8]:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu){border-top-right-radius:0;border-bottom-right-radius:0}.input-group[data-v-7dbaddd8]>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}.valid-feedback[data-v-7dbaddd8]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#198754}.valid-tooltip[data-v-7dbaddd8]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(25,135,84,.9);border-radius:.25rem}.is-valid~.valid-feedback[data-v-7dbaddd8],.is-valid~.valid-tooltip[data-v-7dbaddd8],.was-validated :valid~.valid-feedback[data-v-7dbaddd8],.was-validated :valid~.valid-tooltip[data-v-7dbaddd8]{display:block}.form-control.is-valid[data-v-7dbaddd8],.was-validated .form-control[data-v-7dbaddd8]:valid{border-color:#198754;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-valid[data-v-7dbaddd8]:focus,.was-validated .form-control[data-v-7dbaddd8]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.was-validated textarea.form-control[data-v-7dbaddd8]:valid,textarea.form-control.is-valid[data-v-7dbaddd8]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-valid[data-v-7dbaddd8],.was-validated .form-select[data-v-7dbaddd8]:valid{border-color:#198754}.form-select.is-valid:not([multiple])[size=\"1\"][data-v-7dbaddd8],.form-select.is-valid[data-v-7dbaddd8]:not([multiple]):not([size]),.was-validated .form-select:valid:not([multiple])[size=\"1\"][data-v-7dbaddd8],.was-validated .form-select[data-v-7dbaddd8]:valid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-valid[data-v-7dbaddd8]:focus,.was-validated .form-select[data-v-7dbaddd8]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid[data-v-7dbaddd8],.was-validated .form-check-input[data-v-7dbaddd8]:valid{border-color:#198754}.form-check-input.is-valid[data-v-7dbaddd8]:checked,.was-validated .form-check-input[data-v-7dbaddd8]:valid:checked{background-color:#198754}.form-check-input.is-valid[data-v-7dbaddd8]:focus,.was-validated .form-check-input[data-v-7dbaddd8]:valid:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid~.form-check-label[data-v-7dbaddd8],.was-validated .form-check-input:valid~.form-check-label[data-v-7dbaddd8]{color:#198754}.form-check-inline .form-check-input~.valid-feedback[data-v-7dbaddd8]{margin-left:.5em}.input-group .form-control.is-valid[data-v-7dbaddd8],.input-group .form-select.is-valid[data-v-7dbaddd8],.was-validated .input-group .form-control[data-v-7dbaddd8]:valid,.was-validated .input-group .form-select[data-v-7dbaddd8]:valid{z-index:1}.input-group .form-control.is-valid[data-v-7dbaddd8]:focus,.input-group .form-select.is-valid[data-v-7dbaddd8]:focus,.was-validated .input-group .form-control[data-v-7dbaddd8]:valid:focus,.was-validated .input-group .form-select[data-v-7dbaddd8]:valid:focus{z-index:3}.invalid-feedback[data-v-7dbaddd8]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#dc3545}.invalid-tooltip[data-v-7dbaddd8]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(220,53,69,.9);border-radius:.25rem}.is-invalid~.invalid-feedback[data-v-7dbaddd8],.is-invalid~.invalid-tooltip[data-v-7dbaddd8],.was-validated :invalid~.invalid-feedback[data-v-7dbaddd8],.was-validated :invalid~.invalid-tooltip[data-v-7dbaddd8]{display:block}.form-control.is-invalid[data-v-7dbaddd8],.was-validated .form-control[data-v-7dbaddd8]:invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-invalid[data-v-7dbaddd8]:focus,.was-validated .form-control[data-v-7dbaddd8]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.was-validated textarea.form-control[data-v-7dbaddd8]:invalid,textarea.form-control.is-invalid[data-v-7dbaddd8]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-invalid[data-v-7dbaddd8],.was-validated .form-select[data-v-7dbaddd8]:invalid{border-color:#dc3545}.form-select.is-invalid:not([multiple])[size=\"1\"][data-v-7dbaddd8],.form-select.is-invalid[data-v-7dbaddd8]:not([multiple]):not([size]),.was-validated .form-select:invalid:not([multiple])[size=\"1\"][data-v-7dbaddd8],.was-validated .form-select[data-v-7dbaddd8]:invalid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-invalid[data-v-7dbaddd8]:focus,.was-validated .form-select[data-v-7dbaddd8]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid[data-v-7dbaddd8],.was-validated .form-check-input[data-v-7dbaddd8]:invalid{border-color:#dc3545}.form-check-input.is-invalid[data-v-7dbaddd8]:checked,.was-validated .form-check-input[data-v-7dbaddd8]:invalid:checked{background-color:#dc3545}.form-check-input.is-invalid[data-v-7dbaddd8]:focus,.was-validated .form-check-input[data-v-7dbaddd8]:invalid:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid~.form-check-label[data-v-7dbaddd8],.was-validated .form-check-input:invalid~.form-check-label[data-v-7dbaddd8]{color:#dc3545}.form-check-inline .form-check-input~.invalid-feedback[data-v-7dbaddd8]{margin-left:.5em}.input-group .form-control.is-invalid[data-v-7dbaddd8],.input-group .form-select.is-invalid[data-v-7dbaddd8],.was-validated .input-group .form-control[data-v-7dbaddd8]:invalid,.was-validated .input-group .form-select[data-v-7dbaddd8]:invalid{z-index:2}.input-group .form-control.is-invalid[data-v-7dbaddd8]:focus,.input-group .form-select.is-invalid[data-v-7dbaddd8]:focus,.was-validated .input-group .form-control[data-v-7dbaddd8]:invalid:focus,.was-validated .input-group .form-select[data-v-7dbaddd8]:invalid:focus{z-index:3}.btn[data-v-7dbaddd8]{display:inline-block;font-weight:400;line-height:1.5;color:#212529;text-align:center;text-decoration:none;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn[data-v-7dbaddd8]{transition:none}}.btn[data-v-7dbaddd8]:hover{color:#212529}.btn-check:focus+.btn[data-v-7dbaddd8],.btn[data-v-7dbaddd8]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.btn.disabled[data-v-7dbaddd8],.btn[data-v-7dbaddd8]:disabled,fieldset:disabled .btn[data-v-7dbaddd8]{pointer-events:none;opacity:.65}.btn-primary[data-v-7dbaddd8]{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-primary[data-v-7dbaddd8]:hover{color:#fff;background-color:#0b5ed7;border-color:#0a58ca}.btn-check:focus+.btn-primary[data-v-7dbaddd8],.btn-primary[data-v-7dbaddd8]:focus{color:#fff;background-color:#0b5ed7;border-color:#0a58ca;box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-check:active+.btn-primary[data-v-7dbaddd8],.btn-check:checked+.btn-primary[data-v-7dbaddd8],.btn-primary.active[data-v-7dbaddd8],.btn-primary[data-v-7dbaddd8]:active,.show>.btn-primary.dropdown-toggle[data-v-7dbaddd8]{color:#fff;background-color:#0a58ca;border-color:#0a53be}.btn-check:active+.btn-primary[data-v-7dbaddd8]:focus,.btn-check:checked+.btn-primary[data-v-7dbaddd8]:focus,.btn-primary.active[data-v-7dbaddd8]:focus,.btn-primary[data-v-7dbaddd8]:active:focus,.show>.btn-primary.dropdown-toggle[data-v-7dbaddd8]:focus{box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-primary.disabled[data-v-7dbaddd8],.btn-primary[data-v-7dbaddd8]:disabled{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-secondary[data-v-7dbaddd8]{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary[data-v-7dbaddd8]:hover{color:#fff;background-color:#5c636a;border-color:#565e64}.btn-check:focus+.btn-secondary[data-v-7dbaddd8],.btn-secondary[data-v-7dbaddd8]:focus{color:#fff;background-color:#5c636a;border-color:#565e64;box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-check:active+.btn-secondary[data-v-7dbaddd8],.btn-check:checked+.btn-secondary[data-v-7dbaddd8],.btn-secondary.active[data-v-7dbaddd8],.btn-secondary[data-v-7dbaddd8]:active,.show>.btn-secondary.dropdown-toggle[data-v-7dbaddd8]{color:#fff;background-color:#565e64;border-color:#51585e}.btn-check:active+.btn-secondary[data-v-7dbaddd8]:focus,.btn-check:checked+.btn-secondary[data-v-7dbaddd8]:focus,.btn-secondary.active[data-v-7dbaddd8]:focus,.btn-secondary[data-v-7dbaddd8]:active:focus,.show>.btn-secondary.dropdown-toggle[data-v-7dbaddd8]:focus{box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-secondary.disabled[data-v-7dbaddd8],.btn-secondary[data-v-7dbaddd8]:disabled{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-success[data-v-7dbaddd8]{color:#fff;background-color:#198754;border-color:#198754}.btn-success[data-v-7dbaddd8]:hover{color:#fff;background-color:#157347;border-color:#146c43}.btn-check:focus+.btn-success[data-v-7dbaddd8],.btn-success[data-v-7dbaddd8]:focus{color:#fff;background-color:#157347;border-color:#146c43;box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-check:active+.btn-success[data-v-7dbaddd8],.btn-check:checked+.btn-success[data-v-7dbaddd8],.btn-success.active[data-v-7dbaddd8],.btn-success[data-v-7dbaddd8]:active,.show>.btn-success.dropdown-toggle[data-v-7dbaddd8]{color:#fff;background-color:#146c43;border-color:#13653f}.btn-check:active+.btn-success[data-v-7dbaddd8]:focus,.btn-check:checked+.btn-success[data-v-7dbaddd8]:focus,.btn-success.active[data-v-7dbaddd8]:focus,.btn-success[data-v-7dbaddd8]:active:focus,.show>.btn-success.dropdown-toggle[data-v-7dbaddd8]:focus{box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-success.disabled[data-v-7dbaddd8],.btn-success[data-v-7dbaddd8]:disabled{color:#fff;background-color:#198754;border-color:#198754}.btn-info[data-v-7dbaddd8]{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-info[data-v-7dbaddd8]:hover{color:#000;background-color:#31d2f2;border-color:#25cff2}.btn-check:focus+.btn-info[data-v-7dbaddd8],.btn-info[data-v-7dbaddd8]:focus{color:#000;background-color:#31d2f2;border-color:#25cff2;box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-check:active+.btn-info[data-v-7dbaddd8],.btn-check:checked+.btn-info[data-v-7dbaddd8],.btn-info.active[data-v-7dbaddd8],.btn-info[data-v-7dbaddd8]:active,.show>.btn-info.dropdown-toggle[data-v-7dbaddd8]{color:#000;background-color:#3dd5f3;border-color:#25cff2}.btn-check:active+.btn-info[data-v-7dbaddd8]:focus,.btn-check:checked+.btn-info[data-v-7dbaddd8]:focus,.btn-info.active[data-v-7dbaddd8]:focus,.btn-info[data-v-7dbaddd8]:active:focus,.show>.btn-info.dropdown-toggle[data-v-7dbaddd8]:focus{box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-info.disabled[data-v-7dbaddd8],.btn-info[data-v-7dbaddd8]:disabled{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-warning[data-v-7dbaddd8]{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-warning[data-v-7dbaddd8]:hover{color:#000;background-color:#ffca2c;border-color:#ffc720}.btn-check:focus+.btn-warning[data-v-7dbaddd8],.btn-warning[data-v-7dbaddd8]:focus{color:#000;background-color:#ffca2c;border-color:#ffc720;box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-check:active+.btn-warning[data-v-7dbaddd8],.btn-check:checked+.btn-warning[data-v-7dbaddd8],.btn-warning.active[data-v-7dbaddd8],.btn-warning[data-v-7dbaddd8]:active,.show>.btn-warning.dropdown-toggle[data-v-7dbaddd8]{color:#000;background-color:#ffcd39;border-color:#ffc720}.btn-check:active+.btn-warning[data-v-7dbaddd8]:focus,.btn-check:checked+.btn-warning[data-v-7dbaddd8]:focus,.btn-warning.active[data-v-7dbaddd8]:focus,.btn-warning[data-v-7dbaddd8]:active:focus,.show>.btn-warning.dropdown-toggle[data-v-7dbaddd8]:focus{box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-warning.disabled[data-v-7dbaddd8],.btn-warning[data-v-7dbaddd8]:disabled{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-danger[data-v-7dbaddd8]{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger[data-v-7dbaddd8]:hover{color:#fff;background-color:#bb2d3b;border-color:#b02a37}.btn-check:focus+.btn-danger[data-v-7dbaddd8],.btn-danger[data-v-7dbaddd8]:focus{color:#fff;background-color:#bb2d3b;border-color:#b02a37;box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-check:active+.btn-danger[data-v-7dbaddd8],.btn-check:checked+.btn-danger[data-v-7dbaddd8],.btn-danger.active[data-v-7dbaddd8],.btn-danger[data-v-7dbaddd8]:active,.show>.btn-danger.dropdown-toggle[data-v-7dbaddd8]{color:#fff;background-color:#b02a37;border-color:#a52834}.btn-check:active+.btn-danger[data-v-7dbaddd8]:focus,.btn-check:checked+.btn-danger[data-v-7dbaddd8]:focus,.btn-danger.active[data-v-7dbaddd8]:focus,.btn-danger[data-v-7dbaddd8]:active:focus,.show>.btn-danger.dropdown-toggle[data-v-7dbaddd8]:focus{box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-danger.disabled[data-v-7dbaddd8],.btn-danger[data-v-7dbaddd8]:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-light[data-v-7dbaddd8]{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light[data-v-7dbaddd8]:hover{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:focus+.btn-light[data-v-7dbaddd8],.btn-light[data-v-7dbaddd8]:focus{color:#000;background-color:#f9fafb;border-color:#f9fafb;box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-check:active+.btn-light[data-v-7dbaddd8],.btn-check:checked+.btn-light[data-v-7dbaddd8],.btn-light.active[data-v-7dbaddd8],.btn-light[data-v-7dbaddd8]:active,.show>.btn-light.dropdown-toggle[data-v-7dbaddd8]{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:active+.btn-light[data-v-7dbaddd8]:focus,.btn-check:checked+.btn-light[data-v-7dbaddd8]:focus,.btn-light.active[data-v-7dbaddd8]:focus,.btn-light[data-v-7dbaddd8]:active:focus,.show>.btn-light.dropdown-toggle[data-v-7dbaddd8]:focus{box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-light.disabled[data-v-7dbaddd8],.btn-light[data-v-7dbaddd8]:disabled{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-dark[data-v-7dbaddd8]{color:#fff;background-color:#212529;border-color:#212529}.btn-dark[data-v-7dbaddd8]:hover{color:#fff;background-color:#1c1f23;border-color:#1a1e21}.btn-check:focus+.btn-dark[data-v-7dbaddd8],.btn-dark[data-v-7dbaddd8]:focus{color:#fff;background-color:#1c1f23;border-color:#1a1e21;box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-check:active+.btn-dark[data-v-7dbaddd8],.btn-check:checked+.btn-dark[data-v-7dbaddd8],.btn-dark.active[data-v-7dbaddd8],.btn-dark[data-v-7dbaddd8]:active,.show>.btn-dark.dropdown-toggle[data-v-7dbaddd8]{color:#fff;background-color:#1a1e21;border-color:#191c1f}.btn-check:active+.btn-dark[data-v-7dbaddd8]:focus,.btn-check:checked+.btn-dark[data-v-7dbaddd8]:focus,.btn-dark.active[data-v-7dbaddd8]:focus,.btn-dark[data-v-7dbaddd8]:active:focus,.show>.btn-dark.dropdown-toggle[data-v-7dbaddd8]:focus{box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-dark.disabled[data-v-7dbaddd8],.btn-dark[data-v-7dbaddd8]:disabled{color:#fff;background-color:#212529;border-color:#212529}.btn-outline-primary[data-v-7dbaddd8]{color:#0d6efd;border-color:#0d6efd}.btn-outline-primary[data-v-7dbaddd8]:hover{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:focus+.btn-outline-primary[data-v-7dbaddd8],.btn-outline-primary[data-v-7dbaddd8]:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-check:active+.btn-outline-primary[data-v-7dbaddd8],.btn-check:checked+.btn-outline-primary[data-v-7dbaddd8],.btn-outline-primary.active[data-v-7dbaddd8],.btn-outline-primary.dropdown-toggle.show[data-v-7dbaddd8],.btn-outline-primary[data-v-7dbaddd8]:active{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:active+.btn-outline-primary[data-v-7dbaddd8]:focus,.btn-check:checked+.btn-outline-primary[data-v-7dbaddd8]:focus,.btn-outline-primary.active[data-v-7dbaddd8]:focus,.btn-outline-primary.dropdown-toggle.show[data-v-7dbaddd8]:focus,.btn-outline-primary[data-v-7dbaddd8]:active:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-outline-primary.disabled[data-v-7dbaddd8],.btn-outline-primary[data-v-7dbaddd8]:disabled{color:#0d6efd;background-color:transparent}.btn-outline-secondary[data-v-7dbaddd8]{color:#6c757d;border-color:#6c757d}.btn-outline-secondary[data-v-7dbaddd8]:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:focus+.btn-outline-secondary[data-v-7dbaddd8],.btn-outline-secondary[data-v-7dbaddd8]:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-check:active+.btn-outline-secondary[data-v-7dbaddd8],.btn-check:checked+.btn-outline-secondary[data-v-7dbaddd8],.btn-outline-secondary.active[data-v-7dbaddd8],.btn-outline-secondary.dropdown-toggle.show[data-v-7dbaddd8],.btn-outline-secondary[data-v-7dbaddd8]:active{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:active+.btn-outline-secondary[data-v-7dbaddd8]:focus,.btn-check:checked+.btn-outline-secondary[data-v-7dbaddd8]:focus,.btn-outline-secondary.active[data-v-7dbaddd8]:focus,.btn-outline-secondary.dropdown-toggle.show[data-v-7dbaddd8]:focus,.btn-outline-secondary[data-v-7dbaddd8]:active:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-outline-secondary.disabled[data-v-7dbaddd8],.btn-outline-secondary[data-v-7dbaddd8]:disabled{color:#6c757d;background-color:transparent}.btn-outline-success[data-v-7dbaddd8]{color:#198754;border-color:#198754}.btn-outline-success[data-v-7dbaddd8]:hover{color:#fff;background-color:#198754;border-color:#198754}.btn-check:focus+.btn-outline-success[data-v-7dbaddd8],.btn-outline-success[data-v-7dbaddd8]:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-check:active+.btn-outline-success[data-v-7dbaddd8],.btn-check:checked+.btn-outline-success[data-v-7dbaddd8],.btn-outline-success.active[data-v-7dbaddd8],.btn-outline-success.dropdown-toggle.show[data-v-7dbaddd8],.btn-outline-success[data-v-7dbaddd8]:active{color:#fff;background-color:#198754;border-color:#198754}.btn-check:active+.btn-outline-success[data-v-7dbaddd8]:focus,.btn-check:checked+.btn-outline-success[data-v-7dbaddd8]:focus,.btn-outline-success.active[data-v-7dbaddd8]:focus,.btn-outline-success.dropdown-toggle.show[data-v-7dbaddd8]:focus,.btn-outline-success[data-v-7dbaddd8]:active:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-outline-success.disabled[data-v-7dbaddd8],.btn-outline-success[data-v-7dbaddd8]:disabled{color:#198754;background-color:transparent}.btn-outline-info[data-v-7dbaddd8]{color:#0dcaf0;border-color:#0dcaf0}.btn-outline-info[data-v-7dbaddd8]:hover{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:focus+.btn-outline-info[data-v-7dbaddd8],.btn-outline-info[data-v-7dbaddd8]:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-check:active+.btn-outline-info[data-v-7dbaddd8],.btn-check:checked+.btn-outline-info[data-v-7dbaddd8],.btn-outline-info.active[data-v-7dbaddd8],.btn-outline-info.dropdown-toggle.show[data-v-7dbaddd8],.btn-outline-info[data-v-7dbaddd8]:active{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:active+.btn-outline-info[data-v-7dbaddd8]:focus,.btn-check:checked+.btn-outline-info[data-v-7dbaddd8]:focus,.btn-outline-info.active[data-v-7dbaddd8]:focus,.btn-outline-info.dropdown-toggle.show[data-v-7dbaddd8]:focus,.btn-outline-info[data-v-7dbaddd8]:active:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-outline-info.disabled[data-v-7dbaddd8],.btn-outline-info[data-v-7dbaddd8]:disabled{color:#0dcaf0;background-color:transparent}.btn-outline-warning[data-v-7dbaddd8]{color:#ffc107;border-color:#ffc107}.btn-outline-warning[data-v-7dbaddd8]:hover{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:focus+.btn-outline-warning[data-v-7dbaddd8],.btn-outline-warning[data-v-7dbaddd8]:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-check:active+.btn-outline-warning[data-v-7dbaddd8],.btn-check:checked+.btn-outline-warning[data-v-7dbaddd8],.btn-outline-warning.active[data-v-7dbaddd8],.btn-outline-warning.dropdown-toggle.show[data-v-7dbaddd8],.btn-outline-warning[data-v-7dbaddd8]:active{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:active+.btn-outline-warning[data-v-7dbaddd8]:focus,.btn-check:checked+.btn-outline-warning[data-v-7dbaddd8]:focus,.btn-outline-warning.active[data-v-7dbaddd8]:focus,.btn-outline-warning.dropdown-toggle.show[data-v-7dbaddd8]:focus,.btn-outline-warning[data-v-7dbaddd8]:active:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-outline-warning.disabled[data-v-7dbaddd8],.btn-outline-warning[data-v-7dbaddd8]:disabled{color:#ffc107;background-color:transparent}.btn-outline-danger[data-v-7dbaddd8]{color:#dc3545;border-color:#dc3545}.btn-outline-danger[data-v-7dbaddd8]:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:focus+.btn-outline-danger[data-v-7dbaddd8],.btn-outline-danger[data-v-7dbaddd8]:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-check:active+.btn-outline-danger[data-v-7dbaddd8],.btn-check:checked+.btn-outline-danger[data-v-7dbaddd8],.btn-outline-danger.active[data-v-7dbaddd8],.btn-outline-danger.dropdown-toggle.show[data-v-7dbaddd8],.btn-outline-danger[data-v-7dbaddd8]:active{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:active+.btn-outline-danger[data-v-7dbaddd8]:focus,.btn-check:checked+.btn-outline-danger[data-v-7dbaddd8]:focus,.btn-outline-danger.active[data-v-7dbaddd8]:focus,.btn-outline-danger.dropdown-toggle.show[data-v-7dbaddd8]:focus,.btn-outline-danger[data-v-7dbaddd8]:active:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-outline-danger.disabled[data-v-7dbaddd8],.btn-outline-danger[data-v-7dbaddd8]:disabled{color:#dc3545;background-color:transparent}.btn-outline-light[data-v-7dbaddd8]{color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light[data-v-7dbaddd8]:hover{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:focus+.btn-outline-light[data-v-7dbaddd8],.btn-outline-light[data-v-7dbaddd8]:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-check:active+.btn-outline-light[data-v-7dbaddd8],.btn-check:checked+.btn-outline-light[data-v-7dbaddd8],.btn-outline-light.active[data-v-7dbaddd8],.btn-outline-light.dropdown-toggle.show[data-v-7dbaddd8],.btn-outline-light[data-v-7dbaddd8]:active{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:active+.btn-outline-light[data-v-7dbaddd8]:focus,.btn-check:checked+.btn-outline-light[data-v-7dbaddd8]:focus,.btn-outline-light.active[data-v-7dbaddd8]:focus,.btn-outline-light.dropdown-toggle.show[data-v-7dbaddd8]:focus,.btn-outline-light[data-v-7dbaddd8]:active:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-outline-light.disabled[data-v-7dbaddd8],.btn-outline-light[data-v-7dbaddd8]:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-dark[data-v-7dbaddd8]{color:#212529;border-color:#212529}.btn-outline-dark[data-v-7dbaddd8]:hover{color:#fff;background-color:#212529;border-color:#212529}.btn-check:focus+.btn-outline-dark[data-v-7dbaddd8],.btn-outline-dark[data-v-7dbaddd8]:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-check:active+.btn-outline-dark[data-v-7dbaddd8],.btn-check:checked+.btn-outline-dark[data-v-7dbaddd8],.btn-outline-dark.active[data-v-7dbaddd8],.btn-outline-dark.dropdown-toggle.show[data-v-7dbaddd8],.btn-outline-dark[data-v-7dbaddd8]:active{color:#fff;background-color:#212529;border-color:#212529}.btn-check:active+.btn-outline-dark[data-v-7dbaddd8]:focus,.btn-check:checked+.btn-outline-dark[data-v-7dbaddd8]:focus,.btn-outline-dark.active[data-v-7dbaddd8]:focus,.btn-outline-dark.dropdown-toggle.show[data-v-7dbaddd8]:focus,.btn-outline-dark[data-v-7dbaddd8]:active:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-outline-dark.disabled[data-v-7dbaddd8],.btn-outline-dark[data-v-7dbaddd8]:disabled{color:#212529;background-color:transparent}.btn-link[data-v-7dbaddd8]{font-weight:400;color:#0d6efd;text-decoration:underline}.btn-link[data-v-7dbaddd8]:hover{color:#0a58ca}.btn-link.disabled[data-v-7dbaddd8],.btn-link[data-v-7dbaddd8]:disabled{color:#6c757d}.btn-group-lg>.btn[data-v-7dbaddd8],.btn-lg[data-v-7dbaddd8]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.btn-group-sm>.btn[data-v-7dbaddd8],.btn-sm[data-v-7dbaddd8]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.fade[data-v-7dbaddd8]{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade[data-v-7dbaddd8]{transition:none}}.fade[data-v-7dbaddd8]:not(.show){opacity:0}.collapse[data-v-7dbaddd8]:not(.show){display:none}.collapsing[data-v-7dbaddd8]{height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.collapsing[data-v-7dbaddd8]{transition:none}}.collapsing.collapse-horizontal[data-v-7dbaddd8]{width:0;height:auto;transition:width .35s ease}@media (prefers-reduced-motion:reduce){.collapsing.collapse-horizontal[data-v-7dbaddd8]{transition:none}}.dropdown[data-v-7dbaddd8],.dropend[data-v-7dbaddd8],.dropstart[data-v-7dbaddd8],.dropup[data-v-7dbaddd8]{position:relative}.dropdown-toggle[data-v-7dbaddd8]{white-space:nowrap}.dropdown-toggle[data-v-7dbaddd8]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle[data-v-7dbaddd8]:empty:after{margin-left:0}.dropdown-menu[data-v-7dbaddd8]{position:absolute;z-index:1000;display:none;min-width:10rem;padding:.5rem 0;margin:0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-menu[data-bs-popper][data-v-7dbaddd8]{top:100%;left:0;margin-top:.125rem}.dropdown-menu-start[data-v-7dbaddd8]{--bs-position:start}.dropdown-menu-start[data-bs-popper][data-v-7dbaddd8]{right:auto;left:0}.dropdown-menu-end[data-v-7dbaddd8]{--bs-position:end}.dropdown-menu-end[data-bs-popper][data-v-7dbaddd8]{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-start[data-v-7dbaddd8]{--bs-position:start}.dropdown-menu-sm-start[data-bs-popper][data-v-7dbaddd8]{right:auto;left:0}.dropdown-menu-sm-end[data-v-7dbaddd8]{--bs-position:end}.dropdown-menu-sm-end[data-bs-popper][data-v-7dbaddd8]{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-start[data-v-7dbaddd8]{--bs-position:start}.dropdown-menu-md-start[data-bs-popper][data-v-7dbaddd8]{right:auto;left:0}.dropdown-menu-md-end[data-v-7dbaddd8]{--bs-position:end}.dropdown-menu-md-end[data-bs-popper][data-v-7dbaddd8]{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-start[data-v-7dbaddd8]{--bs-position:start}.dropdown-menu-lg-start[data-bs-popper][data-v-7dbaddd8]{right:auto;left:0}.dropdown-menu-lg-end[data-v-7dbaddd8]{--bs-position:end}.dropdown-menu-lg-end[data-bs-popper][data-v-7dbaddd8]{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-start[data-v-7dbaddd8]{--bs-position:start}.dropdown-menu-xl-start[data-bs-popper][data-v-7dbaddd8]{right:auto;left:0}.dropdown-menu-xl-end[data-v-7dbaddd8]{--bs-position:end}.dropdown-menu-xl-end[data-bs-popper][data-v-7dbaddd8]{right:0;left:auto}}@media (min-width:1400px){.dropdown-menu-xxl-start[data-v-7dbaddd8]{--bs-position:start}.dropdown-menu-xxl-start[data-bs-popper][data-v-7dbaddd8]{right:auto;left:0}.dropdown-menu-xxl-end[data-v-7dbaddd8]{--bs-position:end}.dropdown-menu-xxl-end[data-bs-popper][data-v-7dbaddd8]{right:0;left:auto}}.dropup .dropdown-menu[data-bs-popper][data-v-7dbaddd8]{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle[data-v-7dbaddd8]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle[data-v-7dbaddd8]:empty:after{margin-left:0}.dropend .dropdown-menu[data-bs-popper][data-v-7dbaddd8]{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.dropend .dropdown-toggle[data-v-7dbaddd8]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropend .dropdown-toggle[data-v-7dbaddd8]:empty:after{margin-left:0}.dropend .dropdown-toggle[data-v-7dbaddd8]:after{vertical-align:0}.dropstart .dropdown-menu[data-bs-popper][data-v-7dbaddd8]{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.dropstart .dropdown-toggle[data-v-7dbaddd8]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";display:none}.dropstart .dropdown-toggle[data-v-7dbaddd8]:before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropstart .dropdown-toggle[data-v-7dbaddd8]:empty:after{margin-left:0}.dropstart .dropdown-toggle[data-v-7dbaddd8]:before{vertical-align:0}.dropdown-divider[data-v-7dbaddd8]{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid rgba(0,0,0,.15)}.dropdown-item[data-v-7dbaddd8]{display:block;width:100%;padding:.25rem 1rem;clear:both;font-weight:400;color:#212529;text-align:inherit;text-decoration:none;white-space:nowrap;background-color:transparent;border:0}.dropdown-item[data-v-7dbaddd8]:focus,.dropdown-item[data-v-7dbaddd8]:hover{color:#1e2125;background-color:#e9ecef}.dropdown-item.active[data-v-7dbaddd8],.dropdown-item[data-v-7dbaddd8]:active{color:#fff;text-decoration:none;background-color:#0d6efd}.dropdown-item.disabled[data-v-7dbaddd8],.dropdown-item[data-v-7dbaddd8]:disabled{color:#adb5bd;pointer-events:none;background-color:transparent}.dropdown-menu.show[data-v-7dbaddd8]{display:block}.dropdown-header[data-v-7dbaddd8]{display:block;padding:.5rem 1rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.dropdown-item-text[data-v-7dbaddd8]{display:block;padding:.25rem 1rem;color:#212529}.dropdown-menu-dark[data-v-7dbaddd8]{color:#dee2e6;background-color:#343a40;border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item[data-v-7dbaddd8]{color:#dee2e6}.dropdown-menu-dark .dropdown-item[data-v-7dbaddd8]:focus,.dropdown-menu-dark .dropdown-item[data-v-7dbaddd8]:hover{color:#fff;background-color:hsla(0,0%,100%,.15)}.dropdown-menu-dark .dropdown-item.active[data-v-7dbaddd8],.dropdown-menu-dark .dropdown-item[data-v-7dbaddd8]:active{color:#fff;background-color:#0d6efd}.dropdown-menu-dark .dropdown-item.disabled[data-v-7dbaddd8],.dropdown-menu-dark .dropdown-item[data-v-7dbaddd8]:disabled{color:#adb5bd}.dropdown-menu-dark .dropdown-divider[data-v-7dbaddd8]{border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item-text[data-v-7dbaddd8]{color:#dee2e6}.dropdown-menu-dark .dropdown-header[data-v-7dbaddd8]{color:#adb5bd}.btn-group-vertical[data-v-7dbaddd8],.btn-group[data-v-7dbaddd8]{position:relative;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn[data-v-7dbaddd8],.btn-group>.btn[data-v-7dbaddd8]{position:relative;flex:1 1 auto}.btn-group-vertical>.btn-check:checked+.btn[data-v-7dbaddd8],.btn-group-vertical>.btn-check:focus+.btn[data-v-7dbaddd8],.btn-group-vertical>.btn.active[data-v-7dbaddd8],.btn-group-vertical>.btn[data-v-7dbaddd8]:active,.btn-group-vertical>.btn[data-v-7dbaddd8]:focus,.btn-group-vertical>.btn[data-v-7dbaddd8]:hover,.btn-group>.btn-check:checked+.btn[data-v-7dbaddd8],.btn-group>.btn-check:focus+.btn[data-v-7dbaddd8],.btn-group>.btn.active[data-v-7dbaddd8],.btn-group>.btn[data-v-7dbaddd8]:active,.btn-group>.btn[data-v-7dbaddd8]:focus,.btn-group>.btn[data-v-7dbaddd8]:hover{z-index:1}.btn-toolbar[data-v-7dbaddd8]{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar .input-group[data-v-7dbaddd8]{width:auto}.btn-group>.btn-group[data-v-7dbaddd8]:not(:first-child),.btn-group>.btn[data-v-7dbaddd8]:not(:first-child){margin-left:-1px}.btn-group>.btn-group:not(:last-child)>.btn[data-v-7dbaddd8],.btn-group>.btn[data-v-7dbaddd8]:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn[data-v-7dbaddd8],.btn-group>.btn[data-v-7dbaddd8]:nth-child(n+3),.btn-group>:not(.btn-check)+.btn[data-v-7dbaddd8]{border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split[data-v-7dbaddd8]{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split[data-v-7dbaddd8]:after,.dropend .dropdown-toggle-split[data-v-7dbaddd8]:after,.dropup .dropdown-toggle-split[data-v-7dbaddd8]:after{margin-left:0}.dropstart .dropdown-toggle-split[data-v-7dbaddd8]:before{margin-right:0}.btn-group-sm>.btn+.dropdown-toggle-split[data-v-7dbaddd8],.btn-sm+.dropdown-toggle-split[data-v-7dbaddd8]{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split[data-v-7dbaddd8],.btn-lg+.dropdown-toggle-split[data-v-7dbaddd8]{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical[data-v-7dbaddd8]{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical>.btn-group[data-v-7dbaddd8],.btn-group-vertical>.btn[data-v-7dbaddd8]{width:100%}.btn-group-vertical>.btn-group[data-v-7dbaddd8]:not(:first-child),.btn-group-vertical>.btn[data-v-7dbaddd8]:not(:first-child){margin-top:-1px}.btn-group-vertical>.btn-group:not(:last-child)>.btn[data-v-7dbaddd8],.btn-group-vertical>.btn[data-v-7dbaddd8]:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn[data-v-7dbaddd8],.btn-group-vertical>.btn~.btn[data-v-7dbaddd8]{border-top-left-radius:0;border-top-right-radius:0}.nav[data-v-7dbaddd8]{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link[data-v-7dbaddd8]{display:block;padding:.5rem 1rem;color:#0d6efd;text-decoration:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out}@media (prefers-reduced-motion:reduce){.nav-link[data-v-7dbaddd8]{transition:none}}.nav-link[data-v-7dbaddd8]:focus,.nav-link[data-v-7dbaddd8]:hover{color:#0a58ca}.nav-link.disabled[data-v-7dbaddd8]{color:#6c757d;pointer-events:none;cursor:default}.nav-tabs[data-v-7dbaddd8]{border-bottom:1px solid #dee2e6}.nav-tabs .nav-link[data-v-7dbaddd8]{margin-bottom:-1px;background:0 0;border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link[data-v-7dbaddd8]:focus,.nav-tabs .nav-link[data-v-7dbaddd8]:hover{border-color:#e9ecef #e9ecef #dee2e6;isolation:isolate}.nav-tabs .nav-link.disabled[data-v-7dbaddd8]{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link[data-v-7dbaddd8],.nav-tabs .nav-link.active[data-v-7dbaddd8]{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu[data-v-7dbaddd8]{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link[data-v-7dbaddd8]{background:0 0;border:0;border-radius:.25rem}.nav-pills .nav-link.active[data-v-7dbaddd8],.nav-pills .show>.nav-link[data-v-7dbaddd8]{color:#fff;background-color:#0d6efd}.nav-fill .nav-item[data-v-7dbaddd8],.nav-fill>.nav-link[data-v-7dbaddd8]{flex:1 1 auto;text-align:center}.nav-justified .nav-item[data-v-7dbaddd8],.nav-justified>.nav-link[data-v-7dbaddd8]{flex-basis:0;flex-grow:1;text-align:center}.nav-fill .nav-item .nav-link[data-v-7dbaddd8],.nav-justified .nav-item .nav-link[data-v-7dbaddd8]{width:100%}.tab-content>.tab-pane[data-v-7dbaddd8]{display:none}.tab-content>.active[data-v-7dbaddd8]{display:block}.navbar[data-v-7dbaddd8]{position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding-top:.5rem;padding-bottom:.5rem}.navbar>.container-fluid[data-v-7dbaddd8],.navbar>.container-lg[data-v-7dbaddd8],.navbar>.container-md[data-v-7dbaddd8],.navbar>.container-sm[data-v-7dbaddd8],.navbar>.container-xl[data-v-7dbaddd8],.navbar>.container-xxl[data-v-7dbaddd8],.navbar>.container[data-v-7dbaddd8]{display:flex;flex-wrap:inherit;align-items:center;justify-content:space-between}.navbar-brand[data-v-7dbaddd8]{padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;text-decoration:none;white-space:nowrap}.navbar-nav[data-v-7dbaddd8]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link[data-v-7dbaddd8]{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu[data-v-7dbaddd8]{position:static}.navbar-text[data-v-7dbaddd8]{padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse[data-v-7dbaddd8]{flex-basis:100%;flex-grow:1;align-items:center}.navbar-toggler[data-v-7dbaddd8]{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem;transition:box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.navbar-toggler[data-v-7dbaddd8]{transition:none}}.navbar-toggler[data-v-7dbaddd8]:hover{text-decoration:none}.navbar-toggler[data-v-7dbaddd8]:focus{text-decoration:none;outline:0;box-shadow:0 0 0 .25rem}.navbar-toggler-icon[data-v-7dbaddd8]{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;background-repeat:no-repeat;background-position:50%;background-size:100%}.navbar-nav-scroll[data-v-7dbaddd8]{max-height:var(--bs-scroll-height,75vh);overflow-y:auto}@media (min-width:576px){.navbar-expand-sm[data-v-7dbaddd8]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-sm .navbar-nav[data-v-7dbaddd8]{flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu[data-v-7dbaddd8]{position:absolute}.navbar-expand-sm .navbar-nav .nav-link[data-v-7dbaddd8]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm .navbar-nav-scroll[data-v-7dbaddd8]{overflow:visible}.navbar-expand-sm .navbar-collapse[data-v-7dbaddd8]{display:flex!important;flex-basis:auto}.navbar-expand-sm .navbar-toggler[data-v-7dbaddd8],.navbar-expand-sm .offcanvas-header[data-v-7dbaddd8]{display:none}.navbar-expand-sm .offcanvas[data-v-7dbaddd8]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-sm .offcanvas-bottom[data-v-7dbaddd8],.navbar-expand-sm .offcanvas-top[data-v-7dbaddd8]{height:auto;border-top:0;border-bottom:0}.navbar-expand-sm .offcanvas-body[data-v-7dbaddd8]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:768px){.navbar-expand-md[data-v-7dbaddd8]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-md .navbar-nav[data-v-7dbaddd8]{flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu[data-v-7dbaddd8]{position:absolute}.navbar-expand-md .navbar-nav .nav-link[data-v-7dbaddd8]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md .navbar-nav-scroll[data-v-7dbaddd8]{overflow:visible}.navbar-expand-md .navbar-collapse[data-v-7dbaddd8]{display:flex!important;flex-basis:auto}.navbar-expand-md .navbar-toggler[data-v-7dbaddd8],.navbar-expand-md .offcanvas-header[data-v-7dbaddd8]{display:none}.navbar-expand-md .offcanvas[data-v-7dbaddd8]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-md .offcanvas-bottom[data-v-7dbaddd8],.navbar-expand-md .offcanvas-top[data-v-7dbaddd8]{height:auto;border-top:0;border-bottom:0}.navbar-expand-md .offcanvas-body[data-v-7dbaddd8]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:992px){.navbar-expand-lg[data-v-7dbaddd8]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-lg .navbar-nav[data-v-7dbaddd8]{flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu[data-v-7dbaddd8]{position:absolute}.navbar-expand-lg .navbar-nav .nav-link[data-v-7dbaddd8]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg .navbar-nav-scroll[data-v-7dbaddd8]{overflow:visible}.navbar-expand-lg .navbar-collapse[data-v-7dbaddd8]{display:flex!important;flex-basis:auto}.navbar-expand-lg .navbar-toggler[data-v-7dbaddd8],.navbar-expand-lg .offcanvas-header[data-v-7dbaddd8]{display:none}.navbar-expand-lg .offcanvas[data-v-7dbaddd8]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-lg .offcanvas-bottom[data-v-7dbaddd8],.navbar-expand-lg .offcanvas-top[data-v-7dbaddd8]{height:auto;border-top:0;border-bottom:0}.navbar-expand-lg .offcanvas-body[data-v-7dbaddd8]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1200px){.navbar-expand-xl[data-v-7dbaddd8]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xl .navbar-nav[data-v-7dbaddd8]{flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu[data-v-7dbaddd8]{position:absolute}.navbar-expand-xl .navbar-nav .nav-link[data-v-7dbaddd8]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl .navbar-nav-scroll[data-v-7dbaddd8]{overflow:visible}.navbar-expand-xl .navbar-collapse[data-v-7dbaddd8]{display:flex!important;flex-basis:auto}.navbar-expand-xl .navbar-toggler[data-v-7dbaddd8],.navbar-expand-xl .offcanvas-header[data-v-7dbaddd8]{display:none}.navbar-expand-xl .offcanvas[data-v-7dbaddd8]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xl .offcanvas-bottom[data-v-7dbaddd8],.navbar-expand-xl .offcanvas-top[data-v-7dbaddd8]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xl .offcanvas-body[data-v-7dbaddd8]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1400px){.navbar-expand-xxl[data-v-7dbaddd8]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xxl .navbar-nav[data-v-7dbaddd8]{flex-direction:row}.navbar-expand-xxl .navbar-nav .dropdown-menu[data-v-7dbaddd8]{position:absolute}.navbar-expand-xxl .navbar-nav .nav-link[data-v-7dbaddd8]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xxl .navbar-nav-scroll[data-v-7dbaddd8]{overflow:visible}.navbar-expand-xxl .navbar-collapse[data-v-7dbaddd8]{display:flex!important;flex-basis:auto}.navbar-expand-xxl .navbar-toggler[data-v-7dbaddd8],.navbar-expand-xxl .offcanvas-header[data-v-7dbaddd8]{display:none}.navbar-expand-xxl .offcanvas[data-v-7dbaddd8]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xxl .offcanvas-bottom[data-v-7dbaddd8],.navbar-expand-xxl .offcanvas-top[data-v-7dbaddd8]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xxl .offcanvas-body[data-v-7dbaddd8]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}.navbar-expand[data-v-7dbaddd8]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand .navbar-nav[data-v-7dbaddd8]{flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu[data-v-7dbaddd8]{position:absolute}.navbar-expand .navbar-nav .nav-link[data-v-7dbaddd8]{padding-right:.5rem;padding-left:.5rem}.navbar-expand .navbar-nav-scroll[data-v-7dbaddd8]{overflow:visible}.navbar-expand .navbar-collapse[data-v-7dbaddd8]{display:flex!important;flex-basis:auto}.navbar-expand .navbar-toggler[data-v-7dbaddd8],.navbar-expand .offcanvas-header[data-v-7dbaddd8]{display:none}.navbar-expand .offcanvas[data-v-7dbaddd8]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand .offcanvas-bottom[data-v-7dbaddd8],.navbar-expand .offcanvas-top[data-v-7dbaddd8]{height:auto;border-top:0;border-bottom:0}.navbar-expand .offcanvas-body[data-v-7dbaddd8]{display:flex;flex-grow:0;padding:0;overflow-y:visible}.navbar-light .navbar-brand[data-v-7dbaddd8],.navbar-light .navbar-brand[data-v-7dbaddd8]:focus,.navbar-light .navbar-brand[data-v-7dbaddd8]:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link[data-v-7dbaddd8]{color:rgba(0,0,0,.55)}.navbar-light .navbar-nav .nav-link[data-v-7dbaddd8]:focus,.navbar-light .navbar-nav .nav-link[data-v-7dbaddd8]:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled[data-v-7dbaddd8]{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .nav-link.active[data-v-7dbaddd8],.navbar-light .navbar-nav .show>.nav-link[data-v-7dbaddd8]{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler[data-v-7dbaddd8]{color:rgba(0,0,0,.55);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon[data-v-7dbaddd8]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(0, 0, 0, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-light .navbar-text[data-v-7dbaddd8]{color:rgba(0,0,0,.55)}.navbar-light .navbar-text a[data-v-7dbaddd8],.navbar-light .navbar-text a[data-v-7dbaddd8]:focus,.navbar-light .navbar-text a[data-v-7dbaddd8]:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand[data-v-7dbaddd8],.navbar-dark .navbar-brand[data-v-7dbaddd8]:focus,.navbar-dark .navbar-brand[data-v-7dbaddd8]:hover{color:#fff}.navbar-dark .navbar-nav .nav-link[data-v-7dbaddd8]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-nav .nav-link[data-v-7dbaddd8]:focus,.navbar-dark .navbar-nav .nav-link[data-v-7dbaddd8]:hover{color:hsla(0,0%,100%,.75)}.navbar-dark .navbar-nav .nav-link.disabled[data-v-7dbaddd8]{color:hsla(0,0%,100%,.25)}.navbar-dark .navbar-nav .nav-link.active[data-v-7dbaddd8],.navbar-dark .navbar-nav .show>.nav-link[data-v-7dbaddd8]{color:#fff}.navbar-dark .navbar-toggler[data-v-7dbaddd8]{color:hsla(0,0%,100%,.55);border-color:hsla(0,0%,100%,.1)}.navbar-dark .navbar-toggler-icon[data-v-7dbaddd8]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(255, 255, 255, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-dark .navbar-text[data-v-7dbaddd8]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-text a[data-v-7dbaddd8],.navbar-dark .navbar-text a[data-v-7dbaddd8]:focus,.navbar-dark .navbar-text a[data-v-7dbaddd8]:hover{color:#fff}.card[data-v-7dbaddd8]{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr[data-v-7dbaddd8]{margin-right:0;margin-left:0}.card>.list-group[data-v-7dbaddd8]{border-top:inherit;border-bottom:inherit}.card>.list-group[data-v-7dbaddd8]:first-child{border-top-width:0;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card>.list-group[data-v-7dbaddd8]:last-child{border-bottom-width:0;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card>.card-header+.list-group[data-v-7dbaddd8],.card>.list-group+.card-footer[data-v-7dbaddd8]{border-top:0}.card-body[data-v-7dbaddd8]{flex:1 1 auto;padding:1rem}.card-title[data-v-7dbaddd8]{margin-bottom:.5rem}.card-subtitle[data-v-7dbaddd8]{margin-top:-.25rem;margin-bottom:0}.card-text[data-v-7dbaddd8]:last-child{margin-bottom:0}.card-link+.card-link[data-v-7dbaddd8]{margin-left:1rem}.card-header[data-v-7dbaddd8]{padding:.5rem 1rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header[data-v-7dbaddd8]:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-footer[data-v-7dbaddd8]{padding:.5rem 1rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer[data-v-7dbaddd8]:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs[data-v-7dbaddd8]{margin-bottom:-.5rem;border-bottom:0}.card-header-pills[data-v-7dbaddd8],.card-header-tabs[data-v-7dbaddd8]{margin-right:-.5rem;margin-left:-.5rem}.card-img-overlay[data-v-7dbaddd8]{position:absolute;top:0;right:0;bottom:0;left:0;padding:1rem;border-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-7dbaddd8],.card-img-top[data-v-7dbaddd8],.card-img[data-v-7dbaddd8]{width:100%}.card-img-top[data-v-7dbaddd8],.card-img[data-v-7dbaddd8]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-7dbaddd8],.card-img[data-v-7dbaddd8]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-group>.card[data-v-7dbaddd8]{margin-bottom:.75rem}@media (min-width:576px){.card-group[data-v-7dbaddd8]{display:flex;flex-flow:row wrap}.card-group>.card[data-v-7dbaddd8]{flex:1 0 0%;margin-bottom:0}.card-group>.card+.card[data-v-7dbaddd8]{margin-left:0;border-left:0}.card-group>.card[data-v-7dbaddd8]:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-header[data-v-7dbaddd8],.card-group>.card:not(:last-child) .card-img-top[data-v-7dbaddd8]{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-footer[data-v-7dbaddd8],.card-group>.card:not(:last-child) .card-img-bottom[data-v-7dbaddd8]{border-bottom-right-radius:0}.card-group>.card[data-v-7dbaddd8]:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-header[data-v-7dbaddd8],.card-group>.card:not(:first-child) .card-img-top[data-v-7dbaddd8]{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-footer[data-v-7dbaddd8],.card-group>.card:not(:first-child) .card-img-bottom[data-v-7dbaddd8]{border-bottom-left-radius:0}}.accordion-button[data-v-7dbaddd8]{position:relative;display:flex;align-items:center;width:100%;padding:1rem 1.25rem;font-size:1rem;color:#212529;text-align:left;background-color:#fff;border:0;border-radius:0;overflow-anchor:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,border-radius .15s ease}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-7dbaddd8]{transition:none}}.accordion-button[data-v-7dbaddd8]:not(.collapsed){color:#0c63e4;background-color:#e7f1ff;box-shadow:inset 0 -1px 0 rgba(0,0,0,.125)}.accordion-button[data-v-7dbaddd8]:not(.collapsed):after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230c63e4'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");transform:rotate(-180deg)}.accordion-button[data-v-7dbaddd8]:after{flex-shrink:0;width:1.25rem;height:1.25rem;margin-left:auto;content:\"\";background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-size:1.25rem;transition:transform .2s ease-in-out}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-7dbaddd8]:after{transition:none}}.accordion-button[data-v-7dbaddd8]:hover{z-index:2}.accordion-button[data-v-7dbaddd8]:focus{z-index:3;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.accordion-header[data-v-7dbaddd8]{margin-bottom:0}.accordion-item[data-v-7dbaddd8]{background-color:#fff;border:1px solid rgba(0,0,0,.125)}.accordion-item[data-v-7dbaddd8]:first-of-type{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.accordion-item:first-of-type .accordion-button[data-v-7dbaddd8]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.accordion-item[data-v-7dbaddd8]:not(:first-of-type){border-top:0}.accordion-item[data-v-7dbaddd8]:last-of-type{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-item:last-of-type .accordion-button.collapsed[data-v-7dbaddd8]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.accordion-item:last-of-type .accordion-collapse[data-v-7dbaddd8]{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-body[data-v-7dbaddd8]{padding:1rem 1.25rem}.accordion-flush .accordion-collapse[data-v-7dbaddd8]{border-width:0}.accordion-flush .accordion-item[data-v-7dbaddd8]{border-right:0;border-left:0;border-radius:0}.accordion-flush .accordion-item[data-v-7dbaddd8]:first-child{border-top:0}.accordion-flush .accordion-item[data-v-7dbaddd8]:last-child{border-bottom:0}.accordion-flush .accordion-item .accordion-button[data-v-7dbaddd8]{border-radius:0}.breadcrumb[data-v-7dbaddd8]{display:flex;flex-wrap:wrap;padding:0;margin-bottom:1rem;list-style:none}.breadcrumb-item+.breadcrumb-item[data-v-7dbaddd8]{padding-left:.5rem}.breadcrumb-item+.breadcrumb-item[data-v-7dbaddd8]:before{float:left;padding-right:.5rem;color:#6c757d;content:var(--bs-breadcrumb-divider,\"/\")}.breadcrumb-item.active[data-v-7dbaddd8]{color:#6c757d}.pagination[data-v-7dbaddd8]{display:flex;padding-left:0;list-style:none}.page-link[data-v-7dbaddd8]{position:relative;display:block;color:#0d6efd;text-decoration:none;background-color:#fff;border:1px solid #dee2e6;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.page-link[data-v-7dbaddd8]{transition:none}}.page-link[data-v-7dbaddd8]:hover{z-index:2;color:#0a58ca;background-color:#e9ecef;border-color:#dee2e6}.page-link[data-v-7dbaddd8]:focus{z-index:3;color:#0a58ca;background-color:#e9ecef;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.page-item:not(:first-child) .page-link[data-v-7dbaddd8]{margin-left:-1px}.page-item.active .page-link[data-v-7dbaddd8]{z-index:3;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.page-item.disabled .page-link[data-v-7dbaddd8]{color:#6c757d;pointer-events:none;background-color:#fff;border-color:#dee2e6}.page-link[data-v-7dbaddd8]{padding:.375rem .75rem}.page-item:first-child .page-link[data-v-7dbaddd8]{border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item:last-child .page-link[data-v-7dbaddd8]{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.pagination-lg .page-link[data-v-7dbaddd8]{padding:.75rem 1.5rem;font-size:1.25rem}.pagination-lg .page-item:first-child .page-link[data-v-7dbaddd8]{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link[data-v-7dbaddd8]{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm .page-link[data-v-7dbaddd8]{padding:.25rem .5rem;font-size:.875rem}.pagination-sm .page-item:first-child .page-link[data-v-7dbaddd8]{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link[data-v-7dbaddd8]{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge[data-v-7dbaddd8]{display:inline-block;padding:.35em .65em;font-size:.75em;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}.badge[data-v-7dbaddd8]:empty{display:none}.btn .badge[data-v-7dbaddd8]{position:relative;top:-1px}.alert[data-v-7dbaddd8]{position:relative;padding:1rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading[data-v-7dbaddd8]{color:inherit}.alert-link[data-v-7dbaddd8]{font-weight:700}.alert-dismissible[data-v-7dbaddd8]{padding-right:3rem}.alert-dismissible .btn-close[data-v-7dbaddd8]{position:absolute;top:0;right:0;z-index:2;padding:1.25rem 1rem}.alert-primary[data-v-7dbaddd8]{color:#084298;background-color:#cfe2ff;border-color:#b6d4fe}.alert-primary .alert-link[data-v-7dbaddd8]{color:#06357a}.alert-secondary[data-v-7dbaddd8]{color:#41464b;background-color:#e2e3e5;border-color:#d3d6d8}.alert-secondary .alert-link[data-v-7dbaddd8]{color:#34383c}.alert-success[data-v-7dbaddd8]{color:#0f5132;background-color:#d1e7dd;border-color:#badbcc}.alert-success .alert-link[data-v-7dbaddd8]{color:#0c4128}.alert-info[data-v-7dbaddd8]{color:#055160;background-color:#cff4fc;border-color:#b6effb}.alert-info .alert-link[data-v-7dbaddd8]{color:#04414d}.alert-warning[data-v-7dbaddd8]{color:#664d03;background-color:#fff3cd;border-color:#ffecb5}.alert-warning .alert-link[data-v-7dbaddd8]{color:#523e02}.alert-danger[data-v-7dbaddd8]{color:#842029;background-color:#f8d7da;border-color:#f5c2c7}.alert-danger .alert-link[data-v-7dbaddd8]{color:#6a1a21}.alert-light[data-v-7dbaddd8]{color:#636464;background-color:#fefefe;border-color:#fdfdfe}.alert-light .alert-link[data-v-7dbaddd8]{color:#4f5050}.alert-dark[data-v-7dbaddd8]{color:#141619;background-color:#d3d3d4;border-color:#bcbebf}.alert-dark .alert-link[data-v-7dbaddd8]{color:#101214}@-webkit-keyframes progress-bar-stripes-data-v-7dbaddd8{0%{background-position-x:1rem}}@keyframes progress-bar-stripes-data-v-7dbaddd8{0%{background-position-x:1rem}}.progress[data-v-7dbaddd8]{display:flex;height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress-bar[data-v-7dbaddd8]{display:flex;flex-direction:column;justify-content:center;overflow:hidden;color:#fff;text-align:center;white-space:nowrap;background-color:#0d6efd;transition:width .6s ease}@media (prefers-reduced-motion:reduce){.progress-bar[data-v-7dbaddd8]{transition:none}}.progress-bar-striped[data-v-7dbaddd8]{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-bar-animated[data-v-7dbaddd8]{-webkit-animation:1s linear infinite progress-bar-stripes-data-v-7dbaddd8;animation:1s linear infinite progress-bar-stripes-data-v-7dbaddd8}@media (prefers-reduced-motion:reduce){.progress-bar-animated[data-v-7dbaddd8]{-webkit-animation:none;animation:none}}.list-group[data-v-7dbaddd8]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:.25rem}.list-group-numbered[data-v-7dbaddd8]{list-style-type:none;counter-reset:section}.list-group-numbered>li[data-v-7dbaddd8]:before{content:counters(section,\".\") \". \";counter-increment:section}.list-group-item-action[data-v-7dbaddd8]{width:100%;color:#495057;text-align:inherit}.list-group-item-action[data-v-7dbaddd8]:focus,.list-group-item-action[data-v-7dbaddd8]:hover{z-index:1;color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action[data-v-7dbaddd8]:active{color:#212529;background-color:#e9ecef}.list-group-item[data-v-7dbaddd8]{position:relative;display:block;padding:.5rem 1rem;color:#212529;text-decoration:none;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item[data-v-7dbaddd8]:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.list-group-item[data-v-7dbaddd8]:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.list-group-item.disabled[data-v-7dbaddd8],.list-group-item[data-v-7dbaddd8]:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.list-group-item.active[data-v-7dbaddd8]{z-index:2;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.list-group-item+.list-group-item[data-v-7dbaddd8]{border-top-width:0}.list-group-item+.list-group-item.active[data-v-7dbaddd8]{margin-top:-1px;border-top-width:1px}.list-group-horizontal[data-v-7dbaddd8]{flex-direction:row}.list-group-horizontal>.list-group-item[data-v-7dbaddd8]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal>.list-group-item[data-v-7dbaddd8]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal>.list-group-item.active[data-v-7dbaddd8]{margin-top:0}.list-group-horizontal>.list-group-item+.list-group-item[data-v-7dbaddd8]{border-top-width:1px;border-left-width:0}.list-group-horizontal>.list-group-item+.list-group-item.active[data-v-7dbaddd8]{margin-left:-1px;border-left-width:1px}@media (min-width:576px){.list-group-horizontal-sm[data-v-7dbaddd8]{flex-direction:row}.list-group-horizontal-sm>.list-group-item[data-v-7dbaddd8]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-sm>.list-group-item[data-v-7dbaddd8]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-sm>.list-group-item.active[data-v-7dbaddd8]{margin-top:0}.list-group-horizontal-sm>.list-group-item+.list-group-item[data-v-7dbaddd8]{border-top-width:1px;border-left-width:0}.list-group-horizontal-sm>.list-group-item+.list-group-item.active[data-v-7dbaddd8]{margin-left:-1px;border-left-width:1px}}@media (min-width:768px){.list-group-horizontal-md[data-v-7dbaddd8]{flex-direction:row}.list-group-horizontal-md>.list-group-item[data-v-7dbaddd8]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-md>.list-group-item[data-v-7dbaddd8]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-md>.list-group-item.active[data-v-7dbaddd8]{margin-top:0}.list-group-horizontal-md>.list-group-item+.list-group-item[data-v-7dbaddd8]{border-top-width:1px;border-left-width:0}.list-group-horizontal-md>.list-group-item+.list-group-item.active[data-v-7dbaddd8]{margin-left:-1px;border-left-width:1px}}@media (min-width:992px){.list-group-horizontal-lg[data-v-7dbaddd8]{flex-direction:row}.list-group-horizontal-lg>.list-group-item[data-v-7dbaddd8]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-lg>.list-group-item[data-v-7dbaddd8]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-lg>.list-group-item.active[data-v-7dbaddd8]{margin-top:0}.list-group-horizontal-lg>.list-group-item+.list-group-item[data-v-7dbaddd8]{border-top-width:1px;border-left-width:0}.list-group-horizontal-lg>.list-group-item+.list-group-item.active[data-v-7dbaddd8]{margin-left:-1px;border-left-width:1px}}@media (min-width:1200px){.list-group-horizontal-xl[data-v-7dbaddd8]{flex-direction:row}.list-group-horizontal-xl>.list-group-item[data-v-7dbaddd8]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xl>.list-group-item[data-v-7dbaddd8]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xl>.list-group-item.active[data-v-7dbaddd8]{margin-top:0}.list-group-horizontal-xl>.list-group-item+.list-group-item[data-v-7dbaddd8]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xl>.list-group-item+.list-group-item.active[data-v-7dbaddd8]{margin-left:-1px;border-left-width:1px}}@media (min-width:1400px){.list-group-horizontal-xxl[data-v-7dbaddd8]{flex-direction:row}.list-group-horizontal-xxl>.list-group-item[data-v-7dbaddd8]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xxl>.list-group-item[data-v-7dbaddd8]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xxl>.list-group-item.active[data-v-7dbaddd8]{margin-top:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item[data-v-7dbaddd8]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item.active[data-v-7dbaddd8]{margin-left:-1px;border-left-width:1px}}.list-group-flush[data-v-7dbaddd8]{border-radius:0}.list-group-flush>.list-group-item[data-v-7dbaddd8]{border-width:0 0 1px}.list-group-flush>.list-group-item[data-v-7dbaddd8]:last-child{border-bottom-width:0}.list-group-item-primary[data-v-7dbaddd8]{color:#084298;background-color:#cfe2ff}.list-group-item-primary.list-group-item-action[data-v-7dbaddd8]:focus,.list-group-item-primary.list-group-item-action[data-v-7dbaddd8]:hover{color:#084298;background-color:#bacbe6}.list-group-item-primary.list-group-item-action.active[data-v-7dbaddd8]{color:#fff;background-color:#084298;border-color:#084298}.list-group-item-secondary[data-v-7dbaddd8]{color:#41464b;background-color:#e2e3e5}.list-group-item-secondary.list-group-item-action[data-v-7dbaddd8]:focus,.list-group-item-secondary.list-group-item-action[data-v-7dbaddd8]:hover{color:#41464b;background-color:#cbccce}.list-group-item-secondary.list-group-item-action.active[data-v-7dbaddd8]{color:#fff;background-color:#41464b;border-color:#41464b}.list-group-item-success[data-v-7dbaddd8]{color:#0f5132;background-color:#d1e7dd}.list-group-item-success.list-group-item-action[data-v-7dbaddd8]:focus,.list-group-item-success.list-group-item-action[data-v-7dbaddd8]:hover{color:#0f5132;background-color:#bcd0c7}.list-group-item-success.list-group-item-action.active[data-v-7dbaddd8]{color:#fff;background-color:#0f5132;border-color:#0f5132}.list-group-item-info[data-v-7dbaddd8]{color:#055160;background-color:#cff4fc}.list-group-item-info.list-group-item-action[data-v-7dbaddd8]:focus,.list-group-item-info.list-group-item-action[data-v-7dbaddd8]:hover{color:#055160;background-color:#badce3}.list-group-item-info.list-group-item-action.active[data-v-7dbaddd8]{color:#fff;background-color:#055160;border-color:#055160}.list-group-item-warning[data-v-7dbaddd8]{color:#664d03;background-color:#fff3cd}.list-group-item-warning.list-group-item-action[data-v-7dbaddd8]:focus,.list-group-item-warning.list-group-item-action[data-v-7dbaddd8]:hover{color:#664d03;background-color:#e6dbb9}.list-group-item-warning.list-group-item-action.active[data-v-7dbaddd8]{color:#fff;background-color:#664d03;border-color:#664d03}.list-group-item-danger[data-v-7dbaddd8]{color:#842029;background-color:#f8d7da}.list-group-item-danger.list-group-item-action[data-v-7dbaddd8]:focus,.list-group-item-danger.list-group-item-action[data-v-7dbaddd8]:hover{color:#842029;background-color:#dfc2c4}.list-group-item-danger.list-group-item-action.active[data-v-7dbaddd8]{color:#fff;background-color:#842029;border-color:#842029}.list-group-item-light[data-v-7dbaddd8]{color:#636464;background-color:#fefefe}.list-group-item-light.list-group-item-action[data-v-7dbaddd8]:focus,.list-group-item-light.list-group-item-action[data-v-7dbaddd8]:hover{color:#636464;background-color:#e5e5e5}.list-group-item-light.list-group-item-action.active[data-v-7dbaddd8]{color:#fff;background-color:#636464;border-color:#636464}.list-group-item-dark[data-v-7dbaddd8]{color:#141619;background-color:#d3d3d4}.list-group-item-dark.list-group-item-action[data-v-7dbaddd8]:focus,.list-group-item-dark.list-group-item-action[data-v-7dbaddd8]:hover{color:#141619;background-color:#bebebf}.list-group-item-dark.list-group-item-action.active[data-v-7dbaddd8]{color:#fff;background-color:#141619;border-color:#141619}.btn-close[data-v-7dbaddd8]{box-sizing:content-box;width:1em;height:1em;padding:.25em;color:#000;background:transparent url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M.293.293a1 1 0 11.414 0 NaN NaNlNaN NaN NaN NaNa1 1 0 111.414 1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 10-1.414 NaN NaNz'/%3E%3C/svg%3E\") 50%/1em auto no-repeat;border:0;border-radius:.25rem;opacity:.5}.btn-close[data-v-7dbaddd8]:hover{color:#000;text-decoration:none;opacity:.75}.btn-close[data-v-7dbaddd8]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25);opacity:1}.btn-close.disabled[data-v-7dbaddd8],.btn-close[data-v-7dbaddd8]:disabled{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;opacity:.25}.btn-close-white[data-v-7dbaddd8]{filter:invert(1) grayscale(100%) brightness(200%)}.toast[data-v-7dbaddd8]{width:350px;max-width:100%;font-size:.875rem;pointer-events:auto;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .5rem 1rem rgba(0,0,0,.15);border-radius:.25rem}.toast.showing[data-v-7dbaddd8]{opacity:0}.toast[data-v-7dbaddd8]:not(.show){display:none}.toast-container[data-v-7dbaddd8]{width:-webkit-max-content;width:-moz-max-content;width:max-content;max-width:100%;pointer-events:none}.toast-container[data-v-7dbaddd8]>:not(:last-child){margin-bottom:.75rem}.toast-header[data-v-7dbaddd8]{display:flex;align-items:center;padding:.5rem .75rem;color:#6c757d;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05);border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.toast-header .btn-close[data-v-7dbaddd8]{margin-right:-.375rem;margin-left:.75rem}.toast-body[data-v-7dbaddd8]{padding:.75rem;word-wrap:break-word}.modal[data-v-7dbaddd8]{position:fixed;top:0;left:0;z-index:1055;display:none;width:100%;height:100%;overflow-x:hidden;overflow-y:auto;outline:0}.modal-dialog[data-v-7dbaddd8]{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog[data-v-7dbaddd8]{transition:transform .3s ease-out;transform:translateY(-50px)}@media (prefers-reduced-motion:reduce){.modal.fade .modal-dialog[data-v-7dbaddd8]{transition:none}}.modal.show .modal-dialog[data-v-7dbaddd8]{transform:none}.modal.modal-static .modal-dialog[data-v-7dbaddd8]{transform:scale(1.02)}.modal-dialog-scrollable[data-v-7dbaddd8]{height:calc(100% - 1rem)}.modal-dialog-scrollable .modal-content[data-v-7dbaddd8]{max-height:100%;overflow:hidden}.modal-dialog-scrollable .modal-body[data-v-7dbaddd8]{overflow-y:auto}.modal-dialog-centered[data-v-7dbaddd8]{display:flex;align-items:center;min-height:calc(100% - 1rem)}.modal-content[data-v-7dbaddd8]{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop[data-v-7dbaddd8]{position:fixed;top:0;left:0;z-index:1050;width:100vw;height:100vh;background-color:#000}.modal-backdrop.fade[data-v-7dbaddd8]{opacity:0}.modal-backdrop.show[data-v-7dbaddd8]{opacity:.5}.modal-header[data-v-7dbaddd8]{display:flex;flex-shrink:0;align-items:center;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.modal-header .btn-close[data-v-7dbaddd8]{padding:.5rem;margin:-.5rem -.5rem -.5rem auto}.modal-title[data-v-7dbaddd8]{margin-bottom:0;line-height:1.5}.modal-body[data-v-7dbaddd8]{position:relative;flex:1 1 auto;padding:1rem}.modal-footer[data-v-7dbaddd8]{display:flex;flex-wrap:wrap;flex-shrink:0;align-items:center;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.modal-footer>[data-v-7dbaddd8]{margin:.25rem}@media (min-width:576px){.modal-dialog[data-v-7dbaddd8]{max-width:500px;margin:1.75rem auto}.modal-dialog-scrollable[data-v-7dbaddd8]{height:calc(100% - 3.5rem)}.modal-dialog-centered[data-v-7dbaddd8]{min-height:calc(100% - 3.5rem)}.modal-sm[data-v-7dbaddd8]{max-width:300px}}@media (min-width:992px){.modal-lg[data-v-7dbaddd8],.modal-xl[data-v-7dbaddd8]{max-width:800px}}@media (min-width:1200px){.modal-xl[data-v-7dbaddd8]{max-width:1140px}}.modal-fullscreen[data-v-7dbaddd8]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen .modal-content[data-v-7dbaddd8]{height:100%;border:0;border-radius:0}.modal-fullscreen .modal-header[data-v-7dbaddd8]{border-radius:0}.modal-fullscreen .modal-body[data-v-7dbaddd8]{overflow-y:auto}.modal-fullscreen .modal-footer[data-v-7dbaddd8]{border-radius:0}@media (max-width:575.98px){.modal-fullscreen-sm-down[data-v-7dbaddd8]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-sm-down .modal-content[data-v-7dbaddd8]{height:100%;border:0;border-radius:0}.modal-fullscreen-sm-down .modal-header[data-v-7dbaddd8]{border-radius:0}.modal-fullscreen-sm-down .modal-body[data-v-7dbaddd8]{overflow-y:auto}.modal-fullscreen-sm-down .modal-footer[data-v-7dbaddd8]{border-radius:0}}@media (max-width:767.98px){.modal-fullscreen-md-down[data-v-7dbaddd8]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-md-down .modal-content[data-v-7dbaddd8]{height:100%;border:0;border-radius:0}.modal-fullscreen-md-down .modal-header[data-v-7dbaddd8]{border-radius:0}.modal-fullscreen-md-down .modal-body[data-v-7dbaddd8]{overflow-y:auto}.modal-fullscreen-md-down .modal-footer[data-v-7dbaddd8]{border-radius:0}}@media (max-width:991.98px){.modal-fullscreen-lg-down[data-v-7dbaddd8]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-lg-down .modal-content[data-v-7dbaddd8]{height:100%;border:0;border-radius:0}.modal-fullscreen-lg-down .modal-header[data-v-7dbaddd8]{border-radius:0}.modal-fullscreen-lg-down .modal-body[data-v-7dbaddd8]{overflow-y:auto}.modal-fullscreen-lg-down .modal-footer[data-v-7dbaddd8]{border-radius:0}}@media (max-width:1199.98px){.modal-fullscreen-xl-down[data-v-7dbaddd8]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xl-down .modal-content[data-v-7dbaddd8]{height:100%;border:0;border-radius:0}.modal-fullscreen-xl-down .modal-header[data-v-7dbaddd8]{border-radius:0}.modal-fullscreen-xl-down .modal-body[data-v-7dbaddd8]{overflow-y:auto}.modal-fullscreen-xl-down .modal-footer[data-v-7dbaddd8]{border-radius:0}}@media (max-width:1399.98px){.modal-fullscreen-xxl-down[data-v-7dbaddd8]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xxl-down .modal-content[data-v-7dbaddd8]{height:100%;border:0;border-radius:0}.modal-fullscreen-xxl-down .modal-header[data-v-7dbaddd8]{border-radius:0}.modal-fullscreen-xxl-down .modal-body[data-v-7dbaddd8]{overflow-y:auto}.modal-fullscreen-xxl-down .modal-footer[data-v-7dbaddd8]{border-radius:0}}.tooltip[data-v-7dbaddd8]{position:absolute;z-index:1080;display:block;margin:0;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show[data-v-7dbaddd8]{opacity:.9}.tooltip .tooltip-arrow[data-v-7dbaddd8]{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .tooltip-arrow[data-v-7dbaddd8]:before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[data-popper-placement^=top][data-v-7dbaddd8],.bs-tooltip-top[data-v-7dbaddd8]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-7dbaddd8],.bs-tooltip-top .tooltip-arrow[data-v-7dbaddd8]{bottom:0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-7dbaddd8]:before,.bs-tooltip-top .tooltip-arrow[data-v-7dbaddd8]:before{top:-1px;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[data-popper-placement^=right][data-v-7dbaddd8],.bs-tooltip-end[data-v-7dbaddd8]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-7dbaddd8],.bs-tooltip-end .tooltip-arrow[data-v-7dbaddd8]{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-7dbaddd8]:before,.bs-tooltip-end .tooltip-arrow[data-v-7dbaddd8]:before{right:-1px;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[data-popper-placement^=bottom][data-v-7dbaddd8],.bs-tooltip-bottom[data-v-7dbaddd8]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-7dbaddd8],.bs-tooltip-bottom .tooltip-arrow[data-v-7dbaddd8]{top:0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-7dbaddd8]:before,.bs-tooltip-bottom .tooltip-arrow[data-v-7dbaddd8]:before{bottom:-1px;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[data-popper-placement^=left][data-v-7dbaddd8],.bs-tooltip-start[data-v-7dbaddd8]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-7dbaddd8],.bs-tooltip-start .tooltip-arrow[data-v-7dbaddd8]{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-7dbaddd8]:before,.bs-tooltip-start .tooltip-arrow[data-v-7dbaddd8]:before{left:-1px;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner[data-v-7dbaddd8]{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover[data-v-7dbaddd8]{position:absolute;top:0;left:0;z-index:1070;display:block;max-width:276px;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover .popover-arrow[data-v-7dbaddd8]{position:absolute;display:block;width:1rem;height:.5rem}.popover .popover-arrow[data-v-7dbaddd8]:after,.popover .popover-arrow[data-v-7dbaddd8]:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-7dbaddd8],.bs-popover-top>.popover-arrow[data-v-7dbaddd8]{bottom:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-7dbaddd8]:before,.bs-popover-top>.popover-arrow[data-v-7dbaddd8]:before{bottom:0;border-width:.5rem .5rem 0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-7dbaddd8]:after,.bs-popover-top>.popover-arrow[data-v-7dbaddd8]:after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:#fff}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-7dbaddd8],.bs-popover-end>.popover-arrow[data-v-7dbaddd8]{left:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-7dbaddd8]:before,.bs-popover-end>.popover-arrow[data-v-7dbaddd8]:before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-7dbaddd8]:after,.bs-popover-end>.popover-arrow[data-v-7dbaddd8]:after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:#fff}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-7dbaddd8],.bs-popover-bottom>.popover-arrow[data-v-7dbaddd8]{top:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-7dbaddd8]:before,.bs-popover-bottom>.popover-arrow[data-v-7dbaddd8]:before{top:0;border-width:0 .5rem .5rem;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-7dbaddd8]:after,.bs-popover-bottom>.popover-arrow[data-v-7dbaddd8]:after{top:1px;border-width:0 .5rem .5rem;border-bottom-color:#fff}.bs-popover-auto[data-popper-placement^=bottom] .popover-header[data-v-7dbaddd8]:before,.bs-popover-bottom .popover-header[data-v-7dbaddd8]:before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f0f0f0}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-7dbaddd8],.bs-popover-start>.popover-arrow[data-v-7dbaddd8]{right:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-7dbaddd8]:before,.bs-popover-start>.popover-arrow[data-v-7dbaddd8]:before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-7dbaddd8]:after,.bs-popover-start>.popover-arrow[data-v-7dbaddd8]:after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:#fff}.popover-header[data-v-7dbaddd8]{padding:.5rem 1rem;margin-bottom:0;font-size:1rem;background-color:#f0f0f0;border-bottom:1px solid rgba(0,0,0,.2);border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header[data-v-7dbaddd8]:empty{display:none}.popover-body[data-v-7dbaddd8]{padding:1rem;color:#212529}.carousel[data-v-7dbaddd8]{position:relative}.carousel.pointer-event[data-v-7dbaddd8]{touch-action:pan-y}.carousel-inner[data-v-7dbaddd8]{position:relative;width:100%;overflow:hidden}.carousel-inner[data-v-7dbaddd8]:after{display:block;clear:both;content:\"\"}.carousel-item[data-v-7dbaddd8]{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.carousel-item[data-v-7dbaddd8]{transition:none}}.carousel-item-next[data-v-7dbaddd8],.carousel-item-prev[data-v-7dbaddd8],.carousel-item.active[data-v-7dbaddd8]{display:block}.active.carousel-item-end[data-v-7dbaddd8],.carousel-item-next[data-v-7dbaddd8]:not(.carousel-item-start){transform:translateX(100%)}.active.carousel-item-start[data-v-7dbaddd8],.carousel-item-prev[data-v-7dbaddd8]:not(.carousel-item-end){transform:translateX(-100%)}.carousel-fade .carousel-item[data-v-7dbaddd8]{opacity:0;transition-property:opacity;transform:none}.carousel-fade .carousel-item-next.carousel-item-start[data-v-7dbaddd8],.carousel-fade .carousel-item-prev.carousel-item-end[data-v-7dbaddd8],.carousel-fade .carousel-item.active[data-v-7dbaddd8]{z-index:1;opacity:1}.carousel-fade .active.carousel-item-end[data-v-7dbaddd8],.carousel-fade .active.carousel-item-start[data-v-7dbaddd8]{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.carousel-fade .active.carousel-item-end[data-v-7dbaddd8],.carousel-fade .active.carousel-item-start[data-v-7dbaddd8]{transition:none}}.carousel-control-next[data-v-7dbaddd8],.carousel-control-prev[data-v-7dbaddd8]{position:absolute;top:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center;width:15%;padding:0;color:#fff;text-align:center;background:0 0;border:0;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.carousel-control-next[data-v-7dbaddd8],.carousel-control-prev[data-v-7dbaddd8]{transition:none}}.carousel-control-next[data-v-7dbaddd8]:focus,.carousel-control-next[data-v-7dbaddd8]:hover,.carousel-control-prev[data-v-7dbaddd8]:focus,.carousel-control-prev[data-v-7dbaddd8]:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev[data-v-7dbaddd8]{left:0}.carousel-control-next[data-v-7dbaddd8]{right:0}.carousel-control-next-icon[data-v-7dbaddd8],.carousel-control-prev-icon[data-v-7dbaddd8]{display:inline-block;width:2rem;height:2rem;background-repeat:no-repeat;background-position:50%;background-size:100% 100%}.carousel-control-prev-icon[data-v-7dbaddd8]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3E%3C/svg%3E\")}.carousel-control-next-icon[data-v-7dbaddd8]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\")}.carousel-indicators[data-v-7dbaddd8]{position:absolute;right:0;bottom:0;left:0;z-index:2;display:flex;justify-content:center;padding:0;margin-right:15%;margin-bottom:1rem;margin-left:15%;list-style:none}.carousel-indicators [data-bs-target][data-v-7dbaddd8]{box-sizing:content-box;flex:0 1 auto;width:30px;height:3px;padding:0;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border:0;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.carousel-indicators [data-bs-target][data-v-7dbaddd8]{transition:none}}.carousel-indicators .active[data-v-7dbaddd8]{opacity:1}.carousel-caption[data-v-7dbaddd8]{position:absolute;right:15%;bottom:1.25rem;left:15%;padding-top:1.25rem;padding-bottom:1.25rem;color:#fff;text-align:center}.carousel-dark .carousel-control-next-icon[data-v-7dbaddd8],.carousel-dark .carousel-control-prev-icon[data-v-7dbaddd8]{filter:invert(1) grayscale(100)}.carousel-dark .carousel-indicators [data-bs-target][data-v-7dbaddd8]{background-color:#000}.carousel-dark .carousel-caption[data-v-7dbaddd8]{color:#000}@-webkit-keyframes spinner-border-data-v-7dbaddd8{to{transform:rotate(1turn)}}@keyframes spinner-border-data-v-7dbaddd8{to{transform:rotate(1turn)}}.spinner-border[data-v-7dbaddd8]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:.75s linear infinite spinner-border-data-v-7dbaddd8;animation:.75s linear infinite spinner-border-data-v-7dbaddd8}.spinner-border-sm[data-v-7dbaddd8]{width:1rem;height:1rem;border-width:.2em}@-webkit-keyframes spinner-grow-data-v-7dbaddd8{0%{transform:scale(0)}50%{opacity:1;transform:none}}@keyframes spinner-grow-data-v-7dbaddd8{0%{transform:scale(0)}50%{opacity:1;transform:none}}.spinner-grow[data-v-7dbaddd8]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;background-color:currentColor;border-radius:50%;opacity:0;-webkit-animation:.75s linear infinite spinner-grow-data-v-7dbaddd8;animation:.75s linear infinite spinner-grow-data-v-7dbaddd8}.spinner-grow-sm[data-v-7dbaddd8]{width:1rem;height:1rem}@media (prefers-reduced-motion:reduce){.spinner-border[data-v-7dbaddd8],.spinner-grow[data-v-7dbaddd8]{-webkit-animation-duration:1.5s;animation-duration:1.5s}}.offcanvas[data-v-7dbaddd8]{position:fixed;bottom:0;z-index:1045;display:flex;flex-direction:column;max-width:100%;visibility:hidden;background-color:#fff;background-clip:padding-box;outline:0;transition:transform .3s ease-in-out}@media (prefers-reduced-motion:reduce){.offcanvas[data-v-7dbaddd8]{transition:none}}.offcanvas-backdrop[data-v-7dbaddd8]{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.offcanvas-backdrop.fade[data-v-7dbaddd8]{opacity:0}.offcanvas-backdrop.show[data-v-7dbaddd8]{opacity:.5}.offcanvas-header[data-v-7dbaddd8]{display:flex;align-items:center;justify-content:space-between;padding:1rem}.offcanvas-header .btn-close[data-v-7dbaddd8]{padding:.5rem;margin-top:-.5rem;margin-right:-.5rem;margin-bottom:-.5rem}.offcanvas-title[data-v-7dbaddd8]{margin-bottom:0;line-height:1.5}.offcanvas-body[data-v-7dbaddd8]{flex-grow:1;padding:1rem;overflow-y:auto}.offcanvas-start[data-v-7dbaddd8]{top:0;left:0;width:400px;border-right:1px solid rgba(0,0,0,.2);transform:translateX(-100%)}.offcanvas-end[data-v-7dbaddd8]{top:0;right:0;width:400px;border-left:1px solid rgba(0,0,0,.2);transform:translateX(100%)}.offcanvas-top[data-v-7dbaddd8]{top:0;right:0;left:0;height:30vh;max-height:100%;border-bottom:1px solid rgba(0,0,0,.2);transform:translateY(-100%)}.offcanvas-bottom[data-v-7dbaddd8]{right:0;left:0;height:30vh;max-height:100%;border-top:1px solid rgba(0,0,0,.2);transform:translateY(100%)}.offcanvas.show[data-v-7dbaddd8]{transform:none}.placeholder[data-v-7dbaddd8]{display:inline-block;min-height:1em;vertical-align:middle;cursor:wait;background-color:currentColor;opacity:.5}.placeholder.btn[data-v-7dbaddd8]:before{display:inline-block;content:\"\"}.placeholder-xs[data-v-7dbaddd8]{min-height:.6em}.placeholder-sm[data-v-7dbaddd8]{min-height:.8em}.placeholder-lg[data-v-7dbaddd8]{min-height:1.2em}.placeholder-glow .placeholder[data-v-7dbaddd8]{-webkit-animation:placeholder-glow-data-v-7dbaddd8 2s ease-in-out infinite;animation:placeholder-glow-data-v-7dbaddd8 2s ease-in-out infinite}@-webkit-keyframes placeholder-glow-data-v-7dbaddd8{50%{opacity:.2}}@keyframes placeholder-glow-data-v-7dbaddd8{50%{opacity:.2}}.placeholder-wave[data-v-7dbaddd8]{-webkit-mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);-webkit-mask-size:200% 100%;mask-size:200% 100%;-webkit-animation:placeholder-wave-data-v-7dbaddd8 2s linear infinite;animation:placeholder-wave-data-v-7dbaddd8 2s linear infinite}@-webkit-keyframes placeholder-wave-data-v-7dbaddd8{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}@keyframes placeholder-wave-data-v-7dbaddd8{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}.clearfix[data-v-7dbaddd8]:after{display:block;clear:both;content:\"\"}.link-primary[data-v-7dbaddd8]{color:#0d6efd}.link-primary[data-v-7dbaddd8]:focus,.link-primary[data-v-7dbaddd8]:hover{color:#0a58ca}.link-secondary[data-v-7dbaddd8]{color:#6c757d}.link-secondary[data-v-7dbaddd8]:focus,.link-secondary[data-v-7dbaddd8]:hover{color:#565e64}.link-success[data-v-7dbaddd8]{color:#198754}.link-success[data-v-7dbaddd8]:focus,.link-success[data-v-7dbaddd8]:hover{color:#146c43}.link-info[data-v-7dbaddd8]{color:#0dcaf0}.link-info[data-v-7dbaddd8]:focus,.link-info[data-v-7dbaddd8]:hover{color:#3dd5f3}.link-warning[data-v-7dbaddd8]{color:#ffc107}.link-warning[data-v-7dbaddd8]:focus,.link-warning[data-v-7dbaddd8]:hover{color:#ffcd39}.link-danger[data-v-7dbaddd8]{color:#dc3545}.link-danger[data-v-7dbaddd8]:focus,.link-danger[data-v-7dbaddd8]:hover{color:#b02a37}.link-light[data-v-7dbaddd8]{color:#f8f9fa}.link-light[data-v-7dbaddd8]:focus,.link-light[data-v-7dbaddd8]:hover{color:#f9fafb}.link-dark[data-v-7dbaddd8]{color:#212529}.link-dark[data-v-7dbaddd8]:focus,.link-dark[data-v-7dbaddd8]:hover{color:#1a1e21}.ratio[data-v-7dbaddd8]{position:relative;width:100%}.ratio[data-v-7dbaddd8]:before{display:block;padding-top:var(--bs-aspect-ratio);content:\"\"}.ratio>[data-v-7dbaddd8]{position:absolute;top:0;left:0;width:100%;height:100%}.ratio-1x1[data-v-7dbaddd8]{--bs-aspect-ratio:100%}.ratio-4x3[data-v-7dbaddd8]{--bs-aspect-ratio:75%}.ratio-16x9[data-v-7dbaddd8]{--bs-aspect-ratio:56.25%}.ratio-21x9[data-v-7dbaddd8]{--bs-aspect-ratio:42.8571428571%}.fixed-top[data-v-7dbaddd8]{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom[data-v-7dbaddd8]{position:fixed;right:0;bottom:0;left:0;z-index:1030}.sticky-top[data-v-7dbaddd8]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}@media (min-width:576px){.sticky-sm-top[data-v-7dbaddd8]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:768px){.sticky-md-top[data-v-7dbaddd8]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:992px){.sticky-lg-top[data-v-7dbaddd8]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1200px){.sticky-xl-top[data-v-7dbaddd8]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1400px){.sticky-xxl-top[data-v-7dbaddd8]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.hstack[data-v-7dbaddd8]{display:flex;flex-direction:row;align-items:center;align-self:stretch}.vstack[data-v-7dbaddd8]{display:flex;flex:1 1 auto;flex-direction:column;align-self:stretch}.visually-hidden-focusable[data-v-7dbaddd8]:not(:focus):not(:focus-within),.visually-hidden[data-v-7dbaddd8]{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}.stretched-link[data-v-7dbaddd8]:after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;content:\"\"}.text-truncate[data-v-7dbaddd8]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.vr[data-v-7dbaddd8]{display:inline-block;align-self:stretch;width:1px;min-height:1em;background-color:currentColor;opacity:.25}.align-baseline[data-v-7dbaddd8]{vertical-align:baseline!important}.align-top[data-v-7dbaddd8]{vertical-align:top!important}.align-middle[data-v-7dbaddd8]{vertical-align:middle!important}.align-bottom[data-v-7dbaddd8]{vertical-align:bottom!important}.align-text-bottom[data-v-7dbaddd8]{vertical-align:text-bottom!important}.align-text-top[data-v-7dbaddd8]{vertical-align:text-top!important}.float-start[data-v-7dbaddd8]{float:left!important}.float-end[data-v-7dbaddd8]{float:right!important}.float-none[data-v-7dbaddd8]{float:none!important}.opacity-0[data-v-7dbaddd8]{opacity:0!important}.opacity-25[data-v-7dbaddd8]{opacity:.25!important}.opacity-50[data-v-7dbaddd8]{opacity:.5!important}.opacity-75[data-v-7dbaddd8]{opacity:.75!important}.opacity-100[data-v-7dbaddd8]{opacity:1!important}.overflow-auto[data-v-7dbaddd8]{overflow:auto!important}.overflow-hidden[data-v-7dbaddd8]{overflow:hidden!important}.overflow-visible[data-v-7dbaddd8]{overflow:visible!important}.overflow-scroll[data-v-7dbaddd8]{overflow:scroll!important}.d-inline[data-v-7dbaddd8]{display:inline!important}.d-inline-block[data-v-7dbaddd8]{display:inline-block!important}.d-block[data-v-7dbaddd8]{display:block!important}.d-grid[data-v-7dbaddd8]{display:grid!important}.d-table[data-v-7dbaddd8]{display:table!important}.d-table-row[data-v-7dbaddd8]{display:table-row!important}.d-table-cell[data-v-7dbaddd8]{display:table-cell!important}.d-flex[data-v-7dbaddd8]{display:flex!important}.d-inline-flex[data-v-7dbaddd8]{display:inline-flex!important}.d-none[data-v-7dbaddd8]{display:none!important}.shadow[data-v-7dbaddd8]{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.shadow-sm[data-v-7dbaddd8]{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.shadow-lg[data-v-7dbaddd8]{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.shadow-none[data-v-7dbaddd8]{box-shadow:none!important}.position-static[data-v-7dbaddd8]{position:static!important}.position-relative[data-v-7dbaddd8]{position:relative!important}.position-absolute[data-v-7dbaddd8]{position:absolute!important}.position-fixed[data-v-7dbaddd8]{position:fixed!important}.position-sticky[data-v-7dbaddd8]{position:-webkit-sticky!important;position:sticky!important}.top-0[data-v-7dbaddd8]{top:0!important}.top-50[data-v-7dbaddd8]{top:50%!important}.top-100[data-v-7dbaddd8]{top:100%!important}.bottom-0[data-v-7dbaddd8]{bottom:0!important}.bottom-50[data-v-7dbaddd8]{bottom:50%!important}.bottom-100[data-v-7dbaddd8]{bottom:100%!important}.start-0[data-v-7dbaddd8]{left:0!important}.start-50[data-v-7dbaddd8]{left:50%!important}.start-100[data-v-7dbaddd8]{left:100%!important}.end-0[data-v-7dbaddd8]{right:0!important}.end-50[data-v-7dbaddd8]{right:50%!important}.end-100[data-v-7dbaddd8]{right:100%!important}.translate-middle[data-v-7dbaddd8]{transform:translate(-50%,-50%)!important}.translate-middle-x[data-v-7dbaddd8]{transform:translateX(-50%)!important}.translate-middle-y[data-v-7dbaddd8]{transform:translateY(-50%)!important}.border[data-v-7dbaddd8]{border:1px solid #dee2e6!important}.border-0[data-v-7dbaddd8]{border:0!important}.border-top[data-v-7dbaddd8]{border-top:1px solid #dee2e6!important}.border-top-0[data-v-7dbaddd8]{border-top:0!important}.border-end[data-v-7dbaddd8]{border-right:1px solid #dee2e6!important}.border-end-0[data-v-7dbaddd8]{border-right:0!important}.border-bottom[data-v-7dbaddd8]{border-bottom:1px solid #dee2e6!important}.border-bottom-0[data-v-7dbaddd8]{border-bottom:0!important}.border-start[data-v-7dbaddd8]{border-left:1px solid #dee2e6!important}.border-start-0[data-v-7dbaddd8]{border-left:0!important}.border-primary[data-v-7dbaddd8]{border-color:#0d6efd!important}.border-secondary[data-v-7dbaddd8]{border-color:#6c757d!important}.border-success[data-v-7dbaddd8]{border-color:#198754!important}.border-info[data-v-7dbaddd8]{border-color:#0dcaf0!important}.border-warning[data-v-7dbaddd8]{border-color:#ffc107!important}.border-danger[data-v-7dbaddd8]{border-color:#dc3545!important}.border-light[data-v-7dbaddd8]{border-color:#f8f9fa!important}.border-dark[data-v-7dbaddd8]{border-color:#212529!important}.border-white[data-v-7dbaddd8]{border-color:#fff!important}.border-1[data-v-7dbaddd8]{border-width:1px!important}.border-2[data-v-7dbaddd8]{border-width:2px!important}.border-3[data-v-7dbaddd8]{border-width:3px!important}.border-4[data-v-7dbaddd8]{border-width:4px!important}.border-5[data-v-7dbaddd8]{border-width:5px!important}.w-25[data-v-7dbaddd8]{width:25%!important}.w-50[data-v-7dbaddd8]{width:50%!important}.w-75[data-v-7dbaddd8]{width:75%!important}.w-100[data-v-7dbaddd8]{width:100%!important}.w-auto[data-v-7dbaddd8]{width:auto!important}.mw-100[data-v-7dbaddd8]{max-width:100%!important}.vw-100[data-v-7dbaddd8]{width:100vw!important}.min-vw-100[data-v-7dbaddd8]{min-width:100vw!important}.h-25[data-v-7dbaddd8]{height:25%!important}.h-50[data-v-7dbaddd8]{height:50%!important}.h-75[data-v-7dbaddd8]{height:75%!important}.h-100[data-v-7dbaddd8]{height:100%!important}.h-auto[data-v-7dbaddd8]{height:auto!important}.mh-100[data-v-7dbaddd8]{max-height:100%!important}.vh-100[data-v-7dbaddd8]{height:100vh!important}.min-vh-100[data-v-7dbaddd8]{min-height:100vh!important}.flex-fill[data-v-7dbaddd8]{flex:1 1 auto!important}.flex-row[data-v-7dbaddd8]{flex-direction:row!important}.flex-column[data-v-7dbaddd8]{flex-direction:column!important}.flex-row-reverse[data-v-7dbaddd8]{flex-direction:row-reverse!important}.flex-column-reverse[data-v-7dbaddd8]{flex-direction:column-reverse!important}.flex-grow-0[data-v-7dbaddd8]{flex-grow:0!important}.flex-grow-1[data-v-7dbaddd8]{flex-grow:1!important}.flex-shrink-0[data-v-7dbaddd8]{flex-shrink:0!important}.flex-shrink-1[data-v-7dbaddd8]{flex-shrink:1!important}.flex-wrap[data-v-7dbaddd8]{flex-wrap:wrap!important}.flex-nowrap[data-v-7dbaddd8]{flex-wrap:nowrap!important}.flex-wrap-reverse[data-v-7dbaddd8]{flex-wrap:wrap-reverse!important}.gap-0[data-v-7dbaddd8]{gap:0!important}.gap-1[data-v-7dbaddd8]{gap:.25rem!important}.gap-2[data-v-7dbaddd8]{gap:.5rem!important}.gap-3[data-v-7dbaddd8]{gap:1rem!important}.gap-4[data-v-7dbaddd8]{gap:1.5rem!important}.gap-5[data-v-7dbaddd8]{gap:3rem!important}.justify-content-start[data-v-7dbaddd8]{justify-content:flex-start!important}.justify-content-end[data-v-7dbaddd8]{justify-content:flex-end!important}.justify-content-center[data-v-7dbaddd8]{justify-content:center!important}.justify-content-between[data-v-7dbaddd8]{justify-content:space-between!important}.justify-content-around[data-v-7dbaddd8]{justify-content:space-around!important}.justify-content-evenly[data-v-7dbaddd8]{justify-content:space-evenly!important}.align-items-start[data-v-7dbaddd8]{align-items:flex-start!important}.align-items-end[data-v-7dbaddd8]{align-items:flex-end!important}.align-items-center[data-v-7dbaddd8]{align-items:center!important}.align-items-baseline[data-v-7dbaddd8]{align-items:baseline!important}.align-items-stretch[data-v-7dbaddd8]{align-items:stretch!important}.align-content-start[data-v-7dbaddd8]{align-content:flex-start!important}.align-content-end[data-v-7dbaddd8]{align-content:flex-end!important}.align-content-center[data-v-7dbaddd8]{align-content:center!important}.align-content-between[data-v-7dbaddd8]{align-content:space-between!important}.align-content-around[data-v-7dbaddd8]{align-content:space-around!important}.align-content-stretch[data-v-7dbaddd8]{align-content:stretch!important}.align-self-auto[data-v-7dbaddd8]{align-self:auto!important}.align-self-start[data-v-7dbaddd8]{align-self:flex-start!important}.align-self-end[data-v-7dbaddd8]{align-self:flex-end!important}.align-self-center[data-v-7dbaddd8]{align-self:center!important}.align-self-baseline[data-v-7dbaddd8]{align-self:baseline!important}.align-self-stretch[data-v-7dbaddd8]{align-self:stretch!important}.order-first[data-v-7dbaddd8]{order:-1!important}.order-0[data-v-7dbaddd8]{order:0!important}.order-1[data-v-7dbaddd8]{order:1!important}.order-2[data-v-7dbaddd8]{order:2!important}.order-3[data-v-7dbaddd8]{order:3!important}.order-4[data-v-7dbaddd8]{order:4!important}.order-5[data-v-7dbaddd8]{order:5!important}.order-last[data-v-7dbaddd8]{order:6!important}.m-0[data-v-7dbaddd8]{margin:0!important}.m-1[data-v-7dbaddd8]{margin:.25rem!important}.m-2[data-v-7dbaddd8]{margin:.5rem!important}.m-3[data-v-7dbaddd8]{margin:1rem!important}.m-4[data-v-7dbaddd8]{margin:1.5rem!important}.m-5[data-v-7dbaddd8]{margin:3rem!important}.m-auto[data-v-7dbaddd8]{margin:auto!important}.mx-0[data-v-7dbaddd8]{margin-right:0!important;margin-left:0!important}.mx-1[data-v-7dbaddd8]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-2[data-v-7dbaddd8]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-3[data-v-7dbaddd8]{margin-right:1rem!important;margin-left:1rem!important}.mx-4[data-v-7dbaddd8]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-5[data-v-7dbaddd8]{margin-right:3rem!important;margin-left:3rem!important}.mx-auto[data-v-7dbaddd8]{margin-right:auto!important;margin-left:auto!important}.my-0[data-v-7dbaddd8]{margin-top:0!important;margin-bottom:0!important}.my-1[data-v-7dbaddd8]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-2[data-v-7dbaddd8]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-3[data-v-7dbaddd8]{margin-top:1rem!important;margin-bottom:1rem!important}.my-4[data-v-7dbaddd8]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-5[data-v-7dbaddd8]{margin-top:3rem!important;margin-bottom:3rem!important}.my-auto[data-v-7dbaddd8]{margin-top:auto!important;margin-bottom:auto!important}.mt-0[data-v-7dbaddd8]{margin-top:0!important}.mt-1[data-v-7dbaddd8]{margin-top:.25rem!important}.mt-2[data-v-7dbaddd8]{margin-top:.5rem!important}.mt-3[data-v-7dbaddd8]{margin-top:1rem!important}.mt-4[data-v-7dbaddd8]{margin-top:1.5rem!important}.mt-5[data-v-7dbaddd8]{margin-top:3rem!important}.mt-auto[data-v-7dbaddd8]{margin-top:auto!important}.me-0[data-v-7dbaddd8]{margin-right:0!important}.me-1[data-v-7dbaddd8]{margin-right:.25rem!important}.me-2[data-v-7dbaddd8]{margin-right:.5rem!important}.me-3[data-v-7dbaddd8]{margin-right:1rem!important}.me-4[data-v-7dbaddd8]{margin-right:1.5rem!important}.me-5[data-v-7dbaddd8]{margin-right:3rem!important}.me-auto[data-v-7dbaddd8]{margin-right:auto!important}.mb-0[data-v-7dbaddd8]{margin-bottom:0!important}.mb-1[data-v-7dbaddd8]{margin-bottom:.25rem!important}.mb-2[data-v-7dbaddd8]{margin-bottom:.5rem!important}.mb-3[data-v-7dbaddd8]{margin-bottom:1rem!important}.mb-4[data-v-7dbaddd8]{margin-bottom:1.5rem!important}.mb-5[data-v-7dbaddd8]{margin-bottom:3rem!important}.mb-auto[data-v-7dbaddd8]{margin-bottom:auto!important}.ms-0[data-v-7dbaddd8]{margin-left:0!important}.ms-1[data-v-7dbaddd8]{margin-left:.25rem!important}.ms-2[data-v-7dbaddd8]{margin-left:.5rem!important}.ms-3[data-v-7dbaddd8]{margin-left:1rem!important}.ms-4[data-v-7dbaddd8]{margin-left:1.5rem!important}.ms-5[data-v-7dbaddd8]{margin-left:3rem!important}.ms-auto[data-v-7dbaddd8]{margin-left:auto!important}.p-0[data-v-7dbaddd8]{padding:0!important}.p-1[data-v-7dbaddd8]{padding:.25rem!important}.p-2[data-v-7dbaddd8]{padding:.5rem!important}.p-3[data-v-7dbaddd8]{padding:1rem!important}.p-4[data-v-7dbaddd8]{padding:1.5rem!important}.p-5[data-v-7dbaddd8]{padding:3rem!important}.px-0[data-v-7dbaddd8]{padding-right:0!important;padding-left:0!important}.px-1[data-v-7dbaddd8]{padding-right:.25rem!important;padding-left:.25rem!important}.px-2[data-v-7dbaddd8]{padding-right:.5rem!important;padding-left:.5rem!important}.px-3[data-v-7dbaddd8]{padding-right:1rem!important;padding-left:1rem!important}.px-4[data-v-7dbaddd8]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-5[data-v-7dbaddd8]{padding-right:3rem!important;padding-left:3rem!important}.py-0[data-v-7dbaddd8]{padding-top:0!important;padding-bottom:0!important}.py-1[data-v-7dbaddd8]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-2[data-v-7dbaddd8]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-3[data-v-7dbaddd8]{padding-top:1rem!important;padding-bottom:1rem!important}.py-4[data-v-7dbaddd8]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-5[data-v-7dbaddd8]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-0[data-v-7dbaddd8]{padding-top:0!important}.pt-1[data-v-7dbaddd8]{padding-top:.25rem!important}.pt-2[data-v-7dbaddd8]{padding-top:.5rem!important}.pt-3[data-v-7dbaddd8]{padding-top:1rem!important}.pt-4[data-v-7dbaddd8]{padding-top:1.5rem!important}.pt-5[data-v-7dbaddd8]{padding-top:3rem!important}.pe-0[data-v-7dbaddd8]{padding-right:0!important}.pe-1[data-v-7dbaddd8]{padding-right:.25rem!important}.pe-2[data-v-7dbaddd8]{padding-right:.5rem!important}.pe-3[data-v-7dbaddd8]{padding-right:1rem!important}.pe-4[data-v-7dbaddd8]{padding-right:1.5rem!important}.pe-5[data-v-7dbaddd8]{padding-right:3rem!important}.pb-0[data-v-7dbaddd8]{padding-bottom:0!important}.pb-1[data-v-7dbaddd8]{padding-bottom:.25rem!important}.pb-2[data-v-7dbaddd8]{padding-bottom:.5rem!important}.pb-3[data-v-7dbaddd8]{padding-bottom:1rem!important}.pb-4[data-v-7dbaddd8]{padding-bottom:1.5rem!important}.pb-5[data-v-7dbaddd8]{padding-bottom:3rem!important}.ps-0[data-v-7dbaddd8]{padding-left:0!important}.ps-1[data-v-7dbaddd8]{padding-left:.25rem!important}.ps-2[data-v-7dbaddd8]{padding-left:.5rem!important}.ps-3[data-v-7dbaddd8]{padding-left:1rem!important}.ps-4[data-v-7dbaddd8]{padding-left:1.5rem!important}.ps-5[data-v-7dbaddd8]{padding-left:3rem!important}.font-monospace[data-v-7dbaddd8]{font-family:var(--bs-font-monospace)!important}.fs-1[data-v-7dbaddd8]{font-size:calc(1.375rem + 1.5vw)!important}.fs-2[data-v-7dbaddd8]{font-size:calc(1.325rem + .9vw)!important}.fs-3[data-v-7dbaddd8]{font-size:calc(1.3rem + .6vw)!important}.fs-4[data-v-7dbaddd8]{font-size:calc(1.275rem + .3vw)!important}.fs-5[data-v-7dbaddd8]{font-size:1.25rem!important}.fs-6[data-v-7dbaddd8]{font-size:1rem!important}.fst-italic[data-v-7dbaddd8]{font-style:italic!important}.fst-normal[data-v-7dbaddd8]{font-style:normal!important}.fw-light[data-v-7dbaddd8]{font-weight:300!important}.fw-lighter[data-v-7dbaddd8]{font-weight:lighter!important}.fw-normal[data-v-7dbaddd8]{font-weight:400!important}.fw-bold[data-v-7dbaddd8]{font-weight:700!important}.fw-bolder[data-v-7dbaddd8]{font-weight:bolder!important}.lh-1[data-v-7dbaddd8]{line-height:1!important}.lh-sm[data-v-7dbaddd8]{line-height:1.25!important}.lh-base[data-v-7dbaddd8]{line-height:1.5!important}.lh-lg[data-v-7dbaddd8]{line-height:2!important}.text-start[data-v-7dbaddd8]{text-align:left!important}.text-end[data-v-7dbaddd8]{text-align:right!important}.text-center[data-v-7dbaddd8]{text-align:center!important}.text-decoration-none[data-v-7dbaddd8]{text-decoration:none!important}.text-decoration-underline[data-v-7dbaddd8]{text-decoration:underline!important}.text-decoration-line-through[data-v-7dbaddd8]{text-decoration:line-through!important}.text-lowercase[data-v-7dbaddd8]{text-transform:lowercase!important}.text-uppercase[data-v-7dbaddd8]{text-transform:uppercase!important}.text-capitalize[data-v-7dbaddd8]{text-transform:capitalize!important}.text-wrap[data-v-7dbaddd8]{white-space:normal!important}.text-nowrap[data-v-7dbaddd8]{white-space:nowrap!important}.text-break[data-v-7dbaddd8]{word-wrap:break-word!important;word-break:break-word!important}.text-primary[data-v-7dbaddd8]{--bs-text-opacity:1;color:rgba(var(--bs-primary-rgb),var(--bs-text-opacity))!important}.text-secondary[data-v-7dbaddd8]{--bs-text-opacity:1;color:rgba(var(--bs-secondary-rgb),var(--bs-text-opacity))!important}.text-success[data-v-7dbaddd8]{--bs-text-opacity:1;color:rgba(var(--bs-success-rgb),var(--bs-text-opacity))!important}.text-info[data-v-7dbaddd8]{--bs-text-opacity:1;color:rgba(var(--bs-info-rgb),var(--bs-text-opacity))!important}.text-warning[data-v-7dbaddd8]{--bs-text-opacity:1;color:rgba(var(--bs-warning-rgb),var(--bs-text-opacity))!important}.text-danger[data-v-7dbaddd8]{--bs-text-opacity:1;color:rgba(var(--bs-danger-rgb),var(--bs-text-opacity))!important}.text-light[data-v-7dbaddd8]{--bs-text-opacity:1;color:rgba(var(--bs-light-rgb),var(--bs-text-opacity))!important}.text-dark[data-v-7dbaddd8]{--bs-text-opacity:1;color:rgba(var(--bs-dark-rgb),var(--bs-text-opacity))!important}.text-black[data-v-7dbaddd8]{--bs-text-opacity:1;color:rgba(var(--bs-black-rgb),var(--bs-text-opacity))!important}.text-white[data-v-7dbaddd8]{--bs-text-opacity:1;color:rgba(var(--bs-white-rgb),var(--bs-text-opacity))!important}.text-body[data-v-7dbaddd8]{--bs-text-opacity:1;color:rgba(var(--bs-body-color-rgb),var(--bs-text-opacity))!important}.text-muted[data-v-7dbaddd8]{--bs-text-opacity:1;color:#6c757d!important}.text-black-50[data-v-7dbaddd8]{--bs-text-opacity:1;color:rgba(0,0,0,.5)!important}.text-white-50[data-v-7dbaddd8]{--bs-text-opacity:1;color:hsla(0,0%,100%,.5)!important}.text-reset[data-v-7dbaddd8]{--bs-text-opacity:1;color:inherit!important}.text-opacity-25[data-v-7dbaddd8]{--bs-text-opacity:0.25}.text-opacity-50[data-v-7dbaddd8]{--bs-text-opacity:0.5}.text-opacity-75[data-v-7dbaddd8]{--bs-text-opacity:0.75}.text-opacity-100[data-v-7dbaddd8]{--bs-text-opacity:1}.bg-primary[data-v-7dbaddd8]{--bs-bg-opacity:1;background-color:rgba(var(--bs-primary-rgb),var(--bs-bg-opacity))!important}.bg-secondary[data-v-7dbaddd8]{--bs-bg-opacity:1;background-color:rgba(var(--bs-secondary-rgb),var(--bs-bg-opacity))!important}.bg-success[data-v-7dbaddd8]{--bs-bg-opacity:1;background-color:rgba(var(--bs-success-rgb),var(--bs-bg-opacity))!important}.bg-info[data-v-7dbaddd8]{--bs-bg-opacity:1;background-color:rgba(var(--bs-info-rgb),var(--bs-bg-opacity))!important}.bg-warning[data-v-7dbaddd8]{--bs-bg-opacity:1;background-color:rgba(var(--bs-warning-rgb),var(--bs-bg-opacity))!important}.bg-danger[data-v-7dbaddd8]{--bs-bg-opacity:1;background-color:rgba(var(--bs-danger-rgb),var(--bs-bg-opacity))!important}.bg-light[data-v-7dbaddd8]{--bs-bg-opacity:1;background-color:rgba(var(--bs-light-rgb),var(--bs-bg-opacity))!important}.bg-dark[data-v-7dbaddd8]{--bs-bg-opacity:1;background-color:rgba(var(--bs-dark-rgb),var(--bs-bg-opacity))!important}.bg-black[data-v-7dbaddd8]{--bs-bg-opacity:1;background-color:rgba(var(--bs-black-rgb),var(--bs-bg-opacity))!important}.bg-white[data-v-7dbaddd8]{--bs-bg-opacity:1;background-color:rgba(var(--bs-white-rgb),var(--bs-bg-opacity))!important}.bg-body[data-v-7dbaddd8]{--bs-bg-opacity:1;background-color:rgba(var(--bs-body-bg-rgb),var(--bs-bg-opacity))!important}.bg-transparent[data-v-7dbaddd8]{--bs-bg-opacity:1;background-color:transparent!important}.bg-opacity-10[data-v-7dbaddd8]{--bs-bg-opacity:0.1}.bg-opacity-25[data-v-7dbaddd8]{--bs-bg-opacity:0.25}.bg-opacity-50[data-v-7dbaddd8]{--bs-bg-opacity:0.5}.bg-opacity-75[data-v-7dbaddd8]{--bs-bg-opacity:0.75}.bg-opacity-100[data-v-7dbaddd8]{--bs-bg-opacity:1}.bg-gradient[data-v-7dbaddd8]{background-image:var(--bs-gradient)!important}.user-select-all[data-v-7dbaddd8]{-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.user-select-auto[data-v-7dbaddd8]{-webkit-user-select:auto!important;-moz-user-select:auto!important;user-select:auto!important}.user-select-none[data-v-7dbaddd8]{-webkit-user-select:none!important;-moz-user-select:none!important;user-select:none!important}.pe-none[data-v-7dbaddd8]{pointer-events:none!important}.pe-auto[data-v-7dbaddd8]{pointer-events:auto!important}.rounded[data-v-7dbaddd8]{border-radius:.25rem!important}.rounded-0[data-v-7dbaddd8]{border-radius:0!important}.rounded-1[data-v-7dbaddd8]{border-radius:.2rem!important}.rounded-2[data-v-7dbaddd8]{border-radius:.25rem!important}.rounded-3[data-v-7dbaddd8]{border-radius:.3rem!important}.rounded-circle[data-v-7dbaddd8]{border-radius:50%!important}.rounded-pill[data-v-7dbaddd8]{border-radius:50rem!important}.rounded-top[data-v-7dbaddd8]{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.rounded-end[data-v-7dbaddd8]{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.rounded-bottom[data-v-7dbaddd8]{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-start[data-v-7dbaddd8]{border-bottom-left-radius:.25rem!important;border-top-left-radius:.25rem!important}.visible[data-v-7dbaddd8]{visibility:visible!important}.invisible[data-v-7dbaddd8]{visibility:hidden!important}@media (min-width:576px){.float-sm-start[data-v-7dbaddd8]{float:left!important}.float-sm-end[data-v-7dbaddd8]{float:right!important}.float-sm-none[data-v-7dbaddd8]{float:none!important}.d-sm-inline[data-v-7dbaddd8]{display:inline!important}.d-sm-inline-block[data-v-7dbaddd8]{display:inline-block!important}.d-sm-block[data-v-7dbaddd8]{display:block!important}.d-sm-grid[data-v-7dbaddd8]{display:grid!important}.d-sm-table[data-v-7dbaddd8]{display:table!important}.d-sm-table-row[data-v-7dbaddd8]{display:table-row!important}.d-sm-table-cell[data-v-7dbaddd8]{display:table-cell!important}.d-sm-flex[data-v-7dbaddd8]{display:flex!important}.d-sm-inline-flex[data-v-7dbaddd8]{display:inline-flex!important}.d-sm-none[data-v-7dbaddd8]{display:none!important}.flex-sm-fill[data-v-7dbaddd8]{flex:1 1 auto!important}.flex-sm-row[data-v-7dbaddd8]{flex-direction:row!important}.flex-sm-column[data-v-7dbaddd8]{flex-direction:column!important}.flex-sm-row-reverse[data-v-7dbaddd8]{flex-direction:row-reverse!important}.flex-sm-column-reverse[data-v-7dbaddd8]{flex-direction:column-reverse!important}.flex-sm-grow-0[data-v-7dbaddd8]{flex-grow:0!important}.flex-sm-grow-1[data-v-7dbaddd8]{flex-grow:1!important}.flex-sm-shrink-0[data-v-7dbaddd8]{flex-shrink:0!important}.flex-sm-shrink-1[data-v-7dbaddd8]{flex-shrink:1!important}.flex-sm-wrap[data-v-7dbaddd8]{flex-wrap:wrap!important}.flex-sm-nowrap[data-v-7dbaddd8]{flex-wrap:nowrap!important}.flex-sm-wrap-reverse[data-v-7dbaddd8]{flex-wrap:wrap-reverse!important}.gap-sm-0[data-v-7dbaddd8]{gap:0!important}.gap-sm-1[data-v-7dbaddd8]{gap:.25rem!important}.gap-sm-2[data-v-7dbaddd8]{gap:.5rem!important}.gap-sm-3[data-v-7dbaddd8]{gap:1rem!important}.gap-sm-4[data-v-7dbaddd8]{gap:1.5rem!important}.gap-sm-5[data-v-7dbaddd8]{gap:3rem!important}.justify-content-sm-start[data-v-7dbaddd8]{justify-content:flex-start!important}.justify-content-sm-end[data-v-7dbaddd8]{justify-content:flex-end!important}.justify-content-sm-center[data-v-7dbaddd8]{justify-content:center!important}.justify-content-sm-between[data-v-7dbaddd8]{justify-content:space-between!important}.justify-content-sm-around[data-v-7dbaddd8]{justify-content:space-around!important}.justify-content-sm-evenly[data-v-7dbaddd8]{justify-content:space-evenly!important}.align-items-sm-start[data-v-7dbaddd8]{align-items:flex-start!important}.align-items-sm-end[data-v-7dbaddd8]{align-items:flex-end!important}.align-items-sm-center[data-v-7dbaddd8]{align-items:center!important}.align-items-sm-baseline[data-v-7dbaddd8]{align-items:baseline!important}.align-items-sm-stretch[data-v-7dbaddd8]{align-items:stretch!important}.align-content-sm-start[data-v-7dbaddd8]{align-content:flex-start!important}.align-content-sm-end[data-v-7dbaddd8]{align-content:flex-end!important}.align-content-sm-center[data-v-7dbaddd8]{align-content:center!important}.align-content-sm-between[data-v-7dbaddd8]{align-content:space-between!important}.align-content-sm-around[data-v-7dbaddd8]{align-content:space-around!important}.align-content-sm-stretch[data-v-7dbaddd8]{align-content:stretch!important}.align-self-sm-auto[data-v-7dbaddd8]{align-self:auto!important}.align-self-sm-start[data-v-7dbaddd8]{align-self:flex-start!important}.align-self-sm-end[data-v-7dbaddd8]{align-self:flex-end!important}.align-self-sm-center[data-v-7dbaddd8]{align-self:center!important}.align-self-sm-baseline[data-v-7dbaddd8]{align-self:baseline!important}.align-self-sm-stretch[data-v-7dbaddd8]{align-self:stretch!important}.order-sm-first[data-v-7dbaddd8]{order:-1!important}.order-sm-0[data-v-7dbaddd8]{order:0!important}.order-sm-1[data-v-7dbaddd8]{order:1!important}.order-sm-2[data-v-7dbaddd8]{order:2!important}.order-sm-3[data-v-7dbaddd8]{order:3!important}.order-sm-4[data-v-7dbaddd8]{order:4!important}.order-sm-5[data-v-7dbaddd8]{order:5!important}.order-sm-last[data-v-7dbaddd8]{order:6!important}.m-sm-0[data-v-7dbaddd8]{margin:0!important}.m-sm-1[data-v-7dbaddd8]{margin:.25rem!important}.m-sm-2[data-v-7dbaddd8]{margin:.5rem!important}.m-sm-3[data-v-7dbaddd8]{margin:1rem!important}.m-sm-4[data-v-7dbaddd8]{margin:1.5rem!important}.m-sm-5[data-v-7dbaddd8]{margin:3rem!important}.m-sm-auto[data-v-7dbaddd8]{margin:auto!important}.mx-sm-0[data-v-7dbaddd8]{margin-right:0!important;margin-left:0!important}.mx-sm-1[data-v-7dbaddd8]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-sm-2[data-v-7dbaddd8]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-sm-3[data-v-7dbaddd8]{margin-right:1rem!important;margin-left:1rem!important}.mx-sm-4[data-v-7dbaddd8]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-sm-5[data-v-7dbaddd8]{margin-right:3rem!important;margin-left:3rem!important}.mx-sm-auto[data-v-7dbaddd8]{margin-right:auto!important;margin-left:auto!important}.my-sm-0[data-v-7dbaddd8]{margin-top:0!important;margin-bottom:0!important}.my-sm-1[data-v-7dbaddd8]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-sm-2[data-v-7dbaddd8]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-sm-3[data-v-7dbaddd8]{margin-top:1rem!important;margin-bottom:1rem!important}.my-sm-4[data-v-7dbaddd8]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-sm-5[data-v-7dbaddd8]{margin-top:3rem!important;margin-bottom:3rem!important}.my-sm-auto[data-v-7dbaddd8]{margin-top:auto!important;margin-bottom:auto!important}.mt-sm-0[data-v-7dbaddd8]{margin-top:0!important}.mt-sm-1[data-v-7dbaddd8]{margin-top:.25rem!important}.mt-sm-2[data-v-7dbaddd8]{margin-top:.5rem!important}.mt-sm-3[data-v-7dbaddd8]{margin-top:1rem!important}.mt-sm-4[data-v-7dbaddd8]{margin-top:1.5rem!important}.mt-sm-5[data-v-7dbaddd8]{margin-top:3rem!important}.mt-sm-auto[data-v-7dbaddd8]{margin-top:auto!important}.me-sm-0[data-v-7dbaddd8]{margin-right:0!important}.me-sm-1[data-v-7dbaddd8]{margin-right:.25rem!important}.me-sm-2[data-v-7dbaddd8]{margin-right:.5rem!important}.me-sm-3[data-v-7dbaddd8]{margin-right:1rem!important}.me-sm-4[data-v-7dbaddd8]{margin-right:1.5rem!important}.me-sm-5[data-v-7dbaddd8]{margin-right:3rem!important}.me-sm-auto[data-v-7dbaddd8]{margin-right:auto!important}.mb-sm-0[data-v-7dbaddd8]{margin-bottom:0!important}.mb-sm-1[data-v-7dbaddd8]{margin-bottom:.25rem!important}.mb-sm-2[data-v-7dbaddd8]{margin-bottom:.5rem!important}.mb-sm-3[data-v-7dbaddd8]{margin-bottom:1rem!important}.mb-sm-4[data-v-7dbaddd8]{margin-bottom:1.5rem!important}.mb-sm-5[data-v-7dbaddd8]{margin-bottom:3rem!important}.mb-sm-auto[data-v-7dbaddd8]{margin-bottom:auto!important}.ms-sm-0[data-v-7dbaddd8]{margin-left:0!important}.ms-sm-1[data-v-7dbaddd8]{margin-left:.25rem!important}.ms-sm-2[data-v-7dbaddd8]{margin-left:.5rem!important}.ms-sm-3[data-v-7dbaddd8]{margin-left:1rem!important}.ms-sm-4[data-v-7dbaddd8]{margin-left:1.5rem!important}.ms-sm-5[data-v-7dbaddd8]{margin-left:3rem!important}.ms-sm-auto[data-v-7dbaddd8]{margin-left:auto!important}.p-sm-0[data-v-7dbaddd8]{padding:0!important}.p-sm-1[data-v-7dbaddd8]{padding:.25rem!important}.p-sm-2[data-v-7dbaddd8]{padding:.5rem!important}.p-sm-3[data-v-7dbaddd8]{padding:1rem!important}.p-sm-4[data-v-7dbaddd8]{padding:1.5rem!important}.p-sm-5[data-v-7dbaddd8]{padding:3rem!important}.px-sm-0[data-v-7dbaddd8]{padding-right:0!important;padding-left:0!important}.px-sm-1[data-v-7dbaddd8]{padding-right:.25rem!important;padding-left:.25rem!important}.px-sm-2[data-v-7dbaddd8]{padding-right:.5rem!important;padding-left:.5rem!important}.px-sm-3[data-v-7dbaddd8]{padding-right:1rem!important;padding-left:1rem!important}.px-sm-4[data-v-7dbaddd8]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-sm-5[data-v-7dbaddd8]{padding-right:3rem!important;padding-left:3rem!important}.py-sm-0[data-v-7dbaddd8]{padding-top:0!important;padding-bottom:0!important}.py-sm-1[data-v-7dbaddd8]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-sm-2[data-v-7dbaddd8]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-sm-3[data-v-7dbaddd8]{padding-top:1rem!important;padding-bottom:1rem!important}.py-sm-4[data-v-7dbaddd8]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-sm-5[data-v-7dbaddd8]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-sm-0[data-v-7dbaddd8]{padding-top:0!important}.pt-sm-1[data-v-7dbaddd8]{padding-top:.25rem!important}.pt-sm-2[data-v-7dbaddd8]{padding-top:.5rem!important}.pt-sm-3[data-v-7dbaddd8]{padding-top:1rem!important}.pt-sm-4[data-v-7dbaddd8]{padding-top:1.5rem!important}.pt-sm-5[data-v-7dbaddd8]{padding-top:3rem!important}.pe-sm-0[data-v-7dbaddd8]{padding-right:0!important}.pe-sm-1[data-v-7dbaddd8]{padding-right:.25rem!important}.pe-sm-2[data-v-7dbaddd8]{padding-right:.5rem!important}.pe-sm-3[data-v-7dbaddd8]{padding-right:1rem!important}.pe-sm-4[data-v-7dbaddd8]{padding-right:1.5rem!important}.pe-sm-5[data-v-7dbaddd8]{padding-right:3rem!important}.pb-sm-0[data-v-7dbaddd8]{padding-bottom:0!important}.pb-sm-1[data-v-7dbaddd8]{padding-bottom:.25rem!important}.pb-sm-2[data-v-7dbaddd8]{padding-bottom:.5rem!important}.pb-sm-3[data-v-7dbaddd8]{padding-bottom:1rem!important}.pb-sm-4[data-v-7dbaddd8]{padding-bottom:1.5rem!important}.pb-sm-5[data-v-7dbaddd8]{padding-bottom:3rem!important}.ps-sm-0[data-v-7dbaddd8]{padding-left:0!important}.ps-sm-1[data-v-7dbaddd8]{padding-left:.25rem!important}.ps-sm-2[data-v-7dbaddd8]{padding-left:.5rem!important}.ps-sm-3[data-v-7dbaddd8]{padding-left:1rem!important}.ps-sm-4[data-v-7dbaddd8]{padding-left:1.5rem!important}.ps-sm-5[data-v-7dbaddd8]{padding-left:3rem!important}.text-sm-start[data-v-7dbaddd8]{text-align:left!important}.text-sm-end[data-v-7dbaddd8]{text-align:right!important}.text-sm-center[data-v-7dbaddd8]{text-align:center!important}}@media (min-width:768px){.float-md-start[data-v-7dbaddd8]{float:left!important}.float-md-end[data-v-7dbaddd8]{float:right!important}.float-md-none[data-v-7dbaddd8]{float:none!important}.d-md-inline[data-v-7dbaddd8]{display:inline!important}.d-md-inline-block[data-v-7dbaddd8]{display:inline-block!important}.d-md-block[data-v-7dbaddd8]{display:block!important}.d-md-grid[data-v-7dbaddd8]{display:grid!important}.d-md-table[data-v-7dbaddd8]{display:table!important}.d-md-table-row[data-v-7dbaddd8]{display:table-row!important}.d-md-table-cell[data-v-7dbaddd8]{display:table-cell!important}.d-md-flex[data-v-7dbaddd8]{display:flex!important}.d-md-inline-flex[data-v-7dbaddd8]{display:inline-flex!important}.d-md-none[data-v-7dbaddd8]{display:none!important}.flex-md-fill[data-v-7dbaddd8]{flex:1 1 auto!important}.flex-md-row[data-v-7dbaddd8]{flex-direction:row!important}.flex-md-column[data-v-7dbaddd8]{flex-direction:column!important}.flex-md-row-reverse[data-v-7dbaddd8]{flex-direction:row-reverse!important}.flex-md-column-reverse[data-v-7dbaddd8]{flex-direction:column-reverse!important}.flex-md-grow-0[data-v-7dbaddd8]{flex-grow:0!important}.flex-md-grow-1[data-v-7dbaddd8]{flex-grow:1!important}.flex-md-shrink-0[data-v-7dbaddd8]{flex-shrink:0!important}.flex-md-shrink-1[data-v-7dbaddd8]{flex-shrink:1!important}.flex-md-wrap[data-v-7dbaddd8]{flex-wrap:wrap!important}.flex-md-nowrap[data-v-7dbaddd8]{flex-wrap:nowrap!important}.flex-md-wrap-reverse[data-v-7dbaddd8]{flex-wrap:wrap-reverse!important}.gap-md-0[data-v-7dbaddd8]{gap:0!important}.gap-md-1[data-v-7dbaddd8]{gap:.25rem!important}.gap-md-2[data-v-7dbaddd8]{gap:.5rem!important}.gap-md-3[data-v-7dbaddd8]{gap:1rem!important}.gap-md-4[data-v-7dbaddd8]{gap:1.5rem!important}.gap-md-5[data-v-7dbaddd8]{gap:3rem!important}.justify-content-md-start[data-v-7dbaddd8]{justify-content:flex-start!important}.justify-content-md-end[data-v-7dbaddd8]{justify-content:flex-end!important}.justify-content-md-center[data-v-7dbaddd8]{justify-content:center!important}.justify-content-md-between[data-v-7dbaddd8]{justify-content:space-between!important}.justify-content-md-around[data-v-7dbaddd8]{justify-content:space-around!important}.justify-content-md-evenly[data-v-7dbaddd8]{justify-content:space-evenly!important}.align-items-md-start[data-v-7dbaddd8]{align-items:flex-start!important}.align-items-md-end[data-v-7dbaddd8]{align-items:flex-end!important}.align-items-md-center[data-v-7dbaddd8]{align-items:center!important}.align-items-md-baseline[data-v-7dbaddd8]{align-items:baseline!important}.align-items-md-stretch[data-v-7dbaddd8]{align-items:stretch!important}.align-content-md-start[data-v-7dbaddd8]{align-content:flex-start!important}.align-content-md-end[data-v-7dbaddd8]{align-content:flex-end!important}.align-content-md-center[data-v-7dbaddd8]{align-content:center!important}.align-content-md-between[data-v-7dbaddd8]{align-content:space-between!important}.align-content-md-around[data-v-7dbaddd8]{align-content:space-around!important}.align-content-md-stretch[data-v-7dbaddd8]{align-content:stretch!important}.align-self-md-auto[data-v-7dbaddd8]{align-self:auto!important}.align-self-md-start[data-v-7dbaddd8]{align-self:flex-start!important}.align-self-md-end[data-v-7dbaddd8]{align-self:flex-end!important}.align-self-md-center[data-v-7dbaddd8]{align-self:center!important}.align-self-md-baseline[data-v-7dbaddd8]{align-self:baseline!important}.align-self-md-stretch[data-v-7dbaddd8]{align-self:stretch!important}.order-md-first[data-v-7dbaddd8]{order:-1!important}.order-md-0[data-v-7dbaddd8]{order:0!important}.order-md-1[data-v-7dbaddd8]{order:1!important}.order-md-2[data-v-7dbaddd8]{order:2!important}.order-md-3[data-v-7dbaddd8]{order:3!important}.order-md-4[data-v-7dbaddd8]{order:4!important}.order-md-5[data-v-7dbaddd8]{order:5!important}.order-md-last[data-v-7dbaddd8]{order:6!important}.m-md-0[data-v-7dbaddd8]{margin:0!important}.m-md-1[data-v-7dbaddd8]{margin:.25rem!important}.m-md-2[data-v-7dbaddd8]{margin:.5rem!important}.m-md-3[data-v-7dbaddd8]{margin:1rem!important}.m-md-4[data-v-7dbaddd8]{margin:1.5rem!important}.m-md-5[data-v-7dbaddd8]{margin:3rem!important}.m-md-auto[data-v-7dbaddd8]{margin:auto!important}.mx-md-0[data-v-7dbaddd8]{margin-right:0!important;margin-left:0!important}.mx-md-1[data-v-7dbaddd8]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-md-2[data-v-7dbaddd8]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-md-3[data-v-7dbaddd8]{margin-right:1rem!important;margin-left:1rem!important}.mx-md-4[data-v-7dbaddd8]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-md-5[data-v-7dbaddd8]{margin-right:3rem!important;margin-left:3rem!important}.mx-md-auto[data-v-7dbaddd8]{margin-right:auto!important;margin-left:auto!important}.my-md-0[data-v-7dbaddd8]{margin-top:0!important;margin-bottom:0!important}.my-md-1[data-v-7dbaddd8]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-md-2[data-v-7dbaddd8]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-md-3[data-v-7dbaddd8]{margin-top:1rem!important;margin-bottom:1rem!important}.my-md-4[data-v-7dbaddd8]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-md-5[data-v-7dbaddd8]{margin-top:3rem!important;margin-bottom:3rem!important}.my-md-auto[data-v-7dbaddd8]{margin-top:auto!important;margin-bottom:auto!important}.mt-md-0[data-v-7dbaddd8]{margin-top:0!important}.mt-md-1[data-v-7dbaddd8]{margin-top:.25rem!important}.mt-md-2[data-v-7dbaddd8]{margin-top:.5rem!important}.mt-md-3[data-v-7dbaddd8]{margin-top:1rem!important}.mt-md-4[data-v-7dbaddd8]{margin-top:1.5rem!important}.mt-md-5[data-v-7dbaddd8]{margin-top:3rem!important}.mt-md-auto[data-v-7dbaddd8]{margin-top:auto!important}.me-md-0[data-v-7dbaddd8]{margin-right:0!important}.me-md-1[data-v-7dbaddd8]{margin-right:.25rem!important}.me-md-2[data-v-7dbaddd8]{margin-right:.5rem!important}.me-md-3[data-v-7dbaddd8]{margin-right:1rem!important}.me-md-4[data-v-7dbaddd8]{margin-right:1.5rem!important}.me-md-5[data-v-7dbaddd8]{margin-right:3rem!important}.me-md-auto[data-v-7dbaddd8]{margin-right:auto!important}.mb-md-0[data-v-7dbaddd8]{margin-bottom:0!important}.mb-md-1[data-v-7dbaddd8]{margin-bottom:.25rem!important}.mb-md-2[data-v-7dbaddd8]{margin-bottom:.5rem!important}.mb-md-3[data-v-7dbaddd8]{margin-bottom:1rem!important}.mb-md-4[data-v-7dbaddd8]{margin-bottom:1.5rem!important}.mb-md-5[data-v-7dbaddd8]{margin-bottom:3rem!important}.mb-md-auto[data-v-7dbaddd8]{margin-bottom:auto!important}.ms-md-0[data-v-7dbaddd8]{margin-left:0!important}.ms-md-1[data-v-7dbaddd8]{margin-left:.25rem!important}.ms-md-2[data-v-7dbaddd8]{margin-left:.5rem!important}.ms-md-3[data-v-7dbaddd8]{margin-left:1rem!important}.ms-md-4[data-v-7dbaddd8]{margin-left:1.5rem!important}.ms-md-5[data-v-7dbaddd8]{margin-left:3rem!important}.ms-md-auto[data-v-7dbaddd8]{margin-left:auto!important}.p-md-0[data-v-7dbaddd8]{padding:0!important}.p-md-1[data-v-7dbaddd8]{padding:.25rem!important}.p-md-2[data-v-7dbaddd8]{padding:.5rem!important}.p-md-3[data-v-7dbaddd8]{padding:1rem!important}.p-md-4[data-v-7dbaddd8]{padding:1.5rem!important}.p-md-5[data-v-7dbaddd8]{padding:3rem!important}.px-md-0[data-v-7dbaddd8]{padding-right:0!important;padding-left:0!important}.px-md-1[data-v-7dbaddd8]{padding-right:.25rem!important;padding-left:.25rem!important}.px-md-2[data-v-7dbaddd8]{padding-right:.5rem!important;padding-left:.5rem!important}.px-md-3[data-v-7dbaddd8]{padding-right:1rem!important;padding-left:1rem!important}.px-md-4[data-v-7dbaddd8]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-md-5[data-v-7dbaddd8]{padding-right:3rem!important;padding-left:3rem!important}.py-md-0[data-v-7dbaddd8]{padding-top:0!important;padding-bottom:0!important}.py-md-1[data-v-7dbaddd8]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-md-2[data-v-7dbaddd8]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-md-3[data-v-7dbaddd8]{padding-top:1rem!important;padding-bottom:1rem!important}.py-md-4[data-v-7dbaddd8]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-md-5[data-v-7dbaddd8]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-md-0[data-v-7dbaddd8]{padding-top:0!important}.pt-md-1[data-v-7dbaddd8]{padding-top:.25rem!important}.pt-md-2[data-v-7dbaddd8]{padding-top:.5rem!important}.pt-md-3[data-v-7dbaddd8]{padding-top:1rem!important}.pt-md-4[data-v-7dbaddd8]{padding-top:1.5rem!important}.pt-md-5[data-v-7dbaddd8]{padding-top:3rem!important}.pe-md-0[data-v-7dbaddd8]{padding-right:0!important}.pe-md-1[data-v-7dbaddd8]{padding-right:.25rem!important}.pe-md-2[data-v-7dbaddd8]{padding-right:.5rem!important}.pe-md-3[data-v-7dbaddd8]{padding-right:1rem!important}.pe-md-4[data-v-7dbaddd8]{padding-right:1.5rem!important}.pe-md-5[data-v-7dbaddd8]{padding-right:3rem!important}.pb-md-0[data-v-7dbaddd8]{padding-bottom:0!important}.pb-md-1[data-v-7dbaddd8]{padding-bottom:.25rem!important}.pb-md-2[data-v-7dbaddd8]{padding-bottom:.5rem!important}.pb-md-3[data-v-7dbaddd8]{padding-bottom:1rem!important}.pb-md-4[data-v-7dbaddd8]{padding-bottom:1.5rem!important}.pb-md-5[data-v-7dbaddd8]{padding-bottom:3rem!important}.ps-md-0[data-v-7dbaddd8]{padding-left:0!important}.ps-md-1[data-v-7dbaddd8]{padding-left:.25rem!important}.ps-md-2[data-v-7dbaddd8]{padding-left:.5rem!important}.ps-md-3[data-v-7dbaddd8]{padding-left:1rem!important}.ps-md-4[data-v-7dbaddd8]{padding-left:1.5rem!important}.ps-md-5[data-v-7dbaddd8]{padding-left:3rem!important}.text-md-start[data-v-7dbaddd8]{text-align:left!important}.text-md-end[data-v-7dbaddd8]{text-align:right!important}.text-md-center[data-v-7dbaddd8]{text-align:center!important}}@media (min-width:992px){.float-lg-start[data-v-7dbaddd8]{float:left!important}.float-lg-end[data-v-7dbaddd8]{float:right!important}.float-lg-none[data-v-7dbaddd8]{float:none!important}.d-lg-inline[data-v-7dbaddd8]{display:inline!important}.d-lg-inline-block[data-v-7dbaddd8]{display:inline-block!important}.d-lg-block[data-v-7dbaddd8]{display:block!important}.d-lg-grid[data-v-7dbaddd8]{display:grid!important}.d-lg-table[data-v-7dbaddd8]{display:table!important}.d-lg-table-row[data-v-7dbaddd8]{display:table-row!important}.d-lg-table-cell[data-v-7dbaddd8]{display:table-cell!important}.d-lg-flex[data-v-7dbaddd8]{display:flex!important}.d-lg-inline-flex[data-v-7dbaddd8]{display:inline-flex!important}.d-lg-none[data-v-7dbaddd8]{display:none!important}.flex-lg-fill[data-v-7dbaddd8]{flex:1 1 auto!important}.flex-lg-row[data-v-7dbaddd8]{flex-direction:row!important}.flex-lg-column[data-v-7dbaddd8]{flex-direction:column!important}.flex-lg-row-reverse[data-v-7dbaddd8]{flex-direction:row-reverse!important}.flex-lg-column-reverse[data-v-7dbaddd8]{flex-direction:column-reverse!important}.flex-lg-grow-0[data-v-7dbaddd8]{flex-grow:0!important}.flex-lg-grow-1[data-v-7dbaddd8]{flex-grow:1!important}.flex-lg-shrink-0[data-v-7dbaddd8]{flex-shrink:0!important}.flex-lg-shrink-1[data-v-7dbaddd8]{flex-shrink:1!important}.flex-lg-wrap[data-v-7dbaddd8]{flex-wrap:wrap!important}.flex-lg-nowrap[data-v-7dbaddd8]{flex-wrap:nowrap!important}.flex-lg-wrap-reverse[data-v-7dbaddd8]{flex-wrap:wrap-reverse!important}.gap-lg-0[data-v-7dbaddd8]{gap:0!important}.gap-lg-1[data-v-7dbaddd8]{gap:.25rem!important}.gap-lg-2[data-v-7dbaddd8]{gap:.5rem!important}.gap-lg-3[data-v-7dbaddd8]{gap:1rem!important}.gap-lg-4[data-v-7dbaddd8]{gap:1.5rem!important}.gap-lg-5[data-v-7dbaddd8]{gap:3rem!important}.justify-content-lg-start[data-v-7dbaddd8]{justify-content:flex-start!important}.justify-content-lg-end[data-v-7dbaddd8]{justify-content:flex-end!important}.justify-content-lg-center[data-v-7dbaddd8]{justify-content:center!important}.justify-content-lg-between[data-v-7dbaddd8]{justify-content:space-between!important}.justify-content-lg-around[data-v-7dbaddd8]{justify-content:space-around!important}.justify-content-lg-evenly[data-v-7dbaddd8]{justify-content:space-evenly!important}.align-items-lg-start[data-v-7dbaddd8]{align-items:flex-start!important}.align-items-lg-end[data-v-7dbaddd8]{align-items:flex-end!important}.align-items-lg-center[data-v-7dbaddd8]{align-items:center!important}.align-items-lg-baseline[data-v-7dbaddd8]{align-items:baseline!important}.align-items-lg-stretch[data-v-7dbaddd8]{align-items:stretch!important}.align-content-lg-start[data-v-7dbaddd8]{align-content:flex-start!important}.align-content-lg-end[data-v-7dbaddd8]{align-content:flex-end!important}.align-content-lg-center[data-v-7dbaddd8]{align-content:center!important}.align-content-lg-between[data-v-7dbaddd8]{align-content:space-between!important}.align-content-lg-around[data-v-7dbaddd8]{align-content:space-around!important}.align-content-lg-stretch[data-v-7dbaddd8]{align-content:stretch!important}.align-self-lg-auto[data-v-7dbaddd8]{align-self:auto!important}.align-self-lg-start[data-v-7dbaddd8]{align-self:flex-start!important}.align-self-lg-end[data-v-7dbaddd8]{align-self:flex-end!important}.align-self-lg-center[data-v-7dbaddd8]{align-self:center!important}.align-self-lg-baseline[data-v-7dbaddd8]{align-self:baseline!important}.align-self-lg-stretch[data-v-7dbaddd8]{align-self:stretch!important}.order-lg-first[data-v-7dbaddd8]{order:-1!important}.order-lg-0[data-v-7dbaddd8]{order:0!important}.order-lg-1[data-v-7dbaddd8]{order:1!important}.order-lg-2[data-v-7dbaddd8]{order:2!important}.order-lg-3[data-v-7dbaddd8]{order:3!important}.order-lg-4[data-v-7dbaddd8]{order:4!important}.order-lg-5[data-v-7dbaddd8]{order:5!important}.order-lg-last[data-v-7dbaddd8]{order:6!important}.m-lg-0[data-v-7dbaddd8]{margin:0!important}.m-lg-1[data-v-7dbaddd8]{margin:.25rem!important}.m-lg-2[data-v-7dbaddd8]{margin:.5rem!important}.m-lg-3[data-v-7dbaddd8]{margin:1rem!important}.m-lg-4[data-v-7dbaddd8]{margin:1.5rem!important}.m-lg-5[data-v-7dbaddd8]{margin:3rem!important}.m-lg-auto[data-v-7dbaddd8]{margin:auto!important}.mx-lg-0[data-v-7dbaddd8]{margin-right:0!important;margin-left:0!important}.mx-lg-1[data-v-7dbaddd8]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-lg-2[data-v-7dbaddd8]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-lg-3[data-v-7dbaddd8]{margin-right:1rem!important;margin-left:1rem!important}.mx-lg-4[data-v-7dbaddd8]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-lg-5[data-v-7dbaddd8]{margin-right:3rem!important;margin-left:3rem!important}.mx-lg-auto[data-v-7dbaddd8]{margin-right:auto!important;margin-left:auto!important}.my-lg-0[data-v-7dbaddd8]{margin-top:0!important;margin-bottom:0!important}.my-lg-1[data-v-7dbaddd8]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-lg-2[data-v-7dbaddd8]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-lg-3[data-v-7dbaddd8]{margin-top:1rem!important;margin-bottom:1rem!important}.my-lg-4[data-v-7dbaddd8]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-lg-5[data-v-7dbaddd8]{margin-top:3rem!important;margin-bottom:3rem!important}.my-lg-auto[data-v-7dbaddd8]{margin-top:auto!important;margin-bottom:auto!important}.mt-lg-0[data-v-7dbaddd8]{margin-top:0!important}.mt-lg-1[data-v-7dbaddd8]{margin-top:.25rem!important}.mt-lg-2[data-v-7dbaddd8]{margin-top:.5rem!important}.mt-lg-3[data-v-7dbaddd8]{margin-top:1rem!important}.mt-lg-4[data-v-7dbaddd8]{margin-top:1.5rem!important}.mt-lg-5[data-v-7dbaddd8]{margin-top:3rem!important}.mt-lg-auto[data-v-7dbaddd8]{margin-top:auto!important}.me-lg-0[data-v-7dbaddd8]{margin-right:0!important}.me-lg-1[data-v-7dbaddd8]{margin-right:.25rem!important}.me-lg-2[data-v-7dbaddd8]{margin-right:.5rem!important}.me-lg-3[data-v-7dbaddd8]{margin-right:1rem!important}.me-lg-4[data-v-7dbaddd8]{margin-right:1.5rem!important}.me-lg-5[data-v-7dbaddd8]{margin-right:3rem!important}.me-lg-auto[data-v-7dbaddd8]{margin-right:auto!important}.mb-lg-0[data-v-7dbaddd8]{margin-bottom:0!important}.mb-lg-1[data-v-7dbaddd8]{margin-bottom:.25rem!important}.mb-lg-2[data-v-7dbaddd8]{margin-bottom:.5rem!important}.mb-lg-3[data-v-7dbaddd8]{margin-bottom:1rem!important}.mb-lg-4[data-v-7dbaddd8]{margin-bottom:1.5rem!important}.mb-lg-5[data-v-7dbaddd8]{margin-bottom:3rem!important}.mb-lg-auto[data-v-7dbaddd8]{margin-bottom:auto!important}.ms-lg-0[data-v-7dbaddd8]{margin-left:0!important}.ms-lg-1[data-v-7dbaddd8]{margin-left:.25rem!important}.ms-lg-2[data-v-7dbaddd8]{margin-left:.5rem!important}.ms-lg-3[data-v-7dbaddd8]{margin-left:1rem!important}.ms-lg-4[data-v-7dbaddd8]{margin-left:1.5rem!important}.ms-lg-5[data-v-7dbaddd8]{margin-left:3rem!important}.ms-lg-auto[data-v-7dbaddd8]{margin-left:auto!important}.p-lg-0[data-v-7dbaddd8]{padding:0!important}.p-lg-1[data-v-7dbaddd8]{padding:.25rem!important}.p-lg-2[data-v-7dbaddd8]{padding:.5rem!important}.p-lg-3[data-v-7dbaddd8]{padding:1rem!important}.p-lg-4[data-v-7dbaddd8]{padding:1.5rem!important}.p-lg-5[data-v-7dbaddd8]{padding:3rem!important}.px-lg-0[data-v-7dbaddd8]{padding-right:0!important;padding-left:0!important}.px-lg-1[data-v-7dbaddd8]{padding-right:.25rem!important;padding-left:.25rem!important}.px-lg-2[data-v-7dbaddd8]{padding-right:.5rem!important;padding-left:.5rem!important}.px-lg-3[data-v-7dbaddd8]{padding-right:1rem!important;padding-left:1rem!important}.px-lg-4[data-v-7dbaddd8]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-lg-5[data-v-7dbaddd8]{padding-right:3rem!important;padding-left:3rem!important}.py-lg-0[data-v-7dbaddd8]{padding-top:0!important;padding-bottom:0!important}.py-lg-1[data-v-7dbaddd8]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-lg-2[data-v-7dbaddd8]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-lg-3[data-v-7dbaddd8]{padding-top:1rem!important;padding-bottom:1rem!important}.py-lg-4[data-v-7dbaddd8]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-lg-5[data-v-7dbaddd8]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-lg-0[data-v-7dbaddd8]{padding-top:0!important}.pt-lg-1[data-v-7dbaddd8]{padding-top:.25rem!important}.pt-lg-2[data-v-7dbaddd8]{padding-top:.5rem!important}.pt-lg-3[data-v-7dbaddd8]{padding-top:1rem!important}.pt-lg-4[data-v-7dbaddd8]{padding-top:1.5rem!important}.pt-lg-5[data-v-7dbaddd8]{padding-top:3rem!important}.pe-lg-0[data-v-7dbaddd8]{padding-right:0!important}.pe-lg-1[data-v-7dbaddd8]{padding-right:.25rem!important}.pe-lg-2[data-v-7dbaddd8]{padding-right:.5rem!important}.pe-lg-3[data-v-7dbaddd8]{padding-right:1rem!important}.pe-lg-4[data-v-7dbaddd8]{padding-right:1.5rem!important}.pe-lg-5[data-v-7dbaddd8]{padding-right:3rem!important}.pb-lg-0[data-v-7dbaddd8]{padding-bottom:0!important}.pb-lg-1[data-v-7dbaddd8]{padding-bottom:.25rem!important}.pb-lg-2[data-v-7dbaddd8]{padding-bottom:.5rem!important}.pb-lg-3[data-v-7dbaddd8]{padding-bottom:1rem!important}.pb-lg-4[data-v-7dbaddd8]{padding-bottom:1.5rem!important}.pb-lg-5[data-v-7dbaddd8]{padding-bottom:3rem!important}.ps-lg-0[data-v-7dbaddd8]{padding-left:0!important}.ps-lg-1[data-v-7dbaddd8]{padding-left:.25rem!important}.ps-lg-2[data-v-7dbaddd8]{padding-left:.5rem!important}.ps-lg-3[data-v-7dbaddd8]{padding-left:1rem!important}.ps-lg-4[data-v-7dbaddd8]{padding-left:1.5rem!important}.ps-lg-5[data-v-7dbaddd8]{padding-left:3rem!important}.text-lg-start[data-v-7dbaddd8]{text-align:left!important}.text-lg-end[data-v-7dbaddd8]{text-align:right!important}.text-lg-center[data-v-7dbaddd8]{text-align:center!important}}@media (min-width:1200px){.float-xl-start[data-v-7dbaddd8]{float:left!important}.float-xl-end[data-v-7dbaddd8]{float:right!important}.float-xl-none[data-v-7dbaddd8]{float:none!important}.d-xl-inline[data-v-7dbaddd8]{display:inline!important}.d-xl-inline-block[data-v-7dbaddd8]{display:inline-block!important}.d-xl-block[data-v-7dbaddd8]{display:block!important}.d-xl-grid[data-v-7dbaddd8]{display:grid!important}.d-xl-table[data-v-7dbaddd8]{display:table!important}.d-xl-table-row[data-v-7dbaddd8]{display:table-row!important}.d-xl-table-cell[data-v-7dbaddd8]{display:table-cell!important}.d-xl-flex[data-v-7dbaddd8]{display:flex!important}.d-xl-inline-flex[data-v-7dbaddd8]{display:inline-flex!important}.d-xl-none[data-v-7dbaddd8]{display:none!important}.flex-xl-fill[data-v-7dbaddd8]{flex:1 1 auto!important}.flex-xl-row[data-v-7dbaddd8]{flex-direction:row!important}.flex-xl-column[data-v-7dbaddd8]{flex-direction:column!important}.flex-xl-row-reverse[data-v-7dbaddd8]{flex-direction:row-reverse!important}.flex-xl-column-reverse[data-v-7dbaddd8]{flex-direction:column-reverse!important}.flex-xl-grow-0[data-v-7dbaddd8]{flex-grow:0!important}.flex-xl-grow-1[data-v-7dbaddd8]{flex-grow:1!important}.flex-xl-shrink-0[data-v-7dbaddd8]{flex-shrink:0!important}.flex-xl-shrink-1[data-v-7dbaddd8]{flex-shrink:1!important}.flex-xl-wrap[data-v-7dbaddd8]{flex-wrap:wrap!important}.flex-xl-nowrap[data-v-7dbaddd8]{flex-wrap:nowrap!important}.flex-xl-wrap-reverse[data-v-7dbaddd8]{flex-wrap:wrap-reverse!important}.gap-xl-0[data-v-7dbaddd8]{gap:0!important}.gap-xl-1[data-v-7dbaddd8]{gap:.25rem!important}.gap-xl-2[data-v-7dbaddd8]{gap:.5rem!important}.gap-xl-3[data-v-7dbaddd8]{gap:1rem!important}.gap-xl-4[data-v-7dbaddd8]{gap:1.5rem!important}.gap-xl-5[data-v-7dbaddd8]{gap:3rem!important}.justify-content-xl-start[data-v-7dbaddd8]{justify-content:flex-start!important}.justify-content-xl-end[data-v-7dbaddd8]{justify-content:flex-end!important}.justify-content-xl-center[data-v-7dbaddd8]{justify-content:center!important}.justify-content-xl-between[data-v-7dbaddd8]{justify-content:space-between!important}.justify-content-xl-around[data-v-7dbaddd8]{justify-content:space-around!important}.justify-content-xl-evenly[data-v-7dbaddd8]{justify-content:space-evenly!important}.align-items-xl-start[data-v-7dbaddd8]{align-items:flex-start!important}.align-items-xl-end[data-v-7dbaddd8]{align-items:flex-end!important}.align-items-xl-center[data-v-7dbaddd8]{align-items:center!important}.align-items-xl-baseline[data-v-7dbaddd8]{align-items:baseline!important}.align-items-xl-stretch[data-v-7dbaddd8]{align-items:stretch!important}.align-content-xl-start[data-v-7dbaddd8]{align-content:flex-start!important}.align-content-xl-end[data-v-7dbaddd8]{align-content:flex-end!important}.align-content-xl-center[data-v-7dbaddd8]{align-content:center!important}.align-content-xl-between[data-v-7dbaddd8]{align-content:space-between!important}.align-content-xl-around[data-v-7dbaddd8]{align-content:space-around!important}.align-content-xl-stretch[data-v-7dbaddd8]{align-content:stretch!important}.align-self-xl-auto[data-v-7dbaddd8]{align-self:auto!important}.align-self-xl-start[data-v-7dbaddd8]{align-self:flex-start!important}.align-self-xl-end[data-v-7dbaddd8]{align-self:flex-end!important}.align-self-xl-center[data-v-7dbaddd8]{align-self:center!important}.align-self-xl-baseline[data-v-7dbaddd8]{align-self:baseline!important}.align-self-xl-stretch[data-v-7dbaddd8]{align-self:stretch!important}.order-xl-first[data-v-7dbaddd8]{order:-1!important}.order-xl-0[data-v-7dbaddd8]{order:0!important}.order-xl-1[data-v-7dbaddd8]{order:1!important}.order-xl-2[data-v-7dbaddd8]{order:2!important}.order-xl-3[data-v-7dbaddd8]{order:3!important}.order-xl-4[data-v-7dbaddd8]{order:4!important}.order-xl-5[data-v-7dbaddd8]{order:5!important}.order-xl-last[data-v-7dbaddd8]{order:6!important}.m-xl-0[data-v-7dbaddd8]{margin:0!important}.m-xl-1[data-v-7dbaddd8]{margin:.25rem!important}.m-xl-2[data-v-7dbaddd8]{margin:.5rem!important}.m-xl-3[data-v-7dbaddd8]{margin:1rem!important}.m-xl-4[data-v-7dbaddd8]{margin:1.5rem!important}.m-xl-5[data-v-7dbaddd8]{margin:3rem!important}.m-xl-auto[data-v-7dbaddd8]{margin:auto!important}.mx-xl-0[data-v-7dbaddd8]{margin-right:0!important;margin-left:0!important}.mx-xl-1[data-v-7dbaddd8]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xl-2[data-v-7dbaddd8]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xl-3[data-v-7dbaddd8]{margin-right:1rem!important;margin-left:1rem!important}.mx-xl-4[data-v-7dbaddd8]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xl-5[data-v-7dbaddd8]{margin-right:3rem!important;margin-left:3rem!important}.mx-xl-auto[data-v-7dbaddd8]{margin-right:auto!important;margin-left:auto!important}.my-xl-0[data-v-7dbaddd8]{margin-top:0!important;margin-bottom:0!important}.my-xl-1[data-v-7dbaddd8]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xl-2[data-v-7dbaddd8]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xl-3[data-v-7dbaddd8]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xl-4[data-v-7dbaddd8]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xl-5[data-v-7dbaddd8]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xl-auto[data-v-7dbaddd8]{margin-top:auto!important;margin-bottom:auto!important}.mt-xl-0[data-v-7dbaddd8]{margin-top:0!important}.mt-xl-1[data-v-7dbaddd8]{margin-top:.25rem!important}.mt-xl-2[data-v-7dbaddd8]{margin-top:.5rem!important}.mt-xl-3[data-v-7dbaddd8]{margin-top:1rem!important}.mt-xl-4[data-v-7dbaddd8]{margin-top:1.5rem!important}.mt-xl-5[data-v-7dbaddd8]{margin-top:3rem!important}.mt-xl-auto[data-v-7dbaddd8]{margin-top:auto!important}.me-xl-0[data-v-7dbaddd8]{margin-right:0!important}.me-xl-1[data-v-7dbaddd8]{margin-right:.25rem!important}.me-xl-2[data-v-7dbaddd8]{margin-right:.5rem!important}.me-xl-3[data-v-7dbaddd8]{margin-right:1rem!important}.me-xl-4[data-v-7dbaddd8]{margin-right:1.5rem!important}.me-xl-5[data-v-7dbaddd8]{margin-right:3rem!important}.me-xl-auto[data-v-7dbaddd8]{margin-right:auto!important}.mb-xl-0[data-v-7dbaddd8]{margin-bottom:0!important}.mb-xl-1[data-v-7dbaddd8]{margin-bottom:.25rem!important}.mb-xl-2[data-v-7dbaddd8]{margin-bottom:.5rem!important}.mb-xl-3[data-v-7dbaddd8]{margin-bottom:1rem!important}.mb-xl-4[data-v-7dbaddd8]{margin-bottom:1.5rem!important}.mb-xl-5[data-v-7dbaddd8]{margin-bottom:3rem!important}.mb-xl-auto[data-v-7dbaddd8]{margin-bottom:auto!important}.ms-xl-0[data-v-7dbaddd8]{margin-left:0!important}.ms-xl-1[data-v-7dbaddd8]{margin-left:.25rem!important}.ms-xl-2[data-v-7dbaddd8]{margin-left:.5rem!important}.ms-xl-3[data-v-7dbaddd8]{margin-left:1rem!important}.ms-xl-4[data-v-7dbaddd8]{margin-left:1.5rem!important}.ms-xl-5[data-v-7dbaddd8]{margin-left:3rem!important}.ms-xl-auto[data-v-7dbaddd8]{margin-left:auto!important}.p-xl-0[data-v-7dbaddd8]{padding:0!important}.p-xl-1[data-v-7dbaddd8]{padding:.25rem!important}.p-xl-2[data-v-7dbaddd8]{padding:.5rem!important}.p-xl-3[data-v-7dbaddd8]{padding:1rem!important}.p-xl-4[data-v-7dbaddd8]{padding:1.5rem!important}.p-xl-5[data-v-7dbaddd8]{padding:3rem!important}.px-xl-0[data-v-7dbaddd8]{padding-right:0!important;padding-left:0!important}.px-xl-1[data-v-7dbaddd8]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xl-2[data-v-7dbaddd8]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xl-3[data-v-7dbaddd8]{padding-right:1rem!important;padding-left:1rem!important}.px-xl-4[data-v-7dbaddd8]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xl-5[data-v-7dbaddd8]{padding-right:3rem!important;padding-left:3rem!important}.py-xl-0[data-v-7dbaddd8]{padding-top:0!important;padding-bottom:0!important}.py-xl-1[data-v-7dbaddd8]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xl-2[data-v-7dbaddd8]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xl-3[data-v-7dbaddd8]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xl-4[data-v-7dbaddd8]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xl-5[data-v-7dbaddd8]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xl-0[data-v-7dbaddd8]{padding-top:0!important}.pt-xl-1[data-v-7dbaddd8]{padding-top:.25rem!important}.pt-xl-2[data-v-7dbaddd8]{padding-top:.5rem!important}.pt-xl-3[data-v-7dbaddd8]{padding-top:1rem!important}.pt-xl-4[data-v-7dbaddd8]{padding-top:1.5rem!important}.pt-xl-5[data-v-7dbaddd8]{padding-top:3rem!important}.pe-xl-0[data-v-7dbaddd8]{padding-right:0!important}.pe-xl-1[data-v-7dbaddd8]{padding-right:.25rem!important}.pe-xl-2[data-v-7dbaddd8]{padding-right:.5rem!important}.pe-xl-3[data-v-7dbaddd8]{padding-right:1rem!important}.pe-xl-4[data-v-7dbaddd8]{padding-right:1.5rem!important}.pe-xl-5[data-v-7dbaddd8]{padding-right:3rem!important}.pb-xl-0[data-v-7dbaddd8]{padding-bottom:0!important}.pb-xl-1[data-v-7dbaddd8]{padding-bottom:.25rem!important}.pb-xl-2[data-v-7dbaddd8]{padding-bottom:.5rem!important}.pb-xl-3[data-v-7dbaddd8]{padding-bottom:1rem!important}.pb-xl-4[data-v-7dbaddd8]{padding-bottom:1.5rem!important}.pb-xl-5[data-v-7dbaddd8]{padding-bottom:3rem!important}.ps-xl-0[data-v-7dbaddd8]{padding-left:0!important}.ps-xl-1[data-v-7dbaddd8]{padding-left:.25rem!important}.ps-xl-2[data-v-7dbaddd8]{padding-left:.5rem!important}.ps-xl-3[data-v-7dbaddd8]{padding-left:1rem!important}.ps-xl-4[data-v-7dbaddd8]{padding-left:1.5rem!important}.ps-xl-5[data-v-7dbaddd8]{padding-left:3rem!important}.text-xl-start[data-v-7dbaddd8]{text-align:left!important}.text-xl-end[data-v-7dbaddd8]{text-align:right!important}.text-xl-center[data-v-7dbaddd8]{text-align:center!important}}@media (min-width:1400px){.float-xxl-start[data-v-7dbaddd8]{float:left!important}.float-xxl-end[data-v-7dbaddd8]{float:right!important}.float-xxl-none[data-v-7dbaddd8]{float:none!important}.d-xxl-inline[data-v-7dbaddd8]{display:inline!important}.d-xxl-inline-block[data-v-7dbaddd8]{display:inline-block!important}.d-xxl-block[data-v-7dbaddd8]{display:block!important}.d-xxl-grid[data-v-7dbaddd8]{display:grid!important}.d-xxl-table[data-v-7dbaddd8]{display:table!important}.d-xxl-table-row[data-v-7dbaddd8]{display:table-row!important}.d-xxl-table-cell[data-v-7dbaddd8]{display:table-cell!important}.d-xxl-flex[data-v-7dbaddd8]{display:flex!important}.d-xxl-inline-flex[data-v-7dbaddd8]{display:inline-flex!important}.d-xxl-none[data-v-7dbaddd8]{display:none!important}.flex-xxl-fill[data-v-7dbaddd8]{flex:1 1 auto!important}.flex-xxl-row[data-v-7dbaddd8]{flex-direction:row!important}.flex-xxl-column[data-v-7dbaddd8]{flex-direction:column!important}.flex-xxl-row-reverse[data-v-7dbaddd8]{flex-direction:row-reverse!important}.flex-xxl-column-reverse[data-v-7dbaddd8]{flex-direction:column-reverse!important}.flex-xxl-grow-0[data-v-7dbaddd8]{flex-grow:0!important}.flex-xxl-grow-1[data-v-7dbaddd8]{flex-grow:1!important}.flex-xxl-shrink-0[data-v-7dbaddd8]{flex-shrink:0!important}.flex-xxl-shrink-1[data-v-7dbaddd8]{flex-shrink:1!important}.flex-xxl-wrap[data-v-7dbaddd8]{flex-wrap:wrap!important}.flex-xxl-nowrap[data-v-7dbaddd8]{flex-wrap:nowrap!important}.flex-xxl-wrap-reverse[data-v-7dbaddd8]{flex-wrap:wrap-reverse!important}.gap-xxl-0[data-v-7dbaddd8]{gap:0!important}.gap-xxl-1[data-v-7dbaddd8]{gap:.25rem!important}.gap-xxl-2[data-v-7dbaddd8]{gap:.5rem!important}.gap-xxl-3[data-v-7dbaddd8]{gap:1rem!important}.gap-xxl-4[data-v-7dbaddd8]{gap:1.5rem!important}.gap-xxl-5[data-v-7dbaddd8]{gap:3rem!important}.justify-content-xxl-start[data-v-7dbaddd8]{justify-content:flex-start!important}.justify-content-xxl-end[data-v-7dbaddd8]{justify-content:flex-end!important}.justify-content-xxl-center[data-v-7dbaddd8]{justify-content:center!important}.justify-content-xxl-between[data-v-7dbaddd8]{justify-content:space-between!important}.justify-content-xxl-around[data-v-7dbaddd8]{justify-content:space-around!important}.justify-content-xxl-evenly[data-v-7dbaddd8]{justify-content:space-evenly!important}.align-items-xxl-start[data-v-7dbaddd8]{align-items:flex-start!important}.align-items-xxl-end[data-v-7dbaddd8]{align-items:flex-end!important}.align-items-xxl-center[data-v-7dbaddd8]{align-items:center!important}.align-items-xxl-baseline[data-v-7dbaddd8]{align-items:baseline!important}.align-items-xxl-stretch[data-v-7dbaddd8]{align-items:stretch!important}.align-content-xxl-start[data-v-7dbaddd8]{align-content:flex-start!important}.align-content-xxl-end[data-v-7dbaddd8]{align-content:flex-end!important}.align-content-xxl-center[data-v-7dbaddd8]{align-content:center!important}.align-content-xxl-between[data-v-7dbaddd8]{align-content:space-between!important}.align-content-xxl-around[data-v-7dbaddd8]{align-content:space-around!important}.align-content-xxl-stretch[data-v-7dbaddd8]{align-content:stretch!important}.align-self-xxl-auto[data-v-7dbaddd8]{align-self:auto!important}.align-self-xxl-start[data-v-7dbaddd8]{align-self:flex-start!important}.align-self-xxl-end[data-v-7dbaddd8]{align-self:flex-end!important}.align-self-xxl-center[data-v-7dbaddd8]{align-self:center!important}.align-self-xxl-baseline[data-v-7dbaddd8]{align-self:baseline!important}.align-self-xxl-stretch[data-v-7dbaddd8]{align-self:stretch!important}.order-xxl-first[data-v-7dbaddd8]{order:-1!important}.order-xxl-0[data-v-7dbaddd8]{order:0!important}.order-xxl-1[data-v-7dbaddd8]{order:1!important}.order-xxl-2[data-v-7dbaddd8]{order:2!important}.order-xxl-3[data-v-7dbaddd8]{order:3!important}.order-xxl-4[data-v-7dbaddd8]{order:4!important}.order-xxl-5[data-v-7dbaddd8]{order:5!important}.order-xxl-last[data-v-7dbaddd8]{order:6!important}.m-xxl-0[data-v-7dbaddd8]{margin:0!important}.m-xxl-1[data-v-7dbaddd8]{margin:.25rem!important}.m-xxl-2[data-v-7dbaddd8]{margin:.5rem!important}.m-xxl-3[data-v-7dbaddd8]{margin:1rem!important}.m-xxl-4[data-v-7dbaddd8]{margin:1.5rem!important}.m-xxl-5[data-v-7dbaddd8]{margin:3rem!important}.m-xxl-auto[data-v-7dbaddd8]{margin:auto!important}.mx-xxl-0[data-v-7dbaddd8]{margin-right:0!important;margin-left:0!important}.mx-xxl-1[data-v-7dbaddd8]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xxl-2[data-v-7dbaddd8]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xxl-3[data-v-7dbaddd8]{margin-right:1rem!important;margin-left:1rem!important}.mx-xxl-4[data-v-7dbaddd8]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xxl-5[data-v-7dbaddd8]{margin-right:3rem!important;margin-left:3rem!important}.mx-xxl-auto[data-v-7dbaddd8]{margin-right:auto!important;margin-left:auto!important}.my-xxl-0[data-v-7dbaddd8]{margin-top:0!important;margin-bottom:0!important}.my-xxl-1[data-v-7dbaddd8]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xxl-2[data-v-7dbaddd8]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xxl-3[data-v-7dbaddd8]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xxl-4[data-v-7dbaddd8]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xxl-5[data-v-7dbaddd8]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xxl-auto[data-v-7dbaddd8]{margin-top:auto!important;margin-bottom:auto!important}.mt-xxl-0[data-v-7dbaddd8]{margin-top:0!important}.mt-xxl-1[data-v-7dbaddd8]{margin-top:.25rem!important}.mt-xxl-2[data-v-7dbaddd8]{margin-top:.5rem!important}.mt-xxl-3[data-v-7dbaddd8]{margin-top:1rem!important}.mt-xxl-4[data-v-7dbaddd8]{margin-top:1.5rem!important}.mt-xxl-5[data-v-7dbaddd8]{margin-top:3rem!important}.mt-xxl-auto[data-v-7dbaddd8]{margin-top:auto!important}.me-xxl-0[data-v-7dbaddd8]{margin-right:0!important}.me-xxl-1[data-v-7dbaddd8]{margin-right:.25rem!important}.me-xxl-2[data-v-7dbaddd8]{margin-right:.5rem!important}.me-xxl-3[data-v-7dbaddd8]{margin-right:1rem!important}.me-xxl-4[data-v-7dbaddd8]{margin-right:1.5rem!important}.me-xxl-5[data-v-7dbaddd8]{margin-right:3rem!important}.me-xxl-auto[data-v-7dbaddd8]{margin-right:auto!important}.mb-xxl-0[data-v-7dbaddd8]{margin-bottom:0!important}.mb-xxl-1[data-v-7dbaddd8]{margin-bottom:.25rem!important}.mb-xxl-2[data-v-7dbaddd8]{margin-bottom:.5rem!important}.mb-xxl-3[data-v-7dbaddd8]{margin-bottom:1rem!important}.mb-xxl-4[data-v-7dbaddd8]{margin-bottom:1.5rem!important}.mb-xxl-5[data-v-7dbaddd8]{margin-bottom:3rem!important}.mb-xxl-auto[data-v-7dbaddd8]{margin-bottom:auto!important}.ms-xxl-0[data-v-7dbaddd8]{margin-left:0!important}.ms-xxl-1[data-v-7dbaddd8]{margin-left:.25rem!important}.ms-xxl-2[data-v-7dbaddd8]{margin-left:.5rem!important}.ms-xxl-3[data-v-7dbaddd8]{margin-left:1rem!important}.ms-xxl-4[data-v-7dbaddd8]{margin-left:1.5rem!important}.ms-xxl-5[data-v-7dbaddd8]{margin-left:3rem!important}.ms-xxl-auto[data-v-7dbaddd8]{margin-left:auto!important}.p-xxl-0[data-v-7dbaddd8]{padding:0!important}.p-xxl-1[data-v-7dbaddd8]{padding:.25rem!important}.p-xxl-2[data-v-7dbaddd8]{padding:.5rem!important}.p-xxl-3[data-v-7dbaddd8]{padding:1rem!important}.p-xxl-4[data-v-7dbaddd8]{padding:1.5rem!important}.p-xxl-5[data-v-7dbaddd8]{padding:3rem!important}.px-xxl-0[data-v-7dbaddd8]{padding-right:0!important;padding-left:0!important}.px-xxl-1[data-v-7dbaddd8]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xxl-2[data-v-7dbaddd8]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xxl-3[data-v-7dbaddd8]{padding-right:1rem!important;padding-left:1rem!important}.px-xxl-4[data-v-7dbaddd8]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xxl-5[data-v-7dbaddd8]{padding-right:3rem!important;padding-left:3rem!important}.py-xxl-0[data-v-7dbaddd8]{padding-top:0!important;padding-bottom:0!important}.py-xxl-1[data-v-7dbaddd8]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xxl-2[data-v-7dbaddd8]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xxl-3[data-v-7dbaddd8]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xxl-4[data-v-7dbaddd8]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xxl-5[data-v-7dbaddd8]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xxl-0[data-v-7dbaddd8]{padding-top:0!important}.pt-xxl-1[data-v-7dbaddd8]{padding-top:.25rem!important}.pt-xxl-2[data-v-7dbaddd8]{padding-top:.5rem!important}.pt-xxl-3[data-v-7dbaddd8]{padding-top:1rem!important}.pt-xxl-4[data-v-7dbaddd8]{padding-top:1.5rem!important}.pt-xxl-5[data-v-7dbaddd8]{padding-top:3rem!important}.pe-xxl-0[data-v-7dbaddd8]{padding-right:0!important}.pe-xxl-1[data-v-7dbaddd8]{padding-right:.25rem!important}.pe-xxl-2[data-v-7dbaddd8]{padding-right:.5rem!important}.pe-xxl-3[data-v-7dbaddd8]{padding-right:1rem!important}.pe-xxl-4[data-v-7dbaddd8]{padding-right:1.5rem!important}.pe-xxl-5[data-v-7dbaddd8]{padding-right:3rem!important}.pb-xxl-0[data-v-7dbaddd8]{padding-bottom:0!important}.pb-xxl-1[data-v-7dbaddd8]{padding-bottom:.25rem!important}.pb-xxl-2[data-v-7dbaddd8]{padding-bottom:.5rem!important}.pb-xxl-3[data-v-7dbaddd8]{padding-bottom:1rem!important}.pb-xxl-4[data-v-7dbaddd8]{padding-bottom:1.5rem!important}.pb-xxl-5[data-v-7dbaddd8]{padding-bottom:3rem!important}.ps-xxl-0[data-v-7dbaddd8]{padding-left:0!important}.ps-xxl-1[data-v-7dbaddd8]{padding-left:.25rem!important}.ps-xxl-2[data-v-7dbaddd8]{padding-left:.5rem!important}.ps-xxl-3[data-v-7dbaddd8]{padding-left:1rem!important}.ps-xxl-4[data-v-7dbaddd8]{padding-left:1.5rem!important}.ps-xxl-5[data-v-7dbaddd8]{padding-left:3rem!important}.text-xxl-start[data-v-7dbaddd8]{text-align:left!important}.text-xxl-end[data-v-7dbaddd8]{text-align:right!important}.text-xxl-center[data-v-7dbaddd8]{text-align:center!important}}@media (min-width:1200px){.fs-1[data-v-7dbaddd8]{font-size:2.5rem!important}.fs-2[data-v-7dbaddd8]{font-size:2rem!important}.fs-3[data-v-7dbaddd8]{font-size:1.75rem!important}.fs-4[data-v-7dbaddd8]{font-size:1.5rem!important}}@media print{.d-print-inline[data-v-7dbaddd8]{display:inline!important}.d-print-inline-block[data-v-7dbaddd8]{display:inline-block!important}.d-print-block[data-v-7dbaddd8]{display:block!important}.d-print-grid[data-v-7dbaddd8]{display:grid!important}.d-print-table[data-v-7dbaddd8]{display:table!important}.d-print-table-row[data-v-7dbaddd8]{display:table-row!important}.d-print-table-cell[data-v-7dbaddd8]{display:table-cell!important}.d-print-flex[data-v-7dbaddd8]{display:flex!important}.d-print-inline-flex[data-v-7dbaddd8]{display:inline-flex!important}.d-print-none[data-v-7dbaddd8]{display:none!important}}", ""]);

// exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(173);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2e62f00a", content, true, {});

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".nextto{float:left;margin-right:5px}#bc{padding-left:20px;padding-bottom:20px}", ""]);

// exports


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"bc"}},[_vm._l((_vm.breadcrumb),function(crumb,key){return _c('div',[(key + 1 == _vm.breadcrumb.length)?_c('div',{staticClass:"nextto"},[_c('div',{staticClass:"nextto"},[_vm._v(_vm._s(crumb.Crumb))])]):_c('div',{staticClass:"nextto"},[_c('div',{staticClass:"nextto"},[_c('router-link',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"to":{ path: '/ShowProductsofCat', query: { id: crumb.CatID, level: crumb.Level, category: crumb.Crumb } }}},[_vm._v("\r\n              "+_vm._s(crumb.Crumb)+"\r\n            ")])],1),_vm._v(" "),(_vm.breadcrumb.length > 1)?_c('div',{staticClass:"nextto"},[_vm._v(" / ")]):_vm._e()])])}),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_MenuBar_vue__ = __webpack_require__(75);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24456ff2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_MenuBar_vue__ = __webpack_require__(183);
function injectStyle (ssrContext) {
  __webpack_require__(176)
  __webpack_require__(178)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24456ff2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_MenuBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24456ff2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_MenuBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(177);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4a40ea6d", content, true, {});

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n/*!\n * Bootstrap v5.1.3 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */[data-v-24456ff2]:root{--bs-blue:#0d6efd;--bs-indigo:#6610f2;--bs-purple:#6f42c1;--bs-pink:#d63384;--bs-red:#dc3545;--bs-orange:#fd7e14;--bs-yellow:#ffc107;--bs-green:#198754;--bs-teal:#20c997;--bs-cyan:#0dcaf0;--bs-white:#fff;--bs-gray:#6c757d;--bs-gray-dark:#343a40;--bs-gray-100:#f8f9fa;--bs-gray-200:#e9ecef;--bs-gray-300:#dee2e6;--bs-gray-400:#ced4da;--bs-gray-500:#adb5bd;--bs-gray-600:#6c757d;--bs-gray-700:#495057;--bs-gray-800:#343a40;--bs-gray-900:#212529;--bs-primary:#0d6efd;--bs-secondary:#6c757d;--bs-success:#198754;--bs-info:#0dcaf0;--bs-warning:#ffc107;--bs-danger:#dc3545;--bs-light:#f8f9fa;--bs-dark:#212529;--bs-primary-rgb:13,110,253;--bs-secondary-rgb:108,117,125;--bs-success-rgb:25,135,84;--bs-info-rgb:13,202,240;--bs-warning-rgb:255,193,7;--bs-danger-rgb:220,53,69;--bs-light-rgb:248,249,250;--bs-dark-rgb:33,37,41;--bs-white-rgb:255,255,255;--bs-black-rgb:0,0,0;--bs-body-color-rgb:33,37,41;--bs-body-bg-rgb:255,255,255;--bs-font-sans-serif:system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--bs-font-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;--bs-gradient:linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));--bs-body-font-family:var(--bs-font-sans-serif);--bs-body-font-size:1rem;--bs-body-font-weight:400;--bs-body-line-height:1.5;--bs-body-color:#212529;--bs-body-bg:#fff}[data-v-24456ff2],[data-v-24456ff2]:after,[data-v-24456ff2]:before{box-sizing:border-box}@media (prefers-reduced-motion:no-preference){[data-v-24456ff2]:root{scroll-behavior:smooth}}body[data-v-24456ff2]{margin:0;font-family:var(--bs-body-font-family);font-size:var(--bs-body-font-size);font-weight:var(--bs-body-font-weight);line-height:var(--bs-body-line-height);color:var(--bs-body-color);text-align:var(--bs-body-text-align);background-color:var(--bs-body-bg);-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}hr[data-v-24456ff2]{margin:1rem 0;color:inherit;background-color:currentColor;border:0;opacity:.25}hr[data-v-24456ff2]:not([size]){height:1px}.h1[data-v-24456ff2],.h2[data-v-24456ff2],.h3[data-v-24456ff2],.h4[data-v-24456ff2],.h5[data-v-24456ff2],.h6[data-v-24456ff2],h1[data-v-24456ff2],h2[data-v-24456ff2],h3[data-v-24456ff2],h4[data-v-24456ff2],h5[data-v-24456ff2],h6[data-v-24456ff2]{margin-top:0;margin-bottom:.5rem;font-weight:500;line-height:1.2}.h1[data-v-24456ff2],h1[data-v-24456ff2]{font-size:calc(1.375rem + 1.5vw)}@media (min-width:1200px){.h1[data-v-24456ff2],h1[data-v-24456ff2]{font-size:2.5rem}}.h2[data-v-24456ff2],h2[data-v-24456ff2]{font-size:calc(1.325rem + .9vw)}@media (min-width:1200px){.h2[data-v-24456ff2],h2[data-v-24456ff2]{font-size:2rem}}.h3[data-v-24456ff2],h3[data-v-24456ff2]{font-size:calc(1.3rem + .6vw)}@media (min-width:1200px){.h3[data-v-24456ff2],h3[data-v-24456ff2]{font-size:1.75rem}}.h4[data-v-24456ff2],h4[data-v-24456ff2]{font-size:calc(1.275rem + .3vw)}@media (min-width:1200px){.h4[data-v-24456ff2],h4[data-v-24456ff2]{font-size:1.5rem}}.h5[data-v-24456ff2],h5[data-v-24456ff2]{font-size:1.25rem}.h6[data-v-24456ff2],h6[data-v-24456ff2]{font-size:1rem}p[data-v-24456ff2]{margin-top:0;margin-bottom:1rem}abbr[data-bs-original-title][data-v-24456ff2],abbr[title][data-v-24456ff2]{-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address[data-v-24456ff2]{margin-bottom:1rem;font-style:normal;line-height:inherit}ol[data-v-24456ff2],ul[data-v-24456ff2]{padding-left:2rem}dl[data-v-24456ff2],ol[data-v-24456ff2],ul[data-v-24456ff2]{margin-top:0;margin-bottom:1rem}ol ol[data-v-24456ff2],ol ul[data-v-24456ff2],ul ol[data-v-24456ff2],ul ul[data-v-24456ff2]{margin-bottom:0}dt[data-v-24456ff2]{font-weight:700}dd[data-v-24456ff2]{margin-bottom:.5rem;margin-left:0}blockquote[data-v-24456ff2]{margin:0 0 1rem}b[data-v-24456ff2],strong[data-v-24456ff2]{font-weight:bolder}.small[data-v-24456ff2],small[data-v-24456ff2]{font-size:.875em}.mark[data-v-24456ff2],mark[data-v-24456ff2]{padding:.2em;background-color:#fcf8e3}sub[data-v-24456ff2],sup[data-v-24456ff2]{position:relative;font-size:.75em;line-height:0;vertical-align:baseline}sub[data-v-24456ff2]{bottom:-.25em}sup[data-v-24456ff2]{top:-.5em}a[data-v-24456ff2]{color:#0d6efd;text-decoration:underline}a[data-v-24456ff2]:hover{color:#0a58ca}a[data-v-24456ff2]:not([href]):not([class]),a[data-v-24456ff2]:not([href]):not([class]):hover{color:inherit;text-decoration:none}code[data-v-24456ff2],kbd[data-v-24456ff2],pre[data-v-24456ff2],samp[data-v-24456ff2]{font-family:var(--bs-font-monospace);font-size:1em;direction:ltr;unicode-bidi:bidi-override}pre[data-v-24456ff2]{display:block;margin-top:0;margin-bottom:1rem;overflow:auto;font-size:.875em}pre code[data-v-24456ff2]{font-size:inherit;color:inherit;word-break:normal}code[data-v-24456ff2]{font-size:.875em;color:#d63384;word-wrap:break-word}a>code[data-v-24456ff2]{color:inherit}kbd[data-v-24456ff2]{padding:.2rem .4rem;font-size:.875em;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd[data-v-24456ff2]{padding:0;font-size:1em;font-weight:700}figure[data-v-24456ff2]{margin:0 0 1rem}img[data-v-24456ff2],svg[data-v-24456ff2]{vertical-align:middle}table[data-v-24456ff2]{caption-side:bottom;border-collapse:collapse}caption[data-v-24456ff2]{padding-top:.5rem;padding-bottom:.5rem;color:#6c757d;text-align:left}th[data-v-24456ff2]{text-align:inherit;text-align:-webkit-match-parent}tbody[data-v-24456ff2],td[data-v-24456ff2],tfoot[data-v-24456ff2],th[data-v-24456ff2],thead[data-v-24456ff2],tr[data-v-24456ff2]{border-color:inherit;border-style:solid;border-width:0}label[data-v-24456ff2]{display:inline-block}button[data-v-24456ff2]{border-radius:0}button[data-v-24456ff2]:focus:not(:focus-visible){outline:0}button[data-v-24456ff2],input[data-v-24456ff2],optgroup[data-v-24456ff2],select[data-v-24456ff2],textarea[data-v-24456ff2]{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button[data-v-24456ff2],select[data-v-24456ff2]{text-transform:none}[role=button][data-v-24456ff2]{cursor:pointer}select[data-v-24456ff2]{word-wrap:normal}select[data-v-24456ff2]:disabled{opacity:1}[list][data-v-24456ff2]::-webkit-calendar-picker-indicator{display:none}[type=button][data-v-24456ff2],[type=reset][data-v-24456ff2],[type=submit][data-v-24456ff2],button[data-v-24456ff2]{-webkit-appearance:button}[type=button][data-v-24456ff2]:not(:disabled),[type=reset][data-v-24456ff2]:not(:disabled),[type=submit][data-v-24456ff2]:not(:disabled),button[data-v-24456ff2]:not(:disabled){cursor:pointer}[data-v-24456ff2]::-moz-focus-inner{padding:0;border-style:none}textarea[data-v-24456ff2]{resize:vertical}fieldset[data-v-24456ff2]{min-width:0;padding:0;margin:0;border:0}legend[data-v-24456ff2]{float:left;width:100%;padding:0;margin-bottom:.5rem;font-size:calc(1.275rem + .3vw);line-height:inherit}@media (min-width:1200px){legend[data-v-24456ff2]{font-size:1.5rem}}legend+[data-v-24456ff2]{clear:left}[data-v-24456ff2]::-webkit-datetime-edit-day-field,[data-v-24456ff2]::-webkit-datetime-edit-fields-wrapper,[data-v-24456ff2]::-webkit-datetime-edit-hour-field,[data-v-24456ff2]::-webkit-datetime-edit-minute,[data-v-24456ff2]::-webkit-datetime-edit-month-field,[data-v-24456ff2]::-webkit-datetime-edit-text,[data-v-24456ff2]::-webkit-datetime-edit-year-field{padding:0}[data-v-24456ff2]::-webkit-inner-spin-button{height:auto}[type=search][data-v-24456ff2]{outline-offset:-2px;-webkit-appearance:textfield}[data-v-24456ff2]::-webkit-search-decoration{-webkit-appearance:none}[data-v-24456ff2]::-webkit-color-swatch-wrapper{padding:0}[data-v-24456ff2]::file-selector-button{font:inherit}[data-v-24456ff2]::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output[data-v-24456ff2]{display:inline-block}iframe[data-v-24456ff2]{border:0}summary[data-v-24456ff2]{display:list-item;cursor:pointer}progress[data-v-24456ff2]{vertical-align:baseline}[hidden][data-v-24456ff2]{display:none!important}.lead[data-v-24456ff2]{font-size:1.25rem;font-weight:300}.display-1[data-v-24456ff2]{font-size:calc(1.625rem + 4.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-1[data-v-24456ff2]{font-size:5rem}}.display-2[data-v-24456ff2]{font-size:calc(1.575rem + 3.9vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-2[data-v-24456ff2]{font-size:4.5rem}}.display-3[data-v-24456ff2]{font-size:calc(1.525rem + 3.3vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-3[data-v-24456ff2]{font-size:4rem}}.display-4[data-v-24456ff2]{font-size:calc(1.475rem + 2.7vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-4[data-v-24456ff2]{font-size:3.5rem}}.display-5[data-v-24456ff2]{font-size:calc(1.425rem + 2.1vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-5[data-v-24456ff2]{font-size:3rem}}.display-6[data-v-24456ff2]{font-size:calc(1.375rem + 1.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-6[data-v-24456ff2]{font-size:2.5rem}}.list-inline[data-v-24456ff2],.list-unstyled[data-v-24456ff2]{padding-left:0;list-style:none}.list-inline-item[data-v-24456ff2]{display:inline-block}.list-inline-item[data-v-24456ff2]:not(:last-child){margin-right:.5rem}.initialism[data-v-24456ff2]{font-size:.875em;text-transform:uppercase}.blockquote[data-v-24456ff2]{margin-bottom:1rem;font-size:1.25rem}.blockquote[data-v-24456ff2]>:last-child{margin-bottom:0}.blockquote-footer[data-v-24456ff2]{margin-top:-1rem;margin-bottom:1rem;font-size:.875em;color:#6c757d}.blockquote-footer[data-v-24456ff2]:before{content:\"\\2014\\A0\"}.img-fluid[data-v-24456ff2]{max-width:100%;height:auto}.img-thumbnail[data-v-24456ff2]{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.figure[data-v-24456ff2]{display:inline-block}.figure-img[data-v-24456ff2]{margin-bottom:.5rem;line-height:1}.figure-caption[data-v-24456ff2]{font-size:.875em;color:#6c757d}.container-fluid[data-v-24456ff2],.container-lg[data-v-24456ff2],.container-md[data-v-24456ff2],.container-sm[data-v-24456ff2],.container-xl[data-v-24456ff2],.container-xxl[data-v-24456ff2],.container[data-v-24456ff2]{width:100%;padding-right:var(--bs-gutter-x,.75rem);padding-left:var(--bs-gutter-x,.75rem);margin-right:auto;margin-left:auto}@media (min-width:576px){.container-sm[data-v-24456ff2],.container[data-v-24456ff2]{max-width:540px}}@media (min-width:768px){.container-md[data-v-24456ff2],.container-sm[data-v-24456ff2],.container[data-v-24456ff2]{max-width:720px}}@media (min-width:992px){.container-lg[data-v-24456ff2],.container-md[data-v-24456ff2],.container-sm[data-v-24456ff2],.container[data-v-24456ff2]{max-width:960px}}@media (min-width:1200px){.container-lg[data-v-24456ff2],.container-md[data-v-24456ff2],.container-sm[data-v-24456ff2],.container-xl[data-v-24456ff2],.container[data-v-24456ff2]{max-width:1140px}}@media (min-width:1400px){.container-lg[data-v-24456ff2],.container-md[data-v-24456ff2],.container-sm[data-v-24456ff2],.container-xl[data-v-24456ff2],.container-xxl[data-v-24456ff2],.container[data-v-24456ff2]{max-width:1320px}}.row[data-v-24456ff2]{--bs-gutter-x:1.5rem;--bs-gutter-y:0;display:flex;flex-wrap:wrap;margin-top:calc(-1 * var(--bs-gutter-y));margin-right:calc(-.5 * var(--bs-gutter-x));margin-left:calc(-.5 * var(--bs-gutter-x))}.row>[data-v-24456ff2]{flex-shrink:0;width:100%;max-width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-top:var(--bs-gutter-y)}.col[data-v-24456ff2]{flex:1 0 0%}.row-cols-auto>[data-v-24456ff2]{flex:0 0 auto;width:auto}.row-cols-1>[data-v-24456ff2]{flex:0 0 auto;width:100%}.row-cols-2>[data-v-24456ff2]{flex:0 0 auto;width:50%}.row-cols-3>[data-v-24456ff2]{flex:0 0 auto;width:33.3333333333%}.row-cols-4>[data-v-24456ff2]{flex:0 0 auto;width:25%}.row-cols-5>[data-v-24456ff2]{flex:0 0 auto;width:20%}.row-cols-6>[data-v-24456ff2]{flex:0 0 auto;width:16.6666666667%}.col-auto[data-v-24456ff2]{flex:0 0 auto;width:auto}.col-1[data-v-24456ff2]{flex:0 0 auto;width:8.33333333%}.col-2[data-v-24456ff2]{flex:0 0 auto;width:16.66666667%}.col-3[data-v-24456ff2]{flex:0 0 auto;width:25%}.col-4[data-v-24456ff2]{flex:0 0 auto;width:33.33333333%}.col-5[data-v-24456ff2]{flex:0 0 auto;width:41.66666667%}.col-6[data-v-24456ff2]{flex:0 0 auto;width:50%}.col-7[data-v-24456ff2]{flex:0 0 auto;width:58.33333333%}.col-8[data-v-24456ff2]{flex:0 0 auto;width:66.66666667%}.col-9[data-v-24456ff2]{flex:0 0 auto;width:75%}.col-10[data-v-24456ff2]{flex:0 0 auto;width:83.33333333%}.col-11[data-v-24456ff2]{flex:0 0 auto;width:91.66666667%}.col-12[data-v-24456ff2]{flex:0 0 auto;width:100%}.offset-1[data-v-24456ff2]{margin-left:8.33333333%}.offset-2[data-v-24456ff2]{margin-left:16.66666667%}.offset-3[data-v-24456ff2]{margin-left:25%}.offset-4[data-v-24456ff2]{margin-left:33.33333333%}.offset-5[data-v-24456ff2]{margin-left:41.66666667%}.offset-6[data-v-24456ff2]{margin-left:50%}.offset-7[data-v-24456ff2]{margin-left:58.33333333%}.offset-8[data-v-24456ff2]{margin-left:66.66666667%}.offset-9[data-v-24456ff2]{margin-left:75%}.offset-10[data-v-24456ff2]{margin-left:83.33333333%}.offset-11[data-v-24456ff2]{margin-left:91.66666667%}.g-0[data-v-24456ff2],.gx-0[data-v-24456ff2]{--bs-gutter-x:0}.g-0[data-v-24456ff2],.gy-0[data-v-24456ff2]{--bs-gutter-y:0}.g-1[data-v-24456ff2],.gx-1[data-v-24456ff2]{--bs-gutter-x:0.25rem}.g-1[data-v-24456ff2],.gy-1[data-v-24456ff2]{--bs-gutter-y:0.25rem}.g-2[data-v-24456ff2],.gx-2[data-v-24456ff2]{--bs-gutter-x:0.5rem}.g-2[data-v-24456ff2],.gy-2[data-v-24456ff2]{--bs-gutter-y:0.5rem}.g-3[data-v-24456ff2],.gx-3[data-v-24456ff2]{--bs-gutter-x:1rem}.g-3[data-v-24456ff2],.gy-3[data-v-24456ff2]{--bs-gutter-y:1rem}.g-4[data-v-24456ff2],.gx-4[data-v-24456ff2]{--bs-gutter-x:1.5rem}.g-4[data-v-24456ff2],.gy-4[data-v-24456ff2]{--bs-gutter-y:1.5rem}.g-5[data-v-24456ff2],.gx-5[data-v-24456ff2]{--bs-gutter-x:3rem}.g-5[data-v-24456ff2],.gy-5[data-v-24456ff2]{--bs-gutter-y:3rem}@media (min-width:576px){.col-sm[data-v-24456ff2]{flex:1 0 0%}.row-cols-sm-auto>[data-v-24456ff2]{flex:0 0 auto;width:auto}.row-cols-sm-1>[data-v-24456ff2]{flex:0 0 auto;width:100%}.row-cols-sm-2>[data-v-24456ff2]{flex:0 0 auto;width:50%}.row-cols-sm-3>[data-v-24456ff2]{flex:0 0 auto;width:33.3333333333%}.row-cols-sm-4>[data-v-24456ff2]{flex:0 0 auto;width:25%}.row-cols-sm-5>[data-v-24456ff2]{flex:0 0 auto;width:20%}.row-cols-sm-6>[data-v-24456ff2]{flex:0 0 auto;width:16.6666666667%}.col-sm-auto[data-v-24456ff2]{flex:0 0 auto;width:auto}.col-sm-1[data-v-24456ff2]{flex:0 0 auto;width:8.33333333%}.col-sm-2[data-v-24456ff2]{flex:0 0 auto;width:16.66666667%}.col-sm-3[data-v-24456ff2]{flex:0 0 auto;width:25%}.col-sm-4[data-v-24456ff2]{flex:0 0 auto;width:33.33333333%}.col-sm-5[data-v-24456ff2]{flex:0 0 auto;width:41.66666667%}.col-sm-6[data-v-24456ff2]{flex:0 0 auto;width:50%}.col-sm-7[data-v-24456ff2]{flex:0 0 auto;width:58.33333333%}.col-sm-8[data-v-24456ff2]{flex:0 0 auto;width:66.66666667%}.col-sm-9[data-v-24456ff2]{flex:0 0 auto;width:75%}.col-sm-10[data-v-24456ff2]{flex:0 0 auto;width:83.33333333%}.col-sm-11[data-v-24456ff2]{flex:0 0 auto;width:91.66666667%}.col-sm-12[data-v-24456ff2]{flex:0 0 auto;width:100%}.offset-sm-0[data-v-24456ff2]{margin-left:0}.offset-sm-1[data-v-24456ff2]{margin-left:8.33333333%}.offset-sm-2[data-v-24456ff2]{margin-left:16.66666667%}.offset-sm-3[data-v-24456ff2]{margin-left:25%}.offset-sm-4[data-v-24456ff2]{margin-left:33.33333333%}.offset-sm-5[data-v-24456ff2]{margin-left:41.66666667%}.offset-sm-6[data-v-24456ff2]{margin-left:50%}.offset-sm-7[data-v-24456ff2]{margin-left:58.33333333%}.offset-sm-8[data-v-24456ff2]{margin-left:66.66666667%}.offset-sm-9[data-v-24456ff2]{margin-left:75%}.offset-sm-10[data-v-24456ff2]{margin-left:83.33333333%}.offset-sm-11[data-v-24456ff2]{margin-left:91.66666667%}.g-sm-0[data-v-24456ff2],.gx-sm-0[data-v-24456ff2]{--bs-gutter-x:0}.g-sm-0[data-v-24456ff2],.gy-sm-0[data-v-24456ff2]{--bs-gutter-y:0}.g-sm-1[data-v-24456ff2],.gx-sm-1[data-v-24456ff2]{--bs-gutter-x:0.25rem}.g-sm-1[data-v-24456ff2],.gy-sm-1[data-v-24456ff2]{--bs-gutter-y:0.25rem}.g-sm-2[data-v-24456ff2],.gx-sm-2[data-v-24456ff2]{--bs-gutter-x:0.5rem}.g-sm-2[data-v-24456ff2],.gy-sm-2[data-v-24456ff2]{--bs-gutter-y:0.5rem}.g-sm-3[data-v-24456ff2],.gx-sm-3[data-v-24456ff2]{--bs-gutter-x:1rem}.g-sm-3[data-v-24456ff2],.gy-sm-3[data-v-24456ff2]{--bs-gutter-y:1rem}.g-sm-4[data-v-24456ff2],.gx-sm-4[data-v-24456ff2]{--bs-gutter-x:1.5rem}.g-sm-4[data-v-24456ff2],.gy-sm-4[data-v-24456ff2]{--bs-gutter-y:1.5rem}.g-sm-5[data-v-24456ff2],.gx-sm-5[data-v-24456ff2]{--bs-gutter-x:3rem}.g-sm-5[data-v-24456ff2],.gy-sm-5[data-v-24456ff2]{--bs-gutter-y:3rem}}@media (min-width:768px){.col-md[data-v-24456ff2]{flex:1 0 0%}.row-cols-md-auto>[data-v-24456ff2]{flex:0 0 auto;width:auto}.row-cols-md-1>[data-v-24456ff2]{flex:0 0 auto;width:100%}.row-cols-md-2>[data-v-24456ff2]{flex:0 0 auto;width:50%}.row-cols-md-3>[data-v-24456ff2]{flex:0 0 auto;width:33.3333333333%}.row-cols-md-4>[data-v-24456ff2]{flex:0 0 auto;width:25%}.row-cols-md-5>[data-v-24456ff2]{flex:0 0 auto;width:20%}.row-cols-md-6>[data-v-24456ff2]{flex:0 0 auto;width:16.6666666667%}.col-md-auto[data-v-24456ff2]{flex:0 0 auto;width:auto}.col-md-1[data-v-24456ff2]{flex:0 0 auto;width:8.33333333%}.col-md-2[data-v-24456ff2]{flex:0 0 auto;width:16.66666667%}.col-md-3[data-v-24456ff2]{flex:0 0 auto;width:25%}.col-md-4[data-v-24456ff2]{flex:0 0 auto;width:33.33333333%}.col-md-5[data-v-24456ff2]{flex:0 0 auto;width:41.66666667%}.col-md-6[data-v-24456ff2]{flex:0 0 auto;width:50%}.col-md-7[data-v-24456ff2]{flex:0 0 auto;width:58.33333333%}.col-md-8[data-v-24456ff2]{flex:0 0 auto;width:66.66666667%}.col-md-9[data-v-24456ff2]{flex:0 0 auto;width:75%}.col-md-10[data-v-24456ff2]{flex:0 0 auto;width:83.33333333%}.col-md-11[data-v-24456ff2]{flex:0 0 auto;width:91.66666667%}.col-md-12[data-v-24456ff2]{flex:0 0 auto;width:100%}.offset-md-0[data-v-24456ff2]{margin-left:0}.offset-md-1[data-v-24456ff2]{margin-left:8.33333333%}.offset-md-2[data-v-24456ff2]{margin-left:16.66666667%}.offset-md-3[data-v-24456ff2]{margin-left:25%}.offset-md-4[data-v-24456ff2]{margin-left:33.33333333%}.offset-md-5[data-v-24456ff2]{margin-left:41.66666667%}.offset-md-6[data-v-24456ff2]{margin-left:50%}.offset-md-7[data-v-24456ff2]{margin-left:58.33333333%}.offset-md-8[data-v-24456ff2]{margin-left:66.66666667%}.offset-md-9[data-v-24456ff2]{margin-left:75%}.offset-md-10[data-v-24456ff2]{margin-left:83.33333333%}.offset-md-11[data-v-24456ff2]{margin-left:91.66666667%}.g-md-0[data-v-24456ff2],.gx-md-0[data-v-24456ff2]{--bs-gutter-x:0}.g-md-0[data-v-24456ff2],.gy-md-0[data-v-24456ff2]{--bs-gutter-y:0}.g-md-1[data-v-24456ff2],.gx-md-1[data-v-24456ff2]{--bs-gutter-x:0.25rem}.g-md-1[data-v-24456ff2],.gy-md-1[data-v-24456ff2]{--bs-gutter-y:0.25rem}.g-md-2[data-v-24456ff2],.gx-md-2[data-v-24456ff2]{--bs-gutter-x:0.5rem}.g-md-2[data-v-24456ff2],.gy-md-2[data-v-24456ff2]{--bs-gutter-y:0.5rem}.g-md-3[data-v-24456ff2],.gx-md-3[data-v-24456ff2]{--bs-gutter-x:1rem}.g-md-3[data-v-24456ff2],.gy-md-3[data-v-24456ff2]{--bs-gutter-y:1rem}.g-md-4[data-v-24456ff2],.gx-md-4[data-v-24456ff2]{--bs-gutter-x:1.5rem}.g-md-4[data-v-24456ff2],.gy-md-4[data-v-24456ff2]{--bs-gutter-y:1.5rem}.g-md-5[data-v-24456ff2],.gx-md-5[data-v-24456ff2]{--bs-gutter-x:3rem}.g-md-5[data-v-24456ff2],.gy-md-5[data-v-24456ff2]{--bs-gutter-y:3rem}}@media (min-width:992px){.col-lg[data-v-24456ff2]{flex:1 0 0%}.row-cols-lg-auto>[data-v-24456ff2]{flex:0 0 auto;width:auto}.row-cols-lg-1>[data-v-24456ff2]{flex:0 0 auto;width:100%}.row-cols-lg-2>[data-v-24456ff2]{flex:0 0 auto;width:50%}.row-cols-lg-3>[data-v-24456ff2]{flex:0 0 auto;width:33.3333333333%}.row-cols-lg-4>[data-v-24456ff2]{flex:0 0 auto;width:25%}.row-cols-lg-5>[data-v-24456ff2]{flex:0 0 auto;width:20%}.row-cols-lg-6>[data-v-24456ff2]{flex:0 0 auto;width:16.6666666667%}.col-lg-auto[data-v-24456ff2]{flex:0 0 auto;width:auto}.col-lg-1[data-v-24456ff2]{flex:0 0 auto;width:8.33333333%}.col-lg-2[data-v-24456ff2]{flex:0 0 auto;width:16.66666667%}.col-lg-3[data-v-24456ff2]{flex:0 0 auto;width:25%}.col-lg-4[data-v-24456ff2]{flex:0 0 auto;width:33.33333333%}.col-lg-5[data-v-24456ff2]{flex:0 0 auto;width:41.66666667%}.col-lg-6[data-v-24456ff2]{flex:0 0 auto;width:50%}.col-lg-7[data-v-24456ff2]{flex:0 0 auto;width:58.33333333%}.col-lg-8[data-v-24456ff2]{flex:0 0 auto;width:66.66666667%}.col-lg-9[data-v-24456ff2]{flex:0 0 auto;width:75%}.col-lg-10[data-v-24456ff2]{flex:0 0 auto;width:83.33333333%}.col-lg-11[data-v-24456ff2]{flex:0 0 auto;width:91.66666667%}.col-lg-12[data-v-24456ff2]{flex:0 0 auto;width:100%}.offset-lg-0[data-v-24456ff2]{margin-left:0}.offset-lg-1[data-v-24456ff2]{margin-left:8.33333333%}.offset-lg-2[data-v-24456ff2]{margin-left:16.66666667%}.offset-lg-3[data-v-24456ff2]{margin-left:25%}.offset-lg-4[data-v-24456ff2]{margin-left:33.33333333%}.offset-lg-5[data-v-24456ff2]{margin-left:41.66666667%}.offset-lg-6[data-v-24456ff2]{margin-left:50%}.offset-lg-7[data-v-24456ff2]{margin-left:58.33333333%}.offset-lg-8[data-v-24456ff2]{margin-left:66.66666667%}.offset-lg-9[data-v-24456ff2]{margin-left:75%}.offset-lg-10[data-v-24456ff2]{margin-left:83.33333333%}.offset-lg-11[data-v-24456ff2]{margin-left:91.66666667%}.g-lg-0[data-v-24456ff2],.gx-lg-0[data-v-24456ff2]{--bs-gutter-x:0}.g-lg-0[data-v-24456ff2],.gy-lg-0[data-v-24456ff2]{--bs-gutter-y:0}.g-lg-1[data-v-24456ff2],.gx-lg-1[data-v-24456ff2]{--bs-gutter-x:0.25rem}.g-lg-1[data-v-24456ff2],.gy-lg-1[data-v-24456ff2]{--bs-gutter-y:0.25rem}.g-lg-2[data-v-24456ff2],.gx-lg-2[data-v-24456ff2]{--bs-gutter-x:0.5rem}.g-lg-2[data-v-24456ff2],.gy-lg-2[data-v-24456ff2]{--bs-gutter-y:0.5rem}.g-lg-3[data-v-24456ff2],.gx-lg-3[data-v-24456ff2]{--bs-gutter-x:1rem}.g-lg-3[data-v-24456ff2],.gy-lg-3[data-v-24456ff2]{--bs-gutter-y:1rem}.g-lg-4[data-v-24456ff2],.gx-lg-4[data-v-24456ff2]{--bs-gutter-x:1.5rem}.g-lg-4[data-v-24456ff2],.gy-lg-4[data-v-24456ff2]{--bs-gutter-y:1.5rem}.g-lg-5[data-v-24456ff2],.gx-lg-5[data-v-24456ff2]{--bs-gutter-x:3rem}.g-lg-5[data-v-24456ff2],.gy-lg-5[data-v-24456ff2]{--bs-gutter-y:3rem}}@media (min-width:1200px){.col-xl[data-v-24456ff2]{flex:1 0 0%}.row-cols-xl-auto>[data-v-24456ff2]{flex:0 0 auto;width:auto}.row-cols-xl-1>[data-v-24456ff2]{flex:0 0 auto;width:100%}.row-cols-xl-2>[data-v-24456ff2]{flex:0 0 auto;width:50%}.row-cols-xl-3>[data-v-24456ff2]{flex:0 0 auto;width:33.3333333333%}.row-cols-xl-4>[data-v-24456ff2]{flex:0 0 auto;width:25%}.row-cols-xl-5>[data-v-24456ff2]{flex:0 0 auto;width:20%}.row-cols-xl-6>[data-v-24456ff2]{flex:0 0 auto;width:16.6666666667%}.col-xl-auto[data-v-24456ff2]{flex:0 0 auto;width:auto}.col-xl-1[data-v-24456ff2]{flex:0 0 auto;width:8.33333333%}.col-xl-2[data-v-24456ff2]{flex:0 0 auto;width:16.66666667%}.col-xl-3[data-v-24456ff2]{flex:0 0 auto;width:25%}.col-xl-4[data-v-24456ff2]{flex:0 0 auto;width:33.33333333%}.col-xl-5[data-v-24456ff2]{flex:0 0 auto;width:41.66666667%}.col-xl-6[data-v-24456ff2]{flex:0 0 auto;width:50%}.col-xl-7[data-v-24456ff2]{flex:0 0 auto;width:58.33333333%}.col-xl-8[data-v-24456ff2]{flex:0 0 auto;width:66.66666667%}.col-xl-9[data-v-24456ff2]{flex:0 0 auto;width:75%}.col-xl-10[data-v-24456ff2]{flex:0 0 auto;width:83.33333333%}.col-xl-11[data-v-24456ff2]{flex:0 0 auto;width:91.66666667%}.col-xl-12[data-v-24456ff2]{flex:0 0 auto;width:100%}.offset-xl-0[data-v-24456ff2]{margin-left:0}.offset-xl-1[data-v-24456ff2]{margin-left:8.33333333%}.offset-xl-2[data-v-24456ff2]{margin-left:16.66666667%}.offset-xl-3[data-v-24456ff2]{margin-left:25%}.offset-xl-4[data-v-24456ff2]{margin-left:33.33333333%}.offset-xl-5[data-v-24456ff2]{margin-left:41.66666667%}.offset-xl-6[data-v-24456ff2]{margin-left:50%}.offset-xl-7[data-v-24456ff2]{margin-left:58.33333333%}.offset-xl-8[data-v-24456ff2]{margin-left:66.66666667%}.offset-xl-9[data-v-24456ff2]{margin-left:75%}.offset-xl-10[data-v-24456ff2]{margin-left:83.33333333%}.offset-xl-11[data-v-24456ff2]{margin-left:91.66666667%}.g-xl-0[data-v-24456ff2],.gx-xl-0[data-v-24456ff2]{--bs-gutter-x:0}.g-xl-0[data-v-24456ff2],.gy-xl-0[data-v-24456ff2]{--bs-gutter-y:0}.g-xl-1[data-v-24456ff2],.gx-xl-1[data-v-24456ff2]{--bs-gutter-x:0.25rem}.g-xl-1[data-v-24456ff2],.gy-xl-1[data-v-24456ff2]{--bs-gutter-y:0.25rem}.g-xl-2[data-v-24456ff2],.gx-xl-2[data-v-24456ff2]{--bs-gutter-x:0.5rem}.g-xl-2[data-v-24456ff2],.gy-xl-2[data-v-24456ff2]{--bs-gutter-y:0.5rem}.g-xl-3[data-v-24456ff2],.gx-xl-3[data-v-24456ff2]{--bs-gutter-x:1rem}.g-xl-3[data-v-24456ff2],.gy-xl-3[data-v-24456ff2]{--bs-gutter-y:1rem}.g-xl-4[data-v-24456ff2],.gx-xl-4[data-v-24456ff2]{--bs-gutter-x:1.5rem}.g-xl-4[data-v-24456ff2],.gy-xl-4[data-v-24456ff2]{--bs-gutter-y:1.5rem}.g-xl-5[data-v-24456ff2],.gx-xl-5[data-v-24456ff2]{--bs-gutter-x:3rem}.g-xl-5[data-v-24456ff2],.gy-xl-5[data-v-24456ff2]{--bs-gutter-y:3rem}}@media (min-width:1400px){.col-xxl[data-v-24456ff2]{flex:1 0 0%}.row-cols-xxl-auto>[data-v-24456ff2]{flex:0 0 auto;width:auto}.row-cols-xxl-1>[data-v-24456ff2]{flex:0 0 auto;width:100%}.row-cols-xxl-2>[data-v-24456ff2]{flex:0 0 auto;width:50%}.row-cols-xxl-3>[data-v-24456ff2]{flex:0 0 auto;width:33.3333333333%}.row-cols-xxl-4>[data-v-24456ff2]{flex:0 0 auto;width:25%}.row-cols-xxl-5>[data-v-24456ff2]{flex:0 0 auto;width:20%}.row-cols-xxl-6>[data-v-24456ff2]{flex:0 0 auto;width:16.6666666667%}.col-xxl-auto[data-v-24456ff2]{flex:0 0 auto;width:auto}.col-xxl-1[data-v-24456ff2]{flex:0 0 auto;width:8.33333333%}.col-xxl-2[data-v-24456ff2]{flex:0 0 auto;width:16.66666667%}.col-xxl-3[data-v-24456ff2]{flex:0 0 auto;width:25%}.col-xxl-4[data-v-24456ff2]{flex:0 0 auto;width:33.33333333%}.col-xxl-5[data-v-24456ff2]{flex:0 0 auto;width:41.66666667%}.col-xxl-6[data-v-24456ff2]{flex:0 0 auto;width:50%}.col-xxl-7[data-v-24456ff2]{flex:0 0 auto;width:58.33333333%}.col-xxl-8[data-v-24456ff2]{flex:0 0 auto;width:66.66666667%}.col-xxl-9[data-v-24456ff2]{flex:0 0 auto;width:75%}.col-xxl-10[data-v-24456ff2]{flex:0 0 auto;width:83.33333333%}.col-xxl-11[data-v-24456ff2]{flex:0 0 auto;width:91.66666667%}.col-xxl-12[data-v-24456ff2]{flex:0 0 auto;width:100%}.offset-xxl-0[data-v-24456ff2]{margin-left:0}.offset-xxl-1[data-v-24456ff2]{margin-left:8.33333333%}.offset-xxl-2[data-v-24456ff2]{margin-left:16.66666667%}.offset-xxl-3[data-v-24456ff2]{margin-left:25%}.offset-xxl-4[data-v-24456ff2]{margin-left:33.33333333%}.offset-xxl-5[data-v-24456ff2]{margin-left:41.66666667%}.offset-xxl-6[data-v-24456ff2]{margin-left:50%}.offset-xxl-7[data-v-24456ff2]{margin-left:58.33333333%}.offset-xxl-8[data-v-24456ff2]{margin-left:66.66666667%}.offset-xxl-9[data-v-24456ff2]{margin-left:75%}.offset-xxl-10[data-v-24456ff2]{margin-left:83.33333333%}.offset-xxl-11[data-v-24456ff2]{margin-left:91.66666667%}.g-xxl-0[data-v-24456ff2],.gx-xxl-0[data-v-24456ff2]{--bs-gutter-x:0}.g-xxl-0[data-v-24456ff2],.gy-xxl-0[data-v-24456ff2]{--bs-gutter-y:0}.g-xxl-1[data-v-24456ff2],.gx-xxl-1[data-v-24456ff2]{--bs-gutter-x:0.25rem}.g-xxl-1[data-v-24456ff2],.gy-xxl-1[data-v-24456ff2]{--bs-gutter-y:0.25rem}.g-xxl-2[data-v-24456ff2],.gx-xxl-2[data-v-24456ff2]{--bs-gutter-x:0.5rem}.g-xxl-2[data-v-24456ff2],.gy-xxl-2[data-v-24456ff2]{--bs-gutter-y:0.5rem}.g-xxl-3[data-v-24456ff2],.gx-xxl-3[data-v-24456ff2]{--bs-gutter-x:1rem}.g-xxl-3[data-v-24456ff2],.gy-xxl-3[data-v-24456ff2]{--bs-gutter-y:1rem}.g-xxl-4[data-v-24456ff2],.gx-xxl-4[data-v-24456ff2]{--bs-gutter-x:1.5rem}.g-xxl-4[data-v-24456ff2],.gy-xxl-4[data-v-24456ff2]{--bs-gutter-y:1.5rem}.g-xxl-5[data-v-24456ff2],.gx-xxl-5[data-v-24456ff2]{--bs-gutter-x:3rem}.g-xxl-5[data-v-24456ff2],.gy-xxl-5[data-v-24456ff2]{--bs-gutter-y:3rem}}.table[data-v-24456ff2]{--bs-table-bg:transparent;--bs-table-accent-bg:transparent;--bs-table-striped-color:#212529;--bs-table-striped-bg:rgba(0,0,0,.05);--bs-table-active-color:#212529;--bs-table-active-bg:rgba(0,0,0,.1);--bs-table-hover-color:#212529;--bs-table-hover-bg:rgba(0,0,0,.075);width:100%;margin-bottom:1rem;color:#212529;vertical-align:top;border-color:#dee2e6}.table>:not(caption)>*>[data-v-24456ff2]{padding:.5rem;background-color:var(--bs-table-bg);border-bottom-width:1px;box-shadow:inset 0 0 0 9999px var(--bs-table-accent-bg)}.table>tbody[data-v-24456ff2]{vertical-align:inherit}.table>thead[data-v-24456ff2]{vertical-align:bottom}.table[data-v-24456ff2]>:not(:first-child){border-top:2px solid currentColor}.caption-top[data-v-24456ff2]{caption-side:top}.table-sm>:not(caption)>*>[data-v-24456ff2]{padding:.25rem}.table-bordered>:not(caption)>[data-v-24456ff2]{border-width:1px 0}.table-bordered>:not(caption)>*>[data-v-24456ff2]{border-width:0 1px}.table-borderless>:not(caption)>*>[data-v-24456ff2]{border-bottom-width:0}.table-borderless[data-v-24456ff2]>:not(:first-child){border-top-width:0}.table-striped>tbody>tr:nth-of-type(odd)>[data-v-24456ff2]{--bs-table-accent-bg:var(--bs-table-striped-bg);color:var(--bs-table-striped-color)}.table-active[data-v-24456ff2]{--bs-table-accent-bg:var(--bs-table-active-bg);color:var(--bs-table-active-color)}.table-hover>tbody>tr:hover>[data-v-24456ff2]{--bs-table-accent-bg:var(--bs-table-hover-bg);color:var(--bs-table-hover-color)}.table-primary[data-v-24456ff2]{--bs-table-bg:#cfe2ff;--bs-table-striped-bg:#c5d7f2;--bs-table-striped-color:#000;--bs-table-active-bg:#bacbe6;--bs-table-active-color:#000;--bs-table-hover-bg:#bfd1ec;--bs-table-hover-color:#000;color:#000;border-color:#bacbe6}.table-secondary[data-v-24456ff2]{--bs-table-bg:#e2e3e5;--bs-table-striped-bg:#d7d8da;--bs-table-striped-color:#000;--bs-table-active-bg:#cbccce;--bs-table-active-color:#000;--bs-table-hover-bg:#d1d2d4;--bs-table-hover-color:#000;color:#000;border-color:#cbccce}.table-success[data-v-24456ff2]{--bs-table-bg:#d1e7dd;--bs-table-striped-bg:#c7dbd2;--bs-table-striped-color:#000;--bs-table-active-bg:#bcd0c7;--bs-table-active-color:#000;--bs-table-hover-bg:#c1d6cc;--bs-table-hover-color:#000;color:#000;border-color:#bcd0c7}.table-info[data-v-24456ff2]{--bs-table-bg:#cff4fc;--bs-table-striped-bg:#c5e8ef;--bs-table-striped-color:#000;--bs-table-active-bg:#badce3;--bs-table-active-color:#000;--bs-table-hover-bg:#bfe2e9;--bs-table-hover-color:#000;color:#000;border-color:#badce3}.table-warning[data-v-24456ff2]{--bs-table-bg:#fff3cd;--bs-table-striped-bg:#f2e7c3;--bs-table-striped-color:#000;--bs-table-active-bg:#e6dbb9;--bs-table-active-color:#000;--bs-table-hover-bg:#ece1be;--bs-table-hover-color:#000;color:#000;border-color:#e6dbb9}.table-danger[data-v-24456ff2]{--bs-table-bg:#f8d7da;--bs-table-striped-bg:#eccccf;--bs-table-striped-color:#000;--bs-table-active-bg:#dfc2c4;--bs-table-active-color:#000;--bs-table-hover-bg:#e5c7ca;--bs-table-hover-color:#000;color:#000;border-color:#dfc2c4}.table-light[data-v-24456ff2]{--bs-table-bg:#f8f9fa;--bs-table-striped-bg:#ecedee;--bs-table-striped-color:#000;--bs-table-active-bg:#dfe0e1;--bs-table-active-color:#000;--bs-table-hover-bg:#e5e6e7;--bs-table-hover-color:#000;color:#000;border-color:#dfe0e1}.table-dark[data-v-24456ff2]{--bs-table-bg:#212529;--bs-table-striped-bg:#2c3034;--bs-table-striped-color:#fff;--bs-table-active-bg:#373b3e;--bs-table-active-color:#fff;--bs-table-hover-bg:#323539;--bs-table-hover-color:#fff;color:#fff;border-color:#373b3e}.table-responsive[data-v-24456ff2]{overflow-x:auto;-webkit-overflow-scrolling:touch}@media (max-width:575.98px){.table-responsive-sm[data-v-24456ff2]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:767.98px){.table-responsive-md[data-v-24456ff2]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:991.98px){.table-responsive-lg[data-v-24456ff2]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1199.98px){.table-responsive-xl[data-v-24456ff2]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1399.98px){.table-responsive-xxl[data-v-24456ff2]{overflow-x:auto;-webkit-overflow-scrolling:touch}}.form-label[data-v-24456ff2]{margin-bottom:.5rem}.col-form-label[data-v-24456ff2]{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg[data-v-24456ff2]{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem}.col-form-label-sm[data-v-24456ff2]{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem}.form-text[data-v-24456ff2]{margin-top:.25rem;font-size:.875em;color:#6c757d}.form-control[data-v-24456ff2]{display:block;width:100%;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-24456ff2]{transition:none}}.form-control[type=file][data-v-24456ff2]{overflow:hidden}.form-control[type=file][data-v-24456ff2]:not(:disabled):not([readonly]){cursor:pointer}.form-control[data-v-24456ff2]:focus{color:#212529;background-color:#fff;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-control[data-v-24456ff2]::-webkit-date-and-time-value{height:1.5em}.form-control[data-v-24456ff2]::-moz-placeholder{color:#6c757d;opacity:1}.form-control[data-v-24456ff2]::placeholder{color:#6c757d;opacity:1}.form-control[data-v-24456ff2]:disabled,.form-control[readonly][data-v-24456ff2]{background-color:#e9ecef;opacity:1}.form-control[data-v-24456ff2]::file-selector-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-24456ff2]::-webkit-file-upload-button{-webkit-transition:none;transition:none}.form-control[data-v-24456ff2]::file-selector-button{transition:none}}.form-control[data-v-24456ff2]:hover:not(:disabled):not([readonly])::file-selector-button{background-color:#dde0e3}.form-control[data-v-24456ff2]::-webkit-file-upload-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;-webkit-transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-24456ff2]::-webkit-file-upload-button{-webkit-transition:none;transition:none}}.form-control[data-v-24456ff2]:hover:not(:disabled):not([readonly])::-webkit-file-upload-button{background-color:#dde0e3}.form-control-plaintext[data-v-24456ff2]{display:block;width:100%;padding:.375rem 0;margin-bottom:0;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg[data-v-24456ff2],.form-control-plaintext.form-control-sm[data-v-24456ff2]{padding-right:0;padding-left:0}.form-control-sm[data-v-24456ff2]{min-height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.form-control-sm[data-v-24456ff2]::file-selector-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-sm[data-v-24456ff2]::-webkit-file-upload-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-lg[data-v-24456ff2]{min-height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.form-control-lg[data-v-24456ff2]::file-selector-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}.form-control-lg[data-v-24456ff2]::-webkit-file-upload-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}textarea.form-control[data-v-24456ff2]{min-height:calc(1.5em + .75rem + 2px)}textarea.form-control-sm[data-v-24456ff2]{min-height:calc(1.5em + .5rem + 2px)}textarea.form-control-lg[data-v-24456ff2]{min-height:calc(1.5em + 1rem + 2px)}.form-control-color[data-v-24456ff2]{width:3rem;height:auto;padding:.375rem}.form-control-color[data-v-24456ff2]:not(:disabled):not([readonly]){cursor:pointer}.form-control-color[data-v-24456ff2]::-moz-color-swatch{height:1.5em;border-radius:.25rem}.form-control-color[data-v-24456ff2]::-webkit-color-swatch{height:1.5em;border-radius:.25rem}.form-select[data-v-24456ff2]{display:block;width:100%;padding:.375rem 2.25rem .375rem .75rem;-moz-padding-start:calc(.75rem - 3px);font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right .75rem center;background-size:16px 12px;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-select[data-v-24456ff2]{transition:none}}.form-select[data-v-24456ff2]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-select[multiple][data-v-24456ff2],.form-select[size][data-v-24456ff2]:not([size=\"1\"]){padding-right:.75rem;background-image:none}.form-select[data-v-24456ff2]:disabled{background-color:#e9ecef}.form-select[data-v-24456ff2]:-moz-focusring{color:transparent;text-shadow:0 0 0 #212529}.form-select-sm[data-v-24456ff2]{padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem;border-radius:.2rem}.form-select-lg[data-v-24456ff2]{padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem;border-radius:.3rem}.form-check[data-v-24456ff2]{display:block;min-height:1.5rem;padding-left:1.5em;margin-bottom:.125rem}.form-check .form-check-input[data-v-24456ff2]{float:left;margin-left:-1.5em}.form-check-input[data-v-24456ff2]{width:1em;height:1em;margin-top:.25em;vertical-align:top;background-color:#fff;background-repeat:no-repeat;background-position:50%;background-size:contain;border:1px solid rgba(0,0,0,.25);-webkit-appearance:none;-moz-appearance:none;appearance:none;-webkit-print-color-adjust:exact;color-adjust:exact}.form-check-input[type=checkbox][data-v-24456ff2]{border-radius:.25em}.form-check-input[type=radio][data-v-24456ff2]{border-radius:50%}.form-check-input[data-v-24456ff2]:active{filter:brightness(90%)}.form-check-input[data-v-24456ff2]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-check-input[data-v-24456ff2]:checked{background-color:#0d6efd;border-color:#0d6efd}.form-check-input:checked[type=checkbox][data-v-24456ff2]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3 6-6'/%3E%3C/svg%3E\")}.form-check-input:checked[type=radio][data-v-24456ff2]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='2' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-input[type=checkbox][data-v-24456ff2]:indeterminate{background-color:#0d6efd;border-color:#0d6efd;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3E%3C/svg%3E\")}.form-check-input[data-v-24456ff2]:disabled{pointer-events:none;filter:none;opacity:.5}.form-check-input:disabled~.form-check-label[data-v-24456ff2],.form-check-input[disabled]~.form-check-label[data-v-24456ff2]{opacity:.5}.form-switch[data-v-24456ff2]{padding-left:2.5em}.form-switch .form-check-input[data-v-24456ff2]{width:2em;margin-left:-2.5em;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='rgba(0, 0, 0, 0.25)'/%3E%3C/svg%3E\");background-position:0;border-radius:2em;transition:background-position .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-switch .form-check-input[data-v-24456ff2]{transition:none}}.form-switch .form-check-input[data-v-24456ff2]:focus{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%2386b7fe'/%3E%3C/svg%3E\")}.form-switch .form-check-input[data-v-24456ff2]:checked{background-position:100%;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-inline[data-v-24456ff2]{display:inline-block;margin-right:1rem}.btn-check[data-v-24456ff2]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.btn-check:disabled+.btn[data-v-24456ff2],.btn-check[disabled]+.btn[data-v-24456ff2]{pointer-events:none;filter:none;opacity:.65}.form-range[data-v-24456ff2]{width:100%;height:1.5rem;padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.form-range[data-v-24456ff2]:focus{outline:0}.form-range[data-v-24456ff2]:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-24456ff2]:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-24456ff2]::-moz-focus-outer{border:0}.form-range[data-v-24456ff2]::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#0d6efd;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-24456ff2]::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.form-range[data-v-24456ff2]::-webkit-slider-thumb:active{background-color:#b6d4fe}.form-range[data-v-24456ff2]::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-24456ff2]::-moz-range-thumb{width:1rem;height:1rem;background-color:#0d6efd;border:0;border-radius:1rem;-moz-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-24456ff2]::-moz-range-thumb{-moz-transition:none;transition:none}}.form-range[data-v-24456ff2]::-moz-range-thumb:active{background-color:#b6d4fe}.form-range[data-v-24456ff2]::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-24456ff2]:disabled{pointer-events:none}.form-range[data-v-24456ff2]:disabled::-webkit-slider-thumb{background-color:#adb5bd}.form-range[data-v-24456ff2]:disabled::-moz-range-thumb{background-color:#adb5bd}.form-floating[data-v-24456ff2]{position:relative}.form-floating>.form-control[data-v-24456ff2],.form-floating>.form-select[data-v-24456ff2]{height:calc(3.5rem + 2px);line-height:1.25}.form-floating>label[data-v-24456ff2]{position:absolute;top:0;left:0;height:100%;padding:1rem .75rem;pointer-events:none;border:1px solid transparent;transform-origin:0 0;transition:opacity .1s ease-in-out,transform .1s ease-in-out}@media (prefers-reduced-motion:reduce){.form-floating>label[data-v-24456ff2]{transition:none}}.form-floating>.form-control[data-v-24456ff2]{padding:1rem .75rem}.form-floating>.form-control[data-v-24456ff2]::-moz-placeholder{color:transparent}.form-floating>.form-control[data-v-24456ff2]::placeholder{color:transparent}.form-floating>.form-control[data-v-24456ff2]:not(:-moz-placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-24456ff2]:focus,.form-floating>.form-control[data-v-24456ff2]:not(:placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-24456ff2]:-webkit-autofill{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-select[data-v-24456ff2]{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control:not(:-moz-placeholder-shown)~label[data-v-24456ff2]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:focus~label[data-v-24456ff2],.form-floating>.form-control:not(:placeholder-shown)~label[data-v-24456ff2],.form-floating>.form-select~label[data-v-24456ff2]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:-webkit-autofill~label[data-v-24456ff2]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.input-group[data-v-24456ff2]{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group>.form-control[data-v-24456ff2],.input-group>.form-select[data-v-24456ff2]{position:relative;flex:1 1 auto;width:1%;min-width:0}.input-group>.form-control[data-v-24456ff2]:focus,.input-group>.form-select[data-v-24456ff2]:focus{z-index:3}.input-group .btn[data-v-24456ff2]{position:relative;z-index:2}.input-group .btn[data-v-24456ff2]:focus{z-index:3}.input-group-text[data-v-24456ff2]{display:flex;align-items:center;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-lg>.btn[data-v-24456ff2],.input-group-lg>.form-control[data-v-24456ff2],.input-group-lg>.form-select[data-v-24456ff2],.input-group-lg>.input-group-text[data-v-24456ff2]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.input-group-sm>.btn[data-v-24456ff2],.input-group-sm>.form-control[data-v-24456ff2],.input-group-sm>.form-select[data-v-24456ff2],.input-group-sm>.input-group-text[data-v-24456ff2]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.input-group-lg>.form-select[data-v-24456ff2],.input-group-sm>.form-select[data-v-24456ff2]{padding-right:3rem}.input-group.has-validation>.dropdown-toggle[data-v-24456ff2]:nth-last-child(n+4),.input-group.has-validation[data-v-24456ff2]>:nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),.input-group:not(.has-validation)>.dropdown-toggle[data-v-24456ff2]:nth-last-child(n+3),.input-group[data-v-24456ff2]:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu){border-top-right-radius:0;border-bottom-right-radius:0}.input-group[data-v-24456ff2]>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}.valid-feedback[data-v-24456ff2]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#198754}.valid-tooltip[data-v-24456ff2]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(25,135,84,.9);border-radius:.25rem}.is-valid~.valid-feedback[data-v-24456ff2],.is-valid~.valid-tooltip[data-v-24456ff2],.was-validated :valid~.valid-feedback[data-v-24456ff2],.was-validated :valid~.valid-tooltip[data-v-24456ff2]{display:block}.form-control.is-valid[data-v-24456ff2],.was-validated .form-control[data-v-24456ff2]:valid{border-color:#198754;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-valid[data-v-24456ff2]:focus,.was-validated .form-control[data-v-24456ff2]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.was-validated textarea.form-control[data-v-24456ff2]:valid,textarea.form-control.is-valid[data-v-24456ff2]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-valid[data-v-24456ff2],.was-validated .form-select[data-v-24456ff2]:valid{border-color:#198754}.form-select.is-valid:not([multiple])[size=\"1\"][data-v-24456ff2],.form-select.is-valid[data-v-24456ff2]:not([multiple]):not([size]),.was-validated .form-select:valid:not([multiple])[size=\"1\"][data-v-24456ff2],.was-validated .form-select[data-v-24456ff2]:valid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-valid[data-v-24456ff2]:focus,.was-validated .form-select[data-v-24456ff2]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid[data-v-24456ff2],.was-validated .form-check-input[data-v-24456ff2]:valid{border-color:#198754}.form-check-input.is-valid[data-v-24456ff2]:checked,.was-validated .form-check-input[data-v-24456ff2]:valid:checked{background-color:#198754}.form-check-input.is-valid[data-v-24456ff2]:focus,.was-validated .form-check-input[data-v-24456ff2]:valid:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid~.form-check-label[data-v-24456ff2],.was-validated .form-check-input:valid~.form-check-label[data-v-24456ff2]{color:#198754}.form-check-inline .form-check-input~.valid-feedback[data-v-24456ff2]{margin-left:.5em}.input-group .form-control.is-valid[data-v-24456ff2],.input-group .form-select.is-valid[data-v-24456ff2],.was-validated .input-group .form-control[data-v-24456ff2]:valid,.was-validated .input-group .form-select[data-v-24456ff2]:valid{z-index:1}.input-group .form-control.is-valid[data-v-24456ff2]:focus,.input-group .form-select.is-valid[data-v-24456ff2]:focus,.was-validated .input-group .form-control[data-v-24456ff2]:valid:focus,.was-validated .input-group .form-select[data-v-24456ff2]:valid:focus{z-index:3}.invalid-feedback[data-v-24456ff2]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#dc3545}.invalid-tooltip[data-v-24456ff2]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(220,53,69,.9);border-radius:.25rem}.is-invalid~.invalid-feedback[data-v-24456ff2],.is-invalid~.invalid-tooltip[data-v-24456ff2],.was-validated :invalid~.invalid-feedback[data-v-24456ff2],.was-validated :invalid~.invalid-tooltip[data-v-24456ff2]{display:block}.form-control.is-invalid[data-v-24456ff2],.was-validated .form-control[data-v-24456ff2]:invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-invalid[data-v-24456ff2]:focus,.was-validated .form-control[data-v-24456ff2]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.was-validated textarea.form-control[data-v-24456ff2]:invalid,textarea.form-control.is-invalid[data-v-24456ff2]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-invalid[data-v-24456ff2],.was-validated .form-select[data-v-24456ff2]:invalid{border-color:#dc3545}.form-select.is-invalid:not([multiple])[size=\"1\"][data-v-24456ff2],.form-select.is-invalid[data-v-24456ff2]:not([multiple]):not([size]),.was-validated .form-select:invalid:not([multiple])[size=\"1\"][data-v-24456ff2],.was-validated .form-select[data-v-24456ff2]:invalid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-invalid[data-v-24456ff2]:focus,.was-validated .form-select[data-v-24456ff2]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid[data-v-24456ff2],.was-validated .form-check-input[data-v-24456ff2]:invalid{border-color:#dc3545}.form-check-input.is-invalid[data-v-24456ff2]:checked,.was-validated .form-check-input[data-v-24456ff2]:invalid:checked{background-color:#dc3545}.form-check-input.is-invalid[data-v-24456ff2]:focus,.was-validated .form-check-input[data-v-24456ff2]:invalid:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid~.form-check-label[data-v-24456ff2],.was-validated .form-check-input:invalid~.form-check-label[data-v-24456ff2]{color:#dc3545}.form-check-inline .form-check-input~.invalid-feedback[data-v-24456ff2]{margin-left:.5em}.input-group .form-control.is-invalid[data-v-24456ff2],.input-group .form-select.is-invalid[data-v-24456ff2],.was-validated .input-group .form-control[data-v-24456ff2]:invalid,.was-validated .input-group .form-select[data-v-24456ff2]:invalid{z-index:2}.input-group .form-control.is-invalid[data-v-24456ff2]:focus,.input-group .form-select.is-invalid[data-v-24456ff2]:focus,.was-validated .input-group .form-control[data-v-24456ff2]:invalid:focus,.was-validated .input-group .form-select[data-v-24456ff2]:invalid:focus{z-index:3}.btn[data-v-24456ff2]{display:inline-block;font-weight:400;line-height:1.5;color:#212529;text-align:center;text-decoration:none;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn[data-v-24456ff2]{transition:none}}.btn[data-v-24456ff2]:hover{color:#212529}.btn-check:focus+.btn[data-v-24456ff2],.btn[data-v-24456ff2]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.btn.disabled[data-v-24456ff2],.btn[data-v-24456ff2]:disabled,fieldset:disabled .btn[data-v-24456ff2]{pointer-events:none;opacity:.65}.btn-primary[data-v-24456ff2]{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-primary[data-v-24456ff2]:hover{color:#fff;background-color:#0b5ed7;border-color:#0a58ca}.btn-check:focus+.btn-primary[data-v-24456ff2],.btn-primary[data-v-24456ff2]:focus{color:#fff;background-color:#0b5ed7;border-color:#0a58ca;box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-check:active+.btn-primary[data-v-24456ff2],.btn-check:checked+.btn-primary[data-v-24456ff2],.btn-primary.active[data-v-24456ff2],.btn-primary[data-v-24456ff2]:active,.show>.btn-primary.dropdown-toggle[data-v-24456ff2]{color:#fff;background-color:#0a58ca;border-color:#0a53be}.btn-check:active+.btn-primary[data-v-24456ff2]:focus,.btn-check:checked+.btn-primary[data-v-24456ff2]:focus,.btn-primary.active[data-v-24456ff2]:focus,.btn-primary[data-v-24456ff2]:active:focus,.show>.btn-primary.dropdown-toggle[data-v-24456ff2]:focus{box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-primary.disabled[data-v-24456ff2],.btn-primary[data-v-24456ff2]:disabled{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-secondary[data-v-24456ff2]{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary[data-v-24456ff2]:hover{color:#fff;background-color:#5c636a;border-color:#565e64}.btn-check:focus+.btn-secondary[data-v-24456ff2],.btn-secondary[data-v-24456ff2]:focus{color:#fff;background-color:#5c636a;border-color:#565e64;box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-check:active+.btn-secondary[data-v-24456ff2],.btn-check:checked+.btn-secondary[data-v-24456ff2],.btn-secondary.active[data-v-24456ff2],.btn-secondary[data-v-24456ff2]:active,.show>.btn-secondary.dropdown-toggle[data-v-24456ff2]{color:#fff;background-color:#565e64;border-color:#51585e}.btn-check:active+.btn-secondary[data-v-24456ff2]:focus,.btn-check:checked+.btn-secondary[data-v-24456ff2]:focus,.btn-secondary.active[data-v-24456ff2]:focus,.btn-secondary[data-v-24456ff2]:active:focus,.show>.btn-secondary.dropdown-toggle[data-v-24456ff2]:focus{box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-secondary.disabled[data-v-24456ff2],.btn-secondary[data-v-24456ff2]:disabled{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-success[data-v-24456ff2]{color:#fff;background-color:#198754;border-color:#198754}.btn-success[data-v-24456ff2]:hover{color:#fff;background-color:#157347;border-color:#146c43}.btn-check:focus+.btn-success[data-v-24456ff2],.btn-success[data-v-24456ff2]:focus{color:#fff;background-color:#157347;border-color:#146c43;box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-check:active+.btn-success[data-v-24456ff2],.btn-check:checked+.btn-success[data-v-24456ff2],.btn-success.active[data-v-24456ff2],.btn-success[data-v-24456ff2]:active,.show>.btn-success.dropdown-toggle[data-v-24456ff2]{color:#fff;background-color:#146c43;border-color:#13653f}.btn-check:active+.btn-success[data-v-24456ff2]:focus,.btn-check:checked+.btn-success[data-v-24456ff2]:focus,.btn-success.active[data-v-24456ff2]:focus,.btn-success[data-v-24456ff2]:active:focus,.show>.btn-success.dropdown-toggle[data-v-24456ff2]:focus{box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-success.disabled[data-v-24456ff2],.btn-success[data-v-24456ff2]:disabled{color:#fff;background-color:#198754;border-color:#198754}.btn-info[data-v-24456ff2]{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-info[data-v-24456ff2]:hover{color:#000;background-color:#31d2f2;border-color:#25cff2}.btn-check:focus+.btn-info[data-v-24456ff2],.btn-info[data-v-24456ff2]:focus{color:#000;background-color:#31d2f2;border-color:#25cff2;box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-check:active+.btn-info[data-v-24456ff2],.btn-check:checked+.btn-info[data-v-24456ff2],.btn-info.active[data-v-24456ff2],.btn-info[data-v-24456ff2]:active,.show>.btn-info.dropdown-toggle[data-v-24456ff2]{color:#000;background-color:#3dd5f3;border-color:#25cff2}.btn-check:active+.btn-info[data-v-24456ff2]:focus,.btn-check:checked+.btn-info[data-v-24456ff2]:focus,.btn-info.active[data-v-24456ff2]:focus,.btn-info[data-v-24456ff2]:active:focus,.show>.btn-info.dropdown-toggle[data-v-24456ff2]:focus{box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-info.disabled[data-v-24456ff2],.btn-info[data-v-24456ff2]:disabled{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-warning[data-v-24456ff2]{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-warning[data-v-24456ff2]:hover{color:#000;background-color:#ffca2c;border-color:#ffc720}.btn-check:focus+.btn-warning[data-v-24456ff2],.btn-warning[data-v-24456ff2]:focus{color:#000;background-color:#ffca2c;border-color:#ffc720;box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-check:active+.btn-warning[data-v-24456ff2],.btn-check:checked+.btn-warning[data-v-24456ff2],.btn-warning.active[data-v-24456ff2],.btn-warning[data-v-24456ff2]:active,.show>.btn-warning.dropdown-toggle[data-v-24456ff2]{color:#000;background-color:#ffcd39;border-color:#ffc720}.btn-check:active+.btn-warning[data-v-24456ff2]:focus,.btn-check:checked+.btn-warning[data-v-24456ff2]:focus,.btn-warning.active[data-v-24456ff2]:focus,.btn-warning[data-v-24456ff2]:active:focus,.show>.btn-warning.dropdown-toggle[data-v-24456ff2]:focus{box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-warning.disabled[data-v-24456ff2],.btn-warning[data-v-24456ff2]:disabled{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-danger[data-v-24456ff2]{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger[data-v-24456ff2]:hover{color:#fff;background-color:#bb2d3b;border-color:#b02a37}.btn-check:focus+.btn-danger[data-v-24456ff2],.btn-danger[data-v-24456ff2]:focus{color:#fff;background-color:#bb2d3b;border-color:#b02a37;box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-check:active+.btn-danger[data-v-24456ff2],.btn-check:checked+.btn-danger[data-v-24456ff2],.btn-danger.active[data-v-24456ff2],.btn-danger[data-v-24456ff2]:active,.show>.btn-danger.dropdown-toggle[data-v-24456ff2]{color:#fff;background-color:#b02a37;border-color:#a52834}.btn-check:active+.btn-danger[data-v-24456ff2]:focus,.btn-check:checked+.btn-danger[data-v-24456ff2]:focus,.btn-danger.active[data-v-24456ff2]:focus,.btn-danger[data-v-24456ff2]:active:focus,.show>.btn-danger.dropdown-toggle[data-v-24456ff2]:focus{box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-danger.disabled[data-v-24456ff2],.btn-danger[data-v-24456ff2]:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-light[data-v-24456ff2]{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light[data-v-24456ff2]:hover{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:focus+.btn-light[data-v-24456ff2],.btn-light[data-v-24456ff2]:focus{color:#000;background-color:#f9fafb;border-color:#f9fafb;box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-check:active+.btn-light[data-v-24456ff2],.btn-check:checked+.btn-light[data-v-24456ff2],.btn-light.active[data-v-24456ff2],.btn-light[data-v-24456ff2]:active,.show>.btn-light.dropdown-toggle[data-v-24456ff2]{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:active+.btn-light[data-v-24456ff2]:focus,.btn-check:checked+.btn-light[data-v-24456ff2]:focus,.btn-light.active[data-v-24456ff2]:focus,.btn-light[data-v-24456ff2]:active:focus,.show>.btn-light.dropdown-toggle[data-v-24456ff2]:focus{box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-light.disabled[data-v-24456ff2],.btn-light[data-v-24456ff2]:disabled{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-dark[data-v-24456ff2]{color:#fff;background-color:#212529;border-color:#212529}.btn-dark[data-v-24456ff2]:hover{color:#fff;background-color:#1c1f23;border-color:#1a1e21}.btn-check:focus+.btn-dark[data-v-24456ff2],.btn-dark[data-v-24456ff2]:focus{color:#fff;background-color:#1c1f23;border-color:#1a1e21;box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-check:active+.btn-dark[data-v-24456ff2],.btn-check:checked+.btn-dark[data-v-24456ff2],.btn-dark.active[data-v-24456ff2],.btn-dark[data-v-24456ff2]:active,.show>.btn-dark.dropdown-toggle[data-v-24456ff2]{color:#fff;background-color:#1a1e21;border-color:#191c1f}.btn-check:active+.btn-dark[data-v-24456ff2]:focus,.btn-check:checked+.btn-dark[data-v-24456ff2]:focus,.btn-dark.active[data-v-24456ff2]:focus,.btn-dark[data-v-24456ff2]:active:focus,.show>.btn-dark.dropdown-toggle[data-v-24456ff2]:focus{box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-dark.disabled[data-v-24456ff2],.btn-dark[data-v-24456ff2]:disabled{color:#fff;background-color:#212529;border-color:#212529}.btn-outline-primary[data-v-24456ff2]{color:#0d6efd;border-color:#0d6efd}.btn-outline-primary[data-v-24456ff2]:hover{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:focus+.btn-outline-primary[data-v-24456ff2],.btn-outline-primary[data-v-24456ff2]:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-check:active+.btn-outline-primary[data-v-24456ff2],.btn-check:checked+.btn-outline-primary[data-v-24456ff2],.btn-outline-primary.active[data-v-24456ff2],.btn-outline-primary.dropdown-toggle.show[data-v-24456ff2],.btn-outline-primary[data-v-24456ff2]:active{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:active+.btn-outline-primary[data-v-24456ff2]:focus,.btn-check:checked+.btn-outline-primary[data-v-24456ff2]:focus,.btn-outline-primary.active[data-v-24456ff2]:focus,.btn-outline-primary.dropdown-toggle.show[data-v-24456ff2]:focus,.btn-outline-primary[data-v-24456ff2]:active:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-outline-primary.disabled[data-v-24456ff2],.btn-outline-primary[data-v-24456ff2]:disabled{color:#0d6efd;background-color:transparent}.btn-outline-secondary[data-v-24456ff2]{color:#6c757d;border-color:#6c757d}.btn-outline-secondary[data-v-24456ff2]:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:focus+.btn-outline-secondary[data-v-24456ff2],.btn-outline-secondary[data-v-24456ff2]:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-check:active+.btn-outline-secondary[data-v-24456ff2],.btn-check:checked+.btn-outline-secondary[data-v-24456ff2],.btn-outline-secondary.active[data-v-24456ff2],.btn-outline-secondary.dropdown-toggle.show[data-v-24456ff2],.btn-outline-secondary[data-v-24456ff2]:active{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:active+.btn-outline-secondary[data-v-24456ff2]:focus,.btn-check:checked+.btn-outline-secondary[data-v-24456ff2]:focus,.btn-outline-secondary.active[data-v-24456ff2]:focus,.btn-outline-secondary.dropdown-toggle.show[data-v-24456ff2]:focus,.btn-outline-secondary[data-v-24456ff2]:active:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-outline-secondary.disabled[data-v-24456ff2],.btn-outline-secondary[data-v-24456ff2]:disabled{color:#6c757d;background-color:transparent}.btn-outline-success[data-v-24456ff2]{color:#198754;border-color:#198754}.btn-outline-success[data-v-24456ff2]:hover{color:#fff;background-color:#198754;border-color:#198754}.btn-check:focus+.btn-outline-success[data-v-24456ff2],.btn-outline-success[data-v-24456ff2]:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-check:active+.btn-outline-success[data-v-24456ff2],.btn-check:checked+.btn-outline-success[data-v-24456ff2],.btn-outline-success.active[data-v-24456ff2],.btn-outline-success.dropdown-toggle.show[data-v-24456ff2],.btn-outline-success[data-v-24456ff2]:active{color:#fff;background-color:#198754;border-color:#198754}.btn-check:active+.btn-outline-success[data-v-24456ff2]:focus,.btn-check:checked+.btn-outline-success[data-v-24456ff2]:focus,.btn-outline-success.active[data-v-24456ff2]:focus,.btn-outline-success.dropdown-toggle.show[data-v-24456ff2]:focus,.btn-outline-success[data-v-24456ff2]:active:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-outline-success.disabled[data-v-24456ff2],.btn-outline-success[data-v-24456ff2]:disabled{color:#198754;background-color:transparent}.btn-outline-info[data-v-24456ff2]{color:#0dcaf0;border-color:#0dcaf0}.btn-outline-info[data-v-24456ff2]:hover{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:focus+.btn-outline-info[data-v-24456ff2],.btn-outline-info[data-v-24456ff2]:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-check:active+.btn-outline-info[data-v-24456ff2],.btn-check:checked+.btn-outline-info[data-v-24456ff2],.btn-outline-info.active[data-v-24456ff2],.btn-outline-info.dropdown-toggle.show[data-v-24456ff2],.btn-outline-info[data-v-24456ff2]:active{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:active+.btn-outline-info[data-v-24456ff2]:focus,.btn-check:checked+.btn-outline-info[data-v-24456ff2]:focus,.btn-outline-info.active[data-v-24456ff2]:focus,.btn-outline-info.dropdown-toggle.show[data-v-24456ff2]:focus,.btn-outline-info[data-v-24456ff2]:active:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-outline-info.disabled[data-v-24456ff2],.btn-outline-info[data-v-24456ff2]:disabled{color:#0dcaf0;background-color:transparent}.btn-outline-warning[data-v-24456ff2]{color:#ffc107;border-color:#ffc107}.btn-outline-warning[data-v-24456ff2]:hover{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:focus+.btn-outline-warning[data-v-24456ff2],.btn-outline-warning[data-v-24456ff2]:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-check:active+.btn-outline-warning[data-v-24456ff2],.btn-check:checked+.btn-outline-warning[data-v-24456ff2],.btn-outline-warning.active[data-v-24456ff2],.btn-outline-warning.dropdown-toggle.show[data-v-24456ff2],.btn-outline-warning[data-v-24456ff2]:active{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:active+.btn-outline-warning[data-v-24456ff2]:focus,.btn-check:checked+.btn-outline-warning[data-v-24456ff2]:focus,.btn-outline-warning.active[data-v-24456ff2]:focus,.btn-outline-warning.dropdown-toggle.show[data-v-24456ff2]:focus,.btn-outline-warning[data-v-24456ff2]:active:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-outline-warning.disabled[data-v-24456ff2],.btn-outline-warning[data-v-24456ff2]:disabled{color:#ffc107;background-color:transparent}.btn-outline-danger[data-v-24456ff2]{color:#dc3545;border-color:#dc3545}.btn-outline-danger[data-v-24456ff2]:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:focus+.btn-outline-danger[data-v-24456ff2],.btn-outline-danger[data-v-24456ff2]:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-check:active+.btn-outline-danger[data-v-24456ff2],.btn-check:checked+.btn-outline-danger[data-v-24456ff2],.btn-outline-danger.active[data-v-24456ff2],.btn-outline-danger.dropdown-toggle.show[data-v-24456ff2],.btn-outline-danger[data-v-24456ff2]:active{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:active+.btn-outline-danger[data-v-24456ff2]:focus,.btn-check:checked+.btn-outline-danger[data-v-24456ff2]:focus,.btn-outline-danger.active[data-v-24456ff2]:focus,.btn-outline-danger.dropdown-toggle.show[data-v-24456ff2]:focus,.btn-outline-danger[data-v-24456ff2]:active:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-outline-danger.disabled[data-v-24456ff2],.btn-outline-danger[data-v-24456ff2]:disabled{color:#dc3545;background-color:transparent}.btn-outline-light[data-v-24456ff2]{color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light[data-v-24456ff2]:hover{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:focus+.btn-outline-light[data-v-24456ff2],.btn-outline-light[data-v-24456ff2]:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-check:active+.btn-outline-light[data-v-24456ff2],.btn-check:checked+.btn-outline-light[data-v-24456ff2],.btn-outline-light.active[data-v-24456ff2],.btn-outline-light.dropdown-toggle.show[data-v-24456ff2],.btn-outline-light[data-v-24456ff2]:active{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:active+.btn-outline-light[data-v-24456ff2]:focus,.btn-check:checked+.btn-outline-light[data-v-24456ff2]:focus,.btn-outline-light.active[data-v-24456ff2]:focus,.btn-outline-light.dropdown-toggle.show[data-v-24456ff2]:focus,.btn-outline-light[data-v-24456ff2]:active:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-outline-light.disabled[data-v-24456ff2],.btn-outline-light[data-v-24456ff2]:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-dark[data-v-24456ff2]{color:#212529;border-color:#212529}.btn-outline-dark[data-v-24456ff2]:hover{color:#fff;background-color:#212529;border-color:#212529}.btn-check:focus+.btn-outline-dark[data-v-24456ff2],.btn-outline-dark[data-v-24456ff2]:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-check:active+.btn-outline-dark[data-v-24456ff2],.btn-check:checked+.btn-outline-dark[data-v-24456ff2],.btn-outline-dark.active[data-v-24456ff2],.btn-outline-dark.dropdown-toggle.show[data-v-24456ff2],.btn-outline-dark[data-v-24456ff2]:active{color:#fff;background-color:#212529;border-color:#212529}.btn-check:active+.btn-outline-dark[data-v-24456ff2]:focus,.btn-check:checked+.btn-outline-dark[data-v-24456ff2]:focus,.btn-outline-dark.active[data-v-24456ff2]:focus,.btn-outline-dark.dropdown-toggle.show[data-v-24456ff2]:focus,.btn-outline-dark[data-v-24456ff2]:active:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-outline-dark.disabled[data-v-24456ff2],.btn-outline-dark[data-v-24456ff2]:disabled{color:#212529;background-color:transparent}.btn-link[data-v-24456ff2]{font-weight:400;color:#0d6efd;text-decoration:underline}.btn-link[data-v-24456ff2]:hover{color:#0a58ca}.btn-link.disabled[data-v-24456ff2],.btn-link[data-v-24456ff2]:disabled{color:#6c757d}.btn-group-lg>.btn[data-v-24456ff2],.btn-lg[data-v-24456ff2]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.btn-group-sm>.btn[data-v-24456ff2],.btn-sm[data-v-24456ff2]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.fade[data-v-24456ff2]{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade[data-v-24456ff2]{transition:none}}.fade[data-v-24456ff2]:not(.show){opacity:0}.collapse[data-v-24456ff2]:not(.show){display:none}.collapsing[data-v-24456ff2]{height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.collapsing[data-v-24456ff2]{transition:none}}.collapsing.collapse-horizontal[data-v-24456ff2]{width:0;height:auto;transition:width .35s ease}@media (prefers-reduced-motion:reduce){.collapsing.collapse-horizontal[data-v-24456ff2]{transition:none}}.dropdown[data-v-24456ff2],.dropend[data-v-24456ff2],.dropstart[data-v-24456ff2],.dropup[data-v-24456ff2]{position:relative}.dropdown-toggle[data-v-24456ff2]{white-space:nowrap}.dropdown-toggle[data-v-24456ff2]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle[data-v-24456ff2]:empty:after{margin-left:0}.dropdown-menu[data-v-24456ff2]{position:absolute;z-index:1000;display:none;min-width:10rem;padding:.5rem 0;margin:0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-menu[data-bs-popper][data-v-24456ff2]{top:100%;left:0;margin-top:.125rem}.dropdown-menu-start[data-v-24456ff2]{--bs-position:start}.dropdown-menu-start[data-bs-popper][data-v-24456ff2]{right:auto;left:0}.dropdown-menu-end[data-v-24456ff2]{--bs-position:end}.dropdown-menu-end[data-bs-popper][data-v-24456ff2]{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-start[data-v-24456ff2]{--bs-position:start}.dropdown-menu-sm-start[data-bs-popper][data-v-24456ff2]{right:auto;left:0}.dropdown-menu-sm-end[data-v-24456ff2]{--bs-position:end}.dropdown-menu-sm-end[data-bs-popper][data-v-24456ff2]{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-start[data-v-24456ff2]{--bs-position:start}.dropdown-menu-md-start[data-bs-popper][data-v-24456ff2]{right:auto;left:0}.dropdown-menu-md-end[data-v-24456ff2]{--bs-position:end}.dropdown-menu-md-end[data-bs-popper][data-v-24456ff2]{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-start[data-v-24456ff2]{--bs-position:start}.dropdown-menu-lg-start[data-bs-popper][data-v-24456ff2]{right:auto;left:0}.dropdown-menu-lg-end[data-v-24456ff2]{--bs-position:end}.dropdown-menu-lg-end[data-bs-popper][data-v-24456ff2]{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-start[data-v-24456ff2]{--bs-position:start}.dropdown-menu-xl-start[data-bs-popper][data-v-24456ff2]{right:auto;left:0}.dropdown-menu-xl-end[data-v-24456ff2]{--bs-position:end}.dropdown-menu-xl-end[data-bs-popper][data-v-24456ff2]{right:0;left:auto}}@media (min-width:1400px){.dropdown-menu-xxl-start[data-v-24456ff2]{--bs-position:start}.dropdown-menu-xxl-start[data-bs-popper][data-v-24456ff2]{right:auto;left:0}.dropdown-menu-xxl-end[data-v-24456ff2]{--bs-position:end}.dropdown-menu-xxl-end[data-bs-popper][data-v-24456ff2]{right:0;left:auto}}.dropup .dropdown-menu[data-bs-popper][data-v-24456ff2]{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle[data-v-24456ff2]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle[data-v-24456ff2]:empty:after{margin-left:0}.dropend .dropdown-menu[data-bs-popper][data-v-24456ff2]{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.dropend .dropdown-toggle[data-v-24456ff2]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropend .dropdown-toggle[data-v-24456ff2]:empty:after{margin-left:0}.dropend .dropdown-toggle[data-v-24456ff2]:after{vertical-align:0}.dropstart .dropdown-menu[data-bs-popper][data-v-24456ff2]{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.dropstart .dropdown-toggle[data-v-24456ff2]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";display:none}.dropstart .dropdown-toggle[data-v-24456ff2]:before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropstart .dropdown-toggle[data-v-24456ff2]:empty:after{margin-left:0}.dropstart .dropdown-toggle[data-v-24456ff2]:before{vertical-align:0}.dropdown-divider[data-v-24456ff2]{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid rgba(0,0,0,.15)}.dropdown-item[data-v-24456ff2]{display:block;width:100%;padding:.25rem 1rem;clear:both;font-weight:400;color:#212529;text-align:inherit;text-decoration:none;white-space:nowrap;background-color:transparent;border:0}.dropdown-item[data-v-24456ff2]:focus,.dropdown-item[data-v-24456ff2]:hover{color:#1e2125;background-color:#e9ecef}.dropdown-item.active[data-v-24456ff2],.dropdown-item[data-v-24456ff2]:active{color:#fff;text-decoration:none;background-color:#0d6efd}.dropdown-item.disabled[data-v-24456ff2],.dropdown-item[data-v-24456ff2]:disabled{color:#adb5bd;pointer-events:none;background-color:transparent}.dropdown-menu.show[data-v-24456ff2]{display:block}.dropdown-header[data-v-24456ff2]{display:block;padding:.5rem 1rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.dropdown-item-text[data-v-24456ff2]{display:block;padding:.25rem 1rem;color:#212529}.dropdown-menu-dark[data-v-24456ff2]{color:#dee2e6;background-color:#343a40;border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item[data-v-24456ff2]{color:#dee2e6}.dropdown-menu-dark .dropdown-item[data-v-24456ff2]:focus,.dropdown-menu-dark .dropdown-item[data-v-24456ff2]:hover{color:#fff;background-color:hsla(0,0%,100%,.15)}.dropdown-menu-dark .dropdown-item.active[data-v-24456ff2],.dropdown-menu-dark .dropdown-item[data-v-24456ff2]:active{color:#fff;background-color:#0d6efd}.dropdown-menu-dark .dropdown-item.disabled[data-v-24456ff2],.dropdown-menu-dark .dropdown-item[data-v-24456ff2]:disabled{color:#adb5bd}.dropdown-menu-dark .dropdown-divider[data-v-24456ff2]{border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item-text[data-v-24456ff2]{color:#dee2e6}.dropdown-menu-dark .dropdown-header[data-v-24456ff2]{color:#adb5bd}.btn-group-vertical[data-v-24456ff2],.btn-group[data-v-24456ff2]{position:relative;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn[data-v-24456ff2],.btn-group>.btn[data-v-24456ff2]{position:relative;flex:1 1 auto}.btn-group-vertical>.btn-check:checked+.btn[data-v-24456ff2],.btn-group-vertical>.btn-check:focus+.btn[data-v-24456ff2],.btn-group-vertical>.btn.active[data-v-24456ff2],.btn-group-vertical>.btn[data-v-24456ff2]:active,.btn-group-vertical>.btn[data-v-24456ff2]:focus,.btn-group-vertical>.btn[data-v-24456ff2]:hover,.btn-group>.btn-check:checked+.btn[data-v-24456ff2],.btn-group>.btn-check:focus+.btn[data-v-24456ff2],.btn-group>.btn.active[data-v-24456ff2],.btn-group>.btn[data-v-24456ff2]:active,.btn-group>.btn[data-v-24456ff2]:focus,.btn-group>.btn[data-v-24456ff2]:hover{z-index:1}.btn-toolbar[data-v-24456ff2]{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar .input-group[data-v-24456ff2]{width:auto}.btn-group>.btn-group[data-v-24456ff2]:not(:first-child),.btn-group>.btn[data-v-24456ff2]:not(:first-child){margin-left:-1px}.btn-group>.btn-group:not(:last-child)>.btn[data-v-24456ff2],.btn-group>.btn[data-v-24456ff2]:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn[data-v-24456ff2],.btn-group>.btn[data-v-24456ff2]:nth-child(n+3),.btn-group>:not(.btn-check)+.btn[data-v-24456ff2]{border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split[data-v-24456ff2]{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split[data-v-24456ff2]:after,.dropend .dropdown-toggle-split[data-v-24456ff2]:after,.dropup .dropdown-toggle-split[data-v-24456ff2]:after{margin-left:0}.dropstart .dropdown-toggle-split[data-v-24456ff2]:before{margin-right:0}.btn-group-sm>.btn+.dropdown-toggle-split[data-v-24456ff2],.btn-sm+.dropdown-toggle-split[data-v-24456ff2]{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split[data-v-24456ff2],.btn-lg+.dropdown-toggle-split[data-v-24456ff2]{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical[data-v-24456ff2]{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical>.btn-group[data-v-24456ff2],.btn-group-vertical>.btn[data-v-24456ff2]{width:100%}.btn-group-vertical>.btn-group[data-v-24456ff2]:not(:first-child),.btn-group-vertical>.btn[data-v-24456ff2]:not(:first-child){margin-top:-1px}.btn-group-vertical>.btn-group:not(:last-child)>.btn[data-v-24456ff2],.btn-group-vertical>.btn[data-v-24456ff2]:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn[data-v-24456ff2],.btn-group-vertical>.btn~.btn[data-v-24456ff2]{border-top-left-radius:0;border-top-right-radius:0}.nav[data-v-24456ff2]{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link[data-v-24456ff2]{display:block;padding:.5rem 1rem;color:#0d6efd;text-decoration:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out}@media (prefers-reduced-motion:reduce){.nav-link[data-v-24456ff2]{transition:none}}.nav-link[data-v-24456ff2]:focus,.nav-link[data-v-24456ff2]:hover{color:#0a58ca}.nav-link.disabled[data-v-24456ff2]{color:#6c757d;pointer-events:none;cursor:default}.nav-tabs[data-v-24456ff2]{border-bottom:1px solid #dee2e6}.nav-tabs .nav-link[data-v-24456ff2]{margin-bottom:-1px;background:0 0;border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link[data-v-24456ff2]:focus,.nav-tabs .nav-link[data-v-24456ff2]:hover{border-color:#e9ecef #e9ecef #dee2e6;isolation:isolate}.nav-tabs .nav-link.disabled[data-v-24456ff2]{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link[data-v-24456ff2],.nav-tabs .nav-link.active[data-v-24456ff2]{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu[data-v-24456ff2]{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link[data-v-24456ff2]{background:0 0;border:0;border-radius:.25rem}.nav-pills .nav-link.active[data-v-24456ff2],.nav-pills .show>.nav-link[data-v-24456ff2]{color:#fff;background-color:#0d6efd}.nav-fill .nav-item[data-v-24456ff2],.nav-fill>.nav-link[data-v-24456ff2]{flex:1 1 auto;text-align:center}.nav-justified .nav-item[data-v-24456ff2],.nav-justified>.nav-link[data-v-24456ff2]{flex-basis:0;flex-grow:1;text-align:center}.nav-fill .nav-item .nav-link[data-v-24456ff2],.nav-justified .nav-item .nav-link[data-v-24456ff2]{width:100%}.tab-content>.tab-pane[data-v-24456ff2]{display:none}.tab-content>.active[data-v-24456ff2]{display:block}.navbar[data-v-24456ff2]{position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding-top:.5rem;padding-bottom:.5rem}.navbar>.container-fluid[data-v-24456ff2],.navbar>.container-lg[data-v-24456ff2],.navbar>.container-md[data-v-24456ff2],.navbar>.container-sm[data-v-24456ff2],.navbar>.container-xl[data-v-24456ff2],.navbar>.container-xxl[data-v-24456ff2],.navbar>.container[data-v-24456ff2]{display:flex;flex-wrap:inherit;align-items:center;justify-content:space-between}.navbar-brand[data-v-24456ff2]{padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;text-decoration:none;white-space:nowrap}.navbar-nav[data-v-24456ff2]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link[data-v-24456ff2]{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu[data-v-24456ff2]{position:static}.navbar-text[data-v-24456ff2]{padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse[data-v-24456ff2]{flex-basis:100%;flex-grow:1;align-items:center}.navbar-toggler[data-v-24456ff2]{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem;transition:box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.navbar-toggler[data-v-24456ff2]{transition:none}}.navbar-toggler[data-v-24456ff2]:hover{text-decoration:none}.navbar-toggler[data-v-24456ff2]:focus{text-decoration:none;outline:0;box-shadow:0 0 0 .25rem}.navbar-toggler-icon[data-v-24456ff2]{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;background-repeat:no-repeat;background-position:50%;background-size:100%}.navbar-nav-scroll[data-v-24456ff2]{max-height:var(--bs-scroll-height,75vh);overflow-y:auto}@media (min-width:576px){.navbar-expand-sm[data-v-24456ff2]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-sm .navbar-nav[data-v-24456ff2]{flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu[data-v-24456ff2]{position:absolute}.navbar-expand-sm .navbar-nav .nav-link[data-v-24456ff2]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm .navbar-nav-scroll[data-v-24456ff2]{overflow:visible}.navbar-expand-sm .navbar-collapse[data-v-24456ff2]{display:flex!important;flex-basis:auto}.navbar-expand-sm .navbar-toggler[data-v-24456ff2],.navbar-expand-sm .offcanvas-header[data-v-24456ff2]{display:none}.navbar-expand-sm .offcanvas[data-v-24456ff2]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-sm .offcanvas-bottom[data-v-24456ff2],.navbar-expand-sm .offcanvas-top[data-v-24456ff2]{height:auto;border-top:0;border-bottom:0}.navbar-expand-sm .offcanvas-body[data-v-24456ff2]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:768px){.navbar-expand-md[data-v-24456ff2]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-md .navbar-nav[data-v-24456ff2]{flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu[data-v-24456ff2]{position:absolute}.navbar-expand-md .navbar-nav .nav-link[data-v-24456ff2]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md .navbar-nav-scroll[data-v-24456ff2]{overflow:visible}.navbar-expand-md .navbar-collapse[data-v-24456ff2]{display:flex!important;flex-basis:auto}.navbar-expand-md .navbar-toggler[data-v-24456ff2],.navbar-expand-md .offcanvas-header[data-v-24456ff2]{display:none}.navbar-expand-md .offcanvas[data-v-24456ff2]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-md .offcanvas-bottom[data-v-24456ff2],.navbar-expand-md .offcanvas-top[data-v-24456ff2]{height:auto;border-top:0;border-bottom:0}.navbar-expand-md .offcanvas-body[data-v-24456ff2]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:992px){.navbar-expand-lg[data-v-24456ff2]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-lg .navbar-nav[data-v-24456ff2]{flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu[data-v-24456ff2]{position:absolute}.navbar-expand-lg .navbar-nav .nav-link[data-v-24456ff2]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg .navbar-nav-scroll[data-v-24456ff2]{overflow:visible}.navbar-expand-lg .navbar-collapse[data-v-24456ff2]{display:flex!important;flex-basis:auto}.navbar-expand-lg .navbar-toggler[data-v-24456ff2],.navbar-expand-lg .offcanvas-header[data-v-24456ff2]{display:none}.navbar-expand-lg .offcanvas[data-v-24456ff2]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-lg .offcanvas-bottom[data-v-24456ff2],.navbar-expand-lg .offcanvas-top[data-v-24456ff2]{height:auto;border-top:0;border-bottom:0}.navbar-expand-lg .offcanvas-body[data-v-24456ff2]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1200px){.navbar-expand-xl[data-v-24456ff2]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xl .navbar-nav[data-v-24456ff2]{flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu[data-v-24456ff2]{position:absolute}.navbar-expand-xl .navbar-nav .nav-link[data-v-24456ff2]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl .navbar-nav-scroll[data-v-24456ff2]{overflow:visible}.navbar-expand-xl .navbar-collapse[data-v-24456ff2]{display:flex!important;flex-basis:auto}.navbar-expand-xl .navbar-toggler[data-v-24456ff2],.navbar-expand-xl .offcanvas-header[data-v-24456ff2]{display:none}.navbar-expand-xl .offcanvas[data-v-24456ff2]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xl .offcanvas-bottom[data-v-24456ff2],.navbar-expand-xl .offcanvas-top[data-v-24456ff2]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xl .offcanvas-body[data-v-24456ff2]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1400px){.navbar-expand-xxl[data-v-24456ff2]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xxl .navbar-nav[data-v-24456ff2]{flex-direction:row}.navbar-expand-xxl .navbar-nav .dropdown-menu[data-v-24456ff2]{position:absolute}.navbar-expand-xxl .navbar-nav .nav-link[data-v-24456ff2]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xxl .navbar-nav-scroll[data-v-24456ff2]{overflow:visible}.navbar-expand-xxl .navbar-collapse[data-v-24456ff2]{display:flex!important;flex-basis:auto}.navbar-expand-xxl .navbar-toggler[data-v-24456ff2],.navbar-expand-xxl .offcanvas-header[data-v-24456ff2]{display:none}.navbar-expand-xxl .offcanvas[data-v-24456ff2]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xxl .offcanvas-bottom[data-v-24456ff2],.navbar-expand-xxl .offcanvas-top[data-v-24456ff2]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xxl .offcanvas-body[data-v-24456ff2]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}.navbar-expand[data-v-24456ff2]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand .navbar-nav[data-v-24456ff2]{flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu[data-v-24456ff2]{position:absolute}.navbar-expand .navbar-nav .nav-link[data-v-24456ff2]{padding-right:.5rem;padding-left:.5rem}.navbar-expand .navbar-nav-scroll[data-v-24456ff2]{overflow:visible}.navbar-expand .navbar-collapse[data-v-24456ff2]{display:flex!important;flex-basis:auto}.navbar-expand .navbar-toggler[data-v-24456ff2],.navbar-expand .offcanvas-header[data-v-24456ff2]{display:none}.navbar-expand .offcanvas[data-v-24456ff2]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand .offcanvas-bottom[data-v-24456ff2],.navbar-expand .offcanvas-top[data-v-24456ff2]{height:auto;border-top:0;border-bottom:0}.navbar-expand .offcanvas-body[data-v-24456ff2]{display:flex;flex-grow:0;padding:0;overflow-y:visible}.navbar-light .navbar-brand[data-v-24456ff2],.navbar-light .navbar-brand[data-v-24456ff2]:focus,.navbar-light .navbar-brand[data-v-24456ff2]:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link[data-v-24456ff2]{color:rgba(0,0,0,.55)}.navbar-light .navbar-nav .nav-link[data-v-24456ff2]:focus,.navbar-light .navbar-nav .nav-link[data-v-24456ff2]:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled[data-v-24456ff2]{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .nav-link.active[data-v-24456ff2],.navbar-light .navbar-nav .show>.nav-link[data-v-24456ff2]{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler[data-v-24456ff2]{color:rgba(0,0,0,.55);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon[data-v-24456ff2]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(0, 0, 0, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-light .navbar-text[data-v-24456ff2]{color:rgba(0,0,0,.55)}.navbar-light .navbar-text a[data-v-24456ff2],.navbar-light .navbar-text a[data-v-24456ff2]:focus,.navbar-light .navbar-text a[data-v-24456ff2]:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand[data-v-24456ff2],.navbar-dark .navbar-brand[data-v-24456ff2]:focus,.navbar-dark .navbar-brand[data-v-24456ff2]:hover{color:#fff}.navbar-dark .navbar-nav .nav-link[data-v-24456ff2]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-nav .nav-link[data-v-24456ff2]:focus,.navbar-dark .navbar-nav .nav-link[data-v-24456ff2]:hover{color:hsla(0,0%,100%,.75)}.navbar-dark .navbar-nav .nav-link.disabled[data-v-24456ff2]{color:hsla(0,0%,100%,.25)}.navbar-dark .navbar-nav .nav-link.active[data-v-24456ff2],.navbar-dark .navbar-nav .show>.nav-link[data-v-24456ff2]{color:#fff}.navbar-dark .navbar-toggler[data-v-24456ff2]{color:hsla(0,0%,100%,.55);border-color:hsla(0,0%,100%,.1)}.navbar-dark .navbar-toggler-icon[data-v-24456ff2]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(255, 255, 255, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-dark .navbar-text[data-v-24456ff2]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-text a[data-v-24456ff2],.navbar-dark .navbar-text a[data-v-24456ff2]:focus,.navbar-dark .navbar-text a[data-v-24456ff2]:hover{color:#fff}.card[data-v-24456ff2]{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr[data-v-24456ff2]{margin-right:0;margin-left:0}.card>.list-group[data-v-24456ff2]{border-top:inherit;border-bottom:inherit}.card>.list-group[data-v-24456ff2]:first-child{border-top-width:0;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card>.list-group[data-v-24456ff2]:last-child{border-bottom-width:0;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card>.card-header+.list-group[data-v-24456ff2],.card>.list-group+.card-footer[data-v-24456ff2]{border-top:0}.card-body[data-v-24456ff2]{flex:1 1 auto;padding:1rem}.card-title[data-v-24456ff2]{margin-bottom:.5rem}.card-subtitle[data-v-24456ff2]{margin-top:-.25rem;margin-bottom:0}.card-text[data-v-24456ff2]:last-child{margin-bottom:0}.card-link+.card-link[data-v-24456ff2]{margin-left:1rem}.card-header[data-v-24456ff2]{padding:.5rem 1rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header[data-v-24456ff2]:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-footer[data-v-24456ff2]{padding:.5rem 1rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer[data-v-24456ff2]:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs[data-v-24456ff2]{margin-bottom:-.5rem;border-bottom:0}.card-header-pills[data-v-24456ff2],.card-header-tabs[data-v-24456ff2]{margin-right:-.5rem;margin-left:-.5rem}.card-img-overlay[data-v-24456ff2]{position:absolute;top:0;right:0;bottom:0;left:0;padding:1rem;border-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-24456ff2],.card-img-top[data-v-24456ff2],.card-img[data-v-24456ff2]{width:100%}.card-img-top[data-v-24456ff2],.card-img[data-v-24456ff2]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-24456ff2],.card-img[data-v-24456ff2]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-group>.card[data-v-24456ff2]{margin-bottom:.75rem}@media (min-width:576px){.card-group[data-v-24456ff2]{display:flex;flex-flow:row wrap}.card-group>.card[data-v-24456ff2]{flex:1 0 0%;margin-bottom:0}.card-group>.card+.card[data-v-24456ff2]{margin-left:0;border-left:0}.card-group>.card[data-v-24456ff2]:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-header[data-v-24456ff2],.card-group>.card:not(:last-child) .card-img-top[data-v-24456ff2]{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-footer[data-v-24456ff2],.card-group>.card:not(:last-child) .card-img-bottom[data-v-24456ff2]{border-bottom-right-radius:0}.card-group>.card[data-v-24456ff2]:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-header[data-v-24456ff2],.card-group>.card:not(:first-child) .card-img-top[data-v-24456ff2]{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-footer[data-v-24456ff2],.card-group>.card:not(:first-child) .card-img-bottom[data-v-24456ff2]{border-bottom-left-radius:0}}.accordion-button[data-v-24456ff2]{position:relative;display:flex;align-items:center;width:100%;padding:1rem 1.25rem;font-size:1rem;color:#212529;text-align:left;background-color:#fff;border:0;border-radius:0;overflow-anchor:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,border-radius .15s ease}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-24456ff2]{transition:none}}.accordion-button[data-v-24456ff2]:not(.collapsed){color:#0c63e4;background-color:#e7f1ff;box-shadow:inset 0 -1px 0 rgba(0,0,0,.125)}.accordion-button[data-v-24456ff2]:not(.collapsed):after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230c63e4'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");transform:rotate(-180deg)}.accordion-button[data-v-24456ff2]:after{flex-shrink:0;width:1.25rem;height:1.25rem;margin-left:auto;content:\"\";background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-size:1.25rem;transition:transform .2s ease-in-out}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-24456ff2]:after{transition:none}}.accordion-button[data-v-24456ff2]:hover{z-index:2}.accordion-button[data-v-24456ff2]:focus{z-index:3;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.accordion-header[data-v-24456ff2]{margin-bottom:0}.accordion-item[data-v-24456ff2]{background-color:#fff;border:1px solid rgba(0,0,0,.125)}.accordion-item[data-v-24456ff2]:first-of-type{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.accordion-item:first-of-type .accordion-button[data-v-24456ff2]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.accordion-item[data-v-24456ff2]:not(:first-of-type){border-top:0}.accordion-item[data-v-24456ff2]:last-of-type{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-item:last-of-type .accordion-button.collapsed[data-v-24456ff2]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.accordion-item:last-of-type .accordion-collapse[data-v-24456ff2]{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-body[data-v-24456ff2]{padding:1rem 1.25rem}.accordion-flush .accordion-collapse[data-v-24456ff2]{border-width:0}.accordion-flush .accordion-item[data-v-24456ff2]{border-right:0;border-left:0;border-radius:0}.accordion-flush .accordion-item[data-v-24456ff2]:first-child{border-top:0}.accordion-flush .accordion-item[data-v-24456ff2]:last-child{border-bottom:0}.accordion-flush .accordion-item .accordion-button[data-v-24456ff2]{border-radius:0}.breadcrumb[data-v-24456ff2]{display:flex;flex-wrap:wrap;padding:0;margin-bottom:1rem;list-style:none}.breadcrumb-item+.breadcrumb-item[data-v-24456ff2]{padding-left:.5rem}.breadcrumb-item+.breadcrumb-item[data-v-24456ff2]:before{float:left;padding-right:.5rem;color:#6c757d;content:var(--bs-breadcrumb-divider,\"/\")}.breadcrumb-item.active[data-v-24456ff2]{color:#6c757d}.pagination[data-v-24456ff2]{display:flex;padding-left:0;list-style:none}.page-link[data-v-24456ff2]{position:relative;display:block;color:#0d6efd;text-decoration:none;background-color:#fff;border:1px solid #dee2e6;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.page-link[data-v-24456ff2]{transition:none}}.page-link[data-v-24456ff2]:hover{z-index:2;color:#0a58ca;background-color:#e9ecef;border-color:#dee2e6}.page-link[data-v-24456ff2]:focus{z-index:3;color:#0a58ca;background-color:#e9ecef;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.page-item:not(:first-child) .page-link[data-v-24456ff2]{margin-left:-1px}.page-item.active .page-link[data-v-24456ff2]{z-index:3;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.page-item.disabled .page-link[data-v-24456ff2]{color:#6c757d;pointer-events:none;background-color:#fff;border-color:#dee2e6}.page-link[data-v-24456ff2]{padding:.375rem .75rem}.page-item:first-child .page-link[data-v-24456ff2]{border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item:last-child .page-link[data-v-24456ff2]{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.pagination-lg .page-link[data-v-24456ff2]{padding:.75rem 1.5rem;font-size:1.25rem}.pagination-lg .page-item:first-child .page-link[data-v-24456ff2]{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link[data-v-24456ff2]{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm .page-link[data-v-24456ff2]{padding:.25rem .5rem;font-size:.875rem}.pagination-sm .page-item:first-child .page-link[data-v-24456ff2]{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link[data-v-24456ff2]{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge[data-v-24456ff2]{display:inline-block;padding:.35em .65em;font-size:.75em;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}.badge[data-v-24456ff2]:empty{display:none}.btn .badge[data-v-24456ff2]{position:relative;top:-1px}.alert[data-v-24456ff2]{position:relative;padding:1rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading[data-v-24456ff2]{color:inherit}.alert-link[data-v-24456ff2]{font-weight:700}.alert-dismissible[data-v-24456ff2]{padding-right:3rem}.alert-dismissible .btn-close[data-v-24456ff2]{position:absolute;top:0;right:0;z-index:2;padding:1.25rem 1rem}.alert-primary[data-v-24456ff2]{color:#084298;background-color:#cfe2ff;border-color:#b6d4fe}.alert-primary .alert-link[data-v-24456ff2]{color:#06357a}.alert-secondary[data-v-24456ff2]{color:#41464b;background-color:#e2e3e5;border-color:#d3d6d8}.alert-secondary .alert-link[data-v-24456ff2]{color:#34383c}.alert-success[data-v-24456ff2]{color:#0f5132;background-color:#d1e7dd;border-color:#badbcc}.alert-success .alert-link[data-v-24456ff2]{color:#0c4128}.alert-info[data-v-24456ff2]{color:#055160;background-color:#cff4fc;border-color:#b6effb}.alert-info .alert-link[data-v-24456ff2]{color:#04414d}.alert-warning[data-v-24456ff2]{color:#664d03;background-color:#fff3cd;border-color:#ffecb5}.alert-warning .alert-link[data-v-24456ff2]{color:#523e02}.alert-danger[data-v-24456ff2]{color:#842029;background-color:#f8d7da;border-color:#f5c2c7}.alert-danger .alert-link[data-v-24456ff2]{color:#6a1a21}.alert-light[data-v-24456ff2]{color:#636464;background-color:#fefefe;border-color:#fdfdfe}.alert-light .alert-link[data-v-24456ff2]{color:#4f5050}.alert-dark[data-v-24456ff2]{color:#141619;background-color:#d3d3d4;border-color:#bcbebf}.alert-dark .alert-link[data-v-24456ff2]{color:#101214}@-webkit-keyframes progress-bar-stripes-data-v-24456ff2{0%{background-position-x:1rem}}@keyframes progress-bar-stripes-data-v-24456ff2{0%{background-position-x:1rem}}.progress[data-v-24456ff2]{display:flex;height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress-bar[data-v-24456ff2]{display:flex;flex-direction:column;justify-content:center;overflow:hidden;color:#fff;text-align:center;white-space:nowrap;background-color:#0d6efd;transition:width .6s ease}@media (prefers-reduced-motion:reduce){.progress-bar[data-v-24456ff2]{transition:none}}.progress-bar-striped[data-v-24456ff2]{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-bar-animated[data-v-24456ff2]{-webkit-animation:1s linear infinite progress-bar-stripes-data-v-24456ff2;animation:1s linear infinite progress-bar-stripes-data-v-24456ff2}@media (prefers-reduced-motion:reduce){.progress-bar-animated[data-v-24456ff2]{-webkit-animation:none;animation:none}}.list-group[data-v-24456ff2]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:.25rem}.list-group-numbered[data-v-24456ff2]{list-style-type:none;counter-reset:section}.list-group-numbered>li[data-v-24456ff2]:before{content:counters(section,\".\") \". \";counter-increment:section}.list-group-item-action[data-v-24456ff2]{width:100%;color:#495057;text-align:inherit}.list-group-item-action[data-v-24456ff2]:focus,.list-group-item-action[data-v-24456ff2]:hover{z-index:1;color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action[data-v-24456ff2]:active{color:#212529;background-color:#e9ecef}.list-group-item[data-v-24456ff2]{position:relative;display:block;padding:.5rem 1rem;color:#212529;text-decoration:none;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item[data-v-24456ff2]:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.list-group-item[data-v-24456ff2]:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.list-group-item.disabled[data-v-24456ff2],.list-group-item[data-v-24456ff2]:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.list-group-item.active[data-v-24456ff2]{z-index:2;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.list-group-item+.list-group-item[data-v-24456ff2]{border-top-width:0}.list-group-item+.list-group-item.active[data-v-24456ff2]{margin-top:-1px;border-top-width:1px}.list-group-horizontal[data-v-24456ff2]{flex-direction:row}.list-group-horizontal>.list-group-item[data-v-24456ff2]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal>.list-group-item[data-v-24456ff2]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal>.list-group-item.active[data-v-24456ff2]{margin-top:0}.list-group-horizontal>.list-group-item+.list-group-item[data-v-24456ff2]{border-top-width:1px;border-left-width:0}.list-group-horizontal>.list-group-item+.list-group-item.active[data-v-24456ff2]{margin-left:-1px;border-left-width:1px}@media (min-width:576px){.list-group-horizontal-sm[data-v-24456ff2]{flex-direction:row}.list-group-horizontal-sm>.list-group-item[data-v-24456ff2]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-sm>.list-group-item[data-v-24456ff2]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-sm>.list-group-item.active[data-v-24456ff2]{margin-top:0}.list-group-horizontal-sm>.list-group-item+.list-group-item[data-v-24456ff2]{border-top-width:1px;border-left-width:0}.list-group-horizontal-sm>.list-group-item+.list-group-item.active[data-v-24456ff2]{margin-left:-1px;border-left-width:1px}}@media (min-width:768px){.list-group-horizontal-md[data-v-24456ff2]{flex-direction:row}.list-group-horizontal-md>.list-group-item[data-v-24456ff2]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-md>.list-group-item[data-v-24456ff2]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-md>.list-group-item.active[data-v-24456ff2]{margin-top:0}.list-group-horizontal-md>.list-group-item+.list-group-item[data-v-24456ff2]{border-top-width:1px;border-left-width:0}.list-group-horizontal-md>.list-group-item+.list-group-item.active[data-v-24456ff2]{margin-left:-1px;border-left-width:1px}}@media (min-width:992px){.list-group-horizontal-lg[data-v-24456ff2]{flex-direction:row}.list-group-horizontal-lg>.list-group-item[data-v-24456ff2]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-lg>.list-group-item[data-v-24456ff2]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-lg>.list-group-item.active[data-v-24456ff2]{margin-top:0}.list-group-horizontal-lg>.list-group-item+.list-group-item[data-v-24456ff2]{border-top-width:1px;border-left-width:0}.list-group-horizontal-lg>.list-group-item+.list-group-item.active[data-v-24456ff2]{margin-left:-1px;border-left-width:1px}}@media (min-width:1200px){.list-group-horizontal-xl[data-v-24456ff2]{flex-direction:row}.list-group-horizontal-xl>.list-group-item[data-v-24456ff2]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xl>.list-group-item[data-v-24456ff2]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xl>.list-group-item.active[data-v-24456ff2]{margin-top:0}.list-group-horizontal-xl>.list-group-item+.list-group-item[data-v-24456ff2]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xl>.list-group-item+.list-group-item.active[data-v-24456ff2]{margin-left:-1px;border-left-width:1px}}@media (min-width:1400px){.list-group-horizontal-xxl[data-v-24456ff2]{flex-direction:row}.list-group-horizontal-xxl>.list-group-item[data-v-24456ff2]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xxl>.list-group-item[data-v-24456ff2]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xxl>.list-group-item.active[data-v-24456ff2]{margin-top:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item[data-v-24456ff2]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item.active[data-v-24456ff2]{margin-left:-1px;border-left-width:1px}}.list-group-flush[data-v-24456ff2]{border-radius:0}.list-group-flush>.list-group-item[data-v-24456ff2]{border-width:0 0 1px}.list-group-flush>.list-group-item[data-v-24456ff2]:last-child{border-bottom-width:0}.list-group-item-primary[data-v-24456ff2]{color:#084298;background-color:#cfe2ff}.list-group-item-primary.list-group-item-action[data-v-24456ff2]:focus,.list-group-item-primary.list-group-item-action[data-v-24456ff2]:hover{color:#084298;background-color:#bacbe6}.list-group-item-primary.list-group-item-action.active[data-v-24456ff2]{color:#fff;background-color:#084298;border-color:#084298}.list-group-item-secondary[data-v-24456ff2]{color:#41464b;background-color:#e2e3e5}.list-group-item-secondary.list-group-item-action[data-v-24456ff2]:focus,.list-group-item-secondary.list-group-item-action[data-v-24456ff2]:hover{color:#41464b;background-color:#cbccce}.list-group-item-secondary.list-group-item-action.active[data-v-24456ff2]{color:#fff;background-color:#41464b;border-color:#41464b}.list-group-item-success[data-v-24456ff2]{color:#0f5132;background-color:#d1e7dd}.list-group-item-success.list-group-item-action[data-v-24456ff2]:focus,.list-group-item-success.list-group-item-action[data-v-24456ff2]:hover{color:#0f5132;background-color:#bcd0c7}.list-group-item-success.list-group-item-action.active[data-v-24456ff2]{color:#fff;background-color:#0f5132;border-color:#0f5132}.list-group-item-info[data-v-24456ff2]{color:#055160;background-color:#cff4fc}.list-group-item-info.list-group-item-action[data-v-24456ff2]:focus,.list-group-item-info.list-group-item-action[data-v-24456ff2]:hover{color:#055160;background-color:#badce3}.list-group-item-info.list-group-item-action.active[data-v-24456ff2]{color:#fff;background-color:#055160;border-color:#055160}.list-group-item-warning[data-v-24456ff2]{color:#664d03;background-color:#fff3cd}.list-group-item-warning.list-group-item-action[data-v-24456ff2]:focus,.list-group-item-warning.list-group-item-action[data-v-24456ff2]:hover{color:#664d03;background-color:#e6dbb9}.list-group-item-warning.list-group-item-action.active[data-v-24456ff2]{color:#fff;background-color:#664d03;border-color:#664d03}.list-group-item-danger[data-v-24456ff2]{color:#842029;background-color:#f8d7da}.list-group-item-danger.list-group-item-action[data-v-24456ff2]:focus,.list-group-item-danger.list-group-item-action[data-v-24456ff2]:hover{color:#842029;background-color:#dfc2c4}.list-group-item-danger.list-group-item-action.active[data-v-24456ff2]{color:#fff;background-color:#842029;border-color:#842029}.list-group-item-light[data-v-24456ff2]{color:#636464;background-color:#fefefe}.list-group-item-light.list-group-item-action[data-v-24456ff2]:focus,.list-group-item-light.list-group-item-action[data-v-24456ff2]:hover{color:#636464;background-color:#e5e5e5}.list-group-item-light.list-group-item-action.active[data-v-24456ff2]{color:#fff;background-color:#636464;border-color:#636464}.list-group-item-dark[data-v-24456ff2]{color:#141619;background-color:#d3d3d4}.list-group-item-dark.list-group-item-action[data-v-24456ff2]:focus,.list-group-item-dark.list-group-item-action[data-v-24456ff2]:hover{color:#141619;background-color:#bebebf}.list-group-item-dark.list-group-item-action.active[data-v-24456ff2]{color:#fff;background-color:#141619;border-color:#141619}.btn-close[data-v-24456ff2]{box-sizing:content-box;width:1em;height:1em;padding:.25em;color:#000;background:transparent url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M.293.293a1 1 0 11.414 0 NaN NaNlNaN NaN NaN NaNa1 1 0 111.414 1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 10-1.414 NaN NaNz'/%3E%3C/svg%3E\") 50%/1em auto no-repeat;border:0;border-radius:.25rem;opacity:.5}.btn-close[data-v-24456ff2]:hover{color:#000;text-decoration:none;opacity:.75}.btn-close[data-v-24456ff2]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25);opacity:1}.btn-close.disabled[data-v-24456ff2],.btn-close[data-v-24456ff2]:disabled{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;opacity:.25}.btn-close-white[data-v-24456ff2]{filter:invert(1) grayscale(100%) brightness(200%)}.toast[data-v-24456ff2]{width:350px;max-width:100%;font-size:.875rem;pointer-events:auto;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .5rem 1rem rgba(0,0,0,.15);border-radius:.25rem}.toast.showing[data-v-24456ff2]{opacity:0}.toast[data-v-24456ff2]:not(.show){display:none}.toast-container[data-v-24456ff2]{width:-webkit-max-content;width:-moz-max-content;width:max-content;max-width:100%;pointer-events:none}.toast-container[data-v-24456ff2]>:not(:last-child){margin-bottom:.75rem}.toast-header[data-v-24456ff2]{display:flex;align-items:center;padding:.5rem .75rem;color:#6c757d;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05);border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.toast-header .btn-close[data-v-24456ff2]{margin-right:-.375rem;margin-left:.75rem}.toast-body[data-v-24456ff2]{padding:.75rem;word-wrap:break-word}.modal[data-v-24456ff2]{position:fixed;top:0;left:0;z-index:1055;display:none;width:100%;height:100%;overflow-x:hidden;overflow-y:auto;outline:0}.modal-dialog[data-v-24456ff2]{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog[data-v-24456ff2]{transition:transform .3s ease-out;transform:translateY(-50px)}@media (prefers-reduced-motion:reduce){.modal.fade .modal-dialog[data-v-24456ff2]{transition:none}}.modal.show .modal-dialog[data-v-24456ff2]{transform:none}.modal.modal-static .modal-dialog[data-v-24456ff2]{transform:scale(1.02)}.modal-dialog-scrollable[data-v-24456ff2]{height:calc(100% - 1rem)}.modal-dialog-scrollable .modal-content[data-v-24456ff2]{max-height:100%;overflow:hidden}.modal-dialog-scrollable .modal-body[data-v-24456ff2]{overflow-y:auto}.modal-dialog-centered[data-v-24456ff2]{display:flex;align-items:center;min-height:calc(100% - 1rem)}.modal-content[data-v-24456ff2]{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop[data-v-24456ff2]{position:fixed;top:0;left:0;z-index:1050;width:100vw;height:100vh;background-color:#000}.modal-backdrop.fade[data-v-24456ff2]{opacity:0}.modal-backdrop.show[data-v-24456ff2]{opacity:.5}.modal-header[data-v-24456ff2]{display:flex;flex-shrink:0;align-items:center;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.modal-header .btn-close[data-v-24456ff2]{padding:.5rem;margin:-.5rem -.5rem -.5rem auto}.modal-title[data-v-24456ff2]{margin-bottom:0;line-height:1.5}.modal-body[data-v-24456ff2]{position:relative;flex:1 1 auto;padding:1rem}.modal-footer[data-v-24456ff2]{display:flex;flex-wrap:wrap;flex-shrink:0;align-items:center;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.modal-footer>[data-v-24456ff2]{margin:.25rem}@media (min-width:576px){.modal-dialog[data-v-24456ff2]{max-width:500px;margin:1.75rem auto}.modal-dialog-scrollable[data-v-24456ff2]{height:calc(100% - 3.5rem)}.modal-dialog-centered[data-v-24456ff2]{min-height:calc(100% - 3.5rem)}.modal-sm[data-v-24456ff2]{max-width:300px}}@media (min-width:992px){.modal-lg[data-v-24456ff2],.modal-xl[data-v-24456ff2]{max-width:800px}}@media (min-width:1200px){.modal-xl[data-v-24456ff2]{max-width:1140px}}.modal-fullscreen[data-v-24456ff2]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen .modal-content[data-v-24456ff2]{height:100%;border:0;border-radius:0}.modal-fullscreen .modal-header[data-v-24456ff2]{border-radius:0}.modal-fullscreen .modal-body[data-v-24456ff2]{overflow-y:auto}.modal-fullscreen .modal-footer[data-v-24456ff2]{border-radius:0}@media (max-width:575.98px){.modal-fullscreen-sm-down[data-v-24456ff2]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-sm-down .modal-content[data-v-24456ff2]{height:100%;border:0;border-radius:0}.modal-fullscreen-sm-down .modal-header[data-v-24456ff2]{border-radius:0}.modal-fullscreen-sm-down .modal-body[data-v-24456ff2]{overflow-y:auto}.modal-fullscreen-sm-down .modal-footer[data-v-24456ff2]{border-radius:0}}@media (max-width:767.98px){.modal-fullscreen-md-down[data-v-24456ff2]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-md-down .modal-content[data-v-24456ff2]{height:100%;border:0;border-radius:0}.modal-fullscreen-md-down .modal-header[data-v-24456ff2]{border-radius:0}.modal-fullscreen-md-down .modal-body[data-v-24456ff2]{overflow-y:auto}.modal-fullscreen-md-down .modal-footer[data-v-24456ff2]{border-radius:0}}@media (max-width:991.98px){.modal-fullscreen-lg-down[data-v-24456ff2]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-lg-down .modal-content[data-v-24456ff2]{height:100%;border:0;border-radius:0}.modal-fullscreen-lg-down .modal-header[data-v-24456ff2]{border-radius:0}.modal-fullscreen-lg-down .modal-body[data-v-24456ff2]{overflow-y:auto}.modal-fullscreen-lg-down .modal-footer[data-v-24456ff2]{border-radius:0}}@media (max-width:1199.98px){.modal-fullscreen-xl-down[data-v-24456ff2]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xl-down .modal-content[data-v-24456ff2]{height:100%;border:0;border-radius:0}.modal-fullscreen-xl-down .modal-header[data-v-24456ff2]{border-radius:0}.modal-fullscreen-xl-down .modal-body[data-v-24456ff2]{overflow-y:auto}.modal-fullscreen-xl-down .modal-footer[data-v-24456ff2]{border-radius:0}}@media (max-width:1399.98px){.modal-fullscreen-xxl-down[data-v-24456ff2]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xxl-down .modal-content[data-v-24456ff2]{height:100%;border:0;border-radius:0}.modal-fullscreen-xxl-down .modal-header[data-v-24456ff2]{border-radius:0}.modal-fullscreen-xxl-down .modal-body[data-v-24456ff2]{overflow-y:auto}.modal-fullscreen-xxl-down .modal-footer[data-v-24456ff2]{border-radius:0}}.tooltip[data-v-24456ff2]{position:absolute;z-index:1080;display:block;margin:0;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show[data-v-24456ff2]{opacity:.9}.tooltip .tooltip-arrow[data-v-24456ff2]{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .tooltip-arrow[data-v-24456ff2]:before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[data-popper-placement^=top][data-v-24456ff2],.bs-tooltip-top[data-v-24456ff2]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-24456ff2],.bs-tooltip-top .tooltip-arrow[data-v-24456ff2]{bottom:0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-24456ff2]:before,.bs-tooltip-top .tooltip-arrow[data-v-24456ff2]:before{top:-1px;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[data-popper-placement^=right][data-v-24456ff2],.bs-tooltip-end[data-v-24456ff2]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-24456ff2],.bs-tooltip-end .tooltip-arrow[data-v-24456ff2]{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-24456ff2]:before,.bs-tooltip-end .tooltip-arrow[data-v-24456ff2]:before{right:-1px;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[data-popper-placement^=bottom][data-v-24456ff2],.bs-tooltip-bottom[data-v-24456ff2]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-24456ff2],.bs-tooltip-bottom .tooltip-arrow[data-v-24456ff2]{top:0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-24456ff2]:before,.bs-tooltip-bottom .tooltip-arrow[data-v-24456ff2]:before{bottom:-1px;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[data-popper-placement^=left][data-v-24456ff2],.bs-tooltip-start[data-v-24456ff2]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-24456ff2],.bs-tooltip-start .tooltip-arrow[data-v-24456ff2]{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-24456ff2]:before,.bs-tooltip-start .tooltip-arrow[data-v-24456ff2]:before{left:-1px;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner[data-v-24456ff2]{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover[data-v-24456ff2]{position:absolute;top:0;left:0;z-index:1070;display:block;max-width:276px;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover .popover-arrow[data-v-24456ff2]{position:absolute;display:block;width:1rem;height:.5rem}.popover .popover-arrow[data-v-24456ff2]:after,.popover .popover-arrow[data-v-24456ff2]:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-24456ff2],.bs-popover-top>.popover-arrow[data-v-24456ff2]{bottom:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-24456ff2]:before,.bs-popover-top>.popover-arrow[data-v-24456ff2]:before{bottom:0;border-width:.5rem .5rem 0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-24456ff2]:after,.bs-popover-top>.popover-arrow[data-v-24456ff2]:after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:#fff}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-24456ff2],.bs-popover-end>.popover-arrow[data-v-24456ff2]{left:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-24456ff2]:before,.bs-popover-end>.popover-arrow[data-v-24456ff2]:before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-24456ff2]:after,.bs-popover-end>.popover-arrow[data-v-24456ff2]:after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:#fff}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-24456ff2],.bs-popover-bottom>.popover-arrow[data-v-24456ff2]{top:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-24456ff2]:before,.bs-popover-bottom>.popover-arrow[data-v-24456ff2]:before{top:0;border-width:0 .5rem .5rem;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-24456ff2]:after,.bs-popover-bottom>.popover-arrow[data-v-24456ff2]:after{top:1px;border-width:0 .5rem .5rem;border-bottom-color:#fff}.bs-popover-auto[data-popper-placement^=bottom] .popover-header[data-v-24456ff2]:before,.bs-popover-bottom .popover-header[data-v-24456ff2]:before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f0f0f0}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-24456ff2],.bs-popover-start>.popover-arrow[data-v-24456ff2]{right:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-24456ff2]:before,.bs-popover-start>.popover-arrow[data-v-24456ff2]:before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-24456ff2]:after,.bs-popover-start>.popover-arrow[data-v-24456ff2]:after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:#fff}.popover-header[data-v-24456ff2]{padding:.5rem 1rem;margin-bottom:0;font-size:1rem;background-color:#f0f0f0;border-bottom:1px solid rgba(0,0,0,.2);border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header[data-v-24456ff2]:empty{display:none}.popover-body[data-v-24456ff2]{padding:1rem;color:#212529}.carousel[data-v-24456ff2]{position:relative}.carousel.pointer-event[data-v-24456ff2]{touch-action:pan-y}.carousel-inner[data-v-24456ff2]{position:relative;width:100%;overflow:hidden}.carousel-inner[data-v-24456ff2]:after{display:block;clear:both;content:\"\"}.carousel-item[data-v-24456ff2]{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.carousel-item[data-v-24456ff2]{transition:none}}.carousel-item-next[data-v-24456ff2],.carousel-item-prev[data-v-24456ff2],.carousel-item.active[data-v-24456ff2]{display:block}.active.carousel-item-end[data-v-24456ff2],.carousel-item-next[data-v-24456ff2]:not(.carousel-item-start){transform:translateX(100%)}.active.carousel-item-start[data-v-24456ff2],.carousel-item-prev[data-v-24456ff2]:not(.carousel-item-end){transform:translateX(-100%)}.carousel-fade .carousel-item[data-v-24456ff2]{opacity:0;transition-property:opacity;transform:none}.carousel-fade .carousel-item-next.carousel-item-start[data-v-24456ff2],.carousel-fade .carousel-item-prev.carousel-item-end[data-v-24456ff2],.carousel-fade .carousel-item.active[data-v-24456ff2]{z-index:1;opacity:1}.carousel-fade .active.carousel-item-end[data-v-24456ff2],.carousel-fade .active.carousel-item-start[data-v-24456ff2]{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.carousel-fade .active.carousel-item-end[data-v-24456ff2],.carousel-fade .active.carousel-item-start[data-v-24456ff2]{transition:none}}.carousel-control-next[data-v-24456ff2],.carousel-control-prev[data-v-24456ff2]{position:absolute;top:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center;width:15%;padding:0;color:#fff;text-align:center;background:0 0;border:0;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.carousel-control-next[data-v-24456ff2],.carousel-control-prev[data-v-24456ff2]{transition:none}}.carousel-control-next[data-v-24456ff2]:focus,.carousel-control-next[data-v-24456ff2]:hover,.carousel-control-prev[data-v-24456ff2]:focus,.carousel-control-prev[data-v-24456ff2]:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev[data-v-24456ff2]{left:0}.carousel-control-next[data-v-24456ff2]{right:0}.carousel-control-next-icon[data-v-24456ff2],.carousel-control-prev-icon[data-v-24456ff2]{display:inline-block;width:2rem;height:2rem;background-repeat:no-repeat;background-position:50%;background-size:100% 100%}.carousel-control-prev-icon[data-v-24456ff2]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3E%3C/svg%3E\")}.carousel-control-next-icon[data-v-24456ff2]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\")}.carousel-indicators[data-v-24456ff2]{position:absolute;right:0;bottom:0;left:0;z-index:2;display:flex;justify-content:center;padding:0;margin-right:15%;margin-bottom:1rem;margin-left:15%;list-style:none}.carousel-indicators [data-bs-target][data-v-24456ff2]{box-sizing:content-box;flex:0 1 auto;width:30px;height:3px;padding:0;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border:0;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.carousel-indicators [data-bs-target][data-v-24456ff2]{transition:none}}.carousel-indicators .active[data-v-24456ff2]{opacity:1}.carousel-caption[data-v-24456ff2]{position:absolute;right:15%;bottom:1.25rem;left:15%;padding-top:1.25rem;padding-bottom:1.25rem;color:#fff;text-align:center}.carousel-dark .carousel-control-next-icon[data-v-24456ff2],.carousel-dark .carousel-control-prev-icon[data-v-24456ff2]{filter:invert(1) grayscale(100)}.carousel-dark .carousel-indicators [data-bs-target][data-v-24456ff2]{background-color:#000}.carousel-dark .carousel-caption[data-v-24456ff2]{color:#000}@-webkit-keyframes spinner-border-data-v-24456ff2{to{transform:rotate(1turn)}}@keyframes spinner-border-data-v-24456ff2{to{transform:rotate(1turn)}}.spinner-border[data-v-24456ff2]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:.75s linear infinite spinner-border-data-v-24456ff2;animation:.75s linear infinite spinner-border-data-v-24456ff2}.spinner-border-sm[data-v-24456ff2]{width:1rem;height:1rem;border-width:.2em}@-webkit-keyframes spinner-grow-data-v-24456ff2{0%{transform:scale(0)}50%{opacity:1;transform:none}}@keyframes spinner-grow-data-v-24456ff2{0%{transform:scale(0)}50%{opacity:1;transform:none}}.spinner-grow[data-v-24456ff2]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;background-color:currentColor;border-radius:50%;opacity:0;-webkit-animation:.75s linear infinite spinner-grow-data-v-24456ff2;animation:.75s linear infinite spinner-grow-data-v-24456ff2}.spinner-grow-sm[data-v-24456ff2]{width:1rem;height:1rem}@media (prefers-reduced-motion:reduce){.spinner-border[data-v-24456ff2],.spinner-grow[data-v-24456ff2]{-webkit-animation-duration:1.5s;animation-duration:1.5s}}.offcanvas[data-v-24456ff2]{position:fixed;bottom:0;z-index:1045;display:flex;flex-direction:column;max-width:100%;visibility:hidden;background-color:#fff;background-clip:padding-box;outline:0;transition:transform .3s ease-in-out}@media (prefers-reduced-motion:reduce){.offcanvas[data-v-24456ff2]{transition:none}}.offcanvas-backdrop[data-v-24456ff2]{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.offcanvas-backdrop.fade[data-v-24456ff2]{opacity:0}.offcanvas-backdrop.show[data-v-24456ff2]{opacity:.5}.offcanvas-header[data-v-24456ff2]{display:flex;align-items:center;justify-content:space-between;padding:1rem}.offcanvas-header .btn-close[data-v-24456ff2]{padding:.5rem;margin-top:-.5rem;margin-right:-.5rem;margin-bottom:-.5rem}.offcanvas-title[data-v-24456ff2]{margin-bottom:0;line-height:1.5}.offcanvas-body[data-v-24456ff2]{flex-grow:1;padding:1rem;overflow-y:auto}.offcanvas-start[data-v-24456ff2]{top:0;left:0;width:400px;border-right:1px solid rgba(0,0,0,.2);transform:translateX(-100%)}.offcanvas-end[data-v-24456ff2]{top:0;right:0;width:400px;border-left:1px solid rgba(0,0,0,.2);transform:translateX(100%)}.offcanvas-top[data-v-24456ff2]{top:0;right:0;left:0;height:30vh;max-height:100%;border-bottom:1px solid rgba(0,0,0,.2);transform:translateY(-100%)}.offcanvas-bottom[data-v-24456ff2]{right:0;left:0;height:30vh;max-height:100%;border-top:1px solid rgba(0,0,0,.2);transform:translateY(100%)}.offcanvas.show[data-v-24456ff2]{transform:none}.placeholder[data-v-24456ff2]{display:inline-block;min-height:1em;vertical-align:middle;cursor:wait;background-color:currentColor;opacity:.5}.placeholder.btn[data-v-24456ff2]:before{display:inline-block;content:\"\"}.placeholder-xs[data-v-24456ff2]{min-height:.6em}.placeholder-sm[data-v-24456ff2]{min-height:.8em}.placeholder-lg[data-v-24456ff2]{min-height:1.2em}.placeholder-glow .placeholder[data-v-24456ff2]{-webkit-animation:placeholder-glow-data-v-24456ff2 2s ease-in-out infinite;animation:placeholder-glow-data-v-24456ff2 2s ease-in-out infinite}@-webkit-keyframes placeholder-glow-data-v-24456ff2{50%{opacity:.2}}@keyframes placeholder-glow-data-v-24456ff2{50%{opacity:.2}}.placeholder-wave[data-v-24456ff2]{-webkit-mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);-webkit-mask-size:200% 100%;mask-size:200% 100%;-webkit-animation:placeholder-wave-data-v-24456ff2 2s linear infinite;animation:placeholder-wave-data-v-24456ff2 2s linear infinite}@-webkit-keyframes placeholder-wave-data-v-24456ff2{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}@keyframes placeholder-wave-data-v-24456ff2{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}.clearfix[data-v-24456ff2]:after{display:block;clear:both;content:\"\"}.link-primary[data-v-24456ff2]{color:#0d6efd}.link-primary[data-v-24456ff2]:focus,.link-primary[data-v-24456ff2]:hover{color:#0a58ca}.link-secondary[data-v-24456ff2]{color:#6c757d}.link-secondary[data-v-24456ff2]:focus,.link-secondary[data-v-24456ff2]:hover{color:#565e64}.link-success[data-v-24456ff2]{color:#198754}.link-success[data-v-24456ff2]:focus,.link-success[data-v-24456ff2]:hover{color:#146c43}.link-info[data-v-24456ff2]{color:#0dcaf0}.link-info[data-v-24456ff2]:focus,.link-info[data-v-24456ff2]:hover{color:#3dd5f3}.link-warning[data-v-24456ff2]{color:#ffc107}.link-warning[data-v-24456ff2]:focus,.link-warning[data-v-24456ff2]:hover{color:#ffcd39}.link-danger[data-v-24456ff2]{color:#dc3545}.link-danger[data-v-24456ff2]:focus,.link-danger[data-v-24456ff2]:hover{color:#b02a37}.link-light[data-v-24456ff2]{color:#f8f9fa}.link-light[data-v-24456ff2]:focus,.link-light[data-v-24456ff2]:hover{color:#f9fafb}.link-dark[data-v-24456ff2]{color:#212529}.link-dark[data-v-24456ff2]:focus,.link-dark[data-v-24456ff2]:hover{color:#1a1e21}.ratio[data-v-24456ff2]{position:relative;width:100%}.ratio[data-v-24456ff2]:before{display:block;padding-top:var(--bs-aspect-ratio);content:\"\"}.ratio>[data-v-24456ff2]{position:absolute;top:0;left:0;width:100%;height:100%}.ratio-1x1[data-v-24456ff2]{--bs-aspect-ratio:100%}.ratio-4x3[data-v-24456ff2]{--bs-aspect-ratio:75%}.ratio-16x9[data-v-24456ff2]{--bs-aspect-ratio:56.25%}.ratio-21x9[data-v-24456ff2]{--bs-aspect-ratio:42.8571428571%}.fixed-top[data-v-24456ff2]{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom[data-v-24456ff2]{position:fixed;right:0;bottom:0;left:0;z-index:1030}.sticky-top[data-v-24456ff2]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}@media (min-width:576px){.sticky-sm-top[data-v-24456ff2]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:768px){.sticky-md-top[data-v-24456ff2]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:992px){.sticky-lg-top[data-v-24456ff2]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1200px){.sticky-xl-top[data-v-24456ff2]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1400px){.sticky-xxl-top[data-v-24456ff2]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.hstack[data-v-24456ff2]{display:flex;flex-direction:row;align-items:center;align-self:stretch}.vstack[data-v-24456ff2]{display:flex;flex:1 1 auto;flex-direction:column;align-self:stretch}.visually-hidden-focusable[data-v-24456ff2]:not(:focus):not(:focus-within),.visually-hidden[data-v-24456ff2]{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}.stretched-link[data-v-24456ff2]:after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;content:\"\"}.text-truncate[data-v-24456ff2]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.vr[data-v-24456ff2]{display:inline-block;align-self:stretch;width:1px;min-height:1em;background-color:currentColor;opacity:.25}.align-baseline[data-v-24456ff2]{vertical-align:baseline!important}.align-top[data-v-24456ff2]{vertical-align:top!important}.align-middle[data-v-24456ff2]{vertical-align:middle!important}.align-bottom[data-v-24456ff2]{vertical-align:bottom!important}.align-text-bottom[data-v-24456ff2]{vertical-align:text-bottom!important}.align-text-top[data-v-24456ff2]{vertical-align:text-top!important}.float-start[data-v-24456ff2]{float:left!important}.float-end[data-v-24456ff2]{float:right!important}.float-none[data-v-24456ff2]{float:none!important}.opacity-0[data-v-24456ff2]{opacity:0!important}.opacity-25[data-v-24456ff2]{opacity:.25!important}.opacity-50[data-v-24456ff2]{opacity:.5!important}.opacity-75[data-v-24456ff2]{opacity:.75!important}.opacity-100[data-v-24456ff2]{opacity:1!important}.overflow-auto[data-v-24456ff2]{overflow:auto!important}.overflow-hidden[data-v-24456ff2]{overflow:hidden!important}.overflow-visible[data-v-24456ff2]{overflow:visible!important}.overflow-scroll[data-v-24456ff2]{overflow:scroll!important}.d-inline[data-v-24456ff2]{display:inline!important}.d-inline-block[data-v-24456ff2]{display:inline-block!important}.d-block[data-v-24456ff2]{display:block!important}.d-grid[data-v-24456ff2]{display:grid!important}.d-table[data-v-24456ff2]{display:table!important}.d-table-row[data-v-24456ff2]{display:table-row!important}.d-table-cell[data-v-24456ff2]{display:table-cell!important}.d-flex[data-v-24456ff2]{display:flex!important}.d-inline-flex[data-v-24456ff2]{display:inline-flex!important}.d-none[data-v-24456ff2]{display:none!important}.shadow[data-v-24456ff2]{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.shadow-sm[data-v-24456ff2]{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.shadow-lg[data-v-24456ff2]{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.shadow-none[data-v-24456ff2]{box-shadow:none!important}.position-static[data-v-24456ff2]{position:static!important}.position-relative[data-v-24456ff2]{position:relative!important}.position-absolute[data-v-24456ff2]{position:absolute!important}.position-fixed[data-v-24456ff2]{position:fixed!important}.position-sticky[data-v-24456ff2]{position:-webkit-sticky!important;position:sticky!important}.top-0[data-v-24456ff2]{top:0!important}.top-50[data-v-24456ff2]{top:50%!important}.top-100[data-v-24456ff2]{top:100%!important}.bottom-0[data-v-24456ff2]{bottom:0!important}.bottom-50[data-v-24456ff2]{bottom:50%!important}.bottom-100[data-v-24456ff2]{bottom:100%!important}.start-0[data-v-24456ff2]{left:0!important}.start-50[data-v-24456ff2]{left:50%!important}.start-100[data-v-24456ff2]{left:100%!important}.end-0[data-v-24456ff2]{right:0!important}.end-50[data-v-24456ff2]{right:50%!important}.end-100[data-v-24456ff2]{right:100%!important}.translate-middle[data-v-24456ff2]{transform:translate(-50%,-50%)!important}.translate-middle-x[data-v-24456ff2]{transform:translateX(-50%)!important}.translate-middle-y[data-v-24456ff2]{transform:translateY(-50%)!important}.border[data-v-24456ff2]{border:1px solid #dee2e6!important}.border-0[data-v-24456ff2]{border:0!important}.border-top[data-v-24456ff2]{border-top:1px solid #dee2e6!important}.border-top-0[data-v-24456ff2]{border-top:0!important}.border-end[data-v-24456ff2]{border-right:1px solid #dee2e6!important}.border-end-0[data-v-24456ff2]{border-right:0!important}.border-bottom[data-v-24456ff2]{border-bottom:1px solid #dee2e6!important}.border-bottom-0[data-v-24456ff2]{border-bottom:0!important}.border-start[data-v-24456ff2]{border-left:1px solid #dee2e6!important}.border-start-0[data-v-24456ff2]{border-left:0!important}.border-primary[data-v-24456ff2]{border-color:#0d6efd!important}.border-secondary[data-v-24456ff2]{border-color:#6c757d!important}.border-success[data-v-24456ff2]{border-color:#198754!important}.border-info[data-v-24456ff2]{border-color:#0dcaf0!important}.border-warning[data-v-24456ff2]{border-color:#ffc107!important}.border-danger[data-v-24456ff2]{border-color:#dc3545!important}.border-light[data-v-24456ff2]{border-color:#f8f9fa!important}.border-dark[data-v-24456ff2]{border-color:#212529!important}.border-white[data-v-24456ff2]{border-color:#fff!important}.border-1[data-v-24456ff2]{border-width:1px!important}.border-2[data-v-24456ff2]{border-width:2px!important}.border-3[data-v-24456ff2]{border-width:3px!important}.border-4[data-v-24456ff2]{border-width:4px!important}.border-5[data-v-24456ff2]{border-width:5px!important}.w-25[data-v-24456ff2]{width:25%!important}.w-50[data-v-24456ff2]{width:50%!important}.w-75[data-v-24456ff2]{width:75%!important}.w-100[data-v-24456ff2]{width:100%!important}.w-auto[data-v-24456ff2]{width:auto!important}.mw-100[data-v-24456ff2]{max-width:100%!important}.vw-100[data-v-24456ff2]{width:100vw!important}.min-vw-100[data-v-24456ff2]{min-width:100vw!important}.h-25[data-v-24456ff2]{height:25%!important}.h-50[data-v-24456ff2]{height:50%!important}.h-75[data-v-24456ff2]{height:75%!important}.h-100[data-v-24456ff2]{height:100%!important}.h-auto[data-v-24456ff2]{height:auto!important}.mh-100[data-v-24456ff2]{max-height:100%!important}.vh-100[data-v-24456ff2]{height:100vh!important}.min-vh-100[data-v-24456ff2]{min-height:100vh!important}.flex-fill[data-v-24456ff2]{flex:1 1 auto!important}.flex-row[data-v-24456ff2]{flex-direction:row!important}.flex-column[data-v-24456ff2]{flex-direction:column!important}.flex-row-reverse[data-v-24456ff2]{flex-direction:row-reverse!important}.flex-column-reverse[data-v-24456ff2]{flex-direction:column-reverse!important}.flex-grow-0[data-v-24456ff2]{flex-grow:0!important}.flex-grow-1[data-v-24456ff2]{flex-grow:1!important}.flex-shrink-0[data-v-24456ff2]{flex-shrink:0!important}.flex-shrink-1[data-v-24456ff2]{flex-shrink:1!important}.flex-wrap[data-v-24456ff2]{flex-wrap:wrap!important}.flex-nowrap[data-v-24456ff2]{flex-wrap:nowrap!important}.flex-wrap-reverse[data-v-24456ff2]{flex-wrap:wrap-reverse!important}.gap-0[data-v-24456ff2]{gap:0!important}.gap-1[data-v-24456ff2]{gap:.25rem!important}.gap-2[data-v-24456ff2]{gap:.5rem!important}.gap-3[data-v-24456ff2]{gap:1rem!important}.gap-4[data-v-24456ff2]{gap:1.5rem!important}.gap-5[data-v-24456ff2]{gap:3rem!important}.justify-content-start[data-v-24456ff2]{justify-content:flex-start!important}.justify-content-end[data-v-24456ff2]{justify-content:flex-end!important}.justify-content-center[data-v-24456ff2]{justify-content:center!important}.justify-content-between[data-v-24456ff2]{justify-content:space-between!important}.justify-content-around[data-v-24456ff2]{justify-content:space-around!important}.justify-content-evenly[data-v-24456ff2]{justify-content:space-evenly!important}.align-items-start[data-v-24456ff2]{align-items:flex-start!important}.align-items-end[data-v-24456ff2]{align-items:flex-end!important}.align-items-center[data-v-24456ff2]{align-items:center!important}.align-items-baseline[data-v-24456ff2]{align-items:baseline!important}.align-items-stretch[data-v-24456ff2]{align-items:stretch!important}.align-content-start[data-v-24456ff2]{align-content:flex-start!important}.align-content-end[data-v-24456ff2]{align-content:flex-end!important}.align-content-center[data-v-24456ff2]{align-content:center!important}.align-content-between[data-v-24456ff2]{align-content:space-between!important}.align-content-around[data-v-24456ff2]{align-content:space-around!important}.align-content-stretch[data-v-24456ff2]{align-content:stretch!important}.align-self-auto[data-v-24456ff2]{align-self:auto!important}.align-self-start[data-v-24456ff2]{align-self:flex-start!important}.align-self-end[data-v-24456ff2]{align-self:flex-end!important}.align-self-center[data-v-24456ff2]{align-self:center!important}.align-self-baseline[data-v-24456ff2]{align-self:baseline!important}.align-self-stretch[data-v-24456ff2]{align-self:stretch!important}.order-first[data-v-24456ff2]{order:-1!important}.order-0[data-v-24456ff2]{order:0!important}.order-1[data-v-24456ff2]{order:1!important}.order-2[data-v-24456ff2]{order:2!important}.order-3[data-v-24456ff2]{order:3!important}.order-4[data-v-24456ff2]{order:4!important}.order-5[data-v-24456ff2]{order:5!important}.order-last[data-v-24456ff2]{order:6!important}.m-0[data-v-24456ff2]{margin:0!important}.m-1[data-v-24456ff2]{margin:.25rem!important}.m-2[data-v-24456ff2]{margin:.5rem!important}.m-3[data-v-24456ff2]{margin:1rem!important}.m-4[data-v-24456ff2]{margin:1.5rem!important}.m-5[data-v-24456ff2]{margin:3rem!important}.m-auto[data-v-24456ff2]{margin:auto!important}.mx-0[data-v-24456ff2]{margin-right:0!important;margin-left:0!important}.mx-1[data-v-24456ff2]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-2[data-v-24456ff2]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-3[data-v-24456ff2]{margin-right:1rem!important;margin-left:1rem!important}.mx-4[data-v-24456ff2]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-5[data-v-24456ff2]{margin-right:3rem!important;margin-left:3rem!important}.mx-auto[data-v-24456ff2]{margin-right:auto!important;margin-left:auto!important}.my-0[data-v-24456ff2]{margin-top:0!important;margin-bottom:0!important}.my-1[data-v-24456ff2]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-2[data-v-24456ff2]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-3[data-v-24456ff2]{margin-top:1rem!important;margin-bottom:1rem!important}.my-4[data-v-24456ff2]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-5[data-v-24456ff2]{margin-top:3rem!important;margin-bottom:3rem!important}.my-auto[data-v-24456ff2]{margin-top:auto!important;margin-bottom:auto!important}.mt-0[data-v-24456ff2]{margin-top:0!important}.mt-1[data-v-24456ff2]{margin-top:.25rem!important}.mt-2[data-v-24456ff2]{margin-top:.5rem!important}.mt-3[data-v-24456ff2]{margin-top:1rem!important}.mt-4[data-v-24456ff2]{margin-top:1.5rem!important}.mt-5[data-v-24456ff2]{margin-top:3rem!important}.mt-auto[data-v-24456ff2]{margin-top:auto!important}.me-0[data-v-24456ff2]{margin-right:0!important}.me-1[data-v-24456ff2]{margin-right:.25rem!important}.me-2[data-v-24456ff2]{margin-right:.5rem!important}.me-3[data-v-24456ff2]{margin-right:1rem!important}.me-4[data-v-24456ff2]{margin-right:1.5rem!important}.me-5[data-v-24456ff2]{margin-right:3rem!important}.me-auto[data-v-24456ff2]{margin-right:auto!important}.mb-0[data-v-24456ff2]{margin-bottom:0!important}.mb-1[data-v-24456ff2]{margin-bottom:.25rem!important}.mb-2[data-v-24456ff2]{margin-bottom:.5rem!important}.mb-3[data-v-24456ff2]{margin-bottom:1rem!important}.mb-4[data-v-24456ff2]{margin-bottom:1.5rem!important}.mb-5[data-v-24456ff2]{margin-bottom:3rem!important}.mb-auto[data-v-24456ff2]{margin-bottom:auto!important}.ms-0[data-v-24456ff2]{margin-left:0!important}.ms-1[data-v-24456ff2]{margin-left:.25rem!important}.ms-2[data-v-24456ff2]{margin-left:.5rem!important}.ms-3[data-v-24456ff2]{margin-left:1rem!important}.ms-4[data-v-24456ff2]{margin-left:1.5rem!important}.ms-5[data-v-24456ff2]{margin-left:3rem!important}.ms-auto[data-v-24456ff2]{margin-left:auto!important}.p-0[data-v-24456ff2]{padding:0!important}.p-1[data-v-24456ff2]{padding:.25rem!important}.p-2[data-v-24456ff2]{padding:.5rem!important}.p-3[data-v-24456ff2]{padding:1rem!important}.p-4[data-v-24456ff2]{padding:1.5rem!important}.p-5[data-v-24456ff2]{padding:3rem!important}.px-0[data-v-24456ff2]{padding-right:0!important;padding-left:0!important}.px-1[data-v-24456ff2]{padding-right:.25rem!important;padding-left:.25rem!important}.px-2[data-v-24456ff2]{padding-right:.5rem!important;padding-left:.5rem!important}.px-3[data-v-24456ff2]{padding-right:1rem!important;padding-left:1rem!important}.px-4[data-v-24456ff2]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-5[data-v-24456ff2]{padding-right:3rem!important;padding-left:3rem!important}.py-0[data-v-24456ff2]{padding-top:0!important;padding-bottom:0!important}.py-1[data-v-24456ff2]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-2[data-v-24456ff2]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-3[data-v-24456ff2]{padding-top:1rem!important;padding-bottom:1rem!important}.py-4[data-v-24456ff2]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-5[data-v-24456ff2]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-0[data-v-24456ff2]{padding-top:0!important}.pt-1[data-v-24456ff2]{padding-top:.25rem!important}.pt-2[data-v-24456ff2]{padding-top:.5rem!important}.pt-3[data-v-24456ff2]{padding-top:1rem!important}.pt-4[data-v-24456ff2]{padding-top:1.5rem!important}.pt-5[data-v-24456ff2]{padding-top:3rem!important}.pe-0[data-v-24456ff2]{padding-right:0!important}.pe-1[data-v-24456ff2]{padding-right:.25rem!important}.pe-2[data-v-24456ff2]{padding-right:.5rem!important}.pe-3[data-v-24456ff2]{padding-right:1rem!important}.pe-4[data-v-24456ff2]{padding-right:1.5rem!important}.pe-5[data-v-24456ff2]{padding-right:3rem!important}.pb-0[data-v-24456ff2]{padding-bottom:0!important}.pb-1[data-v-24456ff2]{padding-bottom:.25rem!important}.pb-2[data-v-24456ff2]{padding-bottom:.5rem!important}.pb-3[data-v-24456ff2]{padding-bottom:1rem!important}.pb-4[data-v-24456ff2]{padding-bottom:1.5rem!important}.pb-5[data-v-24456ff2]{padding-bottom:3rem!important}.ps-0[data-v-24456ff2]{padding-left:0!important}.ps-1[data-v-24456ff2]{padding-left:.25rem!important}.ps-2[data-v-24456ff2]{padding-left:.5rem!important}.ps-3[data-v-24456ff2]{padding-left:1rem!important}.ps-4[data-v-24456ff2]{padding-left:1.5rem!important}.ps-5[data-v-24456ff2]{padding-left:3rem!important}.font-monospace[data-v-24456ff2]{font-family:var(--bs-font-monospace)!important}.fs-1[data-v-24456ff2]{font-size:calc(1.375rem + 1.5vw)!important}.fs-2[data-v-24456ff2]{font-size:calc(1.325rem + .9vw)!important}.fs-3[data-v-24456ff2]{font-size:calc(1.3rem + .6vw)!important}.fs-4[data-v-24456ff2]{font-size:calc(1.275rem + .3vw)!important}.fs-5[data-v-24456ff2]{font-size:1.25rem!important}.fs-6[data-v-24456ff2]{font-size:1rem!important}.fst-italic[data-v-24456ff2]{font-style:italic!important}.fst-normal[data-v-24456ff2]{font-style:normal!important}.fw-light[data-v-24456ff2]{font-weight:300!important}.fw-lighter[data-v-24456ff2]{font-weight:lighter!important}.fw-normal[data-v-24456ff2]{font-weight:400!important}.fw-bold[data-v-24456ff2]{font-weight:700!important}.fw-bolder[data-v-24456ff2]{font-weight:bolder!important}.lh-1[data-v-24456ff2]{line-height:1!important}.lh-sm[data-v-24456ff2]{line-height:1.25!important}.lh-base[data-v-24456ff2]{line-height:1.5!important}.lh-lg[data-v-24456ff2]{line-height:2!important}.text-start[data-v-24456ff2]{text-align:left!important}.text-end[data-v-24456ff2]{text-align:right!important}.text-center[data-v-24456ff2]{text-align:center!important}.text-decoration-none[data-v-24456ff2]{text-decoration:none!important}.text-decoration-underline[data-v-24456ff2]{text-decoration:underline!important}.text-decoration-line-through[data-v-24456ff2]{text-decoration:line-through!important}.text-lowercase[data-v-24456ff2]{text-transform:lowercase!important}.text-uppercase[data-v-24456ff2]{text-transform:uppercase!important}.text-capitalize[data-v-24456ff2]{text-transform:capitalize!important}.text-wrap[data-v-24456ff2]{white-space:normal!important}.text-nowrap[data-v-24456ff2]{white-space:nowrap!important}.text-break[data-v-24456ff2]{word-wrap:break-word!important;word-break:break-word!important}.text-primary[data-v-24456ff2]{--bs-text-opacity:1;color:rgba(var(--bs-primary-rgb),var(--bs-text-opacity))!important}.text-secondary[data-v-24456ff2]{--bs-text-opacity:1;color:rgba(var(--bs-secondary-rgb),var(--bs-text-opacity))!important}.text-success[data-v-24456ff2]{--bs-text-opacity:1;color:rgba(var(--bs-success-rgb),var(--bs-text-opacity))!important}.text-info[data-v-24456ff2]{--bs-text-opacity:1;color:rgba(var(--bs-info-rgb),var(--bs-text-opacity))!important}.text-warning[data-v-24456ff2]{--bs-text-opacity:1;color:rgba(var(--bs-warning-rgb),var(--bs-text-opacity))!important}.text-danger[data-v-24456ff2]{--bs-text-opacity:1;color:rgba(var(--bs-danger-rgb),var(--bs-text-opacity))!important}.text-light[data-v-24456ff2]{--bs-text-opacity:1;color:rgba(var(--bs-light-rgb),var(--bs-text-opacity))!important}.text-dark[data-v-24456ff2]{--bs-text-opacity:1;color:rgba(var(--bs-dark-rgb),var(--bs-text-opacity))!important}.text-black[data-v-24456ff2]{--bs-text-opacity:1;color:rgba(var(--bs-black-rgb),var(--bs-text-opacity))!important}.text-white[data-v-24456ff2]{--bs-text-opacity:1;color:rgba(var(--bs-white-rgb),var(--bs-text-opacity))!important}.text-body[data-v-24456ff2]{--bs-text-opacity:1;color:rgba(var(--bs-body-color-rgb),var(--bs-text-opacity))!important}.text-muted[data-v-24456ff2]{--bs-text-opacity:1;color:#6c757d!important}.text-black-50[data-v-24456ff2]{--bs-text-opacity:1;color:rgba(0,0,0,.5)!important}.text-white-50[data-v-24456ff2]{--bs-text-opacity:1;color:hsla(0,0%,100%,.5)!important}.text-reset[data-v-24456ff2]{--bs-text-opacity:1;color:inherit!important}.text-opacity-25[data-v-24456ff2]{--bs-text-opacity:0.25}.text-opacity-50[data-v-24456ff2]{--bs-text-opacity:0.5}.text-opacity-75[data-v-24456ff2]{--bs-text-opacity:0.75}.text-opacity-100[data-v-24456ff2]{--bs-text-opacity:1}.bg-primary[data-v-24456ff2]{--bs-bg-opacity:1;background-color:rgba(var(--bs-primary-rgb),var(--bs-bg-opacity))!important}.bg-secondary[data-v-24456ff2]{--bs-bg-opacity:1;background-color:rgba(var(--bs-secondary-rgb),var(--bs-bg-opacity))!important}.bg-success[data-v-24456ff2]{--bs-bg-opacity:1;background-color:rgba(var(--bs-success-rgb),var(--bs-bg-opacity))!important}.bg-info[data-v-24456ff2]{--bs-bg-opacity:1;background-color:rgba(var(--bs-info-rgb),var(--bs-bg-opacity))!important}.bg-warning[data-v-24456ff2]{--bs-bg-opacity:1;background-color:rgba(var(--bs-warning-rgb),var(--bs-bg-opacity))!important}.bg-danger[data-v-24456ff2]{--bs-bg-opacity:1;background-color:rgba(var(--bs-danger-rgb),var(--bs-bg-opacity))!important}.bg-light[data-v-24456ff2]{--bs-bg-opacity:1;background-color:rgba(var(--bs-light-rgb),var(--bs-bg-opacity))!important}.bg-dark[data-v-24456ff2]{--bs-bg-opacity:1;background-color:rgba(var(--bs-dark-rgb),var(--bs-bg-opacity))!important}.bg-black[data-v-24456ff2]{--bs-bg-opacity:1;background-color:rgba(var(--bs-black-rgb),var(--bs-bg-opacity))!important}.bg-white[data-v-24456ff2]{--bs-bg-opacity:1;background-color:rgba(var(--bs-white-rgb),var(--bs-bg-opacity))!important}.bg-body[data-v-24456ff2]{--bs-bg-opacity:1;background-color:rgba(var(--bs-body-bg-rgb),var(--bs-bg-opacity))!important}.bg-transparent[data-v-24456ff2]{--bs-bg-opacity:1;background-color:transparent!important}.bg-opacity-10[data-v-24456ff2]{--bs-bg-opacity:0.1}.bg-opacity-25[data-v-24456ff2]{--bs-bg-opacity:0.25}.bg-opacity-50[data-v-24456ff2]{--bs-bg-opacity:0.5}.bg-opacity-75[data-v-24456ff2]{--bs-bg-opacity:0.75}.bg-opacity-100[data-v-24456ff2]{--bs-bg-opacity:1}.bg-gradient[data-v-24456ff2]{background-image:var(--bs-gradient)!important}.user-select-all[data-v-24456ff2]{-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.user-select-auto[data-v-24456ff2]{-webkit-user-select:auto!important;-moz-user-select:auto!important;user-select:auto!important}.user-select-none[data-v-24456ff2]{-webkit-user-select:none!important;-moz-user-select:none!important;user-select:none!important}.pe-none[data-v-24456ff2]{pointer-events:none!important}.pe-auto[data-v-24456ff2]{pointer-events:auto!important}.rounded[data-v-24456ff2]{border-radius:.25rem!important}.rounded-0[data-v-24456ff2]{border-radius:0!important}.rounded-1[data-v-24456ff2]{border-radius:.2rem!important}.rounded-2[data-v-24456ff2]{border-radius:.25rem!important}.rounded-3[data-v-24456ff2]{border-radius:.3rem!important}.rounded-circle[data-v-24456ff2]{border-radius:50%!important}.rounded-pill[data-v-24456ff2]{border-radius:50rem!important}.rounded-top[data-v-24456ff2]{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.rounded-end[data-v-24456ff2]{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.rounded-bottom[data-v-24456ff2]{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-start[data-v-24456ff2]{border-bottom-left-radius:.25rem!important;border-top-left-radius:.25rem!important}.visible[data-v-24456ff2]{visibility:visible!important}.invisible[data-v-24456ff2]{visibility:hidden!important}@media (min-width:576px){.float-sm-start[data-v-24456ff2]{float:left!important}.float-sm-end[data-v-24456ff2]{float:right!important}.float-sm-none[data-v-24456ff2]{float:none!important}.d-sm-inline[data-v-24456ff2]{display:inline!important}.d-sm-inline-block[data-v-24456ff2]{display:inline-block!important}.d-sm-block[data-v-24456ff2]{display:block!important}.d-sm-grid[data-v-24456ff2]{display:grid!important}.d-sm-table[data-v-24456ff2]{display:table!important}.d-sm-table-row[data-v-24456ff2]{display:table-row!important}.d-sm-table-cell[data-v-24456ff2]{display:table-cell!important}.d-sm-flex[data-v-24456ff2]{display:flex!important}.d-sm-inline-flex[data-v-24456ff2]{display:inline-flex!important}.d-sm-none[data-v-24456ff2]{display:none!important}.flex-sm-fill[data-v-24456ff2]{flex:1 1 auto!important}.flex-sm-row[data-v-24456ff2]{flex-direction:row!important}.flex-sm-column[data-v-24456ff2]{flex-direction:column!important}.flex-sm-row-reverse[data-v-24456ff2]{flex-direction:row-reverse!important}.flex-sm-column-reverse[data-v-24456ff2]{flex-direction:column-reverse!important}.flex-sm-grow-0[data-v-24456ff2]{flex-grow:0!important}.flex-sm-grow-1[data-v-24456ff2]{flex-grow:1!important}.flex-sm-shrink-0[data-v-24456ff2]{flex-shrink:0!important}.flex-sm-shrink-1[data-v-24456ff2]{flex-shrink:1!important}.flex-sm-wrap[data-v-24456ff2]{flex-wrap:wrap!important}.flex-sm-nowrap[data-v-24456ff2]{flex-wrap:nowrap!important}.flex-sm-wrap-reverse[data-v-24456ff2]{flex-wrap:wrap-reverse!important}.gap-sm-0[data-v-24456ff2]{gap:0!important}.gap-sm-1[data-v-24456ff2]{gap:.25rem!important}.gap-sm-2[data-v-24456ff2]{gap:.5rem!important}.gap-sm-3[data-v-24456ff2]{gap:1rem!important}.gap-sm-4[data-v-24456ff2]{gap:1.5rem!important}.gap-sm-5[data-v-24456ff2]{gap:3rem!important}.justify-content-sm-start[data-v-24456ff2]{justify-content:flex-start!important}.justify-content-sm-end[data-v-24456ff2]{justify-content:flex-end!important}.justify-content-sm-center[data-v-24456ff2]{justify-content:center!important}.justify-content-sm-between[data-v-24456ff2]{justify-content:space-between!important}.justify-content-sm-around[data-v-24456ff2]{justify-content:space-around!important}.justify-content-sm-evenly[data-v-24456ff2]{justify-content:space-evenly!important}.align-items-sm-start[data-v-24456ff2]{align-items:flex-start!important}.align-items-sm-end[data-v-24456ff2]{align-items:flex-end!important}.align-items-sm-center[data-v-24456ff2]{align-items:center!important}.align-items-sm-baseline[data-v-24456ff2]{align-items:baseline!important}.align-items-sm-stretch[data-v-24456ff2]{align-items:stretch!important}.align-content-sm-start[data-v-24456ff2]{align-content:flex-start!important}.align-content-sm-end[data-v-24456ff2]{align-content:flex-end!important}.align-content-sm-center[data-v-24456ff2]{align-content:center!important}.align-content-sm-between[data-v-24456ff2]{align-content:space-between!important}.align-content-sm-around[data-v-24456ff2]{align-content:space-around!important}.align-content-sm-stretch[data-v-24456ff2]{align-content:stretch!important}.align-self-sm-auto[data-v-24456ff2]{align-self:auto!important}.align-self-sm-start[data-v-24456ff2]{align-self:flex-start!important}.align-self-sm-end[data-v-24456ff2]{align-self:flex-end!important}.align-self-sm-center[data-v-24456ff2]{align-self:center!important}.align-self-sm-baseline[data-v-24456ff2]{align-self:baseline!important}.align-self-sm-stretch[data-v-24456ff2]{align-self:stretch!important}.order-sm-first[data-v-24456ff2]{order:-1!important}.order-sm-0[data-v-24456ff2]{order:0!important}.order-sm-1[data-v-24456ff2]{order:1!important}.order-sm-2[data-v-24456ff2]{order:2!important}.order-sm-3[data-v-24456ff2]{order:3!important}.order-sm-4[data-v-24456ff2]{order:4!important}.order-sm-5[data-v-24456ff2]{order:5!important}.order-sm-last[data-v-24456ff2]{order:6!important}.m-sm-0[data-v-24456ff2]{margin:0!important}.m-sm-1[data-v-24456ff2]{margin:.25rem!important}.m-sm-2[data-v-24456ff2]{margin:.5rem!important}.m-sm-3[data-v-24456ff2]{margin:1rem!important}.m-sm-4[data-v-24456ff2]{margin:1.5rem!important}.m-sm-5[data-v-24456ff2]{margin:3rem!important}.m-sm-auto[data-v-24456ff2]{margin:auto!important}.mx-sm-0[data-v-24456ff2]{margin-right:0!important;margin-left:0!important}.mx-sm-1[data-v-24456ff2]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-sm-2[data-v-24456ff2]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-sm-3[data-v-24456ff2]{margin-right:1rem!important;margin-left:1rem!important}.mx-sm-4[data-v-24456ff2]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-sm-5[data-v-24456ff2]{margin-right:3rem!important;margin-left:3rem!important}.mx-sm-auto[data-v-24456ff2]{margin-right:auto!important;margin-left:auto!important}.my-sm-0[data-v-24456ff2]{margin-top:0!important;margin-bottom:0!important}.my-sm-1[data-v-24456ff2]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-sm-2[data-v-24456ff2]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-sm-3[data-v-24456ff2]{margin-top:1rem!important;margin-bottom:1rem!important}.my-sm-4[data-v-24456ff2]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-sm-5[data-v-24456ff2]{margin-top:3rem!important;margin-bottom:3rem!important}.my-sm-auto[data-v-24456ff2]{margin-top:auto!important;margin-bottom:auto!important}.mt-sm-0[data-v-24456ff2]{margin-top:0!important}.mt-sm-1[data-v-24456ff2]{margin-top:.25rem!important}.mt-sm-2[data-v-24456ff2]{margin-top:.5rem!important}.mt-sm-3[data-v-24456ff2]{margin-top:1rem!important}.mt-sm-4[data-v-24456ff2]{margin-top:1.5rem!important}.mt-sm-5[data-v-24456ff2]{margin-top:3rem!important}.mt-sm-auto[data-v-24456ff2]{margin-top:auto!important}.me-sm-0[data-v-24456ff2]{margin-right:0!important}.me-sm-1[data-v-24456ff2]{margin-right:.25rem!important}.me-sm-2[data-v-24456ff2]{margin-right:.5rem!important}.me-sm-3[data-v-24456ff2]{margin-right:1rem!important}.me-sm-4[data-v-24456ff2]{margin-right:1.5rem!important}.me-sm-5[data-v-24456ff2]{margin-right:3rem!important}.me-sm-auto[data-v-24456ff2]{margin-right:auto!important}.mb-sm-0[data-v-24456ff2]{margin-bottom:0!important}.mb-sm-1[data-v-24456ff2]{margin-bottom:.25rem!important}.mb-sm-2[data-v-24456ff2]{margin-bottom:.5rem!important}.mb-sm-3[data-v-24456ff2]{margin-bottom:1rem!important}.mb-sm-4[data-v-24456ff2]{margin-bottom:1.5rem!important}.mb-sm-5[data-v-24456ff2]{margin-bottom:3rem!important}.mb-sm-auto[data-v-24456ff2]{margin-bottom:auto!important}.ms-sm-0[data-v-24456ff2]{margin-left:0!important}.ms-sm-1[data-v-24456ff2]{margin-left:.25rem!important}.ms-sm-2[data-v-24456ff2]{margin-left:.5rem!important}.ms-sm-3[data-v-24456ff2]{margin-left:1rem!important}.ms-sm-4[data-v-24456ff2]{margin-left:1.5rem!important}.ms-sm-5[data-v-24456ff2]{margin-left:3rem!important}.ms-sm-auto[data-v-24456ff2]{margin-left:auto!important}.p-sm-0[data-v-24456ff2]{padding:0!important}.p-sm-1[data-v-24456ff2]{padding:.25rem!important}.p-sm-2[data-v-24456ff2]{padding:.5rem!important}.p-sm-3[data-v-24456ff2]{padding:1rem!important}.p-sm-4[data-v-24456ff2]{padding:1.5rem!important}.p-sm-5[data-v-24456ff2]{padding:3rem!important}.px-sm-0[data-v-24456ff2]{padding-right:0!important;padding-left:0!important}.px-sm-1[data-v-24456ff2]{padding-right:.25rem!important;padding-left:.25rem!important}.px-sm-2[data-v-24456ff2]{padding-right:.5rem!important;padding-left:.5rem!important}.px-sm-3[data-v-24456ff2]{padding-right:1rem!important;padding-left:1rem!important}.px-sm-4[data-v-24456ff2]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-sm-5[data-v-24456ff2]{padding-right:3rem!important;padding-left:3rem!important}.py-sm-0[data-v-24456ff2]{padding-top:0!important;padding-bottom:0!important}.py-sm-1[data-v-24456ff2]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-sm-2[data-v-24456ff2]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-sm-3[data-v-24456ff2]{padding-top:1rem!important;padding-bottom:1rem!important}.py-sm-4[data-v-24456ff2]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-sm-5[data-v-24456ff2]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-sm-0[data-v-24456ff2]{padding-top:0!important}.pt-sm-1[data-v-24456ff2]{padding-top:.25rem!important}.pt-sm-2[data-v-24456ff2]{padding-top:.5rem!important}.pt-sm-3[data-v-24456ff2]{padding-top:1rem!important}.pt-sm-4[data-v-24456ff2]{padding-top:1.5rem!important}.pt-sm-5[data-v-24456ff2]{padding-top:3rem!important}.pe-sm-0[data-v-24456ff2]{padding-right:0!important}.pe-sm-1[data-v-24456ff2]{padding-right:.25rem!important}.pe-sm-2[data-v-24456ff2]{padding-right:.5rem!important}.pe-sm-3[data-v-24456ff2]{padding-right:1rem!important}.pe-sm-4[data-v-24456ff2]{padding-right:1.5rem!important}.pe-sm-5[data-v-24456ff2]{padding-right:3rem!important}.pb-sm-0[data-v-24456ff2]{padding-bottom:0!important}.pb-sm-1[data-v-24456ff2]{padding-bottom:.25rem!important}.pb-sm-2[data-v-24456ff2]{padding-bottom:.5rem!important}.pb-sm-3[data-v-24456ff2]{padding-bottom:1rem!important}.pb-sm-4[data-v-24456ff2]{padding-bottom:1.5rem!important}.pb-sm-5[data-v-24456ff2]{padding-bottom:3rem!important}.ps-sm-0[data-v-24456ff2]{padding-left:0!important}.ps-sm-1[data-v-24456ff2]{padding-left:.25rem!important}.ps-sm-2[data-v-24456ff2]{padding-left:.5rem!important}.ps-sm-3[data-v-24456ff2]{padding-left:1rem!important}.ps-sm-4[data-v-24456ff2]{padding-left:1.5rem!important}.ps-sm-5[data-v-24456ff2]{padding-left:3rem!important}.text-sm-start[data-v-24456ff2]{text-align:left!important}.text-sm-end[data-v-24456ff2]{text-align:right!important}.text-sm-center[data-v-24456ff2]{text-align:center!important}}@media (min-width:768px){.float-md-start[data-v-24456ff2]{float:left!important}.float-md-end[data-v-24456ff2]{float:right!important}.float-md-none[data-v-24456ff2]{float:none!important}.d-md-inline[data-v-24456ff2]{display:inline!important}.d-md-inline-block[data-v-24456ff2]{display:inline-block!important}.d-md-block[data-v-24456ff2]{display:block!important}.d-md-grid[data-v-24456ff2]{display:grid!important}.d-md-table[data-v-24456ff2]{display:table!important}.d-md-table-row[data-v-24456ff2]{display:table-row!important}.d-md-table-cell[data-v-24456ff2]{display:table-cell!important}.d-md-flex[data-v-24456ff2]{display:flex!important}.d-md-inline-flex[data-v-24456ff2]{display:inline-flex!important}.d-md-none[data-v-24456ff2]{display:none!important}.flex-md-fill[data-v-24456ff2]{flex:1 1 auto!important}.flex-md-row[data-v-24456ff2]{flex-direction:row!important}.flex-md-column[data-v-24456ff2]{flex-direction:column!important}.flex-md-row-reverse[data-v-24456ff2]{flex-direction:row-reverse!important}.flex-md-column-reverse[data-v-24456ff2]{flex-direction:column-reverse!important}.flex-md-grow-0[data-v-24456ff2]{flex-grow:0!important}.flex-md-grow-1[data-v-24456ff2]{flex-grow:1!important}.flex-md-shrink-0[data-v-24456ff2]{flex-shrink:0!important}.flex-md-shrink-1[data-v-24456ff2]{flex-shrink:1!important}.flex-md-wrap[data-v-24456ff2]{flex-wrap:wrap!important}.flex-md-nowrap[data-v-24456ff2]{flex-wrap:nowrap!important}.flex-md-wrap-reverse[data-v-24456ff2]{flex-wrap:wrap-reverse!important}.gap-md-0[data-v-24456ff2]{gap:0!important}.gap-md-1[data-v-24456ff2]{gap:.25rem!important}.gap-md-2[data-v-24456ff2]{gap:.5rem!important}.gap-md-3[data-v-24456ff2]{gap:1rem!important}.gap-md-4[data-v-24456ff2]{gap:1.5rem!important}.gap-md-5[data-v-24456ff2]{gap:3rem!important}.justify-content-md-start[data-v-24456ff2]{justify-content:flex-start!important}.justify-content-md-end[data-v-24456ff2]{justify-content:flex-end!important}.justify-content-md-center[data-v-24456ff2]{justify-content:center!important}.justify-content-md-between[data-v-24456ff2]{justify-content:space-between!important}.justify-content-md-around[data-v-24456ff2]{justify-content:space-around!important}.justify-content-md-evenly[data-v-24456ff2]{justify-content:space-evenly!important}.align-items-md-start[data-v-24456ff2]{align-items:flex-start!important}.align-items-md-end[data-v-24456ff2]{align-items:flex-end!important}.align-items-md-center[data-v-24456ff2]{align-items:center!important}.align-items-md-baseline[data-v-24456ff2]{align-items:baseline!important}.align-items-md-stretch[data-v-24456ff2]{align-items:stretch!important}.align-content-md-start[data-v-24456ff2]{align-content:flex-start!important}.align-content-md-end[data-v-24456ff2]{align-content:flex-end!important}.align-content-md-center[data-v-24456ff2]{align-content:center!important}.align-content-md-between[data-v-24456ff2]{align-content:space-between!important}.align-content-md-around[data-v-24456ff2]{align-content:space-around!important}.align-content-md-stretch[data-v-24456ff2]{align-content:stretch!important}.align-self-md-auto[data-v-24456ff2]{align-self:auto!important}.align-self-md-start[data-v-24456ff2]{align-self:flex-start!important}.align-self-md-end[data-v-24456ff2]{align-self:flex-end!important}.align-self-md-center[data-v-24456ff2]{align-self:center!important}.align-self-md-baseline[data-v-24456ff2]{align-self:baseline!important}.align-self-md-stretch[data-v-24456ff2]{align-self:stretch!important}.order-md-first[data-v-24456ff2]{order:-1!important}.order-md-0[data-v-24456ff2]{order:0!important}.order-md-1[data-v-24456ff2]{order:1!important}.order-md-2[data-v-24456ff2]{order:2!important}.order-md-3[data-v-24456ff2]{order:3!important}.order-md-4[data-v-24456ff2]{order:4!important}.order-md-5[data-v-24456ff2]{order:5!important}.order-md-last[data-v-24456ff2]{order:6!important}.m-md-0[data-v-24456ff2]{margin:0!important}.m-md-1[data-v-24456ff2]{margin:.25rem!important}.m-md-2[data-v-24456ff2]{margin:.5rem!important}.m-md-3[data-v-24456ff2]{margin:1rem!important}.m-md-4[data-v-24456ff2]{margin:1.5rem!important}.m-md-5[data-v-24456ff2]{margin:3rem!important}.m-md-auto[data-v-24456ff2]{margin:auto!important}.mx-md-0[data-v-24456ff2]{margin-right:0!important;margin-left:0!important}.mx-md-1[data-v-24456ff2]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-md-2[data-v-24456ff2]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-md-3[data-v-24456ff2]{margin-right:1rem!important;margin-left:1rem!important}.mx-md-4[data-v-24456ff2]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-md-5[data-v-24456ff2]{margin-right:3rem!important;margin-left:3rem!important}.mx-md-auto[data-v-24456ff2]{margin-right:auto!important;margin-left:auto!important}.my-md-0[data-v-24456ff2]{margin-top:0!important;margin-bottom:0!important}.my-md-1[data-v-24456ff2]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-md-2[data-v-24456ff2]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-md-3[data-v-24456ff2]{margin-top:1rem!important;margin-bottom:1rem!important}.my-md-4[data-v-24456ff2]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-md-5[data-v-24456ff2]{margin-top:3rem!important;margin-bottom:3rem!important}.my-md-auto[data-v-24456ff2]{margin-top:auto!important;margin-bottom:auto!important}.mt-md-0[data-v-24456ff2]{margin-top:0!important}.mt-md-1[data-v-24456ff2]{margin-top:.25rem!important}.mt-md-2[data-v-24456ff2]{margin-top:.5rem!important}.mt-md-3[data-v-24456ff2]{margin-top:1rem!important}.mt-md-4[data-v-24456ff2]{margin-top:1.5rem!important}.mt-md-5[data-v-24456ff2]{margin-top:3rem!important}.mt-md-auto[data-v-24456ff2]{margin-top:auto!important}.me-md-0[data-v-24456ff2]{margin-right:0!important}.me-md-1[data-v-24456ff2]{margin-right:.25rem!important}.me-md-2[data-v-24456ff2]{margin-right:.5rem!important}.me-md-3[data-v-24456ff2]{margin-right:1rem!important}.me-md-4[data-v-24456ff2]{margin-right:1.5rem!important}.me-md-5[data-v-24456ff2]{margin-right:3rem!important}.me-md-auto[data-v-24456ff2]{margin-right:auto!important}.mb-md-0[data-v-24456ff2]{margin-bottom:0!important}.mb-md-1[data-v-24456ff2]{margin-bottom:.25rem!important}.mb-md-2[data-v-24456ff2]{margin-bottom:.5rem!important}.mb-md-3[data-v-24456ff2]{margin-bottom:1rem!important}.mb-md-4[data-v-24456ff2]{margin-bottom:1.5rem!important}.mb-md-5[data-v-24456ff2]{margin-bottom:3rem!important}.mb-md-auto[data-v-24456ff2]{margin-bottom:auto!important}.ms-md-0[data-v-24456ff2]{margin-left:0!important}.ms-md-1[data-v-24456ff2]{margin-left:.25rem!important}.ms-md-2[data-v-24456ff2]{margin-left:.5rem!important}.ms-md-3[data-v-24456ff2]{margin-left:1rem!important}.ms-md-4[data-v-24456ff2]{margin-left:1.5rem!important}.ms-md-5[data-v-24456ff2]{margin-left:3rem!important}.ms-md-auto[data-v-24456ff2]{margin-left:auto!important}.p-md-0[data-v-24456ff2]{padding:0!important}.p-md-1[data-v-24456ff2]{padding:.25rem!important}.p-md-2[data-v-24456ff2]{padding:.5rem!important}.p-md-3[data-v-24456ff2]{padding:1rem!important}.p-md-4[data-v-24456ff2]{padding:1.5rem!important}.p-md-5[data-v-24456ff2]{padding:3rem!important}.px-md-0[data-v-24456ff2]{padding-right:0!important;padding-left:0!important}.px-md-1[data-v-24456ff2]{padding-right:.25rem!important;padding-left:.25rem!important}.px-md-2[data-v-24456ff2]{padding-right:.5rem!important;padding-left:.5rem!important}.px-md-3[data-v-24456ff2]{padding-right:1rem!important;padding-left:1rem!important}.px-md-4[data-v-24456ff2]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-md-5[data-v-24456ff2]{padding-right:3rem!important;padding-left:3rem!important}.py-md-0[data-v-24456ff2]{padding-top:0!important;padding-bottom:0!important}.py-md-1[data-v-24456ff2]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-md-2[data-v-24456ff2]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-md-3[data-v-24456ff2]{padding-top:1rem!important;padding-bottom:1rem!important}.py-md-4[data-v-24456ff2]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-md-5[data-v-24456ff2]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-md-0[data-v-24456ff2]{padding-top:0!important}.pt-md-1[data-v-24456ff2]{padding-top:.25rem!important}.pt-md-2[data-v-24456ff2]{padding-top:.5rem!important}.pt-md-3[data-v-24456ff2]{padding-top:1rem!important}.pt-md-4[data-v-24456ff2]{padding-top:1.5rem!important}.pt-md-5[data-v-24456ff2]{padding-top:3rem!important}.pe-md-0[data-v-24456ff2]{padding-right:0!important}.pe-md-1[data-v-24456ff2]{padding-right:.25rem!important}.pe-md-2[data-v-24456ff2]{padding-right:.5rem!important}.pe-md-3[data-v-24456ff2]{padding-right:1rem!important}.pe-md-4[data-v-24456ff2]{padding-right:1.5rem!important}.pe-md-5[data-v-24456ff2]{padding-right:3rem!important}.pb-md-0[data-v-24456ff2]{padding-bottom:0!important}.pb-md-1[data-v-24456ff2]{padding-bottom:.25rem!important}.pb-md-2[data-v-24456ff2]{padding-bottom:.5rem!important}.pb-md-3[data-v-24456ff2]{padding-bottom:1rem!important}.pb-md-4[data-v-24456ff2]{padding-bottom:1.5rem!important}.pb-md-5[data-v-24456ff2]{padding-bottom:3rem!important}.ps-md-0[data-v-24456ff2]{padding-left:0!important}.ps-md-1[data-v-24456ff2]{padding-left:.25rem!important}.ps-md-2[data-v-24456ff2]{padding-left:.5rem!important}.ps-md-3[data-v-24456ff2]{padding-left:1rem!important}.ps-md-4[data-v-24456ff2]{padding-left:1.5rem!important}.ps-md-5[data-v-24456ff2]{padding-left:3rem!important}.text-md-start[data-v-24456ff2]{text-align:left!important}.text-md-end[data-v-24456ff2]{text-align:right!important}.text-md-center[data-v-24456ff2]{text-align:center!important}}@media (min-width:992px){.float-lg-start[data-v-24456ff2]{float:left!important}.float-lg-end[data-v-24456ff2]{float:right!important}.float-lg-none[data-v-24456ff2]{float:none!important}.d-lg-inline[data-v-24456ff2]{display:inline!important}.d-lg-inline-block[data-v-24456ff2]{display:inline-block!important}.d-lg-block[data-v-24456ff2]{display:block!important}.d-lg-grid[data-v-24456ff2]{display:grid!important}.d-lg-table[data-v-24456ff2]{display:table!important}.d-lg-table-row[data-v-24456ff2]{display:table-row!important}.d-lg-table-cell[data-v-24456ff2]{display:table-cell!important}.d-lg-flex[data-v-24456ff2]{display:flex!important}.d-lg-inline-flex[data-v-24456ff2]{display:inline-flex!important}.d-lg-none[data-v-24456ff2]{display:none!important}.flex-lg-fill[data-v-24456ff2]{flex:1 1 auto!important}.flex-lg-row[data-v-24456ff2]{flex-direction:row!important}.flex-lg-column[data-v-24456ff2]{flex-direction:column!important}.flex-lg-row-reverse[data-v-24456ff2]{flex-direction:row-reverse!important}.flex-lg-column-reverse[data-v-24456ff2]{flex-direction:column-reverse!important}.flex-lg-grow-0[data-v-24456ff2]{flex-grow:0!important}.flex-lg-grow-1[data-v-24456ff2]{flex-grow:1!important}.flex-lg-shrink-0[data-v-24456ff2]{flex-shrink:0!important}.flex-lg-shrink-1[data-v-24456ff2]{flex-shrink:1!important}.flex-lg-wrap[data-v-24456ff2]{flex-wrap:wrap!important}.flex-lg-nowrap[data-v-24456ff2]{flex-wrap:nowrap!important}.flex-lg-wrap-reverse[data-v-24456ff2]{flex-wrap:wrap-reverse!important}.gap-lg-0[data-v-24456ff2]{gap:0!important}.gap-lg-1[data-v-24456ff2]{gap:.25rem!important}.gap-lg-2[data-v-24456ff2]{gap:.5rem!important}.gap-lg-3[data-v-24456ff2]{gap:1rem!important}.gap-lg-4[data-v-24456ff2]{gap:1.5rem!important}.gap-lg-5[data-v-24456ff2]{gap:3rem!important}.justify-content-lg-start[data-v-24456ff2]{justify-content:flex-start!important}.justify-content-lg-end[data-v-24456ff2]{justify-content:flex-end!important}.justify-content-lg-center[data-v-24456ff2]{justify-content:center!important}.justify-content-lg-between[data-v-24456ff2]{justify-content:space-between!important}.justify-content-lg-around[data-v-24456ff2]{justify-content:space-around!important}.justify-content-lg-evenly[data-v-24456ff2]{justify-content:space-evenly!important}.align-items-lg-start[data-v-24456ff2]{align-items:flex-start!important}.align-items-lg-end[data-v-24456ff2]{align-items:flex-end!important}.align-items-lg-center[data-v-24456ff2]{align-items:center!important}.align-items-lg-baseline[data-v-24456ff2]{align-items:baseline!important}.align-items-lg-stretch[data-v-24456ff2]{align-items:stretch!important}.align-content-lg-start[data-v-24456ff2]{align-content:flex-start!important}.align-content-lg-end[data-v-24456ff2]{align-content:flex-end!important}.align-content-lg-center[data-v-24456ff2]{align-content:center!important}.align-content-lg-between[data-v-24456ff2]{align-content:space-between!important}.align-content-lg-around[data-v-24456ff2]{align-content:space-around!important}.align-content-lg-stretch[data-v-24456ff2]{align-content:stretch!important}.align-self-lg-auto[data-v-24456ff2]{align-self:auto!important}.align-self-lg-start[data-v-24456ff2]{align-self:flex-start!important}.align-self-lg-end[data-v-24456ff2]{align-self:flex-end!important}.align-self-lg-center[data-v-24456ff2]{align-self:center!important}.align-self-lg-baseline[data-v-24456ff2]{align-self:baseline!important}.align-self-lg-stretch[data-v-24456ff2]{align-self:stretch!important}.order-lg-first[data-v-24456ff2]{order:-1!important}.order-lg-0[data-v-24456ff2]{order:0!important}.order-lg-1[data-v-24456ff2]{order:1!important}.order-lg-2[data-v-24456ff2]{order:2!important}.order-lg-3[data-v-24456ff2]{order:3!important}.order-lg-4[data-v-24456ff2]{order:4!important}.order-lg-5[data-v-24456ff2]{order:5!important}.order-lg-last[data-v-24456ff2]{order:6!important}.m-lg-0[data-v-24456ff2]{margin:0!important}.m-lg-1[data-v-24456ff2]{margin:.25rem!important}.m-lg-2[data-v-24456ff2]{margin:.5rem!important}.m-lg-3[data-v-24456ff2]{margin:1rem!important}.m-lg-4[data-v-24456ff2]{margin:1.5rem!important}.m-lg-5[data-v-24456ff2]{margin:3rem!important}.m-lg-auto[data-v-24456ff2]{margin:auto!important}.mx-lg-0[data-v-24456ff2]{margin-right:0!important;margin-left:0!important}.mx-lg-1[data-v-24456ff2]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-lg-2[data-v-24456ff2]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-lg-3[data-v-24456ff2]{margin-right:1rem!important;margin-left:1rem!important}.mx-lg-4[data-v-24456ff2]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-lg-5[data-v-24456ff2]{margin-right:3rem!important;margin-left:3rem!important}.mx-lg-auto[data-v-24456ff2]{margin-right:auto!important;margin-left:auto!important}.my-lg-0[data-v-24456ff2]{margin-top:0!important;margin-bottom:0!important}.my-lg-1[data-v-24456ff2]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-lg-2[data-v-24456ff2]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-lg-3[data-v-24456ff2]{margin-top:1rem!important;margin-bottom:1rem!important}.my-lg-4[data-v-24456ff2]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-lg-5[data-v-24456ff2]{margin-top:3rem!important;margin-bottom:3rem!important}.my-lg-auto[data-v-24456ff2]{margin-top:auto!important;margin-bottom:auto!important}.mt-lg-0[data-v-24456ff2]{margin-top:0!important}.mt-lg-1[data-v-24456ff2]{margin-top:.25rem!important}.mt-lg-2[data-v-24456ff2]{margin-top:.5rem!important}.mt-lg-3[data-v-24456ff2]{margin-top:1rem!important}.mt-lg-4[data-v-24456ff2]{margin-top:1.5rem!important}.mt-lg-5[data-v-24456ff2]{margin-top:3rem!important}.mt-lg-auto[data-v-24456ff2]{margin-top:auto!important}.me-lg-0[data-v-24456ff2]{margin-right:0!important}.me-lg-1[data-v-24456ff2]{margin-right:.25rem!important}.me-lg-2[data-v-24456ff2]{margin-right:.5rem!important}.me-lg-3[data-v-24456ff2]{margin-right:1rem!important}.me-lg-4[data-v-24456ff2]{margin-right:1.5rem!important}.me-lg-5[data-v-24456ff2]{margin-right:3rem!important}.me-lg-auto[data-v-24456ff2]{margin-right:auto!important}.mb-lg-0[data-v-24456ff2]{margin-bottom:0!important}.mb-lg-1[data-v-24456ff2]{margin-bottom:.25rem!important}.mb-lg-2[data-v-24456ff2]{margin-bottom:.5rem!important}.mb-lg-3[data-v-24456ff2]{margin-bottom:1rem!important}.mb-lg-4[data-v-24456ff2]{margin-bottom:1.5rem!important}.mb-lg-5[data-v-24456ff2]{margin-bottom:3rem!important}.mb-lg-auto[data-v-24456ff2]{margin-bottom:auto!important}.ms-lg-0[data-v-24456ff2]{margin-left:0!important}.ms-lg-1[data-v-24456ff2]{margin-left:.25rem!important}.ms-lg-2[data-v-24456ff2]{margin-left:.5rem!important}.ms-lg-3[data-v-24456ff2]{margin-left:1rem!important}.ms-lg-4[data-v-24456ff2]{margin-left:1.5rem!important}.ms-lg-5[data-v-24456ff2]{margin-left:3rem!important}.ms-lg-auto[data-v-24456ff2]{margin-left:auto!important}.p-lg-0[data-v-24456ff2]{padding:0!important}.p-lg-1[data-v-24456ff2]{padding:.25rem!important}.p-lg-2[data-v-24456ff2]{padding:.5rem!important}.p-lg-3[data-v-24456ff2]{padding:1rem!important}.p-lg-4[data-v-24456ff2]{padding:1.5rem!important}.p-lg-5[data-v-24456ff2]{padding:3rem!important}.px-lg-0[data-v-24456ff2]{padding-right:0!important;padding-left:0!important}.px-lg-1[data-v-24456ff2]{padding-right:.25rem!important;padding-left:.25rem!important}.px-lg-2[data-v-24456ff2]{padding-right:.5rem!important;padding-left:.5rem!important}.px-lg-3[data-v-24456ff2]{padding-right:1rem!important;padding-left:1rem!important}.px-lg-4[data-v-24456ff2]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-lg-5[data-v-24456ff2]{padding-right:3rem!important;padding-left:3rem!important}.py-lg-0[data-v-24456ff2]{padding-top:0!important;padding-bottom:0!important}.py-lg-1[data-v-24456ff2]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-lg-2[data-v-24456ff2]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-lg-3[data-v-24456ff2]{padding-top:1rem!important;padding-bottom:1rem!important}.py-lg-4[data-v-24456ff2]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-lg-5[data-v-24456ff2]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-lg-0[data-v-24456ff2]{padding-top:0!important}.pt-lg-1[data-v-24456ff2]{padding-top:.25rem!important}.pt-lg-2[data-v-24456ff2]{padding-top:.5rem!important}.pt-lg-3[data-v-24456ff2]{padding-top:1rem!important}.pt-lg-4[data-v-24456ff2]{padding-top:1.5rem!important}.pt-lg-5[data-v-24456ff2]{padding-top:3rem!important}.pe-lg-0[data-v-24456ff2]{padding-right:0!important}.pe-lg-1[data-v-24456ff2]{padding-right:.25rem!important}.pe-lg-2[data-v-24456ff2]{padding-right:.5rem!important}.pe-lg-3[data-v-24456ff2]{padding-right:1rem!important}.pe-lg-4[data-v-24456ff2]{padding-right:1.5rem!important}.pe-lg-5[data-v-24456ff2]{padding-right:3rem!important}.pb-lg-0[data-v-24456ff2]{padding-bottom:0!important}.pb-lg-1[data-v-24456ff2]{padding-bottom:.25rem!important}.pb-lg-2[data-v-24456ff2]{padding-bottom:.5rem!important}.pb-lg-3[data-v-24456ff2]{padding-bottom:1rem!important}.pb-lg-4[data-v-24456ff2]{padding-bottom:1.5rem!important}.pb-lg-5[data-v-24456ff2]{padding-bottom:3rem!important}.ps-lg-0[data-v-24456ff2]{padding-left:0!important}.ps-lg-1[data-v-24456ff2]{padding-left:.25rem!important}.ps-lg-2[data-v-24456ff2]{padding-left:.5rem!important}.ps-lg-3[data-v-24456ff2]{padding-left:1rem!important}.ps-lg-4[data-v-24456ff2]{padding-left:1.5rem!important}.ps-lg-5[data-v-24456ff2]{padding-left:3rem!important}.text-lg-start[data-v-24456ff2]{text-align:left!important}.text-lg-end[data-v-24456ff2]{text-align:right!important}.text-lg-center[data-v-24456ff2]{text-align:center!important}}@media (min-width:1200px){.float-xl-start[data-v-24456ff2]{float:left!important}.float-xl-end[data-v-24456ff2]{float:right!important}.float-xl-none[data-v-24456ff2]{float:none!important}.d-xl-inline[data-v-24456ff2]{display:inline!important}.d-xl-inline-block[data-v-24456ff2]{display:inline-block!important}.d-xl-block[data-v-24456ff2]{display:block!important}.d-xl-grid[data-v-24456ff2]{display:grid!important}.d-xl-table[data-v-24456ff2]{display:table!important}.d-xl-table-row[data-v-24456ff2]{display:table-row!important}.d-xl-table-cell[data-v-24456ff2]{display:table-cell!important}.d-xl-flex[data-v-24456ff2]{display:flex!important}.d-xl-inline-flex[data-v-24456ff2]{display:inline-flex!important}.d-xl-none[data-v-24456ff2]{display:none!important}.flex-xl-fill[data-v-24456ff2]{flex:1 1 auto!important}.flex-xl-row[data-v-24456ff2]{flex-direction:row!important}.flex-xl-column[data-v-24456ff2]{flex-direction:column!important}.flex-xl-row-reverse[data-v-24456ff2]{flex-direction:row-reverse!important}.flex-xl-column-reverse[data-v-24456ff2]{flex-direction:column-reverse!important}.flex-xl-grow-0[data-v-24456ff2]{flex-grow:0!important}.flex-xl-grow-1[data-v-24456ff2]{flex-grow:1!important}.flex-xl-shrink-0[data-v-24456ff2]{flex-shrink:0!important}.flex-xl-shrink-1[data-v-24456ff2]{flex-shrink:1!important}.flex-xl-wrap[data-v-24456ff2]{flex-wrap:wrap!important}.flex-xl-nowrap[data-v-24456ff2]{flex-wrap:nowrap!important}.flex-xl-wrap-reverse[data-v-24456ff2]{flex-wrap:wrap-reverse!important}.gap-xl-0[data-v-24456ff2]{gap:0!important}.gap-xl-1[data-v-24456ff2]{gap:.25rem!important}.gap-xl-2[data-v-24456ff2]{gap:.5rem!important}.gap-xl-3[data-v-24456ff2]{gap:1rem!important}.gap-xl-4[data-v-24456ff2]{gap:1.5rem!important}.gap-xl-5[data-v-24456ff2]{gap:3rem!important}.justify-content-xl-start[data-v-24456ff2]{justify-content:flex-start!important}.justify-content-xl-end[data-v-24456ff2]{justify-content:flex-end!important}.justify-content-xl-center[data-v-24456ff2]{justify-content:center!important}.justify-content-xl-between[data-v-24456ff2]{justify-content:space-between!important}.justify-content-xl-around[data-v-24456ff2]{justify-content:space-around!important}.justify-content-xl-evenly[data-v-24456ff2]{justify-content:space-evenly!important}.align-items-xl-start[data-v-24456ff2]{align-items:flex-start!important}.align-items-xl-end[data-v-24456ff2]{align-items:flex-end!important}.align-items-xl-center[data-v-24456ff2]{align-items:center!important}.align-items-xl-baseline[data-v-24456ff2]{align-items:baseline!important}.align-items-xl-stretch[data-v-24456ff2]{align-items:stretch!important}.align-content-xl-start[data-v-24456ff2]{align-content:flex-start!important}.align-content-xl-end[data-v-24456ff2]{align-content:flex-end!important}.align-content-xl-center[data-v-24456ff2]{align-content:center!important}.align-content-xl-between[data-v-24456ff2]{align-content:space-between!important}.align-content-xl-around[data-v-24456ff2]{align-content:space-around!important}.align-content-xl-stretch[data-v-24456ff2]{align-content:stretch!important}.align-self-xl-auto[data-v-24456ff2]{align-self:auto!important}.align-self-xl-start[data-v-24456ff2]{align-self:flex-start!important}.align-self-xl-end[data-v-24456ff2]{align-self:flex-end!important}.align-self-xl-center[data-v-24456ff2]{align-self:center!important}.align-self-xl-baseline[data-v-24456ff2]{align-self:baseline!important}.align-self-xl-stretch[data-v-24456ff2]{align-self:stretch!important}.order-xl-first[data-v-24456ff2]{order:-1!important}.order-xl-0[data-v-24456ff2]{order:0!important}.order-xl-1[data-v-24456ff2]{order:1!important}.order-xl-2[data-v-24456ff2]{order:2!important}.order-xl-3[data-v-24456ff2]{order:3!important}.order-xl-4[data-v-24456ff2]{order:4!important}.order-xl-5[data-v-24456ff2]{order:5!important}.order-xl-last[data-v-24456ff2]{order:6!important}.m-xl-0[data-v-24456ff2]{margin:0!important}.m-xl-1[data-v-24456ff2]{margin:.25rem!important}.m-xl-2[data-v-24456ff2]{margin:.5rem!important}.m-xl-3[data-v-24456ff2]{margin:1rem!important}.m-xl-4[data-v-24456ff2]{margin:1.5rem!important}.m-xl-5[data-v-24456ff2]{margin:3rem!important}.m-xl-auto[data-v-24456ff2]{margin:auto!important}.mx-xl-0[data-v-24456ff2]{margin-right:0!important;margin-left:0!important}.mx-xl-1[data-v-24456ff2]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xl-2[data-v-24456ff2]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xl-3[data-v-24456ff2]{margin-right:1rem!important;margin-left:1rem!important}.mx-xl-4[data-v-24456ff2]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xl-5[data-v-24456ff2]{margin-right:3rem!important;margin-left:3rem!important}.mx-xl-auto[data-v-24456ff2]{margin-right:auto!important;margin-left:auto!important}.my-xl-0[data-v-24456ff2]{margin-top:0!important;margin-bottom:0!important}.my-xl-1[data-v-24456ff2]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xl-2[data-v-24456ff2]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xl-3[data-v-24456ff2]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xl-4[data-v-24456ff2]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xl-5[data-v-24456ff2]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xl-auto[data-v-24456ff2]{margin-top:auto!important;margin-bottom:auto!important}.mt-xl-0[data-v-24456ff2]{margin-top:0!important}.mt-xl-1[data-v-24456ff2]{margin-top:.25rem!important}.mt-xl-2[data-v-24456ff2]{margin-top:.5rem!important}.mt-xl-3[data-v-24456ff2]{margin-top:1rem!important}.mt-xl-4[data-v-24456ff2]{margin-top:1.5rem!important}.mt-xl-5[data-v-24456ff2]{margin-top:3rem!important}.mt-xl-auto[data-v-24456ff2]{margin-top:auto!important}.me-xl-0[data-v-24456ff2]{margin-right:0!important}.me-xl-1[data-v-24456ff2]{margin-right:.25rem!important}.me-xl-2[data-v-24456ff2]{margin-right:.5rem!important}.me-xl-3[data-v-24456ff2]{margin-right:1rem!important}.me-xl-4[data-v-24456ff2]{margin-right:1.5rem!important}.me-xl-5[data-v-24456ff2]{margin-right:3rem!important}.me-xl-auto[data-v-24456ff2]{margin-right:auto!important}.mb-xl-0[data-v-24456ff2]{margin-bottom:0!important}.mb-xl-1[data-v-24456ff2]{margin-bottom:.25rem!important}.mb-xl-2[data-v-24456ff2]{margin-bottom:.5rem!important}.mb-xl-3[data-v-24456ff2]{margin-bottom:1rem!important}.mb-xl-4[data-v-24456ff2]{margin-bottom:1.5rem!important}.mb-xl-5[data-v-24456ff2]{margin-bottom:3rem!important}.mb-xl-auto[data-v-24456ff2]{margin-bottom:auto!important}.ms-xl-0[data-v-24456ff2]{margin-left:0!important}.ms-xl-1[data-v-24456ff2]{margin-left:.25rem!important}.ms-xl-2[data-v-24456ff2]{margin-left:.5rem!important}.ms-xl-3[data-v-24456ff2]{margin-left:1rem!important}.ms-xl-4[data-v-24456ff2]{margin-left:1.5rem!important}.ms-xl-5[data-v-24456ff2]{margin-left:3rem!important}.ms-xl-auto[data-v-24456ff2]{margin-left:auto!important}.p-xl-0[data-v-24456ff2]{padding:0!important}.p-xl-1[data-v-24456ff2]{padding:.25rem!important}.p-xl-2[data-v-24456ff2]{padding:.5rem!important}.p-xl-3[data-v-24456ff2]{padding:1rem!important}.p-xl-4[data-v-24456ff2]{padding:1.5rem!important}.p-xl-5[data-v-24456ff2]{padding:3rem!important}.px-xl-0[data-v-24456ff2]{padding-right:0!important;padding-left:0!important}.px-xl-1[data-v-24456ff2]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xl-2[data-v-24456ff2]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xl-3[data-v-24456ff2]{padding-right:1rem!important;padding-left:1rem!important}.px-xl-4[data-v-24456ff2]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xl-5[data-v-24456ff2]{padding-right:3rem!important;padding-left:3rem!important}.py-xl-0[data-v-24456ff2]{padding-top:0!important;padding-bottom:0!important}.py-xl-1[data-v-24456ff2]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xl-2[data-v-24456ff2]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xl-3[data-v-24456ff2]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xl-4[data-v-24456ff2]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xl-5[data-v-24456ff2]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xl-0[data-v-24456ff2]{padding-top:0!important}.pt-xl-1[data-v-24456ff2]{padding-top:.25rem!important}.pt-xl-2[data-v-24456ff2]{padding-top:.5rem!important}.pt-xl-3[data-v-24456ff2]{padding-top:1rem!important}.pt-xl-4[data-v-24456ff2]{padding-top:1.5rem!important}.pt-xl-5[data-v-24456ff2]{padding-top:3rem!important}.pe-xl-0[data-v-24456ff2]{padding-right:0!important}.pe-xl-1[data-v-24456ff2]{padding-right:.25rem!important}.pe-xl-2[data-v-24456ff2]{padding-right:.5rem!important}.pe-xl-3[data-v-24456ff2]{padding-right:1rem!important}.pe-xl-4[data-v-24456ff2]{padding-right:1.5rem!important}.pe-xl-5[data-v-24456ff2]{padding-right:3rem!important}.pb-xl-0[data-v-24456ff2]{padding-bottom:0!important}.pb-xl-1[data-v-24456ff2]{padding-bottom:.25rem!important}.pb-xl-2[data-v-24456ff2]{padding-bottom:.5rem!important}.pb-xl-3[data-v-24456ff2]{padding-bottom:1rem!important}.pb-xl-4[data-v-24456ff2]{padding-bottom:1.5rem!important}.pb-xl-5[data-v-24456ff2]{padding-bottom:3rem!important}.ps-xl-0[data-v-24456ff2]{padding-left:0!important}.ps-xl-1[data-v-24456ff2]{padding-left:.25rem!important}.ps-xl-2[data-v-24456ff2]{padding-left:.5rem!important}.ps-xl-3[data-v-24456ff2]{padding-left:1rem!important}.ps-xl-4[data-v-24456ff2]{padding-left:1.5rem!important}.ps-xl-5[data-v-24456ff2]{padding-left:3rem!important}.text-xl-start[data-v-24456ff2]{text-align:left!important}.text-xl-end[data-v-24456ff2]{text-align:right!important}.text-xl-center[data-v-24456ff2]{text-align:center!important}}@media (min-width:1400px){.float-xxl-start[data-v-24456ff2]{float:left!important}.float-xxl-end[data-v-24456ff2]{float:right!important}.float-xxl-none[data-v-24456ff2]{float:none!important}.d-xxl-inline[data-v-24456ff2]{display:inline!important}.d-xxl-inline-block[data-v-24456ff2]{display:inline-block!important}.d-xxl-block[data-v-24456ff2]{display:block!important}.d-xxl-grid[data-v-24456ff2]{display:grid!important}.d-xxl-table[data-v-24456ff2]{display:table!important}.d-xxl-table-row[data-v-24456ff2]{display:table-row!important}.d-xxl-table-cell[data-v-24456ff2]{display:table-cell!important}.d-xxl-flex[data-v-24456ff2]{display:flex!important}.d-xxl-inline-flex[data-v-24456ff2]{display:inline-flex!important}.d-xxl-none[data-v-24456ff2]{display:none!important}.flex-xxl-fill[data-v-24456ff2]{flex:1 1 auto!important}.flex-xxl-row[data-v-24456ff2]{flex-direction:row!important}.flex-xxl-column[data-v-24456ff2]{flex-direction:column!important}.flex-xxl-row-reverse[data-v-24456ff2]{flex-direction:row-reverse!important}.flex-xxl-column-reverse[data-v-24456ff2]{flex-direction:column-reverse!important}.flex-xxl-grow-0[data-v-24456ff2]{flex-grow:0!important}.flex-xxl-grow-1[data-v-24456ff2]{flex-grow:1!important}.flex-xxl-shrink-0[data-v-24456ff2]{flex-shrink:0!important}.flex-xxl-shrink-1[data-v-24456ff2]{flex-shrink:1!important}.flex-xxl-wrap[data-v-24456ff2]{flex-wrap:wrap!important}.flex-xxl-nowrap[data-v-24456ff2]{flex-wrap:nowrap!important}.flex-xxl-wrap-reverse[data-v-24456ff2]{flex-wrap:wrap-reverse!important}.gap-xxl-0[data-v-24456ff2]{gap:0!important}.gap-xxl-1[data-v-24456ff2]{gap:.25rem!important}.gap-xxl-2[data-v-24456ff2]{gap:.5rem!important}.gap-xxl-3[data-v-24456ff2]{gap:1rem!important}.gap-xxl-4[data-v-24456ff2]{gap:1.5rem!important}.gap-xxl-5[data-v-24456ff2]{gap:3rem!important}.justify-content-xxl-start[data-v-24456ff2]{justify-content:flex-start!important}.justify-content-xxl-end[data-v-24456ff2]{justify-content:flex-end!important}.justify-content-xxl-center[data-v-24456ff2]{justify-content:center!important}.justify-content-xxl-between[data-v-24456ff2]{justify-content:space-between!important}.justify-content-xxl-around[data-v-24456ff2]{justify-content:space-around!important}.justify-content-xxl-evenly[data-v-24456ff2]{justify-content:space-evenly!important}.align-items-xxl-start[data-v-24456ff2]{align-items:flex-start!important}.align-items-xxl-end[data-v-24456ff2]{align-items:flex-end!important}.align-items-xxl-center[data-v-24456ff2]{align-items:center!important}.align-items-xxl-baseline[data-v-24456ff2]{align-items:baseline!important}.align-items-xxl-stretch[data-v-24456ff2]{align-items:stretch!important}.align-content-xxl-start[data-v-24456ff2]{align-content:flex-start!important}.align-content-xxl-end[data-v-24456ff2]{align-content:flex-end!important}.align-content-xxl-center[data-v-24456ff2]{align-content:center!important}.align-content-xxl-between[data-v-24456ff2]{align-content:space-between!important}.align-content-xxl-around[data-v-24456ff2]{align-content:space-around!important}.align-content-xxl-stretch[data-v-24456ff2]{align-content:stretch!important}.align-self-xxl-auto[data-v-24456ff2]{align-self:auto!important}.align-self-xxl-start[data-v-24456ff2]{align-self:flex-start!important}.align-self-xxl-end[data-v-24456ff2]{align-self:flex-end!important}.align-self-xxl-center[data-v-24456ff2]{align-self:center!important}.align-self-xxl-baseline[data-v-24456ff2]{align-self:baseline!important}.align-self-xxl-stretch[data-v-24456ff2]{align-self:stretch!important}.order-xxl-first[data-v-24456ff2]{order:-1!important}.order-xxl-0[data-v-24456ff2]{order:0!important}.order-xxl-1[data-v-24456ff2]{order:1!important}.order-xxl-2[data-v-24456ff2]{order:2!important}.order-xxl-3[data-v-24456ff2]{order:3!important}.order-xxl-4[data-v-24456ff2]{order:4!important}.order-xxl-5[data-v-24456ff2]{order:5!important}.order-xxl-last[data-v-24456ff2]{order:6!important}.m-xxl-0[data-v-24456ff2]{margin:0!important}.m-xxl-1[data-v-24456ff2]{margin:.25rem!important}.m-xxl-2[data-v-24456ff2]{margin:.5rem!important}.m-xxl-3[data-v-24456ff2]{margin:1rem!important}.m-xxl-4[data-v-24456ff2]{margin:1.5rem!important}.m-xxl-5[data-v-24456ff2]{margin:3rem!important}.m-xxl-auto[data-v-24456ff2]{margin:auto!important}.mx-xxl-0[data-v-24456ff2]{margin-right:0!important;margin-left:0!important}.mx-xxl-1[data-v-24456ff2]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xxl-2[data-v-24456ff2]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xxl-3[data-v-24456ff2]{margin-right:1rem!important;margin-left:1rem!important}.mx-xxl-4[data-v-24456ff2]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xxl-5[data-v-24456ff2]{margin-right:3rem!important;margin-left:3rem!important}.mx-xxl-auto[data-v-24456ff2]{margin-right:auto!important;margin-left:auto!important}.my-xxl-0[data-v-24456ff2]{margin-top:0!important;margin-bottom:0!important}.my-xxl-1[data-v-24456ff2]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xxl-2[data-v-24456ff2]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xxl-3[data-v-24456ff2]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xxl-4[data-v-24456ff2]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xxl-5[data-v-24456ff2]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xxl-auto[data-v-24456ff2]{margin-top:auto!important;margin-bottom:auto!important}.mt-xxl-0[data-v-24456ff2]{margin-top:0!important}.mt-xxl-1[data-v-24456ff2]{margin-top:.25rem!important}.mt-xxl-2[data-v-24456ff2]{margin-top:.5rem!important}.mt-xxl-3[data-v-24456ff2]{margin-top:1rem!important}.mt-xxl-4[data-v-24456ff2]{margin-top:1.5rem!important}.mt-xxl-5[data-v-24456ff2]{margin-top:3rem!important}.mt-xxl-auto[data-v-24456ff2]{margin-top:auto!important}.me-xxl-0[data-v-24456ff2]{margin-right:0!important}.me-xxl-1[data-v-24456ff2]{margin-right:.25rem!important}.me-xxl-2[data-v-24456ff2]{margin-right:.5rem!important}.me-xxl-3[data-v-24456ff2]{margin-right:1rem!important}.me-xxl-4[data-v-24456ff2]{margin-right:1.5rem!important}.me-xxl-5[data-v-24456ff2]{margin-right:3rem!important}.me-xxl-auto[data-v-24456ff2]{margin-right:auto!important}.mb-xxl-0[data-v-24456ff2]{margin-bottom:0!important}.mb-xxl-1[data-v-24456ff2]{margin-bottom:.25rem!important}.mb-xxl-2[data-v-24456ff2]{margin-bottom:.5rem!important}.mb-xxl-3[data-v-24456ff2]{margin-bottom:1rem!important}.mb-xxl-4[data-v-24456ff2]{margin-bottom:1.5rem!important}.mb-xxl-5[data-v-24456ff2]{margin-bottom:3rem!important}.mb-xxl-auto[data-v-24456ff2]{margin-bottom:auto!important}.ms-xxl-0[data-v-24456ff2]{margin-left:0!important}.ms-xxl-1[data-v-24456ff2]{margin-left:.25rem!important}.ms-xxl-2[data-v-24456ff2]{margin-left:.5rem!important}.ms-xxl-3[data-v-24456ff2]{margin-left:1rem!important}.ms-xxl-4[data-v-24456ff2]{margin-left:1.5rem!important}.ms-xxl-5[data-v-24456ff2]{margin-left:3rem!important}.ms-xxl-auto[data-v-24456ff2]{margin-left:auto!important}.p-xxl-0[data-v-24456ff2]{padding:0!important}.p-xxl-1[data-v-24456ff2]{padding:.25rem!important}.p-xxl-2[data-v-24456ff2]{padding:.5rem!important}.p-xxl-3[data-v-24456ff2]{padding:1rem!important}.p-xxl-4[data-v-24456ff2]{padding:1.5rem!important}.p-xxl-5[data-v-24456ff2]{padding:3rem!important}.px-xxl-0[data-v-24456ff2]{padding-right:0!important;padding-left:0!important}.px-xxl-1[data-v-24456ff2]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xxl-2[data-v-24456ff2]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xxl-3[data-v-24456ff2]{padding-right:1rem!important;padding-left:1rem!important}.px-xxl-4[data-v-24456ff2]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xxl-5[data-v-24456ff2]{padding-right:3rem!important;padding-left:3rem!important}.py-xxl-0[data-v-24456ff2]{padding-top:0!important;padding-bottom:0!important}.py-xxl-1[data-v-24456ff2]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xxl-2[data-v-24456ff2]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xxl-3[data-v-24456ff2]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xxl-4[data-v-24456ff2]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xxl-5[data-v-24456ff2]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xxl-0[data-v-24456ff2]{padding-top:0!important}.pt-xxl-1[data-v-24456ff2]{padding-top:.25rem!important}.pt-xxl-2[data-v-24456ff2]{padding-top:.5rem!important}.pt-xxl-3[data-v-24456ff2]{padding-top:1rem!important}.pt-xxl-4[data-v-24456ff2]{padding-top:1.5rem!important}.pt-xxl-5[data-v-24456ff2]{padding-top:3rem!important}.pe-xxl-0[data-v-24456ff2]{padding-right:0!important}.pe-xxl-1[data-v-24456ff2]{padding-right:.25rem!important}.pe-xxl-2[data-v-24456ff2]{padding-right:.5rem!important}.pe-xxl-3[data-v-24456ff2]{padding-right:1rem!important}.pe-xxl-4[data-v-24456ff2]{padding-right:1.5rem!important}.pe-xxl-5[data-v-24456ff2]{padding-right:3rem!important}.pb-xxl-0[data-v-24456ff2]{padding-bottom:0!important}.pb-xxl-1[data-v-24456ff2]{padding-bottom:.25rem!important}.pb-xxl-2[data-v-24456ff2]{padding-bottom:.5rem!important}.pb-xxl-3[data-v-24456ff2]{padding-bottom:1rem!important}.pb-xxl-4[data-v-24456ff2]{padding-bottom:1.5rem!important}.pb-xxl-5[data-v-24456ff2]{padding-bottom:3rem!important}.ps-xxl-0[data-v-24456ff2]{padding-left:0!important}.ps-xxl-1[data-v-24456ff2]{padding-left:.25rem!important}.ps-xxl-2[data-v-24456ff2]{padding-left:.5rem!important}.ps-xxl-3[data-v-24456ff2]{padding-left:1rem!important}.ps-xxl-4[data-v-24456ff2]{padding-left:1.5rem!important}.ps-xxl-5[data-v-24456ff2]{padding-left:3rem!important}.text-xxl-start[data-v-24456ff2]{text-align:left!important}.text-xxl-end[data-v-24456ff2]{text-align:right!important}.text-xxl-center[data-v-24456ff2]{text-align:center!important}}@media (min-width:1200px){.fs-1[data-v-24456ff2]{font-size:2.5rem!important}.fs-2[data-v-24456ff2]{font-size:2rem!important}.fs-3[data-v-24456ff2]{font-size:1.75rem!important}.fs-4[data-v-24456ff2]{font-size:1.5rem!important}}@media print{.d-print-inline[data-v-24456ff2]{display:inline!important}.d-print-inline-block[data-v-24456ff2]{display:inline-block!important}.d-print-block[data-v-24456ff2]{display:block!important}.d-print-grid[data-v-24456ff2]{display:grid!important}.d-print-table[data-v-24456ff2]{display:table!important}.d-print-table-row[data-v-24456ff2]{display:table-row!important}.d-print-table-cell[data-v-24456ff2]{display:table-cell!important}.d-print-flex[data-v-24456ff2]{display:flex!important}.d-print-inline-flex[data-v-24456ff2]{display:inline-flex!important}.d-print-none[data-v-24456ff2]{display:none!important}}", ""]);

// exports


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(179);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7b683aee", content, true, {});

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports
exports.i(__webpack_require__(180), "");
exports.i(__webpack_require__(181), "");
exports.i(__webpack_require__(182), "");

// module
exports.push([module.i, "body[data-v-24456ff2]{margin-top:100px;text-align:center}", ""]);

// exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,500);", ""]);

// module
exports.push([module.i, "@font-face{font-family:e-icons;font-style:normal;font-weight:400;src:url(data:application/x-font-ttf;charset=utf-8;base64,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) format(\"truetype\")}.e-icons{font-family:e-icons;font-style:normal;font-variant:normal;font-weight:400;line-height:1;text-transform:none}.e-icons.e-small{font-size:8px}.e-icons.e-medium{font-size:16px}.e-icons.e-large{font-size:24px}.e-icons.e-export-pdf:before{content:\"\\E240\"}.e-icons.e-export-csv:before{content:\"\\E241\"}.e-icons.e-export-excel:before{content:\"\\E242\"}.e-icons.e-date-range:before{content:\"\\E245\"}.e-icons.e-filter-clear:before{content:\"\\E248\"}.e-icons.e-filter:before{content:\"\\E251\"}.e-icons.e-bullet-6:before{content:\"\\E253\"}.e-icons.e-bullet-1:before{content:\"\\E254\"}.e-icons.e-none:before{content:\"\\E256\"}.e-icons.e-bullet-5:before{content:\"\\E259\"}.e-icons.e-border-diagonal-2:before{content:\"\\E262\"}.e-icons.e-border-diagonal-1:before{content:\"\\E265\"}.e-icons.e-bullet-4:before{content:\"\\E267\"}.e-icons.e-bullet-2:before{content:\"\\E270\"}.e-icons.e-bullet-3:before{content:\"\\E271\"}.e-icons.e-chevron-right-double:before{content:\"\\E300\"}.e-icons.e-chevron-left-double:before{content:\"\\E302\"}.e-icons.e-chevron-down-double:before{content:\"\\E304\"}.e-icons.e-chevron-up-double:before{content:\"\\E306\"}.e-icons.e-repeat:before{content:\"\\E308\"}.e-icons.e-recurrence-edit:before{content:\"\\E30A\"}.e-icons.e-location:before{content:\"\\E30C\"}.e-icons.e-description:before{content:\"\\E30D\"}.e-icons.e-time-zone:before{content:\"\\E30E\"}.e-icons.e-calendar:before{content:\"\\E322\"}.e-icons.e-timeline-agenda:before{content:\"\\E313\"}.e-icons.e-work-week:before{content:\"\\E314\"}.e-icons.e-week:before{content:\"\\E315\"}.e-icons.e-day:before{content:\"\\E31B\"}.e-icons.e-agenda-date-range:before{content:\"\\E31D\"}.e-icons.e-date-time:before{content:\"\\E421\"}.e-icons.e-people:before{content:\"\\E424\"}.e-icons.e-timeline-day:before{content:\"\\EA85\"}.e-icons.e-timeline-week:before{content:\"\\EA88\"}.e-icons.e-timeline-work-week:before{content:\"\\EA8B\"}.e-icons.e-timeline-month:before{content:\"\\EA8E\"}.e-icons.e-table:before{content:\"\\E705\"}.e-icons.e-copy:before{content:\"\\E70A\"}.e-icons.e-th-small:before{content:\"\\E714\"}.e-icons.e-save-2:before{content:\"\\E735\"}.e-icons.e-paragraph-2:before{content:\"\\E75E\"}.e-icons.e-edit-6:before{content:\"\\E7A3\"}.e-icons.e-close-large-1:before{content:\"\\E7A7\"}.e-icons.e-export-word:before{content:\"\\E7B0\"}.e-icons.e-circle-close:before{content:\"\\E7E9\"}.e-icons.e-filter-2:before{content:\"\\E7EE\"}.e-icons.e-plus-small:before{content:\"\\E7F9\"}.e-icons.e-close:before{content:\"\\E7FC\"}.e-icons.e-check:before{content:\"\\E7FF\"}.e-icons.e-print-2:before{content:\"\\E813\"}.e-icons.e-edit-2:before{content:\"\\E81E\"}.e-icons.e-plus:before{content:\"\\E823\"}.e-icons.e-close-large-2:before{content:\"\\E825\"}.e-icons.e-chevron-down-thin:before{content:\"\\E36A\"}.e-icons.e-chevron-up-fill-2:before{content:\"\\E82A\"}.e-icons.e-chevron-down-fill:before{content:\"\\E82E\"}.e-icons.e-chevron-up-fill:before{content:\"\\E834\"}.e-icons.e-chevron-down-fill-2:before{content:\"\\E83D\"}.e-icons.e-arrow-down:before{content:\"\\E83F\"}.e-icons.e-arrow-up:before{content:\"\\E840\"}.e-icons.e-chevron-right-fill-3:before{content:\"\\E848\"}.e-icons.e-chevron-left-fill-2:before{content:\"\\E84B\"}.e-icons.e-delete-1:before{content:\"\\E84E\"}.e-icons.e-chevron-left-fill:before{content:\"\\E854\"}.e-icons.e-chevron-right-fill:before{content:\"\\E859\"}.e-icons.e-arrow-left:before{content:\"\\E85B\"}.e-icons.e-arrow-right:before{content:\"\\E85F\"}.e-icons.e-sorting-1:before{content:\"\\E890\"}.e-icons.e-edit:before{content:\"\\E891\"}.e-icons.e-first-page:before{content:\"\\E896\"}.e-icons.e-last-page:before{content:\"\\E897\"}.e-icons.e-timeline-today:before{content:\"\\E901\"}.e-icons.e-chevron-left:before{content:\"\\E904\"}.e-icons.e-filter-1:before{content:\"\\E909\"}.e-icons.e-chevron-up:before{content:\"\\E910\"}.e-icons.e-chevron-right:before{content:\"\\E913\"}.e-icons.e-chevron-down:before{content:\"\\E916\"}.e-icons.e-circle-close-2:before{content:\"\\E917\"}.e-icons.e-chevron-up-fill-3:before{content:\"\\E918\"}.e-icons.e-chevron-down-fill-3:before{content:\"\\E919\"}.e-icons.e-filter-cancel:before{content:\"\\E920\"}.e-icons.e-chevron-left-2:before{content:\"\\E921\"}.e-icons.e-group-icon:before{content:\"\\E926\"}.e-icons.e-selection:before{content:\"\\E930\"}.e-icons.e-close-2:before{content:\"\\E932\"}.e-icons.e-check-2:before{content:\"\\E933\"}.e-icons.e-intermediate-state:before{content:\"\\E934\"}.e-icons.e-chevron-left-3:before{content:\"\\E937\"}.e-icons.e-edit-3:before{content:\"\\E944\"}.e-icons.e-close-3:before{content:\"\\E945\"}.e-icons.e-chevron-right-2:before{content:\"\\E956\"}.e-icons.e-plus-2:before{content:\"\\E963\"}.e-icons.e-chevron-down-fill-5:before{content:\"\\E969\"}.e-icons.e-circle-remove:before{content:\"\\E974\"}.e-icons.e-arrow-left-2:before{content:\"\\E977\"}.e-icons.e-more-vertical-1:before{content:\"\\E984\"}.e-icons.e-search:before{content:\"\\E993\"}.e-icons.e-month:before{content:\"\\E93C\"}.e-icons.e-trash:before{content:\"\\E94A\"}.e-icons.e-chevron-down-2:before{content:\"\\E94D\"}.e-icons.e-save:before{content:\"\\E98E\"}.e-icons.e-menu:before{content:\"\\E99A\"}.e-icons.e-refresh:before{content:\"\\E99D\"}.e-icons.e-circle-close-fill-3:before{content:\"\\E208\"}.e-icons.e-clock:before{content:\"\\E20C\"}.e-icons.e-freeze-column:before{content:\"\\E21E\"}.e-icons.e-error-treeview:before{content:\"\\E22A\"}.e-icons.e-circle-remove-2:before{content:\"\\E22B\"}.e-icons.e-circle-add:before{content:\"\\E22C\"}.e-icons.e-drag-and-drop-indicator:before{content:\"\\E22D\"}.e-icons.e-chevron-right-3:before{content:\"\\E22F\"}.e-icons.e-chevron-right-4:before{content:\"\\E430\"}.e-icons.e-play:before{content:\"\\E324\"}.e-icons.e-pause:before{content:\"\\E326\"}.e-icons.e-para-option-down:before{content:\"\\E274\"}.e-icons.e-search-2:before{content:\"\\E275\"}.e-icons.e-border-center:before{content:\"\\E276\"}.e-icons.e-restart-at-1:before{content:\"\\E277\"}.e-icons.e-hyperlink-open:before{content:\"\\E278\"}.e-icons.e-cut-2:before{content:\"\\E279\"}.e-icons.e-copy-2:before{content:\"\\E280\"}.e-icons.e-border-top:before{content:\"\\E281\"}.e-icons.e-delete-column:before{content:\"\\E282\"}.e-icons.e-delete-row:before{content:\"\\E283\"}.e-icons.e-insert-right:before{content:\"\\E284\"}.e-icons.e-insert-left:before{content:\"\\E285\"}.e-icons.e-hyperlink-remove:before{content:\"\\E286\"}.e-icons.e-border-middle:before{content:\"\\E287\"}.e-icons.e-border-right:before{content:\"\\E288\"}.e-icons.e-hyperlink-edit:before{content:\"\\E289\"}.e-icons.e-link-2:before{content:\"\\E290\"}.e-icons.e-border-left:before{content:\"\\E291\"}.e-icons.e-table-delete:before{content:\"\\E292\"}.e-icons.e-table-properties:before{content:\"\\E294\"}.e-icons.e-hyperlink-copy:before{content:\"\\E295\"}.e-icons.e-border-bottom:before{content:\"\\E298\"}.e-icons.e-paste-2:before{content:\"\\E501\"}.e-icons.e-continue-numbering:before{content:\"\\E503\"}.e-icons.e-insert-below:before{content:\"\\E505\"}.e-icons.e-insert-above:before{content:\"\\E506\"}.e-icons.e-table-cell-none:before{content:\"\\E507\"}.e-icons.e-box:before{content:\"\\E509\"}.e-icons.e-all:before{content:\"\\E511\"}.e-icons.e-table-align-right:before{content:\"\\E515\"}.e-icons.e-table-border-custom:before{content:\"\\E516\"}.e-icons.e-table-align-left:before{content:\"\\E517\"}.e-icons.e-table-align-center:before{content:\"\\E518\"}.e-icons.e-line-very-small:before{content:\"\\E520\"}.e-icons.e-line-normal:before{content:\"\\E521\"}.e-icons.e-line-small:before{content:\"\\E522\"}.e-icons.e-para-option-up:before{content:\"\\E523\"}.e-icons.e-vertical-align-bottom:before{content:\"\\E525\"}.e-icons.e-vertical-align-center:before{content:\"\\E526\"}.e-icons.e-vertical-align-top:before{content:\"\\E527\"}.e-icons.e-clear-format:before{content:\"\\E331\"}.e-icons.e-strikethrough:before{content:\"\\E332\"}.e-icons.e-upper-case:before{content:\"\\E333\"}.e-icons.e-justify:before{content:\"\\E334\"}.e-icons.e-image:before{content:\"\\E335\"}.e-icons.e-resize:before{content:\"\\E336\"}.e-icons.e-exit-full-screen:before{content:\"\\E337\"}.e-icons.e-edit-4:before{content:\"\\E338\"}.e-icons.e-bold:before{content:\"\\E339\"}.e-icons.e-align-left:before{content:\"\\E33A\"}.e-icons.e-cut:before{content:\"\\E33B\"}.e-icons.e-text-alternative:before{content:\"\\E33C\"}.e-icons.e-copy-1:before{content:\"\\E33D\"}.e-icons.e-delete-2:before{content:\"\\E33E\"}.e-icons.e-increase-indent:before{content:\"\\E33F\"}.e-icons.e-erase:before{content:\"\\E340\"}.e-icons.e-undo:before{content:\"\\E341\"}.e-icons.e-full-screen:before{content:\"\\E342\"}.e-icons.e-underline:before{content:\"\\E343\"}.e-icons.e-list-unordered:before{content:\"\\E344\"}.e-icons.e-eye:before{content:\"\\E345\"}.e-icons.e-list-ordered:before{content:\"\\E346\"}.e-icons.e-lower-case:before{content:\"\\E347\"}.e-icons.e-link-remove:before{content:\"\\E348\"}.e-icons.e-zoom-in:before{content:\"\\E349\"}.e-icons.e-open-link:before{content:\"\\E34A\"}.e-icons.e-print:before{content:\"\\E34B\"}.e-icons.e-font-color:before{content:\"\\E34C\"}.e-icons.e-align-right:before{content:\"\\E34D\"}.e-icons.e-link:before{content:\"\\E34E\"}.e-icons.e-view-side:before{content:\"\\E34F\"}.e-icons.e-code-view:before{content:\"\\E350\"}.e-icons.e-zoom-out:before{content:\"\\E351\"}.e-icons.e-superscript:before{content:\"\\E352\"}.e-icons.e-paragraph:before{content:\"\\E353\"}.e-icons.e-redo:before{content:\"\\E354\"}.e-icons.e-paste:before{content:\"\\E355\"}.e-icons.e-insert-code:before{content:\"\\E356\"}.e-icons.e-subscript:before{content:\"\\E357\"}.e-icons.e-display:before{content:\"\\E358\"}.e-icons.e-replace:before{content:\"\\E359\"}.e-icons.e-italic:before{content:\"\\E35A\"}.e-icons.e-caption:before{content:\"\\E35B\"}.e-icons.e-paint-bucket:before{content:\"\\E35C\"}.e-icons.e-decrease-indent:before{content:\"\\E35D\"}.e-icons.e-align-center:before{content:\"\\E35E\"}.e-icons.e-font-name:before{content:\"\\E35F\"}.e-icons.e-drag-and-drop-2:before{content:\"\\E330\"}.e-icons.e-field-settings:before{content:\"\\E434\"}.e-icons.e-two-column:before{content:\"\\EA74\"}.e-icons.e-two-row:before{content:\"\\EA75\"}.e-icons.e-sum:before{content:\"\\EA76\"}.e-icons.e-filter-3:before{content:\"\\EA77\"}.e-icons.e-close-large:before{content:\"\\EA7F\"}.e-icons.e-filter-clear-2:before{content:\"\\EA82\"}.e-icons.e-circle-check:before{content:\"\\EA84\"}.e-icons.e-align-bottom:before{content:\"\\EA91\"}.e-icons.e-insert-above-2:before{content:\"\\EA92\"}.e-icons.e-insert-below-2:before{content:\"\\EA93\"}.e-icons.e-align-middle:before{content:\"\\EA94\"}.e-icons.e-delete-column-2:before{content:\"\\EA95\"}.e-icons.e-delete-row-2:before{content:\"\\EA96\"}.e-icons.e-insert-left-2:before{content:\"\\EA97\"}.e-icons.e-align-top:before{content:\"\\EA98\"}.e-icons.e-insert-right-2:before{content:\"\\EA99\"}.e-icons.e-edit-5:before{content:\"\\EA9A\"}.e-icons.e-align-middle-2:before{content:\"\\EA9B\"}.e-icons.e-freeze-column-2:before{content:\"\\EA9E\"}.e-icons.e-style:before{content:\"\\EA9F\"}.e-icons.e-delete-3:before{content:\"\\EB00\"}.e-icons.e-freeze-row:before{content:\"\\EB02\"}.e-icons.e-text-header:before{content:\"\\EB03\"}.e-icons.e-more-horizontal-1:before{content:\"\\EB04\"}.e-icons.e-resizer:before{content:\"\\EB05\"}.e-icons.e-folder:before{content:\"\\EC04\"}.e-icons.e-first-page-2:before{content:\"\\EC05\"}.e-icons.e-previous:before{content:\"\\EC06\"}.e-icons.e-next:before{content:\"\\EC07\"}.e-icons.e-last-page-2:before{content:\"\\EC08\"}.e-icons.e-zoom-out-2:before{content:\"\\EC09\"}.e-icons.e-zoom-in-2:before{content:\"\\EC0A\"}.e-icons.e-download:before{content:\"\\EC0B\"}.e-icons.e-bookmark:before{content:\"\\EC0C\"}.e-icons.e-search-3:before{content:\"\\EC0D\"}.e-icons.e-text-annotation:before{content:\"\\EC0E\"}.e-icons.e-close-4:before{content:\"\\EC0F\"}.e-icons.e-comments:before{content:\"\\EC10\"}.e-icons.e-save-3:before{content:\"\\EC11\"}.e-icons.e-align-left-2:before{content:\"\\EC12\"}.e-icons.e-style-2:before{content:\"\\EC13\"}.e-icons.e-undo-2:before{content:\"\\EC14\"}.e-icons.e-highlight-color:before{content:\"\\EC15\"}.e-icons.e-more-vertical-3:before{content:\"\\EC16\"}.e-icons.e-underline-2:before{content:\"\\EC17\"}.e-icons.e-strikethrough-2:before{content:\"\\EC18\"}.e-icons.e-paint-bucket-2:before{content:\"\\EC19\"}.e-icons.e-pan:before{content:\"\\EC1A\"}.e-icons.e-opacity:before{content:\"\\EC1B\"}.e-icons.e-delete-4:before{content:\"\\EC1C\"}.e-icons.e-mouse-pointer:before{content:\"\\EC1D\"}.e-icons.e-chevron-right-small:before{content:\"\\EC1E\"}.e-icons.e-stroke-color:before{content:\"\\EC1F\"}.e-icons.e-print-3:before{content:\"\\EC20\"}.e-icons.e-redo-2:before{content:\"\\EC21\"}.e-icons.e-font-color-2:before{content:\"\\EC22\"}.e-icons.e-shapes:before{content:\"\\EC23\"}.e-icons.e-chevron-left-small:before{content:\"\\EC24\"}.e-icons.e-stroke-width:before{content:\"\\EC25\"}.e-icons.e-annotation-edit:before{content:\"\\EC26\"}.e-icons.e-thumbnail:before{content:\"\\EC27\"}.e-icons.e-stamp:before{content:\"\\EC28\"}.e-icons.e-break-page:before{content:\"\\EC29\"}.e-icons.e-file:before{content:\"\\EC2A\"}.e-icons.e-collapse-2:before{content:\"\\E554\"}.e-icons.e-expand:before{content:\"\\E556\"}.e-icons.e-double-resize-2:before{content:\"\\E557\"}.e-icons.e-double-resize-1:before{content:\"\\E558\"}.e-icons.e-single-resize-1:before{content:\"\\E559\"}.e-icons.e-single-resize-2:before{content:\"\\E56A\"}.e-icons.e-single-resize-3:before{content:\"\\E56B\"}.e-icons.e-single-resize-4:before{content:\"\\E56C\"}.e-icons.e-drag-and-drop:before{content:\"\\E903\"}.e-icons.e-chevron-up-fill-4:before{content:\"\\E56D\"}.e-icons.e-chevron-down-fill-4:before{content:\"\\E56E\"}.e-icons.e-chevron-right-fill-2:before{content:\"\\E56F\"}.e-icons.e-chevron-left-fill-3:before{content:\"\\E570\"}.e-icons.e-more-vertical-4:before{content:\"\\E571\"}.e-icons.e-filter-active:before{content:\"\\EBB3\"}.e-icons.e-code-view-2:before{content:\"\\E907\"}.e-icons.e-grid-view:before{content:\"\\E600\"}.e-icons.e-paste-3:before{content:\"\\E601\"}.e-icons.e-trash-2:before{content:\"\\E602\"}.e-icons.e-download-2:before{content:\"\\E603\"}.e-icons.e-cut-3:before{content:\"\\E604\"}.e-icons.e-list-unordered-2:before{content:\"\\E605\"}.e-icons.e-refresh-2:before{content:\"\\E606\"}.e-icons.e-circle-info:before{content:\"\\E607\"}.e-icons.e-chevron-right-thin:before{content:\"\\E608\"}.e-icons.e-folder-2:before{content:\"\\E609\"}.e-icons.e-close-5:before{content:\"\\E60A\"}.e-icons.e-folder-fill:before{content:\"\\E60B\"}.e-icons.e-rename:before{content:\"\\E60C\"}.e-icons.e-copy-3:before{content:\"\\E60D\"}.e-icons.e-search-4:before{content:\"\\E60E\"}.e-icons.e-upload-1:before{content:\"\\E60F\"}.e-icons.e-back:before{content:\"\\E610\"}.e-icons.e-select-all:before{content:\"\\E611\"}.e-icons.e-sorting-2:before{content:\"\\E612\"}.e-icons.e-more-vertical-5:before{content:\"\\E613\"}.e-icons.e-check-3:before{content:\"\\E614\"}.e-icons.e-more-horizontal-3:before{content:\"\\E615\"}.e-icons.e-export-excel-2:before{content:\"\\E700\"}.e-icons.e-export-csv-2:before{content:\"\\E701\"}.e-icons.e-save-4:before{content:\"\\E703\"}.e-icons.e-save-as:before{content:\"\\E704\"}.e-icons.e-export:before{content:\"\\E711\"}.e-icons.e-delete-5:before{content:\"\\E706\"}.e-icons.e-grand-total:before{content:\"\\E707\"}.e-icons.e-table-2:before{content:\"\\E708\"}.e-icons.e-sub-total:before{content:\"\\E709\"}.e-icons.e-file-new:before{content:\"\\E712\"}.e-icons.e-number-formatting:before{content:\"\\E70B\"}.e-icons.e-rename-2:before{content:\"\\E70C\"}.e-icons.e-export-pdf-2:before{content:\"\\E70D\"}.e-icons.e-full-screen-2:before{content:\"\\E70E\"}.e-icons.e-chart:before{content:\"\\E70F\"}.e-icons.e-upload-2:before{content:\"\\E710\"}.e-icons.e-font-type:before{content:\"\\E273\"}.e-icons.e-close-6:before{content:\"\\EB36\"}.e-icons.e-line-spacing:before{content:\"\\EB37\"}.e-icons.e-lock:before{content:\"\\EB3A\"}.e-icons.e-border-outer:before{content:\"\\EB66\"}.e-icons.e-link-3:before{content:\"\\EB3C\"}.e-icons.e-align-bottom-2:before{content:\"\\EB3D\"}.e-icons.e-border-all-2:before{content:\"\\EB3E\"}.e-icons.e-table-of-content:before{content:\"\\EB41\"}.e-icons.e-page-numbering:before{content:\"\\EB43\"}.e-icons.e-bold-2:before{content:\"\\EB47\"}.e-icons.e-align-top-2:before{content:\"\\EB49\"}.e-icons.e-align-middle-3:before{content:\"\\EB4A\"}.e-icons.e-page-setup:before{content:\"\\EB4C\"}.e-icons.e-stroke-style:before{content:\"\\EB4D\"}.e-icons.e-image-2:before{content:\"\\EB4F\"}.e-icons.e-bookmark-fill:before{content:\"\\EB51\"}.e-icons.e-header:before{content:\"\\EB53\"}.e-icons.e-list-unordered-3:before{content:\"\\EB5B\"}.e-icons.e-show-hide-panel:before{content:\"\\EB5D\"}.e-icons.e-align-right-2:before{content:\"\\EB5F\"}.e-icons.e-footer:before{content:\"\\EB60\"}.e-icons.e-border-all:before{content:\"\\EB95\"}.e-icons.e-border-inner:before{content:\"\\EB88\"}.e-icons.e-cell:before{content:\"\\EB93\"}.e-icons.e-align-top-3:before{content:\"\\EB35\"}.e-icons.e-align-bottom-3:before{content:\"\\EB0E\"}.e-icons.e-align-middle-4:before{content:\"\\EB0D\"}.e-icons.e-check-4:before{content:\"\\E935\"}.e-icons.e-break:before{content:\"\\EBA6\"}.e-icons.e-break-page-2:before{content:\"\\EBA0\"}.e-icons.e-break-section:before{content:\"\\EBA2\"}.e-icons.e-auto-fit-content:before{content:\"\\EBA8\"}.e-icons.e-fixed-column-width:before{content:\"\\EBA9\"}.e-icons.e-auto-fit-window:before{content:\"\\EBAA\"}.e-icons.e-bring-forward:before{content:\"\\E5A1\"}.e-icons.e-bring-to-front:before{content:\"\\E5A2\"}.e-icons.e-send-to-back:before{content:\"\\E5A3\"}.e-icons.e-send-backward:before{content:\"\\E5A4\"}.e-icons.e-ungroup-1:before{content:\"\\E5A6\"}.e-icons.e-group-1:before{content:\"\\E5A7\"}.e-icons.e-order:before{content:\"\\E4A4\"}.e-icons.e-chevron-up-small-2:before{content:\"\\E651\"}.e-icons.e-chevron-down-small-2:before{content:\"\\E652\"}.e-icons.e-chevron-right-small-2:before{content:\"\\E653\"}.e-icons.e-chevron-left-small-2:before{content:\"\\E654\"}.e-icons.e-chevron-right-double-2:before{content:\"\\E655\"}.e-icons.e-chevron-left-double-2:before{content:\"\\E656\"}.e-icons.e-zoom-to-fit:before{content:\"\\E657\"}.e-icons.e-add-above:before{content:\"\\E658\"}.e-icons.e-add-below:before{content:\"\\E659\"}.e-icons.e-line:before{content:\"\\E668\"}.e-icons.e-arrow-right-up:before{content:\"\\E669\"}.e-icons.e-rectangle:before{content:\"\\E670\"}.e-icons.e-circle:before{content:\"\\E671\"}.e-icons.e-pentagan:before{content:\"\\E672\"}.e-icons.e-length:before{content:\"\\E673\"}.e-icons.e-perimeter:before{content:\"\\E674\"}.e-icons.e-area:before{content:\"\\E675\"}.e-icons.e-radius:before{content:\"\\E676\"}.e-icons.e-volume:before{content:\"\\E677\"}.e-icons.e-change-scale-ratio:before{content:\"\\E678\"}.e-icons.e-settings:before{content:\"\\E679\"}.e-icons.e-comment-2:before{content:\"\\E680\"}.e-icons.e-thumbs-down-1:before{content:\"\\E681\"}.e-icons.e-thumbs-up:before{content:\"\\E682\"}.e-icons.e-thumbs-down-2:before{content:\"\\E683\"}.e-icons.e-export-jpg:before{content:\"\\E713\"}.e-icons.e-export-png:before{content:\"\\E715\"}.e-icons.e-export-svg:before{content:\"\\E716\"}.e-icons.e-conditional-formatting:before{content:\"\\E725\"}.e-icons.e-hide-formula-bar:before{content:\"\\E717\"}.e-icons.e-hide-headings:before{content:\"\\E718\"}.e-icons.e-hide-gridlines:before{content:\"\\E719\"}.e-icons.e-eye-slash:before{content:\"\\E721\"}.e-icons.e-export-xls:before{content:\"\\E726\"}.e-icons.e-export-csv-3:before{content:\"\\E727\"}.e-icons.e-mdx:before{content:\"\\E724\"}.e-icons.e-rename-3:before{content:\"\\E728\"}.e-icons.e-folder-open:before{content:\"\\E65F\"}.e-icons.e-named-set:before{content:\"\\E65D\"}.e-icons.e-grip-vertical:before{content:\"\\E65C\"}.e-icons.e-dimension:before{content:\"\\E65B\"}.e-icons.e-level-1:before{content:\"\\E65A\"}.e-icons.e-level-2:before{content:\"\\E662\"}.e-icons.e-level-3:before{content:\"\\E65E\"}.e-icons.e-level-4:before{content:\"\\E660\"}.e-icons.e-level-5:before{content:\"\\E661\"}.e-icons.e-user-defined:before{content:\"\\E663\"}.e-icons.e-kpi:before{content:\"\\E664\"}.e-icons.e-sort-down:before{content:\"\\E665\"}.e-icons.e-sorting-3:before{content:\"\\E666\"}.e-icons.e-sort-up:before{content:\"\\E667\"}.e-icons.e-calculated-member:before{content:\"\\E729\"}.e-icons.e-custom-sort:before{content:\"\\E732\"}.e-icons.e-sort-descending:before{content:\"\\E733\"}.e-icons.e-sort-ascending:before{content:\"\\E734\"}.e-icons.e-comment-add:before{content:\"\\E814\"}.e-icons.e-reply:before{content:\"\\E815\"}.e-icons.e-send-1:before{content:\"\\E816\"}.e-icons.e-comment-show:before{content:\"\\E817\"}.e-icons.e-signature:before{content:\"\\E737\"}.e-icons.e-filter-main:before{content:\"\\E736\"}.e-icons.e-text-wrap:before{content:\"\\E824\"}.e-icons.e-unfiltered:before{content:\"\\E73A\"}.e-icons.e-filtered-sort-descending:before{content:\"\\E73B\"}.e-icons.e-sort-descending-2:before{content:\"\\E73C\"}.e-icons.e-sort-ascending-2:before{content:\"\\E73D\"}.e-icons.e-filtered-sort-ascending:before{content:\"\\E73E\"}.e-icons.e-filtered:before{content:\"\\E73F\"}.e-icons.e-filter-clear-3:before{content:\"\\E738\"}.e-icons.e-reapply:before{content:\"\\E74A\"}.e-icons.e-group-2:before{content:\"\\E74B\"}.e-icons.e-ungroup-2:before{content:\"\\E74C\"}.e-icons.e-paste-text-only:before{content:\"\\E685\"}.e-icons.e-paste-style:before{content:\"\\E686\"}.e-icons.e-paste-special:before{content:\"\\E687\"}.e-icons.e-paste-match-destination:before{content:\"\\E688\"}.e-icons.e-spell-check:before{content:\"\\E689\"}.e-icons.e-comment-reopen:before{content:\"\\E818\"}.e-icons.e-web-layout:before{content:\"\\E193\"}.e-icons.e-print-layout:before{content:\"\\E194\"}.e-icons.e-border-none:before{content:\"\\E195\"}.e-icons.e-data-validation:before{content:\"\\E196\"}.e-icons.e-protect-sheet:before{content:\"\\E197\"}.e-icons.e-text-form:before{content:\"\\E198\"}.e-icons.e-properties-2:before{content:\"\\E199\"}.e-icons.e-clear-form:before{content:\"\\E19A\"}.e-icons.e-drop-down:before{content:\"\\E19B\"}.e-icons.e-form-field:before{content:\"\\E19C\"}.e-icons.e-check-box:before{content:\"\\E192\"}.e-icons.e-table-update:before{content:\"\\E19E\"}.e-icons.e-changes-accept:before{content:\"\\E19F\"}.e-icons.e-display-for-review:before{content:\"\\E203\"}.e-icons.e-changes-reject:before{content:\"\\E204\"}.e-icons.e-changes-previous:before{content:\"\\E205\"}.e-icons.e-show-markup:before{content:\"\\E206\"}.e-icons.e-changes-next:before{content:\"\\E209\"}.e-icons.e-changes-track:before{content:\"\\E20A\"}.e-icons.e-conditional-formatting-large:before{content:\"\\E401\"}.e-icons.e-highlight:before{content:\"\\E402\"}.e-icons.e-top-bottom-rules:before{content:\"\\E403\"}.e-icons.e-data-bars:before{content:\"\\E404\"}.e-icons.e-color-scales:before{content:\"\\E405\"}.e-icons.e-iconsets:before{content:\"\\E406\"}.e-icons.e-clear-rules:before{content:\"\\E407\"}.e-icons.e-new-rules:before{content:\"\\E408\"}.e-icons.e-greater-than:before{content:\"\\E409\"}.e-icons.e-less-than:before{content:\"\\E410\"}.e-icons.e-between:before{content:\"\\E411\"}.e-icons.e-equalto:before{content:\"\\E412\"}.e-icons.e-text-that-contains:before{content:\"\\E413\"}.e-icons.e-date-occurring:before{content:\"\\E414\"}.e-icons.e-top-10:before{content:\"\\E415\"}.e-icons.e-bottom-10-items:before{content:\"\\E416\"}.e-icons.e-bottom-10:before{content:\"\\E417\"}.e-icons.e-above-average:before{content:\"\\E418\"}.e-icons.e-below-average:before{content:\"\\E419\"}.e-icons.e-duplicate-cell:before{content:\"\\E420\"}.e-icons.e-footnote:before{content:\"\\E435\"}.e-icons.e-end-footnote:before{content:\"\\E436\"}.e-icons.e-chart-insert-column:before{content:\"\\E440\"}.e-icons.e-chart-data-table:before{content:\"\\E441\"}.e-icons.e-chart-legend:before{content:\"\\E442\"}.e-icons.e-chart-insert-x-y-scatter:before{content:\"\\E443\"}.e-icons.e-chart-insert-waterfall:before{content:\"\\E444\"}.e-icons.e-chart-updown-bars:before{content:\"\\E445\"}.e-icons.e-add-chart-element:before{content:\"\\E446\"}.e-icons.e-chart-gridlines:before{content:\"\\E447\"}.e-icons.e-insert-hierarchy-charts:before{content:\"\\E448\"}.e-icons.e-chart-insert-line:before{content:\"\\E449\"}.e-icons.e-chart-switch-row-column:before{content:\"\\E450\"}.e-icons.e-chart-error-bars:before{content:\"\\E451\"}.e-icons.e-chart-trendline:before{content:\"\\E452\"}.e-icons.e-chart-axes:before{content:\"\\E453\"}.e-icons.e-chart-select-data:before{content:\"\\E454\"}.e-icons.e-chart-lines:before{content:\"\\E455\"}.e-icons.e-chart-axis-titles:before{content:\"\\E456\"}.e-icons.e-chart-title:before{content:\"\\E457\"}.e-icons.e-chart-insert-pie:before{content:\"\\E458\"}.e-icons.e-change-chart-type:before{content:\"\\E459\"}.e-icons.e-insert-statistic-chart:before{content:\"\\E460\"}.e-icons.e-chart-data-labels:before{content:\"\\E461\"}.e-icons.e-chart-insert-combo:before{content:\"\\E462\"}.e-icons.e-chart-axis-titles-primary-horizontal:before{content:\"\\E486\"}.e-icons.e-chart-linear-forecast:before{content:\"\\E487\"}.e-icons.e-chart-legend-none:before{content:\"\\E488\"}.e-icons.e-chart-legend-right:before{content:\"\\E489\"}.e-icons.e-chart-data-callout:before{content:\"\\E490\"}.e-icons.e-chart-primary-minor-vertical:before{content:\"\\E491\"}.e-icons.e-chart-axes-primary-vertical:before{content:\"\\E492\"}.e-icons.e-chart-data-labels-center:before{content:\"\\E493\"}.e-icons.e-chart-data-table-none:before{content:\"\\E115\"}.e-icons.e-chart-data-labels-none:before{content:\"\\E495\"}.e-icons.e-chart-primary-major-vertical:before{content:\"\\E496\"}.e-icons.e-chart-legend-linear:before{content:\"\\E497\"}.e-icons.e-chart-error-bars-percentage:before{content:\"\\E498\"}.e-icons.e-chart-no-legend-keys:before{content:\"\\E499\"}.e-icons.e-chart-title-above-chart:before{content:\"\\E121\"}.e-icons.e-chart-trendline-none:before{content:\"\\E122\"}.e-icons.e-chart-with-legend-keys:before{content:\"\\E123\"}.e-icons.e-chart-axes-primary-horizontal:before{content:\"\\E124\"}.e-icons.e-chart-error-bars-standard-deviation:before{content:\"\\E125\"}.e-icons.e-chart-legend-top:before{content:\"\\E126\"}.e-icons.e-chart-primary-minor-horizontal:before{content:\"\\E145\"}.e-icons.e-chart-error-bars-none:before{content:\"\\E127\"}.e-icons.e-chart-up-down-bars-2:before{content:\"\\E128\"}.e-icons.e-chart-drop-lines:before{content:\"\\E129\"}.e-icons.e-chart-lines-none:before{content:\"\\E130\"}.e-icons.e-chart-primary-major-horizontal:before{content:\"\\E131\"}.e-icons.e-chart-legend-bottom:before{content:\"\\E132\"}.e-icons.e-chart-up-down-none:before{content:\"\\E111\"}.e-icons.e-chart-data-labels-outside-end:before{content:\"\\E905\"}.e-icons.e-chart-axis-titles-primary-vertical:before{content:\"\\E143\"}.e-icons.e-chart-legend-left:before{content:\"\\E892\"}.e-icons.e-chart-data-labels-inside-base:before{content:\"\\E893\"}.e-icons.e-chart-high-low-lines:before{content:\"\\E894\"}.e-icons.e-chart-trendline-exponential:before{content:\"\\E133\"}.e-icons.e-chart-trendline-moving-average:before{content:\"\\E134\"}.e-icons.e-chart-data-labels-inside-end:before{content:\"\\E135\"}.e-icons.e-chart-title-none:before{content:\"\\E136\"}.e-icons.e-chart-title-centered-overlay:before{content:\"\\E895\"}.e-icons.e-chart-error-bars-standard-error:before{content:\"\\E911\"}.e-icons.e-chart-3d-area-1:before{content:\"\\E144\"}.e-icons.e-chart-2d-stacked-bar:before{content:\"\\E889\"}.e-icons.e-chart-3d-surface-1:before{content:\"\\E827\"}.e-icons.e-chart-histogram-pareto:before{content:\"\\E114\"}.e-icons.e-chart-stock-volumn-open-high-low-close:before{content:\"\\E137\"}.e-icons.e-chart-stock-high-low-close:before{content:\"\\E138\"}.e-icons.e-chart-stock-open-high-low-close:before{content:\"\\E831\"}.e-icons.e-chart-2d-line-100-stacked-line-with-markers:before{content:\"\\E832\"}.e-icons.e-chart-filled-radar:before{content:\"\\E833\"}.e-icons.e-chart-3d-clustered-column:before{content:\"\\E142\"}.e-icons.e-chart-sunburst:before{content:\"\\E835\"}.e-icons.e-chart-treemap:before{content:\"\\E836\"}.e-icons.e-chart-3d-100-percent-stacked-area:before{content:\"\\E139\"}.e-icons.e-chart-3d-pie:before{content:\"\\E838\"}.e-icons.e-chart-3d-column-4:before{content:\"\\E839\"}.e-icons.e-more-column-charts:before{content:\"\\E899\"}.e-icons.e-chart-2d-stacked-line:before{content:\"\\E841\"}.e-icons.e-chart-donut:before{content:\"\\E112\"}.e-icons.e-chart-3d-clustered-bar:before{content:\"\\E843\"}.e-icons.e-chart-funnel:before{content:\"\\E140\"}.e-icons.e-chart-2d-pie-2:before{content:\"\\E141\"}.e-icons.e-chart-3d-line:before{content:\"\\E846\"}.e-icons.e-chart-2d-clustered-column:before{content:\"\\E847\"}.e-icons.e-chart-2d-100-percent-stacked-area:before{content:\"\\E900\"}.e-icons.e-more-line-charts:before{content:\"\\E849\"}.e-icons.e-chart-3d-100-percent-stacked-bar:before{content:\"\\E850\"}.e-icons.e-more-stock-charts:before{content:\"\\E851\"}.e-icons.e-chart-stock-volumn-high-low-close:before{content:\"\\E852\"}.e-icons.e-chart-bar-of-pie:before{content:\"\\E113\"}.e-icons.e-chart-clustered-column-line-on-secondary-axis:before{content:\"\\E912\"}.e-icons.e-chart-2d-clustered-bar:before{content:\"\\E855\"}.e-icons.e-chart-radar:before{content:\"\\E856\"}.e-icons.e-chart-3d-100-percent-stacked-column:before{content:\"\\E857\"}.e-icons.e-chart-stackedlines-with-markers:before{content:\"\\E858\"}.e-icons.e-chart-wireframe-3d-surface:before{content:\"\\E902\"}.e-icons.e-chart-2d-line-with-markers:before{content:\"\\E860\"}.e-icons.e-chart-box-and-whisker:before{content:\"\\E861\"}.e-icons.e-create-custom-combo-chart:before{content:\"\\E862\"}.e-icons.e-chart-2d-100-percent-stacked-bar:before{content:\"\\E863\"}.e-icons.e-chart-scatter-with-straight-lines:before{content:\"\\E864\"}.e-icons.e-more-statistical-charts:before{content:\"\\E865\"}.e-icons.e-chart-3d-stacked-area:before{content:\"\\E866\"}.e-icons.e-chart-2d-line:before{content:\"\\E867\"}.e-icons.e-chart-2d-100-percent-stacked-column:before{content:\"\\E868\"}.e-icons.e-more-pie-charts:before{content:\"\\E869\"}.e-icons.e-chart-bubble-1:before{content:\"\\E870\"}.e-icons.e-chart-2d-100-percent-stacked-line:before{content:\"\\E871\"}.e-icons.e-chart-histogram:before{content:\"\\E872\"}.e-icons.e-more-hierarchy-charts:before{content:\"\\E873\"}.e-icons.e-chart-combo-clustered-column-line:before{content:\"\\E874\"}.e-icons.e-chart-2d-stacked-area:before{content:\"\\E875\"}.e-icons.e-chart-3d-stacked-column:before{content:\"\\E876\"}.e-icons.e-chart-insert-bar:before{content:\"\\E877\"}.e-icons.e-chart-scatter-with-smooth-lines:before{content:\"\\E878\"}.e-icons.e-chart-surface-wireframe-contour:before{content:\"\\E879\"}.e-icons.e-chart-3d-stacked-bar:before{content:\"\\E880\"}.e-icons.e-chart-2d-pie-of-pie:before{content:\"\\E881\"}.e-icons.e-chart-3d-surface-2:before{content:\"\\E882\"}.e-icons.e-chart-2d-area:before{content:\"\\E883\"}.e-icons.e-chart-combo-stacked-area-clustered-column:before{content:\"\\E884\"}.e-icons.e-chart-waterfall:before{content:\"\\E885\"}.e-icons.e-chart-surface-contour:before{content:\"\\E886\"}.e-icons.e-more-scatter-charts:before{content:\"\\E887\"}.e-icons.e-chart-2d-stacked-column:before{content:\"\\E888\"}.e-icons.e-protect-workbook:before{content:\"\\E88A\"}.e-icons.e-change-case:before{content:\"\\E88C\"}.e-icons.e-export-pdf-3:before{content:\"\\E88B\"}.e-icons.e-freeze-pane:before{content:\"\\E88D\"}.e-icons.e-freeze-first-column:before{content:\"\\E88E\"}.e-icons.e-freeze-top-row:before{content:\"\\E88F\"}.e-icons.e-merge-cells:before{content:\"\\E89A\"}.e-icons.e-split-vertical:before{content:\"\\E89B\"}.e-icons.e-table-cell:before{content:\"\\E89C\"}.e-icons.e-split-horizontal:before{content:\"\\E89D\"}.e-icons.e-list-box:before{content:\"\\E89E\"}.e-icons.e-text-form-2:before{content:\"\\E89F\"}.e-icons.e-label:before{content:\"\\E90A\"}.e-icons.e-check-box-2:before{content:\"\\E90B\"}.e-icons.e-add-edit-form-field:before{content:\"\\E90C\"}.e-icons.e-button:before{content:\"\\E90D\"}.e-icons.e-drop-down-2:before{content:\"\\E90E\"}.e-icons.e-radio-button:before{content:\"\\E90F\"}.e-icons.e-password:before{content:\"\\E91A\"}.e-icons.e-table-insert-column:before{content:\"\\E91B\"}.e-icons.e-table-insert-row:before{content:\"\\E91C\"}.e-icons.e-table-overwrite-cells:before{content:\"\\E91D\"}.e-icons.e-table-nested:before{content:\"\\E91E\"}.e-icons.e-table-merge:before{content:\"\\E91F\"}.e-icons.e-drag-fill:before{content:\"\\E92A\"}.e-icons.e-home:before{content:\"\\E92B\"}.e-icons.e-gantt-gripper:before{content:\"\\E92C\"}.e-icons.e-bring-to-view:before{content:\"\\E92D\"}.e-icons.e-bring-to-center:before{content:\"\\E92E\"}.e-icons.e-warning:before{content:\"\\E92F\"}\n\n/*! common core */.e-control,.e-css,.e-error{font-family:Roboto,Segoe UI,GeezaPro,DejaVu Serif,\"sans-serif\",-apple-system,BlinkMacSystemFont;font-size:12px;font-weight:400}.e-error{color:#f44336}.e-control,.e-control [class*=\" e-\"],.e-control [class^=e-]{box-sizing:border-box}.e-control:focus,.e-control :focus{outline:none}.e-rtl{direction:rtl;text-align:right}.e-overlay{background-color:#383838;filter:alpha(opacity=50);height:100%;opacity:.5;pointer-events:none;-ms-touch-action:none;touch-action:none;width:100%}.e-hidden{display:none}.e-blazor-hidden{visibility:hidden}.e-disabled{background-image:none;cursor:default;filter:alpha(Opacity=35);opacity:.35}.e-ul{list-style-type:none}.e-prevent-select{-webkit-user-select:none;-ms-user-select:none;user-select:none}.e-warning{color:#ffca1c}.e-success{color:#22b24b}.e-information{color:#489bd5}.e-block-touch{-ms-touch-action:pinch-zoom;touch-action:pinch-zoom}\n\n/*! animation keyframes */@keyframes SlideLeftOut{0%{transform:translate(0)}to{transform:translate(-100%)}}@keyframes SlideLeftIn{0%{transform:translate(-100%)}to{transform:translate(0)}}@keyframes SlideRightIn{0%{transform:translate(100%)}to{transform:translate(0)}}@keyframes SlideRightOut{0%{transform:translate(0)}to{transform:translate(100%)}}@keyframes SlideBottomIn{0%{transform:translateY(100%)}to{transform:translate(0)}}@keyframes SlideBottomOut{0%{transform:translate(0)}to{transform:translateY(100%)}}@keyframes SlideTopIn{0%{transform:translateY(-100%)}to{transform:translate(0)}}@keyframes SlideTopOut{0%{transform:translate(0)}to{transform:translateY(-100%)}}@keyframes SlideRight{0%{width:0}to{width:100%}}@keyframes SlideLeft{0%{width:100%}to{width:0}}@keyframes SlideDown{0%{height:0}to{height:100%}}@keyframes SlideUp{0%{height:100%}to{height:0}}@keyframes FadeIn{0%{filter:alpha(opacity=0);opacity:0}to{filter:alpha(opacity=100);opacity:1}}@keyframes FadeOut{0%{filter:alpha(opacity=100);opacity:1}to{filter:alpha(opacity=0);opacity:0}}@keyframes ZoomIn{0%{transform:translate(0) scale(0)}to{transform:translate(0) scale(1)}}@keyframes ZoomOut{0%{transform:translate(0) scale(1)}to{transform:translate(0) scale(0)}}@keyframes FadeZoomIn{0%{filter:alpha(opacity=0);opacity:0;transform:scale(0)}to{filter:alpha(opacity=100);opacity:1;transform:scale(1)}}@keyframes FadeZoomOut{0%{filter:alpha(opacity=100);opacity:1;transform:scale(1)}to{filter:alpha(opacity=0);opacity:0;transform:scale(0)}}@keyframes FlipRightDownIn{0%{transform:perspective(400px) rotateY(-180deg);transform-origin:right center;transform-style:preserve-3d}to{transform:rotateY(0deg);transform-origin:right center;transform-style:preserve-3d}}@keyframes FlipRightDownOut{0%{transform:perspective(400px) rotateY(0deg);transform-origin:right center;transform-style:preserve-3d}to{transform:rotateY(-180deg);transform-origin:right center;transform-style:preserve-3d}}@keyframes FlipRightUpIn{0%{transform:perspective(400px) rotateY(135deg);transform-origin:right center;transform-style:preserve-3d}to{transform:rotateY(0deg);transform-origin:right center;transform-style:preserve-3d}}@keyframes FlipRightUpOut{0%{transform:perspective(400px) rotateY(0deg);transform-origin:right center;transform-style:preserve-3d}to{transform:rotateY(135deg);transform-origin:right center;transform-style:preserve-3d}}@keyframes FlipLeftDownIn{0%{transform:perspective(400px) rotateY(-180deg);transform-origin:left center;transform-style:preserve-3d}to{transform:rotateY(0deg);transform-origin:left center;transform-style:preserve-3d}}@keyframes FlipLeftDownOut{0%{transform:perspective(400px) rotateY(0deg);transform-origin:left center;transform-style:preserve-3d}to{transform:rotateY(135deg);transform-origin:left center;transform-style:preserve-3d}}@keyframes FlipLeftUpIn{0%{transform:perspective(400px) rotateY(-135deg);transform-origin:left center;transform-style:preserve-3d}to{transform:rotateY(0deg);transform-origin:left center;transform-style:preserve-3d}}@keyframes FlipLeftUpOut{0%{transform:perspective(400px) rotateY(0deg);transform-origin:left center;transform-style:preserve-3d}to{transform:rotateY(135deg) perspective(200px);transform-origin:left center;transform-style:preserve-3d}}@keyframes FlipYLeftIn{0%{filter:alpha(opacity=0);opacity:0;transform:perspective(400px) rotateY(180deg);transform-origin:center center;transform-style:preserve-3d}50%{transform:perspective(700px) rotateY(90deg)}to{filter:alpha(opacity=100);opacity:1;transform:rotateY(0deg);transform-origin:center center;transform-style:preserve-3d}}@keyframes FlipYLeftOut{0%{filter:alpha(opacity=100);opacity:1;transform:perspective(400px) rotateY(0deg);transform-origin:center center;transform-style:preserve-3d}50%{transform:perspective(700px) rotateY(90deg)}75%{transform:perspective(850px) rotateY(125deg)}to{filter:alpha(opacity=0);opacity:0;transform:rotateY(180deg);transform-origin:center center;transform-style:preserve-3d}}@keyframes FlipYRightIn{0%{filter:alpha(opacity=0);opacity:0;transform:perspective(400px) rotateY(-180deg);transform-origin:center center;transform-style:preserve-3d}50%{transform:perspective(700px) rotateY(-90deg)}to{filter:alpha(opacity=100);opacity:1;transform:rotateY(0deg);transform-origin:center center;transform-style:preserve-3d}}@keyframes FlipYRightOut{0%{filter:alpha(opacity=100);opacity:1;transform:perspective(400px) rotateY(0deg);transform-origin:center center;transform-style:preserve-3d}50%{transform:perspective(700px) rotateY(-90deg)}to{filter:alpha(opacity=0);opacity:0;transform:rotateY(-180deg);transform-origin:center center;transform-style:preserve-3d}}@keyframes FlipXDownIn{0%{filter:alpha(opacity=0);opacity:0;transform:perspective(400px) rotateX(180deg);transform-origin:center center;transform-style:preserve-3d}50%{transform:perspective(700px) rotateX(90deg)}to{filter:alpha(opacity=100);opacity:1;transform:rotateX(0deg);transform-origin:center center;transform-style:preserve-3d}}@keyframes FlipXDownOut{0%{filter:alpha(opacity=100);opacity:1;transform:perspective(400px) rotateX(0deg);transform-origin:center center;transform-style:preserve-3d}50%{transform:perspective(700px) rotateX(90deg)}75%{transform:perspective(850px) rotateX(125deg)}to{filter:alpha(opacity=0);opacity:0;transform:rotateX(180deg);transform-origin:center center;transform-style:preserve-3d}}@keyframes FlipXUpIn{0%{filter:alpha(opacity=0);opacity:0;transform:perspective(400px) rotateX(-180deg);transform-origin:center center;transform-style:preserve-3d}50%{transform:perspective(700px) rotateX(-90deg)}to{filter:alpha(opacity=100);opacity:1;transform:rotateX(0deg);transform-origin:center center;transform-style:preserve-3d}}@keyframes FlipXUpOut{0%{filter:alpha(opacity=100);opacity:1;transform:perspective(400px) rotateX(0deg);transform-origin:center center;transform-style:preserve-3d}50%{transform:perspective(700px) rotateX(-90deg)}to{filter:alpha(opacity=0);opacity:0;transform:rotateX(-180deg);transform-origin:center center;transform-style:preserve-3d}}.e-ripple,.e-ripple-style{overflow:hidden;position:relative;transform:translateZ(0)}.e-ripple-element,.e-ripple-style:after{background-color:rgba(0,0,0,.1);border-radius:100%;overflow:hidden;pointer-events:none;position:absolute;transform:scale(0);transition:opacity,transform 0ms cubic-bezier(0,.1,.2,1)}.e-ripple-style:after{background:rgba(0,0,0,.3);content:\"\";display:block;height:50%;left:25%;opacity:0;top:25%;transform:scale(3);transition:transform .5s,opacity .5s;width:50%}.e-ripple-style:active:after{opacity:1;transform:scale(0);transition:0s}", ""]);

// exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,500);", ""]);

// module
exports.push([module.i, ".e-dialog .e-icon-dlg-close:before{content:\"\\E7FC\";position:relative}.e-dialog .e-icon-dlg-close,.e-dialog .e-icon-dlg-close:active,.e-dialog .e-icon-dlg-close:hover{opacity:1}.e-dialog .e-north-east:before,.e-dialog .e-north-west:before,.e-dialog .e-south-east:before,.e-dialog .e-south-west:before{content:\"\\EB05\"}\n\n/*! dialog layout */.e-dialog{border:none;border-radius:2px;-ms-flex-direction:column;flex-direction:column}.e-dialog,.e-dialog.e-popup{width:100%}.e-dialog.e-dlg-resizable{padding-bottom:15px;-ms-touch-action:none;touch-action:none}.e-dialog .e-dlg-header-content{border-radius:1px 1px 0 0;line-height:30px}.e-dialog .e-dlg-header-content+.e-dlg-content{padding-top:0}.e-dialog .e-btn .e-btn-icon.e-icon-dlg-close{font-size:12px;width:auto}.e-dialog .e-dlg-header{display:block;font-size:18px;font-weight:400;overflow:hidden;text-overflow:ellipsis;-webkit-user-select:none;-ms-user-select:none;user-select:none;vertical-align:top;white-space:nowrap;width:80%}.e-dialog .e-dlg-header.e-hide{display:none}.e-dialog .e-dlg-modal{position:fixed}.e-dialog .e-scroll-disabled{overflow:hidden!important}.e-dialog .e-dlg-content{display:block;-ms-flex:1 1 auto;flex:1 1 auto;font-size:13px;font-weight:400;line-height:normal;overflow:auto;overflow-x:hidden}.e-dialog .e-dlg-content.e-hide{display:none}.e-dialog .e-footer-content{border-bottom-left-radius:0;border-bottom-right-radius:0;border-top:none;bottom:0;display:block;right:0;width:100%}.e-dialog .e-footer-content.e-hide{display:none}.e-dialog .e-footer-content{text-align:right}.e-dialog .e-resize-handle{height:15px;position:absolute;width:15px}.e-dialog .e-resize-handle.e-south-east{bottom:0;cursor:nwse-resize;right:0}.e-dialog .e-resize-handle.e-south-west{bottom:0;cursor:nesw-resize;left:0;transform:rotate(90deg)}.e-dialog .e-resize-handle.e-north-east{cursor:nesw-resize;right:0;top:0;transform:rotate(-90deg)}.e-dialog .e-resize-handle.e-north-west{cursor:nwse-resize;left:0;top:0;transform:rotate(180deg)}.e-dialog .e-east,.e-dialog .e-north,.e-dialog .e-south,.e-dialog .e-west{background-color:transparent;background-repeat:repeat;overflow:visible;position:absolute}.e-dialog .e-east,.e-dialog .e-west{cursor:ew-resize}.e-dialog .e-north,.e-dialog .e-south{cursor:ns-resize}.e-dialog.e-blazor-hidden{left:0;position:absolute}.e-bigger.e-dialog .e-dlg-header-content,.e-bigger .e-dialog .e-dlg-header-content{padding:24px 24px 20px}.e-bigger.e-dialog .e-dlg-header,.e-bigger .e-dialog .e-dlg-header{font-size:18px}.e-bigger.e-dialog .e-dlg-content,.e-bigger .e-dialog .e-dlg-content{font-size:13px;padding:24px}.e-bigger.e-dialog .e-footer-content,.e-bigger .e-dialog .e-footer-content{padding:8px}.e-bigger.e-dialog .e-footer-content .e-btn,.e-bigger .e-dialog .e-footer-content .e-btn{margin-left:8px}.e-bigger.e-dialog .e-dlg-header-content .e-btn.e-dlg-closeicon-btn,.e-bigger .e-dialog .e-dlg-header-content .e-btn.e-dlg-closeicon-btn{bottom:3px;height:36px;left:6px;width:36px}.e-bigger.e-dialog .e-btn .e-btn-icon.e-icon-dlg-close,.e-bigger .e-dialog .e-btn .e-btn-icon.e-icon-dlg-close{font-size:12px;width:auto}.e-bigger.e-rtl .e-footer-content .e-btn,.e-bigger .e-rtl .e-footer-content .e-btn{margin-left:0;margin-right:8px}.e-bigger .e-dlg-header-content+.e-dlg-content{padding-top:0}.e-dialog .e-dlg-header-content{border-bottom:none;padding:18px}.e-dialog .e-dlg-content{padding:18px}.e-dialog .e-footer-content{padding:8px}.e-dialog .e-footer-content .e-btn{margin-left:6px}.e-rtl .e-footer-content .e-btn{margin-right:6px}.e-dialog.e-draggable>.e-dlg-header-content{cursor:move}.e-dialog{max-height:98%;max-width:100%;min-width:240px;position:absolute}.e-rtl .e-footer-content .e-btn{margin-left:0}.e-rtl .e-footer-content{text-align:left}.e-dialog.e-rtl .e-dlg-header-content .e-btn.e-dlg-closeicon-btn{float:left;left:0;right:6px}.e-dialog .e-dlg-header-content .e-btn.e-dlg-closeicon-btn{background-color:transparent;border-color:transparent;border-radius:50%;bottom:0;float:right;height:30px;left:6px;position:relative;width:30px}.e-rtl.e-dialog .e-resize-handle.e-south-west{bottom:0;cursor:sw-resize;direction:ltr;left:0;text-align:initial;transform:rotate(90deg)}.e-dlg-target.e-scroll-disabled{overflow:hidden!important}.e-dlg-overlay{height:100%;left:0;opacity:.5;position:fixed;top:0;transition:opacity .15s linear;width:100%}.e-dlg-overlay.e-fade{opacity:0}.e-dlg-overflow-hidden{overflow:auto}.e-dlg-fullscreen{height:100%!important;left:0!important;top:0!important;width:100%!important}.e-popup.e-popup-open.e-dialog{display:-ms-inline-flexbox;display:inline-flex}.e-dlg-container{-ms-flex-align:start;align-items:flex-start;display:none;height:100%;left:0;position:fixed;top:0;width:100%}.e-dlg-center-center{-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}.e-dlg-center-center,.e-dlg-left-center{-webkit-align-items:center;-ms-flex-align:center;align-items:center}.e-dlg-left-center{-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start}.e-dlg-right-center{-webkit-align-items:center;-webkit-justify-content:flex-end;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end}.e-dlg-left-top{-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start}.e-dlg-left-top,.e-dlg-right-top{-webkit-align-items:flex-start;-ms-flex-align:start;align-items:flex-start}.e-dlg-right-top{-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end}.e-dlg-center-top{-webkit-align-items:center;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;flex-direction:column}.e-dlg-left-bottom{-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start}.e-dlg-left-bottom,.e-dlg-right-bottom{-webkit-align-items:flex-end;-ms-flex-align:end;align-items:flex-end}.e-dlg-center-bottom,.e-dlg-right-bottom{-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end}.e-dlg-center-bottom{-webkit-align-items:center;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;flex-direction:column}.e-dialog .e-btn.e-dlg-closeicon-btn:active,.e-dialog .e-btn.e-dlg-closeicon-btn:focus,.e-dialog .e-btn.e-dlg-closeicon-btn:hover{background-color:#e0e0e0;border-color:transparent;box-shadow:0 0 0 transparent}.e-dialog .e-btn.e-dlg-closeicon-btn:active{background-color:#e0e0e0}.e-content-placeholder.e-dialog.e-placeholder-dialog{background-size:400px 210px;min-height:210px}.e-bigger.e-content-placeholder.e-dialog.e-placeholder-dialog,.e-bigger .e-content-placeholder.e-dialog.e-placeholder-dialog{background-size:400px 220px;min-height:220px}@media (min-width:768px){.e-alert-dialog.e-dialog.e-popup,.e-confirm-dialog.e-dialog.e-popup{margin:30px auto;width:600px}}@media (max-width:768px){.e-alert-dialog.e-dialog.e-popup,.e-confirm-dialog.e-dialog.e-popup{margin:30px auto;width:auto}}.e-dlg-ref-element{display:none}.e-dialog .e-footer-content{box-sizing:border-box}.e-dialog{background-color:#fff;box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12)}.e-dlg-overlay{background-color:#383838}.e-footer-content{background-color:#fff}.e-dlg-header,.e-dlg-header *{color:rgba(0,0,0,.87);font-size:18px;font-weight:400}.e-dlg-content{color:rgba(0,0,0,.87)}.e-device .e-dlg-content,.e-device .e-dlg-content *{font-size:14px}.e-dlg-content,.e-dlg-header-content{background-color:#fff}.e-dialog .e-btn.e-dlg-closeicon-btn:hover span,.e-icon-dlg-close{color:#000}.e-dialog .e-btn.e-dlg-closeicon-btn:active span,.e-dialog .e-btn.e-dlg-closeicon-btn:focus span,.e-icon-dlg-close:active{border-radius:50%;color:#000;opacity:1}.e-icon-dlg-close:hover{color:#000}.e-dlg-header-content .e-dlg-closeicon-btn:active,.e-dlg-header-content .e-dlg-closeicon-btn:hover{background-color:transparent}.e-south-east{color:#000}.e-rtl .e-south-east{color:transparent}.e-rtl .e-south-west{color:#000}.e-north-east,.e-north-west,.e-south-west{color:transparent}\n\n/*! popup layout */.e-popup{height:auto;position:absolute;width:auto;z-index:1000}.e-popup.e-popup-open{display:block}.e-popup.e-popup-close{display:none}.e-tooltip-close:before{content:\"\\E7E9\";font-size:16px}.e-arrow-tip-inner.e-tip-right:before{content:\"\\E848\"}.e-arrow-tip-inner.e-tip-top:before{content:\"\\E918\"}.e-arrow-tip-inner.e-tip-bottom:before{content:\"\\E919\"}.e-arrow-tip-inner.e-tip-left:before{content:\"\\E84B\"}\n\n/*! tooltip popup container layout */.e-tooltip-popup-container{position:relative}\n\n/*! tooltip layout */.e-tooltip-wrap{max-width:350px;min-width:30px;padding:0;position:absolute;visibility:visible\n  /*! tooltip arrow */\n  /*! tooltip sticky mode close icon */\n  /*! tooltip content area */}.e-tooltip-wrap .e-arrow-tip{overflow:hidden;position:absolute}.e-tooltip-wrap .e-arrow-tip.e-tip-bottom{height:8px;left:50%;top:100%;width:16px}.e-tooltip-wrap .e-arrow-tip.e-tip-top{height:8px;left:50%;top:-9px;width:16px}.e-tooltip-wrap .e-arrow-tip.e-tip-left{height:16px;left:-9px;top:48%;width:8px}.e-tooltip-wrap .e-arrow-tip.e-tip-right{height:16px;left:100%;top:50%;width:8px}.e-tooltip-wrap .e-tooltip-close{cursor:pointer;float:right;position:absolute;right:-9px;top:-9px;z-index:inherit}.e-tooltip-wrap .e-tip-content{background-color:inherit;height:100%;line-height:16px;overflow-wrap:break-word;overflow-x:hidden;padding:3px 6px;position:relative;white-space:normal;width:100%;word-break:break-word;z-index:1}\n\n/*! Bigger Style */.e-bigger .e-tooltip-wrap .e-tip-content,.e-tooltip-wrap.e-bigger .e-tip-content{line-height:20px;padding:5px 8px}\n\n/*! Tooltip theme */.e-tooltip-wrap{border-radius:2px;filter:none;opacity:.9\n  /*! tooltip arrow */\n  /*! tooltip sticky mode close icon */\n  /*! tooltip content area */}.e-tooltip-wrap.e-popup{background-color:#616161;border:1px solid #616161}.e-tooltip-wrap .e-arrow-tip-outer{height:0;left:0;position:absolute;top:0;width:0}.e-tooltip-wrap .e-arrow-tip-outer.e-tip-bottom{border-left:8px solid transparent;border-right:8px solid transparent;border-top:8px solid #616161}.e-tooltip-wrap .e-arrow-tip-outer.e-tip-top{border-bottom:8px solid #616161;border-left:8px solid transparent;border-right:8px solid transparent}.e-tooltip-wrap .e-arrow-tip-outer.e-tip-left{border-bottom:8px solid transparent;border-right:8px solid #616161;border-top:8px solid transparent}.e-tooltip-wrap .e-arrow-tip-outer.e-tip-right{border-bottom:8px solid transparent;border-left:8px solid #616161;border-top:8px solid transparent}.e-tooltip-wrap .e-arrow-tip-inner{height:0;position:absolute;width:0;z-index:10}.e-tooltip-wrap .e-arrow-tip-inner.e-tip-bottom,.e-tooltip-wrap .e-arrow-tip-inner.e-tip-left,.e-tooltip-wrap .e-arrow-tip-inner.e-tip-right,.e-tooltip-wrap .e-arrow-tip-inner.e-tip-top{color:#616161;font-family:e-icons;font-size:16px;font-style:normal;font-variant:normal;font-weight:400;line-height:1;text-transform:none}.e-tooltip-wrap .e-arrow-tip-inner.e-tip-bottom,.e-tooltip-wrap .e-arrow-tip-inner.e-tip-top{right:16px}.e-tooltip-wrap .e-arrow-tip-inner.e-tip-left,.e-tooltip-wrap .e-arrow-tip-inner.e-tip-right{bottom:16px}.e-tooltip-wrap .e-tooltip-close{border-color:transparent;border-radius:8px}.e-tooltip-wrap .e-tooltip-close,.e-tooltip-wrap .e-tooltip-close:hover{background-color:#fff;color:#616161}.e-tooltip-wrap .e-tip-content{color:#fff;font-family:Roboto,Segoe UI,GeezaPro,DejaVu Serif,\"sans-serif\",-apple-system,BlinkMacSystemFont;font-size:11px}\n\n/*! bigger style */.e-bigger .e-tooltip-wrap .e-tip-content,.e-tooltip-wrap.e-bigger .e-tip-content{font-size:14px}@keyframes material-spinner-rotate{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes fabric-spinner-rotate{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.e-spinner-pane{-ms-flex-align:center;align-items:center;display:-ms-inline-flexbox;display:inline-flex;height:100%;-ms-flex-pack:center;justify-content:center;left:0;position:absolute;text-align:center;top:0;-webkit-user-select:none;-ms-user-select:none;user-select:none;vertical-align:middle;width:100%;z-index:1000}.e-spinner-pane:after{content:\"Material\";display:none}.e-spinner-pane.e-spin-left .e-spinner-inner{-webkit-transform:translateX(0) translateY(-50%);left:0;padding-left:10px;transform:translateX(0) translateY(-50%)}.e-spinner-pane.e-spin-right .e-spinner-inner{-webkit-transform:translateX(-100%) translateY(-50%);left:100%;padding-right:10px;transform:translateX(-100%) translateY(-50%)}.e-spinner-pane.e-spin-center .e-spinner-inner{-webkit-transform:translateX(-50%) translateY(-50%);left:50%;transform:translateX(-50%) translateY(-50%)}.e-spinner-pane.e-spin-hide{display:none}.e-spinner-pane.e-spin-show{display:-ms-inline-flexbox;display:inline-flex}.e-spinner-pane .e-spinner-inner{-webkit-transform:translateX(-50%) translateY(-50%);left:50%;margin:0;position:absolute;text-align:center;top:50%;transform:translateX(-50%) translateY(-50%);z-index:1000}.e-spinner-pane .e-spinner-inner .e-spin-label{font-family:Roboto,Segoe UI;font-size:13px;margin-top:16px;text-align:center}.e-spinner-pane .e-spinner-inner .e-spin-material{animation:material-spinner-rotate 1568.63ms linear infinite;display:block;margin:0 auto}.e-spinner-pane .e-spinner-inner .e-spin-material .e-path-circle{fill:none;stroke-linecap:square}.e-spinner-pane .e-spinner-inner .e-spin-bootstrap4{animation:material-spinner-rotate .75s linear infinite;border-radius:50%;display:block;margin:0 auto}.e-spinner-pane .e-spinner-inner .e-spin-bootstrap4 .e-path-circle{fill:none;stroke-linecap:square;stroke-width:4}.e-spinner-pane .e-spinner-inner .e-spin-fabric,.e-spinner-pane .e-spinner-inner .e-spin-fluent{animation:fabric-spinner-rotate 1.3s infinite cubic-bezier(.53,.21,.29,.67);display:block;margin:0 auto;overflow:visible}.e-spinner-pane .e-spinner-inner .e-spin-fabric .e-path-arc,.e-spinner-pane .e-spinner-inner .e-spin-fabric .e-path-circle,.e-spinner-pane .e-spinner-inner .e-spin-fluent .e-path-arc,.e-spinner-pane .e-spinner-inner .e-spin-fluent .e-path-circle{fill:none;stroke-width:1.5}.e-spinner-pane .e-spinner-inner .e-spin-tailwind{animation:fabric-spinner-rotate 1.3s infinite cubic-bezier(.21,.21,.21,.21);display:block;margin:0 auto;overflow:visible}.e-spinner-pane .e-spinner-inner .e-spin-tailwind .e-path-arc,.e-spinner-pane .e-spinner-inner .e-spin-tailwind .e-path-circle{fill:none;stroke-width:4.5}.e-spinner-pane .e-spinner-inner .e-spin-bootstrap5{animation:material-spinner-rotate .75s linear infinite;border-radius:50%;display:block;margin:0 auto}.e-spinner-pane .e-spinner-inner .e-spin-bootstrap5 .e-path-circle{fill:none;stroke-linecap:square;stroke-width:4}.e-spinner-pane .e-spinner-inner .e-spin-bootstrap{display:block;margin:0 auto}.e-spinner-pane .e-spinner-inner .e-spin-high-contrast{animation:fabric-spinner-rotate 1.3s infinite cubic-bezier(.53,.21,.29,.67);display:block;margin:0 auto;overflow:visible}.e-spinner-pane .e-spinner-inner .e-spin-high-contrast .e-path-arc,.e-spinner-pane .e-spinner-inner .e-spin-high-contrast .e-path-circle{fill:none;stroke-width:1.5}.e-spinner-pane{background-color:transparent}.e-spinner-pane.e-spin-overlay{background-color:rgba(0,0,0,.4)}.e-spinner-pane.e-spin-overlay .e-spinner-inner .e-spin-label{color:#fff}.e-spinner-pane.e-spin-overlay .e-spinner-inner .e-spin-bootstrap{fill:#e3165b;stroke:#e3165b}.e-spinner-pane .e-spinner-inner .e-spin-label{color:rgba(0,0,0,.87)}.e-spinner-pane .e-spinner-inner .e-spin-fabric .e-path-circle,.e-spinner-pane .e-spinner-inner .e-spin-fluent .e-path-circle{stroke:rgba(227,22,91,.4)}.e-spinner-pane .e-spinner-inner .e-spin-fabric .e-path-arc,.e-spinner-pane .e-spinner-inner .e-spin-fluent .e-path-arc{stroke:#e3165b}.e-spinner-pane .e-spinner-inner .e-spin-tailwind .e-path-circle{stroke:rgba(227,22,91,.4)}.e-spinner-pane .e-spinner-inner .e-spin-bootstrap5,.e-spinner-pane .e-spinner-inner .e-spin-tailwind .e-path-arc{stroke:#e3165b}.e-spinner-pane .e-spinner-inner .e-spin-high-contrast .e-path-circle{stroke:rgba(227,22,91,.4)}.e-spinner-pane .e-spinner-inner .e-spin-bootstrap4,.e-spinner-pane .e-spinner-inner .e-spin-high-contrast .e-path-arc,.e-spinner-pane .e-spinner-inner .e-spin-material{stroke:#e3165b}.e-spinner-pane .e-spinner-inner .e-spin-bootstrap{fill:#e3165b;stroke:#e3165b}", ""]);

// exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,500);", ""]);

// module
exports.push([module.i, "/*! component's theme wise override definitions and variables */\n/*! hscroll icons */.e-hscroll.e-rtl.e-scroll-device .e-nav-right-arrow:before{content:\"\\E904\"}.e-hscroll.e-rtl .e-nav-left-arrow:before,.e-hscroll.e-rtl.e-scroll-device .e-nav-left-arrow:before{content:\"\\E913\"}.e-hscroll.e-rtl .e-nav-right-arrow:before{content:\"\\E904\"}.e-hscroll.e-scroll-device .e-nav-right-arrow:before{content:\"\\E913\"}.e-hscroll.e-scroll-device .e-nav-left-arrow:before{content:\"\\E904\"}.e-hscroll .e-nav-left-arrow:before{content:\"\\E904\";line-height:normal}.e-hscroll .e-nav-right-arrow:before{content:\"\\E913\";line-height:normal}\n\n/*! h-scroll layout */.e-bigger .e-hscroll,.e-hscroll.e-bigger{min-height:56px}.e-bigger .e-hscroll:not(.e-scroll-device),.e-hscroll.e-bigger:not(.e-scroll-device){padding:0 50px}.e-bigger .e-hscroll.e-scroll-device,.e-hscroll.e-bigger.e-scroll-device{padding-right:50px}.e-bigger .e-hscroll.e-rtl.e-scroll-device,.e-hscroll.e-bigger.e-rtl.e-scroll-device{padding-left:50px;padding-right:0}.e-bigger .e-hscroll .e-nav-arrow.e-icons,.e-hscroll.e-bigger .e-nav-arrow.e-icons{font-size:14px}.e-bigger .e-hscroll.e-rtl .e-scroll-overlay.e-scroll-right-overlay,.e-hscroll.e-bigger.e-rtl .e-scroll-overlay.e-scroll-right-overlay{left:50px}.e-bigger .e-hscroll .e-scroll-overlay.e-scroll-right-overlay,.e-hscroll.e-bigger .e-scroll-overlay.e-scroll-right-overlay{right:50px}.e-bigger .e-hscroll .e-scroll-nav,.e-hscroll.e-bigger .e-scroll-nav{min-height:56px;width:50px}.e-hscroll{display:block;position:relative;width:inherit}.e-hscroll.e-rtl.e-scroll-device{padding-left:50px;padding-right:0}.e-hscroll.e-rtl.e-scroll-device .e-scroll-nav{transform:skewX(-16deg) translateX(-6px)}.e-hscroll.e-rtl.e-scroll-device .e-scroll-overlay.e-scroll-right-overlay{left:56px;right:auto;transform:skewX(-16deg) translateX(-6px)}.e-hscroll.e-rtl.e-scroll-device .e-scroll-overlay.e-scroll-left-overlay{left:auto;right:0}.e-hscroll:not(.e-scroll-device){padding:0 40px}.e-hscroll.e-scroll-device{padding-right:50px}.e-hscroll.e-scroll-device .e-scroll-nav{transform:skewX(-16deg) translateX(6px);width:56px}.e-hscroll.e-scroll-device .e-scroll-nav .e-nav-arrow{font-size:14px;transform:skewX(16deg)}.e-hscroll.e-scroll-device .e-scroll-overlay{opacity:.5;pointer-events:none;position:absolute;top:0;z-index:100}.e-hscroll.e-scroll-device .e-scroll-overlay.e-scroll-right-overlay{left:auto;right:56px;transform:skewX(-16deg) translateX(6px)}.e-hscroll.e-scroll-device .e-scroll-overlay.e-scroll-left-overlay{left:0;right:auto}.e-hscroll.e-overlay .e-hscroll-content>*{pointer-events:none}.e-hscroll>*{height:inherit}.e-hscroll .e-hscroll-content{display:inline-block;height:inherit;position:relative;-ms-touch-action:none;touch-action:none}.e-hscroll .e-hscroll-content>*{pointer-events:auto}.e-hscroll.e-rtl .e-scroll-nav.e-scroll-right-nav{left:0;right:auto}.e-hscroll.e-rtl .e-scroll-nav.e-scroll-left-nav{left:auto;right:0}.e-hscroll .e-scroll-nav{-ms-flex-align:center;align-items:center;bottom:0;cursor:pointer;display:-ms-flexbox;display:flex;min-height:42px;overflow:hidden;position:absolute;top:0;width:40px}.e-hscroll .e-scroll-nav.e-scroll-left-nav{left:0}.e-hscroll .e-scroll-nav.e-scroll-right-nav{right:0}.e-hscroll .e-scroll-nav.e-ie-align{display:table}.e-hscroll .e-nav-arrow{position:relative}.e-hscroll .e-nav-arrow.e-icons{display:table-cell;text-align:center;vertical-align:middle;width:100%}.e-hscroll .e-hscroll-bar .e-hscroll-content .e-overlay{pointer-events:none}\n\n/*! h-scroll theme */.e-hscroll .e-scroll-nav .e-icons{color:rgba(0,0,0,.54)}.e-hscroll.e-rtl.e-scroll-device .e-scroll-nav.e-scroll-right-nav{border-color:rgba(0,0,0,.12);box-shadow:4px 0 8px 0 rgba(0,0,0,.06)}.e-hscroll.e-scroll-device .e-scroll-nav.e-scroll-right-nav{background-color:#fafafa;border-color:rgba(0,0,0,.12);border-width:1px;box-shadow:-4px 0 8px 0 rgba(0,0,0,.06)}.e-hscroll.e-scroll-device .e-scroll-nav.e-scroll-right-nav .e-nav-arrow{color:#e3165b}.e-hscroll .e-scroll-overlay{background-color:transparent;background-repeat:repeat-x}.e-hscroll .e-scroll-overlay.e-scroll-left-overlay{background-image:linear-gradient(-270deg,#fafafa,hsla(0,0%,98%,0))}.e-hscroll .e-scroll-overlay.e-scroll-right-overlay{background-image:linear-gradient(-270deg,hsla(0,0%,98%,0),#fafafa)}.e-hscroll.e-rtl .e-scroll-nav{background:#fafafa}.e-hscroll.e-rtl .e-scroll-nav.e-scroll-left-nav{border-left:1px solid rgba(0,0,0,.12);border-right:0}.e-hscroll.e-rtl .e-scroll-nav.e-scroll-right-nav{border-left:0;border-right:1px solid rgba(0,0,0,.12)}.e-hscroll.e-rtl .e-scroll-nav:hover{background:rgba(0,0,0,.12);border:0;color:#000;border-color:rgba(0,0,0,.12)}.e-hscroll:not(.e-scroll-device) .e-scroll-nav:hover{background:rgba(0,0,0,.12);border:0;color:#000}.e-hscroll:not(.e-scroll-device) .e-scroll-nav:focus{background:rgba(0,0,0,.12);border:0;color:#000;border-color:rgba(0,0,0,.12)}.e-hscroll:not(.e-scroll-device) .e-scroll-nav:active{background:#bdbdbd;border:0;box-shadow:none;color:#000}.e-hscroll .e-scroll-nav{background:#fafafa}.e-hscroll .e-scroll-nav.e-scroll-left-nav{border-right:1px solid rgba(0,0,0,.12)}.e-hscroll .e-scroll-nav.e-scroll-right-nav{border-left:1px solid rgba(0,0,0,.12)}.e-hscroll .e-scroll-nav:after{background-color:transparent;border-radius:50%;border-width:1px;box-sizing:border-box;content:\"\";height:1px;left:50%;position:absolute;top:50%;visibility:hidden;width:1px}.e-hscroll .e-scroll-nav:active:after{animation:hscroll-popup-shadow .6s ease-out 0ms;visibility:visible}\n\n/*! component's theme wise override definitions and variables */\n/*! vscroll icons */.e-vscroll.e-scroll-device .e-nav-up-arrow:before{content:\"\\E85E\"}.e-vscroll.e-scroll-device .e-nav-down-arrow:before{content:\"\\E84F\"}.e-vscroll .e-nav-up-arrow:before{content:\"\\E910\";line-height:normal}.e-vscroll .e-nav-down-arrow:before{content:\"\\E916\";line-height:normal}\n\n/*! v-scroll layout */.e-bigger .e-vscroll:not(.e-scroll-device),.e-vscroll.e-bigger:not(.e-scroll-device){padding:24px 0}.e-bigger .e-vscroll .e-icons,.e-vscroll.e-bigger .e-icons{font-size:18px}.e-bigger .e-vscroll.e-rtl .e-scroll-overlay.e-scroll-down-overlay,.e-vscroll.e-bigger.e-rtl .e-scroll-overlay.e-scroll-down-overlay{left:24px}.e-bigger .e-vscroll .e-scroll-overlay.e-scroll-down-overlay,.e-vscroll.e-bigger .e-scroll-overlay.e-scroll-down-overlay{right:24px}.e-bigger .e-vscroll .e-scroll-nav,.e-vscroll.e-bigger .e-scroll-nav{height:24px}.e-vscroll{display:block;position:relative;width:inherit}.e-vscroll.e-rtl.e-scroll-device .e-scroll-nav{transform:skewX(-16deg) translateX(-6px)}.e-vscroll.e-rtl.e-scroll-device .e-scroll-overlay.e-scroll-down-overlay{left:56px;right:auto;transform:skewX(-16deg) translateX(-6px)}.e-vscroll.e-rtl.e-scroll-device .e-scroll-overlay.e-scroll-up-overlay{left:auto;right:0}.e-vscroll:not(.e-scroll-device){padding:0 16px}.e-vscroll.e-scroll-device .e-scroll-nav{transform:skewX(-16deg) translateX(6px);width:56px;z-index:1001}.e-vscroll.e-scroll-device .e-scroll-nav .e-nav-arrow{font-size:14px;transform:skewX(16deg)}.e-vscroll.e-scroll-device .e-scroll-overlay{opacity:.5;pointer-events:none;position:absolute;top:0;z-index:100}.e-vscroll.e-scroll-device .e-scroll-overlay.e-scroll-down-overlay{left:auto;right:56px;transform:skewX(-16deg) translateX(6px)}.e-vscroll.e-scroll-device .e-scroll-overlay.e-scroll-up-overlay{left:0;right:auto}.e-vscroll>*{height:inherit}.e-vscroll .e-vscroll-content{display:inline-block;height:auto;position:relative;-ms-touch-action:none;touch-action:none;width:100%}.e-vscroll .e-vscroll-content>*{pointer-events:auto}.e-vscroll.e-rtl .e-scroll-nav.e-scroll-up-nav{left:auto;right:0}.e-vscroll.e-rtl .e-scroll-nav.e-scroll-down-nav{left:0;right:auto}.e-vscroll .e-scroll-nav{-ms-flex-align:center;align-items:center;cursor:pointer;display:-ms-flexbox;display:flex;height:40px;overflow:hidden;position:absolute;width:100%}.e-vscroll .e-scroll-nav.e-scroll-up-nav{top:0}.e-vscroll .e-scroll-nav.e-scroll-down-nav{bottom:0}.e-vscroll .e-scroll-nav.e-ie-align{display:table}.e-vscroll .e-nav-arrow{position:relative}.e-vscroll .e-nav-arrow.e-icons{display:table-cell;text-align:center;vertical-align:middle;width:100%}\n\n/*! v-scroll theme */.e-vscroll .e-icons{color:rgba(0,0,0,.54)}.e-vscroll.e-rtl.e-scroll-device .e-scroll-nav.e-scroll-right-nav{border-color:rgba(0,0,0,.12);box-shadow:4px 0 8px 0 rgba(0,0,0,.06)}.e-vscroll.e-scroll-device .e-scroll-nav.e-scroll-right-nav{background-color:#fafafa;border-color:rgba(0,0,0,.12);border-width:1px;box-shadow:-4px 0 8px 0 rgba(0,0,0,.06)}.e-vscroll.e-scroll-device .e-scroll-nav.e-scroll-right-nav .e-nav-arrow{color:#e3165b}.e-vscroll .e-scroll-overlay{background-color:transparent;background-repeat:repeat-x}.e-vscroll .e-scroll-overlay.e-scroll-up-overlay{background-image:linear-gradient(-270deg,#fafafa,hsla(0,0%,98%,0))}.e-vscroll .e-scroll-overlay.e-scroll-down-overlay{background-image:linear-gradient(-270deg,hsla(0,0%,98%,0),#fafafa)}.e-vscroll.e-rtl .e-scroll-nav{background:#fafafa}.e-vscroll.e-rtl .e-scroll-nav:hover{background:rgba(0,0,0,.12);border:0;border-color:rgba(0,0,0,.12);color:#000}.e-vscroll:not(.e-scroll-device) .e-scroll-nav:hover{background:rgba(0,0,0,.12);border:0;color:#000}.e-vscroll:not(.e-scroll-device) .e-scroll-nav:focus{background:rgba(0,0,0,.12);border:0;border-color:rgba(0,0,0,.12);color:#000}.e-vscroll:not(.e-scroll-device) .e-scroll-nav:active{background:#bdbdbd;border:0;box-shadow:none;color:#000}.e-vscroll .e-scroll-nav{background:#fafafa}.e-vscroll .e-scroll-nav.e-scroll-up-nav{border-bottom:1px solid rgba(0,0,0,.12)}.e-vscroll .e-scroll-nav.e-scroll-down-nav{border-top:1px solid rgba(0,0,0,.12)}.e-vscroll .e-scroll-nav:after{background-color:transparent;border-radius:50%;border-width:1px;box-sizing:border-box;content:\"\";height:1px;left:50%;position:absolute;top:50%;visibility:hidden;width:1px}.e-vscroll .e-scroll-nav:active:after{animation:vscroll-popup-shadow .6s ease-out 0ms;visibility:visible}\n\n/*! component's theme wise override definitions and variables */\n/*! component's theme wise override definitions and variables */\n/*! component's theme wise override definitions and variables */\n/*! toolbar icons */.e-toolbar .e-popup-down-icon:before{content:\"\\E916\";line-height:normal}.e-toolbar .e-popup-up-icon:before{content:\"\\E910\";line-height:normal}\n\n/*! toolbar layout */.e-bigger .e-toolbar,.e-toolbar.e-bigger{height:56px;min-height:56px}.e-bigger .e-toolbar .e-tbar-btn .e-icons,.e-toolbar.e-bigger .e-tbar-btn .e-icons{font-size:14px}.e-bigger .e-toolbar.e-extended-toolbar.e-tbar-extended,.e-toolbar.e-bigger.e-extended-toolbar.e-tbar-extended{border-bottom:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.e-bigger .e-toolbar.e-extended-toolbar.e-tbar-extended .e-toolbar-extended,.e-toolbar.e-bigger.e-extended-toolbar.e-tbar-extended .e-toolbar-extended{border-top:0;border-top-left-radius:0;border-top-right-radius:0}.e-bigger .e-toolbar.e-toolpop.e-rtl .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-center .e-toolbar-item,.e-toolbar.e-bigger.e-toolpop.e-rtl .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-center .e-toolbar-item{margin:0}.e-bigger .e-toolbar.e-toolpop.e-rtl .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-right .e-toolbar-item:last-child,.e-toolbar.e-bigger.e-toolpop.e-rtl .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-right .e-toolbar-item:last-child{margin:0;margin-left:3px}.e-bigger .e-toolbar.e-toolpop.e-rtl .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-right .e-toolbar-item,.e-toolbar.e-bigger.e-toolpop.e-rtl .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-right .e-toolbar-item{margin:0}.e-bigger .e-toolbar.e-rtl .e-toolbar-items .e-hscroll-bar .e-hscroll-content>.e-toolbar-item:last-child,.e-toolbar.e-bigger.e-rtl .e-toolbar-items .e-hscroll-bar .e-hscroll-content>.e-toolbar-item:last-child{margin-left:3px;margin-right:0}.e-bigger .e-toolbar.e-rtl .e-toolbar-items .e-hscroll-bar .e-hscroll-content .e-toolbar-center .e-toolbar-item,.e-toolbar.e-bigger.e-rtl .e-toolbar-items .e-hscroll-bar .e-hscroll-content .e-toolbar-center .e-toolbar-item{margin:0}.e-bigger .e-toolbar.e-rtl .e-toolbar-items .e-hscroll-bar .e-hscroll-content .e-toolbar-right .e-toolbar-item:last-child,.e-toolbar.e-bigger.e-rtl .e-toolbar-items .e-hscroll-bar .e-hscroll-content .e-toolbar-right .e-toolbar-item:last-child{margin-left:3px;margin-right:0}.e-bigger .e-toolbar.e-rtl .e-toolbar-items .e-hscroll-bar .e-hscroll-content .e-toolbar-right .e-toolbar-item,.e-toolbar.e-bigger.e-rtl .e-toolbar-items .e-hscroll-bar .e-hscroll-content .e-toolbar-right .e-toolbar-item{margin:0}.e-bigger .e-toolbar.e-rtl .e-toolbar-items .e-toolbar-left .e-toolbar-item:first-child,.e-toolbar.e-bigger.e-rtl .e-toolbar-items .e-toolbar-left .e-toolbar-item:first-child{margin-left:0}.e-bigger .e-toolbar.e-rtl .e-toolbar-items .e-toolbar-left .e-toolbar-item:last-child,.e-toolbar.e-bigger.e-rtl .e-toolbar-items .e-toolbar-left .e-toolbar-item:last-child{margin-left:3px}.e-bigger .e-toolbar.e-rtl .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-toolbar.e-bigger.e-rtl .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child{margin-left:0;margin-right:3px}.e-bigger .e-toolbar .e-hor-nav,.e-toolbar.e-bigger .e-hor-nav{min-height:56px;min-width:40px}.e-bigger .e-toolbar .e-toolbar-item .e-tbar-btn.e-btn,.e-toolbar.e-bigger .e-toolbar-item .e-tbar-btn.e-btn{line-height:35px}.e-bigger .e-toolbar .e-toolbar-item .e-btn.e-tbar-btn .e-icons.e-btn-icon,.e-toolbar.e-bigger .e-toolbar-item .e-btn.e-tbar-btn .e-icons.e-btn-icon{line-height:34px;min-height:34px;min-width:27px}.e-bigger .e-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn-text,.e-toolbar.e-bigger .e-toolbar-items .e-toolbar-item .e-tbar-btn-text{line-height:inherit}.e-bigger .e-toolbar .e-toolbar-pop .e-toolbar-item,.e-toolbar.e-bigger .e-toolbar-pop .e-toolbar-item{height:48px}.e-bigger .e-toolbar .e-toolbar-pop .e-toolbar-item:not(.e-separator),.e-toolbar.e-bigger .e-toolbar-pop .e-toolbar-item:not(.e-separator){min-width:48px;padding:0}.e-bigger .e-toolbar .e-toolbar-pop .e-toolbar-item .e-tbar-btn .e-icons.e-btn-icon,.e-toolbar.e-bigger .e-toolbar-pop .e-toolbar-item .e-tbar-btn .e-icons.e-btn-icon{min-width:27px}.e-bigger .e-toolbar .e-toolbar-pop .e-toolbar-item .e-tbar-btn.e-btn,.e-toolbar.e-bigger .e-toolbar-pop .e-toolbar-item .e-tbar-btn.e-btn{min-height:30px;padding:0 16px}.e-bigger .e-toolbar .e-toolbar-pop .e-toolbar-item .e-tbar-btn.e-btn .e-icons.e-btn-icon,.e-toolbar.e-bigger .e-toolbar-pop .e-toolbar-item .e-tbar-btn.e-btn .e-icons.e-btn-icon{margin-left:0;padding:0}.e-bigger .e-toolbar .e-toolbar-pop .e-toolbar-item .e-tbar-btn.e-btn .e-icon-left,.e-toolbar.e-bigger .e-toolbar-pop .e-toolbar-item .e-tbar-btn.e-btn .e-icon-left{padding-right:16px}.e-bigger .e-toolbar .e-toolbar-pop .e-toolbar-item .e-tbar-btn.e-btn .e-tbar-btn-text,.e-toolbar.e-bigger .e-toolbar-pop .e-toolbar-item .e-tbar-btn.e-btn .e-tbar-btn-text{padding:0}.e-bigger .e-toolbar .e-toolbar-items,.e-toolbar.e-bigger .e-toolbar-items{min-height:56px}.e-bigger .e-toolbar .e-toolbar-items.e-toolbar-multirow,.e-toolbar.e-bigger .e-toolbar-items.e-toolbar-multirow{margin-left:24px;margin-right:24px;white-space:normal}.e-bigger .e-toolbar .e-toolbar-items.e-toolbar-multirow .e-toolbar-item.e-separator.e-hidden,.e-bigger .e-toolbar .e-toolbar-items.e-toolbar-multirow .e-toolbar-item.e-separator.e-multirow-separator,.e-toolbar.e-bigger .e-toolbar-items.e-toolbar-multirow .e-toolbar-item.e-separator.e-hidden,.e-toolbar.e-bigger .e-toolbar-items.e-toolbar-multirow .e-toolbar-item.e-separator.e-multirow-separator{display:none}.e-bigger .e-toolbar .e-toolbar-items.e-toolbar-multirow .e-toolbar-item.e-separator,.e-toolbar.e-bigger .e-toolbar-items.e-toolbar-multirow .e-toolbar-item.e-separator{display:-ms-inline-flexbox;display:inline-flex}.e-bigger .e-toolbar .e-toolbar-items.e-toolbar-multirow:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-toolbar.e-bigger .e-toolbar-items.e-toolbar-multirow:not(.e-tbar-pos) .e-toolbar-item:first-child{margin-left:0}.e-bigger .e-toolbar .e-toolbar-items.e-toolbar-multirow:not(.e-tbar-pos) .e-toolbar-item:last-child,.e-toolbar.e-bigger .e-toolbar-items.e-toolbar-multirow:not(.e-tbar-pos) .e-toolbar-item:last-child{margin-right:0}.e-bigger .e-toolbar .e-toolbar-items .e-hscroll-bar .e-hscroll-content>.e-toolbar-item:last-child,.e-toolbar.e-bigger .e-toolbar-items .e-hscroll-bar .e-hscroll-content>.e-toolbar-item:last-child{margin-right:3px}.e-bigger .e-toolbar .e-toolbar-items .e-hscroll-bar .e-hscroll-content .e-toolbar-center .e-toolbar-item,.e-toolbar.e-bigger .e-toolbar-items .e-hscroll-bar .e-hscroll-content .e-toolbar-center .e-toolbar-item{margin:0}.e-bigger .e-toolbar .e-toolbar-items .e-hscroll-bar .e-hscroll-content .e-toolbar-right .e-toolbar-item:last-child,.e-toolbar.e-bigger .e-toolbar-items .e-hscroll-bar .e-hscroll-content .e-toolbar-right .e-toolbar-item:last-child{margin-right:3px}.e-bigger .e-toolbar .e-toolbar-items .e-hscroll-bar .e-hscroll-content .e-toolbar-right .e-toolbar-item,.e-toolbar.e-bigger .e-toolbar-items .e-hscroll-bar .e-hscroll-content .e-toolbar-right .e-toolbar-item{margin:0}.e-bigger .e-toolbar .e-toolbar-items .e-toolbar-left .e-toolbar-item:first-child,.e-bigger .e-toolbar .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-toolbar.e-bigger .e-toolbar-items .e-toolbar-left .e-toolbar-item:first-child,.e-toolbar.e-bigger .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child{margin-left:3px}.e-bigger .e-toolbar .e-toolbar-items .e-toolbar-item,.e-toolbar.e-bigger .e-toolbar-items .e-toolbar-item{min-height:56px}.e-bigger .e-toolbar .e-toolbar-items .e-toolbar-item:not(.e-separator),.e-toolbar.e-bigger .e-toolbar-items .e-toolbar-item:not(.e-separator){min-width:48px;padding:5px}.e-bigger .e-toolbar .e-toolbar-items .e-toolbar-item.e-separator,.e-toolbar.e-bigger .e-toolbar-items .e-toolbar-item.e-separator{height:calc(100% - 20px);margin:10px 5px;min-height:36px}.e-bigger .e-toolbar .e-toolbar-items .e-toolbar-item.e-popup-text .e-tbar-btn.e-btn.e-control.e-tbtn-txt .e-icons.e-btn-icon,.e-bigger .e-toolbar .e-toolbar-items .e-toolbar-item.e-popup-text .e-tbar-btn.e-btn.e-tbtn-txt .e-icons.e-btn-icon,.e-toolbar.e-bigger .e-toolbar-items .e-toolbar-item.e-popup-text .e-tbar-btn.e-btn.e-control.e-tbtn-txt .e-icons.e-btn-icon,.e-toolbar.e-bigger .e-toolbar-items .e-toolbar-item.e-popup-text .e-tbar-btn.e-btn.e-tbtn-txt .e-icons.e-btn-icon{padding:0}.e-bigger .e-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn,.e-bigger .e-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn.e-control,.e-toolbar.e-bigger .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn,.e-toolbar.e-bigger .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn.e-control{height:calc(100% - 11px);margin:5.5px 0;min-height:0;min-width:0;padding:0 6px}.e-bigger .e-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn.e-control.e-tbtn-txt .e-icons.e-btn-icon,.e-bigger .e-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn.e-control.e-tbtn-txt .e-icons.e-icon-right.e-btn-icon,.e-bigger .e-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn.e-tbtn-txt .e-icons.e-btn-icon,.e-bigger .e-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn.e-tbtn-txt .e-icons.e-icon-right.e-btn-icon,.e-toolbar.e-bigger .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn.e-control.e-tbtn-txt .e-icons.e-btn-icon,.e-toolbar.e-bigger .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn.e-control.e-tbtn-txt .e-icons.e-icon-right.e-btn-icon,.e-toolbar.e-bigger .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn.e-tbtn-txt .e-icons.e-btn-icon,.e-toolbar.e-bigger .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn.e-tbtn-txt .e-icons.e-icon-right.e-btn-icon{padding:0}.e-bigger .e-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn.e-control .e-tbar-btn-text,.e-bigger .e-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn .e-tbar-btn-text,.e-toolbar.e-bigger .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn.e-control .e-tbar-btn-text,.e-toolbar.e-bigger .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn .e-tbar-btn-text{padding:0 2.5px}.e-bigger .e-toolbar.e-extended-toolbar .e-toolbar-extended,.e-toolbar.e-bigger.e-extended-toolbar .e-toolbar-extended{min-height:56px;padding:0 3px}.e-bigger .e-toolbar.e-extended-toolbar .e-toolbar-extended.e-popup-close,.e-toolbar.e-bigger.e-extended-toolbar .e-toolbar-extended.e-popup-close{display:none}.e-bigger .e-toolbar.e-extended-toolbar .e-toolbar-extended.e-popup-open,.e-toolbar.e-bigger.e-extended-toolbar .e-toolbar-extended.e-popup-open{display:inline}.e-bigger .e-toolbar.e-extended-toolbar .e-toolbar-pop.e-toolbar-extended,.e-toolbar.e-bigger.e-extended-toolbar .e-toolbar-pop.e-toolbar-extended{width:inherit}.e-bigger .e-toolbar.e-extended-toolbar .e-toolbar-extended,.e-toolbar.e-bigger.e-extended-toolbar .e-toolbar-extended{box-shadow:none;display:inline;white-space:normal}.e-bigger .e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item:not(.e-separator),.e-toolbar.e-bigger.e-extended-toolbar .e-toolbar-extended .e-toolbar-item:not(.e-separator){min-width:48px;padding:5px}.e-bigger .e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item.e-separator.e-extended-separator,.e-toolbar.e-bigger.e-extended-toolbar .e-toolbar-extended .e-toolbar-item.e-separator.e-extended-separator{display:none}.e-bigger .e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item.e-separator,.e-toolbar.e-bigger.e-extended-toolbar .e-toolbar-extended .e-toolbar-item.e-separator{display:-ms-inline-flexbox;display:inline-flex}.e-bigger .e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item,.e-toolbar.e-bigger.e-extended-toolbar .e-toolbar-extended .e-toolbar-item{-ms-flex-line-pack:center;align-content:center;-ms-flex-align:center;align-items:center;cursor:pointer;display:-ms-inline-flexbox;display:inline-flex;min-height:56px;vertical-align:middle;width:auto}.e-bigger .e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn.e-btn.e-control .e-tbar-btn-text,.e-bigger .e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn.e-btn .e-tbar-btn-text,.e-toolbar.e-bigger.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn.e-btn.e-control .e-tbar-btn-text,.e-toolbar.e-bigger.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn.e-btn .e-tbar-btn-text{padding:0 2.5px}.e-bigger .e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn.e-btn,.e-bigger .e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn.e-btn.e-control,.e-toolbar.e-bigger.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn.e-btn,.e-toolbar.e-bigger.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn.e-btn.e-control{height:calc(100% - 11px);margin:5.5px 0;min-height:0;min-width:0;padding:0 6px}.e-bigger .e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn.e-btn,.e-toolbar.e-bigger.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn.e-btn{line-height:35px}.e-bigger .e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item.e-separator,.e-toolbar.e-bigger.e-extended-toolbar .e-toolbar-extended .e-toolbar-item.e-separator{height:calc(100% - 20px);margin:10px 5px;min-height:36px}.e-bigger .e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-btn.e-tbar-btn .e-icons.e-btn-icon,.e-toolbar.e-bigger.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-btn.e-tbar-btn .e-icons.e-btn-icon{line-height:34px;min-height:34px;min-width:27px}.e-bigger .e-toolbar.e-extended-toolbar.e-rtl .e-hor-nav,.e-toolbar.e-bigger.e-extended-toolbar.e-rtl .e-hor-nav{left:0;right:auto}.e-bigger .e-toolbar.e-extended-toolbar.e-rtl .e-toolbar-extended,.e-toolbar.e-bigger.e-extended-toolbar.e-rtl .e-toolbar-extended{padding-right:3px}.e-bigger .e-toolbar.e-vertical .e-toolbar-items .e-toolbar-item:not(.e-separator),.e-toolbar.e-bigger.e-vertical .e-toolbar-items .e-toolbar-item:not(.e-separator){min-height:38px}.e-bigger .e-toolbar.e-vertical .e-toolbar-items .e-toolbar-item.e-separator,.e-toolbar.e-bigger.e-vertical .e-toolbar-items .e-toolbar-item.e-separator{height:auto;margin:5px 10px;min-height:auto}.e-bigger .e-toolbar.e-vertical .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn,.e-toolbar.e-bigger.e-vertical .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn{margin:5.5px auto}.e-bigger .e-toolbar.e-vertical .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-toolbar.e-bigger.e-vertical .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child{margin-left:0}.e-bigger .e-toolbar.e-vertical .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child,.e-toolbar.e-bigger.e-vertical .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin-right:0}.e-bigger .e-toolbar.e-vertical .e-hor-nav,.e-toolbar.e-bigger.e-vertical .e-hor-nav{min-height:40px;min-width:50px}.e-toolbar{border-radius:0;display:block;height:42px;min-height:42px;position:relative;-ms-touch-action:none;touch-action:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap}.e-toolbar .e-blazor-toolbar-items{position:absolute;top:-9999px;visibility:hidden}.e-toolbar.e-extended-toolbar.e-rtl .e-hor-nav{left:0;right:auto}.e-toolbar.e-extended-toolbar.e-rtl .e-toolbar-extended{padding-right:3px}.e-toolbar.e-extended-toolbar.e-rtl .e-toolbar-extended .e-toolbar-item .e-tbar-btn.e-btn .e-icon-left{padding-left:0}.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item.e-popup-text .e-tbar-btn-text{display:none}.e-toolbar.e-extended-toolbar.e-extended-toolbar.e-tbar-extended{border-bottom:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.e-toolbar.e-extended-toolbar .e-hor-nav.e-ie-align{display:table}.e-toolbar.e-extended-toolbar .e-toolbar-extended{border-top:0;border-top-left-radius:0;border-top-right-radius:0;min-height:42px;padding:0 3px}.e-toolbar.e-extended-toolbar .e-toolbar-extended.e-popup-close,.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item.e-toolbar-text .e-tbar-btn-text{display:none}.e-toolbar.e-extended-toolbar .e-toolbar-extended.e-popup-open{display:inline}.e-toolbar.e-extended-toolbar .e-toolbar-pop.e-toolbar-extended{width:inherit}.e-toolbar.e-extended-toolbar .e-toolbar-extended{box-shadow:none;display:inline;white-space:normal}.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item:not(.e-separator){height:100%;min-width:34px;padding:3.5px}.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item.e-separator.e-extended-separator{display:none}.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item.e-separator{display:-ms-inline-flexbox;display:inline-flex}.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item{-ms-flex-line-pack:center;align-content:center;-ms-flex-align:center;align-items:center;cursor:pointer;display:-ms-inline-flexbox;display:inline-flex;min-height:42px;vertical-align:middle;width:auto}.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn.e-btn.e-control .e-tbar-btn-text,.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn.e-btn .e-tbar-btn-text{padding:0 2px}.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn-text{display:inline-block;font-family:Roboto,Segoe UI,GeezaPro,DejaVu Serif;font-size:14px;line-height:inherit;vertical-align:middle;width:auto}.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn.e-btn,.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn.e-btn.e-control{height:calc(100% - 10px);margin:4px 0;min-height:0;min-width:0;padding:0 1.5px}.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn.e-btn{line-height:25px}.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item.e-separator{margin:7.5px 3px;min-height:25px;min-width:1px;vertical-align:middle}.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-btn.e-tbar-btn .e-icons.e-btn-icon:not(.e-toolbar-pop){line-height:25px;min-height:25px;min-width:24px;padding:0}.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item.e-separator:last-of-type{display:-ms-inline-flexbox;display:inline-flex}.e-toolbar.e-extended-toolbar .e-toolbar-pop.e-toolbar-extended .e-toolbar-item:not(.e-separator){height:auto}.e-toolbar.e-extended-toolbar .e-toolbar-pop.e-toolbar-extended .e-toolbar-item .e-tbar-btn .e-icons.e-btn-icon{font-size:14px;vertical-align:middle}.e-toolbar.e-extended-toolbar .e-toolbar-pop.e-toolbar-extended .e-toolbar-item .e-tbar-btn{cursor:pointer;font-family:Roboto,Segoe UI,GeezaPro,DejaVu Serif;font-size:14px;font-weight:400;overflow:hidden;padding:0 1.5px;text-align:center;text-decoration:none;text-transform:none}.e-toolbar.e-extended-toolbar .e-toolbar-pop.e-toolbar-extended .e-tbar-btn:first-child{display:inline-block}.e-toolbar.e-extended-toolbar .e-toolbar-pop.e-toolbar-extended .e-toolbar-item>*{-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;text-overflow:ellipsis}.e-toolbar.e-control[class*=e-toolbar]{box-sizing:content-box}.e-toolbar.e-toolpop .e-toolbar-items .e-toolbar-item.e-popup-text .e-tbar-btn-text{display:none}.e-toolbar .e-tbar-btn-text,.e-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn-text{display:inline-block;padding:0 2px}.e-toolbar.e-hidden,.e-toolbar .e-toolbar-items .e-toolbar-item.e-hidden{display:none}.e-toolbar.e-corner{border-radius:0}.e-toolbar .e-toolbar-pop{border-radius:0;overflow:hidden;padding:0;position:absolute}.e-toolbar .e-toolbar-pop.e-toolbar-extended .e-toolbar-item .e-tbar-btn.e-btn .e-icons.e-btn-icon{margin:0;width:auto}.e-toolbar .e-toolbar-pop .e-toolbar-item.e-toolbar-popup.e-hidden{display:none}.e-toolbar .e-toolbar-pop .e-toolbar-item .e-tbar-btn.e-btn{-ms-flex-align:center;align-items:center;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-pack:start;justify-content:flex-start;min-height:24px;padding:0 16px}.e-toolbar .e-toolbar-pop .e-toolbar-item .e-tbar-btn.e-btn .e-icons.e-btn-icon{margin:0;padding:0;width:auto}.e-toolbar .e-toolbar-pop .e-toolbar-item .e-tbar-btn.e-btn .e-icon-left{padding-right:16px}.e-toolbar .e-toolbar-pop .e-toolbar-item .e-tbar-btn.e-btn .e-tbar-btn-text{padding:0}.e-toolbar .e-toolbar-pop .e-toolbar-item .e-tbar-btn .e-icons.e-btn-icon{min-width:24px}.e-toolbar .e-toolbar-pop .e-toolbar-item:not(.e-separator){min-width:34px;padding:0}.e-toolbar .e-toolbar-pop .e-toolbar-item.e-tbtn-align .e-btn.e-control{text-align:center}.e-toolbar .e-toolbar-pop .e-toolbar-item.e-tbtn-align .e-btn.e-control .e-icons.e-btn-icon{min-width:100%}.e-toolbar .e-toolbar-pop .e-toolbar-item{-ms-flex-line-pack:center;align-content:center;-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;height:36px;-ms-flex-pack:center;justify-content:center}.e-toolbar .e-toolbar-pop .e-toolbar-item>*{height:100%;min-width:100%;text-overflow:ellipsis}.e-toolbar .e-toolbar-pop .e-toolbar-text .e-tbar-btn-text{display:none}.e-toolbar .e-toolbar-pop .e-toolpopup,.e-toolbar .e-toolbar-popup{text-align:center}.e-toolbar.e-toolpop.e-rtl .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-center .e-toolbar-item{margin:0}.e-toolbar.e-toolpop.e-rtl .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-right .e-toolbar-item:last-child{margin:0;margin-left:3px}.e-toolbar.e-toolpop.e-rtl .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-right .e-toolbar-item{margin:0}.e-toolbar.e-rtl .e-hscroll-bar .e-hscroll-content>.e-toolbar-item:last-child{margin-left:3px;margin-right:0}.e-toolbar.e-rtl .e-hscroll-bar .e-hscroll-content .e-toolbar-center .e-toolbar-item{margin:0}.e-toolbar.e-rtl .e-hscroll-bar .e-hscroll-content .e-toolbar-right .e-toolbar-item:last-child{margin-right:3px}.e-toolbar.e-rtl .e-hscroll-bar .e-hscroll-content .e-toolbar-right .e-toolbar-item{margin:0}.e-toolbar.e-rtl .e-toolbar-items.e-tbar-pos .e-toolbar-left{left:auto;right:0}.e-toolbar.e-rtl .e-toolbar-items.e-tbar-pos .e-toolbar-right{left:0;right:auto}.e-toolbar.e-rtl .e-toolbar-items .e-toolbar-left .e-toolbar-item:first-child{margin-left:0}.e-toolbar.e-rtl .e-toolbar-items .e-toolbar-left .e-toolbar-item:last-child{margin-left:3px}.e-toolbar.e-rtl .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child{margin-left:0;margin-right:3px}.e-toolbar.e-rtl .e-toolbar-items:first-child .e-hscroll-bar:first-child .e-toolbar-left .e-toolbar-item:last-child{margin-left:0}.e-toolbar.e-rtl .e-toolbar-items:first-child .e-hscroll-bar:first-child .e-toolbar-left .e-toolbar-item:first-child{margin-left:0;margin-right:3px}.e-toolbar.e-rtl .e-toolbar-items:first-child .e-hscroll-bar:first-child .e-toolbar-center .e-toolbar-item:last-child{margin-right:0}.e-toolbar.e-rtl .e-toolbar-items:first-child .e-hscroll-bar:first-child .e-toolbar-right .e-toolbar-item:last-child{margin-left:3px;margin-right:0}.e-toolbar.e-rtl .e-toolbar-items:first-child .e-hscroll-bar:first-child .e-toolbar-right .e-toolbar-item:first-child{margin-right:0}.e-toolbar.e-rtl .e-toolbar-items:first-child .e-hscroll-bar:first-child .e-toolbar-item:last-child{margin-left:3px;margin-right:0}.e-toolbar.e-rtl .e-toolbar-items:first-child>.e-toolbar-item:last-child:last-child,.e-toolbar.e-rtl .e-toolbar-items:first-child>.e-toolbar-right .e-toolbar-item:last-child{margin-right:0}.e-toolbar.e-rtl .e-toolbar-items:first-child>.e-toolbar-item:last-child:first-child,.e-toolbar.e-rtl .e-toolbar-items:first-child>.e-toolbar-right .e-toolbar-item:first-child{margin-right:3px}.e-toolbar.e-rtl .e-toolbar-pop .e-toolbar-item .e-tbar-btn.e-btn .e-icon-left{padding-left:16px;padding-right:0}.e-toolbar.e-rtl .e-hor-nav{left:0;right:auto;border-radius:0 0 0 0}.e-toolbar .e-hor-nav{-ms-flex-align:center;align-items:center;border-radius:0 0 0 0;cursor:pointer;display:-ms-flexbox;display:flex;height:100%;min-height:42px;overflow:hidden;position:absolute;right:0;top:0;width:32px}.e-toolbar .e-hor-nav.e-ie-align{display:table}.e-toolbar .e-popup-down-icon.e-icons,.e-toolbar .e-popup-up-icon.e-icons{color:rgba(0,0,0,.54);display:table-cell;text-align:center;vertical-align:middle;width:100%}.e-toolbar .e-toolbar-item .e-tbar-btn.e-btn{line-height:25px}.e-toolbar .e-toolbar-item .e-tbar-btn.e-btn .e-icons.e-btn-icon{line-height:25px;min-height:25px}.e-toolbar .e-toolbar-items{border-radius:0 0 0 0;display:inline-block;height:100%;min-height:42px;vertical-align:middle}.e-toolbar .e-toolbar-items.e-toolbar-multirow{margin-bottom:1px;margin-left:18px;margin-right:18px;white-space:normal}.e-toolbar .e-toolbar-items.e-toolbar-multirow .e-toolbar-item.e-separator.e-hidden,.e-toolbar .e-toolbar-items.e-toolbar-multirow .e-toolbar-item.e-separator.e-multirow-separator{display:none}.e-toolbar .e-toolbar-items.e-toolbar-multirow .e-toolbar-item.e-separator{display:-ms-inline-flexbox;display:inline-flex}.e-toolbar .e-toolbar-items.e-multirow-pos .e-toolbar-center,.e-toolbar .e-toolbar-items.e-multirow-pos .e-toolbar-left,.e-toolbar .e-toolbar-items.e-multirow-pos .e-toolbar-right{display:inline}.e-toolbar .e-toolbar-items.e-toolbar-multirow:not(.e-tbar-pos) .e-toolbar-item:first-child{margin-left:0}.e-toolbar .e-toolbar-items.e-toolbar-multirow:not(.e-tbar-pos) .e-toolbar-item:last-child{margin-right:0}.e-toolbar .e-toolbar-items.e-tbar-pos{display:block}.e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-center,.e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-left,.e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-right{display:table;height:100%;top:0}.e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-left,.e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-right{position:absolute}.e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-right{right:0}.e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-left{left:0;line-height:35px}.e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-center{margin:0 auto}.e-toolbar .e-toolbar-items .e-toolbar-center,.e-toolbar .e-toolbar-items .e-toolbar-left,.e-toolbar .e-toolbar-items .e-toolbar-right{display:inline-block}.e-toolbar .e-toolbar-items .e-toolbar-left .e-toolbar-item:first-child,.e-toolbar .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child{margin-left:3px}.e-toolbar .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-right .e-toolbar-item:first-child{margin-left:0}.e-toolbar .e-toolbar-items:first-child .e-hscroll-bar:first-child .e-toolbar-left .e-toolbar-item:last-child{margin-right:0}.e-toolbar .e-toolbar-items:first-child .e-hscroll-bar:first-child .e-toolbar-left .e-toolbar-item:first-child{margin-left:3px}.e-toolbar .e-toolbar-items:first-child .e-hscroll-bar:first-child .e-toolbar-center .e-toolbar-item:last-child{margin-right:0}.e-toolbar .e-toolbar-items:first-child .e-hscroll-bar:first-child .e-toolbar-right .e-toolbar-item:last-child{margin-right:3px}.e-toolbar .e-toolbar-items:first-child .e-hscroll-bar:first-child .e-toolbar-right .e-toolbar-item:first-child{margin-left:0}.e-toolbar .e-toolbar-items .e-hscroll-bar .e-hscroll-content>.e-toolbar-item:last-child,.e-toolbar .e-toolbar-items:first-child .e-hscroll-bar:first-child .e-toolbar-item:last-child,.e-toolbar .e-toolbar-items:first-child>.e-toolbar-item:last-child,.e-toolbar .e-toolbar-items:first-child>.e-toolbar-right .e-toolbar-item:last-child{margin-right:3px}.e-toolbar .e-toolbar-items .e-hscroll-bar .e-hscroll-content .e-toolbar-center .e-toolbar-item{margin:0}.e-toolbar .e-toolbar-items .e-hscroll-bar .e-hscroll-content .e-toolbar-right .e-toolbar-item:last-child{margin-right:3px}.e-toolbar .e-toolbar-items .e-hscroll-bar .e-hscroll-content .e-toolbar-right .e-toolbar-item{margin:0}.e-toolbar .e-toolbar-items .e-toolbar-item{-ms-flex-line-pack:center;align-content:center;-ms-flex-align:center;align-items:center;cursor:pointer;display:-ms-inline-flexbox;display:inline-flex;min-height:42px;vertical-align:middle;width:auto}.e-toolbar .e-toolbar-items .e-toolbar-item:not(.e-separator){height:inherit;min-width:34px;padding:3.5px}.e-toolbar .e-toolbar-items .e-toolbar-item.e-separator{margin:7.5px 3px;min-height:27px;min-width:1px}.e-toolbar .e-toolbar-items .e-toolbar-item input[type=checkbox]{height:auto}.e-toolbar .e-toolbar-items .e-toolbar-item.e-popup-text .e-tbar-btn.e-btn.e-tbtn-txt .e-icons.e-btn-icon{padding:0}.e-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn{height:calc(100% - 10px);margin:4px 0;min-height:0;min-width:0;padding:0 1.5px}.e-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn.e-tbtn-txt .e-icons.e-btn-icon,.e-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn.e-tbtn-txt .e-icons.e-icon-right.e-btn-icon{padding:0}.e-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn .e-icons.e-btn-icon{margin:0;min-width:24px;width:auto}.e-toolbar .e-toolbar-items .e-toolbar-item>*{-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;text-overflow:ellipsis}.e-toolbar .e-toolbar-items .e-toolbar-item.e-separator{height:calc(100% - 15px);vertical-align:middle}.e-toolbar .e-toolbar-items .e-toolbar-item.e-separator+.e-separator,.e-toolbar .e-toolbar-items .e-toolbar-item.e-separator:first-of-type,.e-toolbar .e-toolbar-items .e-toolbar-item.e-separator:last-of-type{display:none}.e-toolbar .e-tbar-btn>:first-child{display:inline-block}.e-toolbar .e-tbar-btn{border:none;cursor:pointer;font-family:Roboto,Segoe UI,GeezaPro,DejaVu Serif;font-size:14px;font-weight:400;overflow:hidden;padding:0 1.5px;text-align:center;text-decoration:none;text-transform:none}.e-toolbar .e-tbar-btn .e-icons.e-btn-icon{font-size:14px;vertical-align:middle}.e-toolbar .e-tbar-btn div{vertical-align:middle}.e-toolbar .e-tbar-btn .e-tbar-btn-text{display:inline-block;font-family:Roboto,Segoe UI,GeezaPro,DejaVu Serif;font-size:14px;line-height:inherit;vertical-align:middle;width:auto}.e-toolbar.e-vertical{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.e-toolbar.e-vertical.e-rtl.e-tbar-pos .e-toolbar-left{bottom:0;top:auto}.e-toolbar.e-vertical.e-rtl.e-tbar-pos .e-toolbar-right{bottom:auto;top:0}.e-toolbar.e-vertical .e-toolbar-items.e-tbar-pos .e-toolbar-center,.e-toolbar.e-vertical .e-toolbar-items.e-tbar-pos .e-toolbar-left,.e-toolbar.e-vertical .e-toolbar-items.e-tbar-pos .e-toolbar-right{height:auto}.e-toolbar.e-vertical .e-toolbar-items.e-tbar-pos .e-toolbar-left{left:auto;right:auto;top:0}.e-toolbar.e-vertical .e-toolbar-items.e-tbar-pos .e-toolbar-right{bottom:0;left:auto;right:auto}.e-toolbar.e-vertical .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child{margin-left:0}.e-toolbar.e-vertical .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin-right:0}.e-toolbar.e-vertical .e-toolbar-items .e-toolbar-item{display:-ms-flexbox;display:flex;height:auto}.e-toolbar.e-vertical .e-toolbar-items .e-toolbar-item:not(.e-separator){min-width:33px}.e-toolbar.e-vertical .e-toolbar-items .e-toolbar-item.e-separator{height:auto;margin:3px 7.5px;min-height:auto}.e-toolbar.e-vertical .e-toolbar-items .e-toolbar-item .e-tbar-btn.e-btn{margin:4px auto}.e-toolbar.e-vertical .e-hor-nav{bottom:0;height:auto;left:0;min-height:40px;min-width:50px;right:auto;top:auto;width:auto}\n\n/*! toolbar theme */.e-toolbar{-webkit-tap-highlight-color:rgba(0,0,0,0);background:#fafafa;border:1px none rgba(0,0,0,.12);box-shadow:none}.e-toolbar.e-vertical .e-hor-nav{border:solid rgba(0,0,0,.12);border-width:1px 0 0}.e-toolbar.e-vertical.e-rtl .e-hor-nav{border:solid rgba(0,0,0,.12);border-width:0 0 1px}.e-toolbar.e-vertical .e-toolbar-items .e-toolbar-item.e-separator{border-width:0 0 .5px}.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item.e-overlay{background:#fafafa}.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item.e-separator{border:solid rgba(0,0,0,.12);border-width:0 .5px 0 0}.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn .e-icons{color:rgba(0,0,0,.54)}.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn{background:#fafafa;box-shadow:none;color:rgba(0,0,0,.87)}.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn .e-toolbar-item .e-tbar-btn-text{color:rgba(0,0,0,.87)}.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn:focus,.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn:hover{background:rgba(0,0,0,.12);border-color:rgba(0,0,0,.12);border-radius:0;color:rgba(0,0,0,.87)}.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn:active{background:#bdbdbd;border-color:#bdbdbd;border-radius:0;box-shadow:none;color:rgba(0,0,0,.87)}.e-toolbar .e-tbar-btn.e-btn .e-icons{color:rgba(0,0,0,.54)}.e-toolbar .e-toolbar-pop{background:#fafafa;border:1px none rgba(0,0,0,.12);box-shadow:0 2px 2px 1px rgba(0,0,0,.21)}.e-toolbar .e-toolbar-pop .e-toolbar-item:not(.e-separator){background:transparent}.e-toolbar.e-extended-toolbar .e-toolbar-pop{background:#fafafa}.e-toolbar.e-toolpop .e-hor-nav.e-nav-active,.e-toolbar.e-toolpop .e-hor-nav.e-nav-active:not(.e-expended-nav){background:rgba(0,0,0,.12);border:0;box-shadow:none;border-left:1px none rgba(0,0,0,.12)}.e-toolbar.e-toolpop .e-hor-nav.e-nav-active .e-icons,.e-toolbar.e-toolpop .e-hor-nav.e-nav-active:not(.e-expended-nav) .e-icons{color:rgba(0,0,0,.87)}.e-toolbar .e-tbar-btn{background:#fafafa;box-shadow:none;color:rgba(0,0,0,.87)}.e-toolbar .e-tbar-btn:focus,.e-toolbar .e-tbar-btn:hover{background:rgba(0,0,0,.12);border-color:rgba(0,0,0,.12);border-radius:0;color:rgba(0,0,0,.87)}.e-toolbar .e-toolbar-items,.e-toolbar .e-toolbar-items .e-toolbar-item.e-overlay{background:#fafafa}.e-toolbar .e-toolbar-items .e-toolbar-item.e-overlay .e-tbar-btn-text{color:rgba(0,0,0,.38)}.e-toolbar .e-toolbar-items .e-toolbar-item.e-overlay .e-icons{color:rgba(0,0,0,.26)}.e-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn-text{color:rgba(0,0,0,.87)}.e-toolbar .e-toolbar-items .e-toolbar-item.e-separator{border:solid rgba(0,0,0,.12);border-width:0 .5px 0 0}.e-toolbar.e-rtl .e-hor-nav{background:#fafafa;border:solid rgba(0,0,0,.12);border-left:0;border-width:0 1px 0 0}.e-toolbar.e-rtl .e-hor-nav:not(.e-nav-active):hover{background:rgba(0,0,0,.12);color:rgba(0,0,0,.87)}.e-toolbar .e-hor-nav{background:#fafafa;border:solid rgba(0,0,0,.12);border-width:0 0 0 1px}.e-toolbar .e-hor-nav:after{background-color:transparent;border-radius:50%;border-width:1px;box-sizing:border-box;content:\"\";height:1px;left:50%;position:absolute;top:50%;visibility:hidden;width:1px}.e-toolbar .e-hor-nav:active{border:0;box-shadow:none;color:rgba(0,0,0,.87)}.e-toolbar .e-hor-nav:active:after{animation:tbar-popup-shadow .6s ease-out 0ms;visibility:visible}.e-toolbar .e-hor-nav:focus,.e-toolbar .e-hor-nav:hover{background:rgba(0,0,0,.12);border-left:0;color:rgba(0,0,0,.87)}.e-toolbar .e-hor-nav:focus{border-color:rgba(0,0,0,.12)}.e-toolbar .e-tbar-btn:active{background:#bdbdbd;border-color:#bdbdbd;border-radius:0;box-shadow:none;color:rgba(0,0,0,.87)}\n\n/*! component's theme wise override material-definitions and variables */\n/*! accordion icons */.e-accordion .e-tgl-collapse-icon:before{content:\"\\E916\"}.e-accordion .e-tgl-collapse-icon.e-expand-icon{transform:rotate(-180deg)}\n\n/*! accordion layout */.e-accordion.e-bigger .e-acrdn-item .e-acrdn-header .e-acrdn-header-content,.e-bigger .e-accordion .e-acrdn-item .e-acrdn-header .e-acrdn-header-content{font-size:16px}.e-accordion.e-bigger .e-acrdn-item.e-select .e-acrdn-panel,.e-bigger .e-accordion .e-acrdn-item.e-select .e-acrdn-panel{font-size:14px}.e-accordion.e-bigger .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content>.e-accordion>.e-acrdn-item>.e-acrdn-panel:not(.e-nested)>.e-acrdn-content,.e-bigger .e-accordion .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content>.e-accordion>.e-acrdn-item>.e-acrdn-panel:not(.e-nested)>.e-acrdn-content{padding:16px 16px 16px 32px}.e-accordion.e-bigger .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content>.e-accordion>.e-acrdn-item>.e-acrdn-header,.e-bigger .e-accordion .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content>.e-accordion>.e-acrdn-item>.e-acrdn-header{padding:0 46px 0 32px}.e-accordion.e-bigger .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content,.e-bigger .e-accordion .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content{padding:0}.e-accordion.e-bigger .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content>.e-accordion,.e-bigger .e-accordion .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content>.e-accordion{border:0}.e-accordion.e-bigger .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content .e-accordion .e-acrdn-panel.e-nested .e-acrdn-content .e-acrdn-header,.e-bigger .e-accordion .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content .e-accordion .e-acrdn-panel.e-nested .e-acrdn-content .e-acrdn-header{padding:0 46px 0 48px}.e-accordion.e-bigger .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content .e-accordion .e-acrdn-panel.e-nested .e-acrdn-content .e-acrdn-panel .e-acrdn-content,.e-bigger .e-accordion .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content .e-accordion .e-acrdn-panel.e-nested .e-acrdn-content .e-acrdn-panel .e-acrdn-content{padding:16px 16px 16px 48px}.e-accordion.e-bigger .e-acrdn-item.e-select .e-acrdn-panel .e-acrdn-header .e-acrdn-header-content,.e-bigger .e-accordion .e-acrdn-item.e-select .e-acrdn-panel .e-acrdn-header .e-acrdn-header-content{font-size:14px}.e-accordion.e-bigger .e-acrdn-item.e-select .e-acrdn-header,.e-bigger .e-accordion .e-acrdn-item.e-select .e-acrdn-header{line-height:47px;min-height:48px;padding:0 46px 0 16px}.e-accordion.e-bigger .e-acrdn-item.e-select .e-acrdn-header .e-toggle-icon,.e-bigger .e-accordion .e-acrdn-item.e-select .e-acrdn-header .e-toggle-icon{height:48px;min-height:48px;min-width:30px;right:16px}.e-accordion.e-bigger .e-acrdn-item.e-select .e-acrdn-header .e-acrdn-header-icon,.e-bigger .e-accordion .e-acrdn-item.e-select .e-acrdn-header .e-acrdn-header-icon{display:inline-block;padding:0 14px 0 0}.e-accordion.e-bigger .e-acrdn-item.e-select .e-acrdn-panel .e-acrdn-content,.e-bigger .e-accordion .e-acrdn-item.e-select .e-acrdn-panel .e-acrdn-content{padding:16px}.e-accordion.e-bigger.e-rtl .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content>.e-accordion>.e-acrdn-item>.e-acrdn-panel:not(.e-nested)>.e-acrdn-content,.e-bigger .e-accordion.e-rtl .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content>.e-accordion>.e-acrdn-item>.e-acrdn-panel:not(.e-nested)>.e-acrdn-content{padding:16px 32px 16px 16px}.e-accordion.e-bigger.e-rtl .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content>.e-accordion>.e-acrdn-item>.e-acrdn-header,.e-bigger .e-accordion.e-rtl .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content>.e-accordion>.e-acrdn-item>.e-acrdn-header{padding:0 32px 0 46px}.e-accordion.e-bigger.e-rtl .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content .e-accordion .e-acrdn-panel.e-nested .e-acrdn-content .e-acrdn-header,.e-bigger .e-accordion.e-rtl .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content .e-accordion .e-acrdn-panel.e-nested .e-acrdn-content .e-acrdn-header{padding:0 48px 0 46px}.e-accordion.e-bigger.e-rtl .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content .e-accordion .e-acrdn-panel.e-nested .e-acrdn-content .e-acrdn-panel .e-acrdn-content,.e-bigger .e-accordion.e-rtl .e-acrdn-item.e-select .e-acrdn-panel.e-nested>.e-acrdn-content .e-accordion .e-acrdn-panel.e-nested .e-acrdn-content .e-acrdn-panel .e-acrdn-content{padding:16px 48px 16px 16px}.e-accordion.e-bigger.e-rtl .e-acrdn-item .e-acrdn-header,.e-bigger .e-accordion.e-rtl .e-acrdn-item .e-acrdn-header{padding:0 16px 0 46px}.e-accordion.e-bigger.e-rtl .e-acrdn-item .e-acrdn-header .e-toggle-icon,.e-bigger .e-accordion.e-rtl .e-acrdn-item .e-acrdn-header .e-toggle-icon{left:16px;right:auto}.e-accordion.e-bigger.e-rtl .e-acrdn-item .e-acrdn-header .e-acrdn-header-icon,.e-bigger .e-accordion.e-rtl .e-acrdn-item .e-acrdn-header .e-acrdn-header-icon{padding:0 0 0 14px}.e-accordion{display:block;position:relative}.e-accordion .e-acrdn-item.e-select.e-selected:first-child{border-top:0}.e-accordion .e-acrdn-item.e-select.e-selected:last-child{border-bottom:0}.e-accordion .e-acrdn-item>.e-acrdn-header .e-acrdn-header-content{font-weight:400}.e-accordion .e-acrdn-item.e-selected{padding-top:0}.e-accordion .e-acrdn-item.e-selected>.e-acrdn-header .e-acrdn-header-content{font-weight:400}.e-accordion .e-acrdn-item.e-overlay{height:auto}.e-accordion .e-acrdn-item{overflow:hidden;padding-top:0;position:relative}.e-accordion .e-acrdn-item.e-hide{display:none}.e-accordion .e-acrdn-item .e-acrdn-header .e-acrdn-header-content{font-size:15px}.e-accordion .e-acrdn-item.e-select>.e-acrdn-header{cursor:pointer}.e-accordion .e-acrdn-item .e-acrdn-header{line-height:35px;min-height:36px;overflow:hidden;padding:0 40px 0 16px;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.e-accordion .e-acrdn-item .e-acrdn-header>*{display:inline-block}.e-accordion .e-acrdn-item .e-acrdn-header .e-toggle-icon{display:table;font-size:12px;height:36px;min-height:36px;min-width:24px;position:absolute;right:16px;top:0}.e-accordion .e-acrdn-item .e-acrdn-header .e-toggle-icon .e-tgl-collapse-icon.e-icons{display:table-cell;text-align:center;vertical-align:middle}.e-accordion .e-acrdn-item .e-acrdn-header .e-toggle-animation{transition:.5s ease 0s}.e-accordion .e-acrdn-item .e-acrdn-header .e-acrdn-header-icon{display:inline-block;padding:0 8px 0 0}.e-accordion .e-acrdn-item .e-acrdn-panel{overflow-y:hidden;text-decoration:none;width:100%}.e-accordion .e-acrdn-item .e-acrdn-panel.e-nested>.e-acrdn-content>.e-accordion>.e-acrdn-item>.e-acrdn-panel:not(.e-nested)>.e-acrdn-content{padding:16px 16px 16px 32px}.e-accordion .e-acrdn-item .e-acrdn-panel.e-nested>.e-acrdn-content>.e-accordion>.e-acrdn-item>.e-acrdn-header{padding:0 40px 0 32px}.e-accordion .e-acrdn-item .e-acrdn-panel.e-nested>.e-acrdn-content,.e-accordion .e-acrdn-item .e-acrdn-panel.e-nested>.e-acrdn-content .e-acrdn-panel.e-nested>.e-acrdn-content{padding:0}.e-accordion .e-acrdn-item .e-acrdn-panel.e-nested>.e-acrdn-content>.e-accordion{border:0}.e-accordion .e-acrdn-item .e-acrdn-panel.e-nested>.e-acrdn-content .e-accordion .e-acrdn-panel.e-nested .e-acrdn-content .e-acrdn-header{padding:0 40px 0 48px}.e-accordion .e-acrdn-item .e-acrdn-panel.e-nested>.e-acrdn-content .e-accordion .e-acrdn-panel.e-nested .e-acrdn-content .e-acrdn-panel .e-acrdn-content{padding:16px 16px 16px 48px}.e-accordion .e-acrdn-item .e-acrdn-panel.e-nested .e-acrdn-item.e-select.e-selected .e-acrdn-header>.e-acrdn-header-content,.e-accordion .e-acrdn-item .e-acrdn-panel.e-nested .e-nested .e-accordion .e-acrdn-item .e-acrdn-header .e-acrdn-header-content{font-weight:400}.e-accordion .e-acrdn-item .e-acrdn-panel .e-acrdn-content{line-height:1.5;overflow:hidden;padding:16px;text-overflow:ellipsis}.e-accordion .e-acrdn-item .e-acrdn-panel .e-acrdn-content>*{overflow:hidden;text-overflow:ellipsis}.e-accordion .e-acrdn-item .e-acrdn-panel .e-acrdn-header-content{font-size:14px}.e-accordion .e-acrdn-item .e-content-hide{display:none}.e-accordion.e-rtl .e-acrdn-item .e-acrdn-panel.e-nested>.e-acrdn-content>.e-accordion>.e-acrdn-item>.e-acrdn-panel:not(.e-nested)>.e-acrdn-content{padding:16px 32px 16px 16px}.e-accordion.e-rtl .e-acrdn-item .e-acrdn-panel.e-nested>.e-acrdn-content>.e-accordion>.e-acrdn-item>.e-acrdn-header{padding:0 32px 0 40px}.e-accordion.e-rtl .e-acrdn-item .e-acrdn-panel.e-nested>.e-acrdn-content .e-accordion .e-acrdn-panel.e-nested .e-acrdn-content .e-acrdn-header{padding:0 48px 0 40px}.e-accordion.e-rtl .e-acrdn-item .e-acrdn-panel.e-nested>.e-acrdn-content .e-accordion .e-acrdn-panel.e-nested .e-acrdn-content .e-acrdn-panel .e-acrdn-content{padding:16px 48px 16px 16px}.e-accordion.e-rtl .e-acrdn-item .e-acrdn-header{padding:0 16px 0 40px}.e-accordion.e-rtl .e-acrdn-item .e-acrdn-header .e-toggle-icon{left:16px;right:auto}.e-accordion.e-rtl .e-acrdn-item .e-acrdn-header .e-acrdn-header-icon{padding:0 0 0 8px}\n\n/*! accordion theme */.e-accordion{-webkit-tap-highlight-color:rgba(0,0,0,0);border:1px solid rgba(0,0,0,.12)}.e-accordion,.e-accordion .e-active{background:#fff}.e-accordion .e-acrdn-item.e-item-focus.e-select.e-selected.e-expand-state{border-top:1px solid #fff}.e-accordion .e-acrdn-item.e-item-focus.e-expand-state.e-select,.e-accordion .e-acrdn-item.e-item-focus.e-select.e-selected.e-expand-state{border-color:#eee}.e-accordion .e-acrdn-item.e-expand-state.e-select{border-bottom:1px solid #fff;border-top:1px solid #fff}.e-accordion .e-acrdn-item.e-overlay{background:#fff}.e-accordion .e-acrdn-item.e-selected.e-select.e-expand-state>.e-acrdn-header:focus{background:#eee}.e-accordion .e-acrdn-item .e-acrdn-panel.e-nested .e-acrdn-header .e-acrdn-header-content,.e-accordion .e-acrdn-item.e-select .e-acrdn-panel .e-acrdn-content{color:rgba(0,0,0,.87)}.e-accordion .e-acrdn-item.e-select .e-acrdn-panel .e-acrdn-content .e-content-icon{color:rgba(0,0,0,.54)}.e-accordion .e-acrdn-item .e-acrdn-header .e-acrdn-header-content{color:rgba(0,0,0,.87)}.e-accordion .e-acrdn-item .e-acrdn-header .e-acrdn-header-icon{color:rgba(0,0,0,.54)}.e-accordion .e-acrdn-item.e-expand-state.e-select:not(.e-selected)>.e-acrdn-header:focus{background:#eee}.e-accordion .e-acrdn-item .e-acrdn-header:active,.e-accordion .e-acrdn-item .e-acrdn-header:hover{background:transparent}.e-accordion .e-acrdn-item .e-acrdn-header:focus{background:#eee}.e-accordion .e-acrdn-item.e-select.e-expand-state>.e-acrdn-header,.e-accordion .e-acrdn-item.e-select.e-selected.e-expand-state>.e-acrdn-header{background:#fff}.e-accordion .e-acrdn-item.e-select.e-expand-state>.e-acrdn-header>.e-toggle-icon,.e-accordion .e-acrdn-item.e-select.e-selected.e-expand-state>.e-acrdn-header>.e-toggle-icon{color:rgba(0,0,0,.54)}.e-accordion .e-acrdn-item.e-select.e-expand-state>.e-acrdn-header .e-acrdn-header-content,.e-accordion .e-acrdn-item.e-select.e-expand-state>.e-acrdn-header .e-acrdn-header-icon,.e-accordion .e-acrdn-item.e-select.e-selected.e-expand-state>.e-acrdn-header .e-acrdn-header-content,.e-accordion .e-acrdn-item.e-select.e-selected.e-expand-state>.e-acrdn-header .e-acrdn-header-icon{color:#e3165b}.e-accordion .e-acrdn-item.e-select{border-bottom:1px solid transparent;border-top:1px solid transparent}.e-accordion .e-acrdn-item.e-select.e-item-focus{border-color:#eee}.e-accordion .e-acrdn-item.e-selected.e-select{border-bottom:1px solid rgba(0,0,0,.12);border-top:1px solid rgba(0,0,0,.12)}.e-accordion .e-acrdn-item.e-selected+.e-selected{border-top:1px solid transparent}.e-accordion .e-acrdn-item.e-selected .e-selected:last-child{border-bottom:1px none rgba(0,0,0,.12)}.e-accordion .e-acrdn-item.e-selected>.e-acrdn-panel .e-acrdn-content{color:rgba(0,0,0,.87)}.e-accordion .e-acrdn-item.e-selected>.e-acrdn-panel .e-acrdn-header-content,.e-accordion .e-acrdn-item .e-toggle-icon{color:rgba(0,0,0,.54)}.e-accordion .e-acrdn-item .e-acrdn-panel{font-size:13px}\n\n/*! Carousel component material theme definitions and variables */.e-carousel .e-previous-icon:before{content:\"\\E904\"}.e-carousel .e-next-icon:before{content:\"\\E913\"}.e-carousel .e-play-icon:before{content:\"\\E324\"}.e-carousel .e-pause-icon:before{content:\"\\E326\"}.e-carousel.e-rtl .e-previous-icon:before{content:\"\\E913\"}.e-carousel.e-rtl .e-next-icon:before{content:\"\\E904\"}\n\n/*! carousel component styles */.e-carousel{display:block;margin:0;padding:0;position:relative}.e-carousel .e-carousel-items{height:100%;margin:0;overflow:hidden;padding:0;position:relative;width:100%}.e-carousel .e-carousel-items:not(.e-carousel-custom-animation) .e-carousel-item{-webkit-backface-visibility:hidden;backface-visibility:hidden;display:none;float:left;height:100%;margin-right:-100%;position:relative;width:100%}.e-carousel .e-carousel-items:not(.e-carousel-custom-animation) .e-carousel-item.e-active{display:block}.e-carousel .e-carousel-items.e-carousel-slide-animation .e-carousel-item{transition:transform .6s ease-in-out}.e-carousel .e-carousel-items.e-carousel-slide-animation .e-carousel-item.e-active,.e-carousel .e-carousel-items.e-carousel-slide-animation .e-carousel-item.e-next,.e-carousel .e-carousel-items.e-carousel-slide-animation .e-carousel-item.e-prev{display:block}.e-carousel .e-carousel-items.e-carousel-slide-animation .e-carousel-item.e-active.e-transition-end,.e-carousel .e-carousel-items.e-carousel-slide-animation .e-carousel-item.e-next:not(.e-transition-start){transform:translateX(100%)}.e-carousel .e-carousel-items.e-carousel-slide-animation .e-carousel-item.e-active.e-transition-start,.e-carousel .e-carousel-items.e-carousel-slide-animation .e-carousel-item.e-prev:not(.e-transition-end){transform:translateX(-100%)}.e-carousel .e-carousel-items.e-carousel-fade-animation .e-carousel-item{display:block;opacity:0;transition:opacity .6s ease-in-out;z-index:0}.e-carousel .e-carousel-items.e-carousel-fade-animation .e-carousel-item.e-active{opacity:1;z-index:1}.e-carousel .e-carousel-items.e-carousel-custom-animation .e-carousel-item{display:block;height:100%;left:0;opacity:0;pointer-events:none;position:absolute;top:0;width:100%}.e-carousel .e-carousel-items.e-carousel-custom-animation .e-carousel-item.e-active{opacity:1;pointer-events:visible}.e-carousel .e-carousel-navigators{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;height:100%;-ms-flex-pack:justify;justify-content:space-between;pointer-events:none;position:absolute;top:0;width:100%;z-index:1}.e-carousel .e-carousel-navigators .e-next,.e-carousel .e-carousel-navigators .e-play-pause,.e-carousel .e-carousel-navigators .e-previous{padding:.5em;pointer-events:auto}.e-carousel .e-carousel-navigators .e-next .e-btn,.e-carousel .e-carousel-navigators .e-play-pause .e-btn,.e-carousel .e-carousel-navigators .e-previous .e-btn{border:0;box-shadow:none}.e-carousel .e-carousel-navigators .e-next .e-btn:hover,.e-carousel .e-carousel-navigators .e-play-pause .e-btn:hover,.e-carousel .e-carousel-navigators .e-previous .e-btn:hover{border-radius:50%}.e-carousel .e-carousel-navigators .e-next .e-btn.e-rtl,.e-carousel .e-carousel-navigators .e-play-pause .e-btn.e-rtl,.e-carousel .e-carousel-navigators .e-previous .e-btn.e-rtl{transform:rotate(180deg)}.e-carousel .e-carousel-navigators .e-next.e-hover-arrows,.e-carousel .e-carousel-navigators .e-play-pause.e-hover-arrows,.e-carousel .e-carousel-navigators .e-previous.e-hover-arrows{display:none}.e-carousel .e-carousel-indicators{-ms-flex-align:center;align-items:center;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;min-height:48px;padding:0;pointer-events:none;position:absolute;width:100%;z-index:1}.e-carousel .e-carousel-indicators .e-indicator-bars{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;pointer-events:auto}.e-carousel .e-carousel-indicators .e-indicator-bars .e-indicator-bar{padding:0}.e-carousel .e-carousel-indicators .e-indicator-bars .e-indicator-bar .e-indicator{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;padding:6px}.e-carousel .e-carousel-indicators .e-indicator-bars .e-indicator-bar .e-indicator div{border:1px solid hsla(0,0%,100%,.4);border-radius:50%;height:12px;transition-duration:.6s;transition-property:background-color,border-color;transition-timing-function:ease-in-out;width:12px}.e-carousel .e-carousel-indicators .e-indicator-bars .e-indicator-bar .e-indicator .e-ripple-element{display:none}\n\n/*! carousel component theme */.e-carousel .e-carousel-navigators .e-next .e-btn:not(:disabled),.e-carousel .e-carousel-navigators .e-play-pause .e-btn:not(:disabled),.e-carousel .e-carousel-navigators .e-previous .e-btn:not(:disabled){background-color:transparent}.e-carousel .e-carousel-navigators .e-next .e-btn:not(:disabled) .e-btn-icon,.e-carousel .e-carousel-navigators .e-play-pause .e-btn:not(:disabled) .e-btn-icon,.e-carousel .e-carousel-navigators .e-previous .e-btn:not(:disabled) .e-btn-icon{color:#fff}.e-carousel .e-carousel-navigators .e-next .e-btn:not(:disabled):active,.e-carousel .e-carousel-navigators .e-next .e-btn:not(:disabled):focus,.e-carousel .e-carousel-navigators .e-next .e-btn:not(:disabled):hover,.e-carousel .e-carousel-navigators .e-play-pause .e-btn:not(:disabled):active,.e-carousel .e-carousel-navigators .e-play-pause .e-btn:not(:disabled):focus,.e-carousel .e-carousel-navigators .e-play-pause .e-btn:not(:disabled):hover,.e-carousel .e-carousel-navigators .e-previous .e-btn:not(:disabled):active,.e-carousel .e-carousel-navigators .e-previous .e-btn:not(:disabled):focus,.e-carousel .e-carousel-navigators .e-previous .e-btn:not(:disabled):hover{background-color:hsla(0,0%,100%,.4);outline:none}.e-carousel .e-carousel-indicators .e-indicator-bar .e-indicator{background-color:transparent;border-color:transparent;box-shadow:none}.e-carousel .e-carousel-indicators .e-indicator-bar .e-indicator div{background-color:#fff;border-color:#fff}.e-carousel .e-carousel-indicators .e-indicator-bar .e-indicator:active,.e-carousel .e-carousel-indicators .e-indicator-bar .e-indicator:focus,.e-carousel .e-carousel-indicators .e-indicator-bar .e-indicator:hover{background-color:transparent;border-color:transparent;box-shadow:none;outline:none}.e-carousel .e-carousel-indicators .e-indicator-bar .e-indicator:focus-visible{border-color:#000}.e-carousel .e-carousel-indicators .e-indicator-bar.e-active .e-indicator div{background-color:#e3165b;border-color:#e3165b}\n\n/*! contextmenu layout */.e-contextmenu-container ul .e-menu-item .e-previous:before,.e-contextmenu-wrapper ul .e-menu-item .e-previous:before{content:\"\\E977\"}.e-contextmenu-container ul .e-menu-item .e-caret:before,.e-contextmenu-wrapper ul .e-menu-item .e-caret:before{content:\"\\E956\"}.e-rtl.e-contextmenu-container .e-menu-item .e-caret:before,.e-rtl.e-contextmenu-wrapper .e-menu-item .e-caret:before{content:\"\\E937\"}\n\n/*! contextmenu layout */.e-contextmenu-container ul,.e-contextmenu-wrapper ul{font-weight:400;list-style-image:none;list-style-position:outside;list-style-type:none;margin:0;overflow:hidden;-webkit-user-select:none;-ms-user-select:none;user-select:none;font-size:14px;padding:0;border:none;border-radius:0;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);display:none;min-width:120px;position:absolute}.e-contextmenu-container ul.e-ul,.e-contextmenu-container ul.e-ul *,.e-contextmenu-wrapper ul.e-ul,.e-contextmenu-wrapper ul.e-ul *{box-sizing:border-box}.e-contextmenu-container ul.e-ul:focus,.e-contextmenu-container ul.e-ul :focus,.e-contextmenu-wrapper ul.e-ul:focus,.e-contextmenu-wrapper ul.e-ul :focus{outline:none}.e-contextmenu-container ul.e-contextmenu,.e-contextmenu-wrapper ul.e-contextmenu{box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.e-contextmenu-container ul.e-ul,.e-contextmenu-wrapper ul.e-ul{font-family:Roboto,Segoe UI,GeezaPro,DejaVu Serif,\"sans-serif\",-apple-system,BlinkMacSystemFont}.e-contextmenu-container ul .e-menu-item,.e-contextmenu-wrapper ul .e-menu-item{cursor:pointer;position:relative;height:36px;line-height:36px;padding:0 16px}.e-contextmenu-container ul .e-menu-item.e-menu-hide,.e-contextmenu-wrapper ul .e-menu-item.e-menu-hide{display:none}.e-contextmenu-container ul .e-menu-item.e-menu-header,.e-contextmenu-wrapper ul .e-menu-item.e-menu-header{border-bottom-style:solid;border-bottom-width:1px}.e-contextmenu-container ul .e-menu-item .e-menu-url,.e-contextmenu-wrapper ul .e-menu-item .e-menu-url{text-decoration:none}.e-contextmenu-container ul .e-menu-item .e-menu-icon,.e-contextmenu-wrapper ul .e-menu-item .e-menu-icon{display:inline-block;vertical-align:middle}.e-contextmenu-container ul .e-menu-item.e-separator,.e-contextmenu-wrapper ul .e-menu-item.e-separator{cursor:auto;line-height:normal;pointer-events:none}.e-contextmenu-container ul .e-menu-item .e-menu-url,.e-contextmenu-wrapper ul .e-menu-item .e-menu-url{display:inline-block;min-width:120px}.e-contextmenu-container ul .e-menu-item .e-menu-icon,.e-contextmenu-wrapper ul .e-menu-item .e-menu-icon{font-size:14px;line-height:36px;margin-right:10px;width:1em}.e-contextmenu-container ul .e-menu-item .e-caret,.e-contextmenu-wrapper ul .e-menu-item .e-caret{line-height:36px;margin-left:16px;margin-right:0;position:absolute;right:8px}.e-contextmenu-container ul .e-menu-item.e-menu-caret-icon,.e-contextmenu-wrapper ul .e-menu-item.e-menu-caret-icon{padding-right:36px}.e-contextmenu-container ul .e-menu-item.e-separator,.e-contextmenu-wrapper ul .e-menu-item.e-separator{border-bottom-style:solid;border-bottom-width:1px;height:auto;margin:8px 0}.e-contextmenu-container ul .e-menu-item .e-caret,.e-contextmenu-wrapper ul .e-menu-item .e-caret{font-size:11px}.e-contextmenu-container ul .e-menu-item .e-previous,.e-contextmenu-wrapper ul .e-menu-item .e-previous{margin-right:16px}.e-contextmenu-container ul .e-menu-item.e-disabled,.e-contextmenu-wrapper ul .e-menu-item.e-disabled{cursor:auto;pointer-events:none}.e-contextmenu-container ul .e-menu-item .e-checkbox-wrapper,.e-contextmenu-wrapper ul .e-menu-item .e-checkbox-wrapper{width:max-content}.e-contextmenu-container.e-sfcontextmenu,.e-contextmenu-container.e-sfcontextmenu .e-menu-vscroll,.e-contextmenu-wrapper.e-sfcontextmenu,.e-contextmenu-wrapper.e-sfcontextmenu .e-menu-vscroll{position:absolute}.e-contextmenu-container.e-sfcontextmenu ul,.e-contextmenu-wrapper.e-sfcontextmenu ul{white-space:nowrap}.e-contextmenu-container.e-sfcontextmenu ul.e-transparent,.e-contextmenu-wrapper.e-sfcontextmenu ul.e-transparent{background:transparent;border:0;box-shadow:none;height:1px;left:0;min-width:0;padding:0;top:0;width:0}.e-contextmenu-container.e-sfcontextmenu ul.e-transparent .e-menu-item,.e-contextmenu-wrapper.e-sfcontextmenu ul.e-transparent .e-menu-item{height:0;padding:0}.e-contextmenu-container.e-sfcontextmenu ul.e-transparent .e-menu-item.e-separator,.e-contextmenu-wrapper.e-sfcontextmenu ul.e-transparent .e-menu-item.e-separator{border:0;margin:0}.e-rtl.e-contextmenu-container .e-menu-item .e-menu-icon,.e-rtl.e-contextmenu-wrapper .e-menu-item .e-menu-icon{margin-right:0}.e-rtl.e-contextmenu-container .e-menu-item .e-caret,.e-rtl.e-contextmenu-wrapper .e-menu-item .e-caret{margin-left:0;margin-right:16px;right:auto}.e-rtl.e-contextmenu-container .e-menu-item .e-menu-icon,.e-rtl.e-contextmenu-wrapper .e-menu-item .e-menu-icon{margin-left:10px}.e-rtl.e-contextmenu-container .e-menu-item .e-caret,.e-rtl.e-contextmenu-wrapper .e-menu-item .e-caret{left:8px}.e-rtl.e-contextmenu-container .e-menu-item.e-menu-caret-icon,.e-rtl.e-contextmenu-wrapper .e-menu-item.e-menu-caret-icon{padding-left:36px;padding-right:16px}.e-rtl.e-contextmenu-container .e-menu-item.e-blankicon,.e-rtl.e-contextmenu-wrapper .e-menu-item.e-blankicon{padding-left:16px}.e-rtl.e-contextmenu-container .e-menu-item.e-blankicon.e-menu-caret-icon,.e-rtl.e-contextmenu-wrapper .e-menu-item.e-blankicon.e-menu-caret-icon{padding-left:36px}.e-bigger.e-contextmenu-container ul,.e-bigger .e-contextmenu-container ul,.e-bigger.e-contextmenu-wrapper ul,.e-bigger .e-contextmenu-wrapper ul{font-size:15px;padding:8px 0;white-space:nowrap;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);max-width:280px;min-width:112px}.e-bigger.e-contextmenu-container ul .e-menu-item,.e-bigger .e-contextmenu-container ul .e-menu-item,.e-bigger.e-contextmenu-wrapper ul .e-menu-item,.e-bigger .e-contextmenu-wrapper ul .e-menu-item{height:48px;line-height:48px}.e-bigger.e-contextmenu-container ul .e-menu-item .e-menu-icon,.e-bigger .e-contextmenu-container ul .e-menu-item .e-menu-icon,.e-bigger.e-contextmenu-wrapper ul .e-menu-item .e-menu-icon,.e-bigger .e-contextmenu-wrapper ul .e-menu-item .e-menu-icon{font-size:16px;line-height:48px}.e-bigger.e-contextmenu-container ul .e-menu-item .e-caret,.e-bigger .e-contextmenu-container ul .e-menu-item .e-caret,.e-bigger.e-contextmenu-wrapper ul .e-menu-item .e-caret,.e-bigger .e-contextmenu-wrapper ul .e-menu-item .e-caret{line-height:48px}.e-bigger.e-contextmenu-container ul .e-menu-item.e-separator,.e-bigger .e-contextmenu-container ul .e-menu-item.e-separator,.e-bigger.e-contextmenu-wrapper ul .e-menu-item.e-separator,.e-bigger .e-contextmenu-wrapper ul .e-menu-item.e-separator{height:auto;line-height:normal}.e-bigger.e-contextmenu-container ul .e-menu-item .e-caret,.e-bigger .e-contextmenu-container ul .e-menu-item .e-caret,.e-bigger.e-contextmenu-wrapper ul .e-menu-item .e-caret,.e-bigger .e-contextmenu-wrapper ul .e-menu-item .e-caret{font-size:12px}.e-bigger.e-contextmenu-container.e-rtl ul .e-blankicon,.e-bigger .e-contextmenu-container.e-rtl ul .e-blankicon,.e-bigger.e-contextmenu-wrapper.e-rtl ul .e-blankicon,.e-bigger .e-contextmenu-wrapper.e-rtl ul .e-blankicon{padding-left:16px}.e-bigger.e-contextmenu-container.e-rtl ul .e-blankicon.e-menu-caret-icon,.e-bigger .e-contextmenu-container.e-rtl ul .e-blankicon.e-menu-caret-icon,.e-bigger.e-contextmenu-wrapper.e-rtl ul .e-blankicon.e-menu-caret-icon,.e-bigger .e-contextmenu-wrapper.e-rtl ul .e-blankicon.e-menu-caret-icon{padding-left:36px}\n\n/*! contextmenu theme */.e-contextmenu-container ul,.e-contextmenu-wrapper ul{background-color:#fff;color:rgba(0,0,0,.87)}.e-contextmenu-container ul .e-menu-item.e-menu-header,.e-contextmenu-wrapper ul .e-menu-item.e-menu-header{border-bottom-color:rgba(0,0,0,.12)}.e-contextmenu-container ul .e-menu-item .e-caret,.e-contextmenu-container ul .e-menu-item .e-menu-icon,.e-contextmenu-wrapper ul .e-menu-item .e-caret,.e-contextmenu-wrapper ul .e-menu-item .e-menu-icon{color:rgba(0,0,0,.54)}.e-contextmenu-container ul .e-menu-item .e-menu-url,.e-contextmenu-wrapper ul .e-menu-item .e-menu-url{color:rgba(0,0,0,.87)}.e-contextmenu-container ul .e-menu-item.e-focused,.e-contextmenu-wrapper ul .e-menu-item.e-focused{background-color:#eee;color:rgba(0,0,0,.87);outline:0 solid rgba(0,0,0,.12);outline-offset:0}.e-contextmenu-container ul .e-menu-item.e-focused .e-caret,.e-contextmenu-container ul .e-menu-item.e-focused .e-menu-icon,.e-contextmenu-wrapper ul .e-menu-item.e-focused .e-caret,.e-contextmenu-wrapper ul .e-menu-item.e-focused .e-menu-icon{color:rgba(0,0,0,.54)}.e-contextmenu-container ul .e-menu-item.e-selected,.e-contextmenu-wrapper ul .e-menu-item.e-selected{background-color:#eee;color:rgba(0,0,0,.87);outline:0 solid #eee;outline-offset:0}.e-contextmenu-container ul .e-menu-item.e-selected .e-caret,.e-contextmenu-container ul .e-menu-item.e-selected .e-menu-icon,.e-contextmenu-wrapper ul .e-menu-item.e-selected .e-caret,.e-contextmenu-wrapper ul .e-menu-item.e-selected .e-menu-icon{color:rgba(0,0,0,.54)}.e-contextmenu-container ul .e-disabled,.e-contextmenu-wrapper ul .e-disabled{color:rgba(0,0,0,.38);opacity:1}.e-contextmenu-container ul .e-disabled .e-caret,.e-contextmenu-container ul .e-disabled .e-menu-icon,.e-contextmenu-container ul .e-disabled .e-menu-url,.e-contextmenu-wrapper ul .e-disabled .e-caret,.e-contextmenu-wrapper ul .e-disabled .e-menu-icon,.e-contextmenu-wrapper ul .e-disabled .e-menu-url{color:rgba(0,0,0,.38)}.e-contextmenu-container ul .e-separator,.e-contextmenu-wrapper ul .e-separator{border-bottom-color:rgba(0,0,0,.12)}\n\n/*! component's theme wise override definitions and variables */@keyframes tbar-popup-shadow{0%{border-color:hsla(0,0%,100%,.5);box-shadow:0 0 0 0 hsla(0,0%,100%,.5)}to{box-shadow:0 0 0 200px hsla(0,0%,100%,.12)}}\n/*! Material theme definition's */\n/*! component's theme wise override definitions and variables */\n/*! Horizontal Tab */@keyframes tbar-alt-popup-shadow{0%{border-color:rgba(0,0,0,.12);box-shadow:0 0 0 0 rgba(0,0,0,.12)}to{box-shadow:0 0 0 200px rgba(0,0,0,.12)}}@keyframes hscroll-alt-popup-shadow{0%{border-color:rgba(0,0,0,.12);box-shadow:0 0 0 0 rgba(0,0,0,.12)}to{box-shadow:0 0 0 200px rgba(0,0,0,.12)}}\n/*! Material specific themes definition's */\n/*! Vertical Tab */\n/*! tab icons */.e-tab .e-tab-header .e-toolbar-items.e-hscroll.e-rtl .e-nav-left-arrow:before{content:\"\\E913\"}.e-tab .e-tab-header .e-scroll-nav .e-nav-left-arrow:before,.e-tab .e-tab-header .e-toolbar-items.e-hscroll.e-rtl .e-nav-right-arrow:before{content:\"\\E904\"}.e-tab .e-tab-header .e-scroll-nav .e-nav-right-arrow:before{content:\"\\E913\"}.e-tab .e-tab-header .e-close-icon:before{content:\"\\E7FC\";position:relative}.e-tab .e-tab-header .e-popup-up-icon:before{content:\"\\E916\"}@media screen and (max-width:480px){.e-tab .e-tab-header .e-popup-up-icon:before{content:\"\\E984\"}}.e-tab .e-tab-header .e-popup-down-icon:before{content:\"\\E916\"}@media screen and (max-width:480px){.e-tab .e-tab-header .e-popup-down-icon:before{content:\"\\E984\"}}@media screen and (max-width:480px){.e-tab.e-vertical-icon .e-tab-header .e-popup-up-icon:before{content:\"\\E82A\"}.e-tab.e-vertical-icon .e-tab-header .e-popup-down-icon:before{content:\"\\E83D\"}}.e-tab.e-vertical-tab .e-tab-header .e-scroll-nav .e-nav-up-arrow:before{content:\"\\E910\"}.e-tab.e-vertical-tab .e-tab-header .e-scroll-nav .e-nav-down-arrow:before{content:\"\\E916\"}.e-tab.e-vertical-tab .e-tab-header .e-popup-up-icon:before{content:\"More\"}.e-tab.e-vertical-tab .e-tab-header .e-popup-up-icon:after{content:\"\\E919\"}.e-tab.e-vertical-tab .e-tab-header .e-popup-down-icon:before{content:\"More\"}.e-tab.e-vertical-tab .e-tab-header .e-popup-down-icon:after{content:\"\\E919\"}.e-tab.e-vertical-tab.e-icon-tab .e-tab-header .e-popup-up-icon:before{content:\"\"}.e-tab.e-vertical-tab.e-icon-tab .e-tab-header .e-popup-up-icon:after{content:\"\\EBB9\"}.e-tab.e-vertical-tab.e-icon-tab .e-tab-header .e-popup-down-icon:before{content:\"\"}.e-tab.e-vertical-tab.e-icon-tab .e-tab-header .e-popup-down-icon:after{content:\"\\EBB9\"}.e-tab-clone-element .e-close-icon:before{content:\"\\E7FC\";position:relative}\n\n/*! tab layout */.e-bigger .e-tab .e-tab-header,.e-tab.e-bigger .e-tab-header{height:48px;min-height:48px}.e-bigger .e-tab .e-tab-header .e-toolbar-items,.e-tab.e-bigger .e-tab-header .e-toolbar-items{height:auto;min-height:auto}.e-bigger .e-tab .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-bigger .e-tab .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child,.e-tab.e-bigger .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-tab.e-bigger .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-bigger .e-tab .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child,.e-tab.e-bigger .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-tab.e-bigger .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0}}.e-bigger .e-tab .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child,.e-tab.e-bigger .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{padding-bottom:0}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child,.e-tab.e-bigger .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0}}.e-bigger .e-tab .e-tab-header .e-toolbar-items.e-hscroll:not(.e-tbar-pos) .e-toolbar-item:last-child,.e-tab.e-bigger .e-tab-header .e-toolbar-items.e-hscroll:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-toolbar-items.e-hscroll:not(.e-tbar-pos) .e-toolbar-item:last-child,.e-tab.e-bigger .e-tab-header .e-toolbar-items.e-hscroll:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0}}.e-bigger .e-tab .e-tab-header .e-toolbar-items.e-hscroll:not(.e-tbar-pos) .e-toolbar-item:last-child.e-active,.e-tab.e-bigger .e-tab-header .e-toolbar-items.e-hscroll:not(.e-tbar-pos) .e-toolbar-item:last-child.e-active{margin:0}.e-bigger .e-tab .e-tab-header .e-toolbar-items.e-hscroll .e-scroll-nav,.e-tab.e-bigger .e-tab-header .e-toolbar-items.e-hscroll .e-scroll-nav{width:50px}.e-bigger .e-tab .e-tab-header .e-toolbar-item:not(.e-separator),.e-tab.e-bigger .e-tab-header .e-toolbar-item:not(.e-separator){height:48px;margin:0;min-height:48px;min-width:auto;padding:0}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-toolbar-item:not(.e-separator),.e-tab.e-bigger .e-tab-header .e-toolbar-item:not(.e-separator){margin:0}}.e-bigger .e-tab .e-tab-header .e-toolbar-item:not(.e-separator).e-ibottom,.e-bigger .e-tab .e-tab-header .e-toolbar-item:not(.e-separator).e-itop,.e-tab.e-bigger .e-tab-header .e-toolbar-item:not(.e-separator).e-ibottom,.e-tab.e-bigger .e-tab-header .e-toolbar-item:not(.e-separator).e-itop{height:72px;min-height:72px}.e-bigger .e-tab .e-tab-header .e-toolbar-item .e-tab-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-item .e-tab-wrap{height:48px;padding:0 24px}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-toolbar-item .e-tab-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-item .e-tab-wrap{padding:0 12px}}.e-bigger .e-tab .e-tab-header .e-toolbar-item .e-text-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-item .e-text-wrap{height:48px}.e-bigger .e-tab .e-tab-header .e-toolbar-item .e-tab-text,.e-tab.e-bigger .e-tab-header .e-toolbar-item .e-tab-text{font-size:14px}.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-active,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-active{margin:0;padding-bottom:0}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-active,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-active{margin:0}}.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-active .e-text-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-active .e-text-wrap{height:48px;margin-top:0}.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-active.e-ileft .e-text-wrap,.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-active.e-iright .e-text-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-active.e-ileft .e-text-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-active.e-iright .e-text-wrap{height:48px}.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-active.e-ileft .e-text-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-active.e-ileft .e-text-wrap{padding:0}.e-bigger .e-tab .e-tab-header .e-toolbar-item .e-icons.e-close-icon,.e-tab.e-bigger .e-tab-header .e-toolbar-item .e-icons.e-close-icon{cursor:pointer;margin:0 0 0 12px}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-toolbar-item .e-icons.e-close-icon,.e-tab.e-bigger .e-tab-header .e-toolbar-item .e-icons.e-close-icon{margin:0 0 0 14px}}.e-bigger .e-tab .e-tab-header .e-toolbar-item .e-close-icon:before,.e-bigger .e-tab .e-tab-header .e-toolbar-item .e-icons.e-close-icon,.e-tab.e-bigger .e-tab-header .e-toolbar-item .e-close-icon:before,.e-tab.e-bigger .e-tab-header .e-toolbar-item .e-icons.e-close-icon{font-size:10px}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-toolbar-item .e-close-icon:before,.e-bigger .e-tab .e-tab-header .e-toolbar-item .e-icons.e-close-icon,.e-tab.e-bigger .e-tab-header .e-toolbar-item .e-close-icon:before,.e-tab.e-bigger .e-tab-header .e-toolbar-item .e-icons.e-close-icon{font-size:12px}}.e-bigger .e-tab .e-tab-header .e-toolbar-item .e-icons.e-tab-icon,.e-tab.e-bigger .e-tab-header .e-toolbar-item .e-icons.e-tab-icon{height:24px;min-width:24px;width:24px}.e-bigger .e-tab .e-tab-header .e-toolbar-item .e-tab-icon,.e-bigger .e-tab .e-tab-header .e-toolbar-item .e-tab-icon:before,.e-tab.e-bigger .e-tab-header .e-toolbar-item .e-tab-icon,.e-tab.e-bigger .e-tab-header .e-toolbar-item .e-tab-icon:before{font-size:20px}.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-icon .e-tab-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-icon .e-tab-wrap{padding:0 24px}.e-bigger .e-tab .e-tab-header .e-toolbar-item .e-icon-left+.e-tab-text,.e-tab.e-bigger .e-tab-header .e-toolbar-item .e-icon-left+.e-tab-text{margin:0 0 0 12px}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-toolbar-item .e-icon-left+.e-tab-text,.e-tab.e-bigger .e-tab-header .e-toolbar-item .e-icon-left+.e-tab-text{margin:0 0 0 14px}}.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-ibottom,.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap,.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-itop,.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-ibottom,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-itop,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap{height:72px}.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus .e-text-wrap{height:auto}.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-ibottom.e-active .e-tab-wrap,.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-itop.e-active .e-tab-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-ibottom.e-active .e-tab-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-itop.e-active .e-tab-wrap{height:72px}.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-ibottom.e-active .e-tab-wrap:focus .e-text-wrap,.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-itop.e-active .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-ibottom.e-active .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-itop.e-active .e-tab-wrap:focus .e-text-wrap{height:auto}.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-ibottom .e-close-icon,.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-itop .e-close-icon,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-ibottom .e-close-icon,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-itop .e-close-icon{right:24px}.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-itop .e-tab-text,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-itop .e-tab-text{margin:10px 0 0}.e-bigger .e-tab .e-tab-header .e-toolbar-item.e-ibottom .e-tab-text,.e-tab.e-bigger .e-tab-header .e-toolbar-item.e-ibottom .e-tab-text{margin:0 0 10px}.e-bigger .e-tab .e-tab-header.e-close-show .e-toolbar-item.e-ibottom .e-text-wrap,.e-bigger .e-tab .e-tab-header.e-close-show .e-toolbar-item.e-itop .e-text-wrap,.e-tab.e-bigger .e-tab-header.e-close-show .e-toolbar-item.e-ibottom .e-text-wrap,.e-tab.e-bigger .e-tab-header.e-close-show .e-toolbar-item.e-itop .e-text-wrap{margin-right:22px}.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item{height:48px;min-height:48px}.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap{height:48px;padding:0 16px}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap{padding:0 16px}}.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-text-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item .e-text-wrap{height:48px}.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-text+.e-close-icon[style=\"display:block\"],.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-text+.e-close-icon[style=\"display:block\"]{padding-right:12px}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-text+.e-close-icon[style=\"display:block\"],.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-text+.e-close-icon[style=\"display:block\"]{padding-right:0}}.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-close-icon,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item .e-close-icon{margin:0}.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-close-icon:before,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item .e-close-icon:before{top:0}.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-close-icon,.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-close-icon,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-close-icon,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-close-icon{right:18px}.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom:not(.e-separator),.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop:not(.e-separator),.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom:not(.e-separator),.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop:not(.e-separator){min-height:48px}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom:not(.e-separator),.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop:not(.e-separator),.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom:not(.e-separator),.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop:not(.e-separator){min-height:48px}}.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom,.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-wrap,.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop,.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-wrap{height:48px}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom,.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-wrap,.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop,.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-wrap,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-wrap{height:48px}}.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-text,.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-text,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-text,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-text{margin:0;padding-left:0;padding-right:12px}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-text,.e-bigger .e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-text,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-text,.e-tab.e-bigger .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-text{margin:0;padding-left:0;padding-right:0}}.e-bigger .e-tab .e-tab-header .e-scroll-nav,.e-tab.e-bigger .e-tab-header .e-scroll-nav{height:48px;min-height:48px;padding:0 12px}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-scroll-nav,.e-tab.e-bigger .e-tab-header .e-scroll-nav{padding:0 12px}}.e-bigger .e-tab .e-tab-header .e-scroll-nav.e-scroll-left-nav,.e-bigger .e-tab .e-tab-header .e-scroll-nav.e-scroll-right-nav,.e-tab.e-bigger .e-tab-header .e-scroll-nav.e-scroll-left-nav,.e-tab.e-bigger .e-tab-header .e-scroll-nav.e-scroll-right-nav{padding:0 12px}.e-bigger .e-tab .e-tab-header .e-scroll-nav .e-nav-arrow,.e-tab.e-bigger .e-tab-header .e-scroll-nav .e-nav-arrow{font-size:12px;height:24px;line-height:24px;width:24px}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-scroll-nav .e-nav-arrow,.e-tab.e-bigger .e-tab-header .e-scroll-nav .e-nav-arrow{font-size:12px;height:24px;line-height:24px;width:24px}}.e-bigger .e-tab .e-tab-header .e-scroll-nav .e-nav-left-arrow:before,.e-bigger .e-tab .e-tab-header .e-scroll-nav .e-nav-right-arrow:before,.e-tab.e-bigger .e-tab-header .e-scroll-nav .e-nav-left-arrow:before,.e-tab.e-bigger .e-tab-header .e-scroll-nav .e-nav-right-arrow:before{font-size:12px;line-height:24px;top:0;vertical-align:initial}.e-bigger .e-tab .e-tab-header .e-hor-nav,.e-tab.e-bigger .e-tab-header .e-hor-nav{height:48px;min-height:48px;padding:0 12px}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-hor-nav,.e-tab.e-bigger .e-tab-header .e-hor-nav{padding:0 12px}}.e-bigger .e-tab .e-tab-header .e-hor-nav .e-popup-down-icon,.e-bigger .e-tab .e-tab-header .e-hor-nav .e-popup-up-icon,.e-tab.e-bigger .e-tab-header .e-hor-nav .e-popup-down-icon,.e-tab.e-bigger .e-tab-header .e-hor-nav .e-popup-up-icon{font-size:12px;height:24px;line-height:24px;width:24px}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-hor-nav .e-popup-down-icon,.e-bigger .e-tab .e-tab-header .e-hor-nav .e-popup-up-icon,.e-tab.e-bigger .e-tab-header .e-hor-nav .e-popup-down-icon,.e-tab.e-bigger .e-tab-header .e-hor-nav .e-popup-up-icon{font-size:12px;height:24px;line-height:24px;width:24px}}.e-bigger .e-tab .e-tab-header .e-hor-nav .e-popup-down-icon:before,.e-bigger .e-tab .e-tab-header .e-hor-nav .e-popup-up-icon:before,.e-tab.e-bigger .e-tab-header .e-hor-nav .e-popup-down-icon:before,.e-tab.e-bigger .e-tab-header .e-hor-nav .e-popup-up-icon:before{font-size:12px;line-height:24px;top:0;vertical-align:initial}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header .e-hor-nav .e-popup-down-icon:before,.e-bigger .e-tab .e-tab-header .e-hor-nav .e-popup-up-icon:before,.e-tab.e-bigger .e-tab-header .e-hor-nav .e-popup-down-icon:before,.e-tab.e-bigger .e-tab-header .e-hor-nav .e-popup-up-icon:before{font-size:16px}}.e-bigger .e-tab .e-tab-header .e-hor-nav .e-popup-down-icon:hover:before,.e-bigger .e-tab .e-tab-header .e-hor-nav .e-popup-up-icon:hover:before,.e-bigger .e-tab .e-tab-header .e-hor-nav:focus .e-popup-down-icon:before,.e-bigger .e-tab .e-tab-header .e-hor-nav:focus .e-popup-up-icon:before,.e-tab.e-bigger .e-tab-header .e-hor-nav .e-popup-down-icon:hover:before,.e-tab.e-bigger .e-tab-header .e-hor-nav .e-popup-up-icon:hover:before,.e-tab.e-bigger .e-tab-header .e-hor-nav:focus .e-popup-down-icon:before,.e-tab.e-bigger .e-tab-header .e-hor-nav:focus .e-popup-up-icon:before{top:0}.e-bigger .e-tab .e-tab-header .e-hor-nav.e-ie-align .e-nav-left-arrow,.e-bigger .e-tab .e-tab-header .e-hor-nav.e-ie-align .e-nav-right-arrow,.e-bigger .e-tab .e-tab-header .e-hor-nav.e-ie-align .e-popup-down-icon,.e-bigger .e-tab .e-tab-header .e-hor-nav.e-ie-align .e-popup-up-icon,.e-bigger .e-tab .e-tab-header .e-scroll-nav.e-ie-align .e-nav-left-arrow,.e-bigger .e-tab .e-tab-header .e-scroll-nav.e-ie-align .e-nav-right-arrow,.e-bigger .e-tab .e-tab-header .e-scroll-nav.e-ie-align .e-popup-down-icon,.e-bigger .e-tab .e-tab-header .e-scroll-nav.e-ie-align .e-popup-up-icon,.e-tab.e-bigger .e-tab-header .e-hor-nav.e-ie-align .e-nav-left-arrow,.e-tab.e-bigger .e-tab-header .e-hor-nav.e-ie-align .e-nav-right-arrow,.e-tab.e-bigger .e-tab-header .e-hor-nav.e-ie-align .e-popup-down-icon,.e-tab.e-bigger .e-tab-header .e-hor-nav.e-ie-align .e-popup-up-icon,.e-tab.e-bigger .e-tab-header .e-scroll-nav.e-ie-align .e-nav-left-arrow,.e-tab.e-bigger .e-tab-header .e-scroll-nav.e-ie-align .e-nav-right-arrow,.e-tab.e-bigger .e-tab-header .e-scroll-nav.e-ie-align .e-popup-down-icon,.e-tab.e-bigger .e-tab-header .e-scroll-nav.e-ie-align .e-popup-up-icon{line-height:15px}.e-bigger .e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child.e-active,.e-tab.e-bigger .e-tab-header.e-horizontal-bottom .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child.e-active{margin:0}.e-bigger .e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active,.e-tab.e-bigger .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active{margin:0;padding-bottom:0}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active,.e-tab.e-bigger .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active{margin:0}}.e-bigger .e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active .e-tab-text,.e-tab.e-bigger .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active .e-tab-text{padding-top:0}.e-bigger .e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active:last-child,.e-tab.e-bigger .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active:last-child{margin:0;padding-bottom:0}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active:last-child,.e-tab.e-bigger .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active:last-child{margin:0}}.e-bigger .e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-ibottom,.e-bigger .e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-itop,.e-tab.e-bigger .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-ibottom,.e-tab.e-bigger .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-itop{padding-bottom:0;padding-top:0}.e-bigger .e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-ileft.e-active .e-text-wrap,.e-tab.e-bigger .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-ileft.e-active .e-text-wrap{margin:0}.e-bigger .e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active .e-text-wrap,.e-tab.e-bigger .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active .e-text-wrap{height:48px;padding:0}.e-bigger .e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active.e-ibottom .e-text-wrap,.e-bigger .e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active.e-itop .e-text-wrap,.e-tab.e-bigger .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active.e-ibottom .e-text-wrap,.e-tab.e-bigger .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active.e-itop .e-text-wrap{height:48px}.e-bigger .e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-ibottom.e-active .e-text-wrap,.e-bigger .e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-itop.e-active .e-text-wrap,.e-tab.e-bigger .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-ibottom.e-active .e-text-wrap,.e-tab.e-bigger .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-itop.e-active .e-text-wrap{height:auto}.e-bigger .e-tab .e-tab-header.e-vertical,.e-tab.e-bigger .e-tab-header.e-vertical{max-width:150px}.e-bigger .e-tab .e-tab-header.e-vertical[style*=\"overflow: hidden\"]:before,.e-tab.e-bigger .e-tab-header.e-vertical[style*=\"overflow: hidden\"]:before{bottom:23px;top:23px}@media screen and (max-width:480px){.e-bigger .e-tab .e-tab-header.e-vertical[style*=\"overflow: hidden\"]:before,.e-tab.e-bigger .e-tab-header.e-vertical[style*=\"overflow: hidden\"]:before{bottom:0;top:0}}.e-bigger .e-tab .e-tab-header.e-vertical .e-toolbar-items,.e-tab.e-bigger .e-tab-header.e-vertical .e-toolbar-items{height:inherit}.e-bigger .e-tab .e-tab-header.e-vertical .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child,.e-tab.e-bigger .e-tab-header.e-vertical .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0}.e-bigger .e-tab .e-tab-header.e-vertical .e-toolbar-items.e-vscroll:not(.e-scroll-device),.e-tab.e-bigger .e-tab-header.e-vertical .e-toolbar-items.e-vscroll:not(.e-scroll-device){padding:24px 0}.e-bigger .e-tab .e-tab-header.e-vertical .e-toolbar-item .e-tab-wrap,.e-tab.e-bigger .e-tab-header.e-vertical .e-toolbar-item .e-tab-wrap{padding:0 24px}.e-bigger .e-tab .e-tab-header.e-vertical .e-toolbar-item.e-ibottom .e-close-icon,.e-bigger .e-tab .e-tab-header.e-vertical .e-toolbar-item.e-itop .e-close-icon,.e-tab.e-bigger .e-tab-header.e-vertical .e-toolbar-item.e-ibottom .e-close-icon,.e-tab.e-bigger .e-tab-header.e-vertical .e-toolbar-item.e-itop .e-close-icon{right:-24px}.e-bigger .e-tab .e-tab-header.e-vertical .e-scroll-nav,.e-tab.e-bigger .e-tab-header.e-vertical .e-scroll-nav{height:24px;min-height:24px}.e-bigger .e-tab .e-tab-header.e-vertical .e-scroll-nav .e-nav-arrow,.e-tab.e-bigger .e-tab-header.e-vertical .e-scroll-nav .e-nav-arrow{font-size:12px;height:24px;line-height:24px;width:24px}.e-bigger .e-tab .e-tab-header.e-vertical .e-hor-nav,.e-tab.e-bigger .e-tab-header.e-vertical .e-hor-nav{padding:0 24px}.e-bigger .e-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-down-icon:before,.e-bigger .e-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-up-icon:before,.e-tab.e-bigger .e-tab-header.e-vertical .e-hor-nav .e-popup-down-icon:before,.e-tab.e-bigger .e-tab-header.e-vertical .e-hor-nav .e-popup-up-icon:before{line-height:46px}.e-bigger .e-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-down-icon:after,.e-bigger .e-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-up-icon:after,.e-tab.e-bigger .e-tab-header.e-vertical .e-hor-nav .e-popup-down-icon:after,.e-tab.e-bigger .e-tab-header.e-vertical .e-hor-nav .e-popup-up-icon:after{font-size:14px;line-height:46px;margin:0 0 0 10px}.e-bigger .e-tab .e-tab-header.e-vertical.e-toolpop .e-toolbar-items,.e-tab.e-bigger .e-tab-header.e-vertical.e-toolpop .e-toolbar-items{height:auto}.e-bigger .e-tab.e-vertical-icon .e-tab-header,.e-tab.e-bigger.e-vertical-icon .e-tab-header{height:72px;min-height:72px}.e-bigger .e-tab.e-vertical-icon .e-tab-header .e-hor-nav,.e-bigger .e-tab.e-vertical-icon .e-tab-header .e-scroll-nav,.e-bigger .e-tab.e-vertical-icon .e-tab-header .e-toolbar-items,.e-tab.e-bigger.e-vertical-icon .e-tab-header .e-hor-nav,.e-tab.e-bigger.e-vertical-icon .e-tab-header .e-scroll-nav,.e-tab.e-bigger.e-vertical-icon .e-tab-header .e-toolbar-items{height:72px}@media screen and (max-width:480px){.e-bigger .e-tab.e-vertical-icon .e-tab-header .e-hor-nav .e-popup-down-icon:before,.e-bigger .e-tab.e-vertical-icon .e-tab-header .e-hor-nav .e-popup-up-icon:before,.e-tab.e-bigger.e-vertical-icon .e-tab-header .e-hor-nav .e-popup-down-icon:before,.e-tab.e-bigger.e-vertical-icon .e-tab-header .e-hor-nav .e-popup-up-icon:before{font-size:12px}}.e-bigger .e-tab.e-vertical-icon.e-vertical-tab .e-tab-header.e-vertical .e-toolbar-items,.e-tab.e-bigger.e-vertical-icon.e-vertical-tab .e-tab-header.e-vertical .e-toolbar-items{height:inherit}.e-bigger .e-tab.e-vertical-icon.e-vertical-tab .e-tab-header.e-vertical .e-scroll-nav,.e-tab.e-bigger.e-vertical-icon.e-vertical-tab .e-tab-header.e-vertical .e-scroll-nav{height:24px}.e-bigger .e-tab.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus,.e-bigger .e-tab.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus,.e-tab.e-bigger.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-text-wrap{height:48px}.e-bigger .e-tab.e-focused .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus,.e-bigger .e-tab.e-focused .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus,.e-tab.e-bigger.e-focused .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus,.e-tab.e-bigger.e-focused .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus{height:72px}.e-bigger .e-tab.e-focused .e-tab-header .e-toolbar-item.e-ibottom.e-active .e-tab-wrap:focus .e-text-wrap,.e-bigger .e-tab.e-focused .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-bigger .e-tab.e-focused .e-tab-header .e-toolbar-item.e-itop.e-active .e-tab-wrap:focus .e-text-wrap,.e-bigger .e-tab.e-focused .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger.e-focused .e-tab-header .e-toolbar-item.e-ibottom.e-active .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger.e-focused .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger.e-focused .e-tab-header .e-toolbar-item.e-itop.e-active .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger.e-focused .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus .e-text-wrap{height:auto}.e-bigger .e-tab.e-focused .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-wrap:focus,.e-bigger .e-tab.e-focused .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-wrap:focus,.e-bigger .e-tab.e-focused .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap:focus,.e-bigger .e-tab.e-focused .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger.e-focused .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-wrap:focus,.e-tab.e-bigger.e-focused .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-wrap:focus,.e-tab.e-bigger.e-focused .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap:focus,.e-tab.e-bigger.e-focused .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap:focus .e-text-wrap{height:48px}.e-bigger .e-tab.e-focused .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger.e-focused .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active .e-tab-wrap:focus .e-text-wrap{height:48px;padding:0}.e-bigger .e-tab.e-edge .e-tab-header .e-hor-nav.e-ie-align .e-popup-down-icon,.e-bigger .e-tab.e-edge .e-tab-header .e-hor-nav.e-ie-align .e-popup-up-icon,.e-bigger .e-tab.e-edge .e-tab-header .e-scroll-nav.e-ie-align .e-popup-down-icon,.e-bigger .e-tab.e-edge .e-tab-header .e-scroll-nav.e-ie-align .e-popup-up-icon,.e-bigger .e-tab.e-ie .e-tab-header .e-hor-nav.e-ie-align .e-nav-left-arrow,.e-bigger .e-tab.e-ie .e-tab-header .e-hor-nav.e-ie-align .e-nav-right-arrow,.e-bigger .e-tab.e-ie .e-tab-header .e-hor-nav.e-ie-align .e-popup-down-icon,.e-bigger .e-tab.e-ie .e-tab-header .e-hor-nav.e-ie-align .e-popup-up-icon,.e-bigger .e-tab.e-ie .e-tab-header .e-scroll-nav.e-ie-align .e-nav-left-arrow,.e-bigger .e-tab.e-ie .e-tab-header .e-scroll-nav.e-ie-align .e-nav-right-arrow,.e-bigger .e-tab.e-ie .e-tab-header .e-scroll-nav.e-ie-align .e-popup-down-icon,.e-bigger .e-tab.e-ie .e-tab-header .e-scroll-nav.e-ie-align .e-popup-up-icon,.e-tab.e-bigger.e-edge .e-tab-header .e-hor-nav.e-ie-align .e-popup-down-icon,.e-tab.e-bigger.e-edge .e-tab-header .e-hor-nav.e-ie-align .e-popup-up-icon,.e-tab.e-bigger.e-edge .e-tab-header .e-scroll-nav.e-ie-align .e-popup-down-icon,.e-tab.e-bigger.e-edge .e-tab-header .e-scroll-nav.e-ie-align .e-popup-up-icon,.e-tab.e-bigger.e-ie .e-tab-header .e-hor-nav.e-ie-align .e-nav-left-arrow,.e-tab.e-bigger.e-ie .e-tab-header .e-hor-nav.e-ie-align .e-nav-right-arrow,.e-tab.e-bigger.e-ie .e-tab-header .e-hor-nav.e-ie-align .e-popup-down-icon,.e-tab.e-bigger.e-ie .e-tab-header .e-hor-nav.e-ie-align .e-popup-up-icon,.e-tab.e-bigger.e-ie .e-tab-header .e-scroll-nav.e-ie-align .e-nav-left-arrow,.e-tab.e-bigger.e-ie .e-tab-header .e-scroll-nav.e-ie-align .e-nav-right-arrow,.e-tab.e-bigger.e-ie .e-tab-header .e-scroll-nav.e-ie-align .e-popup-down-icon,.e-tab.e-bigger.e-ie .e-tab-header .e-scroll-nav.e-ie-align .e-popup-up-icon{line-height:15px}.e-bigger .e-tab.e-edge .e-tab-header .e-hor-nav.e-ie-align .e-nav-left-arrow,.e-bigger .e-tab.e-edge .e-tab-header .e-hor-nav.e-ie-align .e-nav-right-arrow,.e-bigger .e-tab.e-edge .e-tab-header .e-scroll-nav.e-ie-align .e-nav-left-arrow,.e-bigger .e-tab.e-edge .e-tab-header .e-scroll-nav.e-ie-align .e-nav-right-arrow,.e-tab.e-bigger.e-edge .e-tab-header .e-hor-nav.e-ie-align .e-nav-left-arrow,.e-tab.e-bigger.e-edge .e-tab-header .e-hor-nav.e-ie-align .e-nav-right-arrow,.e-tab.e-bigger.e-edge .e-tab-header .e-scroll-nav.e-ie-align .e-nav-left-arrow,.e-tab.e-bigger.e-edge .e-tab-header .e-scroll-nav.e-ie-align .e-nav-right-arrow{line-height:13px}.e-bigger .e-tab.e-safari .e-tab-header .e-close-icon:before,.e-bigger .e-tab.e-safari .e-tab-header .e-hor-nav .e-nav-left-arrow:before,.e-bigger .e-tab.e-safari .e-tab-header .e-hor-nav .e-nav-right-arrow:before,.e-bigger .e-tab.e-safari .e-tab-header .e-hor-nav .e-popup-down-icon:before,.e-bigger .e-tab.e-safari .e-tab-header .e-hor-nav .e-popup-up-icon:before,.e-bigger .e-tab.e-safari .e-tab-header .e-scroll-nav .e-nav-left-arrow:before,.e-bigger .e-tab.e-safari .e-tab-header .e-scroll-nav .e-nav-right-arrow:before,.e-bigger .e-tab.e-safari .e-tab-header .e-scroll-nav .e-popup-down-icon:before,.e-bigger .e-tab.e-safari .e-tab-header .e-scroll-nav .e-popup-up-icon:before,.e-tab.e-bigger.e-safari .e-tab-header .e-close-icon:before,.e-tab.e-bigger.e-safari .e-tab-header .e-hor-nav .e-nav-left-arrow:before,.e-tab.e-bigger.e-safari .e-tab-header .e-hor-nav .e-nav-right-arrow:before,.e-tab.e-bigger.e-safari .e-tab-header .e-hor-nav .e-popup-down-icon:before,.e-tab.e-bigger.e-safari .e-tab-header .e-hor-nav .e-popup-up-icon:before,.e-tab.e-bigger.e-safari .e-tab-header .e-scroll-nav .e-nav-left-arrow:before,.e-tab.e-bigger.e-safari .e-tab-header .e-scroll-nav .e-nav-right-arrow:before,.e-tab.e-bigger.e-safari .e-tab-header .e-scroll-nav .e-popup-down-icon:before,.e-tab.e-bigger.e-safari .e-tab-header .e-scroll-nav .e-popup-up-icon:before{top:0}.e-bigger .e-tab.e-fill .e-tab-header,.e-tab.e-bigger.e-fill .e-tab-header{height:46px;min-height:46px}@media screen and (max-width:480px){.e-bigger .e-tab.e-fill .e-tab-header,.e-tab.e-bigger.e-fill .e-tab-header{height:46px;min-height:46px}}.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-items,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-items{height:auto;min-height:46px}@media screen and (max-width:480px){.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-items,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-items{min-height:46px}}.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0;padding:0}.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item:not(.e-separator),.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item:not(.e-separator){height:46px;margin:0;min-height:46px}@media screen and (max-width:480px){.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item:not(.e-separator),.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item:not(.e-separator){height:46px;min-height:46px}}.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item:not(.e-separator).e-ibottom,.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item:not(.e-separator).e-itop,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item:not(.e-separator).e-ibottom,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item:not(.e-separator).e-itop{height:70px;min-height:70px}.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item .e-tab-wrap,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item .e-tab-wrap{height:46px;padding:0 24px}@media screen and (max-width:480px){.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item .e-tab-wrap,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item .e-tab-wrap{height:46px;padding:0 24px}}.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item .e-text-wrap,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item .e-text-wrap{height:46px}@media screen and (max-width:480px){.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item .e-text-wrap,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item .e-text-wrap{height:46px}}.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item.e-active,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item.e-active{padding:0}.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item.e-active .e-tab-wrap,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item.e-active .e-tab-wrap{margin-bottom:0}.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item.e-active .e-text-wrap,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item.e-active .e-text-wrap{height:46px}@media screen and (max-width:480px){.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item.e-active .e-text-wrap,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item.e-active .e-text-wrap{height:46px}}.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item.e-active.e-ileft .e-text-wrap,.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item.e-active.e-iright .e-text-wrap,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item.e-active.e-ileft .e-text-wrap,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item.e-active.e-iright .e-text-wrap{height:46px}@media screen and (max-width:480px){.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item.e-active.e-ileft .e-text-wrap,.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item.e-active.e-iright .e-text-wrap,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item.e-active.e-ileft .e-text-wrap,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item.e-active.e-iright .e-text-wrap{height:46px}}.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap,.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap,.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap{height:70px}.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom:not(.e-separator),.e-bigger .e-tab.e-fill .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop:not(.e-separator),.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom:not(.e-separator),.e-tab.e-bigger.e-fill .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop:not(.e-separator){height:auto}.e-bigger .e-tab.e-fill .e-tab-header.e-vertical .e-toolbar-items .e-toolbar-item .e-tab-wrap,.e-tab.e-bigger.e-fill .e-tab-header.e-vertical .e-toolbar-items .e-toolbar-item .e-tab-wrap{padding:0 24px}.e-bigger .e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active .e-text-wrap,.e-tab.e-bigger.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active .e-text-wrap{height:46px}.e-bigger .e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-ibottom .e-text-wrap,.e-bigger .e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-itop .e-text-wrap,.e-tab.e-bigger.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-ibottom .e-text-wrap,.e-tab.e-bigger.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-itop .e-text-wrap{height:auto}.e-bigger .e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-bigger .e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-itop .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-itop .e-tab-wrap:focus .e-text-wrap{height:50px}.e-bigger .e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus,.e-bigger .e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger.e-fill.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus,.e-tab.e-bigger.e-fill.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-text-wrap{height:46px}.e-bigger .e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus,.e-bigger .e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus,.e-tab.e-bigger.e-fill.e-focused .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus,.e-tab.e-bigger.e-fill.e-focused .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus{height:70px}.e-bigger .e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-bigger .e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger.e-fill.e-focused .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger.e-fill.e-focused .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus .e-text-wrap{height:auto}@media screen and (max-width:480px){.e-bigger .e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-bigger .e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger.e-fill.e-focused .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-tab.e-bigger.e-fill.e-focused .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus .e-text-wrap{height:auto}}.e-bigger .e-tab.e-fill.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator),.e-tab.e-bigger.e-fill.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator){margin:0}.e-bigger .e-tab.e-fill.e-vertical-icon .e-tab-header,.e-tab.e-bigger.e-fill.e-vertical-icon .e-tab-header{height:70px;min-height:70px}.e-bigger .e-tab.e-background .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-bigger .e-tab.e-background .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child,.e-tab.e-bigger.e-background .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-tab.e-bigger.e-background .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0;padding:0}.e-bigger .e-tab.e-background .e-tab-header .e-toolbar-item:not(.e-separator),.e-tab.e-bigger.e-background .e-tab-header .e-toolbar-item:not(.e-separator){margin:0}.e-bigger .e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap,.e-tab.e-bigger.e-background .e-tab-header .e-toolbar-item .e-tab-wrap{padding:0 24px}@media screen and (max-width:480px){.e-bigger .e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap,.e-tab.e-bigger.e-background .e-tab-header .e-toolbar-item .e-tab-wrap{padding:0 24px}}.e-bigger .e-tab.e-background .e-tab-header .e-toolbar-item.e-active,.e-tab.e-bigger.e-background .e-tab-header .e-toolbar-item.e-active{padding:0}.e-bigger .e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap,.e-tab.e-bigger.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap{margin-bottom:0}.e-bigger .e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-text-wrap,.e-tab.e-bigger.e-background .e-tab-header .e-toolbar-item.e-active .e-text-wrap{height:48px}.e-bigger .e-tab.e-background .e-tab-header.e-vertical .e-toolbar-items .e-toolbar-item .e-tab-wrap,.e-tab.e-bigger.e-background .e-tab-header.e-vertical .e-toolbar-items .e-toolbar-item .e-tab-wrap{padding:0 24px}.e-bigger .e-tab.e-background.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator),.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator),.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child,.e-tab.e-bigger.e-background.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator),.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator),.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0}.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator) .e-icon-left+.e-tab-text,.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator) .e-icon-left+.e-tab-text{margin:0 12px 0 0}@media screen and (max-width:480px){.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator) .e-icon-left+.e-tab-text,.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator) .e-icon-left+.e-tab-text{margin:0 14px 0 0}}.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator) .e-icons.e-close-icon,.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator) .e-icons.e-close-icon{margin:0 12px 0 0}@media screen and (max-width:480px){.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator) .e-icons.e-close-icon,.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator) .e-icons.e-close-icon{margin:0 14px 0 0}}.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator).e-ibottom .e-close-icon,.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator).e-itop .e-close-icon,.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator).e-ibottom .e-close-icon,.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator).e-itop .e-close-icon{left:24px;right:auto}.e-bigger .e-tab.e-rtl .e-tab-header.e-close-show .e-toolbar-item.e-ibottom .e-text-wrap,.e-bigger .e-tab.e-rtl .e-tab-header.e-close-show .e-toolbar-item.e-itop .e-text-wrap,.e-tab.e-bigger.e-rtl .e-tab-header.e-close-show .e-toolbar-item.e-ibottom .e-text-wrap,.e-tab.e-bigger.e-rtl .e-tab-header.e-close-show .e-toolbar-item.e-itop .e-text-wrap{margin-left:22px;margin-right:0}.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item,.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item{margin:0}.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-text,.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-text{padding-left:12px;padding-right:0}@media screen and (max-width:480px){.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-text,.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-text{padding-left:0}}.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item .e-icons.e-close-icon,.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item .e-icons.e-close-icon{margin:0}.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-close-icon,.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-close-icon,.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-close-icon,.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-close-icon{left:18px;right:auto}.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-text,.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-text,.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-text,.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-text{margin:0;padding-left:12px;padding-right:0}@media screen and (max-width:480px){.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-text,.e-bigger .e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-text,.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-text,.e-tab.e-bigger.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-text{margin:0;padding-left:0;padding-right:0}}.e-bigger .e-tab.e-rtl .e-tab-header .e-hor-nav,.e-bigger .e-tab.e-rtl .e-tab-header .e-scroll-left-nav,.e-bigger .e-tab.e-rtl .e-tab-header .e-scroll-right-nav,.e-tab.e-bigger.e-rtl .e-tab-header .e-hor-nav,.e-tab.e-bigger.e-rtl .e-tab-header .e-scroll-left-nav,.e-tab.e-bigger.e-rtl .e-tab-header .e-scroll-right-nav{padding:0 12px}.e-bigger .e-tab.e-rtl .e-tab-header.e-vertical .e-toolbar-item:not(.e-separator),.e-tab.e-bigger.e-rtl .e-tab-header.e-vertical .e-toolbar-item:not(.e-separator){margin:0}.e-bigger .e-tab.e-rtl .e-tab-header.e-vertical .e-toolbar-item.e-ibottom .e-close-icon,.e-bigger .e-tab.e-rtl .e-tab-header.e-vertical .e-toolbar-item.e-itop .e-close-icon,.e-tab.e-bigger.e-rtl .e-tab-header.e-vertical .e-toolbar-item.e-ibottom .e-close-icon,.e-tab.e-bigger.e-rtl .e-tab-header.e-vertical .e-toolbar-item.e-itop .e-close-icon{left:-24px}.e-bigger .e-tab.e-rtl .e-tab-header.e-vertical .e-hor-nav,.e-tab.e-bigger.e-rtl .e-tab-header.e-vertical .e-hor-nav{padding:0 24px}.e-bigger .e-tab.e-rtl .e-tab-header.e-vertical .e-popup-down-icon:after,.e-bigger .e-tab.e-rtl .e-tab-header.e-vertical .e-popup-up-icon:after,.e-tab.e-bigger.e-rtl .e-tab-header.e-vertical .e-popup-down-icon:after,.e-tab.e-bigger.e-rtl .e-tab-header.e-vertical .e-popup-up-icon:after{margin:0 10px 0 0}.e-tab{display:block;position:relative}.e-tab.e-hidden{display:none}.e-tab.e-fill-mode .e-content,.e-tab.e-fill-mode .e-content .e-item,.e-tab.e-fill-mode .e-content .e-item>div,.e-tab.e-fill-mode .e-content .e-item>div>.e-blazor-template{height:100%}.e-tab .e-tab-header{height:36px;min-height:36px}@media screen and (max-width:480px){.e-tab .e-tab-header{height:48px;min-height:48px}}.e-tab .e-tab-header:before{content:\"\";position:absolute}.e-tab .e-tab-header:not(.e-vertical):before{bottom:0;top:0;width:100%}.e-tab .e-tab-header .e-toolbar-items{height:auto;margin:0;min-height:36px;position:relative}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-items{min-height:48px}}.e-tab .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-tab .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0}.e-tab .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0;padding-bottom:0}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0}}.e-tab .e-tab-header .e-toolbar-items.e-hscroll.e-scroll-device{padding:0}.e-tab .e-tab-header .e-toolbar-items.e-hscroll.e-scroll-device .e-scroll-right-nav{display:none}.e-tab .e-tab-header .e-toolbar-items.e-hscroll .e-scroll-nav{width:40px}.e-tab .e-tab-header .e-toolbar-items.e-hscroll:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-items.e-hscroll:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0}}.e-tab .e-tab-header .e-toolbar-items.e-hscroll:not(.e-tbar-pos) .e-toolbar-item:last-child.e-active{margin:0}.e-tab .e-tab-header .e-hscroll-bar{overflow:hidden}.e-tab .e-tab-header .e-indicator{display:block;position:absolute}.e-tab .e-tab-header .e-indicator.e-hidden{display:none}.e-tab .e-tab-header:not(.e-vertical) .e-indicator{bottom:0;height:2px;left:0;right:0;transition:left .125s cubic-bezier(.35,0,.25,1),right .25s cubic-bezier(.35,0,.25,1)}.e-tab .e-tab-header .e-toolbar-item.e-hidden{display:none}.e-tab .e-tab-header .e-toolbar-item:not(.e-separator){height:36px;margin:0;min-height:36px;min-width:auto;padding:0}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item:not(.e-separator){height:48px;min-height:48px}}.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap{height:36px;padding:0 18px;width:100%}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap{height:48px;padding:0 12px}}.e-tab .e-tab-header .e-toolbar-item .e-text-wrap{-ms-flex-line-pack:center;align-content:center;-ms-flex-align:center;align-items:center;display:-ms-inline-flexbox;display:inline-flex;height:36px}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item .e-text-wrap{height:48px}}.e-tab .e-tab-header .e-toolbar-item .e-tab-text{display:inherit;font-family:Roboto,Segoe UI,GeezaPro,DejaVu Serif,\"sans-serif\",-apple-system,BlinkMacSystemFont;font-size:13px;font-weight:500;text-transform:uppercase}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item .e-tab-text{font-size:14px}}.e-tab .e-tab-header .e-toolbar-item.e-active{margin:0;padding-bottom:0}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item.e-active{margin:0}}.e-tab .e-tab-header .e-toolbar-item.e-active .e-text-wrap{height:36px;margin-top:0}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item.e-active .e-text-wrap{height:48px}}.e-tab .e-tab-header .e-toolbar-item.e-active .e-tab-wrap{margin-bottom:0}.e-tab .e-tab-header .e-toolbar-item.e-active .e-tab-text{font-weight:500}.e-tab .e-tab-header .e-toolbar-item.e-active.e-ileft .e-text-wrap,.e-tab .e-tab-header .e-toolbar-item.e-active.e-iright .e-text-wrap{height:36px;padding:0}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item.e-active.e-ileft .e-text-wrap,.e-tab .e-tab-header .e-toolbar-item.e-active.e-iright .e-text-wrap{height:48px}}.e-tab .e-tab-header .e-toolbar-item .e-icons.e-close-icon{display:none;margin:0 0 0 10px;min-width:10px}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item .e-icons.e-close-icon{margin:0 0 0 14px}}.e-tab .e-tab-header .e-toolbar-item .e-close-icon,.e-tab .e-tab-header .e-toolbar-item .e-close-icon:before{font-size:10px}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item .e-close-icon,.e-tab .e-tab-header .e-toolbar-item .e-close-icon:before{font-size:12px}}.e-tab .e-tab-header .e-toolbar-item .e-close-icon:before{top:0}.e-tab .e-tab-header .e-toolbar-item .e-icons.e-tab-icon{display:-ms-inline-flexbox;display:inline-flex;height:20px;min-width:20px;width:20px}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item .e-icons.e-tab-icon{height:20px;width:20px}}.e-tab .e-tab-header .e-toolbar-item .e-tab-icon,.e-tab .e-tab-header .e-toolbar-item .e-tab-icon:before{font-size:18px}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item .e-tab-icon,.e-tab .e-tab-header .e-toolbar-item .e-tab-icon:before{font-size:20px}}.e-tab .e-tab-header .e-toolbar-item.e-icon .e-tab-wrap{-ms-flex-pack:center;justify-content:center;padding:0 18px}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item.e-icon .e-tab-wrap{padding:0 24px}}.e-tab .e-tab-header .e-toolbar-item .e-icon-left+.e-tab-text{margin:0 0 0 10px}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item .e-icon-left+.e-tab-text{margin:0 0 0 14px}}.e-tab .e-tab-header .e-toolbar-item.e-ibottom,.e-tab .e-tab-header .e-toolbar-item.e-itop{height:62px}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item.e-ibottom,.e-tab .e-tab-header .e-toolbar-item.e-itop{height:72px}}.e-tab .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap,.e-tab .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;height:62px;position:relative}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap,.e-tab .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap{height:72px}}.e-tab .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-tab .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus .e-text-wrap{height:auto}.e-tab .e-tab-header .e-toolbar-item.e-ibottom .e-text-wrap,.e-tab .e-tab-header .e-toolbar-item.e-itop .e-text-wrap{display:block;height:auto}.e-tab .e-tab-header .e-toolbar-item.e-ibottom.e-active .e-tab-wrap .e-text-wrap,.e-tab .e-tab-header .e-toolbar-item.e-ibottom.e-active .e-tab-wrap:focus .e-text-wrap,.e-tab .e-tab-header .e-toolbar-item.e-itop.e-active .e-tab-wrap .e-text-wrap,.e-tab .e-tab-header .e-toolbar-item.e-itop.e-active .e-tab-wrap:focus .e-text-wrap{height:auto}.e-tab .e-tab-header .e-toolbar-item.e-ibottom .e-close-icon,.e-tab .e-tab-header .e-toolbar-item.e-itop .e-close-icon{position:absolute;right:18px;top:calc(50% - 6px)}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item.e-ibottom .e-close-icon,.e-tab .e-tab-header .e-toolbar-item.e-itop .e-close-icon{right:12px}}.e-tab .e-tab-header .e-toolbar-item.e-itop .e-tab-text{margin:8px 0 0}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item.e-itop .e-tab-text{margin:10px 0 0}}.e-tab .e-tab-header .e-toolbar-item.e-ibottom .e-tab-text{margin:0 0 8px}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item.e-ibottom .e-tab-text{margin:0 0 10px}}.e-tab .e-tab-header .e-toolbar-item .e-tab-icon.e-icon-bottom,.e-tab .e-tab-header .e-toolbar-item .e-tab-icon.e-icon-top{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;margin:auto}.e-tab .e-tab-header .e-toolbar-pop{padding:0}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item{height:36px;min-height:36px;min-width:auto}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item{height:48px;min-height:48px}}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item:not(.e-separator){margin:0}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap{height:36px;padding:0 16px;text-align:initial}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap{height:48px;padding:0 16px}}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-text-wrap{height:36px;width:100%}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-text{display:-ms-inline-flexbox;display:inline-flex;width:100%}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-close-icon{margin:0 0 0 8px}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-close-icon:before{top:0}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-text+.e-close-icon[style=\"display:block\"]{padding-right:10px}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-text+.e-close-icon[style=\"display:block\"]{padding-right:0}}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom,.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop{height:36px}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom,.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop{height:48px}}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom:not(.e-separator),.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop:not(.e-separator){min-height:36px}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom:not(.e-separator),.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop:not(.e-separator){min-height:48px}}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-wrap,.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-wrap{height:36px}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-wrap,.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-wrap{height:48px}}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-text-wrap,.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-text-wrap{display:-ms-inline-flexbox;display:inline-flex;height:auto}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-text,.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-text{display:block;-ms-flex-pack:center;justify-content:center;margin:0 0 0 10px;padding-left:0;padding-right:10px}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-text,.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-text{-ms-flex-pack:center;justify-content:center;margin:0 0 0 12px;padding-left:0;padding-right:0}}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-close-icon,.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-close-icon{right:18px;top:auto}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-text{margin:0}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-icon.e-icon-bottom,.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-icon.e-icon-top{display:-ms-inline-flexbox;display:inline-flex}.e-tab .e-tab-header.e-close-show .e-icons.e-close-icon{-ms-flex-align:center;align-items:center;-ms-flex-item-align:center;align-self:center;display:-ms-inline-flexbox;display:inline-flex}@media screen and (max-width:480px){.e-tab .e-tab-header.e-close-show .e-icons.e-close-icon{display:none}}@media screen and (max-width:480px){.e-tab .e-tab-header.e-close-show .e-toolbar-item.e-active .e-close-icon{display:-ms-inline-flexbox;display:inline-flex}}.e-tab .e-tab-header.e-close-show .e-toolbar-item.e-ibottom .e-text-wrap,.e-tab .e-tab-header.e-close-show .e-toolbar-item.e-itop .e-text-wrap{margin-right:20px}.e-tab .e-tab-header .e-scroll-nav{height:36px;min-height:36px;min-width:auto;width:auto}@media screen and (max-width:480px){.e-tab .e-tab-header .e-scroll-nav{height:48px;min-height:48px}}.e-tab .e-tab-header .e-scroll-nav.e-scroll-left-nav,.e-tab .e-tab-header .e-scroll-nav.e-scroll-right-nav{padding:0 9px}@media screen and (max-width:480px){.e-tab .e-tab-header .e-scroll-nav.e-scroll-right-nav{padding:0 12px}}.e-tab .e-tab-header .e-scroll-nav .e-nav-left-arrow:before,.e-tab .e-tab-header .e-scroll-nav .e-nav-right-arrow:before{font-size:12px;line-height:24px;position:relative;top:0;vertical-align:initial}.e-tab .e-tab-header .e-scroll-nav .e-nav-arrow{font-size:12px;height:24px;line-height:24px;width:24px}@media screen and (max-width:480px){.e-tab .e-tab-header .e-scroll-nav .e-nav-arrow{font-size:12px;height:24px;line-height:24px;width:24px}}.e-tab .e-tab-header .e-hor-nav{height:36px;min-height:36px;min-width:auto;padding:0 9px;width:auto}@media screen and (max-width:480px){.e-tab .e-tab-header .e-hor-nav{height:48px;min-height:48px;padding:0 12px}}.e-tab .e-tab-header .e-hor-nav .e-popup-down-icon,.e-tab .e-tab-header .e-hor-nav .e-popup-up-icon{font-size:12px;height:24px;line-height:24px;width:24px}@media screen and (max-width:480px){.e-tab .e-tab-header .e-hor-nav .e-popup-down-icon,.e-tab .e-tab-header .e-hor-nav .e-popup-up-icon{font-size:12px;height:24px;line-height:24px;width:24px}}.e-tab .e-tab-header .e-hor-nav .e-popup-down-icon:before,.e-tab .e-tab-header .e-hor-nav .e-popup-up-icon:before{font-size:12px;line-height:24px;position:relative;top:0;vertical-align:initial}@media screen and (max-width:480px){.e-tab .e-tab-header .e-hor-nav .e-popup-down-icon:before,.e-tab .e-tab-header .e-hor-nav .e-popup-up-icon:before{font-size:16px}}.e-tab .e-tab-header .e-hor-nav .e-popup-down-icon:hover:before,.e-tab .e-tab-header .e-hor-nav .e-popup-up-icon:hover:before{top:0}.e-tab .e-tab-header .e-hor-nav .e-popup-up-icon{transform:rotate(180deg);transition:transform .1s ease}@media screen and (max-width:480px){.e-tab .e-tab-header .e-hor-nav .e-popup-up-icon{transform:none;transition:none}}.e-tab .e-tab-header .e-hor-nav .e-popup-down-icon{transform:rotate(0deg);transition:transform .1s ease}@media screen and (max-width:480px){.e-tab .e-tab-header .e-hor-nav .e-popup-down-icon{transform:none;transition:none}}.e-tab .e-tab-header .e-hor-nav:focus .e-popup-down-icon:before,.e-tab .e-tab-header .e-hor-nav:focus .e-popup-up-icon:before{top:0}.e-tab .e-tab-header.e-horizontal-bottom:before{bottom:auto}.e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0;padding-bottom:0;padding-top:0}@media screen and (max-width:480px){.e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0}}.e-tab .e-tab-header.e-horizontal-bottom .e-indicator{bottom:auto;top:0}.e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active{margin:0;padding-bottom:0;padding-top:0}@media screen and (max-width:480px){.e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active{margin:0}}.e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active .e-text-wrap{height:36px;padding:0}.e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-ibottom .e-text-wrap,.e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-itop .e-text-wrap{height:auto}.e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-ibottom.e-active .e-text-wrap,.e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-itop.e-active .e-text-wrap{height:auto;padding:0}.e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-ibottom.e-active .e-text-wrap:before,.e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-itop.e-active .e-text-wrap:before{bottom:auto;top:0}.e-tab .e-tab-header.e-reorder-active-item .e-toolbar-pop .e-toolbar-item.e-active .e-text-wrap:before{display:none}.e-tab .e-tab-header.e-vertical{max-width:150px;z-index:1}.e-tab .e-tab-header.e-vertical:before{bottom:0;height:100%;left:0;top:0}.e-tab .e-tab-header.e-vertical[style*=\"overflow: hidden\"]:before{bottom:15px;height:auto;top:15px}@media screen and (max-width:480px){.e-tab .e-tab-header.e-vertical[style*=\"overflow: hidden\"]:before{bottom:0;top:0}}.e-tab .e-tab-header.e-vertical .e-indicator{display:block;transition:top .125s cubic-bezier(.35,0,.25,1),bottom .25s cubic-bezier(.35,0,.25,1);width:2px}.e-tab .e-tab-header.e-vertical .e-toolbar-items{height:inherit}.e-tab .e-tab-header.e-vertical .e-toolbar-items.e-vscroll:not(.e-scroll-device){padding:16px 0}.e-tab .e-tab-header.e-vertical .e-toolbar-item:last-child,.e-tab .e-tab-header.e-vertical .e-toolbar-item:not(.e-separator){margin:0}.e-tab .e-tab-header.e-vertical .e-toolbar-item .e-tab-wrap{padding:0 18px}.e-tab .e-tab-header.e-vertical .e-toolbar-item .e-text-wrap{position:relative;width:100%}.e-tab .e-tab-header.e-vertical .e-toolbar-item .e-tab-icon:before,.e-tab .e-tab-header.e-vertical .e-toolbar-item .e-tab-text{text-align:center;width:100%}.e-tab .e-tab-header.e-vertical .e-toolbar-item .e-tab-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.e-tab .e-tab-header.e-vertical .e-toolbar-item.e-active .e-text-wrap:before{display:none}.e-tab .e-tab-header.e-vertical .e-toolbar-item.e-ibottom .e-close-icon,.e-tab .e-tab-header.e-vertical .e-toolbar-item.e-itop .e-close-icon{right:-18px}.e-tab .e-tab-header.e-vertical .e-toolbar-pop{top:auto!important}.e-tab .e-tab-header.e-vertical.e-vertical-left{float:left}.e-tab .e-tab-header.e-vertical.e-vertical-left:before{right:0}.e-tab .e-tab-header.e-vertical.e-vertical-left .e-indicator{left:auto;right:0}.e-tab .e-tab-header.e-vertical.e-vertical-right{float:right}.e-tab .e-tab-header.e-vertical.e-vertical-right:before{right:auto}.e-tab .e-tab-header.e-vertical.e-vertical-right .e-indicator{left:0;right:auto}.e-tab .e-tab-header.e-vertical.e-vertical-right .e-tab-wrap{text-align:right}.e-tab .e-tab-header.e-vertical.e-vertical-right .e-toolbar-pop .e-tab-text{width:auto}.e-tab .e-tab-header.e-vertical .e-scroll-nav{height:16px;-ms-flex-pack:center;justify-content:center;min-height:16px;width:100%}.e-tab .e-tab-header.e-vertical .e-scroll-nav .e-nav-arrow{font-size:10px;height:16px;line-height:16px;margin:0 auto;width:16px}.e-tab .e-tab-header.e-vertical .e-hor-nav{padding:0 18px;width:100%}.e-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-down-icon,.e-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-up-icon{height:100%;transform:none;transition:none;width:100%}.e-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-down-icon:before,.e-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-up-icon:before{float:left;font-family:Roboto,Segoe UI,GeezaPro,DejaVu Serif,\"sans-serif\",-apple-system,BlinkMacSystemFont;font-size:13px;font-weight:500;line-height:35px;text-align:left;text-transform:uppercase;transform:none;transition:none}.e-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-down-icon:after,.e-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-up-icon:after{float:left;font-size:12px;line-height:35px;margin:0 0 0 10px;vertical-align:initial}@media screen and (max-width:480px){.e-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-down-icon:after,.e-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-up-icon:after{font-size:14px}}.e-tab .e-tab-header.e-vertical .e-scroll-device .e-scroll-nav,.e-tab .e-tab-header.e-vertical .e-scroll-device .e-scroll-overlay{display:none}.e-tab .e-tab-header.e-vertical.e-toolpop .e-toolbar-items{height:auto}.e-tab.e-rtl .e-tab-header.e-vertical .e-toolbar-item:not(.e-separator),.e-tab.e-rtl .e-tab-header.e-vertical .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0}.e-tab.e-rtl .e-tab-header.e-vertical .e-toolbar-item:not(.e-separator).e-ibottom .e-close-icon,.e-tab.e-rtl .e-tab-header.e-vertical .e-toolbar-item:not(.e-separator).e-itop .e-close-icon{left:-18px}.e-tab.e-rtl .e-tab-header.e-vertical .e-hor-nav{padding:0 18px}.e-tab.e-rtl .e-tab-header.e-vertical .e-hor-nav .e-popup-down-icon:before,.e-tab.e-rtl .e-tab-header.e-vertical .e-hor-nav .e-popup-up-icon:before{float:right}.e-tab.e-rtl .e-tab-header.e-vertical .e-hor-nav .e-popup-down-icon:after,.e-tab.e-rtl .e-tab-header.e-vertical .e-hor-nav .e-popup-up-icon:after{float:right;margin:0 10px 0 0}.e-tab .e-content{position:relative}.e-tab .e-content .e-item.e-view{bottom:0;left:0;overflow:hidden;position:absolute;right:0;top:0}.e-tab .e-content>.e-item{display:none}.e-tab .e-content>.e-item.e-active{background:inherit;display:block}.e-tab .e-content.e-progress{overflow:hidden}.e-tab.e-vertical-tab .e-content{display:-ms-flexbox;display:flex}.e-tab.e-vertical-tab .e-content .e-item.e-active{display:-ms-flexbox;display:flex;-ms-flex:none;flex:none}.e-tab.e-vertical-tab .e-content .e-item,.e-tab.e-vertical-tab .e-content .e-item>:first-child{width:100%}.e-tab.e-vertical-icon .e-tab-header{height:62px;min-height:62px}.e-tab.e-vertical-icon .e-tab-header.e-reorder-active-item .e-toolbar-pop .e-toolbar-item.e-active .e-tab-wrap:before,.e-tab.e-vertical-icon .e-tab-header.e-reorder-active-item .e-toolbar-pop .e-toolbar-item:not(.e-separator):last-child.e-active .e-tab-wrap:before{display:none}.e-tab.e-vertical-icon .e-tab-header .e-hor-nav,.e-tab.e-vertical-icon .e-tab-header .e-scroll-nav,.e-tab.e-vertical-icon .e-tab-header .e-toolbar-items{height:62px}@media screen and (max-width:480px){.e-tab.e-vertical-icon .e-tab-header .e-hor-nav .e-popup-down-icon:before,.e-tab.e-vertical-icon .e-tab-header .e-hor-nav .e-popup-up-icon:before{font-size:12px}}.e-tab.e-vertical-icon .e-tab-header.e-vertical .e-toolbar-item.e-active .e-tab-wrap:before,.e-tab.e-vertical-icon .e-tab-header.e-vertical .e-toolbar-item:not(.e-separator):last-child.e-active .e-tab-wrap:before{display:none}.e-tab.e-vertical-icon .e-tab-header.e-vertical .e-toolbar-item.e-active .e-text-wrap,.e-tab.e-vertical-icon .e-tab-header.e-vertical .e-toolbar-item:not(.e-separator):last-child.e-active .e-text-wrap{position:relative}.e-tab.e-vertical-icon .e-tab-header.e-vertical .e-scroll-nav{height:16px}.e-tab.e-vertical-icon.e-vertical-tab .e-tab-header.e-vertical .e-toolbar-items{height:inherit}.e-tab.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus,.e-tab.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-text-wrap{height:36px}.e-tab.e-focused .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus,.e-tab.e-focused .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus{height:62px}.e-tab.e-focused .e-tab-header .e-toolbar-item.e-ibottom.e-active .e-tab-wrap:focus .e-text-wrap,.e-tab.e-focused .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-tab.e-focused .e-tab-header .e-toolbar-item.e-itop.e-active .e-tab-wrap:focus .e-text-wrap,.e-tab.e-focused .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus .e-text-wrap{height:auto}.e-tab.e-focused .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-wrap:focus,.e-tab.e-focused .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-wrap:focus,.e-tab.e-focused .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap:focus,.e-tab.e-focused .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap:focus .e-text-wrap{height:36px}.e-tab.e-focused .e-tab-header .e-horizontal-bottom .e-toolbar-item.e-active .e-tab-wrap:focus .e-text-wrap{height:36px;padding:0}.e-tab.e-focused .e-tab-header .e-horizontal-bottom .e-toolbar-item.e-ibottom.e-active .e-tab-wrap:focus .e-text-wrap,.e-tab.e-focused .e-tab-header .e-horizontal-bottom .e-toolbar-item.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-tab.e-focused .e-tab-header .e-horizontal-bottom .e-toolbar-item.e-itop.e-active .e-tab-wrap:focus .e-text-wrap,.e-tab.e-focused .e-tab-header .e-horizontal-bottom .e-toolbar-item.e-itop .e-tab-wrap:focus .e-text-wrap{height:auto}.e-tab.e-template .e-content>.e-item{display:none}.e-tab.e-template .e-content>.e-item.e-active{background:inherit;display:block}.e-tab.e-ie .e-tab-header .e-hor-nav.e-ie-align,.e-tab.e-ie .e-tab-header .e-scroll-nav.e-ie-align{display:-ms-flexbox;display:flex}.e-tab.e-ie .e-tab-header .e-hor-nav.e-ie-align .e-popup-down-icon,.e-tab.e-ie .e-tab-header .e-hor-nav.e-ie-align .e-popup-up-icon,.e-tab.e-ie .e-tab-header .e-scroll-nav.e-ie-align .e-popup-down-icon,.e-tab.e-ie .e-tab-header .e-scroll-nav.e-ie-align .e-popup-up-icon{display:block;line-height:15px}.e-tab.e-ie .e-tab-header .e-hor-nav.e-ie-align .e-nav-left-arrow,.e-tab.e-ie .e-tab-header .e-hor-nav.e-ie-align .e-nav-right-arrow,.e-tab.e-ie .e-tab-header .e-scroll-nav.e-ie-align .e-nav-left-arrow,.e-tab.e-ie .e-tab-header .e-scroll-nav.e-ie-align .e-nav-right-arrow{display:block;line-height:14px}.e-tab.e-ie .e-tab-header .e-popup-down-icon,.e-tab.e-ie .e-tab-header .e-popup-up-icon{transform:none;transition:none}.e-tab.e-ie .e-tab-header .e-popup-up-icon:before{transform:rotate(180deg);transition:transform .1s ease}@media screen and (max-width:480px){.e-tab.e-ie .e-tab-header .e-popup-up-icon:before{transform:none;transition:none}}.e-tab.e-ie .e-tab-header .e-popup-down-icon:before{transform:rotate(0deg);transition:transform .1s ease}@media screen and (max-width:480px){.e-tab.e-ie .e-tab-header .e-popup-down-icon:before{transform:none;transition:none}}.e-tab.e-edge .e-tab-header .e-hor-nav.e-ie-align,.e-tab.e-edge .e-tab-header .e-scroll-nav.e-ie-align{display:-ms-flexbox;display:flex}.e-tab.e-edge .e-tab-header .e-hor-nav.e-ie-align .e-popup-down-icon,.e-tab.e-edge .e-tab-header .e-hor-nav.e-ie-align .e-popup-up-icon,.e-tab.e-edge .e-tab-header .e-scroll-nav.e-ie-align .e-popup-down-icon,.e-tab.e-edge .e-tab-header .e-scroll-nav.e-ie-align .e-popup-up-icon{display:block;line-height:14px;position:relative}.e-tab.e-edge .e-tab-header .e-hor-nav.e-ie-align .e-nav-left-arrow,.e-tab.e-edge .e-tab-header .e-hor-nav.e-ie-align .e-nav-right-arrow,.e-tab.e-edge .e-tab-header .e-scroll-nav.e-ie-align .e-nav-left-arrow,.e-tab.e-edge .e-tab-header .e-scroll-nav.e-ie-align .e-nav-right-arrow{display:block;line-height:11px;position:relative}.e-tab.e-edge .e-tab-header .e-popup-up-icon{transform:rotate(180deg);transition:transform .1s ease}@media screen and (max-width:480px){.e-tab.e-edge .e-tab-header .e-popup-up-icon{transform:none;transition:none}}.e-tab.e-edge .e-tab-header .e-popup-down-icon{transform:rotate(0deg);transition:transform .1s ease}@media screen and (max-width:480px){.e-tab.e-edge .e-tab-header .e-popup-down-icon{transform:none;transition:none}}@media screen and (max-width:480px) and (max-width:480px){.e-tab.e-edge .e-tab-header .e-popup-down-icon{transform:none;transition:none}}.e-tab.e-edge .e-tab-header .e-popup-up-icon:before{transform:rotate(180deg);transition:transform .1s ease}@media screen and (max-width:480px){.e-tab.e-edge .e-tab-header .e-popup-up-icon:before{transform:none;transition:none}}.e-tab.e-edge .e-tab-header .e-popup-down-icon:before{transform:rotate(0deg);transition:transform .1s ease}@media screen and (max-width:480px){.e-tab.e-edge .e-tab-header .e-popup-down-icon:before{transform:none;transition:none}}.e-tab.e-safari .e-tab-header .e-close-icon:before{top:-1px}.e-tab.e-safari .e-tab-header .e-hor-nav .e-nav-left-arrow:before,.e-tab.e-safari .e-tab-header .e-hor-nav .e-nav-right-arrow:before,.e-tab.e-safari .e-tab-header .e-hor-nav .e-popup-down-icon:before,.e-tab.e-safari .e-tab-header .e-hor-nav .e-popup-up-icon:before,.e-tab.e-safari .e-tab-header .e-scroll-nav .e-nav-left-arrow:before,.e-tab.e-safari .e-tab-header .e-scroll-nav .e-nav-right-arrow:before,.e-tab.e-safari .e-tab-header .e-scroll-nav .e-popup-down-icon:before,.e-tab.e-safari .e-tab-header .e-scroll-nav .e-popup-up-icon:before{top:0}.e-tab.e-fill .e-tab-header{height:34px;min-height:34px}@media screen and (max-width:480px){.e-tab.e-fill .e-tab-header{height:46px;min-height:46px}}.e-tab.e-fill .e-tab-header .e-indicator{display:none}.e-tab.e-fill .e-tab-header .e-toolbar-items{height:auto;min-height:34px}@media screen and (max-width:480px){.e-tab.e-fill .e-tab-header .e-toolbar-items{min-height:46px}}.e-tab.e-fill .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-tab.e-fill .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0;padding:0}.e-tab.e-fill .e-tab-header .e-toolbar-item:not(.e-separator){height:34px;margin:0;min-height:34px}@media screen and (max-width:480px){.e-tab.e-fill .e-tab-header .e-toolbar-item:not(.e-separator){height:46px;min-height:46px}}.e-tab.e-fill .e-tab-header .e-toolbar-item:not(.e-separator).e-ibottom,.e-tab.e-fill .e-tab-header .e-toolbar-item:not(.e-separator).e-itop{height:60px;min-height:60px}.e-tab.e-fill .e-tab-header .e-toolbar-item .e-tab-wrap{height:34px;padding:0 18px}@media screen and (max-width:480px){.e-tab.e-fill .e-tab-header .e-toolbar-item .e-tab-wrap{height:46px;padding:0 18px}}.e-tab.e-fill .e-tab-header .e-toolbar-item .e-text-wrap{height:34px}@media screen and (max-width:480px){.e-tab.e-fill .e-tab-header .e-toolbar-item .e-text-wrap{height:46px}}.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active{padding:0}.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active .e-tab-wrap{margin-bottom:0}.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active .e-text-wrap{height:34px}@media screen and (max-width:480px){.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active .e-text-wrap{height:46px}}.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active .e-tab-text{font-weight:500}.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active.e-ileft .e-text-wrap,.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active.e-iright .e-text-wrap{height:36px}@media screen and (max-width:480px){.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active.e-ileft .e-text-wrap,.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active.e-iright .e-text-wrap{height:46px}}.e-tab.e-fill .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap,.e-tab.e-fill .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap{height:60px}.e-tab.e-fill .e-tab-header .e-toolbar-item.e-ibottom .e-text-wrap,.e-tab.e-fill .e-tab-header .e-toolbar-item.e-itop .e-text-wrap,.e-tab.e-fill .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom:not(.e-separator),.e-tab.e-fill .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop:not(.e-separator){height:auto}.e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child.e-active,.e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child.e-active{padding:0}.e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item.e-itop,.e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child.e-itop,.e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child.e-itop{padding-top:0}.e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active{margin-right:0;padding:0}.e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active .e-text-wrap{height:34px}@media screen and (max-width:480px){.e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active .e-text-wrap{height:46px}}.e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-itop .e-tab-wrap:focus .e-text-wrap{height:44px}.e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-ibottom .e-text-wrap,.e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-itop .e-text-wrap{height:auto}.e-tab.e-fill .e-tab-header.e-vertical .e-toolbar-items{height:inherit}.e-tab.e-fill .e-tab-header.e-vertical .e-toolbar-items .e-toolbar-item .e-tab-wrap{padding:0 18px}.e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus,.e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-text-wrap{height:34px}.e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus,.e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus{height:60px}.e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus .e-text-wrap{height:auto}@media screen and (max-width:480px){.e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item.e-itop .e-tab-wrap:focus .e-text-wrap{height:auto}}.e-tab.e-fill.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator){margin:0}.e-tab.e-fill.e-vertical-icon .e-tab-header{height:60px;min-height:60px}.e-tab.e-background .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-tab.e-background .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0;padding:0}.e-tab.e-background .e-tab-header .e-toolbar-item:not(.e-separator){margin:0}.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap{padding:0 18px}@media screen and (max-width:480px){.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap{padding:0 24px}}.e-tab.e-background .e-tab-header .e-toolbar-item.e-active{padding:0}.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap{margin-bottom:0}.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-text-wrap{height:36px}.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-text{font-weight:500}.e-tab.e-background .e-tab-header.e-vertical .e-toolbar-items .e-toolbar-item .e-tab-wrap{padding:0 18px}.e-tab.e-background .e-tab-header.e-horizontal-bottom .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child.e-active,.e-tab.e-background .e-tab-header.e-horizontal-bottom .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child.e-active{padding:0}.e-tab.e-background .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active{margin:0;padding:0}.e-tab.e-background .e-tab-header .e-toolbar-pop .e-toolbar-item.e-active .e-text-wrap{height:36px}.e-tab.e-background.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator),.e-tab.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator),.e-tab.e-rtl .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:first-child,.e-tab.e-rtl .e-tab-header .e-toolbar-items:not(.e-tbar-pos) .e-toolbar-item:last-child{margin:0}.e-tab.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator) .e-icon-left+.e-tab-text,.e-tab.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator) .e-icons.e-close-icon{margin:0 10px 0 0}.e-tab.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator).e-ibottom .e-close-icon,.e-tab.e-rtl .e-tab-header .e-toolbar-item:not(.e-separator).e-itop .e-close-icon{left:18px;right:auto}.e-tab.e-rtl .e-tab-header.e-close-show .e-toolbar-item.e-ibottom .e-text-wrap,.e-tab.e-rtl .e-tab-header.e-close-show .e-toolbar-item.e-itop .e-text-wrap{margin-left:20px;margin-right:0}.e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item{margin:0}.e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-text{padding-left:10px;padding-right:0}@media screen and (max-width:480px){.e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-text{padding-left:0}}.e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item .e-icons.e-close-icon{margin:0}.e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item .e-close-icon{left:16px;right:auto}.e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-close-icon,.e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-close-icon{left:18px;right:auto}.e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-text,.e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-text{margin:0;padding-left:10px;padding-right:0}@media screen and (max-width:480px){.e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-ibottom .e-tab-text,.e-tab.e-rtl .e-tab-header .e-toolbar-pop .e-toolbar-item.e-itop .e-tab-text{margin:0;padding-left:10px;padding-right:0}}.e-tab.e-rtl .e-tab-header .e-hor-nav,.e-tab.e-rtl .e-tab-header .e-scroll-left-nav,.e-tab.e-rtl .e-tab-header .e-scroll-right-nav{padding:0 9px}.e-tab.e-vertical-tab.e-icon-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-down-icon:before,.e-tab.e-vertical-tab.e-icon-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-up-icon:before{display:none}.e-tab.e-vertical-tab.e-icon-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-down-icon:after,.e-tab.e-vertical-tab.e-icon-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-up-icon:after{margin:0;width:100%}.e-tab-clone-element{overflow:visible;z-index:10000}.e-tab-clone-element:not(.e-separator){height:36px;margin:0;min-height:36px;min-width:auto;padding:0}@media screen and (max-width:480px){.e-tab-clone-element:not(.e-separator){height:48px;min-height:48px}}.e-tab-clone-element .e-tab-wrap{height:36px;padding:0 18px;width:100%}@media screen and (max-width:480px){.e-tab-clone-element .e-tab-wrap{height:48px;padding:0 12px}}.e-tab-clone-element .e-text-wrap{-ms-flex-line-pack:center;align-content:center;-ms-flex-align:center;align-items:center;display:-ms-inline-flexbox;display:inline-flex;height:36px}@media screen and (max-width:480px){.e-tab-clone-element .e-text-wrap{height:48px}}.e-tab-clone-element .e-tab-text{display:inherit;font-family:Roboto,Segoe UI,GeezaPro,DejaVu Serif,\"sans-serif\",-apple-system,BlinkMacSystemFont;font-size:13px;font-weight:500;text-transform:uppercase}@media screen and (max-width:480px){.e-tab-clone-element .e-tab-text{font-size:14px}}.e-tab-clone-element .e-icons.e-close-icon{display:none}.e-tab-clone-element .e-close-icon,.e-tab-clone-element .e-close-icon:before{font-size:10px}@media screen and (max-width:480px){.e-tab-clone-element .e-close-icon,.e-tab-clone-element .e-close-icon:before{font-size:12px}}.e-tab-clone-element .e-close-icon:before{top:0}.e-tab-clone-element .e-icons.e-tab-icon{display:-ms-inline-flexbox;display:inline-flex;height:20px;min-width:20px;width:20px}@media screen and (max-width:480px){.e-tab-clone-element .e-icons.e-tab-icon{height:20px;width:20px}}.e-tab-clone-element .e-tab-icon,.e-tab-clone-element .e-tab-icon:before{font-size:18px}@media screen and (max-width:480px){.e-tab-clone-element .e-tab-icon,.e-tab-clone-element .e-tab-icon:before{font-size:20px}}.e-tab-clone-element.e-icon .e-tab-wrap{-ms-flex-pack:center;justify-content:center;padding:0 18px}@media screen and (max-width:480px){.e-tab-clone-element.e-icon .e-tab-wrap{padding:0 24px}}.e-tab-clone-element .e-icon-left+.e-tab-text{margin:0 0 0 10px}@media screen and (max-width:480px){.e-tab-clone-element .e-icon-left+.e-tab-text{margin:0 0 0 14px}}.e-tab-clone-element.e-ibottom,.e-tab-clone-element.e-itop{height:62px}@media screen and (max-width:480px){.e-tab-clone-element.e-ibottom,.e-tab-clone-element.e-itop{height:72px}}.e-tab-clone-element.e-ibottom .e-tab-wrap,.e-tab-clone-element.e-itop .e-tab-wrap{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;height:62px;position:relative}@media screen and (max-width:480px){.e-tab-clone-element.e-ibottom .e-tab-wrap,.e-tab-clone-element.e-itop .e-tab-wrap{height:72px}}.e-tab-clone-element.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-tab-clone-element.e-itop .e-tab-wrap:focus .e-text-wrap{height:auto}.e-tab-clone-element.e-ibottom .e-text-wrap,.e-tab-clone-element.e-itop .e-text-wrap{display:block;height:auto}.e-tab-clone-element.e-ibottom .e-close-icon,.e-tab-clone-element.e-itop .e-close-icon{position:absolute;right:18px;top:calc(50% - 6px)}@media screen and (max-width:480px){.e-tab-clone-element.e-ibottom .e-close-icon,.e-tab-clone-element.e-itop .e-close-icon{right:12px}}.e-tab-clone-element.e-itop .e-tab-text{margin:8px 0 0}@media screen and (max-width:480px){.e-tab-clone-element.e-itop .e-tab-text{margin:10px 0 0}}.e-tab-clone-element.e-ibottom .e-tab-text{margin:0 0 8px}@media screen and (max-width:480px){.e-tab-clone-element.e-ibottom .e-tab-text{margin:0 0 10px}}.e-tab-clone-element .e-tab-icon.e-icon-bottom,.e-tab-clone-element .e-tab-icon.e-icon-top{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;margin:auto}.e-tab-clone-element.e-close-show .e-icons.e-close-icon{-ms-flex-align:center;align-items:center;-ms-flex-item-align:center;align-self:center;display:-ms-inline-flexbox;display:inline-flex}@media screen and (max-width:480px){.e-tab-clone-element.e-close-show .e-icons.e-close-icon{display:none}}.e-tab-clone-element.e-close-show .e-toolbar-item.e-ibottom .e-text-wrap,.e-tab-clone-element.e-close-show .e-toolbar-item.e-itop .e-text-wrap{margin-right:20px}.e-bigger .e-tab-clone-element:not(.e-separator){height:48px;margin:0;min-height:48px;min-width:auto;padding:0}@media screen and (max-width:480px){.e-bigger .e-tab-clone-element:not(.e-separator){margin:0}}.e-bigger .e-tab-clone-element:not(.e-separator).e-ibottom,.e-bigger .e-tab-clone-element:not(.e-separator).e-itop{height:72px;min-height:72px}.e-bigger .e-tab-clone-element .e-tab-wrap{height:48px;padding:0 24px}@media screen and (max-width:480px){.e-bigger .e-tab-clone-element .e-tab-wrap{padding:0 12px}}.e-bigger .e-tab-clone-element .e-text-wrap{height:48px}.e-bigger .e-tab-clone-element .e-tab-text{font-size:14px}.e-bigger .e-tab-clone-element .e-icons.e-close-icon{cursor:pointer;margin:0 0 0 12px}@media screen and (max-width:480px){.e-bigger .e-tab-clone-element .e-icons.e-close-icon{margin:0 0 0 14px}}.e-bigger .e-tab-clone-element .e-close-icon:before,.e-bigger .e-tab-clone-element .e-icons.e-close-icon{font-size:10px}@media screen and (max-width:480px){.e-bigger .e-tab-clone-element .e-close-icon:before,.e-bigger .e-tab-clone-element .e-icons.e-close-icon{font-size:12px}}.e-bigger .e-tab-clone-element .e-icons.e-tab-icon{height:24px;min-width:24px;width:24px}.e-bigger .e-tab-clone-element .e-tab-icon,.e-bigger .e-tab-clone-element .e-tab-icon:before{font-size:20px}.e-bigger .e-tab-clone-element.e-icon .e-tab-wrap{padding:0 24px}.e-bigger .e-tab-clone-element .e-icon-left+.e-tab-text{margin:0 0 0 12px}@media screen and (max-width:480px){.e-bigger .e-tab-clone-element .e-icon-left+.e-tab-text{margin:0 0 0 14px}}.e-bigger .e-tab-clone-element.e-ibottom,.e-bigger .e-tab-clone-element.e-ibottom .e-tab-wrap,.e-bigger .e-tab-clone-element.e-itop,.e-bigger .e-tab-clone-element.e-itop .e-tab-wrap{height:72px}.e-bigger .e-tab-clone-element.e-ibottom .e-tab-wrap:focus .e-text-wrap,.e-bigger .e-tab-clone-element.e-itop .e-tab-wrap:focus .e-text-wrap{height:auto}.e-bigger .e-tab-clone-element.e-ibottom.e-active .e-tab-wrap,.e-bigger .e-tab-clone-element.e-itop.e-active .e-tab-wrap{height:72px}.e-bigger .e-tab-clone-element.e-ibottom.e-active .e-tab-wrap:focus .e-text-wrap,.e-bigger .e-tab-clone-element.e-itop.e-active .e-tab-wrap:focus .e-text-wrap{height:auto}.e-bigger .e-tab-clone-element.e-ibottom .e-close-icon,.e-bigger .e-tab-clone-element.e-itop .e-close-icon{right:24px}.e-bigger .e-tab-clone-element.e-itop .e-tab-text{margin:10px 0 0}.e-bigger .e-tab-clone-element.e-ibottom .e-tab-text{margin:0 0 10px}\n\n/*! tab theme */.e-tab{background:transparent;border:none}.e-tab .e-tab-header{background:inherit;border:0;border-radius:0;border-bottom:0}.e-tab .e-tab-header:not(.e-vertical) .e-toolbar-item.e-active{border-bottom:initial}.e-tab .e-tab-header .e-toolbar-items{background:inherit}.e-tab .e-tab-header .e-indicator{background:#e3165b}.e-tab .e-tab-header .e-toolbar-item{background:inherit;border:none}.e-tab .e-tab-header .e-toolbar-item .e-ripple-element{background:rgba(227,22,91,.12)}.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap{border-radius:0;color:rgba(0,0,0,.54)}.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap .e-tab-icon{color:rgba(0,0,0,.54)}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap,.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap .e-tab-icon{color:rgba(0,0,0,.54)}.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap .e-close-icon{color:rgba(0,0,0,.87)}}.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap:hover{background:inherit}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap:hover{background:inherit}}.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap:hover .e-tab-icon,.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap:hover .e-tab-text{color:rgba(0,0,0,.87)}.e-tab .e-tab-header .e-toolbar-item.e-active{border:none;border-radius:0}.e-tab .e-tab-header .e-toolbar-item.e-active.e-ileft .e-tab-icon,.e-tab .e-tab-header .e-toolbar-item.e-active.e-ileft .e-tab-text,.e-tab .e-tab-header .e-toolbar-item.e-active.e-iright .e-tab-icon,.e-tab .e-tab-header .e-toolbar-item.e-active.e-iright .e-tab-text,.e-tab .e-tab-header .e-toolbar-item.e-active .e-tab-icon,.e-tab .e-tab-header .e-toolbar-item.e-active .e-tab-text,.e-tab .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:hover .e-tab-icon,.e-tab .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:hover .e-tab-text{color:#e3165b}.e-tab .e-tab-header .e-toolbar-item .e-close-icon{color:rgba(0,0,0,.54)}.e-tab .e-tab-header .e-toolbar-item .e-close-icon:active,.e-tab .e-tab-header .e-toolbar-item .e-close-icon:hover{color:rgba(0,0,0,.87)}.e-tab .e-tab-header .e-toolbar-item.e-disable.e-overlay{background:inherit;opacity:1;pointer-events:none}.e-tab .e-tab-header .e-toolbar-item.e-disable.e-overlay .e-tab-icon,.e-tab .e-tab-header .e-toolbar-item.e-disable.e-overlay .e-tab-text{color:rgba(0,0,0,.38)}.e-tab .e-tab-header.e-reorder-active-item:not(.e-vertical) .e-toolbar-pop .e-toolbar-item.e-active{border:initial}.e-tab .e-tab-header .e-toolbar-pop{background:#fff;border:0;border-radius:0;box-shadow:0 2px 2px 1px rgba(0,0,0,.21);overflow-y:auto}.e-tab .e-tab-header .e-toolbar-pop[e-animate=true]{overflow-y:hidden}@media screen and (max-width:480px){.e-tab .e-tab-header .e-toolbar-pop{box-shadow:0 2px 2px 1px rgba(0,0,0,.21)}}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap .e-tab-icon,.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap .e-tab-text{color:rgba(0,0,0,.54)}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap:hover{background:#eee}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap:hover .e-close-icon,.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap:hover .e-tab-icon,.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap:hover .e-tab-text{color:rgba(0,0,0,.87)}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap:active{background:#eee}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-active .e-tab-wrap .e-tab-icon,.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-active .e-tab-wrap .e-tab-text{color:#e3165b}.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-disable.e-overlay .e-tab-icon,.e-tab .e-tab-header .e-toolbar-pop .e-toolbar-item.e-disable.e-overlay .e-tab-text{color:rgba(0,0,0,.38)}.e-tab .e-tab-header .e-hscroll:not(.e-scroll-device) .e-scroll-nav,.e-tab .e-tab-header .e-scroll-nav{background:inherit;border:0}.e-tab .e-tab-header .e-hscroll:not(.e-scroll-device) .e-scroll-nav .e-nav-arrow,.e-tab .e-tab-header .e-scroll-nav .e-nav-arrow{color:rgba(0,0,0,.54)}.e-tab .e-tab-header .e-hscroll:not(.e-scroll-device) .e-scroll-nav .e-nav-arrow:hover,.e-tab .e-tab-header .e-scroll-nav .e-nav-arrow:hover{background:initial;color:rgba(0,0,0,.87)}.e-tab .e-tab-header .e-hscroll:not(.e-scroll-device) .e-scroll-nav .e-nav-arrow:active,.e-tab .e-tab-header .e-scroll-nav .e-nav-arrow:active{box-shadow:none}.e-tab .e-tab-header .e-hscroll:not(.e-scroll-device) .e-scroll-nav:focus .e-nav-arrow,.e-tab .e-tab-header .e-scroll-nav:focus .e-nav-arrow{background:rgba(0,0,0,.12);color:rgba(0,0,0,.87)}.e-tab .e-tab-header .e-hscroll:not(.e-scroll-device) .e-scroll-nav:focus .e-nav-arrow:hover,.e-tab .e-tab-header .e-scroll-nav:focus .e-nav-arrow:hover{background:initial;color:rgba(0,0,0,.87)}.e-tab .e-tab-header .e-hscroll:not(.e-scroll-device) .e-scroll-nav.e-overlay .e-nav-arrow,.e-tab .e-tab-header .e-hscroll:not(.e-scroll-device) .e-scroll-nav.e-overlay .e-nav-arrow:hover,.e-tab .e-tab-header .e-scroll-nav.e-overlay .e-nav-arrow,.e-tab .e-tab-header .e-scroll-nav.e-overlay .e-nav-arrow:hover{color:rgba(0,0,0,.54)}.e-tab .e-tab-header .e-hor-nav,.e-tab .e-tab-header .e-hor-nav:not(.e-expended-nav){background:transparent;border:0}.e-tab .e-tab-header .e-hor-nav .e-popup-down-icon,.e-tab .e-tab-header .e-hor-nav .e-popup-up-icon,.e-tab .e-tab-header .e-hor-nav:not(.e-expended-nav) .e-popup-down-icon,.e-tab .e-tab-header .e-hor-nav:not(.e-expended-nav) .e-popup-up-icon{color:rgba(0,0,0,.54)}.e-tab .e-tab-header .e-hor-nav .e-popup-down-icon:hover,.e-tab .e-tab-header .e-hor-nav .e-popup-up-icon:hover,.e-tab .e-tab-header .e-hor-nav:not(.e-expended-nav) .e-popup-down-icon:hover,.e-tab .e-tab-header .e-hor-nav:not(.e-expended-nav) .e-popup-up-icon:hover{background:initial;border:initial;border-radius:0}.e-tab .e-tab-header .e-hor-nav .e-popup-down-icon:hover,.e-tab .e-tab-header .e-hor-nav:not(.e-expended-nav) .e-popup-down-icon:hover{color:rgba(0,0,0,.87)}.e-tab .e-tab-header .e-hor-nav:focus .e-popup-down-icon,.e-tab .e-tab-header .e-hor-nav:focus .e-popup-up-icon,.e-tab .e-tab-header .e-hor-nav:not(.e-expended-nav):focus .e-popup-down-icon,.e-tab .e-tab-header .e-hor-nav:not(.e-expended-nav):focus .e-popup-up-icon{background:rgba(0,0,0,.12);border:initial;border-radius:0;color:rgba(0,0,0,.87)}.e-tab .e-tab-header .e-hor-nav:focus .e-popup-down-icon:hover,.e-tab .e-tab-header .e-hor-nav:focus .e-popup-up-icon:hover,.e-tab .e-tab-header .e-hor-nav:not(.e-expended-nav):focus .e-popup-down-icon:hover,.e-tab .e-tab-header .e-hor-nav:not(.e-expended-nav):focus .e-popup-up-icon:hover{background:initial;border:initial;border-radius:0}.e-tab .e-tab-header .e-hor-nav:focus .e-popup-down-icon:active,.e-tab .e-tab-header .e-hor-nav:focus .e-popup-up-icon:active,.e-tab .e-tab-header .e-hor-nav:not(.e-expended-nav):focus .e-popup-down-icon:active,.e-tab .e-tab-header .e-hor-nav:not(.e-expended-nav):focus .e-popup-up-icon:active{background:initial;border:0;border-radius:0;box-shadow:none}.e-tab .e-tab-header .e-hor-nav:hover,.e-tab .e-tab-header .e-hor-nav:not(.e-expended-nav):hover{border:0}.e-tab .e-tab-header .e-hor-nav:hover:active,.e-tab .e-tab-header .e-hor-nav:not(.e-expended-nav):hover:active{background:transparent}.e-tab .e-tab-header .e-hor-nav.e-nav-active,.e-tab .e-tab-header .e-hor-nav:not(.e-expended-nav).e-nav-active{background:inherit;border:0;box-shadow:none}.e-tab .e-tab-header.e-horizontal-bottom{border-bottom:0;border-top:0}.e-tab .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active{border-bottom:0;border-radius:0;border-top:initial;border-top-color:inherit}.e-tab .e-tab-header.e-vertical:before{border-width:0 1px 0 0}.e-tab .e-tab-header.e-vertical .e-toolbar-item.e-active{border-bottom:0;border-top:0}.e-tab .e-tab-header.e-vertical.e-vertical-left .e-toolbar-item.e-active{border-radius:0;border-right:initial}.e-tab .e-tab-header.e-vertical.e-vertical-right .e-toolbar-item.e-active{border-left:initial;border-radius:0}.e-tab .e-tab-header.e-vertical .e-toolbar-pop{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.e-tab .e-tab-header.e-vertical .e-scroll-nav{background:inherit;border:1px solid transparent}.e-tab .e-tab-header.e-vertical .e-scroll-nav.e-scroll-up-nav{border-bottom-color:rgba(0,0,0,.12)}.e-tab .e-tab-header.e-vertical .e-scroll-nav.e-scroll-down-nav{border-top-color:rgba(0,0,0,.12)}.e-tab .e-tab-header.e-vertical .e-scroll-nav .e-nav-arrow{border:0}.e-tab .e-tab-header.e-vertical .e-scroll-nav .e-nav-arrow:hover{background:none}.e-tab .e-tab-header.e-vertical .e-scroll-nav:hover{background:rgba(0,0,0,.12)}.e-tab .e-tab-header.e-vertical .e-scroll-nav:hover .e-nav-arrow{color:rgba(0,0,0,.87)}.e-tab .e-tab-header.e-vertical .e-scroll-nav:hover .e-nav-arrow:hover{background:none}.e-tab .e-tab-header.e-vertical .e-scroll-nav:focus{background:rgba(0,0,0,.12)}.e-tab .e-tab-header.e-vertical .e-scroll-nav:focus .e-nav-arrow{background:none}.e-tab .e-tab-header.e-vertical .e-scroll-nav:focus .e-nav-arrow:hover{background:none;border:0}.e-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-down-icon,.e-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-up-icon{border:0}.e-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-down-icon:hover,.e-tab .e-tab-header.e-vertical .e-hor-nav .e-popup-up-icon:hover,.e-tab .e-tab-header.e-vertical .e-hor-nav:focus .e-popup-down-icon,.e-tab .e-tab-header.e-vertical .e-hor-nav:focus .e-popup-up-icon{background:inherit;border:0}.e-tab .e-tab-header.e-vertical .e-hor-nav:focus .e-popup-down-icon:active,.e-tab .e-tab-header.e-vertical .e-hor-nav:focus .e-popup-down-icon:active:hover,.e-tab .e-tab-header.e-vertical .e-hor-nav:focus .e-popup-down-icon:hover,.e-tab .e-tab-header.e-vertical .e-hor-nav:focus .e-popup-up-icon:active,.e-tab .e-tab-header.e-vertical .e-hor-nav:focus .e-popup-up-icon:active:hover,.e-tab .e-tab-header.e-vertical .e-hor-nav:focus .e-popup-up-icon:hover{background:inherit;border:0;box-shadow:none}.e-tab .e-tab-header.e-vertical .e-hor-nav:hover .e-popup-down-icon,.e-tab .e-tab-header.e-vertical .e-hor-nav:hover .e-popup-up-icon{border:0}.e-tab.e-focused>.e-tab-header .e-toolbar-item .e-tab-wrap:focus{background:rgba(227,22,91,.12)}.e-tab.e-focused>.e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-tab-icon,.e-tab.e-focused>.e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-tab-text{color:#e3165b}.e-tab.e-focused>.e-tab-header .e-hor-nav:focus .e-popup-down-icon,.e-tab.e-focused>.e-tab-header .e-hor-nav:focus .e-popup-up-icon,.e-tab.e-focused>.e-tab-header .e-scroll-nav:focus .e-nav-arrow{color:rgba(0,0,0,.87)}.e-tab.e-focused>.e-tab-header.e-vertical .e-hor-nav .e-popup-down-icon,.e-tab.e-focused>.e-tab-header.e-vertical .e-hor-nav .e-popup-up-icon,.e-tab.e-focused>.e-tab-header.e-vertical .e-scroll-nav:focus .e-nav-arrow{border:0}.e-tab.e-focused>.e-tab-header.e-vertical .e-hor-nav:focus{outline:0}.e-tab.e-disable{pointer-events:none}.e-tab.e-disable .e-tab-header .e-indicator{background:rgba(227,22,91,.38)}.e-tab.e-disable .e-tab-header .e-toolbar-item .e-tab-wrap{color:rgba(0,0,0,.38)}.e-tab.e-disable .e-tab-header .e-toolbar-item.e-active .e-tab-icon,.e-tab.e-disable .e-tab-header .e-toolbar-item.e-active .e-tab-text{color:rgba(227,22,91,.38)}.e-tab.e-disable .e-content{opacity:.38}.e-tab.e-fill .e-tab-header{border-bottom:2px #e3165b}.e-tab.e-fill .e-tab-header .e-toolbar-item{border:0}.e-tab.e-fill .e-tab-header .e-toolbar-item .e-ripple-element{background:rgba(0,0,0,.05)}.e-tab.e-fill .e-tab-header .e-toolbar-item .e-tab-wrap{color:rgba(0,0,0,.54)}.e-tab.e-fill .e-tab-header .e-toolbar-item .e-tab-wrap:hover .e-tab-icon,.e-tab.e-fill .e-tab-header .e-toolbar-item .e-tab-wrap:hover .e-tab-text{color:rgba(0,0,0,.87)}.e-tab.e-fill .e-tab-header .e-toolbar-item .e-text-wrap{margin-top:0}.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active{border:0}.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active .e-tab-wrap{background:#e3165b;border-radius:0}.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:hover .e-tab-icon,.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:hover .e-tab-text{color:#fff}.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active .e-text-wrap{margin-top:0}.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active .e-tab-icon,.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active .e-tab-text{color:#fff}.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active .e-close-icon{color:hsla(0,0%,100%,.7)}.e-tab.e-fill .e-tab-header .e-toolbar-item.e-active .e-close-icon:hover{color:#fff}.e-tab.e-fill .e-tab-header.e-horizontal-bottom{border-bottom:0;border-top:2px #e3165b}.e-tab.e-fill .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active .e-text-wrap{margin-top:0}.e-tab.e-fill .e-tab-header.e-vertical{border-bottom:0}.e-tab.e-fill .e-tab-header.e-vertical.e-vertical-left{border-right:2px #e3165b}.e-tab.e-fill .e-tab-header.e-vertical.e-vertical-right{border-left:2px #e3165b}.e-tab.e-fill.e-corner .e-tab-header .e-toolbar-item.e-active .e-tab-wrap{border-radius:3px 3px 0 0}.e-tab.e-fill.e-corner .e-tab-header.e-horizontal-bottom .e-toolbar-item.e-active .e-tab-wrap{border-radius:0 0 3px 3px}.e-tab.e-fill.e-disable .e-tab-header{border-bottom:2px rgba(227,22,91,.38)}.e-tab.e-fill.e-disable .e-tab-header .e-toolbar-item .e-tab-wrap{color:rgba(0,0,0,.38)}.e-tab.e-fill.e-disable .e-tab-header .e-toolbar-item.e-active{opacity:1}.e-tab.e-fill.e-disable .e-tab-header .e-toolbar-item.e-active .e-tab-wrap,.e-tab.e-fill.e-disable .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus{background:rgba(227,22,91,.38)}.e-tab.e-fill.e-disable .e-tab-header .e-toolbar-item.e-active .e-tab-wrap .e-tab-icon,.e-tab.e-fill.e-disable .e-tab-header .e-toolbar-item.e-active .e-tab-wrap .e-tab-text,.e-tab.e-fill.e-disable .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus .e-tab-icon,.e-tab.e-fill.e-disable .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus .e-tab-text{color:hsla(0,0%,100%,.38)}.e-tab.e-fill.e-disable .e-tab-header.e-horizontal-bottom{border-bottom:0;border-top:2px rgba(227,22,91,.38)}.e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-close-icon,.e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-tab-icon,.e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-tab-text{color:rgba(0,0,0,.87)}.e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus{background:rgba(227,22,91,.8)}.e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus .e-tab-icon,.e-tab.e-fill.e-focused .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus .e-tab-text{color:#fff}.e-tab.e-background .e-tab-header{background:#3f51b5;border:0}.e-tab.e-background .e-tab-header .e-toolbar-items{background:#3f51b5}.e-tab.e-background .e-tab-header .e-indicator{background:#fff}.e-tab.e-background .e-tab-header .e-toolbar-item{border:0}.e-tab.e-background .e-tab-header .e-toolbar-item .e-ripple-element{background:rgba(0,0,0,.1)}.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap{background:#3f51b5}.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap .e-close-icon,.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap .e-tab-icon,.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap .e-tab-text{color:hsla(0,0%,100%,.7)}.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap .e-close-icon:hover{color:hsla(0,0%,100%,.54)}.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap:hover{background:inherit}.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap:hover .e-close-icon:active,.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap:hover .e-close-icon:hover,.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap:hover .e-tab-icon,.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap:hover .e-tab-text{color:#fff}.e-tab.e-background .e-tab-header .e-toolbar-item.e-active{border:0;margin:0}.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap{background:#3f51b5;border-radius:0}.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:hover .e-tab-icon,.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:hover .e-tab-text{color:#fff}.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus{background:inherit}.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-icon,.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-text,.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus .e-tab-icon,.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus .e-tab-text{color:#fff}.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-close-icon{color:hsla(0,0%,100%,.7)}.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-close-icon:hover{color:#fff}.e-tab.e-background .e-tab-header .e-toolbar-item.e-active.e-ibottom .e-tab-wrap,.e-tab.e-background .e-tab-header .e-toolbar-item.e-active.e-itop .e-tab-wrap{background:rgba(63,81,181,0)}.e-tab.e-background .e-tab-header .e-toolbar-item.e-disable .e-close-icon,.e-tab.e-background .e-tab-header .e-toolbar-item.e-disable .e-tab-icon,.e-tab.e-background .e-tab-header .e-toolbar-item.e-disable .e-tab-text{color:hsla(0,0%,100%,.38)}.e-tab.e-background .e-tab-header .e-toolbar-pop .e-toolbar-item{background:#3f51b5}.e-tab.e-background .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap .e-tab-icon,.e-tab.e-background .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap .e-tab-text{color:hsla(0,0%,100%,.7)}.e-tab.e-background .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap:hover{background:hsla(0,0%,100%,.12)}.e-tab.e-background .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap:hover .e-close-icon,.e-tab.e-background .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap:hover .e-tab-icon,.e-tab.e-background .e-tab-header .e-toolbar-pop .e-toolbar-item .e-tab-wrap:hover .e-tab-text{color:#fff}.e-tab.e-background .e-tab-header .e-hscroll:not(.e-scroll-device) .e-scroll-nav .e-nav-arrow,.e-tab.e-background .e-tab-header .e-scroll-nav .e-nav-arrow{color:hsla(0,0%,100%,.7)}.e-tab.e-background .e-tab-header .e-hscroll:not(.e-scroll-device) .e-scroll-nav .e-nav-arrow:hover,.e-tab.e-background .e-tab-header .e-scroll-nav .e-nav-arrow:hover{background:inherit;color:#fff}.e-tab.e-background .e-tab-header .e-hscroll:not(.e-scroll-device) .e-scroll-nav:focus .e-nav-arrow,.e-tab.e-background .e-tab-header .e-scroll-nav:focus .e-nav-arrow{color:#fff}.e-tab.e-background .e-tab-header .e-hscroll:not(.e-scroll-device) .e-scroll-nav:focus .e-nav-arrow:hover,.e-tab.e-background .e-tab-header .e-scroll-nav:focus .e-nav-arrow:hover{background:inherit;color:#fff}.e-tab.e-background .e-tab-header .e-hscroll:not(.e-scroll-device) .e-scroll-nav:active:after,.e-tab.e-background .e-tab-header .e-scroll-nav:active:after{animation:hscroll-alt-popup-shadow 1s ease-out 0ms}.e-tab.e-background .e-tab-header .e-hor-nav .e-popup-down-icon,.e-tab.e-background .e-tab-header .e-hor-nav .e-popup-up-icon,.e-tab.e-background .e-tab-header .e-hor-nav:not(.e-expended-nav) .e-popup-down-icon,.e-tab.e-background .e-tab-header .e-hor-nav:not(.e-expended-nav) .e-popup-up-icon{color:hsla(0,0%,100%,.7)}.e-tab.e-background .e-tab-header .e-hor-nav .e-popup-down-icon:hover,.e-tab.e-background .e-tab-header .e-hor-nav .e-popup-up-icon:hover,.e-tab.e-background .e-tab-header .e-hor-nav:not(.e-expended-nav) .e-popup-down-icon:hover,.e-tab.e-background .e-tab-header .e-hor-nav:not(.e-expended-nav) .e-popup-up-icon:hover{background:inherit;color:#fff}.e-tab.e-background .e-tab-header .e-hor-nav:focus .e-popup-down-icon,.e-tab.e-background .e-tab-header .e-hor-nav:focus .e-popup-up-icon,.e-tab.e-background .e-tab-header .e-hor-nav:not(.e-expended-nav):focus .e-popup-down-icon,.e-tab.e-background .e-tab-header .e-hor-nav:not(.e-expended-nav):focus .e-popup-up-icon{color:#fff}.e-tab.e-background .e-tab-header .e-hor-nav:active:after,.e-tab.e-background .e-tab-header .e-hor-nav:not(.e-expended-nav):active:after{animation:tbar-alt-popup-shadow 1s ease-out 0ms}.e-tab.e-background .e-tab-header .e-hor-nav.e-nav-active .e-popup-up-icon,.e-tab.e-background .e-tab-header .e-hor-nav:not(.e-expended-nav).e-nav-active .e-popup-up-icon{color:#fff}.e-tab.e-background .e-tab-header.e-vertical .e-scroll-nav .e-nav-arrow,.e-tab.e-background .e-tab-header.e-vertical .e-scroll-nav:focus .e-nav-arrow{border:0}.e-tab.e-background .e-tab-header.e-vertical .e-scroll-nav:focus .e-nav-arrow:hover{background:none}.e-tab.e-background .e-tab-header.e-vertical .e-scroll-nav:hover .e-nav-arrow{color:#fff}.e-tab.e-background .e-tab-header.e-vertical .e-hor-nav .e-popup-down-icon:hover,.e-tab.e-background .e-tab-header.e-vertical .e-hor-nav .e-popup-up-icon:hover,.e-tab.e-background .e-tab-header.e-vertical .e-hor-nav:focus .e-popup-down-icon,.e-tab.e-background .e-tab-header.e-vertical .e-hor-nav:focus .e-popup-down-icon:hover,.e-tab.e-background .e-tab-header.e-vertical .e-hor-nav:focus .e-popup-up-icon,.e-tab.e-background .e-tab-header.e-vertical .e-hor-nav:focus .e-popup-up-icon:hover{background:inherit;border-color:transparent}.e-tab.e-background.e-disable .e-tab-header .e-indicator{background:hsla(0,0%,100%,.38)}.e-tab.e-background.e-disable .e-tab-header .e-toolbar-item .e-tab-wrap,.e-tab.e-background.e-disable .e-tab-header .e-toolbar-item .e-tab-wrap .e-tab-icon,.e-tab.e-background.e-disable .e-tab-header .e-toolbar-item .e-tab-wrap .e-tab-text,.e-tab.e-background.e-disable .e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-tab-icon,.e-tab.e-background.e-disable .e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-tab-text{color:hsla(0,0%,100%,.38)}.e-tab.e-background.e-disable .e-tab-header .e-toolbar-item.e-active{opacity:1}.e-tab.e-background.e-disable .e-tab-header .e-toolbar-item.e-active .e-tab-wrap,.e-tab.e-background.e-disable .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus{background:#3f51b5;color:hsla(0,0%,100%,.38)}.e-tab.e-background.e-disable .e-tab-header .e-toolbar-item.e-active .e-tab-wrap .e-tab-icon,.e-tab.e-background.e-disable .e-tab-header .e-toolbar-item.e-active .e-tab-wrap .e-tab-text,.e-tab.e-background.e-disable .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus .e-tab-icon,.e-tab.e-background.e-disable .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus .e-tab-text{color:hsla(0,0%,100%,.38)}.e-tab.e-background.e-accent .e-tab-header .e-indicator{background:#e3165b}.e-tab.e-background.e-accent .e-tab-header.e-disable .e-indicator{background:rgba(227,22,91,.38)}.e-tab.e-background.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus{background:hsla(0,0%,100%,.12)}.e-tab.e-background.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-close-icon,.e-tab.e-background.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-tab-icon,.e-tab.e-background.e-focused .e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-tab-text{color:hsla(0,0%,100%,.7)}.e-tab.e-background.e-focused .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus{background:hsla(0,0%,100%,.12)}.e-tab.e-background.e-focused .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus .e-tab-icon,.e-tab.e-background.e-focused .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus .e-tab-text{color:#fff}.e-tab.e-background.e-focused .e-tab-header .e-toolbar-item.e-active.e-ibottom .e-tab-wrap,.e-tab.e-background.e-focused .e-tab-header .e-toolbar-item.e-active.e-itop .e-tab-wrap{background:rgba(63,81,181,0)}.e-tab.e-background.e-focused .e-tab-header .e-toolbar-item.e-active.e-ibottom .e-tab-wrap:focus,.e-tab.e-background.e-focused .e-tab-header .e-toolbar-item.e-active.e-itop .e-tab-wrap:focus{background:hsla(0,0%,100%,.12)}.e-tab.e-background.e-focused .e-tab-header .e-hor-nav:focus .e-popup-down-icon,.e-tab.e-background.e-focused .e-tab-header .e-hor-nav:focus .e-popup-up-icon,.e-tab.e-background.e-focused .e-tab-header .e-scroll-nav:focus .e-nav-arrow{color:hsla(0,0%,100%,.87)}.e-tab.e-rtl .e-tab-header .e-hscroll.e-rtl .e-scroll-nav{border:0}.e-tab .e-content{background:inherit}.e-tab .e-content .e-item{background:inherit;color:#000}.e-tab-clone-element{background:#fff;color:rgba(0,0,0,.54)}.e-tab-clone-element .e-tab-wrap{border-radius:0;color:rgba(0,0,0,.54)}.e-tab-clone-element .e-tab-wrap .e-tab-icon{color:rgba(0,0,0,.54)}@keyframes e-input-ripple{to{opacity:0;transform:scale(4)}}@keyframes slideTopUp{0%{transform:translateZ(0) scale(1)}to{transform:translateZ(0) scale(1)}}\n/*! TreeView's material theme wise override definitions and variables */\n/*! TreeView icons */.e-treeview .e-list-item div.e-icons:before{content:\"\\E22F\"}.e-treeview .e-sibling:before{content:\"\"}.e-treeview .e-popup .e-icons:before{content:\"\\E930\"}.e-treeview.e-drag-item .e-icons.e-drop-in:before{content:\"\\E22C\"}.e-treeview.e-drag-item .e-icons.e-drop-out:before{content:\"\\E22B\"}.e-treeview.e-drag-item .e-icons.e-drop-next:before{content:\"\\E22D\"}.e-treeview.e-drag-item .e-icons.e-no-drop:before{content:\"\\E22A\"}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.e-bigger .e-treeview .e-navigable .e-text-content,.e-treeview.e-bigger .e-navigable .e-text-content{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex}.e-bigger .e-treeview .e-navigable .e-list-text,.e-treeview.e-bigger .e-navigable .e-list-text{padding:0;width:100%}.e-bigger .e-treeview .e-navigable .e-checkbox-wrapper+.e-list-text,.e-treeview.e-bigger .e-navigable .e-checkbox-wrapper+.e-list-text{padding:0}.e-bigger .e-treeview .e-navigable .e-checkbox-wrapper+.e-list-url .e-anchor-wrap .e-list-icon,.e-bigger .e-treeview .e-navigable .e-checkbox-wrapper+.e-list-url .e-anchor-wrap .e-list-img,.e-treeview.e-bigger .e-navigable .e-checkbox-wrapper+.e-list-url .e-anchor-wrap .e-list-icon,.e-treeview.e-bigger .e-navigable .e-checkbox-wrapper+.e-list-url .e-anchor-wrap .e-list-img{margin:0 10px 0 6px}.e-bigger .e-treeview .e-navigable .e-anchor-wrap,.e-treeview.e-bigger .e-navigable .e-anchor-wrap{padding:0 0 0 10px}.e-bigger .e-treeview .e-navigable .e-list-icon,.e-bigger .e-treeview .e-navigable .e-list-icon+.e-list-img,.e-bigger .e-treeview .e-navigable .e-list-img,.e-treeview.e-bigger .e-navigable .e-list-icon,.e-treeview.e-bigger .e-navigable .e-list-icon+.e-list-img,.e-treeview.e-bigger .e-navigable .e-list-img{margin:0 10px 0 0}.e-bigger .e-treeview .e-fullrow,.e-treeview.e-bigger .e-fullrow{height:40px}.e-bigger .e-treeview.e-text-wrap .e-checkbox-wrapper+.e-list-text,.e-treeview.e-bigger.e-text-wrap .e-checkbox-wrapper+.e-list-text{max-width:calc(100% - 29px)}.e-bigger .e-treeview.e-text-wrap .e-checkbox-wrapper+.e-list-icon+.e-list-text,.e-bigger .e-treeview.e-text-wrap .e-checkbox-wrapper+.e-list-img+.e-list-text,.e-treeview.e-bigger.e-text-wrap .e-checkbox-wrapper+.e-list-icon+.e-list-text,.e-treeview.e-bigger.e-text-wrap .e-checkbox-wrapper+.e-list-img+.e-list-text{max-width:calc(100% - 70px)}.e-bigger .e-treeview.e-text-wrap .e-checkbox-wrapper+.e-list-icon+.e-list-img+.e-list-text,.e-treeview.e-bigger.e-text-wrap .e-checkbox-wrapper+.e-list-icon+.e-list-img+.e-list-text{max-width:calc(100% - 98px)}.e-bigger .e-treeview.e-text-wrap .e-list-icon+.e-list-text,.e-bigger .e-treeview.e-text-wrap .e-list-img+.e-list-text,.e-treeview.e-bigger.e-text-wrap .e-list-icon+.e-list-text,.e-treeview.e-bigger.e-text-wrap .e-list-img+.e-list-text{max-width:calc(100% - 34px)}.e-bigger .e-treeview.e-text-wrap .e-list-icon+.e-list-img+.e-list-text,.e-treeview.e-bigger.e-text-wrap .e-list-icon+.e-list-img+.e-list-text{max-width:calc(100% - 62px)}.e-bigger .e-treeview .e-list-text,.e-treeview.e-bigger .e-list-text{line-height:38px;min-height:38px;padding:0 10px}.e-bigger .e-treeview .e-list-text .e-input-group,.e-treeview.e-bigger .e-list-text .e-input-group{height:38px}.e-bigger .e-treeview .e-checkbox-wrapper,.e-treeview.e-bigger .e-checkbox-wrapper{margin:0 0 0 10px}.e-bigger .e-treeview .e-checkbox-wrapper+.e-list-icon,.e-bigger .e-treeview .e-checkbox-wrapper+.e-list-img,.e-treeview.e-bigger .e-checkbox-wrapper+.e-list-icon,.e-treeview.e-bigger .e-checkbox-wrapper+.e-list-img{margin:0 0 0 16px}.e-bigger .e-treeview .e-list-icon,.e-bigger .e-treeview .e-list-icon+.e-list-icon,.e-bigger .e-treeview .e-list-icon+.e-list-img,.e-bigger .e-treeview .e-list-img,.e-bigger .e-treeview .e-list-img+.e-list-icon,.e-bigger .e-treeview .e-list-img+.e-list-img,.e-treeview.e-bigger .e-list-icon,.e-treeview.e-bigger .e-list-icon+.e-list-icon,.e-treeview.e-bigger .e-list-icon+.e-list-img,.e-treeview.e-bigger .e-list-img,.e-treeview.e-bigger .e-list-img+.e-list-icon,.e-treeview.e-bigger .e-list-img+.e-list-img{margin:0 0 0 10px}.e-bigger .e-treeview .e-icon-collapsible:before,.e-bigger .e-treeview .e-icon-expandable:before,.e-treeview.e-bigger .e-icon-collapsible:before,.e-treeview.e-bigger .e-icon-expandable:before{padding:6px}.e-bigger .e-treeview.e-rtl .e-navigable .e-checkbox-wrapper+.e-list-url .e-anchor-wrap .e-list-icon,.e-bigger .e-treeview.e-rtl .e-navigable .e-checkbox-wrapper+.e-list-url .e-anchor-wrap .e-list-img,.e-treeview.e-bigger.e-rtl .e-navigable .e-checkbox-wrapper+.e-list-url .e-anchor-wrap .e-list-icon,.e-treeview.e-bigger.e-rtl .e-navigable .e-checkbox-wrapper+.e-list-url .e-anchor-wrap .e-list-img{margin:0 6px 0 10px}.e-bigger .e-treeview.e-rtl .e-navigable .e-anchor-wrap,.e-treeview.e-bigger.e-rtl .e-navigable .e-anchor-wrap{padding:0 10px 0 0}.e-bigger .e-treeview.e-rtl .e-navigable .e-list-icon,.e-bigger .e-treeview.e-rtl .e-navigable .e-list-icon+.e-list-img,.e-bigger .e-treeview.e-rtl .e-navigable .e-list-img,.e-treeview.e-bigger.e-rtl .e-navigable .e-list-icon,.e-treeview.e-bigger.e-rtl .e-navigable .e-list-icon+.e-list-img,.e-treeview.e-bigger.e-rtl .e-navigable .e-list-img{margin:0 0 0 10px}.e-bigger .e-treeview.e-rtl .e-checkbox-wrapper,.e-treeview.e-bigger.e-rtl .e-checkbox-wrapper{margin:0 10px 0 0}.e-bigger .e-treeview.e-rtl .e-checkbox-wrapper+.e-list-icon,.e-bigger .e-treeview.e-rtl .e-checkbox-wrapper+.e-list-img,.e-treeview.e-bigger.e-rtl .e-checkbox-wrapper+.e-list-icon,.e-treeview.e-bigger.e-rtl .e-checkbox-wrapper+.e-list-img{margin:0 16px 0 0}.e-bigger .e-treeview.e-rtl .e-list-icon,.e-bigger .e-treeview.e-rtl .e-list-icon+.e-list-icon,.e-bigger .e-treeview.e-rtl .e-list-icon+.e-list-img,.e-bigger .e-treeview.e-rtl .e-list-img,.e-bigger .e-treeview.e-rtl .e-list-img+.e-list-icon,.e-bigger .e-treeview.e-rtl .e-list-img+.e-list-img,.e-treeview.e-bigger.e-rtl .e-list-icon,.e-treeview.e-bigger.e-rtl .e-list-icon+.e-list-icon,.e-treeview.e-bigger.e-rtl .e-list-icon+.e-list-img,.e-treeview.e-bigger.e-rtl .e-list-img,.e-treeview.e-bigger.e-rtl .e-list-img+.e-list-icon,.e-treeview.e-bigger.e-rtl .e-list-img+.e-list-img{margin:0 10px 0 0}.e-treeview{display:block;overflow:hidden;position:relative;white-space:nowrap}.e-treeview>.e-ul{-webkit-overflow-scrolling:touch;overflow:auto}.e-treeview.e-text-wrap .e-list-text{white-space:normal;word-break:break-word}.e-treeview.e-text-wrap.e-ie-wrap .e-list-text{word-break:break-all}.e-treeview.e-text-wrap .e-editing .e-list-text,.e-treeview.e-text-wrap .e-editing .e-list-text .e-input-group{max-width:calc(100% - 2px)}.e-treeview.e-text-wrap .e-checkbox-wrapper+.e-list-text{max-width:calc(100% - 22px)}.e-treeview.e-text-wrap .e-checkbox-wrapper+.e-list-icon+.e-list-text,.e-treeview.e-text-wrap .e-checkbox-wrapper+.e-list-img+.e-list-text{max-width:calc(100% - 59px)}.e-treeview.e-text-wrap .e-checkbox-wrapper+.e-list-icon+.e-list-img+.e-list-text{max-width:calc(100% - 87px)}.e-treeview.e-text-wrap .e-list-icon+.e-list-text,.e-treeview.e-text-wrap .e-list-img+.e-list-text{max-width:calc(100% - 29px)}.e-treeview.e-text-wrap .e-list-icon+.e-list-img+.e-list-text{max-width:calc(100% - 57px)}.e-treeview .e-ul{margin:0;padding:0 0 0 24px}.e-treeview .e-display-none,.e-treeview li.e-node-collapsed .e-list-item .e-fullrow{display:none}.e-treeview .e-list-item div.e-icons.interaction{-webkit-transition:-webkit-transform .3s ease-in-out;border-radius:15px;transition:transform .3s ease-in-out}.e-treeview .e-list-item .e-icons.e-icon-collapsible{transform:rotate(90deg)}.e-treeview.e-drag-item.e-rtl .e-icons.e-drop-next,.e-treeview.e-rtl div.e-icons{transform:rotate(180deg)}.e-treeview .e-list-item{list-style:none;padding:2px 0}.e-treeview .e-list-item .e-ul{margin:2px 0 -2px;padding:0 0 0 24px}.e-treeview .e-list-item.e-disable>.e-fullrow,.e-treeview .e-list-item.e-disable>.e-text-content{-ms-touch-action:none;filter:alpha(opacity=50);opacity:.5;pointer-events:none;touch-action:none}.e-treeview .e-list-item .e-icons.e-icons-spinner:before{content:none}.e-treeview .e-icons .e-spinner-pane{position:relative}.e-treeview .e-icons .e-treeview-spinner{position:absolute}.e-treeview .e-icons-spinner{position:relative}.e-treeview .e-text-content{margin:0;padding:0 0 0 24px}.e-treeview .e-fullrow,.e-treeview .e-text-content{-ms-user-select:none;-webkit-user-select:none;user-select:none;border:1px solid;cursor:pointer}.e-treeview .e-fullrow{box-sizing:border-box;height:32px;left:0;overflow:hidden;position:absolute;width:100%}.e-treeview .e-checkbox-wrapper{margin:0 0 0 5px;pointer-events:all;position:relative}.e-treeview .e-checkbox-wrapper+.e-list-icon,.e-treeview .e-checkbox-wrapper+.e-list-img{margin:0 0 0 12px}.e-treeview .e-checkbox-wrapper+.e-list-text{padding:0 10px}.e-treeview .e-checkbox-wrapper .e-ripple-container{bottom:-7px;height:32px;left:-7px;right:-7px;top:-7px;width:32px}.e-treeview .e-list-text{box-sizing:border-box;display:inline-block;line-height:30px;margin:0;min-height:30px;padding:0 5px;text-decoration:none;vertical-align:middle}.e-treeview .e-list-text .e-input-group{height:30px;margin-bottom:0;min-width:150px;vertical-align:bottom}.e-treeview .e-list-icon,.e-treeview .e-list-img{display:inline-block;height:18px;margin:0 0 0 5px;vertical-align:middle;width:18px}.e-treeview .e-list-icon+.e-list-icon,.e-treeview .e-list-icon+.e-list-img,.e-treeview .e-list-img+.e-list-icon,.e-treeview .e-list-img+.e-list-img{margin:0 0 0 10px}.e-treeview .e-list-icon+.e-list-text,.e-treeview .e-list-img+.e-list-text{padding:0 10px}.e-treeview .e-icon-collapsible,.e-treeview .e-icon-expandable{display:inline-block;height:24px;margin:0 0 0 -24px;vertical-align:middle;width:24px}.e-treeview .e-icon-collapsible:before,.e-treeview .e-icon-expandable:before{display:inline-block;padding:7px}.e-treeview .e-load{animation:rotation .5s infinite linear}.e-treeview .e-sibling{border-radius:10px;height:6px;margin-top:-5px;width:6px;position:absolute;z-index:2}.e-treeview .e-text-content+.e-sibling{margin-top:-1px}.e-treeview .e-sibling:before{left:6px;top:3px;height:1px;width:144px;position:absolute;z-index:2}.e-treeview .e-popup{-ms-user-select:none;-webkit-user-select:none;user-select:none;font-weight:400;position:absolute;z-index:99999}.e-treeview .e-popup .e-content{border-radius:4px;border-style:solid;border-width:1px;font-size:14px;padding:4px}.e-treeview .e-popup .e-icons{border:1px solid transparent;cursor:pointer;display:inline-block;height:26px;line-height:18px;padding:4px;width:26px}.e-treeview .e-popup .e-downtail:after,.e-treeview .e-popup .e-downtail:before{border:10px solid transparent;content:\"\";height:0;left:8px;position:absolute;width:0}.e-treeview .e-popup .e-downtail:after{bottom:-18px}.e-treeview.e-fullrow-wrap .e-text-content{pointer-events:none;position:relative}.e-treeview.e-fullrow-wrap .e-icon-collapsible,.e-treeview.e-fullrow-wrap .e-icon-expandable,.e-treeview.e-fullrow-wrap .e-input,.e-treeview.e-fullrow-wrap .e-list-url{pointer-events:auto}.e-treeview .e-navigable .e-text-content{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex}.e-treeview .e-navigable .e-list-url{padding:0;width:100%}.e-treeview .e-navigable .e-checkbox-wrapper+.e-list-url .e-anchor-wrap{padding:0 0 0 10px}.e-treeview .e-navigable .e-checkbox-wrapper+.e-list-url .e-anchor-wrap .e-list-icon,.e-treeview .e-navigable .e-checkbox-wrapper+.e-list-url .e-anchor-wrap .e-list-img{margin:0 10px 0 2px}.e-treeview .e-navigable .e-checkbox-wrapper+.e-list-url .e-anchor-wrap .e-list-icon+.e-list-img{margin:0 10px 0 0}.e-treeview .e-navigable .e-anchor-wrap{padding:0 0 0 5px}.e-treeview .e-navigable .e-list-icon,.e-treeview .e-navigable .e-list-img{margin:0 10px 0 0}.e-treeview.e-drag-item{overflow:visible;z-index:10000}.e-treeview.e-drag-item .e-text-content{float:left}.e-treeview.e-drag-item .e-icon-collapsible:before,.e-treeview.e-drag-item .e-icon-expandable:before{padding:6px}.e-treeview.e-drag-item .e-drop-count{border:1px solid;border-radius:15px;box-sizing:content-box;font-size:13px;line-height:normal;min-width:12px;padding:3px 5px 4px;margin-left:-12px;position:absolute;text-align:center;top:-10px}.e-treeview.e-dragging .e-fullrow,.e-treeview.e-dragging .e-text-content{cursor:default}.e-treeview.e-rtl .e-navigable .e-checkbox-wrapper+.e-list-url .e-anchor-wrap{padding:0 10px 0 0}.e-treeview.e-rtl .e-navigable .e-checkbox-wrapper+.e-list-url .e-anchor-wrap .e-list-icon,.e-treeview.e-rtl .e-navigable .e-checkbox-wrapper+.e-list-url .e-anchor-wrap .e-list-img{margin:0 2px 0 10px}.e-treeview.e-rtl .e-navigable .e-checkbox-wrapper+.e-list-url .e-anchor-wrap .e-list-icon+.e-list-img{margin:0 0 0 10px}.e-treeview.e-rtl .e-navigable .e-anchor-wrap{padding:0 5px 0 0}.e-treeview.e-rtl .e-navigable .e-list-icon,.e-treeview.e-rtl .e-navigable .e-list-icon+.e-list-img,.e-treeview.e-rtl .e-navigable .e-list-img{margin:0 0 0 10px}.e-treeview.e-rtl .e-list-item .e-ul,.e-treeview.e-rtl .e-text-content,.e-treeview.e-rtl .e-ul{padding:0 24px 0 0}.e-treeview.e-rtl .e-checkbox-wrapper{margin:0 5px 0 0}.e-treeview.e-rtl .e-checkbox-wrapper+.e-list-icon,.e-treeview.e-rtl .e-checkbox-wrapper+.e-list-img{margin:0 12px 0 0}.e-treeview.e-rtl .e-list-icon,.e-treeview.e-rtl .e-list-img{margin:0 5px 0 0}.e-treeview.e-rtl .e-list-icon+.e-list-icon,.e-treeview.e-rtl .e-list-icon+.e-list-img,.e-treeview.e-rtl .e-list-img+.e-list-icon,.e-treeview.e-rtl .e-list-img+.e-list-img{margin:0 10px 0 0}.e-treeview.e-rtl .e-icon-collapsible,.e-treeview.e-rtl .e-icon-expandable{margin:0 -24px 0 0}.e-treeview.e-rtl .e-sibling:before{right:6px;top:3px}.e-treeview.e-rtl.e-drag-item .e-text-content{float:right}.e-treeview.e-rtl.e-drag-item .e-drop-count{margin-right:-12px}.e-treeview.e-disabled .e-fullrow,.e-treeview.e-disabled .e-icons,.e-treeview.e-disabled .e-list-icon,.e-treeview.e-disabled .e-list-img,.e-treeview.e-disabled .e-text-content{cursor:auto}.e-treeview.e-disabled .e-list-url{cursor:default;pointer-events:none}.e-treeview.e-interaction.e-fullrow-wrap .e-text-content{pointer-events:auto}.e-bigger .e-treeview .e-list-text,.e-treeview.e-bigger .e-list-text{font-size:14px}.e-bigger .e-treeview .e-icon-collapsible:before,.e-bigger .e-treeview .e-icon-expandable:before,.e-treeview.e-bigger .e-icon-collapsible:before,.e-treeview.e-bigger .e-icon-expandable:before{font-size:12px}.e-treeview{-webkit-tap-highlight-color:transparent}.e-treeview .e-fullrow,.e-treeview .e-text-content{border-color:transparent}.e-treeview .e-list-text{color:rgba(0,0,0,.87);font-size:13px}.e-treeview .e-list-icon,.e-treeview .e-list-img{font-size:18px}.e-treeview .e-icon-collapsible,.e-treeview .e-icon-expandable{color:rgba(0,0,0,.54)}.e-treeview .e-icon-collapsible:before,.e-treeview .e-icon-expandable:before{font-size:10px}.e-treeview .e-list-item.e-active,.e-treeview .e-list-item.e-hover{background:transparent}.e-treeview .e-list-item.e-hover>.e-text-content,.e-treeview .e-list-item.e-hover>.e-text-content .e-list-text{color:rgba(0,0,0,.87)}.e-treeview .e-list-item.e-hover>.e-text-content .e-icon-collapsible,.e-treeview .e-list-item.e-hover>.e-text-content .e-icon-expandable{color:rgba(0,0,0,.54)}.e-treeview .e-list-item.e-active>.e-text-content,.e-treeview .e-list-item.e-active>.e-text-content .e-list-text{color:#e3165b}.e-treeview .e-list-item.e-active>.e-text-content .e-icon-collapsible,.e-treeview .e-list-item.e-active>.e-text-content .e-icon-expandable{color:rgba(0,0,0,.54)}.e-treeview .e-list-item.e-active.e-hover>.e-text-content,.e-treeview .e-list-item.e-active.e-hover>.e-text-content .e-list-text{color:#e3165b}.e-treeview .e-list-item.e-active.e-hover>.e-text-content .e-icon-collapsible,.e-treeview .e-list-item.e-active.e-hover>.e-text-content .e-icon-expandable{color:rgba(0,0,0,.54)}.e-treeview .e-list-item.e-editing.e-active>.e-text-content,.e-treeview .e-list-item.e-editing.e-active>.e-text-content .e-list-text,.e-treeview .e-list-item.e-editing.e-hover>.e-text-content,.e-treeview .e-list-item.e-editing.e-hover>.e-text-content .e-list-text{color:rgba(0,0,0,.87)}.e-treeview .e-list-item.e-editing.e-active>.e-text-content .e-icon-collapsible,.e-treeview .e-list-item.e-editing.e-active>.e-text-content .e-icon-expandable,.e-treeview .e-list-item.e-editing.e-hover>.e-text-content .e-icon-collapsible,.e-treeview .e-list-item.e-editing.e-hover>.e-text-content .e-icon-expandable{color:rgba(0,0,0,.54)}.e-treeview .e-list-item.e-hover>.e-fullrow{background-color:#f5f5f5;border-color:#f5f5f5}.e-treeview .e-list-item.e-active>.e-fullrow{background-color:#eee;border-color:#eee}.e-treeview .e-list-item.e-active.e-animation-active>.e-fullrow{background-color:transparent;border-color:transparent}.e-treeview .e-list-item.e-active.e-animation-active>.e-text-content,.e-treeview .e-list-item.e-active.e-animation-active>.e-text-content .e-list-text{color:rgba(0,0,0,.87)}.e-treeview .e-list-item.e-active.e-hover>.e-fullrow{background-color:#e0e0e0;border-color:#e0e0e0}.e-treeview .e-list-item.e-editing.e-active>.e-fullrow,.e-treeview .e-list-item.e-editing.e-hover>.e-fullrow{background-color:transparent;border-color:transparent}.e-treeview .e-list-item.e-disable>.e-fullrow,.e-treeview .e-list-item.e-disable>.e-text-content{color:rgba(0,0,0,.54)}.e-treeview .e-list-item.e-disable>.e-text-content>.e-icon-collapsible,.e-treeview .e-list-item.e-disable>.e-text-content>.e-icon-expandable{color:rgba(0,0,0,.87)}.e-treeview .e-sibling{background:#e3165b}.e-treeview .e-sibling:before{background:rgba(0,0,0,.54)}.e-treeview .e-popup .e-content{background-color:#fff;border-color:#eee}.e-treeview .e-popup.e-select .e-icons{border-color:#eee}.e-treeview .e-popup .e-downtail:before{border-top-color:#eee}.e-treeview .e-popup .e-downtail:after{border-top-color:#fff}.e-treeview:not(.e-fullrow-wrap) .e-list-item.e-hover>.e-text-content{background-color:#f5f5f5;border-color:#f5f5f5}.e-treeview:not(.e-fullrow-wrap) .e-list-item.e-active>.e-text-content{background-color:#eee;border-color:#eee}.e-treeview:not(.e-fullrow-wrap) .e-list-item.e-active.e-hover>.e-text-content{background-color:#e0e0e0;border-color:#e0e0e0}.e-treeview:not(.e-fullrow-wrap) .e-list-item.e-editing.e-active>.e-text-content,.e-treeview:not(.e-fullrow-wrap) .e-list-item.e-editing.e-hover>.e-text-content{background-color:transparent;border-color:transparent}.e-treeview.e-fullrow-wrap .e-text-content{border-color:transparent}.e-treeview.e-drag-item{background-color:#eee;font-family:Roboto,Segoe UI,GeezaPro,DejaVu Serif,\"sans-serif\",-apple-system,BlinkMacSystemFont}.e-treeview.e-drag-item .e-icon-collapsible:before,.e-treeview.e-drag-item .e-icon-expandable:before{font-size:12px}.e-treeview.e-drag-item .e-icons,.e-treeview.e-drag-item .e-list-text{color:rgba(0,0,0,.54)}.e-treeview.e-drag-item .e-drop-count{background-color:#e3165b;border-color:#fff;color:#fff}.e-treeview.e-drag-item.e-rtl .e-sibling{background:#e3165b}\n\n/*! Material theme definition's */\n/*! component's theme wise override definitions and variables */ejs-sidebar{display:none}.e-sidebar-display{display:block}.e-sidebar{-webkit-tap-highlight-color:transparent;background:#fff;height:100%;overflow:auto;position:fixed;top:0;transition:none;vertical-align:middle;visibility:hidden;will-change:transform}.e-sidebar.e-left.e-open,.e-sidebar.e-right.e-open{transform:translateX(0);transition:transform .5s ease;visibility:visible}.e-sidebar.e-left.e-transition.e-close,.e-sidebar.e-right.e-transition.e-close{transition:transform .5s ease,visibility .5s}.e-sidebar.e-left.e-close{box-shadow:none;transform:translateX(-100%);visibility:hidden}.e-sidebar.e-right.e-close{box-shadow:none;transform:translateX(100%);transition:transform .5s ease,visibility .5s;visibility:hidden}.e-sidebar.e-right{border-left:1px solid rgba(0,0,0,.12);left:auto;right:0;top:0}.e-sidebar.e-left{border-right:1px solid rgba(0,0,0,.12);left:0;right:auto;top:0}.e-sidebar.e-left.e-close.e-dock,.e-sidebar.e-right.e-close.e-dock{transform:translateX(0);transition:width .5s ease,visibility .5s;visibility:visible}.e-sidebar.e-left.e-open.e-dock.e-blazor-dock,.e-sidebar.e-right.e-open.e-dock.e-blazor-dock{transition:width .5s ease,visibility .5s}.e-sidebar.e-left.e-close.e-disable-animation,.e-sidebar.e-left.e-open.e-disable-animation,.e-sidebar.e-right.e-close.e-disable-animation,.e-sidebar.e-right.e-open.e-disable-animation{transition:none}.e-sidebar.e-visibility{visibility:hidden}.e-sidebar.e-over{box-shadow:0 0 16px rgba(0,0,0,.18)}.e-sidebar-absolute{position:absolute}.e-sidebar-context{overflow-x:hidden;position:relative}.e-backdrop{background-color:rgba(0,0,0,.6);height:100%;left:0;opacity:.5;pointer-events:auto;top:0;width:auto;z-index:999}.e-content-animation{transition:margin .5s ease,transform .5s ease}.e-content-animation.e-overlay{box-sizing:border-box;overflow:auto;-webkit-user-select:none;-ms-user-select:none;user-select:none}.e-disable-interaction{pointer-events:none;-ms-touch-action:none;touch-action:none}.e-sidebar-overflow{overflow-x:hidden!important}.e-sidebar-overlay{background-color:rgba(0,0,0,.6);height:100%;left:0;opacity:.5;pointer-events:auto;position:fixed;top:0;width:100%;z-index:999}.e-content-placeholder.e-sidebar.e-placeholder-sidebar{left:0;position:fixed;right:auto;top:0;visibility:visible}\n\n/*! component's theme wise override definitions and variables */@keyframes hscroll-popup-shadow{0%{border-color:hsla(0,0%,100%,.5);box-shadow:0 0 0 0 hsla(0,0%,100%,.5)}to{box-shadow:0 0 0 200px hsla(0,0%,100%,.12)}}\n/*! component's theme wise override definitions and variables */@keyframes vscroll-popup-shadow{0%{border-color:hsla(0,0%,100%,.5);box-shadow:0 0 0 0 hsla(0,0%,100%,.5)}to{box-shadow:0 0 0 200px hsla(0,0%,100%,.12)}}\n/*! menu layout */.e-menu-container ul.e-vertical .e-menu-item .e-caret:before,.e-menu-wrapper ul.e-vertical .e-menu-item .e-caret:before{content:\"\\E956\"}.e-menu-container ul .e-menu-item .e-caret:before,.e-menu-wrapper ul .e-menu-item .e-caret:before{content:\"\\E94D\"}.e-menu-container .e-ul .e-menu-item .e-caret:before,.e-menu-wrapper .e-ul .e-menu-item .e-caret:before{content:\"\\E956\"}.e-menu-container.e-hamburger .e-menu-header .e-menu-icon:before,.e-menu-wrapper.e-hamburger .e-menu-header .e-menu-icon:before{content:\"\\E99A\"}.e-menu-container.e-hamburger.e-close-icon .e-menu-header .e-menu-icon:before,.e-menu-wrapper.e-hamburger.e-close-icon .e-menu-header .e-menu-icon:before{content:\"\\EB36\"}.e-menu-container.e-hamburger .e-menu-item .e-caret:before,.e-menu-container.e-hamburger .e-vertical .e-menu-item .e-caret:before,.e-menu-container.e-rtl.e-hamburger ul.e-ul .e-caret:before,.e-menu-wrapper.e-hamburger .e-menu-item .e-caret:before,.e-menu-wrapper.e-hamburger .e-vertical .e-menu-item .e-caret:before,.e-menu-wrapper.e-rtl.e-hamburger ul.e-ul .e-caret:before{content:\"\\E94D\"}.e-menu-container .e-menu-hscroll.e-hscroll .e-nav-left-arrow:before,.e-menu-container .e-menu-hscroll.e-hscroll .e-nav-right-arrow:before,.e-menu-wrapper .e-menu-hscroll.e-hscroll .e-nav-left-arrow:before,.e-menu-wrapper .e-menu-hscroll.e-hscroll .e-nav-right-arrow:before{content:\"\\E956\"}.e-menu-container .e-menu-vscroll.e-vscroll .e-nav-down-arrow:before,.e-menu-container .e-menu-vscroll.e-vscroll .e-nav-up-arrow:before,.e-menu-wrapper .e-menu-vscroll.e-vscroll .e-nav-down-arrow:before,.e-menu-wrapper .e-menu-vscroll.e-vscroll .e-nav-up-arrow:before{content:\"\\E94D\"}.e-bigger.e-rtl.e-menu-container ul.e-ul .e-caret:before,.e-bigger .e-rtl.e-menu-container ul.e-ul .e-caret:before,.e-bigger.e-rtl.e-menu-container ul.e-vertical .e-caret:before,.e-bigger .e-rtl.e-menu-container ul.e-vertical .e-caret:before,.e-bigger.e-rtl.e-menu-wrapper ul.e-ul .e-caret:before,.e-bigger .e-rtl.e-menu-wrapper ul.e-ul .e-caret:before,.e-bigger.e-rtl.e-menu-wrapper ul.e-vertical .e-caret:before,.e-bigger .e-rtl.e-menu-wrapper ul.e-vertical .e-caret:before,.e-rtl.e-menu-container ul.e-ul .e-caret:before,.e-rtl.e-menu-container ul.e-vertical .e-caret:before,.e-rtl.e-menu-wrapper ul.e-ul .e-caret:before,.e-rtl.e-menu-wrapper ul.e-vertical .e-caret:before{content:\"\\E937\"}.e-bigger.e-rtl.e-menu-container.e-hamburger ul.e-ul .e-caret:before,.e-bigger .e-rtl.e-menu-container.e-hamburger ul.e-ul .e-caret:before,.e-bigger.e-rtl.e-menu-wrapper.e-hamburger ul.e-ul .e-caret:before,.e-bigger .e-rtl.e-menu-wrapper.e-hamburger ul.e-ul .e-caret:before{content:\"\\E94D\"}\n\n/*! menu layout */.e-menu-container,.e-menu-wrapper{border:none;border-radius:0;display:inline-block;line-height:0}.e-menu-container .e-menu-vscroll,.e-menu-wrapper .e-menu-vscroll{height:inherit}.e-menu-container ul,.e-menu-wrapper ul{font-weight:400;list-style-image:none;list-style-position:outside;list-style-type:none;margin:0;overflow:hidden;-webkit-user-select:none;-ms-user-select:none;user-select:none;font-size:13px;padding:0;text-align:left;white-space:nowrap}.e-menu-container ul.e-ul,.e-menu-container ul.e-ul *,.e-menu-wrapper ul.e-ul,.e-menu-wrapper ul.e-ul *{box-sizing:border-box}.e-menu-container ul.e-ul:focus,.e-menu-container ul.e-ul :focus,.e-menu-wrapper ul.e-ul:focus,.e-menu-wrapper ul.e-ul :focus{outline:none}.e-menu-container ul.e-vertical,.e-menu-wrapper ul.e-vertical{min-width:120px}.e-menu-container ul.e-vertical .e-menu-item,.e-menu-wrapper ul.e-vertical .e-menu-item{display:list-item}.e-menu-container ul.e-vertical .e-separator,.e-menu-wrapper ul.e-vertical .e-separator{border-bottom-style:solid;border-bottom-width:1px;height:auto}.e-menu-container ul.e-menu,.e-menu-wrapper ul.e-menu{display:inline-block}.e-menu-container ul.e-menu:not(.e-vertical),.e-menu-wrapper ul.e-menu:not(.e-vertical){padding:0}.e-menu-container ul.e-menu:not(.e-vertical) .e-separator,.e-menu-wrapper ul.e-menu:not(.e-vertical) .e-separator{border-right-style:solid;border-right-width:1px;padding:0}.e-menu-container ul.e-menu .e-menu-item .e-menu-icon,.e-menu-wrapper ul.e-menu .e-menu-item .e-menu-icon{width:24px}.e-menu-container ul .e-menu-item,.e-menu-wrapper ul .e-menu-item{cursor:pointer;position:relative;display:-ms-inline-flexbox;display:inline-flex;height:42px;line-height:42px;padding:0 12px;vertical-align:top;white-space:nowrap}.e-menu-container ul .e-menu-item.e-menu-hide,.e-menu-wrapper ul .e-menu-item.e-menu-hide{display:none}.e-menu-container ul .e-menu-item.e-menu-header,.e-menu-wrapper ul .e-menu-item.e-menu-header{border-bottom-style:solid;border-bottom-width:1px}.e-menu-container ul .e-menu-item .e-menu-url,.e-menu-wrapper ul .e-menu-item .e-menu-url{text-decoration:none}.e-menu-container ul .e-menu-item .e-menu-icon,.e-menu-wrapper ul .e-menu-item .e-menu-icon{display:inline-block;vertical-align:middle}.e-menu-container ul .e-menu-item.e-separator,.e-menu-wrapper ul .e-menu-item.e-separator{cursor:auto;line-height:normal;pointer-events:none}.e-menu-container ul .e-menu-item .e-menu-icon,.e-menu-wrapper ul .e-menu-item .e-menu-icon{font-size:14px;height:auto;line-height:42px;margin-right:8px;text-align:center}.e-menu-container ul .e-menu-item .e-caret,.e-menu-wrapper ul .e-menu-item .e-caret{font-size:10px;height:auto;line-height:42px;position:absolute;right:12px;top:0;width:auto}.e-menu-container ul .e-menu-item.e-menu-caret-icon,.e-menu-wrapper ul .e-menu-item.e-menu-caret-icon{padding-right:30px}.e-menu-container ul .e-menu-item.e-disabled,.e-menu-wrapper ul .e-menu-item.e-disabled{cursor:auto;opacity:.38;pointer-events:none}.e-menu-container .e-ul,.e-menu-wrapper .e-ul{font-size:14px;padding:0;min-width:120px}.e-menu-container .e-ul .e-menu-item,.e-menu-wrapper .e-ul .e-menu-item{height:36px;line-height:36px;padding:0 16px;display:list-item}.e-menu-container .e-ul .e-menu-item .e-menu-url,.e-menu-wrapper .e-ul .e-menu-item .e-menu-url{display:inline-block;min-width:120px}.e-menu-container .e-ul .e-menu-item .e-menu-icon,.e-menu-wrapper .e-ul .e-menu-item .e-menu-icon{font-size:14px;line-height:36px;margin-right:10px;width:1em}.e-menu-container .e-ul .e-menu-item .e-caret,.e-menu-wrapper .e-ul .e-menu-item .e-caret{line-height:36px;margin-left:16px;margin-right:0;position:absolute;right:8px}.e-menu-container .e-ul .e-menu-item.e-menu-caret-icon,.e-menu-wrapper .e-ul .e-menu-item.e-menu-caret-icon{padding-right:36px}.e-menu-container .e-ul .e-menu-item.e-separator,.e-menu-wrapper .e-ul .e-menu-item.e-separator{border-bottom-style:solid;border-bottom-width:1px;height:auto;margin:8px 0}.e-menu-container .e-ul .e-menu-item .e-caret,.e-menu-wrapper .e-ul .e-menu-item .e-caret{font-size:11px}.e-menu-container.e-menu-icon-right .e-menu-header .e-menu-icon,.e-menu-wrapper.e-menu-icon-right .e-menu-header .e-menu-icon{float:right}.e-menu-container.e-menu-icon-right .e-menu-header .e-menu-title,.e-menu-wrapper.e-menu-icon-right .e-menu-header .e-menu-title{padding:0 16px}.e-menu-container .e-menu-header,.e-menu-wrapper .e-menu-header{display:none;font-family:Roboto,Segoe UI,GeezaPro,DejaVu Serif,\"sans-serif\",-apple-system,BlinkMacSystemFont;font-size:14px;font-weight:400;height:42px;line-height:42px;text-align:left;white-space:nowrap}.e-menu-container .e-menu-header .e-menu-icon,.e-menu-container .e-menu-header .e-menu-title,.e-menu-wrapper .e-menu-header .e-menu-icon,.e-menu-wrapper .e-menu-header .e-menu-title{display:inline-block;line-height:inherit}.e-menu-container .e-menu-header .e-menu-icon,.e-menu-wrapper .e-menu-header .e-menu-icon{cursor:pointer;float:left;outline:none;padding:0 16px}.e-menu-container .e-menu-hscroll.e-hscroll:not(.e-scroll-device),.e-menu-wrapper .e-menu-hscroll.e-hscroll:not(.e-scroll-device){padding:0 30px}.e-menu-container .e-menu-hscroll.e-hscroll:not(.e-scroll-device) .e-scroll-nav,.e-menu-wrapper .e-menu-hscroll.e-hscroll:not(.e-scroll-device) .e-scroll-nav{width:30px}.e-menu-container .e-menu-hscroll.e-hscroll:not(.e-scroll-device) .e-scroll-nav:focus,.e-menu-container .e-menu-hscroll.e-hscroll:not(.e-scroll-device) .e-scroll-nav:hover,.e-menu-wrapper .e-menu-hscroll.e-hscroll:not(.e-scroll-device) .e-scroll-nav:focus,.e-menu-wrapper .e-menu-hscroll.e-hscroll:not(.e-scroll-device) .e-scroll-nav:hover{border:0}.e-menu-container .e-menu-hscroll.e-hscroll:not(.e-scroll-device) .e-scroll-nav.e-scroll-right-nav,.e-menu-wrapper .e-menu-hscroll.e-hscroll:not(.e-scroll-device) .e-scroll-nav.e-scroll-right-nav{border-left:none}.e-menu-container .e-menu-hscroll.e-hscroll:not(.e-scroll-device) .e-scroll-nav.e-scroll-left-nav,.e-menu-wrapper .e-menu-hscroll.e-hscroll:not(.e-scroll-device) .e-scroll-nav.e-scroll-left-nav{border-right:none}.e-menu-container .e-menu-hscroll.e-hscroll:not(.e-scroll-device) .e-hscroll-bar,.e-menu-wrapper .e-menu-hscroll.e-hscroll:not(.e-scroll-device) .e-hscroll-bar{overflow-y:hidden}.e-menu-container .e-scroll-nav .e-nav-arrow,.e-menu-wrapper .e-scroll-nav .e-nav-arrow{font-size:10px}.e-menu-container .e-scroll-nav .e-nav-arrow.e-nav-left-arrow,.e-menu-container .e-scroll-nav .e-nav-arrow.e-nav-up-arrow,.e-menu-wrapper .e-scroll-nav .e-nav-arrow.e-nav-left-arrow,.e-menu-wrapper .e-scroll-nav .e-nav-arrow.e-nav-up-arrow{transform:rotate(180deg)}.e-menu-container.e-rtl .e-scroll-nav .e-nav-arrow.e-nav-left-arrow,.e-menu-wrapper.e-rtl .e-scroll-nav .e-nav-arrow.e-nav-left-arrow{transform:rotate(0deg)}.e-menu-container.e-rtl .e-scroll-nav .e-nav-arrow.e-nav-right-arrow,.e-menu-wrapper.e-rtl .e-scroll-nav .e-nav-arrow.e-nav-right-arrow{transform:rotate(180deg)}.e-menu-container.e-popup.e-menu-popup,.e-menu-wrapper.e-popup.e-menu-popup{border:none;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);overflow:hidden;position:absolute}.e-menu-container .e-menu-vscroll.e-vscroll:not(.e-scroll-device),.e-menu-wrapper .e-menu-vscroll.e-vscroll:not(.e-scroll-device){padding:16px 0}.e-menu-container .e-menu-vscroll.e-vscroll.e-scroll-device .e-scroll-nav.e-scroll-down-nav,.e-menu-wrapper .e-menu-vscroll.e-vscroll.e-scroll-device .e-scroll-nav.e-scroll-down-nav{transform:none;width:100%}.e-menu-container .e-menu-vscroll.e-vscroll.e-scroll-device .e-scroll-nav.e-scroll-down-nav .e-nav-down-arrow,.e-menu-wrapper .e-menu-vscroll.e-vscroll.e-scroll-device .e-scroll-nav.e-scroll-down-nav .e-nav-down-arrow{transform:none}.e-menu-container .e-menu-vscroll.e-vscroll .e-vscroll-bar,.e-menu-wrapper .e-menu-vscroll.e-vscroll .e-vscroll-bar{height:100%;width:inherit}.e-menu-container .e-menu-vscroll.e-vscroll .e-vscroll-bar .e-vscroll-content,.e-menu-wrapper .e-menu-vscroll.e-vscroll .e-vscroll-bar .e-vscroll-content{width:inherit}.e-menu-container .e-menu-vscroll.e-vscroll .e-scroll-nav,.e-menu-wrapper .e-menu-vscroll.e-vscroll .e-scroll-nav{height:16px}.e-menu-container.e-scrollable,.e-menu-wrapper.e-scrollable{display:block}.e-menu-container.e-scrollable .e-menu,.e-menu-wrapper.e-scrollable .e-menu{display:block;overflow:auto}.e-menu-container.e-contextmenu-container,.e-menu-wrapper.e-contextmenu-container{height:1px}.e-menu-container.e-contextmenu-container .e-menu-vscroll ul.e-ul,.e-menu-wrapper.e-contextmenu-container .e-menu-vscroll ul.e-ul{width:inherit}.e-menu-container.e-contextmenu-container .e-menu-vscroll,.e-menu-wrapper.e-contextmenu-container .e-menu-vscroll{border:none;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.e-menu-container:not(.e-hamburger):not(.e-rtl) .e-menu.e-vertical .e-blankicon{padding-left:44px}.e-rtl.e-menu-container ul .e-menu-item,.e-rtl.e-menu-wrapper ul .e-menu-item{text-align:right}.e-rtl.e-menu-container ul .e-menu-item .e-menu-icon,.e-rtl.e-menu-wrapper ul .e-menu-item .e-menu-icon{margin-right:0}.e-rtl.e-menu-container ul .e-menu-item .e-caret,.e-rtl.e-menu-wrapper ul .e-menu-item .e-caret{margin-left:0;margin-right:16px;right:auto}.e-rtl.e-menu-container ul .e-menu-item .e-menu-icon,.e-rtl.e-menu-wrapper ul .e-menu-item .e-menu-icon{margin-left:8px}.e-rtl.e-menu-container ul .e-menu-item .e-caret,.e-rtl.e-menu-wrapper ul .e-menu-item .e-caret{left:12px}.e-rtl.e-menu-container ul .e-menu-item.e-menu-caret-icon,.e-rtl.e-menu-wrapper ul .e-menu-item.e-menu-caret-icon{padding-left:30px;padding-right:12px}.e-rtl.e-menu-container ul.e-ul .e-menu-item .e-menu-icon,.e-rtl.e-menu-wrapper ul.e-ul .e-menu-item .e-menu-icon{margin-left:10px}.e-rtl.e-menu-container ul.e-ul .e-menu-item .e-caret,.e-rtl.e-menu-wrapper ul.e-ul .e-menu-item .e-caret{left:8px}.e-rtl.e-menu-container ul.e-ul .e-menu-item.e-menu-caret-icon,.e-rtl.e-menu-wrapper ul.e-ul .e-menu-item.e-menu-caret-icon{padding-left:36px;padding-right:16px}.e-rtl.e-menu-container ul.e-ul .e-menu-item.e-blankicon,.e-rtl.e-menu-wrapper ul.e-ul .e-menu-item.e-blankicon{padding-left:16px}.e-rtl.e-menu-container ul.e-ul .e-menu-item.e-blankicon.e-menu-caret-icon,.e-rtl.e-menu-wrapper ul.e-ul .e-menu-item.e-blankicon.e-menu-caret-icon{padding-left:36px}.e-rtl.e-menu-container:not(.e-hamburger) .e-menu.e-vertical .e-blankicon{padding-right:44px}.e-bigger.e-menu-container ul,.e-bigger .e-menu-container ul,.e-bigger.e-menu-wrapper ul,.e-bigger .e-menu-wrapper ul{font-size:14px}.e-bigger.e-menu-container ul .e-menu-item,.e-bigger .e-menu-container ul .e-menu-item,.e-bigger.e-menu-wrapper ul .e-menu-item,.e-bigger .e-menu-wrapper ul .e-menu-item{height:56px;line-height:56px;padding:0 16px}.e-bigger.e-menu-container ul .e-menu-item .e-menu-icon,.e-bigger .e-menu-container ul .e-menu-item .e-menu-icon,.e-bigger.e-menu-wrapper ul .e-menu-item .e-menu-icon,.e-bigger .e-menu-wrapper ul .e-menu-item .e-menu-icon{font-size:16px;line-height:56px;margin-right:10px}.e-bigger.e-menu-container ul .e-menu-item.e-menu-caret-icon,.e-bigger .e-menu-container ul .e-menu-item.e-menu-caret-icon,.e-bigger.e-menu-wrapper ul .e-menu-item.e-menu-caret-icon,.e-bigger .e-menu-wrapper ul .e-menu-item.e-menu-caret-icon{padding-right:36px}.e-bigger.e-menu-container ul .e-menu-item .e-caret,.e-bigger .e-menu-container ul .e-menu-item .e-caret,.e-bigger.e-menu-wrapper ul .e-menu-item .e-caret,.e-bigger .e-menu-wrapper ul .e-menu-item .e-caret{font-size:12px;line-height:56px;right:16px}.e-bigger.e-menu-container ul .e-menu-item.e-separator,.e-bigger .e-menu-container ul .e-menu-item.e-separator,.e-bigger.e-menu-container ul.e-menu:not(.e-vertical),.e-bigger .e-menu-container ul.e-menu:not(.e-vertical),.e-bigger.e-menu-wrapper ul .e-menu-item.e-separator,.e-bigger .e-menu-wrapper ul .e-menu-item.e-separator,.e-bigger.e-menu-wrapper ul.e-menu:not(.e-vertical),.e-bigger .e-menu-wrapper ul.e-menu:not(.e-vertical){padding:0}.e-bigger.e-menu-container ul.e-menu.e-vertical .e-menu-item.e-separator,.e-bigger .e-menu-container ul.e-menu.e-vertical .e-menu-item.e-separator,.e-bigger.e-menu-wrapper ul.e-menu.e-vertical .e-menu-item.e-separator,.e-bigger .e-menu-wrapper ul.e-menu.e-vertical .e-menu-item.e-separator{height:auto;line-height:normal}.e-bigger.e-menu-container ul.e-ul,.e-bigger .e-menu-container ul.e-ul,.e-bigger.e-menu-wrapper ul.e-ul,.e-bigger .e-menu-wrapper ul.e-ul{font-size:15px;padding:8px 0;white-space:nowrap;max-width:280px;min-width:112px}.e-bigger.e-menu-container ul.e-ul .e-menu-item,.e-bigger .e-menu-container ul.e-ul .e-menu-item,.e-bigger.e-menu-wrapper ul.e-ul .e-menu-item,.e-bigger .e-menu-wrapper ul.e-ul .e-menu-item{height:48px;line-height:48px;padding:0 16px}.e-bigger.e-menu-container ul.e-ul .e-menu-item .e-menu-icon,.e-bigger .e-menu-container ul.e-ul .e-menu-item .e-menu-icon,.e-bigger.e-menu-wrapper ul.e-ul .e-menu-item .e-menu-icon,.e-bigger .e-menu-wrapper ul.e-ul .e-menu-item .e-menu-icon{font-size:16px;line-height:48px}.e-bigger.e-menu-container ul.e-ul .e-menu-item .e-caret,.e-bigger .e-menu-container ul.e-ul .e-menu-item .e-caret,.e-bigger.e-menu-wrapper ul.e-ul .e-menu-item .e-caret,.e-bigger .e-menu-wrapper ul.e-ul .e-menu-item .e-caret{line-height:48px}.e-bigger.e-menu-container ul.e-ul .e-menu-item.e-separator,.e-bigger .e-menu-container ul.e-ul .e-menu-item.e-separator,.e-bigger.e-menu-wrapper ul.e-ul .e-menu-item.e-separator,.e-bigger .e-menu-wrapper ul.e-ul .e-menu-item.e-separator{height:auto;line-height:normal}.e-bigger.e-menu-container ul.e-ul .e-menu-item .e-caret,.e-bigger .e-menu-container ul.e-ul .e-menu-item .e-caret,.e-bigger.e-menu-wrapper ul.e-ul .e-menu-item .e-caret,.e-bigger .e-menu-wrapper ul.e-ul .e-menu-item .e-caret{font-size:12px;right:8px}.e-bigger.e-menu-container ul.e-ul .e-menu-item.e-menu-caret-icon,.e-bigger .e-menu-container ul.e-ul .e-menu-item.e-menu-caret-icon,.e-bigger.e-menu-wrapper ul.e-ul .e-menu-item.e-menu-caret-icon,.e-bigger .e-menu-wrapper ul.e-ul .e-menu-item.e-menu-caret-icon{padding-right:36px}.e-bigger.e-menu-container ul.e-ul .e-menu-item .e-menu-icon,.e-bigger .e-menu-container ul.e-ul .e-menu-item .e-menu-icon,.e-bigger.e-menu-wrapper ul.e-ul .e-menu-item .e-menu-icon,.e-bigger .e-menu-wrapper ul.e-ul .e-menu-item .e-menu-icon{margin-right:10px}.e-bigger.e-menu-container:not(.e-hamburger):not(.e-rtl) .e-menu.e-vertical .e-blankicon,.e-bigger .e-menu-container:not(.e-hamburger):not(.e-rtl) .e-menu.e-vertical .e-blankicon{padding-left:50px}.e-bigger.e-menu-container .e-menu-hscroll.e-hscroll:not(.e-scroll-device),.e-bigger .e-menu-container .e-menu-hscroll.e-hscroll:not(.e-scroll-device),.e-bigger.e-menu-wrapper .e-menu-hscroll.e-hscroll:not(.e-scroll-device),.e-bigger .e-menu-wrapper .e-menu-hscroll.e-hscroll:not(.e-scroll-device){padding:0 36px}.e-bigger.e-menu-container .e-menu-hscroll.e-hscroll:not(.e-scroll-device) .e-scroll-nav,.e-bigger .e-menu-container .e-menu-hscroll.e-hscroll:not(.e-scroll-device) .e-scroll-nav,.e-bigger.e-menu-wrapper .e-menu-hscroll.e-hscroll:not(.e-scroll-device) .e-scroll-nav,.e-bigger .e-menu-wrapper .e-menu-hscroll.e-hscroll:not(.e-scroll-device) .e-scroll-nav{width:36px}.e-bigger.e-menu-container .e-menu-vscroll.e-vscroll:not(.e-scroll-device),.e-bigger .e-menu-container .e-menu-vscroll.e-vscroll:not(.e-scroll-device),.e-bigger.e-menu-wrapper .e-menu-vscroll.e-vscroll:not(.e-scroll-device),.e-bigger .e-menu-wrapper .e-menu-vscroll.e-vscroll:not(.e-scroll-device){padding:24px 0}.e-bigger.e-menu-container .e-menu-vscroll.e-vscroll .e-scroll-nav,.e-bigger .e-menu-container .e-menu-vscroll.e-vscroll .e-scroll-nav,.e-bigger.e-menu-wrapper .e-menu-vscroll.e-vscroll .e-scroll-nav,.e-bigger .e-menu-wrapper .e-menu-vscroll.e-vscroll .e-scroll-nav{height:24px}.e-bigger.e-menu-container.e-menu-popup,.e-bigger .e-menu-container.e-menu-popup,.e-bigger.e-menu-wrapper.e-menu-popup,.e-bigger .e-menu-wrapper.e-menu-popup{box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.e-bigger.e-menu-container .e-scroll-nav .e-icons,.e-bigger .e-menu-container .e-scroll-nav .e-icons,.e-bigger.e-menu-wrapper .e-scroll-nav .e-icons,.e-bigger .e-menu-wrapper .e-scroll-nav .e-icons{font-size:12px}.e-bigger.e-rtl.e-menu-container ul .e-menu-item,.e-bigger .e-rtl.e-menu-container ul .e-menu-item,.e-bigger.e-rtl.e-menu-wrapper ul .e-menu-item,.e-bigger .e-rtl.e-menu-wrapper ul .e-menu-item{text-align:right}.e-bigger.e-rtl.e-menu-container ul .e-menu-item .e-menu-icon,.e-bigger .e-rtl.e-menu-container ul .e-menu-item .e-menu-icon,.e-bigger.e-rtl.e-menu-wrapper ul .e-menu-item .e-menu-icon,.e-bigger .e-rtl.e-menu-wrapper ul .e-menu-item .e-menu-icon{margin-left:10px;margin-right:0}.e-bigger.e-rtl.e-menu-container ul .e-menu-item .e-caret,.e-bigger .e-rtl.e-menu-container ul .e-menu-item .e-caret,.e-bigger.e-rtl.e-menu-wrapper ul .e-menu-item .e-caret,.e-bigger .e-rtl.e-menu-wrapper ul .e-menu-item .e-caret{left:16px;margin-left:0;right:auto}.e-bigger.e-rtl.e-menu-container ul .e-menu-item.e-menu-caret-icon,.e-bigger .e-rtl.e-menu-container ul .e-menu-item.e-menu-caret-icon,.e-bigger.e-rtl.e-menu-wrapper ul .e-menu-item.e-menu-caret-icon,.e-bigger .e-rtl.e-menu-wrapper ul .e-menu-item.e-menu-caret-icon{padding-left:36px;padding-right:16px}.e-bigger.e-rtl.e-menu-container ul.e-ul .e-menu-item .e-menu-icon,.e-bigger .e-rtl.e-menu-container ul.e-ul .e-menu-item .e-menu-icon,.e-bigger.e-rtl.e-menu-wrapper ul.e-ul .e-menu-item .e-menu-icon,.e-bigger .e-rtl.e-menu-wrapper ul.e-ul .e-menu-item .e-menu-icon{margin-left:10px}.e-bigger.e-rtl.e-menu-container ul.e-ul .e-menu-item .e-caret,.e-bigger .e-rtl.e-menu-container ul.e-ul .e-menu-item .e-caret,.e-bigger.e-rtl.e-menu-wrapper ul.e-ul .e-menu-item .e-caret,.e-bigger .e-rtl.e-menu-wrapper ul.e-ul .e-menu-item .e-caret{left:8px}.e-bigger.e-rtl.e-menu-container ul.e-ul .e-menu-item.e-menu-caret-icon,.e-bigger .e-rtl.e-menu-container ul.e-ul .e-menu-item.e-menu-caret-icon,.e-bigger.e-rtl.e-menu-wrapper ul.e-ul .e-menu-item.e-menu-caret-icon,.e-bigger .e-rtl.e-menu-wrapper ul.e-ul .e-menu-item.e-menu-caret-icon{padding-left:36px;padding-right:16px}.e-bigger.e-rtl.e-menu-container ul.e-ul .e-menu-item.e-blankicon,.e-bigger .e-rtl.e-menu-container ul.e-ul .e-menu-item.e-blankicon,.e-bigger.e-rtl.e-menu-wrapper ul.e-ul .e-menu-item.e-blankicon,.e-bigger .e-rtl.e-menu-wrapper ul.e-ul .e-menu-item.e-blankicon{padding-left:16px}.e-bigger.e-rtl.e-menu-container ul.e-ul .e-menu-item.e-blankicon.e-menu-caret-icon,.e-bigger .e-rtl.e-menu-container ul.e-ul .e-menu-item.e-blankicon.e-menu-caret-icon,.e-bigger.e-rtl.e-menu-wrapper ul.e-ul .e-menu-item.e-blankicon.e-menu-caret-icon,.e-bigger .e-rtl.e-menu-wrapper ul.e-ul .e-menu-item.e-blankicon.e-menu-caret-icon{padding-left:36px}.e-bigger.e-rtl.e-menu-container:not(.e-hamburger) .e-menu.e-vertical .e-blankicon,.e-bigger .e-rtl.e-menu-container:not(.e-hamburger) .e-menu.e-vertical .e-blankicon{padding-right:50px}.e-menu-container.e-hamburger,.e-menu-wrapper.e-hamburger{border:0;display:block;position:relative}.e-menu-container.e-hamburger .e-menu-header:not(.e-vertical),.e-menu-wrapper.e-hamburger .e-menu-header:not(.e-vertical){border:none;display:block}.e-menu-container.e-hamburger .e-popup.e-menu-popup,.e-menu-wrapper.e-hamburger .e-popup.e-menu-popup{border:0;border-radius:0;box-shadow:none;display:block;position:relative;width:100%}.e-menu-container.e-hamburger ul.e-menu,.e-menu-wrapper.e-hamburger ul.e-menu{border:none;overflow-y:auto;width:100%}.e-menu-container.e-hamburger ul.e-menu.e-menu-parent.e-hide-menu,.e-menu-wrapper.e-hamburger ul.e-menu.e-menu-parent.e-hide-menu{display:none}.e-menu-container.e-hamburger ul.e-menu .e-menu-item,.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item{text-indent:12px}.e-menu-container.e-hamburger ul.e-menu .e-menu-item.e-blankicon,.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item.e-blankicon{text-indent:34px}.e-menu-container.e-hamburger ul.e-menu .e-menu-item .e-menu-icon,.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item .e-menu-icon{display:inline;text-indent:0}.e-menu-container.e-hamburger ul.e-menu .e-menu-item.e-menu-hide,.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item.e-menu-hide{display:none}.e-menu-container.e-hamburger ul.e-menu .e-menu-item[aria-expanded=true] .e-caret,.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item[aria-expanded=true] .e-caret{transition:transform .3s ease-in-out;transform:rotate(-180deg);text-indent:0}.e-menu-container.e-hamburger ul.e-menu .e-menu-item[aria-expanded=false] .e-caret,.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item[aria-expanded=false] .e-caret{transition:transform .3s ease-in-out;transform:rotate(0deg);text-indent:0}.e-menu-container.e-hamburger ul.e-menu:not(.e-vertical),.e-menu-wrapper.e-hamburger ul.e-menu:not(.e-vertical){border-top:0;display:block;padding:0;position:absolute}.e-menu-container.e-hamburger ul.e-ul,.e-menu-wrapper.e-hamburger ul.e-ul{font-size:13px;padding:0}.e-menu-container.e-hamburger ul.e-ul .e-menu-item,.e-menu-wrapper.e-hamburger ul.e-ul .e-menu-item{line-height:42px;text-indent:inherit}.e-menu-container.e-hamburger ul.e-ul .e-menu-item.e-blankicon,.e-menu-wrapper.e-hamburger ul.e-ul .e-menu-item.e-blankicon{padding:0;text-indent:inherit}.e-menu-container.e-hamburger ul.e-ul .e-menu-item .e-caret,.e-menu-wrapper.e-hamburger ul.e-ul .e-menu-item .e-caret{font-size:10px;right:12px}.e-menu-container.e-hamburger ul .e-menu-item,.e-menu-wrapper.e-hamburger ul .e-menu-item{display:list-item;height:auto;padding:0}.e-menu-container.e-hamburger ul .e-menu-item.e-menu-caret-icon,.e-menu-wrapper.e-hamburger ul .e-menu-item.e-menu-caret-icon{padding:0}.e-menu-container.e-hamburger ul .e-menu-item .e-menu-url,.e-menu-wrapper.e-hamburger ul .e-menu-item .e-menu-url{display:inline-block;min-width:120px;text-indent:0;width:100%}.e-menu-container.e-hamburger ul .e-menu-item.e-blankicon,.e-menu-wrapper.e-hamburger ul .e-menu-item.e-blankicon{padding:0}.e-menu-container.e-hamburger ul .e-menu-item.e-separator,.e-menu-wrapper.e-hamburger ul .e-menu-item.e-separator{border-bottom-style:solid;border-bottom-width:1px;height:auto}.e-rtl.e-menu-container.e-hamburger ul .e-menu-item .e-menu-caret-icon,.e-rtl.e-menu-wrapper.e-hamburger ul .e-menu-item .e-menu-caret-icon{padding-left:0;padding-right:0}.e-rtl.e-menu-container.e-hamburger ul .e-menu-item .e-menu-icon,.e-rtl.e-menu-wrapper.e-hamburger ul .e-menu-item .e-menu-icon{margin-left:0;text-indent:inherit}.e-rtl.e-menu-container.e-hamburger ul .e-menu-item .e-caret,.e-rtl.e-menu-wrapper.e-hamburger ul .e-menu-item .e-caret{left:12px;right:auto}.e-bigger.e-menu-container.e-hamburger ul .e-ul,.e-bigger .e-menu-container.e-hamburger ul .e-ul,.e-bigger.e-menu-wrapper.e-hamburger ul .e-ul,.e-bigger .e-menu-wrapper.e-hamburger ul .e-ul{max-width:100%}.e-bigger.e-menu-container.e-hamburger ul .e-ul .e-menu-item,.e-bigger .e-menu-container.e-hamburger ul .e-ul .e-menu-item,.e-bigger.e-menu-wrapper.e-hamburger ul .e-ul .e-menu-item,.e-bigger .e-menu-wrapper.e-hamburger ul .e-ul .e-menu-item{height:auto;line-height:56px;padding:0}.e-bigger.e-menu-container.e-hamburger .e-menu-header,.e-bigger .e-menu-container.e-hamburger .e-menu-header,.e-bigger.e-menu-wrapper.e-hamburger .e-menu-header,.e-bigger .e-menu-wrapper.e-hamburger .e-menu-header{font-size:16px;height:56px;line-height:56px}.e-bigger.e-menu-container.e-hamburger ul.e-menu .e-menu-item,.e-bigger .e-menu-container.e-hamburger ul.e-menu .e-menu-item,.e-bigger.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item,.e-bigger .e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item{text-indent:16px}.e-bigger.e-menu-container.e-hamburger ul.e-menu .e-menu-item.e-blankicon,.e-bigger .e-menu-container.e-hamburger ul.e-menu .e-menu-item.e-blankicon,.e-bigger.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item.e-blankicon,.e-bigger .e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item.e-blankicon{text-indent:42px}.e-bigger.e-menu-container.e-hamburger ul.e-menu .e-ul,.e-bigger .e-menu-container.e-hamburger ul.e-menu .e-ul,.e-bigger.e-menu-wrapper.e-hamburger ul.e-menu .e-ul,.e-bigger .e-menu-wrapper.e-hamburger ul.e-menu .e-ul{font-size:14px}.e-bigger.e-menu-container.e-hamburger ul.e-menu .e-ul .e-menu-item,.e-bigger .e-menu-container.e-hamburger ul.e-menu .e-ul .e-menu-item,.e-bigger.e-menu-wrapper.e-hamburger ul.e-menu .e-ul .e-menu-item,.e-bigger .e-menu-wrapper.e-hamburger ul.e-menu .e-ul .e-menu-item{text-indent:inherit}.e-bigger.e-menu-container.e-hamburger ul.e-menu .e-ul .e-menu-item .e-caret,.e-bigger .e-menu-container.e-hamburger ul.e-menu .e-ul .e-menu-item .e-caret,.e-bigger.e-menu-wrapper.e-hamburger ul.e-menu .e-ul .e-menu-item .e-caret,.e-bigger .e-menu-wrapper.e-hamburger ul.e-menu .e-ul .e-menu-item .e-caret{font-size:12px;right:16px}.e-bigger.e-rtl.e-menu-container.e-hamburger ul.e-menu .e-menu-item,.e-bigger .e-rtl.e-menu-container.e-hamburger ul.e-menu .e-menu-item,.e-bigger.e-rtl.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item,.e-bigger .e-rtl.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item{padding:0;text-indent:16px}.e-bigger.e-rtl.e-menu-container.e-hamburger ul.e-menu .e-menu-item.e-blankicon,.e-bigger .e-rtl.e-menu-container.e-hamburger ul.e-menu .e-menu-item.e-blankicon,.e-bigger.e-rtl.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item.e-blankicon,.e-bigger .e-rtl.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item.e-blankicon{text-indent:42px}.e-bigger.e-rtl.e-menu-container.e-hamburger ul.e-menu .e-menu-item .e-menu-icon,.e-bigger .e-rtl.e-menu-container.e-hamburger ul.e-menu .e-menu-item .e-menu-icon,.e-bigger.e-rtl.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item .e-menu-icon,.e-bigger .e-rtl.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item .e-menu-icon{margin-left:0;text-indent:inherit}.e-bigger.e-rtl.e-menu-container.e-hamburger ul.e-menu .e-menu-item.e-menu-caret-icon,.e-bigger .e-rtl.e-menu-container.e-hamburger ul.e-menu .e-menu-item.e-menu-caret-icon,.e-bigger.e-rtl.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item.e-menu-caret-icon,.e-bigger .e-rtl.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item.e-menu-caret-icon{padding-left:0;padding-right:0}.e-bigger.e-rtl.e-menu-container.e-hamburger ul.e-menu .e-menu-item .e-caret,.e-bigger .e-rtl.e-menu-container.e-hamburger ul.e-menu .e-menu-item .e-caret,.e-bigger.e-rtl.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item .e-caret,.e-bigger .e-rtl.e-menu-wrapper.e-hamburger ul.e-menu .e-menu-item .e-caret{left:12px;right:auto}.e-bigger.e-rtl.e-menu-container.e-hamburger ul.e-menu .e-ul .e-menu-item,.e-bigger .e-rtl.e-menu-container.e-hamburger ul.e-menu .e-ul .e-menu-item,.e-bigger.e-rtl.e-menu-wrapper.e-hamburger ul.e-menu .e-ul .e-menu-item,.e-bigger .e-rtl.e-menu-wrapper.e-hamburger ul.e-menu .e-ul .e-menu-item{text-indent:inherit}\n\n/*! menu theme */.e-menu-container,.e-menu-wrapper{background-color:#fafafa}.e-menu-container .e-menu,.e-menu-wrapper .e-menu{background-color:inherit;color:rgba(0,0,0,.87)}.e-menu-container .e-menu.e-menu:not(.e-vertical) .e-separator,.e-menu-wrapper .e-menu.e-menu:not(.e-vertical) .e-separator{border-right-color:rgba(0,0,0,.12)}.e-menu-container .e-menu .e-menu-item .e-caret,.e-menu-container .e-menu .e-menu-item .e-menu-icon,.e-menu-wrapper .e-menu .e-menu-item .e-caret,.e-menu-wrapper .e-menu .e-menu-item .e-menu-icon{color:rgba(0,0,0,.54)}.e-menu-container .e-menu .e-menu-item.e-menu-header,.e-menu-wrapper .e-menu .e-menu-item.e-menu-header{border-bottom-color:rgba(0,0,0,.12)}.e-menu-container .e-menu .e-menu-item .e-menu-url,.e-menu-wrapper .e-menu .e-menu-item .e-menu-url{color:rgba(0,0,0,.87)}.e-menu-container .e-menu .e-menu-item.e-focused,.e-menu-wrapper .e-menu .e-menu-item.e-focused{color:initial;outline:0 solid rgba(0,0,0,.12);outline-offset:0;background-color:#eee}.e-menu-container .e-menu .e-menu-item.e-focused .e-caret,.e-menu-container .e-menu .e-menu-item.e-focused .e-menu-icon,.e-menu-wrapper .e-menu .e-menu-item.e-focused .e-caret,.e-menu-wrapper .e-menu .e-menu-item.e-focused .e-menu-icon{color:rgba(0,0,0,.54)}.e-menu-container .e-menu .e-menu-item.e-selected,.e-menu-wrapper .e-menu .e-menu-item.e-selected{color:rgba(0,0,0,.87);outline:0 solid #e0e0e0;outline-offset:0;background-color:#e0e0e0}.e-menu-container .e-menu .e-menu-item.e-selected .e-caret,.e-menu-container .e-menu .e-menu-item.e-selected .e-menu-icon,.e-menu-wrapper .e-menu .e-menu-item.e-selected .e-caret,.e-menu-wrapper .e-menu .e-menu-item.e-selected .e-menu-icon{color:rgba(0,0,0,.54)}.e-menu-container .e-menu .e-menu-item.e-separator,.e-menu-wrapper .e-menu .e-menu-item.e-separator{border-bottom-color:rgba(0,0,0,.12)}.e-menu-container .e-menu .e-disabled,.e-menu-wrapper .e-menu .e-disabled{color:rgba(0,0,0,.38);opacity:1}.e-menu-container .e-menu .e-disabled .e-caret,.e-menu-container .e-menu .e-disabled .e-menu-icon,.e-menu-container .e-menu .e-disabled .e-menu-url,.e-menu-wrapper .e-menu .e-disabled .e-caret,.e-menu-wrapper .e-menu .e-disabled .e-menu-icon,.e-menu-wrapper .e-menu .e-disabled .e-menu-url{color:rgba(0,0,0,.38)}.e-menu-container .e-ul,.e-menu-wrapper .e-ul{background-color:inherit;color:rgba(0,0,0,.87)}.e-menu-container .e-ul .e-menu-item .e-menu-url,.e-menu-wrapper .e-ul .e-menu-item .e-menu-url{color:rgba(0,0,0,.87)}.e-menu-container .e-ul .e-menu-item.e-focused,.e-menu-wrapper .e-ul .e-menu-item.e-focused{background-color:#eee;color:rgba(0,0,0,.87);outline:0 solid rgba(0,0,0,.12);outline-offset:0}.e-menu-container .e-ul .e-menu-item.e-selected,.e-menu-wrapper .e-ul .e-menu-item.e-selected{background-color:#eee;color:rgba(0,0,0,.87);outline:0 solid #eee;outline-offset:0}.e-menu-container .e-ul .e-menu-item.e-separator,.e-menu-wrapper .e-ul .e-menu-item.e-separator{border-bottom-color:rgba(0,0,0,.12)}.e-menu-container.e-menu-popup,.e-menu-wrapper.e-menu-popup{background-color:#fff}.e-menu-container.e-menu-popup.e-sfcontextmenu .e-menu-vscroll,.e-menu-wrapper.e-menu-popup.e-sfcontextmenu .e-menu-vscroll{background-color:inherit}.e-menu-container .e-menu-hscroll.e-hscroll .e-scroll-nav,.e-menu-wrapper .e-menu-hscroll.e-hscroll .e-scroll-nav{background:#fafafa}.e-menu-container .e-menu-hscroll.e-hscroll .e-scroll-nav .e-nav-arrow.e-icons,.e-menu-wrapper .e-menu-hscroll.e-hscroll .e-scroll-nav .e-nav-arrow.e-icons{color:rgba(0,0,0,.54)}.e-menu-container .e-menu-hscroll.e-hscroll .e-scroll-nav:active,.e-menu-container .e-menu-hscroll.e-hscroll .e-scroll-nav:focus,.e-menu-container .e-menu-hscroll.e-hscroll .e-scroll-nav:hover,.e-menu-wrapper .e-menu-hscroll.e-hscroll .e-scroll-nav:active,.e-menu-wrapper .e-menu-hscroll.e-hscroll .e-scroll-nav:focus,.e-menu-wrapper .e-menu-hscroll.e-hscroll .e-scroll-nav:hover{background:#eee}.e-menu-container.e-menu-popup .e-menu-vscroll.e-vscroll .e-scroll-nav,.e-menu-wrapper.e-menu-popup .e-menu-vscroll.e-vscroll .e-scroll-nav{background:#fff;border-color:rgba(0,0,0,.12)}.e-menu-container.e-menu-popup .e-menu-vscroll.e-vscroll .e-scroll-nav .e-icons,.e-menu-wrapper.e-menu-popup .e-menu-vscroll.e-vscroll .e-scroll-nav .e-icons{color:rgba(0,0,0,.87)}.e-menu-container.e-menu-popup .e-menu-vscroll.e-vscroll .e-scroll-nav:active,.e-menu-container.e-menu-popup .e-menu-vscroll.e-vscroll .e-scroll-nav:focus,.e-menu-container.e-menu-popup .e-menu-vscroll.e-vscroll .e-scroll-nav:hover,.e-menu-wrapper.e-menu-popup .e-menu-vscroll.e-vscroll .e-scroll-nav:active,.e-menu-wrapper.e-menu-popup .e-menu-vscroll.e-vscroll .e-scroll-nav:focus,.e-menu-wrapper.e-menu-popup .e-menu-vscroll.e-vscroll .e-scroll-nav:hover{background:#eee}.e-menu-container.e-hamburger .e-menu-header,.e-menu-container.e-hamburger .e-menu-header .e-menu-icon,.e-menu-container.e-hamburger ul,.e-menu-wrapper.e-hamburger .e-menu-header,.e-menu-wrapper.e-hamburger .e-menu-header .e-menu-icon,.e-menu-wrapper.e-hamburger ul{color:rgba(0,0,0,.87)}\n\n/*! breadcrumb icons */.e-breadcrumb .e-breadcrumb-collapsed:before,.e-breadcrumb .e-breadcrumb-menu:before{content:\"\\EB04\"}.e-breadcrumb .e-home{margin-top:-1px}.e-breadcrumb .e-home:before{content:\"\\E92B\"}.e-bigger.e-breadcrumb .e-home,.e-bigger .e-breadcrumb .e-home{margin-top:0}\n\n/*! breadcrumb layout */.e-breadcrumb{display:block}.e-breadcrumb.e-breadcrumb-wrap-mode{display:-ms-flexbox;display:flex}.e-breadcrumb .e-breadcrumb-first-ol{-ms-flex-align:start;align-items:flex-start;-ms-flex-negative:0;flex-shrink:0;padding-right:0}.e-breadcrumb .e-breadcrumb-wrapped-ol{-ms-flex-wrap:wrap;flex-wrap:wrap;overflow:hidden;padding-left:0}.e-breadcrumb.e-breadcrumb-scroll-mode{line-height:26px;overflow:auto}.e-breadcrumb ol{-ms-flex-align:center;align-items:center;display:-ms-inline-flexbox;display:inline-flex;line-height:normal;margin:0;padding:0;padding-left:0;padding-right:0}.e-breadcrumb li{list-style-type:none;white-space:nowrap}.e-breadcrumb .e-breadcrumb-item{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0}.e-breadcrumb .e-breadcrumb-item .e-breadcrumb-text{padding:4px 8px;-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;font-size:14px}.e-breadcrumb .e-breadcrumb-item .e-breadcrumb-text .e-anchor-wrap{-ms-flex-align:inherit;align-items:inherit;display:inherit}.e-breadcrumb .e-breadcrumb-item a.e-breadcrumb-text{cursor:pointer;text-decoration:none}.e-breadcrumb .e-breadcrumb-item a.e-breadcrumb-text:active,.e-breadcrumb .e-breadcrumb-item a.e-breadcrumb-text:focus,.e-breadcrumb .e-breadcrumb-item a.e-breadcrumb-text:hover{text-decoration:underline}.e-breadcrumb .e-breadcrumb-item span.e-breadcrumb-text{cursor:default}.e-breadcrumb .e-breadcrumb-item .e-breadcrumb-icon{font-size:14px;padding-right:8px}.e-breadcrumb .e-breadcrumb-item .e-breadcrumb-icon:hover{text-decoration:none}.e-breadcrumb .e-breadcrumb-item .e-breadcrumb-icon:before{display:inline-block;text-decoration:none}.e-breadcrumb .e-breadcrumb-item.e-icon-item .e-breadcrumb-icon{padding:2px 0}.e-breadcrumb .e-breadcrumb-item.e-disabled{opacity:1;pointer-events:none}.e-breadcrumb .e-breadcrumb-separator{display:-ms-flexbox;display:flex;font-size:14px;padding:4px 3px}.e-breadcrumb .e-breadcrumb-separator+.e-breadcrumb-separator{margin-left:-4px;padding-left:0}.e-breadcrumb.e-rtl .e-breadcrumb-separator+.e-breadcrumb-separator{margin-left:0;margin-right:-4px;padding-left:3px;padding-right:0}.e-breadcrumb .e-breadcrumb-collapsed,.e-breadcrumb .e-breadcrumb-menu{cursor:pointer;font-size:16px;padding:4px;vertical-align:bottom}.e-breadcrumb .e-breadcrumb-menu{display:inline-block}.e-breadcrumb .e-breadcrumb-item-wrapper{display:-ms-flexbox;display:flex}.e-breadcrumb.e-icon-right .e-breadcrumb-icon,.e-breadcrumb .e-icon-right .e-breadcrumb-icon,.e-breadcrumb.e-rtl .e-breadcrumb-icon{padding-left:8px;padding-right:0}.e-breadcrumb.e-rtl.e-icon-right .e-breadcrumb-icon,.e-breadcrumb.e-rtl .e-icon-right .e-breadcrumb-icon{padding-left:0;padding-right:8px}.e-breadcrumb.e-disabled{opacity:1}.e-breadcrumb.e-disabled .e-breadcrumb-collapsed,.e-breadcrumb.e-disabled .e-breadcrumb-item,.e-breadcrumb.e-disabled .e-breadcrumb-menu,.e-breadcrumb.e-disabled .e-breadcrumb-separator{pointer-events:none}.e-breadcrumb-popup{border:none;border-radius:0;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);position:absolute}.e-breadcrumb-popup ul{margin:0;padding:0}.e-breadcrumb-popup .e-breadcrumb-item{list-style-type:none;white-space:nowrap}.e-breadcrumb-popup .e-breadcrumb-item .e-breadcrumb-text{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;font-size:14px;height:36px;line-height:36px;padding:0 16px;width:100%}.e-breadcrumb-popup .e-breadcrumb-item .e-breadcrumb-text .e-anchor-wrap{-ms-flex-align:inherit;align-items:inherit;display:inherit;width:inherit}.e-breadcrumb-popup .e-breadcrumb-item .e-breadcrumb-icon{font-size:14px;padding-right:8px}.e-breadcrumb-popup .e-breadcrumb-item.e-icon-item .e-breadcrumb-icon{padding:0}.e-breadcrumb-popup .e-breadcrumb-item a.e-breadcrumb-text{text-decoration:none}.e-breadcrumb-popup.e-icon-right .e-breadcrumb-icon,.e-breadcrumb-popup .e-icon-right .e-breadcrumb-icon,.e-breadcrumb-popup.e-rtl .e-breadcrumb-icon{padding-left:8px;padding-right:0}.e-breadcrumb-popup.e-icon-right .e-breadcrumb-icon,.e-breadcrumb-popup .e-icon-right .e-breadcrumb-icon{display:-ms-flexbox;display:flex;-ms-flex-positive:1;flex-grow:1;-ms-flex-pack:end;justify-content:flex-end}.e-breadcrumb-popup.e-rtl.e-icon-right .e-breadcrumb-icon,.e-breadcrumb-popup.e-rtl .e-icon-right .e-breadcrumb-icon{padding-left:0;padding-right:8px}.e-bigger.e-breadcrumb-popup .e-breadcrumb-text,.e-bigger .e-breadcrumb-popup .e-breadcrumb-text{font-size:16px;height:48px;line-height:48px}.e-bigger.e-breadcrumb-popup .e-breadcrumb-text .e-breadcrumb-icon,.e-bigger .e-breadcrumb-popup .e-breadcrumb-text .e-breadcrumb-icon{font-size:16px;padding-right:8px}.e-bigger.e-breadcrumb-popup .e-icon-item .e-breadcrumb-text .e-breadcrumb-icon,.e-bigger .e-breadcrumb-popup .e-icon-item .e-breadcrumb-text .e-breadcrumb-icon{padding:0}.e-bigger.e-breadcrumb-popup.e-icon-right .e-breadcrumb-icon,.e-bigger.e-breadcrumb-popup .e-icon-right .e-breadcrumb-icon,.e-bigger .e-breadcrumb-popup.e-icon-right .e-breadcrumb-icon,.e-bigger .e-breadcrumb-popup .e-icon-right .e-breadcrumb-icon,.e-bigger.e-breadcrumb-popup.e-rtl .e-breadcrumb-icon,.e-bigger .e-breadcrumb-popup.e-rtl .e-breadcrumb-icon{padding-left:8px;padding-right:0}.e-bigger.e-breadcrumb-popup.e-rtl.e-icon-right .e-breadcrumb-icon,.e-bigger.e-breadcrumb-popup.e-rtl .e-icon-right .e-breadcrumb-icon,.e-bigger .e-breadcrumb-popup.e-rtl.e-icon-right .e-breadcrumb-icon,.e-bigger .e-breadcrumb-popup.e-rtl .e-icon-right .e-breadcrumb-icon{padding-left:0;padding-right:8px}.e-bigger.e-breadcrumb .e-breadcrumb-item .e-breadcrumb-text,.e-bigger .e-breadcrumb .e-breadcrumb-item .e-breadcrumb-text{padding:4px 12px;font-size:16px}.e-bigger.e-breadcrumb .e-breadcrumb-item .e-breadcrumb-text .e-breadcrumb-icon,.e-bigger .e-breadcrumb .e-breadcrumb-item .e-breadcrumb-text .e-breadcrumb-icon{font-size:16px;padding-right:8px}.e-bigger.e-breadcrumb .e-breadcrumb-item.e-icon-item .e-breadcrumb-text .e-breadcrumb-icon,.e-bigger .e-breadcrumb .e-breadcrumb-item.e-icon-item .e-breadcrumb-text .e-breadcrumb-icon{padding:2px 0}.e-bigger.e-breadcrumb .e-breadcrumb-separator,.e-bigger .e-breadcrumb .e-breadcrumb-separator{font-size:16px;padding:4px 5px}.e-bigger.e-breadcrumb .e-breadcrumb-separator+.e-breadcrumb-separator,.e-bigger .e-breadcrumb .e-breadcrumb-separator+.e-breadcrumb-separator{padding-left:0}.e-bigger.e-breadcrumb.e-rtl .e-breadcrumb-separator+.e-breadcrumb-separator,.e-bigger .e-breadcrumb.e-rtl .e-breadcrumb-separator+.e-breadcrumb-separator{padding-left:5px}.e-bigger.e-breadcrumb .e-breadcrumb-collapsed,.e-bigger .e-breadcrumb .e-breadcrumb-collapsed,.e-bigger.e-breadcrumb .e-breadcrumb-menu,.e-bigger .e-breadcrumb .e-breadcrumb-menu{font-size:18px;padding:5px}.e-bigger.e-breadcrumb.e-icon-right .e-breadcrumb-text .e-breadcrumb-icon,.e-bigger.e-breadcrumb .e-icon-right .e-breadcrumb-text .e-breadcrumb-icon,.e-bigger .e-breadcrumb.e-icon-right .e-breadcrumb-text .e-breadcrumb-icon,.e-bigger .e-breadcrumb .e-icon-right .e-breadcrumb-text .e-breadcrumb-icon,.e-bigger.e-breadcrumb.e-rtl .e-breadcrumb-text .e-breadcrumb-icon,.e-bigger .e-breadcrumb.e-rtl .e-breadcrumb-text .e-breadcrumb-icon{padding-left:8px;padding-right:0}.e-bigger.e-breadcrumb.e-rtl .e-icon-right .e-breadcrumb-text .e-breadcrumb-icon,.e-bigger .e-breadcrumb.e-rtl .e-icon-right .e-breadcrumb-text .e-breadcrumb-icon{padding-left:0;padding-right:8px}\n\n/*! breadcrumb theme */.e-breadcrumb .e-breadcrumb-item .e-breadcrumb-text{color:rgba(0,0,0,.65)}.e-breadcrumb .e-breadcrumb-item .e-breadcrumb-text:active,.e-breadcrumb .e-breadcrumb-item .e-breadcrumb-text:focus,.e-breadcrumb .e-breadcrumb-item .e-breadcrumb-text:hover{color:rgba(0,0,0,.87)}.e-breadcrumb .e-breadcrumb-item.e-icon-item:hover{background-color:#f5f5f5;color:rgba(0,0,0,.87)}.e-breadcrumb .e-breadcrumb-item.e-icon-item:active{background-color:#eee;color:rgba(0,0,0,.87)}.e-breadcrumb .e-breadcrumb-item.e-icon-item .e-breadcrumb-text:focus{background-color:#f5f5f5;color:rgba(0,0,0,.87)}.e-breadcrumb .e-breadcrumb-item[data-active-item] .e-breadcrumb-text{color:rgba(0,0,0,.87);font-weight:500}.e-breadcrumb .e-breadcrumb-collapsed,.e-breadcrumb .e-breadcrumb-item .e-breadcrumb-icon,.e-breadcrumb .e-breadcrumb-menu,.e-breadcrumb .e-breadcrumb-separator{color:rgba(0,0,0,.54)}.e-breadcrumb .e-breadcrumb-collapsed:hover,.e-breadcrumb .e-breadcrumb-menu:hover{background-color:#f5f5f5;color:rgba(0,0,0,.87)}.e-breadcrumb .e-breadcrumb-collapsed:active,.e-breadcrumb .e-breadcrumb-menu:active{background-color:#eee;color:rgba(0,0,0,.87)}.e-breadcrumb .e-breadcrumb-collapsed:focus,.e-breadcrumb .e-breadcrumb-menu:focus{background-color:#f5f5f5;color:rgba(0,0,0,.87)}.e-breadcrumb.e-disabled .e-breadcrumb-item .e-breadcrumb-text,.e-breadcrumb .e-disabled.e-breadcrumb-item .e-breadcrumb-text,.e-breadcrumb.e-disabled .e-breadcrumb-item .e-breadcrumb-text .e-breadcrumb-icon,.e-breadcrumb .e-disabled.e-breadcrumb-item .e-breadcrumb-text .e-breadcrumb-icon,.e-breadcrumb.e-disabled .e-breadcrumb-separator,.e-breadcrumb.e-disabled .e-breadcrumb-separator .e-breadcrumb-icon{color:rgba(0,0,0,.26)}.e-breadcrumb-popup{background-color:#fff}.e-breadcrumb-popup .e-breadcrumb-text{color:#616161}.e-breadcrumb-popup .e-breadcrumb-item .e-breadcrumb-text:focus,.e-breadcrumb-popup .e-breadcrumb-text:hover{background-color:#eee;color:rgba(0,0,0,.87)}", ""]);

// exports


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ejs-menu',{attrs:{"items":_vm.menuitems,"fields":_vm.menuFields}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(185);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1c8ea9b8", content, true, {});

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".addroot[data-v-615c4bf9]{font-size:16px;text-decoration:none;color:#6495ed}", ""]);

// exports


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"addroot",attrs:{"to":{ path: '/NewRootNode' }}},[_vm._v("\n    - New Root Node\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_AddRootNode_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a546758_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_AddRootNode_vue__ = __webpack_require__(192);
function injectStyle (ssrContext) {
  __webpack_require__(188)
  __webpack_require__(190)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a546758"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comp_AddRootNode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a546758_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comp_AddRootNode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(189);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7f66f89d", content, true, {});

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n/*!\n * Bootstrap v5.1.3 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */[data-v-5a546758]:root{--bs-blue:#0d6efd;--bs-indigo:#6610f2;--bs-purple:#6f42c1;--bs-pink:#d63384;--bs-red:#dc3545;--bs-orange:#fd7e14;--bs-yellow:#ffc107;--bs-green:#198754;--bs-teal:#20c997;--bs-cyan:#0dcaf0;--bs-white:#fff;--bs-gray:#6c757d;--bs-gray-dark:#343a40;--bs-gray-100:#f8f9fa;--bs-gray-200:#e9ecef;--bs-gray-300:#dee2e6;--bs-gray-400:#ced4da;--bs-gray-500:#adb5bd;--bs-gray-600:#6c757d;--bs-gray-700:#495057;--bs-gray-800:#343a40;--bs-gray-900:#212529;--bs-primary:#0d6efd;--bs-secondary:#6c757d;--bs-success:#198754;--bs-info:#0dcaf0;--bs-warning:#ffc107;--bs-danger:#dc3545;--bs-light:#f8f9fa;--bs-dark:#212529;--bs-primary-rgb:13,110,253;--bs-secondary-rgb:108,117,125;--bs-success-rgb:25,135,84;--bs-info-rgb:13,202,240;--bs-warning-rgb:255,193,7;--bs-danger-rgb:220,53,69;--bs-light-rgb:248,249,250;--bs-dark-rgb:33,37,41;--bs-white-rgb:255,255,255;--bs-black-rgb:0,0,0;--bs-body-color-rgb:33,37,41;--bs-body-bg-rgb:255,255,255;--bs-font-sans-serif:system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--bs-font-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;--bs-gradient:linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));--bs-body-font-family:var(--bs-font-sans-serif);--bs-body-font-size:1rem;--bs-body-font-weight:400;--bs-body-line-height:1.5;--bs-body-color:#212529;--bs-body-bg:#fff}[data-v-5a546758],[data-v-5a546758]:after,[data-v-5a546758]:before{box-sizing:border-box}@media (prefers-reduced-motion:no-preference){[data-v-5a546758]:root{scroll-behavior:smooth}}body[data-v-5a546758]{margin:0;font-family:var(--bs-body-font-family);font-size:var(--bs-body-font-size);font-weight:var(--bs-body-font-weight);line-height:var(--bs-body-line-height);color:var(--bs-body-color);text-align:var(--bs-body-text-align);background-color:var(--bs-body-bg);-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}hr[data-v-5a546758]{margin:1rem 0;color:inherit;background-color:currentColor;border:0;opacity:.25}hr[data-v-5a546758]:not([size]){height:1px}.h1[data-v-5a546758],.h2[data-v-5a546758],.h3[data-v-5a546758],.h4[data-v-5a546758],.h5[data-v-5a546758],.h6[data-v-5a546758],h1[data-v-5a546758],h2[data-v-5a546758],h3[data-v-5a546758],h4[data-v-5a546758],h5[data-v-5a546758],h6[data-v-5a546758]{margin-top:0;margin-bottom:.5rem;font-weight:500;line-height:1.2}.h1[data-v-5a546758],h1[data-v-5a546758]{font-size:calc(1.375rem + 1.5vw)}@media (min-width:1200px){.h1[data-v-5a546758],h1[data-v-5a546758]{font-size:2.5rem}}.h2[data-v-5a546758],h2[data-v-5a546758]{font-size:calc(1.325rem + .9vw)}@media (min-width:1200px){.h2[data-v-5a546758],h2[data-v-5a546758]{font-size:2rem}}.h3[data-v-5a546758],h3[data-v-5a546758]{font-size:calc(1.3rem + .6vw)}@media (min-width:1200px){.h3[data-v-5a546758],h3[data-v-5a546758]{font-size:1.75rem}}.h4[data-v-5a546758],h4[data-v-5a546758]{font-size:calc(1.275rem + .3vw)}@media (min-width:1200px){.h4[data-v-5a546758],h4[data-v-5a546758]{font-size:1.5rem}}.h5[data-v-5a546758],h5[data-v-5a546758]{font-size:1.25rem}.h6[data-v-5a546758],h6[data-v-5a546758]{font-size:1rem}p[data-v-5a546758]{margin-top:0;margin-bottom:1rem}abbr[data-bs-original-title][data-v-5a546758],abbr[title][data-v-5a546758]{-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address[data-v-5a546758]{margin-bottom:1rem;font-style:normal;line-height:inherit}ol[data-v-5a546758],ul[data-v-5a546758]{padding-left:2rem}dl[data-v-5a546758],ol[data-v-5a546758],ul[data-v-5a546758]{margin-top:0;margin-bottom:1rem}ol ol[data-v-5a546758],ol ul[data-v-5a546758],ul ol[data-v-5a546758],ul ul[data-v-5a546758]{margin-bottom:0}dt[data-v-5a546758]{font-weight:700}dd[data-v-5a546758]{margin-bottom:.5rem;margin-left:0}blockquote[data-v-5a546758]{margin:0 0 1rem}b[data-v-5a546758],strong[data-v-5a546758]{font-weight:bolder}.small[data-v-5a546758],small[data-v-5a546758]{font-size:.875em}.mark[data-v-5a546758],mark[data-v-5a546758]{padding:.2em;background-color:#fcf8e3}sub[data-v-5a546758],sup[data-v-5a546758]{position:relative;font-size:.75em;line-height:0;vertical-align:baseline}sub[data-v-5a546758]{bottom:-.25em}sup[data-v-5a546758]{top:-.5em}a[data-v-5a546758]{color:#0d6efd;text-decoration:underline}a[data-v-5a546758]:hover{color:#0a58ca}a[data-v-5a546758]:not([href]):not([class]),a[data-v-5a546758]:not([href]):not([class]):hover{color:inherit;text-decoration:none}code[data-v-5a546758],kbd[data-v-5a546758],pre[data-v-5a546758],samp[data-v-5a546758]{font-family:var(--bs-font-monospace);font-size:1em;direction:ltr;unicode-bidi:bidi-override}pre[data-v-5a546758]{display:block;margin-top:0;margin-bottom:1rem;overflow:auto;font-size:.875em}pre code[data-v-5a546758]{font-size:inherit;color:inherit;word-break:normal}code[data-v-5a546758]{font-size:.875em;color:#d63384;word-wrap:break-word}a>code[data-v-5a546758]{color:inherit}kbd[data-v-5a546758]{padding:.2rem .4rem;font-size:.875em;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd[data-v-5a546758]{padding:0;font-size:1em;font-weight:700}figure[data-v-5a546758]{margin:0 0 1rem}img[data-v-5a546758],svg[data-v-5a546758]{vertical-align:middle}table[data-v-5a546758]{caption-side:bottom;border-collapse:collapse}caption[data-v-5a546758]{padding-top:.5rem;padding-bottom:.5rem;color:#6c757d;text-align:left}th[data-v-5a546758]{text-align:inherit;text-align:-webkit-match-parent}tbody[data-v-5a546758],td[data-v-5a546758],tfoot[data-v-5a546758],th[data-v-5a546758],thead[data-v-5a546758],tr[data-v-5a546758]{border-color:inherit;border-style:solid;border-width:0}label[data-v-5a546758]{display:inline-block}button[data-v-5a546758]{border-radius:0}button[data-v-5a546758]:focus:not(:focus-visible){outline:0}button[data-v-5a546758],input[data-v-5a546758],optgroup[data-v-5a546758],select[data-v-5a546758],textarea[data-v-5a546758]{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button[data-v-5a546758],select[data-v-5a546758]{text-transform:none}[role=button][data-v-5a546758]{cursor:pointer}select[data-v-5a546758]{word-wrap:normal}select[data-v-5a546758]:disabled{opacity:1}[list][data-v-5a546758]::-webkit-calendar-picker-indicator{display:none}[type=button][data-v-5a546758],[type=reset][data-v-5a546758],[type=submit][data-v-5a546758],button[data-v-5a546758]{-webkit-appearance:button}[type=button][data-v-5a546758]:not(:disabled),[type=reset][data-v-5a546758]:not(:disabled),[type=submit][data-v-5a546758]:not(:disabled),button[data-v-5a546758]:not(:disabled){cursor:pointer}[data-v-5a546758]::-moz-focus-inner{padding:0;border-style:none}textarea[data-v-5a546758]{resize:vertical}fieldset[data-v-5a546758]{min-width:0;padding:0;margin:0;border:0}legend[data-v-5a546758]{float:left;width:100%;padding:0;margin-bottom:.5rem;font-size:calc(1.275rem + .3vw);line-height:inherit}@media (min-width:1200px){legend[data-v-5a546758]{font-size:1.5rem}}legend+[data-v-5a546758]{clear:left}[data-v-5a546758]::-webkit-datetime-edit-day-field,[data-v-5a546758]::-webkit-datetime-edit-fields-wrapper,[data-v-5a546758]::-webkit-datetime-edit-hour-field,[data-v-5a546758]::-webkit-datetime-edit-minute,[data-v-5a546758]::-webkit-datetime-edit-month-field,[data-v-5a546758]::-webkit-datetime-edit-text,[data-v-5a546758]::-webkit-datetime-edit-year-field{padding:0}[data-v-5a546758]::-webkit-inner-spin-button{height:auto}[type=search][data-v-5a546758]{outline-offset:-2px;-webkit-appearance:textfield}[data-v-5a546758]::-webkit-search-decoration{-webkit-appearance:none}[data-v-5a546758]::-webkit-color-swatch-wrapper{padding:0}[data-v-5a546758]::file-selector-button{font:inherit}[data-v-5a546758]::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output[data-v-5a546758]{display:inline-block}iframe[data-v-5a546758]{border:0}summary[data-v-5a546758]{display:list-item;cursor:pointer}progress[data-v-5a546758]{vertical-align:baseline}[hidden][data-v-5a546758]{display:none!important}.lead[data-v-5a546758]{font-size:1.25rem;font-weight:300}.display-1[data-v-5a546758]{font-size:calc(1.625rem + 4.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-1[data-v-5a546758]{font-size:5rem}}.display-2[data-v-5a546758]{font-size:calc(1.575rem + 3.9vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-2[data-v-5a546758]{font-size:4.5rem}}.display-3[data-v-5a546758]{font-size:calc(1.525rem + 3.3vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-3[data-v-5a546758]{font-size:4rem}}.display-4[data-v-5a546758]{font-size:calc(1.475rem + 2.7vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-4[data-v-5a546758]{font-size:3.5rem}}.display-5[data-v-5a546758]{font-size:calc(1.425rem + 2.1vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-5[data-v-5a546758]{font-size:3rem}}.display-6[data-v-5a546758]{font-size:calc(1.375rem + 1.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-6[data-v-5a546758]{font-size:2.5rem}}.list-inline[data-v-5a546758],.list-unstyled[data-v-5a546758]{padding-left:0;list-style:none}.list-inline-item[data-v-5a546758]{display:inline-block}.list-inline-item[data-v-5a546758]:not(:last-child){margin-right:.5rem}.initialism[data-v-5a546758]{font-size:.875em;text-transform:uppercase}.blockquote[data-v-5a546758]{margin-bottom:1rem;font-size:1.25rem}.blockquote[data-v-5a546758]>:last-child{margin-bottom:0}.blockquote-footer[data-v-5a546758]{margin-top:-1rem;margin-bottom:1rem;font-size:.875em;color:#6c757d}.blockquote-footer[data-v-5a546758]:before{content:\"\\2014\\A0\"}.img-fluid[data-v-5a546758]{max-width:100%;height:auto}.img-thumbnail[data-v-5a546758]{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.figure[data-v-5a546758]{display:inline-block}.figure-img[data-v-5a546758]{margin-bottom:.5rem;line-height:1}.figure-caption[data-v-5a546758]{font-size:.875em;color:#6c757d}.container-fluid[data-v-5a546758],.container-lg[data-v-5a546758],.container-md[data-v-5a546758],.container-sm[data-v-5a546758],.container-xl[data-v-5a546758],.container-xxl[data-v-5a546758],.container[data-v-5a546758]{width:100%;padding-right:var(--bs-gutter-x,.75rem);padding-left:var(--bs-gutter-x,.75rem);margin-right:auto;margin-left:auto}@media (min-width:576px){.container-sm[data-v-5a546758],.container[data-v-5a546758]{max-width:540px}}@media (min-width:768px){.container-md[data-v-5a546758],.container-sm[data-v-5a546758],.container[data-v-5a546758]{max-width:720px}}@media (min-width:992px){.container-lg[data-v-5a546758],.container-md[data-v-5a546758],.container-sm[data-v-5a546758],.container[data-v-5a546758]{max-width:960px}}@media (min-width:1200px){.container-lg[data-v-5a546758],.container-md[data-v-5a546758],.container-sm[data-v-5a546758],.container-xl[data-v-5a546758],.container[data-v-5a546758]{max-width:1140px}}@media (min-width:1400px){.container-lg[data-v-5a546758],.container-md[data-v-5a546758],.container-sm[data-v-5a546758],.container-xl[data-v-5a546758],.container-xxl[data-v-5a546758],.container[data-v-5a546758]{max-width:1320px}}.row[data-v-5a546758]{--bs-gutter-x:1.5rem;--bs-gutter-y:0;display:flex;flex-wrap:wrap;margin-top:calc(-1 * var(--bs-gutter-y));margin-right:calc(-.5 * var(--bs-gutter-x));margin-left:calc(-.5 * var(--bs-gutter-x))}.row>[data-v-5a546758]{flex-shrink:0;width:100%;max-width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-top:var(--bs-gutter-y)}.col[data-v-5a546758]{flex:1 0 0%}.row-cols-auto>[data-v-5a546758]{flex:0 0 auto;width:auto}.row-cols-1>[data-v-5a546758]{flex:0 0 auto;width:100%}.row-cols-2>[data-v-5a546758]{flex:0 0 auto;width:50%}.row-cols-3>[data-v-5a546758]{flex:0 0 auto;width:33.3333333333%}.row-cols-4>[data-v-5a546758]{flex:0 0 auto;width:25%}.row-cols-5>[data-v-5a546758]{flex:0 0 auto;width:20%}.row-cols-6>[data-v-5a546758]{flex:0 0 auto;width:16.6666666667%}.col-auto[data-v-5a546758]{flex:0 0 auto;width:auto}.col-1[data-v-5a546758]{flex:0 0 auto;width:8.33333333%}.col-2[data-v-5a546758]{flex:0 0 auto;width:16.66666667%}.col-3[data-v-5a546758]{flex:0 0 auto;width:25%}.col-4[data-v-5a546758]{flex:0 0 auto;width:33.33333333%}.col-5[data-v-5a546758]{flex:0 0 auto;width:41.66666667%}.col-6[data-v-5a546758]{flex:0 0 auto;width:50%}.col-7[data-v-5a546758]{flex:0 0 auto;width:58.33333333%}.col-8[data-v-5a546758]{flex:0 0 auto;width:66.66666667%}.col-9[data-v-5a546758]{flex:0 0 auto;width:75%}.col-10[data-v-5a546758]{flex:0 0 auto;width:83.33333333%}.col-11[data-v-5a546758]{flex:0 0 auto;width:91.66666667%}.col-12[data-v-5a546758]{flex:0 0 auto;width:100%}.offset-1[data-v-5a546758]{margin-left:8.33333333%}.offset-2[data-v-5a546758]{margin-left:16.66666667%}.offset-3[data-v-5a546758]{margin-left:25%}.offset-4[data-v-5a546758]{margin-left:33.33333333%}.offset-5[data-v-5a546758]{margin-left:41.66666667%}.offset-6[data-v-5a546758]{margin-left:50%}.offset-7[data-v-5a546758]{margin-left:58.33333333%}.offset-8[data-v-5a546758]{margin-left:66.66666667%}.offset-9[data-v-5a546758]{margin-left:75%}.offset-10[data-v-5a546758]{margin-left:83.33333333%}.offset-11[data-v-5a546758]{margin-left:91.66666667%}.g-0[data-v-5a546758],.gx-0[data-v-5a546758]{--bs-gutter-x:0}.g-0[data-v-5a546758],.gy-0[data-v-5a546758]{--bs-gutter-y:0}.g-1[data-v-5a546758],.gx-1[data-v-5a546758]{--bs-gutter-x:0.25rem}.g-1[data-v-5a546758],.gy-1[data-v-5a546758]{--bs-gutter-y:0.25rem}.g-2[data-v-5a546758],.gx-2[data-v-5a546758]{--bs-gutter-x:0.5rem}.g-2[data-v-5a546758],.gy-2[data-v-5a546758]{--bs-gutter-y:0.5rem}.g-3[data-v-5a546758],.gx-3[data-v-5a546758]{--bs-gutter-x:1rem}.g-3[data-v-5a546758],.gy-3[data-v-5a546758]{--bs-gutter-y:1rem}.g-4[data-v-5a546758],.gx-4[data-v-5a546758]{--bs-gutter-x:1.5rem}.g-4[data-v-5a546758],.gy-4[data-v-5a546758]{--bs-gutter-y:1.5rem}.g-5[data-v-5a546758],.gx-5[data-v-5a546758]{--bs-gutter-x:3rem}.g-5[data-v-5a546758],.gy-5[data-v-5a546758]{--bs-gutter-y:3rem}@media (min-width:576px){.col-sm[data-v-5a546758]{flex:1 0 0%}.row-cols-sm-auto>[data-v-5a546758]{flex:0 0 auto;width:auto}.row-cols-sm-1>[data-v-5a546758]{flex:0 0 auto;width:100%}.row-cols-sm-2>[data-v-5a546758]{flex:0 0 auto;width:50%}.row-cols-sm-3>[data-v-5a546758]{flex:0 0 auto;width:33.3333333333%}.row-cols-sm-4>[data-v-5a546758]{flex:0 0 auto;width:25%}.row-cols-sm-5>[data-v-5a546758]{flex:0 0 auto;width:20%}.row-cols-sm-6>[data-v-5a546758]{flex:0 0 auto;width:16.6666666667%}.col-sm-auto[data-v-5a546758]{flex:0 0 auto;width:auto}.col-sm-1[data-v-5a546758]{flex:0 0 auto;width:8.33333333%}.col-sm-2[data-v-5a546758]{flex:0 0 auto;width:16.66666667%}.col-sm-3[data-v-5a546758]{flex:0 0 auto;width:25%}.col-sm-4[data-v-5a546758]{flex:0 0 auto;width:33.33333333%}.col-sm-5[data-v-5a546758]{flex:0 0 auto;width:41.66666667%}.col-sm-6[data-v-5a546758]{flex:0 0 auto;width:50%}.col-sm-7[data-v-5a546758]{flex:0 0 auto;width:58.33333333%}.col-sm-8[data-v-5a546758]{flex:0 0 auto;width:66.66666667%}.col-sm-9[data-v-5a546758]{flex:0 0 auto;width:75%}.col-sm-10[data-v-5a546758]{flex:0 0 auto;width:83.33333333%}.col-sm-11[data-v-5a546758]{flex:0 0 auto;width:91.66666667%}.col-sm-12[data-v-5a546758]{flex:0 0 auto;width:100%}.offset-sm-0[data-v-5a546758]{margin-left:0}.offset-sm-1[data-v-5a546758]{margin-left:8.33333333%}.offset-sm-2[data-v-5a546758]{margin-left:16.66666667%}.offset-sm-3[data-v-5a546758]{margin-left:25%}.offset-sm-4[data-v-5a546758]{margin-left:33.33333333%}.offset-sm-5[data-v-5a546758]{margin-left:41.66666667%}.offset-sm-6[data-v-5a546758]{margin-left:50%}.offset-sm-7[data-v-5a546758]{margin-left:58.33333333%}.offset-sm-8[data-v-5a546758]{margin-left:66.66666667%}.offset-sm-9[data-v-5a546758]{margin-left:75%}.offset-sm-10[data-v-5a546758]{margin-left:83.33333333%}.offset-sm-11[data-v-5a546758]{margin-left:91.66666667%}.g-sm-0[data-v-5a546758],.gx-sm-0[data-v-5a546758]{--bs-gutter-x:0}.g-sm-0[data-v-5a546758],.gy-sm-0[data-v-5a546758]{--bs-gutter-y:0}.g-sm-1[data-v-5a546758],.gx-sm-1[data-v-5a546758]{--bs-gutter-x:0.25rem}.g-sm-1[data-v-5a546758],.gy-sm-1[data-v-5a546758]{--bs-gutter-y:0.25rem}.g-sm-2[data-v-5a546758],.gx-sm-2[data-v-5a546758]{--bs-gutter-x:0.5rem}.g-sm-2[data-v-5a546758],.gy-sm-2[data-v-5a546758]{--bs-gutter-y:0.5rem}.g-sm-3[data-v-5a546758],.gx-sm-3[data-v-5a546758]{--bs-gutter-x:1rem}.g-sm-3[data-v-5a546758],.gy-sm-3[data-v-5a546758]{--bs-gutter-y:1rem}.g-sm-4[data-v-5a546758],.gx-sm-4[data-v-5a546758]{--bs-gutter-x:1.5rem}.g-sm-4[data-v-5a546758],.gy-sm-4[data-v-5a546758]{--bs-gutter-y:1.5rem}.g-sm-5[data-v-5a546758],.gx-sm-5[data-v-5a546758]{--bs-gutter-x:3rem}.g-sm-5[data-v-5a546758],.gy-sm-5[data-v-5a546758]{--bs-gutter-y:3rem}}@media (min-width:768px){.col-md[data-v-5a546758]{flex:1 0 0%}.row-cols-md-auto>[data-v-5a546758]{flex:0 0 auto;width:auto}.row-cols-md-1>[data-v-5a546758]{flex:0 0 auto;width:100%}.row-cols-md-2>[data-v-5a546758]{flex:0 0 auto;width:50%}.row-cols-md-3>[data-v-5a546758]{flex:0 0 auto;width:33.3333333333%}.row-cols-md-4>[data-v-5a546758]{flex:0 0 auto;width:25%}.row-cols-md-5>[data-v-5a546758]{flex:0 0 auto;width:20%}.row-cols-md-6>[data-v-5a546758]{flex:0 0 auto;width:16.6666666667%}.col-md-auto[data-v-5a546758]{flex:0 0 auto;width:auto}.col-md-1[data-v-5a546758]{flex:0 0 auto;width:8.33333333%}.col-md-2[data-v-5a546758]{flex:0 0 auto;width:16.66666667%}.col-md-3[data-v-5a546758]{flex:0 0 auto;width:25%}.col-md-4[data-v-5a546758]{flex:0 0 auto;width:33.33333333%}.col-md-5[data-v-5a546758]{flex:0 0 auto;width:41.66666667%}.col-md-6[data-v-5a546758]{flex:0 0 auto;width:50%}.col-md-7[data-v-5a546758]{flex:0 0 auto;width:58.33333333%}.col-md-8[data-v-5a546758]{flex:0 0 auto;width:66.66666667%}.col-md-9[data-v-5a546758]{flex:0 0 auto;width:75%}.col-md-10[data-v-5a546758]{flex:0 0 auto;width:83.33333333%}.col-md-11[data-v-5a546758]{flex:0 0 auto;width:91.66666667%}.col-md-12[data-v-5a546758]{flex:0 0 auto;width:100%}.offset-md-0[data-v-5a546758]{margin-left:0}.offset-md-1[data-v-5a546758]{margin-left:8.33333333%}.offset-md-2[data-v-5a546758]{margin-left:16.66666667%}.offset-md-3[data-v-5a546758]{margin-left:25%}.offset-md-4[data-v-5a546758]{margin-left:33.33333333%}.offset-md-5[data-v-5a546758]{margin-left:41.66666667%}.offset-md-6[data-v-5a546758]{margin-left:50%}.offset-md-7[data-v-5a546758]{margin-left:58.33333333%}.offset-md-8[data-v-5a546758]{margin-left:66.66666667%}.offset-md-9[data-v-5a546758]{margin-left:75%}.offset-md-10[data-v-5a546758]{margin-left:83.33333333%}.offset-md-11[data-v-5a546758]{margin-left:91.66666667%}.g-md-0[data-v-5a546758],.gx-md-0[data-v-5a546758]{--bs-gutter-x:0}.g-md-0[data-v-5a546758],.gy-md-0[data-v-5a546758]{--bs-gutter-y:0}.g-md-1[data-v-5a546758],.gx-md-1[data-v-5a546758]{--bs-gutter-x:0.25rem}.g-md-1[data-v-5a546758],.gy-md-1[data-v-5a546758]{--bs-gutter-y:0.25rem}.g-md-2[data-v-5a546758],.gx-md-2[data-v-5a546758]{--bs-gutter-x:0.5rem}.g-md-2[data-v-5a546758],.gy-md-2[data-v-5a546758]{--bs-gutter-y:0.5rem}.g-md-3[data-v-5a546758],.gx-md-3[data-v-5a546758]{--bs-gutter-x:1rem}.g-md-3[data-v-5a546758],.gy-md-3[data-v-5a546758]{--bs-gutter-y:1rem}.g-md-4[data-v-5a546758],.gx-md-4[data-v-5a546758]{--bs-gutter-x:1.5rem}.g-md-4[data-v-5a546758],.gy-md-4[data-v-5a546758]{--bs-gutter-y:1.5rem}.g-md-5[data-v-5a546758],.gx-md-5[data-v-5a546758]{--bs-gutter-x:3rem}.g-md-5[data-v-5a546758],.gy-md-5[data-v-5a546758]{--bs-gutter-y:3rem}}@media (min-width:992px){.col-lg[data-v-5a546758]{flex:1 0 0%}.row-cols-lg-auto>[data-v-5a546758]{flex:0 0 auto;width:auto}.row-cols-lg-1>[data-v-5a546758]{flex:0 0 auto;width:100%}.row-cols-lg-2>[data-v-5a546758]{flex:0 0 auto;width:50%}.row-cols-lg-3>[data-v-5a546758]{flex:0 0 auto;width:33.3333333333%}.row-cols-lg-4>[data-v-5a546758]{flex:0 0 auto;width:25%}.row-cols-lg-5>[data-v-5a546758]{flex:0 0 auto;width:20%}.row-cols-lg-6>[data-v-5a546758]{flex:0 0 auto;width:16.6666666667%}.col-lg-auto[data-v-5a546758]{flex:0 0 auto;width:auto}.col-lg-1[data-v-5a546758]{flex:0 0 auto;width:8.33333333%}.col-lg-2[data-v-5a546758]{flex:0 0 auto;width:16.66666667%}.col-lg-3[data-v-5a546758]{flex:0 0 auto;width:25%}.col-lg-4[data-v-5a546758]{flex:0 0 auto;width:33.33333333%}.col-lg-5[data-v-5a546758]{flex:0 0 auto;width:41.66666667%}.col-lg-6[data-v-5a546758]{flex:0 0 auto;width:50%}.col-lg-7[data-v-5a546758]{flex:0 0 auto;width:58.33333333%}.col-lg-8[data-v-5a546758]{flex:0 0 auto;width:66.66666667%}.col-lg-9[data-v-5a546758]{flex:0 0 auto;width:75%}.col-lg-10[data-v-5a546758]{flex:0 0 auto;width:83.33333333%}.col-lg-11[data-v-5a546758]{flex:0 0 auto;width:91.66666667%}.col-lg-12[data-v-5a546758]{flex:0 0 auto;width:100%}.offset-lg-0[data-v-5a546758]{margin-left:0}.offset-lg-1[data-v-5a546758]{margin-left:8.33333333%}.offset-lg-2[data-v-5a546758]{margin-left:16.66666667%}.offset-lg-3[data-v-5a546758]{margin-left:25%}.offset-lg-4[data-v-5a546758]{margin-left:33.33333333%}.offset-lg-5[data-v-5a546758]{margin-left:41.66666667%}.offset-lg-6[data-v-5a546758]{margin-left:50%}.offset-lg-7[data-v-5a546758]{margin-left:58.33333333%}.offset-lg-8[data-v-5a546758]{margin-left:66.66666667%}.offset-lg-9[data-v-5a546758]{margin-left:75%}.offset-lg-10[data-v-5a546758]{margin-left:83.33333333%}.offset-lg-11[data-v-5a546758]{margin-left:91.66666667%}.g-lg-0[data-v-5a546758],.gx-lg-0[data-v-5a546758]{--bs-gutter-x:0}.g-lg-0[data-v-5a546758],.gy-lg-0[data-v-5a546758]{--bs-gutter-y:0}.g-lg-1[data-v-5a546758],.gx-lg-1[data-v-5a546758]{--bs-gutter-x:0.25rem}.g-lg-1[data-v-5a546758],.gy-lg-1[data-v-5a546758]{--bs-gutter-y:0.25rem}.g-lg-2[data-v-5a546758],.gx-lg-2[data-v-5a546758]{--bs-gutter-x:0.5rem}.g-lg-2[data-v-5a546758],.gy-lg-2[data-v-5a546758]{--bs-gutter-y:0.5rem}.g-lg-3[data-v-5a546758],.gx-lg-3[data-v-5a546758]{--bs-gutter-x:1rem}.g-lg-3[data-v-5a546758],.gy-lg-3[data-v-5a546758]{--bs-gutter-y:1rem}.g-lg-4[data-v-5a546758],.gx-lg-4[data-v-5a546758]{--bs-gutter-x:1.5rem}.g-lg-4[data-v-5a546758],.gy-lg-4[data-v-5a546758]{--bs-gutter-y:1.5rem}.g-lg-5[data-v-5a546758],.gx-lg-5[data-v-5a546758]{--bs-gutter-x:3rem}.g-lg-5[data-v-5a546758],.gy-lg-5[data-v-5a546758]{--bs-gutter-y:3rem}}@media (min-width:1200px){.col-xl[data-v-5a546758]{flex:1 0 0%}.row-cols-xl-auto>[data-v-5a546758]{flex:0 0 auto;width:auto}.row-cols-xl-1>[data-v-5a546758]{flex:0 0 auto;width:100%}.row-cols-xl-2>[data-v-5a546758]{flex:0 0 auto;width:50%}.row-cols-xl-3>[data-v-5a546758]{flex:0 0 auto;width:33.3333333333%}.row-cols-xl-4>[data-v-5a546758]{flex:0 0 auto;width:25%}.row-cols-xl-5>[data-v-5a546758]{flex:0 0 auto;width:20%}.row-cols-xl-6>[data-v-5a546758]{flex:0 0 auto;width:16.6666666667%}.col-xl-auto[data-v-5a546758]{flex:0 0 auto;width:auto}.col-xl-1[data-v-5a546758]{flex:0 0 auto;width:8.33333333%}.col-xl-2[data-v-5a546758]{flex:0 0 auto;width:16.66666667%}.col-xl-3[data-v-5a546758]{flex:0 0 auto;width:25%}.col-xl-4[data-v-5a546758]{flex:0 0 auto;width:33.33333333%}.col-xl-5[data-v-5a546758]{flex:0 0 auto;width:41.66666667%}.col-xl-6[data-v-5a546758]{flex:0 0 auto;width:50%}.col-xl-7[data-v-5a546758]{flex:0 0 auto;width:58.33333333%}.col-xl-8[data-v-5a546758]{flex:0 0 auto;width:66.66666667%}.col-xl-9[data-v-5a546758]{flex:0 0 auto;width:75%}.col-xl-10[data-v-5a546758]{flex:0 0 auto;width:83.33333333%}.col-xl-11[data-v-5a546758]{flex:0 0 auto;width:91.66666667%}.col-xl-12[data-v-5a546758]{flex:0 0 auto;width:100%}.offset-xl-0[data-v-5a546758]{margin-left:0}.offset-xl-1[data-v-5a546758]{margin-left:8.33333333%}.offset-xl-2[data-v-5a546758]{margin-left:16.66666667%}.offset-xl-3[data-v-5a546758]{margin-left:25%}.offset-xl-4[data-v-5a546758]{margin-left:33.33333333%}.offset-xl-5[data-v-5a546758]{margin-left:41.66666667%}.offset-xl-6[data-v-5a546758]{margin-left:50%}.offset-xl-7[data-v-5a546758]{margin-left:58.33333333%}.offset-xl-8[data-v-5a546758]{margin-left:66.66666667%}.offset-xl-9[data-v-5a546758]{margin-left:75%}.offset-xl-10[data-v-5a546758]{margin-left:83.33333333%}.offset-xl-11[data-v-5a546758]{margin-left:91.66666667%}.g-xl-0[data-v-5a546758],.gx-xl-0[data-v-5a546758]{--bs-gutter-x:0}.g-xl-0[data-v-5a546758],.gy-xl-0[data-v-5a546758]{--bs-gutter-y:0}.g-xl-1[data-v-5a546758],.gx-xl-1[data-v-5a546758]{--bs-gutter-x:0.25rem}.g-xl-1[data-v-5a546758],.gy-xl-1[data-v-5a546758]{--bs-gutter-y:0.25rem}.g-xl-2[data-v-5a546758],.gx-xl-2[data-v-5a546758]{--bs-gutter-x:0.5rem}.g-xl-2[data-v-5a546758],.gy-xl-2[data-v-5a546758]{--bs-gutter-y:0.5rem}.g-xl-3[data-v-5a546758],.gx-xl-3[data-v-5a546758]{--bs-gutter-x:1rem}.g-xl-3[data-v-5a546758],.gy-xl-3[data-v-5a546758]{--bs-gutter-y:1rem}.g-xl-4[data-v-5a546758],.gx-xl-4[data-v-5a546758]{--bs-gutter-x:1.5rem}.g-xl-4[data-v-5a546758],.gy-xl-4[data-v-5a546758]{--bs-gutter-y:1.5rem}.g-xl-5[data-v-5a546758],.gx-xl-5[data-v-5a546758]{--bs-gutter-x:3rem}.g-xl-5[data-v-5a546758],.gy-xl-5[data-v-5a546758]{--bs-gutter-y:3rem}}@media (min-width:1400px){.col-xxl[data-v-5a546758]{flex:1 0 0%}.row-cols-xxl-auto>[data-v-5a546758]{flex:0 0 auto;width:auto}.row-cols-xxl-1>[data-v-5a546758]{flex:0 0 auto;width:100%}.row-cols-xxl-2>[data-v-5a546758]{flex:0 0 auto;width:50%}.row-cols-xxl-3>[data-v-5a546758]{flex:0 0 auto;width:33.3333333333%}.row-cols-xxl-4>[data-v-5a546758]{flex:0 0 auto;width:25%}.row-cols-xxl-5>[data-v-5a546758]{flex:0 0 auto;width:20%}.row-cols-xxl-6>[data-v-5a546758]{flex:0 0 auto;width:16.6666666667%}.col-xxl-auto[data-v-5a546758]{flex:0 0 auto;width:auto}.col-xxl-1[data-v-5a546758]{flex:0 0 auto;width:8.33333333%}.col-xxl-2[data-v-5a546758]{flex:0 0 auto;width:16.66666667%}.col-xxl-3[data-v-5a546758]{flex:0 0 auto;width:25%}.col-xxl-4[data-v-5a546758]{flex:0 0 auto;width:33.33333333%}.col-xxl-5[data-v-5a546758]{flex:0 0 auto;width:41.66666667%}.col-xxl-6[data-v-5a546758]{flex:0 0 auto;width:50%}.col-xxl-7[data-v-5a546758]{flex:0 0 auto;width:58.33333333%}.col-xxl-8[data-v-5a546758]{flex:0 0 auto;width:66.66666667%}.col-xxl-9[data-v-5a546758]{flex:0 0 auto;width:75%}.col-xxl-10[data-v-5a546758]{flex:0 0 auto;width:83.33333333%}.col-xxl-11[data-v-5a546758]{flex:0 0 auto;width:91.66666667%}.col-xxl-12[data-v-5a546758]{flex:0 0 auto;width:100%}.offset-xxl-0[data-v-5a546758]{margin-left:0}.offset-xxl-1[data-v-5a546758]{margin-left:8.33333333%}.offset-xxl-2[data-v-5a546758]{margin-left:16.66666667%}.offset-xxl-3[data-v-5a546758]{margin-left:25%}.offset-xxl-4[data-v-5a546758]{margin-left:33.33333333%}.offset-xxl-5[data-v-5a546758]{margin-left:41.66666667%}.offset-xxl-6[data-v-5a546758]{margin-left:50%}.offset-xxl-7[data-v-5a546758]{margin-left:58.33333333%}.offset-xxl-8[data-v-5a546758]{margin-left:66.66666667%}.offset-xxl-9[data-v-5a546758]{margin-left:75%}.offset-xxl-10[data-v-5a546758]{margin-left:83.33333333%}.offset-xxl-11[data-v-5a546758]{margin-left:91.66666667%}.g-xxl-0[data-v-5a546758],.gx-xxl-0[data-v-5a546758]{--bs-gutter-x:0}.g-xxl-0[data-v-5a546758],.gy-xxl-0[data-v-5a546758]{--bs-gutter-y:0}.g-xxl-1[data-v-5a546758],.gx-xxl-1[data-v-5a546758]{--bs-gutter-x:0.25rem}.g-xxl-1[data-v-5a546758],.gy-xxl-1[data-v-5a546758]{--bs-gutter-y:0.25rem}.g-xxl-2[data-v-5a546758],.gx-xxl-2[data-v-5a546758]{--bs-gutter-x:0.5rem}.g-xxl-2[data-v-5a546758],.gy-xxl-2[data-v-5a546758]{--bs-gutter-y:0.5rem}.g-xxl-3[data-v-5a546758],.gx-xxl-3[data-v-5a546758]{--bs-gutter-x:1rem}.g-xxl-3[data-v-5a546758],.gy-xxl-3[data-v-5a546758]{--bs-gutter-y:1rem}.g-xxl-4[data-v-5a546758],.gx-xxl-4[data-v-5a546758]{--bs-gutter-x:1.5rem}.g-xxl-4[data-v-5a546758],.gy-xxl-4[data-v-5a546758]{--bs-gutter-y:1.5rem}.g-xxl-5[data-v-5a546758],.gx-xxl-5[data-v-5a546758]{--bs-gutter-x:3rem}.g-xxl-5[data-v-5a546758],.gy-xxl-5[data-v-5a546758]{--bs-gutter-y:3rem}}.table[data-v-5a546758]{--bs-table-bg:transparent;--bs-table-accent-bg:transparent;--bs-table-striped-color:#212529;--bs-table-striped-bg:rgba(0,0,0,.05);--bs-table-active-color:#212529;--bs-table-active-bg:rgba(0,0,0,.1);--bs-table-hover-color:#212529;--bs-table-hover-bg:rgba(0,0,0,.075);width:100%;margin-bottom:1rem;color:#212529;vertical-align:top;border-color:#dee2e6}.table>:not(caption)>*>[data-v-5a546758]{padding:.5rem;background-color:var(--bs-table-bg);border-bottom-width:1px;box-shadow:inset 0 0 0 9999px var(--bs-table-accent-bg)}.table>tbody[data-v-5a546758]{vertical-align:inherit}.table>thead[data-v-5a546758]{vertical-align:bottom}.table[data-v-5a546758]>:not(:first-child){border-top:2px solid currentColor}.caption-top[data-v-5a546758]{caption-side:top}.table-sm>:not(caption)>*>[data-v-5a546758]{padding:.25rem}.table-bordered>:not(caption)>[data-v-5a546758]{border-width:1px 0}.table-bordered>:not(caption)>*>[data-v-5a546758]{border-width:0 1px}.table-borderless>:not(caption)>*>[data-v-5a546758]{border-bottom-width:0}.table-borderless[data-v-5a546758]>:not(:first-child){border-top-width:0}.table-striped>tbody>tr:nth-of-type(odd)>[data-v-5a546758]{--bs-table-accent-bg:var(--bs-table-striped-bg);color:var(--bs-table-striped-color)}.table-active[data-v-5a546758]{--bs-table-accent-bg:var(--bs-table-active-bg);color:var(--bs-table-active-color)}.table-hover>tbody>tr:hover>[data-v-5a546758]{--bs-table-accent-bg:var(--bs-table-hover-bg);color:var(--bs-table-hover-color)}.table-primary[data-v-5a546758]{--bs-table-bg:#cfe2ff;--bs-table-striped-bg:#c5d7f2;--bs-table-striped-color:#000;--bs-table-active-bg:#bacbe6;--bs-table-active-color:#000;--bs-table-hover-bg:#bfd1ec;--bs-table-hover-color:#000;color:#000;border-color:#bacbe6}.table-secondary[data-v-5a546758]{--bs-table-bg:#e2e3e5;--bs-table-striped-bg:#d7d8da;--bs-table-striped-color:#000;--bs-table-active-bg:#cbccce;--bs-table-active-color:#000;--bs-table-hover-bg:#d1d2d4;--bs-table-hover-color:#000;color:#000;border-color:#cbccce}.table-success[data-v-5a546758]{--bs-table-bg:#d1e7dd;--bs-table-striped-bg:#c7dbd2;--bs-table-striped-color:#000;--bs-table-active-bg:#bcd0c7;--bs-table-active-color:#000;--bs-table-hover-bg:#c1d6cc;--bs-table-hover-color:#000;color:#000;border-color:#bcd0c7}.table-info[data-v-5a546758]{--bs-table-bg:#cff4fc;--bs-table-striped-bg:#c5e8ef;--bs-table-striped-color:#000;--bs-table-active-bg:#badce3;--bs-table-active-color:#000;--bs-table-hover-bg:#bfe2e9;--bs-table-hover-color:#000;color:#000;border-color:#badce3}.table-warning[data-v-5a546758]{--bs-table-bg:#fff3cd;--bs-table-striped-bg:#f2e7c3;--bs-table-striped-color:#000;--bs-table-active-bg:#e6dbb9;--bs-table-active-color:#000;--bs-table-hover-bg:#ece1be;--bs-table-hover-color:#000;color:#000;border-color:#e6dbb9}.table-danger[data-v-5a546758]{--bs-table-bg:#f8d7da;--bs-table-striped-bg:#eccccf;--bs-table-striped-color:#000;--bs-table-active-bg:#dfc2c4;--bs-table-active-color:#000;--bs-table-hover-bg:#e5c7ca;--bs-table-hover-color:#000;color:#000;border-color:#dfc2c4}.table-light[data-v-5a546758]{--bs-table-bg:#f8f9fa;--bs-table-striped-bg:#ecedee;--bs-table-striped-color:#000;--bs-table-active-bg:#dfe0e1;--bs-table-active-color:#000;--bs-table-hover-bg:#e5e6e7;--bs-table-hover-color:#000;color:#000;border-color:#dfe0e1}.table-dark[data-v-5a546758]{--bs-table-bg:#212529;--bs-table-striped-bg:#2c3034;--bs-table-striped-color:#fff;--bs-table-active-bg:#373b3e;--bs-table-active-color:#fff;--bs-table-hover-bg:#323539;--bs-table-hover-color:#fff;color:#fff;border-color:#373b3e}.table-responsive[data-v-5a546758]{overflow-x:auto;-webkit-overflow-scrolling:touch}@media (max-width:575.98px){.table-responsive-sm[data-v-5a546758]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:767.98px){.table-responsive-md[data-v-5a546758]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:991.98px){.table-responsive-lg[data-v-5a546758]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1199.98px){.table-responsive-xl[data-v-5a546758]{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1399.98px){.table-responsive-xxl[data-v-5a546758]{overflow-x:auto;-webkit-overflow-scrolling:touch}}.form-label[data-v-5a546758]{margin-bottom:.5rem}.col-form-label[data-v-5a546758]{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg[data-v-5a546758]{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem}.col-form-label-sm[data-v-5a546758]{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem}.form-text[data-v-5a546758]{margin-top:.25rem;font-size:.875em;color:#6c757d}.form-control[data-v-5a546758]{display:block;width:100%;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-5a546758]{transition:none}}.form-control[type=file][data-v-5a546758]{overflow:hidden}.form-control[type=file][data-v-5a546758]:not(:disabled):not([readonly]){cursor:pointer}.form-control[data-v-5a546758]:focus{color:#212529;background-color:#fff;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-control[data-v-5a546758]::-webkit-date-and-time-value{height:1.5em}.form-control[data-v-5a546758]::-moz-placeholder{color:#6c757d;opacity:1}.form-control[data-v-5a546758]::placeholder{color:#6c757d;opacity:1}.form-control[data-v-5a546758]:disabled,.form-control[readonly][data-v-5a546758]{background-color:#e9ecef;opacity:1}.form-control[data-v-5a546758]::file-selector-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-5a546758]::-webkit-file-upload-button{-webkit-transition:none;transition:none}.form-control[data-v-5a546758]::file-selector-button{transition:none}}.form-control[data-v-5a546758]:hover:not(:disabled):not([readonly])::file-selector-button{background-color:#dde0e3}.form-control[data-v-5a546758]::-webkit-file-upload-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:#212529;background-color:#e9ecef;pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:1px;border-radius:0;-webkit-transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[data-v-5a546758]::-webkit-file-upload-button{-webkit-transition:none;transition:none}}.form-control[data-v-5a546758]:hover:not(:disabled):not([readonly])::-webkit-file-upload-button{background-color:#dde0e3}.form-control-plaintext[data-v-5a546758]{display:block;width:100%;padding:.375rem 0;margin-bottom:0;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg[data-v-5a546758],.form-control-plaintext.form-control-sm[data-v-5a546758]{padding-right:0;padding-left:0}.form-control-sm[data-v-5a546758]{min-height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.form-control-sm[data-v-5a546758]::file-selector-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-sm[data-v-5a546758]::-webkit-file-upload-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-lg[data-v-5a546758]{min-height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.form-control-lg[data-v-5a546758]::file-selector-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}.form-control-lg[data-v-5a546758]::-webkit-file-upload-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}textarea.form-control[data-v-5a546758]{min-height:calc(1.5em + .75rem + 2px)}textarea.form-control-sm[data-v-5a546758]{min-height:calc(1.5em + .5rem + 2px)}textarea.form-control-lg[data-v-5a546758]{min-height:calc(1.5em + 1rem + 2px)}.form-control-color[data-v-5a546758]{width:3rem;height:auto;padding:.375rem}.form-control-color[data-v-5a546758]:not(:disabled):not([readonly]){cursor:pointer}.form-control-color[data-v-5a546758]::-moz-color-swatch{height:1.5em;border-radius:.25rem}.form-control-color[data-v-5a546758]::-webkit-color-swatch{height:1.5em;border-radius:.25rem}.form-select[data-v-5a546758]{display:block;width:100%;padding:.375rem 2.25rem .375rem .75rem;-moz-padding-start:calc(.75rem - 3px);font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right .75rem center;background-size:16px 12px;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-select[data-v-5a546758]{transition:none}}.form-select[data-v-5a546758]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-select[multiple][data-v-5a546758],.form-select[size][data-v-5a546758]:not([size=\"1\"]){padding-right:.75rem;background-image:none}.form-select[data-v-5a546758]:disabled{background-color:#e9ecef}.form-select[data-v-5a546758]:-moz-focusring{color:transparent;text-shadow:0 0 0 #212529}.form-select-sm[data-v-5a546758]{padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem;border-radius:.2rem}.form-select-lg[data-v-5a546758]{padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem;border-radius:.3rem}.form-check[data-v-5a546758]{display:block;min-height:1.5rem;padding-left:1.5em;margin-bottom:.125rem}.form-check .form-check-input[data-v-5a546758]{float:left;margin-left:-1.5em}.form-check-input[data-v-5a546758]{width:1em;height:1em;margin-top:.25em;vertical-align:top;background-color:#fff;background-repeat:no-repeat;background-position:50%;background-size:contain;border:1px solid rgba(0,0,0,.25);-webkit-appearance:none;-moz-appearance:none;appearance:none;-webkit-print-color-adjust:exact;color-adjust:exact}.form-check-input[type=checkbox][data-v-5a546758]{border-radius:.25em}.form-check-input[type=radio][data-v-5a546758]{border-radius:50%}.form-check-input[data-v-5a546758]:active{filter:brightness(90%)}.form-check-input[data-v-5a546758]:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-check-input[data-v-5a546758]:checked{background-color:#0d6efd;border-color:#0d6efd}.form-check-input:checked[type=checkbox][data-v-5a546758]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3 6-6'/%3E%3C/svg%3E\")}.form-check-input:checked[type=radio][data-v-5a546758]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='2' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-input[type=checkbox][data-v-5a546758]:indeterminate{background-color:#0d6efd;border-color:#0d6efd;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3E%3C/svg%3E\")}.form-check-input[data-v-5a546758]:disabled{pointer-events:none;filter:none;opacity:.5}.form-check-input:disabled~.form-check-label[data-v-5a546758],.form-check-input[disabled]~.form-check-label[data-v-5a546758]{opacity:.5}.form-switch[data-v-5a546758]{padding-left:2.5em}.form-switch .form-check-input[data-v-5a546758]{width:2em;margin-left:-2.5em;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='rgba(0, 0, 0, 0.25)'/%3E%3C/svg%3E\");background-position:0;border-radius:2em;transition:background-position .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-switch .form-check-input[data-v-5a546758]{transition:none}}.form-switch .form-check-input[data-v-5a546758]:focus{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%2386b7fe'/%3E%3C/svg%3E\")}.form-switch .form-check-input[data-v-5a546758]:checked{background-position:100%;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")}.form-check-inline[data-v-5a546758]{display:inline-block;margin-right:1rem}.btn-check[data-v-5a546758]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.btn-check:disabled+.btn[data-v-5a546758],.btn-check[disabled]+.btn[data-v-5a546758]{pointer-events:none;filter:none;opacity:.65}.form-range[data-v-5a546758]{width:100%;height:1.5rem;padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.form-range[data-v-5a546758]:focus{outline:0}.form-range[data-v-5a546758]:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-5a546758]:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range[data-v-5a546758]::-moz-focus-outer{border:0}.form-range[data-v-5a546758]::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#0d6efd;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-5a546758]::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.form-range[data-v-5a546758]::-webkit-slider-thumb:active{background-color:#b6d4fe}.form-range[data-v-5a546758]::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-5a546758]::-moz-range-thumb{width:1rem;height:1rem;background-color:#0d6efd;border:0;border-radius:1rem;-moz-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-range[data-v-5a546758]::-moz-range-thumb{-moz-transition:none;transition:none}}.form-range[data-v-5a546758]::-moz-range-thumb:active{background-color:#b6d4fe}.form-range[data-v-5a546758]::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.form-range[data-v-5a546758]:disabled{pointer-events:none}.form-range[data-v-5a546758]:disabled::-webkit-slider-thumb{background-color:#adb5bd}.form-range[data-v-5a546758]:disabled::-moz-range-thumb{background-color:#adb5bd}.form-floating[data-v-5a546758]{position:relative}.form-floating>.form-control[data-v-5a546758],.form-floating>.form-select[data-v-5a546758]{height:calc(3.5rem + 2px);line-height:1.25}.form-floating>label[data-v-5a546758]{position:absolute;top:0;left:0;height:100%;padding:1rem .75rem;pointer-events:none;border:1px solid transparent;transform-origin:0 0;transition:opacity .1s ease-in-out,transform .1s ease-in-out}@media (prefers-reduced-motion:reduce){.form-floating>label[data-v-5a546758]{transition:none}}.form-floating>.form-control[data-v-5a546758]{padding:1rem .75rem}.form-floating>.form-control[data-v-5a546758]::-moz-placeholder{color:transparent}.form-floating>.form-control[data-v-5a546758]::placeholder{color:transparent}.form-floating>.form-control[data-v-5a546758]:not(:-moz-placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-5a546758]:focus,.form-floating>.form-control[data-v-5a546758]:not(:placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control[data-v-5a546758]:-webkit-autofill{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-select[data-v-5a546758]{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control:not(:-moz-placeholder-shown)~label[data-v-5a546758]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:focus~label[data-v-5a546758],.form-floating>.form-control:not(:placeholder-shown)~label[data-v-5a546758],.form-floating>.form-select~label[data-v-5a546758]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:-webkit-autofill~label[data-v-5a546758]{opacity:.65;transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.input-group[data-v-5a546758]{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group>.form-control[data-v-5a546758],.input-group>.form-select[data-v-5a546758]{position:relative;flex:1 1 auto;width:1%;min-width:0}.input-group>.form-control[data-v-5a546758]:focus,.input-group>.form-select[data-v-5a546758]:focus{z-index:3}.input-group .btn[data-v-5a546758]{position:relative;z-index:2}.input-group .btn[data-v-5a546758]:focus{z-index:3}.input-group-text[data-v-5a546758]{display:flex;align-items:center;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-lg>.btn[data-v-5a546758],.input-group-lg>.form-control[data-v-5a546758],.input-group-lg>.form-select[data-v-5a546758],.input-group-lg>.input-group-text[data-v-5a546758]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.input-group-sm>.btn[data-v-5a546758],.input-group-sm>.form-control[data-v-5a546758],.input-group-sm>.form-select[data-v-5a546758],.input-group-sm>.input-group-text[data-v-5a546758]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.input-group-lg>.form-select[data-v-5a546758],.input-group-sm>.form-select[data-v-5a546758]{padding-right:3rem}.input-group.has-validation>.dropdown-toggle[data-v-5a546758]:nth-last-child(n+4),.input-group.has-validation[data-v-5a546758]>:nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),.input-group:not(.has-validation)>.dropdown-toggle[data-v-5a546758]:nth-last-child(n+3),.input-group[data-v-5a546758]:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu){border-top-right-radius:0;border-bottom-right-radius:0}.input-group[data-v-5a546758]>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}.valid-feedback[data-v-5a546758]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#198754}.valid-tooltip[data-v-5a546758]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(25,135,84,.9);border-radius:.25rem}.is-valid~.valid-feedback[data-v-5a546758],.is-valid~.valid-tooltip[data-v-5a546758],.was-validated :valid~.valid-feedback[data-v-5a546758],.was-validated :valid~.valid-tooltip[data-v-5a546758]{display:block}.form-control.is-valid[data-v-5a546758],.was-validated .form-control[data-v-5a546758]:valid{border-color:#198754;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-valid[data-v-5a546758]:focus,.was-validated .form-control[data-v-5a546758]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.was-validated textarea.form-control[data-v-5a546758]:valid,textarea.form-control.is-valid[data-v-5a546758]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-valid[data-v-5a546758],.was-validated .form-select[data-v-5a546758]:valid{border-color:#198754}.form-select.is-valid:not([multiple])[size=\"1\"][data-v-5a546758],.form-select.is-valid[data-v-5a546758]:not([multiple]):not([size]),.was-validated .form-select:valid:not([multiple])[size=\"1\"][data-v-5a546758],.was-validated .form-select[data-v-5a546758]:valid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-valid[data-v-5a546758]:focus,.was-validated .form-select[data-v-5a546758]:valid:focus{border-color:#198754;box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid[data-v-5a546758],.was-validated .form-check-input[data-v-5a546758]:valid{border-color:#198754}.form-check-input.is-valid[data-v-5a546758]:checked,.was-validated .form-check-input[data-v-5a546758]:valid:checked{background-color:#198754}.form-check-input.is-valid[data-v-5a546758]:focus,.was-validated .form-check-input[data-v-5a546758]:valid:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.25)}.form-check-input.is-valid~.form-check-label[data-v-5a546758],.was-validated .form-check-input:valid~.form-check-label[data-v-5a546758]{color:#198754}.form-check-inline .form-check-input~.valid-feedback[data-v-5a546758]{margin-left:.5em}.input-group .form-control.is-valid[data-v-5a546758],.input-group .form-select.is-valid[data-v-5a546758],.was-validated .input-group .form-control[data-v-5a546758]:valid,.was-validated .input-group .form-select[data-v-5a546758]:valid{z-index:1}.input-group .form-control.is-valid[data-v-5a546758]:focus,.input-group .form-select.is-valid[data-v-5a546758]:focus,.was-validated .input-group .form-control[data-v-5a546758]:valid:focus,.was-validated .input-group .form-select[data-v-5a546758]:valid:focus{z-index:3}.invalid-feedback[data-v-5a546758]{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:#dc3545}.invalid-tooltip[data-v-5a546758]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:rgba(220,53,69,.9);border-radius:.25rem}.is-invalid~.invalid-feedback[data-v-5a546758],.is-invalid~.invalid-tooltip[data-v-5a546758],.was-validated :invalid~.invalid-feedback[data-v-5a546758],.was-validated :invalid~.invalid-tooltip[data-v-5a546758]{display:block}.form-control.is-invalid[data-v-5a546758],.was-validated .form-control[data-v-5a546758]:invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-invalid[data-v-5a546758]:focus,.was-validated .form-control[data-v-5a546758]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.was-validated textarea.form-control[data-v-5a546758]:invalid,textarea.form-control.is-invalid[data-v-5a546758]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-invalid[data-v-5a546758],.was-validated .form-select[data-v-5a546758]:invalid{border-color:#dc3545}.form-select.is-invalid:not([multiple])[size=\"1\"][data-v-5a546758],.form-select.is-invalid[data-v-5a546758]:not([multiple]):not([size]),.was-validated .form-select:invalid:not([multiple])[size=\"1\"][data-v-5a546758],.was-validated .form-select[data-v-5a546758]:invalid:not([multiple]):not([size]){padding-right:4.125rem;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E\"),url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E\");background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-invalid[data-v-5a546758]:focus,.was-validated .form-select[data-v-5a546758]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid[data-v-5a546758],.was-validated .form-check-input[data-v-5a546758]:invalid{border-color:#dc3545}.form-check-input.is-invalid[data-v-5a546758]:checked,.was-validated .form-check-input[data-v-5a546758]:invalid:checked{background-color:#dc3545}.form-check-input.is-invalid[data-v-5a546758]:focus,.was-validated .form-check-input[data-v-5a546758]:invalid:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.25)}.form-check-input.is-invalid~.form-check-label[data-v-5a546758],.was-validated .form-check-input:invalid~.form-check-label[data-v-5a546758]{color:#dc3545}.form-check-inline .form-check-input~.invalid-feedback[data-v-5a546758]{margin-left:.5em}.input-group .form-control.is-invalid[data-v-5a546758],.input-group .form-select.is-invalid[data-v-5a546758],.was-validated .input-group .form-control[data-v-5a546758]:invalid,.was-validated .input-group .form-select[data-v-5a546758]:invalid{z-index:2}.input-group .form-control.is-invalid[data-v-5a546758]:focus,.input-group .form-select.is-invalid[data-v-5a546758]:focus,.was-validated .input-group .form-control[data-v-5a546758]:invalid:focus,.was-validated .input-group .form-select[data-v-5a546758]:invalid:focus{z-index:3}.btn[data-v-5a546758]{display:inline-block;font-weight:400;line-height:1.5;color:#212529;text-align:center;text-decoration:none;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn[data-v-5a546758]{transition:none}}.btn[data-v-5a546758]:hover{color:#212529}.btn-check:focus+.btn[data-v-5a546758],.btn[data-v-5a546758]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.btn.disabled[data-v-5a546758],.btn[data-v-5a546758]:disabled,fieldset:disabled .btn[data-v-5a546758]{pointer-events:none;opacity:.65}.btn-primary[data-v-5a546758]{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-primary[data-v-5a546758]:hover{color:#fff;background-color:#0b5ed7;border-color:#0a58ca}.btn-check:focus+.btn-primary[data-v-5a546758],.btn-primary[data-v-5a546758]:focus{color:#fff;background-color:#0b5ed7;border-color:#0a58ca;box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-check:active+.btn-primary[data-v-5a546758],.btn-check:checked+.btn-primary[data-v-5a546758],.btn-primary.active[data-v-5a546758],.btn-primary[data-v-5a546758]:active,.show>.btn-primary.dropdown-toggle[data-v-5a546758]{color:#fff;background-color:#0a58ca;border-color:#0a53be}.btn-check:active+.btn-primary[data-v-5a546758]:focus,.btn-check:checked+.btn-primary[data-v-5a546758]:focus,.btn-primary.active[data-v-5a546758]:focus,.btn-primary[data-v-5a546758]:active:focus,.show>.btn-primary.dropdown-toggle[data-v-5a546758]:focus{box-shadow:0 0 0 .25rem rgba(49,132,253,.5)}.btn-primary.disabled[data-v-5a546758],.btn-primary[data-v-5a546758]:disabled{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-secondary[data-v-5a546758]{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary[data-v-5a546758]:hover{color:#fff;background-color:#5c636a;border-color:#565e64}.btn-check:focus+.btn-secondary[data-v-5a546758],.btn-secondary[data-v-5a546758]:focus{color:#fff;background-color:#5c636a;border-color:#565e64;box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-check:active+.btn-secondary[data-v-5a546758],.btn-check:checked+.btn-secondary[data-v-5a546758],.btn-secondary.active[data-v-5a546758],.btn-secondary[data-v-5a546758]:active,.show>.btn-secondary.dropdown-toggle[data-v-5a546758]{color:#fff;background-color:#565e64;border-color:#51585e}.btn-check:active+.btn-secondary[data-v-5a546758]:focus,.btn-check:checked+.btn-secondary[data-v-5a546758]:focus,.btn-secondary.active[data-v-5a546758]:focus,.btn-secondary[data-v-5a546758]:active:focus,.show>.btn-secondary.dropdown-toggle[data-v-5a546758]:focus{box-shadow:0 0 0 .25rem hsla(208,6%,54%,.5)}.btn-secondary.disabled[data-v-5a546758],.btn-secondary[data-v-5a546758]:disabled{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-success[data-v-5a546758]{color:#fff;background-color:#198754;border-color:#198754}.btn-success[data-v-5a546758]:hover{color:#fff;background-color:#157347;border-color:#146c43}.btn-check:focus+.btn-success[data-v-5a546758],.btn-success[data-v-5a546758]:focus{color:#fff;background-color:#157347;border-color:#146c43;box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-check:active+.btn-success[data-v-5a546758],.btn-check:checked+.btn-success[data-v-5a546758],.btn-success.active[data-v-5a546758],.btn-success[data-v-5a546758]:active,.show>.btn-success.dropdown-toggle[data-v-5a546758]{color:#fff;background-color:#146c43;border-color:#13653f}.btn-check:active+.btn-success[data-v-5a546758]:focus,.btn-check:checked+.btn-success[data-v-5a546758]:focus,.btn-success.active[data-v-5a546758]:focus,.btn-success[data-v-5a546758]:active:focus,.show>.btn-success.dropdown-toggle[data-v-5a546758]:focus{box-shadow:0 0 0 .25rem rgba(60,153,110,.5)}.btn-success.disabled[data-v-5a546758],.btn-success[data-v-5a546758]:disabled{color:#fff;background-color:#198754;border-color:#198754}.btn-info[data-v-5a546758]{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-info[data-v-5a546758]:hover{color:#000;background-color:#31d2f2;border-color:#25cff2}.btn-check:focus+.btn-info[data-v-5a546758],.btn-info[data-v-5a546758]:focus{color:#000;background-color:#31d2f2;border-color:#25cff2;box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-check:active+.btn-info[data-v-5a546758],.btn-check:checked+.btn-info[data-v-5a546758],.btn-info.active[data-v-5a546758],.btn-info[data-v-5a546758]:active,.show>.btn-info.dropdown-toggle[data-v-5a546758]{color:#000;background-color:#3dd5f3;border-color:#25cff2}.btn-check:active+.btn-info[data-v-5a546758]:focus,.btn-check:checked+.btn-info[data-v-5a546758]:focus,.btn-info.active[data-v-5a546758]:focus,.btn-info[data-v-5a546758]:active:focus,.show>.btn-info.dropdown-toggle[data-v-5a546758]:focus{box-shadow:0 0 0 .25rem rgba(11,172,204,.5)}.btn-info.disabled[data-v-5a546758],.btn-info[data-v-5a546758]:disabled{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-warning[data-v-5a546758]{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-warning[data-v-5a546758]:hover{color:#000;background-color:#ffca2c;border-color:#ffc720}.btn-check:focus+.btn-warning[data-v-5a546758],.btn-warning[data-v-5a546758]:focus{color:#000;background-color:#ffca2c;border-color:#ffc720;box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-check:active+.btn-warning[data-v-5a546758],.btn-check:checked+.btn-warning[data-v-5a546758],.btn-warning.active[data-v-5a546758],.btn-warning[data-v-5a546758]:active,.show>.btn-warning.dropdown-toggle[data-v-5a546758]{color:#000;background-color:#ffcd39;border-color:#ffc720}.btn-check:active+.btn-warning[data-v-5a546758]:focus,.btn-check:checked+.btn-warning[data-v-5a546758]:focus,.btn-warning.active[data-v-5a546758]:focus,.btn-warning[data-v-5a546758]:active:focus,.show>.btn-warning.dropdown-toggle[data-v-5a546758]:focus{box-shadow:0 0 0 .25rem rgba(217,164,6,.5)}.btn-warning.disabled[data-v-5a546758],.btn-warning[data-v-5a546758]:disabled{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-danger[data-v-5a546758]{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger[data-v-5a546758]:hover{color:#fff;background-color:#bb2d3b;border-color:#b02a37}.btn-check:focus+.btn-danger[data-v-5a546758],.btn-danger[data-v-5a546758]:focus{color:#fff;background-color:#bb2d3b;border-color:#b02a37;box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-check:active+.btn-danger[data-v-5a546758],.btn-check:checked+.btn-danger[data-v-5a546758],.btn-danger.active[data-v-5a546758],.btn-danger[data-v-5a546758]:active,.show>.btn-danger.dropdown-toggle[data-v-5a546758]{color:#fff;background-color:#b02a37;border-color:#a52834}.btn-check:active+.btn-danger[data-v-5a546758]:focus,.btn-check:checked+.btn-danger[data-v-5a546758]:focus,.btn-danger.active[data-v-5a546758]:focus,.btn-danger[data-v-5a546758]:active:focus,.show>.btn-danger.dropdown-toggle[data-v-5a546758]:focus{box-shadow:0 0 0 .25rem rgba(225,83,97,.5)}.btn-danger.disabled[data-v-5a546758],.btn-danger[data-v-5a546758]:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-light[data-v-5a546758]{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light[data-v-5a546758]:hover{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:focus+.btn-light[data-v-5a546758],.btn-light[data-v-5a546758]:focus{color:#000;background-color:#f9fafb;border-color:#f9fafb;box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-check:active+.btn-light[data-v-5a546758],.btn-check:checked+.btn-light[data-v-5a546758],.btn-light.active[data-v-5a546758],.btn-light[data-v-5a546758]:active,.show>.btn-light.dropdown-toggle[data-v-5a546758]{color:#000;background-color:#f9fafb;border-color:#f9fafb}.btn-check:active+.btn-light[data-v-5a546758]:focus,.btn-check:checked+.btn-light[data-v-5a546758]:focus,.btn-light.active[data-v-5a546758]:focus,.btn-light[data-v-5a546758]:active:focus,.show>.btn-light.dropdown-toggle[data-v-5a546758]:focus{box-shadow:0 0 0 .25rem hsla(210,2%,83%,.5)}.btn-light.disabled[data-v-5a546758],.btn-light[data-v-5a546758]:disabled{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-dark[data-v-5a546758]{color:#fff;background-color:#212529;border-color:#212529}.btn-dark[data-v-5a546758]:hover{color:#fff;background-color:#1c1f23;border-color:#1a1e21}.btn-check:focus+.btn-dark[data-v-5a546758],.btn-dark[data-v-5a546758]:focus{color:#fff;background-color:#1c1f23;border-color:#1a1e21;box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-check:active+.btn-dark[data-v-5a546758],.btn-check:checked+.btn-dark[data-v-5a546758],.btn-dark.active[data-v-5a546758],.btn-dark[data-v-5a546758]:active,.show>.btn-dark.dropdown-toggle[data-v-5a546758]{color:#fff;background-color:#1a1e21;border-color:#191c1f}.btn-check:active+.btn-dark[data-v-5a546758]:focus,.btn-check:checked+.btn-dark[data-v-5a546758]:focus,.btn-dark.active[data-v-5a546758]:focus,.btn-dark[data-v-5a546758]:active:focus,.show>.btn-dark.dropdown-toggle[data-v-5a546758]:focus{box-shadow:0 0 0 .25rem rgba(66,70,73,.5)}.btn-dark.disabled[data-v-5a546758],.btn-dark[data-v-5a546758]:disabled{color:#fff;background-color:#212529;border-color:#212529}.btn-outline-primary[data-v-5a546758]{color:#0d6efd;border-color:#0d6efd}.btn-outline-primary[data-v-5a546758]:hover{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:focus+.btn-outline-primary[data-v-5a546758],.btn-outline-primary[data-v-5a546758]:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-check:active+.btn-outline-primary[data-v-5a546758],.btn-check:checked+.btn-outline-primary[data-v-5a546758],.btn-outline-primary.active[data-v-5a546758],.btn-outline-primary.dropdown-toggle.show[data-v-5a546758],.btn-outline-primary[data-v-5a546758]:active{color:#fff;background-color:#0d6efd;border-color:#0d6efd}.btn-check:active+.btn-outline-primary[data-v-5a546758]:focus,.btn-check:checked+.btn-outline-primary[data-v-5a546758]:focus,.btn-outline-primary.active[data-v-5a546758]:focus,.btn-outline-primary.dropdown-toggle.show[data-v-5a546758]:focus,.btn-outline-primary[data-v-5a546758]:active:focus{box-shadow:0 0 0 .25rem rgba(13,110,253,.5)}.btn-outline-primary.disabled[data-v-5a546758],.btn-outline-primary[data-v-5a546758]:disabled{color:#0d6efd;background-color:transparent}.btn-outline-secondary[data-v-5a546758]{color:#6c757d;border-color:#6c757d}.btn-outline-secondary[data-v-5a546758]:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:focus+.btn-outline-secondary[data-v-5a546758],.btn-outline-secondary[data-v-5a546758]:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-check:active+.btn-outline-secondary[data-v-5a546758],.btn-check:checked+.btn-outline-secondary[data-v-5a546758],.btn-outline-secondary.active[data-v-5a546758],.btn-outline-secondary.dropdown-toggle.show[data-v-5a546758],.btn-outline-secondary[data-v-5a546758]:active{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-check:active+.btn-outline-secondary[data-v-5a546758]:focus,.btn-check:checked+.btn-outline-secondary[data-v-5a546758]:focus,.btn-outline-secondary.active[data-v-5a546758]:focus,.btn-outline-secondary.dropdown-toggle.show[data-v-5a546758]:focus,.btn-outline-secondary[data-v-5a546758]:active:focus{box-shadow:0 0 0 .25rem hsla(208,7%,46%,.5)}.btn-outline-secondary.disabled[data-v-5a546758],.btn-outline-secondary[data-v-5a546758]:disabled{color:#6c757d;background-color:transparent}.btn-outline-success[data-v-5a546758]{color:#198754;border-color:#198754}.btn-outline-success[data-v-5a546758]:hover{color:#fff;background-color:#198754;border-color:#198754}.btn-check:focus+.btn-outline-success[data-v-5a546758],.btn-outline-success[data-v-5a546758]:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-check:active+.btn-outline-success[data-v-5a546758],.btn-check:checked+.btn-outline-success[data-v-5a546758],.btn-outline-success.active[data-v-5a546758],.btn-outline-success.dropdown-toggle.show[data-v-5a546758],.btn-outline-success[data-v-5a546758]:active{color:#fff;background-color:#198754;border-color:#198754}.btn-check:active+.btn-outline-success[data-v-5a546758]:focus,.btn-check:checked+.btn-outline-success[data-v-5a546758]:focus,.btn-outline-success.active[data-v-5a546758]:focus,.btn-outline-success.dropdown-toggle.show[data-v-5a546758]:focus,.btn-outline-success[data-v-5a546758]:active:focus{box-shadow:0 0 0 .25rem rgba(25,135,84,.5)}.btn-outline-success.disabled[data-v-5a546758],.btn-outline-success[data-v-5a546758]:disabled{color:#198754;background-color:transparent}.btn-outline-info[data-v-5a546758]{color:#0dcaf0;border-color:#0dcaf0}.btn-outline-info[data-v-5a546758]:hover{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:focus+.btn-outline-info[data-v-5a546758],.btn-outline-info[data-v-5a546758]:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-check:active+.btn-outline-info[data-v-5a546758],.btn-check:checked+.btn-outline-info[data-v-5a546758],.btn-outline-info.active[data-v-5a546758],.btn-outline-info.dropdown-toggle.show[data-v-5a546758],.btn-outline-info[data-v-5a546758]:active{color:#000;background-color:#0dcaf0;border-color:#0dcaf0}.btn-check:active+.btn-outline-info[data-v-5a546758]:focus,.btn-check:checked+.btn-outline-info[data-v-5a546758]:focus,.btn-outline-info.active[data-v-5a546758]:focus,.btn-outline-info.dropdown-toggle.show[data-v-5a546758]:focus,.btn-outline-info[data-v-5a546758]:active:focus{box-shadow:0 0 0 .25rem rgba(13,202,240,.5)}.btn-outline-info.disabled[data-v-5a546758],.btn-outline-info[data-v-5a546758]:disabled{color:#0dcaf0;background-color:transparent}.btn-outline-warning[data-v-5a546758]{color:#ffc107;border-color:#ffc107}.btn-outline-warning[data-v-5a546758]:hover{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:focus+.btn-outline-warning[data-v-5a546758],.btn-outline-warning[data-v-5a546758]:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-check:active+.btn-outline-warning[data-v-5a546758],.btn-check:checked+.btn-outline-warning[data-v-5a546758],.btn-outline-warning.active[data-v-5a546758],.btn-outline-warning.dropdown-toggle.show[data-v-5a546758],.btn-outline-warning[data-v-5a546758]:active{color:#000;background-color:#ffc107;border-color:#ffc107}.btn-check:active+.btn-outline-warning[data-v-5a546758]:focus,.btn-check:checked+.btn-outline-warning[data-v-5a546758]:focus,.btn-outline-warning.active[data-v-5a546758]:focus,.btn-outline-warning.dropdown-toggle.show[data-v-5a546758]:focus,.btn-outline-warning[data-v-5a546758]:active:focus{box-shadow:0 0 0 .25rem rgba(255,193,7,.5)}.btn-outline-warning.disabled[data-v-5a546758],.btn-outline-warning[data-v-5a546758]:disabled{color:#ffc107;background-color:transparent}.btn-outline-danger[data-v-5a546758]{color:#dc3545;border-color:#dc3545}.btn-outline-danger[data-v-5a546758]:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:focus+.btn-outline-danger[data-v-5a546758],.btn-outline-danger[data-v-5a546758]:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-check:active+.btn-outline-danger[data-v-5a546758],.btn-check:checked+.btn-outline-danger[data-v-5a546758],.btn-outline-danger.active[data-v-5a546758],.btn-outline-danger.dropdown-toggle.show[data-v-5a546758],.btn-outline-danger[data-v-5a546758]:active{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-check:active+.btn-outline-danger[data-v-5a546758]:focus,.btn-check:checked+.btn-outline-danger[data-v-5a546758]:focus,.btn-outline-danger.active[data-v-5a546758]:focus,.btn-outline-danger.dropdown-toggle.show[data-v-5a546758]:focus,.btn-outline-danger[data-v-5a546758]:active:focus{box-shadow:0 0 0 .25rem rgba(220,53,69,.5)}.btn-outline-danger.disabled[data-v-5a546758],.btn-outline-danger[data-v-5a546758]:disabled{color:#dc3545;background-color:transparent}.btn-outline-light[data-v-5a546758]{color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light[data-v-5a546758]:hover{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:focus+.btn-outline-light[data-v-5a546758],.btn-outline-light[data-v-5a546758]:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-check:active+.btn-outline-light[data-v-5a546758],.btn-check:checked+.btn-outline-light[data-v-5a546758],.btn-outline-light.active[data-v-5a546758],.btn-outline-light.dropdown-toggle.show[data-v-5a546758],.btn-outline-light[data-v-5a546758]:active{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}.btn-check:active+.btn-outline-light[data-v-5a546758]:focus,.btn-check:checked+.btn-outline-light[data-v-5a546758]:focus,.btn-outline-light.active[data-v-5a546758]:focus,.btn-outline-light.dropdown-toggle.show[data-v-5a546758]:focus,.btn-outline-light[data-v-5a546758]:active:focus{box-shadow:0 0 0 .25rem rgba(248,249,250,.5)}.btn-outline-light.disabled[data-v-5a546758],.btn-outline-light[data-v-5a546758]:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-dark[data-v-5a546758]{color:#212529;border-color:#212529}.btn-outline-dark[data-v-5a546758]:hover{color:#fff;background-color:#212529;border-color:#212529}.btn-check:focus+.btn-outline-dark[data-v-5a546758],.btn-outline-dark[data-v-5a546758]:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-check:active+.btn-outline-dark[data-v-5a546758],.btn-check:checked+.btn-outline-dark[data-v-5a546758],.btn-outline-dark.active[data-v-5a546758],.btn-outline-dark.dropdown-toggle.show[data-v-5a546758],.btn-outline-dark[data-v-5a546758]:active{color:#fff;background-color:#212529;border-color:#212529}.btn-check:active+.btn-outline-dark[data-v-5a546758]:focus,.btn-check:checked+.btn-outline-dark[data-v-5a546758]:focus,.btn-outline-dark.active[data-v-5a546758]:focus,.btn-outline-dark.dropdown-toggle.show[data-v-5a546758]:focus,.btn-outline-dark[data-v-5a546758]:active:focus{box-shadow:0 0 0 .25rem rgba(33,37,41,.5)}.btn-outline-dark.disabled[data-v-5a546758],.btn-outline-dark[data-v-5a546758]:disabled{color:#212529;background-color:transparent}.btn-link[data-v-5a546758]{font-weight:400;color:#0d6efd;text-decoration:underline}.btn-link[data-v-5a546758]:hover{color:#0a58ca}.btn-link.disabled[data-v-5a546758],.btn-link[data-v-5a546758]:disabled{color:#6c757d}.btn-group-lg>.btn[data-v-5a546758],.btn-lg[data-v-5a546758]{padding:.5rem 1rem;font-size:1.25rem;border-radius:.3rem}.btn-group-sm>.btn[data-v-5a546758],.btn-sm[data-v-5a546758]{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.fade[data-v-5a546758]{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade[data-v-5a546758]{transition:none}}.fade[data-v-5a546758]:not(.show){opacity:0}.collapse[data-v-5a546758]:not(.show){display:none}.collapsing[data-v-5a546758]{height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.collapsing[data-v-5a546758]{transition:none}}.collapsing.collapse-horizontal[data-v-5a546758]{width:0;height:auto;transition:width .35s ease}@media (prefers-reduced-motion:reduce){.collapsing.collapse-horizontal[data-v-5a546758]{transition:none}}.dropdown[data-v-5a546758],.dropend[data-v-5a546758],.dropstart[data-v-5a546758],.dropup[data-v-5a546758]{position:relative}.dropdown-toggle[data-v-5a546758]{white-space:nowrap}.dropdown-toggle[data-v-5a546758]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle[data-v-5a546758]:empty:after{margin-left:0}.dropdown-menu[data-v-5a546758]{position:absolute;z-index:1000;display:none;min-width:10rem;padding:.5rem 0;margin:0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-menu[data-bs-popper][data-v-5a546758]{top:100%;left:0;margin-top:.125rem}.dropdown-menu-start[data-v-5a546758]{--bs-position:start}.dropdown-menu-start[data-bs-popper][data-v-5a546758]{right:auto;left:0}.dropdown-menu-end[data-v-5a546758]{--bs-position:end}.dropdown-menu-end[data-bs-popper][data-v-5a546758]{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-start[data-v-5a546758]{--bs-position:start}.dropdown-menu-sm-start[data-bs-popper][data-v-5a546758]{right:auto;left:0}.dropdown-menu-sm-end[data-v-5a546758]{--bs-position:end}.dropdown-menu-sm-end[data-bs-popper][data-v-5a546758]{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-start[data-v-5a546758]{--bs-position:start}.dropdown-menu-md-start[data-bs-popper][data-v-5a546758]{right:auto;left:0}.dropdown-menu-md-end[data-v-5a546758]{--bs-position:end}.dropdown-menu-md-end[data-bs-popper][data-v-5a546758]{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-start[data-v-5a546758]{--bs-position:start}.dropdown-menu-lg-start[data-bs-popper][data-v-5a546758]{right:auto;left:0}.dropdown-menu-lg-end[data-v-5a546758]{--bs-position:end}.dropdown-menu-lg-end[data-bs-popper][data-v-5a546758]{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-start[data-v-5a546758]{--bs-position:start}.dropdown-menu-xl-start[data-bs-popper][data-v-5a546758]{right:auto;left:0}.dropdown-menu-xl-end[data-v-5a546758]{--bs-position:end}.dropdown-menu-xl-end[data-bs-popper][data-v-5a546758]{right:0;left:auto}}@media (min-width:1400px){.dropdown-menu-xxl-start[data-v-5a546758]{--bs-position:start}.dropdown-menu-xxl-start[data-bs-popper][data-v-5a546758]{right:auto;left:0}.dropdown-menu-xxl-end[data-v-5a546758]{--bs-position:end}.dropdown-menu-xxl-end[data-bs-popper][data-v-5a546758]{right:0;left:auto}}.dropup .dropdown-menu[data-bs-popper][data-v-5a546758]{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle[data-v-5a546758]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle[data-v-5a546758]:empty:after{margin-left:0}.dropend .dropdown-menu[data-bs-popper][data-v-5a546758]{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.dropend .dropdown-toggle[data-v-5a546758]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropend .dropdown-toggle[data-v-5a546758]:empty:after{margin-left:0}.dropend .dropdown-toggle[data-v-5a546758]:after{vertical-align:0}.dropstart .dropdown-menu[data-bs-popper][data-v-5a546758]{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.dropstart .dropdown-toggle[data-v-5a546758]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";display:none}.dropstart .dropdown-toggle[data-v-5a546758]:before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropstart .dropdown-toggle[data-v-5a546758]:empty:after{margin-left:0}.dropstart .dropdown-toggle[data-v-5a546758]:before{vertical-align:0}.dropdown-divider[data-v-5a546758]{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid rgba(0,0,0,.15)}.dropdown-item[data-v-5a546758]{display:block;width:100%;padding:.25rem 1rem;clear:both;font-weight:400;color:#212529;text-align:inherit;text-decoration:none;white-space:nowrap;background-color:transparent;border:0}.dropdown-item[data-v-5a546758]:focus,.dropdown-item[data-v-5a546758]:hover{color:#1e2125;background-color:#e9ecef}.dropdown-item.active[data-v-5a546758],.dropdown-item[data-v-5a546758]:active{color:#fff;text-decoration:none;background-color:#0d6efd}.dropdown-item.disabled[data-v-5a546758],.dropdown-item[data-v-5a546758]:disabled{color:#adb5bd;pointer-events:none;background-color:transparent}.dropdown-menu.show[data-v-5a546758]{display:block}.dropdown-header[data-v-5a546758]{display:block;padding:.5rem 1rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.dropdown-item-text[data-v-5a546758]{display:block;padding:.25rem 1rem;color:#212529}.dropdown-menu-dark[data-v-5a546758]{color:#dee2e6;background-color:#343a40;border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item[data-v-5a546758]{color:#dee2e6}.dropdown-menu-dark .dropdown-item[data-v-5a546758]:focus,.dropdown-menu-dark .dropdown-item[data-v-5a546758]:hover{color:#fff;background-color:hsla(0,0%,100%,.15)}.dropdown-menu-dark .dropdown-item.active[data-v-5a546758],.dropdown-menu-dark .dropdown-item[data-v-5a546758]:active{color:#fff;background-color:#0d6efd}.dropdown-menu-dark .dropdown-item.disabled[data-v-5a546758],.dropdown-menu-dark .dropdown-item[data-v-5a546758]:disabled{color:#adb5bd}.dropdown-menu-dark .dropdown-divider[data-v-5a546758]{border-color:rgba(0,0,0,.15)}.dropdown-menu-dark .dropdown-item-text[data-v-5a546758]{color:#dee2e6}.dropdown-menu-dark .dropdown-header[data-v-5a546758]{color:#adb5bd}.btn-group-vertical[data-v-5a546758],.btn-group[data-v-5a546758]{position:relative;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn[data-v-5a546758],.btn-group>.btn[data-v-5a546758]{position:relative;flex:1 1 auto}.btn-group-vertical>.btn-check:checked+.btn[data-v-5a546758],.btn-group-vertical>.btn-check:focus+.btn[data-v-5a546758],.btn-group-vertical>.btn.active[data-v-5a546758],.btn-group-vertical>.btn[data-v-5a546758]:active,.btn-group-vertical>.btn[data-v-5a546758]:focus,.btn-group-vertical>.btn[data-v-5a546758]:hover,.btn-group>.btn-check:checked+.btn[data-v-5a546758],.btn-group>.btn-check:focus+.btn[data-v-5a546758],.btn-group>.btn.active[data-v-5a546758],.btn-group>.btn[data-v-5a546758]:active,.btn-group>.btn[data-v-5a546758]:focus,.btn-group>.btn[data-v-5a546758]:hover{z-index:1}.btn-toolbar[data-v-5a546758]{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar .input-group[data-v-5a546758]{width:auto}.btn-group>.btn-group[data-v-5a546758]:not(:first-child),.btn-group>.btn[data-v-5a546758]:not(:first-child){margin-left:-1px}.btn-group>.btn-group:not(:last-child)>.btn[data-v-5a546758],.btn-group>.btn[data-v-5a546758]:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn[data-v-5a546758],.btn-group>.btn[data-v-5a546758]:nth-child(n+3),.btn-group>:not(.btn-check)+.btn[data-v-5a546758]{border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split[data-v-5a546758]{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split[data-v-5a546758]:after,.dropend .dropdown-toggle-split[data-v-5a546758]:after,.dropup .dropdown-toggle-split[data-v-5a546758]:after{margin-left:0}.dropstart .dropdown-toggle-split[data-v-5a546758]:before{margin-right:0}.btn-group-sm>.btn+.dropdown-toggle-split[data-v-5a546758],.btn-sm+.dropdown-toggle-split[data-v-5a546758]{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split[data-v-5a546758],.btn-lg+.dropdown-toggle-split[data-v-5a546758]{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical[data-v-5a546758]{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical>.btn-group[data-v-5a546758],.btn-group-vertical>.btn[data-v-5a546758]{width:100%}.btn-group-vertical>.btn-group[data-v-5a546758]:not(:first-child),.btn-group-vertical>.btn[data-v-5a546758]:not(:first-child){margin-top:-1px}.btn-group-vertical>.btn-group:not(:last-child)>.btn[data-v-5a546758],.btn-group-vertical>.btn[data-v-5a546758]:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn[data-v-5a546758],.btn-group-vertical>.btn~.btn[data-v-5a546758]{border-top-left-radius:0;border-top-right-radius:0}.nav[data-v-5a546758]{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link[data-v-5a546758]{display:block;padding:.5rem 1rem;color:#0d6efd;text-decoration:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out}@media (prefers-reduced-motion:reduce){.nav-link[data-v-5a546758]{transition:none}}.nav-link[data-v-5a546758]:focus,.nav-link[data-v-5a546758]:hover{color:#0a58ca}.nav-link.disabled[data-v-5a546758]{color:#6c757d;pointer-events:none;cursor:default}.nav-tabs[data-v-5a546758]{border-bottom:1px solid #dee2e6}.nav-tabs .nav-link[data-v-5a546758]{margin-bottom:-1px;background:0 0;border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link[data-v-5a546758]:focus,.nav-tabs .nav-link[data-v-5a546758]:hover{border-color:#e9ecef #e9ecef #dee2e6;isolation:isolate}.nav-tabs .nav-link.disabled[data-v-5a546758]{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link[data-v-5a546758],.nav-tabs .nav-link.active[data-v-5a546758]{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu[data-v-5a546758]{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link[data-v-5a546758]{background:0 0;border:0;border-radius:.25rem}.nav-pills .nav-link.active[data-v-5a546758],.nav-pills .show>.nav-link[data-v-5a546758]{color:#fff;background-color:#0d6efd}.nav-fill .nav-item[data-v-5a546758],.nav-fill>.nav-link[data-v-5a546758]{flex:1 1 auto;text-align:center}.nav-justified .nav-item[data-v-5a546758],.nav-justified>.nav-link[data-v-5a546758]{flex-basis:0;flex-grow:1;text-align:center}.nav-fill .nav-item .nav-link[data-v-5a546758],.nav-justified .nav-item .nav-link[data-v-5a546758]{width:100%}.tab-content>.tab-pane[data-v-5a546758]{display:none}.tab-content>.active[data-v-5a546758]{display:block}.navbar[data-v-5a546758]{position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding-top:.5rem;padding-bottom:.5rem}.navbar>.container-fluid[data-v-5a546758],.navbar>.container-lg[data-v-5a546758],.navbar>.container-md[data-v-5a546758],.navbar>.container-sm[data-v-5a546758],.navbar>.container-xl[data-v-5a546758],.navbar>.container-xxl[data-v-5a546758],.navbar>.container[data-v-5a546758]{display:flex;flex-wrap:inherit;align-items:center;justify-content:space-between}.navbar-brand[data-v-5a546758]{padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;text-decoration:none;white-space:nowrap}.navbar-nav[data-v-5a546758]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link[data-v-5a546758]{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu[data-v-5a546758]{position:static}.navbar-text[data-v-5a546758]{padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse[data-v-5a546758]{flex-basis:100%;flex-grow:1;align-items:center}.navbar-toggler[data-v-5a546758]{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem;transition:box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.navbar-toggler[data-v-5a546758]{transition:none}}.navbar-toggler[data-v-5a546758]:hover{text-decoration:none}.navbar-toggler[data-v-5a546758]:focus{text-decoration:none;outline:0;box-shadow:0 0 0 .25rem}.navbar-toggler-icon[data-v-5a546758]{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;background-repeat:no-repeat;background-position:50%;background-size:100%}.navbar-nav-scroll[data-v-5a546758]{max-height:var(--bs-scroll-height,75vh);overflow-y:auto}@media (min-width:576px){.navbar-expand-sm[data-v-5a546758]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-sm .navbar-nav[data-v-5a546758]{flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu[data-v-5a546758]{position:absolute}.navbar-expand-sm .navbar-nav .nav-link[data-v-5a546758]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm .navbar-nav-scroll[data-v-5a546758]{overflow:visible}.navbar-expand-sm .navbar-collapse[data-v-5a546758]{display:flex!important;flex-basis:auto}.navbar-expand-sm .navbar-toggler[data-v-5a546758],.navbar-expand-sm .offcanvas-header[data-v-5a546758]{display:none}.navbar-expand-sm .offcanvas[data-v-5a546758]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-sm .offcanvas-bottom[data-v-5a546758],.navbar-expand-sm .offcanvas-top[data-v-5a546758]{height:auto;border-top:0;border-bottom:0}.navbar-expand-sm .offcanvas-body[data-v-5a546758]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:768px){.navbar-expand-md[data-v-5a546758]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-md .navbar-nav[data-v-5a546758]{flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu[data-v-5a546758]{position:absolute}.navbar-expand-md .navbar-nav .nav-link[data-v-5a546758]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md .navbar-nav-scroll[data-v-5a546758]{overflow:visible}.navbar-expand-md .navbar-collapse[data-v-5a546758]{display:flex!important;flex-basis:auto}.navbar-expand-md .navbar-toggler[data-v-5a546758],.navbar-expand-md .offcanvas-header[data-v-5a546758]{display:none}.navbar-expand-md .offcanvas[data-v-5a546758]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-md .offcanvas-bottom[data-v-5a546758],.navbar-expand-md .offcanvas-top[data-v-5a546758]{height:auto;border-top:0;border-bottom:0}.navbar-expand-md .offcanvas-body[data-v-5a546758]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:992px){.navbar-expand-lg[data-v-5a546758]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-lg .navbar-nav[data-v-5a546758]{flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu[data-v-5a546758]{position:absolute}.navbar-expand-lg .navbar-nav .nav-link[data-v-5a546758]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg .navbar-nav-scroll[data-v-5a546758]{overflow:visible}.navbar-expand-lg .navbar-collapse[data-v-5a546758]{display:flex!important;flex-basis:auto}.navbar-expand-lg .navbar-toggler[data-v-5a546758],.navbar-expand-lg .offcanvas-header[data-v-5a546758]{display:none}.navbar-expand-lg .offcanvas[data-v-5a546758]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-lg .offcanvas-bottom[data-v-5a546758],.navbar-expand-lg .offcanvas-top[data-v-5a546758]{height:auto;border-top:0;border-bottom:0}.navbar-expand-lg .offcanvas-body[data-v-5a546758]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1200px){.navbar-expand-xl[data-v-5a546758]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xl .navbar-nav[data-v-5a546758]{flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu[data-v-5a546758]{position:absolute}.navbar-expand-xl .navbar-nav .nav-link[data-v-5a546758]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl .navbar-nav-scroll[data-v-5a546758]{overflow:visible}.navbar-expand-xl .navbar-collapse[data-v-5a546758]{display:flex!important;flex-basis:auto}.navbar-expand-xl .navbar-toggler[data-v-5a546758],.navbar-expand-xl .offcanvas-header[data-v-5a546758]{display:none}.navbar-expand-xl .offcanvas[data-v-5a546758]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xl .offcanvas-bottom[data-v-5a546758],.navbar-expand-xl .offcanvas-top[data-v-5a546758]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xl .offcanvas-body[data-v-5a546758]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1400px){.navbar-expand-xxl[data-v-5a546758]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xxl .navbar-nav[data-v-5a546758]{flex-direction:row}.navbar-expand-xxl .navbar-nav .dropdown-menu[data-v-5a546758]{position:absolute}.navbar-expand-xxl .navbar-nav .nav-link[data-v-5a546758]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xxl .navbar-nav-scroll[data-v-5a546758]{overflow:visible}.navbar-expand-xxl .navbar-collapse[data-v-5a546758]{display:flex!important;flex-basis:auto}.navbar-expand-xxl .navbar-toggler[data-v-5a546758],.navbar-expand-xxl .offcanvas-header[data-v-5a546758]{display:none}.navbar-expand-xxl .offcanvas[data-v-5a546758]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand-xxl .offcanvas-bottom[data-v-5a546758],.navbar-expand-xxl .offcanvas-top[data-v-5a546758]{height:auto;border-top:0;border-bottom:0}.navbar-expand-xxl .offcanvas-body[data-v-5a546758]{display:flex;flex-grow:0;padding:0;overflow-y:visible}}.navbar-expand[data-v-5a546758]{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand .navbar-nav[data-v-5a546758]{flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu[data-v-5a546758]{position:absolute}.navbar-expand .navbar-nav .nav-link[data-v-5a546758]{padding-right:.5rem;padding-left:.5rem}.navbar-expand .navbar-nav-scroll[data-v-5a546758]{overflow:visible}.navbar-expand .navbar-collapse[data-v-5a546758]{display:flex!important;flex-basis:auto}.navbar-expand .navbar-toggler[data-v-5a546758],.navbar-expand .offcanvas-header[data-v-5a546758]{display:none}.navbar-expand .offcanvas[data-v-5a546758]{position:inherit;bottom:0;z-index:1000;flex-grow:1;visibility:visible!important;background-color:transparent;border-right:0;border-left:0;transition:none;transform:none}.navbar-expand .offcanvas-bottom[data-v-5a546758],.navbar-expand .offcanvas-top[data-v-5a546758]{height:auto;border-top:0;border-bottom:0}.navbar-expand .offcanvas-body[data-v-5a546758]{display:flex;flex-grow:0;padding:0;overflow-y:visible}.navbar-light .navbar-brand[data-v-5a546758],.navbar-light .navbar-brand[data-v-5a546758]:focus,.navbar-light .navbar-brand[data-v-5a546758]:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link[data-v-5a546758]{color:rgba(0,0,0,.55)}.navbar-light .navbar-nav .nav-link[data-v-5a546758]:focus,.navbar-light .navbar-nav .nav-link[data-v-5a546758]:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled[data-v-5a546758]{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .nav-link.active[data-v-5a546758],.navbar-light .navbar-nav .show>.nav-link[data-v-5a546758]{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler[data-v-5a546758]{color:rgba(0,0,0,.55);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon[data-v-5a546758]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(0, 0, 0, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-light .navbar-text[data-v-5a546758]{color:rgba(0,0,0,.55)}.navbar-light .navbar-text a[data-v-5a546758],.navbar-light .navbar-text a[data-v-5a546758]:focus,.navbar-light .navbar-text a[data-v-5a546758]:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand[data-v-5a546758],.navbar-dark .navbar-brand[data-v-5a546758]:focus,.navbar-dark .navbar-brand[data-v-5a546758]:hover{color:#fff}.navbar-dark .navbar-nav .nav-link[data-v-5a546758]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-nav .nav-link[data-v-5a546758]:focus,.navbar-dark .navbar-nav .nav-link[data-v-5a546758]:hover{color:hsla(0,0%,100%,.75)}.navbar-dark .navbar-nav .nav-link.disabled[data-v-5a546758]{color:hsla(0,0%,100%,.25)}.navbar-dark .navbar-nav .nav-link.active[data-v-5a546758],.navbar-dark .navbar-nav .show>.nav-link[data-v-5a546758]{color:#fff}.navbar-dark .navbar-toggler[data-v-5a546758]{color:hsla(0,0%,100%,.55);border-color:hsla(0,0%,100%,.1)}.navbar-dark .navbar-toggler-icon[data-v-5a546758]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(255, 255, 255, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-dark .navbar-text[data-v-5a546758]{color:hsla(0,0%,100%,.55)}.navbar-dark .navbar-text a[data-v-5a546758],.navbar-dark .navbar-text a[data-v-5a546758]:focus,.navbar-dark .navbar-text a[data-v-5a546758]:hover{color:#fff}.card[data-v-5a546758]{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr[data-v-5a546758]{margin-right:0;margin-left:0}.card>.list-group[data-v-5a546758]{border-top:inherit;border-bottom:inherit}.card>.list-group[data-v-5a546758]:first-child{border-top-width:0;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card>.list-group[data-v-5a546758]:last-child{border-bottom-width:0;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card>.card-header+.list-group[data-v-5a546758],.card>.list-group+.card-footer[data-v-5a546758]{border-top:0}.card-body[data-v-5a546758]{flex:1 1 auto;padding:1rem}.card-title[data-v-5a546758]{margin-bottom:.5rem}.card-subtitle[data-v-5a546758]{margin-top:-.25rem;margin-bottom:0}.card-text[data-v-5a546758]:last-child{margin-bottom:0}.card-link+.card-link[data-v-5a546758]{margin-left:1rem}.card-header[data-v-5a546758]{padding:.5rem 1rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header[data-v-5a546758]:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-footer[data-v-5a546758]{padding:.5rem 1rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer[data-v-5a546758]:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs[data-v-5a546758]{margin-bottom:-.5rem;border-bottom:0}.card-header-pills[data-v-5a546758],.card-header-tabs[data-v-5a546758]{margin-right:-.5rem;margin-left:-.5rem}.card-img-overlay[data-v-5a546758]{position:absolute;top:0;right:0;bottom:0;left:0;padding:1rem;border-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-5a546758],.card-img-top[data-v-5a546758],.card-img[data-v-5a546758]{width:100%}.card-img-top[data-v-5a546758],.card-img[data-v-5a546758]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img-bottom[data-v-5a546758],.card-img[data-v-5a546758]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-group>.card[data-v-5a546758]{margin-bottom:.75rem}@media (min-width:576px){.card-group[data-v-5a546758]{display:flex;flex-flow:row wrap}.card-group>.card[data-v-5a546758]{flex:1 0 0%;margin-bottom:0}.card-group>.card+.card[data-v-5a546758]{margin-left:0;border-left:0}.card-group>.card[data-v-5a546758]:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-header[data-v-5a546758],.card-group>.card:not(:last-child) .card-img-top[data-v-5a546758]{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-footer[data-v-5a546758],.card-group>.card:not(:last-child) .card-img-bottom[data-v-5a546758]{border-bottom-right-radius:0}.card-group>.card[data-v-5a546758]:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-header[data-v-5a546758],.card-group>.card:not(:first-child) .card-img-top[data-v-5a546758]{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-footer[data-v-5a546758],.card-group>.card:not(:first-child) .card-img-bottom[data-v-5a546758]{border-bottom-left-radius:0}}.accordion-button[data-v-5a546758]{position:relative;display:flex;align-items:center;width:100%;padding:1rem 1.25rem;font-size:1rem;color:#212529;text-align:left;background-color:#fff;border:0;border-radius:0;overflow-anchor:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,border-radius .15s ease}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-5a546758]{transition:none}}.accordion-button[data-v-5a546758]:not(.collapsed){color:#0c63e4;background-color:#e7f1ff;box-shadow:inset 0 -1px 0 rgba(0,0,0,.125)}.accordion-button[data-v-5a546758]:not(.collapsed):after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230c63e4'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");transform:rotate(-180deg)}.accordion-button[data-v-5a546758]:after{flex-shrink:0;width:1.25rem;height:1.25rem;margin-left:auto;content:\"\";background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-size:1.25rem;transition:transform .2s ease-in-out}@media (prefers-reduced-motion:reduce){.accordion-button[data-v-5a546758]:after{transition:none}}.accordion-button[data-v-5a546758]:hover{z-index:2}.accordion-button[data-v-5a546758]:focus{z-index:3;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.accordion-header[data-v-5a546758]{margin-bottom:0}.accordion-item[data-v-5a546758]{background-color:#fff;border:1px solid rgba(0,0,0,.125)}.accordion-item[data-v-5a546758]:first-of-type{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.accordion-item:first-of-type .accordion-button[data-v-5a546758]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.accordion-item[data-v-5a546758]:not(:first-of-type){border-top:0}.accordion-item[data-v-5a546758]:last-of-type{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-item:last-of-type .accordion-button.collapsed[data-v-5a546758]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.accordion-item:last-of-type .accordion-collapse[data-v-5a546758]{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-body[data-v-5a546758]{padding:1rem 1.25rem}.accordion-flush .accordion-collapse[data-v-5a546758]{border-width:0}.accordion-flush .accordion-item[data-v-5a546758]{border-right:0;border-left:0;border-radius:0}.accordion-flush .accordion-item[data-v-5a546758]:first-child{border-top:0}.accordion-flush .accordion-item[data-v-5a546758]:last-child{border-bottom:0}.accordion-flush .accordion-item .accordion-button[data-v-5a546758]{border-radius:0}.breadcrumb[data-v-5a546758]{display:flex;flex-wrap:wrap;padding:0;margin-bottom:1rem;list-style:none}.breadcrumb-item+.breadcrumb-item[data-v-5a546758]{padding-left:.5rem}.breadcrumb-item+.breadcrumb-item[data-v-5a546758]:before{float:left;padding-right:.5rem;color:#6c757d;content:var(--bs-breadcrumb-divider,\"/\")}.breadcrumb-item.active[data-v-5a546758]{color:#6c757d}.pagination[data-v-5a546758]{display:flex;padding-left:0;list-style:none}.page-link[data-v-5a546758]{position:relative;display:block;color:#0d6efd;text-decoration:none;background-color:#fff;border:1px solid #dee2e6;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.page-link[data-v-5a546758]{transition:none}}.page-link[data-v-5a546758]:hover{z-index:2;color:#0a58ca;background-color:#e9ecef;border-color:#dee2e6}.page-link[data-v-5a546758]:focus{z-index:3;color:#0a58ca;background-color:#e9ecef;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.page-item:not(:first-child) .page-link[data-v-5a546758]{margin-left:-1px}.page-item.active .page-link[data-v-5a546758]{z-index:3;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.page-item.disabled .page-link[data-v-5a546758]{color:#6c757d;pointer-events:none;background-color:#fff;border-color:#dee2e6}.page-link[data-v-5a546758]{padding:.375rem .75rem}.page-item:first-child .page-link[data-v-5a546758]{border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item:last-child .page-link[data-v-5a546758]{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.pagination-lg .page-link[data-v-5a546758]{padding:.75rem 1.5rem;font-size:1.25rem}.pagination-lg .page-item:first-child .page-link[data-v-5a546758]{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link[data-v-5a546758]{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm .page-link[data-v-5a546758]{padding:.25rem .5rem;font-size:.875rem}.pagination-sm .page-item:first-child .page-link[data-v-5a546758]{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link[data-v-5a546758]{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge[data-v-5a546758]{display:inline-block;padding:.35em .65em;font-size:.75em;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}.badge[data-v-5a546758]:empty{display:none}.btn .badge[data-v-5a546758]{position:relative;top:-1px}.alert[data-v-5a546758]{position:relative;padding:1rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading[data-v-5a546758]{color:inherit}.alert-link[data-v-5a546758]{font-weight:700}.alert-dismissible[data-v-5a546758]{padding-right:3rem}.alert-dismissible .btn-close[data-v-5a546758]{position:absolute;top:0;right:0;z-index:2;padding:1.25rem 1rem}.alert-primary[data-v-5a546758]{color:#084298;background-color:#cfe2ff;border-color:#b6d4fe}.alert-primary .alert-link[data-v-5a546758]{color:#06357a}.alert-secondary[data-v-5a546758]{color:#41464b;background-color:#e2e3e5;border-color:#d3d6d8}.alert-secondary .alert-link[data-v-5a546758]{color:#34383c}.alert-success[data-v-5a546758]{color:#0f5132;background-color:#d1e7dd;border-color:#badbcc}.alert-success .alert-link[data-v-5a546758]{color:#0c4128}.alert-info[data-v-5a546758]{color:#055160;background-color:#cff4fc;border-color:#b6effb}.alert-info .alert-link[data-v-5a546758]{color:#04414d}.alert-warning[data-v-5a546758]{color:#664d03;background-color:#fff3cd;border-color:#ffecb5}.alert-warning .alert-link[data-v-5a546758]{color:#523e02}.alert-danger[data-v-5a546758]{color:#842029;background-color:#f8d7da;border-color:#f5c2c7}.alert-danger .alert-link[data-v-5a546758]{color:#6a1a21}.alert-light[data-v-5a546758]{color:#636464;background-color:#fefefe;border-color:#fdfdfe}.alert-light .alert-link[data-v-5a546758]{color:#4f5050}.alert-dark[data-v-5a546758]{color:#141619;background-color:#d3d3d4;border-color:#bcbebf}.alert-dark .alert-link[data-v-5a546758]{color:#101214}@-webkit-keyframes progress-bar-stripes-data-v-5a546758{0%{background-position-x:1rem}}@keyframes progress-bar-stripes-data-v-5a546758{0%{background-position-x:1rem}}.progress[data-v-5a546758]{display:flex;height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress-bar[data-v-5a546758]{display:flex;flex-direction:column;justify-content:center;overflow:hidden;color:#fff;text-align:center;white-space:nowrap;background-color:#0d6efd;transition:width .6s ease}@media (prefers-reduced-motion:reduce){.progress-bar[data-v-5a546758]{transition:none}}.progress-bar-striped[data-v-5a546758]{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-bar-animated[data-v-5a546758]{-webkit-animation:1s linear infinite progress-bar-stripes-data-v-5a546758;animation:1s linear infinite progress-bar-stripes-data-v-5a546758}@media (prefers-reduced-motion:reduce){.progress-bar-animated[data-v-5a546758]{-webkit-animation:none;animation:none}}.list-group[data-v-5a546758]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:.25rem}.list-group-numbered[data-v-5a546758]{list-style-type:none;counter-reset:section}.list-group-numbered>li[data-v-5a546758]:before{content:counters(section,\".\") \". \";counter-increment:section}.list-group-item-action[data-v-5a546758]{width:100%;color:#495057;text-align:inherit}.list-group-item-action[data-v-5a546758]:focus,.list-group-item-action[data-v-5a546758]:hover{z-index:1;color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action[data-v-5a546758]:active{color:#212529;background-color:#e9ecef}.list-group-item[data-v-5a546758]{position:relative;display:block;padding:.5rem 1rem;color:#212529;text-decoration:none;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item[data-v-5a546758]:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.list-group-item[data-v-5a546758]:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.list-group-item.disabled[data-v-5a546758],.list-group-item[data-v-5a546758]:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.list-group-item.active[data-v-5a546758]{z-index:2;color:#fff;background-color:#0d6efd;border-color:#0d6efd}.list-group-item+.list-group-item[data-v-5a546758]{border-top-width:0}.list-group-item+.list-group-item.active[data-v-5a546758]{margin-top:-1px;border-top-width:1px}.list-group-horizontal[data-v-5a546758]{flex-direction:row}.list-group-horizontal>.list-group-item[data-v-5a546758]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal>.list-group-item[data-v-5a546758]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal>.list-group-item.active[data-v-5a546758]{margin-top:0}.list-group-horizontal>.list-group-item+.list-group-item[data-v-5a546758]{border-top-width:1px;border-left-width:0}.list-group-horizontal>.list-group-item+.list-group-item.active[data-v-5a546758]{margin-left:-1px;border-left-width:1px}@media (min-width:576px){.list-group-horizontal-sm[data-v-5a546758]{flex-direction:row}.list-group-horizontal-sm>.list-group-item[data-v-5a546758]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-sm>.list-group-item[data-v-5a546758]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-sm>.list-group-item.active[data-v-5a546758]{margin-top:0}.list-group-horizontal-sm>.list-group-item+.list-group-item[data-v-5a546758]{border-top-width:1px;border-left-width:0}.list-group-horizontal-sm>.list-group-item+.list-group-item.active[data-v-5a546758]{margin-left:-1px;border-left-width:1px}}@media (min-width:768px){.list-group-horizontal-md[data-v-5a546758]{flex-direction:row}.list-group-horizontal-md>.list-group-item[data-v-5a546758]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-md>.list-group-item[data-v-5a546758]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-md>.list-group-item.active[data-v-5a546758]{margin-top:0}.list-group-horizontal-md>.list-group-item+.list-group-item[data-v-5a546758]{border-top-width:1px;border-left-width:0}.list-group-horizontal-md>.list-group-item+.list-group-item.active[data-v-5a546758]{margin-left:-1px;border-left-width:1px}}@media (min-width:992px){.list-group-horizontal-lg[data-v-5a546758]{flex-direction:row}.list-group-horizontal-lg>.list-group-item[data-v-5a546758]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-lg>.list-group-item[data-v-5a546758]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-lg>.list-group-item.active[data-v-5a546758]{margin-top:0}.list-group-horizontal-lg>.list-group-item+.list-group-item[data-v-5a546758]{border-top-width:1px;border-left-width:0}.list-group-horizontal-lg>.list-group-item+.list-group-item.active[data-v-5a546758]{margin-left:-1px;border-left-width:1px}}@media (min-width:1200px){.list-group-horizontal-xl[data-v-5a546758]{flex-direction:row}.list-group-horizontal-xl>.list-group-item[data-v-5a546758]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xl>.list-group-item[data-v-5a546758]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xl>.list-group-item.active[data-v-5a546758]{margin-top:0}.list-group-horizontal-xl>.list-group-item+.list-group-item[data-v-5a546758]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xl>.list-group-item+.list-group-item.active[data-v-5a546758]{margin-left:-1px;border-left-width:1px}}@media (min-width:1400px){.list-group-horizontal-xxl[data-v-5a546758]{flex-direction:row}.list-group-horizontal-xxl>.list-group-item[data-v-5a546758]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xxl>.list-group-item[data-v-5a546758]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xxl>.list-group-item.active[data-v-5a546758]{margin-top:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item[data-v-5a546758]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item.active[data-v-5a546758]{margin-left:-1px;border-left-width:1px}}.list-group-flush[data-v-5a546758]{border-radius:0}.list-group-flush>.list-group-item[data-v-5a546758]{border-width:0 0 1px}.list-group-flush>.list-group-item[data-v-5a546758]:last-child{border-bottom-width:0}.list-group-item-primary[data-v-5a546758]{color:#084298;background-color:#cfe2ff}.list-group-item-primary.list-group-item-action[data-v-5a546758]:focus,.list-group-item-primary.list-group-item-action[data-v-5a546758]:hover{color:#084298;background-color:#bacbe6}.list-group-item-primary.list-group-item-action.active[data-v-5a546758]{color:#fff;background-color:#084298;border-color:#084298}.list-group-item-secondary[data-v-5a546758]{color:#41464b;background-color:#e2e3e5}.list-group-item-secondary.list-group-item-action[data-v-5a546758]:focus,.list-group-item-secondary.list-group-item-action[data-v-5a546758]:hover{color:#41464b;background-color:#cbccce}.list-group-item-secondary.list-group-item-action.active[data-v-5a546758]{color:#fff;background-color:#41464b;border-color:#41464b}.list-group-item-success[data-v-5a546758]{color:#0f5132;background-color:#d1e7dd}.list-group-item-success.list-group-item-action[data-v-5a546758]:focus,.list-group-item-success.list-group-item-action[data-v-5a546758]:hover{color:#0f5132;background-color:#bcd0c7}.list-group-item-success.list-group-item-action.active[data-v-5a546758]{color:#fff;background-color:#0f5132;border-color:#0f5132}.list-group-item-info[data-v-5a546758]{color:#055160;background-color:#cff4fc}.list-group-item-info.list-group-item-action[data-v-5a546758]:focus,.list-group-item-info.list-group-item-action[data-v-5a546758]:hover{color:#055160;background-color:#badce3}.list-group-item-info.list-group-item-action.active[data-v-5a546758]{color:#fff;background-color:#055160;border-color:#055160}.list-group-item-warning[data-v-5a546758]{color:#664d03;background-color:#fff3cd}.list-group-item-warning.list-group-item-action[data-v-5a546758]:focus,.list-group-item-warning.list-group-item-action[data-v-5a546758]:hover{color:#664d03;background-color:#e6dbb9}.list-group-item-warning.list-group-item-action.active[data-v-5a546758]{color:#fff;background-color:#664d03;border-color:#664d03}.list-group-item-danger[data-v-5a546758]{color:#842029;background-color:#f8d7da}.list-group-item-danger.list-group-item-action[data-v-5a546758]:focus,.list-group-item-danger.list-group-item-action[data-v-5a546758]:hover{color:#842029;background-color:#dfc2c4}.list-group-item-danger.list-group-item-action.active[data-v-5a546758]{color:#fff;background-color:#842029;border-color:#842029}.list-group-item-light[data-v-5a546758]{color:#636464;background-color:#fefefe}.list-group-item-light.list-group-item-action[data-v-5a546758]:focus,.list-group-item-light.list-group-item-action[data-v-5a546758]:hover{color:#636464;background-color:#e5e5e5}.list-group-item-light.list-group-item-action.active[data-v-5a546758]{color:#fff;background-color:#636464;border-color:#636464}.list-group-item-dark[data-v-5a546758]{color:#141619;background-color:#d3d3d4}.list-group-item-dark.list-group-item-action[data-v-5a546758]:focus,.list-group-item-dark.list-group-item-action[data-v-5a546758]:hover{color:#141619;background-color:#bebebf}.list-group-item-dark.list-group-item-action.active[data-v-5a546758]{color:#fff;background-color:#141619;border-color:#141619}.btn-close[data-v-5a546758]{box-sizing:content-box;width:1em;height:1em;padding:.25em;color:#000;background:transparent url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M.293.293a1 1 0 11.414 0 NaN NaNlNaN NaN NaN NaNa1 1 0 111.414 1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 1-1.414 NaN NaNlNaN NaN NaN NaNa1 1 0 10-1.414 NaN NaNz'/%3E%3C/svg%3E\") 50%/1em auto no-repeat;border:0;border-radius:.25rem;opacity:.5}.btn-close[data-v-5a546758]:hover{color:#000;text-decoration:none;opacity:.75}.btn-close[data-v-5a546758]:focus{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25);opacity:1}.btn-close.disabled[data-v-5a546758],.btn-close[data-v-5a546758]:disabled{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;opacity:.25}.btn-close-white[data-v-5a546758]{filter:invert(1) grayscale(100%) brightness(200%)}.toast[data-v-5a546758]{width:350px;max-width:100%;font-size:.875rem;pointer-events:auto;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .5rem 1rem rgba(0,0,0,.15);border-radius:.25rem}.toast.showing[data-v-5a546758]{opacity:0}.toast[data-v-5a546758]:not(.show){display:none}.toast-container[data-v-5a546758]{width:-webkit-max-content;width:-moz-max-content;width:max-content;max-width:100%;pointer-events:none}.toast-container[data-v-5a546758]>:not(:last-child){margin-bottom:.75rem}.toast-header[data-v-5a546758]{display:flex;align-items:center;padding:.5rem .75rem;color:#6c757d;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05);border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.toast-header .btn-close[data-v-5a546758]{margin-right:-.375rem;margin-left:.75rem}.toast-body[data-v-5a546758]{padding:.75rem;word-wrap:break-word}.modal[data-v-5a546758]{position:fixed;top:0;left:0;z-index:1055;display:none;width:100%;height:100%;overflow-x:hidden;overflow-y:auto;outline:0}.modal-dialog[data-v-5a546758]{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog[data-v-5a546758]{transition:transform .3s ease-out;transform:translateY(-50px)}@media (prefers-reduced-motion:reduce){.modal.fade .modal-dialog[data-v-5a546758]{transition:none}}.modal.show .modal-dialog[data-v-5a546758]{transform:none}.modal.modal-static .modal-dialog[data-v-5a546758]{transform:scale(1.02)}.modal-dialog-scrollable[data-v-5a546758]{height:calc(100% - 1rem)}.modal-dialog-scrollable .modal-content[data-v-5a546758]{max-height:100%;overflow:hidden}.modal-dialog-scrollable .modal-body[data-v-5a546758]{overflow-y:auto}.modal-dialog-centered[data-v-5a546758]{display:flex;align-items:center;min-height:calc(100% - 1rem)}.modal-content[data-v-5a546758]{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop[data-v-5a546758]{position:fixed;top:0;left:0;z-index:1050;width:100vw;height:100vh;background-color:#000}.modal-backdrop.fade[data-v-5a546758]{opacity:0}.modal-backdrop.show[data-v-5a546758]{opacity:.5}.modal-header[data-v-5a546758]{display:flex;flex-shrink:0;align-items:center;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.modal-header .btn-close[data-v-5a546758]{padding:.5rem;margin:-.5rem -.5rem -.5rem auto}.modal-title[data-v-5a546758]{margin-bottom:0;line-height:1.5}.modal-body[data-v-5a546758]{position:relative;flex:1 1 auto;padding:1rem}.modal-footer[data-v-5a546758]{display:flex;flex-wrap:wrap;flex-shrink:0;align-items:center;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.modal-footer>[data-v-5a546758]{margin:.25rem}@media (min-width:576px){.modal-dialog[data-v-5a546758]{max-width:500px;margin:1.75rem auto}.modal-dialog-scrollable[data-v-5a546758]{height:calc(100% - 3.5rem)}.modal-dialog-centered[data-v-5a546758]{min-height:calc(100% - 3.5rem)}.modal-sm[data-v-5a546758]{max-width:300px}}@media (min-width:992px){.modal-lg[data-v-5a546758],.modal-xl[data-v-5a546758]{max-width:800px}}@media (min-width:1200px){.modal-xl[data-v-5a546758]{max-width:1140px}}.modal-fullscreen[data-v-5a546758]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen .modal-content[data-v-5a546758]{height:100%;border:0;border-radius:0}.modal-fullscreen .modal-header[data-v-5a546758]{border-radius:0}.modal-fullscreen .modal-body[data-v-5a546758]{overflow-y:auto}.modal-fullscreen .modal-footer[data-v-5a546758]{border-radius:0}@media (max-width:575.98px){.modal-fullscreen-sm-down[data-v-5a546758]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-sm-down .modal-content[data-v-5a546758]{height:100%;border:0;border-radius:0}.modal-fullscreen-sm-down .modal-header[data-v-5a546758]{border-radius:0}.modal-fullscreen-sm-down .modal-body[data-v-5a546758]{overflow-y:auto}.modal-fullscreen-sm-down .modal-footer[data-v-5a546758]{border-radius:0}}@media (max-width:767.98px){.modal-fullscreen-md-down[data-v-5a546758]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-md-down .modal-content[data-v-5a546758]{height:100%;border:0;border-radius:0}.modal-fullscreen-md-down .modal-header[data-v-5a546758]{border-radius:0}.modal-fullscreen-md-down .modal-body[data-v-5a546758]{overflow-y:auto}.modal-fullscreen-md-down .modal-footer[data-v-5a546758]{border-radius:0}}@media (max-width:991.98px){.modal-fullscreen-lg-down[data-v-5a546758]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-lg-down .modal-content[data-v-5a546758]{height:100%;border:0;border-radius:0}.modal-fullscreen-lg-down .modal-header[data-v-5a546758]{border-radius:0}.modal-fullscreen-lg-down .modal-body[data-v-5a546758]{overflow-y:auto}.modal-fullscreen-lg-down .modal-footer[data-v-5a546758]{border-radius:0}}@media (max-width:1199.98px){.modal-fullscreen-xl-down[data-v-5a546758]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xl-down .modal-content[data-v-5a546758]{height:100%;border:0;border-radius:0}.modal-fullscreen-xl-down .modal-header[data-v-5a546758]{border-radius:0}.modal-fullscreen-xl-down .modal-body[data-v-5a546758]{overflow-y:auto}.modal-fullscreen-xl-down .modal-footer[data-v-5a546758]{border-radius:0}}@media (max-width:1399.98px){.modal-fullscreen-xxl-down[data-v-5a546758]{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xxl-down .modal-content[data-v-5a546758]{height:100%;border:0;border-radius:0}.modal-fullscreen-xxl-down .modal-header[data-v-5a546758]{border-radius:0}.modal-fullscreen-xxl-down .modal-body[data-v-5a546758]{overflow-y:auto}.modal-fullscreen-xxl-down .modal-footer[data-v-5a546758]{border-radius:0}}.tooltip[data-v-5a546758]{position:absolute;z-index:1080;display:block;margin:0;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show[data-v-5a546758]{opacity:.9}.tooltip .tooltip-arrow[data-v-5a546758]{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .tooltip-arrow[data-v-5a546758]:before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[data-popper-placement^=top][data-v-5a546758],.bs-tooltip-top[data-v-5a546758]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-5a546758],.bs-tooltip-top .tooltip-arrow[data-v-5a546758]{bottom:0}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow[data-v-5a546758]:before,.bs-tooltip-top .tooltip-arrow[data-v-5a546758]:before{top:-1px;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[data-popper-placement^=right][data-v-5a546758],.bs-tooltip-end[data-v-5a546758]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-5a546758],.bs-tooltip-end .tooltip-arrow[data-v-5a546758]{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow[data-v-5a546758]:before,.bs-tooltip-end .tooltip-arrow[data-v-5a546758]:before{right:-1px;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[data-popper-placement^=bottom][data-v-5a546758],.bs-tooltip-bottom[data-v-5a546758]{padding:.4rem 0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-5a546758],.bs-tooltip-bottom .tooltip-arrow[data-v-5a546758]{top:0}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow[data-v-5a546758]:before,.bs-tooltip-bottom .tooltip-arrow[data-v-5a546758]:before{bottom:-1px;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[data-popper-placement^=left][data-v-5a546758],.bs-tooltip-start[data-v-5a546758]{padding:0 .4rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-5a546758],.bs-tooltip-start .tooltip-arrow[data-v-5a546758]{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow[data-v-5a546758]:before,.bs-tooltip-start .tooltip-arrow[data-v-5a546758]:before{left:-1px;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner[data-v-5a546758]{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover[data-v-5a546758]{position:absolute;top:0;left:0;z-index:1070;display:block;max-width:276px;font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover .popover-arrow[data-v-5a546758]{position:absolute;display:block;width:1rem;height:.5rem}.popover .popover-arrow[data-v-5a546758]:after,.popover .popover-arrow[data-v-5a546758]:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-5a546758],.bs-popover-top>.popover-arrow[data-v-5a546758]{bottom:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-5a546758]:before,.bs-popover-top>.popover-arrow[data-v-5a546758]:before{bottom:0;border-width:.5rem .5rem 0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow[data-v-5a546758]:after,.bs-popover-top>.popover-arrow[data-v-5a546758]:after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:#fff}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-5a546758],.bs-popover-end>.popover-arrow[data-v-5a546758]{left:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-5a546758]:before,.bs-popover-end>.popover-arrow[data-v-5a546758]:before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow[data-v-5a546758]:after,.bs-popover-end>.popover-arrow[data-v-5a546758]:after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:#fff}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-5a546758],.bs-popover-bottom>.popover-arrow[data-v-5a546758]{top:calc(-.5rem - 1px)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-5a546758]:before,.bs-popover-bottom>.popover-arrow[data-v-5a546758]:before{top:0;border-width:0 .5rem .5rem;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow[data-v-5a546758]:after,.bs-popover-bottom>.popover-arrow[data-v-5a546758]:after{top:1px;border-width:0 .5rem .5rem;border-bottom-color:#fff}.bs-popover-auto[data-popper-placement^=bottom] .popover-header[data-v-5a546758]:before,.bs-popover-bottom .popover-header[data-v-5a546758]:before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f0f0f0}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-5a546758],.bs-popover-start>.popover-arrow[data-v-5a546758]{right:calc(-.5rem - 1px);width:.5rem;height:1rem}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-5a546758]:before,.bs-popover-start>.popover-arrow[data-v-5a546758]:before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow[data-v-5a546758]:after,.bs-popover-start>.popover-arrow[data-v-5a546758]:after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:#fff}.popover-header[data-v-5a546758]{padding:.5rem 1rem;margin-bottom:0;font-size:1rem;background-color:#f0f0f0;border-bottom:1px solid rgba(0,0,0,.2);border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header[data-v-5a546758]:empty{display:none}.popover-body[data-v-5a546758]{padding:1rem;color:#212529}.carousel[data-v-5a546758]{position:relative}.carousel.pointer-event[data-v-5a546758]{touch-action:pan-y}.carousel-inner[data-v-5a546758]{position:relative;width:100%;overflow:hidden}.carousel-inner[data-v-5a546758]:after{display:block;clear:both;content:\"\"}.carousel-item[data-v-5a546758]{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.carousel-item[data-v-5a546758]{transition:none}}.carousel-item-next[data-v-5a546758],.carousel-item-prev[data-v-5a546758],.carousel-item.active[data-v-5a546758]{display:block}.active.carousel-item-end[data-v-5a546758],.carousel-item-next[data-v-5a546758]:not(.carousel-item-start){transform:translateX(100%)}.active.carousel-item-start[data-v-5a546758],.carousel-item-prev[data-v-5a546758]:not(.carousel-item-end){transform:translateX(-100%)}.carousel-fade .carousel-item[data-v-5a546758]{opacity:0;transition-property:opacity;transform:none}.carousel-fade .carousel-item-next.carousel-item-start[data-v-5a546758],.carousel-fade .carousel-item-prev.carousel-item-end[data-v-5a546758],.carousel-fade .carousel-item.active[data-v-5a546758]{z-index:1;opacity:1}.carousel-fade .active.carousel-item-end[data-v-5a546758],.carousel-fade .active.carousel-item-start[data-v-5a546758]{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.carousel-fade .active.carousel-item-end[data-v-5a546758],.carousel-fade .active.carousel-item-start[data-v-5a546758]{transition:none}}.carousel-control-next[data-v-5a546758],.carousel-control-prev[data-v-5a546758]{position:absolute;top:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center;width:15%;padding:0;color:#fff;text-align:center;background:0 0;border:0;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.carousel-control-next[data-v-5a546758],.carousel-control-prev[data-v-5a546758]{transition:none}}.carousel-control-next[data-v-5a546758]:focus,.carousel-control-next[data-v-5a546758]:hover,.carousel-control-prev[data-v-5a546758]:focus,.carousel-control-prev[data-v-5a546758]:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev[data-v-5a546758]{left:0}.carousel-control-next[data-v-5a546758]{right:0}.carousel-control-next-icon[data-v-5a546758],.carousel-control-prev-icon[data-v-5a546758]{display:inline-block;width:2rem;height:2rem;background-repeat:no-repeat;background-position:50%;background-size:100% 100%}.carousel-control-prev-icon[data-v-5a546758]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3E%3C/svg%3E\")}.carousel-control-next-icon[data-v-5a546758]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3E%3Cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\")}.carousel-indicators[data-v-5a546758]{position:absolute;right:0;bottom:0;left:0;z-index:2;display:flex;justify-content:center;padding:0;margin-right:15%;margin-bottom:1rem;margin-left:15%;list-style:none}.carousel-indicators [data-bs-target][data-v-5a546758]{box-sizing:content-box;flex:0 1 auto;width:30px;height:3px;padding:0;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border:0;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.carousel-indicators [data-bs-target][data-v-5a546758]{transition:none}}.carousel-indicators .active[data-v-5a546758]{opacity:1}.carousel-caption[data-v-5a546758]{position:absolute;right:15%;bottom:1.25rem;left:15%;padding-top:1.25rem;padding-bottom:1.25rem;color:#fff;text-align:center}.carousel-dark .carousel-control-next-icon[data-v-5a546758],.carousel-dark .carousel-control-prev-icon[data-v-5a546758]{filter:invert(1) grayscale(100)}.carousel-dark .carousel-indicators [data-bs-target][data-v-5a546758]{background-color:#000}.carousel-dark .carousel-caption[data-v-5a546758]{color:#000}@-webkit-keyframes spinner-border-data-v-5a546758{to{transform:rotate(1turn)}}@keyframes spinner-border-data-v-5a546758{to{transform:rotate(1turn)}}.spinner-border[data-v-5a546758]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:.75s linear infinite spinner-border-data-v-5a546758;animation:.75s linear infinite spinner-border-data-v-5a546758}.spinner-border-sm[data-v-5a546758]{width:1rem;height:1rem;border-width:.2em}@-webkit-keyframes spinner-grow-data-v-5a546758{0%{transform:scale(0)}50%{opacity:1;transform:none}}@keyframes spinner-grow-data-v-5a546758{0%{transform:scale(0)}50%{opacity:1;transform:none}}.spinner-grow[data-v-5a546758]{display:inline-block;width:2rem;height:2rem;vertical-align:-.125em;background-color:currentColor;border-radius:50%;opacity:0;-webkit-animation:.75s linear infinite spinner-grow-data-v-5a546758;animation:.75s linear infinite spinner-grow-data-v-5a546758}.spinner-grow-sm[data-v-5a546758]{width:1rem;height:1rem}@media (prefers-reduced-motion:reduce){.spinner-border[data-v-5a546758],.spinner-grow[data-v-5a546758]{-webkit-animation-duration:1.5s;animation-duration:1.5s}}.offcanvas[data-v-5a546758]{position:fixed;bottom:0;z-index:1045;display:flex;flex-direction:column;max-width:100%;visibility:hidden;background-color:#fff;background-clip:padding-box;outline:0;transition:transform .3s ease-in-out}@media (prefers-reduced-motion:reduce){.offcanvas[data-v-5a546758]{transition:none}}.offcanvas-backdrop[data-v-5a546758]{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.offcanvas-backdrop.fade[data-v-5a546758]{opacity:0}.offcanvas-backdrop.show[data-v-5a546758]{opacity:.5}.offcanvas-header[data-v-5a546758]{display:flex;align-items:center;justify-content:space-between;padding:1rem}.offcanvas-header .btn-close[data-v-5a546758]{padding:.5rem;margin-top:-.5rem;margin-right:-.5rem;margin-bottom:-.5rem}.offcanvas-title[data-v-5a546758]{margin-bottom:0;line-height:1.5}.offcanvas-body[data-v-5a546758]{flex-grow:1;padding:1rem;overflow-y:auto}.offcanvas-start[data-v-5a546758]{top:0;left:0;width:400px;border-right:1px solid rgba(0,0,0,.2);transform:translateX(-100%)}.offcanvas-end[data-v-5a546758]{top:0;right:0;width:400px;border-left:1px solid rgba(0,0,0,.2);transform:translateX(100%)}.offcanvas-top[data-v-5a546758]{top:0;right:0;left:0;height:30vh;max-height:100%;border-bottom:1px solid rgba(0,0,0,.2);transform:translateY(-100%)}.offcanvas-bottom[data-v-5a546758]{right:0;left:0;height:30vh;max-height:100%;border-top:1px solid rgba(0,0,0,.2);transform:translateY(100%)}.offcanvas.show[data-v-5a546758]{transform:none}.placeholder[data-v-5a546758]{display:inline-block;min-height:1em;vertical-align:middle;cursor:wait;background-color:currentColor;opacity:.5}.placeholder.btn[data-v-5a546758]:before{display:inline-block;content:\"\"}.placeholder-xs[data-v-5a546758]{min-height:.6em}.placeholder-sm[data-v-5a546758]{min-height:.8em}.placeholder-lg[data-v-5a546758]{min-height:1.2em}.placeholder-glow .placeholder[data-v-5a546758]{-webkit-animation:placeholder-glow-data-v-5a546758 2s ease-in-out infinite;animation:placeholder-glow-data-v-5a546758 2s ease-in-out infinite}@-webkit-keyframes placeholder-glow-data-v-5a546758{50%{opacity:.2}}@keyframes placeholder-glow-data-v-5a546758{50%{opacity:.2}}.placeholder-wave[data-v-5a546758]{-webkit-mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,.8) 75%,#000 95%);-webkit-mask-size:200% 100%;mask-size:200% 100%;-webkit-animation:placeholder-wave-data-v-5a546758 2s linear infinite;animation:placeholder-wave-data-v-5a546758 2s linear infinite}@-webkit-keyframes placeholder-wave-data-v-5a546758{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}@keyframes placeholder-wave-data-v-5a546758{to{-webkit-mask-position:-200% 0;mask-position:-200% 0}}.clearfix[data-v-5a546758]:after{display:block;clear:both;content:\"\"}.link-primary[data-v-5a546758]{color:#0d6efd}.link-primary[data-v-5a546758]:focus,.link-primary[data-v-5a546758]:hover{color:#0a58ca}.link-secondary[data-v-5a546758]{color:#6c757d}.link-secondary[data-v-5a546758]:focus,.link-secondary[data-v-5a546758]:hover{color:#565e64}.link-success[data-v-5a546758]{color:#198754}.link-success[data-v-5a546758]:focus,.link-success[data-v-5a546758]:hover{color:#146c43}.link-info[data-v-5a546758]{color:#0dcaf0}.link-info[data-v-5a546758]:focus,.link-info[data-v-5a546758]:hover{color:#3dd5f3}.link-warning[data-v-5a546758]{color:#ffc107}.link-warning[data-v-5a546758]:focus,.link-warning[data-v-5a546758]:hover{color:#ffcd39}.link-danger[data-v-5a546758]{color:#dc3545}.link-danger[data-v-5a546758]:focus,.link-danger[data-v-5a546758]:hover{color:#b02a37}.link-light[data-v-5a546758]{color:#f8f9fa}.link-light[data-v-5a546758]:focus,.link-light[data-v-5a546758]:hover{color:#f9fafb}.link-dark[data-v-5a546758]{color:#212529}.link-dark[data-v-5a546758]:focus,.link-dark[data-v-5a546758]:hover{color:#1a1e21}.ratio[data-v-5a546758]{position:relative;width:100%}.ratio[data-v-5a546758]:before{display:block;padding-top:var(--bs-aspect-ratio);content:\"\"}.ratio>[data-v-5a546758]{position:absolute;top:0;left:0;width:100%;height:100%}.ratio-1x1[data-v-5a546758]{--bs-aspect-ratio:100%}.ratio-4x3[data-v-5a546758]{--bs-aspect-ratio:75%}.ratio-16x9[data-v-5a546758]{--bs-aspect-ratio:56.25%}.ratio-21x9[data-v-5a546758]{--bs-aspect-ratio:42.8571428571%}.fixed-top[data-v-5a546758]{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom[data-v-5a546758]{position:fixed;right:0;bottom:0;left:0;z-index:1030}.sticky-top[data-v-5a546758]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}@media (min-width:576px){.sticky-sm-top[data-v-5a546758]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:768px){.sticky-md-top[data-v-5a546758]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:992px){.sticky-lg-top[data-v-5a546758]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1200px){.sticky-xl-top[data-v-5a546758]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}@media (min-width:1400px){.sticky-xxl-top[data-v-5a546758]{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.hstack[data-v-5a546758]{display:flex;flex-direction:row;align-items:center;align-self:stretch}.vstack[data-v-5a546758]{display:flex;flex:1 1 auto;flex-direction:column;align-self:stretch}.visually-hidden-focusable[data-v-5a546758]:not(:focus):not(:focus-within),.visually-hidden[data-v-5a546758]{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}.stretched-link[data-v-5a546758]:after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;content:\"\"}.text-truncate[data-v-5a546758]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.vr[data-v-5a546758]{display:inline-block;align-self:stretch;width:1px;min-height:1em;background-color:currentColor;opacity:.25}.align-baseline[data-v-5a546758]{vertical-align:baseline!important}.align-top[data-v-5a546758]{vertical-align:top!important}.align-middle[data-v-5a546758]{vertical-align:middle!important}.align-bottom[data-v-5a546758]{vertical-align:bottom!important}.align-text-bottom[data-v-5a546758]{vertical-align:text-bottom!important}.align-text-top[data-v-5a546758]{vertical-align:text-top!important}.float-start[data-v-5a546758]{float:left!important}.float-end[data-v-5a546758]{float:right!important}.float-none[data-v-5a546758]{float:none!important}.opacity-0[data-v-5a546758]{opacity:0!important}.opacity-25[data-v-5a546758]{opacity:.25!important}.opacity-50[data-v-5a546758]{opacity:.5!important}.opacity-75[data-v-5a546758]{opacity:.75!important}.opacity-100[data-v-5a546758]{opacity:1!important}.overflow-auto[data-v-5a546758]{overflow:auto!important}.overflow-hidden[data-v-5a546758]{overflow:hidden!important}.overflow-visible[data-v-5a546758]{overflow:visible!important}.overflow-scroll[data-v-5a546758]{overflow:scroll!important}.d-inline[data-v-5a546758]{display:inline!important}.d-inline-block[data-v-5a546758]{display:inline-block!important}.d-block[data-v-5a546758]{display:block!important}.d-grid[data-v-5a546758]{display:grid!important}.d-table[data-v-5a546758]{display:table!important}.d-table-row[data-v-5a546758]{display:table-row!important}.d-table-cell[data-v-5a546758]{display:table-cell!important}.d-flex[data-v-5a546758]{display:flex!important}.d-inline-flex[data-v-5a546758]{display:inline-flex!important}.d-none[data-v-5a546758]{display:none!important}.shadow[data-v-5a546758]{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.shadow-sm[data-v-5a546758]{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.shadow-lg[data-v-5a546758]{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.shadow-none[data-v-5a546758]{box-shadow:none!important}.position-static[data-v-5a546758]{position:static!important}.position-relative[data-v-5a546758]{position:relative!important}.position-absolute[data-v-5a546758]{position:absolute!important}.position-fixed[data-v-5a546758]{position:fixed!important}.position-sticky[data-v-5a546758]{position:-webkit-sticky!important;position:sticky!important}.top-0[data-v-5a546758]{top:0!important}.top-50[data-v-5a546758]{top:50%!important}.top-100[data-v-5a546758]{top:100%!important}.bottom-0[data-v-5a546758]{bottom:0!important}.bottom-50[data-v-5a546758]{bottom:50%!important}.bottom-100[data-v-5a546758]{bottom:100%!important}.start-0[data-v-5a546758]{left:0!important}.start-50[data-v-5a546758]{left:50%!important}.start-100[data-v-5a546758]{left:100%!important}.end-0[data-v-5a546758]{right:0!important}.end-50[data-v-5a546758]{right:50%!important}.end-100[data-v-5a546758]{right:100%!important}.translate-middle[data-v-5a546758]{transform:translate(-50%,-50%)!important}.translate-middle-x[data-v-5a546758]{transform:translateX(-50%)!important}.translate-middle-y[data-v-5a546758]{transform:translateY(-50%)!important}.border[data-v-5a546758]{border:1px solid #dee2e6!important}.border-0[data-v-5a546758]{border:0!important}.border-top[data-v-5a546758]{border-top:1px solid #dee2e6!important}.border-top-0[data-v-5a546758]{border-top:0!important}.border-end[data-v-5a546758]{border-right:1px solid #dee2e6!important}.border-end-0[data-v-5a546758]{border-right:0!important}.border-bottom[data-v-5a546758]{border-bottom:1px solid #dee2e6!important}.border-bottom-0[data-v-5a546758]{border-bottom:0!important}.border-start[data-v-5a546758]{border-left:1px solid #dee2e6!important}.border-start-0[data-v-5a546758]{border-left:0!important}.border-primary[data-v-5a546758]{border-color:#0d6efd!important}.border-secondary[data-v-5a546758]{border-color:#6c757d!important}.border-success[data-v-5a546758]{border-color:#198754!important}.border-info[data-v-5a546758]{border-color:#0dcaf0!important}.border-warning[data-v-5a546758]{border-color:#ffc107!important}.border-danger[data-v-5a546758]{border-color:#dc3545!important}.border-light[data-v-5a546758]{border-color:#f8f9fa!important}.border-dark[data-v-5a546758]{border-color:#212529!important}.border-white[data-v-5a546758]{border-color:#fff!important}.border-1[data-v-5a546758]{border-width:1px!important}.border-2[data-v-5a546758]{border-width:2px!important}.border-3[data-v-5a546758]{border-width:3px!important}.border-4[data-v-5a546758]{border-width:4px!important}.border-5[data-v-5a546758]{border-width:5px!important}.w-25[data-v-5a546758]{width:25%!important}.w-50[data-v-5a546758]{width:50%!important}.w-75[data-v-5a546758]{width:75%!important}.w-100[data-v-5a546758]{width:100%!important}.w-auto[data-v-5a546758]{width:auto!important}.mw-100[data-v-5a546758]{max-width:100%!important}.vw-100[data-v-5a546758]{width:100vw!important}.min-vw-100[data-v-5a546758]{min-width:100vw!important}.h-25[data-v-5a546758]{height:25%!important}.h-50[data-v-5a546758]{height:50%!important}.h-75[data-v-5a546758]{height:75%!important}.h-100[data-v-5a546758]{height:100%!important}.h-auto[data-v-5a546758]{height:auto!important}.mh-100[data-v-5a546758]{max-height:100%!important}.vh-100[data-v-5a546758]{height:100vh!important}.min-vh-100[data-v-5a546758]{min-height:100vh!important}.flex-fill[data-v-5a546758]{flex:1 1 auto!important}.flex-row[data-v-5a546758]{flex-direction:row!important}.flex-column[data-v-5a546758]{flex-direction:column!important}.flex-row-reverse[data-v-5a546758]{flex-direction:row-reverse!important}.flex-column-reverse[data-v-5a546758]{flex-direction:column-reverse!important}.flex-grow-0[data-v-5a546758]{flex-grow:0!important}.flex-grow-1[data-v-5a546758]{flex-grow:1!important}.flex-shrink-0[data-v-5a546758]{flex-shrink:0!important}.flex-shrink-1[data-v-5a546758]{flex-shrink:1!important}.flex-wrap[data-v-5a546758]{flex-wrap:wrap!important}.flex-nowrap[data-v-5a546758]{flex-wrap:nowrap!important}.flex-wrap-reverse[data-v-5a546758]{flex-wrap:wrap-reverse!important}.gap-0[data-v-5a546758]{gap:0!important}.gap-1[data-v-5a546758]{gap:.25rem!important}.gap-2[data-v-5a546758]{gap:.5rem!important}.gap-3[data-v-5a546758]{gap:1rem!important}.gap-4[data-v-5a546758]{gap:1.5rem!important}.gap-5[data-v-5a546758]{gap:3rem!important}.justify-content-start[data-v-5a546758]{justify-content:flex-start!important}.justify-content-end[data-v-5a546758]{justify-content:flex-end!important}.justify-content-center[data-v-5a546758]{justify-content:center!important}.justify-content-between[data-v-5a546758]{justify-content:space-between!important}.justify-content-around[data-v-5a546758]{justify-content:space-around!important}.justify-content-evenly[data-v-5a546758]{justify-content:space-evenly!important}.align-items-start[data-v-5a546758]{align-items:flex-start!important}.align-items-end[data-v-5a546758]{align-items:flex-end!important}.align-items-center[data-v-5a546758]{align-items:center!important}.align-items-baseline[data-v-5a546758]{align-items:baseline!important}.align-items-stretch[data-v-5a546758]{align-items:stretch!important}.align-content-start[data-v-5a546758]{align-content:flex-start!important}.align-content-end[data-v-5a546758]{align-content:flex-end!important}.align-content-center[data-v-5a546758]{align-content:center!important}.align-content-between[data-v-5a546758]{align-content:space-between!important}.align-content-around[data-v-5a546758]{align-content:space-around!important}.align-content-stretch[data-v-5a546758]{align-content:stretch!important}.align-self-auto[data-v-5a546758]{align-self:auto!important}.align-self-start[data-v-5a546758]{align-self:flex-start!important}.align-self-end[data-v-5a546758]{align-self:flex-end!important}.align-self-center[data-v-5a546758]{align-self:center!important}.align-self-baseline[data-v-5a546758]{align-self:baseline!important}.align-self-stretch[data-v-5a546758]{align-self:stretch!important}.order-first[data-v-5a546758]{order:-1!important}.order-0[data-v-5a546758]{order:0!important}.order-1[data-v-5a546758]{order:1!important}.order-2[data-v-5a546758]{order:2!important}.order-3[data-v-5a546758]{order:3!important}.order-4[data-v-5a546758]{order:4!important}.order-5[data-v-5a546758]{order:5!important}.order-last[data-v-5a546758]{order:6!important}.m-0[data-v-5a546758]{margin:0!important}.m-1[data-v-5a546758]{margin:.25rem!important}.m-2[data-v-5a546758]{margin:.5rem!important}.m-3[data-v-5a546758]{margin:1rem!important}.m-4[data-v-5a546758]{margin:1.5rem!important}.m-5[data-v-5a546758]{margin:3rem!important}.m-auto[data-v-5a546758]{margin:auto!important}.mx-0[data-v-5a546758]{margin-right:0!important;margin-left:0!important}.mx-1[data-v-5a546758]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-2[data-v-5a546758]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-3[data-v-5a546758]{margin-right:1rem!important;margin-left:1rem!important}.mx-4[data-v-5a546758]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-5[data-v-5a546758]{margin-right:3rem!important;margin-left:3rem!important}.mx-auto[data-v-5a546758]{margin-right:auto!important;margin-left:auto!important}.my-0[data-v-5a546758]{margin-top:0!important;margin-bottom:0!important}.my-1[data-v-5a546758]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-2[data-v-5a546758]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-3[data-v-5a546758]{margin-top:1rem!important;margin-bottom:1rem!important}.my-4[data-v-5a546758]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-5[data-v-5a546758]{margin-top:3rem!important;margin-bottom:3rem!important}.my-auto[data-v-5a546758]{margin-top:auto!important;margin-bottom:auto!important}.mt-0[data-v-5a546758]{margin-top:0!important}.mt-1[data-v-5a546758]{margin-top:.25rem!important}.mt-2[data-v-5a546758]{margin-top:.5rem!important}.mt-3[data-v-5a546758]{margin-top:1rem!important}.mt-4[data-v-5a546758]{margin-top:1.5rem!important}.mt-5[data-v-5a546758]{margin-top:3rem!important}.mt-auto[data-v-5a546758]{margin-top:auto!important}.me-0[data-v-5a546758]{margin-right:0!important}.me-1[data-v-5a546758]{margin-right:.25rem!important}.me-2[data-v-5a546758]{margin-right:.5rem!important}.me-3[data-v-5a546758]{margin-right:1rem!important}.me-4[data-v-5a546758]{margin-right:1.5rem!important}.me-5[data-v-5a546758]{margin-right:3rem!important}.me-auto[data-v-5a546758]{margin-right:auto!important}.mb-0[data-v-5a546758]{margin-bottom:0!important}.mb-1[data-v-5a546758]{margin-bottom:.25rem!important}.mb-2[data-v-5a546758]{margin-bottom:.5rem!important}.mb-3[data-v-5a546758]{margin-bottom:1rem!important}.mb-4[data-v-5a546758]{margin-bottom:1.5rem!important}.mb-5[data-v-5a546758]{margin-bottom:3rem!important}.mb-auto[data-v-5a546758]{margin-bottom:auto!important}.ms-0[data-v-5a546758]{margin-left:0!important}.ms-1[data-v-5a546758]{margin-left:.25rem!important}.ms-2[data-v-5a546758]{margin-left:.5rem!important}.ms-3[data-v-5a546758]{margin-left:1rem!important}.ms-4[data-v-5a546758]{margin-left:1.5rem!important}.ms-5[data-v-5a546758]{margin-left:3rem!important}.ms-auto[data-v-5a546758]{margin-left:auto!important}.p-0[data-v-5a546758]{padding:0!important}.p-1[data-v-5a546758]{padding:.25rem!important}.p-2[data-v-5a546758]{padding:.5rem!important}.p-3[data-v-5a546758]{padding:1rem!important}.p-4[data-v-5a546758]{padding:1.5rem!important}.p-5[data-v-5a546758]{padding:3rem!important}.px-0[data-v-5a546758]{padding-right:0!important;padding-left:0!important}.px-1[data-v-5a546758]{padding-right:.25rem!important;padding-left:.25rem!important}.px-2[data-v-5a546758]{padding-right:.5rem!important;padding-left:.5rem!important}.px-3[data-v-5a546758]{padding-right:1rem!important;padding-left:1rem!important}.px-4[data-v-5a546758]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-5[data-v-5a546758]{padding-right:3rem!important;padding-left:3rem!important}.py-0[data-v-5a546758]{padding-top:0!important;padding-bottom:0!important}.py-1[data-v-5a546758]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-2[data-v-5a546758]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-3[data-v-5a546758]{padding-top:1rem!important;padding-bottom:1rem!important}.py-4[data-v-5a546758]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-5[data-v-5a546758]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-0[data-v-5a546758]{padding-top:0!important}.pt-1[data-v-5a546758]{padding-top:.25rem!important}.pt-2[data-v-5a546758]{padding-top:.5rem!important}.pt-3[data-v-5a546758]{padding-top:1rem!important}.pt-4[data-v-5a546758]{padding-top:1.5rem!important}.pt-5[data-v-5a546758]{padding-top:3rem!important}.pe-0[data-v-5a546758]{padding-right:0!important}.pe-1[data-v-5a546758]{padding-right:.25rem!important}.pe-2[data-v-5a546758]{padding-right:.5rem!important}.pe-3[data-v-5a546758]{padding-right:1rem!important}.pe-4[data-v-5a546758]{padding-right:1.5rem!important}.pe-5[data-v-5a546758]{padding-right:3rem!important}.pb-0[data-v-5a546758]{padding-bottom:0!important}.pb-1[data-v-5a546758]{padding-bottom:.25rem!important}.pb-2[data-v-5a546758]{padding-bottom:.5rem!important}.pb-3[data-v-5a546758]{padding-bottom:1rem!important}.pb-4[data-v-5a546758]{padding-bottom:1.5rem!important}.pb-5[data-v-5a546758]{padding-bottom:3rem!important}.ps-0[data-v-5a546758]{padding-left:0!important}.ps-1[data-v-5a546758]{padding-left:.25rem!important}.ps-2[data-v-5a546758]{padding-left:.5rem!important}.ps-3[data-v-5a546758]{padding-left:1rem!important}.ps-4[data-v-5a546758]{padding-left:1.5rem!important}.ps-5[data-v-5a546758]{padding-left:3rem!important}.font-monospace[data-v-5a546758]{font-family:var(--bs-font-monospace)!important}.fs-1[data-v-5a546758]{font-size:calc(1.375rem + 1.5vw)!important}.fs-2[data-v-5a546758]{font-size:calc(1.325rem + .9vw)!important}.fs-3[data-v-5a546758]{font-size:calc(1.3rem + .6vw)!important}.fs-4[data-v-5a546758]{font-size:calc(1.275rem + .3vw)!important}.fs-5[data-v-5a546758]{font-size:1.25rem!important}.fs-6[data-v-5a546758]{font-size:1rem!important}.fst-italic[data-v-5a546758]{font-style:italic!important}.fst-normal[data-v-5a546758]{font-style:normal!important}.fw-light[data-v-5a546758]{font-weight:300!important}.fw-lighter[data-v-5a546758]{font-weight:lighter!important}.fw-normal[data-v-5a546758]{font-weight:400!important}.fw-bold[data-v-5a546758]{font-weight:700!important}.fw-bolder[data-v-5a546758]{font-weight:bolder!important}.lh-1[data-v-5a546758]{line-height:1!important}.lh-sm[data-v-5a546758]{line-height:1.25!important}.lh-base[data-v-5a546758]{line-height:1.5!important}.lh-lg[data-v-5a546758]{line-height:2!important}.text-start[data-v-5a546758]{text-align:left!important}.text-end[data-v-5a546758]{text-align:right!important}.text-center[data-v-5a546758]{text-align:center!important}.text-decoration-none[data-v-5a546758]{text-decoration:none!important}.text-decoration-underline[data-v-5a546758]{text-decoration:underline!important}.text-decoration-line-through[data-v-5a546758]{text-decoration:line-through!important}.text-lowercase[data-v-5a546758]{text-transform:lowercase!important}.text-uppercase[data-v-5a546758]{text-transform:uppercase!important}.text-capitalize[data-v-5a546758]{text-transform:capitalize!important}.text-wrap[data-v-5a546758]{white-space:normal!important}.text-nowrap[data-v-5a546758]{white-space:nowrap!important}.text-break[data-v-5a546758]{word-wrap:break-word!important;word-break:break-word!important}.text-primary[data-v-5a546758]{--bs-text-opacity:1;color:rgba(var(--bs-primary-rgb),var(--bs-text-opacity))!important}.text-secondary[data-v-5a546758]{--bs-text-opacity:1;color:rgba(var(--bs-secondary-rgb),var(--bs-text-opacity))!important}.text-success[data-v-5a546758]{--bs-text-opacity:1;color:rgba(var(--bs-success-rgb),var(--bs-text-opacity))!important}.text-info[data-v-5a546758]{--bs-text-opacity:1;color:rgba(var(--bs-info-rgb),var(--bs-text-opacity))!important}.text-warning[data-v-5a546758]{--bs-text-opacity:1;color:rgba(var(--bs-warning-rgb),var(--bs-text-opacity))!important}.text-danger[data-v-5a546758]{--bs-text-opacity:1;color:rgba(var(--bs-danger-rgb),var(--bs-text-opacity))!important}.text-light[data-v-5a546758]{--bs-text-opacity:1;color:rgba(var(--bs-light-rgb),var(--bs-text-opacity))!important}.text-dark[data-v-5a546758]{--bs-text-opacity:1;color:rgba(var(--bs-dark-rgb),var(--bs-text-opacity))!important}.text-black[data-v-5a546758]{--bs-text-opacity:1;color:rgba(var(--bs-black-rgb),var(--bs-text-opacity))!important}.text-white[data-v-5a546758]{--bs-text-opacity:1;color:rgba(var(--bs-white-rgb),var(--bs-text-opacity))!important}.text-body[data-v-5a546758]{--bs-text-opacity:1;color:rgba(var(--bs-body-color-rgb),var(--bs-text-opacity))!important}.text-muted[data-v-5a546758]{--bs-text-opacity:1;color:#6c757d!important}.text-black-50[data-v-5a546758]{--bs-text-opacity:1;color:rgba(0,0,0,.5)!important}.text-white-50[data-v-5a546758]{--bs-text-opacity:1;color:hsla(0,0%,100%,.5)!important}.text-reset[data-v-5a546758]{--bs-text-opacity:1;color:inherit!important}.text-opacity-25[data-v-5a546758]{--bs-text-opacity:0.25}.text-opacity-50[data-v-5a546758]{--bs-text-opacity:0.5}.text-opacity-75[data-v-5a546758]{--bs-text-opacity:0.75}.text-opacity-100[data-v-5a546758]{--bs-text-opacity:1}.bg-primary[data-v-5a546758]{--bs-bg-opacity:1;background-color:rgba(var(--bs-primary-rgb),var(--bs-bg-opacity))!important}.bg-secondary[data-v-5a546758]{--bs-bg-opacity:1;background-color:rgba(var(--bs-secondary-rgb),var(--bs-bg-opacity))!important}.bg-success[data-v-5a546758]{--bs-bg-opacity:1;background-color:rgba(var(--bs-success-rgb),var(--bs-bg-opacity))!important}.bg-info[data-v-5a546758]{--bs-bg-opacity:1;background-color:rgba(var(--bs-info-rgb),var(--bs-bg-opacity))!important}.bg-warning[data-v-5a546758]{--bs-bg-opacity:1;background-color:rgba(var(--bs-warning-rgb),var(--bs-bg-opacity))!important}.bg-danger[data-v-5a546758]{--bs-bg-opacity:1;background-color:rgba(var(--bs-danger-rgb),var(--bs-bg-opacity))!important}.bg-light[data-v-5a546758]{--bs-bg-opacity:1;background-color:rgba(var(--bs-light-rgb),var(--bs-bg-opacity))!important}.bg-dark[data-v-5a546758]{--bs-bg-opacity:1;background-color:rgba(var(--bs-dark-rgb),var(--bs-bg-opacity))!important}.bg-black[data-v-5a546758]{--bs-bg-opacity:1;background-color:rgba(var(--bs-black-rgb),var(--bs-bg-opacity))!important}.bg-white[data-v-5a546758]{--bs-bg-opacity:1;background-color:rgba(var(--bs-white-rgb),var(--bs-bg-opacity))!important}.bg-body[data-v-5a546758]{--bs-bg-opacity:1;background-color:rgba(var(--bs-body-bg-rgb),var(--bs-bg-opacity))!important}.bg-transparent[data-v-5a546758]{--bs-bg-opacity:1;background-color:transparent!important}.bg-opacity-10[data-v-5a546758]{--bs-bg-opacity:0.1}.bg-opacity-25[data-v-5a546758]{--bs-bg-opacity:0.25}.bg-opacity-50[data-v-5a546758]{--bs-bg-opacity:0.5}.bg-opacity-75[data-v-5a546758]{--bs-bg-opacity:0.75}.bg-opacity-100[data-v-5a546758]{--bs-bg-opacity:1}.bg-gradient[data-v-5a546758]{background-image:var(--bs-gradient)!important}.user-select-all[data-v-5a546758]{-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.user-select-auto[data-v-5a546758]{-webkit-user-select:auto!important;-moz-user-select:auto!important;user-select:auto!important}.user-select-none[data-v-5a546758]{-webkit-user-select:none!important;-moz-user-select:none!important;user-select:none!important}.pe-none[data-v-5a546758]{pointer-events:none!important}.pe-auto[data-v-5a546758]{pointer-events:auto!important}.rounded[data-v-5a546758]{border-radius:.25rem!important}.rounded-0[data-v-5a546758]{border-radius:0!important}.rounded-1[data-v-5a546758]{border-radius:.2rem!important}.rounded-2[data-v-5a546758]{border-radius:.25rem!important}.rounded-3[data-v-5a546758]{border-radius:.3rem!important}.rounded-circle[data-v-5a546758]{border-radius:50%!important}.rounded-pill[data-v-5a546758]{border-radius:50rem!important}.rounded-top[data-v-5a546758]{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.rounded-end[data-v-5a546758]{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.rounded-bottom[data-v-5a546758]{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-start[data-v-5a546758]{border-bottom-left-radius:.25rem!important;border-top-left-radius:.25rem!important}.visible[data-v-5a546758]{visibility:visible!important}.invisible[data-v-5a546758]{visibility:hidden!important}@media (min-width:576px){.float-sm-start[data-v-5a546758]{float:left!important}.float-sm-end[data-v-5a546758]{float:right!important}.float-sm-none[data-v-5a546758]{float:none!important}.d-sm-inline[data-v-5a546758]{display:inline!important}.d-sm-inline-block[data-v-5a546758]{display:inline-block!important}.d-sm-block[data-v-5a546758]{display:block!important}.d-sm-grid[data-v-5a546758]{display:grid!important}.d-sm-table[data-v-5a546758]{display:table!important}.d-sm-table-row[data-v-5a546758]{display:table-row!important}.d-sm-table-cell[data-v-5a546758]{display:table-cell!important}.d-sm-flex[data-v-5a546758]{display:flex!important}.d-sm-inline-flex[data-v-5a546758]{display:inline-flex!important}.d-sm-none[data-v-5a546758]{display:none!important}.flex-sm-fill[data-v-5a546758]{flex:1 1 auto!important}.flex-sm-row[data-v-5a546758]{flex-direction:row!important}.flex-sm-column[data-v-5a546758]{flex-direction:column!important}.flex-sm-row-reverse[data-v-5a546758]{flex-direction:row-reverse!important}.flex-sm-column-reverse[data-v-5a546758]{flex-direction:column-reverse!important}.flex-sm-grow-0[data-v-5a546758]{flex-grow:0!important}.flex-sm-grow-1[data-v-5a546758]{flex-grow:1!important}.flex-sm-shrink-0[data-v-5a546758]{flex-shrink:0!important}.flex-sm-shrink-1[data-v-5a546758]{flex-shrink:1!important}.flex-sm-wrap[data-v-5a546758]{flex-wrap:wrap!important}.flex-sm-nowrap[data-v-5a546758]{flex-wrap:nowrap!important}.flex-sm-wrap-reverse[data-v-5a546758]{flex-wrap:wrap-reverse!important}.gap-sm-0[data-v-5a546758]{gap:0!important}.gap-sm-1[data-v-5a546758]{gap:.25rem!important}.gap-sm-2[data-v-5a546758]{gap:.5rem!important}.gap-sm-3[data-v-5a546758]{gap:1rem!important}.gap-sm-4[data-v-5a546758]{gap:1.5rem!important}.gap-sm-5[data-v-5a546758]{gap:3rem!important}.justify-content-sm-start[data-v-5a546758]{justify-content:flex-start!important}.justify-content-sm-end[data-v-5a546758]{justify-content:flex-end!important}.justify-content-sm-center[data-v-5a546758]{justify-content:center!important}.justify-content-sm-between[data-v-5a546758]{justify-content:space-between!important}.justify-content-sm-around[data-v-5a546758]{justify-content:space-around!important}.justify-content-sm-evenly[data-v-5a546758]{justify-content:space-evenly!important}.align-items-sm-start[data-v-5a546758]{align-items:flex-start!important}.align-items-sm-end[data-v-5a546758]{align-items:flex-end!important}.align-items-sm-center[data-v-5a546758]{align-items:center!important}.align-items-sm-baseline[data-v-5a546758]{align-items:baseline!important}.align-items-sm-stretch[data-v-5a546758]{align-items:stretch!important}.align-content-sm-start[data-v-5a546758]{align-content:flex-start!important}.align-content-sm-end[data-v-5a546758]{align-content:flex-end!important}.align-content-sm-center[data-v-5a546758]{align-content:center!important}.align-content-sm-between[data-v-5a546758]{align-content:space-between!important}.align-content-sm-around[data-v-5a546758]{align-content:space-around!important}.align-content-sm-stretch[data-v-5a546758]{align-content:stretch!important}.align-self-sm-auto[data-v-5a546758]{align-self:auto!important}.align-self-sm-start[data-v-5a546758]{align-self:flex-start!important}.align-self-sm-end[data-v-5a546758]{align-self:flex-end!important}.align-self-sm-center[data-v-5a546758]{align-self:center!important}.align-self-sm-baseline[data-v-5a546758]{align-self:baseline!important}.align-self-sm-stretch[data-v-5a546758]{align-self:stretch!important}.order-sm-first[data-v-5a546758]{order:-1!important}.order-sm-0[data-v-5a546758]{order:0!important}.order-sm-1[data-v-5a546758]{order:1!important}.order-sm-2[data-v-5a546758]{order:2!important}.order-sm-3[data-v-5a546758]{order:3!important}.order-sm-4[data-v-5a546758]{order:4!important}.order-sm-5[data-v-5a546758]{order:5!important}.order-sm-last[data-v-5a546758]{order:6!important}.m-sm-0[data-v-5a546758]{margin:0!important}.m-sm-1[data-v-5a546758]{margin:.25rem!important}.m-sm-2[data-v-5a546758]{margin:.5rem!important}.m-sm-3[data-v-5a546758]{margin:1rem!important}.m-sm-4[data-v-5a546758]{margin:1.5rem!important}.m-sm-5[data-v-5a546758]{margin:3rem!important}.m-sm-auto[data-v-5a546758]{margin:auto!important}.mx-sm-0[data-v-5a546758]{margin-right:0!important;margin-left:0!important}.mx-sm-1[data-v-5a546758]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-sm-2[data-v-5a546758]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-sm-3[data-v-5a546758]{margin-right:1rem!important;margin-left:1rem!important}.mx-sm-4[data-v-5a546758]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-sm-5[data-v-5a546758]{margin-right:3rem!important;margin-left:3rem!important}.mx-sm-auto[data-v-5a546758]{margin-right:auto!important;margin-left:auto!important}.my-sm-0[data-v-5a546758]{margin-top:0!important;margin-bottom:0!important}.my-sm-1[data-v-5a546758]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-sm-2[data-v-5a546758]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-sm-3[data-v-5a546758]{margin-top:1rem!important;margin-bottom:1rem!important}.my-sm-4[data-v-5a546758]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-sm-5[data-v-5a546758]{margin-top:3rem!important;margin-bottom:3rem!important}.my-sm-auto[data-v-5a546758]{margin-top:auto!important;margin-bottom:auto!important}.mt-sm-0[data-v-5a546758]{margin-top:0!important}.mt-sm-1[data-v-5a546758]{margin-top:.25rem!important}.mt-sm-2[data-v-5a546758]{margin-top:.5rem!important}.mt-sm-3[data-v-5a546758]{margin-top:1rem!important}.mt-sm-4[data-v-5a546758]{margin-top:1.5rem!important}.mt-sm-5[data-v-5a546758]{margin-top:3rem!important}.mt-sm-auto[data-v-5a546758]{margin-top:auto!important}.me-sm-0[data-v-5a546758]{margin-right:0!important}.me-sm-1[data-v-5a546758]{margin-right:.25rem!important}.me-sm-2[data-v-5a546758]{margin-right:.5rem!important}.me-sm-3[data-v-5a546758]{margin-right:1rem!important}.me-sm-4[data-v-5a546758]{margin-right:1.5rem!important}.me-sm-5[data-v-5a546758]{margin-right:3rem!important}.me-sm-auto[data-v-5a546758]{margin-right:auto!important}.mb-sm-0[data-v-5a546758]{margin-bottom:0!important}.mb-sm-1[data-v-5a546758]{margin-bottom:.25rem!important}.mb-sm-2[data-v-5a546758]{margin-bottom:.5rem!important}.mb-sm-3[data-v-5a546758]{margin-bottom:1rem!important}.mb-sm-4[data-v-5a546758]{margin-bottom:1.5rem!important}.mb-sm-5[data-v-5a546758]{margin-bottom:3rem!important}.mb-sm-auto[data-v-5a546758]{margin-bottom:auto!important}.ms-sm-0[data-v-5a546758]{margin-left:0!important}.ms-sm-1[data-v-5a546758]{margin-left:.25rem!important}.ms-sm-2[data-v-5a546758]{margin-left:.5rem!important}.ms-sm-3[data-v-5a546758]{margin-left:1rem!important}.ms-sm-4[data-v-5a546758]{margin-left:1.5rem!important}.ms-sm-5[data-v-5a546758]{margin-left:3rem!important}.ms-sm-auto[data-v-5a546758]{margin-left:auto!important}.p-sm-0[data-v-5a546758]{padding:0!important}.p-sm-1[data-v-5a546758]{padding:.25rem!important}.p-sm-2[data-v-5a546758]{padding:.5rem!important}.p-sm-3[data-v-5a546758]{padding:1rem!important}.p-sm-4[data-v-5a546758]{padding:1.5rem!important}.p-sm-5[data-v-5a546758]{padding:3rem!important}.px-sm-0[data-v-5a546758]{padding-right:0!important;padding-left:0!important}.px-sm-1[data-v-5a546758]{padding-right:.25rem!important;padding-left:.25rem!important}.px-sm-2[data-v-5a546758]{padding-right:.5rem!important;padding-left:.5rem!important}.px-sm-3[data-v-5a546758]{padding-right:1rem!important;padding-left:1rem!important}.px-sm-4[data-v-5a546758]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-sm-5[data-v-5a546758]{padding-right:3rem!important;padding-left:3rem!important}.py-sm-0[data-v-5a546758]{padding-top:0!important;padding-bottom:0!important}.py-sm-1[data-v-5a546758]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-sm-2[data-v-5a546758]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-sm-3[data-v-5a546758]{padding-top:1rem!important;padding-bottom:1rem!important}.py-sm-4[data-v-5a546758]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-sm-5[data-v-5a546758]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-sm-0[data-v-5a546758]{padding-top:0!important}.pt-sm-1[data-v-5a546758]{padding-top:.25rem!important}.pt-sm-2[data-v-5a546758]{padding-top:.5rem!important}.pt-sm-3[data-v-5a546758]{padding-top:1rem!important}.pt-sm-4[data-v-5a546758]{padding-top:1.5rem!important}.pt-sm-5[data-v-5a546758]{padding-top:3rem!important}.pe-sm-0[data-v-5a546758]{padding-right:0!important}.pe-sm-1[data-v-5a546758]{padding-right:.25rem!important}.pe-sm-2[data-v-5a546758]{padding-right:.5rem!important}.pe-sm-3[data-v-5a546758]{padding-right:1rem!important}.pe-sm-4[data-v-5a546758]{padding-right:1.5rem!important}.pe-sm-5[data-v-5a546758]{padding-right:3rem!important}.pb-sm-0[data-v-5a546758]{padding-bottom:0!important}.pb-sm-1[data-v-5a546758]{padding-bottom:.25rem!important}.pb-sm-2[data-v-5a546758]{padding-bottom:.5rem!important}.pb-sm-3[data-v-5a546758]{padding-bottom:1rem!important}.pb-sm-4[data-v-5a546758]{padding-bottom:1.5rem!important}.pb-sm-5[data-v-5a546758]{padding-bottom:3rem!important}.ps-sm-0[data-v-5a546758]{padding-left:0!important}.ps-sm-1[data-v-5a546758]{padding-left:.25rem!important}.ps-sm-2[data-v-5a546758]{padding-left:.5rem!important}.ps-sm-3[data-v-5a546758]{padding-left:1rem!important}.ps-sm-4[data-v-5a546758]{padding-left:1.5rem!important}.ps-sm-5[data-v-5a546758]{padding-left:3rem!important}.text-sm-start[data-v-5a546758]{text-align:left!important}.text-sm-end[data-v-5a546758]{text-align:right!important}.text-sm-center[data-v-5a546758]{text-align:center!important}}@media (min-width:768px){.float-md-start[data-v-5a546758]{float:left!important}.float-md-end[data-v-5a546758]{float:right!important}.float-md-none[data-v-5a546758]{float:none!important}.d-md-inline[data-v-5a546758]{display:inline!important}.d-md-inline-block[data-v-5a546758]{display:inline-block!important}.d-md-block[data-v-5a546758]{display:block!important}.d-md-grid[data-v-5a546758]{display:grid!important}.d-md-table[data-v-5a546758]{display:table!important}.d-md-table-row[data-v-5a546758]{display:table-row!important}.d-md-table-cell[data-v-5a546758]{display:table-cell!important}.d-md-flex[data-v-5a546758]{display:flex!important}.d-md-inline-flex[data-v-5a546758]{display:inline-flex!important}.d-md-none[data-v-5a546758]{display:none!important}.flex-md-fill[data-v-5a546758]{flex:1 1 auto!important}.flex-md-row[data-v-5a546758]{flex-direction:row!important}.flex-md-column[data-v-5a546758]{flex-direction:column!important}.flex-md-row-reverse[data-v-5a546758]{flex-direction:row-reverse!important}.flex-md-column-reverse[data-v-5a546758]{flex-direction:column-reverse!important}.flex-md-grow-0[data-v-5a546758]{flex-grow:0!important}.flex-md-grow-1[data-v-5a546758]{flex-grow:1!important}.flex-md-shrink-0[data-v-5a546758]{flex-shrink:0!important}.flex-md-shrink-1[data-v-5a546758]{flex-shrink:1!important}.flex-md-wrap[data-v-5a546758]{flex-wrap:wrap!important}.flex-md-nowrap[data-v-5a546758]{flex-wrap:nowrap!important}.flex-md-wrap-reverse[data-v-5a546758]{flex-wrap:wrap-reverse!important}.gap-md-0[data-v-5a546758]{gap:0!important}.gap-md-1[data-v-5a546758]{gap:.25rem!important}.gap-md-2[data-v-5a546758]{gap:.5rem!important}.gap-md-3[data-v-5a546758]{gap:1rem!important}.gap-md-4[data-v-5a546758]{gap:1.5rem!important}.gap-md-5[data-v-5a546758]{gap:3rem!important}.justify-content-md-start[data-v-5a546758]{justify-content:flex-start!important}.justify-content-md-end[data-v-5a546758]{justify-content:flex-end!important}.justify-content-md-center[data-v-5a546758]{justify-content:center!important}.justify-content-md-between[data-v-5a546758]{justify-content:space-between!important}.justify-content-md-around[data-v-5a546758]{justify-content:space-around!important}.justify-content-md-evenly[data-v-5a546758]{justify-content:space-evenly!important}.align-items-md-start[data-v-5a546758]{align-items:flex-start!important}.align-items-md-end[data-v-5a546758]{align-items:flex-end!important}.align-items-md-center[data-v-5a546758]{align-items:center!important}.align-items-md-baseline[data-v-5a546758]{align-items:baseline!important}.align-items-md-stretch[data-v-5a546758]{align-items:stretch!important}.align-content-md-start[data-v-5a546758]{align-content:flex-start!important}.align-content-md-end[data-v-5a546758]{align-content:flex-end!important}.align-content-md-center[data-v-5a546758]{align-content:center!important}.align-content-md-between[data-v-5a546758]{align-content:space-between!important}.align-content-md-around[data-v-5a546758]{align-content:space-around!important}.align-content-md-stretch[data-v-5a546758]{align-content:stretch!important}.align-self-md-auto[data-v-5a546758]{align-self:auto!important}.align-self-md-start[data-v-5a546758]{align-self:flex-start!important}.align-self-md-end[data-v-5a546758]{align-self:flex-end!important}.align-self-md-center[data-v-5a546758]{align-self:center!important}.align-self-md-baseline[data-v-5a546758]{align-self:baseline!important}.align-self-md-stretch[data-v-5a546758]{align-self:stretch!important}.order-md-first[data-v-5a546758]{order:-1!important}.order-md-0[data-v-5a546758]{order:0!important}.order-md-1[data-v-5a546758]{order:1!important}.order-md-2[data-v-5a546758]{order:2!important}.order-md-3[data-v-5a546758]{order:3!important}.order-md-4[data-v-5a546758]{order:4!important}.order-md-5[data-v-5a546758]{order:5!important}.order-md-last[data-v-5a546758]{order:6!important}.m-md-0[data-v-5a546758]{margin:0!important}.m-md-1[data-v-5a546758]{margin:.25rem!important}.m-md-2[data-v-5a546758]{margin:.5rem!important}.m-md-3[data-v-5a546758]{margin:1rem!important}.m-md-4[data-v-5a546758]{margin:1.5rem!important}.m-md-5[data-v-5a546758]{margin:3rem!important}.m-md-auto[data-v-5a546758]{margin:auto!important}.mx-md-0[data-v-5a546758]{margin-right:0!important;margin-left:0!important}.mx-md-1[data-v-5a546758]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-md-2[data-v-5a546758]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-md-3[data-v-5a546758]{margin-right:1rem!important;margin-left:1rem!important}.mx-md-4[data-v-5a546758]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-md-5[data-v-5a546758]{margin-right:3rem!important;margin-left:3rem!important}.mx-md-auto[data-v-5a546758]{margin-right:auto!important;margin-left:auto!important}.my-md-0[data-v-5a546758]{margin-top:0!important;margin-bottom:0!important}.my-md-1[data-v-5a546758]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-md-2[data-v-5a546758]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-md-3[data-v-5a546758]{margin-top:1rem!important;margin-bottom:1rem!important}.my-md-4[data-v-5a546758]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-md-5[data-v-5a546758]{margin-top:3rem!important;margin-bottom:3rem!important}.my-md-auto[data-v-5a546758]{margin-top:auto!important;margin-bottom:auto!important}.mt-md-0[data-v-5a546758]{margin-top:0!important}.mt-md-1[data-v-5a546758]{margin-top:.25rem!important}.mt-md-2[data-v-5a546758]{margin-top:.5rem!important}.mt-md-3[data-v-5a546758]{margin-top:1rem!important}.mt-md-4[data-v-5a546758]{margin-top:1.5rem!important}.mt-md-5[data-v-5a546758]{margin-top:3rem!important}.mt-md-auto[data-v-5a546758]{margin-top:auto!important}.me-md-0[data-v-5a546758]{margin-right:0!important}.me-md-1[data-v-5a546758]{margin-right:.25rem!important}.me-md-2[data-v-5a546758]{margin-right:.5rem!important}.me-md-3[data-v-5a546758]{margin-right:1rem!important}.me-md-4[data-v-5a546758]{margin-right:1.5rem!important}.me-md-5[data-v-5a546758]{margin-right:3rem!important}.me-md-auto[data-v-5a546758]{margin-right:auto!important}.mb-md-0[data-v-5a546758]{margin-bottom:0!important}.mb-md-1[data-v-5a546758]{margin-bottom:.25rem!important}.mb-md-2[data-v-5a546758]{margin-bottom:.5rem!important}.mb-md-3[data-v-5a546758]{margin-bottom:1rem!important}.mb-md-4[data-v-5a546758]{margin-bottom:1.5rem!important}.mb-md-5[data-v-5a546758]{margin-bottom:3rem!important}.mb-md-auto[data-v-5a546758]{margin-bottom:auto!important}.ms-md-0[data-v-5a546758]{margin-left:0!important}.ms-md-1[data-v-5a546758]{margin-left:.25rem!important}.ms-md-2[data-v-5a546758]{margin-left:.5rem!important}.ms-md-3[data-v-5a546758]{margin-left:1rem!important}.ms-md-4[data-v-5a546758]{margin-left:1.5rem!important}.ms-md-5[data-v-5a546758]{margin-left:3rem!important}.ms-md-auto[data-v-5a546758]{margin-left:auto!important}.p-md-0[data-v-5a546758]{padding:0!important}.p-md-1[data-v-5a546758]{padding:.25rem!important}.p-md-2[data-v-5a546758]{padding:.5rem!important}.p-md-3[data-v-5a546758]{padding:1rem!important}.p-md-4[data-v-5a546758]{padding:1.5rem!important}.p-md-5[data-v-5a546758]{padding:3rem!important}.px-md-0[data-v-5a546758]{padding-right:0!important;padding-left:0!important}.px-md-1[data-v-5a546758]{padding-right:.25rem!important;padding-left:.25rem!important}.px-md-2[data-v-5a546758]{padding-right:.5rem!important;padding-left:.5rem!important}.px-md-3[data-v-5a546758]{padding-right:1rem!important;padding-left:1rem!important}.px-md-4[data-v-5a546758]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-md-5[data-v-5a546758]{padding-right:3rem!important;padding-left:3rem!important}.py-md-0[data-v-5a546758]{padding-top:0!important;padding-bottom:0!important}.py-md-1[data-v-5a546758]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-md-2[data-v-5a546758]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-md-3[data-v-5a546758]{padding-top:1rem!important;padding-bottom:1rem!important}.py-md-4[data-v-5a546758]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-md-5[data-v-5a546758]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-md-0[data-v-5a546758]{padding-top:0!important}.pt-md-1[data-v-5a546758]{padding-top:.25rem!important}.pt-md-2[data-v-5a546758]{padding-top:.5rem!important}.pt-md-3[data-v-5a546758]{padding-top:1rem!important}.pt-md-4[data-v-5a546758]{padding-top:1.5rem!important}.pt-md-5[data-v-5a546758]{padding-top:3rem!important}.pe-md-0[data-v-5a546758]{padding-right:0!important}.pe-md-1[data-v-5a546758]{padding-right:.25rem!important}.pe-md-2[data-v-5a546758]{padding-right:.5rem!important}.pe-md-3[data-v-5a546758]{padding-right:1rem!important}.pe-md-4[data-v-5a546758]{padding-right:1.5rem!important}.pe-md-5[data-v-5a546758]{padding-right:3rem!important}.pb-md-0[data-v-5a546758]{padding-bottom:0!important}.pb-md-1[data-v-5a546758]{padding-bottom:.25rem!important}.pb-md-2[data-v-5a546758]{padding-bottom:.5rem!important}.pb-md-3[data-v-5a546758]{padding-bottom:1rem!important}.pb-md-4[data-v-5a546758]{padding-bottom:1.5rem!important}.pb-md-5[data-v-5a546758]{padding-bottom:3rem!important}.ps-md-0[data-v-5a546758]{padding-left:0!important}.ps-md-1[data-v-5a546758]{padding-left:.25rem!important}.ps-md-2[data-v-5a546758]{padding-left:.5rem!important}.ps-md-3[data-v-5a546758]{padding-left:1rem!important}.ps-md-4[data-v-5a546758]{padding-left:1.5rem!important}.ps-md-5[data-v-5a546758]{padding-left:3rem!important}.text-md-start[data-v-5a546758]{text-align:left!important}.text-md-end[data-v-5a546758]{text-align:right!important}.text-md-center[data-v-5a546758]{text-align:center!important}}@media (min-width:992px){.float-lg-start[data-v-5a546758]{float:left!important}.float-lg-end[data-v-5a546758]{float:right!important}.float-lg-none[data-v-5a546758]{float:none!important}.d-lg-inline[data-v-5a546758]{display:inline!important}.d-lg-inline-block[data-v-5a546758]{display:inline-block!important}.d-lg-block[data-v-5a546758]{display:block!important}.d-lg-grid[data-v-5a546758]{display:grid!important}.d-lg-table[data-v-5a546758]{display:table!important}.d-lg-table-row[data-v-5a546758]{display:table-row!important}.d-lg-table-cell[data-v-5a546758]{display:table-cell!important}.d-lg-flex[data-v-5a546758]{display:flex!important}.d-lg-inline-flex[data-v-5a546758]{display:inline-flex!important}.d-lg-none[data-v-5a546758]{display:none!important}.flex-lg-fill[data-v-5a546758]{flex:1 1 auto!important}.flex-lg-row[data-v-5a546758]{flex-direction:row!important}.flex-lg-column[data-v-5a546758]{flex-direction:column!important}.flex-lg-row-reverse[data-v-5a546758]{flex-direction:row-reverse!important}.flex-lg-column-reverse[data-v-5a546758]{flex-direction:column-reverse!important}.flex-lg-grow-0[data-v-5a546758]{flex-grow:0!important}.flex-lg-grow-1[data-v-5a546758]{flex-grow:1!important}.flex-lg-shrink-0[data-v-5a546758]{flex-shrink:0!important}.flex-lg-shrink-1[data-v-5a546758]{flex-shrink:1!important}.flex-lg-wrap[data-v-5a546758]{flex-wrap:wrap!important}.flex-lg-nowrap[data-v-5a546758]{flex-wrap:nowrap!important}.flex-lg-wrap-reverse[data-v-5a546758]{flex-wrap:wrap-reverse!important}.gap-lg-0[data-v-5a546758]{gap:0!important}.gap-lg-1[data-v-5a546758]{gap:.25rem!important}.gap-lg-2[data-v-5a546758]{gap:.5rem!important}.gap-lg-3[data-v-5a546758]{gap:1rem!important}.gap-lg-4[data-v-5a546758]{gap:1.5rem!important}.gap-lg-5[data-v-5a546758]{gap:3rem!important}.justify-content-lg-start[data-v-5a546758]{justify-content:flex-start!important}.justify-content-lg-end[data-v-5a546758]{justify-content:flex-end!important}.justify-content-lg-center[data-v-5a546758]{justify-content:center!important}.justify-content-lg-between[data-v-5a546758]{justify-content:space-between!important}.justify-content-lg-around[data-v-5a546758]{justify-content:space-around!important}.justify-content-lg-evenly[data-v-5a546758]{justify-content:space-evenly!important}.align-items-lg-start[data-v-5a546758]{align-items:flex-start!important}.align-items-lg-end[data-v-5a546758]{align-items:flex-end!important}.align-items-lg-center[data-v-5a546758]{align-items:center!important}.align-items-lg-baseline[data-v-5a546758]{align-items:baseline!important}.align-items-lg-stretch[data-v-5a546758]{align-items:stretch!important}.align-content-lg-start[data-v-5a546758]{align-content:flex-start!important}.align-content-lg-end[data-v-5a546758]{align-content:flex-end!important}.align-content-lg-center[data-v-5a546758]{align-content:center!important}.align-content-lg-between[data-v-5a546758]{align-content:space-between!important}.align-content-lg-around[data-v-5a546758]{align-content:space-around!important}.align-content-lg-stretch[data-v-5a546758]{align-content:stretch!important}.align-self-lg-auto[data-v-5a546758]{align-self:auto!important}.align-self-lg-start[data-v-5a546758]{align-self:flex-start!important}.align-self-lg-end[data-v-5a546758]{align-self:flex-end!important}.align-self-lg-center[data-v-5a546758]{align-self:center!important}.align-self-lg-baseline[data-v-5a546758]{align-self:baseline!important}.align-self-lg-stretch[data-v-5a546758]{align-self:stretch!important}.order-lg-first[data-v-5a546758]{order:-1!important}.order-lg-0[data-v-5a546758]{order:0!important}.order-lg-1[data-v-5a546758]{order:1!important}.order-lg-2[data-v-5a546758]{order:2!important}.order-lg-3[data-v-5a546758]{order:3!important}.order-lg-4[data-v-5a546758]{order:4!important}.order-lg-5[data-v-5a546758]{order:5!important}.order-lg-last[data-v-5a546758]{order:6!important}.m-lg-0[data-v-5a546758]{margin:0!important}.m-lg-1[data-v-5a546758]{margin:.25rem!important}.m-lg-2[data-v-5a546758]{margin:.5rem!important}.m-lg-3[data-v-5a546758]{margin:1rem!important}.m-lg-4[data-v-5a546758]{margin:1.5rem!important}.m-lg-5[data-v-5a546758]{margin:3rem!important}.m-lg-auto[data-v-5a546758]{margin:auto!important}.mx-lg-0[data-v-5a546758]{margin-right:0!important;margin-left:0!important}.mx-lg-1[data-v-5a546758]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-lg-2[data-v-5a546758]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-lg-3[data-v-5a546758]{margin-right:1rem!important;margin-left:1rem!important}.mx-lg-4[data-v-5a546758]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-lg-5[data-v-5a546758]{margin-right:3rem!important;margin-left:3rem!important}.mx-lg-auto[data-v-5a546758]{margin-right:auto!important;margin-left:auto!important}.my-lg-0[data-v-5a546758]{margin-top:0!important;margin-bottom:0!important}.my-lg-1[data-v-5a546758]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-lg-2[data-v-5a546758]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-lg-3[data-v-5a546758]{margin-top:1rem!important;margin-bottom:1rem!important}.my-lg-4[data-v-5a546758]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-lg-5[data-v-5a546758]{margin-top:3rem!important;margin-bottom:3rem!important}.my-lg-auto[data-v-5a546758]{margin-top:auto!important;margin-bottom:auto!important}.mt-lg-0[data-v-5a546758]{margin-top:0!important}.mt-lg-1[data-v-5a546758]{margin-top:.25rem!important}.mt-lg-2[data-v-5a546758]{margin-top:.5rem!important}.mt-lg-3[data-v-5a546758]{margin-top:1rem!important}.mt-lg-4[data-v-5a546758]{margin-top:1.5rem!important}.mt-lg-5[data-v-5a546758]{margin-top:3rem!important}.mt-lg-auto[data-v-5a546758]{margin-top:auto!important}.me-lg-0[data-v-5a546758]{margin-right:0!important}.me-lg-1[data-v-5a546758]{margin-right:.25rem!important}.me-lg-2[data-v-5a546758]{margin-right:.5rem!important}.me-lg-3[data-v-5a546758]{margin-right:1rem!important}.me-lg-4[data-v-5a546758]{margin-right:1.5rem!important}.me-lg-5[data-v-5a546758]{margin-right:3rem!important}.me-lg-auto[data-v-5a546758]{margin-right:auto!important}.mb-lg-0[data-v-5a546758]{margin-bottom:0!important}.mb-lg-1[data-v-5a546758]{margin-bottom:.25rem!important}.mb-lg-2[data-v-5a546758]{margin-bottom:.5rem!important}.mb-lg-3[data-v-5a546758]{margin-bottom:1rem!important}.mb-lg-4[data-v-5a546758]{margin-bottom:1.5rem!important}.mb-lg-5[data-v-5a546758]{margin-bottom:3rem!important}.mb-lg-auto[data-v-5a546758]{margin-bottom:auto!important}.ms-lg-0[data-v-5a546758]{margin-left:0!important}.ms-lg-1[data-v-5a546758]{margin-left:.25rem!important}.ms-lg-2[data-v-5a546758]{margin-left:.5rem!important}.ms-lg-3[data-v-5a546758]{margin-left:1rem!important}.ms-lg-4[data-v-5a546758]{margin-left:1.5rem!important}.ms-lg-5[data-v-5a546758]{margin-left:3rem!important}.ms-lg-auto[data-v-5a546758]{margin-left:auto!important}.p-lg-0[data-v-5a546758]{padding:0!important}.p-lg-1[data-v-5a546758]{padding:.25rem!important}.p-lg-2[data-v-5a546758]{padding:.5rem!important}.p-lg-3[data-v-5a546758]{padding:1rem!important}.p-lg-4[data-v-5a546758]{padding:1.5rem!important}.p-lg-5[data-v-5a546758]{padding:3rem!important}.px-lg-0[data-v-5a546758]{padding-right:0!important;padding-left:0!important}.px-lg-1[data-v-5a546758]{padding-right:.25rem!important;padding-left:.25rem!important}.px-lg-2[data-v-5a546758]{padding-right:.5rem!important;padding-left:.5rem!important}.px-lg-3[data-v-5a546758]{padding-right:1rem!important;padding-left:1rem!important}.px-lg-4[data-v-5a546758]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-lg-5[data-v-5a546758]{padding-right:3rem!important;padding-left:3rem!important}.py-lg-0[data-v-5a546758]{padding-top:0!important;padding-bottom:0!important}.py-lg-1[data-v-5a546758]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-lg-2[data-v-5a546758]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-lg-3[data-v-5a546758]{padding-top:1rem!important;padding-bottom:1rem!important}.py-lg-4[data-v-5a546758]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-lg-5[data-v-5a546758]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-lg-0[data-v-5a546758]{padding-top:0!important}.pt-lg-1[data-v-5a546758]{padding-top:.25rem!important}.pt-lg-2[data-v-5a546758]{padding-top:.5rem!important}.pt-lg-3[data-v-5a546758]{padding-top:1rem!important}.pt-lg-4[data-v-5a546758]{padding-top:1.5rem!important}.pt-lg-5[data-v-5a546758]{padding-top:3rem!important}.pe-lg-0[data-v-5a546758]{padding-right:0!important}.pe-lg-1[data-v-5a546758]{padding-right:.25rem!important}.pe-lg-2[data-v-5a546758]{padding-right:.5rem!important}.pe-lg-3[data-v-5a546758]{padding-right:1rem!important}.pe-lg-4[data-v-5a546758]{padding-right:1.5rem!important}.pe-lg-5[data-v-5a546758]{padding-right:3rem!important}.pb-lg-0[data-v-5a546758]{padding-bottom:0!important}.pb-lg-1[data-v-5a546758]{padding-bottom:.25rem!important}.pb-lg-2[data-v-5a546758]{padding-bottom:.5rem!important}.pb-lg-3[data-v-5a546758]{padding-bottom:1rem!important}.pb-lg-4[data-v-5a546758]{padding-bottom:1.5rem!important}.pb-lg-5[data-v-5a546758]{padding-bottom:3rem!important}.ps-lg-0[data-v-5a546758]{padding-left:0!important}.ps-lg-1[data-v-5a546758]{padding-left:.25rem!important}.ps-lg-2[data-v-5a546758]{padding-left:.5rem!important}.ps-lg-3[data-v-5a546758]{padding-left:1rem!important}.ps-lg-4[data-v-5a546758]{padding-left:1.5rem!important}.ps-lg-5[data-v-5a546758]{padding-left:3rem!important}.text-lg-start[data-v-5a546758]{text-align:left!important}.text-lg-end[data-v-5a546758]{text-align:right!important}.text-lg-center[data-v-5a546758]{text-align:center!important}}@media (min-width:1200px){.float-xl-start[data-v-5a546758]{float:left!important}.float-xl-end[data-v-5a546758]{float:right!important}.float-xl-none[data-v-5a546758]{float:none!important}.d-xl-inline[data-v-5a546758]{display:inline!important}.d-xl-inline-block[data-v-5a546758]{display:inline-block!important}.d-xl-block[data-v-5a546758]{display:block!important}.d-xl-grid[data-v-5a546758]{display:grid!important}.d-xl-table[data-v-5a546758]{display:table!important}.d-xl-table-row[data-v-5a546758]{display:table-row!important}.d-xl-table-cell[data-v-5a546758]{display:table-cell!important}.d-xl-flex[data-v-5a546758]{display:flex!important}.d-xl-inline-flex[data-v-5a546758]{display:inline-flex!important}.d-xl-none[data-v-5a546758]{display:none!important}.flex-xl-fill[data-v-5a546758]{flex:1 1 auto!important}.flex-xl-row[data-v-5a546758]{flex-direction:row!important}.flex-xl-column[data-v-5a546758]{flex-direction:column!important}.flex-xl-row-reverse[data-v-5a546758]{flex-direction:row-reverse!important}.flex-xl-column-reverse[data-v-5a546758]{flex-direction:column-reverse!important}.flex-xl-grow-0[data-v-5a546758]{flex-grow:0!important}.flex-xl-grow-1[data-v-5a546758]{flex-grow:1!important}.flex-xl-shrink-0[data-v-5a546758]{flex-shrink:0!important}.flex-xl-shrink-1[data-v-5a546758]{flex-shrink:1!important}.flex-xl-wrap[data-v-5a546758]{flex-wrap:wrap!important}.flex-xl-nowrap[data-v-5a546758]{flex-wrap:nowrap!important}.flex-xl-wrap-reverse[data-v-5a546758]{flex-wrap:wrap-reverse!important}.gap-xl-0[data-v-5a546758]{gap:0!important}.gap-xl-1[data-v-5a546758]{gap:.25rem!important}.gap-xl-2[data-v-5a546758]{gap:.5rem!important}.gap-xl-3[data-v-5a546758]{gap:1rem!important}.gap-xl-4[data-v-5a546758]{gap:1.5rem!important}.gap-xl-5[data-v-5a546758]{gap:3rem!important}.justify-content-xl-start[data-v-5a546758]{justify-content:flex-start!important}.justify-content-xl-end[data-v-5a546758]{justify-content:flex-end!important}.justify-content-xl-center[data-v-5a546758]{justify-content:center!important}.justify-content-xl-between[data-v-5a546758]{justify-content:space-between!important}.justify-content-xl-around[data-v-5a546758]{justify-content:space-around!important}.justify-content-xl-evenly[data-v-5a546758]{justify-content:space-evenly!important}.align-items-xl-start[data-v-5a546758]{align-items:flex-start!important}.align-items-xl-end[data-v-5a546758]{align-items:flex-end!important}.align-items-xl-center[data-v-5a546758]{align-items:center!important}.align-items-xl-baseline[data-v-5a546758]{align-items:baseline!important}.align-items-xl-stretch[data-v-5a546758]{align-items:stretch!important}.align-content-xl-start[data-v-5a546758]{align-content:flex-start!important}.align-content-xl-end[data-v-5a546758]{align-content:flex-end!important}.align-content-xl-center[data-v-5a546758]{align-content:center!important}.align-content-xl-between[data-v-5a546758]{align-content:space-between!important}.align-content-xl-around[data-v-5a546758]{align-content:space-around!important}.align-content-xl-stretch[data-v-5a546758]{align-content:stretch!important}.align-self-xl-auto[data-v-5a546758]{align-self:auto!important}.align-self-xl-start[data-v-5a546758]{align-self:flex-start!important}.align-self-xl-end[data-v-5a546758]{align-self:flex-end!important}.align-self-xl-center[data-v-5a546758]{align-self:center!important}.align-self-xl-baseline[data-v-5a546758]{align-self:baseline!important}.align-self-xl-stretch[data-v-5a546758]{align-self:stretch!important}.order-xl-first[data-v-5a546758]{order:-1!important}.order-xl-0[data-v-5a546758]{order:0!important}.order-xl-1[data-v-5a546758]{order:1!important}.order-xl-2[data-v-5a546758]{order:2!important}.order-xl-3[data-v-5a546758]{order:3!important}.order-xl-4[data-v-5a546758]{order:4!important}.order-xl-5[data-v-5a546758]{order:5!important}.order-xl-last[data-v-5a546758]{order:6!important}.m-xl-0[data-v-5a546758]{margin:0!important}.m-xl-1[data-v-5a546758]{margin:.25rem!important}.m-xl-2[data-v-5a546758]{margin:.5rem!important}.m-xl-3[data-v-5a546758]{margin:1rem!important}.m-xl-4[data-v-5a546758]{margin:1.5rem!important}.m-xl-5[data-v-5a546758]{margin:3rem!important}.m-xl-auto[data-v-5a546758]{margin:auto!important}.mx-xl-0[data-v-5a546758]{margin-right:0!important;margin-left:0!important}.mx-xl-1[data-v-5a546758]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xl-2[data-v-5a546758]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xl-3[data-v-5a546758]{margin-right:1rem!important;margin-left:1rem!important}.mx-xl-4[data-v-5a546758]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xl-5[data-v-5a546758]{margin-right:3rem!important;margin-left:3rem!important}.mx-xl-auto[data-v-5a546758]{margin-right:auto!important;margin-left:auto!important}.my-xl-0[data-v-5a546758]{margin-top:0!important;margin-bottom:0!important}.my-xl-1[data-v-5a546758]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xl-2[data-v-5a546758]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xl-3[data-v-5a546758]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xl-4[data-v-5a546758]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xl-5[data-v-5a546758]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xl-auto[data-v-5a546758]{margin-top:auto!important;margin-bottom:auto!important}.mt-xl-0[data-v-5a546758]{margin-top:0!important}.mt-xl-1[data-v-5a546758]{margin-top:.25rem!important}.mt-xl-2[data-v-5a546758]{margin-top:.5rem!important}.mt-xl-3[data-v-5a546758]{margin-top:1rem!important}.mt-xl-4[data-v-5a546758]{margin-top:1.5rem!important}.mt-xl-5[data-v-5a546758]{margin-top:3rem!important}.mt-xl-auto[data-v-5a546758]{margin-top:auto!important}.me-xl-0[data-v-5a546758]{margin-right:0!important}.me-xl-1[data-v-5a546758]{margin-right:.25rem!important}.me-xl-2[data-v-5a546758]{margin-right:.5rem!important}.me-xl-3[data-v-5a546758]{margin-right:1rem!important}.me-xl-4[data-v-5a546758]{margin-right:1.5rem!important}.me-xl-5[data-v-5a546758]{margin-right:3rem!important}.me-xl-auto[data-v-5a546758]{margin-right:auto!important}.mb-xl-0[data-v-5a546758]{margin-bottom:0!important}.mb-xl-1[data-v-5a546758]{margin-bottom:.25rem!important}.mb-xl-2[data-v-5a546758]{margin-bottom:.5rem!important}.mb-xl-3[data-v-5a546758]{margin-bottom:1rem!important}.mb-xl-4[data-v-5a546758]{margin-bottom:1.5rem!important}.mb-xl-5[data-v-5a546758]{margin-bottom:3rem!important}.mb-xl-auto[data-v-5a546758]{margin-bottom:auto!important}.ms-xl-0[data-v-5a546758]{margin-left:0!important}.ms-xl-1[data-v-5a546758]{margin-left:.25rem!important}.ms-xl-2[data-v-5a546758]{margin-left:.5rem!important}.ms-xl-3[data-v-5a546758]{margin-left:1rem!important}.ms-xl-4[data-v-5a546758]{margin-left:1.5rem!important}.ms-xl-5[data-v-5a546758]{margin-left:3rem!important}.ms-xl-auto[data-v-5a546758]{margin-left:auto!important}.p-xl-0[data-v-5a546758]{padding:0!important}.p-xl-1[data-v-5a546758]{padding:.25rem!important}.p-xl-2[data-v-5a546758]{padding:.5rem!important}.p-xl-3[data-v-5a546758]{padding:1rem!important}.p-xl-4[data-v-5a546758]{padding:1.5rem!important}.p-xl-5[data-v-5a546758]{padding:3rem!important}.px-xl-0[data-v-5a546758]{padding-right:0!important;padding-left:0!important}.px-xl-1[data-v-5a546758]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xl-2[data-v-5a546758]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xl-3[data-v-5a546758]{padding-right:1rem!important;padding-left:1rem!important}.px-xl-4[data-v-5a546758]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xl-5[data-v-5a546758]{padding-right:3rem!important;padding-left:3rem!important}.py-xl-0[data-v-5a546758]{padding-top:0!important;padding-bottom:0!important}.py-xl-1[data-v-5a546758]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xl-2[data-v-5a546758]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xl-3[data-v-5a546758]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xl-4[data-v-5a546758]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xl-5[data-v-5a546758]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xl-0[data-v-5a546758]{padding-top:0!important}.pt-xl-1[data-v-5a546758]{padding-top:.25rem!important}.pt-xl-2[data-v-5a546758]{padding-top:.5rem!important}.pt-xl-3[data-v-5a546758]{padding-top:1rem!important}.pt-xl-4[data-v-5a546758]{padding-top:1.5rem!important}.pt-xl-5[data-v-5a546758]{padding-top:3rem!important}.pe-xl-0[data-v-5a546758]{padding-right:0!important}.pe-xl-1[data-v-5a546758]{padding-right:.25rem!important}.pe-xl-2[data-v-5a546758]{padding-right:.5rem!important}.pe-xl-3[data-v-5a546758]{padding-right:1rem!important}.pe-xl-4[data-v-5a546758]{padding-right:1.5rem!important}.pe-xl-5[data-v-5a546758]{padding-right:3rem!important}.pb-xl-0[data-v-5a546758]{padding-bottom:0!important}.pb-xl-1[data-v-5a546758]{padding-bottom:.25rem!important}.pb-xl-2[data-v-5a546758]{padding-bottom:.5rem!important}.pb-xl-3[data-v-5a546758]{padding-bottom:1rem!important}.pb-xl-4[data-v-5a546758]{padding-bottom:1.5rem!important}.pb-xl-5[data-v-5a546758]{padding-bottom:3rem!important}.ps-xl-0[data-v-5a546758]{padding-left:0!important}.ps-xl-1[data-v-5a546758]{padding-left:.25rem!important}.ps-xl-2[data-v-5a546758]{padding-left:.5rem!important}.ps-xl-3[data-v-5a546758]{padding-left:1rem!important}.ps-xl-4[data-v-5a546758]{padding-left:1.5rem!important}.ps-xl-5[data-v-5a546758]{padding-left:3rem!important}.text-xl-start[data-v-5a546758]{text-align:left!important}.text-xl-end[data-v-5a546758]{text-align:right!important}.text-xl-center[data-v-5a546758]{text-align:center!important}}@media (min-width:1400px){.float-xxl-start[data-v-5a546758]{float:left!important}.float-xxl-end[data-v-5a546758]{float:right!important}.float-xxl-none[data-v-5a546758]{float:none!important}.d-xxl-inline[data-v-5a546758]{display:inline!important}.d-xxl-inline-block[data-v-5a546758]{display:inline-block!important}.d-xxl-block[data-v-5a546758]{display:block!important}.d-xxl-grid[data-v-5a546758]{display:grid!important}.d-xxl-table[data-v-5a546758]{display:table!important}.d-xxl-table-row[data-v-5a546758]{display:table-row!important}.d-xxl-table-cell[data-v-5a546758]{display:table-cell!important}.d-xxl-flex[data-v-5a546758]{display:flex!important}.d-xxl-inline-flex[data-v-5a546758]{display:inline-flex!important}.d-xxl-none[data-v-5a546758]{display:none!important}.flex-xxl-fill[data-v-5a546758]{flex:1 1 auto!important}.flex-xxl-row[data-v-5a546758]{flex-direction:row!important}.flex-xxl-column[data-v-5a546758]{flex-direction:column!important}.flex-xxl-row-reverse[data-v-5a546758]{flex-direction:row-reverse!important}.flex-xxl-column-reverse[data-v-5a546758]{flex-direction:column-reverse!important}.flex-xxl-grow-0[data-v-5a546758]{flex-grow:0!important}.flex-xxl-grow-1[data-v-5a546758]{flex-grow:1!important}.flex-xxl-shrink-0[data-v-5a546758]{flex-shrink:0!important}.flex-xxl-shrink-1[data-v-5a546758]{flex-shrink:1!important}.flex-xxl-wrap[data-v-5a546758]{flex-wrap:wrap!important}.flex-xxl-nowrap[data-v-5a546758]{flex-wrap:nowrap!important}.flex-xxl-wrap-reverse[data-v-5a546758]{flex-wrap:wrap-reverse!important}.gap-xxl-0[data-v-5a546758]{gap:0!important}.gap-xxl-1[data-v-5a546758]{gap:.25rem!important}.gap-xxl-2[data-v-5a546758]{gap:.5rem!important}.gap-xxl-3[data-v-5a546758]{gap:1rem!important}.gap-xxl-4[data-v-5a546758]{gap:1.5rem!important}.gap-xxl-5[data-v-5a546758]{gap:3rem!important}.justify-content-xxl-start[data-v-5a546758]{justify-content:flex-start!important}.justify-content-xxl-end[data-v-5a546758]{justify-content:flex-end!important}.justify-content-xxl-center[data-v-5a546758]{justify-content:center!important}.justify-content-xxl-between[data-v-5a546758]{justify-content:space-between!important}.justify-content-xxl-around[data-v-5a546758]{justify-content:space-around!important}.justify-content-xxl-evenly[data-v-5a546758]{justify-content:space-evenly!important}.align-items-xxl-start[data-v-5a546758]{align-items:flex-start!important}.align-items-xxl-end[data-v-5a546758]{align-items:flex-end!important}.align-items-xxl-center[data-v-5a546758]{align-items:center!important}.align-items-xxl-baseline[data-v-5a546758]{align-items:baseline!important}.align-items-xxl-stretch[data-v-5a546758]{align-items:stretch!important}.align-content-xxl-start[data-v-5a546758]{align-content:flex-start!important}.align-content-xxl-end[data-v-5a546758]{align-content:flex-end!important}.align-content-xxl-center[data-v-5a546758]{align-content:center!important}.align-content-xxl-between[data-v-5a546758]{align-content:space-between!important}.align-content-xxl-around[data-v-5a546758]{align-content:space-around!important}.align-content-xxl-stretch[data-v-5a546758]{align-content:stretch!important}.align-self-xxl-auto[data-v-5a546758]{align-self:auto!important}.align-self-xxl-start[data-v-5a546758]{align-self:flex-start!important}.align-self-xxl-end[data-v-5a546758]{align-self:flex-end!important}.align-self-xxl-center[data-v-5a546758]{align-self:center!important}.align-self-xxl-baseline[data-v-5a546758]{align-self:baseline!important}.align-self-xxl-stretch[data-v-5a546758]{align-self:stretch!important}.order-xxl-first[data-v-5a546758]{order:-1!important}.order-xxl-0[data-v-5a546758]{order:0!important}.order-xxl-1[data-v-5a546758]{order:1!important}.order-xxl-2[data-v-5a546758]{order:2!important}.order-xxl-3[data-v-5a546758]{order:3!important}.order-xxl-4[data-v-5a546758]{order:4!important}.order-xxl-5[data-v-5a546758]{order:5!important}.order-xxl-last[data-v-5a546758]{order:6!important}.m-xxl-0[data-v-5a546758]{margin:0!important}.m-xxl-1[data-v-5a546758]{margin:.25rem!important}.m-xxl-2[data-v-5a546758]{margin:.5rem!important}.m-xxl-3[data-v-5a546758]{margin:1rem!important}.m-xxl-4[data-v-5a546758]{margin:1.5rem!important}.m-xxl-5[data-v-5a546758]{margin:3rem!important}.m-xxl-auto[data-v-5a546758]{margin:auto!important}.mx-xxl-0[data-v-5a546758]{margin-right:0!important;margin-left:0!important}.mx-xxl-1[data-v-5a546758]{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xxl-2[data-v-5a546758]{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xxl-3[data-v-5a546758]{margin-right:1rem!important;margin-left:1rem!important}.mx-xxl-4[data-v-5a546758]{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xxl-5[data-v-5a546758]{margin-right:3rem!important;margin-left:3rem!important}.mx-xxl-auto[data-v-5a546758]{margin-right:auto!important;margin-left:auto!important}.my-xxl-0[data-v-5a546758]{margin-top:0!important;margin-bottom:0!important}.my-xxl-1[data-v-5a546758]{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xxl-2[data-v-5a546758]{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xxl-3[data-v-5a546758]{margin-top:1rem!important;margin-bottom:1rem!important}.my-xxl-4[data-v-5a546758]{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xxl-5[data-v-5a546758]{margin-top:3rem!important;margin-bottom:3rem!important}.my-xxl-auto[data-v-5a546758]{margin-top:auto!important;margin-bottom:auto!important}.mt-xxl-0[data-v-5a546758]{margin-top:0!important}.mt-xxl-1[data-v-5a546758]{margin-top:.25rem!important}.mt-xxl-2[data-v-5a546758]{margin-top:.5rem!important}.mt-xxl-3[data-v-5a546758]{margin-top:1rem!important}.mt-xxl-4[data-v-5a546758]{margin-top:1.5rem!important}.mt-xxl-5[data-v-5a546758]{margin-top:3rem!important}.mt-xxl-auto[data-v-5a546758]{margin-top:auto!important}.me-xxl-0[data-v-5a546758]{margin-right:0!important}.me-xxl-1[data-v-5a546758]{margin-right:.25rem!important}.me-xxl-2[data-v-5a546758]{margin-right:.5rem!important}.me-xxl-3[data-v-5a546758]{margin-right:1rem!important}.me-xxl-4[data-v-5a546758]{margin-right:1.5rem!important}.me-xxl-5[data-v-5a546758]{margin-right:3rem!important}.me-xxl-auto[data-v-5a546758]{margin-right:auto!important}.mb-xxl-0[data-v-5a546758]{margin-bottom:0!important}.mb-xxl-1[data-v-5a546758]{margin-bottom:.25rem!important}.mb-xxl-2[data-v-5a546758]{margin-bottom:.5rem!important}.mb-xxl-3[data-v-5a546758]{margin-bottom:1rem!important}.mb-xxl-4[data-v-5a546758]{margin-bottom:1.5rem!important}.mb-xxl-5[data-v-5a546758]{margin-bottom:3rem!important}.mb-xxl-auto[data-v-5a546758]{margin-bottom:auto!important}.ms-xxl-0[data-v-5a546758]{margin-left:0!important}.ms-xxl-1[data-v-5a546758]{margin-left:.25rem!important}.ms-xxl-2[data-v-5a546758]{margin-left:.5rem!important}.ms-xxl-3[data-v-5a546758]{margin-left:1rem!important}.ms-xxl-4[data-v-5a546758]{margin-left:1.5rem!important}.ms-xxl-5[data-v-5a546758]{margin-left:3rem!important}.ms-xxl-auto[data-v-5a546758]{margin-left:auto!important}.p-xxl-0[data-v-5a546758]{padding:0!important}.p-xxl-1[data-v-5a546758]{padding:.25rem!important}.p-xxl-2[data-v-5a546758]{padding:.5rem!important}.p-xxl-3[data-v-5a546758]{padding:1rem!important}.p-xxl-4[data-v-5a546758]{padding:1.5rem!important}.p-xxl-5[data-v-5a546758]{padding:3rem!important}.px-xxl-0[data-v-5a546758]{padding-right:0!important;padding-left:0!important}.px-xxl-1[data-v-5a546758]{padding-right:.25rem!important;padding-left:.25rem!important}.px-xxl-2[data-v-5a546758]{padding-right:.5rem!important;padding-left:.5rem!important}.px-xxl-3[data-v-5a546758]{padding-right:1rem!important;padding-left:1rem!important}.px-xxl-4[data-v-5a546758]{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xxl-5[data-v-5a546758]{padding-right:3rem!important;padding-left:3rem!important}.py-xxl-0[data-v-5a546758]{padding-top:0!important;padding-bottom:0!important}.py-xxl-1[data-v-5a546758]{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xxl-2[data-v-5a546758]{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xxl-3[data-v-5a546758]{padding-top:1rem!important;padding-bottom:1rem!important}.py-xxl-4[data-v-5a546758]{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xxl-5[data-v-5a546758]{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xxl-0[data-v-5a546758]{padding-top:0!important}.pt-xxl-1[data-v-5a546758]{padding-top:.25rem!important}.pt-xxl-2[data-v-5a546758]{padding-top:.5rem!important}.pt-xxl-3[data-v-5a546758]{padding-top:1rem!important}.pt-xxl-4[data-v-5a546758]{padding-top:1.5rem!important}.pt-xxl-5[data-v-5a546758]{padding-top:3rem!important}.pe-xxl-0[data-v-5a546758]{padding-right:0!important}.pe-xxl-1[data-v-5a546758]{padding-right:.25rem!important}.pe-xxl-2[data-v-5a546758]{padding-right:.5rem!important}.pe-xxl-3[data-v-5a546758]{padding-right:1rem!important}.pe-xxl-4[data-v-5a546758]{padding-right:1.5rem!important}.pe-xxl-5[data-v-5a546758]{padding-right:3rem!important}.pb-xxl-0[data-v-5a546758]{padding-bottom:0!important}.pb-xxl-1[data-v-5a546758]{padding-bottom:.25rem!important}.pb-xxl-2[data-v-5a546758]{padding-bottom:.5rem!important}.pb-xxl-3[data-v-5a546758]{padding-bottom:1rem!important}.pb-xxl-4[data-v-5a546758]{padding-bottom:1.5rem!important}.pb-xxl-5[data-v-5a546758]{padding-bottom:3rem!important}.ps-xxl-0[data-v-5a546758]{padding-left:0!important}.ps-xxl-1[data-v-5a546758]{padding-left:.25rem!important}.ps-xxl-2[data-v-5a546758]{padding-left:.5rem!important}.ps-xxl-3[data-v-5a546758]{padding-left:1rem!important}.ps-xxl-4[data-v-5a546758]{padding-left:1.5rem!important}.ps-xxl-5[data-v-5a546758]{padding-left:3rem!important}.text-xxl-start[data-v-5a546758]{text-align:left!important}.text-xxl-end[data-v-5a546758]{text-align:right!important}.text-xxl-center[data-v-5a546758]{text-align:center!important}}@media (min-width:1200px){.fs-1[data-v-5a546758]{font-size:2.5rem!important}.fs-2[data-v-5a546758]{font-size:2rem!important}.fs-3[data-v-5a546758]{font-size:1.75rem!important}.fs-4[data-v-5a546758]{font-size:1.5rem!important}}@media print{.d-print-inline[data-v-5a546758]{display:inline!important}.d-print-inline-block[data-v-5a546758]{display:inline-block!important}.d-print-block[data-v-5a546758]{display:block!important}.d-print-grid[data-v-5a546758]{display:grid!important}.d-print-table[data-v-5a546758]{display:table!important}.d-print-table-row[data-v-5a546758]{display:table-row!important}.d-print-table-cell[data-v-5a546758]{display:table-cell!important}.d-print-flex[data-v-5a546758]{display:flex!important}.d-print-inline-flex[data-v-5a546758]{display:inline-flex!important}.d-print-none[data-v-5a546758]{display:none!important}}", ""]);

// exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(191);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("ea2244c4", content, true, {});

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".indented[data-v-5a546758]{margin:20px;max-width:550px}.spacer[data-v-5a546758]{height:15px;border:0 solid #000}.spaced[data-v-5a546758]{margin-bottom:10px}.button[data-v-5a546758]{border:1px solid gray}", ""]);

// exports


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indented"},[_c('form',{ref:"formHTML",on:{"submit":function($event){$event.preventDefault();return _vm.submitForm.apply(null, arguments)}}},[_c('h3',[_vm._v("Add Root Node")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-horizontal"},[_c('h5',[_vm._v("Enter name of category you want to add the root node for:")]),_vm._v(" "),_c('div',{staticClass:"spacer"}),_vm._v(" "),_c('div',{staticClass:"form-group spaced"},[_vm._v("\n        Root node category name:\n        "),_c('div',{staticClass:"spacer"}),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.catname),expression:"catname"}],staticClass:"form-control",attrs:{"type":"text","name":"catname","required":""},domProps:{"value":(_vm.catname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.catname=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(_vm.catname),expression:"catname"}],staticClass:"button btn btn-default",attrs:{"type":"submit","value":"Add"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showcontenttrue),expression:"showcontenttrue"}],attrs:{"id":"content"}},[_c('div',{attrs:{"id":"topleft"}},[_c('Comp_MenuBar',{attrs:{"menuitems":_vm.treeflat}})],1),_vm._v(" "),_c('div',{attrs:{"id":"topright"}},[_c('Comp_BreadCrumb',{attrs:{"breadcrumb":_vm.breadcrumb}})],1),_vm._v(" "),_c('div',{attrs:{"id":"left"}},[_vm._l((_vm.trees),function(tree){return (_vm.treeloaded)?_c('Comp_TreeView',{key:tree.id,attrs:{"key":"tree.id","children":tree.children,"level":1,"catid":tree.id,"name":tree.categoryname}}):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"smallspacer"}),_vm._v(" "),_c('Comp_NewRootNode')],2),_vm._v(" "),_c('div',{attrs:{"id":"right"}},[(_vm.isShowProducts)?_c('Comp_ShowProducts',{attrs:{"products":_vm.products,"catname":_vm.catnameOnTop,"showheader":_vm.showheader}}):_vm._e(),_vm._v(" "),(_vm.isAddProduct)?_c('Comp_AddProduct',{attrs:{"catid":_vm.Cat.id,"level":_vm.Cat.level,"catname":_vm.Cat.catname},on:{"showprodofcat":_vm.showprodofcat}}):_vm._e(),_vm._v(" "),(_vm.isDeleteProduct)?_c('Comp_DeleteProduct',{attrs:{"id":_vm.Product.id,"name":_vm.Product.name}}):_vm._e(),_vm._v(" "),(_vm.isAddSubcat)?_c('Comp_AddSubcat',{attrs:{"parentcategory":_vm.Subcat.parentcategory,"parentid":_vm.Subcat.parentid,"level":_vm.Subcat.level},on:{"reloadtreeview":_vm.reloadTreeView}}):_vm._e(),_vm._v(" "),(_vm.isProductDetails)?_c('Comp_ProductDetails',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadedproductdetails),expression:"loadedproductdetails"}],attrs:{"selectedproduct":_vm.selectedproduct,"name":_vm.Product.name,"id":_vm.Product.id,"catid":_vm.Cat.id},on:{"refreshalternativeproducts":_vm.refreshProductAndAlternatives,"unloadaltprod":_vm.unloadaltprod}}):_vm._e(),_vm._v(" "),(_vm.isAlternativeProductDetails)?_c('Comp_AlternativeProductDetails',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadedaltprod),expression:"loadedaltprod"}],attrs:{"selectedalternativeproduct":_vm.selectedalternativeproduct}}):_vm._e(),_vm._v(" "),(_vm.isDeleteCategory)?_c('Comp_DeleteCategory',{attrs:{"catid":_vm.CattoDelete.id,"catname":_vm.CattoDelete.categoryname}}):_vm._e(),_vm._v(" "),(_vm.isNewRootNode)?_c('Comp_AddRootNode',{on:{"reloadtreeview":_vm.reloadTreeView}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
  * vue-router v3.5.3
  * (c) 2021 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (!condition) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
    .replace(encodeReserveRE, encodeReserveReplacer)
    .replace(commaRE, ','); };

function decode (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    if (false) {
      warn(false, ("Error decoding \"" + str + "\". Leaving it intact."));
    }
  }
  return str
}

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var value = extraQuery[key];
    parsedQuery[key] = Array.isArray(value)
      ? value.map(castQueryParamValue)
      : castQueryParamValue(value);
  }
  return parsedQuery
}

var castQueryParamValue = function (value) { return (value == null || typeof value === 'object' ? value : String(value)); };

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj
    ? Object.keys(obj)
      .map(function (key) {
        var val = obj[key];

        if (val === undefined) {
          return ''
        }

        if (val === null) {
          return encode(key)
        }

        if (Array.isArray(val)) {
          var result = [];
          val.forEach(function (val2) {
            if (val2 === undefined) {
              return
            }
            if (val2 === null) {
              result.push(encode(key));
            } else {
              result.push(encode(key) + '=' + encode(val2));
            }
          });
          return result.join('&')
        }

        return encode(key) + '=' + encode(val)
      })
      .filter(function (x) { return x.length > 0; })
      .join('&')
    : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b, onlyPath) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') && (onlyPath ||
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query))
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      (onlyPath || (
        a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params))
      )
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a).sort();
  var bKeys = Object.keys(b).sort();
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key, i) {
    var aVal = a[key];
    var bKey = bKeys[i];
    if (bKey !== key) { return false }
    var bVal = b[key];
    // query values can be null and undefined
    if (aVal == null || bVal == null) { return aVal === bVal }
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

function handleRouteEntered (route) {
  for (var i = 0; i < route.matched.length; i++) {
    var record = route.matched[i];
    for (var name in record.instances) {
      var instance = record.instances[name];
      var cbs = record.enteredCbs[name];
      if (!instance || !cbs) { continue }
      delete record.enteredCbs[name];
      for (var i$1 = 0; i$1 < cbs.length; i$1++) {
        if (!instance._isBeingDestroyed) { cbs[i$1](instance); }
      }
    }
  }
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children)
      } else {
        // render previous empty view
        return h()
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h()
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }

      // if the route transition has already been confirmed then we weren't
      // able to call the cbs during confirmation as the component was not
      // registered yet, so we call it here.
      handleRouteEntered(route);
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cache
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children)
  }
};

function fillPropsinData (component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/+/g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    // and fix #3106 so that you can work with location descriptor object having params.pathMatch equal to empty string
    if (typeof params.pathMatch === 'string') { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (false) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && typeof params === 'object') {
      next.params = extend({}, params);
    }
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var warnedCustomSlot;
var warnedTagProp;
var warnedEventProp;

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    custom: Boolean,
    exact: Boolean,
    exactPath: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget, this.exactPath);
    classes[activeClass] = this.exact || this.exactPath
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var ariaCurrentValue = classes[exactActiveClass] ? this.ariaCurrentValue : null;

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if (false) {
        !warnedCustomSlot && warn(false, 'In Vue Router 4, the v-slot API will by default wrap its content with an <a> element. Use the custom prop to remove this warning:\n<router-link v-slot="{ navigate, href }" custom></router-link>\n');
        warnedCustomSlot = true;
      }
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(
            false,
            ("<router-link> with to=\"" + (this.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (false) {
      if ('tag' in this.$options.propsData && !warnedTagProp) {
        warn(
          false,
          "<router-link>'s tag prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedTagProp = true;
      }
      if ('event' in this.$options.propsData && !warnedEventProp) {
        warn(
          false,
          "<router-link>'s event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedEventProp = true;
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href, 'aria-current': ariaCurrentValue };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
        aAttrs['aria-current'] = ariaCurrentValue;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap,
  parentRoute
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route, parentRoute);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );

    warn(
      // eslint-disable-next-line no-control-regex
      !/[^\u0000-\u007F]+/.test(path),
      "Route with path \"" + path + "\" contains unencoded characters, make sure " +
        "your path is correctly encoded before passing it to the router. Use " +
        "encodeURI to encode static segments of your path."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    alias: route.alias
      ? typeof route.alias === 'string'
        ? [route.alias]
        : route.alias
      : [],
    instances: {},
    enteredCbs: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function addRoute (parentOrRoute, route) {
    var parent = (typeof parentOrRoute !== 'object') ? nameMap[parentOrRoute] : undefined;
    // $flow-disable-line
    createRouteMap([route || parentOrRoute], pathList, pathMap, nameMap, parent);

    // add aliases of parent
    if (parent && parent.alias.length) {
      createRouteMap(
        // $flow-disable-line route is defined if parent is
        parent.alias.map(function (alias) { return ({ path: alias, children: [route] }); }),
        pathList,
        pathMap,
        nameMap,
        parent
      );
    }
  }

  function getRoutes () {
    return pathList.map(function (path) { return pathMap[path]; })
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoute: addRoute,
    getRoutes: getRoutes,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = typeof m[i] === 'string' ? decode(m[i]) : m[i];
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Prevent browser scroll behavior on History popstate
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  // preserve existing history state as it could be overriden by the user
  var stateCopy = extend({}, window.history.state);
  stateCopy.key = getStateKey();
  window.history.replaceState(stateCopy, '', absolutePath);
  window.addEventListener('popstate', handlePopState);
  return function () {
    window.removeEventListener('popstate', handlePopState);
  }
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (false) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function handlePopState (e) {
  saveScrollPosition();
  if (e.state && e.state.key) {
    setStateKey(e.state.key);
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    // $flow-disable-line
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        left: position.x,
        top: position.y,
        // $flow-disable-line
        behavior: shouldScroll.behavior
      });
    } else {
      window.scrollTo(position.x, position.y);
    }
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && typeof window.history.pushState === 'function'
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

// When changing thing, also edit router.d.ts
var NavigationFailureType = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};

function createNavigationRedirectedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.redirected,
    ("Redirected when going from \"" + (from.fullPath) + "\" to \"" + (stringifyRoute(
      to
    )) + "\" via a navigation guard.")
  )
}

function createNavigationDuplicatedError (from, to) {
  var error = createRouterError(
    from,
    to,
    NavigationFailureType.duplicated,
    ("Avoided redundant navigation to current location: \"" + (from.fullPath) + "\".")
  );
  // backwards compatible with the first introduction of Errors
  error.name = 'NavigationDuplicated';
  return error
}

function createNavigationCancelledError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.cancelled,
    ("Navigation cancelled from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" with a new navigation.")
  )
}

function createNavigationAbortedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.aborted,
    ("Navigation aborted from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" via a navigation guard.")
  )
}

function createRouterError (from, to, type, message) {
  var error = new Error(message);
  error._isRouter = true;
  error.from = from;
  error.to = to;
  error.type = type;

  return error
}

var propertiesToLog = ['params', 'query', 'hash'];

function stringifyRoute (to) {
  if (typeof to === 'string') { return to }
  if ('path' in to) { return to.path }
  var location = {};
  propertiesToLog.forEach(function (key) {
    if (key in to) { location[key] = to[key]; }
  });
  return JSON.stringify(location, null, 2)
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isNavigationFailure (err, errorType) {
  return (
    isError(err) &&
    err._isRouter &&
    (errorType == null || err.type === errorType)
  )
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
  this.listeners = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1 = this;

  var route;
  // catch redirect option https://github.com/vuejs/vue-router/issues/3201
  try {
    route = this.router.match(location, this.current);
  } catch (e) {
    this.errorCbs.forEach(function (cb) {
      cb(e);
    });
    // Exception should still be thrown
    throw e
  }
  var prev = this.current;
  this.confirmTransition(
    route,
    function () {
      this$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1.ensureURL();
      this$1.router.afterHooks.forEach(function (hook) {
        hook && hook(route, prev);
      });

      // fire ready cbs once
      if (!this$1.ready) {
        this$1.ready = true;
        this$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1.ready) {
        // Initial redirection should not mark the history as ready yet
        // because it's triggered by the redirection instead
        // https://github.com/vuejs/vue-router/issues/3225
        // https://github.com/vuejs/vue-router/issues/3331
        if (!isNavigationFailure(err, NavigationFailureType.redirected) || prev !== START) {
          this$1.ready = true;
          this$1.readyErrorCbs.forEach(function (cb) {
            cb(err);
          });
        }
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  this.pending = route;
  var abort = function (err) {
    // changed after adding errors with
    // https://github.com/vuejs/vue-router/pull/3047 before that change,
    // redirect and aborted navigation would produce an err == null
    if (!isNavigationFailure(err) && isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        if (false) {
          warn(false, 'uncaught error during route navigation:');
        }
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  var lastRouteIndex = route.matched.length - 1;
  var lastCurrentIndex = current.matched.length - 1;
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    lastRouteIndex === lastCurrentIndex &&
    route.matched[lastRouteIndex] === current.matched[lastCurrentIndex]
  ) {
    this.ensureURL();
    if (route.hash) {
      handleScroll(this.router, current, route, false);
    }
    return abort(createNavigationDuplicatedError(current, route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort(createNavigationCancelledError(current, route))
    }
    try {
      hook(route, current, function (to) {
        if (to === false) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(createNavigationAbortedError(current, route));
        } else if (isError(to)) {
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort(createNavigationRedirectedError(current, route));
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort(createNavigationCancelledError(current, route))
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          handleRouteEntered(route);
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  this.current = route;
  this.cb && this.cb(route);
};

History.prototype.setupListeners = function setupListeners () {
  // Default implementation is empty
};

History.prototype.teardown = function teardown () {
  // clean up event listeners
  // https://github.com/vuejs/vue-router/issues/2341
  this.listeners.forEach(function (cleanupListener) {
    cleanupListener();
  });
  this.listeners = [];

  // reset current history route
  // https://github.com/vuejs/vue-router/issues/3294
  this.current = START;
  this.pending = null;
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        if (!match.enteredCbs[key]) {
          match.enteredCbs[key] = [];
        }
        match.enteredCbs[key].push(cb);
      }
      next(cb);
    })
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    History.call(this, router, base);

    this._startLocation = getLocation(this.base);
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === this$1._startLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    };
    window.addEventListener('popstate', handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener('popstate', handleRoutingEvent);
    });
  };

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  var pathLowerCase = path.toLowerCase();
  var baseLowerCase = base.toLowerCase();
  // base="/a" shouldn't turn path="/app" into "/a/pp"
  // https://github.com/vuejs/vue-router/issues/3555
  // so we ensure the trailing slash in the base
  if (base && ((pathLowerCase === baseLowerCase) ||
    (pathLowerCase.indexOf(cleanPath(baseLowerCase + '/')) === 0))) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    };
    var eventType = supportsPushState ? 'popstate' : 'hashchange';
    window.addEventListener(
      eventType,
      handleRoutingEvent
    );
    this.listeners.push(function () {
      window.removeEventListener(eventType, handleRoutingEvent);
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
        this$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        var prev = this$1.current;
        this$1.index = targetIndex;
        this$1.updateRoute(route);
        this$1.router.afterHooks.forEach(function (hook) {
          hook && hook(route, prev);
        });
      },
      function (err) {
        if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
          this$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  if (false) {
    warn(this instanceof VueRouter, "Router must be called with the new operator.");
  }
  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback =
    mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' &&
    assert(
      install.installed,
      "not installed. Make sure to call `Vue.use(VueRouter)` " +
        "before creating root instance."
    );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }

    if (!this$1.app) { this$1.history.teardown(); }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History || history instanceof HashHistory) {
    var handleInitialScroll = function (routeOrError) {
      var from = history.current;
      var expectScroll = this$1.options.scrollBehavior;
      var supportsScroll = supportsPushState && expectScroll;

      if (supportsScroll && 'fullPath' in routeOrError) {
        handleScroll(this$1, routeOrError, from, false);
      }
    };
    var setupListeners = function (routeOrError) {
      history.setupListeners();
      handleInitialScroll(routeOrError);
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupListeners,
      setupListeners
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply(
    [],
    route.matched.map(function (m) {
      return Object.keys(m.components).map(function (key) {
        return m.components[key]
      })
    })
  )
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(to, current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.getRoutes = function getRoutes () {
  return this.matcher.getRoutes()
};

VueRouter.prototype.addRoute = function addRoute (parentOrRoute, route) {
  this.matcher.addRoute(parentOrRoute, route);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  if (false) {
    warn(false, 'router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead.');
  }
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.5.3';
VueRouter.isNavigationFailure = isNavigationFailure;
VueRouter.NavigationFailureType = NavigationFailureType;
VueRouter.START_LOCATION = START;

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index__ = __webpack_require__(196);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["a"]; });
/**
 * index
 */



/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_navigations__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accordion_items_directive__ = __webpack_require__(92);
/* unused harmony reexport AccordionItemsDirective */
/* unused harmony reexport AccordionItemDirective */
/* unused harmony reexport AccordionItemsPlugin */
/* unused harmony reexport AccordionItemPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accordion_accordion_component__ = __webpack_require__(292);
/* unused harmony reexport AccordionComponent */
/* unused harmony reexport AccordionPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toolbar_items_directive__ = __webpack_require__(93);
/* unused harmony reexport ItemsDirective */
/* unused harmony reexport ItemDirective */
/* unused harmony reexport ItemsPlugin */
/* unused harmony reexport ItemPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toolbar_toolbar_component__ = __webpack_require__(293);
/* unused harmony reexport ToolbarComponent */
/* unused harmony reexport ToolbarPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context_menu_contextmenu_component__ = __webpack_require__(294);
/* unused harmony reexport ContextMenuComponent */
/* unused harmony reexport ContextMenuPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__breadcrumb_items_directive__ = __webpack_require__(94);
/* unused harmony reexport BreadcrumbItemsDirective */
/* unused harmony reexport BreadcrumbItemDirective */
/* unused harmony reexport BreadcrumbItemsPlugin */
/* unused harmony reexport BreadcrumbItemPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__breadcrumb_breadcrumb_component__ = __webpack_require__(295);
/* unused harmony reexport BreadcrumbComponent */
/* unused harmony reexport BreadcrumbPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__carousel_items_directive__ = __webpack_require__(95);
/* unused harmony reexport CarouselItemsDirective */
/* unused harmony reexport CarouselItemDirective */
/* unused harmony reexport CarouselItemsPlugin */
/* unused harmony reexport CarouselItemPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__carousel_carousel_component__ = __webpack_require__(296);
/* unused harmony reexport CarouselComponent */
/* unused harmony reexport CarouselPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tab_items_directive__ = __webpack_require__(96);
/* unused harmony reexport TabItemsDirective */
/* unused harmony reexport TabItemDirective */
/* unused harmony reexport TabItemsPlugin */
/* unused harmony reexport TabItemPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__tab_tab_component__ = __webpack_require__(297);
/* unused harmony reexport TabComponent */
/* unused harmony reexport TabPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__treeview_treeview_component__ = __webpack_require__(298);
/* unused harmony reexport TreeViewComponent */
/* unused harmony reexport TreeViewPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sidebar_sidebar_component__ = __webpack_require__(299);
/* unused harmony reexport SidebarComponent */
/* unused harmony reexport SidebarPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__menu_items_directive__ = __webpack_require__(97);
/* unused harmony reexport MenuItemsDirective */
/* unused harmony reexport MenuItemDirective */
/* unused harmony reexport MenuItemsPlugin */
/* unused harmony reexport MenuItemPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__menu_menu_component__ = __webpack_require__(300);
/* unused harmony reexport MenuComponent */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_15__menu_menu_component__["a"]; });


















/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_index__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toolbar_index__ = __webpack_require__(244);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__toolbar_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accordion_index__ = __webpack_require__(245);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__accordion_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_menu_index__ = __webpack_require__(247);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__context_menu_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__menu_index__ = __webpack_require__(249);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__menu_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tab_index__ = __webpack_require__(251);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__tab_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__treeview_index__ = __webpack_require__(253);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__treeview_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sidebar_index__ = __webpack_require__(283);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__sidebar_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__breadcrumb_index__ = __webpack_require__(285);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__breadcrumb_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__carousel_index__ = __webpack_require__(287);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__carousel_index__["a"]; });
/**
 * Navigation all modules
 */












/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__h_scroll__ = __webpack_require__(25);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__v_scroll__ = __webpack_require__(28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu_scroll__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menu_base__ = __webpack_require__(29);
/* unused harmony reexport MenuAnimationSettings */
/* unused harmony reexport MenuItem */
/**
 * Navigation Common modules
 */







/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intl_intl_base__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ajax__ = __webpack_require__(202);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ajax__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(203);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__animation__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_2__animation__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_2__animation__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_2__animation__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(12);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__base__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_3__base__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser__ = __webpack_require__(16);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__browser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component__ = __webpack_require__(204);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__child_property__ = __webpack_require__(27);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__child_property__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__draggable__ = __webpack_require__(205);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__draggable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__droppable__ = __webpack_require__(206);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_8__droppable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__event_handler__ = __webpack_require__(15);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_9__event_handler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__internationalization__ = __webpack_require__(19);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__internationalization__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_10__internationalization__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_10__internationalization__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__keyboard__ = __webpack_require__(207);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_11__keyboard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__l10n__ = __webpack_require__(208);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_12__l10n__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__module_loader__ = __webpack_require__(80);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__notify_property_change__ = __webpack_require__(13);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_14__notify_property_change__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_14__notify_property_change__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_14__notify_property_change__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_14__notify_property_change__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_14__notify_property_change__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__touch__ = __webpack_require__(209);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_15__touch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hijri_parser__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__template_engine__ = __webpack_require__(210);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_17__template_engine__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_17__template_engine__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_17__template_engine__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_17__template_engine__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util__ = __webpack_require__(1);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_18__util__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_18__util__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_18__util__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_18__util__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_18__util__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_18__util__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_18__util__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_18__util__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_18__util__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_18__util__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_18__util__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_18__util__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_18__util__["r"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__dom__ = __webpack_require__(10);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_19__dom__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_19__dom__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_19__dom__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_19__dom__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_19__dom__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_19__dom__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_19__dom__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_19__dom__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_19__dom__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_19__dom__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_19__dom__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_19__dom__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_19__dom__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_19__dom__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_19__dom__["o"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__observer__ = __webpack_require__(26);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_20__observer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__sanitize_helper__ = __webpack_require__(212);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_21__sanitize_helper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__validate_lic__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/**
 * Base modules
 */

























/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intl_base__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parser_base__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date_formatter__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hijri_parser__ = __webpack_require__(40);





var standalone = 'stand-alone';
var latnRegex = /^[0-9]*$/;
var timeSetter = {
    minute: 'setMinutes',
    hour: 'setHours',
    second: 'setSeconds',
    day: 'setDate',
    month: 'setMonth',
    milliseconds: 'setMilliseconds'
};
var month = 'months';
/* tslint:disable no-any */
/**
 * Date Parser.
 *
 * @private
 */
var DateParser = /** @class */ (function () {
    function DateParser() {
    }
    /**
     * Returns the parser function for given skeleton.
     *
     * @param {string} culture -  Specifies the culture name to be which formatting.
     * @param {DateFormatOptions} option - Specific the format in which string date  will be parsed.
     * @param {Object} cldr - Specifies the global cldr data collection.
     * @returns {Function} ?
     */
    DateParser.dateParser = function (culture, option, cldr) {
        var _this = this;
        var dependable = __WEBPACK_IMPORTED_MODULE_0__intl_base__["a" /* IntlBase */].getDependables(cldr, culture, option.calendar);
        var numOptions = __WEBPACK_IMPORTED_MODULE_1__parser_base__["a" /* ParserBase */].getCurrentNumericOptions(dependable.parserObject, __WEBPACK_IMPORTED_MODULE_1__parser_base__["a" /* ParserBase */].getNumberingSystem(cldr), false, Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])());
        var parseOptions = {};
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])() && option.isServerRendered) {
            option = __WEBPACK_IMPORTED_MODULE_0__intl_base__["a" /* IntlBase */].compareBlazorDateFormats(option, culture);
        }
        var resPattern = option.format ||
            __WEBPACK_IMPORTED_MODULE_0__intl_base__["a" /* IntlBase */].getResultantPattern(option.skeleton, dependable.dateObject, option.type, false, Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])() ? culture : '');
        var regexString = '';
        var hourOnly;
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["o" /* isUndefined */])(resPattern)) {
            Object(__WEBPACK_IMPORTED_MODULE_2__util__["s" /* throwError */])('Format options or type given must be invalid');
        }
        else {
            resPattern = __WEBPACK_IMPORTED_MODULE_0__intl_base__["a" /* IntlBase */].ConvertDateToWeekFormat(resPattern);
            parseOptions = { isIslamic: __WEBPACK_IMPORTED_MODULE_0__intl_base__["a" /* IntlBase */].islamicRegex.test(option.calendar), pattern: resPattern, evalposition: {}, culture: culture };
            var patternMatch = resPattern.match(__WEBPACK_IMPORTED_MODULE_0__intl_base__["a" /* IntlBase */].dateParseRegex) || [];
            var length_1 = patternMatch.length;
            var gmtCorrection = 0;
            var zCorrectTemp = 0;
            var isgmtTraversed = false;
            var nRegx = numOptions.numericRegex;
            // eslint-disable-next-line
            var numMapper = Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])() ? dependable.parserObject.numbers :
                __WEBPACK_IMPORTED_MODULE_1__parser_base__["a" /* ParserBase */].getNumberMapper(dependable.parserObject, __WEBPACK_IMPORTED_MODULE_1__parser_base__["a" /* ParserBase */].getNumberingSystem(cldr));
            for (var i = 0; i < length_1; i++) {
                var str = patternMatch[i];
                var len = str.length;
                var char = (str[0] === 'K') ? 'h' : str[0];
                var isNumber = void 0;
                var canUpdate = void 0;
                // eslint-disable-next-line
                var charKey = __WEBPACK_IMPORTED_MODULE_3__date_formatter__["b" /* datePartMatcher */][char];
                var optional = (len === 2) ? '' : '?';
                if (isgmtTraversed) {
                    gmtCorrection = zCorrectTemp;
                    isgmtTraversed = false;
                }
                switch (char) {
                    case 'E':
                    case 'c':
                        // eslint-disable-next-line
                        var weekData = void 0;
                        if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])()) {
                            // eslint-disable-next-line
                            weekData = Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* getValue */])('days.' + __WEBPACK_IMPORTED_MODULE_0__intl_base__["a" /* IntlBase */].monthIndex[len], dependable.dateObject);
                        }
                        else {
                            // eslint-disable-next-line
                            weekData = dependable.dateObject[__WEBPACK_IMPORTED_MODULE_0__intl_base__["a" /* IntlBase */].days][standalone][__WEBPACK_IMPORTED_MODULE_0__intl_base__["a" /* IntlBase */].monthIndex[len]];
                        }
                        // eslint-disable-next-line
                        var weekObject = __WEBPACK_IMPORTED_MODULE_1__parser_base__["a" /* ParserBase */].reverseObject(weekData);
                        // tslint:enable
                        regexString += '(' + Object.keys(weekObject).join('|') + ')';
                        break;
                    case 'M':
                    case 'L':
                    case 'd':
                    case 'm':
                    case 's':
                    case 'h':
                    case 'H':
                    case 'f':
                        canUpdate = true;
                        if ((char === 'M' || char === 'L') && len > 2) {
                            var monthData = void 0;
                            if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])()) {
                                // eslint-disable-next-line
                                monthData = Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* getValue */])('months.' + __WEBPACK_IMPORTED_MODULE_0__intl_base__["a" /* IntlBase */].monthIndex[len], dependable.dateObject);
                            }
                            else {
                                // eslint-disable-next-line
                                monthData = dependable.dateObject[month][standalone][__WEBPACK_IMPORTED_MODULE_0__intl_base__["a" /* IntlBase */].monthIndex[len]];
                            }
                            // eslint-disable-next-line
                            parseOptions[charKey] = __WEBPACK_IMPORTED_MODULE_1__parser_base__["a" /* ParserBase */].reverseObject(monthData);
                            // eslint-disable-next-line
                            regexString += '(' + Object.keys(parseOptions[charKey]).join('|') + ')';
                        }
                        else if (char === 'f') {
                            if (len > 3) {
                                continue;
                            }
                            isNumber = true;
                            regexString += '(' + nRegx + nRegx + '?' + nRegx + '?' + ')';
                        }
                        else {
                            isNumber = true;
                            regexString += '(' + nRegx + nRegx + optional + ')';
                        }
                        if (char === 'h') {
                            parseOptions.hour12 = true;
                        }
                        break;
                    case 'W':
                        // eslint-disable-next-line
                        var opt = len === 1 ? '?' : '';
                        regexString += '(' + nRegx + opt + nRegx + ')';
                        break;
                    case 'y':
                        canUpdate = isNumber = true;
                        if (len === 2) {
                            regexString += '(' + nRegx + nRegx + ')';
                        }
                        else {
                            regexString += '(' + nRegx + '{' + len + ',})';
                        }
                        break;
                    case 'a':
                        canUpdate = true;
                        // eslint-disable-next-line
                        var periodValur = Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])() ?
                            Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* getValue */])('dayPeriods', dependable.dateObject) :
                            Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* getValue */])('dayPeriods.format.wide', dependable.dateObject);
                        // eslint-disable-next-line
                        parseOptions[charKey] = __WEBPACK_IMPORTED_MODULE_1__parser_base__["a" /* ParserBase */].reverseObject(periodValur);
                        // eslint-disable-next-line
                        regexString += '(' + Object.keys(parseOptions[charKey]).join('|') + ')';
                        break;
                    case 'G':
                        canUpdate = true;
                        // eslint-disable-next-line
                        var eText = (len <= 3) ? 'eraAbbr' : (len === 4) ? 'eraNames' : 'eraNarrow';
                        // eslint-disable-next-line
                        parseOptions[charKey] = __WEBPACK_IMPORTED_MODULE_1__parser_base__["a" /* ParserBase */].reverseObject(Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])() ?
                            Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* getValue */])('eras', dependable.dateObject) : Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* getValue */])('eras.' + eText, dependable.dateObject));
                        // eslint-disable-next-line
                        regexString += '(' + Object.keys(parseOptions[charKey]).join('|') + '?)';
                        break;
                    case 'z':
                        // eslint-disable-next-line
                        var tval = new Date().getTimezoneOffset();
                        canUpdate = (tval !== 0);
                        // eslint-disable-next-line
                        parseOptions[charKey] = Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* getValue */])('dates.timeZoneNames', dependable.parserObject);
                        // eslint-disable-next-line
                        var tzone = parseOptions[charKey];
                        hourOnly = (len < 4);
                        // eslint-disable-next-line
                        var hpattern = hourOnly ? '+H;-H' : tzone.hourFormat;
                        hpattern = hpattern.replace(/:/g, numMapper.timeSeparator);
                        regexString += '(' + this.parseTimeZoneRegx(hpattern, tzone, nRegx) + ')?';
                        isgmtTraversed = true;
                        zCorrectTemp = hourOnly ? 6 : 12;
                        break;
                    case '\'':
                        // eslint-disable-next-line
                        var iString = str.replace(/'/g, '');
                        regexString += '(' + iString + ')?';
                        break;
                    default:
                        regexString += '([\\D])';
                        break;
                }
                if (canUpdate) {
                    parseOptions.evalposition[charKey] = { isNumber: isNumber, pos: i + 1 + gmtCorrection, hourOnly: hourOnly };
                }
                if (i === length_1 - 1 && !Object(__WEBPACK_IMPORTED_MODULE_2__util__["m" /* isNullOrUndefined */])(regexString)) {
                    parseOptions.parserRegex = new RegExp('^' + regexString + '$', 'i');
                }
            }
        }
        return function (value) {
            var parsedDateParts = _this.internalDateParse(value, parseOptions, numOptions);
            if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["m" /* isNullOrUndefined */])(parsedDateParts) || !Object.keys(parsedDateParts).length) {
                return null;
            }
            if (parseOptions.isIslamic) {
                var dobj = {};
                var tYear = parsedDateParts.year;
                var tDate = parsedDateParts.day;
                var tMonth = parsedDateParts.month;
                var ystrig = tYear ? (tYear + '') : '';
                var is2DigitYear = (ystrig.length === 2);
                if (!tYear || !tMonth || !tDate || is2DigitYear) {
                    dobj = __WEBPACK_IMPORTED_MODULE_4__hijri_parser__["a" /* HijriParser */].getHijriDate(new Date());
                }
                if (is2DigitYear) {
                    tYear = parseInt((dobj.year + '').slice(0, 2) + ystrig, 10);
                }
                // tslint:disable-next-line
                var dateObject = __WEBPACK_IMPORTED_MODULE_4__hijri_parser__["a" /* HijriParser */].toGregorian(tYear || dobj.year, tMonth || dobj.month, tDate || dobj.date);
                parsedDateParts.year = dateObject.getFullYear();
                parsedDateParts.month = dateObject.getMonth() + 1;
                parsedDateParts.day = dateObject.getDate();
            }
            return _this.getDateObject(parsedDateParts);
        };
    };
    /* tslint:disable */
    /**
     * Returns date object for provided date options
     *
     * @param {DateParts} options ?
     * @param {Date} value ?
     * @returns {Date} ?
     */
    DateParser.getDateObject = function (options, value) {
        var res = value || new Date();
        res.setMilliseconds(0);
        var tKeys = ['hour', 'minute', 'second', 'milliseconds', 'month', 'day'];
        var y = options.year;
        var desig = options.designator;
        var tzone = options.timeZone;
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__util__["o" /* isUndefined */])(y)) {
            var len = (y + '').length;
            if (len <= 2) {
                var century = Math.floor(res.getFullYear() / 100) * 100;
                y += century;
            }
            res.setFullYear(y);
        }
        for (var _i = 0, tKeys_1 = tKeys; _i < tKeys_1.length; _i++) {
            var key = tKeys_1[_i];
            // eslint-disable-next-line
            var tValue = options[key];
            if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["o" /* isUndefined */])(tValue) && key === 'day') {
                res.setDate(1);
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__util__["o" /* isUndefined */])(tValue)) {
                if (key === 'month') {
                    tValue -= 1;
                    if (tValue < 0 || tValue > 11) {
                        return new Date('invalid');
                    }
                    var pDate = res.getDate();
                    res.setDate(1);
                    // eslint-disable-next-line
                    res[timeSetter[key]](tValue);
                    var lDate = new Date(res.getFullYear(), tValue + 1, 0).getDate();
                    res.setDate(pDate < lDate ? pDate : lDate);
                }
                else {
                    if (key === 'day') {
                        var lastDay = new Date(res.getFullYear(), res.getMonth() + 1, 0).getDate();
                        if ((tValue < 1 || tValue > lastDay)) {
                            return null;
                        }
                    }
                    // eslint-disable-next-line
                    res[timeSetter[key]](tValue);
                }
            }
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__util__["o" /* isUndefined */])(desig)) {
            var hour = res.getHours();
            if (desig === 'pm') {
                res.setHours(hour + (hour === 12 ? 0 : 12));
            }
            else if (hour === 12) {
                res.setHours(0);
            }
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__util__["o" /* isUndefined */])(tzone)) {
            var tzValue = tzone - res.getTimezoneOffset();
            if (tzValue !== 0) {
                res.setMinutes(res.getMinutes() + tzValue);
            }
        }
        return res;
    };
    /**
     * Returns date parsing options for provided value along with parse and numeric options
     *
     * @param {string} value ?
     * @param {ParseOptions} parseOptions ?
     * @param {NumericOptions} num ?
     * @returns {DateParts} ?
     */
    DateParser.internalDateParse = function (value, parseOptions, num) {
        var matches = value.match(parseOptions.parserRegex);
        var retOptions = { 'hour': 0, 'minute': 0, 'second': 0 };
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["m" /* isNullOrUndefined */])(matches)) {
            return null;
        }
        else {
            var props = Object.keys(parseOptions.evalposition);
            for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
                var prop = props_1[_i];
                var curObject = parseOptions.evalposition[prop];
                var matchString = matches[curObject.pos];
                if (curObject.isNumber) {
                    // eslint-disable-next-line
                    retOptions[prop] = this.internalNumberParser(matchString, num);
                }
                else {
                    if (prop === 'timeZone' && !Object(__WEBPACK_IMPORTED_MODULE_2__util__["o" /* isUndefined */])(matchString)) {
                        var pos = curObject.pos;
                        var val = void 0;
                        var tmatch = matches[pos + 1];
                        var flag = !Object(__WEBPACK_IMPORTED_MODULE_2__util__["o" /* isUndefined */])(tmatch);
                        if (curObject.hourOnly) {
                            val = this.getZoneValue(flag, tmatch, matches[pos + 4], num) * 60;
                        }
                        else {
                            val = this.getZoneValue(flag, tmatch, matches[pos + 7], num) * 60;
                            val += this.getZoneValue(flag, matches[pos + 4], matches[pos + 10], num);
                        }
                        if (!Object(__WEBPACK_IMPORTED_MODULE_2__util__["m" /* isNullOrUndefined */])(val)) {
                            retOptions[prop] = val;
                        }
                    }
                    else {
                        // eslint-disable-next-line
                        matchString = ((prop === 'month') && (!parseOptions.isIslamic) && (parseOptions.culture === 'en' || parseOptions.culture === 'en-GB' || parseOptions.culture === 'en-US'))
                            ? matchString[0].toUpperCase() + matchString.substring(1).toLowerCase() : matchString;
                        // eslint-disable-next-line
                        retOptions[prop] = parseOptions[prop][matchString];
                    }
                }
            }
            if (parseOptions.hour12) {
                retOptions.hour12 = true;
            }
        }
        return retOptions;
    };
    /**
     * Returns parsed number for provided Numeric string and Numeric Options
     *
     * @param {string} value ?
     * @param {NumericOptions} option ?
     * @returns {number} ?
     */
    DateParser.internalNumberParser = function (value, option) {
        value = __WEBPACK_IMPORTED_MODULE_1__parser_base__["a" /* ParserBase */].convertValueParts(value, option.numberParseRegex, option.numericPair);
        if (latnRegex.test(value)) {
            return +value;
        }
        return null;
    };
    /**
     * Returns parsed time zone RegExp for provided hour format and time zone
     *
     * @param {string} hourFormat ?
     * @param {base.TimeZoneOptions} tZone ?
     * @param {string} nRegex ?
     * @returns {string} ?
     */
    DateParser.parseTimeZoneRegx = function (hourFormat, tZone, nRegex) {
        var pattern = tZone.gmtFormat;
        var ret;
        var cRegex = '(' + nRegex + ')' + '(' + nRegex + ')';
        var splitStr;
        ret = hourFormat.replace('+', '\\+');
        if (hourFormat.indexOf('HH') !== -1) {
            ret = ret.replace(/HH|mm/g, '(' + cRegex + ')');
        }
        else {
            ret = ret.replace(/H|m/g, '(' + cRegex + '?)');
        }
        // eslint-disable-next-line
        splitStr = (ret.split(';').map(function (str) {
            return pattern.replace('{0}', str);
        }));
        ret = splitStr.join('|') + '|' + tZone.gmtZeroFormat;
        return ret;
    };
    /**
     * Returns zone based value.
     *
     * @param {boolean} flag ?
     * @param {string} val1 ?
     * @param {string} val2 ?
     * @param {NumericOptions} num ?
     * @returns {number} ?
     */
    DateParser.getZoneValue = function (flag, val1, val2, num) {
        var ival = flag ? val1 : val2;
        if (!ival) {
            return 0;
        }
        var value = this.internalNumberParser(ival, num);
        if (flag) {
            return -value;
        }
        return value;
    };
    return DateParser;
}());



/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NumberParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parser_base__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intl_base__ = __webpack_require__(14);



var parseRegex = /^([^0-9]*)(([0-9,]*[0-9]+)(\.[0-9]+)?)([Ee][+-]?[0-9]+)?([^0-9]*)$/;
var groupRegex = /,/g;
var keys = ['minusSign', 'infinity'];
/**
 * Module for Number Parser.
 *
 * @private
 */
var NumberParser = /** @class */ (function () {
    function NumberParser() {
    }
    /**
     * Returns the parser function for given skeleton.
     *
     * @param {string} culture -  Specifies the culture name to be which formatting.
     * @param {NumberFormatOptions} option - Specific the format in which number  will parsed.
     * @param {Object} cldr - Specifies the global cldr data collection.
     * @returns {Function} ?
     */
    NumberParser.numberParser = function (culture, option, cldr) {
        var _this = this;
        var dependable = __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].getDependables(cldr, culture, '', true);
        var parseOptions = { custom: true };
        var numOptions;
        if ((__WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].formatRegex.test(option.format)) || !(option.format)) {
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])(parseOptions, __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].getProperNumericSkeleton(option.format || 'N'));
            parseOptions.custom = false;
            if (!parseOptions.fractionDigits) {
                if (option.maximumFractionDigits) {
                    parseOptions.maximumFractionDigits = option.maximumFractionDigits;
                }
            }
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])(parseOptions, __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].customFormat(option.format, null, null));
        }
        var numbers = Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])('numbers', dependable.parserObject);
        // eslint-disable-next-line
        numOptions = __WEBPACK_IMPORTED_MODULE_1__parser_base__["a" /* ParserBase */].getCurrentNumericOptions(dependable.parserObject, __WEBPACK_IMPORTED_MODULE_1__parser_base__["a" /* ParserBase */].getNumberingSystem(cldr), true, Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isBlazor */])());
        parseOptions.symbolRegex = __WEBPACK_IMPORTED_MODULE_1__parser_base__["a" /* ParserBase */].getSymbolRegex(Object.keys(numOptions.symbolMatch));
        // eslint-disable-next-line
        parseOptions.infinity = numOptions.symbolNumberSystem[keys[1]];
        var symbolpattern;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isBlazor */])()) {
            symbolpattern = __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].getSymbolPattern(parseOptions.type, numOptions.numberSystem, dependable.numericObject, parseOptions.isAccount);
            if (symbolpattern) {
                symbolpattern = symbolpattern.replace(/\u00A4/g, __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].defaultCurrency);
                var split = symbolpattern.split(';');
                parseOptions.nData = __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].getFormatData(split[1] || '-' + split[0], true, '');
                parseOptions.pData = __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].getFormatData(split[0], true, '');
            }
        }
        else {
            parseOptions.nData = Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])({}, {}, Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])(parseOptions.type + 'nData', numbers));
            parseOptions.pData = Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])({}, {}, Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])(parseOptions.type + 'pData', numbers));
            if (parseOptions.type === 'currency' && option.currency) {
                __WEBPACK_IMPORTED_MODULE_2__intl_base__["a" /* IntlBase */].replaceBlazorCurrency([parseOptions.pData, parseOptions.nData], Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])('currencySymbol', numbers), option.currency);
            }
        }
        return function (value) {
            return _this.getParsedNumber(value, parseOptions, numOptions);
        };
    };
    /**
     * Returns parsed number for the provided formatting options
     *
     * @param {string} value ?
     * @param {NumericParts} options ?
     * @param {NumericOptions} numOptions ?
     * @returns {number} ?
     */
    NumberParser.getParsedNumber = function (value, options, numOptions) {
        var isNegative;
        var isPercent;
        var tempValue;
        var lead;
        var end;
        var ret;
        if (value.indexOf(options.infinity) !== -1) {
            return Infinity;
        }
        else {
            value = __WEBPACK_IMPORTED_MODULE_1__parser_base__["a" /* ParserBase */].convertValueParts(value, options.symbolRegex, numOptions.symbolMatch);
            value = __WEBPACK_IMPORTED_MODULE_1__parser_base__["a" /* ParserBase */].convertValueParts(value, numOptions.numberParseRegex, numOptions.numericPair);
            value = value.indexOf('-') !== -1 ? value.replace('-.', '-0.') : value;
            if (value.indexOf('.') === 0) {
                value = '0' + value;
            }
            var matches = value.match(parseRegex);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(matches)) {
                return NaN;
            }
            lead = matches[1];
            tempValue = matches[2];
            var exponent = matches[5];
            end = matches[6];
            isNegative = options.custom ? ((lead === options.nData.nlead) && (end === options.nData.nend)) :
                ((lead.indexOf(options.nData.nlead) !== -1) && (end.indexOf(options.nData.nend) !== -1));
            isPercent = isNegative ?
                options.nData.isPercent :
                options.pData.isPercent;
            tempValue = tempValue.replace(groupRegex, '');
            if (exponent) {
                tempValue += exponent;
            }
            ret = +tempValue;
            if (options.type === 'percent' || isPercent) {
                ret = ret / 100;
            }
            if (options.custom || options.fractionDigits) {
                ret = parseFloat(ret.toFixed(options.custom ?
                    (isNegative ? options.nData.maximumFractionDigits : options.pData.maximumFractionDigits) : options.fractionDigits));
            }
            if (options.maximumFractionDigits) {
                ret = this.convertMaxFracDigits(tempValue, options, ret, isNegative);
            }
            if (isNegative) {
                ret *= -1;
            }
            return ret;
        }
    };
    NumberParser.convertMaxFracDigits = function (value, options, ret, isNegative) {
        var decimalSplitValue = value.split('.');
        if (decimalSplitValue[1] && decimalSplitValue[1].length > options.maximumFractionDigits) {
            ret = +(ret.toFixed(options.custom ?
                (isNegative ? options.nData.maximumFractionDigits : options.pData.maximumFractionDigits) : options.maximumFractionDigits));
        }
        return ret;
    };
    return NumberParser;
}());



/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ajax; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(1);

var headerRegex = /^(.*?):[ \t]*([^\r\n]*)$/gm;
var defaultType = 'GET';
/**
 * Ajax class provides ability to make asynchronous HTTP request to the server
 * ```typescript
 *   var ajax = new Ajax("index.html", "GET", true);
 *   ajax.send().then(
 *               function (value) {
 *                   console.log(value);
 *               },
 *               function (reason) {
 *                   console.log(reason);
 *               });
 * ```
 */
var Ajax = /** @class */ (function () {
    /**
     * Constructor for Ajax class
     *
     * @param  {string|Object} options ?
     * @param  {string} type ?
     * @param  {boolean} async ?
     * @returns defaultType any
     */
    function Ajax(options, type, async, contentType) {
        /**
         * A boolean value indicating whether the request should be sent asynchronous or not.
         *
         * @default true
         */
        this.mode = true;
        /**
         * A boolean value indicating whether to ignore the promise reject.
         *
         * @private
         * @default true
         */
        this.emitError = true;
        this.options = {};
        if (typeof options === 'string') {
            this.url = options;
            this.type = type ? type.toUpperCase() : defaultType;
            this.mode = !Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(async) ? async : true;
        }
        else if (typeof options === 'object') {
            this.options = options;
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["p" /* merge */])(this, this.options);
        }
        this.type = this.type ? this.type.toUpperCase() : defaultType;
        this.contentType = (this.contentType !== undefined) ? this.contentType : contentType;
    }
    /**
     *
     * Send the request to server.
     *
     * @param {any} data - To send the user data
     * @return {Promise} ?
     */
    Ajax.prototype.send = function (data) {
        var _this = this;
        this.data = Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(data) ? this.data : data;
        var eventArgs = {
            cancel: false,
            httpRequest: null
        };
        var promise = new Promise(function (resolve, reject) {
            _this.httpRequest = new XMLHttpRequest();
            _this.httpRequest.onreadystatechange = function () { _this.stateChange(resolve, reject); };
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(_this.onLoad)) {
                _this.httpRequest.onload = _this.onLoad;
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(_this.onProgress)) {
                _this.httpRequest.onprogress = _this.onProgress;
            }
            /* istanbul ignore next */
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(_this.onAbort)) {
                _this.httpRequest.onabort = _this.onAbort;
            }
            /* istanbul ignore next */
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(_this.onError)) {
                _this.httpRequest.onerror = _this.onError;
            }
            //** Upload Events **/
            /* istanbul ignore next */
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(_this.onUploadProgress)) {
                _this.httpRequest.upload.onprogress = _this.onUploadProgress;
            }
            _this.httpRequest.open(_this.type, _this.url, _this.mode);
            // Set default headers
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(_this.data) && _this.contentType !== null) {
                _this.httpRequest.setRequestHeader('Content-Type', _this.contentType || 'application/json; charset=utf-8');
            }
            if (_this.beforeSend) {
                eventArgs.httpRequest = _this.httpRequest;
                _this.beforeSend(eventArgs);
            }
            if (!eventArgs.cancel) {
                _this.httpRequest.send(!Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(_this.data) ? _this.data : null);
            }
        });
        return promise;
    };
    Ajax.prototype.successHandler = function (data) {
        if (this.onSuccess) {
            this.onSuccess(data, this);
        }
        return data;
    };
    Ajax.prototype.failureHandler = function (reason) {
        if (this.onFailure) {
            this.onFailure(this.httpRequest);
        }
        return reason;
    };
    Ajax.prototype.stateChange = function (resolve, reject) {
        var data = this.httpRequest.responseText;
        if (this.dataType && this.dataType.toLowerCase() === 'json') {
            if (data === '') {
                data = undefined;
            }
            else {
                try {
                    data = JSON.parse(data);
                }
                catch (error) {
                    // no exception handle
                }
            }
        }
        if (this.httpRequest.readyState === 4) {
            //success range should be 200 to 299
            if ((this.httpRequest.status >= 200 && this.httpRequest.status <= 299) || this.httpRequest.status === 304) {
                resolve(this.successHandler(data));
            }
            else {
                if (this.emitError) {
                    reject(new Error(this.failureHandler(this.httpRequest.statusText)));
                }
                else {
                    resolve();
                }
            }
        }
    };
    /**
     * To get the response header from XMLHttpRequest
     *
     * @param  {string} key Key to search in the response header
     * @returns {string} ?
     */
    Ajax.prototype.getResponseHeader = function (key) {
        var responseHeaders;
        var header;
        // eslint-disable-next-line
        responseHeaders = {};
        var headers = headerRegex.exec(this.httpRequest.getAllResponseHeaders());
        while (headers) {
            responseHeaders[headers[1].toLowerCase()] = headers[2];
            headers = headerRegex.exec(this.httpRequest.getAllResponseHeaders());
        }
        // eslint-disable-next-line
        header = responseHeaders[key.toLowerCase()];
        return Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(header) ? null : header;
    };
    return Ajax;
}());



/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Animation; });
/* harmony export (immutable) */ __webpack_exports__["d"] = rippleEffect;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isRippleEnabled; });
/* harmony export (immutable) */ __webpack_exports__["b"] = enableRipple;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_handler__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notify_property_change__ = __webpack_require__(13);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * The Animation framework provide options to animate the html DOM elements
 * ```typescript
 *   let animeObject = new Animation({
 *      name: 'SlideLeftIn',
 *      duration: 1000
 *   });
 *   animeObject.animate('#anime1');
 *   animeObject.animate('#anime2', { duration: 500 });
 * ```
 */
var Animation = /** @class */ (function (_super) {
    __extends(Animation, _super);
    function Animation(options) {
        var _this = _super.call(this, options, undefined) || this;
        /**
         * @private
         */
        _this.easing = {
            ease: 'cubic-bezier(0.250, 0.100, 0.250, 1.000)',
            linear: 'cubic-bezier(0.250, 0.250, 0.750, 0.750)',
            easeIn: 'cubic-bezier(0.420, 0.000, 1.000, 1.000)',
            easeOut: 'cubic-bezier(0.000, 0.000, 0.580, 1.000)',
            easeInOut: 'cubic-bezier(0.420, 0.000, 0.580, 1.000)',
            elasticInOut: 'cubic-bezier(0.5,-0.58,0.38,1.81)',
            elasticIn: 'cubic-bezier(0.17,0.67,0.59,1.81)',
            elasticOut: 'cubic-bezier(0.7,-0.75,0.99,1.01)'
        };
        return _this;
    }
    Animation_1 = Animation;
    /**
     * Applies animation to the current element.
     *
     * @param {string | HTMLElement} element - Element which needs to be animated.
     * @param {AnimationModel} options - Overriding default animation settings.
     * @returns {void} ?
     */
    Animation.prototype.animate = function (element, options) {
        options = !options ? {} : options;
        var model = this.getModel(options);
        if (typeof element === 'string') {
            var elements = Array.prototype.slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__dom__["n" /* selectAll */])(element, document));
            for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
                var element_1 = elements_1[_i];
                model.element = element_1;
                Animation_1.delayAnimation(model);
            }
        }
        else {
            model.element = element;
            Animation_1.delayAnimation(model);
        }
    };
    /**
     * Stop the animation effect on animated element.
     *
     * @param {HTMLElement} element - Element which needs to be stop the animation.
     * @param {AnimationOptions} model - Handling the animation model at stop function.
     * @return {void}
     */
    Animation.stop = function (element, model) {
        element.style.animation = '';
        element.removeAttribute('e-animate');
        var animationId = element.getAttribute('e-animation-id');
        if (animationId) {
            var frameId = parseInt(animationId, 10);
            cancelAnimationFrame(frameId);
            element.removeAttribute('e-animation-id');
        }
        if (model && model.end) {
            model.end.call(this, model);
        }
    };
    /**
     * Set delay to animation element
     *
     * @param {AnimationModel} model ?
     * @returns {void}
     */
    Animation.delayAnimation = function (model) {
        if (model.delay) {
            setTimeout(function () { Animation_1.applyAnimation(model); }, model.delay);
        }
        else {
            Animation_1.applyAnimation(model);
        }
    };
    /**
     * Triggers animation
     *
     * @param {AnimationModel} model ?
     * @returns {void}
     */
    Animation.applyAnimation = function (model) {
        var _this = this;
        model.timeStamp = 0;
        var step = 0;
        var timerId = 0;
        var prevTimeStamp = 0;
        var duration = model.duration;
        model.element.setAttribute('e-animate', 'true');
        var startAnimation = function (timeStamp) {
            try {
                if (timeStamp) {
                    // let step: number = model.timeStamp = timeStamp - startTime;
                    /** phantomjs workaround for timestamp fix */
                    prevTimeStamp = prevTimeStamp === 0 ? timeStamp : prevTimeStamp;
                    model.timeStamp = (timeStamp + model.timeStamp) - prevTimeStamp;
                    prevTimeStamp = timeStamp;
                    /** phantomjs workaround end */
                    // trigger animation begin event
                    if (!step && model.begin) {
                        model.begin.call(_this, model);
                    }
                    step = step + 1;
                    var avg = model.timeStamp / step;
                    if (model.timeStamp < duration && model.timeStamp + avg < duration && model.element.getAttribute('e-animate')) {
                        // apply animation effect to the current element
                        model.element.style.animation = model.name + ' ' + model.duration + 'ms ' + model.timingFunction;
                        if (model.progress) {
                            model.progress.call(_this, model);
                        }
                        // repeat requestAnimationFrame
                        requestAnimationFrame(startAnimation);
                    }
                    else {
                        // clear requestAnimationFrame
                        cancelAnimationFrame(timerId);
                        model.element.removeAttribute('e-animation-id');
                        model.element.removeAttribute('e-animate');
                        model.element.style.animation = '';
                        if (model.end) {
                            model.end.call(_this, model);
                        }
                    }
                }
                else {
                    //startTime = performance.now();
                    // set initial requestAnimationFrame
                    timerId = requestAnimationFrame(startAnimation);
                    model.element.setAttribute('e-animation-id', timerId.toString());
                }
            }
            catch (e) {
                cancelAnimationFrame(timerId);
                model.element.removeAttribute('e-animation-id');
                if (model.fail) {
                    model.fail.call(_this, e);
                }
            }
        };
        startAnimation();
    };
    /**
     * Returns Animation Model
     *
     * @param {AnimationModel} options ?
     * @returns {AnimationModel} ?
     */
    Animation.prototype.getModel = function (options) {
        return {
            name: options.name || this.name,
            delay: options.delay || this.delay,
            duration: (options.duration !== undefined ? options.duration : this.duration),
            begin: options.begin || this.begin,
            end: options.end || this.end,
            fail: options.fail || this.fail,
            progress: options.progress || this.progress,
            timingFunction: this.easing[options.timingFunction] ? this.easing[options.timingFunction] :
                (options.timingFunction || this.easing[this.timingFunction])
        };
    };
    /**
     * @private
     * @param {AnimationModel} newProp ?
     * @param {AnimationModel} oldProp ?
     * @returns {void} ?
     */
    // eslint-disable-next-line
    Animation.prototype.onPropertyChanged = function (newProp, oldProp) {
        // no code needed
    };
    /**
     * Returns module name as animation
     *
     * @private
     * @returns {void} ?
     */
    Animation.prototype.getModuleName = function () {
        return 'animation';
    };
    /**
     *
     * @private
     * @returns {void} ?
     */
    Animation.prototype.destroy = function () {
        //Override base destroy;
    };
    var Animation_1;
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_4__notify_property_change__["e" /* Property */])('FadeIn')
    ], Animation.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_4__notify_property_change__["e" /* Property */])(400)
    ], Animation.prototype, "duration", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_4__notify_property_change__["e" /* Property */])('ease')
    ], Animation.prototype, "timingFunction", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_4__notify_property_change__["e" /* Property */])(0)
    ], Animation.prototype, "delay", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_4__notify_property_change__["c" /* Event */])()
    ], Animation.prototype, "progress", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_4__notify_property_change__["c" /* Event */])()
    ], Animation.prototype, "begin", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_4__notify_property_change__["c" /* Event */])()
    ], Animation.prototype, "end", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_4__notify_property_change__["c" /* Event */])()
    ], Animation.prototype, "fail", void 0);
    Animation = Animation_1 = __decorate([
        __WEBPACK_IMPORTED_MODULE_4__notify_property_change__["d" /* NotifyPropertyChanges */]
    ], Animation);
    return Animation;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* Base */]));

/**
 * Ripple provides material theme's wave effect when an element is clicked
 * ```html
 * <div id='ripple'></div>
 * <script>
 *   rippleEffect(document.getElementById('ripple'));
 * </script>
 * ```
 *
 * @private
 * @param {HTMLElement} element - Target element
 * @param {RippleOptions} rippleOptions - Ripple options .
 * @param {Function} done .
 * @returns {void} .
 */
function rippleEffect(element, rippleOptions, done) {
    var rippleModel = getRippleModel(rippleOptions);
    if (rippleModel.rippleFlag === false || (rippleModel.rippleFlag === undefined && !isRippleEnabled)) {
        return (function () { });
    }
    element.setAttribute('data-ripple', 'true');
    __WEBPACK_IMPORTED_MODULE_3__event_handler__["a" /* EventHandler */].add(element, 'mousedown', rippleHandler, { parent: element, rippleOptions: rippleModel });
    __WEBPACK_IMPORTED_MODULE_3__event_handler__["a" /* EventHandler */].add(element, 'mouseup', rippleUpHandler, { parent: element, rippleOptions: rippleModel, done: done });
    __WEBPACK_IMPORTED_MODULE_3__event_handler__["a" /* EventHandler */].add(element, 'mouseleave', rippleLeaveHandler, { parent: element, rippleOptions: rippleModel });
    if (__WEBPACK_IMPORTED_MODULE_2__browser__["a" /* Browser */].isPointer) {
        __WEBPACK_IMPORTED_MODULE_3__event_handler__["a" /* EventHandler */].add(element, 'transitionend', rippleLeaveHandler, { parent: element, rippleOptions: rippleModel });
    }
    return (function () {
        element.removeAttribute('data-ripple');
        __WEBPACK_IMPORTED_MODULE_3__event_handler__["a" /* EventHandler */].remove(element, 'mousedown', rippleHandler);
        __WEBPACK_IMPORTED_MODULE_3__event_handler__["a" /* EventHandler */].remove(element, 'mouseup', rippleUpHandler);
        __WEBPACK_IMPORTED_MODULE_3__event_handler__["a" /* EventHandler */].remove(element, 'mouseleave', rippleLeaveHandler);
        __WEBPACK_IMPORTED_MODULE_3__event_handler__["a" /* EventHandler */].remove(element, 'transitionend', rippleLeaveHandler);
    });
}
/**
 * Handler for ripple model
 *
 * @param {RippleOptions} rippleOptions ?
 * @returns {RippleOptions} ?
 */
function getRippleModel(rippleOptions) {
    var rippleModel = {
        selector: rippleOptions && rippleOptions.selector ? rippleOptions.selector : null,
        ignore: rippleOptions && rippleOptions.ignore ? rippleOptions.ignore : null,
        rippleFlag: rippleOptions && rippleOptions.rippleFlag,
        isCenterRipple: rippleOptions && rippleOptions.isCenterRipple,
        duration: rippleOptions && rippleOptions.duration ? rippleOptions.duration : 350
    };
    return rippleModel;
}
/**
 * Handler for ripple event
 *
 * @param {MouseEvent} e ?
 * @returns {void} ?
 * @private
 */
function rippleHandler(e) {
    var target = (e.target);
    var selector = this.rippleOptions.selector;
    var element = selector ? Object(__WEBPACK_IMPORTED_MODULE_0__dom__["e" /* closest */])(target, selector) : target;
    if (!element || (this.rippleOptions && Object(__WEBPACK_IMPORTED_MODULE_0__dom__["e" /* closest */])(target, this.rippleOptions.ignore))) {
        return;
    }
    var offset = element.getBoundingClientRect();
    var offsetX = e.pageX - document.body.scrollLeft;
    var offsetY = e.pageY - ((!document.body.scrollTop && document.documentElement) ?
        document.documentElement.scrollTop : document.body.scrollTop);
    var pageX = Math.max(Math.abs(offsetX - offset.left), Math.abs(offsetX - offset.right));
    var pageY = Math.max(Math.abs(offsetY - offset.top), Math.abs(offsetY - offset.bottom));
    var radius = Math.sqrt(pageX * pageX + pageY * pageY);
    var diameter = radius * 2 + 'px';
    var x = offsetX - offset.left - radius;
    var y = offsetY - offset.top - radius;
    if (this.rippleOptions && this.rippleOptions.isCenterRipple) {
        x = 0;
        y = 0;
        diameter = '100%';
    }
    element.classList.add('e-ripple');
    var duration = this.rippleOptions.duration.toString();
    var styles = 'width: ' + diameter + ';height: ' + diameter + ';left: ' + x + 'px;top: ' + y + 'px;' +
        'transition-duration: ' + duration + 'ms;';
    var rippleElement = Object(__WEBPACK_IMPORTED_MODULE_0__dom__["f" /* createElement */])('div', { className: 'e-ripple-element', styles: styles });
    element.appendChild(rippleElement);
    window.getComputedStyle(rippleElement).getPropertyValue('opacity');
    rippleElement.style.transform = 'scale(1)';
    if (element !== this.parent) {
        __WEBPACK_IMPORTED_MODULE_3__event_handler__["a" /* EventHandler */].add(element, 'mouseleave', rippleLeaveHandler, { parent: this.parent, rippleOptions: this.rippleOptions });
    }
}
/**
 * Handler for ripple element mouse up event
 *
 * @param {MouseEvent} e ?
 * @returns {void} ?
 * @private
 */
function rippleUpHandler(e) {
    removeRipple(e, this);
}
/**
 * Handler for ripple element mouse move event
 *
 * @param {MouseEvent} e ?
 * @returns {void} ?
 * @private
 */
function rippleLeaveHandler(e) {
    removeRipple(e, this);
}
/**
 * Handler for removing ripple element
 *
 * @param {MouseEvent} e ?
 * @param {RippleArgs} eventArgs ?
 * @returns {void} ?
 * @private
 */
function removeRipple(e, eventArgs) {
    var duration = eventArgs.rippleOptions.duration;
    var target = (e.target);
    var selector = eventArgs.rippleOptions.selector;
    var element = selector ? Object(__WEBPACK_IMPORTED_MODULE_0__dom__["e" /* closest */])(target, selector) : target;
    if (!element || (element && element.className.indexOf('e-ripple') === -1)) {
        return;
    }
    var rippleElements = Object(__WEBPACK_IMPORTED_MODULE_0__dom__["n" /* selectAll */])('.e-ripple-element', element);
    var rippleElement = rippleElements[rippleElements.length - 1];
    if (rippleElement) {
        rippleElement.style.opacity = '0.5';
    }
    if (eventArgs.parent !== element) {
        __WEBPACK_IMPORTED_MODULE_3__event_handler__["a" /* EventHandler */].remove(element, 'mouseleave', rippleLeaveHandler);
    }
    /* tslint:disable:align */
    setTimeout(function () {
        if (rippleElement && rippleElement.parentNode) {
            rippleElement.parentNode.removeChild(rippleElement);
        }
        if (!element.getElementsByClassName('e-ripple-element').length) {
            element.classList.remove('e-ripple');
        }
        if (eventArgs.done) {
            eventArgs.done(e);
        }
    }, duration);
}
var isRippleEnabled = false;
/**
 * Animation Module provides support to enable ripple effect functionality to Essential JS 2 components.
 *
 * @param {boolean} isRipple Specifies the boolean value to enable or disable ripple effect.
 * @returns {boolean} ?
 */
function enableRipple(isRipple) {
    isRippleEnabled = isRipple;
    return isRippleEnabled;
}


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export versionBasedStatePersistence */
/* unused harmony export enableVersionBasedPersistence */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Component; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_loader__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__observer__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__child_property__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__notify_property_change__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internationalization__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dom__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








// import { validateLicense } from './validate-lic';
var componentCount = 0;
var lastPageID;
var lastHistoryLen = 0;
var versionBasedStatePersistence = false;
/**
 * To enable or disable version based statePersistence functionality for all components globally.
 *
 * @param {boolean} status - Optional argument Specifies the status value to enable or disable versionBasedStatePersistence option.
 * @returns {void}
 */
function enableVersionBasedPersistence(status) {
    versionBasedStatePersistence = status;
}
/**
 * Base class for all Essential JavaScript components
 */
var Component = /** @class */ (function (_super) {
    __extends(Component, _super);
    /**
     * Initialize the constructor for component base
     *
     * @param {Object} options ?
     * @param {string} selector ?
     */
    function Component(options, selector) {
        var _this = _super.call(this, options, selector) || this;
        _this.randomId = Object(__WEBPACK_IMPORTED_MODULE_0__util__["t" /* uniqueID */])();
        /**
         * string template option for Blazor template rendering
         *
         * @private
         */
        _this.isStringTemplate = false;
        _this.needsID = false;
        _this.isReactHybrid = false;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(_this.enableRtl)) {
            _this.setProperties({ 'enableRtl': __WEBPACK_IMPORTED_MODULE_6__internationalization__["f" /* rightToLeft */] }, true);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(_this.locale)) {
            _this.setProperties({ 'locale': __WEBPACK_IMPORTED_MODULE_6__internationalization__["b" /* defaultCulture */] }, true);
        }
        _this.moduleLoader = new __WEBPACK_IMPORTED_MODULE_1__module_loader__["a" /* ModuleLoader */](_this);
        _this.localObserver = new __WEBPACK_IMPORTED_MODULE_3__observer__["a" /* Observer */](_this);
        // tslint:disable-next-line:no-function-constructor-with-string-args
        __WEBPACK_IMPORTED_MODULE_6__internationalization__["e" /* onIntlChange */].on('notifyExternalChange', _this.detectFunction, _this, _this.randomId);
        // if (typeof window !== "undefined" && typeof document !== "undefined") {
        //     validateLicense();
        // }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(selector)) {
            _this.appendTo();
        }
        return _this;
    }
    Component.prototype.requiredModules = function () {
        return [];
    };
    /**
     * Destroys the sub modules while destroying the widget
     *
     * @returns {void} ?
     */
    Component.prototype.destroy = function () {
        if (this.isDestroyed) {
            return;
        }
        if (this.enablePersistence) {
            this.setPersistData();
        }
        this.localObserver.destroy();
        if (this.refreshing) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_7__dom__["l" /* removeClass */])([this.element], ['e-control']);
        this.trigger('destroyed', { cancel: false });
        _super.prototype.destroy.call(this);
        this.moduleLoader.clean();
        __WEBPACK_IMPORTED_MODULE_6__internationalization__["e" /* onIntlChange */].off('notifyExternalChange', this.detectFunction, this.randomId);
    };
    /**
     * Applies all the pending property changes and render the component again.
     *
     * @returns {void} ?
     */
    Component.prototype.refresh = function () {
        this.refreshing = true;
        this.moduleLoader.clean();
        this.destroy();
        this.clearChanges();
        this.localObserver = new __WEBPACK_IMPORTED_MODULE_3__observer__["a" /* Observer */](this);
        this.preRender();
        this.injectModules();
        this.render();
        this.refreshing = false;
    };
    Component.prototype.accessMount = function () {
        if (this.mount && !this.isReactHybrid) {
            this.mount();
        }
    };
    /**
     * Returns the route element of the component
     *
     * @returns {HTMLElement} ?
     */
    Component.prototype.getRootElement = function () {
        if (this.isReactHybrid) {
            // eslint-disable-next-line
            return this.actualElement;
        }
        else {
            return this.element;
        }
    };
    /**
     * Returns the persistence data for component
     *
     * @returns {any} ?
     */
    // eslint-disable-next-line
    Component.prototype.getLocalData = function () {
        var eleId = this.getModuleName() + this.element.id;
        if (versionBasedStatePersistence) {
            return window.localStorage.getItem(eleId + this.ej2StatePersistenceVersion);
        }
        else {
            return window.localStorage.getItem(eleId);
        }
    };
    /**
     * Appends the control within the given HTML element
     *
     * @param {string | HTMLElement} selector - Target element where control needs to be appended
     * @returns {void} ?
     */
    Component.prototype.appendTo = function (selector) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(selector) && typeof (selector) === 'string') {
            this.element = Object(__WEBPACK_IMPORTED_MODULE_7__dom__["m" /* select */])(selector, document);
        }
        else if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(selector)) {
            this.element = selector;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(this.element)) {
            var moduleClass = 'e-' + this.getModuleName().toLowerCase();
            Object(__WEBPACK_IMPORTED_MODULE_7__dom__["a" /* addClass */])([this.element], ['e-control', moduleClass]);
            this.isProtectedOnChange = false;
            if (this.needsID && !this.element.id) {
                this.element.id = this.getUniqueID(this.getModuleName());
            }
            if (this.enablePersistence) {
                this.mergePersistData();
                window.addEventListener('unload', this.setPersistData.bind(this));
            }
            var inst = Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])('ej2_instances', this.element);
            if (!inst || inst.indexOf(this) === -1) {
                _super.prototype.addInstance.call(this);
            }
            this.preRender();
            this.injectModules();
            this.render();
            if (!this.mount) {
                this.trigger('created');
            }
            else {
                this.accessMount();
            }
        }
    };
    /**
     * It is used to process the post rendering functionalities to a component.
     *
     * @param {Node} wrapperElement ?
     * @returns {void} ?
     */
    Component.prototype.renderComplete = function (wrapperElement) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["l" /* isBlazor */])()) {
            var sfBlazor = 'sfBlazor';
            // eslint-disable-next-line
            window[sfBlazor].renderComplete(this.element, wrapperElement);
        }
        this.isRendered = true;
    };
    /**
     * When invoked, applies the pending property changes immediately to the component.
     *
     * @returns {void} ?
     */
    Component.prototype.dataBind = function () {
        this.injectModules();
        _super.prototype.dataBind.call(this);
    };
    /**
     * Attach one or more  event handler to the current component context.
     * It is used for internal handling event internally within the component only.
     *
     * @param {BoundOptions[]| string} event - It is  optional type either to  Set the collection of event list or the eventName.
     * @param {Function} handler - optional parameter Specifies the handler to run when the event occurs
     * @param {Object} context - optional parameter Specifies the context to be bind in the handler.
     * @returns {void} ?
     * @private
     */
    Component.prototype.on = function (event, handler, context) {
        if (typeof event === 'string') {
            this.localObserver.on(event, handler, context);
        }
        else {
            for (var _i = 0, event_1 = event; _i < event_1.length; _i++) {
                var arg = event_1[_i];
                this.localObserver.on(arg.event, arg.handler, arg.context);
            }
        }
    };
    /**
     * To remove one or more event handler that has been attached with the on() method.
     *
     * @param {BoundOptions[]| string} event - It is  optional type either to  Set the collection of event list or the eventName.
     * @param {Function} handler - optional parameter Specifies the function to run when the event occurs
     * @returns {void} ?
     * @private
     */
    Component.prototype.off = function (event, handler) {
        if (typeof event === 'string') {
            this.localObserver.off(event, handler);
        }
        else {
            for (var _i = 0, event_2 = event; _i < event_2.length; _i++) {
                var arg = event_2[_i];
                this.localObserver.off(arg.event, arg.handler);
            }
        }
    };
    /**
     * To notify the handlers in the specified event.
     *
     * @param {string} property - Specifies the event to be notify.
     * @param {Object} argument - Additional parameters to pass while calling the handler.
     * @returns {void} ?
     * @private
     */
    Component.prototype.notify = function (property, argument) {
        if (this.isDestroyed !== true) {
            this.localObserver.notify(property, argument);
        }
    };
    /**
     * Get injected modules
     *
     * @returns {Function} ?
     * @private
     */
    Component.prototype.getInjectedModules = function () {
        return this.injectedModules;
    };
    /**
     * Dynamically injects the required modules to the component.
     *
     * @param {Function} moduleList ?
     * @returns {void} ?
     */
    Component.Inject = function () {
        var moduleList = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            moduleList[_i] = arguments[_i];
        }
        if (!this.prototype.injectedModules) {
            this.prototype.injectedModules = [];
        }
        for (var i = 0; i < moduleList.length; i++) {
            if (this.prototype.injectedModules.indexOf(moduleList[i]) === -1) {
                this.prototype.injectedModules.push(moduleList[i]);
            }
        }
    };
    /**
     * This is a instance method to create an element.
     *
     * @param {string} tagName ?
     * @param {ElementProperties} prop ?
     * @param {boolean} isVDOM ?
     * @returns {any} ?
     * @private
     */
    // eslint-disable-next-line
    Component.prototype.createElement = function (tagName, prop, isVDOM) {
        return Object(__WEBPACK_IMPORTED_MODULE_7__dom__["f" /* createElement */])(tagName, prop);
    };
    /**
     *
     * @param {Function} handler - handler to be triggered after state Updated.
     * @param {any} argument - Arguments to be passed to caller.
     * @returns {void} .
     * @private
     */
    // eslint-disable-next-line
    Component.prototype.triggerStateChange = function (handler, argument) {
        if (this.isReactHybrid) {
            // eslint-disable-next-line
            this.setState();
            this.currentContext = { calls: handler, args: argument };
        }
    };
    // tslint: enable: no-any
    Component.prototype.injectModules = function () {
        if (this.injectedModules && this.injectedModules.length) {
            this.moduleLoader.inject(this.requiredModules(), this.injectedModules);
        }
    };
    Component.prototype.detectFunction = function (args) {
        var prop = Object.keys(args);
        if (prop.length) {
            this[prop[0]] = args[prop[0]];
        }
    };
    Component.prototype.mergePersistData = function () {
        var data;
        if (versionBasedStatePersistence) {
            data = window.localStorage.getItem(this.getModuleName() + this.element.id + this.ej2StatePersistenceVersion);
        }
        else {
            data = window.localStorage.getItem(this.getModuleName() + this.element.id);
        }
        if (!(Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(data) || (data === ''))) {
            this.setProperties(JSON.parse(data), true);
        }
    };
    Component.prototype.setPersistData = function () {
        if (!this.isDestroyed) {
            if (versionBasedStatePersistence) {
                window.localStorage.setItem(this.getModuleName() +
                    this.element.id + this.ej2StatePersistenceVersion, this.getPersistData());
            }
            else {
                window.localStorage.setItem(this.getModuleName() + this.element.id, this.getPersistData());
            }
        }
    };
    //tslint:disable-next-line
    Component.prototype.renderReactTemplates = function () {
        //No Code
    };
    // eslint-disable-next-line
    Component.prototype.clearTemplate = function (templateName, index) {
        //No Code
    };
    Component.prototype.getUniqueID = function (definedName) {
        if (this.isHistoryChanged()) {
            componentCount = 0;
        }
        lastPageID = this.pageID(location.href);
        lastHistoryLen = history.length;
        return definedName + '_' + lastPageID + '_' + componentCount++;
    };
    Component.prototype.pageID = function (url) {
        var hash = 0;
        if (url.length === 0) {
            return hash;
        }
        for (var i = 0; i < url.length; i++) {
            var char = url.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return Math.abs(hash);
    };
    Component.prototype.isHistoryChanged = function () {
        return lastPageID !== this.pageID(location.href) || lastHistoryLen !== history.length;
    };
    Component.prototype.addOnPersist = function (options) {
        var _this = this;
        var persistObj = {};
        for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
            var key = options_1[_i];
            var objValue = void 0;
            // eslint-disable-next-line
            objValue = Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])(key, this);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["o" /* isUndefined */])(objValue)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__util__["r" /* setValue */])(key, this.getActualProperties(objValue), persistObj);
            }
        }
        return JSON.stringify(persistObj, function (key, value) {
            return _this.getActualProperties(value);
        });
    };
    Component.prototype.getActualProperties = function (obj) {
        if (obj instanceof __WEBPACK_IMPORTED_MODULE_4__child_property__["a" /* ChildProperty */]) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* getValue */])('properties', obj);
        }
        else {
            return obj;
        }
    };
    Component.prototype.ignoreOnPersist = function (options) {
        return JSON.stringify(this.iterateJsonProperties(this.properties, options));
    };
    Component.prototype.iterateJsonProperties = function (obj, ignoreList) {
        var newObj = {};
        var _loop_1 = function (key) {
            if (ignoreList.indexOf(key) === -1) {
                // eslint-disable-next-line
                var value = obj[key];
                if (typeof value === 'object' && !(value instanceof Array)) {
                    var newList = ignoreList.filter(function (str) {
                        return new RegExp(key + '.').test(str);
                    }).map(function (str) {
                        return str.replace(key + '.', '');
                    });
                    newObj[key] = this_1.iterateJsonProperties(this_1.getActualProperties(value), newList);
                }
                else {
                    newObj[key] = value;
                }
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
            var key = _a[_i];
            _loop_1(key);
        }
        return newObj;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_5__notify_property_change__["e" /* Property */])(false)
    ], Component.prototype, "enablePersistence", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_5__notify_property_change__["e" /* Property */])()
    ], Component.prototype, "enableRtl", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_5__notify_property_change__["e" /* Property */])()
    ], Component.prototype, "locale", void 0);
    Component = __decorate([
        __WEBPACK_IMPORTED_MODULE_5__notify_property_change__["d" /* NotifyPropertyChanges */]
    ], Component);
    return Component;
}(__WEBPACK_IMPORTED_MODULE_2__base__["a" /* Base */]));

//Function handling for page navigation detection
/* istanbul ignore next */
(function () {
    if (typeof window !== 'undefined') {
        window.addEventListener('popstate', 
        /* istanbul ignore next */
        function () {
            componentCount = 0;
        });
    }
})();


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Position */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Draggable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notify_property_change__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_handler__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__child_property__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var defaultPosition = { left: 0, top: 0, bottom: 0, right: 0 };
var positionProp = ['offsetLeft', 'offsetTop'];
var axisMapper = ['x', 'y'];
var axisValueMapper = ['left', 'top'];
var isDraggedObject = { isDragged: false };
/**
 * Specifies the position coordinates
 */
var Position = /** @class */ (function (_super) {
    __extends(Position, _super);
    function Position() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])(0)
    ], Position.prototype, "left", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])(0)
    ], Position.prototype, "top", void 0);
    return Position;
}(__WEBPACK_IMPORTED_MODULE_5__child_property__["a" /* ChildProperty */]));

/**
 * Draggable Module provides support to enable draggable functionality in Dom Elements.
 * ```html
 * <div id='drag'>Draggable</div>
 * <script>
 * var ele = document.getElementById('drag');
 * var drag:Draggable = new Draggable(ele,{
 *     clone:false,
 *     drag: function(e) {
 *      //drag handler code.
 *      },
 *     handle:'.class'
 * });
 * </script>
 * ```
 */
var Draggable = /** @class */ (function (_super) {
    __extends(Draggable, _super);
    function Draggable(element, options) {
        var _this = _super.call(this, options, element) || this;
        _this.dragLimit = Draggable_1.getDefaultPosition();
        _this.borderWidth = Draggable_1.getDefaultPosition();
        _this.padding = Draggable_1.getDefaultPosition();
        _this.diffX = 0;
        _this.prevLeft = 0;
        _this.prevTop = 0;
        _this.dragProcessStarted = false;
        /* tslint:disable no-any */
        _this.eleTop = 0;
        _this.tapHoldTimer = 0;
        _this.externalInitialize = false;
        _this.diffY = 0;
        _this.parentScrollX = 0;
        _this.parentScrollY = 0;
        _this.droppables = {};
        _this.bind();
        return _this;
    }
    Draggable_1 = Draggable;
    Draggable.prototype.bind = function () {
        this.toggleEvents();
        if (__WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].isIE) {
            Object(__WEBPACK_IMPORTED_MODULE_2__dom__["a" /* addClass */])([this.element], 'e-block-touch');
        }
        this.droppables[this.scope] = {};
    };
    Draggable.getDefaultPosition = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_6__util__["f" /* extend */])({}, defaultPosition);
    };
    Draggable.prototype.toggleEvents = function (isUnWire) {
        var ele;
        if (!Object(__WEBPACK_IMPORTED_MODULE_6__util__["o" /* isUndefined */])(this.handle)) {
            ele = Object(__WEBPACK_IMPORTED_MODULE_2__dom__["m" /* select */])(this.handle, this.element);
        }
        var handler = (this.enableTapHold && __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].isDevice && __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].isTouch) ? this.mobileInitialize : this.initialize;
        if (isUnWire) {
            __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].remove(ele || this.element, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchStartEvent, handler);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].add(ele || this.element, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchStartEvent, handler, this);
        }
    };
    /* istanbul ignore next */
    Draggable.prototype.mobileInitialize = function (evt) {
        var _this = this;
        var target = evt.currentTarget;
        this.tapHoldTimer = setTimeout(function () {
            _this.externalInitialize = true;
            _this.removeTapholdTimer();
            _this.initialize(evt, target);
        }, this.tapHoldThreshold);
        __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].add(document, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchMoveEvent, this.removeTapholdTimer, this);
        __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].add(document, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchEndEvent, this.removeTapholdTimer, this);
    };
    /* istanbul ignore next */
    Draggable.prototype.removeTapholdTimer = function () {
        clearTimeout(this.tapHoldTimer);
        __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].remove(document, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchMoveEvent, this.removeTapholdTimer);
        __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].remove(document, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchEndEvent, this.removeTapholdTimer);
    };
    /* istanbul ignore next */
    Draggable.prototype.getScrollableParent = function (element, axis) {
        var scroll = { 'vertical': 'scrollHeight', 'horizontal': 'scrollWidth' };
        var client = { 'vertical': 'clientHeight', 'horizontal': 'clientWidth' };
        if (Object(__WEBPACK_IMPORTED_MODULE_6__util__["m" /* isNullOrUndefined */])(element)) {
            return null;
        }
        if (element[scroll[axis]] > element[client[axis]]) {
            if (axis === 'vertical' ? element.scrollTop > 0 : element.scrollLeft > 0) {
                if (axis === 'vertical') {
                    this.parentScrollY = this.parentScrollY +
                        (this.parentScrollY === 0 ? element.scrollTop : element.scrollTop - this.parentScrollY);
                    this.tempScrollHeight = element.scrollHeight;
                }
                else {
                    this.parentScrollX = this.parentScrollX +
                        (this.parentScrollX === 0 ? element.scrollLeft : element.scrollLeft - this.parentScrollX);
                    this.tempScrollWidth = element.scrollWidth;
                }
                if (!Object(__WEBPACK_IMPORTED_MODULE_6__util__["m" /* isNullOrUndefined */])(element)) {
                    return this.getScrollableParent(element.parentNode, axis);
                }
                else {
                    return element;
                }
            }
            else {
                return this.getScrollableParent(element.parentNode, axis);
            }
        }
        else {
            return this.getScrollableParent(element.parentNode, axis);
        }
    };
    Draggable.prototype.getScrollableValues = function () {
        this.parentScrollX = 0;
        this.parentScrollY = 0;
        var isModalDialog = this.element.classList.contains('e-dialog') && this.element.classList.contains('e-dlg-modal');
        var verticalScrollParent = this.getScrollableParent(this.element.parentNode, 'vertical');
        var horizontalScrollParent = this.getScrollableParent(this.element.parentNode, 'horizontal');
    };
    Draggable.prototype.initialize = function (evt, curTarget) {
        this.currentStateTarget = evt.target;
        if (this.isDragStarted()) {
            return;
        }
        else {
            this.isDragStarted(true);
            this.externalInitialize = false;
        }
        this.target = (evt.currentTarget || curTarget);
        this.dragProcessStarted = false;
        if (this.abort) {
            /* tslint:disable no-any */
            var abortSelectors = this.abort;
            if (typeof abortSelectors === 'string') {
                abortSelectors = [abortSelectors];
            }
            for (var i = 0; i < abortSelectors.length; i++) {
                if (!Object(__WEBPACK_IMPORTED_MODULE_6__util__["m" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_2__dom__["e" /* closest */])(evt.target, abortSelectors[i]))) {
                    /* istanbul ignore next */
                    if (this.isDragStarted()) {
                        this.isDragStarted(true);
                    }
                    return;
                }
            }
        }
        if (this.preventDefault && !Object(__WEBPACK_IMPORTED_MODULE_6__util__["o" /* isUndefined */])(evt.changedTouches) && evt.type !== 'touchstart') {
            evt.preventDefault();
        }
        this.element.setAttribute('aria-grabbed', 'true');
        var intCoord = this.getCoordinates(evt);
        this.initialPosition = { x: intCoord.pageX, y: intCoord.pageY };
        if (!this.clone) {
            var pos = this.element.getBoundingClientRect();
            this.getScrollableValues();
            if (evt.clientX === evt.pageX) {
                this.parentScrollX = 0;
            }
            if (evt.clientY === evt.pageY) {
                this.parentScrollY = 0;
            }
            this.relativeXPosition = intCoord.pageX - (pos.left + this.parentScrollX);
            this.relativeYPosition = intCoord.pageY - (pos.top + this.parentScrollY);
        }
        if (this.externalInitialize) {
            this.intDragStart(evt);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].add(document, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchMoveEvent, this.intDragStart, this);
            __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].add(document, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchEndEvent, this.intDestroy, this);
        }
        this.toggleEvents(true);
        if (evt.type !== 'touchstart' && this.isPreventSelect) {
            document.body.classList.add('e-prevent-select');
        }
        this.externalInitialize = false;
        __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].trigger(document.documentElement, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchStartEvent, evt);
    };
    Draggable.prototype.intDragStart = function (evt) {
        this.removeTapholdTimer();
        var isChangeTouch = !Object(__WEBPACK_IMPORTED_MODULE_6__util__["o" /* isUndefined */])(evt.changedTouches);
        if (isChangeTouch && (evt.changedTouches.length !== 1)) {
            return;
        }
        if (isChangeTouch) {
            evt.preventDefault();
        }
        var intCordinate = this.getCoordinates(evt);
        var pos;
        var styleProp = getComputedStyle(this.element);
        this.margin = {
            left: parseInt(styleProp.marginLeft, 10),
            top: parseInt(styleProp.marginTop, 10),
            right: parseInt(styleProp.marginRight, 10),
            bottom: parseInt(styleProp.marginBottom, 10),
        };
        var element = this.element;
        if (this.clone && this.dragTarget) {
            var intClosest = Object(__WEBPACK_IMPORTED_MODULE_2__dom__["e" /* closest */])(evt.target, this.dragTarget);
            if (!Object(__WEBPACK_IMPORTED_MODULE_6__util__["m" /* isNullOrUndefined */])(intClosest)) {
                element = intClosest;
            }
        }
        /* istanbul ignore next */
        if (this.isReplaceDragEle) {
            element = this.currentStateCheck(evt.target, element);
        }
        this.offset = this.calculateParentPosition(element);
        this.position = this.getMousePosition(evt, this.isDragScroll);
        var x = this.initialPosition.x - intCordinate.pageX;
        var y = this.initialPosition.y - intCordinate.pageY;
        var distance = Math.sqrt((x * x) + (y * y));
        if ((distance >= this.distance || this.externalInitialize)) {
            var ele = this.getHelperElement(evt);
            if (!ele || Object(__WEBPACK_IMPORTED_MODULE_6__util__["m" /* isNullOrUndefined */])(ele)) {
                return;
            }
            var dragTargetElement = this.helperElement = ele;
            this.parentClientRect = this.calculateParentPosition(dragTargetElement.offsetParent);
            if (this.dragStart) {
                var curTarget = this.getProperTargetElement(evt);
                var args = {
                    event: evt,
                    element: element,
                    target: curTarget,
                    bindEvents: Object(__WEBPACK_IMPORTED_MODULE_6__util__["l" /* isBlazor */])() ? this.bindDragEvents.bind(this) : null,
                    dragElement: dragTargetElement
                };
                this.trigger('dragStart', args);
            }
            if (this.dragArea) {
                this.setDragArea();
            }
            else {
                this.dragLimit = { left: 0, right: 0, bottom: 0, top: 0 };
                this.borderWidth = { top: 0, left: 0 };
            }
            pos = { left: this.position.left - this.parentClientRect.left, top: this.position.top - this.parentClientRect.top };
            if (this.clone && !this.enableTailMode) {
                this.diffX = this.position.left - this.offset.left;
                this.diffY = this.position.top - this.offset.top;
            }
            this.getScrollableValues();
            // when drag element has margin-top
            var styles = getComputedStyle(element);
            var marginTop = parseFloat(styles.marginTop);
            /* istanbul ignore next */
            if (this.clone && marginTop !== 0) {
                pos.top += marginTop;
            }
            this.eleTop = !isNaN(parseFloat(styles.top)) ? parseFloat(styles.top) - this.offset.top : 0;
            /* istanbul ignore next */
            // if (this.eleTop > 0) {
            //     pos.top += this.eleTop;
            // }
            if (this.enableScrollHandler && !this.clone) {
                pos.top -= this.parentScrollY;
                pos.left -= this.parentScrollX;
            }
            var posValue = this.getProcessedPositionValue({
                top: (pos.top - this.diffY) + 'px',
                left: (pos.left - this.diffX) + 'px'
            });
            this.dragElePosition = { top: pos.top, left: pos.left };
            Object(__WEBPACK_IMPORTED_MODULE_2__dom__["o" /* setStyleAttribute */])(dragTargetElement, this.getDragPosition({ position: 'absolute', left: posValue.left, top: posValue.top }));
            __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].remove(document, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchMoveEvent, this.intDragStart);
            __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].remove(document, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchEndEvent, this.intDestroy);
            if (!Object(__WEBPACK_IMPORTED_MODULE_6__util__["l" /* isBlazor */])()) {
                this.bindDragEvents(dragTargetElement);
            }
        }
    };
    Draggable.prototype.bindDragEvents = function (dragTargetElement) {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__dom__["h" /* isVisible */])(dragTargetElement)) {
            __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].add(document, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchMoveEvent, this.intDrag, this);
            __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].add(document, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchEndEvent, this.intDragStop, this);
            this.setGlobalDroppables(false, this.element, dragTargetElement);
        }
        else {
            this.toggleEvents();
            document.body.classList.remove('e-prevent-select');
        }
    };
    Draggable.prototype.elementInViewport = function (el) {
        this.top = el.offsetTop;
        this.left = el.offsetLeft;
        this.width = el.offsetWidth;
        this.height = el.offsetHeight;
        while (el.offsetParent) {
            el = el.offsetParent;
            this.top += el.offsetTop;
            this.left += el.offsetLeft;
        }
        return (this.top >= window.pageYOffset &&
            this.left >= window.pageXOffset &&
            (this.top + this.height) <= (window.pageYOffset + window.innerHeight) &&
            (this.left + this.width) <= (window.pageXOffset + window.innerWidth));
    };
    Draggable.prototype.getProcessedPositionValue = function (value) {
        if (this.queryPositionInfo) {
            return this.queryPositionInfo(value);
        }
        return value;
    };
    Draggable.prototype.calculateParentPosition = function (ele) {
        if (Object(__WEBPACK_IMPORTED_MODULE_6__util__["m" /* isNullOrUndefined */])(ele)) {
            return { left: 0, top: 0 };
        }
        var rect = ele.getBoundingClientRect();
        var style = getComputedStyle(ele);
        return {
            left: (rect.left + window.pageXOffset) - parseInt(style.marginLeft, 10),
            top: (rect.top + window.pageYOffset) - parseInt(style.marginTop, 10)
        };
    };
    // tslint:disable-next-line:max-func-body-length
    Draggable.prototype.intDrag = function (evt) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_6__util__["o" /* isUndefined */])(evt.changedTouches) && (evt.changedTouches.length !== 1)) {
            return;
        }
        if (this.clone && evt.changedTouches && __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].isDevice && __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].isTouch) {
            evt.preventDefault();
        }
        var left;
        var top;
        this.position = this.getMousePosition(evt, this.isDragScroll);
        var docHeight = this.getDocumentWidthHeight('Height');
        if (docHeight < this.position.top) {
            this.position.top = docHeight;
        }
        var docWidth = this.getDocumentWidthHeight('Width');
        if (docWidth < this.position.left) {
            this.position.left = docWidth;
        }
        if (this.drag) {
            var curTarget = this.getProperTargetElement(evt);
            this.trigger('drag', { event: evt, element: this.element, target: curTarget });
        }
        var eleObj = this.checkTargetElement(evt);
        if (eleObj.target && eleObj.instance) {
            /* tslint:disable no-any */
            var flag = true;
            if (this.hoverObject) {
                if (this.hoverObject.instance !== eleObj.instance) {
                    this.triggerOutFunction(evt, eleObj);
                }
                else {
                    flag = false;
                }
            }
            if (flag) {
                eleObj.instance.dragData[this.scope] = this.droppables[this.scope];
                eleObj.instance.intOver(evt, eleObj.target);
                this.hoverObject = eleObj;
            }
        }
        else if (this.hoverObject) {
            this.triggerOutFunction(evt, eleObj);
        }
        var helperElement = this.droppables[this.scope].helper;
        this.parentClientRect = this.calculateParentPosition(this.helperElement.offsetParent);
        var tLeft = this.parentClientRect.left;
        var tTop = this.parentClientRect.top;
        var intCoord = this.getCoordinates(evt);
        var pagex = intCoord.pageX;
        var pagey = intCoord.pageY;
        var dLeft = this.position.left - this.diffX;
        var dTop = this.position.top - this.diffY;
        var styles = getComputedStyle(helperElement);
        if (this.dragArea) {
            if (this.pageX !== pagex || this.skipDistanceCheck) {
                var helperWidth = helperElement.offsetWidth + (parseFloat(styles.marginLeft)
                    + parseFloat(styles.marginRight));
                if (this.dragLimit.left > dLeft && dLeft > 0) {
                    left = this.dragLimit.left;
                }
                else if (this.dragLimit.right + window.pageXOffset < dLeft + helperWidth && dLeft > 0) {
                    left = dLeft - (dLeft - this.dragLimit.right) + window.pageXOffset - helperWidth;
                }
                else {
                    left = dLeft < 0 ? this.dragLimit.left : dLeft;
                }
            }
            if (this.pageY !== pagey || this.skipDistanceCheck) {
                var helperHeight = helperElement.offsetHeight + (parseFloat(styles.marginTop)
                    + parseFloat(styles.marginBottom));
                if (this.dragLimit.top > dTop && dTop > 0) {
                    top = this.dragLimit.top;
                }
                else if (this.dragLimit.bottom + window.pageYOffset < dTop + helperHeight && dTop > 0) {
                    top = dTop - (dTop - this.dragLimit.bottom) + window.pageYOffset - helperHeight;
                }
                else {
                    top = dTop < 0 ? this.dragLimit.top : dTop;
                }
            }
        }
        else {
            left = dLeft;
            top = dTop;
        }
        var iTop = tTop + this.borderWidth.top;
        var iLeft = tLeft + this.borderWidth.left;
        if (this.dragProcessStarted) {
            if (Object(__WEBPACK_IMPORTED_MODULE_6__util__["m" /* isNullOrUndefined */])(top)) {
                top = this.prevTop;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_6__util__["m" /* isNullOrUndefined */])(left)) {
                left = this.prevLeft;
            }
        }
        var draEleTop;
        var draEleLeft;
        if (this.dragArea) {
            this.dragLimit.top = this.clone ? this.dragLimit.top : 0;
            draEleTop = (top - iTop) < 0 ? this.dragLimit.top : (top - iTop);
            draEleLeft = (left - iLeft) < 0 ? this.dragElePosition.left : (left - iLeft);
        }
        else {
            draEleTop = top - iTop;
            draEleLeft = left - iLeft;
        }
        var marginTop = parseFloat(getComputedStyle(this.element).marginTop);
        // when drag-element has margin-top
        /* istanbul ignore next */
        if (marginTop > 0) {
            if (this.clone) {
                draEleTop += marginTop;
                if (dTop < 0) {
                    if ((marginTop + dTop) >= 0) {
                        draEleTop = marginTop + dTop;
                    }
                    else {
                        draEleTop -= marginTop;
                    }
                }
                draEleTop = (this.dragLimit.bottom < draEleTop) ? this.dragLimit.bottom : draEleTop;
            }
            if ((top - iTop) < 0) {
                if (dTop + marginTop + (helperElement.offsetHeight - iTop) >= 0) {
                    var tempDraEleTop = this.dragLimit.top + dTop - iTop;
                    if ((tempDraEleTop + marginTop + iTop) < 0) {
                        draEleTop -= marginTop + iTop;
                    }
                    else {
                        draEleTop = tempDraEleTop;
                    }
                }
                else {
                    draEleTop -= marginTop + iTop;
                }
            }
        }
        /* istanbul ignore next */
        // if(this.eleTop > 0) {
        //      draEleTop += this.eleTop;
        // }
        if (this.enableScrollHandler && !this.clone) {
            draEleTop -= this.parentScrollY;
            draEleLeft -= this.parentScrollX;
        }
        var dragValue = this.getProcessedPositionValue({ top: draEleTop + 'px', left: draEleLeft + 'px' });
        Object(__WEBPACK_IMPORTED_MODULE_2__dom__["o" /* setStyleAttribute */])(helperElement, this.getDragPosition(dragValue));
        if (!this.elementInViewport(helperElement) && this.enableAutoScroll) {
            this.helperElement.scrollIntoView();
        }
        this.dragProcessStarted = true;
        this.prevLeft = left;
        this.prevTop = top;
        this.position.left = left;
        this.position.top = top;
        this.pageX = pagex;
        this.pageY = pagey;
    };
    Draggable.prototype.triggerOutFunction = function (evt, eleObj) {
        this.hoverObject.instance.intOut(evt, eleObj.target);
        this.hoverObject.instance.dragData[this.scope] = null;
        this.hoverObject = null;
    };
    Draggable.prototype.getDragPosition = function (dragValue) {
        var temp = Object(__WEBPACK_IMPORTED_MODULE_6__util__["f" /* extend */])({}, dragValue);
        if (this.axis) {
            if (this.axis === 'x') {
                delete temp.top;
            }
            else if (this.axis === 'y') {
                delete temp.left;
            }
        }
        return temp;
    };
    Draggable.prototype.getDocumentWidthHeight = function (str) {
        var docBody = document.body;
        var docEle = document.documentElement;
        var returnValue = Math.max(docBody['scroll' + str], docEle['scroll' + str], docBody['offset' + str], docEle['offset' + str], docEle['client' + str]);
        return returnValue;
    };
    Draggable.prototype.intDragStop = function (evt) {
        this.dragProcessStarted = false;
        if (!Object(__WEBPACK_IMPORTED_MODULE_6__util__["o" /* isUndefined */])(evt.changedTouches) && (evt.changedTouches.length !== 1)) {
            return;
        }
        var type = ['touchend', 'pointerup', 'mouseup'];
        if (type.indexOf(evt.type) !== -1) {
            if (this.dragStop) {
                var curTarget = this.getProperTargetElement(evt);
                this.trigger('dragStop', { event: evt, element: this.element, target: curTarget, helper: this.helperElement });
            }
            this.intDestroy(evt);
        }
        else {
            this.element.setAttribute('aria-grabbed', 'false');
        }
        var eleObj = this.checkTargetElement(evt);
        if (eleObj.target && eleObj.instance) {
            eleObj.instance.dragStopCalled = true;
            eleObj.instance.dragData[this.scope] = this.droppables[this.scope];
            eleObj.instance.intDrop(evt, eleObj.target);
        }
        this.setGlobalDroppables(true);
        document.body.classList.remove('e-prevent-select');
    };
    /**
     * @private
     */
    Draggable.prototype.intDestroy = function (evt) {
        this.dragProcessStarted = false;
        this.toggleEvents();
        document.body.classList.remove('e-prevent-select');
        this.element.setAttribute('aria-grabbed', 'false');
        __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].remove(document, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchMoveEvent, this.intDragStart);
        __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].remove(document, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchEndEvent, this.intDragStop);
        __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].remove(document, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchEndEvent, this.intDestroy);
        __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].remove(document, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchMoveEvent, this.intDrag);
        if (this.isDragStarted()) {
            this.isDragStarted(true);
        }
    };
    // triggers when property changed
    Draggable.prototype.onPropertyChanged = function (newProp, oldProp) {
        //No Code to handle
    };
    Draggable.prototype.getModuleName = function () {
        return 'draggable';
    };
    Draggable.prototype.isDragStarted = function (change) {
        if (change) {
            isDraggedObject.isDragged = !isDraggedObject.isDragged;
        }
        return isDraggedObject.isDragged;
    };
    Draggable.prototype.setDragArea = function () {
        var eleWidthBound;
        var eleHeightBound;
        var top = 0;
        var left = 0;
        var ele;
        var type = typeof this.dragArea;
        if (type === 'string') {
            ele = Object(__WEBPACK_IMPORTED_MODULE_2__dom__["m" /* select */])(this.dragArea);
        }
        else {
            ele = this.dragArea;
        }
        if (ele) {
            var elementArea = ele.getBoundingClientRect();
            eleWidthBound = ele.scrollWidth ? ele.scrollWidth : elementArea.right - elementArea.left;
            eleHeightBound = ele.scrollHeight ? ele.scrollHeight : elementArea.bottom - elementArea.top;
            var keys = ['Top', 'Left', 'Bottom', 'Right'];
            var styles = getComputedStyle(ele);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var tborder = styles['border' + key + 'Width'];
                var tpadding = styles['padding' + key];
                var lowerKey = key.toLowerCase();
                this.borderWidth[lowerKey] = isNaN(parseFloat(tborder)) ? 0 : parseFloat(tborder);
                this.padding[lowerKey] = isNaN(parseFloat(tpadding)) ? 0 : parseFloat(tpadding);
            }
            top = elementArea.top;
            left = elementArea.left;
            this.dragLimit.left = left + this.borderWidth.left + this.padding.left;
            this.dragLimit.top = ele.offsetTop + this.borderWidth.top + this.padding.top;
            this.dragLimit.right = left + eleWidthBound - (this.borderWidth.right + this.padding.right);
            this.dragLimit.bottom = top + eleHeightBound - (this.borderWidth.bottom + this.padding.bottom);
        }
    };
    Draggable.prototype.getProperTargetElement = function (evt) {
        var intCoord = this.getCoordinates(evt);
        var ele;
        var prevStyle = this.helperElement.style.pointerEvents || '';
        if (Object(__WEBPACK_IMPORTED_MODULE_6__util__["a" /* compareElementParent */])(evt.target, this.helperElement) || evt.type.indexOf('touch') !== -1) {
            this.helperElement.style.pointerEvents = 'none';
            ele = document.elementFromPoint(intCoord.clientX, intCoord.clientY);
            this.helperElement.style.pointerEvents = prevStyle;
        }
        else {
            ele = evt.target;
        }
        return ele;
    };
    /* istanbul ignore next */
    Draggable.prototype.currentStateCheck = function (ele, oldEle) {
        var elem;
        if (!Object(__WEBPACK_IMPORTED_MODULE_6__util__["m" /* isNullOrUndefined */])(this.currentStateTarget) && this.currentStateTarget !== ele) {
            elem = this.currentStateTarget;
        }
        else {
            elem = !Object(__WEBPACK_IMPORTED_MODULE_6__util__["m" /* isNullOrUndefined */])(oldEle) ? oldEle : ele;
        }
        return elem;
    };
    Draggable.prototype.getMousePosition = function (evt, isdragscroll) {
        /* tslint:disable no-any */
        var dragEle = evt.srcElement !== undefined ? evt.srcElement : evt.target;
        var intCoord = this.getCoordinates(evt);
        var pageX;
        var pageY;
        var isOffsetParent = Object(__WEBPACK_IMPORTED_MODULE_6__util__["m" /* isNullOrUndefined */])(dragEle.offsetParent);
        /* istanbul ignore next */
        if (isdragscroll) {
            pageX = this.clone ? intCoord.pageX :
                (intCoord.pageX + (isOffsetParent ? 0 : dragEle.offsetParent.scrollLeft)) - this.relativeXPosition;
            pageY = this.clone ? intCoord.pageY :
                (intCoord.pageY + (isOffsetParent ? 0 : dragEle.offsetParent.scrollTop)) - this.relativeYPosition;
        }
        else {
            pageX = this.clone ? intCoord.pageX : (intCoord.pageX + window.pageXOffset) - this.relativeXPosition;
            pageY = this.clone ? intCoord.pageY : (intCoord.pageY + window.pageYOffset) - this.relativeYPosition;
        }
        return {
            left: pageX - (this.margin.left + this.cursorAt.left),
            top: pageY - (this.margin.top + this.cursorAt.top)
        };
    };
    Draggable.prototype.getCoordinates = function (evt) {
        if (evt.type.indexOf('touch') > -1) {
            return evt.changedTouches[0];
        }
        return evt;
    };
    Draggable.prototype.getHelperElement = function (evt) {
        var element;
        if (this.clone) {
            if (this.helper) {
                element = this.helper({ sender: evt, element: this.target });
            }
            else {
                element = Object(__WEBPACK_IMPORTED_MODULE_2__dom__["f" /* createElement */])('div', { className: 'e-drag-helper e-block-touch', innerHTML: 'Draggable' });
                document.body.appendChild(element);
            }
        }
        else {
            element = this.element;
        }
        return element;
    };
    Draggable.prototype.setGlobalDroppables = function (reset, drag, helper) {
        this.droppables[this.scope] = reset ? null : {
            draggable: drag,
            helper: helper,
            draggedElement: this.element
        };
    };
    Draggable.prototype.checkTargetElement = function (evt) {
        var target = this.getProperTargetElement(evt);
        var dropIns = this.getDropInstance(target);
        if (!dropIns && target && !Object(__WEBPACK_IMPORTED_MODULE_6__util__["m" /* isNullOrUndefined */])(target.parentNode)) {
            var parent_1 = Object(__WEBPACK_IMPORTED_MODULE_2__dom__["e" /* closest */])(target.parentNode, '.e-droppable') || target.parentElement;
            if (parent_1) {
                dropIns = this.getDropInstance(parent_1);
            }
        }
        return { target: target, instance: dropIns };
    };
    Draggable.prototype.getDropInstance = function (ele) {
        var name = 'getModuleName';
        var drop;
        var eleInst = ele && ele.ej2_instances;
        if (eleInst) {
            for (var _i = 0, eleInst_1 = eleInst; _i < eleInst_1.length; _i++) {
                var inst = eleInst_1[_i];
                if (inst[name]() === 'droppable') {
                    drop = inst;
                    break;
                }
            }
        }
        return drop;
    };
    Draggable.prototype.destroy = function () {
        this.toggleEvents(true);
        _super.prototype.destroy.call(this);
    };
    var Draggable_1;
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["b" /* Complex */])({}, Position)
    ], Draggable.prototype, "cursorAt", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])(true)
    ], Draggable.prototype, "clone", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])()
    ], Draggable.prototype, "dragArea", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])()
    ], Draggable.prototype, "isDragScroll", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])()
    ], Draggable.prototype, "isReplaceDragEle", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])(true)
    ], Draggable.prototype, "isPreventSelect", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["c" /* Event */])()
    ], Draggable.prototype, "drag", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["c" /* Event */])()
    ], Draggable.prototype, "dragStart", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["c" /* Event */])()
    ], Draggable.prototype, "dragStop", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])(1)
    ], Draggable.prototype, "distance", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])()
    ], Draggable.prototype, "handle", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])()
    ], Draggable.prototype, "abort", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])()
    ], Draggable.prototype, "helper", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])('default')
    ], Draggable.prototype, "scope", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])('')
    ], Draggable.prototype, "dragTarget", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])()
    ], Draggable.prototype, "axis", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])()
    ], Draggable.prototype, "queryPositionInfo", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])(false)
    ], Draggable.prototype, "enableTailMode", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])(false)
    ], Draggable.prototype, "skipDistanceCheck", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])(true)
    ], Draggable.prototype, "preventDefault", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])(false)
    ], Draggable.prototype, "enableAutoScroll", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])(false)
    ], Draggable.prototype, "enableTapHold", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])(750)
    ], Draggable.prototype, "tapHoldThreshold", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])(false)
    ], Draggable.prototype, "enableScrollHandler", void 0);
    Draggable = Draggable_1 = __decorate([
        __WEBPACK_IMPORTED_MODULE_3__notify_property_change__["d" /* NotifyPropertyChanges */]
    ], Draggable);
    return Draggable;
}(__WEBPACK_IMPORTED_MODULE_0__base__["a" /* Base */]));



/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Droppable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notify_property_change__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_handler__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






/**
 * Droppable Module provides support to enable droppable functionality in Dom Elements.
 * ```html
 * <div id='drop'>Droppable</div>
 * <script>
 * let ele:HTMLElement = document.getElementById('drop');
 * var drag:Droppable = new Droppable(ele,{
 *     accept:'.drop',
 *     drop: function(e) {
 *      //drop handler code.
 *     }
 * });
 * </script>
 * ```
 */
var Droppable = /** @class */ (function (_super) {
    __extends(Droppable, _super);
    function Droppable(element, options) {
        var _this = _super.call(this, options, element) || this;
        _this.mouseOver = false;
        _this.dragData = {};
        _this.dragStopCalled = false;
        _this.bind();
        return _this;
    }
    Droppable.prototype.bind = function () {
        this.wireEvents();
    };
    Droppable.prototype.wireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].add(this.element, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchEndEvent, this.intDrop, this);
    };
    // triggers when property changed
    // eslint-disable-next-line
    Droppable.prototype.onPropertyChanged = function (newProp, oldProp) {
        //No Code to handle
    };
    Droppable.prototype.getModuleName = function () {
        return 'droppable';
    };
    Droppable.prototype.intOver = function (event, element) {
        if (!this.mouseOver) {
            var drag = this.dragData[this.scope];
            this.trigger('over', { event: event, target: element, dragData: drag });
            this.mouseOver = true;
        }
    };
    Droppable.prototype.intOut = function (event, element) {
        if (this.mouseOver) {
            this.trigger('out', { evt: event, target: element });
            this.mouseOver = false;
        }
    };
    Droppable.prototype.intDrop = function (evt, element) {
        if (!this.dragStopCalled) {
            return;
        }
        else {
            this.dragStopCalled = false;
        }
        var accept = true;
        var drag = this.dragData[this.scope];
        var isDrag = drag ? (drag.helper && Object(__WEBPACK_IMPORTED_MODULE_2__dom__["h" /* isVisible */])(drag.helper)) : false;
        var area;
        if (isDrag) {
            area = this.isDropArea(evt, drag.helper, element);
            if (this.accept) {
                accept = Object(__WEBPACK_IMPORTED_MODULE_2__dom__["i" /* matches */])(drag.helper, this.accept);
            }
        }
        if (isDrag && this.drop && area.canDrop && accept) {
            this.trigger('drop', { event: evt, target: area.target, droppedElement: drag.helper, dragData: drag });
        }
        this.mouseOver = false;
    };
    Droppable.prototype.isDropArea = function (evt, helper, element) {
        var area = { canDrop: true, target: element || evt.target };
        var isTouch = evt.type === 'touchend';
        if (isTouch || area.target === helper) {
            helper.style.display = 'none';
            var coord = isTouch ? (evt.changedTouches[0]) : evt;
            var ele = document.elementFromPoint(coord.clientX, coord.clientY);
            area.canDrop = false;
            area.canDrop = Object(__WEBPACK_IMPORTED_MODULE_5__util__["a" /* compareElementParent */])(ele, this.element);
            if (area.canDrop) {
                area.target = ele;
            }
            helper.style.display = '';
        }
        return area;
    };
    Droppable.prototype.destroy = function () {
        __WEBPACK_IMPORTED_MODULE_4__event_handler__["a" /* EventHandler */].remove(this.element, __WEBPACK_IMPORTED_MODULE_1__browser__["a" /* Browser */].touchEndEvent, this.intDrop);
        _super.prototype.destroy.call(this);
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])()
    ], Droppable.prototype, "accept", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["e" /* Property */])('default')
    ], Droppable.prototype, "scope", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["c" /* Event */])()
    ], Droppable.prototype, "drop", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["c" /* Event */])()
    ], Droppable.prototype, "over", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3__notify_property_change__["c" /* Event */])()
    ], Droppable.prototype, "out", void 0);
    Droppable = __decorate([
        __WEBPACK_IMPORTED_MODULE_3__notify_property_change__["d" /* NotifyPropertyChanges */]
    ], Droppable);
    return Droppable;
}(__WEBPACK_IMPORTED_MODULE_0__base__["a" /* Base */]));



/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeyboardEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notify_property_change__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var keyCode = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'control': 17,
    'alt': 18,
    'pause': 19,
    'capslock': 20,
    'space': 32,
    'escape': 27,
    'pageup': 33,
    'pagedown': 34,
    'end': 35,
    'home': 36,
    'leftarrow': 37,
    'uparrow': 38,
    'rightarrow': 39,
    'downarrow': 40,
    'insert': 45,
    'delete': 46,
    'f1': 112,
    'f2': 113,
    'f3': 114,
    'f4': 115,
    'f5': 116,
    'f6': 117,
    'f7': 118,
    'f8': 119,
    'f9': 120,
    'f10': 121,
    'f11': 122,
    'f12': 123,
    'semicolon': 186,
    'plus': 187,
    'comma': 188,
    'minus': 189,
    'dot': 190,
    'forwardslash': 191,
    'graveaccent': 192,
    'openbracket': 219,
    'backslash': 220,
    'closebracket': 221,
    'singlequote': 222
};
/**
 * KeyboardEvents class enables you to bind key action desired key combinations for ex., Ctrl+A, Delete, Alt+Space etc.
 * ```html
 * <div id='testEle'>  </div>;
 * <script>
 *   let node: HTMLElement = document.querySelector('#testEle');
 *   let kbInstance = new KeyboardEvents({
 *       element: node,
 *       keyConfigs:{ selectAll : 'ctrl+a' },
 *       keyAction: function (e:KeyboardEvent, action:string) {
 *           // handler function code
 *       }
 *   });
 * </script>
 * ```
 */
var KeyboardEvents = /** @class */ (function (_super) {
    __extends(KeyboardEvents, _super);
    /**
     * Initializes the KeyboardEvents
     *
     * @param {HTMLElement} element ?
     * @param {KeyboardEventsModel} options ?
     */
    function KeyboardEvents(element, options) {
        var _this = _super.call(this, options, element) || this;
        /**
         * To handle a key press event returns null
         *
         * @param {KeyboardEventArgs} e ?
         * @returns {void} ?
         */
        _this.keyPressHandler = function (e) {
            var isAltKey = e.altKey;
            var isCtrlKey = e.ctrlKey;
            var isShiftKey = e.shiftKey;
            var curkeyCode = e.which;
            var keys = Object.keys(_this.keyConfigs);
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var key = keys_1[_i];
                var configCollection = _this.keyConfigs[key].split(',');
                for (var _a = 0, configCollection_1 = configCollection; _a < configCollection_1.length; _a++) {
                    var rconfig = configCollection_1[_a];
                    var rKeyObj = KeyboardEvents_1.getKeyConfigData(rconfig.trim());
                    if (isAltKey === rKeyObj.altKey && isCtrlKey === rKeyObj.ctrlKey &&
                        isShiftKey === rKeyObj.shiftKey && curkeyCode === rKeyObj.keyCode) {
                        e.action = key;
                        if (_this.keyAction) {
                            _this.keyAction(e);
                        }
                    }
                }
            }
        };
        _this.bind();
        return _this;
    }
    KeyboardEvents_1 = KeyboardEvents;
    /**
     * Unwire bound events and destroy the instance.
     *
     * @returns {void} ?
     */
    KeyboardEvents.prototype.destroy = function () {
        this.unwireEvents();
        _super.prototype.destroy.call(this);
    };
    /**
     * Function can be used to specify certain action if a property is changed
     *
     * @param {KeyboardEventsModel} newProp ?
     * @param {KeyboardEventsModel} oldProp ?
     * @returns {void} ?
     * @private
     */
    // eslint-disable-next-line
    KeyboardEvents.prototype.onPropertyChanged = function (newProp, oldProp) {
        // No code are needed
    };
    KeyboardEvents.prototype.bind = function () {
        this.wireEvents();
    };
    /**
     * To get the module name, returns 'keyboard'.
     *
     * @returns {string} ?
     * @private
     */
    KeyboardEvents.prototype.getModuleName = function () {
        return 'keyboard';
    };
    /**
     * Wiring event handlers to events
     *
     * @returns {void} ?
     * @private
     */
    KeyboardEvents.prototype.wireEvents = function () {
        this.element.addEventListener(this.eventName, this.keyPressHandler);
    };
    /**
     * Unwiring event handlers to events
     *
     * @returns {void} ?
     * @private
     */
    KeyboardEvents.prototype.unwireEvents = function () {
        this.element.removeEventListener(this.eventName, this.keyPressHandler);
    };
    /**
     * To get the key configuration data
     *
     * @param {string} config - configuration data
     * @returns {KeyData} ?
     */
    KeyboardEvents.getKeyConfigData = function (config) {
        if (config in this.configCache) {
            return this.configCache[config];
        }
        var keys = config.toLowerCase().split('+');
        var keyData = {
            altKey: (keys.indexOf('alt') !== -1 ? true : false),
            ctrlKey: (keys.indexOf('ctrl') !== -1 ? true : false),
            shiftKey: (keys.indexOf('shift') !== -1 ? true : false),
            keyCode: null
        };
        if (keys[keys.length - 1].length > 1 && !!Number(keys[keys.length - 1])) {
            keyData.keyCode = Number(keys[keys.length - 1]);
        }
        else {
            keyData.keyCode = KeyboardEvents_1.getKeyCode(keys[keys.length - 1]);
        }
        KeyboardEvents_1.configCache[config] = keyData;
        return keyData;
    };
    // Return the keycode value as string
    KeyboardEvents.getKeyCode = function (keyVal) {
        return keyCode[keyVal] || keyVal.toUpperCase().charCodeAt(0);
    };
    var KeyboardEvents_1;
    KeyboardEvents.configCache = {};
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__notify_property_change__["e" /* Property */])({})
    ], KeyboardEvents.prototype, "keyConfigs", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__notify_property_change__["e" /* Property */])('keyup')
    ], KeyboardEvents.prototype, "eventName", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__notify_property_change__["c" /* Event */])()
    ], KeyboardEvents.prototype, "keyAction", void 0);
    KeyboardEvents = KeyboardEvents_1 = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__notify_property_change__["d" /* NotifyPropertyChanges */]
    ], KeyboardEvents);
    return KeyboardEvents;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* Base */]));



/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return L10n; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internationalization__ = __webpack_require__(19);


/**
 * L10n modules provides localized text for different culture.
 * ```typescript
 * import {setCulture} from '@syncfusion/ts-base-library';
 * //load global locale object common for all components.
 * L10n.load({
 *    'fr-BE': {
 *       'button': {
 *            'check': 'vérifié'
 *        }
 *    }
 * });
 * //set globale default locale culture.
 * setCulture('fr-BE');
 * let instance: L10n = new L10n('button', {
 *    check: 'checked'
 * });
 * //Get locale text for current property.
 * instance.getConstant('check');
 * //Change locale culture in a component.
 * instance.setLocale('en-US');
 * ```
 */
var L10n = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param {string} controlName ?
     * @param {Object} localeStrings ?
     * @param {string} locale ?
     */
    function L10n(controlName, localeStrings, locale) {
        this.controlName = controlName;
        this.localeStrings = localeStrings;
        this.setLocale(locale || __WEBPACK_IMPORTED_MODULE_1__internationalization__["b" /* defaultCulture */]);
    }
    /**
     * Sets the locale text
     *
     * @param {string} locale ?
     * @returns {void} ?
     */
    L10n.prototype.setLocale = function (locale) {
        var intLocale = this.intGetControlConstant(L10n.locale, locale);
        this.currentLocale = intLocale || this.localeStrings;
    };
    /**
     * Sets the global locale for all components.
     *
     * @param {Object} localeObject - specifies the localeObject to be set as global locale.
     * @returns {void} ?
     */
    L10n.load = function (localeObject) {
        this.locale = Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])(this.locale, localeObject, {}, true);
    };
    /**
     * Returns current locale text for the property based on the culture name and control name.
     *
     * @param {string} prop - specifies the property for which localize text to be returned.
     * @returns {string} ?
     */
    L10n.prototype.getConstant = function (prop) {
        // Removed conditional operator because this method does not return correct value when passing 0 as value in localization
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* isNullOrUndefined */])(this.currentLocale[prop])) {
            return this.currentLocale[prop];
        }
        else {
            return this.localeStrings[prop] || '';
        }
    };
    /**
     * Returns the control constant object for current object and the locale specified.
     *
     * @param {Object} curObject ?
     * @param {string} locale ?
     * @returns {Object} ?
     */
    L10n.prototype.intGetControlConstant = function (curObject, locale) {
        if ((curObject)[locale]) {
            return (curObject)[locale][this.controlName];
        }
        return null;
    };
    L10n.locale = {};
    return L10n;
}());



/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SwipeSettings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Touch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notify_property_change__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__child_property__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_handler__ = __webpack_require__(15);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






/**
 * SwipeSettings is a framework module that provides support to handle swipe event like swipe up, swipe right, etc..,
 */
var SwipeSettings = /** @class */ (function (_super) {
    __extends(SwipeSettings, _super);
    function SwipeSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__notify_property_change__["e" /* Property */])(50)
    ], SwipeSettings.prototype, "swipeThresholdDistance", void 0);
    return SwipeSettings;
}(__WEBPACK_IMPORTED_MODULE_4__child_property__["a" /* ChildProperty */]));

var swipeRegex = /(Up|Down)/;
/**
 * Touch class provides support to handle the touch event like tap, double tap, tap hold, etc..,
 * ```typescript
 *    let node: HTMLElement;
 * let touchObj: Touch = new Touch({
 *    element: node,
 *    tap: function (e) {
 *        // tap handler function code
 *    }
 *    tapHold: function (e) {
 *        // tap hold handler function code
 *    }
 *    scroll: function (e) {
 *        // scroll handler function code
 *    }
 *    swipe: function (e) {
 *        // swipe handler function code
 *    }
 * });
 * ```
 */
var Touch = /** @class */ (function (_super) {
    __extends(Touch, _super);
    /* End-Properties */
    function Touch(element, options) {
        var _this = _super.call(this, options, element) || this;
        _this.touchAction = true;
        _this.tapCount = 0;
        /**
         *
         * @param {MouseEventArgs | TouchEventArgs} evt ?
         * @returns {void} ?
         */
        _this.startEvent = function (evt) {
            if (_this.touchAction === true) {
                var point = _this.updateChangeTouches(evt);
                if (evt.changedTouches !== undefined) {
                    _this.touchAction = false;
                }
                _this.isTouchMoved = false;
                _this.movedDirection = '';
                _this.startPoint = _this.lastMovedPoint = { clientX: point.clientX, clientY: point.clientY };
                _this.startEventData = point;
                _this.hScrollLocked = _this.vScrollLocked = false;
                _this.tStampStart = Date.now();
                _this.timeOutTapHold = setTimeout(function () { _this.tapHoldEvent(evt); }, _this.tapHoldThreshold);
                __WEBPACK_IMPORTED_MODULE_5__event_handler__["a" /* EventHandler */].add(_this.element, __WEBPACK_IMPORTED_MODULE_2__browser__["a" /* Browser */].touchMoveEvent, _this.moveEvent, _this);
                __WEBPACK_IMPORTED_MODULE_5__event_handler__["a" /* EventHandler */].add(_this.element, __WEBPACK_IMPORTED_MODULE_2__browser__["a" /* Browser */].touchEndEvent, _this.endEvent, _this);
                __WEBPACK_IMPORTED_MODULE_5__event_handler__["a" /* EventHandler */].add(_this.element, __WEBPACK_IMPORTED_MODULE_2__browser__["a" /* Browser */].touchCancelEvent, _this.cancelEvent, _this);
            }
        };
        /**
         *
         * @param {MouseEventArgs | TouchEventArgs} evt ?
         * @returns {void} ?
         */
        _this.moveEvent = function (evt) {
            var point = _this.updateChangeTouches(evt);
            _this.movedPoint = point;
            _this.isTouchMoved = !(point.clientX === _this.startPoint.clientX && point.clientY === _this.startPoint.clientY);
            var eScrollArgs = {};
            if (_this.isTouchMoved) {
                clearTimeout(_this.timeOutTapHold);
                _this.calcScrollPoints(evt);
                var scrollArg = {
                    startEvents: _this.startEventData,
                    originalEvent: evt, startX: _this.startPoint.clientX,
                    startY: _this.startPoint.clientY, distanceX: _this.distanceX,
                    distanceY: _this.distanceY, scrollDirection: _this.scrollDirection,
                    velocity: _this.getVelocity(point)
                };
                eScrollArgs = Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])(eScrollArgs, {}, scrollArg);
                _this.trigger('scroll', eScrollArgs);
                _this.lastMovedPoint = { clientX: point.clientX, clientY: point.clientY };
            }
        };
        /**
         *
         * @param {MouseEventArgs | TouchEventArgs} evt ?
         * @returns {void} ?
         */
        _this.cancelEvent = function (evt) {
            clearTimeout(_this.timeOutTapHold);
            clearTimeout(_this.timeOutTap);
            _this.tapCount = 0;
            _this.swipeFn(evt);
            __WEBPACK_IMPORTED_MODULE_5__event_handler__["a" /* EventHandler */].remove(_this.element, __WEBPACK_IMPORTED_MODULE_2__browser__["a" /* Browser */].touchCancelEvent, _this.cancelEvent);
        };
        /**
         *
         * @param {MouseEventArgs | TouchEventArgs} evt ?
         * @returns {void} ?
         */
        _this.endEvent = function (evt) {
            _this.swipeFn(evt);
            if (!_this.isTouchMoved) {
                if (typeof _this.tap === 'function') {
                    _this.trigger('tap', { originalEvent: evt, tapCount: ++_this.tapCount });
                    _this.timeOutTap = setTimeout(function () {
                        _this.tapCount = 0;
                    }, _this.tapThreshold);
                }
            }
            _this.modeclear();
        };
        /**
         *
         * @param {MouseEventArgs | TouchEventArgs} evt ?
         * @returns {void} ?
         */
        _this.swipeFn = function (evt) {
            clearTimeout(_this.timeOutTapHold);
            clearTimeout(_this.timeOutTap);
            var point = _this.updateChangeTouches(evt);
            var diffX = point.clientX - _this.startPoint.clientX;
            var diffY = point.clientY - _this.startPoint.clientY;
            diffX = Math.floor(diffX < 0 ? -1 * diffX : diffX);
            diffY = Math.floor(diffY < 0 ? -1 * diffY : diffX);
            _this.isTouchMoved = diffX > 1 || diffY > 1;
            _this.endPoint = point;
            _this.calcPoints(evt);
            var swipeArgs = {
                originalEvent: evt,
                startEvents: _this.startEventData,
                startX: _this.startPoint.clientX,
                startY: _this.startPoint.clientY,
                distanceX: _this.distanceX, distanceY: _this.distanceY, swipeDirection: _this.movedDirection,
                velocity: _this.getVelocity(point)
            };
            if (_this.isTouchMoved) {
                var eSwipeArgs = void 0;
                var tDistance = _this.swipeSettings.swipeThresholdDistance;
                // eslint-disable-next-line
                eSwipeArgs = Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* extend */])(eSwipeArgs, _this.defaultArgs, swipeArgs);
                var canTrigger = false;
                var ele = _this.element;
                var scrollBool = _this.isScrollable(ele);
                var moved = swipeRegex.test(_this.movedDirection);
                if ((tDistance < _this.distanceX && !moved) || (tDistance < _this.distanceY && moved)) {
                    if (!scrollBool) {
                        canTrigger = true;
                    }
                    else {
                        canTrigger = _this.checkSwipe(ele, moved);
                    }
                }
                if (canTrigger) {
                    _this.trigger('swipe', eSwipeArgs);
                }
            }
            _this.modeclear();
        };
        _this.modeclear = function () {
            _this.modeClear = setTimeout(function () {
                _this.touchAction = true;
            }, (typeof _this.tap !== 'function' ? 0 : 20));
            _this.lastTapTime = new Date().getTime();
            __WEBPACK_IMPORTED_MODULE_5__event_handler__["a" /* EventHandler */].remove(_this.element, __WEBPACK_IMPORTED_MODULE_2__browser__["a" /* Browser */].touchMoveEvent, _this.moveEvent);
            __WEBPACK_IMPORTED_MODULE_5__event_handler__["a" /* EventHandler */].remove(_this.element, __WEBPACK_IMPORTED_MODULE_2__browser__["a" /* Browser */].touchEndEvent, _this.endEvent);
            __WEBPACK_IMPORTED_MODULE_5__event_handler__["a" /* EventHandler */].remove(_this.element, __WEBPACK_IMPORTED_MODULE_2__browser__["a" /* Browser */].touchCancelEvent, _this.cancelEvent);
        };
        _this.bind();
        return _this;
    }
    // triggers when property changed
    /**
     *
     * @private
     * @param {TouchModel} newProp ?
     * @param {TouchModel} oldProp ?
     * @returns {void} ?
     */
    // eslint-disable-next-line
    Touch.prototype.onPropertyChanged = function (newProp, oldProp) {
        //No Code to handle
    };
    Touch.prototype.bind = function () {
        this.wireEvents();
        if (__WEBPACK_IMPORTED_MODULE_2__browser__["a" /* Browser */].isIE) {
            this.element.classList.add('e-block-touch');
        }
    };
    /**
     * To destroy the touch instance.
     *
     * @returns {void}
     */
    Touch.prototype.destroy = function () {
        this.unwireEvents();
        _super.prototype.destroy.call(this);
    };
    // Need to changes the event binding once we updated the event handler.
    Touch.prototype.wireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_5__event_handler__["a" /* EventHandler */].add(this.element, __WEBPACK_IMPORTED_MODULE_2__browser__["a" /* Browser */].touchStartEvent, this.startEvent, this);
    };
    Touch.prototype.unwireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_5__event_handler__["a" /* EventHandler */].remove(this.element, __WEBPACK_IMPORTED_MODULE_2__browser__["a" /* Browser */].touchStartEvent, this.startEvent);
    };
    /**
     * Returns module name as touch
     *
     * @returns {string} ?
     * @private
     */
    Touch.prototype.getModuleName = function () {
        return 'touch';
    };
    /**
     * Returns if the HTML element is Scrollable.
     *
     * @param {HTMLElement} element - HTML Element to check if Scrollable.
     * @returns {boolean} ?
     */
    Touch.prototype.isScrollable = function (element) {
        var eleStyle = getComputedStyle(element);
        var style = eleStyle.overflow + eleStyle.overflowX + eleStyle.overflowY;
        if ((/(auto|scroll)/).test(style)) {
            return true;
        }
        return false;
    };
    /**
     *
     * @param {MouseEventArgs | TouchEventArgs} evt ?
     * @returns {void} ?
     */
    Touch.prototype.tapHoldEvent = function (evt) {
        this.tapCount = 0;
        this.touchAction = true;
        var eTapArgs;
        __WEBPACK_IMPORTED_MODULE_5__event_handler__["a" /* EventHandler */].remove(this.element, __WEBPACK_IMPORTED_MODULE_2__browser__["a" /* Browser */].touchMoveEvent, this.moveEvent);
        __WEBPACK_IMPORTED_MODULE_5__event_handler__["a" /* EventHandler */].remove(this.element, __WEBPACK_IMPORTED_MODULE_2__browser__["a" /* Browser */].touchEndEvent, this.endEvent);
        // eslint-disable-next-line
        eTapArgs = { originalEvent: evt };
        this.trigger('tapHold', eTapArgs);
        __WEBPACK_IMPORTED_MODULE_5__event_handler__["a" /* EventHandler */].remove(this.element, __WEBPACK_IMPORTED_MODULE_2__browser__["a" /* Browser */].touchCancelEvent, this.cancelEvent);
    };
    Touch.prototype.calcPoints = function (evt) {
        var point = this.updateChangeTouches(evt);
        this.defaultArgs = { originalEvent: evt };
        this.distanceX = Math.abs((Math.abs(point.clientX) - Math.abs(this.startPoint.clientX)));
        this.distanceY = Math.abs((Math.abs(point.clientY) - Math.abs(this.startPoint.clientY)));
        if (this.distanceX > this.distanceY) {
            this.movedDirection = (point.clientX > this.startPoint.clientX) ? 'Right' : 'Left';
        }
        else {
            this.movedDirection = (point.clientY < this.startPoint.clientY) ? 'Up' : 'Down';
        }
    };
    Touch.prototype.calcScrollPoints = function (evt) {
        var point = this.updateChangeTouches(evt);
        this.defaultArgs = { originalEvent: evt };
        this.distanceX = Math.abs((Math.abs(point.clientX) - Math.abs(this.lastMovedPoint.clientX)));
        this.distanceY = Math.abs((Math.abs(point.clientY) - Math.abs(this.lastMovedPoint.clientY)));
        if ((this.distanceX > this.distanceY || this.hScrollLocked === true) && this.vScrollLocked === false) {
            this.scrollDirection = (point.clientX > this.lastMovedPoint.clientX) ? 'Right' : 'Left';
            this.hScrollLocked = true;
        }
        else {
            this.scrollDirection = (point.clientY < this.lastMovedPoint.clientY) ? 'Up' : 'Down';
            this.vScrollLocked = true;
        }
    };
    Touch.prototype.getVelocity = function (pnt) {
        var newX = pnt.clientX;
        var newY = pnt.clientY;
        var newT = Date.now();
        var xDist = newX - this.startPoint.clientX;
        var yDist = newY - this.startPoint.clientX;
        var interval = newT - this.tStampStart;
        return Math.sqrt(xDist * xDist + yDist * yDist) / interval;
    };
    // eslint-disable-next-line
    Touch.prototype.checkSwipe = function (ele, flag) {
        var keys = ['scroll', 'offset'];
        var temp = flag ? ['Height', 'Top'] : ['Width', 'Left'];
        if ((ele[keys[0] + temp[0]] <= ele[keys[1] + temp[0]])) {
            return true;
        }
        return (ele[keys[0] + temp[1]] === 0) ||
            (ele[keys[1] + temp[0]] + ele[keys[0] + temp[1]] >= ele[keys[0] + temp[0]]);
    };
    Touch.prototype.updateChangeTouches = function (evt) {
        var point = evt.changedTouches && evt.changedTouches.length !== 0 ? evt.changedTouches[0] : evt;
        return point;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__notify_property_change__["c" /* Event */])()
    ], Touch.prototype, "tap", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__notify_property_change__["c" /* Event */])()
    ], Touch.prototype, "tapHold", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__notify_property_change__["c" /* Event */])()
    ], Touch.prototype, "swipe", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__notify_property_change__["c" /* Event */])()
    ], Touch.prototype, "scroll", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__notify_property_change__["e" /* Property */])(350)
    ], Touch.prototype, "tapThreshold", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__notify_property_change__["e" /* Property */])(750)
    ], Touch.prototype, "tapHoldThreshold", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__notify_property_change__["b" /* Complex */])({}, SwipeSettings)
    ], Touch.prototype, "swipeSettings", void 0);
    Touch = __decorate([
        __WEBPACK_IMPORTED_MODULE_1__notify_property_change__["d" /* NotifyPropertyChanges */]
    ], Touch);
    return Touch;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* Base */]));



/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export blazorTemplates */
/* harmony export (immutable) */ __webpack_exports__["b"] = getRandomId;
/* harmony export (immutable) */ __webpack_exports__["a"] = compile;
/* unused harmony export updateBlazorTemplate */
/* unused harmony export resetBlazorTemplate */
/* harmony export (immutable) */ __webpack_exports__["d"] = setTemplateEngine;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTemplateEngine;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(1);
/**
 * Template Engine Bridge
 */



var HAS_ROW = /^[\n\r.]+<tr|^<tr/;
var HAS_SVG = /^[\n\r.]+<svg|^<path|^<g/;
var blazorTemplates = {};
/**
 *
 * @returns {string} ?
 */
function getRandomId() {
    return '-' + Math.random().toString(36).substr(2, 5);
}
/**
 * Compile the template string into template function.
 *
 * @param {string} templateString - The template string which is going to convert.
 * @param {Object} helper - Helper functions as an object.
 * @param {boolean} ignorePrefix ?
 * @returns {NodeList} ?
 * @private
 */
// eslint-disable-next-line
function compile(templateString, helper, ignorePrefix) {
    var compiler = engineObj.compile(templateString, helper, ignorePrefix);
    // eslint-disable-next-line
    return function (data, component, propName, templateId, isStringTemplate, index, element, root) {
        var result = compiler(data, component, propName, element, root);
        var blazorTemplateId = 'BlazorTemplateId';
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])() && !isStringTemplate) {
            var randomId = getRandomId();
            var blazorId = templateId + randomId;
            if (!blazorTemplates[templateId]) {
                blazorTemplates[templateId] = [];
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__util__["m" /* isNullOrUndefined */])(index)) {
                var keys = Object.keys(blazorTemplates[templateId][index]);
                for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                    var key = keys_1[_i];
                    if (key !== blazorTemplateId && data[key]) {
                        blazorTemplates[templateId][index][key] = data[key];
                    }
                    if (key === blazorTemplateId) {
                        blazorId = blazorTemplates[templateId][index][key];
                    }
                }
            }
            else {
                data[blazorTemplateId] = blazorId;
                blazorTemplates[templateId].push(data);
            }
            // eslint-disable-next-line
            return propName === 'rowTemplate' ? [Object(__WEBPACK_IMPORTED_MODULE_1__dom__["f" /* createElement */])('tr', { id: blazorId, className: 'e-blazor-template' })] :
                // eslint-disable-next-line
                [Object(__WEBPACK_IMPORTED_MODULE_1__dom__["f" /* createElement */])('div', { id: blazorId, className: 'e-blazor-template' })];
        }
        if (typeof result === 'string') {
            if (HAS_SVG.test(result)) {
                var ele = Object(__WEBPACK_IMPORTED_MODULE_1__dom__["f" /* createElement */])('svg', { innerHTML: result });
                return ele.childNodes;
            }
            else {
                var ele = Object(__WEBPACK_IMPORTED_MODULE_1__dom__["f" /* createElement */])((HAS_ROW.test(result) ? 'table' : 'div'), { innerHTML: result });
                return ele.childNodes;
            }
        }
        else {
            return result;
        }
    };
}
/**
 *
 * @param {string} templateId ?
 * @param {string} templateName ?
 * @param {string} comp ?
 * @param {boolean} isEmpty ?
 * @param {Function} callBack ?
 * @returns {void} ?
 */
function updateBlazorTemplate(templateId, templateName, comp, isEmpty, callBack) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["l" /* isBlazor */])()) {
        var ejsIntrop = 'sfBlazor';
        window[ejsIntrop].updateTemplate(templateName, blazorTemplates[templateId], templateId, comp, callBack);
        if (isEmpty !== false) {
            blazorTemplates[templateId] = [];
        }
    }
}
/**
 *
 * @param {string} templateId ?
 * @param {string} templateName ?
 * @param {number} index ?
 * @returns {void} ?
 */
function resetBlazorTemplate(templateId, templateName, index) {
    var templateDiv = document.getElementById(templateId);
    if (templateDiv) {
        // eslint-disable-next-line
        var innerTemplates = templateDiv.getElementsByClassName('blazor-inner-template');
        for (var i = 0; i < innerTemplates.length; i++) {
            var tempId = ' ';
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__util__["m" /* isNullOrUndefined */])(index)) {
                tempId = innerTemplates[index].getAttribute('data-templateId');
            }
            else {
                tempId = innerTemplates[i].getAttribute('data-templateId');
            }
            var tempElement = document.getElementById(tempId);
            if (tempElement) {
                var length_1 = tempElement.childNodes.length;
                for (var j = 0; j < length_1; j++) {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_2__util__["m" /* isNullOrUndefined */])(index)) {
                        innerTemplates[index].appendChild(tempElement.childNodes[0]);
                        i = innerTemplates.length;
                    }
                    else {
                        innerTemplates[i].appendChild(tempElement.childNodes[0]);
                    }
                }
            }
        }
    }
}
/**
 * Set your custom template engine for template rendering.
 *
 * @param  {ITemplateEngine} classObj - Class object for custom template.
 * @returns {void} ?
 * @private
 */
function setTemplateEngine(classObj) {
    engineObj.compile = classObj.compile;
}
/**
 * Get current template engine for template rendering
 *
 * @returns {string} ?
 * @private
 */
function getTemplateEngine() {
    return engineObj.compile;
}
//Default Engine Class
var Engine = /** @class */ (function () {
    function Engine() {
    }
    // eslint-disable-next-line
    Engine.prototype.compile = function (templateString, helper, ignorePrefix) {
        if (helper === void 0) { helper = {}; }
        return Object(__WEBPACK_IMPORTED_MODULE_0__template__["a" /* compile */])(templateString, helper);
    };
    return Engine;
}());
var engineObj = { compile: new Engine().compile };


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export expression */
/* harmony export (immutable) */ __webpack_exports__["a"] = compile;
/**
 * Template Engine
 */
var LINES = new RegExp('\\n|\\r|\\s\\s+', 'g');
var QUOTES = new RegExp(/'|"/g);
var IF_STMT = new RegExp('if ?\\(');
var ELSEIF_STMT = new RegExp('else if ?\\(');
var ELSE_STMT = new RegExp('else');
var FOR_STMT = new RegExp('for ?\\(');
var IF_OR_FOR = new RegExp('(/if|/for)');
var CALL_FUNCTION = new RegExp('\\((.*)\\)', '');
var NOT_NUMBER = new RegExp('^[0-9]+$', 'g');
var WORD = new RegExp('[\\w"\'.\\s+]+', 'g');
var DBL_QUOTED_STR = new RegExp('"(.*?)"', 'g');
var WORDIF = new RegExp('[\\w"\'@#$.\\s-+]+', 'g');
var exp = new RegExp('\\${([^}]*)}', 'g');
// let cachedTemplate: Object = {};
var ARR_OBJ = /^\..*/gm;
var SINGLE_SLASH = /\\/gi;
var DOUBLE_SLASH = /\\\\/gi;
var WORDFUNC = new RegExp('[\\w"\'@#$.\\s+]+', 'g');
var WINDOWFUNC = /\window\./gm;
/**
 * The function to set regular expression for template expression string.
 *
 * @param {RegExp} value - Value expression.
 * @returns {RegExp} ?
 * @private
 */
function expression(value) {
    if (value) {
        exp = value;
    }
    return exp;
}
// /**
//  * To render the template string from the given data.
//  * @param  {string} template - String Template.
//  * @param  {Object[]|JSON} data - DataSource for the template.
//  * @param  {Object} helper? - custom helper object.
//  */
// export function template(template: string, data: JSON, helper?: Object): string {
//     let hash: string = hashCode(template);
//     let tmpl: Function;
//     if (!cachedTemplate[hash]) {
//         tmpl = cachedTemplate[hash] = compile(template, helper);
//     } else {
//         tmpl = cachedTemplate[hash];
//     }
//     return tmpl(data);
// }
/**
 * Compile the template string into template function.
 *
 * @param {string} template - The template string which is going to convert.
 * @param {Object} helper - Helper functions as an object.
 * @param {boolean} ignorePrefix ?
 * @returns {string} ?
 * @private
 */
function compile(template, helper, ignorePrefix) {
    var argName = 'data';
    var evalExpResult = evalExp(template, argName, helper, ignorePrefix);
    var condtion = "var valueRegEx = (/value=\\'([A-Za-z0-9 _]*)((.)([\\w)(!-;?-\u25A0\\s]+)['])/g);\n    var hrefRegex = (/(?:href)([\\s='\"./]+)([\\w-./?=&\\\\#\"]+)((.)([\\w)(!-;/?-\u25A0\\s]+)['])/g);\n    if(str.match(valueRegEx)){\n        var check = str.match(valueRegEx);\n        var str1 = str;\n        for (var i=0; i < check.length; i++) {\n            var check1 = str.match(valueRegEx)[i].split('value=')[1];\n            var change = check1.match(/^'/) !== null ? check1.replace(/^'/, '\"') : check1;\n            change =change.match(/.$/)[0] === '\\'' ? change.replace(/.$/,'\"') : change;\n            str1 = str1.replace(check1, change);\n        }\n        str = str.replace(str, str1);\n    }\n    else if (str.match(/(?:href='')/) === null) {\n        if(str.match(hrefRegex)) {\n            var check = str.match(hrefRegex);\n            var str1 = str;\n            for (var i=0; i < check.length; i++) {\n                var check1 = str.match(hrefRegex)[i].split('href=')[1];\n                if (check1) {\n                    var change = check1.match(/^'/) !== null ? check1.replace(/^'/, '\"') : check1;\n                    change =change.match(/.$/)[0] === '\\'' ? change.replace(/.$/,'\"') : change;\n                    str1 = str1.replace(check1, change);\n                }\n            }\n            str = str.replace(str, str1);\n        }\n    }\n    ";
    var fnCode = "var str=\"" + evalExpResult + "\";" + condtion + " return str;";
    var fn = new Function(argName, fnCode);
    return fn.bind(helper);
}
/** function used to evaluate the function expression
 *
 * @param {string} str ?
 * @param {string} nameSpace ?
 * @param {Object} helper ?
 * @param {boolean} ignorePrefix ?
 * @returns {string} ?
 */
function evalExp(str, nameSpace, helper, ignorePrefix) {
    var varCOunt = 0;
    /**
     * Variable containing Local Keys
     */
    var localKeys = [];
    var isClass = str.match(/class="([^"]+|)\s{2}/g);
    var singleSpace = '';
    if (isClass) {
        isClass.forEach(function (value) {
            singleSpace = value.replace(/\s\s+/g, ' ');
            str = str.replace(value, singleSpace);
        });
    }
    return str.replace(LINES, '').replace(DBL_QUOTED_STR, '\'$1\'').replace(exp, 
    // eslint-disable-next-line
    function (match, cnt, offset, matchStr) {
        var SPECIAL_CHAR = /@|#|\$/gm;
        var matches = cnt.match(CALL_FUNCTION);
        // matches to detect any function calls
        if (matches) {
            var rlStr = matches[1];
            if (ELSEIF_STMT.test(cnt)) {
                //handling else-if condition
                cnt = '";} ' + cnt.replace(matches[1], rlStr.replace(WORD, function (str) {
                    str = str.trim();
                    return addNameSpace(str, !(QUOTES.test(str)) && (localKeys.indexOf(str) === -1), nameSpace, localKeys, ignorePrefix);
                })) + '{ \n str = str + "';
            }
            else if (IF_STMT.test(cnt)) {
                //handling if condition
                cnt = '"; ' + cnt.replace(matches[1], rlStr.replace(WORDIF, function (strs) {
                    return HandleSpecialCharArrObj(strs, nameSpace, localKeys, ignorePrefix);
                })) + '{ \n str = str + "';
            }
            else if (FOR_STMT.test(cnt)) {
                //handling for condition
                var rlStr_1 = matches[1].split(' of ');
                // replace for each into actual JavaScript
                // eslint-disable-next-line
                cnt = '"; ' + cnt.replace(matches[1], function (mtc) {
                    localKeys.push(rlStr_1[0]);
                    localKeys.push(rlStr_1[0] + 'Index');
                    varCOunt = varCOunt + 1;
                    // tslint:disable-next-line
                    return 'var i' + varCOunt + '=0; i' + varCOunt + ' < ' + addNameSpace(rlStr_1[1], true, nameSpace, localKeys, ignorePrefix) + '.length; i' + varCOunt + '++';
                }) + '{ \n ' + rlStr_1[0] + '= ' + addNameSpace(rlStr_1[1], true, nameSpace, localKeys, ignorePrefix)
                    + '[i' + varCOunt + ']; \n var ' + rlStr_1[0] + 'Index=i' + varCOunt + '; \n str = str + "';
            }
            else {
                //helper function handling
                var fnStr = cnt.split('(');
                // eslint-disable-next-line
                var fNameSpace = (helper && helper.hasOwnProperty(fnStr[0]) ? 'this.' : 'global');
                fNameSpace = (/\./.test(fnStr[0]) ? '' : fNameSpace);
                var ftArray = matches[1].split(',');
                if (matches[1].length !== 0 && !(/data/).test(ftArray[0]) && !(/window./).test(ftArray[0])) {
                    matches[1] = (fNameSpace === 'global' ? nameSpace + '.' + matches[1] : matches[1]);
                }
                var splRegexp = /@|\$|#/gm;
                var arrObj = /\]\./gm;
                if (WINDOWFUNC.test(cnt) && arrObj.test(cnt) || splRegexp.test(cnt)) {
                    var splArrRegexp = /@|\$|#|\]\./gm;
                    if (splArrRegexp.test(cnt)) {
                        // tslint:disable-next-line
                        cnt = '"+ ' + (fNameSpace === 'global' ? '' : fNameSpace) + cnt.replace(matches[1], rlStr.replace(WORDFUNC, function (strs) {
                            return HandleSpecialCharArrObj(strs, nameSpace, localKeys, ignorePrefix);
                        })) + '+ "';
                    }
                }
                else {
                    cnt = '" + ' + (fNameSpace === 'global' ? '' : fNameSpace) +
                        cnt.replace(rlStr, addNameSpace(matches[1].replace(/,( |)data.|,/gi, ',' + nameSpace + '.').replace(/,( |)data.window/gi, ',window'), (fNameSpace === 'global' ? false : true), nameSpace, localKeys, ignorePrefix)) +
                        '+"';
                }
            }
        }
        else if (ELSE_STMT.test(cnt)) {
            // handling else condition
            cnt = '"; ' + cnt.replace(ELSE_STMT, '} else { \n str = str + "');
            // eslint-disable-next-line
        }
        else if (!!cnt.match(IF_OR_FOR)) {
            // close condition
            cnt = cnt.replace(IF_OR_FOR, '"; \n } \n str = str + "');
        }
        else if (SPECIAL_CHAR.test(cnt)) {
            // template string with double slash with special character
            if (cnt.match(SINGLE_SLASH)) {
                cnt = SlashReplace(cnt);
            }
            cnt = '"+' + NameSpaceForspecialChar(cnt, (localKeys.indexOf(cnt) === -1), nameSpace, localKeys) + '"]+"';
        }
        else {
            // template string with double slash
            if (cnt.match(SINGLE_SLASH)) {
                cnt = SlashReplace(cnt);
                cnt = '"+' + NameSpaceForspecialChar(cnt, (localKeys.indexOf(cnt) === -1), nameSpace, localKeys) + '"]+"';
            }
            else {
                // evaluate normal expression
                cnt = '"+' + addNameSpace(cnt.replace(/,/gi, '+' + nameSpace + '.'), (localKeys.indexOf(cnt) === -1), nameSpace, localKeys, ignorePrefix) + '+"';
            }
        }
        return cnt;
    });
}
/**
 *
 * @param {string} str ?
 * @param {boolean} addNS ?
 * @param {string} nameSpace ?
 * @param {string[]} ignoreList ?
 * @param {boolean} ignorePrefix ?
 * @returns {string} ?
 */
function addNameSpace(str, addNS, nameSpace, ignoreList, ignorePrefix) {
    return ((addNS && !(NOT_NUMBER.test(str)) && ignoreList.indexOf(str.split('.')[0]) === -1 && !ignorePrefix) ? nameSpace + '.' + str : str);
}
/**
 *
 * @param {string} str ?
 * @param {boolean} addNS ?
 * @param {string} nameSpace ?
 * @param {string[]} ignoreList ?
 * @returns {string} ?
 */
function NameSpaceArrObj(str, addNS, nameSpace, ignoreList) {
    var arrObjReg = /^\..*/gm;
    return ((addNS && !(NOT_NUMBER.test(str)) &&
        ignoreList.indexOf(str.split('.')[0]) === -1 && !(arrObjReg.test(str))) ? nameSpace + '.' + str : str);
}
// // Create hashCode for template string to storeCached function
// function hashCode(str: string): string {
//     return str.split('').reduce((a: number, b: string) => { a = ((a << 5) - a) + b.charCodeAt(0); return a & a; }, 0).toString();
// }
/**
 *
 * @param {string} str ?
 * @param {boolean} addNS ?
 * @param {string} nameSpace ?
 * @param {string[]} ignoreList ?
 * @returns {string} ?
 */
function NameSpaceForspecialChar(str, addNS, nameSpace, ignoreList) {
    return ((addNS && !(NOT_NUMBER.test(str)) && ignoreList.indexOf(str.split('.')[0]) === -1) ? nameSpace + '["' + str : str);
}
// eslint-disable-next-line
function SlashReplace(tempStr) {
    var double = '\\\\';
    if (tempStr.match(DOUBLE_SLASH)) {
        // eslint-disable-next-line
        tempStr = tempStr;
    }
    else {
        tempStr = tempStr.replace(SINGLE_SLASH, double);
    }
    return tempStr;
}
/**
 *
 * @param {string} str ?
 * @param {string} nameSpaceNew ?
 * @param {string[]} keys ?
 * @param {boolean} ignorePrefix ?
 * @returns {string} ?
 */
function HandleSpecialCharArrObj(str, nameSpaceNew, keys, ignorePrefix) {
    str = str.trim();
    var windowFunc = /\window\./gm;
    if (!windowFunc.test(str)) {
        var quotes = /'|"/gm;
        var splRegexp = /@|\$|#/gm;
        if (splRegexp.test(str)) {
            str = NameSpaceForspecialChar(str, (keys.indexOf(str) === -1), nameSpaceNew, keys) + '"]';
        }
        if (ARR_OBJ.test(str)) {
            return NameSpaceArrObj(str, !(quotes.test(str)) && (keys.indexOf(str) === -1), nameSpaceNew, keys);
        }
        else {
            return addNameSpace(str, !(quotes.test(str)) && (keys.indexOf(str) === -1), nameSpaceNew, keys, ignorePrefix);
        }
    }
    else {
        return str;
    }
}


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SanitizeHtmlHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom__ = __webpack_require__(10);
/**
 * SanitizeHtmlHelper for sanitize the value.
 */

var removeTags = [
    'script',
    'style',
    'iframe[src]',
    'link[href*="javascript:"]',
    'object[type="text/x-scriptlet"]',
    'object[data^="data:text/html;base64"]',
    'img[src^="data:text/html;base64"]',
    '[src^="javascript:"]',
    '[dynsrc^="javascript:"]',
    '[lowsrc^="javascript:"]',
    '[type^="application/x-shockwave-flash"]'
];
var removeAttrs = [
    { attribute: 'href', selector: '[href*="javascript:"]' },
    { attribute: 'background', selector: '[background^="javascript:"]' },
    { attribute: 'style', selector: '[style*="javascript:"]' },
    { attribute: 'style', selector: '[style*="expression("]' },
    { attribute: 'href', selector: 'a[href^="data:text/html;base64"]' }
];
var jsEvents = ['onchange',
    'onclick',
    'onmouseover',
    'onmouseout',
    'onkeydown',
    'onload',
    'onerror',
    'onblur',
    'onfocus',
    'onbeforeload',
    'onbeforeunload',
    'onkeyup',
    'onsubmit',
    'onafterprint',
    'onbeforeonload',
    'onbeforeprint',
    'onblur',
    'oncanplay',
    'oncanplaythrough',
    'onchange',
    'onclick',
    'oncontextmenu',
    'ondblclick',
    'ondrag',
    'ondragend',
    'ondragenter',
    'ondragleave',
    'ondragover',
    'ondragstart',
    'ondrop',
    'ondurationchange',
    'onemptied',
    'onended',
    'onerror',
    'onerror',
    'onfocus',
    'onformchange',
    'onforminput',
    'onhaschange',
    'oninput',
    'oninvalid',
    'onkeydown',
    'onkeypress',
    'onkeyup',
    'onload',
    'onloadeddata',
    'onloadedmetadata',
    'onloadstart',
    'onmessage',
    'onmousedown',
    'onmousemove',
    'onmouseout',
    'onmouseover',
    'onmouseup',
    'onmousewheel',
    'onoffline',
    'onoine',
    'ononline',
    'onpagehide',
    'onpageshow',
    'onpause',
    'onplay',
    'onplaying',
    'onpopstate',
    'onprogress',
    'onratechange',
    'onreadystatechange',
    'onredo',
    'onresize',
    'onscroll',
    'onseeked',
    'onseeking',
    'onselect',
    'onstalled',
    'onstorage',
    'onsubmit',
    'onsuspend',
    'ontimeupdate',
    'onundo',
    'onunload',
    'onvolumechange',
    'onwaiting',
    'onmouseenter',
    'onmouseleave',
    'onmousewheel',
    'onstart',
    'onpropertychange'
];
var SanitizeHtmlHelper = /** @class */ (function () {
    function SanitizeHtmlHelper() {
    }
    SanitizeHtmlHelper.beforeSanitize = function () {
        return {
            selectors: {
                tags: removeTags,
                attributes: removeAttrs
            }
        };
    };
    SanitizeHtmlHelper.sanitize = function (value) {
        var item = this.beforeSanitize();
        var output = this.serializeValue(item, value);
        return output;
    };
    SanitizeHtmlHelper.serializeValue = function (item, value) {
        this.removeAttrs = item.selectors.attributes;
        this.removeTags = item.selectors.tags;
        this.wrapElement = document.createElement('div');
        this.wrapElement.innerHTML = value;
        this.removeXssTags();
        this.removeJsEvents();
        this.removeXssAttrs();
        var tempEleValue = this.wrapElement.innerHTML;
        this.removeElement();
        return tempEleValue;
    };
    SanitizeHtmlHelper.removeElement = function () {
        // Removes an element's attibute to avoid html tag validation
        var nodes = this.wrapElement.children;
        for (var j = 0; j < nodes.length; j++) {
            var attribute = nodes[j].attributes;
            for (var i = 0; i < attribute.length; i++) {
                this.wrapElement.children[j].removeAttribute(attribute[i].localName);
            }
        }
    };
    SanitizeHtmlHelper.removeXssTags = function () {
        var elements = this.wrapElement.querySelectorAll(this.removeTags.join(','));
        if (elements.length > 0) {
            elements.forEach(function (element) {
                Object(__WEBPACK_IMPORTED_MODULE_0__dom__["g" /* detach */])(element);
            });
        }
        else {
            return;
        }
    };
    SanitizeHtmlHelper.removeJsEvents = function () {
        var elements = this.wrapElement.querySelectorAll('[' + jsEvents.join('],[') + ']');
        if (elements.length > 0) {
            elements.forEach(function (element) {
                jsEvents.forEach(function (attr) {
                    if (element.hasAttribute(attr)) {
                        element.removeAttribute(attr);
                    }
                });
            });
        }
        else {
            return;
        }
    };
    SanitizeHtmlHelper.removeXssAttrs = function () {
        var _this = this;
        // eslint-disable-next-line
        this.removeAttrs.forEach(function (item, index) {
            var elements = _this.wrapElement.querySelectorAll(item.selector);
            if (elements.length > 0) {
                elements.forEach(function (element) {
                    element.removeAttribute(item.attribute);
                });
            }
        });
    };
    return SanitizeHtmlHelper;
}());



/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export registerLicense */
/* unused harmony export validateLicense */
/* unused harmony export getVersion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(1);


var bypassKey = [115, 121, 110, 99, 102, 117, 115, 105,
    111, 110, 46, 105, 115, 76, 105, 99, 86, 97, 108,
    105, 100, 97, 116, 101, 100];
/**
 * License validation module
 * @private
 */
var LicenseValidator = /** @class */ (function () {
    function LicenseValidator(key) {
        this.isValidated = false;
        this.version = '20.1';
        this.platform = /JavaScript|ASPNET|ASPNETCORE|ASPNETMVC|FileFormats/i;
        this.errors = {
            noLicense: 'This application was built using a trial version of Syncfusion Essential Studio.' +
                ' Please include a valid license to permanently remove this license validation message.' +
                ' You can also obtain a free 30 day evaluation license to temporarily remove this message ' +
                'during the evaluation period. Please refer to this <a style="color:yellow;text-decoration:none;"' +
                'href="https://help.syncfusion.com/common/essential-studio/licensing">help topic</a> for more information.',
            trailExpired: 'Your Syncfusion trial license has expired. Please refer to this ' +
                '<a style="color:yellow;text-decoration:none;"' +
                'href="https://help.syncfusion.com/common/essential-studio/licensing/licensing-errors#trial-expired">help topic</a> for more information.',
            versionMismatched: 'The included Syncfusion license (v##LicenseVersion) is invalid for version ' +
                '##Requireversion. Please refer to this <a style="color:yellow;text-decoration:none;" ' +
                'href="https://help.syncfusion.com/es/licensing/version-mismatch/">help topic</a> for more information.',
            platformMismatched: 'The included Syncfusion license is invalid (Platform mismatch). Please refer' +
                ' to this <a style="color:yellow;text-decoration:none;" ' +
                'href="https://help.syncfusion.com/common/essential-studio/licensing/licensing-errors#platform-mismatch">help topic</a> for more information.',
            invalidKey: 'The included Syncfusion license is invalid. Please refer to this ' +
                '<a style="color:yellow;text-decoration:none;" ' +
                'href="https://help.syncfusion.com/common/essential-studio/licensing/licensing-errors#invalid-key">help topic</a> for more information.'
        };
        /**
         * To manage licensing operation.
         */
        this.manager = (function () {
            var licKey = null;
            function set(key) { licKey = key; }
            function get() { return licKey; }
            return {
                setKey: set,
                getKey: get
            };
        })();
        this.manager.setKey(key);
    }
    /**
     * To validate the provided license key.
     */
    LicenseValidator.prototype.validate = function () {
        if (!this.isValidated && (__WEBPACK_IMPORTED_MODULE_1__util__["b" /* containerObject */] && !Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])(convertToChar(bypassKey), __WEBPACK_IMPORTED_MODULE_1__util__["b" /* containerObject */]) && !Object(__WEBPACK_IMPORTED_MODULE_1__util__["k" /* getValue */])('Blazor', __WEBPACK_IMPORTED_MODULE_1__util__["b" /* containerObject */]))) {
            var validateMsg = void 0;
            if (this.manager && this.manager.getKey()) {
                var result = this.getInfoFromKey();
                if (result && result.length) {
                    for (var _i = 0, result_1 = result; _i < result_1.length; _i++) {
                        var res = result_1[_i];
                        if (!this.platform.test(res.platform) || res.invalidPlatform) {
                            validateMsg = this.errors.platformMismatched;
                        }
                        else if (res.version.indexOf(this.version) === -1) {
                            validateMsg = this.errors.versionMismatched;
                            validateMsg = validateMsg.replace('##LicenseVersion', res.version);
                            validateMsg = validateMsg.replace('##Requireversion', this.version + '.x');
                        }
                        else if (res.expiryDate) {
                            var expDate = new Date(res.expiryDate);
                            var currDate = new Date();
                            if (expDate !== currDate && expDate < currDate) {
                                validateMsg = this.errors.trailExpired;
                            }
                            else {
                                break;
                            }
                        }
                    }
                }
                else {
                    validateMsg = this.errors.invalidKey;
                }
            }
            else {
                validateMsg = this.errors.noLicense;
            }
            if (validateMsg && typeof document !== "undefined" && !Object(__WEBPACK_IMPORTED_MODULE_1__util__["m" /* isNullOrUndefined */])(document)) {
                var errorDiv = Object(__WEBPACK_IMPORTED_MODULE_0__dom__["f" /* createElement */])('div', {
                    innerHTML: validateMsg +
                        '<span style="position:absolute;right: 10px;top:27%;cursor:pointer;"' +
                        'onClick=this.parentElement.remove();>' +
                        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20">' +
                        '<line x1="5" y1="5" x2="15" y2="15" stroke="yellow" stroke-width="2.5" ' +
                        'stroke-miterlimit="10" stroke-linecap="round"></line><line x1="15" y1="5" ' +
                        'x2="5" y2="15" stroke="yellow" stroke-width="2.5" stroke-linecap="round" ' +
                        'stroke-miterlimit="10"></line></svg></span>',
                    styles: 'position:fixed;top:0;left:0;right:0;font-family:"Segoe UI";font-size:16px;' +
                        'background:repeating-linear-gradient(45deg,#d70f0f,#d70f0f 10px,#e12121 10px,#e12121 17px);' +
                        'color:#ffffff;z-index:999999999;text-align:center;padding:10px 50px 10px 25px;'
                });
                errorDiv.setAttribute('id', 'js-licensing');
                document.body.appendChild(errorDiv);
            }
            this.isValidated = true;
            Object(__WEBPACK_IMPORTED_MODULE_1__util__["r" /* setValue */])(convertToChar(bypassKey), this.isValidated, __WEBPACK_IMPORTED_MODULE_1__util__["b" /* containerObject */]);
        }
    };
    LicenseValidator.prototype.getDecryptedData = function (key) {
        try {
            return atob(key);
        }
        catch (error) {
            return '';
        }
    };
    /**
     * Get license information from key.
     */
    LicenseValidator.prototype.getInfoFromKey = function () {
        try {
            var licKey = this.manager.getKey();
            var licKeySplit = licKey.split(';');
            var pkey = [5439488, 7929856, 5111808, 6488064, 4587520, 7667712, 5439488,
                6881280, 5177344, 7208960, 4194304, 4456448, 6619136, 7733248, 5242880, 7077888,
                6356992, 7602176, 4587520, 7274496, 7471104, 7143424];
            var decryptedStr = [];
            var resultArray = [];
            var invalidPlatform = false;
            for (var _i = 0, licKeySplit_1 = licKeySplit; _i < licKeySplit_1.length; _i++) {
                var lKey = licKeySplit_1[_i];
                var decodeStr = this.getDecryptedData(lKey);
                if (!decodeStr) {
                    continue;
                }
                var k = 0;
                var buffr = '';
                for (var i = 0; i < decodeStr.length; i++, k++) {
                    if (k === pkey.length) {
                        k = 0;
                    }
                    var c = decodeStr.charCodeAt(i);
                    buffr += String.fromCharCode(c ^ (pkey[k] >> 16));
                }
                if (this.platform.test(buffr)) {
                    decryptedStr = buffr.split(';');
                    invalidPlatform = false;
                    // checked the length to verify the key in proper strucutre
                    if (decryptedStr.length > 3) {
                        resultArray.push({ platform: decryptedStr[0],
                            version: decryptedStr[1],
                            expiryDate: decryptedStr[2] });
                    }
                }
                else if (buffr && buffr.split(';').length > 3) {
                    invalidPlatform = true;
                }
            }
            if (invalidPlatform && !resultArray.length) {
                return [{ invalidPlatform: invalidPlatform }];
            }
            else {
                return resultArray.length ? resultArray : null;
            }
        }
        catch (error) {
            return null;
        }
    };
    return LicenseValidator;
}());
var licenseValidator = new LicenseValidator();
function convertToChar(cArr) {
    var ret = '';
    for (var _i = 0, cArr_1 = cArr; _i < cArr_1.length; _i++) {
        var arr = cArr_1[_i];
        ret += String.fromCharCode(arr);
    }
    return ret;
}
/**
 * To set license key.
 * @param {string} key - license key
 */
function registerLicense(key) {
    licenseValidator = new LicenseValidator(key);
}
var validateLicense = function (key) {
    if (key) {
        registerLicense(key);
    }
    licenseValidator.validate();
};
var getVersion = function () {
    return licenseValidator.version;
};


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__list_view_index__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_index__ = __webpack_require__(231);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__common_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sortable__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/**
 * List Components
 */





/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__list_view__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__virtualization__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/**
 * Listview Component
 */




/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__manager__ = __webpack_require__(83);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__query__ = __webpack_require__(32);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__query__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adaptors__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(31);
/* unused harmony namespace reexport */
/**
 * Data modules
 */






/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_index__ = __webpack_require__(218);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__common_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__common_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_index__ = __webpack_require__(219);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__button_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__check_box_index__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__radio_button_index__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__switch_index__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chips_index__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/**
 * Button all modules
 */








/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(21);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__common__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__common__["e"]; });
/**
 * Common modules
 */



/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button__ = __webpack_require__(220);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__button__["a"]; });
/**
 * Button modules
 */



/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buttonObserver */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_common__ = __webpack_require__(21);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var buttonObserver = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["q" /* Observer */]();
var cssClassName = {
    RTL: 'e-rtl',
    BUTTON: 'e-btn',
    PRIMARY: 'e-primary',
    ICONBTN: 'e-icon-btn'
};
/**
 * The Button is a graphical user interface element that triggers an event on its click action. It can contain a text, an image, or both.
 * ```html
 * <button id="button">Button</button>
 * ```
 * ```typescript
 * <script>
 * var btnObj = new Button();
 * btnObj.appendTo("#button");
 * </script>
 * ```
 */
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    /**
     * Constructor for creating the widget
     *
     * @param  {ButtonModel} options - Specifies the button model
     * @param  {string|HTMLButtonElement} element - Specifies the target element
     */
    function Button(options, element) {
        return _super.call(this, options, element) || this;
    }
    Button.prototype.preRender = function () {
        // pre render code snippets
    };
    /**
     * Initialize the control rendering
     *
     * @returns {void}
     * @private
     */
    Button.prototype.render = function () {
        this.initialize();
        this.removeRippleEffect = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_0" /* rippleEffect */])(this.element, { selector: '.' + cssClassName.BUTTON });
        this.renderComplete();
    };
    Button.prototype.initialize = function () {
        if (this.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], this.cssClass.split(' '));
        }
        if (this.isPrimary) {
            this.element.classList.add(cssClassName.PRIMARY);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["P" /* isBlazor */])() || (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["P" /* isBlazor */])() && this.getModuleName() !== 'progress-btn')) {
            if (this.content) {
                var tempContent = (this.enableHtmlSanitizer) ? __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(this.content) : this.content;
                this.element.innerHTML = tempContent;
            }
            this.setIconCss();
        }
        if (this.enableRtl) {
            this.element.classList.add(cssClassName.RTL);
        }
        if (this.disabled) {
            this.controlStatus(this.disabled);
        }
        else {
            this.wireEvents();
        }
    };
    Button.prototype.controlStatus = function (disabled) {
        this.element.disabled = disabled;
    };
    Button.prototype.setIconCss = function () {
        if (this.iconCss) {
            var span = this.createElement('span', { className: 'e-btn-icon ' + this.iconCss });
            if (!this.element.textContent.trim()) {
                this.element.classList.add(cssClassName.ICONBTN);
            }
            else {
                span.classList.add('e-icon-' + this.iconPosition.toLowerCase());
                if (this.iconPosition === 'Top' || this.iconPosition === 'Bottom') {
                    this.element.classList.add('e-' + this.iconPosition.toLowerCase() + '-icon-btn');
                }
            }
            var node = this.element.childNodes[0];
            if (node && (this.iconPosition === 'Left' || this.iconPosition === 'Top')) {
                this.element.insertBefore(span, node);
            }
            else {
                this.element.appendChild(span);
            }
        }
    };
    Button.prototype.wireEvents = function () {
        if (this.isToggle) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'click', this.btnClickHandler, this);
        }
    };
    Button.prototype.unWireEvents = function () {
        if (this.isToggle) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'click', this.btnClickHandler);
        }
    };
    Button.prototype.btnClickHandler = function () {
        if (this.element.classList.contains('e-active')) {
            this.element.classList.remove('e-active');
        }
        else {
            this.element.classList.add('e-active');
        }
    };
    /**
     * Destroys the widget.
     *
     * @returns {void}
     */
    Button.prototype.destroy = function () {
        var classList = [cssClassName.PRIMARY, cssClassName.RTL, cssClassName.ICONBTN, 'e-success', 'e-info', 'e-danger',
            'e-warning', 'e-flat', 'e-outline', 'e-small', 'e-bigger', 'e-active', 'e-round',
            'e-top-icon-btn', 'e-bottom-icon-btn'];
        if (this.cssClass) {
            classList = classList.concat(this.cssClass.split(' '));
        }
        _super.prototype.destroy.call(this);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], classList);
        if (!this.element.getAttribute('class')) {
            this.element.removeAttribute('class');
        }
        if (this.disabled) {
            this.element.removeAttribute('disabled');
        }
        if (this.content) {
            this.element.innerHTML = this.element.innerHTML.replace(this.content, '');
        }
        var span = this.element.querySelector('span.e-btn-icon');
        if (span) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(span);
        }
        this.unWireEvents();
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["R" /* isRippleEnabled */]) {
            this.removeRippleEffect();
        }
    };
    /**
     * Get component name.
     *
     * @returns {string} - Module name
     * @private
     */
    Button.prototype.getModuleName = function () {
        return 'btn';
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} - Persist Data
     * @private
     */
    Button.prototype.getPersistData = function () {
        return this.addOnPersist([]);
    };
    /**
     * Dynamically injects the required modules to the component.
     *
     * @private
     * @returns {void}
     */
    Button.Inject = function () {
        // Inject code snippets
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param  {ButtonModel} newProp - Specifies new properties
     * @param  {ButtonModel} oldProp - Specifies old properties
     * @returns {void}
     * @private
     */
    Button.prototype.onPropertyChanged = function (newProp, oldProp) {
        var span = this.element.querySelector('span.e-btn-icon');
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'isPrimary':
                    if (newProp.isPrimary) {
                        this.element.classList.add(cssClassName.PRIMARY);
                    }
                    else {
                        this.element.classList.remove(cssClassName.PRIMARY);
                    }
                    break;
                case 'disabled':
                    this.controlStatus(newProp.disabled);
                    break;
                case 'iconCss': {
                    if (span) {
                        if (newProp.iconCss) {
                            span.className = 'e-btn-icon ' + newProp.iconCss;
                            if (this.element.textContent.trim()) {
                                if (this.iconPosition === 'Left') {
                                    span.classList.add('e-icon-left');
                                }
                                else {
                                    span.classList.add('e-icon-right');
                                }
                            }
                        }
                        else {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(span);
                        }
                    }
                    else {
                        this.setIconCss();
                    }
                    break;
                }
                case 'iconPosition':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], ['e-top-icon-btn', 'e-bottom-icon-btn']);
                    span = this.element.querySelector('span.e-btn-icon');
                    if (span) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(span);
                    }
                    this.setIconCss();
                    break;
                case 'cssClass':
                    if (oldProp.cssClass) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], oldProp.cssClass.split(' '));
                    }
                    if (newProp.cssClass) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], newProp.cssClass.split(' '));
                    }
                    break;
                case 'enableRtl':
                    if (newProp.enableRtl) {
                        this.element.classList.add(cssClassName.RTL);
                    }
                    else {
                        this.element.classList.remove(cssClassName.RTL);
                    }
                    break;
                case 'content': {
                    var node = Object(__WEBPACK_IMPORTED_MODULE_1__common_common__["c" /* getTextNode */])(this.element);
                    if (!node) {
                        this.element.classList.remove(cssClassName.ICONBTN);
                    }
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["P" /* isBlazor */])() || (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["P" /* isBlazor */])() && !this.isServerRendered && this.getModuleName() !== 'progress-btn')) {
                        if (this.enableHtmlSanitizer) {
                            newProp.content = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(newProp.content);
                        }
                        this.element.innerHTML = newProp.content;
                        this.setIconCss();
                    }
                    break;
                }
                case 'isToggle':
                    if (newProp.isToggle) {
                        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'click', this.btnClickHandler, this);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'click', this.btnClickHandler);
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], ['e-active']);
                    }
                    break;
            }
        }
    };
    /**
     * Click the button element
     * its native method
     *
     * @public
     * @returns {void}
     */
    Button.prototype.click = function () {
        this.element.click();
    };
    /**
     * Sets the focus to Button
     * its native method
     *
     * @public
     * @returns {void}
     */
    Button.prototype.focusIn = function () {
        this.element.focus();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Left')
    ], Button.prototype, "iconPosition", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Button.prototype, "iconCss", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Button.prototype, "disabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Button.prototype, "isPrimary", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Button.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Button.prototype, "content", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Button.prototype, "isToggle", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Button.prototype, "locale", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Button.prototype, "enableHtmlSanitizer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Button.prototype, "created", void 0);
    Button = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], Button);
    return Button;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__check_box__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/**
 * CheckBox modules
 */



/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CheckBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_common__ = __webpack_require__(21);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var CHECK = 'e-check';
var DISABLED = 'e-checkbox-disabled';
var FRAME = 'e-frame';
var INDETERMINATE = 'e-stop';
var LABEL = 'e-label';
var RIPPLE = 'e-ripple-container';
var RIPPLECHECK = 'e-ripple-check';
var RIPPLEINDETERMINATE = 'e-ripple-stop';
var RTL = 'e-rtl';
var WRAPPER = 'e-checkbox-wrapper';
var containerAttr = ['title', 'class', 'style', 'disabled', 'readonly', 'name', 'value'];
/**
 * The CheckBox is a graphical user interface element that allows you to select one or more options from the choices.
 * It contains checked, unchecked, and indeterminate states.
 * ```html
 * <input type="checkbox" id="checkbox"/>
 * <script>
 * var checkboxObj = new CheckBox({ label: "Default" });
 * checkboxObj.appendTo("#checkbox");
 * </script>
 * ```
 */
var CheckBox = /** @class */ (function (_super) {
    __extends(CheckBox, _super);
    /**
     * Constructor for creating the widget
     *
     * @private
     * @param {CheckBoxModel} options - Specifies checkbox model
     * @param {string | HTMLInputElement} element - Specifies target element
     */
    function CheckBox(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.isFocused = false;
        _this.isMouseClick = false;
        _this.clickTriggered = false;
        _this.validCheck = true;
        return _this;
    }
    CheckBox.prototype.changeState = function (state) {
        var ariaState;
        var rippleSpan;
        var frameSpan = this.getWrapper().getElementsByClassName(FRAME)[0];
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["R" /* isRippleEnabled */]) {
            rippleSpan = this.getWrapper().getElementsByClassName(RIPPLE)[0];
        }
        if (state === 'check') {
            frameSpan.classList.remove(INDETERMINATE);
            frameSpan.classList.add(CHECK);
            if (rippleSpan) {
                rippleSpan.classList.remove(RIPPLEINDETERMINATE);
                rippleSpan.classList.add(RIPPLECHECK);
            }
            ariaState = 'true';
            this.element.checked = true;
            if (this.element.required && this.validCheck) {
                this.element.checked = false;
                this.validCheck = false;
            }
            else if (this.element.required) {
                this.validCheck = true;
            }
        }
        else if (state === 'uncheck') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([frameSpan], [CHECK, INDETERMINATE]);
            if (rippleSpan) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([rippleSpan], [RIPPLECHECK, RIPPLEINDETERMINATE]);
            }
            ariaState = 'false';
            this.element.checked = false;
            if (this.element.required && this.validCheck) {
                this.element.checked = true;
                this.validCheck = false;
            }
            else if (this.element.required) {
                this.validCheck = true;
            }
        }
        else {
            frameSpan.classList.remove(CHECK);
            frameSpan.classList.add(INDETERMINATE);
            if (rippleSpan) {
                rippleSpan.classList.remove(RIPPLECHECK);
                rippleSpan.classList.add(RIPPLEINDETERMINATE);
            }
            ariaState = 'mixed';
            this.element.indeterminate = true;
        }
        this.getWrapper().setAttribute('aria-checked', ariaState);
    };
    CheckBox.prototype.clickHandler = function (event) {
        if (event.target.tagName === 'INPUT' && this.clickTriggered) {
            this.clickTriggered = false;
            return;
        }
        if (event.target.tagName === 'SPAN' || event.target.tagName === 'LABEL') {
            this.clickTriggered = true;
        }
        if (this.isMouseClick) {
            this.focusOutHandler();
            this.isMouseClick = false;
        }
        if (this.indeterminate) {
            this.changeState(this.checked ? 'check' : 'uncheck');
            this.indeterminate = false;
            this.element.indeterminate = false;
        }
        else if (this.checked) {
            this.changeState('uncheck');
            this.checked = false;
        }
        else {
            this.changeState('check');
            this.checked = true;
        }
        var changeEventArgs = { checked: this.updateVueArrayModel(false), event: event };
        this.trigger('change', changeEventArgs);
        event.stopPropagation();
    };
    /**
     * Destroys the widget.
     *
     * @returns {void}
     */
    CheckBox.prototype.destroy = function () {
        var _this = this;
        var wrapper = this.getWrapper();
        _super.prototype.destroy.call(this);
        if (this.wrapper) {
            wrapper = this.wrapper;
            if (!this.disabled) {
                this.unWireEvents();
            }
            if (this.tagName === 'INPUT') {
                if (this.getWrapper() && wrapper.parentNode) {
                    wrapper.parentNode.insertBefore(this.element, wrapper);
                }
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(wrapper);
                this.element.checked = false;
                if (this.indeterminate) {
                    this.element.indeterminate = false;
                }
                ['name', 'value', 'disabled'].forEach(function (key) {
                    _this.element.removeAttribute(key);
                });
            }
            else {
                ['role', 'aria-checked', 'class'].forEach(function (key) {
                    wrapper.removeAttribute(key);
                });
                wrapper.innerHTML = '';
            }
        }
    };
    CheckBox.prototype.focusHandler = function () {
        this.isFocused = true;
    };
    CheckBox.prototype.focusOutHandler = function () {
        var wrapper = this.getWrapper();
        if (wrapper) {
            wrapper.classList.remove('e-focus');
        }
        this.isFocused = false;
    };
    /**
     * Gets the module name.
     *
     * @private
     * @returns {string} - Module Name
     */
    CheckBox.prototype.getModuleName = function () {
        return 'checkbox';
    };
    /**
     * Gets the properties to be maintained in the persistence state.
     *
     * @private
     * @returns {string} - Persist Data
     */
    CheckBox.prototype.getPersistData = function () {
        return this.addOnPersist(['checked', 'indeterminate']);
    };
    CheckBox.prototype.getWrapper = function () {
        if (this.element && this.element.parentElement) {
            return this.element.parentElement.parentElement;
        }
        else {
            return null;
        }
    };
    CheckBox.prototype.initialize = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.initialCheckedValue)) {
            this.initialCheckedValue = this.checked;
        }
        if (this.name) {
            this.element.setAttribute('name', this.name);
        }
        if (this.value) {
            this.element.setAttribute('value', this.value);
            if (this.isVue && typeof this.value === 'boolean' && this.value === true) {
                this.setProperties({ 'checked': true }, true);
            }
        }
        if (this.checked) {
            this.changeState('check');
        }
        if (this.indeterminate) {
            this.changeState();
        }
        if (this.disabled) {
            this.setDisabled();
        }
    };
    CheckBox.prototype.initWrapper = function () {
        var wrapper = this.element.parentElement;
        if (!wrapper.classList.contains(WRAPPER)) {
            wrapper = this.createElement('div', {
                className: WRAPPER, attrs: { 'aria-checked': 'false' }
            });
            this.element.parentNode.insertBefore(wrapper, this.element);
        }
        var label = this.createElement('label', { attrs: { for: this.element.id } });
        var frameSpan = this.createElement('span', { className: 'e-icons ' + FRAME });
        wrapper.classList.add('e-wrapper');
        if (this.enableRtl) {
            wrapper.classList.add(RTL);
        }
        if (this.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([wrapper], this.cssClass.split(' '));
        }
        wrapper.appendChild(label);
        label.appendChild(this.element);
        Object(__WEBPACK_IMPORTED_MODULE_1__common_common__["f" /* setHiddenInput */])(this, label);
        label.appendChild(frameSpan);
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["R" /* isRippleEnabled */]) {
            var rippleSpan = this.createElement('span', { className: RIPPLE });
            if (this.labelPosition === 'Before') {
                label.appendChild(rippleSpan);
            }
            else {
                label.insertBefore(rippleSpan, frameSpan);
            }
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_0" /* rippleEffect */])(rippleSpan, { duration: 400, isCenterRipple: true });
        }
        if (this.label) {
            this.setText(this.label);
        }
    };
    CheckBox.prototype.keyUpHandler = function () {
        if (this.isFocused) {
            this.getWrapper().classList.add('e-focus');
        }
    };
    CheckBox.prototype.labelMouseDownHandler = function (e) {
        this.isMouseClick = true;
        var rippleSpan = this.getWrapper().getElementsByClassName(RIPPLE)[0];
        Object(__WEBPACK_IMPORTED_MODULE_1__common_common__["e" /* rippleMouseHandler */])(e, rippleSpan);
    };
    CheckBox.prototype.labelMouseUpHandler = function (e) {
        this.isMouseClick = true;
        var rippleSpan = this.getWrapper().getElementsByClassName(RIPPLE)[0];
        if (rippleSpan) {
            var rippleElem = rippleSpan.querySelectorAll('.e-ripple-element');
            for (var i = 0; i < rippleElem.length - 1; i++) {
                rippleSpan.removeChild(rippleSpan.childNodes[i]);
            }
            Object(__WEBPACK_IMPORTED_MODULE_1__common_common__["e" /* rippleMouseHandler */])(e, rippleSpan);
        }
    };
    /**
     * Called internally if any of the property value changes.
     *
     * @private
     * @param {CheckBoxModel} newProp - Specifies new Properties
     * @param {CheckBoxModel} oldProp - Specifies old Properties
     *
     * @returns {void}
     */
    CheckBox.prototype.onPropertyChanged = function (newProp, oldProp) {
        var wrapper = this.getWrapper();
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'checked':
                    this.indeterminate = false;
                    this.element.indeterminate = false;
                    this.changeState(newProp.checked ? 'check' : 'uncheck');
                    break;
                case 'indeterminate':
                    if (newProp.indeterminate) {
                        this.changeState();
                    }
                    else {
                        this.element.indeterminate = false;
                        this.changeState(this.checked ? 'check' : 'uncheck');
                    }
                    break;
                case 'disabled':
                    if (newProp.disabled) {
                        this.setDisabled();
                        this.wrapper = this.getWrapper();
                        this.unWireEvents();
                    }
                    else {
                        this.element.disabled = false;
                        wrapper.classList.remove(DISABLED);
                        wrapper.setAttribute('aria-disabled', 'false');
                        this.wireEvents();
                    }
                    break;
                case 'cssClass':
                    if (oldProp.cssClass) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([wrapper], oldProp.cssClass.split(' '));
                    }
                    if (newProp.cssClass) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([wrapper], newProp.cssClass.split(' '));
                    }
                    break;
                case 'enableRtl':
                    if (newProp.enableRtl) {
                        wrapper.classList.add(RTL);
                    }
                    else {
                        wrapper.classList.remove(RTL);
                    }
                    break;
                case 'label':
                    this.setText(newProp.label);
                    break;
                case 'labelPosition': {
                    var label = wrapper.getElementsByClassName(LABEL)[0];
                    var labelWrap = wrapper.getElementsByTagName('label')[0];
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(label);
                    if (newProp.labelPosition === 'After') {
                        labelWrap.appendChild(label);
                    }
                    else {
                        labelWrap.insertBefore(label, wrapper.getElementsByClassName(FRAME)[0]);
                    }
                    break;
                }
                case 'name':
                    this.element.setAttribute('name', newProp.name);
                    break;
                case 'value':
                    if (this.isVue && typeof newProp.value === 'object') {
                        break;
                    }
                    this.element.setAttribute('value', newProp.value);
                    break;
                case 'htmlAttributes':
                    this.updateHtmlAttributeToWrapper();
                    break;
            }
        }
    };
    /**
     * Initialize Angular, React and Unique ID support.
     *
     * @private
     * @returns {void}
     */
    CheckBox.prototype.preRender = function () {
        var element = this.element;
        this.tagName = this.element.tagName;
        element = Object(__WEBPACK_IMPORTED_MODULE_1__common_common__["g" /* wrapperInitialize */])(this.createElement, 'EJS-CHECKBOX', 'checkbox', element, WRAPPER, 'checkbox');
        this.element = element;
        if (this.element.getAttribute('type') !== 'checkbox') {
            this.element.setAttribute('type', 'checkbox');
        }
        if (!this.element.id) {
            this.element.id = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('e-' + this.getModuleName());
        }
    };
    /**
     * Initialize the control rendering.
     *
     * @private
     * @returns {void}
     */
    CheckBox.prototype.render = function () {
        this.initWrapper();
        this.initialize();
        if (!this.disabled) {
            this.wireEvents();
        }
        this.updateHtmlAttributeToWrapper();
        this.updateVueArrayModel(true);
        this.renderComplete();
        this.wrapper = this.getWrapper();
    };
    CheckBox.prototype.setDisabled = function () {
        var wrapper = this.getWrapper();
        this.element.disabled = true;
        wrapper.classList.add(DISABLED);
        wrapper.setAttribute('aria-disabled', 'true');
    };
    CheckBox.prototype.setText = function (text) {
        var wrapper = this.getWrapper();
        if (!wrapper) {
            return;
        }
        var label = wrapper.getElementsByClassName(LABEL)[0];
        if (label) {
            label.textContent = text;
        }
        else {
            text = (this.enableHtmlSanitizer) ? __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(text) : text;
            label = this.createElement('span', { className: LABEL, innerHTML: text });
            var labelWrap = wrapper.getElementsByTagName('label')[0];
            if (this.labelPosition === 'Before') {
                labelWrap.insertBefore(label, wrapper.getElementsByClassName(FRAME)[0]);
            }
            else {
                labelWrap.appendChild(label);
            }
        }
    };
    CheckBox.prototype.changeHandler = function (e) {
        e.stopPropagation();
    };
    CheckBox.prototype.formResetHandler = function () {
        this.checked = this.initialCheckedValue;
        this.element.checked = this.initialCheckedValue;
    };
    CheckBox.prototype.unWireEvents = function () {
        var wrapper = this.wrapper;
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(wrapper, 'click', this.clickHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'keyup', this.keyUpHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'focus', this.focusHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'focusout', this.focusOutHandler);
        var label = wrapper.getElementsByTagName('label')[0];
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(label, 'mousedown', this.labelMouseDownHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(label, 'mouseup', this.labelMouseUpHandler);
        var formElem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, 'form');
        if (formElem) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(formElem, 'reset', this.formResetHandler);
        }
        if (this.tagName === 'EJS-CHECKBOX') {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'change', this.changeHandler);
        }
    };
    CheckBox.prototype.wireEvents = function () {
        var wrapper = this.getWrapper();
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(wrapper, 'click', this.clickHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'keyup', this.keyUpHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'focus', this.focusHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'focusout', this.focusOutHandler, this);
        var label = wrapper.getElementsByTagName('label')[0];
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(label, 'mousedown', this.labelMouseDownHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(label, 'mouseup', this.labelMouseUpHandler, this);
        var formElem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, 'form');
        if (formElem) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(formElem, 'reset', this.formResetHandler, this);
        }
        if (this.tagName === 'EJS-CHECKBOX') {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'change', this.changeHandler, this);
        }
    };
    CheckBox.prototype.updateVueArrayModel = function (init) {
        if (this.isVue && typeof this.value === 'object') {
            var value = this.element.value;
            if (value && this.value) {
                if (init) {
                    for (var i = 0; i < this.value.length; i++) {
                        if (value === this.value[i]) {
                            this.changeState('check');
                            this.setProperties({ 'checked': true }, true);
                        }
                    }
                }
                else {
                    var index = this.value.indexOf(value);
                    if (this.checked) {
                        if (index < 0) {
                            this.value.push(value);
                        }
                    }
                    else {
                        if (index > -1) {
                            this.value.splice(index, 1);
                        }
                    }
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    return this.value;
                }
            }
        }
        return this.validCheck ? this.element.checked : !this.element.checked;
    };
    CheckBox.prototype.updateHtmlAttributeToWrapper = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.htmlAttributes)) {
            for (var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++) {
                var key = _a[_i];
                if (containerAttr.indexOf(key) > -1) {
                    var wrapper = this.getWrapper();
                    if (key === 'class') {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([wrapper], this.htmlAttributes[key].split(' '));
                    }
                    else if (key === 'title') {
                        wrapper.setAttribute(key, this.htmlAttributes[key]);
                    }
                    else if (key === 'style') {
                        var frameSpan = this.getWrapper().getElementsByClassName(FRAME)[0];
                        frameSpan.setAttribute(key, this.htmlAttributes[key]);
                    }
                    else {
                        this.element.setAttribute(key, this.htmlAttributes[key]);
                    }
                }
            }
        }
    };
    /**
     * Click the CheckBox element
     * its native method
     *
     * @public
     * @returns {void}
     */
    CheckBox.prototype.click = function () {
        this.element.click();
    };
    /**
     * Sets the focus to CheckBox
     * its native method
     *
     * @public
     * @returns {void}
     */
    CheckBox.prototype.focusIn = function () {
        this.element.focus();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], CheckBox.prototype, "change", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], CheckBox.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], CheckBox.prototype, "checked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], CheckBox.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], CheckBox.prototype, "disabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], CheckBox.prototype, "indeterminate", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], CheckBox.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('After')
    ], CheckBox.prototype, "labelPosition", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], CheckBox.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], CheckBox.prototype, "value", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], CheckBox.prototype, "enableHtmlSanitizer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])({})
    ], CheckBox.prototype, "htmlAttributes", void 0);
    CheckBox = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], CheckBox);
    return CheckBox;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__radio_button__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/**
 * RadioButton modules
 */



/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RadioButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_common__ = __webpack_require__(21);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var LABEL = 'e-label';
var RIPPLE = 'e-ripple-container';
var RTL = 'e-rtl';
var WRAPPER = 'e-radio-wrapper';
var ATTRIBUTES = ['title', 'class', 'style', 'disabled', 'readonly', 'name', 'value'];
/**
 * The RadioButton is a graphical user interface element that allows you to select one option from the choices.
 * It contains checked and unchecked states.
 * ```html
 * <input type="radio" id="radio"/>
 * <script>
 * var radioObj = new RadioButton({ label: "Default" });
 * radioObj.appendTo("#radio");
 * </script>
 * ```
 */
var RadioButton = /** @class */ (function (_super) {
    __extends(RadioButton, _super);
    /**
     * Constructor for creating the widget
     *
     * @private
     * @param {RadioButtonModel} options - Specifies Radio button model
     * @param {string | HTMLInputElement} element - Specifies target element
     */
    function RadioButton(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.isFocused = false;
        return _this;
    }
    RadioButton_1 = RadioButton;
    RadioButton.prototype.changeHandler = function (event) {
        this.checked = true;
        this.dataBind();
        var value = this.element.getAttribute('value');
        value = this.isVue && value ? this.element.value : this.value;
        this.trigger('change', { value: value, event: event });
        if (this.tagName === 'EJS-RADIOBUTTON') {
            event.stopPropagation();
        }
    };
    RadioButton.prototype.updateChange = function () {
        var input;
        var instance;
        var radioGrp = this.getRadioGroup();
        for (var i = 0; i < radioGrp.length; i++) {
            input = radioGrp[i];
            if (input !== this.element) {
                instance = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(input, RadioButton_1);
                instance.checked = false;
                if (this.tagName === 'EJS-RADIOBUTTON') {
                    instance.angularValue = this.value;
                }
            }
        }
    };
    /**
     * Destroys the widget.
     *
     * @returns {void}
     */
    RadioButton.prototype.destroy = function () {
        var _this = this;
        var radioWrap = this.wrapper;
        _super.prototype.destroy.call(this);
        if (radioWrap) {
            if (!this.disabled) {
                this.unWireEvents();
            }
            if (this.tagName === 'INPUT') {
                if (radioWrap.parentNode) {
                    radioWrap.parentNode.insertBefore(this.element, radioWrap);
                }
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(radioWrap);
                this.element.checked = false;
                ['name', 'value', 'disabled'].forEach(function (key) {
                    _this.element.removeAttribute(key);
                });
            }
            else {
                ['role', 'aria-checked', 'class'].forEach(function (key) {
                    radioWrap.removeAttribute(key);
                });
                radioWrap.innerHTML = '';
            }
        }
    };
    RadioButton.prototype.focusHandler = function () {
        this.isFocused = true;
    };
    RadioButton.prototype.focusOutHandler = function () {
        var label = this.getLabel();
        if (label) {
            label.classList.remove('e-focus');
        }
    };
    RadioButton.prototype.getModuleName = function () {
        return 'radio';
    };
    /**
     * To get the value of selected radio button in a group.
     *
     * @method getSelectedValue
     * @returns {string} - Selected Value
     */
    RadioButton.prototype.getSelectedValue = function () {
        var input;
        var radioGrp = this.getRadioGroup();
        for (var i = 0, len = radioGrp.length; i < len; i++) {
            input = radioGrp[i];
            if (input.checked) {
                return input.value;
            }
        }
        return '';
    };
    RadioButton.prototype.getRadioGroup = function () {
        return document.querySelectorAll('input.e-radio[name="' + this.element.getAttribute('name') + '"]');
    };
    /**
     * Gets the properties to be maintained in the persistence state.
     *
     * @private
     * @returns {string} - Persist Data
     */
    RadioButton.prototype.getPersistData = function () {
        return this.addOnPersist(['checked']);
    };
    RadioButton.prototype.getWrapper = function () {
        if (this.element) {
            return this.element.parentElement;
        }
        else {
            return null;
        }
    };
    RadioButton.prototype.getLabel = function () {
        if (this.element) {
            return this.element.nextElementSibling;
        }
        else {
            return null;
        }
    };
    RadioButton.prototype.initialize = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.initialCheckedValue)) {
            this.initialCheckedValue = this.checked;
        }
        this.initWrapper();
        this.updateHtmlAttribute();
        if (this.name) {
            this.element.setAttribute('name', this.name);
        }
        var value = this.element.getAttribute('value');
        if (this.isVue && value && value === this.value) {
            this.checked = true;
        }
        if (this.isVue ? this.value && !value : this.value) {
            this.element.setAttribute('value', this.value);
        }
        if (this.checked) {
            this.element.checked = true;
        }
        if (this.disabled) {
            this.setDisabled();
        }
    };
    RadioButton.prototype.initWrapper = function () {
        var rippleSpan;
        var wrapper = this.element.parentElement;
        if (!wrapper.classList.contains(WRAPPER)) {
            wrapper = this.createElement('div', { className: WRAPPER });
            this.element.parentNode.insertBefore(wrapper, this.element);
        }
        var label = this.createElement('label', { attrs: { for: this.element.id } });
        wrapper.appendChild(this.element);
        wrapper.appendChild(label);
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["R" /* isRippleEnabled */]) {
            rippleSpan = this.createElement('span', { className: (RIPPLE) });
            label.appendChild(rippleSpan);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_0" /* rippleEffect */])(rippleSpan, {
                duration: 400,
                isCenterRipple: true
            });
        }
        wrapper.classList.add('e-wrapper');
        if (this.enableRtl) {
            label.classList.add(RTL);
        }
        if (this.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([wrapper], this.cssClass.split(' '));
        }
        if (this.label) {
            this.setText(this.label);
        }
    };
    RadioButton.prototype.keyUpHandler = function () {
        if (this.isFocused) {
            this.getLabel().classList.add('e-focus');
        }
    };
    RadioButton.prototype.labelRippleHandler = function (e) {
        var ripple = this.getLabel().getElementsByClassName(RIPPLE)[0];
        Object(__WEBPACK_IMPORTED_MODULE_1__common_common__["e" /* rippleMouseHandler */])(e, ripple);
    };
    RadioButton.prototype.formResetHandler = function () {
        this.checked = this.initialCheckedValue;
        if (this.initialCheckedValue) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'checked': 'true' });
        }
    };
    /**
     * Called internally if any of the property value changes.
     *
     * @private
     * @param {RadioButtonModel} newProp - Specifies New Properties
     * @param {RadioButtonModel} oldProp - Specifies Old Properties
     * @returns {void}
     */
    RadioButton.prototype.onPropertyChanged = function (newProp, oldProp) {
        var wrap = this.getWrapper();
        var label = this.getLabel();
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'checked':
                    if (newProp.checked) {
                        this.updateChange();
                    }
                    this.element.checked = newProp.checked;
                    break;
                case 'disabled':
                    if (newProp.disabled) {
                        this.setDisabled();
                        this.unWireEvents();
                    }
                    else {
                        this.element.disabled = false;
                        this.wireEvents();
                    }
                    break;
                case 'cssClass':
                    if (oldProp.cssClass) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([wrap], oldProp.cssClass.split(' '));
                    }
                    if (newProp.cssClass) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([wrap], newProp.cssClass.split(' '));
                    }
                    break;
                case 'enableRtl':
                    if (newProp.enableRtl) {
                        label.classList.add(RTL);
                    }
                    else {
                        label.classList.remove(RTL);
                    }
                    break;
                case 'label':
                    this.setText(newProp.label);
                    break;
                case 'labelPosition':
                    if (newProp.labelPosition === 'Before') {
                        label.classList.add('e-right');
                    }
                    else {
                        label.classList.remove('e-right');
                    }
                    break;
                case 'name':
                    this.element.setAttribute('name', newProp.name);
                    break;
                case 'value':
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.htmlAttributes) && this.htmlAttributes.value) {
                        break;
                    }
                    this.element.setAttribute('value', newProp.value);
                    break;
                case 'htmlAttributes':
                    this.updateHtmlAttribute();
                    break;
            }
        }
    };
    /**
     * Initialize checked Property, Angular and React and Unique ID support.
     *
     * @private
     * @returns {void}
     */
    RadioButton.prototype.preRender = function () {
        var element = this.element;
        this.formElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, 'form');
        this.tagName = this.element.tagName;
        element = Object(__WEBPACK_IMPORTED_MODULE_1__common_common__["g" /* wrapperInitialize */])(this.createElement, 'EJS-RADIOBUTTON', 'radio', element, WRAPPER, 'radio');
        this.element = element;
        if (this.element.getAttribute('type') !== 'radio') {
            this.element.setAttribute('type', 'radio');
        }
        if (!this.element.id) {
            this.element.id = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('e-' + this.getModuleName());
        }
        if (this.tagName === 'EJS-RADIOBUTTON') {
            var formControlName = this.element.getAttribute('formcontrolname');
            if (formControlName) {
                this.setProperties({ 'name': formControlName }, true);
                this.element.setAttribute('name', formControlName);
            }
        }
    };
    /**
     * Initialize the control rendering
     *
     * @private
     * @returns {void}
     */
    RadioButton.prototype.render = function () {
        this.initialize();
        if (!this.disabled) {
            this.wireEvents();
        }
        this.renderComplete();
        this.wrapper = this.getWrapper();
    };
    RadioButton.prototype.setDisabled = function () {
        this.element.disabled = true;
    };
    RadioButton.prototype.setText = function (text) {
        var label = this.getLabel();
        var textLabel = label.getElementsByClassName(LABEL)[0];
        if (textLabel) {
            textLabel.textContent = text;
        }
        else {
            text = (this.enableHtmlSanitizer) ? __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(text) : text;
            textLabel = this.createElement('span', { className: LABEL, innerHTML: text });
            label.appendChild(textLabel);
        }
        if (this.labelPosition === 'Before') {
            this.getLabel().classList.add('e-right');
        }
        else {
            this.getLabel().classList.remove('e-right');
        }
    };
    RadioButton.prototype.updateHtmlAttribute = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.htmlAttributes)) {
            for (var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++) {
                var key = _a[_i];
                if (ATTRIBUTES.indexOf(key) > -1) {
                    var wrapper = this.element.parentElement;
                    if (key === 'class') {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([wrapper], this.htmlAttributes[key].split(' '));
                    }
                    else if (key === 'title' || key === 'style') {
                        wrapper.setAttribute(key, this.htmlAttributes[key]);
                    }
                    else {
                        this.element.setAttribute(key, this.htmlAttributes[key]);
                    }
                }
            }
        }
    };
    RadioButton.prototype.unWireEvents = function () {
        var label = this.wrapper;
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'change', this.changeHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'focus', this.focusHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'focusout', this.focusOutHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'keyup', this.keyUpHandler);
        var rippleLabel = label.getElementsByTagName('label')[0];
        if (rippleLabel) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(rippleLabel, 'mousedown', this.labelRippleHandler);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(rippleLabel, 'mouseup', this.labelRippleHandler);
        }
        if (this.formElement) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.formElement, 'reset', this.formResetHandler);
        }
    };
    RadioButton.prototype.wireEvents = function () {
        var label = this.getLabel();
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'change', this.changeHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'keyup', this.keyUpHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'focus', this.focusHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'focusout', this.focusOutHandler, this);
        var rippleLabel = label.getElementsByClassName(LABEL)[0];
        if (rippleLabel) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(rippleLabel, 'mousedown', this.labelRippleHandler, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(rippleLabel, 'mouseup', this.labelRippleHandler, this);
        }
        if (this.formElement) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.formElement, 'reset', this.formResetHandler, this);
        }
    };
    /**
     * Click the RadioButton element
     * its native method
     *
     * @public
     * @returns {void}
     */
    RadioButton.prototype.click = function () {
        this.element.click();
    };
    /**
     * Sets the focus to RadioButton
     * its native method
     *
     * @public
     * @returns {void}
     */
    RadioButton.prototype.focusIn = function () {
        this.element.focus();
    };
    var RadioButton_1;
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], RadioButton.prototype, "change", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], RadioButton.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], RadioButton.prototype, "checked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], RadioButton.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], RadioButton.prototype, "disabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], RadioButton.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('After')
    ], RadioButton.prototype, "labelPosition", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], RadioButton.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], RadioButton.prototype, "value", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], RadioButton.prototype, "enableHtmlSanitizer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])({})
    ], RadioButton.prototype, "htmlAttributes", void 0);
    RadioButton = RadioButton_1 = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], RadioButton);
    return RadioButton;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__switch__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/**
 * Switch modules
 */



/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_common__ = __webpack_require__(21);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var DISABLED = 'e-switch-disabled';
var RIPPLE = 'e-ripple-container';
var RIPPLE_CHECK = 'e-ripple-check';
var RTL = 'e-rtl';
var WRAPPER = 'e-switch-wrapper';
var ACTIVE = 'e-switch-active';
/**
 * The Switch is a graphical user interface element that allows you to toggle between checked and unchecked states.
 * ```html
 * <input type="checkbox" id="switch"/>
 * <script>
 * var switchObj = new Switch({});
 * switchObj.appendTo("#switch");
 * </script>
 * ```
 */
var Switch = /** @class */ (function (_super) {
    __extends(Switch, _super);
    /**
     * Constructor for creating the widget.
     *
     * @private
     *
     * @param {SwitchModel} options switch model
     * @param {string | HTMLInputElement} element target element
     *
     */
    function Switch(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.isFocused = false;
        _this.isDrag = false;
        return _this;
    }
    Switch.prototype.changeState = function (state) {
        var ariaState;
        var rippleSpan;
        var wrapper = this.getWrapper();
        var bar = wrapper.querySelector('.e-switch-inner');
        var handle = wrapper.querySelector('.e-switch-handle');
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["R" /* isRippleEnabled */]) {
            rippleSpan = wrapper.getElementsByClassName(RIPPLE)[0];
        }
        if (state) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([bar, handle], ACTIVE);
            ariaState = 'true';
            this.element.checked = true;
            this.checked = true;
            if (rippleSpan) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([rippleSpan], [RIPPLE_CHECK]);
            }
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([bar, handle], ACTIVE);
            ariaState = 'false';
            this.element.checked = false;
            this.checked = false;
            if (rippleSpan) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([rippleSpan], [RIPPLE_CHECK]);
            }
        }
        wrapper.setAttribute('aria-checked', ariaState);
    };
    Switch.prototype.clickHandler = function (evt) {
        this.isDrag = false;
        this.focusOutHandler();
        this.changeState(!this.checked);
        this.element.focus();
        var changeEventArgs = { checked: this.element.checked, event: evt };
        this.trigger('change', changeEventArgs);
    };
    /**
     * Destroys the Switch widget.
     *
     * @returns {void}
     */
    Switch.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        if (!this.disabled) {
            this.unWireEvents();
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__common_common__["b" /* destroy */])(this, this.getWrapper(), this.tagName);
    };
    Switch.prototype.focusHandler = function () {
        this.isFocused = true;
    };
    Switch.prototype.focusOutHandler = function () {
        this.getWrapper().classList.remove('e-focus');
    };
    /**
     * Gets the module name.
     *
     * @private
     * @returns {string} - Module Name
     */
    Switch.prototype.getModuleName = function () {
        return 'switch';
    };
    /**
     * Gets the properties to be maintained in the persistence state.
     *
     * @private
     * @returns {string} - Persist data
     */
    Switch.prototype.getPersistData = function () {
        return this.addOnPersist(['checked']);
    };
    Switch.prototype.getWrapper = function () {
        return this.element.parentElement;
    };
    Switch.prototype.initialize = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.initialSwitchCheckedValue)) {
            this.initialSwitchCheckedValue = this.checked;
        }
        if (this.name) {
            this.element.setAttribute('name', this.name);
        }
        if (this.value) {
            this.element.setAttribute('value', this.value);
        }
        if (this.checked) {
            this.changeState(true);
        }
        if (this.disabled) {
            this.setDisabled();
        }
        if (this.onLabel || this.offLabel) {
            this.setLabel(this.onLabel, this.offLabel);
        }
    };
    Switch.prototype.initWrapper = function () {
        var wrapper = this.element.parentElement;
        if (!wrapper.classList.contains(WRAPPER)) {
            wrapper = this.createElement('div', {
                className: WRAPPER, attrs: { 'aria-checked': 'false' }
            });
            this.element.parentNode.insertBefore(wrapper, this.element);
        }
        var switchInner = this.createElement('span', { className: 'e-switch-inner' });
        var onLabel = this.createElement('span', { className: 'e-switch-on' });
        var offLabel = this.createElement('span', { className: 'e-switch-off' });
        var handle = this.createElement('span', { className: 'e-switch-handle' });
        wrapper.appendChild(this.element);
        Object(__WEBPACK_IMPORTED_MODULE_1__common_common__["f" /* setHiddenInput */])(this, wrapper);
        switchInner.appendChild(onLabel);
        switchInner.appendChild(offLabel);
        wrapper.appendChild(switchInner);
        wrapper.appendChild(handle);
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["R" /* isRippleEnabled */]) {
            var rippleSpan = this.createElement('span', { className: RIPPLE });
            handle.appendChild(rippleSpan);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_0" /* rippleEffect */])(rippleSpan, { duration: 400, isCenterRipple: true });
        }
        wrapper.classList.add('e-wrapper');
        if (this.enableRtl) {
            wrapper.classList.add(RTL);
        }
        if (this.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([wrapper], this.cssClass.split(' '));
        }
    };
    /**
     * Called internally if any of the property value changes.
     *
     * @private
     * @param {SwitchModel} newProp - Specifies New Properties
     * @param {SwitchModel} oldProp - Specifies Old Properties
     * @returns {void}
     */
    Switch.prototype.onPropertyChanged = function (newProp, oldProp) {
        var wrapper = this.getWrapper();
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'checked':
                    this.changeState(newProp.checked);
                    break;
                case 'disabled':
                    if (newProp.disabled) {
                        this.setDisabled();
                        this.unWireEvents();
                    }
                    else {
                        this.element.disabled = false;
                        wrapper.classList.remove(DISABLED);
                        wrapper.setAttribute('aria-disabled', 'false');
                        this.wireEvents();
                    }
                    break;
                case 'value':
                    this.element.setAttribute('value', newProp.value);
                    break;
                case 'name':
                    this.element.setAttribute('name', newProp.name);
                    break;
                case 'onLabel':
                case 'offLabel':
                    this.setLabel(newProp.onLabel, newProp.offLabel);
                    break;
                case 'enableRtl':
                    if (newProp.enableRtl) {
                        wrapper.classList.add(RTL);
                    }
                    else {
                        wrapper.classList.remove(RTL);
                    }
                    break;
                case 'cssClass':
                    if (oldProp.cssClass) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([wrapper], oldProp.cssClass.split(' '));
                    }
                    if (newProp.cssClass) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([wrapper], newProp.cssClass.split(' '));
                    }
                    break;
            }
        }
    };
    /**
     * Initialize Angular, React and Unique ID support.
     *
     * @private
     * @returns {void}
     */
    Switch.prototype.preRender = function () {
        var element = this.element;
        this.formElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, 'form');
        this.tagName = this.element.tagName;
        Object(__WEBPACK_IMPORTED_MODULE_1__common_common__["d" /* preRender */])(this, 'EJS-SWITCH', WRAPPER, element, this.getModuleName());
    };
    /**
     * Initialize control rendering.
     *
     * @private
     * @returns {void}
     */
    Switch.prototype.render = function () {
        this.initWrapper();
        this.initialize();
        if (!this.disabled) {
            this.wireEvents();
        }
        this.renderComplete();
    };
    Switch.prototype.rippleHandler = function (e) {
        var rippleSpan = this.getWrapper().getElementsByClassName(RIPPLE)[0];
        Object(__WEBPACK_IMPORTED_MODULE_1__common_common__["e" /* rippleMouseHandler */])(e, rippleSpan);
        if (e.type === 'mousedown' && e.currentTarget.classList.contains('e-switch-wrapper') && e.which === 1) {
            this.isDrag = true;
            this.isFocused = false;
        }
    };
    Switch.prototype.rippleTouchHandler = function (eventType) {
        var rippleSpan = this.getWrapper().getElementsByClassName(RIPPLE)[0];
        if (rippleSpan) {
            var event_1 = document.createEvent('MouseEvents');
            event_1.initEvent(eventType, false, true);
            rippleSpan.dispatchEvent(event_1);
        }
    };
    Switch.prototype.setDisabled = function () {
        var wrapper = this.getWrapper();
        this.element.disabled = true;
        wrapper.classList.add(DISABLED);
        wrapper.setAttribute('aria-disabled', 'true');
    };
    Switch.prototype.setLabel = function (onText, offText) {
        var wrapper = this.getWrapper();
        if (onText) {
            wrapper.querySelector('.e-switch-on').textContent = onText;
        }
        if (offText) {
            wrapper.querySelector('.e-switch-off').textContent = offText;
        }
    };
    Switch.prototype.switchFocusHandler = function () {
        if (this.isFocused) {
            this.getWrapper().classList.add('e-focus');
        }
    };
    Switch.prototype.switchMouseUp = function (e) {
        var target = e.target;
        if (e.type === 'touchmove') {
            e.preventDefault();
        }
        if (e.type === 'touchstart') {
            this.isDrag = true;
            this.rippleTouchHandler('mousedown');
        }
        if (this.isDrag) {
            if ((e.type === 'mouseup' && target.className.indexOf('e-switch') < 0) || e.type === 'touchend') {
                this.clickHandler(e);
                this.rippleTouchHandler('mouseup');
                e.preventDefault();
            }
        }
    };
    Switch.prototype.formResetHandler = function () {
        this.checked = this.initialSwitchCheckedValue;
        this.element.checked = this.initialSwitchCheckedValue;
    };
    /**
     * Toggle the Switch component state into checked/unchecked.
     *
     * @returns {void}
     */
    Switch.prototype.toggle = function () {
        this.clickHandler();
    };
    Switch.prototype.wireEvents = function () {
        var wrapper = this.getWrapper();
        this.delegateMouseUpHandler = this.switchMouseUp.bind(this);
        this.delegateKeyUpHandler = this.switchFocusHandler.bind(this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(wrapper, 'click', this.clickHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'focus', this.focusHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'focusout', this.focusOutHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'mouseup', this.delegateMouseUpHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'keyup', this.delegateKeyUpHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(wrapper, 'mousedown mouseup', this.rippleHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(wrapper, 'touchstart touchmove touchend', this.switchMouseUp, this);
        if (this.formElement) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.formElement, 'reset', this.formResetHandler, this);
        }
    };
    Switch.prototype.unWireEvents = function () {
        var wrapper = this.getWrapper();
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(wrapper, 'click', this.clickHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'focus', this.focusHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'focusout', this.focusOutHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'mouseup', this.delegateMouseUpHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'keyup', this.delegateKeyUpHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(wrapper, 'mousedown mouseup', this.rippleHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(wrapper, 'touchstart touchmove touchend', this.switchMouseUp);
        if (this.formElement) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.formElement, 'reset', this.formResetHandler);
        }
    };
    /**
     * Click the switch element
     * its native method
     *
     * @public
     * @returns {void}
     */
    Switch.prototype.click = function () {
        this.element.click();
    };
    /**
     * Sets the focus to Switch
     * its native method
     *
     * @public
     */
    Switch.prototype.focusIn = function () {
        this.element.focus();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Switch.prototype, "change", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Switch.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Switch.prototype, "checked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Switch.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Switch.prototype, "disabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Switch.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Switch.prototype, "onLabel", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Switch.prototype, "offLabel", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Switch.prototype, "value", void 0);
    Switch = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], Switch);
    return Switch;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chip_list__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chip__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/**
 * Chip modules
 */




/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export classNames */
/* unused harmony export ChipList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var classNames = {
    chipSet: 'e-chip-set',
    chip: 'e-chip',
    avatar: 'e-chip-avatar',
    text: 'e-chip-text',
    icon: 'e-chip-icon',
    delete: 'e-chip-delete',
    deleteIcon: 'e-dlt-btn',
    multiSelection: 'e-multi-selection',
    singleSelection: 'e-selection',
    active: 'e-active',
    chipWrapper: 'e-chip-avatar-wrap',
    iconWrapper: 'e-chip-icon-wrap',
    focused: 'e-focused',
    disabled: 'e-disabled',
    rtl: 'e-rtl'
};
/**
 * A chip component is a small block of essential information, mostly used on contacts or filter tags.
 * ```html
 * <div id="chip"></div>
 * ```
 * ```typescript
 * <script>
 * var chipObj = new ChipList();
 * chipObj.appendTo("#chip");
 * </script>
 * ```
 */
var ChipList = /** @class */ (function (_super) {
    __extends(ChipList, _super);
    function ChipList(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.multiSelectedChip = [];
        return _this;
    }
    /**
     * Initialize the event handler
     *
     * @private
     */
    ChipList.prototype.preRender = function () {
        //prerender
    };
    /**
     * To find the chips length.
     *
     * @returns boolean
     * @private
     */
    ChipList.prototype.chipType = function () {
        return (this.chips && this.chips.length && this.chips.length > 0);
    };
    /**
     * To Initialize the control rendering.
     *
     * @returns void
     * @private
     */
    ChipList.prototype.render = function () {
        var property;
        this.type = this.chips.length ? 'chipset' : (this.text || this.element.innerText ? 'chip' : 'chipset');
        this.setAttributes();
        this.createChip();
        this.setRtl();
        this.select(this.selectedChips, property);
        this.wireEvent(false);
        this.rippleFunction = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_0" /* rippleEffect */])(this.element, {
            selector: '.e-chip'
        });
        this.renderComplete();
    };
    ChipList.prototype.createChip = function () {
        this.innerText = (this.element.innerText && this.element.innerText.length !== 0)
            ? this.element.innerText.trim() : this.element.innerText;
        this.element.innerHTML = '';
        this.chipCreation(this.type === 'chip' ? [this.innerText ? this.innerText : this.text] : this.chips);
    };
    ChipList.prototype.setAttributes = function () {
        if (this.type === 'chip') {
            this.element.tabIndex = 0;
            this.element.setAttribute('role', 'option');
        }
        else {
            this.element.classList.add(classNames.chipSet);
            this.element.setAttribute('role', 'listbox');
            if (this.selection === 'Multiple') {
                this.element.classList.add(classNames.multiSelection);
                this.element.setAttribute('aria-multiselectable', 'true');
            }
            else if (this.selection === 'Single') {
                this.element.classList.add(classNames.singleSelection);
                this.element.setAttribute('aria-multiselectable', 'false');
            }
            else {
                this.element.setAttribute('aria-multiselectable', 'false');
            }
        }
    };
    ChipList.prototype.setRtl = function () {
        this.element.classList[this.enableRtl ? 'add' : 'remove'](classNames.rtl);
    };
    ChipList.prototype.chipCreation = function (data) {
        var chipListArray = [];
        for (var i = 0; i < data.length; i++) {
            var fieldsData = this.getFieldValues(data[i]);
            var chipArray = this.elementCreation(fieldsData);
            var className = (classNames.chip + ' ' + (fieldsData.enabled ? ' ' : classNames.disabled) + ' ' +
                (fieldsData.avatarIconCss || fieldsData.avatarText ? classNames.chipWrapper : (fieldsData.leadingIconCss ?
                    classNames.iconWrapper : ' ')) + ' ' + fieldsData.cssClass).split(' ').filter(function (css) { return css; });
            if (!this.chipType()) {
                chipListArray = chipArray;
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], className);
                this.element.setAttribute('aria-label', fieldsData.text);
                if (fieldsData.value) {
                    this.element.setAttribute('data-value', fieldsData.value.toString());
                }
            }
            else {
                var wrapper = this.createElement('DIV', {
                    className: className.join(' '), attrs: {
                        tabIndex: '0', role: 'option',
                        'aria-label': fieldsData.text, 'aria-selected': 'false'
                    }
                });
                if (fieldsData.value) {
                    wrapper.setAttribute('data-value', fieldsData.value.toString());
                }
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(chipArray, wrapper);
                chipListArray.push(wrapper);
            }
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(chipListArray, this.element);
    };
    ChipList.prototype.getFieldValues = function (data) {
        var chipEnabled = !(this.enabled.toString() === 'false');
        var fields = {
            text: typeof data === 'object' ? (data.text ? data.text.toString() : this.text.toString()) :
                (!this.chipType() ? (this.innerText ? this.innerText : this.text.toString()) : data.toString()),
            cssClass: typeof data === 'object' ? (data.cssClass ? data.cssClass.toString() : this.cssClass.toString()) :
                (this.cssClass.toString()),
            leadingIconCss: typeof data === 'object' ? (data.leadingIconCss ? data.leadingIconCss.toString() :
                this.leadingIconCss.toString()) : (this.leadingIconCss.toString()),
            avatarIconCss: typeof data === 'object' ? (data.avatarIconCss ? data.avatarIconCss.toString() :
                this.avatarIconCss.toString()) : (this.avatarIconCss.toString()),
            avatarText: typeof data === 'object' ? (data.avatarText ? data.avatarText.toString() : this.avatarText.toString()) :
                (this.avatarText.toString()),
            trailingIconCss: typeof data === 'object' ? (data.trailingIconCss ? data.trailingIconCss.toString() :
                this.trailingIconCss.toString()) : (this.trailingIconCss.toString()),
            enabled: typeof data === 'object' ? (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data.enabled) ? (data.enabled.toString() === 'false' ? false : true) :
                chipEnabled) : (chipEnabled),
            value: typeof data === 'object' ? ((data.value ? data.value.toString() : null)) : null,
            leadingIconUrl: typeof data === 'object' ? (data.leadingIconUrl ? data.leadingIconUrl.toString() : this.leadingIconUrl) :
                this.leadingIconUrl,
            trailingIconUrl: typeof data === 'object' ? (data.trailingIconUrl ? data.trailingIconUrl.toString() : this.trailingIconUrl) :
                this.trailingIconUrl
        };
        return fields;
    };
    ChipList.prototype.elementCreation = function (fields) {
        var chipArray = [];
        if (fields.avatarText || fields.avatarIconCss) {
            var className = (classNames.avatar + ' ' + fields.avatarIconCss).trim();
            var chipAvatarElement = this.createElement('span', { className: className });
            chipAvatarElement.innerText = fields.avatarText;
            chipArray.push(chipAvatarElement);
        }
        else if (fields.leadingIconCss) {
            var className = (classNames.icon + ' ' + fields.leadingIconCss).trim();
            var chipIconElement = this.createElement('span', { className: className });
            chipArray.push(chipIconElement);
        }
        else if (fields.leadingIconUrl) {
            var className = (classNames.avatar + ' ' + 'image-url').trim();
            var chipIconElement = this.createElement('span', { className: className });
            chipIconElement.style.backgroundImage = 'url(' + fields.leadingIconUrl + ')';
            chipArray.push(chipIconElement);
        }
        var chipTextElement = this.createElement('span', { className: classNames.text });
        chipTextElement.innerText = fields.text;
        chipArray.push(chipTextElement);
        if (fields.trailingIconCss || (this.chipType() && this.enableDelete)) {
            var className = (classNames.delete + ' ' +
                (fields.trailingIconCss ? fields.trailingIconCss : classNames.deleteIcon)).trim();
            var chipdeleteElement = this.createElement('span', { className: className });
            chipArray.push(chipdeleteElement);
        }
        else if (fields.trailingIconUrl) {
            var className = ('trailing-icon-url').trim();
            var chipIconsElement = this.createElement('span', { className: className });
            chipIconsElement.style.backgroundImage = 'url(' + fields.trailingIconUrl + ')';
            chipArray.push(chipIconsElement);
        }
        return chipArray;
    };
    /**
     * A function that finds chip based on given input.
     *
     * @param  {number | HTMLElement } fields - We can pass index number or element of chip.
     * {% codeBlock src='chips/find/index.md' %}{% endcodeBlock %}.
     */
    ChipList.prototype.find = function (fields) {
        var chipData;
        var chipElement = fields instanceof HTMLElement ?
            fields : this.element.querySelectorAll('.' + classNames.chip)[fields];
        if (chipElement && this.chipType()) {
            chipData = { text: undefined, index: undefined, element: undefined, data: undefined };
            chipData.index = Array.prototype.slice.call(this.element.querySelectorAll('.' + classNames.chip)).indexOf(chipElement);
            chipData.text = typeof this.chips[chipData.index] === 'object' ?
                (this.chips[chipData.index].text ?
                    this.chips[chipData.index].text.toString() : '') :
                this.chips[chipData.index].toString();
            chipData.data = this.chips[chipData.index];
            chipData.element = chipElement;
        }
        return chipData;
    };
    /**
     * Allows adding the chip item(s) by passing a single or array of string, number, or ChipModel values.
     *
     * @param  {string[] | number[] | ChipModel[] | string | number | ChipModel} chipsData - We can pass array of string or
     *  array of number or array of chip model or string data or number data or chip model.
     * {% codeBlock src='chips/add/index.md' %}{% endcodeBlock %}

     */
    ChipList.prototype.add = function (chipsData) {
        var _a;
        if (this.type !== 'chip') {
            var fieldData = chipsData instanceof Array ?
                chipsData : [chipsData];
            (_a = this.chips).push.apply(_a, fieldData);
            this.chipCreation(fieldData);
        }
    };
    /**
     * Allows selecting the chip item(s) by passing a single or array of string, number, or ChipModel values.
     *
     * @param  {number | number[] | HTMLElement | HTMLElement[]} fields - We can pass number or array of number
     *  or chip element or array of chip element.
     * {% codeBlock src='chips/select/index.md' %}{% endcodeBlock %}
     */
    ChipList.prototype.select = function (fields, selectionType) {
        this.onSelect(fields, false, selectionType);
    };
    ChipList.prototype.multiSelection = function (newProp) {
        var items = this.element.querySelectorAll('.' + 'e-chip');
        for (var j = 0; j < newProp.length; j++) {
            if (typeof newProp[j] === 'string') {
                for (var k = 0; k < items.length; k++) {
                    if (newProp[j] !== k) {
                        if (newProp[j] === items[k].attributes[5].value) {
                            this.multiSelectedChip.push(k);
                            break;
                        }
                    }
                }
            }
            else {
                this.multiSelectedChip.push(newProp[j]);
            }
        }
    };
    ChipList.prototype.onSelect = function (fields, callFromProperty, selectionType) {
        var index;
        var chipNodes;
        var chipValue;
        if (this.chipType() && this.selection !== 'None') {
            if (callFromProperty) {
                var chipElements = this.element.querySelectorAll('.' + classNames.chip);
                for (var i = 0; i < chipElements.length; i++) {
                    chipElements[i].setAttribute('aria-selected', 'false');
                    chipElements[i].classList.remove(classNames.active);
                }
            }
            var fieldData = fields instanceof Array ? fields : [fields];
            for (var i = 0; i < fieldData.length; i++) {
                var chipElement = fieldData[i] instanceof HTMLElement ? fieldData[i]
                    : this.element.querySelectorAll('.' + classNames.chip)[fieldData[i]];
                if (selectionType !== 'index') {
                    for (var j = 0; j < this.chips.length; j++) {
                        chipNodes = this.element.querySelectorAll('.' + classNames.chip)[j];
                        var fieldsData = this.getFieldValues(this.chips[j]);
                        if (selectionType === 'value') {
                            if (fieldsData.value !== null) {
                                chipValue = chipNodes.dataset.value;
                            }
                        }
                        else if (selectionType === 'text') {
                            chipValue = chipNodes.innerText;
                        }
                        if (chipValue === fieldData[i].toString()) {
                            index = j;
                            chipElement = this.element.querySelectorAll('.' + classNames.chip)[index];
                        }
                    }
                }
                if (chipElement instanceof HTMLElement) {
                    this.selectionHandler(chipElement);
                }
            }
        }
    };
    /**
     * Allows removing the chip item(s) by passing a single or array of string, number, or ChipModel values.
     *
     * @param  {number | number[] | HTMLElement | HTMLElement[]} fields - We can pass number or array of number
     *  or chip element or array of chip element.
     * {% codeBlock src='chips/remove/index.md' %}{% endcodeBlock %}
     */
    ChipList.prototype.remove = function (fields) {
        var _this = this;
        if (this.chipType()) {
            var fieldData = fields instanceof Array ? fields : [fields];
            var chipElements_1 = [];
            var chipCollection_1 = this.element.querySelectorAll('.' + classNames.chip);
            fieldData.forEach(function (data) {
                var chipElement = data instanceof HTMLElement ? data
                    : chipCollection_1[data];
                if (chipElement instanceof HTMLElement) {
                    chipElements_1.push(chipElement);
                }
            });
            chipElements_1.forEach(function (element) {
                var chips = _this.element.querySelectorAll('.' + classNames.chip);
                var index = Array.prototype.slice.call(chips).indexOf(element);
                _this.deleteHandler(element, index);
            });
        }
    };
    /**
     * Returns the selected chip(s) data.
     * {% codeBlock src='chips/getSelectedChips/index.md' %}{% endcodeBlock %}
     */
    ChipList.prototype.getSelectedChips = function () {
        var selectedChips;
        if (this.chipType() && this.selection !== 'None') {
            var selectedItems = { texts: [], Indexes: [], data: [], elements: [] };
            var items = this.element.querySelectorAll('.' + classNames.active);
            for (var i = 0; i < items.length; i++) {
                var chip = items[i];
                selectedItems.elements.push(chip);
                var index = Array.prototype.slice.call(this.element.querySelectorAll('.' + classNames.chip)).indexOf(chip);
                selectedItems.Indexes.push(index);
                selectedItems.data.push(this.chips[index]);
                var text = typeof this.chips[index] === 'object' ?
                    this.chips[index].text ? this.chips[index].text.toString()
                        : null : this.chips[index].toString();
                selectedItems.texts.push(text);
            }
            var selectedItem = {
                text: selectedItems.texts[0], index: selectedItems.Indexes[0],
                data: selectedItems.data[0], element: selectedItems.elements[0]
            };
            selectedChips = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(selectedItem.index) ?
                (this.selection === 'Multiple' ? selectedItems : selectedItem) : undefined;
        }
        return selectedChips;
    };
    ChipList.prototype.wireEvent = function (unWireEvent) {
        if (!unWireEvent) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'click', this.clickHandler, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'focusout', this.focusOutHandler, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'keydown', this.keyHandler, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'keyup', this.keyHandler, this);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'click', this.clickHandler);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'focusout', this.focusOutHandler);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'keydown', this.keyHandler);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'keyup', this.keyHandler);
        }
    };
    ChipList.prototype.keyHandler = function (e) {
        if (e.target.classList.contains(classNames.chip)) {
            if (e.type === 'keydown') {
                if (e.keyCode === 13 || e.keyCode === 32) {
                    this.clickHandler(e);
                }
                else if (e.keyCode === 46 && this.enableDelete) {
                    this.clickHandler(e, true);
                }
            }
            else if (e.keyCode === 9) {
                this.focusInHandler(e.target);
            }
        }
    };
    ChipList.prototype.focusInHandler = function (chipWrapper) {
        if (!chipWrapper.classList.contains(classNames.focused)) {
            chipWrapper.classList.add(classNames.focused);
        }
    };
    ChipList.prototype.focusOutHandler = function (e) {
        var chipWrapper = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.' + classNames.chip);
        var focusedElement = !this.chipType() ? (this.element.classList.contains(classNames.focused) ?
            this.element : null) : this.element.querySelector('.' + classNames.focused);
        if (chipWrapper && focusedElement) {
            focusedElement.classList.remove(classNames.focused);
        }
    };
    ChipList.prototype.clickHandler = function (e, del) {
        var _this = this;
        if (del === void 0) { del = false; }
        var chipWrapper = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.' + classNames.chip);
        if (chipWrapper) {
            // eslint-disable-next-line
            var chipDataArgs = void 0;
            if (this.chipType()) {
                chipDataArgs = this.find(chipWrapper);
            }
            else {
                var index = Array.prototype.slice.call(this.element.querySelectorAll('.' + classNames.chip)).indexOf(chipWrapper);
                chipDataArgs = {
                    text: this.innerText ? this.innerText : this.text,
                    element: chipWrapper, data: this.text, index: index
                };
            }
            chipDataArgs.event = e;
            chipDataArgs.cancel = false;
            this.trigger('beforeClick', chipDataArgs, function (observedArgs) {
                if (!observedArgs.cancel) {
                    _this.clickEventHandler(observedArgs.element, e, del);
                }
            });
        }
    };
    ChipList.prototype.clickEventHandler = function (chipWrapper, e, del) {
        var _this = this;
        if (this.chipType()) {
            var chipData_1 = this.find(chipWrapper);
            chipData_1.event = e;
            var deleteElement = e.target.classList.contains(classNames.deleteIcon) ?
                e.target : (del ? chipWrapper.querySelector('.' + classNames.deleteIcon) : undefined);
            if (deleteElement && this.enableDelete) {
                chipData_1.cancel = false;
                var deletedItemArgs = chipData_1;
                this.trigger('delete', deletedItemArgs, function (observedArgs) {
                    if (!observedArgs.cancel) {
                        _this.deleteHandler(observedArgs.element, observedArgs.index);
                        _this.selectionHandler(chipWrapper);
                        chipData_1.selected = observedArgs.element.classList.contains(classNames.active);
                        var selectedItemArgs = chipData_1;
                        _this.trigger('click', selectedItemArgs);
                        var chipElement = _this.element.querySelectorAll('.' + classNames.chip)[observedArgs.index];
                        if (chipElement) {
                            chipElement.focus();
                            _this.focusInHandler(chipElement);
                        }
                    }
                });
            }
            else if (this.selection !== 'None') {
                this.selectionHandler(chipWrapper);
                chipData_1.selected = chipWrapper.classList.contains(classNames.active);
                var selectedItemArgs = chipData_1;
                this.trigger('click', selectedItemArgs);
            }
            else {
                this.focusInHandler(chipWrapper);
                var clickedItemArgs = chipData_1;
                this.trigger('click', clickedItemArgs);
            }
        }
        else {
            this.focusInHandler(chipWrapper);
            var clickedItemArgs = {
                text: this.innerText ? this.innerText : this.text,
                element: chipWrapper, data: this.text, event: e
            };
            this.trigger('click', clickedItemArgs);
        }
    };
    ChipList.prototype.selectionHandler = function (chipWrapper) {
        if (this.selection === 'Single') {
            var activeElement = this.element.querySelector('.' + classNames.active);
            if (activeElement && activeElement !== chipWrapper) {
                activeElement.classList.remove(classNames.active);
                activeElement.setAttribute('aria-selected', 'false');
            }
            this.setProperties({ selectedChips: null }, true);
        }
        else {
            this.setProperties({ selectedChips: [] }, true);
        }
        if (chipWrapper.classList.contains(classNames.active)) {
            chipWrapper.classList.remove(classNames.active);
            chipWrapper.setAttribute('aria-selected', 'false');
        }
        else {
            chipWrapper.classList.add(classNames.active);
            chipWrapper.setAttribute('aria-selected', 'true');
        }
        this.updateSelectedChips();
    };
    ChipList.prototype.updateSelectedChips = function () {
        var chipListEle = this.element.querySelectorAll('.e-chip');
        var chipCollIndex = [];
        var chipCollValue = [];
        var chip = null;
        var value;
        for (var i = 0; i < chipListEle.length; i++) {
            var selectedEle = this.element.querySelectorAll('.e-chip')[i];
            if (selectedEle.getAttribute('aria-selected') === 'true') {
                value = selectedEle.getAttribute('data-value');
                if (this.selection === 'Single' && selectedEle.classList.contains('e-active')) {
                    chip = value ? value : i;
                    break;
                }
                else {
                    chip = value ? chipCollValue.push(value) : chipCollIndex.push(i);
                }
            }
        }
        this.setProperties({ selectedChips: this.selection === 'Single' ? chip : value ? chipCollValue : chipCollIndex }, true);
    };
    ChipList.prototype.deleteHandler = function (chipWrapper, index) {
        // Used to store the deleted chip item details.
        var deletedChipData = this.find(chipWrapper);
        this.chips.splice(index, 1);
        this.setProperties({ chips: this.chips }, true);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(chipWrapper);
        this.trigger('deleted', deletedChipData);
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers. Also, it removes the attributes and classes.
     * {% codeBlock src='chips/destroy/index.md' %}{% endcodeBlock %}
     */
    ChipList.prototype.destroy = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], [classNames.chipSet, classNames.chip, classNames.rtl,
            classNames.multiSelection, classNames.singleSelection, classNames.disabled, classNames.chipWrapper, classNames.iconWrapper,
            classNames.active, classNames.focused].concat(this.cssClass.toString().split(' ').filter(function (css) { return css; })));
        this.removeMultipleAttributes(['tabindex', 'role', 'aria-label', 'aria-multiselectable'], this.element);
        this.wireEvent(true);
        this.rippleFunction();
        _super.prototype.destroy.call(this);
        this.element.innerHTML = '';
        this.element.innerText = this.innerText;
    };
    ChipList.prototype.removeMultipleAttributes = function (attributes, element) {
        attributes.forEach(function (attr) {
            element.removeAttribute(attr);
        });
    };
    ChipList.prototype.getPersistData = function () {
        return this.addOnPersist([]);
    };
    ChipList.prototype.getModuleName = function () {
        return 'chip-list';
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @returns void
     * @private
     */
    ChipList.prototype.onPropertyChanged = function (newProp, oldProp) {
        var property;
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'chips':
                case 'text':
                case 'avatarText':
                case 'avatarIconCss':
                case 'leadingIconCss':
                case 'trailingIconCss':
                case 'selection':
                case 'enableDelete':
                case 'enabled':
                    this.refresh();
                    break;
                case 'cssClass':
                    if (!this.chipType()) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], oldProp.cssClass.toString().split(' ').filter(function (css) { return css; }));
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], newProp.cssClass.toString().split(' ').filter(function (css) { return css; }));
                    }
                    else {
                        this.refresh();
                    }
                    break;
                case 'selectedChips':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])(this.element.querySelectorAll('.e-active'), 'e-active');
                    if (this.selection === 'Multiple') {
                        this.multiSelectedChip = [];
                        this.multiSelection(newProp.selectedChips);
                        this.onSelect(this.multiSelectedChip, true, property);
                        this.updateSelectedChips();
                    }
                    else {
                        this.onSelect(newProp.selectedChips, true, property);
                    }
                    break;
                case 'enableRtl':
                    this.setRtl();
                    break;
            }
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])([])
    ], ChipList.prototype, "chips", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], ChipList.prototype, "text", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], ChipList.prototype, "avatarText", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], ChipList.prototype, "avatarIconCss", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], ChipList.prototype, "leadingIconCss", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], ChipList.prototype, "trailingIconCss", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], ChipList.prototype, "leadingIconUrl", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], ChipList.prototype, "trailingIconUrl", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], ChipList.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], ChipList.prototype, "enabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])([])
    ], ChipList.prototype, "selectedChips", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('None')
    ], ChipList.prototype, "selection", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], ChipList.prototype, "enableDelete", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ChipList.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ChipList.prototype, "click", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ChipList.prototype, "beforeClick", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ChipList.prototype, "delete", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ChipList.prototype, "deleted", void 0);
    ChipList = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], ChipList);
    return ChipList;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Chip */
/**
 * Represents ChipList `Chip` model class.
 */
var Chip = /** @class */ (function () {
    function Chip() {
    }
    return Chip;
}());



/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Virtualization */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__list_view__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_list_base__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_data__ = __webpack_require__(30);




var listElementCount = 1.5;
var windowElementCount = 3;
var Virtualization = /** @class */ (function () {
    function Virtualization(instance) {
        this.elementDifference = 0;
        this.listViewInstance = instance;
    }
    /**
     * For internal use only.
     *
     * @private
     */
    Virtualization.prototype.isNgTemplate = function () {
        return !Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.listViewInstance.templateRef) && typeof this.listViewInstance.templateRef !== 'string';
    };
    /**
     * For internal use only.
     *
     * @private
     */
    Virtualization.prototype.uiVirtualization = function () {
        this.wireScrollEvent(false);
        var curViewDS = this.listViewInstance.curViewDS;
        var firstDs = curViewDS.slice(0, 1);
        this.listViewInstance.ulElement = this.listViewInstance.curUL = __WEBPACK_IMPORTED_MODULE_2__common_list_base__["a" /* ListBase */].createList(
        // eslint-disable-next-line
        this.listViewInstance.createElement, firstDs, this.listViewInstance.listBaseOption, null, this.listViewInstance);
        this.listViewInstance.contentContainer = this.listViewInstance.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].content });
        this.listViewInstance.element.appendChild(this.listViewInstance.contentContainer);
        this.listViewInstance.contentContainer.appendChild(this.listViewInstance.ulElement);
        this.listItemHeight = this.listViewInstance.ulElement.firstElementChild.getBoundingClientRect().height;
        this.expectedDomItemCount = this.ValidateItemCount(10000);
        this.domItemCount = this.ValidateItemCount(Object.keys(this.listViewInstance.curViewDS).length);
        this.uiFirstIndex = 0;
        this.uiLastIndex = this.domItemCount - 1;
        var otherDs = curViewDS.slice(1, this.domItemCount);
        var listItems = __WEBPACK_IMPORTED_MODULE_2__common_list_base__["a" /* ListBase */].createListItemFromJson(
        // eslint-disable-next-line
        this.listViewInstance.createElement, otherDs, this.listViewInstance.listBaseOption, null, null, this.listViewInstance);
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["v" /* append */])(listItems, this.listViewInstance.ulElement);
        this.listViewInstance.liCollection = this.listViewInstance.curUL.querySelectorAll('li');
        this.topElement = this.listViewInstance.createElement('div');
        this.listViewInstance.ulElement.insertBefore(this.topElement, this.listViewInstance.ulElement.firstElementChild);
        this.bottomElement = this.listViewInstance.createElement('div');
        this.listViewInstance.ulElement.insertBefore(this.bottomElement, null);
        this.totalHeight = (Object.keys(curViewDS).length * this.listItemHeight) - (this.domItemCount * this.listItemHeight);
        this.topElement.style.height = 0 + 'px';
        this.bottomElement.style.height = this.totalHeight + 'px';
        this.topElementHeight = 0;
        this.bottomElementHeight = this.totalHeight;
        this.listDiff = 0;
        this.uiIndicesInitialization();
    };
    Virtualization.prototype.wireScrollEvent = function (destroy) {
        if (!destroy) {
            if (this.listViewInstance.isWindow) {
                this.onVirtualScroll = this.onVirtualUiScroll.bind(this);
                window.addEventListener('scroll', this.onVirtualScroll);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["l" /* EventHandler */].add(this.listViewInstance.element, 'scroll', this.onVirtualUiScroll, this);
            }
        }
        else {
            if (this.listViewInstance.isWindow === true) {
                window.removeEventListener('scroll', this.onVirtualScroll);
                window.removeEventListener('scroll', this.updateUl);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.listViewInstance.element, 'scroll', this.onVirtualUiScroll);
                __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.listViewInstance.element, 'scroll', this.updateUlContainer);
            }
        }
    };
    Virtualization.prototype.updateUlContainer = function (e) {
        var listDiff;
        var virtualElementContainer = this.listViewInstance.ulElement.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].virtualElementContainer);
        if (Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.listViewInstance.liElementHeight)) {
            this.listViewInstance.updateLiElementHeight();
        }
        if (this.listViewInstance.isWindow) {
            // eslint-disable-next-line
            listDiff = Math.round(e.target.documentElement.scrollTop / this.listViewInstance.liElementHeight) - 2;
        }
        else {
            // eslint-disable-next-line
            listDiff = Math.round(e.target.scrollTop / this.listViewInstance.liElementHeight) - 2;
        }
        if (((listDiff - 1) * this.listViewInstance.liElementHeight) < 0) {
            virtualElementContainer.style.top = '0px';
        }
        else {
            virtualElementContainer.style.top = (listDiff) * this.listViewInstance.liElementHeight + 'px';
        }
    };
    Virtualization.prototype.ValidateItemCount = function (dataSourceLength) {
        var height = parseFloat(Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["G" /* formatUnit */])(this.listViewInstance.height));
        var itemCount;
        if (this.listViewInstance.isWindow) {
            itemCount = Math.round((window.innerHeight / this.listItemHeight) * windowElementCount);
        }
        else {
            if (typeof this.listViewInstance.height === 'string' && this.listViewInstance.height.indexOf('%') !== -1) {
                // eslint-disable-next-line max-len
                itemCount = Math.round((this.listViewInstance.element.getBoundingClientRect().height / this.listItemHeight) * listElementCount);
            }
            else {
                itemCount = Math.round((height / this.listItemHeight) * listElementCount);
            }
        }
        if (itemCount > dataSourceLength) {
            itemCount = dataSourceLength;
        }
        return itemCount;
    };
    Virtualization.prototype.uiIndicesInitialization = function () {
        this.uiIndices = { 'activeIndices': [], 'disabledItemIndices': [], 'hiddenItemIndices': [] };
        var data = this.listViewInstance.curViewDS;
        for (var i = 0; i < data.length; i++) {
            if (this.listViewInstance.showCheckBox && data[i][this.listViewInstance.fields.isChecked]) {
                this.uiIndices.activeIndices.push(i);
            }
            // eslint-disable-next-line
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data[i][this.listViewInstance.fields.enabled]) &&
                !data[i][this.listViewInstance.fields.enabled]) {
                // eslint-disable-next-line
                (this.uiIndices.disabledItemIndices.push(i));
            }
        }
        if (this.isNgTemplate()) {
            var items = this.listViewInstance.element.querySelectorAll('.' + __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].listItem);
            for (var index = 0; index < items.length; index++) {
                items[index].context = this.listViewInstance.viewContainerRef.get(index).context;
            }
        }
    };
    Virtualization.prototype.refreshItemHeight = function () {
        if (this.listViewInstance.curViewDS.length) {
            var curViewDS = this.listViewInstance.curViewDS;
            this.listItemHeight = this.topElement.nextSibling.getBoundingClientRect().height;
            this.totalHeight = (Object.keys(curViewDS).length * this.listItemHeight) - (this.domItemCount * this.listItemHeight);
            this.bottomElementHeight = this.totalHeight;
            this.bottomElement.style.height = this.totalHeight + 'px';
        }
    };
    Virtualization.prototype.getscrollerHeight = function (startingHeight) {
        return this.listViewInstance.isWindow ? (((pageYOffset - startingHeight) <= 0) ? 0 :
            (pageYOffset - startingHeight)) : ((this.listViewInstance.element.scrollTop - startingHeight) <= 0) ? 0 :
            (this.listViewInstance.element.scrollTop - startingHeight);
    };
    Virtualization.prototype.onVirtualUiScroll = function (e) {
        var _a;
        var startingHeight;
        if (this.listViewInstance.isWindow) {
            startingHeight = this.listViewInstance.ulElement.getBoundingClientRect().top -
                document.documentElement.getBoundingClientRect().top;
        }
        else {
            startingHeight = this.listViewInstance.headerEle ? this.listViewInstance.headerEle.getBoundingClientRect().height : 0;
        }
        this.scrollPosition = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.scrollPosition) ? 0 : this.scrollPosition;
        var scroll = this.getscrollerHeight(startingHeight);
        this.topElementHeight = this.listItemHeight * Math.floor(scroll / this.listItemHeight);
        this.bottomElementHeight = this.totalHeight - this.topElementHeight;
        _a = scroll <= this.totalHeight ?
            [this.topElementHeight, this.bottomElementHeight] : [this.totalHeight, 0], this.topElementHeight = _a[0], this.bottomElementHeight = _a[1];
        if (this.topElementHeight !== parseFloat(this.topElement.style.height)) {
            this.topElement.style.height = this.topElementHeight + 'px';
            this.bottomElement.style.height = this.bottomElementHeight + 'px';
            if (scroll > this.scrollPosition) {
                var listDiff = Math.round(((this.topElementHeight / this.listItemHeight) - this.listDiff));
                if (listDiff > (this.expectedDomItemCount + 5)) {
                    this.onLongScroll(listDiff, true);
                }
                else {
                    this.onNormalScroll(listDiff, true);
                }
            }
            else {
                var listDiff = Math.round((this.listDiff - (this.topElementHeight / this.listItemHeight)));
                if (listDiff > (this.expectedDomItemCount + 5)) {
                    this.onLongScroll(listDiff, false);
                }
                else {
                    this.onNormalScroll(listDiff, false);
                }
            }
        }
        this.listDiff = Math.round(this.topElementHeight / this.listItemHeight);
        if (typeof this.listViewInstance.onUIScrolled === 'function') {
            this.listViewInstance.onUIScrolled();
        }
        this.scrollPosition = scroll;
    };
    Virtualization.prototype.onLongScroll = function (listDiff, isScrollingDown) {
        var index = isScrollingDown ? (this.uiFirstIndex + listDiff) : (this.uiFirstIndex - listDiff);
        var elements = this.listViewInstance.ulElement.querySelectorAll('li');
        for (var i = 0; i < elements.length; i++) {
            this.updateUI(elements[i], index);
            index++;
        }
        this.uiLastIndex = isScrollingDown ? (this.uiLastIndex + listDiff) : (this.uiLastIndex - listDiff);
        this.uiFirstIndex = isScrollingDown ? (this.uiFirstIndex + listDiff) : (this.uiFirstIndex - listDiff);
    };
    Virtualization.prototype.onNormalScroll = function (listDiff, isScrollingDown) {
        if (isScrollingDown) {
            for (var i = 0; i < listDiff; i++) {
                var index = ++this.uiLastIndex;
                this.updateUI(this.topElement.nextElementSibling, index, this.bottomElement);
                this.uiFirstIndex++;
            }
        }
        else {
            for (var i = 0; i < listDiff; i++) {
                var index = --this.uiFirstIndex;
                var target = this.topElement.nextSibling;
                this.updateUI(this.bottomElement.previousElementSibling, index, target);
                this.uiLastIndex--;
            }
        }
    };
    Virtualization.prototype.updateUiContent = function (element, index) {
        // eslint-disable-next-line
        var curViewDs = this.listViewInstance.curViewDS;
        if (typeof this.listViewInstance.dataSource[0] === 'string' ||
            typeof this.listViewInstance.dataSource[0] === 'number') {
            element.dataset.uid = __WEBPACK_IMPORTED_MODULE_2__common_list_base__["a" /* ListBase */].generateId();
            element.getElementsByClassName(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].listItemText)[0].innerHTML =
                this.listViewInstance.curViewDS[index].toString();
        }
        else {
            // eslint-disable-next-line
            element.dataset.uid = (curViewDs[index][this.listViewInstance.fields.id]) ?
                // eslint-disable-next-line
                (curViewDs[index][this.listViewInstance.fields.id]) : __WEBPACK_IMPORTED_MODULE_2__common_list_base__["a" /* ListBase */].generateId();
            element.getElementsByClassName(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].listItemText)[0].innerHTML =
                // eslint-disable-next-line
                (curViewDs[index][this.listViewInstance.fields.text]);
        }
        if (this.listViewInstance.showIcon) {
            if (element.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].listIcon)) {
                Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["D" /* detach */])(element.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].listIcon));
            }
            if (this.listViewInstance.curViewDS[index][this.listViewInstance.fields.iconCss]) {
                var textContent = element.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].textContent);
                var target = this.listViewInstance.createElement('div', {
                    className: __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].listIcon + ' ' +
                        this.listViewInstance.curViewDS[index][this.listViewInstance.fields.iconCss]
                });
                textContent.insertBefore(target, element.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].listItemText));
            }
        }
        if (this.listViewInstance.showCheckBox && this.listViewInstance.fields.groupBy) {
            if (!this.checkListWrapper) {
                this.checkListWrapper = this.listViewInstance.curUL.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].checkboxWrapper).cloneNode(true);
            }
            var textContent = element.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].textContent);
            if (this.listViewInstance.curViewDS[index].isHeader) {
                if (element.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].checkboxWrapper)) {
                    element.classList.remove(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].checklist);
                    textContent.classList.remove(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].checkbox);
                    Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["D" /* detach */])(element.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].checkboxWrapper));
                }
            }
            else {
                if (!element.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].checkboxWrapper)) {
                    element.classList.add(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].checklist);
                    textContent.classList.add(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].checkbox);
                    textContent.insertBefore(this.checkListWrapper.cloneNode(true), element.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].listItemText));
                }
            }
        }
    };
    Virtualization.prototype.changeElementAttributes = function (element, index) {
        element.classList.remove(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].disable);
        if (this.uiIndices.disabledItemIndices.length && this.uiIndices.disabledItemIndices.indexOf(index) !== -1) {
            element.classList.add(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].disable);
        }
        element.style.display = '';
        if (this.uiIndices.hiddenItemIndices.length && this.uiIndices.hiddenItemIndices.indexOf(index) !== -1) {
            element.style.display = 'none';
        }
        if (this.listViewInstance.showCheckBox) {
            var checklistElement = element.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].checkboxWrapper);
            element.classList.remove(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].selected);
            element.classList.remove(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].focused);
            if (checklistElement) {
                checklistElement.removeAttribute('aria-checked');
                checklistElement.firstElementChild.classList.remove(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].checked);
            }
            if (this.uiIndices.activeIndices.length && this.uiIndices.activeIndices.indexOf(index) !== -1 &&
                !this.listViewInstance.curUL.querySelector(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].selected)) {
                element.classList.add(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].selected);
                checklistElement.firstElementChild.classList.add(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].checked);
                checklistElement.setAttribute('aria-checked', 'true');
                if (this.activeIndex === index) {
                    element.classList.add(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].focused);
                }
            }
        }
        else {
            element.classList.remove(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].selected);
            element.removeAttribute('aria-selected');
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.activeIndex) && this.activeIndex === index &&
                !this.listViewInstance.curUL.querySelector(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].selected)) {
                element.classList.add(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].selected);
                element.setAttribute('aria-selected', 'true');
            }
        }
        if (this.listViewInstance.fields.groupBy) {
            if (this.listViewInstance.curViewDS[index].isHeader) {
                if (element.classList.contains(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].listItem)) {
                    element.classList.remove(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].listItem);
                    element.setAttribute('role', 'group');
                    element.classList.add(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].groupListItem);
                }
            }
            else {
                if (element.classList.contains(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].groupListItem)) {
                    element.classList.remove(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].groupListItem);
                    element.setAttribute('role', 'listitem');
                    element.classList.add(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].listItem);
                }
            }
        }
    };
    Virtualization.prototype.findDSAndIndexFromId = function (ds, fields) {
        var _this = this;
        var resultJSON = {};
        fields = this.listViewInstance.getElementUID(fields);
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fields)) {
            ds.some(function (data, index) {
                if ((fields[_this.listViewInstance.fields.id] &&
                    // eslint-disable-next-line
                    fields[_this.listViewInstance.fields.id]
                        // eslint-disable-next-line
                        === (data[_this.listViewInstance.fields.id] && data[_this.listViewInstance.fields.id]) || fields === data)) {
                    resultJSON.index = index;
                    resultJSON.data = data;
                    return true;
                }
                else {
                    return false;
                }
            });
        }
        return resultJSON;
    };
    Virtualization.prototype.getSelectedItems = function () {
        var _this = this;
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.activeIndex) || (this.listViewInstance.showCheckBox && this.uiIndices.activeIndices.length)) {
            var dataCollection = [];
            var textCollection = [];
            if (typeof this.listViewInstance.dataSource[0] === 'string' ||
                typeof this.listViewInstance.dataSource[0] === 'number') {
                var curViewDS_1 = this.listViewInstance.curViewDS;
                if (this.listViewInstance.showCheckBox) {
                    var indices = this.uiIndices.activeIndices;
                    for (var i = 0; i < indices.length; i++) {
                        dataCollection.push(curViewDS_1[indices[i]]);
                    }
                    return {
                        text: dataCollection,
                        // eslint-disable-next-line
                        data: dataCollection,
                        index: this.uiIndices.activeIndices.map(function (index) {
                            return _this.listViewInstance.dataSource.indexOf(curViewDS_1[index]);
                        })
                    };
                }
                else {
                    return {
                        text: curViewDS_1[this.activeIndex],
                        data: curViewDS_1[this.activeIndex],
                        index: this.listViewInstance.dataSource.indexOf(curViewDS_1[this.activeIndex])
                    };
                }
            }
            else {
                var curViewDS_2 = this.listViewInstance.curViewDS;
                var text = this.listViewInstance.fields.text;
                if (this.listViewInstance.showCheckBox) {
                    var indexArray = this.uiIndices.activeIndices;
                    for (var i = 0; i < indexArray.length; i++) {
                        textCollection.push(curViewDS_2[indexArray[i]][text]);
                        // eslint-disable-next-line
                        dataCollection.push(curViewDS_2[indexArray[i]]);
                    }
                    // eslint-disable-next-line
                    var dataSource_1 = this.listViewInstance.dataSource instanceof __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_data__["a" /* DataManager */]
                        ? curViewDS_2 : this.listViewInstance.dataSource;
                    return {
                        text: textCollection,
                        // eslint-disable-next-line
                        data: dataCollection,
                        index: this.uiIndices.activeIndices.map(function (index) {
                            return dataSource_1.indexOf(curViewDS_2[index]);
                        })
                    };
                }
                else {
                    // eslint-disable-next-line
                    var dataSource = this.listViewInstance.dataSource instanceof __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_data__["a" /* DataManager */]
                        ? curViewDS_2 : this.listViewInstance.dataSource;
                    return {
                        text: curViewDS_2[this.activeIndex][this.listViewInstance.fields.text],
                        // eslint-disable-next-line
                        data: curViewDS_2[this.activeIndex],
                        index: dataSource.indexOf(curViewDS_2[this.activeIndex])
                    };
                }
            }
        }
        else {
            return undefined;
        }
    };
    Virtualization.prototype.selectItem = function (obj) {
        // eslint-disable-next-line
        var resutJSON = this.findDSAndIndexFromId(this.listViewInstance.curViewDS, obj);
        if (Object.keys(resutJSON).length) {
            var isSelected = this.activeIndex === resutJSON.index;
            var isChecked = void 0;
            this.activeIndex = resutJSON.index;
            if (this.listViewInstance.showCheckBox) {
                if (this.uiIndices.activeIndices.indexOf(resutJSON.index) === -1) {
                    isChecked = true;
                    this.uiIndices.activeIndices.push(resutJSON.index);
                }
                else {
                    isChecked = false;
                    this.uiIndices.activeIndices.splice(this.uiIndices.activeIndices.indexOf(resutJSON.index), 1);
                }
                if (this.listViewInstance.curUL.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].focused)) {
                    this.listViewInstance.curUL.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].focused).classList.remove(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].focused);
                }
            }
            if (this.listViewInstance.getLiFromObjOrElement(obj)) {
                if (this.listViewInstance.showCheckBox) {
                    this.listViewInstance.setCheckboxLI(this.listViewInstance.getLiFromObjOrElement(obj));
                }
                else {
                    this.listViewInstance.setSelectLI(this.listViewInstance.getLiFromObjOrElement(obj));
                }
            }
            else {
                // eslint-disable-next-line
                var eventArgs = void 0;
                if (typeof this.listViewInstance.dataSource[0] === 'string' ||
                    typeof this.listViewInstance.dataSource[0] === 'number') {
                    eventArgs = {
                        text: this.listViewInstance.curViewDS[this.activeIndex],
                        data: this.listViewInstance.curViewDS[this.activeIndex],
                        index: this.activeIndex
                    };
                }
                else {
                    var curViewDS = this.listViewInstance.curViewDS;
                    eventArgs = {
                        text: curViewDS[this.activeIndex][this.listViewInstance.fields.text],
                        data: curViewDS[this.activeIndex],
                        index: this.activeIndex
                    };
                }
                if (this.listViewInstance.showCheckBox) {
                    eventArgs.isChecked = isChecked;
                    this.listViewInstance.trigger('select', eventArgs);
                }
                else if (!isSelected) {
                    this.listViewInstance.removeSelect();
                    this.listViewInstance.trigger('select', eventArgs);
                }
            }
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(obj) && !this.listViewInstance.showCheckBox) {
            this.listViewInstance.removeSelect();
            this.activeIndex = undefined;
        }
    };
    Virtualization.prototype.enableItem = function (obj) {
        // eslint-disable-next-line
        var resutJSON = this.findDSAndIndexFromId(this.listViewInstance.curViewDS, obj);
        if (Object.keys(resutJSON).length) {
            this.uiIndices.disabledItemIndices.splice(this.uiIndices.disabledItemIndices.indexOf(resutJSON.index), 1);
        }
    };
    Virtualization.prototype.disableItem = function (obj) {
        // eslint-disable-next-line
        var resutJSON = this.findDSAndIndexFromId(this.listViewInstance.curViewDS, obj);
        if (Object.keys(resutJSON).length && this.uiIndices.disabledItemIndices.indexOf(resutJSON.index) === -1) {
            this.uiIndices.disabledItemIndices.push(resutJSON.index);
        }
    };
    Virtualization.prototype.showItem = function (obj) {
        // eslint-disable-next-line
        var resutJSON = this.findDSAndIndexFromId(this.listViewInstance.curViewDS, obj);
        if (Object.keys(resutJSON).length) {
            this.uiIndices.hiddenItemIndices.splice(this.uiIndices.hiddenItemIndices.indexOf(resutJSON.index), 1);
        }
    };
    Virtualization.prototype.hideItem = function (obj) {
        // eslint-disable-next-line
        var resutJSON = this.findDSAndIndexFromId(this.listViewInstance.curViewDS, obj);
        if (Object.keys(resutJSON).length && this.uiIndices.hiddenItemIndices.indexOf(resutJSON.index) === -1) {
            this.uiIndices.hiddenItemIndices.push(resutJSON.index);
        }
    };
    Virtualization.prototype.removeItem = function (obj) {
        var dataSource;
        var curViewDS = this.listViewInstance.curViewDS;
        // eslint-disable-next-line
        var resutJSON = this.findDSAndIndexFromId(curViewDS, obj);
        // eslint-disable-next-line
        if (Object.keys(resutJSON).length) {
            dataSource = resutJSON.data;
            if (curViewDS[resutJSON.index - 1] &&
                curViewDS[resutJSON.index - 1].isHeader &&
                (curViewDS[resutJSON.index - 1])
                    .items.length === 1) {
                this.removeUiItem(resutJSON.index - 1);
                this.removeUiItem(resutJSON.index - 1);
            }
            else {
                this.removeUiItem(resutJSON.index);
            }
        }
        var listDataSource = this.listViewInstance.dataSource instanceof __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_data__["a" /* DataManager */]
            ? this.listViewInstance.localData : this.listViewInstance.dataSource;
        var index = listDataSource.indexOf(dataSource);
        if (index !== -1) {
            listDataSource.splice(index, 1);
            this.listViewInstance.setViewDataSource(listDataSource);
        }
        // recollect all the list item into collection
        this.listViewInstance.liCollection =
            this.listViewInstance.curUL.querySelectorAll('li');
    };
    // eslint-disable-next-line
    Virtualization.prototype.setCheckboxLI = function (li, e) {
        var index = Array.prototype.indexOf.call(this.listViewInstance.curUL.querySelectorAll('li'), li) + this.uiFirstIndex;
        this.activeIndex = Array.prototype.indexOf.call(this.listViewInstance.curUL.querySelectorAll('li'), li) + this.uiFirstIndex;
        if (li.classList.contains(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].selected)) {
            if (this.uiIndices.activeIndices.indexOf(index) === -1) {
                this.uiIndices.activeIndices.push(index);
            }
        }
        else {
            this.uiIndices.activeIndices.splice(this.uiIndices.activeIndices.indexOf(index), 1);
        }
    };
    // eslint-disable-next-line
    Virtualization.prototype.setSelectLI = function (li, e) {
        this.activeIndex = Array.prototype.indexOf.call(this.listViewInstance.curUL.querySelectorAll('li'), li) + this.uiFirstIndex;
    };
    Virtualization.prototype.checkedItem = function (checked) {
        if (checked) {
            this.uiIndices.activeIndices = [];
            this.activeIndex = undefined;
            var data = this.listViewInstance.curViewDS;
            for (var index = 0; index < data.length; index++) {
                if (!data[index].isHeader) {
                    this.uiIndices.activeIndices.push(index);
                }
            }
        }
        else {
            this.activeIndex = undefined;
            this.uiIndices.activeIndices = [];
        }
    };
    Virtualization.prototype.addUiItem = function (index) {
        // virtually new add list item based on the scollbar position
        // if the scroll bar is at the top, just pretend the new item has been added since no UI
        // change is required for the item that has been added at last but when scroll bar is at the bottom
        // just detach top and inject into bottom to mimic new item is added
        var curViewDs = this.listViewInstance.curViewDS;
        this.changeUiIndices(index, true);
        if (this.activeIndex && this.activeIndex >= index) {
            this.activeIndex++;
        }
        if (this.listViewInstance.showCheckBox &&
            curViewDs[index][this.listViewInstance.fields.isChecked]) {
            this.uiIndices.activeIndices.push(index);
        }
        if (!parseFloat(this.bottomElement.style.height) && !parseFloat(this.topElement.style.height)) {
            this.bottomElement.style.height = parseFloat(this.bottomElement.style.height) + this.listItemHeight + 'px';
        }
        if (parseFloat(this.bottomElement.style.height)) {
            var liItem = this.listViewInstance.curUL.lastElementChild.previousSibling;
            var target = this.listViewInstance.getLiFromObjOrElement(curViewDs[index + 1]) ||
                this.listViewInstance.getLiFromObjOrElement(curViewDs[index + 2]);
            if (target) {
                this.bottomElement.style.height = parseFloat(this.bottomElement.style.height) + this.listItemHeight + 'px';
                this.updateUI(liItem, index, target);
            }
        }
        else {
            var liItem = this.listViewInstance.curUL.firstElementChild.nextSibling;
            var target = void 0;
            if ((Object.keys(this.listViewInstance.curViewDS).length - 1) === index) {
                target = this.listViewInstance.curUL.lastElementChild;
            }
            else {
                target = this.listViewInstance.getLiFromObjOrElement(curViewDs[index + 1]) ||
                    this.listViewInstance.getLiFromObjOrElement(curViewDs[index + 2]);
            }
            this.topElement.style.height = parseFloat(this.topElement.style.height) + this.listItemHeight + 'px';
            this.uiFirstIndex++;
            this.uiLastIndex++;
            if (target) {
                this.updateUI(liItem, index, target);
                if (this.listViewInstance.isWindow === true) {
                    window.scrollTo(0, (pageYOffset + this.listItemHeight));
                }
                else {
                    this.listViewInstance.element.scrollTop += this.listItemHeight;
                }
            }
        }
        this.totalHeight += this.listItemHeight;
        this.listDiff = Math.round(parseFloat(this.topElement.style.height) / this.listItemHeight);
    };
    Virtualization.prototype.removeUiItem = function (index) {
        this.totalHeight -= this.listItemHeight;
        var curViewDS = this.listViewInstance.curViewDS[index];
        var liItem = this.listViewInstance.getLiFromObjOrElement(curViewDS);
        this.listViewInstance.curViewDS.splice(index, 1);
        if (this.activeIndex && this.activeIndex >= index) {
            this.activeIndex--;
        }
        if (liItem) {
            if (this.domItemCount > Object.keys(this.listViewInstance.curViewDS).length) {
                Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["D" /* detach */])(liItem);
                this.domItemCount--;
                this.uiLastIndex--;
                this.totalHeight = 0;
            }
            else {
                if (liItem.classList.contains(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].disable)) {
                    liItem.classList.remove(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].disable);
                    this.uiIndices.disabledItemIndices.splice(this.uiIndices.disabledItemIndices.indexOf(index), 1);
                }
                if (liItem.style.display === 'none') {
                    liItem.style.display = '';
                    this.uiIndices.hiddenItemIndices.splice(this.uiIndices.hiddenItemIndices.indexOf(index), 1);
                }
                if (this.listViewInstance.showCheckBox && liItem.classList.contains(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].selected)) {
                    this.listViewInstance.removeSelect();
                    this.uiIndices.activeIndices.splice(this.uiIndices.activeIndices.indexOf(index), 1);
                    var checklistElement = liItem.querySelector('.' + __WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].checkboxWrapper);
                    checklistElement.removeAttribute('aria-checked');
                    checklistElement.firstElementChild.classList.remove(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].checked);
                    if (liItem.classList.contains(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].focused)) {
                        liItem.classList.remove(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].focused);
                        this.activeIndex = undefined;
                    }
                }
                else if (liItem.classList.contains(__WEBPACK_IMPORTED_MODULE_0__list_view__["a" /* classNames */].selected)) {
                    this.listViewInstance.removeSelect();
                    this.activeIndex = undefined;
                }
                if (!parseFloat(this.bottomElement.style.height) && !parseFloat(this.topElement.style.height)) {
                    this.updateUI(liItem, this.uiLastIndex, this.bottomElement);
                }
                else if (parseFloat(this.bottomElement.style.height)) {
                    this.bottomElement.style.height = parseFloat(this.bottomElement.style.height) - this.listItemHeight + 'px';
                    this.updateUI(liItem, this.uiLastIndex, this.bottomElement);
                }
                else {
                    this.topElement.style.height = parseFloat(this.topElement.style.height) - this.listItemHeight + 'px';
                    this.updateUI(liItem, (this.uiFirstIndex - 1), this.topElement.nextSibling);
                    this.uiLastIndex--;
                    this.uiFirstIndex--;
                }
            }
        }
        this.changeUiIndices(index, false);
        this.listDiff = Math.round(parseFloat(this.topElement.style.height) / this.listItemHeight);
    };
    Virtualization.prototype.changeUiIndices = function (index, increment) {
        var keys = Object.keys(this.uiIndices);
        for (var ind = 0; ind < keys.length; ind++) {
            this.uiIndices[keys[ind]] = this.uiIndices[keys[ind]].map(function (i) {
                if (i >= index) {
                    return increment ? ++i : --i;
                }
                else {
                    return i;
                }
            });
        }
    };
    Virtualization.prototype.addItem = function (data, fields, dataSource) {
        for (var i = 0; i < data.length; i++) {
            var currentItem = data[i];
            // push the given data to main data array
            dataSource.push(currentItem);
            // recalculate all the group data or other datasource related things
            this.listViewInstance.setViewDataSource(dataSource);
            // render list items for first time due to no datasource present earlier
            if (!this.domItemCount) {
                // fresh rendering for first time
                if ((this.listViewInstance.template || this.listViewInstance.groupTemplate) && !this.isNgTemplate()) {
                    this.listViewInstance.listBaseOption.template = null;
                    this.listViewInstance.listBaseOption.groupTemplate = null;
                    this.listViewInstance.listBaseOption.itemCreated = this.createUIItem.bind(this);
                }
                this.uiVirtualization();
                // when expected expected DOM count doesn't meet the condition we need to create and inject new item into DOM
            }
            else if (this.domItemCount < this.expectedDomItemCount) {
                var ds = this.listViewInstance.findItemFromDS(dataSource, fields);
                if (ds instanceof Array) {
                    if (this.listViewInstance.ulElement) {
                        var index = this.listViewInstance.curViewDS.indexOf(currentItem);
                        // inject new list item into DOM
                        this.createAndInjectNewItem(currentItem, index);
                        // check for group header item
                        var curViewDS = this.listViewInstance.curViewDS[index - 1];
                        if (curViewDS && curViewDS.isHeader && curViewDS.items.length === 1) {
                            // target group item index in datasource
                            --index;
                            // inject new group header into DOM for previously created list item
                            this.createAndInjectNewItem(curViewDS, index);
                        }
                    }
                    // recollect all the list item into collection
                    this.listViewInstance.liCollection =
                        this.listViewInstance.curUL.querySelectorAll('li');
                }
            }
            else {
                // eslint-disable-next-line
                var index = this.listViewInstance.curViewDS.indexOf(currentItem);
                // virtually new add list item based on the scollbar position
                this.addUiItem(index);
                // check for group header item needs to be added
                var curViewDS = this.listViewInstance.curViewDS[index - 1];
                if (curViewDS && curViewDS.isHeader && curViewDS.items.length === 1) {
                    this.addUiItem(index - 1);
                }
            }
        }
    };
    Virtualization.prototype.createAndInjectNewItem = function (itemData, index) {
        // generate li item for given datasource
        var target;
        var li = __WEBPACK_IMPORTED_MODULE_2__common_list_base__["a" /* ListBase */].createListItemFromJson(this.listViewInstance.createElement, 
        // eslint-disable-next-line
        [itemData], this.listViewInstance.listBaseOption, null, null, this.listViewInstance);
        // check for target element whether to insert before last item or group item
        if ((Object.keys(this.listViewInstance.curViewDS).length - 1) === index) {
            target = this.listViewInstance.curUL.lastElementChild;
        }
        else {
            // target group header's first child item to append its header
            target = this.listViewInstance.getLiFromObjOrElement(this.listViewInstance.curViewDS[index + 1]) ||
                this.listViewInstance.getLiFromObjOrElement(this.listViewInstance.curViewDS[index + 2]);
        }
        if (this.listViewInstance.fields.groupBy && this.listViewInstance.curViewDS[index + 1] && this.listViewInstance.curViewDS[index + 1].isHeader) {
            var targetEle = this.listViewInstance.getLiFromObjOrElement(this.listViewInstance.curViewDS[index - 1]);
            if (targetEle) {
                target = targetEle.nextElementSibling;
            }
        }
        // insert before the target element
        this.listViewInstance.ulElement.insertBefore(li[0], target);
        // increment internal DOM count, last index count for new element
        this.domItemCount++;
        if (this.bottomElementHeight <= 0) {
            this.uiLastIndex++;
        }
        // recalculate the current item height, to avoid jumpy scroller
        this.refreshItemHeight();
    };
    Virtualization.prototype.createUIItem = function (args) {
        var virtualTemplate = this.listViewInstance.template;
        var template = this.listViewInstance.createElement('div');
        var commonTemplate = '<div class="e-text-content" role="presentation"> ' +
            '<span class="e-list-text"> ${' + this.listViewInstance.fields.text + '} </span></div>';
        if (this.listViewInstance.isReact) {
            commonTemplate = null;
        }
        if (this.listViewInstance.showCheckBox) {
            // eslint-disable-next-line
            this.listViewInstance.renderCheckbox(args);
            if ((!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.listViewInstance.virtualCheckBox)) &&
                (!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.listViewInstance.virtualCheckBox.outerHTML))) {
                var div = document.createElement('div');
                div.innerHTML = this.listViewInstance.template || commonTemplate;
                if (div.children && div.children[0]) {
                    div.children[0].classList.add('e-checkbox');
                    if (this.listViewInstance.checkBoxPosition === 'Left') {
                        div.children[0].classList.add('e-checkbox-left');
                    }
                    else {
                        div.children[0].classList.add('e-checkbox-right');
                    }
                    if (this.listViewInstance.checkBoxPosition === 'Left') {
                        div.children[0].insertBefore(this.listViewInstance.virtualCheckBox, div.childNodes[0].children[0]);
                    }
                    else {
                        div.children[0].appendChild(this.listViewInstance.virtualCheckBox);
                    }
                    this.listViewInstance.template = div.innerHTML;
                }
            }
            template.innerHTML = this.listViewInstance.template;
            this.listViewInstance.template = virtualTemplate;
        }
        else {
            template.innerHTML = this.listViewInstance.template || commonTemplate;
        }
        // eslint-disable-next-line
        var templateElements = template.getElementsByTagName('*');
        var groupTemplate = this.listViewInstance.createElement('div');
        if (this.listViewInstance.fields.groupBy) {
            groupTemplate.innerHTML = this.listViewInstance.groupTemplate || commonTemplate;
        }
        // eslint-disable-next-line
        var groupTemplateElements = groupTemplate.getElementsByTagName('*');
        if (args.curData.isHeader) {
            this.headerData = args.curData;
        }
        this.templateData = args.curData.isHeader ? args.curData.items[0] :
            args.curData;
        if (!this.listViewInstance.isReact || (typeof this.listViewInstance.template == "string" && !args.item.classList.contains("e-list-group-item")) ||
            (typeof this.listViewInstance.groupTemplate == "string" && args.item.classList.contains("e-list-group-item"))) {
            args.item.innerHTML = '';
        }
        args.item.context = { data: args.curData, nodes: { flatTemplateNodes: [], groupTemplateNodes: [] } };
        for (var i = 0; i < templateElements.length; i++) {
            this.compileTemplate(templateElements[i], args.item, false);
        }
        for (var i = 0; i < groupTemplateElements.length; i++) {
            this.compileTemplate(groupTemplateElements[i], args.item, true);
        }
        args.item.context.template = args.curData.isHeader ? template.firstElementChild :
            groupTemplate.firstElementChild;
        args.item.context.type = args.curData.isHeader ? 'flatList' : 'groupList';
        var element = args.curData.isHeader ? groupTemplate : template;
        if (element.firstElementChild) {
            args.item.insertBefore(element.firstElementChild, null);
        }
    };
    Virtualization.prototype.compileTemplate = function (element, item, isHeader) {
        this.textProperty(element, item, isHeader);
        this.classProperty(element, item, isHeader);
        this.attributeProperty(element, item, isHeader);
    };
    Virtualization.prototype.onChange = function (newData, listElement) {
        listElement.context.data = newData;
        // eslint-disable-next-line max-len
        var groupTemplateNodes = listElement.context.nodes.groupTemplateNodes;
        // eslint-disable-next-line max-len
        var flatTemplateNodes = listElement.context.nodes.flatTemplateNodes;
        // eslint-disable-next-line
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(newData.isHeader) && newData.isHeader && listElement.context.type === 'groupList') {
            // eslint-disable-next-line
            var element = listElement.firstElementChild;
            Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["D" /* detach */])(listElement.firstElementChild);
            listElement.insertBefore(listElement.context.template, null);
            listElement.context.template = element;
            listElement.context.type = 'flatList';
            for (var i = 0; i < groupTemplateNodes.length; i++) {
                // eslint-disable-next-line
                groupTemplateNodes[i].onChange(newData);
            }
        }
        else if (!newData.isHeader && listElement.context.type === 'flatList') {
            var element = listElement.firstElementChild;
            Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["D" /* detach */])(listElement.firstElementChild);
            listElement.insertBefore(listElement.context.template, null);
            listElement.context.template = element;
            listElement.context.type = 'groupList';
            for (var i = 0; i < flatTemplateNodes.length; i++) {
                // eslint-disable-next-line
                flatTemplateNodes[i].onChange(newData);
            }
        }
        else if (!newData.isHeader) {
            for (var i = 0; i < flatTemplateNodes.length; i++) {
                // eslint-disable-next-line
                flatTemplateNodes[i].onChange(newData);
            }
        }
        else {
            for (var i = 0; i < groupTemplateNodes.length; i++) {
                // eslint-disable-next-line
                groupTemplateNodes[i].onChange(newData);
            }
        }
    };
    // eslint-disable-next-line
    Virtualization.prototype.updateContextData = function (listElement, node, isHeader) {
        if (isHeader) {
            listElement.context.nodes.groupTemplateNodes.push(node);
        }
        else {
            listElement.context.nodes.flatTemplateNodes.push(node);
        }
    };
    Virtualization.prototype.classProperty = function (element, listElement, isHeader) {
        var regex = new RegExp('\\${([^}]*)}', 'g');
        var resultantOutput = [];
        var regexMatch;
        while (regexMatch !== null) {
            var match = regex.exec(element.className);
            resultantOutput.push(match);
            regexMatch = match;
            if (regexMatch === null) {
                resultantOutput.pop();
            }
        }
        if (resultantOutput && resultantOutput.length) {
            var _loop_1 = function (i) {
                var classNameMatch = resultantOutput[i];
                // eslint-disable-next-line
                var classFunction;
                if (classNameMatch[1].indexOf('?') !== -1 && classNameMatch[1].indexOf(':') !== -1) {
                    // tslint:disable-next-line:no-function-constructor-with-string-args
                    classFunction = new Function('data', 'return ' + classNameMatch[1].replace(/\$/g, 'data.'));
                }
                else {
                    // tslint:disable-next-line:no-function-constructor-with-string-args
                    classFunction = new Function('data', 'return ' + 'data.' + classNameMatch[1]);
                }
                // eslint-disable-next-line
                var subNode = {};
                if (isHeader) {
                    subNode.bindedvalue = classFunction(this_1.headerData);
                }
                else {
                    subNode.bindedvalue = classFunction(this_1.templateData);
                }
                subNode.onChange = function (value) {
                    if (subNode.bindedvalue) {
                        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Z" /* removeClass */])([element], subNode.bindedvalue.split(' ').filter(function (css) { return css; }));
                    }
                    var newCss = classFunction(value);
                    if (newCss) {
                        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["u" /* addClass */])([element], (newCss).split(' ').filter(function (css) { return css; }));
                    }
                    subNode.bindedvalue = newCss;
                };
                var className = classNameMatch[0].split(' ');
                for (var i_1 = 0; i_1 < className.length; i_1++) {
                    element.classList.remove(className[i_1]);
                }
                if (subNode.bindedvalue) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["u" /* addClass */])([element], subNode.bindedvalue.split(' ').filter(function (css) { return css; }));
                }
                this_1.updateContextData(listElement, subNode, isHeader);
            };
            var this_1 = this;
            for (var i = 0; i < resultantOutput.length; i++) {
                _loop_1(i);
            }
        }
    };
    Virtualization.prototype.attributeProperty = function (element, listElement, isHeader) {
        var attributeNames = [];
        for (var i = 0; i < element.attributes.length; i++) {
            attributeNames.push(element.attributes[i].nodeName);
        }
        if (attributeNames.indexOf('class') !== -1) {
            attributeNames.splice(attributeNames.indexOf('class'), 1);
        }
        var _loop_2 = function (i) {
            var attributeName = attributeNames[i];
            var attrNameMatch = new RegExp('\\${([^}]*)}', 'g').exec(attributeName) || [];
            var attrValueMatch = new RegExp('\\${([^}]*)}', 'g').exec(element.getAttribute(attributeName))
                || [];
            // eslint-disable-next-line
            var attributeNameFunction;
            // eslint-disable-next-line
            var attributeValueFunction;
            if (attrNameMatch.length || attrValueMatch.length) {
                if (attrNameMatch[1]) {
                    // tslint:disable-next-line:no-function-constructor-with-string-args
                    attributeNameFunction = new Function('data', 'return ' + 'data.' + attrNameMatch[1]);
                }
                if (attrValueMatch[1]) {
                    if (attrValueMatch[1].indexOf('?') !== -1 && attrValueMatch[1].indexOf(':') !== -1) {
                        // tslint:disable-next-line:no-function-constructor-with-string-args
                        attributeValueFunction = new Function('data', 'return ' + attrValueMatch[1].replace(/\$/g, 'data.'));
                    }
                    else {
                        // tslint:disable-next-line:no-function-constructor-with-string-args
                        attributeValueFunction = new Function('data', 'return ' + 'data.' + attrValueMatch[1]);
                    }
                }
                // eslint-disable-next-line @typescript-eslint/ban-types
                var subNode_1 = {};
                if (isHeader) {
                    subNode_1.bindedvalue = [attrNameMatch[1] === undefined ? undefined : attributeNameFunction(this_2.headerData),
                        attrValueMatch[1] === undefined ? undefined : attributeValueFunction(this_2.headerData)];
                }
                else {
                    subNode_1.bindedvalue = [attrNameMatch[1] === undefined ? undefined : attributeNameFunction(this_2.templateData),
                        attrValueMatch[1] === undefined ? undefined : attributeValueFunction(this_2.templateData)];
                }
                subNode_1.attrName = subNode_1.bindedvalue[0] === undefined ?
                    attributeName : subNode_1.bindedvalue[0];
                subNode_1.onChange = function (value) {
                    var bindedvalue = subNode_1.bindedvalue[1] === undefined ?
                        element.getAttribute(subNode_1.attrName) : attributeValueFunction(value);
                    element.removeAttribute(subNode_1.attrName);
                    subNode_1.attrName = subNode_1.bindedvalue[0] === undefined ? subNode_1.attrName : attributeNameFunction(value);
                    element.setAttribute(subNode_1.attrName, bindedvalue);
                    subNode_1.bindedvalue = [subNode_1.bindedvalue[0] === undefined ? undefined : attributeNameFunction(value),
                        subNode_1.bindedvalue[1] === undefined ? undefined : attributeValueFunction(value)];
                };
                var attributeValue = subNode_1.bindedvalue[1] === undefined ? element.getAttribute(attributeName) :
                    subNode_1.bindedvalue[1];
                element.removeAttribute(attributeName);
                element.setAttribute(subNode_1.attrName, attributeValue);
                this_2.updateContextData(listElement, subNode_1, isHeader);
            }
        };
        var this_2 = this;
        for (var i = 0; i < attributeNames.length; i++) {
            _loop_2(i);
        }
    };
    Virtualization.prototype.textProperty = function (element, listElement, isHeader) {
        var regex = new RegExp('\\${([^}]*)}', 'g');
        var resultantOutput = [];
        var regexMatch;
        while (regexMatch !== null) {
            var match = regex.exec(element.innerText);
            resultantOutput.push(match);
            regexMatch = match;
            if (regexMatch === null) {
                resultantOutput.pop();
            }
        }
        var isChildHasTextContent = Array.prototype.some.call(element.children, function (element) {
            if (new RegExp('\\${([^}]*)}', 'g').exec(element.innerText)) {
                return true;
            }
            else {
                return false;
            }
        });
        if (resultantOutput && resultantOutput.length && !isChildHasTextContent) {
            var _loop_3 = function (i) {
                var textPropertyMatch = resultantOutput[i];
                // eslint-disable-next-line
                var subNode = {};
                // eslint-disable-next-line
                var textFunction;
                if (textPropertyMatch[1].indexOf('?') !== -1 && textPropertyMatch[1].indexOf(':') !== -1) {
                    // tslint:disable-next-line:no-function-constructor-with-string-args
                    textFunction = new Function('data', 'return ' + textPropertyMatch[1].replace(/\$/g, 'data.'));
                }
                else {
                    // tslint:disable-next-line:no-function-constructor-with-string-args
                    textFunction = new Function('data', 'return ' + 'data.' + textPropertyMatch[1]);
                }
                if (isHeader) {
                    subNode.bindedvalue = textFunction(this_3.headerData);
                }
                else {
                    subNode.bindedvalue = textFunction(this_3.templateData);
                }
                subNode.onChange = function (value) {
                    element.innerText = element.innerText.replace(subNode.bindedvalue, textFunction(value));
                    subNode.bindedvalue = textFunction(value);
                };
                element.innerText = element.innerText.replace(textPropertyMatch[0], subNode.bindedvalue);
                this_3.updateContextData(listElement, subNode, isHeader);
            };
            var this_3 = this;
            for (var i = 0; i < resultantOutput.length; i++) {
                _loop_3(i);
            }
        }
    };
    Virtualization.prototype.reRenderUiVirtualization = function () {
        this.wireScrollEvent(true);
        if (this.listViewInstance.contentContainer) {
            Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["D" /* detach */])(this.listViewInstance.contentContainer);
        }
        this.listViewInstance.preRender();
        // resetting the dom count to 0, to avoid edge case of dataSource suddenly becoming zero
        // and then manually adding item using addItem API
        this.domItemCount = 0;
        this.listViewInstance.header();
        this.listViewInstance.setLocalData();
    };
    Virtualization.prototype.updateUI = function (element, index, targetElement) {
        // eslint-disable-next-line @typescript-eslint/ban-types
        var onChange = this.isNgTemplate() ? this.onNgChange : this.onChange;
        if (this.listViewInstance.template || this.listViewInstance.groupTemplate) {
            var curViewDS = this.listViewInstance.curViewDS[index];
            // eslint-disable-next-line
            element.dataset.uid = (curViewDS[this.listViewInstance.fields.id]) ?
                // eslint-disable-next-line
                (curViewDS[this.listViewInstance.fields.id]) : __WEBPACK_IMPORTED_MODULE_2__common_list_base__["a" /* ListBase */].generateId();
            onChange(curViewDS, element, this);
        }
        else {
            this.updateUiContent(element, index);
        }
        this.changeElementAttributes(element, index);
        if (targetElement) {
            this.listViewInstance.ulElement.insertBefore(element, targetElement);
        }
    };
    Virtualization.prototype.onNgChange = function (newData, listElement, virtualThis) {
        // compile given target element with template for new data
        // eslint-disable-next-line
        var templateCompiler = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["A" /* compile */])(virtualThis.listViewInstance.template);
        var resultElement = templateCompiler(newData);
        while (listElement.lastChild) {
            listElement.removeChild(listElement.lastChild);
        }
        listElement.appendChild(resultElement[0]);
    };
    Virtualization.prototype.getModuleName = function () {
        return 'virtualization';
    };
    Virtualization.prototype.destroy = function () {
        this.wireScrollEvent(true);
    };
    return Virtualization;
}());



/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__list_base__ = __webpack_require__(42);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__list_base__["a"]; });
/**
 * Listview Component
 */



/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sortable__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/**
 * Sortable Module
 */



/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Sortable */
/* unused harmony export moveTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */



/**
 * Sortable Module provides support to enable sortable functionality in Dom Elements.
 * ```html
 * <div id="sortable">
 *   <div>Item 1</div>
 *   <div>Item 2</div>
 *   <div>Item 3</div>
 *   <div>Item 4</div>
 *   <div>Item 5</div>
 * </div>
 * ```
 * ```typescript
 *   let ele: HTMLElement = document.getElementById('sortable');
 *   let sortObj: Sortable = new Sortable(ele, {});
 * ```
 */
var Sortable = /** @class */ (function (_super) {
    __extends(Sortable, _super);
    /* es-lint enable  */
    function Sortable(element, options) {
        var _this = _super.call(this, options, element) || this;
        // eslint-disable-next-line
        _this.getHelper = function (e) {
            // eslint-disable-next-line prefer-const
            var target = _this.getSortableElement(e.sender.target);
            if (!_this.isValidTarget(target, _this)) {
                return false;
            }
            var element;
            if (_this.helper) {
                element = _this.helper({ sender: target, element: e.element });
            }
            else {
                element = target.cloneNode(true);
                element.style.width = target.offsetWidth + "px";
                element.style.height = target.offsetHeight + "px";
            }
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([element], ['e-sortableclone']);
            document.body.appendChild(element);
            return element;
        };
        // eslint-disable-next-line
        _this.onDrag = function (e) {
            if (!e.target)
                return;
            _this.trigger('drag', { event: e.event, element: _this.element, target: e.target });
            var newInst = _this.getSortableInstance(e.target);
            var target = _this.getSortableElement(e.target, newInst);
            if ((_this.isValidTarget(target, newInst) || e.target.className.indexOf('e-list-group-item') > -1) && (_this.curTarget !== target ||
                !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(newInst.placeHolder)) && (newInst.placeHolderElement ? newInst.placeHolderElement !== e.target :
                true)) {
                if (e.target.className.indexOf('e-list-group-item') > -1) {
                    target = e.target;
                }
                _this.curTarget = target;
                if (_this.target === target) {
                    return;
                }
                var oldIdx = _this.getIndex(newInst.placeHolderElement, newInst);
                var placeHolder = _this.getPlaceHolder(target, newInst);
                var newIdx = void 0;
                if (placeHolder) {
                    oldIdx = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(oldIdx) ? _this.getIndex(_this.target) : oldIdx;
                    newIdx = _this.getIndex(target, newInst, e.event);
                    var isPlaceHolderPresent = _this.isPlaceHolderPresent(newInst);
                    if (isPlaceHolderPresent && oldIdx === newIdx) {
                        return;
                    }
                    if (isPlaceHolderPresent) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(newInst.placeHolderElement);
                    }
                    newInst.placeHolderElement = placeHolder;
                    if (e.target.className.indexOf('e-list-group-item') > -1) {
                        newInst.element.insertBefore(newInst.placeHolderElement, newInst.element.children[newIdx]);
                    }
                    else if (newInst.element !== _this.element && newIdx === newInst.element.childElementCount) {
                        newInst.element.appendChild(newInst.placeHolderElement);
                    }
                    else {
                        newInst.element.insertBefore(newInst.placeHolderElement, newInst.element.children[newIdx]);
                    }
                    _this.refreshDisabled(oldIdx, newIdx, newInst);
                }
                else {
                    oldIdx = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(oldIdx) ? _this.getIndex(_this.target) :
                        _this.getIndex(target, newInst) < oldIdx || !oldIdx ? oldIdx : oldIdx - 1;
                    newIdx = _this.getIndex(target, newInst);
                    var idx = newInst.element !== _this.element ? newIdx : oldIdx < newIdx ? newIdx + 1 : newIdx;
                    _this.updateItemClass(newInst);
                    newInst.element.insertBefore(_this.target, newInst.element.children[idx]);
                    _this.refreshDisabled(oldIdx, newIdx, newInst);
                    _this.curTarget = _this.target;
                    _this.trigger('drop', {
                        droppedElement: _this.target, element: newInst.element, previousIndex: oldIdx, currentIndex: newIdx,
                        target: e.target, helper: document.getElementsByClassName('e-sortableclone')[0], event: e.event, scope: _this.scope
                    });
                }
            }
            newInst = _this.getSortableInstance(_this.curTarget);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(target) && e.target !== newInst.placeHolderElement) {
                if (_this.isPlaceHolderPresent(newInst)) {
                    _this.removePlaceHolder(newInst);
                }
            }
            else {
                var placeHolders = [].slice.call(document.getElementsByClassName('e-sortable-placeholder'));
                var inst_1;
                placeHolders.forEach(function (placeHolder) {
                    inst_1 = _this.getSortableInstance(placeHolder);
                    if (inst_1.element && inst_1 !== newInst) {
                        _this.removePlaceHolder(inst_1);
                    }
                });
            }
        };
        // eslint-disable-next-line
        _this.onDragStart = function (e) {
            _this.target = _this.getSortableElement(e.target);
            var cancelDrag = false;
            _this.target.classList.add('e-grabbed');
            _this.curTarget = _this.target;
            e.helper = document.getElementsByClassName('e-sortableclone')[0];
            var args = { cancel: false, element: _this.element, target: _this.target };
            _this.trigger('beforeDragStart', args, function (observedArgs) {
                if (observedArgs.cancel) {
                    cancelDrag = observedArgs.cancel;
                    _this.onDragStop(e);
                }
            });
            if (cancelDrag) {
                return;
            }
            if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["P" /* isBlazor */]) {
                _this.trigger('dragStart', {
                    event: e.event, element: _this.element, target: _this.target,
                    bindEvents: e.bindEvents, dragElement: e.dragElement
                });
            }
            else {
                _this.trigger('dragStart', { event: e.event, element: _this.element, target: _this.target });
            }
        };
        // eslint-disable-next-line
        _this.onDragStop = function (e) {
            var dropInst = _this.getSortableInstance(_this.curTarget);
            var prevIdx;
            var curIdx;
            var handled;
            prevIdx = _this.getIndex(_this.target);
            var isPlaceHolderPresent = _this.isPlaceHolderPresent(dropInst);
            if (isPlaceHolderPresent) {
                var curIdx_1 = _this.getIndex(dropInst.placeHolderElement, dropInst);
                var args = {
                    previousIndex: prevIdx, currentIndex: curIdx_1, target: e.target, droppedElement: _this.target,
                    helper: e.helper, cancel: false, handled: false
                };
                _this.trigger('beforeDrop', args, function (observedArgs) {
                    if (!observedArgs.cancel) {
                        handled = observedArgs.handled;
                        _this.updateItemClass(dropInst);
                        if (observedArgs.handled) {
                            var ele = _this.target.cloneNode(true);
                            _this.target.classList.remove('e-grabbed');
                            _this.target = ele;
                        }
                        dropInst.element.insertBefore(_this.target, dropInst.placeHolderElement);
                        var curIdx_2 = _this.getIndex(_this.target, dropInst);
                        prevIdx = _this === dropInst && (prevIdx - curIdx_2) > 1 ? prevIdx - 1 : prevIdx;
                        _this.trigger('drop', {
                            event: e.event, element: dropInst.element, previousIndex: prevIdx, currentIndex: curIdx_2,
                            target: e.target, helper: e.helper, droppedElement: _this.target, scopeName: _this.scope, handled: handled
                        });
                    }
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(dropInst.placeHolderElement);
                });
            }
            dropInst = _this.getSortableInstance(e.target);
            // eslint-disable-next-line prefer-const
            curIdx = dropInst.element.childElementCount;
            prevIdx = _this.getIndex(_this.target);
            if (dropInst.element === e.target || (!isPlaceHolderPresent && _this.curTarget === _this.target)) {
                var beforeDropArgs = {
                    previousIndex: prevIdx, currentIndex: _this.curTarget === _this.target ? prevIdx : curIdx,
                    target: e.target, droppedElement: _this.target, helper: e.helper, cancel: false
                };
                _this.trigger('beforeDrop', beforeDropArgs, function (observedArgs) {
                    if (dropInst.element === e.target && !observedArgs.cancel) {
                        _this.updateItemClass(dropInst);
                        dropInst.element.appendChild(_this.target);
                        _this.trigger('drop', {
                            event: e.event, element: dropInst.element, previousIndex: prevIdx, currentIndex: curIdx,
                            target: e.target, helper: e.helper, droppedElement: _this.target, scopeName: _this.scope
                        });
                    }
                });
            }
            _this.target.classList.remove('e-grabbed');
            _this.target = null;
            _this.curTarget = null;
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(e.helper);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["H" /* getComponent */])(_this.element, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["i" /* Draggable */]).intDestroy(e.event);
        };
        _this.bind();
        return _this;
    }
    Sortable_1 = Sortable;
    Sortable.prototype.bind = function () {
        if (!this.element.id) {
            this.element.id = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('sortable');
        }
        if (!this.itemClass) {
            this.itemClass = 'e-sort-item';
            this.dataBind();
        }
        this.initializeDraggable();
    };
    Sortable.prototype.initializeDraggable = function () {
        new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["i" /* Draggable */](this.element, {
            helper: this.getHelper,
            dragStart: this.onDragStart,
            drag: this.onDrag,
            dragStop: this.onDragStop,
            dragTarget: "." + this.itemClass,
            enableTapHold: true,
            tapHoldThreshold: 200,
            queryPositionInfo: this.queryPositionInfo,
            distance: 5
        });
    };
    Sortable.prototype.getPlaceHolder = function (target, instance) {
        if (instance.placeHolder) {
            var placeHolderElement = instance.placeHolder({ element: instance.element, grabbedElement: this.target, target: target });
            placeHolderElement.classList.add('e-sortable-placeholder');
            return placeHolderElement;
        }
        return null;
    };
    Sortable.prototype.isValidTarget = function (target, instance) {
        return target && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["z" /* compareElementParent */])(target, instance.element) && target.classList.contains(instance.itemClass) &&
            !target.classList.contains('e-disabled');
    };
    Sortable.prototype.removePlaceHolder = function (instance) {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(instance.placeHolderElement);
        instance.placeHolderElement = null;
    };
    Sortable.prototype.updateItemClass = function (instance) {
        if (this !== instance) {
            this.target.classList.remove(this.itemClass);
            this.target.classList.add(instance.itemClass);
        }
    };
    Sortable.prototype.getSortableInstance = function (element) {
        element = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(element, ".e-" + this.getModuleName());
        if (element) {
            var inst = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["H" /* getComponent */])(element, Sortable_1);
            return inst.scope && this.scope && inst.scope === this.scope ? inst : this;
        }
        else {
            return this;
        }
    };
    Sortable.prototype.refreshDisabled = function (oldIdx, newIdx, instance) {
        if (instance === this) {
            var element = void 0;
            var increased = oldIdx < newIdx;
            var disabledIdx = void 0;
            var start = increased ? oldIdx : newIdx;
            var end = increased ? newIdx : oldIdx;
            while (start <= end) {
                element = this.element.children[start];
                if (element.classList.contains('e-disabled')) {
                    disabledIdx = this.getIndex(element);
                    this.element.insertBefore(element, this.element.children[increased ? disabledIdx + 2 : disabledIdx - 1]);
                    start = increased ? disabledIdx + 2 : disabledIdx + 1;
                }
                else {
                    start++;
                }
            }
        }
    };
    Sortable.prototype.getIndex = function (target, instance, e) {
        if (instance === void 0) { instance = this; }
        var idx;
        var placeHolderPresent;
        [].slice.call(instance.element.children).forEach(function (element, index) {
            if (element.classList.contains('e-sortable-placeholder')) {
                placeHolderPresent = true;
            }
            if (element === target) {
                idx = index;
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e)) {
                    if (placeHolderPresent) {
                        idx -= 1;
                    }
                    var offset = target.getBoundingClientRect();
                    var clientY = offset.bottom - ((offset.bottom - offset.top) / 2);
                    idx = e.clientY <= clientY ? idx : idx + 1;
                }
                return;
            }
        });
        return idx;
    };
    Sortable.prototype.getSortableElement = function (element, instance) {
        if (instance === void 0) { instance = this; }
        return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(element, "." + instance.itemClass);
    };
    Sortable.prototype.queryPositionInfo = function (value) {
        value.left = pageXOffset ? parseFloat(value.left) - pageXOffset + "px" : value.left;
        value.top = pageYOffset ? parseFloat(value.top) - pageYOffset + "px" : value.top;
        return value;
    };
    Sortable.prototype.isPlaceHolderPresent = function (instance) {
        return instance.placeHolderElement && !!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(instance.placeHolderElement, "#" + instance.element.id);
    };
    /**
     * It is used to sort array of elements from source element to destination element.
     *
     * @param destination - Defines the destination element to which the sortable elements needs to be appended.
     *
     * If it is null, then the Sortable library element will be considered as destination.
     * @param targetIndexes - Specifies the sortable elements indexes which needs to be sorted.
     * @param insertBefore - Specifies the index before which the sortable elements needs to be appended.
     * If it is null, elements will be appended as last child.
     * @function moveTo
     * @returns {void}
     */
    Sortable.prototype.moveTo = function (destination, targetIndexes, insertBefore) {
        moveTo(this.element, destination, targetIndexes, insertBefore);
    };
    /**
     * It is used to destroy the Sortable library.
     */
    Sortable.prototype.destroy = function () {
        if (this.itemClass === 'e-sort-item') {
            this.itemClass = null;
            this.dataBind();
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["H" /* getComponent */])(this.element, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["i" /* Draggable */]).destroy();
        _super.prototype.destroy.call(this);
    };
    Sortable.prototype.getModuleName = function () {
        return 'sortable';
    };
    Sortable.prototype.onPropertyChanged = function (newProp, oldProp) {
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'itemClass':
                    [].slice.call(this.element.children).forEach(function (element) {
                        if (element.classList.contains(oldProp.itemClass)) {
                            element.classList.remove(oldProp.itemClass);
                        }
                        if (newProp.itemClass) {
                            element.classList.add(newProp.itemClass);
                        }
                    });
                    break;
            }
        }
    };
    var Sortable_1;
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Sortable.prototype, "enableAnimation", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], Sortable.prototype, "itemClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], Sortable.prototype, "scope", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Sortable.prototype, "helper", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Sortable.prototype, "placeHolder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Sortable.prototype, "drag", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Sortable.prototype, "beforeDragStart", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Sortable.prototype, "dragStart", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Sortable.prototype, "beforeDrop", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Sortable.prototype, "drop", void 0);
    Sortable = Sortable_1 = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], Sortable);
    return Sortable;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["c" /* Base */]));

/**
 * It is used to sort array of elements from source element to destination element.
 *
 * @private
 */
function moveTo(from, to, targetIndexes, insertBefore) {
    var targetElements = [];
    if (!to) {
        to = from;
    }
    if (targetIndexes && targetIndexes.length) {
        targetIndexes.forEach(function (index) {
            targetElements.push(from.children[index]);
        });
    }
    else {
        targetElements = [].slice.call(from.children);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(insertBefore)) {
        targetElements.forEach(function (target) {
            to.appendChild(target);
        });
    }
    else {
        var insertElement_1 = to.children[insertBefore];
        targetElements.forEach(function (target) {
            to.insertBefore(target, insertElement_1);
        });
    }
}


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popup_index__ = __webpack_require__(235);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__popup_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__popup_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__popup_index__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_index__ = __webpack_require__(236);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__common_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__common_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__common_index__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dialog_index__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tooltip_index__ = __webpack_require__(240);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__tooltip_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__spinner_index__ = __webpack_require__(242);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__spinner_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__spinner_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_4__spinner_index__["c"]; });
/**
 * Popup Components
 */







/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popup__ = __webpack_require__(43);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__popup__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__popup__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__popup__["d"]; });
/**
 * Popup Components
 */



/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__position__ = __webpack_require__(33);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__position__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collision__ = __webpack_require__(44);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__collision__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__collision__["c"]; });
/**
 * Popup Components
 */




/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dialog__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/**
 * Dialog Component
 */



/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ButtonProps */
/* unused harmony export AnimationSettings */
/* unused harmony export Dialog */
/* unused harmony export DialogUtility */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popup_popup__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_resize__ = __webpack_require__(239);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var ButtonProps = /** @class */ (function (_super) {
    __extends(ButtonProps, _super);
    function ButtonProps() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], ButtonProps.prototype, "isFlat", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], ButtonProps.prototype, "buttonModel", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Button')
    ], ButtonProps.prototype, "type", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ButtonProps.prototype, "click", void 0);
    return ButtonProps;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * Configures the animation properties for both open and close the dialog.
 */
var AnimationSettings = /** @class */ (function (_super) {
    __extends(AnimationSettings, _super);
    function AnimationSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Fade')
    ], AnimationSettings.prototype, "effect", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(400)
    ], AnimationSettings.prototype, "duration", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(0)
    ], AnimationSettings.prototype, "delay", void 0);
    return AnimationSettings;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

var ROOT = 'e-dialog';
var RTL = 'e-rtl';
var DLG_HEADER_CONTENT = 'e-dlg-header-content';
var DLG_HEADER = 'e-dlg-header';
var DLG_FOOTER_CONTENT = 'e-footer-content';
var MODAL_DLG = 'e-dlg-modal';
var DLG_CONTENT = 'e-dlg-content';
var DLG_CLOSE_ICON = 'e-icon-dlg-close';
var DLG_OVERLAY = 'e-dlg-overlay';
var DLG_TARGET = 'e-dlg-target';
var DLG_CONTAINER = 'e-dlg-container';
var SCROLL_DISABLED = 'e-scroll-disabled';
var DLG_PRIMARY_BUTTON = 'e-primary';
var ICON = 'e-icons';
var POPUP_ROOT = 'e-popup';
var DEVICE = 'e-device';
var FULLSCREEN = 'e-dlg-fullscreen';
var DLG_CLOSE_ICON_BTN = 'e-dlg-closeicon-btn';
var DLG_HIDE = 'e-popup-close';
var DLG_SHOW = 'e-popup-open';
var DLG_UTIL_DEFAULT_TITLE = 'Information';
var DLG_UTIL_ROOT = 'e-scroll-disabled';
var DLG_UTIL_ALERT = 'e-alert-dialog';
var DLG_UTIL_CONFIRM = 'e-confirm-dialog';
var DLG_RESIZABLE = 'e-dlg-resizable';
var DLG_RESTRICT_LEFT_VALUE = 'e-restrict-left';
var DLG_RESTRICT_WIDTH_VALUE = 'e-resize-viewport';
var DLG_REF_ELEMENT = 'e-dlg-ref-element';
var DLG_USER_ACTION_CLOSED = 'user action';
var DLG_CLOSE_ICON_CLOSED = 'close icon';
var DLG_ESCAPE_CLOSED = 'escape';
var DLG_OVERLAYCLICK_CLOSED = 'overlayClick';
/**
 * Represents the dialog component that displays the information and get input from the user.
 * Two types of dialog components are `Modal and Modeless (non-modal)` depending on its interaction with parent application.
 * ```html
 * <div id="dialog"></div>
 * ```
 * ```typescript
 * <script>
 *   var dialogObj = new Dialog({ header: 'Dialog' });
 *   dialogObj.appendTo("#dialog");
 * </script>
 * ```
 */
var Dialog = /** @class */ (function (_super) {
    __extends(Dialog, _super);
    /*
     * * Constructor for creating the widget
     *
     * @param
     * @param
     * @hidden
     */
    function Dialog(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.dlgClosedBy = DLG_USER_ACTION_CLOSED;
        return _this;
    }
    /**
     *Initialize the control rendering
     *
     * @returns {void}
     * @private
     */
    Dialog.prototype.render = function () {
        this.initialize();
        this.initRender();
        this.wireEvents();
        if (this.width === '100%') {
            this.element.style.width = '';
        }
        if (this.minHeight !== '') {
            this.element.style.minHeight = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.minHeight);
        }
        if (this.enableResize) {
            this.setResize();
            if (this.animationSettings.effect === 'None') {
                this.getMinHeight();
            }
        }
        this.renderComplete();
    };
    /**
     *Initialize the event handler
     *
     * @returns {void}
     * @private
     */
    Dialog.prototype.preRender = function () {
        var _this = this;
        this.headerContent = null;
        this.allowMaxHeight = true;
        this.preventVisibility = true;
        this.clonedEle = this.element.cloneNode(true);
        this.closeIconClickEventHandler = function (event) {
            _this.dlgClosedBy = DLG_CLOSE_ICON_CLOSED;
            _this.hide(event);
        };
        // eslint-disable-next-line
        this.dlgOverlayClickEventHandler = function (event) {
            _this.dlgClosedBy = DLG_OVERLAYCLICK_CLOSED;
            event.preventFocus = false;
            _this.trigger('overlayClick', event, function (overlayClickEventArgs) {
                if (!overlayClickEventArgs.preventFocus) {
                    _this.focusContent();
                }
                _this.dlgClosedBy = DLG_USER_ACTION_CLOSED;
            });
        };
        // eslint-disable-next-line
        var localeText = { close: 'Close' };
        this.l10n = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["o" /* L10n */]('dialog', localeText, this.locale);
        this.checkPositionData();
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.target)) {
            var prevOnChange = this.isProtectedOnChange;
            this.isProtectedOnChange = true;
            this.target = document.body;
            this.isProtectedOnChange = prevOnChange;
        }
    };
    Dialog.prototype.isNumberValue = function (value) {
        var isNumber = /^[-+]?\d*\.?\d+$/.test(value);
        return isNumber;
    };
    Dialog.prototype.checkPositionData = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.position)) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.position.X) && (typeof (this.position.X) !== 'number')) {
                var isNumber = this.isNumberValue(this.position.X);
                if (isNumber) {
                    var prevOnChange = this.isProtectedOnChange;
                    this.isProtectedOnChange = true;
                    this.position.X = parseFloat(this.position.X);
                    this.isProtectedOnChange = prevOnChange;
                }
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.position.Y) && (typeof (this.position.Y) !== 'number')) {
                var isNumber = this.isNumberValue(this.position.Y);
                if (isNumber) {
                    var prevOnChange = this.isProtectedOnChange;
                    this.isProtectedOnChange = true;
                    this.position.Y = parseFloat(this.position.Y);
                    this.isProtectedOnChange = prevOnChange;
                }
            }
        }
    };
    Dialog.prototype.getEle = function (list, selector) {
        var element = undefined;
        for (var i = 0; i < list.length; i++) {
            if (list[i].classList.contains(selector)) {
                element = list[i];
                break;
            }
        }
        return element;
    };
    /* istanbul ignore next */
    Dialog.prototype.getMinHeight = function () {
        var computedHeaderHeight = '0px';
        var computedFooterHeight = '0px';
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.querySelector('.' + DLG_HEADER_CONTENT))) {
            computedHeaderHeight = getComputedStyle(this.headerContent).height;
        }
        var footerEle = this.getEle(this.element.children, DLG_FOOTER_CONTENT);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(footerEle)) {
            computedFooterHeight = getComputedStyle(footerEle).height;
        }
        var headerHeight = parseInt(computedHeaderHeight.slice(0, computedHeaderHeight.indexOf('p')), 10);
        var footerHeight = parseInt(computedFooterHeight.slice(0, computedFooterHeight.indexOf('p')), 10);
        Object(__WEBPACK_IMPORTED_MODULE_3__common_resize__["e" /* setMinHeight */])(headerHeight + 30 + (isNaN(footerHeight) ? 0 : footerHeight));
        return (headerHeight + 30 + footerHeight);
    };
    Dialog.prototype.onResizeStart = function (args, dialogObj) {
        dialogObj.trigger('resizeStart', args);
        return args.cancel;
    };
    Dialog.prototype.onResizing = function (args, dialogObj) {
        dialogObj.trigger('resizing', args);
    };
    Dialog.prototype.onResizeComplete = function (args, dialogObj) {
        dialogObj.trigger('resizeStop', args);
    };
    Dialog.prototype.setResize = function () {
        if (this.enableResize) {
            if (this.isBlazorServerRender() && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.querySelector('.e-icons.e-resize-handle'))) {
                return;
            }
            this.element.classList.add(DLG_RESIZABLE);
            var computedHeight = getComputedStyle(this.element).minHeight;
            var computedWidth = getComputedStyle(this.element).minWidth;
            var direction = '';
            for (var i = 0; i < this.resizeHandles.length; i++) {
                if (this.resizeHandles[i] === 'All') {
                    direction = 'south north east west north-east north-west south-east south-west';
                    break;
                }
                else {
                    var directionValue = '';
                    switch (this.resizeHandles[i].toString()) {
                        case 'SouthEast':
                            directionValue = 'south-east';
                            break;
                        case 'SouthWest':
                            directionValue = 'south-west';
                            break;
                        case 'NorthEast':
                            directionValue = 'north-east';
                            break;
                        case 'NorthWest':
                            directionValue = 'north-west';
                            break;
                        default:
                            directionValue = this.resizeHandles[i].toString();
                            break;
                    }
                    direction += directionValue.toLocaleLowerCase() + ' ';
                }
            }
            if (this.enableRtl && direction.trim() === 'south-east') {
                direction = 'south-west';
            }
            else if (this.enableRtl && direction.trim() === 'south-west') {
                direction = 'south-east';
            }
            if (this.isModal && this.enableRtl) {
                this.element.classList.add(DLG_RESTRICT_LEFT_VALUE);
            }
            else if (this.isModal && this.target === document.body) {
                this.element.classList.add(DLG_RESTRICT_WIDTH_VALUE);
            }
            Object(__WEBPACK_IMPORTED_MODULE_3__common_resize__["a" /* createResize */])({
                element: this.element,
                direction: direction,
                minHeight: parseInt(computedHeight.slice(0, computedWidth.indexOf('p')), 10),
                maxHeight: this.targetEle.clientHeight,
                minWidth: parseInt(computedWidth.slice(0, computedWidth.indexOf('p')), 10),
                maxWidth: this.targetEle.clientWidth,
                boundary: this.target === document.body ? null : this.targetEle,
                resizeBegin: this.onResizeStart.bind(this),
                resizeComplete: this.onResizeComplete.bind(this),
                resizing: this.onResizing.bind(this),
                proxy: this
            });
            this.wireWindowResizeEvent();
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_3__common_resize__["b" /* removeResize */])();
            this.unWireWindowResizeEvent();
            if (this.isModal) {
                this.element.classList.remove(DLG_RESTRICT_LEFT_VALUE);
            }
            else {
                this.element.classList.remove(DLG_RESTRICT_WIDTH_VALUE);
            }
            this.element.classList.remove(DLG_RESIZABLE);
        }
    };
    Dialog.prototype.getFocusElement = function (target) {
        var value = 'input,select,textarea,button:enabled,a,[contenteditable="true"],[tabindex]';
        var items = target.querySelectorAll(value);
        return { element: items[items.length - 1] };
    };
    /* istanbul ignore next */
    Dialog.prototype.keyDown = function (event) {
        var _this = this;
        if (event.keyCode === 9) {
            if (this.isModal) {
                var buttonObj = void 0;
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.btnObj)) {
                    buttonObj = this.btnObj[this.btnObj.length - 1];
                }
                if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.btnObj)) && (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.ftrTemplateContent))) {
                    buttonObj = this.getFocusElement(this.ftrTemplateContent);
                }
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.btnObj) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.ftrTemplateContent) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.contentEle)) {
                    buttonObj = this.getFocusElement(this.contentEle);
                }
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(buttonObj) && document.activeElement === buttonObj.element && !event.shiftKey) {
                    event.preventDefault();
                    this.focusableElements(this.element).focus();
                }
                if (document.activeElement === this.focusableElements(this.element) && event.shiftKey) {
                    event.preventDefault();
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(buttonObj)) {
                        buttonObj.element.focus();
                    }
                }
            }
        }
        var element = document.activeElement;
        var isTagName = (['input', 'textarea'].indexOf(element.tagName.toLowerCase()) > -1);
        var isContentEdit = false;
        if (!isTagName) {
            isContentEdit = element.hasAttribute('contenteditable') && element.getAttribute('contenteditable') === 'true';
        }
        if (event.keyCode === 27 && this.closeOnEscape) {
            this.dlgClosedBy = DLG_ESCAPE_CLOSED;
            // 'document.querySelector' is used to find the elements rendered based on body
            if (!document.querySelector('.e-popup-open:not(.e-dialog)')) {
                this.hide(event);
            }
        }
        if ((event.keyCode === 13 && !event.ctrlKey && element.tagName.toLowerCase() !== 'textarea' &&
            isTagName && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.primaryButtonEle)) ||
            (event.keyCode === 13 && event.ctrlKey && (element.tagName.toLowerCase() === 'textarea' ||
                isContentEdit)) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.primaryButtonEle)) {
            var buttonIndex_1;
            // eslint-disable-next-line
            var firstPrimary = this.buttons.some(function (data, index) {
                buttonIndex_1 = index;
                // eslint-disable-next-line
                var buttonModel = data.buttonModel;
                return !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(buttonModel) && buttonModel.isPrimary === true;
            });
            if (firstPrimary && typeof (this.buttons[buttonIndex_1].click) === 'function') {
                setTimeout(function () {
                    _this.buttons[buttonIndex_1].click.call(_this, event);
                });
            }
        }
    };
    /**
     * Initialize the control rendering
     *
     * @returns {void}
     * @private
     */
    Dialog.prototype.initialize = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.target)) {
            this.targetEle = ((typeof this.target) === 'string') ?
                document.querySelector(this.target) : this.target;
        }
        if (!this.isBlazorServerRender()) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], ROOT);
        }
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], DEVICE);
        }
        if (!this.isBlazorServerRender()) {
            this.setCSSClass();
        }
        this.setMaxHeight();
    };
    /**
     * Initialize the rendering
     *
     * @returns {void}
     * @private
     */
    Dialog.prototype.initRender = function () {
        var _this = this;
        this.initialRender = true;
        if (!this.isBlazorServerRender()) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { role: 'dialog' });
        }
        if (this.zIndex === 1000) {
            this.setzIndex(this.element, false);
            this.calculatezIndex = true;
        }
        else {
            this.calculatezIndex = false;
        }
        if (this.isBlazorServerRender() && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.headerContent)) {
            this.headerContent = this.element.getElementsByClassName('e-dlg-header-content')[0];
        }
        if (this.isBlazorServerRender() && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.contentEle)) {
            this.contentEle = this.element.querySelector('#' + this.element.id + '_dialog-content');
        }
        if (!this.isBlazorServerRender()) {
            this.setTargetContent();
            if (this.header !== '' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.header)) {
                this.setHeader();
            }
            this.renderCloseIcon();
            this.setContent();
            if (this.footerTemplate !== '' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.footerTemplate)) {
                this.setFooterTemplate();
            }
            else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.buttons[0].buttonModel)) {
                this.setButton();
            }
        }
        if (this.isBlazorServerRender()) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.buttons[0].buttonModel) && this.footerTemplate === '') {
                this.setButton();
            }
        }
        if (this.allowDragging && (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.headerContent))) {
            this.setAllowDragging();
        }
        if (!this.isBlazorServerRender()) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'aria-modal': (this.isModal ? 'true' : 'false') });
            if (this.isModal) {
                this.setIsModal();
            }
        }
        if (this.isBlazorServerRender() && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.dlgContainer)) {
            this.dlgContainer = this.element.parentElement;
            for (var i = 0, childNodes = this.dlgContainer.children; i < childNodes.length; i++) {
                if (childNodes[i].classList.contains('e-dlg-overlay')) {
                    this.dlgOverlay = childNodes[i];
                }
            }
        }
        if (this.element.classList.contains(DLG_UTIL_ALERT) !== true && this.element.classList.contains(DLG_UTIL_CONFIRM) !== true
            && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.parentElement)) {
            var parentEle = this.isModal ? this.dlgContainer.parentElement : this.element.parentElement;
            this.refElement = this.createElement('div', { className: DLG_REF_ELEMENT });
            parentEle.insertBefore(this.refElement, (this.isModal ? this.dlgContainer : this.element));
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.targetEle)) {
            // eslint-disable-next-line
            this.isModal ? this.targetEle.appendChild(this.dlgContainer) : this.targetEle.appendChild(this.element);
        }
        this.popupObj = new __WEBPACK_IMPORTED_MODULE_2__popup_popup__["a" /* Popup */](this.element, {
            height: this.height,
            width: this.width,
            zIndex: this.zIndex,
            relateTo: this.target,
            actionOnScroll: 'none',
            enableRtl: this.enableRtl,
            // eslint-disable-next-line
            open: function (event) {
                // eslint-disable-next-line
                var eventArgs = {
                    container: _this.isModal ? _this.dlgContainer : _this.element,
                    element: _this.element,
                    target: _this.target,
                    preventFocus: false
                };
                if (_this.enableResize) {
                    _this.resetResizeIcon();
                }
                // eslint-disable-next-line
                _this.trigger('open', eventArgs, function (openEventArgs) {
                    if (!openEventArgs.preventFocus) {
                        _this.focusContent();
                    }
                });
            },
            // eslint-disable-next-line
            close: function (event) {
                if (_this.isModal) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([_this.dlgOverlay], 'e-fade');
                }
                _this.unBindEvent(_this.element);
                if (_this.isModal) {
                    _this.dlgContainer.style.display = 'none';
                }
                _this.trigger('close', _this.closeArgs);
                var activeEle = document.activeElement;
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(activeEle) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])((activeEle).blur)) {
                    activeEle.blur();
                }
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(_this.storeActiveElement) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(_this.storeActiveElement.focus)) {
                    _this.storeActiveElement.focus();
                }
            }
        });
        this.positionChange();
        this.setEnableRTL();
        if (!this.isBlazorServerRender()) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], DLG_HIDE);
            if (this.isModal) {
                this.setOverlayZindex();
            }
        }
        if (this.visible) {
            this.show();
        }
        else {
            if (this.isModal) {
                this.dlgOverlay.style.display = 'none';
            }
        }
        this.initialRender = false;
    };
    Dialog.prototype.resetResizeIcon = function () {
        var dialogConHeight = this.getMinHeight();
        if (this.targetEle.offsetHeight < dialogConHeight) {
            var className = this.enableRtl ? 'e-south-west' : 'e-south-east';
            var resizeIcon = this.element.querySelector('.' + className);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(resizeIcon)) {
                resizeIcon.style.bottom = '-' + dialogConHeight.toString() + 'px';
            }
        }
    };
    Dialog.prototype.setOverlayZindex = function (zIndexValue) {
        var zIndex;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(zIndexValue)) {
            zIndex = parseInt(this.element.style.zIndex, 10) ? parseInt(this.element.style.zIndex, 10) : this.zIndex;
        }
        else {
            zIndex = zIndexValue;
        }
        this.dlgOverlay.style.zIndex = (zIndex - 1).toString();
        this.dlgContainer.style.zIndex = zIndex.toString();
    };
    Dialog.prototype.positionChange = function () {
        if (this.isModal) {
            if (!isNaN(parseFloat(this.position.X)) && !isNaN(parseFloat(this.position.Y))) {
                this.setPopupPosition();
            }
            else if ((!isNaN(parseFloat(this.position.X)) && isNaN(parseFloat(this.position.Y)))
                || (isNaN(parseFloat(this.position.X)) && !isNaN(parseFloat(this.position.Y)))) {
                this.setPopupPosition();
            }
            else {
                this.element.style.top = '0px';
                this.element.style.left = '0px';
                this.dlgContainer.classList.add('e-dlg-' + this.position.X + '-' + this.position.Y);
            }
        }
        else {
            this.setPopupPosition();
        }
    };
    Dialog.prototype.setPopupPosition = function () {
        this.popupObj.setProperties({
            position: {
                X: this.position.X, Y: this.position.Y
            }
        });
    };
    Dialog.prototype.setAllowDragging = function () {
        var _this = this;
        var handleContent = '.' + DLG_HEADER_CONTENT;
        this.dragObj = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["i" /* Draggable */](this.element, {
            clone: false,
            isDragScroll: true,
            abort: '.e-dlg-closeicon-btn',
            handle: handleContent,
            // eslint-disable-next-line
            dragStart: function (event) {
                // eslint-disable-next-line
                _this.trigger('dragStart', event, function (dragEventArgs) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["P" /* isBlazor */])()) {
                        dragEventArgs.bindEvents(event.dragElement);
                    }
                });
            },
            // eslint-disable-next-line
            dragStop: function (event) {
                if (_this.isModal) {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(_this.position)) {
                        _this.dlgContainer.classList.remove('e-dlg-' + _this.position.X + '-' + _this.position.Y);
                    }
                    // Reset the dialog position after drag completion.
                    _this.element.style.position = 'relative';
                }
                _this.trigger('dragStop', event);
                _this.element.classList.remove(DLG_RESTRICT_LEFT_VALUE);
            },
            // eslint-disable-next-line
            drag: function (event) {
                _this.trigger('drag', event);
            }
        });
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.targetEle)) {
            this.dragObj.dragArea = this.targetEle;
        }
    };
    Dialog.prototype.setButton = function () {
        if (!this.isBlazorServerRender()) {
            this.buttonContent = [];
            this.btnObj = [];
            // eslint-disable-next-line
            var primaryBtnFlag = true;
            for (var i = 0; i < this.buttons.length; i++) {
                var buttonType = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.buttons[i].type) ? this.buttons[i].type.toLowerCase() : 'button';
                var btn = this.createElement('button', { attrs: { type: buttonType } });
                this.buttonContent.push(btn.outerHTML);
            }
            this.setFooterTemplate();
        }
        var footerBtn;
        for (var i = 0, childNodes = this.element.children; i < childNodes.length; i++) {
            if (childNodes[i].classList.contains(DLG_FOOTER_CONTENT)) {
                footerBtn = childNodes[i].querySelectorAll('button');
            }
        }
        for (var i = 0; i < this.buttons.length; i++) {
            if (!this.isBlazorServerRender()) {
                this.btnObj[i] = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__["a" /* Button */](this.buttons[i].buttonModel);
            }
            if (this.isBlazorServerRender()) {
                this.ftrTemplateContent = this.element.querySelector('.' + DLG_FOOTER_CONTENT);
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.ftrTemplateContent) && footerBtn.length > 0) {
                if (typeof (this.buttons[i].click) === 'function') {
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(footerBtn[i], 'click', this.buttons[i].click, this);
                }
                if (typeof (this.buttons[i].click) === 'object') {
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(footerBtn[i], 'click', this.buttonClickHandler.bind(this, i), this);
                }
            }
            if (!this.isBlazorServerRender() && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.ftrTemplateContent)) {
                this.btnObj[i].appendTo(this.ftrTemplateContent.children[i]);
                if (this.buttons[i].isFlat) {
                    this.btnObj[i].element.classList.add('e-flat');
                }
                this.primaryButtonEle = this.element.getElementsByClassName('e-primary')[0];
            }
        }
    };
    Dialog.prototype.buttonClickHandler = function (index) {
        this.trigger('buttons[' + index + '].click', {});
    };
    ;
    Dialog.prototype.setContent = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'aria-describedby': this.element.id + '_dialog-content' });
        this.contentEle = this.createElement('div', { className: DLG_CONTENT, id: this.element.id + '_dialog-content' });
        if (this.innerContentElement) {
            this.contentEle.appendChild(this.innerContentElement);
        }
        else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.content) && this.content !== '' || !this.initialRender) {
            // eslint-disable-next-line
            var blazorContain = Object.keys(window);
            if (typeof (this.content) === 'string' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["P" /* isBlazor */])()) {
                this.setTemplate(this.content, this.contentEle, 'content');
            }
            else if (this.content instanceof HTMLElement) {
                this.contentEle.appendChild(this.content);
            }
            else {
                this.setTemplate(this.content, this.contentEle, 'content');
            }
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.headerContent)) {
            this.element.insertBefore(this.contentEle, this.element.children[1]);
        }
        else {
            this.element.insertBefore(this.contentEle, this.element.children[0]);
        }
        if (this.height === 'auto') {
            if (!this.isBlazorServerRender() && __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isIE && this.element.style.width === '' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.width)) {
                this.element.style.width = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.width);
            }
            this.setMaxHeight();
        }
    };
    Dialog.prototype.setTemplate = function (template, toElement, prop) {
        // eslint-disable-next-line
        var templateFn;
        var templateProps;
        // eslint-disable-next-line
        var blazorContain = Object.keys(window);
        if (toElement.classList.contains(DLG_HEADER)) {
            templateProps = this.element.id + 'header';
        }
        else if (toElement.classList.contains(DLG_FOOTER_CONTENT)) {
            templateProps = this.element.id + 'footerTemplate';
        }
        else {
            templateProps = this.element.id + 'content';
        }
        var templateValue;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(template.outerHTML)) {
            toElement.appendChild(template);
        }
        else if ((typeof template === 'string') || (typeof template !== 'string') || (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["P" /* isBlazor */])() && !this.isStringTemplate)) {
            if ((typeof template === 'string')) {
                template = this.sanitizeHelper(template);
            }
            templateFn = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(template);
            templateValue = template;
        }
        var fromElements = [];
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(templateFn)) {
            var isString = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["P" /* isBlazor */])() &&
                !this.isStringTemplate && (templateValue).indexOf('<div>Blazor') === 0) ?
                this.isStringTemplate : true;
            for (var _i = 0, _a = templateFn({}, this, prop, templateProps, isString); _i < _a.length; _i++) {
                var item = _a[_i];
                fromElements.push(item);
            }
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])([].slice.call(fromElements), toElement);
        }
    };
    /*
     * @returns {void}
     * @hidden
     * @value
     */
    Dialog.prototype.sanitizeHelper = function (value) {
        if (this.enableHtmlSanitizer) {
            var dialogItem = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].beforeSanitize();
            var beforeEvent = {
                cancel: false,
                helper: null
            };
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])(dialogItem, dialogItem, beforeEvent);
            this.trigger('beforeSanitizeHtml', dialogItem);
            if (dialogItem.cancel && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dialogItem.helper)) {
                value = dialogItem.helper(value);
            }
            else if (!dialogItem.cancel) {
                value = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].serializeValue(dialogItem, value);
            }
        }
        return value;
    };
    Dialog.prototype.setMaxHeight = function () {
        if (!this.allowMaxHeight) {
            return;
        }
        var display = this.element.style.display;
        this.element.style.display = 'none';
        this.element.style.maxHeight = (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.target)) && (this.targetEle.offsetHeight < window.innerHeight) ?
            (this.targetEle.offsetHeight - 20) + 'px' : (window.innerHeight - 20) + 'px';
        this.element.style.display = display;
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isIE && this.height === 'auto' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.contentEle)
            && this.element.offsetHeight < this.contentEle.offsetHeight) {
            this.element.style.height = 'inherit';
        }
    };
    Dialog.prototype.setEnableRTL = function () {
        if (!this.isBlazorServerRender()) {
            // eslint-disable-next-line
            this.enableRtl ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], RTL) : Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], RTL);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.querySelector('.e-resize-handle'))) {
            Object(__WEBPACK_IMPORTED_MODULE_3__common_resize__["b" /* removeResize */])();
            this.setResize();
        }
    };
    Dialog.prototype.setTargetContent = function () {
        var _this = this;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.content) || this.content === '') {
            var isContent = this.element.innerHTML.replace(/\s|<(\/?|\/?)(!--!--)>/g, '') !== '';
            if (this.element.children.length > 0 || isContent) {
                this.innerContentElement = document.createDocumentFragment();
                [].slice.call(this.element.childNodes).forEach(function (el) {
                    if (el.nodeType !== 8) {
                        _this.innerContentElement.appendChild(el);
                    }
                });
            }
        }
    };
    Dialog.prototype.setHeader = function () {
        if (this.headerEle) {
            this.headerEle.innerHTML = '';
        }
        else {
            this.headerEle = this.createElement('div', { id: this.element.id + '_title', className: DLG_HEADER });
        }
        this.createHeaderContent();
        this.headerContent.appendChild(this.headerEle);
        this.setTemplate(this.header, this.headerEle, 'header');
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'aria-labelledby': this.element.id });
        this.element.insertBefore(this.headerContent, this.element.children[0]);
    };
    Dialog.prototype.setFooterTemplate = function () {
        if (this.ftrTemplateContent) {
            this.ftrTemplateContent.innerHTML = '';
        }
        else {
            this.ftrTemplateContent = this.createElement('div', {
                className: DLG_FOOTER_CONTENT
            });
        }
        if (this.footerTemplate !== '' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.footerTemplate)) {
            this.setTemplate(this.footerTemplate, this.ftrTemplateContent, 'footerTemplate');
        }
        else {
            this.ftrTemplateContent.innerHTML = this.buttonContent.join('');
        }
        this.element.appendChild(this.ftrTemplateContent);
    };
    Dialog.prototype.createHeaderContent = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.headerContent)) {
            this.headerContent = this.createElement('div', { id: this.element.id + '_dialog-header', className: DLG_HEADER_CONTENT });
        }
    };
    Dialog.prototype.renderCloseIcon = function () {
        if (this.showCloseIcon) {
            this.closeIcon = this.createElement('button', { className: DLG_CLOSE_ICON_BTN, attrs: { type: 'button' } });
            this.closeIconBtnObj = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__["a" /* Button */]({ cssClass: 'e-flat', iconCss: DLG_CLOSE_ICON + ' ' + ICON });
            this.closeIconTitle();
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.headerContent)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["X" /* prepend */])([this.closeIcon], this.headerContent);
            }
            else {
                this.createHeaderContent();
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["X" /* prepend */])([this.closeIcon], this.headerContent);
                this.element.insertBefore(this.headerContent, this.element.children[0]);
            }
            this.closeIconBtnObj.appendTo(this.closeIcon);
        }
    };
    Dialog.prototype.closeIconTitle = function () {
        this.l10n.setLocale(this.locale);
        var closeIconTitle = this.l10n.getConstant('close');
        this.closeIcon.setAttribute('title', closeIconTitle);
        this.closeIcon.setAttribute('aria-label', closeIconTitle);
    };
    Dialog.prototype.setCSSClass = function (oldCSSClass) {
        if (this.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], this.cssClass.split(' '));
        }
        if (oldCSSClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], oldCSSClass.split(' '));
        }
    };
    Dialog.prototype.setIsModal = function () {
        this.dlgContainer = this.createElement('div', { className: DLG_CONTAINER });
        this.element.classList.remove(DLG_SHOW);
        this.element.parentNode.insertBefore(this.dlgContainer, this.element);
        this.dlgContainer.appendChild(this.element);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], MODAL_DLG);
        this.dlgOverlay = this.createElement('div', { className: DLG_OVERLAY });
        this.dlgOverlay.style.zIndex = (this.zIndex - 1).toString();
        this.dlgContainer.appendChild(this.dlgOverlay);
    };
    Dialog.prototype.getValidFocusNode = function (items) {
        var node;
        for (var u = 0; u < items.length; u++) {
            node = items[u];
            if ((node.clientHeight > 0 || (node.tagName.toLowerCase() === 'a' && node.hasAttribute('href'))) && node.tabIndex > -1 &&
                !node.disabled && !this.disableElement(node, '[disabled],[aria-disabled="true"],[type="hidden"]')) {
                return node;
            }
            else {
                node = null;
            }
        }
        return node;
    };
    Dialog.prototype.focusableElements = function (content) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(content)) {
            var value = 'input,select,textarea,button,a,[contenteditable="true"],[tabindex]';
            var items = content.querySelectorAll(value);
            return this.getValidFocusNode(items);
        }
        return null;
    };
    Dialog.prototype.getAutoFocusNode = function (container) {
        var node = container.querySelector('.' + DLG_CLOSE_ICON_BTN);
        var value = '[autofocus]';
        var items = container.querySelectorAll(value);
        var validNode = this.getValidFocusNode(items);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["P" /* isBlazor */])()) {
            this.primaryButtonEle = this.element.getElementsByClassName('e-primary')[0];
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(validNode)) {
            node = validNode;
        }
        else {
            validNode = this.focusableElements(this.contentEle);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(validNode)) {
                return node = validNode;
            }
            else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.primaryButtonEle)) {
                return this.element.querySelector('.' + DLG_PRIMARY_BUTTON);
            }
        }
        return node;
    };
    Dialog.prototype.disableElement = function (element, t) {
        // eslint-disable-next-line
        var elementMatch = element ? element.matches || element.webkitMatchesSelector || element.msGetRegionContent : null;
        if (elementMatch) {
            for (; element; element = element.parentNode) {
                if (element instanceof Element && elementMatch.call(element, t)) {
                    /* istanbul ignore next */
                    return element;
                }
            }
        }
        return null;
    };
    Dialog.prototype.focusContent = function () {
        var element = this.getAutoFocusNode(this.element);
        var node = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(element) ? element : this.element;
        var userAgent = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].userAgent;
        if (userAgent.indexOf('MSIE ') > 0 || userAgent.indexOf('Trident/') > 0) {
            this.element.focus();
        }
        node.focus();
        this.bindEvent(this.element);
    };
    Dialog.prototype.bindEvent = function (element) {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(element, 'keydown', this.keyDown, this);
    };
    Dialog.prototype.unBindEvent = function (element) {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(element, 'keydown', this.keyDown);
    };
    Dialog.prototype.updateSanitizeContent = function () {
        if (!this.isBlazorServerRender()) {
            this.contentEle.innerHTML = this.sanitizeHelper(this.content);
        }
    };
    Dialog.prototype.isBlazorServerRender = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["P" /* isBlazor */])() && this.isServerRendered;
    };
    /**
     * Module required function
     *
     * @returns {void}
     * @private
     */
    Dialog.prototype.getModuleName = function () {
        return 'dialog';
    };
    /**
     * Called internally if any of the property value changed
     *
     * @param {DialogModel} newProp - specifies the new property
     * @param {DialogModel} oldProp - specifies the old property
     * @private
     * @returns {void}
     */
    Dialog.prototype.onPropertyChanged = function (newProp, oldProp) {
        if (!this.element.classList.contains(ROOT)) {
            return;
        }
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'content':
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.content) && this.content !== '') {
                        if (this.isBlazorServerRender()) {
                            this.contentEle = this.element.querySelector('.e-dlg-content');
                        }
                        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.contentEle) && this.contentEle.getAttribute('role') !== 'dialog') {
                            if (!this.isBlazorServerRender()) {
                                this.contentEle.innerHTML = '';
                            }
                            // eslint-disable-next-line
                            if (typeof (this.content) === 'function') {
                                this.clearTemplate(['content']);
                                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.contentEle);
                                this.contentEle = null;
                                this.setContent();
                            }
                            else {
                                typeof (this.content) === 'string' ? (this.isBlazorServerRender() && (this.contentEle.innerText === '')) ?
                                    this.contentEle.insertAdjacentHTML('beforeend', this.sanitizeHelper(this.content)) :
                                    this.updateSanitizeContent() : this.contentEle.appendChild(this.content);
                            }
                            this.setMaxHeight();
                        }
                        else {
                            if (!this.isBlazorServerRender() ||
                                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.querySelector('.e-dlg-content'))) {
                                this.setContent();
                            }
                        }
                    }
                    else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.contentEle)) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.contentEle);
                        this.contentEle = null;
                    }
                    break;
                case 'header':
                    if (this.header === '' || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.header)) {
                        if (this.headerEle) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.headerEle);
                            this.headerEle = null;
                        }
                    }
                    else {
                        if (!this.isBlazorServerRender() ||
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.querySelector('.e-dlg-header-content'))) {
                            this.setHeader();
                        }
                    }
                    break;
                case 'footerTemplate':
                    if (this.footerTemplate === '' || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.footerTemplate)) {
                        if (!this.ftrTemplateContent) {
                            return;
                        }
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.ftrTemplateContent);
                        this.ftrTemplateContent = null;
                        this.buttons = [{}];
                    }
                    else {
                        if (!this.isBlazorServerRender() ||
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.querySelector('.e-footer-content'))) {
                            this.setFooterTemplate();
                        }
                        this.buttons = [{}];
                    }
                    break;
                case 'showCloseIcon':
                    if (this.element.getElementsByClassName(DLG_CLOSE_ICON).length > 0) {
                        if (!this.showCloseIcon && (this.header === '' || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.header))) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.headerContent);
                            this.headerContent = null;
                        }
                        else if (!this.showCloseIcon) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.closeIcon);
                        }
                        else {
                            if (this.isBlazorServerRender()) {
                                this.wireEvents();
                            }
                        }
                    }
                    else {
                        if (!this.isBlazorServerRender()) {
                            this.renderCloseIcon();
                        }
                        this.wireEvents();
                    }
                    break;
                case 'locale':
                    if (this.showCloseIcon) {
                        this.closeIconTitle();
                    }
                    break;
                case 'visible':
                    // eslint-disable-next-line
                    this.visible ? this.show() : this.hide();
                    break;
                case 'isModal':
                    this.updateIsModal();
                    break;
                case 'height':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'height': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(newProp.height) });
                    break;
                case 'width':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'width': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(newProp.width) });
                    break;
                case 'zIndex':
                    this.popupObj.zIndex = this.zIndex;
                    if (this.isModal) {
                        this.setOverlayZindex(this.zIndex);
                    }
                    if (this.element.style.zIndex !== this.zIndex.toString()) {
                        this.calculatezIndex = false;
                    }
                    break;
                case 'cssClass':
                    this.setCSSClass(oldProp.cssClass);
                    break;
                case 'buttons': {
                    var buttonCount = this.buttons.length;
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.ftrTemplateContent) && !this.isBlazorServerRender()) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.ftrTemplateContent);
                        this.ftrTemplateContent = null;
                    }
                    for (var i = 0; i < buttonCount; i++) {
                        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.buttons[i].buttonModel)) {
                            this.footerTemplate = '';
                            this.setButton();
                        }
                    }
                    break;
                }
                case 'allowDragging':
                    if (this.allowDragging && (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.headerContent))) {
                        this.setAllowDragging();
                    }
                    else {
                        this.dragObj.destroy();
                    }
                    break;
                case 'target':
                    this.setTarget(newProp.target);
                    break;
                case 'position':
                    this.checkPositionData();
                    if (this.isModal) {
                        var positionX = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(oldProp.position.X) ? this.position.X : oldProp.position.X;
                        var positionY = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(oldProp.position.Y) ? this.position.Y : oldProp.position.Y;
                        if (this.dlgContainer.classList.contains('e-dlg-' + positionX + '-' + positionY)) {
                            this.dlgContainer.classList.remove('e-dlg-' + positionX + '-' + positionY);
                        }
                    }
                    this.positionChange();
                    break;
                case 'enableRtl':
                    this.setEnableRTL();
                    break;
                case 'enableResize':
                    this.setResize();
                    break;
            }
        }
    };
    Dialog.prototype.setTarget = function (target) {
        this.popupObj.relateTo = target;
        this.target = target;
        this.targetEle = ((typeof this.target) === 'string') ?
            document.querySelector(this.target) : this.target;
        if (this.dragObj) {
            this.dragObj.dragArea = this.targetEle;
        }
        this.setMaxHeight();
        if (this.isModal) {
            this.updateIsModal();
        }
        if (this.enableResize) {
            this.setResize();
        }
    };
    Dialog.prototype.updateIsModal = function () {
        this.element.setAttribute('aria-modal', this.isModal ? 'true' : 'false');
        if (this.isModal) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.dlgOverlay)) {
                this.setIsModal();
                this.element.style.top = '0px';
                this.element.style.left = '0px';
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.targetEle)) {
                    this.targetEle.appendChild(this.dlgContainer);
                }
            }
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], MODAL_DLG);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([document.body], [DLG_TARGET, SCROLL_DISABLED]);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.dlgOverlay);
            while (this.dlgContainer.firstChild) {
                this.dlgContainer.parentElement.insertBefore(this.dlgContainer.firstChild, this.dlgContainer);
            }
            this.dlgContainer.parentElement.removeChild(this.dlgContainer);
        }
        if (this.visible) {
            this.show();
        }
        this.positionChange();
        if (this.isModal && this.dlgOverlay) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.dlgOverlay, 'click', this.dlgOverlayClickEventHandler, this);
        }
    };
    Dialog.prototype.setzIndex = function (zIndexElement, setPopupZindex) {
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        this.zIndex = Object(__WEBPACK_IMPORTED_MODULE_2__popup_popup__["d" /* getZindexPartial */])(zIndexElement);
        this.isProtectedOnChange = prevOnChange;
        if (setPopupZindex) {
            this.popupObj.zIndex = this.zIndex;
        }
    };
    Dialog.prototype.windowResizeHandler = function () {
        Object(__WEBPACK_IMPORTED_MODULE_3__common_resize__["d" /* setMaxWidth */])(this.targetEle.clientWidth);
        Object(__WEBPACK_IMPORTED_MODULE_3__common_resize__["c" /* setMaxHeight */])(this.targetEle.clientHeight);
        this.setMaxHeight();
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {void}
     * @private
     */
    Dialog.prototype.getPersistData = function () {
        return this.addOnPersist([]);
    };
    /**
     * To destroy the widget
     *
     * @returns {void}
     */
    Dialog.prototype.destroy = function () {
        if (this.isDestroyed) {
            return;
        }
        var classArray = [RTL, MODAL_DLG, DLG_RESIZABLE, DLG_RESTRICT_LEFT_VALUE, FULLSCREEN, DEVICE];
        var attrs = ['role', 'aria-modal', 'aria-labelledby', 'aria-describedby', 'aria-grabbed', 'tabindex', 'style'];
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.targetEle], [DLG_TARGET, SCROLL_DISABLED]);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element) && this.element.classList.contains(FULLSCREEN)) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([document.body], [DLG_TARGET, SCROLL_DISABLED]);
        }
        if (this.isModal) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([(!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.targetEle) ? this.targetEle : document.body)], SCROLL_DISABLED);
        }
        this.unWireEvents();
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.btnObj)) {
            for (var i = 0; i < this.btnObj.length; i++) {
                this.btnObj[i].destroy();
            }
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.dragObj)) {
            this.dragObj.destroy();
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.popupObj.element) && this.popupObj.element.classList.contains(POPUP_ROOT)) {
            this.popupObj.destroy();
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], classArray);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.cssClass) && this.cssClass !== '') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], this.cssClass.split(' '));
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.refElement) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.refElement.parentElement)) {
            this.refElement.parentElement.insertBefore((this.isModal ? this.dlgContainer : this.element), this.refElement);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.refElement);
            this.refElement = undefined;
        }
        if (this.isModal && !this.isBlazorServerRender()) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.dlgOverlay);
            this.dlgContainer.parentNode.insertBefore(this.element, this.dlgContainer);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.dlgContainer);
        }
        if (!this.isBlazorServerRender()) {
            this.element.innerHTML = this.clonedEle.innerHTML;
        }
        if (this.isBlazorServerRender()) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.children)) {
                for (var i = 0; i <= this.element.children.length; i++) {
                    i = i - i;
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.element.children[i]);
                }
            }
        }
        for (var i = 0; i < attrs.length; i++) {
            this.element.removeAttribute(attrs[i]);
        }
        if (!this.isBlazorServerRender()) {
            _super.prototype.destroy.call(this);
        }
        else {
            this.isDestroyed = true;
        }
        // eslint-disable-next-line
        if (this.isReact) {
            this.clearTemplate();
        }
    };
    Dialog.prototype.wireWindowResizeEvent = function () {
        window.addEventListener('resize', this.windowResizeHandler.bind(this));
    };
    Dialog.prototype.unWireWindowResizeEvent = function () {
        window.removeEventListener('resize', this.windowResizeHandler.bind(this));
    };
    /**
     * Binding event to the element while widget creation
     *
     * @returns {void}
     * @hidden
     */
    Dialog.prototype.wireEvents = function () {
        if (this.isBlazorServerRender() && this.showCloseIcon) {
            this.closeIcon = this.element.getElementsByClassName('e-dlg-closeicon-btn')[0];
        }
        if (this.showCloseIcon) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.closeIcon, 'click', this.closeIconClickEventHandler, this);
        }
        if (this.isModal && this.dlgOverlay) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.dlgOverlay, 'click', this.dlgOverlayClickEventHandler, this);
        }
    };
    /**
     * Unbinding event to the element while widget destroy
     *
     * @returns {void}
     * @hidden
     */
    Dialog.prototype.unWireEvents = function () {
        if (this.showCloseIcon) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.closeIcon, 'click', this.closeIconClickEventHandler);
        }
        if (this.isModal) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.dlgOverlay, 'click', this.dlgOverlayClickEventHandler);
        }
        if (this.buttons.length > 0 && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.buttons[0].buttonModel) && this.footerTemplate === '') {
            for (var i = 0; i < this.buttons.length; i++) {
                if (typeof (this.buttons[i].click) === 'function') {
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.ftrTemplateContent.children[i], 'click', this.buttons[i].click);
                }
            }
        }
    };
    /**
     * Refreshes the dialog's position when the user changes its header and footer height/width dynamically.
     *
     * @returns {void}
     */
    Dialog.prototype.refreshPosition = function () {
        this.popupObj.refreshPosition();
    };
    /**
     * Returns the current width and height of the Dialog
     *
     * @returns {DialogDimension}
     * @public
     */
    Dialog.prototype.getDimension = function () {
        var dialogWidth = this.element.offsetWidth;
        var dialogHeight = this.element.offsetHeight;
        return { width: dialogWidth, height: dialogHeight };
    };
    /**
     * Opens the dialog if it is in hidden state.
     * To open the dialog with full screen width, set the parameter to true.
     *
     * @param { boolean } isFullScreen - Enable the fullScreen Dialog.
     * @returns {void}
     */
    Dialog.prototype.show = function (isFullScreen) {
        var _this = this;
        if (!this.element.classList.contains(ROOT)) {
            return;
        }
        if (!this.element.classList.contains(DLG_SHOW) || (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(isFullScreen))) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(isFullScreen)) {
                this.fullScreen(isFullScreen);
            }
            var eventArgs_1 = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["P" /* isBlazor */])() ? {
                cancel: false,
                element: this.element,
                container: this.isModal ? this.dlgContainer : this.element,
                maxHeight: this.element.style.maxHeight
            } : {
                cancel: false,
                element: this.element,
                container: this.isModal ? this.dlgContainer : this.element,
                target: this.target,
                maxHeight: this.element.style.maxHeight
            };
            this.trigger('beforeOpen', eventArgs_1, function (beforeOpenArgs) {
                if (!beforeOpenArgs.cancel) {
                    if (_this.element.style.maxHeight !== eventArgs_1.maxHeight) {
                        _this.allowMaxHeight = false;
                        _this.element.style.maxHeight = eventArgs_1.maxHeight;
                    }
                    _this.storeActiveElement = document.activeElement;
                    _this.element.tabIndex = -1;
                    if (_this.isModal && (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(_this.dlgOverlay))) {
                        _this.dlgOverlay.style.display = 'block';
                        _this.dlgContainer.style.display = 'flex';
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([_this.dlgOverlay], 'e-fade');
                        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(_this.targetEle)) {
                            if (_this.targetEle === document.body) {
                                _this.dlgContainer.style.position = 'fixed';
                            }
                            else {
                                _this.dlgContainer.style.position = 'absolute';
                            }
                            _this.dlgOverlay.style.position = 'absolute';
                            _this.element.style.position = 'relative';
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([_this.targetEle], [DLG_TARGET, SCROLL_DISABLED]);
                        }
                        else {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([document.body], [DLG_TARGET, SCROLL_DISABLED]);
                        }
                    }
                    // eslint-disable-next-line
                    var openAnimation = {
                        name: _this.animationSettings.effect + 'In',
                        duration: _this.animationSettings.duration,
                        delay: _this.animationSettings.delay
                    };
                    var zIndexElement = (_this.isModal) ? _this.element.parentElement : _this.element;
                    if (_this.calculatezIndex) {
                        _this.setzIndex(zIndexElement, true);
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(_this.element, { 'zIndex': _this.zIndex });
                        if (_this.isModal) {
                            _this.setOverlayZindex(_this.zIndex);
                        }
                    }
                    // eslint-disable-next-line
                    _this.animationSettings.effect === 'None' ? _this.popupObj.show() : _this.popupObj.show(openAnimation);
                    _this.dialogOpen = true;
                    var prevOnChange = _this.isProtectedOnChange;
                    _this.isProtectedOnChange = true;
                    _this.visible = true;
                    _this.preventVisibility = true;
                    _this.isProtectedOnChange = prevOnChange;
                }
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.isReact) {
            this.renderReactTemplates();
        }
    };
    /**
     * Closes the dialog if it is in visible state.
     *
     * @param { Event } event - specifies the event
     * @returns {void}
     */
    Dialog.prototype.hide = function (event) {
        var _this = this;
        if (!this.element.classList.contains(ROOT)) {
            return;
        }
        if (this.preventVisibility) {
            var eventArgs = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["P" /* isBlazor */])() ? {
                cancel: false,
                isInteracted: event ? true : false,
                element: this.element,
                container: this.isModal ? this.dlgContainer : this.element,
                event: event
            } : {
                cancel: false,
                isInteracted: event ? true : false,
                element: this.element,
                target: this.target,
                container: this.isModal ? this.dlgContainer : this.element,
                event: event,
                closedBy: this.dlgClosedBy
            };
            this.closeArgs = eventArgs;
            this.trigger('beforeClose', eventArgs, function (beforeCloseArgs) {
                if (!beforeCloseArgs.cancel) {
                    if (_this.isModal) {
                        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(_this.targetEle)) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([_this.targetEle], [DLG_TARGET, SCROLL_DISABLED]);
                        }
                    }
                    if (document.body.classList.contains(DLG_TARGET) &&
                        document.body.classList.contains(SCROLL_DISABLED)) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([document.body], [DLG_TARGET, SCROLL_DISABLED]);
                    }
                    // eslint-disable-next-line
                    var closeAnimation = {
                        name: _this.animationSettings.effect + 'Out',
                        duration: _this.animationSettings.duration,
                        delay: _this.animationSettings.delay
                    };
                    // eslint-disable-next-line
                    _this.animationSettings.effect === 'None' ? _this.popupObj.hide() : _this.popupObj.hide(closeAnimation);
                    _this.dialogOpen = false;
                    var prevOnChange = _this.isProtectedOnChange;
                    _this.isProtectedOnChange = true;
                    _this.visible = false;
                    _this.preventVisibility = false;
                    _this.isProtectedOnChange = prevOnChange;
                }
                _this.dlgClosedBy = DLG_USER_ACTION_CLOSED;
            });
        }
    };
    // eslint-disable-next-line
    /**
     * Specifies to view the Full screen Dialog.
     *
     * @returns {void}
     * @private
     */
    Dialog.prototype.fullScreen = function (args) {
        /* eslint-disable */
        var top = this.element.offsetTop;
        var left = this.element.offsetLeft;
        /* eslint-enable */
        if (args) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], FULLSCREEN);
            var display = this.element.style.display;
            this.element.style.display = 'none';
            this.element.style.maxHeight = (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.target)) ?
                (this.targetEle.offsetHeight) + 'px' : (window.innerHeight) + 'px';
            this.element.style.display = display;
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([document.body], [DLG_TARGET, SCROLL_DISABLED]);
            if (this.allowDragging && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.dragObj)) {
                this.dragObj.destroy();
            }
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], FULLSCREEN);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([document.body], [DLG_TARGET, SCROLL_DISABLED]);
            if (this.allowDragging && (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.headerContent))) {
                this.setAllowDragging();
            }
        }
        return args;
    };
    /**
     * Returns the dialog button instances.
     * Based on that, you can dynamically change the button states.
     *
     * @param { number } index - Index of the button.
     * @returns {Button} - returns the button element
     */
    Dialog.prototype.getButtons = function (index) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(index)) {
            return this.btnObj[index];
        }
        return this.btnObj;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Dialog.prototype, "content", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Dialog.prototype, "enableHtmlSanitizer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Dialog.prototype, "showCloseIcon", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Dialog.prototype, "isModal", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Dialog.prototype, "header", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Dialog.prototype, "visible", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Dialog.prototype, "enableResize", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(['South-East'])
    ], Dialog.prototype, "resizeHandles", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('auto')
    ], Dialog.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Dialog.prototype, "minHeight", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('100%')
    ], Dialog.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Dialog.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(1000)
    ], Dialog.prototype, "zIndex", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], Dialog.prototype, "target", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Dialog.prototype, "footerTemplate", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Dialog.prototype, "allowDragging", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["f" /* Collection */])([{}], ButtonProps)
    ], Dialog.prototype, "buttons", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Dialog.prototype, "closeOnEscape", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({}, AnimationSettings)
    ], Dialog.prototype, "animationSettings", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({ X: 'center', Y: 'center' }, __WEBPACK_IMPORTED_MODULE_2__popup_popup__["b" /* PositionData */])
    ], Dialog.prototype, "position", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Dialog.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Dialog.prototype, "open", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Dialog.prototype, "beforeSanitizeHtml", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Dialog.prototype, "beforeOpen", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Dialog.prototype, "close", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Dialog.prototype, "beforeClose", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Dialog.prototype, "dragStart", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Dialog.prototype, "dragStop", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Dialog.prototype, "drag", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Dialog.prototype, "overlayClick", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Dialog.prototype, "resizeStart", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Dialog.prototype, "resizing", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Dialog.prototype, "resizeStop", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Dialog.prototype, "destroyed", void 0);
    Dialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], Dialog);
    return Dialog;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));

/**
 * Base for creating Alert and Confirmation Dialog through util method.
 */
// eslint-disable-next-line
var DialogUtility;
(function (DialogUtility) {
    /**
     * An alert dialog box is used to display warning like messages to the users.
     * ```
     * Eg : DialogUtility.alert('Alert message');
     *
     * ```
     */
    /* istanbul ignore next */
    /**
     *
     * @param {AlertDialogArgs} args - specifies the string
     * @returns {Dialog} - returns the dialog element.
     */
    function alert(args) {
        // eslint-disable-next-line
        var dialogComponent;
        var dialogElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */])('div', { 'className': DLG_UTIL_ALERT });
        document.body.appendChild(dialogElement);
        var alertDialogObj;
        var okButtonModel = [{
                buttonModel: { isPrimary: true, content: 'OK' },
                click: function () {
                    this.hide();
                }
            }];
        if (typeof (args) === 'string') {
            alertDialogObj = createDialog({ content: args,
                position: { X: 'center', Y: 'top' },
                isModal: true, header: DLG_UTIL_DEFAULT_TITLE,
                buttons: okButtonModel }, dialogElement);
        }
        else {
            alertDialogObj = createDialog(alertOptions(args), dialogElement);
        }
        alertDialogObj.close = function () {
            if (args && args.close) {
                args.close.apply(alertDialogObj);
            }
            alertDialogObj.destroy();
            if (alertDialogObj.element.classList.contains('e-dlg-modal')) {
                alertDialogObj.element.parentElement.remove();
                alertDialogObj.target.classList.remove(DLG_UTIL_ROOT);
            }
            else {
                alertDialogObj.element.remove();
            }
        };
        return alertDialogObj;
    }
    DialogUtility.alert = alert;
    /**
     * A confirm dialog displays a specified message along with ‘OK’ and ‘Cancel’ button.
     * ```
     * Eg : DialogUtility.confirm('Confirm dialog message');
     *
     * ```
     */
    /* istanbul ignore next */
    /**
     *
     * @param {ConfirmDialogArgs} args - specifies the args
     * @returns {Dialog} - returns te element
     */
    function confirm(args) {
        // eslint-disable-next-line
        var dialogComponent;
        var dialogElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */])('div', { 'className': DLG_UTIL_CONFIRM });
        document.body.appendChild(dialogElement);
        var confirmDialogObj;
        var okCancelButtonModel = [{
                buttonModel: { isPrimary: true, content: 'OK' },
                click: function () {
                    this.hide();
                }
            }, {
                buttonModel: { content: 'Cancel' },
                click: function () {
                    this.hide();
                }
            }];
        if (typeof (args) === 'string') {
            confirmDialogObj = createDialog({ position: { X: 'center', Y: 'top' }, content: args, isModal: true,
                header: DLG_UTIL_DEFAULT_TITLE, buttons: okCancelButtonModel
            }, dialogElement);
        }
        else {
            confirmDialogObj = createDialog(confirmOptions(args), dialogElement);
        }
        confirmDialogObj.close = function () {
            if (args && args.close) {
                args.close.apply(confirmDialogObj);
            }
            confirmDialogObj.destroy();
            if (confirmDialogObj.element.classList.contains('e-dlg-modal')) {
                confirmDialogObj.element.parentElement.remove();
                confirmDialogObj.target.classList.remove(DLG_UTIL_ROOT);
            }
            else {
                confirmDialogObj.element.remove();
            }
        };
        return confirmDialogObj;
    }
    DialogUtility.confirm = confirm;
    // eslint-disable-next-line
    function createDialog(options, element) {
        var dialogObject = new Dialog(options);
        dialogObject.appendTo(element);
        return dialogObject;
    }
    // eslint-disable-next-line
    function alertOptions(option) {
        var options = {};
        options.buttons = [];
        options = formOptions(options, option);
        options = setAlertButtonModel(options, option);
        return options;
    }
    // eslint-disable-next-line
    function confirmOptions(option) {
        var options = {};
        options.buttons = [];
        options = formOptions(options, option);
        options = setConfirmButtonModel(options, option);
        return options;
    }
    // eslint-disable-next-line
    function formOptions(options, option) {
        options.header = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.title) ? option.title : DLG_UTIL_DEFAULT_TITLE;
        options.content = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.content) ? option.content : '';
        options.isModal = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.isModal) ? option.isModal : true;
        options.showCloseIcon = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.showCloseIcon) ? option.showCloseIcon : false;
        options.allowDragging = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.isDraggable) ? option.isDraggable : false;
        options.closeOnEscape = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.closeOnEscape) ? option.closeOnEscape : false;
        options.position = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.position) ? option.position : { X: 'center', Y: 'top' };
        options.animationSettings = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.animationSettings) ? option.animationSettings :
            { effect: 'Fade', duration: 400, delay: 0 };
        options.cssClass = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.cssClass) ? option.cssClass : '';
        options.zIndex = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.zIndex) ? option.zIndex : 1000;
        options.open = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.open) ? option.open : null;
        return options;
    }
    // eslint-disable-next-line
    function setAlertButtonModel(options, option) {
        var alertButtonModel = [{
                buttonModel: { isPrimary: true, content: 'OK' },
                click: function () {
                    this.hide();
                }
            }];
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.okButton)) {
            options.buttons[0] = formButtonModel(options.buttons[0], option.okButton, alertButtonModel[0]);
        }
        else {
            options.buttons = alertButtonModel;
        }
        return options;
    }
    // eslint-disable-next-line
    function setConfirmButtonModel(options, option) {
        var okButtonModel = {
            buttonModel: { isPrimary: true, content: 'OK' },
            click: function () {
                this.hide();
            }
        };
        var cancelButtonModel = {
            buttonModel: { content: 'Cancel' },
            click: function () {
                this.hide();
            }
        };
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.okButton)) {
            options.buttons[0] = formButtonModel(options.buttons[0], option.okButton, okButtonModel);
        }
        else {
            options.buttons[0] = okButtonModel;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.cancelButton)) {
            options.buttons[1] = formButtonModel(options.buttons[1], option.cancelButton, cancelButtonModel);
        }
        else {
            options.buttons[1] = cancelButtonModel;
        }
        return options;
    }
    // eslint-disable-next-line
    function formButtonModel(buttonModel, option, buttonPropModel) {
        var buttonProps = buttonPropModel;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.text)) {
            buttonProps.buttonModel.content = option.text;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.icon)) {
            buttonProps.buttonModel.iconCss = option.icon;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.cssClass)) {
            buttonProps.buttonModel.cssClass = option.cssClass;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(option.click)) {
            buttonProps.click = option.click;
        }
        return buttonProps;
    }
})(DialogUtility || (DialogUtility = {}));


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createResize;
/* harmony export (immutable) */ __webpack_exports__["e"] = setMinHeight;
/* harmony export (immutable) */ __webpack_exports__["d"] = setMaxWidth;
/* harmony export (immutable) */ __webpack_exports__["c"] = setMaxHeight;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeResize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/**
 * Resize library
 */

/* eslint-disable */
var elementClass = ['north-west', 'north', 'north-east', 'west', 'east', 'south-west', 'south', 'south-east'];
var RESIZE_HANDLER = 'e-resize-handle';
var FOCUSED_HANDLER = 'e-focused-handle';
var DIALOG_RESIZABLE = 'e-dlg-resizable';
var RESTRICT_LEFT = ['e-restrict-left'];
var RESIZE_WITHIN_VIEWPORT = 'e-resize-viewport';
var dialogBorderResize = ['north', 'west', 'east', 'south'];
var targetElement;
var selectedHandler;
var originalWidth = 0;
var originalHeight = 0;
var originalX = 0;
var originalY = 0;
var originalMouseX = 0;
var originalMouseY = 0;
var minHeight;
var maxHeight;
var minWidth;
var maxWidth;
var containerElement;
/* eslint-disable */
var resizeStart = null;
var resize = null;
var resizeEnd = null;
/* eslint-enable */
var resizeWestWidth;
var setLeft = true;
var previousWidth = 0;
var setWidth = true;
// eslint-disable-next-line
var proxy;
/**
 *
 * @param {ResizeArgs} args - specifies the resize args
 * @returns {void}
 */
function createResize(args) {
    resizeStart = args.resizeBegin;
    resize = args.resizing;
    resizeEnd = args.resizeComplete;
    targetElement = getDOMElement(args.element);
    containerElement = getDOMElement(args.boundary);
    var directions = args.direction.split(' ');
    for (var i = 0; i < directions.length; i++) {
        if (dialogBorderResize.indexOf(directions[i]) >= 0 && directions[i]) {
            setBorderResizeElm(directions[i]);
        }
        else if (directions[i].trim() !== '') {
            var resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */])('div', { className: 'e-icons ' + RESIZE_HANDLER + ' ' + 'e-' + directions[i] });
            targetElement.appendChild(resizeHandler);
        }
    }
    minHeight = args.minHeight;
    minWidth = args.minWidth;
    maxWidth = args.maxWidth;
    maxHeight = args.maxHeight;
    if (args.proxy && args.proxy.element && args.proxy.element.classList.contains('e-dialog')) {
        wireEvents(args.proxy);
    }
    else {
        wireEvents();
    }
}
/**
 *
 * @param {string} direction - specifies the string
 * @returns {void}
 */
function setBorderResizeElm(direction) {
    calculateValues();
    var borderBottom = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */])('span', {
        attrs: {
            'unselectable': 'on', 'contenteditable': 'false'
        }
    });
    borderBottom.setAttribute('class', 'e-dialog-border-resize e-' + direction);
    if (direction === 'south') {
        borderBottom.style.height = '2px';
        borderBottom.style.width = '100%';
        borderBottom.style.bottom = '0px';
        borderBottom.style.left = '0px';
    }
    if (direction === 'north') {
        borderBottom.style.height = '2px';
        borderBottom.style.width = '100%';
        borderBottom.style.top = '0px';
        borderBottom.style.left = '0px';
    }
    if (direction === 'east') {
        borderBottom.style.height = '100%';
        borderBottom.style.width = '2px';
        borderBottom.style.right = '0px';
        borderBottom.style.top = '0px';
    }
    if (direction === 'west') {
        borderBottom.style.height = '100%';
        borderBottom.style.width = '2px';
        borderBottom.style.left = '0px';
        borderBottom.style.top = '0px';
    }
    targetElement.appendChild(borderBottom);
}
/**
 *
 * @param {string} element - specifies the element
 * @returns {HTMLElement} - returns the element
 */
function getDOMElement(element) {
    var domElement;
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(element)) {
        if (typeof (element) === 'string') {
            domElement = document.querySelector(element);
        }
        else {
            domElement = element;
        }
    }
    return domElement;
}
// eslint-disable-next-line
function wireEvents(args) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args)) {
        args = this;
    }
    var resizers = targetElement.querySelectorAll('.' + RESIZE_HANDLER);
    for (var i = 0; i < resizers.length; i++) {
        selectedHandler = resizers[i];
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(selectedHandler, 'mousedown', onMouseDown, args);
        var eventName = (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name === 'msie') ? 'pointerdown' : 'touchstart';
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(selectedHandler, eventName, onTouchStart, args);
    }
    var borderResizers = targetElement.querySelectorAll('.e-dialog-border-resize');
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(borderResizers)) {
        for (var i = 0; i < borderResizers.length; i++) {
            selectedHandler = borderResizers[i];
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(selectedHandler, 'mousedown', onMouseDown, args);
            var eventName = (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name === 'msie') ? 'pointerdown' : 'touchstart';
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(selectedHandler, eventName, onTouchStart, args);
        }
    }
}
/* istanbul ignore next */
/**
 *
 * @param {string} e - specifies the string
 * @returns {string} - returns the string
 */
function getEventType(e) {
    return (e.indexOf('mouse') > -1) ? 'mouse' : 'touch';
}
/* istanbul ignore next */
/**
 *
 * @param {MouseEvent} e - specifies the mouse event
 * @returns {void}
 */
function onMouseDown(e) {
    e.preventDefault();
    targetElement = e.target.parentElement;
    calculateValues();
    originalMouseX = e.pageX;
    originalMouseY = e.pageY;
    e.target.classList.add(FOCUSED_HANDLER);
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(resizeStart)) {
        proxy = this;
        if (resizeStart(e, proxy) === true) {
            return;
        }
    }
    if (this.targetEle && targetElement && targetElement.querySelector('.' + DIALOG_RESIZABLE)) {
        containerElement = this.target === 'body' || 'document.body' || document.body ? null : this.targetEle;
        maxWidth = this.targetEle.clientWidth;
        maxHeight = this.targetEle.clientHeight;
    }
    var target = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement)) ? document : containerElement;
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(target, 'mousemove', onMouseMove, this);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'mouseup', onMouseUp, this);
    for (var i = 0; i < RESTRICT_LEFT.length; i++) {
        if (targetElement.classList.contains(RESTRICT_LEFT[i])) {
            setLeft = false;
        }
        else {
            setLeft = true;
        }
    }
}
/* istanbul ignore next */
/**
 *
 * @param {MouseEvent} e - specifies the event
 * @returns {void}
 */
function onMouseUp(e) {
    var touchMoveEvent = (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name === 'msie') ? 'pointermove' : 'touchmove';
    var touchEndEvent = (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name === 'msie') ? 'pointerup' : 'touchend';
    var target = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement)) ? document : containerElement;
    var eventName = (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name === 'msie') ? 'pointerdown' : 'touchstart';
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(target, 'mousemove', onMouseMove);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(target, touchMoveEvent, onMouseMove);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(target, eventName, onMouseMove);
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(document.body.querySelector('.' + FOCUSED_HANDLER))) {
        document.body.querySelector('.' + FOCUSED_HANDLER).classList.remove(FOCUSED_HANDLER);
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(resizeEnd)) {
        proxy = this;
        resizeEnd(e, proxy);
    }
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'mouseup', onMouseUp);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, touchEndEvent, onMouseUp);
}
/* istanbul ignore next */
/**
 * @returns {void}
 */
function calculateValues() {
    originalWidth = parseFloat(getComputedStyle(targetElement, null).getPropertyValue('width').replace('px', ''));
    originalHeight = parseFloat(getComputedStyle(targetElement, null).getPropertyValue('height').replace('px', ''));
    originalX = targetElement.getBoundingClientRect().left;
    originalY = targetElement.getBoundingClientRect().top;
}
/* istanbul ignore next */
/**
 *
 * @param {MouseEvent} e - specifies the event
 * @returns {void}
 */
function onTouchStart(e) {
    targetElement = e.target.parentElement;
    calculateValues();
    var coordinates = e.touches ? e.changedTouches[0] : e;
    originalMouseX = coordinates.pageX;
    originalMouseY = coordinates.pageY;
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(resizeStart)) {
        proxy = this;
        if (resizeStart(e, proxy) === true) {
            return;
        }
    }
    var touchMoveEvent = (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name === 'msie') ? 'pointermove' : 'touchmove';
    var touchEndEvent = (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name === 'msie') ? 'pointerup' : 'touchend';
    var target = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement)) ? document : containerElement;
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(target, touchMoveEvent, onMouseMove, this);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, touchEndEvent, onMouseUp);
}
/* istanbul ignore next */
/**
 *
 * @param {MouseEvent} e - specifies the event
 * @returns {void}
 */
function onMouseMove(e) {
    if (e.target.classList.contains(RESIZE_HANDLER) && e.target.classList.contains(FOCUSED_HANDLER)) {
        selectedHandler = e.target;
    }
    else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(document.body.querySelector('.' + FOCUSED_HANDLER))) {
        selectedHandler = document.body.querySelector('.' + FOCUSED_HANDLER);
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(selectedHandler)) {
        var resizeTowards = '';
        for (var i = 0; i < elementClass.length; i++) {
            if (selectedHandler.classList.contains('e-' + elementClass[i])) {
                resizeTowards = elementClass[i];
            }
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(resize)) {
            proxy = this;
            resize(e, proxy);
        }
        switch (resizeTowards) {
            case 'south':
                resizeSouth(e);
                break;
            case 'north':
                resizeNorth(e);
                break;
            case 'west':
                resizeWest(e);
                break;
            case 'east':
                resizeEast(e);
                break;
            case 'south-east':
                resizeSouth(e);
                resizeEast(e);
                break;
            case 'south-west':
                resizeSouth(e);
                resizeWest(e);
                break;
            case 'north-east':
                resizeNorth(e);
                resizeEast(e);
                break;
            case 'north-west':
                resizeNorth(e);
                resizeWest(e);
                break;
            default: break;
        }
    }
}
/* istanbul ignore next */
/**
 *
 * @param {HTMLElement} element - specifies the eleemnt
 * @returns {ClientRect} - returns the client
 */
function getClientRectValues(element) {
    return element.getBoundingClientRect();
}
/* istanbul ignore next */
// eslint-disable-next-line
function resizeSouth(e) {
    var documentHeight = document.documentElement.clientHeight;
    var calculateValue = false;
    var coordinates = e.touches ? e.changedTouches[0] : e;
    var currentpageY = coordinates.pageY;
    var targetRectValues = getClientRectValues(targetElement);
    var containerRectValues;
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement)) {
        containerRectValues = getClientRectValues(containerElement);
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement)) {
        calculateValue = true;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement) && ((documentHeight - currentpageY) >= 0 || (targetRectValues.top < 0))) {
        calculateValue = true;
    }
    var calculatedHeight = originalHeight + (currentpageY - originalMouseY);
    calculatedHeight = (calculatedHeight > minHeight) ? calculatedHeight : minHeight;
    var containerTop = 0;
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement)) {
        containerTop = containerRectValues.top;
    }
    var borderValue = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement) ? 0 : containerElement.offsetHeight - containerElement.clientHeight;
    var topWithoutborder = (targetRectValues.top - containerTop) - (borderValue / 2);
    topWithoutborder = (topWithoutborder < 0) ? 0 : topWithoutborder;
    if (targetRectValues.top > 0 && (topWithoutborder + calculatedHeight) > maxHeight) {
        calculateValue = false;
        if (targetElement.classList.contains(RESIZE_WITHIN_VIEWPORT)) {
            return;
        }
        targetElement.style.height = (maxHeight - parseInt(topWithoutborder.toString(), 10)) + 'px';
        return;
    }
    var targetTop = 0;
    if (calculateValue) {
        if (targetRectValues.top < 0 && (documentHeight + (targetRectValues.height + targetRectValues.top) > 0)) {
            targetTop = targetRectValues.top;
            if ((calculatedHeight + targetTop) <= 30) {
                calculatedHeight = (targetRectValues.height - (targetRectValues.height + targetRectValues.top)) + 30;
            }
        }
        if (((calculatedHeight + targetRectValues.top) >= maxHeight)) {
            targetElement.style.height = targetRectValues.height +
                (documentHeight - (targetRectValues.height + targetRectValues.top)) + 'px';
        }
        var calculatedTop = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement)) ? targetTop : topWithoutborder;
        if (calculatedHeight >= minHeight && ((calculatedHeight + calculatedTop) <= maxHeight)) {
            targetElement.style.height = calculatedHeight + 'px';
        }
    }
}
/* istanbul ignore next */
// eslint-disable-next-line
function resizeNorth(e) {
    var calculateValue = false;
    var boundaryRectValues;
    var pageY = (getEventType(e.type) === 'mouse') ? e.pageY : e.touches[0].pageY;
    var targetRectValues = getClientRectValues(targetElement);
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement)) {
        boundaryRectValues = getClientRectValues(containerElement);
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement) && (targetRectValues.top - boundaryRectValues.top) > 0) {
        calculateValue = true;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement) && pageY > 0) {
        calculateValue = true;
    }
    var currentHeight = originalHeight - (pageY - originalMouseY);
    if (calculateValue) {
        if (currentHeight >= minHeight && currentHeight <= maxHeight) {
            var containerTop = 0;
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement)) {
                containerTop = boundaryRectValues.top;
            }
            var top_1 = (originalY - containerTop) + (pageY - originalMouseY);
            top_1 = top_1 > 0 ? top_1 : 1;
            targetElement.style.height = currentHeight + 'px';
            targetElement.style.top = top_1 + 'px';
        }
    }
}
/* istanbul ignore next */
// eslint-disable-next-line
function resizeWest(e) {
    var documentWidth = document.documentElement.clientWidth;
    var calculateValue = false;
    var rectValues;
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement)) {
        rectValues = getClientRectValues(containerElement);
    }
    var pageX = (getEventType(e.type) === 'mouse') ? e.pageX : e.touches[0].pageX;
    var targetRectValues = getClientRectValues(targetElement);
    var borderValue = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement) ? 0 : containerElement.offsetWidth - containerElement.clientWidth;
    /* eslint-disable */
    var left = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement) ? 0 : rectValues.left;
    var containerWidth = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement) ? 0 : rectValues.width;
    /* eslint-enable */
    if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(resizeWestWidth)) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement)) {
            resizeWestWidth = (((targetRectValues.left - left) - borderValue / 2)) + targetRectValues.width;
            resizeWestWidth = resizeWestWidth + (containerWidth - borderValue - resizeWestWidth);
        }
        else {
            resizeWestWidth = documentWidth;
        }
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement) &&
        (Math.floor((targetRectValues.left - rectValues.left) + targetRectValues.width +
            (rectValues.right - targetRectValues.right)) - borderValue) <= maxWidth) {
        calculateValue = true;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement) && pageX >= 0) {
        calculateValue = true;
    }
    var calculatedWidth = originalWidth - (pageX - originalMouseX);
    if (setLeft) {
        calculatedWidth = (calculatedWidth > resizeWestWidth) ? resizeWestWidth : calculatedWidth;
    }
    if (calculateValue) {
        if (calculatedWidth >= minWidth && calculatedWidth <= maxWidth) {
            var containerLeft = 0;
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement)) {
                containerLeft = rectValues.left;
            }
            var left_1 = (originalX - containerLeft) + (pageX - originalMouseX);
            left_1 = (left_1 > 0) ? left_1 : 1;
            if (calculatedWidth !== previousWidth && setWidth) {
                targetElement.style.width = calculatedWidth + 'px';
            }
            if (setLeft) {
                targetElement.style.left = left_1 + 'px';
                if (left_1 === 1) {
                    setWidth = false;
                }
                else {
                    setWidth = true;
                }
            }
        }
    }
    previousWidth = calculatedWidth;
}
/* istanbul ignore next */
// eslint-disable-next-line
function resizeEast(e) {
    var documentWidth = document.documentElement.clientWidth;
    var calculateValue = false;
    var containerRectValues;
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement)) {
        containerRectValues = getClientRectValues(containerElement);
    }
    var coordinates = e.touches ? e.changedTouches[0] : e;
    var pageX = coordinates.pageX;
    var targetRectValues = getClientRectValues(targetElement);
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement) && (((targetRectValues.left - containerRectValues.left) + targetRectValues.width) <= maxWidth
        || (targetRectValues.right - containerRectValues.left) >= targetRectValues.width)) {
        calculateValue = true;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement) && (documentWidth - pageX) > 0) {
        calculateValue = true;
    }
    var calculatedWidth = originalWidth + (pageX - originalMouseX);
    var containerLeft = 0;
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(containerElement)) {
        containerLeft = containerRectValues.left;
    }
    if (((targetRectValues.left - containerLeft) + calculatedWidth) > maxWidth) {
        calculateValue = false;
        if (targetElement.classList.contains(RESIZE_WITHIN_VIEWPORT)) {
            return;
        }
        targetElement.style.width = maxWidth - (targetRectValues.left - containerLeft) + 'px';
    }
    if (calculateValue) {
        if (calculatedWidth >= minWidth && calculatedWidth <= maxWidth) {
            targetElement.style.width = calculatedWidth + 'px';
        }
    }
}
/* istanbul ignore next */
/**
 *
 * @param {number} minimumHeight - specifies the number
 * @returns {void}
 */
function setMinHeight(minimumHeight) {
    minHeight = minimumHeight;
}
/**
 *
 * @param {number} value - specifies the number value
 * @returns {void}
 */
function setMaxWidth(value) {
    maxWidth = value;
}
/**
 *
 * @param {number} value - specifies the number value
 * @returns {void}
 */
function setMaxHeight(value) {
    maxHeight = value;
}
/**
 * @returns {void}
 */
function removeResize() {
    var handlers = targetElement.querySelectorAll('.' + RESIZE_HANDLER);
    for (var i = 0; i < handlers.length; i++) {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(handlers[i]);
    }
    var borderResizers = targetElement.querySelectorAll('.e-dialog-border-resize');
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(borderResizers)) {
        for (var i = 0; i < borderResizers.length; i++) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(borderResizers[i]);
        }
    }
}


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tooltip__ = __webpack_require__(241);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__tooltip__["a"]; });
/**
 * Tooltip modules
 */



/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Animation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popup_popup__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_position__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_collision__ = __webpack_require__(44);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var TOUCHEND_HIDE_DELAY = 1500;
var TAPHOLD_THRESHOLD = 500;
var SHOW_POINTER_TIP_GAP = 0;
var HIDE_POINTER_TIP_GAP = 8;
var MOUSE_TRAIL_GAP = 2;
var POINTER_ADJUST = 2;
var ROOT = 'e-tooltip';
var RTL = 'e-rtl';
var DEVICE = 'e-bigger';
var ICON = 'e-icons';
var CLOSE = 'e-tooltip-close';
var TOOLTIP_WRAP = 'e-tooltip-wrap';
var CONTENT = 'e-tip-content';
var ARROW_TIP = 'e-arrow-tip';
var ARROW_TIP_OUTER = 'e-arrow-tip-outer';
var ARROW_TIP_INNER = 'e-arrow-tip-inner';
var TIP_BOTTOM = 'e-tip-bottom';
var TIP_TOP = 'e-tip-top';
var TIP_LEFT = 'e-tip-left';
var TIP_RIGHT = 'e-tip-right';
var POPUP_ROOT = 'e-popup';
var POPUP_OPEN = 'e-popup-open';
var POPUP_CLOSE = 'e-popup-close';
var POPUP_LIB = 'e-lib';
var HIDE_POPUP = 'e-hidden';
var POPUP_CONTAINER = 'e-tooltip-popup-container';
var Animation = /** @class */ (function (_super) {
    __extends(Animation, _super);
    function Animation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])({ effect: 'FadeIn', duration: 150, delay: 0 })
    ], Animation.prototype, "open", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])({ effect: 'FadeOut', duration: 150, delay: 0 })
    ], Animation.prototype, "close", void 0);
    return Animation;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * Represents the Tooltip component that displays a piece of information about the target element on mouse hover.
 * ```html
 * <div id="tooltip">Show Tooltip</div>
 * ```
 * ```typescript
 * <script>
 *   var tooltipObj = new Tooltip({ content: 'Tooltip text' });
 *   tooltipObj.appendTo("#tooltip");
 * </script>
 * ```
 */
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    /* eslint-enable */
    /**
     * Constructor for creating the Tooltip Component
     *
     * @param {TooltipModel} options - specifies the options for the constructor
     * @param {string| HTMLElement} element - specifies the element for the constructor
     *
     */
    function Tooltip(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.mouseMoveEvent = null;
        _this.mouseMoveTarget = null;
        _this.containerElement = null;
        _this.isBodyContainer = true;
        return _this;
    }
    Tooltip.prototype.initialize = function () {
        this.formatPosition();
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], ROOT);
    };
    Tooltip.prototype.formatPosition = function () {
        var _a, _b;
        if (this.position.indexOf('Top') === 0 || this.position.indexOf('Bottom') === 0) {
            _a = this.position.split(/(?=[A-Z])/), this.tooltipPositionY = _a[0], this.tooltipPositionX = _a[1];
        }
        else {
            _b = this.position.split(/(?=[A-Z])/), this.tooltipPositionX = _b[0], this.tooltipPositionY = _b[1];
        }
    };
    Tooltip.prototype.renderArrow = function () {
        this.setTipClass(this.position);
        var tip = this.createElement('div', { className: ARROW_TIP + ' ' + this.tipClass });
        tip.appendChild(this.createElement('div', { className: ARROW_TIP_OUTER + ' ' + this.tipClass }));
        tip.appendChild(this.createElement('div', { className: ARROW_TIP_INNER + ' ' + this.tipClass }));
        this.tooltipEle.appendChild(tip);
    };
    Tooltip.prototype.setTipClass = function (position) {
        if (position.indexOf('Right') === 0) {
            this.tipClass = TIP_LEFT;
        }
        else if (position.indexOf('Bottom') === 0) {
            this.tipClass = TIP_TOP;
        }
        else if (position.indexOf('Left') === 0) {
            this.tipClass = TIP_RIGHT;
        }
        else {
            this.tipClass = TIP_BOTTOM;
        }
    };
    Tooltip.prototype.renderPopup = function (target) {
        var elePos = this.mouseTrail ? { top: 0, left: 0 } : this.getTooltipPosition(target);
        this.tooltipEle.classList.remove(POPUP_LIB);
        this.popupObj = new __WEBPACK_IMPORTED_MODULE_1__popup_popup__["a" /* Popup */](this.tooltipEle, {
            height: this.height,
            width: this.width,
            position: { X: elePos.left, Y: elePos.top },
            enableRtl: this.enableRtl,
            open: this.openPopupHandler.bind(this),
            close: this.closePopupHandler.bind(this)
        });
    };
    Tooltip.prototype.getTooltipPosition = function (target) {
        this.tooltipEle.style.display = 'block';
        var pos = Object(__WEBPACK_IMPORTED_MODULE_2__common_position__["a" /* calculatePosition */])(target, this.tooltipPositionX, this.tooltipPositionY, !this.isBodyContainer, this.isBodyContainer ? null : this.containerElement.getBoundingClientRect());
        var offsetPos = this.calculateTooltipOffset(this.position);
        var collisionPosition = this.calculateElementPosition(pos, offsetPos);
        var collisionLeft = collisionPosition[0];
        var collisionTop = collisionPosition[1];
        var elePos = this.collisionFlipFit(target, collisionLeft, collisionTop);
        this.tooltipEle.style.display = '';
        return elePos;
    };
    Tooltip.prototype.windowResize = function () {
        this.reposition(this.findTarget());
    };
    Tooltip.prototype.reposition = function (target) {
        if (this.popupObj && target) {
            var elePos = this.getTooltipPosition(target);
            this.popupObj.position = { X: elePos.left, Y: elePos.top };
            this.popupObj.dataBind();
        }
    };
    Tooltip.prototype.openPopupHandler = function () {
        if (!this.mouseTrail && this.needTemplateReposition()) {
            this.reposition(this.findTarget());
        }
        this.trigger('afterOpen', this.tooltipEventArgs);
    };
    Tooltip.prototype.closePopupHandler = function () {
        this.clearTemplate(['content']);
        this.clear();
        this.trigger('afterClose', this.tooltipEventArgs);
    };
    Tooltip.prototype.calculateTooltipOffset = function (position) {
        var pos = { top: 0, left: 0 };
        var tooltipEleWidth = this.tooltipEle.offsetWidth;
        var tooltipEleHeight = this.tooltipEle.offsetHeight;
        var arrowEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + ARROW_TIP, this.tooltipEle);
        var tipWidth = arrowEle ? arrowEle.offsetWidth : 0;
        var tipHeight = arrowEle ? arrowEle.offsetHeight : 0;
        var tipAdjust = (this.showTipPointer ? SHOW_POINTER_TIP_GAP : HIDE_POINTER_TIP_GAP);
        var tipHeightAdjust = (tipHeight / 2) + POINTER_ADJUST + (this.tooltipEle.offsetHeight - this.tooltipEle.clientHeight);
        var tipWidthAdjust = (tipWidth / 2) + POINTER_ADJUST + (this.tooltipEle.offsetWidth - this.tooltipEle.clientWidth);
        if (this.mouseTrail) {
            tipAdjust += MOUSE_TRAIL_GAP;
        }
        switch (position) {
            case 'RightTop':
                pos.left += tipWidth + tipAdjust;
                pos.top -= tooltipEleHeight - tipHeightAdjust;
                break;
            case 'RightCenter':
                pos.left += tipWidth + tipAdjust;
                pos.top -= (tooltipEleHeight / 2);
                break;
            case 'RightBottom':
                pos.left += tipWidth + tipAdjust;
                pos.top -= (tipHeightAdjust);
                break;
            case 'BottomRight':
                pos.top += (tipHeight + tipAdjust);
                pos.left -= (tipWidthAdjust);
                break;
            case 'BottomCenter':
                pos.top += (tipHeight + tipAdjust);
                pos.left -= (tooltipEleWidth / 2);
                break;
            case 'BottomLeft':
                pos.top += (tipHeight + tipAdjust);
                pos.left -= (tooltipEleWidth - tipWidthAdjust);
                break;
            case 'LeftBottom':
                pos.left -= (tipWidth + tooltipEleWidth + tipAdjust);
                pos.top -= (tipHeightAdjust);
                break;
            case 'LeftCenter':
                pos.left -= (tipWidth + tooltipEleWidth + tipAdjust);
                pos.top -= (tooltipEleHeight / 2);
                break;
            case 'LeftTop':
                pos.left -= (tipWidth + tooltipEleWidth + tipAdjust);
                pos.top -= (tooltipEleHeight - tipHeightAdjust);
                break;
            case 'TopLeft':
                pos.top -= (tooltipEleHeight + tipHeight + tipAdjust);
                pos.left -= (tooltipEleWidth - tipWidthAdjust);
                break;
            case 'TopRight':
                pos.top -= (tooltipEleHeight + tipHeight + tipAdjust);
                pos.left -= (tipWidthAdjust);
                break;
            default:
                pos.top -= (tooltipEleHeight + tipHeight + tipAdjust);
                pos.left -= (tooltipEleWidth / 2);
                break;
        }
        pos.left += this.offsetX;
        pos.top += this.offsetY;
        return pos;
    };
    Tooltip.prototype.updateTipPosition = function (position) {
        var selEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + ARROW_TIP + ',.' + ARROW_TIP_OUTER + ',.' + ARROW_TIP_INNER, this.tooltipEle);
        var removeList = [TIP_BOTTOM, TIP_TOP, TIP_LEFT, TIP_RIGHT];
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])(selEle, removeList);
        this.setTipClass(position);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])(selEle, this.tipClass);
    };
    Tooltip.prototype.adjustArrow = function (target, position, tooltipPositionX, tooltipPositionY) {
        if (this.showTipPointer === false) {
            return;
        }
        this.updateTipPosition(position);
        var leftValue;
        var topValue;
        this.tooltipEle.style.display = 'block';
        var tooltipWidth = this.tooltipEle.clientWidth;
        var tooltipHeight = this.tooltipEle.clientHeight;
        var arrowEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + ARROW_TIP, this.tooltipEle);
        var arrowInnerELe = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + ARROW_TIP_INNER, this.tooltipEle);
        var tipWidth = arrowEle.offsetWidth;
        var tipHeight = arrowEle.offsetHeight;
        this.tooltipEle.style.display = '';
        if (this.tipClass === TIP_BOTTOM || this.tipClass === TIP_TOP) {
            if (this.tipClass === TIP_BOTTOM) {
                topValue = '99.9%';
                // Arrow icon aligned -2px height from ArrowOuterTip div
                arrowInnerELe.style.top = '-' + (tipHeight - 2) + 'px';
            }
            else {
                topValue = -(tipHeight - 1) + 'px';
                // Arrow icon aligned -6px height from ArrowOuterTip div
                arrowInnerELe.style.top = '-' + (tipHeight - 6) + 'px';
            }
            if (target) {
                var tipPosExclude = tooltipPositionX !== 'Center' || (tooltipWidth > target.offsetWidth) || this.mouseTrail;
                if ((tipPosExclude && tooltipPositionX === 'Left') || (!tipPosExclude && this.tipPointerPosition === 'End')) {
                    leftValue = (tooltipWidth - tipWidth - POINTER_ADJUST) + 'px';
                }
                else if ((tipPosExclude && tooltipPositionX === 'Right') || (!tipPosExclude && this.tipPointerPosition === 'Start')) {
                    leftValue = POINTER_ADJUST + 'px';
                }
                else {
                    leftValue = ((tooltipWidth / 2) - (tipWidth / 2)) + 'px';
                }
            }
        }
        else {
            if (this.tipClass === TIP_RIGHT) {
                leftValue = '99.9%';
                // Arrow icon aligned -2px left from ArrowOuterTip div
                arrowInnerELe.style.left = '-' + (tipWidth - 2) + 'px';
            }
            else {
                leftValue = -(tipWidth - 1) + 'px';
                // Arrow icon aligned -2px from ArrowOuterTip width
                arrowInnerELe.style.left = (-(tipWidth) + (tipWidth - 2)) + 'px';
            }
            var tipPosExclude = tooltipPositionY !== 'Center' || (tooltipHeight > target.offsetHeight) || this.mouseTrail;
            if ((tipPosExclude && tooltipPositionY === 'Top') || (!tipPosExclude && this.tipPointerPosition === 'End')) {
                topValue = (tooltipHeight - tipHeight - POINTER_ADJUST) + 'px';
            }
            else if ((tipPosExclude && tooltipPositionY === 'Bottom') || (!tipPosExclude && this.tipPointerPosition === 'Start')) {
                topValue = POINTER_ADJUST + 'px';
            }
            else {
                topValue = ((tooltipHeight / 2) - (tipHeight / 2)) + 'px';
            }
        }
        arrowEle.style.top = topValue;
        arrowEle.style.left = leftValue;
    };
    Tooltip.prototype.renderContent = function (target) {
        var tooltipContent = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CONTENT, this.tooltipEle);
        if (this.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.tooltipEle], this.cssClass.split(' '));
        }
        if (target && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(target.getAttribute('title'))) {
            target.setAttribute('data-content', target.getAttribute('title'));
            target.removeAttribute('title');
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.content)) {
            tooltipContent.innerHTML = '';
            if (this.content instanceof HTMLElement) {
                tooltipContent.appendChild(this.content);
            }
            else if (typeof this.content === 'string') {
                if (this.enableHtmlSanitizer) {
                    this.setProperties({ content: __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(this.content) }, true);
                }
                // eslint-disable-next-line
                var tempFunction = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(this.content);
                var tempArr = tempFunction({}, this, 'content', this.element.id + 'content', undefined, undefined, tooltipContent);
                if (tempArr) {
                    if (this.enableHtmlParse) {
                        var nodeList = tempArr.length;
                        for (var i = 0; i < nodeList; i++) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(tempArr, tooltipContent);
                        }
                    }
                    else {
                        tooltipContent['textContent'] = this.content;
                    }
                    this.enableHtmlParse ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(tempArr, tooltipContent) : tooltipContent['textContent'] = this.content;
                }
            }
            else {
                // eslint-disable-next-line
                var templateFunction = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(this.content);
                var tempArr = templateFunction({}, this, 'content', this.element.id + 'content', undefined, undefined, tooltipContent);
                if (tempArr) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(tempArr, tooltipContent);
                }
                this.renderReactTemplates();
            }
        }
        else {
            if (target && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(target.getAttribute('data-content'))) {
                tooltipContent.innerHTML = target.getAttribute('data-content');
            }
        }
    };
    Tooltip.prototype.renderCloseIcon = function () {
        if (!this.isSticky) {
            return;
        }
        var tipClose = this.createElement('div', { className: ICON + ' ' + CLOSE });
        this.tooltipEle.appendChild(tipClose);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(tipClose, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].touchStartEvent, this.onStickyClose, this);
    };
    Tooltip.prototype.addDescribedBy = function (target, id) {
        var describedby = (target.getAttribute('aria-describedby') || '').split(/\s+/);
        if (describedby.indexOf(id) < 0) {
            describedby.push(id);
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(target, { 'aria-describedby': describedby.join(' ').trim(), 'data-tooltip-id': id });
    };
    Tooltip.prototype.removeDescribedBy = function (target) {
        var id = target.getAttribute('data-tooltip-id');
        var describedby = (target.getAttribute('aria-describedby') || '').split(/\s+/);
        var index = describedby.indexOf(id);
        if (index !== -1) {
            describedby.splice(index, 1);
        }
        target.removeAttribute('data-tooltip-id');
        var orgdescribedby = describedby.join(' ').trim();
        if (orgdescribedby) {
            target.setAttribute('aria-describedby', orgdescribedby);
        }
        else {
            target.removeAttribute('aria-describedby');
        }
    };
    Tooltip.prototype.tapHoldHandler = function (evt) {
        clearTimeout(this.autoCloseTimer);
        this.targetHover(evt.originalEvent);
    };
    Tooltip.prototype.touchEndHandler = function (e) {
        var _this = this;
        if (this.isSticky) {
            return;
        }
        // eslint-disable-next-line
        var close = function () {
            _this.close();
        };
        this.autoCloseTimer = setTimeout(close, TOUCHEND_HIDE_DELAY);
    };
    Tooltip.prototype.targetClick = function (e) {
        var target;
        if (this.target) {
            target = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, this.target);
        }
        else {
            target = this.element;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(target)) {
            return;
        }
        if (target.getAttribute('data-tooltip-id') === null) {
            this.targetHover(e);
        }
        else if (!this.isSticky) {
            this.hideTooltip(this.animation.close, e, target);
        }
    };
    Tooltip.prototype.targetHover = function (e) {
        var target;
        if (this.target) {
            target = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, this.target);
        }
        else {
            target = this.element;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(target) || (target.getAttribute('data-tooltip-id') !== null && this.closeDelay === 0)) {
            return;
        }
        var targetList = [].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('[data-tooltip-id= "' + this.ctrlId + '_content"]', document));
        for (var _i = 0, targetList_1 = targetList; _i < targetList_1.length; _i++) {
            var target_1 = targetList_1[_i];
            this.restoreElement(target_1);
        }
        this.showTooltip(target, this.animation.open, e);
    };
    Tooltip.prototype.mouseMoveBeforeOpen = function (e) {
        this.mouseMoveEvent = e;
    };
    Tooltip.prototype.mouseMoveBeforeRemove = function () {
        if (this.mouseMoveTarget) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.mouseMoveTarget, 'mousemove touchstart', this.mouseMoveBeforeOpen);
        }
    };
    Tooltip.prototype.showTooltip = function (target, showAnimation, e) {
        var _this = this;
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
        if (this.openDelay && this.mouseTrail) {
            this.mouseMoveBeforeRemove();
            this.mouseMoveTarget = target;
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.mouseMoveTarget, 'mousemove touchstart', this.mouseMoveBeforeOpen, this);
        }
        this.tooltipEventArgs = {
            type: e ? e.type : null, cancel: false, target: target, event: e ? e : null,
            element: this.tooltipEle, isInteracted: !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e)
        };
        // eslint-disable-next-line
        var observeCallback = function (beforeRenderArgs) {
            _this.beforeRenderCallback(beforeRenderArgs, target, e, showAnimation);
        };
        this.trigger('beforeRender', this.tooltipEventArgs, observeCallback.bind(this));
    };
    Tooltip.prototype.beforeRenderCallback = function (beforeRenderArgs, target, e, showAnimation) {
        if (beforeRenderArgs.cancel) {
            this.isHidden = true;
            this.clear();
            this.mouseMoveBeforeRemove();
        }
        else {
            this.isHidden = false;
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.tooltipEle)) {
                this.ctrlId = this.element.getAttribute('id') ?
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])(this.element.getAttribute('id')) : Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('tooltip');
                this.tooltipEle = this.createElement('div', {
                    className: TOOLTIP_WRAP + ' ' + POPUP_ROOT + ' ' + POPUP_LIB, attrs: {
                        role: 'tooltip', 'aria-hidden': 'false', 'id': this.ctrlId + '_content'
                    }, styles: 'width:' +
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.width) + ';height:' + Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.height) + ';position:absolute;'
                });
                this.tooltipBeforeRender(target, this);
                this.tooltipAfterRender(target, e, showAnimation, this);
            }
            else {
                if (target) {
                    this.adjustArrow(target, this.position, this.tooltipPositionX, this.tooltipPositionY);
                    this.addDescribedBy(target, this.ctrlId + '_content');
                    this.renderContent(target);
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["b" /* Animation */].stop(this.tooltipEle);
                    this.reposition(target);
                    this.tooltipAfterRender(target, e, showAnimation, this);
                }
            }
        }
    };
    Tooltip.prototype.appendContainer = function (ctrlObj) {
        if (typeof this.container == 'string') {
            if (this.container === 'body') {
                this.containerElement = document.body;
            }
            else {
                this.isBodyContainer = false;
                this.containerElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])(this.container, document);
            }
        }
        else if (this.container instanceof HTMLElement) {
            this.containerElement = this.container;
            this.isBodyContainer = this.containerElement.tagName === 'BODY';
        }
        if (!this.isBodyContainer) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.containerElement], POPUP_CONTAINER);
        }
        this.containerElement.appendChild(ctrlObj.tooltipEle);
    };
    Tooltip.prototype.tooltipBeforeRender = function (target, ctrlObj) {
        if (target) {
            if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([ctrlObj.tooltipEle], DEVICE);
            }
            if (ctrlObj.width !== 'auto') {
                ctrlObj.tooltipEle.style.maxWidth = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(ctrlObj.width);
            }
            ctrlObj.tooltipEle.appendChild(ctrlObj.createElement('div', { className: CONTENT }));
            this.appendContainer(ctrlObj);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([ctrlObj.tooltipEle], HIDE_POPUP);
            ctrlObj.addDescribedBy(target, ctrlObj.ctrlId + '_content');
            ctrlObj.renderContent(target);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([ctrlObj.tooltipEle], POPUP_OPEN);
            if (ctrlObj.showTipPointer) {
                ctrlObj.renderArrow();
            }
            ctrlObj.renderCloseIcon();
            ctrlObj.renderPopup(target);
            ctrlObj.adjustArrow(target, ctrlObj.position, ctrlObj.tooltipPositionX, ctrlObj.tooltipPositionY);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["b" /* Animation */].stop(ctrlObj.tooltipEle);
            ctrlObj.reposition(target);
        }
    };
    Tooltip.prototype.tooltipAfterRender = function (target, e, showAnimation, ctrlObj) {
        if (target) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([ctrlObj.tooltipEle], POPUP_OPEN);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([ctrlObj.tooltipEle], POPUP_CLOSE);
            ctrlObj.tooltipEventArgs = {
                type: e ? e.type : null, cancel: false, target: target, event: e ? e : null,
                element: ctrlObj.tooltipEle, isInteracted: !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e)
            };
            if (ctrlObj.needTemplateReposition() && !ctrlObj.mouseTrail) {
                ctrlObj.tooltipEle.style.display = 'none';
            }
            // eslint-disable-next-line
            var observeCallback = function (observedArgs) {
                ctrlObj.beforeOpenCallback(observedArgs, target, showAnimation, e);
            };
            ctrlObj.trigger('beforeOpen', ctrlObj.tooltipEventArgs, observeCallback.bind(ctrlObj));
        }
    };
    Tooltip.prototype.beforeOpenCallback = function (observedArgs, target, showAnimation, e) {
        var _this = this;
        if (observedArgs.cancel) {
            this.isHidden = true;
            this.clear();
            this.mouseMoveBeforeRemove();
            this.restoreElement(target);
        }
        else {
            // eslint-disable-next-line
            var openAnimation_1 = {
                name: showAnimation.effect,
                duration: showAnimation.duration,
                delay: showAnimation.delay,
                timingFunction: 'easeOut'
            };
            if (showAnimation.effect === 'None') {
                openAnimation_1 = undefined;
            }
            if (this.openDelay > 0) {
                // eslint-disable-next-line
                var show = function () {
                    if (_this.mouseTrail) {
                        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(target, 'mousemove touchstart mouseenter', _this.onMouseMove, _this);
                    }
                    if (_this.popupObj) {
                        _this.popupObj.show(openAnimation_1, target);
                        if (_this.mouseMoveEvent && _this.mouseTrail) {
                            _this.onMouseMove(_this.mouseMoveEvent);
                        }
                    }
                };
                this.showTimer = setTimeout(show, this.openDelay);
            }
            else {
                if (this.popupObj) {
                    this.popupObj.show(openAnimation_1, target);
                }
            }
        }
        if (e) {
            this.wireMouseEvents(e, target);
        }
    };
    Tooltip.prototype.needTemplateReposition = function () {
        // eslint-disable-next-line
        var tooltip = this;
        return !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(tooltip.viewContainerRef)
            && typeof tooltip.viewContainerRef !== 'string';
    };
    Tooltip.prototype.checkCollision = function (target, x, y) {
        var elePos = {
            left: x, top: y, position: this.position,
            horizontal: this.tooltipPositionX, vertical: this.tooltipPositionY
        };
        var affectedPos = Object(__WEBPACK_IMPORTED_MODULE_3__common_collision__["c" /* isCollide */])(this.tooltipEle, this.checkCollideTarget(), x, y);
        if (affectedPos.length > 0) {
            elePos.horizontal = affectedPos.indexOf('left') >= 0 ? 'Right' : affectedPos.indexOf('right') >= 0 ? 'Left' :
                this.tooltipPositionX;
            elePos.vertical = affectedPos.indexOf('top') >= 0 ? 'Bottom' : affectedPos.indexOf('bottom') >= 0 ? 'Top' :
                this.tooltipPositionY;
        }
        return elePos;
    };
    Tooltip.prototype.calculateElementPosition = function (pos, offsetPos) {
        return [this.isBodyContainer ? pos.left + offsetPos.left :
                (pos.left - this.containerElement.offsetLeft) + offsetPos.left + window.pageXOffset + this.containerElement.scrollLeft,
            this.isBodyContainer ? pos.top + offsetPos.top :
                (pos.top - this.containerElement.offsetTop) + offsetPos.top + window.pageYOffset + this.containerElement.scrollTop];
    };
    Tooltip.prototype.collisionFlipFit = function (target, x, y) {
        var elePos = this.checkCollision(target, x, y);
        var newpos = elePos.position;
        if (this.tooltipPositionY !== elePos.vertical) {
            newpos = ((this.position.indexOf('Bottom') === 0 || this.position.indexOf('Top') === 0) ?
                elePos.vertical + this.tooltipPositionX : this.tooltipPositionX + elePos.vertical);
        }
        if (this.tooltipPositionX !== elePos.horizontal) {
            if (newpos.indexOf('Left') === 0) {
                elePos.vertical = (newpos === 'LeftTop' || newpos === 'LeftCenter') ? 'Top' : 'Bottom';
                newpos = (elePos.vertical + 'Left');
            }
            if (newpos.indexOf('Right') === 0) {
                elePos.vertical = (newpos === 'RightTop' || newpos === 'RightCenter') ? 'Top' : 'Bottom';
                newpos = (elePos.vertical + 'Right');
            }
            elePos.horizontal = this.tooltipPositionX;
        }
        this.tooltipEventArgs = {
            type: null, cancel: false, target: target, event: null,
            element: this.tooltipEle, collidedPosition: newpos
        };
        this.trigger('beforeCollision', this.tooltipEventArgs);
        var elePosVertical = elePos.vertical;
        var elePosHorizontal = elePos.horizontal;
        if (elePos.position !== newpos) {
            var pos = Object(__WEBPACK_IMPORTED_MODULE_2__common_position__["a" /* calculatePosition */])(target, elePosHorizontal, elePosVertical, !this.isBodyContainer, this.isBodyContainer ? null : this.containerElement.getBoundingClientRect());
            this.adjustArrow(target, newpos, elePosHorizontal, elePosVertical);
            var offsetPos = this.calculateTooltipOffset(newpos);
            offsetPos.top -= this.getOffSetPosition('TopBottom', newpos, this.offsetY);
            offsetPos.left -= this.getOffSetPosition('RightLeft', newpos, this.offsetX);
            elePos.position = newpos;
            var elePosition = this.calculateElementPosition(pos, offsetPos);
            elePos.left = elePosition[0];
            elePos.top = elePosition[1];
        }
        else {
            this.adjustArrow(target, newpos, elePosHorizontal, elePosVertical);
        }
        var eleOffset = { left: elePos.left, top: elePos.top };
        var left = this.isBodyContainer ?
            Object(__WEBPACK_IMPORTED_MODULE_3__common_collision__["a" /* fit */])(this.tooltipEle, this.checkCollideTarget(), { X: true, Y: false }, eleOffset).left : eleOffset.left;
        this.tooltipEle.style.display = 'block';
        if (this.showTipPointer && (newpos.indexOf('Bottom') === 0 || newpos.indexOf('Top') === 0)) {
            var arrowEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + ARROW_TIP, this.tooltipEle);
            var arrowleft = parseInt(arrowEle.style.left, 10) - (left - elePos.left);
            if (arrowleft < 0) {
                arrowleft = 0;
            }
            else if ((arrowleft + arrowEle.offsetWidth) > this.tooltipEle.clientWidth) {
                arrowleft = this.tooltipEle.clientWidth - arrowEle.offsetWidth;
            }
            arrowEle.style.left = arrowleft.toString() + 'px';
        }
        this.tooltipEle.style.display = '';
        eleOffset.left = left;
        return eleOffset;
    };
    Tooltip.prototype.getOffSetPosition = function (positionString, newPos, offsetType) {
        return ((positionString.indexOf(this.position.split(/(?=[A-Z])/)[0]) !== -1) &&
            (positionString.indexOf(newPos.split(/(?=[A-Z])/)[0]) !== -1)) ? (2 * offsetType) : 0;
    };
    Tooltip.prototype.checkCollideTarget = function () {
        return !this.windowCollision && this.target ? this.element : null;
    };
    Tooltip.prototype.hideTooltip = function (hideAnimation, e, targetElement) {
        var _this = this;
        if (this.closeDelay > 0) {
            clearTimeout(this.hideTimer);
            clearTimeout(this.showTimer);
            // eslint-disable-next-line
            var hide = function () {
                if (_this.closeDelay && _this.tooltipEle && _this.isTooltipOpen) {
                    return;
                }
                _this.tooltipHide(hideAnimation, e, targetElement);
            };
            this.hideTimer = setTimeout(hide, this.closeDelay);
        }
        else {
            this.tooltipHide(hideAnimation, e, targetElement);
        }
    };
    Tooltip.prototype.tooltipHide = function (hideAnimation, e, targetElement) {
        var _this = this;
        var target;
        if (e) {
            target = this.target ? (targetElement || e.target) : this.element;
        }
        else {
            target = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('[data-tooltip-id= "' + this.ctrlId + '_content"]', document);
        }
        this.tooltipEventArgs = {
            type: e ? e.type : null, cancel: false, target: target, event: e ? e : null,
            element: this.tooltipEle, isInteracted: !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e)
        };
        // this line commented for close the tooltip popup element even the target element destroyed in a page.
        //if (isNullOrUndefined(target)) { return; }
        this.trigger('beforeClose', this.tooltipEventArgs, function (observedArgs) {
            if (!observedArgs.cancel) {
                _this.mouseMoveBeforeRemove();
                _this.popupHide(hideAnimation, target);
            }
            else {
                _this.isHidden = false;
            }
        });
    };
    Tooltip.prototype.popupHide = function (hideAnimation, target) {
        if (target) {
            this.restoreElement(target);
        }
        this.isHidden = true;
        // eslint-disable-next-line
        var closeAnimation = {
            name: hideAnimation.effect,
            duration: hideAnimation.duration,
            delay: hideAnimation.delay,
            timingFunction: 'easeIn'
        };
        if (hideAnimation.effect === 'None') {
            closeAnimation = undefined;
        }
        if (this.popupObj) {
            this.popupObj.hide(closeAnimation);
        }
    };
    Tooltip.prototype.restoreElement = function (target) {
        this.unwireMouseEvents(target);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(target.getAttribute('data-content'))) {
            target.setAttribute('title', target.getAttribute('data-content'));
            target.removeAttribute('data-content');
        }
        this.removeDescribedBy(target);
    };
    Tooltip.prototype.clear = function () {
        if (this.tooltipEle) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.tooltipEle], POPUP_CLOSE);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.tooltipEle], POPUP_OPEN);
        }
        if (this.isHidden) {
            if (this.popupObj) {
                this.popupObj.destroy();
            }
            if (this.tooltipEle) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(this.tooltipEle);
            }
            this.tooltipEle = null;
            this.popupObj = null;
        }
    };
    Tooltip.prototype.tooltipHover = function (e) {
        if (this.tooltipEle) {
            this.isTooltipOpen = true;
        }
    };
    Tooltip.prototype.tooltipMouseOut = function (e) {
        this.isTooltipOpen = false;
        this.hideTooltip(this.animation.close, e, this.findTarget());
    };
    Tooltip.prototype.onMouseOut = function (e) {
        var enteredElement = e.relatedTarget;
        // don't close the tooltip only if it is tooltip content element
        if (enteredElement && !this.mouseTrail) {
            var checkForTooltipElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(enteredElement, "." + TOOLTIP_WRAP + "." + POPUP_LIB + "." + POPUP_ROOT);
            if (checkForTooltipElement) {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(checkForTooltipElement, 'mouseleave', this.tooltipElementMouseOut, this);
            }
            else {
                this.hideTooltip(this.animation.close, e, this.findTarget());
                if (this.closeDelay === 0) {
                    this.clear();
                }
            }
        }
        else {
            this.hideTooltip(this.animation.close, e, this.findTarget());
            this.clear();
        }
    };
    Tooltip.prototype.tooltipElementMouseOut = function (e) {
        this.hideTooltip(this.animation.close, e, this.findTarget());
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'mouseleave', this.tooltipElementMouseOut);
        this.clear();
    };
    Tooltip.prototype.onStickyClose = function (e) {
        this.close();
    };
    Tooltip.prototype.onMouseMove = function (event) {
        var eventPageX = 0;
        var eventPageY = 0;
        if (event.type.indexOf('touch') > -1) {
            event.preventDefault();
            eventPageX = event.touches[0].pageX;
            eventPageY = event.touches[0].pageY;
        }
        else {
            eventPageX = event.pageX;
            eventPageY = event.pageY;
        }
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["b" /* Animation */].stop(this.tooltipEle);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.tooltipEle], POPUP_CLOSE);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.tooltipEle], POPUP_OPEN);
        this.adjustArrow(event.target, this.position, this.tooltipPositionX, this.tooltipPositionY);
        var pos = this.calculateTooltipOffset(this.position);
        var x = eventPageX + pos.left + this.offsetX;
        var y = eventPageY + pos.top + this.offsetY;
        var elePos = this.checkCollision(event.target, x, y);
        if (this.tooltipPositionX !== elePos.horizontal || this.tooltipPositionY !== elePos.vertical) {
            var newpos = (this.position.indexOf('Bottom') === 0 || this.position.indexOf('Top') === 0) ?
                elePos.vertical + elePos.horizontal : elePos.horizontal + elePos.vertical;
            elePos.position = newpos;
            this.adjustArrow(event.target, elePos.position, elePos.horizontal, elePos.vertical);
            var colpos = this.calculateTooltipOffset(elePos.position);
            elePos.left = eventPageX + colpos.left - this.offsetX;
            elePos.top = eventPageY + colpos.top - this.offsetY;
        }
        this.tooltipEle.style.left = elePos.left + 'px';
        this.tooltipEle.style.top = elePos.top + 'px';
    };
    Tooltip.prototype.keyDown = function (event) {
        if (this.tooltipEle && event.keyCode === 27) {
            this.close();
        }
    };
    Tooltip.prototype.touchEnd = function (e) {
        if (this.tooltipEle && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.' + ROOT) === null && !this.isSticky) {
            this.close();
        }
    };
    Tooltip.prototype.scrollHandler = function (e) {
        if (this.tooltipEle) {
            if (!(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, "." + TOOLTIP_WRAP + "." + POPUP_LIB + "." + POPUP_ROOT))) {
                this.close();
            }
        }
    };
    /**
     * Core method that initializes the control rendering.
     *
     * @private
     * @returns {void}
     */
    Tooltip.prototype.render = function () {
        this.initialize();
        this.wireEvents(this.opensOn);
        this.renderComplete();
    };
    /**
     * Initializes the values of private members.
     *
     * @private
     * @returns {void}
     */
    Tooltip.prototype.preRender = function () {
        this.tipClass = TIP_BOTTOM;
        this.tooltipPositionX = 'Center';
        this.tooltipPositionY = 'Top';
        this.isHidden = true;
    };
    /**
     * Binding events to the Tooltip element.
     *
     * @hidden
     * @param {string} trigger - specify the trigger string to the function
     * @returns {void}
     *
     */
    Tooltip.prototype.wireEvents = function (trigger) {
        var triggerList = this.getTriggerList(trigger);
        for (var _i = 0, triggerList_1 = triggerList; _i < triggerList_1.length; _i++) {
            var opensOn = triggerList_1[_i];
            if (opensOn === 'Custom') {
                return;
            }
            if (opensOn === 'Focus') {
                this.wireFocusEvents();
            }
            if (opensOn === 'Click') {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].touchStartEvent, this.targetClick, this);
            }
            if (opensOn === 'Hover') {
                if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
                    this.touchModule = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["t" /* Touch */](this.element, {
                        tapHoldThreshold: TAPHOLD_THRESHOLD,
                        tapHold: this.tapHoldHandler.bind(this)
                    });
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].touchEndEvent, this.touchEndHandler, this);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'mouseover', this.targetHover, this);
                }
            }
        }
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'touchend', this.touchEnd, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'scroll wheel', this.scrollHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(window, 'resize', this.windowResize, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'keydown', this.keyDown, this);
    };
    Tooltip.prototype.getTriggerList = function (trigger) {
        if (trigger === 'Auto') {
            trigger = (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) ? 'Hover' : 'Hover Focus';
        }
        return trigger.split(' ');
    };
    Tooltip.prototype.wireFocusEvents = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.target)) {
            var targetList = [].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])(this.target, this.element));
            for (var _i = 0, targetList_2 = targetList; _i < targetList_2.length; _i++) {
                var target = targetList_2[_i];
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(target, 'focus', this.targetHover, this);
            }
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'focus', this.targetHover, this);
        }
    };
    Tooltip.prototype.wireMouseEvents = function (e, target) {
        if (this.tooltipEle) {
            if (!this.isSticky) {
                if (e.type === 'focus') {
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(target, 'blur', this.onMouseOut, this);
                }
                if (e.type === 'mouseover') {
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(target, 'mouseleave', this.onMouseOut, this);
                }
                if (this.closeDelay) {
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.tooltipEle, 'mouseenter', this.tooltipHover, this);
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.tooltipEle, 'mouseleave', this.tooltipMouseOut, this);
                }
            }
            if (this.mouseTrail && this.openDelay === 0) {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(target, 'mousemove touchstart mouseenter', this.onMouseMove, this);
            }
        }
    };
    /**
     * Unbinding events from the element on widget destroy.
     *
     * @hidden
     *
     * @param {string} trigger - specify the trigger string to the function
     * @returns {void}
     *
     */
    Tooltip.prototype.unwireEvents = function (trigger) {
        var triggerList = this.getTriggerList(trigger);
        for (var _i = 0, triggerList_2 = triggerList; _i < triggerList_2.length; _i++) {
            var opensOn = triggerList_2[_i];
            if (opensOn === 'Custom') {
                return;
            }
            if (opensOn === 'Focus') {
                this.unwireFocusEvents();
            }
            if (opensOn === 'Click') {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].touchStartEvent, this.targetClick);
            }
            if (opensOn === 'Hover') {
                if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
                    if (this.touchModule) {
                        this.touchModule.destroy();
                    }
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].touchEndEvent, this.touchEndHandler);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'mouseover', this.targetHover);
                }
            }
        }
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'touchend', this.touchEnd);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'scroll wheel', this.scrollHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(window, 'resize', this.windowResize);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'keydown', this.keyDown);
    };
    Tooltip.prototype.unwireFocusEvents = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.target)) {
            var targetList = [].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])(this.target, this.element));
            for (var _i = 0, targetList_3 = targetList; _i < targetList_3.length; _i++) {
                var target = targetList_3[_i];
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(target, 'focus', this.targetHover);
            }
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'focus', this.targetHover);
        }
    };
    Tooltip.prototype.unwireMouseEvents = function (target) {
        if (!this.isSticky) {
            var triggerList = this.getTriggerList(this.opensOn);
            for (var _i = 0, triggerList_3 = triggerList; _i < triggerList_3.length; _i++) {
                var opensOn = triggerList_3[_i];
                if (opensOn === 'Focus') {
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(target, 'blur', this.onMouseOut);
                }
                if (opensOn === 'Hover' && !__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(target, 'mouseleave', this.onMouseOut);
                }
            }
            if (this.closeDelay) {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(target, 'mouseenter', this.tooltipHover);
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(target, 'mouseleave', this.tooltipMouseOut);
            }
        }
        if (this.mouseTrail) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(target, 'mousemove touchstart mouseenter', this.onMouseMove);
        }
    };
    Tooltip.prototype.findTarget = function () {
        var target = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('[data-tooltip-id= "' + this.ctrlId + '_content"]', document);
        return target;
    };
    /**
     * Core method to return the component name.
     *
     * @private
     *
     * @returns {string} - this method returns module name.
     */
    Tooltip.prototype.getModuleName = function () {
        return 'tooltip';
    };
    /**
     * Returns the properties to be maintained in the persisted state.
     *
     * @private
     *
     * @returns {string} - this method returns persisted data.
     */
    Tooltip.prototype.getPersistData = function () {
        return this.addOnPersist([]);
    };
    /**
     * Called internally, if any of the property value changed.
     *
     * @private
     *
     * @param {TooltipModel} newProp - this param gives new property values to the method
     * @param {TooltipModel} oldProp - this param gives old property values to the method
     * @returns {void}
     *
     */
    Tooltip.prototype.onPropertyChanged = function (newProp, oldProp) {
        var targetElement = this.findTarget();
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'width':
                    if (this.tooltipEle && targetElement) {
                        this.tooltipEle.style.width = this.tooltipEle.style.maxWidth = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(newProp.width);
                        this.reposition(targetElement);
                    }
                    break;
                case 'height':
                    if (this.tooltipEle && targetElement) {
                        this.tooltipEle.style.height = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(newProp.height);
                        this.reposition(targetElement);
                    }
                    break;
                case 'content':
                    if (this.tooltipEle) {
                        this.renderContent();
                    }
                    break;
                case 'opensOn':
                    this.unwireEvents(oldProp.opensOn);
                    this.wireEvents(newProp.opensOn);
                    break;
                case 'position':
                    this.formatPosition();
                    if (this.tooltipEle && targetElement) {
                        var arrowInnerELe = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + ARROW_TIP_INNER, this.tooltipEle);
                        arrowInnerELe.style.top = arrowInnerELe.style.left = null;
                        this.reposition(targetElement);
                    }
                    break;
                case 'tipPointerPosition':
                    if (this.tooltipEle && targetElement) {
                        this.reposition(targetElement);
                    }
                    break;
                case 'offsetX':
                    if (this.tooltipEle) {
                        var x = newProp.offsetX - oldProp.offsetX;
                        this.tooltipEle.style.left = (parseInt(this.tooltipEle.style.left, 10) + (x)).toString() + 'px';
                    }
                    break;
                case 'offsetY':
                    if (this.tooltipEle) {
                        var y = newProp.offsetY - oldProp.offsetY;
                        this.tooltipEle.style.top = (parseInt(this.tooltipEle.style.top, 10) + (y)).toString() + 'px';
                    }
                    break;
                case 'cssClass':
                    if (this.tooltipEle) {
                        if (oldProp.cssClass) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.tooltipEle], oldProp.cssClass.split(' '));
                        }
                        if (newProp.cssClass) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.tooltipEle], newProp.cssClass.split(' '));
                        }
                    }
                    break;
                case 'enableRtl':
                    if (this.tooltipEle) {
                        if (this.enableRtl) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.tooltipEle], RTL);
                        }
                        else {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.tooltipEle], RTL);
                        }
                    }
                    break;
                case 'container':
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.containerElement)) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.containerElement], POPUP_CONTAINER);
                    }
                    this.container = newProp.container;
                    if (this.tooltipEle && targetElement) {
                        this.appendContainer(this);
                        this.reposition(targetElement);
                    }
            }
        }
    };
    /**
     * It is used to show the Tooltip on the specified target with specific animation settings.
     *
     * @param {HTMLElement} element - Target element where the Tooltip is to be displayed. (It is an optional parameter)
     * @param {TooltipAnimationSettings} animation - Sets the specific animation, while showing the Tooltip on the screen. (It is an optional parameter)
     * @returns {void}
     */
    Tooltip.prototype.open = function (element, animation) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(animation)) {
            animation = this.animation.open;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(element)) {
            element = this.element;
        }
        if (element.style.display === 'none') {
            return;
        }
        this.showTooltip(element, animation);
    };
    /**
     * It is used to hide the Tooltip with specific animation effect.
     *
     * @param {TooltipAnimationSettings} animation - Sets the specific animation when hiding Tooltip from the screen. (It is an optional parameter)
     * @returns {void}
     */
    Tooltip.prototype.close = function (animation) {
        if (!animation) {
            animation = this.animation.close;
        }
        this.hideTooltip(animation);
    };
    /**
     * It is used to refresh the Tooltip content and its position.
     *
     * @param {HTMLElement} target - Target element where the Tooltip content or position needs to be refreshed.
     * @returns {void}
     */
    Tooltip.prototype.refresh = function (target) {
        if (this.tooltipEle) {
            this.renderContent(target);
        }
        if (this.popupObj && target) {
            this.reposition(target);
        }
    };
    /**
     * It is used to destroy the Tooltip component.
     * @method destroy
     * @returns {void}
     * @memberof Tooltip
     */
    Tooltip.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        if (this.tooltipEle) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(this.tooltipEle);
        }
        if (this.popupObj) {
            this.popupObj.destroy();
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], ROOT);
        this.unwireEvents(this.opensOn);
        this.unwireMouseEvents(this.element);
        this.tooltipEle = null;
        this.popupObj = null;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('auto')
    ], Tooltip.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('auto')
    ], Tooltip.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Tooltip.prototype, "content", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('body')
    ], Tooltip.prototype, "container", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Tooltip.prototype, "target", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('TopCenter')
    ], Tooltip.prototype, "position", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(0)
    ], Tooltip.prototype, "offsetX", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(0)
    ], Tooltip.prototype, "offsetY", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Tooltip.prototype, "showTipPointer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Tooltip.prototype, "enableHtmlParse", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Tooltip.prototype, "windowCollision", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Auto')
    ], Tooltip.prototype, "tipPointerPosition", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Auto')
    ], Tooltip.prototype, "opensOn", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Tooltip.prototype, "mouseTrail", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Tooltip.prototype, "isSticky", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({}, Animation)
    ], Tooltip.prototype, "animation", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(0)
    ], Tooltip.prototype, "openDelay", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(0)
    ], Tooltip.prototype, "closeDelay", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Tooltip.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Tooltip.prototype, "enableHtmlSanitizer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tooltip.prototype, "beforeRender", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tooltip.prototype, "beforeOpen", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tooltip.prototype, "afterOpen", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tooltip.prototype, "beforeClose", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tooltip.prototype, "afterClose", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tooltip.prototype, "beforeCollision", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tooltip.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tooltip.prototype, "destroyed", void 0);
    Tooltip = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], Tooltip);
    return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__spinner__ = __webpack_require__(243);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__spinner__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__spinner__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__spinner__["c"]; });
/**
 * spinner modules
 */



/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Spinner */
/* harmony export (immutable) */ __webpack_exports__["a"] = createSpinner;
/* harmony export (immutable) */ __webpack_exports__["c"] = showSpinner;
/* harmony export (immutable) */ __webpack_exports__["b"] = hideSpinner;
/* unused harmony export setSpinner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);

var globalTimeOut = {};
var DEFT_MAT_WIDTH = 30;
var DEFT_FAB_WIDTH = 30;
var DEFT_FLUENT_WIDTH = 30;
var DEFT_TAIL_WIDTH = 24;
var DEFT_BOOT_WIDTH = 30;
var DEFT_BOOT4_WIDTH = 36;
var DEFT_BOOT5_WIDTH = 36;
var CLS_SHOWSPIN = 'e-spin-show';
var CLS_HIDESPIN = 'e-spin-hide';
var CLS_MATERIALSPIN = 'e-spin-material';
var CLS_FABRICSPIN = 'e-spin-fabric';
var CLS_FLUENTSPIN = 'e-spin-fluent';
var CLS_TAILWINDSPIN = 'e-spin-tailwind';
var CLS_BOOTSPIN = 'e-spin-bootstrap';
var CLS_BOOT4SPIN = 'e-spin-bootstrap4';
var CLS_BOOT5SPIN = 'e-spin-bootstrap5';
var CLS_HIGHCONTRASTSPIN = 'e-spin-high-contrast';
var CLS_SPINWRAP = 'e-spinner-pane';
var CLS_SPININWRAP = 'e-spinner-inner';
var CLS_SPINCIRCLE = 'e-path-circle';
var CLS_SPINARC = 'e-path-arc';
var CLS_SPINLABEL = 'e-spin-label';
var CLS_SPINTEMPLATE = 'e-spin-template';
var spinTemplate = null;
var spinCSSClass = null;
// eslint-disable-next-line
/**
  * Function to change the Spinners in a page globally from application end.
  * ```
  * E.g : blazorSpinner({ action: "Create", options: {target: targetElement}, type: "" });
  * ```
  *
  * @param {string} action - specifies the string
  * @param {CreateArgs} options - specifies the args
  * @param {string} target - specifies the target
  * @param {string} type - specifes the type
  * @returns {void}
  * @private
  */
function Spinner(action, options, target, type) {
    switch (action) {
        case 'Create':
            /* eslint-disable */
            var element = document.querySelector(options.target);
            var args = { type: type, target: element, cssClass: options.cssClass,
                label: options.label, width: options.width };
            /* eslint-enable */
            createSpinner(args);
            break;
        case 'Show':
            showSpinner(document.querySelector(target));
            break;
        case 'Hide':
            hideSpinner(document.querySelector(target));
            break;
        case 'Set':
            // eslint-disable-next-line
            var setArgs = { cssClass: options.cssClass, type: type };
            setSpinner(setArgs);
            break;
    }
}
/**
 * Create a spinner for the specified target element.
 * ```
 * E.g : createSpinner({ target: targetElement, width: '34px', label: 'Loading..' });
 * ```
 *
 * @param {SpinnerArgs} args - specifies the args
 * @param {CreateElementArgs} internalCreateElement - specifis the element args
 * @returns {void}
 * @private
 */
function createSpinner(args, internalCreateElement) {
    if (!args.target) {
        return;
    }
    var radius;
    var makeElement = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(internalCreateElement) ? internalCreateElement : __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */];
    // eslint-disable-next-line
    var container = create_spinner_container(args.target, makeElement);
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.cssClass)) {
        container.wrap.classList.add(args.cssClass);
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.template) || !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(spinTemplate)) {
        var template = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.template) ? args.template : spinTemplate;
        container.wrap.classList.add(CLS_SPINTEMPLATE);
        replaceContent(container.wrap, template, spinCSSClass);
    }
    else {
        var theme = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.type) ? args.type : getTheme(container.wrap);
        var width = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.width) ? args.width : undefined;
        radius = calculateRadius(width, theme);
        setTheme(theme, container.wrap, radius, makeElement);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.label)) {
            createLabel(container.inner_wrap, args.label, makeElement);
        }
    }
    container.wrap.classList.add(CLS_HIDESPIN);
    container = null;
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {string} label - specifies the string
 * @param {createElementParams} makeElement - specifies the element
 * @returns {HTMLElement} - returns the element
 */
function createLabel(container, label, makeElement) {
    var labelEle = makeElement('div', {});
    labelEle.classList.add(CLS_SPINLABEL);
    labelEle.innerHTML = label;
    container.appendChild(labelEle);
    return labelEle;
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */
function createMaterialSpinner(container, radius, makeElement) {
    var uniqueID = random_generator();
    globalTimeOut[uniqueID] = { timeOut: 0, type: 'Material', radius: radius };
    create_material_element(container, uniqueID, makeElement, CLS_MATERIALSPIN);
    mat_calculate_attributes(radius, container, 'Material', CLS_MATERIALSPIN);
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */
function createBootstrap4Spinner(container, radius, makeElement) {
    var uniqueID = random_generator();
    globalTimeOut[uniqueID] = { timeOut: 0, type: 'Bootstrap4', radius: radius };
    create_material_element(container, uniqueID, makeElement, CLS_BOOT4SPIN);
    mat_calculate_attributes(radius, container, 'Bootstrap4', CLS_BOOT4SPIN);
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */
function createBootstrap5Spinner(container, radius, makeElement) {
    var uniqueID = random_generator();
    globalTimeOut[uniqueID] = { timeOut: 0, type: 'Bootstrap5', radius: radius };
    create_material_element(container, uniqueID, makeElement, CLS_BOOT5SPIN);
    mat_calculate_attributes(radius, container, 'Bootstrap5', CLS_BOOT5SPIN);
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {string} uniqueID - specifies the id.
 * @param {number} radius - specifies the radius
 * @returns {void}
 */
function startMatAnimate(container, uniqueID, radius) {
    var globalObject = {};
    var timeOutVar = 0;
    globalTimeOut[uniqueID].timeOut = 0;
    globalObject[uniqueID] = globalVariables(uniqueID, radius, 0, 0);
    // eslint-disable-next-line
    var spinnerInfo = { uniqueID: uniqueID, container: container, globalInfo: globalObject, timeOutVar: timeOutVar };
    animateMaterial(spinnerInfo);
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */
function createFabricSpinner(container, radius, makeElement) {
    var uniqueID = random_generator();
    globalTimeOut[uniqueID] = { timeOut: 0, type: 'Fabric', radius: radius };
    create_fabric_element(container, uniqueID, CLS_FABRICSPIN, makeElement);
    fb_calculate_attributes(radius, container, CLS_FABRICSPIN);
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */
function createFluentSinner(container, radius, makeElement) {
    var uniqueID = random_generator();
    globalTimeOut[uniqueID] = { timeOut: 0, type: 'Fluent', radius: radius };
    create_fabric_element(container, uniqueID, CLS_FLUENTSPIN, makeElement);
    fb_calculate_attributes(radius, container, CLS_FLUENTSPIN);
}
function createTailwindSpinner(container, radius, makeElement) {
    var uniqueID = random_generator();
    globalTimeOut[uniqueID] = { timeOut: 0, type: 'Tailwind', radius: radius };
    create_fabric_element(container, uniqueID, CLS_TAILWINDSPIN, makeElement);
    fb_calculate_attributes(radius, container, CLS_TAILWINDSPIN);
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */
function createHighContrastSpinner(container, radius, makeElement) {
    var uniqueID = random_generator();
    globalTimeOut[uniqueID] = { timeOut: 0, type: 'HighContrast', radius: radius };
    create_fabric_element(container, uniqueID, CLS_HIGHCONTRASTSPIN, makeElement);
    fb_calculate_attributes(radius, container, CLS_HIGHCONTRASTSPIN);
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @returns {string} - returns the string
 */
function getTheme(container) {
    var theme = window.getComputedStyle(container, ':after').getPropertyValue('content');
    return theme.replace(/['"]+/g, '');
}
/**
 *
 * @param {string} theme - specifies the theme
 * @param {HTMLElement} container - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */
function setTheme(theme, container, radius, makeElement) {
    var innerContainer = container.querySelector('.' + CLS_SPININWRAP);
    var svg = innerContainer.querySelector('svg');
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(svg)) {
        innerContainer.removeChild(svg);
    }
    switch (theme) {
        case 'Material':
            createMaterialSpinner(innerContainer, radius, makeElement);
            break;
        case 'Fabric':
            createFabricSpinner(innerContainer, radius, makeElement);
            break;
        case 'Fluent':
            createFluentSinner(innerContainer, radius, makeElement);
            break;
        case 'Bootstrap':
            createBootstrapSpinner(innerContainer, radius, makeElement);
            break;
        case 'HighContrast':
            createHighContrastSpinner(innerContainer, radius, makeElement);
            break;
        case 'Bootstrap4':
            createBootstrap4Spinner(innerContainer, radius, makeElement);
            break;
        case 'Bootstrap5':
            createBootstrap5Spinner(innerContainer, radius, makeElement);
            break;
        case 'Tailwind':
        case 'Tailwind-dark':
            createTailwindSpinner(innerContainer, radius, makeElement);
            break;
    }
}
/**
 *
 * @param {HTMLElement} innerContainer - specifies the element
 * @param {number} radius - specifies the radius
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */
function createBootstrapSpinner(innerContainer, radius, makeElement) {
    var uniqueID = random_generator();
    globalTimeOut[uniqueID] = { timeOut: 0, type: 'Bootstrap', radius: radius };
    create_bootstrap_element(innerContainer, uniqueID, makeElement);
    boot_calculate_attributes(innerContainer, radius);
}
/**
 *
 * @param {HTMLElement} innerContainer - specifies the element
 * @param {string} uniqueID - specifies the id
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */
// eslint-disable-next-line
function create_bootstrap_element(innerContainer, uniqueID, makeElement) {
    var svgBoot = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var viewBoxValue = 64;
    var trans = 32;
    var defaultRadius = 2;
    svgBoot.setAttribute('id', uniqueID);
    svgBoot.setAttribute('class', CLS_BOOTSPIN);
    svgBoot.setAttribute('viewBox', '0 0 ' + viewBoxValue + ' ' + viewBoxValue);
    innerContainer.insertBefore(svgBoot, innerContainer.firstChild);
    for (var item = 0; item <= 7; item++) {
        var bootCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        bootCircle.setAttribute('class', CLS_SPINCIRCLE + '_' + item);
        bootCircle.setAttribute('r', defaultRadius + '');
        bootCircle.setAttribute('transform', 'translate(' + trans + ',' + trans + ')');
        svgBoot.appendChild(bootCircle);
    }
}
/**
 *
 * @param {HTMLElement} innerContainer - specifies the element
 * @param {number} radius - specifies the radius
 * @returns {void}
 */
// eslint-disable-next-line
function boot_calculate_attributes(innerContainer, radius) {
    var svg = innerContainer.querySelector('svg.e-spin-bootstrap');
    var x = 0;
    var y = 0;
    var rad = 24;
    svg.style.width = svg.style.height = radius + 'px';
    var startArc = 90;
    for (var item = 0; item <= 7; item++) {
        var start = defineArcPoints(x, y, rad, startArc);
        var circleEle = svg.querySelector('.' + CLS_SPINCIRCLE + '_' + item);
        circleEle.setAttribute('cx', start.x + '');
        circleEle.setAttribute('cy', start.y + '');
        startArc = startArc >= 360 ? 0 : startArc;
        startArc = startArc + 45;
    }
}
/**
 *
 * @param {number} begin - specifies the number
 * @param {number} stop  - specifirs the number
 * @returns {number[]} - returns the array of number
 */
function generateSeries(begin, stop) {
    var series = [];
    var start = begin;
    var end = stop;
    // eslint-disable-next-line
    var increment = false, count = 1;
    formSeries(start);
    /**
     *
     * @param {number} i - specifies the number
     * @returns {void}
     */
    function formSeries(i) {
        series.push(i);
        if (i !== end || count === 1) {
            if (i <= start && i > 1 && !increment) {
                i = parseFloat((i - 0.2).toFixed(2));
            }
            else if (i === 1) {
                i = 7;
                i = parseFloat((i + 0.2).toFixed(2));
                increment = true;
            }
            else if (i < 8 && increment) {
                i = parseFloat((i + 0.2).toFixed(2));
                if (i === 8) {
                    increment = false;
                }
            }
            else if (i <= 8 && !increment) {
                i = parseFloat((i - 0.2).toFixed(2));
            }
            ++count;
            formSeries(i);
        }
    }
    return series;
}
/**
 *
 * @param {HTMLElement} innerContainer - specifies the element
 * @returns {void}
 */
function animateBootstrap(innerContainer) {
    var svg = innerContainer.querySelector('svg.e-spin-bootstrap');
    var id = svg.getAttribute('id');
    for (var i = 1; i <= 8; i++) {
        var circleEle = (innerContainer.getElementsByClassName('e-path-circle_' +
            (i === 8 ? 0 : i))[0]);
        rotation(circleEle, i, i, generateSeries(i, i), id);
    }
    /**
     *
     * @param {SVGCircleElement} circle - specifies the circl element
     * @param {number} start - specifies the number
     * @param {number} end - specifies the end number
     * @param {number} series - specifies the series
     * @param {string} id - specifies the id
     * @returns {void}
     */
    function rotation(circle, start, end, series, id) {
        var count = 0;
        boot_animate(start);
        // eslint-disable-next-line
        function boot_animate(radius) {
            if (globalTimeOut[id].isAnimate) {
                ++count;
                circle.setAttribute('r', radius + '');
                if (count >= series.length) {
                    count = 0;
                }
                // eslint-disable-next-line
                globalTimeOut[id].timeOut = setTimeout(boot_animate.bind(null, series[count]), 18);
            }
        }
    }
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {string} template - specifies the template
 * @param {string} cssClass - specifies the css class.
 * @returns {void}
 */
function replaceContent(container, template, cssClass) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(cssClass)) {
        container.classList.add(cssClass);
    }
    var inner = container.querySelector('.e-spinner-inner');
    inner.innerHTML = template;
}
/**
 *
 * @param {string} width - specifies the width
 * @param {string} theme - specifies the string
 * @returns {number} - returns the number
 */
function calculateRadius(width, theme) {
    var defaultSize;
    switch (theme) {
        case 'Material':
            defaultSize = DEFT_MAT_WIDTH;
            break;
        case 'Fabric':
            defaultSize = DEFT_FAB_WIDTH;
            break;
        case 'Tailwind':
        case 'Tailwind-dark':
            defaultSize = DEFT_FAB_WIDTH;
            break;
        case 'Fluent':
            defaultSize = DEFT_FLUENT_WIDTH;
            break;
        case 'Bootstrap4':
            defaultSize = DEFT_BOOT4_WIDTH;
            break;
        case 'Bootstrap5':
            defaultSize = DEFT_BOOT5_WIDTH;
            break;
        default:
            defaultSize = DEFT_BOOT_WIDTH;
    }
    width = width ? parseFloat(width + '') : defaultSize;
    return theme === 'Bootstrap' ? width : width / 2;
}
/**
 *
 * @param {string} id - specifies the id
 * @param {number} radius - specifies the radius
 * @param {number} count - specifies the number count
 * @param {number} previousId - specifies the previous id
 * @returns {GlobalVariables} - returns the variables
 */
function globalVariables(id, radius, count, previousId) {
    return {
        radius: radius,
        count: count,
        previousId: previousId
    };
}
/**
 * @returns {string} - returns the string
 */
// eslint-disable-next-line
function random_generator() {
    var random = '';
    var combine = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < 5; i++) {
        random += combine.charAt(Math.floor(Math.random() * combine.length));
    }
    return random;
}
/**
 *
 * @param {HTMLElement} innerCon - specifies the element
 * @param {string} uniqueID - specifies the unique id
 * @param {string} themeClass - specifies the string
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */
// eslint-disable-next-line
function create_fabric_element(innerCon, uniqueID, themeClass, makeElement) {
    var svgFabric = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svgFabric.setAttribute('id', uniqueID);
    svgFabric.setAttribute('class', themeClass);
    var fabricCirclePath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    fabricCirclePath.setAttribute('class', CLS_SPINCIRCLE);
    var fabricCircleArc = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    fabricCircleArc.setAttribute('class', CLS_SPINARC);
    innerCon.insertBefore(svgFabric, innerCon.firstChild);
    svgFabric.appendChild(fabricCirclePath);
    svgFabric.appendChild(fabricCircleArc);
}
/**
 *
 * @param {HTMLElement} innerContainer - specifies the element
 * @param {string} uniqueID - specifies the unique id
 * @param {createElementParams} makeElement - specifies the element
 * @param {string} cls - specifies the string
 * @returns {void}
 */
// eslint-disable-next-line
function create_material_element(innerContainer, uniqueID, makeElement, cls) {
    var svgMaterial = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var matCirclePath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    svgMaterial.setAttribute('class', cls);
    svgMaterial.setAttribute('id', uniqueID);
    matCirclePath.setAttribute('class', CLS_SPINCIRCLE);
    innerContainer.insertBefore(svgMaterial, innerContainer.firstChild);
    svgMaterial.appendChild(matCirclePath);
}
/**
 *
 * @param {HTMLElement} target - specifies the element
 * @param {createElementParams} makeElement - specifies the element
 * @returns {void}
 */
// eslint-disable-next-line
function create_spinner_container(target, makeElement) {
    var spinnerContainer = makeElement('div', {});
    var spinnerInnerContainer = makeElement('div', {});
    spinnerContainer.classList.add(CLS_SPINWRAP);
    spinnerInnerContainer.classList.add(CLS_SPININWRAP);
    target.appendChild(spinnerContainer);
    spinnerContainer.appendChild(spinnerInnerContainer);
    // eslint-disable-next-line
    return { wrap: spinnerContainer, inner_wrap: spinnerInnerContainer };
}
/**
 *
 * @param {SpinnerInfo} spinnerInfo - specifies the spinner
 * @returns {void}
 */
function animateMaterial(spinnerInfo) {
    var start = 1;
    var end = 149;
    var duration = 1333;
    var max = 75;
    createCircle(start, end, easeAnimation, duration, spinnerInfo.globalInfo[spinnerInfo.uniqueID].count, max, spinnerInfo);
    spinnerInfo.globalInfo[spinnerInfo.uniqueID].count = ++spinnerInfo.globalInfo[spinnerInfo.uniqueID].count % 4;
}
/**
 *
 * @param {number} start - specifies the number
 * @param {number} end - specifies the end number
 * @param {Function} easing - specifies the function
 * @param {number} duration - specifies the duration
 * @param {number} count - specifies the count
 * @param {number} max - specifies the max number
 * @param {SpinnerInfo} spinnerInfo - specifies the spinner info
 * @returns {void}
 */
// eslint-disable-next-line
function createCircle(start, end, easing, duration, count, max, spinnerInfo) {
    var id = ++spinnerInfo.globalInfo[spinnerInfo.uniqueID].previousId;
    var startTime = new Date().getTime();
    var change = end - start;
    var diameter = getSize((spinnerInfo.globalInfo[spinnerInfo.uniqueID].radius * 2) + '');
    var strokeSize = getStrokeSize(diameter);
    var rotate = -90 * (spinnerInfo.globalInfo[spinnerInfo.uniqueID].count || 0);
    mat_animation(spinnerInfo);
    // eslint-disable-next-line
    function mat_animation(spinnerInfo) {
        var currentTime = Math.max(0, Math.min(new Date().getTime() - startTime, duration));
        updatePath(easing(currentTime, start, change, duration), spinnerInfo.container);
        if (id === spinnerInfo.globalInfo[spinnerInfo.uniqueID].previousId && currentTime < duration) {
            // eslint-disable-next-line
            globalTimeOut[spinnerInfo.uniqueID].timeOut = setTimeout(mat_animation.bind(null, spinnerInfo), 1);
        }
        else {
            animateMaterial(spinnerInfo);
        }
    }
    /**
     *
     * @param {number} value - specifies the number value
     * @param {HTMLElement} container - specifies the container
     * @returns {void}
     */
    function updatePath(value, container) {
        if ((!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(container.querySelector('svg.e-spin-material')))
            && (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(container.querySelector('svg.e-spin-material').querySelector('path.e-path-circle')))) {
            var svg = container.querySelector('svg.e-spin-material');
            var path = svg.querySelector('path.e-path-circle');
            path.setAttribute('stroke-dashoffset', getDashOffset(diameter, strokeSize, value, max) + '');
            path.setAttribute('transform', 'rotate(' + (rotate) + ' ' + diameter / 2 + ' ' + diameter / 2 + ')');
        }
    }
}
/**
 *
 * @param {number} radius - specifies the number
 * @param {HTMLElement} container - specifies the element
 * @param {string} type - specifies the string type
 * @param {string} cls - specifies the string
 * @returns {void}
 */
// eslint-disable-next-line
function mat_calculate_attributes(radius, container, type, cls) {
    var diameter = radius * 2;
    var svg = container.querySelector('svg.' + cls);
    var path = svg.querySelector('path.e-path-circle');
    var strokeSize = getStrokeSize(diameter);
    var transformOrigin = (diameter / 2) + 'px';
    svg.setAttribute('viewBox', '0 0 ' + diameter + ' ' + diameter);
    svg.style.width = svg.style.height = diameter + 'px';
    svg.style.transformOrigin = transformOrigin + ' ' + transformOrigin + ' ' + transformOrigin;
    path.setAttribute('d', drawArc(diameter, strokeSize));
    if (type === 'Material') {
        path.setAttribute('stroke-width', strokeSize + '');
        path.setAttribute('stroke-dasharray', ((diameter - strokeSize) * Math.PI * 0.75) + '');
        path.setAttribute('stroke-dashoffset', getDashOffset(diameter, strokeSize, 1, 75) + '');
    }
}
/**
 *
 * @param {string} value - specifies the value
 * @returns {number} - returns the number
 */
function getSize(value) {
    var parsed = parseFloat(value);
    return parsed;
}
/**
 *
 * @param {number} diameter - specifies the diameter
 * @param {number} strokeSize - specifies the size
 * @returns {string} - returns the string
 */
function drawArc(diameter, strokeSize) {
    var radius = diameter / 2;
    var offset = strokeSize / 2;
    return 'M' + radius + ',' + offset
        + 'A' + (radius - offset) + ',' + (radius - offset) + ' 0 1 1 ' + offset + ',' + radius;
}
/**
 *
 * @param {number} diameter - specifies the number
 * @returns {number} - returns the number
 */
function getStrokeSize(diameter) {
    return 10 / 100 * diameter;
}
/**
 *
 * @param {number} diameter - specifies the number
 * @param {number} strokeSize - specifies the stroke size
 * @param {number} value - specifies the value
 * @param {number} max - specifies the max number
 * @returns {number} - returns the number
 */
function getDashOffset(diameter, strokeSize, value, max) {
    return (diameter - strokeSize) * Math.PI * ((3 * (max) / 100) - (value / 100));
}
/**
 *
 * @param {number} current - specifies the number
 * @param {number} start - specifies the stroke size
 * @param {number} change - specifies the value
 * @param {number} duration - specifies the max number
 * @returns {number} - returns the number
 */
function easeAnimation(current, start, change, duration) {
    var timestamp = (current /= duration) * current;
    var timecount = timestamp * current;
    return start + change * (6 * timecount * timestamp + -15 * timestamp * timestamp + 10 * timecount);
}
/**
 *
 * @param {number} radius - specifies the number
 * @param {HTMLElement} innerConainer - specifies the element
 * @param {string} trgClass - specifies the class
 * @returns {void}
 */
// eslint-disable-next-line
function fb_calculate_attributes(radius, innerConainer, trgClass) {
    var centerX = radius;
    var centerY = radius;
    var diameter = radius * 2;
    // eslint-disable-next-line
    var startArc = 315, endArc = 45;
    var svg = innerConainer.querySelector('.' + trgClass);
    var circle = svg.querySelector('.e-path-circle');
    var path = svg.querySelector('.e-path-arc');
    var transformOrigin = (diameter / 2) + 'px';
    circle.setAttribute('d', defineCircle(centerX, centerY, radius));
    path.setAttribute('d', defineArc(centerX, centerY, radius, startArc, endArc));
    svg.setAttribute('viewBox', '0 0 ' + diameter + ' ' + diameter);
    svg.style.transformOrigin = transformOrigin + ' ' + transformOrigin + ' ' + transformOrigin;
    svg.style.width = svg.style.height = diameter + 'px';
}
/**
 *
 * @param {number} centerX - specifies the number
 * @param {number} centerY - specifies the stroke size
 * @param {number} radius - specifies the value
 * @param {number} angle - specifies the max number
 * @returns {number} - returns the number
 */
function defineArcPoints(centerX, centerY, radius, angle) {
    var radians = (angle - 90) * Math.PI / 180.0;
    return {
        x: centerX + (radius * Math.cos(radians)),
        y: centerY + (radius * Math.sin(radians))
    };
}
/**
 *
 * @param {number} x - specifies the number
 * @param {number} y - specifies the stroke size
 * @param {number} radius - specifies the radius
 * @param {number} startArc - specifies the value
 * @param {number} endArc - specifies the max number
 * @returns {number} - returns the number
 */
function defineArc(x, y, radius, startArc, endArc) {
    var start = defineArcPoints(x, y, radius, endArc);
    var end = defineArcPoints(x, y, radius, startArc);
    var d = [
        'M', start.x, start.y,
        'A', radius, radius, 0, 0, 0, end.x, end.y
    ].join(' ');
    return d;
}
/**
 *
 * @param {number} x - specifies the number
 * @param {number} y - specifies the stroke size
 * @param {number} radius - specifies the value
 * @returns {string} - returns the string
 */
function defineCircle(x, y, radius) {
    var d = [
        'M', x, y,
        'm', -radius, 0,
        'a', radius, radius, 0, 1, 0, radius * 2, 0,
        'a', radius, radius, 0, 1, 0, -radius * 2, 0
    ].join(' ');
    return d;
}
// eslint-disable-next-line
/**
 * Function to show the Spinner.
 *
 * @param {HTMLElement} container - Specify the target of the Spinner.
 * @returns {void}
 * @private
 */
function showSpinner(container) {
    showHideSpinner(container, false);
    container = null;
}
/**
 *
 * @param {HTMLElement} container - specifies the element
 * @param {boolean} isHide - specifies the boolean
 * @returns {void}
 */
function showHideSpinner(container, isHide) {
    var spinnerWrap;
    if (container) {
        spinnerWrap = container.classList.contains(CLS_SPINWRAP) ? container :
            container.querySelector('.' + CLS_SPINWRAP);
    }
    if (container && spinnerWrap) {
        var inner = spinnerWrap.querySelector('.' + CLS_SPININWRAP);
        var spinCheck = void 0;
        // eslint-disable-next-line
        spinCheck = isHide ? !spinnerWrap.classList.contains(CLS_SPINTEMPLATE) && !spinnerWrap.classList.contains(CLS_HIDESPIN) :
            !spinnerWrap.classList.contains(CLS_SPINTEMPLATE) && !spinnerWrap.classList.contains(CLS_SHOWSPIN);
        if (spinCheck) {
            var svgEle = spinnerWrap.querySelector('svg');
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(svgEle)) {
                return;
            }
            var id = svgEle.getAttribute('id');
            globalTimeOut[id].isAnimate = !isHide;
            switch (globalTimeOut[id].type) {
                case 'Material':
                    // eslint-disable-next-line
                    isHide ? clearTimeout(globalTimeOut[id].timeOut) : startMatAnimate(inner, id, globalTimeOut[id].radius);
                    break;
                case 'Bootstrap':
                    // eslint-disable-next-line
                    isHide ? clearTimeout(globalTimeOut[id].timeOut) : animateBootstrap(inner);
                    break;
            }
        }
        // eslint-disable-next-line
        isHide ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["x" /* classList */])(spinnerWrap, [CLS_HIDESPIN], [CLS_SHOWSPIN]) : Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["x" /* classList */])(spinnerWrap, [CLS_SHOWSPIN], [CLS_HIDESPIN]);
        container = null;
    }
}
/**
 * Function to hide the Spinner.
 *
 * @param {HTMLElement} container - Specify the target of the Spinner.
 * @returns {void}
 * @private
 */
function hideSpinner(container) {
    showHideSpinner(container, true);
    container = null;
}
// eslint-disable-next-line
/**
  * Function to change the Spinners in a page globally from application end.
  * ```
  * E.g : setSpinner({ cssClass: 'custom-css'; type: 'Material' });
  * ```
  *
  * @param {SetSpinnerArgs} args - specifies the args
  * @param {createElementParams} internalCreateElement - specifies the element params
  * @returns {void}
  * @private
  */
function setSpinner(args, internalCreateElement) {
    var makeElement = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(internalCreateElement) ? internalCreateElement : __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */];
    if (args.template !== undefined) {
        spinTemplate = args.template;
        if (args.template !== undefined) {
            spinCSSClass = args.cssClass;
        }
    }
    var container = document.querySelectorAll('.' + CLS_SPINWRAP);
    for (var index = 0; index < container.length; index++) {
        ensureTemplate(args.template, container[index], args.type, args.cssClass, makeElement);
    }
}
/**
 *
 * @param {string} template - specifies the string
 * @param {HTMLElement} container - specifies the container
 * @param {string} theme - specifies the theme
 * @param {string} cssClass - specifies the string class
 * @param {createElementParams} makeEle - specifies the params
 * @returns {void}
 */
function ensureTemplate(template, container, theme, cssClass, makeEle) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(template) && !container.classList.contains(CLS_SPINTEMPLATE)) {
        replaceTheme(container, theme, cssClass, makeEle);
        if (container.classList.contains(CLS_SHOWSPIN)) {
            container.classList.remove(CLS_SHOWSPIN);
            showSpinner(container);
        }
        else {
            container.classList.remove(CLS_HIDESPIN);
            hideSpinner(container);
        }
    }
    else {
        spinTemplate = template;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(cssClass)) {
            spinCSSClass = cssClass;
        }
    }
}
/**
 *
 * @param {HTMLElement} container - specifies the container
 * @param {string} theme - specifies the theme
 * @param {string} cssClass - specifies the string class
 * @param {createElementParams} makeEle - specifies the params
 * @returns {void}
 */
function replaceTheme(container, theme, cssClass, makeEle) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(cssClass)) {
        container.classList.add(cssClass);
    }
    var svgElement = container.querySelector('svg');
    var radius = theme === 'Bootstrap' ? parseFloat(svgElement.style.height) : parseFloat(svgElement.style.height) / 2;
    var classNames = svgElement.getAttribute('class');
    var svgClassList = classNames.split(/\s/);
    if (svgClassList.indexOf('e-spin-material') >= 0) {
        var id = svgElement.getAttribute('id');
        clearTimeout(globalTimeOut[id].timeOut);
    }
    setTheme(theme, container, radius, makeEle);
}


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toolbar__ = __webpack_require__(85);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__toolbar__["a"]; });
/**
 * Toolbar modules
 */



/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accordion__ = __webpack_require__(246);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__accordion__["a"]; });
/**
 * Accordion all modules
 */



/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AccordionActionSettings */
/* unused harmony export AccordionAnimationSettings */
/* unused harmony export AccordionItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Accordion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */






var CLS_ACRDN_ROOT = 'e-acrdn-root';
var CLS_ROOT = 'e-accordion';
var CLS_ITEM = 'e-acrdn-item';
var CLS_ITEMFOCUS = 'e-item-focus';
var CLS_ITEMHIDE = 'e-hide';
var CLS_HEADER = 'e-acrdn-header';
var CLS_HEADERICN = 'e-acrdn-header-icon';
var CLS_HEADERCTN = 'e-acrdn-header-content';
var CLS_CONTENT = 'e-acrdn-panel';
var CLS_CTENT = 'e-acrdn-content';
var CLS_TOOGLEICN = 'e-toggle-icon';
var CLS_COLLAPSEICN = 'e-tgl-collapse-icon e-icons';
var CLS_EXPANDICN = 'e-expand-icon';
var CLS_RTL = 'e-rtl';
var CLS_CTNHIDE = 'e-content-hide';
var CLS_SLCT = 'e-select';
var CLS_SLCTED = 'e-selected';
var CLS_ACTIVE = 'e-active';
var CLS_ANIMATE = 'e-animate';
var CLS_DISABLE = 'e-overlay';
var CLS_TOGANIMATE = 'e-toggle-animation';
var CLS_NEST = 'e-nested';
var CLS_EXPANDSTATE = 'e-expand-state';
var CLS_CONTAINER = 'e-accordion-container';
/**
 * Objects used for configuring the Accordion expanding item action properties.
 */
var AccordionActionSettings = /** @class */ (function (_super) {
    __extends(AccordionActionSettings, _super);
    function AccordionActionSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('SlideDown')
    ], AccordionActionSettings.prototype, "effect", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(400)
    ], AccordionActionSettings.prototype, "duration", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('linear')
    ], AccordionActionSettings.prototype, "easing", void 0);
    return AccordionActionSettings;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * Objects used for configuring the Accordion animation properties.
 */
var AccordionAnimationSettings = /** @class */ (function (_super) {
    __extends(AccordionAnimationSettings, _super);
    function AccordionAnimationSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({ effect: 'SlideUp', duration: 400, easing: 'linear' }, AccordionActionSettings)
    ], AccordionAnimationSettings.prototype, "collapse", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({ effect: 'SlideDown', duration: 400, easing: 'linear' }, AccordionActionSettings)
    ], AccordionAnimationSettings.prototype, "expand", void 0);
    return AccordionAnimationSettings;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * An item object that is used to configure Accordion items.
 */
var AccordionItem = /** @class */ (function (_super) {
    __extends(AccordionItem, _super);
    function AccordionItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], AccordionItem.prototype, "content", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], AccordionItem.prototype, "header", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], AccordionItem.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], AccordionItem.prototype, "iconCss", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], AccordionItem.prototype, "expanded", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], AccordionItem.prototype, "visible", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], AccordionItem.prototype, "disabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], AccordionItem.prototype, "id", void 0);
    return AccordionItem;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * The Accordion is a vertically collapsible content panel that displays one or more panels at a time within the available space.
 * ```html
 * <div id='accordion'/>
 * <script>
 *   var accordionObj = new Accordion();
 *   accordionObj.appendTo('#accordion');
 * </script>
 * ```
 */
var Accordion = /** @class */ (function (_super) {
    __extends(Accordion, _super);
    /**
     * Initializes a new instance of the Accordion class.
     *
     * @param {AccordionModel} options  - Specifies Accordion model properties as options.
     * @param {string | HTMLElement} element  - Specifies the element that is rendered as an Accordion.
     */
    function Accordion(options, element) {
        var _this = _super.call(this, options, element) || this;
        /**
         * Contains the keyboard configuration of the Accordion.
         */
        _this.keyConfigs = {
            moveUp: 'uparrow',
            moveDown: 'downarrow',
            enter: 'enter',
            space: 'space',
            home: 'home',
            end: 'end'
        };
        return _this;
    }
    /**
     * Removes the control from the DOM and also removes all its related events.
     *
     * @returns {void}
     */
    Accordion.prototype.destroy = function () {
        var _this = this;
        if (this.isReact || this.isAngular || this.isVue) {
            this.clearTemplate();
        }
        var ele = this.element;
        _super.prototype.destroy.call(this);
        this.unwireEvents();
        this.isDestroy = true;
        this.restoreContent(null);
        [].slice.call(ele.children).forEach(function (el) {
            ele.removeChild(el);
        });
        if (this.trgtEle) {
            this.trgtEle = null;
            while (this.ctrlTem.firstElementChild) {
                ele.appendChild(this.ctrlTem.firstElementChild);
            }
            this.ctrlTem = null;
        }
        ele.classList.remove(CLS_ACRDN_ROOT);
        ele.removeAttribute('style');
        ['aria-disabled', 'aria-multiselectable', 'role', 'data-ripple'].forEach(function (attrb) {
            _this.element.removeAttribute(attrb);
        });
        if (!this.isNested && __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["R" /* isRippleEnabled */]) {
            this.removeRippleEffect();
        }
    };
    Accordion.prototype.preRender = function () {
        var nested = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, '.' + CLS_CONTENT);
        this.isNested = false;
        this.templateEle = [];
        if (!this.isDestroy) {
            this.isDestroy = false;
        }
        if (nested && nested.firstElementChild && nested.firstElementChild.firstElementChild) {
            if (nested.firstElementChild.firstElementChild.classList.contains(CLS_ROOT)) {
                nested.classList.add(CLS_NEST);
                this.isNested = true;
            }
        }
        else {
            this.element.classList.add(CLS_ACRDN_ROOT);
        }
        if (this.enableRtl) {
            this.add(this.element, CLS_RTL);
        }
    };
    Accordion.prototype.add = function (ele, val) {
        ele.classList.add(val);
    };
    Accordion.prototype.remove = function (ele, val) {
        ele.classList.remove(val);
    };
    /**
     * To initialize the control rendering
     *
     * @private
     * @returns {void}
     */
    Accordion.prototype.render = function () {
        this.initializeHeaderTemplate();
        this.initializeItemTemplate();
        this.initialize();
        this.renderControl();
        this.wireEvents();
        this.renderComplete();
    };
    Accordion.prototype.initialize = function () {
        var width = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.width);
        var height = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.height);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'width': width, 'height': height });
        var ariaAttr = {
            'aria-disabled': 'false', 'role': 'presentation', 'aria-multiselectable': 'true'
        };
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.initExpand)) {
            this.initExpand = [];
        }
        if (this.expandedIndices.length > 0) {
            this.initExpand = this.expandedIndices;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, ariaAttr);
        if (this.expandMode === 'Single') {
            this.element.setAttribute('aria-multiselectable', 'false');
        }
    };
    Accordion.prototype.renderControl = function () {
        this.trgtEle = (this.element.children.length > 0) ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('div', this.element) : null;
        this.renderItems();
        this.initItemExpand();
    };
    Accordion.prototype.wireFocusEvents = function () {
        var acrdItem = [].slice.call(this.element.querySelectorAll('.' + CLS_ITEM));
        for (var _i = 0, acrdItem_1 = acrdItem; _i < acrdItem_1.length; _i++) {
            var item = acrdItem_1[_i];
            var headerEle = item.querySelector('.' + CLS_HEADER);
            if (item.childElementCount > 0 && headerEle) {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].clearEvents(headerEle);
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(headerEle, 'focus', this.focusIn, this);
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(headerEle, 'blur', this.focusOut, this);
            }
        }
    };
    Accordion.prototype.unwireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'click', this.clickHandler);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.keyModule)) {
            this.keyModule.destroy();
        }
    };
    Accordion.prototype.wireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'click', this.clickHandler, this);
        if (!this.isNested && !this.isDestroy) {
            this.removeRippleEffect = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_0" /* rippleEffect */])(this.element, { selector: '.' + CLS_HEADER });
        }
        if (!this.isNested) {
            this.keyModule = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["n" /* KeyboardEvents */](this.element, {
                keyAction: this.keyActionHandler.bind(this),
                keyConfigs: this.keyConfigs,
                eventName: 'keydown'
            });
        }
    };
    Accordion.prototype.templateParser = function (template) {
        if (template) {
            try {
                if (document.querySelectorAll(template).length) {
                    return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(document.querySelector(template).innerHTML.trim());
                }
                else {
                    return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(template);
                }
            }
            catch (error) {
                return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(template);
            }
        }
        return undefined;
    };
    Accordion.prototype.initializeHeaderTemplate = function () {
        if (this.headerTemplate) {
            this.headerTemplateFn = this.templateParser(this.headerTemplate);
        }
    };
    Accordion.prototype.initializeItemTemplate = function () {
        if (this.itemTemplate) {
            this.itemTemplateFn = this.templateParser(this.itemTemplate);
        }
    };
    Accordion.prototype.getHeaderTemplate = function () {
        return this.headerTemplateFn;
    };
    Accordion.prototype.getItemTemplate = function () {
        return this.itemTemplateFn;
    };
    Accordion.prototype.focusIn = function (e) {
        e.target.parentElement.classList.add(CLS_ITEMFOCUS);
    };
    Accordion.prototype.focusOut = function (e) {
        e.target.parentElement.classList.remove(CLS_ITEMFOCUS);
    };
    Accordion.prototype.ctrlTemplate = function () {
        this.ctrlTem = this.element.cloneNode(true);
        var innerEles;
        var rootEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_CONTAINER, this.element);
        if (rootEle) {
            innerEles = rootEle.children;
        }
        else {
            innerEles = this.element.children;
        }
        var items = [];
        [].slice.call(innerEles).forEach(function (el) {
            items.push({
                header: (el.childElementCount > 0 && el.children[0]) ? (el.children[0]) : '',
                content: (el.childElementCount > 1 && el.children[1]) ? (el.children[1]) : ''
            });
            el.parentNode.removeChild(el);
        });
        if (rootEle) {
            this.element.removeChild(rootEle);
        }
        this.setProperties({ items: items }, true);
    };
    Accordion.prototype.toggleIconGenerate = function () {
        var tglIcon = this.createElement('div', { className: CLS_TOOGLEICN });
        var hdrColIcon = this.createElement('span', { className: CLS_COLLAPSEICN });
        tglIcon.appendChild(hdrColIcon);
        return tglIcon;
    };
    Accordion.prototype.initItemExpand = function () {
        var len = this.initExpand.length;
        if (len === 0) {
            return;
        }
        if (this.expandMode === 'Single') {
            this.expandItem(true, this.initExpand[len - 1]);
        }
        else {
            for (var i = 0; i < len; i++) {
                this.expandItem(true, this.initExpand[i]);
            }
        }
        if (this.isReact) {
            this.renderReactTemplates();
        }
    };
    Accordion.prototype.renderItems = function () {
        var _this = this;
        var ele = this.element;
        var innerItem;
        var innerDataSourceItem;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.trgtEle)) {
            this.ctrlTemplate();
        }
        if (this.dataSource.length > 0) {
            this.dataSource.forEach(function (item, index) {
                innerDataSourceItem = _this.renderInnerItem(item, index);
                ele.appendChild(innerDataSourceItem);
                if (innerDataSourceItem.childElementCount > 0) {
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(innerDataSourceItem.querySelector('.' + CLS_HEADER), 'focus', _this.focusIn, _this);
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(innerDataSourceItem.querySelector('.' + CLS_HEADER), 'blur', _this.focusOut, _this);
                }
            });
        }
        else {
            var items = this.items;
            if (ele && items.length > 0) {
                items.forEach(function (item, index) {
                    innerItem = _this.renderInnerItem(item, index);
                    ele.appendChild(innerItem);
                    if (innerItem.childElementCount > 0) {
                        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(innerItem.querySelector('.' + CLS_HEADER), 'focus', _this.focusIn, _this);
                        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(innerItem.querySelector('.' + CLS_HEADER), 'blur', _this.focusOut, _this);
                    }
                });
            }
        }
        if (this.isReact) {
            this.renderReactTemplates();
        }
    };
    Accordion.prototype.clickHandler = function (e) {
        var trgt = e.target;
        var items = this.getItems();
        var eventArgs = {};
        var tglIcon;
        var acrdEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '.' + CLS_ROOT);
        if (acrdEle !== this.element) {
            return;
        }
        trgt.classList.add('e-target');
        var acrdnItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '.' + CLS_ITEM);
        var acrdnHdr = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '.' + CLS_HEADER);
        var acrdnCtn = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '.' + CLS_CONTENT);
        if (acrdnItem && (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(acrdnHdr) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(acrdnCtn))) {
            acrdnHdr = acrdnItem.children[0];
            acrdnCtn = acrdnItem.children[1];
        }
        if (acrdnHdr) {
            tglIcon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TOOGLEICN, acrdnHdr);
        }
        var acrdnCtnItem;
        if (acrdnHdr) {
            acrdnCtnItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(acrdnHdr, '.' + CLS_ITEM);
        }
        else if (acrdnCtn) {
            acrdnCtnItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(acrdnCtn, '.' + CLS_ITEM);
        }
        var index = this.getIndexByItem(acrdnItem);
        if (acrdnCtnItem) {
            eventArgs.item = items[this.getIndexByItem(acrdnCtnItem)];
        }
        eventArgs.originalEvent = e;
        var ctnCheck = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(tglIcon) && acrdnItem.childElementCount <= 1;
        if (ctnCheck && (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(acrdnCtn) || !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_HEADER + ' .' + CLS_TOOGLEICN, acrdnCtnItem)))) {
            acrdnItem.appendChild(this.contentRendering(index));
            this.ariaAttrUpdate(acrdnItem);
            this.afterContentRender(trgt, eventArgs, acrdnItem, acrdnHdr, acrdnCtn, acrdnCtnItem);
        }
        else {
            this.afterContentRender(trgt, eventArgs, acrdnItem, acrdnHdr, acrdnCtn, acrdnCtnItem);
        }
        if (this.isReact) {
            this.renderReactTemplates();
        }
    };
    Accordion.prototype.afterContentRender = function (trgt, eventArgs, acrdnItem, acrdnHdr, acrdnCtn, acrdnCtnItem) {
        var _this = this;
        var acrdActive = [];
        this.trigger('clicked', eventArgs);
        var cntclkCheck = (acrdnCtn && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-target', acrdnCtn)));
        var inlineAcrdnSel = '.' + CLS_CONTENT + ' .' + CLS_ROOT;
        var inlineEleAcrdn = acrdnCtn && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_ROOT, acrdnCtn)) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, inlineAcrdnSel));
        var nestContCheck = acrdnCtn && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_ROOT, acrdnCtn)) || !(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '.' + CLS_ROOT) === this.element);
        cntclkCheck = cntclkCheck && (inlineEleAcrdn || nestContCheck);
        trgt.classList.remove('e-target');
        if (trgt.classList.contains(CLS_CONTENT) || trgt.classList.contains(CLS_CTENT) || cntclkCheck) {
            return;
        }
        var acrdcontainer = this.element.querySelector('.' + CLS_CONTAINER);
        var acrdnchild = (acrdcontainer) ? acrdcontainer.children : this.element.children;
        [].slice.call(acrdnchild).forEach(function (el) {
            if (el.classList.contains(CLS_ACTIVE)) {
                acrdActive.push(el);
            }
        });
        var acrdAniEle = [].slice.call(this.element.querySelectorAll('.' + CLS_ITEM + ' [' + CLS_ANIMATE + ']'));
        if (acrdAniEle.length > 0) {
            for (var _i = 0, acrdAniEle_1 = acrdAniEle; _i < acrdAniEle_1.length; _i++) {
                var el = acrdAniEle_1[_i];
                acrdActive.push(el.parentElement);
            }
        }
        var sameContentCheck = acrdActive.indexOf(acrdnCtnItem) !== -1 && acrdnCtn.getAttribute('e-animate') === 'true';
        var sameHeader = false;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(acrdnItem) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(acrdnHdr)) {
            var acrdnCtn_1 = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_CONTENT, acrdnItem);
            var acrdnRoot = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(acrdnItem, '.' + CLS_ACRDN_ROOT);
            var expandState = acrdnRoot.querySelector('.' + CLS_EXPANDSTATE);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(acrdnCtn_1)) {
                return;
            }
            sameHeader = (expandState === acrdnItem);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(acrdnCtn_1) && (!sameContentCheck || acrdnCtnItem.classList.contains(CLS_SLCTED))) {
                this.collapse(acrdnCtn_1);
            }
            else {
                if ((acrdActive.length > 0) && this.expandMode === 'Single' && !sameContentCheck) {
                    acrdActive.forEach(function (el) {
                        _this.collapse(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_CONTENT, el));
                        el.classList.remove(CLS_EXPANDSTATE);
                    });
                }
                this.expand(acrdnCtn_1);
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(expandState) && !sameHeader) {
                expandState.classList.remove(CLS_EXPANDSTATE);
            }
        }
    };
    Accordion.prototype.eleMoveFocus = function (action, root, trgt) {
        var clst;
        var clstItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '.' + CLS_ITEM);
        if (trgt === root) {
            clst = ((action === 'moveUp' ? trgt.lastElementChild : trgt).querySelector('.' + CLS_HEADER));
        }
        else if (trgt.classList.contains(CLS_HEADER)) {
            clstItem = (action === 'moveUp' ? clstItem.previousElementSibling : clstItem.nextElementSibling);
            if (clstItem) {
                clst = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_HEADER, clstItem);
            }
        }
        if (clst) {
            clst.focus();
        }
    };
    Accordion.prototype.keyActionHandler = function (e) {
        var trgt = e.target;
        var header = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, CLS_HEADER);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(header) && !trgt.classList.contains(CLS_ROOT) && !trgt.classList.contains(CLS_HEADER)) {
            return;
        }
        var clst;
        var root = this.element;
        var content;
        switch (e.action) {
            case 'moveUp':
                this.eleMoveFocus(e.action, root, trgt);
                break;
            case 'moveDown':
                this.eleMoveFocus(e.action, root, trgt);
                break;
            case 'space':
            case 'enter':
                content = trgt.nextElementSibling;
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(content) && content.classList.contains(CLS_CONTENT)) {
                    if (content.getAttribute('e-animate') !== 'true') {
                        trgt.click();
                    }
                }
                else {
                    trgt.click();
                }
                e.preventDefault();
                break;
            case 'home':
            case 'end':
                clst = e.action === 'home' ? root.firstElementChild.children[0] : root.lastElementChild.children[0];
                clst.focus();
                e.preventDefault();
                break;
        }
    };
    Accordion.prototype.headerEleGenerate = function () {
        var header = this.createElement('div', { className: CLS_HEADER, id: Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('acrdn_header') });
        var items = this.getItems();
        var ariaAttr = {
            'tabindex': '0', 'role': 'heading', 'aria-label': 'collapsed',
            'aria-disabled': 'false', 'aria-level': items.length.toString()
        };
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(header, ariaAttr);
        return header;
    };
    Accordion.prototype.renderInnerItem = function (item, index) {
        var innerEle = this.createElement('div', {
            className: CLS_ITEM, id: item.id || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('acrdn_item'),
            attrs: { 'aria-expanded': 'false', 'role': 'row' }
        });
        if (this.headerTemplate) {
            var ctnEle = this.headerEleGenerate();
            var hdrEle = this.createElement('div', { className: CLS_HEADERCTN });
            ctnEle.appendChild(hdrEle);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(this.getHeaderTemplate()(item, this, 'headerTemplate', this.element.id + '_headerTemplate', false), hdrEle);
            innerEle.appendChild(ctnEle);
            ctnEle.appendChild(this.toggleIconGenerate());
            this.add(innerEle, CLS_SLCT);
            return innerEle;
        }
        if (item.header && this.angularnativeCondiCheck(item, 'header')) {
            if (this.enableHtmlSanitizer && typeof (item.header) === 'string') {
                item.header = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(item.header);
            }
            var ctnEle = this.headerEleGenerate();
            var hdrEle = this.createElement('div', { className: CLS_HEADERCTN });
            ctnEle.appendChild(hdrEle);
            ctnEle.appendChild(this.fetchElement(hdrEle, item.header, index, true));
            innerEle.appendChild(ctnEle);
        }
        var hdr = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_HEADER, innerEle);
        if (item.expanded && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(index) && (!this.enablePersistence)) {
            if (this.initExpand.indexOf(index) === -1) {
                this.initExpand.push(index);
            }
        }
        if (item.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([innerEle], item.cssClass.split(' '));
        }
        if (item.disabled) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([innerEle], CLS_DISABLE);
        }
        if (item.visible === false) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([innerEle], CLS_ITEMHIDE);
        }
        if (item.iconCss) {
            var hdrIcnEle = this.createElement('div', { className: CLS_HEADERICN });
            var icon = this.createElement('span', { className: item.iconCss + ' e-icons' });
            hdrIcnEle.appendChild(icon);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(hdr)) {
                hdr = this.headerEleGenerate();
                hdr.appendChild(hdrIcnEle);
                innerEle.appendChild(hdr);
            }
            else {
                hdr.insertBefore(hdrIcnEle, hdr.childNodes[0]);
            }
        }
        if (item.content && this.angularnativeCondiCheck(item, 'content')) {
            var hdrIcon = this.toggleIconGenerate();
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(hdr)) {
                hdr = this.headerEleGenerate();
                innerEle.appendChild(hdr);
            }
            hdr.appendChild(hdrIcon);
            this.add(innerEle, CLS_SLCT);
        }
        return innerEle;
    };
    Accordion.prototype.angularnativeCondiCheck = function (item, prop) {
        var property = prop === 'content' ? item.content : item.header;
        var content = property;
        if (this.isAngular && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(content.elementRef)) {
            var data = content.elementRef.nativeElement.data;
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data) || data === '' || (data.indexOf('bindings=') === -1)) {
                return true;
            }
            var parseddata = JSON.parse(content.elementRef.nativeElement.data.replace('bindings=', ''));
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(parseddata) && parseddata['ng-reflect-ng-if'] === 'false') {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return true;
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Accordion.prototype.fetchElement = function (ele, value, index, isHeader) {
        var templateFn;
        var temString;
        try {
            if (document.querySelectorAll(value).length && value !== 'Button') {
                var eleVal = document.querySelector(value);
                temString = eleVal.outerHTML.trim();
                ele.appendChild(eleVal);
                eleVal.style.display = '';
            }
            else {
                templateFn = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(value);
            }
        }
        catch (e) {
            if (typeof (value) === 'string') {
                ele.innerHTML = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(value);
            }
            else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.trgtEle) && (value instanceof (HTMLElement))) {
                ele.appendChild(value);
                ele.firstElementChild.style.display = '';
            }
            else {
                templateFn = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(value);
            }
        }
        var tempArray;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(templateFn)) {
            if (this.isReact) {
                this.renderReactTemplates();
            }
            var templateProps = void 0;
            var templateName = void 0;
            if (ele.classList.contains(CLS_HEADERCTN)) {
                templateProps = this.element.id + index + '_header';
                templateName = 'header';
            }
            else if (ele.classList.contains(CLS_CTENT)) {
                templateProps = this.element.id + index + '_content';
                templateName = 'content';
            }
            tempArray = templateFn({}, this, templateName, templateProps, this.isStringTemplate);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(tempArray) && tempArray.length > 0 && !(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(tempArray[0].tagName) && tempArray.length === 1)) {
            [].slice.call(tempArray).forEach(function (el) {
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(el.tagName)) {
                    el.style.display = '';
                }
                ele.appendChild(el);
            });
        }
        else if (ele.childElementCount === 0) {
            ele.innerHTML = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(value);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(temString)) {
            if (this.templateEle.indexOf(value) === -1) {
                this.templateEle.push(value);
            }
        }
        return ele;
    };
    Accordion.prototype.ariaAttrUpdate = function (itemEle) {
        var header = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_HEADER, itemEle);
        var content = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_CONTENT, itemEle);
        header.setAttribute('aria-controls', content.id);
        content.setAttribute('aria-labelledby', header.id);
        content.setAttribute('role', 'definition');
    };
    Accordion.prototype.contentRendering = function (index) {
        var itemcnt = this.createElement('div', { className: CLS_CONTENT + ' ' + CLS_CTNHIDE, id: Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('acrdn_panel') });
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(itemcnt, { 'aria-hidden': 'true' });
        var ctn = this.createElement('div', { className: CLS_CTENT });
        if (this.dataSource.length > 0) {
            if (this.isReact) {
                this.renderReactTemplates();
            }
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(this.getItemTemplate()(this.dataSource[index], this, 'itemTemplate', this.element.id + '_itemTemplate', false), ctn);
            itemcnt.appendChild(ctn);
        }
        else {
            if (this.enableHtmlSanitizer && typeof (this.items[index].content)) {
                this.items[index].content = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(this.items[index].content);
            }
            itemcnt.appendChild(this.fetchElement(ctn, this.items[index].content, index, false));
        }
        return itemcnt;
    };
    Accordion.prototype.expand = function (trgt) {
        var _this = this;
        var items = this.getItems();
        var trgtItemEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '.' + CLS_ITEM);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(trgt) || (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(trgt) && trgt.getAttribute('e-animate') !== 'true') || trgtItemEle.classList.contains(CLS_DISABLE)) {
            return;
        }
        var acrdnRoot = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgtItemEle, '.' + CLS_ACRDN_ROOT);
        var expandState = acrdnRoot.querySelector('.' + CLS_EXPANDSTATE);
        var animation = {
            name: this.animation.expand.effect,
            duration: this.animation.expand.duration,
            timingFunction: this.animation.expand.easing
        };
        var icon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TOOGLEICN, trgtItemEle).firstElementChild;
        var eventArgs = {
            element: trgtItemEle,
            item: items[this.getIndexByItem(trgtItemEle)],
            index: this.getIndexByItem(trgtItemEle),
            content: trgtItemEle.querySelector('.' + CLS_CONTENT),
            isExpanded: true
        };
        this.trigger('expanding', eventArgs, function (expandArgs) {
            if (!expandArgs.cancel) {
                icon.classList.add(CLS_TOGANIMATE);
                _this.expandedItemsPush(trgtItemEle);
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(expandState)) {
                    expandState.classList.remove(CLS_EXPANDSTATE);
                }
                trgtItemEle.classList.add(CLS_EXPANDSTATE);
                if ((animation.name === 'None')) {
                    _this.expandProgress('begin', icon, trgt, trgtItemEle, expandArgs);
                    _this.expandProgress('end', icon, trgt, trgtItemEle, expandArgs);
                }
                else {
                    _this.expandAnimation(animation.name, icon, trgt, trgtItemEle, animation, expandArgs);
                }
            }
        });
    };
    Accordion.prototype.expandAnimation = function (ef, icn, trgt, trgtItemEle, animate, args) {
        var _this = this;
        var height;
        this.lastActiveItemId = trgtItemEle.id;
        if (ef === 'SlideDown') {
            animate.begin = function () {
                _this.expandProgress('begin', icn, trgt, trgtItemEle, args);
                trgt.style.position = 'absolute';
                height = trgtItemEle.offsetHeight;
                trgt.style.maxHeight = (trgt.offsetHeight) + 'px';
                trgtItemEle.style.maxHeight = '';
            };
            animate.progress = function () {
                trgtItemEle.style.minHeight = (height + trgt.offsetHeight) + 'px';
            };
            animate.end = function () {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(trgt, { 'position': '', 'maxHeight': '' });
                trgtItemEle.style.minHeight = '';
                _this.expandProgress('end', icn, trgt, trgtItemEle, args);
            };
        }
        else {
            animate.begin = function () {
                _this.expandProgress('begin', icn, trgt, trgtItemEle, args);
            };
            animate.end = function () {
                _this.expandProgress('end', icn, trgt, trgtItemEle, args);
            };
        }
        new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["b" /* Animation */](animate).animate(trgt);
    };
    Accordion.prototype.expandProgress = function (progress, icon, trgt, trgtItemEle, eventArgs) {
        this.remove(trgt, CLS_CTNHIDE);
        this.add(trgtItemEle, CLS_SLCTED);
        this.add(icon, CLS_EXPANDICN);
        if (progress === 'end') {
            this.add(trgtItemEle, CLS_ACTIVE);
            trgt.setAttribute('aria-hidden', 'false');
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(trgtItemEle, { 'aria-expanded': 'true' });
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(trgt.previousElementSibling, { 'aria-label': 'expanded' });
            icon.classList.remove(CLS_TOGANIMATE);
            this.trigger('expanded', eventArgs);
        }
    };
    Accordion.prototype.expandedItemsPush = function (item) {
        var index = this.getIndexByItem(item);
        if (this.expandedIndices.indexOf(index) === -1) {
            var temp = [].slice.call(this.expandedIndices);
            temp.push(index);
            this.setProperties({ expandedIndices: temp }, true);
        }
    };
    Accordion.prototype.getIndexByItem = function (item) {
        var itemEle = this.getItemElements();
        return [].slice.call(itemEle).indexOf(item);
    };
    Accordion.prototype.getItemElements = function () {
        var itemEle = [];
        var itemCollection = this.element.children;
        [].slice.call(itemCollection).forEach(function (el) {
            if (el.classList.contains(CLS_ITEM)) {
                itemEle.push(el);
            }
        });
        return itemEle;
    };
    Accordion.prototype.expandedItemsPop = function (item) {
        var index = this.getIndexByItem(item);
        var temp = [].slice.call(this.expandedIndices);
        temp.splice(temp.indexOf(index), 1);
        this.setProperties({ expandedIndices: temp }, true);
    };
    Accordion.prototype.collapse = function (trgt) {
        var _this = this;
        var items = this.getItems();
        var trgtItemEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trgt, '.' + CLS_ITEM);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(trgt) || !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(trgt) || trgtItemEle.classList.contains(CLS_DISABLE)) {
            return;
        }
        var animation = {
            name: this.animation.collapse.effect,
            duration: this.animation.collapse.duration,
            timingFunction: this.animation.collapse.easing
        };
        var icon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TOOGLEICN, trgtItemEle).firstElementChild;
        var eventArgs = {
            element: trgtItemEle,
            item: items[this.getIndexByItem(trgtItemEle)],
            index: this.getIndexByItem(trgtItemEle),
            content: trgtItemEle.querySelector('.' + CLS_CONTENT),
            isExpanded: false
        };
        this.trigger('expanding', eventArgs, function (expandArgs) {
            if (!expandArgs.cancel) {
                _this.expandedItemsPop(trgtItemEle);
                trgtItemEle.classList.remove(CLS_EXPANDSTATE);
                icon.classList.add(CLS_TOGANIMATE);
                if ((animation.name === 'None')) {
                    _this.collapseProgress('begin', icon, trgt, trgtItemEle, expandArgs);
                    _this.collapseProgress('end', icon, trgt, trgtItemEle, expandArgs);
                }
                else {
                    _this.collapseAnimation(animation.name, trgt, trgtItemEle, icon, animation, expandArgs);
                }
            }
        });
    };
    Accordion.prototype.collapseAnimation = function (ef, trgt, trgtItEl, icn, animate, args) {
        var _this = this;
        var height;
        var trgtHeight;
        var itemHeight;
        var remain;
        this.lastActiveItemId = trgtItEl.id;
        if (ef === 'SlideUp') {
            animate.begin = function () {
                itemHeight = trgtItEl.offsetHeight;
                trgtItEl.style.minHeight = itemHeight + 'px';
                trgt.style.position = 'absolute';
                height = trgtItEl.offsetHeight;
                trgtHeight = trgt.offsetHeight;
                trgt.style.maxHeight = trgtHeight + 'px';
                _this.collapseProgress('begin', icn, trgt, trgtItEl, args);
            };
            animate.progress = function () {
                remain = ((height - (trgtHeight - trgt.offsetHeight)));
                if (remain < itemHeight) {
                    trgtItEl.style.minHeight = remain + 'px';
                }
            };
            animate.end = function () {
                trgt.style.display = 'none';
                _this.collapseProgress('end', icn, trgt, trgtItEl, args);
                trgtItEl.style.minHeight = '';
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(trgt, { 'position': '', 'maxHeight': '', 'display': '' });
            };
        }
        else {
            animate.begin = function () {
                _this.collapseProgress('begin', icn, trgt, trgtItEl, args);
            };
            animate.end = function () {
                _this.collapseProgress('end', icn, trgt, trgtItEl, args);
            };
        }
        new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["b" /* Animation */](animate).animate(trgt);
    };
    Accordion.prototype.collapseProgress = function (progress, icon, trgt, trgtItemEle, eventArgs) {
        this.remove(icon, CLS_EXPANDICN);
        this.remove(trgtItemEle, CLS_SLCTED);
        if (progress === 'end') {
            this.add(trgt, CLS_CTNHIDE);
            icon.classList.remove(CLS_TOGANIMATE);
            this.remove(trgtItemEle, CLS_ACTIVE);
            trgt.setAttribute('aria-hidden', 'true');
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(trgtItemEle, { 'aria-expanded': 'false' });
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(trgt.previousElementSibling, { 'aria-label': 'collapsed' });
            this.trigger('expanded', eventArgs);
        }
    };
    /**
     * Returns the current module name.
     *
     * @returns {string} - It returns the current module name.
     * @private
     */
    Accordion.prototype.getModuleName = function () {
        return 'accordion';
    };
    Accordion.prototype.itemAttribUpdate = function () {
        var items = this.getItems();
        var itemEle = this.getItemElements();
        var itemLen = items.length;
        itemEle.forEach(function (ele) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_HEADER, ele).setAttribute('aria-level', '' + itemLen);
        });
    };
    Accordion.prototype.getItems = function () {
        var items;
        if (this.itemTemplate && this.headerTemplate) {
            items = this.dataSource;
        }
        else {
            items = this.items;
        }
        return items;
    };
    /**
     * Adds new item to the Accordion with the specified index of the Accordion.
     *
     * @param  {AccordionItemModel | AccordionItemModel[] | Object | Object[]} item - Item array that is to be added to the Accordion.
     * @param  {number} index - Number value that determines where the item should be added.
     * By default, item is added at the last index if the index is not specified.
     * @returns {void}
     */
    Accordion.prototype.addItem = function (item, index) {
        var _this = this;
        var ele = this.element;
        var itemEle = this.getItemElements();
        var items = this.getItems();
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(index)) {
            index = items.length;
        }
        if (ele.childElementCount >= index) {
            var addItems = (item instanceof Array) ? item : [item];
            addItems.forEach(function (addItem, i) {
                var itemIndex = index + i;
                items.splice(itemIndex, 0, addItem);
                var innerItemEle = _this.renderInnerItem(addItem, itemIndex);
                if (ele.childElementCount === itemIndex) {
                    ele.appendChild(innerItemEle);
                }
                else {
                    ele.insertBefore(innerItemEle, itemEle[itemIndex]);
                }
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(innerItemEle.querySelector('.' + CLS_HEADER), 'focus', _this.focusIn, _this);
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(innerItemEle.querySelector('.' + CLS_HEADER), 'blur', _this.focusOut, _this);
                _this.itemAttribUpdate();
                _this.expandedIndices = [];
                _this.expandedItemRefresh(ele);
                if (addItem && addItem.expanded) {
                    _this.expandItem(true, itemIndex);
                }
            });
        }
        if (this.isReact) {
            this.renderReactTemplates();
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Accordion.prototype.expandedItemRefresh = function (ele) {
        var _this = this;
        var itemEle = this.getItemElements();
        [].slice.call(itemEle).forEach(function (el) {
            if (el.classList.contains(CLS_SLCTED)) {
                _this.expandedItemsPush(el);
            }
        });
    };
    /**
     * Dynamically removes item from Accordion.
     *
     * @param  {number} index - Number value that determines which item should be removed.
     * @returns {void}.
     */
    Accordion.prototype.removeItem = function (index) {
        if (this.isReact) {
            this.clearTemplate(['headerTemplate', 'itemTemplate'], index);
        }
        var itemEle = this.getItemElements();
        var ele = itemEle[index];
        var items = this.getItems();
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ele)) {
            return;
        }
        this.restoreContent(index);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(ele);
        items.splice(index, 1);
        this.itemAttribUpdate();
        this.expandedIndices = [];
        this.expandedItemRefresh(this.element);
    };
    /**
     * Sets focus to the specified index item header in Accordion.
     *
     * @param  {number} index - Number value that determines which item should be focused.
     * @returns {void}.
     */
    Accordion.prototype.select = function (index) {
        var itemEle = this.getItemElements();
        var ele = itemEle[index];
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ele) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_HEADER, ele))) {
            return;
        }
        ele.children[0].focus();
    };
    /**
     * Shows or hides the specified item from Accordion.
     *
     * @param  {number} index - Number value that determines which item should be hidden/shown.
     * @param  {boolean} isHidden - Boolean value that determines the action either hide (true) or show (false). Default value is false.
     * If the `isHidden` value is false, the item is shown or else item it is hidden.
     * @returns {void}.
     */
    Accordion.prototype.hideItem = function (index, isHidden) {
        var itemEle = this.getItemElements();
        var ele = itemEle[index];
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ele)) {
            return;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(isHidden)) {
            isHidden = true;
        }
        if (isHidden) {
            this.add(ele, CLS_ITEMHIDE);
        }
        else {
            this.remove(ele, CLS_ITEMHIDE);
        }
    };
    /**
     * Enables/Disables the specified Accordion item.
     *
     * @param  {number} index - Number value that determines which item should be enabled/disabled.
     * @param  {boolean} isEnable - Boolean value that determines the action as enable (true) or disable (false).
     * If the `isEnable` value is true, the item is enabled or else it is disabled.
     * @returns {void}.
     */
    Accordion.prototype.enableItem = function (index, isEnable) {
        var itemEle = this.getItemElements();
        var ele = itemEle[index];
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ele)) {
            return;
        }
        var eleHeader = ele.firstElementChild;
        if (isEnable) {
            this.remove(ele, CLS_DISABLE);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(eleHeader, { 'tabindex': '0', 'aria-disabled': 'false' });
            eleHeader.focus();
        }
        else {
            if (ele.classList.contains(CLS_ACTIVE)) {
                this.expandItem(false, index);
                this.eleMoveFocus('movedown', this.element, eleHeader);
            }
            this.add(ele, CLS_DISABLE);
            eleHeader.setAttribute('aria-disabled', 'true');
            eleHeader.removeAttribute('tabindex');
        }
    };
    /**
     * Expands/Collapses the specified Accordion item.
     *
     * @param  {boolean} isExpand - Boolean value that determines the action as expand or collapse.
     * @param  {number} index - Number value that determines which item should be expanded/collapsed.`index` is optional parameter.
     * Without Specifying index, based on the `isExpand` value all Accordion item can be expanded or collapsed.
     * @returns {void}.
     */
    Accordion.prototype.expandItem = function (isExpand, index) {
        var _this = this;
        var itemEle = this.getItemElements();
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(index)) {
            if (this.expandMode === 'Single' && isExpand) {
                var ele = itemEle[itemEle.length - 1];
                this.itemExpand(isExpand, ele, this.getIndexByItem(ele));
            }
            else {
                var item = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('#' + this.lastActiveItemId, this.element);
                [].slice.call(itemEle).forEach(function (el) {
                    _this.itemExpand(isExpand, el, _this.getIndexByItem(el));
                    el.classList.remove(CLS_EXPANDSTATE);
                });
                var expandedItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_EXPANDSTATE, this.element);
                if (expandedItem) {
                    expandedItem.classList.remove(CLS_EXPANDSTATE);
                }
                if (item) {
                    item.classList.add(CLS_EXPANDSTATE);
                }
            }
        }
        else {
            var ele = itemEle[index];
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ele) || !ele.classList.contains(CLS_SLCT) || (ele.classList.contains(CLS_ACTIVE) && isExpand)) {
                return;
            }
            else {
                if (this.expandMode === 'Single') {
                    this.expandItem(false);
                }
                this.itemExpand(isExpand, ele, index);
            }
        }
    };
    Accordion.prototype.itemExpand = function (isExpand, ele, index) {
        var ctn = ele.children[1];
        if (ele.classList.contains(CLS_DISABLE)) {
            return;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ctn) && isExpand) {
            ctn = this.contentRendering(index);
            ele.appendChild(ctn);
            this.ariaAttrUpdate(ele);
            this.expand(ctn);
        }
        else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ctn)) {
            if (isExpand) {
                this.expand(ctn);
            }
            else {
                this.collapse(ctn);
            }
        }
        if (this.isReact) {
            this.renderReactTemplates();
        }
    };
    Accordion.prototype.destroyItems = function () {
        this.restoreContent(null);
        if (this.isReact || this.isAngular || this.isVue) {
            this.clearTemplate();
        }
        [].slice.call(this.element.querySelectorAll('.' + CLS_ITEM)).forEach(function (el) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(el);
        });
    };
    Accordion.prototype.restoreContent = function (index) {
        var ctnElePos;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(index)) {
            ctnElePos = this.element;
        }
        else {
            ctnElePos = this.element.querySelectorAll('.' + CLS_ITEM)[index];
        }
        this.templateEle.forEach(function (eleStr) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ctnElePos.querySelector(eleStr))) {
                document.body.appendChild(ctnElePos.querySelector(eleStr)).style.display = 'none';
            }
        });
    };
    Accordion.prototype.updateItem = function (item, index) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item)) {
            var items = this.getItems();
            var itemObj = items[index];
            items.splice(index, 1);
            this.restoreContent(index);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(item);
            this.addItem(itemObj, index);
        }
    };
    Accordion.prototype.setTemplate = function (template, toElement, index) {
        toElement.innerHTML = '';
        this.templateCompile(toElement, template, index);
        if (this.isReact) {
            this.renderReactTemplates();
        }
    };
    Accordion.prototype.templateCompile = function (ele, cnt, index) {
        var tempEle = this.createElement('div');
        this.fetchElement(tempEle, cnt, index, false);
        if (tempEle.childNodes.length !== 0) {
            [].slice.call(tempEle.childNodes).forEach(function (childEle) {
                ele.appendChild(childEle);
            });
        }
    };
    Accordion.prototype.getPersistData = function () {
        var keyEntity = ['expandedIndices'];
        return this.addOnPersist(keyEntity);
    };
    /**
     * Gets called when the model property changes.The data that describes the old and new values of the property that changed.
     *
     * @param  {AccordionModel} newProp - It contains the new value of data.
     * @param  {AccordionModel} oldProp - It contains the old value of data.
     * @returns {void}
     * @private
     */
    Accordion.prototype.onPropertyChanged = function (newProp, oldProp) {
        var acrdn = this.element;
        var isRefresh = false;
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'items':
                    if (!(newProp.items instanceof Array && oldProp.items instanceof Array)) {
                        var changedProp = Object.keys(newProp.items);
                        for (var j = 0; j < changedProp.length; j++) {
                            var index = parseInt(Object.keys(newProp.items)[j], 10);
                            var property = Object.keys(newProp.items[index])[0];
                            var item = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_ITEM, this.element)[index];
                            var oldVal = Object(oldProp.items[index])[property];
                            var newVal = Object(newProp.items[index])[property];
                            var temp = property;
                            if (temp === 'header' || temp === 'iconCss' || temp === 'expanded' || ((temp === 'content') && (oldVal === ''))) {
                                this.updateItem(item, index);
                            }
                            if (property === 'cssClass' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item)) {
                                item.classList.remove(oldVal);
                                item.classList.add(newVal);
                            }
                            if (property === 'visible' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item)) {
                                if (Object(newProp.items[index])[property] === false) {
                                    item.classList.add(CLS_ITEMHIDE);
                                }
                                else {
                                    item.classList.remove(CLS_ITEMHIDE);
                                }
                            }
                            if (property === 'disabled' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item)) {
                                this.enableItem(index, !newVal);
                            }
                            if (property === 'content' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item) && item.children.length === 2) {
                                if (typeof newVal === 'function') {
                                    var activeContent = item.querySelector('.' + CLS_CTENT);
                                    activeContent.innerHTML = '';
                                    this.setTemplate(newVal, activeContent, index);
                                }
                                else {
                                    if (item.classList.contains(CLS_SLCTED)) {
                                        this.expandItem(false, index);
                                    }
                                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(item.querySelector('.' + CLS_CONTENT));
                                }
                            }
                        }
                    }
                    else {
                        isRefresh = true;
                    }
                    break;
                case 'dataSource':
                case 'expandedIndices':
                    if (this.expandedIndices === null) {
                        this.expandedIndices = [];
                    }
                    isRefresh = true;
                    break;
                case 'headerTemplate':
                    this.initializeHeaderTemplate();
                    isRefresh = true;
                    break;
                case 'itemTemplate':
                    this.initializeItemTemplate();
                    isRefresh = true;
                    break;
                case 'enableRtl':
                    if (newProp.enableRtl) {
                        this.add(acrdn, CLS_RTL);
                    }
                    else {
                        this.remove(acrdn, CLS_RTL);
                    }
                    break;
                case 'height':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'height': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(newProp.height) });
                    break;
                case 'width':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'width': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(newProp.width) });
                    break;
                case 'expandMode':
                    if (newProp.expandMode === 'Single') {
                        this.element.setAttribute('aria-multiselectable', 'false');
                        if (this.expandedIndices.length > 1) {
                            this.expandItem(false);
                        }
                    }
                    else {
                        this.element.setAttribute('aria-multiselectable', 'true');
                    }
                    break;
            }
        }
        if (isRefresh) {
            this.initExpand = [];
            if (this.expandedIndices.length > 0) {
                this.initExpand = this.expandedIndices;
            }
            this.destroyItems();
            this.renderItems();
            this.initItemExpand();
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["f" /* Collection */])([], AccordionItem)
    ], Accordion.prototype, "items", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])([])
    ], Accordion.prototype, "dataSource", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Accordion.prototype, "itemTemplate", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Accordion.prototype, "headerTemplate", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('100%')
    ], Accordion.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('auto')
    ], Accordion.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])([])
    ], Accordion.prototype, "expandedIndices", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Multiple')
    ], Accordion.prototype, "expandMode", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Accordion.prototype, "enableHtmlSanitizer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({}, AccordionAnimationSettings)
    ], Accordion.prototype, "animation", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Accordion.prototype, "clicked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Accordion.prototype, "expanding", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Accordion.prototype, "expanded", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Accordion.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Accordion.prototype, "destroyed", void 0);
    Accordion = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], Accordion);
    return Accordion;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__context_menu__ = __webpack_require__(248);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__context_menu__["a"]; });
/**
 * ContextMenu modules
 */



/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_menu_base__ = __webpack_require__(29);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/triple-slash-reference */
/// <reference path='../common/menu-base-model.d.ts'/>



/**
 * The ContextMenu is a graphical user interface that appears on the user right click/touch hold operation.
 * ```html
 * <div id = 'target'></div>
 * <ul id = 'contextmenu'></ul>
 * ```
 * ```typescript
 * <script>
 * var contextMenuObj = new ContextMenu({items: [{ text: 'Cut' }, { text: 'Copy' },{ text: 'Paste' }], target: '#target'});
 * </script>
 * ```
 */
var ContextMenu = /** @class */ (function (_super) {
    __extends(ContextMenu, _super);
    /**
     * Constructor for creating the widget.
     *
     * @private
     * @param {ContextMenuModel} options - Specifies the context menu model
     * @param {string} element - Specifies the element
     */
    function ContextMenu(options, element) {
        return _super.call(this, options, element) || this;
    }
    /**
     * For internal use only - prerender processing.
     *
     * @private
     * @returns {void}
     */
    ContextMenu.prototype.preRender = function () {
        this.isMenu = false;
        this.element.id = this.element.id || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('ej2-contextmenu');
        _super.prototype.preRender.call(this);
    };
    ContextMenu.prototype.initialize = function () {
        _super.prototype.initialize.call(this);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'role': 'menubar', 'tabindex': '0' });
        this.element.style.zIndex = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__["g" /* getZindexPartial */])(this.element).toString();
    };
    /**
     * This method is used to open the ContextMenu in specified position.
     *
     * @param {number} top - To specify ContextMenu vertical positioning.
     * @param {number} left - To specify ContextMenu horizontal positioning.
     * @param {HTMLElement} target - To calculate z-index for ContextMenu based upon the specified target.
     * @function open
     * @returns {void}
     */
    ContextMenu.prototype.open = function (top, left, target) {
        _super.prototype.openMenu.call(this, null, null, top, left, null, target);
    };
    /**
     * Closes the ContextMenu if it is opened.
     *
     * @function close
     * @returns {void}
     */
    ContextMenu.prototype.close = function () {
        _super.prototype.closeMenu.call(this);
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @private
     * @param {ContextMenuModel} newProp - Specifies new properties
     * @param {ContextMenuModel} oldProp - Specifies old properties
     * @returns {void}
     */
    ContextMenu.prototype.onPropertyChanged = function (newProp, oldProp) {
        _super.prototype.onPropertyChanged.call(this, newProp, oldProp);
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'filter':
                    this.close();
                    this.filter = newProp.filter;
                    break;
                case 'target':
                    this.unWireEvents(oldProp.target);
                    this.wireEvents();
                    break;
            }
        }
    };
    /**
     * Get module name.
     *
     * @returns {string} - Module Name
     * @private
     */
    ContextMenu.prototype.getModuleName = function () {
        return 'contextmenu';
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], ContextMenu.prototype, "target", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], ContextMenu.prototype, "filter", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["f" /* Collection */])([], __WEBPACK_IMPORTED_MODULE_2__common_menu_base__["c" /* MenuItem */])
    ], ContextMenu.prototype, "items", void 0);
    ContextMenu = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], ContextMenu);
    return ContextMenu;
}(__WEBPACK_IMPORTED_MODULE_2__common_menu_base__["b" /* MenuBase */]));



/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu__ = __webpack_require__(250);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__menu__["a"]; });
/**
 * Menu modules
 */



/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Menu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_menu_base__ = __webpack_require__(29);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/triple-slash-reference */
/// <reference path='../common/menu-base-model.d.ts'/>



var VMENU = 'e-vertical';
var SCROLLABLE = 'e-scrollable';
var HAMBURGER = 'e-hamburger';
/**
 * The Menu is a graphical user interface that serve as navigation headers for your application or site.
 * ```html
 * <ul id = 'menu'></ul>
 * ```
 * ```typescript
 * <script>
 * var menuObj = new Menu({ items: [{ text: 'Home' }, { text: 'Contact Us' },{ text: 'Login' }]});
 * menuObj.appendTo("#menu");
 * </script>
 * ```
 */
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    /**
     * Constructor for creating the component.
     *
     * @private
     * @param {MenuModel} options - Specifies the menu model
     * @param {string} element - Specifies the element
     */
    function Menu(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.tempItems = [];
        return _this;
    }
    /**
     * Get module name.
     *
     * @private
     * @returns {string} - Module Name
     */
    Menu.prototype.getModuleName = function () {
        return 'menu';
    };
    /**
     * For internal use only - prerender processing.
     *
     * @private
     * @returns {void}
     */
    Menu.prototype.preRender = function () {
        this.isMenu = true;
        this.element.id = this.element.id || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('ej2-menu');
        if (this.template) {
            try {
                if (document.querySelectorAll(this.template).length) {
                    this.template = document.querySelector(this.template).innerHTML.trim();
                    this.clearChanges();
                }
            }
            catch (e) {
                /* action on catch */
            }
        }
        else {
            this.updateMenuItems(this.items);
        }
        _super.prototype.preRender.call(this);
    };
    Menu.prototype.initialize = function () {
        _super.prototype.initialize.call(this);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'role': 'menubar', 'tabindex': '0' });
        if (this.orientation === 'Vertical') {
            this.element.classList.add(VMENU);
            if (this.hamburgerMode && !this.target) {
                this.element.previousElementSibling.classList.add(VMENU);
            }
            this.element.setAttribute('aria-orientation', 'vertical');
        }
        else {
            if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice && !this.enableScrolling) {
                this.element.parentElement.classList.add(SCROLLABLE);
            }
        }
        if (this.hamburgerMode) {
            this.element.parentElement.classList.add(HAMBURGER);
            if (this.orientation === 'Horizontal') {
                this.element.classList.add('e-hide-menu');
            }
        }
    };
    Menu.prototype.updateMenuItems = function (items) {
        this.tempItems = items;
        this.items = [];
        this.tempItems.map(this.createMenuItems, this);
        this.setProperties({ items: this.items }, true);
        this.tempItems = [];
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @private
     * @param {MenuModel} newProp - Specifies the new properties.
     * @param {MenuModel} oldProp - Specifies the old properties.
     * @returns {void}
     */
    Menu.prototype.onPropertyChanged = function (newProp, oldProp) {
        var _this = this;
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'orientation':
                    if (newProp.orientation === 'Vertical') {
                        this.element.classList.add(VMENU);
                        if (this.hamburgerMode) {
                            if (!this.target) {
                                this.element.previousElementSibling.classList.add(VMENU);
                            }
                            this.element.classList.remove('e-hide-menu');
                        }
                        this.element.setAttribute('aria-orientation', 'vertical');
                    }
                    else {
                        this.element.classList.remove(VMENU);
                        if (this.hamburgerMode) {
                            if (!this.target) {
                                this.element.previousElementSibling.classList.remove(VMENU);
                            }
                            this.element.classList.add('e-hide-menu');
                        }
                        this.element.removeAttribute('aria-orientation');
                    }
                    break;
                case 'items':
                    if (!Object.keys(oldProp.items).length) {
                        this.updateMenuItems(newProp.items);
                    }
                    break;
                case 'hamburgerMode':
                    if (!this.element.previousElementSibling) {
                        _super.prototype.createHeaderContainer.call(this);
                    }
                    if (newProp.hamburgerMode) {
                        this.element.parentElement.classList.add(HAMBURGER);
                        [].slice.call(this.element.getElementsByClassName('e-blankicon')).forEach(function (li) {
                            li.style[_this.enableRtl ? 'paddingRight' : 'paddingLeft'] = '';
                        });
                    }
                    else {
                        this.element.parentElement.classList.remove(HAMBURGER);
                        if (this.orientation === 'Vertical') {
                            this.setBlankIconStyle(this.element);
                        }
                    }
                    if (this.orientation === 'Vertical') {
                        if (!this.target) {
                            this.element.previousElementSibling.classList.add(VMENU);
                        }
                        this.element.classList.remove('e-hide-menu');
                    }
                    else {
                        if (this.target) {
                            this.element.previousElementSibling.classList.add(VMENU);
                        }
                        else {
                            this.element.previousElementSibling.classList.remove(VMENU);
                        }
                        this.element.classList[newProp.hamburgerMode ? 'add' : 'remove']('e-hide-menu');
                    }
                    break;
                case 'title':
                    if (this.hamburgerMode && this.element.previousElementSibling) {
                        newProp.title = (this.enableHtmlSanitizer) ? __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(newProp.title) : newProp.title;
                        this.element.previousElementSibling.querySelector('.e-menu-title').innerHTML = newProp.title;
                    }
                    break;
                case 'target':
                    if (this.hamburgerMode) {
                        this.unWireEvents(oldProp.target);
                        this.wireEvents();
                        if (this.orientation === 'Horizontal') {
                            if (!newProp.target) {
                                if (!this.element.previousElementSibling) {
                                    _super.prototype.createHeaderContainer.call(this);
                                }
                                this.element.previousElementSibling.classList.remove(VMENU);
                            }
                            else {
                                this.element.previousElementSibling.classList.add(VMENU);
                            }
                            this.element.classList.add('e-hide-menu');
                        }
                    }
                    break;
            }
        }
        _super.prototype.onPropertyChanged.call(this, newProp, oldProp);
    };
    Menu.prototype.createMenuItems = function (item) {
        var idx;
        var i;
        var items = this.items;
        var pIdField = this.getField('parentId');
        if (item[pIdField]) {
            idx = this.getIndex(item[pIdField].toString(), true);
            for (i = 0; i < idx.length; i++) {
                if (!items[idx[i]].items) {
                    items[idx[i]].items = [];
                }
                items = items[idx[i]].items;
            }
            items.push(item);
        }
        else {
            this.items.push(item);
        }
    };
    /**
     * This method is used to open the Menu in hamburger mode.
     *
     * @function open
     * @returns {void}
     */
    Menu.prototype.open = function () {
        _super.prototype.openHamburgerMenu.call(this);
    };
    /**
     * Closes the Menu if it is opened in hamburger mode.
     *
     * @function close
     * @returns {void}
     */
    Menu.prototype.close = function () {
        _super.prototype.closeHamburgerMenu.call(this);
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Horizontal')
    ], Menu.prototype, "orientation", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Menu.prototype, "target", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], Menu.prototype, "template", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Menu.prototype, "enableScrolling", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Menu.prototype, "hamburgerMode", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Menu')
    ], Menu.prototype, "title", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Menu.prototype, "enableHtmlSanitizer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({ itemId: 'id', text: 'text', parentId: 'parentId', iconCss: 'iconCss', url: 'url', separator: 'separator', children: 'items' }, __WEBPACK_IMPORTED_MODULE_1__common_menu_base__["a" /* FieldSettings */])
    ], Menu.prototype, "fields", void 0);
    Menu = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], Menu);
    return Menu;
}(__WEBPACK_IMPORTED_MODULE_1__common_menu_base__["b" /* MenuBase */]));



/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tab__ = __webpack_require__(252);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__tab__["a"]; });
/**
 * Tab modules
 */



/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TabActionSettings */
/* unused harmony export TabAnimationSettings */
/* unused harmony export Header */
/* unused harmony export TabItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toolbar_toolbar__ = __webpack_require__(85);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var CLS_TAB = 'e-tab';
var CLS_HEADER = 'e-tab-header';
var CLS_BLA_TEM = 'blazor-template';
var CLS_CONTENT = 'e-content';
var CLS_NEST = 'e-nested';
var CLS_ITEMS = 'e-items';
var CLS_ITEM = 'e-item';
var CLS_TEMPLATE = 'e-template';
var CLS_RTL = 'e-rtl';
var CLS_ACTIVE = 'e-active';
var CLS_DISABLE = 'e-disable';
var CLS_HIDDEN = 'e-hidden';
var CLS_FOCUS = 'e-focused';
var CLS_ICONS = 'e-icons';
var CLS_ICON = 'e-icon';
var CLS_ICON_TAB = 'e-icon-tab';
var CLS_ICON_CLOSE = 'e-close-icon';
var CLS_CLOSE_SHOW = 'e-close-show';
var CLS_TEXT = 'e-tab-text';
var CLS_INDICATOR = 'e-indicator';
var CLS_WRAP = 'e-tab-wrap';
var CLS_TEXT_WRAP = 'e-text-wrap';
var CLS_TAB_ICON = 'e-tab-icon';
var CLS_TB_ITEMS = 'e-toolbar-items';
var CLS_TB_ITEM = 'e-toolbar-item';
var CLS_TB_POP = 'e-toolbar-pop';
var CLS_TB_POPUP = 'e-toolbar-popup';
var CLS_HOR_NAV = 'e-hor-nav';
var CLS_POPUP_OPEN = 'e-popup-open';
var CLS_POPUP_CLOSE = 'e-popup-close';
var CLS_PROGRESS = 'e-progress';
var CLS_IGNORE = 'e-ignore';
var CLS_OVERLAY = 'e-overlay';
var CLS_HSCRCNT = 'e-hscroll-content';
var CLS_VSCRCNT = 'e-vscroll-content';
var CLS_VTAB = 'e-vertical-tab';
var CLS_VERTICAL = 'e-vertical';
var CLS_VLEFT = 'e-vertical-left';
var CLS_VRIGHT = 'e-vertical-right';
var CLS_HBOTTOM = 'e-horizontal-bottom';
var CLS_FILL = 'e-fill-mode';
var TABITEMPREFIX = 'tabitem_';
var CLS_REORDER_ACTIVE_ITEM = 'e-reorder-active-item';
/**
 * Objects used for configuring the Tab selecting item action properties.
 */
var TabActionSettings = /** @class */ (function (_super) {
    __extends(TabActionSettings, _super);
    function TabActionSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('SlideLeftIn')
    ], TabActionSettings.prototype, "effect", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(600)
    ], TabActionSettings.prototype, "duration", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('ease')
    ], TabActionSettings.prototype, "easing", void 0);
    return TabActionSettings;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * Objects used for configuring the Tab animation properties.
 */
var TabAnimationSettings = /** @class */ (function (_super) {
    __extends(TabAnimationSettings, _super);
    function TabAnimationSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({ effect: 'SlideLeftIn', duration: 600, easing: 'ease' }, TabActionSettings)
    ], TabAnimationSettings.prototype, "previous", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({ effect: 'SlideRightIn', duration: 600, easing: 'ease' }, TabActionSettings)
    ], TabAnimationSettings.prototype, "next", void 0);
    return TabAnimationSettings;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * Objects used for configuring the Tab item header properties.
 */
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Header.prototype, "text", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Header.prototype, "iconCss", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('left')
    ], Header.prototype, "iconPosition", void 0);
    return Header;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * An array of object that is used to configure the Tab.
 */
var TabItem = /** @class */ (function (_super) {
    __extends(TabItem, _super);
    function TabItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({}, Header)
    ], TabItem.prototype, "header", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], TabItem.prototype, "headerTemplate", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], TabItem.prototype, "content", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], TabItem.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], TabItem.prototype, "disabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], TabItem.prototype, "visible", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], TabItem.prototype, "id", void 0);
    return TabItem;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * Tab is a content panel to show multiple contents in a single space, one at a time.
 * Each Tab item has an associated content, that will be displayed based on the active Tab header item.
 * ```html
 * <div id="tab"></div>
 * <script>
 *   var tabObj = new Tab();
 *   tab.appendTo("#tab");
 * </script>
 * ```
 */
var Tab = /** @class */ (function (_super) {
    __extends(Tab, _super);
    /**
     * Initializes a new instance of the Tab class.
     *
     * @param {TabModel} options  - Specifies Tab model properties as options.
     * @param {string | HTMLElement} element  - Specifies the element that is rendered as a Tab.
     */
    function Tab(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.show = {};
        _this.hide = {};
        _this.maxHeight = 0;
        _this.title = 'Close';
        _this.isInteracted = false;
        _this.lastIndex = 0;
        _this.isAdd = false;
        _this.isIconAlone = false;
        _this.draggableItems = [];
        _this.resizeContext = _this.refreshActiveTabBorder.bind(_this);
        /**
         * Contains the keyboard configuration of the Tab.
         */
        _this.keyConfigs = {
            tab: 'tab',
            home: 'home',
            end: 'end',
            enter: 'enter',
            space: 'space',
            delete: 'delete',
            moveLeft: 'leftarrow',
            moveRight: 'rightarrow',
            moveUp: 'uparrow',
            moveDown: 'downarrow'
        };
        return _this;
    }
    /**
     * Removes the component from the DOM and detaches all its related event handlers, attributes and classes.
     *
     * @returns {void}
     */
    Tab.prototype.destroy = function () {
        var _this = this;
        if (this.isReact || this.isAngular) {
            this.clearTemplate();
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.tbObj)) {
            this.tbObj.destroy();
            this.tbObj = null;
        }
        this.unWireEvents();
        ['role', 'aria-disabled', 'aria-activedescendant', 'tabindex', 'aria-orientation'].forEach(function (val) {
            _this.element.removeAttribute(val);
        });
        this.expTemplateContent();
        if (!this.isTemplate) {
            while (this.element.firstElementChild) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(this.element.firstElementChild);
            }
        }
        else {
            var cntEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TAB + ' > .' + CLS_CONTENT, this.element);
            this.element.classList.remove(CLS_TEMPLATE);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(cntEle)) {
                cntEle.innerHTML = this.cnt;
            }
        }
        if (this.btnCls) {
            this.btnCls = null;
        }
        this.hdrEle = null;
        this.cntEle = null;
        this.tbItems = null;
        this.tbItem = null;
        this.tbPop = null;
        this.prevItem = null;
        this.popEle = null;
        this.bdrLine = null;
        this.content = null;
        this.dragItem = null;
        this.cloneElement = null;
        this.draggingItems = [];
        if (this.draggableItems && this.draggableItems.length > 0) {
            for (var i = 0; i < this.draggableItems.length; i++) {
                this.draggableItems[i].destroy();
                this.draggableItems[i] = null;
            }
            this.draggableItems = [];
        }
        _super.prototype.destroy.call(this);
        this.trigger('destroyed');
    };
    /**
     * Refresh the tab component
     *
     * @returns {void}
     */
    Tab.prototype.refresh = function () {
        if (this.isReact) {
            this.clearTemplate();
        }
        _super.prototype.refresh.call(this);
        if (this.isReact) {
            this.renderReactTemplates();
        }
    };
    /**
     * Initialize component
     *
     * @private
     * @returns {void}
     */
    Tab.prototype.preRender = function () {
        var nested = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, '.' + CLS_CONTENT);
        this.prevIndex = 0;
        this.isNested = false;
        this.isPopup = false;
        this.initRender = true;
        this.isSwipeed = false;
        this.itemIndexArray = [];
        this.templateEle = [];
        if (this.allowDragAndDrop) {
            this.dragArea = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.dragArea) ? this.dragArea : '#' + this.element.id + ' ' + ('.' + CLS_HEADER);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(nested)) {
            nested.parentElement.classList.add(CLS_NEST);
            this.isNested = true;
        }
        var name = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name;
        var css = (name === 'msie') ? 'e-ie' : (name === 'edge') ? 'e-edge' : (name === 'safari') ? 'e-safari' : '';
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'width': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.width), 'height': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.height) });
        this.setCssClass(this.element, this.cssClass, true);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { role: 'tablist', 'aria-disabled': 'false', 'aria-activedescendant': '' });
        this.setCssClass(this.element, css, true);
        this.updatePopAnimationConfig();
    };
    /**
     * Initialize the component rendering
     *
     * @private
     * @returns {void}
     */
    Tab.prototype.render = function () {
        this.btnCls = this.createElement('span', { className: CLS_ICONS + ' ' + CLS_ICON_CLOSE, attrs: { title: this.title } });
        this.tabId = this.element.id.length > 0 ? ('-' + this.element.id) : Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["L" /* getRandomId */])();
        this.renderContainer();
        this.wireEvents();
        this.initRender = false;
    };
    Tab.prototype.renderContainer = function () {
        var ele = this.element;
        this.items.forEach(function (item, index) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.id) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.setProperties)) {
                item.setProperties({ id: TABITEMPREFIX + index.toString() }, true);
            }
        });
        if (this.items.length > 0 && ele.children.length === 0) {
            ele.appendChild(this.createElement('div', { className: CLS_CONTENT }));
            this.setOrientation(this.headerPlacement, this.createElement('div', { className: CLS_HEADER }));
            this.isTemplate = false;
        }
        else if (this.element.children.length > 0) {
            this.isTemplate = true;
            ele.classList.add(CLS_TEMPLATE);
            var header = ele.querySelector('.' + CLS_HEADER);
            if (header && this.headerPlacement === 'Bottom') {
                this.setOrientation(this.headerPlacement, header);
            }
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_HEADER, this.element)) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_CONTENT, this.element))) {
            this.renderHeader();
            this.tbItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_HEADER + ' .' + CLS_TB_ITEMS, this.element);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.tbItems)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_0" /* rippleEffect */])(this.tbItems, { selector: '.e-tab-wrap' });
            }
            this.renderContent();
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEM, this.element).length > 0) {
                this.tbItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_HEADER + ' .' + CLS_TB_ITEMS, this.element);
                this.bdrLine = this.createElement('div', { className: CLS_INDICATOR + ' ' + CLS_HIDDEN + ' ' + CLS_IGNORE });
                var scrCnt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + this.scrCntClass, this.tbItems);
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(scrCnt)) {
                    scrCnt.insertBefore(this.bdrLine, scrCnt.firstChild);
                }
                else {
                    this.tbItems.insertBefore(this.bdrLine, this.tbItems.firstChild);
                }
                this.setContentHeight(true);
                this.select(this.selectedItem);
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.tbItem)) {
                for (var i = 0; i < this.items.length; i++) {
                    var tabID = this.items[i].id;
                    this.tbItem[i].setAttribute('data-id', tabID);
                }
            }
            this.setRTL(this.enableRtl);
        }
    };
    Tab.prototype.serverItemsChanged = function () {
        this.enableAnimation = false;
        this.setActive(this.selectedItem, true);
        if (this.loadOn !== 'Dynamic' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.cntEle)) {
            var itemCollection = [].slice.call(this.cntEle.children);
            var content_1 = CLS_CONTENT + this.tabId + '_' + this.selectedItem;
            itemCollection.forEach(function (item) {
                if (item.classList.contains(CLS_ACTIVE) && item.id !== content_1) {
                    item.classList.remove(CLS_ACTIVE);
                }
                if (item.id === content_1) {
                    item.classList.add(CLS_ACTIVE);
                }
            });
            this.prevIndex = this.selectedItem;
            this.triggerAnimation(CLS_ITEM + this.tabId + '_' + this.selectedItem, false);
        }
        this.enableAnimation = true;
    };
    Tab.prototype.headerReady = function () {
        this.initRender = true;
        this.hdrEle = this.getTabHeader();
        this.setOrientation(this.headerPlacement, this.hdrEle);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.hdrEle)) {
            this.tbObj = (this.hdrEle && this.hdrEle.ej2_instances[0]);
        }
        this.tbObj.clicked = this.clickHandler.bind(this);
        this.tbObj.on('onItemsChanged', this.serverItemsChanged.bind(this));
        this.tbItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_HEADER + ' .' + CLS_TB_ITEMS, this.element);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.tbItems)) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_0" /* rippleEffect */])(this.tbItems, { selector: '.e-tab-wrap' });
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEM, this.element).length > 0) {
            this.bdrLine = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_INDICATOR + '.' + CLS_IGNORE, this.element);
            var scrollCnt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + this.scrCntClass, this.tbItems);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(scrollCnt)) {
                scrollCnt.insertBefore(this.bdrLine, scrollCnt.firstElementChild);
            }
            else {
                this.tbItems.insertBefore(this.bdrLine, this.tbItems.firstElementChild);
            }
            this.select(this.selectedItem);
        }
        this.cntEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TAB + ' > .' + CLS_CONTENT, this.element);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.cntEle)) {
            this.touchModule = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["t" /* Touch */](this.cntEle, { swipe: this.swipeHandler.bind(this) });
        }
        if (this.loadOn === 'Demand') {
            var id = this.setActiveContent();
            this.triggerAnimation(id, false);
        }
        this.initRender = false;
        this.renderComplete();
    };
    Tab.prototype.setActiveContent = function () {
        var id = CLS_ITEM + this.tabId + '_' + this.selectedItem;
        var item = this.getTrgContent(this.cntEle, this.extIndex(id));
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item)) {
            item.classList.add(CLS_ACTIVE);
        }
        return id;
    };
    Tab.prototype.renderHeader = function () {
        var _this = this;
        var hdrPlace = this.headerPlacement;
        var tabItems = [];
        this.hdrEle = this.getTabHeader();
        this.addVerticalClass();
        if (!this.isTemplate) {
            tabItems = this.parseObject(this.items, 0);
        }
        else {
            if (this.element.children.length > 1 && this.element.children[1].classList.contains(CLS_HEADER)) {
                this.setProperties({ headerPlacement: 'Bottom' }, true);
            }
            var count = this.hdrEle.children.length;
            var hdrItems = [];
            for (var i = 0; i < count; i++) {
                hdrItems.push(this.hdrEle.children.item(i).innerHTML);
            }
            if (count > 0) {
                while (this.hdrEle.firstElementChild) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.hdrEle.firstElementChild);
                }
                var tabItems_1 = this.createElement('div', { className: CLS_ITEMS });
                this.hdrEle.appendChild(tabItems_1);
                hdrItems.forEach(function (item, index) {
                    _this.lastIndex = index;
                    var attr = {
                        className: CLS_ITEM, id: CLS_ITEM + _this.tabId + '_' + index,
                        attrs: { role: 'tab', 'aria-controls': CLS_CONTENT + _this.tabId + '_' + index, 'aria-selected': 'false' }
                    };
                    var txt = _this.createElement('span', {
                        className: CLS_TEXT, innerHTML: item, attrs: { 'role': 'presentation' }
                    }).outerHTML;
                    var cont = _this.createElement('div', {
                        className: CLS_TEXT_WRAP, innerHTML: txt + _this.btnCls.outerHTML
                    }).outerHTML;
                    var wrap = _this.createElement('div', { className: CLS_WRAP, innerHTML: cont, attrs: { tabIndex: '-1' } });
                    tabItems_1.appendChild(_this.createElement('div', attr));
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_ITEM, tabItems_1)[index].appendChild(wrap);
                });
            }
        }
        this.tbObj = new __WEBPACK_IMPORTED_MODULE_1__toolbar_toolbar__["a" /* Toolbar */]({
            width: (hdrPlace === 'Left' || hdrPlace === 'Right') ? 'auto' : '100%',
            height: (hdrPlace === 'Left' || hdrPlace === 'Right') ? '100%' : 'auto',
            overflowMode: this.overflowMode,
            items: (tabItems.length !== 0) ? tabItems : [],
            clicked: this.clickHandler.bind(this),
            scrollStep: this.scrollStep,
            enableHtmlSanitizer: this.enableHtmlSanitizer
        });
        this.tbObj.isStringTemplate = true;
        this.tbObj.createElement = this.createElement;
        this.tbObj.appendTo(this.hdrEle);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.hdrEle, { 'aria-label': 'tab-header' });
        this.updateOrientationAttribute();
        this.setCloseButton(this.showCloseButton);
    };
    Tab.prototype.renderContent = function () {
        this.cntEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_CONTENT, this.element);
        var hdrItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEM, this.element);
        if (this.isTemplate) {
            this.cnt = (this.cntEle.children.length > 0) ? this.cntEle.innerHTML : '';
            var contents = this.cntEle.children;
            for (var i = 0; i < hdrItem.length; i++) {
                if (contents.length - 1 >= i) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([contents.item(i)], CLS_ITEM);
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(contents.item(i), { 'role': 'tabpanel', 'aria-labelledby': CLS_ITEM + this.tabId + '_' + i });
                    contents.item(i).id = CLS_CONTENT + this.tabId + '_' + i;
                }
            }
        }
    };
    Tab.prototype.reRenderItems = function () {
        this.renderContainer();
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.cntEle)) {
            this.touchModule = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["t" /* Touch */](this.cntEle, { swipe: this.swipeHandler.bind(this) });
        }
    };
    Tab.prototype.parseObject = function (items, index) {
        var _this = this;
        var tbItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.e-tab-header .' + CLS_TB_ITEM, this.element);
        var maxId = this.lastIndex;
        if (!this.isReplace && tbItems.length > 0) {
            var idList_1 = [];
            tbItems.forEach(function (item) {
                idList_1.push(parseInt(item.id.slice(item.id.indexOf('_') + 1), 10));
            });
            maxId = Math.max.apply(Math, idList_1);
        }
        var tItems = [];
        var txtWrapEle;
        var spliceArray = [];
        var i = 0;
        items.forEach(function (item, i) {
            var pos = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.header) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.header.iconPosition)) ? '' : item.header.iconPosition;
            var css = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.header) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.header.iconCss)) ? '' : item.header.iconCss;
            if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.headerTemplate)) && (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.header) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.header.text) ||
                ((item.header.text.length === 0)) && (css === ''))) {
                spliceArray.push(i);
                return;
            }
            var txt = item.headerTemplate || item.header.text;
            if (typeof txt === 'string' && _this.enableHtmlSanitizer) {
                txt = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(txt);
            }
            var itemIndex;
            if (_this.isReplace && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(_this.tbId) && _this.tbId !== '') {
                var num = (_this.tbId.indexOf('_'));
                itemIndex = parseInt(_this.tbId.substring(num + 1), 10);
                _this.tbId = '';
            }
            else {
                itemIndex = index + i;
            }
            _this.lastIndex = ((tbItems.length === 0) ? i : ((_this.isReplace) ? (itemIndex) : (maxId + 1 + i)));
            var disabled = (item.disabled) ? ' ' + CLS_DISABLE + ' ' + CLS_OVERLAY : '';
            var hidden = (item.visible === false) ? ' ' + CLS_HIDDEN : '';
            txtWrapEle = _this.createElement('div', { className: CLS_TEXT, attrs: { 'role': 'presentation' } });
            var tHtml = ((txt instanceof Object) ? txt.outerHTML : txt);
            var txtEmpty = (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(tHtml) && tHtml !== '');
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(txt.tagName)) {
                txtWrapEle.appendChild(txt);
            }
            else {
                _this.headerTextCompile(txtWrapEle, txt, i);
            }
            var tEle;
            var icon = _this.createElement('span', {
                className: CLS_ICONS + ' ' + CLS_TAB_ICON + ' ' + CLS_ICON + '-' + pos + ' ' + css
            });
            var tCont = _this.createElement('div', { className: CLS_TEXT_WRAP });
            tCont.appendChild(txtWrapEle);
            if ((txt !== '' && txt !== undefined) && css !== '') {
                if ((pos === 'left' || pos === 'top')) {
                    tCont.insertBefore(icon, tCont.firstElementChild);
                }
                else {
                    tCont.appendChild(icon);
                }
                tEle = txtWrapEle;
                _this.isIconAlone = false;
            }
            else {
                tEle = ((css === '') ? txtWrapEle : icon);
                if (tEle === icon) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(txtWrapEle);
                    tCont.appendChild(icon);
                    _this.isIconAlone = true;
                }
            }
            var wrapAttrs = (item.disabled) ? {} : { tabIndex: '-1' };
            tCont.appendChild(_this.btnCls.cloneNode(true));
            var wrap = _this.createElement('div', { className: CLS_WRAP, attrs: wrapAttrs });
            wrap.appendChild(tCont);
            if (_this.itemIndexArray === []) {
                _this.itemIndexArray.push(CLS_ITEM + _this.tabId + '_' + _this.lastIndex);
            }
            else {
                _this.itemIndexArray.splice((index + i), 0, CLS_ITEM + _this.tabId + '_' + _this.lastIndex);
            }
            var attrObj = {
                id: CLS_ITEM + _this.tabId + '_' + _this.lastIndex, role: 'tab', 'aria-selected': 'false'
            };
            var tItem = { htmlAttributes: attrObj, template: wrap };
            tItem.cssClass = ((item.cssClass !== undefined) ? item.cssClass : ' ') + ' ' + disabled + ' ' + hidden + ' '
                + ((css !== '') ? 'e-i' + pos : '') + ' ' + ((!txtEmpty) ? CLS_ICON : '');
            if (pos === 'top' || pos === 'bottom') {
                _this.element.classList.add('e-vertical-icon');
            }
            tItems.push(tItem);
            i++;
        });
        if (!this.isAdd) {
            spliceArray.forEach(function (spliceItemIndex) {
                _this.items.splice(spliceItemIndex, 1);
            });
        }
        if (this.isIconAlone) {
            this.element.classList.add(CLS_ICON_TAB);
        }
        else {
            this.element.classList.remove(CLS_ICON_TAB);
        }
        return tItems;
    };
    Tab.prototype.removeActiveClass = function () {
        var tabHeader = this.getTabHeader();
        if (tabHeader) {
            var tabItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEM + '.' + CLS_ACTIVE, tabHeader);
            [].slice.call(tabItems).forEach(function (node) { return node.classList.remove(CLS_ACTIVE); });
        }
    };
    Tab.prototype.checkPopupOverflow = function (ele) {
        this.tbPop = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TB_POP, this.element);
        var popIcon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-hor-nav', this.element);
        var tbrItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TB_ITEMS, this.element);
        var lastChild = tbrItems.lastChild;
        var isOverflow = false;
        if (!this.isVertical() && ((this.enableRtl && ((popIcon.offsetLeft + popIcon.offsetWidth) > tbrItems.offsetLeft))
            || (!this.enableRtl && popIcon.offsetLeft < tbrItems.offsetWidth))) {
            isOverflow = true;
        }
        else if (this.isVertical() && (popIcon.offsetTop < lastChild.offsetTop + lastChild.offsetHeight)) {
            isOverflow = true;
        }
        if (isOverflow) {
            ele.classList.add(CLS_TB_POPUP);
            this.tbPop.insertBefore(ele, Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_POPUP, this.tbPop)[0]);
        }
        return true;
    };
    Tab.prototype.popupHandler = function (target) {
        var ripEle = target.querySelector('.e-ripple-element');
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ripEle)) {
            ripEle.outerHTML = '';
            target.querySelector('.' + CLS_WRAP).classList.remove('e-ripple');
        }
        this.tbItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEMS + ' .' + CLS_TB_ITEM, this.hdrEle);
        var lastChild = this.tbItem[this.tbItem.length - 1];
        if (this.tbItem.length !== 0) {
            target.classList.remove(CLS_TB_POPUP);
            target.removeAttribute('style');
            this.tbItems.appendChild(target);
            this.actEleId = target.id;
            if (this.checkPopupOverflow(lastChild)) {
                var prevEle = this.tbItems.lastChild.previousElementSibling;
                this.checkPopupOverflow(prevEle);
            }
            this.isPopup = true;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEM, this.tbItems).length - 1;
    };
    Tab.prototype.updateOrientationAttribute = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'aria-orientation': (this.isVertical() ? 'vertical' : 'horizontal') });
    };
    Tab.prototype.setCloseButton = function (val) {
        var trg = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_HEADER, this.element);
        if (val === true) {
            trg.classList.add(CLS_CLOSE_SHOW);
        }
        else {
            trg.classList.remove(CLS_CLOSE_SHOW);
        }
        this.tbObj.refreshOverflow();
        this.refreshActiveTabBorder();
    };
    Tab.prototype.prevCtnAnimation = function (prev, current) {
        var animation;
        var checkRTL = this.enableRtl || this.element.classList.contains(CLS_RTL);
        if (this.isPopup || prev <= current) {
            if (this.animation.previous.effect === 'SlideLeftIn') {
                animation = {
                    name: 'SlideLeftOut',
                    duration: this.animation.previous.duration, timingFunction: this.animation.previous.easing
                };
            }
            else {
                animation = null;
            }
        }
        else {
            if (this.animation.next.effect === 'SlideRightIn') {
                animation = {
                    name: 'SlideRightOut',
                    duration: this.animation.next.duration, timingFunction: this.animation.next.easing
                };
            }
            else {
                animation = null;
            }
        }
        return animation;
    };
    Tab.prototype.triggerPrevAnimation = function (oldCnt, prevIndex) {
        var _this = this;
        var animateObj = this.prevCtnAnimation(prevIndex, this.selectedItem);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(animateObj)) {
            animateObj.begin = function () {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(oldCnt, { 'position': 'absolute' });
                oldCnt.classList.add(CLS_PROGRESS);
                oldCnt.classList.add('e-view');
            };
            animateObj.end = function () {
                oldCnt.style.display = 'none';
                oldCnt.classList.remove(CLS_ACTIVE);
                oldCnt.classList.remove(CLS_PROGRESS);
                oldCnt.classList.remove('e-view');
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(oldCnt, { 'display': '', 'position': '' });
                if (oldCnt.childNodes.length === 0 && !_this.isTemplate) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(oldCnt);
                }
            };
            new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["b" /* Animation */](animateObj).animate(oldCnt);
        }
        else {
            oldCnt.classList.remove(CLS_ACTIVE);
        }
    };
    Tab.prototype.triggerAnimation = function (id, value) {
        var _this = this;
        var prevIndex = this.prevIndex;
        var oldCnt;
        var itemCollection = [].slice.call(this.element.querySelector('.' + CLS_CONTENT).children);
        itemCollection.forEach(function (item) {
            if (item.id === _this.prevActiveEle) {
                oldCnt = item;
            }
        });
        var prevEle = this.tbItem[prevIndex];
        var newCnt = this.getTrgContent(this.cntEle, this.extIndex(id));
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(oldCnt) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(prevEle)) {
            var idNo = this.extIndex(prevEle.id);
            oldCnt = this.getTrgContent(this.cntEle, idNo);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(newCnt)) {
            this.prevActiveEle = newCnt.id;
        }
        if (this.initRender || value === false || this.animation === {} || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.animation)) {
            if (oldCnt && oldCnt !== newCnt) {
                oldCnt.classList.remove(CLS_ACTIVE);
            }
            return;
        }
        var cnt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_CONTENT, this.element);
        var animateObj;
        if (this.prevIndex > this.selectedItem && !this.isPopup) {
            var openEff = this.animation.previous.effect;
            animateObj = {
                name: ((openEff === 'None') ? '' : ((openEff !== 'SlideLeftIn') ? openEff : 'SlideLeftIn')),
                duration: this.animation.previous.duration,
                timingFunction: this.animation.previous.easing
            };
        }
        else if (this.isPopup || this.prevIndex < this.selectedItem || this.prevIndex === this.selectedItem) {
            var clsEff = this.animation.next.effect;
            animateObj = {
                name: ((clsEff === 'None') ? '' : ((clsEff !== 'SlideRightIn') ? clsEff : 'SlideRightIn')),
                duration: this.animation.next.duration,
                timingFunction: this.animation.next.easing
            };
        }
        animateObj.progress = function () {
            cnt.classList.add(CLS_PROGRESS);
            _this.setActiveBorder();
        };
        animateObj.end = function () {
            cnt.classList.remove(CLS_PROGRESS);
            newCnt.classList.add(CLS_ACTIVE);
        };
        if (!this.initRender && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(oldCnt)) {
            this.triggerPrevAnimation(oldCnt, prevIndex);
        }
        this.isPopup = false;
        if (animateObj.name === '') {
            newCnt.classList.add(CLS_ACTIVE);
        }
        else {
            new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["b" /* Animation */](animateObj).animate(newCnt);
        }
    };
    Tab.prototype.keyPressed = function (trg) {
        var trgParent = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trg, '.' + CLS_HEADER + ' .' + CLS_TB_ITEM);
        var trgIndex = this.getEleIndex(trgParent);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.popEle) && trg.classList.contains('e-hor-nav')) {
            (this.popEle.classList.contains(CLS_POPUP_OPEN)) ? this.popObj.hide(this.hide) : this.popObj.show(this.show);
        }
        else if (trg.classList.contains('e-scroll-nav')) {
            trg.click();
        }
        else {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(trgParent) && trgParent.classList.contains(CLS_ACTIVE) === false) {
                this.selectTab(trgIndex, null, true);
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.popEle)) {
                    this.popObj.hide(this.hide);
                }
            }
        }
    };
    Tab.prototype.getTabHeader = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element)) {
            return undefined;
        }
        var headers = [].slice.call(this.element.children).filter(function (e) { return e.classList.contains(CLS_HEADER); });
        if (headers.length > 0) {
            return headers[0];
        }
        else {
            var wrap = [].slice.call(this.element.children).filter(function (e) { return !e.classList.contains(CLS_BLA_TEM); })[0];
            if (!wrap) {
                return undefined;
            }
            return [].slice.call(wrap.children).filter(function (e) { return e.classList.contains(CLS_HEADER); })[0];
        }
    };
    Tab.prototype.getEleIndex = function (item) {
        return Array.prototype.indexOf.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEM, this.getTabHeader()), item);
    };
    Tab.prototype.extIndex = function (id) {
        return id.replace(CLS_ITEM + this.tabId + '_', '');
    };
    Tab.prototype.expTemplateContent = function () {
        var _this = this;
        this.templateEle.forEach(function (eleStr) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(_this.element.querySelector(eleStr))) {
                document.body.appendChild(_this.element.querySelector(eleStr)).style.display = 'none';
            }
        });
    };
    Tab.prototype.templateCompile = function (ele, cnt, index) {
        var tempEle = this.createElement('div');
        this.compileElement(tempEle, cnt, 'content', index);
        if (tempEle.childNodes.length !== 0) {
            ele.appendChild(tempEle);
        }
        if (this.isReact) {
            this.renderReactTemplates();
        }
    };
    Tab.prototype.compileElement = function (ele, val, prop, index) {
        var templateFn;
        if (typeof val === 'string') {
            val = val.trim();
            if (this.isVue) {
                templateFn = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(val));
            }
            else {
                ele.innerHTML = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(val);
            }
        }
        else {
            templateFn = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(val);
        }
        var templateFUN;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(templateFn)) {
            templateFUN = templateFn({}, this, prop);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(templateFn) && templateFUN.length > 0) {
            [].slice.call(templateFUN).forEach(function (el) {
                ele.appendChild(el);
            });
        }
    };
    Tab.prototype.headerTextCompile = function (element, text, index) {
        this.compileElement(element, text, 'headerTemplate', index);
    };
    Tab.prototype.getContent = function (ele, cnt, callType, index) {
        var eleStr;
        cnt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(cnt) ? "" : cnt;
        if (typeof cnt === 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(cnt.innerHTML)) {
            if (typeof cnt === 'string' && this.enableHtmlSanitizer) {
                cnt = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(cnt);
            }
            if (cnt[0] === '.' || cnt[0] === '#') {
                if (document.querySelectorAll(cnt).length) {
                    var eleVal = document.querySelector(cnt);
                    eleStr = eleVal.outerHTML.trim();
                    if (callType === 'clone') {
                        ele.appendChild(eleVal.cloneNode(true));
                    }
                    else {
                        ele.appendChild(eleVal);
                        eleVal.style.display = '';
                    }
                }
                else {
                    this.templateCompile(ele, cnt, index);
                }
            }
            else {
                this.templateCompile(ele, cnt, index);
            }
        }
        else {
            ele.appendChild(cnt);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(eleStr)) {
            if (this.templateEle.indexOf(cnt.toString()) === -1) {
                this.templateEle.push(cnt.toString());
            }
        }
    };
    Tab.prototype.getTrgContent = function (cntEle, no) {
        var ele;
        if (this.element.classList.contains(CLS_NEST)) {
            ele = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_NEST + '> .' + CLS_CONTENT + ' > #' + CLS_CONTENT + this.tabId + '_' + no, this.element);
        }
        else {
            ele = this.findEle(cntEle.children, CLS_CONTENT + this.tabId + '_' + no);
        }
        return ele;
    };
    Tab.prototype.findEle = function (items, key) {
        var ele;
        for (var i = 0; i < items.length; i++) {
            if (items[i].id === key) {
                ele = items[i];
                break;
            }
        }
        return ele;
    };
    Tab.prototype.isVertical = function () {
        var isVertical = (this.headerPlacement === 'Left' || this.headerPlacement === 'Right') ? true : false;
        this.scrCntClass = (isVertical) ? CLS_VSCRCNT : CLS_HSCRCNT;
        return isVertical;
    };
    Tab.prototype.addVerticalClass = function () {
        if (this.isVertical()) {
            var tbPos = (this.headerPlacement === 'Left') ? CLS_VLEFT : CLS_VRIGHT;
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.hdrEle], [CLS_VERTICAL, tbPos]);
            if (!this.element.classList.contains(CLS_NEST)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], [CLS_VTAB, tbPos]);
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.hdrEle], [CLS_VTAB, tbPos]);
            }
        }
        if (this.headerPlacement === 'Bottom') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.hdrEle], [CLS_HBOTTOM]);
        }
    };
    Tab.prototype.updatePopAnimationConfig = function () {
        this.show = { name: (this.isVertical() ? 'FadeIn' : 'SlideDown'), duration: 100 };
        this.hide = { name: (this.isVertical() ? 'FadeOut' : 'SlideUp'), duration: 100 };
    };
    Tab.prototype.changeOrientation = function (place) {
        this.setOrientation(place, this.hdrEle);
        var activeTab = this.hdrEle.querySelector('.' + CLS_ACTIVE);
        var isVertical = this.hdrEle.classList.contains(CLS_VERTICAL) ? true : false;
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], [CLS_VTAB]);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.hdrEle], [CLS_VERTICAL, CLS_VLEFT, CLS_VRIGHT]);
        if (isVertical !== this.isVertical()) {
            this.changeToolbarOrientation();
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(activeTab) && activeTab.classList.contains(CLS_TB_POPUP)) {
                this.popupHandler(activeTab);
            }
        }
        this.addVerticalClass();
        this.updateOrientationAttribute();
        this.setActiveBorder();
        this.focusItem();
    };
    Tab.prototype.focusItem = function () {
        var curActItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])(' #' + CLS_ITEM + this.tabId + '_' + this.selectedItem, this.hdrEle);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(curActItem)) {
            curActItem.firstElementChild.focus();
        }
    };
    Tab.prototype.changeToolbarOrientation = function () {
        this.tbObj.setProperties({ height: (this.isVertical() ? '100%' : 'auto'), width: (this.isVertical() ? 'auto' : '100%') }, true);
        this.tbObj.changeOrientation();
        this.updatePopAnimationConfig();
    };
    Tab.prototype.setOrientation = function (place, ele) {
        var headerPos = Array.prototype.indexOf.call(this.element.children, ele);
        var contentPos = Array.prototype.indexOf.call(this.element.children, this.element.querySelector('.' + CLS_CONTENT));
        if (place === 'Bottom' && (contentPos > headerPos)) {
            this.element.appendChild(ele);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([ele], [CLS_HBOTTOM]);
            this.element.insertBefore(ele, Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_CONTENT, this.element));
        }
    };
    Tab.prototype.setCssClass = function (ele, cls, val) {
        if (cls === '') {
            return;
        }
        var list = cls.split(' ');
        for (var i = 0; i < list.length; i++) {
            if (val) {
                ele.classList.add(list[i]);
            }
            else {
                ele.classList.remove(list[i]);
            }
        }
    };
    Tab.prototype.setContentHeight = function (val) {
        if (this.element.classList.contains(CLS_FILL)) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], [CLS_FILL]);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.cntEle)) {
            return;
        }
        var hdrEle = this.getTabHeader();
        if (this.heightAdjustMode === 'None') {
            if (this.height === 'auto') {
                return;
            }
            else {
                if (!this.isVertical()) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.cntEle, { 'height': (this.element.offsetHeight - hdrEle.offsetHeight) + 'px' });
                }
            }
        }
        else if (this.heightAdjustMode === 'Fill') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], [CLS_FILL]);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'height': '100%' });
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.cntEle, { 'height': (this.element.offsetHeight - hdrEle.offsetHeight) + 'px' });
        }
        else if (this.heightAdjustMode === 'Auto') {
            if (this.isTemplate === true) {
                var cnt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_CONTENT + ' > .' + CLS_ITEM, this.element);
                for (var i = 0; i < cnt.length; i++) {
                    cnt[i].setAttribute('style', 'display:block; visibility: visible');
                    this.maxHeight = Math.max(this.maxHeight, this.getHeight(cnt[i]));
                    cnt[i].style.removeProperty('display');
                    cnt[i].style.removeProperty('visibility');
                }
            }
            else {
                this.cntEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_CONTENT, this.element);
                if (val === true) {
                    this.cntEle.appendChild(this.createElement('div', {
                        id: (CLS_CONTENT + this.tabId + '_' + 0), className: CLS_ITEM + ' ' + CLS_ACTIVE,
                        attrs: { 'role': 'tabpanel', 'aria-labelledby': CLS_ITEM + this.tabId + '_' + 0 }
                    }));
                }
                var ele = this.cntEle.children.item(0);
                for (var i = 0; i < this.items.length; i++) {
                    this.getContent(ele, this.items[i].content, 'clone', i);
                    this.maxHeight = Math.max(this.maxHeight, this.getHeight(ele));
                    while (ele.firstChild) {
                        ele.removeChild(ele.firstChild);
                    }
                }
                if (this.isReact) {
                    this.clearTemplate(['content']);
                }
                this.templateEle = [];
                this.getContent(ele, this.items[0].content, 'render', 0);
                if (this.prevIndex !== this.selectedItem) {
                    ele.classList.remove(CLS_ACTIVE);
                }
            }
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.cntEle, { 'height': this.maxHeight + 'px' });
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.cntEle, { 'height': 'auto' });
        }
    };
    Tab.prototype.getHeight = function (ele) {
        var cs = window.getComputedStyle(ele);
        return ele.offsetHeight + parseFloat(cs.getPropertyValue('padding-top')) + parseFloat(cs.getPropertyValue('padding-bottom')) +
            parseFloat(cs.getPropertyValue('margin-top')) + parseFloat(cs.getPropertyValue('margin-bottom'));
    };
    Tab.prototype.setActiveBorder = function () {
        var trgHdrEle = this.getTabHeader();
        var trg = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TB_ITEM + '.' + CLS_ACTIVE, trgHdrEle);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(trg)) {
            return;
        }
        if (!this.reorderActiveTab) {
            if (trg.classList.contains(CLS_TB_POPUP) && !this.bdrLine.classList.contains(CLS_HIDDEN)) {
                this.bdrLine.classList.add(CLS_HIDDEN);
            }
            if (trgHdrEle && !trgHdrEle.classList.contains(CLS_REORDER_ACTIVE_ITEM)) {
                trgHdrEle.classList.add(CLS_REORDER_ACTIVE_ITEM);
            }
        }
        else if (trgHdrEle) {
            trgHdrEle.classList.remove(CLS_REORDER_ACTIVE_ITEM);
        }
        var root = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trg, '.' + CLS_TAB);
        if (this.element !== root) {
            return;
        }
        this.tbItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TB_ITEMS, trgHdrEle);
        var bar = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_INDICATOR, trgHdrEle);
        var scrollCnt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TB_ITEMS + ' .' + this.scrCntClass, trgHdrEle);
        if (this.isVertical()) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(bar, { 'left': '', 'right': '' });
            var tbHeight = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(scrollCnt)) ? this.tbItems.offsetHeight : scrollCnt.offsetHeight;
            if (tbHeight !== 0) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(bar, { 'top': trg.offsetTop + 'px', 'height': trg.offsetHeight + 'px' });
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(bar, { 'top': 0, 'height': 0 });
            }
        }
        else {
            if (this.overflowMode === 'MultiRow') {
                var bar_1 = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_INDICATOR, this.element);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(bar_1, { 'top': trg.offsetHeight + trg.offsetTop + 'px', 'height': '' });
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(bar, { 'top': '', 'height': '' });
            }
            var tbWidth = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(scrollCnt)) ? this.tbItems.offsetWidth : scrollCnt.offsetWidth;
            if (tbWidth !== 0) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(bar, { 'left': trg.offsetLeft + 'px', 'right': tbWidth - (trg.offsetLeft + trg.offsetWidth) + 'px' });
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(bar, { 'left': 'auto', 'right': 'auto' });
            }
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.bdrLine) && !trg.classList.contains(CLS_TB_POPUP)) {
            this.bdrLine.classList.remove(CLS_HIDDEN);
        }
    };
    Tab.prototype.setActive = function (value, skipDataBind, isInteracted) {
        if (skipDataBind === void 0) { skipDataBind = false; }
        if (isInteracted === void 0) { isInteracted = false; }
        this.tbItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEM, this.getTabHeader());
        var trg = this.tbItem[value];
        if (value < 0 || isNaN(value) || this.tbItem.length === 0) {
            return;
        }
        if (value >= 0 && !skipDataBind) {
            this.allowServerDataBinding = false;
            this.setProperties({ selectedItem: value }, true);
            this.allowServerDataBinding = true;
            if (!this.initRender) {
                this.serverDataBind();
            }
        }
        if (trg.classList.contains(CLS_ACTIVE)) {
            this.setActiveBorder();
            return;
        }
        if (!this.isTemplate) {
            var prev = this.tbItem[this.prevIndex];
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(prev)) {
                prev.removeAttribute('aria-controls');
            }
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(trg, { 'aria-controls': CLS_CONTENT + this.tabId + '_' + value });
        }
        var id = trg.id;
        this.removeActiveClass();
        trg.classList.add(CLS_ACTIVE);
        this.tbItem[this.prevIndex].setAttribute('aria-selected', 'false');
        trg.setAttribute('aria-selected', 'true');
        var no = Number(this.extIndex(id));
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.prevActiveEle)) {
            this.prevActiveEle = CLS_CONTENT + this.tabId + '_' + no;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'aria-activedescendant': id });
        if (this.isTemplate) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_CONTENT, this.element).children.length > 0) {
                var trg_1 = this.findEle(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_CONTENT, this.element).children, CLS_CONTENT + this.tabId + '_' + no);
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(trg_1)) {
                    trg_1.classList.add(CLS_ACTIVE);
                }
                this.triggerAnimation(id, this.enableAnimation);
            }
        }
        else {
            this.cntEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TAB + ' > .' + CLS_CONTENT, this.element);
            var item = this.getTrgContent(this.cntEle, this.extIndex(id));
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item)) {
                this.cntEle.appendChild(this.createElement('div', {
                    id: CLS_CONTENT + this.tabId + '_' + this.extIndex(id), className: CLS_ITEM + ' ' + CLS_ACTIVE,
                    attrs: { role: 'tabpanel', 'aria-labelledby': CLS_ITEM + this.tabId + '_' + this.extIndex(id) }
                }));
                var eleTrg = this.getTrgContent(this.cntEle, this.extIndex(id));
                var itemIndex = Array.prototype.indexOf.call(this.itemIndexArray, id);
                this.getContent(eleTrg, this.items[itemIndex].content, 'render', itemIndex);
            }
            else {
                item.classList.add(CLS_ACTIVE);
            }
            this.triggerAnimation(id, this.enableAnimation);
        }
        this.setActiveBorder();
        this.refreshItemVisibility(trg);
        if (!this.initRender && !skipDataBind) {
            trg.firstElementChild.focus();
            var eventArg = {
                previousItem: this.prevItem,
                previousIndex: this.prevIndex,
                selectedItem: trg,
                selectedIndex: value,
                selectedContent: Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('#' + CLS_CONTENT + this.tabId + '_' + this.selectingID, this.content),
                isSwiped: this.isSwipeed,
                isInteracted: isInteracted
            };
            this.trigger('selected', eventArg);
        }
    };
    Tab.prototype.contentReady = function () {
        var id = this.setActiveContent();
        this.triggerAnimation(id, this.enableAnimation);
    };
    Tab.prototype.setItems = function (items) {
        this.isReplace = true;
        this.tbItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TB_ITEMS, this.getTabHeader());
        this.tbObj.items = this.parseObject(items, 0);
        this.tbObj.dataBind();
        this.isReplace = false;
    };
    Tab.prototype.setRTL = function (value) {
        this.tbObj.enableRtl = value;
        this.tbObj.dataBind();
        this.setCssClass(this.element, CLS_RTL, value);
        this.refreshActiveBorder();
    };
    Tab.prototype.refreshActiveBorder = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.bdrLine)) {
            this.bdrLine.classList.add(CLS_HIDDEN);
        }
        this.setActiveBorder();
    };
    Tab.prototype.showPopup = function (config) {
        var tbPop = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-popup.e-toolbar-pop', this.hdrEle);
        if (tbPop.classList.contains('e-popup-close')) {
            var tbPopObj = (tbPop && tbPop.ej2_instances[0]);
            tbPopObj.position.X = (this.headerPlacement === 'Left') ? 'left' : 'right';
            tbPopObj.dataBind();
            tbPopObj.show(config);
        }
    };
    Tab.prototype.bindDraggable = function () {
        var _this = this;
        if (this.allowDragAndDrop) {
            var tabHeader = this.element.querySelector('.' + CLS_HEADER);
            if (tabHeader) {
                var items = tabHeader.querySelectorAll('.' + CLS_TB_ITEM);
                items.forEach(function (element) {
                    _this.initializeDrag(element);
                });
            }
        }
    };
    Tab.prototype.wireEvents = function () {
        this.bindDraggable();
        window.addEventListener('resize', this.resizeContext);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'mouseover', this.hoverHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'keydown', this.spaceKeyDown, this);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.cntEle)) {
            this.touchModule = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["t" /* Touch */](this.cntEle, { swipe: this.swipeHandler.bind(this) });
        }
        this.keyModule = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["n" /* KeyboardEvents */](this.element, { keyAction: this.keyHandler.bind(this), keyConfigs: this.keyConfigs });
        this.tabKeyModule = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["n" /* KeyboardEvents */](this.element, {
            keyAction: this.keyHandler.bind(this),
            keyConfigs: { openPopup: 'shift+f10', tab: 'tab', shiftTab: 'shift+tab' },
            eventName: 'keydown'
        });
    };
    Tab.prototype.unWireEvents = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.keyModule)) {
            this.keyModule.destroy();
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.tabKeyModule)) {
            this.tabKeyModule.destroy();
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.cntEle) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.touchModule)) {
            this.touchModule.destroy();
            this.touchModule = null;
        }
        window.removeEventListener('resize', this.resizeContext);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'mouseover', this.hoverHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'keydown', this.spaceKeyDown);
        this.element.classList.remove(CLS_RTL);
        this.element.classList.remove(CLS_FOCUS);
    };
    Tab.prototype.clickHandler = function (args) {
        this.element.classList.remove(CLS_FOCUS);
        var trg = args.originalEvent.target;
        var trgParent = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trg, '.' + CLS_TB_ITEM);
        var trgIndex = this.getEleIndex(trgParent);
        if (trg.classList.contains(CLS_ICON_CLOSE)) {
            this.removeTab(trgIndex);
        }
        else if (this.isVertical() && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trg, '.' + CLS_HOR_NAV)) {
            this.showPopup(this.show);
        }
        else {
            this.isPopup = false;
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(trgParent) && (trgIndex !== this.selectedItem || trgIndex !== this.prevIndex)) {
                this.selectTab(trgIndex, args.originalEvent, true);
            }
        }
    };
    Tab.prototype.swipeHandler = function (e) {
        if (e.velocity < 3 && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e.originalEvent.changedTouches)) {
            return;
        }
        if (this.isNested) {
            this.element.setAttribute('data-swipe', 'true');
        }
        var nestedTab = this.element.querySelector('[data-swipe="true"]');
        if (nestedTab) {
            nestedTab.removeAttribute('data-swipe');
            return;
        }
        this.isSwipeed = true;
        if (e.swipeDirection === 'Right' && this.selectedItem !== 0) {
            for (var k = this.selectedItem - 1; k >= 0; k--) {
                if (!this.tbItem[k].classList.contains(CLS_HIDDEN)) {
                    this.selectTab(k, null, true);
                    break;
                }
            }
        }
        else if (e.swipeDirection === 'Left' && (this.selectedItem !== Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEM, this.element).length - 1)) {
            for (var i = this.selectedItem + 1; i < this.tbItem.length; i++) {
                if (!this.tbItem[i].classList.contains(CLS_HIDDEN)) {
                    this.selectTab(i, null, true);
                    break;
                }
            }
        }
        this.isSwipeed = false;
    };
    Tab.prototype.spaceKeyDown = function (e) {
        if ((e.keyCode === 32 && e.which === 32) || (e.keyCode === 35 && e.which === 35)) {
            var clstHead = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.' + CLS_HEADER);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(clstHead)) {
                e.preventDefault();
            }
        }
    };
    Tab.prototype.keyHandler = function (e) {
        if (this.element.classList.contains(CLS_DISABLE)) {
            return;
        }
        this.element.classList.add(CLS_FOCUS);
        var trg = e.target;
        var tabHeader = this.getTabHeader();
        var actEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_ACTIVE, tabHeader);
        this.popEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TB_POP, tabHeader);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.popEle)) {
            this.popObj = this.popEle.ej2_instances[0];
        }
        var item = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(document.activeElement, '.' + CLS_TB_ITEM);
        var trgParent = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trg, '.' + CLS_TB_ITEM);
        switch (e.action) {
            case 'space':
            case 'enter':
                if (trg.parentElement.classList.contains(CLS_DISABLE)) {
                    return;
                }
                if (e.action === 'enter' && trg.classList.contains('e-hor-nav')) {
                    this.showPopup(this.show);
                    break;
                }
                this.keyPressed(trg);
                break;
            case 'tab':
            case 'shiftTab':
                if (trg.classList.contains(CLS_WRAP)
                    && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(trg, '.' + CLS_TB_ITEM).classList.contains(CLS_ACTIVE) === false) {
                    trg.setAttribute('tabindex', '-1');
                }
                if (this.popObj && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(this.popObj.element)) {
                    this.popObj.hide(this.hide);
                }
                actEle.children.item(0).setAttribute('tabindex', '0');
                break;
            case 'moveLeft':
            case 'moveRight':
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item)) {
                    this.refreshItemVisibility(item);
                }
                break;
            case 'openPopup':
                e.preventDefault();
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.popEle) && this.popEle.classList.contains(CLS_POPUP_CLOSE)) {
                    this.popObj.show(this.show);
                }
                break;
            case 'delete':
                if (this.showCloseButton === true && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(trgParent)) {
                    var nxtSib = trgParent.nextSibling;
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(nxtSib) && nxtSib.classList.contains(CLS_TB_ITEM)) {
                        nxtSib.firstElementChild.focus();
                    }
                    this.removeTab(this.getEleIndex(trgParent));
                }
                this.setActiveBorder();
                break;
        }
    };
    /**
     * Refresh the active tab border
     *
     * @returns {void}
     * @private
     */
    Tab.prototype.refreshActiveTabBorder = function () {
        var activeEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TB_ITEM + '.' + CLS_TB_POPUP + '.' + CLS_ACTIVE, this.element);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(activeEle) && this.reorderActiveTab) {
            this.select(this.getEleIndex(activeEle));
        }
        this.refreshActiveBorder();
    };
    Tab.prototype.refreshItemVisibility = function (target) {
        var scrCnt = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + this.scrCntClass, this.tbItems);
        if (!this.isVertical() && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(scrCnt)) {
            var scrBar = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-hscroll-bar', this.tbItems);
            var scrStart = scrBar.scrollLeft;
            var scrEnd = scrStart + scrBar.offsetWidth;
            var eleStart = target.offsetLeft;
            var eleWidth = target.offsetWidth;
            var eleEnd = target.offsetLeft + target.offsetWidth;
            if ((scrStart < eleStart) && (scrEnd < eleEnd)) {
                var eleViewRange = scrEnd - eleStart;
                scrBar.scrollLeft = scrStart + (eleWidth - eleViewRange);
            }
            else {
                if ((scrStart > eleStart) && (scrEnd > eleEnd)) {
                    var eleViewRange = eleEnd - scrStart;
                    scrBar.scrollLeft = scrStart - (eleWidth - eleViewRange);
                }
            }
        }
        else {
            return;
        }
    };
    Tab.prototype.hoverHandler = function (e) {
        var trg = e.target;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(trg.classList) && trg.classList.contains(CLS_ICON_CLOSE)) {
            trg.setAttribute('title', new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["o" /* L10n */]('tab', { closeButtonTitle: this.title }, this.locale).getConstant('closeButtonTitle'));
        }
    };
    Tab.prototype.evalOnPropertyChangeItems = function (newProp, oldProp) {
        if (!(newProp.items instanceof Array && oldProp.items instanceof Array)) {
            var changedProp = Object.keys(newProp.items);
            for (var i = 0; i < changedProp.length; i++) {
                var index = parseInt(Object.keys(newProp.items)[i], 10);
                var properties = Object.keys(newProp.items[index]);
                for (var j = 0; j < properties.length; j++) {
                    var oldVal = Object(oldProp.items[index])[properties[j]];
                    var newVal = Object(newProp.items[index])[properties[j]];
                    var hdr = this.element.querySelectorAll('.' + CLS_TB_ITEM)[index];
                    var itemIndex = void 0;
                    if (hdr && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(hdr.id) && hdr.id !== '') {
                        var num = (hdr.id.lastIndexOf('_'));
                        itemIndex = parseInt(hdr.id.substring(num + 1), 10);
                    }
                    else {
                        itemIndex = index;
                    }
                    var hdrItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TB_ITEMS + ' #' + CLS_ITEM + this.tabId + '_' + itemIndex, this.element);
                    var cntItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_CONTENT + ' #' + CLS_CONTENT + this.tabId + '_' + itemIndex, this.element);
                    if (properties[j] === 'header' || properties[j] === 'headerTemplate') {
                        var icon = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.items[index].header) ||
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.items[index].header.iconCss)) ? '' : this.items[index].header.iconCss;
                        var textVal = this.items[index].headerTemplate || this.items[index].header.text;
                        if ((textVal === '') && (icon === '')) {
                            this.removeTab(index);
                        }
                        else {
                            this.tbId = hdr.id;
                            var arr = [];
                            arr.push(this.items[index]);
                            this.items.splice(index, 1);
                            this.itemIndexArray.splice(index, 1);
                            this.tbObj.items.splice(index, 1);
                            var isHiddenEle = hdrItem.classList.contains(CLS_HIDDEN);
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(hdrItem);
                            this.isReplace = true;
                            this.addTab(arr, index);
                            if (isHiddenEle) {
                                this.hideTab(index);
                            }
                            this.isReplace = false;
                        }
                    }
                    if (properties[j] === 'content' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(cntItem)) {
                        var strVal = typeof newVal === 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(newVal.innerHTML);
                        if (strVal && (newVal[0] === '.' || newVal[0] === '#') && newVal.length) {
                            var eleVal = document.querySelector(newVal);
                            cntItem.appendChild(eleVal);
                            eleVal.style.display = '';
                        }
                        else if (newVal === '' && oldVal[0] === '#') {
                            document.body.appendChild(this.element.querySelector(oldVal)).style.display = 'none';
                            cntItem.innerHTML = newVal;
                        }
                        else if (this.isReact) {
                            cntItem.innerHTML = '';
                            this.templateCompile(cntItem, newVal, index);
                        }
                        else if (typeof newVal !== 'function') {
                            cntItem.innerHTML = newVal;
                        }
                    }
                    if (properties[j] === 'cssClass') {
                        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(hdrItem)) {
                            hdrItem.classList.remove(oldVal);
                            hdrItem.classList.add(newVal);
                        }
                        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(cntItem)) {
                            cntItem.classList.remove(oldVal);
                            cntItem.classList.add(newVal);
                        }
                    }
                    if (properties[j] === 'disabled') {
                        this.enableTab(index, ((newVal === true) ? false : true));
                    }
                    if (properties[j] === 'visible') {
                        this.hideTab(index, ((newVal === true) ? false : true));
                    }
                }
            }
        }
        else {
            this.lastIndex = 0;
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.tbObj)) {
                this.reRenderItems();
            }
            else {
                if (this.isReact || this.isAngular) {
                    this.clearTemplate();
                }
                this.setItems(newProp.items);
                if (this.templateEle.length > 0) {
                    this.expTemplateContent();
                }
                this.templateEle = [];
                var selectElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TAB + ' > .' + CLS_CONTENT, this.element);
                while (selectElement.firstElementChild) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(selectElement.firstElementChild);
                }
                this.select(this.selectedItem);
                this.draggableItems = [];
                this.bindDraggable();
            }
        }
    };
    Tab.prototype.initializeDrag = function (target) {
        var _this = this;
        var dragObj = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["i" /* Draggable */](target, {
            dragArea: this.dragArea,
            dragTarget: '.' + CLS_TB_ITEM,
            clone: true,
            helper: this.helper.bind(this),
            dragStart: this.itemDragStart.bind(this),
            drag: function (e) {
                var dragIndex = _this.getEleIndex(_this.dragItem);
                var dropIndex;
                var dropItem;
                var dragArgs = {
                    draggedItem: _this.dragItem,
                    event: e.event,
                    target: e.target,
                    droppedItem: e.target.closest('.' + CLS_TB_ITEM),
                    clonedElement: _this.cloneElement,
                    index: dragIndex
                };
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e.target.closest('.' + CLS_TAB)) && !e.target.closest('.' + CLS_TAB).isEqualNode(_this.element) &&
                    _this.dragArea !== '.' + CLS_HEADER) {
                    _this.trigger('dragging', dragArgs);
                }
                else {
                    if (!(e.target.closest(_this.dragArea)) && _this.overflowMode !== 'Popup') {
                        document.body.style.cursor = 'not-allowed';
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([_this.cloneElement], CLS_HIDDEN);
                        if (_this.dragItem.classList.contains(CLS_HIDDEN)) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([_this.dragItem], CLS_HIDDEN);
                        }
                        _this.dragItem.querySelector('.' + CLS_WRAP).style.visibility = 'visible';
                    }
                    else {
                        document.body.style.cursor = '';
                        _this.dragItem.querySelector('.' + CLS_WRAP).style.visibility = 'hidden';
                        if (_this.cloneElement.classList.contains(CLS_HIDDEN)) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([_this.cloneElement], CLS_HIDDEN);
                        }
                    }
                    if (_this.overflowMode === 'Scrollable' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(_this.element.querySelector('.e-hscroll'))) {
                        var scrollRightNavEle = _this.element.querySelector('.e-scroll-right-nav');
                        var scrollLeftNavEle = _this.element.querySelector('.e-scroll-left-nav');
                        var hscrollBar = _this.element.querySelector('.e-hscroll-bar');
                        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(scrollRightNavEle) && Math.abs((scrollRightNavEle.offsetWidth / 2) +
                            scrollRightNavEle.offsetLeft) > _this.cloneElement.offsetLeft + _this.cloneElement.offsetWidth) {
                            hscrollBar.scrollLeft -= 10;
                        }
                        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(scrollLeftNavEle) && Math.abs((scrollLeftNavEle.offsetLeft + scrollLeftNavEle.offsetWidth) -
                            _this.cloneElement.offsetLeft) > (scrollLeftNavEle.offsetWidth / 2)) {
                            hscrollBar.scrollLeft += 10;
                        }
                    }
                    _this.cloneElement.style.pointerEvents = 'none';
                    dropItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.' + CLS_TB_ITEM + '.e-draggable');
                    var scrollContentWidth = 0;
                    if (_this.overflowMode === 'Scrollable' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(_this.element.querySelector('.e-hscroll'))) {
                        scrollContentWidth = _this.element.querySelector('.e-hscroll-content').offsetWidth;
                    }
                    if (dropItem != null && !dropItem.isSameNode(_this.dragItem) &&
                        dropItem.closest('.' + CLS_TAB).isSameNode(_this.dragItem.closest('.' + CLS_TAB))) {
                        dropIndex = _this.getEleIndex(dropItem);
                        if (dropIndex < dragIndex &&
                            (Math.abs((dropItem.offsetLeft + dropItem.offsetWidth) -
                                _this.cloneElement.offsetLeft) > (dropItem.offsetWidth / 2))) {
                            _this.dragAction(dropItem, dragIndex, dropIndex);
                        }
                        if (dropIndex > dragIndex &&
                            (Math.abs(dropItem.offsetWidth / 2) + dropItem.offsetLeft -
                                scrollContentWidth) < _this.cloneElement.offsetLeft + _this.cloneElement.offsetWidth) {
                            _this.dragAction(dropItem, dragIndex, dropIndex);
                        }
                    }
                    _this.droppedIndex = _this.getEleIndex(_this.dragItem);
                    _this.trigger('dragging', dragArgs);
                }
            },
            dragStop: this.itemDragStop.bind(this)
        });
        this.draggableItems.push(dragObj);
    };
    Tab.prototype.helper = function (e) {
        this.cloneElement = this.createElement('div');
        if (e.element) {
            this.cloneElement = (e.element.cloneNode(true));
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.cloneElement], 'e-tab-clone-element');
            if (this.element.querySelector('.' + CLS_HEADER).classList.contains(CLS_CLOSE_SHOW)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.cloneElement], CLS_CLOSE_SHOW);
            }
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.cloneElement.querySelector('.' + CLS_WRAP)], 'e-ripple');
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.cloneElement.querySelector('.e-ripple-element'))) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(this.cloneElement.querySelector('.e-ripple-element'));
            }
            document.body.appendChild(this.cloneElement);
        }
        return this.cloneElement;
    };
    Tab.prototype.itemDragStart = function (e) {
        var _this = this;
        this.draggingItems = this.items.map(function (x) { return x; });
        this.dragItem = e.element;
        var dragArgs = {
            draggedItem: e.element,
            event: e.event,
            target: e.target,
            droppedItem: null,
            index: this.getEleIndex(this.dragItem),
            clonedElement: this.cloneElement,
            cancel: false
        };
        this.trigger('onDragStart', dragArgs, function (tabitemDragArgs) {
            if (tabitemDragArgs.cancel) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(_this.cloneElement);
            }
            else {
                _this.removeActiveClass();
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([_this.tbItems.querySelector('.' + CLS_INDICATOR)], CLS_HIDDEN);
                _this.dragItem.querySelector('.' + CLS_WRAP).style.visibility = 'hidden';
            }
        });
    };
    Tab.prototype.dragAction = function (dropItem, dragsIndex, dropIndex) {
        if (this.items.length > 0) {
            var item = this.draggingItems[dragsIndex];
            this.draggingItems.splice(dragsIndex, 1);
            this.draggingItems.splice(dropIndex, 0, item);
        }
        if (this.overflowMode === 'MultiRow') {
            dropItem.parentNode.insertBefore(this.dragItem, dropItem.nextElementSibling);
        }
        if (dragsIndex > dropIndex) {
            if (!(this.dragItem.parentElement).isSameNode(dropItem.parentElement)) {
                if (this.overflowMode === 'Extended') {
                    if (dropItem.isSameNode(dropItem.parentElement.lastChild)) {
                        var popupContainer = this.dragItem.parentNode;
                        dropItem.parentNode.insertBefore(this.dragItem, dropItem);
                        popupContainer.insertBefore(dropItem.parentElement.lastChild, popupContainer.childNodes[0]);
                    }
                    else {
                        this.dragItem.parentNode.insertBefore((dropItem.parentElement.lastChild), this.dragItem.parentElement.childNodes[0]);
                        dropItem.parentNode.insertBefore(this.dragItem, dropItem);
                    }
                }
                else {
                    var lastEle = (dropItem.parentElement).lastChild;
                    if (dropItem.isSameNode(lastEle)) {
                        var popupContainer = this.dragItem.parentNode;
                        dropItem.parentNode.insertBefore(this.dragItem, dropItem);
                        popupContainer.insertBefore(lastEle, popupContainer.childNodes[0]);
                    }
                    else {
                        this.dragItem.parentNode.insertBefore((dropItem.parentElement).lastChild, this.dragItem.parentElement.childNodes[0]);
                        dropItem.parentNode.insertBefore(this.dragItem, dropItem);
                    }
                }
            }
            else {
                this.dragItem.parentNode.insertBefore(this.dragItem, dropItem);
            }
        }
        if (dragsIndex < dropIndex) {
            if (!(this.dragItem.parentElement).isSameNode(dropItem.parentElement)) {
                if (this.overflowMode === 'Extended') {
                    this.dragItem.parentElement.appendChild(dropItem.parentElement.firstElementChild);
                    dropItem.parentNode.insertBefore(this.dragItem, dropItem.nextSibling);
                }
                else {
                    this.dragItem.parentNode.insertBefore((dropItem.parentElement).lastChild, this.dragItem.parentElement.childNodes[0]);
                    dropItem.parentNode.insertBefore(this.dragItem, dropItem);
                }
            }
            else {
                this.dragItem.parentNode.insertBefore(dropItem, this.dragItem);
            }
        }
    };
    Tab.prototype.itemDragStop = function (e) {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.cloneElement);
        this.cloneElement = null;
        this.dragItem.querySelector('.' + CLS_WRAP).style.visibility = 'visible';
        document.body.style.cursor = '';
        var dragStopArgs = {
            draggedItem: this.dragItem,
            event: e.event,
            target: e.target,
            droppedItem: this.tbItem[this.droppedIndex],
            clonedElement: null,
            index: this.droppedIndex,
            cancel: false
        };
        this.trigger('dragged', dragStopArgs, function (tabItemDropArgs) {
            if (tabItemDropArgs.cancel) {
                _this.refresh();
            }
            else {
                if (_this.items.length > 0 && _this.draggingItems.length > 0) {
                    _this.items = _this.draggingItems;
                    _this.selectedItem = _this.droppedIndex;
                    _this.refresh();
                }
                else {
                    _this.dragItem.querySelector('.' + CLS_WRAP).style.visibility = '';
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([_this.tbItems.querySelector('.' + CLS_INDICATOR)], CLS_HIDDEN);
                    _this.selectTab(_this.droppedIndex, null, true);
                }
            }
        });
        this.dragItem = null;
    };
    /**
     * Enables or disables the specified Tab item. On passing value as `false`, the item will be disabled.
     *
     * @param {number} index - Index value of target Tab item.
     * @param {boolean} value - Boolean value that determines whether the command should be enabled or disabled.
     * By default, isEnable is true.
     * @returns {void}.
     */
    Tab.prototype.enableTab = function (index, value) {
        var tbItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEM, this.element)[index];
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(tbItems)) {
            return;
        }
        if (value === true) {
            tbItems.classList.remove(CLS_DISABLE, CLS_OVERLAY);
            tbItems.firstElementChild.setAttribute('tabindex', '-1');
        }
        else {
            tbItems.classList.add(CLS_DISABLE, CLS_OVERLAY);
            tbItems.firstElementChild.removeAttribute('tabindex');
            if (tbItems.classList.contains(CLS_ACTIVE)) {
                this.select(index + 1);
            }
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.items[index])) {
            this.items[index].disabled = !value;
            this.dataBind();
        }
        tbItems.setAttribute('aria-disabled', (value === true) ? 'false' : 'true');
    };
    /**
     * Adds new items to the Tab that accepts an array as Tab items.
     *
     * @param {TabItemModel[]} items - An array of item that is added to the Tab.
     * @param {number} index - Number value that determines where the items to be added. By default, index is 0.
     * @returns {void}.
     */
    Tab.prototype.addTab = function (items, index) {
        var _this = this;
        var addArgs = { addedItems: items, cancel: false };
        if (!this.isReplace) {
            this.trigger('adding', addArgs, function (tabAddingArgs) {
                if (!tabAddingArgs.cancel) {
                    _this.addingTabContent(items, index);
                }
            });
        }
        else {
            this.addingTabContent(items, index);
        }
        if (this.isReact) {
            this.renderReactTemplates();
        }
    };
    Tab.prototype.addingTabContent = function (items, index) {
        var _this = this;
        var lastEleIndex = 0;
        this.hdrEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_HEADER, this.element);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.hdrEle)) {
            this.items = items;
            this.reRenderItems();
            this.bindDraggable();
        }
        else {
            var itemsCount = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.e-tab-header .' + CLS_TB_ITEM, this.element).length;
            if (itemsCount !== 0) {
                lastEleIndex = this.lastIndex + 1;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(index)) {
                index = itemsCount - 1;
            }
            if (itemsCount < index || index < 0 || isNaN(index)) {
                return;
            }
            if (itemsCount === 0 && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.hdrEle)) {
                this.hdrEle.style.display = '';
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.bdrLine)) {
                this.bdrLine.classList.add(CLS_HIDDEN);
            }
            this.tbItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TB_ITEMS, this.getTabHeader());
            this.isAdd = true;
            var tabItems = this.parseObject(items, index);
            this.isAdd = false;
            var i_1 = 0;
            var textValue_1;
            items.forEach(function (item, place) {
                textValue_1 = item.headerTemplate || item.header.text;
                if (!(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.headerTemplate || item.header) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(textValue_1) ||
                    (textValue_1.length === 0) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.header) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.header.iconCss))) {
                    _this.items.splice((index + i_1), 0, item);
                    i_1++;
                }
                if (_this.isTemplate && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.header) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.header.text)) {
                    var no = lastEleIndex + place;
                    var ele = _this.createElement('div', {
                        id: CLS_CONTENT + _this.tabId + '_' + no, className: CLS_ITEM,
                        attrs: { role: 'tabpanel', 'aria-labelledby': CLS_ITEM + '_' + no }
                    });
                    _this.cntEle.insertBefore(ele, _this.cntEle.children[(index + place)]);
                    var eleTrg = _this.getTrgContent(_this.cntEle, no.toString());
                    _this.getContent(eleTrg, item.content, 'render', index);
                }
            });
            this.tbObj.addItems(tabItems, index);
            if (!this.isReplace) {
                this.trigger('added', { addedItems: items });
            }
            if (this.selectedItem === index) {
                this.select(index);
            }
            else {
                this.setActiveBorder();
            }
            this.bindDraggable();
        }
    };
    /**
     * Removes the items in the Tab from the specified index.
     *
     * @param {number} index - Index of target item that is going to be removed.
     * @returns {void}.
     */
    Tab.prototype.removeTab = function (index) {
        var _this = this;
        var trg = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEM, this.element)[index];
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(trg)) {
            return;
        }
        var removeArgs = { removedItem: trg, removedIndex: index, cancel: false };
        this.trigger('removing', removeArgs, function (tabRemovingArgs) {
            if (!tabRemovingArgs.cancel) {
                _this.tbObj.removeItems(index);
                if (_this.allowDragAndDrop && (index !== Array.prototype.indexOf.call(_this.itemIndexArray, trg.id))) {
                    index = Array.prototype.indexOf.call(_this.itemIndexArray, trg.id);
                }
                _this.items.splice(index, 1);
                _this.itemIndexArray.splice(index, 1);
                _this.refreshActiveBorder();
                var cntTrg = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('#' + CLS_CONTENT + _this.tabId + '_' + _this.extIndex(trg.id), Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_CONTENT, _this.element));
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(cntTrg)) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(cntTrg);
                }
                _this.trigger('removed', tabRemovingArgs);
                if (_this.draggableItems && _this.draggableItems.length > 0) {
                    _this.draggableItems[index].destroy();
                    _this.draggableItems[index] = null;
                    _this.draggableItems.splice(index, 1);
                }
                if (trg.classList.contains(CLS_ACTIVE)) {
                    index = (index > Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEM + ':not(.' + CLS_TB_POPUP + ')', _this.element).length - 1) ? index - 1 : index;
                    _this.enableAnimation = false;
                    _this.selectedItem = index;
                    _this.select(index);
                }
                else if (index !== _this.selectedItem) {
                    if (index < _this.selectedItem) {
                        index = _this.itemIndexArray.indexOf(_this.tbItem[_this.selectedItem].id);
                        _this.setProperties({ selectedItem: index > -1 ? index : _this.selectedItem }, true);
                        _this.prevIndex = _this.selectedItem;
                    }
                    _this.tbItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEM, _this.getTabHeader());
                }
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEM, _this.element).length === 0) {
                    _this.hdrEle.style.display = 'none';
                }
                _this.enableAnimation = true;
            }
        });
    };
    /**
     * Shows or hides the Tab that is in the specified index.
     *
     * @param {number} index - Index value of target item.
     * @param {boolean} value - Based on this Boolean value, item will be hide (false) or show (true). By default, value is true.
     * @returns {void}.
     */
    Tab.prototype.hideTab = function (index, value) {
        var items;
        var item = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEM, this.element)[index];
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item)) {
            return;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(value)) {
            value = true;
        }
        this.bdrLine.classList.add(CLS_HIDDEN);
        if (value === true) {
            item.classList.add(CLS_HIDDEN);
            items = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEM + ':not(.' + CLS_HIDDEN + ')', this.tbItems);
            if (items.length !== 0 && item.classList.contains(CLS_ACTIVE)) {
                if (index !== 0) {
                    for (var i = index - 1; i >= 0; i--) {
                        if (!this.tbItem[i].classList.contains(CLS_HIDDEN)) {
                            this.select(i);
                            break;
                        }
                        else if (i === 0) {
                            for (var k = index + 1; k < this.tbItem.length; k++) {
                                if (!this.tbItem[k].classList.contains(CLS_HIDDEN)) {
                                    this.select(k);
                                    break;
                                }
                            }
                        }
                    }
                }
                else {
                    for (var k = index + 1; k < this.tbItem.length; k++) {
                        if (!this.tbItem[k].classList.contains(CLS_HIDDEN)) {
                            this.select(k);
                            break;
                        }
                    }
                }
            }
            else if (items.length === 0) {
                this.element.classList.add(CLS_HIDDEN);
            }
        }
        else {
            this.element.classList.remove(CLS_HIDDEN);
            items = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEM + ':not(.' + CLS_HIDDEN + ')', this.tbItems);
            item.classList.remove(CLS_HIDDEN);
            if (items.length === 0) {
                this.select(index);
            }
        }
        this.setActiveBorder();
        item.setAttribute('aria-hidden', '' + value);
        if (this.overflowMode === 'Popup' && this.tbObj) {
            this.tbObj.refreshOverflow();
        }
    };
    Tab.prototype.selectTab = function (args, event, isInteracted) {
        if (event === void 0) { event = null; }
        if (isInteracted === void 0) { isInteracted = false; }
        this.isInteracted = isInteracted;
        this.select(args, event);
    };
    /**
     * Specifies the index or HTMLElement to select an item from the Tab.
     *
     * @param {number | HTMLElement} args - Index or DOM element is used for selecting an item from the Tab.
     * @param {Event} event - An event which takes place in DOM.
     * @returns {void}
     */
    Tab.prototype.select = function (args, event) {
        var _this = this;
        var tabHeader = this.getTabHeader();
        this.tbItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_TB_ITEMS, tabHeader);
        this.tbItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEM, tabHeader);
        this.content = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CLS_CONTENT, this.element);
        this.prevItem = this.tbItem[this.prevIndex];
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.selectedItem) || (this.selectedItem < 0) || (this.tbItem.length <= this.selectedItem) || isNaN(this.selectedItem)) {
            this.selectedItem = 0;
        }
        else {
            this.selectedID = this.extIndex(this.tbItem[this.selectedItem].id);
        }
        var trg = this.tbItem[args];
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(trg)) {
            this.selectedID = '0';
        }
        else {
            this.selectingID = this.extIndex(trg.id);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.prevItem) && !this.prevItem.classList.contains(CLS_DISABLE)) {
            this.prevItem.children.item(0).setAttribute('tabindex', '-1');
        }
        var eventArg = {
            event: event,
            previousItem: this.prevItem,
            previousIndex: this.prevIndex,
            selectedItem: this.tbItem[this.selectedItem],
            selectedIndex: this.selectedItem,
            selectedContent: !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.content) ?
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('#' + CLS_CONTENT + this.tabId + '_' + this.selectedID, this.content) : null,
            selectingItem: trg,
            selectingIndex: args,
            selectingContent: !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.content) ?
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('#' + CLS_CONTENT + this.tabId + '_' + this.selectingID, this.content) : null,
            isSwiped: this.isSwipeed,
            isInteracted: this.isInteracted,
            cancel: false
        };
        if (!this.initRender) {
            this.trigger('selecting', eventArg, function (selectArgs) {
                if (!selectArgs.cancel) {
                    _this.selectingContent(args, _this.isInteracted);
                }
            });
        }
        else {
            this.selectingContent(args, this.isInteracted);
        }
        this.isInteracted = false;
    };
    Tab.prototype.selectingContent = function (args, isInteracted) {
        if (typeof args === 'number') {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.tbItem[args]) && (this.tbItem[args].classList.contains(CLS_DISABLE) ||
                this.tbItem[args].classList.contains(CLS_HIDDEN))) {
                for (var i = args + 1; i < this.items.length; i++) {
                    if (this.items[i].disabled === false && this.items[i].visible === true) {
                        args = i;
                        break;
                    }
                    else {
                        args = 0;
                    }
                }
            }
            if (this.tbItem.length > args && args >= 0 && !isNaN(args)) {
                this.prevIndex = this.selectedItem;
                this.prevItem = this.tbItem[this.prevIndex];
                if (this.tbItem[args].classList.contains(CLS_TB_POPUP) && this.reorderActiveTab) {
                    this.setActive(this.popupHandler(this.tbItem[args]), null, isInteracted);
                    if ((!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.items) && this.items.length > 0) && this.allowDragAndDrop) {
                        this.tbItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CLS_TB_ITEMS + ' .' + CLS_TB_ITEM, this.hdrEle);
                        var item = this.items[args];
                        this.items.splice(args, 1);
                        this.items.splice(this.tbItem.length - 1, 0, item);
                    }
                }
                else {
                    this.setActive(args, null, isInteracted);
                }
            }
            else {
                this.setActive(0, null, isInteracted);
            }
        }
        else if (args instanceof (HTMLElement)) {
            this.setActive(this.getEleIndex(args), null, isInteracted);
        }
    };
    /**
     * Gets the item index from the Tab.
     *
     * @param  {string} tabItemId - Item ID is used for getting index from the Tab.
     * @returns {number} - It returns item index.
     */
    Tab.prototype.getItemIndex = function (tabItemId) {
        var tabIndex;
        for (var i = 0; i < this.tbItem.length; i++) {
            var value = this.tbItem[i].getAttribute('data-id');
            if (tabItemId === value) {
                tabIndex = i;
                break;
            }
        }
        return tabIndex;
    };
    /**
     * Specifies the value to disable/enable the Tab component.
     * When set to `true`, the component will be disabled.
     *
     * @param  {boolean} value - Based on this Boolean value, Tab will be enabled (false) or disabled (true).
     * @returns {void}.
     */
    Tab.prototype.disable = function (value) {
        this.setCssClass(this.element, CLS_DISABLE, value);
        this.element.setAttribute('aria-disabled', '' + value);
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} - It returns the persisted state.
     */
    Tab.prototype.getPersistData = function () {
        return this.addOnPersist(['selectedItem', 'actEleId']);
    };
    /**
     * Returns the current module name.
     *
     * @returns {string} - It returns the current module name.
     * @private
     */
    Tab.prototype.getModuleName = function () {
        return 'tab';
    };
    /**
     * Gets called when the model property changes.The data that describes the old and new values of the property that changed.
     *
     * @param  {TabModel} newProp - It contains the new value of data.
     * @param  {TabModel} oldProp - It contains the old value of data.
     * @returns {void}
     * @private
     */
    Tab.prototype.onPropertyChanged = function (newProp, oldProp) {
        var _this = this;
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'width':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { width: Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(newProp.width) });
                    break;
                case 'height':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { height: Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(newProp.height) });
                    this.setContentHeight(false);
                    break;
                case 'cssClass':
                    if (oldProp.cssClass !== '' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(oldProp.cssClass)) {
                        this.setCssClass(this.element, oldProp.cssClass, false);
                        this.setCssClass(this.element, newProp.cssClass, true);
                    }
                    else {
                        this.setCssClass(this.element, newProp.cssClass, true);
                    }
                    break;
                case 'items':
                    this.evalOnPropertyChangeItems(newProp, oldProp);
                    break;
                case 'showCloseButton':
                    this.setCloseButton(newProp.showCloseButton);
                    break;
                case 'reorderActiveTab':
                    this.refreshActiveTabBorder();
                    break;
                case 'selectedItem':
                    this.selectedItem = oldProp.selectedItem;
                    this.select(newProp.selectedItem);
                    break;
                case 'headerPlacement':
                    this.changeOrientation(newProp.headerPlacement);
                    break;
                case 'enableRtl':
                    this.setRTL(newProp.enableRtl);
                    break;
                case 'overflowMode':
                    this.tbObj.overflowMode = newProp.overflowMode;
                    this.tbObj.dataBind();
                    this.refreshActiveTabBorder();
                    break;
                case 'heightAdjustMode':
                    this.setContentHeight(false);
                    this.select(this.selectedItem);
                    break;
                case 'scrollStep':
                    if (this.tbObj) {
                        this.tbObj.scrollStep = this.scrollStep;
                    }
                    break;
                case 'allowDragAndDrop':
                    this.bindDraggable();
                    break;
                case 'dragArea':
                    if (this.allowDragAndDrop) {
                        this.draggableItems.forEach(function (item) {
                            item.dragArea = _this.dragArea;
                        });
                        this.refresh();
                    }
                    break;
            }
        }
    };
    Tab.prototype.refreshActiveTab = function () {
        if (this.isReact) {
            this.clearTemplate();
        }
        if (!this.isTemplate) {
            if (this.element.querySelector('.' + CLS_TB_ITEM + '.' + CLS_ACTIVE)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.element.querySelector('.' + CLS_TB_ITEM + '.' + CLS_ACTIVE).children[0]);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.element.querySelector('.' + CLS_CONTENT).querySelector('.' + CLS_ACTIVE).children[0]);
                var item = this.items[this.selectedItem];
                var pos = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.header) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.header.iconPosition)) ? '' : item.header.iconPosition;
                var css = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.header) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.header.iconCss)) ? '' : item.header.iconCss;
                var text = item.headerTemplate || item.header.text;
                var txtWrap = this.createElement('div', { className: CLS_TEXT, attrs: { 'role': 'presentation' } });
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(text.tagName)) {
                    txtWrap.appendChild(text);
                }
                else {
                    this.headerTextCompile(txtWrap, text, this.selectedItem);
                }
                var tEle = void 0;
                var icon = this.createElement('span', {
                    className: CLS_ICONS + ' ' + CLS_TAB_ICON + ' ' + CLS_ICON + '-' + pos + ' ' + css
                });
                var tConts = this.createElement('div', { className: CLS_TEXT_WRAP });
                tConts.appendChild(txtWrap);
                if ((text !== '' && text !== undefined) && css !== '') {
                    if ((pos === 'left' || pos === 'top')) {
                        tConts.insertBefore(icon, tConts.firstElementChild);
                    }
                    else {
                        tConts.appendChild(icon);
                    }
                    tEle = txtWrap;
                    this.isIconAlone = false;
                }
                else {
                    tEle = ((css === '') ? txtWrap : icon);
                    if (tEle === icon) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(txtWrap);
                        tConts.appendChild(icon);
                        this.isIconAlone = true;
                    }
                }
                var wrapAtt = (item.disabled) ? {} : { tabIndex: '-1' };
                tConts.appendChild(this.btnCls.cloneNode(true));
                var wraper = this.createElement('div', { className: CLS_WRAP, attrs: wrapAtt });
                wraper.appendChild(tConts);
                if (pos === 'top' || pos === 'bottom') {
                    this.element.classList.add('e-vertical-icon');
                }
                this.element.querySelector('.' + CLS_TB_ITEM + '.' + CLS_ACTIVE).appendChild(wraper);
                var crElem = this.createElement('div');
                var cnt = item.content;
                var eleStr = void 0;
                if (typeof cnt === 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(cnt.innerHTML)) {
                    if (typeof cnt === 'string' && this.enableHtmlSanitizer) {
                        cnt = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(cnt);
                    }
                    if (cnt[0] === '.' || cnt[0] === '#') {
                        if (document.querySelectorAll(cnt).length) {
                            var eleVal = document.querySelector(cnt);
                            eleStr = eleVal.outerHTML.trim();
                            crElem.appendChild(eleVal);
                            eleVal.style.display = '';
                        }
                        else {
                            this.compileElement(crElem, cnt, 'content', this.selectedItem);
                        }
                    }
                    else {
                        this.compileElement(crElem, cnt, 'content', this.selectedItem);
                    }
                }
                else {
                    crElem.appendChild(cnt);
                }
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(eleStr)) {
                    if (this.templateEle.indexOf(cnt.toString()) === -1) {
                        this.templateEle.push(cnt.toString());
                    }
                }
                this.element.querySelector('.' + CLS_ITEM + '.' + CLS_ACTIVE).appendChild(crElem);
            }
        }
        else {
            var tabItems = this.element.querySelector('.' + CLS_TB_ITEMS);
            var element = this.element.querySelector('.' + CLS_TB_ITEM + '.' + CLS_ACTIVE);
            var id = element.id;
            var num = (id.indexOf('_'));
            var index = parseInt(id.substring(num + 1), 10);
            var header = element.innerText;
            var detachContent = this.element.querySelector('.' + CLS_CONTENT).querySelector('.' + CLS_ACTIVE).children[0];
            var mainContents = detachContent.innerHTML;
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(element);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(detachContent);
            var attr = {
                className: CLS_TB_ITEM + ' ' + CLS_TEMPLATE + ' ' + CLS_ACTIVE, id: CLS_ITEM + this.tabId + '_' + index,
                attrs: {
                    role: 'tab', 'aria-controls': CLS_CONTENT + this.tabId + '_' + index,
                    'aria-disabled': 'false', 'aria-selected': 'true'
                }
            };
            var txtString = this.createElement('span', {
                className: CLS_TEXT, innerHTML: header, attrs: { 'role': 'presentation' }
            }).outerHTML;
            var conte = this.createElement('div', {
                className: CLS_TEXT_WRAP, innerHTML: txtString + this.btnCls.outerHTML
            }).outerHTML;
            var wrap = this.createElement('div', { className: CLS_WRAP, innerHTML: conte, attrs: { tabIndex: '-1' } });
            tabItems.insertBefore(this.createElement('div', attr), tabItems.children[index + 1]);
            this.element.querySelector('.' + CLS_TB_ITEM + '.' + CLS_ACTIVE).appendChild(wrap);
            var crElem = this.createElement('div', { innerHTML: mainContents });
            this.element.querySelector('.' + CLS_CONTENT).querySelector('.' + CLS_ACTIVE).appendChild(crElem);
        }
        if (this.isReact) {
            this.renderReactTemplates();
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["f" /* Collection */])([], TabItem)
    ], Tab.prototype, "items", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('100%')
    ], Tab.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('auto')
    ], Tab.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Tab.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(0)
    ], Tab.prototype, "selectedItem", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Top')
    ], Tab.prototype, "headerPlacement", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Content')
    ], Tab.prototype, "heightAdjustMode", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Scrollable')
    ], Tab.prototype, "overflowMode", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Dynamic')
    ], Tab.prototype, "loadOn", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Tab.prototype, "enablePersistence", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Tab.prototype, "enableHtmlSanitizer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Tab.prototype, "showCloseButton", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Tab.prototype, "reorderActiveTab", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Tab.prototype, "scrollStep", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Tab.prototype, "dragArea", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Tab.prototype, "allowDragAndDrop", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({}, TabAnimationSettings)
    ], Tab.prototype, "animation", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tab.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tab.prototype, "adding", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tab.prototype, "added", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tab.prototype, "selecting", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tab.prototype, "selected", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tab.prototype, "removing", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tab.prototype, "removed", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tab.prototype, "onDragStart", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tab.prototype, "dragging", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tab.prototype, "dragged", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Tab.prototype, "destroyed", void 0);
    Tab = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], Tab);
    return Tab;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__treeview__ = __webpack_require__(254);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__treeview__["a"]; });
/**
 * TreeView modules
 */



/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FieldsSettings */
/* unused harmony export ActionSettings */
/* unused harmony export NodeAnimationSettings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TreeView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_lists__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_buttons__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_inputs__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__syncfusion_ej2_popups__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};













var ROOT = 'e-treeview';
var CONTROL = 'e-control';
var COLLAPSIBLE = 'e-icon-collapsible';
var EXPANDABLE = 'e-icon-expandable';
var LISTITEM = 'e-list-item';
var LISTTEXT = 'e-list-text';
var LISTWRAP = 'e-text-wrap';
var IELISTWRAP = 'e-ie-wrap';
var PARENTITEM = 'e-list-parent';
var HOVER = 'e-hover';
var ACTIVE = 'e-active';
var LOAD = 'e-icons-spinner';
var PROCESS = 'e-process';
var ICON = 'e-icons';
var TEXTWRAP = 'e-text-content';
var INPUT = 'e-input';
var INPUTGROUP = 'e-input-group';
var TREEINPUT = 'e-tree-input';
var EDITING = 'e-editing';
var RTL = 'e-rtl';
var INTERACTION = 'e-interaction';
var DRAGITEM = 'e-drag-item';
var DROPPABLE = 'e-droppable';
var DRAGGING = 'e-dragging';
var SIBLING = 'e-sibling';
var DROPIN = 'e-drop-in';
var DROPNEXT = 'e-drop-next';
var DROPOUT = 'e-drop-out';
var NODROP = 'e-no-drop';
var FULLROWWRAP = 'e-fullrow-wrap';
var FULLROW = 'e-fullrow';
var SELECTED = 'e-selected';
var EXPANDED = 'e-expanded';
var NODECOLLAPSED = 'e-node-collapsed';
var DISABLE = 'e-disable';
var DROPCOUNT = 'e-drop-count';
var CHECK = 'e-check';
var INDETERMINATE = 'e-stop';
var CHECKBOXWRAP = 'e-checkbox-wrapper';
var CHECKBOXFRAME = 'e-frame';
var CHECKBOXRIPPLE = 'e-ripple-container';
var RIPPLE = 'e-ripple';
var RIPPLEELMENT = 'e-ripple-element';
var FOCUS = 'e-node-focus';
var IMAGE = 'e-list-img';
var BIGGER = 'e-bigger';
var SMALL = 'e-small';
var CHILD = 'e-has-child';
var ITEM_ANIMATION_ACTIVE = 'e-animation-active';
var DISABLED = 'e-disabled';
var treeAriaAttr = {
    treeRole: 'tree',
    itemRole: 'treeitem',
    listRole: 'group',
    itemText: '',
    wrapperRole: ''
};
/**
 * Configures the fields to bind to the properties of node in the TreeView component.
 */
var FieldsSettings = /** @class */ (function (_super) {
    __extends(FieldsSettings, _super);
    function FieldsSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('child')
    ], FieldsSettings.prototype, "child", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])([])
    ], FieldsSettings.prototype, "dataSource", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('expanded')
    ], FieldsSettings.prototype, "expanded", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('hasChildren')
    ], FieldsSettings.prototype, "hasChildren", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('htmlAttributes')
    ], FieldsSettings.prototype, "htmlAttributes", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('iconCss')
    ], FieldsSettings.prototype, "iconCss", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('id')
    ], FieldsSettings.prototype, "id", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('imageUrl')
    ], FieldsSettings.prototype, "imageUrl", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('isChecked')
    ], FieldsSettings.prototype, "isChecked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('parentID')
    ], FieldsSettings.prototype, "parentID", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], FieldsSettings.prototype, "query", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('selected')
    ], FieldsSettings.prototype, "selected", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], FieldsSettings.prototype, "tableName", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('text')
    ], FieldsSettings.prototype, "text", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('tooltip')
    ], FieldsSettings.prototype, "tooltip", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('navigateUrl')
    ], FieldsSettings.prototype, "navigateUrl", void 0);
    return FieldsSettings;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * Configures animation settings for the TreeView component.
 */
var ActionSettings = /** @class */ (function (_super) {
    __extends(ActionSettings, _super);
    function ActionSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('SlideDown')
    ], ActionSettings.prototype, "effect", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(400)
    ], ActionSettings.prototype, "duration", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('linear')
    ], ActionSettings.prototype, "easing", void 0);
    return ActionSettings;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * Configures the animation settings for expanding and collapsing nodes in TreeView.
 */
var NodeAnimationSettings = /** @class */ (function (_super) {
    __extends(NodeAnimationSettings, _super);
    function NodeAnimationSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({ effect: 'SlideUp', duration: 400, easing: 'linear' }, ActionSettings)
    ], NodeAnimationSettings.prototype, "collapse", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({ effect: 'SlideDown', duration: 400, easing: 'linear' }, ActionSettings)
    ], NodeAnimationSettings.prototype, "expand", void 0);
    return NodeAnimationSettings;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * The TreeView component is used to represent hierarchical data in a tree like structure with advanced
 * functions to perform edit, drag and drop, selection with check-box, and more.
 * ```html
 *  <div id="tree"></div>
 * ```
 * ```typescript
 *  let treeObj: TreeView = new TreeView();
 *  treeObj.appendTo('#tree');
 * ```
 */
var TreeView = /** @class */ (function (_super) {
    __extends(TreeView, _super);
    function TreeView(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.isRefreshed = false;
        _this.preventExpand = false;
        _this.checkedElement = [];
        _this.disableNode = [];
        // eslint-disable-next-line
        _this.validArr = [];
        _this.validNodes = [];
        _this.expandChildren = [];
        _this.isFieldChange = false;
        _this.changeDataSource = false;
        _this.hasTemplate = false;
        _this.isFirstRender = false;
        _this.mouseDownStatus = false;
        return _this;
    }
    TreeView_1 = TreeView;
    /**
     * Get component name.
     *
     * @returns {string} - returns module name.
     * @private
     */
    TreeView.prototype.getModuleName = function () {
        return 'treeview';
    };
    /**
     * Initialize the event handler
     *
     * @returns {void}
     */
    TreeView.prototype.preRender = function () {
        var _this = this;
        this.checkActionNodes = [];
        this.parentNodeCheck = [];
        this.dragStartAction = false;
        this.isAnimate = false;
        this.keyConfigs = {
            escape: 'escape',
            end: 'end',
            enter: 'enter',
            f2: 'f2',
            home: 'home',
            moveDown: 'downarrow',
            moveLeft: 'leftarrow',
            moveRight: 'rightarrow',
            moveUp: 'uparrow',
            ctrlDown: 'ctrl+downarrow',
            ctrlUp: 'ctrl+uparrow',
            ctrlEnter: 'ctrl+enter',
            ctrlHome: 'ctrl+home',
            ctrlEnd: 'ctrl+end',
            ctrlA: 'ctrl+A',
            shiftDown: 'shift+downarrow',
            shiftUp: 'shift+uparrow',
            shiftEnter: 'shift+enter',
            shiftHome: 'shift+home',
            shiftEnd: 'shift+end',
            csDown: 'ctrl+shift+downarrow',
            csUp: 'ctrl+shift+uparrow',
            csEnter: 'ctrl+shift+enter',
            csHome: 'ctrl+shift+home',
            csEnd: 'ctrl+shift+end',
            space: 'space'
        };
        this.listBaseOption = {
            expandCollapse: true,
            showIcon: true,
            expandIconClass: EXPANDABLE,
            ariaAttributes: treeAriaAttr,
            expandIconPosition: 'Left',
            itemCreated: function (e) {
                _this.beforeNodeCreate(e);
            },
            enableHtmlSanitizer: this.enableHtmlSanitizer,
            itemNavigable: this.fullRowNavigable
        };
        this.updateListProp(this.fields);
        this.aniObj = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["b" /* Animation */]({});
        this.treeList = [];
        this.isLoaded = false;
        this.isInitalExpand = false;
        this.expandChildren = [];
        this.index = 0;
        this.setTouchClass();
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.selectedNodes)) {
            this.setProperties({ selectedNodes: [] }, true);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.checkedNodes)) {
            this.setProperties({ checkedNodes: [] }, true);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.expandedNodes)) {
            this.setProperties({ expandedNodes: [] }, true);
        }
        else {
            this.isInitalExpand = true;
        }
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} - returns the persisted data
     * @hidden
     */
    TreeView.prototype.getPersistData = function () {
        var keyEntity = ['selectedNodes', 'checkedNodes', 'expandedNodes'];
        return this.addOnPersist(keyEntity);
    };
    /**
     * To Initialize the control rendering
     *
     * @private
     * @returns {void}
     */
    TreeView.prototype.render = function () {
        this.initialRender = true;
        this.initialize();
        this.setDataBinding(false);
        this.setDisabledMode();
        this.setExpandOnType();
        if (!this.disabled) {
            this.setRipple();
        }
        this.wireEditingEvents(this.allowEditing);
        this.setDragAndDrop(this.allowDragAndDrop);
        if (!this.disabled) {
            this.wireEvents();
        }
        this.initialRender = false;
        this.renderComplete();
    };
    TreeView.prototype.initialize = function () {
        this.element.setAttribute('role', 'tree');
        this.element.setAttribute('tabindex', '0');
        this.element.setAttribute('aria-activedescendant', this.element.id + '_active');
        this.setCssClass(null, this.cssClass);
        this.setEnableRtl();
        this.setFullRow(this.fullRowSelect);
        this.setTextWrap();
        this.nodeTemplateFn = this.templateComplier(this.nodeTemplate);
    };
    TreeView.prototype.setDisabledMode = function () {
        if (this.disabled) {
            this.element.classList.add(DISABLED);
        }
        else {
            this.element.classList.remove(DISABLED);
        }
    };
    TreeView.prototype.setEnableRtl = function () {
        (this.enableRtl ? __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */] : __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], RTL);
    };
    TreeView.prototype.setRipple = function () {
        var tempStr = '.' + FULLROW + ',.' + TEXTWRAP;
        var rippleModel = {
            selector: tempStr,
            ignore: '.' + TEXTWRAP + ' > .' + ICON + ',.' + INPUTGROUP + ',.' + INPUT + ', .' + CHECKBOXWRAP
        };
        this.rippleFn = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_0" /* rippleEffect */])(this.element, rippleModel);
        var iconModel = {
            selector: '.' + TEXTWRAP + ' > .' + ICON,
            isCenterRipple: true
        };
        this.rippleIconFn = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_0" /* rippleEffect */])(this.element, iconModel);
    };
    TreeView.prototype.setFullRow = function (isEnabled) {
        (isEnabled ? __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */] : __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], FULLROWWRAP);
    };
    TreeView.prototype.setMultiSelect = function (isEnabled) {
        var firstUl = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, this.element);
        if (isEnabled) {
            firstUl.setAttribute('aria-multiselectable', 'true');
        }
        else {
            firstUl.removeAttribute('aria-multiselectable');
        }
    };
    // eslint-disable-next-line
    TreeView.prototype.templateComplier = function (template) {
        if (template) {
            this.hasTemplate = true;
            // eslint-disable-next-line
            var e = void 0;
            this.element.classList.add(INTERACTION);
            try {
                if (document.querySelectorAll(template).length) {
                    return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(document.querySelector(template).innerHTML.trim());
                }
                else {
                    return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(template);
                }
            }
            catch (e) {
                return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(template);
            }
        }
        this.element.classList.remove(INTERACTION);
        return undefined;
    };
    TreeView.prototype.setDataBinding = function (changeDataSource) {
        var _this = this;
        this.treeList.push('false');
        if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */]) {
            /* eslint-disable */
            this.isOffline = this.fields.dataSource.dataSource.offline;
            if (this.fields.dataSource.ready) {
                this.fields.dataSource.ready.then(function (e) {
                    /* eslint-disable */
                    _this.isOffline = _this.fields.dataSource.dataSource.offline;
                    if (_this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] && _this.isOffline) {
                        _this.treeList.pop();
                        _this.treeData = e.result;
                        _this.isNumberTypeId = _this.getType();
                        _this.setRootData();
                        _this.renderItems(true);
                        if (_this.treeList.length === 0 && !_this.isLoaded) {
                            _this.finalize();
                        }
                    }
                }).catch(function (e) {
                    _this.trigger('actionFailure', { error: e });
                });
            }
            else {
                this.fields.dataSource.executeQuery(this.getQuery(this.fields)).then(function (e) {
                    _this.treeList.pop();
                    _this.treeData = e.result;
                    _this.isNumberTypeId = _this.getType();
                    _this.setRootData();
                    if (changeDataSource) {
                        _this.changeDataSource = true;
                    }
                    _this.renderItems(true);
                    _this.changeDataSource = false;
                    if (_this.treeList.length === 0 && !_this.isLoaded) {
                        _this.finalize();
                    }
                }).catch(function (e) {
                    _this.trigger('actionFailure', { error: e });
                });
            }
        }
        else {
            this.treeList.pop();
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.fields.dataSource)) {
                this.rootData = this.treeData = [];
            }
            else {
                this.treeData = JSON.parse(JSON.stringify(this.fields.dataSource));
                this.setRootData();
            }
            this.isNumberTypeId = this.getType();
            this.renderItems(false);
        }
        if (this.treeList.length === 0 && !this.isLoaded) {
            this.finalize();
        }
    };
    TreeView.prototype.getQuery = function (mapper, value) {
        if (value === void 0) { value = null; }
        var columns = [];
        var query;
        if (!mapper.query) {
            query = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["b" /* Query */]();
            var prop = this.getActualProperties(mapper);
            for (var _i = 0, _a = Object.keys(prop); _i < _a.length; _i++) {
                var col = _a[_i];
                if (col !== 'dataSource' && col !== 'tableName' && col !== 'child' && !!mapper[col]
                    && col !== 'url' && columns.indexOf(mapper[col]) === -1) {
                    columns.push(mapper[col]);
                }
            }
            query.select(columns);
            if (prop.hasOwnProperty('tableName')) {
                query.from(mapper.tableName);
            }
        }
        else {
            query = mapper.query.clone();
        }
        __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_lists__["a" /* ListBase */].addSorting(this.sortOrder, mapper.text, query);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(mapper.parentID)) {
            query.where(mapper.parentID, 'equal', (this.isNumberTypeId ? parseFloat(value) : value));
        }
        return query;
    };
    TreeView.prototype.getType = function () {
        return this.treeData[0] ? ((typeof Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.id, this.treeData[0]) === 'number') ? true : false) : false;
    };
    TreeView.prototype.setRootData = function () {
        this.dataType = this.getDataType(this.treeData, this.fields);
        if (this.dataType === 1) {
            this.groupedData = this.getGroupedData(this.treeData, this.fields.parentID);
            var rootItems = this.getChildNodes(this.treeData, undefined, true);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(rootItems)) {
                this.rootData = [];
            }
            else {
                this.rootData = rootItems;
            }
        }
        else {
            this.rootData = this.treeData;
        }
    };
    TreeView.prototype.renderItems = function (isSorted) {
        /* eslint-disable */
        this.listBaseOption.ariaAttributes.level = 1;
        var sortedData = this.getSortedData(this.rootData);
        this.ulElement = __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_lists__["a" /* ListBase */].createList(this.createElement, isSorted ? this.rootData : sortedData, this.listBaseOption);
        this.element.appendChild(this.ulElement);
        var rootNodes = this.ulElement.querySelectorAll('.e-list-item');
        if (this.loadOnDemand === false) {
            var i = 0;
            while (i < rootNodes.length) {
                this.renderChildNodes(rootNodes[i], true, null, true);
                i++;
            }
        }
        var parentEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + PARENTITEM, this.element);
        if ((parentEle.length === 1 && (rootNodes && rootNodes.length !== 0)) || this.loadOnDemand) {
            this.finalizeNode(this.element);
        }
        this.parentNodeCheck = [];
        this.parentCheckData = [];
        this.updateCheckedStateFromDS();
        if (this.autoCheck && this.showCheckBox && !this.isLoaded) {
            this.updateParentCheckState();
        }
    };
    /**
     * Update the checkedNodes from datasource at initial rendering
     */
    TreeView.prototype.updateCheckedStateFromDS = function (id) {
        this.validNodes = [];
        if (this.treeData && this.showCheckBox) {
            if (this.dataType === 1) {
                var mapper = this.fields;
                var resultData = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */](this.treeData).executeLocal(new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["b" /* Query */]().where(mapper.isChecked, 'equal', true, false));
                for (var i = 0; i < resultData.length; i++) {
                    var resultId = resultData[i][this.fields.id] ? resultData[i][this.fields.id].toString() : null;
                    var resultPId = resultData[i][this.fields.parentID] ? resultData[i][this.fields.parentID].toString() : null;
                    if (this.checkedNodes.indexOf(resultId) === -1 && !(this.isLoaded)) {
                        this.checkedNodes.push(resultId);
                    }
                    if (resultData[i][this.fields.hasChildren]) {
                        var id_1 = resultData[i][this.fields.id];
                        var childData = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */](this.treeData).
                            executeLocal(new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["b" /* Query */]().where(mapper.parentID, 'equal', id_1, false));
                        for (var child = 0; child < childData.length; child++) {
                            var childId = childData[child][this.fields.id] ? childData[child][this.fields.id].toString() : null;
                            if (this.checkedNodes.indexOf(childId) === -1 && this.autoCheck) {
                                this.checkedNodes.push(childId);
                            }
                        }
                    }
                }
                for (var i = 0; i < this.checkedNodes.length; i++) {
                    var mapper_1 = this.fields;
                    var checkState = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */](this.treeData).
                        executeLocal(new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["b" /* Query */]().where(mapper_1.id, 'equal', this.checkedNodes[i], true));
                    if (checkState[0] && this.autoCheck) {
                        this.getCheckedNodeDetails(mapper_1, checkState);
                        this.checkIndeterminateState(checkState[0]);
                    }
                    if (checkState.length > 0) {
                        var checkedId = checkState[0][this.fields.id] ? checkState[0][this.fields.id].toString() : null;
                        if (this.checkedNodes.indexOf(checkedId) > -1 && this.validNodes.indexOf(checkedId) === -1) {
                            this.validNodes.push(checkedId);
                        }
                    }
                    var checkedData = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */](this.treeData).
                        executeLocal(new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["b" /* Query */]().where(mapper_1.parentID, 'equal', this.checkedNodes[i], true));
                    for (var index = 0; index < checkedData.length; index++) {
                        var checkedId = checkedData[index][this.fields.id] ? checkedData[index][this.fields.id].toString() : null;
                        if (this.checkedNodes.indexOf(checkedId) === -1 && this.autoCheck) {
                            this.checkedNodes.push(checkedId);
                        }
                        if (this.checkedNodes.indexOf(checkedId) > -1 && this.validNodes.indexOf(checkedId) === -1) {
                            this.validNodes.push(checkedId);
                        }
                    }
                }
            }
            else if (this.dataType === 2 || (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] &&
                this.isOffline)) {
                for (var index = 0; index < this.treeData.length; index++) {
                    var fieldId = this.treeData[index][this.fields.id] ? this.treeData[index][this.fields.id].toString() : '';
                    if (this.treeData[index][this.fields.isChecked] && !(this.isLoaded) && this.checkedNodes.indexOf(fieldId) === -1) {
                        this.checkedNodes.push(fieldId);
                    }
                    if (this.checkedNodes.indexOf(fieldId) > -1 && this.validNodes.indexOf(fieldId) === -1) {
                        this.validNodes.push(fieldId);
                    }
                    var childItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.child.toString(), this.treeData[index]);
                    if (childItems) {
                        this.updateChildCheckState(childItems, this.treeData[index]);
                    }
                }
            }
            this.setProperties({ checkedNodes: this.validNodes }, true);
        }
    };
    /**
     * To check whether the list data has sub child and to change the parent check state accordingly
     */
    TreeView.prototype.getCheckedNodeDetails = function (mapper, checkNodes) {
        var id = checkNodes[0][this.fields.parentID] ? checkNodes[0][this.fields.parentID].toString() : null;
        var count = 0;
        var element = this.element.querySelector('[data-uid="' + checkNodes[0][this.fields.id] + '"]');
        var parentEle = this.element.querySelector('[data-uid="' + checkNodes[0][this.fields.parentID] + '"]');
        if (!element && !parentEle) {
            var len = this.parentNodeCheck.length;
            if (this.parentNodeCheck.indexOf(id) === -1) {
                this.parentNodeCheck.push(id);
            }
            var childNodes = this.getChildNodes(this.treeData, id);
            for (var i = 0; i < childNodes.length; i++) {
                var childId = childNodes[i][this.fields.id] ? childNodes[i][this.fields.id].toString() : null;
                if (this.checkedNodes.indexOf(childId) !== -1) {
                    count++;
                }
                if (count === childNodes.length && this.checkedNodes.indexOf(id) === -1) {
                    this.checkedNodes.push(id);
                }
            }
            var preElement = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */](this.treeData).
                executeLocal(new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["b" /* Query */]().where(mapper.id, 'equal', id, true));
            this.getCheckedNodeDetails(mapper, preElement);
        }
        else if (parentEle) {
            var check = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CHECK, parentEle);
            if (!check) {
                this.changeState(parentEle, 'indeterminate', null, true, true);
            }
        }
    };
    /**
     * Update the checkedNodes and parent state when all the child Nodes are in checkedstate at initial rendering
     */
    TreeView.prototype.updateParentCheckState = function () {
        var indeterminate = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + INDETERMINATE, this.element);
        var childCheckedElement;
        for (var i = 0; i < indeterminate.length; i++) {
            var node = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(indeterminate[i], '.' + LISTITEM);
            var nodeId = node.getAttribute('data-uid').toString();
            if (this.dataType === 1) {
                childCheckedElement = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */](this.treeData).
                    executeLocal(new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["b" /* Query */]().where(this.fields.parentID, 'equal', nodeId, true));
            }
            else {
                childCheckedElement = this.getChildNodes(this.treeData, nodeId);
            }
            var count = 0;
            if (childCheckedElement) {
                for (var j = 0; j < childCheckedElement.length; j++) {
                    var childId = childCheckedElement[j][this.fields.id].toString();
                    if (this.checkedNodes.indexOf(childId) !== -1) {
                        count++;
                    }
                }
                if (count === childCheckedElement.length) {
                    var nodeCheck = node.getAttribute('data-uid');
                    if (this.checkedNodes.indexOf(nodeCheck) === -1) {
                        this.checkedNodes.push(nodeCheck);
                    }
                    this.changeState(node, 'check', null, true, true);
                }
                else if (count === 0 && this.checkedNodes.length === 0) {
                    this.changeState(node, 'uncheck', null, true, true);
                }
            }
        }
    };
    /**
     * Change the parent to indeterminate state whenever the child is in checked state which is not rendered in DOM
     */
    TreeView.prototype.checkIndeterminateState = function (data) {
        var element;
        if (this.dataType === 1) {
            element = this.element.querySelector('[data-uid="' + data[this.fields.parentID] + '"]');
        }
        else {
            element = this.element.querySelector('[data-uid="' + data[this.fields.id] + '"]');
        }
        if (element) {
            var ariaChecked = element.querySelector('.' + CHECKBOXWRAP).getAttribute('aria-checked');
            if (ariaChecked !== 'true') {
                this.changeState(element, 'indeterminate', null, true, true);
            }
        }
        else if (this.dataType === 2) {
            var len = this.parentNodeCheck.length;
            if (this.parentNodeCheck.indexOf(data[this.fields.id].toString()) === -1) {
                this.parentNodeCheck.push(data[this.fields.id].toString());
            }
        }
    };
    /**
     * Update the checkedNodes for child and subchild from datasource (hierarchical datasource) at initial rendering
     */
    TreeView.prototype.updateChildCheckState = function (childItems, treeData) {
        var count = 0;
        var checkedParent = treeData[this.fields.id] ? treeData[this.fields.id].toString() : '';
        for (var index = 0; index < childItems.length; index++) {
            var checkedChild = childItems[index][this.fields.id] ? childItems[index][this.fields.id].toString() : '';
            if (childItems[index][this.fields.isChecked] && !(this.isLoaded) && this.checkedNodes.indexOf(checkedChild) === -1) {
                this.checkedNodes.push(checkedChild);
            }
            if (this.checkedNodes.indexOf(checkedParent) !== -1 && this.checkedNodes.indexOf(checkedChild) === -1 && this.autoCheck) {
                this.checkedNodes.push(checkedChild);
            }
            if (this.checkedNodes.indexOf(checkedChild) !== -1 && this.autoCheck) {
                count++;
            }
            if (this.checkedNodes.indexOf(checkedChild) > -1 && this.validNodes.indexOf(checkedChild) === -1) {
                this.validNodes.push(checkedChild);
            }
            var subChildItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.child.toString(), childItems[index]);
            if (subChildItems && subChildItems.length) {
                if (this.parentCheckData.indexOf(treeData) === -1)
                    this.parentCheckData.push(treeData);
                this.updateChildCheckState(subChildItems, childItems[index]);
            }
            if (count === childItems.length && this.autoCheck && this.checkedNodes.indexOf(checkedParent) === -1) {
                this.checkedNodes.push(checkedParent);
            }
        }
        if (count !== 0 && this.autoCheck) {
            this.checkIndeterminateState(treeData);
            for (var len = 0; len < this.parentCheckData.length; len++) {
                if ((treeData !== this.parentCheckData[len]) && (this.parentCheckData[len])) {
                    this.checkIndeterminateState(this.parentCheckData[len]);
                }
            }
        }
    };
    TreeView.prototype.beforeNodeCreate = function (e) {
        if (this.showCheckBox) {
            var checkboxEle = Object(__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_buttons__["b" /* createCheckBox */])(this.createElement, true, { cssClass: this.touchClass });
            checkboxEle.setAttribute('role', 'checkbox');
            var icon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('div.' + ICON, e.item);
            var id = e.item.getAttribute('data-uid');
            e.item.childNodes[0].insertBefore(checkboxEle, e.item.childNodes[0].childNodes[Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(icon) ? 0 : 1]);
            var checkValue = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(e.fields.isChecked, e.curData);
            if (this.checkedNodes.indexOf(id) > -1) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CHECKBOXFRAME, checkboxEle).classList.add(CHECK);
                checkboxEle.setAttribute('aria-checked', 'true');
                this.addCheck(e.item);
            }
            else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(checkValue) && checkValue.toString() === 'true') {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CHECKBOXFRAME, checkboxEle).classList.add(CHECK);
                checkboxEle.setAttribute('aria-checked', 'true');
                this.addCheck(e.item);
            }
            else {
                checkboxEle.setAttribute('aria-checked', 'false');
            }
            var frame = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CHECKBOXFRAME, checkboxEle);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(frame, 'mousedown', this.frameMouseHandler, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(frame, 'mouseup', this.frameMouseHandler, this);
        }
        if (this.fullRowSelect) {
            this.createFullRow(e.item);
        }
        if (this.allowMultiSelection && !e.item.classList.contains(SELECTED)) {
            e.item.setAttribute('aria-selected', 'false');
        }
        var fields = e.fields;
        this.addActionClass(e, fields.selected, SELECTED);
        this.addActionClass(e, fields.expanded, EXPANDED);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.nodeTemplateFn)) {
            var textEle = e.item.querySelector('.' + LISTTEXT);
            var dataId = e.item.getAttribute('data-uid');
            textEle.innerHTML = '';
            this.renderNodeTemplate(e.curData, textEle, dataId);
        }
        var eventArgs = {
            node: e.item,
            nodeData: e.curData,
            text: e.text,
        };
        if (!this.isRefreshed) {
            this.trigger('drawNode', eventArgs);
        }
    };
    TreeView.prototype.frameMouseHandler = function (e) {
        var rippleSpan = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CHECKBOXRIPPLE, e.target.parentElement);
        Object(__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_buttons__["c" /* rippleMouseHandler */])(e, rippleSpan);
    };
    TreeView.prototype.addActionClass = function (e, action, cssClass) {
        var data = e.curData;
        var actionValue = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(action, data);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(actionValue) && actionValue.toString() !== 'false') {
            e.item.classList.add(cssClass);
        }
    };
    TreeView.prototype.getDataType = function (ds, mapper) {
        if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */]) {
            for (var i = 0; i < ds.length; i++) {
                if (this.isOffline) {
                    if ((typeof mapper.child === 'string') && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.child, ds[i])) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.parentID, ds[i]))) {
                        return 1;
                    }
                }
                else if ((typeof mapper.child === 'string') && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.child, ds[i]))) {
                    return 1;
                }
            }
            return 2;
        }
        for (var i = 0, len = ds.length; i < len; i++) {
            if ((typeof mapper.child === 'string') && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.child, ds[i]))) {
                return 2;
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.parentID, ds[i])) || !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.hasChildren, ds[i]))) {
                return 1;
            }
        }
        return 1;
    };
    TreeView.prototype.getGroupedData = function (dataSource, groupBy) {
        var cusQuery = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["b" /* Query */]().group(groupBy);
        var ds = __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_lists__["a" /* ListBase */].getDataSource(dataSource, cusQuery);
        var grpItem = [];
        for (var j = 0; j < ds.length; j++) {
            var itemObj = ds[j].items;
            grpItem.push(itemObj);
        }
        return grpItem;
    };
    TreeView.prototype.getSortedData = function (list) {
        if (list && this.sortOrder !== 'None') {
            list = __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_lists__["a" /* ListBase */].getDataSource(list, __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_lists__["a" /* ListBase */].addSorting(this.sortOrder, this.fields.text));
        }
        return list;
    };
    TreeView.prototype.finalizeNode = function (element) {
        var iNodes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + IMAGE, element);
        for (var k = 0; k < iNodes.length; k++) {
            iNodes[k].setAttribute('alt', IMAGE);
        }
        if (this.isLoaded) {
            var sNodes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + SELECTED, element);
            for (var i = 0; i < sNodes.length; i++) {
                this.selectNode(sNodes[i], null);
                break;
            }
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])(sNodes, SELECTED);
        }
        var cNodes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + LISTITEM + ':not(.' + EXPANDED + ')', element);
        for (var j = 0; j < cNodes.length; j++) {
            var icon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('div.' + ICON, cNodes[j]);
            if (icon && icon.classList.contains(EXPANDABLE)) {
                this.disableExpandAttr(cNodes[j]);
            }
        }
        var eNodes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + EXPANDED, element);
        if (!this.isInitalExpand) {
            for (var i = 0; i < eNodes.length; i++) {
                this.renderChildNodes(eNodes[i]);
            }
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])(eNodes, EXPANDED);
        this.updateList();
        if (this.isLoaded) {
            this.updateCheckedProp();
        }
    };
    TreeView.prototype.updateCheckedProp = function () {
        if (this.showCheckBox) {
            var nodes = [].concat([], this.checkedNodes);
            this.setProperties({ checkedNodes: nodes }, true);
        }
    };
    TreeView.prototype.ensureIndeterminate = function () {
        if (this.autoCheck) {
            var liElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('li', this.element);
            var ulElement = void 0;
            for (var i = 0; i < liElement.length; i++) {
                if (liElement[i].classList.contains(LISTITEM)) {
                    ulElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, liElement[i]);
                    if (ulElement) {
                        this.ensureParentCheckState(liElement[i]);
                    }
                    else {
                        this.ensureChildCheckState(liElement[i]);
                    }
                }
            }
        }
        else {
            var indeterminate = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + INDETERMINATE, this.element);
            for (var i = 0; i < indeterminate.length; i++) {
                indeterminate[i].classList.remove(INDETERMINATE);
            }
        }
    };
    TreeView.prototype.ensureParentCheckState = function (element) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(element)) {
            if (element.classList.contains(ROOT)) {
                return;
            }
            var ulElement = element;
            if (element.classList.contains(LISTITEM)) {
                ulElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, element);
            }
            var checkedNodes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CHECK, ulElement);
            var indeterminateNodes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + INDETERMINATE, ulElement);
            var nodes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + LISTITEM, ulElement);
            var checkBoxEle = element.getElementsByClassName(CHECKBOXWRAP)[0];
            if (nodes.length === checkedNodes.length) {
                this.changeState(checkBoxEle, 'check', null, true, true);
            }
            else if (checkedNodes.length > 0 || indeterminateNodes.length > 0) {
                this.changeState(checkBoxEle, 'indeterminate', null, true, true);
            }
            else if (checkedNodes.length === 0) {
                this.changeState(checkBoxEle, 'uncheck', null, true, true);
            }
            var parentUL = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(element, '.' + PARENTITEM);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(parentUL)) {
                var currentParent = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(parentUL, '.' + LISTITEM);
                this.ensureParentCheckState(currentParent);
            }
        }
    };
    TreeView.prototype.ensureChildCheckState = function (element, e) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(element)) {
            var childElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, element);
            var checkBoxes = void 0;
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(childElement)) {
                checkBoxes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CHECKBOXWRAP, childElement);
                var isChecked = element.getElementsByClassName(CHECKBOXFRAME)[0].classList.contains(CHECK);
                var parentCheck = element.getElementsByClassName(CHECKBOXFRAME)[0].classList.contains(INDETERMINATE);
                var childCheck = childElement.querySelectorAll('li');
                var expandState = childElement.parentElement.getAttribute('aria-expanded');
                var checkedState = void 0;
                for (var index = 0; index < checkBoxes.length; index++) {
                    var childId = childCheck[index].getAttribute('data-uid');
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.currentLoadData) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.isChecked, this.currentLoadData[index]))) {
                        checkedState = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.isChecked, this.currentLoadData[index]) ? 'check' : 'uncheck';
                        if (this.ele !== -1) {
                            checkedState = isChecked ? 'check' : 'uncheck';
                        }
                        if ((checkedState === 'uncheck') && (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["S" /* isUndefined */])(this.parentNodeCheck) && this.autoCheck
                            && this.parentNodeCheck.indexOf(childId) !== -1)) {
                            this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(childId), 1);
                            checkedState = 'indeterminate';
                        }
                    }
                    else {
                        var isNodeChecked = checkBoxes[index].getElementsByClassName(CHECKBOXFRAME)[0].classList.contains(CHECK);
                        if (isChecked) {
                            checkedState = 'check';
                        }
                        else if (isNodeChecked && !this.isLoaded) {
                            checkedState = 'check';
                        }
                        else if (this.checkedNodes.indexOf(childId) !== -1 && this.isLoaded && (parentCheck || isChecked)) {
                            checkedState = 'check';
                        }
                        else if (childCheck[index].classList.contains(CHILD) && (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["S" /* isUndefined */])(this.parentNodeCheck) && this.autoCheck
                            && (isChecked || parentCheck) && this.parentNodeCheck.indexOf(childId) !== -1)) {
                            checkedState = 'indeterminate';
                            this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(childId), 1);
                        }
                        else if (this.dataType === 1 && (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["S" /* isUndefined */])(this.parentNodeCheck) && this.autoCheck &&
                            (isChecked || parentCheck) && this.parentNodeCheck.indexOf(childId) !== -1)) {
                            checkedState = 'indeterminate';
                            this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(childId), 1);
                        }
                        else {
                            checkedState = 'uncheck';
                        }
                    }
                    this.changeState(checkBoxes[index], checkedState, e, true, true);
                }
            }
            if (this.autoCheck && this.isLoaded) {
                this.updateParentCheckState();
            }
        }
    };
    TreeView.prototype.doCheckBoxAction = function (nodes, doCheck) {
        var li = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + LISTITEM, this.element);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(nodes)) {
            for (var len = nodes.length; len >= 0; len--) {
                var liEle = void 0;
                if (nodes.length === 1) {
                    liEle = this.getElement(nodes[len - 1]);
                }
                else {
                    liEle = this.getElement(nodes[len]);
                }
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liEle)) {
                    var node = void 0;
                    node = nodes[len - nodes.length] ? nodes[len - nodes.length].toString() : nodes[len] ? nodes[len].toString() : null;
                    if (node !== '' && doCheck && node) {
                        this.setValidCheckedNode(node);
                        this.dynamicCheckState(node, doCheck);
                    }
                    else if (this.checkedNodes.indexOf(node) !== -1 && node !== '' && !doCheck) {
                        this.checkedNodes.splice(this.checkedNodes.indexOf(node), 1);
                        var childItems = this.getChildNodes(this.treeData, node);
                        if (childItems) {
                            for (var i = 0; i < childItems.length; i++) {
                                var id = childItems[i][this.fields.id] ? childItems[i][this.fields.id].toString() : null;
                                if (this.checkedNodes.indexOf(id) !== -1) {
                                    this.checkedNodes.splice(this.checkedNodes.indexOf(id), 1);
                                    var ele = this.element.querySelector('[data-uid="' + id + '"]');
                                    if (ele) {
                                        this.changeState(ele, 'uncheck', null);
                                    }
                                }
                            }
                            if (this.parentNodeCheck.indexOf(node) !== -1) {
                                this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(node), 1);
                            }
                        }
                        if (node) {
                            this.dynamicCheckState(node, doCheck);
                        }
                        this.updateField(this.treeData, this.fields, node, 'isChecked', null);
                    }
                    continue;
                }
                var checkBox = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM + ' .' + CHECKBOXWRAP, liEle);
                this.validateCheckNode(checkBox, !doCheck, liEle, null);
            }
        }
        else {
            var checkBoxes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + CHECKBOXWRAP, this.element);
            if (this.loadOnDemand) {
                for (var index = 0; index < checkBoxes.length; index++) {
                    this.updateFieldChecked(checkBoxes[index], doCheck);
                    this.changeState(checkBoxes[index], doCheck ? 'check' : 'uncheck', null, null, null, doCheck);
                }
            }
            else {
                for (var index = 0; index < checkBoxes.length; index++) {
                    this.updateFieldChecked(checkBoxes[index], doCheck);
                    this.changeState(checkBoxes[index], doCheck ? 'check' : 'uncheck');
                }
            }
        }
        if (nodes) {
            for (var j = 0; j < nodes.length; j++) {
                var node = nodes[j] ? nodes[j].toString() : '';
                if (!doCheck) {
                    this.updateField(this.treeData, this.fields, node, 'isChecked', null);
                }
            }
        }
        if (this.autoCheck) {
            this.updateParentCheckState();
        }
    };
    TreeView.prototype.updateFieldChecked = function (checkbox, doCheck) {
        var currLi = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(checkbox, '.' + LISTITEM);
        var id = currLi.getAttribute('data-uid');
        var nodeDetails = this.getNodeData(currLi);
        if (nodeDetails.isChecked === 'true' && !doCheck) {
            this.updateField(this.treeData, this.fields, id, 'isChecked', null);
        }
    };
    /**
     * Changes the parent and child  check state while changing the checkedNodes via setmodel
     */
    TreeView.prototype.dynamicCheckState = function (node, doCheck) {
        if (this.dataType === 1) {
            var count = 0;
            var resultId = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */](this.treeData).executeLocal(new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["b" /* Query */]().where(this.fields.id, 'equal', node, true));
            if (resultId[0]) {
                var id = resultId[0][this.fields.id] ? resultId[0][this.fields.id].toString() : null;
                var parent_1 = resultId[0][this.fields.parentID] ? resultId[0][this.fields.parentID].toString() : null;
                var parentElement = this.element.querySelector('[data-uid="' + parent_1 + '"]');
                var indeterminate = parentElement ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + INDETERMINATE, parentElement) : null;
                var check = parentElement ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CHECK, parentElement) : null;
                var element = this.element.querySelector('[data-uid="' + id + '"]');
                var childNodes = this.getChildNodes(this.treeData, parent_1);
                if (childNodes) {
                    for (var i = 0; i < childNodes.length; i++) {
                        var childId = childNodes[i][this.fields.id] ? childNodes[i][this.fields.id].toString() : null;
                        if (this.checkedNodes.indexOf(childId) !== -1) {
                            count++;
                        }
                    }
                }
                if (this.checkedNodes.indexOf(node) !== -1 && parentElement && (id === node) && this.autoCheck) {
                    this.changeState(parentElement, 'indeterminate', null);
                }
                else if (this.checkedNodes.indexOf(node) === -1 && element && (id === node) && !doCheck) {
                    this.changeState(element, 'uncheck', null);
                }
                else if (this.checkedNodes.indexOf(node) !== -1 && element && (id === node) && doCheck) {
                    this.changeState(element, 'check', null);
                }
                else if (this.checkedNodes.indexOf(node) === -1 && !element && parentElement && (id === node) && this.autoCheck
                    && count !== 0) {
                    this.changeState(parentElement, 'indeterminate', null);
                }
                else if (this.checkedNodes.indexOf(node) === -1 && !element && parentElement && (id === node) && this.autoCheck
                    && count === 0) {
                    this.changeState(parentElement, 'uncheck', null);
                }
                else if (!element && !parentElement && (id === node) && this.autoCheck) {
                    this.updateIndeterminate(node, doCheck);
                }
            }
        }
        else if (this.dataType === 2 || (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] &&
            this.isOffline)) {
            var id = void 0;
            var parentElement = void 0;
            var check = void 0;
            for (var i = 0; i < this.treeData.length; i++) {
                id = this.treeData[i][this.fields.id] ? this.treeData[i][this.fields.id].toString() : '';
                parentElement = this.element.querySelector('[data-uid="' + id + '"]');
                check = parentElement ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CHECK, parentElement) : null;
                if (this.checkedNodes.indexOf(id) === -1 && parentElement && check && !doCheck) {
                    this.changeState(parentElement, 'uncheck', null);
                }
                var subChild = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.child.toString(), this.treeData[i]);
                if (subChild) {
                    this.updateChildIndeterminate(subChild, id, node, doCheck, id);
                }
            }
        }
    };
    /**
     * updates the parent and child  check state while changing the checkedNodes via setmodel for listData
     */
    TreeView.prototype.updateIndeterminate = function (node, doCheck) {
        var indeterminateData = this.getTreeData(node);
        var count = 0;
        var parent;
        if (this.dataType === 1) {
            parent = indeterminateData[0][this.fields.parentID] ? indeterminateData[0][this.fields.parentID].toString() : null;
        }
        var childNodes = this.getChildNodes(this.treeData, parent);
        if (childNodes) {
            for (var i = 0; i < childNodes.length; i++) {
                var childId = childNodes[i][this.fields.id] ? childNodes[i][this.fields.id].toString() : null;
                if (this.checkedNodes.indexOf(childId) !== -1) {
                    count++;
                }
            }
        }
        var parentElement = this.element.querySelector('[data-uid="' + parent + '"]');
        if (parentElement && doCheck) {
            this.changeState(parentElement, 'indeterminate', null);
        }
        else if (!doCheck && parentElement && this.parentNodeCheck.indexOf(parent) === -1 && count !== 0) {
            this.changeState(parentElement, 'indeterminate', null);
        }
        else if (!doCheck && parentElement && this.parentNodeCheck.indexOf(parent) === -1 && count === 0) {
            this.changeState(parentElement, 'uncheck', null);
        }
        else if (!parentElement) {
            if (!doCheck && this.checkedNodes.indexOf(parent) === -1 && this.parentNodeCheck.indexOf(parent) !== -1) {
                this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(parent), 1);
            }
            else if (doCheck && this.checkedNodes.indexOf(parent) === -1 && this.parentNodeCheck.indexOf(parent) === -1) {
                this.parentNodeCheck.push(parent);
            }
            else if (!doCheck && this.checkedNodes.indexOf(parent) !== -1 && this.parentNodeCheck.indexOf(parent) === -1
                && count !== 0) {
                this.parentNodeCheck.push(parent);
            }
            this.updateIndeterminate(parent, doCheck);
            if (this.checkedNodes.indexOf(parent) !== -1 && !doCheck) {
                this.checkedNodes.splice(this.checkedNodes.indexOf(parent), 1);
            }
        }
    };
    /**
     * updates the parent and child  check state while changing the checkedNodes via setmodel for hierarchical data
     */
    TreeView.prototype.updateChildIndeterminate = function (subChild, parent, node, doCheck, child) {
        var count = 0;
        for (var j = 0; j < subChild.length; j++) {
            var subId = subChild[j][this.fields.id] ? subChild[j][this.fields.id].toString() : '';
            if (this.checkedNodes.indexOf(subId) !== -1) {
                count++;
            }
            var parentElement = this.element.querySelector('[data-uid="' + parent + '"]');
            var indeterminate = parentElement ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + INDETERMINATE, parentElement) : null;
            var check = parentElement ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CHECK, parentElement) : null;
            var element = this.element.querySelector('[data-uid="' + subId + '"]');
            var childElementCheck = element ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CHECK, element) : null;
            if (this.checkedNodes.indexOf(node) !== -1 && parentElement && (subId === node) && this.autoCheck) {
                this.changeState(parentElement, 'indeterminate', null);
            }
            else if (this.checkedNodes.indexOf(node) === -1 && parentElement && !element && (subId === node) && !doCheck) {
                if (this.autoCheck) {
                    this.changeState(parentElement, 'uncheck', null);
                }
                else {
                    if (count !== 0) {
                        this.changeState(parentElement, 'indeterminate', null);
                    }
                    else {
                        this.changeState(parentElement, 'uncheck', null);
                    }
                }
            }
            else if (this.checkedNodes.indexOf(node) === -1 && element && (subId === node) && !doCheck) {
                this.changeState(element, 'uncheck', null);
            }
            else if (this.checkedNodes.indexOf(node) === -1 && indeterminate && (subId === node) && this.autoCheck && count === 0
                && !doCheck) {
                indeterminate.classList.remove(INDETERMINATE);
            }
            else if (this.checkedNodes.indexOf(node) === -1 && !element && check && (subId === node) && count === 0) {
                this.changeState(parentElement, 'uncheck', null);
            }
            else if (this.checkedNodes.indexOf(subId) === -1 && element && childElementCheck && count === 0) {
                this.changeState(element, 'uncheck', null);
            }
            else if (!element && !parentElement && (subId === node) || (this.parentNodeCheck.indexOf(parent) !== -1) && this.autoCheck) {
                var childElement = this.element.querySelector('[data-uid="' + child + '"]');
                if (doCheck && count !== 0) {
                    this.changeState(childElement, 'indeterminate', null);
                }
                else if (doCheck && count === subChild.length && this.checkedNodes.indexOf(parent) === -1) {
                    this.checkedNodes.push(parent);
                }
                else if (!doCheck && count === 0 && this.parentNodeCheck.indexOf(parent) !== -1) {
                    this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(parent));
                }
                if (this.parentNodeCheck.indexOf(parent) === -1) {
                    this.parentNodeCheck.push(parent);
                }
            }
            var innerChild = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.child.toString(), subChild[j]);
            if (innerChild) {
                this.updateChildIndeterminate(innerChild, subId, node, doCheck, child);
            }
        }
    };
    TreeView.prototype.changeState = function (wrapper, state, e, isPrevent, isAdd, doCheck) {
        var _this = this;
        var eventArgs;
        var currLi = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(wrapper, '.' + LISTITEM);
        if (wrapper === currLi) {
            wrapper = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CHECKBOXWRAP, currLi);
        }
        if (!isPrevent) {
            this.checkActionNodes = [];
            eventArgs = this.getCheckEvent(currLi, state, e);
            this.trigger('nodeChecking', eventArgs, function (observedArgs) {
                if (!observedArgs.cancel) {
                    _this.nodeCheckAction(wrapper, state, currLi, observedArgs, e, isPrevent, isAdd, doCheck);
                }
            });
        }
        else {
            this.nodeCheckAction(wrapper, state, currLi, eventArgs, e, isPrevent, isAdd, doCheck);
        }
    };
    TreeView.prototype.nodeCheckAction = function (wrapper, state, currLi, eventArgs, e, isPrevent, isAdd, doCheck) {
        var ariaState;
        var frameSpan = wrapper.getElementsByClassName(CHECKBOXFRAME)[0];
        if (state === 'check' && !frameSpan.classList.contains(CHECK)) {
            frameSpan.classList.remove(INDETERMINATE);
            frameSpan.classList.add(CHECK);
            this.addCheck(currLi);
            ariaState = 'true';
        }
        else if (state === 'uncheck' && (frameSpan.classList.contains(CHECK) || frameSpan.classList.contains(INDETERMINATE))) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([frameSpan], [CHECK, INDETERMINATE]);
            this.removeCheck(currLi);
            ariaState = 'false';
        }
        else if (state === 'indeterminate' && this.autoCheck) {
            frameSpan.classList.remove(CHECK);
            frameSpan.classList.add(INDETERMINATE);
            this.removeCheck(currLi);
            ariaState = 'mixed';
        }
        ariaState = state === 'check' ? 'true' : state === 'uncheck' ? 'false' : ariaState;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ariaState)) {
            wrapper.setAttribute('aria-checked', ariaState);
        }
        if (isAdd) {
            var data = [].concat([], this.checkActionNodes);
            eventArgs = this.getCheckEvent(currLi, state, e);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["S" /* isUndefined */])(isPrevent)) {
                eventArgs.data = data;
            }
        }
        if (doCheck !== undefined) {
            this.ensureStateChange(currLi, doCheck);
        }
        if (!isPrevent) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ariaState)) {
                wrapper.setAttribute('aria-checked', ariaState);
                eventArgs.data[0].checked = ariaState;
                this.trigger('nodeChecked', eventArgs);
                this.checkActionNodes = [];
            }
        }
    };
    TreeView.prototype.addCheck = function (liEle) {
        var id = liEle.getAttribute('data-uid');
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(id) && this.checkedNodes.indexOf(id) === -1) {
            this.checkedNodes.push(id);
        }
    };
    TreeView.prototype.removeCheck = function (liEle) {
        var index = this.checkedNodes.indexOf(liEle.getAttribute('data-uid'));
        if (index > -1) {
            this.checkedNodes.splice(index, 1);
        }
    };
    TreeView.prototype.getCheckEvent = function (currLi, action, e) {
        this.checkActionNodes.push(this.getNodeData(currLi));
        var nodeData = this.checkActionNodes;
        return { action: action, cancel: false, isInteracted: Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e) ? false : true, node: currLi, data: nodeData };
    };
    TreeView.prototype.finalize = function () {
        var firstUl = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, this.element);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(firstUl)) {
            firstUl.setAttribute('role', treeAriaAttr.treeRole);
            this.setMultiSelect(this.allowMultiSelection);
            var firstNode = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + LISTITEM, this.element);
            if (firstNode) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([firstNode], FOCUS);
                this.updateIdAttr(null, firstNode);
            }
            if (this.allowTextWrap) {
                this.updateWrap();
            }
            this.renderReactTemplates();
            this.hasPid = this.rootData[0] ? this.rootData[0].hasOwnProperty(this.fields.parentID) : false;
            this.doExpandAction();
        }
    };
    TreeView.prototype.setTextWrap = function () {
        (this.allowTextWrap ? __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */] : __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], LISTWRAP);
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isIE) {
            (this.allowTextWrap ? __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */] : __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], IELISTWRAP);
        }
    };
    TreeView.prototype.updateWrap = function (ulEle) {
        if (!this.fullRowSelect) {
            return;
        }
        var liEle = ulEle ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + LISTITEM, ulEle) : this.liList;
        var length = liEle.length;
        for (var i = 0; i < length; i++) {
            this.calculateWrap(liEle[i]);
        }
    };
    TreeView.prototype.calculateWrap = function (liEle) {
        var element = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + FULLROW, liEle);
        if (element && element.nextElementSibling) {
            element.style.height = this.allowTextWrap ? element.nextElementSibling.offsetHeight + 'px' : '';
        }
    };
    TreeView.prototype.doExpandAction = function () {
        var eUids = this.expandedNodes;
        if (this.isInitalExpand && eUids.length > 0) {
            this.setProperties({ expandedNodes: [] }, true);
            /* eslint-disable */
            if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */]) {
                this.expandGivenNodes(eUids);
            }
            else {
                for (var i = 0; i < eUids.length; i++) {
                    var eNode = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('[data-uid="' + eUids[i] + '"]', this.element);
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(eNode)) {
                        var icon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + EXPANDABLE, Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + TEXTWRAP, eNode));
                        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(icon)) {
                            this.expandAction(eNode, icon, null);
                        }
                    }
                    else {
                        if (eUids[i] && this.expandChildren.indexOf(eUids[i]) === -1) {
                            this.expandChildren.push(eUids[i].toString());
                        }
                        continue;
                    }
                }
                this.afterFinalized();
            }
        }
        else {
            this.afterFinalized();
        }
    };
    TreeView.prototype.expandGivenNodes = function (arr) {
        var proxy = this;
        this.expandCallback(arr[this.index], function () {
            proxy.index++;
            if (proxy.index < arr.length) {
                proxy.expandGivenNodes(arr);
            }
            else {
                proxy.afterFinalized();
            }
        });
    };
    TreeView.prototype.expandCallback = function (eUid, callback) {
        var eNode = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('[data-uid="' + eUid + '"]', this.element);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(eNode)) {
            var icon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + EXPANDABLE, Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + TEXTWRAP, eNode));
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(icon)) {
                this.expandAction(eNode, icon, null, false, callback);
            }
            else {
                callback();
            }
        }
        else {
            callback();
        }
    };
    TreeView.prototype.afterFinalized = function () {
        this.doSelectionAction();
        this.updateCheckedProp();
        this.isAnimate = true;
        this.isInitalExpand = false;
        if (!this.isLoaded || this.isFieldChange) {
            var eventArgs = { data: this.treeData };
            this.trigger('dataBound', eventArgs);
        }
        this.isLoaded = true;
    };
    TreeView.prototype.doSelectionAction = function () {
        var sNodes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + SELECTED, this.element);
        var sUids = this.selectedNodes;
        if (sUids.length > 0) {
            this.setProperties({ selectedNodes: [] }, true);
            for (var i = 0; i < sUids.length; i++) {
                var sNode = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('[data-uid="' + sUids[i] + '"]', this.element);
                if (sNode && !(sNode.classList.contains('e-active'))) {
                    this.selectNode(sNode, null, true);
                }
                else {
                    this.selectedNodes.push(sUids[i]);
                }
                if (!this.allowMultiSelection) {
                    break;
                }
            }
        }
        else {
            this.selectGivenNodes(sNodes);
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])(sNodes, SELECTED);
    };
    TreeView.prototype.selectGivenNodes = function (sNodes) {
        for (var i = 0; i < sNodes.length; i++) {
            if (!sNodes[i].classList.contains('e-disable')) {
                this.selectNode(sNodes[i], null, true);
            }
            if (!this.allowMultiSelection) {
                break;
            }
        }
    };
    TreeView.prototype.clickHandler = function (event) {
        var target = event.originalEvent.target;
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'contextmenu', this.preventContextMenu);
        if (!target || this.dragStartAction) {
            return;
        }
        else {
            var classList = target.classList;
            var li = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(target, '.' + LISTITEM);
            if (!li) {
                return;
            }
            else if (event.originalEvent.which !== 3) {
                var rippleElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + RIPPLEELMENT, li);
                var rippleIcons = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + ICON, li);
                this.removeHover();
                this.setFocusElement(li);
                if (this.showCheckBox && !li.classList.contains('e-disable')) {
                    var checkWrapper = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(target, '.' + CHECKBOXWRAP);
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(checkWrapper)) {
                        var checkElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CHECKBOXFRAME, checkWrapper);
                        this.validateCheckNode(checkWrapper, checkElement.classList.contains(CHECK), li, event.originalEvent);
                        this.triggerClickEvent(event.originalEvent, li);
                        return;
                    }
                }
                if (classList.contains(EXPANDABLE)) {
                    this.expandAction(li, target, event);
                }
                else if (classList.contains(COLLAPSIBLE)) {
                    this.collapseNode(li, target, event);
                }
                else if (rippleElement && rippleIcons) {
                    if (rippleIcons.classList.contains(RIPPLE) && rippleIcons.classList.contains(EXPANDABLE)) {
                        this.expandAction(li, rippleIcons, event);
                    }
                    else if (rippleIcons.classList.contains(RIPPLE) && rippleIcons.classList.contains(COLLAPSIBLE)) {
                        this.collapseNode(li, rippleIcons, event);
                    }
                    else if (!classList.contains(PARENTITEM) && !classList.contains(LISTITEM)) {
                        this.toggleSelect(li, event.originalEvent, false);
                    }
                }
                else {
                    if (!classList.contains(PARENTITEM) && !classList.contains(LISTITEM)) {
                        this.toggleSelect(li, event.originalEvent, false);
                    }
                }
            }
            this.triggerClickEvent(event.originalEvent, li);
        }
    };
    TreeView.prototype.nodeCheckedEvent = function (wrapper, isCheck, e) {
        var currLi = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(wrapper, '.' + LISTITEM);
        var eventArgs = this.getCheckEvent(wrapper, isCheck ? 'uncheck' : 'check', e);
        eventArgs.data = eventArgs.data.splice(0, eventArgs.data.length - 1);
        this.trigger('nodeChecked', eventArgs);
    };
    TreeView.prototype.triggerClickEvent = function (e, li) {
        var eventArgs = {
            event: e,
            node: li,
        };
        this.trigger('nodeClicked', eventArgs);
    };
    TreeView.prototype.expandNode = function (currLi, icon, loaded) {
        var _this = this;
        this.renderReactTemplates();
        if (icon.classList.contains(LOAD)) {
            this.hideSpinner(icon);
        }
        if (!this.initialRender) {
            icon.classList.add('interaction');
        }
        if (loaded !== true || (loaded === true && currLi.classList.contains('e-expanded'))) {
            if (this.preventExpand !== true) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([icon], EXPANDABLE);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([icon], COLLAPSIBLE);
                var start_1 = 0;
                var end_1 = 0;
                var proxy_1 = this;
                var ul_1 = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, currLi);
                var liEle_1 = currLi;
                this.setHeight(liEle_1, ul_1);
                var activeElement_1 = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + LISTITEM + '.' + ACTIVE, currLi);
                if (this.isAnimate && !this.isRefreshed) {
                    this.aniObj.animate(ul_1, {
                        name: this.animation.expand.effect,
                        duration: this.animation.expand.duration,
                        timingFunction: this.animation.expand.easing,
                        begin: function (args) {
                            liEle_1.style.overflow = 'hidden';
                            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(activeElement_1) && activeElement_1 instanceof HTMLElement) {
                                activeElement_1.classList.add(ITEM_ANIMATION_ACTIVE);
                            }
                            start_1 = liEle_1.offsetHeight;
                            end_1 = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + TEXTWRAP, currLi).offsetHeight;
                        },
                        progress: function (args) {
                            args.element.style.display = 'block';
                            proxy_1.animateHeight(args, start_1, end_1);
                        },
                        end: function (args) {
                            args.element.style.display = 'block';
                            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(activeElement_1) && activeElement_1 instanceof HTMLElement) {
                                activeElement_1.classList.remove(ITEM_ANIMATION_ACTIVE);
                            }
                            _this.expandedNode(liEle_1, ul_1, icon);
                        }
                    });
                }
                else {
                    this.expandedNode(liEle_1, ul_1, icon);
                }
            }
        }
        else {
            var ul = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, currLi);
            ul.style.display = 'none';
            if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] === true) {
                this.preventExpand = false;
            }
        }
        if (this.initialRender) {
            icon.classList.add('interaction');
        }
    };
    TreeView.prototype.expandedNode = function (currLi, ul, icon) {
        ul.style.display = 'block';
        currLi.style.display = 'block';
        currLi.style.overflow = '';
        currLi.style.height = '';
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([icon], PROCESS);
        this.addExpand(currLi);
        if (this.allowTextWrap && this.isLoaded && this.isFirstRender) {
            this.updateWrap(currLi);
            this.isFirstRender = false;
        }
        if (this.isLoaded && this.expandArgs && !this.isRefreshed) {
            this.expandArgs = this.getExpandEvent(currLi, null);
            this.trigger('nodeExpanded', this.expandArgs);
        }
    };
    TreeView.prototype.addExpand = function (liEle) {
        liEle.setAttribute('aria-expanded', 'true');
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([liEle], NODECOLLAPSED);
        var id = liEle.getAttribute('data-uid');
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(id) && this.expandedNodes.indexOf(id) === -1) {
            this.expandedNodes.push(id);
        }
    };
    TreeView.prototype.collapseNode = function (currLi, icon, e) {
        var _this = this;
        if (icon.classList.contains(PROCESS)) {
            return;
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([icon], PROCESS);
        }
        var colArgs;
        if (this.isLoaded) {
            colArgs = this.getExpandEvent(currLi, e);
            this.trigger('nodeCollapsing', colArgs, function (observedArgs) {
                if (observedArgs.cancel) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([icon], PROCESS);
                }
                else {
                    _this.nodeCollapseAction(currLi, icon, observedArgs);
                }
            });
        }
        else {
            this.nodeCollapseAction(currLi, icon, colArgs);
        }
    };
    TreeView.prototype.nodeCollapseAction = function (currLi, icon, colArgs) {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([icon], COLLAPSIBLE);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([icon], EXPANDABLE);
        var start = 0;
        var end = 0;
        var proxy = this;
        var ul = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, currLi);
        var liEle = currLi;
        var activeElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + LISTITEM + '.' + ACTIVE, currLi);
        if (this.isAnimate) {
            this.aniObj.animate(ul, {
                name: this.animation.collapse.effect,
                duration: this.animation.collapse.duration,
                timingFunction: this.animation.collapse.easing,
                begin: function (args) {
                    liEle.style.overflow = 'hidden';
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(activeElement) && activeElement instanceof HTMLElement) {
                        activeElement.classList.add(ITEM_ANIMATION_ACTIVE);
                    }
                    start = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + TEXTWRAP, currLi).offsetHeight;
                    end = liEle.offsetHeight;
                },
                progress: function (args) {
                    proxy.animateHeight(args, start, end);
                },
                end: function (args) {
                    args.element.style.display = 'none';
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(activeElement) && activeElement instanceof HTMLElement) {
                        activeElement.classList.remove(ITEM_ANIMATION_ACTIVE);
                    }
                    _this.collapsedNode(liEle, ul, icon, colArgs);
                }
            });
        }
        else {
            this.collapsedNode(liEle, ul, icon, colArgs);
        }
    };
    TreeView.prototype.collapsedNode = function (liEle, ul, icon, colArgs) {
        ul.style.display = 'none';
        liEle.style.overflow = '';
        liEle.style.height = '';
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([icon], PROCESS);
        this.removeExpand(liEle);
        if (this.isLoaded) {
            colArgs = this.getExpandEvent(liEle, null);
            this.trigger('nodeCollapsed', colArgs);
        }
    };
    TreeView.prototype.removeExpand = function (liEle, toRemove) {
        if (toRemove) {
            liEle.removeAttribute('aria-expanded');
        }
        else {
            this.disableExpandAttr(liEle);
        }
        var index = this.expandedNodes.indexOf(liEle.getAttribute('data-uid'));
        if (index > -1) {
            this.expandedNodes.splice(index, 1);
        }
    };
    TreeView.prototype.disableExpandAttr = function (liEle) {
        liEle.setAttribute('aria-expanded', 'false');
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([liEle], NODECOLLAPSED);
    };
    TreeView.prototype.setHeight = function (currLi, ul) {
        ul.style.display = 'block';
        ul.style.visibility = 'hidden';
        currLi.style.height = currLi.offsetHeight + 'px';
        ul.style.display = 'none';
        ul.style.visibility = '';
    };
    TreeView.prototype.animateHeight = function (args, start, end) {
        var remaining = (args.duration - args.timeStamp) / args.duration;
        var currentHeight = (end - start) * remaining + start;
        args.element.parentElement.style.height = currentHeight + 'px';
    };
    TreeView.prototype.renderChildNodes = function (parentLi, expandChild, callback, loaded) {
        var _this = this;
        var eicon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('div.' + ICON, parentLi);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(eicon)) {
            return;
        }
        this.showSpinner(eicon);
        var childItems;
        /* eslint-disable */
        if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */]) {
            var level = this.parents(parentLi, '.' + PARENTITEM).length;
            var mapper_2 = this.getChildFields(this.fields, level, 1);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(mapper_2) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(mapper_2.dataSource)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(eicon);
                this.removeExpand(parentLi, true);
                return;
            }
            this.treeList.push('false');
            if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] && this.isOffline) {
                this.treeList.pop();
                childItems = this.getChildNodes(this.treeData, parentLi.getAttribute('data-uid'));
                this.loadChild(childItems, mapper_2, eicon, parentLi, expandChild, callback, loaded);
            }
            else {
                mapper_2.dataSource.executeQuery(this.getQuery(mapper_2, parentLi.getAttribute('data-uid'))).then(function (e) {
                    _this.treeList.pop();
                    childItems = e.result;
                    if (_this.dataType === 1) {
                        _this.dataType = 2;
                    }
                    _this.loadChild(childItems, mapper_2, eicon, parentLi, expandChild, callback, loaded);
                }).catch(function (e) {
                    _this.trigger('actionFailure', { error: e });
                });
            }
        }
        else {
            childItems = this.getChildNodes(this.treeData, parentLi.getAttribute('data-uid'));
            this.currentLoadData = this.getSortedData(childItems);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(childItems) || childItems.length === 0) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(eicon);
                this.removeExpand(parentLi, true);
                return;
            }
            else {
                this.listBaseOption.ariaAttributes.level = parseFloat(parentLi.getAttribute('aria-level')) + 1;
                parentLi.appendChild(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_lists__["a" /* ListBase */].createList(this.createElement, this.currentLoadData, this.listBaseOption));
                this.expandNode(parentLi, eicon, loaded);
                this.setSelectionForChildNodes(childItems);
                this.ensureCheckNode(parentLi);
                this.finalizeNode(parentLi);
                this.disableTreeNodes(childItems);
                this.renderSubChild(parentLi, expandChild, loaded);
            }
        }
    };
    TreeView.prototype.loadChild = function (childItems, mapper, eicon, parentLi, expandChild, callback, loaded) {
        this.currentLoadData = childItems;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(childItems) || childItems.length === 0) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(eicon);
            this.removeExpand(parentLi, true);
        }
        else {
            this.updateListProp(mapper);
            if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] && !this.isOffline) {
                var id = parentLi.getAttribute('data-uid');
                var nodeData = this.getNodeObject(id);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])('child', childItems, nodeData);
            }
            this.listBaseOption.ariaAttributes.level = parseFloat(parentLi.getAttribute('aria-level')) + 1;
            parentLi.appendChild(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_lists__["a" /* ListBase */].createList(this.createElement, childItems, this.listBaseOption));
            this.expandNode(parentLi, eicon, loaded);
            this.setSelectionForChildNodes(childItems);
            this.ensureCheckNode(parentLi);
            this.finalizeNode(parentLi);
            this.disableTreeNodes(childItems);
            this.renderSubChild(parentLi, expandChild, loaded);
        }
        if (callback) {
            callback();
        }
        if (this.treeList.length === 0 && !this.isLoaded) {
            this.finalize();
        }
    };
    TreeView.prototype.disableTreeNodes = function (childItems) {
        var i = 0;
        while (i < childItems.length) {
            var id = childItems[i][this.fields.id] ? childItems[i][this.fields.id].toString() : null;
            if (this.disableNode !== undefined && this.disableNode.indexOf(id) !== -1) {
                this.doDisableAction([id]);
            }
            i++;
        }
    };
    /**
     * Sets the child Item in selectedState while rendering the child node
     */
    TreeView.prototype.setSelectionForChildNodes = function (nodes) {
        var i;
        for (i = 0; i < nodes.length; i++) {
            var id = nodes[i][this.fields.id] ? nodes[i][this.fields.id].toString() : null;
            if (this.selectedNodes !== undefined && this.selectedNodes.indexOf(id) !== -1) {
                this.doSelectionAction();
            }
        }
    };
    TreeView.prototype.ensureCheckNode = function (element) {
        if (this.showCheckBox) {
            this.ele = (this.checkedElement) ? this.checkedElement.indexOf(element.getAttribute('data-uid')) : null;
            if (this.autoCheck) {
                this.ensureChildCheckState(element);
                this.ensureParentCheckState(element);
            }
        }
        this.currentLoadData = null;
    };
    TreeView.prototype.getFields = function (mapper, nodeLevel, dataLevel) {
        if (nodeLevel === dataLevel) {
            return mapper;
        }
        else {
            return this.getFields(this.getChildMapper(mapper), nodeLevel, dataLevel + 1);
        }
    };
    TreeView.prototype.getChildFields = function (mapper, nodeLevel, dataLevel) {
        var childData;
        if (nodeLevel === dataLevel) {
            return this.getChildMapper(mapper);
        }
        else {
            return this.getChildFields(this.getChildMapper(mapper), nodeLevel, dataLevel + 1);
        }
    };
    TreeView.prototype.getChildMapper = function (mapper) {
        return (typeof mapper.child === 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(mapper.child)) ? mapper : mapper.child;
    };
    TreeView.prototype.getChildNodes = function (obj, parentId, isRoot) {
        if (isRoot === void 0) { isRoot = false; }
        var childNodes;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(obj)) {
            return childNodes;
        }
        else if (this.dataType === 1) {
            return this.getChildGroup(this.groupedData, parentId, isRoot);
        }
        else {
            if (typeof this.fields.child === 'string') {
                for (var i = 0, objlen = obj.length; i < objlen; i++) {
                    var dataId = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.id, obj[i]);
                    if (dataId && dataId.toString() === parentId) {
                        return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.child, obj[i]);
                    }
                    else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.child, obj[i]))) {
                        childNodes = this.getChildNodes(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.child, obj[i]), parentId);
                        if (childNodes !== undefined) {
                            break;
                        }
                    }
                }
            }
        }
        return childNodes;
    };
    TreeView.prototype.getChildGroup = function (data, parentId, isRoot) {
        var childNodes;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data)) {
            return childNodes;
        }
        for (var i = 0, objlen = data.length; i < objlen; i++) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data[i][0]) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.parentID, data[i][0]))) {
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.parentID, data[i][0]).toString() === parentId) {
                    return data[i];
                }
            }
            else if (isRoot) {
                return data[i];
            }
            else {
                return [];
            }
        }
        return childNodes;
    };
    TreeView.prototype.renderSubChild = function (element, expandChild, loaded) {
        if (expandChild) {
            var cIcons = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + EXPANDABLE, element);
            for (var i = 0, len = cIcons.length; i < len; i++) {
                var icon = cIcons[i];
                if (element.querySelector('.e-icons') !== cIcons[i]) {
                    var curLi = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(icon, '.' + LISTITEM);
                    this.expandArgs = this.getExpandEvent(curLi, null);
                    if (loaded !== true) {
                        this.trigger('nodeExpanding', this.expandArgs);
                    }
                    this.renderChildNodes(curLi, expandChild, null, loaded);
                }
            }
        }
    };
    TreeView.prototype.toggleSelect = function (li, e, multiSelect) {
        if (!li.classList.contains('e-disable')) {
            if (this.allowMultiSelection && ((e && e.ctrlKey) || multiSelect) && this.isActive(li)) {
                this.unselectNode(li, e);
            }
            else {
                this.selectNode(li, e, multiSelect);
            }
        }
    };
    TreeView.prototype.isActive = function (li) {
        return li.classList.contains(ACTIVE) ? true : false;
    };
    TreeView.prototype.selectNode = function (li, e, multiSelect) {
        var _this = this;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li) || (!this.allowMultiSelection && this.isActive(li) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e))) {
            this.setFocusElement(li);
            return;
        }
        var eventArgs;
        if (this.isLoaded) {
            eventArgs = this.getSelectEvent(li, 'select', e);
            this.trigger('nodeSelecting', eventArgs, function (observedArgs) {
                if (!observedArgs.cancel) {
                    _this.nodeSelectAction(li, e, observedArgs, multiSelect);
                }
            });
        }
        else {
            this.nodeSelectAction(li, e, eventArgs, multiSelect);
        }
    };
    TreeView.prototype.nodeSelectAction = function (li, e, eventArgs, multiSelect) {
        if (!this.allowMultiSelection || (!multiSelect && (!e || (e && !e.ctrlKey)))) {
            this.removeSelectAll();
        }
        if (this.allowMultiSelection && e && e.shiftKey) {
            if (!this.startNode) {
                this.startNode = li;
            }
            var startIndex = this.liList.indexOf(this.startNode);
            var endIndex = this.liList.indexOf(li);
            if (startIndex > endIndex) {
                var temp = startIndex;
                startIndex = endIndex;
                endIndex = temp;
            }
            for (var i = startIndex; i <= endIndex; i++) {
                var currNode = this.liList[i];
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(currNode) && !currNode.classList.contains('e-disable')) {
                    this.addSelect(currNode);
                }
            }
        }
        else {
            this.startNode = li;
            this.addSelect(li);
        }
        this.setFocusElement(li);
        if (this.isLoaded) {
            eventArgs.nodeData = this.getNodeData(li);
            this.trigger('nodeSelected', eventArgs);
        }
    };
    TreeView.prototype.unselectNode = function (li, e) {
        var _this = this;
        var eventArgs;
        if (this.isLoaded) {
            eventArgs = this.getSelectEvent(li, 'un-select', e);
            this.trigger('nodeSelecting', eventArgs, function (observedArgs) {
                if (!observedArgs.cancel) {
                    _this.nodeUnselectAction(li, observedArgs);
                }
            });
        }
        else {
            this.nodeUnselectAction(li, eventArgs);
        }
    };
    TreeView.prototype.nodeUnselectAction = function (li, eventArgs) {
        this.removeSelect(li);
        this.setFocusElement(li);
        if (this.isLoaded) {
            eventArgs.nodeData = this.getNodeData(li);
            this.trigger('nodeSelected', eventArgs);
        }
    };
    TreeView.prototype.setFocusElement = function (li) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li)) {
            var focusedNode = this.getFocusedNode();
            if (focusedNode) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([focusedNode], FOCUS);
            }
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([li], FOCUS);
            this.updateIdAttr(focusedNode, li);
        }
    };
    TreeView.prototype.addSelect = function (liEle) {
        liEle.setAttribute('aria-selected', 'true');
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([liEle], ACTIVE);
        var id = liEle.getAttribute('data-uid');
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(id) && this.selectedNodes.indexOf(id) === -1) {
            this.selectedNodes.push(id);
        }
    };
    TreeView.prototype.removeSelect = function (liEle) {
        if (this.allowMultiSelection) {
            liEle.setAttribute('aria-selected', 'false');
        }
        else {
            liEle.removeAttribute('aria-selected');
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([liEle], ACTIVE);
        var index = this.selectedNodes.indexOf(liEle.getAttribute('data-uid'));
        if (index > -1) {
            this.selectedNodes.splice(index, 1);
        }
    };
    TreeView.prototype.removeSelectAll = function () {
        var selectedLI = this.element.querySelectorAll('.' + ACTIVE);
        for (var _i = 0, selectedLI_1 = selectedLI; _i < selectedLI_1.length; _i++) {
            var ele = selectedLI_1[_i];
            if (this.allowMultiSelection) {
                ele.setAttribute('aria-selected', 'false');
            }
            else {
                ele.removeAttribute('aria-selected');
            }
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])(selectedLI, ACTIVE);
        this.setProperties({ selectedNodes: [] }, true);
    };
    TreeView.prototype.getSelectEvent = function (currLi, action, e) {
        var nodeData = this.getNodeData(currLi);
        return { action: action, cancel: false, isInteracted: Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e) ? false : true, node: currLi, nodeData: nodeData };
    };
    TreeView.prototype.setExpandOnType = function () {
        this.expandOnType = (this.expandOn === 'Auto') ? (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice ? 'Click' : 'DblClick') : this.expandOn;
    };
    TreeView.prototype.expandHandler = function (e) {
        var target = e.originalEvent.target;
        if (!target || target.classList.contains(INPUT) || target.classList.contains(ROOT) ||
            target.classList.contains(PARENTITEM) || target.classList.contains(LISTITEM) ||
            target.classList.contains(ICON) || this.showCheckBox && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(target, '.' + CHECKBOXWRAP)) {
            return;
        }
        else {
            this.expandCollapseAction(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(target, '.' + LISTITEM), e);
        }
    };
    TreeView.prototype.expandCollapseAction = function (currLi, e) {
        var icon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('div.' + ICON, currLi);
        if (!icon || icon.classList.contains(PROCESS)) {
            return;
        }
        else {
            var classList = icon.classList;
            if (classList.contains(EXPANDABLE)) {
                this.expandAction(currLi, icon, e);
            }
            else if (classList.contains(COLLAPSIBLE)) {
                this.collapseNode(currLi, icon, e);
            }
        }
    };
    TreeView.prototype.expandAction = function (currLi, icon, e, expandChild, callback) {
        var _this = this;
        if (icon.classList.contains(PROCESS)) {
            return;
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([icon], PROCESS);
        }
        if (this.isLoaded && !this.isRefreshed) {
            this.expandArgs = this.getExpandEvent(currLi, e);
            this.trigger('nodeExpanding', this.expandArgs, function (observedArgs) {
                if (observedArgs.cancel) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([icon], PROCESS);
                }
                else {
                    _this.nodeExpandAction(currLi, icon, expandChild, callback);
                }
            });
        }
        else {
            this.nodeExpandAction(currLi, icon, expandChild, callback);
        }
    };
    TreeView.prototype.nodeExpandAction = function (currLi, icon, expandChild, callback) {
        var ul = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, currLi);
        if (ul && ul.nodeName === 'UL') {
            this.expandNode(currLi, icon);
        }
        else {
            this.isFirstRender = true;
            this.renderChildNodes(currLi, expandChild, callback);
            var liEles = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + LISTITEM, currLi);
            for (var i = 0; i < liEles.length; i++) {
                var id = this.getId(liEles[i]);
                if (this.expandChildren.indexOf(id) !== -1 && this.expandChildren !== undefined) {
                    var icon_1 = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + EXPANDABLE, Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + TEXTWRAP, liEles[i]));
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(icon_1)) {
                        this.expandAction(liEles[i], icon_1, null);
                    }
                    this.expandChildren.splice(this.expandChildren.indexOf(id), 1);
                }
            }
        }
    };
    TreeView.prototype.keyActionHandler = function (e) {
        var _this = this;
        var target = e.target;
        var focusedNode = this.getFocusedNode();
        if (target && target.classList.contains(INPUT)) {
            var inpEle = target;
            if (e.action === 'enter') {
                inpEle.blur();
                this.element.focus();
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([focusedNode], HOVER);
            }
            else if (e.action === 'escape') {
                inpEle.value = this.oldText;
                inpEle.blur();
                this.element.focus();
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([focusedNode], HOVER);
            }
            return;
        }
        e.preventDefault();
        var eventArgs = {
            cancel: false,
            event: e,
            node: focusedNode,
        };
        this.trigger('keyPress', eventArgs, function (observedArgs) {
            if (!observedArgs.cancel) {
                switch (e.action) {
                    case 'space':
                        if (_this.showCheckBox) {
                            _this.checkNode(e);
                        }
                        break;
                    case 'moveRight':
                        _this.openNode(_this.enableRtl ? false : true, e);
                        break;
                    case 'moveLeft':
                        _this.openNode(_this.enableRtl ? true : false, e);
                        break;
                    case 'shiftDown':
                        _this.shiftKeySelect(true, e);
                        break;
                    case 'moveDown':
                    case 'ctrlDown':
                    case 'csDown':
                        _this.navigateNode(true);
                        break;
                    case 'shiftUp':
                        _this.shiftKeySelect(false, e);
                        break;
                    case 'moveUp':
                    case 'ctrlUp':
                    case 'csUp':
                        _this.navigateNode(false);
                        break;
                    case 'home':
                    case 'shiftHome':
                    case 'ctrlHome':
                    case 'csHome':
                        _this.navigateRootNode(true);
                        break;
                    case 'end':
                    case 'shiftEnd':
                    case 'ctrlEnd':
                    case 'csEnd':
                        _this.navigateRootNode(false);
                        break;
                    case 'enter':
                    case 'ctrlEnter':
                    case 'shiftEnter':
                    case 'csEnter':
                        _this.toggleSelect(focusedNode, e);
                        break;
                    case 'f2':
                        if (_this.allowEditing && !focusedNode.classList.contains('e-disable')) {
                            _this.createTextbox(focusedNode, e);
                        }
                        break;
                    case 'ctrlA':
                        if (_this.allowMultiSelection) {
                            var sNodes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + LISTITEM + ':not(.' + ACTIVE + ')', _this.element);
                            _this.selectGivenNodes(sNodes);
                        }
                        break;
                }
            }
        });
    };
    TreeView.prototype.navigateToFocus = function (isUp) {
        var focusNode = this.getFocusedNode().querySelector('.' + TEXTWRAP);
        var pos = focusNode.getBoundingClientRect();
        var parent = this.getScrollParent(this.element);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(parent)) {
            var parentPos = parent.getBoundingClientRect();
            if (pos.bottom > parentPos.bottom) {
                parent.scrollTop += pos.bottom - parentPos.bottom;
            }
            else if (pos.top < parentPos.top) {
                parent.scrollTop -= parentPos.top - pos.top;
            }
        }
        var isVisible = this.isVisibleInViewport(focusNode);
        if (!isVisible) {
            focusNode.scrollIntoView(isUp);
        }
    };
    TreeView.prototype.isVisibleInViewport = function (txtWrap) {
        var pos = txtWrap.getBoundingClientRect();
        return (pos.top >= 0 && pos.left >= 0 && pos.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            pos.right <= (window.innerWidth || document.documentElement.clientWidth));
    };
    TreeView.prototype.getScrollParent = function (node) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(node)) {
            return null;
        }
        return (node.scrollHeight > node.clientHeight) ? node : this.getScrollParent(node.parentElement);
    };
    TreeView.prototype.shiftKeySelect = function (isTowards, e) {
        if (this.allowMultiSelection) {
            var focusedNode = this.getFocusedNode();
            var nextNode = isTowards ? this.getNextNode(focusedNode) : this.getPrevNode(focusedNode);
            this.removeHover();
            this.setFocusElement(nextNode);
            this.toggleSelect(nextNode, e, false);
            this.navigateToFocus(!isTowards);
        }
        else {
            this.navigateNode(isTowards);
        }
    };
    TreeView.prototype.checkNode = function (e) {
        var focusedNode = this.getFocusedNode();
        var checkWrap = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CHECKBOXWRAP, focusedNode);
        var isChecked = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])(' .' + CHECKBOXFRAME, checkWrap).classList.contains(CHECK);
        if (!focusedNode.classList.contains('e-disable')) {
            if (focusedNode.getElementsByClassName("e-checkbox-disabled").length == 0) {
                this.validateCheckNode(checkWrap, isChecked, focusedNode, e);
            }
        }
    };
    TreeView.prototype.validateCheckNode = function (checkWrap, isCheck, li, e) {
        var _this = this;
        var currLi = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(checkWrap, '.' + LISTITEM);
        this.checkActionNodes = [];
        var ariaState = !isCheck ? 'true' : 'false';
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ariaState)) {
            checkWrap.setAttribute('aria-checked', ariaState);
        }
        var eventArgs = this.getCheckEvent(currLi, isCheck ? 'uncheck' : 'check', e);
        this.trigger('nodeChecking', eventArgs, function (observedArgs) {
            if (!observedArgs.cancel) {
                _this.nodeCheckingAction(checkWrap, isCheck, li, observedArgs, e);
            }
        });
    };
    TreeView.prototype.nodeCheckingAction = function (checkWrap, isCheck, li, eventArgs, e) {
        if (this.checkedElement.indexOf(li.getAttribute('data-uid')) === -1) {
            this.checkedElement.push(li.getAttribute('data-uid'));
            if (this.autoCheck) {
                var child = this.getChildNodes(this.treeData, li.getAttribute('data-uid'));
                (child !== null) ? this.allCheckNode(child, this.checkedElement, null, null, false) : child = null;
            }
        }
        this.changeState(checkWrap, isCheck ? 'uncheck' : 'check', e, true);
        if (this.autoCheck) {
            this.ensureChildCheckState(li);
            this.ensureParentCheckState(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(li, '.' + PARENTITEM), '.' + LISTITEM));
            var doCheck = void 0;
            if (eventArgs.action === 'check') {
                doCheck = true;
            }
            else if (eventArgs.action === 'uncheck') {
                doCheck = false;
            }
            this.ensureStateChange(li, doCheck);
        }
        this.nodeCheckedEvent(checkWrap, isCheck, e);
    };
    /**
     * Update checkedNodes when UI interaction happens before the child node renders in DOM
     */
    TreeView.prototype.ensureStateChange = function (li, doCheck) {
        var childElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, li);
        var parentIndex = li.getAttribute('data-uid');
        var mapper = this.fields;
        if (this.dataType === 1 && this.autoCheck) {
            var resultData = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */](this.treeData).executeLocal(new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["b" /* Query */]().where(mapper.parentID, 'equal', parentIndex, true));
            for (var i = 0; i < resultData.length; i++) {
                var resultId = resultData[i][this.fields.id] ? resultData[i][this.fields.id].toString() : null;
                var isCheck = resultData[i][this.fields.isChecked] ? resultData[i][this.fields.isChecked].toString() : null;
                if (this.checkedNodes.indexOf(parentIndex) !== -1 && this.checkedNodes.indexOf(resultId) === -1) {
                    this.checkedNodes.push(resultId);
                    var childItems = this.getChildNodes(this.treeData, resultId);
                    this.getChildItems(childItems, doCheck);
                    if (this.parentNodeCheck.indexOf(resultId) !== -1) {
                        this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(resultId), 1);
                    }
                }
                else if (this.checkedNodes.indexOf(parentIndex) === -1 && childElement === null &&
                    this.checkedNodes.indexOf(resultId) !== -1) {
                    this.checkedNodes.splice(this.checkedNodes.indexOf(resultId), 1);
                    if (isCheck === 'true') {
                        this.updateField(this.treeData, this.fields, resultId, 'isChecked', null);
                    }
                    if (this.checkedNodes.indexOf(parentIndex) === -1 && childElement === null ||
                        this.parentNodeCheck.indexOf(resultId) !== -1) {
                        var childNodes = this.getChildNodes(this.treeData, resultId);
                        this.getChildItems(childNodes, doCheck);
                        if (this.parentNodeCheck.indexOf(resultId) !== -1) {
                            this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(resultId), 1);
                        }
                    }
                }
                else {
                    var childItems = this.getChildNodes(this.treeData, resultId);
                    this.getChildItems(childItems, doCheck);
                }
            }
        }
        else if (this.dataType === 1 && !this.autoCheck) {
            if (!doCheck) {
                var checkedData = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */](this.treeData).executeLocal(new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["b" /* Query */]().where(mapper.isChecked, 'equal', true, false));
                for (var i = 0; i < checkedData.length; i++) {
                    var id = checkedData[i][this.fields.id] ? checkedData[i][this.fields.id].toString() : null;
                    if (this.checkedNodes.indexOf(id) !== -1) {
                        this.checkedNodes.splice(this.checkedNodes.indexOf(id), 1);
                    }
                    this.updateField(this.treeData, this.fields, id, 'isChecked', null);
                }
                this.checkedNodes = [];
            }
            else {
                for (var i = 0; i < this.treeData.length; i++) {
                    var checkedId = this.treeData[i][this.fields.id] ? this.treeData[i][this.fields.id].toString() : null;
                    if (this.checkedNodes.indexOf(checkedId) === -1) {
                        this.checkedNodes.push(checkedId);
                    }
                }
            }
        }
        else {
            var childItems = this.getChildNodes(this.treeData, parentIndex);
            if (childItems) {
                this.childStateChange(childItems, parentIndex, childElement, doCheck);
            }
        }
    };
    TreeView.prototype.getChildItems = function (childItems, doCheck) {
        for (var i = 0; i < childItems.length; i++) {
            var childId = childItems[i][this.fields.id] ? childItems[i][this.fields.id].toString() : null;
            var childIsCheck = childItems[i][this.fields.isChecked] ? childItems[i][this.fields.isChecked].toString() :
                null;
            if (this.checkedNodes.indexOf(childId) !== -1 && !doCheck) {
                this.checkedNodes.splice(this.checkedNodes.indexOf(childId), 1);
            }
            if (this.checkedNodes.indexOf(childId) === -1 && doCheck) {
                this.checkedNodes.push(childId);
            }
            if (childIsCheck === 'true' && !doCheck) {
                this.updateField(this.treeData, this.fields, childId, 'isChecked', null);
            }
            var subChildItems = this.getChildNodes(this.treeData, childId);
            if (subChildItems.length > 0) {
                this.getChildItems(subChildItems, doCheck);
            }
        }
    };
    /**
     * Update checkedNodes when UI interaction happens before the child node renders in DOM for hierarchical DS
     */
    TreeView.prototype.childStateChange = function (childItems, parent, childElement, doCheck) {
        for (var i = 0; i < childItems.length; i++) {
            var checkedChild = childItems[i][this.fields.id] ? childItems[i][this.fields.id].toString() : '';
            var isCheck = childItems[i][this.fields.isChecked] ? childItems[i][this.fields.isChecked].toString() : null;
            if (this.autoCheck) {
                if (this.checkedNodes.indexOf(parent) !== -1 && this.checkedNodes.indexOf(checkedChild) === -1) {
                    this.checkedNodes.push(checkedChild);
                    if (this.parentNodeCheck.indexOf(checkedChild) !== -1) {
                        this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(checkedChild), 1);
                    }
                }
                else if (this.checkedNodes.indexOf(parent) === -1 && this.checkedNodes.indexOf(checkedChild) !== -1 && !doCheck) {
                    this.checkedNodes.splice(this.checkedNodes.indexOf(checkedChild), 1);
                    if (isCheck === 'true') {
                        this.updateField(this.treeData, this.fields, checkedChild, 'isChecked', null);
                    }
                }
            }
            else if (!this.autoCheck) {
                if (!doCheck) {
                    if (this.checkedNodes.indexOf(checkedChild) !== -1) {
                        this.checkedNodes.splice(this.checkedNodes.indexOf(checkedChild), 1);
                    }
                    this.updateField(this.treeData, this.fields, checkedChild, 'isChecked', null);
                    this.checkedNodes = [];
                }
                else {
                    if (this.checkedNodes.indexOf(checkedChild) === -1) {
                        this.checkedNodes.push(checkedChild);
                    }
                }
            }
            var subChild = this.getChildNodes([childItems[i]], checkedChild);
            if (subChild) {
                this.childStateChange(subChild, parent, childElement, doCheck);
            }
        }
    };
    //This method can be used to get all child nodes of a parent by passing the children of a parent along with 'validateCheck' set to false
    TreeView.prototype.allCheckNode = function (child, newCheck, checked, childCheck, validateCheck) {
        if (child) {
            for (var length_1 = 0; length_1 < child.length; length_1++) {
                var childId = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.id, child[length_1]);
                var check = this.element.querySelector('[data-uid="' + childId + '"]');
                //Validates isChecked case while no UI interaction has been performed on the node or it's parent
                if (validateCheck !== false && this.checkedElement.indexOf(childId.toString()) === -1) {
                    if (((check === null && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(child[length_1][this.fields.isChecked]) && newCheck.indexOf(childId.toString()) === -1)
                        || childCheck === 0 || checked === 2)) {
                        (child[length_1][this.fields.isChecked] !== false || checked === 2) ? newCheck.push(childId.toString())
                            : childCheck = null;
                        childCheck = (child[length_1][this.fields.isChecked] !== false || checked === 2) ? 0 : null;
                    }
                }
                //Pushes child checked node done thro' UI interaction
                if (newCheck.indexOf(childId.toString()) === -1 && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(checked)) {
                    newCheck.push(childId.toString());
                }
                var hierChildId = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.child.toString(), child[length_1]);
                //Gets if any next level children are available for child nodes
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.hasChildren, child[length_1]) === true || hierChildId) {
                    var id = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.id, child[length_1]);
                    var childId_1 = void 0;
                    if (this.dataType === 1) {
                        childId_1 = this.getChildNodes(this.treeData, id.toString());
                    }
                    else {
                        childId_1 = hierChildId;
                    }
                    if (childId_1) {
                        (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(validateCheck)) ? this.allCheckNode(childId_1, newCheck, checked, childCheck) :
                            this.allCheckNode(childId_1, newCheck, checked, childCheck, validateCheck);
                        childCheck = null;
                    }
                }
                childCheck = null;
            }
        }
    };
    TreeView.prototype.openNode = function (toBeOpened, e) {
        var focusedNode = this.getFocusedNode();
        var icon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('div.' + ICON, focusedNode);
        if (toBeOpened) {
            if (!icon) {
                return;
            }
            else if (icon.classList.contains(EXPANDABLE)) {
                this.expandAction(focusedNode, icon, e);
            }
            else {
                this.focusNextNode(focusedNode, true);
            }
        }
        else {
            if (icon && icon.classList.contains(COLLAPSIBLE)) {
                this.collapseNode(focusedNode, icon, e);
            }
            else {
                var parentLi = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(focusedNode, '.' + PARENTITEM), '.' + LISTITEM);
                if (!parentLi) {
                    return;
                }
                else {
                    if (!parentLi.classList.contains('e-disable')) {
                        this.setFocus(focusedNode, parentLi);
                        this.navigateToFocus(true);
                    }
                }
            }
        }
    };
    TreeView.prototype.navigateNode = function (isTowards) {
        var focusedNode = this.getFocusedNode();
        this.focusNextNode(focusedNode, isTowards);
    };
    TreeView.prototype.navigateRootNode = function (isBackwards) {
        var focusedNode = this.getFocusedNode();
        var rootNode = isBackwards ? this.getRootNode() : this.getEndNode();
        if (!rootNode.classList.contains('e-disable')) {
            this.setFocus(focusedNode, rootNode);
            this.navigateToFocus(isBackwards);
        }
    };
    TreeView.prototype.getFocusedNode = function () {
        var selectedItem;
        var fNode = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + LISTITEM + '.' + FOCUS, this.element);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fNode)) {
            selectedItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + LISTITEM, this.element);
        }
        return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fNode) ? (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(selectedItem) ? this.element.firstElementChild : selectedItem) : fNode;
    };
    TreeView.prototype.focusNextNode = function (li, isTowards) {
        var nextNode = isTowards ? this.getNextNode(li) : this.getPrevNode(li);
        this.setFocus(li, nextNode);
        this.navigateToFocus(!isTowards);
        if (nextNode.classList.contains('e-disable')) {
            var lastChild = nextNode.lastChild;
            if (nextNode.previousSibling == null && nextNode.classList.contains('e-level-1')) {
                this.focusNextNode(nextNode, true);
            }
            else if (nextNode.nextSibling == null && nextNode.classList.contains('e-node-collapsed')) {
                this.focusNextNode(nextNode, false);
            }
            else if (nextNode.nextSibling == null && lastChild.classList.contains(TEXTWRAP)) {
                this.focusNextNode(nextNode, false);
            }
            else {
                this.focusNextNode(nextNode, isTowards);
            }
        }
    };
    TreeView.prototype.getNextNode = function (li) {
        var index = this.liList.indexOf(li);
        var nextNode;
        do {
            index++;
            nextNode = this.liList[index];
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(nextNode)) {
                return li;
            }
        } while (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(nextNode));
        return nextNode;
    };
    TreeView.prototype.getPrevNode = function (li) {
        var index = this.liList.indexOf(li);
        var prevNode;
        do {
            index--;
            prevNode = this.liList[index];
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(prevNode)) {
                return li;
            }
        } while (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(prevNode));
        return prevNode;
    };
    TreeView.prototype.getRootNode = function () {
        var index = 0;
        var rootNode;
        do {
            rootNode = this.liList[index];
            index++;
        } while (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(rootNode));
        return rootNode;
    };
    TreeView.prototype.getEndNode = function () {
        var index = this.liList.length - 1;
        var endNode;
        do {
            endNode = this.liList[index];
            index--;
        } while (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(endNode));
        return endNode;
    };
    TreeView.prototype.setFocus = function (preNode, nextNode) {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([preNode], [HOVER, FOCUS]);
        if (!nextNode.classList.contains('e-disable')) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([nextNode], [HOVER, FOCUS]);
            this.updateIdAttr(preNode, nextNode);
        }
    };
    TreeView.prototype.updateIdAttr = function (preNode, nextNode) {
        this.element.removeAttribute('aria-activedescendant');
        if (preNode) {
            preNode.removeAttribute('id');
        }
        nextNode.setAttribute('id', this.element.id + '_active');
        this.element.setAttribute('aria-activedescendant', this.element.id + '_active');
    };
    TreeView.prototype.focusIn = function () {
        if (!this.mouseDownStatus) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.getFocusedNode()], HOVER);
        }
        this.mouseDownStatus = false;
    };
    TreeView.prototype.focusOut = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.getFocusedNode()], HOVER);
    };
    TreeView.prototype.onMouseOver = function (e) {
        var target = e.target;
        var classList = target.classList;
        var currentLi = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(target, '.' + LISTITEM);
        if (!currentLi || classList.contains(PARENTITEM) || classList.contains(LISTITEM)) {
            this.removeHover();
            return;
        }
        else {
            if (currentLi && !currentLi.classList.contains('e-disable')) {
                this.setHover(currentLi);
            }
        }
    };
    TreeView.prototype.setHover = function (li) {
        if (!li.classList.contains(HOVER)) {
            this.removeHover();
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([li], HOVER);
        }
    };
    ;
    TreeView.prototype.onMouseLeave = function (e) {
        this.removeHover();
    };
    TreeView.prototype.removeHover = function () {
        var hoveredNode = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + HOVER, this.element);
        if (hoveredNode && hoveredNode.length) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])(hoveredNode, HOVER);
        }
    };
    ;
    TreeView.prototype.getNodeData = function (currLi, fromDS) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(currLi) && currLi.classList.contains(LISTITEM) &&
            !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(currLi, '.' + CONTROL)) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(currLi, '.' + CONTROL).classList.contains(ROOT)) {
            var id = currLi.getAttribute('data-uid');
            var text = this.getText(currLi, fromDS);
            var pNode = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(currLi.parentNode, '.' + LISTITEM);
            var pid = pNode ? pNode.getAttribute('data-uid') : null;
            var selected = currLi.classList.contains(ACTIVE);
            var expanded = (currLi.getAttribute('aria-expanded') === 'true') ? true : false;
            var hasChildren = currLi.getAttribute('aria-expanded') !== null ? true : (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + EXPANDABLE, currLi) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + COLLAPSIBLE, currLi)) != null ? true : false;
            var checked = null;
            if (this.showCheckBox) {
                checked = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CHECKBOXWRAP, currLi).getAttribute('aria-checked');
            }
            return {
                id: id, text: text, parentID: pid, selected: selected, expanded: expanded,
                isChecked: checked, hasChildren: hasChildren
            };
        }
        return { id: '', text: '', parentID: '', selected: false, expanded: false, isChecked: '', hasChildren: false };
    };
    TreeView.prototype.getText = function (currLi, fromDS) {
        if (fromDS) {
            var nodeData = this.getNodeObject(currLi.getAttribute('data-uid'));
            var level = parseFloat(currLi.getAttribute('aria-level'));
            var nodeFields = this.getFields(this.fields, level, 1);
            return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(nodeFields.text, nodeData);
        }
        return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + LISTTEXT, currLi).textContent;
    };
    TreeView.prototype.getExpandEvent = function (currLi, e) {
        var nodeData = this.getNodeData(currLi);
        return { cancel: false, isInteracted: Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e) ? false : true, node: currLi, nodeData: nodeData, event: e };
    };
    TreeView.prototype.renderNodeTemplate = function (data, textEle, dataId) {
        var tempArr = this.nodeTemplateFn(data, this, 'nodeTemplate' + dataId, this.element.id + 'nodeTemplate', this.isStringTemplate, undefined, textEle, this.root);
        if (tempArr) {
            tempArr = Array.prototype.slice.call(tempArr);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(tempArr, textEle);
        }
    };
    TreeView.prototype.destroyTemplate = function (liEle) {
        this.clearTemplate(['nodeTemplate' + liEle.getAttribute('data-uid')]);
    };
    TreeView.prototype.reRenderNodes = function () {
        this.updateListProp(this.fields);
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isIE) {
            this.ulElement = this.element.querySelector('.e-list-parent.e-ul');
            this.ulElement.parentElement.removeChild(this.ulElement);
        }
        else {
            this.element.innerHTML = '';
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.nodeTemplateFn)) {
            this.clearTemplate();
        }
        this.setTouchClass();
        this.setProperties({ selectedNodes: [], checkedNodes: [], expandedNodes: [] }, true);
        this.checkedElement = [];
        this.isLoaded = false;
        this.setDataBinding(true);
    };
    TreeView.prototype.setCssClass = function (oldClass, newClass) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(oldClass) && oldClass !== '') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], oldClass.split(' '));
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(newClass) && newClass !== '') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], newClass.split(' '));
        }
    };
    TreeView.prototype.editingHandler = function (e) {
        var target = e.target;
        if (!target || target.classList.contains(ROOT) || target.classList.contains(PARENTITEM) ||
            target.classList.contains(LISTITEM) || target.classList.contains(ICON) ||
            target.classList.contains(INPUT) || target.classList.contains(INPUTGROUP)) {
            return;
        }
        else {
            var liEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(target, '.' + LISTITEM);
            this.createTextbox(liEle, e);
        }
    };
    TreeView.prototype.createTextbox = function (liEle, e) {
        var _this = this;
        var oldInpEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + TREEINPUT, this.element);
        if (oldInpEle) {
            oldInpEle.blur();
        }
        var textEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + LISTTEXT, liEle);
        this.updateOldText(liEle);
        var innerEle = this.createElement('input', { className: TREEINPUT, attrs: { value: this.oldText } });
        var eventArgs = this.getEditEvent(liEle, null, innerEle.outerHTML);
        this.trigger('nodeEditing', eventArgs, function (observedArgs) {
            if (!observedArgs.cancel) {
                var inpWidth = textEle.offsetWidth + 5;
                var style = 'width:' + inpWidth + 'px';
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([liEle], EDITING);
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(_this.nodeTemplateFn)) {
                    _this.destroyTemplate(liEle);
                }
                textEle.innerHTML = eventArgs.innerHtml;
                var inpEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + TREEINPUT, textEle);
                _this.inputObj = __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_inputs__["a" /* Input */].createInput({
                    element: inpEle,
                    properties: {
                        enableRtl: _this.enableRtl,
                    }
                }, _this.createElement);
                _this.inputObj.container.setAttribute('style', style);
                inpEle.focus();
                var inputEle = inpEle;
                inputEle.setSelectionRange(0, inputEle.value.length);
                _this.wireInputEvents(inpEle);
            }
        });
    };
    TreeView.prototype.updateOldText = function (liEle) {
        var id = liEle.getAttribute('data-uid');
        this.editData = this.getNodeObject(id);
        var level = parseFloat(liEle.getAttribute('aria-level'));
        this.editFields = this.getFields(this.fields, level, 1);
        this.oldText = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.editFields.text, this.editData);
    };
    TreeView.prototype.inputFocusOut = function (e) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + TREEINPUT, this.element)) {
            return;
        }
        var target = e.target;
        var newText = target.value;
        var txtEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(target, '.' + LISTTEXT);
        var liEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(target, '.' + LISTITEM);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.inputObj.container);
        if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] && !this.isOffline) {
            this.crudOperation('update', null, liEle, newText, null, null, true);
        }
        else {
            this.appendNewText(liEle, txtEle, newText, true);
        }
    };
    TreeView.prototype.appendNewText = function (liEle, txtEle, newText, isInput) {
        var _this = this;
        var eventArgs = this.getEditEvent(liEle, newText, null);
        this.trigger('nodeEdited', eventArgs, function (observedArgs) {
            newText = observedArgs.cancel ? observedArgs.oldText : observedArgs.newText;
            _this.updateText(liEle, txtEle, newText, isInput);
            if (observedArgs.oldText !== newText) {
                _this.triggerEvent();
            }
        });
    };
    TreeView.prototype.updateText = function (liEle, txtEle, newText, isInput) {
        var newData = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])(this.editFields.text, newText, this.editData);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.nodeTemplateFn)) {
            txtEle.innerText = '';
            var dataId = liEle.getAttribute('data-uid');
            this.renderNodeTemplate(newData, txtEle, dataId);
            this.renderReactTemplates();
        }
        else {
            txtEle.innerText = newText;
        }
        if (isInput) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([liEle], EDITING);
            txtEle.focus();
        }
        if (this.allowTextWrap) {
            this.calculateWrap(liEle);
        }
    };
    TreeView.prototype.getElement = function (ele) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ele)) {
            return null;
        }
        else if (typeof ele === 'string') {
            return this.element.querySelector('[data-uid="' + ele + '"]');
        }
        else if (typeof ele === 'object') {
            return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["I" /* getElement */])(ele);
        }
        else {
            return null;
        }
    };
    TreeView.prototype.getId = function (ele) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ele)) {
            return null;
        }
        else if (typeof ele === 'string') {
            return ele;
        }
        else if (typeof ele === 'object') {
            return (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["I" /* getElement */])(ele)).getAttribute('data-uid');
        }
        else {
            return null;
        }
    };
    TreeView.prototype.getEditEvent = function (liEle, newText, inpEle) {
        var data = this.getNodeData(liEle);
        return { cancel: false, newText: newText, node: liEle, nodeData: data, oldText: this.oldText, innerHtml: inpEle };
    };
    TreeView.prototype.getNodeObject = function (id) {
        var childNodes;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(id)) {
            return childNodes;
        }
        else if (this.dataType === 1) {
            for (var i = 0, objlen = this.treeData.length; i < objlen; i++) {
                var dataId = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.id, this.treeData[i]);
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.treeData[i]) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dataId) && dataId.toString() === id) {
                    return this.treeData[i];
                }
            }
        }
        else {
            return this.getChildNodeObject(this.treeData, this.fields, id);
        }
        return childNodes;
    };
    TreeView.prototype.getChildNodeObject = function (obj, mapper, id) {
        var newList;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(obj)) {
            return newList;
        }
        for (var i = 0, objlen = obj.length; i < objlen; i++) {
            var dataId = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.id, obj[i]);
            if (obj[i] && dataId && dataId.toString() === id) {
                return obj[i];
            }
            else if (typeof mapper.child === 'string' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.child, obj[i]))) {
                var childData = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.child, obj[i]);
                newList = this.getChildNodeObject(childData, this.getChildMapper(mapper), id);
                if (newList !== undefined) {
                    break;
                }
            }
            else if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('child', obj[i]))) {
                var child = 'child';
                newList = this.getChildNodeObject(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(child, obj[i]), this.getChildMapper(mapper), id);
                if (newList !== undefined) {
                    break;
                }
            }
        }
        return newList;
    };
    TreeView.prototype.setDragAndDrop = function (toBind) {
        if (toBind && !this.disabled) {
            this.initializeDrag();
        }
        else {
            this.destroyDrag();
        }
    };
    TreeView.prototype.initializeDrag = function () {
        var _this = this;
        var virtualEle;
        var proxy = this;
        this.dragObj = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["i" /* Draggable */](this.element, {
            enableTailMode: true, enableAutoScroll: true,
            dragArea: this.dragArea,
            dragTarget: '.' + TEXTWRAP,
            helper: function (e) {
                _this.dragTarget = e.sender.target;
                var dragRoot = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(_this.dragTarget, '.' + ROOT);
                var dragWrap = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(_this.dragTarget, '.' + TEXTWRAP);
                _this.dragLi = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(_this.dragTarget, '.' + LISTITEM);
                if (_this.fullRowSelect && !dragWrap && _this.dragTarget.classList.contains(FULLROW)) {
                    dragWrap = _this.dragTarget.nextElementSibling;
                }
                if (!_this.dragTarget || !e.element.isSameNode(dragRoot) || !dragWrap ||
                    _this.dragTarget.classList.contains(ROOT) || _this.dragTarget.classList.contains(PARENTITEM) ||
                    _this.dragTarget.classList.contains(LISTITEM) || _this.dragLi.classList.contains('e-disable')) {
                    return false;
                }
                var cloneEle = (dragWrap.cloneNode(true));
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('div.' + ICON, cloneEle))) {
                    var icon = proxy.createElement('div', { className: ICON + ' ' + EXPANDABLE });
                    cloneEle.insertBefore(icon, cloneEle.children[0]);
                }
                var cssClass = DRAGITEM + ' ' + ROOT + ' ' + _this.cssClass + ' ' + (_this.enableRtl ? RTL : '');
                virtualEle = proxy.createElement('div', { className: cssClass });
                virtualEle.appendChild(cloneEle);
                var nLen = _this.selectedNodes.length;
                if (nLen > 1 && _this.allowMultiSelection && _this.dragLi.classList.contains(ACTIVE)) {
                    var cNode = proxy.createElement('span', { className: DROPCOUNT, innerHTML: '' + nLen });
                    virtualEle.appendChild(cNode);
                }
                document.body.appendChild(virtualEle);
                document.body.style.cursor = '';
                _this.dragData = _this.getNodeData(_this.dragLi);
                return virtualEle;
            },
            dragStart: function (e) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([_this.element], DRAGGING);
                var listItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.e-list-item');
                var level;
                if (listItem) {
                    level = parseInt(listItem.getAttribute('aria-level'), 10);
                }
                var eventArgs = _this.getDragEvent(e.event, _this, null, e.target, null, virtualEle, level);
                if (eventArgs.draggedNode.classList.contains(EDITING)) {
                    _this.dragObj.intDestroy(e.event);
                    _this.dragCancelAction(virtualEle);
                }
                else {
                    _this.trigger('nodeDragStart', eventArgs, function (observedArgs) {
                        if (observedArgs.cancel) {
                            _this.dragObj.intDestroy(e.event);
                            _this.dragCancelAction(virtualEle);
                        }
                        else {
                            _this.dragStartAction = true;
                        }
                    });
                }
            },
            drag: function (e) {
                _this.dragObj.setProperties({ cursorAt: { top: (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e.event.targetTouches) || __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) ? 60 : -20 } });
                _this.dragAction(e, virtualEle);
            },
            dragStop: function (e) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([_this.element], DRAGGING);
                _this.removeVirtualEle();
                var dropTarget = e.target;
                var preventTargetExpand = false;
                var dropRoot = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(dropTarget, '.' + DROPPABLE));
                var isHelperElement = true;
                if (!dropTarget || !dropRoot) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(e.helper);
                    document.body.style.cursor = '';
                    isHelperElement = false;
                }
                var listItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(dropTarget, '.e-list-item');
                var level;
                if (listItem) {
                    level = parseInt(listItem.getAttribute('aria-level'), 10);
                }
                var eventArgs = _this.getDragEvent(e.event, _this, dropTarget, dropTarget, null, e.helper, level);
                eventArgs.preventTargetExpand = preventTargetExpand;
                _this.trigger('nodeDragStop', eventArgs, function (observedArgs) {
                    _this.dragParent = observedArgs.draggedParentNode;
                    _this.preventExpand = observedArgs.preventTargetExpand;
                    if (observedArgs.cancel) {
                        if (e.helper.parentNode) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(e.helper);
                        }
                        document.body.style.cursor = '';
                        isHelperElement = false;
                    }
                    _this.dragStartAction = false;
                });
            }
        });
        this.dropObj = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["j" /* Droppable */](this.element, {
            out: function (e) {
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e) && !e.target.classList.contains(SIBLING)) {
                    document.body.style.cursor = 'not-allowed';
                }
            },
            over: function (e) {
                document.body.style.cursor = '';
            },
            drop: function (e) {
                _this.dropAction(e);
            }
        });
    };
    TreeView.prototype.dragCancelAction = function (virtualEle) {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(virtualEle);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], DRAGGING);
        this.dragStartAction = false;
    };
    TreeView.prototype.dragAction = function (e, virtualEle) {
        var dropRoot = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.' + DROPPABLE);
        var dropWrap = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.' + TEXTWRAP);
        var icon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('div.' + ICON, virtualEle);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([icon], [DROPIN, DROPNEXT, DROPOUT, NODROP]);
        this.removeVirtualEle();
        document.body.style.cursor = '';
        var classList = e.target.classList;
        if (this.fullRowSelect && !dropWrap && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(classList) && classList.contains(FULLROW)) {
            dropWrap = e.target.nextElementSibling;
        }
        if (dropRoot) {
            var dropLi = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.' + LISTITEM);
            var checkWrapper = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.' + CHECKBOXWRAP);
            var collapse = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.' + COLLAPSIBLE);
            var expand = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.' + EXPANDABLE);
            if (!dropRoot.classList.contains(ROOT) || (dropWrap &&
                (!dropLi.isSameNode(this.dragLi) && !this.isDescendant(this.dragLi, dropLi)))) {
                if (this.hasTemplate && dropLi) {
                    var templateTarget = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])(this.fullRowSelect ? '.' + FULLROW : '.' + TEXTWRAP, dropLi);
                    if ((e && (!expand && !collapse) && e.event.offsetY < 7 && !checkWrapper) || (((expand && e.event.offsetY < 5) || (collapse && e.event.offsetX < 3)))) {
                        var index = this.fullRowSelect ? (1) : (0);
                        this.appendIndicator(dropLi, icon, index);
                    }
                    else if ((e && (!expand && !collapse) && !checkWrapper && templateTarget && e.event.offsetY > templateTarget.offsetHeight - 10) || ((expand && e.event.offsetY > 19) || (collapse && e.event.offsetX > 19))) {
                        var index = this.fullRowSelect ? (2) : (1);
                        this.appendIndicator(dropLi, icon, index);
                    }
                    else {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([icon], DROPIN);
                    }
                }
                else {
                    if ((dropLi && e && (!expand && !collapse) && (e.event.offsetY < 7) && !checkWrapper) || (((expand && e.event.offsetY < 5) || (collapse && e.event.offsetX < 3)))) {
                        var index = this.fullRowSelect ? (1) : (0);
                        this.appendIndicator(dropLi, icon, index);
                    }
                    else if ((dropLi && e && (!expand && !collapse) && (e.target.offsetHeight > 0 && e.event.offsetY > (e.target.offsetHeight - 10)) && !checkWrapper) || (((expand && e.event.offsetY > 19) || (collapse && e.event.offsetX > 19)))) {
                        var index = this.fullRowSelect ? (2) : (1);
                        this.appendIndicator(dropLi, icon, index);
                    }
                    else {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([icon], DROPIN);
                    }
                }
            }
            else if (e.target.nodeName === 'LI' && (!dropLi.isSameNode(this.dragLi) && !this.isDescendant(this.dragLi, dropLi))) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([icon], DROPNEXT);
                this.renderVirtualEle(e);
            }
            else if (e.target.classList.contains(SIBLING)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([icon], DROPNEXT);
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([icon], DROPOUT);
            }
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([icon], NODROP);
            document.body.style.cursor = 'not-allowed';
        }
        var listItem = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.e-list-item');
        var level;
        if (listItem) {
            level = parseInt(listItem.getAttribute('aria-level'), 10);
        }
        var eventArgs = this.getDragEvent(e.event, this, e.target, e.target, null, virtualEle, level);
        if (eventArgs.dropIndicator) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([icon], eventArgs.dropIndicator);
        }
        this.trigger('nodeDragging', eventArgs);
        if (eventArgs.dropIndicator) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([icon], eventArgs.dropIndicator);
        }
    };
    TreeView.prototype.appendIndicator = function (dropLi, icon, index) {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([icon], DROPNEXT);
        var virEle = this.createElement('div', { className: SIBLING });
        dropLi.insertBefore(virEle, dropLi.children[index]);
    };
    /* eslint-disable */
    TreeView.prototype.dropAction = function (e) {
        var offsetY = e.event.offsetY;
        var dropTarget = e.target;
        var dragObj;
        var level;
        var drop = false;
        var dragInstance;
        dragInstance = e.dragData.draggable;
        for (var i = 0; i < dragInstance.ej2_instances.length; i++) {
            if (dragInstance.ej2_instances[i] instanceof TreeView_1) {
                dragObj = dragInstance.ej2_instances[i];
                break;
            }
        }
        if (dragObj && dragObj.dragTarget) {
            var dragTarget = dragObj.dragTarget;
            var dragLi = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(dragTarget, '.' + LISTITEM));
            var dropLi = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(dropTarget, '.' + LISTITEM));
            if (dropLi == null && dropTarget.classList.contains(ROOT)) {
                dropLi = dropTarget.firstElementChild;
            }
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(e.droppedElement);
            document.body.style.cursor = '';
            if (!dropLi || dropLi.isSameNode(dragLi) || this.isDescendant(dragLi, dropLi)) {
                if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] === false) {
                    this.preventExpand = false;
                }
                return;
            }
            if (dragObj.allowMultiSelection && dragLi.classList.contains(ACTIVE)) {
                var sNodes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + ACTIVE, dragObj.element);
                if (e.target.offsetHeight <= 33 && offsetY > e.target.offsetHeight - 10 && offsetY > 6) {
                    for (var i = sNodes.length - 1; i >= 0; i--) {
                        if (dropLi.isSameNode(sNodes[i]) || this.isDescendant(sNodes[i], dropLi)) {
                            continue;
                        }
                        this.appendNode(dropTarget, sNodes[i], dropLi, e, dragObj, offsetY);
                    }
                }
                else {
                    for (var i = 0; i < sNodes.length; i++) {
                        if (dropLi.isSameNode(sNodes[i]) || this.isDescendant(sNodes[i], dropLi)) {
                            continue;
                        }
                        this.appendNode(dropTarget, sNodes[i], dropLi, e, dragObj, offsetY);
                    }
                }
            }
            else {
                this.appendNode(dropTarget, dragLi, dropLi, e, dragObj, offsetY);
            }
            level = parseInt(dragLi.getAttribute('aria-level'), 10);
            drop = true;
        }
        if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] === false) {
            this.preventExpand = false;
        }
        this.trigger('nodeDropped', this.getDragEvent(e.event, dragObj, dropTarget, e.target, e.dragData.draggedElement, null, level, drop));
        if (dragObj.element.id !== this.element.id) {
            dragObj.triggerEvent();
        }
        this.triggerEvent();
    };
    TreeView.prototype.appendNode = function (dropTarget, dragLi, dropLi, e, dragObj, offsetY) {
        var checkWrapper = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(dropTarget, '.' + CHECKBOXWRAP);
        var collapse = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.' + COLLAPSIBLE);
        var expand = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.' + EXPANDABLE);
        if (!dragLi.classList.contains('e-disable') && !checkWrapper && ((expand && e.event.offsetY < 5) || (collapse && e.event.offsetX < 3) || (expand && e.event.offsetY > 19) || (collapse && e.event.offsetX > 19) || (!expand && !collapse))) {
            if (dropTarget.nodeName === 'LI') {
                this.dropAsSiblingNode(dragLi, dropLi, e, dragObj);
            }
            else if (dropTarget.firstElementChild && dropTarget.classList.contains(ROOT)) {
                if (dropTarget.firstElementChild.nodeName === 'UL') {
                    this.dropAsSiblingNode(dragLi, dropLi, e, dragObj);
                }
            }
            else if ((dropTarget.classList.contains('e-icon-collapsible')) || (dropTarget.classList.contains('e-icon-expandable'))) {
                this.dropAsSiblingNode(dragLi, dropLi, e, dragObj);
            }
            else {
                this.dropAsChildNode(dragLi, dropLi, dragObj, null, e, offsetY);
            }
        }
        else {
            this.dropAsChildNode(dragLi, dropLi, dragObj, null, e, offsetY, true);
        }
    };
    TreeView.prototype.dropAsSiblingNode = function (dragLi, dropLi, e, dragObj) {
        var dropUl = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(dropLi, '.' + PARENTITEM);
        var dragParentUl = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(dragLi, '.' + PARENTITEM);
        var dragParentLi = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(dragParentUl, '.' + LISTITEM);
        var pre;
        if (e.target.offsetHeight > 0 && e.event.offsetY > e.target.offsetHeight - 2) {
            pre = false;
        }
        else if (e.event.offsetY < 2) {
            pre = true;
        }
        else if (e.target.classList.contains('e-icon-expandable') || (e.target.classList.contains('e-icon-collapsible'))) {
            if ((e.event.offsetY < 5) || (e.event.offsetX < 3)) {
                pre = true;
            }
            else if ((e.event.offsetY > 15) || (e.event.offsetX > 17)) {
                pre = false;
            }
        }
        if ((e.target.classList.contains('e-icon-expandable')) || (e.target.classList.contains('e-icon-collapsible'))) {
            var target = e.target.closest('li');
            dropUl.insertBefore(dragLi, pre ? target : target.nextElementSibling);
        }
        else {
            dropUl.insertBefore(dragLi, pre ? e.target : e.target.nextElementSibling);
        }
        this.moveData(dragLi, dropLi, dropUl, pre, dragObj);
        this.updateElement(dragParentUl, dragParentLi);
        this.updateAriaLevel(dragLi);
        if (dragObj.element.id === this.element.id) {
            this.updateList();
        }
        else {
            dragObj.updateInstance();
            this.updateInstance();
        }
    };
    TreeView.prototype.dropAsChildNode = function (dragLi, dropLi, dragObj, index, e, pos, isCheck) {
        var dragParentUl = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(dragLi, '.' + PARENTITEM);
        var dragParentLi = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(dragParentUl, '.' + LISTITEM);
        var dropParentUl = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(dropLi, '.' + PARENTITEM);
        var templateTarget;
        if (e && e.target) {
            templateTarget = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])(this.fullRowSelect ? '.' + FULLROW : '.' + TEXTWRAP, dropLi);
        }
        if (e && (pos < 7) && !isCheck) {
            dropParentUl.insertBefore(dragLi, dropLi);
            this.moveData(dragLi, dropLi, dropParentUl, true, dragObj);
        }
        else if (e && (e.target.offsetHeight > 0 && pos > (e.target.offsetHeight - 10)) && !isCheck && !this.hasTemplate) {
            dropParentUl.insertBefore(dragLi, dropLi.nextElementSibling);
            this.moveData(dragLi, dropLi, dropParentUl, false, dragObj);
        }
        else if (this.hasTemplate && templateTarget && pos > templateTarget.offsetHeight - 10 && !isCheck) {
            dropParentUl.insertBefore(dragLi, dropLi.nextElementSibling);
            this.moveData(dragLi, dropLi, dropParentUl, false, dragObj);
        }
        else {
            var dropUl = this.expandParent(dropLi);
            var childLi = dropUl.childNodes[index];
            dropUl.insertBefore(dragLi, childLi);
            this.moveData(dragLi, childLi, dropUl, true, dragObj);
        }
        this.updateElement(dragParentUl, dragParentLi);
        this.updateAriaLevel(dragLi);
        if (dragObj.element.id === this.element.id) {
            this.updateList();
        }
        else {
            dragObj.updateInstance();
            this.updateInstance();
        }
    };
    TreeView.prototype.moveData = function (dragLi, dropLi, dropUl, pre, dragObj) {
        var dropParentLi = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(dropUl, '.' + LISTITEM);
        var id = this.getId(dragLi);
        var removedData = dragObj.updateChildField(dragObj.treeData, dragObj.fields, id, null, null, true);
        var refId = this.getId(dropLi);
        var index = this.getDataPos(this.treeData, this.fields, refId);
        var parentId = this.getId(dropParentLi);
        if (this.dataType === 1) {
            this.updateField(this.treeData, this.fields, parentId, 'hasChildren', true);
            var pos = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(index) ? this.treeData.length : (pre ? index : index + 1);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(parentId) && !this.hasPid) {
                delete removedData[0][this.fields.parentID];
            }
            else {
                var currPid = this.isNumberTypeId ? parseFloat(parentId) : parentId;
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])(this.fields.parentID, currPid, removedData[0]);
            }
            this.treeData.splice(pos, 0, removedData[0]);
            if (dragObj.element.id !== this.element.id) {
                var childData = dragObj.removeChildNodes(id);
                pos++;
                for (var i = 0, len = childData.length; i < len; i++) {
                    this.treeData.splice(pos, 0, childData[i]);
                    pos++;
                }
                dragObj.groupedData = dragObj.getGroupedData(dragObj.treeData, dragObj.fields.parentID);
            }
            this.groupedData = this.getGroupedData(this.treeData, this.fields.parentID);
        }
        else {
            this.addChildData(this.treeData, this.fields, parentId, removedData, pre ? index : index + 1);
        }
    };
    TreeView.prototype.expandParent = function (dropLi) {
        var dropIcon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('div.' + ICON, dropLi);
        if (dropIcon && dropIcon.classList.contains(EXPANDABLE) && this.preventExpand !== true) {
            this.expandAction(dropLi, dropIcon, null);
        }
        var dropUl = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, dropLi);
        if (this.preventExpand === true && !dropUl && dropIcon) {
            this.renderChildNodes(dropLi);
        }
        dropUl = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, dropLi);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dropUl) && this.preventExpand === true) {
            dropUl.style.display = 'none';
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dropUl) && this.preventExpand === false) {
            dropUl.style.display = 'block';
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dropUl) && this.preventExpand === true) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dropIcon)) {
                __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_lists__["a" /* ListBase */].generateIcon(this.createElement, dropLi, EXPANDABLE, this.listBaseOption);
            }
            var icon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('div.' + ICON, dropLi);
            if (icon) {
                icon.classList.add('e-icon-expandable');
            }
            dropUl = __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_lists__["a" /* ListBase */].generateUL(this.createElement, [], null, this.listBaseOption);
            dropLi.appendChild(dropUl);
            if (icon) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([icon], COLLAPSIBLE);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_lists__["a" /* ListBase */].generateIcon(this.createElement, dropLi, EXPANDABLE, this.listBaseOption);
            }
            dropLi.setAttribute('aria-expanded', 'false');
            dropUl.style.display = 'none';
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dropUl)) {
            this.trigger('nodeExpanding', this.getExpandEvent(dropLi, null));
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dropIcon)) {
                __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_lists__["a" /* ListBase */].generateIcon(this.createElement, dropLi, COLLAPSIBLE, this.listBaseOption);
            }
            var icon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('div.' + ICON, dropLi);
            if (icon) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([icon], EXPANDABLE);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_lists__["a" /* ListBase */].generateIcon(this.createElement, dropLi, COLLAPSIBLE, this.listBaseOption);
                icon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('div.' + ICON, dropLi);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([icon], EXPANDABLE);
            }
            dropUl = __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_lists__["a" /* ListBase */].generateUL(this.createElement, [], null, this.listBaseOption);
            dropLi.appendChild(dropUl);
            this.addExpand(dropLi);
            this.trigger('nodeExpanded', this.getExpandEvent(dropLi, null));
        }
        return dropUl;
    };
    TreeView.prototype.updateElement = function (dragParentUl, dragParentLi) {
        if (dragParentLi && dragParentUl.childElementCount === 0) {
            var dragIcon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('div.' + ICON, dragParentLi);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(dragParentUl);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(dragIcon);
            var parentId = this.getId(dragParentLi);
            this.updateField(this.treeData, this.fields, parentId, 'hasChildren', false);
            this.removeExpand(dragParentLi, true);
        }
    };
    TreeView.prototype.updateAriaLevel = function (dragLi) {
        var level = this.parents(dragLi, '.' + PARENTITEM).length;
        dragLi.setAttribute('aria-level', '' + level);
        this.updateChildAriaLevel(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, dragLi), level + 1);
    };
    TreeView.prototype.updateChildAriaLevel = function (element, level) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(element)) {
            var cNodes = element.childNodes;
            for (var i = 0, len = cNodes.length; i < len; i++) {
                var liEle = cNodes[i];
                liEle.setAttribute('aria-level', '' + level);
                this.updateChildAriaLevel(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, liEle), level + 1);
            }
        }
    };
    TreeView.prototype.renderVirtualEle = function (e) {
        var pre;
        if (e.event.offsetY > e.target.offsetHeight - 2) {
            pre = false;
        }
        else if (e.event.offsetY < 2) {
            pre = true;
        }
        var virEle = this.createElement('div', { className: SIBLING });
        var index = this.fullRowSelect ? (pre ? 1 : 2) : (pre ? 0 : 1);
        e.target.insertBefore(virEle, e.target.children[index]);
    };
    TreeView.prototype.removeVirtualEle = function () {
        var sibEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + SIBLING);
        if (sibEle) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(sibEle);
        }
    };
    TreeView.prototype.destroyDrag = function () {
        if (this.dragObj && this.dropObj) {
            this.dragObj.destroy();
            this.dropObj.destroy();
        }
    };
    TreeView.prototype.getDragEvent = function (event, obj, dropTarget, target, dragNode, cloneEle, level, drop) {
        var dropLi = dropTarget ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(dropTarget, '.' + LISTITEM) : null;
        var dropData = dropLi ? this.getNodeData(dropLi) : null;
        var draggedNode = obj ? obj.dragLi : dragNode;
        var draggedNodeData = obj ? obj.dragData : null;
        var newParent = dropTarget ? this.parents(dropTarget, '.' + LISTITEM) : null;
        var dragLiParent = obj.dragLi.parentElement;
        var dragParent = obj.dragLi ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(dragLiParent, '.' + LISTITEM) : null;
        var targetParent = null;
        var indexValue = null;
        var iconCss = [DROPNEXT, DROPIN, DROPOUT, NODROP];
        var iconClass = null;
        var node = (drop === true) ? draggedNode : dropLi;
        var index = node ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(node, '.e-list-parent') : null;
        var i = 0;
        var position = null;
        dragParent = (obj.dragLi && dragParent === null) ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(dragLiParent, '.' + ROOT) : dragParent;
        dragParent = (drop === true) ? this.dragParent : dragParent;
        if (cloneEle) {
            while (i < 4) {
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + ICON, cloneEle).classList.contains(iconCss[i])) {
                    iconClass = iconCss[i];
                    break;
                }
                i++;
            }
        }
        if (index) {
            var dropTar = 0;
            for (i = 0; i < index.childElementCount; i++) {
                dropTar = (drop !== true && index.children[i] === draggedNode && dropLi !== draggedNode) ? ++dropTar : dropTar;
                if ((drop !== true && index.children[i].classList.contains('e-hover'))) {
                    indexValue = (event.offsetY >= 23) ? i + 1 : i;
                    break;
                }
                else if (index.children[i] === node) {
                    indexValue = (event.offsetY >= 23) ? i : i;
                    break;
                }
            }
            indexValue = (dropTar !== 0) ? --indexValue : indexValue;
            position = (iconClass == "e-drop-in") ? "Inside" : ((event.offsetY < 7) ? "Before" : "After");
        }
        if (dropTarget) {
            if (newParent.length === 0) {
                targetParent = null;
            }
            else if (dropTarget.classList.contains(LISTITEM)) {
                targetParent = newParent[0];
            }
            else {
                targetParent = newParent[1];
            }
        }
        if (dropLi === draggedNode) {
            targetParent = dropLi;
        }
        if (dropTarget && target.offsetHeight <= 33 && event.offsetY < target.offsetHeight - 10 && event.offsetY > 6) {
            targetParent = dropLi;
            if (drop !== true) {
                level = ++level;
                var parent_2 = targetParent ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-list-parent', targetParent) : null;
                indexValue = (parent_2) ? parent_2.children.length : 0;
                if (!(this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */]) && parent_2 === null && targetParent) {
                    var parent_3 = targetParent.hasAttribute('data-uid') ?
                        this.getChildNodes(this.fields.dataSource, targetParent.getAttribute('data-uid').toString()) : null;
                    indexValue = (parent_3) ? parent_3.length : 0;
                }
            }
        }
        return {
            cancel: false,
            clonedNode: cloneEle,
            event: event,
            draggedNode: draggedNode,
            draggedNodeData: draggedNodeData,
            droppedNode: dropLi,
            droppedNodeData: dropData,
            dropIndex: indexValue,
            dropLevel: level,
            draggedParentNode: dragParent,
            dropTarget: targetParent,
            dropIndicator: iconClass,
            target: target,
            position: position,
        };
    };
    TreeView.prototype.addFullRow = function (toAdd) {
        var len = this.liList.length;
        if (toAdd) {
            for (var i = 0; i < len; i++) {
                this.createFullRow(this.liList[i]);
            }
        }
        else {
            for (var i = 0; i < len; i++) {
                var rowDiv = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + FULLROW, this.liList[i]);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(rowDiv);
            }
        }
    };
    TreeView.prototype.createFullRow = function (item) {
        var rowDiv = this.createElement('div', { className: FULLROW });
        item.insertBefore(rowDiv, item.childNodes[0]);
    };
    TreeView.prototype.addMultiSelect = function (toAdd) {
        if (toAdd) {
            var liEles = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + LISTITEM + ':not([aria-selected="true"])', this.element);
            for (var _i = 0, liEles_1 = liEles; _i < liEles_1.length; _i++) {
                var ele = liEles_1[_i];
                ele.setAttribute('aria-selected', 'false');
            }
        }
        else {
            var liEles = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + LISTITEM + '[aria-selected="false"]', this.element);
            for (var _a = 0, liEles_2 = liEles; _a < liEles_2.length; _a++) {
                var ele = liEles_2[_a];
                ele.removeAttribute('aria-selected');
            }
        }
    };
    TreeView.prototype.collapseByLevel = function (element, level, excludeHiddenNodes) {
        if (level > 0 && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(element)) {
            var cNodes = this.getVisibleNodes(excludeHiddenNodes, element.childNodes);
            for (var i = 0, len = cNodes.length; i < len; i++) {
                var liEle = cNodes[i];
                var icon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + COLLAPSIBLE, Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + TEXTWRAP, liEle));
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(icon)) {
                    this.collapseNode(liEle, icon, null);
                }
                this.collapseByLevel(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, liEle), level - 1, excludeHiddenNodes);
            }
        }
    };
    TreeView.prototype.collapseAllNodes = function (excludeHiddenNodes) {
        var cIcons = this.getVisibleNodes(excludeHiddenNodes, Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + COLLAPSIBLE, this.element));
        for (var i = 0, len = cIcons.length; i < len; i++) {
            var icon = cIcons[i];
            var liEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(icon, '.' + LISTITEM);
            this.collapseNode(liEle, icon, null);
        }
    };
    TreeView.prototype.expandByLevel = function (element, level, excludeHiddenNodes) {
        if (level > 0 && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(element)) {
            var eNodes = this.getVisibleNodes(excludeHiddenNodes, element.childNodes);
            for (var i = 0, len = eNodes.length; i < len; i++) {
                var liEle = eNodes[i];
                var icon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + EXPANDABLE, Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + TEXTWRAP, liEle));
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(icon)) {
                    this.expandAction(liEle, icon, null);
                }
                this.expandByLevel(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, liEle), level - 1, excludeHiddenNodes);
            }
        }
    };
    TreeView.prototype.expandAllNodes = function (excludeHiddenNodes) {
        var eIcons = this.getVisibleNodes(excludeHiddenNodes, Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + EXPANDABLE, this.element));
        for (var i = 0, len = eIcons.length; i < len; i++) {
            var icon = eIcons[i];
            var liEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(icon, '.' + LISTITEM);
            this.expandAction(liEle, icon, null, true);
        }
    };
    TreeView.prototype.getVisibleNodes = function (excludeHiddenNodes, nodes) {
        var vNodes = Array.prototype.slice.call(nodes);
        if (excludeHiddenNodes) {
            for (var i = 0; i < vNodes.length; i++) {
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["T" /* isVisible */])(vNodes[i])) {
                    vNodes.splice(i, 1);
                    i--;
                }
            }
        }
        return vNodes;
    };
    TreeView.prototype.removeNode = function (node) {
        var dragParentUl = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(node, '.' + PARENTITEM);
        var dragParentLi = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(dragParentUl, '.' + LISTITEM);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.nodeTemplateFn)) {
            this.destroyTemplate(node);
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(node);
        this.updateElement(dragParentUl, dragParentLi);
        this.removeData(node);
    };
    TreeView.prototype.updateInstance = function () {
        this.updateList();
        this.updateSelectedNodes();
        this.updateExpandedNodes();
    };
    TreeView.prototype.updateList = function () {
        this.liList = Array.prototype.slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + LISTITEM, this.element));
    };
    TreeView.prototype.updateSelectedNodes = function () {
        this.setProperties({ selectedNodes: [] }, true);
        var sNodes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + ACTIVE, this.element);
        this.selectGivenNodes(sNodes);
    };
    TreeView.prototype.updateExpandedNodes = function () {
        this.setProperties({ expandedNodes: [] }, true);
        var eNodes = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('[aria-expanded="true"]', this.element);
        for (var i = 0, len = eNodes.length; i < len; i++) {
            this.addExpand(eNodes[i]);
        }
    };
    TreeView.prototype.removeData = function (node) {
        if (this.dataType === 1) {
            var dm = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */](this.treeData);
            var id = this.getId(node);
            var data = {};
            var newId = this.isNumberTypeId ? parseFloat(id) : id;
            data[this.fields.id] = newId;
            dm.remove(this.fields.id, data);
            this.removeChildNodes(id);
        }
        else {
            var id = this.getId(node);
            this.updateChildField(this.treeData, this.fields, id, null, null, true);
        }
    };
    TreeView.prototype.removeChildNodes = function (parentId) {
        var cNodes = this.getChildGroup(this.groupedData, parentId, false);
        var childData = [];
        if (cNodes) {
            for (var i = 0, len = cNodes.length; i < len; i++) {
                var dm = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */](this.treeData);
                var id = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.id, cNodes[i]).toString();
                var data = {};
                var currId = this.isNumberTypeId ? parseFloat(id) : id;
                data[this.fields.id] = currId;
                var nodeData = dm.remove(this.fields.id, data);
                childData.push(nodeData[0]);
                this.removeChildNodes(id);
            }
        }
        return childData;
    };
    TreeView.prototype.doGivenAction = function (nodes, selector, toExpand) {
        for (var i = 0, len = nodes.length; i < len; i++) {
            var liEle = this.getElement(nodes[i]);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liEle)) {
                continue;
            }
            var icon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + selector, Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + TEXTWRAP, liEle));
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(icon)) {
                toExpand ? this.expandAction(liEle, icon, null) : this.collapseNode(liEle, icon, null);
            }
        }
    };
    TreeView.prototype.addGivenNodes = function (nodes, dropLi, index, isRemote, dropEle) {
        if (nodes.length === 0) {
            return;
        }
        var sNodes = this.getSortedData(nodes);
        var level = dropLi ? parseFloat(dropLi.getAttribute('aria-level')) + 1 : 1;
        if (isRemote) {
            this.updateMapper(level);
        }
        var li = __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_lists__["a" /* ListBase */].createListItemFromJson(this.createElement, sNodes, this.listBaseOption, level);
        var dropUl;
        if (!dropEle) {
            dropUl = dropLi ? this.expandParent(dropLi) : Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, this.element);
        }
        else {
            dropUl = dropEle;
        }
        var refNode = dropUl.childNodes[index];
        for (var i = 0; i < li.length; i++) {
            dropUl.insertBefore(li[i], refNode);
        }
        var id = this.getId(dropLi);
        if (this.dataType === 1) {
            this.updateField(this.treeData, this.fields, id, 'hasChildren', true);
            var refId = this.getId(refNode);
            var pos = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(refId) ? this.treeData.length : this.getDataPos(this.treeData, this.fields, refId);
            for (var j = 0; j < nodes.length; j++) {
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(id)) {
                    var currId = this.isNumberTypeId ? parseFloat(id) : id;
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])(this.fields.parentID, currId, nodes[j]);
                }
                this.treeData.splice(pos, 0, nodes[j]);
                pos++;
            }
        }
        else {
            this.addChildData(this.treeData, this.fields, id, nodes, index);
        }
        this.finalizeNode(dropUl);
    };
    TreeView.prototype.updateMapper = function (level) {
        var mapper = (level === 1) ? this.fields : this.getChildFields(this.fields, level - 1, 1);
        this.updateListProp(mapper);
    };
    TreeView.prototype.updateListProp = function (mapper) {
        var prop = this.getActualProperties(mapper);
        this.listBaseOption.fields = prop;
        this.listBaseOption.fields.url = prop.hasOwnProperty('navigateUrl') ? prop.navigateUrl : 'navigateUrl';
    };
    TreeView.prototype.getDataPos = function (obj, mapper, id) {
        var pos = null;
        for (var i = 0, objlen = obj.length; i < objlen; i++) {
            var nodeId = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.id, obj[i]);
            if (obj[i] && nodeId && nodeId.toString() === id) {
                return i;
            }
            else if (typeof mapper.child === 'string' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.child, obj[i]))) {
                var data = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.child, obj[i]);
                pos = this.getDataPos(data, this.getChildMapper(mapper), id);
                if (pos !== null) {
                    break;
                }
            }
            else if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('child', obj[i]))) {
                var items = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('child', obj[i]);
                pos = this.getDataPos(items, this.getChildMapper(mapper), id);
                if (pos !== null) {
                    break;
                }
            }
        }
        return pos;
    };
    TreeView.prototype.addChildData = function (obj, mapper, id, data, index) {
        var updated;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(id)) {
            index = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(index) ? obj.length : index;
            for (var k = 0, len = data.length; k < len; k++) {
                obj.splice(index, 0, data[k]);
                index++;
            }
            return updated;
        }
        for (var i = 0, objlen = obj.length; i < objlen; i++) {
            var nodeId = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.id, obj[i]);
            if (obj[i] && nodeId && nodeId.toString() === id) {
                if ((typeof mapper.child === 'string' && (obj[i].hasOwnProperty(mapper.child) && obj[i][mapper.child] !== null)) ||
                    ((this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */]) && obj[i].hasOwnProperty('child'))) {
                    var key = (typeof mapper.child === 'string') ? mapper.child : 'child';
                    var childData = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(key, obj[i]);
                    if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(childData)) {
                        childData = [];
                    }
                    index = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(index) ? childData.length : index;
                    for (var k = 0, len = data.length; k < len; k++) {
                        childData.splice(index, 0, data[k]);
                        index++;
                    }
                }
                else {
                    var key = (typeof mapper.child === 'string') ? mapper.child : 'child';
                    obj[i][key] = data;
                }
                return true;
            }
            else if (typeof mapper.child === 'string' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.child, obj[i]))) {
                var childObj = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.child, obj[i]);
                updated = this.addChildData(childObj, this.getChildMapper(mapper), id, data, index);
                if (updated !== undefined) {
                    break;
                }
            }
            else if ((this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */]) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('child', obj[i]))) {
                var childData = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('child', obj[i]);
                updated = this.addChildData(childData, this.getChildMapper(mapper), id, data, index);
                if (updated !== undefined) {
                    break;
                }
            }
        }
        return updated;
    };
    TreeView.prototype.doDisableAction = function (nodes) {
        var validNodes = this.nodeType(nodes);
        var validID = this.checkValidId(validNodes);
        this.validArr = [];
        for (var i = 0, len = validID.length; i < len; i++) {
            var id = validID[i][this.fields.id].toString();
            if (id && this.disableNode.indexOf(id) === -1) {
                this.disableNode.push(id);
            }
            var liEle = this.getElement(id);
            if (liEle) {
                liEle.setAttribute('aria-disabled', 'true');
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([liEle], DISABLE);
            }
        }
    };
    TreeView.prototype.doEnableAction = function (nodes) {
        var strNodes = this.nodeType(nodes);
        for (var i = 0, len = strNodes.length; i < len; i++) {
            var liEle = this.getElement(strNodes[i]);
            var id = strNodes[i];
            if (id && this.disableNode.indexOf(id) !== -1) {
                this.disableNode.splice(this.disableNode.indexOf(id), 1);
            }
            if (liEle) {
                liEle.removeAttribute('aria-disabled');
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([liEle], DISABLE);
            }
        }
    };
    TreeView.prototype.nodeType = function (nodes) {
        var validID = [];
        for (var i = 0, len = nodes.length; i < len; i++) {
            var id = void 0;
            if (typeof nodes[i] == "string") {
                id = (nodes[i]) ? nodes[i].toString() : null;
            }
            else if (typeof nodes[i] === "object") {
                id = nodes[i] ? nodes[i].getAttribute("data-uid").toString() : null;
            }
            if (validID.indexOf(id) == -1) {
                validID.push(id);
            }
        }
        return validID;
    };
    TreeView.prototype.checkValidId = function (node) {
        var _this = this;
        if (this.dataType === 1) {
            this.validArr = this.treeData.filter(function (data) {
                return node.indexOf(data[_this.fields.id] ? data[_this.fields.id].toString() : null) !== -1;
            });
        }
        else if (this.dataType === 2) {
            for (var k = 0; k < this.treeData.length; k++) {
                var id = this.treeData[k][this.fields.id] ? this.treeData[k][this.fields.id].toString() : null;
                if (node.indexOf(id) !== -1) {
                    this.validArr.push(this.treeData[k]);
                }
                var childItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.child.toString(), this.treeData[k]);
                if (childItems) {
                    this.filterNestedChild(childItems, node);
                }
            }
        }
        return this.validArr;
    };
    TreeView.prototype.filterNestedChild = function (treeData, nodes) {
        for (var k = 0; k < treeData.length; k++) {
            var id = treeData[k][this.fields.id] ? treeData[k][this.fields.id].toString() : null;
            if (nodes.indexOf(id) !== -1) {
                this.validArr.push(treeData[k]);
            }
            var childItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.child.toString(), treeData[k]);
            if (childItems) {
                this.filterNestedChild(childItems, nodes);
            }
        }
    };
    TreeView.prototype.setTouchClass = function () {
        var ele = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, '.' + BIGGER);
        this.touchClass = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ele) ? '' : SMALL;
    };
    TreeView.prototype.updatePersistProp = function () {
        this.removeField(this.treeData, this.fields, ['selected', 'expanded']);
        var sleNodes = this.selectedNodes;
        for (var l = 0, slelen = sleNodes.length; l < slelen; l++) {
            this.updateField(this.treeData, this.fields, sleNodes[l], 'selected', true);
        }
        var enodes = this.expandedNodes;
        for (var k = 0, nodelen = enodes.length; k < nodelen; k++) {
            this.updateField(this.treeData, this.fields, enodes[k], 'expanded', true);
        }
        if (this.showCheckBox) {
            this.removeField(this.treeData, this.fields, ['isChecked']);
            var cnodes = this.checkedNodes;
            for (var m = 0, nodelen = cnodes.length; m < nodelen; m++) {
                this.updateField(this.treeData, this.fields, cnodes[m], 'isChecked', true);
            }
        }
    };
    TreeView.prototype.removeField = function (obj, mapper, names) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(obj) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(mapper)) {
            return;
        }
        for (var i = 0, objlen = obj.length; i < objlen; i++) {
            for (var j = 0; j < names.length; j++) {
                var field = this.getMapperProp(mapper, names[j]);
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(obj[i][field])) {
                    delete obj[i][field];
                }
            }
            if (typeof mapper.child === 'string' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.child, obj[i]))) {
                this.removeField(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.child, obj[i]), this.getChildMapper(mapper), names);
            }
            else if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('child', obj[i]))) {
                this.removeField(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('child', obj[i]), this.getChildMapper(mapper), names);
            }
        }
    };
    TreeView.prototype.getMapperProp = function (mapper, fieldName) {
        switch (fieldName) {
            case 'selected':
                return !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(mapper.selected) ? mapper.selected : 'selected';
            case 'expanded':
                return !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(mapper.expanded) ? mapper.expanded : 'expanded';
            case 'isChecked':
                return !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(mapper.isChecked) ? mapper.isChecked : 'isChecked';
            case 'hasChildren':
                return !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(mapper.hasChildren) ? mapper.hasChildren : 'hasChildren';
            default:
                return fieldName;
        }
    };
    TreeView.prototype.updateField = function (obj, mapper, id, key, value) {
        var childNodes;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(id)) {
            return;
        }
        else if (this.dataType === 1) {
            var newId = this.isNumberTypeId ? parseFloat(id) : id;
            var resultData = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */](this.treeData).executeLocal(new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["b" /* Query */]().where(mapper.id, 'equal', newId, false));
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])(this.getMapperProp(mapper, key), value, resultData[0]);
        }
        else {
            this.updateChildField(obj, mapper, id, key, value);
        }
    };
    TreeView.prototype.updateChildField = function (obj, mapper, id, key, value, remove) {
        var removedData;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(obj)) {
            return removedData;
        }
        for (var i = 0, objlen = obj.length; i < objlen; i++) {
            var nodeId = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.id, obj[i]);
            if (obj[i] && nodeId && nodeId.toString() === id) {
                if (remove) {
                    removedData = obj.splice(i, 1);
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])(this.getMapperProp(mapper, key), value, obj[i]);
                    removedData = [];
                }
                return removedData;
            }
            else if (typeof mapper.child === 'string' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.child, obj[i]))) {
                var childData = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.child, obj[i]);
                removedData = this.updateChildField(childData, this.getChildMapper(mapper), id, key, value, remove);
                if (removedData !== undefined) {
                    break;
                }
            }
            else if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('child', obj[i]))) {
                var childItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('child', obj[i]);
                removedData = this.updateChildField(childItems, this.getChildMapper(mapper), id, key, value, remove);
                if (removedData !== undefined) {
                    break;
                }
            }
        }
        return removedData;
    };
    TreeView.prototype.triggerEvent = function () {
        this.renderReactTemplates();
        var eventArgs = { data: this.treeData };
        this.trigger('dataSourceChanged', eventArgs);
    };
    TreeView.prototype.wireInputEvents = function (inpEle) {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(inpEle, 'blur', this.inputFocusOut, this);
    };
    TreeView.prototype.wireEditingEvents = function (toBind) {
        var _this = this;
        if (toBind && !this.disabled) {
            var proxy_2 = this;
            this.touchEditObj = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["t" /* Touch */](this.element, {
                tap: function (e) {
                    if (_this.isDoubleTapped(e) && e.tapCount === 2) {
                        e.originalEvent.preventDefault();
                        proxy_2.editingHandler(e.originalEvent);
                    }
                }
            });
        }
        else {
            if (this.touchEditObj) {
                this.touchEditObj.destroy();
            }
        }
    };
    TreeView.prototype.wireClickEvent = function (toBind) {
        if (toBind) {
            var proxy_3 = this;
            this.touchClickObj = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["t" /* Touch */](this.element, {
                tap: function (e) {
                    proxy_3.clickHandler(e);
                }
            });
        }
        else {
            if (this.touchClickObj) {
                this.touchClickObj.destroy();
            }
        }
    };
    TreeView.prototype.wireExpandOnEvent = function (toBind) {
        var _this = this;
        if (toBind) {
            var proxy_4 = this;
            this.touchExpandObj = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["t" /* Touch */](this.element, {
                tap: function (e) {
                    if ((_this.expandOnType === 'Click' || (_this.expandOnType === 'DblClick' && _this.isDoubleTapped(e) && e.tapCount === 2))
                        && e.originalEvent.which !== 3) {
                        proxy_4.expandHandler(e);
                    }
                }
            });
        }
        else {
            if (this.touchExpandObj) {
                this.touchExpandObj.destroy();
            }
        }
    };
    TreeView.prototype.mouseDownHandler = function (e) {
        this.mouseDownStatus = true;
        if (e.shiftKey || e.ctrlKey) {
            e.preventDefault();
        }
        if (e.ctrlKey && this.allowMultiSelection) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'contextmenu', this.preventContextMenu, this);
        }
    };
    ;
    TreeView.prototype.preventContextMenu = function (e) {
        e.preventDefault();
    };
    TreeView.prototype.wireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'mousedown', this.mouseDownHandler, this);
        this.wireClickEvent(true);
        if (this.expandOnType !== 'None') {
            this.wireExpandOnEvent(true);
        }
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'focus', this.focusIn, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'blur', this.focusOut, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'mouseover', this.onMouseOver, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'mouseout', this.onMouseLeave, this);
        this.keyboardModule = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["n" /* KeyboardEvents */](this.element, {
            keyAction: this.keyActionHandler.bind(this),
            keyConfigs: this.keyConfigs,
            eventName: 'keydown',
        });
    };
    TreeView.prototype.unWireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'mousedown', this.mouseDownHandler);
        this.wireClickEvent(false);
        this.wireExpandOnEvent(false);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'focus', this.focusIn);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'blur', this.focusOut);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'mouseover', this.onMouseOver);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'mouseout', this.onMouseLeave);
        if (!this.disabled) {
            this.keyboardModule.destroy();
        }
    };
    TreeView.prototype.parents = function (element, selector) {
        var matched = [];
        var el = element.parentNode;
        while (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(el)) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["U" /* matches */])(el, selector)) {
                matched.push(el);
            }
            el = el.parentNode;
        }
        return matched;
    };
    TreeView.prototype.isDoubleTapped = function (e) {
        var target = e.originalEvent.target;
        var secondTap;
        if (target && e.tapCount) {
            if (e.tapCount === 1) {
                this.firstTap = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(target, '.' + LISTITEM);
            }
            else if (e.tapCount === 2) {
                secondTap = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(target, '.' + LISTITEM);
            }
        }
        return (this.firstTap === secondTap);
    };
    TreeView.prototype.isDescendant = function (parent, child) {
        var node = child.parentNode;
        while (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(node)) {
            if (node === parent) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    };
    TreeView.prototype.showSpinner = function (element) {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([element], LOAD);
        Object(__WEBPACK_IMPORTED_MODULE_5__syncfusion_ej2_popups__["d" /* createSpinner */])({
            target: element,
            width: __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice ? 16 : 14
        }, this.createElement);
        Object(__WEBPACK_IMPORTED_MODULE_5__syncfusion_ej2_popups__["j" /* showSpinner */])(element);
    };
    TreeView.prototype.hideSpinner = function (element) {
        Object(__WEBPACK_IMPORTED_MODULE_5__syncfusion_ej2_popups__["h" /* hideSpinner */])(element);
        element.innerHTML = '';
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([element], LOAD);
    };
    TreeView.prototype.setCheckedNodes = function (nodes) {
        nodes = JSON.parse(JSON.stringify(nodes));
        this.uncheckAll(this.checkedNodes);
        this.setIndeterminate(nodes);
        if (nodes.length > 0) {
            this.checkAll(nodes);
        }
    };
    /**
     * Checks whether the checkedNodes entered are valid and sets the valid checkedNodes while changing via setmodel
     */
    TreeView.prototype.setValidCheckedNode = function (node) {
        if (this.dataType === 1) {
            var mapper = this.fields;
            var resultData = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */](this.treeData).executeLocal(new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["b" /* Query */]().where(mapper.id, 'equal', node, true));
            if (resultData[0]) {
                this.setChildCheckState(resultData, node, resultData[0]);
                if (this.autoCheck) {
                    var parent_4 = resultData[0][this.fields.parentID] ? resultData[0][this.fields.parentID].toString() : null;
                    var childNodes = this.getChildNodes(this.treeData, parent_4);
                    var count = 0;
                    for (var len = 0; len < childNodes.length; len++) {
                        var childId = childNodes[len][this.fields.id].toString();
                        if (this.checkedNodes.indexOf(childId) !== -1) {
                            count++;
                        }
                    }
                    if (count === childNodes.length && this.checkedNodes.indexOf(parent_4) === -1 && parent_4) {
                        this.checkedNodes.push(parent_4);
                    }
                }
            }
        }
        else if (this.dataType === 2) {
            for (var a = 0; a < this.treeData.length; a++) {
                var index = this.treeData[a][this.fields.id] ? this.treeData[a][this.fields.id].toString() : '';
                if (index === node && this.checkedNodes.indexOf(node) === -1) {
                    this.checkedNodes.push(node);
                    break;
                }
                var childItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.child.toString(), this.treeData[a]);
                if (childItems) {
                    this.setChildCheckState(childItems, node, this.treeData[a]);
                }
            }
        }
    };
    /**
     * Checks whether the checkedNodes entered are valid and sets the valid checkedNodes while changing via setmodel(for hierarchical DS)
     */
    TreeView.prototype.setChildCheckState = function (childItems, node, treeData) {
        var checkedParent;
        var count = 0;
        if (this.dataType === 1) {
            if (treeData) {
                checkedParent = treeData[this.fields.id] ? treeData[this.fields.id].toString() : null;
            }
            for (var index = 0; index < childItems.length; index++) {
                var checkNode = childItems[index][this.fields.id] ? childItems[index][this.fields.id].toString() : null;
                if (treeData && checkedParent && this.autoCheck) {
                    if (this.checkedNodes.indexOf(checkedParent) !== -1 && this.checkedNodes.indexOf(checkNode) === -1) {
                        this.checkedNodes.push(checkNode);
                    }
                }
                if (checkNode === node && this.checkedNodes.indexOf(node) === -1) {
                    this.checkedNodes.push(node);
                }
                var subChildItems = this.getChildNodes(this.treeData, checkNode);
                if (subChildItems) {
                    this.setChildCheckState(subChildItems, node, treeData);
                }
            }
        }
        else {
            if (treeData) {
                checkedParent = treeData[this.fields.id] ? treeData[this.fields.id].toString() : '';
            }
            for (var index = 0; index < childItems.length; index++) {
                var checkedChild = childItems[index][this.fields.id] ? childItems[index][this.fields.id].toString() : '';
                if (treeData && checkedParent && this.autoCheck) {
                    if (this.checkedNodes.indexOf(checkedParent) !== -1 && this.checkedNodes.indexOf(checkedChild) === -1) {
                        this.checkedNodes.push(checkedChild);
                    }
                }
                if (checkedChild === node && this.checkedNodes.indexOf(node) === -1) {
                    this.checkedNodes.push(node);
                }
                var subChildItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.child.toString(), childItems[index]);
                if (subChildItems) {
                    this.setChildCheckState(subChildItems, node, childItems[index]);
                }
                if (this.checkedNodes.indexOf(checkedChild) !== -1 && this.autoCheck) {
                    count++;
                }
                if (count === childItems.length && this.checkedNodes.indexOf(checkedParent) === -1 && this.autoCheck) {
                    this.checkedNodes.push(checkedParent);
                }
            }
        }
    };
    TreeView.prototype.setIndeterminate = function (nodes) {
        for (var i = 0; i < nodes.length; i++) {
            this.setValidCheckedNode(nodes[i]);
        }
    };
    TreeView.prototype.updatePosition = function (id, newData, isRefreshChild, childValue) {
        if (this.dataType === 1) {
            var pos = this.getDataPos(this.treeData, this.fields, id);
            this.treeData.splice(pos, 1, newData);
            if (isRefreshChild) {
                this.removeChildNodes(id);
                for (var j = 0; j < childValue.length; j++) {
                    this.treeData.splice(pos, 0, childValue[j]);
                    pos++;
                }
            }
            this.groupedData = this.getGroupedData(this.treeData, this.fields.parentID);
        }
        else {
            this.updateChildPosition(this.treeData, this.fields, id, [newData], undefined);
        }
    };
    TreeView.prototype.updateChildPosition = function (treeData, mapper, currID, newData, index) {
        var found;
        for (var i = 0, objlen = treeData.length; i < objlen; i++) {
            var nodeId = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.id, treeData[i]);
            if (treeData[i] && nodeId && nodeId.toString() === currID) {
                treeData[i] = newData[0];
                return true;
            }
            else if (typeof mapper.child === 'string' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.child, treeData[i]))) {
                var childObj = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(mapper.child, treeData[i]);
                found = this.updateChildPosition(childObj, this.getChildMapper(mapper), currID, newData, index);
                if (found !== undefined) {
                    break;
                }
            }
            else if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('child', treeData[i]))) {
                var childData = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('child', treeData[i]);
                found = this.updateChildPosition(childData, this.getChildMapper(mapper), currID, newData, index);
                if (found !== undefined) {
                    break;
                }
            }
        }
        return found;
    };
    TreeView.prototype.dynamicState = function () {
        this.setDragAndDrop(this.allowDragAndDrop);
        this.wireEditingEvents(this.allowEditing);
        if (!this.disabled) {
            this.wireEvents();
            this.setRipple();
        }
        else {
            this.unWireEvents();
            this.rippleFn();
            this.rippleIconFn();
        }
    };
    TreeView.prototype.crudOperation = function (operation, nodes, target, newText, newNode, index, prevent) {
        var _this = this;
        var data = this.fields.dataSource;
        var matchedArr = [];
        var query = this.getQuery(this.fields);
        var key = this.fields.id;
        var crud;
        var changes = {
            addedRecords: [],
            deletedRecords: [],
            changedRecords: []
        };
        var nodesID = [];
        if (nodes) {
            nodesID = this.nodeType(nodes);
        }
        else if (target) {
            if (typeof target == "string") {
                nodesID[0] = target.toString();
            }
            else if (typeof target === "object") {
                nodesID[0] = target.getAttribute("data-uid").toString();
            }
        }
        for (var i = 0, len = nodesID.length; i < len; i++) {
            var liEle = this.getElement(nodesID[i]);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liEle)) {
                continue;
            }
            var removedData = this.getNodeObject(nodesID[i]);
            matchedArr.push(removedData);
        }
        switch (operation) {
            case 'delete':
                if (nodes.length == 1) {
                    crud = data.remove(key, matchedArr[0], query.fromTable, query);
                }
                else {
                    changes.deletedRecords = matchedArr;
                    crud = data.saveChanges(changes, key, query.fromTable, query);
                }
                crud.then(function (e) { return _this.deleteSuccess(nodesID); })
                    .catch(function (e) { return _this.dmFailure(e); });
                break;
            case 'update':
                matchedArr[0][this.fields.text] = newText;
                crud = data.update(key, matchedArr[0], query.fromTable, query);
                crud.then(function (e) { return _this.editSucess(target, newText, prevent); })
                    .catch(function (e) { return _this.dmFailure(e, target, prevent); });
                break;
            case 'insert':
                if (newNode.length == 1) {
                    crud = data.insert(newNode[0], query.fromTable, query);
                }
                else {
                    var arr = [];
                    for (var i = 0, len = newNode.length; i < len; i++) {
                        arr.push(newNode[i]);
                    }
                    changes.addedRecords = arr;
                    crud = data.saveChanges(changes, key, query.fromTable, query);
                }
                crud.then(function (e) {
                    var dropLi = _this.getElement(target);
                    _this.addSuccess(newNode, dropLi, index);
                    _this.preventExpand = false;
                }).catch(function (e) { return _this.dmFailure(e); });
                break;
        }
    };
    TreeView.prototype.deleteSuccess = function (nodes) {
        for (var i = 0, len = nodes.length; i < len; i++) {
            var liEle = this.getElement(nodes[i]);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liEle)) {
                continue;
            }
            this.removeNode(liEle);
        }
        this.updateInstance();
        if (this.dataType === 1) {
            this.groupedData = this.getGroupedData(this.treeData, this.fields.parentID);
        }
        this.triggerEvent();
    };
    TreeView.prototype.editSucess = function (target, newText, prevent) {
        var liEle = this.getElement(target);
        var txtEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + LISTTEXT, liEle);
        this.appendNewText(liEle, txtEle, newText, prevent);
    };
    TreeView.prototype.addSuccess = function (nodes, dropLi, index) {
        var dropUl;
        var icon = dropLi ? dropLi.querySelector('.' + ICON) : null;
        var proxy = this;
        if (dropLi && icon && icon.classList.contains(EXPANDABLE) &&
            dropLi.querySelector('.' + PARENTITEM) === null) {
            proxy.renderChildNodes(dropLi, null, function () {
                dropUl = dropLi.querySelector('.' + PARENTITEM);
                proxy.addGivenNodes(nodes, dropLi, index, true, dropUl);
                proxy.triggerEvent();
            });
        }
        else {
            this.addGivenNodes(nodes, dropLi, index, true);
            this.triggerEvent();
        }
    };
    TreeView.prototype.dmFailure = function (e, target, prevent) {
        if (target) {
            this.updatePreviousText(target, prevent);
        }
        this.trigger('actionFailure', { error: e });
    };
    TreeView.prototype.updatePreviousText = function (target, prevent) {
        var liEle = this.getElement(target);
        var txtEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + LISTTEXT, liEle);
        this.updateText(liEle, txtEle, this.oldText, prevent);
    };
    /**
     * Called internally if any of the property value changed.
     * @param  {TreeView} newProp
     * @param  {TreeView} oldProp
     * @returns void
     * @private
     */
    TreeView.prototype.onPropertyChanged = function (newProp, oldProp) {
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'allowDragAndDrop':
                    this.setDragAndDrop(this.allowDragAndDrop);
                    break;
                case 'dragArea':
                    if (this.allowDragAndDrop) {
                        this.dragObj.dragArea = this.dragArea;
                    }
                    break;
                case 'allowEditing':
                    this.wireEditingEvents(this.allowEditing);
                    break;
                case 'allowMultiSelection':
                    if (this.selectedNodes.length > 1) {
                        var sNode = this.getElement(this.selectedNodes[0]);
                        this.isLoaded = false;
                        this.removeSelectAll();
                        this.selectNode(sNode, null);
                        this.isLoaded = true;
                    }
                    this.setMultiSelect(this.allowMultiSelection);
                    this.addMultiSelect(this.allowMultiSelection);
                    break;
                case 'allowTextWrap':
                    this.setTextWrap();
                    this.updateWrap();
                    break;
                case 'checkedNodes':
                    if (this.showCheckBox) {
                        this.checkedNodes = oldProp.checkedNodes;
                        this.setCheckedNodes(newProp.checkedNodes);
                    }
                    break;
                case 'autoCheck':
                    if (this.showCheckBox) {
                        this.autoCheck = newProp.autoCheck;
                        this.ensureIndeterminate();
                    }
                    break;
                case 'cssClass':
                    this.setCssClass(oldProp.cssClass, newProp.cssClass);
                    break;
                case 'enableRtl':
                    this.setEnableRtl();
                    break;
                case 'expandedNodes':
                    this.isAnimate = false;
                    this.setProperties({ expandedNodes: [] }, true);
                    this.collapseAll();
                    this.isInitalExpand = true;
                    this.setProperties({ expandedNodes: Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(newProp.expandedNodes) ? [] : newProp.expandedNodes }, true);
                    this.doExpandAction();
                    this.isInitalExpand = false;
                    this.isAnimate = true;
                    break;
                case 'expandOn':
                    this.wireExpandOnEvent(false);
                    this.setExpandOnType();
                    if (this.expandOnType !== 'None' && !this.disabled) {
                        this.wireExpandOnEvent(true);
                    }
                    break;
                case 'disabled':
                    this.setDisabledMode();
                    this.dynamicState();
                    break;
                case 'fields':
                    this.isAnimate = false;
                    this.isFieldChange = true;
                    this.initialRender = true;
                    this.reRenderNodes();
                    this.initialRender = false;
                    this.isAnimate = true;
                    this.isFieldChange = false;
                    break;
                case 'fullRowSelect':
                    this.setFullRow(this.fullRowSelect);
                    this.addFullRow(this.fullRowSelect);
                    if (this.allowTextWrap) {
                        this.setTextWrap();
                        this.updateWrap();
                    }
                    break;
                case 'loadOnDemand':
                    if (this.loadOnDemand === false && !this.onLoaded) {
                        var nodes = this.element.querySelectorAll('li');
                        var i = 0;
                        while (i < nodes.length) {
                            if (nodes[i].getAttribute('aria-expanded') !== 'true') {
                                this.renderChildNodes(nodes[i], true, null, true);
                            }
                            i++;
                        }
                        this.onLoaded = true;
                    }
                    break;
                case 'nodeTemplate':
                    this.hasTemplate = false;
                    this.nodeTemplateFn = this.templateComplier(this.nodeTemplate);
                    this.reRenderNodes();
                    break;
                case 'selectedNodes':
                    this.removeSelectAll();
                    this.setProperties({ selectedNodes: newProp.selectedNodes }, true);
                    this.doSelectionAction();
                    break;
                case 'showCheckBox':
                    this.reRenderNodes();
                    break;
                case 'sortOrder':
                    this.reRenderNodes();
                    break;
                case 'fullRowNavigable':
                    this.setProperties({ fullRowNavigable: newProp.fullRowNavigable }, true);
                    this.listBaseOption.itemNavigable = newProp.fullRowNavigable;
                    this.reRenderNodes();
                    break;
            }
        }
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers. It also removes the attributes and classes.
     */
    TreeView.prototype.destroy = function () {
        this.clearTemplate();
        this.element.removeAttribute('aria-activedescendant');
        this.element.removeAttribute('tabindex');
        this.unWireEvents();
        this.wireEditingEvents(false);
        if (!this.disabled) {
            this.rippleFn();
            this.rippleIconFn();
        }
        this.setCssClass(this.cssClass, null);
        this.setDragAndDrop(false);
        this.setFullRow(false);
        if (this.ulElement && this.ulElement.parentElement) {
            this.ulElement.parentElement.removeChild(this.ulElement);
        }
        _super.prototype.destroy.call(this);
    };
    /**
     * Adds the collection of TreeView nodes based on target and index position. If target node is not specified,
     * then the nodes are added as children of the given parentID or in the root level of TreeView.
     * @param  { { [key: string]: Object }[] } nodes - Specifies the array of JSON data that has to be added.
     * @param  { string | Element } target - Specifies ID of TreeView node/TreeView node as target element.
     * @param  { number } index - Specifies the index to place the newly added nodes in the target element.
     * @param { boolean } preventTargetExpand - If set to true, the target parent node will be prevented from auto expanding.
     */
    TreeView.prototype.addNodes = function (nodes, target, index, preventTargetExpand) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(nodes)) {
            return;
        }
        nodes = JSON.parse(JSON.stringify(nodes));
        var dropLi = this.getElement(target);
        this.preventExpand = preventTargetExpand;
        if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */]) {
            if (!this.isOffline) {
                this.crudOperation('insert', null, target, null, nodes, index, this.preventExpand);
            }
            else {
                this.addSuccess(nodes, dropLi, index);
            }
        }
        else if (this.dataType === 2) {
            this.addGivenNodes(nodes, dropLi, index);
        }
        else {
            if (dropLi) {
                this.addGivenNodes(nodes, dropLi, index);
            }
            else {
                nodes = this.getSortedData(nodes);
                for (var i = 0; i < nodes.length; i++) {
                    var pid = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.parentID, nodes[i]);
                    dropLi = pid ? this.getElement(pid.toString()) : pid;
                    this.addGivenNodes([nodes[i]], dropLi, index);
                }
            }
            this.groupedData = this.getGroupedData(this.treeData, this.fields.parentID);
        }
        this.updateCheckedStateFromDS();
        if (this.showCheckBox && dropLi) {
            this.ensureParentCheckState(dropLi);
        }
        if ((this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] === false)) {
            this.preventExpand = false;
            this.triggerEvent();
        }
    };
    /**
     * Instead of clicking on the TreeView node for editing, we can enable it by using
     * `beginEdit` property. On passing the node ID or element through this property, the edit textBox
     * will be created for the particular node thus allowing us to edit it.
     * @param  {string | Element} node - Specifies ID of TreeView node/TreeView node.
     */
    TreeView.prototype.beginEdit = function (node) {
        var ele = this.getElement(node);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ele) || this.disabled) {
            return;
        }
        this.createTextbox(ele, null);
    };
    /**
     * Checks all the unchecked nodes. You can also check specific nodes by passing array of unchecked nodes
     * as argument to this method.
     * @param  {string[] | Element[]} nodes - Specifies the array of TreeView nodes ID/array of TreeView node.
     */
    TreeView.prototype.checkAll = function (nodes) {
        if (this.showCheckBox) {
            this.doCheckBoxAction(nodes, true);
        }
    };
    /**
     * Collapses all the expanded TreeView nodes. You can collapse specific nodes by passing array of nodes as argument to this method.
     * You can also collapse all the nodes excluding the hidden nodes by setting **excludeHiddenNodes** to true. If you want to collapse
     * a specific level of nodes, set **level** as argument to collapseAll method.
     * @param  {string[] | Element[]} nodes - Specifies the array of TreeView nodes ID/ array of TreeView node.
     * @param  {number} level - TreeView nodes will collapse up to the given level.
     * @param  {boolean} excludeHiddenNodes - Whether or not to exclude hidden nodes of TreeView when collapsing all nodes.
     */
    TreeView.prototype.collapseAll = function (nodes, level, excludeHiddenNodes) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(nodes)) {
            this.doGivenAction(nodes, COLLAPSIBLE, false);
        }
        else {
            if (level > 0) {
                this.collapseByLevel(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, this.element), level, excludeHiddenNodes);
            }
            else {
                this.collapseAllNodes(excludeHiddenNodes);
            }
        }
    };
    /**
     * Disables the collection of nodes by passing the ID of nodes or node elements in the array.
     * @param  {string[] | Element[]} nodes - Specifies the array of TreeView nodes ID/array of TreeView nodes.
     */
    TreeView.prototype.disableNodes = function (nodes) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(nodes)) {
            this.doDisableAction(nodes);
        }
    };
    /**
     * Enables the collection of disabled nodes by passing the ID of nodes or node elements in the array.
     * @param  {string[] | Element[]} nodes - Specifies the array of TreeView nodes ID/array of TreeView nodes.
     */
    TreeView.prototype.enableNodes = function (nodes) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(nodes)) {
            this.doEnableAction(nodes);
        }
    };
    /**
     * Ensures visibility of the TreeView node by using node ID or node element.
     * When many TreeView nodes are present and we need to find a particular node, `ensureVisible` property
     * helps bring the node to visibility by expanding the TreeView and scrolling to the specific node.
     * @param  {string | Element} node - Specifies ID of TreeView node/TreeView nodes.
     */
    TreeView.prototype.ensureVisible = function (node) {
        var liEle = this.getElement(node);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liEle)) {
            return;
        }
        var parents = this.parents(liEle, '.' + LISTITEM);
        this.expandAll(parents);
        setTimeout(function () { liEle.scrollIntoView(true); }, 450);
    };
    /**
     * Expands all the collapsed TreeView nodes. You can expand the specific nodes by passing the array of collapsed nodes
     * as argument to this method. You can also expand all the collapsed nodes by excluding the hidden nodes by setting
     * **excludeHiddenNodes** to true to this method. To expand a specific level of nodes, set **level** as argument to expandAll method.
     * @param  {string[] | Element[]} nodes - Specifies the array of TreeView nodes ID/array of TreeView nodes.
     * @param  {number} level - TreeView nodes will expand up to the given level.
     * @param  {boolean} excludeHiddenNodes - Whether or not to exclude hidden nodes when expanding all nodes.
     */
    TreeView.prototype.expandAll = function (nodes, level, excludeHiddenNodes) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(nodes)) {
            this.doGivenAction(nodes, EXPANDABLE, true);
        }
        else {
            if (level > 0) {
                this.expandByLevel(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, this.element), level, excludeHiddenNodes);
            }
            else {
                this.expandAllNodes(excludeHiddenNodes);
            }
        }
    };
    /**
     * Gets all the checked nodes including child, whether it is loaded or not.
     */
    TreeView.prototype.getAllCheckedNodes = function () {
        var checkNodes = this.checkedNodes;
        return checkNodes;
    };
    /**
    * Gets all the disabled nodes including child, whether it is loaded or not.
    */
    TreeView.prototype.getDisabledNodes = function () {
        var disabledNodes = this.disableNode;
        return disabledNodes;
    };
    /**
     * Get the node's data such as id, text, parentID, selected, isChecked, and expanded by passing the node element or it's ID.
     * @param  {string | Element} node - Specifies ID of TreeView node/TreeView node.
     */
    TreeView.prototype.getNode = function (node) {
        var ele = this.getElement(node);
        return this.getNodeData(ele, true);
    };
    /**
     * To get the updated data source of TreeView after performing some operation like drag and drop, node editing,
     * node selecting/unSelecting, node expanding/collapsing, node checking/unChecking, adding and removing node.
     * * If you pass the ID of TreeView node as arguments for this method then it will return the updated data source
     * of the corresponding node otherwise it will return the entire updated data source of TreeView.
     * * The updated data source also contains custom attributes if you specified in data source.
     * @param  {string | Element} node - Specifies ID of TreeView node/TreeView node.
     * @isGenericType true
     */
    TreeView.prototype.getTreeData = function (node) {
        var id = this.getId(node);
        this.updatePersistProp();
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(id)) {
            return this.treeData;
        }
        else {
            var data = this.getNodeObject(id);
            return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data) ? [] : [data];
        }
    };
    /**
     * Moves the collection of nodes within the same TreeView based on target or its index position.
     * @param  {string[] | Element[]} sourceNodes - Specifies the array of TreeView nodes ID/array of TreeView node.
     * @param  {string | Element} target - Specifies ID of TreeView node/TreeView node as target element.
     * @param  {number} index - Specifies the index to place the moved nodes in the target element.
     * @param { boolean } preventTargetExpand - If set to true, the target parent node will be prevented from auto expanding.
     */
    TreeView.prototype.moveNodes = function (sourceNodes, target, index, preventTargetExpand) {
        var dropLi = this.getElement(target);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dropLi)) {
            return;
        }
        for (var i = 0; i < sourceNodes.length; i++) {
            var dragLi = this.getElement(sourceNodes[i]);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(dragLi) || dropLi.isSameNode(dragLi) || this.isDescendant(dragLi, dropLi)) {
                continue;
            }
            this.preventExpand = preventTargetExpand;
            this.dropAsChildNode(dragLi, dropLi, this, index);
        }
        if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] === false) {
            this.preventExpand = false;
        }
        this.triggerEvent();
    };
    /**
     * Refreshes a particular node of the TreeView.
     * @param  {string | Element} target - Specifies the ID of TreeView node or TreeView node as target element.
     * @param  {{ [key: string]: Object }[]} newData - Specifies the new data of TreeView node.
     */
    TreeView.prototype.refreshNode = function (target, newData) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(target) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(newData)) {
            return;
        }
        var id;
        var isRefreshChild = false;
        if (this.dataType == 1 && newData.length > 1) {
            isRefreshChild = true;
        }
        else if (this.dataType == 2 && newData.length === 1) {
            var updatedChildValue = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.child.toString(), newData[0]);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(updatedChildValue)) {
                isRefreshChild = true;
            }
        }
        var liEle = this.getElement(target);
        id = liEle ? liEle.getAttribute('data-uid') : ((target) ? target.toString() : null);
        this.refreshData = this.getNodeObject(id);
        newData = JSON.parse(JSON.stringify(newData));
        /* eslint-disable */
        var newNodeData;
        var parentData;
        if (this.dataType == 1 && isRefreshChild) {
            for (var k = 0; k < newData.length; k++) {
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(newData[k][this.fields.parentID])) {
                    parentData = newData[k];
                    newData.splice(k, 1);
                    break;
                }
            }
            newNodeData = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, this.refreshData, parentData);
        }
        else {
            newNodeData = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, this.refreshData, newData[0]);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liEle)) {
            this.updatePosition(id, newNodeData, isRefreshChild, newData);
            return;
        }
        this.isRefreshed = true;
        var level = parseFloat(liEle.getAttribute('aria-level'));
        var newliEle = __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_lists__["a" /* ListBase */].createListItemFromJson(this.createElement, [newNodeData], this.listBaseOption, level);
        var ul = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PARENTITEM, liEle);
        var childItems = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(this.fields.child.toString(), newNodeData);
        if ((isRefreshChild && ul) || (isRefreshChild && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(childItems))) {
            var parentEle = liEle.parentElement;
            var index = Array.prototype.indexOf.call(parentEle.childNodes, liEle);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(liEle);
            parentEle.insertBefore(newliEle[0], parentEle.childNodes[index]);
            this.updatePosition(id, newNodeData, isRefreshChild, newData);
            if (isRefreshChild && ul) {
                this.expandAll([id]);
            }
        }
        else {
            var txtEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + TEXTWRAP, liEle);
            var newTextEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + TEXTWRAP, newliEle[0]);
            var icon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('div.' + ICON, txtEle);
            var newIcon = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('div.' + ICON, newTextEle);
            if (icon && newIcon) {
                if (newIcon.classList.contains(EXPANDABLE) && icon.classList.contains(COLLAPSIBLE)) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([newIcon], EXPANDABLE);
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([newIcon], COLLAPSIBLE);
                }
                else if (newIcon.classList.contains(COLLAPSIBLE) && icon.classList.contains(EXPANDABLE)) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([newIcon], COLLAPSIBLE);
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([newIcon], EXPANDABLE);
                }
                else if (icon.classList.contains('interaction')) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([newIcon], 'interaction');
                }
            }
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(txtEle);
            var fullEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + FULLROW, liEle);
            fullEle.parentNode.insertBefore(newTextEle, fullEle.nextSibling);
            this.updatePosition(id, newNodeData, isRefreshChild, newData);
        }
        liEle = this.getElement(target);
        if (newNodeData[this.fields.tooltip]) {
            liEle.setAttribute("title", newNodeData[this.fields.tooltip]);
        }
        if (newNodeData.hasOwnProperty(this.fields.htmlAttributes) && newNodeData[this.fields.htmlAttributes]) {
            var attr = {};
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["V" /* merge */])(attr, newNodeData[this.fields.htmlAttributes]);
            if (attr.class) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([liEle], attr.class.split(' '));
                delete attr.class;
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(liEle, attr);
            }
        }
        if (this.selectedNodes.indexOf(id) !== -1) {
            liEle.setAttribute('aria-selected', 'true');
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([liEle], ACTIVE);
        }
        this.isRefreshed = false;
        this.triggerEvent();
    };
    /**
     * Removes the collection of TreeView nodes by passing the array of node details as argument to this method.
     * @param  {string[] | Element[]} nodes - Specifies the array of TreeView nodes ID/array of TreeView node.
     */
    TreeView.prototype.removeNodes = function (nodes) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(nodes)) {
            if (this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] && !this.isOffline) {
                this.crudOperation('delete', nodes);
            }
            else {
                this.deleteSuccess(nodes);
            }
        }
    };
    /**
     * Replaces the text of the TreeView node with the given text.
     * @param  {string | Element} target - Specifies ID of TreeView node/TreeView node as target element.
     * @param  {string} newText - Specifies the new text of TreeView node.
     */
    TreeView.prototype.updateNode = function (target, newText) {
        var _this = this;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(target) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(newText) || !this.allowEditing) {
            return;
        }
        var liEle = this.getElement(target);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liEle)) {
            return;
        }
        var txtEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + LISTTEXT, liEle);
        this.updateOldText(liEle);
        var eventArgs = this.getEditEvent(liEle, null, null);
        this.trigger('nodeEditing', eventArgs, function (observedArgs) {
            if (!observedArgs.cancel) {
                if (_this.fields.dataSource instanceof __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_data__["a" /* DataManager */] && !_this.isOffline) {
                    _this.crudOperation('update', null, target, newText, null, null, false);
                }
                else {
                    _this.appendNewText(liEle, txtEle, newText, false);
                }
            }
        });
    };
    /**
     * Unchecks all the checked nodes. You can also uncheck the specific nodes by passing array of checked nodes
     * as argument to this method.
     * @param  {string[] | Element[]} nodes - Specifies the array of TreeView nodes ID/array of TreeView node.
     */
    TreeView.prototype.uncheckAll = function (nodes) {
        if (this.showCheckBox) {
            this.doCheckBoxAction(nodes, false);
        }
    };
    var TreeView_1;
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], TreeView.prototype, "allowDragAndDrop", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], TreeView.prototype, "allowEditing", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], TreeView.prototype, "allowMultiSelection", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], TreeView.prototype, "allowTextWrap", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({}, NodeAnimationSettings)
    ], TreeView.prototype, "animation", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], TreeView.prototype, "checkedNodes", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], TreeView.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], TreeView.prototype, "disabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], TreeView.prototype, "dragArea", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], TreeView.prototype, "enableHtmlSanitizer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], TreeView.prototype, "enablePersistence", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], TreeView.prototype, "expandedNodes", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Auto')
    ], TreeView.prototype, "expandOn", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({}, FieldsSettings)
    ], TreeView.prototype, "fields", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], TreeView.prototype, "fullRowSelect", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], TreeView.prototype, "loadOnDemand", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], TreeView.prototype, "locale", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], TreeView.prototype, "nodeTemplate", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], TreeView.prototype, "selectedNodes", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('None')
    ], TreeView.prototype, "sortOrder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], TreeView.prototype, "showCheckBox", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], TreeView.prototype, "autoCheck", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], TreeView.prototype, "fullRowNavigable", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "actionFailure", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "dataBound", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "dataSourceChanged", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "drawNode", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "destroyed", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "keyPress", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "nodeChecked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "nodeChecking", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "nodeClicked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "nodeCollapsed", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "nodeCollapsing", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "nodeDragging", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "nodeDragStart", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "nodeDragStop", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "nodeDropped", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "nodeEdited", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "nodeEditing", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "nodeExpanded", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "nodeExpanding", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "nodeSelected", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TreeView.prototype, "nodeSelecting", void 0);
    TreeView = TreeView_1 = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], TreeView);
    return TreeView;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index__ = __webpack_require__(256);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["a"]; });
/**
 * index
 */



/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__numerictextbox_index__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__maskedtextbox_index__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__input_index__ = __webpack_require__(87);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__input_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slider_index__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_validator_index__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__uploader_index__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__color_picker_index__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__textbox_index__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__signature_index__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_index__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/**
 * NumericTextBox all modules
 */












/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NumericTextBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input_input__ = __webpack_require__(22);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var ROOT = 'e-control-wrapper e-numeric';
var SPINICON = 'e-input-group-icon';
var SPINUP = 'e-spin-up';
var SPINDOWN = 'e-spin-down';
var ERROR = 'e-error';
var INCREMENT = 'increment';
var DECREMENT = 'decrement';
var INTREGEXP = new RegExp('^(-)?(\\d*)$');
var DECIMALSEPARATOR = '.';
var COMPONENT = 'e-numerictextbox';
var CONTROL = 'e-control';
var NUMERIC_FOCUS = 'e-input-focus';
var HIDDENELEMENT = 'e-numeric-hidden';
var wrapperAttributes = ['title', 'style', 'class'];
/**
 * Represents the NumericTextBox component that allows the user to enter only numeric values.
 * ```html
 * <input type='text' id="numeric"/>
 * ```
 * ```typescript
 * <script>
 *   var numericObj = new NumericTextBox({ value: 10 });
 *   numericObj.appendTo("#numeric");
 * </script>
 * ```
 */
var NumericTextBox = /** @class */ (function (_super) {
    __extends(NumericTextBox, _super);
    /**
     *
     * @param {NumericTextBoxModel} options - Specifies the NumericTextBox model.
     * @param {string | HTMLInputElement} element - Specifies the element to render as component.
     * @private
     */
    function NumericTextBox(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.isVue = false;
        _this.preventChange = false;
        _this.isAngular = false;
        _this.isDynamicChange = false;
        _this.numericOptions = options;
        return _this;
    }
    NumericTextBox.prototype.preRender = function () {
        this.isPrevFocused = false;
        this.decimalSeparator = '.';
        // eslint-disable-next-line no-useless-escape
        this.intRegExp = new RegExp('/^(-)?(\d*)$/');
        this.isCalled = false;
        var ejInstance = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('ej2_instances', this.element);
        this.cloneElement = this.element.cloneNode(true);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.cloneElement], [CONTROL, COMPONENT, 'e-lib']);
        this.angularTagName = null;
        this.formEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, 'form');
        if (this.element.tagName === 'EJS-NUMERICTEXTBOX') {
            this.angularTagName = this.element.tagName;
            var input = this.createElement('input');
            var index = 0;
            for (index; index < this.element.attributes.length; index++) {
                var attributeName = this.element.attributes[index].nodeName;
                if (attributeName !== 'id') {
                    input.setAttribute(this.element.attributes[index].nodeName, this.element.attributes[index].nodeValue);
                    input.innerHTML = this.element.innerHTML;
                }
            }
            if (this.element.hasAttribute('name')) {
                this.element.removeAttribute('name');
            }
            this.element.classList.remove('e-control', 'e-numerictextbox');
            this.element.appendChild(input);
            this.element = input;
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])('ej2_instances', ejInstance, this.element);
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'role': 'spinbutton', 'tabindex': '0', 'autocomplete': 'off', 'aria-live': 'assertive' });
        var localeText = {
            incrementTitle: 'Increment value', decrementTitle: 'Decrement value', placeholder: this.placeholder
        };
        this.l10n = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["o" /* L10n */]('numerictextbox', localeText, this.locale);
        if (this.l10n.getConstant('placeholder') !== '') {
            this.setProperties({ placeholder: this.placeholder || this.l10n.getConstant('placeholder') }, true);
        }
        this.isValidState = true;
        this.inputStyle = null;
        this.inputName = null;
        this.cultureInfo = {};
        this.initCultureInfo();
        this.initCultureFunc();
        this.prevValue = this.value;
        this.updateHTMLAttrToElement();
        this.checkAttributes(false);
        if (this.formEle) {
            this.inputEleValue = this.value;
        }
        this.validateMinMax();
        this.validateStep();
        if (this.placeholder === null) {
            this.updatePlaceholder();
        }
    };
    /**
     * To Initialize the control rendering
     *
     * @returns {void}
     * @private
     */
    NumericTextBox.prototype.render = function () {
        if (this.element.tagName.toLowerCase() === 'input') {
            this.createWrapper();
            if (this.showSpinButton) {
                this.spinBtnCreation();
            }
            this.setElementWidth(this.width);
            if (!this.container.classList.contains('e-input-group')) {
                this.container.classList.add('e-input-group');
            }
            this.changeValue(this.value === null || isNaN(this.value) ?
                null : this.strictMode ? this.trimValue(this.value) : this.value);
            this.wireEvents();
            if (this.value !== null && !isNaN(this.value)) {
                if (this.decimals) {
                    this.setProperties({ value: this.roundNumber(this.value, this.decimals) }, true);
                }
            }
            if (this.element.getAttribute('value') || this.value) {
                this.element.setAttribute('value', this.element.value);
                this.hiddenInput.setAttribute('value', this.hiddenInput.value);
            }
            this.elementPrevValue = this.element.value;
            if (this.element.hasAttribute('data-val')) {
                this.element.setAttribute('data-val', 'false');
            }
            this.renderComplete();
        }
    };
    NumericTextBox.prototype.checkAttributes = function (isDynamic) {
        var attributes = isDynamic ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.htmlAttributes) ? [] : Object.keys(this.htmlAttributes) :
            ['value', 'min', 'max', 'step', 'disabled', 'readonly', 'style', 'name', 'placeholder'];
        for (var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++) {
            var prop = attributes_1[_i];
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.getAttribute(prop))) {
                switch (prop) {
                    case 'disabled':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.numericOptions) || (this.numericOptions['enabled'] === undefined)) || isDynamic) {
                            var enabled = this.element.getAttribute(prop) === 'disabled' || this.element.getAttribute(prop) === ''
                                || this.element.getAttribute(prop) === 'true' ? false : true;
                            this.setProperties({ enabled: enabled }, !isDynamic);
                        }
                        break;
                    case 'readonly':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.numericOptions) || (this.numericOptions['readonly'] === undefined)) || isDynamic) {
                            var readonly = this.element.getAttribute(prop) === 'readonly' || this.element.getAttribute(prop) === ''
                                || this.element.getAttribute(prop) === 'true' ? true : false;
                            this.setProperties({ readonly: readonly }, !isDynamic);
                        }
                        break;
                    case 'placeholder':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.numericOptions) || (this.numericOptions['placeholder'] === undefined)) || isDynamic) {
                            this.setProperties({ placeholder: this.element.placeholder }, !isDynamic);
                        }
                        break;
                    case 'value':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.numericOptions) || (this.numericOptions['value'] === undefined)) || isDynamic) {
                            var setNumber = this.instance.getNumberParser({ format: 'n' })(this.element.getAttribute(prop));
                            this.setProperties(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])(prop, setNumber, {}), !isDynamic);
                        }
                        break;
                    case 'min':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.numericOptions) || (this.numericOptions['min'] === undefined)) || isDynamic) {
                            var minValue = this.instance.getNumberParser({ format: 'n' })(this.element.getAttribute(prop));
                            if (minValue !== null && !isNaN(minValue)) {
                                this.setProperties(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])(prop, minValue, {}), !isDynamic);
                            }
                        }
                        break;
                    case 'max':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.numericOptions) || (this.numericOptions['max'] === undefined)) || isDynamic) {
                            var maxValue = this.instance.getNumberParser({ format: 'n' })(this.element.getAttribute(prop));
                            if (maxValue !== null && !isNaN(maxValue)) {
                                this.setProperties(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])(prop, maxValue, {}), !isDynamic);
                            }
                        }
                        break;
                    case 'step':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.numericOptions) || (this.numericOptions['step'] === undefined)) || isDynamic) {
                            var stepValue = this.instance.getNumberParser({ format: 'n' })(this.element.getAttribute(prop));
                            if (stepValue !== null && !isNaN(stepValue)) {
                                this.setProperties(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])(prop, stepValue, {}), !isDynamic);
                            }
                        }
                        break;
                    case 'style':
                        this.inputStyle = this.element.getAttribute(prop);
                        break;
                    case 'name':
                        this.inputName = this.element.getAttribute(prop);
                        break;
                    default:
                        {
                            var value = this.instance.getNumberParser({ format: 'n' })(this.element.getAttribute(prop));
                            if ((value !== null && !isNaN(value)) || (prop === 'value')) {
                                this.setProperties(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])(prop, value, {}), true);
                            }
                        }
                        break;
                }
            }
        }
    };
    NumericTextBox.prototype.updatePlaceholder = function () {
        this.setProperties({ placeholder: this.l10n.getConstant('placeholder') }, true);
    };
    NumericTextBox.prototype.initCultureFunc = function () {
        this.instance = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["m" /* Internationalization */](this.locale);
    };
    NumericTextBox.prototype.initCultureInfo = function () {
        this.cultureInfo.format = this.format;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('currency', this) !== null) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])('currency', this.currency, this.cultureInfo);
            this.setProperties({ currencyCode: this.currency }, true);
        }
    };
    /* Wrapper creation */
    NumericTextBox.prototype.createWrapper = function () {
        var updatedCssClassValue = this.cssClass;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.cssClass) && this.cssClass !== '') {
            updatedCssClassValue = this.getNumericValidClassList(this.cssClass);
        }
        var inputObj = __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].createInput({
            element: this.element,
            floatLabelType: this.floatLabelType,
            properties: {
                readonly: this.readonly,
                placeholder: this.placeholder,
                cssClass: updatedCssClassValue,
                enableRtl: this.enableRtl,
                showClearButton: this.showClearButton,
                enabled: this.enabled
            }
        }, this.createElement);
        this.inputWrapper = inputObj;
        this.container = inputObj.container;
        this.container.setAttribute('class', ROOT + ' ' + this.container.getAttribute('class'));
        this.updateHTMLAttrToWrapper();
        if (this.readonly) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'aria-readonly': 'true' });
        }
        this.hiddenInput = (this.createElement('input', { attrs: { type: 'text',
                'validateHidden': 'true', 'class': HIDDENELEMENT } }));
        this.inputName = this.inputName !== null ? this.inputName : this.element.id;
        this.element.removeAttribute('name');
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.hiddenInput, { 'name': this.inputName });
        this.container.insertBefore(this.hiddenInput, this.container.childNodes[1]);
        this.updateDataAttribute(false);
        if (this.inputStyle !== null) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.container, { 'style': this.inputStyle });
        }
    };
    NumericTextBox.prototype.updateDataAttribute = function (isDynamic) {
        var attr = {};
        if (!isDynamic) {
            for (var a = 0; a < this.element.attributes.length; a++) {
                attr[this.element.attributes[a].name] = this.element.getAttribute(this.element.attributes[a].name);
            }
        }
        else {
            attr = this.htmlAttributes;
        }
        for (var _i = 0, _a = Object.keys(attr); _i < _a.length; _i++) {
            var key = _a[_i];
            if (key.indexOf('data') === 0) {
                this.hiddenInput.setAttribute(key, attr[key]);
            }
        }
    };
    NumericTextBox.prototype.updateHTMLAttrToElement = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.htmlAttributes)) {
            for (var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++) {
                var pro = _a[_i];
                if (wrapperAttributes.indexOf(pro) < 0) {
                    this.element.setAttribute(pro, this.htmlAttributes[pro]);
                }
            }
        }
    };
    NumericTextBox.prototype.updateCssClass = function (newClass, oldClass) {
        __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setCssClass(this.getNumericValidClassList(newClass), [this.container], this.getNumericValidClassList(oldClass));
    };
    NumericTextBox.prototype.getNumericValidClassList = function (numericClassName) {
        var result = numericClassName;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(numericClassName) && numericClassName !== '') {
            result = (numericClassName.replace(/\s+/g, ' ')).trim();
        }
        return result;
    };
    NumericTextBox.prototype.updateHTMLAttrToWrapper = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.htmlAttributes)) {
            for (var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++) {
                var pro = _a[_i];
                if (wrapperAttributes.indexOf(pro) > -1) {
                    if (pro === 'class') {
                        var updatedClassValue = this.getNumericValidClassList(this.htmlAttributes[pro]);
                        if (updatedClassValue !== '') {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.container], updatedClassValue.split(' '));
                        }
                    }
                    else if (pro === 'style') {
                        var numericStyle = this.container.getAttribute(pro);
                        numericStyle = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(numericStyle) ? (numericStyle + this.htmlAttributes[pro]) :
                            this.htmlAttributes[pro];
                        this.container.setAttribute(pro, numericStyle);
                    }
                    else {
                        this.container.setAttribute(pro, this.htmlAttributes[pro]);
                    }
                }
            }
        }
    };
    NumericTextBox.prototype.setElementWidth = function (width) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(width)) {
            if (typeof width === 'number') {
                this.container.style.width = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(width);
            }
            else if (typeof width === 'string') {
                this.container.style.width = (width.match(/px|%|em/)) ? (width) : (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(width));
            }
        }
    };
    /* Spinner creation */
    NumericTextBox.prototype.spinBtnCreation = function () {
        this.spinDown = __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].appendSpan(SPINICON + ' ' + SPINDOWN, this.container, this.createElement);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.spinDown, {
            'title': this.l10n.getConstant('decrementTitle'),
            'aria-label': this.l10n.getConstant('decrementTitle')
        });
        this.spinUp = __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].appendSpan(SPINICON + ' ' + SPINUP, this.container, this.createElement);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.spinUp, {
            'title': this.l10n.getConstant('incrementTitle'),
            'aria-label': this.l10n.getConstant('incrementTitle')
        });
        this.wireSpinBtnEvents();
    };
    NumericTextBox.prototype.validateMinMax = function () {
        if (!(typeof (this.min) === 'number' && !isNaN(this.min))) {
            this.setProperties({ min: -(Number.MAX_VALUE) }, true);
        }
        if (!(typeof (this.max) === 'number' && !isNaN(this.max))) {
            this.setProperties({ max: Number.MAX_VALUE }, true);
        }
        if (this.decimals !== null) {
            if (this.min !== -(Number.MAX_VALUE)) {
                this.setProperties({ min: this.instance.getNumberParser({ format: 'n' })(this.formattedValue(this.decimals, this.min)) }, true);
            }
            if (this.max !== (Number.MAX_VALUE)) {
                this.setProperties({ max: this.instance.getNumberParser({ format: 'n' })(this.formattedValue(this.decimals, this.max)) }, true);
            }
        }
        this.setProperties({ min: this.min > this.max ? this.max : this.min }, true);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'aria-valuemin': this.min.toString(), 'aria-valuemax': this.max.toString() });
    };
    NumericTextBox.prototype.formattedValue = function (decimals, value) {
        return this.instance.getNumberFormat({
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals, useGrouping: false
        })(value);
    };
    NumericTextBox.prototype.validateStep = function () {
        if (this.decimals !== null) {
            this.setProperties({ step: this.instance.getNumberParser({ format: 'n' })(this.formattedValue(this.decimals, this.step)) }, true);
        }
    };
    NumericTextBox.prototype.action = function (operation, event) {
        this.isInteract = true;
        var value = this.isFocused ? this.instance.getNumberParser({ format: 'n' })(this.element.value) : this.value;
        this.changeValue(this.performAction(value, this.step, operation));
        this.raiseChangeEvent(event);
    };
    NumericTextBox.prototype.checkErrorClass = function () {
        if (this.isValidState) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.container], ERROR);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.container], ERROR);
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'aria-invalid': this.isValidState ? 'false' : 'true' });
    };
    NumericTextBox.prototype.bindClearEvent = function () {
        if (this.showClearButton) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.inputWrapper.clearButton, 'mousedown touchstart', this.resetHandler, this);
        }
    };
    NumericTextBox.prototype.resetHandler = function (e) {
        e.preventDefault();
        if (!(this.inputWrapper.clearButton.classList.contains('e-clear-icon-hide')) || this.inputWrapper.container.classList.contains('e-static-clear')) {
            this.clear(e);
        }
        this.isInteract = true;
        this.raiseChangeEvent(e);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    NumericTextBox.prototype.clear = function (event) {
        this.setProperties({ value: null }, true);
        this.setElementValue('');
        this.hiddenInput.value = '';
        var formElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, 'form');
        if (formElement) {
            var element = this.element.nextElementSibling;
            var keyupEvent = document.createEvent('KeyboardEvent');
            keyupEvent.initEvent('keyup', false, true);
            element.dispatchEvent(keyupEvent);
        }
    };
    NumericTextBox.prototype.resetFormHandler = function () {
        if (this.element.tagName === 'EJS-NUMERICTEXTBOX') {
            this.updateValue(null);
        }
        else {
            this.updateValue(this.inputEleValue);
        }
    };
    NumericTextBox.prototype.setSpinButton = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.spinDown)) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.spinDown, {
                'title': this.l10n.getConstant('decrementTitle'),
                'aria-label': this.l10n.getConstant('decrementTitle')
            });
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.spinUp)) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.spinUp, {
                'title': this.l10n.getConstant('incrementTitle'),
                'aria-label': this.l10n.getConstant('incrementTitle')
            });
        }
    };
    NumericTextBox.prototype.wireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'focus', this.focusHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'blur', this.focusOutHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'keydown', this.keyDownHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'keyup', this.keyUpHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'input', this.inputHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'keypress', this.keyPressHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'change', this.changeHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'paste', this.pasteHandler, this);
        if (this.enabled) {
            this.bindClearEvent();
            if (this.formEle) {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.formEle, 'reset', this.resetFormHandler, this);
            }
        }
    };
    NumericTextBox.prototype.wireSpinBtnEvents = function () {
        /* bind spin button events */
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.spinUp, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].touchStartEvent, this.mouseDownOnSpinner, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.spinDown, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].touchStartEvent, this.mouseDownOnSpinner, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.spinUp, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].touchEndEvent, this.mouseUpOnSpinner, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.spinDown, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].touchEndEvent, this.mouseUpOnSpinner, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.spinUp, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].touchMoveEvent, this.touchMoveOnSpinner, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.spinDown, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].touchMoveEvent, this.touchMoveOnSpinner, this);
    };
    NumericTextBox.prototype.unwireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'focus', this.focusHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'blur', this.focusOutHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'keyup', this.keyUpHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'input', this.inputHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'keydown', this.keyDownHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'keypress', this.keyPressHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'change', this.changeHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'paste', this.pasteHandler);
        if (this.formEle) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.formEle, 'reset', this.resetFormHandler);
        }
    };
    NumericTextBox.prototype.unwireSpinBtnEvents = function () {
        /* unbind spin button events */
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.spinUp, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].touchStartEvent, this.mouseDownOnSpinner);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.spinDown, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].touchStartEvent, this.mouseDownOnSpinner);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.spinUp, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].touchEndEvent, this.mouseUpOnSpinner);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.spinDown, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].touchEndEvent, this.mouseUpOnSpinner);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.spinUp, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].touchMoveEvent, this.touchMoveOnSpinner);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.spinDown, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].touchMoveEvent, this.touchMoveOnSpinner);
    };
    NumericTextBox.prototype.changeHandler = function (event) {
        event.stopPropagation();
        if (!this.element.value.length) {
            this.setProperties({ value: null }, true);
        }
        var parsedInput = this.instance.getNumberParser({ format: 'n' })(this.element.value);
        this.updateValue(parsedInput, event);
    };
    NumericTextBox.prototype.raiseChangeEvent = function (event) {
        if (this.prevValue !== this.value) {
            var eventArgs = {};
            this.changeEventArgs = { value: this.value, previousValue: this.prevValue, isInteracted: this.isInteract,
                isInteraction: this.isInteract, event: event };
            if (event) {
                this.changeEventArgs.event = event;
            }
            if (this.changeEventArgs.event === undefined) {
                this.changeEventArgs.isInteracted = false;
                this.changeEventArgs.isInteraction = false;
            }
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["V" /* merge */])(eventArgs, this.changeEventArgs);
            this.prevValue = this.value;
            this.isInteract = false;
            this.elementPrevValue = this.element.value;
            this.preventChange = false;
            this.trigger('change', eventArgs);
        }
    };
    NumericTextBox.prototype.pasteHandler = function () {
        var _this = this;
        if (!this.enabled || this.readonly) {
            return;
        }
        var beforeUpdate = this.element.value;
        setTimeout(function () {
            if (!_this.numericRegex().test(_this.element.value)) {
                _this.setElementValue(beforeUpdate);
            }
        });
    };
    NumericTextBox.prototype.preventHandler = function () {
        var _this = this;
        var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        setTimeout(function () {
            if (_this.element.selectionStart > 0) {
                var currentPos = _this.element.selectionStart;
                var prevPos = _this.element.selectionStart - 1;
                var start = 0;
                var valArray = _this.element.value.split('');
                var numericObject = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["K" /* getNumericObject */])(_this.locale);
                var decimalSeparator = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('decimal', numericObject);
                var ignoreKeyCode = decimalSeparator.charCodeAt(0);
                if (_this.element.value[prevPos] === ' ' && _this.element.selectionStart > 0 && !iOS) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(_this.prevVal)) {
                        _this.element.value = _this.element.value.trim();
                    }
                    else if (prevPos !== 0) {
                        _this.element.value = _this.prevVal;
                    }
                    else if (prevPos === 0) {
                        _this.element.value = _this.element.value.trim();
                    }
                    _this.element.setSelectionRange(prevPos, prevPos);
                }
                else if (isNaN(parseFloat(_this.element.value[_this.element.selectionStart - 1])) &&
                    _this.element.value[_this.element.selectionStart - 1].charCodeAt(0) !== 45) {
                    if ((valArray.indexOf(_this.element.value[_this.element.selectionStart - 1]) !==
                        valArray.lastIndexOf(_this.element.value[_this.element.selectionStart - 1]) &&
                        _this.element.value[_this.element.selectionStart - 1].charCodeAt(0) === ignoreKeyCode) ||
                        _this.element.value[_this.element.selectionStart - 1].charCodeAt(0) !== ignoreKeyCode) {
                        _this.element.value = _this.element.value.substring(0, prevPos) +
                            _this.element.value.substring(currentPos, _this.element.value.length);
                        _this.element.setSelectionRange(prevPos, prevPos);
                        if (isNaN(parseFloat(_this.element.value[_this.element.selectionStart - 1])) && _this.element.selectionStart > 0
                            && _this.element.value.length) {
                            _this.preventHandler();
                        }
                    }
                }
                else if (isNaN(parseFloat(_this.element.value[_this.element.selectionStart - 2])) && _this.element.selectionStart > 1 &&
                    _this.element.value[_this.element.selectionStart - 2].charCodeAt(0) !== 45) {
                    if ((valArray.indexOf(_this.element.value[_this.element.selectionStart - 2]) !==
                        valArray.lastIndexOf(_this.element.value[_this.element.selectionStart - 2]) &&
                        _this.element.value[_this.element.selectionStart - 2].charCodeAt(0) === ignoreKeyCode) ||
                        _this.element.value[_this.element.selectionStart - 2].charCodeAt(0) !== ignoreKeyCode) {
                        _this.element.setSelectionRange(prevPos, prevPos);
                        _this.nextEle = _this.element.value[_this.element.selectionStart];
                        _this.cursorPosChanged = true;
                        _this.preventHandler();
                    }
                }
                if (_this.cursorPosChanged === true && _this.element.value[_this.element.selectionStart] === _this.nextEle &&
                    isNaN(parseFloat(_this.element.value[_this.element.selectionStart - 1]))) {
                    _this.element.setSelectionRange(_this.element.selectionStart + 1, _this.element.selectionStart + 1);
                    _this.cursorPosChanged = false;
                    _this.nextEle = null;
                }
                if (_this.element.value.trim() === '') {
                    _this.element.setSelectionRange(start, start);
                }
                if (_this.element.selectionStart > 0) {
                    if ((_this.element.value[_this.element.selectionStart - 1].charCodeAt(0) === 45) && _this.element.selectionStart > 1) {
                        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(_this.prevVal)) {
                            // eslint-disable-next-line no-self-assign
                            _this.element.value = _this.element.value;
                        }
                        else {
                            _this.element.value = _this.prevVal;
                        }
                        _this.element.setSelectionRange(_this.element.selectionStart, _this.element.selectionStart);
                    }
                    if (_this.element.value[_this.element.selectionStart - 1] === decimalSeparator && _this.decimals === 0 && _this.validateDecimalOnType) {
                        _this.element.value = _this.element.value.substring(0, prevPos) +
                            _this.element.value.substring(currentPos, _this.element.value.length);
                    }
                }
                _this.prevVal = _this.element.value;
            }
        });
    };
    NumericTextBox.prototype.keyUpHandler = function () {
        if (!this.enabled || this.readonly) {
            return;
        }
        var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        if (!iOS && __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
            this.preventHandler();
        }
        var parseValue = this.instance.getNumberParser({ format: 'n' })(this.element.value);
        parseValue = parseValue === null || isNaN(parseValue) ? null : parseValue;
        this.hiddenInput.value = parseValue || parseValue === 0 ? parseValue.toString() : null;
        var formElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, 'form');
        if (formElement) {
            var element = this.element.nextElementSibling;
            var keyupEvent = document.createEvent('KeyboardEvent');
            keyupEvent.initEvent('keyup', false, true);
            element.dispatchEvent(keyupEvent);
        }
    };
    NumericTextBox.prototype.inputHandler = function (event) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-this-alias
        var numerictextboxObj = this;
        if (!this.enabled || this.readonly) {
            return;
        }
        var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        var fireFox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        if ((fireFox || iOS) && __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
            this.preventHandler();
        }
        /* istanbul ignore next */
        if (this.isAngular
            && this.element.value !== Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('decimal', Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["K" /* getNumericObject */])(this.locale))
            && this.element.value !== Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('minusSign', Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["K" /* getNumericObject */])(this.locale))) {
            var parsedValue = this.instance.getNumberParser({ format: 'n' })(this.element.value);
            parsedValue = isNaN(parsedValue) ? null : parsedValue;
            numerictextboxObj.localChange({ value: parsedValue });
            this.preventChange = true;
        }
        if (this.isVue) {
            var current = this.instance.getNumberParser({ format: 'n' })(this.element.value);
            var previous = this.instance.getNumberParser({ format: 'n' })(this.elementPrevValue);
            //EJ2-54963-if type "." or ".0" or "-.0" it converts to "0" automatically when binding v-model
            var nonZeroRegex = new RegExp('[^1-9]+$');
            if (nonZeroRegex.test(this.element.value)) {
                current = this.value;
            }
            var eventArgs = {
                event: event,
                value: (current === null || isNaN(current) ? null : current),
                previousValue: (previous === null || isNaN(previous) ? null : previous)
            };
            this.preventChange = true;
            this.elementPrevValue = this.element.value;
            this.trigger('input', eventArgs);
        }
    };
    NumericTextBox.prototype.keyDownHandler = function (event) {
        if (!this.readonly) {
            switch (event.keyCode) {
                case 38:
                    event.preventDefault();
                    this.action(INCREMENT, event);
                    break;
                case 40:
                    event.preventDefault();
                    this.action(DECREMENT, event);
                    break;
                default: break;
            }
        }
    };
    NumericTextBox.prototype.performAction = function (value, step, operation) {
        if (value === null || isNaN(value)) {
            value = 0;
        }
        var updatedValue = operation === INCREMENT ? value + step : value - step;
        updatedValue = this.correctRounding(value, step, updatedValue);
        return this.strictMode ? this.trimValue(updatedValue) : updatedValue;
    };
    NumericTextBox.prototype.correctRounding = function (value, step, result) {
        var floatExp = new RegExp('[,.](.*)');
        var floatValue = floatExp.test(value.toString());
        var floatStep = floatExp.test(step.toString());
        if (floatValue || floatStep) {
            var valueCount = floatValue ? floatExp.exec(value.toString())[0].length : 0;
            var stepCount = floatStep ? floatExp.exec(step.toString())[0].length : 0;
            var max = Math.max(valueCount, stepCount);
            return value = this.roundValue(result, max);
        }
        return result;
    };
    NumericTextBox.prototype.roundValue = function (result, precision) {
        precision = precision || 0;
        var divide = Math.pow(10, precision);
        return result *= divide, result = Math.round(result) / divide;
    };
    NumericTextBox.prototype.updateValue = function (value, event) {
        if (event) {
            this.isInteract = true;
        }
        if (value !== null && !isNaN(value)) {
            if (this.decimals) {
                value = this.roundNumber(value, this.decimals);
            }
        }
        this.changeValue(value === null || isNaN(value) ? null : this.strictMode ? this.trimValue(value) : value);
        /* istanbul ignore next */
        if (!this.isDynamicChange) {
            this.raiseChangeEvent(event);
        }
    };
    NumericTextBox.prototype.updateCurrency = function (prop, propVal) {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])(prop, propVal, this.cultureInfo);
        this.updateValue(this.value);
    };
    NumericTextBox.prototype.changeValue = function (value) {
        if (!(value || value === 0)) {
            value = null;
            this.setProperties({ value: value }, true);
        }
        else {
            var numberOfDecimals = this.getNumberOfDecimals(value);
            this.setProperties({ value: this.roundNumber(value, numberOfDecimals) }, true);
        }
        this.modifyText();
        if (!this.strictMode) {
            this.validateState();
        }
    };
    NumericTextBox.prototype.modifyText = function () {
        if (this.value || this.value === 0) {
            var value = this.formatNumber();
            var elementValue = this.isFocused ? value : this.instance.getNumberFormat(this.cultureInfo)(this.value);
            this.setElementValue(elementValue);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'aria-valuenow': value });
            this.hiddenInput.value = this.value.toString();
            if (this.value !== null && this.serverDecimalSeparator) {
                this.hiddenInput.value = this.hiddenInput.value.replace('.', this.serverDecimalSeparator);
            }
        }
        else {
            this.setElementValue('');
            this.element.removeAttribute('aria-valuenow');
            this.hiddenInput.value = null;
        }
    };
    NumericTextBox.prototype.setElementValue = function (val, element) {
        __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setValue(val, (element ? element : this.element), this.floatLabelType, this.showClearButton);
    };
    NumericTextBox.prototype.validateState = function () {
        this.isValidState = true;
        if (this.value || this.value === 0) {
            this.isValidState = !(this.value > this.max || this.value < this.min);
        }
        this.checkErrorClass();
    };
    NumericTextBox.prototype.getNumberOfDecimals = function (value) {
        var numberOfDecimals;
        // eslint-disable-next-line no-useless-escape
        var EXPREGEXP = new RegExp('[eE][\-+]?([0-9]+)');
        var valueString = value.toString();
        if (EXPREGEXP.test(valueString)) {
            var result = EXPREGEXP.exec(valueString);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(result)) {
                valueString = value.toFixed(Math.min(parseInt(result[1], 10), 20));
            }
        }
        var decimalPart = valueString.split('.')[1];
        numberOfDecimals = !decimalPart || !decimalPart.length ? 0 : decimalPart.length;
        if (this.decimals !== null) {
            numberOfDecimals = numberOfDecimals < this.decimals ? numberOfDecimals : this.decimals;
        }
        return numberOfDecimals;
    };
    NumericTextBox.prototype.formatNumber = function () {
        var numberOfDecimals = this.getNumberOfDecimals(this.value);
        return this.instance.getNumberFormat({
            maximumFractionDigits: numberOfDecimals,
            minimumFractionDigits: numberOfDecimals, useGrouping: false
        })(this.value);
    };
    NumericTextBox.prototype.trimValue = function (value) {
        if (value > this.max) {
            return this.max;
        }
        if (value < this.min) {
            return this.min;
        }
        return value;
    };
    NumericTextBox.prototype.roundNumber = function (value, precision) {
        var result = value;
        var decimals = precision || 0;
        var result1 = result.toString().split('e');
        result = Math.round(Number(result1[0] + 'e' + (result1[1] ? (Number(result1[1]) + decimals) : decimals)));
        var result2 = result.toString().split('e');
        result = Number(result2[0] + 'e' + (result2[1] ? (Number(result2[1]) - decimals) : -decimals));
        return Number(result.toFixed(decimals));
    };
    NumericTextBox.prototype.cancelEvent = function (event) {
        event.preventDefault();
        return false;
    };
    NumericTextBox.prototype.keyPressHandler = function (event) {
        if (!this.enabled || this.readonly) {
            return true;
        }
        if (!__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice && __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.version === '11.0' && event.keyCode === 13) {
            var parsedInput = this.instance.getNumberParser({ format: 'n' })(this.element.value);
            this.updateValue(parsedInput, event);
            return true;
        }
        if (event.which === 0 || event.metaKey || event.ctrlKey || event.keyCode === 8 || event.keyCode === 13) {
            return true;
        }
        var currentChar = String.fromCharCode(event.which);
        var text = this.element.value;
        text = text.substring(0, this.element.selectionStart) + currentChar + text.substring(this.element.selectionEnd);
        if (!this.numericRegex().test(text)) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        }
        else {
            return true;
        }
    };
    NumericTextBox.prototype.numericRegex = function () {
        var numericObject = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["K" /* getNumericObject */])(this.locale);
        var decimalSeparator = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('decimal', numericObject);
        var fractionRule = '*';
        if (decimalSeparator === DECIMALSEPARATOR) {
            decimalSeparator = '\\' + decimalSeparator;
        }
        if (this.decimals === 0 && this.validateDecimalOnType) {
            return INTREGEXP;
        }
        if (this.decimals && this.validateDecimalOnType) {
            fractionRule = '{0,' + this.decimals + '}';
        }
        return new RegExp('^(-)?(((\\d+(' + decimalSeparator + '\\d' + fractionRule +
            ')?)|(' + decimalSeparator + '\\d' + fractionRule + ')))?$');
    };
    NumericTextBox.prototype.mouseWheel = function (event) {
        event.preventDefault();
        var delta;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var rawEvent = event;
        if (rawEvent.wheelDelta) {
            delta = rawEvent.wheelDelta / 120;
        }
        else if (rawEvent.detail) {
            delta = -rawEvent.detail / 3;
        }
        if (delta > 0) {
            this.action(INCREMENT, event);
        }
        else if (delta < 0) {
            this.action(DECREMENT, event);
        }
        this.cancelEvent(event);
    };
    NumericTextBox.prototype.focusHandler = function (event) {
        var _this = this;
        this.focusEventArgs = { event: event, value: this.value, container: this.container };
        this.trigger('focus', this.focusEventArgs);
        if (!this.enabled || this.readonly) {
            return;
        }
        this.isFocused = true;
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.container], ERROR);
        this.prevValue = this.value;
        if ((this.value || this.value === 0)) {
            var formatValue_1 = this.formatNumber();
            this.setElementValue(formatValue_1);
            if (!this.isPrevFocused) {
                if (!__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice && __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.version === '11.0') {
                    this.element.setSelectionRange(0, formatValue_1.length);
                }
                else {
                    var delay = (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice && __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isIos) ? 600 : 0;
                    setTimeout(function () {
                        _this.element.setSelectionRange(0, formatValue_1.length);
                    }, delay);
                }
            }
        }
        if (!__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'mousewheel DOMMouseScroll', this.mouseWheel, this);
        }
    };
    NumericTextBox.prototype.focusOutHandler = function (event) {
        var _this = this;
        this.blurEventArgs = { event: event, value: this.value, container: this.container };
        this.trigger('blur', this.blurEventArgs);
        if (!this.enabled || this.readonly) {
            return;
        }
        if (this.isPrevFocused) {
            event.preventDefault();
            if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
                var value_1 = this.element.value;
                this.element.focus();
                this.isPrevFocused = false;
                var ele_1 = this.element;
                setTimeout(function () {
                    _this.setElementValue(value_1, ele_1);
                }, 200);
            }
        }
        else {
            this.isFocused = false;
            if (!this.element.value.length) {
                this.setProperties({ value: null }, true);
            }
            var parsedInput = this.instance.getNumberParser({ format: 'n' })(this.element.value);
            this.updateValue(parsedInput);
            if (!__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'mousewheel DOMMouseScroll', this.mouseWheel);
            }
        }
        var formElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, 'form');
        if (formElement) {
            var element = this.element.nextElementSibling;
            var focusEvent = document.createEvent('FocusEvent');
            focusEvent.initEvent('focusout', false, true);
            element.dispatchEvent(focusEvent);
        }
    };
    NumericTextBox.prototype.mouseDownOnSpinner = function (event) {
        var _this = this;
        if (this.isFocused) {
            this.isPrevFocused = true;
            event.preventDefault();
        }
        if (!this.getElementData(event)) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var result = this.getElementData(event);
        var target = event.currentTarget;
        var action = (target.classList.contains(SPINUP)) ? INCREMENT : DECREMENT;
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(target, 'mouseleave', this.mouseUpClick, this);
        this.timeOut = setInterval(function () {
            _this.isCalled = true;
            _this.action(action, event);
        }, 150);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'mouseup', this.mouseUpClick, this);
    };
    NumericTextBox.prototype.touchMoveOnSpinner = function (event) {
        var target;
        if (event.type === "touchmove") {
            var touchEvent = event.touches;
            target = touchEvent.length && document.elementFromPoint(touchEvent[0].pageX, touchEvent[0].pageY);
        }
        else {
            target = document.elementFromPoint(event.clientX, event.clientY);
        }
        if (!(target.classList.contains(SPINICON))) {
            clearInterval(this.timeOut);
        }
    };
    NumericTextBox.prototype.mouseUpOnSpinner = function (event) {
        this.prevValue = this.value;
        if (this.isPrevFocused) {
            this.element.focus();
            if (!__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
                this.isPrevFocused = false;
            }
        }
        if (!__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
            event.preventDefault();
        }
        if (!this.getElementData(event)) {
            return;
        }
        var target = event.currentTarget;
        var action = (target.classList.contains(SPINUP)) ? INCREMENT : DECREMENT;
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(target, 'mouseleave', this.mouseUpClick);
        if (!this.isCalled) {
            this.action(action, event);
        }
        this.isCalled = false;
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'mouseup', this.mouseUpClick);
        var formElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, 'form');
        if (formElement) {
            var element = this.element.nextElementSibling;
            var keyupEvent = document.createEvent('KeyboardEvent');
            keyupEvent.initEvent('keyup', false, true);
            element.dispatchEvent(keyupEvent);
        }
    };
    NumericTextBox.prototype.getElementData = function (event) {
        if ((event.which && event.which === 3) || (event.button && event.button === 2)
            || !this.enabled || this.readonly) {
            return false;
        }
        clearInterval(this.timeOut);
        return true;
    };
    NumericTextBox.prototype.floatLabelTypeUpdate = function () {
        __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].removeFloating(this.inputWrapper);
        var hiddenInput = this.hiddenInput;
        this.hiddenInput.remove();
        __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].addFloating(this.element, this.floatLabelType, this.placeholder, this.createElement);
        this.container.insertBefore(hiddenInput, this.container.childNodes[1]);
    };
    NumericTextBox.prototype.mouseUpClick = function (event) {
        event.stopPropagation();
        clearInterval(this.timeOut);
        this.isCalled = false;
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.spinUp, 'mouseleave', this.mouseUpClick);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.spinDown, 'mouseleave', this.mouseUpClick);
    };
    /**
     * Increments the NumericTextBox value with the specified step value.
     *
     * @param {number} step - Specifies the value used to increment the NumericTextBox value.
     * if its not given then numeric value will be incremented based on the step property value.
     * @returns {void}
     */
    NumericTextBox.prototype.increment = function (step) {
        if (step === void 0) { step = this.step; }
        this.isInteract = false;
        this.changeValue(this.performAction(this.value, step, INCREMENT));
        this.raiseChangeEvent();
    };
    /**
     * Decrements the NumericTextBox value with specified step value.
     *
     * @param {number} step - Specifies the value used to decrement the NumericTextBox value.
     * if its not given then numeric value will be decremented based on the step property value.
     * @returns {void}
     */
    NumericTextBox.prototype.decrement = function (step) {
        if (step === void 0) { step = this.step; }
        this.isInteract = false;
        this.changeValue(this.performAction(this.value, step, DECREMENT));
        this.raiseChangeEvent();
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers.
     * Also it maintains the initial input element from the DOM.
     *
     * @method destroy
     * @returns {void}
     */
    NumericTextBox.prototype.destroy = function () {
        this.unwireEvents();
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.hiddenInput);
        if (this.showSpinButton) {
            this.unwireSpinBtnEvents();
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.spinUp);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.spinDown);
        }
        var attrArray = ['aria-labelledby', 'role', 'autocomplete', 'aria-readonly',
            'autocorrect', 'aria-disabled', 'aria-placeholder', 'autocapitalize',
            'spellcheck', 'aria-autocomplete', 'tabindex', 'aria-valuemin',
            'aria-valuemax', 'aria-live', 'aria-valuenow', 'aria-invalid'];
        for (var i = 0; i < attrArray.length; i++) {
            this.element.removeAttribute(attrArray[i]);
        }
        this.element.classList.remove('e-input');
        this.container.insertAdjacentElement('afterend', this.element);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.container);
        _super.prototype.destroy.call(this);
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns */
    /**
     * Returns the value of NumericTextBox with the format applied to the NumericTextBox.
     *
     */
    NumericTextBox.prototype.getText = function () {
        return this.element.value;
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns */
    /**
     * Sets the focus to widget for interaction.
     *
     * @returns {void}
     */
    NumericTextBox.prototype.focusIn = function () {
        if (document.activeElement !== this.element && this.enabled) {
            this.element.focus();
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.container], [NUMERIC_FOCUS]);
        }
    };
    /**
     * Remove the focus from widget, if the widget is in focus state.
     *
     * @returns {void}
     */
    NumericTextBox.prototype.focusOut = function () {
        if (document.activeElement === this.element && this.enabled) {
            this.element.blur();
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.container], [NUMERIC_FOCUS]);
        }
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */
    /**
     * Gets the properties to be maintained in the persisted state.
     *
     * @returns {string}
     */
    NumericTextBox.prototype.getPersistData = function () {
        var keyEntity = ['value'];
        return this.addOnPersist(keyEntity);
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */
    /**
     * Calls internally if any of the property value is changed.
     *
     * @param {NumericTextBoxModel} newProp - Returns the dynamic property value of the component.
     * @param {NumericTextBoxModel} oldProp - Returns the previous property value of the component.
     * @returns {void}
     * @private
     */
    NumericTextBox.prototype.onPropertyChanged = function (newProp, oldProp) {
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'width':
                    this.setElementWidth(newProp.width);
                    break;
                case 'cssClass':
                    this.updateCssClass(newProp.cssClass, oldProp.cssClass);
                    break;
                case 'enabled':
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setEnabled(newProp.enabled, this.element);
                    break;
                case 'enableRtl':
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setEnableRtl(newProp.enableRtl, [this.container]);
                    break;
                case 'readonly':
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setReadonly(newProp.readonly, this.element);
                    if (this.readonly) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'aria-readonly': 'true' });
                    }
                    else {
                        this.element.removeAttribute('aria-readonly');
                    }
                    break;
                case 'htmlAttributes':
                    this.updateHTMLAttrToElement();
                    this.updateHTMLAttrToWrapper();
                    this.updateDataAttribute(true);
                    this.checkAttributes(true);
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].validateInputType(this.container, this.element);
                    break;
                case 'placeholder':
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setPlaceholder(newProp.placeholder, this.element);
                    break;
                case 'step':
                    this.step = newProp.step;
                    this.validateStep();
                    break;
                case 'showSpinButton':
                    this.updateSpinButton(newProp);
                    break;
                case 'showClearButton':
                    this.updateClearButton(newProp);
                    break;
                case 'floatLabelType':
                    this.floatLabelType = newProp.floatLabelType;
                    this.floatLabelTypeUpdate();
                    break;
                case 'value':
                    this.isDynamicChange = (this.isAngular || this.isVue) && this.preventChange;
                    this.updateValue(newProp.value);
                    if (this.isDynamicChange) {
                        this.preventChange = false;
                        this.isDynamicChange = false;
                    }
                    break;
                case 'min':
                case 'max':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])(prop, Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(prop, newProp), this);
                    this.validateMinMax();
                    this.updateValue(this.value);
                    break;
                case 'strictMode':
                    this.strictMode = newProp.strictMode;
                    this.updateValue(this.value);
                    this.validateState();
                    break;
                case 'locale':
                    this.initCultureFunc();
                    this.l10n.setLocale(this.locale);
                    this.setSpinButton();
                    this.updatePlaceholder();
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setPlaceholder(this.placeholder, this.element);
                    this.updateValue(this.value);
                    break;
                case 'currency':
                    {
                        var propVal = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(prop, newProp);
                        this.setProperties({ currencyCode: propVal }, true);
                        this.updateCurrency(prop, propVal);
                    }
                    break;
                case 'currencyCode':
                    {
                        var propValue = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(prop, newProp);
                        this.setProperties({ currency: propValue }, true);
                        this.updateCurrency('currency', propValue);
                    }
                    break;
                case 'format':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])(prop, Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])(prop, newProp), this);
                    this.initCultureInfo();
                    this.updateValue(this.value);
                    break;
                case 'decimals':
                    this.decimals = newProp.decimals;
                    this.updateValue(this.value);
            }
        }
    };
    NumericTextBox.prototype.updateClearButton = function (newProp) {
        __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setClearButton(newProp.showClearButton, this.element, this.inputWrapper, undefined, this.createElement);
        this.bindClearEvent();
    };
    NumericTextBox.prototype.updateSpinButton = function (newProp) {
        if (newProp.showSpinButton) {
            this.spinBtnCreation();
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.spinUp);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.spinDown);
        }
    };
    /**
     * Gets the component name
     *
     * @returns {string} Returns the component name.
     * @private
     */
    NumericTextBox.prototype.getModuleName = function () {
        return 'numerictextbox';
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], NumericTextBox.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], NumericTextBox.prototype, "value", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(-(Number.MAX_VALUE))
    ], NumericTextBox.prototype, "min", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(Number.MAX_VALUE)
    ], NumericTextBox.prototype, "max", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(1)
    ], NumericTextBox.prototype, "step", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], NumericTextBox.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], NumericTextBox.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])({})
    ], NumericTextBox.prototype, "htmlAttributes", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], NumericTextBox.prototype, "showSpinButton", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], NumericTextBox.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], NumericTextBox.prototype, "enabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], NumericTextBox.prototype, "showClearButton", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], NumericTextBox.prototype, "enablePersistence", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('n2')
    ], NumericTextBox.prototype, "format", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], NumericTextBox.prototype, "decimals", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], NumericTextBox.prototype, "currency", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], NumericTextBox.prototype, "currencyCode", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], NumericTextBox.prototype, "strictMode", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], NumericTextBox.prototype, "validateDecimalOnType", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Never')
    ], NumericTextBox.prototype, "floatLabelType", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], NumericTextBox.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], NumericTextBox.prototype, "destroyed", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], NumericTextBox.prototype, "change", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], NumericTextBox.prototype, "focus", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], NumericTextBox.prototype, "blur", void 0);
    NumericTextBox = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], NumericTextBox);
    return NumericTextBox;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_index__ = __webpack_require__(45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__maskedtextbox_index__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/**
 * MaskedTextbox modules
 */




/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return regularExpressions; });
/* harmony export (immutable) */ __webpack_exports__["c"] = createMask;
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMask;
/* harmony export (immutable) */ __webpack_exports__["j"] = wireEvents;
/* harmony export (immutable) */ __webpack_exports__["i"] = unwireEvents;
/* harmony export (immutable) */ __webpack_exports__["b"] = bindClearEvent;
/* harmony export (immutable) */ __webpack_exports__["h"] = unstrippedValue;
/* harmony export (immutable) */ __webpack_exports__["g"] = strippedValue;
/* unused harmony export maskInputMouseDownHandler */
/* unused harmony export maskInputMouseUpHandler */
/* unused harmony export maskInputFocusHandler */
/* unused harmony export triggerFocus */
/* unused harmony export maskInputBlurHandler */
/* unused harmony export maskInputDropHandler */
/* unused harmony export mobileRemoveFunction */
/* harmony export (immutable) */ __webpack_exports__["f"] = setMaskValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = setElementValue;
/* unused harmony export maskInput */
/* unused harmony export getVal */
/* unused harmony export getMaskedVal */
/* unused harmony export MaskUndo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input_input__ = __webpack_require__(22);
/* eslint-disable valid-jsdoc, jsdoc/require-jsdoc, jsdoc/require-returns, jsdoc/require-param */
/**
 * MaskedTextBox base module
 */


var ERROR = 'e-error';
var INPUTGROUP = 'e-input-group';
var FLOATINPUT = 'e-float-input';
var UTILMASK = 'e-utility-mask';
var TOPLABEL = 'e-label-top';
var BOTTOMLABEL = 'e-label-bottom';
/**
 * @hidden
 * Built-in masking elements collection.
 */
var regularExpressions = {
    '0': '[0-9]',
    '9': '[0-9 ]',
    '#': '[0-9 +-]',
    'L': '[A-Za-z]',
    '?': '[A-Za-z ]',
    '&': '[^\x7f ]+',
    'C': '[^\x7f]+',
    'A': '[A-Za-z0-9]',
    'a': '[A-Za-z0-9 ]'
};
/**
 * Generate required masking elements to the MaskedTextBox from user mask input.
 *
 * @hidden
 */
function createMask() {
    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, {
        'role': 'textbox', 'autocomplete': 'off', 'autocorrect': 'off', 'autocapitalize': 'off',
        'spellcheck': 'false', 'aria-live': 'assertive', 'aria-valuenow': ''
    });
    if (this.mask) {
        var splitMask = this.mask.split(']');
        for (var i = 0; i < splitMask.length; i++) {
            if (splitMask[i][splitMask[i].length - 1] === '\\') {
                splitMask[i] = splitMask[i] + ']';
                var splitInnerMask = splitMask[i].split('[');
                for (var j = 0; j < splitInnerMask.length; j++) {
                    if (splitInnerMask[j][splitInnerMask[j].length - 1] === '\\') {
                        splitInnerMask[j] = splitInnerMask[j] + '[';
                    }
                    pushIntoRegExpCollec.call(this, splitInnerMask[j]);
                }
            }
            else {
                var splitInnerMask = splitMask[i].split('[');
                if (splitInnerMask.length > 1) {
                    var chkSpace = false;
                    for (var j = 0; j < splitInnerMask.length; j++) {
                        if (splitInnerMask[j] === '\\') {
                            this.customRegExpCollec.push('[');
                            this.hiddenMask += splitInnerMask[j] + '[';
                        }
                        else if (splitInnerMask[j] === '') {
                            chkSpace = true;
                        }
                        else if ((splitInnerMask[j] !== '' && chkSpace) || j === splitInnerMask.length - 1) {
                            this.customRegExpCollec.push('[' + splitInnerMask[j] + ']');
                            this.hiddenMask += this.promptChar;
                            chkSpace = false;
                        }
                        else {
                            pushIntoRegExpCollec.call(this, splitInnerMask[j]);
                        }
                    }
                }
                else {
                    pushIntoRegExpCollec.call(this, splitInnerMask[0]);
                }
            }
        }
        this.escapeMaskValue = this.hiddenMask;
        this.promptMask = this.hiddenMask.replace(/[09?LCAa#&]/g, this.promptChar);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customCharacters)) {
            for (var i = 0; i < this.promptMask.length; i++) {
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customCharacters[this.promptMask[i]])) {
                    this.promptMask = this.promptMask.replace(new RegExp(this.promptMask[i], 'g'), this.promptChar);
                }
            }
        }
        var escapeNumber = 0;
        if (this.hiddenMask.match(new RegExp(/\\/))) {
            for (var i = 0; i < this.hiddenMask.length; i++) {
                var j = 0;
                if (i >= 1) {
                    j = i;
                }
                escapeNumber = this.hiddenMask.length - this.promptMask.length;
                j = j - escapeNumber;
                if ((i > 0 && this.hiddenMask[i - 1] !== '\\') && (this.hiddenMask[i] === '>' ||
                    this.hiddenMask[i] === '<' || this.hiddenMask[i] === '|')) {
                    this.promptMask = this.promptMask.substring(0, j) +
                        this.promptMask.substring((i + 1) - escapeNumber, this.promptMask.length);
                    this.escapeMaskValue = this.escapeMaskValue.substring(0, j) +
                        this.escapeMaskValue.substring((i + 1) - escapeNumber, this.escapeMaskValue.length);
                }
                if (this.hiddenMask[i] === '\\') {
                    this.promptMask = this.promptMask.substring(0, j) + this.hiddenMask[i + 1] +
                        this.promptMask.substring((i + 2) - escapeNumber, this.promptMask.length);
                    this.escapeMaskValue = this.escapeMaskValue.substring(0, j) + this.escapeMaskValue[i + 1] +
                        this.escapeMaskValue.substring((i + 2) - escapeNumber, this.escapeMaskValue.length);
                }
            }
        }
        else {
            this.promptMask = this.promptMask.replace(/[>|<]/g, '');
            this.escapeMaskValue = this.hiddenMask.replace(/[>|<]/g, '');
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'aria-invalid': 'false' });
    }
}
/**
 * Apply mask ability with masking elements to the MaskedTextBox.
 *
 * @hidden
 */
function applyMask() {
    setElementValue.call(this, this.promptMask);
    setMaskValue.call(this, this.value);
}
/**
 * To wire required events to the MaskedTextBox.
 *
 * @hidden
 */
function wireEvents() {
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'keydown', maskInputKeyDownHandler, this);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'keypress', maskInputKeyPressHandler, this);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'keyup', maskInputKeyUpHandler, this);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'input', maskInputHandler, this);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'focus', maskInputFocusHandler, this);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'blur', maskInputBlurHandler, this);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'paste', maskInputPasteHandler, this);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'cut', maskInputCutHandler, this);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'drop', maskInputDropHandler, this);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'mousedown', maskInputMouseDownHandler, this);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'mouseup', maskInputMouseUpHandler, this);
    if (this.enabled) {
        bindClearEvent.call(this);
        if (this.formElement) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.formElement, 'reset', resetFormHandler, this);
        }
    }
}
/**
 * To unwire events attached to the MaskedTextBox.
 *
 * @hidden
 */
function unwireEvents() {
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'keydown', maskInputKeyDownHandler);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'keypress', maskInputKeyPressHandler);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'keyup', maskInputKeyUpHandler);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'input', maskInputHandler);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'focus', maskInputFocusHandler);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'blur', maskInputBlurHandler);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'paste', maskInputPasteHandler);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'cut', maskInputCutHandler);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'mousedown', maskInputMouseDownHandler);
    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'mouseup', maskInputMouseUpHandler);
    if (this.formElement) {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.formElement, 'reset', resetFormHandler);
    }
}
/**
 * To bind required events to the MaskedTextBox clearButton.
 *
 * @hidden
 */
function bindClearEvent() {
    if (this.showClearButton) {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.inputObj.clearButton, 'mousedown touchstart', resetHandler, this);
    }
}
function resetHandler(e) {
    e.preventDefault();
    if (!this.inputObj.clearButton.classList.contains('e-clear-icon-hide') || (this.inputObj.container.classList.contains('e-static-clear'))) {
        clear.call(this, e);
        this.value = '';
    }
}
function clear(event) {
    var value = this.element.value;
    setElementValue.call(this, this.promptMask);
    this.redoCollec.unshift({
        value: this.promptMask, startIndex: this.element.selectionStart, endIndex: this.element.selectionEnd
    });
    triggerMaskChangeEvent.call(this, event, value);
    this.element.setSelectionRange(0, 0);
}
function resetFormHandler() {
    if (this.element.tagName === 'EJS-MASKEDTEXTBOX') {
        setElementValue.call(this, this.promptMask);
    }
    else {
        this.value = this.initInputValue;
    }
}
/**
 * To get masked value from the MaskedTextBox.
 *
 * @hidden
 */
function unstrippedValue(element) {
    return element.value;
}
/**
 * To extract raw value from the MaskedTextBox.
 *
 * @hidden
 */
function strippedValue(element, maskValues) {
    var value = '';
    var k = 0;
    var checkMask = false;
    var maskValue = (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(maskValues)) ? maskValues : (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(element) &&
        !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this)) ? element.value : maskValues;
    if (maskValue !== this.promptMask) {
        for (var i = 0; i < this.customRegExpCollec.length; i++) {
            if (checkMask) {
                checkMask = false;
            }
            if (this.customRegExpCollec[k] === '>' || this.customRegExpCollec[k] === '<' ||
                this.customRegExpCollec[k] === '|' || this.customRegExpCollec[k] === '\\') {
                --i;
                checkMask = true;
            }
            if (!checkMask) {
                if ((maskValue[i] !== this.promptChar) && (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customRegExpCollec[k]) &&
                    ((this._callPasteHandler || !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.regExpCollec[this.customRegExpCollec[k]])) ||
                        (this.customRegExpCollec[k].length > 2 && this.customRegExpCollec[k][0] === '[' &&
                            this.customRegExpCollec[k][this.customRegExpCollec[k].length - 1] === ']') ||
                        (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customCharacters) &&
                            (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customCharacters[this.customRegExpCollec[k]]))))) && (maskValue !== '')) {
                    value += maskValue[i];
                }
            }
            ++k;
        }
    }
    if (this.mask === null || this.mask === '' && this.value !== undefined) {
        value = maskValue;
    }
    return value;
}
function pushIntoRegExpCollec(value) {
    for (var k = 0; k < value.length; k++) {
        this.hiddenMask += value[k];
        if (value[k] !== '\\') {
            this.customRegExpCollec.push(value[k]);
        }
    }
}
function maskInputMouseDownHandler() {
    this.isClicked = true;
}
function maskInputMouseUpHandler() {
    this.isClicked = false;
}
function maskInputFocusHandler(event) {
    var _this = this;
    var inputElement = this.element;
    var startIndex = 0;
    var modelValue = strippedValue.call(this, inputElement);
    var toAllowForward = false;
    var toAllowBackward = false;
    var eventArgs = {
        selectionStart: inputElement.selectionStart,
        event: event,
        value: this.value,
        maskedValue: inputElement.value,
        container: this.inputObj.container,
        selectionEnd: inputElement.selectionEnd
    };
    if (!this.isClicked) {
        triggerFocus.call(this, eventArgs, inputElement);
    }
    if (this.mask) {
        if (!(!(modelValue === null || modelValue === '') || this.floatLabelType === 'Always' ||
            this.placeholder === null || this.placeholder === '')) {
            inputElement.value = this.promptMask;
        }
        setTimeout(function () {
            if (inputElement.selectionStart === _this.promptMask.length ||
                inputElement.value[inputElement.selectionStart] === _this.promptChar) {
                toAllowForward = true;
            }
            else {
                for (var i = inputElement.selectionStart; i < _this.promptMask.length; i++) {
                    if (inputElement.value[i] !== _this.promptChar) {
                        if ((inputElement.value[i] !== _this.promptMask[i])) {
                            toAllowForward = false;
                            break;
                        }
                    }
                    else {
                        toAllowForward = true;
                        break;
                    }
                }
            }
        });
        setTimeout(function () {
            var backSelectionStart = inputElement.selectionStart - 1;
            if (backSelectionStart === _this.promptMask.length - 1 ||
                inputElement.value[backSelectionStart] === _this.promptChar) {
                toAllowBackward = true;
            }
            else {
                for (var i = backSelectionStart; i >= 0; i--) {
                    if (inputElement.value[i] !== _this.promptChar) {
                        if ((inputElement.value[i] !== _this.promptMask[i])) {
                            toAllowBackward = false;
                            break;
                        }
                    }
                    else {
                        toAllowBackward = true;
                        break;
                    }
                }
            }
        });
        if ((this.isClicked || (this.floatLabelType !== 'Always' &&
            ((modelValue === null || modelValue === '') &&
                (this.placeholder !== null && this.placeholder !== ''))))) {
            for (startIndex = 0; startIndex < this.promptMask.length; startIndex++) {
                if (inputElement.value[startIndex] === this.promptChar) {
                    setTimeout(function () {
                        if (toAllowForward || toAllowBackward) {
                            inputElement.selectionEnd = startIndex;
                            inputElement.selectionStart = startIndex;
                        }
                        eventArgs = {
                            selectionStart: inputElement.selectionStart,
                            event: event,
                            value: _this.value,
                            maskedValue: inputElement.value,
                            container: _this.inputObj.container,
                            selectionEnd: inputElement.selectionEnd
                        };
                        triggerFocus.call(_this, eventArgs, inputElement);
                    });
                    break;
                }
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(inputElement.value.match(this.promptChar))) {
                eventArgs = {
                    selectionStart: inputElement.selectionStart,
                    event: event,
                    value: this.value,
                    maskedValue: inputElement.value,
                    container: this.inputObj.container,
                    selectionEnd: inputElement.selectionEnd
                };
                triggerFocus.call(this, eventArgs, inputElement);
            }
            this.isClicked = false;
        }
    }
}
function triggerFocus(eventArgs, inputElement) {
    this.trigger('focus', eventArgs, function (eventArgs) {
        inputElement.selectionStart = eventArgs.selectionStart;
        inputElement.selectionEnd = eventArgs.selectionEnd;
    });
}
function maskInputBlurHandler(event) {
    this.blurEventArgs = {
        event: event,
        value: this.value,
        maskedValue: this.element.value,
        container: this.inputObj.container
    };
    this.trigger('blur', this.blurEventArgs);
    if (this.mask) {
        this.isFocus = false;
        if (this.placeholder && this.element.value === this.promptMask && this.floatLabelType !== 'Always') {
            setElementValue.call(this, '');
            var labelElement = this.element.parentNode.querySelector('.e-float-text');
            if (this.floatLabelType === 'Auto' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(labelElement) && labelElement.classList.contains(TOPLABEL)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([labelElement], TOPLABEL);
            }
        }
    }
}
function maskInputPasteHandler(event) {
    var _this = this;
    if (this.mask && !this.readonly) {
        var sIndex_1 = this.element.selectionStart;
        var eIndex_1 = this.element.selectionEnd;
        var oldValue_1 = this.element.value;
        setElementValue.call(this, '');
        this._callPasteHandler = true;
        setTimeout(function () {
            var value = _this.element.value.replace(/ /g, '');
            if (_this.redoCollec.length > 0 && _this.redoCollec[0].value === _this.element.value) {
                value = strippedValue.call(_this, _this.element);
            }
            setElementValue.call(_this, oldValue_1);
            _this.element.selectionStart = sIndex_1;
            _this.element.selectionEnd = eIndex_1;
            var i = 0;
            _this.maskKeyPress = true;
            do {
                validateValue.call(_this, value[i], false, null);
                ++i;
            } while (i < value.length);
            _this.maskKeyPress = false;
            _this._callPasteHandler = false;
            if (_this.element.value === oldValue_1) {
                var i_1 = 0;
                _this.maskKeyPress = true;
                do {
                    validateValue.call(_this, value[i_1], false, null);
                    ++i_1;
                } while (i_1 < value.length);
                _this.maskKeyPress = false;
            }
            else {
                triggerMaskChangeEvent.call(_this, event, oldValue_1);
            }
        }, 1);
    }
}
function maskInputCutHandler(event) {
    var _this = this;
    if (this.mask && !this.readonly) {
        var preValue_1 = this.element.value;
        var sIndex_2 = this.element.selectionStart;
        var eIndex = this.element.selectionEnd;
        this.undoCollec.push({ value: this.element.value, startIndex: this.element.selectionStart, endIndex: this.element.selectionEnd });
        var value_1 = this.element.value.substring(0, sIndex_2) + this.promptMask.substring(sIndex_2, eIndex) +
            this.element.value.substring(eIndex);
        setTimeout(function () {
            setElementValue.call(_this, value_1);
            _this.element.selectionStart = _this.element.selectionEnd = sIndex_2;
            if (_this.element.value !== preValue_1) {
                triggerMaskChangeEvent.call(_this, event, null);
            }
        }, 0);
    }
}
function maskInputDropHandler(event) {
    event.preventDefault();
}
function maskInputHandler(event) {
    if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isIE === true && this.element.value === '' && this.floatLabelType === 'Never') {
        return;
    }
    var eventArgs = { ctrlKey: false, keyCode: 229 };
    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])(event, eventArgs);
    if (this.mask) {
        if (this.element.value === '') {
            this.redoCollec.unshift({
                value: this.promptMask, startIndex: this.element.selectionStart, endIndex: this.element.selectionEnd
            });
        }
        if (this.element.value.length === 1) {
            this.element.value = this.element.value + this.promptMask;
            this.element.setSelectionRange(1, 1);
        }
        if (!this._callPasteHandler) {
            removeMaskInputValues.call(this, event);
        }
        if (this.element.value.length > this.promptMask.length) {
            var startIndex = this.element.selectionStart;
            var addedValues = this.element.value.length - this.promptMask.length;
            var value = this.element.value.substring(startIndex - addedValues, startIndex);
            this.maskKeyPress = false;
            var i = 0;
            do {
                validateValue.call(this, value[i], event.ctrlKey, event);
                ++i;
            } while (i < value.length);
            if (this.element.value !== this.preEleVal) {
                triggerMaskChangeEvent.call(this, event, null);
            }
        }
        var val = strippedValue.call(this, this.element);
        this.prevValue = val;
        this.value = val;
        if (val === '') {
            setElementValue.call(this, this.promptMask);
            this.element.setSelectionRange(0, 0);
        }
    }
}
function maskInputKeyDownHandler(event) {
    if (this.mask && !this.readonly) {
        if (event.keyCode !== 229) {
            if (event.ctrlKey && (event.keyCode === 89 || event.keyCode === 90)) {
                event.preventDefault();
            }
            removeMaskInputValues.call(this, event);
        }
        var startValue = this.element.value;
        if (event.ctrlKey && (event.keyCode === 89 || event.keyCode === 90)) {
            var collec = void 0;
            if (event.keyCode === 90 && this.undoCollec.length > 0 && startValue !== this.undoCollec[this.undoCollec.length - 1].value) {
                collec = this.undoCollec[this.undoCollec.length - 1];
                this.redoCollec.unshift({
                    value: this.element.value, startIndex: this.element.selectionStart,
                    endIndex: this.element.selectionEnd
                });
                setElementValue.call(this, collec.value);
                this.element.selectionStart = collec.startIndex;
                this.element.selectionEnd = collec.endIndex;
                this.undoCollec.splice(this.undoCollec.length - 1, 1);
            }
            else if (event.keyCode === 89 && this.redoCollec.length > 0 && startValue !== this.redoCollec[0].value) {
                collec = this.redoCollec[0];
                this.undoCollec.push({
                    value: this.element.value, startIndex: this.element.selectionStart,
                    endIndex: this.element.selectionEnd
                });
                setElementValue.call(this, collec.value);
                this.element.selectionStart = collec.startIndex;
                this.element.selectionEnd = collec.endIndex;
                this.redoCollec.splice(0, 1);
            }
        }
    }
}
function mobileRemoveFunction() {
    var collec;
    var sIndex = this.element.selectionStart;
    var eIndex = this.element.selectionEnd;
    if (this.redoCollec.length > 0) {
        collec = this.redoCollec[0];
        setElementValue.call(this, collec.value);
        if ((collec.startIndex - sIndex) === 1) {
            this.element.selectionStart = collec.startIndex;
            this.element.selectionEnd = collec.endIndex;
        }
        else {
            this.element.selectionStart = sIndex + 1;
            this.element.selectionEnd = eIndex + 1;
        }
    }
    else {
        setElementValue.call(this, this.promptMask);
        this.element.selectionStart = this.element.selectionEnd = sIndex;
    }
}
function autoFillMaskInputValues(isRemove, oldEventVal, event) {
    if (event.type === 'input') {
        isRemove = false;
        oldEventVal = this.element.value;
        setElementValue.call(this, this.promptMask);
        setMaskValue.call(this, oldEventVal);
    }
    return isRemove;
}
function removeMaskInputValues(event) {
    var isRemove = false;
    var oldEventVal;
    var isDeleted = false;
    if (this.element.value.length < this.promptMask.length) {
        isRemove = true;
        oldEventVal = this.element.value;
        isRemove = autoFillMaskInputValues.call(this, isRemove, oldEventVal, event);
        mobileRemoveFunction.call(this);
    }
    if (this.element.value.length >= this.promptMask.length && event.type === 'input') {
        isRemove = autoFillMaskInputValues.call(this, isRemove, oldEventVal, event);
    }
    var initStartIndex = this.element.selectionStart;
    var initEndIndex = this.element.selectionEnd;
    var startIndex = this.element.selectionStart;
    var endIndex = this.element.selectionEnd;
    var maskValue = this.hiddenMask.replace(/[>|\\<]/g, '');
    var curMask = maskValue[startIndex - 1];
    var deleteEndIndex = this.element.selectionEnd;
    if (isRemove || event.keyCode === 8 || event.keyCode === 46) {
        this.undoCollec.push({ value: this.element.value, startIndex: this.element.selectionStart, endIndex: endIndex });
        var multipleDel = false;
        var preValue = this.element.value;
        if (startIndex > 0 || ((event.keyCode === 8 || event.keyCode === 46) && startIndex < this.element.value.length
            && ((this.element.selectionEnd - startIndex) !== this.element.value.length))) {
            var index = startIndex;
            if (startIndex !== endIndex) {
                startIndex = endIndex;
                if (event.keyCode === 46) {
                    multipleDel = true;
                }
            }
            else if (event.keyCode === 46) {
                ++index;
            }
            else {
                --index;
            }
            for (var k = startIndex; (event.keyCode === 8 || isRemove || multipleDel) ? k > index : k < index; (event.keyCode === 8 || isRemove || multipleDel) ? k-- : k++) {
                for (var i = startIndex; (event.keyCode === 8 || isRemove || multipleDel) ? i > 0 : i < this.element.value.length; (event.keyCode === 8 || isRemove || multipleDel) ? i-- : i++) {
                    var sIndex = void 0;
                    if (((event.keyCode === 8 || multipleDel) && ((initStartIndex !== initEndIndex && initStartIndex !== startIndex) ||
                        (initStartIndex === initEndIndex))) || isRemove) {
                        curMask = maskValue[i - 1];
                        sIndex = startIndex - 1;
                    }
                    else {
                        curMask = maskValue[i];
                        sIndex = startIndex;
                        ++startIndex;
                    }
                    var oldValue = this.element.value[sIndex];
                    if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.regExpCollec[curMask]) && (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customCharacters)
                        && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customCharacters[curMask]))
                        && ((this.hiddenMask[sIndex] !== this.promptChar && this.customRegExpCollec[sIndex][0] !== '['
                            && this.customRegExpCollec[sIndex][this.customRegExpCollec[sIndex].length - 1] !== ']')))
                        || (this.promptMask[sIndex] !== this.promptChar && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customCharacters))) {
                        this.element.selectionStart = this.element.selectionEnd = sIndex;
                        event.preventDefault();
                        if (event.keyCode === 46 && !multipleDel) {
                            ++this.element.selectionStart;
                        }
                    }
                    else {
                        var value = this.element.value;
                        var prompt_1 = this.promptChar;
                        var elementValue = value.substring(0, sIndex) + prompt_1 + value.substring(startIndex, value.length);
                        setElementValue.call(this, elementValue);
                        event.preventDefault();
                        if (event.keyCode === 46 && !multipleDel) {
                            sIndex++;
                        }
                        this.element.selectionStart = this.element.selectionEnd = sIndex;
                        isDeleted = true;
                    }
                    startIndex = this.element.selectionStart;
                    if ((!isDeleted && event.keyCode === 8) || multipleDel || (!isDeleted && !(event.keyCode === 46))) {
                        sIndex = startIndex - 1;
                    }
                    else {
                        sIndex = startIndex;
                        isDeleted = false;
                    }
                    oldValue = this.element.value[sIndex];
                    if (((initStartIndex !== initEndIndex) && (this.element.selectionStart === initStartIndex))
                        || (this.promptMask[sIndex] === this.promptChar) || ((oldValue !== this.promptMask[sIndex]) &&
                        (this.promptMask[sIndex] !== this.promptChar) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customCharacters))) {
                        break;
                    }
                }
            }
        }
        if (event.keyCode === 46 && multipleDel && isDeleted) {
            this.element.selectionStart = this.element.selectionEnd = deleteEndIndex;
        }
        if (this.element.selectionStart === 0 && (this.element.selectionEnd === this.element.value.length)) {
            setElementValue.call(this, this.promptMask);
            event.preventDefault();
            this.element.selectionStart = this.element.selectionEnd = startIndex;
        }
        this.redoCollec.unshift({
            value: this.element.value, startIndex: this.element.selectionStart,
            endIndex: this.element.selectionEnd
        });
        if (this.element.value !== preValue) {
            triggerMaskChangeEvent.call(this, event, oldEventVal);
        }
    }
}
function maskInputKeyPressHandler(event) {
    if (this.mask && !this.readonly) {
        var oldValue = this.element.value;
        if ((!event.ctrlKey) || (event.ctrlKey && event.code !== 'KeyA' && event.code !== 'KeyY'
            && event.code !== 'KeyZ' && event.code !== 'KeyX' && event.code !== 'KeyC' && event.code !== 'KeyV')) {
            this.maskKeyPress = true;
            var key = event.key;
            if (key === 'Spacebar') {
                key = String.fromCharCode(event.keyCode);
            }
            if (!key) {
                this.isIosInvalid = true;
                validateValue.call(this, String.fromCharCode(event.keyCode), event.ctrlKey, event);
                event.preventDefault();
                this.isIosInvalid = false;
            }
            else if (key && key.length === 1) {
                validateValue.call(this, key, event.ctrlKey, event);
                event.preventDefault();
            }
            if (event.keyCode === 32 && key === ' ' && this.promptChar === ' ') {
                this.element.selectionStart = this.element.selectionEnd = this.element.selectionStart - key.length;
            }
        }
        if (this.element.value !== oldValue) {
            triggerMaskChangeEvent.call(this, event, oldValue);
        }
    }
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function triggerMaskChangeEvent(event, oldValue) {
    var prevOnChange = this.isProtectedOnChange;
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.changeEventArgs) && !this.isInitial) {
        var eventArgs = {};
        this.changeEventArgs = { value: this.element.value, maskedValue: this.element.value, isInteraction: false, isInteracted: false };
        if (this.mask) {
            this.changeEventArgs.value = strippedValue.call(this, this.element);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(event)) {
            this.changeEventArgs.isInteracted = true;
            this.changeEventArgs.isInteraction = true;
            this.changeEventArgs.event = event;
        }
        this.isProtectedOnChange = true;
        this.value = this.changeEventArgs.value;
        this.isProtectedOnChange = prevOnChange;
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["V" /* merge */])(eventArgs, this.changeEventArgs);
        /* istanbul ignore next */
        if (this.isAngular && this.preventChange) {
            this.preventChange = false;
        }
        else {
            this.trigger('change', eventArgs);
        }
    }
    this.preEleVal = this.element.value;
    this.prevValue = strippedValue.call(this, this.element);
    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'aria-valuenow': this.element.value });
}
function maskInputKeyUpHandler(event) {
    if (this.mask && !this.readonly) {
        var collec = void 0;
        if (!this.maskKeyPress && event.keyCode === 229) {
            var oldEventVal = void 0;
            if (this.element.value.length === 1) {
                this.element.value = this.element.value + this.promptMask;
                this.element.setSelectionRange(1, 1);
            }
            if (this.element.value.length > this.promptMask.length) {
                var startIndex = this.element.selectionStart;
                var addedValues = this.element.value.length - this.promptMask.length;
                var val_1 = this.element.value.substring(startIndex - addedValues, startIndex);
                if (this.undoCollec.length > 0) {
                    collec = this.undoCollec[this.undoCollec.length - 1];
                    var startIndex_1 = this.element.selectionStart;
                    oldEventVal = collec.value;
                    var oldVal = collec.value.substring(startIndex_1 - addedValues, startIndex_1);
                    collec = this.redoCollec[0];
                    val_1 = val_1.trim();
                    var isSpace = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isAndroid && val_1 === '';
                    if (!isSpace && oldVal !== val_1 && collec.value.substring(startIndex_1 - addedValues, startIndex_1) !== val_1) {
                        validateValue.call(this, val_1, event.ctrlKey, event);
                    }
                    else if (isSpace) {
                        preventUnsupportedValues.call(this, event, startIndex_1 - 1, this.element.selectionEnd - 1, val_1, event.ctrlKey, false);
                    }
                }
                else {
                    oldEventVal = this.promptMask;
                    validateValue.call(this, val_1, event.ctrlKey, event);
                }
                this.maskKeyPress = false;
                triggerMaskChangeEvent.call(this, event, oldEventVal);
            }
        }
        else {
            removeMaskError.call(this);
        }
        var val = strippedValue.call(this, this.element);
        if (!((this.element.selectionStart === 0) && (this.promptMask === this.element.value) && val === '')
            || (val === '' && this.value !== val)) {
            this.prevValue = val;
            this.value = val;
        }
    }
    else {
        triggerMaskChangeEvent.call(this, event);
    }
    if (this.element.selectionStart === 0 && this.element.selectionEnd === 0) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var temp_1 = this.element;
        setTimeout(function () {
            temp_1.setSelectionRange(0, 0);
        }, 0);
    }
}
function mobileSwipeCheck(key) {
    if (key.length > 1 && ((this.promptMask.length + key.length) < this.element.value.length)) {
        var elementValue = this.redoCollec[0].value.substring(0, this.redoCollec[0].startIndex) + key +
            this.redoCollec[0].value.substring(this.redoCollec[0].startIndex, this.redoCollec[0].value.length);
        setElementValue.call(this, elementValue);
        this.element.selectionStart = this.element.selectionEnd = this.redoCollec[0].startIndex + key.length;
    }
    this.element.selectionStart = this.element.selectionStart - key.length;
    this.element.selectionEnd = this.element.selectionEnd - key.length;
}
function mobileValidation(key) {
    if (!this.maskKeyPress) {
        mobileSwipeCheck.call(this, key);
    }
}
function validateValue(key, isCtrlKey, event) {
    mobileValidation.call(this, key);
    if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(key)) {
        return;
    }
    var startIndex = this.element.selectionStart;
    var initStartIndex = startIndex;
    var curMask;
    var allowText = false;
    var value = this.element.value;
    var eventOldVal;
    var prevSupport = false;
    var isEqualVal = false;
    for (var k = 0; k < key.length; k++) {
        var keyValue = key[k];
        startIndex = this.element.selectionStart;
        if (!this.maskKeyPress && initStartIndex === startIndex) {
            startIndex = startIndex + k;
        }
        if ((!this.maskKeyPress || startIndex < this.promptMask.length)) {
            for (var i = startIndex; i < this.promptMask.length; i++) {
                var maskValue = this.escapeMaskValue;
                curMask = maskValue[startIndex];
                if (this.hiddenMask[startIndex] === '\\' && this.hiddenMask[startIndex + 1] === key) {
                    isEqualVal = true;
                }
                if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.regExpCollec[curMask]) && (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customCharacters)
                    || (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customCharacters) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customCharacters[curMask])))
                    && ((this.hiddenMask[startIndex] !== this.promptChar && this.customRegExpCollec[startIndex][0] !== '['
                        && this.customRegExpCollec[startIndex][this.customRegExpCollec[startIndex].length - 1] !== ']')))
                    || ((this.promptMask[startIndex] !== this.promptChar) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customCharacters))
                    || (this.promptChar === curMask && this.escapeMaskValue === this.mask)) {
                    this.element.selectionStart = this.element.selectionEnd = startIndex + 1;
                    startIndex = this.element.selectionStart;
                    curMask = this.hiddenMask[startIndex];
                }
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customCharacters) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.customCharacters[curMask])) {
                var customValStr = this.customCharacters[curMask];
                var customValArr = customValStr.split(',');
                for (var i = 0; i < customValArr.length; i++) {
                    if (keyValue.match(new RegExp('[' + customValArr[i] + ']'))) {
                        allowText = true;
                        break;
                    }
                }
            }
            else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.regExpCollec[curMask]) && keyValue.match(new RegExp(this.regExpCollec[curMask]))
                && this.promptMask[startIndex] === this.promptChar) {
                allowText = true;
            }
            else if (this.promptMask[startIndex] === this.promptChar && this.customRegExpCollec[startIndex][0] === '['
                && this.customRegExpCollec[startIndex][this.customRegExpCollec[startIndex].length - 1] === ']'
                && keyValue.match(new RegExp(this.customRegExpCollec[startIndex]))) {
                allowText = true;
            }
            if ((!this.maskKeyPress || startIndex < this.hiddenMask.length) && allowText) {
                if (k === 0) {
                    if (this.maskKeyPress) {
                        this.undoCollec.push({ value: value, startIndex: startIndex, endIndex: startIndex });
                    }
                    else {
                        var sIndex = this.element.selectionStart;
                        var eIndex = this.element.selectionEnd;
                        if (this.redoCollec.length > 0) {
                            eventOldVal = this.redoCollec[0].value;
                            setElementValue.call(this, eventOldVal);
                            this.undoCollec.push(this.redoCollec[0]);
                        }
                        else {
                            this.undoCollec.push({ value: this.promptMask, startIndex: startIndex, endIndex: startIndex });
                            eventOldVal = this.promptMask;
                            setElementValue.call(this, eventOldVal);
                        }
                        this.element.selectionStart = sIndex;
                        this.element.selectionEnd = eIndex;
                    }
                }
                startIndex = this.element.selectionStart;
                applySupportedValues.call(this, event, startIndex, keyValue, eventOldVal, isEqualVal);
                prevSupport = true;
                if (k === key.length - 1) {
                    this.redoCollec.unshift({
                        value: this.element.value, startIndex: this.element.selectionStart, endIndex: this.element.selectionEnd
                    });
                }
                allowText = false;
            }
            else {
                startIndex = this.element.selectionStart;
                preventUnsupportedValues.call(this, event, startIndex, initStartIndex, key, isCtrlKey, prevSupport);
            }
            if (k === key.length - 1 && !allowText) {
                if (!__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isAndroid || (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isAndroid && startIndex < this.promptMask.length)) {
                    this.redoCollec.unshift({
                        value: this.element.value, startIndex: this.element.selectionStart, endIndex: this.element.selectionEnd
                    });
                }
            }
        }
        else {
            if (key.length === 1 && !isCtrlKey && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(event)) {
                addMaskErrorClass.call(this);
            }
        }
    }
}
function applySupportedValues(event, startIndex, keyValue, eventOldVal, isEqualVal) {
    if (this.hiddenMask.length > this.promptMask.length) {
        keyValue = changeToLowerUpperCase.call(this, keyValue, this.element.value);
    }
    if (!isEqualVal) {
        var value = this.element.value;
        var elementValue = value.substring(0, startIndex) + keyValue + value.substring(startIndex + 1, value.length);
        setElementValue.call(this, elementValue);
        this.element.selectionStart = this.element.selectionEnd = startIndex + 1;
    }
}
function preventUnsupportedValues(event, sIdx, idx, key, ctrl, chkSupport) {
    if (!this.maskKeyPress) {
        var value = this.element.value;
        if (sIdx >= this.promptMask.length) {
            setElementValue.call(this, value.substring(0, sIdx));
        }
        else {
            if (idx === sIdx) {
                setElementValue.call(this, value.substring(0, sIdx) + value.substring(sIdx + 1, value.length));
            }
            else {
                if (this.promptMask.length === this.element.value.length) {
                    setElementValue.call(this, value.substring(0, sIdx) + value.substring(sIdx, value.length));
                }
                else {
                    setElementValue.call(this, value.substring(0, idx) + value.substring(idx + 1, value.length));
                }
            }
            this.element.selectionStart = this.element.selectionEnd = (chkSupport ||
                this.element.value[idx] !== this.promptChar) ? sIdx : idx;
        }
        addMaskErrorClass.call(this);
    }
    if (key.length === 1 && !ctrl && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(event)) {
        addMaskErrorClass.call(this);
    }
}
function addMaskErrorClass() {
    var _this = this;
    var parentElement = this.element.parentNode;
    var timer = 200;
    if (parentElement.classList.contains(INPUTGROUP) || parentElement.classList.contains(FLOATINPUT)) {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([parentElement], ERROR);
    }
    else {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], ERROR);
    }
    if (this.isIosInvalid === true) {
        timer = 400;
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'aria-invalid': 'true' });
    setTimeout(function () {
        if (!_this.maskKeyPress) {
            removeMaskError.call(_this);
        }
    }, timer);
}
function removeMaskError() {
    var parentElement = this.element.parentNode;
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(parentElement)) {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([parentElement], ERROR);
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], ERROR);
    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'aria-invalid': 'false' });
}
/**
 * Validates user input using masking elements '<' , '>' and '|'.
 *
 * @hidden
 */
function changeToLowerUpperCase(key, value) {
    var promptMask;
    var i;
    var curVal = value;
    var caseCount = 0;
    for (i = 0; i < this.hiddenMask.length; i++) {
        if (this.hiddenMask[i] === '\\') {
            promptMask = curVal.substring(0, i) + '\\' + curVal.substring(i, curVal.length);
        }
        if (this.hiddenMask[i] === '>' || this.hiddenMask[i] === '<' || this.hiddenMask[i] === '|') {
            if (this.hiddenMask[i] !== curVal[i]) {
                promptMask = curVal.substring(0, i) + this.hiddenMask[i] + curVal.substring(i, curVal.length);
            }
            ++caseCount;
        }
        if (promptMask) {
            if (((promptMask[i] === this.promptChar) && (i > this.element.selectionStart)) ||
                (this.element.value.indexOf(this.promptChar) < 0 && (this.element.selectionStart + caseCount) === i)) {
                caseCount = 0;
                break;
            }
            curVal = promptMask;
        }
    }
    while (i >= 0 && promptMask) {
        if (i === 0 || promptMask[i - 1] !== '\\') {
            if (promptMask[i] === '>') {
                key = key.toUpperCase();
                break;
            }
            else if (promptMask[i] === '<') {
                key = key.toLowerCase();
                break;
            }
            else if (promptMask[i] === '|') {
                break;
            }
        }
        --i;
    }
    return key;
}
/**
 * To set updated values in the MaskedTextBox.
 *
 * @hidden
 */
function setMaskValue(val) {
    if (this.mask && val !== undefined && (this.prevValue === undefined || this.prevValue !== val)) {
        this.maskKeyPress = true;
        setElementValue.call(this, this.promptMask);
        if (val !== '' && !(val === null && this.floatLabelType === 'Never' && this.placeholder)) {
            this.element.selectionStart = 0;
            this.element.selectionEnd = 0;
        }
        if (val !== null) {
            for (var i = 0; i < val.length; i++) {
                validateValue.call(this, val[i], false, null);
            }
        }
        var newVal = strippedValue.call(this, this.element);
        this.prevValue = newVal;
        this.value = newVal;
        triggerMaskChangeEvent.call(this, null, null);
        this.maskKeyPress = false;
        var labelElement = this.element.parentNode.querySelector('.e-float-text');
        if (this.element.value === this.promptMask && this.floatLabelType === 'Auto' && this.placeholder &&
            !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(labelElement) && labelElement.classList.contains(TOPLABEL) && !this.isFocus) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([labelElement], TOPLABEL);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([labelElement], BOTTOMLABEL);
            setElementValue.call(this, '');
        }
    }
    if (this.mask === null || this.mask === '' && this.value !== undefined) {
        setElementValue.call(this, this.value);
    }
}
/**
 * To set updated values in the input element.
 *
 * @hidden
 */
function setElementValue(val, element) {
    if (!this.isFocus && this.floatLabelType === 'Auto' && this.placeholder && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.value)) {
        val = '';
    }
    var value = strippedValue.call(this, (element ? element : this.element), val);
    if (value === null || value === '') {
        __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setValue(val, (element ? element : this.element), this.floatLabelType, false);
        if (this.showClearButton) {
            this.inputObj.clearButton.classList.add('e-clear-icon-hide');
        }
    }
    else {
        __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setValue(val, (element ? element : this.element), this.floatLabelType, this.showClearButton);
    }
}
/**
 * Provide mask support to input textbox through utility method.
 *
 * @hidden
 */
function maskInput(args) {
    var inputEle = getMaskInput(args);
    applyMask.call(inputEle);
    var val = strippedValue.call(this, this.element);
    this.prevValue = val;
    this.value = val;
    if (args.mask) {
        unwireEvents.call(inputEle);
        wireEvents.call(inputEle);
    }
}
function getMaskInput(args) {
    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([args.element], UTILMASK);
    var inputEle = {
        element: args.element,
        mask: args.mask,
        promptMask: '',
        hiddenMask: '',
        escapeMaskValue: '',
        promptChar: args.promptChar ? (args.promptChar.length > 1) ? args.promptChar = args.promptChar[0]
            : args.promptChar : '_',
        value: args.value ? args.value : null,
        regExpCollec: regularExpressions,
        customRegExpCollec: [],
        customCharacters: args.customCharacters,
        undoCollec: [],
        redoCollec: [],
        maskKeyPress: false,
        prevValue: ''
    };
    createMask.call(inputEle);
    return inputEle;
}
/**
 * Gets raw value of the textbox which has been masked through utility method.
 *
 * @hidden
 */
function getVal(args) {
    return strippedValue.call(getUtilMaskEle(args), args.element);
}
/**
 * Gets masked value of the textbox which has been masked through utility method.
 *
 * @hidden
 */
function getMaskedVal(args) {
    return unstrippedValue.call(getUtilMaskEle(args), args.element);
}
function getUtilMaskEle(args) {
    var inputEle;
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args) && args.element.classList.contains(UTILMASK)) {
        inputEle = getMaskInput(args);
    }
    return inputEle;
}
/**
 * Arguments to perform undo and redo functionalities.
 *
 * @hidden
 */
var MaskUndo = /** @class */ (function () {
    function MaskUndo() {
    }
    return MaskUndo;
}());

// eslint-disable-next-line @typescript-eslint/no-unused-vars
var maskUndo = new MaskUndo();
/* eslint-enable valid-jsdoc, jsdoc/require-jsdoc, jsdoc/require-returns, jsdoc/require-param */


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__maskedtextbox__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/**
 * MaskedTextbox modules
 */



/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MaskedTextBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_index__ = __webpack_require__(45);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var ROOT = 'e-control-wrapper e-mask';
var INPUT = 'e-input';
var COMPONENT = 'e-maskedtextbox';
var CONTROL = 'e-control';
var MASKINPUT_FOCUS = 'e-input-focus';
var wrapperAttr = ['title', 'style', 'class'];
/**
 * The MaskedTextBox allows the user to enter the valid input only based on the provided mask.
 * ```html
 * <input id="mask" type="text" />
 * ```
 * ```typescript
 * <script>
 * var maskObj = new MaskedTextBox({ mask: "(999) 9999-999" });
 * maskObj.appendTo('#mask');
 * </script>
 * ```
 */
var MaskedTextBox = /** @class */ (function (_super) {
    __extends(MaskedTextBox, _super);
    /**
     *
     * @param {MaskedTextBoxModel} options - Specifies the MaskedTextBox model.
     * @param {string | HTMLElement | HTMLInputElement} element - Specifies the element to render as component.
     * @private
     */
    function MaskedTextBox(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.initInputValue = '';
        _this.isAngular = false;
        _this.preventChange = false;
        _this.isClicked = false;
        _this.maskOptions = options;
        return _this;
    }
    /**
     * Gets the component name.
     *
     * @returns {string} Returns the component name.
     * @private
     */
    MaskedTextBox.prototype.getModuleName = function () {
        return 'maskedtextbox';
    };
    /**
     * Initializes the event handler
     *
     * @returns {void}
     * @private
     */
    MaskedTextBox.prototype.preRender = function () {
        this.promptMask = '';
        this.hiddenMask = '';
        this.escapeMaskValue = '';
        this.regExpCollec = __WEBPACK_IMPORTED_MODULE_2__base_index__["d" /* regularExpressions */];
        this.customRegExpCollec = [];
        this.undoCollec = [];
        this.redoCollec = [];
        this.changeEventArgs = {};
        this.focusEventArgs = {};
        this.blurEventArgs = {};
        this.maskKeyPress = false;
        this.isFocus = false;
        this.isInitial = false;
        this.isIosInvalid = false;
        var ejInstance = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('ej2_instances', this.element);
        this.cloneElement = this.element.cloneNode(true);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.cloneElement], [CONTROL, COMPONENT, 'e-lib']);
        this.angularTagName = null;
        this.formElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, 'form');
        if (this.element.tagName === 'EJS-MASKEDTEXTBOX') {
            this.angularTagName = this.element.tagName;
            var input = this.createElement('input');
            for (var i = 0; i < this.element.attributes.length; i++) {
                input.setAttribute(this.element.attributes[i].nodeName, this.element.attributes[i].nodeValue);
                input.innerHTML = this.element.innerHTML;
            }
            if (this.element.hasAttribute('id')) {
                this.element.removeAttribute('id');
            }
            this.element.classList.remove('e-control', 'e-maskedtextbox');
            this.element.classList.add('e-mask-container');
            this.element.appendChild(input);
            this.element = input;
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])('ej2_instances', ejInstance, this.element);
        }
        this.updateHTMLAttrToElement();
        this.checkHtmlAttributes(false);
        if (this.formElement) {
            this.initInputValue = this.value;
        }
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */
    /**
     * Gets the properties to be maintained in the persisted state.
     *
     * @returns {string}
     */
    MaskedTextBox.prototype.getPersistData = function () {
        var keyEntity = ['value'];
        return this.addOnPersist(keyEntity);
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */
    /**
     * Initializes the component rendering.
     *
     * @returns {void}
     * @private
     */
    MaskedTextBox.prototype.render = function () {
        if (this.element.tagName.toLowerCase() === 'input') {
            if (this.floatLabelType === 'Never') {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], INPUT);
            }
            this.createWrapper();
            this.updateHTMLAttrToWrapper();
            if (this.element.name === '') {
                this.element.setAttribute('name', this.element.id);
            }
            this.isInitial = true;
            this.resetMaskedTextBox();
            this.isInitial = false;
            this.setMaskPlaceholder(true, false);
            this.setWidth(this.width);
            this.preEleVal = this.element.value;
            if (!__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice && (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.version === '11.0' || __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name === 'edge')) {
                this.element.blur();
            }
            if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice && __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isIos) {
                this.element.blur();
            }
            if (this.element.getAttribute('value') || this.value) {
                this.element.setAttribute('value', this.element.value);
            }
            this.renderComplete();
        }
    };
    MaskedTextBox.prototype.updateHTMLAttrToElement = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.htmlAttributes)) {
            for (var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++) {
                var key = _a[_i];
                if (wrapperAttr.indexOf(key) < 0) {
                    this.element.setAttribute(key, this.htmlAttributes[key]);
                }
            }
        }
    };
    MaskedTextBox.prototype.updateCssClass = function (newClass, oldClass) {
        __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setCssClass(this.getValidClassList(newClass), [this.inputObj.container], this.getValidClassList(oldClass));
    };
    MaskedTextBox.prototype.getValidClassList = function (maskClassName) {
        var result = maskClassName;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(maskClassName) && maskClassName !== '') {
            result = (maskClassName.replace(/\s+/g, ' ')).trim();
        }
        return result;
    };
    MaskedTextBox.prototype.updateHTMLAttrToWrapper = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.htmlAttributes)) {
            for (var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++) {
                var key = _a[_i];
                if (wrapperAttr.indexOf(key) > -1) {
                    if (key === 'class') {
                        var updatedClassValues = (this.htmlAttributes[key].replace(/\s+/g, ' ')).trim();
                        if (updatedClassValues !== '') {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.inputObj.container], updatedClassValues.split(' '));
                        }
                    }
                    else if (key === 'style') {
                        var maskStyle = this.inputObj.container.getAttribute(key);
                        maskStyle = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(maskStyle) ? (maskStyle + this.htmlAttributes[key]) :
                            this.htmlAttributes[key];
                        this.inputObj.container.setAttribute(key, maskStyle);
                    }
                    else {
                        this.inputObj.container.setAttribute(key, this.htmlAttributes[key]);
                    }
                }
            }
        }
    };
    MaskedTextBox.prototype.resetMaskedTextBox = function () {
        this.promptMask = '';
        this.hiddenMask = '';
        this.escapeMaskValue = '';
        this.customRegExpCollec = [];
        this.undoCollec = [];
        this.redoCollec = [];
        if (this.promptChar.length > 1) {
            this.promptChar = this.promptChar[0];
        }
        __WEBPACK_IMPORTED_MODULE_2__base_index__["c" /* createMask */].call(this);
        __WEBPACK_IMPORTED_MODULE_2__base_index__["a" /* applyMask */].call(this);
        if (this.mask === null || this.mask === '' && this.value !== undefined) {
            __WEBPACK_IMPORTED_MODULE_2__base_index__["e" /* setElementValue */].call(this, this.value);
        }
        var val = __WEBPACK_IMPORTED_MODULE_2__base_index__["g" /* strippedValue */].call(this, this.element);
        this.prevValue = val;
        this.value = val;
        if (!this.isInitial) {
            __WEBPACK_IMPORTED_MODULE_2__base_index__["i" /* unwireEvents */].call(this);
        }
        __WEBPACK_IMPORTED_MODULE_2__base_index__["j" /* wireEvents */].call(this);
    };
    MaskedTextBox.prototype.setMaskPlaceholder = function (setVal, dynamicPlaceholder) {
        if (dynamicPlaceholder || this.placeholder) {
            __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setPlaceholder(this.placeholder, this.element);
            if ((this.element.value === this.promptMask && setVal && this.floatLabelType !== 'Always') ||
                this.element.value === this.promptMask && this.floatLabelType === 'Never') {
                __WEBPACK_IMPORTED_MODULE_2__base_index__["e" /* setElementValue */].call(this, '');
            }
        }
    };
    MaskedTextBox.prototype.setWidth = function (width) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(width)) {
            if (typeof width === 'number') {
                this.inputObj.container.style.width = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(width);
                this.element.style.width = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(width);
            }
            else if (typeof width === 'string') {
                var elementWidth = (width.match(/px|%|em/)) ? (width) : (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(width));
                this.inputObj.container.style.width = elementWidth;
                this.element.style.width = elementWidth;
            }
        }
    };
    MaskedTextBox.prototype.checkHtmlAttributes = function (isDynamic) {
        var attributes = isDynamic ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.htmlAttributes) ? [] : Object.keys(this.htmlAttributes)
            : ['placeholder', 'disabled', 'value', 'readonly'];
        for (var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++) {
            var key = attributes_1[_i];
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.getAttribute(key))) {
                switch (key) {
                    case 'placeholder':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.maskOptions) || (this.maskOptions['placeholder'] === undefined)) || isDynamic) {
                            this.setProperties({ placeholder: this.element.placeholder }, !isDynamic);
                        }
                        break;
                    case 'disabled':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.maskOptions) || (this.maskOptions['enabled'] === undefined)) || isDynamic) {
                            var isEnabled = this.element.getAttribute(key) === 'disabled' || this.element.getAttribute(key) === '' ||
                                this.element.getAttribute(key) === 'true' ? false : true;
                            this.setProperties({ enabled: isEnabled }, !isDynamic);
                        }
                        break;
                    case 'value':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.maskOptions) || (this.maskOptions['value'] === undefined)) || isDynamic) {
                            this.setProperties({ value: this.element.value }, !isDynamic);
                        }
                        break;
                    case 'readonly':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.maskOptions) || (this.maskOptions['readonly'] === undefined)) || isDynamic) {
                            var isReadonly = this.element.getAttribute(key) === 'readonly' || this.element.getAttribute(key) === ''
                                || this.element.getAttribute(key) === 'true' ? true : false;
                            this.setProperties({ readonly: isReadonly }, !isDynamic);
                        }
                        break;
                }
            }
        }
    };
    MaskedTextBox.prototype.createWrapper = function () {
        var updatedCssClassValues = this.cssClass;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.cssClass) && this.cssClass !== '') {
            updatedCssClassValues = this.getValidClassList(this.cssClass);
        }
        this.inputObj = __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].createInput({
            element: this.element,
            floatLabelType: this.floatLabelType,
            properties: {
                enableRtl: this.enableRtl,
                cssClass: updatedCssClassValues,
                enabled: this.enabled,
                readonly: this.readonly,
                placeholder: this.placeholder,
                showClearButton: this.showClearButton
            }
        }, this.createElement);
        this.inputObj.container.setAttribute('class', ROOT + ' ' + this.inputObj.container.getAttribute('class'));
    };
    /**
     * Calls internally if any of the property value is changed.
     *
     * @param {MaskedTextBoxModel} newProp - Returns the dynamic property value of the component.
     * @param {MaskedTextBoxModel} oldProp - Returns the previous property value of the component.
     * @returns {void}
     * @hidden
     */
    MaskedTextBox.prototype.onPropertyChanged = function (newProp, oldProp) {
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'value':
                    __WEBPACK_IMPORTED_MODULE_2__base_index__["f" /* setMaskValue */].call(this, this.value);
                    if (this.placeholder) {
                        this.setMaskPlaceholder(false, false);
                    }
                    break;
                case 'placeholder':
                    this.setMaskPlaceholder(true, true);
                    break;
                case 'width':
                    this.setWidth(newProp.width);
                    break;
                case 'cssClass':
                    this.updateCssClass(newProp.cssClass, oldProp.cssClass);
                    break;
                case 'enabled':
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setEnabled(newProp.enabled, this.element, this.floatLabelType, this.inputObj.container);
                    break;
                case 'readonly':
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setReadonly(newProp.readonly, this.element);
                    break;
                case 'enableRtl':
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setEnableRtl(newProp.enableRtl, [this.inputObj.container]);
                    break;
                case 'customCharacters':
                    this.customCharacters = newProp.customCharacters;
                    this.resetMaskedTextBox();
                    break;
                case 'showClearButton':
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setClearButton(newProp.showClearButton, this.element, this.inputObj, undefined, this.createElement);
                    __WEBPACK_IMPORTED_MODULE_2__base_index__["b" /* bindClearEvent */].call(this);
                    break;
                case 'floatLabelType':
                    this.floatLabelType = newProp.floatLabelType;
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].removeFloating(this.inputObj);
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].addFloating(this.element, this.floatLabelType, this.placeholder, this.createElement);
                    break;
                case 'htmlAttributes':
                    this.updateHTMLAttrToElement();
                    this.updateHTMLAttrToWrapper();
                    this.checkHtmlAttributes(true);
                    break;
                case 'mask':
                    {
                        var strippedValue_1 = this.value;
                        this.mask = newProp.mask;
                        this.updateValue(strippedValue_1);
                    }
                    break;
                case 'promptChar': {
                    if (newProp.promptChar.length > 1) {
                        newProp.promptChar = newProp.promptChar[0];
                    }
                    if (newProp.promptChar) {
                        this.promptChar = newProp.promptChar;
                    }
                    else {
                        this.promptChar = '_';
                    }
                    var value = this.element.value.replace(new RegExp('[' + oldProp.promptChar + ']', 'g'), this.promptChar);
                    if (this.promptMask === this.element.value) {
                        value = this.promptMask.replace(new RegExp('[' + oldProp.promptChar + ']', 'g'), this.promptChar);
                    }
                    this.promptMask = this.promptMask.replace(new RegExp('[' + oldProp.promptChar + ']', 'g'), this.promptChar);
                    this.undoCollec = this.redoCollec = [];
                    __WEBPACK_IMPORTED_MODULE_2__base_index__["e" /* setElementValue */].call(this, value);
                    break;
                }
            }
        }
        this.preventChange = this.isAngular && this.preventChange ? !this.preventChange : this.preventChange;
    };
    MaskedTextBox.prototype.updateValue = function (strippedVal) {
        this.resetMaskedTextBox();
        __WEBPACK_IMPORTED_MODULE_2__base_index__["f" /* setMaskValue */].call(this, strippedVal);
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */
    /**
     * Gets the value of the MaskedTextBox with the masked format.
     * By using `value` property, you can get the raw value of maskedtextbox without literals and prompt characters.
     *
     * @returns {string}
     */
    MaskedTextBox.prototype.getMaskedValue = function () {
        return __WEBPACK_IMPORTED_MODULE_2__base_index__["h" /* unstrippedValue */].call(this, this.element);
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */
    /**
     * Sets the focus to widget for interaction.
     *
     * @returns {void}
     */
    MaskedTextBox.prototype.focusIn = function () {
        if (document.activeElement !== this.element && this.enabled) {
            this.element.focus();
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.inputObj.container], [MASKINPUT_FOCUS]);
        }
    };
    /**
     * Remove the focus from widget, if the widget is in focus state.
     *
     * @returns {void}
     */
    MaskedTextBox.prototype.focusOut = function () {
        if (document.activeElement === this.element && this.enabled) {
            this.element.blur();
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.inputObj.container], [MASKINPUT_FOCUS]);
        }
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers.
     * Also it maintains the initial input element from the DOM.
     *
     * @method destroy
     * @returns {void}
     */
    MaskedTextBox.prototype.destroy = function () {
        __WEBPACK_IMPORTED_MODULE_2__base_index__["i" /* unwireEvents */].call(this);
        var attrArray = ['aria-labelledby', 'role', 'autocomplete', 'aria-readonly',
            'autocorrect', 'aria-disabled', 'aria-placeholder', 'autocapitalize',
            'spellcheck', 'aria-autocomplete',
            'aria-live', 'aria-valuenow', 'aria-invalid'];
        for (var i = 0; i < attrArray.length; i++) {
            this.element.removeAttribute(attrArray[i]);
        }
        this.element.classList.remove('e-input');
        this.inputObj.container.insertAdjacentElement('afterend', this.element);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.inputObj.container);
        _super.prototype.destroy.call(this);
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], MaskedTextBox.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], MaskedTextBox.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], MaskedTextBox.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Never')
    ], MaskedTextBox.prototype, "floatLabelType", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])({})
    ], MaskedTextBox.prototype, "htmlAttributes", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], MaskedTextBox.prototype, "enabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], MaskedTextBox.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], MaskedTextBox.prototype, "showClearButton", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], MaskedTextBox.prototype, "enablePersistence", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], MaskedTextBox.prototype, "mask", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('_')
    ], MaskedTextBox.prototype, "promptChar", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], MaskedTextBox.prototype, "value", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], MaskedTextBox.prototype, "customCharacters", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], MaskedTextBox.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], MaskedTextBox.prototype, "destroyed", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], MaskedTextBox.prototype, "change", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], MaskedTextBox.prototype, "focus", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], MaskedTextBox.prototype, "blur", void 0);
    MaskedTextBox = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], MaskedTextBox);
    return MaskedTextBox;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__slider__ = __webpack_require__(88);
/* unused harmony namespace reexport */
/**
 * Slider modules
 */



/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_validator__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/**
 * Input box Component
 */



/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export regex */
/* unused harmony export ErrorOption */
/* unused harmony export FormValidator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




/**
 * global declarations
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var regex = {
    /* eslint-disable no-useless-escape */
    EMAIL: new RegExp('^[A-Za-z0-9._%+-]{1,}@[A-Za-z0-9._%+-]{1,}([.]{1}[a-zA-Z0-9]{2,}' +
        '|[.]{1}[a-zA-Z0-9]{2,4}[.]{1}[a-zA-Z0-9]{2,4})$'),
    URL: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/m,
    DATE_ISO: new RegExp('^([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$'),
    DIGITS: new RegExp('^[0-9]*$'),
    PHONE: new RegExp('^[+]?[0-9]{9,13}$'),
    CREDITCARD: new RegExp('^\\d{13,16}$')
    /* eslint-enable no-useless-escape */
};
/**
 * ErrorOption values
 *
 * @private
 */
var ErrorOption;
(function (ErrorOption) {
    /**
     * Defines the error message.
     */
    ErrorOption[ErrorOption["Message"] = 0] = "Message";
    /**
     * Defines the error element type.
     */
    ErrorOption[ErrorOption["Label"] = 1] = "Label";
})(ErrorOption || (ErrorOption = {}));
/**
 * FormValidator class enables you to validate the form fields based on your defined rules
 * ```html
 * <form id='formId'>
 *  <input type='text' name='Name' />
 *  <input type='text' name='Age' />
 * </form>
 * <script>
 *   let formObject = new FormValidator('#formId', {
 *      rules: { Name: { required: true }, Age: { range: [18, 30] } };
 *   });
 *   formObject.validate();
 * </script>
 * ```
 */
var FormValidator = /** @class */ (function (_super) {
    __extends(FormValidator, _super);
    /**
     * Initializes the FormValidator.
     *
     * @param {string | HTMLFormElement} element - Specifies the element to render as component.
     * @param {FormValidatorModel} options - Specifies the FormValidator model.
     * @private
     */
    function FormValidator(element, options) {
        var _this = _super.call(this, options, element) || this;
        _this.validated = [];
        _this.errorRules = [];
        _this.allowSubmit = false;
        _this.required = 'required';
        _this.infoElement = null;
        _this.inputElement = null;
        _this.selectQuery = 'input:not([type=reset]):not([type=button]), select, textarea';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _this.localyMessage = {};
        /**
         * Specifies the default messages for validation rules.
         *
         * @default { List of validation message }
         */
        _this.defaultMessages = {
            required: 'This field is required.',
            email: 'Please enter a valid email address.',
            url: 'Please enter a valid URL.',
            date: 'Please enter a valid date.',
            dateIso: 'Please enter a valid date ( ISO ).',
            creditcard: 'Please enter valid card number',
            number: 'Please enter a valid number.',
            digits: 'Please enter only digits.',
            maxLength: 'Please enter no more than {0} characters.',
            minLength: 'Please enter at least {0} characters.',
            rangeLength: 'Please enter a value between {0} and {1} characters long.',
            range: 'Please enter a value between {0} and {1}.',
            max: 'Please enter a value less than or equal to {0}.',
            min: 'Please enter a value greater than or equal to {0}.',
            regex: 'Please enter a correct value.',
            tel: 'Please enter a valid phone number.',
            pattern: 'Please enter a correct pattern value.',
            equalTo: 'Please enter the valid match text'
        };
        if (typeof _this.rules === 'undefined') {
            _this.rules = {};
        }
        _this.l10n = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["o" /* L10n */]('formValidator', _this.defaultMessages, _this.locale);
        if (_this.locale) {
            _this.localeFunc();
        }
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["W" /* onIntlChange */].on('notifyExternalChange', _this.afterLocalization, _this);
        element = typeof element === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])(element, document) : element;
        // Set novalidate to prevent default HTML5 form validation
        if (_this.element != null) {
            _this.element.setAttribute('novalidate', '');
            _this.inputElements = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])(_this.selectQuery, _this.element);
            _this.createHTML5Rules();
            _this.wireEvents();
        }
        else {
            return undefined;
        }
        return _this;
    }
    FormValidator_1 = FormValidator;
    /* eslint-enable @typescript-eslint/no-explicit-any */
    /**
     * Add validation rules to the corresponding input element based on `name` attribute.
     *
     * @param {string} name `name` of form field.
     * @param {Object} rules Validation rules for the corresponding element.
     * @returns {void}
     */
    FormValidator.prototype.addRules = function (name, rules) {
        if (name) {
            // eslint-disable-next-line no-prototype-builtins
            if (this.rules.hasOwnProperty(name)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])(this.rules[name], rules, {});
            }
            else {
                this.rules[name] = rules;
            }
        }
    };
    /**
     * Remove validation to the corresponding field based on name attribute.
     * When no parameter is passed, remove all the validations in the form.
     *
     * @param {string} name Input name attribute value.
     * @param {string[]} rules List of validation rules need to be remove from the corresponding element.
     * @returns {void}
     */
    FormValidator.prototype.removeRules = function (name, rules) {
        if (!name && !rules) {
            this.rules = {};
        }
        else if (this.rules[name] && !rules) {
            delete this.rules[name];
        }
        else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.rules[name] && rules)) {
            for (var i = 0; i < rules.length; i++) {
                delete this.rules[name][rules[i]];
            }
        }
        else {
            return;
        }
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */
    /**
     * Validate the current form values using defined rules.
     * Returns `true` when the form is valid otherwise `false`
     *
     * @param {string} selected - Optional parameter to validate specified element.
     * @returns {boolean}
     */
    FormValidator.prototype.validate = function (selected) {
        var rules = Object.keys(this.rules);
        if (selected && rules.length) {
            this.validateRules(selected);
            //filter the selected element it don't have any valid input element
            return rules.indexOf(selected) !== -1 && this.errorRules.filter(function (data) {
                return data.name === selected;
            }).length === 0;
        }
        else {
            this.errorRules = [];
            for (var _i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
                var name_1 = rules_1[_i];
                this.validateRules(name_1);
            }
            return this.errorRules.length === 0;
        }
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */
    /**
     * Reset the value of all the fields in form.
     *
     * @returns {void}
     */
    FormValidator.prototype.reset = function () {
        this.element.reset();
        this.clearForm();
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */
    /**
     * Get input element by name.
     *
     * @param {string} name - Input element name attribute value.
     * @returns {HTMLInputElement}
     */
    FormValidator.prototype.getInputElement = function (name) {
        this.inputElement = (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('[name="' + name + '"]', this.element));
        return this.inputElement;
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */
    /**
     * Destroy the form validator object and error elements.
     *
     * @returns {void}
     */
    FormValidator.prototype.destroy = function () {
        this.reset();
        this.unwireEvents();
        this.rules = {};
        var elements = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + this.errorClass + ', .' + this.validClass, this.element);
        for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
            var element = elements_1[_i];
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(element);
        }
        _super.prototype.destroy.call(this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["W" /* onIntlChange */].off('notifyExternalChange', this.afterLocalization);
    };
    /**
     * @param {FormValidatorModel} newProp - Returns the dynamic property value of the component.
     * @param {FormValidatorModel} oldProp - Returns the previous property value of the component.
     * @returns {void}
     * @private
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    FormValidator.prototype.onPropertyChanged = function (newProp, oldProp) {
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'locale':
                    this.localeFunc();
                    break;
            }
        }
    };
    /**
     * @private
     * @returns {void}
     */
    FormValidator.prototype.localeFunc = function () {
        for (var _i = 0, _a = Object.keys(this.defaultMessages); _i < _a.length; _i++) {
            var key = _a[_i];
            this.l10n.setLocale(this.locale);
            var value = this.l10n.getConstant(key);
            this.localyMessage[key] = value;
        }
    };
    /**
     * @private
     * @returns {string} - Returns the component name.
     */
    FormValidator.prototype.getModuleName = function () {
        return 'formValidator';
    };
    /**
     * @param {any} args - Specifies the culture name.
     * @private
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    FormValidator.prototype.afterLocalization = function (args) {
        this.locale = args.locale;
        this.localeFunc();
    };
    /**
     * Allows you to refresh the form validator base events to the elements inside the form.
     *
     * @returns {void}
     */
    FormValidator.prototype.refresh = function () {
        this.unwireEvents();
        this.inputElements = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])(this.selectQuery, this.element);
        this.wireEvents();
    };
    FormValidator.prototype.clearForm = function () {
        this.errorRules = [];
        this.validated = [];
        var elements = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])(this.selectQuery, this.element);
        for (var _i = 0, elements_2 = elements; _i < elements_2.length; _i++) {
            var element = elements_2[_i];
            var input = element;
            input.removeAttribute('aria-invalid');
            input.classList.remove(this.errorClass);
            if (input.name.length > 0) {
                this.getInputElement(input.name);
                this.getErrorElement(input.name);
                this.hideMessage(input.name);
            }
            input.classList.remove(this.validClass);
        }
    };
    FormValidator.prototype.createHTML5Rules = function () {
        var defRules = ['required', 'validateHidden', 'regex', 'rangeLength', 'maxLength', 'minLength', 'dateIso', 'digits',
            'pattern', 'data-val-required', 'type', 'data-validation', 'min', 'max', 'range', 'equalTo', 'data-val-minlength-min',
            'data-val-equalto-other', 'data-val-maxlength-max', 'data-val-range-min', 'data-val-regex-pattern', 'data-val-length-max',
            'data-val-creditcard', 'data-val-phone'];
        var acceptedTypes = ['hidden', 'email', 'url', 'date', 'number', 'tel'];
        for (var _i = 0, _a = (this.inputElements); _i < _a.length; _i++) {
            var input = _a[_i];
            // Default attribute rules
            var allRule = {};
            for (var _b = 0, defRules_1 = defRules; _b < defRules_1.length; _b++) {
                var rule = defRules_1[_b];
                if (input.getAttribute(rule) !== null) {
                    switch (rule) {
                        case 'required':
                            this.defRule(input, allRule, rule, input.required);
                            break;
                        case 'data-validation':
                            rule = input.getAttribute(rule);
                            this.defRule(input, allRule, rule, true);
                            break;
                        case 'type':
                            if (acceptedTypes.indexOf(input.type) !== -1) {
                                this.defRule(input, allRule, input.type, true);
                            }
                            break;
                        case 'rangeLength':
                        case 'range':
                            this.defRule(input, allRule, rule, JSON.parse(input.getAttribute(rule)));
                            break;
                        case 'equalTo':
                            {
                                var id = input.getAttribute(rule);
                                this.defRule(input, allRule, rule, id);
                            }
                            break;
                        default:
                            if (input.getAttribute('data-val') === 'true') {
                                this.annotationRule(input, allRule, rule, input.getAttribute(rule));
                            }
                            else {
                                this.defRule(input, allRule, rule, input.getAttribute(rule));
                            }
                    }
                }
            }
            //adding pattern type validation
            if (Object.keys(allRule).length !== 0) {
                this.addRules(input.name, allRule);
            }
        }
    };
    FormValidator.prototype.annotationRule = function (input, ruleCon, ruleName, value) {
        var annotationRule = ruleName.split('-');
        var rulesList = ['required', 'creditcard', 'phone', 'maxlength', 'minlength', 'range', 'regex', 'equalto'];
        var ruleFirstName = annotationRule[annotationRule.length - 1];
        var ruleSecondName = annotationRule[annotationRule.length - 2];
        if (rulesList.indexOf(ruleFirstName) !== -1) {
            switch (ruleFirstName) {
                case 'required':
                    this.defRule(input, ruleCon, 'required', value);
                    break;
                case 'creditcard':
                    this.defRule(input, ruleCon, 'creditcard', value);
                    break;
                case 'phone':
                    this.defRule(input, ruleCon, 'tel', value);
                    break;
            }
        }
        else if (rulesList.indexOf(ruleSecondName) !== -1) {
            switch (ruleSecondName) {
                case 'maxlength':
                    this.defRule(input, ruleCon, 'maxLength', value);
                    break;
                case 'minlength':
                    this.defRule(input, ruleCon, 'minLength', value);
                    break;
                case 'range':
                    {
                        var minvalue = input.getAttribute('data-val-range-min');
                        var maxvalue = input.getAttribute('data-val-range-max');
                        this.defRule(input, ruleCon, 'range', [minvalue, maxvalue]);
                    }
                    break;
                case 'equalto':
                    {
                        var id = input.getAttribute(ruleName).split('.');
                        this.defRule(input, ruleCon, 'equalTo', id[id.length - 1]);
                    }
                    break;
                case 'regex':
                    this.defRule(input, ruleCon, 'regex', value);
                    break;
            }
        }
    };
    FormValidator.prototype.defRule = function (input, ruleCon, ruleName, value) {
        var message = input.getAttribute('data-' + ruleName + '-message');
        var annotationMessage = input.getAttribute('data-val-' + ruleName);
        var customMessage;
        if (this.rules[input.name] && ruleName !== 'validateHidden' && ruleName !== 'hidden') {
            this.getInputElement(input.name);
            customMessage = this.getErrorMessage(this.rules[input.name][ruleName], ruleName);
        }
        if (message) {
            value = [value, message];
        }
        else if (annotationMessage) {
            value = [value, annotationMessage];
        }
        else if (customMessage) {
            value = [value, customMessage];
        }
        ruleCon[ruleName] = value;
    };
    // Wire events to the form elements
    FormValidator.prototype.wireEvents = function () {
        for (var _i = 0, _a = (this.inputElements); _i < _a.length; _i++) {
            var input = _a[_i];
            if (FormValidator_1.isCheckable(input)) {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(input, 'click', this.clickHandler, this);
            }
            else if (input.tagName === 'SELECT') {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(input, 'change', this.changeHandler, this);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(input, 'focusout', this.focusOutHandler, this);
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(input, 'keyup', this.keyUpHandler, this);
            }
        }
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'submit', this.submitHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'reset', this.resetHandler, this);
    };
    // UnWire events to the form elements
    FormValidator.prototype.unwireEvents = function () {
        for (var _i = 0, _a = (this.inputElements); _i < _a.length; _i++) {
            var input = _a[_i];
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].clearEvents(input);
        }
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'submit', this.submitHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'reset', this.resetHandler);
    };
    // Handle input element focusout event
    FormValidator.prototype.focusOutHandler = function (e) {
        this.trigger('focusout', e);
        //FormValidator.triggerCallback(this.focusout, e);
        var element = e.target;
        if (this.rules[element.name]) {
            if (this.rules[element.name][this.required] || element.value.length > 0) {
                this.validate(element.name);
            }
            else if (this.validated.indexOf(element.name) === -1) {
                this.validated.push(element.name);
            }
        }
    };
    // Handle input element keyup event
    FormValidator.prototype.keyUpHandler = function (e) {
        this.trigger('keyup', e);
        var element = e.target;
        // List of keys need to prevent while validation
        var excludeKeys = [16, 17, 18, 20, 35, 36, 37, 38, 39, 40, 45, 144, 225];
        if (e.which === 9 && (!this.rules[element.name] || (this.rules[element.name] && !this.rules[element.name][this.required]))) {
            return;
        }
        if (this.validated.indexOf(element.name) !== -1 && this.rules[element.name] && excludeKeys.indexOf(e.which) === -1) {
            this.validate(element.name);
        }
    };
    // Handle input click event
    FormValidator.prototype.clickHandler = function (e) {
        this.trigger('click', e);
        var element = e.target;
        // If element type is not submit allow validation
        if (element.type !== 'submit') {
            this.validate(element.name);
        }
        else if (element.getAttribute('formnovalidate') !== null) {
            // Prevent form validation, if submit button has formnovalidate attribute
            this.allowSubmit = true;
        }
    };
    // Handle input change event
    FormValidator.prototype.changeHandler = function (e) {
        this.trigger('change', e);
        var element = e.target;
        this.validate(element.name);
    };
    // Handle form submit event
    FormValidator.prototype.submitHandler = function (e) {
        this.trigger('submit', e);
        //FormValidator.triggerCallback(this.submit, e);
        // Prevent form submit if validation failed
        if (!this.allowSubmit && !this.validate()) {
            e.preventDefault();
        }
        else {
            this.allowSubmit = false;
        }
    };
    // Handle form reset
    FormValidator.prototype.resetHandler = function () {
        this.clearForm();
    };
    // Validate each rule based on input element name
    FormValidator.prototype.validateRules = function (name) {
        if (!this.rules[name]) {
            return;
        }
        var rules = Object.keys(this.rules[name]);
        var hiddenType = false;
        var validateHiddenType = false;
        var vhPos = rules.indexOf('validateHidden');
        var hPos = rules.indexOf('hidden');
        this.getInputElement(name);
        if (hPos !== -1) {
            hiddenType = true;
        }
        if (vhPos !== -1) {
            validateHiddenType = true;
        }
        if (!hiddenType || (hiddenType && validateHiddenType)) {
            if (vhPos !== -1) {
                rules.splice(vhPos, 1);
            }
            if (hPos !== -1) {
                rules.splice((hPos - 1), 1);
            }
            this.getErrorElement(name);
            for (var _i = 0, rules_2 = rules; _i < rules_2.length; _i++) {
                var rule = rules_2[_i];
                var errorMessage = this.getErrorMessage(this.rules[name][rule], rule);
                var errorRule = { name: name, message: errorMessage };
                var eventArgs = {
                    inputName: name,
                    element: this.inputElement,
                    message: errorMessage
                };
                if (!this.isValid(name, rule) && !this.inputElement.classList.contains(this.ignore)) {
                    this.removeErrorRules(name);
                    this.errorRules.push(errorRule);
                    // Set aria attributes to invalid elements
                    this.inputElement.setAttribute('aria-invalid', 'true');
                    this.inputElement.setAttribute('aria-describedby', this.inputElement.id + '-info');
                    this.inputElement.classList.add(this.errorClass);
                    this.inputElement.classList.remove(this.validClass);
                    if (!this.infoElement) {
                        this.createErrorElement(name, errorRule.message, this.inputElement);
                    }
                    else {
                        this.showMessage(errorRule);
                    }
                    eventArgs.errorElement = this.infoElement;
                    eventArgs.status = 'failure';
                    this.inputElement.classList.add(this.errorClass);
                    this.inputElement.classList.remove(this.validClass);
                    this.optionalValidationStatus(name, eventArgs);
                    this.trigger('validationComplete', eventArgs);
                    // Set aria-required to required rule elements
                    if (rule === 'required') {
                        this.inputElement.setAttribute('aria-required', 'true');
                    }
                    break;
                }
                else {
                    this.hideMessage(name);
                    eventArgs.status = 'success';
                    this.trigger('validationComplete', eventArgs);
                }
            }
        }
        else {
            return;
        }
    };
    // Update the optional validation status
    FormValidator.prototype.optionalValidationStatus = function (name, refer) {
        if (!this.rules[name][this.required] && !this.inputElement.value.length && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.infoElement)) {
            this.infoElement.innerHTML = this.inputElement.value;
            this.infoElement.setAttribute('aria-invalid', 'false');
            refer.status = '';
            this.hideMessage(name);
        }
    };
    // Check the input element whether it's value satisfy the validation rule or not
    FormValidator.prototype.isValid = function (name, rule) {
        var params = this.rules[name][rule];
        var param = (params instanceof Array && typeof params[1] === 'string') ? params[0] : params;
        var currentRule = this.rules[name][rule];
        var args = { value: this.inputElement.value, param: param, element: this.inputElement, formElement: this.element };
        this.trigger('validationBegin', args);
        if (!args.param && rule === 'required') {
            return true;
        }
        if (currentRule && typeof currentRule[0] === 'function') {
            var fn = currentRule[0];
            return fn.call(this, { element: this.inputElement, value: this.inputElement.value });
        }
        else if (FormValidator_1.isCheckable(this.inputElement)) {
            if (rule !== 'required') {
                return true;
            }
            return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('input[name="' + name + '"]:checked', this.element).length > 0;
        }
        else {
            return FormValidator_1.checkValidator[rule](args);
        }
    };
    // Return default error message or custom error message
    FormValidator.prototype.getErrorMessage = function (ruleValue, rule) {
        var message = this.inputElement.getAttribute('data-' + rule + '-message') ?
            this.inputElement.getAttribute('data-' + rule + '-message') :
            (ruleValue instanceof Array && typeof ruleValue[1] === 'string') ? ruleValue[1] :
                (Object.keys(this.localyMessage).length !== 0) ? this.localyMessage[rule] : this.defaultMessages[rule];
        var formats = message.match(/{(\d)}/g);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(formats)) {
            for (var i = 0; i < formats.length; i++) {
                var value = ruleValue instanceof Array ? ruleValue[i] : ruleValue;
                message = message.replace(formats[i], value);
            }
        }
        return message;
    };
    // Create error element based on name and error message
    FormValidator.prototype.createErrorElement = function (name, message, input) {
        var errorElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */])(this.errorElement, {
            className: this.errorClass,
            innerHTML: message,
            attrs: { for: name }
        });
        // Create message design if errorOption is message
        if (this.errorOption === ErrorOption.Message) {
            errorElement.classList.remove(this.errorClass);
            errorElement.classList.add('e-message');
            errorElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */])(this.errorContainer, { className: this.errorClass, innerHTML: errorElement.outerHTML });
        }
        errorElement.id = this.inputElement.name + '-info';
        // Append error message into MVC error message element
        if (this.element.querySelector('[data-valmsg-for="' + input.id + '"]')) {
            this.element.querySelector('[data-valmsg-for="' + input.id + '"]').appendChild(errorElement);
        }
        else if (input.hasAttribute('data-msg-containerid') === true) {
            // Append error message into custom div element
            var containerId = input.getAttribute('data-msg-containerid');
            var divElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('#' + containerId, this.element);
            divElement.appendChild(errorElement);
        }
        else if (this.customPlacement != null) {
            // Call custom placement function if customPlacement is not null
            this.customPlacement.call(this, this.inputElement, errorElement);
        }
        else {
            this.inputElement.parentNode.insertBefore(errorElement, this.inputElement.nextSibling);
        }
        errorElement.style.display = 'block';
        this.getErrorElement(name);
        this.validated.push(name);
        this.checkRequired(name);
    };
    // Get error element by name
    FormValidator.prototype.getErrorElement = function (name) {
        this.infoElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])(this.errorElement + '.' + this.errorClass, this.inputElement.parentElement);
        if (!this.infoElement) {
            this.infoElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])(this.errorElement + '.' + this.errorClass + '[for="' + name + '"]', this.element);
        }
        return this.infoElement;
    };
    // Remove existing rule from errorRules object
    FormValidator.prototype.removeErrorRules = function (name) {
        for (var i = 0; i < this.errorRules.length; i++) {
            var rule = this.errorRules[i];
            if (rule.name === name) {
                this.errorRules.splice(i, 1);
            }
        }
    };
    // Show error message to the input element
    FormValidator.prototype.showMessage = function (errorRule) {
        this.infoElement.style.display = 'block';
        this.infoElement.innerHTML = errorRule.message;
        this.checkRequired(errorRule.name);
    };
    // Hide error message based on input name
    FormValidator.prototype.hideMessage = function (name) {
        if (this.infoElement) {
            this.infoElement.style.display = 'none';
            this.removeErrorRules(name);
            this.inputElement.classList.add(this.validClass);
            this.inputElement.classList.remove(this.errorClass);
            this.inputElement.setAttribute('aria-invalid', 'false');
        }
    };
    // Check whether the input element have required rule and its value is not empty
    FormValidator.prototype.checkRequired = function (name) {
        if (!this.rules[name][this.required] && !this.inputElement.value.length && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.infoElement)) {
            this.infoElement.innerHTML = this.inputElement.value;
            this.infoElement.setAttribute('aria-invalid', 'false');
            this.hideMessage(name);
        }
    };
    // Return boolean result if the input have chekcable or submit types
    FormValidator.isCheckable = function (input) {
        var inputType = input.getAttribute('type');
        return inputType && (inputType === 'checkbox' || inputType === 'radio' || inputType === 'submit');
    };
    var FormValidator_1;
    // List of function to validate the rules
    FormValidator.checkValidator = {
        required: function (option) {
            return !isNaN(Date.parse(option.value)) ? !isNaN(new Date(option.value).getTime()) : option.value.toString().length > 0;
        },
        email: function (option) {
            return regex.EMAIL.test(option.value);
        },
        url: function (option) {
            return regex.URL.test(option.value);
        },
        dateIso: function (option) {
            return regex.DATE_ISO.test(option.value);
        },
        tel: function (option) {
            return regex.PHONE.test(option.value);
        },
        creditcard: function (option) {
            return regex.CREDITCARD.test(option.value);
        },
        number: function (option) {
            return !isNaN(Number(option.value)) && option.value.indexOf(' ') === -1;
        },
        digits: function (option) {
            return regex.DIGITS.test(option.value);
        },
        maxLength: function (option) {
            return option.value.length <= option.param;
        },
        minLength: function (option) {
            return option.value.length >= option.param;
        },
        rangeLength: function (option) {
            var param = option.param;
            return option.value.length >= param[0] && option.value.length <= param[1];
        },
        range: function (option) {
            var param = option.param;
            return !isNaN(Number(option.value)) && Number(option.value) >= param[0] && Number(option.value) <= param[1];
        },
        date: function (option) {
            return !isNaN(new Date(option.value).getTime());
        },
        max: function (option) {
            if (!isNaN(Number(option.value))) {
                // Maximum rule validation for number
                return +option.value <= option.param;
            }
            // Maximum rule validation for date
            return new Date(option.value).getTime() <= new Date(JSON.parse(JSON.stringify(option.param))).getTime();
        },
        min: function (option) {
            if (!isNaN(Number(option.value))) {
                // Minimum rule validation for number
                return +option.value >= option.param;
            }
            else if ((option.value).indexOf(',') !== -1) {
                var uNum = (option.value).replace(/,/g, '');
                return parseFloat(uNum) >= option.param;
            }
            else {
                // Minimum rule validation for date
                return new Date(option.value).getTime() >= new Date(JSON.parse(JSON.stringify(option.param))).getTime();
            }
        },
        regex: function (option) {
            return new RegExp(option.param).test(option.value);
        },
        equalTo: function (option) {
            var compareTo = option.formElement.querySelector('#' + option.param);
            option.param = compareTo.value;
            return option.param === option.value;
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], FormValidator.prototype, "locale", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('e-hidden')
    ], FormValidator.prototype, "ignore", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], FormValidator.prototype, "rules", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('e-error')
    ], FormValidator.prototype, "errorClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('e-valid')
    ], FormValidator.prototype, "validClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('label')
    ], FormValidator.prototype, "errorElement", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('div')
    ], FormValidator.prototype, "errorContainer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(ErrorOption.Label)
    ], FormValidator.prototype, "errorOption", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], FormValidator.prototype, "focusout", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], FormValidator.prototype, "keyup", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], FormValidator.prototype, "click", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], FormValidator.prototype, "change", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], FormValidator.prototype, "submit", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], FormValidator.prototype, "validationBegin", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], FormValidator.prototype, "validationComplete", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], FormValidator.prototype, "customPlacement", void 0);
    FormValidator = FormValidator_1 = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], FormValidator);
    return FormValidator;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["c" /* Base */]));



/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uploader__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/**
 * Uploader modules
 */



/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FilesProp */
/* unused harmony export ButtonsProps */
/* unused harmony export AsyncSettings */
/* unused harmony export Uploader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */






var CONTROL_WRAPPER = 'e-upload e-control-wrapper';
var INPUT_WRAPPER = 'e-file-select';
var DROP_AREA = 'e-file-drop';
var DROP_WRAPPER = 'e-file-select-wrap';
var LIST_PARENT = 'e-upload-files';
var FILE = 'e-upload-file-list';
var STATUS = 'e-file-status';
var ACTION_BUTTONS = 'e-upload-actions';
var UPLOAD_BUTTONS = 'e-file-upload-btn e-css e-btn e-flat e-primary';
var CLEAR_BUTTONS = 'e-file-clear-btn e-css e-btn e-flat';
var FILE_NAME = 'e-file-name';
var FILE_TYPE = 'e-file-type';
var FILE_SIZE = 'e-file-size';
var REMOVE_ICON = 'e-file-remove-btn';
var DELETE_ICON = 'e-file-delete-btn';
var SPINNER_PANE = 'e-spinner-pane';
var ABORT_ICON = 'e-file-abort-btn';
var RETRY_ICON = 'e-file-reload-btn';
var DRAG_HOVER = 'e-upload-drag-hover';
var PROGRESS_WRAPPER = 'e-upload-progress-wrap';
var PROGRESSBAR = 'e-upload-progress-bar';
var PROGRESSBAR_TEXT = 'e-progress-bar-text';
var UPLOAD_INPROGRESS = 'e-upload-progress';
var UPLOAD_SUCCESS = 'e-upload-success';
var UPLOAD_FAILED = 'e-upload-fails';
var TEXT_CONTAINER = 'e-file-container';
var VALIDATION_FAILS = 'e-validation-fails';
var RTL = 'e-rtl';
var DISABLED = 'e-disabled';
var RTL_CONTAINER = 'e-rtl-container';
var ICON_FOCUSED = 'e-clear-icon-focus';
var PROGRESS_INNER_WRAPPER = 'e-progress-inner-wrap';
var PAUSE_UPLOAD = 'e-file-pause-btn';
var RESUME_UPLOAD = 'e-file-play-btn';
var RESTRICT_RETRY = 'e-restrict-retry';
var wrapperAttr = ['title', 'style', 'class'];
var FORM_UPLOAD = 'e-form-upload';
var HIDDEN_INPUT = 'e-hidden-file-input';
var INVALID_FILE = 'e-file-invalid';
var INFORMATION = 'e-file-information';
var FilesProp = /** @class */ (function (_super) {
    __extends(FilesProp, _super);
    function FilesProp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], FilesProp.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], FilesProp.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], FilesProp.prototype, "type", void 0);
    return FilesProp;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

var ButtonsProps = /** @class */ (function (_super) {
    __extends(ButtonsProps, _super);
    function ButtonsProps() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Browse...')
    ], ButtonsProps.prototype, "browse", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Upload')
    ], ButtonsProps.prototype, "upload", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Clear')
    ], ButtonsProps.prototype, "clear", void 0);
    return ButtonsProps;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

var AsyncSettings = /** @class */ (function (_super) {
    __extends(AsyncSettings, _super);
    function AsyncSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], AsyncSettings.prototype, "saveUrl", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], AsyncSettings.prototype, "removeUrl", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(0)
    ], AsyncSettings.prototype, "chunkSize", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(3)
    ], AsyncSettings.prototype, "retryCount", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(500)
    ], AsyncSettings.prototype, "retryAfterDelay", void 0);
    return AsyncSettings;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * The uploader component allows to upload images, documents, and other files from local to server.
 * ```html
 * <input type='file' name='images[]' id='upload'/>
 * ```
 * ```typescript
 * <script>
 *   var uploadObj = new Uploader();
 *   uploadObj.appendTo('#upload');
 * </script>
 * ```
 */
var Uploader = /** @class */ (function (_super) {
    __extends(Uploader, _super);
    /**
     * Triggers when change the Uploader value.
     *
     * @param {UploaderModel} options - Specifies the Uploader model.
     * @param {string | HTMLInputElement} element - Specifies the element to render as component.
     * @private
     */
    function Uploader(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.initialAttr = { accept: null, multiple: false, disabled: false };
        _this.uploadedFilesData = [];
        _this.base64String = [];
        _this.isForm = false;
        _this.allTypes = false;
        _this.pausedData = [];
        _this.uploadMetaData = [];
        _this.tabIndex = '0';
        _this.btnTabIndex = '0';
        _this.disableKeyboardNavigation = false;
        _this.count = -1;
        _this.actionCompleteCount = 0;
        _this.flag = true;
        _this.selectedFiles = [];
        _this.uploaderName = 'UploadFiles';
        _this.fileStreams = [];
        _this.newFileRef = 0;
        _this.isFirstFileOnSelection = false;
        _this.dragCounter = 0;
        /**
         * Get the file item(li) which are shown in file list.
         *
         * @private
         */
        _this.fileList = [];
        /**
         * Get the data of files which are shown in file list.
         *
         * @private
         */
        _this.filesData = [];
        _this.uploaderOptions = options;
        return _this;
    }
    /**
     * Calls internally if any of the property value is changed.
     *
     * @param {UploaderModel} newProp - Returns the dynamic property value of the component.
     * @param {UploaderModel} oldProp - Returns the previous property value of the component.
     * @returns {void}
     * @private
     */
    Uploader.prototype.onPropertyChanged = function (newProp, oldProp) {
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'allowedExtensions':
                    this.setExtensions(this.allowedExtensions);
                    this.clearAll();
                    break;
                case 'enabled':
                    this.setControlStatus();
                    break;
                case 'multiple':
                    this.setMultipleSelection();
                    break;
                case 'enableRtl':
                    this.setRTL();
                    this.reRenderFileList();
                    break;
                case 'buttons':
                    this.buttons.browse = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.buttons.browse) ? '' : this.buttons.browse;
                    this.buttons.clear = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.buttons.clear) ? '' : this.buttons.clear;
                    this.buttons.upload = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.buttons.upload) ? '' : this.buttons.upload;
                    this.renderButtonTemplates();
                    break;
                case 'dropArea':
                    this.unBindDropEvents();
                    this.updateDropArea();
                    break;
                case 'htmlAttributes':
                    this.updateHTMLAttrToElement();
                    this.updateHTMLAttrToWrapper();
                    this.checkHTMLAttributes(true);
                    break;
                case 'files':
                    this.renderPreLoadFiles();
                    break;
                case 'directoryUpload':
                    this.updateDirectoryAttributes();
                    break;
                case 'template':
                    this.clearAll();
                    break;
                case 'minFileSize':
                case 'maxFileSize':
                case 'autoUpload':
                    this.clearAll();
                    break;
                case 'sequentialUpload':
                    this.clearAll();
                    break;
                case 'locale':
                    this.l10n.setLocale(this.locale);
                    this.setLocalizedTexts();
                    this.preLocaleObj = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('currentLocale', this.l10n);
                    break;
                case 'cssClass':
                    this.setCSSClass(oldProp.cssClass);
                    break;
            }
        }
    };
    Uploader.prototype.setLocalizedTexts = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.template)) {
            if (typeof (this.buttons.browse) === 'string') {
                this.browseButton.innerText = (this.buttons.browse === 'Browse...') ?
                    this.localizedTexts('Browse') : this.buttons.browse;
                this.browseButton.setAttribute('title', this.browseButton.innerText);
                if (this.uploadWrapper && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.uploadWrapper.querySelector('.' + DROP_AREA))) {
                    this.uploadWrapper.querySelector('.' + DROP_AREA).innerHTML = this.localizedTexts('dropFilesHint');
                }
            }
            this.updateFileList();
        }
    };
    Uploader.prototype.getKeyValue = function (val) {
        var keyValue;
        for (var _i = 0, _a = Object.keys(this.preLocaleObj); _i < _a.length; _i++) {
            var key = _a[_i];
            if (this.preLocaleObj[key] === val) {
                keyValue = key;
            }
        }
        return keyValue;
    };
    Uploader.prototype.updateFileList = function () {
        var element;
        /* istanbul ignore next */
        if (this.fileList.length > 0 && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.uploadWrapper.querySelector('.' + LIST_PARENT))) {
            for (var i = 0; i < this.fileList.length; i++) {
                element = this.fileList[i].querySelector('.e-file-status');
                element.innerHTML = this.localizedTexts(this.getKeyValue(this.filesData[i].status));
                this.filesData[i].status = this.localizedTexts(this.getKeyValue(this.filesData[i].status));
                if (this.fileList[i].classList.contains(UPLOAD_SUCCESS)) {
                    this.fileList[i].querySelector('.e-icons').setAttribute('title', this.localizedTexts('delete'));
                }
                if (this.fileList[i].querySelector('.e-file-play-btn')) {
                    this.fileList[i].querySelector('.e-icons').setAttribute('title', this.localizedTexts('resume'));
                }
                if (this.fileList[i].querySelector('.e-file-remove-btn')) {
                    this.fileList[i].querySelector('.e-icons').setAttribute('title', this.localizedTexts('remove'));
                }
                if (this.fileList[i].querySelector('.e-file-reload-btn')) {
                    this.fileList[i].querySelector('.e-icons').setAttribute('title', this.localizedTexts('retry'));
                }
                if (!this.autoUpload) {
                    this.uploadButton.innerText = (this.buttons.upload === 'Upload') ?
                        this.localizedTexts('Upload') : this.buttons.upload;
                    this.uploadButton.setAttribute('title', this.localizedTexts('Upload'));
                    this.clearButton.innerText = (this.buttons.clear === 'Clear') ?
                        this.localizedTexts('Clear') : this.buttons.clear;
                    this.clearButton.setAttribute('title', this.localizedTexts('Clear'));
                }
            }
        }
    };
    Uploader.prototype.reRenderFileList = function () {
        if (this.listParent) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.listParent);
            this.listParent = null;
            this.fileList = [];
            this.createFileList(this.filesData);
            if (this.actionButtons) {
                this.removeActionButtons();
                this.renderActionButtons();
                this.checkActionButtonStatus();
            }
        }
    };
    Uploader.prototype.preRender = function () {
        this.localeText = { Browse: 'Browse...', Clear: 'Clear', Upload: 'Upload',
            dropFilesHint: 'Or drop files here', invalidMaxFileSize: 'File size is too large',
            invalidMinFileSize: 'File size is too small', invalidFileType: 'File type is not allowed',
            uploadFailedMessage: 'File failed to upload', uploadSuccessMessage: 'File uploaded successfully',
            removedSuccessMessage: 'File removed successfully', removedFailedMessage: 'Unable to remove file', inProgress: 'Uploading',
            readyToUploadMessage: 'Ready to upload', abort: 'Abort', remove: 'Remove', cancel: 'Cancel', delete: 'Delete file',
            pauseUpload: 'File upload paused', pause: 'Pause', resume: 'Resume', retry: 'Retry',
            fileUploadCancel: 'File upload canceled', invalidFileSelection: 'Invalid files selected', totalFiles: 'Total files',
            size: 'Size'
        };
        this.l10n = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["o" /* L10n */]('uploader', this.localeText, this.locale);
        this.preLocaleObj = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('currentLocale', this.l10n);
        this.formRendered();
        this.updateHTMLAttrToElement();
        this.checkHTMLAttributes(false);
        var ejInstance = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('ej2_instances', this.element);
        /* istanbul ignore next */
        if (this.element.tagName === 'EJS-UPLOADER') {
            var inputElement = this.createElement('input', { attrs: { type: 'file' } });
            var index = 0;
            for (index; index < this.element.attributes.length; index++) {
                inputElement.setAttribute(this.element.attributes[index].nodeName, this.element.attributes[index].nodeValue);
                inputElement.innerHTML = this.element.innerHTML;
            }
            if (!inputElement.hasAttribute('name')) {
                inputElement.setAttribute('name', 'UploadFiles');
            }
            this.element.appendChild(inputElement);
            this.element = inputElement;
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])('ej2_instances', ejInstance, this.element);
        }
        /* istanbul ignore next */
        if (ejInstance[0].isPureReactComponent) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ejInstance[0].props.name)) {
                this.element.setAttribute('name', ejInstance[0].props.name);
            }
            else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ejInstance[0].props.id) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(ejInstance[0].props.name)) {
                this.element.setAttribute('name', ejInstance[0].props.id);
            }
            else {
                this.element.setAttribute('name', 'UploadFiles');
            }
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.getAttribute('name'))) {
            this.element.setAttribute('name', this.element.getAttribute('id'));
        }
        if (!this.element.hasAttribute('type')) {
            this.element.setAttribute('type', 'file');
        }
        this.updateDirectoryAttributes();
        this.keyConfigs = {
            enter: 'enter'
        };
        if (this.element.hasAttribute('tabindex')) {
            this.tabIndex = this.element.getAttribute('tabindex');
        }
        this.browserName = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name;
        this.uploaderName = this.element.getAttribute('name');
    };
    Uploader.prototype.formRendered = function () {
        var parentEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, 'form');
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(parentEle)) {
            for (; parentEle && parentEle !== document.documentElement; parentEle = parentEle.parentElement) {
                if (parentEle.tagName === 'FORM') {
                    this.isForm = true;
                    this.formElement = parentEle;
                    parentEle.setAttribute('enctype', 'multipart/form-data');
                    parentEle.setAttribute('encoding', 'multipart/form-data');
                }
            }
        }
    };
    Uploader.prototype.getPersistData = function () {
        return this.addOnPersist(['filesData']);
    };
    /**
     * Return the module name of the component.
     *
     * @returns {string} Returns the component name.
     */
    Uploader.prototype.getModuleName = function () {
        return 'uploader';
    };
    Uploader.prototype.updateDirectoryAttributes = function () {
        if (this.directoryUpload) {
            this.element.setAttribute('directory', 'true');
            this.element.setAttribute('webkitdirectory', 'true');
        }
        else {
            this.element.removeAttribute('directory');
            this.element.removeAttribute('webkitdirectory');
        }
    };
    /**
     * To Initialize the control rendering
     *
     * @private
     * @returns {void}
     */
    Uploader.prototype.render = function () {
        this.renderBrowseButton();
        this.initializeUpload();
        this.updateHTMLAttrToWrapper();
        this.wireEvents();
        this.setMultipleSelection();
        this.setExtensions(this.allowedExtensions);
        this.setRTL();
        this.renderPreLoadFiles();
        this.setControlStatus();
        this.setCSSClass();
    };
    Uploader.prototype.renderBrowseButton = function () {
        this.browseButton = this.createElement('button', { className: 'e-css e-btn', attrs: { 'type': 'button' } });
        this.browseButton.setAttribute('tabindex', this.tabIndex);
        if (typeof (this.buttons.browse) === 'string') {
            this.browseButton.textContent = (this.buttons.browse === 'Browse...') ?
                this.localizedTexts('Browse') : this.buttons.browse;
            this.browseButton.setAttribute('title', this.browseButton.innerText);
        }
        else {
            this.browseButton.appendChild(this.buttons.browse);
        }
        this.element.setAttribute('aria-label', 'Uploader');
    };
    Uploader.prototype.renderActionButtons = function () {
        this.element.setAttribute('tabindex', '-1');
        this.actionButtons = this.createElement('div', { className: ACTION_BUTTONS });
        this.uploadButton = this.createElement('button', { className: UPLOAD_BUTTONS,
            attrs: { 'type': 'button', 'tabindex': this.btnTabIndex } });
        this.clearButton = this.createElement('button', { className: CLEAR_BUTTONS,
            attrs: { 'type': 'button', 'tabindex': this.btnTabIndex } });
        this.actionButtons.appendChild(this.clearButton);
        this.actionButtons.appendChild(this.uploadButton);
        this.renderButtonTemplates();
        this.uploadWrapper.appendChild(this.actionButtons);
        this.browseButton.blur();
        if (!this.isPreloadFiles) {
            this.uploadButton.focus();
        }
        this.wireActionButtonEvents();
    };
    /* istanbul ignore next */
    Uploader.prototype.serverActionButtonsEventBind = function (element) {
        if (element && !this.isForm) {
            this.browseButton.blur();
            this.actionButtons = element;
            this.uploadButton = this.actionButtons.querySelector('.e-file-upload-btn');
            this.clearButton = this.actionButtons.querySelector('.e-file-clear-btn');
            this.uploadButton.focus();
            this.unwireActionButtonEvents();
            this.wireActionButtonEvents();
            this.checkActionButtonStatus();
        }
    };
    Uploader.prototype.wireActionButtonEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.uploadButton, 'click', this.uploadButtonClick, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.clearButton, 'click', this.clearButtonClick, this);
    };
    Uploader.prototype.unwireActionButtonEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.uploadButton, 'click', this.uploadButtonClick);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.clearButton, 'click', this.clearButtonClick);
    };
    Uploader.prototype.removeActionButtons = function () {
        if (this.actionButtons) {
            this.unwireActionButtonEvents();
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.actionButtons);
            this.actionButtons = null;
        }
    };
    Uploader.prototype.renderButtonTemplates = function () {
        if (typeof (this.buttons.browse) === 'string') {
            this.browseButton.textContent = (this.buttons.browse === 'Browse...') ?
                this.localizedTexts('Browse') : this.buttons.browse;
            this.browseButton.setAttribute('title', this.browseButton.textContent);
        }
        else {
            this.browseButton.innerHTML = '';
            this.browseButton.appendChild(this.buttons.browse);
        }
        if (this.uploadButton) {
            var uploadText = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.buttons.upload) ? 'Upload' : this.buttons.upload;
            this.buttons.upload = uploadText;
            if (typeof (this.buttons.upload) === 'string') {
                this.uploadButton.textContent = (this.buttons.upload === 'Upload') ?
                    this.localizedTexts('Upload') : this.buttons.upload;
                this.uploadButton.setAttribute('title', this.uploadButton.textContent);
            }
            else {
                this.uploadButton.innerHTML = '';
                this.uploadButton.appendChild(this.buttons.upload);
            }
        }
        if (this.clearButton) {
            var clearText = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.buttons.clear) ? 'Clear' : this.buttons.clear;
            this.buttons.clear = clearText;
            if (typeof (this.buttons.clear) === 'string') {
                this.clearButton.textContent = (this.buttons.clear === 'Clear') ?
                    this.localizedTexts('Clear') : this.buttons.clear;
                this.clearButton.setAttribute('title', this.clearButton.textContent);
            }
            else {
                this.clearButton.innerHTML = '';
                this.clearButton.appendChild(this.buttons.clear);
            }
        }
    };
    Uploader.prototype.initializeUpload = function () {
        this.element.setAttribute('tabindex', '-1');
        var inputWrapper = this.createElement('span', { className: INPUT_WRAPPER });
        this.element.parentElement.insertBefore(inputWrapper, this.element);
        this.dropAreaWrapper = this.createElement('div', { className: DROP_WRAPPER });
        this.element.parentElement.insertBefore(this.dropAreaWrapper, this.element);
        inputWrapper.appendChild(this.element);
        this.dropAreaWrapper.appendChild(this.browseButton);
        this.dropAreaWrapper.appendChild(inputWrapper);
        this.uploadWrapper = this.createElement('div', { className: CONTROL_WRAPPER });
        this.dropAreaWrapper.parentElement.insertBefore(this.uploadWrapper, this.dropAreaWrapper);
        this.uploadWrapper.appendChild(this.dropAreaWrapper);
        this.setDropArea();
    };
    Uploader.prototype.renderPreLoadFiles = function () {
        if (this.files.length) {
            if (this.enablePersistence && this.filesData.length) {
                this.createFileList(this.filesData);
                return;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.files[0].size)) {
                return;
            }
            this.isPreloadFiles = true;
            var files = [].slice.call(this.files);
            var filesData = [];
            if (!this.multiple) {
                this.clearData();
                files = [files[0]];
            }
            for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
                var data = files_1[_i];
                var fileData = {
                    name: data.name + '.' + data.type.split('.')[data.type.split('.').length - 1],
                    rawFile: '',
                    size: data.size,
                    status: this.localizedTexts('uploadSuccessMessage'),
                    type: data.type,
                    validationMessages: { minSize: '', maxSize: '' },
                    statusCode: '2'
                };
                filesData.push(fileData);
                this.filesData.push(fileData);
            }
            this.createFileList(filesData);
            if (!this.autoUpload && this.listParent && !this.actionButtons && (!this.isForm || this.allowUpload()) && this.showFileList) {
                this.renderActionButtons();
            }
            this.checkActionButtonStatus();
            if (this.sequentialUpload) {
                this.count = this.filesData.length - 1;
            }
            this.isPreloadFiles = false;
        }
    };
    Uploader.prototype.checkActionButtonStatus = function () {
        if (this.actionButtons) {
            var length_1 = this.uploadWrapper.querySelectorAll('.' + VALIDATION_FAILS).length +
                this.uploadWrapper.querySelectorAll('.e-upload-fails:not(.e-upload-progress)').length +
                this.uploadWrapper.querySelectorAll('span.' + UPLOAD_SUCCESS).length +
                this.uploadWrapper.querySelectorAll('span.' + UPLOAD_INPROGRESS).length;
            if (length_1 > 0 && length_1 === this.uploadWrapper.querySelectorAll('li').length) {
                this.uploadButton.setAttribute('disabled', 'disabled');
            }
            else {
                this.uploadButton.removeAttribute('disabled');
            }
        }
    };
    Uploader.prototype.setDropArea = function () {
        var dropTextArea = this.dropAreaWrapper.querySelector('.e-file-drop');
        if (this.dropArea) {
            this.dropZoneElement = (typeof (this.dropArea) !== 'string') ? this.dropArea :
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])(this.dropArea, document);
            var element = this.element;
            var enableDropText = false;
            while (element.parentNode) {
                element = element.parentNode;
                if (element === this.dropZoneElement) {
                    enableDropText = true;
                    if (!dropTextArea) {
                        this.createDropTextHint();
                    }
                    else {
                        dropTextArea.innerHTML = this.localizedTexts('dropFilesHint');
                    }
                }
            }
            if (!enableDropText && dropTextArea) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(dropTextArea);
            }
        }
        else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.uploaderOptions) && this.uploaderOptions.dropArea === undefined) {
            this.createDropTextHint();
            this.dropZoneElement = this.uploadWrapper;
            this.setProperties({ dropArea: this.uploadWrapper }, true);
        }
        this.bindDropEvents();
    };
    Uploader.prototype.updateDropArea = function () {
        if (this.dropArea) {
            this.setDropArea();
        }
        else {
            this.dropZoneElement = null;
            var dropTextArea = this.dropAreaWrapper.querySelector('.e-file-drop');
            if (dropTextArea) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(dropTextArea);
            }
        }
    };
    Uploader.prototype.createDropTextHint = function () {
        var fileDropArea = this.createElement('span', { className: DROP_AREA });
        fileDropArea.innerHTML = this.localizedTexts('dropFilesHint');
        this.dropAreaWrapper.appendChild(fileDropArea);
    };
    Uploader.prototype.updateHTMLAttrToElement = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.htmlAttributes)) {
            for (var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++) {
                var pro = _a[_i];
                if (wrapperAttr.indexOf(pro) < 0) {
                    this.element.setAttribute(pro, this.htmlAttributes[pro]);
                }
            }
        }
    };
    Uploader.prototype.updateHTMLAttrToWrapper = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.htmlAttributes)) {
            for (var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++) {
                var pro = _a[_i];
                if (wrapperAttr.indexOf(pro) > -1) {
                    if (pro === 'class') {
                        var updatedClassValues = (this.htmlAttributes[pro].replace(/\s+/g, ' ')).trim();
                        if (updatedClassValues !== '') {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.uploadWrapper], updatedClassValues.split(' '));
                        }
                    }
                    else if (pro === 'style') {
                        var uploadStyle = this.uploadWrapper.getAttribute(pro);
                        uploadStyle = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(uploadStyle) ? (uploadStyle + this.htmlAttributes[pro]) :
                            this.htmlAttributes[pro];
                        this.uploadWrapper.setAttribute(pro, uploadStyle);
                    }
                    else {
                        this.uploadWrapper.setAttribute(pro, this.htmlAttributes[pro]);
                    }
                }
            }
        }
    };
    Uploader.prototype.setMultipleSelection = function () {
        if (this.multiple && !this.element.hasAttribute('multiple')) {
            var newAttr = document.createAttribute('multiple');
            newAttr.value = 'multiple';
            this.element.setAttributeNode(newAttr);
        }
        else if (!this.multiple) {
            this.element.removeAttribute('multiple');
        }
    };
    Uploader.prototype.checkAutoUpload = function (fileData) {
        if (this.autoUpload) {
            if (this.sequentialUpload) {
                /* istanbul ignore next */
                this.sequenceUpload(fileData);
            }
            else {
                this.upload(fileData);
            }
            this.removeActionButtons();
        }
        else if (!this.actionButtons) {
            this.renderActionButtons();
        }
        this.checkActionButtonStatus();
    };
    Uploader.prototype.sequenceUpload = function (fileData) {
        if (this.filesData.length - fileData.length === 0 ||
            this.filesData[(this.filesData.length - fileData.length - 1)].statusCode !== '1') {
            ++this.count;
            var isFileListCreated = this.showFileList ? false : true;
            if (typeof this.filesData[this.count] === 'object') {
                this.isFirstFileOnSelection = false;
                this.upload(this.filesData[this.count], isFileListCreated);
                if (this.filesData[this.count].statusCode === '0') {
                    this.sequenceUpload(fileData);
                }
            }
            else {
                --this.count;
            }
        }
    };
    Uploader.prototype.setCSSClass = function (oldCSSClass) {
        var updatedCssClassValue = this.cssClass;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.cssClass) && this.cssClass !== '') {
            updatedCssClassValue = (this.cssClass.replace(/\s+/g, ' ')).trim();
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.cssClass) && updatedCssClassValue !== '') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.uploadWrapper], updatedCssClassValue.split(updatedCssClassValue.indexOf(',') > -1 ? ',' : ' '));
        }
        var updatedOldCssClass = oldCSSClass;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(oldCSSClass)) {
            updatedOldCssClass = (oldCSSClass.replace(/\s+/g, ' ')).trim();
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(oldCSSClass) && updatedOldCssClass !== '') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.uploadWrapper], updatedOldCssClass.split(' '));
        }
    };
    Uploader.prototype.wireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.browseButton, 'click', this.browseButtonClick, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'change', this.onSelectFiles, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'click', this.removeFocus, this);
        this.keyboardModule = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["n" /* KeyboardEvents */](this.uploadWrapper, {
            keyAction: this.keyActionHandler.bind(this),
            keyConfigs: this.keyConfigs,
            eventName: 'keydown'
        });
        if (this.isForm) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.formElement, 'reset', this.resetForm, this);
        }
    };
    Uploader.prototype.unWireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.browseButton, 'click', this.browseButtonClick);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'change', this.onSelectFiles);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'click', this.removeFocus);
        if (this.isForm) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.formElement, 'reset', this.resetForm);
        }
        if (this.keyboardModule) {
            this.keyboardModule.destroy();
        }
    };
    Uploader.prototype.resetForm = function () {
        this.clearAll();
    };
    Uploader.prototype.keyActionHandler = function (e) {
        var targetElement = e.target;
        switch (e.action) {
            case 'enter':
                if (e.target === this.clearButton) {
                    this.clearButtonClick();
                }
                else if (e.target === this.uploadButton) {
                    this.uploadButtonClick();
                }
                else if (e.target === this.browseButton) {
                    this.browseButtonClick();
                }
                else if (targetElement.classList.contains(PAUSE_UPLOAD)) {
                    var metaData = this.getCurrentMetaData(null, e);
                    metaData.file.statusCode = '4';
                    metaData.file.status = this.localizedTexts('pauseUpload');
                    this.abortUpload(metaData, false);
                }
                else if (targetElement.classList.contains(RESUME_UPLOAD)) {
                    this.resumeUpload(this.getCurrentMetaData(null, e), e);
                }
                else if (targetElement.classList.contains(RETRY_ICON)) {
                    var metaData = this.getCurrentMetaData(null, e);
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(metaData)) {
                        metaData.file.statusCode = '1';
                        metaData.file.status = this.localizedTexts('readyToUploadMessage');
                        this.chunkUpload(metaData.file);
                    }
                    else {
                        var target = e.target.parentElement;
                        var fileData = this.filesData[this.fileList.indexOf(target)];
                        this.retry(fileData);
                    }
                }
                else {
                    this.removeFiles(e);
                    if (!targetElement.classList.contains(ABORT_ICON)) {
                        this.browseButton.focus();
                    }
                }
                e.preventDefault();
                e.stopPropagation();
                break;
        }
    };
    Uploader.prototype.getCurrentMetaData = function (fileInfo, e) {
        var fileData;
        var targetMetaData;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fileInfo)) {
            var target = e.target.parentElement;
            fileData = this.filesData[this.fileList.indexOf(target)];
        }
        else {
            fileData = fileInfo;
        }
        for (var i = 0; i < this.uploadMetaData.length; i++) {
            if (this.uploadMetaData[i].file.name === fileData.name) {
                targetMetaData = this.uploadMetaData[i];
            }
        }
        return targetMetaData;
    };
    Uploader.prototype.removeFocus = function () {
        if (this.uploadWrapper && this.listParent && this.listParent.querySelector('.' + ICON_FOCUSED)) {
            document.activeElement.blur();
            this.listParent.querySelector('.' + ICON_FOCUSED).classList.remove(ICON_FOCUSED);
        }
    };
    Uploader.prototype.browseButtonClick = function () {
        this.element.click();
    };
    Uploader.prototype.uploadButtonClick = function () {
        if (this.sequentialUpload) {
            this.sequenceUpload(this.filesData);
        }
        else {
            this.upload(this.filesData);
        }
    };
    Uploader.prototype.clearButtonClick = function () {
        this.clearAll();
        /* istanbul ignore next */
        if (this.sequentialUpload) {
            this.count = -1;
        }
        this.actionCompleteCount = 0;
    };
    Uploader.prototype.bindDropEvents = function () {
        if (this.dropZoneElement) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.dropZoneElement, 'drop', this.dropElement, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.dropZoneElement, 'dragover', this.dragHover, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.dropZoneElement, 'dragleave', this.onDragLeave, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.dropZoneElement, 'paste', this.onPasteFile, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.dropZoneElement, 'dragenter', this.onDragEnter, this);
        }
    };
    Uploader.prototype.unBindDropEvents = function () {
        if (this.dropZoneElement) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.dropZoneElement, 'drop', this.dropElement);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.dropZoneElement, 'dragover', this.dragHover);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.dropZoneElement, 'dragleave', this.onDragLeave);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.dropZoneElement, 'dragenter', this.onDragEnter);
        }
    };
    Uploader.prototype.onDragEnter = function (e) {
        if (!this.enabled) {
            return;
        }
        this.dropZoneElement.classList.add(DRAG_HOVER);
        this.dragCounter = this.dragCounter + 1;
        e.preventDefault();
        e.stopPropagation();
    };
    Uploader.prototype.onDragLeave = function () {
        if (!this.enabled) {
            return;
        }
        this.dragCounter = this.dragCounter - 1;
        if (!this.dragCounter) {
            this.dropZoneElement.classList.remove(DRAG_HOVER);
        }
    };
    Uploader.prototype.dragHover = function (e) {
        if (!this.enabled) {
            return;
        }
        if (this.dropEffect !== 'Default') {
            e.dataTransfer.dropEffect = this.dropEffect.toLowerCase();
        }
        e.preventDefault();
        e.stopPropagation();
    };
    /* istanbul ignore next */
    Uploader.prototype.dropElement = function (e) {
        this.dragCounter = 0;
        this.dropZoneElement.classList.remove(DRAG_HOVER);
        this.onSelectFiles(e);
        e.preventDefault();
        e.stopPropagation();
    };
    /* istanbul ignore next */
    Uploader.prototype.onPasteFile = function (event) {
        var item = event.clipboardData.items;
        if (item.length !== 1) {
            return;
        }
        var pasteFile = [].slice.call(item)[0];
        if ((pasteFile.kind === 'file') && pasteFile.type.match('^image/')) {
            this.renderSelectedFiles(event, [pasteFile.getAsFile()], false, true);
        }
    };
    Uploader.prototype.getSelectedFiles = function (index) {
        var data = [];
        var liElement = this.fileList[index];
        var allFiles = this.getFilesData();
        var nameElements = +liElement.getAttribute('data-files-count');
        var startIndex = 0;
        for (var i = 0; i < index; i++) {
            startIndex += (+this.fileList[i].getAttribute('data-files-count'));
        }
        for (var j = startIndex; j < (startIndex + nameElements); j++) {
            data.push(allFiles[j]);
        }
        return data;
    };
    Uploader.prototype.removeFiles = function (args) {
        if (!this.enabled) {
            return;
        }
        var selectedElement = args.target.parentElement;
        var index = this.fileList.indexOf(selectedElement);
        var liElement = this.fileList[index];
        var formUpload = this.isFormUpload();
        var fileData = formUpload ? this.getSelectedFiles(index) : this.getFilesInArray(this.filesData[index]);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fileData)) {
            return;
        }
        if (args.target.classList.contains(ABORT_ICON) && !formUpload) {
            fileData[0].statusCode = '5';
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement)) {
                var spinnerTarget = liElement.querySelector('.' + ABORT_ICON);
                Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__["d" /* createSpinner */])({ target: spinnerTarget, width: '20px' });
                Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__["j" /* showSpinner */])(spinnerTarget);
            }
            if (this.sequentialUpload) {
                /* istanbul ignore next */
                this.uploadSequential();
            }
            if (!(liElement.classList.contains(RESTRICT_RETRY))) {
                this.checkActionComplete(true);
            }
        }
        else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(args.target, '.' + SPINNER_PANE)) {
            this.remove(fileData, false, false, true, args);
        }
        this.element.value = '';
        this.checkActionButtonStatus();
    };
    Uploader.prototype.removeFilesData = function (file, customTemplate) {
        var index;
        if (customTemplate) {
            if (!this.showFileList) {
                index = this.filesData.indexOf(file);
                this.filesData.splice(index, 1);
            }
            return;
        }
        var selectedElement = this.getLiElement(file);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(selectedElement)) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(selectedElement);
        index = this.fileList.indexOf(selectedElement);
        this.fileList.splice(index, 1);
        this.filesData.splice(index, 1);
        if (this.fileList.length === 0 && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.listParent)) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.listParent);
            this.listParent = null;
            this.removeActionButtons();
        }
        if (this.sequentialUpload) {
            /* istanbul ignore next */
            if (index <= this.count) {
                --this.count;
            }
        }
    };
    Uploader.prototype.removeUploadedFile = function (file, eventArgs, removeDirectly, custom) {
        var _this = this;
        var selectedFiles = file;
        var ajax = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["a" /* Ajax */](this.asyncSettings.removeUrl, 'POST', true, null);
        ajax.emitError = false;
        var formData = new FormData();
        ajax.beforeSend = function (e) {
            eventArgs.currentRequest = ajax.httpRequest;
            if (!removeDirectly) {
                _this.trigger('removing', eventArgs, function (eventArgs) {
                    if (eventArgs.cancel) {
                        e.cancel = true;
                    }
                    else {
                        _this.removingEventCallback(eventArgs, formData, selectedFiles, file);
                    }
                });
            }
            else {
                _this.removingEventCallback(eventArgs, formData, selectedFiles, file);
            }
        };
        ajax.onLoad = function (e) {
            _this.removeCompleted(e, selectedFiles, custom);
            return {};
        };
        /* istanbul ignore next */
        ajax.onError = function (e) {
            _this.removeFailed(e, selectedFiles, custom);
            return {};
        };
        ajax.send(formData);
    };
    Uploader.prototype.removingEventCallback = function (eventArgs, formData, selectedFiles, file) {
        /* istanbul ignore next */
        var name = this.element.getAttribute('name');
        var liElement = this.getLiElement(file);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement) && (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement.querySelector('.' + DELETE_ICON)) ||
            !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement.querySelector('.' + REMOVE_ICON)))) {
            var spinnerTarget = liElement.querySelector('.' + DELETE_ICON) ?
                liElement.querySelector('.' + DELETE_ICON) :
                liElement.querySelector('.' + REMOVE_ICON);
            Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__["d" /* createSpinner */])({ target: spinnerTarget, width: '20px' });
            Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__["j" /* showSpinner */])(spinnerTarget);
        }
        if (eventArgs.postRawFile && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(selectedFiles.rawFile) && selectedFiles.rawFile !== '') {
            formData.append(name, selectedFiles.rawFile, selectedFiles.name);
        }
        else {
            formData.append(name, selectedFiles.name);
        }
        this.updateFormData(formData, eventArgs.customFormData);
    };
    /* istanbul ignore next */
    Uploader.prototype.updateFormData = function (formData, customData) {
        if (customData.length > 0 && customData[0]) {
            var _loop_1 = function (i) {
                var data = customData[i];
                // eslint-disable-next-line @typescript-eslint/tslint/config
                var value = Object.keys(data).map(function (e) {
                    return data[e];
                });
                formData.append(Object.keys(data)[0], value);
            };
            for (var i = 0; i < customData.length; i++) {
                _loop_1(i);
            }
        }
    };
    /* istanbul ignore next */
    Uploader.prototype.updateCustomheader = function (request, currentRequest) {
        if (currentRequest.length > 0 && currentRequest[0]) {
            var _loop_2 = function (i) {
                var data = currentRequest[i];
                // eslint-disable-next-line @typescript-eslint/tslint/config
                var value = Object.keys(data).map(function (e) {
                    return data[e];
                });
                request.setRequestHeader(Object.keys(data)[0], value);
            };
            for (var i = 0; i < currentRequest.length; i++) {
                _loop_2(i);
            }
        }
    };
    Uploader.prototype.removeCompleted = function (e, files, customTemplate) {
        var response = e && e.currentTarget ? this.getResponse(e) : null;
        var status = e.target;
        if (status.readyState === 4 && status.status >= 200 && status.status <= 299) {
            var args = {
                e: e, response: response, operation: 'remove', file: this.updateStatus(files, this.localizedTexts('removedSuccessMessage'), '2')
            };
            this.trigger('success', args);
            this.removeFilesData(files, customTemplate);
            var index = this.uploadedFilesData.indexOf(files);
            this.uploadedFilesData.splice(index, 1);
            this.trigger('change', { files: this.uploadedFilesData });
        }
        else {
            this.removeFailed(e, files, customTemplate);
        }
    };
    Uploader.prototype.removeFailed = function (e, files, customTemplate) {
        var response = e && e.currentTarget ? this.getResponse(e) : null;
        var args = {
            e: e, response: response, operation: 'remove', file: this.updateStatus(files, this.localizedTexts('removedFailedMessage'), '0')
        };
        if (!customTemplate) {
            var index = this.filesData.indexOf(files);
            var rootElement = this.fileList[index];
            if (rootElement) {
                rootElement.classList.remove(UPLOAD_SUCCESS);
                rootElement.classList.add(UPLOAD_FAILED);
                var statusElement = rootElement.querySelector('.' + STATUS);
                if (statusElement) {
                    statusElement.classList.remove(UPLOAD_SUCCESS);
                    statusElement.classList.add(UPLOAD_FAILED);
                }
            }
            this.checkActionButtonStatus();
        }
        this.trigger('failure', args);
        var liElement = this.getLiElement(files);
        /* istanbul ignore next */
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement.querySelector('.' + DELETE_ICON))) {
            var spinnerTarget = liElement.querySelector('.' + DELETE_ICON);
            Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__["h" /* hideSpinner */])(spinnerTarget);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(liElement.querySelector('.e-spinner-pane'));
        }
    };
    /* istanbul ignore next */
    Uploader.prototype.getFilesFromFolder = function (event) {
        this.filesEntries = [];
        var items = this.multiple ?
            event.dataTransfer.items : [event.dataTransfer.items[0]];
        var validDirectoryUpload = this.checkDirectoryUpload(items);
        if (!validDirectoryUpload) {
            return;
        }
        var _loop_3 = function (i) {
            var item = items[i].webkitGetAsEntry();
            if (item.isFile) {
                var files_2 = [];
                (item).file(function (fileObj) {
                    var path = item.fullPath;
                    files_2.push({ 'path': path, 'file': fileObj });
                });
                this_1.renderSelectedFiles(event, files_2, true);
            }
            else if (item.isDirectory) {
                this_1.traverseFileTree(item, event);
            }
        };
        var this_1 = this;
        for (var i = 0; i < items.length; i++) {
            _loop_3(i);
        }
    };
    /* istanbul ignore next */
    Uploader.prototype.checkDirectoryUpload = function (items) {
        for (var i = 0; items && i < items.length; i++) {
            var item = items[i].webkitGetAsEntry();
            if (item.isDirectory) {
                return true;
            }
        }
        return false;
    };
    /* eslint-disable @typescript-eslint/explicit-module-boundary-types */
    /* istanbul ignore next */
    Uploader.prototype.traverseFileTree = function (item, event) {
        /* eslint-enable @typescript-eslint/explicit-module-boundary-types */
        if (item.isFile) {
            this.filesEntries.push(item);
        }
        else if (item.isDirectory) {
            var directoryReader = item.createReader();
            this.readFileFromDirectory(directoryReader, event);
        }
    };
    /* istanbul ignore next */
    Uploader.prototype.readFileFromDirectory = function (directoryReader, event) {
        var _this = this;
        directoryReader.readEntries(function (entries) {
            for (var i = 0; i < entries.length; i++) {
                _this.traverseFileTree(entries[i], event);
            }
            _this.pushFilesEntries(event);
            if (entries.length) {
                _this.readFileFromDirectory(directoryReader);
            }
        });
    };
    Uploader.prototype.pushFilesEntries = function (event) {
        var _this = this;
        var files = [];
        var _loop_4 = function (i) {
            this_2.filesEntries[i].file(function (fileObj) {
                if (_this.filesEntries.length) {
                    var path = _this.filesEntries[i].fullPath;
                    files.push({ 'path': path, 'file': fileObj });
                    if (i === _this.filesEntries.length - 1) {
                        _this.filesEntries = [];
                        _this.renderSelectedFiles(event, files, true);
                    }
                }
            });
        };
        var this_2 = this;
        for (var i = 0; i < this.filesEntries.length; i++) {
            _loop_4(i);
        }
    };
    Uploader.prototype.onSelectFiles = function (args) {
        if (!this.enabled) {
            return;
        }
        var targetFiles;
        /* istanbul ignore next */
        if (args.type === 'drop') {
            if (this.directoryUpload) {
                this.getFilesFromFolder(args);
            }
            else {
                var files = this.sortFilesList = args.dataTransfer.files;
                if (this.browserName !== 'msie' && this.browserName !== 'edge' && this.browserName !== 'safari') {
                    this.element.files = files;
                }
                if (files.length > 0) {
                    targetFiles = this.multiple ? this.sortFileList(files) : [files[0]];
                    this.renderSelectedFiles(args, targetFiles);
                }
            }
        }
        else {
            targetFiles = [].slice.call(args.target.files);
            this.renderSelectedFiles(args, targetFiles);
        }
    };
    /* istanbul ignore next */
    Uploader.prototype.getBase64 = function (file) {
        return new Promise(function (resolve, reject) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function () { return resolve(fileReader.result); };
            fileReader.onerror = function (error) { return reject(error); };
        });
    };
    /* istanbul ignore next */
    /* tslint:ignore */
    Uploader.prototype.renderSelectedFiles = function (args, targetFiles, directory, paste) {
        var _this = this;
        this.base64String = [];
        var eventArgs = {
            event: args,
            cancel: false,
            filesData: [],
            isModified: false,
            modifiedFilesData: [],
            progressInterval: '',
            isCanceled: false,
            currentRequest: null,
            customFormData: null
        };
        /* istanbul ignore next */
        if (targetFiles.length < 1) {
            eventArgs.isCanceled = true;
            this.trigger('selected', eventArgs);
            return;
        }
        this.flag = true;
        var fileData = [];
        if (!this.multiple) {
            this.clearData(true);
            targetFiles = [targetFiles[0]];
        }
        for (var i = 0; i < targetFiles.length; i++) {
            var file = directory ? targetFiles[i].file : targetFiles[i];
            this.updateInitialFileDetails(args, targetFiles, file, i, fileData, directory, paste);
        }
        eventArgs.filesData = fileData;
        if (this.allowedExtensions.indexOf('*') > -1) {
            this.allTypes = true;
        }
        if (!this.allTypes) {
            fileData = this.checkExtension(fileData);
        }
        this.trigger('selected', eventArgs, function (eventArgs) {
            _this._internalRenderSelect(eventArgs, fileData);
        });
    };
    Uploader.prototype.updateInitialFileDetails = function (args, 
    // eslint-disable-next-line @typescript-eslint/indent
    targetFiles, file, i, fileData, directory, paste) {
        var fileName = directory ? targetFiles[i].path.substring(1, targetFiles[i].path.length) : paste ?
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])(file.name.substring(0, file.name.lastIndexOf('.'))) + '.' + this.getFileType(file.name) :
            this.directoryUpload ? targetFiles[i].webkitRelativePath : file.name;
        var fileDetails = {
            name: fileName,
            rawFile: file,
            size: file.size,
            status: this.localizedTexts('readyToUploadMessage'),
            type: this.getFileType(file.name),
            validationMessages: this.validatedFileSize(file.size),
            statusCode: '1',
            id: Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])(file.name.substring(0, file.name.lastIndexOf('.'))) + '.' + this.getFileType(file.name)
        };
        /* istanbul ignore next */
        if (paste) {
            fileDetails.fileSource = 'paste';
        }
        fileDetails.status = fileDetails.validationMessages.minSize !== '' ? this.localizedTexts('invalidMinFileSize') :
            fileDetails.validationMessages.maxSize !== '' ? this.localizedTexts('invalidMaxFileSize') : fileDetails.status;
        if (fileDetails.validationMessages.minSize !== '' || fileDetails.validationMessages.maxSize !== '') {
            fileDetails.statusCode = '0';
        }
        fileData.push(fileDetails);
    };
    Uploader.prototype._internalRenderSelect = function (eventArgs, fileData) {
        if (!eventArgs.cancel) {
            /* istanbul ignore next */
            this.selectedFiles = this.selectedFiles.concat(fileData);
            this.btnTabIndex = this.disableKeyboardNavigation ? '-1' : '0';
            if (this.showFileList) {
                if (eventArgs.isModified && eventArgs.modifiedFilesData.length > 0) {
                    for (var j = 0; j < eventArgs.modifiedFilesData.length; j++) {
                        for (var k = 0; k < fileData.length; k++) {
                            if (eventArgs.modifiedFilesData[j].id === fileData[k].id) {
                                eventArgs.modifiedFilesData[j].rawFile = fileData[k].rawFile;
                            }
                        }
                    }
                    var dataFiles = this.allTypes ? eventArgs.modifiedFilesData :
                        this.checkExtension(eventArgs.modifiedFilesData);
                    this.updateSortedFileList(dataFiles);
                    this.filesData = dataFiles;
                    if (!this.isForm || this.allowUpload()) {
                        this.checkAutoUpload(dataFiles);
                    }
                }
                else {
                    this.createFileList(fileData, true);
                    this.filesData = this.filesData.concat(fileData);
                    if (!this.isForm || this.allowUpload()) {
                        this.checkAutoUpload(fileData);
                    }
                }
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(eventArgs.progressInterval) && eventArgs.progressInterval !== '') {
                    this.progressInterval = eventArgs.progressInterval;
                }
            }
            else {
                this.filesData = this.filesData.concat(fileData);
                if (this.autoUpload) {
                    this.upload(this.filesData, true);
                }
            }
            this.raiseActionComplete();
            this.isFirstFileOnSelection = true;
        }
    };
    Uploader.prototype.allowUpload = function () {
        var allowFormUpload = false;
        if (this.isForm && (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.asyncSettings.saveUrl) && this.asyncSettings.saveUrl !== '')) {
            allowFormUpload = true;
        }
        return allowFormUpload;
    };
    Uploader.prototype.isFormUpload = function () {
        var isFormUpload = false;
        if (this.isForm && ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.asyncSettings.saveUrl) || this.asyncSettings.saveUrl === '')
            && (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.asyncSettings.removeUrl) || this.asyncSettings.removeUrl === ''))) {
            isFormUpload = true;
        }
        return isFormUpload;
    };
    Uploader.prototype.clearData = function (singleUpload) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.listParent)) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.listParent);
            this.listParent = null;
        }
        if (this.browserName !== 'msie' && !singleUpload) {
            this.element.value = '';
        }
        this.fileList = [];
        this.filesData = [];
        this.removeActionButtons();
    };
    Uploader.prototype.updateSortedFileList = function (filesData) {
        var previousListClone = this.createElement('div', { id: 'clonewrapper' });
        var added = -1;
        var removedList;
        if (this.listParent) {
            for (var i = 0; i < this.listParent.querySelectorAll('li').length; i++) {
                var liElement = this.listParent.querySelectorAll('li')[i];
                previousListClone.appendChild(liElement.cloneNode(true));
            }
            removedList = this.listParent.querySelectorAll('li');
            for (var _i = 0, removedList_1 = removedList; _i < removedList_1.length; _i++) {
                var item = removedList_1[_i];
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(item);
            }
            this.removeActionButtons();
            var oldList = [].slice.call(previousListClone.childNodes);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.listParent);
            this.listParent = null;
            this.fileList = [];
            this.createParentUL();
            for (var index = 0; index < filesData.length; index++) {
                for (var j = 0; j < this.filesData.length; j++) {
                    if (this.filesData[j].name === filesData[index].name) {
                        this.listParent.appendChild(oldList[j]);
                        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(oldList[j].querySelector('.e-icons'), 'click', this.removeFiles, this);
                        this.fileList.push(oldList[j]);
                        added = index;
                    }
                }
                if (added !== index) {
                    this.createFileList([filesData[index]]);
                }
            }
        }
        else {
            this.createFileList(filesData);
        }
    };
    Uploader.prototype.isBlank = function (str) {
        return (!str || /^\s*$/.test(str));
    };
    Uploader.prototype.checkExtension = function (files) {
        var dropFiles = files;
        if (!this.isBlank(this.allowedExtensions)) {
            var allowedExtensions = [];
            var extensions = this.allowedExtensions.split(',');
            for (var _i = 0, extensions_1 = extensions; _i < extensions_1.length; _i++) {
                var extension = extensions_1[_i];
                allowedExtensions.push(extension.trim().toLocaleLowerCase());
            }
            for (var i = 0; i < files.length; i++) {
                if (allowedExtensions.indexOf(('.' + files[i].type).toLocaleLowerCase()) === -1) {
                    files[i].status = this.localizedTexts('invalidFileType');
                    files[i].statusCode = '0';
                }
            }
        }
        return dropFiles;
    };
    Uploader.prototype.validatedFileSize = function (fileSize) {
        var minSizeError = '';
        var maxSizeError = '';
        if (fileSize < this.minFileSize) {
            minSizeError = this.localizedTexts('invalidMinFileSize');
        }
        else if (fileSize > this.maxFileSize) {
            maxSizeError = this.localizedTexts('invalidMaxFileSize');
        }
        else {
            minSizeError = '';
            maxSizeError = '';
        }
        var errorMessage = { minSize: minSizeError, maxSize: maxSizeError };
        return errorMessage;
    };
    Uploader.prototype.isPreLoadFile = function (fileData) {
        var isPreload = false;
        for (var i = 0; i < this.files.length; i++) {
            if (this.files[i].name === fileData.name.slice(0, fileData.name.lastIndexOf('.')) && this.files[i].type === fileData.type) {
                isPreload = true;
            }
        }
        return isPreload;
    };
    Uploader.prototype.createCustomfileList = function (fileData) {
        this.createParentUL();
        for (var _i = 0, fileData_1 = fileData; _i < fileData_1.length; _i++) {
            var listItem = fileData_1[_i];
            var listElement = this.createElement('li', { className: FILE, attrs: { 'data-file-name': listItem.name } });
            this.uploadTemplateFn = this.templateComplier(this.template);
            var liTempCompiler = this.uploadTemplateFn(listItem, this, 'template', this.element.id + 'Template', this.isStringTemplate, null, listElement);
            if (liTempCompiler) {
                var fromElements = [].slice.call(liTempCompiler);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(fromElements, listElement);
            }
            var index = fileData.indexOf(listItem);
            var eventArgs = {
                element: listElement,
                fileInfo: listItem,
                index: index,
                isPreload: this.isPreLoadFile(listItem)
            };
            var eventsArgs = {
                element: listElement,
                fileInfo: listItem,
                index: index,
                isPreload: this.isPreLoadFile(listItem)
            };
            this.trigger('rendering', eventArgs);
            this.trigger('fileListRendering', eventsArgs);
            this.listParent.appendChild(listElement);
            this.fileList.push(listElement);
        }
        this.renderReactTemplates();
    };
    Uploader.prototype.createParentUL = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.listParent)) {
            this.listParent = this.createElement('ul', { className: LIST_PARENT });
            this.uploadWrapper.appendChild(this.listParent);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Uploader.prototype.formFileList = function (fileData, files) {
        var fileList = this.createElement('li', { className: FILE });
        fileList.setAttribute('data-files-count', fileData.length + '');
        var fileContainer = this.createElement('span', { className: TEXT_CONTAINER });
        var statusMessage;
        for (var _i = 0, fileData_2 = fileData; _i < fileData_2.length; _i++) {
            var listItem = fileData_2[_i];
            var fileNameEle = this.createElement('span', { className: FILE_NAME });
            fileNameEle.innerHTML = this.getFileNameOnly(listItem.name);
            var fileTypeEle = this.createElement('span', { className: FILE_TYPE });
            var fileType = this.getFileType(listItem.name);
            fileTypeEle.innerHTML = '.' + fileType;
            if (!fileType) {
                fileTypeEle.classList.add('e-hidden');
            }
            if (!this.enableRtl) {
                fileContainer.appendChild(fileNameEle);
                fileContainer.appendChild(fileTypeEle);
            }
            else {
                var rtlContainer = this.createElement('span', { className: RTL_CONTAINER });
                rtlContainer.appendChild(fileTypeEle);
                rtlContainer.appendChild(fileNameEle);
                fileContainer.appendChild(rtlContainer);
            }
            this.truncateName(fileNameEle);
            statusMessage = this.formValidateFileInfo(listItem, fileList);
        }
        fileList.appendChild(fileContainer);
        this.setListToFileInfo(fileData, fileList);
        var index = this.listParent.querySelectorAll('li').length;
        var infoEle = this.createElement('span');
        if (fileList.classList.contains(INVALID_FILE)) {
            infoEle.classList.add(STATUS);
            infoEle.classList.add(INVALID_FILE);
            infoEle.innerText = fileData.length > 1 ? this.localizedTexts('invalidFileSelection') : statusMessage;
        }
        else {
            infoEle.classList.add(fileData.length > 1 ? INFORMATION : FILE_SIZE);
            infoEle.innerText = fileData.length > 1 ? this.localizedTexts('totalFiles') + ': ' + fileData.length + ' , '
                + this.localizedTexts('size') + ': ' +
                this.bytesToSize(this.getFileSize(fileData)) : this.bytesToSize(fileData[0].size);
            this.createFormInput(fileData);
        }
        fileContainer.appendChild(infoEle);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fileList.querySelector('.e-icons'))) {
            var iconElement = this.createElement('span', { className: 'e-icons', attrs: { 'tabindex': this.btnTabIndex } });
            /* istanbul ignore next */
            if (this.browserName === 'msie') {
                iconElement.classList.add('e-msie');
            }
            iconElement.setAttribute('title', this.localizedTexts('remove'));
            fileList.appendChild(fileContainer);
            fileList.appendChild(iconElement);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(iconElement, 'click', this.removeFiles, this);
            iconElement.classList.add(REMOVE_ICON);
        }
        var eventArgs = {
            element: fileList,
            fileInfo: this.mergeFileInfo(fileData, fileList),
            index: index,
            isPreload: this.isPreLoadFile(this.mergeFileInfo(fileData, fileList))
        };
        var eventsArgs = {
            element: fileList,
            fileInfo: this.mergeFileInfo(fileData, fileList),
            index: index,
            isPreload: this.isPreLoadFile(this.mergeFileInfo(fileData, fileList))
        };
        this.trigger('rendering', eventArgs);
        this.trigger('fileListRendering', eventsArgs);
        this.listParent.appendChild(fileList);
        this.fileList.push(fileList);
    };
    Uploader.prototype.formValidateFileInfo = function (listItem, fileList) {
        var statusMessage = listItem.status;
        var validationMessages = this.validatedFileSize(listItem.size);
        if (validationMessages.minSize !== '' || validationMessages.maxSize !== '') {
            this.addInvalidClass(fileList);
            statusMessage = validationMessages.minSize !== '' ? this.localizedTexts('invalidMinFileSize') :
                validationMessages.maxSize !== '' ? this.localizedTexts('invalidMaxFileSize') : statusMessage;
        }
        var typeValidationMessage = this.checkExtension(this.getFilesInArray(listItem))[0].status;
        if (typeValidationMessage === this.localizedTexts('invalidFileType')) {
            this.addInvalidClass(fileList);
            statusMessage = typeValidationMessage;
        }
        return statusMessage;
    };
    Uploader.prototype.addInvalidClass = function (fileList) {
        fileList.classList.add(INVALID_FILE);
    };
    Uploader.prototype.createFormInput = function (fileData) {
        if (this.browserName !== 'safari') {
            var inputElement = this.element.cloneNode(true);
            inputElement.classList.add(HIDDEN_INPUT);
            for (var _i = 0, fileData_3 = fileData; _i < fileData_3.length; _i++) {
                var listItem = fileData_3[_i];
                listItem.input = inputElement;
            }
            inputElement.setAttribute('name', this.uploaderName);
            this.uploadWrapper.querySelector('.' + INPUT_WRAPPER).appendChild(inputElement);
            if (this.browserName !== 'msie' && this.browserName !== 'edge') {
                this.element.value = '';
            }
        }
    };
    Uploader.prototype.getFileSize = function (fileData) {
        var fileSize = 0;
        for (var _i = 0, fileData_4 = fileData; _i < fileData_4.length; _i++) {
            var file = fileData_4[_i];
            fileSize += file.size;
        }
        return fileSize;
    };
    Uploader.prototype.mergeFileInfo = function (fileData, fileList) {
        var result = {
            name: '',
            rawFile: '',
            size: 0,
            status: '',
            type: '',
            validationMessages: { minSize: '', maxSize: '' },
            statusCode: '1',
            list: fileList
        };
        var fileNames = [];
        var type = '';
        for (var _i = 0, fileData_5 = fileData; _i < fileData_5.length; _i++) {
            var listItem = fileData_5[_i];
            fileNames.push(listItem.name);
            type = listItem.type;
        }
        result.name = fileNames.join(', ');
        result.size = this.getFileSize(fileData);
        result.type = type;
        result.status = this.statusForFormUpload(fileData, fileList);
        return result;
    };
    Uploader.prototype.statusForFormUpload = function (fileData, fileList) {
        var isValid = true;
        var statusMessage;
        for (var _i = 0, fileData_6 = fileData; _i < fileData_6.length; _i++) {
            var listItem = fileData_6[_i];
            statusMessage = listItem.status;
            var validationMessages = this.validatedFileSize(listItem.size);
            if (validationMessages.minSize !== '' || validationMessages.maxSize !== '') {
                isValid = false;
                statusMessage = validationMessages.minSize !== '' ? this.localizedTexts('invalidMinFileSize') :
                    validationMessages.maxSize !== '' ? this.localizedTexts('invalidMaxFileSize') : statusMessage;
            }
            var typeValidationMessage = this.checkExtension(this.getFilesInArray(listItem))[0].status;
            if (typeValidationMessage === this.localizedTexts('invalidFileType')) {
                isValid = false;
                statusMessage = typeValidationMessage;
            }
        }
        if (!isValid) {
            fileList.classList.add(INVALID_FILE);
            statusMessage = fileData.length > 1 ? this.localizedTexts('invalidFileSelection') : statusMessage;
        }
        else {
            statusMessage = this.localizedTexts('totalFiles') + ': ' + fileData.length + ' , '
                + this.localizedTexts('size') + ': ' +
                this.bytesToSize(this.getFileSize(fileData));
        }
        return statusMessage;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Uploader.prototype.formCustomFileList = function (fileData, files) {
        this.createParentUL();
        var fileList = this.createElement('li', { className: FILE });
        fileList.setAttribute('data-files-count', fileData.length + '');
        this.setListToFileInfo(fileData, fileList);
        var result = this.mergeFileInfo(fileData, fileList);
        fileList.setAttribute('data-file-name', result.name);
        this.uploadTemplateFn = this.templateComplier(this.template);
        var liTempCompiler = this.uploadTemplateFn(result, this, 'template', this.element.id + 'Template', this.isStringTemplate, null, fileList);
        if (liTempCompiler) {
            var fromElements = [].slice.call(liTempCompiler);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(fromElements, fileList);
        }
        var index = this.listParent.querySelectorAll('li').length;
        if (!fileList.classList.contains(INVALID_FILE)) {
            this.createFormInput(fileData);
        }
        var eventArgs = {
            element: fileList,
            fileInfo: result,
            index: index,
            isPreload: this.isPreLoadFile(result)
        };
        var eventsArgs = {
            element: fileList,
            fileInfo: result,
            index: index,
            isPreload: this.isPreLoadFile(result)
        };
        this.trigger('rendering', eventArgs);
        this.trigger('fileListRendering', eventsArgs);
        this.listParent.appendChild(fileList);
        this.fileList.push(fileList);
        this.renderReactTemplates();
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-param */
    /**
     * Create the file list for specified files data.
     *
     * @param { FileInfo[] } fileData - Specifies the files data for file list creation.
     * @returns {void}
     */
    Uploader.prototype.createFileList = function (fileData, isSelectedFile) {
        /* eslint-enable valid-jsdoc, jsdoc/require-param */
        this.createParentUL();
        if (this.template !== '' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.template)) {
            if (this.isFormUpload()) {
                this.uploadWrapper.classList.add(FORM_UPLOAD);
                this.formCustomFileList(fileData, this.element.files);
            }
            else {
                this.createCustomfileList(fileData);
            }
        }
        else if (this.isFormUpload()) {
            this.uploadWrapper.classList.add(FORM_UPLOAD);
            this.formFileList(fileData, this.element.files);
        }
        else {
            for (var _i = 0, fileData_7 = fileData; _i < fileData_7.length; _i++) {
                var listItem = fileData_7[_i];
                var liElement = this.createElement('li', {
                    className: FILE,
                    attrs: { 'data-file-name': listItem.name, 'data-files-count': '1' }
                });
                var textContainer = this.createElement('span', { className: TEXT_CONTAINER });
                var textElement = this.createElement('span', { className: FILE_NAME, attrs: { 'title': listItem.name } });
                textElement.innerHTML = this.getFileNameOnly(listItem.name);
                var fileExtension = this.createElement('span', { className: FILE_TYPE });
                var fileType = this.getFileType(listItem.name);
                fileExtension.innerHTML = '.' + fileType;
                if (!fileType) {
                    fileExtension.classList.add('e-hidden');
                }
                if (!this.enableRtl) {
                    textContainer.appendChild(textElement);
                    textContainer.appendChild(fileExtension);
                }
                else {
                    var rtlContainer = this.createElement('span', { className: RTL_CONTAINER });
                    rtlContainer.appendChild(fileExtension);
                    rtlContainer.appendChild(textElement);
                    textContainer.appendChild(rtlContainer);
                }
                var fileSize = this.createElement('span', { className: FILE_SIZE });
                fileSize.innerHTML = this.bytesToSize(listItem.size);
                textContainer.appendChild(fileSize);
                var statusElement = this.createElement('span', { className: STATUS });
                textContainer.appendChild(statusElement);
                statusElement.innerHTML = listItem.status;
                liElement.appendChild(textContainer);
                var iconElement = this.createElement('span', { className: ' e-icons',
                    attrs: { 'tabindex': this.btnTabIndex } });
                /* istanbul ignore next */
                if (this.browserName === 'msie') {
                    iconElement.classList.add('e-msie');
                }
                iconElement.setAttribute('title', this.localizedTexts('remove'));
                liElement.appendChild(iconElement);
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(iconElement, 'click', this.removeFiles, this);
                if (listItem.statusCode === '2') {
                    statusElement.classList.add(UPLOAD_SUCCESS);
                    iconElement.classList.add(DELETE_ICON);
                    iconElement.setAttribute('title', this.localizedTexts('delete'));
                }
                else if (listItem.statusCode !== '1') {
                    statusElement.classList.remove(UPLOAD_SUCCESS);
                    statusElement.classList.add(VALIDATION_FAILS);
                }
                if (this.autoUpload && listItem.statusCode === '1' && this.asyncSettings.saveUrl !== '') {
                    statusElement.innerHTML = '';
                }
                if (!iconElement.classList.contains(DELETE_ICON)) {
                    iconElement.classList.add(REMOVE_ICON);
                }
                var index = fileData.indexOf(listItem);
                var eventArgs = {
                    element: liElement,
                    fileInfo: listItem,
                    index: index,
                    isPreload: this.isPreLoadFile(listItem)
                };
                var eventsArgs = {
                    element: liElement,
                    fileInfo: listItem,
                    index: index,
                    isPreload: this.isPreLoadFile(listItem)
                };
                this.trigger('rendering', eventArgs);
                this.trigger('fileListRendering', eventsArgs);
                this.listParent.appendChild(liElement);
                this.fileList.push(liElement);
                this.truncateName(textElement);
                var preventActionComplete = this.flag;
                if (this.isPreLoadFile(listItem)) {
                    this.flag = false;
                    this.checkActionComplete(true);
                    this.flag = preventActionComplete;
                }
            }
        }
    };
    Uploader.prototype.getSlicedName = function (nameElement) {
        var text = nameElement.textContent;
        nameElement.dataset.tail = text.slice(text.length - 10);
    };
    Uploader.prototype.setListToFileInfo = function (fileData, fileList) {
        for (var _i = 0, fileData_8 = fileData; _i < fileData_8.length; _i++) {
            var listItem = fileData_8[_i];
            listItem.list = fileList;
        }
    };
    Uploader.prototype.truncateName = function (name) {
        var nameElement = name;
        if (this.browserName !== 'edge' && nameElement.offsetWidth < nameElement.scrollWidth) {
            this.getSlicedName(nameElement);
            /* istanbul ignore next */
        }
        else if (nameElement.offsetWidth + 1 < nameElement.scrollWidth) {
            this.getSlicedName(nameElement);
        }
    };
    Uploader.prototype.getFileType = function (name) {
        var extension;
        var index = name.lastIndexOf('.');
        if (index >= 0) {
            extension = name.substring(index + 1);
        }
        return extension ? extension : '';
    };
    Uploader.prototype.getFileNameOnly = function (name) {
        var type = this.getFileType(name);
        var names = name.split('.' + type);
        return type = names[0];
    };
    Uploader.prototype.setInitialAttributes = function () {
        if (this.initialAttr.accept) {
            this.element.setAttribute('accept', this.initialAttr.accept);
        }
        if (this.initialAttr.disabled) {
            this.element.setAttribute('disabled', 'disabled');
        }
        if (this.initialAttr.multiple) {
            var newAttr = document.createAttribute('multiple');
            this.element.setAttributeNode(newAttr);
        }
    };
    Uploader.prototype.filterfileList = function (files) {
        var filterFiles = [];
        var li;
        for (var i = 0; i < files.length; i++) {
            li = this.getLiElement(files[i]);
            if (!li.classList.contains(UPLOAD_SUCCESS)) {
                filterFiles.push(files[i]);
            }
        }
        return filterFiles;
    };
    Uploader.prototype.updateStatus = function (files, status, statusCode, updateLiStatus) {
        if (updateLiStatus === void 0) { updateLiStatus = true; }
        if (!(status === '' || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(status)) && !(statusCode === '' || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(statusCode))) {
            files.status = status;
            files.statusCode = statusCode;
        }
        if (updateLiStatus) {
            var li = this.getLiElement(files);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li)) {
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li.querySelector('.' + STATUS)) && !((status === '' || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(status)))) {
                    li.querySelector('.' + STATUS).textContent = status;
                }
            }
        }
        return files;
    };
    Uploader.prototype.getLiElement = function (files) {
        var index;
        for (var i = 0; i < this.filesData.length; i++) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(files) && ((!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.filesData[i].id) &&
                !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(files.id)) ? (this.filesData[i].name === files.name &&
                this.filesData[i].id === files.id) : this.filesData[i].name === files.name)) {
                index = i;
            }
        }
        return this.fileList[index];
    };
    Uploader.prototype.createProgressBar = function (liElement) {
        var progressbarWrapper = this.createElement('span', { className: PROGRESS_WRAPPER });
        var progressBar = this.createElement('progressbar', { className: PROGRESSBAR, attrs: { value: '0', max: '100' } });
        var progressbarInnerWrapper = this.createElement('span', { className: PROGRESS_INNER_WRAPPER });
        progressBar.setAttribute('style', 'width: 0%');
        var progressbarText = this.createElement('span', { className: PROGRESSBAR_TEXT });
        progressbarText.textContent = '0%';
        progressbarInnerWrapper.appendChild(progressBar);
        progressbarWrapper.appendChild(progressbarInnerWrapper);
        progressbarWrapper.appendChild(progressbarText);
        liElement.querySelector('.' + TEXT_CONTAINER).appendChild(progressbarWrapper);
    };
    /* istanbul ignore next */
    Uploader.prototype.updateProgressbar = function (e, li) {
        if (!isNaN(Math.round((e.loaded / e.total) * 100)) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li.querySelector('.' + PROGRESSBAR))) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.progressInterval) && this.progressInterval !== '') {
                var value = (Math.round((e.loaded / e.total) * 100)) % parseInt(this.progressInterval, 10);
                if (value === 0 || value === 100) {
                    this.changeProgressValue(li, Math.round((e.loaded / e.total) * 100).toString() + '%');
                }
            }
            else {
                this.changeProgressValue(li, Math.round((e.loaded / e.total) * 100).toString() + '%');
            }
        }
    };
    Uploader.prototype.changeProgressValue = function (li, progressValue) {
        li.querySelector('.' + PROGRESSBAR).setAttribute('style', 'width:' + progressValue);
        li.querySelector('.' + PROGRESSBAR_TEXT).textContent = progressValue;
    };
    Uploader.prototype.uploadInProgress = function (e, files, customUI, request) {
        var li = this.getLiElement(files);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li) && (!customUI)) {
            return;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li)) {
            /* istanbul ignore next */
            if (files.statusCode === '5') {
                this.cancelUploadingFile(files, e, request, li);
            }
            if (!(li.querySelectorAll('.' + PROGRESS_WRAPPER).length > 0) && li.querySelector('.' + STATUS)) {
                li.querySelector('.' + STATUS).classList.add(UPLOAD_INPROGRESS);
                this.createProgressBar(li);
                this.updateProgressBarClasses(li, UPLOAD_INPROGRESS);
                li.querySelector('.' + STATUS).classList.remove(UPLOAD_FAILED);
            }
            this.updateProgressbar(e, li);
            var iconEle = li.querySelector('.' + REMOVE_ICON);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(iconEle)) {
                iconEle.classList.add(ABORT_ICON, UPLOAD_INPROGRESS);
                iconEle.setAttribute('title', this.localizedTexts('abort'));
                iconEle.classList.remove(REMOVE_ICON);
            }
        }
        else {
            this.cancelUploadingFile(files, e, request);
        }
        var args = { e: e, operation: 'upload', file: this.updateStatus(files, this.localizedTexts('inProgress'), '3') };
        this.trigger('progress', args);
    };
    /* istanbul ignore next */
    Uploader.prototype.cancelUploadingFile = function (files, e, request, li) {
        var _this = this;
        if (files.statusCode === '5') {
            var eventArgs = {
                event: e,
                fileData: files,
                cancel: false,
                customFormData: []
            };
            this.trigger('canceling', eventArgs, function (eventArgs) {
                if (eventArgs.cancel) {
                    files.statusCode = '3';
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li)) {
                        var spinnerTarget = li.querySelector('.' + ABORT_ICON);
                        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(spinnerTarget)) {
                            Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__["h" /* hideSpinner */])(spinnerTarget);
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(li.querySelector('.e-spinner-pane'));
                        }
                    }
                }
                else {
                    request.emitError = false;
                    request.httpRequest.abort();
                    var formData = new FormData();
                    if (files.statusCode === '5') {
                        var name_1 = _this.element.getAttribute('name');
                        formData.append(name_1, files.name);
                        formData.append('cancel-uploading', files.name);
                        _this.updateFormData(formData, eventArgs.customFormData);
                        var ajax = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["a" /* Ajax */](_this.asyncSettings.removeUrl, 'POST', true, null);
                        ajax.emitError = false;
                        ajax.onLoad = function (e) {
                            _this.removecanceledFile(e, files);
                            return {};
                        };
                        ajax.send(formData);
                    }
                }
            });
        }
    };
    Uploader.prototype.removecanceledFile = function (e, file) {
        var liElement = this.getLiElement(file);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement) || liElement.querySelector('.' + RETRY_ICON) || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement.querySelector('.' + ABORT_ICON))) {
            return;
        }
        this.updateStatus(file, this.localizedTexts('fileUploadCancel'), '5');
        this.renderFailureState(e, file, liElement);
        var spinnerTarget = liElement.querySelector('.' + REMOVE_ICON);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement)) {
            Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__["h" /* hideSpinner */])(spinnerTarget);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement.querySelector('.e-spinner-pane'))) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(liElement.querySelector('.e-spinner-pane'));
            }
        }
        var requestResponse = e && e.currentTarget ? this.getResponse(e) : null;
        var args = { event: e, response: requestResponse, operation: 'cancel', file: file };
        this.trigger('success', args);
    };
    Uploader.prototype.renderFailureState = function (e, file, liElement) {
        var _this = this;
        this.updateProgressBarClasses(liElement, UPLOAD_FAILED);
        this.removeProgressbar(liElement, 'failure');
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement.querySelector('.e-file-status'))) {
            liElement.querySelector('.e-file-status').classList.add(UPLOAD_FAILED);
        }
        var deleteIcon = liElement.querySelector('.' + ABORT_ICON);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(deleteIcon)) {
            return;
        }
        deleteIcon.classList.remove(ABORT_ICON, UPLOAD_INPROGRESS);
        deleteIcon.classList.add(REMOVE_ICON);
        deleteIcon.setAttribute('title', this.localizedTexts('remove'));
        this.pauseButton = this.createElement('span', { className: 'e-icons e-file-reload-btn', attrs: { 'tabindex': this.btnTabIndex } });
        deleteIcon.parentElement.insertBefore(this.pauseButton, deleteIcon);
        this.pauseButton.setAttribute('title', this.localizedTexts('retry'));
        var retryElement = liElement.querySelector('.' + RETRY_ICON);
        /* istanbul ignore next */
        retryElement.addEventListener('click', function (e) {
            _this.reloadcanceledFile(e, file, liElement, false);
        }, false);
    };
    Uploader.prototype.reloadcanceledFile = function (e, file, liElement, custom) {
        file.statusCode = '1';
        file.status = this.localizedTexts('readyToUploadMessage');
        if (!custom) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement.querySelector('.' + STATUS))) {
                liElement.querySelector('.' + STATUS).classList.remove(UPLOAD_FAILED);
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement.querySelector('.' + RETRY_ICON))) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(liElement.querySelector('.' + RETRY_ICON));
            }
            this.pauseButton = null;
        }
        /* istanbul ignore next */
        liElement.classList.add(RESTRICT_RETRY);
        this.upload([file]);
    };
    /* istanbul ignore next */
    Uploader.prototype.uploadComplete = function (e, file, customUI) {
        var status = e.target;
        if (status.readyState === 4 && status.status >= 200 && status.status <= 299) {
            var li = this.getLiElement(file);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li) && (!customUI || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(customUI))) {
                return;
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li)) {
                this.updateProgressBarClasses(li, UPLOAD_SUCCESS);
                this.removeProgressbar(li, 'success');
                var iconEle = li.querySelector('.' + ABORT_ICON);
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(iconEle)) {
                    iconEle.classList.add(DELETE_ICON);
                    iconEle.setAttribute('title', this.localizedTexts('delete'));
                    iconEle.classList.remove(ABORT_ICON);
                    iconEle.classList.remove(UPLOAD_INPROGRESS);
                }
            }
            this.raiseSuccessEvent(e, file);
        }
        else {
            this.uploadFailed(e, file);
        }
    };
    Uploader.prototype.getResponse = function (e) {
        var target = e.currentTarget;
        var response = {
            readyState: target.readyState,
            statusCode: target.status,
            statusText: target.statusText,
            headers: target.getAllResponseHeaders(),
            withCredentials: target.withCredentials
        };
        return response;
    };
    Uploader.prototype.raiseSuccessEvent = function (e, file) {
        var _this = this;
        var response = e && e.currentTarget ? this.getResponse(e) : null;
        var statusMessage = this.localizedTexts('uploadSuccessMessage');
        var args = {
            e: e, response: response, operation: 'upload', file: this.updateStatus(file, statusMessage, '2', false), statusText: statusMessage
        };
        var liElement = this.getLiElement(file);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement)) {
            var spinnerEle = liElement.querySelector('.' + SPINNER_PANE);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(spinnerEle)) {
                Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__["h" /* hideSpinner */])(liElement);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(spinnerEle);
            }
        }
        this.trigger('success', args, function (args) {
            _this.updateStatus(file, args.statusText, '2');
            _this.uploadedFilesData.push(file);
            _this.trigger('change', { file: _this.uploadedFilesData });
            _this.checkActionButtonStatus();
            if (_this.fileList.length > 0) {
                if ((!(_this.getLiElement(file)).classList.contains(RESTRICT_RETRY))) {
                    _this.uploadSequential();
                    _this.checkActionComplete(true);
                }
                else {
                    /* istanbul ignore next */
                    (_this.getLiElement(file)).classList.remove(RESTRICT_RETRY);
                }
            }
        });
    };
    Uploader.prototype.uploadFailed = function (e, file) {
        var _this = this;
        var li = this.getLiElement(file);
        var response = e && e.currentTarget ? this.getResponse(e) : null;
        var statusMessage = this.localizedTexts('uploadFailedMessage');
        var args = {
            e: e, response: response, operation: 'upload', file: this.updateStatus(file, statusMessage, '0', false), statusText: statusMessage
        };
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li)) {
            this.renderFailureState(e, file, li);
        }
        this.trigger('failure', args, function (args) {
            _this.updateStatus(file, args.statusText, '0');
            _this.checkActionButtonStatus();
            _this.uploadSequential();
            _this.checkActionComplete(true);
        });
    };
    Uploader.prototype.uploadSequential = function () {
        if (this.sequentialUpload) {
            if (this.autoUpload) {
                /* istanbul ignore next */
                this.checkAutoUpload(this.filesData);
            }
            else {
                this.uploadButtonClick();
            }
        }
    };
    Uploader.prototype.checkActionComplete = function (increment) {
        if (increment) {
            ++this.actionCompleteCount;
        }
        else {
            --this.actionCompleteCount;
        }
        this.raiseActionComplete();
    };
    Uploader.prototype.raiseActionComplete = function () {
        if ((this.filesData.length === this.actionCompleteCount) && this.flag) {
            this.flag = false;
            var eventArgs = {
                fileData: []
            };
            eventArgs.fileData = this.getSelectedFileStatus(this.selectedFiles);
            this.trigger('actionComplete', eventArgs);
        }
    };
    Uploader.prototype.getSelectedFileStatus = function (selectedFiles) {
        var matchFiles = [];
        var matchFilesIndex = 0;
        for (var selectFileIndex = 0; selectFileIndex < selectedFiles.length; selectFileIndex++) {
            var selectedFileData = selectedFiles[selectFileIndex];
            for (var fileDataIndex = 0; fileDataIndex < this.filesData.length; fileDataIndex++) {
                if (this.filesData[fileDataIndex].name === selectedFileData.name) {
                    matchFiles[matchFilesIndex] = this.filesData[fileDataIndex];
                    ++matchFilesIndex;
                }
            }
        }
        return matchFiles;
    };
    Uploader.prototype.updateProgressBarClasses = function (li, className) {
        var progressBar = li.querySelector('.' + PROGRESSBAR);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(progressBar)) {
            progressBar.classList.add(className);
        }
    };
    Uploader.prototype.removeProgressbar = function (li, callType) {
        var _this = this;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li.querySelector('.' + PROGRESS_WRAPPER))) {
            this.progressAnimation = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["b" /* Animation */]({ duration: 1250 });
            this.progressAnimation.animate(li.querySelector('.' + PROGRESS_WRAPPER), { name: 'FadeOut' });
            this.progressAnimation.animate(li.querySelector('.' + PROGRESSBAR_TEXT), { name: 'FadeOut' });
            setTimeout(function () {
                _this.animateProgressBar(li, callType);
            }, 750);
        }
    };
    /* istanbul ignore next */
    Uploader.prototype.animateProgressBar = function (li, callType) {
        if (callType === 'success') {
            li.classList.add(UPLOAD_SUCCESS);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li.querySelector('.' + STATUS))) {
                li.querySelector('.' + STATUS).classList.remove(UPLOAD_INPROGRESS);
                this.progressAnimation.animate(li.querySelector('.' + STATUS), { name: 'FadeIn' });
                li.querySelector('.' + STATUS).classList.add(UPLOAD_SUCCESS);
            }
        }
        else {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(li.querySelector('.' + STATUS))) {
                li.querySelector('.' + STATUS).classList.remove(UPLOAD_INPROGRESS);
                this.progressAnimation.animate(li.querySelector('.' + STATUS), { name: 'FadeIn' });
                li.querySelector('.' + STATUS).classList.add(UPLOAD_FAILED);
            }
        }
        if (li.querySelector('.' + PROGRESS_WRAPPER)) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(li.querySelector('.' + PROGRESS_WRAPPER));
        }
    };
    Uploader.prototype.setExtensions = function (extensions) {
        if (extensions !== '' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(extensions)) {
            this.element.setAttribute('accept', extensions);
        }
        else {
            this.element.removeAttribute('accept');
        }
    };
    Uploader.prototype.templateComplier = function (uploadTemplate) {
        if (uploadTemplate) {
            try {
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])(uploadTemplate, document).length) {
                    return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])(uploadTemplate, document).innerHTML.trim());
                }
                else {
                    return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(uploadTemplate);
                }
            }
            catch (exception) {
                return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(uploadTemplate);
            }
        }
        return undefined;
    };
    Uploader.prototype.setRTL = function () {
        if (this.enableRtl) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.uploadWrapper], RTL);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.uploadWrapper], RTL);
        }
    };
    Uploader.prototype.localizedTexts = function (localeText) {
        this.l10n.setLocale(this.locale);
        return this.l10n.getConstant(localeText);
    };
    Uploader.prototype.setControlStatus = function () {
        if (!this.enabled) {
            this.uploadWrapper.classList.add(DISABLED);
            this.element.setAttribute('disabled', 'disabled');
            this.browseButton.setAttribute('disabled', 'disabled');
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.clearButton)) {
                this.clearButton.setAttribute('disabled', 'disabled');
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.uploadButton)) {
                this.uploadButton.setAttribute('disabled', 'disabled');
            }
        }
        else {
            if (this.uploadWrapper.classList.contains(DISABLED)) {
                this.uploadWrapper.classList.remove(DISABLED);
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.browseButton) && this.element.hasAttribute('disabled')) {
                this.element.removeAttribute('disabled');
                this.browseButton.removeAttribute('disabled');
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.clearButton) && this.clearButton.hasAttribute('disabled')) {
                this.clearButton.removeAttribute('disabled');
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.uploadButton) && this.uploadButton.hasAttribute('disabled')) {
                this.uploadButton.hasAttribute('disabled');
            }
        }
    };
    Uploader.prototype.checkHTMLAttributes = function (isDynamic) {
        var attributes = isDynamic ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.htmlAttributes) ? [] : Object.keys(this.htmlAttributes) :
            ['accept', 'multiple', 'disabled'];
        for (var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++) {
            var prop = attributes_1[_i];
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.getAttribute(prop))) {
                switch (prop) {
                    case 'accept':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.uploaderOptions) || (this.uploaderOptions['allowedExtensions'] === undefined))
                            || isDynamic) {
                            this.setProperties({ allowedExtensions: this.element.getAttribute('accept') }, !isDynamic);
                            this.initialAttr.accept = this.allowedExtensions;
                        }
                        break;
                    case 'multiple':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.uploaderOptions) || (this.uploaderOptions['multiple'] === undefined)) || isDynamic) {
                            var isMutiple = this.element.getAttribute(prop) === 'multiple' ||
                                this.element.getAttribute(prop) === '' || this.element.getAttribute(prop) === 'true' ? true : false;
                            this.setProperties({ multiple: isMutiple }, !isDynamic);
                            this.initialAttr.multiple = true;
                        }
                        break;
                    case 'disabled':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.uploaderOptions) || (this.uploaderOptions['enabled'] === undefined)) || isDynamic) {
                            var isDisabled = this.element.getAttribute(prop) === 'disabled' ||
                                this.element.getAttribute(prop) === '' || this.element.getAttribute(prop) === 'true' ? false : true;
                            this.setProperties({ enabled: isDisabled }, !isDynamic);
                            this.initialAttr.disabled = true;
                        }
                }
            }
        }
    };
    Uploader.prototype.chunkUpload = function (file, custom, fileIndex) {
        var start = 0;
        var end = Math.min(this.asyncSettings.chunkSize, file.size);
        var index = 0;
        var blob = file.rawFile.slice(start, end);
        var metaData = { chunkIndex: index, blob: blob, file: file, start: start, end: end, retryCount: 0, request: null };
        this.sendRequest(file, metaData, custom, fileIndex);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Uploader.prototype.sendRequest = function (file, metaData, custom, fileIndex) {
        var _this = this;
        var formData = new FormData();
        var blob = file.rawFile.slice(metaData.start, metaData.end);
        formData.append('chunkFile', blob, file.name);
        formData.append(this.uploaderName, blob, file.name);
        formData.append('chunk-index', metaData.chunkIndex.toString());
        formData.append('chunkIndex', metaData.chunkIndex.toString());
        var totalChunk = Math.max(Math.ceil(file.size / this.asyncSettings.chunkSize), 1);
        formData.append('total-chunk', totalChunk.toString());
        formData.append('totalChunk', totalChunk.toString());
        var ajax = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["a" /* Ajax */]({ url: this.asyncSettings.saveUrl, type: 'POST', async: true, contentType: null });
        ajax.emitError = false;
        ajax.onLoad = function (e) {
            _this.chunkUploadComplete(e, metaData, custom);
            return {};
        };
        ajax.onUploadProgress = function (e) {
            _this.chunkUploadInProgress(e, metaData, custom);
            return {};
        };
        var eventArgs = {
            fileData: file,
            customFormData: [],
            cancel: false,
            chunkSize: this.asyncSettings.chunkSize === 0 ? null : this.asyncSettings.chunkSize
        };
        ajax.beforeSend = function (e) {
            eventArgs.currentRequest = ajax.httpRequest;
            eventArgs.currentChunkIndex = metaData.chunkIndex;
            if (eventArgs.currentChunkIndex === 0) {
                // This event is currently not required but to avoid breaking changes for previous customer, we have included.
                _this.trigger('uploading', eventArgs, function (eventArgs) {
                    _this.uploadingEventCallback(formData, eventArgs, e, file);
                });
            }
            else {
                _this.trigger('chunkUploading', eventArgs, function (eventArgs) {
                    _this.uploadingEventCallback(formData, eventArgs, e, file);
                });
            }
        };
        /* istanbul ignore next */
        ajax.onError = function (e) {
            _this.chunkUploadFailed(e, metaData, custom);
            return {};
        };
        ajax.send(formData);
        metaData.request = ajax;
    };
    Uploader.prototype.uploadingEventCallback = function (formData, eventArgs, e, file) {
        if (eventArgs.cancel) {
            this.eventCancelByArgs(e, eventArgs, file);
        }
        else {
            this.updateFormData(formData, eventArgs.customFormData);
        }
    };
    Uploader.prototype.eventCancelByArgs = function (e, eventArgs, file) {
        var _this = this;
        e.cancel = true;
        if (eventArgs.fileData.statusCode === '5') {
            return;
        }
        eventArgs.fileData.statusCode = '5';
        eventArgs.fileData.status = this.localizedTexts('fileUploadCancel');
        var liElement = this.getLiElement(eventArgs.fileData);
        if (liElement) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement.querySelector('.' + STATUS))) {
                liElement.querySelector('.' + STATUS).innerHTML = this.localizedTexts('fileUploadCancel');
                liElement.querySelector('.' + STATUS).classList.add(UPLOAD_FAILED);
            }
            this.pauseButton = this.createElement('span', { className: 'e-icons e-file-reload-btn', attrs: { 'tabindex': this.btnTabIndex } });
            var removeIcon = liElement.querySelector('.' + REMOVE_ICON);
            if (removeIcon) {
                removeIcon.parentElement.insertBefore(this.pauseButton, removeIcon);
            }
            this.pauseButton.setAttribute('title', this.localizedTexts('retry'));
            /* istanbul ignore next */
            this.pauseButton.addEventListener('click', function (e) {
                _this.reloadcanceledFile(e, file, liElement);
            }, false);
            this.checkActionButtonStatus();
        }
    };
    Uploader.prototype.checkChunkUpload = function () {
        return (this.asyncSettings.chunkSize <= 0 || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.asyncSettings.chunkSize)) ? false : true;
    };
    Uploader.prototype.chunkUploadComplete = function (e, metaData, custom) {
        var _this = this;
        var response = e.target;
        var liElement;
        if (response.readyState === 4 && response.status >= 200 && response.status < 300) {
            var requestResponse = e && e.currentTarget ? this.getResponse(e) : null;
            var totalChunk = Math.max(Math.ceil(metaData.file.size / this.asyncSettings.chunkSize), 1);
            var eventArgs = {
                event: e,
                file: metaData.file,
                chunkIndex: metaData.chunkIndex,
                totalChunk: totalChunk,
                chunkSize: this.asyncSettings.chunkSize,
                response: requestResponse
            };
            this.trigger('chunkSuccess', eventArgs);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(custom) || !custom) {
                liElement = this.getLiElement(metaData.file);
            }
            this.updateMetaData(metaData);
            if (metaData.end === metaData.file.size) {
                metaData.file.statusCode = '3';
            }
            if (metaData.file.statusCode === '5') {
                var eventArgs_1 = { event: e, fileData: metaData.file, cancel: false, customFormData: [] };
                this.trigger('canceling', eventArgs_1, function (eventArgs) {
                    /* istanbul ignore next */
                    if (eventArgs.cancel) {
                        metaData.file.statusCode = '3';
                        var spinnerTarget = liElement.querySelector('.' + ABORT_ICON);
                        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(spinnerTarget)) {
                            Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__["h" /* hideSpinner */])(spinnerTarget);
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(liElement.querySelector('.e-spinner-pane'));
                        }
                        _this.sendNextRequest(metaData);
                    }
                    else {
                        metaData.request.emitError = false;
                        response.abort();
                        var formData = new FormData();
                        var name_2 = _this.element.getAttribute('name');
                        formData.append(name_2, metaData.file.name);
                        formData.append('cancel-uploading', metaData.file.name);
                        formData.append('cancelUploading', metaData.file.name);
                        _this.updateFormData(formData, eventArgs.customFormData);
                        var ajax = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["a" /* Ajax */](_this.asyncSettings.removeUrl, 'POST', true, null);
                        ajax.emitError = false;
                        ajax.onLoad = function (e) {
                            _this.removeChunkFile(e, metaData, custom);
                            return {};
                        };
                        ajax.send(formData);
                    }
                });
            }
            else {
                if ((totalChunk - 1) === metaData.chunkIndex && totalChunk > metaData.chunkIndex) {
                    var index = this.pausedData.indexOf(metaData);
                    if (index >= 0) {
                        this.pausedData.splice(index, 1);
                    }
                    if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.template) && (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(custom) || !custom) && liElement) {
                        if (liElement && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement.querySelector('.' + PAUSE_UPLOAD))) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(liElement.querySelector('.' + PAUSE_UPLOAD));
                        }
                        this.removeChunkProgressBar(metaData);
                    }
                    this.raiseSuccessEvent(e, metaData.file);
                    return;
                }
                if (metaData.file.statusCode !== '4') {
                    this.sendNextRequest(metaData);
                }
            }
        }
        else {
            this.chunkUploadFailed(e, metaData);
        }
    };
    Uploader.prototype.sendNextRequest = function (metaData) {
        metaData.start = metaData.end;
        metaData.end += this.asyncSettings.chunkSize;
        metaData.end = Math.min(metaData.end, metaData.file.size);
        metaData.chunkIndex += 1;
        this.sendRequest(metaData.file, metaData);
    };
    Uploader.prototype.removeChunkFile = function (e, metaData, custom) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.template) && (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(custom) && !custom)) {
            var liElement = this.getLiElement(metaData.file);
            var deleteIcon = liElement.querySelector('.' + ABORT_ICON);
            var spinnerTarget = deleteIcon;
            this.updateStatus(metaData.file, this.localizedTexts('fileUploadCancel'), '5');
            this.updateProgressBarClasses(liElement, UPLOAD_FAILED);
            this.removeProgressbar(liElement, 'failure');
            deleteIcon && deleteIcon.classList.remove(ABORT_ICON);
            deleteIcon && deleteIcon.classList.add(REMOVE_ICON);
            deleteIcon && deleteIcon.setAttribute('title', this.localizedTexts('remove'));
            var pauseIcon = liElement.querySelector('.' + PAUSE_UPLOAD);
            pauseIcon && pauseIcon.classList.add(RETRY_ICON);
            pauseIcon && pauseIcon.classList.remove(PAUSE_UPLOAD);
            pauseIcon && pauseIcon.setAttribute('title', this.localizedTexts('retry'));
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement) && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(deleteIcon)
                && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement.querySelector('.e-spinner-pane'))) {
                Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__["h" /* hideSpinner */])(spinnerTarget);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(liElement.querySelector('.e-spinner-pane'));
            }
        }
    };
    Uploader.prototype.pauseUpload = function (metaData, e, custom) {
        metaData.file.statusCode = '4';
        metaData.file.status = this.localizedTexts('pause');
        this.updateMetaData(metaData);
        var eventArgs = {
            event: e ? e : null,
            file: metaData.file,
            chunkIndex: metaData.chunkIndex,
            chunkCount: Math.round(metaData.file.size / this.asyncSettings.chunkSize),
            chunkSize: this.asyncSettings.chunkSize
        };
        this.abortUpload(metaData, custom, eventArgs);
    };
    Uploader.prototype.abortUpload = function (metaData, custom, eventArgs) {
        if (metaData.file.statusCode !== '4') {
            metaData.request.emitError = false;
            metaData.request.httpRequest.abort();
        }
        var liElement = this.getLiElement(metaData.file);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.template) && (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(custom) || !custom)) {
            var targetElement = liElement.querySelector('.' + PAUSE_UPLOAD);
            targetElement.classList.remove(PAUSE_UPLOAD);
            targetElement.classList.add(RESUME_UPLOAD);
            targetElement.setAttribute('title', this.localizedTexts('resume'));
            targetElement.nextElementSibling.classList.add(REMOVE_ICON);
            targetElement.nextElementSibling.classList.remove(ABORT_ICON);
            targetElement.nextElementSibling.setAttribute('title', this.localizedTexts('remove'));
        }
        for (var i = 0; i < this.pausedData.length; i++) {
            if (this.pausedData[i].file.name === metaData.file.name) {
                this.pausedData.splice(i, 1);
            }
        }
        this.pausedData.push(metaData);
        this.trigger('pausing', eventArgs);
    };
    Uploader.prototype.resumeUpload = function (metaData, e, custom) {
        var liElement = this.getLiElement(metaData.file);
        var targetElement;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement)) {
            targetElement = liElement.querySelector('.' + RESUME_UPLOAD);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(targetElement) && (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(custom) || !custom)) {
            targetElement.classList.remove(RESUME_UPLOAD);
            targetElement.classList.add(PAUSE_UPLOAD);
            targetElement.setAttribute('title', this.localizedTexts('pause'));
            targetElement.nextElementSibling.classList.remove(REMOVE_ICON);
            targetElement.nextElementSibling.classList.add(ABORT_ICON);
            targetElement.nextElementSibling.setAttribute('title', this.localizedTexts('abort'));
        }
        metaData.file.status = this.localizedTexts('inProgress');
        metaData.file.statusCode = '3';
        this.updateMetaData(metaData);
        var eventArgs = {
            event: e ? e : null,
            file: metaData.file,
            chunkIndex: metaData.chunkIndex,
            chunkCount: Math.round(metaData.file.size / this.asyncSettings.chunkSize),
            chunkSize: this.asyncSettings.chunkSize
        };
        this.trigger('resuming', eventArgs);
        for (var i = 0; i < this.pausedData.length; i++) {
            if (this.pausedData[i].end === this.pausedData[i].file.size) {
                this.chunkUploadComplete(e, metaData, custom);
            }
            else {
                if (this.pausedData[i].file.name === metaData.file.name) {
                    this.pausedData[i].start = this.pausedData[i].end;
                    this.pausedData[i].end = this.pausedData[i].end + this.asyncSettings.chunkSize;
                    this.pausedData[i].end = Math.min(this.pausedData[i].end, this.pausedData[i].file.size);
                    this.pausedData[i].chunkIndex = this.pausedData[i].chunkIndex + 1;
                    this.sendRequest(this.pausedData[i].file, this.pausedData[i], custom);
                }
            }
        }
    };
    Uploader.prototype.updateMetaData = function (metaData) {
        if (this.uploadMetaData.indexOf(metaData) === -1) {
            this.uploadMetaData.push(metaData);
        }
        else {
            this.uploadMetaData.splice(this.uploadMetaData.indexOf(metaData), 1);
            this.uploadMetaData.push(metaData);
        }
    };
    Uploader.prototype.removeChunkProgressBar = function (metaData) {
        var liElement = this.getLiElement(metaData.file);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement)) {
            this.updateProgressBarClasses(liElement, UPLOAD_SUCCESS);
            this.removeProgressbar(liElement, 'success');
            var cancelButton = liElement.querySelector('.' + ABORT_ICON);
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(cancelButton)) {
                cancelButton.classList.add(DELETE_ICON);
                cancelButton.setAttribute('title', this.localizedTexts('delete'));
                cancelButton.classList.remove(ABORT_ICON, UPLOAD_INPROGRESS);
            }
        }
    };
    Uploader.prototype.chunkUploadFailed = function (e, metaData, custom) {
        var _this = this;
        var chunkCount = Math.max(Math.ceil(metaData.file.size / this.asyncSettings.chunkSize), 1);
        var liElement;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.template) && (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(custom) || !custom)) {
            liElement = this.getLiElement(metaData.file);
        }
        var requestResponse = e && e.currentTarget ? this.getResponse(e) : null;
        var eventArgs = {
            event: e,
            file: metaData.file,
            chunkIndex: metaData.chunkIndex,
            totalChunk: chunkCount,
            chunkSize: this.asyncSettings.chunkSize,
            cancel: false,
            response: requestResponse
        };
        this.trigger('chunkFailure', eventArgs, function (eventArgs) {
            // To prevent triggering of failure event
            if (!eventArgs.cancel) {
                if (metaData.retryCount < _this.asyncSettings.retryCount) {
                    setTimeout(function () {
                        _this.retryRequest(liElement, metaData, custom);
                    }, _this.asyncSettings.retryAfterDelay);
                }
                else {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement)) {
                        var pauseButton = liElement.querySelector('.' + PAUSE_UPLOAD) ?
                            liElement.querySelector('.' + PAUSE_UPLOAD) : liElement.querySelector('.' + RESUME_UPLOAD);
                        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(pauseButton)) {
                            pauseButton.classList.add(RETRY_ICON);
                            pauseButton.classList.remove(PAUSE_UPLOAD, RESUME_UPLOAD);
                        }
                        _this.updateProgressBarClasses(liElement, UPLOAD_FAILED);
                        _this.removeProgressbar(liElement, 'failure');
                        liElement.querySelector('.e-icons').classList.remove(UPLOAD_INPROGRESS);
                        var iconElement = liElement.querySelector('.' + ABORT_ICON) ?
                            liElement.querySelector('.' + ABORT_ICON) : liElement.querySelector('.' + REMOVE_ICON);
                        iconElement.classList.remove(ABORT_ICON);
                        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement.querySelector('.' + PAUSE_UPLOAD))) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(liElement.querySelector('.' + PAUSE_UPLOAD));
                        }
                        if (metaData.start > 0) {
                            iconElement.classList.add(DELETE_ICON);
                            iconElement.setAttribute('title', _this.localizedTexts('delete'));
                        }
                        else {
                            iconElement.classList.add(REMOVE_ICON);
                            iconElement.setAttribute('title', _this.localizedTexts('remove'));
                        }
                    }
                    metaData.retryCount = 0;
                    var file_1 = metaData.file;
                    var failureMessage = _this.localizedTexts('uploadFailedMessage');
                    var args = {
                        e: e, response: requestResponse,
                        operation: 'upload',
                        file: _this.updateStatus(file_1, failureMessage, '0', false),
                        statusText: failureMessage
                    };
                    _this.trigger('failure', args, function (args) {
                        _this.updateStatus(file_1, args.statusText, '0');
                        _this.uploadSequential();
                        _this.checkActionComplete(true);
                    });
                }
            }
        });
    };
    Uploader.prototype.retryRequest = function (liElement, metaData, custom) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.template) && (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(custom) || !custom) && liElement) {
            this.updateProgressBarClasses(liElement, UPLOAD_FAILED);
        }
        metaData.retryCount += 1;
        this.sendRequest(metaData.file, metaData);
    };
    Uploader.prototype.checkPausePlayAction = function (e) {
        var targetElement = e.target;
        var selectedElement = e.target.parentElement;
        var index = this.fileList.indexOf(selectedElement);
        var fileData = this.filesData[index];
        var metaData = this.getCurrentMetaData(fileData);
        if (targetElement.classList.contains(PAUSE_UPLOAD)) {
            /* istanbul ignore next */
            this.pauseUpload(metaData, e);
        }
        else if (targetElement.classList.contains(RESUME_UPLOAD)) {
            /* istanbul ignore next */
            this.resumeUpload(metaData, e);
        }
        else if (targetElement.classList.contains(RETRY_ICON)) {
            if (metaData.file.status === this.localizedTexts('fileUploadCancel')) {
                this.retryUpload(metaData, false);
            }
            else {
                this.retryUpload(metaData, true);
            }
        }
    };
    Uploader.prototype.retryUpload = function (metaData, fromcanceledStage) {
        if (fromcanceledStage) {
            metaData.end = metaData.end + this.asyncSettings.chunkSize;
            metaData.start = metaData.start + this.asyncSettings.chunkSize;
            this.sendRequest(metaData.file, metaData);
        }
        else {
            metaData.file.statusCode = '1';
            metaData.file.status = this.localizedTexts('readyToUploadMessage');
            this.chunkUpload(metaData.file);
        }
        /* istanbul ignore next */
        (this.getLiElement(metaData.file)).classList.add(RESTRICT_RETRY);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Uploader.prototype.chunkUploadInProgress = function (e, metaData, custom) {
        var _this = this;
        if (metaData.file.statusCode === '4') {
            return;
        }
        if (metaData.file.statusCode !== '4' && metaData.file.statusCode !== '5') {
            metaData.file.statusCode = '3';
            metaData.file.status = this.localizedTexts('inProgress');
        }
        this.updateMetaData(metaData);
        var liElement = this.getLiElement(metaData.file);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement)) {
            return;
        }
        var retryElement = liElement.querySelector('.' + RETRY_ICON);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(retryElement)) {
            retryElement.classList.add(PAUSE_UPLOAD);
            retryElement.setAttribute('title', this.localizedTexts('pause'));
            retryElement.classList.remove(RETRY_ICON);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement)) {
            if (!(liElement.querySelectorAll('.' + PROGRESS_WRAPPER).length > 0)) {
                var statusElement = liElement.querySelector('.' + STATUS);
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.template)) {
                    statusElement.classList.add(UPLOAD_INPROGRESS);
                    statusElement.classList.remove(UPLOAD_FAILED);
                    this.createProgressBar(liElement);
                    this.updateProgressBarClasses(liElement, UPLOAD_INPROGRESS);
                }
                var clearIcon = liElement.querySelector('.' + REMOVE_ICON) ? liElement.querySelector('.' + REMOVE_ICON) :
                    liElement.querySelector('.' + DELETE_ICON);
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(clearIcon)) {
                    clearIcon.classList.add(ABORT_ICON);
                    clearIcon.setAttribute('title', this.localizedTexts('abort'));
                    clearIcon.classList.remove(REMOVE_ICON);
                }
            }
            if (!isNaN(Math.round((e.loaded / e.total) * 100)) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.template) && metaData.file.statusCode !== '4') {
                var progressVal = void 0;
                var totalChunks = Math.ceil(metaData.file.size / this.asyncSettings.chunkSize) - 1;
                if (this.asyncSettings.chunkSize && totalChunks) {
                    progressVal = Math.round(metaData.chunkIndex / totalChunks * 100);
                    this.changeProgressValue(liElement, progressVal.toString() + '%');
                }
            }
            if (metaData.chunkIndex === 0) {
                this.checkActionButtonStatus();
            }
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement.querySelector('.' + PAUSE_UPLOAD)) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.template)
            && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement.querySelector('.' + DELETE_ICON))) {
            this.pauseButton = this.createElement('span', { className: 'e-icons e-file-pause-btn', attrs: { 'tabindex': this.btnTabIndex } });
            if (this.browserName === 'msie') {
                this.pauseButton.classList.add('e-msie');
            }
            var abortIcon = liElement.querySelector('.' + ABORT_ICON);
            abortIcon.parentElement.insertBefore(this.pauseButton, abortIcon);
            this.pauseButton.setAttribute('title', this.localizedTexts('pause'));
            this.pauseButton.addEventListener('click', function (e) {
                _this.checkPausePlayAction(e);
            }, false);
        }
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */
    /**
     * It is used to convert bytes value into kilobytes or megabytes depending on the size based
     * on [binary prefix](https://en.wikipedia.org/wiki/Binary_prefix).
     *
     * @param { number } bytes - Specifies the file size in bytes.
     * @returns {string}
     */
    Uploader.prototype.bytesToSize = function (bytes) {
        var i = -1;
        if (!bytes) {
            return '0.0 KB';
        }
        do {
            bytes = bytes / 1024;
            i++;
        } while (bytes > 99);
        if (i >= 2) {
            bytes = bytes * 1024;
            i = 1;
        }
        return Math.max(bytes, 0).toFixed(1) + ' ' + ['KB', 'MB'][i];
    };
    /**
     * Allows you to sort the file data alphabetically based on its file name clearly.
     *
     * @param { FileList } filesData - specifies the files data for upload.
     * @returns {File[]}
     */
    /* istanbul ignore next */
    Uploader.prototype.sortFileList = function (filesData) {
        filesData = filesData ? filesData : this.sortFilesList;
        var files = filesData;
        var fileNames = [];
        for (var i = 0; i < files.length; i++) {
            fileNames.push(files[i].name);
        }
        var sortedFileNames = fileNames.sort();
        var sortedFilesData = [];
        for (var _i = 0, sortedFileNames_1 = sortedFileNames; _i < sortedFileNames_1.length; _i++) {
            var name_3 = sortedFileNames_1[_i];
            for (var i = 0; i < files.length; i++) {
                if (name_3 === files[i].name) {
                    sortedFilesData.push(files[i]);
                }
            }
        }
        return sortedFilesData;
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */
    /**
     * Removes the component from the DOM and detaches all its related event handlers. Also it removes the attributes and classes.
     *
     * @method destroy
     * @returns {void}
     */
    Uploader.prototype.destroy = function () {
        this.element.value = null;
        this.clearTemplate();
        this.clearAll();
        this.unWireEvents();
        this.unBindDropEvents();
        if (this.multiple) {
            this.element.removeAttribute('multiple');
        }
        if (!this.enabled) {
            this.element.removeAttribute('disabled');
        }
        this.element.removeAttribute('accept');
        this.setInitialAttributes();
        var attributes = ['aria-label', 'directory', 'webkitdirectory', 'tabindex'];
        for (var _i = 0, attributes_2 = attributes; _i < attributes_2.length; _i++) {
            var key = attributes_2[_i];
            this.element.removeAttribute(key);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.uploadWrapper)) {
            this.uploadWrapper.parentElement.appendChild(this.element);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.uploadWrapper);
        }
        this.uploadWrapper = null;
        _super.prototype.destroy.call(this);
    };
    /**
     * Allows you to call the upload process manually by calling save URL action.
     * To process the selected files (added in upload queue), pass an empty argument otherwise
     * upload the specific file based on its argument.
     *
     * @param { FileInfo | FileInfo[] } files - Specifies the files data for upload.
     * @param {boolean} custom - Specifies whether the uploader is rendered with custom file list.
     * @returns {void}
     */
    Uploader.prototype.upload = function (files, custom) {
        var _this = this;
        files = files ? files : this.filesData;
        if (this.sequentialUpload && (this.isFirstFileOnSelection || custom)) {
            this.sequenceUpload(files);
        }
        else {
            var uploadFiles_1 = this.getFilesInArray(files);
            var eventArgs = {
                customFormData: [],
                currentRequest: null,
                cancel: false
            };
            this.trigger('beforeUpload', eventArgs, function (eventArgs) {
                if (!eventArgs.cancel) {
                    _this.uploadFiles(uploadFiles_1, custom);
                }
            });
        }
    };
    Uploader.prototype.getFilesInArray = function (files) {
        var uploadFiles = [];
        if (files instanceof Array) {
            uploadFiles = files;
        }
        else {
            uploadFiles.push(files);
        }
        return uploadFiles;
    };
    /* istanbul ignore next */
    Uploader.prototype.serverReadFileBase64 = function (fileIndex, position, totalCount) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var file = _this.fileStreams[fileIndex].rawFile;
            try {
                var reader = new FileReader();
                reader.onload = (function (args) {
                    return function () {
                        try {
                            var contents = args.result;
                            var data = contents ? contents.split(';base64,')[1] : null;
                            resolve(data);
                        }
                        catch (e) {
                            reject(e);
                        }
                    };
                })(reader);
                reader.readAsDataURL(file.slice(position, position + totalCount));
            }
            catch (e) {
                reject(e);
            }
        });
    };
    /* eslint-disable @typescript-eslint/no-unused-vars */
    /* istanbul ignore next */
    Uploader.prototype.uploadFileCount = function (ele) {
        /* eslint-enable @typescript-eslint/no-unused-vars */
        var files = this.filesData;
        if (!files || files.length === 0) {
            return -1;
        }
        var result = files.length;
        return result;
    };
    /* eslint-disable @typescript-eslint/no-unused-vars */
    /* istanbul ignore next */
    Uploader.prototype.getFileRead = function (index, ele) {
        /* eslint-enable @typescript-eslint/no-unused-vars */
        var files = this.filesData;
        if (!files || files.length === 0) {
            return -1;
        }
        var file = files[index];
        var fileCount = this.newFileRef++;
        this.fileStreams[fileCount] = file;
        return fileCount;
    };
    /* eslint-disable @typescript-eslint/no-unused-vars */
    /* istanbul ignore next */
    Uploader.prototype.getFileInfo = function (index, ele) {
        /* eslint-enable @typescript-eslint/no-unused-vars */
        var files = this.filesData;
        if (!files || files.length === 0) {
            return null;
        }
        var file = files[index];
        if (!file) {
            return null;
        }
        return this.filesData[index];
    };
    Uploader.prototype.uploadFiles = function (files, custom) {
        var selectedFiles = [];
        if (this.asyncSettings.saveUrl === '' || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.asyncSettings.saveUrl)) {
            return;
        }
        if (!custom || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(custom)) {
            if (!this.multiple) {
                var file = [];
                file.push(files[0]);
                selectedFiles = this.filterfileList(file);
            }
            else {
                selectedFiles = this.filterfileList(files);
            }
        }
        else {
            selectedFiles = files;
        }
        for (var i = 0; i < selectedFiles.length; i++) {
            this.uploadFilesRequest(selectedFiles, i, custom);
        }
    };
    Uploader.prototype.uploadFilesRequest = function (selectedFiles, i, custom) {
        var _this = this;
        var cloneFiles = [];
        var chunkEnabled = this.checkChunkUpload();
        var ajax = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["a" /* Ajax */](this.asyncSettings.saveUrl, 'POST', true, null);
        ajax.emitError = false;
        var getFileData;
        var eventArgs = {
            fileData: selectedFiles[i],
            customFormData: [],
            cancel: false
        };
        var formData = new FormData();
        ajax.beforeSend = function (e) {
            eventArgs.currentRequest = ajax.httpRequest;
            _this.trigger('uploading', eventArgs, function (eventArgs) {
                /* istanbul ignore next */
                if (eventArgs.cancel) {
                    _this.eventCancelByArgs(e, eventArgs, selectedFiles[i]);
                }
                _this.updateFormData(formData, eventArgs.customFormData);
            });
        };
        if (selectedFiles[i].statusCode === '1') {
            var name_4 = this.element.getAttribute('name');
            formData.append(name_4, selectedFiles[i].rawFile, selectedFiles[i].name);
            if (chunkEnabled && selectedFiles[i].size > this.asyncSettings.chunkSize) {
                this.chunkUpload(selectedFiles[i], custom, i);
            }
            else {
                ajax.onLoad = function (e) {
                    if (eventArgs.cancel) {
                        return {};
                    }
                    else {
                        _this.uploadComplete(e, selectedFiles[i], custom);
                        return {};
                    }
                };
                ajax.onUploadProgress = function (e) {
                    if (eventArgs.cancel) {
                        return {};
                    }
                    else {
                        _this.uploadInProgress(e, selectedFiles[i], custom, ajax);
                        return {};
                    }
                };
                /* istanbul ignore next */
                ajax.onError = function (e) {
                    _this.uploadFailed(e, selectedFiles[i]);
                    return {};
                };
                ajax.send(formData);
            }
        }
    };
    Uploader.prototype.spliceFiles = function (liIndex) {
        var liElement = this.fileList[liIndex];
        var allFiles = this.getFilesData();
        var nameElements = +liElement.getAttribute('data-files-count');
        var startIndex = 0;
        for (var i = 0; i < liIndex; i++) {
            startIndex += (+this.fileList[i].getAttribute('data-files-count'));
        }
        var endIndex = (startIndex + nameElements) - 1;
        for (var j = endIndex; j >= startIndex; j--) {
            allFiles.splice(j, 1);
        }
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-param */
    /**
     * Remove the uploaded file from server manually by calling the remove URL action.
     * If you pass an empty argument to this method, the complete file list can be cleared,
     * otherwise remove the specific file based on its argument (“file_data”).
     *
     * @param { FileInfo | FileInfo[] } fileData - specifies the files data to remove from file list/server.
     * @param { boolean } customTemplate - Set true if the component rendering with customize template.
     * @param { boolean } removeDirectly - Set true if files remove without removing event.
     * @param { boolean } postRawFile - Set false, to post file name only to the remove action.
     * @returns {void}
     */
    Uploader.prototype.remove = function (fileData, customTemplate, removeDirectly, postRawFile, args) {
        var _this = this;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(postRawFile)) {
            postRawFile = true;
        }
        var eventArgs = {
            event: args,
            cancel: false,
            filesData: [],
            customFormData: [],
            postRawFile: postRawFile,
            currentRequest: null
        };
        var beforeEventArgs = {
            cancel: false,
            customFormData: [],
            currentRequest: null
        };
        this.trigger('beforeRemove', beforeEventArgs, function (beforeEventArgs) {
            if (!beforeEventArgs.cancel) {
                if (_this.isFormUpload()) {
                    eventArgs.filesData = fileData;
                    _this.trigger('removing', eventArgs, function (eventArgs) {
                        if (!eventArgs.cancel) {
                            var removingFiles = _this.getFilesInArray(fileData);
                            var isLiRemoved = false;
                            var liIndex = void 0;
                            for (var _i = 0, removingFiles_1 = removingFiles; _i < removingFiles_1.length; _i++) {
                                var data = removingFiles_1[_i];
                                if (!isLiRemoved) {
                                    liIndex = _this.fileList.indexOf(data.list);
                                }
                                if (liIndex > -1) {
                                    var inputElement = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(data.input) ? data.input : null;
                                    if (inputElement) {
                                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(inputElement);
                                    }
                                    _this.spliceFiles(liIndex);
                                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(_this.fileList[liIndex]);
                                    _this.fileList.splice(liIndex, 1);
                                    isLiRemoved = true;
                                    liIndex = -1;
                                }
                            }
                        }
                    });
                }
                else if (_this.isForm && (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(_this.asyncSettings.removeUrl) || _this.asyncSettings.removeUrl === '')) {
                    eventArgs.filesData = _this.getFilesData();
                    _this.trigger('removing', eventArgs, function (eventArgs) {
                        if (!eventArgs.cancel) {
                            _this.clearAll();
                        }
                    });
                }
                else {
                    var removeFiles = [];
                    fileData = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fileData) ? fileData : _this.filesData;
                    if (fileData instanceof Array) {
                        removeFiles = fileData;
                    }
                    else {
                        removeFiles.push(fileData);
                    }
                    eventArgs.filesData = removeFiles;
                    var removeUrl = _this.asyncSettings.removeUrl;
                    var validUrl = (removeUrl === '' || Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(removeUrl)) ? false : true;
                    var _loop_5 = function (files) {
                        var fileUploadedIndex = _this.uploadedFilesData.indexOf(files);
                        if ((files.statusCode === '2' || files.statusCode === '4' || (files.statusCode === '0' &&
                            fileUploadedIndex !== -1)) && validUrl) {
                            _this.removeUploadedFile(files, eventArgs, removeDirectly, customTemplate);
                        }
                        else {
                            if (!removeDirectly) {
                                _this.trigger('removing', eventArgs, function (eventArgs) {
                                    if (!eventArgs.cancel) {
                                        _this.removeFilesData(files, customTemplate);
                                    }
                                });
                            }
                            else {
                                _this.removeFilesData(files, customTemplate);
                            }
                        }
                        if (args && !args.target.classList.contains(REMOVE_ICON)) {
                            _this.checkActionComplete(false);
                        }
                    };
                    for (var _i = 0, removeFiles_1 = removeFiles; _i < removeFiles_1.length; _i++) {
                        var files = removeFiles_1[_i];
                        _loop_5(files);
                    }
                }
            }
        });
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-param */
    /**
     * Clear all the file entries from list that can be uploaded files or added in upload queue.
     *
     * @returns {void}
     */
    Uploader.prototype.clearAll = function () {
        var _this = this;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.listParent)) {
            if (this.browserName !== 'msie') {
                this.element.value = '';
            }
            this.filesData = [];
            return;
        }
        var eventArgs = {
            cancel: false,
            filesData: this.filesData
        };
        this.trigger('clearing', eventArgs, function (eventArgs) {
            if (!eventArgs.cancel) {
                _this.clearData();
                _this.actionCompleteCount = 0;
                _this.count = -1;
            }
        });
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns-description */
    /**
     * Get the data of files which are shown in file list.
     *
     * @param { number } index - specifies the file list item(li) index.
     * @returns {FileInfo[]}
     */
    Uploader.prototype.getFilesData = function (index) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(index)) {
            return this.filesData;
        }
        else {
            return this.getSelectedFiles(index);
        }
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns-description */
    /**
     * Pauses the in-progress chunked upload based on the file data.
     *
     * @param { FileInfo | FileInfo[] } fileData - specifies the files data to pause from uploading.
     * @param { boolean } custom - Set true if used custom UI.
     * @returns {void}
     */
    Uploader.prototype.pause = function (fileData, custom) {
        fileData = fileData ? fileData : this.filesData;
        var fileDataFiles = this.getFilesInArray(fileData);
        this.pauseUploading(fileDataFiles, custom);
    };
    Uploader.prototype.pauseUploading = function (fileData, custom) {
        var files = this.getFiles(fileData);
        for (var i = 0; i < files.length; i++) {
            if (files[i].statusCode === '3') {
                this.pauseUpload(this.getCurrentMetaData(files[i], null), null, custom);
            }
        }
    };
    Uploader.prototype.getFiles = function (fileData) {
        var files = [];
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(fileData) && !(fileData instanceof Array)) {
            files.push(fileData);
        }
        else {
            files = fileData;
        }
        return files;
    };
    /**
     * Resumes the chunked upload that is previously paused based on the file data.
     *
     * @param { FileInfo | FileInfo[] } fileData - specifies the files data to resume the paused file.
     * @param { boolean } custom - Set true if used custom UI.
     * @returns {void}
     */
    Uploader.prototype.resume = function (fileData, custom) {
        fileData = fileData ? fileData : this.filesData;
        var fileDataFiles = this.getFilesInArray(fileData);
        this.resumeFiles(fileDataFiles, custom);
    };
    Uploader.prototype.resumeFiles = function (fileData, custom) {
        var files = this.getFiles(fileData);
        for (var i = 0; i < files.length; i++) {
            if (files[i].statusCode === '4') {
                this.resumeUpload(this.getCurrentMetaData(files[i], null), null, custom);
            }
        }
    };
    /**
     * Retries the canceled or failed file upload based on the file data.
     *
     * @param { FileInfo | FileInfo[] } fileData - specifies the files data to retry the canceled or failed file.
     * @param { boolean } fromcanceledStage - Set true to retry from canceled stage and set false to retry from initial stage.
     * @param {boolean} custom -Specifies whether the uploader is rendered with custom file list.
     * @returns {void}
     */
    Uploader.prototype.retry = function (fileData, fromcanceledStage, custom) {
        fileData = fileData ? fileData : this.filesData;
        var fileDataFiles = this.getFilesInArray(fileData);
        if (this.sequentialUpload && this.isFirstFileOnSelection) {
            this.isFirstFileOnSelection = false;
        }
        this.retryFailedFiles(fileDataFiles, fromcanceledStage, custom);
    };
    Uploader.prototype.retryFailedFiles = function (fileData, fromcanceledStage, custom) {
        var files = this.getFiles(fileData);
        for (var i = 0; i < files.length; i++) {
            if (files[i].statusCode === '5' || files[i].statusCode === '0') {
                if (this.asyncSettings.chunkSize > 0) {
                    this.retryUpload(this.getCurrentMetaData(files[i], null), fromcanceledStage);
                }
                else {
                    var liElement = void 0;
                    if (!custom) {
                        liElement = this.fileList[this.filesData.indexOf(files[i])];
                    }
                    this.reloadcanceledFile(null, files[i], liElement, custom);
                }
            }
        }
    };
    /**
     * Stops the in-progress chunked upload based on the file data.
     * When the file upload is canceled, the partially uploaded file is removed from server.
     *
     * @param { FileInfo | FileInfo[] } fileData - specifies the files data to cancel the progressing file.
     * @returns {void}
     */
    Uploader.prototype.cancel = function (fileData) {
        fileData = fileData ? fileData : this.filesData;
        var cancelingFiles = this.getFilesInArray(fileData);
        this.cancelUpload(cancelingFiles);
    };
    Uploader.prototype.cancelUpload = function (fileData) {
        var files = this.getFiles(fileData);
        if (this.asyncSettings.chunkSize > 0) {
            for (var i = 0; i < files.length; i++) {
                if (files[i].statusCode === '3') {
                    var metaData = this.getCurrentMetaData(files[i], null);
                    metaData.file.statusCode = '5';
                    metaData.file.status = this.localizedTexts('fileUploadCancel');
                    this.updateMetaData(metaData);
                    this.showHideUploadSpinner(files[i]);
                }
            }
        }
        else {
            for (var i = 0; i < files.length; i++) {
                if (files[i].statusCode === '3') {
                    files[i].statusCode = '5';
                    files[i].status = this.localizedTexts('fileUploadCancel');
                    this.showHideUploadSpinner(files[i]);
                }
            }
        }
    };
    Uploader.prototype.showHideUploadSpinner = function (files) {
        var liElement = this.getLiElement(files);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(liElement) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.template)) {
            var spinnerTarget = liElement.querySelector('.' + ABORT_ICON);
            Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__["d" /* createSpinner */])({ target: spinnerTarget, width: '20px' });
            Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_popups__["j" /* showSpinner */])(spinnerTarget);
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({ saveUrl: '', removeUrl: '' }, AsyncSettings)
    ], Uploader.prototype, "asyncSettings", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Uploader.prototype, "sequentialUpload", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])({})
    ], Uploader.prototype, "htmlAttributes", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Uploader.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Uploader.prototype, "enabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], Uploader.prototype, "template", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Uploader.prototype, "multiple", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Uploader.prototype, "autoUpload", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({}, ButtonsProps)
    ], Uploader.prototype, "buttons", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Uploader.prototype, "allowedExtensions", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(0)
    ], Uploader.prototype, "minFileSize", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(30000000)
    ], Uploader.prototype, "maxFileSize", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], Uploader.prototype, "dropArea", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["f" /* Collection */])([{}], FilesProp)
    ], Uploader.prototype, "files", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Uploader.prototype, "showFileList", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Uploader.prototype, "directoryUpload", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Default')
    ], Uploader.prototype, "dropEffect", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "actionComplete", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "rendering", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "beforeUpload", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "fileListRendering", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "selected", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "uploading", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "success", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "failure", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "removing", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "beforeRemove", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "clearing", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "progress", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "change", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "chunkSuccess", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "chunkFailure", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "chunkUploading", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "canceling", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "pausing", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Uploader.prototype, "resuming", void 0);
    Uploader = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], Uploader);
    return Uploader;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));

/* eslint-enable @typescript-eslint/no-explicit-any */


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_picker__ = __webpack_require__(268);
/* unused harmony namespace reexport */
/**
 * ColorPicker modules
 */



/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ColorPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_splitbuttons__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__input_index__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__numerictextbox_index__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__slider_slider__ = __webpack_require__(88);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable prefer-spread */










var APPLY = 'e-apply';
var CANCEL = 'e-cancel';
var CURRENT = 'e-current';
var CONTAINER = 'e-container';
var CTRLBTN = 'e-ctrl-btn';
var CTRLSWITCH = 'e-switch-ctrl-btn';
var DISABLED = 'e-disabled';
var FORMATSWITCH = 'e-value-switch-btn';
var HANDLER = 'e-handler';
var HEX = 'e-hex';
var HIDEHEX = 'e-hide-hex-value';
var HIDEOPACITY = 'e-hide-opacity';
var HIDERGBA = 'e-hide-switchable-value';
var HIDEVALUE = 'e-hide-value';
var HIDEVALUESWITCH = 'e-hide-valueswitcher';
var HSVAREA = 'e-hsv-color';
var HSVCONTAINER = 'e-hsv-container';
var INPUTWRAPPER = 'e-selected-value';
var MODESWITCH = 'e-mode-switch-btn';
var NOCOLOR = 'e-nocolor-item';
var OPACITY = 'e-opacity-value';
var PALETTES = 'e-palette';
var PALETTECONTENT = 'e-color-palette';
var PICKERCONTENT = 'e-color-picker';
var PREVIEW = 'e-preview-container';
var PREVIOUS = 'e-previous';
var RTL = 'e-rtl';
var SHOWVALUE = 'e-show-value';
var SELECT = 'e-selected';
var SPLITPREVIEW = 'e-split-preview';
var TILE = 'e-tile';
var presets = {
    default: ['#000000', '#f44336', '#e91e63', '#9c27b0', '#673ab7', '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#ffeb3b',
        '#ffffff', '#ffebee', '#fce4ec', '#f3e5f5', '#ede7f6', '#e3f2fd', '#e1f5fe', '#e0f7fa', '#e0f2f1', '#fffde7',
        '#f2f2f2', '#ffcdd2', '#f8bbd0', '#e1bee7', '#d1c4e9', '#bbdefb', '#b3e5fc', '#b2ebf2', '#b2dfdb', '#fff9c4',
        '#e6e6e6', '#ef9a9a', '#f48fb1', '#ce93d8', '#b39ddb', '#90caf9', '#81d4fa', '#80deea', '#80cbc4', '#fff59d',
        '#cccccc', '#e57373', '#f06292', '#ba68c8', '#9575cd', '#64b5f6', '#4fc3f7', '#4dd0e1', '#4db6ac', '#fff176',
        '#b3b3b3', '#ef5350', '#ec407a', '#ab47bc', '#7e57c2', '#42a5f5', '#29b6f6', '#26c6da', '#26a69a', '#ffee58',
        '#999999', '#e53935', '#d81b60', '#8e24aa', '#5e35b1', '#1e88e5', '#039be5', '#00acc1', '#00897b', '#fdd835',
        '#808080', '#d32f2f', '#c2185b', '#7b1fa2', '#512da8', '#1976d2', '#0288d1', '#0097a7', '#00796b', '#fbc02d',
        '#666666', '#c62828', '#ad1457', '#6a1b9a', '#4527a0', '#1565c0', '#0277bd', '#00838f', '#00695c', '#f9a825',
        '#4d4d4d', '#b71c1c', '#880e4f', '#4a148c', '#311b92', '#0d47a1', '#01579b', '#006064', '#004d40', '#f57f17']
};
/**
 * ColorPicker component is a user interface to select and adjust color values. It provides supports for various
 * color specification like Red Green Blue, Hue Saturation Value and Hex codes.
 * ```html
 * <input type="color" id="color-picker">
 * ```
 * ```typescript
 * <script>
 *   let colorPickerObj: ColorPicker = new ColorPicker(null , "#color-picker");
 * </script>
 * ```
 */
var ColorPicker = /** @class */ (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker(options, element) {
        return _super.call(this, options, element) || this;
    }
    ColorPicker.prototype.preRender = function () {
        var ele = this.element;
        this.formElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, 'form');
        if (this.formElement) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.formElement, 'reset', this.formResetHandler, this);
        }
        var localeText = { Apply: 'Apply', Cancel: 'Cancel', ModeSwitcher: 'Switch Mode' };
        this.l10n = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["o" /* L10n */]('colorpicker', localeText, this.locale);
        if (ele.getAttribute('ejs-for') && !ele.getAttribute('name')) {
            ele.setAttribute('name', ele.id);
        }
    };
    /**
     * To Initialize the component rendering
     *
     * @private
     * @returns {void}
     */
    ColorPicker.prototype.render = function () {
        this.initWrapper();
        if (this.inline) {
            this.createWidget();
        }
        else {
            this.createSplitBtn();
        }
        if (!this.enableOpacity) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.container.parentElement], HIDEOPACITY);
        }
        this.renderComplete();
    };
    ColorPicker.prototype.initWrapper = function () {
        var wrapper = this.createElement('div', { className: 'e-' + this.getModuleName() + '-wrapper' });
        this.element.parentNode.insertBefore(wrapper, this.element);
        wrapper.appendChild(this.element);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'tabindex': '-1', 'spellcheck': 'false' });
        this.container = this.createElement('div', { className: CONTAINER });
        this.getWrapper().appendChild(this.container);
        var value = this.value ? this.roundValue(this.value).toLowerCase() : '#008000ff';
        if (this.noColor && this.mode === 'Palette' && this.value === '') {
            value = '';
        }
        var slicedValue = value.slice(0, 7);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.initialInputValue)) {
            this.initialInputValue = slicedValue;
        }
        this.element.value = slicedValue;
        if (this.enableOpacity) {
            this.setProperties({ 'value': value }, true);
        }
        else {
            this.setProperties({ 'value': slicedValue }, true);
        }
        if (this.enableRtl) {
            wrapper.classList.add(RTL);
        }
        if (this.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([wrapper], this.cssClass.split(' '));
        }
        this.tileRipple = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_0" /* rippleEffect */])(this.container, { selector: '.' + TILE });
        this.ctrlBtnRipple = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_0" /* rippleEffect */])(this.container, { selector: '.e-btn' });
    };
    ColorPicker.prototype.getWrapper = function () {
        return this.element.parentElement;
    };
    ColorPicker.prototype.createWidget = function () {
        if (this.mode === 'Palette') {
            this.createPalette();
            if (!this.inline) {
                this.firstPaletteFocus();
            }
        }
        else {
            this.createPicker();
            if (!this.inline) {
                this.getDragHandler().focus();
            }
        }
        this.isRgb = true;
        this.createInput();
        this.createCtrlBtn();
        if (!this.disabled) {
            this.wireEvents();
        }
        if (this.inline && this.disabled) {
            this.toggleDisabled(true);
        }
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
            this.refreshPopupPos();
        }
    };
    ColorPicker.prototype.createSplitBtn = function () {
        var _this = this;
        var splitButton = this.createElement('button', { className: 'e-split-colorpicker' });
        this.getWrapper().appendChild(splitButton);
        this.splitBtn = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_splitbuttons__["b" /* SplitButton */]({
            iconCss: 'e-selected-color',
            target: this.container,
            disabled: this.disabled,
            enableRtl: this.enableRtl,
            createPopupOnClick: this.createPopupOnClick,
            open: this.onOpen.bind(this),
            click: function () {
                _this.trigger('change', {
                    currentValue: { hex: _this.value.slice(0, 7), rgba: _this.convertToRgbString(_this.hexToRgb(_this.value)) },
                    previousValue: { hex: null, rgba: null }, value: _this.value
                });
            }
        });
        this.splitBtn.createElement = this.createElement;
        this.splitBtn.appendTo(splitButton);
        var preview = this.createElement('span', { className: SPLITPREVIEW });
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-selected-color', splitButton).appendChild(preview);
        preview.style.backgroundColor = this.convertToRgbString(this.hexToRgb(this.value));
        var popupEle = this.getPopupEle();
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([popupEle], 'e-colorpicker-popup');
        if (this.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([popupEle], this.cssClass.split(' '));
        }
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
            var popupInst = this.getPopupInst();
            popupInst.relateTo = document.body;
            popupInst.position = { X: 'center', Y: 'center' };
            popupInst.targetType = 'container';
            popupInst.collision = { X: 'fit', Y: 'fit' };
            popupInst.offsetY = 4;
            popupEle.style.zIndex = Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["g" /* getZindexPartial */])(this.splitBtn.element).toString();
        }
        this.bindCallBackEvent();
    };
    ColorPicker.prototype.onOpen = function () {
        this.trigger('open', { element: this.container });
    };
    ColorPicker.prototype.getPopupInst = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(this.getPopupEle(), __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["a" /* Popup */]);
    };
    ColorPicker.prototype.bindCallBackEvent = function () {
        var _this = this;
        this.splitBtn.beforeOpen = function (args) {
            var callBackPromise = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_splitbuttons__["a" /* Deferred */]();
            _this.trigger('beforeOpen', args, function (observeOpenArgs) {
                if (!observeOpenArgs.cancel) {
                    var popupEle = _this.getPopupEle();
                    popupEle.style.top = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(0 + pageYOffset);
                    popupEle.style.left = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(0 + pageXOffset);
                    popupEle.style.display = 'block';
                    _this.createWidget();
                    popupEle.style.display = '';
                    if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
                        _this.modal = _this.createElement('div');
                        _this.modal.className = 'e-' + _this.getModuleName() + ' e-modal';
                        _this.modal.style.display = 'none';
                        document.body.insertBefore(_this.modal, popupEle);
                        document.body.className += ' e-colorpicker-overflow';
                        _this.modal.style.display = 'block';
                        _this.modal.style.zIndex = (Number(popupEle.style.zIndex) - 1).toString();
                    }
                }
                args.cancel = observeOpenArgs.cancel;
                callBackPromise.resolve(observeOpenArgs);
            });
            return callBackPromise;
        };
        this.splitBtn.beforeClose = function (args) {
            var callBackPromise = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_splitbuttons__["a" /* Deferred */]();
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(args.event)) {
                var beforeCloseArgs = { element: _this.container, event: args.event, cancel: false };
                _this.trigger('beforeClose', beforeCloseArgs, function (observedCloseArgs) {
                    if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice && args.event.target === _this.modal) {
                        observedCloseArgs.cancel = true;
                    }
                    if (!observedCloseArgs.cancel) {
                        _this.onPopupClose();
                    }
                    args.cancel = observedCloseArgs.cancel;
                    callBackPromise.resolve(observedCloseArgs);
                });
            }
            else {
                callBackPromise.resolve(args);
            }
            return callBackPromise;
        };
    };
    ColorPicker.prototype.onPopupClose = function () {
        this.unWireEvents();
        this.destroyOtherComp();
        this.container.style.width = '';
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + SPLITPREVIEW, this.splitBtn.element).style.backgroundColor
            = this.convertToRgbString(this.hexToRgb(this.value));
        this.container.innerHTML = '';
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.container], [PICKERCONTENT, PALETTECONTENT]);
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice && this.modal) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([document.body], 'e-colorpicker-overflow');
            this.modal.style.display = 'none';
            this.modal.outerHTML = '';
            this.modal = null;
        }
    };
    ColorPicker.prototype.createPalette = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["x" /* classList */])(this.container, [PALETTECONTENT], [PICKERCONTENT]);
        if (this.presetColors) {
            var paletteGroup = this.createElement('div', { className: 'e-custom-palette' });
            this.appendElement(paletteGroup);
            var keys = Object.keys(this.presetColors);
            if (keys.length === 1) {
                this.appendPalette(this.presetColors[keys[0]], keys[0], paletteGroup);
            }
            else {
                for (var i = 0, len = keys.length; i < len; i++) {
                    this.appendPalette(this.presetColors[keys[i]], keys[i], paletteGroup);
                }
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.e-row', paletteGroup).length > 10) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([paletteGroup], 'e-palette-group');
            }
        }
        else {
            this.appendPalette(presets.default, 'default');
        }
        if (this.mode === 'Palette' && !this.modeSwitcher && this.noColor) {
            this.setNoColor();
        }
        var width = parseInt(getComputedStyle(this.container).borderBottomWidth, 10);
        this.container.style.width = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.container.children[0].offsetWidth + width + width);
        this.rgb = this.hexToRgb(this.roundValue(this.value));
        this.hsv = this.rgbToHsv.apply(this, this.rgb);
    };
    ColorPicker.prototype.firstPaletteFocus = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + SELECT, this.container.children[0])) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + PALETTES, this.container)[0].focus();
        }
    };
    ColorPicker.prototype.appendPalette = function (colors, key, refEle) {
        var palette = this.createElement('div', { className: PALETTES, attrs: { 'tabindex': '0' } });
        if (refEle) {
            refEle.appendChild(palette);
        }
        else {
            this.appendElement(palette);
        }
        var row;
        var tile;
        var roundedColor;
        for (var i = 0, len = colors.length; i < len; i++) {
            if (i === 0 || i % this.columns === 0) {
                row = this.createElement('div', {
                    className: 'e-row', attrs: { 'role': 'presentation' }
                });
                palette.appendChild(row);
            }
            roundedColor = this.roundValue(colors[i]).toLowerCase();
            tile = this.createElement('span', {
                className: TILE, attrs: { 'role': 'gridcell', 'aria-label': roundedColor, 'aria-selected': 'false', 'tabindex': '0' }
            });
            this.trigger('beforeTileRender', { element: tile, presetName: key, value: colors[i] });
            row.appendChild(tile);
            if (this.value === roundedColor) {
                this.addTileSelection(tile);
                palette.focus();
            }
            tile.style.backgroundColor = this.convertToRgbString(this.hexToRgb(roundedColor));
        }
    };
    ColorPicker.prototype.setNoColor = function () {
        var noColorEle = this.container.querySelector('.e-row').children[0];
        noColorEle.classList.add(NOCOLOR);
        if (!this.value) {
            noColorEle.classList.add(SELECT);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(noColorEle, '.' + PALETTES).focus();
        }
        ['aria-selected', 'aria-label'].forEach(function (attr) { noColorEle.removeAttribute(attr); });
        noColorEle.style.backgroundColor = '';
    };
    ColorPicker.prototype.appendElement = function (ele, insertPos) {
        if (insertPos === void 0) { insertPos = 0; }
        var refEle = this.container.children[insertPos];
        if (refEle) {
            this.container.insertBefore(ele, refEle);
        }
        else {
            this.container.appendChild(ele);
        }
    };
    ColorPicker.prototype.addTileSelection = function (ele) {
        ele.classList.add(SELECT);
        ele.setAttribute('aria-selected', 'true');
    };
    ColorPicker.prototype.createPicker = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["x" /* classList */])(this.container, [PICKERCONTENT], [PALETTECONTENT]);
        var hsvContainer = this.createElement('div', { className: HSVCONTAINER });
        this.appendElement(hsvContainer);
        hsvContainer.appendChild(this.createElement('div', { className: HSVAREA }));
        var dragHandler = this.createElement('span', { className: HANDLER, attrs: { 'tabindex': '0' } });
        hsvContainer.appendChild(dragHandler);
        if (this.value === null) {
            this.value = '#008000ff';
        }
        this.rgb = this.hexToRgb(this.value);
        this.hsv = this.rgbToHsv.apply(this, this.rgb);
        this.setHsvContainerBg();
        this.setHandlerPosition();
        this.createSlider();
        this.createDragTooltip();
    };
    ColorPicker.prototype.setHsvContainerBg = function (h) {
        if (h === void 0) { h = this.hsv[0]; }
        this.getHsvContainer().style.backgroundColor = this.convertToRgbString(this.hsvToRgb(h, 100, 100, 1));
    };
    ColorPicker.prototype.getHsvContainer = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + HSVCONTAINER, this.container);
    };
    ColorPicker.prototype.setHandlerPosition = function () {
        var dragHandler = this.getDragHandler();
        var hsvArea = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + HSVAREA, this.container);
        if (this.enableRtl) {
            dragHandler.style.left = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(hsvArea.offsetWidth * Math.abs(100 - this.hsv[1]) / 100);
        }
        else {
            dragHandler.style.left = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(hsvArea.offsetWidth * this.hsv[1] / 100);
        }
        dragHandler.style.top = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(hsvArea.offsetHeight * (100 - this.hsv[2]) / 100);
    };
    ColorPicker.prototype.createSlider = function () {
        var sliderPreviewWrapper = this.createElement('div', { className: 'e-slider-preview' });
        this.appendElement(sliderPreviewWrapper, 1);
        this.createPreview(sliderPreviewWrapper);
        var sliderWrapper = this.createElement('div', { className: 'e-colorpicker-slider' });
        sliderPreviewWrapper.insertBefore(sliderWrapper, sliderPreviewWrapper.children[0]);
        var slider = this.createElement('div', { className: 'e-hue-slider' });
        sliderWrapper.appendChild(slider);
        this.hueSlider = new __WEBPACK_IMPORTED_MODULE_5__slider_slider__["a" /* Slider */]({
            value: this.hsv[0],
            min: 0,
            max: 359,
            enableRtl: this.enableRtl,
            enabled: !this.disabled,
            change: this.hueChange.bind(this)
        });
        this.hueSlider.createElement = this.createElement;
        this.hueSlider.appendTo(slider);
        if (this.enableOpacity) {
            slider = this.createElement('div', { className: 'e-opacity-slider' });
            sliderWrapper.appendChild(slider);
            this.createOpacitySlider(slider);
        }
    };
    ColorPicker.prototype.createOpacitySlider = function (slider) {
        this.opacitySlider = new __WEBPACK_IMPORTED_MODULE_5__slider_slider__["a" /* Slider */]({
            value: this.rgb[3] * 100,
            min: 0,
            max: 100,
            enableRtl: this.enableRtl,
            enabled: !this.disabled,
            change: this.opacityChange.bind(this)
        });
        this.opacitySlider.createElement = this.createElement;
        this.opacitySlider.appendTo(slider);
        var opacityBgTrack = this.createElement('div', { className: 'e-opacity-empty-track' });
        slider.appendChild(opacityBgTrack);
        this.updateOpacitySliderBg();
    };
    ColorPicker.prototype.updateOpacitySliderBg = function () {
        var direction = this.enableRtl ? 'to left' : 'to right';
        var opacityEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-opacity-empty-track', this.opacitySlider.element);
        if (opacityEle) {
            opacityEle.style.background =
                'linear-gradient(' + direction + ', rgba(' + this.rgb.slice(0, 3) + ', 0) 0%, ' +
                    this.convertToRgbString(this.rgb.slice(0, 3)) + ' 100%)';
        }
    };
    ColorPicker.prototype.hueChange = function (args) {
        this.hsv[0] = args.value;
        this.setHsvContainerBg();
        this.convertToOtherFormat();
    };
    ColorPicker.prototype.opacityChange = function (args) {
        var value = args.value;
        var pValue = this.rgbToHex(this.rgb);
        this.hsv[3] = value / 100;
        this.rgb[3] = value / 100;
        var cValue = this.rgbToHex(this.rgb);
        this.updateOpacityInput(value);
        var rgb = this.convertToRgbString(this.rgb);
        this.updatePreview(rgb);
        this.triggerEvent(cValue, pValue, rgb);
    };
    ColorPicker.prototype.updateOpacityInput = function (value) {
        if (this.enableOpacity && !this.getWrapper().classList.contains(HIDEVALUE)) {
            var opacityTextBoxInst = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + OPACITY, this.container), __WEBPACK_IMPORTED_MODULE_4__numerictextbox_index__["a" /* NumericTextBox */]);
            opacityTextBoxInst.value = value;
            opacityTextBoxInst.dataBind();
        }
    };
    ColorPicker.prototype.createPreview = function (parentEle) {
        var previewContainer = this.createElement('div', { className: PREVIEW });
        parentEle.appendChild(previewContainer);
        var preview = this.createElement('span', { className: 'e-preview ' + CURRENT });
        previewContainer.appendChild(preview);
        var colorValue = this.convertToRgbString(this.rgb);
        preview.style.backgroundColor = colorValue;
        preview = this.createElement('span', { className: 'e-preview ' + PREVIOUS });
        previewContainer.appendChild(preview);
        preview.style.backgroundColor = colorValue;
    };
    ColorPicker.prototype.isPicker = function () {
        return !this.container.classList.contains(PALETTECONTENT);
    };
    ColorPicker.prototype.getPopupEle = function () {
        return this.container.parentElement;
    };
    ColorPicker.prototype.createNumericInput = function (element, value, label, max) {
        var _this = this;
        var numericInput = new __WEBPACK_IMPORTED_MODULE_4__numerictextbox_index__["a" /* NumericTextBox */]({
            value: value,
            placeholder: label,
            min: 0,
            max: max,
            format: '###.##',
            showSpinButton: false,
            floatLabelType: 'Always',
            enableRtl: this.enableRtl,
            enabled: !this.disabled,
            readonly: this.isPicker() ? false : true,
            change: function (args) {
                if (args.event) {
                    _this.inputHandler(args.event);
                }
            }
        });
        numericInput.createElement = this.createElement;
        numericInput.appendTo(element);
    };
    ColorPicker.prototype.createInput = function () {
        var isPicker = this.isPicker();
        var wrapper = this.getWrapper();
        if ((isPicker && !wrapper.classList.contains(HIDEVALUE)) || (!isPicker && wrapper.classList.contains(SHOWVALUE))) {
            var inputWrap = this.createElement('div', { className: INPUTWRAPPER });
            if (isPicker) {
                this.appendElement(inputWrap, 2);
            }
            else {
                this.appendElement(inputWrap, 1);
            }
            var container = this.createElement('div', { className: 'e-input-container' });
            inputWrap.appendChild(container);
            if (!wrapper.classList.contains(HIDEVALUESWITCH)) {
                this.appendValueSwitchBtn(inputWrap);
            }
            if (!wrapper.classList.contains(HIDEHEX)) {
                var hexInput = this.createElement('input', {
                    className: HEX,
                    attrs: { 'maxlength': '7', 'spellcheck': 'false' }
                });
                container.appendChild(hexInput);
                __WEBPACK_IMPORTED_MODULE_3__input_index__["a" /* Input */].createInput({
                    element: hexInput,
                    floatLabelType: 'Always',
                    properties: {
                        placeholder: 'HEX',
                        enableRtl: this.enableRtl,
                        enabled: !this.disabled,
                        readonly: this.isPicker() ? false : true
                    }
                }, this.createElement);
                __WEBPACK_IMPORTED_MODULE_3__input_index__["a" /* Input */].setValue(this.value.slice(0, 7), hexInput);
                hexInput.addEventListener('input', this.inputHandler.bind(this));
            }
            if (!wrapper.classList.contains(HIDERGBA)) {
                var label = void 0;
                var value = void 0;
                if (this.isRgb) {
                    label = 'RGB';
                    value = this.rgb;
                }
                else {
                    label = 'HSV';
                    value = this.hsv;
                }
                var clsName = ['rh', 'gs', 'bv'];
                for (var i = 0; i < 3; i++) {
                    this.createNumericInput(container.appendChild(this.createElement('input', { className: 'e-' + clsName[i] + '-value' })), value[i], label[i], 255);
                }
                if (this.enableOpacity) {
                    this.appendOpacityValue(container);
                }
            }
        }
    };
    ColorPicker.prototype.appendOpacityValue = function (container) {
        this.createNumericInput(container.appendChild(this.createElement('input', { className: OPACITY })), this.rgb[3] * 100, 'A', 100);
    };
    ColorPicker.prototype.appendValueSwitchBtn = function (targetEle) {
        var valueSwitchBtn = this.createElement('button', {
            className: 'e-icons e-css e-btn e-flat e-icon-btn ' + FORMATSWITCH
        });
        targetEle.appendChild(valueSwitchBtn);
        if (this.isPicker() && !this.getWrapper().classList.contains(HIDERGBA)) {
            valueSwitchBtn.addEventListener('click', this.formatSwitchHandler.bind(this));
        }
    };
    ColorPicker.prototype.createCtrlBtn = function () {
        if (this.modeSwitcher || this.showButtons) {
            this.l10n.setLocale(this.locale);
            var btnWrapper = this.createElement('div', { className: CTRLSWITCH });
            this.container.appendChild(btnWrapper);
            if (this.showButtons) {
                var controlBtnWrapper = this.createElement('div', { className: CTRLBTN });
                btnWrapper.appendChild(controlBtnWrapper);
                var apply = this.l10n.getConstant('Apply');
                controlBtnWrapper.appendChild(this.createElement('button', {
                    innerHTML: apply,
                    className: 'e-btn e-css e-flat e-primary e-small ' + APPLY,
                    attrs: { 'title': apply }
                }));
                var cancel = this.l10n.getConstant('Cancel');
                controlBtnWrapper.appendChild(this.createElement('button', {
                    innerHTML: cancel,
                    className: 'e-btn e-css e-flat e-small ' + CANCEL,
                    attrs: { 'title': cancel }
                }));
            }
            if (this.modeSwitcher) {
                this.appendModeSwitchBtn();
            }
        }
    };
    ColorPicker.prototype.appendModeSwitchBtn = function () {
        var modeSwitcher = this.createElement('button', {
            className: 'e-icons e-btn e-flat e-icon-btn ' + MODESWITCH, attrs: { title: this.l10n.getConstant('ModeSwitcher') }
        });
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CTRLSWITCH, this.container).insertBefore(modeSwitcher, Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CTRLBTN, this.container));
    };
    ColorPicker.prototype.createDragTooltip = function () {
        var _this = this;
        var tooltip = new __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["b" /* Tooltip */]({
            opensOn: 'Custom',
            showTipPointer: false,
            cssClass: 'e-color-picker-tooltip',
            beforeOpen: function (args) {
                _this.tooltipEle = args.element;
            },
            animation: { open: { effect: 'None' }, close: { effect: 'None' } }
        });
        tooltip.createElement = this.createElement;
        tooltip.appendTo(this.container);
        tooltip.open(this.container);
        this.tooltipEle.style.zIndex = Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["g" /* getZindexPartial */])(this.tooltipEle).toString();
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-tip-content', this.tooltipEle).appendChild(this.createElement('div', { className: 'e-tip-transparent' }));
    };
    ColorPicker.prototype.getTooltipInst = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(this.container, __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["b" /* Tooltip */]);
    };
    ColorPicker.prototype.setTooltipOffset = function (value) {
        this.getTooltipInst().offsetY = value;
    };
    ColorPicker.prototype.toggleDisabled = function (enable) {
        if (enable) {
            this.getWrapper().classList.add(DISABLED);
        }
        else {
            this.getWrapper().classList.remove(DISABLED);
        }
        if (this.showButtons) {
            ([].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.e-btn', this.container))).forEach(function (ele) {
                if (enable) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(ele, { 'disabled': '' });
                }
                else {
                    ele.removeAttribute('disabled');
                }
            });
        }
    };
    ColorPicker.prototype.convertToRgbString = function (rgb) {
        return rgb.length ? rgb.length === 4 ? 'rgba(' + rgb.join() + ')' : 'rgb(' + rgb.join() + ')' : '';
    };
    ColorPicker.prototype.convertToHsvString = function (hsv) {
        return hsv.length === 4 ? 'hsva(' + hsv.join() + ')' : 'hsv(' + hsv.join() + ')';
    };
    ColorPicker.prototype.updateHsv = function () {
        this.hsv[1] = this.hsv[1] > 100 ? 100 : this.hsv[1];
        this.hsv[2] = this.hsv[2] > 100 ? 100 : this.hsv[2];
        this.setHandlerPosition();
    };
    ColorPicker.prototype.convertToOtherFormat = function (isKey) {
        if (isKey === void 0) { isKey = false; }
        var pValue = this.rgbToHex(this.rgb);
        this.rgb = this.hsvToRgb.apply(this, this.hsv);
        var cValue = this.rgbToHex(this.rgb);
        var rgba = this.convertToRgbString(this.rgb);
        this.updatePreview(rgba);
        this.updateInput(cValue);
        this.triggerEvent(cValue, pValue, rgba, isKey);
    };
    ColorPicker.prototype.updateInput = function (value) {
        var wrapper = this.getWrapper();
        if (!wrapper.classList.contains(HIDEVALUE)) {
            if (!wrapper.classList.contains(HIDEHEX)) {
                __WEBPACK_IMPORTED_MODULE_3__input_index__["a" /* Input */].setValue(value.substr(0, 7), Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + HEX, this.container));
            }
            if (!wrapper.classList.contains(HIDERGBA)) {
                if (this.isRgb) {
                    this.updateValue(this.rgb, false);
                }
                else {
                    this.updateValue(this.hsv, false);
                }
            }
        }
    };
    ColorPicker.prototype.updatePreview = function (value) {
        if (this.enableOpacity) {
            this.updateOpacitySliderBg();
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-tip-transparent', this.tooltipEle).style.backgroundColor = value;
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PREVIEW + ' .' + CURRENT, this.container).style.backgroundColor = value;
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PREVIEW + ' .' + PREVIOUS, this.container).style.backgroundColor
            = this.convertToRgbString(this.hexToRgb(this.value));
    };
    ColorPicker.prototype.getDragHandler = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + HANDLER, this.container);
    };
    ColorPicker.prototype.removeTileSelection = function () {
        var selectedEle = [].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + SELECT, this.container.children[0]));
        selectedEle.forEach(function (ele) {
            ele.classList.remove(SELECT);
            ele.setAttribute('aria-selected', 'false');
        });
    };
    ColorPicker.prototype.convertRgbToNumberArray = function (value) {
        return (value.slice(value.indexOf('(') + 1, value.indexOf(')'))).split(',').map(function (n, i) {
            return (i !== 3) ? parseInt(n, 10) : parseFloat(n);
        });
    };
    /**
     * To get color value in specified type.
     *
     * @param {string} value - Specify the color value.
     * @param {string} type - Specify the type to which the specified color needs to be converted.
     * @method getValue
     * @returns {string} - Color value
     */
    ColorPicker.prototype.getValue = function (value, type) {
        if (!value) {
            value = this.value;
        }
        type = !type ? 'hex' : type.toLowerCase();
        if (value[0] === 'r') {
            var cValue = this.convertRgbToNumberArray(value);
            if (type === 'hex' || type === 'hexa') {
                var hex = this.rgbToHex(cValue);
                return type === 'hex' ? hex.slice(0, 7) : hex;
            }
            else {
                if (type === 'hsv') {
                    return this.convertToHsvString(this.rgbToHsv.apply(this, cValue.slice(0, 3)));
                }
                else {
                    if (type === 'hsva') {
                        return this.convertToHsvString(this.rgbToHsv.apply(this, cValue));
                    }
                    else {
                        return 'null';
                    }
                }
            }
        }
        else {
            if (value[0] === 'h') {
                var cValue = this.hsvToRgb.apply(this, this.convertRgbToNumberArray(value));
                if (type === 'rgba') {
                    return this.convertToRgbString(cValue);
                }
                else {
                    if (type === 'hex' || type === 'hexa') {
                        var hex = this.rgbToHex(cValue);
                        return type === 'hex' ? hex.slice(0, 7) : hex;
                    }
                    else {
                        if (type === 'rgb') {
                            return this.convertToRgbString(cValue.slice(0, 3));
                        }
                        else {
                            return 'null';
                        }
                    }
                }
            }
            else {
                value = this.roundValue(value);
                var rgb = this.hexToRgb(value);
                if (type === 'rgb' || type === 'hsv') {
                    rgb = rgb.slice(0, 3);
                }
                if (type === 'rgba' || type === 'rgb') {
                    return this.convertToRgbString(rgb);
                }
                else {
                    if (type === 'hsva' || type === 'hsv') {
                        return this.convertToHsvString(this.rgbToHsv.apply(this, rgb));
                    }
                    else {
                        if (type === 'hex') {
                            return value.slice(0, 7);
                        }
                        else {
                            if (type === 'a') {
                                return rgb[3].toString();
                            }
                            else {
                                return 'null';
                            }
                        }
                    }
                }
            }
        }
    };
    /**
     * To show/hide ColorPicker popup based on current state of the SplitButton.
     *
     * @method toggle
     * @returns {void}
     */
    ColorPicker.prototype.toggle = function () {
        if (this.container.parentElement.classList.contains('e-popup-close')) {
            this.splitBtn.toggle();
        }
        else {
            this.closePopup(null);
        }
    };
    /**
     * Get component name.
     *
     * @returns {string} - Module Name
     * @private
     */
    ColorPicker.prototype.getModuleName = function () {
        return 'colorpicker';
    };
    /**
     * Gets the properties to be maintained in the persisted state.
     *
     * @returns {string} - Persist data
     */
    ColorPicker.prototype.getPersistData = function () {
        return this.addOnPersist(['value']);
    };
    ColorPicker.prototype.wireEvents = function () {
        if (this.isPicker()) {
            var dragHandler = this.getDragHandler();
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(dragHandler, 'keydown', this.pickerKeyDown, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.getHsvContainer(), 'mousedown touchstart', this.handlerDown, this);
            if (this.modeSwitcher || this.showButtons) {
                this.addCtrlSwitchEvent();
            }
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PREVIOUS, this.container), 'click', this.previewHandler, this);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.container, 'click', this.paletteClickHandler, this);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.container, 'keydown', this.paletteKeyDown, this);
        }
    };
    ColorPicker.prototype.formResetHandler = function () {
        this.value = this.initialInputValue;
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'value': this.initialInputValue });
    };
    ColorPicker.prototype.addCtrlSwitchEvent = function () {
        var ctrlSwitchBtn = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CTRLSWITCH, this.container);
        if (ctrlSwitchBtn) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(ctrlSwitchBtn, 'click', this.btnClickHandler, this);
        }
    };
    ColorPicker.prototype.pickerKeyDown = function (e) {
        switch (e.keyCode) {
            case 39:
                this.handlerDragPosition(1, this.enableRtl ? -1 : 1, e);
                break;
            case 37:
                this.handlerDragPosition(1, this.enableRtl ? 1 : -1, e);
                break;
            case 38:
                this.handlerDragPosition(2, 1, e);
                break;
            case 40:
                this.handlerDragPosition(2, -1, e);
                break;
            case 13: {
                e.preventDefault();
                var cValue = this.rgbToHex(this.rgb);
                this.enterKeyHandler(cValue, e);
            }
        }
    };
    ColorPicker.prototype.enterKeyHandler = function (value, e) {
        this.triggerChangeEvent(value);
        if (!this.inline) {
            this.closePopup(e);
            this.splitBtn.element.focus();
        }
    };
    ColorPicker.prototype.closePopup = function (e) {
        var _this = this;
        var beforeCloseArgs = { element: this.container, event: e, cancel: false };
        this.trigger('beforeClose', beforeCloseArgs, function (observedcloseArgs) {
            if (!observedcloseArgs.cancel) {
                _this.splitBtn.toggle();
                _this.onPopupClose();
            }
        });
    };
    ColorPicker.prototype.triggerChangeEvent = function (value) {
        var hex = value.slice(0, 7);
        this.trigger('change', {
            currentValue: { hex: hex, rgba: this.convertToRgbString(this.rgb) },
            previousValue: { hex: this.value.slice(0, 7), rgba: this.convertToRgbString(this.hexToRgb(this.value)) },
            value: this.enableOpacity ? value : hex
        });
        if (this.enableOpacity) {
            this.setProperties({ 'value': value }, true);
        }
        else {
            this.setProperties({ 'value': hex }, true);
        }
        this.element.value = hex ? hex : '#000000';
    };
    ColorPicker.prototype.handlerDragPosition = function (prob, value, e) {
        e.preventDefault();
        this.hsv[prob] += value * (e.ctrlKey ? 1 : 3);
        if (this.hsv[prob] < 0) {
            this.hsv[prob] = 0;
        }
        this.updateHsv();
        this.convertToOtherFormat(true);
    };
    ColorPicker.prototype.handlerDown = function (e) {
        e.preventDefault();
        if (e.type === 'mousedown') {
            this.clientX = Math.abs(e.pageX - pageXOffset);
            this.clientY = Math.abs(e.pageY - pageYOffset);
            this.setTooltipOffset(8);
        }
        else {
            this.clientX = Math.abs(e.changedTouches[0].pageX - pageXOffset);
            this.clientY = Math.abs(e.changedTouches[0].pageY - pageYOffset);
            this.setTooltipOffset(-8);
        }
        this.setHsv(this.clientX, this.clientY);
        this.getDragHandler().style.transition = 'left .4s cubic-bezier(.25, .8, .25, 1), top .4s cubic-bezier(.25, .8, .25, 1)';
        this.updateHsv();
        this.convertToOtherFormat();
        this.getDragHandler().focus();
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'mousemove touchmove', this.handlerMove, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'mouseup touchend', this.handlerEnd, this);
    };
    ColorPicker.prototype.handlerMove = function (e) {
        if (e.type !== 'touchmove') {
            e.preventDefault();
        }
        var x;
        var y;
        if (e.type === 'mousemove') {
            x = Math.abs(e.pageX - pageXOffset);
            y = Math.abs(e.pageY - pageYOffset);
        }
        else {
            x = Math.abs(e.changedTouches[0].pageX - pageXOffset);
            y = Math.abs(e.changedTouches[0].pageY - pageYOffset);
        }
        this.setHsv(x, y);
        var dragHandler = this.getDragHandler();
        this.updateHsv();
        this.convertToOtherFormat();
        this.getTooltipInst().refresh(dragHandler);
        if (!this.tooltipEle.style.transform) {
            if (Math.abs(this.clientX - x) > 8 || Math.abs(this.clientY - y) > 8) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + HSVAREA, this.container).style.cursor = 'pointer';
                dragHandler.style.transition = 'none';
                if (!this.inline) {
                    this.tooltipEle.style.zIndex = (parseInt(this.getPopupEle().style.zIndex, 10) + 1).toString();
                }
                this.tooltipEle.style.transform = 'rotate(45deg)';
                dragHandler.classList.add('e-hide-handler');
            }
        }
    };
    ColorPicker.prototype.setHsv = function (clientX, clientY) {
        var ele = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + HSVAREA, this.container);
        var position = ele.getBoundingClientRect();
        if (this.enableRtl) {
            clientX = clientX > position.right ? 0 : Math.abs(clientX - position.right);
        }
        else {
            clientX = clientX > position.left ? Math.abs(clientX - position.left) : 0;
        }
        clientY = clientY > position.top ? Math.abs(clientY - position.top) : 0;
        this.hsv[2] = Math.round(Number(100 * (ele.offsetHeight -
            Math.max(0, Math.min(ele.offsetHeight, (clientY - ele.offsetTop)))) / ele.offsetHeight) * 10) / 10;
        this.hsv[1] =
            Math.round(Number(100 * (Math.max(0, Math.min(ele.offsetWidth, (clientX - ele.offsetLeft)))) / ele.offsetWidth) * 10) / 10;
    };
    ColorPicker.prototype.handlerEnd = function (e) {
        if (e.type !== 'touchend') {
            e.preventDefault();
        }
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'mousemove touchmove', this.handlerMove);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'mouseup touchend', this.handlerEnd);
        var dragHandler = this.getDragHandler();
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + HSVAREA, this.container).style.cursor = '';
        if (this.tooltipEle.style.transform) {
            this.tooltipEle.style.transform = '';
            dragHandler.classList.remove('e-hide-handler');
        }
        if (!this.inline && !this.showButtons) {
            this.closePopup(e);
        }
    };
    ColorPicker.prototype.btnClickHandler = function (e) {
        var target = e.target;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(target, '.' + MODESWITCH)) {
            e.stopPropagation();
            this.switchToPalette();
        }
        else {
            if (target.classList.contains(APPLY) || target.classList.contains(CANCEL)) {
                this.ctrlBtnClick(target, e);
            }
        }
    };
    ColorPicker.prototype.switchToPalette = function () {
        this.trigger('beforeModeSwitch', { element: this.container, mode: 'Palette' });
        this.unWireEvents();
        this.destroyOtherComp();
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-slider-preview', this.container));
        if (!this.getWrapper().classList.contains(HIDEVALUE)) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + INPUTWRAPPER, this.container));
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.getHsvContainer());
        this.createPalette();
        this.firstPaletteFocus();
        this.createInput();
        this.refreshPopupPos();
        this.wireEvents();
        this.trigger('onModeSwitch', { element: this.container, mode: 'Palette' });
    };
    ColorPicker.prototype.refreshPopupPos = function () {
        if (!this.inline) {
            var popupEle = this.getPopupEle();
            popupEle.style.left = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(0 + pageXOffset);
            popupEle.style.top = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(0 + pageYOffset);
            this.getPopupInst().refreshPosition(this.splitBtn.element.parentElement);
        }
    };
    ColorPicker.prototype.formatSwitchHandler = function () {
        if (this.isRgb) {
            this.updateValue(this.hsv, true, 3, [360, 100, 100]);
            this.isRgb = false;
        }
        else {
            this.updateValue(this.rgb, true, 2);
            this.isRgb = true;
        }
    };
    ColorPicker.prototype.updateValue = function (value, format, idx, max) {
        var clsName = ['e-rh-value', 'e-gs-value', 'e-bv-value'];
        var inst;
        for (var i = 0, len = clsName.length; i < len; i++) {
            inst = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + clsName[i], this.container), __WEBPACK_IMPORTED_MODULE_4__numerictextbox_index__["a" /* NumericTextBox */]);
            inst.value = Math.round(value[i]);
            if (format) {
                inst.placeholder = clsName[i].substr(idx, 1).toUpperCase();
                inst.max = max ? max[i] : 255;
            }
            inst.dataBind();
        }
    };
    ColorPicker.prototype.previewHandler = function (e) {
        var target = e.target;
        var pValue = this.rgbToHex(this.rgb);
        this.rgb = this.convertRgbToNumberArray(target.style.backgroundColor);
        if (!this.rgb[3]) {
            this.rgb[3] = 1;
        }
        var cValue = this.rgbToHex(this.rgb);
        var hsv = this.rgbToHsv.apply(this, this.rgb);
        if (hsv[0] !== this.hsv[0]) {
            this.hueSlider.setProperties({ 'value': hsv[0] }, true);
            this.hueSlider.refresh();
        }
        this.setHsvContainerBg(hsv[0]);
        if (this.enableOpacity && hsv[3] !== this.hsv[3]) {
            this.opacitySlider.setProperties({ 'value': hsv[3] * 100 }, true);
            this.opacitySlider.refresh();
            this.updateOpacitySliderBg();
        }
        this.hsv = hsv;
        this.setHandlerPosition();
        this.updateInput(cValue);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PREVIEW + ' .' + CURRENT, this.container).style.backgroundColor = this.convertToRgbString(this.rgb);
        this.triggerEvent(cValue, pValue, this.convertToRgbString(this.rgb));
    };
    ColorPicker.prototype.paletteClickHandler = function (e) {
        e.preventDefault();
        var target = e.target;
        if (target.classList.contains(TILE)) {
            this.removeTileSelection();
            this.addTileSelection(target);
            if (target.classList.contains(NOCOLOR)) {
                this.noColorTile();
            }
            else {
                var cValue = target.getAttribute('aria-label');
                var pValue = this.rgbToHex(this.rgb);
                this.rgb = this.hexToRgb(this.roundValue(cValue));
                this.hsv = this.rgbToHsv.apply(this, this.rgb);
                if (this.getWrapper().classList.contains(SHOWVALUE)) {
                    this.updateInput(cValue);
                }
                this.triggerEvent(cValue, pValue, this.convertToRgbString(this.rgb));
            }
            if (!this.inline && !this.showButtons) {
                this.closePopup(e);
            }
        }
        else {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(target, '.' + MODESWITCH)) {
                this.switchToPicker();
            }
            else {
                if (target.classList.contains(APPLY) || target.classList.contains(CANCEL)) {
                    this.ctrlBtnClick(target, e);
                }
                else {
                    if (this.getWrapper().classList.contains(SHOWVALUE) && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(target, '.' + FORMATSWITCH)) {
                        this.formatSwitchHandler();
                    }
                }
            }
        }
    };
    ColorPicker.prototype.noColorTile = function (isKey) {
        if (isKey === void 0) { isKey = false; }
        var pValue = this.rgbToHex(this.rgb);
        this.rgb = [];
        this.hsv = [];
        this.triggerEvent('', pValue, '', isKey);
    };
    ColorPicker.prototype.switchToPicker = function () {
        var wrapper = this.getWrapper();
        this.trigger('beforeModeSwitch', { element: this.container, mode: 'Picker' });
        this.unWireEvents();
        ([].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + PALETTES, this.container))).forEach(function (ele) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(ele);
        });
        if (wrapper.classList.contains(SHOWVALUE)) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + INPUTWRAPPER, this.container));
        }
        this.container.style.width = '';
        var grpEle = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-custom-palette', this.container);
        if (this.presetColors) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(grpEle);
        }
        this.createPicker();
        this.getDragHandler().focus();
        this.createInput();
        this.refreshPopupPos();
        this.wireEvents();
        this.trigger('onModeSwitch', { element: this.container, mode: 'Picker' });
    };
    ColorPicker.prototype.ctrlBtnClick = function (ele, e) {
        if (ele.classList.contains(APPLY)) {
            var cValue = this.rgbToHex(this.rgb);
            this.triggerChangeEvent(cValue);
        }
        if (!this.inline) {
            this.closePopup(e);
            this.splitBtn.element.focus();
        }
    };
    ColorPicker.prototype.paletteKeyDown = function (e) {
        var target = e.target;
        if (!target.classList.contains(PALETTES)) {
            return;
        }
        var selectedEle;
        var idx;
        var tiles = [].slice.call(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_2" /* selectAll */])('.' + TILE, target));
        var prevSelectedEle = (tiles.filter(function (tile) { return tile.classList.contains('e-selected'); })).pop();
        switch (!e.altKey && e.keyCode) {
            case 39:
                e.preventDefault();
                selectedEle = prevSelectedEle ? tiles[this.tilePosition(tiles, prevSelectedEle, this.enableRtl ? -1 : 1)]
                    : tiles[this.enableRtl ? tiles.length - 1 : 0];
                this.keySelectionChanges(selectedEle);
                break;
            case 37:
                e.preventDefault();
                selectedEle = prevSelectedEle ? tiles[this.tilePosition(tiles, prevSelectedEle, this.enableRtl ? 1 : -1)]
                    : tiles[this.enableRtl ? 0 : tiles.length - 1];
                this.keySelectionChanges(selectedEle);
                break;
            case 38:
                e.preventDefault();
                idx = prevSelectedEle ? this.tilePosition(tiles, prevSelectedEle, -this.columns) : 0;
                selectedEle = tiles[idx] ? tiles[idx] : tiles[idx - this.columns];
                this.keySelectionChanges(selectedEle);
                break;
            case 40:
                e.preventDefault();
                idx = prevSelectedEle ? this.tilePosition(tiles, prevSelectedEle, this.columns) : tiles.length - 1;
                if (tiles[idx]) {
                    selectedEle = tiles[idx];
                }
                else {
                    idx %= tiles.length;
                    idx += tiles[tiles.length - 1].parentElement.childElementCount;
                    selectedEle = tiles[idx];
                }
                this.keySelectionChanges(selectedEle);
                break;
            case 13:
                e.preventDefault();
                if (prevSelectedEle) {
                    var cValue = prevSelectedEle.getAttribute('aria-label');
                    this.enterKeyHandler(cValue ? cValue : '', e);
                }
        }
    };
    ColorPicker.prototype.keySelectionChanges = function (newEle) {
        this.removeTileSelection();
        this.addTileSelection(newEle);
        if (newEle.classList.contains(NOCOLOR)) {
            this.noColorTile(true);
        }
        else {
            var cValue = newEle.getAttribute('aria-label');
            var pValue = this.rgbToHex(this.rgb);
            this.rgb = this.hexToRgb(cValue);
            this.hsv = this.rgbToHsv.apply(this, this.rgb);
            if (this.getWrapper().classList.contains(SHOWVALUE)) {
                this.updateInput(cValue);
            }
            this.triggerEvent(cValue, pValue, this.convertToRgbString(this.rgb), true);
        }
    };
    ColorPicker.prototype.tilePosition = function (items, element, cIdx) {
        items = Array.prototype.slice.call(items);
        var n = items.length;
        var emptyCount = this.columns - items[n - 1].parentElement.childElementCount;
        var idx = items.indexOf(element);
        idx += cIdx;
        if (idx < 0) {
            idx += n + emptyCount;
        }
        else {
            idx %= n + emptyCount;
        }
        return idx;
    };
    ColorPicker.prototype.inputHandler = function (e) {
        var target = e.target;
        if (!target.value.length) {
            return;
        }
        var hsv;
        var pValue;
        var label = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-float-text', target.parentElement).textContent;
        switch (label) {
            case 'HEX': {
                var value = '';
                if ((target.value[0] === '#' && target.value.length !== 5) || (target.value[0] !== '#' && target.value.length !== 4)) {
                    value = this.roundValue(target.value);
                }
                if (value.length === 9) {
                    pValue = this.rgbToHex(this.rgb);
                    this.rgb = this.hexToRgb(value + value.substr(-2));
                    this.inputValueChange(this.rgbToHsv.apply(this, this.rgb), pValue, target.value);
                }
                else {
                    return;
                }
                break;
            }
            case 'R':
                if (this.rgb[0] !== Number(target.value)) {
                    pValue = this.rgbToHex(this.rgb);
                    this.rgb[0] = Number(target.value);
                    hsv = this.rgbToHsv.apply(this, this.rgb);
                    this.inputValueChange(hsv, pValue);
                }
                break;
            case 'G':
                if (this.rgb[1] !== Number(target.value)) {
                    pValue = this.rgbToHex(this.rgb);
                    this.rgb[1] = Number(target.value);
                    hsv = this.rgbToHsv.apply(this, this.rgb);
                    this.inputValueChange(hsv, pValue);
                }
                break;
            case 'B':
                if (this.rgb[2] !== Number(target.value)) {
                    pValue = this.rgbToHex(this.rgb);
                    this.rgb[2] = Number(target.value);
                    hsv = this.rgbToHsv.apply(this, this.rgb);
                    this.inputValueChange(hsv, pValue);
                }
                break;
            case 'H':
                this.hueSlider.value = Number(target.value);
                break;
            case 'S':
                if (this.hsv[1] !== Number(target.value)) {
                    this.hsv[1] = Number(target.value);
                    this.updateHsv();
                    this.convertToOtherFormat();
                }
                break;
            case 'V':
                if (this.hsv[2] !== Number(target.value)) {
                    this.hsv[2] = Number(target.value);
                    this.updateHsv();
                    this.convertToOtherFormat();
                }
                break;
            case 'A':
                this.opacitySlider.value = Number(target.value);
                break;
        }
    };
    ColorPicker.prototype.inputValueChange = function (hsv, pValue, value) {
        if (hsv[0] !== this.hsv[0]) {
            this.hueSlider.setProperties({ 'value': hsv[0] }, true);
            this.hueSlider.refresh();
            this.setHsvContainerBg(hsv[0]);
        }
        this.hsv = hsv;
        var cValue = this.rgbToHex(this.rgb);
        this.setHandlerPosition();
        this.updateInput(value ? value : cValue);
        var rgba = this.convertToRgbString(this.rgb);
        this.updatePreview(rgba);
        this.triggerEvent(cValue, pValue, rgba);
    };
    ColorPicker.prototype.triggerEvent = function (cValue, pValue, rgba, isKey) {
        if (isKey === void 0) { isKey = false; }
        var hex = cValue.slice(0, 7);
        if (!this.showButtons && !isKey) {
            this.trigger('change', { currentValue: { hex: hex, rgba: rgba },
                previousValue: { hex: this.value.slice(0, 7), rgba: this.convertToRgbString(this.hexToRgb(this.value)) }, value: cValue });
            if (this.enableOpacity) {
                this.setProperties({ 'value': cValue }, true);
            }
            else {
                this.setProperties({ 'value': hex }, true);
            }
            this.element.value = hex ? hex : '#000000';
        }
        else {
            this.trigger('select', {
                currentValue: { hex: hex, rgba: rgba },
                previousValue: { hex: pValue.slice(0, 7), rgba: this.convertToRgbString(this.hexToRgb(pValue)) }
            });
        }
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers.
     * Also it maintains the initial input element from the DOM.
     *
     * @method destroy
     * @returns {void}
     */
    ColorPicker.prototype.destroy = function () {
        var _this = this;
        var wrapper = this.getWrapper();
        _super.prototype.destroy.call(this);
        ['tabindex', 'spellcheck'].forEach(function (attr) { _this.element.removeAttribute(attr); });
        if (this.inline) {
            this.unWireEvents();
            this.destroyOtherComp();
        }
        else {
            if (this.isPopupOpen()) {
                this.unWireEvents();
                this.destroyOtherComp();
            }
            this.splitBtn.destroy();
            this.splitBtn = null;
        }
        this.tileRipple();
        this.tileRipple = null;
        this.ctrlBtnRipple();
        this.ctrlBtnRipple = null;
        if (this.element.nextElementSibling) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.element.nextElementSibling);
        }
        if (wrapper) {
            wrapper.parentElement.insertBefore(this.element, wrapper);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(wrapper);
        }
        this.container = null;
        if (this.formElement) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.formElement, 'reset', this.formResetHandler);
        }
    };
    ColorPicker.prototype.destroyOtherComp = function () {
        if (this.isPicker()) {
            this.hueSlider.destroy();
            if (this.enableOpacity) {
                this.opacitySlider.destroy();
                this.opacitySlider = null;
            }
            this.hueSlider = null;
            var tooltipInst = this.getTooltipInst();
            tooltipInst.close();
            tooltipInst.destroy();
            this.tooltipEle = null;
        }
    };
    ColorPicker.prototype.isPopupOpen = function () {
        return this.getPopupEle().classList.contains('e-popup-open');
    };
    ColorPicker.prototype.unWireEvents = function () {
        if (this.isPicker()) {
            var dragHandler = this.getDragHandler();
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(dragHandler, 'keydown', this.pickerKeyDown);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.getHsvContainer(), 'mousedown touchstart', this.handlerDown);
            if (this.modeSwitcher || this.showButtons) {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CTRLSWITCH, this.container), 'click', this.btnClickHandler);
            }
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + PREVIOUS, this.container), 'click', this.previewHandler);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.container, 'click', this.paletteClickHandler);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.container, 'keydown', this.paletteKeyDown);
        }
    };
    ColorPicker.prototype.roundValue = function (value) {
        if (!value) {
            return '';
        }
        if (value[0] !== '#') {
            value = '#' + value;
        }
        var len = value.length;
        if (len === 4) {
            value += 'f';
            len = 5;
        }
        if (len === 5) {
            var tempValue = '';
            for (var i = 1, len_1 = value.length; i < len_1; i++) {
                tempValue += (value.charAt(i) + value.charAt(i));
            }
            value = '#' + tempValue;
            len = 9;
        }
        if (len === 7) {
            value += 'ff';
        }
        return value;
    };
    ColorPicker.prototype.hexToRgb = function (hex) {
        if (!hex) {
            return [];
        }
        hex = hex.trim();
        if (hex.length !== 9) {
            hex = this.roundValue(hex);
        }
        var opacity = Number((parseInt(hex.slice(-2), 16) / 255).toFixed(2));
        hex = hex.slice(1, 7);
        var bigInt = parseInt(hex, 16);
        var h = [];
        h.push((bigInt >> 16) & 255);
        h.push((bigInt >> 8) & 255);
        h.push(bigInt & 255);
        h.push(opacity);
        return h;
    };
    ColorPicker.prototype.rgbToHsv = function (r, g, b, opacity) {
        if (this.rgb && !this.rgb.length) {
            return [];
        }
        r /= 255;
        g /= 255;
        b /= 255;
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var h;
        var v = max;
        var d = max - min;
        var s = max === 0 ? 0 : d / max;
        if (max === min) {
            h = 0;
        }
        else {
            switch (max) {
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        var hsv = [Math.round(h * 360), Math.round(s * 1000) / 10, Math.round(v * 1000) / 10];
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(opacity)) {
            hsv.push(opacity);
        }
        return hsv;
    };
    ColorPicker.prototype.hsvToRgb = function (h, s, v, opacity) {
        var r;
        var g;
        var b;
        s /= 100;
        v /= 100;
        if (s === 0) {
            r = g = b = v;
            return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255), opacity];
        }
        h /= 60;
        var i = Math.floor(h);
        var f = h - i;
        var p = v * (1 - s);
        var q = v * (1 - s * f);
        var t = v * (1 - s * (1 - f));
        switch (i) {
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            default:
                r = v;
                g = p;
                b = q;
        }
        var rgb = [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(opacity)) {
            rgb.push(opacity);
        }
        return rgb;
    };
    ColorPicker.prototype.rgbToHex = function (rgb) {
        return rgb.length ? ('#' + this.hex(rgb[0]) + this.hex(rgb[1]) + this.hex(rgb[2]) +
            (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(rgb[3]) ? (rgb[3] !== 0 ? (Math.round(rgb[3] * 255) + 0x10000).toString(16).substr(-2) : '00') : '')) : '';
    };
    ColorPicker.prototype.hex = function (x) {
        return ('0' + x.toString(16)).slice(-2);
    };
    ColorPicker.prototype.changeModeSwitcherProp = function (prop) {
        var ctrlSwitchWrapper = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CTRLSWITCH, this.container);
        if (prop) {
            if (ctrlSwitchWrapper) {
                this.appendModeSwitchBtn();
            }
            else {
                this.createCtrlBtn();
                if (this.isPicker() && !this.disabled) {
                    this.addCtrlSwitchEvent();
                }
            }
        }
        else {
            if (ctrlSwitchWrapper) {
                if (this.showButtons) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + MODESWITCH, ctrlSwitchWrapper));
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(ctrlSwitchWrapper);
                }
            }
        }
    };
    ColorPicker.prototype.changeShowBtnProps = function (prop) {
        var ctrlBtnWrapper = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CTRLSWITCH, this.container);
        if (prop) {
            if (ctrlBtnWrapper) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(ctrlBtnWrapper);
            }
            this.createCtrlBtn();
            if (this.isPicker() && !this.disabled) {
                this.addCtrlSwitchEvent();
            }
        }
        else {
            if (this.modeSwitcher) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + CTRLBTN, ctrlBtnWrapper));
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(ctrlBtnWrapper);
            }
        }
    };
    ColorPicker.prototype.changeValueProp = function (newProp) {
        if (this.isPicker()) {
            this.rgb = this.hexToRgb(newProp);
            this.hsv = this.rgbToHsv.apply(this, this.rgb);
            this.setHandlerPosition();
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.hueSlider.element, '.e-slider-preview'));
            this.createSlider();
            this.setHsvContainerBg();
            this.updateInput(newProp);
            if (this.rgb.length === 4) {
                this.updateOpacityInput(this.rgb[3] * 100);
            }
        }
        else {
            this.removeTileSelection();
            var ele = this.container.querySelector('span[aria-label="' + this.roundValue(newProp) + '"]');
            if (ele) {
                this.addTileSelection(ele);
            }
        }
    };
    ColorPicker.prototype.setInputEleProps = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + INPUTWRAPPER, this.container));
        this.createInput();
    };
    ColorPicker.prototype.changeDisabledProp = function (newProp) {
        if (this.isPicker()) {
            this.hueSlider.enabled = !newProp;
            this.opacitySlider.enabled = !newProp;
            this.setInputEleProps();
        }
        if (newProp) {
            this.toggleDisabled(true);
            this.unWireEvents();
        }
        else {
            this.toggleDisabled(false);
            this.wireEvents();
        }
    };
    ColorPicker.prototype.changeCssClassProps = function (newProp, oldProp) {
        var wrapper = this.getWrapper();
        var popupWrapper = this.getPopupEle();
        if (oldProp) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([wrapper, popupWrapper], oldProp.split(' '));
        }
        if (newProp) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([wrapper, popupWrapper], newProp.split(' '));
        }
    };
    ColorPicker.prototype.changeRtlProps = function (newProp) {
        if (newProp) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.getWrapper()], 'e-rtl');
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.getWrapper()], 'e-rtl');
        }
    };
    ColorPicker.prototype.changePaletteProps = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.container.children[0]);
        this.container.style.width = '';
        this.createPalette();
    };
    ColorPicker.prototype.changeOpacityProps = function (newProp) {
        var wrapper = this.getWrapper();
        if (newProp) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.container.parentElement], HIDEOPACITY);
            this.createOpacitySlider(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-colorpicker-slider', this.container).appendChild(this.createElement('div', { className: 'e-opacity-slider' })));
            if (!wrapper.classList.contains(HIDEVALUE) && !wrapper.classList.contains(HIDERGBA)) {
                this.appendOpacityValue(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.e-input-container', this.container));
            }
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.container.parentElement], HIDEOPACITY);
            this.opacitySlider.destroy();
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(this.opacitySlider.element);
            this.opacitySlider = null;
            if (!wrapper.classList.contains(HIDEVALUE) && !wrapper.classList.contains(HIDERGBA)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + OPACITY, this.container).parentElement);
            }
        }
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param  {ColorPickerModel} newProp - Specifies new properties
     * @param  {ColorPickerModel} oldProp - Specifies old properties
     * @returns {void}
     * @private
     */
    ColorPicker.prototype.onPropertyChanged = function (newProp, oldProp) {
        var _this = this;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(newProp.value)) {
            var value = this.roundValue(newProp.value);
            if (value.length === 9) {
                this.element.value = this.roundValue(value).slice(0, 7);
                var preview = this.splitBtn && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + SPLITPREVIEW, this.splitBtn.element);
                if (preview) {
                    preview.style.backgroundColor = this.convertToRgbString(this.hexToRgb(newProp.value));
                }
            }
            else {
                this.value = oldProp.value;
            }
        }
        if (!this.inline && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(newProp.inline)) {
            var otherCompModel = ['disabled', 'enableRtl'];
            this.splitBtn.setProperties(Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_splitbuttons__["c" /* getModel */])(newProp, otherCompModel));
            if (!this.isPopupOpen()) {
                this.changeCssClassProps(newProp.cssClass, oldProp.cssClass);
                this.changeRtlProps(newProp.enableRtl);
                return;
            }
        }
        var _loop_1 = function (prop) {
            switch (prop) {
                case 'inline':
                    if (newProp.inline) {
                        this_1.getWrapper().appendChild(this_1.container);
                        this_1.splitBtn.destroy();
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this_1.element.nextElementSibling);
                        if (!this_1.container.children.length) {
                            this_1.createWidget();
                        }
                    }
                    else {
                        this_1.destroyOtherComp();
                        this_1.unWireEvents();
                        this_1.container.innerHTML = '';
                        this_1.createSplitBtn();
                    }
                    break;
                case 'cssClass': {
                    this_1.changeCssClassProps(newProp.cssClass, oldProp.cssClass);
                    var props = newProp.cssClass.split(' ').concat(oldProp.cssClass.split(' '));
                    props = props.reduce(function (a, b) { if (a.indexOf(b) < 0) {
                        a.push(b);
                    } return a; }, []);
                    var count_1 = 0;
                    props.forEach(function (cls) {
                        if (count_1 === 0 &&
                            (cls === HIDEVALUE || cls === HIDEVALUESWITCH || cls === SHOWVALUE || cls === HIDEHEX || cls === HIDERGBA)) {
                            var inputWrap = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + INPUTWRAPPER, _this.container);
                            if (inputWrap) {
                                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_1" /* select */])('.' + INPUTWRAPPER, _this.container));
                            }
                            _this.createInput();
                            count_1++;
                        }
                    });
                    break;
                }
                case 'enableRtl':
                    if (this_1.isPicker()) {
                        this_1.hueSlider.enableRtl = newProp.enableRtl;
                        if (this_1.enableOpacity) {
                            this_1.opacitySlider.enableRtl = newProp.enableRtl;
                        }
                        this_1.setInputEleProps();
                    }
                    this_1.changeRtlProps(newProp.enableRtl);
                    break;
                case 'disabled':
                    this_1.changeDisabledProp(newProp.disabled);
                    break;
                case 'value':
                    if (this_1.value !== oldProp.value) {
                        this_1.changeValueProp(newProp.value);
                    }
                    break;
                case 'showButtons':
                    this_1.changeShowBtnProps(newProp.showButtons);
                    break;
                case 'mode':
                    if (newProp.mode === 'Picker') {
                        this_1.switchToPicker();
                    }
                    else {
                        this_1.switchToPalette();
                    }
                    break;
                case 'modeSwitcher':
                    this_1.changeModeSwitcherProp(newProp.modeSwitcher);
                    break;
                case 'columns':
                case 'presetColors':
                    if (!this_1.isPicker()) {
                        this_1.changePaletteProps();
                    }
                    break;
                case 'noColor':
                    if (newProp.noColor) {
                        if (this_1.mode === 'Palette' && !this_1.modeSwitcher) {
                            this_1.setNoColor();
                        }
                    }
                    else {
                        this_1.changePaletteProps();
                    }
                    break;
                case 'enableOpacity':
                    this_1.changeOpacityProps(newProp.enableOpacity);
                    break;
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            _loop_1(prop);
        }
    };
    /**
     * Sets the focus to Colorpicker
     * its native method
     *
     * @public
     * @returns {void}
     */
    ColorPicker.prototype.focusIn = function () {
        this.element.parentElement.focus();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('#008000ff')
    ], ColorPicker.prototype, "value", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], ColorPicker.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], ColorPicker.prototype, "disabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Picker')
    ], ColorPicker.prototype, "mode", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], ColorPicker.prototype, "modeSwitcher", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], ColorPicker.prototype, "presetColors", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], ColorPicker.prototype, "showButtons", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(10)
    ], ColorPicker.prototype, "columns", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], ColorPicker.prototype, "inline", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], ColorPicker.prototype, "noColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], ColorPicker.prototype, "enablePersistence", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], ColorPicker.prototype, "enableOpacity", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], ColorPicker.prototype, "createPopupOnClick", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ColorPicker.prototype, "select", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ColorPicker.prototype, "change", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ColorPicker.prototype, "beforeTileRender", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ColorPicker.prototype, "beforeOpen", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ColorPicker.prototype, "open", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ColorPicker.prototype, "beforeClose", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ColorPicker.prototype, "beforeModeSwitch", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ColorPicker.prototype, "onModeSwitch", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], ColorPicker.prototype, "created", void 0);
    ColorPicker = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], ColorPicker);
    return ColorPicker;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_index__ = __webpack_require__(270);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__common_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__drop_down_button_index__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__split_button_index__ = __webpack_require__(272);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__split_button_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__split_button_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_group_index__ = __webpack_require__(274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_button_index__ = __webpack_require__(276);
/* unused harmony namespace reexport */
/**
 * SplitButton all module
 */







/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(34);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__common__["b"]; });
/**
 * Common modules
 */



/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__drop_down_button__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/**
 * DropDownButton modules
 */



/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__split_button__ = __webpack_require__(273);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__split_button__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__split_button__["b"]; });
/**
 * Split Button modules
 */



/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SplitButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Deferred; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_common__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__drop_down_button_drop_down_button__ = __webpack_require__(90);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path='../drop-down-button/drop-down-button-model.d.ts'/>






var RTL = 'e-rtl';
var TAGNAME = 'EJS-SPLITBUTTON';
/**
 * SplitButton component has primary and secondary button. Primary button is used to select
 * default action and secondary button is used to toggle contextual overlays for displaying list of
 * action items. It can contain both text and images.
 * ```html
 * <button id="element"></button>
 * ```
 * ```typescript
 * <script>
 * var splitBtnObj = new SplitButton({content: 'SplitButton'});
 * splitBtnObj.appendTo("#element");
 * </script>
 * ```
 */
var SplitButton = /** @class */ (function (_super) {
    __extends(SplitButton, _super);
    /**
     * Constructor for creating the widget
     *
     * @param  {SplitButtonModel} options - Specifies the splitbutton model
     * @param  {string|HTMLButtonElement} element - Specifies the element
     * @hidden
     */
    function SplitButton(options, element) {
        return _super.call(this, options, element) || this;
    }
    /**
     * Initialize Angular support.
     *
     * @private
     * @returns {void}
     */
    SplitButton.prototype.preRender = function () {
        var ele = this.element;
        if (ele.tagName === TAGNAME) {
            var ejInstance = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('ej2_instances', ele);
            var btn = this.createElement('button', { attrs: { 'type': 'button' } });
            var wrapper = this.createElement(TAGNAME, { className: 'e-' + this.getModuleName() + '-wrapper' });
            for (var idx = 0, len = ele.attributes.length; idx < len; idx++) {
                btn.setAttribute(ele.attributes[idx].nodeName, ele.attributes[idx].nodeValue);
            }
            ele.parentNode.insertBefore(wrapper, ele);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(ele);
            ele = btn;
            wrapper.appendChild(ele);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])('ej2_instances', ejInstance, ele);
            this.wrapper = wrapper;
            this.element = ele;
        }
        if (!this.element.id) {
            this.element.id = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('e-' + this.getModuleName());
        }
    };
    /**
     * Initialize the Component rendering.
     *
     * @returns {void}
     * @private
     */
    SplitButton.prototype.render = function () {
        this.initWrapper();
        this.createPrimaryButton();
        this.renderControl();
    };
    SplitButton.prototype.renderControl = function () {
        this.createSecondaryButton();
        this.setActiveElem([this.element, this.secondaryBtnObj.element]);
        this.setAria();
        this.wireEvents();
        this.renderComplete();
    };
    /**
     * Adds a new item to the menu. By default, new item appends to the list as the last item,
     * but you can insert based on the text parameter.
     *
     * @param  { ItemModel[] } items - Specifies an array of JSON data.
     * @param { string } text - Specifies the text to insert the newly added item in the menu.
     * @returns {void}.
     */
    SplitButton.prototype.addItems = function (items, text) {
        _super.prototype.addItems.call(this, items, text);
        this.secondaryBtnObj.items = this.items;
    };
    /**
     * Removes the items from the menu.
     *
     * @param  { string[] } items - Specifies an array of string to remove the items.
     * @param { string } isUniqueId - Set `true` if specified items is a collection of unique id.
     * @returns {void}.
     */
    SplitButton.prototype.removeItems = function (items, isUniqueId) {
        _super.prototype.removeItems.call(this, items, isUniqueId);
        this.secondaryBtnObj.items = this.items;
    };
    SplitButton.prototype.initWrapper = function () {
        if (!this.wrapper) {
            this.wrapper = this.createElement('div', { className: 'e-' + this.getModuleName() + '-wrapper' });
            this.element.parentNode.insertBefore(this.wrapper, this.element);
        }
        this.element.classList.remove('e-' + this.getModuleName());
        if (this.enableRtl) {
            this.wrapper.classList.add(RTL);
        }
        if (this.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.wrapper], this.cssClass.split(' '));
        }
    };
    SplitButton.prototype.createPrimaryButton = function () {
        var btnModel = {
            cssClass: this.cssClass,
            enableRtl: this.enableRtl,
            iconCss: this.iconCss,
            iconPosition: this.iconPosition,
            content: this.content,
            disabled: this.disabled
        };
        this.primaryBtnObj = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__["a" /* Button */](btnModel);
        this.primaryBtnObj.createElement = this.createElement;
        this.primaryBtnObj.appendTo(this.element);
        this.element.classList.add('e-' + this.getModuleName());
        this.element.type = 'button';
        this.wrapper.appendChild(this.element);
    };
    SplitButton.prototype.createSecondaryButton = function () {
        var _this = this;
        var btnElem = this.createElement('button', {
            className: 'e-icon-btn',
            attrs: { 'tabindex': '-1' },
            id: this.element.id + '_dropdownbtn'
        });
        this.wrapper.appendChild(btnElem);
        var dropDownBtnModel = {
            cssClass: this.cssClass,
            disabled: this.disabled,
            enableRtl: this.enableRtl,
            items: this.items,
            target: this.target,
            createPopupOnClick: this.createPopupOnClick
        };
        dropDownBtnModel.beforeItemRender = function (args) {
            if (_this.createPopupOnClick) {
                _this.secondaryBtnObj.dropDown.relateTo = _this.wrapper;
                _this.dropDown = _this.secondaryBtnObj.dropDown;
            }
            _this.trigger('beforeItemRender', args);
        };
        dropDownBtnModel.open = function (args) {
            _this.trigger('open', args);
        };
        dropDownBtnModel.close = function (args) {
            _this.trigger('close', args);
        };
        dropDownBtnModel.select = function (args) {
            _this.trigger('select', args);
        };
        dropDownBtnModel.beforeOpen = function (args) {
            var callBackPromise = new Deferred();
            _this.trigger('beforeOpen', args, function (observedArgs) {
                callBackPromise.resolve(observedArgs);
            });
            return callBackPromise;
        };
        dropDownBtnModel.beforeClose = function (args) {
            var callBackPromise = new Deferred();
            _this.trigger('beforeClose', args, function (observedArgs) {
                callBackPromise.resolve(observedArgs);
            });
            return callBackPromise;
        };
        this.secondaryBtnObj = new __WEBPACK_IMPORTED_MODULE_3__drop_down_button_drop_down_button__["a" /* DropDownButton */](dropDownBtnModel);
        this.secondaryBtnObj.createElement = this.createElement;
        this.secondaryBtnObj.appendTo(btnElem);
        if (!this.createPopupOnClick) {
            this.secondaryBtnObj.dropDown.relateTo = this.wrapper;
            this.dropDown = this.secondaryBtnObj.dropDown;
        }
        this.secondaryBtnObj.activeElem = [this.element, this.secondaryBtnObj.element];
        this.secondaryBtnObj.element.querySelector('.e-btn-icon').classList.remove('e-icon-right');
    };
    SplitButton.prototype.setAria = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, {
            'aria-expanded': 'false', 'aria-haspopup': 'true',
            'aria-label': this.element.textContent + ' splitbutton', 'aria-owns': this.element.id + '_dropdownbtn-popup'
        });
    };
    /**
     * Get component name.
     *
     * @returns {string} - Module Name
     * @private
     */
    SplitButton.prototype.getModuleName = function () {
        return 'split-btn';
    };
    /**
     * To open/close SplitButton popup based on current state of the SplitButton.
     *
     * @returns {void}
     */
    SplitButton.prototype.toggle = function () {
        this.secondaryBtnObj.toggle();
    };
    SplitButton.prototype.destroy = function () {
        var _this = this;
        var classList = [RTL];
        if (this.cssClass) {
            classList = classList.concat(this.cssClass.split(' '));
        }
        if (this.element) {
            var element = document.getElementById(this.element.id);
            if (element && element.parentElement === this.wrapper) {
                if (this.wrapper.tagName === TAGNAME) {
                    this.wrapper.innerHTML = '';
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.wrapper], ['e-rtl', 'e-' + this.getModuleName() + '-wrapper']);
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.wrapper], this.cssClass.split(' '));
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], classList);
                    ['aria-label', 'aria-haspopup', 'aria-expanded', 'aria-owns', 'type'].forEach(function (key) {
                        _this.element.removeAttribute(key);
                    });
                    this.wrapper.parentNode.insertBefore(this.element, this.wrapper);
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(this.wrapper);
                }
                this.unWireEvents();
            }
        }
        this.primaryBtnObj.destroy();
        this.secondaryBtnObj.destroy();
        _super.prototype.destroy.call(this);
        if (!this.element.getAttribute('class')) {
            this.element.removeAttribute('class');
        }
    };
    SplitButton.prototype.wireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'click', this.primaryBtnClickHandler, this);
        new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["n" /* KeyboardEvents */](this.element, {
            keyAction: this.btnKeyBoardHandler.bind(this),
            keyConfigs: {
                altdownarrow: 'alt+downarrow'
            }
        });
    };
    SplitButton.prototype.unWireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'click', this.primaryBtnClickHandler);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(this.element, __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["n" /* KeyboardEvents */]).destroy();
    };
    SplitButton.prototype.primaryBtnClickHandler = function () {
        this.trigger('click', { element: this.element });
    };
    SplitButton.prototype.btnKeyBoardHandler = function (e) {
        switch (e.action) {
            case 'altdownarrow':
                this.clickHandler(e);
                break;
        }
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param  {SplitButtonModel} newProp - Specifies new properties
     * @param  {SplitButtonModel} oldProp - Specifies old properties
     * @returns {void}
     */
    SplitButton.prototype.onPropertyChanged = function (newProp, oldProp) {
        var model = ['content', 'iconCss', 'iconPosition', 'cssClass', 'disabled', 'enableRtl'];
        this.primaryBtnObj.setProperties(Object(__WEBPACK_IMPORTED_MODULE_2__common_common__["b" /* getModel */])(newProp, model));
        model = ['beforeOpen', 'beforeItemRender', 'select', 'open',
            'close', 'cssClass', 'disabled', 'enableRtl', 'createPopupOnClick'];
        if (Object.keys(newProp).indexOf('items') > -1) {
            this.secondaryBtnObj.items = newProp.items;
            this.secondaryBtnObj.dataBind();
        }
        this.secondaryBtnObj.setProperties(Object(__WEBPACK_IMPORTED_MODULE_2__common_common__["b" /* getModel */])(newProp, model));
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'cssClass':
                    if (oldProp.cssClass) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.wrapper], oldProp.cssClass.split(' '));
                    }
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.wrapper], newProp.cssClass.split(' '));
                    break;
                case 'enableRtl':
                    if (newProp.enableRtl) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.wrapper], RTL);
                    }
                    else {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.wrapper], RTL);
                    }
                    break;
            }
        }
    };
    /**
     * Sets the focus to SplitButton
     * its native method
     *
     * @public
     * @returns {void}
     */
    SplitButton.prototype.focusIn = function () {
        this.element.focus();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], SplitButton.prototype, "content", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], SplitButton.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], SplitButton.prototype, "disabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], SplitButton.prototype, "iconCss", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Left')
    ], SplitButton.prototype, "iconPosition", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], SplitButton.prototype, "createPopupOnClick", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["f" /* Collection */])([], __WEBPACK_IMPORTED_MODULE_2__common_common__["a" /* Item */])
    ], SplitButton.prototype, "items", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], SplitButton.prototype, "target", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], SplitButton.prototype, "beforeItemRender", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], SplitButton.prototype, "beforeOpen", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], SplitButton.prototype, "beforeClose", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], SplitButton.prototype, "click", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], SplitButton.prototype, "close", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], SplitButton.prototype, "open", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], SplitButton.prototype, "select", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], SplitButton.prototype, "created", void 0);
    SplitButton = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], SplitButton);
    return SplitButton;
}(__WEBPACK_IMPORTED_MODULE_3__drop_down_button_drop_down_button__["a" /* DropDownButton */]));

/**
 * Deferred is used to handle asynchronous operation.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        /**
         * Promise is an object that represents a value that may not be available yet, but will be resolved at some point in the future.
         */
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        /**
         * Defines the callback function triggers when the Deferred object is rejected.
         */
        this.catch = this.promise.catch.bind(this.promise);
        /**
         * Defines the callback function triggers when the Deferred object is resolved.
         */
        this.then = this.promise.then.bind(this.promise);
    }
    return Deferred;
}());



/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button_group__ = __webpack_require__(275);
/* unused harmony namespace reexport */
/**
 * ButtonGroup modules
 */



/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__ = __webpack_require__(11);


/**
 * Initialize ButtonGroup CSS component with specified properties.
 * ```html
 * <div id='buttongroup'>
 * <button></button>
 * <button></button>
 * <button></button>
 * </div>
 * ```
 * ```typescript
 * createButtonGroup('#buttongroup', {
 *   cssClass: 'e-outline',
 *   buttons: [
 *       { content: 'Day' },
 *       { content: 'Week' },
 *       { content: 'Work Week'}
 *   ]
 * });
 * ```
 *
 * @param {string} selector
 * @param {CreateButtonGroupModel} options
 * @returns HTMLElement
 */
/**
 * Creates button group.
 *
 * @param {string} selector - Specifies the selector.
 * @param {CreateButtonGroupModel} options - Specifies the button group model.
 * @param {Function} createElement - Specifies the element.
 * @returns {HTMLElement} - Button group element.
 */
function createButtonGroup(selector, options, createElement) {
    if (options === void 0) { options = {}; }
    var child;
    var btnElem;
    var nextChild;
    var btnModel;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(createElement)) {
        createElement = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["B" /* createElement */];
    }
    var wrapper = document.querySelector(selector);
    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([wrapper], ['e-btn-group', 'e-css']);
    wrapper.setAttribute('role', 'group');
    var childs = wrapper.children;
    options.buttons = options.buttons || [];
    for (var i = 0, j = 0; j < childs.length; i++, j++) {
        child = childs[j];
        btnModel = options.buttons[i];
        if (btnModel !== null) {
            if (child.tagName === 'BUTTON') {
                btnElem = child;
            }
            else {
                btnElem = createElement('label');
                nextChild = childs[j + 1];
                if (nextChild) {
                    wrapper.insertBefore(btnElem, nextChild);
                }
                else {
                    wrapper.appendChild(btnElem);
                }
                if (child.id) {
                    btnElem.setAttribute('for', child.id);
                }
                if (btnModel && btnModel.disabled) {
                    child.disabled = true;
                }
                j++;
            }
            if (options.cssClass && btnModel && !btnModel.cssClass) {
                btnModel.cssClass = options.cssClass;
            }
            new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__["a" /* Button */](btnModel || {}, btnElem);
        }
    }
    return wrapper;
}


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_button__ = __webpack_require__(277);
/* unused harmony namespace reexport */
/**
 * ProgressButton modules
 */



/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SpinSettings */
/* unused harmony export AnimationSettings */
/* unused harmony export ProgressButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_buttons__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var HIDESPINNER = 'e-hide-spinner';
var PROGRESS = 'e-progress';
var PROGRESSACTIVE = 'e-progress-active';
var CONTENTCLS = 'e-btn-content';
/**
 * Defines the spin settings.
 */
var SpinSettings = /** @class */ (function (_super) {
    __extends(SpinSettings, _super);
    function SpinSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["r" /* Property */])(null)
    ], SpinSettings.prototype, "template", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["r" /* Property */])(16)
    ], SpinSettings.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["r" /* Property */])('Left')
    ], SpinSettings.prototype, "position", void 0);
    return SpinSettings;
}(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * Defines the animation settings.
 */
var AnimationSettings = /** @class */ (function (_super) {
    __extends(AnimationSettings, _super);
    function AnimationSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["r" /* Property */])(400)
    ], AnimationSettings.prototype, "duration", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["r" /* Property */])('None')
    ], AnimationSettings.prototype, "effect", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["r" /* Property */])('ease')
    ], AnimationSettings.prototype, "easing", void 0);
    return AnimationSettings;
}(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * The ProgressButton visualizes the progression of an operation to indicate the user
 * that a process is happening in the background with visual representation.
 * ```html
 * <button id="element"></button>
 * ```
 * ```typescript
 * <script>
 * var progressButtonObj = new ProgressButton({ content: 'Progress Button' });
 * progressButtonObj.appendTo("#element");
 * </script>
 * ```
 */
var ProgressButton = /** @class */ (function (_super) {
    __extends(ProgressButton, _super);
    /**
     * Constructor for creating the widget.
     *
     * @param  {ProgressButtonModel} options - Specifies progress button model
     * @param  {string|HTMLButtonElement} element - Specifies element
     */
    function ProgressButton(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.step = 1;
        return _this;
    }
    ProgressButton.prototype.preRender = function () {
        _super.prototype.preRender.call(this);
    };
    /**
     * Initialize the Component rendering
     *
     * @returns {void}
     * @private
     */
    ProgressButton.prototype.render = function () {
        _super.prototype.render.call(this);
        this.init();
        this.wireEvents();
        this.setAria();
        this.renderComplete();
    };
    /**
     * Starts the button progress at the specified percent.
     *
     * @param {number} percent - Starts the button progress at this percent.
     * @returns {void}
     */
    ProgressButton.prototype.start = function (percent) {
        this.isPaused = false;
        this.startProgress(percent ? percent : this.percent, this.progressTime);
    };
    /**
     * Stops the button progress.
     *
     * @returns {void}
     */
    ProgressButton.prototype.stop = function () {
        this.isPaused = true;
        cancelAnimationFrame(this.timerId);
    };
    /**
     * Complete the button progress.
     *
     * @returns {void}
     */
    ProgressButton.prototype.progressComplete = function () {
        this.isPaused = false;
        this.finishProgress();
    };
    /**
     * Get component name.
     *
     * @returns {string} - Module Name
     * @private
     */
    ProgressButton.prototype.getModuleName = function () {
        return 'progress-btn';
    };
    /**
     * Destroys the widget.
     *
     * @returns {void}
     */
    ProgressButton.prototype.destroy = function () {
        var _this = this;
        var classList = [HIDESPINNER, PROGRESSACTIVE, 'e-round-corner', 'e-' + _super.prototype.getModuleName.call(this),
            'e-spin-' + this.spinSettings.position.toLowerCase()];
        _super.prototype.destroy.call(this);
        this.unWireEvents();
        this.element.innerHTML = '';
        if (this.cssClass) {
            classList = classList.concat(this.cssClass.split(' '));
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], classList);
        var css = this.element.getAttribute('class') ? ['aria-label', 'aria-valuemin', 'aria-valuemax', 'aria-valuenow']
            : ['aria-label', 'aria-valuemin', 'aria-valuemax', 'aria-valuenow', 'class'];
        css.forEach(function (key) {
            _this.element.removeAttribute(key);
        });
        if (this.disabled) {
            this.element.removeAttribute('disabled');
        }
    };
    ProgressButton.prototype.init = function () {
        this.element.classList.add('e-' + _super.prototype.getModuleName.call(this));
        this.setContent();
        this.createSpinner();
        if (this.enableProgress) {
            this.createProgress();
        }
    };
    ProgressButton.prototype.createSpinner = function () {
        var spinner = this.createElement('span', { className: 'e-spinner' });
        this.setSpinPosition(spinner);
        Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["d" /* createSpinner */])({
            target: spinner, width: this.spinSettings.width || 16, template: this.spinSettings.template
        }, this.createElement);
    };
    ProgressButton.prototype.getSpinner = function () {
        return this.element.getElementsByClassName('e-spinner')[0];
    };
    ProgressButton.prototype.getProgress = function () {
        return this.element.getElementsByClassName(PROGRESS)[0];
    };
    ProgressButton.prototype.setSpinPosition = function (ele) {
        var position = this.spinSettings.position || 'Left';
        if (position === 'Left' || position === 'Top') {
            this.element.insertBefore(ele, this.element.getElementsByClassName(CONTENTCLS)[0]);
        }
        else {
            this.element.appendChild(ele);
        }
        this.element.classList.add('e-spin-' + position.toLowerCase());
    };
    ProgressButton.prototype.createProgress = function () {
        this.element.appendChild(this.createElement('span', { className: PROGRESS }));
    };
    ProgressButton.prototype.setContent = function () {
        var cont;
        cont = this.element.innerHTML;
        if (this.enableHtmlSanitizer) {
            cont = __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["s" /* SanitizeHtmlHelper */].sanitize(this.element.innerHTML);
        }
        this.element.innerHTML = '';
        this.element.appendChild(this.createElement('span', { className: CONTENTCLS, innerHTML: cont }));
    };
    ProgressButton.prototype.setContentIcon = function (content) {
        var contElem = this.createElement('span', { className: CONTENTCLS, innerHTML: content });
        if (this.iconCss) {
            var span = this.createElement('span', { className: 'e-btn-icon ' + this.iconCss });
            if (!this.element.textContent.trim()) {
                this.element.classList.add('e-icon-btn');
            }
            else {
                span.classList.add('e-icon-' + this.iconPosition.toLowerCase());
                if (this.iconPosition === 'Top' || this.iconPosition === 'Bottom') {
                    this.element.classList.add('e-' + this.iconPosition.toLowerCase() + '-icon-btn');
                }
            }
            var node = contElem.childNodes[0];
            if (node && (this.iconPosition === 'Left' || this.iconPosition === 'Top')) {
                contElem.insertBefore(span, node);
            }
            else {
                contElem.appendChild(span);
            }
        }
        this.element.appendChild(contElem);
    };
    ProgressButton.prototype.clickHandler = function () {
        if (this.element.classList.contains(PROGRESSACTIVE)) {
            return;
        }
        this.startProgress();
    };
    ProgressButton.prototype.startProgress = function (percent, progressTime) {
        var clsList = this.element.classList;
        var isVertical = clsList.contains('e-vertical');
        clsList.add(PROGRESSACTIVE);
        if (!(clsList.contains(HIDESPINNER))) {
            Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["j" /* showSpinner */])(this.element);
        }
        this.startAnimate(Date.now(), progressTime ? progressTime : 0, progressTime ? Date.now() - (this.duration * 1 / 100) : Date.now(), percent ? percent : 0, 0, this.step, 0, isVertical);
        this.startContAnimate();
    };
    ProgressButton.prototype.startAnimate = function (timestamp, progressTime, prevTime, percent, prevPercent, step, prevProgressTime, isVertical) {
        var _this = this;
        try {
            var timeDiff = timestamp - prevTime;
            var stepTime = this.duration * step / 100;
            var timeDiffBuffer_1 = timeDiff ? (timeDiff < stepTime ? timeDiff - stepTime : timeDiff % stepTime) : 0;
            this.progressTime = progressTime = progressTime + timeDiff - timeDiffBuffer_1;
            prevTime = timestamp - timeDiffBuffer_1;
            percent = percent + (timeDiff - timeDiffBuffer_1) / this.duration * 100;
            prevPercent = ((progressTime - prevProgressTime) % stepTime === 0 || percent === 100) ? percent : prevPercent;
            var args = { percent: prevPercent, currentDuration: progressTime, step: step };
            this.eIsVertical = isVertical;
            if (percent === 0) {
                this.trigger('begin', args, function (observedArgs) {
                    _this.successCallback(observedArgs, percent, prevPercent, progressTime, prevProgressTime, timeDiffBuffer_1, prevTime);
                });
            }
            else if (percent === 100 || progressTime === this.duration) {
                this.trigger('end', args, function (observedArgs) {
                    _this.successCallback(observedArgs, percent, prevPercent, progressTime, prevProgressTime, timeDiffBuffer_1, prevTime);
                });
            }
            else {
                this.trigger('progress', args, function (observedArgs) {
                    _this.successCallback(observedArgs, percent, prevPercent, progressTime, prevProgressTime, timeDiffBuffer_1, prevTime);
                });
            }
        }
        catch (e) {
            cancelAnimationFrame(this.timerId);
            this.trigger('fail', e);
        }
    };
    ProgressButton.prototype.successCallback = function (args, perc, pPerc, prgTim, pPrgTim, timDif, pTim) {
        var _this = this;
        var percent = perc;
        var prevPercent = pPerc;
        var timeDiffBuffer = timDif;
        var progressTime = prgTim;
        var prevProgressTime = pPrgTim;
        var prevTime = pTim;
        var isVertical = this.eIsVertical;
        if (percent !== args.percent && args.percent !== prevPercent) {
            percent = args.percent;
        }
        this.percent = percent;
        this.step = args.step;
        if ((progressTime - prevProgressTime) % (this.duration * args.step / 100) === 0 || percent === 100) {
            this.timerId = requestAnimationFrame(function () {
                if (_this.enableProgress) {
                    _this.getProgress().style[isVertical ? 'height' : 'width'] = percent + '%';
                }
                _this.element.setAttribute('aria-valuenow', percent.toString());
            });
            prevPercent = percent;
            prevProgressTime = progressTime;
        }
        if (!this.isPaused) {
            if (progressTime < this.duration && percent < 100) {
                this.interval = window.setTimeout(function () {
                    _this.startAnimate(Date.now(), progressTime, prevTime, percent, prevPercent, args.step, prevProgressTime, isVertical);
                }, (this.duration / 100) - timeDiffBuffer);
            }
            else {
                this.interval = window.setTimeout(function () {
                    _this.progressTime = _this.percent = 0;
                    if (_this.enableProgress) {
                        _this.getProgress().style[isVertical ? 'height' : 'width'] = '0%';
                    }
                    _this.element.setAttribute('aria-valuenow', '0');
                    _this.hideSpin();
                }, 100);
            }
        }
    };
    ProgressButton.prototype.startContAnimate = function () {
        var _this = this;
        var ele = this.element.getElementsByClassName(CONTENTCLS)[0];
        if (this.animationSettings.effect !== 'None') {
            (new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["b" /* Animation */]({})).animate(ele, {
                duration: this.animationSettings.duration,
                name: 'Progress' + this.animationSettings.effect,
                timingFunction: this.animationSettings.easing,
                begin: function () {
                    if (_this.spinSettings.position === 'Center') {
                        _this.setSpinnerSize();
                    }
                },
                end: function () {
                    ele.classList.add('e-animate-end');
                }
            });
        }
        else if (this.spinSettings.position === 'Center') {
            this.setSpinnerSize();
        }
    };
    ProgressButton.prototype.finishProgress = function () {
        var clsList = this.element.classList;
        var isVertical = clsList.contains('e-vertical');
        clsList.add(PROGRESSACTIVE);
        var count = 100;
        for (var i = this.percent; i < count; i++) {
            i += 10;
            if (i > 100) {
                i = 100;
            }
            if (this.enableProgress) {
                this.getProgress().style[isVertical ? 'height' : 'width'] = (this.percent < 100) ? (i + '%') : '100%';
            }
        }
        this.element.setAttribute('aria-valuenow', '0');
        this.hideSpin();
        var args = { step: this.step, currentDuration: this.progressTime, percent: 100 };
        clearTimeout(this.interval);
        this.trigger('end', args);
        this.progressTime = this.percent = 0;
    };
    ProgressButton.prototype.setSpinnerSize = function () {
        var ele = this.element.getElementsByClassName(CONTENTCLS)[0];
        var spinner = this.getSpinner();
        spinner.style.width = Math.max(spinner.offsetWidth, ele.offsetWidth) + 'px';
        spinner.style.height = Math.max(spinner.offsetHeight, ele.offsetHeight) + 'px';
        ele.classList.add('e-cont-animate');
    };
    ProgressButton.prototype.hideSpin = function () {
        var cont = this.element.getElementsByClassName(CONTENTCLS)[0];
        if (!(this.element.classList.contains(HIDESPINNER))) {
            Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["h" /* hideSpinner */])(this.element);
        }
        this.element.classList.remove(PROGRESSACTIVE);
        if (this.animationSettings.effect !== 'None') {
            cont.classList.remove('e-animate-end');
        }
        if (this.spinSettings.position === 'Center') {
            var ele = this.getSpinner();
            cont.classList.remove('e-cont-animate');
            ele.style.width = 'auto';
            ele.style.height = 'auto';
        }
    };
    ProgressButton.prototype.setIconSpan = function () {
        var cont = this.element.getElementsByClassName(CONTENTCLS)[0];
        var iconSpan = this.element.getElementsByClassName('e-btn-icon')[0];
        if (cont.childNodes[0] && (this.iconPosition === 'Left' || this.iconPosition === 'Top')) {
            cont.insertBefore(iconSpan, cont.childNodes[0]);
        }
        else {
            cont.appendChild(iconSpan);
        }
    };
    ProgressButton.prototype.setAria = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["w" /* attributes */])(this.element, {
            'aria-label': this.element.textContent + ' progress', 'aria-valuemin': '0', 'aria-valuemax': '100', 'aria-valuenow': '0'
        });
    };
    ProgressButton.prototype.wireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'click', this.clickHandler, this);
    };
    ProgressButton.prototype.unWireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'click', this.clickHandler);
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param  {ProgressButtonModel} newProp - Specifies new properties
     * @param  {ProgressButtonModel} oldProp - Specifies old properties
     * @returns {void}
     * @private
     */
    ProgressButton.prototype.onPropertyChanged = function (newProp, oldProp) {
        var ele = this.element;
        var isSpinning = false;
        var clsList = this.element.querySelector('.e-spinner-pane').classList;
        if (clsList.contains('e-spin-show')) {
            isSpinning = true;
        }
        _super.prototype.onPropertyChanged.call(this, newProp, oldProp);
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'content':
                    this.setContent();
                    this.createSpinner();
                    if (isSpinning) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["j" /* showSpinner */])(this.element);
                        isSpinning = false;
                    }
                    if (this.enableProgress) {
                        this.createProgress();
                    }
                    ele.setAttribute('aria-label', ele.textContent + ' progress');
                    break;
                case 'iconCss':
                    if (!oldProp.iconCss) {
                        this.setIconSpan();
                    }
                    break;
                case 'iconPosition':
                    this.setIconSpan();
                    break;
                case 'enableProgress':
                    if (newProp.enableProgress) {
                        this.createProgress();
                    }
                    else {
                        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Y" /* remove */])(this.getProgress());
                    }
                    break;
                case 'spinSettings':
                    if (newProp.spinSettings.position) {
                        ele.classList.remove('e-spin-' + oldProp.spinSettings.position.toLowerCase());
                        this.setSpinPosition(this.getSpinner());
                    }
                    if (newProp.spinSettings.template || newProp.spinSettings.width) {
                        ele.removeChild(this.getSpinner());
                        this.createSpinner();
                    }
                    break;
            }
        }
    };
    /**
     * Sets the focus to ProgressButton
     * its native method
     *
     * @public
     * @returns {void}
     */
    ProgressButton.prototype.focusIn = function () {
        this.element.focus();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["r" /* Property */])(false)
    ], ProgressButton.prototype, "enableProgress", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["r" /* Property */])(2000)
    ], ProgressButton.prototype, "duration", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["r" /* Property */])('Left')
    ], ProgressButton.prototype, "iconPosition", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["r" /* Property */])('')
    ], ProgressButton.prototype, "iconCss", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["r" /* Property */])(false)
    ], ProgressButton.prototype, "disabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["r" /* Property */])(false)
    ], ProgressButton.prototype, "isPrimary", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["r" /* Property */])('')
    ], ProgressButton.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["r" /* Property */])('')
    ], ProgressButton.prototype, "content", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["r" /* Property */])(false)
    ], ProgressButton.prototype, "isToggle", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["r" /* Property */])(false)
    ], ProgressButton.prototype, "enableHtmlSanitizer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["g" /* Complex */])({}, SpinSettings)
    ], ProgressButton.prototype, "spinSettings", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["g" /* Complex */])({}, AnimationSettings)
    ], ProgressButton.prototype, "animationSettings", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["k" /* Event */])()
    ], ProgressButton.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["k" /* Event */])()
    ], ProgressButton.prototype, "begin", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["k" /* Event */])()
    ], ProgressButton.prototype, "progress", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["k" /* Event */])()
    ], ProgressButton.prototype, "end", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["k" /* Event */])()
    ], ProgressButton.prototype, "fail", void 0);
    ProgressButton = __decorate([
        __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], ProgressButton);
    return ProgressButton;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_buttons__["a" /* Button */]));



/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__textbox__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/**
 * Uploader modules
 */



/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TextBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input_input__ = __webpack_require__(22);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var HIDE_CLEAR = 'e-clear-icon-hide';
var TEXTBOX_FOCUS = 'e-input-focus';
var containerAttr = ['title', 'style', 'class'];
/**
 * Represents the TextBox component that allows the user to enter the values based on it's type.
 * ```html
 * <input name='images' id='textbox'/>
 * ```
 * ```typescript
 * <script>
 *   var textboxObj = new TextBox();
 *   textboxObj.appendTo('#textbox');
 * </script>
 * ```
 */
var TextBox = /** @class */ (function (_super) {
    __extends(TextBox, _super);
    /**
     *
     * @param {TextBoxModel} options - Specifies the TextBox model.
     * @param {string | HTMLInputElement | HTMLTextAreaElement} element - Specifies the element to render as component.
     * @private
     */
    function TextBox(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.previousValue = null;
        _this.isAngular = false;
        _this.isHiddenInput = false;
        _this.isForm = false;
        _this.inputPreviousValue = null;
        _this.isVue = false;
        _this.textboxOptions = options;
        return _this;
    }
    /**
     * Calls internally if any of the property value is changed.
     *
     * @param {TextBoxModel} newProp - Returns the dynamic property value of the component.
     * @param {TextBoxModel} oldProp - Returns the previous property value of the component.
     * @returns {void}
     * @private
     */
    TextBox.prototype.onPropertyChanged = function (newProp, oldProp) {
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'floatLabelType':
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].removeFloating(this.textboxWrapper);
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].addFloating(this.respectiveElement, this.floatLabelType, this.placeholder);
                    break;
                case 'enabled':
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setEnabled(this.enabled, this.respectiveElement, this.floatLabelType, this.textboxWrapper.container);
                    this.bindClearEvent();
                    break;
                case 'width':
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setWidth(newProp.width, this.textboxWrapper.container);
                    break;
                case 'value':
                    {
                        var prevOnChange = this.isProtectedOnChange;
                        this.isProtectedOnChange = true;
                        if (!this.isBlank(this.value)) {
                            this.value = this.value.toString();
                        }
                        this.isProtectedOnChange = prevOnChange;
                        __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setValue(this.value, this.respectiveElement, this.floatLabelType, this.showClearButton);
                        if (this.isHiddenInput) {
                            this.element.value = this.respectiveElement.value;
                        }
                        this.inputPreviousValue = this.respectiveElement.value;
                        /* istanbul ignore next */
                        if ((this.isAngular || this.isVue) && this.preventChange === true) {
                            this.previousValue = this.isAngular ? this.value : this.previousValue;
                            this.preventChange = false;
                        }
                        else if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.isAngular) || !this.isAngular
                            || (this.isAngular && !this.preventChange) || (this.isAngular && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.preventChange))) {
                            this.raiseChangeEvent();
                        }
                    }
                    break;
                case 'htmlAttributes':
                    {
                        this.updateHTMLAttrToElement();
                        this.updateHTMLAttrToWrapper();
                        this.checkAttributes(true);
                        __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].validateInputType(this.textboxWrapper.container, this.element);
                    }
                    break;
                case 'readonly':
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setReadonly(this.readonly, this.respectiveElement);
                    break;
                case 'type':
                    if (this.respectiveElement.tagName !== 'TEXTAREA') {
                        this.respectiveElement.setAttribute('type', this.type);
                        __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].validateInputType(this.textboxWrapper.container, this.element);
                        this.raiseChangeEvent();
                    }
                    break;
                case 'showClearButton':
                    if (this.respectiveElement.tagName !== 'TEXTAREA') {
                        __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setClearButton(this.showClearButton, this.respectiveElement, this.textboxWrapper);
                        this.bindClearEvent();
                    }
                    break;
                case 'enableRtl':
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setEnableRtl(this.enableRtl, [this.textboxWrapper.container]);
                    break;
                case 'placeholder':
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setPlaceholder(this.placeholder, this.respectiveElement);
                    break;
                case 'autocomplete':
                    if (this.autocomplete !== 'on' && this.autocomplete !== '') {
                        this.respectiveElement.autocomplete = this.autocomplete;
                    }
                    else {
                        this.removeAttributes(['autocomplete']);
                    }
                    break;
                case 'cssClass':
                    this.updateCssClass(newProp.cssClass, oldProp.cssClass);
                    break;
                case 'locale':
                    this.globalize = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["m" /* Internationalization */](this.locale);
                    this.l10n.setLocale(this.locale);
                    this.setProperties({ placeholder: this.l10n.getConstant('placeholder') }, true);
                    __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setPlaceholder(this.placeholder, this.respectiveElement);
                    break;
            }
        }
    };
    /**
     * Gets the component name
     *
     * @returns {string} Returns the component name.
     * @private
     */
    TextBox.prototype.getModuleName = function () {
        return 'textbox';
    };
    TextBox.prototype.isBlank = function (str) {
        return (!str || /^\s*$/.test(str));
    };
    TextBox.prototype.preRender = function () {
        this.cloneElement = this.element.cloneNode(true);
        this.formElement = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(this.element, 'form');
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.formElement)) {
            this.isForm = true;
        }
        /* istanbul ignore next */
        if (this.element.tagName === 'EJS-TEXTBOX') {
            var ejInstance = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('ej2_instances', this.element);
            var inputElement = this.multiline ?
                this.createElement('textarea') :
                this.createElement('input');
            var index = 0;
            for (index; index < this.element.attributes.length; index++) {
                var attributeName = this.element.attributes[index].nodeName;
                if (attributeName !== 'id') {
                    inputElement.setAttribute(attributeName, this.element.attributes[index].nodeValue);
                    inputElement.innerHTML = this.element.innerHTML;
                    if (attributeName === 'name') {
                        this.element.removeAttribute('name');
                    }
                }
            }
            this.element.appendChild(inputElement);
            this.element = inputElement;
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_5" /* setValue */])('ej2_instances', ejInstance, this.element);
        }
        this.updateHTMLAttrToElement();
        this.checkAttributes(false);
        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.textboxOptions) || (this.textboxOptions['value'] === undefined)) && this.element.value !== '') {
            this.setProperties({ value: this.element.value }, true);
        }
        if (this.element.tagName !== 'TEXTAREA') {
            this.element.setAttribute('type', this.type);
        }
        this.element.setAttribute('role', 'textbox');
        this.globalize = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["m" /* Internationalization */](this.locale);
        var localeText = { placeholder: this.placeholder };
        this.l10n = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["o" /* L10n */]('textbox', localeText, this.locale);
        if (this.l10n.getConstant('placeholder') !== '') {
            this.setProperties({ placeholder: this.placeholder || this.l10n.getConstant('placeholder') }, true);
        }
        if (!this.element.hasAttribute('id')) {
            this.element.setAttribute('id', Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('textbox'));
        }
        if (!this.element.hasAttribute('name')) {
            this.element.setAttribute('name', this.element.getAttribute('id'));
        }
        if (this.element.tagName === 'INPUT' && this.multiline) {
            this.isHiddenInput = true;
            this.textarea = this.createElement('textarea');
            this.element.parentNode.insertBefore(this.textarea, this.element);
            this.element.setAttribute('type', 'hidden');
            this.textarea.setAttribute('name', this.element.getAttribute('name'));
            this.element.removeAttribute('name');
            this.textarea.setAttribute('role', this.element.getAttribute('role'));
            this.element.removeAttribute('role');
            this.textarea.setAttribute('id', Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('textarea'));
            var apiAttributes = ['placeholder', 'disabled', 'value', 'readonly', 'type', 'autocomplete'];
            for (var index = 0; index < this.element.attributes.length; index++) {
                var attributeName = this.element.attributes[index].nodeName;
                if (this.element.hasAttribute(attributeName) && containerAttr.indexOf(attributeName) < 0 &&
                    !(attributeName === 'id' || attributeName === 'type' || attributeName === 'e-mappinguid')) {
                    // e-mappinguid attribute is handled for Grid component.
                    this.textarea.setAttribute(attributeName, this.element.attributes[index].nodeValue);
                    if (apiAttributes.indexOf(attributeName) < 0) {
                        this.element.removeAttribute(attributeName);
                        index--;
                    }
                }
            }
        }
    };
    TextBox.prototype.checkAttributes = function (isDynamic) {
        var attrs = isDynamic ? Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.htmlAttributes) ? [] : Object.keys(this.htmlAttributes) :
            ['placeholder', 'disabled', 'value', 'readonly', 'type', 'autocomplete'];
        for (var _i = 0, attrs_1 = attrs; _i < attrs_1.length; _i++) {
            var key = attrs_1[_i];
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.element.getAttribute(key))) {
                switch (key) {
                    case 'disabled':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.textboxOptions) || (this.textboxOptions['enabled'] === undefined)) || isDynamic) {
                            var enabled = this.element.getAttribute(key) === 'disabled' || this.element.getAttribute(key) === '' ||
                                this.element.getAttribute(key) === 'true' ? false : true;
                            this.setProperties({ enabled: enabled }, !isDynamic);
                        }
                        break;
                    case 'readonly':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.textboxOptions) || (this.textboxOptions['readonly'] === undefined)) || isDynamic) {
                            var readonly = this.element.getAttribute(key) === 'readonly' || this.element.getAttribute(key) === ''
                                || this.element.getAttribute(key) === 'true' ? true : false;
                            this.setProperties({ readonly: readonly }, !isDynamic);
                        }
                        break;
                    case 'placeholder':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.textboxOptions) || (this.textboxOptions['placeholder'] === undefined)) || isDynamic) {
                            this.setProperties({ placeholder: this.element.placeholder }, !isDynamic);
                        }
                        break;
                    case 'autocomplete':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.textboxOptions) || (this.textboxOptions['autocomplete'] === undefined)) || isDynamic) {
                            var autoCompleteTxt = this.element.autocomplete === 'off' ? 'off' : 'on';
                            this.setProperties({ autocomplete: autoCompleteTxt }, !isDynamic);
                        }
                        break;
                    case 'value':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.textboxOptions) || (this.textboxOptions['value'] === undefined)) || isDynamic) {
                            this.setProperties({ value: this.element.value }, !isDynamic);
                        }
                        break;
                    case 'type':
                        if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.textboxOptions) || (this.textboxOptions['type'] === undefined)) || isDynamic) {
                            this.setProperties({ type: this.element.type }, !isDynamic);
                        }
                        break;
                }
            }
        }
    };
    /**
     * To Initialize the control rendering
     *
     * @returns {void}
     * @private
     */
    TextBox.prototype.render = function () {
        var updatedCssClassValue = this.cssClass;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.cssClass) && this.cssClass !== '') {
            updatedCssClassValue = this.getInputValidClassList(this.cssClass);
        }
        this.respectiveElement = (this.isHiddenInput) ? this.textarea : this.element;
        this.textboxWrapper = __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].createInput({
            element: this.respectiveElement,
            floatLabelType: this.floatLabelType,
            properties: {
                enabled: this.enabled,
                enableRtl: this.enableRtl,
                cssClass: updatedCssClassValue,
                readonly: this.readonly,
                placeholder: this.placeholder,
                showClearButton: this.showClearButton
            }
        });
        this.updateHTMLAttrToWrapper();
        if (this.isHiddenInput) {
            this.respectiveElement.parentNode.insertBefore(this.element, this.respectiveElement);
        }
        this.wireEvents();
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.value)) {
            __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setValue(this.value, this.respectiveElement, this.floatLabelType, this.showClearButton);
            if (this.isHiddenInput) {
                this.element.value = this.respectiveElement.value;
            }
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.value)) {
            this.initialValue = this.value;
            this.setInitialValue();
        }
        if (this.autocomplete !== 'on' && this.autocomplete !== '') {
            this.respectiveElement.autocomplete = this.autocomplete;
        }
        else if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.textboxOptions) && (this.textboxOptions['autocomplete'] !== undefined)) {
            this.removeAttributes(['autocomplete']);
        }
        this.previousValue = this.value;
        this.inputPreviousValue = this.value;
        this.respectiveElement.defaultValue = this.respectiveElement.value;
        __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setWidth(this.width, this.textboxWrapper.container);
        this.renderComplete();
    };
    TextBox.prototype.updateHTMLAttrToWrapper = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.htmlAttributes)) {
            for (var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++) {
                var key = _a[_i];
                if (containerAttr.indexOf(key) > -1) {
                    if (key === 'class') {
                        var updatedClassValues = this.getInputValidClassList(this.htmlAttributes[key]);
                        if (updatedClassValues !== '') {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.textboxWrapper.container], updatedClassValues.split(' '));
                        }
                    }
                    else if (key === 'style') {
                        var setStyle = this.textboxWrapper.container.getAttribute(key);
                        setStyle = !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(setStyle) ? (setStyle + this.htmlAttributes[key]) :
                            this.htmlAttributes[key];
                        this.textboxWrapper.container.setAttribute(key, setStyle);
                    }
                    else {
                        this.textboxWrapper.container.setAttribute(key, this.htmlAttributes[key]);
                    }
                }
            }
        }
    };
    TextBox.prototype.updateHTMLAttrToElement = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.htmlAttributes)) {
            for (var _i = 0, _a = Object.keys(this.htmlAttributes); _i < _a.length; _i++) {
                var key = _a[_i];
                if (containerAttr.indexOf(key) < 0) {
                    this.element.setAttribute(key, this.htmlAttributes[key]);
                }
            }
        }
    };
    TextBox.prototype.updateCssClass = function (newClass, oldClass) {
        __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setCssClass(this.getInputValidClassList(newClass), [this.textboxWrapper.container], this.getInputValidClassList(oldClass));
    };
    TextBox.prototype.getInputValidClassList = function (inputClassName) {
        var result = inputClassName;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(inputClassName) && inputClassName !== '') {
            result = (inputClassName.replace(/\s+/g, ' ')).trim();
        }
        return result;
    };
    TextBox.prototype.setInitialValue = function () {
        if (!this.isAngular) {
            this.respectiveElement.setAttribute('value', this.initialValue);
        }
    };
    TextBox.prototype.wireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.respectiveElement, 'focus', this.focusHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.respectiveElement, 'blur', this.focusOutHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.respectiveElement, 'input', this.inputHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.respectiveElement, 'change', this.changeHandler, this);
        if (this.isForm) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.formElement, 'reset', this.resetForm, this);
        }
        this.bindClearEvent();
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.textboxWrapper.container.querySelector('.e-float-text')) && this.floatLabelType === 'Auto'
            && this.textboxWrapper.container.classList.contains('e-autofill') &&
            this.textboxWrapper.container.classList.contains('e-outline')) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add((this.textboxWrapper.container.querySelector('.e-float-text')), 'animationstart', this.animationHandler, this);
        }
    };
    TextBox.prototype.animationHandler = function () {
        this.textboxWrapper.container.classList.add('e-valid-input');
        var label = this.textboxWrapper.container.querySelector('.e-float-text');
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(label)) {
            label.classList.add('e-label-top');
            if (label.classList.contains('e-label-bottom')) {
                label.classList.remove('e-label-bottom');
            }
        }
    };
    TextBox.prototype.resetValue = function (value) {
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        this.value = value;
        this.isProtectedOnChange = prevOnChange;
    };
    TextBox.prototype.resetForm = function () {
        if (this.isAngular) {
            this.resetValue('');
        }
        else {
            this.resetValue(this.initialValue);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.textboxWrapper)) {
            var label = this.textboxWrapper.container.querySelector('.e-float-text');
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(label)) {
                if ((Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.initialValue) || this.initialValue === '')) {
                    label.classList.add('e-label-bottom');
                    label.classList.remove('e-label-top');
                }
                else if (this.initialValue !== '') {
                    label.classList.add('e-label-top');
                    label.classList.remove('e-label-bottom');
                }
            }
        }
    };
    TextBox.prototype.focusHandler = function (args) {
        var eventArgs = {
            container: this.textboxWrapper.container,
            event: args,
            value: this.value
        };
        this.trigger('focus', eventArgs);
    };
    TextBox.prototype.focusOutHandler = function (args) {
        if (!(this.previousValue === null && this.value === null && this.respectiveElement.value === '') &&
            (this.previousValue !== this.respectiveElement.value)) {
            this.raiseChangeEvent(args, true);
        }
        var eventArgs = {
            container: this.textboxWrapper.container,
            event: args,
            value: this.value
        };
        this.trigger('blur', eventArgs);
    };
    TextBox.prototype.inputHandler = function (args) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-this-alias
        var textboxObj = this;
        var eventArgs = {
            event: args,
            value: this.respectiveElement.value,
            previousValue: this.inputPreviousValue,
            container: this.textboxWrapper.container
        };
        this.inputPreviousValue = this.respectiveElement.value;
        /* istanbul ignore next */
        if (this.isAngular) {
            textboxObj.localChange({ value: this.respectiveElement.value });
            this.preventChange = true;
        }
        if (this.isVue) {
            this.preventChange = true;
        }
        this.trigger('input', eventArgs);
        args.stopPropagation();
    };
    TextBox.prototype.changeHandler = function (args) {
        this.setProperties({ value: this.respectiveElement.value }, true);
        this.raiseChangeEvent(args, true);
        args.stopPropagation();
    };
    TextBox.prototype.raiseChangeEvent = function (event, interaction) {
        var eventArgs = {
            event: event,
            value: this.value,
            previousValue: this.previousValue,
            container: this.textboxWrapper.container,
            isInteraction: interaction ? interaction : false,
            isInteracted: interaction ? interaction : false
        };
        this.preventChange = false;
        this.trigger('change', eventArgs);
        this.previousValue = this.value;
        //EJ2CORE-738:For this task we update the textarea value to the input when input tag with multiline is present
        if (this.element.tagName === 'INPUT' && this.multiline && __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].info.name === 'mozilla') {
            this.element.value = this.respectiveElement.value;
        }
    };
    TextBox.prototype.bindClearEvent = function () {
        if (this.showClearButton && this.respectiveElement.tagName !== 'TEXTAREA') {
            if (this.enabled) {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.textboxWrapper.clearButton, 'mousedown touchstart', this.resetInputHandler, this);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.textboxWrapper.clearButton, 'mousedown touchstart', this.resetInputHandler);
            }
        }
    };
    TextBox.prototype.resetInputHandler = function (event) {
        event.preventDefault();
        if (!(this.textboxWrapper.clearButton.classList.contains(HIDE_CLEAR)) || this.textboxWrapper.container.classList.contains('e-static-clear')) {
            __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setValue('', this.respectiveElement, this.floatLabelType, this.showClearButton);
            if (this.isHiddenInput) {
                this.element.value = this.respectiveElement.value;
            }
            this.setProperties({ value: this.respectiveElement.value }, true);
            var eventArgs = {
                event: event,
                value: this.respectiveElement.value,
                previousValue: this.inputPreviousValue,
                container: this.textboxWrapper.container
            };
            this.trigger('input', eventArgs);
            this.inputPreviousValue = this.respectiveElement.value;
            this.raiseChangeEvent(event, true);
        }
    };
    TextBox.prototype.unWireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.respectiveElement, 'focus', this.focusHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.respectiveElement, 'blur', this.focusOutHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.respectiveElement, 'input', this.inputHandler);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.respectiveElement, 'change', this.changeHandler);
        if (this.isForm) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.formElement, 'reset', this.resetForm);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.textboxWrapper.container.querySelector('.e-float-text')) && this.floatLabelType === 'Auto'
            && this.textboxWrapper.container.classList.contains('e-outline') &&
            this.textboxWrapper.container.classList.contains('e-autofill')) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove((this.textboxWrapper.container.querySelector('.e-float-text')), 'animationstart', this.animationHandler);
        }
    };
    /**
     * Removes the component from the DOM and detaches all its related event handlers.
     * Also, it maintains the initial TextBox element from the DOM.
     *
     * @method destroy
     * @returns {void}
     */
    TextBox.prototype.destroy = function () {
        this.unWireEvents();
        if (this.element.tagName === 'INPUT' && this.multiline) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.textboxWrapper.container.getElementsByTagName('textarea')[0]);
            this.respectiveElement = this.element;
            this.element.removeAttribute('type');
        }
        this.respectiveElement.value = this.respectiveElement.defaultValue;
        this.respectiveElement.classList.remove('e-input');
        this.removeAttributes(['aria-placeholder', 'aria-disabled', 'aria-readonly', 'aria-labelledby']);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.textboxWrapper)) {
            this.textboxWrapper.container.insertAdjacentElement('afterend', this.respectiveElement);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.textboxWrapper.container);
        }
        this.textboxWrapper = null;
        _super.prototype.destroy.call(this);
    };
    /**
     * Adding the icons to the TextBox component.
     *
     * @param { string } position - Specify the icon placement on the TextBox. Possible values are append and prepend.
     * @param { string | string[] } icons - Icon classes which are need to add to the span element which is going to created.
     * Span element acts as icon or button element for TextBox.
     * @returns {void}
     */
    TextBox.prototype.addIcon = function (position, icons) {
        __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].addIcon(position, icons, this.textboxWrapper.container, this.respectiveElement, this.createElement);
    };
    /* eslint-disable valid-jsdoc, jsdoc/require-returns */
    /**
     * Gets the properties to be maintained in the persisted state.
     *
     */
    TextBox.prototype.getPersistData = function () {
        var keyEntity = ['value'];
        return this.addOnPersist(keyEntity);
    };
    /* eslint-enable valid-jsdoc, jsdoc/require-returns */
    /**
     * Adding the multiple attributes as key-value pair to the TextBox element.
     *
     * @param {string} attributes - Specifies the attributes to be add to TextBox element.
     * @returns {void}
     */
    TextBox.prototype.addAttributes = function (attributes) {
        for (var _i = 0, _a = Object.keys(attributes); _i < _a.length; _i++) {
            var key = _a[_i];
            if (key === 'disabled') {
                this.setProperties({ enabled: false }, true);
                __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setEnabled(this.enabled, this.respectiveElement, this.floatLabelType, this.textboxWrapper.container);
            }
            else if (key === 'readonly') {
                this.setProperties({ readonly: true }, true);
                __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setReadonly(this.readonly, this.respectiveElement);
            }
            else if (key === 'class') {
                this.respectiveElement.classList.add(attributes[key]);
            }
            else if (key === 'placeholder') {
                this.setProperties({ placeholder: attributes[key] }, true);
                __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setPlaceholder(this.placeholder, this.respectiveElement);
            }
            else if (key === 'rows' && this.respectiveElement.tagName === 'TEXTAREA') {
                this.respectiveElement.setAttribute(key, attributes[key]);
            }
            else {
                this.respectiveElement.setAttribute(key, attributes[key]);
            }
        }
    };
    /**
     * Removing the multiple attributes as key-value pair to the TextBox element.
     *
     * @param { string[] } attributes - Specifies the attributes name to be removed from TextBox element.
     * @returns {void}
     */
    TextBox.prototype.removeAttributes = function (attributes) {
        for (var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++) {
            var key = attributes_1[_i];
            if (key === 'disabled') {
                this.setProperties({ enabled: true }, true);
                __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setEnabled(this.enabled, this.respectiveElement, this.floatLabelType, this.textboxWrapper.container);
            }
            else if (key === 'readonly') {
                this.setProperties({ readonly: false }, true);
                __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setReadonly(this.readonly, this.respectiveElement);
            }
            else if (key === 'placeholder') {
                this.setProperties({ placeholder: null }, true);
                __WEBPACK_IMPORTED_MODULE_1__input_input__["a" /* Input */].setPlaceholder(this.placeholder, this.respectiveElement);
            }
            else {
                this.respectiveElement.removeAttribute(key);
            }
        }
    };
    /**
     * Sets the focus to widget for interaction.
     *
     * @returns {void}
     */
    TextBox.prototype.focusIn = function () {
        if (document.activeElement !== this.respectiveElement && this.enabled) {
            this.respectiveElement.focus();
            if (this.textboxWrapper.container.classList.contains('e-input-group')
                || this.textboxWrapper.container.classList.contains('e-outline')
                || this.textboxWrapper.container.classList.contains('e-filled')) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.textboxWrapper.container], [TEXTBOX_FOCUS]);
            }
        }
    };
    /**
     * Remove the focus from widget, if the widget is in focus state.
     *
     * @returns {void}
     */
    TextBox.prototype.focusOut = function () {
        if (document.activeElement === this.respectiveElement && this.enabled) {
            this.respectiveElement.blur();
            if (this.textboxWrapper.container.classList.contains('e-input-group')
                || this.textboxWrapper.container.classList.contains('e-outline')
                || this.textboxWrapper.container.classList.contains('e-filled')) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.textboxWrapper.container], [TEXTBOX_FOCUS]);
            }
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('text')
    ], TextBox.prototype, "type", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], TextBox.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], TextBox.prototype, "value", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Never')
    ], TextBox.prototype, "floatLabelType", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], TextBox.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], TextBox.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('on')
    ], TextBox.prototype, "autocomplete", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])({})
    ], TextBox.prototype, "htmlAttributes", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], TextBox.prototype, "multiline", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], TextBox.prototype, "enabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], TextBox.prototype, "showClearButton", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], TextBox.prototype, "enablePersistence", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], TextBox.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TextBox.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TextBox.prototype, "destroyed", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TextBox.prototype, "change", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TextBox.prototype, "blur", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TextBox.prototype, "focus", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], TextBox.prototype, "input", void 0);
    TextBox = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], TextBox);
    return TextBox;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__signature__ = __webpack_require__(281);
/* unused harmony namespace reexport */
/**
 * Signature modules
 */



/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Signature */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_signature_base__ = __webpack_require__(91);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



/**
 * The Signature component allows user to draw smooth signatures as vector outline of strokes using variable width bezier curve interpolation.
 * It allows to save signature as image.
 * You can use your finger, pen, or mouse on a tablet, touchscreen, etc., to draw your own signature on this Signature component.
 * Signature component is a user interface to draw the Signature or Text.
 * It provides supports for various Background color, Stroke color and Background Image.
 * ```html
 * <canvas id="signature"></canvas>
 * ```
 * ```typescript
 * <script>
 *   let signatureObj: Signature = new Signature(null , "#signature");
 * </script>
 * ```
 */
var Signature = /** @class */ (function (_super) {
    __extends(Signature, _super);
    /**
     * Constructor for creating the widget.
     *
     * @param {SignatureModel} options - Specifies the Signature model.
     * @param {string | HTMLCanvasElement} element - Specifies the element.
     * @private
     */
    function Signature(options, element) {
        return _super.call(this, options, element) || this;
    }
    Signature.prototype.preRender = function () {
        // pre render code snippets
    };
    /**
     * To Initialize the component rendering
     *
     * @private
     * @returns {void}
     */
    Signature.prototype.render = function () {
        this.initialize();
    };
    Signature.prototype.initialize = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], 'e-' + this.getModuleName());
        _super.prototype.initialize.call(this, this.element);
        if (this.enablePersistence) {
            this.loadPersistedSignature();
        }
    };
    /**
     * To get component name.
     *
     * @returns {string} - Module Name
     * @private
     */
    Signature.prototype.getModuleName = function () {
        return 'signature';
    };
    /**
     * To get the properties to be maintained in the persisted state.
     *
     * @returns {string} - Persist data
     */
    Signature.prototype.getPersistData = function () {
        return this.addOnPersist(['signatureValue']);
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param  {SignatureModel} newProp - Specifies new properties
     * @param  {SignatureModel} oldProp - Specifies old properties
     * @returns {void}
     * @private
     */
    Signature.prototype.onPropertyChanged = function (newProp, oldProp) {
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'backgroundColor':
                    _super.prototype.propertyChanged.call(this, prop, newProp.backgroundColor);
                    break;
                case 'backgroundImage':
                    _super.prototype.propertyChanged.call(this, prop, newProp.backgroundImage);
                    break;
                case 'strokeColor':
                    if (newProp.strokeColor !== oldProp.strokeColor) {
                        _super.prototype.propertyChanged.call(this, prop, newProp.strokeColor);
                    }
                    break;
                case 'saveWithBackground':
                    _super.prototype.propertyChanged.call(this, prop, newProp.saveWithBackground);
                    break;
                case 'isReadOnly':
                    _super.prototype.propertyChanged.call(this, prop, newProp.isReadOnly);
                    break;
                case 'disabled':
                    _super.prototype.propertyChanged.call(this, prop, newProp.disabled);
                    break;
            }
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Signature.prototype, "backgroundColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Signature.prototype, "backgroundImage", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Signature.prototype, "disabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Signature.prototype, "isReadOnly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Signature.prototype, "saveWithBackground", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('#000000')
    ], Signature.prototype, "strokeColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(0.5)
    ], Signature.prototype, "minStrokeWidth", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(2)
    ], Signature.prototype, "maxStrokeWidth", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(0.7)
    ], Signature.prototype, "velocity", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('en-US')
    ], Signature.prototype, "locale", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Signature.prototype, "enableRtl", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Signature.prototype, "enablePersistence", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Signature.prototype, "beforeSave", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Signature.prototype, "change", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Signature.prototype, "created", void 0);
    Signature = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], Signature);
    return Signature;
}(__WEBPACK_IMPORTED_MODULE_1__common_signature_base__["a" /* SignatureBase */]));



/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__signature_base__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/**
 * Signature base modules
 */



/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sidebar__ = __webpack_require__(284);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__sidebar__["a"]; });
/**
 * Sidebar modules
 */



/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Sidebar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var CONTROL = 'e-control';
var ROOT = 'e-sidebar';
var DOCKER = 'e-dock';
var CLOSE = 'e-close';
var OPEN = 'e-open';
var TRASITION = 'e-transition';
var DEFAULTBACKDROP = 'e-sidebar-overlay';
var CONTEXTBACKDROP = 'e-backdrop';
var RTL = 'e-rtl';
var RIGHT = 'e-right';
var LEFT = 'e-left';
var OVER = 'e-over';
var PUSH = 'e-push';
var SLIDE = 'e-slide';
var VISIBILITY = 'e-visibility';
var DISPLAY = 'e-sidebar-display';
var MAINCONTENTANIMATION = 'e-content-animation';
var DISABLEANIMATION = 'e-disable-animation';
var CONTEXT = 'e-sidebar-context';
var SIDEBARABSOLUTE = 'e-sidebar-absolute';
/**
 * Sidebar is an expandable or collapsible
 * component that typically act as a side container to place the primary or secondary content alongside of the main content.
 * ```html
 * <aside id="sidebar">
 * </aside>
 * ```
 * ```typescript
 * <script>
 *   let sidebarObject: Sidebar = new Sidebar();
 *   sidebarObject.appendTo("#sidebar");
 * </script>
 * ```
 */
var Sidebar = /** @class */ (function (_super) {
    __extends(Sidebar, _super);
    /* eslint-enable */
    function Sidebar(options, element) {
        return _super.call(this, options, element) || this;
    }
    Sidebar.prototype.preRender = function () {
        this.setWidth();
    };
    Sidebar.prototype.render = function () {
        this.initialize();
        this.wireEvents();
        this.renderComplete();
    };
    Sidebar.prototype.initialize = function () {
        this.setTarget();
        this.addClass();
        this.setZindex();
        if (this.enableDock) {
            this.setDock();
        }
        if (this.isOpen) {
            this.show();
            this.firstRender = true;
        }
        else {
            this.setMediaQuery();
        }
        this.checkType(true);
        this.setType(this.type);
        this.setCloseOnDocumentClick();
        this.setEnableRTL();
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
            this.windowWidth = window.innerWidth;
        }
    };
    Sidebar.prototype.setEnableRTL = function () {
        (this.enableRtl ? __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */] : __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], RTL);
    };
    Sidebar.prototype.setTarget = function () {
        this.targetEle = this.element.nextElementSibling;
        this.sidebarEleCopy = this.element.cloneNode(true);
        if (typeof (this.target) === 'string') {
            this.setProperties({ target: document.querySelector(this.target) }, true);
        }
        if (this.target) {
            this.target.insertBefore(this.element, this.target.children[0]);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], SIDEBARABSOLUTE);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.target], CONTEXT);
            this.targetEle = this.getTargetElement();
        }
    };
    Sidebar.prototype.getTargetElement = function () {
        var siblingElement = this.element.nextElementSibling;
        while (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(siblingElement)) {
            if (!siblingElement.classList.contains(ROOT)) {
                break;
            }
            siblingElement = siblingElement.nextElementSibling;
        }
        return siblingElement;
    };
    Sidebar.prototype.setCloseOnDocumentClick = function () {
        if (this.closeOnDocumentClick) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'mousedown touchstart', this.documentclickHandler, this);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'mousedown touchstart', this.documentclickHandler);
        }
    };
    Sidebar.prototype.setWidth = function () {
        if (this.enableDock && this.position === 'Left') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'width': this.setDimension(this.dockSize) });
        }
        else if (this.enableDock && this.position === 'Right') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'width': this.setDimension(this.dockSize) });
        }
        else if (!this.enableDock) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'width': this.setDimension(this.width) });
        }
    };
    Sidebar.prototype.setDimension = function (width) {
        if (typeof width === 'number') {
            width = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(width);
        }
        else if (typeof width === 'string') {
            width = (width.match(/px|%|em/)) ? width : Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(width);
        }
        else {
            width = '100%';
        }
        return width;
    };
    Sidebar.prototype.setZindex = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'z-index': '' + this.zIndex });
    };
    Sidebar.prototype.addClass = function () {
        if (this.element.tagName === "EJS-SIDEBAR") {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], DISPLAY);
        }
        var classELement = document.querySelector('.e-main-content');
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(classELement || this.targetEle)) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([classELement || this.targetEle], [MAINCONTENTANIMATION]);
        }
        this.tabIndex = this.element.hasAttribute('tabindex') ? this.element.getAttribute('tabindex') : '0';
        if (!this.enableDock && this.type !== 'Auto') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], [VISIBILITY]);
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], [OPEN, CLOSE, RIGHT, LEFT, SLIDE, PUSH, OVER]);
        this.element.classList.add(ROOT);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], (this.position === 'Right') ? RIGHT : LEFT);
        if (this.enableDock) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], DOCKER);
        }
        this.element.setAttribute('tabindex', this.tabIndex);
        if (this.type === 'Auto' && !__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
            this.show();
        }
        else if (!this.isOpen) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], CLOSE);
        }
    };
    Sidebar.prototype.checkType = function (val) {
        if (!(this.type === 'Push' || this.type === 'Over' || this.type === 'Slide')) {
            this.type = 'Auto';
        }
        else {
            if (!this.element.classList.contains(CLOSE) && !val) {
                this.hide();
            }
        }
    };
    Sidebar.prototype.transitionEnd = function (e) {
        this.setDock();
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e) && !this.firstRender) {
            this.triggerChange();
        }
        this.firstRender = false;
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'transitionend', this.transitionEnd);
    };
    Sidebar.prototype.destroyBackDrop = function () {
        var sibling = document.querySelector('.e-main-content') || this.targetEle;
        if (this.target && this.showBackdrop && sibling) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([sibling], CONTEXTBACKDROP);
        }
        else if (this.showBackdrop && this.modal) {
            this.modal.style.display = 'none';
            this.modal.outerHTML = '';
            this.modal = null;
        }
    };
    /* eslint-disable */
    /**
     * Hide the Sidebar component, if it is in an open state.
     *
     * @returns {void}
     *
     */
    Sidebar.prototype.hide = function (e) {
        var _this = this;
        var closeArguments = {
            model: this,
            element: this.element,
            cancel: false,
            isInteracted: !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e),
            event: (e || null)
        };
        this.trigger('close', closeArguments, function (observedcloseArgs) {
            if (!observedcloseArgs.cancel) {
                if (_this.element.classList.contains(CLOSE)) {
                    return;
                }
                if (_this.element.classList.contains(OPEN) && !_this.animate) {
                    _this.triggerChange();
                }
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([_this.element], CLOSE);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([_this.element], OPEN);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(_this.element, { 'width': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(_this.enableDock ? _this.dockSize : _this.width) });
                _this.setType(_this.type);
                var sibling = document.querySelector('.e-main-content') || _this.targetEle;
                if (!_this.enableDock && sibling) {
                    sibling.style.transform = 'translateX(' + 0 + 'px)';
                    sibling.style[_this.position === 'Left' ? 'marginLeft' : 'marginRight'] = '0px';
                }
                _this.destroyBackDrop();
                _this.setAnimation();
                if (_this.type === 'Slide') {
                    document.body.classList.remove('e-sidebar-overflow');
                }
                _this.setProperties({ isOpen: false }, true);
                if (_this.enableDock) {
                    setTimeout(function () { return _this.setTimeOut(); }, 50);
                }
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(_this.element, 'transitionend', _this.transitionEnd, _this);
            }
        });
    };
    Sidebar.prototype.setTimeOut = function () {
        var sibling = document.querySelector('.e-main-content') || this.targetEle;
        var elementWidth = this.element.getBoundingClientRect().width;
        if (this.element.classList.contains(OPEN) && sibling && !(this.type === 'Over' && this.enableDock)) {
            if (this.position === 'Left') {
                sibling.style.marginLeft = this.setDimension(this.width === 'auto' ? elementWidth : this.width);
            }
            else {
                sibling.style.marginRight = this.setDimension(this.width === 'auto' ? elementWidth : this.width);
            }
        }
        else if (this.element.classList.contains(CLOSE) && sibling) {
            if (this.position === 'Left') {
                sibling.style.marginLeft = this.setDimension(this.dockSize === 'auto' ? elementWidth : this.dockSize);
            }
            else {
                sibling.style.marginRight = this.setDimension(this.dockSize === 'auto' ? elementWidth : this.dockSize);
            }
        }
    };
    /* eslint-disable */
    /**
     * Shows the Sidebar component, if it is in closed state.
     *
     * @returns {void}
     */
    Sidebar.prototype.show = function (e) {
        var _this = this;
        var openArguments = {
            model: this,
            element: this.element,
            cancel: false,
            isInteracted: !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(e),
            event: (e || null)
        };
        this.trigger('open', openArguments, function (observedopenArgs) {
            if (!observedopenArgs.cancel) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([_this.element], VISIBILITY);
                if (_this.element.classList.contains(OPEN)) {
                    return;
                }
                if (_this.element.classList.contains(CLOSE) && !_this.animate) {
                    _this.triggerChange();
                }
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([_this.element], [OPEN, TRASITION]);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(_this.element, { 'transform': '' });
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([_this.element], CLOSE);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(_this.element, { 'width': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(_this.width) });
                _this.setType(_this.type);
                _this.createBackDrop();
                _this.setAnimation();
                if (_this.type === 'Slide') {
                    document.body.classList.add('e-sidebar-overflow');
                }
                _this.setProperties({ isOpen: true }, true);
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(_this.element, 'transitionend', _this.transitionEnd, _this);
            }
        });
    };
    Sidebar.prototype.setAnimation = function () {
        if (this.animate) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], DISABLEANIMATION);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], DISABLEANIMATION);
        }
    };
    Sidebar.prototype.triggerChange = function () {
        var changeArguments = { name: 'change', element: this.element };
        this.trigger('change', changeArguments);
    };
    Sidebar.prototype.setDock = function () {
        if (this.enableDock && this.position === 'Left' && !this.getState()) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'transform': 'translateX(' + -100 + '%) translateX(' + this.setDimension(this.dockSize) + ')' });
        }
        else if (this.enableDock && this.position === 'Right' && !this.getState()) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'transform': 'translateX(' + 100 + '%) translateX(' + '-' + this.setDimension(this.dockSize) + ')' });
        }
        if (this.element.classList.contains(CLOSE) && this.enableDock) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'width': this.setDimension(this.dockSize) });
        }
    };
    Sidebar.prototype.createBackDrop = function () {
        if (this.target && this.showBackdrop && this.getState()) {
            var sibling = document.querySelector('.e-main-content') || this.targetEle;
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([sibling], CONTEXTBACKDROP);
        }
        else if (this.showBackdrop && !this.modal && this.getState()) {
            this.modal = this.createElement('div');
            this.modal.className = DEFAULTBACKDROP;
            this.modal.style.display = 'block';
            document.body.appendChild(this.modal);
        }
    };
    Sidebar.prototype.getPersistData = function () {
        return this.addOnPersist(['type', 'position', 'isOpen']);
    };
    /**
     * Returns the current module name.
     *
     * @returns {string} - returns module name.
     * @private
     *
     */
    Sidebar.prototype.getModuleName = function () {
        return 'sidebar';
    };
    /**
     * Shows or hides the Sidebar based on the current state.
     *
     * @returns {void}
     */
    Sidebar.prototype.toggle = function () {
        if (this.element.classList.contains(OPEN)) {
            this.hide();
        }
        else {
            this.show();
        }
    };
    Sidebar.prototype.getState = function () {
        return this.element.classList.contains(OPEN) ? true : false;
    };
    Sidebar.prototype.setMediaQuery = function () {
        if (this.mediaQuery) {
            var media = false;
            if (typeof (this.mediaQuery) === 'string') {
                media = window.matchMedia(this.mediaQuery).matches;
            }
            else {
                media = (this.mediaQuery).matches;
            }
            if (media && this.windowWidth !== window.innerWidth) {
                this.show();
            }
            else if (this.getState() && this.windowWidth !== window.innerWidth) {
                this.hide();
            }
        }
    };
    Sidebar.prototype.resize = function () {
        if (this.type === 'Auto') {
            if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], OVER);
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], PUSH);
            }
        }
        this.setMediaQuery();
        if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
            this.windowWidth = window.innerWidth;
        }
    };
    Sidebar.prototype.documentclickHandler = function (e) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, '.' + CONTROL + '' + '.' + ROOT)) {
            return;
        }
        this.hide(e);
    };
    Sidebar.prototype.enableGestureHandler = function (args) {
        if (!this.isOpen && this.position === 'Left' && args.swipeDirection === 'Right' &&
            (args.startX <= 20 && args.distanceX >= 50 && args.velocity >= 0.5)) {
            this.show();
        }
        else if (this.isOpen && this.position === 'Left' && args.swipeDirection === 'Left') {
            this.hide();
        }
        else if (this.isOpen && this.position === 'Right' && args.swipeDirection === 'Right') {
            this.hide();
        }
        else if (!this.isOpen && this.position === 'Right' && args.swipeDirection === 'Left'
            && (window.innerWidth - args.startX <= 20 && args.distanceX >= 50 && args.velocity >= 0.5)) {
            this.show();
        }
    };
    Sidebar.prototype.setEnableGestures = function () {
        if (this.enableGestures) {
            this.mainContentEle = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["t" /* Touch */](document.body, { swipe: this.enableGestureHandler.bind(this) });
            this.sidebarEle = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["t" /* Touch */](this.element, { swipe: this.enableGestureHandler.bind(this) });
        }
        else {
            if (this.mainContentEle && this.sidebarEle) {
                this.mainContentEle.destroy();
                this.sidebarEle.destroy();
            }
        }
    };
    Sidebar.prototype.wireEvents = function () {
        this.setEnableGestures();
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(window, 'resize', this.resize, this);
    };
    Sidebar.prototype.unWireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(window, 'resize', this.resize);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'mousedown touchstart', this.documentclickHandler);
        if (this.mainContentEle) {
            this.mainContentEle.destroy();
        }
        if (this.sidebarEle) {
            this.sidebarEle.destroy();
        }
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param {SidebarModel} newProp - specifies newProp value.
     * @param {SidebarModel} oldProp - specifies oldProp value.
     * @returns {void}
     * @private
     *
     */
    Sidebar.prototype.onPropertyChanged = function (newProp, oldProp) {
        var sibling = document.querySelector('.e-main-content') || this.targetEle;
        var isRendered = this.isServerRendered;
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'isOpen':
                    if (this.isOpen) {
                        this.show();
                    }
                    else {
                        this.hide();
                    }
                    break;
                case 'width':
                    this.setWidth();
                    if (!this.getState()) {
                        this.setDock();
                    }
                    break;
                case 'animate':
                    this.setAnimation();
                    break;
                case 'type':
                    this.checkType(false);
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], [VISIBILITY]);
                    this.addClass();
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], this.type === 'Auto' ? (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice ? ['e-over'] :
                        ['e-push']) : ['e-' + this.type.toLowerCase()]);
                    break;
                case 'position':
                    this.element.style.transform = '';
                    this.setDock();
                    if (sibling) {
                        sibling.style[this.position === 'Left' ? 'marginRight' : 'marginLeft'] = '0px';
                    }
                    if (this.position === 'Right') {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], LEFT);
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], RIGHT);
                    }
                    else {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], RIGHT);
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], LEFT);
                    }
                    this.setType(this.type);
                    break;
                case 'showBackdrop':
                    if (this.showBackdrop) {
                        this.createBackDrop();
                    }
                    else {
                        if (this.modal) {
                            this.modal.style.display = 'none';
                            this.modal.outerHTML = '';
                            this.modal = null;
                        }
                    }
                    break;
                case 'target':
                    if (typeof (this.target) === 'string') {
                        this.setProperties({ target: document.querySelector(this.target) }, true);
                    }
                    if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.target)) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], SIDEBARABSOLUTE);
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([oldProp.target], CONTEXT);
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(sibling, { 'margin-left': 0, 'margin-right': 0 });
                        document.body.insertAdjacentElement('afterbegin', this.element);
                    }
                    this.isServerRendered = false;
                    _super.prototype.refresh.call(this);
                    this.isServerRendered = isRendered;
                    break;
                case 'closeOnDocumentClick':
                    this.setCloseOnDocumentClick();
                    break;
                case 'enableDock':
                    if (!this.getState()) {
                        this.setDock();
                    }
                    break;
                case 'zIndex':
                    this.setZindex();
                    break;
                case 'mediaQuery':
                    this.setMediaQuery();
                    break;
                case 'enableGestures':
                    this.setEnableGestures();
                    break;
                case 'enableRtl':
                    this.setEnableRTL();
                    break;
            }
        }
    };
    Sidebar.prototype.setType = function (type) {
        var elementWidth = this.element.getBoundingClientRect().width;
        this.setZindex();
        var sibling = document.querySelector('.e-main-content') || this.targetEle;
        if (sibling) {
            sibling.style.transform = 'translateX(' + 0 + 'px)';
            if (!__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice && this.type !== 'Auto' && !(this.type === 'Over' && this.enableDock)) {
                sibling.style[this.position === 'Left' ? 'marginLeft' : 'marginRight'] = '0px';
            }
        }
        var margin = this.position === 'Left' ? elementWidth + 'px' : elementWidth + 'px';
        var eleWidth = this.position === 'Left' ? elementWidth : -(elementWidth);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], [PUSH, OVER, SLIDE]);
        switch (type) {
            case 'Push':
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], [PUSH]);
                if (sibling && (this.enableDock || this.element.classList.contains(OPEN))) {
                    sibling.style[this.position === 'Left' ? 'marginLeft' : 'marginRight'] = margin;
                }
                break;
            case 'Slide':
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], [SLIDE]);
                if (sibling && (this.enableDock || this.element.classList.contains(OPEN))) {
                    sibling.style.transform = 'translateX(' + eleWidth + 'px)';
                }
                break;
            case 'Over':
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], [OVER]);
                if (this.enableDock && (this.element.classList.contains(CLOSE) || this.isOpen)) {
                    if (sibling) {
                        sibling.style[this.position === 'Left' ? 'marginLeft' : 'marginRight'] = this.setDimension(this.dockSize);
                    }
                }
                break;
            case 'Auto':
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], [TRASITION]);
                if (__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["d" /* Browser */].isDevice) {
                    if (sibling && (this.enableDock) && !this.getState()) {
                        sibling.style[this.position === 'Left' ? 'marginLeft' : 'marginRight'] = margin;
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], PUSH);
                    }
                    else {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], OVER);
                    }
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], PUSH);
                    if (sibling && (this.enableDock || this.element.classList.contains(OPEN))) {
                        sibling.style[this.position === 'Left' ? 'marginLeft' : 'marginRight'] = margin;
                    }
                }
                this.createBackDrop();
        }
    };
    /**
     * Removes the control from the DOM and detaches all its related event handlers. Also it removes the attributes and classes.
     *
     * @returns {void}
     *
     */
    Sidebar.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        if (this.target) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.target], CONTEXT);
        }
        this.destroyBackDrop();
        if (this.element) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], [OPEN, CLOSE, PUSH, SLIDE, OVER, LEFT, RIGHT, TRASITION]);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], SIDEBARABSOLUTE);
            this.element.style.width = '';
            this.element.style.zIndex = '';
            this.element.style.transform = '';
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.sidebarEleCopy.getAttribute('tabindex'))) {
                this.element.setAttribute('tabindex', this.tabIndex);
            }
            else {
                this.element.removeAttribute('tabindex');
            }
        }
        this.windowWidth = null;
        var sibling = document.querySelector('.e-main-content') || this.targetEle;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(sibling)) {
            sibling.style.margin = '';
            sibling.style.transform = '';
        }
        this.unWireEvents();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('auto')
    ], Sidebar.prototype, "dockSize", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], Sidebar.prototype, "mediaQuery", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Sidebar.prototype, "enableDock", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('en-US')
    ], Sidebar.prototype, "locale", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Sidebar.prototype, "enablePersistence", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Sidebar.prototype, "enableGestures", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Sidebar.prototype, "isOpen", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Sidebar.prototype, "enableRtl", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Sidebar.prototype, "animate", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('auto')
    ], Sidebar.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Sidebar.prototype, "closeOnDocumentClick", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Left')
    ], Sidebar.prototype, "position", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], Sidebar.prototype, "target", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Sidebar.prototype, "showBackdrop", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Auto')
    ], Sidebar.prototype, "type", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('auto')
    ], Sidebar.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(1000)
    ], Sidebar.prototype, "zIndex", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Sidebar.prototype, "created", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Sidebar.prototype, "close", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Sidebar.prototype, "open", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Sidebar.prototype, "change", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Sidebar.prototype, "destroyed", void 0);
    Sidebar = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], Sidebar);
    return Sidebar;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__breadcrumb__ = __webpack_require__(286);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__breadcrumb__["a"]; });
/**
 * Breadcrumb modules
 */



/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BreadcrumbItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breadcrumb; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_lists__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var ICONRIGHT = 'e-icon-right';
var ITEMTEXTCLASS = 'e-breadcrumb-text';
var ICONCLASS = 'e-breadcrumb-icon';
var MENUCLASS = 'e-breadcrumb-menu';
var ITEMCLASS = 'e-breadcrumb-item';
var POPUPCLASS = 'e-breadcrumb-popup';
var WRAPMODECLASS = 'e-breadcrumb-wrap-mode';
var SCROLLMODECLASS = 'e-breadcrumb-scroll-mode';
var TABINDEX = 'tabindex';
var DISABLEDCLASS = 'e-disabled';
var ARIADISABLED = 'aria-disabled';
var DOT = '.';
var BreadcrumbItem = /** @class */ (function (_super) {
    __extends(BreadcrumbItem, _super);
    function BreadcrumbItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], BreadcrumbItem.prototype, "text", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], BreadcrumbItem.prototype, "url", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], BreadcrumbItem.prototype, "iconCss", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], BreadcrumbItem.prototype, "disabled", void 0);
    return BreadcrumbItem;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/**
 * Breadcrumb is a graphical user interface that helps to identify or highlight the current location within a hierarchical structure of websites.
 * The aim is to make the user aware of their current position in a hierarchy of website links.
 * ```html
 * <nav id='breadcrumb'></nav>
 * ```
 * ```typescript
 * <script>
 * var breadcrumbObj = new Breadcrumb({ items: [{ text: 'Home', url: '/' }, { text: 'Index', url: './index.html }]});
 * breadcrumbObj.appendTo("#breadcrumb");
 * </script>
 * ```
 */
var Breadcrumb = /** @class */ (function (_super) {
    __extends(Breadcrumb, _super);
    /**
     * Constructor for creating the widget.
     *
     * @private
     * @param {BreadcrumbModel} options - Specifies the Breadcrumb model.
     * @param {string | HTMLElement} element - Specifies the element.
     */
    function Breadcrumb(options, element) {
        return _super.call(this, options, element) || this;
    }
    /**
     * @private
     * @returns {void}
     */
    Breadcrumb.prototype.preRender = function () {
        // pre render code
    };
    /**
     * Initialize the control rendering.
     *
     * @private
     * @returns {void}
     */
    Breadcrumb.prototype.render = function () {
        this.initialize();
        this.renderItems(this.items);
        this.wireEvents();
    };
    Breadcrumb.prototype.initialize = function () {
        this._maxItems = this.maxItems;
        this.element.setAttribute('aria-label', 'breadcrumb');
        if (this.cssClass) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], this.cssClass.split(' '));
        }
        if (this.enableRtl) {
            this.element.classList.add('e-rtl');
        }
        if (this.disabled) {
            this.element.classList.add(DISABLEDCLASS);
            this.element.setAttribute(ARIADISABLED, 'true');
        }
        if (this.overflowMode === 'Wrap') {
            this.element.classList.add(WRAPMODECLASS);
        }
        else if (this.overflowMode === 'Scroll') {
            this.element.classList.add(SCROLLMODECLASS);
        }
        this.initItems();
        this.initPvtProps();
    };
    Breadcrumb.prototype.initPvtProps = function () {
        if (this.overflowMode === 'Hidden' && this._maxItems > 0) {
            this.endIndex = this.getEndIndex();
            this.startIndex = this.endIndex + 1 - (this._maxItems - 1);
        }
        if (this.overflowMode === 'Menu') {
            if (this._maxItems >= 0) {
                this.startIndex = this._maxItems > 1 ? 1 : 0;
                this.endIndex = this.getEndIndex();
                this.popupUl = this.createElement('ul', { attrs: { TABINDEX: '0', 'role': 'menu' } });
            }
            else {
                this.startIndex = this.endIndex = null;
            }
        }
    };
    Breadcrumb.prototype.getEndIndex = function () {
        var _this = this;
        var endIndex;
        if (this.activeItem) {
            this.items.forEach(function (item, idx) {
                if (item.url === _this.activeItem || item.text === _this.activeItem) {
                    endIndex = idx;
                }
            });
        }
        else {
            endIndex = this.items.length - 1;
        }
        return endIndex;
    };
    Breadcrumb.prototype.initItems = function () {
        if (!this.items.length) {
            var baseUri = void 0;
            var uri = void 0;
            var items = [];
            if (this.url) {
                var url = new URL(this.url, window.location.origin);
                baseUri = url.origin + '/';
                uri = url.href.split(baseUri)[1].split('/');
            }
            else {
                baseUri = window.location.origin + '/';
                uri = window.location.href.split(baseUri)[1].split('/');
            }
            items.push({ iconCss: 'e-icons e-home', url: baseUri });
            for (var i = 0; i < uri.length; i++) {
                if (uri[i]) {
                    items.push({ text: uri[i], url: baseUri + uri[i] });
                    baseUri += uri[i] + '/';
                }
            }
            this.setProperties({ items: items }, true);
        }
    };
    Breadcrumb.prototype.renderItems = function (items) {
        var _this = this;
        var item;
        var isSingleLevel;
        var isIconRight = this.element.classList.contains(ICONRIGHT);
        var itemsLength = items.length;
        if (itemsLength) {
            var isActiveItem = void 0;
            var isLastItem = void 0;
            var isLastItemInPopup_1;
            var j_1 = 0;
            var wrapDiv = void 0;
            var len = (itemsLength * 2) - 1;
            var isItemCancelled_1 = false;
            var ol = this.createElement('ol', { className: this.overflowMode === 'Wrap' ? 'e-breadcrumb-wrapped-ol' : '' });
            var firstOl = this.createElement('ol', { className: this.overflowMode === 'Wrap' ? 'e-breadcrumb-first-ol' : '' });
            var showIcon = this.hasField(items, 'iconCss');
            var isCollasped = (this.overflowMode === 'Collapsed' && this._maxItems > 0 && itemsLength > this._maxItems && !this.isExpanded);
            var isDefaultOverflowMode_1 = (this.overflowMode === 'Hidden' && this._maxItems > 0);
            if (this.overflowMode === 'Menu' && this.popupUl) {
                this.popupUl.innerHTML = '';
            }
            var listBaseOptions = {
                moduleName: this.getModuleName(),
                showIcon: showIcon,
                itemNavigable: true,
                itemCreated: function (args) {
                    var isLastItem = args.curData.isLastItem;
                    if (isLastItem && args.item.children.length && !_this.itemTemplate) {
                        delete args.curData.isLastItem;
                        if (!isLastItemInPopup_1 && !_this.enableActiveItemNavigation) {
                            args.item.innerHTML = _this.createElement('span', { className: ITEMTEXTCLASS, innerHTML: args.item.children[0].innerHTML }).outerHTML;
                        }
                    }
                    if (args.curData.iconCss && !args.curData.text && !_this.itemTemplate) {
                        args.item.classList.add('e-icon-item');
                    }
                    if (isDefaultOverflowMode_1) {
                        args.item.setAttribute('item-index', j_1.toString());
                    }
                    var eventArgs = {
                        item: Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, args.curData.properties ?
                            args.curData.properties : args.curData), element: args.item, cancel: false
                    };
                    _this.trigger('beforeItemRender', eventArgs);
                    isItemCancelled_1 = eventArgs.cancel;
                    var containsRightIcon = (isIconRight || eventArgs.element.classList.contains(ICONRIGHT));
                    if (containsRightIcon && args.curData.iconCss && !_this.itemTemplate) {
                        args.item.querySelector('.e-anchor-wrap').appendChild(args.item.querySelector(DOT + ICONCLASS));
                    }
                    if (eventArgs.item.disabled) {
                        args.item.setAttribute(ARIADISABLED, 'true');
                        args.item.classList.add(DISABLEDCLASS);
                    }
                    if ((eventArgs.item.disabled || _this.disabled) && args.item.children.length && !_this.itemTemplate) {
                        args.item.children[0].setAttribute(TABINDEX, '-1');
                    }
                    if (args.curData.isEmptyUrl) {
                        args.item.children[0].removeAttribute('href');
                        if ((!isLastItem || (isLastItem && _this.enableActiveItemNavigation)) && !(eventArgs.item.disabled || _this.disabled)) {
                            args.item.children[0].setAttribute(TABINDEX, '0');
                            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(args.item.children[0], 'keydown', _this.keyDownHandler, _this);
                        }
                    }
                    if (isLastItem) {
                        args.item.setAttribute('data-active-item', '');
                    }
                    if (!_this.itemTemplate) {
                        _this.beforeItemRenderChanges(args.curData, eventArgs.item, args.item, containsRightIcon);
                    }
                }
            };
            for (var i = 0; i < len; (i % 2 && j_1++), i++) {
                isActiveItem = (this.activeItem && (this.activeItem === items[j_1].url || this.activeItem === items[j_1].text));
                if (isCollasped && i > 1 && i < len - 2) {
                    continue;
                }
                else if (isDefaultOverflowMode_1 && ((j_1 < this.startIndex || j_1 > this.endIndex)
                    && (i % 2 ? j_1 !== this.startIndex - 1 : true)) && j_1 !== 0) {
                    continue;
                }
                if (i % 2) {
                    // separator item
                    wrapDiv = this.createElement('div', { className: 'e-breadcrumb-item-wrapper' });
                    listBaseOptions.template = this.separatorTemplate ? this.separatorTemplate : '/';
                    listBaseOptions.itemClass = 'e-breadcrumb-separator';
                    isSingleLevel = false;
                    item = [{ previousItem: items[j_1], nextItem: items[j_1 + 1] }];
                }
                else {
                    // list item
                    listBaseOptions.itemClass = '';
                    if (this.itemTemplate) {
                        listBaseOptions.template = this.itemTemplate;
                        isSingleLevel = false;
                    }
                    else {
                        isSingleLevel = true;
                    }
                    item = [Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, items[j_1].properties ? items[j_1].properties
                            : items[j_1])];
                    if (!item[0].url && !this.itemTemplate) {
                        item = [Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["F" /* extend */])({}, item[0], { isEmptyUrl: true, url: '#' })];
                    }
                    isLastItem = (isDefaultOverflowMode_1 || this.overflowMode === 'Menu') && (j_1 === this.endIndex);
                    if (((i === len - 1 || isLastItem) && !this.itemTemplate) || isActiveItem) {
                        item[0].isLastItem = true;
                    }
                }
                var parent_1 = ol;
                var lastPopupItemIdx = this.startIndex + this.endIndex - this._maxItems;
                if (this.overflowMode === 'Menu' && ((j_1 >= this.startIndex && (j_1 <= lastPopupItemIdx && (i % 2 ? !(j_1 === lastPopupItemIdx) : true)) && this.endIndex >= this._maxItems && this._maxItems > 0) || this._maxItems === 0)) {
                    if (i % 2) {
                        continue;
                    }
                    else {
                        parent_1 = this.popupUl;
                        if (isLastItem) {
                            isLastItemInPopup_1 = true;
                        }
                    }
                }
                else if (this.overflowMode === 'Wrap') {
                    if (i === 0) {
                        parent_1 = firstOl;
                    }
                    else {
                        parent_1 = wrapDiv;
                    }
                }
                var li = __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_lists__["a" /* ListBase */].createList(this.createElement, item, listBaseOptions, isSingleLevel, this).childNodes;
                if (!isItemCancelled_1) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(li, parent_1);
                }
                else if (isDefaultOverflowMode_1 || isCollasped || this.overflowMode === 'Menu' || this.overflowMode === 'Wrap') {
                    items.splice(j_1, 1);
                    this.initPvtProps();
                    return this.reRenderItems();
                }
                else if ((i === len - 1 || isLastItem)) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(parent_1.lastElementChild);
                }
                if (this.overflowMode === 'Wrap' && i !== 0 && i % 2 === 0) {
                    ol.appendChild(wrapDiv);
                }
                if (isCollasped && i === 1) {
                    var li_1 = this.createElement('li', { className: 'e-icons e-breadcrumb-collapsed', attrs: { TABINDEX: '0' } });
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(li_1, 'keyup', this.expandHandler, this);
                    ol.appendChild(li_1);
                }
                if (this.overflowMode === 'Menu' && this.startIndex === i && this.endIndex >= this._maxItems && this._maxItems >= 0) {
                    var menu = this.getMenuElement();
                    __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(menu, 'keyup', this.keyDownHandler, this);
                    ol.appendChild(menu);
                }
                if (isActiveItem || isLastItem) {
                    break;
                }
                if (isItemCancelled_1) {
                    i++;
                }
            }
            if (this.isReact) {
                this.renderReactTemplates();
            }
            if (this.overflowMode === 'Wrap') {
                this.element.appendChild(firstOl);
            }
            this.element.appendChild(ol);
            this.calculateMaxItems();
        }
    };
    Breadcrumb.prototype.calculateMaxItems = function () {
        if (this.overflowMode === 'Hidden' || this.overflowMode === 'Collapsed' || this.overflowMode === 'Menu') {
            var maxItems = void 0;
            var width = this.element.offsetWidth;
            var liElems = [].slice.call(this.element.children[0].children).reverse();
            var liWidth = this.overflowMode === 'Menu' ? 0 : liElems[liElems.length - 1].offsetWidth + (liElems[liElems.length - 2] ? liElems[liElems.length - 2].offsetWidth : 0);
            if (this.overflowMode === 'Menu') {
                var menuEle = this.getMenuElement();
                this.element.appendChild(menuEle);
                liWidth += menuEle.offsetWidth;
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(menuEle);
            }
            for (var i = 0; i < liElems.length - 2; i++) {
                if (liWidth > width) {
                    maxItems = Math.ceil((i - 1) / 2) + ((this.overflowMode === 'Menu' && i <= 2) ? 0 : 1);
                    if (((this.maxItems > maxItems && !(this.maxItems > -1 && maxItems == -1)) || this.maxItems == -1) && this._maxItems != maxItems) {
                        this._maxItems = maxItems;
                        this.initPvtProps();
                        return this.reRenderItems();
                    }
                    else {
                        break;
                    }
                }
                else {
                    if (this.overflowMode === 'Menu' && i === 2) {
                        liWidth += liElems[liElems.length - 1].offsetWidth + liElems[liElems.length - 2].offsetWidth;
                        if (liWidth > width) {
                            this._maxItems = 1;
                            this.initPvtProps();
                            return this.reRenderItems();
                        }
                    }
                    if (!(this.overflowMode === 'Menu' && liElems[i].classList.contains(MENUCLASS))) {
                        liWidth += liElems[i].offsetWidth;
                        if (liWidth > width) {
                            maxItems = Math.ceil((i) / 2) + (this.overflowMode === 'Menu' && i <= 2 ? 0 : 1);
                            this._maxItems = maxItems;
                            this.initPvtProps();
                            return this.reRenderItems();
                        }
                    }
                }
            }
        }
        else if ((this.overflowMode === 'Wrap' || this.overflowMode === 'Scroll') && this._maxItems > 0) {
            var width = 0;
            var liElems = this.element.querySelectorAll(DOT + ITEMCLASS);
            if (liElems.length > this._maxItems + this._maxItems - 1) {
                for (var i = this.overflowMode === 'Wrap' ? 1 : 0; i < this._maxItems + this._maxItems - 1; i++) {
                    width += liElems[i].offsetWidth;
                }
                width = width + 5 + (parseInt(getComputedStyle(this.element.children[0]).paddingLeft, 10) * 2);
                if (this.overflowMode === 'Wrap') {
                    this.element.querySelector('.e-breadcrumb-wrapped-ol').style.width = width + 'px';
                }
                else {
                    this.element.style.width = width + 'px';
                }
            }
        }
    };
    Breadcrumb.prototype.hasField = function (items, field) {
        for (var i = 0, len = items.length; i < len; i++) {
            if (items[i][field]) {
                return true;
            }
        }
        return false;
    };
    Breadcrumb.prototype.getMenuElement = function () {
        return this.createElement('li', { className: 'e-icons e-breadcrumb-menu', attrs: { TABINDEX: '0' } });
    };
    Breadcrumb.prototype.beforeItemRenderChanges = function (prevItem, currItem, elem, isRightIcon) {
        var wrapElem = elem.querySelector('.e-anchor-wrap');
        if (currItem.text !== prevItem.text) {
            wrapElem.childNodes.forEach(function (child) {
                if (child.nodeType === Node.TEXT_NODE) {
                    child.textContent = currItem.text;
                }
            });
        }
        if (currItem.iconCss !== prevItem.iconCss && wrapElem) { // wrapElem - for checking it is item not a separator
            var iconElem = elem.querySelector(DOT + ICONCLASS);
            if (iconElem) {
                if (currItem.iconCss) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([iconElem], prevItem.iconCss.split(' '));
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([iconElem], currItem.iconCss.split(' '));
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(iconElem);
                }
            }
            else if (currItem.iconCss) {
                var iconElem_1 = this.createElement('span', { className: ICONCLASS + ' ' + currItem.iconCss });
                if (isRightIcon) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])([iconElem_1], wrapElem);
                }
                else {
                    wrapElem.insertBefore(iconElem_1, wrapElem.childNodes[0]);
                }
            }
        }
        if (currItem.url !== prevItem.url && this.enableNavigation) {
            var anchor = elem.querySelector('a.' + ITEMTEXTCLASS);
            if (anchor) {
                if (currItem.url) {
                    anchor.setAttribute('href', currItem.url);
                }
                else {
                    anchor.removeAttribute('href');
                }
            }
        }
    };
    Breadcrumb.prototype.reRenderItems = function () {
        this.element.innerHTML = '';
        this.renderItems(this.items);
    };
    Breadcrumb.prototype.clickHandler = function (e) {
        var li = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, DOT + ITEMCLASS + ':not(.e-breadcrumb-separator)');
        if (!this.enableNavigation) {
            e.preventDefault();
        }
        if (li && (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, DOT + ITEMTEXTCLASS) || this.itemTemplate)) {
            var idx = void 0;
            if (this.overflowMode === 'Wrap') {
                idx = [].slice.call(this.element.querySelectorAll(DOT + ITEMCLASS)).indexOf(li);
            }
            else {
                idx = [].slice.call(li.parentElement.children).indexOf(li);
            }
            if (this.overflowMode === 'Menu') {
                if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, DOT + POPUPCLASS)) {
                    idx += this.startIndex;
                    this.endIndex = idx;
                    if (e.type === 'keydown') {
                        this.documentClickHandler(e);
                    }
                }
                else if (this.element.querySelector(DOT + MENUCLASS)) {
                    if (idx > [].slice.call(this.element.children[0].children).indexOf(this.element.querySelector(DOT + MENUCLASS))) {
                        idx += (this.popupUl.childElementCount * 2) - 2;
                        idx = Math.floor(idx / 2);
                        this.endIndex = idx;
                    }
                    else {
                        this.startIndex = this.endIndex = idx;
                    }
                }
                else {
                    idx = Math.floor(idx / 2);
                    this.startIndex = this.endIndex = idx;
                }
            }
            else {
                idx = Math.floor(idx / 2);
            }
            if (this.overflowMode === 'Hidden' && this._maxItems > 0 && this.endIndex !== 0) {
                idx = parseInt(li.getAttribute('item-index'), 10);
                if (this.startIndex > 1) {
                    this.startIndex -= (this.endIndex - idx);
                }
                this.endIndex = idx;
            }
            this.trigger('itemClick', { element: li, item: this.items[idx], event: e });
            this.activeItem = this.items[idx].url || this.items[idx].text;
            this.dataBind();
        }
        if (e.target.classList.contains('e-breadcrumb-collapsed')) {
            this.isExpanded = true;
            this.reRenderItems();
        }
        if (e.target.classList.contains(MENUCLASS)) {
            this.renderPopup();
        }
    };
    Breadcrumb.prototype.renderPopup = function () {
        var _this = this;
        var wrapper = this.createElement('div', { className: POPUPCLASS + ' ' + this.cssClass + (this.enableRtl ? ' e-rtl' : '') });
        document.body.appendChild(wrapper);
        this.popupObj = new __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_popups__["a" /* Popup */](wrapper, {
            content: this.popupUl,
            relateTo: this.element.querySelector(DOT + MENUCLASS),
            enableRtl: this.enableRtl,
            position: { X: 'left', Y: 'bottom' },
            collision: { X: 'fit', Y: 'flip' },
            open: function () {
                _this.popupUl.focus();
            }
        });
        this.popupWireEvents();
        this.popupObj.show();
    };
    Breadcrumb.prototype.documentClickHandler = function (e) {
        if (this.overflowMode === 'Menu' && this.popupObj && this.popupObj.element.classList.contains('e-popup-open') && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, DOT + MENUCLASS)) {
            this.popupObj.hide();
            this.popupObj.destroy();
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["D" /* detach */])(this.popupObj.element);
        }
    };
    Breadcrumb.prototype.resize = function () {
        this._maxItems = this.maxItems;
        this.initPvtProps();
        this.reRenderItems();
    };
    Breadcrumb.prototype.expandHandler = function (e) {
        if (e.key === 'Enter') {
            this.isExpanded = true;
            this.reRenderItems();
        }
    };
    Breadcrumb.prototype.keyDownHandler = function (e) {
        if (e.key === 'Enter') {
            this.clickHandler(e);
        }
    };
    Breadcrumb.prototype.popupKeyDownHandler = function (e) {
        if (e.key === 'Escape') {
            this.documentClickHandler(e);
        }
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @private
     * @param {BreadcrumbModel} newProp - Specifies the new properties.
     * @param {BreadcrumbModel} oldProp - Specifies the old properties.
     * @returns {void}
     */
    Breadcrumb.prototype.onPropertyChanged = function (newProp, oldProp) {
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'items':
                case 'enableActiveItemNavigation':
                    this.reRenderItems();
                    break;
                case 'activeItem':
                    this._maxItems = this.maxItems;
                    this.initPvtProps();
                    this.reRenderItems();
                    break;
                case 'overflowMode':
                case 'maxItems':
                    this._maxItems = this.maxItems;
                    this.initPvtProps();
                    this.reRenderItems();
                    if (oldProp.overflowMode === 'Wrap') {
                        this.element.classList.remove(WRAPMODECLASS);
                    }
                    else if (newProp.overflowMode === 'Wrap') {
                        this.element.classList.add(WRAPMODECLASS);
                    }
                    if (oldProp.overflowMode === 'Scroll') {
                        this.element.classList.remove(SCROLLMODECLASS);
                    }
                    else if (newProp.overflowMode === 'Scroll') {
                        this.element.classList.add(SCROLLMODECLASS);
                    }
                    break;
                case 'url':
                    this.initItems();
                    this.reRenderItems();
                    break;
                case 'cssClass':
                    if (oldProp.cssClass) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], oldProp.cssClass.split(' '));
                    }
                    if (newProp.cssClass) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], newProp.cssClass.split(' '));
                    }
                    if ((oldProp.cssClass && oldProp.cssClass.indexOf(ICONRIGHT) > -1) && !(newProp.cssClass &&
                        newProp.cssClass.indexOf(ICONRIGHT) > -1) || !(oldProp.cssClass && oldProp.cssClass.indexOf(ICONRIGHT) > -1) &&
                        (newProp.cssClass && newProp.cssClass.indexOf(ICONRIGHT) > -1)) {
                        this.reRenderItems();
                    }
                    break;
                case 'enableRtl':
                    this.element.classList.toggle('e-rtl');
                    break;
                case 'disabled':
                    this.element.classList.toggle(DISABLEDCLASS);
                    this.element.setAttribute(ARIADISABLED, newProp.disabled + '');
                    break;
            }
        }
    };
    Breadcrumb.prototype.wireEvents = function () {
        this.delegateClickHanlder = this.documentClickHandler.bind(this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(document, 'click', this.delegateClickHanlder, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'click', this.clickHandler, this);
        window.addEventListener('resize', this.resize.bind(this));
    };
    Breadcrumb.prototype.popupWireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.popupObj.element, 'click', this.clickHandler, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.popupObj.element, 'keydown', this.popupKeyDownHandler, this);
    };
    Breadcrumb.prototype.unWireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(document, 'click', this.delegateClickHanlder);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element, 'click', this.clickHandler);
        window.removeEventListener('resize', this.resize.bind(this));
        if (this.popupObj) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.popupObj.element, 'click', this.clickHandler);
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.popupObj.element, 'keydown', this.popupKeyDownHandler);
        }
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} - Persist data
     */
    Breadcrumb.prototype.getPersistData = function () {
        return this.addOnPersist(['activeItem']);
    };
    /**
     * Get module name.
     *
     * @private
     * @returns {string} - Module Name
     */
    Breadcrumb.prototype.getModuleName = function () {
        return 'breadcrumb';
    };
    /**
     * Destroys the widget.
     *
     * @returns {void}
     */
    Breadcrumb.prototype.destroy = function () {
        var _this = this;
        var classes = [];
        var attributes = ['aria-label'];
        if (this.cssClass) {
            classes.concat(this.cssClass.split(' '));
        }
        if (this.enableRtl) {
            classes.push('e-rtl');
        }
        if (this.disabled) {
            classes.push(DISABLEDCLASS);
            attributes.push(ARIADISABLED);
        }
        if (this.overflowMode === 'Wrap') {
            classes.push(WRAPMODECLASS);
        }
        else if (this.overflowMode === 'Scroll') {
            classes.push(SCROLLMODECLASS);
        }
        this.unWireEvents();
        this.element.innerHTML = '';
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], classes);
        attributes.forEach(function (attribute) {
            _this.element.removeAttribute(attribute);
        });
        _super.prototype.destroy.call(this);
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Breadcrumb.prototype, "url", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["f" /* Collection */])([], BreadcrumbItem)
    ], Breadcrumb.prototype, "items", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Breadcrumb.prototype, "activeItem", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(-1)
    ], Breadcrumb.prototype, "maxItems", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Menu')
    ], Breadcrumb.prototype, "overflowMode", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Breadcrumb.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(null)
    ], Breadcrumb.prototype, "itemTemplate", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('/')
    ], Breadcrumb.prototype, "separatorTemplate", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Breadcrumb.prototype, "enableNavigation", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Breadcrumb.prototype, "enableActiveItemNavigation", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Breadcrumb.prototype, "disabled", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('')
    ], Breadcrumb.prototype, "locale", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Breadcrumb.prototype, "beforeItemRender", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Breadcrumb.prototype, "itemClick", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Breadcrumb.prototype, "created", void 0);
    Breadcrumb = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], Breadcrumb);
    return Breadcrumb;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__carousel__ = __webpack_require__(288);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__carousel__["a"]; });
/** Carousel export modules */



/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CarouselItem */
/* unused harmony export CarouselAnimationSettings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Carousel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__ = __webpack_require__(11);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */




// Constant variables
var CLS_CAROUSEL = 'e-carousel';
var CLS_ACTIVE = 'e-active';
var CLS_RTL = 'e-rtl';
var CLS_ITEMS = 'e-carousel-items';
var CLS_ITEM = 'e-carousel-item';
var CLS_PREVIOUS = 'e-previous';
var CLS_NEXT = 'e-next';
var CLS_PREV_ICON = 'e-previous-icon';
var CLS_NEXT_ICON = 'e-next-icon';
var CLS_NAVIGATORS = 'e-carousel-navigators';
var CLS_INDICATORS = 'e-carousel-indicators';
var CLS_INDICATOR_BARS = 'e-indicator-bars';
var CLS_INDICATOR_BAR = 'e-indicator-bar';
var CLS_INDICATOR = 'e-indicator';
var CLS_ICON = 'e-icons';
var CLS_PLAY_PAUSE = 'e-play-pause';
var CLS_PLAY_ICON = 'e-play-icon';
var CLS_PAUSE_ICON = 'e-pause-icon';
var CLS_PREV_BUTTON = 'e-previous-button';
var CLS_NEXT_BUTTON = 'e-next-button';
var CLS_PLAY_BUTTON = 'e-play-button';
var CLS_FLAT = 'e-flat';
var CLS_ROUND = 'e-round';
var CLS_HOVER_ARROWS = 'e-hover-arrows';
var CLS_HOVER = 'e-carousel-hover';
var CLS_TEMPLATE = 'e-template';
var CLS_SLIDE_ANIMATION = 'e-carousel-slide-animation';
var CLS_FADE_ANIMATION = 'e-carousel-fade-animation';
var CLS_CUSTOM_ANIMATION = 'e-carousel-custom-animation';
var CLS_PREV_SLIDE = 'e-prev';
var CLS_NEXT_SLIDE = 'e-next';
var CLS_TRANSITION_START = 'e-transition-start';
var CLS_TRANSITION_END = 'e-transition-end';
/** Specifies the carousel individual item. */
var CarouselItem = /** @class */ (function (_super) {
    __extends(CarouselItem, _super);
    function CarouselItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], CarouselItem.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], CarouselItem.prototype, "interval", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], CarouselItem.prototype, "template", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], CarouselItem.prototype, "htmlAttributes", void 0);
    return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

/** Specifies the animation configuration for carousel items. */
var CarouselAnimationSettings = /** @class */ (function (_super) {
    __extends(CarouselAnimationSettings, _super);
    function CarouselAnimationSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Slide')
    ], CarouselAnimationSettings.prototype, "effect", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], CarouselAnimationSettings.prototype, "customEffect", void 0);
    return CarouselAnimationSettings;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["e" /* ChildProperty */]));

var Carousel = /** @class */ (function (_super) {
    __extends(Carousel, _super);
    /**
     * Constructor for creating the Carousel widget
     *
     * @param {CarouselModel} options Accepts the carousel model properties to initiate the rendering
     * @param {string | HTMLElement} element Accepts the DOM element reference
     */
    function Carousel(options, element) {
        return _super.call(this, options, element) || this;
    }
    Carousel.prototype.getModuleName = function () {
        return CLS_CAROUSEL.replace('e-', '');
    };
    Carousel.prototype.getPersistData = function () {
        return this.addOnPersist(['selectedIndex']);
    };
    Carousel.prototype.preRender = function () {
        this.keyConfigs = {
            home: 'home',
            end: 'end',
            space: 'space',
            moveLeft: 'leftarrow',
            moveRight: 'rightarrow',
            moveUp: 'uparrow',
            moveDown: 'downarrow'
        };
        var defaultLocale = {
            nextSlide: 'Next slide',
            of: 'of',
            pauseSlideTransition: 'Pause slide transition',
            playSlideTransition: 'Play slide transition',
            previousSlide: 'Previous slide',
            slide: 'Slide',
            slideShow: 'Slide show'
        };
        this.localeObj = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["o" /* L10n */](this.getModuleName(), defaultLocale, this.locale);
    };
    Carousel.prototype.render = function () {
        this.initialize();
        this.renderSlides();
        this.renderNavigators();
        this.renderPlayButton();
        this.renderIndicators();
        this.applyAnimation();
        this.wireEvents();
    };
    Carousel.prototype.onPropertyChanged = function (newProp, oldProp) {
        var target;
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'animation':
                    for (var _b = 0, _c = Object.keys(newProp.animation); _b < _c.length; _b++) {
                        var propName = _c[_b];
                        if (propName === 'customEffect' && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(oldProp.animation.customEffect)) {
                            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element.querySelector("." + CLS_ITEMS)], oldProp.animation.customEffect);
                        }
                    }
                    this.applyAnimation();
                    break;
                case 'cssClass':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["x" /* classList */])(this.element, [newProp.cssClass], [oldProp.cssClass]);
                    break;
                case 'selectedIndex':
                    this.setActiveSlide(this.selectedIndex, oldProp.selectedIndex > this.selectedIndex ? 'Previous' : 'Next');
                    this.autoSlide();
                    break;
                case 'htmlAttributes':
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.htmlAttributes)) {
                        this.setHtmlAttributes(this.htmlAttributes, this.element);
                    }
                    break;
                case 'enableTouchSwipe':
                    if (!this.enableTouchSwipe && this.touchModule) {
                        this.touchModule.destroy();
                    }
                    if (this.element.querySelector("." + CLS_ITEMS)) {
                        this.renderTouchActions();
                    }
                    break;
                case 'loop':
                    if (this.loop && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.autoSlideInterval)) {
                        this.applySlideInterval();
                    }
                    this.handleNavigatorsActions(this.selectedIndex);
                    break;
                case 'enableRtl':
                    if (this.enableRtl) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], CLS_RTL);
                    }
                    else {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], CLS_RTL);
                    }
                    break;
                case 'buttonsVisibility':
                    target = this.element.querySelector("." + CLS_NAVIGATORS);
                    if (target) {
                        switch (this.buttonsVisibility) {
                            case 'Hidden':
                                this.resetTemplates(['previousButtonTemplate', 'nextButtonTemplate']);
                                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(target);
                                break;
                            case 'VisibleOnHover':
                                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([].slice.call(target.childNodes), CLS_HOVER_ARROWS);
                                break;
                            case 'Visible':
                                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([].slice.call(target.childNodes), CLS_HOVER_ARROWS);
                                break;
                        }
                    }
                    else {
                        this.renderNavigators();
                        this.renderPlayButton();
                    }
                    break;
                case 'width':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'width': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.width) });
                    break;
                case 'height':
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'height': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.height) });
                    break;
                case 'autoPlay':
                    if (this.showPlayButton && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.playButtonTemplate)) {
                        this.playButtonClickHandler(null, true);
                    }
                    this.autoSlide();
                    break;
                case 'interval':
                    this.autoSlide();
                    break;
                case 'showIndicators':
                    target = this.element.querySelector("." + CLS_INDICATORS);
                    if (!this.showIndicators && target) {
                        this.resetTemplates(['indicatorsTemplate']);
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(target);
                    }
                    this.renderIndicators();
                    break;
                case 'showPlayButton':
                    target = this.element.querySelector("." + CLS_PLAY_PAUSE);
                    if (!this.showPlayButton && target) {
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(target);
                        this.resetTemplates(['playButtonTemplate']);
                    }
                    this.renderPlayButton();
                    break;
                case 'items':
                case 'dataSource':
                    target = this.element.querySelector("." + CLS_ITEMS);
                    if (target) {
                        this.resetTemplates(['itemTemplate']);
                        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Y" /* remove */])(target);
                    }
                    this.renderSlides();
                    break;
            }
        }
    };
    Carousel.prototype.initialize = function () {
        var carouselClasses = [];
        if (this.cssClass) {
            carouselClasses.push(this.cssClass);
        }
        if (this.enableRtl) {
            carouselClasses.push(CLS_RTL);
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], carouselClasses);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["_3" /* setStyleAttribute */])(this.element, { 'width': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.width), 'height': Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["G" /* formatUnit */])(this.height) });
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(this.element, { 'tabindex': '0', 'aria-roledescription': 'carousel', 'aria-label': this.localeObj.getConstant('slideShow') });
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.htmlAttributes)) {
            this.setHtmlAttributes(this.htmlAttributes, this.element);
        }
    };
    Carousel.prototype.renderSlides = function () {
        var _this = this;
        var itemsContainer = this.createElement('div', { className: CLS_ITEMS, attrs: { 'aria-live': this.autoPlay ? 'off' : 'polite' } });
        this.element.appendChild(itemsContainer);
        if (this.items.length > 0) {
            this.slideItems = this.items;
            this.items.forEach(function (item, index) {
                _this.renderSlide(item, item.template, index, itemsContainer);
            });
        }
        else if (this.dataSource.length > 0) {
            this.slideItems = this.dataSource;
            this.dataSource.forEach(function (item, index) {
                _this.renderSlide(item, _this.itemTemplate, index, itemsContainer);
            });
        }
        this.renderTemplates();
        this.autoSlide();
        this.renderTouchActions();
        this.renderKeyboardActions();
    };
    Carousel.prototype.renderSlide = function (item, itemTemplate, index, container) {
        var itemEle = this.createElement('div', {
            id: Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["N" /* getUniqueID */])('carousel_item'),
            className: CLS_ITEM + " " + (item.cssClass ? item.cssClass : '') + " " + (this.selectedIndex === index ? CLS_ACTIVE : ''),
            attrs: {
                'aria-hidden': this.selectedIndex === index ? 'false' : 'true', 'data-index': index.toString(),
                'aria-role': 'group', 'aria-roledescription': 'slide'
            }
        });
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(item.htmlAttributes)) {
            this.setHtmlAttributes(item.htmlAttributes, itemEle);
        }
        var templateId = this.element.id + '_template';
        var template = this.templateParser(itemTemplate)(item, this, 'itemTemplate', templateId, false);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(template, itemEle);
        container.appendChild(itemEle);
    };
    Carousel.prototype.renderNavigators = function () {
        if (this.buttonsVisibility === 'Hidden') {
            return;
        }
        var navigators = this.createElement('div', { className: CLS_NAVIGATORS });
        var itemsContainer = this.element.querySelector("." + CLS_ITEMS);
        itemsContainer.insertAdjacentElement('afterend', navigators);
        this.renderNavigatorButton('Previous');
        this.renderNavigatorButton('Next');
        this.renderTemplates();
    };
    Carousel.prototype.renderNavigatorButton = function (direction) {
        var buttonContainer = this.createElement('div', {
            className: (direction === 'Previous' ? CLS_PREVIOUS : CLS_NEXT) + ' ' + (this.buttonsVisibility === 'VisibleOnHover' ? CLS_HOVER_ARROWS : ''),
            attrs: { 'aria-label': this.localeObj.getConstant(direction === 'Previous' ? 'previousSlide' : 'nextSlide') }
        });
        if (direction === 'Previous' && this.previousButtonTemplate) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([buttonContainer], CLS_TEMPLATE);
            var templateId = this.element.id + '_previousButtonTemplate';
            var template = this.templateParser(this.previousButtonTemplate)({ type: 'Previous' }, this, 'previousButtonTemplate', templateId, false);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(template, buttonContainer);
        }
        else if (direction === 'Next' && this.nextButtonTemplate) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([buttonContainer], CLS_TEMPLATE);
            var templateId = this.element.id + '_nextButtonTemplate';
            var template = this.templateParser(this.nextButtonTemplate)({ type: 'Next' }, this, 'nextButtonTemplate', templateId, false);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(template, buttonContainer);
        }
        else {
            var button = this.createElement('button');
            var buttonObj = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__["a" /* Button */]({
                cssClass: CLS_FLAT + ' ' + CLS_ROUND + ' ' + (direction === 'Previous' ? CLS_PREV_BUTTON : CLS_NEXT_BUTTON),
                iconCss: CLS_ICON + ' ' + (direction === 'Previous' ? CLS_PREV_ICON : CLS_NEXT_ICON),
                enableRtl: this.enableRtl,
                disabled: !this.loop && this.selectedIndex === (direction === 'Previous' ? 0 : this.slideItems.length - 1)
            });
            buttonObj.appendTo(button);
            buttonContainer.appendChild(button);
        }
        this.element.querySelector('.' + CLS_NAVIGATORS).appendChild(buttonContainer);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(buttonContainer, 'click', this.navigatorClickHandler, this);
    };
    Carousel.prototype.renderPlayButton = function () {
        if (this.buttonsVisibility === 'Hidden' || !this.showPlayButton) {
            return;
        }
        var playPauseWrap = this.createElement('div', {
            className: CLS_PLAY_PAUSE + ' ' + (this.buttonsVisibility === 'VisibleOnHover' ? CLS_HOVER_ARROWS : '')
        });
        if (this.playButtonTemplate) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([playPauseWrap], CLS_TEMPLATE);
            var templateId = this.element.id + '_playButtonTemplate';
            var template = this.templateParser(this.playButtonTemplate)({}, this, 'playButtonTemplate', templateId, false);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(template, playPauseWrap);
        }
        else {
            var playButton = this.createElement('button', {
                attrs: { 'aria-label': this.localeObj.getConstant(this.autoPlay ? 'pauseSlideTransition' : 'playSlideTransition') }
            });
            var isLastSlide = this.selectedIndex === this.slideItems.length - 1 && !this.loop;
            var buttonObj = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__["a" /* Button */]({
                cssClass: CLS_FLAT + ' ' + CLS_ROUND + ' ' + CLS_PLAY_BUTTON,
                iconCss: CLS_ICON + ' ' + (this.autoPlay && !isLastSlide ? CLS_PAUSE_ICON : CLS_PLAY_ICON),
                isToggle: true,
                enableRtl: this.enableRtl
            });
            if (isLastSlide) {
                this.setProperties({ autoPlay: false }, true);
                playButton.setAttribute('aria-label', this.localeObj.getConstant('playSlideTransition'));
                var itemsContainer = this.element.querySelector("." + CLS_ITEMS);
                itemsContainer.setAttribute('aria-live', 'polite');
            }
            buttonObj.appendTo(playButton);
            playPauseWrap.appendChild(playButton);
        }
        var navigators = this.element.querySelector("." + CLS_NAVIGATORS);
        navigators.insertBefore(playPauseWrap, navigators.lastElementChild);
        this.renderTemplates();
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(playPauseWrap, 'click', this.playButtonClickHandler, this);
    };
    Carousel.prototype.renderIndicators = function () {
        var _this = this;
        if (!this.showIndicators) {
            return;
        }
        var indicatorWrap = this.createElement('div', { className: CLS_INDICATORS });
        var indicatorBars = this.createElement('div', { className: CLS_INDICATOR_BARS });
        indicatorWrap.appendChild(indicatorBars);
        if (this.slideItems) {
            this.slideItems.forEach(function (item, index) {
                var indicatorBar = _this.createElement('div', {
                    className: CLS_INDICATOR_BAR + ' ' + (_this.selectedIndex === index ? CLS_ACTIVE : ''),
                    attrs: { 'data-index': index.toString(), 'aria-current': _this.selectedIndex === index ? 'true' : 'false' }
                });
                if (_this.indicatorsTemplate) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([indicatorBar], CLS_TEMPLATE);
                    var templateId = _this.element.id + '_indicatorsTemplate';
                    var template = _this.templateParser(_this.indicatorsTemplate)({ index: index, selectedIndex: _this.selectedIndex }, _this, 'indicatorsTemplate', templateId, false);
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["v" /* append */])(template, indicatorBar);
                }
                else {
                    var indicator = _this.createElement('button', { className: CLS_INDICATOR });
                    indicatorBar.appendChild(indicator);
                    indicator.appendChild(_this.createElement('div', {
                        attrs: {
                            'aria-label': _this.localeObj.getConstant('slide') + ' ' + (index + 1) + ' ' + _this.localeObj.getConstant('of') + ' ' + _this.slideItems.length
                        }
                    }));
                    var buttonObj = new __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__["a" /* Button */]({ cssClass: 'e-flat e-small' });
                    buttonObj.appendTo(indicator);
                }
                indicatorBars.appendChild(indicatorBar);
                __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(indicatorBar, 'click', _this.indicatorClickHandler, _this);
            });
        }
        this.element.appendChild(indicatorWrap);
    };
    Carousel.prototype.renderKeyboardActions = function () {
        this.keyModule = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["n" /* KeyboardEvents */](this.element, { keyAction: this.keyHandler.bind(this), keyConfigs: this.keyConfigs });
    };
    Carousel.prototype.renderTouchActions = function () {
        if (!this.enableTouchSwipe) {
            return;
        }
        this.touchModule = new __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["t" /* Touch */](this.element, { swipe: this.swipeHandler.bind(this) });
    };
    Carousel.prototype.applyAnimation = function () {
        var animationTarget = this.element.querySelector("." + CLS_ITEMS);
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([animationTarget], [CLS_CUSTOM_ANIMATION, CLS_FADE_ANIMATION, CLS_SLIDE_ANIMATION]);
        if (this.animation.customEffect) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([animationTarget], [CLS_CUSTOM_ANIMATION, this.animation.customEffect]);
        }
        else if (this.animation.effect !== 'None') {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([animationTarget], this.animation.effect === 'Fade' ? CLS_FADE_ANIMATION : CLS_SLIDE_ANIMATION);
        }
    };
    Carousel.prototype.autoSlide = function () {
        this.resetSlideInterval();
        this.applySlideInterval();
    };
    Carousel.prototype.autoSlideChange = function () {
        var activeSlide = this.element.querySelector("." + CLS_ACTIVE);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(activeSlide)) {
            return;
        }
        var activeIndex = parseInt(activeSlide.dataset.index, 10);
        if (!this.loop && activeIndex === this.slideItems.length - 1) {
            this.resetSlideInterval();
        }
        else {
            var index = (activeIndex + 1) % this.slideItems.length;
            if (!this.element.classList.contains(CLS_HOVER)) {
                this.setActiveSlide(index, 'Next');
            }
            this.autoSlide();
        }
    };
    Carousel.prototype.applySlideInterval = function () {
        var _this = this;
        if (!this.autoPlay || this.element.classList.contains(CLS_HOVER)) {
            return;
        }
        var itemInterval = this.interval;
        if (this.items.length > 0 && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.items[this.selectedIndex].interval)) {
            itemInterval = this.items[this.selectedIndex].interval;
        }
        this.autoSlideInterval = setInterval(function () { return _this.autoSlideChange(); }, itemInterval);
    };
    Carousel.prototype.resetSlideInterval = function () {
        clearInterval(this.autoSlideInterval);
        this.autoSlideInterval = null;
    };
    Carousel.prototype.getSlideIndex = function (direction) {
        var currentIndex = this.selectedIndex;
        if (direction === 'Previous') {
            currentIndex--;
            if (currentIndex < 0) {
                currentIndex = this.slideItems.length - 1;
            }
        }
        else {
            currentIndex++;
            if (currentIndex === this.slideItems.length) {
                currentIndex = 0;
            }
        }
        return currentIndex;
    };
    Carousel.prototype.setActiveSlide = function (currentIndex, direction, isSwiped) {
        var _this = this;
        if (isSwiped === void 0) { isSwiped = false; }
        if (this.element.querySelectorAll("." + CLS_ITEM + "." + CLS_PREV_SLIDE + ",." + CLS_ITEM + "." + CLS_NEXT_SLIDE).length > 0) {
            return;
        }
        var allSlides = [].slice.call(this.element.querySelectorAll("." + CLS_ITEM));
        var activeSlide = this.element.querySelector("." + CLS_ITEM + "." + CLS_ACTIVE);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(activeSlide) && this.showIndicators) {
            var activeIndicator = this.element.querySelector("." + CLS_INDICATOR_BAR + "." + CLS_ACTIVE);
            var activeIndex_1 = parseInt(activeIndicator.dataset.index, 10);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([allSlides[activeIndex_1]], CLS_ACTIVE);
            return;
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(activeSlide)) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([allSlides[currentIndex]], CLS_ACTIVE);
            return;
        }
        var activeIndex = parseInt(activeSlide.dataset.index, 10);
        var currentSlide = allSlides[currentIndex];
        var eventArgs = {
            currentIndex: activeIndex,
            nextIndex: currentIndex,
            currentSlide: activeSlide,
            nextSlide: currentSlide,
            slideDirection: direction,
            isSwiped: isSwiped,
            cancel: false
        };
        this.trigger('slideChanging', eventArgs, function (args) {
            if (args.cancel) {
                return;
            }
            _this.setProperties({ selectedIndex: currentIndex }, true);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(args.currentSlide, { 'aria-hidden': 'true' });
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(args.nextSlide, { 'aria-hidden': 'false' });
            var slideIndicators = [].slice.call(_this.element.querySelectorAll("." + CLS_INDICATOR_BAR));
            if (slideIndicators.length > 0) {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(slideIndicators[activeIndex], { 'aria-current': 'false' });
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["w" /* attributes */])(slideIndicators[currentIndex], { 'aria-current': 'true' });
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])(slideIndicators, CLS_ACTIVE);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([slideIndicators[currentIndex]], CLS_ACTIVE);
            }
            _this.slideChangedEventArgs = {
                currentIndex: args.nextIndex,
                previousIndex: args.currentIndex,
                currentSlide: args.nextSlide,
                previousSlide: args.currentSlide,
                slideDirection: direction,
                isSwiped: isSwiped
            };
            var slideHeight;
            if (_this.animation.customEffect) {
                if (direction === 'Previous') {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([args.nextSlide], CLS_NEXT_SLIDE);
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([args.currentSlide], CLS_PREV_SLIDE);
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([args.currentSlide], CLS_PREV_SLIDE);
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([args.nextSlide], CLS_NEXT_SLIDE);
                }
            }
            else if (_this.animation.effect === 'Slide') {
                if (direction === 'Previous') {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([args.nextSlide], CLS_PREV_SLIDE);
                    slideHeight = args.nextSlide.offsetHeight;
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([args.currentSlide, args.nextSlide], CLS_TRANSITION_END);
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([args.nextSlide], CLS_NEXT_SLIDE);
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    slideHeight = args.nextSlide.offsetHeight;
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([args.currentSlide, args.nextSlide], CLS_TRANSITION_START);
                }
            }
            else if (_this.animation.effect === 'Fade') {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([args.currentSlide], CLS_ACTIVE);
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([args.nextSlide], CLS_ACTIVE);
            }
            else {
                _this.onTransitionEnd();
            }
            _this.handleNavigatorsActions(currentIndex);
        });
    };
    Carousel.prototype.onTransitionEnd = function () {
        var _this = this;
        if (this.slideChangedEventArgs) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.slideChangedEventArgs.currentSlide], CLS_ACTIVE);
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.slideChangedEventArgs.previousSlide], CLS_ACTIVE);
            this.trigger('slideChanged', this.slideChangedEventArgs, function () {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])(_this.element.querySelectorAll("." + CLS_ITEM), [CLS_PREV_SLIDE, CLS_NEXT_SLIDE, CLS_TRANSITION_START, CLS_TRANSITION_END]);
                _this.slideChangedEventArgs = null;
            });
        }
    };
    Carousel.prototype.setHtmlAttributes = function (attribute, element) {
        var keys = Object.keys(attribute);
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            if (key === 'class') {
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([element], attribute[key]);
            }
            else {
                element.setAttribute(key, attribute[key]);
            }
        }
    };
    Carousel.prototype.templateParser = function (template) {
        if (template) {
            try {
                if (document.querySelectorAll(template).length) {
                    return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(document.querySelector(template).innerHTML.trim());
                }
                else {
                    return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(template);
                }
            }
            catch (error) {
                return Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["A" /* compile */])(template);
            }
        }
        return undefined;
    };
    Carousel.prototype.getNavigatorState = function (target, isPrevious) {
        var button = target.querySelector("." + (isPrevious ? CLS_PREV_BUTTON : CLS_NEXT_BUTTON));
        if (button) {
            var buttonObj = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(button, __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__["a" /* Button */]);
            return buttonObj.disabled;
        }
        return false;
    };
    Carousel.prototype.navigatorClickHandler = function (e) {
        var target = e.currentTarget;
        var isDisabled = this.getNavigatorState(target, target.classList.contains(CLS_PREVIOUS));
        if (isDisabled) {
            return;
        }
        var direction = target.classList.contains(CLS_PREVIOUS) ? 'Previous' : 'Next';
        this.setActiveSlide(this.getSlideIndex(direction), direction);
        this.autoSlide();
    };
    Carousel.prototype.indicatorClickHandler = function (e) {
        var target = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["y" /* closest */])(e.target, "." + CLS_INDICATOR_BAR);
        var index = parseInt(target.dataset.index, 10);
        if (this.selectedIndex !== index) {
            this.setActiveSlide(index, this.selectedIndex > index ? 'Previous' : 'Next');
            this.autoSlide();
        }
    };
    Carousel.prototype.playButtonClickHandler = function (e, isPropertyChange) {
        if (isPropertyChange === void 0) { isPropertyChange = false; }
        var playButton = this.element.querySelector("." + CLS_PLAY_BUTTON);
        if (playButton) {
            var buttonObj = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(playButton, __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__["a" /* Button */]);
            if (!isPropertyChange) {
                this.setProperties({ autoPlay: !this.autoPlay }, true);
            }
            playButton.setAttribute('aria-label', this.localeObj.getConstant(this.autoPlay ? 'pauseSlideTransition' : 'playSlideTransition'));
            buttonObj.iconCss = CLS_ICON + ' ' + (this.autoPlay ? CLS_PAUSE_ICON : CLS_PLAY_ICON);
            buttonObj.dataBind();
            var itemsContainer = this.element.querySelector("." + CLS_ITEMS);
            itemsContainer.setAttribute('aria-live', this.autoPlay ? 'off' : 'polite');
            if (this.autoPlay && !this.loop && this.selectedIndex === this.slideItems.length - 1) {
                this.setActiveSlide(0, 'Next');
            }
            this.autoSlide();
        }
    };
    Carousel.prototype.keyHandler = function (e) {
        var direction;
        var slideIndex;
        var isSlideTransition = false;
        var target = e.target;
        e.preventDefault();
        switch (e.action) {
            case 'space':
                if (this.showIndicators && target.classList.contains(CLS_INDICATOR)) {
                    target.click();
                }
                else if (target.classList.contains(CLS_CAROUSEL) || target.classList.contains(CLS_PLAY_BUTTON)) {
                    this.playButtonClickHandler(e);
                }
                else if (target.classList.contains(CLS_NEXT_BUTTON)) {
                    this.next();
                }
                else if (target.classList.contains(CLS_PREV_BUTTON)) {
                    this.prev();
                }
                break;
            case 'end':
                slideIndex = this.slideItems.length - 1;
                direction = 'Next';
                isSlideTransition = true;
                break;
            case 'home':
                slideIndex = 0;
                direction = 'Previous';
                isSlideTransition = true;
                break;
            case 'moveUp':
            case 'moveLeft':
            case 'moveDown':
            case 'moveRight':
                if (this.showIndicators && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.indicatorsTemplate)) {
                    this.element.focus();
                }
                direction = (e.action === 'moveUp' || e.action === 'moveLeft') ? 'Previous' : 'Next';
                slideIndex = this.getSlideIndex(direction);
                isSlideTransition = !this.isSuspendSlideTransition(slideIndex, direction);
                break;
        }
        if (isSlideTransition) {
            this.setActiveSlide(slideIndex, direction);
            this.autoSlide();
            isSlideTransition = false;
        }
    };
    Carousel.prototype.swipeHandler = function (e) {
        if (this.element.classList.contains(CLS_HOVER)) {
            return;
        }
        var direction = (e.swipeDirection === 'Right') ? 'Previous' : 'Next';
        var slideIndex = this.getSlideIndex(direction);
        if (!this.isSuspendSlideTransition(slideIndex, direction)) {
            this.setActiveSlide(slideIndex, direction, true);
            this.autoSlide();
        }
    };
    Carousel.prototype.isSuspendSlideTransition = function (index, direction) {
        return !this.loop && (direction === 'Next' && index === 0 || direction === 'Previous' && index === this.slideItems.length - 1);
    };
    Carousel.prototype.handleNavigatorsActions = function (index) {
        if (this.buttonsVisibility === 'Hidden') {
            return;
        }
        if (this.showPlayButton) {
            var playButton = this.element.querySelector("." + CLS_PLAY_BUTTON);
            var isLastSlide = this.selectedIndex === this.slideItems.length - 1 && !this.loop;
            var isButtonUpdate = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.playButtonTemplate) && playButton && isLastSlide;
            if (Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.playButtonTemplate) && playButton && !isLastSlide) {
                isButtonUpdate = !playButton.classList.contains(CLS_ACTIVE);
            }
            if (isButtonUpdate) {
                this.setProperties({ autoPlay: !isLastSlide }, true);
                playButton.setAttribute('aria-label', this.localeObj.getConstant(this.autoPlay ? 'pauseSlideTransition' : 'playSlideTransition'));
                var itemsContainer = this.element.querySelector("." + CLS_ITEMS);
                itemsContainer.setAttribute('aria-live', this.autoPlay ? 'off' : 'polite');
                var buttonObj = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(playButton, __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__["a" /* Button */]);
                buttonObj.iconCss = CLS_ICON + ' ' + (this.autoPlay ? CLS_PAUSE_ICON : CLS_PLAY_ICON);
                buttonObj.dataBind();
            }
        }
        var prevButton = this.element.querySelector("." + CLS_PREV_BUTTON);
        if (prevButton && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.previousButtonTemplate)) {
            var buttonObj = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(prevButton, __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__["a" /* Button */]);
            buttonObj.disabled = !this.loop && index === 0;
            buttonObj.dataBind();
        }
        var nextButton = this.element.querySelector("." + CLS_NEXT_BUTTON);
        if (nextButton && Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.nextButtonTemplate)) {
            var buttonObj = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(nextButton, __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__["a" /* Button */]);
            buttonObj.disabled = !this.loop && index === this.slideItems.length - 1;
            buttonObj.dataBind();
        }
    };
    Carousel.prototype.onHoverActions = function (e) {
        var navigator = this.element.querySelector("." + CLS_NAVIGATORS);
        switch (e.type) {
            case 'mouseenter':
                if (this.buttonsVisibility === 'VisibleOnHover' && navigator) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([].slice.call(navigator.childNodes), CLS_HOVER_ARROWS);
                }
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], CLS_HOVER);
                break;
            case 'mouseleave':
                if (this.buttonsVisibility === 'VisibleOnHover' && navigator) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([].slice.call(navigator.childNodes), CLS_HOVER_ARROWS);
                }
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], CLS_HOVER);
                break;
        }
        this.autoSlide();
    };
    Carousel.prototype.onFocusActions = function (e) {
        switch (e.type) {
            case 'focusin':
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["u" /* addClass */])([this.element], CLS_HOVER);
                break;
            case 'focusout':
                Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], CLS_HOVER);
                break;
        }
        this.autoSlide();
    };
    Carousel.prototype.destroyButtons = function () {
        var buttonCollections = [].slice.call(this.element.querySelectorAll('.e-control.e-btn'));
        for (var _i = 0, buttonCollections_1 = buttonCollections; _i < buttonCollections_1.length; _i++) {
            var button = buttonCollections_1[_i];
            var instance = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["J" /* getInstance */])(button, __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_buttons__["a" /* Button */]);
            if (instance) {
                instance.destroy();
            }
        }
    };
    Carousel.prototype.wireEvents = function () {
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'focusin focusout', this.onFocusActions, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element, 'mouseenter mouseleave', this.onHoverActions, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element.firstElementChild, 'animationend', this.onTransitionEnd, this);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].add(this.element.firstElementChild, 'transitionend', this.onTransitionEnd, this);
    };
    Carousel.prototype.unWireEvents = function () {
        var _this = this;
        var indicators = [].slice.call(this.element.querySelectorAll("." + CLS_INDICATOR_BAR));
        indicators.forEach(function (indicator) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(indicator, 'click', _this.indicatorClickHandler);
        });
        var navigators = [].slice.call(this.element.querySelectorAll("." + CLS_PREVIOUS + ",." + CLS_NEXT));
        navigators.forEach(function (navigator) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(navigator, 'click', _this.navigatorClickHandler);
        });
        var playIcon = this.element.querySelector("." + CLS_PLAY_PAUSE);
        if (playIcon) {
            __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(playIcon, 'click', this.playButtonClickHandler);
        }
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element.firstElementChild, 'animationend', this.onTransitionEnd);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].remove(this.element.firstElementChild, 'transitionend', this.onTransitionEnd);
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["l" /* EventHandler */].clearEvents(this.element);
    };
    /**
     * Method to transit from the current slide to the previous slide.
     *
     * @returns {void}
     */
    Carousel.prototype.prev = function () {
        if (!this.loop && this.selectedIndex === 0) {
            return;
        }
        var index = (this.selectedIndex === 0) ? this.slideItems.length - 1 : this.selectedIndex - 1;
        this.setActiveSlide(index, 'Previous');
        this.autoSlide();
    };
    /**
     * Method to transit from the current slide to the next slide.
     *
     * @returns {void}
     */
    Carousel.prototype.next = function () {
        if (!this.loop && this.selectedIndex === this.slideItems.length - 1) {
            return;
        }
        var index = (this.selectedIndex === this.slideItems.length - 1) ? 0 : this.selectedIndex + 1;
        this.setActiveSlide(index, 'Next');
        this.autoSlide();
    };
    /**
     * Method to play the slides programmatically.
     *
     * @returns {void}
     */
    Carousel.prototype.play = function () {
        var playIcon = this.element.querySelector("." + CLS_PLAY_ICON);
        if (this.showPlayButton && playIcon) {
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["x" /* classList */])(playIcon, [CLS_PAUSE_ICON], [CLS_PLAY_ICON]);
            var playButton = this.element.querySelector("." + CLS_PLAY_BUTTON);
            playButton.setAttribute('aria-label', this.localeObj.getConstant('pauseSlideTransition'));
        }
        this.setProperties({ autoPlay: true }, true);
        var itemsContainer = this.element.querySelector("." + CLS_ITEMS);
        itemsContainer.setAttribute('aria-live', 'off');
        this.applySlideInterval();
    };
    /**
     * Method to pause the slides programmatically.
     *
     * @returns {void}
     */
    Carousel.prototype.pause = function () {
        var pauseIcon = this.element.querySelector("." + CLS_PAUSE_ICON);
        if (this.showPlayButton && pauseIcon) {
            var playButton = this.element.querySelector("." + CLS_PLAY_BUTTON);
            playButton.setAttribute('aria-label', this.localeObj.getConstant('playSlideTransition'));
            Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["x" /* classList */])(pauseIcon, [CLS_PLAY_ICON], [CLS_PAUSE_ICON]);
        }
        this.setProperties({ autoPlay: false }, true);
        var itemsContainer = this.element.querySelector("." + CLS_ITEMS);
        itemsContainer.setAttribute('aria-live', 'off');
        this.resetSlideInterval();
    };
    /**
     * Method to render react and angular templates
     *
     * @returns {void}
     * @private
     */
    Carousel.prototype.renderTemplates = function () {
        if (this.isAngular || this.isReact) {
            this.renderReactTemplates();
        }
    };
    /**
     * Method to reset react and angular templates
     *
     * @param {string[]} templates Accepts the template ID
     * @returns {void}
     * @private
     */
    Carousel.prototype.resetTemplates = function (templates) {
        if (this.isAngular || this.isReact) {
            this.clearTemplate(templates);
        }
    };
    /**
     * Method for destroy the carousel component.
     *
     * @returns {void}
     */
    Carousel.prototype.destroy = function () {
        var _this = this;
        this.resetTemplates();
        if (this.touchModule) {
            this.touchModule.destroy();
            this.touchModule = null;
        }
        this.keyModule.destroy();
        this.keyModule = null;
        this.resetSlideInterval();
        this.destroyButtons();
        this.unWireEvents();
        [].slice.call(this.element.children).forEach(function (ele) { _this.element.removeChild(ele); });
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Z" /* removeClass */])([this.element], [CLS_CAROUSEL, this.cssClass, CLS_RTL]);
        ['tabindex', 'role', 'style'].forEach(function (attr) { _this.element.removeAttribute(attr); });
        _super.prototype.destroy.call(this);
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["f" /* Collection */])([], CarouselItem)
    ], Carousel.prototype, "items", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["g" /* Complex */])({}, CarouselAnimationSettings)
    ], Carousel.prototype, "animation", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Carousel.prototype, "previousButtonTemplate", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Carousel.prototype, "nextButtonTemplate", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Carousel.prototype, "indicatorsTemplate", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Carousel.prototype, "playButtonTemplate", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Carousel.prototype, "cssClass", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])([])
    ], Carousel.prototype, "dataSource", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Carousel.prototype, "itemTemplate", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(0)
    ], Carousel.prototype, "selectedIndex", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('100%')
    ], Carousel.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('100%')
    ], Carousel.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(5000)
    ], Carousel.prototype, "interval", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Carousel.prototype, "autoPlay", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Carousel.prototype, "loop", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(false)
    ], Carousel.prototype, "showPlayButton", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Carousel.prototype, "enableTouchSwipe", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])(true)
    ], Carousel.prototype, "showIndicators", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])('Visible')
    ], Carousel.prototype, "buttonsVisibility", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["r" /* Property */])()
    ], Carousel.prototype, "htmlAttributes", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Carousel.prototype, "slideChanging", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["k" /* Event */])()
    ], Carousel.prototype, "slideChanged", void 0);
    Carousel = __decorate([
        __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["p" /* NotifyPropertyChanges */]
    ], Carousel);
    return Carousel;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["h" /* Component */]));



/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_base__ = __webpack_require__(46);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__component_base__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__component_base__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__component_base__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_decorator__ = __webpack_require__(290);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__component_decorator__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__component_decorator__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template__ = __webpack_require__(291);
/* unused harmony namespace reexport */
/**
 * index for component base
 */





/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export $internalHooks */
/* harmony export (immutable) */ __webpack_exports__["b"] = getProps;
/* harmony export (immutable) */ __webpack_exports__["a"] = EJComponentDecorator;
/* unused harmony export EJcomponentFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_base__ = __webpack_require__(46);
/**
 * Vue Component Base
 */

// import { Base, Component as EJ2Component, isNullOrUndefined } from '@syncfusion/ej2-base';

var $internalHooks = [
    'data',
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeDestroy',
    'destroyed',
    'beforeUpdate',
    'updated',
    'activated',
    'deactivated',
    'render',
    'errorCaptured' // 2.5
];
function getProps(options) {
    if (options === void 0) { options = {}; }
    if (options.props) {
        var _loop_1 = function (prop) {
            (options.newprops || (options.newprops = {}))[prop] = {};
            (options.watch || (options.watch = {}))[prop] = function (newVal) {
                this.ej2Instances[prop] = newVal;
                if (this.dataBind && (options.name !== 'DateRangePickerComponent')) {
                    this.dataBind();
                }
            };
        };
        for (var _i = 0, _a = options.props; _i < _a.length; _i++) {
            var prop = _a[_i];
            _loop_1(prop);
        }
    }
    return [options.newprops, options.watch];
}
function EJComponentDecorator(options, isExecute) {
    if (!isExecute) {
        return;
    }
    return function (Component) {
        return EJcomponentFactory(Component, options);
    };
}
function EJcomponentFactory(Component, options) {
    if (options === void 0) { options = {}; }
    options.name = options.name || Component._componentTag || Component.name;
    // prototype props.
    var proto = Component.prototype;
    if (options.props) {
        var _loop_2 = function (prop) {
            (options.props || (options.props = {}))[prop] = {};
            (options.watch || (options.watch = {}))[prop] = function (newVal) {
                this.ej2Instances[prop] = newVal;
                if (this.dataBind && (options.name !== 'DateRangePickerComponent')) {
                    this.dataBind();
                }
            };
        };
        for (var _i = 0, _a = options.props; _i < _a.length; _i++) {
            var prop = _a[_i];
            _loop_2(prop);
        }
    }
    Object.getOwnPropertyNames(proto).forEach(function (key) {
        // hooks
        if (key === 'constructor') {
            return;
        }
        if ($internalHooks.indexOf(key) > -1) {
            options[key] = proto[key];
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(proto, key);
        if (typeof descriptor.value === 'function') {
            // methods
            (options.methods || (options.methods = {}))[key] = descriptor.value;
        }
        else if (descriptor.get || descriptor.set) {
            // computed properties
            (options.computed || (options.computed = {}))[key] = {
                get: descriptor.get,
                set: descriptor.set
            };
        }
    });
    Object.getOwnPropertyNames(__WEBPACK_IMPORTED_MODULE_1__component_base__["a" /* ComponentBase */].prototype).forEach(function (key) {
        if ($internalHooks.indexOf(key) > -1) {
            options[key] = proto[key];
            return;
        }
    });
    (options.mixins || (options.mixins = [])).push({
        data: function () {
            return collectDataFromConstructor(this, Component);
        }
    });
    //  decorate options
    var decorators = Component.__decorators__;
    if (decorators) {
        decorators.forEach(Function(options));
        delete Component.__decorators__;
    }
    // find super
    var superProto = Object.getPrototypeOf(Component.prototype);
    var Super = superProto instanceof __WEBPACK_IMPORTED_MODULE_0_vue__["default"]
        ? superProto.constructor
        : __WEBPACK_IMPORTED_MODULE_0_vue__["default"];
    var Extended = Super.extend(options);
    return Extended;
}
function collectDataFromConstructor(vm, Component) {
    Component.prototype._init = function () {
        var _this = this;
        var keys = Object.getOwnPropertyNames(vm);
        if (vm.$options.props) {
            for (var key in vm.$options.props) {
                if (!vm.hasOwnProperty(key)) {
                    keys.push(key);
                }
            }
        }
        keys.forEach(function (key) {
            if (key.charAt(0) !== '_') {
                Object.defineProperty(_this, key, {
                    get: function () { return vm[key]; },
                    set: function (value) { return vm[key] = value; }
                });
            }
        });
    };
    var data = new Component();
    var plainData = {};
    Object.keys(data).forEach(function (key) {
        if (data[key] !== undefined) {
            plainData[key] = data[key];
        }
    });
    return plainData;
}


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_base__ = __webpack_require__(46);



// tslint:disable:no-any
var stringCompiler = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["M" /* getTemplateEngine */])();
function compile(templateElement, helper) {
    var that = this;
    return function (data, context, propName, element, root) {
        var returnEle;
        if (context) {
            var pid = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["N" /* getUniqueID */])("templateParentDiv");
            var id = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["N" /* getUniqueID */])("templateDiv");
            var ele = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["B" /* createElement */])("div", {
                id: pid,
                innerHTML: '<div id="' + id + '"></div>',
            });
            document.body.appendChild(ele);
            if (__WEBPACK_IMPORTED_MODULE_2__component_base__["c" /* gh */] && typeof templateElement === "string") {
                var vue3Slots_1 = getVue3Slot(context.vueInstance, templateElement, root);
                if (vue3Slots_1) {
                    // Compilation for Vue 3 slot template
                    __WEBPACK_IMPORTED_MODULE_2__component_base__["b" /* allVue */]
                        .createApp({
                        render: function () {
                            return vue3Slots_1[templateElement]({ data: data });
                        }
                    })
                        .mount("#" + id);
                    returnEle = ele.childNodes;
                    Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["D" /* detach */])(ele);
                }
                else {
                    // Compilation for Vue 3 string template
                    Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["D" /* detach */])(ele);
                    return stringCompiler(templateElement, helper)(data);
                }
            }
            else if (__WEBPACK_IMPORTED_MODULE_2__component_base__["c" /* gh */]) {
                // Compilation for Vue 3 functional template
                var tempObj = templateElement.call(that, {});
                var object = tempObj;
                var propsData = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["O" /* getValue */])("template.propsData", tempObj);
                var dataObj = {
                    data: { data: Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["F" /* extend */])(tempObj.data || {}, data) },
                    parent: context.vueInstance,
                };
                if (!object.template) {
                    object.template = object[Object.keys(object)[0]];
                }
                var templateCompRef = void 0;
                if (object.template.extends) {
                    templateCompRef = object.template.extends._context.components.template;
                }
                else {
                    templateCompRef = object.template._context.components[templateElement.name];
                    if (!templateCompRef) {
                        var key = Object.keys(object.template._context.components)[0];
                        templateCompRef = object.template._context.components[key];
                    }
                }
                var tempRef_1;
                if (propsData) {
                    tempRef_1 = Object.assign(templateCompRef.data(), propsData);
                }
                else {
                    tempRef_1 = Object.assign(templateCompRef.data(), dataObj.data);
                    if (templateCompRef.components) {
                        var objkeys = Object.keys(templateCompRef.components) || [];
                        var _loop_1 = function (objstring) {
                            var intComponent = templateCompRef.components[objstring];
                            if (intComponent && intComponent.data) {
                                var tempRef2_1 = Object.assign(intComponent.data(), dataObj.data);
                                intComponent.data = function () { return tempRef2_1; };
                            }
                        };
                        for (var _i = 0, objkeys_1 = objkeys; _i < objkeys_1.length; _i++) {
                            var objstring = objkeys_1[_i];
                            _loop_1(objstring);
                        }
                    }
                }
                templateCompRef.data = function () { return tempRef_1; };
                __WEBPACK_IMPORTED_MODULE_2__component_base__["b" /* allVue */]
                    .createApp(templateCompRef)
                    .mount("#" + id);
                returnEle = ele.childNodes;
                Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["D" /* detach */])(ele);
            }
            else if (typeof templateElement === "string") {
                var vue2Slots_1 = getVue2Slot(context.vueInstance, templateElement, root);
                if (vue2Slots_1) {
                    // Compilation for Vue 2 slot template
                    var vueTemplate = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
                        render: function () {
                            return vue2Slots_1[templateElement]({ data: data });
                        }
                    });
                    vueTemplate.$mount("#" + id);
                    returnEle = ele.childNodes;
                    Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["D" /* detach */])(ele);
                }
                else {
                    // Compilation for Vue 2 string template
                    Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["D" /* detach */])(ele);
                    return stringCompiler(templateElement, helper)(data);
                }
            }
            else {
                // Compilation for Vue 2 functional template
                var tempObj = templateElement.call(that, {});
                var templateFunction = tempObj.template;
                var propsData = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["O" /* getValue */])("template.propsData", tempObj);
                var dataObj = {
                    data: { data: Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["F" /* extend */])(tempObj.data || {}, data) },
                    parent: context.vueInstance,
                };
                if (propsData) {
                    templateFunction = tempObj.template.extends;
                    dataObj.propsData = propsData;
                }
                if (typeof templateFunction !== "function") {
                    templateFunction = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(templateFunction);
                }
                var templateVue = new templateFunction(dataObj);
                // let templateVue = new Vue(tempObj.template);
                // templateVue.$data.data = extend(tempObj.data, data);
                templateVue.$mount("#" + id);
                returnEle = ele.childNodes;
                if (context.vueInstance) {
                    var templateInstance = context.vueInstance.templateCollection;
                    if (!templateInstance) {
                        context.vueInstance.templateCollection = {};
                        templateInstance = context.vueInstance.templateCollection;
                    }
                    if (propName) {
                        if (!templateInstance[propName]) {
                            templateInstance[propName] = [];
                        }
                        templateInstance[propName].push(returnEle[0]);
                    }
                }
                Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["D" /* detach */])(ele);
            }
        }
        return returnEle || [];
    };
}
Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["_4" /* setTemplateEngine */])({ compile: compile });
// Get the Vue2 slot template from the root or current Vue component.
function getVue2Slot(vueInstance, templateElement, root) {
    if (!vueInstance && !(root && root.vueInstance)) {
        return undefined;
    }
    var instance = (root && root.vueInstance) ? root.vueInstance : vueInstance;
    return getVue2ChildSlot(instance, templateElement);
}
function getVue2ChildSlot(vueInstance, templateElement) {
    if (!vueInstance) {
        return undefined;
    }
    var slots = vueInstance.$slots;
    var scopedSlots = vueInstance.$scopedSlots;
    var vSlots = vueInstance.scopedSlots;
    var children = vueInstance.children;
    if (scopedSlots && scopedSlots[templateElement]) {
        return scopedSlots;
    }
    else if (slots && slots.default) {
        var childSlots = slots.default;
        for (var i = 0; i < childSlots.length; i++) {
            var slot = getVue2ChildSlot(getSlot(childSlots[i]), templateElement);
            if (slot) {
                return slot;
            }
        }
    }
    else if (vSlots && vSlots[templateElement]) {
        return vSlots;
    }
    else if (children) {
        for (var i = 0; i < children.length; i++) {
            var slot = getVue2ChildSlot(getSlot(children[i]), templateElement);
            if (slot) {
                return slot;
            }
        }
    }
    return undefined;
}
function getSlot(vnode) {
    var slot = (vnode.componentOptions && vnode.componentOptions.children) ? vnode.componentOptions : vnode.data;
    return vnode.componentInstance ? vnode.componentInstance : slot;
}
// Get the Vue3 slot template from the root or current Vue component.
function getVue3Slot(vueInstance, templateElement, root) {
    if (!vueInstance && !(root && root.vueInstance)) {
        return undefined;
    }
    var slots = (root && root.vueInstance) ? root.vueInstance.$slots : vueInstance.$slots;
    return getVue3ChildSlot(slots, templateElement);
}
function getVue3ChildSlot(slots, templateElement) {
    if (slots && slots[templateElement]) {
        return slots;
    }
    else if (slots && slots.default) {
        var childSlots = slots.default();
        for (var i = 0; i < childSlots.length; i++) {
            var slot = getVue3ChildSlot(childSlots[i].children, templateElement);
            if (slot) {
                return slot;
            }
        }
    }
    return undefined;
}


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export properties */
/* unused harmony export modelProps */
/* unused harmony export testProp */
/* unused harmony export props */
/* unused harmony export watch */
/* unused harmony export emitProbs */
/* unused harmony export isExecute */
/* unused harmony export AccordionComponent */
/* unused harmony export AccordionPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__items_directive__ = __webpack_require__(92);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var properties = ['isLazyUpdate', 'animation', 'dataSource', 'enableHtmlSanitizer', 'enablePersistence', 'enableRtl', 'expandMode', 'expandedIndices', 'headerTemplate', 'height', 'itemTemplate', 'items', 'locale', 'width', 'clicked', 'created', 'destroyed', 'expanded', 'expanding'];
var modelProps = ['expandedIndices'];
var testProp = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["d" /* getProps */])({ props: properties });
var props = testProp[0];
var watch = testProp[1];
var emitProbs = Object.keys(watch);
emitProbs.push('modelchanged');
for (var _i = 0, modelProps_1 = modelProps; _i < modelProps_1.length; _i++) {
    var props_1 = modelProps_1[_i];
    emitProbs.push('update:' + props_1);
}
var isExecute = __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["e" /* gh */] ? false : true;
/**
 * Represents the VueJS Accordion Component.
 * ```html
 * <ejs-accordion></ejs-accordion>
 * ```
 */
var AccordionComponent = /** @class */ (function (_super) {
    __extends(AccordionComponent, _super);
    function AccordionComponent() {
        var _this = _super.call(this, arguments) || this;
        _this.propKeys = properties;
        _this.models = modelProps;
        _this.hasChildDirective = true;
        _this.hasInjectedModules = false;
        _this.tagMapper = { "e-accordionitems": "e-accordionitem" };
        _this.tagNameMapper = { "e-accordionitems": "e-items" };
        _this.isVue3 = !isExecute;
        _this.ej2Instances = new __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__["a" /* Accordion */]({});
        _this.ej2Instances._trigger = _this.ej2Instances.trigger;
        _this.ej2Instances.trigger = _this.trigger;
        _this.bindProperties();
        _this.ej2Instances._setProperties = _this.ej2Instances.setProperties;
        _this.ej2Instances.setProperties = _this.setProperties;
        _this.ej2Instances.clearTemplate = _this.clearTemplate;
        _this.updated = _this.updated;
        return _this;
    }
    AccordionComponent.prototype.clearTemplate = function (templateNames) {
        if (!templateNames) {
            templateNames = Object.keys(this.templateCollection || {});
        }
        if (templateNames.length && this.templateCollection) {
            for (var _i = 0, templateNames_1 = templateNames; _i < templateNames_1.length; _i++) {
                var tempName = templateNames_1[_i];
                var elementCollection = this.templateCollection[tempName];
                if (elementCollection && elementCollection.length) {
                    for (var _a = 0, elementCollection_1 = elementCollection; _a < elementCollection_1.length; _a++) {
                        var ele = elementCollection_1[_a];
                        var destroy = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('__vue__.$destroy', ele);
                        if (destroy) {
                            ele.__vue__.$destroy();
                        }
                        if (ele.innerHTML) {
                            ele.innerHTML = '';
                        }
                    }
                    delete this.templateCollection[tempName];
                }
            }
        }
    };
    AccordionComponent.prototype.setProperties = function (prop, muteOnChange) {
        var _this = this;
        if (this.isVue3) {
            this.models = !this.models ? this.ej2Instances.referModels : this.models;
        }
        if (this.ej2Instances && this.ej2Instances._setProperties) {
            this.ej2Instances._setProperties(prop, muteOnChange);
        }
        if (prop && this.models && this.models.length) {
            Object.keys(prop).map(function (key) {
                _this.models.map(function (model) {
                    if ((key === model) && !(/datasource/i.test(key))) {
                        if (_this.isVue3) {
                            _this.ej2Instances.vueInstance.$emit('update:' + key, prop[key]);
                        }
                        else {
                            _this.$emit('update:' + key, prop[key]);
                            _this.$emit('modelchanged', prop[key]);
                        }
                    }
                });
            });
        }
    };
    AccordionComponent.prototype.trigger = function (eventName, eventProp, successHandler) {
        if (!isExecute) {
            this.models = !this.models ? this.ej2Instances.referModels : this.models;
        }
        if ((eventName === 'change' || eventName === 'input') && this.models && (this.models.length !== 0)) {
            var key = this.models.toString().match(/checked|value/) || [];
            var propKey = key[0];
            if (eventProp && key && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["S" /* isUndefined */])(eventProp[propKey])) {
                if (!isExecute) {
                    this.ej2Instances.vueInstance.$emit('update:' + propKey, eventProp[propKey]);
                    this.ej2Instances.vueInstance.$emit('modelchanged', eventProp[propKey]);
                    this.ej2Instances.vueInstance.$emit('update:modelValue', eventProp[propKey]);
                }
                else {
                    if (eventName === 'change' || (this.$props && !this.$props.isLazyUpdate)) {
                        this.$emit('update:' + propKey, eventProp[propKey]);
                        this.$emit('modelchanged', eventProp[propKey]);
                    }
                }
            }
        }
        else if ((eventName === 'actionBegin' && eventProp.requestType === 'dateNavigate') && this.models && (this.models.length !== 0)) {
            var key = this.models.toString().match(/currentView|selectedDate/) || [];
            var propKey = key[0];
            if (eventProp && key && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["S" /* isUndefined */])(eventProp[propKey])) {
                if (!isExecute) {
                    this.ej2Instances.vueInstance.$emit('update:' + propKey, eventProp[propKey]);
                    this.ej2Instances.vueInstance.$emit('modelchanged', eventProp[propKey]);
                }
                else {
                    this.$emit('update:' + propKey, eventProp[propKey]);
                    this.$emit('modelchanged', eventProp[propKey]);
                }
            }
        }
        if ((this.ej2Instances && this.ej2Instances._trigger)) {
            this.ej2Instances._trigger(eventName, eventProp, successHandler);
        }
    };
    AccordionComponent.prototype.render = function (createElement) {
        var h = __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["e" /* gh */] || createElement;
        var slots = null;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.$slots.default)) {
            slots = __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["e" /* gh */] ? this.$slots.default() : this.$slots.default;
        }
        return h('div', slots);
    };
    AccordionComponent.prototype.custom = function () {
        this.updated();
    };
    AccordionComponent.prototype.addItem = function (item, index) {
        return this.ej2Instances.addItem(item, index);
    };
    AccordionComponent.prototype.enableItem = function (index, isEnable) {
        return this.ej2Instances.enableItem(index, isEnable);
    };
    AccordionComponent.prototype.expandItem = function (isExpand, index) {
        return this.ej2Instances.expandItem(isExpand, index);
    };
    AccordionComponent.prototype.hideItem = function (index, isHidden) {
        return this.ej2Instances.hideItem(index, isHidden);
    };
    AccordionComponent.prototype.removeItem = function (index) {
        return this.ej2Instances.removeItem(index);
    };
    AccordionComponent.prototype.select = function (index) {
        return this.ej2Instances.select(index);
    };
    AccordionComponent = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({
            props: properties,
            model: {
                event: 'modelchanged'
            }
        }, isExecute)
        
    ], AccordionComponent);
    return AccordionComponent;
}(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["a" /* ComponentBase */]));

var AccordionPlugin = {
    name: 'ejs-accordion',
    install: function (Vue) {
        Vue.component(AccordionPlugin.name, AccordionComponent);
        Vue.component(__WEBPACK_IMPORTED_MODULE_3__items_directive__["b" /* AccordionItemPlugin */].name, __WEBPACK_IMPORTED_MODULE_3__items_directive__["a" /* AccordionItemDirective */]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_3__items_directive__["d" /* AccordionItemsPlugin */].name, __WEBPACK_IMPORTED_MODULE_3__items_directive__["c" /* AccordionItemsDirective */]);
    }
};


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export properties */
/* unused harmony export modelProps */
/* unused harmony export testProp */
/* unused harmony export props */
/* unused harmony export watch */
/* unused harmony export emitProbs */
/* unused harmony export isExecute */
/* unused harmony export ToolbarComponent */
/* unused harmony export ToolbarPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__items_directive__ = __webpack_require__(93);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var properties = ['isLazyUpdate', 'allowKeyboard', 'cssClass', 'enableCollision', 'enableHtmlSanitizer', 'enablePersistence', 'enableRtl', 'height', 'items', 'locale', 'overflowMode', 'scrollStep', 'width', 'beforeCreate', 'clicked', 'created', 'destroyed'];
var modelProps = [];
var testProp = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["d" /* getProps */])({ props: properties });
var props = testProp[0];
var watch = testProp[1];
var emitProbs = Object.keys(watch);
emitProbs.push('modelchanged');
for (var _i = 0, modelProps_1 = modelProps; _i < modelProps_1.length; _i++) {
    var props_1 = modelProps_1[_i];
    emitProbs.push('update:' + props_1);
}
var isExecute = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? false : true;
/**
 * Represents the VueJS Toolbar Component.
 * ```html
 * <ejs-toolbar></ejs-toolbar>
 * ```
 */
var ToolbarComponent = /** @class */ (function (_super) {
    __extends(ToolbarComponent, _super);
    function ToolbarComponent() {
        var _this = _super.call(this, arguments) || this;
        _this.propKeys = properties;
        _this.models = modelProps;
        _this.hasChildDirective = true;
        _this.hasInjectedModules = false;
        _this.tagMapper = { "e-items": "e-item" };
        _this.tagNameMapper = {};
        _this.isVue3 = !isExecute;
        _this.ej2Instances = new __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__["h" /* Toolbar */]({});
        _this.bindProperties();
        _this.ej2Instances._setProperties = _this.ej2Instances.setProperties;
        _this.ej2Instances.setProperties = _this.setProperties;
        _this.ej2Instances.clearTemplate = _this.clearTemplate;
        _this.updated = _this.updated;
        return _this;
    }
    ToolbarComponent.prototype.clearTemplate = function (templateNames) {
        if (!templateNames) {
            templateNames = Object.keys(this.templateCollection || {});
        }
        if (templateNames.length && this.templateCollection) {
            for (var _i = 0, templateNames_1 = templateNames; _i < templateNames_1.length; _i++) {
                var tempName = templateNames_1[_i];
                var elementCollection = this.templateCollection[tempName];
                if (elementCollection && elementCollection.length) {
                    for (var _a = 0, elementCollection_1 = elementCollection; _a < elementCollection_1.length; _a++) {
                        var ele = elementCollection_1[_a];
                        var destroy = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["O" /* getValue */])('__vue__.$destroy', ele);
                        if (destroy) {
                            ele.__vue__.$destroy();
                        }
                        if (ele.innerHTML) {
                            ele.innerHTML = '';
                        }
                    }
                    delete this.templateCollection[tempName];
                }
            }
        }
    };
    ToolbarComponent.prototype.setProperties = function (prop, muteOnChange) {
        var _this = this;
        if (this.isVue3) {
            this.models = !this.models ? this.ej2Instances.referModels : this.models;
        }
        if (this.ej2Instances && this.ej2Instances._setProperties) {
            this.ej2Instances._setProperties(prop, muteOnChange);
        }
        if (prop && this.models && this.models.length) {
            Object.keys(prop).map(function (key) {
                _this.models.map(function (model) {
                    if ((key === model) && !(/datasource/i.test(key))) {
                        if (_this.isVue3) {
                            _this.ej2Instances.vueInstance.$emit('update:' + key, prop[key]);
                        }
                        else {
                            _this.$emit('update:' + key, prop[key]);
                            _this.$emit('modelchanged', prop[key]);
                        }
                    }
                });
            });
        }
    };
    ToolbarComponent.prototype.render = function (createElement) {
        var h = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] || createElement;
        var slots = null;
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.$slots.default)) {
            slots = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? this.$slots.default() : this.$slots.default;
        }
        return h('div', slots);
    };
    ToolbarComponent.prototype.custom = function () {
        this.updated();
    };
    ToolbarComponent.prototype.addItems = function (items, index) {
        return this.ej2Instances.addItems(items, index);
    };
    ToolbarComponent.prototype.disable = function (value) {
        return this.ej2Instances.disable(value);
    };
    ToolbarComponent.prototype.enableItems = function (items, isEnable) {
        return this.ej2Instances.enableItems(items, isEnable);
    };
    ToolbarComponent.prototype.hideItem = function (index, value) {
        return this.ej2Instances.hideItem(index, value);
    };
    ToolbarComponent.prototype.refreshOverflow = function () {
        return this.ej2Instances.refreshOverflow();
    };
    ToolbarComponent.prototype.removeItems = function (args) {
        return this.ej2Instances.removeItems(args);
    };
    ToolbarComponent = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({
            props: properties
        }, isExecute)
        
    ], ToolbarComponent);
    return ToolbarComponent;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["a" /* ComponentBase */]));

var ToolbarPlugin = {
    name: 'ejs-toolbar',
    install: function (Vue) {
        Vue.component(ToolbarPlugin.name, ToolbarComponent);
        Vue.component(__WEBPACK_IMPORTED_MODULE_3__items_directive__["b" /* ItemPlugin */].name, __WEBPACK_IMPORTED_MODULE_3__items_directive__["a" /* ItemDirective */]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_3__items_directive__["d" /* ItemsPlugin */].name, __WEBPACK_IMPORTED_MODULE_3__items_directive__["c" /* ItemsDirective */]);
    }
};


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export properties */
/* unused harmony export modelProps */
/* unused harmony export testProp */
/* unused harmony export props */
/* unused harmony export watch */
/* unused harmony export emitProbs */
/* unused harmony export isExecute */
/* unused harmony export ContextMenuComponent */
/* unused harmony export ContextMenuPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__ = __webpack_require__(9);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var properties = ['isLazyUpdate', 'animationSettings', 'cssClass', 'enableHtmlSanitizer', 'enablePersistence', 'enableRtl', 'enableScrolling', 'fields', 'filter', 'hoverDelay', 'items', 'locale', 'showItemOnClick', 'target', 'template', 'beforeClose', 'beforeItemRender', 'beforeOpen', 'created', 'onClose', 'onOpen', 'select'];
var modelProps = [];
var testProp = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["d" /* getProps */])({ props: properties });
var props = testProp[0];
var watch = testProp[1];
var emitProbs = Object.keys(watch);
emitProbs.push('modelchanged');
for (var _i = 0, modelProps_1 = modelProps; _i < modelProps_1.length; _i++) {
    var props_1 = modelProps_1[_i];
    emitProbs.push('update:' + props_1);
}
var isExecute = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? false : true;
/**
 * Represents the Essential JS 2 VueJS ContextMenu Component.
 * ```html
 * <div id='target'>Right click / Touch hold to open the ContextMenu</div>
 * <ejs-contextmenu target='#target' :items='menuItems'></ejs-contextmenu>
 * ```
 */
var ContextMenuComponent = /** @class */ (function (_super) {
    __extends(ContextMenuComponent, _super);
    function ContextMenuComponent() {
        var _this = _super.call(this, arguments) || this;
        _this.propKeys = properties;
        _this.models = modelProps;
        _this.hasChildDirective = false;
        _this.hasInjectedModules = false;
        _this.tagMapper = {};
        _this.tagNameMapper = {};
        _this.isVue3 = !isExecute;
        _this.ej2Instances = new __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__["d" /* ContextMenu */]({});
        _this.bindProperties();
        _this.ej2Instances._setProperties = _this.ej2Instances.setProperties;
        _this.ej2Instances.setProperties = _this.setProperties;
        _this.ej2Instances.clearTemplate = _this.clearTemplate;
        _this.updated = _this.updated;
        return _this;
    }
    ContextMenuComponent.prototype.clearTemplate = function (templateNames) {
        if (!templateNames) {
            templateNames = Object.keys(this.templateCollection || {});
        }
        if (templateNames.length && this.templateCollection) {
            for (var _i = 0, templateNames_1 = templateNames; _i < templateNames_1.length; _i++) {
                var tempName = templateNames_1[_i];
                var elementCollection = this.templateCollection[tempName];
                if (elementCollection && elementCollection.length) {
                    for (var _a = 0, elementCollection_1 = elementCollection; _a < elementCollection_1.length; _a++) {
                        var ele = elementCollection_1[_a];
                        var destroy = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["O" /* getValue */])('__vue__.$destroy', ele);
                        if (destroy) {
                            ele.__vue__.$destroy();
                        }
                        if (ele.innerHTML) {
                            ele.innerHTML = '';
                        }
                    }
                    delete this.templateCollection[tempName];
                }
            }
        }
    };
    ContextMenuComponent.prototype.setProperties = function (prop, muteOnChange) {
        var _this = this;
        if (this.isVue3) {
            this.models = !this.models ? this.ej2Instances.referModels : this.models;
        }
        if (this.ej2Instances && this.ej2Instances._setProperties) {
            this.ej2Instances._setProperties(prop, muteOnChange);
        }
        if (prop && this.models && this.models.length) {
            Object.keys(prop).map(function (key) {
                _this.models.map(function (model) {
                    if ((key === model) && !(/datasource/i.test(key))) {
                        if (_this.isVue3) {
                            _this.ej2Instances.vueInstance.$emit('update:' + key, prop[key]);
                        }
                        else {
                            _this.$emit('update:' + key, prop[key]);
                            _this.$emit('modelchanged', prop[key]);
                        }
                    }
                });
            });
        }
    };
    ContextMenuComponent.prototype.render = function (createElement) {
        var h = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] || createElement;
        var slots = null;
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.$slots.default)) {
            slots = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? this.$slots.default() : this.$slots.default;
        }
        return h('ul', slots);
    };
    ContextMenuComponent.prototype.custom = function () {
        this.updated();
    };
    ContextMenuComponent.prototype.close = function () {
        return this.ej2Instances.close();
    };
    ContextMenuComponent.prototype.enableItems = function (items, enable, isUniqueId) {
        return this.ej2Instances.enableItems(items, enable, isUniqueId);
    };
    ContextMenuComponent.prototype.getItemIndex = function (item, isUniqueId) {
        return this.ej2Instances.getItemIndex(item, isUniqueId);
    };
    ContextMenuComponent.prototype.hideItems = function (items, isUniqueId) {
        return this.ej2Instances.hideItems(items, isUniqueId);
    };
    ContextMenuComponent.prototype.insertAfter = function (items, text, isUniqueId) {
        return this.ej2Instances.insertAfter(items, text, isUniqueId);
    };
    ContextMenuComponent.prototype.insertBefore = function (items, text, isUniqueId) {
        return this.ej2Instances.insertBefore(items, text, isUniqueId);
    };
    ContextMenuComponent.prototype.open = function (top, left, target) {
        return this.ej2Instances.open(top, left, target);
    };
    ContextMenuComponent.prototype.removeItems = function (items, isUniqueId) {
        return this.ej2Instances.removeItems(items, isUniqueId);
    };
    ContextMenuComponent.prototype.setItem = function (item, id, isUniqueId) {
        return this.ej2Instances.setItem(item, id, isUniqueId);
    };
    ContextMenuComponent.prototype.showItems = function (items, isUniqueId) {
        return this.ej2Instances.showItems(items, isUniqueId);
    };
    ContextMenuComponent = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({
            props: properties
        }, isExecute)
        
    ], ContextMenuComponent);
    return ContextMenuComponent;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["a" /* ComponentBase */]));

var ContextMenuPlugin = {
    name: 'ejs-contextmenu',
    install: function (Vue) {
        Vue.component(ContextMenuPlugin.name, ContextMenuComponent);
    }
};


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export properties */
/* unused harmony export modelProps */
/* unused harmony export testProp */
/* unused harmony export props */
/* unused harmony export watch */
/* unused harmony export emitProbs */
/* unused harmony export isExecute */
/* unused harmony export BreadcrumbComponent */
/* unused harmony export BreadcrumbPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__items_directive__ = __webpack_require__(94);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var properties = ['isLazyUpdate', 'activeItem', 'cssClass', 'disabled', 'enableActiveItemNavigation', 'enableNavigation', 'enablePersistence', 'enableRtl', 'itemTemplate', 'items', 'locale', 'maxItems', 'overflowMode', 'separatorTemplate', 'url', 'beforeItemRender', 'created', 'itemClick'];
var modelProps = ['activeItem'];
var testProp = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["d" /* getProps */])({ props: properties });
var props = testProp[0];
var watch = testProp[1];
var emitProbs = Object.keys(watch);
emitProbs.push('modelchanged');
for (var _i = 0, modelProps_1 = modelProps; _i < modelProps_1.length; _i++) {
    var props_1 = modelProps_1[_i];
    emitProbs.push('update:' + props_1);
}
var isExecute = __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["e" /* gh */] ? false : true;
/**
 * Represents the VueJS Breadcrumb Component.
 * ```html
 * <ejs-breadcrumb :items='breadcrumbItems'></ejs-breadcrumb>
 * ```
 */
var BreadcrumbComponent = /** @class */ (function (_super) {
    __extends(BreadcrumbComponent, _super);
    function BreadcrumbComponent() {
        var _this = _super.call(this, arguments) || this;
        _this.propKeys = properties;
        _this.models = modelProps;
        _this.hasChildDirective = true;
        _this.hasInjectedModules = false;
        _this.tagMapper = { "e-breadcrumb-items": "e-breadcrumb-item" };
        _this.tagNameMapper = { "e-breadcrumb-items": "e-items" };
        _this.isVue3 = !isExecute;
        _this.ej2Instances = new __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__["b" /* Breadcrumb */]({});
        _this.ej2Instances._trigger = _this.ej2Instances.trigger;
        _this.ej2Instances.trigger = _this.trigger;
        _this.bindProperties();
        _this.ej2Instances._setProperties = _this.ej2Instances.setProperties;
        _this.ej2Instances.setProperties = _this.setProperties;
        _this.ej2Instances.clearTemplate = _this.clearTemplate;
        _this.updated = _this.updated;
        return _this;
    }
    BreadcrumbComponent.prototype.clearTemplate = function (templateNames) {
        if (!templateNames) {
            templateNames = Object.keys(this.templateCollection || {});
        }
        if (templateNames.length && this.templateCollection) {
            for (var _i = 0, templateNames_1 = templateNames; _i < templateNames_1.length; _i++) {
                var tempName = templateNames_1[_i];
                var elementCollection = this.templateCollection[tempName];
                if (elementCollection && elementCollection.length) {
                    for (var _a = 0, elementCollection_1 = elementCollection; _a < elementCollection_1.length; _a++) {
                        var ele = elementCollection_1[_a];
                        var destroy = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('__vue__.$destroy', ele);
                        if (destroy) {
                            ele.__vue__.$destroy();
                        }
                        if (ele.innerHTML) {
                            ele.innerHTML = '';
                        }
                    }
                    delete this.templateCollection[tempName];
                }
            }
        }
    };
    BreadcrumbComponent.prototype.setProperties = function (prop, muteOnChange) {
        var _this = this;
        if (this.isVue3) {
            this.models = !this.models ? this.ej2Instances.referModels : this.models;
        }
        if (this.ej2Instances && this.ej2Instances._setProperties) {
            this.ej2Instances._setProperties(prop, muteOnChange);
        }
        if (prop && this.models && this.models.length) {
            Object.keys(prop).map(function (key) {
                _this.models.map(function (model) {
                    if ((key === model) && !(/datasource/i.test(key))) {
                        if (_this.isVue3) {
                            _this.ej2Instances.vueInstance.$emit('update:' + key, prop[key]);
                        }
                        else {
                            _this.$emit('update:' + key, prop[key]);
                            _this.$emit('modelchanged', prop[key]);
                        }
                    }
                });
            });
        }
    };
    BreadcrumbComponent.prototype.trigger = function (eventName, eventProp, successHandler) {
        if (!isExecute) {
            this.models = !this.models ? this.ej2Instances.referModels : this.models;
        }
        if ((eventName === 'change' || eventName === 'input') && this.models && (this.models.length !== 0)) {
            var key = this.models.toString().match(/checked|value/) || [];
            var propKey = key[0];
            if (eventProp && key && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["S" /* isUndefined */])(eventProp[propKey])) {
                if (!isExecute) {
                    this.ej2Instances.vueInstance.$emit('update:' + propKey, eventProp[propKey]);
                    this.ej2Instances.vueInstance.$emit('modelchanged', eventProp[propKey]);
                    this.ej2Instances.vueInstance.$emit('update:modelValue', eventProp[propKey]);
                }
                else {
                    if (eventName === 'change' || (this.$props && !this.$props.isLazyUpdate)) {
                        this.$emit('update:' + propKey, eventProp[propKey]);
                        this.$emit('modelchanged', eventProp[propKey]);
                    }
                }
            }
        }
        else if ((eventName === 'actionBegin' && eventProp.requestType === 'dateNavigate') && this.models && (this.models.length !== 0)) {
            var key = this.models.toString().match(/currentView|selectedDate/) || [];
            var propKey = key[0];
            if (eventProp && key && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["S" /* isUndefined */])(eventProp[propKey])) {
                if (!isExecute) {
                    this.ej2Instances.vueInstance.$emit('update:' + propKey, eventProp[propKey]);
                    this.ej2Instances.vueInstance.$emit('modelchanged', eventProp[propKey]);
                }
                else {
                    this.$emit('update:' + propKey, eventProp[propKey]);
                    this.$emit('modelchanged', eventProp[propKey]);
                }
            }
        }
        if ((this.ej2Instances && this.ej2Instances._trigger)) {
            this.ej2Instances._trigger(eventName, eventProp, successHandler);
        }
    };
    BreadcrumbComponent.prototype.render = function (createElement) {
        var h = __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["e" /* gh */] || createElement;
        var slots = null;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.$slots.default)) {
            slots = __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["e" /* gh */] ? this.$slots.default() : this.$slots.default;
        }
        return h('nav', slots);
    };
    BreadcrumbComponent.prototype.custom = function () {
        this.updated();
    };
    BreadcrumbComponent = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({
            props: properties,
            model: {
                event: 'modelchanged'
            }
        }, isExecute)
        
    ], BreadcrumbComponent);
    return BreadcrumbComponent;
}(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["a" /* ComponentBase */]));

var BreadcrumbPlugin = {
    name: 'ejs-breadcrumb',
    install: function (Vue) {
        Vue.component(BreadcrumbPlugin.name, BreadcrumbComponent);
        Vue.component(__WEBPACK_IMPORTED_MODULE_3__items_directive__["b" /* BreadcrumbItemPlugin */].name, __WEBPACK_IMPORTED_MODULE_3__items_directive__["a" /* BreadcrumbItemDirective */]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_3__items_directive__["d" /* BreadcrumbItemsPlugin */].name, __WEBPACK_IMPORTED_MODULE_3__items_directive__["c" /* BreadcrumbItemsDirective */]);
    }
};


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export properties */
/* unused harmony export modelProps */
/* unused harmony export testProp */
/* unused harmony export props */
/* unused harmony export watch */
/* unused harmony export emitProbs */
/* unused harmony export isExecute */
/* unused harmony export CarouselComponent */
/* unused harmony export CarouselPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__items_directive__ = __webpack_require__(95);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var properties = ['isLazyUpdate', 'animation', 'autoPlay', 'buttonsVisibility', 'cssClass', 'dataSource', 'enablePersistence', 'enableRtl', 'enableTouchSwipe', 'height', 'htmlAttributes', 'indicatorsTemplate', 'interval', 'itemTemplate', 'items', 'locale', 'loop', 'nextButtonTemplate', 'playButtonTemplate', 'previousButtonTemplate', 'selectedIndex', 'showIndicators', 'showPlayButton', 'width', 'slideChanged', 'slideChanging'];
var modelProps = ['selectedIndex'];
var testProp = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["d" /* getProps */])({ props: properties });
var props = testProp[0];
var watch = testProp[1];
var emitProbs = Object.keys(watch);
emitProbs.push('modelchanged');
for (var _i = 0, modelProps_1 = modelProps; _i < modelProps_1.length; _i++) {
    var props_1 = modelProps_1[_i];
    emitProbs.push('update:' + props_1);
}
var isExecute = __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["e" /* gh */] ? false : true;
/**
 * Represents the VueJS Carousel Component.
 * ```html
 * <ejs-carousel :items='carouselItems'></ejs-carousel>
 * ```
 */
var CarouselComponent = /** @class */ (function (_super) {
    __extends(CarouselComponent, _super);
    function CarouselComponent() {
        var _this = _super.call(this, arguments) || this;
        _this.propKeys = properties;
        _this.models = modelProps;
        _this.hasChildDirective = true;
        _this.hasInjectedModules = false;
        _this.tagMapper = { "e-carousel-items": "e-carousel-item" };
        _this.tagNameMapper = { "e-carousel-items": "e-items" };
        _this.isVue3 = !isExecute;
        _this.ej2Instances = new __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__["c" /* Carousel */]({});
        _this.ej2Instances._trigger = _this.ej2Instances.trigger;
        _this.ej2Instances.trigger = _this.trigger;
        _this.bindProperties();
        _this.ej2Instances._setProperties = _this.ej2Instances.setProperties;
        _this.ej2Instances.setProperties = _this.setProperties;
        _this.ej2Instances.clearTemplate = _this.clearTemplate;
        _this.updated = _this.updated;
        return _this;
    }
    CarouselComponent.prototype.clearTemplate = function (templateNames) {
        if (!templateNames) {
            templateNames = Object.keys(this.templateCollection || {});
        }
        if (templateNames.length && this.templateCollection) {
            for (var _i = 0, templateNames_1 = templateNames; _i < templateNames_1.length; _i++) {
                var tempName = templateNames_1[_i];
                var elementCollection = this.templateCollection[tempName];
                if (elementCollection && elementCollection.length) {
                    for (var _a = 0, elementCollection_1 = elementCollection; _a < elementCollection_1.length; _a++) {
                        var ele = elementCollection_1[_a];
                        var destroy = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('__vue__.$destroy', ele);
                        if (destroy) {
                            ele.__vue__.$destroy();
                        }
                        if (ele.innerHTML) {
                            ele.innerHTML = '';
                        }
                    }
                    delete this.templateCollection[tempName];
                }
            }
        }
    };
    CarouselComponent.prototype.setProperties = function (prop, muteOnChange) {
        var _this = this;
        if (this.isVue3) {
            this.models = !this.models ? this.ej2Instances.referModels : this.models;
        }
        if (this.ej2Instances && this.ej2Instances._setProperties) {
            this.ej2Instances._setProperties(prop, muteOnChange);
        }
        if (prop && this.models && this.models.length) {
            Object.keys(prop).map(function (key) {
                _this.models.map(function (model) {
                    if ((key === model) && !(/datasource/i.test(key))) {
                        if (_this.isVue3) {
                            _this.ej2Instances.vueInstance.$emit('update:' + key, prop[key]);
                        }
                        else {
                            _this.$emit('update:' + key, prop[key]);
                            _this.$emit('modelchanged', prop[key]);
                        }
                    }
                });
            });
        }
    };
    CarouselComponent.prototype.trigger = function (eventName, eventProp, successHandler) {
        if (!isExecute) {
            this.models = !this.models ? this.ej2Instances.referModels : this.models;
        }
        if ((eventName === 'change' || eventName === 'input') && this.models && (this.models.length !== 0)) {
            var key = this.models.toString().match(/checked|value/) || [];
            var propKey = key[0];
            if (eventProp && key && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["S" /* isUndefined */])(eventProp[propKey])) {
                if (!isExecute) {
                    this.ej2Instances.vueInstance.$emit('update:' + propKey, eventProp[propKey]);
                    this.ej2Instances.vueInstance.$emit('modelchanged', eventProp[propKey]);
                    this.ej2Instances.vueInstance.$emit('update:modelValue', eventProp[propKey]);
                }
                else {
                    if (eventName === 'change' || (this.$props && !this.$props.isLazyUpdate)) {
                        this.$emit('update:' + propKey, eventProp[propKey]);
                        this.$emit('modelchanged', eventProp[propKey]);
                    }
                }
            }
        }
        else if ((eventName === 'actionBegin' && eventProp.requestType === 'dateNavigate') && this.models && (this.models.length !== 0)) {
            var key = this.models.toString().match(/currentView|selectedDate/) || [];
            var propKey = key[0];
            if (eventProp && key && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["S" /* isUndefined */])(eventProp[propKey])) {
                if (!isExecute) {
                    this.ej2Instances.vueInstance.$emit('update:' + propKey, eventProp[propKey]);
                    this.ej2Instances.vueInstance.$emit('modelchanged', eventProp[propKey]);
                }
                else {
                    this.$emit('update:' + propKey, eventProp[propKey]);
                    this.$emit('modelchanged', eventProp[propKey]);
                }
            }
        }
        if ((this.ej2Instances && this.ej2Instances._trigger)) {
            this.ej2Instances._trigger(eventName, eventProp, successHandler);
        }
    };
    CarouselComponent.prototype.render = function (createElement) {
        var h = __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["e" /* gh */] || createElement;
        var slots = null;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.$slots.default)) {
            slots = __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["e" /* gh */] ? this.$slots.default() : this.$slots.default;
        }
        return h('div', slots);
    };
    CarouselComponent.prototype.custom = function () {
        this.updated();
    };
    CarouselComponent.prototype.next = function () {
        return this.ej2Instances.next();
    };
    CarouselComponent.prototype.pause = function () {
        return this.ej2Instances.pause();
    };
    CarouselComponent.prototype.play = function () {
        return this.ej2Instances.play();
    };
    CarouselComponent.prototype.prev = function () {
        return this.ej2Instances.prev();
    };
    CarouselComponent = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({
            props: properties,
            model: {
                event: 'modelchanged'
            }
        }, isExecute)
        
    ], CarouselComponent);
    return CarouselComponent;
}(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["a" /* ComponentBase */]));

var CarouselPlugin = {
    name: 'ejs-carousel',
    install: function (Vue) {
        Vue.component(CarouselPlugin.name, CarouselComponent);
        Vue.component(__WEBPACK_IMPORTED_MODULE_3__items_directive__["b" /* CarouselItemPlugin */].name, __WEBPACK_IMPORTED_MODULE_3__items_directive__["a" /* CarouselItemDirective */]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_3__items_directive__["d" /* CarouselItemsPlugin */].name, __WEBPACK_IMPORTED_MODULE_3__items_directive__["c" /* CarouselItemsDirective */]);
    }
};


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export properties */
/* unused harmony export modelProps */
/* unused harmony export testProp */
/* unused harmony export props */
/* unused harmony export watch */
/* unused harmony export emitProbs */
/* unused harmony export isExecute */
/* unused harmony export TabComponent */
/* unused harmony export TabPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__items_directive__ = __webpack_require__(96);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var properties = ['isLazyUpdate', 'allowDragAndDrop', 'animation', 'cssClass', 'dragArea', 'enableHtmlSanitizer', 'enablePersistence', 'enableRtl', 'headerPlacement', 'height', 'heightAdjustMode', 'items', 'loadOn', 'locale', 'overflowMode', 'reorderActiveTab', 'scrollStep', 'selectedItem', 'showCloseButton', 'width', 'added', 'adding', 'created', 'destroyed', 'dragged', 'dragging', 'onDragStart', 'removed', 'removing', 'selected', 'selecting'];
var modelProps = [];
var testProp = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["d" /* getProps */])({ props: properties });
var props = testProp[0];
var watch = testProp[1];
var emitProbs = Object.keys(watch);
emitProbs.push('modelchanged');
for (var _i = 0, modelProps_1 = modelProps; _i < modelProps_1.length; _i++) {
    var props_1 = modelProps_1[_i];
    emitProbs.push('update:' + props_1);
}
var isExecute = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? false : true;
/**
 * Represents the VueJS Tab Component.
 * ```html
 * <ejs-tab></ejs-tab>
 * ```
 */
var TabComponent = /** @class */ (function (_super) {
    __extends(TabComponent, _super);
    function TabComponent() {
        var _this = _super.call(this, arguments) || this;
        _this.propKeys = properties;
        _this.models = modelProps;
        _this.hasChildDirective = true;
        _this.hasInjectedModules = false;
        _this.tagMapper = { "e-tabitems": "e-tabitem" };
        _this.tagNameMapper = { "e-tabitems": "e-items" };
        _this.isVue3 = !isExecute;
        _this.ej2Instances = new __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__["g" /* Tab */]({});
        _this.bindProperties();
        _this.ej2Instances._setProperties = _this.ej2Instances.setProperties;
        _this.ej2Instances.setProperties = _this.setProperties;
        _this.ej2Instances.clearTemplate = _this.clearTemplate;
        _this.updated = _this.updated;
        return _this;
    }
    TabComponent.prototype.clearTemplate = function (templateNames) {
        if (!templateNames) {
            templateNames = Object.keys(this.templateCollection || {});
        }
        if (templateNames.length && this.templateCollection) {
            for (var _i = 0, templateNames_1 = templateNames; _i < templateNames_1.length; _i++) {
                var tempName = templateNames_1[_i];
                var elementCollection = this.templateCollection[tempName];
                if (elementCollection && elementCollection.length) {
                    for (var _a = 0, elementCollection_1 = elementCollection; _a < elementCollection_1.length; _a++) {
                        var ele = elementCollection_1[_a];
                        var destroy = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["O" /* getValue */])('__vue__.$destroy', ele);
                        if (destroy) {
                            ele.__vue__.$destroy();
                        }
                        if (ele.innerHTML) {
                            ele.innerHTML = '';
                        }
                    }
                    delete this.templateCollection[tempName];
                }
            }
        }
    };
    TabComponent.prototype.setProperties = function (prop, muteOnChange) {
        var _this = this;
        if (this.isVue3) {
            this.models = !this.models ? this.ej2Instances.referModels : this.models;
        }
        if (this.ej2Instances && this.ej2Instances._setProperties) {
            this.ej2Instances._setProperties(prop, muteOnChange);
        }
        if (prop && this.models && this.models.length) {
            Object.keys(prop).map(function (key) {
                _this.models.map(function (model) {
                    if ((key === model) && !(/datasource/i.test(key))) {
                        if (_this.isVue3) {
                            _this.ej2Instances.vueInstance.$emit('update:' + key, prop[key]);
                        }
                        else {
                            _this.$emit('update:' + key, prop[key]);
                            _this.$emit('modelchanged', prop[key]);
                        }
                    }
                });
            });
        }
    };
    TabComponent.prototype.render = function (createElement) {
        var h = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] || createElement;
        var slots = null;
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.$slots.default)) {
            slots = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? this.$slots.default() : this.$slots.default;
        }
        return h('div', slots);
    };
    TabComponent.prototype.custom = function () {
        this.updated();
    };
    TabComponent.prototype.addTab = function (items, index) {
        return this.ej2Instances.addTab(items, index);
    };
    TabComponent.prototype.disable = function (value) {
        return this.ej2Instances.disable(value);
    };
    TabComponent.prototype.enableTab = function (index, value) {
        return this.ej2Instances.enableTab(index, value);
    };
    TabComponent.prototype.getItemIndex = function (tabItemId) {
        return this.ej2Instances.getItemIndex(tabItemId);
    };
    TabComponent.prototype.hideTab = function (index, value) {
        return this.ej2Instances.hideTab(index, value);
    };
    TabComponent.prototype.refresh = function () {
        return this.ej2Instances.refresh();
    };
    TabComponent.prototype.refreshActiveTab = function () {
        return this.ej2Instances.refreshActiveTab();
    };
    TabComponent.prototype.removeTab = function (index) {
        return this.ej2Instances.removeTab(index);
    };
    TabComponent.prototype.select = function (args, event) {
        return this.ej2Instances.select(args, event);
    };
    TabComponent = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({
            props: properties
        }, isExecute)
        
    ], TabComponent);
    return TabComponent;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["a" /* ComponentBase */]));

var TabPlugin = {
    name: 'ejs-tab',
    install: function (Vue) {
        Vue.component(TabPlugin.name, TabComponent);
        Vue.component(__WEBPACK_IMPORTED_MODULE_3__items_directive__["b" /* TabItemPlugin */].name, __WEBPACK_IMPORTED_MODULE_3__items_directive__["a" /* TabItemDirective */]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_3__items_directive__["d" /* TabItemsPlugin */].name, __WEBPACK_IMPORTED_MODULE_3__items_directive__["c" /* TabItemsDirective */]);
    }
};


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export properties */
/* unused harmony export modelProps */
/* unused harmony export testProp */
/* unused harmony export props */
/* unused harmony export watch */
/* unused harmony export emitProbs */
/* unused harmony export isExecute */
/* unused harmony export TreeViewComponent */
/* unused harmony export TreeViewPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__ = __webpack_require__(9);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var properties = ['isLazyUpdate', 'allowDragAndDrop', 'allowEditing', 'allowMultiSelection', 'allowTextWrap', 'animation', 'autoCheck', 'checkedNodes', 'cssClass', 'disabled', 'dragArea', 'enableHtmlSanitizer', 'enablePersistence', 'enableRtl', 'expandOn', 'expandedNodes', 'fields', 'fullRowNavigable', 'fullRowSelect', 'loadOnDemand', 'locale', 'nodeTemplate', 'selectedNodes', 'showCheckBox', 'sortOrder', 'actionFailure', 'created', 'dataBound', 'dataSourceChanged', 'destroyed', 'drawNode', 'keyPress', 'nodeChecked', 'nodeChecking', 'nodeClicked', 'nodeCollapsed', 'nodeCollapsing', 'nodeDragStart', 'nodeDragStop', 'nodeDragging', 'nodeDropped', 'nodeEdited', 'nodeEditing', 'nodeExpanded', 'nodeExpanding', 'nodeSelected', 'nodeSelecting'];
var modelProps = [];
var testProp = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["d" /* getProps */])({ props: properties });
var props = testProp[0];
var watch = testProp[1];
var emitProbs = Object.keys(watch);
emitProbs.push('modelchanged');
for (var _i = 0, modelProps_1 = modelProps; _i < modelProps_1.length; _i++) {
    var props_1 = modelProps_1[_i];
    emitProbs.push('update:' + props_1);
}
var isExecute = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? false : true;
/**
 * Represents the EJ2 VueJS TreeView Component.
 * ```html
 * <ejs-treeview></ejs-treeview>
 * ```
 */
var TreeViewComponent = /** @class */ (function (_super) {
    __extends(TreeViewComponent, _super);
    function TreeViewComponent() {
        var _this = _super.call(this, arguments) || this;
        _this.propKeys = properties;
        _this.models = modelProps;
        _this.hasChildDirective = false;
        _this.hasInjectedModules = false;
        _this.tagMapper = {};
        _this.tagNameMapper = {};
        _this.isVue3 = !isExecute;
        _this.ej2Instances = new __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__["i" /* TreeView */]({});
        _this.bindProperties();
        _this.ej2Instances._setProperties = _this.ej2Instances.setProperties;
        _this.ej2Instances.setProperties = _this.setProperties;
        _this.ej2Instances.clearTemplate = _this.clearTemplate;
        _this.updated = _this.updated;
        return _this;
    }
    TreeViewComponent.prototype.clearTemplate = function (templateNames) {
        if (!templateNames) {
            templateNames = Object.keys(this.templateCollection || {});
        }
        if (templateNames.length && this.templateCollection) {
            for (var _i = 0, templateNames_1 = templateNames; _i < templateNames_1.length; _i++) {
                var tempName = templateNames_1[_i];
                var elementCollection = this.templateCollection[tempName];
                if (elementCollection && elementCollection.length) {
                    for (var _a = 0, elementCollection_1 = elementCollection; _a < elementCollection_1.length; _a++) {
                        var ele = elementCollection_1[_a];
                        var destroy = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["O" /* getValue */])('__vue__.$destroy', ele);
                        if (destroy) {
                            ele.__vue__.$destroy();
                        }
                        if (ele.innerHTML) {
                            ele.innerHTML = '';
                        }
                    }
                    delete this.templateCollection[tempName];
                }
            }
        }
    };
    TreeViewComponent.prototype.setProperties = function (prop, muteOnChange) {
        var _this = this;
        if (this.isVue3) {
            this.models = !this.models ? this.ej2Instances.referModels : this.models;
        }
        if (this.ej2Instances && this.ej2Instances._setProperties) {
            this.ej2Instances._setProperties(prop, muteOnChange);
        }
        if (prop && this.models && this.models.length) {
            Object.keys(prop).map(function (key) {
                _this.models.map(function (model) {
                    if ((key === model) && !(/datasource/i.test(key))) {
                        if (_this.isVue3) {
                            _this.ej2Instances.vueInstance.$emit('update:' + key, prop[key]);
                        }
                        else {
                            _this.$emit('update:' + key, prop[key]);
                            _this.$emit('modelchanged', prop[key]);
                        }
                    }
                });
            });
        }
    };
    TreeViewComponent.prototype.render = function (createElement) {
        var h = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] || createElement;
        var slots = null;
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.$slots.default)) {
            slots = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? this.$slots.default() : this.$slots.default;
        }
        return h('div', slots);
    };
    TreeViewComponent.prototype.custom = function () {
        this.updated();
    };
    TreeViewComponent.prototype.addNodes = function (nodes, target, index, preventTargetExpand) {
        return this.ej2Instances.addNodes(nodes, target, index, preventTargetExpand);
    };
    TreeViewComponent.prototype.beginEdit = function (node) {
        return this.ej2Instances.beginEdit(node);
    };
    TreeViewComponent.prototype.checkAll = function (nodes) {
        return this.ej2Instances.checkAll(nodes);
    };
    TreeViewComponent.prototype.collapseAll = function (nodes, level, excludeHiddenNodes) {
        return this.ej2Instances.collapseAll(nodes, level, excludeHiddenNodes);
    };
    TreeViewComponent.prototype.disableNodes = function (nodes) {
        return this.ej2Instances.disableNodes(nodes);
    };
    TreeViewComponent.prototype.enableNodes = function (nodes) {
        return this.ej2Instances.enableNodes(nodes);
    };
    TreeViewComponent.prototype.ensureVisible = function (node) {
        return this.ej2Instances.ensureVisible(node);
    };
    TreeViewComponent.prototype.expandAll = function (nodes, level, excludeHiddenNodes) {
        return this.ej2Instances.expandAll(nodes, level, excludeHiddenNodes);
    };
    TreeViewComponent.prototype.getAllCheckedNodes = function () {
        return this.ej2Instances.getAllCheckedNodes();
    };
    TreeViewComponent.prototype.getDisabledNodes = function () {
        return this.ej2Instances.getDisabledNodes();
    };
    TreeViewComponent.prototype.getNode = function (node) {
        return this.ej2Instances.getNode(node);
    };
    TreeViewComponent.prototype.getTreeData = function (node) {
        return this.ej2Instances.getTreeData(node);
    };
    TreeViewComponent.prototype.moveNodes = function (sourceNodes, target, index, preventTargetExpand) {
        return this.ej2Instances.moveNodes(sourceNodes, target, index, preventTargetExpand);
    };
    TreeViewComponent.prototype.refreshNode = function (target, newData) {
        return this.ej2Instances.refreshNode(target, newData);
    };
    TreeViewComponent.prototype.removeNodes = function (nodes) {
        return this.ej2Instances.removeNodes(nodes);
    };
    TreeViewComponent.prototype.uncheckAll = function (nodes) {
        return this.ej2Instances.uncheckAll(nodes);
    };
    TreeViewComponent.prototype.updateNode = function (target, newText) {
        return this.ej2Instances.updateNode(target, newText);
    };
    TreeViewComponent = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({
            props: properties
        }, isExecute)
        
    ], TreeViewComponent);
    return TreeViewComponent;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["a" /* ComponentBase */]));

var TreeViewPlugin = {
    name: 'ejs-treeview',
    install: function (Vue) {
        Vue.component(TreeViewPlugin.name, TreeViewComponent);
    }
};


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export properties */
/* unused harmony export modelProps */
/* unused harmony export testProp */
/* unused harmony export props */
/* unused harmony export watch */
/* unused harmony export emitProbs */
/* unused harmony export isExecute */
/* unused harmony export SidebarComponent */
/* unused harmony export SidebarPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__ = __webpack_require__(9);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var properties = ['isLazyUpdate', 'animate', 'closeOnDocumentClick', 'dockSize', 'enableDock', 'enableGestures', 'enablePersistence', 'enableRtl', 'height', 'isOpen', 'locale', 'mediaQuery', 'position', 'showBackdrop', 'target', 'type', 'width', 'zIndex', 'change', 'close', 'created', 'destroyed', 'open'];
var modelProps = ['isOpen'];
var testProp = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["d" /* getProps */])({ props: properties });
var props = testProp[0];
var watch = testProp[1];
var emitProbs = Object.keys(watch);
emitProbs.push('modelchanged');
for (var _i = 0, modelProps_1 = modelProps; _i < modelProps_1.length; _i++) {
    var props_1 = modelProps_1[_i];
    emitProbs.push('update:' + props_1);
}
var isExecute = __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["e" /* gh */] ? false : true;
/**
 *  Represents the Essential JS 2 VueJS Sidebar Component.
 * ```html
 * <ejs-sidebar></ejs-sidebar>
 * ```
 */
var SidebarComponent = /** @class */ (function (_super) {
    __extends(SidebarComponent, _super);
    function SidebarComponent() {
        var _this = _super.call(this, arguments) || this;
        _this.propKeys = properties;
        _this.models = modelProps;
        _this.hasChildDirective = false;
        _this.hasInjectedModules = false;
        _this.tagMapper = {};
        _this.tagNameMapper = {};
        _this.isVue3 = !isExecute;
        _this.ej2Instances = new __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__["f" /* Sidebar */]({});
        _this.ej2Instances._trigger = _this.ej2Instances.trigger;
        _this.ej2Instances.trigger = _this.trigger;
        _this.bindProperties();
        _this.ej2Instances._setProperties = _this.ej2Instances.setProperties;
        _this.ej2Instances.setProperties = _this.setProperties;
        _this.ej2Instances.clearTemplate = _this.clearTemplate;
        _this.updated = _this.updated;
        return _this;
    }
    SidebarComponent.prototype.clearTemplate = function (templateNames) {
        if (!templateNames) {
            templateNames = Object.keys(this.templateCollection || {});
        }
        if (templateNames.length && this.templateCollection) {
            for (var _i = 0, templateNames_1 = templateNames; _i < templateNames_1.length; _i++) {
                var tempName = templateNames_1[_i];
                var elementCollection = this.templateCollection[tempName];
                if (elementCollection && elementCollection.length) {
                    for (var _a = 0, elementCollection_1 = elementCollection; _a < elementCollection_1.length; _a++) {
                        var ele = elementCollection_1[_a];
                        var destroy = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["O" /* getValue */])('__vue__.$destroy', ele);
                        if (destroy) {
                            ele.__vue__.$destroy();
                        }
                        if (ele.innerHTML) {
                            ele.innerHTML = '';
                        }
                    }
                    delete this.templateCollection[tempName];
                }
            }
        }
    };
    SidebarComponent.prototype.setProperties = function (prop, muteOnChange) {
        var _this = this;
        if (this.isVue3) {
            this.models = !this.models ? this.ej2Instances.referModels : this.models;
        }
        if (this.ej2Instances && this.ej2Instances._setProperties) {
            this.ej2Instances._setProperties(prop, muteOnChange);
        }
        if (prop && this.models && this.models.length) {
            Object.keys(prop).map(function (key) {
                _this.models.map(function (model) {
                    if ((key === model) && !(/datasource/i.test(key))) {
                        if (_this.isVue3) {
                            _this.ej2Instances.vueInstance.$emit('update:' + key, prop[key]);
                        }
                        else {
                            _this.$emit('update:' + key, prop[key]);
                            _this.$emit('modelchanged', prop[key]);
                        }
                    }
                });
            });
        }
    };
    SidebarComponent.prototype.trigger = function (eventName, eventProp, successHandler) {
        if (!isExecute) {
            this.models = !this.models ? this.ej2Instances.referModels : this.models;
        }
        if ((eventName === 'change' || eventName === 'input') && this.models && (this.models.length !== 0)) {
            var key = this.models.toString().match(/checked|value/) || [];
            var propKey = key[0];
            if (eventProp && key && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["S" /* isUndefined */])(eventProp[propKey])) {
                if (!isExecute) {
                    this.ej2Instances.vueInstance.$emit('update:' + propKey, eventProp[propKey]);
                    this.ej2Instances.vueInstance.$emit('modelchanged', eventProp[propKey]);
                    this.ej2Instances.vueInstance.$emit('update:modelValue', eventProp[propKey]);
                }
                else {
                    if (eventName === 'change' || (this.$props && !this.$props.isLazyUpdate)) {
                        this.$emit('update:' + propKey, eventProp[propKey]);
                        this.$emit('modelchanged', eventProp[propKey]);
                    }
                }
            }
        }
        else if ((eventName === 'actionBegin' && eventProp.requestType === 'dateNavigate') && this.models && (this.models.length !== 0)) {
            var key = this.models.toString().match(/currentView|selectedDate/) || [];
            var propKey = key[0];
            if (eventProp && key && !Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["S" /* isUndefined */])(eventProp[propKey])) {
                if (!isExecute) {
                    this.ej2Instances.vueInstance.$emit('update:' + propKey, eventProp[propKey]);
                    this.ej2Instances.vueInstance.$emit('modelchanged', eventProp[propKey]);
                }
                else {
                    this.$emit('update:' + propKey, eventProp[propKey]);
                    this.$emit('modelchanged', eventProp[propKey]);
                }
            }
        }
        if ((this.ej2Instances && this.ej2Instances._trigger)) {
            this.ej2Instances._trigger(eventName, eventProp, successHandler);
        }
    };
    SidebarComponent.prototype.render = function (createElement) {
        var h = __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["e" /* gh */] || createElement;
        var slots = null;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.$slots.default)) {
            slots = __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["e" /* gh */] ? this.$slots.default() : this.$slots.default;
        }
        return h('div', slots);
    };
    SidebarComponent.prototype.custom = function () {
        this.updated();
    };
    SidebarComponent.prototype.hide = function (e) {
        return this.ej2Instances.hide(e);
    };
    SidebarComponent.prototype.show = function (e) {
        return this.ej2Instances.show(e);
    };
    SidebarComponent.prototype.toggle = function () {
        return this.ej2Instances.toggle();
    };
    SidebarComponent = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({
            props: properties,
            model: {
                event: 'modelchanged'
            }
        }, isExecute)
        
    ], SidebarComponent);
    return SidebarComponent;
}(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_vue_base__["a" /* ComponentBase */]));

var SidebarPlugin = {
    name: 'ejs-sidebar',
    install: function (Vue) {
        Vue.component(SidebarPlugin.name, SidebarComponent);
    }
};


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export properties */
/* unused harmony export modelProps */
/* unused harmony export testProp */
/* unused harmony export props */
/* unused harmony export watch */
/* unused harmony export emitProbs */
/* unused harmony export isExecute */
/* unused harmony export MenuComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__items_directive__ = __webpack_require__(97);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var properties = ['isLazyUpdate', 'animationSettings', 'cssClass', 'enableHtmlSanitizer', 'enablePersistence', 'enableRtl', 'enableScrolling', 'fields', 'filter', 'hamburgerMode', 'hoverDelay', 'items', 'locale', 'orientation', 'showItemOnClick', 'target', 'template', 'title', 'beforeClose', 'beforeItemRender', 'beforeOpen', 'created', 'onClose', 'onOpen', 'select'];
var modelProps = [];
var testProp = Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["d" /* getProps */])({ props: properties });
var props = testProp[0];
var watch = testProp[1];
var emitProbs = Object.keys(watch);
emitProbs.push('modelchanged');
for (var _i = 0, modelProps_1 = modelProps; _i < modelProps_1.length; _i++) {
    var props_1 = modelProps_1[_i];
    emitProbs.push('update:' + props_1);
}
var isExecute = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? false : true;
/**
 * Represents the Essential JS 2 VueJS Menu Component.
 * ```html
 * <ejs-menu :items='menuItems'></ejs-menu>
 * ```
 */
var MenuComponent = /** @class */ (function (_super) {
    __extends(MenuComponent, _super);
    function MenuComponent() {
        var _this = _super.call(this, arguments) || this;
        _this.propKeys = properties;
        _this.models = modelProps;
        _this.hasChildDirective = true;
        _this.hasInjectedModules = false;
        _this.tagMapper = { "e-menu-items": "e-" };
        _this.tagNameMapper = { "e-menu-items": "e-items" };
        _this.isVue3 = !isExecute;
        _this.ej2Instances = new __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_navigations__["e" /* Menu */]({});
        _this.bindProperties();
        _this.ej2Instances._setProperties = _this.ej2Instances.setProperties;
        _this.ej2Instances.setProperties = _this.setProperties;
        _this.ej2Instances.clearTemplate = _this.clearTemplate;
        _this.updated = _this.updated;
        return _this;
    }
    MenuComponent.prototype.clearTemplate = function (templateNames) {
        if (!templateNames) {
            templateNames = Object.keys(this.templateCollection || {});
        }
        if (templateNames.length && this.templateCollection) {
            for (var _i = 0, templateNames_1 = templateNames; _i < templateNames_1.length; _i++) {
                var tempName = templateNames_1[_i];
                var elementCollection = this.templateCollection[tempName];
                if (elementCollection && elementCollection.length) {
                    for (var _a = 0, elementCollection_1 = elementCollection; _a < elementCollection_1.length; _a++) {
                        var ele = elementCollection_1[_a];
                        var destroy = Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["O" /* getValue */])('__vue__.$destroy', ele);
                        if (destroy) {
                            ele.__vue__.$destroy();
                        }
                        if (ele.innerHTML) {
                            ele.innerHTML = '';
                        }
                    }
                    delete this.templateCollection[tempName];
                }
            }
        }
    };
    MenuComponent.prototype.setProperties = function (prop, muteOnChange) {
        var _this = this;
        if (this.isVue3) {
            this.models = !this.models ? this.ej2Instances.referModels : this.models;
        }
        if (this.ej2Instances && this.ej2Instances._setProperties) {
            this.ej2Instances._setProperties(prop, muteOnChange);
        }
        if (prop && this.models && this.models.length) {
            Object.keys(prop).map(function (key) {
                _this.models.map(function (model) {
                    if ((key === model) && !(/datasource/i.test(key))) {
                        if (_this.isVue3) {
                            _this.ej2Instances.vueInstance.$emit('update:' + key, prop[key]);
                        }
                        else {
                            _this.$emit('update:' + key, prop[key]);
                            _this.$emit('modelchanged', prop[key]);
                        }
                    }
                });
            });
        }
    };
    MenuComponent.prototype.render = function (createElement) {
        var h = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] || createElement;
        var slots = null;
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__syncfusion_ej2_base__["Q" /* isNullOrUndefined */])(this.$slots.default)) {
            slots = __WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["e" /* gh */] ? this.$slots.default() : this.$slots.default;
        }
        return h('ul', slots);
    };
    MenuComponent.prototype.custom = function () {
        this.updated();
    };
    MenuComponent.prototype.close = function () {
        return this.ej2Instances.close();
    };
    MenuComponent.prototype.enableItems = function (items, enable, isUniqueId) {
        return this.ej2Instances.enableItems(items, enable, isUniqueId);
    };
    MenuComponent.prototype.getItemIndex = function (item, isUniqueId) {
        return this.ej2Instances.getItemIndex(item, isUniqueId);
    };
    MenuComponent.prototype.hideItems = function (items, isUniqueId) {
        return this.ej2Instances.hideItems(items, isUniqueId);
    };
    MenuComponent.prototype.insertAfter = function (items, text, isUniqueId) {
        return this.ej2Instances.insertAfter(items, text, isUniqueId);
    };
    MenuComponent.prototype.insertBefore = function (items, text, isUniqueId) {
        return this.ej2Instances.insertBefore(items, text, isUniqueId);
    };
    MenuComponent.prototype.open = function () {
        return this.ej2Instances.open();
    };
    MenuComponent.prototype.removeItems = function (items, isUniqueId) {
        return this.ej2Instances.removeItems(items, isUniqueId);
    };
    MenuComponent.prototype.setItem = function (item, id, isUniqueId) {
        return this.ej2Instances.setItem(item, id, isUniqueId);
    };
    MenuComponent.prototype.showItems = function (items, isUniqueId) {
        return this.ej2Instances.showItems(items, isUniqueId);
    };
    MenuComponent = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["b" /* EJComponentDecorator */])({
            props: properties
        }, isExecute)
        
    ], MenuComponent);
    return MenuComponent;
}(__WEBPACK_IMPORTED_MODULE_0__syncfusion_ej2_vue_base__["a" /* ComponentBase */]));

var MenuPlugin = {
    name: 'ejs-menu',
    install: function (Vue) {
        Vue.component(MenuPlugin.name, MenuComponent);
        Vue.component(__WEBPACK_IMPORTED_MODULE_3__items_directive__["b" /* MenuItemPlugin */].name, __WEBPACK_IMPORTED_MODULE_3__items_directive__["a" /* MenuItemDirective */]);
        Vue.component(__WEBPACK_IMPORTED_MODULE_3__items_directive__["d" /* MenuItemsPlugin */].name, __WEBPACK_IMPORTED_MODULE_3__items_directive__["c" /* MenuItemsDirective */]);
    }
};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js